import _get3 from "/codebuild/output/src1432916655/src/node_modules/@babel/runtime/helpers/esm/get";
import _assertThisInitialized2 from "/codebuild/output/src1432916655/src/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _wrapNativeSuper from "/codebuild/output/src1432916655/src/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _asyncToGenerator2 from "/codebuild/output/src1432916655/src/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _inherits2 from "/codebuild/output/src1432916655/src/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn2 from "/codebuild/output/src1432916655/src/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf2 from "/codebuild/output/src1432916655/src/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck2 from "/codebuild/output/src1432916655/src/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass2 from "/codebuild/output/src1432916655/src/node_modules/@babel/runtime/helpers/esm/createClass";
import _slicedToArray2 from "/codebuild/output/src1432916655/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray2 from "/codebuild/output/src1432916655/src/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty2 from "/codebuild/output/src1432916655/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties2 from "/codebuild/output/src1432916655/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded2 = ["color", "size", "strokeWidth", "absoluteStrokeWidth", "className", "children", "iconNode"],
    _excluded3 = ["className"],
    _excluded4 = ["children"],
    _excluded5 = ["_f"],
    _excluded6 = ["name"],
    _excluded7 = ["_f"],
    _excluded8 = ["ref", "message", "type"],
    _excluded9 = ["formControl"];
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.array.flat.js";
import _regeneratorRuntime from "/codebuild/output/src1432916655/src/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray2(o, minLen); }

function _arrayLikeToArray2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct2(); return function _createSuperInternal() { var Super = _getPrototypeOf2(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf2(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn2(this, result); }; }

function _isNativeReflectConstruct2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { _ownKeys(Object(source), true).forEach(function (key) { _defineProperty2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { _ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import 'core-js/modules/es.symbol.js';
import 'core-js/modules/es.symbol.description.js';
import 'core-js/modules/es.symbol.async-iterator.js';
import 'core-js/modules/es.symbol.has-instance.js';
import 'core-js/modules/es.symbol.is-concat-spreadable.js';
import 'core-js/modules/es.symbol.iterator.js';
import 'core-js/modules/es.symbol.match.js';
import 'core-js/modules/es.symbol.replace.js';
import 'core-js/modules/es.symbol.search.js';
import 'core-js/modules/es.symbol.species.js';
import 'core-js/modules/es.symbol.split.js';
import 'core-js/modules/es.symbol.to-primitive.js';
import 'core-js/modules/es.symbol.to-string-tag.js';
import 'core-js/modules/es.symbol.unscopables.js';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.array.copy-within.js';
import 'core-js/modules/es.array.every.js';
import 'core-js/modules/es.array.fill.js';
import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.array.find.js';
import 'core-js/modules/es.array.find-index.js';
import 'core-js/modules/es.array.flat.js';
import 'core-js/modules/es.array.flat-map.js';
import 'core-js/modules/es.array.for-each.js';
import 'core-js/modules/es.array.from.js';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.array.index-of.js';
import 'core-js/modules/es.array.is-array.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.array.join.js';
import 'core-js/modules/es.array.last-index-of.js';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.array.of.js';
import 'core-js/modules/es.array.reduce.js';
import 'core-js/modules/es.array.reduce-right.js';
import 'core-js/modules/es.array.reverse.js';
import 'core-js/modules/es.array.slice.js';
import 'core-js/modules/es.array.some.js';
import 'core-js/modules/es.array.sort.js';
import 'core-js/modules/es.array.species.js';
import 'core-js/modules/es.array.splice.js';
import 'core-js/modules/es.array.unscopables.flat.js';
import 'core-js/modules/es.array.unscopables.flat-map.js';
import 'core-js/modules/es.array-buffer.constructor.js';
import 'core-js/modules/es.array-buffer.is-view.js';
import 'core-js/modules/es.array-buffer.slice.js';
import 'core-js/modules/es.data-view.js';
import 'core-js/modules/es.date.now.js';
import 'core-js/modules/es.date.to-iso-string.js';
import 'core-js/modules/es.date.to-json.js';
import 'core-js/modules/es.date.to-primitive.js';
import 'core-js/modules/es.date.to-string.js';
import 'core-js/modules/es.function.bind.js';
import 'core-js/modules/es.function.has-instance.js';
import 'core-js/modules/es.function.name.js';
import 'core-js/modules/es.json.to-string-tag.js';
import 'core-js/modules/es.map.js';
import 'core-js/modules/es.math.acosh.js';
import 'core-js/modules/es.math.asinh.js';
import 'core-js/modules/es.math.atanh.js';
import 'core-js/modules/es.math.cbrt.js';
import 'core-js/modules/es.math.clz32.js';
import 'core-js/modules/es.math.cosh.js';
import 'core-js/modules/es.math.expm1.js';
import 'core-js/modules/es.math.fround.js';
import 'core-js/modules/es.math.hypot.js';
import 'core-js/modules/es.math.imul.js';
import 'core-js/modules/es.math.log10.js';
import 'core-js/modules/es.math.log1p.js';
import 'core-js/modules/es.math.log2.js';
import 'core-js/modules/es.math.sign.js';
import 'core-js/modules/es.math.sinh.js';
import 'core-js/modules/es.math.tanh.js';
import 'core-js/modules/es.math.to-string-tag.js';
import 'core-js/modules/es.math.trunc.js';
import 'core-js/modules/es.number.constructor.js';
import 'core-js/modules/es.number.epsilon.js';
import 'core-js/modules/es.number.is-finite.js';
import 'core-js/modules/es.number.is-integer.js';
import 'core-js/modules/es.number.is-nan.js';
import 'core-js/modules/es.number.is-safe-integer.js';
import 'core-js/modules/es.number.max-safe-integer.js';
import 'core-js/modules/es.number.min-safe-integer.js';
import 'core-js/modules/es.number.parse-float.js';
import 'core-js/modules/es.number.parse-int.js';
import 'core-js/modules/es.number.to-fixed.js';
import 'core-js/modules/es.number.to-precision.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.object.create.js';
import 'core-js/modules/es.object.define-getter.js';
import 'core-js/modules/es.object.define-properties.js';
import 'core-js/modules/es.object.define-property.js';
import 'core-js/modules/es.object.define-setter.js';
import 'core-js/modules/es.object.entries.js';
import 'core-js/modules/es.object.freeze.js';
import 'core-js/modules/es.object.from-entries.js';
import 'core-js/modules/es.object.get-own-property-descriptor.js';
import 'core-js/modules/es.object.get-own-property-descriptors.js';
import 'core-js/modules/es.object.get-own-property-names.js';
import 'core-js/modules/es.object.get-prototype-of.js';
import 'core-js/modules/es.object.is.js';
import 'core-js/modules/es.object.is-extensible.js';
import 'core-js/modules/es.object.is-frozen.js';
import 'core-js/modules/es.object.is-sealed.js';
import 'core-js/modules/es.object.keys.js';
import 'core-js/modules/es.object.lookup-getter.js';
import 'core-js/modules/es.object.lookup-setter.js';
import 'core-js/modules/es.object.prevent-extensions.js';
import 'core-js/modules/es.object.seal.js';
import 'core-js/modules/es.object.set-prototype-of.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.object.values.js';
import 'core-js/modules/es.parse-float.js';
import 'core-js/modules/es.parse-int.js';
import 'core-js/modules/es.promise.js';
import 'core-js/modules/es.promise.finally.js';
import 'core-js/modules/es.reflect.apply.js';
import 'core-js/modules/es.reflect.construct.js';
import 'core-js/modules/es.reflect.define-property.js';
import 'core-js/modules/es.reflect.delete-property.js';
import 'core-js/modules/es.reflect.get.js';
import 'core-js/modules/es.reflect.get-own-property-descriptor.js';
import 'core-js/modules/es.reflect.get-prototype-of.js';
import 'core-js/modules/es.reflect.has.js';
import 'core-js/modules/es.reflect.is-extensible.js';
import 'core-js/modules/es.reflect.own-keys.js';
import 'core-js/modules/es.reflect.prevent-extensions.js';
import 'core-js/modules/es.reflect.set.js';
import 'core-js/modules/es.reflect.set-prototype-of.js';
import 'core-js/modules/es.regexp.constructor.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.regexp.flags.js';
import 'core-js/modules/es.regexp.to-string.js';
import 'core-js/modules/es.set.js';
import 'core-js/modules/es.string.code-point-at.js';
import 'core-js/modules/es.string.ends-with.js';
import 'core-js/modules/es.string.from-code-point.js';
import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/es.string.iterator.js';
import 'core-js/modules/es.string.match.js';
import 'core-js/modules/es.string.pad-end.js';
import 'core-js/modules/es.string.pad-start.js';
import 'core-js/modules/es.string.raw.js';
import 'core-js/modules/es.string.repeat.js';
import 'core-js/modules/es.string.replace.js';
import 'core-js/modules/es.string.search.js';
import 'core-js/modules/es.string.split.js';
import 'core-js/modules/es.string.starts-with.js';
import 'core-js/modules/es.string.trim.js';
import 'core-js/modules/es.string.trim-end.js';
import 'core-js/modules/es.string.trim-start.js';
import 'core-js/modules/es.string.anchor.js';
import 'core-js/modules/es.string.big.js';
import 'core-js/modules/es.string.blink.js';
import 'core-js/modules/es.string.bold.js';
import 'core-js/modules/es.string.fixed.js';
import 'core-js/modules/es.string.fontcolor.js';
import 'core-js/modules/es.string.fontsize.js';
import 'core-js/modules/es.string.italics.js';
import 'core-js/modules/es.string.link.js';
import 'core-js/modules/es.string.small.js';
import 'core-js/modules/es.string.strike.js';
import 'core-js/modules/es.string.sub.js';
import 'core-js/modules/es.string.sup.js';
import 'core-js/modules/es.typed-array.float32-array.js';
import 'core-js/modules/es.typed-array.float64-array.js';
import 'core-js/modules/es.typed-array.int8-array.js';
import 'core-js/modules/es.typed-array.int16-array.js';
import 'core-js/modules/es.typed-array.int32-array.js';
import 'core-js/modules/es.typed-array.uint8-array.js';
import 'core-js/modules/es.typed-array.uint8-clamped-array.js';
import 'core-js/modules/es.typed-array.uint16-array.js';
import 'core-js/modules/es.typed-array.uint32-array.js';
import 'core-js/modules/es.typed-array.copy-within.js';
import 'core-js/modules/es.typed-array.every.js';
import 'core-js/modules/es.typed-array.fill.js';
import 'core-js/modules/es.typed-array.filter.js';
import 'core-js/modules/es.typed-array.find.js';
import 'core-js/modules/es.typed-array.find-index.js';
import 'core-js/modules/es.typed-array.for-each.js';
import 'core-js/modules/es.typed-array.from.js';
import 'core-js/modules/es.typed-array.includes.js';
import 'core-js/modules/es.typed-array.index-of.js';
import 'core-js/modules/es.typed-array.iterator.js';
import 'core-js/modules/es.typed-array.join.js';
import 'core-js/modules/es.typed-array.last-index-of.js';
import 'core-js/modules/es.typed-array.map.js';
import 'core-js/modules/es.typed-array.of.js';
import 'core-js/modules/es.typed-array.reduce.js';
import 'core-js/modules/es.typed-array.reduce-right.js';
import 'core-js/modules/es.typed-array.reverse.js';
import 'core-js/modules/es.typed-array.set.js';
import 'core-js/modules/es.typed-array.slice.js';
import 'core-js/modules/es.typed-array.some.js';
import 'core-js/modules/es.typed-array.sort.js';
import 'core-js/modules/es.typed-array.subarray.js';
import 'core-js/modules/es.typed-array.to-locale-string.js';
import 'core-js/modules/es.typed-array.to-string.js';
import 'core-js/modules/es.weak-map.js';
import 'core-js/modules/es.weak-set.js';
import 'core-js/modules/esnext.aggregate-error.js';
import 'core-js/modules/esnext.array.last-index.js';
import 'core-js/modules/esnext.array.last-item.js';
import 'core-js/modules/esnext.composite-key.js';
import 'core-js/modules/esnext.composite-symbol.js';
import 'core-js/modules/esnext.global-this.js';
import 'core-js/modules/esnext.map.delete-all.js';
import 'core-js/modules/esnext.map.every.js';
import 'core-js/modules/esnext.map.filter.js';
import 'core-js/modules/esnext.map.find.js';
import 'core-js/modules/esnext.map.find-key.js';
import 'core-js/modules/esnext.map.from.js';
import 'core-js/modules/esnext.map.group-by.js';
import 'core-js/modules/esnext.map.includes.js';
import 'core-js/modules/esnext.map.key-by.js';
import 'core-js/modules/esnext.map.key-of.js';
import 'core-js/modules/esnext.map.map-keys.js';
import 'core-js/modules/esnext.map.map-values.js';
import 'core-js/modules/esnext.map.merge.js';
import 'core-js/modules/esnext.map.of.js';
import 'core-js/modules/esnext.map.reduce.js';
import 'core-js/modules/esnext.map.some.js';
import 'core-js/modules/esnext.map.update.js';
import 'core-js/modules/esnext.math.clamp.js';
import 'core-js/modules/esnext.math.deg-per-rad.js';
import 'core-js/modules/esnext.math.degrees.js';
import 'core-js/modules/esnext.math.fscale.js';
import 'core-js/modules/esnext.math.iaddh.js';
import 'core-js/modules/esnext.math.imulh.js';
import 'core-js/modules/esnext.math.isubh.js';
import 'core-js/modules/esnext.math.rad-per-deg.js';
import 'core-js/modules/esnext.math.radians.js';
import 'core-js/modules/esnext.math.scale.js';
import 'core-js/modules/esnext.math.seeded-prng.js';
import 'core-js/modules/esnext.math.signbit.js';
import 'core-js/modules/esnext.math.umulh.js';
import 'core-js/modules/esnext.number.from-string.js';
import 'core-js/modules/esnext.observable.js';
import 'core-js/modules/esnext.promise.all-settled.js';
import 'core-js/modules/esnext.promise.any.js';
import 'core-js/modules/esnext.promise.try.js';
import 'core-js/modules/esnext.reflect.define-metadata.js';
import 'core-js/modules/esnext.reflect.delete-metadata.js';
import 'core-js/modules/esnext.reflect.get-metadata.js';
import 'core-js/modules/esnext.reflect.get-metadata-keys.js';
import 'core-js/modules/esnext.reflect.get-own-metadata.js';
import 'core-js/modules/esnext.reflect.get-own-metadata-keys.js';
import 'core-js/modules/esnext.reflect.has-metadata.js';
import 'core-js/modules/esnext.reflect.has-own-metadata.js';
import 'core-js/modules/esnext.reflect.metadata.js';
import 'core-js/modules/esnext.set.add-all.js';
import 'core-js/modules/esnext.set.delete-all.js';
import 'core-js/modules/esnext.set.difference.js';
import 'core-js/modules/esnext.set.every.js';
import 'core-js/modules/esnext.set.filter.js';
import 'core-js/modules/esnext.set.find.js';
import 'core-js/modules/esnext.set.from.js';
import 'core-js/modules/esnext.set.intersection.js';
import 'core-js/modules/esnext.set.is-disjoint-from.js';
import 'core-js/modules/esnext.set.is-subset-of.js';
import 'core-js/modules/esnext.set.is-superset-of.js';
import 'core-js/modules/esnext.set.join.js';
import 'core-js/modules/esnext.set.map.js';
import 'core-js/modules/esnext.set.of.js';
import 'core-js/modules/esnext.set.reduce.js';
import 'core-js/modules/esnext.set.some.js';
import 'core-js/modules/esnext.set.symmetric-difference.js';
import 'core-js/modules/esnext.set.union.js';
import 'core-js/modules/esnext.string.at.js';
import 'core-js/modules/esnext.string.code-points.js';
import 'core-js/modules/esnext.string.match-all.js';
import 'core-js/modules/esnext.string.replace-all.js';
import 'core-js/modules/esnext.symbol.dispose.js';
import 'core-js/modules/esnext.symbol.observable.js';
import 'core-js/modules/esnext.symbol.pattern-match.js';
import 'core-js/modules/esnext.weak-map.delete-all.js';
import 'core-js/modules/esnext.weak-map.from.js';
import 'core-js/modules/esnext.weak-map.of.js';
import 'core-js/modules/esnext.weak-set.add-all.js';
import 'core-js/modules/esnext.weak-set.delete-all.js';
import 'core-js/modules/esnext.weak-set.from.js';
import 'core-js/modules/esnext.weak-set.of.js';
import 'core-js/modules/web.dom-collections.for-each.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/web.immediate.js';
import 'core-js/modules/web.queue-microtask.js';
import 'core-js/modules/web.timers.js';
import 'core-js/modules/web.url.js';
import 'core-js/modules/web.url.to-json.js';
import 'core-js/modules/web.url-search-params.js';
import 'regenerator-runtime/runtime';
import styled, { keyframes as keyframes$3, useTheme, css as css$3, createGlobalStyle, ThemeProvider } from 'styled-components';
import _defineProperty$6 from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties$8 from '@babel/runtime/helpers/objectWithoutProperties';
import { jsx as jsx$1, jsxs, Fragment } from 'react/jsx-runtime';
import * as React from 'react';
import React__default, { forwardRef as forwardRef$1, createElement, useContext, Component, createContext, useState, useCallback, useMemo, Fragment as Fragment$1, useRef, useEffect, useLayoutEffect, memo, cloneElement, Children, isValidElement, useReducer, PureComponent, useImperativeHandle, createRef } from 'react';
import { system, compose, width, height, minWidth, minHeight, maxWidth, maxHeight, display, verticalAlign, overflow, space as space$5, color as color$3, border as border$1, flexbox, position, typography, variant, grid, layout, shadow, background } from 'styled-system';
import _slicedToArray$4 from '@babel/runtime/helpers/slicedToArray';
import _get from 'lodash/get';
import queryString from 'query-string';
import { createPortal } from 'react-dom';
import axios from 'axios';
import _toConsumableArray$1 from '@babel/runtime/helpers/toConsumableArray';
import _taggedTemplateLiteral$1 from '@babel/runtime/helpers/taggedTemplateLiteral';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _objectDestructuringEmpty from '@babel/runtime/helpers/objectDestructuringEmpty';
import { Box as Box$1, Text as Text$1, useModal, Icon as Icon$2, theme, redesignTheme, Stack as Stack$2, Heading, Button as Button$1, Section, Skeleton as Skeleton$1, Spinner as Spinner$1, Link as Link$1, Message, Input as Input$5, Grid as Grid$1, Select as Select$2, Badge, HtmlBlock, Radio, Pagination, ThemeProvider as ThemeProvider$1, GlobalStyle as GlobalStyle$1, ModalProvider, Divider, AlertInline, Popover as Popover$1, Selector, StyleReset } from '@rebeldotcom/components';
import PropTypes, { PropTypes as PropTypes$1 } from 'prop-types';
import invariant$2 from 'invariant';
import createContext$1 from 'create-react-context';
import { RiQuestionLine, RiShoppingCartLine, RiAccountBoxLine, RiAccountBoxFill, RiFoldersLine, RiFoldersFill, RiNotificationBadgeLine, RiNotificationBadgeFill, RiSettings4Line, RiSettings4Fill, RiLogoutBoxRLine, RiLogoutBoxRFill, RiLayoutGridFill, RiLayoutGridLine, RiTableFill, RiTableLine, RiUploadLine, RiCheckboxFill, RiShuffleLine, RiAddLine, RiRefreshLine, RiArrowLeftCircleFill, RiAddCircleLine, RiArrowGoBackFill, RiEditLine, RiDeleteBinLine, RiAddCircleFill, RiCheckboxCircleFill, RiErrorWarningFill, RiTodoLine, RiArrowDropDownLine, RiMore2Fill, RiArrowRightLine, RiArrowRightCircleFill, RiAuctionLine, RiMagicLine } from '@remixicon/react';
import { stringify as stringify$1, rulesheet, middleware, dealloc, alloc, RULESET, combine, match as match$3, serialize, copy, replace, WEBKIT, MOZ, MS, KEYFRAMES, DECLARATION, compile, next, token, from as from$1, peek, delimit, slice as slice$1, position as position$1, hash, charat, strlen, indexof } from 'stylis';
import '@babel/runtime/helpers/extends';
import 'hoist-non-react-statics';
import _typeof$2 from '@babel/runtime/helpers/typeof';
import { zodResolver } from '@hookform/resolvers/zod';
import capitalize$1 from 'lodash/capitalize';
import _$1, { capitalize, startCase, findKey as findKey$1, get as get$5, set as set$2, isEmpty as isEmpty$3 } from 'lodash';
import get$4 from 'lodash.get';
import _classCallCheck$a from '@babel/runtime/helpers/classCallCheck';
import _createClass$a from '@babel/runtime/helpers/createClass';
import debounce from 'lodash/debounce';
import _possibleConstructorReturn$2 from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf$1 from '@babel/runtime/helpers/getPrototypeOf';
import _inherits$2 from '@babel/runtime/helpers/inherits';
import fingerprint2 from 'fingerprintjs2';
import isEqual$2 from 'lodash/isEqual';
import { osVersion, osName, isMobile, isBrowser as isBrowser$7, fullBrowserVersion, browserName, mobileVendor, mobileModel, getUA } from 'react-device-detect';
import { Source, visit, print, BREAK, parse as parse$2 } from 'graphql';
import * as cookie from 'cookie';
import isNil from 'lodash/isNil';
import isEmpty$2 from 'lodash/isEmpty';
import map$2 from 'lodash/map';
import { Helmet } from 'react-helmet';
import isEqual$3 from 'react-fast-compare';
import has$1 from 'lodash/has';
import mapValues$1 from 'lodash/mapValues';
import { getter, forEach as forEach$1, split } from 'property-expr';
import _snakeCase from 'lodash/snakeCase';
import _camelCase from 'lodash/camelCase';
import mapKeys from 'lodash/mapKeys';
import toposort from 'toposort';
import Recaptcha from 'react-google-invisible-recaptcha';
import FacebookLogin from 'react-facebook-login';
import { GoogleLogin } from 'react-google-login';
import en from 'react-phone-number-input/locale/en.json';
import keys$1 from 'lodash/keys';
import includes from 'lodash/includes';
import classNames$1 from 'classnames';
import debounce$1 from 'lodash.debounce';
import { Number as Number$1, Expiration, Cvc } from 'react-credit-card-primitives';
import times from 'lodash/times';
import { useTable } from 'react-table';
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var toKebabCase = function toKebabCase(string) {
  return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
};

var mergeClasses = function mergeClasses() {
  for (var _len3 = arguments.length, classes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    classes[_key3] = arguments[_key3];
  }

  return classes.filter(function (className, index, array) {
    return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
  }).join(" ").trim();
};
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */


var defaultAttributes = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var Icon$1 = forwardRef$1(function (_ref13, ref) {
  var _ref13$color = _ref13.color,
      color = _ref13$color === void 0 ? "currentColor" : _ref13$color,
      _ref13$size = _ref13.size,
      size = _ref13$size === void 0 ? 24 : _ref13$size,
      _ref13$strokeWidth = _ref13.strokeWidth,
      strokeWidth = _ref13$strokeWidth === void 0 ? 2 : _ref13$strokeWidth,
      absoluteStrokeWidth = _ref13.absoluteStrokeWidth,
      _ref13$className = _ref13.className,
      className = _ref13$className === void 0 ? "" : _ref13$className,
      children = _ref13.children,
      iconNode = _ref13.iconNode,
      rest = _objectWithoutProperties2(_ref13, _excluded2);

  return createElement("svg", _objectSpread3(_objectSpread3({
    ref: ref
  }, defaultAttributes), {}, {
    width: size,
    height: size,
    stroke: color,
    strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
    className: mergeClasses("lucide", className)
  }, rest), [].concat(_toConsumableArray2(iconNode.map(function (_ref14) {
    var _ref15 = _slicedToArray2(_ref14, 2),
        tag = _ref15[0],
        attrs = _ref15[1];

    return createElement(tag, attrs);
  })), _toConsumableArray2(Array.isArray(children) ? children : [children])));
});
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var createLucideIcon = function createLucideIcon(iconName, iconNode) {
  var Component = forwardRef$1(function (_ref16, ref) {
    var className = _ref16.className,
        props = _objectWithoutProperties2(_ref16, _excluded3);

    return createElement(Icon$1, _objectSpread3({
      ref: ref,
      iconNode: iconNode,
      className: mergeClasses("lucide-".concat(toKebabCase(iconName)), className)
    }, props));
  });
  Component.displayName = "".concat(iconName);
  return Component;
};
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */


var ArrowLeft = createLucideIcon("ArrowLeft", [["path", {
  d: "m12 19-7-7 7-7",
  key: "1l729n"
}], ["path", {
  d: "M19 12H5",
  key: "x3x0zl"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var ArrowRight = createLucideIcon("ArrowRight", [["path", {
  d: "M5 12h14",
  key: "1ays0h"
}], ["path", {
  d: "m12 5 7 7-7 7",
  key: "xquz4c"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var Ban = createLucideIcon("Ban", [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "1mglay"
}], ["path", {
  d: "m4.9 4.9 14.2 14.2",
  key: "1m5liu"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var ChartNoAxesColumn = createLucideIcon("ChartNoAxesColumn", [["line", {
  x1: "18",
  x2: "18",
  y1: "20",
  y2: "10",
  key: "1xfpm4"
}], ["line", {
  x1: "12",
  x2: "12",
  y1: "20",
  y2: "4",
  key: "be30l9"
}], ["line", {
  x1: "6",
  x2: "6",
  y1: "20",
  y2: "14",
  key: "1r4le6"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var Check$1 = createLucideIcon("Check", [["path", {
  d: "M20 6 9 17l-5-5",
  key: "1gmf2c"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var ChevronDown = createLucideIcon("ChevronDown", [["path", {
  d: "m6 9 6 6 6-6",
  key: "qrunsl"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var CircleAlert = createLucideIcon("CircleAlert", [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "1mglay"
}], ["line", {
  x1: "12",
  x2: "12",
  y1: "8",
  y2: "12",
  key: "1pkeuh"
}], ["line", {
  x1: "12",
  x2: "12.01",
  y1: "16",
  y2: "16",
  key: "4dfq90"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var CircleArrowLeft = createLucideIcon("CircleArrowLeft", [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "1mglay"
}], ["path", {
  d: "M16 12H8",
  key: "1fr5h0"
}], ["path", {
  d: "m12 8-4 4 4 4",
  key: "15vm53"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var CircleCheckBig = createLucideIcon("CircleCheckBig", [["path", {
  d: "M21.801 10A10 10 0 1 1 17 3.335",
  key: "yps3ct"
}], ["path", {
  d: "m9 11 3 3L22 4",
  key: "1pflzl"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var CircleCheck = createLucideIcon("CircleCheck", [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "1mglay"
}], ["path", {
  d: "m9 12 2 2 4-4",
  key: "dzmm74"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var CircleX = createLucideIcon("CircleX", [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "1mglay"
}], ["path", {
  d: "m15 9-6 6",
  key: "1uzhvr"
}], ["path", {
  d: "m9 9 6 6",
  key: "z0biqf"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var Command = createLucideIcon("Command", [["path", {
  d: "M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3",
  key: "11bfej"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var CreditCard = createLucideIcon("CreditCard", [["rect", {
  width: "20",
  height: "14",
  x: "2",
  y: "5",
  rx: "2",
  key: "ynyp8z"
}], ["line", {
  x1: "2",
  x2: "22",
  y1: "10",
  y2: "10",
  key: "1b3vmo"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var Crown = createLucideIcon("Crown", [["path", {
  d: "M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z",
  key: "1vdc57"
}], ["path", {
  d: "M5 21h14",
  key: "11awu3"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var EllipsisVertical = createLucideIcon("EllipsisVertical", [["circle", {
  cx: "12",
  cy: "12",
  r: "1",
  key: "41hilf"
}], ["circle", {
  cx: "12",
  cy: "5",
  r: "1",
  key: "gxeob9"
}], ["circle", {
  cx: "12",
  cy: "19",
  r: "1",
  key: "lyex9k"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var FileUp = createLucideIcon("FileUp", [["path", {
  d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
  key: "1rqfz7"
}], ["path", {
  d: "M14 2v4a2 2 0 0 0 2 2h4",
  key: "tnqrlb"
}], ["path", {
  d: "M12 12v6",
  key: "3ahymv"
}], ["path", {
  d: "m15 15-3-3-3 3",
  key: "15xj92"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var Globe = createLucideIcon("Globe", [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "1mglay"
}], ["path", {
  d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20",
  key: "13o1zl"
}], ["path", {
  d: "M2 12h20",
  key: "9i4pu4"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var Info = createLucideIcon("Info", [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "1mglay"
}], ["path", {
  d: "M12 16v-4",
  key: "1dtifu"
}], ["path", {
  d: "M12 8h.01",
  key: "e9boi3"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var Link2 = createLucideIcon("Link2", [["path", {
  d: "M9 17H7A5 5 0 0 1 7 7h2",
  key: "8i5ue5"
}], ["path", {
  d: "M15 7h2a5 5 0 1 1 0 10h-2",
  key: "1b9ql8"
}], ["line", {
  x1: "8",
  x2: "16",
  y1: "12",
  y2: "12",
  key: "1jonct"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var LoaderCircle = createLucideIcon("LoaderCircle", [["path", {
  d: "M21 12a9 9 0 1 1-6.219-8.56",
  key: "13zald"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var Lock = createLucideIcon("Lock", [["rect", {
  width: "18",
  height: "11",
  x: "3",
  y: "11",
  rx: "2",
  ry: "2",
  key: "1w4ew1"
}], ["path", {
  d: "M7 11V7a5 5 0 0 1 10 0v4",
  key: "fwvmzm"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var Mail = createLucideIcon("Mail", [["rect", {
  width: "20",
  height: "16",
  x: "2",
  y: "4",
  rx: "2",
  key: "18n3k1"
}], ["path", {
  d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7",
  key: "1ocrg3"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var Moon = createLucideIcon("Moon", [["path", {
  d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z",
  key: "a7tn18"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var PanelsTopLeft = createLucideIcon("PanelsTopLeft", [["rect", {
  width: "18",
  height: "18",
  x: "3",
  y: "3",
  rx: "2",
  key: "afitv7"
}], ["path", {
  d: "M3 9h18",
  key: "1pudct"
}], ["path", {
  d: "M9 21V9",
  key: "1oto5p"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var Plus = createLucideIcon("Plus", [["path", {
  d: "M5 12h14",
  key: "1ays0h"
}], ["path", {
  d: "M12 5v14",
  key: "s699le"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var Repeat2 = createLucideIcon("Repeat2", [["path", {
  d: "m2 9 3-3 3 3",
  key: "1ltn5i"
}], ["path", {
  d: "M13 18H7a2 2 0 0 1-2-2V6",
  key: "1r6tfw"
}], ["path", {
  d: "m22 15-3 3-3-3",
  key: "4rnwn2"
}], ["path", {
  d: "M11 6h6a2 2 0 0 1 2 2v10",
  key: "2f72bc"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var Search = createLucideIcon("Search", [["circle", {
  cx: "11",
  cy: "11",
  r: "8",
  key: "4ej97u"
}], ["path", {
  d: "m21 21-4.3-4.3",
  key: "1qie3q"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var Server = createLucideIcon("Server", [["rect", {
  width: "20",
  height: "8",
  x: "2",
  y: "2",
  rx: "2",
  ry: "2",
  key: "ngkwjq"
}], ["rect", {
  width: "20",
  height: "8",
  x: "2",
  y: "14",
  rx: "2",
  ry: "2",
  key: "iecqi9"
}], ["line", {
  x1: "6",
  x2: "6.01",
  y1: "6",
  y2: "6",
  key: "16zg32"
}], ["line", {
  x1: "6",
  x2: "6.01",
  y1: "18",
  y2: "18",
  key: "nzw8ys"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var Share = createLucideIcon("Share", [["path", {
  d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8",
  key: "1b2hhj"
}], ["polyline", {
  points: "16 6 12 2 8 6",
  key: "m901s6"
}], ["line", {
  x1: "12",
  x2: "12",
  y1: "2",
  y2: "15",
  key: "1p0rca"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var Shield = createLucideIcon("Shield", [["path", {
  d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
  key: "oel41y"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var ShoppingCart = createLucideIcon("ShoppingCart", [["circle", {
  cx: "8",
  cy: "21",
  r: "1",
  key: "jimo8o"
}], ["circle", {
  cx: "19",
  cy: "21",
  r: "1",
  key: "13723u"
}], ["path", {
  d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
  key: "9zh506"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var Star = createLucideIcon("Star", [["path", {
  d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
  key: "r04s7s"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var Sun = createLucideIcon("Sun", [["circle", {
  cx: "12",
  cy: "12",
  r: "4",
  key: "4exip2"
}], ["path", {
  d: "M12 2v2",
  key: "tus03m"
}], ["path", {
  d: "M12 20v2",
  key: "1lh1kg"
}], ["path", {
  d: "m4.93 4.93 1.41 1.41",
  key: "149t6j"
}], ["path", {
  d: "m17.66 17.66 1.41 1.41",
  key: "ptbguv"
}], ["path", {
  d: "M2 12h2",
  key: "1t8f8n"
}], ["path", {
  d: "M20 12h2",
  key: "1q8mjw"
}], ["path", {
  d: "m6.34 17.66-1.41 1.41",
  key: "1m8zz5"
}], ["path", {
  d: "m19.07 4.93-1.41 1.41",
  key: "1shlcs"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var Trash2 = createLucideIcon("Trash2", [["path", {
  d: "M3 6h18",
  key: "d0wm0j"
}], ["path", {
  d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6",
  key: "4alrt4"
}], ["path", {
  d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2",
  key: "v07s0e"
}], ["line", {
  x1: "10",
  x2: "10",
  y1: "11",
  y2: "17",
  key: "1uufr5"
}], ["line", {
  x1: "14",
  x2: "14",
  y1: "11",
  y2: "17",
  key: "xtxkd"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var User = createLucideIcon("User", [["path", {
  d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2",
  key: "975kel"
}], ["circle", {
  cx: "12",
  cy: "7",
  r: "4",
  key: "17ys0d"
}]]);
/**
 * @license lucide-react v0.461.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

var X = createLucideIcon("X", [["path", {
  d: "M18 6 6 18",
  key: "1bl5f8"
}], ["path", {
  d: "m6 6 12 12",
  key: "d8bk6v"
}]]);
var spin = keyframes$3(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
var SpinnerWrapper$1 = styled.div.withConfig({
  displayName: "spinner__SpinnerWrapper",
  componentId: "sc-jr4znu-0"
})(["display:flex;width:fit-content;height:fit-content;animation:", " 1s linear infinite;"], spin);

function Spinner(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 18 : _ref$size;
  return /*#__PURE__*/jsx$1(SpinnerWrapper$1, {
    children: /*#__PURE__*/jsx$1(LoaderCircle, {
      size: size
    })
  });
}

var gap = system({
  gap: {
    property: 'gap',
    scale: 'space'
  }
});
var transition = system({
  transition: true
});
/**
 * We do this to exclude the Size property that exists in `layout`.
 * This is important so that we can define our own, non-conflicting size variants.
 */

var customLayout = compose(width, height, minWidth, minHeight, maxWidth, maxHeight, display, verticalAlign, overflow);
var commonStyles = compose(gap, space$5, color$3, border$1, display, flexbox, position, transition, typography, customLayout);
var variants$2 = {
  link: {
    padding: '0px',
    border: 'none',
    borderRadius: 'none',
    backgroundColor: 'none',
    fontWeight: 'regular',
    color: 'primary-500',
    "&[data-active='true']": {
      color: 'primary-700',
      fontWeight: 'semi'
    },
    '&:hover': {},
    '&:active': {
      textDecorationColor: 'transparent'
    }
  },
  minimal: {
    padding: '0px',
    fontWeight: 'semi',
    color: 'primary-700',
    backgroundColor: 'none',
    '&:active': {
      textDecorationThickness: '2px'
    },
    '&:hover:not(:disabled)': {
      transform: 'translateY(-1px)'
    },
    '&:disabled': {
      filter: 'opacity(0.5)'
    }
  },
  primary: {
    backgroundColor: 'secondary-900',
    '&:hover:not(:disabled)': {
      borderColor: 'primary-800'
    },
    '&:disabled': {
      color: 'primary-300'
    },
    color: 'primary-800'
  },
  secondary: {
    backgroundColor: function backgroundColor(theme) {
      if (theme.mode === 'dark') {
        return theme.colors['neutral-200'];
      }

      return theme.colors['primary-700'];
    },
    color: 'white',
    '&:hover:not(:disabled)': {
      backgroundColor: 'primary-500'
    },
    '&:disabled': {
      backgroundColor: 'primary-300'
    }
  },
  tertiary: {
    color: 'neutral-700',
    backgroundColor: 'neutral-300',
    '&:hover:not(:disabled)': {
      borderColor: 'neutral-700'
    },
    '&:disabled': {
      color: 'neutral-400',
      borderColor: 'neutral-400'
    }
  },
  outlined: {
    backgroundColor: 'background',
    borderColor: 'primary-700',
    color: 'primary-700',
    '&:hover:not(:disabled)': {
      backgroundColor: 'primary-100'
    },
    '&:disabled': {
      color: 'primary-300',
      borderColor: 'primary-300'
    }
  }
};
var buttonVariants = variant({
  prop: 'variant',
  variants: variants$2
});
var _excluded$T = ["variant", "loading", "children", "disabled"];

function ownKeys$1Z(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1Y(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1Z(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1Z(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var StyledButton = styled.button.withConfig({
  displayName: "button__StyledButton",
  componentId: "sc-5k9lma-0"
})(["display:flex;align-items:center;justify-content:center;white-space:nowrap;font-size:16px;padding:12px 24px;gap:", ";font-family:", ";font-weight:", ";cursor:pointer;transition:0.2s;border:1px solid transparent;border-radius:", ";text-decoration:underline;text-decoration-color:transparent;position:relative;&:disabled{cursor:not-allowed;}&:active{text-decoration-color:inherit;}", " ", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.space[2];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fonts.body;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeights.medium;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.radii.rounded;
}, buttonVariants, commonStyles);
var SpinnerWrapper = styled.div.withConfig({
  displayName: "button__SpinnerWrapper",
  componentId: "sc-5k9lma-1"
})(["position:absolute;display:flex;align-items:center;justify-content:center;"]);

function Button(_ref5) {
  var _ref5$variant = _ref5.variant,
      variant = _ref5$variant === void 0 ? 'primary' : _ref5$variant,
      _ref5$loading = _ref5.loading,
      loading = _ref5$loading === void 0 ? false : _ref5$loading,
      children = _ref5.children,
      disabled = _ref5.disabled,
      props = _objectWithoutProperties$8(_ref5, _excluded$T);

  return /*#__PURE__*/jsx$1(StyledButton, _objectSpread$1Y(_objectSpread$1Y({
    variant: variant,
    disabled: loading || disabled
  }, props), {}, {
    children: loading ? /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx$1("span", {
        style: {
          visibility: loading ? 'hidden' : 'visible',
          display: 'flex',
          gap: '8px'
        },
        children: children
      }), /*#__PURE__*/jsx$1(SpinnerWrapper, {
        children: /*#__PURE__*/jsx$1(Spinner, {})
      })]
    }) : children
  }));
}
/** Flexbox container */


var Box = styled.div.withConfig({
  displayName: "box__Box",
  componentId: "sc-zt6lok-0"
})(["display:flex;", ""], commonStyles);
var Grid = styled.div.withConfig({
  displayName: "grid__Grid",
  componentId: "sc-1dsnjtb-0"
})(["display:grid;", " ", ""], grid, commonStyles);
var Stack$1 = styled.div.withConfig({
  displayName: "stack__Stack",
  componentId: "sc-1ehhep7-0"
})(["display:flex;flex-direction:column;", ""], commonStyles);
var _excluded$S = ["className", "checked"];

function ownKeys$1Y(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1X(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1Y(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1Y(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var HiddenCheckbox = styled.input.attrs({
  type: 'checkbox'
}).withConfig({
  displayName: "checkbox__HiddenCheckbox",
  componentId: "sc-orlo1x-0"
})(["position:absolute;opacity:0;pointer-events:none;"]);
var StyledCheckbox = styled.span.withConfig({
  displayName: "checkbox__StyledCheckbox",
  componentId: "sc-orlo1x-1"
})(["display:flex;align-items:center;justify-content:center;width:16px;height:16px;background-color:", ";border:1.5px solid ", ";border-radius:3px;transition:all 0.2s ease;cursor:pointer;transform:scale(1.1);svg{visibility:", ";color:", ";width:12px;height:12px;}", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.card;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors['primary-700'];
}, function (_ref3) {
  var checked = _ref3.checked;
  return checked ? 'visible' : 'hidden';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.background;
}, function (_ref5) {
  var checked = _ref5.checked,
      theme = _ref5.theme;
  return checked && "\n      background-color: ".concat(theme.colors['primary-600'], ";\n      border-color: ").concat(theme.colors['primary-600'], ";\n    ");
});
var CheckboxContainer = styled.label.withConfig({
  displayName: "checkbox__CheckboxContainer",
  componentId: "sc-orlo1x-2"
})(["display:inline-flex;align-items:center;gap:8px;cursor:pointer;position:relative;font-family:", ";", ""], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fonts.body;
}, commonStyles);

function Checkbox$1(_ref7) {
  var className = _ref7.className,
      checked = _ref7.checked,
      props = _objectWithoutProperties$8(_ref7, _excluded$S);

  return /*#__PURE__*/jsxs(CheckboxContainer, {
    className: className,
    children: [/*#__PURE__*/jsx$1(HiddenCheckbox, _objectSpread$1X(_objectSpread$1X({
      checked: checked
    }, props), {}, {
      type: "checkbox"
    })), /*#__PURE__*/jsx$1(StyledCheckbox, {
      checked: checked,
      children: /*#__PURE__*/jsx$1(Check$1, {
        strokeWidth: 2,
        size: 2
      })
    })]
  });
}

var global$2 = typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {}; // shim for using process in browser
// based off https://github.com/defunctzombie/node-process/blob/master/browser.js

function defaultSetTimout() {
  throw new Error('setTimeout has not been defined');
}

function defaultClearTimeout() {
  throw new Error('clearTimeout has not been defined');
}

var cachedSetTimeout = defaultSetTimout;
var cachedClearTimeout = defaultClearTimeout;

if (typeof global$2.setTimeout === 'function') {
  cachedSetTimeout = setTimeout;
}

if (typeof global$2.clearTimeout === 'function') {
  cachedClearTimeout = clearTimeout;
}

function runTimeout(fun) {
  if (cachedSetTimeout === setTimeout) {
    //normal enviroments in sane situations
    return setTimeout(fun, 0);
  } // if setTimeout wasn't available but was latter defined


  if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
    cachedSetTimeout = setTimeout;
    return setTimeout(fun, 0);
  }

  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return cachedSetTimeout(fun, 0);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
      return cachedSetTimeout.call(null, fun, 0);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
      return cachedSetTimeout.call(this, fun, 0);
    }
  }
}

function runClearTimeout(marker) {
  if (cachedClearTimeout === clearTimeout) {
    //normal enviroments in sane situations
    return clearTimeout(marker);
  } // if clearTimeout wasn't available but was latter defined


  if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
    cachedClearTimeout = clearTimeout;
    return clearTimeout(marker);
  }

  try {
    // when when somebody has screwed with setTimeout but no I.E. maddness
    return cachedClearTimeout(marker);
  } catch (e) {
    try {
      // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
      return cachedClearTimeout.call(null, marker);
    } catch (e) {
      // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
      // Some versions of I.E. have different rules for clearTimeout vs setTimeout
      return cachedClearTimeout.call(this, marker);
    }
  }
}

var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
  if (!draining || !currentQueue) {
    return;
  }

  draining = false;

  if (currentQueue.length) {
    queue = currentQueue.concat(queue);
  } else {
    queueIndex = -1;
  }

  if (queue.length) {
    drainQueue();
  }
}

function drainQueue() {
  if (draining) {
    return;
  }

  var timeout = runTimeout(cleanUpNextTick);
  draining = true;
  var len = queue.length;

  while (len) {
    currentQueue = queue;
    queue = [];

    while (++queueIndex < len) {
      if (currentQueue) {
        currentQueue[queueIndex].run();
      }
    }

    queueIndex = -1;
    len = queue.length;
  }

  currentQueue = null;
  draining = false;
  runClearTimeout(timeout);
}

function nextTick(fun) {
  var args = new Array(arguments.length - 1);

  if (arguments.length > 1) {
    for (var i = 1; i < arguments.length; i++) {
      args[i - 1] = arguments[i];
    }
  }

  queue.push(new Item(fun, args));

  if (queue.length === 1 && !draining) {
    runTimeout(drainQueue);
  }
} // v8 likes predictible objects


function Item(fun, array) {
  this.fun = fun;
  this.array = array;
}

Item.prototype.run = function () {
  this.fun.apply(null, this.array);
};

var title = 'browser';
var platform = 'browser';
var browser = true;
var env = {};
var argv = [];
var version$2 = ''; // empty string to avoid regexp issues

var versions = {};
var release = {};
var config = {};

function noop$3() {}

var on = noop$3;
var addListener = noop$3;
var once$1 = noop$3;
var off = noop$3;
var removeListener = noop$3;
var removeAllListeners = noop$3;
var emit = noop$3;

function binding(name) {
  throw new Error('process.binding is not supported');
}

function cwd() {
  return '/';
}

function chdir(dir) {
  throw new Error('process.chdir is not supported');
}

function umask() {
  return 0;
} // from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js


var performance$1 = global$2.performance || {};

var performanceNow = performance$1.now || performance$1.mozNow || performance$1.msNow || performance$1.oNow || performance$1.webkitNow || function () {
  return new Date().getTime();
}; // generate timestamp or delta
// see http://nodejs.org/api/process.html#process_process_hrtime


function hrtime(previousTimestamp) {
  var clocktime = performanceNow.call(performance$1) * 1e-3;
  var seconds = Math.floor(clocktime);
  var nanoseconds = Math.floor(clocktime % 1 * 1e9);

  if (previousTimestamp) {
    seconds = seconds - previousTimestamp[0];
    nanoseconds = nanoseconds - previousTimestamp[1];

    if (nanoseconds < 0) {
      seconds--;
      nanoseconds += 1e9;
    }
  }

  return [seconds, nanoseconds];
}

var startTime = new Date();

function uptime() {
  var currentTime = new Date();
  var dif = currentTime - startTime;
  return dif / 1000;
}

var browser$1 = {
  nextTick: nextTick,
  title: title,
  browser: browser,
  env: env,
  argv: argv,
  version: version$2,
  versions: versions,
  on: on,
  addListener: addListener,
  once: once$1,
  off: off,
  removeListener: removeListener,
  removeAllListeners: removeAllListeners,
  emit: emit,
  binding: binding,
  cwd: cwd,
  chdir: chdir,
  umask: umask,
  hrtime: hrtime,
  platform: platform,
  release: release,
  config: config,
  uptime: uptime
};
var process$1 = browser$1;

function _extends$b() {
  return _extends$b = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];

      for (var r in t) {
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
    }

    return n;
  }, _extends$b.apply(null, arguments);
}

var isDevelopment$2 = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  } // this function should always return with a value
  // TS can't understand it though so we make it stop complaining here


  return undefined;
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? !isDevelopment$2 : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {}
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    this.tags.forEach(function (tag) {
      var _tag$parentNode;

      return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();

var weakMemoize = function weakMemoize(func) {
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // Use non-null assertion because we just checked that the cache `has` it
      // This allows us to remove `undefined` from the return value
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

function memoize$2(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var isBrowser$6 = typeof document !== 'undefined';

var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice$1(begin, position$1);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position$1 - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from$1(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();

var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value;
  var parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};

var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
/* eslint-disable no-fallthrough */


function prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    // order

    case 6165:
      return WEBKIT + value + MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return replace(value, ':', ':' + WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return WEBKIT + value + MS + value + value;
  }

  return value;
}

var prefixer$1 = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case DECLARATION:
      element["return"] = prefix(element.value, element.length);
      break;

    case KEYFRAMES:
      return serialize([copy(element, {
        value: replace(element.value, '@', '@' + WEBKIT)
      })], callback);

    case RULESET:
      if (element.length) return combine(element.props, function (value) {
        switch (match$3(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return serialize([copy(element, {
              props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return serialize([copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]
            }), copy(element, {
              props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var getServerStylisCache = isBrowser$6 ? undefined : weakMemoize(function () {
  return memoize$2(function () {
    return {};
  });
});
var defaultStylisPlugins = [prefixer$1];

var createCache = function createCache(options) {
  var key = options.key;

  if (isBrowser$6 && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }

      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
  var inserted = {};
  var container;
  var nodesToHydrate = [];

  if (isBrowser$6) {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' ');

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (!getServerStylisCache) {
    var currentSheet;
    var finalizingPlugins = [stringify$1, rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stringify$1];

    var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

    var _stylis = function _stylis(styles) {
      return serialize(compile(styles), _serializer);
    };

    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

var isBrowser$5 = typeof document !== 'undefined';

function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else if (className) {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}

var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$5 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};

var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      if (!isBrowser$5 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$5 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86


function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

function memoize$1(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var isDevelopment$1 = false;
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize$1(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  var componentSelector = interpolation;

  if (componentSelector.__emotion_styles !== undefined) {
    return componentSelector;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        var keyframes = interpolation;

        if (keyframes.anim === 1) {
          cursor = {
            name: keyframes.name,
            styles: keyframes.styles,
            next: cursor
          };
          return keyframes.name;
        }

        var serializedStyles = interpolation;

        if (serializedStyles.styles !== undefined) {
          var next = serializedStyles.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = serializedStyles.styles + ";";
          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        }

        break;
      }
  } // finalize string values (regular strings and functions interpolated into css calls)


  var asString = interpolation;

  if (registered == null) {
    return asString;
  }

  var cached = registered[asString];
  return cached !== undefined ? cached : asString;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var key in obj) {
      var value = obj[key];

      if (typeof value !== 'object') {
        var asString = value;

        if (registered != null && registered[asString] !== undefined) {
          string += key + "{" + registered[asString] + "}";
        } else if (isProcessableValue(asString)) {
          string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        }
      } else {
        if (key === 'NO_COMPONENT_SELECTOR' && isDevelopment$1) {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                string += key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list

var cursor;

function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    var asTemplateStringsArr = strings;
    styles += asTemplateStringsArr[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      var templateStringsArr = strings;
      styles += templateStringsArr[i];
    }
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + match[1];
  }

  var name = murmur2(styles) + identifierName;
  return {
    name: name,
    styles: styles,
    next: cursor
  };
}

var isBrowser$4 = typeof document !== 'undefined';

var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = React['useInsertion' + 'Effect'] ? React['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = !isBrowser$4 ? syncFallback : useInsertionEffect || syncFallback;
var isDevelopment = false;
var isBrowser$3 = typeof document !== 'undefined';
var EmotionCacheContext = /* #__PURE__ */React.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
  key: 'css'
}) : null);
EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  return /*#__PURE__*/forwardRef$1(function (props, ref) {
    // the cache will never be null in the browser
    var cache = useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

if (!isBrowser$3) {
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      var cache = useContext(EmotionCacheContext);

      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = createCache({
          key: 'css'
        });
        return /*#__PURE__*/React.createElement(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}

var ThemeContext$1 = /* #__PURE__ */React.createContext({});
var hasOwn$2 = {}.hasOwnProperty;
var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';

var createEmotionProps = function createEmotionProps(type, props) {
  var newProps = {};

  for (var _key in props) {
    if (hasOwn$2.call(props, _key)) {
      newProps[_key] = props[_key];
    }
  }

  newProps[typePropName] = type; // Runtime labeling is an opt-in feature because:

  return newProps;
};

var Insertion$1 = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  registerStyles(cache, serialized, isStringTag);
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    return insertStyles(cache, serialized, isStringTag);
  });

  if (!isBrowser$3 && rules !== undefined) {
    var _ref2;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return /*#__PURE__*/React.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles, undefined, React.useContext(ThemeContext$1));
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var _key2 in props) {
    if (hasOwn$2.call(props, _key2) && _key2 !== 'css' && _key2 !== typePropName && !isDevelopment) {
      newProps[_key2] = props[_key2];
    }
  }

  newProps.className = className;

  if (ref) {
    newProps.ref = ref;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Insertion$1, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/React.createElement(WrappedComponent, newProps));
});
var Emotion$1 = Emotion;

var jsx = function jsx(type, props) {
  // eslint-disable-next-line prefer-rest-params
  var args = arguments;

  if (props == null || !hasOwn$2.call(props, 'css')) {
    return React.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion$1;
  createElementArgArray[1] = createEmotionProps(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  }

  return React.createElement.apply(null, createElementArgArray);
};

(function (_jsx) {
  var JSX;

  (function (_JSX) {})(JSX || (JSX = _jsx.JSX || (_jsx.JSX = {})));
})(jsx || (jsx = {}));

function css$2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

function keyframes$2() {
  var insertable = css$2.apply(void 0, arguments);
  var name = "animation-" + insertable.name;
  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  var rules = useInsertionEffectAlwaysWithSyncFallback(function () {
    var rules = '';

    for (var i = 0; i < serializedArr.length; i++) {
      var res = insertStyles(cache, serializedArr[i], false);

      if (!isBrowser$3 && res !== undefined) {
        rules += res;
      }
    }

    if (!isBrowser$3) {
      return rules;
    }
  });

  if (!isBrowser$3 && rules.length !== 0) {
    var _ref2;

    return /*#__PURE__*/React.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function (serialized) {
      return serialized.name;
    }).join(' '), _ref2.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref2.nonce = cache.sheet.nonce, _ref2));
  }

  return null;
};

var ClassNames = /* #__PURE__ */withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && isDevelopment) {
      throw new Error('css can only be used during render');
    }

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && isDevelopment) {
      throw new Error('cx can only be used during render');
    }

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: React.useContext(ThemeContext$1)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
});

function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}

function _objectWithoutPropertiesLoose$8(r, e) {
  if (null == r) return {};
  var t = {};

  for (var n in r) {
    if ({}.hasOwnProperty.call(r, n)) {
      if (-1 !== e.indexOf(n)) continue;
      t[n] = r[n];
    }
  }

  return t;
}

function _objectWithoutProperties$7(e, t) {
  if (null == e) return {};

  var o,
      r,
      i = _objectWithoutPropertiesLoose$8(e, t);

  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);

    for (r = 0; r < n.length; r++) {
      o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
  }

  return i;
}

function _typeof$1(o) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$1(o);
}

function _classCallCheck$9(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

function toPrimitive(t, r) {
  if ("object" != _typeof$1(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof$1(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof$1(i) ? i : i + "";
}

function _defineProperties$9(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}

function _createClass$9(e, r, t) {
  return r && _defineProperties$9(e.prototype, r), t && _defineProperties$9(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

function _inherits$1(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

function _defineProperty$5(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

function _defineProperty$4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$1X(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1X(Object(source), true).forEach(function (key) {
        _defineProperty$4(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1X(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _isNativeReflectConstruct$2() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$1(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$2();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$1(this, result);
  };
}

var _excluded$3$1 = ["className", "clearValue", "cx", "getStyles", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"]; // ==============================
// NO OP
// ==============================

var noop$2 = function noop() {}; // Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/


function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, state, className) {
  var arr = [className];

  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
} // ==============================
// Clean Value
// ==============================


var cleanValue = function cleanValue(value) {
  if (isArray$5(value)) return value.filter(Boolean);
  if (_typeof$1(value) === 'object' && value !== null) return [value];
  return [];
}; // ==============================
// Clean Common Props
// ==============================


var cleanCommonProps = function cleanCommonProps(props) {
  //className
  props.className;
  props.clearValue;
  props.cx;
  props.getStyles;
  props.getValue;
  props.hasValue;
  props.isMulti;
  props.isRtl;
  props.options;
  props.selectOption;
  props.selectProps;
  props.setValue;
  props.theme;

  var innerProps = _objectWithoutProperties$7(props, _excluded$3$1);

  return _objectSpread2({}, innerProps);
}; // ==============================
// Scroll Helpers
// ==============================


function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------


function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }

  return el.scrollTop;
}

function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------


function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  if (style.position === 'fixed') return document.documentElement;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);

    if (excludeStaticParent && style.position === 'static') {
      continue;
    }

    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return document.documentElement;
} // Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/


function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop$2;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);

    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }

  animateScroll();
} // Scroll Into View
// ------------------------------


function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect


function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
} // Touch Capability Detector
// ==============================


function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
} // ==============================
// Mobile Device Detector
// ==============================


function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
} // ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36


var passiveOptionAccessed = false;
var options$1 = {
  get passive() {
    return passiveOptionAccessed = true;
  }

}; // check for SSR

var w = typeof window !== 'undefined' ? window : {};

if (w.addEventListener && w.removeEventListener) {
  w.addEventListener('p', noop$2, options$1);
  w.removeEventListener('p', noop$2, false);
}

var supportsPassiveEvents = passiveOptionAccessed;

function notNullish(item) {
  return item != null;
}

function isArray$5(arg) {
  return Array.isArray(arg);
}

function valueTernary(isMulti, multiValue, singleValue) {
  return isMulti ? multiValue : singleValue;
}

function singleValueAsValue(singleValue) {
  return singleValue;
}

function multiValueAsValue(multiValue) {
  return multiValue;
}

function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition,
      theme = _ref.theme;
  var spacing = theme.spacing;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: maxHeight
  }; // something went wrong, return default state

  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = window.innerHeight;
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        } // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.


        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      } // 4. Forked beviour when there isn't enough space below
      // AUTO: flip the menu, render above


      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;

        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll


      if (placement === 'bottom') {
        if (shouldScroll) {
          scrollTo(scrollParent, scrollDown);
        }

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      }

      break;

    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }

        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      } // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below


      return {
        placement: 'bottom',
        maxHeight: maxHeight
      };

    default:
      throw new Error("Invalid placement provided \"".concat(placement, "\"."));
  }

  return defaultState;
} // Menu Component
// ------------------------------


function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}

var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement,
      _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      spacing = _ref2$theme.spacing,
      colors = _ref2$theme.colors;
  return _ref3 = {
    label: 'menu'
  }, _defineProperty$5(_ref3, alignToControl(placement), '100%'), _defineProperty$5(_ref3, "backgroundColor", colors.neutral0), _defineProperty$5(_ref3, "borderRadius", borderRadius), _defineProperty$5(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), _defineProperty$5(_ref3, "marginBottom", spacing.menuGutter), _defineProperty$5(_ref3, "marginTop", spacing.menuGutter), _defineProperty$5(_ref3, "position", 'absolute'), _defineProperty$5(_ref3, "width", '100%'), _defineProperty$5(_ref3, "zIndex", 1), _ref3;
};

var PortalPlacementContext = /*#__PURE__*/createContext({
  getPortalPlacement: null
}); // NOTE: internal only

var MenuPlacer = /*#__PURE__*/function (_Component) {
  _inherits$1(MenuPlacer, _Component);

  var _super = _createSuper(MenuPlacer);

  function MenuPlacer() {
    var _this;

    _classCallCheck$9(this, MenuPlacer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    };
    _this.context = void 0;

    _this.getPlacement = function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
          theme = _this$props.theme;
      if (!ref) return; // DO NOT scroll if position is fixed

      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition,
        theme: theme
      });
      var getPortalPlacement = _this.context.getPortalPlacement;
      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    };

    _this.getUpdatedProps = function () {
      var menuPlacement = _this.props.menuPlacement;
      var placement = _this.state.placement || coercePlacement(menuPlacement);
      return _objectSpread2(_objectSpread2({}, _this.props), {}, {
        placement: placement,
        maxHeight: _this.state.maxHeight
      });
    };

    return _this;
  }

  _createClass$9(MenuPlacer, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);

  return MenuPlacer;
}(Component);

MenuPlacer.contextType = PortalPlacementContext;

var Menu = function Menu(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return jsx("div", _extends$b({
    css: getStyles('menu', props),
    className: cx({
      menu: true
    }, className),
    ref: innerRef
  }, innerProps), children);
}; // Menu List
// ==============================


var menuListCSS = function menuListCSS(_ref4) {
  var maxHeight = _ref4.maxHeight,
      baseUnit = _ref4.theme.spacing.baseUnit;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: baseUnit,
    paddingTop: baseUnit,
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};

var MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      innerRef = props.innerRef,
      isMulti = props.isMulti;
  return jsx("div", _extends$b({
    css: getStyles('menuList', props),
    className: cx({
      'menu-list': true,
      'menu-list--is-multi': isMulti
    }, className),
    ref: innerRef
  }, innerProps), children);
}; // ==============================
// Menu Notices
// ==============================


var noticeCSS = function noticeCSS(_ref5) {
  var _ref5$theme = _ref5.theme,
      baseUnit = _ref5$theme.spacing.baseUnit,
      colors = _ref5$theme.colors;
  return {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
    textAlign: 'center'
  };
};

var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;

var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$b({
    css: getStyles('noOptionsMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--no-options': true
    }, className)
  }, innerProps), children);
};

NoOptionsMessage.defaultProps = {
  children: 'No options'
};

var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$b({
    css: getStyles('loadingMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--loading': true
    }, className)
  }, innerProps), children);
};

LoadingMessage.defaultProps = {
  children: 'Loading...'
}; // ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
      offset = _ref6.offset,
      position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};

var MenuPortal = /*#__PURE__*/function (_Component2) {
  _inherits$1(MenuPortal, _Component2);

  var _super2 = _createSuper(MenuPortal);

  function MenuPortal() {
    var _this2;

    _classCallCheck$9(this, MenuPortal);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _this2.state = {
      placement: null
    };

    _this2.getPortalPlacement = function (_ref7) {
      var placement = _ref7.placement;
      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed

      if (placement !== initialPlacement) {
        _this2.setState({
          placement: placement
        });
      }
    };

    return _this2;
  }

  _createClass$9(MenuPortal, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          appendTo = _this$props2.appendTo,
          children = _this$props2.children,
          className = _this$props2.className,
          controlElement = _this$props2.controlElement,
          cx = _this$props2.cx,
          innerProps = _this$props2.innerProps,
          menuPlacement = _this$props2.menuPlacement,
          position = _this$props2.menuPosition,
          getStyles = _this$props2.getStyles;
      var isFixed = position === 'fixed'; // bail early if required elements aren't present

      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = {
        offset: offset,
        position: position,
        rect: rect
      }; // same wrapper element whether fixed or portalled

      var menuWrapper = jsx("div", _extends$b({
        css: getStyles('menuPortal', state),
        className: cx({
          'menu-portal': true
        }, className)
      }, innerProps), children);
      return jsx(PortalPlacementContext.Provider, {
        value: {
          getPortalPlacement: this.getPortalPlacement
        }
      }, appendTo ? /*#__PURE__*/createPortal(menuWrapper, appendTo) : menuWrapper);
    }
  }]);

  return MenuPortal;
}(Component);

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : undefined,
    pointerEvents: isDisabled ? 'none' : undefined,
    // cancel mouse events when disabled
    position: 'relative'
  };
};

var SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;
  return jsx("div", _extends$b({
    css: getStyles('container', props),
    className: cx({
      '--is-disabled': isDisabled,
      '--is-rtl': isRtl
    }, className)
  }, innerProps), children);
}; // ==============================
// Value Container
// ==============================


var valueContainerCSS = function valueContainerCSS(_ref2) {
  var spacing = _ref2.theme.spacing,
      isMulti = _ref2.isMulti,
      hasValue = _ref2.hasValue,
      controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
  return {
    alignItems: 'center',
    display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
    flex: 1,
    flexWrap: 'wrap',
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  };
};

var ValueContainer = function ValueContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      innerProps = props.innerProps,
      isMulti = props.isMulti,
      getStyles = props.getStyles,
      hasValue = props.hasValue;
  return jsx("div", _extends$b({
    css: getStyles('valueContainer', props),
    className: cx({
      'value-container': true,
      'value-container--is-multi': isMulti,
      'value-container--has-value': hasValue
    }, className)
  }, innerProps), children);
}; // ==============================
// Indicator Container
// ==============================


var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};

var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      innerProps = props.innerProps,
      getStyles = props.getStyles;
  return jsx("div", _extends$b({
    css: getStyles('indicatorsContainer', props),
    className: cx({
      indicators: true
    }, className)
  }, innerProps), children);
};

var _templateObject$E;

var _excluded$2$1 = ["size"];

function _EMOTION_STRINGIFIED_CSS_ERROR__$2() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var _ref2$1 = process$1.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
}; // ==============================
// Dropdown & Clear Icons
// ==============================


var Svg = function Svg(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties$7(_ref, _excluded$2$1);

  return jsx("svg", _extends$b({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2$1
  }, props));
};

var CrossIcon = function CrossIcon(props) {
  return jsx(Svg, _extends$b({
    size: 20
  }, props), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};

var DownChevron = function DownChevron(props) {
  return jsx(Svg, _extends$b({
    size: 20
  }, props), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================


var baseCSS = function baseCSS(_ref3) {
  var isFocused = _ref3.isFocused,
      _ref3$theme = _ref3.theme,
      baseUnit = _ref3$theme.spacing.baseUnit,
      colors = _ref3$theme.colors;
  return {
    label: 'indicatorContainer',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = baseCSS;

var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$b({
    css: getStyles('dropdownIndicator', props),
    className: cx({
      indicator: true,
      'dropdown-indicator': true
    }, className)
  }, innerProps), children || jsx(DownChevron, null));
};

var clearIndicatorCSS = baseCSS;

var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$b({
    css: getStyles('clearIndicator', props),
    className: cx({
      indicator: true,
      'clear-indicator': true
    }, className)
  }, innerProps), children || jsx(CrossIcon, null));
}; // ==============================
// Separator
// ==============================


var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4) {
  var isDisabled = _ref4.isDisabled,
      _ref4$theme = _ref4.theme,
      baseUnit = _ref4$theme.spacing.baseUnit,
      colors = _ref4$theme.colors;
  return {
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2,
    width: 1
  };
};

var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("span", _extends$b({}, innerProps, {
    css: getStyles('indicatorSeparator', props),
    className: cx({
      'indicator-separator': true
    }, className)
  }));
}; // ==============================
// Loading
// ==============================


var loadingDotAnimations = keyframes$2(_templateObject$E || (_templateObject$E = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"])));

var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5) {
  var isFocused = _ref5.isFocused,
      size = _ref5.size,
      _ref5$theme = _ref5.theme,
      colors = _ref5$theme.colors,
      baseUnit = _ref5$theme.spacing.baseUnit;
  return {
    label: 'loadingIndicator',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref6) {
  var delay = _ref6.delay,
      offset = _ref6.offset;
  return jsx("span", {
    css: /*#__PURE__*/css$2({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: 'currentColor',
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : undefined,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    }, process$1.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process$1.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
};

var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isRtl = props.isRtl;
  return jsx("div", _extends$b({
    css: getStyles('loadingIndicator', props),
    className: cx({
      indicator: true,
      'loading-indicator': true
    }, className)
  }, innerProps), jsx(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), jsx(LoadingDot, {
    delay: 160,
    offset: true
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};

LoadingIndicator.defaultProps = {
  size: 4
};

var css$1 = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      borderRadius = _ref$theme.borderRadius,
      spacing = _ref$theme.spacing;
  return {
    label: 'control',
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      menuIsOpen = props.menuIsOpen;
  return jsx("div", _extends$b({
    ref: innerRef,
    css: getStyles('control', props),
    className: cx({
      control: true,
      'control--is-disabled': isDisabled,
      'control--is-focused': isFocused,
      'control--menu-is-open': menuIsOpen
    }, className)
  }, innerProps), children);
};

var _excluded$1$1 = ["data"];

var groupCSS = function groupCSS(_ref) {
  var spacing = _ref.theme.spacing;
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      headingProps = props.headingProps,
      innerProps = props.innerProps,
      label = props.label,
      theme = props.theme,
      selectProps = props.selectProps;
  return jsx("div", _extends$b({
    css: getStyles('group', props),
    className: cx({
      group: true
    }, className)
  }, innerProps), jsx(Heading, _extends$b({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    cx: cx
  }), label), jsx("div", null, children));
};

var groupHeadingCSS = function groupHeadingCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    label: 'group',
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: 500,
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};

var GroupHeading = function GroupHeading(props) {
  var getStyles = props.getStyles,
      cx = props.cx,
      className = props.className;

  var _cleanCommonProps = cleanCommonProps(props);

  _cleanCommonProps.data;

  var innerProps = _objectWithoutProperties$7(_cleanCommonProps, _excluded$1$1);

  return jsx("div", _extends$b({
    css: getStyles('groupHeading', props),
    className: cx({
      'group-heading': true
    }, className)
  }, innerProps));
};

var _excluded$R = ["innerRef", "isDisabled", "isHidden", "inputClassName"];

var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      value = _ref.value,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return _objectSpread2({
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.neutral80,
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: value ? 'translateZ(0)' : ''
  }, containerStyle);
};

var spacingStyle = {
  gridArea: '1 / 2',
  font: 'inherit',
  minWidth: '2px',
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
};
var containerStyle = {
  flex: '1 1 auto',
  display: 'inline-grid',
  gridArea: '1 / 1 / 2 / 3',
  gridTemplateColumns: '0 min-content',
  '&:after': _objectSpread2({
    content: 'attr(data-value) " "',
    visibility: 'hidden',
    whiteSpace: 'pre'
  }, spacingStyle)
};

var inputStyle = function inputStyle(isHidden) {
  return _objectSpread2({
    label: 'input',
    color: 'inherit',
    background: 0,
    opacity: isHidden ? 0 : 1,
    width: '100%'
  }, spacingStyle);
};

var Input$4 = function Input(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      value = props.value;

  var _cleanCommonProps = cleanCommonProps(props),
      innerRef = _cleanCommonProps.innerRef,
      isDisabled = _cleanCommonProps.isDisabled,
      isHidden = _cleanCommonProps.isHidden,
      inputClassName = _cleanCommonProps.inputClassName,
      innerProps = _objectWithoutProperties$7(_cleanCommonProps, _excluded$R);

  return jsx("div", {
    className: cx({
      'input-container': true
    }, className),
    css: getStyles('input', props),
    "data-value": value || ''
  }, jsx("input", _extends$b({
    className: cx({
      input: true
    }, inputClassName),
    ref: innerRef,
    style: inputStyle(isHidden),
    disabled: isDisabled
  }, innerProps)));
};

var multiValueCSS = function multiValueCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      borderRadius = _ref$theme.borderRadius,
      colors = _ref$theme.colors;
  return {
    label: 'multiValue',
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug

  };
};

var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
  var _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      colors = _ref2$theme.colors,
      cropWithEllipsis = _ref2.cropWithEllipsis;
  return {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
    whiteSpace: 'nowrap'
  };
};

var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
  var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      borderRadius = _ref3$theme.borderRadius,
      colors = _ref3$theme.colors,
      isFocused = _ref3.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused ? colors.dangerLight : undefined,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};

var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
      innerProps = _ref4.innerProps;
  return jsx("div", innerProps, children);
};

var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;

function MultiValueRemove(_ref5) {
  var children = _ref5.children,
      innerProps = _ref5.innerProps;
  return jsx("div", _extends$b({
    role: "button"
  }, innerProps), children || jsx(CrossIcon, {
    size: 14
  }));
}

var MultiValue = function MultiValue(props) {
  var children = props.children,
      className = props.className,
      components = props.components,
      cx = props.cx,
      data = props.data,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      removeProps = props.removeProps,
      selectProps = props.selectProps;
  var Container = components.Container,
      Label = components.Label,
      Remove = components.Remove;
  return jsx(ClassNames, null, function (_ref6) {
    var css = _ref6.css,
        emotionCx = _ref6.cx;
    return jsx(Container, {
      data: data,
      innerProps: _objectSpread2({
        className: emotionCx(css(getStyles('multiValue', props)), cx({
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, className))
      }, innerProps),
      selectProps: selectProps
    }, jsx(Label, {
      data: data,
      innerProps: {
        className: emotionCx(css(getStyles('multiValueLabel', props)), cx({
          'multi-value__label': true
        }, className))
      },
      selectProps: selectProps
    }, children), jsx(Remove, {
      data: data,
      innerProps: _objectSpread2({
        className: emotionCx(css(getStyles('multiValueRemove', props)), cx({
          'multi-value__remove': true
        }, className)),
        'aria-label': "Remove ".concat(children || 'option')
      }, removeProps),
      selectProps: selectProps
    }));
  });
};

var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'option',
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return jsx("div", _extends$b({
    css: getStyles('option', props),
    className: cx({
      option: true,
      'option--is-disabled': isDisabled,
      'option--is-focused': isFocused,
      'option--is-selected': isSelected
    }, className),
    ref: innerRef,
    "aria-disabled": isDisabled
  }, innerProps), children);
};

var placeholderCSS = function placeholderCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'placeholder',
    color: colors.neutral50,
    gridArea: '1 / 1 / 2 / 3',
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2
  };
};

var Placeholder = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$b({
    css: getStyles('placeholder', props),
    className: cx({
      placeholder: true
    }, className)
  }, innerProps), children);
};

var css = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'singleValue',
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    gridArea: '1 / 1 / 2 / 3',
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;
  return jsx("div", _extends$b({
    css: getStyles('singleValue', props),
    className: cx({
      'single-value': true,
      'single-value--is-disabled': isDisabled
    }, className)
  }, innerProps), children);
};

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input$4,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};

var defaultComponents = function defaultComponents(props) {
  return _objectSpread2(_objectSpread2({}, components), props.components);
};

function _arrayWithHoles$3(r) {
  if (Array.isArray(r)) return r;
}

function _iterableToArrayLimit$3(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayLikeToArray$f(r, a) {
  (null == a || a > r.length) && (a = r.length);

  for (var e = 0, n = Array(a); e < a; e++) {
    n[e] = r[e];
  }

  return n;
}

function _unsupportedIterableToArray$f(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$f(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$f(r, a) : void 0;
  }
}

function _nonIterableRest$3() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray$3(r, e) {
  return _arrayWithHoles$3(r) || _iterableToArrayLimit$3(r, e) || _unsupportedIterableToArray$f(r, e) || _nonIterableRest$3();
}

var _excluded$Q = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];

function useStateManager(_ref) {
  var _ref$defaultInputValu = _ref.defaultInputValue,
      defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu,
      _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen,
      defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
      propsInputValue = _ref.inputValue,
      propsMenuIsOpen = _ref.menuIsOpen,
      propsOnChange = _ref.onChange,
      propsOnInputChange = _ref.onInputChange,
      propsOnMenuClose = _ref.onMenuClose,
      propsOnMenuOpen = _ref.onMenuOpen,
      propsValue = _ref.value,
      restSelectProps = _objectWithoutProperties$7(_ref, _excluded$Q);

  var _useState = useState(propsInputValue !== undefined ? propsInputValue : defaultInputValue),
      _useState2 = _slicedToArray$3(_useState, 2),
      stateInputValue = _useState2[0],
      setStateInputValue = _useState2[1];

  var _useState3 = useState(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen),
      _useState4 = _slicedToArray$3(_useState3, 2),
      stateMenuIsOpen = _useState4[0],
      setStateMenuIsOpen = _useState4[1];

  var _useState5 = useState(propsValue !== undefined ? propsValue : defaultValue),
      _useState6 = _slicedToArray$3(_useState5, 2),
      stateValue = _useState6[0],
      setStateValue = _useState6[1];

  var onChange = useCallback(function (value, actionMeta) {
    if (typeof propsOnChange === 'function') {
      propsOnChange(value, actionMeta);
    }

    setStateValue(value);
  }, [propsOnChange]);
  var onInputChange = useCallback(function (value, actionMeta) {
    var newValue;

    if (typeof propsOnInputChange === 'function') {
      newValue = propsOnInputChange(value, actionMeta);
    }

    setStateInputValue(newValue !== undefined ? newValue : value);
  }, [propsOnInputChange]);
  var onMenuOpen = useCallback(function () {
    if (typeof propsOnMenuOpen === 'function') {
      propsOnMenuOpen();
    }

    setStateMenuIsOpen(true);
  }, [propsOnMenuOpen]);
  var onMenuClose = useCallback(function () {
    if (typeof propsOnMenuClose === 'function') {
      propsOnMenuClose();
    }

    setStateMenuIsOpen(false);
  }, [propsOnMenuClose]);
  var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
  var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
  var value = propsValue !== undefined ? propsValue : stateValue;
  return _objectSpread2(_objectSpread2({}, restSelectProps), {}, {
    inputValue: inputValue,
    menuIsOpen: menuIsOpen,
    onChange: onChange,
    onInputChange: onInputChange,
    onMenuClose: onMenuClose,
    onMenuOpen: onMenuOpen,
    value: value
  });
}

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray$f(r);
}

function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray$f(r) || _nonIterableSpread();
}

var safeIsNaN = Number.isNaN || function ponyfill(value) {
  return typeof value === 'number' && value !== value;
};

function isEqual$1(first, second) {
  if (first === second) {
    return true;
  }

  if (safeIsNaN(first) && safeIsNaN(second)) {
    return true;
  }

  return false;
}

function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (!isEqual$1(newInputs[i], lastInputs[i])) {
      return false;
    }
  }

  return true;
}

function memoizeOne(resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = areInputsEqual;
  }

  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;

  function memoized() {
    var newArgs = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }

    if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  }

  return memoized;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var _ref = process$1.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
};

var A11yText = function A11yText(props) {
  return jsx("span", _extends$b({
    css: _ref
  }, props));
};

var defaultAriaLiveMessages = {
  guidance: function guidance(props) {
    var isSearchable = props.isSearchable,
        isMulti = props.isMulti,
        isDisabled = props.isDisabled,
        tabSelectsValue = props.tabSelectsValue,
        context = props.context;

    switch (context) {
      case 'menu':
        return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");

      case 'input':
        return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');

      case 'value':
        return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';

      default:
        return '';
    }
  },
  onChange: function onChange(props) {
    var action = props.action,
        _props$label = props.label,
        label = _props$label === void 0 ? '' : _props$label,
        labels = props.labels,
        isDisabled = props.isDisabled;

    switch (action) {
      case 'deselect-option':
      case 'pop-value':
      case 'remove-value':
        return "option ".concat(label, ", deselected.");

      case 'clear':
        return 'All selected options have been cleared.';

      case 'initial-input-focus':
        return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");

      case 'select-option':
        return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");

      default:
        return '';
    }
  },
  onFocus: function onFocus(props) {
    var context = props.context,
        focused = props.focused,
        options = props.options,
        _props$label2 = props.label,
        label = _props$label2 === void 0 ? '' : _props$label2,
        selectValue = props.selectValue,
        isDisabled = props.isDisabled,
        isSelected = props.isSelected;

    var getArrayIndex = function getArrayIndex(arr, item) {
      return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
    };

    if (context === 'value' && selectValue) {
      return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
    }

    if (context === 'menu') {
      var disabled = isDisabled ? ' disabled' : '';
      var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
      return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
    }

    return '';
  },
  onFilter: function onFilter(props) {
    var inputValue = props.inputValue,
        resultsMessage = props.resultsMessage;
    return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
  }
};

var LiveRegion = function LiveRegion(props) {
  var ariaSelection = props.ariaSelection,
      focusedOption = props.focusedOption,
      focusedValue = props.focusedValue,
      focusableOptions = props.focusableOptions,
      isFocused = props.isFocused,
      selectValue = props.selectValue,
      selectProps = props.selectProps,
      id = props.id;
  var ariaLiveMessages = selectProps.ariaLiveMessages,
      getOptionLabel = selectProps.getOptionLabel,
      inputValue = selectProps.inputValue,
      isMulti = selectProps.isMulti,
      isOptionDisabled = selectProps.isOptionDisabled,
      isSearchable = selectProps.isSearchable,
      menuIsOpen = selectProps.menuIsOpen,
      options = selectProps.options,
      screenReaderStatus = selectProps.screenReaderStatus,
      tabSelectsValue = selectProps.tabSelectsValue;
  var ariaLabel = selectProps['aria-label'];
  var ariaLive = selectProps['aria-live']; // Update aria live message configuration when prop changes

  var messages = useMemo(function () {
    return _objectSpread2(_objectSpread2({}, defaultAriaLiveMessages), ariaLiveMessages || {});
  }, [ariaLiveMessages]); // Update aria live selected option when prop changes

  var ariaSelected = useMemo(function () {
    var message = '';

    if (ariaSelection && messages.onChange) {
      var option = ariaSelection.option,
          selectedOptions = ariaSelection.options,
          removedValue = ariaSelection.removedValue,
          removedValues = ariaSelection.removedValues,
          value = ariaSelection.value; // select-option when !isMulti does not return option so we assume selected option is value

      var asOption = function asOption(val) {
        return !Array.isArray(val) ? val : null;
      }; // If there is just one item from the action then get its label


      var selected = removedValue || option || asOption(value);
      var label = selected ? getOptionLabel(selected) : ''; // If there are multiple items from the action then return an array of labels

      var multiSelected = selectedOptions || removedValues || undefined;
      var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];

      var onChangeProps = _objectSpread2({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: selected && isOptionDisabled(selected, selectValue),
        label: label,
        labels: labels
      }, ariaSelection);

      message = messages.onChange(onChangeProps);
    }

    return message;
  }, [ariaSelection, messages, isOptionDisabled, selectValue, getOptionLabel]);
  var ariaFocused = useMemo(function () {
    var focusMsg = '';
    var focused = focusedOption || focusedValue;
    var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));

    if (focused && messages.onFocus) {
      var onFocusProps = {
        focused: focused,
        label: getOptionLabel(focused),
        isDisabled: isOptionDisabled(focused, selectValue),
        isSelected: isSelected,
        options: options,
        context: focused === focusedOption ? 'menu' : 'value',
        selectValue: selectValue
      };
      focusMsg = messages.onFocus(onFocusProps);
    }

    return focusMsg;
  }, [focusedOption, focusedValue, getOptionLabel, isOptionDisabled, messages, options, selectValue]);
  var ariaResults = useMemo(function () {
    var resultsMsg = '';

    if (menuIsOpen && options.length && messages.onFilter) {
      var resultsMessage = screenReaderStatus({
        count: focusableOptions.length
      });
      resultsMsg = messages.onFilter({
        inputValue: inputValue,
        resultsMessage: resultsMessage
      });
    }

    return resultsMsg;
  }, [focusableOptions, inputValue, menuIsOpen, messages, options, screenReaderStatus]);
  var ariaGuidance = useMemo(function () {
    var guidanceMsg = '';

    if (messages.guidance) {
      var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
      guidanceMsg = messages.guidance({
        'aria-label': ariaLabel,
        context: context,
        isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
        isMulti: isMulti,
        isSearchable: isSearchable,
        tabSelectsValue: tabSelectsValue
      });
    }

    return guidanceMsg;
  }, [ariaLabel, focusedOption, focusedValue, isMulti, isOptionDisabled, isSearchable, menuIsOpen, messages, selectValue, tabSelectsValue]);
  var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
  var ScreenReaderText = jsx(Fragment$1, null, jsx("span", {
    id: "aria-selection"
  }, ariaSelected), jsx("span", {
    id: "aria-context"
  }, ariaContext));
  var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
  return jsx(Fragment$1, null, jsx(A11yText, {
    id: id
  }, isInitialFocus && ScreenReaderText), jsx(A11yText, {
    "aria-live": ariaLive,
    "aria-atomic": "false",
    "aria-relevant": "additions text"
  }, isFocused && !isInitialFocus && ScreenReaderText));
};

var diacritics = [{
  base: 'A',
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: 'AA',
  letters: "\uA732"
}, {
  base: 'AE',
  letters: "\xC6\u01FC\u01E2"
}, {
  base: 'AO',
  letters: "\uA734"
}, {
  base: 'AU',
  letters: "\uA736"
}, {
  base: 'AV',
  letters: "\uA738\uA73A"
}, {
  base: 'AY',
  letters: "\uA73C"
}, {
  base: 'B',
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: 'C',
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: 'D',
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: 'DZ',
  letters: "\u01F1\u01C4"
}, {
  base: 'Dz',
  letters: "\u01F2\u01C5"
}, {
  base: 'E',
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: 'F',
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: 'G',
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: 'H',
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: 'I',
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: 'J',
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: 'K',
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: 'L',
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: 'LJ',
  letters: "\u01C7"
}, {
  base: 'Lj',
  letters: "\u01C8"
}, {
  base: 'M',
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: 'N',
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: 'NJ',
  letters: "\u01CA"
}, {
  base: 'Nj',
  letters: "\u01CB"
}, {
  base: 'O',
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: 'OI',
  letters: "\u01A2"
}, {
  base: 'OO',
  letters: "\uA74E"
}, {
  base: 'OU',
  letters: "\u0222"
}, {
  base: 'P',
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: 'Q',
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: 'R',
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: 'S',
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: 'T',
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: 'TZ',
  letters: "\uA728"
}, {
  base: 'U',
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: 'V',
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: 'VY',
  letters: "\uA760"
}, {
  base: 'W',
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: 'X',
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: 'Y',
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: 'Z',
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: 'a',
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: 'aa',
  letters: "\uA733"
}, {
  base: 'ae',
  letters: "\xE6\u01FD\u01E3"
}, {
  base: 'ao',
  letters: "\uA735"
}, {
  base: 'au',
  letters: "\uA737"
}, {
  base: 'av',
  letters: "\uA739\uA73B"
}, {
  base: 'ay',
  letters: "\uA73D"
}, {
  base: 'b',
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: 'c',
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: 'd',
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: 'dz',
  letters: "\u01F3\u01C6"
}, {
  base: 'e',
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: 'f',
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: 'g',
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: 'h',
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: 'hv',
  letters: "\u0195"
}, {
  base: 'i',
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: 'j',
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: 'k',
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: 'l',
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: 'lj',
  letters: "\u01C9"
}, {
  base: 'm',
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: 'n',
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: 'nj',
  letters: "\u01CC"
}, {
  base: 'o',
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: 'oi',
  letters: "\u01A3"
}, {
  base: 'ou',
  letters: "\u0223"
}, {
  base: 'oo',
  letters: "\uA74F"
}, {
  base: 'p',
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: 'q',
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: 'r',
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: 's',
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: 't',
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: 'tz',
  letters: "\uA729"
}, {
  base: 'u',
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: 'v',
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: 'vy',
  letters: "\uA761"
}, {
  base: 'w',
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: 'x',
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: 'y',
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: 'z',
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}];
var anyDiacritic = new RegExp('[' + diacritics.map(function (d) {
  return d.letters;
}).join('') + ']', 'g');
var diacriticToBase = {};

for (var i = 0; i < diacritics.length; i++) {
  var diacritic = diacritics[i];

  for (var j = 0; j < diacritic.letters.length; j++) {
    diacriticToBase[diacritic.letters[j]] = diacritic.base;
  }
}

var stripDiacritics$1 = function stripDiacritics(str) {
  return str.replace(anyDiacritic, function (match) {
    return diacriticToBase[match];
  });
};

var memoizedStripDiacriticsForInput = memoizeOne(stripDiacritics$1);

var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};

var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    // eslint-disable-next-line no-underscore-dangle
    if (option.data.__isNew__) return true;

    var _ignoreCase$ignoreAcc = _objectSpread2({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: 'any'
    }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify = _ignoreCase$ignoreAcc.stringify,
        trim = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;

    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);

    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }

    if (ignoreAccents) {
      input = memoizedStripDiacriticsForInput(input);
      candidate = stripDiacritics$1(candidate);
    }

    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

var _excluded$P = ["innerRef"];

function DummyInput(_ref) {
  var innerRef = _ref.innerRef,
      props = _objectWithoutProperties$7(_ref, _excluded$P);

  return jsx("input", _extends$b({
    ref: innerRef
  }, props, {
    css: /*#__PURE__*/css$2({
      label: 'dummyInput',
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: 'transparent',
      fontSize: 'inherit',
      gridArea: '1 / 1 / 2 / 3',
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: 'transparent',
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: 'relative',
      transform: 'scale(.01)'
    }, process$1.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process$1.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNNIiwiZmlsZSI6IkR1bW15SW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgcmV0dXJuIChcbiAgICA8aW5wdXRcbiAgICAgIHJlZj17aW5uZXJSZWZ9XG4gICAgICB7Li4ucHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}

var cancelScroll = function cancelScroll(event) {
  event.preventDefault();
  event.stopPropagation();
};

function useScrollCapture(_ref) {
  var isEnabled = _ref.isEnabled,
      onBottomArrive = _ref.onBottomArrive,
      onBottomLeave = _ref.onBottomLeave,
      onTopArrive = _ref.onTopArrive,
      onTopLeave = _ref.onTopLeave;
  var isBottom = useRef(false);
  var isTop = useRef(false);
  var touchStart = useRef(0);
  var scrollTarget = useRef(null);
  var handleEventDelta = useCallback(function (event, delta) {
    if (scrollTarget.current === null) return;
    var _scrollTarget$current = scrollTarget.current,
        scrollTop = _scrollTarget$current.scrollTop,
        scrollHeight = _scrollTarget$current.scrollHeight,
        clientHeight = _scrollTarget$current.clientHeight;
    var target = scrollTarget.current;
    var isDeltaPositive = delta > 0;
    var availableScroll = scrollHeight - clientHeight - scrollTop;
    var shouldCancelScroll = false; // reset bottom/top flags

    if (availableScroll > delta && isBottom.current) {
      if (onBottomLeave) onBottomLeave(event);
      isBottom.current = false;
    }

    if (isDeltaPositive && isTop.current) {
      if (onTopLeave) onTopLeave(event);
      isTop.current = false;
    } // bottom limit


    if (isDeltaPositive && delta > availableScroll) {
      if (onBottomArrive && !isBottom.current) {
        onBottomArrive(event);
      }

      target.scrollTop = scrollHeight;
      shouldCancelScroll = true;
      isBottom.current = true; // top limit
    } else if (!isDeltaPositive && -delta > scrollTop) {
      if (onTopArrive && !isTop.current) {
        onTopArrive(event);
      }

      target.scrollTop = 0;
      shouldCancelScroll = true;
      isTop.current = true;
    } // cancel scroll


    if (shouldCancelScroll) {
      cancelScroll(event);
    }
  }, [onBottomArrive, onBottomLeave, onTopArrive, onTopLeave]);
  var onWheel = useCallback(function (event) {
    handleEventDelta(event, event.deltaY);
  }, [handleEventDelta]);
  var onTouchStart = useCallback(function (event) {
    // set touch start so we can calculate touchmove delta
    touchStart.current = event.changedTouches[0].clientY;
  }, []);
  var onTouchMove = useCallback(function (event) {
    var deltaY = touchStart.current - event.changedTouches[0].clientY;
    handleEventDelta(event, deltaY);
  }, [handleEventDelta]);
  var startListening = useCallback(function (el) {
    // bail early if no element is available to attach to
    if (!el) return;
    var notPassive = supportsPassiveEvents ? {
      passive: false
    } : false;
    el.addEventListener('wheel', onWheel, notPassive);
    el.addEventListener('touchstart', onTouchStart, notPassive);
    el.addEventListener('touchmove', onTouchMove, notPassive);
  }, [onTouchMove, onTouchStart, onWheel]);
  var stopListening = useCallback(function (el) {
    // bail early if no element is available to detach from
    if (!el) return;
    el.removeEventListener('wheel', onWheel, false);
    el.removeEventListener('touchstart', onTouchStart, false);
    el.removeEventListener('touchmove', onTouchMove, false);
  }, [onTouchMove, onTouchStart, onWheel]);
  useEffect(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    startListening(element);
    return function () {
      stopListening(element);
    };
  }, [isEnabled, startListening, stopListening]);
  return function (element) {
    scrollTarget.current = element;
  };
}

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};

function preventTouchMove(e) {
  e.preventDefault();
}

function allowTouchMove(e) {
  e.stopPropagation();
}

function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface


function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

var canUseDOM$1 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;
var listenerOptions = {
  capture: false,
  passive: false
};

function useScrollLock(_ref) {
  var isEnabled = _ref.isEnabled,
      _ref$accountForScroll = _ref.accountForScrollbars,
      accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
  var originalStyles = useRef({});
  var scrollTarget = useRef(null);
  var addScrollLock = useCallback(function (touchScrollTarget) {
    if (!canUseDOM$1) return;
    var target = document.body;
    var targetStyle = target && target.style;

    if (accountForScrollbars) {
      // store any styles already applied to the body
      STYLE_KEYS.forEach(function (key) {
        var val = targetStyle && targetStyle[key];
        originalStyles.current[key] = val;
      });
    } // apply the lock styles and padding if this is the first scroll lock


    if (accountForScrollbars && activeScrollLocks < 1) {
      var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
      var clientWidth = document.body ? document.body.clientWidth : 0;
      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
      Object.keys(LOCK_STYLES).forEach(function (key) {
        var val = LOCK_STYLES[key];

        if (targetStyle) {
          targetStyle[key] = val;
        }
      });

      if (targetStyle) {
        targetStyle.paddingRight = "".concat(adjustedPadding, "px");
      }
    } // account for touch devices


    if (target && isTouchDevice()) {
      // Mobile Safari ignores { overflow: hidden } declaration on the body.
      target.addEventListener('touchmove', preventTouchMove, listenerOptions); // Allow scroll on provided target

      if (touchScrollTarget) {
        touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.addEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    } // increment active scroll locks


    activeScrollLocks += 1;
  }, [accountForScrollbars]);
  var removeScrollLock = useCallback(function (touchScrollTarget) {
    if (!canUseDOM$1) return;
    var target = document.body;
    var targetStyle = target && target.style; // safely decrement active scroll locks

    activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any

    if (accountForScrollbars && activeScrollLocks < 1) {
      STYLE_KEYS.forEach(function (key) {
        var val = originalStyles.current[key];

        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    } // remove touch listeners


    if (target && isTouchDevice()) {
      target.removeEventListener('touchmove', preventTouchMove, listenerOptions);

      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, listenerOptions);
        touchScrollTarget.removeEventListener('touchmove', allowTouchMove, listenerOptions);
      }
    }
  }, [accountForScrollbars]);
  useEffect(function () {
    if (!isEnabled) return;
    var element = scrollTarget.current;
    addScrollLock(element);
    return function () {
      removeScrollLock(element);
    };
  }, [isEnabled, addScrollLock, removeScrollLock]);
  return function (element) {
    scrollTarget.current = element;
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var blurSelectInput = function blurSelectInput() {
  return document.activeElement && document.activeElement.blur();
};

var _ref2 = process$1.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function ScrollManager(_ref) {
  var children = _ref.children,
      lockEnabled = _ref.lockEnabled,
      _ref$captureEnabled = _ref.captureEnabled,
      captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled,
      onBottomArrive = _ref.onBottomArrive,
      onBottomLeave = _ref.onBottomLeave,
      onTopArrive = _ref.onTopArrive,
      onTopLeave = _ref.onTopLeave;
  var setScrollCaptureTarget = useScrollCapture({
    isEnabled: captureEnabled,
    onBottomArrive: onBottomArrive,
    onBottomLeave: onBottomLeave,
    onTopArrive: onTopArrive,
    onTopLeave: onTopLeave
  });
  var setScrollLockTarget = useScrollLock({
    isEnabled: lockEnabled
  });

  var targetRef = function targetRef(element) {
    setScrollCaptureTarget(element);
    setScrollLockTarget(element);
  };

  return jsx(Fragment$1, null, lockEnabled && jsx("div", {
    onClick: blurSelectInput,
    css: _ref2
  }), children(targetRef));
}

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};

var getOptionLabel$1 = function getOptionLabel(option) {
  return option.label;
};

var getOptionValue$1 = function getOptionValue(option) {
  return option.value;
};

var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css,
  valueContainer: valueContainerCSS
}; // Merge Utility

var colors$p = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4; // Used to calculate consistent margin/padding on elements

var baseUnit = 4; // The minimum height of the control

var controlHeight = 38; // The amount of space between the control and menu */

var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors$p,
  spacing: spacing
};
var defaultProps$Q = {
  'aria-live': 'polite',
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel$1,
  getOptionValue: getOptionValue$1,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: true
};

function toCategorizedOption(props, option, selectValue, index) {
  var isDisabled = _isOptionDisabled(props, option, selectValue);

  var isSelected = _isOptionSelected(props, option, selectValue);

  var label = getOptionLabel(props, option);
  var value = getOptionValue(props, option);
  return {
    type: 'option',
    data: option,
    isDisabled: isDisabled,
    isSelected: isSelected,
    label: label,
    value: value,
    index: index
  };
}

function buildCategorizedOptions(props, selectValue) {
  return props.options.map(function (groupOrOption, groupOrOptionIndex) {
    if ('options' in groupOrOption) {
      var categorizedOptions = groupOrOption.options.map(function (option, optionIndex) {
        return toCategorizedOption(props, option, selectValue, optionIndex);
      }).filter(function (categorizedOption) {
        return isFocusable(props, categorizedOption);
      });
      return categorizedOptions.length > 0 ? {
        type: 'group',
        data: groupOrOption,
        options: categorizedOptions,
        index: groupOrOptionIndex
      } : undefined;
    }

    var categorizedOption = toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
    return isFocusable(props, categorizedOption) ? categorizedOption : undefined;
  }).filter(notNullish);
}

function buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
  return categorizedOptions.reduce(function (optionsAccumulator, categorizedOption) {
    if (categorizedOption.type === 'group') {
      optionsAccumulator.push.apply(optionsAccumulator, _toConsumableArray(categorizedOption.options.map(function (option) {
        return option.data;
      })));
    } else {
      optionsAccumulator.push(categorizedOption.data);
    }

    return optionsAccumulator;
  }, []);
}

function buildFocusableOptions(props, selectValue) {
  return buildFocusableOptionsFromCategorizedOptions(buildCategorizedOptions(props, selectValue));
}

function isFocusable(props, categorizedOption) {
  var _props$inputValue = props.inputValue,
      inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
  var data = categorizedOption.data,
      isSelected = categorizedOption.isSelected,
      label = categorizedOption.label,
      value = categorizedOption.value;
  return (!shouldHideSelectedOptions(props) || !isSelected) && _filterOption(props, {
    label: label,
    value: value,
    data: data
  }, inputValue);
}

function getNextFocusedValue(state, nextSelectValue) {
  var focusedValue = state.focusedValue,
      lastSelectValue = state.selectValue;
  var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);

  if (lastFocusedIndex > -1) {
    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);

    if (nextFocusedIndex > -1) {
      // the focused value is still in the selectValue, return it
      return focusedValue;
    } else if (lastFocusedIndex < nextSelectValue.length) {
      // the focusedValue is not present in the next selectValue array by
      // reference, so return the new value at the same index
      return nextSelectValue[lastFocusedIndex];
    }
  }

  return null;
}

function getNextFocusedOption(state, options) {
  var lastFocusedOption = state.focusedOption;
  return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}

var getOptionLabel = function getOptionLabel(props, data) {
  return props.getOptionLabel(data);
};

var getOptionValue = function getOptionValue(props, data) {
  return props.getOptionValue(data);
};

function _isOptionDisabled(props, option, selectValue) {
  return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}

function _isOptionSelected(props, option, selectValue) {
  if (selectValue.indexOf(option) > -1) return true;

  if (typeof props.isOptionSelected === 'function') {
    return props.isOptionSelected(option, selectValue);
  }

  var candidate = getOptionValue(props, option);
  return selectValue.some(function (i) {
    return getOptionValue(props, i) === candidate;
  });
}

function _filterOption(props, option, inputValue) {
  return props.filterOption ? props.filterOption(option, inputValue) : true;
}

var shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
  var hideSelectedOptions = props.hideSelectedOptions,
      isMulti = props.isMulti;
  if (hideSelectedOptions === undefined) return isMulti;
  return hideSelectedOptions;
};

var instanceId = 1;

var Select$1 = /*#__PURE__*/function (_Component) {
  _inherits$1(Select, _Component);

  var _super = _createSuper(Select); // Misc. Instance Properties
  // ------------------------------
  // TODO
  // Refs
  // ------------------------------
  // Lifecycle
  // ------------------------------


  function Select(_props) {
    var _this;

    _classCallCheck$9(this, Select);

    _this = _super.call(this, _props);
    _this.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      selectValue: [],
      clearFocusValueOnUpdate: false,
      prevWasFocused: false,
      inputIsHiddenAfterUpdate: undefined,
      prevProps: undefined
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.commonProps = void 0;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.instancePrefix = '';
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.controlRef = null;

    _this.getControlRef = function (ref) {
      _this.controlRef = ref;
    };

    _this.focusedOptionRef = null;

    _this.getFocusedOptionRef = function (ref) {
      _this.focusedOptionRef = ref;
    };

    _this.menuListRef = null;

    _this.getMenuListRef = function (ref) {
      _this.menuListRef = ref;
    };

    _this.inputRef = null;

    _this.getInputRef = function (ref) {
      _this.inputRef = ref;
    };

    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;

    _this.onChange = function (newValue, actionMeta) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          name = _this$props.name;
      actionMeta.name = name;

      _this.ariaOnChange(newValue, actionMeta);

      onChange(newValue, actionMeta);
    };

    _this.setValue = function (newValue, action, option) {
      var _this$props2 = _this.props,
          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
          isMulti = _this$props2.isMulti,
          inputValue = _this$props2.inputValue;

      _this.onInputChange('', {
        action: 'set-value',
        prevInputValue: inputValue
      });

      if (closeMenuOnSelect) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });

        _this.onMenuClose();
      } // when the select value should change, we should reset focusedValue


      _this.setState({
        clearFocusValueOnUpdate: true
      });

      _this.onChange(newValue, {
        action: action,
        option: option
      });
    };

    _this.selectOption = function (newValue) {
      var _this$props3 = _this.props,
          blurInputOnSelect = _this$props3.blurInputOnSelect,
          isMulti = _this$props3.isMulti,
          name = _this$props3.name;
      var selectValue = _this.state.selectValue;

      var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);

      var isDisabled = _this.isOptionDisabled(newValue, selectValue);

      if (deselected) {
        var candidate = _this.getOptionValue(newValue);

        _this.setValue(multiValueAsValue(selectValue.filter(function (i) {
          return _this.getOptionValue(i) !== candidate;
        })), 'deselect-option', newValue);
      } else if (!isDisabled) {
        // Select option if option is not disabled
        if (isMulti) {
          _this.setValue(multiValueAsValue([].concat(_toConsumableArray(selectValue), [newValue])), 'select-option', newValue);
        } else {
          _this.setValue(singleValueAsValue(newValue), 'select-option');
        }
      } else {
        _this.ariaOnChange(singleValueAsValue(newValue), {
          action: 'select-option',
          option: newValue,
          name: name
        });

        return;
      }

      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };

    _this.removeValue = function (removedValue) {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;

      var candidate = _this.getOptionValue(removedValue);

      var newValueArray = selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      });
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);

      _this.onChange(newValue, {
        action: 'remove-value',
        removedValue: removedValue
      });

      _this.focusInput();
    };

    _this.clearValue = function () {
      var selectValue = _this.state.selectValue;

      _this.onChange(valueTernary(_this.props.isMulti, [], null), {
        action: 'clear',
        removedValues: selectValue
      });
    };

    _this.popValue = function () {
      var isMulti = _this.props.isMulti;
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValueArray = selectValue.slice(0, selectValue.length - 1);
      var newValue = valueTernary(isMulti, newValueArray, newValueArray[0] || null);

      _this.onChange(newValue, {
        action: 'pop-value',
        removedValue: lastSelectedValue
      });
    };

    _this.getValue = function () {
      return _this.state.selectValue;
    };

    _this.cx = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return classNames.apply(void 0, [_this.props.classNamePrefix].concat(args));
    };

    _this.getOptionLabel = function (data) {
      return getOptionLabel(_this.props, data);
    };

    _this.getOptionValue = function (data) {
      return getOptionValue(_this.props, data);
    };

    _this.getStyles = function (key, props) {
      var base = defaultStyles[key](props);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };

    _this.getElementId = function (element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    };

    _this.getComponents = function () {
      return defaultComponents(_this.props);
    };

    _this.buildCategorizedOptions = function () {
      return buildCategorizedOptions(_this.props, _this.state.selectValue);
    };

    _this.getCategorizedOptions = function () {
      return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
    };

    _this.buildFocusableOptions = function () {
      return buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
    };

    _this.getFocusableOptions = function () {
      return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
    };

    _this.ariaOnChange = function (value, actionMeta) {
      _this.setState({
        ariaSelection: _objectSpread2({
          value: value
        }, actionMeta)
      });
    };

    _this.onMenuMouseDown = function (event) {
      if (event.button !== 0) {
        return;
      }

      event.stopPropagation();
      event.preventDefault();

      _this.focusInput();
    };

    _this.onMenuMouseMove = function (event) {
      _this.blockOptionHover = false;
    };

    _this.onControlMouseDown = function (event) {
      var openMenuOnClick = _this.props.openMenuOnClick;

      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }

        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
          _this.onMenuClose();
        }
      }

      if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
        event.preventDefault();
      }
    };

    _this.onDropdownIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
          isMulti = _this$props4.isMulti,
          menuIsOpen = _this$props4.menuIsOpen;

      _this.focusInput();

      if (menuIsOpen) {
        _this.setState({
          inputIsHiddenAfterUpdate: !isMulti
        });

        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }

      event.preventDefault();
      event.stopPropagation();
    };

    _this.onClearIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      _this.clearValue();

      event.preventDefault();
      event.stopPropagation();
      _this.openAfterFocus = false;

      if (event.type === 'touchend') {
        _this.focusInput();
      } else {
        setTimeout(function () {
          return _this.focusInput();
        });
      }
    };

    _this.onScroll = function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };

    _this.onCompositionStart = function () {
      _this.isComposing = true;
    };

    _this.onCompositionEnd = function () {
      _this.isComposing = false;
    };

    _this.onTouchStart = function (_ref2) {
      var touches = _ref2.touches;
      var touch = touches && touches.item(0);

      if (!touch) {
        return;
      }

      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };

    _this.onTouchMove = function (_ref3) {
      var touches = _ref3.touches;
      var touch = touches && touches.item(0);

      if (!touch) {
        return;
      }

      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };

    _this.onTouchEnd = function (event) {
      if (_this.userIsDragging) return; // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).

      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      } // reset move vars


      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };

    _this.onControlTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onControlMouseDown(event);
    };

    _this.onClearIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onClearIndicatorMouseDown(event);
    };

    _this.onDropdownIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onDropdownIndicatorMouseDown(event);
    };

    _this.handleInputChange = function (event) {
      var prevInputValue = _this.props.inputValue;
      var inputValue = event.currentTarget.value;

      _this.setState({
        inputIsHiddenAfterUpdate: false
      });

      _this.onInputChange(inputValue, {
        action: 'input-change',
        prevInputValue: prevInputValue
      });

      if (!_this.props.menuIsOpen) {
        _this.onMenuOpen();
      }
    };

    _this.onInputFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      _this.setState({
        inputIsHiddenAfterUpdate: false,
        isFocused: true
      });

      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }

      _this.openAfterFocus = false;
    };

    _this.onInputBlur = function (event) {
      var prevInputValue = _this.props.inputValue;

      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();

        return;
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      _this.onInputChange('', {
        action: 'input-blur',
        prevInputValue: prevInputValue
      });

      _this.onMenuClose();

      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };

    _this.onOptionHover = function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }

      _this.setState({
        focusedOption: focusedOption
      });
    };

    _this.shouldHideSelectedOptions = function () {
      return shouldHideSelectedOptions(_this.props);
    };

    _this.onKeyDown = function (event) {
      var _this$props5 = _this.props,
          isMulti = _this$props5.isMulti,
          backspaceRemovesValue = _this$props5.backspaceRemovesValue,
          escapeClearsValue = _this$props5.escapeClearsValue,
          inputValue = _this$props5.inputValue,
          isClearable = _this$props5.isClearable,
          isDisabled = _this$props5.isDisabled,
          menuIsOpen = _this$props5.menuIsOpen,
          onKeyDown = _this$props5.onKeyDown,
          tabSelectsValue = _this$props5.tabSelectsValue,
          openMenuOnFocus = _this$props5.openMenuOnFocus;
      var _this$state = _this.state,
          focusedOption = _this$state.focusedOption,
          focusedValue = _this$state.focusedValue,
          selectValue = _this$state.selectValue;
      if (isDisabled) return;

      if (typeof onKeyDown === 'function') {
        onKeyDown(event);

        if (event.defaultPrevented) {
          return;
        }
      } // Block option hover events when the user has just pressed a key


      _this.blockOptionHover = true;

      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;

          _this.focusValue('previous');

          break;

        case 'ArrowRight':
          if (!isMulti || inputValue) return;

          _this.focusValue('next');

          break;

        case 'Delete':
        case 'Backspace':
          if (inputValue) return;

          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;

            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }

          break;

        case 'Tab':
          if (_this.isComposing) return;

          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }

          _this.selectOption(focusedOption);

          break;

        case 'Enter':
          if (event.keyCode === 229) {
            // ignore the keydown event from an Input Method Editor(IME)
            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
            break;
          }

          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;

            _this.selectOption(focusedOption);

            break;
          }

          return;

        case 'Escape':
          if (menuIsOpen) {
            _this.setState({
              inputIsHiddenAfterUpdate: false
            });

            _this.onInputChange('', {
              action: 'menu-close',
              prevInputValue: inputValue
            });

            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }

          break;

        case ' ':
          // space
          if (inputValue) {
            return;
          }

          if (!menuIsOpen) {
            _this.openMenu('first');

            break;
          }

          if (!focusedOption) return;

          _this.selectOption(focusedOption);

          break;

        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }

          break;

        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }

          break;

        case 'PageUp':
          if (!menuIsOpen) return;

          _this.focusOption('pageup');

          break;

        case 'PageDown':
          if (!menuIsOpen) return;

          _this.focusOption('pagedown');

          break;

        case 'Home':
          if (!menuIsOpen) return;

          _this.focusOption('first');

          break;

        case 'End':
          if (!menuIsOpen) return;

          _this.focusOption('last');

          break;

        default:
          return;
      }

      event.preventDefault();
    };

    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);
    _this.state.selectValue = cleanValue(_props.value);
    return _this;
  }

  _createClass$9(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();

      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }

      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props6 = this.props,
          isDisabled = _this$props6.isDisabled,
          menuIsOpen = _this$props6.menuIsOpen;
      var isFocused = this.state.isFocused;

      if ( // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }

      if (isFocused && isDisabled && !prevProps.isDisabled) {
        // ensure select state gets blurred in case Select is programatically disabled while focused
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          isFocused: false
        }, this.onMenuClose);
      } // scroll the focused option into view if necessary


      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    } // ==============================
    // Consumer Handlers
    // ==============================

  }, {
    key: "onMenuOpen",
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      this.onInputChange('', {
        action: 'menu-close',
        prevInputValue: this.props.inputValue
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    } // ==============================
    // Methods
    // ==============================

  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    } // aliased for consumers

  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this2 = this;

      var _this$state2 = this.state,
          selectValue = _this$state2.selectValue,
          isFocused = _this$state2.isFocused;
      var focusableOptions = this.buildFocusableOptions();
      var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;

      if (!this.props.isMulti) {
        var selectedIndex = focusableOptions.indexOf(selectValue[0]);

        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      } // only scroll if the menu isn't already open


      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.setState({
        inputIsHiddenAfterUpdate: false,
        focusedValue: null,
        focusedOption: focusableOptions[openAtIndex]
      }, function () {
        return _this2.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$state3 = this.state,
          selectValue = _this$state3.selectValue,
          focusedValue = _this$state3.focusedValue; // Only multiselects support value focusing

      if (!this.props.isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);

      if (!focusedValue) {
        focusedIndex = -1;
      }

      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;

      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }

          break;

        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }

          break;
      }

      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var focusedOption = this.state.focusedOption;
      var options = this.getFocusableOptions();
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'

      var focusedIndex = options.indexOf(focusedOption);

      if (!focusedOption) {
        focusedIndex = -1;
      }

      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }

      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
    }
  }, {
    key: "getTheme",
    value: // ==============================
    // Getters
    // ==============================
    function getTheme() {
      // Use the default theme if there are no customizations.
      if (!this.props.theme) {
        return defaultTheme;
      } // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.


      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      } // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.


      return _objectSpread2(_objectSpread2({}, defaultTheme), this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
          cx = this.cx,
          getStyles = this.getStyles,
          getValue = this.getValue,
          selectOption = this.selectOption,
          setValue = this.setValue,
          props = this.props;
      var isMulti = props.isMulti,
          isRtl = props.isRtl,
          options = props.options;
      var hasValue = this.hasValue();
      return {
        clearValue: clearValue,
        cx: cx,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        selectProps: props,
        setValue: setValue,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props7 = this.props,
          isClearable = _this$props7.isClearable,
          isMulti = _this$props7.isMulti; // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable

      if (isClearable === undefined) return isMulti;
      return isClearable;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled(option, selectValue) {
      return _isOptionDisabled(this.props, option, selectValue);
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      return _isOptionSelected(this.props, option, selectValue);
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return _filterOption(this.props, option, inputValue);
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var _inputValue = this.props.inputValue;
        var _selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: _inputValue,
          selectValue: _selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel(data) {
      return this.props.formatGroupLabel(data);
    } // ==============================
    // Mouse Handlers
    // ==============================

  }, {
    key: "startListeningComposition",
    value: // ==============================
    // Composition Handlers
    // ==============================
    function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    value: // ==============================
    // Touch Handlers
    // ==============================
    function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "renderInput",
    value: // ==============================
    // Renderers
    // ==============================
    function renderInput() {
      var _this$props8 = this.props,
          isDisabled = _this$props8.isDisabled,
          isSearchable = _this$props8.isSearchable,
          inputId = _this$props8.inputId,
          inputValue = _this$props8.inputValue,
          tabIndex = _this$props8.tabIndex,
          form = _this$props8.form,
          menuIsOpen = _this$props8.menuIsOpen;

      var _this$getComponents = this.getComponents(),
          Input = _this$getComponents.Input;

      var _this$state4 = this.state,
          inputIsHidden = _this$state4.inputIsHidden,
          ariaSelection = _this$state4.ariaSelection;
      var commonProps = this.commonProps;
      var id = inputId || this.getElementId('input'); // aria attributes makes the JSX "noisy", separated for clarity

      var ariaAttributes = _objectSpread2(_objectSpread2({
        'aria-autocomplete': 'list',
        'aria-expanded': menuIsOpen,
        'aria-haspopup': true,
        'aria-controls': this.getElementId('listbox'),
        'aria-owns': this.getElementId('listbox'),
        'aria-errormessage': this.props['aria-errormessage'],
        'aria-invalid': this.props['aria-invalid'],
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby'],
        role: 'combobox'
      }, !isSearchable && {
        'aria-readonly': true
      }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
        'aria-describedby': this.getElementId('live-region')
      } : {
        'aria-describedby': this.getElementId('placeholder')
      });

      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/React.createElement(DummyInput, _extends$b({
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop$2,
          onFocus: this.onInputFocus,
          disabled: isDisabled,
          tabIndex: tabIndex,
          inputMode: "none",
          form: form,
          value: ""
        }, ariaAttributes));
      }

      return /*#__PURE__*/React.createElement(Input, _extends$b({}, commonProps, {
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: "false",
        tabIndex: tabIndex,
        form: form,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this3 = this;

      var _this$getComponents2 = this.getComponents(),
          MultiValue = _this$getComponents2.MultiValue,
          MultiValueContainer = _this$getComponents2.MultiValueContainer,
          MultiValueLabel = _this$getComponents2.MultiValueLabel,
          MultiValueRemove = _this$getComponents2.MultiValueRemove,
          SingleValue = _this$getComponents2.SingleValue,
          Placeholder = _this$getComponents2.Placeholder;

      var commonProps = this.commonProps;
      var _this$props9 = this.props,
          controlShouldRenderValue = _this$props9.controlShouldRenderValue,
          isDisabled = _this$props9.isDisabled,
          isMulti = _this$props9.isMulti,
          inputValue = _this$props9.inputValue,
          placeholder = _this$props9.placeholder;
      var _this$state5 = this.state,
          selectValue = _this$state5.selectValue,
          focusedValue = _this$state5.focusedValue,
          isFocused = _this$state5.isFocused;

      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : /*#__PURE__*/React.createElement(Placeholder, _extends$b({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused,
          innerProps: {
            id: this.getElementId('placeholder')
          }
        }), placeholder);
      }

      if (isMulti) {
        return selectValue.map(function (opt, index) {
          var isOptionFocused = opt === focusedValue;
          var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
          return /*#__PURE__*/React.createElement(MultiValue, _extends$b({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isOptionFocused,
            isDisabled: isDisabled,
            key: key,
            index: index,
            removeProps: {
              onClick: function onClick() {
                return _this3.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this3.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
                e.stopPropagation();
              }
            },
            data: opt
          }), _this3.formatOptionLabel(opt, 'value'));
        });
      }

      if (inputValue) {
        return null;
      }

      var singleValue = selectValue[0];
      return /*#__PURE__*/React.createElement(SingleValue, _extends$b({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var _this$getComponents3 = this.getComponents(),
          ClearIndicator = _this$getComponents3.ClearIndicator;

      var commonProps = this.commonProps;
      var _this$props10 = this.props,
          isDisabled = _this$props10.isDisabled,
          isLoading = _this$props10.isLoading;
      var isFocused = this.state.isFocused;

      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }

      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React.createElement(ClearIndicator, _extends$b({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var _this$getComponents4 = this.getComponents(),
          LoadingIndicator = _this$getComponents4.LoadingIndicator;

      var commonProps = this.commonProps;
      var _this$props11 = this.props,
          isDisabled = _this$props11.isDisabled,
          isLoading = _this$props11.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React.createElement(LoadingIndicator, _extends$b({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$getComponents5 = this.getComponents(),
          DropdownIndicator = _this$getComponents5.DropdownIndicator,
          IndicatorSeparator = _this$getComponents5.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator


      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return /*#__PURE__*/React.createElement(IndicatorSeparator, _extends$b({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var _this$getComponents6 = this.getComponents(),
          DropdownIndicator = _this$getComponents6.DropdownIndicator;

      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return /*#__PURE__*/React.createElement(DropdownIndicator, _extends$b({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this4 = this;

      var _this$getComponents7 = this.getComponents(),
          Group = _this$getComponents7.Group,
          GroupHeading = _this$getComponents7.GroupHeading,
          Menu = _this$getComponents7.Menu,
          MenuList = _this$getComponents7.MenuList,
          MenuPortal = _this$getComponents7.MenuPortal,
          LoadingMessage = _this$getComponents7.LoadingMessage,
          NoOptionsMessage = _this$getComponents7.NoOptionsMessage,
          Option = _this$getComponents7.Option;

      var commonProps = this.commonProps;
      var focusedOption = this.state.focusedOption;
      var _this$props12 = this.props,
          captureMenuScroll = _this$props12.captureMenuScroll,
          inputValue = _this$props12.inputValue,
          isLoading = _this$props12.isLoading,
          loadingMessage = _this$props12.loadingMessage,
          minMenuHeight = _this$props12.minMenuHeight,
          maxMenuHeight = _this$props12.maxMenuHeight,
          menuIsOpen = _this$props12.menuIsOpen,
          menuPlacement = _this$props12.menuPlacement,
          menuPosition = _this$props12.menuPosition,
          menuPortalTarget = _this$props12.menuPortalTarget,
          menuShouldBlockScroll = _this$props12.menuShouldBlockScroll,
          menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView,
          noOptionsMessage = _this$props12.noOptionsMessage,
          onMenuScrollToTop = _this$props12.onMenuScrollToTop,
          onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
      if (!menuIsOpen) return null; // TODO: Internal Option Type here

      var render = function render(props, id) {
        var type = props.type,
            data = props.data,
            isDisabled = props.isDisabled,
            isSelected = props.isSelected,
            label = props.label,
            value = props.value;
        var isFocused = focusedOption === data;
        var onHover = isDisabled ? undefined : function () {
          return _this4.onOptionHover(data);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this4.selectOption(data);
        };
        var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
        var innerProps = {
          id: optionId,
          onClick: onSelect,
          onMouseMove: onHover,
          onMouseOver: onHover,
          tabIndex: -1
        };
        return /*#__PURE__*/React.createElement(Option, _extends$b({}, commonProps, {
          innerProps: innerProps,
          data: data,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: type,
          value: value,
          isFocused: isFocused,
          innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
        }), _this4.formatOptionLabel(props.data, 'menu'));
      };

      var menuUI;

      if (this.hasOptions()) {
        menuUI = this.getCategorizedOptions().map(function (item) {
          if (item.type === 'group') {
            var _data = item.data,
                options = item.options,
                groupIndex = item.index;
            var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
            var headingId = "".concat(groupId, "-heading");
            return /*#__PURE__*/React.createElement(Group, _extends$b({}, commonProps, {
              key: groupId,
              data: _data,
              options: options,
              Heading: GroupHeading,
              headingProps: {
                id: headingId,
                data: item.data
              },
              label: _this4.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option, "".concat(groupIndex, "-").concat(option.index));
            }));
          } else if (item.type === 'option') {
            return render(item, "".concat(item.index));
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = /*#__PURE__*/React.createElement(LoadingMessage, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });

        if (_message === null) return null;
        menuUI = /*#__PURE__*/React.createElement(NoOptionsMessage, commonProps, _message);
      }

      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = /*#__PURE__*/React.createElement(MenuPlacer, _extends$b({}, commonProps, menuPlacementProps), function (_ref4) {
        var ref = _ref4.ref,
            _ref4$placerProps = _ref4.placerProps,
            placement = _ref4$placerProps.placement,
            maxHeight = _ref4$placerProps.maxHeight;
        return /*#__PURE__*/React.createElement(Menu, _extends$b({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this4.onMenuMouseDown,
            onMouseMove: _this4.onMenuMouseMove,
            id: _this4.getElementId('listbox')
          },
          isLoading: isLoading,
          placement: placement
        }), /*#__PURE__*/React.createElement(ScrollManager, {
          captureEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom,
          lockEnabled: menuShouldBlockScroll
        }, function (scrollTargetRef) {
          return /*#__PURE__*/React.createElement(MenuList, _extends$b({}, commonProps, {
            innerRef: function innerRef(instance) {
              _this4.getMenuListRef(instance);

              scrollTargetRef(instance);
            },
            isLoading: isLoading,
            maxHeight: maxHeight,
            focusedOption: focusedOption
          }), menuUI);
        }));
      }); // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`

      return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/React.createElement(MenuPortal, _extends$b({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this5 = this;

      var _this$props13 = this.props,
          delimiter = _this$props13.delimiter,
          isDisabled = _this$props13.isDisabled,
          isMulti = _this$props13.isMulti,
          name = _this$props13.name;
      var selectValue = this.state.selectValue;
      if (!name || isDisabled) return;

      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this5.getOptionValue(opt);
          }).join(delimiter);
          return /*#__PURE__*/React.createElement("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return /*#__PURE__*/React.createElement("input", {
              key: "i-".concat(i),
              name: name,
              type: "hidden",
              value: _this5.getOptionValue(opt)
            });
          }) : /*#__PURE__*/React.createElement("input", {
            name: name,
            type: "hidden"
          });
          return /*#__PURE__*/React.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';

        return /*#__PURE__*/React.createElement("input", {
          name: name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      var commonProps = this.commonProps;
      var _this$state6 = this.state,
          ariaSelection = _this$state6.ariaSelection,
          focusedOption = _this$state6.focusedOption,
          focusedValue = _this$state6.focusedValue,
          isFocused = _this$state6.isFocused,
          selectValue = _this$state6.selectValue;
      var focusableOptions = this.getFocusableOptions();
      return /*#__PURE__*/React.createElement(LiveRegion, _extends$b({}, commonProps, {
        id: this.getElementId('live-region'),
        ariaSelection: ariaSelection,
        focusedOption: focusedOption,
        focusedValue: focusedValue,
        isFocused: isFocused,
        selectValue: selectValue,
        focusableOptions: focusableOptions
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$getComponents8 = this.getComponents(),
          Control = _this$getComponents8.Control,
          IndicatorsContainer = _this$getComponents8.IndicatorsContainer,
          SelectContainer = _this$getComponents8.SelectContainer,
          ValueContainer = _this$getComponents8.ValueContainer;

      var _this$props14 = this.props,
          className = _this$props14.className,
          id = _this$props14.id,
          isDisabled = _this$props14.isDisabled,
          menuIsOpen = _this$props14.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return /*#__PURE__*/React.createElement(SelectContainer, _extends$b({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), /*#__PURE__*/React.createElement(Control, _extends$b({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), /*#__PURE__*/React.createElement(ValueContainer, _extends$b({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/React.createElement(IndicatorsContainer, _extends$b({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps,
          clearFocusValueOnUpdate = state.clearFocusValueOnUpdate,
          inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate,
          ariaSelection = state.ariaSelection,
          isFocused = state.isFocused,
          prevWasFocused = state.prevWasFocused;
      var options = props.options,
          value = props.value,
          menuIsOpen = props.menuIsOpen,
          inputValue = props.inputValue,
          isMulti = props.isMulti;
      var selectValue = cleanValue(value);
      var newMenuOptionsState = {};

      if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
        var focusableOptions = menuIsOpen ? buildFocusableOptions(props, selectValue) : [];
        var focusedValue = clearFocusValueOnUpdate ? getNextFocusedValue(state, selectValue) : null;
        var focusedOption = getNextFocusedOption(state, focusableOptions);
        newMenuOptionsState = {
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedValue: focusedValue,
          clearFocusValueOnUpdate: false
        };
      } // some updates should toggle the state of the input visibility


      var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
        inputIsHidden: inputIsHiddenAfterUpdate,
        inputIsHiddenAfterUpdate: undefined
      } : {};
      var newAriaSelection = ariaSelection;
      var hasKeptFocus = isFocused && prevWasFocused;

      if (isFocused && !hasKeptFocus) {
        // If `value` or `defaultValue` props are not empty then announce them
        // when the Select is initially focused
        newAriaSelection = {
          value: valueTernary(isMulti, selectValue, selectValue[0] || null),
          options: selectValue,
          action: 'initial-input-focus'
        };
        hasKeptFocus = !prevWasFocused;
      } // If the 'initial-input-focus' action has been set already
      // then reset the ariaSelection to null


      if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') {
        newAriaSelection = null;
      }

      return _objectSpread2(_objectSpread2(_objectSpread2({}, newMenuOptionsState), newInputIsHiddenState), {}, {
        prevProps: props,
        ariaSelection: newAriaSelection,
        prevWasFocused: hasKeptFocus
      });
    }
  }]);

  return Select;
}(Component);

Select$1.defaultProps = defaultProps$Q;
var StateManagedSelect = /*#__PURE__*/forwardRef$1(function (props, ref) {
  var baseSelectProps = useStateManager(props);
  return /*#__PURE__*/React.createElement(Select$1, _extends$b({
    ref: ref
  }, baseSelectProps));
});
var Select = StateManagedSelect;
var _excluded$O = ["error", "styles"];

function ownKeys$1W(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1W(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1W(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1W(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function Dropdown$1(_ref) {
  var error = _ref.error,
      overrideStyles = _ref.styles,
      props = _objectWithoutProperties$8(_ref, _excluded$O);

  var theme = useTheme();

  var styles = _objectSpread$1W({
    control: function control(base, state) {
      var borderColor = theme.colors['neutral-200'];
      if (error) borderColor = theme.colors['destructive-400'];else if (state.isFocused) borderColor = theme.colors['primary-400'];
      return _objectSpread$1W(_objectSpread$1W({}, base), {}, {
        borderRadius: '0px',
        border: 'none',
        borderBottom: "1px solid ".concat(borderColor),
        borderColor: borderColor,
        backgroundColor: theme.colors.background,
        cursor: 'pointer',
        boxShadow: 'none',
        '&:hover': {
          borderColor: theme.colors['primary-400']
        },
        fontFamily: theme.fonts.body,
        fontSize: '14px'
      });
    },
    option: function option(base, state) {
      return _objectSpread$1W(_objectSpread$1W({}, base), {}, {
        cursor: 'pointer',
        backgroundColor: state.isFocused ? theme.colors['primary-50'] : theme.colors.background,
        color: theme.colors['neutral-700'],
        fontFamily: theme.fonts.body,
        fontWeight: theme.fontWeights.medium
      });
    },
    menu: function menu(base) {
      return _objectSpread$1W(_objectSpread$1W({}, base), {}, {
        zIndex: 1
      });
    },
    menuPortal: function menuPortal(base) {
      return _objectSpread$1W(_objectSpread$1W({}, base), {}, {
        zIndex: 1001
      });
    },
    singleValue: function singleValue(base) {
      return _objectSpread$1W(_objectSpread$1W({}, base), {}, {
        color: theme.colors['neutral-700'],
        fontWeight: theme.fontWeights.medium
      });
    },
    dropdownIndicator: function dropdownIndicator(base) {
      return _objectSpread$1W(_objectSpread$1W({}, base), {}, {
        color: theme.colors['neutral-800'],
        padding: '2px',
        '&:hover': {
          color: theme.colors['neutral-800']
        }
      });
    },
    indicatorSeparator: function indicatorSeparator() {
      return {
        display: 'none'
      };
    }
  }, overrideStyles);

  return /*#__PURE__*/jsx$1(Select, _objectSpread$1W(_objectSpread$1W({}, props), {}, {
    styles: styles,
    menuPortalTarget: document.body
  }));
}

var Input$3 = styled.input.attrs(function (_ref) {
  var type = _ref.type;
  return {
    type: type || 'text'
  };
}).withConfig({
  displayName: "input__Input",
  componentId: "sc-4en67k-0"
})(["background-color:", ";font-family:", ";&[type='number']::-webkit-outer-spin-button,&[type='number']::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}&[type='number']{-moz-appearance:textfield;appearance:textfield;}", " &:disabled{cursor:default;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.none;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.body;
}, commonStyles);
var Textarea = styled.textarea.withConfig({
  displayName: "textarea__Textarea",
  componentId: "sc-ldwu9z-0"
})(["background-color:", ";font-family:", ";transition:0.2s;&:focus-visible,&:focus-within{box-shadow:none;}&:disabled{cursor:default;resize:none;}", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.none;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fonts.body;
}, commonStyles);
var shine = keyframes$3(["0%{background-position:-200% 0;}100%{background-position:200% 0;}"]);
/** Skeleton Loader */

var Skeleton = styled.div.withConfig({
  displayName: "skeleton__Skeleton",
  componentId: "sc-19g0pzo-0"
})(["position:relative;background:linear-gradient( 90deg,", " 25%,", " 50%,", " 75% );background-size:200% 100%;animation:", " 1.5s infinite linear;height:100%;width:100%;border-radius:", ";", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.colors['neutral-100'];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors['neutral-200'];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors['neutral-100'];
}, shine, function (_ref4) {
  var theme = _ref4.theme;
  return theme.radii.base;
}, commonStyles);

function ownKeys$1V(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1V(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1V(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1V(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var pixify = function pixify(n) {
  return "".concat(n, "px");
};

var space$4 = [0, 4, 8, 16, 32, 64, 128, 256, 512].map(pixify);
var breakpoints = [600, 900, 1200].map(pixify);
var colors$o = {
  white: '#ffffff',
  black: '#000000',
  none: 'transparent',
  background: '#ffffff',
  card: '#ffffff',
  'primary-50': '#F7F6F9',
  'primary-200': '#CDC9DD',
  'primary-100': '#E6E4EE',
  'primary-300': '#B4AFCD',
  'primary-400': '#9B94BC',
  'primary-500': '#453E63',
  'primary-600': '#3F395B',
  'primary-700': '#37314E',
  'primary-800': '#2E2942',
  'primary-900': '#201C2D',
  'secondary-50': '#FFFAF2',
  'secondary-100': '#FFF6E6',
  'secondary-200': '#FFF1D9',
  'secondary-300': '#FFECCC',
  'secondary-400': '#FFE8C0',
  'secondary-500': '#FFE3B3',
  'secondary-600': '#FFDEA6',
  'secondary-700': '#FFD999',
  'secondary-800': '#FFD58D',
  'secondary-900': '#FFD080',
  'neutral-50': '#F9FAFB',
  'neutral-100': '#F3F4F6',
  'neutral-200': '#E5E7EB',
  'neutral-300': '#D1D5DB',
  'neutral-400': '#9CA3AF',
  'neutral-500': '#6B7280',
  'neutral-600': '#4B5563',
  'neutral-700': '#374151',
  'neutral-800': '#1F2937',
  'neutral-900': '#111827',
  'success-50': '#F0FDF4',
  'success-100': '#DCFCE7',
  'success-200': '#BBF7D0',
  'success-300': '#86EFAC',
  'success-400': '#4ADE80',
  'success-500': '#22C55E',
  'success-600': '#16A34A',
  'success-700': '#15803D',
  'success-800': '#166534',
  'success-900': '#14532D',
  'destructive-50': '#FEF2F2',
  'destructive-100': '#FEE2E2',
  'destructive-200': '#FECACA',
  'destructive-300': '#FCA5A5',
  'destructive-400': '#F87171',
  'destructive-500': '#EF4444',
  'destructive-600': '#DC2626',
  'destructive-700': '#B91C1C',
  'destructive-800': '#991B1B',
  'destructive-900': '#7F1D1D',
  'warning-50': '#FFFBEB',
  'warning-100': '#FEF3C7',
  'warning-200': '#FDE68A',
  'warning-300': '#FCD34D',
  'warning-400': '#FBBF24',
  'warning-500': '#F59E0B',
  'warning-600': '#D97706',
  'warning-700': '#B45309',
  'warning-800': '#92400E',
  'warning-900': '#78350F',
  'supporting-aqua': '#0BFFE6',
  'supporting-grapefruit': '#FE546F',
  'supporting-sunflower': '#FFD080',
  'supporting-strongCyan': '#36BFC6',
  'supporting-orangePeel': '#FF9D00',
  'supporting-haciendaBlue': '#00819E'
};
var darkColors = {
  white: '#ffffff',
  black: '#000000',
  background: '#101010',
  card: '#171717',
  'primary-50': '#171717',
  'primary-100': '#262626',
  'primary-200': '#404040',
  'primary-300': '#525252',
  'primary-400': '#737373',
  'primary-500': '#a3a3a3',
  'primary-600': '#d4d4d4',
  'primary-700': '#e5e5e5',
  'primary-800': '#f5f5f5',
  'primary-900': '#fafafa',

  /**
   * Secondary color is used to contrast with dark colors on light mode
   * In dark mode, here, dark colors are light, so we need the secondary
   * color to be dark for contrast to show.
   */
  'secondary-50': '#262626',
  'secondary-100': '#262626',
  'secondary-200': '#262626',
  'secondary-300': '#262626',
  'secondary-400': '#262626',
  'secondary-500': '#262626',
  'secondary-600': '#262626',
  'secondary-700': '#262626',
  'secondary-800': '#262626',
  'secondary-900': '#262626',
  'neutral-50': '#171717',
  'neutral-100': '#262626',
  'neutral-200': '#404040',
  'neutral-300': '#525252',
  'neutral-400': '#737373',
  'neutral-500': '#a3a3a3',
  'neutral-600': '#d4d4d4',
  'neutral-700': '#e5e5e5',
  'neutral-800': '#f5f5f5',
  'neutral-900': '#fafafa',
  'success-900': '#F0FDF4',
  'success-800': '#DCFCE7',
  'success-700': '#BBF7D0',
  'success-600': '#86EFAC',
  'success-500': '#4ADE80',
  'success-400': '#22C55E',
  'success-300': '#16A34A',
  'success-200': '#15803D',
  'success-100': '#166534',
  'success-50': '#14532D',
  'destructive-900': '#FEF2F2',
  'destructive-800': '#FEE2E2',
  'destructive-700': '#FECACA',
  'destructive-600': '#FCA5A5',
  'destructive-500': '#F87171',
  'destructive-400': '#EF4444',
  'destructive-300': '#DC2626',
  'destructive-200': '#B91C1C',
  'destructive-100': '#991B1B',
  'destructive-50': '#7F1D1D',
  'warning-900': '#FFFBEB',
  'warning-800': '#FEF3C7',
  'warning-700': '#FDE68A',
  'warning-600': '#FCD34D',
  'warning-500': '#FBBF24',
  'warning-400': '#F59E0B',
  'warning-300': '#D97706',
  'warning-200': '#B45309',
  'warning-100': '#92400E',
  'warning-50': '#78350F'
};
var internicColors = {
  'primary-50': '#F6F8FC',
  'primary-100': '#E0E5F7',
  'primary-200': '#C1C8EF',
  'primary-300': '#A2ABE5',
  'primary-400': '#808CDA',
  'primary-500': '#3440B3',
  'primary-600': '#2F3AA4',
  'primary-700': '#283290',
  'primary-800': '#222A7C',
  'primary-900': '#171D5A',
  'secondary-50': '#FCFCFC',
  'secondary-100': '#F9F9F9',
  'secondary-200': '#F4F4F4',
  'secondary-300': '#F0F0F0',
  'secondary-400': '#ECECEC',
  'secondary-500': '#F7F7F7',
  'secondary-600': '#E2E2E2',
  'secondary-700': '#D6D6D6',
  'secondary-800': '#C9C9C9',
  'secondary-900': '#BDBDBD'
};
var fonts$4 = {
  title: "'DM Sans', Inter, ivyjournal, sans-serif;",
  body: "Inter, Montserrat, 'work-sans', sans-serif;"
};
var internicFonts = {
  title: "Montserrat, sans-serif",
  body: "Montserrat, sans-serif"
};
var fontWeights = {
  light: 300,
  regular: 400,
  medium: 500,
  semi: 600,
  bold: 700,
  extraBold: 800
};
var media$4 = {
  smallAndDown: function smallAndDown() {
    return css$3(["@media only screen and (max-width:", "){", ";}"], breakpoints[0], css$3.apply(void 0, arguments));
  }
};
var radii$1 = {
  none: '0px',
  base: '8px',
  large: '24px',
  rounded: '999px',
  circle: '50%'
};
var THEME = {
  media: media$4,
  space: space$4,
  radii: radii$1,
  fonts: fonts$4,
  fontWeights: fontWeights,
  breakpoints: breakpoints
};

function getTheme(mode, isInternic) {
  var theme = _objectSpread$1V(_objectSpread$1V({
    mode: mode
  }, THEME), {}, {
    colors: _objectSpread$1V(_objectSpread$1V(_objectSpread$1V({}, colors$o), isInternic ? internicColors : {}), mode === 'dark' ? darkColors : {}),
    fonts: _objectSpread$1V(_objectSpread$1V({}, fonts$4), isInternic ? internicFonts : {})
  });

  return theme;
}

var THEME_KEY = 'color-theme-mode';
var ThemeContext = /*#__PURE__*/createContext(undefined);

var useThemeContext = function useThemeContext() {
  var ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useThemeContext must be used within VulcanThemeProvider');
  return ctx;
};

var GlobalStyle = createGlobalStyle(["html{font-size:62.5%;-webkit-font-smoothing:antialiased;}*,*::after,*::before{margin:0;padding:0;box-sizing:inherit;font-family:", ";}body{font-size:1.6rem;line-height:1.7;box-sizing:border-box;background:", ";color:", ";}a{text-decoration:none;}h1,h2,h3,h4,h5,h6{margin:0;padding:0;border:0;}label,input,textarea,select{background-color:transparent;color:inherit;font-family:", ";font-size:1.6rem;}option{color:initial;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fonts.body;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.background;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors['neutral-700'];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fonts.body;
});

var getPreferredTheme = function getPreferredTheme() {
  if (typeof window === 'undefined') return 'light';
  var stored = localStorage.getItem(THEME_KEY);
  if (stored === 'light' || stored === 'dark') return stored;
  return 'light';
};

function VulcanThemeProvider(_ref5) {
  var children = _ref5.children,
      _ref5$isInternic = _ref5.isInternic,
      isInternic = _ref5$isInternic === void 0 ? false : _ref5$isInternic;

  var _useState = useState(function () {
    return getPreferredTheme();
  }),
      _useState2 = _slicedToArray$4(_useState, 2),
      mode = _useState2[0],
      setMode = _useState2[1];

  useEffect(function () {
    localStorage.setItem(THEME_KEY, mode);
  }, [mode]);

  var toggle = function toggle() {
    return setMode(function (prev) {
      return prev === 'light' ? 'dark' : 'light';
    });
  };

  var theme = getTheme(mode, isInternic);
  return /*#__PURE__*/jsx$1(ThemeContext.Provider, {
    value: {
      mode: mode,
      toggle: toggle,
      setMode: setMode
    },
    children: /*#__PURE__*/jsxs(ThemeProvider, {
      theme: theme,
      children: [/*#__PURE__*/jsx$1("link", {
        rel: "stylesheet",
        href: "https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=DM+Sans:wght@300;400;500;600;700;800&family=Montserrat:wght@300;400;500;600;700;800&display=swap"
      }), /*#__PURE__*/jsx$1(GlobalStyle, {}), children]
    })
  });
}

var variants$1 = {
  hero: {
    fontSize: ['56px', '76px', '76px'],
    lineHeight: ['60px', '78px', '78px'],
    fontFamily: 'title',
    letterSpacing: '-1.3px'
  },
  'heading-h1': {
    fontSize: ['36px', '56px', '56px'],
    lineHeight: ['60px', '72px', '72px'],
    fontFamily: 'title',
    letterSpacing: ['-0.72px', '-1.12px', '-1.12px']
  },
  'heading-h2': {
    fontSize: ['32px', '40px', '40px'],
    lineHeight: ['44px', '52px', '52px'],
    fontFamily: 'body',
    letterSpacing: ['-0.64px', '-0.8px', '-0.8px']
  },
  'heading-h3': {
    fontSize: ['28px', '32px', '32px'],
    lineHeight: ['36px', '40px', '40px'],
    fontFamily: 'body',
    letterSpacing: ['-0.56px', '-0.64px', '-0.64px']
  },
  'heading-h4': {
    fontSize: ['24px', '28px', '28px'],
    lineHeight: ['32px', '36px', '36px'],
    fontFamily: 'body',
    letterSpacing: ['-0.48px', '-0.56px', '-0.56px']
  },
  'heading-h5': {
    fontSize: ['20px', '24px', '24px'],
    lineHeight: ['28px', '32px', '32px'],
    fontFamily: 'body',
    letterSpacing: ['-0.4px', '-0.48px', '-0.48px']
  },
  'heading-h6': {
    fontSize: ['18px', '20px', '20px'],
    lineHeight: ['24px', '28px', '28px'],
    fontFamily: 'body',
    letterSpacing: ['-0.36px', '-0.4px', '-0.4px']
  },
  'heading-h7': {
    fontSize: ['14px', '16px', '16px'],
    lineHeight: ['20px', '24px', '24px'],
    fontFamily: 'body',
    letterSpacing: ['-0.28px', '-0.32px', '-0.32px']
  },
  'paragraph-large': {
    fontSize: ['18px', '20px', '20px'],
    lineHeight: ['24px', '28px', '28px'],
    fontFamily: 'body'
  },
  'paragraph-medium': {
    fontSize: ['14px', '16px', '16px'],
    lineHeight: ['20px', '24px', '24px'],
    fontFamily: 'body'
  },
  'paragraph-small': {
    fontSize: ['12px', '14px', '14px'],
    lineHeight: ['24px', '28px', '28px'],
    fontFamily: 'body'
  },
  'paragraph-xsmall': {
    fontSize: ['10px', '12px', '12px'],
    lineHeight: ['16px', '18px', '18px'],
    fontFamily: 'body'
  }
};
var textVariants$1 = variant({
  prop: 'variant',
  variants: variants$1
});
var _excluded$N = ["variant", "color", "as", "opacity"];

function ownKeys$1U(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1U(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1U(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1U(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var variantToElement = {
  hero: 'h1',
  'heading-h1': 'h1',
  'heading-h2': 'h2',
  'heading-h3': 'h3',
  'heading-h4': 'h4',
  'heading-h5': 'h5',
  'heading-h6': 'h6',
  'heading-h7': 'h6'
};
var StyledText = styled.span.withConfig({
  displayName: "text__StyledText",
  componentId: "sc-sm4tq6-0"
})(["", " ", ""], textVariants$1, commonStyles);
/** We default to expected tag types based on variant */

function Text(props) {
  var _ref;

  var _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'paragraph-medium' : _props$variant,
      _props$color = props.color,
      color = _props$color === void 0 ? 'neutral-700' : _props$color,
      as = props.as,
      opacity = props.opacity,
      restProps = _objectWithoutProperties$8(props, _excluded$N);

  var element = (_ref = as !== null && as !== void 0 ? as : variantToElement[variant]) !== null && _ref !== void 0 ? _ref : 'span';

  var _useThemeContext = useThemeContext(),
      mode = _useThemeContext.mode;

  return /*#__PURE__*/jsx$1(StyledText, _objectSpread$1U({
    as: element,
    variant: variant,
    color: color,
    opacity: function () {
      // If the variant is a paragraph and the color is primary-600, we set the opacity to 0.8
      // This is to ensure that the primary text color is not too bold in paragraph contexts.
      // This only applies in dark mode.
      if (mode === 'dark' && props.color === 'primary-600' && (props.fontWeight === 'regular' || !props.fontWeight) && variant.startsWith('paragraph-')) {
        return 0.8;
      }

      return opacity;
    }()
  }, restProps));
}

var hasDOM = typeof window !== 'undefined';
var SCREEN_SIZES = {
  mobile: 'mobile',
  tablet: 'tablet',
  desktop: 'dektop'
};

var getScreenSize = function getScreenSize() {
  if (!hasDOM) {
    return null;
  }

  var width = window.innerWidth;

  if (width <= 520) {
    return SCREEN_SIZES.mobile;
  }

  if (width <= 820) {
    return SCREEN_SIZES.tablet;
  }

  return SCREEN_SIZES.desktop;
};

var getReturnUrl = function getReturnUrl() {
  if (!hasDOM) {
    return null;
  }

  var decoded = decodeURIComponent(window.location.search + window.location.hash);
  return _get(queryString.parse(decoded), 'ReturnUrl');
};
/** Hook to close on escape key */


function useEscapeKey(onClose) {
  useEffect(function () {
    var handleKeyDown = function handleKeyDown(e) {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return function () {
      return window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);
}

var slideIn$1 = keyframes$3(["from{opacity:0;transform:translateY(-20px);}to{opacity:1;transform:translateY(0);}"]);
var Backdrop = styled(Box).withConfig({
  displayName: "modal__Backdrop",
  componentId: "sc-xi2qmx-0"
})(["position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.5);display:flex;align-items:center;justify-content:center;z-index:999;opacity:", ";visibility:", ";transition:opacity 0.3s ease,visibility 0.3s ease;pointer-events:", ";"], function (_ref) {
  var $isOpen = _ref.$isOpen;
  return $isOpen ? 1 : 0;
}, function (_ref2) {
  var $isOpen = _ref2.$isOpen;
  return $isOpen ? 'visible' : 'hidden';
}, function (_ref3) {
  var $isOpen = _ref3.$isOpen;
  return $isOpen ? 'auto' : 'none';
});
var ModalContainer = styled(Stack$1).withConfig({
  displayName: "modal__ModalContainer",
  componentId: "sc-xi2qmx-1"
})(["position:relative;background:", ";border-radius:", ";padding:56px;max-width:90%;max-height:90%;overflow:auto;box-shadow:0px 10px 40px rgba(0,0,0,0.2);z-index:1000;opacity:", ";transform:translateY(", ");transition:opacity 0.3s ease,transform 0.3s ease;animation:", " 0.3s ease;border:1px solid ", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.background;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.radii.base;
}, function (_ref6) {
  var $isOpen = _ref6.$isOpen;
  return $isOpen ? 1 : 0;
}, function (_ref7) {
  var $isOpen = _ref7.$isOpen;
  return $isOpen ? '0' : '-20px';
}, slideIn$1, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors['neutral-200'];
});

function Modal(_ref9) {
  var title = _ref9.title,
      onBack = _ref9.onBack,
      isOpen = _ref9.isOpen,
      onClose = _ref9.onClose,
      children = _ref9.children;
  useEscapeKey(onClose);
  if (!hasDOM || !isOpen) return null;
  var modalContent = /*#__PURE__*/jsx$1(Backdrop, {
    "data-testid": "modal-backdrop",
    $isOpen: isOpen,
    onClick: onClose,
    children: /*#__PURE__*/jsxs(ModalContainer, {
      $isOpen: isOpen,
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      children: [onBack ? /*#__PURE__*/jsxs(Box, {
        color: "neutral-700",
        mb: 3,
        children: [/*#__PURE__*/jsxs(Button, {
          onClick: onBack,
          variant: "minimal",
          maxWidth: 140,
          px: "0",
          justifyContent: "left",
          children: [/*#__PURE__*/jsx$1(ArrowLeft, {}), /*#__PURE__*/jsx$1(Text, {
            children: "Back"
          })]
        }), title && /*#__PURE__*/jsx$1(Text, {
          variant: "heading-h5",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          ml: 4,
          width: "100%",
          children: title
        })]
      }) : /*#__PURE__*/jsxs(Box, {
        borderBottom: "1px solid",
        borderColor: "neutral-200",
        width: "100%",
        pb: "24px",
        mb: "24px",
        children: [title && /*#__PURE__*/jsx$1(Text, {
          variant: "heading-h5",
          fontWeight: "bold",
          color: "neutral-700",
          display: "flex",
          alignItems: "center",
          children: title
        }), /*#__PURE__*/jsxs(Button, {
          ml: "auto",
          variant: "minimal",
          onClick: onClose,
          alignItems: "center",
          "data-testid": "close-modal-button",
          children: [/*#__PURE__*/jsx$1(X, {}), /*#__PURE__*/jsx$1(Text, {
            children: "Close"
          })]
        })]
      }), children]
    })
  });
  return isOpen ? /*#__PURE__*/createPortal(modalContent, document.body) : null;
}

var _excluded$M = ["children", "trigger"];

function ownKeys$1T(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1T(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1T(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1T(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var fadeInSlideDown = keyframes$3(["from{opacity:0;transform:translateX(-50%) translateY(-10%);}to{opacity:1;transform:translateX(-50%) translateY(0%);}"]);
var fadeOutSlideUp = keyframes$3(["from{opacity:1;transform:translateX(-50%) translateY(0%);}to{opacity:0;transform:translateX(-50%) translateY(-10%);}"]);
var PopoverWrapper = styled.div.withConfig({
  displayName: "popover__PopoverWrapper",
  componentId: "sc-1dq7985-0"
})(["position:relative;display:inline-block;height:fit-content;width:fit-content;"]);
var PopoverContent = styled.div.withConfig({
  displayName: "popover__PopoverContent",
  componentId: "sc-1dq7985-1"
})(["position:absolute;top:100%;left:50%;transform:translateX(-50%);margin-top:10px;background-color:", ";box-shadow:0px 14px 64px -4px rgba(63,57,91,0.12),0px 8px 22px -6px rgba(63,57,91,0.12);border-radius:", ";padding:8px 16px;z-index:500;white-space:nowrap;", " & > div{width:100%;height:100%;position:relative;background:transparent;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.card;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.radii.base;
}, function (_ref3) {
  var isVisible = _ref3.isVisible;
  return isVisible ? css$3(["animation:", " 0.2s ease-in-out forwards;"], fadeInSlideDown) : css$3(["animation:", " 0.2s ease-in-out forwards;"], fadeOutSlideUp);
});

function Popover(_ref4) {
  var children = _ref4.children,
      trigger = _ref4.trigger,
      rest = _objectWithoutProperties$8(_ref4, _excluded$M);

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isVisible = _useState2[0],
      setIsVisible = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$4(_useState3, 2),
      shouldRender = _useState4[0],
      setShouldRender = _useState4[1];

  var popoverRef = useRef(null);
  var triggerRef = useRef(null);
  var hideWithDelay = useCallback(function () {
    setIsVisible(false);
    setTimeout(function () {
      return setShouldRender(false);
    }, 200); // Match animation duration
  }, []);

  var toggleVisibility = function toggleVisibility() {
    if (isVisible) {
      hideWithDelay();
    } else {
      setShouldRender(true);
      requestAnimationFrame(function () {
        return setIsVisible(true);
      });
    }
  };

  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (popoverRef.current && !popoverRef.current.contains(event.target) && triggerRef.current && !triggerRef.current.contains(event.target)) {
        hideWithDelay();
      }
    };

    var handleKeyDown = function handleKeyDown(event) {
      if (event.key === 'Escape') {
        hideWithDelay();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKeyDown);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [hideWithDelay]);
  return /*#__PURE__*/jsxs(PopoverWrapper, {
    className: "popover-container",
    children: [/*#__PURE__*/jsx$1(_StyledBox$s, {
      ref: triggerRef,
      "aria-controls": "popover-content",
      "aria-expanded": isVisible,
      "aria-haspopup": "true",
      className: "popover-trigger",
      onClick: toggleVisibility,
      $_css: isVisible ? 'rotate(180deg)' : 'rotate(0)',
      children: trigger
    }), shouldRender && /*#__PURE__*/jsx$1(PopoverContent, _objectSpread$1T(_objectSpread$1T({
      ref: popoverRef,
      "aria-modal": "true",
      className: "popover-content",
      id: "popover-content",
      isVisible: isVisible,
      role: "dialog"
    }, rest), {}, {
      children: /*#__PURE__*/jsx$1("div", {
        id: "relative-wrapper",
        children: children
      })
    }))]
  });
}

var _StyledBox$s = styled(Box).withConfig({
  displayName: "popover___StyledBox",
  componentId: "sc-1dq7985-2"
})([".chevron{transition:0.2s;transform:", ";}"], function (p) {
  return p.$_css;
});
/* eslint-disable no-plusplus */


var id = 0;
var listeners = [];

function toastHandler(type, message) {
  var text;

  if (axios.isAxiosError(message)) {
    var _ref, _message$response$dat, _message$response, _message$response$dat2, _message$response2, _message$response2$da;

    text = (_ref = (_message$response$dat = (_message$response = message.response) === null || _message$response === void 0 ? void 0 : (_message$response$dat2 = _message$response.data) === null || _message$response$dat2 === void 0 ? void 0 : _message$response$dat2.message) !== null && _message$response$dat !== void 0 ? _message$response$dat : (_message$response2 = message.response) === null || _message$response2 === void 0 ? void 0 : (_message$response2$da = _message$response2.data) === null || _message$response2$da === void 0 ? void 0 : _message$response2$da.Message) !== null && _ref !== void 0 ? _ref : 'Something went wrong. Please try again later.';
  } else if (message instanceof Error) {
    text = message.message;
  } else {
    text = message;
  }

  var toastMessage = {
    id: ++id,
    type: type,
    message: text
  };
  listeners.forEach(function (listener) {
    return listener(toastMessage);
  });
}

var toast = {
  info: function info(msg) {
    return toastHandler('info', msg);
  },
  warning: function warning(msg) {
    return toastHandler('warning', msg);
  },
  success: function success(msg) {
    return toastHandler('success', msg);
  },
  error: function error(msg) {
    return toastHandler('error', msg);
  }
};

function subscribe(fn) {
  listeners.push(fn);
  return function () {
    listeners = listeners.filter(function (l) {
      return l !== fn;
    });
  };
}

function ownKeys$1S(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1S(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1S(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1S(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var slideIn = keyframes$3(["from{transform:translateY(100%);opacity:0;}to{transform:translateY(0);opacity:1;}"]);
var slideOut = keyframes$3(["from{transform:translateY(0);opacity:1;}to{transform:translateY(100%);opacity:0;}"]);
var progressBar = keyframes$3(["from{width:100%;}to{width:0%;}"]);
var ToastContainer = styled.div.withConfig({
  displayName: "toast-provider__ToastContainer",
  componentId: "sc-j54l4o-0"
})(["position:fixed;bottom:20px;right:20px;z-index:1000;display:flex;flex-direction:column;gap:8px;max-width:420px;"]);
var ToastBox = styled.div.withConfig({
  displayName: "toast-provider__ToastBox",
  componentId: "sc-j54l4o-1"
})(["display:flex;align-items:flex-start;gap:12px;padding:16px;padding-bottom:12px;border-radius:12px;box-shadow:0 4px 12px rgba(0,0,0,0.15);backdrop-filter:blur(10px);border:1px solid rgba(255,255,255,0.1);font-weight:500;font-size:14px;line-height:1.4;animation:", " 0.3s ease-out forwards;position:relative;min-width:320px;overflow:hidden;", " ", " ", " ", " &::after{content:'';position:absolute;bottom:0;left:0;height:2px;background:rgba(255,255,255,0.8);animation:", " 3s linear forwards;}"], function (props) {
  return props.isExiting ? slideOut : slideIn;
}, function (props) {
  return props.type === 'success' && "\n    background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n    color: white;\n    border-color: rgba(16, 185, 129, 0.3);\n  ";
}, function (props) {
  return props.type === 'error' && "\n    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n    color: white;\n    border-color: rgba(239, 68, 68, 0.3);\n  ";
}, function (props) {
  return props.type === 'warning' && "\n    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n    color: white;\n    border-color: rgba(245, 158, 11, 0.3);\n  ";
}, function (props) {
  return props.type === 'info' && "\n    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n    color: white;\n    border-color: rgba(59, 130, 246, 0.3);\n  ";
}, progressBar);
var IconWrapper$1 = styled.div.withConfig({
  displayName: "toast-provider__IconWrapper",
  componentId: "sc-j54l4o-2"
})(["flex-shrink:0;margin-top:1px;"]);
var MessageWrapper = styled.div.withConfig({
  displayName: "toast-provider__MessageWrapper",
  componentId: "sc-j54l4o-3"
})(["flex:1;margin-right:8px;"]);
var CloseButton = styled.button.withConfig({
  displayName: "toast-provider__CloseButton",
  componentId: "sc-j54l4o-4"
})(["background:none;border:none;color:inherit;cursor:pointer;padding:2px;border-radius:4px;opacity:0.7;transition:opacity 0.2s ease;flex-shrink:0;&:hover{opacity:1;background:rgba(255,255,255,0.1);}&:focus{outline:2px solid rgba(255,255,255,0.3);outline-offset:1px;}"]);

var getToastIcon = function getToastIcon(type) {
  switch (type) {
    case 'success':
      return /*#__PURE__*/jsx$1(CircleCheckBig, {
        size: 20
      });

    case 'error':
      return /*#__PURE__*/jsx$1(CircleX, {
        size: 20
      });

    case 'warning':
      return /*#__PURE__*/jsx$1(CircleAlert, {
        size: 20
      });

    case 'info':
      return /*#__PURE__*/jsx$1(Info, {
        size: 20
      });

    default:
      return /*#__PURE__*/jsx$1(Info, {
        size: 20
      });
  }
};

function ToastProvider(_ref) {
  var children = _ref.children;

  var _useState = useState([]),
      _useState2 = _slicedToArray$4(_useState, 2),
      toasts = _useState2[0],
      setToasts = _useState2[1];

  var dismissToast = function dismissToast(toastId) {
    setToasts(function (prev) {
      return prev.map(function (t) {
        return t.id === toastId ? _objectSpread$1S(_objectSpread$1S({}, t), {}, {
          isExiting: true
        }) : t;
      });
    });
    setTimeout(function () {
      setToasts(function (prev) {
        return prev.filter(function (t) {
          return t.id !== toastId;
        });
      });
    }, 300);
  };

  useEffect(function () {
    var unsub = subscribe(function (toast) {
      setToasts(function (prev) {
        return [].concat(_toConsumableArray$1(prev), [toast]);
      }); // Auto-dismiss after 4 seconds

      setTimeout(function () {
        dismissToast(toast.id);
      }, 3000);
    });
    return unsub;
  }, []);
  if (!hasDOM) return null;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [children, /*#__PURE__*/createPortal( /*#__PURE__*/jsx$1(ToastContainer, {
      children: toasts.map(function (toast) {
        return /*#__PURE__*/jsxs(ToastBox, {
          type: toast.type,
          isExiting: toast.isExiting,
          children: [/*#__PURE__*/jsx$1(IconWrapper$1, {
            children: getToastIcon(toast.type)
          }), /*#__PURE__*/jsx$1(MessageWrapper, {
            children: toast.message
          }), /*#__PURE__*/jsx$1(CloseButton, {
            onClick: function onClick() {
              return dismissToast(toast.id);
            },
            "aria-label": "Dismiss notification",
            children: /*#__PURE__*/jsx$1(X, {
              size: 16
            })
          })]
        }, toast.id);
      })
    }), document.body)]
  });
}

var _templateObject$D;

function Uploader(_ref) {
  var onFileUpload = _ref.onFileUpload;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isDropping = _useState2[0],
      setIsDropping = _useState2[1];

  var handleDrop = function handleDrop(event) {
    event.preventDefault();
    setIsDropping(false);
    var files = event.dataTransfer.files;

    if (files.length > 0) {
      onFileUpload(files[0]);
    }
  };

  var handleDragOver = function handleDragOver(event) {
    event.preventDefault();
    setIsDropping(true);
  };

  var handleDragLeave = function handleDragLeave() {
    setIsDropping(false);
  };

  var handleChange = function handleChange(event) {
    var _event$target$files;

    var file = (_event$target$files = event.target.files) === null || _event$target$files === void 0 ? void 0 : _event$target$files[0];

    if (file) {
      onFileUpload(file);
    }
  };

  return /*#__PURE__*/jsxs(_StyledStack$m, {
    minHeight: "300px",
    color: "primary-700",
    justifyContent: "center",
    alignItems: "center",
    onDragOver: handleDragOver,
    onDragLeave: handleDragLeave,
    onDrop: handleDrop,
    gap: 3,
    onClick: function onClick() {
      var _document$getElementB;

      (_document$getElementB = document.getElementById('input-box-bulk-search-drop')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.click();
    },
    children: [/*#__PURE__*/jsx$1(Text, {
      variant: "paragraph-large",
      color: "primary-600",
      mb: 2,
      children: "Or upload your .txt or .csv file of domain names"
    }), /*#__PURE__*/jsx$1(Input$3, {
      id: "input-box-bulk-search-drop",
      type: "file",
      accept: ".csv, .txt",
      onChange: handleChange,
      display: "none"
    }), /*#__PURE__*/jsxs(_StyledStack2$5, {
      flex: 1,
      borderRadius: "base",
      border: "1px dashed",
      borderColor: "neutral-400",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      $_css: isDropping ? function (_ref2) {
        var theme = _ref2.theme;
        return theme.colors['neutral-100'];
      } : 'transparent',
      children: [/*#__PURE__*/jsxs(Box, {
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        children: [/*#__PURE__*/jsx$1(FileUp, {
          size: 48,
          strokeWidth: 2
        }), /*#__PURE__*/jsx$1(Text, {
          fontWeight: "semi",
          children: "Import File"
        })]
      }), /*#__PURE__*/jsx$1(Text, {
        mt: 2,
        fontWeight: "medium",
        children: "Or drag and drop file here"
      })]
    })]
  });
}

var _StyledStack$m = styled(Stack$1)(_templateObject$D || (_templateObject$D = _taggedTemplateLiteral$1(["\n        transition: 0.2s;\n      "])));

var _StyledStack2$5 = styled(Stack$1).withConfig({
  displayName: "uploader___StyledStack2",
  componentId: "sc-1bgkj0k-0"
})(["cursor:pointer;transition:0.2s;background:", ";&:hover{background:", ";}"], function (p) {
  return p.$_css;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors['neutral-100'];
});

function useDocumentTitle(title) {
  useEffect(function () {
    if (hasDOM && title) {
      document.title = title;
    }
  }, [title]);
  return null;
}

var authStrings = {
  accountHeader: 'Step 1: Your account',
  backTo6Digit: 'I have my 6-digit code',
  byCreatingAccount: 'By creating an account you agree to the',
  cancel: 'Cancel',
  cancelBtnTitle: 'Back to login view',
  createAccountHeader: 'Create Account',
  createBtn: 'Create account',
  createBtnTitle: 'Create an account',
  default6DigitCodeErrorMsg: 'You have entered an invalid code, please re-enter code',
  defaultForgotPassErrorMsg: 'Reset password failed. Please try again',
  defaultLoginErrorMsg: 'Login failed. Please try again',
  defaultLogoutErrorMsg: 'Logout failed. Please try again',
  defaultRecoveryCodeErrorMsg: 'Recovery code creation failed. Please try again.',
  defaultSignupErrorMsg: 'Account creation failed. Please try again',
  doneRecovery: 'Got it, thanks',
  email: 'Email',
  emailInvalid: 'Email is invalid',
  emailRequired: 'Email is required',
  enter6DigitCode: 'Enter your 6-digit code',
  enter6DigitCodeApp: 'You have chosen to use an authentication app to log-in to your account. Please enter your 6 digit app code below',
  enter6DigitCodeEmail: 'We sent an email to $$EMAIL$$ with a verification code. Please enter it below',
  enter6DigitCodePhone: 'We sent a text to $$PHONE$$ with a verification code. Please enter it below',
  enterRecoveryCode: 'Enter your recovery code',
  existingAccount: 'Already have an account?',
  firstName: 'First Name',
  firstNameRequired: 'First name is required',
  forgotLabel: 'Email or username',
  forgotMessageHelper: 'Please enter your username or email address to search for your account',
  forgotPassword: 'Forgot your password?',
  getStarted: 'Get started',
  getStartedTitle: 'Sign up',
  invalidUserNameErrorMsg: 'Invalid email or username',
  loginBtn: 'Log in',
  loginHeader: 'Sign in to your Account',
  logoutBtn: 'Log out',
  messageSent: 'Please check your email for a message with a link to reset your password',
  needToUserRecoveryCode: 'I want to use my recovery code',
  newRecoveryCode: 'Remember to save this new recovery code',
  noAccount: "Don't have an account?",
  noCode: "Haven't received your code? Check out your other contact options",
  orUseLegacyApp: 'Or use legacy application system',
  password: 'Password',
  passwordLength8: 'Password must be at least 8 characters long',
  passwordRequired: 'Password is required',
  passwordStrength: 'Password must contain a lowercase,\nan uppercase, a number, and a symbol',
  phone: 'Text',
  pickContactMethod: "We couldn't reach you at $$METHOD$$, below are alternative contact options on your account",
  pickContactMethodError: 'An error occurred selecting that method',
  privacyPolicy: 'Privacy Policy',
  send: 'Send',
  sendBtnTitle: 'Submit account info',
  showPassword: 'Show password',
  signIn: 'Sign in',
  submitCode: 'Submit Code',
  termsConditions: 'Terms and Conditions',
  termsOfService: 'Terms of Service',
  twoFactorCodeHeading: 'Two Factor Authentication',
  twoFactorNotice: "$$RESELLER$$ now offers two-factor authentication (often shortened to 2FA) to help our customers elevate their account security.",
  twoFactorSubNotice: "In today\u2019s digital world,  cyber threats are constantly evolving. At $$RESELLER$$ we prioritize keeping your account safe. Logging in using 2FA is easy and will provide you peace of mind. If you\u2019re curious about its advantages, ",
  username: 'Username',
  usernameRequired: 'Username is required',
  userOrEmailRequired: 'Username or email is required'
};
var allSupportStrings = {
  rebel: {
    phone: '1-844-548-2157',
    email: 'service@rebel.com',
    abuse: 'abuse@rebel.com'
  },
  internic: {
    phone: '1-866-642-1232',
    email: 'service@internic.ca',
    abuse: 'abuse@internic.ca'
  }
};
var OrderStrings = {
  purchaseFlow: {
    continueShopping: 'Continue shopping',
    havingTrouble: 'Having trouble with our beta order page?',
    goToOldCart: 'Head over to the old experience to complete your purchase',
    oldCart: 'Go to old cart',
    goHome: 'Back to the homepage',
    processButtonText: 'Process order',
    errorProcessing: 'An error occurred during processing. Please try again or call support.',
    userInfo: {
      tld: {
        ca: {
          header: '.CA Information',
          note: 'Contacts associated to .CA domains require additional information.',
          faqLink: 'Learn more',
          terms: 'Terms and conditions of the CIRA Registrant Agreement',
          company: 'Company',
          companyReq: 'Company name is required',
          invalidCompanyName: 'Company name is invalid',
          companyReqPrefix: '*Click ',
          companyReqLink: 'here',
          companyReqSuffix: ' for the complete Company requirement information.',
          companyReqLinkTitle: 'Company Requirements',
          privateInfo: 'Make my info private'
        }
      }
    },
    helpSection: {
      heading: 'Need Help? We have award winning support',
      topRated: "We're a Top Rated Web Host",
      liveChat: 'Live Chat ',
      officeHours: '(8am-10pm EST daily)',
      chatTitle: 'Chat Support',
      phoneTitle: 'Phone Support',
      emailTitle: 'Email Support'
    }
  }
};
var currencyStrings = {
  title: 'Select your currency'
};
var paymentStrings = {
  paymentHeader: 'Billing Information',
  ccNumber: 'Credit card number',
  ccName: 'Name on card',
  numRequired: 'Credit card number is required',
  ccNameRequired: 'Name on card is required',
  ccNameLength: 'Maximum length is 255',
  ccAliasLength: 'Maximum length is 50',
  expireRequired: 'Expiration date is required',
  cvvRequired: 'CVV is required',
  ccExpiration: 'Exp. MM / YY',
  cvv: 'CVV/CVC',
  expiry: 'exp',
  end: 'ending in',
  ccBlurb: 'secured payments',
  billingTitle: 'Use contact address for billing address',
  billingSummary: 'Your billing address must match the address on your card',
  summaryPaymentType: 'Payment type',
  summaryBillingAddress: 'Billing address',
  summaryAccountEmail: 'Email',
  editBilling: 'Edit billing information',
  err_monthyear: 'Expiration date is required',
  err_month: 'Expiration month is past date',
  err_year: 'Expiration year is past date',
  err_pastdate: 'Enter a valid card expiration date',
  selectCreditCard: 'Select a card',
  myCards: 'My Cards',
  addCreditCard: 'Add a new card',
  useExistingCC: 'Use existing credit card',
  alias: 'Alias (optional)',
  defaultCardOption: 'Make this my default card',
  cardNameLength: 'Card name should be shorter than 30 characters',
  endingIn: 'Ending in ',
  expiryDateInvalid: 'Expiration date is not correct',
  cvvInvalid: 'CVV is not correct'
};
var INTERNIC = 'internic.ca';
var REBELCOM = 'rebel.com';
var REBELCA = 'rebel.ca';

var getResellerFromHost = function getResellerFromHost() {
  if (hasDOM) {
    var host = window.location.hostname;

    if (host.includes('internic')) {
      return INTERNIC;
    }

    if (host.includes('.ca')) {
      return REBELCA;
    }
  }

  return REBELCOM;
};

var RESELLER = process.env.GATSBY_RESELLER || getResellerFromHost();

var GET_RESELLER_ID = function GET_RESELLER_ID() {
  switch (RESELLER) {
    case 'internic.ca':
      return 4;

    case 'rebel.ca':
      return 3;

    default:
      return 2;
  }
};

var RESELLER_ID = GET_RESELLER_ID();
var isRebel = RESELLER === 'rebel.ca' || RESELLER === 'rebel.com';
var isRebelCA = RESELLER === 'rebel.ca';
var isRebelCOM = RESELLER === 'rebel.com';
var isInternic = RESELLER === 'internic.ca';
var resellerName = RESELLER.charAt(0).toUpperCase() + RESELLER.slice(1);
var resellerTitle = resellerName.split('.')[0];
var rebelSupport = allSupportStrings.rebel,
    internicSupport = allSupportStrings.internic;
var SUPPORT_STRINGS = isInternic ? internicSupport : rebelSupport;

var getServerResellerMapping = function getServerResellerMapping() {
  if (isInternic) {
    return 'Internic';
  }

  if (isRebelCA) {
    return 'DAC';
  }

  return 'Rebel';
};

var SERVER_RESELLER = getServerResellerMapping();
var socialLinksRebel = [{
  icon: 'twitter',
  href: 'https://twitter.com/rebeldotcom',
  title: "Rebel's Twitter account",
  ml: '-0.9rem'
}, {
  icon: 'facebook',
  href: 'https://www.facebook.com/rebeldotcomhosting/',
  title: "Rebel's Facebook account"
}, {
  icon: 'instagram',
  href: 'https://instagram.com/rebeldotcom/',
  title: "Rebel's Instagram account",
  ml: '-0.9rem'
}, {
  icon: 'youtube',
  href: 'https://www.youtube.com/channel/UCn8PAsNxo2zC8Ka53Feg_-Q',
  title: "Rebel's YouTube account"
}, {
  icon: 'linkedin',
  href: 'https://ca.linkedin.com/company/rebel-com',
  title: "Rebel's LinkedIn account"
}];
var socialLinksInternic = [{
  icon: 'twitter',
  href: 'https://twitter.com/internicdotca',
  title: "Internic Twitter"
}, {
  icon: 'facebook',
  href: 'https://www.facebook.com/Internic.ca',
  title: "Internic Facebook"
}];
var socialLinks = isRebel ? socialLinksRebel : socialLinksInternic;

function getHost() {
  var host = 'dev.rebel.com';

  if (hasDOM) {
    var hostname = window.location.hostname;

    if (__PROD__) {
      // Handle CI
      host = hostname === 'localhost' ? 'www.rebel.com' : window.location.hostname;
    } else if (__DEV__) {
      host = "dev.".concat(RESELLER);
    } else if (__LOCAL__) {
      host = "local.".concat(RESELLER);
    }
  }

  return host;
}

var host$2 = getHost();
var resellerApiSite = isInternic ? 'internic.ca' : 'rebel.com';

var createEndpoint = function createEndpoint(endpoint) {
  return "https://".concat(host$2).concat(endpoint);
};

var createEndpoints = function createEndpoints(arr, path) {
  return arr.reduce(function (acc, el) {
    acc[el] = createEndpoint("".concat(path, "/").concat(el));
    return acc;
  }, {});
};

var SKYWALKER_ENDPOINTS = {
  openExchange: 'open-exchange/',
  domains: 'domains/',
  log: 'log/'
};

var buildSkywalkerEndpoint = function buildSkywalkerEndpoint(endpoint) {
  var endpointProd = {
    path: "https://api.".concat(resellerApiSite, "/").concat(endpoint)
  };
  var endpointDev = {
    path: "https://dev.api.".concat(resellerApiSite, "/").concat(endpoint)
  };
  var endpointLocal = {
    path: "http://localhost:3001/".concat(endpoint)
  };

  var _ref = // eslint-disable-next-line no-undef
  __LOCAL__ && endpointLocal || __DEV__ && endpointDev || __PROD__ && endpointProd,
      path = _ref.path;

  return path;
};

var getUserSunshineJWTEndpoint = function getUserSunshineJWTEndpoint() {
  var endpoint = "api/user/sunshine/jwt";
  var userSunshineEndpointProd = {
    path: "https://www.".concat(resellerApiSite, "/").concat(endpoint)
  };
  var userSunshineEndpointDev = {
    path: "https://dev.".concat(resellerApiSite, "/").concat(endpoint)
  };
  var userSunshineEndpointLocal = {
    path: "https://local.".concat(resellerApiSite, "/").concat(endpoint)
  };

  var _ref2 = // eslint-disable-next-line no-undef
  __LOCAL__ && userSunshineEndpointLocal || __DEV__ && userSunshineEndpointDev || __PROD__ && userSunshineEndpointProd,
      path = _ref2.path;

  return path;
};

var getOXaccounts = function getOXaccounts() {
  return createEndpoint('/api/openexchange');
};

var getOXAddToCart = function getOXAddToCart() {
  return createEndpoint('/api/openexchange/add-to-cart');
};

var getPrivacyProtectionEndpoint = function getPrivacyProtectionEndpoint() {
  var privacyProtectionEndpointProd = {
    privacyProtectionEndpoint: "https://www.".concat(RESELLER, "/api/domains/privacyprotection")
  };
  var privacyProtectionEndpointDev = {
    privacyProtectionEndpoint: "https://dev.".concat(RESELLER, "/api/domains/privacyprotection")
  };
  var privacyProtectionEndpointLocal = {
    privacyProtectionEndpoint: "http://local.".concat(RESELLER, "/api/domains/privacyprotection")
  };

  var _ref3 = // eslint-disable-next-line no-undef
  __LOCAL__ && privacyProtectionEndpointLocal || __DEV__ && privacyProtectionEndpointDev || __PROD__ && privacyProtectionEndpointProd,
      privacyProtectionEndpoint = _ref3.privacyProtectionEndpoint;

  return privacyProtectionEndpoint;
};

var getExpiryProtectionEndpoint = function getExpiryProtectionEndpoint() {
  var expiryProtectionEndpointProd = {
    expiryProtectionEndpoint: "https://www.".concat(RESELLER, "/api/domains/expiryprotection")
  };
  var expiryProtectionEndpointDev = {
    expiryProtectionEndpoint: "https://dev.".concat(RESELLER, "/api/domains/expiryprotection")
  };
  var expiryProtectionEndpointLocal = {
    expiryProtectionEndpoint: "http://local.".concat(RESELLER, "/api/domains/expiryprotection")
  };

  var _ref4 = // eslint-disable-next-line no-undef
  __LOCAL__ && expiryProtectionEndpointLocal || __DEV__ && expiryProtectionEndpointDev || __PROD__ && expiryProtectionEndpointProd,
      expiryProtectionEndpoint = _ref4.expiryProtectionEndpoint;

  return expiryProtectionEndpoint;
};

var getOwnershipProtectionEndpoint = function getOwnershipProtectionEndpoint() {
  var ownershipProtectionEndpointProd = {
    ownershipProtectionEndpoint: "https://www.".concat(RESELLER, "/api/domains/ownershipprotection")
  };
  var ownershipProtectionEndpointDev = {
    ownershipProtectionEndpoint: "https://dev.".concat(RESELLER, "/api/domains/ownershipprotection")
  };
  var ownershipProtectionEndpointLocal = {
    ownershipProtectionEndpoint: "http://local.".concat(RESELLER, "/api/domains/ownershipprotection")
  };

  var _ref5 = // eslint-disable-next-line no-undef
  __LOCAL__ && ownershipProtectionEndpointLocal || __DEV__ && ownershipProtectionEndpointDev || __PROD__ && ownershipProtectionEndpointProd,
      ownershipProtectionEndpoint = _ref5.ownershipProtectionEndpoint;

  return ownershipProtectionEndpoint;
};

var getMarketgooLoginEndpoint = function getMarketgooLoginEndpoint(domainId) {
  var marketgooLoginEndpointProd = {
    marketgooLoginEndpoint: "https://www.rebel.com/api/domains/".concat(domainId, "/marketgoologin")
  };
  var marketgooLoginEndpointDev = {
    marketgooLoginEndpoint: "https://dev.rebel.com/api/domains/".concat(domainId, "/marketgoologin")
  };
  var marketgooLoginEndpointLocal = {
    marketgooLoginEndpoint: "http://local.rebel.com/api/domains/".concat(domainId, "/marketgoologin")
  };

  var _ref6 = // eslint-disable-next-line no-undef
  __LOCAL__ && marketgooLoginEndpointLocal || __DEV__ && marketgooLoginEndpointDev || __PROD__ && marketgooLoginEndpointProd,
      marketgooLoginEndpoint = _ref6.marketgooLoginEndpoint;

  return marketgooLoginEndpoint;
};

var getDomainRecoveryEndpoint = function getDomainRecoveryEndpoint(domainId) {
  return createEndpoint("/api/domains/".concat(domainId, "/recover"));
};

var getDynamicPriceEndpoint = function getDynamicPriceEndpoint(itemcodes) {
  var dynamicePriceEndpointProd = {
    dynamicePriceEndpoint: "https://api.".concat(resellerApiSite, "/price/static/itemcodes?itemcodes=").concat(itemcodes)
  };
  var dynamicePriceEndpointDev = {
    dynamicePriceEndpoint: "https://dev.api.".concat(resellerApiSite, "/price/static/itemcodes?itemcodes=").concat(itemcodes)
  };
  var dynamicePriceEndpointLocal = {
    dynamicePriceEndpoint: "http://localhost:3001/price/static/itemcodes?itemcodes=".concat(itemcodes)
  };

  var _ref7 = // eslint-disable-next-line no-undef
  __LOCAL__ && dynamicePriceEndpointLocal || __DEV__ && dynamicePriceEndpointDev || __PROD__ && dynamicePriceEndpointProd,
      dynamicePriceEndpoint = _ref7.dynamicePriceEndpoint;

  return dynamicePriceEndpoint;
}; // ========= USER =========


var user$1 = ['creditcard', 'info', 'social', 'logout', 'auth', 'create', 'comredirecturl', 'sso', 'currency', 'setcontact', 'token', 'current']; // creates //${host}/api/user/${userEndpoint}

var userEndpoints = createEndpoints(user$1, '/api/user');
userEndpoints.passwordReset = createEndpoint('/api/password/reset');
userEndpoints.passwordSet = createEndpoint('/api/password/set');
userEndpoints.activationValidate = createEndpoint('/api/activation/validate');
userEndpoints.userAccessToken = createEndpoint("/api/user/token");
userEndpoints.error = createEndpoint('/api/user/error-logger');
userEndpoints.defaultContact = createEndpoint('/api/user/defaultcontact'); // ========= CREDIT CARD =========

var creditCardEndpoints = {};
creditCardEndpoints.card = createEndpoint('/api/creditcard');
creditCardEndpoints["default"] = createEndpoint('/api/creditcard/default');
creditCardEndpoints.backup = createEndpoint('/api/creditcard/backup'); // ========= QUICK RENEW ========

var quickRenewEndpoints = {};

quickRenewEndpoints.summary = function (domainName) {
  return createEndpoint("/api/chargebee/quick-renew/".concat(domainName, "/summary"));
};

quickRenewEndpoints.process = function (domainName, chargebeeToken) {
  return createEndpoint("/api/chargebee/quick-renew/".concat(domainName, "/process/").concat(chargebeeToken));
}; // ========= CONTACT ==============


var contactEndpoints = {};
contactEndpoints.contact = createEndpoint('/api/contacts');
contactEndpoints.deleteById = createEndpoint('/api/deletecontacts');
contactEndpoints.primaryContact = createEndpoint('/api/user/setcontact');

var getTLDOptionsEndpoint = function getTLDOptionsEndpoint() {
  return createEndpoint('/api/options/extrainfo');
};

var addInfoRequiredProd = {
  addInfoRequiredEndpoint: "https://www.".concat(RESELLER, "/api/domaintransfer/DoDomainsRequireAdditionalInfo")
};
var addInfoRequiredDev = {
  addInfoRequiredEndpoint: "https://dev.".concat(RESELLER, "/api/domaintransfer/DoDomainsRequireAdditionalInfo")
};
var addInfoRequiredLocal = {
  addInfoRequiredEndpoint: "https://local.".concat(RESELLER, "/api/domaintransfer/DoDomainsRequireAdditionalInfo")
};

var _ref8 = // eslint-disable-next-line no-undef
__LOCAL__ && addInfoRequiredLocal || __DEV__ && addInfoRequiredDev || __PROD__ && addInfoRequiredProd,
    addInfoRequiredEndpoint = _ref8.addInfoRequiredEndpoint; // ========= EMAIL SIGNUP =========


var marketingEndpoint = __DEV__ || __LOCAL__ ? "https://dev.api.rebel.com" : 'https://api.mktg.rebel.com';
var emailSignup = __DEV__ ? "".concat(marketingEndpoint, "/automation/email/sign-up") : "".concat(marketingEndpoint, "/automation/email/sign-up");
var mfaEndpointProd = {
  mfaEndpoint: "https://api.rebel.com/2fa"
};
var mfaEndpointDev = {
  mfaEndpoint: "https://dev.api.rebel.com/2fa"
};
var mfaEndpointLocal = {
  mfaEndpoint: "http://localhost:3001/2fa"
};

var _ref9 = // eslint-disable-next-line no-undef
__LOCAL__ && mfaEndpointLocal || __DEV__ && mfaEndpointDev || __PROD__ && mfaEndpointProd,
    mfaEndpoint = _ref9.mfaEndpoint;

var addBulkMarketgooEndpoint = createEndpoint('/api/order/add-bulk-marketgoo');
var addBulkSecurityEndpoint = createEndpoint('/api/order/add-bulk-security');
var removeBulkSecurityEndpoint = createEndpoint('/api/order/remove-bulk-security');
var bulkSecurityEndpoints = {
  add: addBulkSecurityEndpoint,
  remove: removeBulkSecurityEndpoint
};
var supportRequestEndpoint = "".concat(marketingEndpoint, "/web-form/order-support-request");
var notificationProd = {
  notificationEndpoint: "https://api.rebel.com/notification"
};
var notificationDev = {
  notificationEndpoint: "https://dev.api.rebel.com/notification"
};
var notificationLocal = {
  notificationEndpoint: "http://localhost:3002/notification"
};

var _ref0 = // eslint-disable-next-line no-undef
__LOCAL__ && notificationLocal || __DEV__ && notificationDev || __PROD__ && notificationProd,
    notificationEndpoint = _ref0.notificationEndpoint;

var googleWorkspaceProd = {
  googleWorkspaceEndpoint: "https://api.rebel.com/google-workspace"
};
var googleWorkspaceDev = {
  googleWorkspaceEndpoint: "https://dev.api.rebel.com/google-workspace"
};
var googleWorkspaceLocal = {
  googleWorkspaceEndpoint: "http://localhost:3001/google-workspace"
};

var _ref1 = // eslint-disable-next-line no-undef
__LOCAL__ && googleWorkspaceLocal || __DEV__ && googleWorkspaceDev || __PROD__ && googleWorkspaceProd,
    googleWorkspaceEndpoint = _ref1.googleWorkspaceEndpoint; // ========= Prices endpoint  =========


var pricesEndpoint$1 = createEndpoint('/api/price/static/all');
var pricesTLDsProd = {
  pricesTLDsEndpoint: "https://api.".concat(resellerApiSite, "/price/tlds/").concat(resellerApiSite)
};
var pricesTLDsDev = {
  pricesTLDsEndpoint: "https://dev.api.".concat(resellerApiSite, "/price/tlds/").concat(resellerApiSite)
};
var pricesTLDsLocal = {
  pricesTLDsEndpoint: "http://localhost:3001/price/tlds/".concat(resellerApiSite)
};

var _ref10 = // eslint-disable-next-line no-undef
__LOCAL__ && pricesTLDsLocal || __DEV__ && pricesTLDsDev || __PROD__ && pricesTLDsProd;

_ref10.pricesTLDsEndpoint;
var pricesAddonsProd = {
  pricesAddonsEndpoint: "https://api.".concat(resellerApiSite, "/price/items/").concat(resellerApiSite)
};
var pricesAddonsDev = {
  pricesAddonsEndpoint: "https://dev.api.".concat(resellerApiSite, "/price/items/").concat(resellerApiSite)
};
var pricesAddonsLocal = {
  pricesAddonsEndpoint: "https://dev.api.".concat(resellerApiSite, "/price/items/").concat(resellerApiSite)
};

var _ref11 = // eslint-disable-next-line no-undef
__LOCAL__ && pricesAddonsLocal || __DEV__ && pricesAddonsDev || __PROD__ && pricesAddonsProd,
    pricesAddonsEndpoint = _ref11.pricesAddonsEndpoint; // ========= ORDER =========


var order$2 = ['count']; // creates //${host}/api/order/${orderEndpoint}

var orderEndpoints = createEndpoints(order$2, '/api/order');
var localOrderEndpoint = 'http://localhost:4000/order';
var devOrderEndpoint = "https://dev.api.".concat(resellerApiSite, "/order");
var prodApiEndpoint = "https://api.".concat(resellerApiSite, "/order");
orderEndpoints.get = __LOCAL__ && localOrderEndpoint || __DEV__ && devOrderEndpoint || __PROD__ && prodApiEndpoint;

orderEndpoints.addToCart = function (_ref12) {
  var domain = _ref12.domain,
      packageId = _ref12.packageId,
      type = _ref12.type;
  return createEndpoint("/api/".concat(type, "/add-to-cart/").concat(domain, "/").concat(packageId));
};

var localGraphAPI = 'http://localhost:3000/graphql/';
var devGraphAPI = "https://dev.api.".concat(resellerApiSite, "/graphql");
var prodGraphAPI = "https://api.".concat(resellerApiSite, "/graphql");
var graphQLEndpoint = __LOCAL__ && localGraphAPI || __DEV__ && devGraphAPI || __PROD__ && prodGraphAPI;
var payPalUrl = '//www.paypalobjects.com/api/checkout.js';
var countriesEndpoint = createEndpoint('/api/options/countries'); // ========= Email Setup endpoint  =========

var emailSetupEndpoint = "https://api.".concat(resellerApiSite, "/email-assistant"); // ========= My Account Domains endpoint  =========

var localDomains = "https://local.".concat(RESELLER, "/api/user/domains/");
var devDomains = "https://dev.".concat(RESELLER, "/api/user/domains/");
var prodDomains = "https://www.".concat(RESELLER, "/api/user/domains/");
var accountDomains = __LOCAL__ && localDomains || __DEV__ && devDomains || __PROD__ && prodDomains; // ========= Simple email login =========

var localSimpleEmailLoginLink = function localSimpleEmailLoginLink(subscriptionId) {
  return "http://local.rebel.com/api/subscription/hosting/".concat(subscriptionId, "/loginlink");
};

var devSimpleEmailLoginLink = function devSimpleEmailLoginLink(subscriptionId) {
  return "https://dev.rebel.com/api/subscription/hosting/".concat(subscriptionId, "/loginlink");
};

var prodSimpleEmailLoginLink = function prodSimpleEmailLoginLink(subscriptionId) {
  return "https://www.rebel.com/api/subscription/hosting/".concat(subscriptionId, "/loginlink");
};

var simpleEmailLoginLink = __LOCAL__ && localSimpleEmailLoginLink || __DEV__ && devSimpleEmailLoginLink || __PROD__ && prodSimpleEmailLoginLink;
var NicSupportDomain$1 = "https://support.internic.ca";
var RebelSupportDomain$1 = "https://support.rebel.com";
var SupportDomain$1 = isInternic ? NicSupportDomain$1 : RebelSupportDomain$1;

var createSupportArticleEndpoint = function createSupportArticleEndpoint(nicArticleID, rebelArticleID) {
  if (isInternic) {
    return "".concat(SupportDomain$1, "/hc/en-us/articles/").concat(nicArticleID);
  }

  return "".concat(SupportDomain$1, "/hc/en-us/articles/").concat(rebelArticleID);
};

var errorStrings$1 = {
  apiError: 'Something went wrong!  Try again or call our support team.'
};

function _regenerator$1I() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1I(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1I(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1I(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1I(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1I(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1I(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1I(u), _regeneratorDefine2$1I(u, o, "Generator"), _regeneratorDefine2$1I(u, n, function () {
    return this;
  }), _regeneratorDefine2$1I(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1I = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1I(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1I = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1I(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1I(e, r, n, t);
} // Note this is not evaluating a Set or a Map


var isEmpty$1 = function isEmpty(obj) {
  return [Object, Array].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;
};

function cleanDomain(url) {
  if (!url) {
    return url;
  } // Remove protocol (http, https) and www.


  var cleanedUrl = url.trim().replace(/^(?:https?:\/\/)?(?:www\.)?/i, ''); // Exclude paths from search, only include domain part.

  cleanedUrl = cleanedUrl.split('/')[0]; // Remove special characters except hyphens and periods.

  cleanedUrl = cleanedUrl.replace(/[^a-zA-Z0-9-.]/g, ''); // Remove trailing slash, if any.

  cleanedUrl = cleanedUrl.replace(/\/$/, '');
  return cleanedUrl.toLowerCase();
}
/**
 * Validates domain format.
 * ✅ example.com
 * ✅ example.com.au
 * ❌ example
 * ❌ examp!e.com
 */


function isValidDomain(domain) {
  if (!domain) {
    return false;
  }

  var domainRegex = /^(?!-)(?:[a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,63}$/;
  return domainRegex.test(domain);
}

var isTest = Boolean(typeof __TEST__ !== 'undefined' && __TEST__);

var getMergedSet = function getMergedSet(arrayOne, arrayTwo) {
  var uniqueArrayTwo = arrayTwo.filter(function (i) {
    return !arrayOne.includes(i);
  });
  return [].concat(_toConsumableArray$1(arrayOne), _toConsumableArray$1(uniqueArrayTwo));
};

var getExcludedItems = function getExcludedItems(arrayOne, arrayTwo) {
  return arrayTwo.filter(function (i) {
    return !arrayOne.includes(i);
  });
};

function getmfaTypeFromInt(mfaTypeInt) {
  switch (mfaTypeInt) {
    case 1:
      return 'none';

    case 2:
      return 'app';

    case 3:
      return 'email';

    case 4:
      return 'phone';

    default:
      return 'none';
  }
}

function getUserForMFA() {
  return _getUserForMFA.apply(this, arguments);
}

function _getUserForMFA() {
  _getUserForMFA = _asyncToGenerator( /*#__PURE__*/_regenerator$1I().m(function _callee() {
    var res, _res;

    return _regenerator$1I().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return get$3("".concat(mfaEndpoint, "/user"));

          case 1:
            res = _context.v;
            return _context.a(2, res.data.user);

          case 2:
            _context.p = 2;
            _context.n = 3;
            return refreshRWT();

          case 3:
            _context.n = 4;
            return get$3("".concat(mfaEndpoint, "/user"));

          case 4:
            _res = _context.v;
            return _context.a(2, _res.data.user);
        }
      }
    }, _callee, null, [[0, 2]]);
  }));
  return _getUserForMFA.apply(this, arguments);
}

var getItem = function getItem(key) {
  if (!hasDOM || !localStorage) {
    return null;
  }

  var item = localStorage.getItem(key);

  if (isEmpty$1(item)) {
    return null;
  }

  try {
    return JSON.parse(item);
  } catch (e) {
    if (localStorage[key]) {
      return item;
    } // eslint-disable-next-line no-console


    console.error("Error fetching key: '".concat(key, "' from localStorage"), e);
    return null;
  }
};

var setItem = function setItem(key, data) {
  if (!hasDOM) {
    return;
  }

  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error("Error setting ".concat(key, " in localStorage"), e);
  }
};

var removeItem = function removeItem(key) {
  if (!hasDOM) {
    return;
  }

  localStorage.removeItem(key);
};

var storageKeys = {
  LSToken: 'rwt',
  User: 'user',
  PaypalEnv: 'paypalEnv',
  MerchantId: 'merchantId',
  LoginSettings: 'loginSettings',
  Currency: 'currency',
  SupportRequests: 'supportRequests',
  BulkSecurity: 'bulkSecurity',
  OrderItems: 'orderItems',
  Features: 'features',
  Alerts: 'alerts',
  MyAccountDashboard: 'myAccountDashboard',
  UseOldCart: 'useOldCart'
};
var LS = {
  getItem: getItem,
  setItem: setItem,
  removeItem: removeItem,
  storageKeys: storageKeys
};

function ownKeys$1R(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1R(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1R(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1R(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _regenerator$1H() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1H(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1H(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1H(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1H(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1H(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1H(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1H(u), _regeneratorDefine2$1H(u, o, "Generator"), _regeneratorDefine2$1H(u, n, function () {
    return this;
  }), _regeneratorDefine2$1H(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1H = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1H(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1H = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1H(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1H(e, r, n, t);
}

axios.defaults.withCredentials = true;

var hasValidHeaders = function hasValidHeaders(headers) {
  if (typeof headers === 'undefined' || typeof headers['content-type'] === 'undefined' || !headers['content-type'].includes('application/json')) {
    return false;
  }

  return true;
};

var shouldClearToken = function shouldClearToken() {
  var cookie;

  if (hasDOM) {
    // eslint-disable-next-line prefer-destructuring
    cookie = document.cookie;
  }

  if (cookie && cookie.includes('ClearUserToken')) {
    cookie = 'ClearUserToken=;Expires=Thu, 01 Jan 1970 00:00:00 GMT;Path=/;';
    LS.removeItem(storageKeys.LSToken);
    return true;
  }

  return false;
};

var fetchToken = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$1H().m(function _callee(req) {
    var res, _t;

    return _regenerator$1H().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            _context.p = 0;
            res = null;

            if (!(req.force || shouldClearToken())) {
              _context.n = 2;
              break;
            }

            _context.n = 1;
            return axios.get(userEndpoints.userAccessToken);

          case 1:
            res = _context.v;
            LS.setItem(storageKeys.LSToken, res.data.token);

          case 2:
            return _context.a(2, res);

          case 3:
            _context.p = 3;
            _t = _context.v;
            throw _t;

          case 4:
            return _context.a(2);
        }
      }
    }, _callee, null, [[0, 3]]);
  }));

  return function fetchToken(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getAuthToken = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$1H().m(function _callee2(newToken) {
    var authToken, res;
    return _regenerator$1H().w(function (_context2) {
      while (1) {
        switch (_context2.n) {
          case 0:
            authToken = !newToken && LS.getItem(storageKeys.LSToken);

            if (authToken) {
              _context2.n = 2;
              break;
            }

            _context2.n = 1;
            return fetchToken({
              force: true
            });

          case 1:
            res = _context2.v;
            authToken = res.data.token;

          case 2:
            return _context2.a(2, authToken);
        }
      }
    }, _callee2);
  }));

  return function getAuthToken(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var refreshRWT = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator$1H().m(function _callee3() {
    var _yield$fetchToken, data;

    return _regenerator$1H().w(function (_context3) {
      while (1) {
        switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return fetchToken({
              force: true
            });

          case 1:
            _yield$fetchToken = _context3.v;
            data = _yield$fetchToken.data;
            return _context3.a(2, data.token);
        }
      }
    }, _callee3);
  }));

  return function refreshRWT() {
    return _ref3.apply(this, arguments);
  };
}();

var get$3 = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regenerator$1H().m(function _callee4(url, config, newToken) {
    var authToken, response, statusCode, headers, newAuthToken, retryResponse, _t2;

    return _regenerator$1H().w(function (_context4) {
      while (1) {
        switch (_context4.n) {
          case 0:
            _context4.p = 0;
            _context4.n = 1;
            return getAuthToken(newToken);

          case 1:
            authToken = _context4.v;
            _context4.n = 2;
            return axios.get(url, _objectSpread$1R({
              headers: {
                Authorization: authToken
              }
            }, config));

          case 2:
            response = _context4.v;
            return _context4.a(2, response);

          case 3:
            _context4.p = 3;
            _t2 = _context4.v;
            statusCode = _get(_t2, 'response.status');
            headers = _get(_t2, 'response.headers'); // If auth error, maybe token has expired.
            // Create new token and try again

            _context4.p = 4;

            if (!(statusCode === 401)) {
              _context4.n = 7;
              break;
            }

            _context4.n = 5;
            return refreshRWT();

          case 5:
            newAuthToken = _context4.v;
            _context4.n = 6;
            return axios.get(url, _objectSpread$1R({
              headers: {
                Authorization: newAuthToken
              }
            }, config));

          case 6:
            retryResponse = _context4.v;
            return _context4.a(2, retryResponse);

          case 7:
            _context4.n = 9;
            break;

          case 8:
            _context4.p = 8;

          case 9:
            if (hasValidHeaders(headers)) {
              _context4.n = 10;
              break;
            }

            throw new Error(errorStrings$1.apiError);

          case 10:
            throw _t2;

          case 11:
            return _context4.a(2);
        }
      }
    }, _callee4, null, [[4, 8], [0, 3]]);
  }));

  return function get(_x3, _x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();

var post$1 = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regenerator$1H().m(function _callee5(url, body, config) {
    var authToken, headers, response, statusCode, _headers, newAuthToken, retryResponse, _t4;

    return _regenerator$1H().w(function (_context5) {
      while (1) {
        switch (_context5.n) {
          case 0:
            _context5.p = 0;
            _context5.n = 1;
            return getAuthToken();

          case 1:
            authToken = _context5.v;
            headers = {
              Authorization: authToken
            };

            if (config && config.dontSetAuthorizationHeader) {
              delete headers.Authorization;
            }

            _context5.n = 2;
            return axios.post(url, body, _objectSpread$1R({
              headers: headers
            }, config));

          case 2:
            response = _context5.v;
            return _context5.a(2, response);

          case 3:
            _context5.p = 3;
            _t4 = _context5.v;
            statusCode = _get(_t4, 'response.status');
            _headers = _get(_t4, 'response.headers'); // If auth error, maybe token has expired.
            // Create new token and try again if it is not the /auth endpoint

            _context5.p = 4;

            if (!(statusCode === 401 && !url.includes('api/user/auth'))) {
              _context5.n = 7;
              break;
            }

            _context5.n = 5;
            return refreshRWT();

          case 5:
            newAuthToken = _context5.v;
            _context5.n = 6;
            return axios.post(url, body, _objectSpread$1R({
              headers: {
                Authorization: newAuthToken
              }
            }, config));

          case 6:
            retryResponse = _context5.v;
            return _context5.a(2, retryResponse);

          case 7:
            _context5.n = 9;
            break;

          case 8:
            _context5.p = 8;

          case 9:
            if (hasValidHeaders(_headers)) {
              _context5.n = 10;
              break;
            }

            throw new Error(errorStrings$1.apiError);

          case 10:
            throw _t4;

          case 11:
            return _context5.a(2);
        }
      }
    }, _callee5, null, [[4, 8], [0, 3]]);
  }));

  return function post(_x6, _x7, _x8) {
    return _ref5.apply(this, arguments);
  };
}();

var put$1 = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regenerator$1H().m(function _callee6(url, body, config) {
    var authToken, headers, response, statusCode, _headers2, newAuthToken, retryResponse, _t6;

    return _regenerator$1H().w(function (_context6) {
      while (1) {
        switch (_context6.n) {
          case 0:
            _context6.p = 0;
            _context6.n = 1;
            return getAuthToken();

          case 1:
            authToken = _context6.v;
            headers = {
              Authorization: authToken
            };

            if (config && config.dontSetAuthorizationHeader) {
              delete headers.Authorization;
            }

            _context6.n = 2;
            return axios.put(url, body, _objectSpread$1R({
              headers: headers
            }, config));

          case 2:
            response = _context6.v;
            return _context6.a(2, response);

          case 3:
            _context6.p = 3;
            _t6 = _context6.v;
            statusCode = _get(_t6, 'response.status');
            _headers2 = _get(_t6, 'response.headers'); // If auth error, maybe token has expired.
            // Create new token and try again

            _context6.p = 4;

            if (!(statusCode === 401)) {
              _context6.n = 7;
              break;
            }

            _context6.n = 5;
            return refreshRWT();

          case 5:
            newAuthToken = _context6.v;
            _context6.n = 6;
            return axios.put(url, body, _objectSpread$1R({
              headers: {
                Authorization: newAuthToken
              }
            }, config));

          case 6:
            retryResponse = _context6.v;
            return _context6.a(2, retryResponse);

          case 7:
            _context6.n = 9;
            break;

          case 8:
            _context6.p = 8;

          case 9:
            if (hasValidHeaders(_headers2)) {
              _context6.n = 10;
              break;
            }

            throw new Error(errorStrings$1.apiError);

          case 10:
            throw _t6;

          case 11:
            return _context6.a(2);
        }
      }
    }, _callee6, null, [[4, 8], [0, 3]]);
  }));

  return function put(_x9, _x0, _x1) {
    return _ref6.apply(this, arguments);
  };
}();

var del$1 = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regenerator$1H().m(function _callee7(url, config) {
    var authToken, headers, response, statusCode, _headers3, newAuthToken, retryResponse, _t8;

    return _regenerator$1H().w(function (_context7) {
      while (1) {
        switch (_context7.n) {
          case 0:
            _context7.p = 0;
            _context7.n = 1;
            return getAuthToken();

          case 1:
            authToken = _context7.v;
            headers = {
              Authorization: authToken
            };

            if (config && config.dontSetAuthorizationHeader) {
              delete headers.Authorization;
            }

            _context7.n = 2;
            return axios["delete"](url, _objectSpread$1R({
              headers: headers
            }, config));

          case 2:
            response = _context7.v;
            return _context7.a(2, response);

          case 3:
            _context7.p = 3;
            _t8 = _context7.v;
            statusCode = _get(_t8, 'response.status');
            _headers3 = _get(_t8, 'response.headers'); // If auth error, maybe token has expired.
            // Create new token and try again

            _context7.p = 4;

            if (!(statusCode === 401)) {
              _context7.n = 7;
              break;
            }

            _context7.n = 5;
            return refreshRWT();

          case 5:
            newAuthToken = _context7.v;
            _context7.n = 6;
            return axios["delete"](url, _objectSpread$1R({
              headers: {
                Authorization: newAuthToken
              }
            }, config));

          case 6:
            retryResponse = _context7.v;
            return _context7.a(2, retryResponse);

          case 7:
            _context7.n = 9;
            break;

          case 8:
            _context7.p = 8;

          case 9:
            if (hasValidHeaders(_headers3)) {
              _context7.n = 10;
              break;
            }

            throw new Error(errorStrings$1.apiError);

          case 10:
            throw _t8;

          case 11:
            return _context7.a(2);
        }
      }
    }, _callee7, null, [[4, 8], [0, 3]]);
  }));

  return function del(_x10, _x11) {
    return _ref7.apply(this, arguments);
  };
}();
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


var _assign$ = function __assign$9() {
  _assign$ = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign$.apply(this, arguments);
};

function __rest$6(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function __values$1(o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read$4(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
}

function __spreadArray$2(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

var ActionTypes;

(function (ActionTypes) {
  ActionTypes["Start"] = "xstate.start";
  ActionTypes["Stop"] = "xstate.stop";
  ActionTypes["Raise"] = "xstate.raise";
  ActionTypes["Send"] = "xstate.send";
  ActionTypes["Cancel"] = "xstate.cancel";
  ActionTypes["NullEvent"] = "";
  ActionTypes["Assign"] = "xstate.assign";
  ActionTypes["After"] = "xstate.after";
  ActionTypes["DoneState"] = "done.state";
  ActionTypes["DoneInvoke"] = "done.invoke";
  ActionTypes["Log"] = "xstate.log";
  ActionTypes["Init"] = "xstate.init";
  ActionTypes["Invoke"] = "xstate.invoke";
  ActionTypes["ErrorExecution"] = "error.execution";
  ActionTypes["ErrorCommunication"] = "error.communication";
  ActionTypes["ErrorPlatform"] = "error.platform";
  ActionTypes["ErrorCustom"] = "xstate.error";
  ActionTypes["Update"] = "xstate.update";
  ActionTypes["Pure"] = "xstate.pure";
  ActionTypes["Choose"] = "xstate.choose";
})(ActionTypes || (ActionTypes = {}));

var SpecialTargets;

(function (SpecialTargets) {
  SpecialTargets["Parent"] = "#_parent";
  SpecialTargets["Internal"] = "#_internal";
})(SpecialTargets || (SpecialTargets = {}));

var start$1 = ActionTypes.Start;
var stop$1 = ActionTypes.Stop;
var raise$1 = ActionTypes.Raise;
var send$1 = ActionTypes.Send;
var cancel$1 = ActionTypes.Cancel;
var nullEvent = ActionTypes.NullEvent;
var assign$4 = ActionTypes.Assign;
ActionTypes.After;
ActionTypes.DoneState;
var log = ActionTypes.Log;
var init = ActionTypes.Init;
var invoke = ActionTypes.Invoke;
ActionTypes.ErrorExecution;
var errorPlatform = ActionTypes.ErrorPlatform;
var error$2 = ActionTypes.ErrorCustom;
var update = ActionTypes.Update;
var choose = ActionTypes.Choose;
var pure = ActionTypes.Pure;
var STATE_DELIMITER = '.';
var EMPTY_ACTIVITY_MAP = {};
var DEFAULT_GUARD_TYPE = 'xstate.guard';
var TARGETLESS_KEY = '';
var IS_PRODUCTION = process$1.env.NODE_ENV === 'production';

var _a$4;

function matchesState(parentStateId, childStateId, delimiter) {
  if (delimiter === void 0) {
    delimiter = STATE_DELIMITER;
  }

  var parentStateValue = toStateValue(parentStateId, delimiter);
  var childStateValue = toStateValue(childStateId, delimiter);

  if (isString$3(childStateValue)) {
    if (isString$3(parentStateValue)) {
      return childStateValue === parentStateValue;
    } // Parent more specific than child


    return false;
  }

  if (isString$3(parentStateValue)) {
    return parentStateValue in childStateValue;
  }

  return Object.keys(parentStateValue).every(function (key) {
    if (!(key in childStateValue)) {
      return false;
    }

    return matchesState(parentStateValue[key], childStateValue[key]);
  });
}

function getEventType(event) {
  try {
    return isString$3(event) || typeof event === 'number' ? "".concat(event) : event.type;
  } catch (e) {
    throw new Error('Events must be strings or objects with a string event.type property.');
  }
}

function toStatePath(stateId, delimiter) {
  try {
    if (isArray$4(stateId)) {
      return stateId;
    }

    return stateId.toString().split(delimiter);
  } catch (e) {
    throw new Error("'".concat(stateId, "' is not a valid state path."));
  }
}

function isStateLike(state) {
  return typeof state === 'object' && 'value' in state && 'context' in state && 'event' in state && '_event' in state;
}

function toStateValue(stateValue, delimiter) {
  if (isStateLike(stateValue)) {
    return stateValue.value;
  }

  if (isArray$4(stateValue)) {
    return pathToStateValue(stateValue);
  }

  if (typeof stateValue !== 'string') {
    return stateValue;
  }

  var statePath = toStatePath(stateValue, delimiter);
  return pathToStateValue(statePath);
}

function pathToStateValue(statePath) {
  if (statePath.length === 1) {
    return statePath[0];
  }

  var value = {};
  var marker = value;

  for (var i = 0; i < statePath.length - 1; i++) {
    if (i === statePath.length - 2) {
      marker[statePath[i]] = statePath[i + 1];
    } else {
      marker[statePath[i]] = {};
      marker = marker[statePath[i]];
    }
  }

  return value;
}

function mapValues(collection, iteratee) {
  var result = {};
  var collectionKeys = Object.keys(collection);

  for (var i = 0; i < collectionKeys.length; i++) {
    var key = collectionKeys[i];
    result[key] = iteratee(collection[key], key, collection, i);
  }

  return result;
}

function mapFilterValues(collection, iteratee, predicate) {
  var e_1, _a;

  var result = {};

  try {
    for (var _b = __values$1(Object.keys(collection)), _c = _b.next(); !_c.done; _c = _b.next()) {
      var key = _c.value;
      var item = collection[key];

      if (!predicate(item)) {
        continue;
      }

      result[key] = iteratee(item, key, collection);
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return result;
}
/**
 * Retrieves a value at the given path.
 * @param props The deep path to the prop of the desired value
 */


var path = function path(props) {
  return function (object) {
    var e_2, _a;

    var result = object;

    try {
      for (var props_1 = __values$1(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()) {
        var prop = props_1_1.value;
        result = result[prop];
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
      } finally {
        if (e_2) throw e_2.error;
      }
    }

    return result;
  };
};
/**
 * Retrieves a value at the given path via the nested accessor prop.
 * @param props The deep path to the prop of the desired value
 */


function nestedPath(props, accessorProp) {
  return function (object) {
    var e_3, _a;

    var result = object;

    try {
      for (var props_2 = __values$1(props), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()) {
        var prop = props_2_1.value;
        result = result[accessorProp][prop];
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (props_2_1 && !props_2_1.done && (_a = props_2.return)) _a.call(props_2);
      } finally {
        if (e_3) throw e_3.error;
      }
    }

    return result;
  };
}

function toStatePaths(stateValue) {
  if (!stateValue) {
    return [[]];
  }

  if (isString$3(stateValue)) {
    return [[stateValue]];
  }

  var result = flatten(Object.keys(stateValue).map(function (key) {
    var subStateValue = stateValue[key];

    if (typeof subStateValue !== 'string' && (!subStateValue || !Object.keys(subStateValue).length)) {
      return [[key]];
    }

    return toStatePaths(stateValue[key]).map(function (subPath) {
      return [key].concat(subPath);
    });
  }));
  return result;
}

function flatten(array) {
  var _a;

  return (_a = []).concat.apply(_a, __spreadArray$2([], __read$4(array), false));
}

function toArrayStrict(value) {
  if (isArray$4(value)) {
    return value;
  }

  return [value];
}

function toArray$2(value) {
  if (value === undefined) {
    return [];
  }

  return toArrayStrict(value);
}

function mapContext(mapper, context, _event) {
  var e_5, _a;

  if (isFunction$3(mapper)) {
    return mapper(context, _event.data);
  }

  var result = {};

  try {
    for (var _b = __values$1(Object.keys(mapper)), _c = _b.next(); !_c.done; _c = _b.next()) {
      var key = _c.value;
      var subMapper = mapper[key];

      if (isFunction$3(subMapper)) {
        result[key] = subMapper(context, _event.data);
      } else {
        result[key] = subMapper;
      }
    }
  } catch (e_5_1) {
    e_5 = {
      error: e_5_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_5) throw e_5.error;
    }
  }

  return result;
}

function isBuiltInEvent(eventType) {
  return /^(done|error)\./.test(eventType);
}

function isPromiseLike$1(value) {
  if (value instanceof Promise) {
    return true;
  } // Check if shape matches the Promise/A+ specification for a "thenable".


  if (value !== null && (isFunction$3(value) || typeof value === 'object') && isFunction$3(value.then)) {
    return true;
  }

  return false;
}

function isBehavior(value) {
  return value !== null && typeof value === 'object' && 'transition' in value && typeof value.transition === 'function';
}

function partition$1(items, predicate) {
  var e_6, _a;

  var _b = __read$4([[], []], 2),
      truthy = _b[0],
      falsy = _b[1];

  try {
    for (var items_1 = __values$1(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
      var item = items_1_1.value;

      if (predicate(item)) {
        truthy.push(item);
      } else {
        falsy.push(item);
      }
    }
  } catch (e_6_1) {
    e_6 = {
      error: e_6_1
    };
  } finally {
    try {
      if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
    } finally {
      if (e_6) throw e_6.error;
    }
  }

  return [truthy, falsy];
}

function updateHistoryStates(hist, stateValue) {
  return mapValues(hist.states, function (subHist, key) {
    if (!subHist) {
      return undefined;
    }

    var subStateValue = (isString$3(stateValue) ? undefined : stateValue[key]) || (subHist ? subHist.current : undefined);

    if (!subStateValue) {
      return undefined;
    }

    return {
      current: subStateValue,
      states: updateHistoryStates(subHist, subStateValue)
    };
  });
}

function updateHistoryValue(hist, stateValue) {
  return {
    current: stateValue,
    states: updateHistoryStates(hist, stateValue)
  };
}

function updateContext(context, _event, assignActions, state) {
  if (!IS_PRODUCTION) {
    warn(!!context, 'Attempting to update undefined context');
  }

  var updatedContext = context ? assignActions.reduce(function (acc, assignAction) {
    var e_7, _a;

    var assignment = assignAction.assignment;
    var meta = {
      state: state,
      action: assignAction,
      _event: _event
    };
    var partialUpdate = {};

    if (isFunction$3(assignment)) {
      partialUpdate = assignment(acc, _event.data, meta);
    } else {
      try {
        for (var _b = __values$1(Object.keys(assignment)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var key = _c.value;
          var propAssignment = assignment[key];
          partialUpdate[key] = isFunction$3(propAssignment) ? propAssignment(acc, _event.data, meta) : propAssignment;
        }
      } catch (e_7_1) {
        e_7 = {
          error: e_7_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_7) throw e_7.error;
        }
      }
    }

    return Object.assign({}, acc, partialUpdate);
  }, context) : context;
  return updatedContext;
} // tslint:disable-next-line:no-empty


var warn = function warn() {};

if (!IS_PRODUCTION) {
  warn = function warn(condition, message) {
    var error = condition instanceof Error ? condition : undefined;

    if (!error && condition) {
      return;
    }

    if (console !== undefined) {
      var args = ["Warning: ".concat(message)];

      if (error) {
        args.push(error);
      } // tslint:disable-next-line:no-console


      console.warn.apply(console, args);
    }
  };
}

function isArray$4(value) {
  return Array.isArray(value);
} // tslint:disable-next-line:ban-types


function isFunction$3(value) {
  return typeof value === 'function';
}

function isString$3(value) {
  return typeof value === 'string';
}

function toGuard(condition, guardMap) {
  if (!condition) {
    return undefined;
  }

  if (isString$3(condition)) {
    return {
      type: DEFAULT_GUARD_TYPE,
      name: condition,
      predicate: guardMap ? guardMap[condition] : undefined
    };
  }

  if (isFunction$3(condition)) {
    return {
      type: DEFAULT_GUARD_TYPE,
      name: condition.name,
      predicate: condition
    };
  }

  return condition;
}

function isObservable$1(value) {
  try {
    return 'subscribe' in value && isFunction$3(value.subscribe);
  } catch (e) {
    return false;
  }
}

var symbolObservable = /*#__PURE__*/function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}(); // TODO: to be removed in v5, left it out just to minimize the scope of the change and maintain compatibility with older versions of integration paackages


_a$4 = {}, _a$4[symbolObservable] = function () {
  return this;
}, _a$4[Symbol.observable] = function () {
  return this;
}, _a$4;

function isMachine(value) {
  return !!value && '__xstatenode' in value;
}

function isActor$1(value) {
  return !!value && typeof value.send === 'function';
}

function toEventObject(event, payload // id?: TEvent['type']
) {
  if (isString$3(event) || typeof event === 'number') {
    return _assign$({
      type: event
    }, payload);
  }

  return event;
}

function toSCXMLEvent(event, scxmlEvent) {
  if (!isString$3(event) && '$$type' in event && event.$$type === 'scxml') {
    return event;
  }

  var eventObject = toEventObject(event);
  return _assign$({
    name: eventObject.type,
    data: eventObject,
    $$type: 'scxml',
    type: 'external'
  }, scxmlEvent);
}

function toTransitionConfigArray(event, configLike) {
  var transitions = toArrayStrict(configLike).map(function (transitionLike) {
    if (typeof transitionLike === 'undefined' || typeof transitionLike === 'string' || isMachine(transitionLike)) {
      return {
        target: transitionLike,
        event: event
      };
    }

    return _assign$(_assign$({}, transitionLike), {
      event: event
    });
  });
  return transitions;
}

function normalizeTarget(target) {
  if (target === undefined || target === TARGETLESS_KEY) {
    return undefined;
  }

  return toArray$2(target);
}

function reportUnhandledExceptionOnInvocation(originalError, currentError, id) {
  if (!IS_PRODUCTION) {
    var originalStackTrace = originalError.stack ? " Stacktrace was '".concat(originalError.stack, "'") : '';

    if (originalError === currentError) {
      // tslint:disable-next-line:no-console
      console.error("Missing onError handler for invocation '".concat(id, "', error was '").concat(originalError, "'.").concat(originalStackTrace));
    } else {
      var stackTrace = currentError.stack ? " Stacktrace was '".concat(currentError.stack, "'") : ''; // tslint:disable-next-line:no-console

      console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '".concat(id, "'. ") + "Original error: '".concat(originalError, "'. ").concat(originalStackTrace, " Current error is '").concat(currentError, "'.").concat(stackTrace));
    }
  }
}

function evaluateGuard(machine, guard, context, _event, state) {
  var guards = machine.options.guards;
  var guardMeta = {
    state: state,
    cond: guard,
    _event: _event
  }; // TODO: do not hardcode!

  if (guard.type === DEFAULT_GUARD_TYPE) {
    return ((guards === null || guards === void 0 ? void 0 : guards[guard.name]) || guard.predicate)(context, _event.data, guardMeta);
  }

  var condFn = guards === null || guards === void 0 ? void 0 : guards[guard.type];

  if (!condFn) {
    throw new Error("Guard '".concat(guard.type, "' is not implemented on machine '").concat(machine.id, "'."));
  }

  return condFn(context, _event.data, guardMeta);
}

function toInvokeSource$1(src) {
  if (typeof src === 'string') {
    return {
      type: src
    };
  }

  return src;
}

function toObserver$1(nextHandler, errorHandler, completionHandler) {
  if (typeof nextHandler === 'object') {
    return nextHandler;
  }

  var noop = function noop() {
    return void 0;
  };

  return {
    next: nextHandler,
    error: errorHandler || noop,
    complete: completionHandler || noop
  };
}

function createInvokeId(stateNodeId, index) {
  return "".concat(stateNodeId, ":invocation[").concat(index, "]");
}

var initEvent = /*#__PURE__*/toSCXMLEvent({
  type: init
});

function getActionFunction(actionType, actionFunctionMap) {
  return actionFunctionMap ? actionFunctionMap[actionType] || undefined : undefined;
}

function toActionObject(action, actionFunctionMap) {
  var actionObject;

  if (isString$3(action) || typeof action === 'number') {
    var exec = getActionFunction(action, actionFunctionMap);

    if (isFunction$3(exec)) {
      actionObject = {
        type: action,
        exec: exec
      };
    } else if (exec) {
      actionObject = exec;
    } else {
      actionObject = {
        type: action,
        exec: undefined
      };
    }
  } else if (isFunction$3(action)) {
    actionObject = {
      // Convert action to string if unnamed
      type: action.name || action.toString(),
      exec: action
    };
  } else {
    var exec = getActionFunction(action.type, actionFunctionMap);

    if (isFunction$3(exec)) {
      actionObject = _assign$(_assign$({}, action), {
        exec: exec
      });
    } else if (exec) {
      var actionType = exec.type || action.type;
      actionObject = _assign$(_assign$(_assign$({}, exec), action), {
        type: actionType
      });
    } else {
      actionObject = action;
    }
  }

  return actionObject;
}

var toActionObjects = function toActionObjects(action, actionFunctionMap) {
  if (!action) {
    return [];
  }

  var actions = isArray$4(action) ? action : [action];
  return actions.map(function (subAction) {
    return toActionObject(subAction, actionFunctionMap);
  });
};

function toActivityDefinition(action) {
  var actionObject = toActionObject(action);
  return _assign$(_assign$({
    id: isString$3(action) ? action : actionObject.id
  }, actionObject), {
    type: actionObject.type
  });
}
/**
 * Raises an event. This places the event in the internal event queue, so that
 * the event is immediately consumed by the machine in the current step.
 *
 * @param eventType The event to raise.
 */


function raise(event) {
  if (!isString$3(event)) {
    return send(event, {
      to: SpecialTargets.Internal
    });
  }

  return {
    type: raise$1,
    event: event
  };
}

function resolveRaise(action) {
  return {
    type: raise$1,
    _event: toSCXMLEvent(action.event)
  };
}
/**
 * Sends an event. This returns an action that will be read by an interpreter to
 * send the event in the next step, after the current step is finished executing.
 *
 * @param event The event to send.
 * @param options Options to pass into the send event:
 *  - `id` - The unique send event identifier (used with `cancel()`).
 *  - `delay` - The number of milliseconds to delay the sending of the event.
 *  - `to` - The target of this event (by default, the machine the event was sent from).
 */


function send(event, options) {
  return {
    to: options ? options.to : undefined,
    type: send$1,
    event: isFunction$3(event) ? event : toEventObject(event),
    delay: options ? options.delay : undefined,
    id: options && options.id !== undefined ? options.id : isFunction$3(event) ? event.name : getEventType(event)
  };
}

function resolveSend(action, ctx, _event, delaysMap) {
  var meta = {
    _event: _event
  }; // TODO: helper function for resolving Expr

  var resolvedEvent = toSCXMLEvent(isFunction$3(action.event) ? action.event(ctx, _event.data, meta) : action.event);
  var resolvedDelay;

  if (isString$3(action.delay)) {
    var configDelay = delaysMap && delaysMap[action.delay];
    resolvedDelay = isFunction$3(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
  } else {
    resolvedDelay = isFunction$3(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
  }

  var resolvedTarget = isFunction$3(action.to) ? action.to(ctx, _event.data, meta) : action.to;
  return _assign$(_assign$({}, action), {
    to: resolvedTarget,
    _event: resolvedEvent,
    event: resolvedEvent.data,
    delay: resolvedDelay
  });
}

var resolveLog = function resolveLog(action, ctx, _event) {
  return _assign$(_assign$({}, action), {
    value: isString$3(action.expr) ? action.expr : action.expr(ctx, _event.data, {
      _event: _event
    })
  });
};
/**
 * Cancels an in-flight `send(...)` action. A canceled sent action will not
 * be executed, nor will its event be sent, unless it has already been sent
 * (e.g., if `cancel(...)` is called after the `send(...)` action's `delay`).
 *
 * @param sendId The `id` of the `send(...)` action to cancel.
 */


var cancel = function cancel(sendId) {
  return {
    type: cancel$1,
    sendId: sendId
  };
};
/**
 * Starts an activity.
 *
 * @param activity The activity to start.
 */


function start(activity) {
  var activityDef = toActivityDefinition(activity);
  return {
    type: ActionTypes.Start,
    activity: activityDef,
    exec: undefined
  };
}
/**
 * Stops an activity.
 *
 * @param actorRef The activity to stop.
 */


function stop(actorRef) {
  var activity = isFunction$3(actorRef) ? actorRef : toActivityDefinition(actorRef);
  return {
    type: ActionTypes.Stop,
    activity: activity,
    exec: undefined
  };
}

function resolveStop(action, context, _event) {
  var actorRefOrString = isFunction$3(action.activity) ? action.activity(context, _event.data) : action.activity;
  var resolvedActorRef = typeof actorRefOrString === 'string' ? {
    id: actorRefOrString
  } : actorRefOrString;
  var actionObject = {
    type: ActionTypes.Stop,
    activity: resolvedActorRef
  };
  return actionObject;
}
/**
 * Updates the current context of the machine.
 *
 * @param assignment An object that represents the partial context to update.
 */


var assign$3 = function assign$3(assignment) {
  return {
    type: assign$4,
    assignment: assignment
  };
};
/**
 * Returns an event type that represents an implicit event that
 * is sent after the specified `delay`.
 *
 * @param delayRef The delay in milliseconds
 * @param id The state node ID where this event is handled
 */


function after(delayRef, id) {
  var idSuffix = id ? "#".concat(id) : '';
  return "".concat(ActionTypes.After, "(").concat(delayRef, ")").concat(idSuffix);
}
/**
 * Returns an event that represents that a final state node
 * has been reached in the parent state node.
 *
 * @param id The final state node's parent state node `id`
 * @param data The data to pass into the event
 */


function done(id, data) {
  var type = "".concat(ActionTypes.DoneState, ".").concat(id);
  var eventObject = {
    type: type,
    data: data
  };

  eventObject.toString = function () {
    return type;
  };

  return eventObject;
}
/**
 * Returns an event that represents that an invoked service has terminated.
 *
 * An invoked service is terminated when it has reached a top-level final state node,
 * but not when it is canceled.
 *
 * @param id The final state node ID
 * @param data The data to pass into the event
 */


function doneInvoke(id, data) {
  var type = "".concat(ActionTypes.DoneInvoke, ".").concat(id);
  var eventObject = {
    type: type,
    data: data
  };

  eventObject.toString = function () {
    return type;
  };

  return eventObject;
}

function error$1(id, data) {
  var type = "".concat(ActionTypes.ErrorPlatform, ".").concat(id);
  var eventObject = {
    type: type,
    data: data
  };

  eventObject.toString = function () {
    return type;
  };

  return eventObject;
}

function resolveActions(machine, currentState, currentContext, _event, actions, preserveActionOrder) {
  if (preserveActionOrder === void 0) {
    preserveActionOrder = false;
  }

  var _a = __read$4(preserveActionOrder ? [[], actions] : partition$1(actions, function (action) {
    return action.type === assign$4;
  }), 2),
      assignActions = _a[0],
      otherActions = _a[1];

  var updatedContext = assignActions.length ? updateContext(currentContext, _event, assignActions, currentState) : currentContext;
  var preservedContexts = preserveActionOrder ? [currentContext] : undefined;
  var resolvedActions = flatten(otherActions.map(function (actionObject) {
    var _a;

    switch (actionObject.type) {
      case raise$1:
        return resolveRaise(actionObject);

      case send$1:
        var sendAction = resolveSend(actionObject, updatedContext, _event, machine.options.delays); // TODO: fix ActionTypes.Init

        if (!IS_PRODUCTION) {
          // warn after resolving as we can create better contextual message here
          warn(!isString$3(actionObject.delay) || typeof sendAction.delay === 'number', // tslint:disable-next-line:max-line-length
          "No delay reference for delay expression '".concat(actionObject.delay, "' was found on machine '").concat(machine.id, "'"));
        }

        return sendAction;

      case log:
        return resolveLog(actionObject, updatedContext, _event);

      case choose:
        {
          var chooseAction = actionObject;
          var matchedActions = (_a = chooseAction.conds.find(function (condition) {
            var guard = toGuard(condition.cond, machine.options.guards);
            return !guard || evaluateGuard(machine, guard, updatedContext, _event, currentState);
          })) === null || _a === void 0 ? void 0 : _a.actions;

          if (!matchedActions) {
            return [];
          }

          var _b = __read$4(resolveActions(machine, currentState, updatedContext, _event, toActionObjects(toArray$2(matchedActions), machine.options.actions), preserveActionOrder), 2),
              resolvedActionsFromChoose = _b[0],
              resolvedContextFromChoose = _b[1];

          updatedContext = resolvedContextFromChoose;
          preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
          return resolvedActionsFromChoose;
        }

      case pure:
        {
          var matchedActions = actionObject.get(updatedContext, _event.data);

          if (!matchedActions) {
            return [];
          }

          var _c = __read$4(resolveActions(machine, currentState, updatedContext, _event, toActionObjects(toArray$2(matchedActions), machine.options.actions), preserveActionOrder), 2),
              resolvedActionsFromPure = _c[0],
              resolvedContext = _c[1];

          updatedContext = resolvedContext;
          preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
          return resolvedActionsFromPure;
        }

      case stop$1:
        {
          return resolveStop(actionObject, updatedContext, _event);
        }

      case assign$4:
        {
          updatedContext = updateContext(updatedContext, _event, [actionObject], currentState);
          preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
          break;
        }

      default:
        var resolvedActionObject = toActionObject(actionObject, machine.options.actions);
        var exec_1 = resolvedActionObject.exec;

        if (exec_1 && preservedContexts) {
          var contextIndex_1 = preservedContexts.length - 1;
          resolvedActionObject = _assign$(_assign$({}, resolvedActionObject), {
            exec: function exec(_ctx) {
              var args = [];

              for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
              }

              exec_1.apply(void 0, __spreadArray$2([preservedContexts[contextIndex_1]], __read$4(args), false));
            }
          });
        }

        return resolvedActionObject;
    }
  }).filter(function (a) {
    return !!a;
  }));
  return [resolvedActions, updatedContext];
}
/**
 * Maintains a stack of the current service in scope.
 * This is used to provide the correct service to spawn().
 */


var provide = function provide(service, fn) {
  var result = fn(service);
  return result;
};

function createNullActor(id) {
  var _a;

  return _a = {
    id: id,
    send: function send() {
      return void 0;
    },
    subscribe: function subscribe() {
      return {
        unsubscribe: function unsubscribe() {
          return void 0;
        }
      };
    },
    getSnapshot: function getSnapshot() {
      return undefined;
    },
    toJSON: function toJSON() {
      return {
        id: id
      };
    }
  }, _a[symbolObservable] = function () {
    return this;
  }, _a;
}
/**
 * Creates a deferred actor that is able to be invoked given the provided
 * invocation information in its `.meta` value.
 *
 * @param invokeDefinition The meta information needed to invoke the actor.
 */


function createInvocableActor(invokeDefinition, machine, context, _event) {
  var _a;

  var invokeSrc = toInvokeSource$1(invokeDefinition.src);
  var serviceCreator = (_a = machine === null || machine === void 0 ? void 0 : machine.options.services) === null || _a === void 0 ? void 0 : _a[invokeSrc.type];
  var resolvedData = invokeDefinition.data ? mapContext(invokeDefinition.data, context, _event) : undefined;
  var tempActor = serviceCreator ? createDeferredActor(serviceCreator, invokeDefinition.id, resolvedData) : createNullActor(invokeDefinition.id); // @ts-ignore

  tempActor.meta = invokeDefinition;
  return tempActor;
}

function createDeferredActor(entity, id, data) {
  var tempActor = createNullActor(id); // @ts-ignore

  tempActor.deferred = true;

  if (isMachine(entity)) {
    // "mute" the existing service scope so potential spawned actors within the `.initialState` stay deferred here
    var initialState_1 = tempActor.state = provide(undefined, function () {
      return (data ? entity.withContext(data) : entity).initialState;
    });

    tempActor.getSnapshot = function () {
      return initialState_1;
    };
  }

  return tempActor;
}

function isActor(item) {
  try {
    return typeof item.send === 'function';
  } catch (e) {
    return false;
  }
}

function isSpawnedActor(item) {
  return isActor(item) && 'id' in item;
} // TODO: refactor the return type, this could be written in a better way but it's best to avoid unneccessary breaking changes now


function toActorRef(actorRefLike) {
  var _a;

  return _assign$((_a = {
    subscribe: function subscribe() {
      return {
        unsubscribe: function unsubscribe() {
          return void 0;
        }
      };
    },
    id: 'anonymous',
    getSnapshot: function getSnapshot() {
      return undefined;
    }
  }, _a[symbolObservable] = function () {
    return this;
  }, _a), actorRefLike);
}

var isLeafNode = function isLeafNode(stateNode) {
  return stateNode.type === 'atomic' || stateNode.type === 'final';
};

function getChildren(stateNode) {
  return Object.keys(stateNode.states).map(function (key) {
    return stateNode.states[key];
  });
}

function getAllStateNodes(stateNode) {
  var stateNodes = [stateNode];

  if (isLeafNode(stateNode)) {
    return stateNodes;
  }

  return stateNodes.concat(flatten(getChildren(stateNode).map(getAllStateNodes)));
}

function getConfiguration(prevStateNodes, stateNodes) {
  var e_1, _a, e_2, _b, e_3, _c, e_4, _d;

  var prevConfiguration = new Set(prevStateNodes);
  var prevAdjList = getAdjList(prevConfiguration);
  var configuration = new Set(stateNodes);

  try {
    // add all ancestors
    for (var configuration_1 = __values$1(configuration), configuration_1_1 = configuration_1.next(); !configuration_1_1.done; configuration_1_1 = configuration_1.next()) {
      var s = configuration_1_1.value;
      var m = s.parent;

      while (m && !configuration.has(m)) {
        configuration.add(m);
        m = m.parent;
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (configuration_1_1 && !configuration_1_1.done && (_a = configuration_1.return)) _a.call(configuration_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  var adjList = getAdjList(configuration);

  try {
    // add descendants
    for (var configuration_2 = __values$1(configuration), configuration_2_1 = configuration_2.next(); !configuration_2_1.done; configuration_2_1 = configuration_2.next()) {
      var s = configuration_2_1.value; // if previously active, add existing child nodes

      if (s.type === 'compound' && (!adjList.get(s) || !adjList.get(s).length)) {
        if (prevAdjList.get(s)) {
          prevAdjList.get(s).forEach(function (sn) {
            return configuration.add(sn);
          });
        } else {
          s.initialStateNodes.forEach(function (sn) {
            return configuration.add(sn);
          });
        }
      } else {
        if (s.type === 'parallel') {
          try {
            for (var _e = (e_3 = void 0, __values$1(getChildren(s))), _f = _e.next(); !_f.done; _f = _e.next()) {
              var child = _f.value;

              if (child.type === 'history') {
                continue;
              }

              if (!configuration.has(child)) {
                configuration.add(child);

                if (prevAdjList.get(child)) {
                  prevAdjList.get(child).forEach(function (sn) {
                    return configuration.add(sn);
                  });
                } else {
                  child.initialStateNodes.forEach(function (sn) {
                    return configuration.add(sn);
                  });
                }
              }
            }
          } catch (e_3_1) {
            e_3 = {
              error: e_3_1
            };
          } finally {
            try {
              if (_f && !_f.done && (_c = _e.return)) _c.call(_e);
            } finally {
              if (e_3) throw e_3.error;
            }
          }
        }
      }
    }
  } catch (e_2_1) {
    e_2 = {
      error: e_2_1
    };
  } finally {
    try {
      if (configuration_2_1 && !configuration_2_1.done && (_b = configuration_2.return)) _b.call(configuration_2);
    } finally {
      if (e_2) throw e_2.error;
    }
  }

  try {
    // add all ancestors
    for (var configuration_3 = __values$1(configuration), configuration_3_1 = configuration_3.next(); !configuration_3_1.done; configuration_3_1 = configuration_3.next()) {
      var s = configuration_3_1.value;
      var m = s.parent;

      while (m && !configuration.has(m)) {
        configuration.add(m);
        m = m.parent;
      }
    }
  } catch (e_4_1) {
    e_4 = {
      error: e_4_1
    };
  } finally {
    try {
      if (configuration_3_1 && !configuration_3_1.done && (_d = configuration_3.return)) _d.call(configuration_3);
    } finally {
      if (e_4) throw e_4.error;
    }
  }

  return configuration;
}

function getValueFromAdj(baseNode, adjList) {
  var childStateNodes = adjList.get(baseNode);

  if (!childStateNodes) {
    return {}; // todo: fix?
  }

  if (baseNode.type === 'compound') {
    var childStateNode = childStateNodes[0];

    if (childStateNode) {
      if (isLeafNode(childStateNode)) {
        return childStateNode.key;
      }
    } else {
      return {};
    }
  }

  var stateValue = {};
  childStateNodes.forEach(function (csn) {
    stateValue[csn.key] = getValueFromAdj(csn, adjList);
  });
  return stateValue;
}

function getAdjList(configuration) {
  var e_5, _a;

  var adjList = new Map();

  try {
    for (var configuration_4 = __values$1(configuration), configuration_4_1 = configuration_4.next(); !configuration_4_1.done; configuration_4_1 = configuration_4.next()) {
      var s = configuration_4_1.value;

      if (!adjList.has(s)) {
        adjList.set(s, []);
      }

      if (s.parent) {
        if (!adjList.has(s.parent)) {
          adjList.set(s.parent, []);
        }

        adjList.get(s.parent).push(s);
      }
    }
  } catch (e_5_1) {
    e_5 = {
      error: e_5_1
    };
  } finally {
    try {
      if (configuration_4_1 && !configuration_4_1.done && (_a = configuration_4.return)) _a.call(configuration_4);
    } finally {
      if (e_5) throw e_5.error;
    }
  }

  return adjList;
}

function getValue$1(rootNode, configuration) {
  var config = getConfiguration([rootNode], configuration);
  return getValueFromAdj(rootNode, getAdjList(config));
}

function has(iterable, item) {
  if (Array.isArray(iterable)) {
    return iterable.some(function (member) {
      return member === item;
    });
  }

  if (iterable instanceof Set) {
    return iterable.has(item);
  }

  return false; // TODO: fix
}

function nextEvents(configuration) {
  return __spreadArray$2([], __read$4(new Set(flatten(__spreadArray$2([], __read$4(configuration.map(function (sn) {
    return sn.ownEvents;
  })), false)))), false);
}

function isInFinalState(configuration, stateNode) {
  if (stateNode.type === 'compound') {
    return getChildren(stateNode).some(function (s) {
      return s.type === 'final' && has(configuration, s);
    });
  }

  if (stateNode.type === 'parallel') {
    return getChildren(stateNode).every(function (sn) {
      return isInFinalState(configuration, sn);
    });
  }

  return false;
}

function getMeta(configuration) {
  if (configuration === void 0) {
    configuration = [];
  }

  return configuration.reduce(function (acc, stateNode) {
    if (stateNode.meta !== undefined) {
      acc[stateNode.id] = stateNode.meta;
    }

    return acc;
  }, {});
}

function getTagsFromConfiguration(configuration) {
  return new Set(flatten(configuration.map(function (sn) {
    return sn.tags;
  })));
}

function stateValuesEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (a === undefined || b === undefined) {
    return false;
  }

  if (isString$3(a) || isString$3(b)) {
    return a === b;
  }

  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  return aKeys.length === bKeys.length && aKeys.every(function (key) {
    return stateValuesEqual(a[key], b[key]);
  });
}

function isStateConfig(state) {
  if (typeof state !== 'object' || state === null) {
    return false;
  }

  return 'value' in state && '_event' in state;
}

function bindActionToState(action, state) {
  var exec = action.exec;

  var boundAction = _assign$(_assign$({}, action), {
    exec: exec !== undefined ? function () {
      return exec(state.context, state.event, {
        action: action,
        state: state,
        _event: state._event
      });
    } : undefined
  });

  return boundAction;
}

var State =
/*#__PURE__*/

/** @class */
function () {
  /**
   * Creates a new State instance.
   * @param value The state value
   * @param context The extended state
   * @param historyValue The tree representing historical values of the state nodes
   * @param history The previous state
   * @param actions An array of action objects to execute as side-effects
   * @param activities A mapping of activities and whether they are started (`true`) or stopped (`false`).
   * @param meta
   * @param events Internal event queue. Should be empty with run-to-completion semantics.
   * @param configuration
   */
  function State(config) {
    var _this = this;

    var _a;

    this.actions = [];
    this.activities = EMPTY_ACTIVITY_MAP;
    this.meta = {};
    this.events = [];
    this.value = config.value;
    this.context = config.context;
    this._event = config._event;
    this._sessionid = config._sessionid;
    this.event = this._event.data;
    this.historyValue = config.historyValue;
    this.history = config.history;
    this.actions = config.actions || [];
    this.activities = config.activities || EMPTY_ACTIVITY_MAP;
    this.meta = getMeta(config.configuration);
    this.events = config.events || [];
    this.matches = this.matches.bind(this);
    this.toStrings = this.toStrings.bind(this);
    this.configuration = config.configuration;
    this.transitions = config.transitions;
    this.children = config.children;
    this.done = !!config.done;
    this.tags = (_a = Array.isArray(config.tags) ? new Set(config.tags) : config.tags) !== null && _a !== void 0 ? _a : new Set();
    this.machine = config.machine;
    Object.defineProperty(this, 'nextEvents', {
      get: function get() {
        return nextEvents(_this.configuration);
      }
    });
  }
  /**
   * Creates a new State instance for the given `stateValue` and `context`.
   * @param stateValue
   * @param context
   */


  State.from = function (stateValue, context) {
    if (stateValue instanceof State) {
      if (stateValue.context !== context) {
        return new State({
          value: stateValue.value,
          context: context,
          _event: stateValue._event,
          _sessionid: null,
          historyValue: stateValue.historyValue,
          history: stateValue.history,
          actions: [],
          activities: stateValue.activities,
          meta: {},
          events: [],
          configuration: [],
          transitions: [],
          children: {}
        });
      }

      return stateValue;
    }

    var _event = initEvent;
    return new State({
      value: stateValue,
      context: context,
      _event: _event,
      _sessionid: null,
      historyValue: undefined,
      history: undefined,
      actions: [],
      activities: undefined,
      meta: undefined,
      events: [],
      configuration: [],
      transitions: [],
      children: {}
    });
  };
  /**
   * Creates a new State instance for the given `config`.
   * @param config The state config
   */


  State.create = function (config) {
    return new State(config);
  };
  /**
   * Creates a new `State` instance for the given `stateValue` and `context` with no actions (side-effects).
   * @param stateValue
   * @param context
   */


  State.inert = function (stateValue, context) {
    if (stateValue instanceof State) {
      if (!stateValue.actions.length) {
        return stateValue;
      }

      var _event = initEvent;
      return new State({
        value: stateValue.value,
        context: context,
        _event: _event,
        _sessionid: null,
        historyValue: stateValue.historyValue,
        history: stateValue.history,
        activities: stateValue.activities,
        configuration: stateValue.configuration,
        transitions: [],
        children: {}
      });
    }

    return State.from(stateValue, context);
  };
  /**
   * Returns an array of all the string leaf state node paths.
   * @param stateValue
   * @param delimiter The character(s) that separate each subpath in the string state node path.
   */


  State.prototype.toStrings = function (stateValue, delimiter) {
    var _this = this;

    if (stateValue === void 0) {
      stateValue = this.value;
    }

    if (delimiter === void 0) {
      delimiter = '.';
    }

    if (isString$3(stateValue)) {
      return [stateValue];
    }

    var valueKeys = Object.keys(stateValue);
    return valueKeys.concat.apply(valueKeys, __spreadArray$2([], __read$4(valueKeys.map(function (key) {
      return _this.toStrings(stateValue[key], delimiter).map(function (s) {
        return key + delimiter + s;
      });
    })), false));
  };

  State.prototype.toJSON = function () {
    var _a = this;

    _a.configuration;
    _a.transitions;
    var tags = _a.tags;
    _a.machine;

    var jsonValues = __rest$6(_a, ["configuration", "transitions", "tags", "machine"]);

    return _assign$(_assign$({}, jsonValues), {
      tags: Array.from(tags)
    });
  };

  State.prototype.matches = function (parentStateValue) {
    return matchesState(parentStateValue, this.value);
  };
  /**
   * Whether the current state configuration has a state node with the specified `tag`.
   * @param tag
   */


  State.prototype.hasTag = function (tag) {
    return this.tags.has(tag);
  };
  /**
   * Determines whether sending the `event` will cause a non-forbidden transition
   * to be selected, even if the transitions have no actions nor
   * change the state value.
   *
   * @param event The event to test
   * @returns Whether the event will cause a transition
   */


  State.prototype.can = function (event) {
    var _a;

    if (IS_PRODUCTION) {
      warn(!!this.machine, "state.can(...) used outside of a machine-created State object; this will always return false.");
    }

    var transitionData = (_a = this.machine) === null || _a === void 0 ? void 0 : _a.getTransitionData(this, event);
    return !!(transitionData === null || transitionData === void 0 ? void 0 : transitionData.transitions.length) && // Check that at least one transition is not forbidden
    transitionData.transitions.some(function (t) {
      return t.target !== undefined || t.actions.length;
    });
  };

  return State;
}();

var defaultOptions$2 = {
  deferEvents: false
};

var Scheduler =
/*#__PURE__*/

/** @class */
function () {
  function Scheduler(options) {
    this.processingEvent = false;
    this.queue = [];
    this.initialized = false;
    this.options = _assign$(_assign$({}, defaultOptions$2), options);
  }

  Scheduler.prototype.initialize = function (callback) {
    this.initialized = true;

    if (callback) {
      if (!this.options.deferEvents) {
        this.schedule(callback);
        return;
      }

      this.process(callback);
    }

    this.flushEvents();
  };

  Scheduler.prototype.schedule = function (task) {
    if (!this.initialized || this.processingEvent) {
      this.queue.push(task);
      return;
    }

    if (this.queue.length !== 0) {
      throw new Error('Event queue should be empty when it is not processing events');
    }

    this.process(task);
    this.flushEvents();
  };

  Scheduler.prototype.clear = function () {
    this.queue = [];
  };

  Scheduler.prototype.flushEvents = function () {
    var nextCallback = this.queue.shift();

    while (nextCallback) {
      this.process(nextCallback);
      nextCallback = this.queue.shift();
    }
  };

  Scheduler.prototype.process = function (callback) {
    this.processingEvent = true;

    try {
      callback();
    } catch (e) {
      // there is no use to keep the future events
      // as the situation is not anymore the same
      this.clear();
      throw e;
    } finally {
      this.processingEvent = false;
    }
  };

  return Scheduler;
}();

var children = /*#__PURE__*/new Map();
var sessionIdIndex = 0;
var registry = {
  bookId: function bookId() {
    return "x:".concat(sessionIdIndex++);
  },
  register: function register(id, actor) {
    children.set(id, actor);
    return id;
  },
  get: function get(id) {
    return children.get(id);
  },
  free: function free(id) {
    children.delete(id);
  }
};

function getGlobal() {
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  }

  if (typeof self !== 'undefined') {
    return self;
  }

  if (typeof window !== 'undefined') {
    return window;
  }

  if (typeof global$2 !== 'undefined') {
    return global$2;
  }

  if (!IS_PRODUCTION) {
    console.warn('XState could not find a global object in this environment. Please let the maintainers know and raise an issue here: https://github.com/statelyai/xstate/issues');
  }
}

function getDevTools() {
  var global = getGlobal();

  if (global && '__xstate__' in global) {
    return global.__xstate__;
  }

  return undefined;
}

function registerService(service) {
  if (!getGlobal()) {
    return;
  }

  var devTools = getDevTools();

  if (devTools) {
    devTools.register(service);
  }
}

function spawnBehavior(behavior, options) {
  if (options === void 0) {
    options = {};
  }

  var state = behavior.initialState;
  var observers = new Set();
  var mailbox = [];
  var flushing = false;

  var flush = function flush() {
    if (flushing) {
      return;
    }

    flushing = true;

    while (mailbox.length > 0) {
      var event_1 = mailbox.shift();
      state = behavior.transition(state, event_1, actorCtx);
      observers.forEach(function (observer) {
        return observer.next(state);
      });
    }

    flushing = false;
  };

  var actor = toActorRef({
    id: options.id,
    send: function send(event) {
      mailbox.push(event);
      flush();
    },
    getSnapshot: function getSnapshot() {
      return state;
    },
    subscribe: function subscribe(next, handleError, complete) {
      var observer = toObserver$1(next, handleError, complete);
      observers.add(observer);
      observer.next(state);
      return {
        unsubscribe: function unsubscribe() {
          observers.delete(observer);
        }
      };
    }
  });
  var actorCtx = {
    parent: options.parent,
    self: actor,
    id: options.id || 'anonymous',
    observers: observers
  };
  state = behavior.start ? behavior.start(actorCtx) : state;
  return actor;
}

var DEFAULT_SPAWN_OPTIONS = {
  sync: false,
  autoForward: false
};
var InterpreterStatus;

(function (InterpreterStatus) {
  InterpreterStatus[InterpreterStatus["NotStarted"] = 0] = "NotStarted";
  InterpreterStatus[InterpreterStatus["Running"] = 1] = "Running";
  InterpreterStatus[InterpreterStatus["Stopped"] = 2] = "Stopped";
})(InterpreterStatus || (InterpreterStatus = {}));

var Interpreter =
/*#__PURE__*/

/** @class */
function () {
  /**
   * Creates a new Interpreter instance (i.e., service) for the given machine with the provided options, if any.
   *
   * @param machine The machine to be interpreted
   * @param options Interpreter options
   */
  function Interpreter(machine, options) {
    var _this = this;

    if (options === void 0) {
      options = Interpreter.defaultOptions;
    }

    this.machine = machine;
    this.scheduler = new Scheduler();
    this.delayedEventsMap = {};
    this.listeners = new Set();
    this.contextListeners = new Set();
    this.stopListeners = new Set();
    this.doneListeners = new Set();
    this.eventListeners = new Set();
    this.sendListeners = new Set();
    /**
     * Whether the service is started.
     */

    this.initialized = false;
    this.status = InterpreterStatus.NotStarted;
    this.children = new Map();
    this.forwardTo = new Set();
    /**
     * Alias for Interpreter.prototype.start
     */

    this.init = this.start;
    /**
     * Sends an event to the running interpreter to trigger a transition.
     *
     * An array of events (batched) can be sent as well, which will send all
     * batched events to the running interpreter. The listeners will be
     * notified only **once** when all events are processed.
     *
     * @param event The event(s) to send
     */

    this.send = function (event, payload) {
      if (isArray$4(event)) {
        _this.batch(event);

        return _this.state;
      }

      var _event = toSCXMLEvent(toEventObject(event, payload));

      if (_this.status === InterpreterStatus.Stopped) {
        // do nothing
        if (!IS_PRODUCTION) {
          warn(false, "Event \"".concat(_event.name, "\" was sent to stopped service \"").concat(_this.machine.id, "\". This service has already reached its final state, and will not transition.\nEvent: ").concat(JSON.stringify(_event.data)));
        }

        return _this.state;
      }

      if (_this.status !== InterpreterStatus.Running && !_this.options.deferEvents) {
        throw new Error("Event \"".concat(_event.name, "\" was sent to uninitialized service \"").concat(_this.machine.id // tslint:disable-next-line:max-line-length
        , "\". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.\nEvent: ").concat(JSON.stringify(_event.data)));
      }

      _this.scheduler.schedule(function () {
        // Forward copy of event to child actors
        _this.forward(_event);

        var nextState = _this.nextState(_event);

        _this.update(nextState, _event);
      });

      return _this._state; // TODO: deprecate (should return void)
      // tslint:disable-next-line:semicolon
    };

    this.sendTo = function (event, to) {
      var isParent = _this.parent && (to === SpecialTargets.Parent || _this.parent.id === to);
      var target = isParent ? _this.parent : isString$3(to) ? _this.children.get(to) || registry.get(to) : isActor$1(to) ? to : undefined;

      if (!target) {
        if (!isParent) {
          throw new Error("Unable to send event to child '".concat(to, "' from service '").concat(_this.id, "'."));
        } // tslint:disable-next-line:no-console


        if (!IS_PRODUCTION) {
          warn(false, "Service '".concat(_this.id, "' has no parent: unable to send event ").concat(event.type));
        }

        return;
      }

      if ('machine' in target) {
        // Send SCXML events to machines
        target.send(_assign$(_assign$({}, event), {
          name: event.name === error$2 ? "".concat(error$1(_this.id)) : event.name,
          origin: _this.sessionId
        }));
      } else {
        // Send normal events to other targets
        target.send(event.data);
      }
    };

    var resolvedOptions = _assign$(_assign$({}, Interpreter.defaultOptions), options);

    var clock = resolvedOptions.clock,
        logger = resolvedOptions.logger,
        parent = resolvedOptions.parent,
        id = resolvedOptions.id;
    var resolvedId = id !== undefined ? id : machine.id;
    this.id = resolvedId;
    this.logger = logger;
    this.clock = clock;
    this.parent = parent;
    this.options = resolvedOptions;
    this.scheduler = new Scheduler({
      deferEvents: this.options.deferEvents
    });
    this.sessionId = registry.bookId();
  }

  Object.defineProperty(Interpreter.prototype, "initialState", {
    get: function get() {
      var _this = this;

      if (this._initialState) {
        return this._initialState;
      }

      return provide(this, function () {
        _this._initialState = _this.machine.initialState;
        return _this._initialState;
      });
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Interpreter.prototype, "state", {
    get: function get() {
      if (!IS_PRODUCTION) {
        warn(this.status !== InterpreterStatus.NotStarted, "Attempted to read state from uninitialized service '".concat(this.id, "'. Make sure the service is started first."));
      }

      return this._state;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Executes the actions of the given state, with that state's `context` and `event`.
   *
   * @param state The state whose actions will be executed
   * @param actionsConfig The action implementations to use
   */

  Interpreter.prototype.execute = function (state, actionsConfig) {
    var e_1, _a;

    try {
      for (var _b = __values$1(state.actions), _c = _b.next(); !_c.done; _c = _b.next()) {
        var action = _c.value;
        this.exec(action, state, actionsConfig);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  };

  Interpreter.prototype.update = function (state, _event) {
    var e_2, _a, e_3, _b, e_4, _c, e_5, _d;

    var _this = this; // Attach session ID to state


    state._sessionid = this.sessionId; // Update state

    this._state = state; // Execute actions

    if (this.options.execute) {
      this.execute(this.state);
    } // Update children


    this.children.forEach(function (child) {
      _this.state.children[child.id] = child;
    }); // Dev tools

    if (this.devTools) {
      this.devTools.send(_event.data, state);
    } // Execute listeners


    if (state.event) {
      try {
        for (var _e = __values$1(this.eventListeners), _f = _e.next(); !_f.done; _f = _e.next()) {
          var listener = _f.value;
          listener(state.event);
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
    }

    try {
      for (var _g = __values$1(this.listeners), _h = _g.next(); !_h.done; _h = _g.next()) {
        var listener = _h.value;
        listener(state, state.event);
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
      } finally {
        if (e_3) throw e_3.error;
      }
    }

    try {
      for (var _j = __values$1(this.contextListeners), _k = _j.next(); !_k.done; _k = _j.next()) {
        var contextListener = _k.value;
        contextListener(this.state.context, this.state.history ? this.state.history.context : undefined);
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
      } finally {
        if (e_4) throw e_4.error;
      }
    }

    var isDone = isInFinalState(state.configuration || [], this.machine);

    if (this.state.configuration && isDone) {
      // get final child state node
      var finalChildStateNode = state.configuration.find(function (sn) {
        return sn.type === 'final' && sn.parent === _this.machine;
      });
      var doneData = finalChildStateNode && finalChildStateNode.doneData ? mapContext(finalChildStateNode.doneData, state.context, _event) : undefined;

      try {
        for (var _l = __values$1(this.doneListeners), _m = _l.next(); !_m.done; _m = _l.next()) {
          var listener = _m.value;
          listener(doneInvoke(this.id, doneData));
        }
      } catch (e_5_1) {
        e_5 = {
          error: e_5_1
        };
      } finally {
        try {
          if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
        } finally {
          if (e_5) throw e_5.error;
        }
      }

      this.stop();
    }
  };
  /*
   * Adds a listener that is notified whenever a state transition happens. The listener is called with
   * the next state and the event object that caused the state transition.
   *
   * @param listener The state listener
   */


  Interpreter.prototype.onTransition = function (listener) {
    this.listeners.add(listener); // Send current state to listener

    if (this.status === InterpreterStatus.Running) {
      listener(this.state, this.state.event);
    }

    return this;
  };

  Interpreter.prototype.subscribe = function (nextListenerOrObserver, _, // TODO: error listener
  completeListener) {
    var _this = this;

    if (!nextListenerOrObserver) {
      return {
        unsubscribe: function unsubscribe() {
          return void 0;
        }
      };
    }

    var listener;
    var resolvedCompleteListener = completeListener;

    if (typeof nextListenerOrObserver === 'function') {
      listener = nextListenerOrObserver;
    } else {
      listener = nextListenerOrObserver.next.bind(nextListenerOrObserver);
      resolvedCompleteListener = nextListenerOrObserver.complete.bind(nextListenerOrObserver);
    }

    this.listeners.add(listener); // Send current state to listener

    if (this.status === InterpreterStatus.Running) {
      listener(this.state);
    }

    if (resolvedCompleteListener) {
      this.onDone(resolvedCompleteListener);
    }

    return {
      unsubscribe: function unsubscribe() {
        listener && _this.listeners.delete(listener);
        resolvedCompleteListener && _this.doneListeners.delete(resolvedCompleteListener);
      }
    };
  };
  /**
   * Adds an event listener that is notified whenever an event is sent to the running interpreter.
   * @param listener The event listener
   */


  Interpreter.prototype.onEvent = function (listener) {
    this.eventListeners.add(listener);
    return this;
  };
  /**
   * Adds an event listener that is notified whenever a `send` event occurs.
   * @param listener The event listener
   */


  Interpreter.prototype.onSend = function (listener) {
    this.sendListeners.add(listener);
    return this;
  };
  /**
   * Adds a context listener that is notified whenever the state context changes.
   * @param listener The context listener
   */


  Interpreter.prototype.onChange = function (listener) {
    this.contextListeners.add(listener);
    return this;
  };
  /**
   * Adds a listener that is notified when the machine is stopped.
   * @param listener The listener
   */


  Interpreter.prototype.onStop = function (listener) {
    this.stopListeners.add(listener);
    return this;
  };
  /**
   * Adds a state listener that is notified when the statechart has reached its final state.
   * @param listener The state listener
   */


  Interpreter.prototype.onDone = function (listener) {
    this.doneListeners.add(listener);
    return this;
  };
  /**
   * Removes a listener.
   * @param listener The listener to remove
   */


  Interpreter.prototype.off = function (listener) {
    this.listeners.delete(listener);
    this.eventListeners.delete(listener);
    this.sendListeners.delete(listener);
    this.stopListeners.delete(listener);
    this.doneListeners.delete(listener);
    this.contextListeners.delete(listener);
    return this;
  };
  /**
   * Starts the interpreter from the given state, or the initial state.
   * @param initialState The state to start the statechart from
   */


  Interpreter.prototype.start = function (initialState) {
    var _this = this;

    if (this.status === InterpreterStatus.Running) {
      // Do not restart the service if it is already started
      return this;
    } // yes, it's a hack but we need the related cache to be populated for some things to work (like delayed transitions)
    // this is usually called by `machine.getInitialState` but if we rehydrate from a state we might bypass this call
    // we also don't want to call this method here as it resolves the full initial state which might involve calling assign actions
    // and that could potentially lead to some unwanted side-effects (even such as creating some rogue actors)


    this.machine._init();

    registry.register(this.sessionId, this);
    this.initialized = true;
    this.status = InterpreterStatus.Running;
    var resolvedState = initialState === undefined ? this.initialState : provide(this, function () {
      return isStateConfig(initialState) ? _this.machine.resolveState(initialState) : _this.machine.resolveState(State.from(initialState, _this.machine.context));
    });

    if (this.options.devTools) {
      this.attachDev();
    }

    this.scheduler.initialize(function () {
      _this.update(resolvedState, initEvent);
    });
    return this;
  };
  /**
   * Stops the interpreter and unsubscribe all listeners.
   *
   * This will also notify the `onStop` listeners.
   */


  Interpreter.prototype.stop = function () {
    var e_6, _a, e_7, _b, e_8, _c, e_9, _d, e_10, _e;

    var _this = this;

    try {
      for (var _f = __values$1(this.listeners), _g = _f.next(); !_g.done; _g = _f.next()) {
        var listener = _g.value;
        this.listeners.delete(listener);
      }
    } catch (e_6_1) {
      e_6 = {
        error: e_6_1
      };
    } finally {
      try {
        if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
      } finally {
        if (e_6) throw e_6.error;
      }
    }

    try {
      for (var _h = __values$1(this.stopListeners), _j = _h.next(); !_j.done; _j = _h.next()) {
        var listener = _j.value; // call listener, then remove

        listener();
        this.stopListeners.delete(listener);
      }
    } catch (e_7_1) {
      e_7 = {
        error: e_7_1
      };
    } finally {
      try {
        if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
      } finally {
        if (e_7) throw e_7.error;
      }
    }

    try {
      for (var _k = __values$1(this.contextListeners), _l = _k.next(); !_l.done; _l = _k.next()) {
        var listener = _l.value;
        this.contextListeners.delete(listener);
      }
    } catch (e_8_1) {
      e_8 = {
        error: e_8_1
      };
    } finally {
      try {
        if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
      } finally {
        if (e_8) throw e_8.error;
      }
    }

    try {
      for (var _m = __values$1(this.doneListeners), _o = _m.next(); !_o.done; _o = _m.next()) {
        var listener = _o.value;
        this.doneListeners.delete(listener);
      }
    } catch (e_9_1) {
      e_9 = {
        error: e_9_1
      };
    } finally {
      try {
        if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
      } finally {
        if (e_9) throw e_9.error;
      }
    }

    if (!this.initialized) {
      // Interpreter already stopped; do nothing
      return this;
    }

    __spreadArray$2([], __read$4(this.state.configuration), false).sort(function (a, b) {
      return b.order - a.order;
    }).forEach(function (stateNode) {
      var e_11, _a;

      try {
        for (var _b = __values$1(stateNode.definition.exit), _c = _b.next(); !_c.done; _c = _b.next()) {
          var action = _c.value;

          _this.exec(action, _this.state);
        }
      } catch (e_11_1) {
        e_11 = {
          error: e_11_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_11) throw e_11.error;
        }
      }
    }); // Stop all children


    this.children.forEach(function (child) {
      if (isFunction$3(child.stop)) {
        child.stop();
      }
    });

    try {
      // Cancel all delayed events
      for (var _p = __values$1(Object.keys(this.delayedEventsMap)), _q = _p.next(); !_q.done; _q = _p.next()) {
        var key = _q.value;
        this.clock.clearTimeout(this.delayedEventsMap[key]);
      }
    } catch (e_10_1) {
      e_10 = {
        error: e_10_1
      };
    } finally {
      try {
        if (_q && !_q.done && (_e = _p.return)) _e.call(_p);
      } finally {
        if (e_10) throw e_10.error;
      }
    }

    this.scheduler.clear();
    this.initialized = false;
    this.status = InterpreterStatus.Stopped;
    registry.free(this.sessionId);
    return this;
  };

  Interpreter.prototype.batch = function (events) {
    var _this = this;

    if (this.status === InterpreterStatus.NotStarted && this.options.deferEvents) {
      // tslint:disable-next-line:no-console
      if (!IS_PRODUCTION) {
        warn(false, "".concat(events.length, " event(s) were sent to uninitialized service \"").concat(this.machine.id, "\" and are deferred. Make sure .start() is called for this service.\nEvent: ").concat(JSON.stringify(event)));
      }
    } else if (this.status !== InterpreterStatus.Running) {
      throw new Error( // tslint:disable-next-line:max-line-length
      "".concat(events.length, " event(s) were sent to uninitialized service \"").concat(this.machine.id, "\". Make sure .start() is called for this service, or set { deferEvents: true } in the service options."));
    }

    this.scheduler.schedule(function () {
      var e_12, _a;

      var nextState = _this.state;
      var batchChanged = false;
      var batchedActions = [];

      var _loop_1 = function _loop_1(event_1) {
        var _event = toSCXMLEvent(event_1);

        _this.forward(_event);

        nextState = provide(_this, function () {
          return _this.machine.transition(nextState, _event);
        });
        batchedActions.push.apply(batchedActions, __spreadArray$2([], __read$4(nextState.actions.map(function (a) {
          return bindActionToState(a, nextState);
        })), false));
        batchChanged = batchChanged || !!nextState.changed;
      };

      try {
        for (var events_1 = __values$1(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()) {
          var event_1 = events_1_1.value;

          _loop_1(event_1);
        }
      } catch (e_12_1) {
        e_12 = {
          error: e_12_1
        };
      } finally {
        try {
          if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
        } finally {
          if (e_12) throw e_12.error;
        }
      }

      nextState.changed = batchChanged;
      nextState.actions = batchedActions;

      _this.update(nextState, toSCXMLEvent(events[events.length - 1]));
    });
  };
  /**
   * Returns a send function bound to this interpreter instance.
   *
   * @param event The event to be sent by the sender.
   */


  Interpreter.prototype.sender = function (event) {
    return this.send.bind(this, event);
  };
  /**
   * Returns the next state given the interpreter's current state and the event.
   *
   * This is a pure method that does _not_ update the interpreter's state.
   *
   * @param event The event to determine the next state
   */


  Interpreter.prototype.nextState = function (event) {
    var _this = this;

    var _event = toSCXMLEvent(event);

    if (_event.name.indexOf(errorPlatform) === 0 && !this.state.nextEvents.some(function (nextEvent) {
      return nextEvent.indexOf(errorPlatform) === 0;
    })) {
      throw _event.data.data;
    }

    var nextState = provide(this, function () {
      return _this.machine.transition(_this.state, _event);
    });
    return nextState;
  };

  Interpreter.prototype.forward = function (event) {
    var e_13, _a;

    try {
      for (var _b = __values$1(this.forwardTo), _c = _b.next(); !_c.done; _c = _b.next()) {
        var id = _c.value;
        var child = this.children.get(id);

        if (!child) {
          throw new Error("Unable to forward event '".concat(event, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(id, "'."));
        }

        child.send(event);
      }
    } catch (e_13_1) {
      e_13 = {
        error: e_13_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_13) throw e_13.error;
      }
    }
  };

  Interpreter.prototype.defer = function (sendAction) {
    var _this = this;

    this.delayedEventsMap[sendAction.id] = this.clock.setTimeout(function () {
      if (sendAction.to) {
        _this.sendTo(sendAction._event, sendAction.to);
      } else {
        _this.send(sendAction._event);
      }
    }, sendAction.delay);
  };

  Interpreter.prototype.cancel = function (sendId) {
    this.clock.clearTimeout(this.delayedEventsMap[sendId]);
    delete this.delayedEventsMap[sendId];
  };

  Interpreter.prototype.exec = function (action, state, actionFunctionMap) {
    if (actionFunctionMap === void 0) {
      actionFunctionMap = this.machine.options.actions;
    }

    var context = state.context,
        _event = state._event;
    var actionOrExec = action.exec || getActionFunction(action.type, actionFunctionMap);
    var exec = isFunction$3(actionOrExec) ? actionOrExec : actionOrExec ? actionOrExec.exec : action.exec;

    if (exec) {
      try {
        return exec(context, _event.data, {
          action: action,
          state: this.state,
          _event: _event
        });
      } catch (err) {
        if (this.parent) {
          this.parent.send({
            type: 'xstate.error',
            data: err
          });
        }

        throw err;
      }
    }

    switch (action.type) {
      case send$1:
        var sendAction = action;

        if (typeof sendAction.delay === 'number') {
          this.defer(sendAction);
          return;
        } else {
          if (sendAction.to) {
            this.sendTo(sendAction._event, sendAction.to);
          } else {
            this.send(sendAction._event);
          }
        }

        break;

      case cancel$1:
        this.cancel(action.sendId);
        break;

      case start$1:
        {
          if (this.status !== InterpreterStatus.Running) {
            return;
          }

          var activity = action.activity; // If the activity will be stopped right after it's started
          // (such as in transient states)
          // don't bother starting the activity.

          if (!this.state.activities[activity.id || activity.type]) {
            break;
          } // Invoked services


          if (activity.type === ActionTypes.Invoke) {
            var invokeSource = toInvokeSource$1(activity.src);
            var serviceCreator = this.machine.options.services ? this.machine.options.services[invokeSource.type] : undefined;
            var id = activity.id,
                data = activity.data;

            if (!IS_PRODUCTION) {
              warn(!('forward' in activity), // tslint:disable-next-line:max-line-length
              "`forward` property is deprecated (found in invocation of '".concat(activity.src, "' in in machine '").concat(this.machine.id, "'). ") + "Please use `autoForward` instead.");
            }

            var autoForward = 'autoForward' in activity ? activity.autoForward : !!activity.forward;

            if (!serviceCreator) {
              // tslint:disable-next-line:no-console
              if (!IS_PRODUCTION) {
                warn(false, "No service found for invocation '".concat(activity.src, "' in machine '").concat(this.machine.id, "'."));
              }

              return;
            }

            var resolvedData = data ? mapContext(data, context, _event) : undefined;

            if (typeof serviceCreator === 'string') {
              // TODO: warn
              return;
            }

            var source = isFunction$3(serviceCreator) ? serviceCreator(context, _event.data, {
              data: resolvedData,
              src: invokeSource,
              meta: activity.meta
            }) : serviceCreator;

            if (!source) {
              // TODO: warn?
              return;
            }

            var options = void 0;

            if (isMachine(source)) {
              source = resolvedData ? source.withContext(resolvedData) : source;
              options = {
                autoForward: autoForward
              };
            }

            this.spawn(source, id, options);
          } else {
            this.spawnActivity(activity);
          }

          break;
        }

      case stop$1:
        {
          this.stopChild(action.activity.id);
          break;
        }

      case log:
        var label = action.label,
            value = action.value;

        if (label) {
          this.logger(label, value);
        } else {
          this.logger(value);
        }

        break;

      default:
        if (!IS_PRODUCTION) {
          warn(false, "No implementation found for action type '".concat(action.type, "'"));
        }

        break;
    }

    return undefined;
  };

  Interpreter.prototype.removeChild = function (childId) {
    var _a;

    this.children.delete(childId);
    this.forwardTo.delete(childId); // this.state might not exist at the time this is called,
    // such as when a child is added then removed while initializing the state

    (_a = this.state) === null || _a === void 0 ? true : delete _a.children[childId];
  };

  Interpreter.prototype.stopChild = function (childId) {
    var child = this.children.get(childId);

    if (!child) {
      return;
    }

    this.removeChild(childId);

    if (isFunction$3(child.stop)) {
      child.stop();
    }
  };

  Interpreter.prototype.spawn = function (entity, name, options) {
    if (isPromiseLike$1(entity)) {
      return this.spawnPromise(Promise.resolve(entity), name);
    } else if (isFunction$3(entity)) {
      return this.spawnCallback(entity, name);
    } else if (isSpawnedActor(entity)) {
      return this.spawnActor(entity, name);
    } else if (isObservable$1(entity)) {
      return this.spawnObservable(entity, name);
    } else if (isMachine(entity)) {
      return this.spawnMachine(entity, _assign$(_assign$({}, options), {
        id: name
      }));
    } else if (isBehavior(entity)) {
      return this.spawnBehavior(entity, name);
    } else {
      throw new Error("Unable to spawn entity \"".concat(name, "\" of type \"").concat(typeof entity, "\"."));
    }
  };

  Interpreter.prototype.spawnMachine = function (machine, options) {
    var _this = this;

    if (options === void 0) {
      options = {};
    }

    var childService = new Interpreter(machine, _assign$(_assign$({}, this.options), {
      parent: this,
      id: options.id || machine.id
    }));

    var resolvedOptions = _assign$(_assign$({}, DEFAULT_SPAWN_OPTIONS), options);

    if (resolvedOptions.sync) {
      childService.onTransition(function (state) {
        _this.send(update, {
          state: state,
          id: childService.id
        });
      });
    }

    var actor = childService;
    this.children.set(childService.id, actor);

    if (resolvedOptions.autoForward) {
      this.forwardTo.add(childService.id);
    }

    childService.onDone(function (doneEvent) {
      _this.removeChild(childService.id);

      _this.send(toSCXMLEvent(doneEvent, {
        origin: childService.id
      }));
    }).start();
    return actor;
  };

  Interpreter.prototype.spawnBehavior = function (behavior, id) {
    var actorRef = spawnBehavior(behavior, {
      id: id,
      parent: this
    });
    this.children.set(id, actorRef);
    return actorRef;
  };

  Interpreter.prototype.spawnPromise = function (promise, id) {
    var _a;

    var _this = this;

    var canceled = false;
    var resolvedData;
    promise.then(function (response) {
      if (!canceled) {
        resolvedData = response;

        _this.removeChild(id);

        _this.send(toSCXMLEvent(doneInvoke(id, response), {
          origin: id
        }));
      }
    }, function (errorData) {
      if (!canceled) {
        _this.removeChild(id);

        var errorEvent = error$1(id, errorData);

        try {
          // Send "error.platform.id" to this (parent).
          _this.send(toSCXMLEvent(errorEvent, {
            origin: id
          }));
        } catch (error) {
          reportUnhandledExceptionOnInvocation(errorData, error, id);

          if (_this.devTools) {
            _this.devTools.send(errorEvent, _this.state);
          }

          if (_this.machine.strict) {
            // it would be better to always stop the state machine if unhandled
            // exception/promise rejection happens but because we don't want to
            // break existing code so enforce it on strict mode only especially so
            // because documentation says that onError is optional
            _this.stop();
          }
        }
      }
    });
    var actor = (_a = {
      id: id,
      send: function send() {
        return void 0;
      },
      subscribe: function subscribe(next, handleError, complete) {
        var observer = toObserver$1(next, handleError, complete);
        var unsubscribed = false;
        promise.then(function (response) {
          if (unsubscribed) {
            return;
          }

          observer.next(response);

          if (unsubscribed) {
            return;
          }

          observer.complete();
        }, function (err) {
          if (unsubscribed) {
            return;
          }

          observer.error(err);
        });
        return {
          unsubscribe: function unsubscribe() {
            return unsubscribed = true;
          }
        };
      },
      stop: function stop() {
        canceled = true;
      },
      toJSON: function toJSON() {
        return {
          id: id
        };
      },
      getSnapshot: function getSnapshot() {
        return resolvedData;
      }
    }, _a[symbolObservable] = function () {
      return this;
    }, _a);
    this.children.set(id, actor);
    return actor;
  };

  Interpreter.prototype.spawnCallback = function (callback, id) {
    var _a;

    var _this = this;

    var canceled = false;
    var receivers = new Set();
    var listeners = new Set();
    var emitted;

    var receive = function receive(e) {
      emitted = e;
      listeners.forEach(function (listener) {
        return listener(e);
      });

      if (canceled) {
        return;
      }

      _this.send(toSCXMLEvent(e, {
        origin: id
      }));
    };

    var callbackStop;

    try {
      callbackStop = callback(receive, function (newListener) {
        receivers.add(newListener);
      });
    } catch (err) {
      this.send(error$1(id, err));
    }

    if (isPromiseLike$1(callbackStop)) {
      // it turned out to be an async function, can't reliably check this before calling `callback`
      // because transpiled async functions are not recognizable
      return this.spawnPromise(callbackStop, id);
    }

    var actor = (_a = {
      id: id,
      send: function send(event) {
        return receivers.forEach(function (receiver) {
          return receiver(event);
        });
      },
      subscribe: function subscribe(next) {
        var observer = toObserver$1(next);
        listeners.add(observer.next);
        return {
          unsubscribe: function unsubscribe() {
            listeners.delete(observer.next);
          }
        };
      },
      stop: function stop() {
        canceled = true;

        if (isFunction$3(callbackStop)) {
          callbackStop();
        }
      },
      toJSON: function toJSON() {
        return {
          id: id
        };
      },
      getSnapshot: function getSnapshot() {
        return emitted;
      }
    }, _a[symbolObservable] = function () {
      return this;
    }, _a);
    this.children.set(id, actor);
    return actor;
  };

  Interpreter.prototype.spawnObservable = function (source, id) {
    var _a;

    var _this = this;

    var emitted;
    var subscription = source.subscribe(function (value) {
      emitted = value;

      _this.send(toSCXMLEvent(value, {
        origin: id
      }));
    }, function (err) {
      _this.removeChild(id);

      _this.send(toSCXMLEvent(error$1(id, err), {
        origin: id
      }));
    }, function () {
      _this.removeChild(id);

      _this.send(toSCXMLEvent(doneInvoke(id), {
        origin: id
      }));
    });
    var actor = (_a = {
      id: id,
      send: function send() {
        return void 0;
      },
      subscribe: function subscribe(next, handleError, complete) {
        return source.subscribe(next, handleError, complete);
      },
      stop: function stop() {
        return subscription.unsubscribe();
      },
      getSnapshot: function getSnapshot() {
        return emitted;
      },
      toJSON: function toJSON() {
        return {
          id: id
        };
      }
    }, _a[symbolObservable] = function () {
      return this;
    }, _a);
    this.children.set(id, actor);
    return actor;
  };

  Interpreter.prototype.spawnActor = function (actor, name) {
    this.children.set(name, actor);
    return actor;
  };

  Interpreter.prototype.spawnActivity = function (activity) {
    var implementation = this.machine.options && this.machine.options.activities ? this.machine.options.activities[activity.type] : undefined;

    if (!implementation) {
      if (!IS_PRODUCTION) {
        warn(false, "No implementation found for activity '".concat(activity.type, "'"));
      } // tslint:disable-next-line:no-console


      return;
    } // Start implementation


    var dispose = implementation(this.state.context, activity);
    this.spawnEffect(activity.id, dispose);
  };

  Interpreter.prototype.spawnEffect = function (id, dispose) {
    var _a;

    this.children.set(id, (_a = {
      id: id,
      send: function send() {
        return void 0;
      },
      subscribe: function subscribe() {
        return {
          unsubscribe: function unsubscribe() {
            return void 0;
          }
        };
      },
      stop: dispose || undefined,
      getSnapshot: function getSnapshot() {
        return undefined;
      },
      toJSON: function toJSON() {
        return {
          id: id
        };
      }
    }, _a[symbolObservable] = function () {
      return this;
    }, _a));
  };

  Interpreter.prototype.attachDev = function () {
    var global = getGlobal();

    if (this.options.devTools && global) {
      if (global.__REDUX_DEVTOOLS_EXTENSION__) {
        var devToolsOptions = typeof this.options.devTools === 'object' ? this.options.devTools : undefined;
        this.devTools = global.__REDUX_DEVTOOLS_EXTENSION__.connect(_assign$(_assign$({
          name: this.id,
          autoPause: true,
          stateSanitizer: function stateSanitizer(state) {
            return {
              value: state.value,
              context: state.context,
              actions: state.actions
            };
          }
        }, devToolsOptions), {
          features: _assign$({
            jump: false,
            skip: false
          }, devToolsOptions ? devToolsOptions.features : undefined)
        }), this.machine);
        this.devTools.init(this.state);
      } // add XState-specific dev tooling hook


      registerService(this);
    }
  };

  Interpreter.prototype.toJSON = function () {
    return {
      id: this.id
    };
  };

  Interpreter.prototype[symbolObservable] = function () {
    return this;
  };

  Interpreter.prototype.getSnapshot = function () {
    if (this.status === InterpreterStatus.NotStarted) {
      return this.initialState;
    }

    return this._state;
  };
  /**
   * The default interpreter options:
   *
   * - `clock` uses the global `setTimeout` and `clearTimeout` functions
   * - `logger` uses the global `console.log()` method
   */


  Interpreter.defaultOptions = {
    execute: true,
    deferEvents: true,
    clock: {
      setTimeout: function (_setTimeout) {
        function setTimeout(_x19, _x20) {
          return _setTimeout.apply(this, arguments);
        }

        setTimeout.toString = function () {
          return _setTimeout.toString();
        };

        return setTimeout;
      }(function (fn, ms) {
        return setTimeout(fn, ms);
      }),
      clearTimeout: function (_clearTimeout) {
        function clearTimeout(_x21) {
          return _clearTimeout.apply(this, arguments);
        }

        clearTimeout.toString = function () {
          return _clearTimeout.toString();
        };

        return clearTimeout;
      }(function (id) {
        return clearTimeout(id);
      })
    },
    logger: /*#__PURE__*/console.log.bind(console),
    devTools: false
  };
  Interpreter.interpret = interpret;
  return Interpreter;
}();
/**
 * Creates a new Interpreter instance for the given machine with the provided options, if any.
 *
 * @param machine The machine to interpret
 * @param options Interpreter options
 */


function interpret(machine, options) {
  var interpreter = new Interpreter(machine, options);
  return interpreter;
}

function toInvokeSource(src) {
  if (typeof src === 'string') {
    var simpleSrc = {
      type: src
    };

    simpleSrc.toString = function () {
      return src;
    }; // v4 compat - TODO: remove in v5


    return simpleSrc;
  }

  return src;
}

function toInvokeDefinition(invokeConfig) {
  return _assign$(_assign$({
    type: invoke
  }, invokeConfig), {
    toJSON: function toJSON() {
      invokeConfig.onDone;
      invokeConfig.onError;

      var invokeDef = __rest$6(invokeConfig, ["onDone", "onError"]);

      return _assign$(_assign$({}, invokeDef), {
        type: invoke,
        src: toInvokeSource(invokeConfig.src)
      });
    }
  });
}

var NULL_EVENT = '';
var STATE_IDENTIFIER = '#';
var WILDCARD = '*';
var EMPTY_OBJECT = {};

var isStateId = function isStateId(str) {
  return str[0] === STATE_IDENTIFIER;
};

var createDefaultOptions = function createDefaultOptions() {
  return {
    actions: {},
    guards: {},
    services: {},
    activities: {},
    delays: {}
  };
};

var validateArrayifiedTransitions = function validateArrayifiedTransitions(stateNode, event, transitions) {
  var hasNonLastUnguardedTarget = transitions.slice(0, -1).some(function (transition) {
    return !('cond' in transition) && !('in' in transition) && (isString$3(transition.target) || isMachine(transition.target));
  });
  var eventText = event === NULL_EVENT ? 'the transient event' : "event '".concat(event, "'");
  warn(!hasNonLastUnguardedTarget, "One or more transitions for ".concat(eventText, " on state '").concat(stateNode.id, "' are unreachable. ") + "Make sure that the default transition is the last one defined.");
};

var StateNode =
/*#__PURE__*/

/** @class */
function () {
  function StateNode(
  /**
   * The raw config used to create the machine.
   */
  config, options,
  /**
   * The initial extended state
   */
  _context, // TODO: this is unsafe, but we're removing it in v5 anyway
  _stateInfo) {
    var _this = this;

    if (_context === void 0) {
      _context = 'context' in config ? config.context : undefined;
    }

    var _a;

    this.config = config;
    this._context = _context;
    /**
     * The order this state node appears. Corresponds to the implicit SCXML document order.
     */

    this.order = -1;
    this.__xstatenode = true;
    this.__cache = {
      events: undefined,
      relativeValue: new Map(),
      initialStateValue: undefined,
      initialState: undefined,
      on: undefined,
      transitions: undefined,
      candidates: {},
      delayedTransitions: undefined
    };
    this.idMap = {};
    this.tags = [];
    this.options = Object.assign(createDefaultOptions(), options);
    this.parent = _stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.parent;
    this.key = this.config.key || (_stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.key) || this.config.id || '(machine)';
    this.machine = this.parent ? this.parent.machine : this;
    this.path = this.parent ? this.parent.path.concat(this.key) : [];
    this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : STATE_DELIMITER);
    this.id = this.config.id || __spreadArray$2([this.machine.key], __read$4(this.path), false).join(this.delimiter);
    this.version = this.parent ? this.parent.version : this.config.version;
    this.type = this.config.type || (this.config.parallel ? 'parallel' : this.config.states && Object.keys(this.config.states).length ? 'compound' : this.config.history ? 'history' : 'atomic');
    this.schema = this.parent ? this.machine.schema : (_a = this.config.schema) !== null && _a !== void 0 ? _a : {};
    this.description = this.config.description;

    if (!IS_PRODUCTION) {
      warn(!('parallel' in this.config), "The \"parallel\" property is deprecated and will be removed in version 4.1. ".concat(this.config.parallel ? "Replace with `type: 'parallel'`" : "Use `type: '".concat(this.type, "'`"), " in the config for state node '").concat(this.id, "' instead."));
    }

    this.initial = this.config.initial;
    this.states = this.config.states ? mapValues(this.config.states, function (stateConfig, key) {
      var _a;

      var stateNode = new StateNode(stateConfig, {}, undefined, {
        parent: _this,
        key: key
      });
      Object.assign(_this.idMap, _assign$((_a = {}, _a[stateNode.id] = stateNode, _a), stateNode.idMap));
      return stateNode;
    }) : EMPTY_OBJECT; // Document order

    var order = 0;

    function dfs(stateNode) {
      var e_1, _a;

      stateNode.order = order++;

      try {
        for (var _b = __values$1(getChildren(stateNode)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var child = _c.value;
          dfs(child);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    }

    dfs(this); // History config

    this.history = this.config.history === true ? 'shallow' : this.config.history || false;
    this._transient = !!this.config.always || (!this.config.on ? false : Array.isArray(this.config.on) ? this.config.on.some(function (_a) {
      var event = _a.event;
      return event === NULL_EVENT;
    }) : NULL_EVENT in this.config.on);
    this.strict = !!this.config.strict; // TODO: deprecate (entry)

    this.onEntry = toArray$2(this.config.entry || this.config.onEntry).map(function (action) {
      return toActionObject(action);
    }); // TODO: deprecate (exit)

    this.onExit = toArray$2(this.config.exit || this.config.onExit).map(function (action) {
      return toActionObject(action);
    });
    this.meta = this.config.meta;
    this.doneData = this.type === 'final' ? this.config.data : undefined;
    this.invoke = toArray$2(this.config.invoke).map(function (invokeConfig, i) {
      var _a, _b;

      if (isMachine(invokeConfig)) {
        var invokeId = createInvokeId(_this.id, i);
        _this.machine.options.services = _assign$((_a = {}, _a[invokeId] = invokeConfig, _a), _this.machine.options.services);
        return toInvokeDefinition({
          src: invokeId,
          id: invokeId
        });
      } else if (isString$3(invokeConfig.src)) {
        var invokeId = invokeConfig.id || createInvokeId(_this.id, i);
        return toInvokeDefinition(_assign$(_assign$({}, invokeConfig), {
          id: invokeId,
          src: invokeConfig.src
        }));
      } else if (isMachine(invokeConfig.src) || isFunction$3(invokeConfig.src)) {
        var invokeId = invokeConfig.id || createInvokeId(_this.id, i);
        _this.machine.options.services = _assign$((_b = {}, _b[invokeId] = invokeConfig.src, _b), _this.machine.options.services);
        return toInvokeDefinition(_assign$(_assign$({
          id: invokeId
        }, invokeConfig), {
          src: invokeId
        }));
      } else {
        var invokeSource = invokeConfig.src;
        return toInvokeDefinition(_assign$(_assign$({
          id: createInvokeId(_this.id, i)
        }, invokeConfig), {
          src: invokeSource
        }));
      }
    });
    this.activities = toArray$2(this.config.activities).concat(this.invoke).map(function (activity) {
      return toActivityDefinition(activity);
    });
    this.transition = this.transition.bind(this);
    this.tags = toArray$2(this.config.tags); // TODO: this is the real fix for initialization once
    // state node getters are deprecated
    // if (!this.parent) {
    //   this._init();
    // }
  }

  StateNode.prototype._init = function () {
    if (this.__cache.transitions) {
      return;
    }

    getAllStateNodes(this).forEach(function (stateNode) {
      return stateNode.on;
    });
  };
  /**
   * Clones this state machine with custom options and context.
   *
   * @param options Options (actions, guards, activities, services) to recursively merge with the existing options.
   * @param context Custom context (will override predefined context)
   */


  StateNode.prototype.withConfig = function (options, context) {
    var _a = this.options,
        actions = _a.actions,
        activities = _a.activities,
        guards = _a.guards,
        services = _a.services,
        delays = _a.delays;
    return new StateNode(this.config, {
      actions: _assign$(_assign$({}, actions), options.actions),
      activities: _assign$(_assign$({}, activities), options.activities),
      guards: _assign$(_assign$({}, guards), options.guards),
      services: _assign$(_assign$({}, services), options.services),
      delays: _assign$(_assign$({}, delays), options.delays)
    }, context !== null && context !== void 0 ? context : this.context);
  };
  /**
   * Clones this state machine with custom context.
   *
   * @param context Custom context (will override predefined context, not recursive)
   */


  StateNode.prototype.withContext = function (context) {
    return new StateNode(this.config, this.options, context);
  };

  Object.defineProperty(StateNode.prototype, "context", {
    get: function get() {
      return isFunction$3(this._context) ? this._context() : this._context;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "definition", {
    /**
     * The well-structured state node definition.
     */
    get: function get() {
      return {
        id: this.id,
        key: this.key,
        version: this.version,
        context: this.context,
        type: this.type,
        initial: this.initial,
        history: this.history,
        states: mapValues(this.states, function (state) {
          return state.definition;
        }),
        on: this.on,
        transitions: this.transitions,
        entry: this.onEntry,
        exit: this.onExit,
        activities: this.activities || [],
        meta: this.meta,
        order: this.order || -1,
        data: this.doneData,
        invoke: this.invoke,
        description: this.description,
        tags: this.tags
      };
    },
    enumerable: false,
    configurable: true
  });

  StateNode.prototype.toJSON = function () {
    return this.definition;
  };

  Object.defineProperty(StateNode.prototype, "on", {
    /**
     * The mapping of events to transitions.
     */
    get: function get() {
      if (this.__cache.on) {
        return this.__cache.on;
      }

      var transitions = this.transitions;
      return this.__cache.on = transitions.reduce(function (map, transition) {
        map[transition.eventType] = map[transition.eventType] || [];
        map[transition.eventType].push(transition);
        return map;
      }, {});
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "after", {
    get: function get() {
      return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "transitions", {
    /**
     * All the transitions that can be taken from this state node.
     */
    get: function get() {
      return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
    },
    enumerable: false,
    configurable: true
  });

  StateNode.prototype.getCandidates = function (eventName) {
    if (this.__cache.candidates[eventName]) {
      return this.__cache.candidates[eventName];
    }

    var transient = eventName === NULL_EVENT;
    var candidates = this.transitions.filter(function (transition) {
      var sameEventType = transition.eventType === eventName; // null events should only match against eventless transitions

      return transient ? sameEventType : sameEventType || transition.eventType === WILDCARD;
    });
    this.__cache.candidates[eventName] = candidates;
    return candidates;
  };
  /**
   * All delayed transitions from the config.
   */


  StateNode.prototype.getDelayedTransitions = function () {
    var _this = this;

    var afterConfig = this.config.after;

    if (!afterConfig) {
      return [];
    }

    var mutateEntryExit = function mutateEntryExit(delay, i) {
      var delayRef = isFunction$3(delay) ? "".concat(_this.id, ":delay[").concat(i, "]") : delay;
      var eventType = after(delayRef, _this.id);

      _this.onEntry.push(send(eventType, {
        delay: delay
      }));

      _this.onExit.push(cancel(eventType));

      return eventType;
    };

    var delayedTransitions = isArray$4(afterConfig) ? afterConfig.map(function (transition, i) {
      var eventType = mutateEntryExit(transition.delay, i);
      return _assign$(_assign$({}, transition), {
        event: eventType
      });
    }) : flatten(Object.keys(afterConfig).map(function (delay, i) {
      var configTransition = afterConfig[delay];
      var resolvedTransition = isString$3(configTransition) ? {
        target: configTransition
      } : configTransition;
      var resolvedDelay = !isNaN(+delay) ? +delay : delay;
      var eventType = mutateEntryExit(resolvedDelay, i);
      return toArray$2(resolvedTransition).map(function (transition) {
        return _assign$(_assign$({}, transition), {
          event: eventType,
          delay: resolvedDelay
        });
      });
    }));
    return delayedTransitions.map(function (delayedTransition) {
      var delay = delayedTransition.delay;
      return _assign$(_assign$({}, _this.formatTransition(delayedTransition)), {
        delay: delay
      });
    });
  };
  /**
   * Returns the state nodes represented by the current state value.
   *
   * @param state The state value or State instance
   */


  StateNode.prototype.getStateNodes = function (state) {
    var _a;

    var _this = this;

    if (!state) {
      return [];
    }

    var stateValue = state instanceof State ? state.value : toStateValue(state, this.delimiter);

    if (isString$3(stateValue)) {
      var initialStateValue = this.getStateNode(stateValue).initial;
      return initialStateValue !== undefined ? this.getStateNodes((_a = {}, _a[stateValue] = initialStateValue, _a)) : [this, this.states[stateValue]];
    }

    var subStateKeys = Object.keys(stateValue);
    var subStateNodes = [this];
    subStateNodes.push.apply(subStateNodes, __spreadArray$2([], __read$4(flatten(subStateKeys.map(function (subStateKey) {
      return _this.getStateNode(subStateKey).getStateNodes(stateValue[subStateKey]);
    }))), false));
    return subStateNodes;
  };
  /**
   * Returns `true` if this state node explicitly handles the given event.
   *
   * @param event The event in question
   */


  StateNode.prototype.handles = function (event) {
    var eventType = getEventType(event);
    return this.events.includes(eventType);
  };
  /**
   * Resolves the given `state` to a new `State` instance relative to this machine.
   *
   * This ensures that `.events` and `.nextEvents` represent the correct values.
   *
   * @param state The state to resolve
   */


  StateNode.prototype.resolveState = function (state) {
    var stateFromConfig = state instanceof State ? state : State.create(state);
    var configuration = Array.from(getConfiguration([], this.getStateNodes(stateFromConfig.value)));
    return new State(_assign$(_assign$({}, stateFromConfig), {
      value: this.resolve(stateFromConfig.value),
      configuration: configuration,
      done: isInFinalState(configuration, this),
      tags: getTagsFromConfiguration(configuration),
      machine: this.machine
    }));
  };

  StateNode.prototype.transitionLeafNode = function (stateValue, state, _event) {
    var stateNode = this.getStateNode(stateValue);
    var next = stateNode.next(state, _event);

    if (!next || !next.transitions.length) {
      return this.next(state, _event);
    }

    return next;
  };

  StateNode.prototype.transitionCompoundNode = function (stateValue, state, _event) {
    var subStateKeys = Object.keys(stateValue);
    var stateNode = this.getStateNode(subStateKeys[0]);

    var next = stateNode._transition(stateValue[subStateKeys[0]], state, _event);

    if (!next || !next.transitions.length) {
      return this.next(state, _event);
    }

    return next;
  };

  StateNode.prototype.transitionParallelNode = function (stateValue, state, _event) {
    var e_2, _a;

    var transitionMap = {};

    try {
      for (var _b = __values$1(Object.keys(stateValue)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var subStateKey = _c.value;
        var subStateValue = stateValue[subStateKey];

        if (!subStateValue) {
          continue;
        }

        var subStateNode = this.getStateNode(subStateKey);

        var next = subStateNode._transition(subStateValue, state, _event);

        if (next) {
          transitionMap[subStateKey] = next;
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }

    var stateTransitions = Object.keys(transitionMap).map(function (key) {
      return transitionMap[key];
    });
    var enabledTransitions = flatten(stateTransitions.map(function (st) {
      return st.transitions;
    }));
    var willTransition = stateTransitions.some(function (st) {
      return st.transitions.length > 0;
    });

    if (!willTransition) {
      return this.next(state, _event);
    }

    var entryNodes = flatten(stateTransitions.map(function (t) {
      return t.entrySet;
    }));
    var configuration = flatten(Object.keys(transitionMap).map(function (key) {
      return transitionMap[key].configuration;
    }));
    return {
      transitions: enabledTransitions,
      entrySet: entryNodes,
      exitSet: flatten(stateTransitions.map(function (t) {
        return t.exitSet;
      })),
      configuration: configuration,
      source: state,
      actions: flatten(Object.keys(transitionMap).map(function (key) {
        return transitionMap[key].actions;
      }))
    };
  };

  StateNode.prototype._transition = function (stateValue, state, _event) {
    // leaf node
    if (isString$3(stateValue)) {
      return this.transitionLeafNode(stateValue, state, _event);
    } // hierarchical node


    if (Object.keys(stateValue).length === 1) {
      return this.transitionCompoundNode(stateValue, state, _event);
    } // orthogonal node


    return this.transitionParallelNode(stateValue, state, _event);
  };

  StateNode.prototype.getTransitionData = function (state, event) {
    return this._transition(state.value, state, toSCXMLEvent(event));
  };

  StateNode.prototype.next = function (state, _event) {
    var e_3, _a;

    var _this = this;

    var eventName = _event.name;
    var actions = [];
    var nextStateNodes = [];
    var selectedTransition;

    try {
      for (var _b = __values$1(this.getCandidates(eventName)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var candidate = _c.value;
        var cond = candidate.cond,
            stateIn = candidate.in;
        var resolvedContext = state.context;
        var isInState = stateIn ? isString$3(stateIn) && isStateId(stateIn) ? // Check if in state by ID
        state.matches(toStateValue(this.getStateNodeById(stateIn).path, this.delimiter)) : // Check if in state by relative grandparent
        matchesState(toStateValue(stateIn, this.delimiter), path(this.path.slice(0, -2))(state.value)) : true;
        var guardPassed = false;

        try {
          guardPassed = !cond || evaluateGuard(this.machine, cond, resolvedContext, _event, state);
        } catch (err) {
          throw new Error("Unable to evaluate guard '".concat(cond.name || cond.type, "' in transition for event '").concat(eventName, "' in state node '").concat(this.id, "':\n").concat(err.message));
        }

        if (guardPassed && isInState) {
          if (candidate.target !== undefined) {
            nextStateNodes = candidate.target;
          }

          actions.push.apply(actions, __spreadArray$2([], __read$4(candidate.actions), false));
          selectedTransition = candidate;
          break;
        }
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_3) throw e_3.error;
      }
    }

    if (!selectedTransition) {
      return undefined;
    }

    if (!nextStateNodes.length) {
      return {
        transitions: [selectedTransition],
        entrySet: [],
        exitSet: [],
        configuration: state.value ? [this] : [],
        source: state,
        actions: actions
      };
    }

    var allNextStateNodes = flatten(nextStateNodes.map(function (stateNode) {
      return _this.getRelativeStateNodes(stateNode, state.historyValue);
    }));
    var isInternal = !!selectedTransition.internal;
    var reentryNodes = isInternal ? [] : flatten(allNextStateNodes.map(function (n) {
      return _this.nodesFromChild(n);
    }));
    return {
      transitions: [selectedTransition],
      entrySet: reentryNodes,
      exitSet: isInternal ? [] : [this],
      configuration: allNextStateNodes,
      source: state,
      actions: actions
    };
  };

  StateNode.prototype.nodesFromChild = function (childStateNode) {
    if (childStateNode.escapes(this)) {
      return [];
    }

    var nodes = [];
    var marker = childStateNode;

    while (marker && marker !== this) {
      nodes.push(marker);
      marker = marker.parent;
    }

    nodes.push(this); // inclusive

    return nodes;
  };
  /**
   * Whether the given state node "escapes" this state node. If the `stateNode` is equal to or the parent of
   * this state node, it does not escape.
   */


  StateNode.prototype.escapes = function (stateNode) {
    if (this === stateNode) {
      return false;
    }

    var parent = this.parent;

    while (parent) {
      if (parent === stateNode) {
        return false;
      }

      parent = parent.parent;
    }

    return true;
  };

  StateNode.prototype.getActions = function (transition, currentContext, _event, prevState) {
    var e_4, _a, e_5, _b;

    var prevConfig = getConfiguration([], prevState ? this.getStateNodes(prevState.value) : [this]);
    var resolvedConfig = transition.configuration.length ? getConfiguration(prevConfig, transition.configuration) : prevConfig;

    try {
      for (var resolvedConfig_1 = __values$1(resolvedConfig), resolvedConfig_1_1 = resolvedConfig_1.next(); !resolvedConfig_1_1.done; resolvedConfig_1_1 = resolvedConfig_1.next()) {
        var sn = resolvedConfig_1_1.value;

        if (!has(prevConfig, sn)) {
          transition.entrySet.push(sn);
        }
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (resolvedConfig_1_1 && !resolvedConfig_1_1.done && (_a = resolvedConfig_1.return)) _a.call(resolvedConfig_1);
      } finally {
        if (e_4) throw e_4.error;
      }
    }

    try {
      for (var prevConfig_1 = __values$1(prevConfig), prevConfig_1_1 = prevConfig_1.next(); !prevConfig_1_1.done; prevConfig_1_1 = prevConfig_1.next()) {
        var sn = prevConfig_1_1.value;

        if (!has(resolvedConfig, sn) || has(transition.exitSet, sn.parent)) {
          transition.exitSet.push(sn);
        }
      }
    } catch (e_5_1) {
      e_5 = {
        error: e_5_1
      };
    } finally {
      try {
        if (prevConfig_1_1 && !prevConfig_1_1.done && (_b = prevConfig_1.return)) _b.call(prevConfig_1);
      } finally {
        if (e_5) throw e_5.error;
      }
    }

    var doneEvents = flatten(transition.entrySet.map(function (sn) {
      var events = [];

      if (sn.type !== 'final') {
        return events;
      }

      var parent = sn.parent;

      if (!parent.parent) {
        return events;
      }

      events.push(done(sn.id, sn.doneData), // TODO: deprecate - final states should not emit done events for their own state.
      done(parent.id, sn.doneData ? mapContext(sn.doneData, currentContext, _event) : undefined));
      var grandparent = parent.parent;

      if (grandparent.type === 'parallel') {
        if (getChildren(grandparent).every(function (parentNode) {
          return isInFinalState(transition.configuration, parentNode);
        })) {
          events.push(done(grandparent.id));
        }
      }

      return events;
    }));
    transition.exitSet.sort(function (a, b) {
      return b.order - a.order;
    });
    transition.entrySet.sort(function (a, b) {
      return a.order - b.order;
    });
    var entryStates = new Set(transition.entrySet);
    var exitStates = new Set(transition.exitSet);

    var _c = __read$4([flatten(Array.from(entryStates).map(function (stateNode) {
      return __spreadArray$2(__spreadArray$2([], __read$4(stateNode.activities.map(function (activity) {
        return start(activity);
      })), false), __read$4(stateNode.onEntry), false);
    })).concat(doneEvents.map(raise)), flatten(Array.from(exitStates).map(function (stateNode) {
      return __spreadArray$2(__spreadArray$2([], __read$4(stateNode.onExit), false), __read$4(stateNode.activities.map(function (activity) {
        return stop(activity);
      })), false);
    }))], 2),
        entryActions = _c[0],
        exitActions = _c[1];

    var actions = toActionObjects(exitActions.concat(transition.actions).concat(entryActions), this.machine.options.actions);
    return actions;
  };
  /**
   * Determines the next state given the current `state` and sent `event`.
   *
   * @param state The current State instance or state value
   * @param event The event that was sent at the current state
   * @param context The current context (extended state) of the current state
   */


  StateNode.prototype.transition = function (state, event, context) {
    if (state === void 0) {
      state = this.initialState;
    }

    var _event = toSCXMLEvent(event);

    var currentState;

    if (state instanceof State) {
      currentState = context === undefined ? state : this.resolveState(State.from(state, context));
    } else {
      var resolvedStateValue = isString$3(state) ? this.resolve(pathToStateValue(this.getResolvedPath(state))) : this.resolve(state);
      var resolvedContext = context !== null && context !== void 0 ? context : this.machine.context;
      currentState = this.resolveState(State.from(resolvedStateValue, resolvedContext));
    }

    if (!IS_PRODUCTION && _event.name === WILDCARD) {
      throw new Error("An event cannot have the wildcard type ('".concat(WILDCARD, "')"));
    }

    if (this.strict) {
      if (!this.events.includes(_event.name) && !isBuiltInEvent(_event.name)) {
        throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(_event.name, "'"));
      }
    }

    var stateTransition = this._transition(currentState.value, currentState, _event) || {
      transitions: [],
      configuration: [],
      entrySet: [],
      exitSet: [],
      source: currentState,
      actions: []
    };
    var prevConfig = getConfiguration([], this.getStateNodes(currentState.value));
    var resolvedConfig = stateTransition.configuration.length ? getConfiguration(prevConfig, stateTransition.configuration) : prevConfig;
    stateTransition.configuration = __spreadArray$2([], __read$4(resolvedConfig), false);
    return this.resolveTransition(stateTransition, currentState, currentState.context, _event);
  };

  StateNode.prototype.resolveRaisedTransition = function (state, _event, originalEvent) {
    var _a;

    var currentActions = state.actions;
    state = this.transition(state, _event); // Save original event to state
    // TODO: this should be the raised event! Delete in V5 (breaking)

    state._event = originalEvent;
    state.event = originalEvent.data;

    (_a = state.actions).unshift.apply(_a, __spreadArray$2([], __read$4(currentActions), false));

    return state;
  };

  StateNode.prototype.resolveTransition = function (stateTransition, currentState, context, _event) {
    var e_6, _a;

    var _this = this;

    if (_event === void 0) {
      _event = initEvent;
    }

    var configuration = stateTransition.configuration; // Transition will "apply" if:
    // - this is the initial state (there is no current state)
    // - OR there are transitions

    var willTransition = !currentState || stateTransition.transitions.length > 0;
    var resolvedStateValue = willTransition ? getValue$1(this.machine, configuration) : undefined;
    var historyValue = currentState ? currentState.historyValue ? currentState.historyValue : stateTransition.source ? this.machine.historyValue(currentState.value) : undefined : undefined;
    var actions = this.getActions(stateTransition, context, _event, currentState);
    var activities = currentState ? _assign$({}, currentState.activities) : {};

    try {
      for (var actions_1 = __values$1(actions), actions_1_1 = actions_1.next(); !actions_1_1.done; actions_1_1 = actions_1.next()) {
        var action = actions_1_1.value;

        if (action.type === start$1) {
          activities[action.activity.id || action.activity.type] = action;
        } else if (action.type === stop$1) {
          activities[action.activity.id || action.activity.type] = false;
        }
      }
    } catch (e_6_1) {
      e_6 = {
        error: e_6_1
      };
    } finally {
      try {
        if (actions_1_1 && !actions_1_1.done && (_a = actions_1.return)) _a.call(actions_1);
      } finally {
        if (e_6) throw e_6.error;
      }
    }

    var _b = __read$4(resolveActions(this, currentState, context, _event, actions, this.machine.config.preserveActionOrder), 2),
        resolvedActions = _b[0],
        updatedContext = _b[1];

    var _c = __read$4(partition$1(resolvedActions, function (action) {
      return action.type === raise$1 || action.type === send$1 && action.to === SpecialTargets.Internal;
    }), 2),
        raisedEvents = _c[0],
        nonRaisedActions = _c[1];

    var invokeActions = resolvedActions.filter(function (action) {
      var _a;

      return action.type === start$1 && ((_a = action.activity) === null || _a === void 0 ? void 0 : _a.type) === invoke;
    });
    var children = invokeActions.reduce(function (acc, action) {
      acc[action.activity.id] = createInvocableActor(action.activity, _this.machine, updatedContext, _event);
      return acc;
    }, currentState ? _assign$({}, currentState.children) : {});
    var resolvedConfiguration = willTransition ? stateTransition.configuration : currentState ? currentState.configuration : [];
    var isDone = isInFinalState(resolvedConfiguration, this);
    var nextState = new State({
      value: resolvedStateValue || currentState.value,
      context: updatedContext,
      _event: _event,
      // Persist _sessionid between states
      _sessionid: currentState ? currentState._sessionid : null,
      historyValue: resolvedStateValue ? historyValue ? updateHistoryValue(historyValue, resolvedStateValue) : undefined : currentState ? currentState.historyValue : undefined,
      history: !resolvedStateValue || stateTransition.source ? currentState : undefined,
      actions: resolvedStateValue ? nonRaisedActions : [],
      activities: resolvedStateValue ? activities : currentState ? currentState.activities : {},
      events: [],
      configuration: resolvedConfiguration,
      transitions: stateTransition.transitions,
      children: children,
      done: isDone,
      tags: currentState === null || currentState === void 0 ? void 0 : currentState.tags,
      machine: this
    });
    var didUpdateContext = context !== updatedContext;
    nextState.changed = _event.name === update || didUpdateContext; // Dispose of penultimate histories to prevent memory leaks

    var history = nextState.history;

    if (history) {
      delete history.history;
    } // There are transient transitions if the machine is not in a final state
    // and if some of the state nodes have transient ("always") transitions.


    var isTransient = !isDone && (this._transient || configuration.some(function (stateNode) {
      return stateNode._transient;
    })); // If there are no enabled transitions, check if there are transient transitions.
    // If there are transient transitions, continue checking for more transitions
    // because an transient transition should be triggered even if there are no
    // enabled transitions.
    //
    // If we're already working on an transient transition (by checking
    // if the event is a NULL_EVENT), then stop to prevent an infinite loop.
    //
    // Otherwise, if there are no enabled nor transient transitions, we are done.

    if (!willTransition && (!isTransient || _event.name === NULL_EVENT)) {
      return nextState;
    }

    var maybeNextState = nextState;

    if (!isDone) {
      if (isTransient) {
        maybeNextState = this.resolveRaisedTransition(maybeNextState, {
          type: nullEvent
        }, _event);
      }

      while (raisedEvents.length) {
        var raisedEvent = raisedEvents.shift();
        maybeNextState = this.resolveRaisedTransition(maybeNextState, raisedEvent._event, _event);
      }
    } // Detect if state changed


    var changed = maybeNextState.changed || (history ? !!maybeNextState.actions.length || didUpdateContext || typeof history.value !== typeof maybeNextState.value || !stateValuesEqual(maybeNextState.value, history.value) : undefined);
    maybeNextState.changed = changed; // Preserve original history after raised events

    maybeNextState.history = history;
    maybeNextState.tags = getTagsFromConfiguration(maybeNextState.configuration);
    return maybeNextState;
  };
  /**
   * Returns the child state node from its relative `stateKey`, or throws.
   */


  StateNode.prototype.getStateNode = function (stateKey) {
    if (isStateId(stateKey)) {
      return this.machine.getStateNodeById(stateKey);
    }

    if (!this.states) {
      throw new Error("Unable to retrieve child state '".concat(stateKey, "' from '").concat(this.id, "'; no child states exist."));
    }

    var result = this.states[stateKey];

    if (!result) {
      throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
    }

    return result;
  };
  /**
   * Returns the state node with the given `stateId`, or throws.
   *
   * @param stateId The state ID. The prefix "#" is removed.
   */


  StateNode.prototype.getStateNodeById = function (stateId) {
    var resolvedStateId = isStateId(stateId) ? stateId.slice(STATE_IDENTIFIER.length) : stateId;

    if (resolvedStateId === this.id) {
      return this;
    }

    var stateNode = this.machine.idMap[resolvedStateId];

    if (!stateNode) {
      throw new Error("Child state node '#".concat(resolvedStateId, "' does not exist on machine '").concat(this.id, "'"));
    }

    return stateNode;
  };
  /**
   * Returns the relative state node from the given `statePath`, or throws.
   *
   * @param statePath The string or string array relative path to the state node.
   */


  StateNode.prototype.getStateNodeByPath = function (statePath) {
    if (typeof statePath === 'string' && isStateId(statePath)) {
      try {
        return this.getStateNodeById(statePath.slice(1));
      } catch (e) {// try individual paths
        // throw e;
      }
    }

    var arrayStatePath = toStatePath(statePath, this.delimiter).slice();
    var currentStateNode = this;

    while (arrayStatePath.length) {
      var key = arrayStatePath.shift();

      if (!key.length) {
        break;
      }

      currentStateNode = currentStateNode.getStateNode(key);
    }

    return currentStateNode;
  };
  /**
   * Resolves a partial state value with its full representation in this machine.
   *
   * @param stateValue The partial state value to resolve.
   */


  StateNode.prototype.resolve = function (stateValue) {
    var _a;

    var _this = this;

    if (!stateValue) {
      return this.initialStateValue || EMPTY_OBJECT; // TODO: type-specific properties
    }

    switch (this.type) {
      case 'parallel':
        return mapValues(this.initialStateValue, function (subStateValue, subStateKey) {
          return subStateValue ? _this.getStateNode(subStateKey).resolve(stateValue[subStateKey] || subStateValue) : EMPTY_OBJECT;
        });

      case 'compound':
        if (isString$3(stateValue)) {
          var subStateNode = this.getStateNode(stateValue);

          if (subStateNode.type === 'parallel' || subStateNode.type === 'compound') {
            return _a = {}, _a[stateValue] = subStateNode.initialStateValue, _a;
          }

          return stateValue;
        }

        if (!Object.keys(stateValue).length) {
          return this.initialStateValue || {};
        }

        return mapValues(stateValue, function (subStateValue, subStateKey) {
          return subStateValue ? _this.getStateNode(subStateKey).resolve(subStateValue) : EMPTY_OBJECT;
        });

      default:
        return stateValue || EMPTY_OBJECT;
    }
  };

  StateNode.prototype.getResolvedPath = function (stateIdentifier) {
    if (isStateId(stateIdentifier)) {
      var stateNode = this.machine.idMap[stateIdentifier.slice(STATE_IDENTIFIER.length)];

      if (!stateNode) {
        throw new Error("Unable to find state node '".concat(stateIdentifier, "'"));
      }

      return stateNode.path;
    }

    return toStatePath(stateIdentifier, this.delimiter);
  };

  Object.defineProperty(StateNode.prototype, "initialStateValue", {
    get: function get() {
      var _a;

      if (this.__cache.initialStateValue) {
        return this.__cache.initialStateValue;
      }

      var initialStateValue;

      if (this.type === 'parallel') {
        initialStateValue = mapFilterValues(this.states, function (state) {
          return state.initialStateValue || EMPTY_OBJECT;
        }, function (stateNode) {
          return !(stateNode.type === 'history');
        });
      } else if (this.initial !== undefined) {
        if (!this.states[this.initial]) {
          throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
        }

        initialStateValue = isLeafNode(this.states[this.initial]) ? this.initial : (_a = {}, _a[this.initial] = this.states[this.initial].initialStateValue, _a);
      } else {
        // The finite state value of a machine without child states is just an empty object
        initialStateValue = {};
      }

      this.__cache.initialStateValue = initialStateValue;
      return this.__cache.initialStateValue;
    },
    enumerable: false,
    configurable: true
  });

  StateNode.prototype.getInitialState = function (stateValue, context) {
    this._init(); // TODO: this should be in the constructor (see note in constructor)


    var configuration = this.getStateNodes(stateValue);
    return this.resolveTransition({
      configuration: configuration,
      entrySet: configuration,
      exitSet: [],
      transitions: [],
      source: undefined,
      actions: []
    }, undefined, context !== null && context !== void 0 ? context : this.machine.context, undefined);
  };

  Object.defineProperty(StateNode.prototype, "initialState", {
    /**
     * The initial State instance, which includes all actions to be executed from
     * entering the initial state.
     */
    get: function get() {
      var initialStateValue = this.initialStateValue;

      if (!initialStateValue) {
        throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
      }

      return this.getInitialState(initialStateValue);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "target", {
    /**
     * The target state value of the history state node, if it exists. This represents the
     * default state value to transition to if no history value exists yet.
     */
    get: function get() {
      var target;

      if (this.type === 'history') {
        var historyConfig = this.config;

        if (isString$3(historyConfig.target)) {
          target = isStateId(historyConfig.target) ? pathToStateValue(this.machine.getStateNodeById(historyConfig.target).path.slice(this.path.length - 1)) : historyConfig.target;
        } else {
          target = historyConfig.target;
        }
      }

      return target;
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Returns the leaf nodes from a state path relative to this state node.
   *
   * @param relativeStateId The relative state path to retrieve the state nodes
   * @param history The previous state to retrieve history
   * @param resolve Whether state nodes should resolve to initial child state nodes
   */

  StateNode.prototype.getRelativeStateNodes = function (relativeStateId, historyValue, resolve) {
    if (resolve === void 0) {
      resolve = true;
    }

    return resolve ? relativeStateId.type === 'history' ? relativeStateId.resolveHistory(historyValue) : relativeStateId.initialStateNodes : [relativeStateId];
  };

  Object.defineProperty(StateNode.prototype, "initialStateNodes", {
    get: function get() {
      var _this = this;

      if (isLeafNode(this)) {
        return [this];
      } // Case when state node is compound but no initial state is defined


      if (this.type === 'compound' && !this.initial) {
        if (!IS_PRODUCTION) {
          warn(false, "Compound state node '".concat(this.id, "' has no initial state."));
        }

        return [this];
      }

      var initialStateNodePaths = toStatePaths(this.initialStateValue);
      return flatten(initialStateNodePaths.map(function (initialPath) {
        return _this.getFromRelativePath(initialPath);
      }));
    },
    enumerable: false,
    configurable: true
  });
  /**
   * Retrieves state nodes from a relative path to this state node.
   *
   * @param relativePath The relative path from this state node
   * @param historyValue
   */

  StateNode.prototype.getFromRelativePath = function (relativePath) {
    if (!relativePath.length) {
      return [this];
    }

    var _a = __read$4(relativePath),
        stateKey = _a[0],
        childStatePath = _a.slice(1);

    if (!this.states) {
      throw new Error("Cannot retrieve subPath '".concat(stateKey, "' from node with no states"));
    }

    var childStateNode = this.getStateNode(stateKey);

    if (childStateNode.type === 'history') {
      return childStateNode.resolveHistory();
    }

    if (!this.states[stateKey]) {
      throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
    }

    return this.states[stateKey].getFromRelativePath(childStatePath);
  };

  StateNode.prototype.historyValue = function (relativeStateValue) {
    if (!Object.keys(this.states).length) {
      return undefined;
    }

    return {
      current: relativeStateValue || this.initialStateValue,
      states: mapFilterValues(this.states, function (stateNode, key) {
        if (!relativeStateValue) {
          return stateNode.historyValue();
        }

        var subStateValue = isString$3(relativeStateValue) ? undefined : relativeStateValue[key];
        return stateNode.historyValue(subStateValue || stateNode.initialStateValue);
      }, function (stateNode) {
        return !stateNode.history;
      })
    };
  };
  /**
   * Resolves to the historical value(s) of the parent state node,
   * represented by state nodes.
   *
   * @param historyValue
   */


  StateNode.prototype.resolveHistory = function (historyValue) {
    var _this = this;

    if (this.type !== 'history') {
      return [this];
    }

    var parent = this.parent;

    if (!historyValue) {
      var historyTarget = this.target;
      return historyTarget ? flatten(toStatePaths(historyTarget).map(function (relativeChildPath) {
        return parent.getFromRelativePath(relativeChildPath);
      })) : parent.initialStateNodes;
    }

    var subHistoryValue = nestedPath(parent.path, 'states')(historyValue).current;

    if (isString$3(subHistoryValue)) {
      return [parent.getStateNode(subHistoryValue)];
    }

    return flatten(toStatePaths(subHistoryValue).map(function (subStatePath) {
      return _this.history === 'deep' ? parent.getFromRelativePath(subStatePath) : [parent.states[subStatePath[0]]];
    }));
  };

  Object.defineProperty(StateNode.prototype, "stateIds", {
    /**
     * All the state node IDs of this state node and its descendant state nodes.
     */
    get: function get() {
      var _this = this;

      var childStateIds = flatten(Object.keys(this.states).map(function (stateKey) {
        return _this.states[stateKey].stateIds;
      }));
      return [this.id].concat(childStateIds);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "events", {
    /**
     * All the event types accepted by this state node and its descendants.
     */
    get: function get() {
      var e_7, _a, e_8, _b;

      if (this.__cache.events) {
        return this.__cache.events;
      }

      var states = this.states;
      var events = new Set(this.ownEvents);

      if (states) {
        try {
          for (var _c = __values$1(Object.keys(states)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var stateId = _d.value;
            var state = states[stateId];

            if (state.states) {
              try {
                for (var _e = (e_8 = void 0, __values$1(state.events)), _f = _e.next(); !_f.done; _f = _e.next()) {
                  var event_1 = _f.value;
                  events.add("".concat(event_1));
                }
              } catch (e_8_1) {
                e_8 = {
                  error: e_8_1
                };
              } finally {
                try {
                  if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally {
                  if (e_8) throw e_8.error;
                }
              }
            }
          }
        } catch (e_7_1) {
          e_7 = {
            error: e_7_1
          };
        } finally {
          try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
          } finally {
            if (e_7) throw e_7.error;
          }
        }
      }

      return this.__cache.events = Array.from(events);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(StateNode.prototype, "ownEvents", {
    /**
     * All the events that have transitions directly from this state node.
     *
     * Excludes any inert events.
     */
    get: function get() {
      var events = new Set(this.transitions.filter(function (transition) {
        return !(!transition.target && !transition.actions.length && transition.internal);
      }).map(function (transition) {
        return transition.eventType;
      }));
      return Array.from(events);
    },
    enumerable: false,
    configurable: true
  });

  StateNode.prototype.resolveTarget = function (_target) {
    var _this = this;

    if (_target === undefined) {
      // an undefined target signals that the state node should not transition from that state when receiving that event
      return undefined;
    }

    return _target.map(function (target) {
      if (!isString$3(target)) {
        return target;
      }

      var isInternalTarget = target[0] === _this.delimiter; // If internal target is defined on machine,
      // do not include machine key on target

      if (isInternalTarget && !_this.parent) {
        return _this.getStateNodeByPath(target.slice(1));
      }

      var resolvedTarget = isInternalTarget ? _this.key + target : target;

      if (_this.parent) {
        try {
          var targetStateNode = _this.parent.getStateNodeByPath(resolvedTarget);

          return targetStateNode;
        } catch (err) {
          throw new Error("Invalid transition definition for state node '".concat(_this.id, "':\n").concat(err.message));
        }
      } else {
        return _this.getStateNodeByPath(resolvedTarget);
      }
    });
  };

  StateNode.prototype.formatTransition = function (transitionConfig) {
    var _this = this;

    var normalizedTarget = normalizeTarget(transitionConfig.target);
    var internal = 'internal' in transitionConfig ? transitionConfig.internal : normalizedTarget ? normalizedTarget.some(function (_target) {
      return isString$3(_target) && _target[0] === _this.delimiter;
    }) : true;
    var guards = this.machine.options.guards;
    var target = this.resolveTarget(normalizedTarget);

    var transition = _assign$(_assign$({}, transitionConfig), {
      actions: toActionObjects(toArray$2(transitionConfig.actions)),
      cond: toGuard(transitionConfig.cond, guards),
      target: target,
      source: this,
      internal: internal,
      eventType: transitionConfig.event,
      toJSON: function toJSON() {
        return _assign$(_assign$({}, transition), {
          target: transition.target ? transition.target.map(function (t) {
            return "#".concat(t.id);
          }) : undefined,
          source: "#".concat(_this.id)
        });
      }
    });

    return transition;
  };

  StateNode.prototype.formatTransitions = function () {
    var e_9, _a;

    var _this = this;

    var onConfig;

    if (!this.config.on) {
      onConfig = [];
    } else if (Array.isArray(this.config.on)) {
      onConfig = this.config.on;
    } else {
      var _b = this.config.on,
          _c = WILDCARD,
          _d = _b[_c],
          wildcardConfigs = _d === void 0 ? [] : _d,
          strictTransitionConfigs_1 = __rest$6(_b, [typeof _c === "symbol" ? _c : _c + ""]);

      onConfig = flatten(Object.keys(strictTransitionConfigs_1).map(function (key) {
        if (!IS_PRODUCTION && key === NULL_EVENT) {
          warn(false, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + "Please check the `on` configuration for \"#".concat(_this.id, "\"."));
        }

        var transitionConfigArray = toTransitionConfigArray(key, strictTransitionConfigs_1[key]);

        if (!IS_PRODUCTION) {
          validateArrayifiedTransitions(_this, key, transitionConfigArray);
        }

        return transitionConfigArray;
      }).concat(toTransitionConfigArray(WILDCARD, wildcardConfigs)));
    }

    var eventlessConfig = this.config.always ? toTransitionConfigArray('', this.config.always) : [];
    var doneConfig = this.config.onDone ? toTransitionConfigArray(String(done(this.id)), this.config.onDone) : [];

    if (!IS_PRODUCTION) {
      warn(!(this.config.onDone && !this.parent), "Root nodes cannot have an \".onDone\" transition. Please check the config of \"".concat(this.id, "\"."));
    }

    var invokeConfig = flatten(this.invoke.map(function (invokeDef) {
      var settleTransitions = [];

      if (invokeDef.onDone) {
        settleTransitions.push.apply(settleTransitions, __spreadArray$2([], __read$4(toTransitionConfigArray(String(doneInvoke(invokeDef.id)), invokeDef.onDone)), false));
      }

      if (invokeDef.onError) {
        settleTransitions.push.apply(settleTransitions, __spreadArray$2([], __read$4(toTransitionConfigArray(String(error$1(invokeDef.id)), invokeDef.onError)), false));
      }

      return settleTransitions;
    }));
    var delayedTransitions = this.after;
    var formattedTransitions = flatten(__spreadArray$2(__spreadArray$2(__spreadArray$2(__spreadArray$2([], __read$4(doneConfig), false), __read$4(invokeConfig), false), __read$4(onConfig), false), __read$4(eventlessConfig), false).map(function (transitionConfig) {
      return toArray$2(transitionConfig).map(function (transition) {
        return _this.formatTransition(transition);
      });
    }));

    try {
      for (var delayedTransitions_1 = __values$1(delayedTransitions), delayedTransitions_1_1 = delayedTransitions_1.next(); !delayedTransitions_1_1.done; delayedTransitions_1_1 = delayedTransitions_1.next()) {
        var delayedTransition = delayedTransitions_1_1.value;
        formattedTransitions.push(delayedTransition);
      }
    } catch (e_9_1) {
      e_9 = {
        error: e_9_1
      };
    } finally {
      try {
        if (delayedTransitions_1_1 && !delayedTransitions_1_1.done && (_a = delayedTransitions_1.return)) _a.call(delayedTransitions_1);
      } finally {
        if (e_9) throw e_9.error;
      }
    }

    return formattedTransitions;
  };

  return StateNode;
}();

function Machine(config, options, initialContext) {
  if (initialContext === void 0) {
    initialContext = config.context;
  }

  return new StateNode(config, options, initialContext);
}

function createMachine(config, options) {
  return new StateNode(config, options);
}

var assign$2 = assign$3;
var ReactEffectType;

(function (ReactEffectType) {
  ReactEffectType[ReactEffectType["Effect"] = 1] = "Effect";
  ReactEffectType[ReactEffectType["LayoutEffect"] = 2] = "LayoutEffect";
})(ReactEffectType || (ReactEffectType = {}));

var isClient = typeof document !== 'undefined';

var noop$1 = function noop() {};

var index$2 = isClient ? useLayoutEffect : noop$1;

function useConstant$1(fn) {
  var ref = React.useRef();

  if (!ref.current) {
    ref.current = {
      v: fn()
    };
  }

  return ref.current.v;
}

var __read$3 = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __values = undefined && undefined.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

function partition(items, predicate) {
  var e_1, _a;

  var _b = __read$3([[], []], 2),
      truthy = _b[0],
      falsy = _b[1];

  try {
    for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
      var item = items_1_1.value;

      if (predicate(item)) {
        truthy.push(item);
      } else {
        falsy.push(item);
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return [truthy, falsy];
}

var __read$2 = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spreadArray$1 = undefined && undefined.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

function executeEffect(action, state) {
  var exec = action.exec;
  var originalExec = exec(state.context, state._event.data, {
    action: action,
    state: state,
    _event: state._event
  });
  originalExec();
}

function useReactEffectActions(service) {
  var effectActionsRef = useRef([]);
  var layoutEffectActionsRef = useRef([]);
  index$2(function () {
    var sub = service.subscribe(function (currentState) {
      var _a, _b;

      if (currentState.actions.length) {
        var reactEffectActions = currentState.actions.filter(function (action) {
          return typeof action.exec === 'function' && '__effect' in action.exec;
        });

        var _c = __read$2(partition(reactEffectActions, function (action) {
          return action.exec.__effect === ReactEffectType.Effect;
        }), 2),
            effectActions = _c[0],
            layoutEffectActions = _c[1];

        (_a = effectActionsRef.current).push.apply(_a, __spreadArray$1([], __read$2(effectActions.map(function (effectAction) {
          return [effectAction, currentState];
        })), false));

        (_b = layoutEffectActionsRef.current).push.apply(_b, __spreadArray$1([], __read$2(layoutEffectActions.map(function (layoutEffectAction) {
          return [layoutEffectAction, currentState];
        })), false));
      }
    });
    return function () {
      sub.unsubscribe();
    };
  }, []); // this is somewhat weird - this should always be flushed within useLayoutEffect
  // but we don't want to receive warnings about useLayoutEffect being used on the server
  // so we have to use `useIsomorphicLayoutEffect` to silence those warnings

  index$2(function () {
    while (layoutEffectActionsRef.current.length) {
      var _a = __read$2(layoutEffectActionsRef.current.shift(), 2),
          layoutEffectAction = _a[0],
          effectState = _a[1];

      executeEffect(layoutEffectAction, effectState);
    }
  }); // https://github.com/statelyai/xstate/pull/1202#discussion_r429677773

  useEffect(function () {
    while (effectActionsRef.current.length) {
      var _a = __read$2(effectActionsRef.current.shift(), 2),
          effectAction = _a[0],
          effectState = _a[1];

      executeEffect(effectAction, effectState);
    }
  });
}

var __assign$8 = undefined && undefined.__assign || function () {
  __assign$8 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$8.apply(this, arguments);
};

var __rest$5 = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __read$1 = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
}; // copied from core/src/utils.ts
// it avoids a breaking change between this package and XState which is its peer dep


function toObserver(nextHandler, errorHandler, completionHandler) {
  if (typeof nextHandler === 'object') {
    return nextHandler;
  }

  var noop = function noop() {
    return void 0;
  };

  return {
    next: nextHandler,
    error: errorHandler || noop,
    complete: completionHandler || noop
  };
}

function useInterpret(getMachine) {
  var _a = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    _a[_i - 1] = arguments[_i];
  }

  var _b = __read$1(_a, 2),
      _c = _b[0],
      options = _c === void 0 ? {} : _c,
      observerOrListener = _b[1];

  var machine = useConstant$1(function () {
    return typeof getMachine === 'function' ? getMachine() : getMachine;
  });

  if (process$1.env.NODE_ENV !== 'production' && typeof getMachine !== 'function') {
    var _d = __read$1(useState(machine), 1),
        initialMachine = _d[0];

    if (getMachine !== initialMachine) {
      console.warn('Machine given to `useMachine` has changed between renders. This is not supported and might lead to unexpected results.\n' + 'Please make sure that you pass the same Machine as argument each time.');
    }
  }

  var context = options.context,
      guards = options.guards,
      actions = options.actions,
      services = options.services,
      delays = options.delays,
      rehydratedState = options.state,
      interpreterOptions = __rest$5(options, ["context", "guards", "actions", "services", "delays", "state"]); // it's not defined in `TypegenMachineOptions` so we can't just unpack this property here freely


  var activities = options.activities;
  var service = useConstant$1(function () {
    var machineConfig = {
      context: context,
      guards: guards,
      actions: actions,
      activities: activities,
      services: services,
      delays: delays
    };
    var machineWithConfig = machine.withConfig(machineConfig, function () {
      return __assign$8(__assign$8({}, machine.context), context);
    });
    return interpret(machineWithConfig, __assign$8({
      deferEvents: true
    }, interpreterOptions));
  });
  index$2(function () {
    var sub;

    if (observerOrListener) {
      sub = service.subscribe(toObserver(observerOrListener));
    }

    return function () {
      sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
    };
  }, [observerOrListener]);
  index$2(function () {
    service.start(rehydratedState ? State.create(rehydratedState) : undefined);
    return function () {
      service.stop();
    };
  }, []); // Make sure options are kept updated when they change.
  // This mutation assignment is safe because the service instance is only used
  // in one place -- this hook's caller.

  index$2(function () {
    Object.assign(service.machine.options.actions, actions);
    Object.assign(service.machine.options.guards, guards);
    Object.assign(service.machine.options.activities, activities);
    Object.assign(service.machine.options.services, services);
    Object.assign(service.machine.options.delays, delays);
  }, [actions, guards, activities, services, delays]);
  useReactEffectActions(service);
  return service;
}

var __read = undefined && undefined.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

undefined && undefined.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

function useMachine(getMachine) {
  var _a = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    _a[_i - 1] = arguments[_i];
  }

  var _b = __read(_a, 1),
      _c = _b[0],
      options = _c === void 0 ? {} : _c;

  var listener = useCallback(function (nextState) {
    // Only change the current state if:
    // - the incoming state is the "live" initial state (since it might have new actors)
    // - OR the incoming state actually changed.
    //
    // The "live" initial state will have .changed === undefined.
    var initialStateChanged = nextState.changed === undefined && Object.keys(nextState.children).length;

    if (nextState.changed || initialStateChanged) {
      setState(nextState);
    }
  }, []);
  var service = useInterpret(getMachine, options, listener);

  var _d = __read(useState(function () {
    var initialState = service.machine.initialState;
    return options.state ? State.create(options.state) : initialState;
  }), 2),
      state = _d[0],
      setState = _d[1];

  return [state, service.send, service];
}

var ANALYTICS_EVENTS = {
  addToCart: 'ADD_TO_CART',
  create: 'Create',
  checkout: 'Checkout',
  forgot: 'Forgot',
  login: 'Login',
  logout: 'Logout',
  navigation: 'Navigation',
  orderItems: 'Order Items',
  purchase: 'Purchase',
  pageView: 'Page View',
  productView: 'Product View',
  removeFromCart: 'Remove From Cart',
  search: 'SEARCH_LIST_RESULT',
  skipCheckout: 'Skip To Checkout',
  supportRequest: 'Support Request',
  bulkSecurity: 'Bulk Security',
  helpSection: 'Help Section',
  aiGeneratorClick: 'ai_generator_click',
  generatePromptClick: 'generate_prompt_click',
  hireBrokerClick: 'hire_broker_click',
  addonsShowMore: 'addons_show_more',
  educationDropdownPress: 'education_dropdown_click'
};
var ANALYTICS_CATEGORIES = {
  purchase: 'Purchase',
  user: 'User'
};

var trackLink = function trackLink(_ref) {
  var eventName = _ref.eventName,
      location = _ref.location;
  return function (e) {
    var data = {
      event: eventName,
      data: {
        location: location,
        href: e.target.href,
        title: e.target.innerText
      }
    };

    if (hasDOM && window.dataLayer) {
      window.dataLayer.push(data);
    }
  };
};

var trackEvent = function trackEvent(_ref2) {
  var event = _ref2.event,
      eventCategory = _ref2.eventCategory,
      data = _ref2.data;

  try {
    if (hasDOM && window.dataLayer && event) {
      window.dataLayer.push({
        event: event,
        eventCategory: eventCategory,
        data: data
      });
    }
  } catch (ex) {// continue on
  }
};

var datalayerPush = function datalayerPush(event) {
  try {
    if (hasDOM && window.dataLayer && event) {
      window.dataLayer.push(event);
    }
  } catch (ex) {// continue on
  }
};

var MENUS = {
  hosting: 'hosting',
  domains: 'domains',
  security: 'security',
  email: 'email',
  seo: 'seo',
  support: 'support',
  mobile: 'mobile',
  mydomains: 'mydomains',
  myhosting: 'myhosting',
  myaccount: 'myaccount'
};
var HOSTING = [[{
  display: 'Web Hosting - Powered by Plesk',
  url: '/hosting/web-hosting',
  applySale: [REBELCA, REBELCOM]
}, {
  display: 'Managed WordPress Packages',
  url: '/hosting/managed-wordpress',
  applySale: [REBELCA, REBELCOM, INTERNIC]
}, {
  display: 'Free Hosting Migration',
  url: '/hosting/hosting-migration'
}], [{
  display: 'Virtual Private Servers',
  url: '/hosting/vps',
  applySale: [INTERNIC]
}, {
  display: 'Website Design Services',
  url: '/websites/website-design'
}]];
var DOMAINS = [[{
  display: 'Find And Register A Domain',
  url: '/domains/register',
  applySale: [REBELCA, REBELCOM]
}, {
  display: 'Bulk Search',
  url: '/search#bulk'
}, {
  display: "Transfer Your Domain To ".concat(isInternic ? 'Internic' : 'Rebel'),
  url: '/domains/domain-transfer'
}], [{
  display: 'Renew An Existing Domain',
  url: '/domains/renewals'
}, {
  display: 'Pricing',
  url: '/domains/pricing'
}, {
  display: 'WHOIS',
  url: '/Whois.aspx'
}]];
var SECURITY = [[{
  display: 'Security Overview',
  url: '/security/security-overview'
}, {
  display: 'Website Security',
  url: '/websites/website-security'
}, {
  display: 'SSL',
  url: '/security/ssl-certificates'
}, {
  display: 'Imunify360',
  url: '/security/imunify360'
}], [{
  display: 'Domain Privacy Protection',
  url: '/security/domain-privacy'
}, {
  display: 'Ownership & Expiry Protection',
  url: '/security/domain-protection'
}, {
  display: 'AdultBlock',
  url: '/security/adult-block'
}]];
var EMAIL = [[{
  display: "".concat(isInternic ? 'Internic' : 'Rebel', " Cloud Email"),
  url: '/email/cloud-email',
  applyNew: [REBELCA, REBELCOM, INTERNIC]
}, {
  display: 'Google Workspace',
  url: '/email/google-workspace'
}, {
  display: 'Email Setup Assistant',
  url: '/email/smart-setup/'
}]];
var SEO = {
  display: 'SEO Tools',
  url: '/seo/seo-tools'
};
var SUPPORT = [[{
  display: 'Help Center',
  url: isInternic ? 'https://support.internic.ca/' : 'https://support.rebel.com/'
}, {
  display: 'Contact Us',
  url: isInternic ? 'https://support.internic.ca/#contact' : 'https://support.rebel.com/#contact'
}], [{
  display: 'Partner Program',
  url: '/programs/partner-program'
}, {
  display: 'Email Setup Assistant',
  url: '/email/smart-setup/'
}, {
  display: 'Quick Renew',
  url: '/QuickRenew.aspx'
}], [{
  display: 'Status Page',
  url: isInternic ? 'https://status.internic.ca/' : 'https://status.rebel.com/'
}, {
  display: 'Blog',
  url: 'https://blog.rebel.com/',
  hide: isInternic
}]];
var ACCOUNT_MENU = {
  mydomains: [[{
    display: 'Domain Manager',
    url: '/MyAccount/Portfolio.aspx'
  }, {
    display: 'Transfer Manager',
    url: '/MyAccount/TransferManager.aspx'
  }, {
    display: 'Contact Manager',
    url: '/contacts/manage/'
  }]],
  myhosting: [[{
    display: 'Hosting Manager',
    url: '/MyAccount/HostingPackages.aspx'
  }, {
    display: 'Cloud Email Manager',
    url: '/my-account/email-manager',
    applyNew: [REBELCA, REBELCOM, INTERNIC]
  }, {
    display: 'Google Workspace Manager',
    url: '/my-account/google-workspace'
  }, {
    display: 'SEO Manager',
    url: '/my-account/seo-manager'
  }, {
    display: 'Weebly Website Manager',
    url: '/Websites/Manage'
  }, {
    display: 'Website Security Manager',
    url: '/MyAccount/SecurityManager.aspx'
  }, {
    display: 'SSL Manager',
    url: '/MyAccount/SSLManager.aspx'
  }, {
    display: 'Classic Webmail',
    url: isInternic ? 'https://webmail.internic.ca' : 'https://webmail.rebel.com'
  }, {
    display: 'Cloud Webmail',
    url: isInternic ? 'https://mail.internic.ca' : 'https://mail.rebel.com'
  }]],
  myaccount: [[{
    display: 'My Account',
    url: '/my-account/'
  }, {
    display: 'Account Settings',
    url: '/my-account/user-details'
  }, {
    display: 'Payment Settings',
    url: '/my-account/settings/payment'
  }, {
    display: 'Billing History',
    url: '/my-account/billing-history'
  }, {
    display: 'Subscriptions',
    url: '/MyAccount/Subscriptions.aspx'
  }, {
    display: 'Login History',
    url: '/my-account/login-history'
  }, {
    display: 'Security Settings',
    url: '/my-account/settings/security'
  }]]
};

var NAV_MENUS = _defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6({}, MENUS.hosting, HOSTING), MENUS.domains, DOMAINS), MENUS.security, SECURITY), MENUS.email, EMAIL), MENUS.seo, SEO), MENUS.support, SUPPORT);

var MOBILE_NAV_MENUS = _defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6({}, MENUS.hosting, HOSTING), MENUS.domains, DOMAINS), MENUS.security, SECURITY), MENUS.email, EMAIL), MENUS.seo, SEO);

var makeTag = function makeTag(color, text) {
  return /*#__PURE__*/jsx$1(Box$1, {
    alignSelf: "center",
    bg: isInternic ? color : color,
    height: "fit-content",
    justifyContent: "center",
    mx: 2,
    children: /*#__PURE__*/jsx$1(Text$1, {
      color: "white",
      px: "0.3rem",
      variant: "micro",
      fontWeight: "regular",
      children: text
    })
  });
};

var mainMenuHasTag = function mainMenuHasTag(menuName, tag) {
  if (menuName === MENUS.myaccount) {
    return false;
  }

  var menuItems = [];

  if (Array.isArray(NAV_MENUS[menuName])) {
    NAV_MENUS[menuName].forEach(function (menuGroup) {
      menuItems = menuItems.concat(menuGroup);
    });
    var menuItemsWithSale = menuItems.filter(function (menuItem) {
      return menuItem[tag];
    });

    if (menuItemsWithSale.length > 0) {
      var menuItemsWithResellerSale = menuItemsWithSale.filter(function (item) {
        return item[tag].includes(RESELLER);
      });

      if (menuItemsWithResellerSale.length > 0) {
        return true;
      }
    }
  }

  if (NAV_MENUS[menuName] && NAV_MENUS[menuName][tag]) {
    return NAV_MENUS[menuName][tag].includes(RESELLER);
  }
};

var subMenuHasSale = function subMenuHasSale(applySale) {
  if (!applySale) {
    return false;
  }

  if (!applySale.includes(RESELLER)) {
    return false;
  }

  return true;
};

var subMenuHasNew = function subMenuHasNew(applyNew) {
  if (!applyNew) {
    return false;
  }

  if (!applyNew.includes(RESELLER)) {
    return false;
  }

  return true;
};

var siteLinks = {
  contactManager: '/contacts/manage/',
  myAccount: '/my-account',
  googleWorkspaceManager: '/my-account/google-workspace'
};

var navigateToUrl = function navigateToUrl(url) {
  window.location.href = url;
};

function ownKeys$1Q(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1Q(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1Q(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1Q(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _regenerator$1G() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1G(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1G(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1G(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1G(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1G(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1G(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1G(u), _regeneratorDefine2$1G(u, o, "Generator"), _regeneratorDefine2$1G(u, n, function () {
    return this;
  }), _regeneratorDefine2$1G(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1G = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1G(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1G = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1G(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1G(e, r, n, t);
}
/**
 * NOTE:
 * Machine's context is initialized with nothing, but data may be added
 * when using `useMachine(machine, opts)` in the provider
 *
 */


var track$3 = function track(ctx, evt) {
  var data = {
    type: evt.type
  };

  if (ctx.error) {
    data.error = {};

    if (Array.isArray(ctx.error)) {
      ctx.error.forEach(function (v, i) {
        data.error["error_".concat(i)] = v;
      });
    } else {
      data.error.error_0 = ctx.error;
    }
  }

  trackEvent({
    event: 'UserAuth',
    data: data
  });
};

var createReturnUrl = function createReturnUrl(returnHost) {
  return "".concat(returnHost).concat(window.location.pathname !== '/' && !window.location.pathname.includes('/account') ? "&ReturnUrl=".concat(window.location.pathname) : '');
}; // Services


var createAccount = function createAccount(ctx, evt) {
  return post$1(userEndpoints.create, evt.payload);
};

var login = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$1G().m(function _callee(ctx, evt) {
    return _regenerator$1G().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            return _context.a(2, post$1(userEndpoints.auth, evt.payload));
        }
      }
    }, _callee);
  }));

  return function login(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var sendTokenToUser = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$1G().m(function _callee2(ctx, evt) {
    var username, contactMethod;
    return _regenerator$1G().w(function (_context2) {
      while (1) {
        switch (_context2.n) {
          case 0:
            username = ctx.credentials.username;
            contactMethod = evt.contactMethod || ctx.contactMethod || getmfaTypeFromInt(ctx.currentInfo.mfaType);

            if (contactMethod == 'phone' && !ctx.currentInfo.phone) {
              contactMethod = 'email';
            }

            if (contactMethod == 'email' && !ctx.currentInfo.email) {
              contactMethod = 'alternateEmail';
            }

            return _context2.a(2, post$1("".concat(mfaEndpoint, "/token/send"), {
              username: username,
              contactMethod: contactMethod,
              customerId: ctx.currentInfo.customerId
            }));
        }
      }
    }, _callee2);
  }));

  return function sendTokenToUser(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var loginWithCode = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator$1G().m(function _callee3(ctx, evt) {
    var _ctx$credentials, username, password, recaptchaResponse, contactMethod, payload;

    return _regenerator$1G().w(function (_context3) {
      while (1) {
        switch (_context3.n) {
          case 0:
            _ctx$credentials = ctx.credentials, username = _ctx$credentials.username, password = _ctx$credentials.password, recaptchaResponse = _ctx$credentials.recaptchaResponse;
            contactMethod = ctx.contactMethod;

            if (!contactMethod) {
              contactMethod = getmfaTypeFromInt(ctx.currentInfo.mfaType);
            }

            if (!ctx.currentInfo.phone) {
              contactMethod = 'email';
            }

            if (!ctx.currentInfo.email) {
              contactMethod = 'alternateEmail';
            }

            payload = {
              username: username,
              password: password,
              contactMethod: contactMethod,
              recaptchaResponse: recaptchaResponse,
              code: evt.token
            };
            return _context3.a(2, post$1(userEndpoints.auth, payload));
        }
      }
    }, _callee3);
  }));

  return function loginWithCode(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();

var checkMFAFails = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regenerator$1G().m(function _callee4(ctx, evt) {
    return _regenerator$1G().w(function (_context4) {
      while (1) {
        switch (_context4.n) {
          case 0:
            return _context4.a(2, put$1("".concat(mfaEndpoint, "/logins/check"), {
              customerId: ctx.currentInfo.customerId
            }));
        }
      }
    }, _callee4);
  }));

  return function checkMFAFails(_x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}();

var logout = function logout() {
  return post$1(userEndpoints.logout);
};

var socialLogin = function socialLogin(ctx, evt) {
  return post$1("".concat(userEndpoints.social, "?createNew=False"), evt.payload);
};

var socialSignup = function socialSignup(ctx, evt) {
  return post$1("".concat(userEndpoints.social, "?createNew=True"), evt.payload);
};

var resetPasswordRequest = function resetPasswordRequest(ctx, evt) {
  return post$1(userEndpoints.passwordReset, evt.payload);
};

var assignContactMethod = function assignContactMethod(ctx, evt) {
  return evt.contactMethod;
};

var authStates = {
  initializing: 'initializing',
  login: 'login',
  signUp: 'signup',
  forgotPassword: 'forgotPassword',
  loggedIn: 'loggedIn',
  loggingOut: 'loggingOut',
  twoFA: 'twoFA'
};
var events$c = {
  SIGN_UP: 'signup',
  FORGOT_PW: 'forgot-pw',
  LOG_OUT: 'logout',
  LOGIN: 'login',
  SUBMIT: 'submit',
  SOCIAL: 'social',
  SAVE_USER: 'save-user',
  REMOVE_USER: 'remove-user',
  BACK: 'back',
  DONE: 'done',
  CANCEL: 'cancel',
  RESET: 'reset',
  SUBMITNOREDIRECT: 'submitNoRedirect',
  CODE: 'code',
  OPTIONS: 'options',
  RESEND: 'resend'
};
var authOpts = {
  services: {
    login: login,
    logout: logout,
    socialLogin: socialLogin,
    socialSignup: socialSignup,
    checkMFAFails: checkMFAFails,
    loginWithCode: loginWithCode,
    createAccount: createAccount,
    sendTokenToUser: sendTokenToUser,
    assignContactMethod: assignContactMethod,
    resetPasswordRequest: resetPasswordRequest
  },
  actions: {
    track: track$3,
    saveUserFromPromise: assign$2(function (ctx, evt) {
      LS.setItem(storageKeys.User, evt.data.data);
      LS.setItem(storageKeys.Alerts, []);
      LS.removeItem(storageKeys.LSToken); // reset to use new cart, otherwise they will get stuck on old between sessions

      LS.removeItem(storageKeys.UseOldCart);
      return {
        user: evt.data.data
      };
    }),
    saveUser: assign$2(function (ctx, evt) {
      LS.setItem(storageKeys.User, evt.payload); // reset to use new cart, otherwise they will get stuck on old between sessions

      LS.removeItem(storageKeys.UseOldCart);
      return {
        user: evt.payload
      };
    }),
    removeUser: assign$2(function () {
      LS.removeItem(storageKeys.User);
      LS.removeItem(storageKeys.LSToken);
      return {
        user: null
      };
    }),
    cacheCurrentInfo: assign$2({
      currentInfo: function currentInfo(ctx, evt) {
        return evt.data.data;
      }
    }),
    cacheUserCredentials: assign$2({
      credentials: function credentials(ctx, evt) {
        return _objectSpread$1Q({}, evt.payload);
      }
    }),
    cacheContactMethod: assign$2({
      contactMethod: function contactMethod(ctx, evt) {
        return evt.contactMethod;
      }
    }),
    cacheError: assign$2({
      error: function error(ctx, evt) {
        var error;

        var data = _get(evt, 'data.response.data'); // Error is from level from backend


        if (data && Array.isArray(data)) {
          error = data;
        }

        if (!error) {
          error = _get(evt, 'data.response.data.errorMessage');
        }

        var message = _get(evt, 'data.message');

        if (!error && typeof message === 'string') {
          error = message;
        }

        if (!error) {
          error = _get(evt, 'data.response.data', 'Network Error');
        } // Anything using auth.machine is expecting a property `errorMessage`


        return typeof error === 'string' ? {
          errorMessage: error,
          status: _get(evt, 'data.response.status', 500)
        } : error;
      }
    }),
    removeError: assign$2({
      error: null
    }),
    loginSuccess: function loginSuccess() {// Placeholder... must be overridden!!!
    },
    loginUserInfoFetch: function loginUserInfoFetch() {// Placeholder... must be overridden!!!
    },
    checkForRedirect: function checkForRedirect(ctx, evt) {
      if (authOpts.guards.isCheckout()) {
        // If it's the checkout page, we want to stay there.
        return;
      }

      var resellerUrl = _get(evt, 'data.data.resellerUrl');

      if (resellerUrl) {
        window.location = createReturnUrl(resellerUrl);
        return;
      }

      if (hasDOM && window.redirectOnLogout) {
        window.location = "/Account?ReturnUrl=".concat(window.location.pathname);
        return;
      }

      var returnUrl = getReturnUrl();

      if (hasDOM && returnUrl) {
        var redirectURL = "".concat(window.location.origin).concat(returnUrl.replace('~', '')); // decodeURIComponent will take rebel.com%2fmyaccount
        // and return rebel.com/myaccount

        window.location.href = decodeURIComponent(redirectURL);
        return;
      }

      navigateToUrl(siteLinks.myAccount);
    },
    checkForCARedirect: function checkForCARedirect(ctx, evt) {
      var resellerUrl = _get(evt, 'data.data.resellerUrl');

      if (resellerUrl) {
        window.location = createReturnUrl(resellerUrl);
      }
    },
    checkRedirectOnLogout: function checkRedirectOnLogout() {
      if (hasDOM && window.redirectOnLogout) {
        window.location = "/Account?ReturnUrl=".concat(window.location.pathname);
      }
    }
  },
  guards: {
    isLoggedIn: function isLoggedIn(ctx) {
      return Boolean(ctx.user);
    },
    requires2FACode: function requires2FACode(ctx, evt) {
      return evt.data.data.mfaType && evt.data.data.mfaType != 1;
    },
    // 1 is 'none'
    isCheckout: function isCheckout() {
      if (hasDOM && window.location && window.location.href) {
        return window.location.href.includes('checkout');
      }

      return false;
    },
    isApp: function isApp(ctx) {
      return getmfaTypeFromInt(ctx.currentInfo.mfaType) === 'app';
    },
    isFirstMFASignIn: function isFirstMFASignIn(ctx) {
      return ctx.currentInfo.isFirstMFASignIn;
    }
  }
};
var authMachine = Machine({
  id: 'user-auth',
  initial: authStates.initializing,
  context: {
    credentials: {},
    currentInfo: {},
    user: null,
    isLoggedIn: false,
    error: null
  },
  states: _defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6({}, authStates.initializing, {
    always: [{
      cond: 'isLoggedIn',
      target: '#loggedIn'
    }, {
      cond: 'isCheckout',
      target: '#signUp'
    }, {
      target: '#login'
    }]
  }), authStates.login, {
    id: 'login',
    initial: 'idle',
    states: {
      idle: {
        on: _defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6({}, events$c.SIGN_UP, '#signUp'), events$c.FORGOT_PW, '#forgotPassword'), events$c.SUBMIT, 'fetching'), events$c.SUBMITNOREDIRECT, 'fetchingWithoutRedirect'), events$c.SOCIAL, 'fetchingSocial'), events$c.SAVE_USER, {
          target: '#loggedIn',
          actions: 'saveUser'
        })
      },
      fetchingSocial: {
        onEntry: 'showLoader',
        onExit: 'hideLoader',
        invoke: {
          id: 'fetch-social-login',
          src: 'socialLogin',
          onDone: {
            target: '#loggedIn',
            actions: ['track', 'saveUserFromPromise', 'checkForRedirect']
          },
          onError: {
            target: 'error',
            actions: ['track', 'cacheError']
          }
        }
      },
      fetching: {
        onEntry: ['cacheUserCredentials', 'showLoader'],
        onExit: 'hideLoader',
        invoke: {
          id: 'fetch-login',
          src: 'login',
          onDone: [{
            cond: 'requires2FACode',
            actions: 'cacheCurrentInfo',
            target: '#2fa-start'
          }, {
            target: '#loggedIn',
            actions: ['track', 'saveUserFromPromise', 'checkForRedirect']
          }],
          onError: {
            target: 'error',
            actions: ['track', 'cacheError']
          }
        }
      },
      fetchingWithoutRedirect: {
        onEntry: ['cacheUserCredentials', 'showLoader'],
        onExit: 'hideLoader',
        invoke: {
          id: 'fetch-login',
          src: 'login',
          onDone: [{
            cond: 'requires2FACode',
            actions: 'cacheCurrentInfo',
            target: '#2fa-start'
          }, {
            target: '#loggedIn',
            actions: ['track', 'saveUserFromPromise', 'checkForCARedirect', 'loginUserInfoFetch']
          }],
          onError: {
            target: 'error',
            actions: ['track', 'cacheError']
          }
        }
      },
      error: {
        on: _defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6({}, events$c.SUBMIT, 'fetching'), events$c.SUBMITNOREDIRECT, 'fetchingWithoutRedirect'), events$c.SOCIAL, 'fetchingSocial'), events$c.SIGN_UP, '#signUp'), events$c.FORGOT_PW, '#forgotPassword'), events$c.RESET, '#login'),
        onExit: 'removeError'
      }
    }
  }), authStates.signUp, {
    id: 'signUp',
    initial: 'idle',
    states: {
      idle: {
        on: _defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6({}, events$c.LOGIN, '#login'), events$c.SUBMIT, 'fetching'), events$c.SUBMITNOREDIRECT, 'fetchingWithoutRedirect'), events$c.SOCIAL, 'fetchingSocial'), events$c.RESET, {
          target: '#login',
          actions: 'removeError'
        }), events$c.SAVE_USER, {
          target: '#loggedIn',
          actions: 'saveUser'
        })
      },
      fetchingSocial: {
        onEntry: 'showLoader',
        onExit: 'hideLoader',
        invoke: {
          id: 'fetch-social-signup',
          src: 'socialSignup',
          onDone: {
            target: '#loggedIn',
            actions: ['track', 'saveUserFromPromise', 'checkForRedirect']
          },
          onError: {
            target: 'error',
            actions: ['track', 'cacheError']
          }
        }
      },
      fetching: {
        onEntry: 'showLoader',
        onExit: 'hideLoader',
        invoke: {
          src: 'createAccount',
          onDone: {
            target: '#loggedIn',
            actions: ['track', 'saveUserFromPromise', 'checkForRedirect']
          },
          onError: {
            target: 'error',
            actions: ['track', 'cacheError']
          }
        }
      },
      fetchingWithoutRedirect: {
        onEntry: 'showLoader',
        onExit: 'hideLoader',
        invoke: {
          src: 'createAccount',
          onDone: {
            target: '#loggedIn',
            actions: ['track', 'saveUserFromPromise', 'loginUserInfoFetch']
          },
          onError: {
            target: 'error',
            actions: ['track', 'cacheError']
          }
        }
      },
      error: {
        on: _defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6({}, events$c.SUBMIT, 'fetching'), events$c.SUBMITNOREDIRECT, 'fetchingWithoutRedirect'), events$c.SOCIAL, 'fetchingSocial'), events$c.LOGIN, '#login'), events$c.RESET, '#login'),
        onExit: 'removeError'
      }
    }
  }), authStates.forgotPassword, {
    id: 'forgotPassword',
    initial: 'idle',
    states: {
      idle: {
        on: _defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6({}, events$c.LOGIN, '#login'), events$c.SUBMIT, 'fetching'), events$c.CANCEL, '#login'), events$c.RESET, '#login'), events$c.SAVE_USER, {
          target: '#loggedIn',
          actions: 'saveUser'
        })
      },
      fetching: {
        onEntry: 'showLoader',
        invoke: {
          src: 'resetPasswordRequest',
          onDone: {
            target: 'checkEmail',
            actions: ['track', 'removeError']
          },
          onError: {
            target: 'error',
            actions: ['track', 'cacheError']
          }
        },
        onExit: 'hideLoader'
      },
      checkEmail: {
        on: _defineProperty$6({}, events$c.LOGIN, '#login')
      },
      error: {
        on: _defineProperty$6(_defineProperty$6(_defineProperty$6({}, events$c.SUBMIT, 'fetching'), events$c.CANCEL, '#login'), events$c.RESET, '#login'),
        onExit: 'removeError'
      }
    }
  }), authStates.loggingOut, {
    id: '#loggingOut',
    onEntry: 'showLoader',
    onExit: 'hideLoader',
    invoke: {
      id: 'logout',
      src: 'logout',
      onDone: {
        target: '#login',
        actions: ['track', 'removeUser', 'checkRedirectOnLogout']
      },
      onError: {
        target: '#login',
        actions: 'removeUser'
      }
    }
  }), authStates.loggedIn, {
    id: 'loggedIn',
    onEntry: 'loginSuccess',
    on: _defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6({}, events$c.LOG_OUT, 'loggingOut'), events$c.CANCEL, 'loggedIn'), events$c.SAVE_USER, {
      actions: 'saveUser'
    }), events$c.REMOVE_USER, {
      target: '#login',
      actions: 'removeUser'
    })
  }), authStates.twoFA, {
    id: '2fa-start',
    initial: 'determinePath',
    states: {
      determinePath: {
        always: [{
          cond: 'isFirstMFASignIn',
          target: 'mfaInfoPage'
        }, {
          target: 'determinemfaType'
        }]
      },
      mfaInfoPage: {
        initial: 'idle',
        states: {
          idle: {
            on: _defineProperty$6(_defineProperty$6({}, events$c.BACK, '#determinemfaType'), events$c.RESET, {
              target: '#login',
              actions: 'removeError'
            })
          }
        }
      },
      determinemfaType: {
        id: 'determinemfaType',
        always: [{
          cond: 'isApp',
          target: '#enterSixDigit'
        }, {
          target: 'isNotApp'
        }]
      },
      isNotApp: {
        invoke: {
          src: 'sendTokenToUser',
          onDone: {
            target: '#enterSixDigit',
            actions: 'removeError'
          },
          onError: {
            target: '#enterSixDigit',
            actions: 'cacheError'
          }
        }
      },
      enterSixDigit: {
        id: 'enterSixDigit',
        initial: 'idle',
        states: {
          idle: {
            on: _defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6({}, events$c.CODE, 'verifyAndLogin'), events$c.RESEND, 'resendCode'), events$c.OPTIONS, '#contactOptions'), events$c.RESET, {
              target: '#login',
              actions: 'removeError'
            })
          },
          verifyAndLogin: {
            id: 'verifyAndLogin',
            onEntry: 'showLoader',
            onExit: 'hideLoader',
            invoke: {
              id: 'loginWithCode',
              src: 'loginWithCode',
              onDone: {
                target: '#loggedIn',
                actions: ['track', 'saveUserFromPromise', 'checkForRedirect']
              },
              onError: {
                target: '#checkMFAFails',
                actions: ['track', 'cacheError']
              }
            }
          },
          checkMFAFails: {
            id: 'checkMFAFails',
            onEntry: 'showLoader',
            onExit: 'hideLoader',
            invoke: {
              id: 'checkMFAFails',
              src: 'checkMFAFails',
              onDone: {
                target: '#enterSixDigit',
                actions: 'track'
              },
              onError: {
                target: '#enterSixDigit',
                actions: ['track', 'cacheError']
              }
            }
          },
          resendCode: {
            onEntry: 'showLoader',
            onExit: 'hideLoader',
            invoke: {
              src: 'sendTokenToUser',
              onDone: {
                target: '#enterSixDigit',
                actions: 'removeError'
              },
              onError: {
                target: '#enterSixDigit',
                actions: ['track', 'cacheError']
              }
            }
          }
        }
      },
      contactOptions: {
        id: 'contactOptions',
        initial: 'idle',
        states: {
          idle: {
            on: _defineProperty$6(_defineProperty$6(_defineProperty$6({}, events$c.SUBMIT, 'sendTokenWithNewMethod'), events$c.BACK, '#enterSixDigit'), events$c.RESET, {
              target: '#login',
              actions: 'removeError'
            })
          },
          sendTokenWithNewMethod: {
            onEntry: 'cacheContactMethod',
            invoke: {
              src: 'sendTokenToUser',
              onDone: {
                target: '#enterSixDigit',
                actions: 'removeError'
              },
              onError: {
                target: '#enterSixDigit',
                actions: ['track', 'cacheError']
              }
            }
          }
        }
      }
    }
  })
}, authOpts);
var rotate = keyframes$3(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
var loaderStyles = css$3(["margin:auto;font-size:10px;position:relative;text-indent:-9999em;border-top:1.1em solid rgba(255,255,255,0.2);border-right:1.1em solid rgba(255,255,255,0.2);border-bottom:1.1em solid rgba(255,255,255,0.2);border-left:1.1em solid #ffffff;transform:translateZ(0);animation:", " 1.1s infinite linear;border-radius:50%;width:10em;height:10em;&:after{border-radius:50%;width:10em;height:10em;}"], rotate);
var LoaderContext = /*#__PURE__*/createContext();

function LoaderProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      loaderIsVisible = _useState2[0],
      setLoaderIsVisible = _useState2[1];

  return /*#__PURE__*/jsxs(LoaderContext.Provider, {
    value: {
      loaderIsVisible: loaderIsVisible,
      setLoaderIsVisible: setLoaderIsVisible
    },
    children: [children, /*#__PURE__*/jsx$1(Loader$1, {})]
  });
}

LoaderProvider.propTypes = {
  children: PropTypes.node.isRequired
};

function useLoaderService() {
  var context = useContext(LoaderContext);

  if (!context) {
    throw new Error("useLoaderService must be used within an LoaderProvider");
  }

  var loaderIsVisible = context.loaderIsVisible,
      setLoaderIsVisible = context.setLoaderIsVisible;

  var showLoader = function showLoader() {
    setLoaderIsVisible(true);
  };

  var hideLoader = function hideLoader() {
    setLoaderIsVisible(false);
  };

  return {
    hideLoader: hideLoader,
    showLoader: showLoader,
    loaderIsVisible: loaderIsVisible
  };
}

function Loader$1() {
  var _useLoaderService = useLoaderService(),
      loaderIsVisible = _useLoaderService.loaderIsVisible;

  return loaderIsVisible && /*#__PURE__*/jsx$1(Box$1, {
    bg: "rgba(10, 10, 10, 0.5)",
    height: "100%",
    id: "rebel-loader",
    left: "0",
    position: "fixed",
    top: "0",
    width: "100%",
    zIndex: "99999999999",
    children: /*#__PURE__*/jsx$1(_StyledBox$r, {})
  });
}

var _StyledBox$r = styled(Box$1).withConfig({
  displayName: "loader-provider___StyledBox",
  componentId: "sc-1eae429-0"
})(["", ""], loaderStyles);

function _regenerator$1F() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1F(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1F(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1F(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1F(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1F(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1F(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1F(u), _regeneratorDefine2$1F(u, o, "Generator"), _regeneratorDefine2$1F(u, n, function () {
    return this;
  }), _regeneratorDefine2$1F(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1F = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1F(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1F = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1F(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1F(e, r, n, t);
}

function ownKeys$1P(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1P(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1P(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1P(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var UserContext = /*#__PURE__*/React__default.createContext();

function UserProvider(_ref) {
  var props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));

  var _useModal = useModal(),
      openModal = _useModal.openModal,
      closeModal = _useModal.closeModal,
      isOpen = _useModal.isOpen,
      Modal = _useModal.Modal,
      containerRef = _useModal.containerRef;

  var _useLoaderService = useLoaderService(),
      showLoader = _useLoaderService.showLoader,
      hideLoader = _useLoaderService.hideLoader;

  var _useState = useState(),
      _useState2 = _slicedToArray$4(_useState, 2),
      onResetPasswordError = _useState2[0],
      setOnResetPasswordError = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray$4(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  var _useState5 = useState(true),
      _useState6 = _slicedToArray$4(_useState5, 2),
      isNew = _useState6[0],
      setIsNew = _useState6[1];

  var lsUser = LS.getItem(storageKeys.User);
  var features = LS.getItem(storageKeys.Features);

  if (lsUser && features) {
    lsUser.features = features;
  }

  var getFeatures = function getFeatures() {
    return LS.getItem(storageKeys.Features);
  };

  var _useMachine = useMachine(authMachine, {
    context: {
      user: lsUser
    },
    actions: {
      loginSuccess: function loginSuccess() {
        closeModal();
      },
      loginUserInfoFetch: function loginUserInfoFetch() {
        lsUser = LS.getItem(storageKeys.User);

        _initialCurrentUserFetch();
      },
      showLoader: showLoader,
      hideLoader: hideLoader
    }
  }),
      _useMachine2 = _slicedToArray$4(_useMachine, 2),
      currentState = _useMachine2[0],
      send = _useMachine2[1];

  var removeUserInfo = function removeUserInfo() {
    LS.removeItem(storageKeys.User);
    send(events$c.REMOVE_USER);
  };

  var fetchUserInfo = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$1F().m(function _callee() {
      var _yield$get, data, user, info, billingAddress, primaryAddress, creditCards, company, customerId, newUserData;

      return _regenerator$1F().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              if (lsUser) {
                _context.n = 1;
                break;
              }

              setIsLoading(false);
              return _context.a(2);

            case 1:
              if (!isLoading) {
                setIsLoading(true);
              }

              _context.n = 2;
              return get$3(userEndpoints.info);

            case 2:
              _yield$get = _context.v;
              data = _yield$get.data;
              user = data.user;
              info = user ? user.activeCustomer : {};
              billingAddress = info.billingAddress, primaryAddress = info.primaryAddress, creditCards = info.creditCards, company = info.company, customerId = info.id;
              newUserData = _objectSpread$1P(_objectSpread$1P({}, lsUser), {}, {
                billingAddress: billingAddress,
                primaryAddress: primaryAddress,
                creditCards: creditCards,
                company: company,
                customerId: customerId,
                userName: lsUser.userName,
                status: user.status
              });
              LS.setItem(storageKeys.User, newUserData); // Send to state machine

              send({
                type: events$c.SAVE_USER,
                payload: newUserData
              });
              setIsLoading(false);

            case 3:
              return _context.a(2);
          }
        }
      }, _callee);
    }));

    return function fetchUserInfo() {
      return _ref2.apply(this, arguments);
    };
  }();

  var _initialCurrentUserFetch = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator$1F().m(function _callee2() {
      var isRetry,
          _yield$get2,
          currentUser,
          _args2 = arguments;

      return _regenerator$1F().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              isRetry = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : false;
              _context2.p = 1;
              _context2.n = 2;
              return get$3(userEndpoints.current);

            case 2:
              _yield$get2 = _context2.v;
              currentUser = _yield$get2.data;

              if (currentUser.features) {
                LS.setItem("".concat(storageKeys.Features), currentUser.features);
              } // Call to current doesn't return error if not logged in


              if (!(currentUser.errorMessage && currentUser.errorMessage === 'Not Logged In')) {
                _context2.n = 5;
                break;
              }

              if (!isRetry) {
                _context2.n = 3;
                break;
              }

              removeUserInfo();
              setIsLoading(false);
              return _context2.a(2);

            case 3:
              _context2.n = 4;
              return refreshRWT();

            case 4:
              return _context2.a(2, _initialCurrentUserFetch(true));

            case 5:
              if (lsUser === null || lsUser.customerId !== currentUser.customerId) {
                send({
                  type: events$c.SAVE_USER,
                  payload: currentUser
                });
              }

              if (lsUser && currentUser.userName) {
                lsUser.userName = currentUser.userName;
              }

              trackEvent({
                event: 'User',
                data: currentUser
              });

              if (lsUser && currentUser.cartThreshold) {
                lsUser.cartThreshold = currentUser.cartThreshold;
              }

              if (lsUser && currentUser.features) {
                lsUser.features = currentUser.features;
              }

              if (lsUser && currentUser.balance) {
                lsUser.balance = currentUser.balance;
              } else if (lsUser && lsUser.balance) {
                delete lsUser.balance;
              }

              if (lsUser && currentUser.hasSubscriptions) {
                lsUser.hasSubscriptions = currentUser.hasSubscriptions;
              }

              if (currentUser.orderCount) {
                LS.setItem(storageKeys.OrderItems, currentUser.orderCount);
              }

              if (!currentUser.customerId) {
                _context2.n = 6;
                break;
              }

              _context2.n = 6;
              return fetchUserInfo();

            case 6:
              _context2.n = 8;
              break;

            case 7:
              _context2.p = 7;
              setIsLoading(false);
              removeUserInfo();

            case 8:
              return _context2.a(2);
          }
        }
      }, _callee2, null, [[1, 7]]);
    }));

    return function initialCurrentUserFetch() {
      return _ref3.apply(this, arguments);
    };
  }();

  useEffect(function () {
    _initialCurrentUserFetch();
  }, []);
  useEffect(function () {
    var localUserPolling = setInterval(function () {
      var localUser = LS.getItem(storageKeys.User);

      var localUserName = _get(localUser, 'userName');

      var stateUser = currentState.context.user;

      var stateUserName = _get(stateUser, 'userName');

      if (localUserName !== stateUserName) {
        if (localUser) {
          send({
            type: events$c.SAVE_USER,
            payload: localUser
          });
        } else {
          send(events$c.REMOVE_USER);
        }
      }
    }, 200);
    return function () {
      clearInterval(localUserPolling);
    };
  }, [currentState.context.user]);
  useEffect(function () {
    var user = currentState.context.user;
    setIsNew(user && (!user.primaryAddress || !user.primaryAddress.firstName || !user.primaryAddress.lastName));
  }, [currentState.context.user]);

  var openUserAuthModal = function openUserAuthModal() {
    openModal();
  };

  var closeUserAuthModal = function closeUserAuthModal() {
    closeModal();
  };

  var onSSOLogin = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regenerator$1F().m(function _callee3(userId) {
      var _yield$get3, data, _t2;

      return _regenerator$1F().w(function (_context3) {
        while (1) {
          switch (_context3.n) {
            case 0:
              showLoader();
              _context3.p = 1;
              _context3.n = 2;
              return get$3("".concat(userEndpoints.sso, "/").concat(userId));

            case 2:
              _yield$get3 = _context3.v;
              data = _yield$get3.data;
              window.location = data;
              _context3.n = 4;
              break;

            case 3:
              _context3.p = 3;
              _t2 = _context3.v; // eslint-disable-next-line no-console

              console.error(_get(_t2, 'response.data', _t2));

            case 4:
              hideLoader();

            case 5:
              return _context3.a(2);
          }
        }
      }, _callee3, null, [[1, 3]]);
    }));

    return function onSSOLogin(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  var onResetPassword = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regenerator$1F().m(function _callee4(_ref5) {
      var payload, cb, _t3;

      return _regenerator$1F().w(function (_context4) {
        while (1) {
          switch (_context4.n) {
            case 0:
              payload = _ref5.payload, cb = _ref5.cb;
              showLoader();
              _context4.p = 1;
              _context4.n = 2;
              return post$1(userEndpoints.passwordSet, payload);

            case 2:
              if (cb) {
                cb();
              }

              _context4.n = 4;
              break;

            case 3:
              _context4.p = 3;
              _t3 = _context4.v; // eslint-disable-next-line no-console

              console.error(_get(_t3, 'response.data', _t3));
              setOnResetPasswordError(_get(_t3, 'response.data', _t3));

            case 4:
              hideLoader();

            case 5:
              return _context4.a(2);
          }
        }
      }, _callee4, null, [[1, 3]]);
    }));

    return function onResetPassword(_x2) {
      return _ref6.apply(this, arguments);
    };
  }();

  var validatePasswordGUID = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regenerator$1F().m(function _callee5(_ref7) {
      var guid, cb, _t4;

      return _regenerator$1F().w(function (_context5) {
        while (1) {
          switch (_context5.n) {
            case 0:
              guid = _ref7.guid, cb = _ref7.cb;
              showLoader();
              _context5.p = 1;
              _context5.n = 2;
              return post$1(userEndpoints.activationValidate, {
                guid: guid
              });

            case 2:
              if (cb) {
                cb();
              }

              _context5.n = 4;
              break;

            case 3:
              _context5.p = 3;
              _t4 = _context5.v; // eslint-disable-next-line no-console

              console.error(_get(_t4, 'response.data', _t4));

            case 4:
              hideLoader();

            case 5:
              return _context5.a(2);
          }
        }
      }, _callee5, null, [[1, 3]]);
    }));

    return function validatePasswordGUID(_x3) {
      return _ref8.apply(this, arguments);
    };
  }();

  var onLogout = function onLogout() {
    send(events$c.LOG_OUT);
  };

  var value = useMemo(function () {
    return {
      closeUserAuthModal: closeUserAuthModal,
      containerRef: containerRef,
      currentState: currentState,
      fetchUserInfo: fetchUserInfo,
      getFeatures: getFeatures,
      isNew: isNew,
      isLoading: isLoading,
      isUserAuthModalOpen: isOpen,
      Modal: Modal,
      onLogout: onLogout,
      onResetPassword: onResetPassword,
      onResetPasswordError: onResetPasswordError,
      onSSOLogin: onSSOLogin,
      openUserAuthModal: openUserAuthModal,
      send: send,
      validatePasswordGUID: validatePasswordGUID
    };
  }, [currentState, isOpen, currentState.context.user, onResetPasswordError, isLoading]);
  return /*#__PURE__*/jsx$1(UserContext.Provider, _objectSpread$1P({
    value: value
  }, props));
}

function useUserService() {
  var userCtx = React__default.useContext(UserContext);

  if (!userCtx) {
    throw new Error("useUserService must be used within an UserProvider");
  }

  var user = userCtx.currentState.context.user;

  var userName = _get(user, 'userName');

  var ssoUserList = _get(user, 'ssoUserList');

  var billingAddress = _get(user, 'billingAddress');

  return _objectSpread$1P(_objectSpread$1P({}, userCtx), {}, {
    fetchUserInfo: userCtx.fetchUserInfo,
    user: user,
    userName: userName,
    ssoUserList: ssoUserList,
    billingAddress: billingAddress
  });
}

function _regenerator$1E() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1E(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1E(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1E(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1E(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1E(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1E(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1E(u), _regeneratorDefine2$1E(u, o, "Generator"), _regeneratorDefine2$1E(u, n, function () {
    return this;
  }), _regeneratorDefine2$1E(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1E = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1E(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1E = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1E(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1E(e, r, n, t);
}

var SCRIPT_ID$2 = 'ZENDESK_NEW_WIDGET';

function getResellerUrl() {
  if (__PROD__) {
    var integrationIds = {
      'internic.ca': 'internic.zendesk.com',
      'rebel.ca': 'rebelsupport.zendesk.com',
      'rebel.com': 'rebelsupport.zendesk.com'
    };
    return integrationIds[RESELLER.toLowerCase()];
  }

  return 'rebelsupport1707248142.zendesk.com';
}

function getUserJWT() {
  return _getUserJWT.apply(this, arguments);
}

function _getUserJWT() {
  _getUserJWT = _asyncToGenerator( /*#__PURE__*/_regenerator$1E().m(function _callee2() {
    var response;
    return _regenerator$1E().w(function (_context2) {
      while (1) {
        switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return get$3(getUserSunshineJWTEndpoint());

          case 1:
            response = _context2.v;
            return _context2.a(2, response.data.jwt);
        }
      }
    }, _callee2);
  }));
  return _getUserJWT.apply(this, arguments);
}

function loadAndExecuteScript$2() {
  return _loadAndExecuteScript.apply(this, arguments);
}

function _loadAndExecuteScript() {
  _loadAndExecuteScript = _asyncToGenerator( /*#__PURE__*/_regenerator$1E().m(function _callee3() {
    return _regenerator$1E().w(function (_context3) {
      while (1) {
        switch (_context3.n) {
          case 0:
            if (!document.getElementById(SCRIPT_ID$2)) {
              _context3.n = 1;
              break;
            }

            return _context3.a(2, Promise.resolve());

          case 1:
            return _context3.a(2, new Promise(function (resolve) {
              var script = document.createElement('script');
              script.async = true;
              script.type = 'text/javascript';
              script.id = SCRIPT_ID$2;
              var scriptContent = "\n          window.zEmbed ||\n            (function (e, t) {\n              var n,\n                o,\n                d,\n                i,\n                s,\n                a = [],\n                r = document.createElement(\"iframe\");\n              (window.zEmbed = function () {\n                a.push(arguments);\n              }),\n                (window.zE = window.zE || window.zEmbed),\n                (r.src = \"javascript:false\"),\n                (r.title = \"\"),\n                (r.role = \"presentation\"),\n                ((r.frameElement || r).style.cssText = \"display: none\"),\n                (d = document.getElementsByTagName(\"script\")),\n                (d = d[d.length - 1]),\n                d.parentNode.insertBefore(r, d),\n                (i = r.contentWindow),\n                (s = i.document);\n              try {\n                o = s;\n              } catch (e) {\n                (n = document.domain),\n                  (r.src =\n                    'javascript:var d=document.open();d.domain=\"' + n + '\";void(0);'),\n                  (o = s);\n              }\n              (o.open()._l = function () {\n                var o = this.createElement(\"script\");\n                n && (this.domain = n),\n                  (o.id = \"js-iframe-async\"),\n                  (o.src = e),\n                  (this.t = +new Date()),\n                  (this.zendeskHost = t),\n                  (this.zEQueue = a),\n                  this.body.appendChild(o);\n              }),\n                o.write('<body onload=\"document._l();\">'),\n                o.close();\n            })(\n              \"https://assets.zendesk.com/embeddable_framework/main.js\",\n              \"".concat(getResellerUrl(), "\"\n            );\n          ");
              script.textContent = scriptContent;
              document.head.appendChild(script);
              resolve(true);
            }));
        }
      }
    }, _callee3);
  }));
  return _loadAndExecuteScript.apply(this, arguments);
}

function loginUserToWidget() {
  if (!window.zE) return;
  window.zE('messenger', 'loginUser', function (callback) {
    getUserJWT().then(function (token) {
      callback(token);
    });
  });
}

function logoutUserFromWidget() {
  if (!window.zE) return;
  window.zE('messenger', 'logoutUser');
}

function useSunshine() {
  var _useUserService = useUserService(),
      user = _useUserService.user;

  var isSignedIn = Boolean(user === null || user === void 0 ? void 0 : user.customerId);

  function init() {
    return _init.apply(this, arguments);
  }

  function _init() {
    _init = _asyncToGenerator( /*#__PURE__*/_regenerator$1E().m(function _callee() {
      return _regenerator$1E().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              if (hasDOM) {
                _context.n = 1;
                break;
              }

              return _context.a(2);

            case 1:
              if (window.zE) {
                _context.n = 2;
                break;
              }

              _context.n = 2;
              return loadAndExecuteScript$2();

            case 2:
              if (window.zE) {
                _context.n = 3;
                break;
              }

              throw new Error('Zendesk widget setup failed');

            case 3:
              if (isSignedIn) {
                loginUserToWidget();
              } else {
                logoutUserFromWidget();
              }

            case 4:
              return _context.a(2);
          }
        }
      }, _callee);
    }));
    return _init.apply(this, arguments);
  }

  function openChat() {
    if (!hasDOM) return;
    var script = document.getElementById(SCRIPT_ID$2);

    if (script && window.zE) {
      window.zE('messenger', 'open');
    } else {
      init().then(function () {
        if (!window.zE) return;
        window.zE('messenger', 'open');
      });
    }
  }

  useEffect(function () {
    init();
  }, [user]);
  return {
    openChat: openChat
  };
}

var useTabTrapper = function useTabTrapper(ref) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var lastFocusedEl = arguments.length > 2 ? arguments[2] : undefined;
  var firstItem;
  var lastItem;
  var focusElements;
  useEffect(function () {
    var node;

    if (ref) {
      node = ref.current;

      if (node) {
        focusElements = Array.from(node.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable], audio[controls], video[controls], summary')); // eslint-disable-next-line prefer-destructuring

        firstItem = focusElements[0];
        lastItem = focusElements[focusElements.length - 1]; // eslint-disable-next-line no-use-before-define

        node.addEventListener('keydown', trap);

        if (firstItem) {
          firstItem.focus();
        }
      }
    }

    return function () {
      if (lastFocusedEl) {
        lastFocusedEl.focus();
      }

      if (node) {
        // eslint-disable-next-line no-use-before-define
        node.removeEventListener('keydown', trap);
      }
    };
  }, deps);

  function trap(event) {
    // Tab is pressed
    if (event.keyCode === 9) {
      // Shift is held down
      if (event.shiftKey) {
        // Backwards (Holding shift and pressing tab goes backwards)
        if (hasDOM && document.activeElement === firstItem) {
          event.preventDefault();
          lastItem.focus();
        }

        return;
      }

      if (hasDOM && document.activeElement === lastItem) {
        // Forwards (because shift key is not being held)
        event.preventDefault();
        firstItem.focus();
      }
    }
  }

  return null;
};

var _excluded$L = ["component", "title"];

function ownKeys$1O(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1O(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1O(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1O(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}
/**
 * To be used when defining a new route within a Router.
 * Component to display, and path at which that component should be displayed.
 */


function Route(_ref) {
  var Component = _ref.component,
      title = _ref.title,
      rest = _objectWithoutProperties$8(_ref, _excluded$L);

  useDocumentTitle(title);
  return /*#__PURE__*/jsx$1(Component, _objectSpread$1O({}, rest));
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);

  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  } // Binding "this" is important for shallow renderer support.


  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
} // React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.


componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') {
    return Component;
  } // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.


  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;

  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }

  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }

  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }

  if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
    var componentName = Component.displayName || Component.name;
    var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
    throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
  } // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.


  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  } // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.


  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
    }

    prototype.componentWillUpdate = componentWillUpdate;
    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
} ////////////////////////////////////////////////////////////////////////////////
// startsWith(string, search) - Check if `string` starts with `search`


var startsWith = function startsWith(string, search) {
  return string.substr(0, search.length) === search;
}; ////////////////////////////////////////////////////////////////////////////////
// pick(routes, uri)
//
// Ranks and picks the best route to match. Each segment gets the highest
// amount of points, then the type of segment gets an additional amount of
// points where
//
//     static > dynamic > splat > root
//
// This way we don't have to worry about the order of our routes, let the
// computers do it.
//
// A route looks like this
//
//     { path, default, value }
//
// And a returned match looks like:
//
//     { route, params, uri }
//
// I know, I should use TypeScript not comments for these types.


var pick = function pick(routes, uri) {
  var match = void 0;
  var default_ = void 0;

  var _uri$split = uri.split("?"),
      uriPathname = _uri$split[0];

  var uriSegments = segmentize(uriPathname);
  var isRootUri = uriSegments[0] === "";
  var ranked = rankRoutes(routes);

  for (var i = 0, l = ranked.length; i < l; i++) {
    var missed = false;
    var route = ranked[i].route;

    if (route.default) {
      default_ = {
        route: route,
        params: {},
        uri: uri
      };
      continue;
    }

    var routeSegments = segmentize(route.path);
    var params = {};
    var max = Math.max(uriSegments.length, routeSegments.length);
    var index = 0;

    for (; index < max; index++) {
      var routeSegment = routeSegments[index];
      var uriSegment = uriSegments[index];

      if (isSplat(routeSegment)) {
        // Hit a splat, just grab the rest, and return a match
        // uri:   /files/documents/work
        // route: /files/*
        var param = routeSegment.slice(1) || "*";
        params[param] = uriSegments.slice(index).map(decodeURIComponent).join("/");
        break;
      }

      if (uriSegment === undefined) {
        // URI is shorter than the route, no match
        // uri:   /users
        // route: /users/:userId
        missed = true;
        break;
      }

      var dynamicMatch = paramRe.exec(routeSegment);

      if (dynamicMatch && !isRootUri) {
        var matchIsNotReserved = reservedNames.indexOf(dynamicMatch[1]) === -1;
        !matchIsNotReserved ? process$1.env.NODE_ENV !== "production" ? invariant$2(false, "<Router> dynamic segment \"" + dynamicMatch[1] + "\" is a reserved name. Please use a different name in path \"" + route.path + "\".") : invariant$2(false) : void 0;
        var value = decodeURIComponent(uriSegment);
        params[dynamicMatch[1]] = value;
      } else if (routeSegment !== uriSegment) {
        // Current segments don't match, not dynamic, not splat, so no match
        // uri:   /users/123/settings
        // route: /users/:id/profile
        missed = true;
        break;
      }
    }

    if (!missed) {
      match = {
        route: route,
        params: params,
        uri: "/" + uriSegments.slice(0, index).join("/")
      };
      break;
    }
  }

  return match || default_ || null;
}; ////////////////////////////////////////////////////////////////////////////////
// match(path, uri) - Matches just one path to a uri, also lol


var match$2 = function match(path, uri) {
  return pick([{
    path: path
  }], uri);
}; ////////////////////////////////////////////////////////////////////////////////
// resolve(to, basepath)
//
// Resolves URIs as though every path is a directory, no files.  Relative URIs
// in the browser can feel awkward because not only can you be "in a directory"
// you can be "at a file", too. For example
//
//     browserSpecResolve('foo', '/bar/') => /bar/foo
//     browserSpecResolve('foo', '/bar') => /foo
//
// But on the command line of a file system, it's not as complicated, you can't
// `cd` from a file, only directories.  This way, links have to know less about
// their current path. To go deeper you can do this:
//
//     <Link to="deeper"/>
//     // instead of
//     <Link to=`{${props.uri}/deeper}`/>
//
// Just like `cd`, if you want to go deeper from the command line, you do this:
//
//     cd deeper
//     # not
//     cd $(pwd)/deeper
//
// By treating every path as a directory, linking to relative paths should
// require less contextual information and (fingers crossed) be more intuitive.


var resolve = function resolve(to, base) {
  // /foo/bar, /baz/qux => /foo/bar
  if (startsWith(to, "/")) {
    return to;
  }

  var _to$split = to.split("?"),
      toPathname = _to$split[0],
      toQuery = _to$split[1];

  var _base$split = base.split("?"),
      basePathname = _base$split[0];

  var toSegments = segmentize(toPathname);
  var baseSegments = segmentize(basePathname); // ?a=b, /users?b=c => /users?a=b

  if (toSegments[0] === "") {
    return addQuery(basePathname, toQuery);
  } // profile, /users/789 => /users/789/profile


  if (!startsWith(toSegments[0], ".")) {
    var pathname = baseSegments.concat(toSegments).join("/");
    return addQuery((basePathname === "/" ? "" : "/") + pathname, toQuery);
  } // ./         /users/123  =>  /users/123
  // ../        /users/123  =>  /users
  // ../..      /users/123  =>  /
  // ../../one  /a/b/c/d    =>  /a/b/one
  // .././one   /a/b/c/d    =>  /a/b/c/one


  var allSegments = baseSegments.concat(toSegments);
  var segments = [];

  for (var i = 0, l = allSegments.length; i < l; i++) {
    var segment = allSegments[i];
    if (segment === "..") segments.pop();else if (segment !== ".") segments.push(segment);
  }

  return addQuery("/" + segments.join("/"), toQuery);
}; ////////////////////////////////////////////////////////////////////////////////
// insertParams(path, params)


var insertParams = function insertParams(path, params) {
  var _path$split = path.split("?"),
      pathBase = _path$split[0],
      _path$split$ = _path$split[1],
      query = _path$split$ === undefined ? "" : _path$split$;

  var segments = segmentize(pathBase);
  var constructedPath = "/" + segments.map(function (segment) {
    var match = paramRe.exec(segment);
    return match ? params[match[1]] : segment;
  }).join("/");
  var _params$location = params.location;
  _params$location = _params$location === undefined ? {} : _params$location;
  var _params$location$sear = _params$location.search,
      search = _params$location$sear === undefined ? "" : _params$location$sear;
  var searchSplit = search.split("?")[1] || "";
  constructedPath = addQuery(constructedPath, query, searchSplit);
  return constructedPath;
};

var validateRedirect = function validateRedirect(from, to) {
  var filter = function filter(segment) {
    return isDynamic(segment);
  };

  var fromString = segmentize(from).filter(filter).sort().join("/");
  var toString = segmentize(to).filter(filter).sort().join("/");
  return fromString === toString;
}; ////////////////////////////////////////////////////////////////////////////////
// Junk


var paramRe = /^:(.+)/;
var SEGMENT_POINTS = 4;
var STATIC_POINTS = 3;
var DYNAMIC_POINTS = 2;
var SPLAT_PENALTY = 1;
var ROOT_POINTS = 1;

var isRootSegment = function isRootSegment(segment) {
  return segment === "";
};

var isDynamic = function isDynamic(segment) {
  return paramRe.test(segment);
};

var isSplat = function isSplat(segment) {
  return segment && segment[0] === "*";
};

var rankRoute = function rankRoute(route, index) {
  var score = route.default ? 0 : segmentize(route.path).reduce(function (score, segment) {
    score += SEGMENT_POINTS;
    if (isRootSegment(segment)) score += ROOT_POINTS;else if (isDynamic(segment)) score += DYNAMIC_POINTS;else if (isSplat(segment)) score -= SEGMENT_POINTS + SPLAT_PENALTY;else score += STATIC_POINTS;
    return score;
  }, 0);
  return {
    route: route,
    score: score,
    index: index
  };
};

var rankRoutes = function rankRoutes(routes) {
  return routes.map(rankRoute).sort(function (a, b) {
    return a.score < b.score ? 1 : a.score > b.score ? -1 : a.index - b.index;
  });
};

var segmentize = function segmentize(uri) {
  return uri // strip starting/ending slashes
  .replace(/(^\/+|\/+$)/g, "").split("/");
};

var addQuery = function addQuery(pathname) {
  for (var _len = arguments.length, query = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    query[_key - 1] = arguments[_key];
  }

  query = query.filter(function (q) {
    return q && q.length > 0;
  });
  return pathname + (query && query.length > 0 ? "?" + query.join("&") : "");
};

var reservedNames = ["uri", "path"];
/**
 * Shallow compares two objects.
 * @param {Object} obj1 The first object to compare.
 * @param {Object} obj2 The second object to compare.
 */

var shallowCompare$1 = function shallowCompare(obj1, obj2) {
  var obj1Keys = Object.keys(obj1);
  return obj1Keys.length === Object.keys(obj2).length && obj1Keys.every(function (key) {
    return obj2.hasOwnProperty(key) && obj1[key] === obj2[key];
  });
};

var _extends$a = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var getLocation = function getLocation(source) {
  var _source$location = source.location,
      search = _source$location.search,
      hash = _source$location.hash,
      href = _source$location.href,
      origin = _source$location.origin,
      protocol = _source$location.protocol,
      host = _source$location.host,
      hostname = _source$location.hostname,
      port = _source$location.port;
  var pathname = source.location.pathname;

  if (!pathname && href && canUseDOM) {
    var url = new URL(href);
    pathname = url.pathname;
  }

  return {
    pathname: encodeURI(decodeURI(pathname)),
    search: search,
    hash: hash,
    href: href,
    origin: origin,
    protocol: protocol,
    host: host,
    hostname: hostname,
    port: port,
    state: source.history.state,
    key: source.history.state && source.history.state.key || "initial"
  };
};

var createHistory = function createHistory(source, options) {
  var listeners = [];
  var location = getLocation(source);
  var transitioning = false;

  var resolveTransition = function resolveTransition() {};

  return {
    get location() {
      return location;
    },

    get transitioning() {
      return transitioning;
    },

    _onTransitionComplete: function _onTransitionComplete() {
      transitioning = false;
      resolveTransition();
    },
    listen: function listen(listener) {
      listeners.push(listener);

      var popstateListener = function popstateListener() {
        location = getLocation(source);
        listener({
          location: location,
          action: "POP"
        });
      };

      source.addEventListener("popstate", popstateListener);
      return function () {
        source.removeEventListener("popstate", popstateListener);
        listeners = listeners.filter(function (fn) {
          return fn !== listener;
        });
      };
    },
    navigate: function navigate(to) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          state = _ref.state,
          _ref$replace = _ref.replace,
          replace = _ref$replace === undefined ? false : _ref$replace;

      if (typeof to === "number") {
        source.history.go(to);
      } else {
        state = _extends$a({}, state, {
          key: Date.now() + ""
        }); // try...catch iOS Safari limits to 100 pushState calls

        try {
          if (transitioning || replace) {
            source.history.replaceState(state, null, to);
          } else {
            source.history.pushState(state, null, to);
          }
        } catch (e) {
          source.location[replace ? "replace" : "assign"](to);
        }
      }

      location = getLocation(source);
      transitioning = true;
      var transition = new Promise(function (res) {
        return resolveTransition = res;
      });
      listeners.forEach(function (listener) {
        return listener({
          location: location,
          action: "PUSH"
        });
      });
      return transition;
    }
  };
}; ////////////////////////////////////////////////////////////////////////////////
// Stores history entries in memory for testing or other platforms like Native


var createMemorySource = function createMemorySource() {
  var initialPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var searchIndex = initialPath.indexOf("?");
  var initialLocation = {
    pathname: searchIndex > -1 ? initialPath.substr(0, searchIndex) : initialPath,
    search: searchIndex > -1 ? initialPath.substr(searchIndex) : ""
  };
  var index = 0;
  var stack = [initialLocation];
  var states = [null];
  return {
    get location() {
      return stack[index];
    },

    addEventListener: function addEventListener(name, fn) {},
    removeEventListener: function removeEventListener(name, fn) {},
    history: {
      get entries() {
        return stack;
      },

      get index() {
        return index;
      },

      get state() {
        return states[index];
      },

      pushState: function pushState(state, _, uri) {
        var _uri$split = uri.split("?"),
            pathname = _uri$split[0],
            _uri$split$ = _uri$split[1],
            search = _uri$split$ === undefined ? "" : _uri$split$;

        index++;
        stack.push({
          pathname: pathname,
          search: search.length ? "?" + search : search
        });
        states.push(state);
      },
      replaceState: function replaceState(state, _, uri) {
        var _uri$split2 = uri.split("?"),
            pathname = _uri$split2[0],
            _uri$split2$ = _uri$split2[1],
            search = _uri$split2$ === undefined ? "" : _uri$split2$;

        stack[index] = {
          pathname: pathname,
          search: search
        };
        states[index] = state;
      },
      go: function go(to) {
        var newIndex = index + to;

        if (newIndex < 0 || newIndex > states.length - 1) {
          return;
        }

        index = newIndex;
      }
    }
  };
}; ////////////////////////////////////////////////////////////////////////////////
// global history - uses window.history as the source if available, otherwise a
// memory history


var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);

var getSource = function getSource() {
  return canUseDOM ? window : createMemorySource();
};

var globalHistory = createHistory(getSource());
var navigate = globalHistory.navigate;

var _extends$9 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$6(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck$8(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} ////////////////////////////////////////////////////////////////////////////////


var createNamedContext = function createNamedContext(name, defaultValue) {
  var Ctx = createContext$1(defaultValue);
  Ctx.displayName = name;
  return Ctx;
}; ////////////////////////////////////////////////////////////////////////////////
// Location Context/Provider


var LocationContext = createNamedContext("Location"); // sets up a listener if there isn't one already so apps don't need to be
// wrapped in some top level provider

var Location = function Location(_ref) {
  var children = _ref.children;
  return React__default.createElement(LocationContext.Consumer, null, function (context) {
    return context ? children(context) : React__default.createElement(LocationProvider, null, children);
  });
};

var LocationProvider = function (_React$Component) {
  _inherits(LocationProvider, _React$Component);

  function LocationProvider() {
    var _temp, _this, _ret;

    _classCallCheck$8(this, LocationProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      context: _this.getContext(),
      refs: {
        unlisten: null
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  LocationProvider.prototype.getContext = function getContext() {
    var _props$history = this.props.history,
        navigate = _props$history.navigate,
        location = _props$history.location;
    return {
      navigate: navigate,
      location: location
    };
  };

  LocationProvider.prototype.componentDidCatch = function componentDidCatch(error, info) {
    if (isRedirect(error)) {
      var _navigate = this.props.history.navigate;

      _navigate(error.uri, {
        replace: true
      });
    } else {
      throw error;
    }
  };

  LocationProvider.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevState.context.location !== this.state.context.location) {
      this.props.history._onTransitionComplete();
    }
  };

  LocationProvider.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var refs = this.state.refs,
        history = this.props.history;

    history._onTransitionComplete();

    refs.unlisten = history.listen(function () {
      Promise.resolve().then(function () {
        // TODO: replace rAF with react deferred update API when it's ready https://github.com/facebook/react/issues/13306
        requestAnimationFrame(function () {
          if (!_this2.unmounted) {
            _this2.setState(function () {
              return {
                context: _this2.getContext()
              };
            });
          }
        });
      });
    });
  };

  LocationProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    var refs = this.state.refs;
    this.unmounted = true;
    refs.unlisten();
  };

  LocationProvider.prototype.render = function render() {
    var context = this.state.context,
        children = this.props.children;
    return React__default.createElement(LocationContext.Provider, {
      value: context
    }, typeof children === "function" ? children(context) : children || null);
  };

  return LocationProvider;
}(React__default.Component); ////////////////////////////////////////////////////////////////////////////////


LocationProvider.defaultProps = {
  history: globalHistory
};
process$1.env.NODE_ENV !== "production" ? LocationProvider.propTypes = {
  history: PropTypes.object.isRequired
} : void 0; ////////////////////////////////////////////////////////////////////////////////
// Sets baseuri and basepath for nested routers and links

var BaseContext = createNamedContext("Base", {
  baseuri: "/",
  basepath: "/"
}); ////////////////////////////////////////////////////////////////////////////////
// The main event, welcome to the show everybody.

var Router = function Router(props) {
  return React__default.createElement(BaseContext.Consumer, null, function (baseContext) {
    return React__default.createElement(Location, null, function (locationContext) {
      return React__default.createElement(RouterImpl, _extends$9({}, baseContext, locationContext, props));
    });
  });
};

var RouterImpl = function (_React$PureComponent) {
  _inherits(RouterImpl, _React$PureComponent);

  function RouterImpl() {
    _classCallCheck$8(this, RouterImpl);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  RouterImpl.prototype.render = function render() {
    var _props = this.props,
        location = _props.location,
        _navigate2 = _props.navigate,
        basepath = _props.basepath,
        primary = _props.primary,
        children = _props.children;
    _props.baseuri;

    var _props$component = _props.component,
        component = _props$component === undefined ? "div" : _props$component,
        domProps = _objectWithoutProperties$6(_props, ["location", "navigate", "basepath", "primary", "children", "baseuri", "component"]);

    var routes = React__default.Children.toArray(children).reduce(function (array, child) {
      var routes = createRoute(basepath)(child);
      return array.concat(routes);
    }, []);
    var pathname = location.pathname;
    var match = pick(routes, pathname);

    if (match) {
      var params = match.params,
          uri = match.uri,
          route = match.route,
          element = match.route.value; // remove the /* from the end for child routes relative paths

      basepath = route.default ? basepath : route.path.replace(/\*$/, "");

      var props = _extends$9({}, params, {
        uri: uri,
        location: location,
        navigate: function navigate(to, options) {
          return _navigate2(resolve(to, uri), options);
        }
      });

      var clone = React__default.cloneElement(element, props, element.props.children ? React__default.createElement(Router, {
        location: location,
        primary: primary
      }, element.props.children) : undefined); // using 'div' for < 16.3 support

      var FocusWrapper = primary ? FocusHandler : component; // don't pass any props to 'div'

      var wrapperProps = primary ? _extends$9({
        uri: uri,
        location: location,
        component: component
      }, domProps) : domProps;
      return React__default.createElement(BaseContext.Provider, {
        value: {
          baseuri: uri,
          basepath: basepath
        }
      }, React__default.createElement(FocusWrapper, wrapperProps, clone));
    } else {
      // Not sure if we want this, would require index routes at every level
      // warning(
      //   false,
      //   `<Router basepath="${basepath}">\n\nNothing matched:\n\t${
      //     location.pathname
      //   }\n\nPaths checked: \n\t${routes
      //     .map(route => route.path)
      //     .join(
      //       "\n\t"
      //     )}\n\nTo get rid of this warning, add a default NotFound component as child of Router:
      //   \n\tlet NotFound = () => <div>Not Found!</div>
      //   \n\t<Router>\n\t  <NotFound default/>\n\t  {/* ... */}\n\t</Router>`
      // );
      return null;
    }
  };

  return RouterImpl;
}(React__default.PureComponent);

RouterImpl.defaultProps = {
  primary: true
};
var FocusContext = createNamedContext("Focus");

var FocusHandler = function FocusHandler(_ref3) {
  var uri = _ref3.uri,
      location = _ref3.location,
      component = _ref3.component,
      domProps = _objectWithoutProperties$6(_ref3, ["uri", "location", "component"]);

  return React__default.createElement(FocusContext.Consumer, null, function (requestFocus) {
    return React__default.createElement(FocusHandlerImpl, _extends$9({}, domProps, {
      component: component,
      requestFocus: requestFocus,
      uri: uri,
      location: location
    }));
  });
}; // don't focus on initial render


var initialRender = true;
var focusHandlerCount = 0;

var FocusHandlerImpl = function (_React$Component2) {
  _inherits(FocusHandlerImpl, _React$Component2);

  function FocusHandlerImpl() {
    var _temp2, _this4, _ret2;

    _classCallCheck$8(this, FocusHandlerImpl);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this4 = _possibleConstructorReturn(this, _React$Component2.call.apply(_React$Component2, [this].concat(args))), _this4), _this4.state = {}, _this4.requestFocus = function (node) {
      if (!_this4.state.shouldFocus && node) {
        node.focus();
      }
    }, _temp2), _possibleConstructorReturn(_this4, _ret2);
  }

  FocusHandlerImpl.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var initial = prevState.uri == null;

    if (initial) {
      return _extends$9({
        shouldFocus: true
      }, nextProps);
    } else {
      var myURIChanged = nextProps.uri !== prevState.uri;
      var navigatedUpToMe = prevState.location.pathname !== nextProps.location.pathname && nextProps.location.pathname === nextProps.uri;
      return _extends$9({
        shouldFocus: myURIChanged || navigatedUpToMe
      }, nextProps);
    }
  };

  FocusHandlerImpl.prototype.componentDidMount = function componentDidMount() {
    focusHandlerCount++;
    this.focus();
  };

  FocusHandlerImpl.prototype.componentWillUnmount = function componentWillUnmount() {
    focusHandlerCount--;

    if (focusHandlerCount === 0) {
      initialRender = true;
    }
  };

  FocusHandlerImpl.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevProps.location !== this.props.location && this.state.shouldFocus) {
      this.focus();
    }
  };

  FocusHandlerImpl.prototype.focus = function focus() {
    if (process$1.env.NODE_ENV === "test") {
      // getting cannot read property focus of null in the tests
      // and that bit of global `initialRender` state causes problems
      // should probably figure it out!
      return;
    }

    var requestFocus = this.props.requestFocus;

    if (requestFocus) {
      requestFocus(this.node);
    } else {
      if (initialRender) {
        initialRender = false;
      } else if (this.node) {
        // React polyfills [autofocus] and it fires earlier than cDM,
        // so we were stealing focus away, this line prevents that.
        if (!this.node.contains(document.activeElement)) {
          this.node.focus();
        }
      }
    }
  };

  FocusHandlerImpl.prototype.render = function render() {
    var _this5 = this;

    var _props2 = this.props;
    _props2.children;
    var style = _props2.style;
    _props2.requestFocus;
    var _props2$component = _props2.component,
        Comp = _props2$component === undefined ? "div" : _props2$component;
    _props2.uri;
    _props2.location;

    var domProps = _objectWithoutProperties$6(_props2, ["children", "style", "requestFocus", "component", "uri", "location"]);

    return React__default.createElement(Comp, _extends$9({
      style: _extends$9({
        outline: "none"
      }, style),
      tabIndex: "-1",
      ref: function ref(n) {
        return _this5.node = n;
      }
    }, domProps), React__default.createElement(FocusContext.Provider, {
      value: this.requestFocus
    }, this.props.children));
  };

  return FocusHandlerImpl;
}(React__default.Component);

polyfill(FocusHandlerImpl);

var k = function k() {}; ////////////////////////////////////////////////////////////////////////////////


var forwardRef = React__default.forwardRef;

if (typeof forwardRef === "undefined") {
  forwardRef = function forwardRef(C) {
    return C;
  };
}

var Link = forwardRef(function (_ref4, ref) {
  var innerRef = _ref4.innerRef,
      props = _objectWithoutProperties$6(_ref4, ["innerRef"]);

  return React__default.createElement(BaseContext.Consumer, null, function (_ref5) {
    _ref5.basepath;
    var baseuri = _ref5.baseuri;
    return React__default.createElement(Location, null, function (_ref6) {
      var location = _ref6.location,
          navigate = _ref6.navigate;

      var to = props.to,
          state = props.state,
          replace = props.replace,
          _props$getProps = props.getProps,
          getProps = _props$getProps === undefined ? k : _props$getProps,
          anchorProps = _objectWithoutProperties$6(props, ["to", "state", "replace", "getProps"]);

      var href = resolve(to, baseuri);
      var encodedHref = encodeURI(href);
      var isCurrent = location.pathname === encodedHref;
      var isPartiallyCurrent = startsWith(location.pathname, encodedHref);
      return React__default.createElement("a", _extends$9({
        ref: ref || innerRef,
        "aria-current": isCurrent ? "page" : undefined
      }, anchorProps, getProps({
        isCurrent: isCurrent,
        isPartiallyCurrent: isPartiallyCurrent,
        href: href,
        location: location
      }), {
        href: href,
        onClick: function onClick(event) {
          if (anchorProps.onClick) anchorProps.onClick(event);

          if (shouldNavigate(event)) {
            event.preventDefault();
            var shouldReplace = replace;

            if (typeof replace !== "boolean" && isCurrent) {
              var _location$state = _extends$9({}, location.state);

              _location$state.key;

              var restState = _objectWithoutProperties$6(_location$state, ["key"]);

              shouldReplace = shallowCompare$1(_extends$9({}, state), restState);
            }

            navigate(href, {
              state: state,
              replace: shouldReplace
            });
          }
        }
      }));
    });
  });
});
Link.displayName = "Link";
process$1.env.NODE_ENV !== "production" ? Link.propTypes = {
  to: PropTypes.string.isRequired
} : void 0; ////////////////////////////////////////////////////////////////////////////////

function RedirectRequest(uri) {
  this.uri = uri;
}

var isRedirect = function isRedirect(o) {
  return o instanceof RedirectRequest;
};

var redirectTo = function redirectTo(to) {
  throw new RedirectRequest(to);
};

var RedirectImpl = function (_React$Component3) {
  _inherits(RedirectImpl, _React$Component3);

  function RedirectImpl() {
    _classCallCheck$8(this, RedirectImpl);

    return _possibleConstructorReturn(this, _React$Component3.apply(this, arguments));
  } // Support React < 16 with this hook


  RedirectImpl.prototype.componentDidMount = function componentDidMount() {
    var _props3 = this.props,
        navigate = _props3.navigate,
        to = _props3.to;
    _props3.from;
    var _props3$replace = _props3.replace,
        replace = _props3$replace === undefined ? true : _props3$replace,
        state = _props3.state;
    _props3.noThrow;

    var baseuri = _props3.baseuri,
        props = _objectWithoutProperties$6(_props3, ["navigate", "to", "from", "replace", "state", "noThrow", "baseuri"]);

    Promise.resolve().then(function () {
      var resolvedTo = resolve(to, baseuri);
      navigate(insertParams(resolvedTo, props), {
        replace: replace,
        state: state
      });
    });
  };

  RedirectImpl.prototype.render = function render() {
    var _props4 = this.props;
    _props4.navigate;
    var to = _props4.to;
    _props4.from;
    _props4.replace;
    _props4.state;

    var noThrow = _props4.noThrow,
        baseuri = _props4.baseuri,
        props = _objectWithoutProperties$6(_props4, ["navigate", "to", "from", "replace", "state", "noThrow", "baseuri"]);

    var resolvedTo = resolve(to, baseuri);
    if (!noThrow) redirectTo(insertParams(resolvedTo, props));
    return null;
  };

  return RedirectImpl;
}(React__default.Component);

var Redirect = function Redirect(props) {
  return React__default.createElement(BaseContext.Consumer, null, function (_ref7) {
    var baseuri = _ref7.baseuri;
    return React__default.createElement(Location, null, function (locationContext) {
      return React__default.createElement(RedirectImpl, _extends$9({}, locationContext, {
        baseuri: baseuri
      }, props));
    });
  });
};

process$1.env.NODE_ENV !== "production" ? Redirect.propTypes = {
  from: PropTypes.string,
  to: PropTypes.string.isRequired
} : void 0; ////////////////////////////////////////////////////////////////////////////////
// Hooks

var useLocation = function useLocation() {
  var context = useContext(LocationContext);

  if (!context) {
    throw new Error("useLocation hook was used but a LocationContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
  }

  return context.location;
};

var useParams = function useParams() {
  var context = useContext(BaseContext);

  if (!context) {
    throw new Error("useParams hook was used but a LocationContext.Provider was not found in the parent tree. Make sure this is used in a component that is a child of Router");
  }

  var location = useLocation();
  var results = match$2(context.basepath, location.pathname);
  return results ? results.params : null;
}; ////////////////////////////////////////////////////////////////////////////////
// Junk


var stripSlashes = function stripSlashes(str) {
  return str.replace(/(^\/+|\/+$)/g, "");
};

var createRoute = function createRoute(basepath) {
  return function (element) {
    if (!element) {
      return null;
    }

    if (element.type === React__default.Fragment && element.props.children) {
      return React__default.Children.map(element.props.children, createRoute(basepath));
    }

    !(element.props.path || element.props.default || element.type === Redirect) ? process$1.env.NODE_ENV !== "production" ? invariant$2(false, "<Router>: Children of <Router> must have a `path` or `default` prop, or be a `<Redirect>`. None found on element type `" + element.type + "`") : invariant$2(false) : void 0;
    !!(element.type === Redirect && (!element.props.from || !element.props.to)) ? process$1.env.NODE_ENV !== "production" ? invariant$2(false, "<Redirect from=\"" + element.props.from + "\" to=\"" + element.props.to + "\"/> requires both \"from\" and \"to\" props when inside a <Router>.") : invariant$2(false) : void 0;
    !!(element.type === Redirect && !validateRedirect(element.props.from, element.props.to)) ? process$1.env.NODE_ENV !== "production" ? invariant$2(false, "<Redirect from=\"" + element.props.from + " to=\"" + element.props.to + "\"/> has mismatched dynamic segments, ensure both paths have the exact same dynamic segments.") : invariant$2(false) : void 0;

    if (element.props.default) {
      return {
        value: element,
        default: true
      };
    }

    var elementPath = element.type === Redirect ? element.props.from : element.props.path;
    var path = elementPath === "/" ? basepath : stripSlashes(basepath) + "/" + stripSlashes(elementPath);
    return {
      value: element,
      default: element.props.default,
      path: element.props.children ? stripSlashes(path) + "/*" : path
    };
  };
};

var shouldNavigate = function shouldNavigate(event) {
  return !event.defaultPrevented && event.button === 0 && !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};
/**
 * Fuse.js v7.1.0 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2025 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */


function isArray$3(value) {
  return !Array.isArray ? getTag$2(value) === '[object Array]' : Array.isArray(value);
} // Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js


var INFINITY$2 = 1 / 0;

function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$2 ? '-0' : result;
}

function toString$4(value) {
  return value == null ? '' : baseToString$1(value);
}

function isString$2(value) {
  return typeof value === 'string';
}

function isNumber(value) {
  return typeof value === 'number';
} // Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js


function isBoolean$1(value) {
  return value === true || value === false || isObjectLike$1(value) && getTag$2(value) == '[object Boolean]';
}

function isObject$5(value) {
  return typeof value === 'object';
} // Checks if `value` is object-like.


function isObjectLike$1(value) {
  return isObject$5(value) && value !== null;
}

function isDefined(value) {
  return value !== undefined && value !== null;
}

function isBlank(value) {
  return !value.trim().length;
} // Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js


function getTag$2(value) {
  return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}

var EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
var INCORRECT_INDEX_TYPE = "Incorrect 'index' type";

var LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = function LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key) {
  return "Invalid value for key ".concat(key);
};

var PATTERN_LENGTH_TOO_LARGE = function PATTERN_LENGTH_TOO_LARGE(max) {
  return "Pattern length exceeds max of ".concat(max, ".");
};

var MISSING_KEY_PROPERTY = function MISSING_KEY_PROPERTY(name) {
  return "Missing ".concat(name, " property in key");
};

var INVALID_KEY_WEIGHT_VALUE = function INVALID_KEY_WEIGHT_VALUE(key) {
  return "Property 'weight' in key '".concat(key, "' must be a positive integer");
};

var hasOwn$1 = Object.prototype.hasOwnProperty;

var KeyStore = /*#__PURE__*/function () {
  function KeyStore(keys) {
    var _this7 = this;

    _classCallCheck2(this, KeyStore);

    this._keys = [];
    this._keyMap = {};
    var totalWeight = 0;
    keys.forEach(function (key) {
      var obj = createKey(key);

      _this7._keys.push(obj);

      _this7._keyMap[obj.id] = obj;
      totalWeight += obj.weight;
    }); // Normalize weights so that their sum is equal to 1

    this._keys.forEach(function (key) {
      key.weight /= totalWeight;
    });
  }

  _createClass2(KeyStore, [{
    key: "get",
    value: function get(keyId) {
      return this._keyMap[keyId];
    }
  }, {
    key: "keys",
    value: function keys() {
      return this._keys;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return JSON.stringify(this._keys);
    }
  }]);

  return KeyStore;
}();

function createKey(key) {
  var path = null;
  var id = null;
  var src = null;
  var weight = 1;
  var getFn = null;

  if (isString$2(key) || isArray$3(key)) {
    src = key;
    path = createKeyPath(key);
    id = createKeyId(key);
  } else {
    if (!hasOwn$1.call(key, 'name')) {
      throw new Error(MISSING_KEY_PROPERTY('name'));
    }

    var name = key.name;
    src = name;

    if (hasOwn$1.call(key, 'weight')) {
      weight = key.weight;

      if (weight <= 0) {
        throw new Error(INVALID_KEY_WEIGHT_VALUE(name));
      }
    }

    path = createKeyPath(name);
    id = createKeyId(name);
    getFn = key.getFn;
  }

  return {
    path: path,
    id: id,
    weight: weight,
    src: src,
    getFn: getFn
  };
}

function createKeyPath(key) {
  return isArray$3(key) ? key : key.split('.');
}

function createKeyId(key) {
  return isArray$3(key) ? key.join('.') : key;
}

function get$2(obj, path) {
  var list = [];
  var arr = false;

  var deepGet = function deepGet(obj, path, index) {
    if (!isDefined(obj)) {
      return;
    }

    if (!path[index]) {
      // If there's no path left, we've arrived at the object we care about.
      list.push(obj);
    } else {
      var key = path[index];
      var value = obj[key];

      if (!isDefined(value)) {
        return;
      } // If we're at the last value in the path, and if it's a string/number/bool,
      // add it to the list


      if (index === path.length - 1 && (isString$2(value) || isNumber(value) || isBoolean$1(value))) {
        list.push(toString$4(value));
      } else if (isArray$3(value)) {
        arr = true; // Search each item in the array.

        for (var _i2 = 0, len = value.length; _i2 < len; _i2 += 1) {
          deepGet(value[_i2], path, index + 1);
        }
      } else if (path.length) {
        // An object. Recurse further.
        deepGet(value, path, index + 1);
      }
    }
  }; // Backwards compatibility (since path used to be a string)


  deepGet(obj, isString$2(path) ? path.split('.') : path, 0);
  return arr ? list : list[0];
}

var MatchOptions = {
  // Whether the matches should be included in the result set. When `true`, each record in the result
  // set will include the indices of the matched characters.
  // These can consequently be used for highlighting purposes.
  includeMatches: false,
  // When `true`, the matching function will continue to the end of a search pattern even if
  // a perfect match has already been located in the string.
  findAllMatches: false,
  // Minimum number of characters that must be matched before a result is considered a match
  minMatchCharLength: 1
};
var BasicOptions = {
  // When `true`, the algorithm continues searching to the end of the input even if a perfect
  // match is found before the end of the same input.
  isCaseSensitive: false,
  // When `true`, the algorithm will ignore diacritics (accents) in comparisons
  ignoreDiacritics: false,
  // When true, the matching function will continue to the end of a search pattern even if
  includeScore: false,
  // List of properties that will be searched. This also supports nested properties.
  keys: [],
  // Whether to sort the result list, by score
  shouldSort: true,
  // Default sort function: sort by ascending score, ascending index
  sortFn: function sortFn(a, b) {
    return a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1;
  }
};
var FuzzyOptions = {
  // Approximately where in the text is the pattern expected to be found?
  location: 0,
  // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
  // (of both letters and location), a threshold of '1.0' would match anything.
  threshold: 0.6,
  // Determines how close the match must be to the fuzzy location (specified above).
  // An exact letter match which is 'distance' characters away from the fuzzy location
  // would score as a complete mismatch. A distance of '0' requires the match be at
  // the exact location specified, a threshold of '1000' would require a perfect match
  // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
  distance: 100
};
var AdvancedOptions = {
  // When `true`, it enables the use of unix-like search commands
  useExtendedSearch: false,
  // The get function to use when fetching an object's properties.
  // The default will search nested paths *ie foo.bar.baz*
  getFn: get$2,
  // When `true`, search will ignore `location` and `distance`, so it won't matter
  // where in the string the pattern appears.
  // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
  ignoreLocation: false,
  // When `true`, the calculation for the relevance score (used for sorting) will
  // ignore the field-length norm.
  // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
  ignoreFieldNorm: false,
  // The weight to determine how much field length norm effects scoring.
  fieldNormWeight: 1
};

var Config$1 = _objectSpread3(_objectSpread3(_objectSpread3(_objectSpread3({}, BasicOptions), MatchOptions), FuzzyOptions), AdvancedOptions);

var SPACE = /[^ ]+/g; // Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.

function norm() {
  var weight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var mantissa = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
  var cache = new Map();
  var m = Math.pow(10, mantissa);
  return {
    get: function get(value) {
      var numTokens = value.match(SPACE).length;

      if (cache.has(numTokens)) {
        return cache.get(numTokens);
      } // Default function is 1/sqrt(x), weight makes that variable


      var norm = 1 / Math.pow(numTokens, 0.5 * weight); // In place of `toFixed(mantissa)`, for faster computation

      var n = parseFloat(Math.round(norm * m) / m);
      cache.set(numTokens, n);
      return n;
    },
    clear: function clear() {
      cache.clear();
    }
  };
}

var FuseIndex = /*#__PURE__*/function () {
  function FuseIndex() {
    var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref17$getFn = _ref17.getFn,
        getFn = _ref17$getFn === void 0 ? Config$1.getFn : _ref17$getFn,
        _ref17$fieldNormWeigh = _ref17.fieldNormWeight,
        fieldNormWeight = _ref17$fieldNormWeigh === void 0 ? Config$1.fieldNormWeight : _ref17$fieldNormWeigh;

    _classCallCheck2(this, FuseIndex);

    this.norm = norm(fieldNormWeight, 3);
    this.getFn = getFn;
    this.isCreated = false;
    this.setIndexRecords();
  }

  _createClass2(FuseIndex, [{
    key: "setSources",
    value: function setSources() {
      var docs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.docs = docs;
    }
  }, {
    key: "setIndexRecords",
    value: function setIndexRecords() {
      var records = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.records = records;
    }
  }, {
    key: "setKeys",
    value: function setKeys() {
      var _this8 = this;

      var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.keys = keys;
      this._keysMap = {};
      keys.forEach(function (key, idx) {
        _this8._keysMap[key.id] = idx;
      });
    }
  }, {
    key: "create",
    value: function create() {
      var _this9 = this;

      if (this.isCreated || !this.docs.length) {
        return;
      }

      this.isCreated = true; // List is Array<String>

      if (isString$2(this.docs[0])) {
        this.docs.forEach(function (doc, docIndex) {
          _this9._addString(doc, docIndex);
        });
      } else {
        // List is Array<Object>
        this.docs.forEach(function (doc, docIndex) {
          _this9._addObject(doc, docIndex);
        });
      }

      this.norm.clear();
    } // Adds a doc to the end of the index

  }, {
    key: "add",
    value: function add(doc) {
      var idx = this.size();

      if (isString$2(doc)) {
        this._addString(doc, idx);
      } else {
        this._addObject(doc, idx);
      }
    } // Removes the doc at the specified index of the index

  }, {
    key: "removeAt",
    value: function removeAt(idx) {
      this.records.splice(idx, 1); // Change ref index of every subsquent doc

      for (var _i3 = idx, len = this.size(); _i3 < len; _i3 += 1) {
        this.records[_i3].i -= 1;
      }
    }
  }, {
    key: "getValueForItemAtKeyId",
    value: function getValueForItemAtKeyId(item, keyId) {
      return item[this._keysMap[keyId]];
    }
  }, {
    key: "size",
    value: function size() {
      return this.records.length;
    }
  }, {
    key: "_addString",
    value: function _addString(doc, docIndex) {
      if (!isDefined(doc) || isBlank(doc)) {
        return;
      }

      var record = {
        v: doc,
        i: docIndex,
        n: this.norm.get(doc)
      };
      this.records.push(record);
    }
  }, {
    key: "_addObject",
    value: function _addObject(doc, docIndex) {
      var _this10 = this;

      var record = {
        i: docIndex,
        $: {}
      }; // Iterate over every key (i.e, path), and fetch the value at that key

      this.keys.forEach(function (key, keyIndex) {
        var value = key.getFn ? key.getFn(doc) : _this10.getFn(doc, key.path);

        if (!isDefined(value)) {
          return;
        }

        if (isArray$3(value)) {
          (function () {
            var subRecords = [];
            var stack = [{
              nestedArrIndex: -1,
              value: value
            }];

            while (stack.length) {
              var _stack$pop = stack.pop(),
                  nestedArrIndex = _stack$pop.nestedArrIndex,
                  _value2 = _stack$pop.value;

              if (!isDefined(_value2)) {
                continue;
              }

              if (isString$2(_value2) && !isBlank(_value2)) {
                var subRecord = {
                  v: _value2,
                  i: nestedArrIndex,
                  n: _this10.norm.get(_value2)
                };
                subRecords.push(subRecord);
              } else if (isArray$3(_value2)) {
                _value2.forEach(function (item, k) {
                  stack.push({
                    nestedArrIndex: k,
                    value: item
                  });
                });
              } else ;
            }

            record.$[keyIndex] = subRecords;
          })();
        } else if (isString$2(value) && !isBlank(value)) {
          var subRecord = {
            v: value,
            n: _this10.norm.get(value)
          };
          record.$[keyIndex] = subRecord;
        }
      });
      this.records.push(record);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        keys: this.keys,
        records: this.records
      };
    }
  }]);

  return FuseIndex;
}();

function createIndex(keys, docs) {
  var _ref18 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref18$getFn = _ref18.getFn,
      getFn = _ref18$getFn === void 0 ? Config$1.getFn : _ref18$getFn,
      _ref18$fieldNormWeigh = _ref18.fieldNormWeight,
      fieldNormWeight = _ref18$fieldNormWeigh === void 0 ? Config$1.fieldNormWeight : _ref18$fieldNormWeigh;

  var myIndex = new FuseIndex({
    getFn: getFn,
    fieldNormWeight: fieldNormWeight
  });
  myIndex.setKeys(keys.map(createKey));
  myIndex.setSources(docs);
  myIndex.create();
  return myIndex;
}

function parseIndex(data) {
  var _ref19 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref19$getFn = _ref19.getFn,
      getFn = _ref19$getFn === void 0 ? Config$1.getFn : _ref19$getFn,
      _ref19$fieldNormWeigh = _ref19.fieldNormWeight,
      fieldNormWeight = _ref19$fieldNormWeigh === void 0 ? Config$1.fieldNormWeight : _ref19$fieldNormWeigh;

  var keys = data.keys,
      records = data.records;
  var myIndex = new FuseIndex({
    getFn: getFn,
    fieldNormWeight: fieldNormWeight
  });
  myIndex.setKeys(keys);
  myIndex.setIndexRecords(records);
  return myIndex;
}

function computeScore$1(pattern) {
  var _ref20 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref20$errors = _ref20.errors,
      errors = _ref20$errors === void 0 ? 0 : _ref20$errors,
      _ref20$currentLocatio = _ref20.currentLocation,
      currentLocation = _ref20$currentLocatio === void 0 ? 0 : _ref20$currentLocatio,
      _ref20$expectedLocati = _ref20.expectedLocation,
      expectedLocation = _ref20$expectedLocati === void 0 ? 0 : _ref20$expectedLocati,
      _ref20$distance = _ref20.distance,
      distance = _ref20$distance === void 0 ? Config$1.distance : _ref20$distance,
      _ref20$ignoreLocation = _ref20.ignoreLocation,
      ignoreLocation = _ref20$ignoreLocation === void 0 ? Config$1.ignoreLocation : _ref20$ignoreLocation;

  var accuracy = errors / pattern.length;

  if (ignoreLocation) {
    return accuracy;
  }

  var proximity = Math.abs(expectedLocation - currentLocation);

  if (!distance) {
    // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
  }

  return accuracy + proximity / distance;
}

function convertMaskToIndices() {
  var matchmask = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var minMatchCharLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Config$1.minMatchCharLength;
  var indices = [];
  var start = -1;
  var end = -1;
  var i = 0;

  for (var len = matchmask.length; i < len; i += 1) {
    var _match2 = matchmask[i];

    if (_match2 && start === -1) {
      start = i;
    } else if (!_match2 && start !== -1) {
      end = i - 1;

      if (end - start + 1 >= minMatchCharLength) {
        indices.push([start, end]);
      }

      start = -1;
    }
  } // (i-1 - start) + 1 => i - start


  if (matchmask[i - 1] && i - start >= minMatchCharLength) {
    indices.push([start, i - 1]);
  }

  return indices;
} // Machine word size


var MAX_BITS = 32;

function search(text, pattern, patternAlphabet) {
  var _ref21 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref21$location = _ref21.location,
      location = _ref21$location === void 0 ? Config$1.location : _ref21$location,
      _ref21$distance = _ref21.distance,
      distance = _ref21$distance === void 0 ? Config$1.distance : _ref21$distance,
      _ref21$threshold = _ref21.threshold,
      threshold = _ref21$threshold === void 0 ? Config$1.threshold : _ref21$threshold,
      _ref21$findAllMatches = _ref21.findAllMatches,
      findAllMatches = _ref21$findAllMatches === void 0 ? Config$1.findAllMatches : _ref21$findAllMatches,
      _ref21$minMatchCharLe = _ref21.minMatchCharLength,
      minMatchCharLength = _ref21$minMatchCharLe === void 0 ? Config$1.minMatchCharLength : _ref21$minMatchCharLe,
      _ref21$includeMatches = _ref21.includeMatches,
      includeMatches = _ref21$includeMatches === void 0 ? Config$1.includeMatches : _ref21$includeMatches,
      _ref21$ignoreLocation = _ref21.ignoreLocation,
      ignoreLocation = _ref21$ignoreLocation === void 0 ? Config$1.ignoreLocation : _ref21$ignoreLocation;

  if (pattern.length > MAX_BITS) {
    throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS));
  }

  var patternLen = pattern.length; // Set starting location at beginning text and initialize the alphabet.

  var textLen = text.length; // Handle the case when location > text.length

  var expectedLocation = Math.max(0, Math.min(location, textLen)); // Highest score beyond which we give up.

  var currentThreshold = threshold; // Is there a nearby exact match? (speedup)

  var bestLocation = expectedLocation; // Performance: only computer matches when the minMatchCharLength > 1
  // OR if `includeMatches` is true.

  var computeMatches = minMatchCharLength > 1 || includeMatches; // A mask of the matches, used for building the indices

  var matchMask = computeMatches ? Array(textLen) : [];
  var index; // Get all exact matches, here for speed up

  while ((index = text.indexOf(pattern, bestLocation)) > -1) {
    var score = computeScore$1(pattern, {
      currentLocation: index,
      expectedLocation: expectedLocation,
      distance: distance,
      ignoreLocation: ignoreLocation
    });
    currentThreshold = Math.min(score, currentThreshold);
    bestLocation = index + patternLen;

    if (computeMatches) {
      var _i4 = 0;

      while (_i4 < patternLen) {
        matchMask[index + _i4] = 1;
        _i4 += 1;
      }
    }
  } // Reset the best location


  bestLocation = -1;
  var lastBitArr = [];
  var finalScore = 1;
  var binMax = patternLen + textLen;
  var mask = 1 << patternLen - 1;

  for (var _i5 = 0; _i5 < patternLen; _i5 += 1) {
    // Scan for the best match; each iteration allows for one more error.
    // Run a binary search to determine how far from the match location we can stray
    // at this error level.
    var binMin = 0;
    var binMid = binMax;

    while (binMin < binMid) {
      var _score2 = computeScore$1(pattern, {
        errors: _i5,
        currentLocation: expectedLocation + binMid,
        expectedLocation: expectedLocation,
        distance: distance,
        ignoreLocation: ignoreLocation
      });

      if (_score2 <= currentThreshold) {
        binMin = binMid;
      } else {
        binMax = binMid;
      }

      binMid = Math.floor((binMax - binMin) / 2 + binMin);
    } // Use the result from this iteration as the maximum for the next.


    binMax = binMid;

    var _start = Math.max(1, expectedLocation - binMid + 1);

    var finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen; // Initialize the bit array

    var bitArr = Array(finish + 2);
    bitArr[finish + 1] = (1 << _i5) - 1;

    for (var _j2 = finish; _j2 >= _start; _j2 -= 1) {
      var currentLocation = _j2 - 1;
      var charMatch = patternAlphabet[text.charAt(currentLocation)];

      if (computeMatches) {
        // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
        matchMask[currentLocation] = +!!charMatch;
      } // First pass: exact match


      bitArr[_j2] = (bitArr[_j2 + 1] << 1 | 1) & charMatch; // Subsequent passes: fuzzy match

      if (_i5) {
        bitArr[_j2] |= (lastBitArr[_j2 + 1] | lastBitArr[_j2]) << 1 | 1 | lastBitArr[_j2 + 1];
      }

      if (bitArr[_j2] & mask) {
        finalScore = computeScore$1(pattern, {
          errors: _i5,
          currentLocation: currentLocation,
          expectedLocation: expectedLocation,
          distance: distance,
          ignoreLocation: ignoreLocation
        }); // This match will almost certainly be better than any existing match.
        // But check anyway.

        if (finalScore <= currentThreshold) {
          // Indeed it is
          currentThreshold = finalScore;
          bestLocation = currentLocation; // Already passed `loc`, downhill from here on in.

          if (bestLocation <= expectedLocation) {
            break;
          } // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.


          _start = Math.max(1, 2 * expectedLocation - bestLocation);
        }
      }
    } // No hope for a (better) match at greater error levels.


    var _score = computeScore$1(pattern, {
      errors: _i5 + 1,
      currentLocation: expectedLocation,
      expectedLocation: expectedLocation,
      distance: distance,
      ignoreLocation: ignoreLocation
    });

    if (_score > currentThreshold) {
      break;
    }

    lastBitArr = bitArr;
  }

  var result = {
    isMatch: bestLocation >= 0,
    // Count exact matches (those with a score of 0) to be "almost" exact
    score: Math.max(0.001, finalScore)
  };

  if (computeMatches) {
    var indices = convertMaskToIndices(matchMask, minMatchCharLength);

    if (!indices.length) {
      result.isMatch = false;
    } else if (includeMatches) {
      result.indices = indices;
    }
  }

  return result;
}

function createPatternAlphabet(pattern) {
  var mask = {};

  for (var _i6 = 0, len = pattern.length; _i6 < len; _i6 += 1) {
    var char = pattern.charAt(_i6);
    mask[char] = (mask[char] || 0) | 1 << len - _i6 - 1;
  }

  return mask;
}

var stripDiacritics = String.prototype.normalize ? function (str) {
  return str.normalize('NFD').replace(/[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C04\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00-\u0D03\u0D3B\u0D3C\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF7-\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F]/g, '');
} : function (str) {
  return str;
};

var BitapSearch = /*#__PURE__*/function () {
  function BitapSearch(pattern) {
    var _this11 = this;

    var _ref22 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref22$location = _ref22.location,
        location = _ref22$location === void 0 ? Config$1.location : _ref22$location,
        _ref22$threshold = _ref22.threshold,
        threshold = _ref22$threshold === void 0 ? Config$1.threshold : _ref22$threshold,
        _ref22$distance = _ref22.distance,
        distance = _ref22$distance === void 0 ? Config$1.distance : _ref22$distance,
        _ref22$includeMatches = _ref22.includeMatches,
        includeMatches = _ref22$includeMatches === void 0 ? Config$1.includeMatches : _ref22$includeMatches,
        _ref22$findAllMatches = _ref22.findAllMatches,
        findAllMatches = _ref22$findAllMatches === void 0 ? Config$1.findAllMatches : _ref22$findAllMatches,
        _ref22$minMatchCharLe = _ref22.minMatchCharLength,
        minMatchCharLength = _ref22$minMatchCharLe === void 0 ? Config$1.minMatchCharLength : _ref22$minMatchCharLe,
        _ref22$isCaseSensitiv = _ref22.isCaseSensitive,
        isCaseSensitive = _ref22$isCaseSensitiv === void 0 ? Config$1.isCaseSensitive : _ref22$isCaseSensitiv,
        _ref22$ignoreDiacriti = _ref22.ignoreDiacritics,
        ignoreDiacritics = _ref22$ignoreDiacriti === void 0 ? Config$1.ignoreDiacritics : _ref22$ignoreDiacriti,
        _ref22$ignoreLocation = _ref22.ignoreLocation,
        ignoreLocation = _ref22$ignoreLocation === void 0 ? Config$1.ignoreLocation : _ref22$ignoreLocation;

    _classCallCheck2(this, BitapSearch);

    this.options = {
      location: location,
      threshold: threshold,
      distance: distance,
      includeMatches: includeMatches,
      findAllMatches: findAllMatches,
      minMatchCharLength: minMatchCharLength,
      isCaseSensitive: isCaseSensitive,
      ignoreDiacritics: ignoreDiacritics,
      ignoreLocation: ignoreLocation
    };
    pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
    pattern = ignoreDiacritics ? stripDiacritics(pattern) : pattern;
    this.pattern = pattern;
    this.chunks = [];

    if (!this.pattern.length) {
      return;
    }

    var addChunk = function addChunk(pattern, startIndex) {
      _this11.chunks.push({
        pattern: pattern,
        alphabet: createPatternAlphabet(pattern),
        startIndex: startIndex
      });
    };

    var len = this.pattern.length;

    if (len > MAX_BITS) {
      var _i7 = 0;
      var remainder = len % MAX_BITS;
      var end = len - remainder;

      while (_i7 < end) {
        addChunk(this.pattern.substr(_i7, MAX_BITS), _i7);
        _i7 += MAX_BITS;
      }

      if (remainder) {
        var startIndex = len - MAX_BITS;
        addChunk(this.pattern.substr(startIndex), startIndex);
      }
    } else {
      addChunk(this.pattern, 0);
    }
  }

  _createClass2(BitapSearch, [{
    key: "searchIn",
    value: function searchIn(text) {
      var _this$options = this.options,
          isCaseSensitive = _this$options.isCaseSensitive,
          ignoreDiacritics = _this$options.ignoreDiacritics,
          includeMatches = _this$options.includeMatches;
      text = isCaseSensitive ? text : text.toLowerCase();
      text = ignoreDiacritics ? stripDiacritics(text) : text; // Exact match

      if (this.pattern === text) {
        var _result4 = {
          isMatch: true,
          score: 0
        };

        if (includeMatches) {
          _result4.indices = [[0, text.length - 1]];
        }

        return _result4;
      } // Otherwise, use Bitap algorithm


      var _this$options2 = this.options,
          location = _this$options2.location,
          distance = _this$options2.distance,
          threshold = _this$options2.threshold,
          findAllMatches = _this$options2.findAllMatches,
          minMatchCharLength = _this$options2.minMatchCharLength,
          ignoreLocation = _this$options2.ignoreLocation;
      var allIndices = [];
      var totalScore = 0;
      var hasMatches = false;
      this.chunks.forEach(function (_ref23) {
        var pattern = _ref23.pattern,
            alphabet = _ref23.alphabet,
            startIndex = _ref23.startIndex;

        var _search = search(text, pattern, alphabet, {
          location: location + startIndex,
          distance: distance,
          threshold: threshold,
          findAllMatches: findAllMatches,
          minMatchCharLength: minMatchCharLength,
          includeMatches: includeMatches,
          ignoreLocation: ignoreLocation
        }),
            isMatch = _search.isMatch,
            score = _search.score,
            indices = _search.indices;

        if (isMatch) {
          hasMatches = true;
        }

        totalScore += score;

        if (isMatch && indices) {
          allIndices = [].concat(_toConsumableArray2(allIndices), _toConsumableArray2(indices));
        }
      });
      var result = {
        isMatch: hasMatches,
        score: hasMatches ? totalScore / this.chunks.length : 1
      };

      if (hasMatches && includeMatches) {
        result.indices = allIndices;
      }

      return result;
    }
  }]);

  return BitapSearch;
}();

var BaseMatch = /*#__PURE__*/function () {
  function BaseMatch(pattern) {
    _classCallCheck2(this, BaseMatch);

    this.pattern = pattern;
  }

  _createClass2(BaseMatch, [{
    key: "search",
    value: function search() {}
  }], [{
    key: "isMultiMatch",
    value: function isMultiMatch(pattern) {
      return getMatch(pattern, this.multiRegex);
    }
  }, {
    key: "isSingleMatch",
    value: function isSingleMatch(pattern) {
      return getMatch(pattern, this.singleRegex);
    }
  }]);

  return BaseMatch;
}();

function getMatch(pattern, exp) {
  var matches = pattern.match(exp);
  return matches ? matches[1] : null;
} // Token: 'file


var ExactMatch = /*#__PURE__*/function (_BaseMatch) {
  _inherits2(ExactMatch, _BaseMatch);

  var _super3 = _createSuper2(ExactMatch);

  function ExactMatch(pattern) {
    _classCallCheck2(this, ExactMatch);

    return _super3.call(this, pattern);
  }

  _createClass2(ExactMatch, [{
    key: "search",
    value: function search(text) {
      var isMatch = text === this.pattern;
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [0, this.pattern.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^="(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^=(.*)$/;
    }
  }]);

  return ExactMatch;
}(BaseMatch); // Token: !fire


var InverseExactMatch = /*#__PURE__*/function (_BaseMatch2) {
  _inherits2(InverseExactMatch, _BaseMatch2);

  var _super4 = _createSuper2(InverseExactMatch);

  function InverseExactMatch(pattern) {
    _classCallCheck2(this, InverseExactMatch);

    return _super4.call(this, pattern);
  }

  _createClass2(InverseExactMatch, [{
    key: "search",
    value: function search(text) {
      var index = text.indexOf(this.pattern);
      var isMatch = index === -1;
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [0, text.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'inverse-exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^!"(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^!(.*)$/;
    }
  }]);

  return InverseExactMatch;
}(BaseMatch); // Token: ^file


var PrefixExactMatch = /*#__PURE__*/function (_BaseMatch3) {
  _inherits2(PrefixExactMatch, _BaseMatch3);

  var _super5 = _createSuper2(PrefixExactMatch);

  function PrefixExactMatch(pattern) {
    _classCallCheck2(this, PrefixExactMatch);

    return _super5.call(this, pattern);
  }

  _createClass2(PrefixExactMatch, [{
    key: "search",
    value: function search(text) {
      var isMatch = text.startsWith(this.pattern);
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [0, this.pattern.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'prefix-exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^\^"(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^\^(.*)$/;
    }
  }]);

  return PrefixExactMatch;
}(BaseMatch); // Token: !^fire


var InversePrefixExactMatch = /*#__PURE__*/function (_BaseMatch4) {
  _inherits2(InversePrefixExactMatch, _BaseMatch4);

  var _super6 = _createSuper2(InversePrefixExactMatch);

  function InversePrefixExactMatch(pattern) {
    _classCallCheck2(this, InversePrefixExactMatch);

    return _super6.call(this, pattern);
  }

  _createClass2(InversePrefixExactMatch, [{
    key: "search",
    value: function search(text) {
      var isMatch = !text.startsWith(this.pattern);
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [0, text.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'inverse-prefix-exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^!\^"(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^!\^(.*)$/;
    }
  }]);

  return InversePrefixExactMatch;
}(BaseMatch); // Token: .file$


var SuffixExactMatch = /*#__PURE__*/function (_BaseMatch5) {
  _inherits2(SuffixExactMatch, _BaseMatch5);

  var _super7 = _createSuper2(SuffixExactMatch);

  function SuffixExactMatch(pattern) {
    _classCallCheck2(this, SuffixExactMatch);

    return _super7.call(this, pattern);
  }

  _createClass2(SuffixExactMatch, [{
    key: "search",
    value: function search(text) {
      var isMatch = text.endsWith(this.pattern);
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [text.length - this.pattern.length, text.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'suffix-exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^"(.*)"\$$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^(.*)\$$/;
    }
  }]);

  return SuffixExactMatch;
}(BaseMatch); // Token: !.file$


var InverseSuffixExactMatch = /*#__PURE__*/function (_BaseMatch6) {
  _inherits2(InverseSuffixExactMatch, _BaseMatch6);

  var _super8 = _createSuper2(InverseSuffixExactMatch);

  function InverseSuffixExactMatch(pattern) {
    _classCallCheck2(this, InverseSuffixExactMatch);

    return _super8.call(this, pattern);
  }

  _createClass2(InverseSuffixExactMatch, [{
    key: "search",
    value: function search(text) {
      var isMatch = !text.endsWith(this.pattern);
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: [0, text.length - 1]
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'inverse-suffix-exact';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^!"(.*)"\$$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^!(.*)\$$/;
    }
  }]);

  return InverseSuffixExactMatch;
}(BaseMatch);

var FuzzyMatch = /*#__PURE__*/function (_BaseMatch7) {
  _inherits2(FuzzyMatch, _BaseMatch7);

  var _super9 = _createSuper2(FuzzyMatch);

  function FuzzyMatch(pattern) {
    var _this12;

    var _ref24 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref24$location = _ref24.location,
        location = _ref24$location === void 0 ? Config$1.location : _ref24$location,
        _ref24$threshold = _ref24.threshold,
        threshold = _ref24$threshold === void 0 ? Config$1.threshold : _ref24$threshold,
        _ref24$distance = _ref24.distance,
        distance = _ref24$distance === void 0 ? Config$1.distance : _ref24$distance,
        _ref24$includeMatches = _ref24.includeMatches,
        includeMatches = _ref24$includeMatches === void 0 ? Config$1.includeMatches : _ref24$includeMatches,
        _ref24$findAllMatches = _ref24.findAllMatches,
        findAllMatches = _ref24$findAllMatches === void 0 ? Config$1.findAllMatches : _ref24$findAllMatches,
        _ref24$minMatchCharLe = _ref24.minMatchCharLength,
        minMatchCharLength = _ref24$minMatchCharLe === void 0 ? Config$1.minMatchCharLength : _ref24$minMatchCharLe,
        _ref24$isCaseSensitiv = _ref24.isCaseSensitive,
        isCaseSensitive = _ref24$isCaseSensitiv === void 0 ? Config$1.isCaseSensitive : _ref24$isCaseSensitiv,
        _ref24$ignoreDiacriti = _ref24.ignoreDiacritics,
        ignoreDiacritics = _ref24$ignoreDiacriti === void 0 ? Config$1.ignoreDiacritics : _ref24$ignoreDiacriti,
        _ref24$ignoreLocation = _ref24.ignoreLocation,
        ignoreLocation = _ref24$ignoreLocation === void 0 ? Config$1.ignoreLocation : _ref24$ignoreLocation;

    _classCallCheck2(this, FuzzyMatch);

    _this12 = _super9.call(this, pattern);
    _this12._bitapSearch = new BitapSearch(pattern, {
      location: location,
      threshold: threshold,
      distance: distance,
      includeMatches: includeMatches,
      findAllMatches: findAllMatches,
      minMatchCharLength: minMatchCharLength,
      isCaseSensitive: isCaseSensitive,
      ignoreDiacritics: ignoreDiacritics,
      ignoreLocation: ignoreLocation
    });
    return _this12;
  }

  _createClass2(FuzzyMatch, [{
    key: "search",
    value: function search(text) {
      return this._bitapSearch.searchIn(text);
    }
  }], [{
    key: "type",
    get: function get() {
      return 'fuzzy';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^"(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^(.*)$/;
    }
  }]);

  return FuzzyMatch;
}(BaseMatch); // Token: 'file


var IncludeMatch = /*#__PURE__*/function (_BaseMatch8) {
  _inherits2(IncludeMatch, _BaseMatch8);

  var _super10 = _createSuper2(IncludeMatch);

  function IncludeMatch(pattern) {
    _classCallCheck2(this, IncludeMatch);

    return _super10.call(this, pattern);
  }

  _createClass2(IncludeMatch, [{
    key: "search",
    value: function search(text) {
      var location = 0;
      var index;
      var indices = [];
      var patternLen = this.pattern.length; // Get all exact matches

      while ((index = text.indexOf(this.pattern, location)) > -1) {
        location = index + patternLen;
        indices.push([index, location - 1]);
      }

      var isMatch = !!indices.length;
      return {
        isMatch: isMatch,
        score: isMatch ? 0 : 1,
        indices: indices
      };
    }
  }], [{
    key: "type",
    get: function get() {
      return 'include';
    }
  }, {
    key: "multiRegex",
    get: function get() {
      return /^'"(.*)"$/;
    }
  }, {
    key: "singleRegex",
    get: function get() {
      return /^'(.*)$/;
    }
  }]);

  return IncludeMatch;
}(BaseMatch); // ❗Order is important. DO NOT CHANGE.


var searchers = [ExactMatch, IncludeMatch, PrefixExactMatch, InversePrefixExactMatch, InverseSuffixExactMatch, SuffixExactMatch, InverseExactMatch, FuzzyMatch];
var searchersLen = searchers.length; // Regex to split by spaces, but keep anything in quotes together

var SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
var OR_TOKEN = '|'; // Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]

function parseQuery(pattern) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return pattern.split(OR_TOKEN).map(function (item) {
    var query = item.trim().split(SPACE_RE).filter(function (item) {
      return item && !!item.trim();
    });
    var results = [];

    for (var _i8 = 0, len = query.length; _i8 < len; _i8 += 1) {
      var queryItem = query[_i8]; // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)

      var found = false;
      var idx = -1;

      while (!found && ++idx < searchersLen) {
        var searcher = searchers[idx];

        var _token = searcher.isMultiMatch(queryItem);

        if (_token) {
          results.push(new searcher(_token, options));
          found = true;
        }
      }

      if (found) {
        continue;
      } // 2. Handle single query matches (i.e, once that are *not* quoted)


      idx = -1;

      while (++idx < searchersLen) {
        var _searcher = searchers[idx];

        var _token2 = _searcher.isSingleMatch(queryItem);

        if (_token2) {
          results.push(new _searcher(_token2, options));
          break;
        }
      }
    }

    return results;
  });
} // These extended matchers can return an array of matches, as opposed
// to a singl match


var MultiMatchSet = new Set([FuzzyMatch.type, IncludeMatch.type]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */

var ExtendedSearch = /*#__PURE__*/function () {
  function ExtendedSearch(pattern) {
    var _ref25 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref25$isCaseSensitiv = _ref25.isCaseSensitive,
        isCaseSensitive = _ref25$isCaseSensitiv === void 0 ? Config$1.isCaseSensitive : _ref25$isCaseSensitiv,
        _ref25$ignoreDiacriti = _ref25.ignoreDiacritics,
        ignoreDiacritics = _ref25$ignoreDiacriti === void 0 ? Config$1.ignoreDiacritics : _ref25$ignoreDiacriti,
        _ref25$includeMatches = _ref25.includeMatches,
        includeMatches = _ref25$includeMatches === void 0 ? Config$1.includeMatches : _ref25$includeMatches,
        _ref25$minMatchCharLe = _ref25.minMatchCharLength,
        minMatchCharLength = _ref25$minMatchCharLe === void 0 ? Config$1.minMatchCharLength : _ref25$minMatchCharLe,
        _ref25$ignoreLocation = _ref25.ignoreLocation,
        ignoreLocation = _ref25$ignoreLocation === void 0 ? Config$1.ignoreLocation : _ref25$ignoreLocation,
        _ref25$findAllMatches = _ref25.findAllMatches,
        findAllMatches = _ref25$findAllMatches === void 0 ? Config$1.findAllMatches : _ref25$findAllMatches,
        _ref25$location = _ref25.location,
        location = _ref25$location === void 0 ? Config$1.location : _ref25$location,
        _ref25$threshold = _ref25.threshold,
        threshold = _ref25$threshold === void 0 ? Config$1.threshold : _ref25$threshold,
        _ref25$distance = _ref25.distance,
        distance = _ref25$distance === void 0 ? Config$1.distance : _ref25$distance;

    _classCallCheck2(this, ExtendedSearch);

    this.query = null;
    this.options = {
      isCaseSensitive: isCaseSensitive,
      ignoreDiacritics: ignoreDiacritics,
      includeMatches: includeMatches,
      minMatchCharLength: minMatchCharLength,
      findAllMatches: findAllMatches,
      ignoreLocation: ignoreLocation,
      location: location,
      threshold: threshold,
      distance: distance
    };
    pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
    pattern = ignoreDiacritics ? stripDiacritics(pattern) : pattern;
    this.pattern = pattern;
    this.query = parseQuery(this.pattern, this.options);
  }

  _createClass2(ExtendedSearch, [{
    key: "searchIn",
    value: function searchIn(text) {
      var query = this.query;

      if (!query) {
        return {
          isMatch: false,
          score: 1
        };
      }

      var _this$options3 = this.options,
          includeMatches = _this$options3.includeMatches,
          isCaseSensitive = _this$options3.isCaseSensitive,
          ignoreDiacritics = _this$options3.ignoreDiacritics;
      text = isCaseSensitive ? text : text.toLowerCase();
      text = ignoreDiacritics ? stripDiacritics(text) : text;
      var numMatches = 0;
      var allIndices = [];
      var totalScore = 0; // ORs

      for (var _i9 = 0, qLen = query.length; _i9 < qLen; _i9 += 1) {
        var _searchers = query[_i9]; // Reset indices

        allIndices.length = 0;
        numMatches = 0; // ANDs

        for (var _j3 = 0, pLen = _searchers.length; _j3 < pLen; _j3 += 1) {
          var searcher = _searchers[_j3];

          var _searcher$search = searcher.search(text),
              isMatch = _searcher$search.isMatch,
              indices = _searcher$search.indices,
              score = _searcher$search.score;

          if (isMatch) {
            numMatches += 1;
            totalScore += score;

            if (includeMatches) {
              var type = searcher.constructor.type;

              if (MultiMatchSet.has(type)) {
                allIndices = [].concat(_toConsumableArray2(allIndices), _toConsumableArray2(indices));
              } else {
                allIndices.push(indices);
              }
            }
          } else {
            totalScore = 0;
            numMatches = 0;
            allIndices.length = 0;
            break;
          }
        } // OR condition, so if TRUE, return


        if (numMatches) {
          var result = {
            isMatch: true,
            score: totalScore / numMatches
          };

          if (includeMatches) {
            result.indices = allIndices;
          }

          return result;
        }
      } // Nothing was matched


      return {
        isMatch: false,
        score: 1
      };
    }
  }], [{
    key: "condition",
    value: function condition(_, options) {
      return options.useExtendedSearch;
    }
  }]);

  return ExtendedSearch;
}();

var registeredSearchers = [];

function register() {
  registeredSearchers.push.apply(registeredSearchers, arguments);
}

function createSearcher(pattern, options) {
  for (var _i10 = 0, len = registeredSearchers.length; _i10 < len; _i10 += 1) {
    var searcherClass = registeredSearchers[_i10];

    if (searcherClass.condition(pattern, options)) {
      return new searcherClass(pattern, options);
    }
  }

  return new BitapSearch(pattern, options);
}

var LogicalOperator = {
  AND: '$and',
  OR: '$or'
};
var KeyType = {
  PATH: '$path',
  PATTERN: '$val'
};

var isExpression = function isExpression(query) {
  return !!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);
};

var isPath$1 = function isPath$1(query) {
  return !!query[KeyType.PATH];
};

var isLeaf = function isLeaf(query) {
  return !isArray$3(query) && isObject$5(query) && !isExpression(query);
};

var convertToExplicit = function convertToExplicit(query) {
  return _defineProperty2({}, LogicalOperator.AND, Object.keys(query).map(function (key) {
    return _defineProperty2({}, key, query[key]);
  }));
}; // When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance


function parse$1(query, options) {
  var _ref28 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref28$auto = _ref28.auto,
      auto = _ref28$auto === void 0 ? true : _ref28$auto;

  var next = function next(query) {
    var keys = Object.keys(query);
    var isQueryPath = isPath$1(query);

    if (!isQueryPath && keys.length > 1 && !isExpression(query)) {
      return next(convertToExplicit(query));
    }

    if (isLeaf(query)) {
      var key = isQueryPath ? query[KeyType.PATH] : keys[0];
      var pattern = isQueryPath ? query[KeyType.PATTERN] : query[key];

      if (!isString$2(pattern)) {
        throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
      }

      var obj = {
        keyId: createKeyId(key),
        pattern: pattern
      };

      if (auto) {
        obj.searcher = createSearcher(pattern, options);
      }

      return obj;
    }

    var node = {
      children: [],
      operator: keys[0]
    };
    keys.forEach(function (key) {
      var value = query[key];

      if (isArray$3(value)) {
        value.forEach(function (item) {
          node.children.push(next(item));
        });
      }
    });
    return node;
  };

  if (!isExpression(query)) {
    query = convertToExplicit(query);
  }

  return next(query);
} // Practical scoring function


function computeScore(results, _ref29) {
  var _ref29$ignoreFieldNor = _ref29.ignoreFieldNorm,
      ignoreFieldNorm = _ref29$ignoreFieldNor === void 0 ? Config$1.ignoreFieldNorm : _ref29$ignoreFieldNor;
  results.forEach(function (result) {
    var totalScore = 1;
    result.matches.forEach(function (_ref30) {
      var key = _ref30.key,
          norm = _ref30.norm,
          score = _ref30.score;
      var weight = key ? key.weight : null;
      totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
    });
    result.score = totalScore;
  });
}

function transformMatches(result, data) {
  var matches = result.matches;
  data.matches = [];

  if (!isDefined(matches)) {
    return;
  }

  matches.forEach(function (match) {
    if (!isDefined(match.indices) || !match.indices.length) {
      return;
    }

    var indices = match.indices,
        value = match.value;
    var obj = {
      indices: indices,
      value: value
    };

    if (match.key) {
      obj.key = match.key.src;
    }

    if (match.idx > -1) {
      obj.refIndex = match.idx;
    }

    data.matches.push(obj);
  });
}

function transformScore(result, data) {
  data.score = result.score;
}

function format$2(results, docs) {
  var _ref31 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref31$includeMatches = _ref31.includeMatches,
      includeMatches = _ref31$includeMatches === void 0 ? Config$1.includeMatches : _ref31$includeMatches,
      _ref31$includeScore = _ref31.includeScore,
      includeScore = _ref31$includeScore === void 0 ? Config$1.includeScore : _ref31$includeScore;

  var transformers = [];
  if (includeMatches) transformers.push(transformMatches);
  if (includeScore) transformers.push(transformScore);
  return results.map(function (result) {
    var idx = result.idx;
    var data = {
      item: docs[idx],
      refIndex: idx
    };

    if (transformers.length) {
      transformers.forEach(function (transformer) {
        transformer(result, data);
      });
    }

    return data;
  });
}

var Fuse = /*#__PURE__*/function () {
  function Fuse(docs) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var index = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck2(this, Fuse);

    this.options = _objectSpread3(_objectSpread3({}, Config$1), options);

    if (this.options.useExtendedSearch && !true) {
      throw new Error(EXTENDED_SEARCH_UNAVAILABLE);
    }

    this._keyStore = new KeyStore(this.options.keys);
    this.setCollection(docs, index);
  }

  _createClass2(Fuse, [{
    key: "setCollection",
    value: function setCollection(docs, index) {
      this._docs = docs;

      if (index && !(index instanceof FuseIndex)) {
        throw new Error(INCORRECT_INDEX_TYPE);
      }

      this._myIndex = index || createIndex(this.options.keys, this._docs, {
        getFn: this.options.getFn,
        fieldNormWeight: this.options.fieldNormWeight
      });
    }
  }, {
    key: "add",
    value: function add(doc) {
      if (!isDefined(doc)) {
        return;
      }

      this._docs.push(doc);

      this._myIndex.add(doc);
    }
  }, {
    key: "remove",
    value: function remove() {
      var predicate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
        return false;
      };
      var results = [];

      for (var _i11 = 0, len = this._docs.length; _i11 < len; _i11 += 1) {
        var doc = this._docs[_i11];

        if (predicate(doc, _i11)) {
          this.removeAt(_i11);
          _i11 -= 1;
          len -= 1;
          results.push(doc);
        }
      }

      return results;
    }
  }, {
    key: "removeAt",
    value: function removeAt(idx) {
      this._docs.splice(idx, 1);

      this._myIndex.removeAt(idx);
    }
  }, {
    key: "getIndex",
    value: function getIndex() {
      return this._myIndex;
    }
  }, {
    key: "search",
    value: function search(query) {
      var _ref32 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref32$limit = _ref32.limit,
          limit = _ref32$limit === void 0 ? -1 : _ref32$limit;

      var _this$options4 = this.options,
          includeMatches = _this$options4.includeMatches,
          includeScore = _this$options4.includeScore,
          shouldSort = _this$options4.shouldSort,
          sortFn = _this$options4.sortFn,
          ignoreFieldNorm = _this$options4.ignoreFieldNorm;
      var results = isString$2(query) ? isString$2(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
      computeScore(results, {
        ignoreFieldNorm: ignoreFieldNorm
      });

      if (shouldSort) {
        results.sort(sortFn);
      }

      if (isNumber(limit) && limit > -1) {
        results = results.slice(0, limit);
      }

      return format$2(results, this._docs, {
        includeMatches: includeMatches,
        includeScore: includeScore
      });
    }
  }, {
    key: "_searchStringList",
    value: function _searchStringList(query) {
      var searcher = createSearcher(query, this.options);
      var records = this._myIndex.records;
      var results = []; // Iterate over every string in the index

      records.forEach(function (_ref33) {
        var text = _ref33.v,
            idx = _ref33.i,
            norm = _ref33.n;

        if (!isDefined(text)) {
          return;
        }

        var _searcher$searchIn = searcher.searchIn(text),
            isMatch = _searcher$searchIn.isMatch,
            score = _searcher$searchIn.score,
            indices = _searcher$searchIn.indices;

        if (isMatch) {
          results.push({
            item: text,
            idx: idx,
            matches: [{
              score: score,
              value: text,
              norm: norm,
              indices: indices
            }]
          });
        }
      });
      return results;
    }
  }, {
    key: "_searchLogical",
    value: function _searchLogical(query) {
      var _this13 = this;

      var expression = parse$1(query, this.options);

      var evaluate = function evaluate(node, item, idx) {
        if (!node.children) {
          var keyId = node.keyId,
              searcher = node.searcher;

          var matches = _this13._findMatches({
            key: _this13._keyStore.get(keyId),
            value: _this13._myIndex.getValueForItemAtKeyId(item, keyId),
            searcher: searcher
          });

          if (matches && matches.length) {
            return [{
              idx: idx,
              item: item,
              matches: matches
            }];
          }

          return [];
        }

        var res = [];

        for (var _i12 = 0, len = node.children.length; _i12 < len; _i12 += 1) {
          var child = node.children[_i12];
          var result = evaluate(child, item, idx);

          if (result.length) {
            res.push.apply(res, _toConsumableArray2(result));
          } else if (node.operator === LogicalOperator.AND) {
            return [];
          }
        }

        return res;
      };

      var records = this._myIndex.records;
      var resultMap = {};
      var results = [];
      records.forEach(function (_ref34) {
        var item = _ref34.$,
            idx = _ref34.i;

        if (isDefined(item)) {
          var expResults = evaluate(expression, item, idx);

          if (expResults.length) {
            // Dedupe when adding
            if (!resultMap[idx]) {
              resultMap[idx] = {
                idx: idx,
                item: item,
                matches: []
              };
              results.push(resultMap[idx]);
            }

            expResults.forEach(function (_ref35) {
              var _resultMap$idx$matche;

              var matches = _ref35.matches;

              (_resultMap$idx$matche = resultMap[idx].matches).push.apply(_resultMap$idx$matche, _toConsumableArray2(matches));
            });
          }
        }
      });
      return results;
    }
  }, {
    key: "_searchObjectList",
    value: function _searchObjectList(query) {
      var _this14 = this;

      var searcher = createSearcher(query, this.options);
      var _this$_myIndex = this._myIndex,
          keys = _this$_myIndex.keys,
          records = _this$_myIndex.records;
      var results = []; // List is Array<Object>

      records.forEach(function (_ref36) {
        var item = _ref36.$,
            idx = _ref36.i;

        if (!isDefined(item)) {
          return;
        }

        var matches = []; // Iterate over every key (i.e, path), and fetch the value at that key

        keys.forEach(function (key, keyIndex) {
          matches.push.apply(matches, _toConsumableArray2(_this14._findMatches({
            key: key,
            value: item[keyIndex],
            searcher: searcher
          })));
        });

        if (matches.length) {
          results.push({
            idx: idx,
            item: item,
            matches: matches
          });
        }
      });
      return results;
    }
  }, {
    key: "_findMatches",
    value: function _findMatches(_ref37) {
      var key = _ref37.key,
          value = _ref37.value,
          searcher = _ref37.searcher;

      if (!isDefined(value)) {
        return [];
      }

      var matches = [];

      if (isArray$3(value)) {
        value.forEach(function (_ref38) {
          var text = _ref38.v,
              idx = _ref38.i,
              norm = _ref38.n;

          if (!isDefined(text)) {
            return;
          }

          var _searcher$searchIn2 = searcher.searchIn(text),
              isMatch = _searcher$searchIn2.isMatch,
              score = _searcher$searchIn2.score,
              indices = _searcher$searchIn2.indices;

          if (isMatch) {
            matches.push({
              score: score,
              key: key,
              value: text,
              idx: idx,
              norm: norm,
              indices: indices
            });
          }
        });
      } else {
        var text = value.v,
            _norm = value.n;

        var _searcher$searchIn3 = searcher.searchIn(text),
            isMatch = _searcher$searchIn3.isMatch,
            score = _searcher$searchIn3.score,
            indices = _searcher$searchIn3.indices;

        if (isMatch) {
          matches.push({
            score: score,
            key: key,
            value: text,
            norm: _norm,
            indices: indices
          });
        }
      }

      return matches;
    }
  }]);

  return Fuse;
}();

Fuse.version = '7.1.0';
Fuse.createIndex = createIndex;
Fuse.parseIndex = parseIndex;
Fuse.config = Config$1;
{
  Fuse.parseQuery = parse$1;
}
{
  register(ExtendedSearch);
}

var _templateObject$C;

function handleNavigate(href, close) {
  navigate(href);
  close();
}

function Finder(_ref) {
  var links = _ref.links;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray$4(_useState3, 2),
      search = _useState4[0],
      setSearch = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray$4(_useState5, 2),
      selectedIndex = _useState6[0],
      setSelectedIndex = _useState6[1];

  var fuse = useMemo(function () {
    return new Fuse(links, {
      keys: ['label', 'keywords'],
      threshold: 0.3
    });
  }, [links]);
  var filteredLinks = useMemo(function () {
    var results = search.trim() ? fuse.search(search).map(function (res) {
      return res.item;
    }).slice(0, 5) : links.slice(0, 5);
    setSelectedIndex(0); // reset selection when filtered

    return results;
  }, [search, fuse, links]);

  var close = function close() {
    setIsOpen(false);
    setTimeout(function () {
      setSearch('');
      setSelectedIndex(0);
    }, 300);
  };

  useEffect(function () {
    var handleKeyDown = function handleKeyDown(e) {
      var isCmdOrCtrlK = (e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k';

      if (isCmdOrCtrlK) {
        e.preventDefault();
        setIsOpen(true);
        return;
      }

      if (!isOpen) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setSelectedIndex(function (prev) {
          return (prev + 1) % filteredLinks.length;
        });
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setSelectedIndex(function (prev) {
          return prev === 0 ? filteredLinks.length - 1 : prev - 1;
        });
      } else if (e.key === 'Enter' && filteredLinks[selectedIndex]) {
        e.preventDefault();
        handleNavigate(filteredLinks[selectedIndex].href, close);
      } else if (e.key === 'Escape') {
        close();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return function () {
      return window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, filteredLinks, selectedIndex]);
  return /*#__PURE__*/jsx$1(Modal, {
    isOpen: isOpen,
    onClose: close,
    title: "Finder",
    children: /*#__PURE__*/jsxs(Stack$1, {
      gap: "16px",
      width: "500px",
      maxWidth: "100%",
      "data-testid": "dashboard-finder",
      children: [/*#__PURE__*/jsx$1(Stack$1, {
        children: /*#__PURE__*/jsx$1(Text, {
          color: "primary-600",
          children: "Searching for a page? Type a relevant term to easily find it."
        })
      }), /*#__PURE__*/jsx$1(_StyledInput$5, {
        autoFocus: true,
        placeholder: "Find a page...",
        value: search,
        onChange: function onChange(e) {
          return setSearch(e.target.value);
        },
        "data-testid": "dashboard-finder-input"
      }), /*#__PURE__*/jsx$1(Stack$1, {
        gap: "8px",
        children: filteredLinks.length > 0 ? filteredLinks.map(function (_ref2, index) {
          var page = _ref2.page,
              href = _ref2.href,
              label = _ref2.label,
              Icon = _ref2.Icon;
          return /*#__PURE__*/jsxs(_StyledButton$h, {
            variant: "link",
            onClick: function onClick() {
              return handleNavigate(href, close);
            },
            "data-active": index === selectedIndex,
            "data-testid": "".concat(page, "-").concat(label),
            role: "link",
            justifyContent: "flex-start",
            borderRadius: "base",
            children: [/*#__PURE__*/jsx$1(Icon, {
              size: 18
            }), /*#__PURE__*/jsxs(Text, {
              children: [page, " > ", label]
            }), hasDOM && window.location.pathname + window.location.search === href && /*#__PURE__*/jsx$1(Text, {
              ml: "auto",
              variant: "paragraph-xsmall",
              fontWeight: "semi",
              borderRadius: "rounded",
              px: "12px",
              py: "4px",
              alignItems: "center",
              border: "1px solid",
              borderColor: "neutral-200",
              "data-testid": "finder-current-badge",
              children: "Current"
            })]
          }, href);
        }) : /*#__PURE__*/jsx$1(Text, {
          color: "primary-600",
          children: "No results found."
        })
      })]
    })
  });
}

var _StyledInput$5 = styled(Input$3)(_templateObject$C || (_templateObject$C = _taggedTemplateLiteral$1(["\n            transition: 0.2s;\n            background-color: ", ";\n            color: ", ";\n            padding: 10px 15px;\n            border: 1px solid ", ";\n            border-radius: ", ";\n            outline: none;\n\n            &:focus-within,\n            &:hover {\n              border-color: ", ";\n            }\n          "])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.card;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors['neutral-700'];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors['neutral-200'];
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.radii.rounded;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors['supporting-haciendaBlue'];
});

var _StyledButton$h = styled(Button).withConfig({
  displayName: "finder___StyledButton",
  componentId: "sc-q0ivhl-0"
})(["padding:12px;background:transparent;transition:background 0.2s,padding 0.2s;&:hover{background-color:", ";padding-left:18px;padding-right:6px;}&[data-active='true']{background-color:", ";padding-left:18px;padding-right:6px;}"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors['neutral-50'];
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors['neutral-50'];
});

var BASEPATH = '/dashboard';
var FINDER_LINKS = [{
  href: "".concat(BASEPATH, "/my-account/domains"),
  label: 'Domains List',
  keywords: ['my domains'],
  Icon: Globe,
  page: 'My Account'
}, {
  href: "".concat(BASEPATH, "/my-account/subscriptions/active"),
  label: 'Active Subscriptions',
  keywords: ['plans', 'billing'],
  Icon: CreditCard,
  page: 'My Account'
}, {
  href: "".concat(BASEPATH, "/my-account/subscriptions/canceled"),
  label: 'Canceled Subscriptions',
  keywords: ['past', 'old plans'],
  Icon: Ban,
  page: 'My Account'
}, {
  href: "".concat(BASEPATH, "/my-account/contacts"),
  label: 'Contacts',
  keywords: ['support', 'info'],
  Icon: User,
  page: 'My Account'
}, {
  href: "".concat(BASEPATH, "/managers/domains"),
  label: 'Domains',
  keywords: ['dns', 'management'],
  Icon: Globe,
  page: 'Managers'
}, {
  href: "".concat(BASEPATH, "/managers/transfer"),
  label: 'Transfer',
  keywords: ['move', 'domain'],
  Icon: Share,
  page: 'Managers'
}, {
  href: "".concat(BASEPATH, "/managers/hosting"),
  label: 'Hosting',
  keywords: ['web hosting', 'servers'],
  Icon: Server,
  page: 'Managers'
}, {
  href: "".concat(BASEPATH, "/managers/ssl"),
  label: 'SSL',
  keywords: ['certificate', 'https'],
  Icon: Lock,
  page: 'Managers'
}, {
  href: "".concat(BASEPATH, "/managers/email"),
  label: 'Email',
  keywords: ['mailbox', 'inbox'],
  Icon: Mail,
  page: 'Managers'
}, {
  href: "".concat(BASEPATH, "/managers/seo"),
  label: 'SEO',
  keywords: ['search engine optimization'],
  Icon: ChartNoAxesColumn,
  page: 'Managers'
}, {
  href: "".concat(BASEPATH, "/managers/website-security"),
  label: 'Website Security',
  keywords: ['firewall', 'malware', 'site protection'],
  Icon: Shield,
  page: 'Managers'
}, {
  href: "".concat(BASEPATH, "/managers/website-builder"),
  label: 'Website Builder',
  keywords: ['site builder', 'create website'],
  Icon: PanelsTopLeft,
  page: 'Managers'
}, {
  href: "".concat(BASEPATH, "/settings/personal-info"),
  label: 'Personal Info',
  keywords: ['name', 'details'],
  Icon: User,
  page: 'Settings'
}, {
  href: "".concat(BASEPATH, "/settings/payment-settings"),
  label: 'Payment Settings',
  keywords: ['card', 'billing info'],
  Icon: CreditCard,
  page: 'Settings'
}, {
  href: "".concat(BASEPATH, "/settings/billing-history"),
  label: 'Billing History',
  keywords: ['invoices', 'transactions'],
  Icon: ChartNoAxesColumn,
  page: 'Settings'
}, {
  href: "".concat(BASEPATH, "/settings/security-settings"),
  label: 'Security Settings',
  keywords: ['2fa', 'mfa', 'password'],
  Icon: Shield,
  page: 'Settings'
}, {
  href: "".concat(BASEPATH, "/settings/login-history"),
  label: 'Login History',
  keywords: ['access', 'activity'],
  Icon: Lock,
  page: 'Settings'
}];
var HeaderContext = /*#__PURE__*/createContext(undefined);

function HeaderProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(null),
      _useState2 = _slicedToArray$4(_useState, 2),
      header = _useState2[0],
      setHeader = _useState2[1];

  return /*#__PURE__*/jsx$1(HeaderContext.Provider, {
    value: {
      header: header,
      setHeader: setHeader
    },
    children: children
  });
}

function useHeader() {
  var ctx = useContext(HeaderContext);

  if (!ctx) {
    throw new Error('useHeader must be used within a HeaderProvider');
  }

  return ctx;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */


var _extendStatics$ = function extendStatics$2(d, b) {
  _extendStatics$ = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics$(d, b);
};

function __extends$2(d, b) {
  _extendStatics$(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign$2 = function __assign$7() {
  _assign$2 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign$2.apply(this, arguments);
};

function __rest$4(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
}

var warning$1 = function warning$1() {};

var invariant$1 = function invariant$1() {};

if (process$1.env.NODE_ENV !== 'production') {
  warning$1 = function warning$1(check, message) {
    if (!check && typeof console !== 'undefined') {
      console.warn(message);
    }
  };

  invariant$1 = function invariant$1(check, message) {
    if (!check) {
      throw new Error(message);
    }
  };
}

var prevTime = 0;
var onNextFrame = typeof window !== 'undefined' && window.requestAnimationFrame !== undefined ? function (callback) {
  return window.requestAnimationFrame(callback);
} : function (callback) {
  var timestamp = Date.now();
  var timeToCall = Math.max(0, 16.7 - (timestamp - prevTime));
  prevTime = timestamp + timeToCall;
  setTimeout(function () {
    return callback(prevTime);
  }, timeToCall);
};

var createStep = function createStep(setRunNextFrame) {
  var processToRun = [];
  var processToRunNextFrame = [];
  var numThisFrame = 0;
  var isProcessing = false;
  var i = 0;
  var cancelled = new WeakSet();
  var toKeepAlive = new WeakSet();
  var renderStep = {
    cancel: function cancel(process) {
      var indexOfCallback = processToRunNextFrame.indexOf(process);
      cancelled.add(process);

      if (indexOfCallback !== -1) {
        processToRunNextFrame.splice(indexOfCallback, 1);
      }
    },
    process: function process(frame) {
      var _a;

      isProcessing = true;
      _a = [processToRunNextFrame, processToRun], processToRun = _a[0], processToRunNextFrame = _a[1];
      processToRunNextFrame.length = 0;
      numThisFrame = processToRun.length;

      if (numThisFrame) {
        var process_1;

        for (i = 0; i < numThisFrame; i++) {
          process_1 = processToRun[i];
          process_1(frame);

          if (toKeepAlive.has(process_1) === true && !cancelled.has(process_1)) {
            renderStep.schedule(process_1);
            setRunNextFrame(true);
          }
        }
      }

      isProcessing = false;
    },
    schedule: function schedule(process, keepAlive, immediate) {
      if (keepAlive === void 0) {
        keepAlive = false;
      }

      if (immediate === void 0) {
        immediate = false;
      }

      invariant$1(typeof process === "function", "Argument must be a function");
      var addToCurrentBuffer = immediate && isProcessing;
      var buffer = addToCurrentBuffer ? processToRun : processToRunNextFrame;
      cancelled.delete(process);
      if (keepAlive) toKeepAlive.add(process);

      if (buffer.indexOf(process) === -1) {
        buffer.push(process);
        if (addToCurrentBuffer) numThisFrame = processToRun.length;
      }
    }
  };
  return renderStep;
};

var maxElapsed = 40;
var defaultElapsed = 1 / 60 * 1000;
var useDefaultElapsed = true;
var willRunNextFrame = false;
var isProcessing = false;
var frame = {
  delta: 0,
  timestamp: 0
};
var stepsOrder = ["read", "update", "preRender", "render", "postRender"];

var setWillRunNextFrame = function setWillRunNextFrame(willRun) {
  return willRunNextFrame = willRun;
};

var steps = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
  acc[key] = createStep(setWillRunNextFrame);
  return acc;
}, {});
var sync = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
  var step = steps[key];

  acc[key] = function (process, keepAlive, immediate) {
    if (keepAlive === void 0) {
      keepAlive = false;
    }

    if (immediate === void 0) {
      immediate = false;
    }

    if (!willRunNextFrame) startLoop();
    step.schedule(process, keepAlive, immediate);
    return process;
  };

  return acc;
}, {});
var cancelSync = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
  acc[key] = steps[key].cancel;
  return acc;
}, {});

var processStep = function processStep(stepId) {
  return steps[stepId].process(frame);
};

var processFrame = function processFrame(timestamp) {
  willRunNextFrame = false;
  frame.delta = useDefaultElapsed ? defaultElapsed : Math.max(Math.min(timestamp - frame.timestamp, maxElapsed), 1);
  if (!useDefaultElapsed) defaultElapsed = frame.delta;
  frame.timestamp = timestamp;
  isProcessing = true;
  stepsOrder.forEach(processStep);
  isProcessing = false;

  if (willRunNextFrame) {
    useDefaultElapsed = false;
    onNextFrame(processFrame);
  }
};

var startLoop = function startLoop() {
  willRunNextFrame = true;
  useDefaultElapsed = true;
  if (!isProcessing) onNextFrame(processFrame);
};

var getFrameData = function getFrameData() {
  return frame;
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


var _assign$3 = function __assign$6() {
  _assign$3 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign$3.apply(this, arguments);
};

var clamp$2 = function clamp$2(min, max) {
  return function (v) {
    return Math.max(Math.min(v, max), min);
  };
};

var sanitize = function sanitize(v) {
  return v % 1 ? Number(v.toFixed(5)) : v;
};

var floatRegex = /(-)?(\d[\d\.]*)/g;
var colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
var singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
var number$1 = {
  test: function test(v) {
    return typeof v === 'number';
  },
  parse: parseFloat,
  transform: function transform(v) {
    return v;
  }
};

var alpha = _assign$3(_assign$3({}, number$1), {
  transform: clamp$2(0, 1)
});

var scale = _assign$3(_assign$3({}, number$1), {
  default: 1
});

var createUnitType = function createUnitType(unit) {
  return {
    test: function test(v) {
      return typeof v === 'string' && v.endsWith(unit) && v.split(' ').length === 1;
    },
    parse: parseFloat,
    transform: function transform(v) {
      return "" + v + unit;
    }
  };
};

var degrees = createUnitType('deg');
var percent = createUnitType('%');
var px = createUnitType('px');
var vh = createUnitType('vh');
var vw = createUnitType('vw');

var progressPercentage = _assign$3(_assign$3({}, percent), {
  parse: function parse(v) {
    return percent.parse(v) / 100;
  },
  transform: function transform(v) {
    return percent.transform(v * 100);
  }
});

var getValueFromFunctionString = function getValueFromFunctionString(value) {
  return value.substring(value.indexOf('(') + 1, value.lastIndexOf(')'));
};

var clampRgbUnit = clamp$2(0, 255);

var isRgba = function isRgba(v) {
  return v.red !== undefined;
};

var isHsla = function isHsla(v) {
  return v.hue !== undefined;
};

function getValuesAsArray(value) {
  return getValueFromFunctionString(value).replace(/(,|\/)/g, ' ').split(/ \s*/);
}

var splitColorValues = function splitColorValues(terms) {
  return function (v) {
    if (typeof v !== 'string') return v;
    var values = {};
    var valuesArray = getValuesAsArray(v);

    for (var i = 0; i < 4; i++) {
      values[terms[i]] = valuesArray[i] !== undefined ? parseFloat(valuesArray[i]) : 1;
    }

    return values;
  };
};

var rgbaTemplate = function rgbaTemplate(_a) {
  var red = _a.red,
      green = _a.green,
      blue = _a.blue,
      _b = _a.alpha,
      alpha = _b === void 0 ? 1 : _b;
  return "rgba(" + red + ", " + green + ", " + blue + ", " + alpha + ")";
};

var hslaTemplate = function hslaTemplate(_a) {
  var hue = _a.hue,
      saturation = _a.saturation,
      lightness = _a.lightness,
      _b = _a.alpha,
      alpha = _b === void 0 ? 1 : _b;
  return "hsla(" + hue + ", " + saturation + ", " + lightness + ", " + alpha + ")";
};

var rgbUnit = _assign$3(_assign$3({}, number$1), {
  transform: function transform(v) {
    return Math.round(clampRgbUnit(v));
  }
});

function isColorString(color, colorType) {
  return color.startsWith(colorType) && singleColorRegex.test(color);
}

var rgba = {
  test: function test(v) {
    return typeof v === 'string' ? isColorString(v, 'rgb') : isRgba(v);
  },
  parse: splitColorValues(['red', 'green', 'blue', 'alpha']),
  transform: function transform(_a) {
    var red = _a.red,
        green = _a.green,
        blue = _a.blue,
        _b = _a.alpha,
        alpha$1 = _b === void 0 ? 1 : _b;
    return rgbaTemplate({
      red: rgbUnit.transform(red),
      green: rgbUnit.transform(green),
      blue: rgbUnit.transform(blue),
      alpha: sanitize(alpha.transform(alpha$1))
    });
  }
};
var hsla = {
  test: function test(v) {
    return typeof v === 'string' ? isColorString(v, 'hsl') : isHsla(v);
  },
  parse: splitColorValues(['hue', 'saturation', 'lightness', 'alpha']),
  transform: function transform(_a) {
    var hue = _a.hue,
        saturation = _a.saturation,
        lightness = _a.lightness,
        _b = _a.alpha,
        alpha$1 = _b === void 0 ? 1 : _b;
    return hslaTemplate({
      hue: Math.round(hue),
      saturation: percent.transform(sanitize(saturation)),
      lightness: percent.transform(sanitize(lightness)),
      alpha: sanitize(alpha.transform(alpha$1))
    });
  }
};

var hex = _assign$3(_assign$3({}, rgba), {
  test: function test(v) {
    return typeof v === 'string' && isColorString(v, '#');
  },
  parse: function parse(v) {
    var r = '';
    var g = '';
    var b = '';

    if (v.length > 4) {
      r = v.substr(1, 2);
      g = v.substr(3, 2);
      b = v.substr(5, 2);
    } else {
      r = v.substr(1, 1);
      g = v.substr(2, 1);
      b = v.substr(3, 1);
      r += r;
      g += g;
      b += b;
    }

    return {
      red: parseInt(r, 16),
      green: parseInt(g, 16),
      blue: parseInt(b, 16),
      alpha: 1
    };
  }
});

var color$2 = {
  test: function test(v) {
    return typeof v === 'string' && singleColorRegex.test(v) || isRgba(v) || isHsla(v);
  },
  parse: function parse(v) {
    if (rgba.test(v)) {
      return rgba.parse(v);
    } else if (hsla.test(v)) {
      return hsla.parse(v);
    } else if (hex.test(v)) {
      return hex.parse(v);
    }

    return v;
  },
  transform: function transform(v) {
    if (isRgba(v)) {
      return rgba.transform(v);
    } else if (isHsla(v)) {
      return hsla.transform(v);
    }

    return v;
  }
};
var COLOR_TOKEN = '${c}';
var NUMBER_TOKEN = '${n}';

var convertNumbersToZero = function convertNumbersToZero(v) {
  return typeof v === 'number' ? 0 : v;
};

var complex = {
  test: function test(v) {
    if (typeof v !== 'string' || !isNaN(v)) return false;
    var numValues = 0;
    var foundNumbers = v.match(floatRegex);
    var foundColors = v.match(colorRegex);
    if (foundNumbers) numValues += foundNumbers.length;
    if (foundColors) numValues += foundColors.length;
    return numValues > 0;
  },
  parse: function parse(v) {
    var input = v;
    var parsed = [];
    var foundColors = input.match(colorRegex);

    if (foundColors) {
      input = input.replace(colorRegex, COLOR_TOKEN);
      parsed.push.apply(parsed, foundColors.map(color$2.parse));
    }

    var foundNumbers = input.match(floatRegex);

    if (foundNumbers) {
      parsed.push.apply(parsed, foundNumbers.map(number$1.parse));
    }

    return parsed;
  },
  createTransformer: function createTransformer(prop) {
    var template = prop;
    var token = 0;
    var foundColors = prop.match(colorRegex);
    var numColors = foundColors ? foundColors.length : 0;

    if (foundColors) {
      for (var i = 0; i < numColors; i++) {
        template = template.replace(foundColors[i], COLOR_TOKEN);
        token++;
      }
    }

    var foundNumbers = template.match(floatRegex);
    var numNumbers = foundNumbers ? foundNumbers.length : 0;

    if (foundNumbers) {
      for (var i = 0; i < numNumbers; i++) {
        template = template.replace(foundNumbers[i], NUMBER_TOKEN);
        token++;
      }
    }

    return function (v) {
      var output = template;

      for (var i = 0; i < token; i++) {
        output = output.replace(i < numColors ? COLOR_TOKEN : NUMBER_TOKEN, i < numColors ? color$2.transform(v[i]) : sanitize(v[i]));
      }

      return output;
    };
  },
  getAnimatableNone: function getAnimatableNone(target) {
    var parsedTarget = complex.parse(target);
    var targetTransformer = complex.createTransformer(target);
    return targetTransformer(parsedTarget.map(convertNumbersToZero));
  }
};
var DEFAULT_OVERSHOOT_STRENGTH = 1.525;

var reversed = function reversed(easing) {
  return function (p) {
    return 1 - easing(1 - p);
  };
};

var mirrored = function mirrored(easing) {
  return function (p) {
    return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
  };
};

var createReversedEasing = reversed;
var createMirroredEasing = mirrored;

var createExpoIn = function createExpoIn(power) {
  return function (p) {
    return Math.pow(p, power);
  };
};

var createBackIn = function createBackIn(power) {
  return function (p) {
    return p * p * ((power + 1) * p - power);
  };
};

var createAnticipateEasing = function createAnticipateEasing(power) {
  var backEasing = createBackIn(power);
  return function (p) {
    return (p *= 2) < 1 ? 0.5 * backEasing(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
  };
};

var linear = function linear(p) {
  return p;
};

var easeIn = /*#__PURE__*/createExpoIn(2);
var easeOut = /*#__PURE__*/reversed(easeIn);
var easeInOut = /*#__PURE__*/mirrored(easeIn);

var circIn = function circIn(p) {
  return 1 - Math.sin(Math.acos(p));
};

var circOut = /*#__PURE__*/reversed(circIn);
var circInOut = /*#__PURE__*/mirrored(circOut);
var backIn = /*#__PURE__*/createBackIn(DEFAULT_OVERSHOOT_STRENGTH);
var backOut = /*#__PURE__*/reversed(backIn);
var backInOut = /*#__PURE__*/mirrored(backIn);
var anticipate = /*#__PURE__*/createAnticipateEasing(DEFAULT_OVERSHOOT_STRENGTH);
var BOUNCE_FIRST_THRESHOLD = 4.0 / 11.0;
var BOUNCE_SECOND_THRESHOLD = 8.0 / 11.0;
var BOUNCE_THIRD_THRESHOLD = 9.0 / 10.0;
var ca = 4356.0 / 361.0;
var cb = 35442.0 / 1805.0;
var cc = 16061.0 / 1805.0;

var bounceOut = function bounceOut(p) {
  var p2 = p * p;
  return p < BOUNCE_FIRST_THRESHOLD ? 7.5625 * p2 : p < BOUNCE_SECOND_THRESHOLD ? 9.075 * p2 - 9.9 * p + 3.4 : p < BOUNCE_THIRD_THRESHOLD ? ca * p2 - cb * p + cc : 10.8 * p * p - 20.52 * p + 10.72;
};

var bounceIn = function bounceIn(p) {
  return 1.0 - bounceOut(1.0 - p);
};

var bounceInOut = function bounceInOut(p) {
  return p < 0.5 ? 0.5 * (1.0 - bounceOut(1.0 - p * 2.0)) : 0.5 * bounceOut(p * 2.0 - 1.0) + 0.5;
};

var NEWTON_ITERATIONS = 8;
var NEWTON_MIN_SLOPE = 0.001;
var SUBDIVISION_PRECISION = 0.0000001;
var SUBDIVISION_MAX_ITERATIONS = 10;
var K_SPLINE_TABLE_SIZE = 11;
var K_SAMPLE_STEP_SIZE = 1.0 / (K_SPLINE_TABLE_SIZE - 1.0);
var FLOAT_32_SUPPORTED = typeof Float32Array !== 'undefined';

var a = function a(a1, a2) {
  return 1.0 - 3.0 * a2 + 3.0 * a1;
};

var b = function b(a1, a2) {
  return 3.0 * a2 - 6.0 * a1;
};

var c = function c(a1) {
  return 3.0 * a1;
};

var getSlope = function getSlope(t, a1, a2) {
  return 3.0 * a(a1, a2) * t * t + 2.0 * b(a1, a2) * t + c(a1);
};

var calcBezier = function calcBezier(t, a1, a2) {
  return ((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t;
};

function cubicBezier(mX1, mY1, mX2, mY2) {
  var sampleValues = FLOAT_32_SUPPORTED ? new Float32Array(K_SPLINE_TABLE_SIZE) : new Array(K_SPLINE_TABLE_SIZE);

  var binarySubdivide = function binarySubdivide(aX, aA, aB) {
    var i = 0;
    var currentX;
    var currentT;

    do {
      currentT = aA + (aB - aA) / 2.0;
      currentX = calcBezier(currentT, mX1, mX2) - aX;

      if (currentX > 0.0) {
        aB = currentT;
      } else {
        aA = currentT;
      }
    } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);

    return currentT;
  };

  var newtonRaphsonIterate = function newtonRaphsonIterate(aX, aGuessT) {
    var i = 0;
    var currentSlope = 0;
    var currentX;

    for (; i < NEWTON_ITERATIONS; ++i) {
      currentSlope = getSlope(aGuessT, mX1, mX2);

      if (currentSlope === 0.0) {
        return aGuessT;
      }

      currentX = calcBezier(aGuessT, mX1, mX2) - aX;
      aGuessT -= currentX / currentSlope;
    }

    return aGuessT;
  };

  var calcSampleValues = function calcSampleValues() {
    for (var i = 0; i < K_SPLINE_TABLE_SIZE; ++i) {
      sampleValues[i] = calcBezier(i * K_SAMPLE_STEP_SIZE, mX1, mX2);
    }
  };

  var getTForX = function getTForX(aX) {
    var intervalStart = 0.0;
    var currentSample = 1;
    var lastSample = K_SPLINE_TABLE_SIZE - 1;
    var dist = 0.0;
    var guessForT = 0.0;
    var initialSlope = 0.0;

    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
      intervalStart += K_SAMPLE_STEP_SIZE;
    }

    --currentSample;
    dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
    guessForT = intervalStart + dist * K_SAMPLE_STEP_SIZE;
    initialSlope = getSlope(guessForT, mX1, mX2);

    if (initialSlope >= NEWTON_MIN_SLOPE) {
      return newtonRaphsonIterate(aX, guessForT);
    } else if (initialSlope === 0.0) {
      return guessForT;
    } else {
      return binarySubdivide(aX, intervalStart, intervalStart + K_SAMPLE_STEP_SIZE);
    }
  };

  calcSampleValues();

  var resolver = function resolver(aX) {
    var returnValue;

    if (mX1 === mY1 && mX2 === mY2) {
      returnValue = aX;
    } else if (aX === 0) {
      returnValue = 0;
    } else if (aX === 1) {
      returnValue = 1;
    } else {
      returnValue = calcBezier(getTForX(aX), mY1, mY2);
    }

    return returnValue;
  };

  return resolver;
}

var easingLookup = /*#__PURE__*/Object.freeze({
  __proto__: null,
  reversed: reversed,
  mirrored: mirrored,
  createReversedEasing: createReversedEasing,
  createMirroredEasing: createMirroredEasing,
  createExpoIn: createExpoIn,
  createBackIn: createBackIn,
  createAnticipateEasing: createAnticipateEasing,
  linear: linear,
  easeIn: easeIn,
  easeOut: easeOut,
  easeInOut: easeInOut,
  circIn: circIn,
  circOut: circOut,
  circInOut: circInOut,
  backIn: backIn,
  backOut: backOut,
  backInOut: backInOut,
  anticipate: anticipate,
  bounceOut: bounceOut,
  bounceIn: bounceIn,
  bounceInOut: bounceInOut,
  cubicBezier: cubicBezier
});
var zeroPoint = {
  x: 0,
  y: 0,
  z: 0
};

var isNum = function isNum(v) {
  return typeof v === 'number';
};

var curryRange = function curryRange(func) {
  return function (min, max, v) {
    return v !== undefined ? func(min, max, v) : function (cv) {
      return func(min, max, cv);
    };
  };
};

var clamp = function clamp(min, max, v) {
  return Math.min(Math.max(v, min), max);
};

var clamp$1 = curryRange(clamp);

var isPoint = function isPoint(point) {
  return point.hasOwnProperty('x') && point.hasOwnProperty('y');
};

var isPoint3D = function isPoint3D(point) {
  return isPoint(point) && point.hasOwnProperty('z');
};

var distance1D = function distance1D(a, b) {
  return Math.abs(a - b);
};

var distance = function distance(a, b) {
  if (b === void 0) {
    b = zeroPoint;
  }

  if (isNum(a) && isNum(b)) {
    return distance1D(a, b);
  } else if (isPoint(a) && isPoint(b)) {
    var xDelta = distance1D(a.x, b.x);
    var yDelta = distance1D(a.y, b.y);
    var zDelta = isPoint3D(a) && isPoint3D(b) ? distance1D(a.z, b.z) : 0;
    return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
  }

  return 0;
};

var progress = function progress(from, to, value) {
  var toFromDifference = to - from;
  return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

var mix = function mix(from, to, progress) {
  return -progress * from + progress * to + from;
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */


var _assign$4 = function __assign$5() {
  _assign$4 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign$4.apply(this, arguments);
};

var mixLinearColor = function mixLinearColor(from, to, v) {
  var fromExpo = from * from;
  var toExpo = to * to;
  return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
};

var colorTypes = [hex, rgba, hsla];

var getColorType = function getColorType(v) {
  return colorTypes.find(function (type) {
    return type.test(v);
  });
};

var notAnimatable = function notAnimatable(color$$1) {
  return "'" + color$$1 + "' is not an animatable color. Use the equivalent color code instead.";
};

var mixColor = function mixColor(from, to) {
  var fromColorType = getColorType(from);
  var toColorType = getColorType(to);
  invariant$1(!!fromColorType, notAnimatable(from));
  invariant$1(!!toColorType, notAnimatable(to));
  invariant$1(fromColorType.transform === toColorType.transform, 'Both colors must be hex/RGBA, OR both must be HSLA.');
  var fromColor = fromColorType.parse(from);
  var toColor = toColorType.parse(to);

  var blended = _assign$4({}, fromColor);

  var mixFunc = fromColorType === hsla ? mix : mixLinearColor;
  return function (v) {
    for (var key in blended) {
      if (key !== 'alpha') {
        blended[key] = mixFunc(fromColor[key], toColor[key], v);
      }
    }

    blended.alpha = mix(fromColor.alpha, toColor.alpha, v);
    return fromColorType.transform(blended);
  };
};

var combineFunctions = function combineFunctions(a, b) {
  return function (v) {
    return b(a(v));
  };
};

var pipe = function pipe() {
  var transformers = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    transformers[_i] = arguments[_i];
  }

  return transformers.reduce(combineFunctions);
};

function getMixer(origin, target) {
  if (isNum(origin)) {
    return function (v) {
      return mix(origin, target, v);
    };
  } else if (color$2.test(origin)) {
    return mixColor(origin, target);
  } else {
    return mixComplex(origin, target);
  }
}

var mixArray = function mixArray(from, to) {
  var output = from.slice();
  var numValues = output.length;
  var blendValue = from.map(function (fromThis, i) {
    return getMixer(fromThis, to[i]);
  });
  return function (v) {
    for (var i = 0; i < numValues; i++) {
      output[i] = blendValue[i](v);
    }

    return output;
  };
};

function analyse(value) {
  var parsed = complex.parse(value);
  var numValues = parsed.length;
  var numNumbers = 0;
  var numRGB = 0;
  var numHSL = 0;

  for (var i = 0; i < numValues; i++) {
    if (numNumbers || typeof parsed[i] === 'number') {
      numNumbers++;
    } else {
      if (parsed[i].hue !== undefined) {
        numHSL++;
      } else {
        numRGB++;
      }
    }
  }

  return {
    parsed: parsed,
    numNumbers: numNumbers,
    numRGB: numRGB,
    numHSL: numHSL
  };
}

var mixComplex = function mixComplex(origin, target) {
  var template = complex.createTransformer(target);
  var originStats = analyse(origin);
  var targetStats = analyse(target);
  invariant$1(originStats.numHSL === targetStats.numHSL && originStats.numRGB === targetStats.numRGB && originStats.numNumbers >= targetStats.numNumbers, "Complex values '" + origin + "' and '" + target + "' too different to mix. Ensure all colors are of the same type.");
  return pipe(mixArray(originStats.parsed, targetStats.parsed), template);
};

var velocityPerFrame = function velocityPerFrame(xps, frameDuration) {
  return isNum(xps) ? xps / (1000 / frameDuration) : 0;
};

var velocityPerSecond = function velocityPerSecond(velocity, frameDuration) {
  return frameDuration ? velocity * (1000 / frameDuration) : 0;
};

clamp$1(0, 1);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign$5 = function __assign$4() {
  _assign$5 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign$5.apply(this, arguments);
};

function __rest$3(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var createStyler = function createStyler(_a) {
  var onRead = _a.onRead,
      onRender = _a.onRender,
      _b = _a.uncachedValues,
      uncachedValues = _b === void 0 ? new Set() : _b,
      _c = _a.useCache,
      useCache = _c === void 0 ? true : _c;
  return function (_a) {
    if (_a === void 0) {
      _a = {};
    }

    var props = __rest$3(_a, []);

    var state = {};
    var changedValues = [];
    var hasChanged = false;

    function setValue(key, value) {
      if (key.startsWith('--')) {
        props.hasCSSVariable = true;
      }

      var currentValue = state[key];
      state[key] = value;
      if (state[key] === currentValue) return;

      if (changedValues.indexOf(key) === -1) {
        changedValues.push(key);
      }

      if (!hasChanged) {
        hasChanged = true;
        sync.render(styler.render);
      }
    }

    var styler = {
      get: function get(key, forceRead) {
        if (forceRead === void 0) {
          forceRead = false;
        }

        var useCached = !forceRead && useCache && !uncachedValues.has(key) && state[key] !== undefined;
        return useCached ? state[key] : onRead(key, props);
      },
      set: function set(values, value) {
        if (typeof values === 'string') {
          setValue(values, value);
        } else {
          for (var key in values) {
            setValue(key, values[key]);
          }
        }

        return this;
      },
      render: function render(forceRender) {
        if (forceRender === void 0) {
          forceRender = false;
        }

        if (hasChanged || forceRender === true) {
          onRender(state, props, changedValues);
          hasChanged = false;
          changedValues.length = 0;
        }

        return this;
      }
    };
    return styler;
  };
};

var CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
var REPLACE_TEMPLATE = '$1-$2';

var camelToDash = function camelToDash(str) {
  return str.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase();
};

var camelCache = /*#__PURE__*/new Map();
var dashCache = /*#__PURE__*/new Map();
var prefixes$1 = ['Webkit', 'Moz', 'O', 'ms', ''];
var numPrefixes = prefixes$1.length;
var isBrowser$2 = typeof document !== 'undefined';
var testElement;

var setDashPrefix = function setDashPrefix(key, prefixed) {
  return dashCache.set(key, camelToDash(prefixed));
};

var testPrefix = function testPrefix(key) {
  testElement = testElement || document.createElement('div');

  for (var i = 0; i < numPrefixes; i++) {
    var prefix = prefixes$1[i];
    var noPrefix = prefix === '';
    var prefixedPropertyName = noPrefix ? key : prefix + key.charAt(0).toUpperCase() + key.slice(1);

    if (prefixedPropertyName in testElement.style || noPrefix) {
      if (noPrefix && key === 'clipPath' && dashCache.has(key)) {
        return;
      }

      camelCache.set(key, prefixedPropertyName);
      setDashPrefix(key, "" + (noPrefix ? '' : '-') + camelToDash(prefixedPropertyName));
    }
  }
};

var setServerProperty = function setServerProperty(key) {
  return setDashPrefix(key, key);
};

var prefixer = function prefixer(key, asDashCase) {
  if (asDashCase === void 0) {
    asDashCase = false;
  }

  var cache = asDashCase ? dashCache : camelCache;

  if (!cache.has(key)) {
    isBrowser$2 ? testPrefix(key) : setServerProperty(key);
  }

  return cache.get(key) || key;
};

var axes = ['', 'X', 'Y', 'Z'];
var order$1 = ['translate', 'scale', 'rotate', 'skew', 'transformPerspective'];
var transformProps = /*#__PURE__*/order$1.reduce(function (acc, key) {
  return axes.reduce(function (axesAcc, axesKey) {
    axesAcc.push(key + axesKey);
    return axesAcc;
  }, acc);
}, ['x', 'y', 'z']);
var transformPropDictionary = /*#__PURE__*/transformProps.reduce(function (dict, key) {
  dict[key] = true;
  return dict;
}, {});

function isTransformProp(key) {
  return transformPropDictionary[key] === true;
}

function sortTransformProps(a, b) {
  return transformProps.indexOf(a) - transformProps.indexOf(b);
}

var transformOriginProps$1 = /*#__PURE__*/new Set(['originX', 'originY', 'originZ']);

function isTransformOriginProp$1(key) {
  return transformOriginProps$1.has(key);
}

var int = /*#__PURE__*/_assign$5( /*#__PURE__*/_assign$5({}, number$1), {
  transform: Math.round
});

var valueTypes$1 = {
  color: color$2,
  backgroundColor: color$2,
  outlineColor: color$2,
  fill: color$2,
  stroke: color$2,
  borderColor: color$2,
  borderTopColor: color$2,
  borderRightColor: color$2,
  borderBottomColor: color$2,
  borderLeftColor: color$2,
  borderWidth: px,
  borderTopWidth: px,
  borderRightWidth: px,
  borderBottomWidth: px,
  borderLeftWidth: px,
  borderRadius: px,
  radius: px,
  borderTopLeftRadius: px,
  borderTopRightRadius: px,
  borderBottomRightRadius: px,
  borderBottomLeftRadius: px,
  width: px,
  maxWidth: px,
  height: px,
  maxHeight: px,
  size: px,
  top: px,
  right: px,
  bottom: px,
  left: px,
  padding: px,
  paddingTop: px,
  paddingRight: px,
  paddingBottom: px,
  paddingLeft: px,
  margin: px,
  marginTop: px,
  marginRight: px,
  marginBottom: px,
  marginLeft: px,
  rotate: degrees,
  rotateX: degrees,
  rotateY: degrees,
  rotateZ: degrees,
  scale: scale,
  scaleX: scale,
  scaleY: scale,
  scaleZ: scale,
  skew: degrees,
  skewX: degrees,
  skewY: degrees,
  distance: px,
  translateX: px,
  translateY: px,
  translateZ: px,
  x: px,
  y: px,
  z: px,
  perspective: px,
  opacity: alpha,
  originX: progressPercentage,
  originY: progressPercentage,
  originZ: px,
  zIndex: int,
  fillOpacity: alpha,
  strokeOpacity: alpha,
  numOctaves: int
};

var getValueType$1 = function getValueType$1(key) {
  return valueTypes$1[key];
};

var getValueAsType = function getValueAsType(value, type) {
  return type && typeof value === 'number' ? type.transform(value) : value;
};

var SCROLL_LEFT = 'scrollLeft';
var SCROLL_TOP = 'scrollTop';
var scrollKeys = /*#__PURE__*/new Set([SCROLL_LEFT, SCROLL_TOP]);
var blacklist = /*#__PURE__*/new Set([SCROLL_LEFT, SCROLL_TOP, 'transform']);
var translateAlias = {
  x: 'translateX',
  y: 'translateY',
  z: 'translateZ'
};

function isCustomTemplate(v) {
  return typeof v === 'function';
}

function buildTransform(state, transform, transformKeys, transformIsDefault, enableHardwareAcceleration, allowTransformNone) {
  if (allowTransformNone === void 0) {
    allowTransformNone = true;
  }

  var transformString = '';
  var transformHasZ = false;
  transformKeys.sort(sortTransformProps);
  var numTransformKeys = transformKeys.length;

  for (var i = 0; i < numTransformKeys; i++) {
    var key = transformKeys[i];
    transformString += (translateAlias[key] || key) + "(" + transform[key] + ") ";
    transformHasZ = key === 'z' ? true : transformHasZ;
  }

  if (!transformHasZ && enableHardwareAcceleration) {
    transformString += 'translateZ(0)';
  } else {
    transformString = transformString.trim();
  }

  if (isCustomTemplate(state.transform)) {
    transformString = state.transform(transform, transformIsDefault ? '' : transformString);
  } else if (allowTransformNone && transformIsDefault) {
    transformString = 'none';
  }

  return transformString;
}

function buildStyleProperty(state, enableHardwareAcceleration, styles, transform, transformOrigin, transformKeys, isDashCase, allowTransformNone) {
  if (enableHardwareAcceleration === void 0) {
    enableHardwareAcceleration = true;
  }

  if (styles === void 0) {
    styles = {};
  }

  if (transform === void 0) {
    transform = {};
  }

  if (transformOrigin === void 0) {
    transformOrigin = {};
  }

  if (transformKeys === void 0) {
    transformKeys = [];
  }

  if (isDashCase === void 0) {
    isDashCase = false;
  }

  if (allowTransformNone === void 0) {
    allowTransformNone = true;
  }

  var transformIsDefault = true;
  var hasTransform = false;
  var hasTransformOrigin = false;

  for (var key in state) {
    var value = state[key];
    var valueType = getValueType$1(key);
    var valueAsType = getValueAsType(value, valueType);

    if (isTransformProp(key)) {
      hasTransform = true;
      transform[key] = valueAsType;
      transformKeys.push(key);

      if (transformIsDefault) {
        if (valueType.default && value !== valueType.default || !valueType.default && value !== 0) {
          transformIsDefault = false;
        }
      }
    } else if (isTransformOriginProp$1(key)) {
      transformOrigin[key] = valueAsType;
      hasTransformOrigin = true;
    } else if (!blacklist.has(key) || !isCustomTemplate(valueAsType)) {
      styles[prefixer(key, isDashCase)] = valueAsType;
    }
  }

  if (hasTransform || typeof state.transform === 'function') {
    styles.transform = buildTransform(state, transform, transformKeys, transformIsDefault, enableHardwareAcceleration, allowTransformNone);
  }

  if (hasTransformOrigin) {
    styles.transformOrigin = (transformOrigin.originX || '50%') + " " + (transformOrigin.originY || '50%') + " " + (transformOrigin.originZ || 0);
  }

  return styles;
}

function createStyleBuilder(_a) {
  var _b = _a === void 0 ? {} : _a,
      _c = _b.enableHardwareAcceleration,
      enableHardwareAcceleration = _c === void 0 ? true : _c,
      _d = _b.isDashCase,
      isDashCase = _d === void 0 ? true : _d,
      _e = _b.allowTransformNone,
      allowTransformNone = _e === void 0 ? true : _e;

  var styles = {};
  var transform = {};
  var transformOrigin = {};
  var transformKeys = [];
  return function (state) {
    transformKeys.length = 0;
    buildStyleProperty(state, enableHardwareAcceleration, styles, transform, transformOrigin, transformKeys, isDashCase, allowTransformNone);
    return styles;
  };
}

function onRead(key, options) {
  var element = options.element,
      preparseOutput = options.preparseOutput;
  var defaultValueType = getValueType$1(key);

  if (isTransformProp(key)) {
    return defaultValueType ? defaultValueType.default || 0 : 0;
  } else if (scrollKeys.has(key)) {
    return element[key];
  } else {
    var domValue = window.getComputedStyle(element, null).getPropertyValue(prefixer(key, true)) || 0;
    return preparseOutput && defaultValueType && defaultValueType.test(domValue) && defaultValueType.parse ? defaultValueType.parse(domValue) : domValue;
  }
}

function onRender(state, _a, changedValues) {
  var element = _a.element,
      buildStyles = _a.buildStyles,
      hasCSSVariable = _a.hasCSSVariable;
  Object.assign(element.style, buildStyles(state));

  if (hasCSSVariable) {
    var numChangedValues = changedValues.length;

    for (var i = 0; i < numChangedValues; i++) {
      var key = changedValues[i];

      if (key.startsWith('--')) {
        element.style.setProperty(key, state[key]);
      }
    }
  }

  if (changedValues.indexOf(SCROLL_LEFT) !== -1) {
    element[SCROLL_LEFT] = state[SCROLL_LEFT];
  }

  if (changedValues.indexOf(SCROLL_TOP) !== -1) {
    element[SCROLL_TOP] = state[SCROLL_TOP];
  }
}

var cssStyler = /*#__PURE__*/createStyler({
  onRead: onRead,
  onRender: onRender,
  uncachedValues: scrollKeys
});

function createCssStyler(element, _a) {
  if (_a === void 0) {
    _a = {};
  }

  var enableHardwareAcceleration = _a.enableHardwareAcceleration,
      allowTransformNone = _a.allowTransformNone,
      props = __rest$3(_a, ["enableHardwareAcceleration", "allowTransformNone"]);

  return cssStyler(_assign$5({
    element: element,
    buildStyles: createStyleBuilder({
      enableHardwareAcceleration: enableHardwareAcceleration,
      allowTransformNone: allowTransformNone
    }),
    preparseOutput: true
  }, props));
}

var camelCaseAttributes = /*#__PURE__*/new Set(['baseFrequency', 'diffuseConstant', 'kernelMatrix', 'kernelUnitLength', 'keySplines', 'keyTimes', 'limitingConeAngle', 'markerHeight', 'markerWidth', 'numOctaves', 'targetX', 'targetY', 'surfaceScale', 'specularConstant', 'specularExponent', 'stdDeviation', 'tableValues']);
var defaultOrigin = 0.5;

var svgAttrsTemplate = function svgAttrsTemplate() {
  return {
    style: {}
  };
};

var progressToPixels = function progressToPixels(progress, length) {
  return px.transform(progress * length);
};

var unmeasured = {
  x: 0,
  y: 0,
  width: 0,
  height: 0
};

function calcOrigin(origin, offset, size) {
  return typeof origin === 'string' ? origin : px.transform(offset + size * origin);
}

function calculateSVGTransformOrigin(dimensions, originX, originY) {
  return calcOrigin(originX, dimensions.x, dimensions.width) + " " + calcOrigin(originY, dimensions.y, dimensions.height);
}

var svgStyleConfig = {
  enableHardwareAcceleration: false,
  isDashCase: false
};

function buildSVGAttrs(_a, dimensions, totalPathLength, cssBuilder, attrs, isDashCase) {
  if (dimensions === void 0) {
    dimensions = unmeasured;
  }

  if (cssBuilder === void 0) {
    cssBuilder = createStyleBuilder(svgStyleConfig);
  }

  if (attrs === void 0) {
    attrs = svgAttrsTemplate();
  }

  if (isDashCase === void 0) {
    isDashCase = true;
  }

  var attrX = _a.attrX,
      attrY = _a.attrY,
      originX = _a.originX,
      originY = _a.originY,
      pathLength = _a.pathLength,
      _b = _a.pathSpacing,
      pathSpacing = _b === void 0 ? 1 : _b,
      _c = _a.pathOffset,
      pathOffset = _c === void 0 ? 0 : _c,
      state = __rest$3(_a, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);

  var style = cssBuilder(state);

  for (var key in style) {
    if (key === 'transform') {
      attrs.style.transform = style[key];
    } else {
      var attrKey = isDashCase && !camelCaseAttributes.has(key) ? camelToDash(key) : key;
      attrs[attrKey] = style[key];
    }
  }

  if (originX !== undefined || originY !== undefined || style.transform) {
    attrs.style.transformOrigin = calculateSVGTransformOrigin(dimensions, originX !== undefined ? originX : defaultOrigin, originY !== undefined ? originY : defaultOrigin);
  }

  if (attrX !== undefined) attrs.x = attrX;
  if (attrY !== undefined) attrs.y = attrY;

  if (totalPathLength !== undefined && pathLength !== undefined) {
    attrs[isDashCase ? 'stroke-dashoffset' : 'strokeDashoffset'] = progressToPixels(-pathOffset, totalPathLength);
    attrs[isDashCase ? 'stroke-dasharray' : 'strokeDasharray'] = progressToPixels(pathLength, totalPathLength) + " " + progressToPixels(pathSpacing, totalPathLength);
  }

  return attrs;
}

function createAttrBuilder(dimensions, totalPathLength, isDashCase) {
  if (isDashCase === void 0) {
    isDashCase = true;
  }

  var attrs = svgAttrsTemplate();
  var cssBuilder = createStyleBuilder(svgStyleConfig);
  return function (state) {
    return buildSVGAttrs(state, dimensions, totalPathLength, cssBuilder, attrs, isDashCase);
  };
}

var getDimensions = function getDimensions(element) {
  return typeof element.getBBox === 'function' ? element.getBBox() : element.getBoundingClientRect();
};

var getSVGElementDimensions = function getSVGElementDimensions(element) {
  try {
    return getDimensions(element);
  } catch (e) {
    return {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
  }
};

var isPath = function isPath(element) {
  return element.tagName === 'path';
};

var svgStyler = /*#__PURE__*/createStyler({
  onRead: function onRead(key, _a) {
    var element = _a.element;
    key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;

    if (!isTransformProp(key)) {
      return element.getAttribute(key);
    } else {
      var valueType = getValueType$1(key);
      return valueType ? valueType.default || 0 : 0;
    }
  },
  onRender: function onRender(state, _a) {
    var element = _a.element,
        buildAttrs = _a.buildAttrs;
    var attrs = buildAttrs(state);

    for (var key in attrs) {
      if (key === 'style') {
        Object.assign(element.style, attrs.style);
      } else {
        element.setAttribute(key, attrs[key]);
      }
    }
  }
});

var svg = function svg(element) {
  var dimensions = getSVGElementDimensions(element);
  var pathLength = isPath(element) && element.getTotalLength ? element.getTotalLength() : undefined;
  return svgStyler({
    element: element,
    buildAttrs: createAttrBuilder(dimensions, pathLength)
  });
};

var viewport = /*#__PURE__*/createStyler({
  useCache: false,
  onRead: function onRead(key) {
    return key === 'scrollTop' ? window.pageYOffset : window.pageXOffset;
  },
  onRender: function onRender(_a) {
    var _b = _a.scrollTop,
        scrollTop = _b === void 0 ? 0 : _b,
        _c = _a.scrollLeft,
        scrollLeft = _c === void 0 ? 0 : _c;
    return window.scrollTo(scrollLeft, scrollTop);
  }
});
var cache$2 = /*#__PURE__*/new WeakMap();

var isHTMLElement$2 = function isHTMLElement$2(node) {
  return node instanceof HTMLElement || typeof node.click === 'function';
};

var isSVGElement = function isSVGElement(node) {
  return node instanceof SVGElement || 'ownerSVGElement' in node;
};

var createDOMStyler = function createDOMStyler(node, props) {
  var styler;

  if (node === window) {
    styler = viewport(node);
  } else if (isHTMLElement$2(node)) {
    styler = createCssStyler(node, props);
  } else if (isSVGElement(node)) {
    styler = svg(node);
  }

  invariant$1(styler !== undefined, 'No valid node provided. Node must be HTMLElement, SVGElement or window.');
  cache$2.set(node, styler);
  return styler;
};

var getStyler = function getStyler(node, props) {
  return cache$2.has(node) ? cache$2.get(node) : createDOMStyler(node, props);
};

function index$1(nodeOrSelector, props) {
  var node = typeof nodeOrSelector === 'string' ? document.querySelector(nodeOrSelector) : nodeOrSelector;
  return getStyler(node, props);
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


var _assign$6 = function __assign$3() {
  _assign$6 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign$6.apply(this, arguments);
};

function __rest$2(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var Observer = /*#__PURE__*/function () {
  function Observer(_a, observer) {
    var _this = this;

    var middleware = _a.middleware,
        onComplete = _a.onComplete;
    this.isActive = true;

    this.update = function (v) {
      if (_this.observer.update) _this.updateObserver(v);
    };

    this.complete = function () {
      if (_this.observer.complete && _this.isActive) _this.observer.complete();
      if (_this.onComplete) _this.onComplete();
      _this.isActive = false;
    };

    this.error = function (err) {
      if (_this.observer.error && _this.isActive) _this.observer.error(err);
      _this.isActive = false;
    };

    this.observer = observer;

    this.updateObserver = function (v) {
      return observer.update(v);
    };

    this.onComplete = onComplete;

    if (observer.update && middleware && middleware.length) {
      middleware.forEach(function (m) {
        return _this.updateObserver = m(_this.updateObserver, _this.complete);
      });
    }
  }

  return Observer;
}();

var createObserver = function createObserver(observerCandidate, _a, onComplete) {
  var middleware = _a.middleware;

  if (typeof observerCandidate === 'function') {
    return new Observer({
      middleware: middleware,
      onComplete: onComplete
    }, {
      update: observerCandidate
    });
  } else {
    return new Observer({
      middleware: middleware,
      onComplete: onComplete
    }, observerCandidate);
  }
};

var Action = /*#__PURE__*/function () {
  function Action(props) {
    if (props === void 0) {
      props = {};
    }

    this.props = props;
  }

  Action.prototype.create = function (props) {
    return new Action(props);
  };

  Action.prototype.start = function (observerCandidate) {
    if (observerCandidate === void 0) {
      observerCandidate = {};
    }

    var isComplete = false;
    var subscription = {
      stop: function stop() {
        return undefined;
      }
    };

    var _a = this.props,
        init = _a.init,
        observerProps = __rest$2(_a, ["init"]);

    var observer = createObserver(observerCandidate, observerProps, function () {
      isComplete = true;
      subscription.stop();
    });
    var api = init(observer);
    subscription = api ? _assign$6({}, subscription, api) : subscription;
    if (isComplete) subscription.stop();
    return subscription;
  };

  Action.prototype.applyMiddleware = function (middleware) {
    return this.create(_assign$6({}, this.props, {
      middleware: this.props.middleware ? [middleware].concat(this.props.middleware) : [middleware]
    }));
  };

  Action.prototype.pipe = function () {
    var funcs = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      funcs[_i] = arguments[_i];
    }

    var pipedUpdate = funcs.length === 1 ? funcs[0] : pipe.apply(void 0, funcs);
    return this.applyMiddleware(function (update) {
      return function (v) {
        return update(pipedUpdate(v));
      };
    });
  };

  return Action;
}();

var action = function action(init) {
  return new Action({
    init: init
  });
};

var createVectorTests = function createVectorTests(typeTests) {
  var testNames = Object.keys(typeTests);

  var isVectorProp = function isVectorProp(prop, key) {
    return prop !== undefined && !typeTests[key](prop);
  };

  var getVectorKeys = function getVectorKeys(props) {
    return testNames.reduce(function (vectorKeys, key) {
      if (isVectorProp(props[key], key)) vectorKeys.push(key);
      return vectorKeys;
    }, []);
  };

  var testVectorProps = function testVectorProps(props) {
    return props && testNames.some(function (key) {
      return isVectorProp(props[key], key);
    });
  };

  return {
    getVectorKeys: getVectorKeys,
    testVectorProps: testVectorProps
  };
};

var unitTypes = [px, percent, degrees, vh, vw];

var findUnitType = function findUnitType(prop) {
  return unitTypes.find(function (type) {
    return type.test(prop);
  });
};

var isUnitProp = function isUnitProp(prop) {
  return Boolean(findUnitType(prop));
};

var createAction = function createAction(action, props) {
  return action(props);
};

var createUnitAction = function createUnitAction(action, _a) {
  var from = _a.from,
      to = _a.to,
      props = __rest$2(_a, ["from", "to"]);

  var unitType = findUnitType(from) || findUnitType(to);
  var transform = unitType.transform,
      parse = unitType.parse;
  return action(_assign$6({}, props, {
    from: typeof from === 'string' ? parse(from) : from,
    to: typeof to === 'string' ? parse(to) : to
  })).pipe(transform);
};

var createMixerAction = function createMixerAction(mixer) {
  return function (action, _a) {
    var from = _a.from,
        to = _a.to,
        props = __rest$2(_a, ["from", "to"]);

    return action(_assign$6({}, props, {
      from: 0,
      to: 1
    })).pipe(mixer(from, to));
  };
};

var createColorAction = /*#__PURE__*/createMixerAction(mixColor);
var createComplexAction = /*#__PURE__*/createMixerAction(mixComplex);

var createVectorAction = function createVectorAction(action, typeTests) {
  var _a = createVectorTests(typeTests),
      testVectorProps = _a.testVectorProps,
      getVectorKeys = _a.getVectorKeys;

  var vectorAction = function vectorAction(props) {
    var isVector = testVectorProps(props);
    if (!isVector) return action(props);
    var vectorKeys = getVectorKeys(props);
    var testKey = vectorKeys[0];
    var testProp = props[testKey];
    return getActionCreator(testProp)(action, props, vectorKeys);
  };

  return vectorAction;
};

var getActionCreator = function getActionCreator(prop) {
  if (typeof prop === 'number') {
    return createAction;
  } else if (isUnitProp(prop)) {
    return createUnitAction;
  } else if (color$2.test(prop)) {
    return createColorAction;
  } else if (complex.test(prop)) {
    return createComplexAction;
  } else {
    return createAction;
  }
};

var decay = function decay(props) {
  if (props === void 0) {
    props = {};
  }

  return action(function (_a) {
    var complete = _a.complete,
        update = _a.update;
    var _b = props.velocity,
        velocity = _b === void 0 ? 0 : _b,
        _c = props.from,
        from = _c === void 0 ? 0 : _c,
        _d = props.power,
        power = _d === void 0 ? 0.8 : _d,
        _e = props.timeConstant,
        timeConstant = _e === void 0 ? 350 : _e,
        _f = props.restDelta,
        restDelta = _f === void 0 ? 0.5 : _f,
        modifyTarget = props.modifyTarget;
    var elapsed = 0;
    var amplitude = power * velocity;
    var idealTarget = Math.round(from + amplitude);
    var target = typeof modifyTarget === 'undefined' ? idealTarget : modifyTarget(idealTarget);
    var process = sync.update(function (_a) {
      var frameDelta = _a.delta;
      elapsed += frameDelta;
      var delta = -amplitude * Math.exp(-elapsed / timeConstant);
      var isMoving = delta > restDelta || delta < -restDelta;
      var current = isMoving ? target + delta : target;
      update(current);

      if (!isMoving) {
        cancelSync.update(process);
        complete();
      }
    }, true);
    return {
      stop: function stop() {
        return cancelSync.update(process);
      }
    };
  });
};

var vectorDecay = /*#__PURE__*/createVectorAction(decay, {
  from: number$1.test,
  modifyTarget: function modifyTarget(func) {
    return typeof func === 'function';
  },
  velocity: number$1.test
});

var spring = function spring(props) {
  if (props === void 0) {
    props = {};
  }

  return action(function (_a) {
    var update = _a.update,
        complete = _a.complete;
    var _b = props.velocity,
        velocity = _b === void 0 ? 0.0 : _b;
    var _c = props.from,
        from = _c === void 0 ? 0.0 : _c,
        _d = props.to,
        to = _d === void 0 ? 0.0 : _d,
        _e = props.stiffness,
        stiffness = _e === void 0 ? 100 : _e,
        _f = props.damping,
        damping = _f === void 0 ? 10 : _f,
        _g = props.mass,
        mass = _g === void 0 ? 1.0 : _g,
        _h = props.restSpeed,
        restSpeed = _h === void 0 ? 0.01 : _h,
        _j = props.restDelta,
        restDelta = _j === void 0 ? 0.01 : _j;
    var initialVelocity = velocity ? -(velocity / 1000) : 0.0;
    var t = 0;
    var delta = to - from;
    var position = from;
    var prevPosition = position;
    var process = sync.update(function (_a) {
      var timeDelta = _a.delta;
      t += timeDelta;
      var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
      var angularFreq = Math.sqrt(stiffness / mass) / 1000;
      prevPosition = position;

      if (dampingRatio < 1) {
        var envelope = Math.exp(-dampingRatio * angularFreq * t);
        var expoDecay = angularFreq * Math.sqrt(1.0 - dampingRatio * dampingRatio);
        position = to - envelope * ((initialVelocity + dampingRatio * angularFreq * delta) / expoDecay * Math.sin(expoDecay * t) + delta * Math.cos(expoDecay * t));
      } else {
        var envelope = Math.exp(-angularFreq * t);
        position = to - envelope * (delta + (initialVelocity + angularFreq * delta) * t);
      }

      velocity = velocityPerSecond(position - prevPosition, timeDelta);
      var isBelowVelocityThreshold = Math.abs(velocity) <= restSpeed;
      var isBelowDisplacementThreshold = Math.abs(to - position) <= restDelta;

      if (isBelowVelocityThreshold && isBelowDisplacementThreshold) {
        position = to;
        update(position);
        cancelSync.update(process);
        complete();
      } else {
        update(position);
      }
    }, true);
    return {
      stop: function stop() {
        return cancelSync.update(process);
      }
    };
  });
};

var vectorSpring = /*#__PURE__*/createVectorAction(spring, {
  from: number$1.test,
  to: number$1.test,
  stiffness: number$1.test,
  damping: number$1.test,
  mass: number$1.test,
  velocity: number$1.test
});

var inertia = function inertia(_a) {
  var _b = _a.from,
      from = _b === void 0 ? 0 : _b,
      _c = _a.velocity,
      velocity = _c === void 0 ? 0 : _c,
      min = _a.min,
      max = _a.max,
      _d = _a.power,
      power = _d === void 0 ? 0.8 : _d,
      _e = _a.timeConstant,
      timeConstant = _e === void 0 ? 700 : _e,
      _f = _a.bounceStiffness,
      bounceStiffness = _f === void 0 ? 500 : _f,
      _g = _a.bounceDamping,
      bounceDamping = _g === void 0 ? 10 : _g,
      _h = _a.restDelta,
      restDelta = _h === void 0 ? 1 : _h,
      modifyTarget = _a.modifyTarget;
  return action(function (_a) {
    var update = _a.update,
        _complete = _a.complete;
    var prev = from;
    var current = from;
    var activeAnimation;
    var isSpring = false;

    var isLessThanMin = function isLessThanMin(v) {
      return min !== undefined && v <= min;
    };

    var isMoreThanMax = function isMoreThanMax(v) {
      return max !== undefined && v >= max;
    };

    var isOutOfBounds = function isOutOfBounds(v) {
      return isLessThanMin(v) || isMoreThanMax(v);
    };

    var isTravellingAwayFromBounds = function isTravellingAwayFromBounds(v, currentVelocity) {
      return isLessThanMin(v) && currentVelocity < 0 || isMoreThanMax(v) && currentVelocity > 0;
    };

    var onUpdate = function onUpdate(v) {
      update(v);
      prev = current;
      current = v;
      velocity = velocityPerSecond(current - prev, getFrameData().delta);

      if (activeAnimation && !isSpring && isTravellingAwayFromBounds(v, velocity)) {
        startSpring({
          from: v,
          velocity: velocity
        });
      }
    };

    var startAnimation = function startAnimation(animation, next) {
      activeAnimation && activeAnimation.stop();
      activeAnimation = animation.start({
        update: onUpdate,
        complete: function complete() {
          if (next) {
            next();
            return;
          }

          _complete();
        }
      });
    };

    var startSpring = function startSpring(props) {
      isSpring = true;
      startAnimation(vectorSpring(_assign$6({}, props, {
        to: isLessThanMin(props.from) ? min : max,
        stiffness: bounceStiffness,
        damping: bounceDamping,
        restDelta: restDelta
      })));
    };

    if (isOutOfBounds(from)) {
      startSpring({
        from: from,
        velocity: velocity
      });
    } else if (velocity !== 0) {
      var animation = vectorDecay({
        from: from,
        velocity: velocity,
        timeConstant: timeConstant,
        power: power,
        restDelta: isOutOfBounds(from) ? 20 : restDelta,
        modifyTarget: modifyTarget
      });
      startAnimation(animation, function () {
        if (isOutOfBounds(current)) {
          startSpring({
            from: current,
            velocity: velocity
          });
        } else {
          _complete();
        }
      });
    } else {
      _complete();
    }

    return {
      stop: function stop() {
        return activeAnimation && activeAnimation.stop();
      }
    };
  });
};

var index = /*#__PURE__*/createVectorAction(inertia, {
  from: number$1.test,
  velocity: number$1.test,
  min: number$1.test,
  max: number$1.test,
  damping: number$1.test,
  stiffness: number$1.test,
  modifyTarget: function modifyTarget(func) {
    return typeof func === 'function';
  }
});

var scrubber = function scrubber(_a) {
  var _b = _a.from,
      from = _b === void 0 ? 0 : _b,
      _c = _a.to,
      to = _c === void 0 ? 1 : _c,
      _d = _a.ease,
      ease = _d === void 0 ? linear : _d,
      _e = _a.reverseEase,
      reverseEase = _e === void 0 ? false : _e;

  if (reverseEase) {
    ease = createReversedEasing(ease);
  }

  return action(function (_a) {
    var update = _a.update;
    return {
      seek: function seek(progress) {
        return update(progress);
      }
    };
  }).pipe(ease, function (v) {
    return mix(from, to, v);
  });
};

var vectorScrubber = /*#__PURE__*/createVectorAction(scrubber, {
  ease: function ease(func) {
    return typeof func === 'function';
  },
  from: number$1.test,
  to: number$1.test
});
var clampProgress = /*#__PURE__*/clamp$1(0, 1);

var tween = function tween(props) {
  if (props === void 0) {
    props = {};
  }

  return action(function (_a) {
    var update = _a.update,
        complete = _a.complete;
    var _b = props.duration,
        duration = _b === void 0 ? 300 : _b,
        _c = props.ease,
        ease = _c === void 0 ? easeOut : _c,
        _d = props.flip,
        flip = _d === void 0 ? 0 : _d,
        _e = props.loop,
        loop = _e === void 0 ? 0 : _e,
        _f = props.yoyo,
        yoyo = _f === void 0 ? 0 : _f,
        _g = props.repeatDelay,
        repeatDelay = _g === void 0 ? 0 : _g;
    var _h = props.from,
        from = _h === void 0 ? 0 : _h,
        _j = props.to,
        to = _j === void 0 ? 1 : _j,
        _k = props.elapsed,
        elapsed = _k === void 0 ? 0 : _k,
        _l = props.flipCount,
        flipCount = _l === void 0 ? 0 : _l,
        _m = props.yoyoCount,
        yoyoCount = _m === void 0 ? 0 : _m,
        _o = props.loopCount,
        loopCount = _o === void 0 ? 0 : _o;
    var playhead = vectorScrubber({
      from: from,
      to: to,
      ease: ease
    }).start(update);
    var currentProgress = 0;
    var process;
    var _isActive = false;

    var reverseAnimation = function reverseAnimation(reverseEase) {
      var _a;

      if (reverseEase === void 0) {
        reverseEase = false;
      }

      _a = [to, from], from = _a[0], to = _a[1];
      playhead = vectorScrubber({
        from: from,
        to: to,
        ease: ease,
        reverseEase: reverseEase
      }).start(update);
    };

    var isTweenComplete = function isTweenComplete() {
      var isComplete = _isActive && elapsed > duration + repeatDelay;
      if (!isComplete) return false;
      if (isComplete && !loop && !flip && !yoyo) return true;
      var overtime = elapsed - duration;
      elapsed = overtime - repeatDelay;

      if (loop && loopCount < loop) {
        loopCount++;
        return false;
      } else if (flip && flipCount < flip) {
        flipCount++;
        reverseAnimation();
        return false;
      } else if (yoyo && yoyoCount < yoyo) {
        yoyoCount++;
        reverseAnimation(yoyoCount % 2 !== 0);
        return false;
      }

      return true;
    };

    var updateTween = function updateTween() {
      currentProgress = clampProgress(progress(0, duration, elapsed));
      playhead.seek(currentProgress);
    };

    var startTimer = function startTimer() {
      _isActive = true;
      process = sync.update(function (_a) {
        var delta = _a.delta;
        elapsed += delta;
        updateTween();

        if (isTweenComplete()) {
          cancelSync.update(process);
          complete && sync.update(complete, false, true);
        }
      }, true);
    };

    var stopTimer = function stopTimer() {
      _isActive = false;
      if (process) cancelSync.update(process);
    };

    startTimer();
    return {
      isActive: function isActive() {
        return _isActive;
      },
      getElapsed: function getElapsed() {
        return clamp$1(0, duration, elapsed);
      },
      getProgress: function getProgress() {
        return currentProgress;
      },
      stop: function stop() {
        stopTimer();
      },
      pause: function pause() {
        stopTimer();
        return this;
      },
      resume: function resume() {
        if (!_isActive) startTimer();
        return this;
      },
      seek: function seek(newProgress) {
        elapsed = mix(0, duration, newProgress);
        sync.update(updateTween, false, true);
        return this;
      },
      reverse: function reverse() {
        reverseAnimation();
        return this;
      }
    };
  });
};

var clampProgress$1 = /*#__PURE__*/clamp$1(0, 1);

var defaultEasings = function defaultEasings(values, easing) {
  return values.map(function () {
    return easing || easeOut;
  }).splice(0, values.length - 1);
};

var defaultTimings = function defaultTimings(values) {
  var numValues = values.length;
  return values.map(function (value, i) {
    return i !== 0 ? i / (numValues - 1) : 0;
  });
};

var interpolateScrubbers = function interpolateScrubbers(input, scrubbers, update) {
  var rangeLength = input.length;
  var finalInputIndex = rangeLength - 1;
  var finalScrubberIndex = finalInputIndex - 1;
  var subs = scrubbers.map(function (scrub) {
    return scrub.start(update);
  });
  return function (v) {
    if (v <= input[0]) {
      subs[0].seek(0);
    }

    if (v >= input[finalInputIndex]) {
      subs[finalScrubberIndex].seek(1);
    }

    var i = 1;

    for (; i < rangeLength; i++) {
      if (input[i] > v || i === finalInputIndex) break;
    }

    var progressInRange = progress(input[i - 1], input[i], v);
    subs[i - 1].seek(clampProgress$1(progressInRange));
  };
};

var keyframes$1 = function keyframes$1(_a) {
  var easings = _a.easings,
      _b = _a.ease,
      ease = _b === void 0 ? linear : _b,
      times = _a.times,
      values = _a.values,
      tweenProps = __rest$2(_a, ["easings", "ease", "times", "values"]);

  easings = Array.isArray(easings) ? easings : defaultEasings(values, easings);
  times = times || defaultTimings(values);
  var scrubbers = easings.map(function (easing, i) {
    return vectorScrubber({
      from: values[i],
      to: values[i + 1],
      ease: easing
    });
  });
  return tween(_assign$6({}, tweenProps, {
    ease: ease
  })).applyMiddleware(function (update) {
    return interpolateScrubbers(times, scrubbers, update);
  });
};

var physics = function physics(props) {
  if (props === void 0) {
    props = {};
  }

  return action(function (_a) {
    var complete = _a.complete,
        update = _a.update;
    var _b = props.acceleration,
        acceleration = _b === void 0 ? 0 : _b,
        _c = props.friction,
        friction = _c === void 0 ? 0 : _c,
        _d = props.velocity,
        velocity = _d === void 0 ? 0 : _d,
        springStrength = props.springStrength,
        to = props.to;
    var _e = props.restSpeed,
        restSpeed = _e === void 0 ? 0.001 : _e,
        _f = props.from,
        from = _f === void 0 ? 0 : _f;
    var current = from;
    var process = sync.update(function (_a) {
      var delta = _a.delta;
      var elapsed = Math.max(delta, 16);
      if (acceleration) velocity += velocityPerFrame(acceleration, elapsed);
      if (friction) velocity *= Math.pow(1 - friction, elapsed / 100);

      if (springStrength !== undefined && to !== undefined) {
        var distanceToTarget = to - current;
        velocity += distanceToTarget * velocityPerFrame(springStrength, elapsed);
      }

      current += velocityPerFrame(velocity, elapsed);
      update(current);
      var isComplete = restSpeed !== false && (!velocity || Math.abs(velocity) <= restSpeed);

      if (isComplete) {
        cancelSync.update(process);
        complete();
      }
    }, true);
    return {
      set: function set(v) {
        current = v;
        return this;
      },
      setAcceleration: function setAcceleration(v) {
        acceleration = v;
        return this;
      },
      setFriction: function setFriction(v) {
        friction = v;
        return this;
      },
      setSpringStrength: function setSpringStrength(v) {
        springStrength = v;
        return this;
      },
      setSpringTarget: function setSpringTarget(v) {
        to = v;
        return this;
      },
      setVelocity: function setVelocity(v) {
        velocity = v;
        return this;
      },
      stop: function stop() {
        return cancelSync.update(process);
      }
    };
  });
};
/*#__PURE__*/


createVectorAction(physics, {
  acceleration: number$1.test,
  friction: number$1.test,
  velocity: number$1.test,
  from: number$1.test,
  to: number$1.test,
  springStrength: number$1.test
});

var listen = function listen(element, events, options) {
  return action(function (_a) {
    var update = _a.update;
    var eventNames = events.split(' ').map(function (eventName) {
      element.addEventListener(eventName, update, options);
      return eventName;
    });
    return {
      stop: function stop() {
        return eventNames.forEach(function (eventName) {
          return element.removeEventListener(eventName, update, options);
        });
      }
    };
  });
};

var defaultPointerPos = function defaultPointerPos() {
  return {
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    x: 0,
    y: 0
  };
};

var eventToPoint = function eventToPoint(e, point) {
  if (point === void 0) {
    point = defaultPointerPos();
  }

  point.clientX = point.x = e.clientX;
  point.clientY = point.y = e.clientY;
  point.pageX = e.pageX;
  point.pageY = e.pageY;
  return point;
};

var points = [/*#__PURE__*/defaultPointerPos()];

if (typeof document !== 'undefined') {
  var updatePointsLocation = function updatePointsLocation(_a) {
    var touches = _a.touches;
    var numTouches = touches.length;
    points.length = 0;

    for (var i = 0; i < numTouches; i++) {
      var thisTouch = touches[i];
      points.push(eventToPoint(thisTouch));
    }
  };

  listen(document, 'touchstart touchmove', {
    passive: true,
    capture: true
  }).start(updatePointsLocation);
}

var point = /*#__PURE__*/defaultPointerPos();

if (typeof document !== 'undefined') {
  var updatePointLocation = function updatePointLocation(e) {
    eventToPoint(e, point);
  };

  listen(document, 'mousedown mousemove', true).start(updatePointLocation);
}

var delay = function delay(timeToDelay) {
  return action(function (_a) {
    var complete = _a.complete;
    var timeout = setTimeout(complete, timeToDelay);
    return {
      stop: function stop() {
        return clearTimeout(timeout);
      }
    };
  });
};

var isFloat = function isFloat(value) {
  return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */


var MotionValue = function () {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */
  function MotionValue(init, _a) {
    var _this = this;

    var _b = _a === void 0 ? {} : _a,
        transformer = _b.transformer,
        parent = _b.parent;
    /**
     * Duration, in milliseconds, since last updating frame.
     *
     * @internal
     */


    this.timeDelta = 0;
    /**
     * Timestamp of the last time this `MotionValue` was updated.
     *
     * @internal
     */

    this.lastUpdated = 0;
    /**
     * Tracks whether this value can output a velocity. Currently this is only true
     * if the value is numerical, but we might be able to widen the scope here and support
     * other value types.
     *
     * @internal
     */

    this.canTrackVelocity = false;

    this.updateAndNotify = function (v, render) {
      if (render === void 0) {
        render = true;
      }

      _this.prev = _this.current;
      _this.current = _this.transformer ? _this.transformer(v) : v;

      if (_this.updateSubscribers && _this.prev !== _this.current) {
        _this.updateSubscribers.forEach(_this.notifySubscriber);
      }

      if (_this.children) {
        _this.children.forEach(_this.setChild);
      }

      if (render && _this.renderSubscribers) {
        _this.renderSubscribers.forEach(_this.notifySubscriber);
      } // Update timestamp


      var _a = getFrameData(),
          delta = _a.delta,
          timestamp = _a.timestamp;

      if (_this.lastUpdated !== timestamp) {
        _this.timeDelta = delta;
        _this.lastUpdated = timestamp;
        sync.postRender(_this.scheduleVelocityCheck);
      }
    };
    /**
     * Notify a subscriber with the latest value.
     *
     * This is an instanced and bound function to prevent generating a new
     * function once per frame.
     *
     * @param subscriber - The subscriber to notify.
     *
     * @internal
     */


    this.notifySubscriber = function (subscriber) {
      subscriber(_this.current);
    };
    /**
     * Schedule a velocity check for the next frame.
     *
     * This is an instanced and bound function to prevent generating a new
     * function once per frame.
     *
     * @internal
     */


    this.scheduleVelocityCheck = function () {
      return sync.postRender(_this.velocityCheck);
    };
    /**
     * Updates `prev` with `current` if the value hasn't been updated this frame.
     * This ensures velocity calculations return `0`.
     *
     * This is an instanced and bound function to prevent generating a new
     * function once per frame.
     *
     * @internal
     */


    this.velocityCheck = function (_a) {
      var timestamp = _a.timestamp;

      if (timestamp !== _this.lastUpdated) {
        _this.prev = _this.current;
      }
    };
    /**
     * Updates child `MotionValue`.
     *
     * @param child - Child `MotionValue`.
     *
     * @internal
     */


    this.setChild = function (child) {
      return child.set(_this.current);
    };

    this.parent = parent;
    this.transformer = transformer;
    this.set(init, false);
    this.canTrackVelocity = isFloat(this.current);
  }
  /**
   * Creates a new `MotionValue` that's subscribed to the output of this one.
   *
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   *
   * @internal
   */


  MotionValue.prototype.addChild = function (config) {
    if (config === void 0) {
      config = {};
    }

    var child = new MotionValue(this.current, _assign$2({
      parent: this
    }, config));
    if (!this.children) this.children = new Set();
    this.children.add(child);
    return child;
  };
  /**
   * Stops a `MotionValue` from being subscribed to this one.
   *
   * @param child - The subscribed `MotionValue`
   *
   * @internal
   */


  MotionValue.prototype.removeChild = function (child) {
    if (!this.children) {
      return;
    }

    this.children.delete(child);
  };
  /**
   * Subscribes a subscriber function to a subscription list.
   *
   * @param subscriptions - A `Set` of subscribers.
   * @param subscription - A subscriber function.
   */


  MotionValue.prototype.subscribeTo = function (subscriptions, subscription) {
    var _this = this;

    var updateSubscriber = function updateSubscriber() {
      return subscription(_this.current);
    };

    subscriptions.add(updateSubscriber);
    return function () {
      return subscriptions.delete(updateSubscriber);
    };
  };
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * @library
   *
   * ```jsx
   * function MyComponent() {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.onChange(updateOpacity)
   *     const unsubscribeY = y.onChange(updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <Frame x={x} />
   * }
   * ```
   *
   * @motion
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.onChange(updateOpacity)
   *     const unsubscribeY = y.onChange(updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @internalremarks
   *
   * We could look into a `useOnChange` hook if the above lifecycle management proves confusing.
   *
   * ```jsx
   * useOnChange(x, () => {})
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @public
   */


  MotionValue.prototype.onChange = function (subscription) {
    if (!this.updateSubscribers) this.updateSubscribers = new Set();
    return this.subscribeTo(this.updateSubscribers, subscription);
  };
  /**
   * Adds a function that will be notified when the `MotionValue` requests a render.
   *
   * @param subscriber - A function that's provided the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @internal
   */


  MotionValue.prototype.onRenderRequest = function (subscription) {
    if (!this.renderSubscribers) this.renderSubscribers = new Set(); // Render immediately

    this.notifySubscriber(subscription);
    return this.subscribeTo(this.renderSubscribers, subscription);
  };
  /**
   * Attaches a passive effect to the `MotionValue`.
   *
   * @internal
   */


  MotionValue.prototype.attach = function (passiveEffect) {
    this.passiveEffect = passiveEffect;
  };
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */


  MotionValue.prototype.set = function (v, render) {
    if (render === void 0) {
      render = true;
    }

    if (!render || !this.passiveEffect) {
      this.updateAndNotify(v, render);
    } else {
      this.passiveEffect(v, this.updateAndNotify);
    }
  };
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */


  MotionValue.prototype.get = function () {
    return this.current;
  };
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */


  MotionValue.prototype.getVelocity = function () {
    // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
    return this.canTrackVelocity ? // These casts could be avoided if parseFloat would be typed better
    velocityPerSecond(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
  };
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   *
   * @internal
   */


  MotionValue.prototype.start = function (animation) {
    var _this = this;

    this.stop();
    return new Promise(function (resolve) {
      _this.stopAnimation = animation(resolve);
    }).then(function () {
      return _this.clearAnimation();
    });
  };
  /**
   * Stop the currently active animation.
   *
   * @public
   */


  MotionValue.prototype.stop = function () {
    if (this.stopAnimation) this.stopAnimation();
    this.clearAnimation();
  };
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */


  MotionValue.prototype.isAnimating = function () {
    return !!this.stopAnimation;
  };

  MotionValue.prototype.clearAnimation = function () {
    this.stopAnimation = null;
  };
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */


  MotionValue.prototype.destroy = function () {
    this.updateSubscribers && this.updateSubscribers.clear();
    this.renderSubscribers && this.renderSubscribers.clear();
    this.parent && this.parent.removeChild(this);
    this.stop();
  };

  return MotionValue;
}();
/**
 * @internal
 */


function motionValue(init, opts) {
  return new MotionValue(init, opts);
}
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */


function useConstant(init) {
  var ref = useRef(null);

  if (ref.current === null) {
    ref.current = init();
  }

  return ref.current;
}

var isMotionValue = function isMotionValue(value) {
  return value instanceof MotionValue;
}; // Creating a styler factory for the `onUpdate` prop allows all values
// to fire and the `onUpdate` prop will only fire once per frame


var updateStyler = createStyler({
  onRead: function onRead() {
    return null;
  },
  onRender: function onRender(state, _a) {
    var onUpdate = _a.onUpdate;
    return onUpdate(state);
  }
});

var MotionValuesMap = function () {
  function MotionValuesMap() {
    this.hasMounted = false;
    this.values = new Map();
    this.unsubscribers = new Map();
  }

  MotionValuesMap.prototype.has = function (key) {
    return this.values.has(key);
  };

  MotionValuesMap.prototype.set = function (key, value) {
    this.values.set(key, value);

    if (this.hasMounted) {
      this.bindValueToOutput(key, value);
    }
  };

  MotionValuesMap.prototype.get = function (key, defaultValue) {
    var value = this.values.get(key);

    if (value === undefined && defaultValue !== undefined) {
      value = new MotionValue(defaultValue);
      this.set(key, value);
    }

    return value;
  };

  MotionValuesMap.prototype.forEach = function (callback) {
    return this.values.forEach(callback);
  };

  MotionValuesMap.prototype.bindValueToOutput = function (key, value) {
    var _this = this;

    var onRender = function onRender(v) {
      return _this.output && _this.output(key, v);
    };

    var unsubscribeOnRender = value.onRenderRequest(onRender);

    var onChange = function onChange(v) {
      _this.onUpdate && _this.onUpdate.set(key, v);
    };

    var unsubscribeOnChange = value.onChange(onChange);

    if (this.unsubscribers.has(key)) {
      this.unsubscribers.get(key)();
    }

    this.unsubscribers.set(key, function () {
      unsubscribeOnRender();
      unsubscribeOnChange();
    });
  };

  MotionValuesMap.prototype.setOnUpdate = function (onUpdate) {
    this.onUpdate = undefined;

    if (onUpdate) {
      this.onUpdate = updateStyler({
        onUpdate: onUpdate
      });
    }
  };

  MotionValuesMap.prototype.setTransformTemplate = function (transformTemplate) {
    if (this.transformTemplate !== transformTemplate) {
      this.transformTemplate = transformTemplate;
      this.updateTransformTemplate();
    }
  };

  MotionValuesMap.prototype.getTransformTemplate = function () {
    return this.transformTemplate;
  };

  MotionValuesMap.prototype.updateTransformTemplate = function () {
    if (this.output) {
      this.output("transform", this.transformTemplate);
    }
  };

  MotionValuesMap.prototype.mount = function (output) {
    var _this = this;

    this.hasMounted = true;
    if (output) this.output = output;
    this.values.forEach(function (value, key) {
      return _this.bindValueToOutput(key, value);
    });
    this.updateTransformTemplate();
  };

  MotionValuesMap.prototype.unmount = function () {
    var _this = this;

    this.values.forEach(function (_value, key) {
      var unsubscribe = _this.unsubscribers.get(key);

      unsubscribe && unsubscribe();
    });
  };

  return MotionValuesMap;
}();

var specialMotionValueProps = new Set(["dragOriginX", "dragOriginY"]);

var useMotionValues = function useMotionValues(props) {
  var motionValues = useConstant(function () {
    var map = new MotionValuesMap();
    /**
     * Loop through every prop and add any detected `MotionValue`s. This is SVG-specific
     * code that should be extracted, perhaps considered hollistically with `useMotionStyles`.
     *
     * <motion.circle cx={motionValue(0)} />
     */

    for (var key in props) {
      if (isMotionValue(props[key]) && !specialMotionValueProps.has(key)) {
        map.set(key, props[key]);
      }
    }

    return map;
  });
  motionValues.setOnUpdate(props.onUpdate);
  motionValues.setTransformTemplate(props.transformTemplate);
  return motionValues;
};

var session = null;
var syncRenderSession = {
  isOpen: function isOpen() {
    return session !== null;
  },
  open: function open() {
    invariant$1(!session, "Sync render session already open");
    session = [];
  },
  flush: function flush() {
    invariant$1(session !== null, "No sync render session found");
    session && session.forEach(function (styler) {
      return styler.render();
    });
    session = null;
  },
  push: function push(styler) {
    invariant$1(session !== null, "No sync render session found");
    session && session.push(styler);
  }
};
/**
 * `useEffect` gets resolved bottom-up. We defer some optional functionality to child
 * components, so to ensure everything runs correctly we export the ref-binding logic
 * to a new component rather than in `useMotionValues`.
 */

var MountComponent = function MountComponent(_a) {
  var ref = _a.innerRef,
      values = _a.values,
      isStatic = _a.isStatic;
  useEffect(function () {
    invariant$1(ref.current instanceof Element, "No `ref` found. Ensure components created with `motion.custom` forward refs using `React.forwardRef`");
    var domStyler = index$1(ref.current, {
      preparseOutput: false,
      enableHardwareAcceleration: !isStatic
    });
    values.mount(function (key, value) {
      domStyler.set(key, value);

      if (syncRenderSession.isOpen()) {
        syncRenderSession.push(domStyler);
      }
    });
    return function () {
      return values.unmount();
    };
  }, []);
  return null;
};

var Mount = memo(MountComponent);

var createValueResolver = function createValueResolver(resolver) {
  return function (values) {
    var resolvedValues = {};
    values.forEach(function (value, key) {
      return resolvedValues[key] = resolver(value);
    });
    return resolvedValues;
  };
};

var resolveCurrent = createValueResolver(function (value) {
  return value.get();
});
var transformOriginProps = new Set(["originX", "originY", "originZ"]);

var isTransformOriginProp = function isTransformOriginProp(key) {
  return transformOriginProps.has(key);
};

var buildStyleAttr = function buildStyleAttr(values, styleProp, isStatic) {
  var motionValueStyles = resolveCurrent(values);
  var transformTemplate = values.getTransformTemplate();

  if (transformTemplate) {
    // If `transform` has been manually set as a string, pass that through the template
    // otherwise pass it forward to Stylefire's style property builder
    motionValueStyles.transform = styleProp.transform ? transformTemplate({}, styleProp.transform) : transformTemplate;
  }

  return buildStyleProperty(_assign$2(_assign$2({}, styleProp), motionValueStyles), !isStatic);
};

var useMotionStyles = function useMotionStyles(values, styleProp, isStatic, transformValues) {
  if (styleProp === void 0) {
    styleProp = {};
  }

  var style = {};
  var prevMotionStyles = useRef({}).current;

  for (var key in styleProp) {
    var thisStyle = styleProp[key];

    if (isMotionValue(thisStyle)) {
      // If this is a motion value, add it to our MotionValuesMap
      values.set(key, thisStyle);
    } else if (!isStatic && (isTransformProp(key) || isTransformOriginProp(key))) {
      // Or if it's a transform prop, create a motion value (or update an existing one)
      // to ensure Stylefire can reconcile all the transform values together.
      // A further iteration on this would be to create a single styler per component that gets
      // used in the DOM renderer's buildStyleAttr *and* animations, then we would only
      // have to convert animating values to `MotionValues` (we could probably remove this entire function).
      // The only architectural consideration is to allow Stylefire to have elements mounted after
      // a styler is created.
      if (!values.has(key)) {
        // If it doesn't exist as a motion value, create it
        values.set(key, motionValue(thisStyle));
      } else {
        // Otherwise only update it if it's changed from a previous render
        if (thisStyle !== prevMotionStyles[key]) {
          var value = values.get(key);
          value.set(thisStyle);
        }
      }

      prevMotionStyles[key] = thisStyle;
    } else {
      style[key] = thisStyle;
    }
  }

  return transformValues ? transformValues(style) : style;
};

var isKeyframesTarget = function isKeyframesTarget(v) {
  return Array.isArray(v);
};

var resolveFinalValueInKeyframes = function resolveFinalValueInKeyframes(v) {
  // TODO maybe throw if v.length - 1 is placeholder token?
  return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
};

var auto = {
  test: function test(v) {
    return v === "auto";
  },
  parse: function parse(v) {
    return v;
  }
};
var dimensionTypes = [number$1, px, percent, degrees, vw, vh, auto];

var valueTypes = __spreadArrays(dimensionTypes, [color$2, complex]);

var testValueType = function testValueType(v) {
  return function (type) {
    return type.test(v);
  };
};

var getDimensionValueType = function getDimensionValueType(v) {
  return dimensionTypes.find(testValueType(v));
};

var getValueType = function getValueType(v) {
  return valueTypes.find(testValueType(v));
};

var underDampedSpring = function underDampedSpring() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restDelta: 0.5,
    restSpeed: 10
  };
};

var overDampedSpring = function overDampedSpring(to) {
  return {
    type: "spring",
    stiffness: 700,
    damping: to === 0 ? 100 : 35
  };
};

var linearTween = function linearTween() {
  return {
    ease: "linear",
    duration: 0.3
  };
};

var keyframes = function keyframes(values) {
  return {
    type: "keyframes",
    duration: 0.8,
    values: values
  };
};

var defaultTransitions = {
  x: underDampedSpring,
  y: underDampedSpring,
  z: underDampedSpring,
  rotate: underDampedSpring,
  rotateX: underDampedSpring,
  rotateY: underDampedSpring,
  rotateZ: underDampedSpring,
  scaleX: overDampedSpring,
  scaleY: overDampedSpring,
  scale: overDampedSpring,
  opacity: linearTween,
  backgroundColor: linearTween,
  color: linearTween,
  default: overDampedSpring
};

var getDefaultTransition = function getDefaultTransition(valueKey, to) {
  var transitionFactory;

  if (isKeyframesTarget(to)) {
    transitionFactory = keyframes;
  } else {
    transitionFactory = defaultTransitions[valueKey] || defaultTransitions.default;
  }

  return _assign$2({
    to: to
  }, transitionFactory(to));
};
/**
 * A Popmotion action that accepts a single `to` prop. When it starts, it immediately
 * updates with `to` and then completes. By using this we can compose instant transitions
 * in with the same logic that applies `delay` or returns a `Promise` etc.
 *
 * Accepting `duration` is a little bit of a hack that simply defers the completetion of
 * the animation until after the duration finishes. This is for situations when you're **only**
 * animating non-animatable values and then setting something on `transitionEnd`. Really
 * you want this to fire after the "animation" finishes, rather than instantly.
 *
 * ```
 * animate={{
 *   display: 'block',
 *   transitionEnd: { display: 'none' }
 * }}
 * ```
 */


var just = function just(_a) {
  var to = _a.to,
      duration = _a.duration;
  return action(function (_a) {
    var update = _a.update,
        complete = _a.complete;
    update(to);
    duration ? delay(duration).start({
      complete: complete
    }) : complete();
  });
};

var easingDefinitionToFunction = function easingDefinitionToFunction(definition) {
  if (Array.isArray(definition)) {
    // If cubic bezier definition, create bezier curve
    invariant$1(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
    var x1 = definition[0],
        y1 = definition[1],
        x2 = definition[2],
        y2 = definition[3];
    return cubicBezier(x1, y1, x2, y2);
  } else if (typeof definition === "string") {
    // Else lookup from table
    invariant$1(easingLookup[definition] !== undefined, "Invalid easing type '" + definition + "'");
    return easingLookup[definition];
  }

  return definition;
};

var isEasingArray = function isEasingArray(ease) {
  return Array.isArray(ease) && typeof ease[0] !== "number";
};

var isDurationAnimation = function isDurationAnimation(v) {
  return v.hasOwnProperty("duration") || v.hasOwnProperty("repeatDelay");
};
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */


var isAnimatable = function isAnimatable(key, value) {
  // If the list of keys tat might be non-animatable grows, replace with Set
  if (key === "zIndex") return false; // If it's a number or a keyframes array, we can animate it. We might at some point
  // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
  // but for now lets leave it like this for performance reasons

  if (typeof value === "number" || Array.isArray(value)) return true;

  if (typeof value === "string" && // It's animatable if we have a string
  complex.test(value) && // And it contains numbers and/or colors
  !value.startsWith("url(") // Unless it starts with "url("
  ) {
    return true;
  }

  return false;
};
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */


var secondsToMilliseconds = function secondsToMilliseconds(seconds) {
  return seconds * 1000;
};

var transitions = {
  tween: tween,
  spring: vectorSpring,
  keyframes: keyframes$1,
  inertia: index,
  just: just
};
var transitionOptionParser = {
  tween: function tween(opts) {
    if (opts.ease) {
      var ease = isEasingArray(opts.ease) ? opts.ease[0] : opts.ease;
      opts.ease = easingDefinitionToFunction(ease);
    }

    return opts;
  },
  keyframes: function keyframes(_a) {
    var from = _a.from;
    _a.to;
    _a.velocity;

    var opts = __rest$4(_a, ["from", "to", "velocity"]);

    if (opts.values && opts.values[0] === null) {
      var values = __spreadArrays(opts.values);

      values[0] = from;
      opts.values = values;
    }

    if (opts.ease) {
      opts.easings = isEasingArray(opts.ease) ? opts.ease.map(easingDefinitionToFunction) : easingDefinitionToFunction(opts.ease);
    }

    opts.ease = linear;
    return opts;
  }
};

var isTransitionDefined = function isTransitionDefined(_a) {
  _a.when;
  _a.delay;
  _a.delayChildren;
  _a.staggerChildren;
  _a.staggerDirection;

  var transition = __rest$4(_a, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection"]);

  return Object.keys(transition).length;
};

var getTransitionDefinition = function getTransitionDefinition(key, to, transitionDefinition) {
  var delay = transitionDefinition ? transitionDefinition.delay : 0; // If no object, return default transition
  // A better way to handle this would be to deconstruct out all the shared Orchestration props
  // and see if there's any props remaining

  if (transitionDefinition === undefined || !isTransitionDefined(transitionDefinition)) {
    return _assign$2({
      delay: delay
    }, getDefaultTransition(key, to));
  }

  var valueTransitionDefinition = transitionDefinition[key] || transitionDefinition.default || transitionDefinition;

  if (valueTransitionDefinition.type === false) {
    return {
      delay: valueTransitionDefinition.hasOwnProperty("delay") ? valueTransitionDefinition.delay : delay,
      to: isKeyframesTarget(to) ? to[to.length - 1] : to,
      type: "just"
    };
  } else if (isKeyframesTarget(to)) {
    return _assign$2(_assign$2({
      values: to,
      duration: 0.8,
      delay: delay,
      ease: "linear"
    }, valueTransitionDefinition), {
      // This animation must be keyframes if we're animating through an array
      type: "keyframes"
    });
  } else {
    return _assign$2({
      type: "tween",
      to: to,
      delay: delay
    }, valueTransitionDefinition);
  }
};

var preprocessOptions = function preprocessOptions(type, opts) {
  return transitionOptionParser[type] ? transitionOptionParser[type](opts) : opts;
};

var getAnimation = function getAnimation(key, value, target, transition) {
  var origin = value.get();
  var isOriginAnimatable = isAnimatable(key, origin);
  var isTargetAnimatable = isAnimatable(key, target); // TODO we could probably improve this check to ensure both values are of the same type -
  // for instance 100 to #fff. This might live better in Popmotion.

  warning$1(isOriginAnimatable === isTargetAnimatable, "You are trying to animate " + key + " from \"" + origin + "\" to " + target + ". \"" + origin + "\" is not an animatable value - to enable this animation set " + origin + " to a value animatable to " + target + " via the `style` property."); // Parse the `transition` prop and return options for the Popmotion animation

  var _a = getTransitionDefinition(key, target, transition),
      _b = _a.type,
      type = _b === void 0 ? "tween" : _b,
      transitionDefinition = __rest$4(_a, ["type"]); // If this is an animatable pair of values, return an animation, otherwise use `just`


  var actionFactory = isOriginAnimatable && isTargetAnimatable ? transitions[type] : just;
  var opts = preprocessOptions(type, _assign$2({
    from: origin,
    velocity: value.getVelocity()
  }, transitionDefinition)); // Convert duration from Framer Motion's seconds into Popmotion's milliseconds

  if (isDurationAnimation(opts)) {
    if (opts.duration) {
      opts.duration = secondsToMilliseconds(opts.duration);
    }

    if (opts.repeatDelay) {
      opts.repeatDelay = secondsToMilliseconds(opts.repeatDelay);
    }
  }

  return [actionFactory, opts];
};
/**
 * Start animation on a value. This function completely encapsulates Popmotion-specific logic.
 *
 * @internal
 */


function startAnimation(key, value, target, _a) {
  var _b = _a.delay,
      delay$1 = _b === void 0 ? 0 : _b,
      transition = __rest$4(_a, ["delay"]);

  return value.start(function (complete) {
    var activeAnimation;

    var _a = getAnimation(key, value, target, transition),
        animationFactory = _a[0],
        _b = _a[1],
        valueDelay = _b.delay,
        options = __rest$4(_b, ["delay"]);

    if (valueDelay !== undefined) {
      delay$1 = valueDelay;
    }

    var animate = function animate() {
      var animation = animationFactory(options); // Bind animation opts to animation

      activeAnimation = animation.start({
        update: function update(v) {
          return value.set(v);
        },
        complete: complete
      });
    }; // If we're delaying this animation, only resolve it **after** the delay to
    // ensure the value's resolve velocity is up-to-date.


    if (delay$1) {
      activeAnimation = delay(secondsToMilliseconds(delay$1)).start({
        complete: animate
      });
    } else {
      animate();
    }

    return function () {
      if (activeAnimation) activeAnimation.stop();
    };
  });
}
/**
 * Get the current value of every `MotionValue`
 * @param values -
 */


var getCurrent = function getCurrent(values) {
  var current = {};
  values.forEach(function (value, key) {
    return current[key] = value.get();
  });
  return current;
};
/**
 * Get the current velocity of every `MotionValue`
 * @param values -
 */


var getVelocity = function getVelocity(values) {
  var velocity = {};
  values.forEach(function (value, key) {
    return velocity[key] = value.getVelocity();
  });
  return velocity;
};
/**
 * Check if value is a function that returns a `Target`. A generic typeof === 'function'
 * check, just helps with typing.
 * @param p -
 */


var isTargetResolver = function isTargetResolver(p) {
  return typeof p === "function";
};
/**
 * Check if value is a list of variant labels
 * @param v -
 */


var isVariantLabels = function isVariantLabels(v) {
  return Array.isArray(v);
};
/**
 * Check if value is a numerical string, ie "100" or "100px"
 */


var isNumericalString = function isNumericalString(v) {
  return /^\d*\.?\d+$/.test(v);
};
/**
 * Control animations for a single component
 *
 * @internal
 */


var ValueAnimationControls = function () {
  function ValueAnimationControls(_a) {
    var _this = this;

    var values = _a.values,
        readValueFromSource = _a.readValueFromSource,
        makeTargetAnimatable = _a.makeTargetAnimatable;
    /**
     * A reference to the component's latest props. We could probably ditch this in
     * favour to a reference to the `custom` prop now we don't send all props through
     * to target resolvers.
     */

    this.props = {};
    /**
     * The component's variants, as provided by `variants`
     */

    this.variants = {};
    /**
     * A set of values that we animate back to when a value is cleared of all overrides.
     */

    this.baseTarget = {};
    /**
     * A series of target overrides that we can animate to/from when overrides are set/cleared.
     */

    this.overrides = [];
    /**
     * A series of target overrides as they were originally resolved.
     */

    this.resolvedOverrides = [];
    /**
     * A Set of currently active override indexes
     */

    this.activeOverrides = new Set();
    /**
     * A Set of value keys that are currently animating.
     */

    this.isAnimating = new Set();
    /**
     * Check if the associated `MotionValueMap` has a key with the provided string.
     * Pre-bound to the class so we can provide directly to the `filter` in `checkForNewValues`.
     */

    this.hasValue = function (key) {
      return !_this.values.has(key);
    };

    this.values = values;
    this.readValueFromSource = readValueFromSource;
    this.makeTargetAnimatable = makeTargetAnimatable;
    this.values.forEach(function (value, key) {
      return _this.baseTarget[key] = value.get();
    });
  }
  /**
   * Set the reference to the component's props.
   * @param props -
   */


  ValueAnimationControls.prototype.setProps = function (props) {
    this.props = props;
  };
  /**
   * Set the reference to the component's variants
   * @param variants -
   */


  ValueAnimationControls.prototype.setVariants = function (variants) {
    if (variants) this.variants = variants;
  };
  /**
   * Set the component's default transition
   * @param transition -
   */


  ValueAnimationControls.prototype.setDefaultTransition = function (transition) {
    if (transition) this.defaultTransition = transition;
  };
  /**
   * Set motion values without animation.
   *
   * @param definition -
   * @param isActive -
   */


  ValueAnimationControls.prototype.setValues = function (definition, _a) {
    var _this = this;

    var _b = _a === void 0 ? {} : _a,
        _c = _b.isActive,
        isActive = _c === void 0 ? new Set() : _c,
        priority = _b.priority;

    var _d = this.resolveVariant(definition),
        target = _d.target,
        transitionEnd = _d.transitionEnd;

    target = this.transformValues(_assign$2(_assign$2({}, target), transitionEnd));
    return Object.keys(target).forEach(function (key) {
      if (isActive.has(key)) return;
      isActive.add(key);

      if (target) {
        var targetValue = resolveFinalValueInKeyframes(target[key]);

        if (_this.values.has(key)) {
          var value = _this.values.get(key);

          value && value.set(targetValue);
        } else {
          _this.values.set(key, motionValue(targetValue));
        }

        if (!priority) _this.baseTarget[key] = targetValue;
      }
    });
  };
  /**
   * Allows `transformValues` to be set by a component that allows us to
   * transform the values in a given `Target`. This allows Framer Library
   * to extend Framer Motion to animate `Color` variables etc. Currently we have
   * to manually support these extended types here in Framer Motion.
   *
   * @param values -
   */


  ValueAnimationControls.prototype.transformValues = function (values) {
    var transformValues = this.props.transformValues;
    return transformValues ? transformValues(values) : values;
  };
  /**
   * Check a `Target` for new values we haven't animated yet, and add them
   * to the `MotionValueMap`.
   *
   * Currently there's functionality here that is DOM-specific, we should allow
   * this functionality to be injected by the factory that creates DOM-specific
   * components.
   *
   * @param target -
   */


  ValueAnimationControls.prototype.checkForNewValues = function (target) {
    var newValueKeys = Object.keys(target).filter(this.hasValue);
    var numNewValues = newValueKeys.length;
    if (!numNewValues) return;

    for (var i = 0; i < numNewValues; i++) {
      var key = newValueKeys[i];
      var targetValue = target[key];
      var value = null; // If this is a keyframes value, we can attempt to use the first value in the
      // array as that's going to be the first value of the animation anyway

      if (Array.isArray(targetValue)) {
        value = targetValue[0];
      } // If it isn't a keyframes or the first keyframes value was set as `null`, read the
      // value from the DOM. It might be worth investigating whether to check props (for SVG)
      // or props.style (for HTML) if the value exists there before attempting to read.


      if (value === null) {
        value = this.readValueFromSource(key);
        invariant$1(value !== null, "No initial value for \"" + key + "\" can be inferred. Ensure an initial value for \"" + key + "\" is defined on the component.");
      }

      if (typeof value === "string" && isNumericalString(value)) {
        // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
      } else if (!getValueType(value) && complex.test(targetValue)) {
        // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
        value = complex.getAnimatableNone(targetValue);
      }

      this.values.set(key, motionValue(value));
      this.baseTarget[key] = value;
    }
  };
  /**
   * Resolve a variant from its label or resolver into an actual `Target` we can animate to.
   * @param variant -
   */


  ValueAnimationControls.prototype.resolveVariant = function (variant) {
    if (!variant) {
      return {
        target: undefined,
        transition: undefined,
        transitionEnd: undefined
      };
    }

    if (isTargetResolver(variant)) {
      // resolve current and velocity
      variant = variant(this.props.custom, getCurrent(this.values), getVelocity(this.values));
    }

    var _a = variant.transition,
        transition = _a === void 0 ? this.defaultTransition : _a,
        transitionEnd = variant.transitionEnd,
        target = __rest$4(variant, ["transition", "transitionEnd"]);

    return {
      transition: transition,
      transitionEnd: transitionEnd,
      target: target
    };
  };
  /**
   * Get the highest active override priority index
   */


  ValueAnimationControls.prototype.getHighestPriority = function () {
    if (!this.activeOverrides.size) return 0;
    return Math.max.apply(Math, Array.from(this.activeOverrides));
  };
  /**
   * Set an override. We add this layer of indirection so if, for instance, a tap gesture
   * starts and overrides a hover gesture, when we clear the tap gesture and fallback to the
   * hover gesture, if that hover gesture has changed in the meantime we can go to that rather
   * than the one that was resolved when the hover gesture animation started.
   *
   * @param definition -
   * @param overrideIndex -
   */


  ValueAnimationControls.prototype.setOverride = function (definition, overrideIndex) {
    this.overrides[overrideIndex] = definition;

    if (this.children) {
      this.children.forEach(function (child) {
        return child.setOverride(definition, overrideIndex);
      });
    }
  };
  /**
   * Start an override animation.
   * @param overrideIndex -
   */


  ValueAnimationControls.prototype.startOverride = function (overrideIndex) {
    var override = this.overrides[overrideIndex];

    if (override) {
      return this.start(override, {
        priority: overrideIndex
      });
    }
  };
  /**
   * Clear an override. We check every value we animated to in this override to see if
   * its present on any lower-priority overrides. If not, we animate it back to its base target.
   * @param overrideIndex -
   */


  ValueAnimationControls.prototype.clearOverride = function (overrideIndex) {
    var _this = this;

    if (this.children) {
      this.children.forEach(function (child) {
        return child.clearOverride(overrideIndex);
      });
    }

    var override = this.overrides[overrideIndex];
    if (!override) return;
    this.activeOverrides.delete(overrideIndex);
    var highest = this.getHighestPriority();
    this.resetIsAnimating();

    if (highest) {
      var highestOverride = this.overrides[highest];
      highestOverride && this.startOverride(highest);
    } // Figure out which remaining values were affected by the override and animate those


    var overrideTarget = this.resolvedOverrides[overrideIndex];
    if (!overrideTarget) return;
    var remainingValues = {};

    for (var key in this.baseTarget) {
      if (overrideTarget[key] !== undefined) {
        remainingValues[key] = this.baseTarget[key];
      }
    }

    this.onStart();
    this.animate(remainingValues).then(function () {
      return _this.onComplete();
    });
  };
  /**
   * Apply a target/variant without any animation
   */


  ValueAnimationControls.prototype.apply = function (definition) {
    if (Array.isArray(definition)) {
      return this.applyVariantLabels(definition);
    } else if (typeof definition === "string") {
      return this.applyVariantLabels([definition]);
    } else {
      this.setValues(definition);
    }
  };
  /**
   * Apply variant labels without animation
   */


  ValueAnimationControls.prototype.applyVariantLabels = function (variantLabelList) {
    var _this = this;

    var isActive = new Set();

    var reversedList = __spreadArrays(variantLabelList).reverse();

    reversedList.forEach(function (key) {
      var _a = _this.resolveVariant(_this.variants[key]),
          target = _a.target,
          transitionEnd = _a.transitionEnd;

      if (transitionEnd) {
        _this.setValues(transitionEnd, {
          isActive: isActive
        });
      }

      if (target) {
        _this.setValues(target, {
          isActive: isActive
        });
      }

      if (_this.children && _this.children.size) {
        _this.children.forEach(function (child) {
          return child.applyVariantLabels(variantLabelList);
        });
      }
    });
  };

  ValueAnimationControls.prototype.start = function (definition, opts) {
    var _this = this;

    if (opts === void 0) {
      opts = {};
    }

    if (opts.priority) {
      this.activeOverrides.add(opts.priority);
    }

    this.resetIsAnimating(opts.priority);
    var animation;

    if (isVariantLabels(definition)) {
      animation = this.animateVariantLabels(definition, opts);
    } else if (typeof definition === "string") {
      animation = this.animateVariant(definition, opts);
    } else {
      animation = this.animate(definition, opts);
    }

    this.onStart();
    return animation.then(function () {
      return _this.onComplete();
    });
  };

  ValueAnimationControls.prototype.animate = function (animationDefinition, _a) {
    var _this = this;

    var _b = _a === void 0 ? {} : _a,
        _c = _b.delay,
        delay = _c === void 0 ? 0 : _c,
        _d = _b.priority,
        priority = _d === void 0 ? 0 : _d,
        transitionOverride = _b.transitionOverride;

    var _e = this.resolveVariant(animationDefinition),
        target = _e.target,
        transition = _e.transition,
        transitionEnd = _e.transitionEnd;

    if (transitionOverride) {
      transition = transitionOverride;
    }

    if (!target) return Promise.resolve();
    target = this.transformValues(target);

    if (transitionEnd) {
      transitionEnd = this.transformValues(transitionEnd);
    }

    this.checkForNewValues(target);

    if (this.makeTargetAnimatable) {
      var animatable = this.makeTargetAnimatable(target, transitionEnd);
      target = animatable.target;
      transitionEnd = animatable.transitionEnd;
    }

    if (priority) {
      this.resolvedOverrides[priority] = target;
    }

    this.checkForNewValues(target);
    var animations = [];

    for (var key in target) {
      var value = this.values.get(key);
      if (!value || !target || target[key] === undefined) continue;
      var valueTarget = target[key];

      if (!priority) {
        this.baseTarget[key] = resolveFinalValueInKeyframes(valueTarget);
      }

      if (this.isAnimating.has(key)) continue;
      this.isAnimating.add(key);
      animations.push(startAnimation(key, value, valueTarget, _assign$2({
        delay: delay
      }, transition)));
    }

    var allAnimations = Promise.all(animations);
    return transitionEnd ? allAnimations.then(function () {
      _this.setValues(transitionEnd, {
        priority: priority
      });
    }) : allAnimations;
  };

  ValueAnimationControls.prototype.animateVariantLabels = function (variantLabels, opts) {
    var _this = this;

    var animations = __spreadArrays(variantLabels).reverse().map(function (label) {
      return _this.animateVariant(label, opts);
    });

    return Promise.all(animations);
  };

  ValueAnimationControls.prototype.animateVariant = function (variantLabel, opts) {
    var _this = this;

    var when = false;
    var delayChildren = 0;
    var staggerChildren = 0;
    var staggerDirection = 1;
    var priority = opts && opts.priority || 0;
    var variant = this.variants[variantLabel];
    var getAnimations = variant ? function () {
      return _this.animate(variant, opts);
    } : function () {
      return Promise.resolve();
    };
    var getChildrenAnimations = this.children ? function () {
      return _this.animateChildren(variantLabel, delayChildren, staggerChildren, staggerDirection, priority);
    } : function () {
      return Promise.resolve();
    };

    if (variant && this.children) {
      var transition = this.resolveVariant(variant).transition;

      if (transition) {
        when = transition.when || when;
        delayChildren = transition.delayChildren || delayChildren;
        staggerChildren = transition.staggerChildren || staggerChildren;
        staggerDirection = transition.staggerDirection || staggerDirection;
      }
    }

    if (when) {
      var _a = when === "beforeChildren" ? [getAnimations, getChildrenAnimations] : [getChildrenAnimations, getAnimations],
          first = _a[0],
          last = _a[1];

      return first().then(last);
    } else {
      return Promise.all([getAnimations(), getChildrenAnimations()]);
    }
  };

  ValueAnimationControls.prototype.animateChildren = function (variantLabel, delayChildren, staggerChildren, staggerDirection, priority) {
    if (delayChildren === void 0) {
      delayChildren = 0;
    }

    if (staggerChildren === void 0) {
      staggerChildren = 0;
    }

    if (staggerDirection === void 0) {
      staggerDirection = 1;
    }

    if (priority === void 0) {
      priority = 0;
    }

    if (!this.children) {
      return Promise.resolve();
    }

    var animations = [];
    var maxStaggerDuration = (this.children.size - 1) * staggerChildren;
    var generateStaggerDuration = staggerDirection === 1 ? function (i) {
      return i * staggerChildren;
    } : function (i) {
      return maxStaggerDuration - i * staggerChildren;
    };
    Array.from(this.children).forEach(function (childControls, i) {
      var animation = childControls.animateVariant(variantLabel, {
        priority: priority,
        delay: delayChildren + generateStaggerDuration(i)
      });
      animations.push(animation);
    });
    return Promise.all(animations);
  };

  ValueAnimationControls.prototype.onStart = function () {
    var onAnimationStart = this.props.onAnimationStart;
    onAnimationStart && onAnimationStart();
  };

  ValueAnimationControls.prototype.onComplete = function () {
    var onAnimationComplete = this.props.onAnimationComplete;
    onAnimationComplete && onAnimationComplete();
  };

  ValueAnimationControls.prototype.checkOverrideIsAnimating = function (priority) {
    var numOverrides = this.overrides.length;

    for (var i = priority + 1; i < numOverrides; i++) {
      var resolvedOverride = this.resolvedOverrides[i];

      if (resolvedOverride) {
        for (var key in resolvedOverride) {
          this.isAnimating.add(key);
        }
      }
    }
  };

  ValueAnimationControls.prototype.resetIsAnimating = function (priority) {
    if (priority === void 0) {
      priority = 0;
    }

    this.isAnimating.clear(); // If this isn't the highest priority gesture, block the animation
    // of anything that's currently being animated

    if (priority < this.getHighestPriority()) {
      this.checkOverrideIsAnimating(priority);
    }

    if (this.children) {
      this.children.forEach(function (child) {
        return child.resetIsAnimating(priority);
      });
    }
  };

  ValueAnimationControls.prototype.stop = function () {
    this.values.forEach(function (value) {
      return value.stop();
    });
  };
  /**
   * Add the controls of a child component.
   * @param controls -
   */


  ValueAnimationControls.prototype.addChild = function (controls) {
    if (!this.children) {
      this.children = new Set();
    }

    this.children.add(controls); // We set child overrides when `setOverride` is called, but also have to do it here
    // as the first time `setOverride` is called all the children might not have been added yet.

    this.overrides.forEach(function (override, i) {
      override && controls.setOverride(override, i);
    });
  };

  ValueAnimationControls.prototype.removeChild = function (controls) {
    if (!this.children) {
      return;
    }

    this.children.delete(controls);
  };

  ValueAnimationControls.prototype.resetChildren = function () {
    if (this.children) this.children.clear();
  };

  return ValueAnimationControls;
}();
/**
 * Use callback either only on the initial render or on all renders. In concurrent mode
 * the "initial" render might run multiple times
 *
 * @param callback - Callback to run
 * @param isInitialOnly - Set to `true` to only run on initial render, or `false` for all renders. Defaults to `false`.
 *
 * @public
 */


function useInitialOrEveryRender(callback, isInitialOnly) {
  if (isInitialOnly === void 0) {
    isInitialOnly = false;
  }

  var isInitialRender = useRef(true);

  if (!isInitialOnly || isInitialOnly && isInitialRender.current) {
    callback();
  }

  isInitialRender.current = false;
}
/**
 * Control animations on one or more components.
 *
 * @public
 */


var AnimationControls = function () {
  function AnimationControls() {
    /**
     * Track whether the host component has mounted.
     *
     * @internal
     */
    this.hasMounted = false;
    /**
     * Pending animations that are started before a component is mounted.
     *
     * @internal
     */

    this.pendingAnimations = [];
    /**
     * A collection of linked component animation controls.
     *
     * @internal
     */

    this.componentControls = new Set();
  }
  /**
   * Set variants on this and all child components.
   *
   * @param variants - The variants to set
   *
   * @internal
   */


  AnimationControls.prototype.setVariants = function (variants) {
    this.variants = variants;
    this.componentControls.forEach(function (controls) {
      return controls.setVariants(variants);
    });
  };
  /**
   * Set a default transition on this and all child components
   *
   * @param transition - The default transition to set
   *
   * @internal
   */


  AnimationControls.prototype.setDefaultTransition = function (transition) {
    this.defaultTransition = transition;
    this.componentControls.forEach(function (controls) {
      return controls.setDefaultTransition(transition);
    });
  };
  /**
   * Subscribes a component's animation controls to this.
   *
   * @param controls - The controls to subscribe
   * @returns An unsubscribe function.
   *
   * @internal
   */


  AnimationControls.prototype.subscribe = function (controls) {
    var _this = this;

    this.componentControls.add(controls);
    if (this.variants) controls.setVariants(this.variants);
    if (this.defaultTransition) controls.setDefaultTransition(this.defaultTransition);
    return function () {
      return _this.componentControls.delete(controls);
    };
  };
  /**
   * Starts an animation on all linked components.
   *
   * @remarks
   *
   * ```jsx
   * controls.start("variantLabel")
   * controls.start({
   *   x: 0,
   *   transition: { duration: 1 }
   * })
   * ```
   *
   * @param definition - Properties or variant label to animate to
   * @param transition - Optional `transtion` to apply to a variant
   * @returns - A `Promise` that resolves when all animations have completed.
   *
   * @public
   */


  AnimationControls.prototype.start = function (definition, transitionOverride) {
    var _this = this;

    if (this.hasMounted) {
      var animations_1 = [];
      this.componentControls.forEach(function (controls) {
        var animation = controls.start(definition, {
          transitionOverride: transitionOverride
        });
        animations_1.push(animation);
      });
      return Promise.all(animations_1);
    } else {
      return new Promise(function (resolve) {
        _this.pendingAnimations.push({
          animation: [definition, transitionOverride],
          resolve: resolve
        });
      });
    }
  };
  /**
   * Instantly set to a set of properties or a variant.
   *
   * ```jsx
   * // With properties
   * controls.set({ opacity: 0 })
   *
   * // With variants
   * controls.set("hidden")
   * ```
   *
   * @internalremarks
   * We could perform a similar trick to `.start` where this can be called before mount
   * and we maintain a list of of pending actions that get applied on mount. But the
   * expectation of `set` is that it happens synchronously and this would be difficult
   * to do before any children have even attached themselves. It's also poor practise
   * and we should discourage render-synchronous `.start` calls rather than lean into this.
   *
   * @public
   */


  AnimationControls.prototype.set = function (definition) {
    invariant$1(this.hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
    return this.componentControls.forEach(function (controls) {
      return controls.apply(definition);
    });
  };
  /**
   * Stops animations on all linked components.
   *
   * ```jsx
   * controls.stop()
   * ```
   *
   * @public
   */


  AnimationControls.prototype.stop = function () {
    this.componentControls.forEach(function (controls) {
      return controls.stop();
    });
  };
  /**
   * Initialises the animation controls.
   *
   * @internal
   */


  AnimationControls.prototype.mount = function () {
    var _this = this;

    this.hasMounted = true;
    this.pendingAnimations.forEach(function (_a) {
      var animation = _a.animation,
          resolve = _a.resolve;
      return _this.start.apply(_this, animation).then(resolve);
    });
  };
  /**
   * Stops all child animations when the host component unmounts.
   *
   * @internal
   */


  AnimationControls.prototype.unmount = function () {
    this.hasMounted = false;
    this.stop();
  };

  return AnimationControls;
}();

var PresenceContext = createContext(null);
/**
 * @internal
 */

var MotionContext = createContext({
  static: false
});

var isVariantLabel = function isVariantLabel(v) {
  return typeof v === "string" || Array.isArray(v);
};

var isAnimationControls = function isAnimationControls(v) {
  return v instanceof AnimationControls;
};
/**
 * Set up the context for children motion components.
 *
 * We also use this opportunity to apply `initial` values
 */


var useMotionContext = function useMotionContext(parentContext, controls, values, isStatic, _a) {
  if (isStatic === void 0) {
    isStatic = false;
  }

  var initial = _a.initial,
      animate = _a.animate,
      variants = _a.variants,
      whileTap = _a.whileTap,
      whileHover = _a.whileHover;

  var _b;

  var presenceContext = useContext(PresenceContext); // Override initial with that from a parent context, if defined

  if (((_b = presenceContext) === null || _b === void 0 ? void 0 : _b.initial) !== undefined) {
    initial = presenceContext.initial;
  }

  var initialState;

  if (initial === false && !isAnimationControls(animate)) {
    initialState = animate;
  } else if (typeof initial !== "boolean") {
    initialState = initial;
  } // Track mounted status so children can detect whether they were present during their
  // parent's first render


  var hasMounted = useRef(false); // We propagate this component's ValueAnimationControls *if* we're being provided variants,
  // if we're being used to control variants, or if we're being passed animation controls.
  // Otherwise this component should be "invisible" to variant propagation. This is a slight concession
  // to Framer X where every `Frame` is a `motion` component and it might be if we change that in the future
  // that this restriction is removed.

  var shouldPropagateControls = variants || isVariantLabel(animate) || isVariantLabel(whileTap) || isVariantLabel(whileHover) || isAnimationControls(animate); // If this component's `initial` prop is a variant label, propagate it. Otherwise pass the parent's.

  var targetInitial = isVariantLabel(initialState) ? initialState : parentContext.initial; // If this is a variant tree we need to propagate the `animate` prop in case new children are added after
  // the tree initially animates.

  var targetAnimate = isVariantLabel(animate) ? animate : parentContext.animate; // Only allow `initial` to trigger context re-renders if this is a `static` component (ie we're on the Framer canvas)
  // or in another non-animation/interaction environment.

  var initialDependency = isStatic ? targetInitial : null; // Only allow `animate` to trigger context re-renders if it's a variant label. If this is an array of
  // variant labels there's probably an optimisation to deep-compare but it might be an over-optimisation.
  // We want to do this as we rely on React's component rendering order each render cycle to determine
  // the new order of any child components for the `staggerChildren` functionality.

  var animateDependency = shouldPropagateControls && isVariantLabel(targetAnimate) ? targetAnimate : null; // The context to provide to the child. We `useMemo` because although `controls` and `initial` are
  // unlikely to change, by making the context an object it'll be considered a new value every render.
  // So all child motion components will re-render as a result.

  var context = useMemo(function () {
    return {
      controls: shouldPropagateControls ? controls : parentContext.controls,
      initial: targetInitial,
      animate: targetAnimate,
      values: values,
      hasMounted: hasMounted,
      isReducedMotion: parentContext.isReducedMotion
    };
  }, [initialDependency, animateDependency, parentContext.isReducedMotion]); // Update the `static` property every render. This is unlikely to change but also essentially free.

  context.static = isStatic; // Set initial state. If this is a static component (ie in Framer canvas), respond to updates
  // in `initial`.

  useInitialOrEveryRender(function () {
    var initialToApply = initialState || parentContext.initial;
    initialToApply && controls.apply(initialToApply);
  }, !isStatic);
  useEffect(function () {
    hasMounted.current = true;
  }, []);
  return context;
};
/**
 * Creates an imperative set of controls to trigger animations.
 *
 * This allows a consolidated, uniform API for animations, to be triggered by other APIs like the `animate` prop, or the gesture handlers.
 *
 * @param values
 * @param props
 * @param ref
 * @param subscribeToParentControls
 *
 * @internal
 */


function useValueAnimationControls(config, props, subscribeToParentControls) {
  var variants = props.variants,
      transition = props.transition;
  var parentControls = useContext(MotionContext).controls;
  var presenceContext = useContext(PresenceContext);
  var controls = useConstant(function () {
    return new ValueAnimationControls(config);
  }); // Reset and resubscribe children every render to ensure stagger order is correct

  if (!presenceContext || presenceContext.isPresent) {
    controls.resetChildren();
    controls.setProps(props);
    controls.setVariants(variants);
    controls.setDefaultTransition(transition);
  } // We have to subscribe to the parent controls within a useEffect rather than during render,
  // as


  useEffect(function () {
    if (subscribeToParentControls && parentControls) {
      parentControls.addChild(controls);
    }
  });
  useEffect(function () {
    return function () {
      // Remove reference to onAnimationComplete from controls. All the MotionValues
      // are unsubscribed from this component separately. We let animations run out
      // as they might be animating other components.
      props.onAnimationComplete;

      var unmountProps = __rest$4(props, ["onAnimationComplete"]);

      controls.setProps(unmountProps);
      parentControls && parentControls.removeChild(controls);
    };
  }, []);
  return controls;
}

var checkShouldInheritVariant = function checkShouldInheritVariant(_a) {
  var animate = _a.animate,
      variants = _a.variants,
      _b = _a.inherit,
      inherit = _b === void 0 ? true : _b;
  return inherit && !!variants && (!animate || animate instanceof AnimationControls);
};
/**
 * Uses the ref that is passed in, or creates a new one
 * @param external - External ref
 * @internal
 */


function useExternalRef(externalRef) {
  // We're conditionally calling `useRef` here which is sort of naughty as hooks
  // shouldn't be called conditionally. However, Framer Motion will break if this
  // condition changes anyway. It might be possible to use an invariant here to
  // make it explicit, but I expect changing `ref` is not normal behaviour.
  var ref = !externalRef || typeof externalRef === "function" ? useRef(null) : externalRef; // Handle `ref` functions. Again, calling the hook conditionally is kind of naughty
  // but `ref` types changing between renders would break Motion anyway. If we receive
  // bug reports about this, we should track the provided ref and throw an invariant
  // rather than move the conditional to inside the useEffect as this will be fired
  // for every Frame component within Framer.

  if (externalRef && typeof externalRef === "function") {
    useEffect(function () {
      externalRef(ref.current);
      return function () {
        return externalRef(null);
      };
    }, []);
  }

  return ref;
}
/**
 * @internal
 */


var createMotionComponent = function createMotionComponent(_a) {
  var getValueControlsConfig = _a.getValueControlsConfig,
      loadFunctionalityComponents = _a.loadFunctionalityComponents,
      renderComponent = _a.renderComponent;

  function MotionComponent(props, externalRef) {
    var ref = useExternalRef(externalRef);
    var parentContext = useContext(MotionContext);
    var isStatic = parentContext.static || props.static || false;
    var values = useMotionValues(props);
    var style = useMotionStyles(values, props.style, isStatic, props.transformValues);
    var shouldInheritVariant = checkShouldInheritVariant(props);
    var controlsConfig = useConstant(function () {
      return getValueControlsConfig(ref, values);
    });
    var controls = useValueAnimationControls(controlsConfig, props, shouldInheritVariant);
    var context = useMotionContext(parentContext, controls, values, isStatic, props);
    var functionality = isStatic ? null : loadFunctionalityComponents(ref, values, props, parentContext, controls, shouldInheritVariant);
    var renderedComponent = renderComponent(ref, style, values, props, isStatic);
    return createElement(Fragment$1, null, createElement(MotionContext.Provider, {
      value: context
    }, renderedComponent), createElement(Fragment$1, null, createElement(Mount, {
      innerRef: ref,
      values: values,
      isStatic: isStatic
    }), functionality));
  }

  return forwardRef$1(MotionComponent);
};
/**
 * @internal
 */


var htmlElements = ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "webview"];
/**
 * @internal
 */

var svgElements = ["animate", "circle", "clipPath", "defs", "desc", "ellipse", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "metadata", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "switch", "symbol", "text", "textPath", "tspan", "use", "view"];
/**
 * @internal
 */

var MotionPluginContext = createContext({
  transformPagePoint: function transformPagePoint(p) {
    return p;
  }
});

function useUnmountEffect(callback) {
  return useEffect(function () {
    return function () {
      return callback();
    };
  }, []);
}

function addDomEvent(target, eventName, handler, options) {
  if (!handler) return;
  target.addEventListener(eventName, handler, options);
  return function () {
    return target.removeEventListener(eventName, handler, options);
  };
}
/**
 * Attaches an event listener directly to the provided DOM element.
 *
 * Bypassing React's event system can be desirable, for instance when attaching non-passive
 * event handlers.
 *
 * ```jsx
 * const ref = useRef(null)
 *
 * useDomEvent(ref, 'wheel', onWheel, { passive: false })
 *
 * return <div ref={ref} />
 * ```
 *
 * @param ref - React.RefObject that's been provided to the element you want to bind the listener to.
 * @param eventName - Name of the event you want listen for.
 * @param handler - Function to fire when receiving the event.
 * @param options - Options to pass to `Event.addEventListener`.
 *
 * @public
 */


function useDomEvent(ref, eventName, handler, options) {
  useEffect(function () {
    var element = ref.current;

    if (handler && element) {
      return addDomEvent(element, eventName, handler, options);
    }
  }, [ref, eventName, handler, options]);
}

function isMouseEvent(event) {
  // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
  if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) {
    return !!(event.pointerType === "mouse");
  }

  return event instanceof MouseEvent;
}

function isTouchEvent(event) {
  var hasTouches = !!event.touches;
  return hasTouches;
}
/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */


function filterPrimaryPointer(eventHandler) {
  if (!eventHandler) return undefined;
  return function (event) {
    var isMouseEvent = event instanceof MouseEvent;
    var isPrimaryPointer = !isMouseEvent || isMouseEvent && event.button === 0;

    if (isPrimaryPointer) {
      eventHandler(event);
    }
  };
}

var defaultPagePoint = {
  pageX: 0,
  pageY: 0
};

function pointFromTouch(e) {
  var primaryTouch = e.touches[0] || e.changedTouches[0];

  var _a = primaryTouch || defaultPagePoint,
      pageX = _a.pageX,
      pageY = _a.pageY;

  return {
    x: pageX,
    y: pageY
  };
}

function pointFromMouse(_a) {
  var _b = _a.pageX,
      pageX = _b === void 0 ? 0 : _b,
      _c = _a.pageY,
      pageY = _c === void 0 ? 0 : _c;
  return {
    x: pageX,
    y: pageY
  };
}

function extractEventInfo(event) {
  return {
    point: isTouchEvent(event) ? pointFromTouch(event) : pointFromMouse(event)
  };
}

var wrapHandler = function wrapHandler(handler, shouldFilterPrimaryPointer) {
  if (shouldFilterPrimaryPointer === void 0) {
    shouldFilterPrimaryPointer = false;
  }

  if (!handler) return;

  var listener = function listener(event) {
    return handler(event, extractEventInfo(event));
  };

  return shouldFilterPrimaryPointer ? filterPrimaryPointer(listener) : listener;
};

var isBrowser = typeof window !== "undefined"; // We check for event support via functions in case they've been mocked by a testing suite.

var supportsPointerEvents = function supportsPointerEvents() {
  return isBrowser && window.onpointerdown === null;
};

var supportsTouchEvents = function supportsTouchEvents() {
  return isBrowser && window.ontouchstart === null;
};

var supportsMouseEvents = function supportsMouseEvents() {
  return isBrowser && window.onmousedown === null;
};

var mouseEventNames = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
};
var touchEventNames = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};

function getPointerEventName(name) {
  if (supportsPointerEvents()) {
    return name;
  } else if (supportsTouchEvents()) {
    return touchEventNames[name];
  } else if (supportsMouseEvents()) {
    return mouseEventNames[name];
  }

  return name;
}

function addPointerEvent(target, eventName, handler, options) {
  return addDomEvent(target, getPointerEventName(eventName), wrapHandler(handler, eventName === "pointerdown"), options);
}

function usePointerEvent(ref, eventName, handler, options) {
  return useDomEvent(ref, getPointerEventName(eventName), wrapHandler(handler, eventName === "pointerdown"), options);
}
/** @public */


var Point;

(function (Point) {
  /** @beta */
  Point.subtract = function (a, b) {
    return {
      x: a.x - b.x,
      y: a.y - b.y
    };
  };
  /** @beta */


  Point.relativeTo = function (idOrElem) {
    var elem;

    var getElem = function getElem() {
      // Caching element here could be leaky because of React lifecycle
      if (elem !== undefined) return elem;

      if (typeof idOrElem === "string") {
        elem = document.getElementById(idOrElem);
      } else {
        elem = idOrElem;
      }

      return elem;
    };

    return function (_a) {
      var x = _a.x,
          y = _a.y;
      var localElem = getElem();
      if (!localElem) return undefined;
      var rect = localElem.getBoundingClientRect();
      return {
        x: x - rect.left - window.scrollX,
        y: y - rect.top - window.scrollY
      };
    };
  };
})(Point || (Point = {}));

var isViewportScrollBlocked = false;
var isBrowser$1 = typeof window !== "undefined";

if (isBrowser$1) {
  document.addEventListener("touchmove", function (event) {
    if (isViewportScrollBlocked) {
      event.preventDefault();
    }
  }, {
    passive: false
  });
}

var blockViewportScroll = function blockViewportScroll() {
  return isViewportScrollBlocked = true;
};

var unblockViewportScroll = function unblockViewportScroll() {
  return isViewportScrollBlocked = false;
};
/**
 * @internal
 */


var PanSession = function () {
  function PanSession(event, handlers, _a) {
    var _this = this;

    var transformPagePoint = (_a === void 0 ? {} : _a).transformPagePoint;
    /**
     * @internal
     */

    this.startEvent = null;
    /**
     * @internal
     */

    this.lastMoveEvent = null;
    /**
     * @internal
     */

    this.lastMoveEventInfo = null;
    /**
     * @internal
     */

    this.handlers = {};

    this.updatePoint = function () {
      if (!(_this.lastMoveEvent && _this.lastMoveEventInfo)) return;
      var info = getPanInfo(_this.lastMoveEventInfo, _this.history);
      var isPanStarted = _this.startEvent !== null; // Only start panning if the offset is larger than 3 pixels. If we make it
      // any larger than this we'll want to reset the pointer history
      // on the first update to avoid visual snapping to the cursoe.

      var isDistancePastThreshold = distance(info.offset, {
        x: 0,
        y: 0
      }) >= 3;
      if (!isPanStarted && !isDistancePastThreshold) return;
      var point = info.point;
      var timestamp = getFrameData().timestamp;

      _this.history.push(_assign$2(_assign$2({}, point), {
        timestamp: timestamp
      }));

      var _a = _this.handlers,
          onStart = _a.onStart,
          onMove = _a.onMove;

      if (!isPanStarted) {
        onStart && onStart(_this.lastMoveEvent, info);
        _this.startEvent = _this.lastMoveEvent;
      }

      onMove && onMove(_this.lastMoveEvent, info);
    }; // If we have more than one touch, don't start detecting this gesture


    if (isTouchEvent(event) && event.touches.length > 1) return;
    this.handlers = handlers;
    this.transformPagePoint = transformPagePoint;
    var info = extractEventInfo(event);
    var initialInfo = transformPoint(info, this.transformPagePoint);
    var point = initialInfo.point;
    var timestamp = getFrameData().timestamp;
    this.history = [_assign$2(_assign$2({}, point), {
      timestamp: timestamp
    })];
    var onSessionStart = handlers.onSessionStart;
    onSessionStart && onSessionStart(event, getPanInfo(initialInfo, this.history));
    var removeOnPointerMove = addPointerEvent(window, "pointermove", function (event, info) {
      return _this.handlePointerMove(event, info);
    });
    var removeOnPointerUp = addPointerEvent(window, "pointerup", function (event, info) {
      return _this.handlePointerUp(event, info);
    });

    this.removeListeners = function () {
      removeOnPointerMove && removeOnPointerMove();
      removeOnPointerUp && removeOnPointerUp();
    };
  }

  PanSession.prototype.handlePointerMove = function (event, info) {
    this.lastMoveEvent = event;
    this.lastMoveEventInfo = transformPoint(info, this.transformPagePoint); // Because Safari doesn't trigger mouseup events when it's above a `<select>`

    if (isMouseEvent(event) && event.buttons === 0) {
      this.handlePointerUp(event, info);
      return;
    } // Throttle mouse move event to once per frame


    sync.update(this.updatePoint, true);
  };

  PanSession.prototype.handlePointerUp = function (event, info) {
    this.end();
    var onEnd = this.handlers.onEnd;
    if (!onEnd) return;
    var panInfo = getPanInfo(transformPoint(info, this.transformPagePoint), this.history);
    onEnd && onEnd(event, panInfo);
  };

  PanSession.prototype.updateHandlers = function (handlers) {
    this.handlers = handlers;
  };

  PanSession.prototype.end = function () {
    this.removeListeners && this.removeListeners();
    cancelSync.update(this.updatePoint);
    unblockViewportScroll();
  };

  return PanSession;
}();

function transformPoint(info, transformPagePoint) {
  return transformPagePoint ? {
    point: transformPagePoint(info.point)
  } : info;
}

function getPanInfo(_a, history) {
  var point = _a.point;
  return {
    point: point,
    delta: Point.subtract(point, lastDevicePoint(history)),
    offset: Point.subtract(point, startDevicePoint(history)),
    velocity: getVelocity$1(history, 0.1)
  };
}

function startDevicePoint(history) {
  return history[0];
}

function lastDevicePoint(history) {
  return history[history.length - 1];
}

function getVelocity$1(history, timeDelta) {
  if (history.length < 2) {
    return {
      x: 0,
      y: 0
    };
  }

  var i = history.length - 1;
  var timestampedPoint = null;
  var lastPoint = lastDevicePoint(history);

  while (i >= 0) {
    timestampedPoint = history[i];

    if (lastPoint.timestamp - timestampedPoint.timestamp > secondsToMilliseconds(timeDelta)) {
      break;
    }

    i--;
  }

  if (!timestampedPoint) {
    return {
      x: 0,
      y: 0
    };
  }

  var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;

  if (time === 0) {
    return {
      x: 0,
      y: 0
    };
  }

  var currentVelocity = {
    x: (lastPoint.x - timestampedPoint.x) / time,
    y: (lastPoint.y - timestampedPoint.y) / time
  };

  if (currentVelocity.x === Infinity) {
    currentVelocity.x = 0;
  }

  if (currentVelocity.y === Infinity) {
    currentVelocity.y = 0;
  }

  return currentVelocity;
}
/**
 *
 * @param handlers -
 * @param ref -
 *
 * @internalremarks
 * Currently this sets new pan gesture functions every render. The memo route has been explored
 * in the past but ultimately we're still creating new functions every render. An optimisation
 * to explore is creating the pan gestures and loading them into a `ref`.
 *
 * @internal
 */


function usePanGesture(_a, ref) {
  var onPan = _a.onPan,
      onPanStart = _a.onPanStart,
      onPanEnd = _a.onPanEnd,
      onPanSessionStart = _a.onPanSessionStart;
  var hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
  var panSession = useRef(null);
  var transformPagePoint = useContext(MotionPluginContext).transformPagePoint;
  var handlers = {
    onSessionStart: onPanSessionStart,
    onStart: onPanStart,
    onMove: onPan,
    onEnd: function onEnd(event, info) {
      panSession.current = null;
      onPanEnd && onPanEnd(event, info);
    }
  };

  if (panSession.current !== null) {
    panSession.current.updateHandlers(handlers);
  }

  function onPointerDown(event) {
    panSession.current = new PanSession(event, handlers, {
      transformPagePoint: transformPagePoint
    });
  }

  usePointerEvent(ref, "pointerdown", hasPanEvents && onPointerDown);
  useUnmountEffect(function () {
    return panSession.current && panSession.current.end();
  });
}
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */


var isNodeOrChild = function isNodeOrChild(parent, child) {
  if (!child) {
    return false;
  } else if (parent === child) {
    return true;
  } else {
    return isNodeOrChild(parent, child.parentElement);
  }
};

var order = ["whileHover", "whileTap", "whileDrag"];

var getGesturePriority = function getGesturePriority(gesture) {
  return order.indexOf(gesture) + 1;
};

function createLock(name) {
  var lock = null;
  return function () {
    var openLock = function openLock() {
      lock = null;
    };

    if (lock === null) {
      lock = name;
      return openLock;
    }

    return false;
  };
}

var globalHorizontalLock = createLock("dragHorizontal");
var globalVerticalLock = createLock("dragVertical");

function getGlobalLock(drag) {
  var lock = false;

  if (drag === "y") {
    lock = globalVerticalLock();
  } else if (drag === "x") {
    lock = globalHorizontalLock();
  } else {
    var openHorizontal_1 = globalHorizontalLock();
    var openVertical_1 = globalVerticalLock();

    if (openHorizontal_1 && openVertical_1) {
      lock = function lock() {
        openHorizontal_1();
        openVertical_1();
      };
    } else {
      // Release the locks because we don't use them
      if (openHorizontal_1) openHorizontal_1();
      if (openVertical_1) openVertical_1();
    }
  }

  return lock;
}

var tapGesturePriority = getGesturePriority("whileTap");
/**
 * @param handlers -
 * @internal
 */

function useTapGesture(_a, ref) {
  var onTap = _a.onTap,
      onTapStart = _a.onTapStart,
      onTapCancel = _a.onTapCancel,
      whileTap = _a.whileTap,
      controls = _a.controls;
  var hasTapListeners = onTap || onTapStart || onTapCancel || whileTap;
  var isTapping = useRef(false);
  var cancelPointerEventListener = useRef(null);

  function removePointerUp() {
    cancelPointerEventListener.current && cancelPointerEventListener.current();
    cancelPointerEventListener.current = null;
  }

  if (whileTap && controls) {
    controls.setOverride(whileTap, tapGesturePriority);
  } // We load this event handler into a ref so we can later refer to
  // onPointerUp.current which will always have reference to the latest props


  var onPointerUp = useRef(null);

  onPointerUp.current = function (event, info) {
    var element = ref.current;
    removePointerUp();
    if (!isTapping.current || !element) return;
    isTapping.current = false;

    if (controls && whileTap) {
      controls.clearOverride(tapGesturePriority);
    } // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.


    var openGestureLock = getGlobalLock(true);
    if (!openGestureLock) return;
    openGestureLock();

    if (!isNodeOrChild(element, event.target)) {
      onTapCancel && onTapCancel(event, info);
    } else {
      onTap && onTap(event, info);
    }
  };

  function onPointerDown(event, info) {
    removePointerUp();
    cancelPointerEventListener.current = addPointerEvent(window, "pointerup", function (event, info) {
      return onPointerUp.current(event, info);
    });
    var element = ref.current;
    if (!element || isTapping.current) return;
    isTapping.current = true;
    onTapStart && onTapStart(event, info);

    if (controls && whileTap) {
      controls.startOverride(tapGesturePriority);
    }
  }

  usePointerEvent(ref, "pointerdown", hasTapListeners ? onPointerDown : undefined);
  useUnmountEffect(removePointerUp);
}

var hoverPriority = getGesturePriority("whileHover");

var filterTouch = function filterTouch(listener) {
  return function (event, info) {
    if (isMouseEvent(event)) listener(event, info);
  };
};
/**
 *
 * @param props
 * @param ref
 * @internal
 */


function useHoverGesture(_a, ref) {
  var whileHover = _a.whileHover,
      onHoverStart = _a.onHoverStart,
      onHoverEnd = _a.onHoverEnd,
      controls = _a.controls;

  if (whileHover && controls) {
    controls.setOverride(whileHover, hoverPriority);
  }

  usePointerEvent(ref, "pointerenter", filterTouch(function (event, info) {
    if (onHoverStart) onHoverStart(event, info);

    if (whileHover && controls) {
      controls.startOverride(hoverPriority);
    }
  }));
  usePointerEvent(ref, "pointerleave", filterTouch(function (event, info) {
    if (onHoverEnd) onHoverEnd(event, info);

    if (whileHover && controls) {
      controls.clearOverride(hoverPriority);
    }
  }));
}
/**
 * Add pan and tap gesture recognition to an element.
 *
 * @param props - Gesture event handlers
 * @param ref - React `ref` containing a DOM `Element`
 * @public
 */


function useGestures(props, ref) {
  usePanGesture(props, ref);
  useTapGesture(props, ref);
  useHoverGesture(props, ref);
}

var makeRenderlessComponent = function makeRenderlessComponent(hook) {
  return function (props) {
    hook(props);
    return null;
  };
};

var gestureProps = ["onPan", "onPanStart", "onPanEnd", "onPanSessionStart", "onTap", "onTapStart", "onTapCancel", "whileTap", "whileHover", "onHoverStart", "onHoverEnd"];
var Gestures = {
  key: "gestures",
  shouldRender: function shouldRender(props) {
    return gestureProps.some(function (key) {
      return props.hasOwnProperty(key);
    });
  },
  Component: makeRenderlessComponent(function (_a) {
    var innerRef = _a.innerRef,
        props = __rest$4(_a, ["innerRef"]);

    useGestures(props, innerRef);
  })
};

var isRefObject = function isRefObject(ref) {
  return typeof ref === "object" && ref.hasOwnProperty("current");
};

var noop = function noop(v) {
  return v;
};

var ComponentDragControls = function () {
  function ComponentDragControls(_a) {
    var ref = _a.ref,
        values = _a.values,
        controls = _a.controls;
    /**
     * Track whether we're currently dragging.
     *
     * @internal
     */

    this.isDragging = false;
    /**
     * The current direction of drag, or `null` if both.
     *
     * @internal
     */

    this.currentDirection = null;
    /**
     * The permitted t/r/b/l boundaries of travel, in pixels.
     *
     * @internal
     */

    this.constraints = false;
    /**
     * A reference to the host component's latest props.
     *
     * @internal
     */

    this.props = {
      transformPagePoint: noop
    };
    /**
     * References to the MotionValues used for tracking the current dragged point.
     *
     * @internal
     */

    this.point = {};
    /**
     * The origin point for the current drag gesture.
     *
     * @internal
     */

    this.origin = {
      x: motionValue(0),
      y: motionValue(0)
    }; // This is a reference to the global drag gesture lock, ensuring only one component
    // can "capture" the drag of one or both axes.
    // TODO: Look into moving this into pansession?

    this.openGlobalLock = null;
    /**
     * @internal
     */

    this.panSession = null;
    /**
     * A reference to the previous constraints bounding box
     *
     * @internal
     */

    this.prevConstraintsBox = {
      width: 0,
      height: 0,
      x: 0,
      y: 0
    };
    this.ref = ref;
    this.values = values;
    this.controls = controls;
  }
  /**
   * Start dragging the host component.
   *
   * @param event - The originating pointer event.
   * @param options -
   *
   * @public
   */


  ComponentDragControls.prototype.start = function (originEvent, _a) {
    var _this = this;

    var _b = (_a === void 0 ? {} : _a).snapToCursor,
        snapToCursor = _b === void 0 ? false : _b;
    snapToCursor && this.snapToCursor(originEvent);

    var onSessionStart = function onSessionStart() {
      // Initiate viewport scroll blocking on touch start. This is a very aggressive approach
      // which has come out of the difficulty in us being able to do this once a scroll gesture
      // has initiated in mobile browsers. This means if there's a horizontally-scrolling carousel
      // on a page we can't let a user scroll the page itself from it. Ideally what we'd do is
      // trigger this once we've got a scroll direction determined. This approach sort-of worked
      // but if the component was dragged too far in a single frame page scrolling would initiate.
      blockViewportScroll(); // Stop any animations on both axis values immediately. This allows the user to throw and catch
      // the component.

      bothAxis(function (axis) {
        var axisPoint = _this.point[axis];
        axisPoint && axisPoint.stop();
      });
    };

    var onStart = function onStart(event, info) {
      // If constraints are an element, resolve them again in case they've updated.
      if (_this.constraintsNeedResolution) {
        var _a = _this.props,
            dragConstraints = _a.dragConstraints,
            transformPagePoint_1 = _a.transformPagePoint;
        _this.constraints = calculateConstraintsFromDom(dragConstraints, _this.ref, _this.point, transformPagePoint_1);

        _this.applyConstraintsToPoint();
      } // Set point origin and stop any existing animations.


      bothAxis(function (axis) {
        var axisPoint = _this.point[axis];
        if (!axisPoint) return;

        _this.origin[axis].set(axisPoint.get());
      }); // Attempt to grab the global drag gesture lock - maybe make this part of PanSession

      var _b = _this.props,
          drag = _b.drag,
          dragPropagation = _b.dragPropagation;

      if (drag && !dragPropagation) {
        if (_this.openGlobalLock) _this.openGlobalLock();
        _this.openGlobalLock = getGlobalLock(drag);
        if (!_this.openGlobalLock) return;
      }

      _this.isDragging = true;
      _this.currentDirection = null;
      var onDragStart = _this.props.onDragStart;
      onDragStart && onDragStart(event, convertPanToDrag(info, _this.point));
    };

    var onMove = function onMove(event, info) {
      var _a = _this.props,
          dragPropagation = _a.dragPropagation,
          dragDirectionLock = _a.dragDirectionLock; // If we didn't successfully receive the gesture lock, early return.

      if (!dragPropagation && !_this.openGlobalLock) return;
      var offset = info.offset; // Attempt to detect drag direction if directionLock is true

      if (dragDirectionLock && _this.currentDirection === null) {
        _this.currentDirection = getCurrentDirection(offset); // If we've successfully set a direction, notify listener

        if (_this.currentDirection !== null) {
          var onDirectionLock = _this.props.onDirectionLock;
          onDirectionLock && onDirectionLock(_this.currentDirection);
        }

        return;
      }

      _this.updatePoint("x", offset);

      _this.updatePoint("y", offset);

      var onDrag = _this.props.onDrag;
      onDrag && onDrag(event, convertPanToDrag(info, _this.point));
    };

    var onEnd = function onEnd(event, info) {
      _this.stop(event, info);
    };

    var transformPagePoint = this.props.transformPagePoint;
    this.panSession = new PanSession(originEvent, {
      onSessionStart: onSessionStart,
      onStart: onStart,
      onMove: onMove,
      onEnd: onEnd
    }, {
      transformPagePoint: transformPagePoint
    });
  };

  ComponentDragControls.prototype.cancelDrag = function () {
    unblockViewportScroll();
    this.isDragging = false;
    this.panSession && this.panSession.end();
    this.panSession = null;

    if (!this.props.dragPropagation && this.openGlobalLock) {
      this.openGlobalLock();
      this.openGlobalLock = null;
    }
  };

  ComponentDragControls.prototype.stop = function (event, info) {
    var _a;

    (_a = this.panSession) === null || _a === void 0 ? void 0 : _a.end();
    this.panSession = null;
    var isDragging = this.isDragging;
    this.cancelDrag();
    if (!isDragging) return;
    var _b = this.props,
        dragMomentum = _b.dragMomentum,
        dragElastic = _b.dragElastic,
        onDragEnd = _b.onDragEnd;

    if (dragMomentum || dragElastic) {
      var velocity = info.velocity;
      this.animateDragEnd(velocity);
    } else {
      this.recordBoxInfo(this.constraints);
    }

    onDragEnd && onDragEnd(event, convertPanToDrag(info, this.point));
  };

  ComponentDragControls.prototype.recordBoxInfo = function (constraints) {
    if (constraints) {
      var right = constraints.right,
          left = constraints.left,
          bottom = constraints.bottom,
          top_1 = constraints.top;
      this.prevConstraintsBox.width = (right || 0) - (left || 0);
      this.prevConstraintsBox.height = (bottom || 0) - (top_1 || 0);
    }

    if (this.point.x) this.prevConstraintsBox.x = this.point.x.get();
    if (this.point.y) this.prevConstraintsBox.y = this.point.y.get();
  };

  ComponentDragControls.prototype.snapToCursor = function (event) {
    var _this = this;

    var transformPagePoint = this.props.transformPagePoint;
    var point = extractEventInfo(event).point;
    var boundingBox = getBoundingBox(this.ref, transformPagePoint);
    var center = {
      x: boundingBox.width / 2 + boundingBox.left + window.scrollX,
      y: boundingBox.height / 2 + boundingBox.top + window.scrollY
    };
    var offset = {
      x: point.x - center.x,
      y: point.y - center.y
    };
    bothAxis(function (axis) {
      var point = _this.point[axis];
      if (!point) return;

      _this.origin[axis].set(point.get());
    });
    this.updatePoint("x", offset);
    this.updatePoint("y", offset);
  };

  ComponentDragControls.prototype.setPoint = function (axis, value) {
    this.point[axis] = value;
  };

  ComponentDragControls.prototype.updatePoint = function (axis, offset) {
    var _a = this.props,
        drag = _a.drag,
        dragElastic = _a.dragElastic;
    var axisPoint = this.point[axis]; // If we're not dragging this axis, do an early return.

    if (!shouldDrag(axis, drag, this.currentDirection) || !axisPoint) return;
    var current = applyConstraints(axis, this.origin[axis].get() + offset[axis], this.constraints, dragElastic);
    axisPoint.set(current);
  };

  ComponentDragControls.prototype.updateProps = function (_a) {
    var _this = this;

    var _b = _a.drag,
        drag = _b === void 0 ? false : _b,
        _c = _a.dragDirectionLock,
        dragDirectionLock = _c === void 0 ? false : _c,
        _d = _a.dragPropagation,
        dragPropagation = _d === void 0 ? false : _d,
        _e = _a.dragConstraints,
        dragConstraints = _e === void 0 ? false : _e,
        _f = _a.dragElastic,
        dragElastic = _f === void 0 ? true : _f,
        _g = _a.dragMomentum,
        dragMomentum = _g === void 0 ? true : _g,
        remainingProps = __rest$4(_a, ["drag", "dragDirectionLock", "dragPropagation", "dragConstraints", "dragElastic", "dragMomentum"]);

    this.props = _assign$2({
      drag: drag,
      dragDirectionLock: dragDirectionLock,
      dragPropagation: dragPropagation,
      dragConstraints: dragConstraints,
      dragElastic: dragElastic,
      dragMomentum: dragMomentum
    }, remainingProps);
    var _dragValueX = remainingProps._dragValueX,
        _dragValueY = remainingProps._dragValueY,
        dragOriginX = remainingProps.dragOriginX,
        dragOriginY = remainingProps.dragOriginY;
    if (dragOriginX) this.origin.x = dragOriginX;
    if (dragOriginY) this.origin.y = dragOriginY; // Get the `MotionValue` for both draggable axes, or create them if they don't already
    // exist on this component.

    bothAxis(function (axis) {
      if (!shouldDrag(axis, drag, _this.currentDirection)) return;
      var defaultValue = axis === "x" ? _dragValueX : _dragValueY;

      _this.setPoint(axis, defaultValue || _this.values.get(axis, 0));
    }); // If `dragConstraints` is a React `ref`, we should resolve the constraints once the
    // component has rendered.

    this.constraintsNeedResolution = isRefObject(dragConstraints);
    this.constraints = this.constraintsNeedResolution ? this.constraints || false : dragConstraints;
  };

  ComponentDragControls.prototype.applyConstraintsToPoint = function (constraints) {
    var _this = this;

    if (constraints === void 0) {
      constraints = this.constraints;
    }

    return bothAxis(function (axis) {
      var axisPoint = _this.point[axis];
      axisPoint && !axisPoint.isAnimating() && applyConstraints(axis, axisPoint, constraints, 0);
    });
  };

  ComponentDragControls.prototype.animateDragEnd = function (velocity) {
    var _this = this;

    var _a = this.props,
        drag = _a.drag,
        dragMomentum = _a.dragMomentum,
        dragElastic = _a.dragElastic,
        dragTransition = _a.dragTransition,
        _dragValueX = _a._dragValueX,
        _dragValueY = _a._dragValueY,
        _dragTransitionControls = _a._dragTransitionControls;
    var momentumAnimations = bothAxis(function (axis) {
      var _a;

      if (!shouldDrag(axis, drag, _this.currentDirection)) {
        return;
      }

      var transition = _this.constraints ? getConstraints(axis, _this.constraints) : {};
      /**
       * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
       * of spring animations so we should look into adding a disable spring option to `inertia`.
       * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
       * using the value of `dragElastic`.
       */

      var bounceStiffness = dragElastic ? 200 : 1000000;
      var bounceDamping = dragElastic ? 40 : 10000000;
      var animationControls = _dragTransitionControls || _this.controls;

      var inertia = _assign$2(_assign$2({
        type: "inertia",
        velocity: dragMomentum ? velocity[axis] : 0,
        bounceStiffness: bounceStiffness,
        bounceDamping: bounceDamping,
        timeConstant: 750,
        restDelta: 1
      }, dragTransition), transition);

      var externalAxisMotionValue = axis === "x" ? _dragValueX : _dragValueY; // If we're not animating on an externally-provided `MotionValue` we can use the
      // component's animation controls which will handle interactions with whileHover (etc),
      // otherwise we just have to animate the `MotionValue` itself.

      return externalAxisMotionValue ? startAnimation(axis, externalAxisMotionValue, 0, inertia) : animationControls.start((_a = {}, _a[axis] = 0, _a.transition = inertia, _a));
    }); // Run all animations and then resolve the new drag constraints.

    return Promise.all(momentumAnimations).then(function () {
      _this.recordBoxInfo(_this.constraints);

      _this.scalePoint();

      var onDragTransitionEnd = _this.props.onDragTransitionEnd;
      onDragTransitionEnd && onDragTransitionEnd();
    });
  };

  ComponentDragControls.prototype.scalePoint = function () {
    var _this = this;

    var _a = this.props,
        dragConstraints = _a.dragConstraints,
        transformPagePoint = _a.transformPagePoint;
    if (!isRefObject(dragConstraints)) return;
    var constraintsBox = getBoundingBox(dragConstraints, transformPagePoint);
    var draggableBox = getBoundingBox(this.ref, transformPagePoint); // Scale a point relative to the transformation of a constraints-providing element.

    var scaleAxisPoint = function scaleAxisPoint(axis, dimension) {
      var pointToScale = _this.point[axis];
      if (!pointToScale) return; // Stop any current animations as they bug out if you resize during one

      if (pointToScale.isAnimating()) {
        pointToScale.stop();

        _this.recordBoxInfo();

        return;
      } // If the previous dimension was `0` (default), set `scale` to `1` to prevent
      // divide by zero errors.


      var scale = _this.prevConstraintsBox[dimension] ? (constraintsBox[dimension] - draggableBox[dimension]) / _this.prevConstraintsBox[dimension] : 1;
      pointToScale.set(_this.prevConstraintsBox[axis] * scale);
    };

    scaleAxisPoint("x", "width");
    scaleAxisPoint("y", "height");
  };

  ComponentDragControls.prototype.mount = function (element) {
    var _this = this;

    var stopPointerListener = addPointerEvent(element, "pointerdown", function (event) {
      var _a = _this.props,
          drag = _a.drag,
          _b = _a.dragListener,
          dragListener = _b === void 0 ? true : _b;
      drag && dragListener && _this.start(event);
    });
    var stopResizeListener = addDomEvent(window, "resize", function () {
      return _this.scalePoint();
    });

    if (this.constraintsNeedResolution) {
      var _a = this.props,
          dragConstraints = _a.dragConstraints,
          transformPagePoint = _a.transformPagePoint;
      var constraints = calculateConstraintsFromDom(dragConstraints, this.ref, this.point, transformPagePoint);
      this.applyConstraintsToPoint(constraints);
      this.recordBoxInfo(constraints);
    } else if (!this.isDragging && this.constraints) {
      this.applyConstraintsToPoint();
    }

    return function () {
      stopPointerListener && stopPointerListener();
      stopResizeListener && stopResizeListener();

      _this.cancelDrag();
    };
  };

  return ComponentDragControls;
}(); // Call a handler once for each axis


function bothAxis(handler) {
  return [handler("x"), handler("y")];
}

function convertPanToDrag(info, point) {
  return _assign$2(_assign$2({}, info), {
    point: {
      x: point.x ? point.x.get() : 0,
      y: point.y ? point.y.get() : 0
    }
  });
}

function getConstraints(axis, _a) {
  var top = _a.top,
      right = _a.right,
      bottom = _a.bottom,
      left = _a.left;

  if (axis === "x") {
    return {
      min: left,
      max: right
    };
  } else {
    return {
      min: top,
      max: bottom
    };
  }
}

function shouldDrag(direction, drag, currentDirection) {
  return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */


function getCurrentDirection(offset, lockThreshold) {
  if (lockThreshold === void 0) {
    lockThreshold = 10;
  }

  var direction = null;

  if (Math.abs(offset.y) > lockThreshold) {
    direction = "y";
  } else if (Math.abs(offset.x) > lockThreshold) {
    direction = "x";
  }

  return direction;
}
/**
 * Takes a parent Element and a draggable Element and returns pixel-based drag constraints.
 *
 * @param constraintsRef
 * @param draggableRef
 */


function calculateConstraintsFromDom(constraintsRef, draggableRef, point, transformPagePoint) {
  invariant$1(constraintsRef.current !== null && draggableRef.current !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
  var parentBoundingBox = getBoundingBox(constraintsRef, transformPagePoint);
  var draggableBoundingBox = getBoundingBox(draggableRef, transformPagePoint);
  var left = parentBoundingBox.left - draggableBoundingBox.left + getCurrentOffset(point.x);
  var top = parentBoundingBox.top - draggableBoundingBox.top + getCurrentOffset(point.y);
  var right = parentBoundingBox.width - draggableBoundingBox.width + left;
  var bottom = parentBoundingBox.height - draggableBoundingBox.height + top;
  return {
    top: top,
    left: left,
    right: right,
    bottom: bottom
  };
}

function getBoundingBox(ref, transformPagePoint) {
  var rect = ref.current.getBoundingClientRect();

  var _a = transformPagePoint({
    x: rect.left,
    y: rect.top
  }),
      left = _a.x,
      top = _a.y;

  var _b = transformPagePoint({
    x: rect.width,
    y: rect.height
  }),
      width = _b.x,
      height = _b.y;

  return {
    left: left,
    top: top,
    width: width,
    height: height
  };
}

function getCurrentOffset(point) {
  return point ? point.get() : 0;
}

function applyConstraints(axis, value, constraints, dragElastic) {
  var constrainedValue = value instanceof MotionValue ? value.get() : value;

  if (!constraints) {
    return constrainedValue;
  }

  var _a = getConstraints(axis, constraints),
      min = _a.min,
      max = _a.max;

  if (min !== undefined && constrainedValue < min) {
    constrainedValue = dragElastic ? applyOverdrag(min, constrainedValue, dragElastic) : Math.max(min, constrainedValue);
  } else if (max !== undefined && constrainedValue > max) {
    constrainedValue = dragElastic ? applyOverdrag(max, constrainedValue, dragElastic) : Math.min(max, constrainedValue);
  }

  if (value instanceof MotionValue) {
    value.set(constrainedValue);
  }

  return constrainedValue;
}

function applyOverdrag(origin, current, dragElastic) {
  var dragFactor = typeof dragElastic === "number" ? dragElastic : 0.35;
  return mix(origin, current, dragFactor);
}
/**
 * A hook that allows an element to be dragged.
 *
 * @param param
 * @param ref
 * @param values
 * @param controls
 *
 * @internal
 */


function useDrag(props, ref, values, controls) {
  var groupDragControls = props.dragControls;
  var transformPagePoint = useContext(MotionPluginContext).transformPagePoint;
  var dragControls = useConstant(function () {
    return new ComponentDragControls({
      ref: ref,
      values: values,
      controls: controls
    });
  });
  dragControls.updateProps(_assign$2(_assign$2({}, props), {
    transformPagePoint: transformPagePoint
  }));
  useEffect(function () {
    return groupDragControls && groupDragControls.subscribe(dragControls);
  }, [dragControls]);
  useEffect(function () {
    return dragControls.mount(ref.current);
  }, []);
}

var Drag = {
  key: "drag",
  shouldRender: function shouldRender(props) {
    return !!props.drag;
  },
  Component: makeRenderlessComponent(function (_a) {
    var innerRef = _a.innerRef,
        values = _a.values,
        controls = _a.controls,
        props = __rest$4(_a, ["innerRef", "values", "controls"]);

    return useDrag(props, innerRef, values, controls);
  })
};

function isCSSVariable(value) {
  return typeof value === "string" && value.startsWith("var(--");
}
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */


var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;

function parseCSSVariable(current) {
  var match = cssVariableRegex.exec(current);
  if (!match) return [,];
  var token = match[1],
      fallback = match[2];
  return [token, fallback];
}

var maxDepth = 4;

function getVariableValue(current, element, depth) {
  if (depth === void 0) {
    depth = 1;
  }

  invariant$1(depth <= maxDepth, "Max CSS variable fallback depth detected in property \"" + current + "\". This may indicate a circular fallback dependency.");

  var _a = parseCSSVariable(current),
      token = _a[0],
      fallback = _a[1]; // No CSS variable detected


  if (!token) return; // Attempt to read this CSS variable off the element

  var resolved = window.getComputedStyle(element).getPropertyValue(token);

  if (resolved) {
    return resolved;
  } else if (isCSSVariable(fallback)) {
    // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return getVariableValue(fallback, element, depth + 1);
  } else {
    return fallback;
  }
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */


function resolveCSSVariables(values, ref, _a, transitionEnd) {
  var target = __rest$4(_a, []);

  var element = ref.current;
  if (!(element instanceof HTMLElement)) return {
    target: target,
    transitionEnd: transitionEnd
  }; // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
  // only if they change but I think this reads clearer and this isn't a performance-critical path.

  if (transitionEnd) {
    transitionEnd = _assign$2({}, transitionEnd);
  } // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved


  values.forEach(function (value) {
    var current = value.get();
    if (!isCSSVariable(current)) return;
    var resolved = getVariableValue(current, element);
    if (resolved) value.set(resolved);
  }); // Cycle through every target property and resolve CSS variables. Currently
  // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`

  for (var key in target) {
    var current = target[key];
    if (!isCSSVariable(current)) continue;
    var resolved = getVariableValue(current, element);
    if (!resolved) continue; // Clone target if it hasn't already been

    target[key] = resolved; // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
    // CSS variable. This will ensure that after the animation the component will reflect
    // changes in the value of the CSS variable.

    if (transitionEnd && transitionEnd[key] === undefined) {
      transitionEnd[key] = current;
    }
  }

  return {
    target: target,
    transitionEnd: transitionEnd
  };
}

var positionalKeys = new Set(["width", "height", "top", "left", "right", "bottom", "x", "y"]);

var isPositionalKey = function isPositionalKey(key) {
  return positionalKeys.has(key);
};

var hasPositionalKey = function hasPositionalKey(target) {
  return Object.keys(target).some(isPositionalKey);
};

var setAndResetVelocity = function setAndResetVelocity(value, to) {
  // Looks odd but setting it twice doesn't render, it'll just
  // set both prev and current to the latest value
  value.set(to, false);
  value.set(to);
};

var isNumOrPxType = function isNumOrPxType(v) {
  return v === number$1 || v === px;
};

var BoundingBoxDimension;

(function (BoundingBoxDimension) {
  BoundingBoxDimension["width"] = "width";
  BoundingBoxDimension["height"] = "height";
  BoundingBoxDimension["left"] = "left";
  BoundingBoxDimension["right"] = "right";
  BoundingBoxDimension["top"] = "top";
  BoundingBoxDimension["bottom"] = "bottom";
})(BoundingBoxDimension || (BoundingBoxDimension = {}));

var getPosFromMatrix = function getPosFromMatrix(matrix, pos) {
  return parseFloat(matrix.split(", ")[pos]);
};

var getTranslateFromMatrix = function getTranslateFromMatrix(pos2, pos3) {
  return function (_bbox, _a) {
    var transform = _a.transform;
    if (transform === "none" || !transform) return 0;
    var matrix3d = transform.match(/^matrix3d\((.+)\)$/);

    if (matrix3d) {
      return getPosFromMatrix(matrix3d[1], pos3);
    } else {
      var matrix = transform.match(/^matrix\((.+)\)$/);

      if (matrix) {
        return getPosFromMatrix(matrix[1], pos2);
      } else {
        return 0;
      }
    }
  };
};

var transformKeys = new Set(["x", "y", "z"]);
var nonTranslationalTransformKeys = transformProps.filter(function (key) {
  return !transformKeys.has(key);
});

function removeNonTranslationalTransform(values, elementStyler) {
  var removedTransforms = [];
  nonTranslationalTransformKeys.forEach(function (key) {
    var value = values.get(key);

    if (value !== undefined) {
      removedTransforms.push([key, value.get()]);
      value.set(key.startsWith("scale") ? 1 : 0);
    }
  }); // Apply changes to element before measurement

  if (removedTransforms.length) elementStyler.render();
  return removedTransforms;
}

var positionalValues = {
  // Dimensions
  width: function width(_a) {
    var width = _a.width;
    return width;
  },
  height: function height(_a) {
    var height = _a.height;
    return height;
  },
  top: function top(_bbox, _a) {
    var top = _a.top;
    return parseFloat(top);
  },
  left: function left(_bbox, _a) {
    var left = _a.left;
    return parseFloat(left);
  },
  bottom: function bottom(_a, _b) {
    var height = _a.height;
    var top = _b.top;
    return parseFloat(top) + height;
  },
  right: function right(_a, _b) {
    var width = _a.width;
    var left = _b.left;
    return parseFloat(left) + width;
  },
  // Transform
  x: getTranslateFromMatrix(4, 13),
  y: getTranslateFromMatrix(5, 14)
};

var convertChangedValueTypes = function convertChangedValueTypes(target, values, element, elementStyler, changedKeys) {
  var originBbox = element.getBoundingClientRect();
  var elementComputedStyle = getComputedStyle(element);
  var display = elementComputedStyle.display,
      top = elementComputedStyle.top,
      left = elementComputedStyle.left,
      bottom = elementComputedStyle.bottom,
      right = elementComputedStyle.right,
      transform = elementComputedStyle.transform;
  var originComputedStyle = {
    top: top,
    left: left,
    bottom: bottom,
    right: right,
    transform: transform
  }; // If the element is currently set to display: "none", make it visible before
  // measuring the target bounding box

  if (display === "none") {
    elementStyler.set("display", target.display || "block");
  } // Apply the latest values (as set in checkAndConvertChangedValueTypes)


  elementStyler.render();
  var targetBbox = element.getBoundingClientRect();
  changedKeys.forEach(function (key) {
    // Restore styles to their **calculated computed style**, not their actual
    // originally set style. This allows us to animate between equivalent pixel units.
    var value = values.get(key);
    setAndResetVelocity(value, positionalValues[key](originBbox, originComputedStyle));
    target[key] = positionalValues[key](targetBbox, elementComputedStyle);
  });
  return target;
};

var checkAndConvertChangedValueTypes = function checkAndConvertChangedValueTypes(values, ref, target, transitionEnd) {
  if (transitionEnd === void 0) {
    transitionEnd = {};
  }

  target = _assign$2({}, target);
  transitionEnd = _assign$2({}, transitionEnd);
  var element = ref.current;
  var elementStyler = index$1(element);
  var targetPositionalKeys = Object.keys(target).filter(isPositionalKey); // We want to remove any transform values that could affect the element's bounding box before
  // it's measured. We'll reapply these later.

  var removedTransformValues = [];
  var hasAttemptedToRemoveTransformValues = false;
  var changedValueTypeKeys = targetPositionalKeys.reduce(function (acc, key) {
    var value = values.get(key);
    if (!value) return acc;
    var from = value.get();
    var to = target[key];
    var fromType = getDimensionValueType(from);
    var toType; // TODO: The current implementation of this basically throws an error
    // if you try and do value conversion via keyframes. There's probably
    // a way of doing this but the performance implications would need greater scrutiny,
    // as it'd be doing multiple resize-remeasure operations.

    if (isKeyframesTarget(to)) {
      var numKeyframes = to.length;

      for (var i = to[0] === null ? 1 : 0; i < numKeyframes; i++) {
        if (!toType) {
          toType = getDimensionValueType(to[i]);
          invariant$1(toType === fromType || isNumOrPxType(fromType) && isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
        } else {
          invariant$1(getDimensionValueType(to[i]) === toType, "All keyframes must be of the same type");
        }
      }
    } else {
      toType = getDimensionValueType(to);
    }

    if (fromType !== toType) {
      // If they're both just number or px, convert them both to numbers rather than
      // relying on resize/remeasure to convert (which is wasteful in this situation)
      if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
        var current = value.get();

        if (typeof current === "string") {
          value.set(parseFloat(current));
        }

        if (typeof to === "string") {
          target[key] = parseFloat(to);
        } else if (Array.isArray(to) && toType === px) {
          target[key] = to.map(parseFloat);
        }
      } else {
        // If we're going to do value conversion via DOM measurements, we first
        // need to remove non-positional transform values that could affect the bbox measurements.
        if (!hasAttemptedToRemoveTransformValues) {
          removedTransformValues = removeNonTranslationalTransform(values, elementStyler);
          hasAttemptedToRemoveTransformValues = true;
        }

        acc.push(key);
        transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
        setAndResetVelocity(value, to);
      }
    }

    return acc;
  }, []);

  if (changedValueTypeKeys.length) {
    var convertedTarget = convertChangedValueTypes(target, values, element, elementStyler, changedValueTypeKeys); // If we removed transform values, reapply them before the next render

    if (removedTransformValues.length) {
      removedTransformValues.forEach(function (_a) {
        var key = _a[0],
            value = _a[1];
        values.get(key).set(value);
      });
    } // Reapply original values


    elementStyler.render();
    return {
      target: convertedTarget,
      transitionEnd: transitionEnd
    };
  } else {
    return {
      target: target,
      transitionEnd: transitionEnd
    };
  }
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @param values
 * @param ref
 * @param target
 * @param transitionEnd
 * @internal
 */


function unitConversion(values, ref, target, transitionEnd) {
  return hasPositionalKey(target) ? checkAndConvertChangedValueTypes(values, ref, target, transitionEnd) : {
    target: target,
    transitionEnd: transitionEnd
  };
}

var parseDomVariant = function parseDomVariant(values, ref) {
  return function (target, transitionEnd) {
    var resolved = resolveCSSVariables(values, ref, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return unitConversion(values, ref, target, transitionEnd);
  };
};

function useForceUpdate() {
  var _a = useState(0),
      forcedRenderCount = _a[0],
      setForcedRenderCount = _a[1];

  return useCallback(function () {
    return setForcedRenderCount(forcedRenderCount + 1);
  }, [forcedRenderCount]);
}

var SyncLayoutContext = createContext(null);

var _a$3;

var StepName;

(function (StepName) {
  StepName["Prepare"] = "prepare";
  StepName["Read"] = "read";
  StepName["Render"] = "render";
})(StepName || (StepName = {}));

var stepOrder = [StepName.Prepare, StepName.Read, StepName.Render];
var jobs = stepOrder.reduce(function (acc, key) {
  acc[key] = [];
  return acc;
}, {});
var jobsNeedProcessing = false;

function flushCallbackList(list) {
  var numJobs = list.length;

  for (var i = 0; i < numJobs; i++) {
    list[i]();
  }

  list.length = 0;
}

function flushAllJobs() {
  if (!jobsNeedProcessing) return;
  flushCallbackList(jobs.prepare);
  flushCallbackList(jobs.read);
  flushCallbackList(jobs.render);
  jobsNeedProcessing = false;
} // Note: The approach of schedulng jobs during the render step is incompatible with concurrent mode
// where multiple renders might happen without a DOM update. This would result in unneccessary batched
// jobs. But this was already a problem with our previous approach to positionTransition.
// Hopefully the React team offer a getSnapshotBeforeUpdate-esque hook and we can move to that.


var createUseSyncEffect = function createUseSyncEffect(stepName) {
  return function (callback) {
    if (!callback) return;
    jobsNeedProcessing = true;
    jobs[stepName].push(callback);
  };
};

var layoutSync = (_a$3 = {}, _a$3[StepName.Prepare] = createUseSyncEffect(StepName.Prepare), _a$3[StepName.Read] = createUseSyncEffect(StepName.Read), _a$3[StepName.Render] = createUseSyncEffect(StepName.Render), _a$3.flush = flushAllJobs, _a$3);

function isHTMLElement$1(element) {
  return element instanceof HTMLElement;
}

var defaultLayoutTransition = {
  duration: 0.8,
  ease: [0.45, 0.05, 0.19, 1.0]
};
var defaultPositionTransition = underDampedSpring();

function getDefaultLayoutTransition(isPositionOnly) {
  return isPositionOnly ? defaultPositionTransition : defaultLayoutTransition;
}

function isResolver(transition) {
  return typeof transition === "function";
}

var axisLabels = {
  x: {
    id: "x",
    size: "width",
    min: "left",
    max: "right",
    origin: "originX"
  },
  y: {
    id: "y",
    size: "height",
    min: "top",
    max: "bottom",
    origin: "originY"
  }
};

function centerOf(min, max) {
  return (min + max) / 2;
}

function calcAxisDelta(prev, next, names) {
  var _a;

  var sizeDelta = prev[names.size] - next[names.size];
  var origin = 0.5; // If the element has changed size we want to check whether either side is in
  // the same position before/after the layout transition. If so, we can anchor
  // the element to that position and only animate its size.

  if (sizeDelta) {
    if (prev[names.min] === next[names.min]) {
      origin = 0;
    } else if (prev[names.max] === next[names.max]) {
      origin = 1;
    }
  }

  var delta = (_a = {}, _a[names.size] = sizeDelta, _a[names.origin] = origin, _a[names.id] = // Only measure a position delta if we haven't anchored to one side
  origin === 0.5 ? centerOf(prev[names.min], prev[names.max]) - centerOf(next[names.min], next[names.max]) : 0, _a);
  return delta;
}

function calcDelta(prev, next) {
  var delta = _assign$2(_assign$2({}, calcAxisDelta(prev, next, axisLabels.x)), calcAxisDelta(prev, next, axisLabels.y));

  return delta;
}

var offset = {
  getLayout: function getLayout(_a) {
    var offset = _a.offset;
    return offset;
  },
  measure: function measure(element) {
    var offsetLeft = element.offsetLeft,
        offsetTop = element.offsetTop,
        offsetWidth = element.offsetWidth,
        offsetHeight = element.offsetHeight;
    return {
      left: offsetLeft,
      top: offsetTop,
      right: offsetLeft + offsetWidth,
      bottom: offsetTop + offsetHeight,
      width: offsetWidth,
      height: offsetHeight
    };
  }
};
var boundingBox = {
  getLayout: function getLayout(_a) {
    var boundingBox = _a.boundingBox;
    return boundingBox;
  },
  measure: function measure(element) {
    var _a = element.getBoundingClientRect(),
        left = _a.left,
        top = _a.top,
        width = _a.width,
        height = _a.height,
        right = _a.right,
        bottom = _a.bottom;

    return {
      left: left,
      top: top,
      width: width,
      height: height,
      right: right,
      bottom: bottom
    };
  }
};

function readPositionStyle(element) {
  return window.getComputedStyle(element).position;
}

function getLayoutType(prev, next, isPositionOnly) {
  return isPositionOnly && prev === next ? offset : boundingBox;
}

function isSizeKey(key) {
  return key === "width" || key === "height";
}

function getTransition(_a) {
  var layoutTransition = _a.layoutTransition,
      positionTransition = _a.positionTransition;
  return layoutTransition || positionTransition;
}

var LayoutAnimation = function (_super) {
  __extends$2(LayoutAnimation, _super);

  function LayoutAnimation() {
    return _super !== null && _super.apply(this, arguments) || this;
  } // Measure the current state of the DOM before it's updated, and schedule checks to see
  // if it's changed as a result of a React render.


  LayoutAnimation.prototype.getSnapshotBeforeUpdate = function () {
    var _a = this.props,
        innerRef = _a.innerRef,
        positionTransition = _a.positionTransition,
        values = _a.values,
        controls = _a.controls;
    var element = innerRef.current;
    if (!isHTMLElement$1(element)) return;
    var layoutTransition = getTransition(this.props);
    var isPositionOnly = !!positionTransition;
    var positionStyle = readPositionStyle(element);
    var prev = {
      offset: offset.measure(element),
      boundingBox: boundingBox.measure(element)
    };
    var transform;
    var next;
    var compare; // We split the unsetting, read and reapplication of the `transform` style prop into
    // different steps via useSyncEffect. Multiple components might all be doing the same
    // thing and by splitting these jobs and flushing them in batches we prevent layout thrashing.

    layoutSync.prepare(function () {
      // Unset the transform of all layoutTransition components so we can accurately measure
      // the target bounding box
      transform = element.style.transform;
      element.style.transform = "";
    });
    layoutSync.read(function () {
      // Read the target VisualInfo of all layoutTransition components
      next = {
        offset: offset.measure(element),
        boundingBox: boundingBox.measure(element)
      };
      var nextPosition = readPositionStyle(element);
      compare = getLayoutType(positionStyle, nextPosition, isPositionOnly);
    });
    layoutSync.render(function () {
      // Reverse the layout delta of all newly laid-out layoutTransition components into their
      // prev visual state and then animate them into their new one using transforms.
      var prevLayout = compare.getLayout(prev);
      var nextLayout = compare.getLayout(next);
      var delta = calcDelta(prevLayout, nextLayout);
      var hasAnyChanged = delta.x || delta.y || delta.width || delta.height;

      if (!hasAnyChanged) {
        // If layout hasn't changed, reapply the transform and get out of here.
        transform && (element.style.transform = transform);
        return;
      }

      index$1(element).set({
        originX: delta.originX,
        originY: delta.originY
      });
      syncRenderSession.open();
      var target = {};
      var transition = {};
      var transitionDefinition = isResolver(layoutTransition) ? layoutTransition({
        delta: delta
      }) : layoutTransition;

      function makeTransition(layoutKey, transformKey, targetValue, visualOrigin) {
        // If this dimension hasn't changed, early return
        var deltaKey = isSizeKey(layoutKey) ? layoutKey : transformKey;
        if (!delta[deltaKey]) return;
        var baseTransition = typeof transitionDefinition === "boolean" ? _assign$2({}, getDefaultLayoutTransition(isPositionOnly)) : transitionDefinition;
        var value = values.get(transformKey, targetValue);
        var velocity = value.getVelocity();
        transition[transformKey] = baseTransition[transformKey] ? _assign$2({}, baseTransition[transformKey]) : _assign$2({}, baseTransition);

        if (transition[transformKey].velocity === undefined) {
          transition[transformKey].velocity = velocity || 0;
        } // The target value of all transforms is the default value of that prop (ie x = 0, scaleX = 1)
        // This is because we're inverting the layout change with `transform` and then animating to `transform: none`


        target[transformKey] = targetValue;
        var offsetToApply = !isSizeKey(layoutKey) && compare === offset ? value.get() : 0;
        value.set(visualOrigin + offsetToApply);
      }

      makeTransition("left", "x", 0, delta.x);
      makeTransition("top", "y", 0, delta.y);

      if (!isPositionOnly) {
        makeTransition("width", "scaleX", 1, prev.boundingBox.width / next.boundingBox.width);
        makeTransition("height", "scaleY", 1, prev.boundingBox.height / next.boundingBox.height);
      }

      target.transition = transition; // Only start the transition if `transitionDefinition` isn't `false`. Otherwise we want
      // to leave the values in their newly-inverted state and let the user cope with the rest.

      transitionDefinition && controls.start(target); // Force a render to ensure there's no visual flickering

      syncRenderSession.flush();
    });
    return null;
  };

  LayoutAnimation.prototype.componentDidUpdate = function () {
    layoutSync.flush();
  };

  LayoutAnimation.prototype.render = function () {
    return null;
  };

  LayoutAnimation.contextType = SyncLayoutContext;
  return LayoutAnimation;
}(Component);

var Layout = {
  key: "layout",
  shouldRender: function shouldRender(_a) {
    var positionTransition = _a.positionTransition,
        layoutTransition = _a.layoutTransition;
    invariant$1(!(positionTransition && layoutTransition), "Don't set both positionTransition and layoutTransition on the same component");
    return typeof window !== "undefined" && !!(positionTransition || layoutTransition);
  },
  Component: LayoutAnimation
};
/**
 * A list of all valid MotionProps
 *
 * @internalremarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */

var validMotionProps = new Set(["initial", "animate", "exit", "style", "variants", "transition", "transformTemplate", "transformValues", "custom", "inherit", "static", "positionTransition", "layoutTransition", "onAnimationStart", "onAnimationComplete", "onUpdate", "onDragStart", "onDrag", "onDragEnd", "onDirectionLock", "onDragTransitionEnd", "drag", "dragControls", "dragListener", "dragConstraints", "dragDirectionLock", "dragElastic", "dragMomentum", "dragPropagation", "dragTransition", "_dragValueX", "_dragValueY", "_dragTransitionControls", "dragOriginX", "dragOriginY", "onPan", "onPanStart", "onPanEnd", "onPanSessionStart", "onTap", "onTapStart", "onTapCancel", "whileHover", "whileTap", "onHoverEnd", "onHoverStart"]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */

function isValidMotionProp(key) {
  return validMotionProps.has(key);
}

var AnimatePropType;

(function (AnimatePropType) {
  AnimatePropType["Target"] = "Target";
  AnimatePropType["VariantLabel"] = "VariantLabel";
  AnimatePropType["AnimationSubscription"] = "AnimationSubscription";
})(AnimatePropType || (AnimatePropType = {}));

function shallowCompare(next, prev) {
  if (prev === null) return false;
  var prevLength = prev.length;
  if (prevLength !== next.length) return false;

  for (var i = 0; i < prevLength; i++) {
    if (prev[i] !== next[i]) return false;
  }

  return true;
}

var hasUpdated = function hasUpdated(prev, next) {
  return next !== undefined && (Array.isArray(prev) && Array.isArray(next) ? !shallowCompare(next, prev) : prev !== next);
};

function targetWithoutTransition(_a, mergeTransitionEnd) {
  if (mergeTransitionEnd === void 0) {
    mergeTransitionEnd = false;
  }

  _a.transition;

  var transitionEnd = _a.transitionEnd,
      target = __rest$4(_a, ["transition", "transitionEnd"]);

  return mergeTransitionEnd ? _assign$2(_assign$2({}, target), transitionEnd) : target;
}
/**
 * Handle the `animate` prop when its an object of values, ie:
 *
 * ```jsx
 * <motion.div animate={{ opacity: 1 }} />
 * ```
 *
 * @internalremarks
 * It might be worth consolidating this with `use-variants`
 *
 * ```jsx
 * <motion.div animate="visible" />
 * ```
 *
 * @param target
 * @param controls
 * @param values
 * @param transition
 *
 * @internal
 */


function useAnimateProp(targetAndTransition, controls, values, defaultTransition) {
  var isInitialRender = useRef(true);
  var prevValues = useRef(null);

  if (!prevValues.current) {
    prevValues.current = targetWithoutTransition(targetAndTransition, true);
  }

  useEffect(function () {
    var targetToAnimate = {}; // These are the values we're actually animating

    var animatingTarget = targetWithoutTransition(targetAndTransition); // This is the target as it'll be once transitionEnd values are applied

    var finalTarget = targetWithoutTransition(targetAndTransition, true); // Detect which values have changed between renders

    for (var key in animatingTarget) {
      // This value should animate on mount if this value doesn't already exist (wasn't
      // defined in `style` or `initial`) or if it does exist and it's already changed.
      var shouldAnimateOnMount = isInitialRender.current && (!values.has(key) || values.get(key).get() !== finalTarget[key]); // If this value has updated between renders or it's we're animating this value on mount,
      // add it to the animate target.

      var isValidValue = finalTarget[key] !== null;
      var valueHasUpdated = hasUpdated(prevValues.current[key], finalTarget[key]);

      if (isValidValue && (valueHasUpdated || shouldAnimateOnMount)) {
        targetToAnimate[key] = animatingTarget[key];
      }
    }

    isInitialRender.current = false;
    prevValues.current = _assign$2(_assign$2({}, prevValues.current), finalTarget);

    if (Object.keys(targetToAnimate).length) {
      controls.start(_assign$2(_assign$2({}, targetToAnimate), {
        transition: targetAndTransition.transition || defaultTransition,
        transitionEnd: targetAndTransition.transitionEnd
      }));
    }
  }, [targetAndTransition]);
}

var labelsToArray = function labelsToArray(label) {
  if (!label) {
    return [];
  }

  if (Array.isArray(label)) {
    return label;
  }

  return [label];
};

var resolveVariantLabels = function resolveVariantLabels(variant) {
  var unresolvedVariant = variant instanceof MotionValue ? variant.get() : variant;
  return Array.from(new Set(labelsToArray(unresolvedVariant)));
};
/**
 * Hooks in React sometimes accept a dependency array as their final argument. (ie useEffect/useMemo)
 * When values in this array change, React re-runs the dependency. However if the array
 * contains a variable number of items, React throws an error.
 */


var asDependencyList = function asDependencyList(list) {
  return [list.join(",")];
};

var hasVariantChanged = function hasVariantChanged(oldVariant, newVariant) {
  return oldVariant.join(",") !== newVariant.join(",");
};
/**
 * Handle variants and the `animate` prop when its set as variant labels.
 *
 * @param initial - Initial variant(s)
 * @param animate - Variant(s) to animate to
 * @param inherit - `true` is inheriting animations from parent
 * @param controls - Animation controls
 *
 * @internal
 */


function useVariants(initial, animate, inherit, controls) {
  var targetVariants = resolveVariantLabels(animate);
  var context = useContext(MotionContext);
  var parentAlreadyMounted = context.hasMounted && context.hasMounted.current;
  var hasMounted = useRef(false);
  useEffect(function () {
    var shouldAnimate = false;

    if (inherit) {
      // If we're inheriting variant changes and the parent has already
      // mounted when this component loads, we need to manually trigger
      // this animation.
      shouldAnimate = !!parentAlreadyMounted;
      targetVariants = resolveVariantLabels(context.animate);
    } else {
      shouldAnimate = hasMounted.current || hasVariantChanged(resolveVariantLabels(initial), targetVariants);
    }

    shouldAnimate && controls.start(targetVariants);
    hasMounted.current = true;
  }, asDependencyList(targetVariants));
}
/**
 * `useAnimationGroupSubscription` allows a component to subscribe to an
 * externally-created `AnimationControls`, created by the `useAnimation` hook.
 *
 * @param animation
 * @param controls
 *
 * @internal
 */


function useAnimationGroupSubscription(animation, controls) {
  var unsubscribe = useMemo(function () {
    return animation.subscribe(controls);
  }, [animation]);
  useEffect(function () {
    return function () {
      unsubscribe && unsubscribe();
    };
  }, [unsubscribe]);
}

var _a$1$1, _b;

var AnimatePropComponents = (_a$1$1 = {}, _a$1$1[AnimatePropType.Target] = makeRenderlessComponent(function (_a) {
  var animate = _a.animate,
      controls = _a.controls,
      values = _a.values,
      transition = _a.transition;
  return useAnimateProp(animate, controls, values, transition);
}), _a$1$1[AnimatePropType.VariantLabel] = makeRenderlessComponent(function (_a) {
  var animate = _a.animate,
      _b = _a.inherit,
      inherit = _b === void 0 ? true : _b,
      controls = _a.controls,
      initial = _a.initial;
  return useVariants(initial, animate, inherit, controls);
}), _a$1$1[AnimatePropType.AnimationSubscription] = makeRenderlessComponent(function (_a) {
  var animate = _a.animate,
      controls = _a.controls;
  return useAnimationGroupSubscription(animate, controls);
}), _a$1$1);

var isVariantLabel$1 = function isVariantLabel$1(prop) {
  return Array.isArray(prop) || typeof prop === "string";
};

var isAnimationSubscription = function isAnimationSubscription(_a) {
  var animate = _a.animate;
  return animate instanceof AnimationControls;
};

var animationProps = ["initial", "animate", "whileTap", "whileHover"];
var animatePropTypeTests = (_b = {}, _b[AnimatePropType.Target] = function (props) {
  return props.animate !== undefined && !isVariantLabel$1(props.animate) && !isAnimationSubscription(props);
}, _b[AnimatePropType.VariantLabel] = function (props) {
  return props.variants !== undefined || animationProps.some(function (key) {
    return typeof props[key] === "string";
  });
}, _b[AnimatePropType.AnimationSubscription] = isAnimationSubscription, _b);

var getAnimationComponent = function getAnimationComponent(props) {
  var animatePropType = undefined;

  for (var key in AnimatePropType) {
    if (animatePropTypeTests[key](props)) {
      animatePropType = key;
    }
  }

  return animatePropType ? AnimatePropComponents[animatePropType] : undefined;
};
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */


function usePresence() {
  var context = useContext(PresenceContext);
  if (context === null) return [true];
  var isPresent = context.isPresent,
      onExitComplete = context.onExitComplete,
      register = context.register;
  useEffect(register, []);
  return !isPresent && onExitComplete ? [false, onExitComplete] : [true];
}

var Exit = {
  key: "exit",
  shouldRender: function shouldRender(props) {
    return !!props.exit && !checkShouldInheritVariant(props);
  },
  Component: makeRenderlessComponent(function (props) {
    var _a;

    var animate = props.animate,
        controls = props.controls,
        exit = props.exit;

    var _b = usePresence(),
        isPresent = _b[0],
        onExitComplete = _b[1];

    var presenceContext = useContext(PresenceContext);
    var isPlayingExitAnimation = useRef(false);
    var custom = ((_a = presenceContext) === null || _a === void 0 ? void 0 : _a.custom) !== undefined ? presenceContext.custom : props.custom;
    useEffect(function () {
      if (!isPresent) {
        if (!isPlayingExitAnimation.current && exit) {
          controls.setProps(_assign$2(_assign$2({}, props), {
            custom: custom
          }));
          controls.start(exit).then(onExitComplete);
        }

        isPlayingExitAnimation.current = true;
      } else if (isPlayingExitAnimation.current && animate && !(animate instanceof AnimationControls)) {
        controls.start(animate);
      }

      if (isPresent) {
        isPlayingExitAnimation.current = false;
      }
    }, [isPresent]);
  })
};

var isPropValid = function isPropValid(key) {
  return !isValidMotionProp(key);
};
/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */


try {
  var emotionIsPropValid_1 = require("@emotion/is-prop-valid").default;

  isPropValid = function isPropValid(key) {
    // Handle events explicitly as Emotion validates them all as true
    if (key.startsWith("on")) {
      return !isValidMotionProp(key);
    } else {
      return emotionIsPropValid_1(key);
    }
  };
} catch (_a) {// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}

function filterValidProps(props) {
  var domProps = {};

  for (var key in props) {
    if (isPropValid(key)) {
      domProps[key] = props[key];
    }
  }

  return domProps;
}

var buildHTMLProps = function buildHTMLProps(values, style, isStatic, isDrag) {
  // The `any` isn't ideal but it is the type of createElement props argument
  var props = {
    style: buildStyleAttr(values, style, isStatic)
  };

  if (isDrag) {
    // Disable text selection
    props.style.userSelect = "none"; // Disable the ghost element when a user drags

    props.draggable = false;
  }

  return props;
};

var buildSVGProps = function buildSVGProps(values, style) {
  var motionValueStyles = resolveCurrent(values);
  var props = buildSVGAttrs(motionValueStyles, undefined, undefined, undefined, undefined, false);
  props.style = _assign$2(_assign$2({}, style), props.style);
  return props;
};

var functionalityComponents = [Layout, Drag, Gestures, Exit];
var numFunctionalityComponents = functionalityComponents.length;
/**
 * Create a configuration for `motion` components that provides DOM-specific functionality.
 *
 * @internal
 */

function createDomMotionConfig(Component) {
  var isDOM = typeof Component === "string";
  var isSVG = isDOM && svgElements.indexOf(Component) !== -1;
  return {
    renderComponent: function renderComponent(ref, style, values, props, isStatic) {
      var forwardedProps = isDOM ? filterValidProps(props) : props;
      var staticVisualStyles = isSVG ? buildSVGProps(values, style) : buildHTMLProps(values, style, isStatic, !!props.drag);
      return createElement(Component, _assign$2(_assign$2(_assign$2({}, forwardedProps), {
        ref: ref
      }), staticVisualStyles));
    },

    /**
     * loadFunctionalityComponents gets used by the `motion` component
     *
     * Each functionality component gets provided the `ref`, animation controls and the `MotionValuesMap`
     * generated for that component, as well as all the `props` passed to it by the user.
     *
     * The pattern used to determine whether to load and use each piece of functionality is
     * consistent (should render? Then push component) and could be used to extend functionality.
     *
     * By exposing a mutable piece of memory via an API like `extendMotionComponent` we could
     * allow users to add `FunctionalComponentDefinition`s. This would allow us to offer file size
     * reductions by shipping an entry point that doesn't load gesture and drag functionality, and
     * also offer a way for users to develop plugins/other functionality. Because these functionalities
     * are loaded as components, we can look into using Suspense for this purpose.
     *
     * For user-defined functionality we'd need to allow
     *  1) User-defined prop typing (extending `P`)
     *  2) User-defined "clean props" function that removes their plugin's props before being passed to the DOM.
     */
    loadFunctionalityComponents: function loadFunctionalityComponents(ref, values, props, context, controls, inherit) {
      var activeComponents = []; // TODO: Consolidate Animation functionality loading strategy with other functionality components

      var Animation = getAnimationComponent(props);

      if (Animation) {
        activeComponents.push(createElement(Animation, {
          key: "animation",
          initial: props.initial,
          animate: props.animate,
          variants: props.variants,
          transition: props.transition,
          controls: controls,
          inherit: inherit,
          values: values
        }));
      }

      for (var i = 0; i < numFunctionalityComponents; i++) {
        var _a = functionalityComponents[i],
            shouldRender = _a.shouldRender,
            key = _a.key,
            Component_1 = _a.Component;

        if (shouldRender(props, context)) {
          activeComponents.push(createElement(Component_1, _assign$2({
            key: key
          }, props, {
            parentContext: context,
            values: values,
            controls: controls,
            innerRef: ref
          })));
        }
      }

      return activeComponents;
    },
    getValueControlsConfig: function getValueControlsConfig(ref, values) {
      return {
        values: values,
        readValueFromSource: function readValueFromSource(key) {
          return index$1(ref.current).get(key);
        },
        // TODO: This is a good second source of plugins. This function contains the CSS variable
        // and unit conversion support. These functions share a common signature. We could make another
        // API for adding these.
        makeTargetAnimatable: parseDomVariant(values, ref)
      };
    }
  };
}

var htmlMotionComponents = htmlElements.reduce(function (acc, Component) {
  var config = createDomMotionConfig(Component); // Suppress "Expression produces a union type that is too complex to represent" error
  // @ts-ignore

  acc[Component] = createMotionComponent(config);
  return acc;
}, {});
var svgMotionComponents = svgElements.reduce(function (acc, Component) {
  // Suppress "Expression produces a union type that is too complex to represent" error
  // @ts-ignore
  acc[Component] = createMotionComponent(createDomMotionConfig(Component));
  return acc;
}, {});
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @internalremarks
 *
 * I'd like to make it possible for these to be loaded "on demand" - to reduce bundle size by only
 * including HTML/SVG stylers, animation and/or gesture support when necessary.
 *
 * ```jsx
 * <motion.div animate={{ x: 100 }} />
 *
 * <motion.p animate={{ height: 200 }} />
 *
 * <svg><motion.circle r={10} animate={{ r: 20 }} /></svg>
 * ```
 *
 * @public
 */

var motion = _assign$2(_assign$2({
  /**
   * Convert a custom React component into a `motion` component.
   *
   * It can also accept a string, to create [custom DOM elements](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Using_custom_elements).
   *
   * ```jsx
   * const Component = React.forwardRef((props: Props, ref) => {
   *   return <div ref={ref} />
   * })
   *
   * const MotionComponent = motion.custom<Props>(Component)
   * ```
   *
   * @param Component -
   */
  custom: function custom(Component) {
    return createMotionComponent(createDomMotionConfig(Component));
  }
}, htmlMotionComponents), svgMotionComponents);

motionValue(0);
motionValue(0);
motionValue(0);
motionValue(0);

var PresenceChild = function PresenceChild(_a) {
  var children = _a.children,
      initial = _a.initial,
      isPresent = _a.isPresent,
      _onExitComplete = _a.onExitComplete,
      custom = _a.custom;
  var numPresenceChildren = useRef(0);
  var numExitComplete = useRef(0);
  var context = {
    initial: initial,
    isPresent: isPresent,
    custom: custom,
    onExitComplete: function onExitComplete() {
      numExitComplete.current++;
      var allComplete = numExitComplete.current >= numPresenceChildren.current;
      _onExitComplete && allComplete && _onExitComplete();
    }
  };
  var register = useMemo(function () {
    numExitComplete.current = 0;
    return function () {
      numPresenceChildren.current++;
      return function () {
        return numPresenceChildren.current--;
      };
    };
  }, [isPresent]);
  return createElement(PresenceContext.Provider, {
    value: _assign$2(_assign$2({}, context), {
      register: register
    })
  }, children);
};

function getChildKey(child) {
  return child.key || "";
}

function updateChildLookup(children, allChildren) {
  var seenChildren = process$1.env.NODE_ENV !== "production" ? new Set() : null;
  children.forEach(function (child) {
    var key = getChildKey(child);

    if (process$1.env.NODE_ENV !== "production" && seenChildren) {
      if (seenChildren.has(key)) {
        console.warn("Children of AnimatePresence require unique keys. \"" + key + "\" is a duplicate.");
      }

      seenChildren.add(key);
    }

    allChildren.set(key, child);
  });
}

function onlyElements(children) {
  var filtered = []; // We use forEach here instead of map as map mutates the component key by preprending `.$`

  Children.forEach(children, function (child) {
    if (isValidElement(child)) filtered.push(child);
  });
  return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * @library
 *
 * Any `Frame` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { Frame, AnimatePresence } from 'framer'
 *
 * // As items are added and removed from `items`
 * export function Items({ items }) {
 *   return (
 *     <AnimatePresence>
 *       {items.map(item => (
 *         <Frame
 *           key={item.id}
 *           initial={{ opacity: 0 }}
 *           animate={{ opacity: 1 }}
 *           exit={{ opacity: 0 }}
 *         />
 *       ))}
 *     </AnimatePresence>
 *   )
 * }
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * @motion
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */


var AnimatePresence = function AnimatePresence(_a) {
  var children = _a.children,
      custom = _a.custom,
      _b = _a.initial,
      initial = _b === void 0 ? true : _b,
      onExitComplete = _a.onExitComplete,
      exitBeforeEnter = _a.exitBeforeEnter; // We want to force a re-render once all exiting animations have finished. We
  // either use a local forceUpdate function, or one from a parent context if it exists.

  var localForceUpdate = useForceUpdate();
  var contextForceUpdate = useContext(SyncLayoutContext);
  var forceUpdate = contextForceUpdate || localForceUpdate;
  var isInitialRender = useRef(true); // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key

  var filteredChildren = onlyElements(children); // Keep a living record of the children we're actually rendering so we
  // can diff to figure out which are entering and exiting

  var presentChildren = useRef(filteredChildren); // A lookup table to quickly reference components by key

  var allChildren = useRef(new Map()).current; // A living record of all currently exiting components.

  var exiting = useRef(new Set()).current;
  updateChildLookup(filteredChildren, allChildren); // If this is the initial component render, just deal with logic surrounding whether
  // we play onMount animations or not.

  if (isInitialRender.current) {
    isInitialRender.current = false;
    return createElement(Fragment$1, null, filteredChildren.map(function (child) {
      return createElement(PresenceChild, {
        key: getChildKey(child),
        isPresent: true,
        initial: initial ? undefined : false
      }, child);
    }));
  } // If this is a subsequent render, deal with entering and exiting children


  var childrenToRender = __spreadArrays(filteredChildren); // Diff the keys of the currently-present and target children to update our
  // exiting list.


  var presentKeys = presentChildren.current.map(getChildKey);
  var targetKeys = filteredChildren.map(getChildKey); // Diff the present children with our target children and mark those that are exiting

  var numPresent = presentKeys.length;

  for (var i = 0; i < numPresent; i++) {
    var key = presentKeys[i];

    if (targetKeys.indexOf(key) === -1) {
      exiting.add(key);
    } else {
      // In case this key has re-entered, remove from the exiting list
      exiting.delete(key);
    }
  } // If we currently have exiting children, and we're deferring rendering incoming children
  // until after all current children have exiting, empty the childrenToRender array


  if (exitBeforeEnter && exiting.size) {
    childrenToRender = [];
  } // Loop through all currently exiting components and clone them to overwrite `animate`
  // with any `exit` prop they might have defined.


  exiting.forEach(function (key) {
    // If this component is actually entering again, early return
    if (targetKeys.indexOf(key) !== -1) return;
    var child = allChildren.get(key);
    if (!child) return;
    var insertionIndex = presentKeys.indexOf(key);

    var onExit = function onExit() {
      exiting.delete(key); // Remove this child from the present children

      var removeIndex = presentChildren.current.findIndex(function (child) {
        return child.key === key;
      });
      presentChildren.current.splice(removeIndex, 1); // Defer re-rendering until all exiting children have indeed left

      if (!exiting.size) {
        presentChildren.current = filteredChildren;
        forceUpdate();
        onExitComplete && onExitComplete();
      }
    };

    childrenToRender.splice(insertionIndex, 0, createElement(PresenceChild, {
      key: getChildKey(child),
      isPresent: false,
      onExitComplete: onExit,
      custom: custom
    }, child));
  }); // Add `MotionContext` even to children that don't need it to ensure we're rendering
  // the same tree between renders

  childrenToRender = childrenToRender.map(function (child) {
    var key = child.key;
    return exiting.has(key) ? child : createElement(PresenceChild, {
      key: getChildKey(child),
      isPresent: true
    }, child);
  });
  presentChildren.current = childrenToRender;

  if (process$1.env.NODE_ENV !== "production" && exitBeforeEnter && childrenToRender.length > 1) {
    console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour.");
  }

  return createElement(Fragment$1, null, exiting.size ? childrenToRender : childrenToRender.map(function (child) {
    return cloneElement(child);
  }));
}; // Does this device prefer reduced motion? Returns `null` server-side.


var prefersReducedMotion = motionValue(null);

if (typeof window !== "undefined") {
  if (window.matchMedia) {
    var motionMediaQuery_1 = window.matchMedia("(prefers-reduced-motion)");

    var setReducedMotionPreferences = function setReducedMotionPreferences() {
      return prefersReducedMotion.set(motionMediaQuery_1.matches);
    };

    motionMediaQuery_1.addListener(setReducedMotionPreferences);
    setReducedMotionPreferences();
  } else {
    prefersReducedMotion.set(false);
  }
}

var ToggleButton = styled.button.withConfig({
  displayName: "theme-toggle-button__ToggleButton",
  componentId: "sc-6exhqm-0"
})(["all:unset;cursor:pointer;width:36px;height:36px;border-radius:", ";background-color:", ";color:", ";display:flex;align-items:center;justify-content:center;overflow:hidden;position:relative;"], function (_ref) {
  var theme = _ref.theme;
  return theme.radii.base;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors['neutral-50'];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors['neutral-700'];
});

function ThemeToggleButton() {
  var _useThemeContext = useThemeContext(),
      mode = _useThemeContext.mode,
      toggle = _useThemeContext.toggle;

  var isDark = mode === 'dark';
  return /*#__PURE__*/jsx$1(ToggleButton, {
    onClick: toggle,
    "aria-label": "Toggle dark mode",
    children: /*#__PURE__*/jsx$1(AnimatePresence, {
      initial: false,
      mode: "wait",
      children: isDark ? /*#__PURE__*/jsx$1(motion.div, {
        initial: {
          y: -18,
          opacity: 0
        },
        animate: {
          y: 0,
          opacity: 1
        },
        exit: {
          y: 18,
          opacity: 0
        },
        transition: {
          type: 'spring',
          stiffness: 300,
          damping: 25
        },
        style: {
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        },
        children: /*#__PURE__*/jsx$1(Moon, {
          size: 16
        })
      }, 'moon') : /*#__PURE__*/jsx$1(motion.div, {
        initial: {
          y: 18,
          opacity: 0
        },
        animate: {
          y: 0,
          opacity: 1
        },
        exit: {
          y: -18,
          opacity: 0
        },
        transition: {
          type: 'spring',
          stiffness: 300,
          damping: 25
        },
        style: {
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        },
        children: /*#__PURE__*/jsx$1(Sun, {
          size: 16
        })
      }, 'sun')
    })
  });
}

function isMacPlatform() {
  var _navigator$userAgentD;

  if (typeof navigator === 'undefined') return false;

  if ('userAgentData' in navigator && (_navigator$userAgentD = navigator.userAgentData) !== null && _navigator$userAgentD !== void 0 && _navigator$userAgentD.platform) {
    return /mac|apple/i.test(navigator.userAgentData.platform || '');
  }

  return /Mac|iPhone|iPad|iPod|Apple/i.test(navigator.userAgent);
}

function NavbarQuickSearch() {
  var isMac = useMemo(function () {
    return isMacPlatform();
  }, []);

  function triggerCommandK() {
    var event = new KeyboardEvent('keydown', {
      key: 'k',
      code: 'KeyK',
      keyCode: 75,
      which: 75,
      bubbles: true,
      cancelable: true,
      metaKey: true
    });
    document.dispatchEvent(event);
  }

  return /*#__PURE__*/jsxs(Button, {
    variant: "link",
    onClick: triggerCommandK,
    borderRadius: "base",
    gap: 4,
    py: 1,
    px: 3,
    fontWeight: "regular",
    backgroundColor: "neutral-50",
    children: [/*#__PURE__*/jsx$1(Text, {
      variant: "paragraph-small",
      children: "Search pages..."
    }), /*#__PURE__*/jsxs(Box, {
      gap: 2,
      alignItems: "center",
      children: [/*#__PURE__*/jsxs(Box, {
        as: "span",
        backgroundColor: "background",
        borderRadius: "base",
        py: 1,
        px: 2,
        display: "flex",
        alignItems: "center",
        gap: 1,
        children: [isMac ? /*#__PURE__*/jsx$1(Command, {
          size: 12
        }) : null, /*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-xsmall",
          children: isMac ? 'Cmd' : 'Ctrl'
        })]
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        backgroundColor: "background",
        borderRadius: "base",
        py: 1,
        px: 2,
        children: "K"
      })]
    })]
  });
}

function Navbar() {
  var _useHeader = useHeader(),
      header = _useHeader.header;

  return /*#__PURE__*/jsxs(Box, {
    as: "header",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    mb: "48px",
    children: [/*#__PURE__*/jsx$1(Box, {
      children: typeof header === 'string' ? /*#__PURE__*/jsx$1(Text, {
        variant: "heading-h3",
        color: "primary-600",
        children: header
      }) : header
    }), /*#__PURE__*/jsxs(Box, {
      as: "nav",
      gap: 3,
      children: [/*#__PURE__*/jsxs(Box, {
        gap: 2,
        children: [/*#__PURE__*/jsx$1(ThemeToggleButton, {}), /*#__PURE__*/jsx$1(NavbarQuickSearch, {})]
      }), /*#__PURE__*/jsxs(Button, {
        variant: "minimal",
        color: "primary-600",
        px: 0,
        children: [/*#__PURE__*/jsx$1(RiQuestionLine, {}), /*#__PURE__*/jsx$1(Text, {
          children: "Help"
        })]
      }), /*#__PURE__*/jsxs(Button, {
        variant: "minimal",
        color: "primary-600",
        px: 0,
        children: [/*#__PURE__*/jsx$1(RiShoppingCartLine, {}), /*#__PURE__*/jsx$1(Text, {
          children: "Cart"
        })]
      })]
    })]
  });
}

var _excluded$K = ["children"];

function ownKeys$1N(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1N(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1N(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1N(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function PageWrapper(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties$8(_ref, _excluded$K);

  return /*#__PURE__*/jsx$1(Stack$1, _objectSpread$1N(_objectSpread$1N({
    height: "100%",
    width: "100%",
    pb: "48px",
    px: "56px",
    pt: 4,
    flex: 1,
    alignItems: "start",
    justifyContent: "start"
  }, props), {}, {
    children: children
  }));
}

function SidebarItem(_ref) {
  var _ref$item = _ref.item,
      Icon = _ref$item.Icon,
      IconFill = _ref$item.IconFill,
      label = _ref$item.label,
      href = _ref$item.href,
      _ref$item$gap = _ref$item.gap,
      gap = _ref$item$gap === void 0 ? false : _ref$item$gap; // @ts-expect-error -- This exists but bad TS in service.

  var _useUserService = useUserService(),
      onLogout = _useUserService.onLogout;

  var location = useLocation();
  var active = location.pathname.startsWith(href);
  var DisplayIcon = active ? IconFill : Icon;
  return /*#__PURE__*/jsx$1(Link, {
    to: href,
    children: /*#__PURE__*/jsxs(_StyledButton$g, {
      variant: "link",
      "data-active": active,
      p: 0,
      mx: "auto",
      flexDirection: "column",
      mt: gap ? 5 : 0,
      onClick: function onClick() {
        if (href.endsWith('?logout=true')) {
          onLogout();
        }
      },
      children: [/*#__PURE__*/jsx$1(Box, {
        className: "sidebar-icon-wrapper",
        width: "40px",
        height: "40px",
        borderRadius: "base",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: active ? 'primary-100' : 'none',
        transition: "0.2s",
        children: /*#__PURE__*/jsx$1(DisplayIcon, {
          size: "32px"
        })
      }), /*#__PURE__*/jsx$1(Text, {
        fontWeight: active ? 'semi' : 'regular',
        transition: "0.2s",
        children: label
      })]
    })
  });
}

var _StyledButton$g = styled(Button).withConfig({
  displayName: "sidebar-item___StyledButton",
  componentId: "sc-9ua8w-0"
})(["&:hover .sidebar-icon-wrapper{background-color:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors['primary-100'];
});

var SIDEBAR_ITEMS = [{
  Icon: RiAccountBoxLine,
  IconFill: RiAccountBoxFill,
  label: 'My Account',
  href: "".concat(BASEPATH, "/my-account")
}, {
  Icon: RiFoldersLine,
  IconFill: RiFoldersFill,
  label: 'Managers',
  href: "".concat(BASEPATH, "/managers")
}, {
  Icon: RiNotificationBadgeLine,
  IconFill: RiNotificationBadgeFill,
  label: 'Notifications',
  href: "".concat(BASEPATH, "/notifications")
}, {
  Icon: RiSettings4Line,
  IconFill: RiSettings4Fill,
  label: 'Settings',
  href: "".concat(BASEPATH, "/settings"),
  gap: true
}, {
  Icon: RiLogoutBoxRLine,
  IconFill: RiLogoutBoxRFill,
  label: 'Log out',
  href: "".concat(BASEPATH, "?logout=true")
}];

function Logo(_ref) {
  var mode = _ref.mode,
      reseller = _ref.reseller;

  function getLogo() {
    if (reseller === 'internic.ca' && mode === 'dark') {
      return 'interniclogo';
    }

    if (reseller === 'internic.ca' && mode === 'light') {
      return 'interniclogo-black';
    }

    return 'rebelcom-logo';
  }

  return /*#__PURE__*/jsx$1(Icon$2, {
    name: getLogo(),
    height: "26.562px",
    width: "136px"
  });
}

function SideBarComponent() {
  var _useThemeContext = useThemeContext(),
      mode = _useThemeContext.mode;

  return /*#__PURE__*/jsxs(Stack$1, {
    id: "dashboard-sidebar",
    gap: 3,
    p: 4,
    borderRight: "1px solid",
    borderColor: "neutral-200",
    minHeight: "100%",
    children: [/*#__PURE__*/jsx$1(Stack$1, {
      mb: 4,
      children: /*#__PURE__*/jsx$1(Button, {
        variant: "link",
        width: "fit-content",
        px: 0,
        onClick: function onClick() {
          window.location.href = '/';
        },
        children: /*#__PURE__*/jsx$1(Logo, {
          mode: mode,
          reseller: RESELLER
        })
      })
    }), SIDEBAR_ITEMS.map(function (item) {
      return /*#__PURE__*/jsx$1(SidebarItem, {
        item: item
      }, item.href);
    })]
  });
}

function Sidebar() {
  return /*#__PURE__*/jsx$1(Router, {
    basepath: BASEPATH,
    children: /*#__PURE__*/jsx$1(Route, {
      component: SideBarComponent,
      path: "/*"
    })
  });
}

var ViewProviderContext = /*#__PURE__*/createContext(undefined);

function ViewProvider(_ref) {
  var children = _ref.children;

  var _useState = useState('GRID'),
      _useState2 = _slicedToArray$4(_useState, 2),
      view = _useState2[0],
      setView = _useState2[1];

  var setGridView = function setGridView() {
    return setView('GRID');
  };

  var setTableView = function setTableView() {
    return setView('TABLE');
  };

  return /*#__PURE__*/jsx$1(ViewProviderContext.Provider, {
    value: {
      view: view,
      setGridView: setGridView,
      setTableView: setTableView
    },
    children: children
  });
}

function useViewProvider() {
  var context = useContext(ViewProviderContext);

  if (!context) {
    throw new Error('useViewProvider must be used within a ViewProvider');
  }

  return context;
}

function Header$1(_ref) {
  var children = _ref.children,
      header = _ref.header;

  var _useHeader = useHeader(),
      setHeader = _useHeader.setHeader;

  useEffect(function () {
    var value = null;

    if (typeof header === 'string') {
      value = header;
    } else if ( /*#__PURE__*/isValidElement(children)) {
      value = children;
    }

    setHeader(value);
  }, [setHeader, children, header]);
  return null;
}

var _templateObject$B;

function StyledInput(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      autoFocus = _ref.autoFocus;
  var inputRef = useRef(null);
  return /*#__PURE__*/jsxs(_StyledBox$q, {
    justifyContent: "space-between",
    border: "1px solid",
    borderColor: "neutral-200",
    borderRadius: "rounded",
    px: "32px",
    gap: 4,
    onClick: function onClick() {
      var _inputRef$current;

      return (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
    },
    style: {
      cursor: 'text'
    },
    transition: "0.2s",
    backgroundColor: "card",
    children: [/*#__PURE__*/jsx$1(_StyledInput$4, {
      ref: inputRef,
      value: value,
      onChange: onChange,
      placeholder: placeholder,
      autoFocus: autoFocus,
      my: "12px",
      height: "20px",
      border: "none",
      color: "neutral-700"
    }), /*#__PURE__*/jsxs(Box, {
      gap: 2,
      alignItems: "center",
      color: "primary-700",
      children: [/*#__PURE__*/jsx$1(Search, {}), /*#__PURE__*/jsx$1(Text, {
        color: "primary-700",
        fontWeight: "semi",
        children: "Search"
      })]
    })]
  });
}

var _StyledBox$q = styled(Box)(_templateObject$B || (_templateObject$B = _taggedTemplateLiteral$1(["\n        box-shadow: 0px 20px 26px -20px rgba(0, 0, 0, 0.15);\n        &:focus-within,\n        &:hover {\n          border-color: ", ";\n        }\n      "])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors['supporting-haciendaBlue'];
});

var _StyledInput$4 = styled(Input$3).withConfig({
  displayName: "styled-input___StyledInput",
  componentId: "sc-1l31p4o-0"
})(["background:none;outline:none;font-size:14px;&::placeholder{color:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors['neutral-400'];
});

function Tabs(_ref) {
  var tabs = _ref.tabs;
  var location = useLocation();
  return /*#__PURE__*/jsx$1(Box, {
    borderBottom: "1px solid",
    borderColor: "neutral-200",
    overflowX: "auto",
    width: "100%",
    role: "tablist",
    padding: "24px 0px",
    gap: 3,
    mb: "48px",
    children: tabs.map(function (tab) {
      var active = location.pathname.endsWith(tab.path);
      return /*#__PURE__*/jsx$1(Link, {
        to: tab.path,
        "data-testid": "tabulator-link-".concat(tab.path),
        children: /*#__PURE__*/jsx$1(_StyledButton$f, {
          variant: "link",
          borderRadius: "none",
          border: "none",
          "aria-selected": active,
          role: "tab",
          p: "4px 8px",
          "data-active": active,
          $_css: active ? 1 : 0,
          $_css2: active ? 'translateY(0)' : 'translateY(2px)',
          children: /*#__PURE__*/jsx$1(Text, {
            variant: "heading-h7",
            fontWeight: active ? 'semi' : 'regular',
            children: tab.label
          })
        }, tab.path)
      }, tab.path);
    })
  });
}

var _StyledButton$f = styled(Button).withConfig({
  displayName: "tabs___StyledButton",
  componentId: "sc-aqquf2-0"
})(["position:relative;text-decoration-line:none;h6{position:relative;transition:0.2s;&::after{content:'';position:absolute;left:0;bottom:-2px;width:100%;height:2px;background-color:currentColor;opacity:", ";transform:", ";transition:transform 0.2s ease,opacity 0.2s ease;}}&:hover{h6{&::after{opacity:1;transform:translateY(0);}}}"], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
});
/**
 * This component allows users to switch between grid and table views with animations.
 */


function ViewManager(_ref) {
  var gridView = _ref.gridView,
      tableView = _ref.tableView,
      items = _ref.items,
      headerBar = _ref.headerBar;

  var _useViewProvider = useViewProvider(),
      view = _useViewProvider.view,
      setGridView = _useViewProvider.setGridView,
      setTableView = _useViewProvider.setTableView;

  var isGridView = view === 'GRID';
  var isTableView = view === 'TABLE';
  return /*#__PURE__*/jsxs(Stack$1, {
    gap: 4,
    width: "100%",
    mt: "32px",
    children: [/*#__PURE__*/jsxs(Box, {
      width: "100%",
      gap: 4,
      alignItems: "center",
      flexDirection: ['column', 'row'],
      children: [/*#__PURE__*/jsxs(Button, {
        variant: "minimal",
        onClick: setGridView,
        color: isGridView ? 'primary-600' : 'primary-500',
        px: 0,
        children: [view === 'GRID' ? /*#__PURE__*/jsx$1(RiLayoutGridFill, {}) : /*#__PURE__*/jsx$1(RiLayoutGridLine, {}), /*#__PURE__*/jsx$1(Text, {
          fontWeight: isGridView ? 'semi' : 'regular',
          children: "Grid"
        })]
      }), /*#__PURE__*/jsxs(Button, {
        variant: "minimal",
        onClick: setTableView,
        px: 0,
        color: isTableView ? 'primary-600' : 'primary-500',
        children: [view === 'TABLE' ? /*#__PURE__*/jsx$1(RiTableFill, {}) : /*#__PURE__*/jsx$1(RiTableLine, {}), /*#__PURE__*/jsx$1(Text, {
          fontWeight: isTableView ? 'semi' : 'regular',
          children: "Table"
        })]
      }), headerBar && /*#__PURE__*/jsx$1(Box, {
        flex: 1,
        alignItems: "center",
        children: headerBar
      })]
    }), items && items.length === 0 ? /*#__PURE__*/jsx$1(Box, {
      mt: 4,
      alignItems: "center",
      justifyContent: "center",
      children: /*#__PURE__*/jsx$1(Text, {
        variant: "heading-h6",
        color: "neutral-500",
        children: "No items to display"
      })
    }) : /*#__PURE__*/jsx$1(motion.div, {
      initial: {
        x: view === 'TABLE' ? 100 : -100,
        opacity: 0
      },
      animate: {
        x: 0,
        opacity: 1
      },
      exit: {
        x: view === 'TABLE' ? -100 : 100,
        opacity: 0
      },
      transition: {
        type: 'spring',
        stiffness: 300,
        damping: 30
      },
      style: {
        width: '100%'
      },
      children: view === 'GRID' ? gridView : tableView
    }, view)]
  });
}

var TABS = {
  myAccount: [{
    path: "".concat(BASEPATH, "/my-account/domains"),
    label: 'My Domains'
  }, {
    path: "".concat(BASEPATH, "/my-account/active-subscriptions"),
    label: 'Active Subscriptions'
  }, {
    path: "".concat(BASEPATH, "/my-account/canceled-subscriptions"),
    label: 'Canceled Subscriptions'
  }, {
    path: "".concat(BASEPATH, "/my-account/contacts"),
    label: 'Contacts'
  }],
  managers: [{
    path: "".concat(BASEPATH, "/managers/domains"),
    label: 'Domains'
  }, {
    path: "".concat(BASEPATH, "/managers/transfer"),
    label: 'Transfer'
  }, {
    path: "".concat(BASEPATH, "/managers/hosting"),
    label: 'Hosting'
  }, {
    path: "".concat(BASEPATH, "/managers/ssl"),
    label: 'SSL'
  }, {
    path: "".concat(BASEPATH, "/managers/seo"),
    label: 'SEO'
  }, {
    path: "".concat(BASEPATH, "/managers/website-builder"),
    label: 'Website Builder'
  }, {
    path: "".concat(BASEPATH, "/managers/website-security"),
    label: 'Website Security'
  }],
  settings: [{
    path: "".concat(BASEPATH, "/settings/personal-info"),
    label: 'Personal Info'
  }, {
    path: "".concat(BASEPATH, "/settings/payment-settings"),
    label: 'Payment Settings'
  }, {
    path: "".concat(BASEPATH, "/settings/billing-history"),
    label: 'Billing History'
  }, {
    path: "".concat(BASEPATH, "/settings/security-settings"),
    label: 'Security Settings'
  }, {
    path: "".concat(BASEPATH, "/settings/login-history"),
    label: 'Login History'
  }],
  domainOptions: function domainOptions(domainName) {
    return [{
      path: "".concat(BASEPATH, "/managers/domains/").concat(domainName, "/contacts"),
      label: 'Domain Contacts'
    }, {
      path: "".concat(BASEPATH, "/managers/domains/").concat(domainName, "/dns"),
      label: 'DNS'
    }, {
      path: "".concat(BASEPATH, "/managers/domains/").concat(domainName, "/options"),
      label: 'Domain Options'
    }];
  }
};

function _regenerator$1D() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1D(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1D(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1D(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1D(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1D(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1D(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1D(u), _regeneratorDefine2$1D(u, o, "Generator"), _regeneratorDefine2$1D(u, n, function () {
    return this;
  }), _regeneratorDefine2$1D(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1D = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1D(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1D = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1D(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1D(e, r, n, t);
}
/**
 * A utility function that executes an asynchronous function and captures any thrown errors.
 * It returns a tuple where either the result is present, or an error is present, but never both.
 *
 * @returns {Promise<[T, null] | [null, Error]>} A promise resolving to a tuple where the first element is the result (or `null` if an error occurred),
 * and the second element is an `Error` object (or `null` if execution was successful).
 */


function tryCatch(_x) {
  return _tryCatch.apply(this, arguments);
}

function _tryCatch() {
  _tryCatch = _asyncToGenerator( /*#__PURE__*/_regenerator$1D().m(function _callee(fn) {
    var result, _t, _t2;

    return _regenerator$1D().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            _context.p = 0;

            if (!(fn instanceof Function)) {
              _context.n = 2;
              break;
            }

            _context.n = 1;
            return fn();

          case 1:
            _t = _context.v;
            _context.n = 4;
            break;

          case 2:
            _context.n = 3;
            return fn;

          case 3:
            _t = _context.v;

          case 4:
            result = _t;
            return _context.a(2, [result, null]);

          case 5:
            _context.p = 5;
            _t2 = _context.v;
            return _context.a(2, [null, _t2 instanceof Error ? _t2 : new Error(String(_t2))]);
        }
      }
    }, _callee, null, [[0, 5]]);
  }));
  return _tryCatch.apply(this, arguments);
}

var APIS = {
  rebelWeb: function rebelWeb(path) {
    if (__LOCAL__) {
      return "https://local.".concat(RESELLER, "/api").concat(path);
    }

    if (__DEV__) {
      return "https://dev.".concat(RESELLER, "/api").concat(path);
    }

    return "https://www.".concat(RESELLER, "/api").concat(path);
  }
};

function _regenerator$1C() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1C(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1C(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1C(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1C(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1C(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1C(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1C(u), _regeneratorDefine2$1C(u, o, "Generator"), _regeneratorDefine2$1C(u, n, function () {
    return this;
  }), _regeneratorDefine2$1C(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1C = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1C(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1C = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1C(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1C(e, r, n, t);
}

function ownKeys$1M(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1M(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1M(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1M(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}
/**
 * Creates request headers with authorization token
 */


var createHeaders = function createHeaders() {
  var auth = LS.getItem(storageKeys.LSToken);
  return {
    Authorization: auth
  };
};
/**
 * Generic request handler for all HTTP methods
 */


var request = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$1C().m(function _callee(method, endpoint, body) {
    var config,
        headers,
        requestConfig,
        _yield,
        data,
        _args = arguments;

    return _regenerator$1C().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            config = _args.length > 3 && _args[3] !== undefined ? _args[3] : {};
            headers = createHeaders();
            requestConfig = _objectSpread$1M(_objectSpread$1M({}, config), {}, {
              headers: _objectSpread$1M(_objectSpread$1M({}, headers), config.headers)
            });
            _context.n = 1;
            return method === 'get' || method === 'delete' ? axios[method](endpoint, requestConfig) : axios[method](endpoint, body, requestConfig);

          case 1:
            _yield = _context.v;
            data = _yield.data;
            return _context.a(2, data);
        }
      }
    }, _callee);
  }));

  return function request(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * HTTP GET request
 */


var get$1 = function get(endpoint, config) {
  return request('get', endpoint, undefined, config);
};
/**
 * HTTP POST request
 */


var post = function post(endpoint, body, config) {
  return request('post', endpoint, body, config);
};
/**
 * HTTP PUT request
 */


var put = function put(endpoint, body, config) {
  return request('put', endpoint, body, config);
};
/**
 * HTTP DELETE request
 */


var del = function del(endpoint, config) {
  return request('delete', endpoint, undefined, config);
};

function ownKeys$1L(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1L(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1L(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1L(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _regenerator$1B() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1B(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1B(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1B(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1B(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1B(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1B(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1B(u), _regeneratorDefine2$1B(u, o, "Generator"), _regeneratorDefine2$1B(u, n, function () {
    return this;
  }), _regeneratorDefine2$1B(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1B = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1B(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1B = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1B(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1B(e, r, n, t);
}

var contacts = {
  /** Fetches all contact information for the current authorized user. */
  fetchAll: function fetchAll() {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1B().m(function _callee() {
      var endpoint, contactsResponse;
      return _regenerator$1B().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              endpoint = APIS.rebelWeb("/contacts");
              _context.n = 1;
              return get$1(endpoint);

            case 1:
              contactsResponse = _context.v;
              return _context.a(2, contactsResponse);
          }
        }
      }, _callee);
    })));
  },

  /** Fetches all domains linked to the list of contacts given */
  fetchAllLinkedDomains: function fetchAllLinkedDomains(contactIds) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1B().m(function _callee2() {
      var endpoint, contactsDomainsResponse;
      return _regenerator$1B().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              endpoint = APIS.rebelWeb("/contacts/domains");
              _context2.n = 1;
              return post(endpoint, contactIds);

            case 1:
              contactsDomainsResponse = _context2.v;
              return _context2.a(2, contactsDomainsResponse);
          }
        }
      }, _callee2);
    })));
  },

  /** Fetches all drop down values used for extra info views */
  fetchTLDOptions: function fetchTLDOptions() {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1B().m(function _callee3() {
      var endpoint, OptionsResponse;
      return _regenerator$1B().w(function (_context3) {
        while (1) {
          switch (_context3.n) {
            case 0:
              endpoint = APIS.rebelWeb("/options/extrainfo");
              _context3.n = 1;
              return get$1(endpoint);

            case 1:
              OptionsResponse = _context3.v;
              return _context3.a(2, OptionsResponse);
          }
        }
      }, _callee3);
    })));
  },

  /** Fetches all drop down values used for countries on a contact(not extra info) */
  fetchCountries: function fetchCountries() {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1B().m(function _callee4() {
      var endpoint, OptionsResponse;
      return _regenerator$1B().w(function (_context4) {
        while (1) {
          switch (_context4.n) {
            case 0:
              endpoint = APIS.rebelWeb("/options/countries");
              _context4.n = 1;
              return get$1(endpoint);

            case 1:
              OptionsResponse = _context4.v;
              return _context4.a(2, OptionsResponse);
          }
        }
      }, _callee4);
    })));
  },
  addContact: function addContact(contact) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1B().m(function _callee5() {
      var endpoint, addContactResponse;
      return _regenerator$1B().w(function (_context5) {
        while (1) {
          switch (_context5.n) {
            case 0:
              endpoint = APIS.rebelWeb("/contacts");
              _context5.n = 1;
              return post(endpoint, _objectSpread$1L({}, contact));

            case 1:
              addContactResponse = _context5.v;
              return _context5.a(2, addContactResponse);
          }
        }
      }, _callee5);
    })));
  },
  updateContact: function updateContact(contact) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1B().m(function _callee6() {
      var endpoint, addContactResponse;
      return _regenerator$1B().w(function (_context6) {
        while (1) {
          switch (_context6.n) {
            case 0:
              endpoint = APIS.rebelWeb("/contacts/".concat(contact.id));
              _context6.n = 1;
              return post(endpoint, contact);

            case 1:
              addContactResponse = _context6.v;
              return _context6.a(2, addContactResponse);
          }
        }
      }, _callee6);
    })));
  },
  deleteUnused: function deleteUnused() {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1B().m(function _callee7() {
      var endpoint, deleteUnusedResponse;
      return _regenerator$1B().w(function (_context7) {
        while (1) {
          switch (_context7.n) {
            case 0:
              endpoint = APIS.rebelWeb("/contacts/deleteunused");
              _context7.n = 1;
              return del(endpoint);

            case 1:
              deleteUnusedResponse = _context7.v;
              return _context7.a(2, deleteUnusedResponse);
          }
        }
      }, _callee7);
    })));
  },
  deleteContact: function deleteContact(contactIds) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1B().m(function _callee8() {
      var endpoint, deleteUnusedResponse;
      return _regenerator$1B().w(function (_context8) {
        while (1) {
          switch (_context8.n) {
            case 0:
              endpoint = APIS.rebelWeb("/deletecontacts");
              _context8.n = 1;
              return post(endpoint, contactIds);

            case 1:
              deleteUnusedResponse = _context8.v;
              return _context8.a(2, deleteUnusedResponse);
          }
        }
      }, _callee8);
    })));
  },
  resendVerification: function resendVerification(contactId) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1B().m(function _callee9() {
      var endpoint, deleteUnusedResponse;
      return _regenerator$1B().w(function (_context9) {
        while (1) {
          switch (_context9.n) {
            case 0:
              endpoint = APIS.rebelWeb("/contacts/".concat(contactId, "/verify"));
              _context9.n = 1;
              return post(endpoint);

            case 1:
              deleteUnusedResponse = _context9.v;
              return _context9.a(2, deleteUnusedResponse);
          }
        }
      }, _callee9);
    })));
  }
};

function _regenerator$1A() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1A(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1A(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1A(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1A(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1A(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1A(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1A(u), _regeneratorDefine2$1A(u, o, "Generator"), _regeneratorDefine2$1A(u, n, function () {
    return this;
  }), _regeneratorDefine2$1A(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1A = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1A(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1A = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1A(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1A(e, r, n, t);
}

var creditCards = {
  /** Delete a specific credit card by ID */
  deleteCard: function deleteCard(paymentSourceId) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1A().m(function _callee() {
      var endpoint;
      return _regenerator$1A().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              endpoint = APIS.rebelWeb("/creditcard/".concat(paymentSourceId));
              return _context.a(2, del(endpoint));
          }
        }
      }, _callee);
    })));
  },

  /** Set a card as the primary/default card */
  setPrimary: function setPrimary(paymentSourceId) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1A().m(function _callee2() {
      var endpoint;
      return _regenerator$1A().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              endpoint = APIS.rebelWeb("/creditcard/default/".concat(paymentSourceId));
              return _context2.a(2, put(endpoint));
          }
        }
      }, _callee2);
    })));
  },

  /** Set a card as the backup payment method */
  setBackup: function setBackup(paymentSourceId) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1A().m(function _callee3() {
      var endpoint;
      return _regenerator$1A().w(function (_context3) {
        while (1) {
          switch (_context3.n) {
            case 0:
              endpoint = APIS.rebelWeb("/creditcard/backup/".concat(paymentSourceId));
              return _context3.a(2, put(endpoint));
          }
        }
      }, _callee3);
    })));
  },
  addCard: function addCard(token, cardType, ccRole) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1A().m(function _callee4() {
      var endpoint;
      return _regenerator$1A().w(function (_context4) {
        while (1) {
          switch (_context4.n) {
            case 0:
              endpoint = APIS.rebelWeb("/creditcard");
              return _context4.a(2, post(endpoint, {
                chargebeeToken: token,
                type: cardType,
                ccRole: ccRole
              }));
          }
        }
      }, _callee4);
    })));
  }
};

function _regenerator$1z() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1z(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1z(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1z(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1z(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1z(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1z(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1z(u), _regeneratorDefine2$1z(u, o, "Generator"), _regeneratorDefine2$1z(u, n, function () {
    return this;
  }), _regeneratorDefine2$1z(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1z = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1z(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1z = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1z(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1z(e, r, n, t);
}

var dns = {
  fetchRecords: function fetchRecords(domain) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1z().m(function _callee() {
      var endpoint, response;
      return _regenerator$1z().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              endpoint = APIS.rebelWeb("/dns/records?domain=".concat(domain));
              _context.n = 1;
              return get$1(endpoint);

            case 1:
              response = _context.v;
              return _context.a(2, response.records);
          }
        }
      }, _callee);
    })));
  },
  createRecord: function createRecord(domain, record) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1z().m(function _callee2() {
      var endpoint;
      return _regenerator$1z().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              endpoint = APIS.rebelWeb("/dns/records");
              return _context2.a(2, post(endpoint, {
                domain: domain,
                record: record
              }));
          }
        }
      }, _callee2);
    })));
  },
  updateRecord: function updateRecord(domain, record) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1z().m(function _callee3() {
      var endpoint;
      return _regenerator$1z().w(function (_context3) {
        while (1) {
          switch (_context3.n) {
            case 0:
              endpoint = APIS.rebelWeb("/dns/records?domain=".concat(domain));
              return _context3.a(2, put(endpoint, {
                domain: domain,
                record: record
              }));
          }
        }
      }, _callee3);
    })));
  },
  deleteRecord: function deleteRecord(domainName, recordId) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1z().m(function _callee4() {
      var endpoint;
      return _regenerator$1z().w(function (_context4) {
        while (1) {
          switch (_context4.n) {
            case 0:
              endpoint = APIS.rebelWeb("/dns/records?domain=".concat(domainName, "&id=").concat(recordId));
              return _context4.a(2, del(endpoint));
          }
        }
      }, _callee4);
    })));
  },
  updateNameservers: function updateNameservers(domainId, updateRequest) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1z().m(function _callee5() {
      var endpoint;
      return _regenerator$1z().w(function (_context5) {
        while (1) {
          switch (_context5.n) {
            case 0:
              endpoint = APIS.rebelWeb("/dns/".concat(domainId, "/nameservers"));
              return _context5.a(2, put(endpoint, updateRequest));
          }
        }
      }, _callee5);
    })));
  },
  resetToDefaultRecords: function resetToDefaultRecords(domainName) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1z().m(function _callee6() {
      var endpoint;
      return _regenerator$1z().w(function (_context6) {
        while (1) {
          switch (_context6.n) {
            case 0:
              endpoint = APIS.rebelWeb("/dns/defaults");
              return _context6.a(2, post(endpoint, {
                domain: domainName,
                type: 'ALL'
              }));
          }
        }
      }, _callee6);
    })));
  },
  updateRegistryNameservers: function updateRegistryNameservers(domainId, records) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1z().m(function _callee7() {
      var endpoint;
      return _regenerator$1z().w(function (_context7) {
        while (1) {
          switch (_context7.n) {
            case 0:
              endpoint = APIS.rebelWeb("/dns/".concat(domainId, "/registry-nameservers"));
              return _context7.a(2, post(endpoint, records));
          }
        }
      }, _callee7);
    })));
  }
};

function _regenerator$1y() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1y(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1y(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1y(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1y(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1y(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1y(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1y(u), _regeneratorDefine2$1y(u, o, "Generator"), _regeneratorDefine2$1y(u, n, function () {
    return this;
  }), _regeneratorDefine2$1y(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1y = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1y(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1y = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1y(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1y(e, r, n, t);
}

var domains = {
  /** Fetches all domain information for the current authorized user. */
  fetchAll: function fetchAll() {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1y().m(function _callee() {
      var endpoint;
      return _regenerator$1y().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              endpoint = APIS.rebelWeb('/user/simplified-domains');
              return _context.a(2, get$1(endpoint));
          }
        }
      }, _callee);
    })));
  },

  /** Renews the given domains. */
  renew: function renew(DomainIDs) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1y().m(function _callee2() {
      var endpoint;
      return _regenerator$1y().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              endpoint = APIS.rebelWeb('/domains/renewdomain');
              return _context2.a(2, post(endpoint, {
                DomainIDs: DomainIDs
              }));
          }
        }
      }, _callee2);
    })));
  },

  /** Enables given addon on given domainId and charges for it immediately through background cart. */
  enableAddon: function enableAddon(domainId, addon) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1y().m(function _callee3() {
      var endpoint;
      return _regenerator$1y().w(function (_context3) {
        while (1) {
          switch (_context3.n) {
            case 0:
              endpoint = APIS.rebelWeb("/domains/".concat(domainId, "/enable-addon/").concat(addon));
              _context3.n = 1;
              return post(endpoint);

            case 1:
              return _context3.a(2);
          }
        }
      }, _callee3);
    })));
  },

  /** Moves domains to the target customer. Obviously validates the domains belong to current user. */
  move: function move(DomainIds, TargetCustomerId) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1y().m(function _callee4() {
      var endpoint;
      return _regenerator$1y().w(function (_context4) {
        while (1) {
          switch (_context4.n) {
            case 0:
              endpoint = APIS.rebelWeb('/domains/move');
              return _context4.a(2, post(endpoint, {
                DomainIds: DomainIds,
                TargetCustomerId: TargetCustomerId
              }));
          }
        }
      }, _callee4);
    })));
  },

  /**
   * Returns minimal information about customers with a particular login
   * @param customerLogin Username or email
   */
  getMoveCustomers: function getMoveCustomers(customerLogin) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1y().m(function _callee5() {
      var endpoint;
      return _regenerator$1y().w(function (_context5) {
        while (1) {
          switch (_context5.n) {
            case 0:
              endpoint = APIS.rebelWeb("/domains/move-customer?login=".concat(customerLogin));
              return _context5.a(2, get$1(endpoint));
          }
        }
      }, _callee5);
    })));
  },

  /** Lists all the user's available portfolios */
  listPortfolios: function listPortfolios() {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1y().m(function _callee6() {
      var endpoint;
      return _regenerator$1y().w(function (_context6) {
        while (1) {
          switch (_context6.n) {
            case 0:
              endpoint = APIS.rebelWeb('/domains/portfolios');
              return _context6.a(2, get$1(endpoint));
          }
        }
      }, _callee6);
    })));
  },
  createPortfolio: function createPortfolio(portfolioName) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1y().m(function _callee7() {
      var endpoint;
      return _regenerator$1y().w(function (_context7) {
        while (1) {
          switch (_context7.n) {
            case 0:
              endpoint = APIS.rebelWeb('/domains/portfolio');
              return _context7.a(2, post(endpoint, {
                Name: portfolioName
              }));
          }
        }
      }, _callee7);
    })));
  },
  moveToPortfolio: function moveToPortfolio(targetPortfolioId, domainsIds) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1y().m(function _callee8() {
      var endpoint;
      return _regenerator$1y().w(function (_context8) {
        while (1) {
          switch (_context8.n) {
            case 0:
              endpoint = APIS.rebelWeb('/domains/move-to-portfolio');
              return _context8.a(2, post(endpoint, {
                TargetPortfolio: targetPortfolioId,
                DomainsToMove: domainsIds
              }));
          }
        }
      }, _callee8);
    })));
  },
  requestTransferCode: function requestTransferCode(domainId) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1y().m(function _callee9() {
      var endpoint;
      return _regenerator$1y().w(function (_context9) {
        while (1) {
          switch (_context9.n) {
            case 0:
              endpoint = APIS.rebelWeb("/domains/".concat(domainId, "/send-auth-code"));
              return _context9.a(2, post(endpoint));
          }
        }
      }, _callee9);
    })));
  },
  toggleAutoRenew: function toggleAutoRenew(domainId, toggle) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1y().m(function _callee0() {
      var endpoint;
      return _regenerator$1y().w(function (_context0) {
        while (1) {
          switch (_context0.n) {
            case 0:
              endpoint = APIS.rebelWeb("/domains/".concat(domainId, "/autorenew/").concat(toggle));
              return _context0.a(2, post(endpoint));
          }
        }
      }, _callee0);
    })));
  },
  deleteDomain: function deleteDomain(domainId) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1y().m(function _callee1() {
      var endpoint;
      return _regenerator$1y().w(function (_context1) {
        while (1) {
          switch (_context1.n) {
            case 0:
              endpoint = APIS.rebelWeb("/domains/canceldomain");
              return _context1.a(2, post(endpoint, {
                domainIds: [domainId]
              }));
          }
        }
      }, _callee1);
    })));
  }
};

function _regenerator$1x() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1x(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1x(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1x(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1x(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1x(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1x(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1x(u), _regeneratorDefine2$1x(u, o, "Generator"), _regeneratorDefine2$1x(u, n, function () {
    return this;
  }), _regeneratorDefine2$1x(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1x = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1x(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1x = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1x(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1x(e, r, n, t);
}

var plesk = {
  addToCart: function addToCart(product) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1x().m(function _callee() {
      var endpoint;
      return _regenerator$1x().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              endpoint = APIS.rebelWeb("/hosting/addplesktocart/".concat(product));
              return _context.a(2, get$1(endpoint));
          }
        }
      }, _callee);
    })));
  }
};

function determinePricing$1(_ref) {
  var annual = _ref.annual,
      regular = _ref.regular,
      itemCode = _ref.itemCode; // Special case because they only use promo price if bundled.

  var SPECIAL_CASES = ['DMLOCK', 'DMEXPINSURANCE'];

  if (SPECIAL_CASES.includes(itemCode)) {
    return {
      reg: regular.price,
      rnw: regular.price
    };
  }

  return annual ? {
    reg: annual.promo,
    rnw: annual.price
  } : {
    reg: regular.promo,
    rnw: regular.price
  };
}

function _regenerator$1w() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1w(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1w(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1w(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1w(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1w(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1w(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1w(u), _regeneratorDefine2$1w(u, o, "Generator"), _regeneratorDefine2$1w(u, n, function () {
    return this;
  }), _regeneratorDefine2$1w(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1w = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1w(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1w = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1w(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1w(e, r, n, t);
}

var prices = {
  getAll: function getAll(currency) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1w().m(function _callee() {
      var endpoint;
      return _regenerator$1w().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              endpoint = APIS.rebelWeb("/price/static/all?currency=".concat(currency, "&reseller=").concat(SERVER_RESELLER));
              return _context.a(2, get$1(endpoint));
          }
        }
      }, _callee);
    })));
  },
  getByItemCode: function getByItemCode(itemCode, currency) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1w().m(function _callee2() {
      var endpoint, response, desiredPrice;
      return _regenerator$1w().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              if (!(itemCode === 'OPEPBUNDLE')) {
                _context2.n = 3;
                break;
              }

              if (!(currency === 'CAD')) {
                _context2.n = 1;
                break;
              }

              return _context2.a(2, {
                reg: 10,
                rnw: 50
              });

            case 1:
              if (!(currency === 'USD')) {
                _context2.n = 2;
                break;
              }

              return _context2.a(2, {
                reg: 8,
                rnw: 40
              });

            case 2:
              return _context2.a(2, {
                reg: -1,
                rnw: -1
              });

            case 3:
              endpoint = APIS.rebelWeb("/price/static/all?currency=".concat(currency, "&reseller=").concat(SERVER_RESELLER));
              _context2.n = 4;
              return get$1(endpoint);

            case 4:
              response = _context2.v;
              desiredPrice = response.find(function (price) {
                return price.itemCode === itemCode;
              });

              if (desiredPrice) {
                _context2.n = 5;
                break;
              }

              throw new Error("No prices for itemCode ".concat(itemCode, "."));

            case 5:
              return _context2.a(2, determinePricing$1(desiredPrice));
          }
        }
      }, _callee2);
    })));
  }
};

function _regenerator$1v() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1v(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1v(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1v(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1v(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1v(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1v(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1v(u), _regeneratorDefine2$1v(u, o, "Generator"), _regeneratorDefine2$1v(u, n, function () {
    return this;
  }), _regeneratorDefine2$1v(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1v = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1v(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1v = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1v(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1v(e, r, n, t);
}

var seo = {
  addToCart: function addToCart(domain, seoPackage) {
    var goToCart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1v().m(function _callee() {
      var endpoint;
      return _regenerator$1v().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              endpoint = APIS.rebelWeb("/marketgoo/add-to-cart/".concat(domain, "/").concat(seoPackage));
              _context.n = 1;
              return post(endpoint);

            case 1:
              if (goToCart) window.location.href = '/checkout';

            case 2:
              return _context.a(2);
          }
        }
      }, _callee);
    })));
  }
};

function _regenerator$1u() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1u(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1u(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1u(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1u(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1u(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1u(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1u(u), _regeneratorDefine2$1u(u, o, "Generator"), _regeneratorDefine2$1u(u, n, function () {
    return this;
  }), _regeneratorDefine2$1u(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1u = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1u(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1u = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1u(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1u(e, r, n, t);
}

var ssl = {
  addToCart: function addToCart(domain, sslPackage) {
    var goToCart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1u().m(function _callee() {
      var endpoint;
      return _regenerator$1u().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              endpoint = APIS.rebelWeb("/ssl/".concat(domain, "/add-cert-to-cart/").concat(sslPackage));
              _context.n = 1;
              return post(endpoint);

            case 1:
              if (goToCart) window.location.href = '/MyAccount/ShoppingCart.aspx';

            case 2:
              return _context.a(2);
          }
        }
      }, _callee);
    })));
  }
};

function _regenerator$1t() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1t(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1t(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1t(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1t(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1t(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1t(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1t(u), _regeneratorDefine2$1t(u, o, "Generator"), _regeneratorDefine2$1t(u, n, function () {
    return this;
  }), _regeneratorDefine2$1t(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1t = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1t(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1t = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1t(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1t(e, r, n, t);
}

var subscriptions = {
  fetch: function fetch(status) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1t().m(function _callee() {
      var endpoint, response;
      return _regenerator$1t().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              endpoint = APIS.rebelWeb("/user/subscriptions?statusType=".concat(status));
              _context.n = 1;
              return get$1(endpoint);

            case 1:
              response = _context.v;
              return _context.a(2, response.subscriptions);
          }
        }
      }, _callee);
    })));
  }
};

function _regenerator$1s() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1s(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1s(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1s(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1s(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1s(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1s(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1s(u), _regeneratorDefine2$1s(u, o, "Generator"), _regeneratorDefine2$1s(u, n, function () {
    return this;
  }), _regeneratorDefine2$1s(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1s = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1s(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1s = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1s(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1s(e, r, n, t);
}

var user = {
  fetchLoginHistory: function fetchLoginHistory() {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1s().m(function _callee() {
      var _yield$get, loginResults;

      return _regenerator$1s().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              _context.n = 1;
              return get$1(APIS.rebelWeb('/user/loginHistory'));

            case 1:
              _yield$get = _context.v;
              loginResults = _yield$get.loginResults;
              return _context.a(2, loginResults);
          }
        }
      }, _callee);
    })));
  },
  fetchAddress: function fetchAddress() {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1s().m(function _callee2() {
      var endpoint, _yield$get2, address;

      return _regenerator$1s().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              endpoint = APIS.rebelWeb("/user/address");
              _context2.n = 1;
              return get$1(endpoint);

            case 1:
              _yield$get2 = _context2.v;
              address = _yield$get2.address;
              return _context2.a(2, address);
          }
        }
      }, _callee2);
    })));
  },
  fetchUserDetails: function fetchUserDetails() {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1s().m(function _callee3() {
      var endpoint;
      return _regenerator$1s().w(function (_context3) {
        while (1) {
          switch (_context3.n) {
            case 0:
              endpoint = APIS.rebelWeb("/user/details");
              return _context3.a(2, get$1(endpoint));
          }
        }
      }, _callee3);
    })));
  },
  updateUserDetails: function updateUserDetails(data) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1s().m(function _callee4() {
      var endpoint;
      return _regenerator$1s().w(function (_context4) {
        while (1) {
          switch (_context4.n) {
            case 0:
              endpoint = APIS.rebelWeb("/user/details");
              return _context4.a(2, put(endpoint, data));
          }
        }
      }, _callee4);
    })));
  },
  updateAddress: function updateAddress(data) {
    return tryCatch( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1s().m(function _callee5() {
      var endpoint;
      return _regenerator$1s().w(function (_context5) {
        while (1) {
          switch (_context5.n) {
            case 0:
              endpoint = APIS.rebelWeb("/user/address");
              return _context5.a(2, put(endpoint, data));
          }
        }
      }, _callee5);
    })));
  }
};
var api = {
  contacts: contacts,
  dns: dns,
  domains: domains,
  plesk: plesk,
  prices: prices,
  seo: seo,
  ssl: ssl,
  subscriptions: subscriptions,
  creditCards: creditCards,
  user: user
};

function _regenerator$1r() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1r(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1r(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1r(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1r(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1r(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1r(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1r(u), _regeneratorDefine2$1r(u, o, "Generator"), _regeneratorDefine2$1r(u, n, function () {
    return this;
  }), _regeneratorDefine2$1r(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1r = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1r(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1r = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1r(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1r(e, r, n, t);
}

function ownKeys$1K(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1K(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1K(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1K(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var DomainsContext = /*#__PURE__*/createContext(undefined);
var PAGINATION_COUNT$2 = 20;

function DomainsProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(),
      _useState2 = _slicedToArray$4(_useState, 2),
      domains = _useState2[0],
      setDomains = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray$4(_useState3, 2),
      searchTerm = _useState4[0],
      setSearchTerm = _useState4[1];

  var _useState5 = useState(PAGINATION_COUNT$2),
      _useState6 = _slicedToArray$4(_useState5, 2),
      visibleCount = _useState6[0],
      setVisibleCount = _useState6[1];

  var _useState7 = useState({
    available: [],
    active: null
  }),
      _useState8 = _slicedToArray$4(_useState7, 2),
      portfolios = _useState8[0],
      setPortfolios = _useState8[1];

  var setActivePortfolio = useCallback(function (portfolioId) {
    var found = portfolios.available.find(function (p) {
      return p.id === portfolioId;
    }) || null;
    setPortfolios(function (prev) {
      return _objectSpread$1K(_objectSpread$1K({}, prev), {}, {
        active: found
      });
    });
    setSearchTerm('');
  }, [portfolios.available]);
  var filteredDomains = useMemo(function () {
    if (!domains) return undefined;
    var filtered = domains;

    if (searchTerm && searchTerm.length > 2) {
      filtered = filtered.filter(function (domain) {
        return domain.DomainName.includes(searchTerm);
      });
    }

    if (portfolios.active && !portfolios.active.isTopLevel) {
      filtered = filtered.filter(function (domain) {
        var _portfolios$active;

        return domain.PortfolioID === ((_portfolios$active = portfolios.active) === null || _portfolios$active === void 0 ? void 0 : _portfolios$active.id);
      });
    }

    return filtered.slice(0, visibleCount);
  }, [domains, searchTerm, portfolios.active, visibleCount]);
  var refreshDomains = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1r().m(function _callee() {
    var _yield$Promise$all, _yield$Promise$all2, _yield$Promise$all2$, domainsResponse, domainsError, _yield$Promise$all2$2, portfoliosResponse, portfoliosError, available;

    return _regenerator$1r().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            _context.n = 1;
            return Promise.all([api.domains.fetchAll(), api.domains.listPortfolios()]);

          case 1:
            _yield$Promise$all = _context.v;
            _yield$Promise$all2 = _slicedToArray$4(_yield$Promise$all, 2);
            _yield$Promise$all2$ = _slicedToArray$4(_yield$Promise$all2[0], 2);
            domainsResponse = _yield$Promise$all2$[0];
            domainsError = _yield$Promise$all2$[1];
            _yield$Promise$all2$2 = _slicedToArray$4(_yield$Promise$all2[1], 2);
            portfoliosResponse = _yield$Promise$all2$2[0];
            portfoliosError = _yield$Promise$all2$2[1];

            if (!domainsError) {
              _context.n = 2;
              break;
            }

            toast.error(domainsError.message);
            return _context.a(2);

          case 2:
            if (!portfoliosError) {
              _context.n = 3;
              break;
            }

            toast.error(portfoliosError.message);
            return _context.a(2);

          case 3:
            setDomains(domainsResponse);
            available = portfoliosResponse.map(function (p) {
              var count = p.IsTopLevel ? domainsResponse.length : domainsResponse.filter(function (d) {
                return d.PortfolioID === p.ID;
              }).length;
              return {
                id: p.ID,
                name: p.Name,
                count: count,
                isTopLevel: p.IsTopLevel
              };
            }).sort(function (a, b) {
              return a.id - b.id;
            });
            setPortfolios(function (prev) {
              var _ref3, _ref4;

              var currentActive = available.find(function (p) {
                var _prev$active;

                return p.id === ((_prev$active = prev.active) === null || _prev$active === void 0 ? void 0 : _prev$active.id);
              });
              var defaultPortfolio = (_ref3 = (_ref4 = currentActive !== null && currentActive !== void 0 ? currentActive : available.find(function (p) {
                return p.isTopLevel;
              })) !== null && _ref4 !== void 0 ? _ref4 : available[0]) !== null && _ref3 !== void 0 ? _ref3 : null;
              return {
                available: available,
                active: defaultPortfolio
              };
            });

          case 4:
            return _context.a(2);
        }
      }
    }, _callee);
  })), []);
  var showAll = useMemo(function () {
    if (!domains) return undefined;
    var filtered = domains;

    if (searchTerm && searchTerm.length > 2) {
      filtered = filtered.filter(function (domain) {
        return domain.DomainName.includes(searchTerm);
      });
    }

    if (portfolios.active && !portfolios.active.isTopLevel) {
      filtered = filtered.filter(function (domain) {
        var _portfolios$active2;

        return domain.PortfolioID === ((_portfolios$active2 = portfolios.active) === null || _portfolios$active2 === void 0 ? void 0 : _portfolios$active2.id);
      });
    }

    return visibleCount < filtered.length ? function () {
      return setVisibleCount(filtered.length);
    } : undefined;
  }, [domains, searchTerm, portfolios.active, visibleCount]);
  useEffect(function () {
    refreshDomains();
  }, [refreshDomains]);
  useEffect(function () {
    setVisibleCount(PAGINATION_COUNT$2);
  }, [searchTerm, portfolios.active]);
  return /*#__PURE__*/jsx$1(DomainsContext.Provider, {
    value: {
      domains: filteredDomains,
      searchTerm: searchTerm,
      setSearchTerm: setSearchTerm,
      setActivePortfolio: setActivePortfolio,
      portfolios: portfolios,
      refreshDomains: refreshDomains,
      showAll: showAll
    },
    children: children
  });
}

function useDomains() {
  var context = useContext(DomainsContext);

  if (!context) {
    throw new Error('useDomains must be used within a DomainsProvider');
  }

  return context;
}

var currencyOpts = [{
  name: 'canada',
  code: 'cad',
  axe: 'canadian dollar'
}, {
  name: 'united states',
  code: 'usd',
  axe: 'us dollar'
}];

var getCurrencyByCode = function getCurrencyByCode(code) {
  var codeMatcher = (code || 'cad').toLowerCase();
  var foundCurrency = currencyOpts.find(function (c) {
    return c.code === codeMatcher;
  });
  return foundCurrency || currencyOpts.find(function (c) {
    return c.code === 'usd';
  });
};

function ownKeys$1J(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1J(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1J(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1J(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var ErrorStateContext = /*#__PURE__*/React__default.createContext();
var ErrorDispatchContext = /*#__PURE__*/React__default.createContext();
var ERROR_KEYS = {
  order: 'order',
  session: 'session',
  user: {
    current: 'currentUser',
    info: 'userInfo',
    create: 'createUser',
    login: 'userLogin',
    social: 'socialLogin',
    sso: 'ssoLogin',
    logout: 'logout',
    resetReq: 'passwordResetReq',
    resetPass: 'passwordReset',
    validatePassGUI: 'validatePassGUI'
  }
};
var initialState$3 = {};

var reducer$3 = function reducer(state, action) {
  switch (action.type) {
    case 'add':
      {
        return _objectSpread$1J(_objectSpread$1J({}, state), {}, _defineProperty$6({}, action.key, action.payload));
      }

    case 'remove':
      {
        return _objectSpread$1J(_objectSpread$1J({}, state), {}, _defineProperty$6({}, action.key, null));
      }

    default:
      return initialState$3;
  }
}; // eslint-disable-next-line react/prop-types


function ErrorProvider$1(_ref) {
  var children = _ref.children;

  var _useReducer = useReducer(reducer$3, initialState$3),
      _useReducer2 = _slicedToArray$4(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var addError = function addError(_ref2) {
    var key = _ref2.key,
        error = _ref2.error;

    if (!key || !error) {
      throw new Error("You must supply a key and error to 'addError'.  You gave key: ".concat(key, " and error: ").concat(error));
    }

    dispatch({
      type: 'add',
      key: key,
      payload: error
    });
  };

  var removeError = function removeError(key) {
    if (!key) {
      throw new Error("You must supply a key to 'removeError'");
    }

    dispatch({
      type: 'remove',
      key: key
    });
  };

  var actions = useMemo(function () {
    return {
      addError: addError,
      removeError: removeError
    };
  }, []);
  return /*#__PURE__*/jsx$1(ErrorStateContext.Provider, {
    value: state,
    children: /*#__PURE__*/jsx$1(ErrorDispatchContext.Provider, {
      value: actions,
      children: children
    })
  });
}

function useErrorStateService(key) {
  var context = React__default.useContext(ErrorStateContext);

  if (!context) {
    throw new Error("useErrorStateService must be used within an ErrorProvider");
  }

  return context[key];
}

function useErrorDispatchService() {
  var context = React__default.useContext(ErrorDispatchContext);

  if (!context) {
    throw new Error("useErrorDispatchService must be used within an ErrorProvider");
  }

  return context;
}

function _regenerator$1q() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1q(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1q(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1q(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1q(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1q(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1q(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1q(u), _regeneratorDefine2$1q(u, o, "Generator"), _regeneratorDefine2$1q(u, n, function () {
    return this;
  }), _regeneratorDefine2$1q(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1q = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1q(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1q = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1q(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1q(e, r, n, t);
}

function ownKeys$1I(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1I(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1I(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1I(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var SessionContext = /*#__PURE__*/React__default.createContext();
var initialState$2 = {
  error: null,
  data: {
    currentCurrency: getCurrencyByCode(LS.getItem(storageKeys.Currency))
  },
  loading: false
};
/*

success type action:

Must have props:
type,
payload,
key

Use key for storing in data cache

*/

var reducer$2 = function reducer(state, action) {
  switch (action.type) {
    case 'error':
      {
        return _objectSpread$1I(_objectSpread$1I({}, state), {}, {
          loading: false
        });
      }

    case 'fetching':
      {
        return _objectSpread$1I(_objectSpread$1I({}, state), {}, {
          loading: true
        });
      }

    case 'success':
      {
        return _objectSpread$1I(_objectSpread$1I({}, state), {}, {
          data: _objectSpread$1I(_objectSpread$1I({}, state.data), {}, _defineProperty$6({}, action.key, action.payload)),
          error: null,
          loading: false
        });
      }

    case 'removeError':
      {
        return _objectSpread$1I(_objectSpread$1I({}, state), {}, {
          error: null
        });
      }

    default:
      return initialState$2;
  }
};

function SessionProvider(props) {
  var _useReducer = useReducer(reducer$2, initialState$2),
      _useReducer2 = _slicedToArray$4(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var _useErrorDispatchServ = useErrorDispatchService(),
      addError = _useErrorDispatchServ.addError;

  var fetchCurrency = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$1q().m(function _callee() {
      var _yield$get, _data, currency, _t;

      return _regenerator$1q().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              _context.p = 0;
              dispatch({
                type: 'fetching'
              });
              _context.n = 1;
              return get$3(userEndpoints.currency);

            case 1:
              _yield$get = _context.v;
              _data = _yield$get.data;
              currency = getCurrencyByCode(_data.currency);
              LS.setItem(storageKeys.Currency, _data.currency);
              dispatch({
                type: 'success',
                payload: currency,
                key: 'currentCurrency'
              });
              _context.n = 3;
              break;

            case 2:
              _context.p = 2;
              _t = _context.v;
              dispatch({
                type: 'error'
              });
              addError({
                key: ERROR_KEYS.session,
                error: _t
              });

            case 3:
              return _context.a(2);
          }
        }
      }, _callee, null, [[0, 2]]);
    }));

    return function fetchCurrency() {
      return _ref.apply(this, arguments);
    };
  }();

  var setCurrency = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$1q().m(function _callee2(currency) {
      var _t2;

      return _regenerator$1q().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              _context2.p = 0;
              dispatch({
                type: 'fetching'
              });
              _context2.n = 1;
              return post$1(userEndpoints.currency, currency);

            case 1:
              LS.setItem(storageKeys.Currency, currency.code);
              dispatch({
                type: 'success',
                payload: currency,
                key: 'currentCurrency'
              });

              if (hasDOM) {
                window.location.reload();
              }

              _context2.n = 3;
              break;

            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              dispatch({
                type: 'error'
              });
              addError({
                key: ERROR_KEYS.session,
                error: _t2
              });

            case 3:
              return _context2.a(2);
          }
        }
      }, _callee2, null, [[0, 2]]);
    }));

    return function setCurrency(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var setUseOldCart = function setUseOldCart(useOldCart) {
    try {
      LS.setItem(storageKeys.UseOldCart, useOldCart);
    } catch (error) {
      addError({
        key: ERROR_KEYS.session,
        error: error
      });
    }
  };

  var doUseOldCart = function doUseOldCart() {
    try {
      return LS.getItem(storageKeys.UseOldCart);
    } catch (error) {
      addError({
        key: ERROR_KEYS.session,
        error: error
      });
    }
  };

  var data = state.data,
      loading = state.loading;
  var value = useMemo(function () {
    return {
      fetchCurrency: fetchCurrency,
      setCurrency: setCurrency,
      setUseOldCart: setUseOldCart,
      doUseOldCart: doUseOldCart,
      data: data,
      loading: loading
    };
  }, [state]);
  useEffect(function () {
    fetchCurrency();
  }, []);
  return /*#__PURE__*/jsx$1(SessionContext.Provider, _objectSpread$1I({
    value: value
  }, props));
}

function useSessionService() {
  var context = React__default.useContext(SessionContext);

  if (!context) {
    throw new Error('useSessionService must be used within an SessionProvider');
  }

  return context;
}

function _regenerator$1p() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1p(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1p(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1p(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1p(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1p(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1p(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1p(u), _regeneratorDefine2$1p(u, o, "Generator"), _regeneratorDefine2$1p(u, n, function () {
    return this;
  }), _regeneratorDefine2$1p(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1p = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1p(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1p = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1p(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1p(e, r, n, t);
}

var PricingContext = /*#__PURE__*/createContext(undefined);

function PricingProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(),
      _useState2 = _slicedToArray$4(_useState, 2),
      prices = _useState2[0],
      setPrices = _useState2[1];

  var session = useSessionService();
  var currency = session.data.currentCurrency.code.toUpperCase();

  var getPriceByItemCode = function getPriceByItemCode(itemCode) {
    if (!prices) return null; // OPEP Doesn't have dynamic pricing, needs to be hardcoded.

    if (itemCode === 'OPEPBUNDLE') {
      if (currency === 'CAD') {
        return {
          reg: 10,
          rnw: 50
        };
      }

      if (currency === 'USD') {
        return {
          reg: 8,
          rnw: 40
        };
      }

      return {
        reg: -1,
        rnw: -1
      };
    }

    var desiredPrice = prices.find(function (price) {
      return price.itemCode === itemCode;
    });
    if (!desiredPrice) return null;
    return determinePricing$1(desiredPrice);
  };

  useEffect(function () {
    var fetchPrices = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$1p().m(function _callee() {
        var _yield$api$prices$get, _yield$api$prices$get2, rawPrices, error;

        return _regenerator$1p().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.n = 1;
                return api.prices.getAll(currency);

              case 1:
                _yield$api$prices$get = _context.v;
                _yield$api$prices$get2 = _slicedToArray$4(_yield$api$prices$get, 2);
                rawPrices = _yield$api$prices$get2[0];
                error = _yield$api$prices$get2[1];

                if (error) {
                  console.log(error);
                } else {
                  setPrices(rawPrices);
                }

              case 2:
                return _context.a(2);
            }
          }
        }, _callee);
      }));

      return function fetchPrices() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchPrices();
  }, [currency]);
  return /*#__PURE__*/jsx$1(PricingContext.Provider, {
    value: {
      prices: prices,
      getPriceByItemCode: getPriceByItemCode
    },
    children: children
  });
}

function usePricingContext() {
  var context = useContext(PricingContext);
  if (context === undefined) throw new Error('usePricingContext must be used within provider.');
  return context;
}

function ExportButton(_ref) {
  var selected = _ref.selected,
      domains = _ref.domains;

  function exportToCSV() {
    var selectedDomains = domains.filter(function (domain) {
      return selected.includes(domain.DomainID);
    });

    if (selectedDomains.length === 0) {
      return;
    }

    var headers = ['Name', 'TLD', 'Portfolio', 'Status', 'Expires', 'DNS1', 'DNS2', 'Ownership Protection', 'Expiry Protection', 'Privacy Protection', 'Premium', 'Auto Renew'];
    var rows = selectedDomains.map(function (domain) {
      return [domain.DomainName, domain.TLD, domain.PortfolioName, domain.Status, domain.PaidExpiryDate, domain.DNS1, domain.DNS2, domain.HasOwnershipProtection, domain.HasExpiryProtection, domain.HasPrivacyProtection, domain.IsPremium, domain.IsAutoRenew];
    });
    var csvContent = [headers.join(',')].concat(_toConsumableArray$1(rows.map(function (row) {
      return row.map(function (item) {
        return typeof item === 'string' ? "\"".concat(item.replace(/"/g, '""'), "\"") : String(item);
      }).join(',');
    }))).join('\n');
    var blob = new Blob([csvContent], {
      type: 'text/csv;charset=utf-8;'
    });
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'selected-domains.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    toast.success("Exported ".concat(selectedDomains.length, " domains to CSV!"));
  }

  return /*#__PURE__*/jsxs(Button, {
    variant: "minimal",
    onClick: exportToCSV,
    px: 0,
    children: [/*#__PURE__*/jsx$1(RiUploadLine, {}), /*#__PURE__*/jsx$1(Text, {
      fontWeight: "regular",
      children: "Export to CSV"
    })]
  });
}

function _regenerator$1o() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1o(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1o(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1o(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1o(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1o(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1o(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1o(u), _regeneratorDefine2$1o(u, o, "Generator"), _regeneratorDefine2$1o(u, n, function () {
    return this;
  }), _regeneratorDefine2$1o(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1o = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1o(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1o = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1o(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1o(e, r, n, t);
}
/** Helper hook for handling mutations in a clean way with toast integration and loading state */


function useMutation$1(config) {
  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  function mutate() {
    return _mutate.apply(this, arguments);
  }

  function _mutate() {
    _mutate = _asyncToGenerator( /*#__PURE__*/_regenerator$1o().m(function _callee() {
      var _yield$config$fn,
          _yield$config$fn2,
          data,
          error,
          _config$failureMessag,
          _config$onSuccess,
          _args = arguments;

      return _regenerator$1o().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              setIsLoading(true);
              _context.n = 1;
              return config.fn.apply(config, _args);

            case 1:
              _yield$config$fn = _context.v;
              _yield$config$fn2 = _slicedToArray$4(_yield$config$fn, 2);
              data = _yield$config$fn2[0];
              error = _yield$config$fn2[1];

              if (!error) {
                _context.n = 2;
                break;
              }

              toast.error((_config$failureMessag = config.failureMessage) !== null && _config$failureMessag !== void 0 ? _config$failureMessag : error);
              _context.n = 4;
              break;

            case 2:
              _context.n = 3;
              return (_config$onSuccess = config.onSuccess) === null || _config$onSuccess === void 0 ? void 0 : _config$onSuccess.call(config, data);

            case 3:
              toast.success(config.successMessage);

            case 4:
              setIsLoading(false);

            case 5:
              return _context.a(2);
          }
        }
      }, _callee);
    }));
    return _mutate.apply(this, arguments);
  }

  return {
    mutate: mutate,
    isLoading: isLoading
  };
}

var _templateObject$A, _templateObject2$m;

function _regenerator$1n() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1n(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1n(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1n(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1n(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1n(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1n(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1n(u), _regeneratorDefine2$1n(u, o, "Generator"), _regeneratorDefine2$1n(u, n, function () {
    return this;
  }), _regeneratorDefine2$1n(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1n = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1n(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1n = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1n(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1n(e, r, n, t);
}

function MoveButton(_ref) {
  var selected = _ref.selected,
      domains = _ref.domains;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isModalOpen = _useState2[0],
      setIsModalOpen = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray$4(_useState3, 2),
      input = _useState4[0],
      setInput = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray$4(_useState5, 2),
      matchedUsers = _useState6[0],
      setMatchedUsers = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray$4(_useState7, 2),
      selectedUser = _useState8[0],
      setSelectedUser = _useState8[1];

  var _useState9 = useState(),
      _useState0 = _slicedToArray$4(_useState9, 2),
      moveResponse = _useState0[0],
      setMoveResponse = _useState0[1];

  var _useUserService = useUserService(),
      user = _useUserService.user;

  var _useDomains = useDomains(),
      refreshDomains = _useDomains.refreshDomains;

  var _useMutation = useMutation$1({
    fn: api.domains.move,
    successMessage: 'Domains moved successfully.',
    onSuccess: function () {
      var _onSuccess = _asyncToGenerator( /*#__PURE__*/_regenerator$1n().m(function _callee(response) {
        return _regenerator$1n().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                setMoveResponse(response);
                setIsModalOpen(false);
                _context.n = 1;
                return refreshDomains();

              case 1:
                return _context.a(2);
            }
          }
        }, _callee);
      }));

      function onSuccess(_x) {
        return _onSuccess.apply(this, arguments);
      }

      return onSuccess;
    }()
  }),
      isLoading = _useMutation.isLoading,
      moveDomains = _useMutation.mutate;

  useEffect(function () {
    function findUsers() {
      return _findUsers.apply(this, arguments);
    }

    function _findUsers() {
      _findUsers = _asyncToGenerator( /*#__PURE__*/_regenerator$1n().m(function _callee2() {
        var _yield$api$domains$ge, _yield$api$domains$ge2, users, error;

        return _regenerator$1n().w(function (_context2) {
          while (1) {
            switch (_context2.n) {
              case 0:
                setSelectedUser(undefined);
                _context2.n = 1;
                return api.domains.getMoveCustomers(input);

              case 1:
                _yield$api$domains$ge = _context2.v;
                _yield$api$domains$ge2 = _slicedToArray$4(_yield$api$domains$ge, 2);
                users = _yield$api$domains$ge2[0];
                error = _yield$api$domains$ge2[1];

                if (error) {
                  toast.error(error);
                } else {
                  setMatchedUsers(users);
                }

              case 2:
                return _context2.a(2);
            }
          }
        }, _callee2);
      }));
      return _findUsers.apply(this, arguments);
    }

    if (!input.trim()) {
      setMatchedUsers(undefined);
      return;
    }

    var timeout = setTimeout(function () {
      findUsers();
    }, 800);
    return function () {
      return clearTimeout(timeout);
    };
  }, [input]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Modal, {
      isOpen: isModalOpen,
      onClose: function onClose() {
        setMatchedUsers(undefined);
        setSelectedUser(undefined);
        setInput('');
        setIsModalOpen(false);
      },
      title: "Move domain",
      children: /*#__PURE__*/jsx$1(Stack$1, {
        gap: 4,
        width: ['100%', '800px', '800px'],
        children: moveResponse && selectedUser ? /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsxs(Box, {
            backgroundColor: "success-200",
            padding: "4px 16px",
            height: "60px",
            alignItems: "center",
            gap: "16px",
            color: "neutral-700",
            borderRadius: "base",
            children: [/*#__PURE__*/jsx$1(RiCheckboxFill, {}), /*#__PURE__*/jsx$1(Text, {
              variant: "paragraph-small",
              children: "You've successfuly moved your domain(s)."
            })]
          }), /*#__PURE__*/jsxs(_StyledStack$l, {
            padding: "32px 16px",
            gap: "24px",
            borderRadius: "large",
            border: "1px solid",
            borderColor: "primary-100",
            children: [/*#__PURE__*/jsx$1(Text, {
              variant: "paragraph-small",
              color: "neutral-500",
              children: "Domains Moved"
            }), moveResponse === null || moveResponse === void 0 ? void 0 : moveResponse.successfulDomains.map(function (movedDomain) {
              return /*#__PURE__*/jsx$1(Text, {
                fontWeight: "semi",
                color: "neutral-700",
                children: movedDomain
              });
            })]
          }), /*#__PURE__*/jsxs(_StyledBox$p, {
            padding: "32px 16px",
            gap: "80px",
            borderRadius: "large",
            border: "1px solid",
            borderColor: "primary-100",
            children: [/*#__PURE__*/jsxs(Stack$1, {
              gap: 2,
              children: [/*#__PURE__*/jsx$1(Text, {
                color: "neutral-500",
                variant: "paragraph-small",
                children: "From"
              }), /*#__PURE__*/jsxs(Text, {
                color: "neutral-700",
                fontWeight: "semi",
                children: [user.email, /*#__PURE__*/jsx$1("br", {}), user.company]
              })]
            }), /*#__PURE__*/jsxs(Stack$1, {
              gap: 2,
              children: [/*#__PURE__*/jsx$1(Text, {
                color: "neutral-500",
                variant: "paragraph-small",
                children: "To"
              }), /*#__PURE__*/jsxs(Text, {
                color: "neutral-700",
                fontWeight: "semi",
                children: [selectedUser.email, /*#__PURE__*/jsx$1("br", {}), selectedUser.company]
              })]
            }), /*#__PURE__*/jsxs(Stack$1, {
              gap: 2,
              children: [/*#__PURE__*/jsx$1(Text, {
                color: "neutral-500",
                variant: "paragraph-small",
                children: "Number of Domains"
              }), /*#__PURE__*/jsx$1(Text, {
                color: "neutral-700",
                fontWeight: "semi",
                children: moveResponse === null || moveResponse === void 0 ? void 0 : moveResponse.successfulDomains.length
              })]
            })]
          })]
        }) : /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx$1(Text, {
            color: "primary-700",
            children: "To move your domain to another customer, enter their user name or email in the search box."
          }), /*#__PURE__*/jsx$1(Box, {
            width: "50%",
            children: /*#__PURE__*/jsx$1(StyledInput, {
              value: input,
              onChange: function onChange(e) {
                return setInput(e.target.value);
              },
              placeholder: "it.support@gmail.com"
            })
          }), matchedUsers && matchedUsers.length > 0 && /*#__PURE__*/jsxs(Stack$1, {
            gap: 3,
            mt: 3,
            children: [/*#__PURE__*/jsx$1(Text, {
              color: "primary-700",
              children: "Here are the customer(s) we located:"
            }), /*#__PURE__*/jsxs(_StyledStack2$4, {
              border: "1px solid",
              borderColor: "primary-100",
              borderRadius: "large",
              padding: "32px 16px",
              children: [/*#__PURE__*/jsxs(Stack$1, {
                pb: "16px",
                mb: "16px",
                borderBottom: "1px solid",
                borderColor: "neutral-200",
                children: [/*#__PURE__*/jsx$1(Text, {
                  variant: "paragraph-small",
                  color: "neutral-500",
                  children: "Domain"
                }), domains.filter(function (d) {
                  return selected.includes(d.DomainID);
                }).map(function (d) {
                  return /*#__PURE__*/jsx$1(Text, {
                    color: "neutral-700",
                    fontWeight: "semi",
                    children: d.DomainName
                  }, d.DomainID);
                })]
              }), matchedUsers.map(function (matchedUser) {
                var id = matchedUser.id,
                    firstName = matchedUser.firstName,
                    lastName = matchedUser.lastName,
                    company = matchedUser.company;
                return /*#__PURE__*/jsxs(Box, {
                  justifyContent: "space-between",
                  my: 3,
                  children: [/*#__PURE__*/jsx$1(Checkbox$1, {
                    disabled: isLoading,
                    checked: (selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.id) === id,
                    onChange: function onChange() {
                      if ((selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.id) === id) {
                        setSelectedUser(undefined);
                      } else {
                        setSelectedUser(matchedUser);
                      }
                    }
                  }), /*#__PURE__*/jsxs(Stack$1, {
                    children: [/*#__PURE__*/jsx$1(Text, {
                      variant: "paragraph-small",
                      color: "neutral-500",
                      children: "Company Name"
                    }), /*#__PURE__*/jsx$1(Text, {
                      fontWeight: "semi",
                      color: "neutral-700",
                      children: company
                    })]
                  }), /*#__PURE__*/jsxs(Stack$1, {
                    children: [/*#__PURE__*/jsx$1(Text, {
                      variant: "paragraph-small",
                      color: "neutral-500",
                      children: "First Name"
                    }), /*#__PURE__*/jsx$1(Text, {
                      fontWeight: "semi",
                      color: "neutral-700",
                      children: firstName
                    })]
                  }), /*#__PURE__*/jsxs(Stack$1, {
                    children: [/*#__PURE__*/jsx$1(Text, {
                      variant: "paragraph-small",
                      color: "neutral-500",
                      children: "Last Name"
                    }), /*#__PURE__*/jsx$1(Text, {
                      fontWeight: "semi",
                      color: "neutral-700",
                      children: lastName
                    })]
                  })]
                }, matchedUser.id);
              })]
            })]
          }), selectedUser && /*#__PURE__*/jsx$1(Box, {
            color: "primary-700",
            children: /*#__PURE__*/jsxs(Text, {
              children: [/*#__PURE__*/jsx$1(Text, {
                fontWeight: "semi",
                children: "Please note: "
              }), "By moving your domain(s), you will not be able to transfer them to another registrar or edit the owner information for the next 60 days. If you wish to move the selected domain(s) to the account of the customer listed above, click the \"Confirm\" button below."]
            })
          }), /*#__PURE__*/jsx$1(Button, {
            disabled: Boolean(!selectedUser),
            variant: "secondary",
            width: "fit-content",
            loading: isLoading,
            mt: 3,
            onClick: function onClick() {
              if (selected.length > 0 && selectedUser) {
                moveDomains(selected, selectedUser.id);
              }
            },
            children: "Confirm"
          })]
        })
      })
    }), /*#__PURE__*/jsxs(Button, {
      variant: "minimal",
      onClick: function onClick() {
        if (selected.length > 0) {
          setIsModalOpen(true);
        }
      },
      px: 0,
      children: [/*#__PURE__*/jsx$1(RiShuffleLine, {}), /*#__PURE__*/jsx$1(Text, {
        fontWeight: "regular",
        children: "Move"
      })]
    })]
  });
}

var _StyledStack$l = styled(Stack$1)(_templateObject$A || (_templateObject$A = _taggedTemplateLiteral$1(["\n                  box-shadow: 0px 10px 15px -3px rgba(63, 57, 91, 0.1),\n                    0px 4px 6px -2px rgba(63, 57, 91, 0.05);\n                "])));

var _StyledBox$p = styled(Box)(_templateObject2$m || (_templateObject2$m = _taggedTemplateLiteral$1(["\n                  box-shadow: 0px 10px 15px -3px rgba(63, 57, 91, 0.1),\n                    0px 4px 6px -2px rgba(63, 57, 91, 0.05);\n                "])));

var _StyledStack2$4 = styled(Stack$1).withConfig({
  displayName: "move-button___StyledStack2",
  componentId: "sc-nhddl1-0"
})(["box-shadow:0px 10px 15px -3px rgba(63,57,91,0.1),0px 4px 6px -2px rgba(63,57,91,0.05);"]);

function _regenerator$1m() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1m(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1m(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1m(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1m(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1m(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1m(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1m(u), _regeneratorDefine2$1m(u, o, "Generator"), _regeneratorDefine2$1m(u, n, function () {
    return this;
  }), _regeneratorDefine2$1m(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1m = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1m(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1m = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1m(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1m(e, r, n, t);
}

function PortfolioButton$1(_ref) {
  var _targettablePortfolio;

  var selected = _ref.selected;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useDomains = useDomains(),
      portfolios = _useDomains.portfolios,
      refreshDomains = _useDomains.refreshDomains;

  var targettablePortfolios = portfolios.available.filter(function (p) {
    var _portfolios$active;

    return p.id !== ((_portfolios$active = portfolios.active) === null || _portfolios$active === void 0 ? void 0 : _portfolios$active.id);
  });

  var _useState3 = useState((_targettablePortfolio = targettablePortfolios[0]) === null || _targettablePortfolio === void 0 ? void 0 : _targettablePortfolio.id),
      _useState4 = _slicedToArray$4(_useState3, 2),
      selectedPortfolioId = _useState4[0],
      setSelectedPortfolioId = _useState4[1];

  var _useMutation = useMutation$1({
    fn: api.domains.moveToPortfolio,
    successMessage: "Moved ".concat(selected.length, " domains to portfolio."),
    onSuccess: function () {
      var _onSuccess = _asyncToGenerator( /*#__PURE__*/_regenerator$1m().m(function _callee() {
        return _regenerator$1m().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.n = 1;
                return refreshDomains();

              case 1:
                setIsOpen(false);

              case 2:
                return _context.a(2);
            }
          }
        }, _callee);
      }));

      function onSuccess() {
        return _onSuccess.apply(this, arguments);
      }

      return onSuccess;
    }()
  }),
      isLoading = _useMutation.isLoading,
      moveToPortfolio = _useMutation.mutate;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(Button, {
      px: 0,
      variant: "minimal",
      onClick: function onClick() {
        if (portfolios.available.length > 1 && selected.length > 0) {
          setIsOpen(true);
        }
      },
      children: [/*#__PURE__*/jsx$1(RiAddLine, {}), /*#__PURE__*/jsx$1(Text, {
        fontWeight: "regular",
        children: "Add to Portfolio"
      })]
    }), /*#__PURE__*/jsx$1(Modal, {
      isOpen: isOpen,
      onClose: function onClose() {
        return setIsOpen(false);
      },
      title: "Add to portfolio",
      children: /*#__PURE__*/jsxs(Stack$1, {
        gap: 5,
        minWidth: ['300px', '400px', '500px'],
        children: [/*#__PURE__*/jsxs(Stack$1, {
          gap: 2,
          children: [/*#__PURE__*/jsx$1(Text, {
            variant: "paragraph-small",
            color: "neutral-500",
            children: "Portfolio name"
          }), /*#__PURE__*/jsx$1(Dropdown$1, {
            onChange: function onChange(e) {
              return setSelectedPortfolioId(Number(e === null || e === void 0 ? void 0 : e.value));
            },
            options: targettablePortfolios.map(function (p) {
              return {
                value: String(p.id),
                label: "".concat(p.name, " (").concat(p.count, ")")
              };
            })
          })]
        }), /*#__PURE__*/jsx$1(Button, {
          width: "fit-content",
          variant: "secondary",
          loading: isLoading,
          onClick: function onClick() {
            if (selectedPortfolioId && selected.length > 0) {
              moveToPortfolio(selectedPortfolioId, selected);
            }
          },
          children: "Save changes"
        })]
      })
    })]
  });
}

function RenewButton(_ref) {
  var selected = _ref.selected;

  var _useMutation = useMutation$1({
    fn: api.domains.renew,
    successMessage: "Successfully renewed ".concat(selected.length, " domains."),
    failureMessage: 'Failed to renew domains.',
    onSuccess: function onSuccess() {
      window.location.href = '/checkout';
    }
  }),
      isLoading = _useMutation.isLoading,
      renewDomains = _useMutation.mutate;

  return /*#__PURE__*/jsxs(Button, {
    px: 0,
    variant: "minimal",
    loading: isLoading,
    onClick: function onClick() {
      if (selected.length > 0) {
        renewDomains(selected);
      }
    },
    children: [/*#__PURE__*/jsx$1(RiRefreshLine, {}), /*#__PURE__*/jsx$1(Text, {
      fontWeight: "regular",
      children: "Renew"
    })]
  });
}

function ActionsBar(_ref) {
  var selected = _ref.selected,
      domains = _ref.domains;
  return /*#__PURE__*/jsxs(Box, {
    gap: 2,
    children: [/*#__PURE__*/jsx$1(RenewButton, {
      selected: selected
    }), /*#__PURE__*/jsx$1(MoveButton, {
      selected: selected,
      domains: domains
    }), /*#__PURE__*/jsx$1(PortfolioButton$1, {
      selected: selected
    }), /*#__PURE__*/jsx$1(ExportButton, {
      domains: domains,
      selected: selected
    })]
  });
}

var _excluded$J = ["to", "text"];

function ownKeys$1H(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1H(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1H(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1H(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function BackButton$1(_ref) {
  var to = _ref.to,
      text = _ref.text,
      props = _objectWithoutProperties$8(_ref, _excluded$J);

  return /*#__PURE__*/jsx$1(Link, {
    to: to,
    children: /*#__PURE__*/jsxs(Button, _objectSpread$1H(_objectSpread$1H({
      variant: "minimal",
      alignItems: "center",
      fontWeight: "semi",
      gap: 3,
      p: 0
    }, props), {}, {
      children: [/*#__PURE__*/jsx$1(Box, {
        alignItems: "center",
        justifyContent: "center",
        color: "primary-600",
        children: /*#__PURE__*/jsx$1(RiArrowLeftCircleFill, {
          size: 40
        })
      }), /*#__PURE__*/jsx$1(Text, {
        color: "primary-700",
        style: {
          textDecoration: 'underline'
        },
        children: text
      })]
    }))
  });
}
/** Fetches the domain from the path param /:domainName/, can also pass in a domainId directly */


function useQueryDomain(domainName) {
  var _useDomains = useDomains(),
      domains = _useDomains.domains,
      showAll = _useDomains.showAll;

  var params = useParams();
  useEffect(function () {
    showAll === null || showAll === void 0 ? void 0 : showAll();
  }, [showAll]);
  var domain = useMemo(function () {
    if (domainName) {
      return domains === null || domains === void 0 ? void 0 : domains.find(function (_ref) {
        var DomainName = _ref.DomainName;
        return DomainName.toLowerCase() === domainName;
      });
    }

    return domains === null || domains === void 0 ? void 0 : domains.find(function (_ref2) {
      var DomainName = _ref2.DomainName;
      return DomainName.toLowerCase() === params.domainName;
    });
  }, [params, domains, domainName]);
  return {
    domain: domain
  };
}

function DomainContacts() {
  var _useQueryDomain = useQueryDomain(),
      domain = _useQueryDomain.domain;

  if (!domain) {
    return /*#__PURE__*/jsx$1(Skeleton, {
      borderRadius: "base",
      height: "400px"
    });
  }

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Header$1, {
      children: /*#__PURE__*/jsx$1(BackButton$1, {
        text: "Back to Domain Manager",
        to: "".concat(BASEPATH, "/managers/domains")
      })
    }), /*#__PURE__*/jsx$1(Tabs, {
      tabs: TABS.domainOptions(domain.DomainName)
    }), /*#__PURE__*/jsxs("h1", {
      children: ["Contacts ", domain.DomainName]
    })]
  });
}

var DnsTypes = /*#__PURE__*/function (DnsTypes) {
  DnsTypes["Parked"] = "Parked";
  DnsTypes["ThirdPartyHosting"] = "ThirdPartyHosting";
  DnsTypes["Forwarding"] = "Forwarding";
  DnsTypes["Hosted"] = "Hosted";
  DnsTypes["Expired"] = "Expired";
  DnsTypes["Deleted"] = "Deleted";
  DnsTypes["Weebly"] = "Weebly";
  DnsTypes["WeeblyAndEmail"] = "WeeblyAndEmail";
  DnsTypes["ParkedDefault"] = "ParkedDefault";
  DnsTypes["Plesk"] = "Plesk";
  DnsTypes["CloudEmail"] = "CloudEmail";
  DnsTypes["CloudEmailAndWeebly"] = "CloudEmailAndWeebly";
  return DnsTypes;
}({});

var DnsRecordTypes = /*#__PURE__*/function (DnsRecordTypes) {
  DnsRecordTypes["A"] = "A";
  DnsRecordTypes["CNAME"] = "CNAME";
  DnsRecordTypes["MX"] = "MX";
  DnsRecordTypes["NS"] = "NS";
  DnsRecordTypes["TXT"] = "TXT";
  DnsRecordTypes["SPF"] = "SPF";
  DnsRecordTypes["SRV"] = "SRV";
  DnsRecordTypes["AAAA"] = "AAAA";
  DnsRecordTypes["CAA"] = "CAA";
  return DnsRecordTypes;
}({});

var isCheckBoxInput = function isCheckBoxInput(element) {
  return element.type === 'checkbox';
};

var isDateObject = function isDateObject(value) {
  return value instanceof Date;
};

var isNullOrUndefined = function isNullOrUndefined(value) {
  return value == null;
};

var isObjectType = function isObjectType(value) {
  return typeof value === 'object';
};

var isObject$4 = function isObject$4(value) {
  return !isNullOrUndefined(value) && !Array.isArray(value) && isObjectType(value) && !isDateObject(value);
};

var getEventValue = function getEventValue(event) {
  return isObject$4(event) && event.target ? isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
};

var getNodeParentName = function getNodeParentName(name) {
  return name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
};

var isNameInFieldArray = function isNameInFieldArray(names, name) {
  return names.has(getNodeParentName(name));
};

var isPlainObject$1 = function isPlainObject$1(tempObject) {
  var prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
  return isObject$4(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};

var isWeb = typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined' && typeof document !== 'undefined';

function cloneObject$1(data) {
  var copy;
  var isArray = Array.isArray(data);
  var isFileListInstance = typeof FileList !== 'undefined' ? data instanceof FileList : false;

  if (data instanceof Date) {
    copy = new Date(data);
  } else if (!(isWeb && (data instanceof Blob || isFileListInstance)) && (isArray || isObject$4(data))) {
    copy = isArray ? [] : {};

    if (!isArray && !isPlainObject$1(data)) {
      copy = data;
    } else {
      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          copy[key] = cloneObject$1(data[key]);
        }
      }
    }
  } else {
    return data;
  }

  return copy;
}

var isKey = function isKey(value) {
  return /^\w*$/.test(value);
};

var isUndefined = function isUndefined(val) {
  return val === undefined;
};

var compact$1 = function compact$1(value) {
  return Array.isArray(value) ? value.filter(Boolean) : [];
};

var stringToPath$2 = function stringToPath$2(input) {
  return compact$1(input.replace(/["|']|\]/g, '').split(/\.|\[/));
};

var _get2 = function get(object, path, defaultValue) {
  if (!path || !isObject$4(object)) {
    return defaultValue;
  }

  var result = (isKey(path) ? [path] : stringToPath$2(path)).reduce(function (result, key) {
    return isNullOrUndefined(result) ? result : result[key];
  }, object);
  return isUndefined(result) || result === object ? isUndefined(object[path]) ? defaultValue : object[path] : result;
};

var isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};

var set$1 = function set$1(object, path, value) {
  var index = -1;
  var tempPath = isKey(path) ? [path] : stringToPath$2(path);
  var length = tempPath.length;
  var lastIndex = length - 1;

  while (++index < length) {
    var key = tempPath[index];
    var newValue = value;

    if (index !== lastIndex) {
      var objValue = object[key];
      newValue = isObject$4(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
    }

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return;
    }

    object[key] = newValue;
    object = object[key];
  }
};

var EVENTS$1 = {
  BLUR: 'blur',
  FOCUS_OUT: 'focusout',
  CHANGE: 'change'
};
var VALIDATION_MODE = {
  onBlur: 'onBlur',
  onChange: 'onChange',
  onSubmit: 'onSubmit',
  onTouched: 'onTouched',
  all: 'all'
};
var INPUT_VALIDATION_RULES = {
  max: 'max',
  min: 'min',
  maxLength: 'maxLength',
  minLength: 'minLength',
  pattern: 'pattern',
  required: 'required',
  validate: 'validate'
};
var HookFormContext = React__default.createContext(null);
HookFormContext.displayName = 'HookFormContext';
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */

var useFormContext = function useFormContext() {
  return React__default.useContext(HookFormContext);
};
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */


var FormProvider = function FormProvider(props) {
  var children = props.children,
      data = _objectWithoutProperties2(props, _excluded4);

  return React__default.createElement(HookFormContext.Provider, {
    value: data
  }, children);
};

var getProxyFormState = function getProxyFormState(formState, control, localProxyFormState) {
  var isRoot = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var result = {
    defaultValues: control._defaultValues
  };

  var _loop2 = function _loop2(key) {
    Object.defineProperty(result, key, {
      get: function get() {
        var _key = key;

        if (control._proxyFormState[_key] !== VALIDATION_MODE.all) {
          control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
        }

        localProxyFormState && (localProxyFormState[_key] = true);
        return formState[_key];
      }
    });
  };

  for (var key in formState) {
    _loop2(key);
  }

  return result;
};

var useIsomorphicLayoutEffect$1 = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */

function useFormState(props) {
  var methods = useFormContext();

  var _ref39 = props || {},
      _ref39$control = _ref39.control,
      control = _ref39$control === void 0 ? methods.control : _ref39$control,
      disabled = _ref39.disabled,
      name = _ref39.name,
      exact = _ref39.exact;

  var _React__default$useSt = React__default.useState(control._formState),
      _React__default$useSt2 = _slicedToArray2(_React__default$useSt, 2),
      formState = _React__default$useSt2[0],
      updateFormState = _React__default$useSt2[1];

  var _localProxyFormState = React__default.useRef({
    isDirty: false,
    isLoading: false,
    dirtyFields: false,
    touchedFields: false,
    validatingFields: false,
    isValidating: false,
    isValid: false,
    errors: false
  });

  useIsomorphicLayoutEffect$1(function () {
    return control._subscribe({
      name: name,
      formState: _localProxyFormState.current,
      exact: exact,
      callback: function callback(formState) {
        !disabled && updateFormState(_objectSpread3(_objectSpread3({}, control._formState), formState));
      }
    });
  }, [name, disabled, exact]);
  React__default.useEffect(function () {
    _localProxyFormState.current.isValid && control._setValid(true);
  }, [control]);
  return React__default.useMemo(function () {
    return getProxyFormState(formState, control, _localProxyFormState.current, false);
  }, [formState, control]);
}

var isString$1 = function isString$1(value) {
  return typeof value === 'string';
};

var generateWatchOutput = function generateWatchOutput(names, _names, formValues, isGlobal, defaultValue) {
  if (isString$1(names)) {
    isGlobal && _names.watch.add(names);
    return _get2(formValues, names, defaultValue);
  }

  if (Array.isArray(names)) {
    return names.map(function (fieldName) {
      return isGlobal && _names.watch.add(fieldName), _get2(formValues, fieldName);
    });
  }

  isGlobal && (_names.watchAll = true);
  return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */


function useWatch(props) {
  var methods = useFormContext();

  var _ref40 = props || {},
      _ref40$control = _ref40.control,
      control = _ref40$control === void 0 ? methods.control : _ref40$control,
      name = _ref40.name,
      defaultValue = _ref40.defaultValue,
      disabled = _ref40.disabled,
      exact = _ref40.exact;

  var _defaultValue = React__default.useRef(defaultValue);

  var _React__default$useSt3 = React__default.useState(control._getWatch(name, _defaultValue.current)),
      _React__default$useSt4 = _slicedToArray2(_React__default$useSt3, 2),
      value = _React__default$useSt4[0],
      updateValue = _React__default$useSt4[1];

  useIsomorphicLayoutEffect$1(function () {
    return control._subscribe({
      name: name,
      formState: {
        values: true
      },
      exact: exact,
      callback: function callback(formState) {
        return !disabled && updateValue(generateWatchOutput(name, control._names, formState.values || control._formValues, false, _defaultValue.current));
      }
    });
  }, [name, control, disabled, exact]);
  React__default.useEffect(function () {
    return control._removeUnmounted();
  });
  return value;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */


function useController(props) {
  var methods = useFormContext();
  var name = props.name,
      disabled = props.disabled,
      _props$control = props.control,
      control = _props$control === void 0 ? methods.control : _props$control,
      shouldUnregister = props.shouldUnregister;
  var isArrayField = isNameInFieldArray(control._names.array, name);
  var value = useWatch({
    control: control,
    name: name,
    defaultValue: _get2(control._formValues, name, _get2(control._defaultValues, name, props.defaultValue)),
    exact: true
  });
  var formState = useFormState({
    control: control,
    name: name,
    exact: true
  });

  var _props = React__default.useRef(props);

  var _registerProps = React__default.useRef(control.register(name, _objectSpread3(_objectSpread3({}, props.rules), {}, {
    value: value
  }, isBoolean(props.disabled) ? {
    disabled: props.disabled
  } : {})));

  var fieldState = React__default.useMemo(function () {
    return Object.defineProperties({}, {
      invalid: {
        enumerable: true,
        get: function get() {
          return !!_get2(formState.errors, name);
        }
      },
      isDirty: {
        enumerable: true,
        get: function get() {
          return !!_get2(formState.dirtyFields, name);
        }
      },
      isTouched: {
        enumerable: true,
        get: function get() {
          return !!_get2(formState.touchedFields, name);
        }
      },
      isValidating: {
        enumerable: true,
        get: function get() {
          return !!_get2(formState.validatingFields, name);
        }
      },
      error: {
        enumerable: true,
        get: function get() {
          return _get2(formState.errors, name);
        }
      }
    });
  }, [formState, name]);
  var onChange = React__default.useCallback(function (event) {
    return _registerProps.current.onChange({
      target: {
        value: getEventValue(event),
        name: name
      },
      type: EVENTS$1.CHANGE
    });
  }, [name]);
  var onBlur = React__default.useCallback(function () {
    return _registerProps.current.onBlur({
      target: {
        value: _get2(control._formValues, name),
        name: name
      },
      type: EVENTS$1.BLUR
    });
  }, [name, control._formValues]);
  var ref = React__default.useCallback(function (elm) {
    var field = _get2(control._fields, name);

    if (field && elm) {
      field._f.ref = {
        focus: function focus() {
          return elm.focus && elm.focus();
        },
        select: function select() {
          return elm.select && elm.select();
        },
        setCustomValidity: function setCustomValidity(message) {
          return elm.setCustomValidity(message);
        },
        reportValidity: function reportValidity() {
          return elm.reportValidity();
        }
      };
    }
  }, [control._fields, name]);
  var field = React__default.useMemo(function () {
    return _objectSpread3(_objectSpread3({
      name: name,
      value: value
    }, isBoolean(disabled) || formState.disabled ? {
      disabled: formState.disabled || disabled
    } : {}), {}, {
      onChange: onChange,
      onBlur: onBlur,
      ref: ref
    });
  }, [name, disabled, formState.disabled, onChange, onBlur, ref, value]);
  React__default.useEffect(function () {
    var _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;

    control.register(name, _objectSpread3(_objectSpread3({}, _props.current.rules), isBoolean(_props.current.disabled) ? {
      disabled: _props.current.disabled
    } : {}));

    var updateMounted = function updateMounted(name, value) {
      var field = _get2(control._fields, name);

      if (field && field._f) {
        field._f.mount = value;
      }
    };

    updateMounted(name, true);

    if (_shouldUnregisterField) {
      var _value3 = cloneObject$1(_get2(control._options.defaultValues, name));

      set$1(control._defaultValues, name, _value3);

      if (isUndefined(_get2(control._formValues, name))) {
        set$1(control._formValues, name, _value3);
      }
    }

    !isArrayField && control.register(name);
    return function () {
      (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
    };
  }, [name, control, isArrayField, shouldUnregister]);
  React__default.useEffect(function () {
    control._setDisabledField({
      disabled: disabled,
      name: name
    });
  }, [disabled, name, control]);
  return React__default.useMemo(function () {
    return {
      field: field,
      formState: formState,
      fieldState: fieldState
    };
  }, [field, formState, fieldState]);
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */


var Controller = function Controller(props) {
  return props.render(useController(props));
};

var appendErrors = function appendErrors(name, validateAllFieldCriteria, errors, type, message) {
  return validateAllFieldCriteria ? _objectSpread3(_objectSpread3({}, errors[name]), {}, {
    types: _objectSpread3(_objectSpread3({}, errors[name] && errors[name].types ? errors[name].types : {}), {}, _defineProperty2({}, type, message || true))
  }) : {};
};

var convertToArrayPayload = function convertToArrayPayload(value) {
  return Array.isArray(value) ? value : [value];
};

var createSubject = function createSubject() {
  var _observers = [];

  var next = function next(value) {
    var _iterator3 = _createForOfIteratorHelper(_observers),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var observer = _step3.value;
        observer.next && observer.next(value);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  };

  var subscribe = function subscribe(observer) {
    _observers.push(observer);

    return {
      unsubscribe: function unsubscribe() {
        _observers = _observers.filter(function (o) {
          return o !== observer;
        });
      }
    };
  };

  var unsubscribe = function unsubscribe() {
    _observers = [];
  };

  return {
    get observers() {
      return _observers;
    },

    next: next,
    subscribe: subscribe,
    unsubscribe: unsubscribe
  };
};

var isPrimitive = function isPrimitive(value) {
  return isNullOrUndefined(value) || !isObjectType(value);
};

function deepEqual(object1, object2) {
  var _internal_visited = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new WeakSet();

  if (isPrimitive(object1) || isPrimitive(object2)) {
    return object1 === object2;
  }

  if (isDateObject(object1) && isDateObject(object2)) {
    return object1.getTime() === object2.getTime();
  }

  var keys1 = Object.keys(object1);
  var keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  if (_internal_visited.has(object1) || _internal_visited.has(object2)) {
    return true;
  }

  _internal_visited.add(object1);

  _internal_visited.add(object2);

  for (var _i13 = 0, _keys = keys1; _i13 < _keys.length; _i13++) {
    var key = _keys[_i13];
    var val1 = object1[key];

    if (!keys2.includes(key)) {
      return false;
    }

    if (key !== 'ref') {
      var val2 = object2[key];

      if (isDateObject(val1) && isDateObject(val2) || isObject$4(val1) && isObject$4(val2) || Array.isArray(val1) && Array.isArray(val2) ? !deepEqual(val1, val2, _internal_visited) : val1 !== val2) {
        return false;
      }
    }
  }

  return true;
}

var isEmptyObject = function isEmptyObject(value) {
  return isObject$4(value) && !Object.keys(value).length;
};

var isFileInput = function isFileInput(element) {
  return element.type === 'file';
};

var isFunction$2 = function isFunction$2(value) {
  return typeof value === 'function';
};

var isHTMLElement = function isHTMLElement(value) {
  if (!isWeb) {
    return false;
  }

  var owner = value ? value.ownerDocument : 0;
  return value instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};

var isMultipleSelect = function isMultipleSelect(element) {
  return element.type === "select-multiple";
};

var isRadioInput = function isRadioInput(element) {
  return element.type === 'radio';
};

var isRadioOrCheckbox = function isRadioOrCheckbox(ref) {
  return isRadioInput(ref) || isCheckBoxInput(ref);
};

var live = function live(ref) {
  return isHTMLElement(ref) && ref.isConnected;
};

function baseGet(object, updatePath) {
  var length = updatePath.slice(0, -1).length;
  var index = 0;

  while (index < length) {
    object = isUndefined(object) ? index++ : object[updatePath[index++]];
  }

  return object;
}

function isEmptyArray(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key) && !isUndefined(obj[key])) {
      return false;
    }
  }

  return true;
}

function unset(object, path) {
  var paths = Array.isArray(path) ? path : isKey(path) ? [path] : stringToPath$2(path);
  var childObject = paths.length === 1 ? object : baseGet(object, paths);
  var index = paths.length - 1;
  var key = paths[index];

  if (childObject) {
    delete childObject[key];
  }

  if (index !== 0 && (isObject$4(childObject) && isEmptyObject(childObject) || Array.isArray(childObject) && isEmptyArray(childObject))) {
    unset(object, paths.slice(0, -1));
  }

  return object;
}

var objectHasFunction = function objectHasFunction(data) {
  for (var key in data) {
    if (isFunction$2(data[key])) {
      return true;
    }
  }

  return false;
};

function markFieldsDirty(data) {
  var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isParentNodeArray = Array.isArray(data);

  if (isObject$4(data) || isParentNodeArray) {
    for (var key in data) {
      if (Array.isArray(data[key]) || isObject$4(data[key]) && !objectHasFunction(data[key])) {
        fields[key] = Array.isArray(data[key]) ? [] : {};
        markFieldsDirty(data[key], fields[key]);
      } else if (!isNullOrUndefined(data[key])) {
        fields[key] = true;
      }
    }
  }

  return fields;
}

function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
  var isParentNodeArray = Array.isArray(data);

  if (isObject$4(data) || isParentNodeArray) {
    for (var key in data) {
      if (Array.isArray(data[key]) || isObject$4(data[key]) && !objectHasFunction(data[key])) {
        if (isUndefined(formValues) || isPrimitive(dirtyFieldsFromValues[key])) {
          dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? markFieldsDirty(data[key], []) : _objectSpread3({}, markFieldsDirty(data[key]));
        } else {
          getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        }
      } else {
        dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
      }
    }
  }

  return dirtyFieldsFromValues;
}

var getDirtyFields = function getDirtyFields(defaultValues, formValues) {
  return getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));
};

var defaultResult = {
  value: false,
  isValid: false
};
var validResult = {
  value: true,
  isValid: true
};

var getCheckboxValue = function getCheckboxValue(options) {
  if (Array.isArray(options)) {
    if (options.length > 1) {
      var values = options.filter(function (option) {
        return option && option.checked && !option.disabled;
      }).map(function (option) {
        return option.value;
      });
      return {
        value: values,
        isValid: !!values.length
      };
    }

    return options[0].checked && !options[0].disabled ? // @ts-expect-error expected to work in the browser
    options[0].attributes && !isUndefined(options[0].attributes.value) ? isUndefined(options[0].value) || options[0].value === '' ? validResult : {
      value: options[0].value,
      isValid: true
    } : validResult : defaultResult;
  }

  return defaultResult;
};

var getFieldValueAs = function getFieldValueAs(value, _ref41) {
  var valueAsNumber = _ref41.valueAsNumber,
      valueAsDate = _ref41.valueAsDate,
      setValueAs = _ref41.setValueAs;
  return isUndefined(value) ? value : valueAsNumber ? value === '' ? NaN : value ? +value : value : valueAsDate && isString$1(value) ? new Date(value) : setValueAs ? setValueAs(value) : value;
};

var defaultReturn = {
  isValid: false,
  value: null
};

var getRadioValue = function getRadioValue(options) {
  return Array.isArray(options) ? options.reduce(function (previous, option) {
    return option && option.checked && !option.disabled ? {
      isValid: true,
      value: option.value
    } : previous;
  }, defaultReturn) : defaultReturn;
};

function getFieldValue(_f) {
  var ref = _f.ref;

  if (isFileInput(ref)) {
    return ref.files;
  }

  if (isRadioInput(ref)) {
    return getRadioValue(_f.refs).value;
  }

  if (isMultipleSelect(ref)) {
    return _toConsumableArray2(ref.selectedOptions).map(function (_ref42) {
      var value = _ref42.value;
      return value;
    });
  }

  if (isCheckBoxInput(ref)) {
    return getCheckboxValue(_f.refs).value;
  }

  return getFieldValueAs(isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}

var getResolverOptions = function getResolverOptions(fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) {
  var fields = {};

  var _iterator4 = _createForOfIteratorHelper(fieldsNames),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var name = _step4.value;

      var field = _get2(_fields, name);

      field && set$1(fields, name, field._f);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return {
    criteriaMode: criteriaMode,
    names: _toConsumableArray2(fieldsNames),
    fields: fields,
    shouldUseNativeValidation: shouldUseNativeValidation
  };
};

var isRegex = function isRegex(value) {
  return value instanceof RegExp;
};

var getRuleValue = function getRuleValue(rule) {
  return isUndefined(rule) ? rule : isRegex(rule) ? rule.source : isObject$4(rule) ? isRegex(rule.value) ? rule.value.source : rule.value : rule;
};

var getValidationModes = function getValidationModes(mode) {
  return {
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched
  };
};

var ASYNC_FUNCTION = 'AsyncFunction';

var hasPromiseValidation = function hasPromiseValidation(fieldReference) {
  return !!fieldReference && !!fieldReference.validate && !!(isFunction$2(fieldReference.validate) && fieldReference.validate.constructor.name === ASYNC_FUNCTION || isObject$4(fieldReference.validate) && Object.values(fieldReference.validate).find(function (validateFunction) {
    return validateFunction.constructor.name === ASYNC_FUNCTION;
  }));
};

var hasValidation = function hasValidation(options) {
  return options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
};

var isWatched = function isWatched(name, _names, isBlurEvent) {
  return !isBlurEvent && (_names.watchAll || _names.watch.has(name) || _toConsumableArray2(_names.watch).some(function (watchName) {
    return name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length));
  }));
};

var iterateFieldsByAction = function iterateFieldsByAction(fields, action, fieldsNames, abortEarly) {
  var _iterator5 = _createForOfIteratorHelper(fieldsNames || Object.keys(fields)),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var key = _step5.value;

      var field = _get2(fields, key);

      if (field) {
        var _f = field._f,
            currentField = _objectWithoutProperties2(field, _excluded5);

        if (_f) {
          if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) {
            return true;
          } else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) {
            return true;
          } else {
            if (iterateFieldsByAction(currentField, action)) {
              break;
            }
          }
        } else if (isObject$4(currentField)) {
          if (iterateFieldsByAction(currentField, action)) {
            break;
          }
        }
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  return;
};

function schemaErrorLookup(errors, _fields, name) {
  var error = _get2(errors, name);

  if (error || isKey(name)) {
    return {
      error: error,
      name: name
    };
  }

  var names = name.split('.');

  while (names.length) {
    var fieldName = names.join('.');

    var field = _get2(_fields, fieldName);

    var foundError = _get2(errors, fieldName);

    if (field && !Array.isArray(field) && name !== fieldName) {
      return {
        name: name
      };
    }

    if (foundError && foundError.type) {
      return {
        name: fieldName,
        error: foundError
      };
    }

    if (foundError && foundError.root && foundError.root.type) {
      return {
        name: "".concat(fieldName, ".root"),
        error: foundError.root
      };
    }

    names.pop();
  }

  return {
    name: name
  };
}

var shouldRenderFormState = function shouldRenderFormState(formStateData, _proxyFormState, updateFormState, isRoot) {
  updateFormState(formStateData);

  var name = formStateData.name,
      formState = _objectWithoutProperties2(formStateData, _excluded6);

  return isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find(function (key) {
    return _proxyFormState[key] === (!isRoot || VALIDATION_MODE.all);
  });
};

var shouldSubscribeByName = function shouldSubscribeByName(name, signalName, exact) {
  return !name || !signalName || name === signalName || convertToArrayPayload(name).some(function (currentName) {
    return currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName));
  });
};

var skipValidation = function skipValidation(isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) {
  if (mode.isOnAll) {
    return false;
  } else if (!isSubmitted && mode.isOnTouch) {
    return !(isTouched || isBlurEvent);
  } else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
    return !isBlurEvent;
  } else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
    return isBlurEvent;
  }

  return true;
};

var unsetEmptyArray = function unsetEmptyArray(ref, name) {
  return !compact$1(_get2(ref, name)).length && unset(ref, name);
};

var updateFieldArrayRootError = function updateFieldArrayRootError(errors, error, name) {
  var fieldArrayErrors = convertToArrayPayload(_get2(errors, name));
  set$1(fieldArrayErrors, 'root', error[name]);
  set$1(errors, name, fieldArrayErrors);
  return errors;
};

var isMessage = function isMessage(value) {
  return isString$1(value);
};

function getValidateError(result, ref) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'validate';

  if (isMessage(result) || Array.isArray(result) && result.every(isMessage) || isBoolean(result) && !result) {
    return {
      type: type,
      message: isMessage(result) ? result : '',
      ref: ref
    };
  }
}

var getValueAndMessage = function getValueAndMessage(validationData) {
  return isObject$4(validationData) && !isRegex(validationData) ? validationData : {
    value: validationData,
    message: ''
  };
};

var validateField = /*#__PURE__*/function () {
  var _ref43 = _asyncToGenerator2( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(field, disabledFieldNames, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) {
    var _field$_f, ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, inputValue, inputRef, setCustomValidity, error, isRadio, isCheckBox, isRadioOrCheckbox, isEmpty, appendErrorsCurry, getMinMaxMessage, _ref44, value, message, exceedMax, exceedMin, maxOutput, minOutput, valueNumber, valueDate, convertTimeToDate, isTime, isWeek, maxLengthOutput, minLengthOutput, _exceedMax, _exceedMin, _getValueAndMessage, patternValue, _message2, result, validateError, validationResult, key, _validateError;

    return _regeneratorRuntime.wrap(function _callee11$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _field$_f = field._f, ref = _field$_f.ref, refs = _field$_f.refs, required = _field$_f.required, maxLength = _field$_f.maxLength, minLength = _field$_f.minLength, min = _field$_f.min, max = _field$_f.max, pattern = _field$_f.pattern, validate = _field$_f.validate, name = _field$_f.name, valueAsNumber = _field$_f.valueAsNumber, mount = _field$_f.mount;
            inputValue = _get2(formValues, name);

            if (!(!mount || disabledFieldNames.has(name))) {
              _context12.next = 4;
              break;
            }

            return _context12.abrupt("return", {});

          case 4:
            inputRef = refs ? refs[0] : ref;

            setCustomValidity = function setCustomValidity(message) {
              if (shouldUseNativeValidation && inputRef.reportValidity) {
                inputRef.setCustomValidity(isBoolean(message) ? '' : message || '');
                inputRef.reportValidity();
              }
            };

            error = {};
            isRadio = isRadioInput(ref);
            isCheckBox = isCheckBoxInput(ref);
            isRadioOrCheckbox = isRadio || isCheckBox;
            isEmpty = (valueAsNumber || isFileInput(ref)) && isUndefined(ref.value) && isUndefined(inputValue) || isHTMLElement(ref) && ref.value === '' || inputValue === '' || Array.isArray(inputValue) && !inputValue.length;
            appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);

            getMinMaxMessage = function getMinMaxMessage(exceedMax, maxLengthMessage, minLengthMessage) {
              var maxType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : INPUT_VALIDATION_RULES.maxLength;
              var minType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : INPUT_VALIDATION_RULES.minLength;
              var message = exceedMax ? maxLengthMessage : minLengthMessage;
              error[name] = _objectSpread3({
                type: exceedMax ? maxType : minType,
                message: message,
                ref: ref
              }, appendErrorsCurry(exceedMax ? maxType : minType, message));
            };

            if (!(isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue)) || isBoolean(inputValue) && !inputValue || isCheckBox && !getCheckboxValue(refs).isValid || isRadio && !getRadioValue(refs).isValid))) {
              _context12.next = 20;
              break;
            }

            _ref44 = isMessage(required) ? {
              value: !!required,
              message: required
            } : getValueAndMessage(required), value = _ref44.value, message = _ref44.message;

            if (!value) {
              _context12.next = 20;
              break;
            }

            error[name] = _objectSpread3({
              type: INPUT_VALIDATION_RULES.required,
              message: message,
              ref: inputRef
            }, appendErrorsCurry(INPUT_VALIDATION_RULES.required, message));

            if (validateAllFieldCriteria) {
              _context12.next = 20;
              break;
            }

            setCustomValidity(message);
            return _context12.abrupt("return", error);

          case 20:
            if (!(!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max)))) {
              _context12.next = 29;
              break;
            }

            maxOutput = getValueAndMessage(max);
            minOutput = getValueAndMessage(min);

            if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
              valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);

              if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
              }

              if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
              }
            } else {
              valueDate = ref.valueAsDate || new Date(inputValue);

              convertTimeToDate = function convertTimeToDate(time) {
                return new Date(new Date().toDateString() + ' ' + time);
              };

              isTime = ref.type == 'time';
              isWeek = ref.type == 'week';

              if (isString$1(maxOutput.value) && inputValue) {
                exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
              }

              if (isString$1(minOutput.value) && inputValue) {
                exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
              }
            }

            if (!(exceedMax || exceedMin)) {
              _context12.next = 29;
              break;
            }

            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);

            if (validateAllFieldCriteria) {
              _context12.next = 29;
              break;
            }

            setCustomValidity(error[name].message);
            return _context12.abrupt("return", error);

          case 29:
            if (!((maxLength || minLength) && !isEmpty && (isString$1(inputValue) || isFieldArray && Array.isArray(inputValue)))) {
              _context12.next = 39;
              break;
            }

            maxLengthOutput = getValueAndMessage(maxLength);
            minLengthOutput = getValueAndMessage(minLength);
            _exceedMax = !isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
            _exceedMin = !isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;

            if (!(_exceedMax || _exceedMin)) {
              _context12.next = 39;
              break;
            }

            getMinMaxMessage(_exceedMax, maxLengthOutput.message, minLengthOutput.message);

            if (validateAllFieldCriteria) {
              _context12.next = 39;
              break;
            }

            setCustomValidity(error[name].message);
            return _context12.abrupt("return", error);

          case 39:
            if (!(pattern && !isEmpty && isString$1(inputValue))) {
              _context12.next = 46;
              break;
            }

            _getValueAndMessage = getValueAndMessage(pattern), patternValue = _getValueAndMessage.value, _message2 = _getValueAndMessage.message;

            if (!(isRegex(patternValue) && !inputValue.match(patternValue))) {
              _context12.next = 46;
              break;
            }

            error[name] = _objectSpread3({
              type: INPUT_VALIDATION_RULES.pattern,
              message: _message2,
              ref: ref
            }, appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, _message2));

            if (validateAllFieldCriteria) {
              _context12.next = 46;
              break;
            }

            setCustomValidity(_message2);
            return _context12.abrupt("return", error);

          case 46:
            if (!validate) {
              _context12.next = 80;
              break;
            }

            if (!isFunction$2(validate)) {
              _context12.next = 59;
              break;
            }

            _context12.next = 50;
            return validate(inputValue, formValues);

          case 50:
            result = _context12.sent;
            validateError = getValidateError(result, inputRef);

            if (!validateError) {
              _context12.next = 57;
              break;
            }

            error[name] = _objectSpread3(_objectSpread3({}, validateError), appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message));

            if (validateAllFieldCriteria) {
              _context12.next = 57;
              break;
            }

            setCustomValidity(validateError.message);
            return _context12.abrupt("return", error);

          case 57:
            _context12.next = 80;
            break;

          case 59:
            if (!isObject$4(validate)) {
              _context12.next = 80;
              break;
            }

            validationResult = {};
            _context12.t0 = _regeneratorRuntime.keys(validate);

          case 62:
            if ((_context12.t1 = _context12.t0()).done) {
              _context12.next = 76;
              break;
            }

            key = _context12.t1.value;

            if (!(!isEmptyObject(validationResult) && !validateAllFieldCriteria)) {
              _context12.next = 66;
              break;
            }

            return _context12.abrupt("break", 76);

          case 66:
            _context12.t2 = getValidateError;
            _context12.next = 69;
            return validate[key](inputValue, formValues);

          case 69:
            _context12.t3 = _context12.sent;
            _context12.t4 = inputRef;
            _context12.t5 = key;
            _validateError = (0, _context12.t2)(_context12.t3, _context12.t4, _context12.t5);

            if (_validateError) {
              validationResult = _objectSpread3(_objectSpread3({}, _validateError), appendErrorsCurry(key, _validateError.message));
              setCustomValidity(_validateError.message);

              if (validateAllFieldCriteria) {
                error[name] = validationResult;
              }
            }

            _context12.next = 62;
            break;

          case 76:
            if (isEmptyObject(validationResult)) {
              _context12.next = 80;
              break;
            }

            error[name] = _objectSpread3({
              ref: inputRef
            }, validationResult);

            if (validateAllFieldCriteria) {
              _context12.next = 80;
              break;
            }

            return _context12.abrupt("return", error);

          case 80:
            setCustomValidity(true);
            return _context12.abrupt("return", error);

          case 82:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee11);
  }));

  return function validateField(_x22, _x23, _x24, _x25, _x26, _x27) {
    return _ref43.apply(this, arguments);
  };
}();

var defaultOptions$1 = {
  mode: VALIDATION_MODE.onSubmit,
  reValidateMode: VALIDATION_MODE.onChange,
  shouldFocusError: true
};

function createFormControl() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options = _objectSpread3(_objectSpread3({}, defaultOptions$1), props);

  var _formState = {
    submitCount: 0,
    isDirty: false,
    isReady: false,
    isLoading: isFunction$2(_options.defaultValues),
    isValidating: false,
    isSubmitted: false,
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: _options.errors || {},
    disabled: _options.disabled || false
  };
  var _fields = {};

  var _defaultValues = isObject$4(_options.defaultValues) || isObject$4(_options.values) ? cloneObject$1(_options.defaultValues || _options.values) || {} : {};

  var _formValues = _options.shouldUnregister ? {} : cloneObject$1(_defaultValues);

  var _state = {
    action: false,
    mount: false,
    watch: false
  };
  var _names = {
    mount: new Set(),
    disabled: new Set(),
    unMount: new Set(),
    array: new Set(),
    watch: new Set()
  };
  var delayErrorCallback;
  var timer = 0;
  var _proxyFormState = {
    isDirty: false,
    dirtyFields: false,
    validatingFields: false,
    touchedFields: false,
    isValidating: false,
    isValid: false,
    errors: false
  };

  var _proxySubscribeFormState = _objectSpread3({}, _proxyFormState);

  var _subjects = {
    array: createSubject(),
    state: createSubject()
  };
  var shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;

  var debounce = function debounce(callback) {
    return function (wait) {
      clearTimeout(timer);
      timer = setTimeout(callback, wait);
    };
  };

  var _setValid = /*#__PURE__*/function () {
    var _ref45 = _asyncToGenerator2( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(shouldUpdateValid) {
      var _isValid;

      return _regeneratorRuntime.wrap(function _callee12$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              if (!(!_options.disabled && (_proxyFormState.isValid || _proxySubscribeFormState.isValid || shouldUpdateValid))) {
                _context13.next = 14;
                break;
              }

              if (!_options.resolver) {
                _context13.next = 9;
                break;
              }

              _context13.t1 = isEmptyObject;
              _context13.next = 5;
              return _runSchema();

            case 5:
              _context13.t2 = _context13.sent.errors;
              _context13.t0 = (0, _context13.t1)(_context13.t2);
              _context13.next = 12;
              break;

            case 9:
              _context13.next = 11;
              return executeBuiltInValidation(_fields, true);

            case 11:
              _context13.t0 = _context13.sent;

            case 12:
              _isValid = _context13.t0;

              if (_isValid !== _formState.isValid) {
                _subjects.state.next({
                  isValid: _isValid
                });
              }

            case 14:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee12);
    }));

    return function _setValid(_x28) {
      return _ref45.apply(this, arguments);
    };
  }();

  var _updateIsValidating = function _updateIsValidating(names, isValidating) {
    if (!_options.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields || _proxySubscribeFormState.isValidating || _proxySubscribeFormState.validatingFields)) {
      (names || Array.from(_names.mount)).forEach(function (name) {
        if (name) {
          isValidating ? set$1(_formState.validatingFields, name, isValidating) : unset(_formState.validatingFields, name);
        }
      });

      _subjects.state.next({
        validatingFields: _formState.validatingFields,
        isValidating: !isEmptyObject(_formState.validatingFields)
      });
    }
  };

  var _setFieldArray = function _setFieldArray(name) {
    var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var method = arguments.length > 2 ? arguments[2] : undefined;
    var args = arguments.length > 3 ? arguments[3] : undefined;
    var shouldSetValues = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var shouldUpdateFieldsAndState = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;

    if (args && method && !_options.disabled) {
      _state.action = true;

      if (shouldUpdateFieldsAndState && Array.isArray(_get2(_fields, name))) {
        var fieldValues = method(_get2(_fields, name), args.argA, args.argB);
        shouldSetValues && set$1(_fields, name, fieldValues);
      }

      if (shouldUpdateFieldsAndState && Array.isArray(_get2(_formState.errors, name))) {
        var _errors2 = method(_get2(_formState.errors, name), args.argA, args.argB);

        shouldSetValues && set$1(_formState.errors, name, _errors2);
        unsetEmptyArray(_formState.errors, name);
      }

      if ((_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && shouldUpdateFieldsAndState && Array.isArray(_get2(_formState.touchedFields, name))) {
        var touchedFields = method(_get2(_formState.touchedFields, name), args.argA, args.argB);
        shouldSetValues && set$1(_formState.touchedFields, name, touchedFields);
      }

      if (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) {
        _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
      }

      _subjects.state.next({
        name: name,
        isDirty: _getDirty(name, values),
        dirtyFields: _formState.dirtyFields,
        errors: _formState.errors,
        isValid: _formState.isValid
      });
    } else {
      set$1(_formValues, name, values);
    }
  };

  var updateErrors = function updateErrors(name, error) {
    set$1(_formState.errors, name, error);

    _subjects.state.next({
      errors: _formState.errors
    });
  };

  var _setErrors = function _setErrors(errors) {
    _formState.errors = errors;

    _subjects.state.next({
      errors: _formState.errors,
      isValid: false
    });
  };

  var updateValidAndValue = function updateValidAndValue(name, shouldSkipSetValueAs, value, ref) {
    var field = _get2(_fields, name);

    if (field) {
      var defaultValue = _get2(_formValues, name, isUndefined(value) ? _get2(_defaultValues, name) : value);

      isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? set$1(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f)) : setFieldValue(name, defaultValue);
      _state.mount && _setValid();
    }
  };

  var updateTouchAndDirty = function updateTouchAndDirty(name, fieldValue, isBlurEvent, shouldDirty, shouldRender) {
    var shouldUpdateField = false;
    var isPreviousDirty = false;
    var output = {
      name: name
    };

    if (!_options.disabled) {
      if (!isBlurEvent || shouldDirty) {
        if (_proxyFormState.isDirty || _proxySubscribeFormState.isDirty) {
          isPreviousDirty = _formState.isDirty;
          _formState.isDirty = output.isDirty = _getDirty();
          shouldUpdateField = isPreviousDirty !== output.isDirty;
        }

        var isCurrentFieldPristine = deepEqual(_get2(_defaultValues, name), fieldValue);
        isPreviousDirty = !!_get2(_formState.dirtyFields, name);
        isCurrentFieldPristine ? unset(_formState.dirtyFields, name) : set$1(_formState.dirtyFields, name, true);
        output.dirtyFields = _formState.dirtyFields;
        shouldUpdateField = shouldUpdateField || (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) && isPreviousDirty !== !isCurrentFieldPristine;
      }

      if (isBlurEvent) {
        var isPreviousFieldTouched = _get2(_formState.touchedFields, name);

        if (!isPreviousFieldTouched) {
          set$1(_formState.touchedFields, name, isBlurEvent);
          output.touchedFields = _formState.touchedFields;
          shouldUpdateField = shouldUpdateField || (_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && isPreviousFieldTouched !== isBlurEvent;
        }
      }

      shouldUpdateField && shouldRender && _subjects.state.next(output);
    }

    return shouldUpdateField ? output : {};
  };

  var shouldRenderByError = function shouldRenderByError(name, isValid, error, fieldState) {
    var previousFieldError = _get2(_formState.errors, name);

    var shouldUpdateValid = (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && isBoolean(isValid) && _formState.isValid !== isValid;

    if (_options.delayError && error) {
      delayErrorCallback = debounce(function () {
        return updateErrors(name, error);
      });
      delayErrorCallback(_options.delayError);
    } else {
      clearTimeout(timer);
      delayErrorCallback = null;
      error ? set$1(_formState.errors, name, error) : unset(_formState.errors, name);
    }

    if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) || !isEmptyObject(fieldState) || shouldUpdateValid) {
      var updatedFormState = _objectSpread3(_objectSpread3(_objectSpread3({}, fieldState), shouldUpdateValid && isBoolean(isValid) ? {
        isValid: isValid
      } : {}), {}, {
        errors: _formState.errors,
        name: name
      });

      _formState = _objectSpread3(_objectSpread3({}, _formState), updatedFormState);

      _subjects.state.next(updatedFormState);
    }
  };

  var _runSchema = /*#__PURE__*/function () {
    var _ref46 = _asyncToGenerator2( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(name) {
      var result;
      return _regeneratorRuntime.wrap(function _callee13$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _updateIsValidating(name, true);

              _context14.next = 3;
              return _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));

            case 3:
              result = _context14.sent;

              _updateIsValidating(name);

              return _context14.abrupt("return", result);

            case 6:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee13);
    }));

    return function _runSchema(_x29) {
      return _ref46.apply(this, arguments);
    };
  }();

  var executeSchemaAndUpdateState = /*#__PURE__*/function () {
    var _ref47 = _asyncToGenerator2( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(names) {
      var _yield$_runSchema, errors, _iterator6, _step6, _name2, _error;

      return _regeneratorRuntime.wrap(function _callee14$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return _runSchema(names);

            case 2:
              _yield$_runSchema = _context15.sent;
              errors = _yield$_runSchema.errors;

              if (names) {
                _iterator6 = _createForOfIteratorHelper(names);

                try {
                  for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                    _name2 = _step6.value;
                    _error = _get2(errors, _name2);
                    _error ? set$1(_formState.errors, _name2, _error) : unset(_formState.errors, _name2);
                  }
                } catch (err) {
                  _iterator6.e(err);
                } finally {
                  _iterator6.f();
                }
              } else {
                _formState.errors = errors;
              }

              return _context15.abrupt("return", errors);

            case 6:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee14);
    }));

    return function executeSchemaAndUpdateState(_x30) {
      return _ref47.apply(this, arguments);
    };
  }();

  var executeBuiltInValidation = /*#__PURE__*/function () {
    var _ref48 = _asyncToGenerator2( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(fields, shouldOnlyCheckValid) {
      var context,
          _name3,
          field,
          _f,
          fieldValue,
          isFieldArrayRoot,
          isPromiseFunction,
          fieldError,
          _args14 = arguments;

      return _regeneratorRuntime.wrap(function _callee15$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              context = _args14.length > 2 && _args14[2] !== undefined ? _args14[2] : {
                valid: true
              };
              _context16.t0 = _regeneratorRuntime.keys(fields);

            case 2:
              if ((_context16.t1 = _context16.t0()).done) {
                _context16.next = 26;
                break;
              }

              _name3 = _context16.t1.value;
              field = fields[_name3];

              if (!field) {
                _context16.next = 24;
                break;
              }

              _f = field._f, fieldValue = _objectWithoutProperties2(field, _excluded7);

              if (!_f) {
                _context16.next = 20;
                break;
              }

              isFieldArrayRoot = _names.array.has(_f.name);
              isPromiseFunction = field._f && hasPromiseValidation(field._f);

              if (isPromiseFunction && _proxyFormState.validatingFields) {
                _updateIsValidating([_name3], true);
              }

              _context16.next = 13;
              return validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);

            case 13:
              fieldError = _context16.sent;

              if (isPromiseFunction && _proxyFormState.validatingFields) {
                _updateIsValidating([_name3]);
              }

              if (!fieldError[_f.name]) {
                _context16.next = 19;
                break;
              }

              context.valid = false;

              if (!shouldOnlyCheckValid) {
                _context16.next = 19;
                break;
              }

              return _context16.abrupt("break", 26);

            case 19:
              !shouldOnlyCheckValid && (_get2(fieldError, _f.name) ? isFieldArrayRoot ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : set$1(_formState.errors, _f.name, fieldError[_f.name]) : unset(_formState.errors, _f.name));

            case 20:
              _context16.t2 = !isEmptyObject(fieldValue);

              if (!_context16.t2) {
                _context16.next = 24;
                break;
              }

              _context16.next = 24;
              return executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);

            case 24:
              _context16.next = 2;
              break;

            case 26:
              return _context16.abrupt("return", context.valid);

            case 27:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee15);
    }));

    return function executeBuiltInValidation(_x31, _x32) {
      return _ref48.apply(this, arguments);
    };
  }();

  var _removeUnmounted = function _removeUnmounted() {
    var _iterator7 = _createForOfIteratorHelper(_names.unMount),
        _step7;

    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var _name4 = _step7.value;

        var field = _get2(_fields, _name4);

        field && (field._f.refs ? field._f.refs.every(function (ref) {
          return !live(ref);
        }) : !live(field._f.ref)) && unregister(_name4);
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }

    _names.unMount = new Set();
  };

  var _getDirty = function _getDirty(name, data) {
    return !_options.disabled && (name && data && set$1(_formValues, name, data), !deepEqual(getValues(), _defaultValues));
  };

  var _getWatch = function _getWatch(names, defaultValue, isGlobal) {
    return generateWatchOutput(names, _names, _objectSpread3({}, _state.mount ? _formValues : isUndefined(defaultValue) ? _defaultValues : isString$1(names) ? _defineProperty2({}, names, defaultValue) : defaultValue), isGlobal, defaultValue);
  };

  var _getFieldArray = function _getFieldArray(name) {
    return compact$1(_get2(_state.mount ? _formValues : _defaultValues, name, _options.shouldUnregister ? _get2(_defaultValues, name, []) : []));
  };

  var setFieldValue = function setFieldValue(name, value) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var field = _get2(_fields, name);

    var fieldValue = value;

    if (field) {
      var fieldReference = field._f;

      if (fieldReference) {
        !fieldReference.disabled && set$1(_formValues, name, getFieldValueAs(value, fieldReference));
        fieldValue = isHTMLElement(fieldReference.ref) && isNullOrUndefined(value) ? '' : value;

        if (isMultipleSelect(fieldReference.ref)) {
          _toConsumableArray2(fieldReference.ref.options).forEach(function (optionRef) {
            return optionRef.selected = fieldValue.includes(optionRef.value);
          });
        } else if (fieldReference.refs) {
          if (isCheckBoxInput(fieldReference.ref)) {
            fieldReference.refs.forEach(function (checkboxRef) {
              if (!checkboxRef.defaultChecked || !checkboxRef.disabled) {
                if (Array.isArray(fieldValue)) {
                  checkboxRef.checked = !!fieldValue.find(function (data) {
                    return data === checkboxRef.value;
                  });
                } else {
                  checkboxRef.checked = fieldValue === checkboxRef.value || !!fieldValue;
                }
              }
            });
          } else {
            fieldReference.refs.forEach(function (radioRef) {
              return radioRef.checked = radioRef.value === fieldValue;
            });
          }
        } else if (isFileInput(fieldReference.ref)) {
          fieldReference.ref.value = '';
        } else {
          fieldReference.ref.value = fieldValue;

          if (!fieldReference.ref.type) {
            _subjects.state.next({
              name: name,
              values: cloneObject$1(_formValues)
            });
          }
        }
      }
    }

    (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
    options.shouldValidate && trigger(name);
  };

  var setValues = function setValues(name, value, options) {
    for (var fieldKey in value) {
      if (!value.hasOwnProperty(fieldKey)) {
        return;
      }

      var fieldValue = value[fieldKey];
      var fieldName = name + '.' + fieldKey;

      var field = _get2(_fields, fieldName);

      (_names.array.has(name) || isObject$4(fieldValue) || field && !field._f) && !isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
    }
  };

  var setValue = function setValue(name, value) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var field = _get2(_fields, name);

    var isFieldArray = _names.array.has(name);

    var cloneValue = cloneObject$1(value);
    set$1(_formValues, name, cloneValue);

    if (isFieldArray) {
      _subjects.array.next({
        name: name,
        values: cloneObject$1(_formValues)
      });

      if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields || _proxySubscribeFormState.isDirty || _proxySubscribeFormState.dirtyFields) && options.shouldDirty) {
        _subjects.state.next({
          name: name,
          dirtyFields: getDirtyFields(_defaultValues, _formValues),
          isDirty: _getDirty(name, cloneValue)
        });
      }
    } else {
      field && !field._f && !isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
    }

    isWatched(name, _names) && _subjects.state.next(_objectSpread3({}, _formState));

    _subjects.state.next({
      name: _state.mount ? name : undefined,
      values: cloneObject$1(_formValues)
    });
  };

  var onChange = /*#__PURE__*/function () {
    var _ref50 = _asyncToGenerator2( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(event) {
      var target, name, isFieldValueUpdated, field, _updateIsFieldValueUpdated, validationModeBeforeSubmit, validationModeAfterSubmit, _error2, _isValid2, fieldValue, isBlurEvent, shouldSkipValidation, watched, fieldState, shouldRender, _yield$_runSchema2, _errors3, previousErrorLookupResult, errorLookupResult;

      return _regeneratorRuntime.wrap(function _callee16$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _state.mount = true;
              target = event.target;
              name = target.name;
              isFieldValueUpdated = true;
              field = _get2(_fields, name);

              _updateIsFieldValueUpdated = function _updateIsFieldValueUpdated(fieldValue) {
                isFieldValueUpdated = Number.isNaN(fieldValue) || isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || deepEqual(fieldValue, _get2(_formValues, name, fieldValue));
              };

              validationModeBeforeSubmit = getValidationModes(_options.mode);
              validationModeAfterSubmit = getValidationModes(_options.reValidateMode);

              if (!field) {
                _context17.next = 48;
                break;
              }

              fieldValue = target.type ? getFieldValue(field._f) : getEventValue(event);
              isBlurEvent = event.type === EVENTS$1.BLUR || event.type === EVENTS$1.FOCUS_OUT;
              shouldSkipValidation = !hasValidation(field._f) && !_options.resolver && !_get2(_formState.errors, name) && !field._f.deps || skipValidation(isBlurEvent, _get2(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
              watched = isWatched(name, _names, isBlurEvent);
              set$1(_formValues, name, fieldValue);

              if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
              } else if (field._f.onChange) {
                field._f.onChange(event);
              }

              fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent);
              shouldRender = !isEmptyObject(fieldState) || watched;
              !isBlurEvent && _subjects.state.next({
                name: name,
                type: event.type,
                values: cloneObject$1(_formValues)
              });

              if (!shouldSkipValidation) {
                _context17.next = 21;
                break;
              }

              if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) {
                if (_options.mode === 'onBlur') {
                  if (isBlurEvent) {
                    _setValid();
                  }
                } else if (!isBlurEvent) {
                  _setValid();
                }
              }

              return _context17.abrupt("return", shouldRender && _subjects.state.next(_objectSpread3({
                name: name
              }, watched ? {} : fieldState)));

            case 21:
              !isBlurEvent && watched && _subjects.state.next(_objectSpread3({}, _formState));

              if (!_options.resolver) {
                _context17.next = 31;
                break;
              }

              _context17.next = 25;
              return _runSchema([name]);

            case 25:
              _yield$_runSchema2 = _context17.sent;
              _errors3 = _yield$_runSchema2.errors;

              _updateIsFieldValueUpdated(fieldValue);

              if (isFieldValueUpdated) {
                previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                errorLookupResult = schemaErrorLookup(_errors3, _fields, previousErrorLookupResult.name || name);
                _error2 = errorLookupResult.error;
                name = errorLookupResult.name;
                _isValid2 = isEmptyObject(_errors3);
              }

              _context17.next = 47;
              break;

            case 31:
              _updateIsValidating([name], true);

              _context17.next = 34;
              return validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation);

            case 34:
              _context17.t0 = name;
              _error2 = _context17.sent[_context17.t0];

              _updateIsValidating([name]);

              _updateIsFieldValueUpdated(fieldValue);

              if (!isFieldValueUpdated) {
                _context17.next = 47;
                break;
              }

              if (!_error2) {
                _context17.next = 43;
                break;
              }

              _isValid2 = false;
              _context17.next = 47;
              break;

            case 43:
              if (!(_proxyFormState.isValid || _proxySubscribeFormState.isValid)) {
                _context17.next = 47;
                break;
              }

              _context17.next = 46;
              return executeBuiltInValidation(_fields, true);

            case 46:
              _isValid2 = _context17.sent;

            case 47:
              if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, _isValid2, _error2, fieldState);
              }

            case 48:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee16);
    }));

    return function onChange(_x33) {
      return _ref50.apply(this, arguments);
    };
  }();

  var _focusInput = function _focusInput(ref, key) {
    if (_get2(_formState.errors, key) && ref.focus) {
      ref.focus();
      return 1;
    }

    return;
  };

  var trigger = /*#__PURE__*/function () {
    var _ref51 = _asyncToGenerator2( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(name) {
      var options,
          isValid,
          validationResult,
          fieldNames,
          _errors4,
          _args17 = arguments;

      return _regeneratorRuntime.wrap(function _callee18$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              options = _args17.length > 1 && _args17[1] !== undefined ? _args17[1] : {};
              fieldNames = convertToArrayPayload(name);

              if (!_options.resolver) {
                _context19.next = 10;
                break;
              }

              _context19.next = 5;
              return executeSchemaAndUpdateState(isUndefined(name) ? name : fieldNames);

            case 5:
              _errors4 = _context19.sent;
              isValid = isEmptyObject(_errors4);
              validationResult = name ? !fieldNames.some(function (name) {
                return _get2(_errors4, name);
              }) : isValid;
              _context19.next = 20;
              break;

            case 10:
              if (!name) {
                _context19.next = 17;
                break;
              }

              _context19.next = 13;
              return Promise.all(fieldNames.map( /*#__PURE__*/function () {
                var _ref52 = _asyncToGenerator2( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(fieldName) {
                  var field;
                  return _regeneratorRuntime.wrap(function _callee17$(_context18) {
                    while (1) {
                      switch (_context18.prev = _context18.next) {
                        case 0:
                          field = _get2(_fields, fieldName);
                          _context18.next = 3;
                          return executeBuiltInValidation(field && field._f ? _defineProperty2({}, fieldName, field) : field);

                        case 3:
                          return _context18.abrupt("return", _context18.sent);

                        case 4:
                        case "end":
                          return _context18.stop();
                      }
                    }
                  }, _callee17);
                }));

                return function (_x35) {
                  return _ref52.apply(this, arguments);
                };
              }()));

            case 13:
              validationResult = _context19.sent.every(Boolean);
              !(!validationResult && !_formState.isValid) && _setValid();
              _context19.next = 20;
              break;

            case 17:
              _context19.next = 19;
              return executeBuiltInValidation(_fields);

            case 19:
              validationResult = isValid = _context19.sent;

            case 20:
              _subjects.state.next(_objectSpread3(_objectSpread3(_objectSpread3({}, !isString$1(name) || (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && isValid !== _formState.isValid ? {} : {
                name: name
              }), _options.resolver || !name ? {
                isValid: isValid
              } : {}), {}, {
                errors: _formState.errors
              }));

              options.shouldFocus && !validationResult && iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
              return _context19.abrupt("return", validationResult);

            case 23:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee18);
    }));

    return function trigger(_x34) {
      return _ref51.apply(this, arguments);
    };
  }();

  var getValues = function getValues(fieldNames) {
    var values = _objectSpread3({}, _state.mount ? _formValues : _defaultValues);

    return isUndefined(fieldNames) ? values : isString$1(fieldNames) ? _get2(values, fieldNames) : fieldNames.map(function (name) {
      return _get2(values, name);
    });
  };

  var getFieldState = function getFieldState(name, formState) {
    return {
      invalid: !!_get2((formState || _formState).errors, name),
      isDirty: !!_get2((formState || _formState).dirtyFields, name),
      error: _get2((formState || _formState).errors, name),
      isValidating: !!_get2(_formState.validatingFields, name),
      isTouched: !!_get2((formState || _formState).touchedFields, name)
    };
  };

  var clearErrors = function clearErrors(name) {
    name && convertToArrayPayload(name).forEach(function (inputName) {
      return unset(_formState.errors, inputName);
    });

    _subjects.state.next({
      errors: name ? _formState.errors : {}
    });
  };

  var setError = function setError(name, error, options) {
    var ref = (_get2(_fields, name, {
      _f: {}
    })._f || {}).ref;
    var currentError = _get2(_formState.errors, name) || {}; // Don't override existing error messages elsewhere in the object tree.

    var currentRef = currentError.ref,
        message = currentError.message,
        type = currentError.type,
        restOfErrorTree = _objectWithoutProperties2(currentError, _excluded8);

    set$1(_formState.errors, name, _objectSpread3(_objectSpread3(_objectSpread3({}, restOfErrorTree), error), {}, {
      ref: ref
    }));

    _subjects.state.next({
      name: name,
      errors: _formState.errors,
      isValid: false
    });

    options && options.shouldFocus && ref && ref.focus && ref.focus();
  };

  var watch = function watch(name, defaultValue) {
    return isFunction$2(name) ? _subjects.state.subscribe({
      next: function next(payload) {
        return name(_getWatch(undefined, defaultValue), payload);
      }
    }) : _getWatch(name, defaultValue, true);
  };

  var _subscribe = function _subscribe(props) {
    return _subjects.state.subscribe({
      next: function next(formState) {
        if (shouldSubscribeByName(props.name, formState.name, props.exact) && shouldRenderFormState(formState, props.formState || _proxyFormState, _setFormState, props.reRenderRoot)) {
          props.callback(_objectSpread3(_objectSpread3({
            values: _objectSpread3({}, _formValues)
          }, _formState), formState));
        }
      }
    }).unsubscribe;
  };

  var subscribe = function subscribe(props) {
    _state.mount = true;
    _proxySubscribeFormState = _objectSpread3(_objectSpread3({}, _proxySubscribeFormState), props.formState);
    return _subscribe(_objectSpread3(_objectSpread3({}, props), {}, {
      formState: _proxySubscribeFormState
    }));
  };

  var unregister = function unregister(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _iterator8 = _createForOfIteratorHelper(name ? convertToArrayPayload(name) : _names.mount),
        _step8;

    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var fieldName = _step8.value;

        _names.mount.delete(fieldName);

        _names.array.delete(fieldName);

        if (!options.keepValue) {
          unset(_fields, fieldName);
          unset(_formValues, fieldName);
        }

        !options.keepError && unset(_formState.errors, fieldName);
        !options.keepDirty && unset(_formState.dirtyFields, fieldName);
        !options.keepTouched && unset(_formState.touchedFields, fieldName);
        !options.keepIsValidating && unset(_formState.validatingFields, fieldName);
        !_options.shouldUnregister && !options.keepDefaultValue && unset(_defaultValues, fieldName);
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }

    _subjects.state.next({
      values: cloneObject$1(_formValues)
    });

    _subjects.state.next(_objectSpread3(_objectSpread3({}, _formState), !options.keepDirty ? {} : {
      isDirty: _getDirty()
    }));

    !options.keepIsValid && _setValid();
  };

  var _setDisabledField = function _setDisabledField(_ref54) {
    var disabled = _ref54.disabled,
        name = _ref54.name;

    if (isBoolean(disabled) && _state.mount || !!disabled || _names.disabled.has(name)) {
      disabled ? _names.disabled.add(name) : _names.disabled.delete(name);
    }
  };

  var register = function register(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var field = _get2(_fields, name);

    var disabledIsDefined = isBoolean(options.disabled) || isBoolean(_options.disabled);
    set$1(_fields, name, _objectSpread3(_objectSpread3({}, field || {}), {}, {
      _f: _objectSpread3(_objectSpread3({}, field && field._f ? field._f : {
        ref: {
          name: name
        }
      }), {}, {
        name: name,
        mount: true
      }, options)
    }));

    _names.mount.add(name);

    if (field) {
      _setDisabledField({
        disabled: isBoolean(options.disabled) ? options.disabled : _options.disabled,
        name: name
      });
    } else {
      updateValidAndValue(name, true, options.value);
    }

    return _objectSpread3(_objectSpread3(_objectSpread3({}, disabledIsDefined ? {
      disabled: options.disabled || _options.disabled
    } : {}), _options.progressive ? {
      required: !!options.required,
      min: getRuleValue(options.min),
      max: getRuleValue(options.max),
      minLength: getRuleValue(options.minLength),
      maxLength: getRuleValue(options.maxLength),
      pattern: getRuleValue(options.pattern)
    } : {}), {}, {
      name: name,
      onChange: onChange,
      onBlur: onChange,
      ref: function (_ref55) {
        function ref(_x36) {
          return _ref55.apply(this, arguments);
        }

        ref.toString = function () {
          return _ref55.toString();
        };

        return ref;
      }(function (ref) {
        if (ref) {
          register(name, options);
          field = _get2(_fields, name);
          var fieldRef = isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll('input,select,textarea')[0] || ref : ref : ref;
          var radioOrCheckbox = isRadioOrCheckbox(fieldRef);
          var refs = field._f.refs || [];

          if (radioOrCheckbox ? refs.find(function (option) {
            return option === fieldRef;
          }) : fieldRef === field._f.ref) {
            return;
          }

          set$1(_fields, name, {
            _f: _objectSpread3(_objectSpread3({}, field._f), radioOrCheckbox ? {
              refs: [].concat(_toConsumableArray2(refs.filter(live)), [fieldRef], _toConsumableArray2(Array.isArray(_get2(_defaultValues, name)) ? [{}] : [])),
              ref: {
                type: fieldRef.type,
                name: name
              }
            } : {
              ref: fieldRef
            })
          });
          updateValidAndValue(name, false, undefined, fieldRef);
        } else {
          field = _get2(_fields, name, {});

          if (field._f) {
            field._f.mount = false;
          }

          (_options.shouldUnregister || options.shouldUnregister) && !(isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
        }
      })
    });
  };

  var _focusError = function _focusError() {
    return _options.shouldFocusError && iterateFieldsByAction(_fields, _focusInput, _names.mount);
  };

  var _disableForm = function _disableForm(disabled) {
    if (isBoolean(disabled)) {
      _subjects.state.next({
        disabled: disabled
      });

      iterateFieldsByAction(_fields, function (ref, name) {
        var currentField = _get2(_fields, name);

        if (currentField) {
          ref.disabled = currentField._f.disabled || disabled;

          if (Array.isArray(currentField._f.refs)) {
            currentField._f.refs.forEach(function (inputRef) {
              inputRef.disabled = currentField._f.disabled || disabled;
            });
          }
        }
      }, 0, false);
    }
  };

  var handleSubmit = function handleSubmit(onValid, onInvalid) {
    return /*#__PURE__*/function () {
      var _ref56 = _asyncToGenerator2( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(e) {
        var onValidError, fieldValues, _yield$_runSchema3, _errors5, values, _iterator9, _step9, _name5;

        return _regeneratorRuntime.wrap(function _callee19$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                onValidError = undefined;

                if (e) {
                  e.preventDefault && e.preventDefault();
                  e.persist && e.persist();
                }

                fieldValues = cloneObject$1(_formValues);

                _subjects.state.next({
                  isSubmitting: true
                });

                if (!_options.resolver) {
                  _context20.next = 14;
                  break;
                }

                _context20.next = 7;
                return _runSchema();

              case 7:
                _yield$_runSchema3 = _context20.sent;
                _errors5 = _yield$_runSchema3.errors;
                values = _yield$_runSchema3.values;
                _formState.errors = _errors5;
                fieldValues = cloneObject$1(values);
                _context20.next = 16;
                break;

              case 14:
                _context20.next = 16;
                return executeBuiltInValidation(_fields);

              case 16:
                if (_names.disabled.size) {
                  _iterator9 = _createForOfIteratorHelper(_names.disabled);

                  try {
                    for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                      _name5 = _step9.value;
                      unset(fieldValues, _name5);
                    }
                  } catch (err) {
                    _iterator9.e(err);
                  } finally {
                    _iterator9.f();
                  }
                }

                unset(_formState.errors, 'root');

                if (!isEmptyObject(_formState.errors)) {
                  _context20.next = 30;
                  break;
                }

                _subjects.state.next({
                  errors: {}
                });

                _context20.prev = 20;
                _context20.next = 23;
                return onValid(fieldValues, e);

              case 23:
                _context20.next = 28;
                break;

              case 25:
                _context20.prev = 25;
                _context20.t0 = _context20["catch"](20);
                onValidError = _context20.t0;

              case 28:
                _context20.next = 35;
                break;

              case 30:
                if (!onInvalid) {
                  _context20.next = 33;
                  break;
                }

                _context20.next = 33;
                return onInvalid(_objectSpread3({}, _formState.errors), e);

              case 33:
                _focusError();

                setTimeout(_focusError);

              case 35:
                _subjects.state.next({
                  isSubmitted: true,
                  isSubmitting: false,
                  isSubmitSuccessful: isEmptyObject(_formState.errors) && !onValidError,
                  submitCount: _formState.submitCount + 1,
                  errors: _formState.errors
                });

                if (!onValidError) {
                  _context20.next = 38;
                  break;
                }

                throw onValidError;

              case 38:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee19, null, [[20, 25]]);
      }));

      return function (_x37) {
        return _ref56.apply(this, arguments);
      };
    }();
  };

  var resetField = function resetField(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (_get2(_fields, name)) {
      if (isUndefined(options.defaultValue)) {
        setValue(name, cloneObject$1(_get2(_defaultValues, name)));
      } else {
        setValue(name, options.defaultValue);
        set$1(_defaultValues, name, cloneObject$1(options.defaultValue));
      }

      if (!options.keepTouched) {
        unset(_formState.touchedFields, name);
      }

      if (!options.keepDirty) {
        unset(_formState.dirtyFields, name);
        _formState.isDirty = options.defaultValue ? _getDirty(name, cloneObject$1(_get2(_defaultValues, name))) : _getDirty();
      }

      if (!options.keepError) {
        unset(_formState.errors, name);
        _proxyFormState.isValid && _setValid();
      }

      _subjects.state.next(_objectSpread3({}, _formState));
    }
  };

  var _reset = function _reset(formValues) {
    var keepStateOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var updatedValues = formValues ? cloneObject$1(formValues) : _defaultValues;
    var cloneUpdatedValues = cloneObject$1(updatedValues);
    var isEmptyResetValues = isEmptyObject(formValues);
    var values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;

    if (!keepStateOptions.keepDefaultValues) {
      _defaultValues = updatedValues;
    }

    if (!keepStateOptions.keepValues) {
      if (keepStateOptions.keepDirtyValues) {
        var fieldsToCheck = new Set([].concat(_toConsumableArray2(_names.mount), _toConsumableArray2(Object.keys(getDirtyFields(_defaultValues, _formValues)))));

        for (var _i14 = 0, _Array$from = Array.from(fieldsToCheck); _i14 < _Array$from.length; _i14++) {
          var fieldName = _Array$from[_i14];
          _get2(_formState.dirtyFields, fieldName) ? set$1(values, fieldName, _get2(_formValues, fieldName)) : setValue(fieldName, _get2(values, fieldName));
        }
      } else {
        if (isWeb && isUndefined(formValues)) {
          var _iterator10 = _createForOfIteratorHelper(_names.mount),
              _step10;

          try {
            for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
              var _name6 = _step10.value;

              var field = _get2(_fields, _name6);

              if (field && field._f) {
                var fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;

                if (isHTMLElement(fieldReference)) {
                  var form = fieldReference.closest('form');

                  if (form) {
                    form.reset();
                    break;
                  }
                }
              }
            }
          } catch (err) {
            _iterator10.e(err);
          } finally {
            _iterator10.f();
          }
        }

        if (keepStateOptions.keepFieldsRef) {
          var _iterator11 = _createForOfIteratorHelper(_names.mount),
              _step11;

          try {
            for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
              var _fieldName = _step11.value;
              setValue(_fieldName, _get2(values, _fieldName));
            }
          } catch (err) {
            _iterator11.e(err);
          } finally {
            _iterator11.f();
          }
        } else {
          _fields = {};
        }
      }

      _formValues = _options.shouldUnregister ? keepStateOptions.keepDefaultValues ? cloneObject$1(_defaultValues) : {} : cloneObject$1(values);

      _subjects.array.next({
        values: _objectSpread3({}, values)
      });

      _subjects.state.next({
        values: _objectSpread3({}, values)
      });
    }

    _names = {
      mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
      unMount: new Set(),
      array: new Set(),
      disabled: new Set(),
      watch: new Set(),
      watchAll: false,
      focus: ''
    };
    _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
    _state.watch = !!_options.shouldUnregister;

    _subjects.state.next({
      submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
      isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !deepEqual(formValues, _defaultValues)),
      isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
      dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
      touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
      errors: keepStateOptions.keepErrors ? _formState.errors : {},
      isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
      isSubmitting: false
    });
  };

  var reset = function reset(formValues, keepStateOptions) {
    return _reset(isFunction$2(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
  };

  var setFocus = function setFocus(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var field = _get2(_fields, name);

    var fieldReference = field && field._f;

    if (fieldReference) {
      var fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;

      if (fieldRef.focus) {
        fieldRef.focus();
        options.shouldSelect && isFunction$2(fieldRef.select) && fieldRef.select();
      }
    }
  };

  var _setFormState = function _setFormState(updatedFormState) {
    _formState = _objectSpread3(_objectSpread3({}, _formState), updatedFormState);
  };

  var _resetDefaultValues = function _resetDefaultValues() {
    return isFunction$2(_options.defaultValues) && _options.defaultValues().then(function (values) {
      reset(values, _options.resetOptions);

      _subjects.state.next({
        isLoading: false
      });
    });
  };

  var methods = {
    control: {
      register: register,
      unregister: unregister,
      getFieldState: getFieldState,
      handleSubmit: handleSubmit,
      setError: setError,
      _subscribe: _subscribe,
      _runSchema: _runSchema,
      _focusError: _focusError,
      _getWatch: _getWatch,
      _getDirty: _getDirty,
      _setValid: _setValid,
      _setFieldArray: _setFieldArray,
      _setDisabledField: _setDisabledField,
      _setErrors: _setErrors,
      _getFieldArray: _getFieldArray,
      _reset: _reset,
      _resetDefaultValues: _resetDefaultValues,
      _removeUnmounted: _removeUnmounted,
      _disableForm: _disableForm,
      _subjects: _subjects,
      _proxyFormState: _proxyFormState,

      get _fields() {
        return _fields;
      },

      get _formValues() {
        return _formValues;
      },

      get _state() {
        return _state;
      },

      set _state(value) {
        _state = value;
      },

      get _defaultValues() {
        return _defaultValues;
      },

      get _names() {
        return _names;
      },

      set _names(value) {
        _names = value;
      },

      get _formState() {
        return _formState;
      },

      get _options() {
        return _options;
      },

      set _options(value) {
        _options = _objectSpread3(_objectSpread3({}, _options), value);
      }

    },
    subscribe: subscribe,
    trigger: trigger,
    register: register,
    handleSubmit: handleSubmit,
    watch: watch,
    setValue: setValue,
    getValues: getValues,
    reset: reset,
    resetField: resetField,
    clearErrors: clearErrors,
    unregister: unregister,
    setError: setError,
    setFocus: setFocus,
    getFieldState: getFieldState
  };
  return _objectSpread3(_objectSpread3({}, methods), {}, {
    formControl: methods
  });
}

var generateId = function generateId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  var d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16 + d) % 16 | 0;
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
};

var getFocusFieldName = function getFocusFieldName(name, index) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return options.shouldFocus || isUndefined(options.shouldFocus) ? options.focusName || "".concat(name, ".").concat(isUndefined(options.focusIndex) ? index : options.focusIndex, ".") : '';
};

var appendAt = function appendAt(data, value) {
  return [].concat(_toConsumableArray2(data), _toConsumableArray2(convertToArrayPayload(value)));
};

var fillEmptyArray = function fillEmptyArray(value) {
  return Array.isArray(value) ? value.map(function () {
    return undefined;
  }) : undefined;
};

function insert(data, index, value) {
  return [].concat(_toConsumableArray2(data.slice(0, index)), _toConsumableArray2(convertToArrayPayload(value)), _toConsumableArray2(data.slice(index)));
}

var moveArrayAt = function moveArrayAt(data, from, to) {
  if (!Array.isArray(data)) {
    return [];
  }

  if (isUndefined(data[to])) {
    data[to] = undefined;
  }

  data.splice(to, 0, data.splice(from, 1)[0]);
  return data;
};

var prependAt = function prependAt(data, value) {
  return [].concat(_toConsumableArray2(convertToArrayPayload(value)), _toConsumableArray2(convertToArrayPayload(data)));
};

function removeAtIndexes(data, indexes) {
  var i = 0;

  var temp = _toConsumableArray2(data);

  var _iterator12 = _createForOfIteratorHelper(indexes),
      _step12;

  try {
    for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
      var _index = _step12.value;
      temp.splice(_index - i, 1);
      i++;
    }
  } catch (err) {
    _iterator12.e(err);
  } finally {
    _iterator12.f();
  }

  return compact$1(temp).length ? temp : [];
}

var removeArrayAt = function removeArrayAt(data, index) {
  return isUndefined(index) ? [] : removeAtIndexes(data, convertToArrayPayload(index).sort(function (a, b) {
    return a - b;
  }));
};

var swapArrayAt = function swapArrayAt(data, indexA, indexB) {
  var _ref57 = [data[indexB], data[indexA]];
  data[indexA] = _ref57[0];
  data[indexB] = _ref57[1];
};

var updateAt = function updateAt(fieldValues, index, value) {
  fieldValues[index] = value;
  return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */


function useFieldArray(props) {
  var methods = useFormContext();
  var _props$control2 = props.control,
      control = _props$control2 === void 0 ? methods.control : _props$control2,
      name = props.name,
      _props$keyName = props.keyName,
      keyName = _props$keyName === void 0 ? 'id' : _props$keyName,
      shouldUnregister = props.shouldUnregister,
      rules = props.rules;

  var _React__default$useSt5 = React__default.useState(control._getFieldArray(name)),
      _React__default$useSt6 = _slicedToArray2(_React__default$useSt5, 2),
      fields = _React__default$useSt6[0],
      setFields = _React__default$useSt6[1];

  var ids = React__default.useRef(control._getFieldArray(name).map(generateId));

  var _fieldIds = React__default.useRef(fields);

  var _name = React__default.useRef(name);

  var _actioned = React__default.useRef(false);

  _name.current = name;
  _fieldIds.current = fields;

  control._names.array.add(name);

  rules && control.register(name, rules);
  useIsomorphicLayoutEffect$1(function () {
    return control._subjects.array.subscribe({
      next: function next(_ref58) {
        var values = _ref58.values,
            fieldArrayName = _ref58.name;

        if (fieldArrayName === _name.current || !fieldArrayName) {
          var fieldValues = _get2(values, _name.current);

          if (Array.isArray(fieldValues)) {
            setFields(fieldValues);
            ids.current = fieldValues.map(generateId);
          }
        }
      }
    }).unsubscribe;
  }, [control]);
  var updateValues = React__default.useCallback(function (updatedFieldArrayValues) {
    _actioned.current = true;

    control._setFieldArray(name, updatedFieldArrayValues);
  }, [control, name]);

  var append = function append(value, options) {
    var appendValue = convertToArrayPayload(cloneObject$1(value));
    var updatedFieldArrayValues = appendAt(control._getFieldArray(name), appendValue);
    control._names.focus = getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
    ids.current = appendAt(ids.current, appendValue.map(generateId));
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);

    control._setFieldArray(name, updatedFieldArrayValues, appendAt, {
      argA: fillEmptyArray(value)
    });
  };

  var prepend = function prepend(value, options) {
    var prependValue = convertToArrayPayload(cloneObject$1(value));
    var updatedFieldArrayValues = prependAt(control._getFieldArray(name), prependValue);
    control._names.focus = getFocusFieldName(name, 0, options);
    ids.current = prependAt(ids.current, prependValue.map(generateId));
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);

    control._setFieldArray(name, updatedFieldArrayValues, prependAt, {
      argA: fillEmptyArray(value)
    });
  };

  var remove = function remove(index) {
    var updatedFieldArrayValues = removeArrayAt(control._getFieldArray(name), index);
    ids.current = removeArrayAt(ids.current, index);
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);
    !Array.isArray(_get2(control._fields, name)) && set$1(control._fields, name, undefined);

    control._setFieldArray(name, updatedFieldArrayValues, removeArrayAt, {
      argA: index
    });
  };

  var insert$1 = function insert$1(index, value, options) {
    var insertValue = convertToArrayPayload(cloneObject$1(value));
    var updatedFieldArrayValues = insert(control._getFieldArray(name), index, insertValue);
    control._names.focus = getFocusFieldName(name, index, options);
    ids.current = insert(ids.current, index, insertValue.map(generateId));
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);

    control._setFieldArray(name, updatedFieldArrayValues, insert, {
      argA: index,
      argB: fillEmptyArray(value)
    });
  };

  var swap = function swap(indexA, indexB) {
    var updatedFieldArrayValues = control._getFieldArray(name);

    swapArrayAt(updatedFieldArrayValues, indexA, indexB);
    swapArrayAt(ids.current, indexA, indexB);
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);

    control._setFieldArray(name, updatedFieldArrayValues, swapArrayAt, {
      argA: indexA,
      argB: indexB
    }, false);
  };

  var move = function move(from, to) {
    var updatedFieldArrayValues = control._getFieldArray(name);

    moveArrayAt(updatedFieldArrayValues, from, to);
    moveArrayAt(ids.current, from, to);
    updateValues(updatedFieldArrayValues);
    setFields(updatedFieldArrayValues);

    control._setFieldArray(name, updatedFieldArrayValues, moveArrayAt, {
      argA: from,
      argB: to
    }, false);
  };

  var update = function update(index, value) {
    var updateValue = cloneObject$1(value);
    var updatedFieldArrayValues = updateAt(control._getFieldArray(name), index, updateValue);
    ids.current = _toConsumableArray2(updatedFieldArrayValues).map(function (item, i) {
      return !item || i === index ? generateId() : ids.current[i];
    });
    updateValues(updatedFieldArrayValues);
    setFields(_toConsumableArray2(updatedFieldArrayValues));

    control._setFieldArray(name, updatedFieldArrayValues, updateAt, {
      argA: index,
      argB: updateValue
    }, true, false);
  };

  var replace = function replace(value) {
    var updatedFieldArrayValues = convertToArrayPayload(cloneObject$1(value));
    ids.current = updatedFieldArrayValues.map(generateId);
    updateValues(_toConsumableArray2(updatedFieldArrayValues));
    setFields(_toConsumableArray2(updatedFieldArrayValues));

    control._setFieldArray(name, _toConsumableArray2(updatedFieldArrayValues), function (data) {
      return data;
    }, {}, true, false);
  };

  React__default.useEffect(function () {
    control._state.action = false;
    isWatched(name, control._names) && control._subjects.state.next(_objectSpread3({}, control._formState));

    if (_actioned.current && (!getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted) && !getValidationModes(control._options.reValidateMode).isOnSubmit) {
      if (control._options.resolver) {
        control._runSchema([name]).then(function (result) {
          var error = _get2(result.errors, name);

          var existingError = _get2(control._formState.errors, name);

          if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
            error ? set$1(control._formState.errors, name, error) : unset(control._formState.errors, name);

            control._subjects.state.next({
              errors: control._formState.errors
            });
          }
        });
      } else {
        var field = _get2(control._fields, name);

        if (field && field._f && !(getValidationModes(control._options.reValidateMode).isOnSubmit && getValidationModes(control._options.mode).isOnSubmit)) {
          validateField(field, control._names.disabled, control._formValues, control._options.criteriaMode === VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then(function (error) {
            return !isEmptyObject(error) && control._subjects.state.next({
              errors: updateFieldArrayRootError(control._formState.errors, error, name)
            });
          });
        }
      }
    }

    control._subjects.state.next({
      name: name,
      values: cloneObject$1(control._formValues)
    });

    control._names.focus && iterateFieldsByAction(control._fields, function (ref, key) {
      if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
        ref.focus();
        return 1;
      }

      return;
    });
    control._names.focus = '';

    control._setValid();

    _actioned.current = false;
  }, [fields, name, control]);
  React__default.useEffect(function () {
    !_get2(control._formValues, name) && control._setFieldArray(name);
    return function () {
      var updateMounted = function updateMounted(name, value) {
        var field = _get2(control._fields, name);

        if (field && field._f) {
          field._f.mount = value;
        }
      };

      control._options.shouldUnregister || shouldUnregister ? control.unregister(name) : updateMounted(name, false);
    };
  }, [name, control, keyName, shouldUnregister]);
  return {
    swap: React__default.useCallback(swap, [updateValues, name, control]),
    move: React__default.useCallback(move, [updateValues, name, control]),
    prepend: React__default.useCallback(prepend, [updateValues, name, control]),
    append: React__default.useCallback(append, [updateValues, name, control]),
    remove: React__default.useCallback(remove, [updateValues, name, control]),
    insert: React__default.useCallback(insert$1, [updateValues, name, control]),
    update: React__default.useCallback(update, [updateValues, name, control]),
    replace: React__default.useCallback(replace, [updateValues, name, control]),
    fields: React__default.useMemo(function () {
      return fields.map(function (field, index) {
        return _objectSpread3(_objectSpread3({}, field), {}, _defineProperty2({}, keyName, ids.current[index] || generateId()));
      });
    }, [fields, keyName])
  };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */


function useForm() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _formControl = React__default.useRef(undefined);

  var _values = React__default.useRef(undefined);

  var _React__default$useSt7 = React__default.useState({
    isDirty: false,
    isValidating: false,
    isLoading: isFunction$2(props.defaultValues),
    isSubmitted: false,
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: props.errors || {},
    disabled: props.disabled || false,
    isReady: false,
    defaultValues: isFunction$2(props.defaultValues) ? undefined : props.defaultValues
  }),
      _React__default$useSt8 = _slicedToArray2(_React__default$useSt7, 2),
      formState = _React__default$useSt8[0],
      updateFormState = _React__default$useSt8[1];

  if (!_formControl.current) {
    if (props.formControl) {
      _formControl.current = _objectSpread3(_objectSpread3({}, props.formControl), {}, {
        formState: formState
      });

      if (props.defaultValues && !isFunction$2(props.defaultValues)) {
        props.formControl.reset(props.defaultValues, props.resetOptions);
      }
    } else {
      var _createFormControl = createFormControl(props),
          formControl = _createFormControl.formControl,
          rest = _objectWithoutProperties2(_createFormControl, _excluded9);

      _formControl.current = _objectSpread3(_objectSpread3({}, rest), {}, {
        formState: formState
      });
    }
  }

  var control = _formControl.current.control;
  control._options = props;
  useIsomorphicLayoutEffect$1(function () {
    var sub = control._subscribe({
      formState: control._proxyFormState,
      callback: function callback() {
        return updateFormState(_objectSpread3({}, control._formState));
      },
      reRenderRoot: true
    });

    updateFormState(function (data) {
      return _objectSpread3(_objectSpread3({}, data), {}, {
        isReady: true
      });
    });
    control._formState.isReady = true;
    return sub;
  }, [control]);
  React__default.useEffect(function () {
    return control._disableForm(props.disabled);
  }, [control, props.disabled]);
  React__default.useEffect(function () {
    if (props.mode) {
      control._options.mode = props.mode;
    }

    if (props.reValidateMode) {
      control._options.reValidateMode = props.reValidateMode;
    }
  }, [control, props.mode, props.reValidateMode]);
  React__default.useEffect(function () {
    if (props.errors) {
      control._setErrors(props.errors);

      control._focusError();
    }
  }, [control, props.errors]);
  React__default.useEffect(function () {
    props.shouldUnregister && control._subjects.state.next({
      values: control._getWatch()
    });
  }, [control, props.shouldUnregister]);
  React__default.useEffect(function () {
    if (control._proxyFormState.isDirty) {
      var _isDirty = control._getDirty();

      if (_isDirty !== formState.isDirty) {
        control._subjects.state.next({
          isDirty: _isDirty
        });
      }
    }
  }, [control, formState.isDirty]);
  React__default.useEffect(function () {
    if (props.values && !deepEqual(props.values, _values.current)) {
      control._reset(props.values, _objectSpread3({
        keepFieldsRef: true
      }, control._options.resetOptions));

      _values.current = props.values;
      updateFormState(function (state) {
        return _objectSpread3({}, state);
      });
    } else {
      control._resetDefaultValues();
    }
  }, [control, props.values]);
  React__default.useEffect(function () {
    if (!control._state.mount) {
      control._setValid();

      control._state.mount = true;
    }

    if (control._state.watch) {
      control._state.watch = false;

      control._subjects.state.next(_objectSpread3({}, control._formState));
    }

    control._removeUnmounted();
  });
  _formControl.current.formState = getProxyFormState(formState, control);
  return _formControl.current;
}

var _excluded$I = ["name", "label"];

function ownKeys$1G(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1G(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1G(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1G(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function FormCheckbox(_ref) {
  var _get;

  var name = _ref.name,
      label = _ref.label,
      props = _objectWithoutProperties$8(_ref, _excluded$I);

  var _useFormContext = useFormContext(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var error = (_get = _get2(errors, name)) === null || _get === void 0 ? void 0 : _get.message;
  var id = "checkbox-".concat(name);
  return /*#__PURE__*/jsxs(Stack$1, {
    gap: 1,
    children: [/*#__PURE__*/jsxs(Box, {
      gap: 2,
      children: [/*#__PURE__*/jsx$1(Controller, {
        name: name,
        control: control,
        render: function render(_ref2) {
          var field = _ref2.field;
          return /*#__PURE__*/jsx$1(Checkbox$1, _objectSpread$1G({
            id: id,
            checked: !!field.value,
            onChange: function onChange(e) {
              return field.onChange(e.target.checked);
            }
          }, props));
        }
      }), label && /*#__PURE__*/jsx$1(Text, {
        as: "label",
        variant: "paragraph-xsmall",
        color: "neutral-700",
        htmlFor: id,
        children: label
      })]
    }), error && /*#__PURE__*/jsx$1(Text, {
      id: "".concat(name, "-error"),
      color: "destructive-400",
      variant: "paragraph-xsmall",
      children: error
    })]
  });
}

var _excluded$H = ["name", "label", "placeholder", "type", "stackProps", "disabled"];

function ownKeys$1F(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1F(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1F(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1F(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function FormInput(_ref) {
  var _get;

  var name = _ref.name,
      label = _ref.label,
      placeholder = _ref.placeholder,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      stackProps = _ref.stackProps,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      props = _objectWithoutProperties$8(_ref, _excluded$H);

  var _useFormContext = useFormContext(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var error = (_get = _get2(errors, name)) === null || _get === void 0 ? void 0 : _get.message;
  var id = "input-".concat(name);
  return /*#__PURE__*/jsxs(Stack$1, _objectSpread$1F(_objectSpread$1F({
    gap: 1
  }, stackProps), {}, {
    children: [label && /*#__PURE__*/jsx$1(Text, {
      as: "label",
      variant: "paragraph-xsmall",
      color: "neutral-500",
      htmlFor: id,
      style: {
        cursor: 'pointer'
      },
      children: label
    }), /*#__PURE__*/jsx$1(Controller, {
      name: name,
      control: control,
      render: function render(_ref2) {
        var field = _ref2.field;
        return /*#__PURE__*/jsx$1(Input$3, _objectSpread$1F(_objectSpread$1F({}, field), {}, {
          id: id,
          type: type,
          placeholder: placeholder,
          "aria-invalid": !!error,
          "aria-describedby": "".concat(name, "-error"),
          padding: "8px 16px",
          border: "none",
          borderBottom: "1px solid",
          borderColor: "neutral-200",
          color: "neutral-700",
          fontWeight: "medium",
          disabled: disabled
        }, props));
      }
    }), error && /*#__PURE__*/jsx$1(Text, {
      id: "".concat(name, "-error"),
      color: "destructive-400",
      variant: "paragraph-xsmall",
      children: error
    })]
  }));
}
/** Erros on the root schema and not on a specific property can be displayed with this */


function FormRootError(_ref) {
  var _fieldError$root;

  var name = _ref.name;

  var _useFormContext = useFormContext(),
      errors = _useFormContext.formState.errors;

  var fieldError = _get2(errors, name);

  if (!(fieldError !== null && fieldError !== void 0 && (_fieldError$root = fieldError.root) !== null && _fieldError$root !== void 0 && _fieldError$root.message)) return null;
  return /*#__PURE__*/jsx$1(Text, {
    color: "destructive-400",
    variant: "paragraph-xsmall",
    children: String(fieldError.root.message)
  });
}

function FormSelect(_ref) {
  var _get;

  var name = _ref.name,
      label = _ref.label,
      options = _ref.options,
      placeholder = _ref.placeholder,
      _ref$isClearable = _ref.isClearable,
      isClearable = _ref$isClearable === void 0 ? false : _ref$isClearable;

  var _useFormContext = useFormContext(),
      control = _useFormContext.control,
      errors = _useFormContext.formState.errors;

  var error = (_get = _get2(errors, name)) === null || _get === void 0 ? void 0 : _get.message;
  return /*#__PURE__*/jsxs(Stack$1, {
    gap: 1,
    children: [label && /*#__PURE__*/jsx$1(Text, {
      variant: "paragraph-xsmall",
      color: "neutral-500",
      children: label
    }), /*#__PURE__*/jsx$1(Controller, {
      control: control,
      name: name,
      render: function render(_ref2) {
        var _options$find;

        var field = _ref2.field;
        var selected = (_options$find = options.find(function (opt) {
          return opt.value === field.value;
        })) !== null && _options$find !== void 0 ? _options$find : null;
        return /*#__PURE__*/jsx$1(Dropdown$1, {
          error: !!error,
          value: selected,
          onChange: function onChange(opt) {
            return field.onChange(opt === null || opt === void 0 ? void 0 : opt.value);
          },
          options: options,
          placeholder: placeholder,
          isClearable: isClearable
        });
      }
    }), error && /*#__PURE__*/jsx$1(Text, {
      color: "destructive-400",
      variant: "paragraph-xsmall",
      children: error
    })]
  });
}

function _regenerator$1l() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1l(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1l(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1l(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1l(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1l(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1l(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1l(u), _regeneratorDefine2$1l(u, o, "Generator"), _regeneratorDefine2$1l(u, n, function () {
    return this;
  }), _regeneratorDefine2$1l(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1l = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1l(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1l = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1l(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1l(e, r, n, t);
}

var DnsContext = /*#__PURE__*/React__default.createContext(undefined);

function DnsProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(),
      _useState2 = _slicedToArray$4(_useState, 2),
      records = _useState2[0],
      setRecords = _useState2[1];

  var _useParams = useParams(),
      domainName = _useParams.domainName;

  var refreshRecords = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1l().m(function _callee() {
    var _yield$api$dns$fetchR, _yield$api$dns$fetchR2, fetchedRecords, error;

    return _regenerator$1l().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            _context.n = 1;
            return api.dns.fetchRecords(domainName);

          case 1:
            _yield$api$dns$fetchR = _context.v;
            _yield$api$dns$fetchR2 = _slicedToArray$4(_yield$api$dns$fetchR, 2);
            fetchedRecords = _yield$api$dns$fetchR2[0];
            error = _yield$api$dns$fetchR2[1];

            if (error) {
              toast.error(error);
            } else {
              setRecords(fetchedRecords);
            }

          case 2:
            return _context.a(2);
        }
      }
    }, _callee);
  })), [domainName]);
  useEffect(function () {
    refreshRecords();
  }, [refreshRecords]);
  return /*#__PURE__*/jsx$1(DnsContext.Provider, {
    value: {
      records: records,
      refreshRecords: refreshRecords,
      domainName: domainName
    },
    children: children
  });
}

function useDnsProvider() {
  var context = React__default.useContext(DnsContext);

  if (context === undefined) {
    throw new Error('useDnsProvider must be used within a DnsProvider');
  }

  return context;
}

var EDUCATION_LINKS = _defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6({}, DnsRecordTypes.A, {
  'rebel.com': 'https://support.rebel.com/hc/en-us/articles/227817687-What-are-Address-A-Records-and-how-do-I-edit-add-them',
  'rebel.ca': 'https://support.rebel.com/hc/en-us/articles/227817687-What-are-Address-A-Records-and-how-do-I-edit-add-them',
  'internic.ca': 'https://support.internic.ca/hc/en-us/articles/229510587-What-are-Address-A-Records-and-how-do-I-edit-add-them'
}), DnsRecordTypes.AAAA, {
  'rebel.com': 'https://support.rebel.com/hc/en-us/articles/227832827-How-do-I-add-IPv6-Address-AAAA-Records',
  'rebel.ca': 'https://support.rebel.com/hc/en-us/articles/227832827-How-do-I-add-IPv6-Address-AAAA-Records',
  'internic.ca': 'https://support.internic.ca/hc/en-us/articles/229511747-How-do-I-add-IPv6-Address-AAAA-Records'
}), DnsRecordTypes.CAA, {
  'rebel.com': undefined,
  'rebel.ca': undefined,
  'internic.ca': undefined
}), DnsRecordTypes.CNAME, {
  'rebel.com': 'https://support.rebel.com/hc/en-us/articles/227817707-What-are-Canonical-Name-CNAME-Records-and-how-do-I-edit-add-them',
  'rebel.ca': 'https://support.rebel.com/hc/en-us/articles/227817707-What-are-Canonical-Name-CNAME-Records-and-how-do-I-edit-add-them',
  'internic.ca': 'https://support.internic.ca/hc/en-us/articles/229511627-What-are-Canonical-Name-CNAME-Records-and-how-do-I-edit-add-them'
}), DnsRecordTypes.MX, {
  'rebel.com': 'https://support.rebel.com/hc/en-us/articles/115000808853-What-are-Mail-Exchanger-MX-Records-and-how-do-I-edit-add-them',
  'rebel.ca': 'https://support.rebel.com/hc/en-us/articles/115000808853-What-are-Mail-Exchanger-MX-Records-and-how-do-I-edit-add-them',
  'internic.ca': 'https://support.internic.ca/hc/en-us/articles/229863228-What-are-Mail-Exchanger-MX-Records-and-how-do-I-edit-add-them'
}), DnsRecordTypes.NS, {
  'rebel.com': 'https://support.rebel.com/hc/en-us/articles/360005366294-What-are-Authoritative-Name-Server-NS-Records-and-how-do-I-edit-add-them',
  'rebel.ca': 'https://support.rebel.com/hc/en-us/articles/360005366294-What-are-Authoritative-Name-Server-NS-Records-and-how-do-I-edit-add-them',
  'internic.ca': 'https://support.internic.ca/hc/en-us/articles/360022147774-What-are-Authoritative-Name-Server-NS-Records-and-how-do-I-edit-add-them'
}), DnsRecordTypes.SPF, {
  'rebel.com': 'https://support.rebel.com/hc/en-us/articles/227967408-What-are-Sender-Policy-Framework-SPF-Records-and-how-do-I-edit-add-them',
  'rebel.ca': 'https://support.rebel.com/hc/en-us/articles/227967408-What-are-Sender-Policy-Framework-SPF-Records-and-how-do-I-edit-add-them',
  'internic.ca': 'https://support.internic.ca/hc/en-us/articles/229864548-What-are-Sender-Policy-Framework-SPF-Records-and-how-do-I-edit-add-them'
}), DnsRecordTypes.SRV, {
  'rebel.com': 'https://support.rebel.com/hc/en-us/articles/360005368454-What-are-Service-SRV-Records-and-how-do-I-edit-add-them',
  'rebel.ca': 'https://support.rebel.com/hc/en-us/articles/360005368454-What-are-Service-SRV-Records-and-how-do-I-edit-add-them',
  'internic.ca': 'https://support.internic.ca/hc/en-us/articles/360021582414-What-are-Service-SRV-Records-and-how-do-I-edit-add-them'
}), DnsRecordTypes.TXT, {
  'rebel.com': 'https://support.rebel.com/hc/en-us/articles/227969668-What-are-Text-TXT-Records-and-how-do-I-edit-add-them',
  'rebel.ca': 'https://support.rebel.com/hc/en-us/articles/227969668-What-are-Text-TXT-Records-and-how-do-I-edit-add-them',
  'internic.ca': 'https://support.internic.ca/hc/en-us/articles/229511527-What-are-Text-TXT-Records-and-how-do-I-edit-add-them'
});

var util;

(function (util) {
  util.assertEqual = function (_) {};

  function assertIs(_arg) {}

  util.assertIs = assertIs;

  function assertNever(_x) {
    throw new Error();
  }

  util.assertNever = assertNever;

  util.arrayToEnum = function (items) {
    var obj = {};

    var _iterator13 = _createForOfIteratorHelper(items),
        _step13;

    try {
      for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
        var item = _step13.value;
        obj[item] = item;
      }
    } catch (err) {
      _iterator13.e(err);
    } finally {
      _iterator13.f();
    }

    return obj;
  };

  util.getValidEnumValues = function (obj) {
    var validKeys = util.objectKeys(obj).filter(function (k) {
      return typeof obj[obj[k]] !== "number";
    });
    var filtered = {};

    var _iterator14 = _createForOfIteratorHelper(validKeys),
        _step14;

    try {
      for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
        var _k2 = _step14.value;
        filtered[_k2] = obj[_k2];
      }
    } catch (err) {
      _iterator14.e(err);
    } finally {
      _iterator14.f();
    }

    return util.objectValues(filtered);
  };

  util.objectValues = function (obj) {
    return util.objectKeys(obj).map(function (e) {
      return obj[e];
    });
  };

  util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
  ? function (obj) {
    return Object.keys(obj);
  } // eslint-disable-line ban/ban
  : function (object) {
    var keys = [];

    for (var key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        keys.push(key);
      }
    }

    return keys;
  };

  util.find = function (arr, checker) {
    var _iterator15 = _createForOfIteratorHelper(arr),
        _step15;

    try {
      for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
        var item = _step15.value;
        if (checker(item)) return item;
      }
    } catch (err) {
      _iterator15.e(err);
    } finally {
      _iterator15.f();
    }

    return undefined;
  };

  util.isInteger = typeof Number.isInteger === "function" ? function (val) {
    return Number.isInteger(val);
  } // eslint-disable-line ban/ban
  : function (val) {
    return typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
  };

  function joinValues(array) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : " | ";
    return array.map(function (val) {
      return typeof val === "string" ? "'".concat(val, "'") : val;
    }).join(separator);
  }

  util.joinValues = joinValues;

  util.jsonStringifyReplacer = function (_, value) {
    if (typeof value === "bigint") {
      return value.toString();
    }

    return value;
  };
})(util || (util = {}));

var objectUtil;

(function (objectUtil) {
  objectUtil.mergeShapes = function (first, second) {
    return _objectSpread3(_objectSpread3({}, first), second);
  };
})(objectUtil || (objectUtil = {}));

var ZodParsedType = util.arrayToEnum(["string", "nan", "number", "integer", "float", "boolean", "date", "bigint", "symbol", "function", "undefined", "null", "array", "object", "unknown", "promise", "void", "never", "map", "set"]);

var getParsedType = function getParsedType(data) {
  var t = typeof data;

  switch (t) {
    case "undefined":
      return ZodParsedType.undefined;

    case "string":
      return ZodParsedType.string;

    case "number":
      return Number.isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;

    case "boolean":
      return ZodParsedType.boolean;

    case "function":
      return ZodParsedType.function;

    case "bigint":
      return ZodParsedType.bigint;

    case "symbol":
      return ZodParsedType.symbol;

    case "object":
      if (Array.isArray(data)) {
        return ZodParsedType.array;
      }

      if (data === null) {
        return ZodParsedType.null;
      }

      if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") {
        return ZodParsedType.promise;
      }

      if (typeof Map !== "undefined" && data instanceof Map) {
        return ZodParsedType.map;
      }

      if (typeof Set !== "undefined" && data instanceof Set) {
        return ZodParsedType.set;
      }

      if (typeof Date !== "undefined" && data instanceof Date) {
        return ZodParsedType.date;
      }

      return ZodParsedType.object;

    default:
      return ZodParsedType.unknown;
  }
};

var ZodIssueCode = util.arrayToEnum(["invalid_type", "invalid_literal", "custom", "invalid_union", "invalid_union_discriminator", "invalid_enum_value", "unrecognized_keys", "invalid_arguments", "invalid_return_type", "invalid_date", "invalid_string", "too_small", "too_big", "invalid_intersection_types", "not_multiple_of", "not_finite"]);

var quotelessJson = function quotelessJson(obj) {
  var json = JSON.stringify(obj, null, 2);
  return json.replace(/"([^"]+)":/g, "$1:");
};

var ZodError = /*#__PURE__*/function (_Error) {
  _inherits2(ZodError, _Error);

  var _super11 = _createSuper2(ZodError);

  function ZodError(issues) {
    var _this15;

    _classCallCheck2(this, ZodError);

    _this15 = _super11.call(this);
    _this15.issues = [];

    _this15.addIssue = function (sub) {
      _this15.issues = [].concat(_toConsumableArray2(_this15.issues), [sub]);
    };

    _this15.addIssues = function () {
      var subs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      _this15.issues = [].concat(_toConsumableArray2(_this15.issues), _toConsumableArray2(subs));
    };

    var actualProto = (this instanceof ZodError ? this.constructor : void 0).prototype;

    if (Object.setPrototypeOf) {
      // eslint-disable-next-line ban/ban
      Object.setPrototypeOf(_assertThisInitialized2(_this15), actualProto);
    } else {
      _this15.__proto__ = actualProto;
    }

    _this15.name = "ZodError";
    _this15.issues = issues;
    return _this15;
  }

  _createClass2(ZodError, [{
    key: "errors",
    get: function get() {
      return this.issues;
    }
  }, {
    key: "format",
    value: function format(_mapper) {
      var mapper = _mapper || function (issue) {
        return issue.message;
      };

      var fieldErrors = {
        _errors: []
      };

      var processError = function processError(error) {
        var _iterator16 = _createForOfIteratorHelper(error.issues),
            _step16;

        try {
          for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
            var issue = _step16.value;

            if (issue.code === "invalid_union") {
              issue.unionErrors.map(processError);
            } else if (issue.code === "invalid_return_type") {
              processError(issue.returnTypeError);
            } else if (issue.code === "invalid_arguments") {
              processError(issue.argumentsError);
            } else if (issue.path.length === 0) {
              fieldErrors._errors.push(mapper(issue));
            } else {
              var curr = fieldErrors;
              var _i15 = 0;

              while (_i15 < issue.path.length) {
                var el = issue.path[_i15];
                var terminal = _i15 === issue.path.length - 1;

                if (!terminal) {
                  curr[el] = curr[el] || {
                    _errors: []
                  }; // if (typeof el === "string") {
                  //   curr[el] = curr[el] || { _errors: [] };
                  // } else if (typeof el === "number") {
                  //   const errorArray: any = [];
                  //   errorArray._errors = [];
                  //   curr[el] = curr[el] || errorArray;
                  // }
                } else {
                  curr[el] = curr[el] || {
                    _errors: []
                  };

                  curr[el]._errors.push(mapper(issue));
                }

                curr = curr[el];
                _i15++;
              }
            }
          }
        } catch (err) {
          _iterator16.e(err);
        } finally {
          _iterator16.f();
        }
      };

      processError(this);
      return fieldErrors;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.message;
    }
  }, {
    key: "message",
    get: function get() {
      return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
    }
  }, {
    key: "isEmpty",
    get: function get() {
      return this.issues.length === 0;
    }
  }, {
    key: "flatten",
    value: function flatten() {
      var mapper = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (issue) {
        return issue.message;
      };
      var fieldErrors = {};
      var formErrors = [];

      var _iterator17 = _createForOfIteratorHelper(this.issues),
          _step17;

      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var sub = _step17.value;

          if (sub.path.length > 0) {
            var firstEl = sub.path[0];
            fieldErrors[firstEl] = fieldErrors[firstEl] || [];
            fieldErrors[firstEl].push(mapper(sub));
          } else {
            formErrors.push(mapper(sub));
          }
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }

      return {
        formErrors: formErrors,
        fieldErrors: fieldErrors
      };
    }
  }, {
    key: "formErrors",
    get: function get() {
      return this.flatten();
    }
  }], [{
    key: "assert",
    value: function assert(value) {
      if (!(value instanceof ZodError)) {
        throw new Error("Not a ZodError: ".concat(value));
      }
    }
  }]);

  return ZodError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

ZodError.create = function (issues) {
  var error = new ZodError(issues);
  return error;
};

var errorMap = function errorMap(issue, _ctx) {
  var message;

  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === ZodParsedType.undefined) {
        message = "Required";
      } else {
        message = "Expected ".concat(issue.expected, ", received ").concat(issue.received);
      }

      break;

    case ZodIssueCode.invalid_literal:
      message = "Invalid literal value, expected ".concat(JSON.stringify(issue.expected, util.jsonStringifyReplacer));
      break;

    case ZodIssueCode.unrecognized_keys:
      message = "Unrecognized key(s) in object: ".concat(util.joinValues(issue.keys, ", "));
      break;

    case ZodIssueCode.invalid_union:
      message = "Invalid input";
      break;

    case ZodIssueCode.invalid_union_discriminator:
      message = "Invalid discriminator value. Expected ".concat(util.joinValues(issue.options));
      break;

    case ZodIssueCode.invalid_enum_value:
      message = "Invalid enum value. Expected ".concat(util.joinValues(issue.options), ", received '").concat(issue.received, "'");
      break;

    case ZodIssueCode.invalid_arguments:
      message = "Invalid function arguments";
      break;

    case ZodIssueCode.invalid_return_type:
      message = "Invalid function return type";
      break;

    case ZodIssueCode.invalid_date:
      message = "Invalid date";
      break;

    case ZodIssueCode.invalid_string:
      if (typeof issue.validation === "object") {
        if ("includes" in issue.validation) {
          message = "Invalid input: must include \"".concat(issue.validation.includes, "\"");

          if (typeof issue.validation.position === "number") {
            message = "".concat(message, " at one or more positions greater than or equal to ").concat(issue.validation.position);
          }
        } else if ("startsWith" in issue.validation) {
          message = "Invalid input: must start with \"".concat(issue.validation.startsWith, "\"");
        } else if ("endsWith" in issue.validation) {
          message = "Invalid input: must end with \"".concat(issue.validation.endsWith, "\"");
        } else {
          util.assertNever(issue.validation);
        }
      } else if (issue.validation !== "regex") {
        message = "Invalid ".concat(issue.validation);
      } else {
        message = "Invalid";
      }

      break;

    case ZodIssueCode.too_small:
      if (issue.type === "array") message = "Array must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at least" : "more than", " ").concat(issue.minimum, " element(s)");else if (issue.type === "string") message = "String must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at least" : "over", " ").concat(issue.minimum, " character(s)");else if (issue.type === "number") message = "Number must be ".concat(issue.exact ? "exactly equal to " : issue.inclusive ? "greater than or equal to " : "greater than ").concat(issue.minimum);else if (issue.type === "bigint") message = "Number must be ".concat(issue.exact ? "exactly equal to " : issue.inclusive ? "greater than or equal to " : "greater than ").concat(issue.minimum);else if (issue.type === "date") message = "Date must be ".concat(issue.exact ? "exactly equal to " : issue.inclusive ? "greater than or equal to " : "greater than ").concat(new Date(Number(issue.minimum)));else message = "Invalid input";
      break;

    case ZodIssueCode.too_big:
      if (issue.type === "array") message = "Array must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at most" : "less than", " ").concat(issue.maximum, " element(s)");else if (issue.type === "string") message = "String must contain ".concat(issue.exact ? "exactly" : issue.inclusive ? "at most" : "under", " ").concat(issue.maximum, " character(s)");else if (issue.type === "number") message = "Number must be ".concat(issue.exact ? "exactly" : issue.inclusive ? "less than or equal to" : "less than", " ").concat(issue.maximum);else if (issue.type === "bigint") message = "BigInt must be ".concat(issue.exact ? "exactly" : issue.inclusive ? "less than or equal to" : "less than", " ").concat(issue.maximum);else if (issue.type === "date") message = "Date must be ".concat(issue.exact ? "exactly" : issue.inclusive ? "smaller than or equal to" : "smaller than", " ").concat(new Date(Number(issue.maximum)));else message = "Invalid input";
      break;

    case ZodIssueCode.custom:
      message = "Invalid input";
      break;

    case ZodIssueCode.invalid_intersection_types:
      message = "Intersection results could not be merged";
      break;

    case ZodIssueCode.not_multiple_of:
      message = "Number must be a multiple of ".concat(issue.multipleOf);
      break;

    case ZodIssueCode.not_finite:
      message = "Number must be finite";
      break;

    default:
      message = _ctx.defaultError;
      util.assertNever(issue);
  }

  return {
    message: message
  };
};

var defaultErrorMap = errorMap;
var overrideErrorMap = defaultErrorMap;

function setErrorMap(map) {
  overrideErrorMap = map;
}

function getErrorMap() {
  return overrideErrorMap;
}

var makeIssue = function makeIssue(params) {
  var data = params.data,
      path = params.path,
      errorMaps = params.errorMaps,
      issueData = params.issueData;
  var fullPath = [].concat(_toConsumableArray2(path), _toConsumableArray2(issueData.path || []));

  var fullIssue = _objectSpread3(_objectSpread3({}, issueData), {}, {
    path: fullPath
  });

  if (issueData.message !== undefined) {
    return _objectSpread3(_objectSpread3({}, issueData), {}, {
      path: fullPath,
      message: issueData.message
    });
  }

  var errorMessage = "";
  var maps = errorMaps.filter(function (m) {
    return !!m;
  }).slice().reverse();

  var _iterator18 = _createForOfIteratorHelper(maps),
      _step18;

  try {
    for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
      var _map = _step18.value;
      errorMessage = _map(fullIssue, {
        data: data,
        defaultError: errorMessage
      }).message;
    }
  } catch (err) {
    _iterator18.e(err);
  } finally {
    _iterator18.f();
  }

  return _objectSpread3(_objectSpread3({}, issueData), {}, {
    path: fullPath,
    message: errorMessage
  });
};

var EMPTY_PATH = [];

function addIssueToContext(ctx, issueData) {
  var overrideMap = getErrorMap();
  var issue = makeIssue({
    issueData: issueData,
    data: ctx.data,
    path: ctx.path,
    errorMaps: [ctx.common.contextualErrorMap, // contextual error map is first priority
    ctx.schemaErrorMap, // then schema-bound map if available
    overrideMap, // then global override map
    overrideMap === defaultErrorMap ? undefined : defaultErrorMap // then global default map
    ].filter(function (x) {
      return !!x;
    })
  });
  ctx.common.issues.push(issue);
}

var ParseStatus = /*#__PURE__*/function () {
  function ParseStatus() {
    _classCallCheck2(this, ParseStatus);

    this.value = "valid";
  }

  _createClass2(ParseStatus, [{
    key: "dirty",
    value: function dirty() {
      if (this.value === "valid") this.value = "dirty";
    }
  }, {
    key: "abort",
    value: function abort() {
      if (this.value !== "aborted") this.value = "aborted";
    }
  }], [{
    key: "mergeArray",
    value: function mergeArray(status, results) {
      var arrayValue = [];

      var _iterator19 = _createForOfIteratorHelper(results),
          _step19;

      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var s = _step19.value;
          if (s.status === "aborted") return INVALID;
          if (s.status === "dirty") status.dirty();
          arrayValue.push(s.value);
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }

      return {
        status: status.value,
        value: arrayValue
      };
    }
  }, {
    key: "mergeObjectAsync",
    value: function () {
      var _mergeObjectAsync = _asyncToGenerator2( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(status, pairs) {
        var syncPairs, _iterator20, _step20, pair, key, value;

        return _regeneratorRuntime.wrap(function _callee20$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                syncPairs = [];
                _iterator20 = _createForOfIteratorHelper(pairs);
                _context21.prev = 2;

                _iterator20.s();

              case 4:
                if ((_step20 = _iterator20.n()).done) {
                  _context21.next = 15;
                  break;
                }

                pair = _step20.value;
                _context21.next = 8;
                return pair.key;

              case 8:
                key = _context21.sent;
                _context21.next = 11;
                return pair.value;

              case 11:
                value = _context21.sent;
                syncPairs.push({
                  key: key,
                  value: value
                });

              case 13:
                _context21.next = 4;
                break;

              case 15:
                _context21.next = 20;
                break;

              case 17:
                _context21.prev = 17;
                _context21.t0 = _context21["catch"](2);

                _iterator20.e(_context21.t0);

              case 20:
                _context21.prev = 20;

                _iterator20.f();

                return _context21.finish(20);

              case 23:
                return _context21.abrupt("return", ParseStatus.mergeObjectSync(status, syncPairs));

              case 24:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee20, null, [[2, 17, 20, 23]]);
      }));

      function mergeObjectAsync(_x38, _x39) {
        return _mergeObjectAsync.apply(this, arguments);
      }

      return mergeObjectAsync;
    }()
  }, {
    key: "mergeObjectSync",
    value: function mergeObjectSync(status, pairs) {
      var finalObject = {};

      var _iterator21 = _createForOfIteratorHelper(pairs),
          _step21;

      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var pair = _step21.value;
          var key = pair.key,
              value = pair.value;
          if (key.status === "aborted") return INVALID;
          if (value.status === "aborted") return INVALID;
          if (key.status === "dirty") status.dirty();
          if (value.status === "dirty") status.dirty();

          if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) {
            finalObject[key.value] = value.value;
          }
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }

      return {
        status: status.value,
        value: finalObject
      };
    }
  }]);

  return ParseStatus;
}();

var INVALID = Object.freeze({
  status: "aborted"
});

var DIRTY = function DIRTY(value) {
  return {
    status: "dirty",
    value: value
  };
};

var OK = function OK(value) {
  return {
    status: "valid",
    value: value
  };
};

var isAborted = function isAborted(x) {
  return x.status === "aborted";
};

var isDirty = function isDirty(x) {
  return x.status === "dirty";
};

var isValid = function isValid(x) {
  return x.status === "valid";
};

var isAsync = function isAsync(x) {
  return typeof Promise !== "undefined" && x instanceof Promise;
};

var errorUtil;

(function (errorUtil) {
  errorUtil.errToObj = function (message) {
    return typeof message === "string" ? {
      message: message
    } : message || {};
  }; // biome-ignore lint:


  errorUtil.toString = function (message) {
    return typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
  };
})(errorUtil || (errorUtil = {}));

var ParseInputLazyPath = /*#__PURE__*/function () {
  function ParseInputLazyPath(parent, value, path, key) {
    _classCallCheck2(this, ParseInputLazyPath);

    this._cachedPath = [];
    this.parent = parent;
    this.data = value;
    this._path = path;
    this._key = key;
  }

  _createClass2(ParseInputLazyPath, [{
    key: "path",
    get: function get() {
      if (!this._cachedPath.length) {
        if (Array.isArray(this._key)) {
          var _this$_cachedPath;

          (_this$_cachedPath = this._cachedPath).push.apply(_this$_cachedPath, _toConsumableArray2(this._path).concat(_toConsumableArray2(this._key)));
        } else {
          var _this$_cachedPath2;

          (_this$_cachedPath2 = this._cachedPath).push.apply(_this$_cachedPath2, _toConsumableArray2(this._path).concat([this._key]));
        }
      }

      return this._cachedPath;
    }
  }]);

  return ParseInputLazyPath;
}();

var handleResult = function handleResult(ctx, result) {
  if (isValid(result)) {
    return {
      success: true,
      data: result.value
    };
  } else {
    if (!ctx.common.issues.length) {
      throw new Error("Validation failed but no issues detected.");
    }

    return {
      success: false,

      get error() {
        if (this._error) return this._error;
        var error = new ZodError(ctx.common.issues);
        this._error = error;
        return this._error;
      }

    };
  }
};

function processCreateParams(params) {
  if (!params) return {};
  var errorMap = params.errorMap,
      invalid_type_error = params.invalid_type_error,
      required_error = params.required_error,
      description = params.description;

  if (errorMap && (invalid_type_error || required_error)) {
    throw new Error("Can't use \"invalid_type_error\" or \"required_error\" in conjunction with custom error map.");
  }

  if (errorMap) return {
    errorMap: errorMap,
    description: description
  };

  var customMap = function customMap(iss, ctx) {
    var _ref60;

    var message = params.message;

    if (iss.code === "invalid_enum_value") {
      return {
        message: message !== null && message !== void 0 ? message : ctx.defaultError
      };
    }

    if (typeof ctx.data === "undefined") {
      var _ref59;

      return {
        message: (_ref59 = message !== null && message !== void 0 ? message : required_error) !== null && _ref59 !== void 0 ? _ref59 : ctx.defaultError
      };
    }

    if (iss.code !== "invalid_type") return {
      message: ctx.defaultError
    };
    return {
      message: (_ref60 = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _ref60 !== void 0 ? _ref60 : ctx.defaultError
    };
  };

  return {
    errorMap: customMap,
    description: description
  };
}

var ZodType = /*#__PURE__*/function () {
  function ZodType(def) {
    var _this16 = this;

    _classCallCheck2(this, ZodType);

    /** Alias of safeParseAsync */
    this.spa = this.safeParseAsync;
    this._def = def;
    this.parse = this.parse.bind(this);
    this.safeParse = this.safeParse.bind(this);
    this.parseAsync = this.parseAsync.bind(this);
    this.safeParseAsync = this.safeParseAsync.bind(this);
    this.spa = this.spa.bind(this);
    this.refine = this.refine.bind(this);
    this.refinement = this.refinement.bind(this);
    this.superRefine = this.superRefine.bind(this);
    this.optional = this.optional.bind(this);
    this.nullable = this.nullable.bind(this);
    this.nullish = this.nullish.bind(this);
    this.array = this.array.bind(this);
    this.promise = this.promise.bind(this);
    this.or = this.or.bind(this);
    this.and = this.and.bind(this);
    this.transform = this.transform.bind(this);
    this.brand = this.brand.bind(this);
    this.default = this.default.bind(this);
    this.catch = this.catch.bind(this);
    this.describe = this.describe.bind(this);
    this.pipe = this.pipe.bind(this);
    this.readonly = this.readonly.bind(this);
    this.isNullable = this.isNullable.bind(this);
    this.isOptional = this.isOptional.bind(this);
    this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: function validate(data) {
        return _this16["~validate"](data);
      }
    };
  }

  _createClass2(ZodType, [{
    key: "description",
    get: function get() {
      return this._def.description;
    }
  }, {
    key: "_getType",
    value: function _getType(input) {
      return getParsedType(input.data);
    }
  }, {
    key: "_getOrReturnCtx",
    value: function _getOrReturnCtx(input, ctx) {
      return ctx || {
        common: input.parent.common,
        data: input.data,
        parsedType: getParsedType(input.data),
        schemaErrorMap: this._def.errorMap,
        path: input.path,
        parent: input.parent
      };
    }
  }, {
    key: "_processInputParams",
    value: function _processInputParams(input) {
      return {
        status: new ParseStatus(),
        ctx: {
          common: input.parent.common,
          data: input.data,
          parsedType: getParsedType(input.data),
          schemaErrorMap: this._def.errorMap,
          path: input.path,
          parent: input.parent
        }
      };
    }
  }, {
    key: "_parseSync",
    value: function _parseSync(input) {
      var result = this._parse(input);

      if (isAsync(result)) {
        throw new Error("Synchronous parse encountered promise.");
      }

      return result;
    }
  }, {
    key: "_parseAsync",
    value: function _parseAsync(input) {
      var result = this._parse(input);

      return Promise.resolve(result);
    }
  }, {
    key: "parse",
    value: function parse(data, params) {
      var result = this.safeParse(data, params);
      if (result.success) return result.data;
      throw result.error;
    }
  }, {
    key: "safeParse",
    value: function safeParse(data, params) {
      var _params$async;

      var ctx = {
        common: {
          issues: [],
          async: (_params$async = params === null || params === void 0 ? void 0 : params.async) !== null && _params$async !== void 0 ? _params$async : false,
          contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
        },
        path: (params === null || params === void 0 ? void 0 : params.path) || [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data: data,
        parsedType: getParsedType(data)
      };

      var result = this._parseSync({
        data: data,
        path: ctx.path,
        parent: ctx
      });

      return handleResult(ctx, result);
    }
  }, {
    key: "~validate",
    value: function validate(data) {
      var ctx = {
        common: {
          issues: [],
          async: !!this["~standard"].async
        },
        path: [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data: data,
        parsedType: getParsedType(data)
      };

      if (!this["~standard"].async) {
        try {
          var result = this._parseSync({
            data: data,
            path: [],
            parent: ctx
          });

          return isValid(result) ? {
            value: result.value
          } : {
            issues: ctx.common.issues
          };
        } catch (err) {
          var _err$message, _err$message$toLowerC;

          if (err !== null && err !== void 0 && (_err$message = err.message) !== null && _err$message !== void 0 && (_err$message$toLowerC = _err$message.toLowerCase()) !== null && _err$message$toLowerC !== void 0 && _err$message$toLowerC.includes("encountered")) {
            this["~standard"].async = true;
          }

          ctx.common = {
            issues: [],
            async: true
          };
        }
      }

      return this._parseAsync({
        data: data,
        path: [],
        parent: ctx
      }).then(function (result) {
        return isValid(result) ? {
          value: result.value
        } : {
          issues: ctx.common.issues
        };
      });
    }
  }, {
    key: "parseAsync",
    value: function () {
      var _parseAsync2 = _asyncToGenerator2( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(data, params) {
        var result;
        return _regeneratorRuntime.wrap(function _callee21$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return this.safeParseAsync(data, params);

              case 2:
                result = _context22.sent;

                if (!result.success) {
                  _context22.next = 5;
                  break;
                }

                return _context22.abrupt("return", result.data);

              case 5:
                throw result.error;

              case 6:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee21, this);
      }));

      function parseAsync(_x40, _x41) {
        return _parseAsync2.apply(this, arguments);
      }

      return parseAsync;
    }()
  }, {
    key: "safeParseAsync",
    value: function () {
      var _safeParseAsync = _asyncToGenerator2( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(data, params) {
        var ctx, maybeAsyncResult, result;
        return _regeneratorRuntime.wrap(function _callee22$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                ctx = {
                  common: {
                    issues: [],
                    contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                    async: true
                  },
                  path: (params === null || params === void 0 ? void 0 : params.path) || [],
                  schemaErrorMap: this._def.errorMap,
                  parent: null,
                  data: data,
                  parsedType: getParsedType(data)
                };
                maybeAsyncResult = this._parse({
                  data: data,
                  path: ctx.path,
                  parent: ctx
                });
                _context23.next = 4;
                return isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult);

              case 4:
                result = _context23.sent;
                return _context23.abrupt("return", handleResult(ctx, result));

              case 6:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee22, this);
      }));

      function safeParseAsync(_x42, _x43) {
        return _safeParseAsync.apply(this, arguments);
      }

      return safeParseAsync;
    }()
  }, {
    key: "refine",
    value: function refine(check, message) {
      var getIssueProperties = function getIssueProperties(val) {
        if (typeof message === "string" || typeof message === "undefined") {
          return {
            message: message
          };
        } else if (typeof message === "function") {
          return message(val);
        } else {
          return message;
        }
      };

      return this._refinement(function (val, ctx) {
        var result = check(val);

        var setError = function setError() {
          return ctx.addIssue(_objectSpread3({
            code: ZodIssueCode.custom
          }, getIssueProperties(val)));
        };

        if (typeof Promise !== "undefined" && result instanceof Promise) {
          return result.then(function (data) {
            if (!data) {
              setError();
              return false;
            } else {
              return true;
            }
          });
        }

        if (!result) {
          setError();
          return false;
        } else {
          return true;
        }
      });
    }
  }, {
    key: "refinement",
    value: function refinement(check, refinementData) {
      return this._refinement(function (val, ctx) {
        if (!check(val)) {
          ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
          return false;
        } else {
          return true;
        }
      });
    }
  }, {
    key: "_refinement",
    value: function _refinement(refinement) {
      return new ZodEffects({
        schema: this,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect: {
          type: "refinement",
          refinement: refinement
        }
      });
    }
  }, {
    key: "superRefine",
    value: function superRefine(refinement) {
      return this._refinement(refinement);
    }
  }, {
    key: "optional",
    value: function optional() {
      return ZodOptional.create(this, this._def);
    }
  }, {
    key: "nullable",
    value: function nullable() {
      return ZodNullable.create(this, this._def);
    }
  }, {
    key: "nullish",
    value: function nullish() {
      return this.nullable().optional();
    }
  }, {
    key: "array",
    value: function array() {
      return ZodArray.create(this);
    }
  }, {
    key: "promise",
    value: function promise() {
      return ZodPromise.create(this, this._def);
    }
  }, {
    key: "or",
    value: function or(option) {
      return ZodUnion.create([this, option], this._def);
    }
  }, {
    key: "and",
    value: function and(incoming) {
      return ZodIntersection.create(this, incoming, this._def);
    }
  }, {
    key: "transform",
    value: function transform(_transform) {
      return new ZodEffects(_objectSpread3(_objectSpread3({}, processCreateParams(this._def)), {}, {
        schema: this,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect: {
          type: "transform",
          transform: _transform
        }
      }));
    }
  }, {
    key: "default",
    value: function _default(def) {
      var defaultValueFunc = typeof def === "function" ? def : function () {
        return def;
      };
      return new ZodDefault(_objectSpread3(_objectSpread3({}, processCreateParams(this._def)), {}, {
        innerType: this,
        defaultValue: defaultValueFunc,
        typeName: ZodFirstPartyTypeKind.ZodDefault
      }));
    }
  }, {
    key: "brand",
    value: function brand() {
      return new ZodBranded(_objectSpread3({
        typeName: ZodFirstPartyTypeKind.ZodBranded,
        type: this
      }, processCreateParams(this._def)));
    }
  }, {
    key: "catch",
    value: function _catch(def) {
      var catchValueFunc = typeof def === "function" ? def : function () {
        return def;
      };
      return new ZodCatch(_objectSpread3(_objectSpread3({}, processCreateParams(this._def)), {}, {
        innerType: this,
        catchValue: catchValueFunc,
        typeName: ZodFirstPartyTypeKind.ZodCatch
      }));
    }
  }, {
    key: "describe",
    value: function describe(description) {
      var This = this.constructor;
      return new This(_objectSpread3(_objectSpread3({}, this._def), {}, {
        description: description
      }));
    }
  }, {
    key: "pipe",
    value: function pipe(target) {
      return ZodPipeline.create(this, target);
    }
  }, {
    key: "readonly",
    value: function readonly() {
      return ZodReadonly.create(this);
    }
  }, {
    key: "isOptional",
    value: function isOptional() {
      return this.safeParse(undefined).success;
    }
  }, {
    key: "isNullable",
    value: function isNullable() {
      return this.safeParse(null).success;
    }
  }]);

  return ZodType;
}();

var cuidRegex = /^c[^\s-]{8,}$/i;
var cuid2Regex = /^[0-9a-z]+$/;
var ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i; // const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;

var uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
var nanoidRegex = /^[a-z0-9_-]{21}$/i;
var jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
var durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/; // from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;

var emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i; // const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression

var _emojiRegex = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
var emojiRegex; // faster, simpler, safer

var ipv4Regex$1 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
var ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/; // const ipv6Regex =
// /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;

var ipv6Regex$1 = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
var ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/; // https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript

var base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/; // https://base64.guru/standards/base64url

var base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/; // simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation

var dateRegexSource = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))";
var dateRegex$1 = new RegExp("^".concat(dateRegexSource, "$"));

function timeRegexSource(args) {
  var secondsRegexSource = "[0-5]\\d";

  if (args.precision) {
    secondsRegexSource = "".concat(secondsRegexSource, "\\.\\d{").concat(args.precision, "}");
  } else if (args.precision == null) {
    secondsRegexSource = "".concat(secondsRegexSource, "(\\.\\d+)?");
  }

  var secondsQuantifier = args.precision ? "+" : "?"; // require seconds if precision is nonzero

  return "([01]\\d|2[0-3]):[0-5]\\d(:".concat(secondsRegexSource, ")").concat(secondsQuantifier);
}

function timeRegex$1(args) {
  return new RegExp("^".concat(timeRegexSource(args), "$"));
} // Adapted from https://stackoverflow.com/a/3143231


function datetimeRegex(args) {
  var regex = "".concat(dateRegexSource, "T").concat(timeRegexSource(args));
  var opts = [];
  opts.push(args.local ? "Z?" : "Z");
  if (args.offset) opts.push("([+-]\\d{2}:?\\d{2})");
  regex = "".concat(regex, "(").concat(opts.join("|"), ")");
  return new RegExp("^".concat(regex, "$"));
}

function isValidIP(ip, version) {
  if ((version === "v4" || !version) && ipv4Regex$1.test(ip)) {
    return true;
  }

  if ((version === "v6" || !version) && ipv6Regex$1.test(ip)) {
    return true;
  }

  return false;
}

function isValidJWT(jwt, alg) {
  if (!jwtRegex.test(jwt)) return false;

  try {
    var _jwt$split = jwt.split("."),
        _jwt$split2 = _slicedToArray2(_jwt$split, 1),
        header = _jwt$split2[0];

    if (!header) return false; // Convert base64url to base64

    var base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
    var decoded = JSON.parse(atob(base64));
    if (typeof decoded !== "object" || decoded === null) return false;
    if ("typ" in decoded && (decoded === null || decoded === void 0 ? void 0 : decoded.typ) !== "JWT") return false;
    if (!decoded.alg) return false;
    if (alg && decoded.alg !== alg) return false;
    return true;
  } catch (_unused2) {
    return false;
  }
}

function isValidCidr(ip, version) {
  if ((version === "v4" || !version) && ipv4CidrRegex.test(ip)) {
    return true;
  }

  if ((version === "v6" || !version) && ipv6CidrRegex.test(ip)) {
    return true;
  }

  return false;
}

var ZodString = /*#__PURE__*/function (_ZodType) {
  _inherits2(ZodString, _ZodType);

  var _super12 = _createSuper2(ZodString);

  function ZodString() {
    _classCallCheck2(this, ZodString);

    return _super12.apply(this, arguments);
  }

  _createClass2(ZodString, [{
    key: "_parse",
    value: function _parse(input) {
      if (this._def.coerce) {
        input.data = String(input.data);
      }

      var parsedType = this._getType(input);

      if (parsedType !== ZodParsedType.string) {
        var _ctx2 = this._getOrReturnCtx(input);

        addIssueToContext(_ctx2, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.string,
          received: _ctx2.parsedType
        });
        return INVALID;
      }

      var status = new ParseStatus();
      var ctx = undefined;

      var _iterator22 = _createForOfIteratorHelper(this._def.checks),
          _step22;

      try {
        for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
          var _check = _step22.value;

          if (_check.kind === "min") {
            if (input.data.length < _check.value) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                minimum: _check.value,
                type: "string",
                inclusive: true,
                exact: false,
                message: _check.message
              });
              status.dirty();
            }
          } else if (_check.kind === "max") {
            if (input.data.length > _check.value) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                maximum: _check.value,
                type: "string",
                inclusive: true,
                exact: false,
                message: _check.message
              });
              status.dirty();
            }
          } else if (_check.kind === "length") {
            var tooBig = input.data.length > _check.value;
            var tooSmall = input.data.length < _check.value;

            if (tooBig || tooSmall) {
              ctx = this._getOrReturnCtx(input, ctx);

              if (tooBig) {
                addIssueToContext(ctx, {
                  code: ZodIssueCode.too_big,
                  maximum: _check.value,
                  type: "string",
                  inclusive: true,
                  exact: true,
                  message: _check.message
                });
              } else if (tooSmall) {
                addIssueToContext(ctx, {
                  code: ZodIssueCode.too_small,
                  minimum: _check.value,
                  type: "string",
                  inclusive: true,
                  exact: true,
                  message: _check.message
                });
              }

              status.dirty();
            }
          } else if (_check.kind === "email") {
            if (!emailRegex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "email",
                code: ZodIssueCode.invalid_string,
                message: _check.message
              });
              status.dirty();
            }
          } else if (_check.kind === "emoji") {
            if (!emojiRegex) {
              emojiRegex = new RegExp(_emojiRegex, "u");
            }

            if (!emojiRegex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "emoji",
                code: ZodIssueCode.invalid_string,
                message: _check.message
              });
              status.dirty();
            }
          } else if (_check.kind === "uuid") {
            if (!uuidRegex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "uuid",
                code: ZodIssueCode.invalid_string,
                message: _check.message
              });
              status.dirty();
            }
          } else if (_check.kind === "nanoid") {
            if (!nanoidRegex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "nanoid",
                code: ZodIssueCode.invalid_string,
                message: _check.message
              });
              status.dirty();
            }
          } else if (_check.kind === "cuid") {
            if (!cuidRegex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "cuid",
                code: ZodIssueCode.invalid_string,
                message: _check.message
              });
              status.dirty();
            }
          } else if (_check.kind === "cuid2") {
            if (!cuid2Regex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "cuid2",
                code: ZodIssueCode.invalid_string,
                message: _check.message
              });
              status.dirty();
            }
          } else if (_check.kind === "ulid") {
            if (!ulidRegex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "ulid",
                code: ZodIssueCode.invalid_string,
                message: _check.message
              });
              status.dirty();
            }
          } else if (_check.kind === "url") {
            try {
              new URL(input.data);
            } catch (_unused3) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "url",
                code: ZodIssueCode.invalid_string,
                message: _check.message
              });
              status.dirty();
            }
          } else if (_check.kind === "regex") {
            _check.regex.lastIndex = 0;

            var testResult = _check.regex.test(input.data);

            if (!testResult) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "regex",
                code: ZodIssueCode.invalid_string,
                message: _check.message
              });
              status.dirty();
            }
          } else if (_check.kind === "trim") {
            input.data = input.data.trim();
          } else if (_check.kind === "includes") {
            if (!input.data.includes(_check.value, _check.position)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_string,
                validation: {
                  includes: _check.value,
                  position: _check.position
                },
                message: _check.message
              });
              status.dirty();
            }
          } else if (_check.kind === "toLowerCase") {
            input.data = input.data.toLowerCase();
          } else if (_check.kind === "toUpperCase") {
            input.data = input.data.toUpperCase();
          } else if (_check.kind === "startsWith") {
            if (!input.data.startsWith(_check.value)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_string,
                validation: {
                  startsWith: _check.value
                },
                message: _check.message
              });
              status.dirty();
            }
          } else if (_check.kind === "endsWith") {
            if (!input.data.endsWith(_check.value)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_string,
                validation: {
                  endsWith: _check.value
                },
                message: _check.message
              });
              status.dirty();
            }
          } else if (_check.kind === "datetime") {
            var regex = datetimeRegex(_check);

            if (!regex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_string,
                validation: "datetime",
                message: _check.message
              });
              status.dirty();
            }
          } else if (_check.kind === "date") {
            var _regex3 = dateRegex$1;

            if (!_regex3.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_string,
                validation: "date",
                message: _check.message
              });
              status.dirty();
            }
          } else if (_check.kind === "time") {
            var _regex4 = timeRegex$1(_check);

            if (!_regex4.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_string,
                validation: "time",
                message: _check.message
              });
              status.dirty();
            }
          } else if (_check.kind === "duration") {
            if (!durationRegex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "duration",
                code: ZodIssueCode.invalid_string,
                message: _check.message
              });
              status.dirty();
            }
          } else if (_check.kind === "ip") {
            if (!isValidIP(input.data, _check.version)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "ip",
                code: ZodIssueCode.invalid_string,
                message: _check.message
              });
              status.dirty();
            }
          } else if (_check.kind === "jwt") {
            if (!isValidJWT(input.data, _check.alg)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "jwt",
                code: ZodIssueCode.invalid_string,
                message: _check.message
              });
              status.dirty();
            }
          } else if (_check.kind === "cidr") {
            if (!isValidCidr(input.data, _check.version)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "cidr",
                code: ZodIssueCode.invalid_string,
                message: _check.message
              });
              status.dirty();
            }
          } else if (_check.kind === "base64") {
            if (!base64Regex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "base64",
                code: ZodIssueCode.invalid_string,
                message: _check.message
              });
              status.dirty();
            }
          } else if (_check.kind === "base64url") {
            if (!base64urlRegex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "base64url",
                code: ZodIssueCode.invalid_string,
                message: _check.message
              });
              status.dirty();
            }
          } else {
            util.assertNever(_check);
          }
        }
      } catch (err) {
        _iterator22.e(err);
      } finally {
        _iterator22.f();
      }

      return {
        status: status.value,
        value: input.data
      };
    }
  }, {
    key: "_regex",
    value: function _regex(regex, validation, message) {
      return this.refinement(function (data) {
        return regex.test(data);
      }, _objectSpread3({
        validation: validation,
        code: ZodIssueCode.invalid_string
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "_addCheck",
    value: function _addCheck(check) {
      return new ZodString(_objectSpread3(_objectSpread3({}, this._def), {}, {
        checks: [].concat(_toConsumableArray2(this._def.checks), [check])
      }));
    }
  }, {
    key: "email",
    value: function email(message) {
      return this._addCheck(_objectSpread3({
        kind: "email"
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "url",
    value: function url(message) {
      return this._addCheck(_objectSpread3({
        kind: "url"
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "emoji",
    value: function emoji(message) {
      return this._addCheck(_objectSpread3({
        kind: "emoji"
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "uuid",
    value: function uuid(message) {
      return this._addCheck(_objectSpread3({
        kind: "uuid"
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "nanoid",
    value: function nanoid(message) {
      return this._addCheck(_objectSpread3({
        kind: "nanoid"
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "cuid",
    value: function cuid(message) {
      return this._addCheck(_objectSpread3({
        kind: "cuid"
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "cuid2",
    value: function cuid2(message) {
      return this._addCheck(_objectSpread3({
        kind: "cuid2"
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "ulid",
    value: function ulid(message) {
      return this._addCheck(_objectSpread3({
        kind: "ulid"
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "base64",
    value: function base64(message) {
      return this._addCheck(_objectSpread3({
        kind: "base64"
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "base64url",
    value: function base64url(message) {
      // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
      return this._addCheck(_objectSpread3({
        kind: "base64url"
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "jwt",
    value: function jwt(options) {
      return this._addCheck(_objectSpread3({
        kind: "jwt"
      }, errorUtil.errToObj(options)));
    }
  }, {
    key: "ip",
    value: function ip(options) {
      return this._addCheck(_objectSpread3({
        kind: "ip"
      }, errorUtil.errToObj(options)));
    }
  }, {
    key: "cidr",
    value: function cidr(options) {
      return this._addCheck(_objectSpread3({
        kind: "cidr"
      }, errorUtil.errToObj(options)));
    }
  }, {
    key: "datetime",
    value: function datetime(options) {
      var _options$offset, _options$local;

      if (typeof options === "string") {
        return this._addCheck({
          kind: "datetime",
          precision: null,
          offset: false,
          local: false,
          message: options
        });
      }

      return this._addCheck(_objectSpread3({
        kind: "datetime",
        precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
        offset: (_options$offset = options === null || options === void 0 ? void 0 : options.offset) !== null && _options$offset !== void 0 ? _options$offset : false,
        local: (_options$local = options === null || options === void 0 ? void 0 : options.local) !== null && _options$local !== void 0 ? _options$local : false
      }, errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
    }
  }, {
    key: "date",
    value: function date(message) {
      return this._addCheck({
        kind: "date",
        message: message
      });
    }
  }, {
    key: "time",
    value: function time(options) {
      if (typeof options === "string") {
        return this._addCheck({
          kind: "time",
          precision: null,
          message: options
        });
      }

      return this._addCheck(_objectSpread3({
        kind: "time",
        precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision
      }, errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
    }
  }, {
    key: "duration",
    value: function duration(message) {
      return this._addCheck(_objectSpread3({
        kind: "duration"
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "regex",
    value: function regex(_regex2, message) {
      return this._addCheck(_objectSpread3({
        kind: "regex",
        regex: _regex2
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "includes",
    value: function includes(value, options) {
      return this._addCheck(_objectSpread3({
        kind: "includes",
        value: value,
        position: options === null || options === void 0 ? void 0 : options.position
      }, errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
    }
  }, {
    key: "startsWith",
    value: function startsWith(value, message) {
      return this._addCheck(_objectSpread3({
        kind: "startsWith",
        value: value
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "endsWith",
    value: function endsWith(value, message) {
      return this._addCheck(_objectSpread3({
        kind: "endsWith",
        value: value
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "min",
    value: function min(minLength, message) {
      return this._addCheck(_objectSpread3({
        kind: "min",
        value: minLength
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "max",
    value: function max(maxLength, message) {
      return this._addCheck(_objectSpread3({
        kind: "max",
        value: maxLength
      }, errorUtil.errToObj(message)));
    }
  }, {
    key: "length",
    value: function length(len, message) {
      return this._addCheck(_objectSpread3({
        kind: "length",
        value: len
      }, errorUtil.errToObj(message)));
    }
    /**
     * Equivalent to `.min(1)`
     */

  }, {
    key: "nonempty",
    value: function nonempty(message) {
      return this.min(1, errorUtil.errToObj(message));
    }
  }, {
    key: "trim",
    value: function trim() {
      return new ZodString(_objectSpread3(_objectSpread3({}, this._def), {}, {
        checks: [].concat(_toConsumableArray2(this._def.checks), [{
          kind: "trim"
        }])
      }));
    }
  }, {
    key: "toLowerCase",
    value: function toLowerCase() {
      return new ZodString(_objectSpread3(_objectSpread3({}, this._def), {}, {
        checks: [].concat(_toConsumableArray2(this._def.checks), [{
          kind: "toLowerCase"
        }])
      }));
    }
  }, {
    key: "toUpperCase",
    value: function toUpperCase() {
      return new ZodString(_objectSpread3(_objectSpread3({}, this._def), {}, {
        checks: [].concat(_toConsumableArray2(this._def.checks), [{
          kind: "toUpperCase"
        }])
      }));
    }
  }, {
    key: "isDatetime",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "datetime";
      });
    }
  }, {
    key: "isDate",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "date";
      });
    }
  }, {
    key: "isTime",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "time";
      });
    }
  }, {
    key: "isDuration",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "duration";
      });
    }
  }, {
    key: "isEmail",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "email";
      });
    }
  }, {
    key: "isURL",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "url";
      });
    }
  }, {
    key: "isEmoji",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "emoji";
      });
    }
  }, {
    key: "isUUID",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "uuid";
      });
    }
  }, {
    key: "isNANOID",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "nanoid";
      });
    }
  }, {
    key: "isCUID",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "cuid";
      });
    }
  }, {
    key: "isCUID2",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "cuid2";
      });
    }
  }, {
    key: "isULID",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "ulid";
      });
    }
  }, {
    key: "isIP",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "ip";
      });
    }
  }, {
    key: "isCIDR",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "cidr";
      });
    }
  }, {
    key: "isBase64",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "base64";
      });
    }
  }, {
    key: "isBase64url",
    get: function get() {
      // base64url encoding is a modification of base64 that can safely be used in URLs and filenames
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "base64url";
      });
    }
  }, {
    key: "minLength",
    get: function get() {
      var min = null;

      var _iterator23 = _createForOfIteratorHelper(this._def.checks),
          _step23;

      try {
        for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
          var ch = _step23.value;

          if (ch.kind === "min") {
            if (min === null || ch.value > min) min = ch.value;
          }
        }
      } catch (err) {
        _iterator23.e(err);
      } finally {
        _iterator23.f();
      }

      return min;
    }
  }, {
    key: "maxLength",
    get: function get() {
      var max = null;

      var _iterator24 = _createForOfIteratorHelper(this._def.checks),
          _step24;

      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var ch = _step24.value;

          if (ch.kind === "max") {
            if (max === null || ch.value < max) max = ch.value;
          }
        }
      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }

      return max;
    }
  }]);

  return ZodString;
}(ZodType);

ZodString.create = function (params) {
  var _params$coerce;

  return new ZodString(_objectSpread3({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodString,
    coerce: (_params$coerce = params === null || params === void 0 ? void 0 : params.coerce) !== null && _params$coerce !== void 0 ? _params$coerce : false
  }, processCreateParams(params)));
}; // https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034


function floatSafeRemainder(val, step) {
  var valDecCount = (val.toString().split(".")[1] || "").length;
  var stepDecCount = (step.toString().split(".")[1] || "").length;
  var decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
  var valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
  var stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
  return valInt % stepInt / Math.pow(10, decCount);
}

var ZodNumber = /*#__PURE__*/function (_ZodType2) {
  _inherits2(ZodNumber, _ZodType2);

  var _super13 = _createSuper2(ZodNumber);

  function ZodNumber() {
    var _this17;

    _classCallCheck2(this, ZodNumber);

    _this17 = _super13.apply(this, arguments);
    _this17.min = _this17.gte;
    _this17.max = _this17.lte;
    _this17.step = _this17.multipleOf;
    return _this17;
  }

  _createClass2(ZodNumber, [{
    key: "_parse",
    value: function _parse(input) {
      if (this._def.coerce) {
        input.data = Number(input.data);
      }

      var parsedType = this._getType(input);

      if (parsedType !== ZodParsedType.number) {
        var _ctx3 = this._getOrReturnCtx(input);

        addIssueToContext(_ctx3, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.number,
          received: _ctx3.parsedType
        });
        return INVALID;
      }

      var ctx = undefined;
      var status = new ParseStatus();

      var _iterator25 = _createForOfIteratorHelper(this._def.checks),
          _step25;

      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var _check2 = _step25.value;

          if (_check2.kind === "int") {
            if (!util.isInteger(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: "integer",
                received: "float",
                message: _check2.message
              });
              status.dirty();
            }
          } else if (_check2.kind === "min") {
            var tooSmall = _check2.inclusive ? input.data < _check2.value : input.data <= _check2.value;

            if (tooSmall) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                minimum: _check2.value,
                type: "number",
                inclusive: _check2.inclusive,
                exact: false,
                message: _check2.message
              });
              status.dirty();
            }
          } else if (_check2.kind === "max") {
            var tooBig = _check2.inclusive ? input.data > _check2.value : input.data >= _check2.value;

            if (tooBig) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                maximum: _check2.value,
                type: "number",
                inclusive: _check2.inclusive,
                exact: false,
                message: _check2.message
              });
              status.dirty();
            }
          } else if (_check2.kind === "multipleOf") {
            if (floatSafeRemainder(input.data, _check2.value) !== 0) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.not_multiple_of,
                multipleOf: _check2.value,
                message: _check2.message
              });
              status.dirty();
            }
          } else if (_check2.kind === "finite") {
            if (!Number.isFinite(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.not_finite,
                message: _check2.message
              });
              status.dirty();
            }
          } else {
            util.assertNever(_check2);
          }
        }
      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }

      return {
        status: status.value,
        value: input.data
      };
    }
  }, {
    key: "gte",
    value: function gte(value, message) {
      return this.setLimit("min", value, true, errorUtil.toString(message));
    }
  }, {
    key: "gt",
    value: function gt(value, message) {
      return this.setLimit("min", value, false, errorUtil.toString(message));
    }
  }, {
    key: "lte",
    value: function lte(value, message) {
      return this.setLimit("max", value, true, errorUtil.toString(message));
    }
  }, {
    key: "lt",
    value: function lt(value, message) {
      return this.setLimit("max", value, false, errorUtil.toString(message));
    }
  }, {
    key: "setLimit",
    value: function setLimit(kind, value, inclusive, message) {
      return new ZodNumber(_objectSpread3(_objectSpread3({}, this._def), {}, {
        checks: [].concat(_toConsumableArray2(this._def.checks), [{
          kind: kind,
          value: value,
          inclusive: inclusive,
          message: errorUtil.toString(message)
        }])
      }));
    }
  }, {
    key: "_addCheck",
    value: function _addCheck(check) {
      return new ZodNumber(_objectSpread3(_objectSpread3({}, this._def), {}, {
        checks: [].concat(_toConsumableArray2(this._def.checks), [check])
      }));
    }
  }, {
    key: "int",
    value: function int(message) {
      return this._addCheck({
        kind: "int",
        message: errorUtil.toString(message)
      });
    }
  }, {
    key: "positive",
    value: function positive(message) {
      return this._addCheck({
        kind: "min",
        value: 0,
        inclusive: false,
        message: errorUtil.toString(message)
      });
    }
  }, {
    key: "negative",
    value: function negative(message) {
      return this._addCheck({
        kind: "max",
        value: 0,
        inclusive: false,
        message: errorUtil.toString(message)
      });
    }
  }, {
    key: "nonpositive",
    value: function nonpositive(message) {
      return this._addCheck({
        kind: "max",
        value: 0,
        inclusive: true,
        message: errorUtil.toString(message)
      });
    }
  }, {
    key: "nonnegative",
    value: function nonnegative(message) {
      return this._addCheck({
        kind: "min",
        value: 0,
        inclusive: true,
        message: errorUtil.toString(message)
      });
    }
  }, {
    key: "multipleOf",
    value: function multipleOf(value, message) {
      return this._addCheck({
        kind: "multipleOf",
        value: value,
        message: errorUtil.toString(message)
      });
    }
  }, {
    key: "finite",
    value: function finite(message) {
      return this._addCheck({
        kind: "finite",
        message: errorUtil.toString(message)
      });
    }
  }, {
    key: "safe",
    value: function safe(message) {
      return this._addCheck({
        kind: "min",
        inclusive: true,
        value: Number.MIN_SAFE_INTEGER,
        message: errorUtil.toString(message)
      })._addCheck({
        kind: "max",
        inclusive: true,
        value: Number.MAX_SAFE_INTEGER,
        message: errorUtil.toString(message)
      });
    }
  }, {
    key: "minValue",
    get: function get() {
      var min = null;

      var _iterator26 = _createForOfIteratorHelper(this._def.checks),
          _step26;

      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var ch = _step26.value;

          if (ch.kind === "min") {
            if (min === null || ch.value > min) min = ch.value;
          }
        }
      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }

      return min;
    }
  }, {
    key: "maxValue",
    get: function get() {
      var max = null;

      var _iterator27 = _createForOfIteratorHelper(this._def.checks),
          _step27;

      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
          var ch = _step27.value;

          if (ch.kind === "max") {
            if (max === null || ch.value < max) max = ch.value;
          }
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }

      return max;
    }
  }, {
    key: "isInt",
    get: function get() {
      return !!this._def.checks.find(function (ch) {
        return ch.kind === "int" || ch.kind === "multipleOf" && util.isInteger(ch.value);
      });
    }
  }, {
    key: "isFinite",
    get: function get() {
      var max = null;
      var min = null;

      var _iterator28 = _createForOfIteratorHelper(this._def.checks),
          _step28;

      try {
        for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
          var ch = _step28.value;

          if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") {
            return true;
          } else if (ch.kind === "min") {
            if (min === null || ch.value > min) min = ch.value;
          } else if (ch.kind === "max") {
            if (max === null || ch.value < max) max = ch.value;
          }
        }
      } catch (err) {
        _iterator28.e(err);
      } finally {
        _iterator28.f();
      }

      return Number.isFinite(min) && Number.isFinite(max);
    }
  }]);

  return ZodNumber;
}(ZodType);

ZodNumber.create = function (params) {
  return new ZodNumber(_objectSpread3({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodNumber,
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
  }, processCreateParams(params)));
};

var ZodBigInt = /*#__PURE__*/function (_ZodType3) {
  _inherits2(ZodBigInt, _ZodType3);

  var _super14 = _createSuper2(ZodBigInt);

  function ZodBigInt() {
    var _this18;

    _classCallCheck2(this, ZodBigInt);

    _this18 = _super14.apply(this, arguments);
    _this18.min = _this18.gte;
    _this18.max = _this18.lte;
    return _this18;
  }

  _createClass2(ZodBigInt, [{
    key: "_parse",
    value: function _parse(input) {
      if (this._def.coerce) {
        try {
          input.data = BigInt(input.data);
        } catch (_unused4) {
          return this._getInvalidInput(input);
        }
      }

      var parsedType = this._getType(input);

      if (parsedType !== ZodParsedType.bigint) {
        return this._getInvalidInput(input);
      }

      var ctx = undefined;
      var status = new ParseStatus();

      var _iterator29 = _createForOfIteratorHelper(this._def.checks),
          _step29;

      try {
        for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
          var _check3 = _step29.value;

          if (_check3.kind === "min") {
            var tooSmall = _check3.inclusive ? input.data < _check3.value : input.data <= _check3.value;

            if (tooSmall) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                type: "bigint",
                minimum: _check3.value,
                inclusive: _check3.inclusive,
                message: _check3.message
              });
              status.dirty();
            }
          } else if (_check3.kind === "max") {
            var tooBig = _check3.inclusive ? input.data > _check3.value : input.data >= _check3.value;

            if (tooBig) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                type: "bigint",
                maximum: _check3.value,
                inclusive: _check3.inclusive,
                message: _check3.message
              });
              status.dirty();
            }
          } else if (_check3.kind === "multipleOf") {
            if (input.data % _check3.value !== BigInt(0)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.not_multiple_of,
                multipleOf: _check3.value,
                message: _check3.message
              });
              status.dirty();
            }
          } else {
            util.assertNever(_check3);
          }
        }
      } catch (err) {
        _iterator29.e(err);
      } finally {
        _iterator29.f();
      }

      return {
        status: status.value,
        value: input.data
      };
    }
  }, {
    key: "_getInvalidInput",
    value: function _getInvalidInput(input) {
      var ctx = this._getOrReturnCtx(input);

      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.bigint,
        received: ctx.parsedType
      });
      return INVALID;
    }
  }, {
    key: "gte",
    value: function gte(value, message) {
      return this.setLimit("min", value, true, errorUtil.toString(message));
    }
  }, {
    key: "gt",
    value: function gt(value, message) {
      return this.setLimit("min", value, false, errorUtil.toString(message));
    }
  }, {
    key: "lte",
    value: function lte(value, message) {
      return this.setLimit("max", value, true, errorUtil.toString(message));
    }
  }, {
    key: "lt",
    value: function lt(value, message) {
      return this.setLimit("max", value, false, errorUtil.toString(message));
    }
  }, {
    key: "setLimit",
    value: function setLimit(kind, value, inclusive, message) {
      return new ZodBigInt(_objectSpread3(_objectSpread3({}, this._def), {}, {
        checks: [].concat(_toConsumableArray2(this._def.checks), [{
          kind: kind,
          value: value,
          inclusive: inclusive,
          message: errorUtil.toString(message)
        }])
      }));
    }
  }, {
    key: "_addCheck",
    value: function _addCheck(check) {
      return new ZodBigInt(_objectSpread3(_objectSpread3({}, this._def), {}, {
        checks: [].concat(_toConsumableArray2(this._def.checks), [check])
      }));
    }
  }, {
    key: "positive",
    value: function positive(message) {
      return this._addCheck({
        kind: "min",
        value: BigInt(0),
        inclusive: false,
        message: errorUtil.toString(message)
      });
    }
  }, {
    key: "negative",
    value: function negative(message) {
      return this._addCheck({
        kind: "max",
        value: BigInt(0),
        inclusive: false,
        message: errorUtil.toString(message)
      });
    }
  }, {
    key: "nonpositive",
    value: function nonpositive(message) {
      return this._addCheck({
        kind: "max",
        value: BigInt(0),
        inclusive: true,
        message: errorUtil.toString(message)
      });
    }
  }, {
    key: "nonnegative",
    value: function nonnegative(message) {
      return this._addCheck({
        kind: "min",
        value: BigInt(0),
        inclusive: true,
        message: errorUtil.toString(message)
      });
    }
  }, {
    key: "multipleOf",
    value: function multipleOf(value, message) {
      return this._addCheck({
        kind: "multipleOf",
        value: value,
        message: errorUtil.toString(message)
      });
    }
  }, {
    key: "minValue",
    get: function get() {
      var min = null;

      var _iterator30 = _createForOfIteratorHelper(this._def.checks),
          _step30;

      try {
        for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
          var ch = _step30.value;

          if (ch.kind === "min") {
            if (min === null || ch.value > min) min = ch.value;
          }
        }
      } catch (err) {
        _iterator30.e(err);
      } finally {
        _iterator30.f();
      }

      return min;
    }
  }, {
    key: "maxValue",
    get: function get() {
      var max = null;

      var _iterator31 = _createForOfIteratorHelper(this._def.checks),
          _step31;

      try {
        for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
          var ch = _step31.value;

          if (ch.kind === "max") {
            if (max === null || ch.value < max) max = ch.value;
          }
        }
      } catch (err) {
        _iterator31.e(err);
      } finally {
        _iterator31.f();
      }

      return max;
    }
  }]);

  return ZodBigInt;
}(ZodType);

ZodBigInt.create = function (params) {
  var _params$coerce2;

  return new ZodBigInt(_objectSpread3({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodBigInt,
    coerce: (_params$coerce2 = params === null || params === void 0 ? void 0 : params.coerce) !== null && _params$coerce2 !== void 0 ? _params$coerce2 : false
  }, processCreateParams(params)));
};

var ZodBoolean = /*#__PURE__*/function (_ZodType4) {
  _inherits2(ZodBoolean, _ZodType4);

  var _super15 = _createSuper2(ZodBoolean);

  function ZodBoolean() {
    _classCallCheck2(this, ZodBoolean);

    return _super15.apply(this, arguments);
  }

  _createClass2(ZodBoolean, [{
    key: "_parse",
    value: function _parse(input) {
      if (this._def.coerce) {
        input.data = Boolean(input.data);
      }

      var parsedType = this._getType(input);

      if (parsedType !== ZodParsedType.boolean) {
        var ctx = this._getOrReturnCtx(input);

        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.boolean,
          received: ctx.parsedType
        });
        return INVALID;
      }

      return OK(input.data);
    }
  }]);

  return ZodBoolean;
}(ZodType);

ZodBoolean.create = function (params) {
  return new ZodBoolean(_objectSpread3({
    typeName: ZodFirstPartyTypeKind.ZodBoolean,
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
  }, processCreateParams(params)));
};

var ZodDate = /*#__PURE__*/function (_ZodType5) {
  _inherits2(ZodDate, _ZodType5);

  var _super16 = _createSuper2(ZodDate);

  function ZodDate() {
    _classCallCheck2(this, ZodDate);

    return _super16.apply(this, arguments);
  }

  _createClass2(ZodDate, [{
    key: "_parse",
    value: function _parse(input) {
      if (this._def.coerce) {
        input.data = new Date(input.data);
      }

      var parsedType = this._getType(input);

      if (parsedType !== ZodParsedType.date) {
        var _ctx4 = this._getOrReturnCtx(input);

        addIssueToContext(_ctx4, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.date,
          received: _ctx4.parsedType
        });
        return INVALID;
      }

      if (Number.isNaN(input.data.getTime())) {
        var _ctx5 = this._getOrReturnCtx(input);

        addIssueToContext(_ctx5, {
          code: ZodIssueCode.invalid_date
        });
        return INVALID;
      }

      var status = new ParseStatus();
      var ctx = undefined;

      var _iterator32 = _createForOfIteratorHelper(this._def.checks),
          _step32;

      try {
        for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
          var _check4 = _step32.value;

          if (_check4.kind === "min") {
            if (input.data.getTime() < _check4.value) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                message: _check4.message,
                inclusive: true,
                exact: false,
                minimum: _check4.value,
                type: "date"
              });
              status.dirty();
            }
          } else if (_check4.kind === "max") {
            if (input.data.getTime() > _check4.value) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                message: _check4.message,
                inclusive: true,
                exact: false,
                maximum: _check4.value,
                type: "date"
              });
              status.dirty();
            }
          } else {
            util.assertNever(_check4);
          }
        }
      } catch (err) {
        _iterator32.e(err);
      } finally {
        _iterator32.f();
      }

      return {
        status: status.value,
        value: new Date(input.data.getTime())
      };
    }
  }, {
    key: "_addCheck",
    value: function _addCheck(check) {
      return new ZodDate(_objectSpread3(_objectSpread3({}, this._def), {}, {
        checks: [].concat(_toConsumableArray2(this._def.checks), [check])
      }));
    }
  }, {
    key: "min",
    value: function min(minDate, message) {
      return this._addCheck({
        kind: "min",
        value: minDate.getTime(),
        message: errorUtil.toString(message)
      });
    }
  }, {
    key: "max",
    value: function max(maxDate, message) {
      return this._addCheck({
        kind: "max",
        value: maxDate.getTime(),
        message: errorUtil.toString(message)
      });
    }
  }, {
    key: "minDate",
    get: function get() {
      var min = null;

      var _iterator33 = _createForOfIteratorHelper(this._def.checks),
          _step33;

      try {
        for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
          var ch = _step33.value;

          if (ch.kind === "min") {
            if (min === null || ch.value > min) min = ch.value;
          }
        }
      } catch (err) {
        _iterator33.e(err);
      } finally {
        _iterator33.f();
      }

      return min != null ? new Date(min) : null;
    }
  }, {
    key: "maxDate",
    get: function get() {
      var max = null;

      var _iterator34 = _createForOfIteratorHelper(this._def.checks),
          _step34;

      try {
        for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
          var ch = _step34.value;

          if (ch.kind === "max") {
            if (max === null || ch.value < max) max = ch.value;
          }
        }
      } catch (err) {
        _iterator34.e(err);
      } finally {
        _iterator34.f();
      }

      return max != null ? new Date(max) : null;
    }
  }]);

  return ZodDate;
}(ZodType);

ZodDate.create = function (params) {
  return new ZodDate(_objectSpread3({
    checks: [],
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
    typeName: ZodFirstPartyTypeKind.ZodDate
  }, processCreateParams(params)));
};

var ZodSymbol = /*#__PURE__*/function (_ZodType6) {
  _inherits2(ZodSymbol, _ZodType6);

  var _super17 = _createSuper2(ZodSymbol);

  function ZodSymbol() {
    _classCallCheck2(this, ZodSymbol);

    return _super17.apply(this, arguments);
  }

  _createClass2(ZodSymbol, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);

      if (parsedType !== ZodParsedType.symbol) {
        var ctx = this._getOrReturnCtx(input);

        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.symbol,
          received: ctx.parsedType
        });
        return INVALID;
      }

      return OK(input.data);
    }
  }]);

  return ZodSymbol;
}(ZodType);

ZodSymbol.create = function (params) {
  return new ZodSymbol(_objectSpread3({
    typeName: ZodFirstPartyTypeKind.ZodSymbol
  }, processCreateParams(params)));
};

var ZodUndefined = /*#__PURE__*/function (_ZodType7) {
  _inherits2(ZodUndefined, _ZodType7);

  var _super18 = _createSuper2(ZodUndefined);

  function ZodUndefined() {
    _classCallCheck2(this, ZodUndefined);

    return _super18.apply(this, arguments);
  }

  _createClass2(ZodUndefined, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);

      if (parsedType !== ZodParsedType.undefined) {
        var ctx = this._getOrReturnCtx(input);

        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.undefined,
          received: ctx.parsedType
        });
        return INVALID;
      }

      return OK(input.data);
    }
  }]);

  return ZodUndefined;
}(ZodType);

ZodUndefined.create = function (params) {
  return new ZodUndefined(_objectSpread3({
    typeName: ZodFirstPartyTypeKind.ZodUndefined
  }, processCreateParams(params)));
};

var ZodNull = /*#__PURE__*/function (_ZodType8) {
  _inherits2(ZodNull, _ZodType8);

  var _super19 = _createSuper2(ZodNull);

  function ZodNull() {
    _classCallCheck2(this, ZodNull);

    return _super19.apply(this, arguments);
  }

  _createClass2(ZodNull, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);

      if (parsedType !== ZodParsedType.null) {
        var ctx = this._getOrReturnCtx(input);

        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.null,
          received: ctx.parsedType
        });
        return INVALID;
      }

      return OK(input.data);
    }
  }]);

  return ZodNull;
}(ZodType);

ZodNull.create = function (params) {
  return new ZodNull(_objectSpread3({
    typeName: ZodFirstPartyTypeKind.ZodNull
  }, processCreateParams(params)));
};

var ZodAny = /*#__PURE__*/function (_ZodType9) {
  _inherits2(ZodAny, _ZodType9);

  var _super20 = _createSuper2(ZodAny);

  function ZodAny() {
    var _this19;

    _classCallCheck2(this, ZodAny);

    _this19 = _super20.apply(this, arguments); // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.

    _this19._any = true;
    return _this19;
  }

  _createClass2(ZodAny, [{
    key: "_parse",
    value: function _parse(input) {
      return OK(input.data);
    }
  }]);

  return ZodAny;
}(ZodType);

ZodAny.create = function (params) {
  return new ZodAny(_objectSpread3({
    typeName: ZodFirstPartyTypeKind.ZodAny
  }, processCreateParams(params)));
};

var ZodUnknown = /*#__PURE__*/function (_ZodType10) {
  _inherits2(ZodUnknown, _ZodType10);

  var _super21 = _createSuper2(ZodUnknown);

  function ZodUnknown() {
    var _this20;

    _classCallCheck2(this, ZodUnknown);

    _this20 = _super21.apply(this, arguments); // required

    _this20._unknown = true;
    return _this20;
  }

  _createClass2(ZodUnknown, [{
    key: "_parse",
    value: function _parse(input) {
      return OK(input.data);
    }
  }]);

  return ZodUnknown;
}(ZodType);

ZodUnknown.create = function (params) {
  return new ZodUnknown(_objectSpread3({
    typeName: ZodFirstPartyTypeKind.ZodUnknown
  }, processCreateParams(params)));
};

var ZodNever = /*#__PURE__*/function (_ZodType11) {
  _inherits2(ZodNever, _ZodType11);

  var _super22 = _createSuper2(ZodNever);

  function ZodNever() {
    _classCallCheck2(this, ZodNever);

    return _super22.apply(this, arguments);
  }

  _createClass2(ZodNever, [{
    key: "_parse",
    value: function _parse(input) {
      var ctx = this._getOrReturnCtx(input);

      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.never,
        received: ctx.parsedType
      });
      return INVALID;
    }
  }]);

  return ZodNever;
}(ZodType);

ZodNever.create = function (params) {
  return new ZodNever(_objectSpread3({
    typeName: ZodFirstPartyTypeKind.ZodNever
  }, processCreateParams(params)));
};

var ZodVoid = /*#__PURE__*/function (_ZodType12) {
  _inherits2(ZodVoid, _ZodType12);

  var _super23 = _createSuper2(ZodVoid);

  function ZodVoid() {
    _classCallCheck2(this, ZodVoid);

    return _super23.apply(this, arguments);
  }

  _createClass2(ZodVoid, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);

      if (parsedType !== ZodParsedType.undefined) {
        var ctx = this._getOrReturnCtx(input);

        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.void,
          received: ctx.parsedType
        });
        return INVALID;
      }

      return OK(input.data);
    }
  }]);

  return ZodVoid;
}(ZodType);

ZodVoid.create = function (params) {
  return new ZodVoid(_objectSpread3({
    typeName: ZodFirstPartyTypeKind.ZodVoid
  }, processCreateParams(params)));
};

var ZodArray = /*#__PURE__*/function (_ZodType13) {
  _inherits2(ZodArray, _ZodType13);

  var _super24 = _createSuper2(ZodArray);

  function ZodArray() {
    _classCallCheck2(this, ZodArray);

    return _super24.apply(this, arguments);
  }

  _createClass2(ZodArray, [{
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa = this._processInputParams(input),
          ctx = _this$_processInputPa.ctx,
          status = _this$_processInputPa.status;

      var def = this._def;

      if (ctx.parsedType !== ZodParsedType.array) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.array,
          received: ctx.parsedType
        });
        return INVALID;
      }

      if (def.exactLength !== null) {
        var tooBig = ctx.data.length > def.exactLength.value;
        var tooSmall = ctx.data.length < def.exactLength.value;

        if (tooBig || tooSmall) {
          addIssueToContext(ctx, {
            code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
            minimum: tooSmall ? def.exactLength.value : undefined,
            maximum: tooBig ? def.exactLength.value : undefined,
            type: "array",
            inclusive: true,
            exact: true,
            message: def.exactLength.message
          });
          status.dirty();
        }
      }

      if (def.minLength !== null) {
        if (ctx.data.length < def.minLength.value) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: def.minLength.value,
            type: "array",
            inclusive: true,
            exact: false,
            message: def.minLength.message
          });
          status.dirty();
        }
      }

      if (def.maxLength !== null) {
        if (ctx.data.length > def.maxLength.value) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: def.maxLength.value,
            type: "array",
            inclusive: true,
            exact: false,
            message: def.maxLength.message
          });
          status.dirty();
        }
      }

      if (ctx.common.async) {
        return Promise.all(_toConsumableArray2(ctx.data).map(function (item, i) {
          return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then(function (result) {
          return ParseStatus.mergeArray(status, result);
        });
      }

      var result = _toConsumableArray2(ctx.data).map(function (item, i) {
        return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
      });

      return ParseStatus.mergeArray(status, result);
    }
  }, {
    key: "element",
    get: function get() {
      return this._def.type;
    }
  }, {
    key: "min",
    value: function min(minLength, message) {
      return new ZodArray(_objectSpread3(_objectSpread3({}, this._def), {}, {
        minLength: {
          value: minLength,
          message: errorUtil.toString(message)
        }
      }));
    }
  }, {
    key: "max",
    value: function max(maxLength, message) {
      return new ZodArray(_objectSpread3(_objectSpread3({}, this._def), {}, {
        maxLength: {
          value: maxLength,
          message: errorUtil.toString(message)
        }
      }));
    }
  }, {
    key: "length",
    value: function length(len, message) {
      return new ZodArray(_objectSpread3(_objectSpread3({}, this._def), {}, {
        exactLength: {
          value: len,
          message: errorUtil.toString(message)
        }
      }));
    }
  }, {
    key: "nonempty",
    value: function nonempty(message) {
      return this.min(1, message);
    }
  }]);

  return ZodArray;
}(ZodType);

ZodArray.create = function (schema, params) {
  return new ZodArray(_objectSpread3({
    type: schema,
    minLength: null,
    maxLength: null,
    exactLength: null,
    typeName: ZodFirstPartyTypeKind.ZodArray
  }, processCreateParams(params)));
};

function deepPartialify(schema) {
  if (schema instanceof ZodObject) {
    var newShape = {};

    for (var key in schema.shape) {
      var fieldSchema = schema.shape[key];
      newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
    }

    return new ZodObject(_objectSpread3(_objectSpread3({}, schema._def), {}, {
      shape: function shape() {
        return newShape;
      }
    }));
  } else if (schema instanceof ZodArray) {
    return new ZodArray(_objectSpread3(_objectSpread3({}, schema._def), {}, {
      type: deepPartialify(schema.element)
    }));
  } else if (schema instanceof ZodOptional) {
    return ZodOptional.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodNullable) {
    return ZodNullable.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodTuple) {
    return ZodTuple.create(schema.items.map(function (item) {
      return deepPartialify(item);
    }));
  } else {
    return schema;
  }
}

var ZodObject = /*#__PURE__*/function (_ZodType14) {
  _inherits2(ZodObject, _ZodType14);

  var _super25 = _createSuper2(ZodObject);

  function ZodObject() {
    var _this21;

    _classCallCheck2(this, ZodObject);

    _this21 = _super25.apply(this, arguments);
    _this21._cached = null;
    /**
     * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
     * If you want to pass through unknown properties, use `.passthrough()` instead.
     */

    _this21.nonstrict = _this21.passthrough; // extend<
    //   Augmentation extends ZodRawShape,
    //   NewOutput extends util.flatten<{
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   }>,
    //   NewInput extends util.flatten<{
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }>
    // >(
    //   augmentation: Augmentation
    // ): ZodObject<
    //   extendShape<T, Augmentation>,
    //   UnknownKeys,
    //   Catchall,
    //   NewOutput,
    //   NewInput
    // > {
    //   return new ZodObject({
    //     ...this._def,
    //     shape: () => ({
    //       ...this._def.shape(),
    //       ...augmentation,
    //     }),
    //   }) as any;
    // }

    /**
     * @deprecated Use `.extend` instead
     *  */

    _this21.augment = _this21.extend;
    return _this21;
  }

  _createClass2(ZodObject, [{
    key: "_getCached",
    value: function _getCached() {
      if (this._cached !== null) return this._cached;

      var shape = this._def.shape();

      var keys = util.objectKeys(shape);
      this._cached = {
        shape: shape,
        keys: keys
      };
      return this._cached;
    }
  }, {
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);

      if (parsedType !== ZodParsedType.object) {
        var _ctx6 = this._getOrReturnCtx(input);

        addIssueToContext(_ctx6, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.object,
          received: _ctx6.parsedType
        });
        return INVALID;
      }

      var _this$_processInputPa2 = this._processInputParams(input),
          status = _this$_processInputPa2.status,
          ctx = _this$_processInputPa2.ctx;

      var _this$_getCached = this._getCached(),
          shape = _this$_getCached.shape,
          shapeKeys = _this$_getCached.keys;

      var extraKeys = [];

      if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
        for (var key in ctx.data) {
          if (!shapeKeys.includes(key)) {
            extraKeys.push(key);
          }
        }
      }

      var pairs = [];

      var _iterator35 = _createForOfIteratorHelper(shapeKeys),
          _step35;

      try {
        for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
          var _key7 = _step35.value;
          var keyValidator = shape[_key7];
          var _value5 = ctx.data[_key7];
          pairs.push({
            key: {
              status: "valid",
              value: _key7
            },
            value: keyValidator._parse(new ParseInputLazyPath(ctx, _value5, ctx.path, _key7)),
            alwaysSet: _key7 in ctx.data
          });
        }
      } catch (err) {
        _iterator35.e(err);
      } finally {
        _iterator35.f();
      }

      if (this._def.catchall instanceof ZodNever) {
        var unknownKeys = this._def.unknownKeys;

        if (unknownKeys === "passthrough") {
          var _iterator36 = _createForOfIteratorHelper(extraKeys),
              _step36;

          try {
            for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
              var _key4 = _step36.value;
              pairs.push({
                key: {
                  status: "valid",
                  value: _key4
                },
                value: {
                  status: "valid",
                  value: ctx.data[_key4]
                }
              });
            }
          } catch (err) {
            _iterator36.e(err);
          } finally {
            _iterator36.f();
          }
        } else if (unknownKeys === "strict") {
          if (extraKeys.length > 0) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.unrecognized_keys,
              keys: extraKeys
            });
            status.dirty();
          }
        } else if (unknownKeys === "strip") ;else {
          throw new Error("Internal ZodObject error: invalid unknownKeys value.");
        }
      } else {
        // run catchall validation
        var catchall = this._def.catchall;

        var _iterator37 = _createForOfIteratorHelper(extraKeys),
            _step37;

        try {
          for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
            var _key5 = _step37.value;
            var value = ctx.data[_key5];
            pairs.push({
              key: {
                status: "valid",
                value: _key5
              },
              value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, _key5) //, ctx.child(key), value, getParsedType(value)
              ),
              alwaysSet: _key5 in ctx.data
            });
          }
        } catch (err) {
          _iterator37.e(err);
        } finally {
          _iterator37.f();
        }
      }

      if (ctx.common.async) {
        return Promise.resolve().then( /*#__PURE__*/_asyncToGenerator2( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
          var syncPairs, _iterator38, _step38, pair, _key6, _value4;

          return _regeneratorRuntime.wrap(function _callee23$(_context24) {
            while (1) {
              switch (_context24.prev = _context24.next) {
                case 0:
                  syncPairs = [];
                  _iterator38 = _createForOfIteratorHelper(pairs);
                  _context24.prev = 2;

                  _iterator38.s();

                case 4:
                  if ((_step38 = _iterator38.n()).done) {
                    _context24.next = 15;
                    break;
                  }

                  pair = _step38.value;
                  _context24.next = 8;
                  return pair.key;

                case 8:
                  _key6 = _context24.sent;
                  _context24.next = 11;
                  return pair.value;

                case 11:
                  _value4 = _context24.sent;
                  syncPairs.push({
                    key: _key6,
                    value: _value4,
                    alwaysSet: pair.alwaysSet
                  });

                case 13:
                  _context24.next = 4;
                  break;

                case 15:
                  _context24.next = 20;
                  break;

                case 17:
                  _context24.prev = 17;
                  _context24.t0 = _context24["catch"](2);

                  _iterator38.e(_context24.t0);

                case 20:
                  _context24.prev = 20;

                  _iterator38.f();

                  return _context24.finish(20);

                case 23:
                  return _context24.abrupt("return", syncPairs);

                case 24:
                case "end":
                  return _context24.stop();
              }
            }
          }, _callee23, null, [[2, 17, 20, 23]]);
        }))).then(function (syncPairs) {
          return ParseStatus.mergeObjectSync(status, syncPairs);
        });
      } else {
        return ParseStatus.mergeObjectSync(status, pairs);
      }
    }
  }, {
    key: "shape",
    get: function get() {
      return this._def.shape();
    }
  }, {
    key: "strict",
    value: function strict(message) {
      var _this22 = this;

      errorUtil.errToObj;
      return new ZodObject(_objectSpread3(_objectSpread3({}, this._def), {}, {
        unknownKeys: "strict"
      }, message !== undefined ? {
        errorMap: function errorMap(issue, ctx) {
          var _this22$_def$errorMap, _this22$_def$errorMap2, _this22$_def, _errorUtil$errToObj$m;

          var defaultError = (_this22$_def$errorMap = (_this22$_def$errorMap2 = (_this22$_def = _this22._def).errorMap) === null || _this22$_def$errorMap2 === void 0 ? void 0 : _this22$_def$errorMap2.call(_this22$_def, issue, ctx).message) !== null && _this22$_def$errorMap !== void 0 ? _this22$_def$errorMap : ctx.defaultError;
          if (issue.code === "unrecognized_keys") return {
            message: (_errorUtil$errToObj$m = errorUtil.errToObj(message).message) !== null && _errorUtil$errToObj$m !== void 0 ? _errorUtil$errToObj$m : defaultError
          };
          return {
            message: defaultError
          };
        }
      } : {}));
    }
  }, {
    key: "strip",
    value: function strip() {
      return new ZodObject(_objectSpread3(_objectSpread3({}, this._def), {}, {
        unknownKeys: "strip"
      }));
    }
  }, {
    key: "passthrough",
    value: function passthrough() {
      return new ZodObject(_objectSpread3(_objectSpread3({}, this._def), {}, {
        unknownKeys: "passthrough"
      }));
    } // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };

  }, {
    key: "extend",
    value: function extend(augmentation) {
      var _this23 = this;

      return new ZodObject(_objectSpread3(_objectSpread3({}, this._def), {}, {
        shape: function shape() {
          return _objectSpread3(_objectSpread3({}, _this23._def.shape()), augmentation);
        }
      }));
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */

  }, {
    key: "merge",
    value: function merge(merging) {
      var _this24 = this;

      var merged = new ZodObject({
        unknownKeys: merging._def.unknownKeys,
        catchall: merging._def.catchall,
        shape: function shape() {
          return _objectSpread3(_objectSpread3({}, _this24._def.shape()), merging._def.shape());
        },
        typeName: ZodFirstPartyTypeKind.ZodObject
      });
      return merged;
    } // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }

  }, {
    key: "setKey",
    value: function setKey(key, schema) {
      return this.augment(_defineProperty2({}, key, schema));
    } // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }

  }, {
    key: "catchall",
    value: function catchall(index) {
      return new ZodObject(_objectSpread3(_objectSpread3({}, this._def), {}, {
        catchall: index
      }));
    }
  }, {
    key: "pick",
    value: function pick(mask) {
      var _shape = {};

      var _iterator39 = _createForOfIteratorHelper(util.objectKeys(mask)),
          _step39;

      try {
        for (_iterator39.s(); !(_step39 = _iterator39.n()).done;) {
          var key = _step39.value;

          if (mask[key] && this.shape[key]) {
            _shape[key] = this.shape[key];
          }
        }
      } catch (err) {
        _iterator39.e(err);
      } finally {
        _iterator39.f();
      }

      return new ZodObject(_objectSpread3(_objectSpread3({}, this._def), {}, {
        shape: function shape() {
          return _shape;
        }
      }));
    }
  }, {
    key: "omit",
    value: function omit(mask) {
      var _shape2 = {};

      var _iterator40 = _createForOfIteratorHelper(util.objectKeys(this.shape)),
          _step40;

      try {
        for (_iterator40.s(); !(_step40 = _iterator40.n()).done;) {
          var key = _step40.value;

          if (!mask[key]) {
            _shape2[key] = this.shape[key];
          }
        }
      } catch (err) {
        _iterator40.e(err);
      } finally {
        _iterator40.f();
      }

      return new ZodObject(_objectSpread3(_objectSpread3({}, this._def), {}, {
        shape: function shape() {
          return _shape2;
        }
      }));
    }
    /**
     * @deprecated
     */

  }, {
    key: "deepPartial",
    value: function deepPartial() {
      return deepPartialify(this);
    }
  }, {
    key: "partial",
    value: function partial(mask) {
      var newShape = {};

      var _iterator41 = _createForOfIteratorHelper(util.objectKeys(this.shape)),
          _step41;

      try {
        for (_iterator41.s(); !(_step41 = _iterator41.n()).done;) {
          var key = _step41.value;
          var fieldSchema = this.shape[key];

          if (mask && !mask[key]) {
            newShape[key] = fieldSchema;
          } else {
            newShape[key] = fieldSchema.optional();
          }
        }
      } catch (err) {
        _iterator41.e(err);
      } finally {
        _iterator41.f();
      }

      return new ZodObject(_objectSpread3(_objectSpread3({}, this._def), {}, {
        shape: function shape() {
          return newShape;
        }
      }));
    }
  }, {
    key: "required",
    value: function required(mask) {
      var newShape = {};

      var _iterator42 = _createForOfIteratorHelper(util.objectKeys(this.shape)),
          _step42;

      try {
        for (_iterator42.s(); !(_step42 = _iterator42.n()).done;) {
          var key = _step42.value;

          if (mask && !mask[key]) {
            newShape[key] = this.shape[key];
          } else {
            var fieldSchema = this.shape[key];
            var newField = fieldSchema;

            while (newField instanceof ZodOptional) {
              newField = newField._def.innerType;
            }

            newShape[key] = newField;
          }
        }
      } catch (err) {
        _iterator42.e(err);
      } finally {
        _iterator42.f();
      }

      return new ZodObject(_objectSpread3(_objectSpread3({}, this._def), {}, {
        shape: function shape() {
          return newShape;
        }
      }));
    }
  }, {
    key: "keyof",
    value: function keyof() {
      return createZodEnum(util.objectKeys(this.shape));
    }
  }]);

  return ZodObject;
}(ZodType);

ZodObject.create = function (_shape3, params) {
  return new ZodObject(_objectSpread3({
    shape: function shape() {
      return _shape3;
    },
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject
  }, processCreateParams(params)));
};

ZodObject.strictCreate = function (_shape4, params) {
  return new ZodObject(_objectSpread3({
    shape: function shape() {
      return _shape4;
    },
    unknownKeys: "strict",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject
  }, processCreateParams(params)));
};

ZodObject.lazycreate = function (shape, params) {
  return new ZodObject(_objectSpread3({
    shape: shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject
  }, processCreateParams(params)));
};

var ZodUnion = /*#__PURE__*/function (_ZodType15) {
  _inherits2(ZodUnion, _ZodType15);

  var _super26 = _createSuper2(ZodUnion);

  function ZodUnion() {
    _classCallCheck2(this, ZodUnion);

    return _super26.apply(this, arguments);
  }

  _createClass2(ZodUnion, [{
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa3 = this._processInputParams(input),
          ctx = _this$_processInputPa3.ctx;

      var options = this._def.options;

      function handleResults(results) {
        // return first issue-free validation if it exists
        var _iterator43 = _createForOfIteratorHelper(results),
            _step43;

        try {
          for (_iterator43.s(); !(_step43 = _iterator43.n()).done;) {
            var result = _step43.value;

            if (result.result.status === "valid") {
              return result.result;
            }
          }
        } catch (err) {
          _iterator43.e(err);
        } finally {
          _iterator43.f();
        }

        var _iterator44 = _createForOfIteratorHelper(results),
            _step44;

        try {
          for (_iterator44.s(); !(_step44 = _iterator44.n()).done;) {
            var _result5 = _step44.value;

            if (_result5.result.status === "dirty") {
              var _ctx$common$issues;

              // add issues from dirty option
              (_ctx$common$issues = ctx.common.issues).push.apply(_ctx$common$issues, _toConsumableArray2(_result5.ctx.common.issues));

              return _result5.result;
            }
          } // return invalid

        } catch (err) {
          _iterator44.e(err);
        } finally {
          _iterator44.f();
        }

        var unionErrors = results.map(function (result) {
          return new ZodError(result.ctx.common.issues);
        });
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_union,
          unionErrors: unionErrors
        });
        return INVALID;
      }

      if (ctx.common.async) {
        return Promise.all(options.map( /*#__PURE__*/function () {
          var _ref62 = _asyncToGenerator2( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(option) {
            var childCtx;
            return _regeneratorRuntime.wrap(function _callee24$(_context25) {
              while (1) {
                switch (_context25.prev = _context25.next) {
                  case 0:
                    childCtx = _objectSpread3(_objectSpread3({}, ctx), {}, {
                      common: _objectSpread3(_objectSpread3({}, ctx.common), {}, {
                        issues: []
                      }),
                      parent: null
                    });
                    _context25.next = 3;
                    return option._parseAsync({
                      data: ctx.data,
                      path: ctx.path,
                      parent: childCtx
                    });

                  case 3:
                    _context25.t0 = _context25.sent;
                    _context25.t1 = childCtx;
                    return _context25.abrupt("return", {
                      result: _context25.t0,
                      ctx: _context25.t1
                    });

                  case 6:
                  case "end":
                    return _context25.stop();
                }
              }
            }, _callee24);
          }));

          return function (_x44) {
            return _ref62.apply(this, arguments);
          };
        }())).then(handleResults);
      } else {
        var dirty = undefined;
        var issues = [];

        var _iterator45 = _createForOfIteratorHelper(options),
            _step45;

        try {
          for (_iterator45.s(); !(_step45 = _iterator45.n()).done;) {
            var option = _step45.value;

            var childCtx = _objectSpread3(_objectSpread3({}, ctx), {}, {
              common: _objectSpread3(_objectSpread3({}, ctx.common), {}, {
                issues: []
              }),
              parent: null
            });

            var result = option._parseSync({
              data: ctx.data,
              path: ctx.path,
              parent: childCtx
            });

            if (result.status === "valid") {
              return result;
            } else if (result.status === "dirty" && !dirty) {
              dirty = {
                result: result,
                ctx: childCtx
              };
            }

            if (childCtx.common.issues.length) {
              issues.push(childCtx.common.issues);
            }
          }
        } catch (err) {
          _iterator45.e(err);
        } finally {
          _iterator45.f();
        }

        if (dirty) {
          var _ctx$common$issues2;

          (_ctx$common$issues2 = ctx.common.issues).push.apply(_ctx$common$issues2, _toConsumableArray2(dirty.ctx.common.issues));

          return dirty.result;
        }

        var unionErrors = issues.map(function (issues) {
          return new ZodError(issues);
        });
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_union,
          unionErrors: unionErrors
        });
        return INVALID;
      }
    }
  }, {
    key: "options",
    get: function get() {
      return this._def.options;
    }
  }]);

  return ZodUnion;
}(ZodType);

ZodUnion.create = function (types, params) {
  return new ZodUnion(_objectSpread3({
    options: types,
    typeName: ZodFirstPartyTypeKind.ZodUnion
  }, processCreateParams(params)));
}; /////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////


var getDiscriminator = function getDiscriminator(type) {
  if (type instanceof ZodLazy) {
    return getDiscriminator(type.schema);
  } else if (type instanceof ZodEffects) {
    return getDiscriminator(type.innerType());
  } else if (type instanceof ZodLiteral) {
    return [type.value];
  } else if (type instanceof ZodEnum) {
    return type.options;
  } else if (type instanceof ZodNativeEnum) {
    // eslint-disable-next-line ban/ban
    return util.objectValues(type.enum);
  } else if (type instanceof ZodDefault) {
    return getDiscriminator(type._def.innerType);
  } else if (type instanceof ZodUndefined) {
    return [undefined];
  } else if (type instanceof ZodNull) {
    return [null];
  } else if (type instanceof ZodOptional) {
    return [undefined].concat(_toConsumableArray2(getDiscriminator(type.unwrap())));
  } else if (type instanceof ZodNullable) {
    return [null].concat(_toConsumableArray2(getDiscriminator(type.unwrap())));
  } else if (type instanceof ZodBranded) {
    return getDiscriminator(type.unwrap());
  } else if (type instanceof ZodReadonly) {
    return getDiscriminator(type.unwrap());
  } else if (type instanceof ZodCatch) {
    return getDiscriminator(type._def.innerType);
  } else {
    return [];
  }
};

var ZodDiscriminatedUnion = /*#__PURE__*/function (_ZodType16) {
  _inherits2(ZodDiscriminatedUnion, _ZodType16);

  var _super27 = _createSuper2(ZodDiscriminatedUnion);

  function ZodDiscriminatedUnion() {
    _classCallCheck2(this, ZodDiscriminatedUnion);

    return _super27.apply(this, arguments);
  }

  _createClass2(ZodDiscriminatedUnion, [{
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa4 = this._processInputParams(input),
          ctx = _this$_processInputPa4.ctx;

      if (ctx.parsedType !== ZodParsedType.object) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.object,
          received: ctx.parsedType
        });
        return INVALID;
      }

      var discriminator = this.discriminator;
      var discriminatorValue = ctx.data[discriminator];
      var option = this.optionsMap.get(discriminatorValue);

      if (!option) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_union_discriminator,
          options: Array.from(this.optionsMap.keys()),
          path: [discriminator]
        });
        return INVALID;
      }

      if (ctx.common.async) {
        return option._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
      } else {
        return option._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
      }
    }
  }, {
    key: "discriminator",
    get: function get() {
      return this._def.discriminator;
    }
  }, {
    key: "options",
    get: function get() {
      return this._def.options;
    }
  }, {
    key: "optionsMap",
    get: function get() {
      return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */

  }], [{
    key: "create",
    value: function create(discriminator, options, params) {
      // Get all the valid discriminator values
      var optionsMap = new Map(); // try {

      var _iterator46 = _createForOfIteratorHelper(options),
          _step46;

      try {
        for (_iterator46.s(); !(_step46 = _iterator46.n()).done;) {
          var type = _step46.value;
          var discriminatorValues = getDiscriminator(type.shape[discriminator]);

          if (!discriminatorValues.length) {
            throw new Error("A discriminator value for key `".concat(discriminator, "` could not be extracted from all schema options"));
          }

          var _iterator47 = _createForOfIteratorHelper(discriminatorValues),
              _step47;

          try {
            for (_iterator47.s(); !(_step47 = _iterator47.n()).done;) {
              var value = _step47.value;

              if (optionsMap.has(value)) {
                throw new Error("Discriminator property ".concat(String(discriminator), " has duplicate value ").concat(String(value)));
              }

              optionsMap.set(value, type);
            }
          } catch (err) {
            _iterator47.e(err);
          } finally {
            _iterator47.f();
          }
        }
      } catch (err) {
        _iterator46.e(err);
      } finally {
        _iterator46.f();
      }

      return new ZodDiscriminatedUnion(_objectSpread3({
        typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
        discriminator: discriminator,
        options: options,
        optionsMap: optionsMap
      }, processCreateParams(params)));
    }
  }]);

  return ZodDiscriminatedUnion;
}(ZodType);

function mergeValues(a, b) {
  var aType = getParsedType(a);
  var bType = getParsedType(b);

  if (a === b) {
    return {
      valid: true,
      data: a
    };
  } else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
    var bKeys = util.objectKeys(b);
    var sharedKeys = util.objectKeys(a).filter(function (key) {
      return bKeys.indexOf(key) !== -1;
    });

    var newObj = _objectSpread3(_objectSpread3({}, a), b);

    var _iterator48 = _createForOfIteratorHelper(sharedKeys),
        _step48;

    try {
      for (_iterator48.s(); !(_step48 = _iterator48.n()).done;) {
        var key = _step48.value;
        var sharedValue = mergeValues(a[key], b[key]);

        if (!sharedValue.valid) {
          return {
            valid: false
          };
        }

        newObj[key] = sharedValue.data;
      }
    } catch (err) {
      _iterator48.e(err);
    } finally {
      _iterator48.f();
    }

    return {
      valid: true,
      data: newObj
    };
  } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
    if (a.length !== b.length) {
      return {
        valid: false
      };
    }

    var newArray = [];

    for (var _index2 = 0; _index2 < a.length; _index2++) {
      var itemA = a[_index2];
      var itemB = b[_index2];

      var _sharedValue = mergeValues(itemA, itemB);

      if (!_sharedValue.valid) {
        return {
          valid: false
        };
      }

      newArray.push(_sharedValue.data);
    }

    return {
      valid: true,
      data: newArray
    };
  } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a === +b) {
    return {
      valid: true,
      data: a
    };
  } else {
    return {
      valid: false
    };
  }
}

var ZodIntersection = /*#__PURE__*/function (_ZodType17) {
  _inherits2(ZodIntersection, _ZodType17);

  var _super28 = _createSuper2(ZodIntersection);

  function ZodIntersection() {
    _classCallCheck2(this, ZodIntersection);

    return _super28.apply(this, arguments);
  }

  _createClass2(ZodIntersection, [{
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa5 = this._processInputParams(input),
          status = _this$_processInputPa5.status,
          ctx = _this$_processInputPa5.ctx;

      var handleParsed = function handleParsed(parsedLeft, parsedRight) {
        if (isAborted(parsedLeft) || isAborted(parsedRight)) {
          return INVALID;
        }

        var merged = mergeValues(parsedLeft.value, parsedRight.value);

        if (!merged.valid) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_intersection_types
          });
          return INVALID;
        }

        if (isDirty(parsedLeft) || isDirty(parsedRight)) {
          status.dirty();
        }

        return {
          status: status.value,
          value: merged.data
        };
      };

      if (ctx.common.async) {
        return Promise.all([this._def.left._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }), this._def.right._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        })]).then(function (_ref63) {
          var _ref64 = _slicedToArray2(_ref63, 2),
              left = _ref64[0],
              right = _ref64[1];

          return handleParsed(left, right);
        });
      } else {
        return handleParsed(this._def.left._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }), this._def.right._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }));
      }
    }
  }]);

  return ZodIntersection;
}(ZodType);

ZodIntersection.create = function (left, right, params) {
  return new ZodIntersection(_objectSpread3({
    left: left,
    right: right,
    typeName: ZodFirstPartyTypeKind.ZodIntersection
  }, processCreateParams(params)));
}; // type ZodTupleItems = [ZodTypeAny, ...ZodTypeAny[]];


var ZodTuple = /*#__PURE__*/function (_ZodType18) {
  _inherits2(ZodTuple, _ZodType18);

  var _super29 = _createSuper2(ZodTuple);

  function ZodTuple() {
    _classCallCheck2(this, ZodTuple);

    return _super29.apply(this, arguments);
  }

  _createClass2(ZodTuple, [{
    key: "_parse",
    value: function _parse(input) {
      var _this25 = this;

      var _this$_processInputPa6 = this._processInputParams(input),
          status = _this$_processInputPa6.status,
          ctx = _this$_processInputPa6.ctx;

      if (ctx.parsedType !== ZodParsedType.array) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.array,
          received: ctx.parsedType
        });
        return INVALID;
      }

      if (ctx.data.length < this._def.items.length) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: this._def.items.length,
          inclusive: true,
          exact: false,
          type: "array"
        });
        return INVALID;
      }

      var rest = this._def.rest;

      if (!rest && ctx.data.length > this._def.items.length) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: this._def.items.length,
          inclusive: true,
          exact: false,
          type: "array"
        });
        status.dirty();
      }

      var items = _toConsumableArray2(ctx.data).map(function (item, itemIndex) {
        var schema = _this25._def.items[itemIndex] || _this25._def.rest;
        if (!schema) return null;
        return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
      }).filter(function (x) {
        return !!x;
      }); // filter nulls


      if (ctx.common.async) {
        return Promise.all(items).then(function (results) {
          return ParseStatus.mergeArray(status, results);
        });
      } else {
        return ParseStatus.mergeArray(status, items);
      }
    }
  }, {
    key: "items",
    get: function get() {
      return this._def.items;
    }
  }, {
    key: "rest",
    value: function rest(_rest) {
      return new ZodTuple(_objectSpread3(_objectSpread3({}, this._def), {}, {
        rest: _rest
      }));
    }
  }]);

  return ZodTuple;
}(ZodType);

ZodTuple.create = function (schemas, params) {
  if (!Array.isArray(schemas)) {
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  }

  return new ZodTuple(_objectSpread3({
    items: schemas,
    typeName: ZodFirstPartyTypeKind.ZodTuple,
    rest: null
  }, processCreateParams(params)));
};

var ZodRecord = /*#__PURE__*/function (_ZodType19) {
  _inherits2(ZodRecord, _ZodType19);

  var _super30 = _createSuper2(ZodRecord);

  function ZodRecord() {
    _classCallCheck2(this, ZodRecord);

    return _super30.apply(this, arguments);
  }

  _createClass2(ZodRecord, [{
    key: "keySchema",
    get: function get() {
      return this._def.keyType;
    }
  }, {
    key: "valueSchema",
    get: function get() {
      return this._def.valueType;
    }
  }, {
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa7 = this._processInputParams(input),
          status = _this$_processInputPa7.status,
          ctx = _this$_processInputPa7.ctx;

      if (ctx.parsedType !== ZodParsedType.object) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.object,
          received: ctx.parsedType
        });
        return INVALID;
      }

      var pairs = [];
      var keyType = this._def.keyType;
      var valueType = this._def.valueType;

      for (var key in ctx.data) {
        pairs.push({
          key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
          value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
          alwaysSet: key in ctx.data
        });
      }

      if (ctx.common.async) {
        return ParseStatus.mergeObjectAsync(status, pairs);
      } else {
        return ParseStatus.mergeObjectSync(status, pairs);
      }
    }
  }, {
    key: "element",
    get: function get() {
      return this._def.valueType;
    }
  }], [{
    key: "create",
    value: function create(first, second, third) {
      if (second instanceof ZodType) {
        return new ZodRecord(_objectSpread3({
          keyType: first,
          valueType: second,
          typeName: ZodFirstPartyTypeKind.ZodRecord
        }, processCreateParams(third)));
      }

      return new ZodRecord(_objectSpread3({
        keyType: ZodString.create(),
        valueType: first,
        typeName: ZodFirstPartyTypeKind.ZodRecord
      }, processCreateParams(second)));
    }
  }]);

  return ZodRecord;
}(ZodType);

var ZodMap = /*#__PURE__*/function (_ZodType20) {
  _inherits2(ZodMap, _ZodType20);

  var _super31 = _createSuper2(ZodMap);

  function ZodMap() {
    _classCallCheck2(this, ZodMap);

    return _super31.apply(this, arguments);
  }

  _createClass2(ZodMap, [{
    key: "keySchema",
    get: function get() {
      return this._def.keyType;
    }
  }, {
    key: "valueSchema",
    get: function get() {
      return this._def.valueType;
    }
  }, {
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa8 = this._processInputParams(input),
          status = _this$_processInputPa8.status,
          ctx = _this$_processInputPa8.ctx;

      if (ctx.parsedType !== ZodParsedType.map) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.map,
          received: ctx.parsedType
        });
        return INVALID;
      }

      var keyType = this._def.keyType;
      var valueType = this._def.valueType;

      var pairs = _toConsumableArray2(ctx.data.entries()).map(function (_ref65, index) {
        var _ref66 = _slicedToArray2(_ref65, 2),
            key = _ref66[0],
            value = _ref66[1];

        return {
          key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
          value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"]))
        };
      });

      if (ctx.common.async) {
        var finalMap = new Map();
        return Promise.resolve().then( /*#__PURE__*/_asyncToGenerator2( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
          var _iterator49, _step49, pair, key, value;

          return _regeneratorRuntime.wrap(function _callee25$(_context26) {
            while (1) {
              switch (_context26.prev = _context26.next) {
                case 0:
                  _iterator49 = _createForOfIteratorHelper(pairs);
                  _context26.prev = 1;

                  _iterator49.s();

                case 3:
                  if ((_step49 = _iterator49.n()).done) {
                    _context26.next = 17;
                    break;
                  }

                  pair = _step49.value;
                  _context26.next = 7;
                  return pair.key;

                case 7:
                  key = _context26.sent;
                  _context26.next = 10;
                  return pair.value;

                case 10:
                  value = _context26.sent;

                  if (!(key.status === "aborted" || value.status === "aborted")) {
                    _context26.next = 13;
                    break;
                  }

                  return _context26.abrupt("return", INVALID);

                case 13:
                  if (key.status === "dirty" || value.status === "dirty") {
                    status.dirty();
                  }

                  finalMap.set(key.value, value.value);

                case 15:
                  _context26.next = 3;
                  break;

                case 17:
                  _context26.next = 22;
                  break;

                case 19:
                  _context26.prev = 19;
                  _context26.t0 = _context26["catch"](1);

                  _iterator49.e(_context26.t0);

                case 22:
                  _context26.prev = 22;

                  _iterator49.f();

                  return _context26.finish(22);

                case 25:
                  return _context26.abrupt("return", {
                    status: status.value,
                    value: finalMap
                  });

                case 26:
                case "end":
                  return _context26.stop();
              }
            }
          }, _callee25, null, [[1, 19, 22, 25]]);
        })));
      } else {
        var _finalMap = new Map();

        var _iterator50 = _createForOfIteratorHelper(pairs),
            _step50;

        try {
          for (_iterator50.s(); !(_step50 = _iterator50.n()).done;) {
            var pair = _step50.value;
            var key = pair.key;
            var value = pair.value;

            if (key.status === "aborted" || value.status === "aborted") {
              return INVALID;
            }

            if (key.status === "dirty" || value.status === "dirty") {
              status.dirty();
            }

            _finalMap.set(key.value, value.value);
          }
        } catch (err) {
          _iterator50.e(err);
        } finally {
          _iterator50.f();
        }

        return {
          status: status.value,
          value: _finalMap
        };
      }
    }
  }]);

  return ZodMap;
}(ZodType);

ZodMap.create = function (keyType, valueType, params) {
  return new ZodMap(_objectSpread3({
    valueType: valueType,
    keyType: keyType,
    typeName: ZodFirstPartyTypeKind.ZodMap
  }, processCreateParams(params)));
};

var ZodSet = /*#__PURE__*/function (_ZodType21) {
  _inherits2(ZodSet, _ZodType21);

  var _super32 = _createSuper2(ZodSet);

  function ZodSet() {
    _classCallCheck2(this, ZodSet);

    return _super32.apply(this, arguments);
  }

  _createClass2(ZodSet, [{
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa9 = this._processInputParams(input),
          status = _this$_processInputPa9.status,
          ctx = _this$_processInputPa9.ctx;

      if (ctx.parsedType !== ZodParsedType.set) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.set,
          received: ctx.parsedType
        });
        return INVALID;
      }

      var def = this._def;

      if (def.minSize !== null) {
        if (ctx.data.size < def.minSize.value) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: def.minSize.value,
            type: "set",
            inclusive: true,
            exact: false,
            message: def.minSize.message
          });
          status.dirty();
        }
      }

      if (def.maxSize !== null) {
        if (ctx.data.size > def.maxSize.value) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: def.maxSize.value,
            type: "set",
            inclusive: true,
            exact: false,
            message: def.maxSize.message
          });
          status.dirty();
        }
      }

      var valueType = this._def.valueType;

      function finalizeSet(elements) {
        var parsedSet = new Set();

        var _iterator51 = _createForOfIteratorHelper(elements),
            _step51;

        try {
          for (_iterator51.s(); !(_step51 = _iterator51.n()).done;) {
            var element = _step51.value;
            if (element.status === "aborted") return INVALID;
            if (element.status === "dirty") status.dirty();
            parsedSet.add(element.value);
          }
        } catch (err) {
          _iterator51.e(err);
        } finally {
          _iterator51.f();
        }

        return {
          status: status.value,
          value: parsedSet
        };
      }

      var elements = _toConsumableArray2(ctx.data.values()).map(function (item, i) {
        return valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i));
      });

      if (ctx.common.async) {
        return Promise.all(elements).then(function (elements) {
          return finalizeSet(elements);
        });
      } else {
        return finalizeSet(elements);
      }
    }
  }, {
    key: "min",
    value: function min(minSize, message) {
      return new ZodSet(_objectSpread3(_objectSpread3({}, this._def), {}, {
        minSize: {
          value: minSize,
          message: errorUtil.toString(message)
        }
      }));
    }
  }, {
    key: "max",
    value: function max(maxSize, message) {
      return new ZodSet(_objectSpread3(_objectSpread3({}, this._def), {}, {
        maxSize: {
          value: maxSize,
          message: errorUtil.toString(message)
        }
      }));
    }
  }, {
    key: "size",
    value: function size(_size, message) {
      return this.min(_size, message).max(_size, message);
    }
  }, {
    key: "nonempty",
    value: function nonempty(message) {
      return this.min(1, message);
    }
  }]);

  return ZodSet;
}(ZodType);

ZodSet.create = function (valueType, params) {
  return new ZodSet(_objectSpread3({
    valueType: valueType,
    minSize: null,
    maxSize: null,
    typeName: ZodFirstPartyTypeKind.ZodSet
  }, processCreateParams(params)));
};

var ZodFunction = /*#__PURE__*/function (_ZodType22) {
  _inherits2(ZodFunction, _ZodType22);

  var _super33 = _createSuper2(ZodFunction);

  function ZodFunction() {
    var _this26;

    _classCallCheck2(this, ZodFunction);

    _this26 = _super33.apply(this, arguments);
    _this26.validate = _this26.implement;
    return _this26;
  }

  _createClass2(ZodFunction, [{
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa10 = this._processInputParams(input),
          ctx = _this$_processInputPa10.ctx;

      if (ctx.parsedType !== ZodParsedType.function) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.function,
          received: ctx.parsedType
        });
        return INVALID;
      }

      function makeArgsIssue(args, error) {
        return makeIssue({
          data: args,
          path: ctx.path,
          errorMaps: [ctx.common.contextualErrorMap, ctx.schemaErrorMap, getErrorMap(), defaultErrorMap].filter(function (x) {
            return !!x;
          }),
          issueData: {
            code: ZodIssueCode.invalid_arguments,
            argumentsError: error
          }
        });
      }

      function makeReturnsIssue(returns, error) {
        return makeIssue({
          data: returns,
          path: ctx.path,
          errorMaps: [ctx.common.contextualErrorMap, ctx.schemaErrorMap, getErrorMap(), defaultErrorMap].filter(function (x) {
            return !!x;
          }),
          issueData: {
            code: ZodIssueCode.invalid_return_type,
            returnTypeError: error
          }
        });
      }

      var params = {
        errorMap: ctx.common.contextualErrorMap
      };
      var fn = ctx.data;

      if (this._def.returns instanceof ZodPromise) {
        // Would love a way to avoid disabling this rule, but we need
        // an alias (using an arrow function was what caused 2651).
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var me = this;
        return OK( /*#__PURE__*/_asyncToGenerator2( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
          var _len4,
              args,
              _key8,
              error,
              parsedArgs,
              result,
              parsedReturns,
              _args25 = arguments;

          return _regeneratorRuntime.wrap(function _callee26$(_context27) {
            while (1) {
              switch (_context27.prev = _context27.next) {
                case 0:
                  for (_len4 = _args25.length, args = new Array(_len4), _key8 = 0; _key8 < _len4; _key8++) {
                    args[_key8] = _args25[_key8];
                  }

                  error = new ZodError([]);
                  _context27.next = 4;
                  return me._def.args.parseAsync(args, params).catch(function (e) {
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                  });

                case 4:
                  parsedArgs = _context27.sent;
                  _context27.next = 7;
                  return Reflect.apply(fn, this, parsedArgs);

                case 7:
                  result = _context27.sent;
                  _context27.next = 10;
                  return me._def.returns._def.type.parseAsync(result, params).catch(function (e) {
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                  });

                case 10:
                  parsedReturns = _context27.sent;
                  return _context27.abrupt("return", parsedReturns);

                case 12:
                case "end":
                  return _context27.stop();
              }
            }
          }, _callee26, this);
        })));
      } else {
        // Would love a way to avoid disabling this rule, but we need
        // an alias (using an arrow function was what caused 2651).
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var _me = this;

        return OK(function () {
          for (var _len5 = arguments.length, args = new Array(_len5), _key9 = 0; _key9 < _len5; _key9++) {
            args[_key9] = arguments[_key9];
          }

          var parsedArgs = _me._def.args.safeParse(args, params);

          if (!parsedArgs.success) {
            throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
          }

          var result = Reflect.apply(fn, this, parsedArgs.data);

          var parsedReturns = _me._def.returns.safeParse(result, params);

          if (!parsedReturns.success) {
            throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
          }

          return parsedReturns.data;
        });
      }
    }
  }, {
    key: "parameters",
    value: function parameters() {
      return this._def.args;
    }
  }, {
    key: "returnType",
    value: function returnType() {
      return this._def.returns;
    }
  }, {
    key: "args",
    value: function args() {
      for (var _len6 = arguments.length, items = new Array(_len6), _key10 = 0; _key10 < _len6; _key10++) {
        items[_key10] = arguments[_key10];
      }

      return new ZodFunction(_objectSpread3(_objectSpread3({}, this._def), {}, {
        args: ZodTuple.create(items).rest(ZodUnknown.create())
      }));
    }
  }, {
    key: "returns",
    value: function returns(returnType) {
      return new ZodFunction(_objectSpread3(_objectSpread3({}, this._def), {}, {
        returns: returnType
      }));
    }
  }, {
    key: "implement",
    value: function implement(func) {
      var validatedFunc = this.parse(func);
      return validatedFunc;
    }
  }, {
    key: "strictImplement",
    value: function strictImplement(func) {
      var validatedFunc = this.parse(func);
      return validatedFunc;
    }
  }], [{
    key: "create",
    value: function create(args, returns, params) {
      return new ZodFunction(_objectSpread3({
        args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
        returns: returns || ZodUnknown.create(),
        typeName: ZodFirstPartyTypeKind.ZodFunction
      }, processCreateParams(params)));
    }
  }]);

  return ZodFunction;
}(ZodType);

var ZodLazy = /*#__PURE__*/function (_ZodType23) {
  _inherits2(ZodLazy, _ZodType23);

  var _super34 = _createSuper2(ZodLazy);

  function ZodLazy() {
    _classCallCheck2(this, ZodLazy);

    return _super34.apply(this, arguments);
  }

  _createClass2(ZodLazy, [{
    key: "schema",
    get: function get() {
      return this._def.getter();
    }
  }, {
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa11 = this._processInputParams(input),
          ctx = _this$_processInputPa11.ctx;

      var lazySchema = this._def.getter();

      return lazySchema._parse({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    }
  }]);

  return ZodLazy;
}(ZodType);

ZodLazy.create = function (getter, params) {
  return new ZodLazy(_objectSpread3({
    getter: getter,
    typeName: ZodFirstPartyTypeKind.ZodLazy
  }, processCreateParams(params)));
};

var ZodLiteral = /*#__PURE__*/function (_ZodType24) {
  _inherits2(ZodLiteral, _ZodType24);

  var _super35 = _createSuper2(ZodLiteral);

  function ZodLiteral() {
    _classCallCheck2(this, ZodLiteral);

    return _super35.apply(this, arguments);
  }

  _createClass2(ZodLiteral, [{
    key: "_parse",
    value: function _parse(input) {
      if (input.data !== this._def.value) {
        var ctx = this._getOrReturnCtx(input);

        addIssueToContext(ctx, {
          received: ctx.data,
          code: ZodIssueCode.invalid_literal,
          expected: this._def.value
        });
        return INVALID;
      }

      return {
        status: "valid",
        value: input.data
      };
    }
  }, {
    key: "value",
    get: function get() {
      return this._def.value;
    }
  }]);

  return ZodLiteral;
}(ZodType);

ZodLiteral.create = function (value, params) {
  return new ZodLiteral(_objectSpread3({
    value: value,
    typeName: ZodFirstPartyTypeKind.ZodLiteral
  }, processCreateParams(params)));
};

function createZodEnum(values, params) {
  return new ZodEnum(_objectSpread3({
    values: values,
    typeName: ZodFirstPartyTypeKind.ZodEnum
  }, processCreateParams(params)));
}

var ZodEnum = /*#__PURE__*/function (_ZodType25) {
  _inherits2(ZodEnum, _ZodType25);

  var _super36 = _createSuper2(ZodEnum);

  function ZodEnum() {
    _classCallCheck2(this, ZodEnum);

    return _super36.apply(this, arguments);
  }

  _createClass2(ZodEnum, [{
    key: "_parse",
    value: function _parse(input) {
      if (typeof input.data !== "string") {
        var ctx = this._getOrReturnCtx(input);

        var expectedValues = this._def.values;
        addIssueToContext(ctx, {
          expected: util.joinValues(expectedValues),
          received: ctx.parsedType,
          code: ZodIssueCode.invalid_type
        });
        return INVALID;
      }

      if (!this._cache) {
        this._cache = new Set(this._def.values);
      }

      if (!this._cache.has(input.data)) {
        var _ctx7 = this._getOrReturnCtx(input);

        var _expectedValues = this._def.values;
        addIssueToContext(_ctx7, {
          received: _ctx7.data,
          code: ZodIssueCode.invalid_enum_value,
          options: _expectedValues
        });
        return INVALID;
      }

      return OK(input.data);
    }
  }, {
    key: "options",
    get: function get() {
      return this._def.values;
    }
  }, {
    key: "enum",
    get: function get() {
      var enumValues = {};

      var _iterator52 = _createForOfIteratorHelper(this._def.values),
          _step52;

      try {
        for (_iterator52.s(); !(_step52 = _iterator52.n()).done;) {
          var val = _step52.value;
          enumValues[val] = val;
        }
      } catch (err) {
        _iterator52.e(err);
      } finally {
        _iterator52.f();
      }

      return enumValues;
    }
  }, {
    key: "Values",
    get: function get() {
      var enumValues = {};

      var _iterator53 = _createForOfIteratorHelper(this._def.values),
          _step53;

      try {
        for (_iterator53.s(); !(_step53 = _iterator53.n()).done;) {
          var val = _step53.value;
          enumValues[val] = val;
        }
      } catch (err) {
        _iterator53.e(err);
      } finally {
        _iterator53.f();
      }

      return enumValues;
    }
  }, {
    key: "Enum",
    get: function get() {
      var enumValues = {};

      var _iterator54 = _createForOfIteratorHelper(this._def.values),
          _step54;

      try {
        for (_iterator54.s(); !(_step54 = _iterator54.n()).done;) {
          var val = _step54.value;
          enumValues[val] = val;
        }
      } catch (err) {
        _iterator54.e(err);
      } finally {
        _iterator54.f();
      }

      return enumValues;
    }
  }, {
    key: "extract",
    value: function extract(values) {
      var newDef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._def;
      return ZodEnum.create(values, _objectSpread3(_objectSpread3({}, this._def), newDef));
    }
  }, {
    key: "exclude",
    value: function exclude(values) {
      var newDef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._def;
      return ZodEnum.create(this.options.filter(function (opt) {
        return !values.includes(opt);
      }), _objectSpread3(_objectSpread3({}, this._def), newDef));
    }
  }]);

  return ZodEnum;
}(ZodType);

ZodEnum.create = createZodEnum;

var ZodNativeEnum = /*#__PURE__*/function (_ZodType26) {
  _inherits2(ZodNativeEnum, _ZodType26);

  var _super37 = _createSuper2(ZodNativeEnum);

  function ZodNativeEnum() {
    _classCallCheck2(this, ZodNativeEnum);

    return _super37.apply(this, arguments);
  }

  _createClass2(ZodNativeEnum, [{
    key: "_parse",
    value: function _parse(input) {
      var nativeEnumValues = util.getValidEnumValues(this._def.values);

      var ctx = this._getOrReturnCtx(input);

      if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
        var expectedValues = util.objectValues(nativeEnumValues);
        addIssueToContext(ctx, {
          expected: util.joinValues(expectedValues),
          received: ctx.parsedType,
          code: ZodIssueCode.invalid_type
        });
        return INVALID;
      }

      if (!this._cache) {
        this._cache = new Set(util.getValidEnumValues(this._def.values));
      }

      if (!this._cache.has(input.data)) {
        var _expectedValues2 = util.objectValues(nativeEnumValues);

        addIssueToContext(ctx, {
          received: ctx.data,
          code: ZodIssueCode.invalid_enum_value,
          options: _expectedValues2
        });
        return INVALID;
      }

      return OK(input.data);
    }
  }, {
    key: "enum",
    get: function get() {
      return this._def.values;
    }
  }]);

  return ZodNativeEnum;
}(ZodType);

ZodNativeEnum.create = function (values, params) {
  return new ZodNativeEnum(_objectSpread3({
    values: values,
    typeName: ZodFirstPartyTypeKind.ZodNativeEnum
  }, processCreateParams(params)));
};

var ZodPromise = /*#__PURE__*/function (_ZodType27) {
  _inherits2(ZodPromise, _ZodType27);

  var _super38 = _createSuper2(ZodPromise);

  function ZodPromise() {
    _classCallCheck2(this, ZodPromise);

    return _super38.apply(this, arguments);
  }

  _createClass2(ZodPromise, [{
    key: "unwrap",
    value: function unwrap() {
      return this._def.type;
    }
  }, {
    key: "_parse",
    value: function _parse(input) {
      var _this27 = this;

      var _this$_processInputPa12 = this._processInputParams(input),
          ctx = _this$_processInputPa12.ctx;

      if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.promise,
          received: ctx.parsedType
        });
        return INVALID;
      }

      var promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
      return OK(promisified.then(function (data) {
        return _this27._def.type.parseAsync(data, {
          path: ctx.path,
          errorMap: ctx.common.contextualErrorMap
        });
      }));
    }
  }]);

  return ZodPromise;
}(ZodType);

ZodPromise.create = function (schema, params) {
  return new ZodPromise(_objectSpread3({
    type: schema,
    typeName: ZodFirstPartyTypeKind.ZodPromise
  }, processCreateParams(params)));
};

var ZodEffects = /*#__PURE__*/function (_ZodType28) {
  _inherits2(ZodEffects, _ZodType28);

  var _super39 = _createSuper2(ZodEffects);

  function ZodEffects() {
    _classCallCheck2(this, ZodEffects);

    return _super39.apply(this, arguments);
  }

  _createClass2(ZodEffects, [{
    key: "innerType",
    value: function innerType() {
      return this._def.schema;
    }
  }, {
    key: "sourceType",
    value: function sourceType() {
      return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
  }, {
    key: "_parse",
    value: function _parse(input) {
      var _this28 = this;

      var _this$_processInputPa13 = this._processInputParams(input),
          status = _this$_processInputPa13.status,
          ctx = _this$_processInputPa13.ctx;

      var effect = this._def.effect || null;
      var checkCtx = {
        addIssue: function addIssue(arg) {
          addIssueToContext(ctx, arg);

          if (arg.fatal) {
            status.abort();
          } else {
            status.dirty();
          }
        },

        get path() {
          return ctx.path;
        }

      };
      checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);

      if (effect.type === "preprocess") {
        var processed = effect.transform(ctx.data, checkCtx);

        if (ctx.common.async) {
          return Promise.resolve(processed).then( /*#__PURE__*/function () {
            var _ref69 = _asyncToGenerator2( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(processed) {
              var result;
              return _regeneratorRuntime.wrap(function _callee27$(_context28) {
                while (1) {
                  switch (_context28.prev = _context28.next) {
                    case 0:
                      if (!(status.value === "aborted")) {
                        _context28.next = 2;
                        break;
                      }

                      return _context28.abrupt("return", INVALID);

                    case 2:
                      _context28.next = 4;
                      return _this28._def.schema._parseAsync({
                        data: processed,
                        path: ctx.path,
                        parent: ctx
                      });

                    case 4:
                      result = _context28.sent;

                      if (!(result.status === "aborted")) {
                        _context28.next = 7;
                        break;
                      }

                      return _context28.abrupt("return", INVALID);

                    case 7:
                      if (!(result.status === "dirty")) {
                        _context28.next = 9;
                        break;
                      }

                      return _context28.abrupt("return", DIRTY(result.value));

                    case 9:
                      if (!(status.value === "dirty")) {
                        _context28.next = 11;
                        break;
                      }

                      return _context28.abrupt("return", DIRTY(result.value));

                    case 11:
                      return _context28.abrupt("return", result);

                    case 12:
                    case "end":
                      return _context28.stop();
                  }
                }
              }, _callee27);
            }));

            return function (_x45) {
              return _ref69.apply(this, arguments);
            };
          }());
        } else {
          if (status.value === "aborted") return INVALID;

          var result = this._def.schema._parseSync({
            data: processed,
            path: ctx.path,
            parent: ctx
          });

          if (result.status === "aborted") return INVALID;
          if (result.status === "dirty") return DIRTY(result.value);
          if (status.value === "dirty") return DIRTY(result.value);
          return result;
        }
      }

      if (effect.type === "refinement") {
        var executeRefinement = function executeRefinement(acc) {
          var result = effect.refinement(acc, checkCtx);

          if (ctx.common.async) {
            return Promise.resolve(result);
          }

          if (result instanceof Promise) {
            throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
          }

          return acc;
        };

        if (ctx.common.async === false) {
          var inner = this._def.schema._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          });

          if (inner.status === "aborted") return INVALID;
          if (inner.status === "dirty") status.dirty(); // return value is ignored

          executeRefinement(inner.value);
          return {
            status: status.value,
            value: inner.value
          };
        } else {
          return this._def.schema._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          }).then(function (inner) {
            if (inner.status === "aborted") return INVALID;
            if (inner.status === "dirty") status.dirty();
            return executeRefinement(inner.value).then(function () {
              return {
                status: status.value,
                value: inner.value
              };
            });
          });
        }
      }

      if (effect.type === "transform") {
        if (ctx.common.async === false) {
          var _base = this._def.schema._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          });

          if (!isValid(_base)) return INVALID;

          var _result6 = effect.transform(_base.value, checkCtx);

          if (_result6 instanceof Promise) {
            throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
          }

          return {
            status: status.value,
            value: _result6
          };
        } else {
          return this._def.schema._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          }).then(function (base) {
            if (!isValid(base)) return INVALID;
            return Promise.resolve(effect.transform(base.value, checkCtx)).then(function (result) {
              return {
                status: status.value,
                value: result
              };
            });
          });
        }
      }

      util.assertNever(effect);
    }
  }]);

  return ZodEffects;
}(ZodType);

ZodEffects.create = function (schema, effect, params) {
  return new ZodEffects(_objectSpread3({
    schema: schema,
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    effect: effect
  }, processCreateParams(params)));
};

ZodEffects.createWithPreprocess = function (preprocess, schema, params) {
  return new ZodEffects(_objectSpread3({
    schema: schema,
    effect: {
      type: "preprocess",
      transform: preprocess
    },
    typeName: ZodFirstPartyTypeKind.ZodEffects
  }, processCreateParams(params)));
};

var ZodOptional = /*#__PURE__*/function (_ZodType29) {
  _inherits2(ZodOptional, _ZodType29);

  var _super40 = _createSuper2(ZodOptional);

  function ZodOptional() {
    _classCallCheck2(this, ZodOptional);

    return _super40.apply(this, arguments);
  }

  _createClass2(ZodOptional, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);

      if (parsedType === ZodParsedType.undefined) {
        return OK(undefined);
      }

      return this._def.innerType._parse(input);
    }
  }, {
    key: "unwrap",
    value: function unwrap() {
      return this._def.innerType;
    }
  }]);

  return ZodOptional;
}(ZodType);

ZodOptional.create = function (type, params) {
  return new ZodOptional(_objectSpread3({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodOptional
  }, processCreateParams(params)));
};

var ZodNullable = /*#__PURE__*/function (_ZodType30) {
  _inherits2(ZodNullable, _ZodType30);

  var _super41 = _createSuper2(ZodNullable);

  function ZodNullable() {
    _classCallCheck2(this, ZodNullable);

    return _super41.apply(this, arguments);
  }

  _createClass2(ZodNullable, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);

      if (parsedType === ZodParsedType.null) {
        return OK(null);
      }

      return this._def.innerType._parse(input);
    }
  }, {
    key: "unwrap",
    value: function unwrap() {
      return this._def.innerType;
    }
  }]);

  return ZodNullable;
}(ZodType);

ZodNullable.create = function (type, params) {
  return new ZodNullable(_objectSpread3({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodNullable
  }, processCreateParams(params)));
};

var ZodDefault = /*#__PURE__*/function (_ZodType31) {
  _inherits2(ZodDefault, _ZodType31);

  var _super42 = _createSuper2(ZodDefault);

  function ZodDefault() {
    _classCallCheck2(this, ZodDefault);

    return _super42.apply(this, arguments);
  }

  _createClass2(ZodDefault, [{
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa14 = this._processInputParams(input),
          ctx = _this$_processInputPa14.ctx;

      var data = ctx.data;

      if (ctx.parsedType === ZodParsedType.undefined) {
        data = this._def.defaultValue();
      }

      return this._def.innerType._parse({
        data: data,
        path: ctx.path,
        parent: ctx
      });
    }
  }, {
    key: "removeDefault",
    value: function removeDefault() {
      return this._def.innerType;
    }
  }]);

  return ZodDefault;
}(ZodType);

ZodDefault.create = function (type, params) {
  return new ZodDefault(_objectSpread3({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodDefault,
    defaultValue: typeof params.default === "function" ? params.default : function () {
      return params.default;
    }
  }, processCreateParams(params)));
};

var ZodCatch = /*#__PURE__*/function (_ZodType32) {
  _inherits2(ZodCatch, _ZodType32);

  var _super43 = _createSuper2(ZodCatch);

  function ZodCatch() {
    _classCallCheck2(this, ZodCatch);

    return _super43.apply(this, arguments);
  }

  _createClass2(ZodCatch, [{
    key: "_parse",
    value: function _parse(input) {
      var _this29 = this;

      var _this$_processInputPa15 = this._processInputParams(input),
          ctx = _this$_processInputPa15.ctx; // newCtx is used to not collect issues from inner types in ctx


      var newCtx = _objectSpread3(_objectSpread3({}, ctx), {}, {
        common: _objectSpread3(_objectSpread3({}, ctx.common), {}, {
          issues: []
        })
      });

      var result = this._def.innerType._parse({
        data: newCtx.data,
        path: newCtx.path,
        parent: _objectSpread3({}, newCtx)
      });

      if (isAsync(result)) {
        return result.then(function (result) {
          return {
            status: "valid",
            value: result.status === "valid" ? result.value : _this29._def.catchValue({
              get error() {
                return new ZodError(newCtx.common.issues);
              },

              input: newCtx.data
            })
          };
        });
      } else {
        return {
          status: "valid",
          value: result.status === "valid" ? result.value : this._def.catchValue({
            get error() {
              return new ZodError(newCtx.common.issues);
            },

            input: newCtx.data
          })
        };
      }
    }
  }, {
    key: "removeCatch",
    value: function removeCatch() {
      return this._def.innerType;
    }
  }]);

  return ZodCatch;
}(ZodType);

ZodCatch.create = function (type, params) {
  return new ZodCatch(_objectSpread3({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodCatch,
    catchValue: typeof params.catch === "function" ? params.catch : function () {
      return params.catch;
    }
  }, processCreateParams(params)));
};

var ZodNaN = /*#__PURE__*/function (_ZodType33) {
  _inherits2(ZodNaN, _ZodType33);

  var _super44 = _createSuper2(ZodNaN);

  function ZodNaN() {
    _classCallCheck2(this, ZodNaN);

    return _super44.apply(this, arguments);
  }

  _createClass2(ZodNaN, [{
    key: "_parse",
    value: function _parse(input) {
      var parsedType = this._getType(input);

      if (parsedType !== ZodParsedType.nan) {
        var ctx = this._getOrReturnCtx(input);

        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.nan,
          received: ctx.parsedType
        });
        return INVALID;
      }

      return {
        status: "valid",
        value: input.data
      };
    }
  }]);

  return ZodNaN;
}(ZodType);

ZodNaN.create = function (params) {
  return new ZodNaN(_objectSpread3({
    typeName: ZodFirstPartyTypeKind.ZodNaN
  }, processCreateParams(params)));
};

var BRAND = Symbol("zod_brand");

var ZodBranded = /*#__PURE__*/function (_ZodType34) {
  _inherits2(ZodBranded, _ZodType34);

  var _super45 = _createSuper2(ZodBranded);

  function ZodBranded() {
    _classCallCheck2(this, ZodBranded);

    return _super45.apply(this, arguments);
  }

  _createClass2(ZodBranded, [{
    key: "_parse",
    value: function _parse(input) {
      var _this$_processInputPa16 = this._processInputParams(input),
          ctx = _this$_processInputPa16.ctx;

      var data = ctx.data;
      return this._def.type._parse({
        data: data,
        path: ctx.path,
        parent: ctx
      });
    }
  }, {
    key: "unwrap",
    value: function unwrap() {
      return this._def.type;
    }
  }]);

  return ZodBranded;
}(ZodType);

var ZodPipeline = /*#__PURE__*/function (_ZodType35) {
  _inherits2(ZodPipeline, _ZodType35);

  var _super46 = _createSuper2(ZodPipeline);

  function ZodPipeline() {
    _classCallCheck2(this, ZodPipeline);

    return _super46.apply(this, arguments);
  }

  _createClass2(ZodPipeline, [{
    key: "_parse",
    value: function _parse(input) {
      var _this30 = this;

      var _this$_processInputPa17 = this._processInputParams(input),
          status = _this$_processInputPa17.status,
          ctx = _this$_processInputPa17.ctx;

      if (ctx.common.async) {
        var handleAsync = /*#__PURE__*/function () {
          var _ref70 = _asyncToGenerator2( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
            var inResult;
            return _regeneratorRuntime.wrap(function _callee28$(_context29) {
              while (1) {
                switch (_context29.prev = _context29.next) {
                  case 0:
                    _context29.next = 2;
                    return _this30._def.in._parseAsync({
                      data: ctx.data,
                      path: ctx.path,
                      parent: ctx
                    });

                  case 2:
                    inResult = _context29.sent;

                    if (!(inResult.status === "aborted")) {
                      _context29.next = 5;
                      break;
                    }

                    return _context29.abrupt("return", INVALID);

                  case 5:
                    if (!(inResult.status === "dirty")) {
                      _context29.next = 10;
                      break;
                    }

                    status.dirty();
                    return _context29.abrupt("return", DIRTY(inResult.value));

                  case 10:
                    return _context29.abrupt("return", _this30._def.out._parseAsync({
                      data: inResult.value,
                      path: ctx.path,
                      parent: ctx
                    }));

                  case 11:
                  case "end":
                    return _context29.stop();
                }
              }
            }, _callee28);
          }));

          return function handleAsync() {
            return _ref70.apply(this, arguments);
          };
        }();

        return handleAsync();
      } else {
        var inResult = this._def.in._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });

        if (inResult.status === "aborted") return INVALID;

        if (inResult.status === "dirty") {
          status.dirty();
          return {
            status: "dirty",
            value: inResult.value
          };
        } else {
          return this._def.out._parseSync({
            data: inResult.value,
            path: ctx.path,
            parent: ctx
          });
        }
      }
    }
  }], [{
    key: "create",
    value: function create(a, b) {
      return new ZodPipeline({
        in: a,
        out: b,
        typeName: ZodFirstPartyTypeKind.ZodPipeline
      });
    }
  }]);

  return ZodPipeline;
}(ZodType);

var ZodReadonly = /*#__PURE__*/function (_ZodType36) {
  _inherits2(ZodReadonly, _ZodType36);

  var _super47 = _createSuper2(ZodReadonly);

  function ZodReadonly() {
    _classCallCheck2(this, ZodReadonly);

    return _super47.apply(this, arguments);
  }

  _createClass2(ZodReadonly, [{
    key: "_parse",
    value: function _parse(input) {
      var result = this._def.innerType._parse(input);

      var freeze = function freeze(data) {
        if (isValid(data)) {
          data.value = Object.freeze(data.value);
        }

        return data;
      };

      return isAsync(result) ? result.then(function (data) {
        return freeze(data);
      }) : freeze(result);
    }
  }, {
    key: "unwrap",
    value: function unwrap() {
      return this._def.innerType;
    }
  }]);

  return ZodReadonly;
}(ZodType);

ZodReadonly.create = function (type, params) {
  return new ZodReadonly(_objectSpread3({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodReadonly
  }, processCreateParams(params)));
}; ////////////////////////////////////////
////////////////////////////////////////
//////////                    //////////
//////////      z.custom      //////////
//////////                    //////////
////////////////////////////////////////
////////////////////////////////////////


function cleanParams(params, data) {
  var p = typeof params === "function" ? params(data) : typeof params === "string" ? {
    message: params
  } : params;
  var p2 = typeof p === "string" ? {
    message: p
  } : p;
  return p2;
}

function custom(check) {
  var _params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var
  /**
   * @deprecated
   *
   * Pass `fatal` into the params object instead:
   *
   * ```ts
   * z.string().custom((val) => val.length > 5, { fatal: false })
   * ```
   *
   */
  fatal = arguments.length > 2 ? arguments[2] : undefined;
  if (check) return ZodAny.create().superRefine(function (data, ctx) {
    var r = check(data);

    if (r instanceof Promise) {
      return r.then(function (r) {
        if (!r) {
          var _ref71, _params$fatal;

          var params = cleanParams(_params, data);

          var _fatal = (_ref71 = (_params$fatal = params.fatal) !== null && _params$fatal !== void 0 ? _params$fatal : fatal) !== null && _ref71 !== void 0 ? _ref71 : true;

          ctx.addIssue(_objectSpread3(_objectSpread3({
            code: "custom"
          }, params), {}, {
            fatal: _fatal
          }));
        }
      });
    }

    if (!r) {
      var _ref72, _params$fatal2;

      var params = cleanParams(_params, data);

      var _fatal = (_ref72 = (_params$fatal2 = params.fatal) !== null && _params$fatal2 !== void 0 ? _params$fatal2 : fatal) !== null && _ref72 !== void 0 ? _ref72 : true;

      ctx.addIssue(_objectSpread3(_objectSpread3({
        code: "custom"
      }, params), {}, {
        fatal: _fatal
      }));
    }

    return;
  });
  return ZodAny.create();
}

var late = {
  object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;

(function (ZodFirstPartyTypeKind) {
  ZodFirstPartyTypeKind["ZodString"] = "ZodString";
  ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
  ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
  ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
  ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
  ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
  ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
  ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
  ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
  ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
  ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
  ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
  ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
  ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
  ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
  ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
  ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
  ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
  ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
  ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
  ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
  ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
  ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
  ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
  ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
  ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
  ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
  ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
  ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
  ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
  ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
  ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
  ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
  ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
  ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
  ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));

var instanceOfType = function instanceOfType( // const instanceOfType = <T extends new (...args: any[]) => any>(
cls) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    message: "Input not instance of ".concat(cls.name)
  };
  return custom(function (data) {
    return data instanceof cls;
  }, params);
};

var stringType = ZodString.create;
var numberType = ZodNumber.create;
var nanType = ZodNaN.create;
var bigIntType = ZodBigInt.create;
var booleanType = ZodBoolean.create;
var dateType = ZodDate.create;
var symbolType = ZodSymbol.create;
var undefinedType = ZodUndefined.create;
var nullType = ZodNull.create;
var anyType = ZodAny.create;
var unknownType = ZodUnknown.create;
var neverType = ZodNever.create;
var voidType = ZodVoid.create;
var arrayType = ZodArray.create;
var objectType = ZodObject.create;
var strictObjectType = ZodObject.strictCreate;
var unionType = ZodUnion.create;
var discriminatedUnionType = ZodDiscriminatedUnion.create;
var intersectionType = ZodIntersection.create;
var tupleType = ZodTuple.create;
var recordType = ZodRecord.create;
var mapType = ZodMap.create;
var setType = ZodSet.create;
var functionType = ZodFunction.create;
var lazyType = ZodLazy.create;
var literalType = ZodLiteral.create;
var enumType = ZodEnum.create;
var nativeEnumType = ZodNativeEnum.create;
var promiseType = ZodPromise.create;
var effectsType = ZodEffects.create;
var optionalType = ZodOptional.create;
var nullableType = ZodNullable.create;
var preprocessType = ZodEffects.createWithPreprocess;
var pipelineType = ZodPipeline.create;

var ostring = function ostring() {
  return stringType().optional();
};

var onumber = function onumber() {
  return numberType().optional();
};

var oboolean = function oboolean() {
  return booleanType().optional();
};

var coerce = {
  string: function string(arg) {
    return ZodString.create(_objectSpread3(_objectSpread3({}, arg), {}, {
      coerce: true
    }));
  },
  number: function number(arg) {
    return ZodNumber.create(_objectSpread3(_objectSpread3({}, arg), {}, {
      coerce: true
    }));
  },
  boolean: function boolean(arg) {
    return ZodBoolean.create(_objectSpread3(_objectSpread3({}, arg), {}, {
      coerce: true
    }));
  },
  bigint: function bigint(arg) {
    return ZodBigInt.create(_objectSpread3(_objectSpread3({}, arg), {}, {
      coerce: true
    }));
  },
  date: function date(arg) {
    return ZodDate.create(_objectSpread3(_objectSpread3({}, arg), {}, {
      coerce: true
    }));
  }
};
var NEVER = INVALID;
var z = /*#__PURE__*/Object.freeze({
  __proto__: null,
  defaultErrorMap: defaultErrorMap,
  setErrorMap: setErrorMap,
  getErrorMap: getErrorMap,
  makeIssue: makeIssue,
  EMPTY_PATH: EMPTY_PATH,
  addIssueToContext: addIssueToContext,
  ParseStatus: ParseStatus,
  INVALID: INVALID,
  DIRTY: DIRTY,
  OK: OK,
  isAborted: isAborted,
  isDirty: isDirty,
  isValid: isValid,
  isAsync: isAsync,

  get util() {
    return util;
  },

  get objectUtil() {
    return objectUtil;
  },

  ZodParsedType: ZodParsedType,
  getParsedType: getParsedType,
  ZodType: ZodType,
  datetimeRegex: datetimeRegex,
  ZodString: ZodString,
  ZodNumber: ZodNumber,
  ZodBigInt: ZodBigInt,
  ZodBoolean: ZodBoolean,
  ZodDate: ZodDate,
  ZodSymbol: ZodSymbol,
  ZodUndefined: ZodUndefined,
  ZodNull: ZodNull,
  ZodAny: ZodAny,
  ZodUnknown: ZodUnknown,
  ZodNever: ZodNever,
  ZodVoid: ZodVoid,
  ZodArray: ZodArray,
  ZodObject: ZodObject,
  ZodUnion: ZodUnion,
  ZodDiscriminatedUnion: ZodDiscriminatedUnion,
  ZodIntersection: ZodIntersection,
  ZodTuple: ZodTuple,
  ZodRecord: ZodRecord,
  ZodMap: ZodMap,
  ZodSet: ZodSet,
  ZodFunction: ZodFunction,
  ZodLazy: ZodLazy,
  ZodLiteral: ZodLiteral,
  ZodEnum: ZodEnum,
  ZodNativeEnum: ZodNativeEnum,
  ZodPromise: ZodPromise,
  ZodEffects: ZodEffects,
  ZodTransformer: ZodEffects,
  ZodOptional: ZodOptional,
  ZodNullable: ZodNullable,
  ZodDefault: ZodDefault,
  ZodCatch: ZodCatch,
  ZodNaN: ZodNaN,
  BRAND: BRAND,
  ZodBranded: ZodBranded,
  ZodPipeline: ZodPipeline,
  ZodReadonly: ZodReadonly,
  custom: custom,
  Schema: ZodType,
  ZodSchema: ZodType,
  late: late,

  get ZodFirstPartyTypeKind() {
    return ZodFirstPartyTypeKind;
  },

  coerce: coerce,
  any: anyType,
  array: arrayType,
  bigint: bigIntType,
  boolean: booleanType,
  date: dateType,
  discriminatedUnion: discriminatedUnionType,
  effect: effectsType,
  'enum': enumType,
  'function': functionType,
  'instanceof': instanceOfType,
  intersection: intersectionType,
  lazy: lazyType,
  literal: literalType,
  map: mapType,
  nan: nanType,
  nativeEnum: nativeEnumType,
  never: neverType,
  'null': nullType,
  nullable: nullableType,
  number: numberType,
  object: objectType,
  oboolean: oboolean,
  onumber: onumber,
  optional: optionalType,
  ostring: ostring,
  pipeline: pipelineType,
  preprocess: preprocessType,
  promise: promiseType,
  record: recordType,
  set: setType,
  strictObject: strictObjectType,
  string: stringType,
  symbol: symbolType,
  transformer: effectsType,
  tuple: tupleType,
  'undefined': undefinedType,
  union: unionType,
  unknown: unknownType,
  'void': voidType,
  NEVER: NEVER,
  ZodIssueCode: ZodIssueCode,
  quotelessJson: quotelessJson,
  ZodError: ZodError
});
var dnsSchema = z.object({
  type: z.nativeEnum(DnsRecordTypes),
  host: z.string().min(1, 'Host is required'),
  value: z.string().min(1, 'Value is required'),
  ttl: z.coerce.number()["int"]().min(60, 'Minimum TTL is 60'),
  priority: z.number().nullable().optional(),
  flag: z.number().nullable().optional(),
  tag: z.string().nullable().optional(),
  service: z.string().nullable().optional(),
  protocol: z.string().nullable().optional(),
  port: z.number().nullable().optional(),
  weight: z.number().nullable().optional(),
  target: z.string().nullable().optional()
}).superRefine(function (data, ctx) {
  if (data.type === DnsRecordTypes.MX && data.priority === undefined) {
    ctx.addIssue({
      code: 'custom',
      message: 'Priority is required for MX records',
      path: ['priority']
    });
  }

  if (data.type === DnsRecordTypes.CAA) {
    if (data.flag === undefined) {
      ctx.addIssue({
        code: 'custom',
        message: 'Flag is required for CAA records',
        path: ['flag']
      });
    }

    if (!data.tag) {
      ctx.addIssue({
        code: 'custom',
        message: 'Tag is required for CAA records',
        path: ['tag']
      });
    }
  }

  if (data.type === DnsRecordTypes.SRV) {
    var requiredSrvFields = [{
      field: 'service',
      value: data.service
    }, {
      field: 'protocol',
      value: data.protocol
    }, {
      field: 'port',
      value: data.port
    }, {
      field: 'weight',
      value: data.weight
    }, {
      field: 'priority',
      value: data.priority
    }, {
      field: 'target',
      value: data.target
    }];
    requiredSrvFields.forEach(function (_ref) {
      var field = _ref.field,
          value = _ref.value;

      if (value === undefined || value === '') {
        ctx.addIssue({
          code: 'custom',
          message: "".concat(field, " is required for SRV records"),
          path: [field]
        });
      }
    });
  }
});

function _regenerator$1k() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1k(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1k(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1k(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1k(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1k(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1k(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1k(u), _regeneratorDefine2$1k(u, o, "Generator"), _regeneratorDefine2$1k(u, n, function () {
    return this;
  }), _regeneratorDefine2$1k(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1k = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1k(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1k = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1k(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1k(e, r, n, t);
}

function ownKeys$1E(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1E(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1E(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1E(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function AddEditForm(_ref) {
  var onDone = _ref.onDone,
      existingRecord = _ref.existingRecord;

  var _useDnsProvider = useDnsProvider(),
      domainName = _useDnsProvider.domainName,
      refreshRecords = _useDnsProvider.refreshRecords;

  var defaultValues = useMemo(function () {
    if (existingRecord) {
      return _objectSpread$1E(_objectSpread$1E({}, existingRecord), {}, {
        host: existingRecord.host.replace(domainName, '').replaceAll('.', '')
      });
    }

    return {
      ttl: 3600,
      type: DnsRecordTypes.A
    };
  }, [existingRecord, domainName]);
  var methods = useForm({
    resolver: zodResolver(dnsSchema),
    defaultValues: defaultValues
  });

  var _useMutation = useMutation$1({
    fn: existingRecord ? api.dns.updateRecord : api.dns.createRecord,
    successMessage: 'Record saved successfully',
    failureMessage: 'Failed to save record',
    onSuccess: function () {
      var _onSuccess = _asyncToGenerator( /*#__PURE__*/_regenerator$1k().m(function _callee() {
        return _regenerator$1k().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                methods.reset();
                _context.n = 1;
                return refreshRecords();

              case 1:
                onDone();

              case 2:
                return _context.a(2);
            }
          }
        }, _callee);
      }));

      function onSuccess() {
        return _onSuccess.apply(this, arguments);
      }

      return onSuccess;
    }()
  }),
      mutate = _useMutation.mutate,
      isLoading = _useMutation.isLoading;

  var type = useWatch({
    control: methods.control,
    name: 'type'
  });

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$1k().m(function _callee2(data) {
      var payload;
      return _regenerator$1k().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              payload = existingRecord ? _objectSpread$1E(_objectSpread$1E({}, existingRecord), data) : data;
              _context2.n = 1;
              return mutate(domainName, payload);

            case 1:
              return _context2.a(2);
          }
        }
      }, _callee2);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var typeOptions = useMemo(function () {
    return Object.values(DnsRecordTypes).map(function (value) {
      return {
        label: value,
        value: value
      };
    });
  }, []);
  return /*#__PURE__*/jsx$1(FormProvider, _objectSpread$1E(_objectSpread$1E({}, methods), {}, {
    children: /*#__PURE__*/jsx$1("form", {
      onSubmit: methods.handleSubmit(onSubmit),
      children: /*#__PURE__*/jsxs(Stack$1, {
        gap: 4,
        children: [existingRecord ? /*#__PURE__*/jsxs(Stack$1, {
          children: [/*#__PURE__*/jsx$1(Text, {
            variant: "paragraph-small",
            color: "neutral-500",
            children: "Record Type"
          }), /*#__PURE__*/jsx$1(Text, {
            fontWeight: "medium",
            pl: 3,
            py: "6px",
            children: existingRecord.type
          })]
        }) : /*#__PURE__*/jsxs(Stack$1, {
          children: [/*#__PURE__*/jsx$1(FormSelect, {
            name: "type",
            label: "Record Type",
            options: typeOptions
          }), EDUCATION_LINKS[type][RESELLER] && /*#__PURE__*/jsx$1(Button, {
            width: "fit-content",
            pt: 3,
            color: "neutral-500",
            fontWeight: "regular",
            style: {
              textDecoration: 'underline'
            },
            variant: "link",
            type: "button",
            onClick: function onClick() {
              return window.open(EDUCATION_LINKS[type][RESELLER], '_blank');
            },
            rel: "noreferrer",
            children: "Learn more about this kind of record"
          })]
        }), /*#__PURE__*/jsxs(Grid, {
          gap: 4,
          gridTemplateColumns: "repeat(2, 1fr)",
          children: [/*#__PURE__*/jsx$1(FormInput, {
            name: "host",
            label: type === DnsRecordTypes.CNAME ? 'Alias' : 'Host',
            placeholder: "www"
          }), /*#__PURE__*/jsxs(Text, {
            fontWeight: "medium",
            color: "primary-700",
            alignItems: "flex-end",
            display: "flex",
            children: [".", domainName]
          }), /*#__PURE__*/jsx$1(FormInput, {
            name: "value",
            label: "Points to",
            placeholder: "1.2.3.4"
          }), /*#__PURE__*/jsx$1(FormInput, {
            name: "ttl",
            type: "number",
            label: "TTL",
            placeholder: "3600"
          }), type === DnsRecordTypes.MX && /*#__PURE__*/jsx$1(FormInput, {
            name: "priority",
            type: "number",
            label: "Priority",
            placeholder: "10"
          }), type === DnsRecordTypes.CAA && /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx$1(FormInput, {
              name: "flag",
              type: "number",
              label: "Flag",
              placeholder: "0"
            }), /*#__PURE__*/jsx$1(FormInput, {
              name: "tag",
              label: "Tag",
              placeholder: "issue"
            })]
          }), type === DnsRecordTypes.SRV && /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx$1(FormInput, {
              name: "service",
              label: "Service",
              placeholder: "_http"
            }), /*#__PURE__*/jsx$1(FormInput, {
              name: "protocol",
              label: "Protocol",
              placeholder: "_tcp"
            }), /*#__PURE__*/jsx$1(FormInput, {
              name: "port",
              type: "number",
              label: "Port",
              placeholder: "80"
            }), /*#__PURE__*/jsx$1(FormInput, {
              name: "weight",
              type: "number",
              label: "Weight",
              placeholder: "10"
            }), /*#__PURE__*/jsx$1(FormInput, {
              name: "priority",
              type: "number",
              label: "Priority",
              placeholder: "10"
            }), /*#__PURE__*/jsx$1(FormInput, {
              name: "target",
              label: "Target",
              placeholder: "example.com"
            })]
          })]
        }), /*#__PURE__*/jsx$1(Button, {
          mt: "24px",
          type: "submit",
          variant: "secondary",
          width: "fit-content",
          loading: isLoading,
          children: existingRecord ? 'Update Record' : 'Add Record'
        })]
      })
    })
  }));
}

function AddDnsModal() {
  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(Button, {
      onClick: function onClick() {
        return setIsOpen(true);
      },
      variant: "minimal",
      color: "neutral-700",
      width: "fit-content",
      children: [/*#__PURE__*/jsx$1(RiAddCircleLine, {}), /*#__PURE__*/jsx$1(Text, {
        fontWeight: "regular",
        children: "Add Record"
      })]
    }), /*#__PURE__*/jsx$1(Modal, {
      title: "Add Record",
      isOpen: isOpen,
      onClose: function onClose() {
        return setIsOpen(false);
      },
      children: /*#__PURE__*/jsx$1(AddEditForm, {
        onDone: function onDone() {
          return setIsOpen(false);
        }
      })
    })]
  });
}

function ExportDnsButton(_ref) {
  var records = _ref.records;

  function exportToCsv() {
    var headers = ['Type', 'Host / Alias', 'Value', 'TTL', 'Last Updated', 'Priority', 'Service', 'Protocol', 'Port', 'Weight', 'Flag', 'Tag'];
    var rows = records.map(function (record) {
      return [record.type, record.host, record.value, record.ttl, record.lastUpdated, record.priority, record.service, record.protocol, record.port, record.weight, record.flag, record.tag];
    });
    var csvContent = [headers.join(',')].concat(_toConsumableArray$1(rows.map(function (row) {
      return row.join(',');
    }))).join('\n');
    var blob = new Blob([csvContent], {
      type: 'text/csv;charset=utf-8;'
    });
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.download = 'dns-records.csv';
    link.click();
    URL.revokeObjectURL(url);
  }

  return /*#__PURE__*/jsxs(Button, {
    variant: "minimal",
    color: "neutral-700",
    onClick: exportToCsv,
    children: [/*#__PURE__*/jsx$1(RiUploadLine, {}), /*#__PURE__*/jsx$1(Text, {
      fontWeight: "regular",
      children: "Export CSV"
    })]
  });
}

function _regenerator$1j() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1j(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1j(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1j(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1j(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1j(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1j(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1j(u), _regeneratorDefine2$1j(u, o, "Generator"), _regeneratorDefine2$1j(u, n, function () {
    return this;
  }), _regeneratorDefine2$1j(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1j = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1j(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1j = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1j(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1j(e, r, n, t);
}

function RestoreDefaultsButton() {
  var _useDnsProvider = useDnsProvider(),
      domainName = _useDnsProvider.domainName,
      refreshRecords = _useDnsProvider.refreshRecords;

  var _useMutation = useMutation$1({
    fn: function fn() {
      return api.dns.resetToDefaultRecords(domainName);
    },
    successMessage: 'Record defaults restored successfully',
    failureMessage: 'Failed to restore record defaults',
    onSuccess: function () {
      var _onSuccess = _asyncToGenerator( /*#__PURE__*/_regenerator$1j().m(function _callee() {
        return _regenerator$1j().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.n = 1;
                return refreshRecords();

              case 1:
                return _context.a(2);
            }
          }
        }, _callee);
      }));

      function onSuccess() {
        return _onSuccess.apply(this, arguments);
      }

      return onSuccess;
    }()
  }),
      mutate = _useMutation.mutate,
      isLoading = _useMutation.isLoading;

  return /*#__PURE__*/jsxs(Button, {
    variant: "minimal",
    color: "neutral-700",
    fontWeight: "regular",
    loading: isLoading,
    onClick: mutate,
    children: [/*#__PURE__*/jsx$1(RiArrowGoBackFill, {}), /*#__PURE__*/jsx$1(Text, {
      children: "Restore Defaults"
    })]
  });
}

function DnsActionsBar() {
  var _useDnsProvider = useDnsProvider(),
      records = _useDnsProvider.records;

  if (!records) return null;
  return /*#__PURE__*/jsxs(Box, {
    ml: "auto",
    gap: 3,
    children: [/*#__PURE__*/jsx$1(AddDnsModal, {}), /*#__PURE__*/jsx$1(RestoreDefaultsButton, {}), /*#__PURE__*/jsx$1(ExportDnsButton, {
      records: records
    })]
  });
}

function EditDnsModal(_ref) {
  var existingRecord = _ref.existingRecord;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(Button, {
      onClick: function onClick() {
        return setIsOpen(true);
      },
      variant: "minimal",
      color: "primary-700",
      width: "fit-content",
      my: "12px",
      children: [/*#__PURE__*/jsx$1(RiEditLine, {}), /*#__PURE__*/jsx$1(Text, {
        fontWeight: "medium",
        children: "Edit"
      })]
    }), /*#__PURE__*/jsx$1(Modal, {
      title: "Edit Record",
      isOpen: isOpen,
      onClose: function onClose() {
        return setIsOpen(false);
      },
      children: /*#__PURE__*/jsx$1(AddEditForm, {
        existingRecord: existingRecord,
        onDone: function onDone() {
          return setIsOpen(false);
        }
      })
    })]
  });
}

function _regenerator$1i() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1i(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1i(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1i(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1i(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1i(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1i(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1i(u), _regeneratorDefine2$1i(u, o, "Generator"), _regeneratorDefine2$1i(u, n, function () {
    return this;
  }), _regeneratorDefine2$1i(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1i = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1i(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1i = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1i(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1i(e, r, n, t);
}

function DeleteModal(_ref) {
  var record = _ref.record;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useDnsProvider = useDnsProvider(),
      domainName = _useDnsProvider.domainName,
      refreshRecords = _useDnsProvider.refreshRecords;

  var _useMutation = useMutation$1({
    fn: function fn() {
      return api.dns.deleteRecord(domainName, record.id);
    },
    successMessage: 'Record deleted successfully',
    failureMessage: 'Failed to delete record',
    onSuccess: function () {
      var _onSuccess = _asyncToGenerator( /*#__PURE__*/_regenerator$1i().m(function _callee() {
        return _regenerator$1i().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.n = 1;
                return refreshRecords();

              case 1:
                setIsOpen(false);

              case 2:
                return _context.a(2);
            }
          }
        }, _callee);
      }));

      function onSuccess() {
        return _onSuccess.apply(this, arguments);
      }

      return onSuccess;
    }()
  }),
      mutate = _useMutation.mutate,
      isLoading = _useMutation.isLoading;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(Button, {
      onClick: function onClick() {
        return setIsOpen(true);
      },
      variant: "minimal",
      children: [/*#__PURE__*/jsx$1(RiDeleteBinLine, {}), /*#__PURE__*/jsx$1(Text, {
        fontWeight: "medium",
        children: "Delete"
      })]
    }), isOpen && /*#__PURE__*/jsx$1(Modal, {
      title: "Delete Record",
      isOpen: isOpen,
      onClose: function onClose() {
        return setIsOpen(false);
      },
      children: /*#__PURE__*/jsxs(Stack$1, {
        gap: "56px",
        children: [/*#__PURE__*/jsxs(Stack$1, {
          mt: "32px",
          children: [/*#__PURE__*/jsx$1(Text, {
            variant: "paragraph-large",
            children: "Are you sure you want to delete this record?"
          }), /*#__PURE__*/jsx$1(Text, {
            variant: "paragraph-large",
            children: "Deleting a record is a permanent action."
          })]
        }), /*#__PURE__*/jsx$1(Button, {
          width: "fit-content",
          variant: "secondary",
          loading: isLoading,
          onClick: mutate,
          children: "Delete Record"
        })]
      })
    })]
  });
}

function DnsGridViewCard(_ref) {
  var record = _ref.record;
  var type = record.type,
      host = record.host,
      value = record.value,
      ttl = record.ttl,
      lastUpdated = record.lastUpdated;
  return /*#__PURE__*/jsxs(Stack$1, {
    padding: "32px 24px 16px 24px",
    gap: 4,
    border: "1px solid",
    borderColor: "neutral-200",
    borderRadius: "base",
    backgroundColor: "card",
    children: [/*#__PURE__*/jsxs(Stack$1, {
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        color: "neutral-500",
        children: "Type"
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        color: "neutral-700",
        fontWeight: "bold",
        children: type
      })]
    }), /*#__PURE__*/jsxs(Stack$1, {
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        color: "neutral-500",
        children: "Host/Alias"
      }), /*#__PURE__*/jsx$1(Text, {
        color: "neutral-700",
        fontWeight: "semi",
        children: host
      })]
    }), /*#__PURE__*/jsxs(Stack$1, {
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        color: "neutral-500",
        children: "Value"
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        color: "neutral-700",
        fontWeight: "bold",
        children: value
      })]
    }), /*#__PURE__*/jsxs(Stack$1, {
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        color: "neutral-500",
        children: "TTL"
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        color: "neutral-700",
        fontWeight: "bold",
        children: ttl
      })]
    }), /*#__PURE__*/jsxs(Stack$1, {
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        color: "neutral-500",
        children: "Last Update"
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        color: "neutral-700",
        fontWeight: "bold",
        children: lastUpdated
      })]
    }), /*#__PURE__*/jsxs(Box, {
      width: "100%",
      justifyContent: "space-between",
      py: "24px",
      borderTop: "1px solid",
      borderColor: "neutral-200",
      children: [/*#__PURE__*/jsx$1(EditDnsModal, {
        existingRecord: record
      }), /*#__PURE__*/jsx$1(DeleteModal, {
        record: record
      })]
    })]
  });
}

function DnsGridView() {
  var _useDnsProvider = useDnsProvider(),
      records = _useDnsProvider.records;

  return /*#__PURE__*/jsx$1(Grid, {
    gridTemplateColumns: ['1fr', 'repeat(2, 1fr)', 'repeat(4, 1fr)'],
    gap: 3,
    children: records ? records.map(function (record) {
      return /*#__PURE__*/jsx$1(DnsGridViewCard, {
        record: record
      }, record.id);
    }) : Array.from({
      length: 4
    }).map(function (_, i) {
      return /*#__PURE__*/jsx$1(Skeleton, {
        borderRadius: "base",
        height: "400px"
      }, i);
    })
  });
}

function useSortState(items) {
  var _useState = useState({
    sortKey: null,
    sortDirection: null
  }),
      _useState2 = _slicedToArray$4(_useState, 2),
      sortState = _useState2[0],
      setSortState = _useState2[1];

  var handleToggleSort = function handleToggleSort(field) {
    setSortState(function (prev) {
      if (prev.sortKey !== field) return {
        sortKey: field,
        sortDirection: 'asc'
      };
      if (prev.sortDirection === 'asc') return {
        sortKey: field,
        sortDirection: 'desc'
      };
      return {
        sortKey: null,
        sortDirection: null
      };
    });
  };

  var sortedItems = useMemo(function () {
    var sortKey = sortState.sortKey,
        sortDirection = sortState.sortDirection;
    if (!items || !sortKey || !sortDirection) return items;
    return _toConsumableArray$1(items).sort(function (a, b) {
      var aValue = a[sortKey];
      var bValue = b[sortKey];
      if (aValue == null) return 1;
      if (bValue == null) return -1;
      var result = String(aValue).localeCompare(String(bValue));
      return sortDirection === 'asc' ? result : -result;
    });
  }, [items, sortState]);
  return {
    sortState: sortState,
    setSortState: setSortState,
    handleToggleSort: handleToggleSort,
    sortedItems: sortedItems
  };
}

function SortableHeader(_ref) {
  var field = _ref.field,
      label = _ref.label,
      sortState = _ref.sortState,
      onToggleSort = _ref.onToggleSort;
  var isActive = sortState.sortKey === field;
  var icon = '⇅';

  if (isActive) {
    icon = sortState.sortDirection === 'asc' ? '↑' : '↓';
  }

  return /*#__PURE__*/jsx$1(Button, {
    onClick: function onClick() {
      return onToggleSort(field);
    },
    variant: "link",
    p: 0,
    color: "neutral-700",
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    gap: 1,
    transition: "0.2s",
    children: /*#__PURE__*/jsxs(Text, {
      fontWeight: "medium",
      children: [label, " ", icon]
    })
  });
}

function TableRow$3(_ref) {
  var record = _ref.record;
  var type = record.type,
      host = record.host,
      value = record.value,
      ttl = record.ttl,
      lastUpdated = record.lastUpdated;
  return /*#__PURE__*/jsxs(Grid, {
    gridTemplateColumns: "1fr 2fr 1fr 1fr 1fr 2fr",
    alignItems: "center",
    p: "24px 16px",
    borderBottom: "1px solid",
    borderColor: "neutral-200",
    gap: 4,
    fontWeight: "medium",
    children: [/*#__PURE__*/jsx$1(Text, {
      color: "neutral-700",
      children: type
    }), /*#__PURE__*/jsx$1(Text, {
      color: "neutral-700",
      children: host
    }), /*#__PURE__*/jsx$1(Text, {
      color: "neutral-700",
      children: value
    }), /*#__PURE__*/jsx$1(Text, {
      color: "neutral-700",
      children: ttl
    }), /*#__PURE__*/jsx$1(Text, {
      color: "neutral-700",
      children: lastUpdated
    }), /*#__PURE__*/jsxs(Box, {
      justifyContent: "center",
      gap: 4,
      children: [/*#__PURE__*/jsx$1(EditDnsModal, {
        existingRecord: record
      }), /*#__PURE__*/jsx$1(DeleteModal, {
        record: record
      })]
    })]
  }, record.id);
}

function DnsTableView() {
  var _useDnsProvider = useDnsProvider(),
      records = _useDnsProvider.records;

  var _useSortState = useSortState(records),
      sortState = _useSortState.sortState,
      handleToggleSort = _useSortState.handleToggleSort,
      sortedItems = _useSortState.sortedItems;

  return /*#__PURE__*/jsxs(Stack$1, {
    children: [/*#__PURE__*/jsxs(Grid, {
      gridTemplateColumns: "1fr 2fr 1fr 1fr 1fr 2fr",
      alignItems: "center",
      backgroundColor: "neutral-100",
      p: "24px 16px",
      gap: 4,
      borderBottom: "1px solid",
      borderColor: "neutral-200",
      children: [/*#__PURE__*/jsx$1(SortableHeader, {
        field: "type",
        label: "Type",
        sortState: sortState,
        onToggleSort: handleToggleSort
      }), /*#__PURE__*/jsx$1(SortableHeader, {
        field: "host",
        label: "Host / Alias",
        sortState: sortState,
        onToggleSort: handleToggleSort
      }), /*#__PURE__*/jsx$1(SortableHeader, {
        field: "value",
        label: "Value",
        sortState: sortState,
        onToggleSort: handleToggleSort
      }), /*#__PURE__*/jsx$1(SortableHeader, {
        field: "ttl",
        label: "TTL",
        sortState: sortState,
        onToggleSort: handleToggleSort
      }), /*#__PURE__*/jsx$1(SortableHeader, {
        field: "lastUpdated",
        label: "Last Update",
        sortState: sortState,
        onToggleSort: handleToggleSort
      })]
    }), sortedItems ? sortedItems.map(function (record) {
      return /*#__PURE__*/jsx$1(TableRow$3, {
        record: record
      }, record.id);
    }) : Array.from({
      length: 4
    }).map(function (_, index) {
      return /*#__PURE__*/jsx$1(Skeleton, {
        height: "64px",
        borderRadius: "base"
      }, index);
    })]
  });
}

function AdvancedDns() {
  var _useDnsProvider = useDnsProvider(),
      records = _useDnsProvider.records,
      domainName = _useDnsProvider.domainName;

  var _useQueryDomain = useQueryDomain(),
      domain = _useQueryDomain.domain;

  useEffect(function () {
    // Third party hosting manage their advanced DNS elsewhere.
    // The link to this page shouldn't show, but this guards against manual navigation
    if ((domain === null || domain === void 0 ? void 0 : domain.DnsType) === DnsTypes.ThirdPartyHosting) {
      navigate("".concat(BASEPATH, "/managers/domains/").concat(domain.DomainName, "/dns"));
    }
  }, [domain]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Header$1, {
      children: /*#__PURE__*/jsx$1(BackButton$1, {
        to: "".concat(BASEPATH, "/managers/domains/").concat(domainName, "/dns"),
        text: "Back to DNS Manager"
      })
    }), /*#__PURE__*/jsxs(Stack$1, {
      gap: 4,
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "heading-h6",
        fontWeight: "bold",
        children: "Advanced DNS Manager"
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "heading-h4",
        fontWeight: "semi",
        children: domainName
      })]
    }), /*#__PURE__*/jsx$1(ViewManager, {
      items: records,
      tableView: /*#__PURE__*/jsx$1(DnsTableView, {}),
      gridView: /*#__PURE__*/jsx$1(DnsGridView, {}),
      headerBar: /*#__PURE__*/jsx$1(DnsActionsBar, {})
    })]
  });
}

function AdvancedDnsManager() {
  return /*#__PURE__*/jsx$1(DnsProvider, {
    children: /*#__PURE__*/jsx$1(AdvancedDns, {})
  });
}

var _NAMESERVER_MESSAGING;

var NAMESERVER_MESSAGING = (_NAMESERVER_MESSAGING = {}, _defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_NAMESERVER_MESSAGING, DnsTypes.Parked, "Your domain is parked with ".concat(capitalize(RESELLER))), DnsTypes.ParkedDefault, "Your domain is parked with ".concat(capitalize(RESELLER), " with defaults")), DnsTypes.ThirdPartyHosting, "Your domain is hosted with a third-party provider"), DnsTypes.Forwarding, "Your domain is currently set to Forwarding"), DnsTypes.Hosted, 'Your domain is currently hosted'), DnsTypes.Expired, 'Your domain is expired'), DnsTypes.Deleted, 'Your domain is deleted'), DnsTypes.Weebly, 'Your domain is currently hosted with Weebly'), DnsTypes.WeeblyAndEmail, 'Your domain is currently hosted with Weebly'), DnsTypes.CloudEmail, 'Your domain is currently hosted with CloudEmail'), _defineProperty$6(_defineProperty$6(_NAMESERVER_MESSAGING, DnsTypes.CloudEmailAndWeebly, 'Your domain is currently hosted with CloudEmail'), DnsTypes.Plesk, 'Your domain is currently hosted with Plesk'));

function ownKeys$1D(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1D(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1D(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1D(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _regenerator$1h() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1h(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1h(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1h(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1h(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1h(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1h(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1h(u), _regeneratorDefine2$1h(u, o, "Generator"), _regeneratorDefine2$1h(u, n, function () {
    return this;
  }), _regeneratorDefine2$1h(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1h = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1h(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1h = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1h(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1h(e, r, n, t);
}

var schema$4 = objectType({
  dnsType: nativeEnumType(DnsTypes),
  forwardingUrl: stringType().url().optional().or(literalType('')),
  enableHttpsForwarding: booleanType()["default"](false).optional(),
  nameServers: arrayType(objectType({
    value: stringType()
  }))["default"]([])
}).superRefine(function (data, ctx) {
  var _data$forwardingUrl;

  if (data.dnsType === DnsTypes.Forwarding && !((_data$forwardingUrl = data.forwardingUrl) !== null && _data$forwardingUrl !== void 0 && _data$forwardingUrl.trim())) {
    ctx.addIssue({
      path: ['forwardingUrl'],
      code: ZodIssueCode.custom,
      message: 'Forwarding URL is required when forwarding is selected'
    });
  }

  if (data.dnsType === DnsTypes.ThirdPartyHosting) {
    if (data.nameServers.length < 2) {
      ctx.addIssue({
        path: ['nameServers'],
        code: ZodIssueCode.custom,
        message: 'At least two nameservers are required'
      });
    }
  }
});

function DomainNameservers(_ref) {
  var _domain$Nameservers, _domain$ForwardingUrl, _domain$IsHttpsForwar;

  var domain = _ref.domain;

  var _useDomains = useDomains(),
      refreshDomains = _useDomains.refreshDomains;

  var _useMutation = useMutation$1({
    fn: api.dns.updateNameservers,
    successMessage: 'Successfully updated nameservers.',
    failureMessage: 'Failed to update nameservers.',
    onSuccess: function () {
      var _onSuccess = _asyncToGenerator( /*#__PURE__*/_regenerator$1h().m(function _callee() {
        return _regenerator$1h().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.n = 1;
                return refreshDomains();

              case 1:
                return _context.a(2);
            }
          }
        }, _callee);
      }));

      function onSuccess() {
        return _onSuccess.apply(this, arguments);
      }

      return onSuccess;
    }()
  }),
      mutate = _useMutation.mutate,
      isLoading = _useMutation.isLoading;

  var initialNameServers = ((_domain$Nameservers = domain.Nameservers) !== null && _domain$Nameservers !== void 0 ? _domain$Nameservers : []).sort(function (a, b) {
    return a.Position - b.Position;
  }).map(function (ns) {
    return {
      value: ns.DNS
    };
  });

  while (initialNameServers.length < 2) {
    initialNameServers.push({
      value: ''
    });
  }

  var methods = useForm({
    resolver: zodResolver(schema$4),
    defaultValues: {
      dnsType: domain.DnsType,
      forwardingUrl: (_domain$ForwardingUrl = domain.ForwardingUrl) !== null && _domain$ForwardingUrl !== void 0 ? _domain$ForwardingUrl : '',
      enableHttpsForwarding: (_domain$IsHttpsForwar = domain.IsHttpsForwarding) !== null && _domain$IsHttpsForwar !== void 0 ? _domain$IsHttpsForwar : false,
      nameServers: initialNameServers
    }
  });
  var handleSubmit = methods.handleSubmit,
      control = methods.control,
      clearErrors = methods.clearErrors;
  var dnsType = useWatch({
    control: control,
    name: 'dnsType'
  });

  var _useFieldArray = useFieldArray({
    control: control,
    name: 'nameServers'
  }),
      fields = _useFieldArray.fields,
      append = _useFieldArray.append,
      remove = _useFieldArray.remove;

  useEffect(function () {
    clearErrors();
  }, [dnsType, clearErrors]);

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$1h().m(function _callee2(data) {
      return _regenerator$1h().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              if (!(domain.DnsType === data.dnsType)) {
                _context2.n = 1;
                break;
              }

              return _context2.a(2);

            case 1:
              _context2.n = 2;
              return mutate(domain.DomainID, {
                DnsType: data.dnsType,
                NameServers: data.nameServers.map(function (ns) {
                  return ns.value;
                }),
                ForwardingUrl: data.forwardingUrl,
                EnableHttpsForwarding: data.enableHttpsForwarding
              });

            case 2:
              return _context2.a(2);
          }
        }
      }, _callee2);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/jsx$1(FormProvider, _objectSpread$1D(_objectSpread$1D({}, methods), {}, {
    children: /*#__PURE__*/jsx$1("form", {
      onSubmit: handleSubmit(onSubmit),
      children: /*#__PURE__*/jsxs(Stack$1, {
        gap: "40px",
        children: [/*#__PURE__*/jsx$1(Text, {
          variant: "heading-h6",
          fontWeight: "semi",
          children: "Domain Nameserver Information"
        }), /*#__PURE__*/jsxs(Box, {
          justifyContent: "space-between",
          children: [/*#__PURE__*/jsxs(Stack$1, {
            gap: 3,
            children: [/*#__PURE__*/jsx$1(Text, {
              children: "What action do you want to take?"
            }), /*#__PURE__*/jsx$1(FormSelect, {
              name: "dnsType",
              options: [{
                label: "Park with ".concat(capitalize$1(RESELLER), " (default)"),
                value: DnsTypes.ParkedDefault
              }, {
                label: "Park with ".concat(capitalize$1(RESELLER)),
                value: DnsTypes.Parked
              }, {
                label: 'Forward domain',
                value: DnsTypes.Forwarding
              }, {
                label: 'Use third-party hosting',
                value: DnsTypes.ThirdPartyHosting
              }]
            }), dnsType === DnsTypes.Forwarding && /*#__PURE__*/jsxs(Fragment, {
              children: [/*#__PURE__*/jsx$1(FormInput, {
                name: "forwardingUrl",
                label: "Forwarding URL",
                placeholder: "https://example.com"
              }), /*#__PURE__*/jsx$1(FormCheckbox, {
                name: "enableHttpsForwarding",
                label: "Enable HTTPS Forwarding"
              })]
            }), dnsType === DnsTypes.ThirdPartyHosting && /*#__PURE__*/jsxs(Fragment, {
              children: [/*#__PURE__*/jsx$1(Text, {
                fontWeight: "medium",
                variant: "paragraph-small",
                children: "Enter at least two nameservers:"
              }), /*#__PURE__*/jsxs(Stack$1, {
                gap: 2,
                children: [fields.map(function (field, index) {
                  return /*#__PURE__*/jsxs(Box, {
                    alignItems: "center",
                    gap: 2,
                    children: [/*#__PURE__*/jsx$1(FormInput, {
                      name: "nameServers.".concat(index, ".value"),
                      placeholder: "Nameserver ".concat(index + 1)
                    }), fields.length > 2 && /*#__PURE__*/jsx$1(Button, {
                      variant: "link",
                      type: "button",
                      onClick: function onClick() {
                        return remove(index);
                      },
                      children: "Remove"
                    })]
                  }, field.id);
                }), /*#__PURE__*/jsx$1(Button, {
                  variant: "link",
                  type: "button",
                  onClick: function onClick() {
                    return append({
                      value: ''
                    });
                  },
                  children: "+ Add Nameserver"
                })]
              })]
            })]
          }), /*#__PURE__*/jsx$1(Button, {
            variant: "secondary",
            type: "submit",
            height: "fit-content",
            loading: isLoading,
            children: "Save Changes"
          })]
        }), /*#__PURE__*/jsxs(Stack$1, {
          gap: "32px",
          children: [/*#__PURE__*/jsx$1(Text, {
            variant: "paragraph-large",
            children: NAMESERVER_MESSAGING[dnsType]
          }), domain.DnsType !== dnsType && /*#__PURE__*/jsxs(Text, {
            children: [/*#__PURE__*/jsx$1(Text, {
              fontWeight: "semi",
              children: "Please note: "
            }), /*#__PURE__*/jsxs(Text, {
              children: ["Your have selected to change your Nameserver type to ", dnsType, ". Your Advanced DNS entries will be updated to reflect this change. Any custom entries you may have previously entered in Advanced DNS will remain intact."]
            })]
          })]
        })]
      })
    })
  }));
}

function ownKeys$1C(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1C(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1C(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1C(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _regenerator$1g() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1g(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1g(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1g(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1g(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1g(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1g(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1g(u), _regeneratorDefine2$1g(u, o, "Generator"), _regeneratorDefine2$1g(u, n, function () {
    return this;
  }), _regeneratorDefine2$1g(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1g = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1g(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1g = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1g(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1g(e, r, n, t);
}

function extractPrefix(fqdn) {
  return fqdn.split('.')[0];
}

var ipv4Regex = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;
var ipv6Regex = /^(([0-9a-fA-F]{1,4}):){7}([0-9a-fA-F]{1,4})$|^(([0-9a-fA-F]{1,4}):){1,7}:$|^(([0-9a-fA-F]{1,4}):){1,6}:[0-9a-fA-F]{1,4}$|^(([0-9a-fA-F]{1,4}):){1,5}(:[0-9a-fA-F]{1,4}){1,2}$|^(([0-9a-fA-F]{1,4}):){1,4}(:[0-9a-fA-F]{1,4}){1,3}$|^(([0-9a-fA-F]{1,4}):){1,3}(:[0-9a-fA-F]{1,4}){1,4}$|^(([0-9a-fA-F]{1,4}):){1,2}(:[0-9a-fA-F]{1,4}){1,5}$|^([0-9a-fA-F]{1,4}):((:[0-9a-fA-F]{1,4}){1,6})$|^:((:[0-9a-fA-F]{1,4}){1,7}|:)$|^fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}$|^::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}\d){0,1}\d)\.){3,3}(25[0-5]|(2[0-4]|1{0,1}\d){0,1}\d)$|^([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}\d){0,1}\d)\.){3,3}(25[0-5]|(2[0-4]|1{0,1}\d){0,1}\d)$/;
var recordSchema = objectType({
  id: numberType()["int"]().min(-1),
  prefix: stringType().min(1, 'Prefix is required'),
  IPv4: stringType().optional().refine(function (ip) {
    return !ip || ipv4Regex.test(ip);
  }, {
    message: 'Invalid IPv4 address format'
  }),
  IPv6: stringType().optional().refine(function (ip) {
    return !ip || ipv6Regex.test(ip);
  }, {
    message: 'Invalid IPv6 address format'
  })
}).refine(function (data) {
  var _data$IPv, _data$IPv2;

  return ((_data$IPv = data.IPv4) === null || _data$IPv === void 0 ? void 0 : _data$IPv.trim()) || ((_data$IPv2 = data.IPv6) === null || _data$IPv2 === void 0 ? void 0 : _data$IPv2.trim());
}, {
  message: 'At least one IP address (IPv4 or IPv6) is required'
});
var schema$3 = objectType({
  records: arrayType(recordSchema)
});

function RegistryNameserverRecords(_ref) {
  var domain = _ref.domain;

  var _useDomains = useDomains(),
      refreshDomains = _useDomains.refreshDomains;

  var _useMutation = useMutation$1({
    fn: api.dns.updateRegistryNameservers,
    successMessage: 'Registry nameservers updated.',
    failureMessage: 'Failed to update registry nameservers.',
    onSuccess: function () {
      var _onSuccess = _asyncToGenerator( /*#__PURE__*/_regenerator$1g().m(function _callee() {
        return _regenerator$1g().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.n = 1;
                return refreshDomains();

              case 1:
                return _context.a(2);
            }
          }
        }, _callee);
      }));

      function onSuccess() {
        return _onSuccess.apply(this, arguments);
      }

      return onSuccess;
    }()
  }),
      mutate = _useMutation.mutate,
      isLoading = _useMutation.isLoading;

  var initialRecords = domain.RegistryNameservers.map(function (r) {
    return {
      id: r.ID,
      prefix: extractPrefix(r.DNS),
      IPv4: r.IPv4 || '',
      IPv6: r.IPv6 || ''
    };
  });
  var methods = useForm({
    resolver: zodResolver(schema$3),
    defaultValues: {
      records: initialRecords.length > 0 ? initialRecords : []
    }
  });
  var handleSubmit = methods.handleSubmit,
      control = methods.control;

  var _useFieldArray = useFieldArray({
    control: control,
    name: 'records'
  }),
      fields = _useFieldArray.fields,
      append = _useFieldArray.append,
      remove = _useFieldArray.remove;

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$1g().m(function _callee2(data) {
      var payload;
      return _regenerator$1g().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              payload = data.records.map(function (r) {
                return {
                  ID: r.id,
                  DNS: "".concat(r.prefix, ".").concat(domain.DomainName),
                  IPv4: r.IPv4 || '',
                  IPv6: r.IPv6 || ''
                };
              });
              _context2.n = 1;
              return mutate(domain.DomainID, payload);

            case 1:
              return _context2.a(2);
          }
        }
      }, _callee2);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/jsx$1(FormProvider, _objectSpread$1C(_objectSpread$1C({}, methods), {}, {
    children: /*#__PURE__*/jsx$1("form", {
      onSubmit: handleSubmit(onSubmit),
      children: /*#__PURE__*/jsxs(Stack$1, {
        gap: "32px",
        width: "100%",
        children: [/*#__PURE__*/jsx$1(Text, {
          variant: "heading-h6",
          fontWeight: "semi",
          children: "Registry Nameserver Records"
        }), /*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-large",
          children: "Point the nameservers for this domain to a specific IP address."
        }), fields.map(function (field, index) {
          return /*#__PURE__*/jsxs(Stack$1, {
            children: [/*#__PURE__*/jsxs(Box, {
              alignItems: "center",
              gap: 4,
              flexWrap: "wrap",
              children: [/*#__PURE__*/jsxs(Box, {
                gap: 4,
                children: [/*#__PURE__*/jsx$1(FormInput, {
                  name: "records.".concat(index, ".prefix"),
                  placeholder: "Prefix (e.g. ns1)",
                  label: "Prefix",
                  stackProps: {
                    width: '100px'
                  }
                }), /*#__PURE__*/jsxs(Stack$1, {
                  justifyContent: "space-between",
                  children: [/*#__PURE__*/jsx$1(Text, {
                    variant: "paragraph-xsmall",
                    color: "neutral-500",
                    children: "DNS Suffix"
                  }), /*#__PURE__*/jsx$1(Text, {
                    pb: "4px",
                    fontWeight: "medium",
                    borderBottom: "1px solid",
                    borderColor: "neutral-200",
                    children: domain.DomainName
                  })]
                })]
              }), /*#__PURE__*/jsx$1(FormInput, {
                name: "records.".concat(index, ".IPv4"),
                placeholder: "IPv4 address",
                label: "IPv4"
              }), /*#__PURE__*/jsx$1(FormInput, {
                name: "records.".concat(index, ".IPv6"),
                placeholder: "IPv6 address",
                label: "IPv6",
                stackProps: {
                  width: '350px'
                }
              }), /*#__PURE__*/jsxs(Button, {
                type: "button",
                variant: "minimal",
                onClick: function onClick() {
                  return remove(index);
                },
                color: "primary-700",
                children: [/*#__PURE__*/jsx$1(RiDeleteBinLine, {}), /*#__PURE__*/jsx$1(Text, {
                  variant: "paragraph-small",
                  fontWeight: "medium",
                  children: "Delete"
                })]
              })]
            }), /*#__PURE__*/jsx$1(FormRootError, {
              name: "records.".concat(index)
            })]
          }, field.id);
        }), /*#__PURE__*/jsxs(Box, {
          width: "100%",
          justifyContent: "space-between",
          children: [/*#__PURE__*/jsxs(Button, {
            type: "button",
            variant: "minimal",
            onClick: function onClick() {
              return append({
                id: 0,
                prefix: '',
                IPv4: '',
                IPv6: ''
              });
            },
            color: "primary-700",
            children: [/*#__PURE__*/jsx$1(RiAddCircleFill, {}), /*#__PURE__*/jsx$1(Text, {
              variant: "paragraph-large",
              fontWeight: "medium",
              children: "Add Nameserver"
            })]
          }), /*#__PURE__*/jsx$1(Button, {
            type: "submit",
            variant: "secondary",
            loading: isLoading,
            children: "Save Changes"
          })]
        })]
      })
    })
  }));
}

function DnsManager() {
  var _useQueryDomain = useQueryDomain(),
      domain = _useQueryDomain.domain;

  if (!domain) {
    return /*#__PURE__*/jsx$1(Skeleton, {
      borderRadius: "base",
      height: "400px"
    });
  }

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Header$1, {
      children: /*#__PURE__*/jsx$1(BackButton$1, {
        text: "Back to Domain Manager",
        to: "".concat(BASEPATH, "/managers/domains")
      })
    }), /*#__PURE__*/jsx$1(Text, {
      variant: "heading-h4",
      fontWeight: "semi",
      mb: "48px",
      children: domain.DomainName
    }), /*#__PURE__*/jsx$1(Tabs, {
      tabs: TABS.domainOptions(domain.DomainName)
    }), /*#__PURE__*/jsxs(Stack$1, {
      mb: "48px",
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "heading-h5",
        fontWeight: "bold",
        color: "primary-600",
        children: "DNS (Domain NameServer)"
      }), /*#__PURE__*/jsx$1(Text, {
        color: "neutral-700",
        children: "Here, you'll find the DNS records for your domain"
      })]
    }), /*#__PURE__*/jsxs(Stack$1, {
      gap: "96px",
      children: [/*#__PURE__*/jsx$1(DomainNameservers, {
        domain: domain
      }), domain.DnsType !== DnsTypes.ThirdPartyHosting && /*#__PURE__*/jsxs(Stack$1, {
        gap: "32px",
        children: [/*#__PURE__*/jsx$1(Text, {
          variant: "heading-h6",
          fontWeight: "bold",
          children: "Manage Advanced DNS Records"
        }), /*#__PURE__*/jsxs(Box, {
          gap: 6,
          width: "100%",
          justifyContent: "space-between",
          children: [/*#__PURE__*/jsxs(Stack$1, {
            gap: "40px",
            children: [/*#__PURE__*/jsx$1(Text, {
              variant: "paragraph-large",
              children: "Manage your A, AAA, CNAME, CAA, NS, TXT, SPF, and SRV records."
            }), /*#__PURE__*/jsxs(Text, {
              children: [/*#__PURE__*/jsx$1(Text, {
                fontWeight: "semi",
                children: "Please note: "
              }), /*#__PURE__*/jsx$1(Text, {
                children: "Any change to advanced DNS record settings may interrupt your service. If you are not an advanced user, we strongly recommend that you do not modify these settings."
              })]
            })]
          }), /*#__PURE__*/jsx$1(Link, {
            to: "advanced",
            children: /*#__PURE__*/jsx$1(Button, {
              variant: "secondary",
              children: /*#__PURE__*/jsx$1(Text, {
                color: "white",
                children: "Advanced DNS Settings"
              })
            })
          })]
        })]
      }), /*#__PURE__*/jsx$1(RegistryNameserverRecords, {
        domain: domain
      })]
    })]
  });
}

function Dns() {
  return /*#__PURE__*/jsxs(Router, {
    children: [/*#__PURE__*/jsx$1(Route, {
      component: DnsManager,
      path: "/"
    }), /*#__PURE__*/jsx$1(Route, {
      component: AdvancedDnsManager,
      path: "/advanced"
    })]
  });
}

function _regenerator$1f() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1f(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1f(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1f(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1f(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1f(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1f(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1f(u), _regeneratorDefine2$1f(u, o, "Generator"), _regeneratorDefine2$1f(u, n, function () {
    return this;
  }), _regeneratorDefine2$1f(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1f = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1f(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1f = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1f(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1f(e, r, n, t);
}
/** This modal turns off autorenew for a domain */


function CancelAtEndOfTermModal(_ref) {
  var domain = _ref.domain;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useDomains = useDomains(),
      refreshDomains = _useDomains.refreshDomains;

  var _useMutation = useMutation$1({
    fn: function fn() {
      return api.domains.toggleAutoRenew(domain.DomainID, 'off');
    },
    successMessage: 'Domain set to cancel at end of term.',
    failureMessage: 'Failed to set domain to cancel at end of term.',
    onSuccess: function () {
      var _onSuccess = _asyncToGenerator( /*#__PURE__*/_regenerator$1f().m(function _callee() {
        return _regenerator$1f().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.n = 1;
                return refreshDomains();

              case 1:
                setIsOpen(false);

              case 2:
                return _context.a(2);
            }
          }
        }, _callee);
      }));

      function onSuccess() {
        return _onSuccess.apply(this, arguments);
      }

      return onSuccess;
    }()
  }),
      isLoading = _useMutation.isLoading,
      cancelAtEndOfTerm = _useMutation.mutate;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Button, {
      onClick: function onClick() {
        return setIsOpen(true);
      },
      variant: "secondary",
      height: "fit-content",
      children: "Proceed to Cancel"
    }), /*#__PURE__*/jsx$1(Modal, {
      isOpen: isOpen,
      onClose: function onClose() {
        return setIsOpen(false);
      },
      title: "Cancel Domain",
      children: /*#__PURE__*/jsxs(Stack$1, {
        children: [/*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-large",
          fontWeight: "semi",
          mb: 4,
          children: "By confirming, your domain will be set to cancel at the end of its term."
        }), /*#__PURE__*/jsxs(Text, {
          variant: "paragraph-large",
          children: ["It will stay active until the day of expiration. ", /*#__PURE__*/jsx$1("br", {}), "No automatic attempt will be made to renew the domain."]
        }), /*#__PURE__*/jsx$1(Button, {
          variant: "secondary",
          onClick: function onClick() {
            return domain.IsAutoRenew ? cancelAtEndOfTerm() : toast.info('Domain already set to cancel at end of term');
          },
          loading: isLoading,
          mt: "56px",
          width: "fit-content",
          children: "Confirm"
        })]
      })
    })]
  });
}

function CancelAtEndOfTerm(_ref) {
  var domain = _ref.domain;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Text, {
      variant: "heading-h6",
      fontWeight: "bold",
      children: "Cancel at End of Term"
    }), /*#__PURE__*/jsxs(Box, {
      gap: 5,
      justifyContent: "space-between",
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-large",
        width: "50%",
        children: "Canceling at end of term will keep the domain active until the day of its expiration. Doing so means that no automatic attempt will be made to renew the domain. To extend the domain's expiration, a manual renewal is required."
      }), /*#__PURE__*/jsx$1(CancelAtEndOfTermModal, {
        domain: domain
      })]
    })]
  });
}

function _regenerator$1e() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1e(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1e(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1e(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1e(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1e(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1e(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1e(u), _regeneratorDefine2$1e(u, o, "Generator"), _regeneratorDefine2$1e(u, n, function () {
    return this;
  }), _regeneratorDefine2$1e(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1e = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1e(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1e = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1e(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1e(e, r, n, t);
}
/** This modal turns on autorenew for a domain */


function RenewAtEndOfTermModal(_ref) {
  var domain = _ref.domain;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useDomains = useDomains(),
      refreshDomains = _useDomains.refreshDomains;

  var _useMutation = useMutation$1({
    fn: function fn() {
      return api.domains.toggleAutoRenew(domain.DomainID, 'on');
    },
    successMessage: 'Domain set to renew at end of term.',
    failureMessage: 'Failed to set domain to renew at end of term.',
    onSuccess: function () {
      var _onSuccess = _asyncToGenerator( /*#__PURE__*/_regenerator$1e().m(function _callee() {
        return _regenerator$1e().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.n = 1;
                return refreshDomains();

              case 1:
                setIsOpen(false);

              case 2:
                return _context.a(2);
            }
          }
        }, _callee);
      }));

      function onSuccess() {
        return _onSuccess.apply(this, arguments);
      }

      return onSuccess;
    }()
  }),
      isLoading = _useMutation.isLoading,
      renewAtEndOfTerm = _useMutation.mutate;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Button, {
      onClick: function onClick() {
        return setIsOpen(true);
      },
      variant: "secondary",
      height: "fit-content",
      children: "Proceed to Uncancel"
    }), /*#__PURE__*/jsx$1(Modal, {
      isOpen: isOpen,
      onClose: function onClose() {
        return setIsOpen(false);
      },
      title: "Cancel Domain",
      children: /*#__PURE__*/jsxs(Stack$1, {
        children: [/*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-large",
          fontWeight: "semi",
          mb: 4,
          children: "By confirming, your domain will be set to renew at end of term."
        }), /*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-large",
          children: "Your card will be automatically charged for the next term as per your domain's billing schedule."
        }), /*#__PURE__*/jsx$1(Button, {
          variant: "secondary",
          loading: isLoading,
          mt: "56px",
          width: "fit-content",
          onClick: function onClick() {
            return domain.IsAutoRenew ? toast.info('Domain already set to renew at end of term') : renewAtEndOfTerm();
          },
          children: "Confirm"
        })]
      })
    })]
  });
}

function RenewAtEndOfTerm(_ref) {
  var domain = _ref.domain;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Text, {
      variant: "heading-h6",
      fontWeight: "bold",
      children: "Renew at End of Term"
    }), /*#__PURE__*/jsxs(Box, {
      gap: 5,
      justifyContent: "space-between",
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-large",
        width: "50%",
        children: "Automatically renewing at the end of term ensures that you don't lose your domain by forgetting to renew it manually."
      }), /*#__PURE__*/jsx$1(RenewAtEndOfTermModal, {
        domain: domain
      })]
    })]
  });
}

function CancelOption(_ref) {
  var domain = _ref.domain;
  return /*#__PURE__*/jsx$1(Stack$1, {
    gap: 4,
    children: domain.IsAutoRenew ? /*#__PURE__*/jsx$1(CancelAtEndOfTerm, {
      domain: domain
    }) : /*#__PURE__*/jsx$1(RenewAtEndOfTerm, {
      domain: domain
    })
  });
}

function _regenerator$1d() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1d(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1d(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1d(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1d(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1d(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1d(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1d(u), _regeneratorDefine2$1d(u, o, "Generator"), _regeneratorDefine2$1d(u, n, function () {
    return this;
  }), _regeneratorDefine2$1d(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1d = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1d(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1d = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1d(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1d(e, r, n, t);
}

function DeleteDomainModal(_ref) {
  var domain = _ref.domain;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useDomains = useDomains(),
      refreshDomains = _useDomains.refreshDomains;

  var _useMutation = useMutation$1({
    fn: function fn() {
      return api.domains.deleteDomain(domain.DomainID);
    },
    successMessage: 'Domain deleted successfully',
    failureMessage: 'Failed to delete domain',
    onSuccess: function () {
      var _onSuccess = _asyncToGenerator( /*#__PURE__*/_regenerator$1d().m(function _callee() {
        return _regenerator$1d().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.n = 1;
                return refreshDomains();

              case 1:
                setIsOpen(false);
                navigate("".concat(BASEPATH, "/managers/domains"));

              case 2:
                return _context.a(2);
            }
          }
        }, _callee);
      }));

      function onSuccess() {
        return _onSuccess.apply(this, arguments);
      }

      return onSuccess;
    }()
  }),
      mutate = _useMutation.mutate,
      isLoading = _useMutation.isLoading;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Button, {
      onClick: function onClick() {
        return setIsOpen(true);
      },
      variant: "secondary",
      height: "fit-content",
      children: "Proceed to Delete"
    }), /*#__PURE__*/jsx$1(Modal, {
      isOpen: isOpen,
      onClose: function onClose() {
        return setIsOpen(false);
      },
      title: "Delete Domain",
      children: /*#__PURE__*/jsxs(Stack$1, {
        gap: 4,
        children: [/*#__PURE__*/jsxs(Stack$1, {
          children: [/*#__PURE__*/jsx$1(Text, {
            children: "Are you sure you want to delete this domain?"
          }), /*#__PURE__*/jsx$1(Text, {
            children: "Deleting this domain will remove it from your account."
          })]
        }), /*#__PURE__*/jsx$1(Text, {
          fontWeight: "semi",
          children: "Once it is deleted, you will only be able to recover it with recovery fee within 30 days."
        }), /*#__PURE__*/jsxs(Text, {
          children: [/*#__PURE__*/jsx$1(Text, {
            fontWeight: "semi",
            children: "Please note: "
          }), /*#__PURE__*/jsx$1(Text, {
            children: "No credit or refund will be given for domains deleting prior to their next billing date."
          })]
        }), /*#__PURE__*/jsx$1(Button, {
          width: "fit-content",
          variant: "secondary",
          loading: isLoading,
          onClick: mutate,
          mt: 3,
          children: "Confirm"
        })]
      })
    })]
  });
}

function DeleteOption(_ref) {
  var domain = _ref.domain;
  return /*#__PURE__*/jsxs(Stack$1, {
    gap: 4,
    children: [/*#__PURE__*/jsx$1(Text, {
      variant: "heading-h6",
      fontWeight: "bold",
      children: "Delete Domain"
    }), /*#__PURE__*/jsxs(Box, {
      justifyContent: "space-between",
      gap: 5,
      children: [/*#__PURE__*/jsxs(Stack$1, {
        gap: 4,
        width: "50%",
        children: [/*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-large",
          children: "Deleting this domain will set it to expire immediately. Once it is cancelled, you will be able to recover it with a recovery fee within 30 days."
        }), /*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-large",
          fontWeight: "semi",
          children: "Please note, no credit or refund will be given for domains delete prior to their next billing date."
        })]
      }), /*#__PURE__*/jsx$1(DeleteDomainModal, {
        domain: domain
      })]
    })]
  });
}
/** Returns formatted price and term */


function formatPrice(amount, term) {
  if (amount <= 0) return 'Free';
  var price = new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
  return "$".concat(price, " ").concat(term);
}
/** String enum linking domain addons to their itemcodes. */


var DomainAddons$1 = /*#__PURE__*/function (DomainAddons) {
  DomainAddons["Privacy"] = "PRIVACY";
  DomainAddons["Expiry"] = "DMEXPINSURANCE";
  DomainAddons["Ownership"] = "DMLOCK";
  DomainAddons["Bundle"] = "OPEPBUNDLE";
  return DomainAddons;
}({});
/** The possible products that a domain can be related to */


var _templateObject$z, _templateObject2$l;

function _regenerator$1c() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1c(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1c(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1c(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1c(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1c(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1c(u), _regeneratorDefine2$1c(u, o, "Generator"), _regeneratorDefine2$1c(u, n, function () {
    return this;
  }), _regeneratorDefine2$1c(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1c = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1c(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1c = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1c(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1c(e, r, n, t);
}

function PackageCard(_ref) {
  var pkg = _ref.pkg,
      domain = _ref.domain,
      closeModal = _ref.closeModal;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isAdding = _useState2[0],
      setIsAdding = _useState2[1];

  var _useDomains = useDomains(),
      refreshDomains = _useDomains.refreshDomains;

  var _usePricingContext = usePricingContext(),
      getPriceByItemCode = _usePricingContext.getPriceByItemCode;

  var session = useSessionService();
  var currency = session.data.currentCurrency.code.slice(0, 2).toUpperCase();
  var isOPEPBundle = pkg.itemCode === DomainAddons$1.Bundle;
  var pricing = getPriceByItemCode(pkg.itemCode);

  function onAdd() {
    return _onAdd.apply(this, arguments);
  }

  function _onAdd() {
    _onAdd = _asyncToGenerator( /*#__PURE__*/_regenerator$1c().m(function _callee() {
      var _yield$pkg$onAdd, _yield$pkg$onAdd2, error;

      return _regenerator$1c().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              setIsAdding(true);
              _context.n = 1;
              return pkg.onAdd(domain);

            case 1:
              _yield$pkg$onAdd = _context.v;
              _yield$pkg$onAdd2 = _slicedToArray$4(_yield$pkg$onAdd, 2);
              error = _yield$pkg$onAdd2[1];

              if (!error) {
                _context.n = 2;
                break;
              }

              toast.error(error);
              _context.n = 4;
              break;

            case 2:
              _context.n = 3;
              return refreshDomains();

            case 3:
              closeModal();
              toast.success("Added ".concat(pkg.title, " to ").concat(domain.DomainName));

            case 4:
              setIsAdding(false);

            case 5:
              return _context.a(2);
          }
        }
      }, _callee);
    }));
    return _onAdd.apply(this, arguments);
  }

  return /*#__PURE__*/jsxs(_StyledStack$k, {
    borderRadius: "base",
    maxWidth: "500px",
    overflow: "hidden",
    children: [/*#__PURE__*/jsxs(Box, {
      backgroundColor: "primary-100",
      padding: "24px",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 3,
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-large",
        fontWeight: "semi",
        color: "neutral-700",
        children: pkg.title
      }), /*#__PURE__*/jsx$1(Stack$1, {
        alignItems: "end",
        textAlign: "right",
        children: pricing === null ? /*#__PURE__*/jsx$1(Skeleton, {
          height: "30px",
          width: "70px"
        }) : /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx$1(Text, {
            color: "primary-600",
            variant: "heading-h7",
            fontWeight: "semi",
            children: "".concat(currency, "$ ").concat(formatPrice(pricing.reg, pkg.term))
          }), pricing.reg !== pricing.rnw && /*#__PURE__*/jsx$1(_StyledText$p, {
            variant: "paragraph-small",
            color: "neutral-500",
            children: "Renewal ".concat(currency, "$ ").concat(formatPrice(pricing.rnw, pkg.term))
          })]
        })
      })]
    }), /*#__PURE__*/jsxs(Stack$1, {
      padding: "24px",
      gap: 4,
      flex: "1",
      backgroundColor: "card",
      children: [isOPEPBundle && /*#__PURE__*/jsx$1(Box, {
        borderRadius: "base",
        padding: "4px 8px",
        backgroundColor: "secondary-600",
        justifyContent: "center",
        alignItems: "center",
        width: "fit-content",
        children: /*#__PURE__*/jsx$1(Text, {
          color: "neutral-700",
          variant: "paragraph-small",
          fontWeight: "semi",
          children: "75% OFF YOUR FIRST TERM"
        })
      }), /*#__PURE__*/jsx$1(Text, {
        color: "neutral-700",
        children: pkg.description
      }), /*#__PURE__*/jsxs(_StyledStack2$3, {
        gap: 2,
        children: [/*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-xsmall",
          fontWeight: "semi",
          color: "primary-700",
          children: "Features"
        }), /*#__PURE__*/jsx$1("ul", {
          children: pkg.features.map(function (feature, i) {
            return /*#__PURE__*/jsx$1("li", {
              children: /*#__PURE__*/jsxs(Text, {
                color: "primary-600",
                children: ["\u2022 ", feature]
              })
            }, i);
          })
        })]
      }), /*#__PURE__*/jsxs(Button, {
        variant: "minimal",
        disabled: isAdding,
        loading: isAdding,
        mt: "auto",
        mr: "auto",
        p: 0,
        onClick: onAdd,
        children: [/*#__PURE__*/jsx$1(RiAddCircleFill, {}), " ", /*#__PURE__*/jsx$1(Text, {
          children: "Add to domain"
        })]
      })]
    })]
  });
}

var _StyledStack$k = styled(Stack$1)(_templateObject$z || (_templateObject$z = _taggedTemplateLiteral$1(["\n        box-shadow: 0px 14px 64px -4px rgba(63, 57, 91, 0.12),\n          0px 8px 22px -6px rgba(63, 57, 91, 0.12);\n      "])));

var _StyledText$p = styled(Text)(_templateObject2$l || (_templateObject2$l = _taggedTemplateLiteral$1(["\n                    white-space: nowrap;\n                  "])));

var _StyledStack2$3 = styled(Stack$1).withConfig({
  displayName: "product-modal-package-card___StyledStack2",
  componentId: "sc-102dz4b-0"
})(["ul{list-style-type:none;}"]);

function ProductModal(_ref) {
  var domain = _ref.domain,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      product = _ref.product;
  return /*#__PURE__*/jsx$1(Modal, {
    isOpen: isOpen,
    onClose: onClose,
    title: product.modalHeader,
    children: /*#__PURE__*/jsxs(Stack$1, {
      gap: 4,
      children: [product.info && /*#__PURE__*/jsx$1(Text, {
        maxWidth: "1100px",
        color: "primary-700",
        children: product.info
      }), /*#__PURE__*/jsx$1(Box, {
        gap: "24px",
        width: "100%",
        justifyContent: "center",
        my: 2,
        children: product.packages.map(function (pkg) {
          return /*#__PURE__*/jsx$1(PackageCard, {
            pkg: pkg,
            domain: domain,
            closeModal: onClose
          }, pkg.itemCode);
        })
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-small",
        color: "neutral-500",
        children: "Sale pricing on your first term (month or year). Your package will renew at its full price."
      })]
    })
  });
}

var _excluded$G = ["domain", "product", "color"];

function ownKeys$1B(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1B(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1B(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1B(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function ProductCard$1(_ref) {
  var domain = _ref.domain,
      product = _ref.product;
  _ref.color;

  var rest = _objectWithoutProperties$8(_ref, _excluded$G);

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isModalOpen = _useState2[0],
      setIsModalOpen = _useState2[1];

  var _usePricingContext = usePricingContext(),
      getPriceByItemCode = _usePricingContext.getPriceByItemCode;

  var firstPackage = product.packages[0];
  var pricing = getPriceByItemCode(firstPackage.itemCode);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(Stack$1, _objectSpread$1B(_objectSpread$1B({
      gap: 3,
      pr: 2,
      backgroundColor: "card",
      borderRadius: "base"
    }, rest), {}, {
      children: [/*#__PURE__*/jsxs(Stack$1, {
        children: [/*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-small",
          fontWeight: "semi",
          color: "neutral-700",
          children: product.title
        }), pricing && /*#__PURE__*/jsx$1(Text, {
          color: "neutral-700",
          variant: "paragraph-small",
          children: formatPrice(pricing.reg, firstPackage.term)
        })]
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        color: "primary-700",
        children: product.description
      }), /*#__PURE__*/jsx$1(Box, {
        mt: "auto",
        children: product.isActive(domain) ? /*#__PURE__*/jsxs(Button, {
          disabled: true,
          variant: "minimal",
          p: 0,
          children: [/*#__PURE__*/jsx$1(RiCheckboxCircleFill, {}), /*#__PURE__*/jsx$1(Text, {
            variant: "paragraph-small",
            children: "Added"
          })]
        }) : /*#__PURE__*/jsxs(Button, {
          variant: "minimal",
          onClick: function onClick() {
            return setIsModalOpen(true);
          },
          p: 0,
          children: [/*#__PURE__*/jsx$1(Text, {
            color: "primary-700",
            variant: "paragraph-small",
            fontWeight: "medium",
            children: "More details"
          }), /*#__PURE__*/jsx$1(ArrowRight, {})]
        })
      })]
    })), /*#__PURE__*/jsx$1(ProductModal, {
      product: product,
      domain: domain,
      isOpen: isModalOpen,
      onClose: function onClose() {
        return setIsModalOpen(false);
      }
    })]
  });
}

var PleskPackages = /*#__PURE__*/function (PleskPackages) {
  PleskPackages["Personal"] = "PPPRSN";
  PleskPackages["Startup"] = "PPBASE5";
  PleskPackages["Business"] = "PPBUSBASE";
  return PleskPackages;
}({});

var SEOPackages = /*#__PURE__*/function (SEOPackages) {
  SEOPackages["MarketgooLite"] = "MARKETGOOLITE";
  return SEOPackages;
}({});

var SSLPackages = /*#__PURE__*/function (SSLPackages) {
  SSLPackages["AlphaSingle"] = "SSLALPHADOMAIN2";
  SSLPackages["DomainSingle"] = "SSLDOMAINSINGLE2";
  SSLPackages["OrganizationSingle"] = "SSLORGSINGLE2";
  SSLPackages["ExtendedSingle"] = "SSLEXTSINGLE2";
  SSLPackages["AlphaWildCard"] = "SSLALPHAWILDCARD";
  SSLPackages["DomainWildCard"] = "SSLDOMAINWILDCARD";
  SSLPackages["OrganizationWildCard"] = "SSLORGWILDCARD";
  SSLPackages["ExtendedWildCard"] = "SSLEXTWILDCARD";
  return SSLPackages;
}({});

var protectionInfo = /*#__PURE__*/jsxs(Fragment, {
  children: ["Adding protection products to your domain? Great! We'll", ' ', /*#__PURE__*/jsx$1(Text, {
    fontWeight: "semi",
    children: "automatically apply the charges "
  }), "on the updated payment method in your profile. This streamlines the process, so you can easily manage your services."]
});
var BUNDLE_PRODUCT = {
  title: 'Ownership + Expiry Protection',
  description: 'Prevent unauthorized transfers and accidental changes while ensuring it never expires unexpectedly.',
  features: ['Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.'],
  itemCode: DomainAddons$1.Bundle,
  term: '/yr',
  onAdd: function onAdd(domain) {
    return api.domains.enableAddon(domain.DomainID, DomainAddons$1.Bundle);
  }
};
var PRODUCTS = [{
  title: 'Expiry Protection',
  description: 'Protect your domain from being lost if your annual payment is unsuccessful.',
  info: protectionInfo,
  isActive: function isActive(domain) {
    return domain.HasExpiryProtection;
  },
  modalHeader: 'Domain protection products',
  isProtectionProduct: true,
  packages: [{
    title: 'Expiry Protection',
    description: 'Protect your domain from being lost if your annual payment is unsuccessful.',
    features: ['Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.'],
    itemCode: DomainAddons$1.Expiry,
    term: '/yr',
    onAdd: function onAdd(domain) {
      return api.domains.enableAddon(domain.DomainID, DomainAddons$1.Expiry);
    }
  }, BUNDLE_PRODUCT]
}, {
  title: 'Ownership Protection',
  description: 'Lock down your domain information and securely tie it to your account.',
  info: protectionInfo,
  isActive: function isActive(domain) {
    return domain.HasOwnershipProtection;
  },
  modalHeader: 'Domain protection products',
  isProtectionProduct: true,
  packages: [{
    title: 'Ownership Protection',
    description: 'Lock down your domain information and securely tie it to your account.',
    features: ['Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.'],
    itemCode: DomainAddons$1.Ownership,
    term: '/yr',
    onAdd: function onAdd(domain) {
      return api.domains.enableAddon(domain.DomainID, DomainAddons$1.Ownership);
    }
  }, BUNDLE_PRODUCT]
}, {
  title: 'Privacy Protection',
  description: "Prevent your personal domain's information from appearing in search results",
  info: protectionInfo,
  isActive: function isActive(domain) {
    return domain.HasPrivacyProtection;
  },
  modalHeader: 'Domain protection products',
  isProtectionProduct: true,
  packages: [{
    title: 'Privacy Protection',
    description: "Prevent your personal domain's information from appearing in search results",
    features: ['Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.'],
    itemCode: DomainAddons$1.Privacy,
    term: '/yr',
    onAdd: function onAdd(domain) {
      return api.domains.enableAddon(domain.DomainID, DomainAddons$1.Privacy);
    }
  }, BUNDLE_PRODUCT]
}, {
  title: 'SEO Tools',
  description: 'Generate more website traffic using SEO tools.',
  isActive: function isActive(domain) {
    return domain.HasMarketgoo;
  },
  modalHeader: 'Add products to advance your domain',
  isProtectionProduct: false,
  packages: [{
    title: 'Marketgoo Lite',
    description: 'Generate more website traffic using SEO tools.',
    features: ['Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.'],
    itemCode: SEOPackages.MarketgooLite,
    term: '/yr',
    onAdd: function onAdd(domain) {
      return api.seo.addToCart(domain.DomainName, SEOPackages.MarketgooLite);
    }
  }]
}, {
  title: 'Personal Hosting',
  description: 'Manage your websites, emails, and applications with Plesk easily.',
  isActive: function isActive(domain) {
    return domain.HasPleskHosting;
  },
  modalHeader: 'Add products to advance your domain',
  isProtectionProduct: false,
  packages: [{
    title: 'Personal Hosting',
    description: 'Manage your websites, emails, and applications with Plesk easily.',
    features: ['Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.'],
    itemCode: PleskPackages.Personal,
    term: '/mo',
    onAdd: function onAdd() {
      return api.plesk.addToCart(PleskPackages.Personal);
    }
  }, {
    title: 'Startup Hosting',
    description: 'Manage your websites, emails, and applications with Plesk easily.',
    features: ['Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.'],
    itemCode: PleskPackages.Startup,
    term: '/mo',
    onAdd: function onAdd() {
      return api.plesk.addToCart(PleskPackages.Startup);
    }
  }, {
    title: 'Business Hosting',
    description: 'Manage your websites, emails, and applications with Plesk easily.',
    features: ['Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.'],
    itemCode: PleskPackages.Business,
    term: '/mo',
    onAdd: function onAdd() {
      return api.plesk.addToCart(PleskPackages.Business);
    }
  }]
}, {
  title: 'Security (SSL)',
  description: 'Ensure the security of your transaction and customer data.',
  isActive: function isActive(domain) {
    return domain.HasSSL;
  },
  modalHeader: 'Protect your website visitors with SSL',
  isProtectionProduct: false,
  packages: [{
    title: 'Alpha SSL (Single Domain)',
    description: 'Ensure the security of your transaction and customer data.',
    features: ['Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.', 'Lorem non mollit quis pariatur reprehenderit quis duis.'],
    itemCode: SSLPackages.AlphaSingle,
    term: '/yr',
    onAdd: function onAdd(domain) {
      return api.ssl.addToCart(domain.DomainName, SSLPackages.AlphaSingle, true);
    }
  }]
}];

function ProductOptions(_ref) {
  var domain = _ref.domain;
  return /*#__PURE__*/jsxs(Stack$1, {
    pb: "48px",
    borderBottom: "1px solid",
    borderColor: "neutral-200",
    children: [/*#__PURE__*/jsx$1(Text, {
      variant: "heading-h6",
      fontWeight: "bold",
      children: "Products"
    }), /*#__PURE__*/jsx$1(Text, {
      my: "32px",
      variant: "paragraph-large",
      children: "Upgrade your domain with additional products"
    }), /*#__PURE__*/jsx$1(_StyledGrid$7, {
      gridTemplateColumns: ['repeat(6, 1fr)'],
      gap: 4,
      children: PRODUCTS.map(function (product, i) {
        return /*#__PURE__*/jsx$1(ProductCard$1, {
          product: product,
          domain: domain,
          backgroundColor: "none",
          borderRadius: "none"
        }, i);
      })
    })]
  });
}

var _StyledGrid$7 = styled(Grid).withConfig({
  displayName: "options-products___StyledGrid",
  componentId: "sc-jnkcr1-0"
})(["& > div{border-right:1px solid ", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors['neutral-200'];
});

var CANCEL_FORM_URL = {
  'rebel.com': 'https://s3.amazonaws.com/rebel.com/protection/Request+to+Cancel+Ownership+Protection+Form.pdf',
  'rebel.ca': 'https://s3.amazonaws.com/rebel.com/protection/Request+to+Cancel+Ownership+Protection+Form.pdf',
  'internic.ca': 'https://s3.amazonaws.com/internic.ca/protection/Request+to+Cancel+Ownership+Protection+Form.pdf'
};
/** This banner warns the user that transfering is not possible while OP is activated */

function OPWarningBanner() {
  return /*#__PURE__*/jsxs(Box, {
    padding: "16px 24px",
    borderRadius: "base",
    backgroundColor: "neutral-100",
    children: [/*#__PURE__*/jsxs(Box, {
      alignItems: "center",
      gap: 3,
      color: "neutral-700",
      children: [/*#__PURE__*/jsx$1(RiErrorWarningFill, {}), /*#__PURE__*/jsxs(Stack$1, {
        children: [/*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-small",
          children: "This domain cannot be transferred until OwnershipProtection has been turned OFF."
        }), /*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-small",
          children: "To turn OFF Ownersihp Protection - Download, complete, and submit the Ownership Protection Cancelation Request form."
        })]
      })]
    }), /*#__PURE__*/jsxs(Button, {
      variant: "minimal",
      color: "primary-700",
      onClick: function onClick() {
        return window.open(CANCEL_FORM_URL[RESELLER], '_blank');
      },
      ml: "auto",
      children: [/*#__PURE__*/jsx$1(RiTodoLine, {}), /*#__PURE__*/jsx$1(Text, {
        fontWeight: "medium",
        children: "Request Form"
      })]
    })]
  });
}

function TransferOption(_ref) {
  var domain = _ref.domain;

  var _useMutation = useMutation$1({
    fn: function fn() {
      return api.domains.requestTransferCode(domain.DomainID);
    },
    successMessage: 'Authorization code sent successfully',
    failureMessage: 'Failed to send authorization code'
  }),
      requestAuthCode = _useMutation.mutate,
      isLoading = _useMutation.isLoading;

  return /*#__PURE__*/jsxs(Stack$1, {
    gap: 4,
    children: [/*#__PURE__*/jsx$1(Text, {
      variant: "heading-h6",
      fontWeight: "bold",
      children: "Transfer Domain"
    }), domain.HasOwnershipProtection && /*#__PURE__*/jsx$1(OPWarningBanner, {}), /*#__PURE__*/jsxs(Box, {
      justifyContent: "space-between",
      gap: 5,
      alignItems: "center",
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-large",
        width: "50%",
        children: "If any domain(s) was moved or its contact updated within last 60 days then transfer authorization code for the corresponding domain(s) will not be sent."
      }), /*#__PURE__*/jsx$1(Button, {
        variant: "secondary",
        loading: isLoading,
        onClick: requestAuthCode,
        children: "Send Authorization Code"
      })]
    })]
  });
}

function DomainOptions() {
  var _useQueryDomain = useQueryDomain(),
      domain = _useQueryDomain.domain;

  if (!domain) {
    return /*#__PURE__*/jsx$1(Skeleton, {
      borderRadius: "base",
      height: "400px"
    });
  }

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Header$1, {
      children: /*#__PURE__*/jsx$1(BackButton$1, {
        text: "Back to Domain Manager",
        to: "".concat(BASEPATH, "/managers/domains")
      })
    }), /*#__PURE__*/jsxs(Text, {
      variant: "heading-h4",
      fontWeight: "semi",
      mb: "48px",
      children: [domain.DomainName, " - ", domain.Status]
    }), /*#__PURE__*/jsx$1(Tabs, {
      tabs: TABS.domainOptions(domain.DomainName)
    }), /*#__PURE__*/jsxs(Stack$1, {
      gap: "96px",
      children: [/*#__PURE__*/jsxs(Stack$1, {
        gap: 3,
        children: [/*#__PURE__*/jsx$1(Text, {
          variant: "heading-h5",
          fontWeight: "bold",
          children: "Domain Options"
        }), /*#__PURE__*/jsx$1(Text, {
          mb: 3,
          children: "Here you'll find information about your domain. You have the ability to add products, and manage your domain's lifecycle."
        }), /*#__PURE__*/jsx$1(ProductOptions, {
          domain: domain
        })]
      }), /*#__PURE__*/jsx$1(TransferOption, {
        domain: domain
      }), /*#__PURE__*/jsx$1(CancelOption, {
        domain: domain
      }), /*#__PURE__*/jsx$1(DeleteOption, {
        domain: domain
      })]
    })]
  });
}

function DomainDetails(_ref) {
  var domainName = _ref.domainName;

  var _useQueryDomain = useQueryDomain(domainName),
      domain = _useQueryDomain.domain;

  return /*#__PURE__*/jsxs(Router, {
    children: [/*#__PURE__*/jsx$1(Route, {
      component: Dns,
      path: "/dns/*",
      title: domain ? "DNS \u2014 ".concat(domain.DomainName) : 'DNS'
    }), /*#__PURE__*/jsx$1(Route, {
      component: DomainContacts,
      path: "/contacts",
      title: domain ? "Contacts \u2014 ".concat(domain.DomainName) : 'Domain Contacts'
    }), /*#__PURE__*/jsx$1(Route, {
      component: DomainOptions,
      path: "/options",
      title: domain ? "Options \u2014 ".concat(domain.DomainName) : 'Domain Options'
    }), /*#__PURE__*/jsx$1(Redirect, {
      from: "*",
      to: "dns",
      noThrow: true
    })]
  });
}

var _templateObject$y;

function _regenerator$1b() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1b(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1b(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1b(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1b(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1b(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1b(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1b(u), _regeneratorDefine2$1b(u, o, "Generator"), _regeneratorDefine2$1b(u, n, function () {
    return this;
  }), _regeneratorDefine2$1b(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1b = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1b(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1b = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1b(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1b(e, r, n, t);
}

function PortfolioButton() {
  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray$4(_useState3, 2),
      input = _useState4[0],
      setInput = _useState4[1];

  var _useDomains = useDomains(),
      portfolios = _useDomains.portfolios,
      setActivePortfolio = _useDomains.setActivePortfolio,
      refreshDomains = _useDomains.refreshDomains;

  var _useMutation = useMutation$1({
    fn: api.domains.createPortfolio,
    successMessage: 'Created new portfolio.',
    failureMessage: 'Failed to create new portfolio.',
    onSuccess: function () {
      var _onSuccess = _asyncToGenerator( /*#__PURE__*/_regenerator$1b().m(function _callee() {
        return _regenerator$1b().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.n = 1;
                return refreshDomains();

              case 1:
                setIsOpen(false);

              case 2:
                return _context.a(2);
            }
          }
        }, _callee);
      }));

      function onSuccess() {
        return _onSuccess.apply(this, arguments);
      }

      return onSuccess;
    }()
  }),
      isLoading = _useMutation.isLoading,
      createPortfolio = _useMutation.mutate;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Popover, {
      trigger: /*#__PURE__*/jsxs(Button, {
        variant: "minimal",
        px: 0,
        width: "fit-content",
        color: "neutral-700",
        gap: 2,
        mt: 4,
        children: [/*#__PURE__*/jsx$1(RiFoldersLine, {}), /*#__PURE__*/jsx$1(Text, {
          fontWeight: "medium",
          mr: 2,
          children: portfolios.active ? "".concat(portfolios.active.name, " (").concat(portfolios.active.count, ")") : 'Portfolios'
        }), /*#__PURE__*/jsx$1(RiArrowDropDownLine, {
          className: "chevron"
        })]
      }),
      children: /*#__PURE__*/jsxs(Stack$1, {
        p: 2,
        gap: 2,
        width: "250px",
        children: [portfolios.available.map(function (portfolio) {
          var _portfolios$active;

          var isActive = portfolio.id === ((_portfolios$active = portfolios.active) === null || _portfolios$active === void 0 ? void 0 : _portfolios$active.id);
          return /*#__PURE__*/jsx$1(_StyledBox$o, {
            p: 2,
            onClick: function onClick() {
              setActivePortfolio(portfolio.id); // Fire this event to close the popover

              var escapeEvent = new KeyboardEvent('keydown', {
                key: 'Escape',
                code: 'Escape',
                keyCode: 27,
                which: 27,
                bubbles: true
              });
              document.dispatchEvent(escapeEvent);
            },
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            transition: "0.2s",
            borderRadius: "base",
            children: /*#__PURE__*/jsx$1(Text, {
              fontWeight: isActive ? 'semi' : 'regular',
              children: "".concat(portfolio.name, " (").concat(portfolio.count, ")")
            })
          }, portfolio.id);
        }), /*#__PURE__*/jsx$1(Box, {
          width: "100%",
          border: "1px solid",
          borderColor: "neutral-100"
        }), /*#__PURE__*/jsxs(Button, {
          variant: "minimal",
          onClick: function onClick() {
            return setIsOpen(true);
          },
          color: "primary-700",
          px: 0,
          width: "fit-content",
          children: [/*#__PURE__*/jsx$1(RiFoldersLine, {}), /*#__PURE__*/jsx$1(Text, {
            variant: "paragraph-xsmall",
            children: "New Portfolio"
          })]
        })]
      })
    }), /*#__PURE__*/jsx$1(Modal, {
      isOpen: isOpen,
      onClose: function onClose() {
        return setIsOpen(false);
      },
      title: "New Portfolio",
      children: /*#__PURE__*/jsxs(Stack$1, {
        gap: 5,
        minWidth: ['300px', '400px', '500px'],
        children: [/*#__PURE__*/jsxs(Stack$1, {
          children: [/*#__PURE__*/jsx$1(Text, {
            color: "neutral-500",
            variant: "paragraph-small",
            children: "Type portfolio name"
          }), /*#__PURE__*/jsx$1(_StyledInput$3, {
            value: input,
            onChange: function onChange(e) {
              var raw = e.target.value;
              var cleaned = raw.replace(/\s+/g, ' ').replace(/[^\w\s\-]/g, '');
              setInput(cleaned);
            },
            padding: 2,
            border: "none",
            borderBottom: "1px solid",
            borderBottomColor: "neutral-300",
            placeholder: "Business Domains",
            fontWeight: "medium",
            color: "neutral-700"
          })]
        }), /*#__PURE__*/jsx$1(Button, {
          onClick: function onClick() {
            var trimmed = input.trim();

            if (trimmed) {
              createPortfolio(trimmed);
            }
          },
          width: "fit-content",
          variant: "secondary",
          loading: isLoading,
          children: "Save Changes"
        })]
      })
    })]
  });
}

var _StyledBox$o = styled(Box)(_templateObject$y || (_templateObject$y = _taggedTemplateLiteral$1(["\n                  cursor: pointer;\n\n                  &:hover {\n                    background-color: ", ";\n                  }\n                "])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors['neutral-100'];
});

var _StyledInput$3 = styled(Input$3).withConfig({
  displayName: "domain-manager-portfolio-button___StyledInput",
  componentId: "sc-1fg9hae-0"
})(["font-size:16px;outline:none;"]);

function AdditionalProductsModal(_ref) {
  var domain = _ref.domain;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(Button, {
      variant: "minimal",
      px: 0,
      onClick: function onClick() {
        return setIsOpen(true);
      },
      children: [/*#__PURE__*/jsx$1(RiMore2Fill, {}), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-small",
        children: "Products"
      })]
    }), /*#__PURE__*/jsxs(Modal, {
      isOpen: isOpen,
      onClose: function onClose() {
        return setIsOpen(false);
      },
      title: "More products to advance your domain",
      children: [/*#__PURE__*/jsx$1(_StyledGrid$6, {
        gridTemplateColumns: ['1fr', 'repeat(2, 1fr)', 'repeat(3, 1fr)'],
        gap: 4,
        children: PRODUCTS.map(function (product, i) {
          return /*#__PURE__*/jsx$1(ProductCard$1, {
            product: product,
            domain: domain,
            padding: "24px",
            maxWidth: "300px"
          }, i);
        })
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-small",
        color: "neutral-500",
        mt: 5,
        children: "Sale pricing on your first term (month or year). Your package will renew at its full price."
      })]
    })]
  });
}

var _StyledGrid$6 = styled(Grid).withConfig({
  displayName: "additional-products-modal___StyledGrid",
  componentId: "sc-1sfz4wm-0"
})(["& > div{box-shadow:0px 14px 64px -4px rgba(63,57,91,0.12),0px 8px 22px -6px rgba(63,57,91,0.12);}"]);

function ProtectionProductsModal(_ref) {
  var domain = _ref.domain;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(Stack$1, {
      borderRadius: "base",
      padding: "16px",
      border: "1px solid",
      borderColor: "neutral-200",
      backgroundColor: "neutral-100",
      gap: "4px",
      alignItems: "start",
      children: [/*#__PURE__*/jsx$1(Text, {
        fontWeight: "semi",
        variant: "paragraph-small",
        color: "primary-700",
        children: "Domain Protection Products"
      }), /*#__PURE__*/jsxs(Button, {
        variant: "minimal",
        px: 0,
        onClick: function onClick() {
          return setIsOpen(true);
        },
        color: "primary-700",
        children: [/*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-xsmall",
          fontWeight: "regular",
          children: "More details"
        }), /*#__PURE__*/jsx$1(RiArrowRightLine, {})]
      })]
    }), isOpen && /*#__PURE__*/jsxs(Modal, {
      isOpen: true,
      onClose: function onClose() {
        return setIsOpen(false);
      },
      title: "More products to advance your domain",
      children: [/*#__PURE__*/jsx$1(_StyledGrid$5, {
        gridTemplateColumns: ['1fr', 'repeat(2, 1fr)', 'repeat(3, 1fr)'],
        gap: 4,
        children: PRODUCTS.filter(function (p) {
          return p.isProtectionProduct;
        }).map(function (product, i) {
          return /*#__PURE__*/jsx$1(ProductCard$1, {
            product: product,
            domain: domain,
            padding: "24px",
            maxWidth: "300px"
          }, i);
        })
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-small",
        color: "neutral-500",
        mt: 5,
        children: "Sale pricing on your first term (month or year). Your package will renew at its full price."
      })]
    })]
  });
}

var _StyledGrid$5 = styled(Grid).withConfig({
  displayName: "protection-products-modal___StyledGrid",
  componentId: "sc-p3zonz-0"
})(["& > div{box-shadow:0px 14px 64px -4px rgba(63,57,91,0.12),0px 8px 22px -6px rgba(63,57,91,0.12);}"]);

function GridCardComponent(_ref) {
  var domain = _ref.domain,
      toggleSelected = _ref.toggleSelected,
      isSelected = _ref.isSelected;
  var DomainName = domain.DomainName,
      Status = domain.Status,
      PaidExpiryDate = domain.PaidExpiryDate;
  var domainHasProducts = domain.HasExpiryProtection || domain.HasOwnershipProtection || domain.HasPrivacyProtection;
  return /*#__PURE__*/jsxs(Stack$1, {
    padding: "32px 24px 16px 24px",
    gap: 4,
    border: "1px solid",
    borderColor: "neutral-200",
    borderRadius: "base",
    backgroundColor: "card",
    children: [/*#__PURE__*/jsxs(Stack$1, {
      children: [/*#__PURE__*/jsxs(Box, {
        justifyContent: "space-between",
        children: [/*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-small",
          color: "neutral-500",
          children: "Domain"
        }), /*#__PURE__*/jsx$1(Checkbox$1, {
          onChange: function onChange() {
            return toggleSelected(domain.DomainID);
          },
          checked: isSelected
        })]
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        color: "neutral-700",
        fontWeight: "bold",
        children: DomainName
      })]
    }), /*#__PURE__*/jsxs(Stack$1, {
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-small",
        color: "neutral-500",
        children: "Status"
      }), /*#__PURE__*/jsx$1(Text, {
        color: "neutral-700",
        fontWeight: "semi",
        children: Status
      })]
    }), /*#__PURE__*/jsxs(Stack$1, {
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-small",
        color: "neutral-500",
        children: "Expiry Date"
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        color: "neutral-700",
        fontWeight: "bold",
        children: PaidExpiryDate
      })]
    }), domainHasProducts ? /*#__PURE__*/jsxs(Stack$1, {
      gap: 2,
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-small",
        color: "neutral-500",
        children: "Added products:"
      }), domain.HasExpiryProtection && /*#__PURE__*/jsx$1(Text, {
        ml: 2,
        fontWeight: "semi",
        color: "neutral-700",
        variant: "paragraph-xsmall",
        children: "\u2022 Expiry Protection"
      }), domain.HasOwnershipProtection && /*#__PURE__*/jsx$1(Text, {
        ml: 2,
        fontWeight: "semi",
        color: "neutral-700",
        variant: "paragraph-xsmall",
        children: "\u2022 Ownership Protection"
      }), domain.HasPrivacyProtection && /*#__PURE__*/jsx$1(Text, {
        ml: 2,
        fontWeight: "semi",
        color: "neutral-700",
        variant: "paragraph-xsmall",
        children: "\u2022 Privacy Protection"
      })]
    }) : /*#__PURE__*/jsxs(Stack$1, {
      gap: 2,
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-small",
        color: "neutral-500",
        children: "Add to advance your domain:"
      }), /*#__PURE__*/jsx$1(ProtectionProductsModal, {
        domain: domain
      })]
    }), /*#__PURE__*/jsx$1(Stack$1, {
      padding: "12px 0px",
      borderTop: "1px solid",
      borderColor: "neutral-200",
      alignItems: "start",
      mt: "auto",
      children: /*#__PURE__*/jsxs(Box, {
        justifyContent: "space-between",
        width: "100%",
        children: [/*#__PURE__*/jsx$1(AdditionalProductsModal, {
          domain: domain
        }), /*#__PURE__*/jsx$1(Link, {
          to: "".concat(BASEPATH, "/managers/domains/").concat(domain.DomainName),
          children: /*#__PURE__*/jsxs(Button, {
            variant: "minimal",
            px: 0,
            children: [/*#__PURE__*/jsx$1(Text, {
              variant: "paragraph-small",
              children: "Manage"
            }), /*#__PURE__*/jsx$1(ArrowRight, {})]
          })
        })]
      })
    })]
  });
}

function areEqual$2(prevProps, nextProps) {
  if (prevProps.isSelected !== nextProps.isSelected) return false;
  var prevDomainEntries = Object.entries(prevProps.domain);
  var nextDomain = nextProps.domain; // eslint-disable-next-line no-restricted-syntax

  for (var _i = 0, _prevDomainEntries = prevDomainEntries; _i < _prevDomainEntries.length; _i++) {
    var _prevDomainEntries$_i = _slicedToArray$4(_prevDomainEntries[_i], 2),
        key = _prevDomainEntries$_i[0],
        value = _prevDomainEntries$_i[1];

    if (nextDomain[key] !== value) {
      return false;
    }
  }

  return true;
}

var GridCard = /*#__PURE__*/memo(GridCardComponent, areEqual$2);

function DomainsListGrid$1(_ref) {
  var toggleSelected = _ref.toggleSelected,
      selected = _ref.selected;

  var _useDomains = useDomains(),
      domains = _useDomains.domains;

  return /*#__PURE__*/jsx$1(Grid, {
    gridTemplateColumns: ['1fr', 'repeat(2, 1fr)', 'repeat(4, 1fr)'],
    gap: 3,
    children: domains ? domains.map(function (domain) {
      return /*#__PURE__*/jsx$1(GridCard, {
        domain: domain,
        toggleSelected: toggleSelected,
        isSelected: Boolean(selected.find(function (id) {
          return id === domain.DomainID;
        }))
      }, domain.DomainName);
    }) : // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Array.from({
      length: 4
    }).map(function (_, i) {
      return /*#__PURE__*/jsx$1(Skeleton, {
        borderRadius: "base",
        height: "400px"
      }, i);
    })
  });
}

var _templateObject$x;

function ExpandableProductsSection(_ref) {
  var domain = _ref.domain,
      expanded = _ref.expanded;
  return /*#__PURE__*/jsx$1(_StyledStack$j, {
    transition: "0.2s",
    gap: 4,
    borderBottom: "1px solid",
    borderColor: expanded ? 'neutral-200' : 'none',
    $_css: expanded ? '500px' : '0',
    $_css2: expanded ? '24px' : '0 24px',
    children: expanded && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "heading-h6",
        fontWeight: "medium",
        color: "primary-700",
        children: "Add products to advance your domain"
      }), /*#__PURE__*/jsx$1(_StyledGrid$4, {
        gridTemplateColumns: ['repeat(6, 1fr)'],
        gap: 4,
        children: PRODUCTS.map(function (product, i) {
          return /*#__PURE__*/jsx$1(ProductCard$1, {
            product: product,
            domain: domain,
            backgroundColor: "none",
            borderRadius: "none"
          }, i);
        })
      })]
    })
  });
}

var _StyledStack$j = styled(Stack$1)(_templateObject$x || (_templateObject$x = _taggedTemplateLiteral$1(["\n        overflow: hidden;\n        max-height: ", ";\n        padding: ", ";\n      "])), function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
});

var _StyledGrid$4 = styled(Grid).withConfig({
  displayName: "table-row-expandable-product-section___StyledGrid",
  componentId: "sc-q9yb2b-0"
})(["& > div{border-right:1px solid ", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors['neutral-200'];
});

function TableRowComponent(_ref) {
  var domain = _ref.domain,
      isSelected = _ref.isSelected,
      toggleSelected = _ref.toggleSelected;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var DomainID = domain.DomainID,
      DomainName = domain.DomainName,
      Status = domain.Status,
      PaidExpiryDate = domain.PaidExpiryDate,
      NextBillingAt = domain.NextBillingAt;
  return /*#__PURE__*/jsxs(Stack$1, {
    backgroundColor: expanded ? 'neutral-50' : 'none',
    transition: "0.2s",
    children: [/*#__PURE__*/jsxs(Grid, {
      gap: 4,
      gridTemplateColumns: "2fr 1fr 1fr 1fr 2fr",
      alignItems: "center",
      p: "24px 16px",
      borderBottom: "1px solid",
      borderColor: "neutral-200",
      fontWeight: "medium",
      children: [/*#__PURE__*/jsxs(Box, {
        gap: 2,
        alignItems: "center",
        children: [/*#__PURE__*/jsx$1(Checkbox$1, {
          onChange: function onChange() {
            return toggleSelected(domain.DomainID);
          },
          checked: isSelected
        }), /*#__PURE__*/jsx$1(Text, {
          color: "neutral-700",
          children: DomainName
        })]
      }), /*#__PURE__*/jsx$1(Text, {
        color: "neutral-700",
        children: Status
      }), /*#__PURE__*/jsx$1(Text, {
        color: "neutral-700",
        children: PaidExpiryDate
      }), /*#__PURE__*/jsx$1(Text, {
        color: "neutral-700",
        children: NextBillingAt
      }), /*#__PURE__*/jsxs(Box, {
        gap: 3,
        children: [/*#__PURE__*/jsxs(_StyledButton$e, {
          p: 0,
          variant: "link",
          fontWeight: "medium",
          color: "primary-700",
          onClick: function onClick() {
            return setExpanded(function (prev) {
              return !prev;
            });
          },
          $_css: expanded ? 'rotate(180deg)' : 'rotate(0)',
          children: [/*#__PURE__*/jsx$1(Text, {
            variant: "paragraph-small",
            children: "Review"
          }), /*#__PURE__*/jsx$1(ChevronDown, {
            size: 18
          })]
        }), /*#__PURE__*/jsx$1(Link, {
          to: "".concat(BASEPATH, "/managers/domains/").concat(domain.DomainName),
          children: /*#__PURE__*/jsxs(Button, {
            variant: "minimal",
            px: 0,
            children: [/*#__PURE__*/jsx$1(Text, {
              variant: "paragraph-small",
              children: "Manage"
            }), /*#__PURE__*/jsx$1(ArrowRight, {})]
          })
        })]
      })]
    }, DomainID), /*#__PURE__*/jsx$1(ExpandableProductsSection, {
      domain: domain,
      expanded: expanded
    })]
  });
}

function areEqual$1(prevProps, nextProps) {
  if (prevProps.isSelected !== nextProps.isSelected) return false;
  var prevDomainEntries = Object.entries(prevProps.domain);
  var nextDomain = nextProps.domain; // eslint-disable-next-line no-restricted-syntax

  for (var _i = 0, _prevDomainEntries = prevDomainEntries; _i < _prevDomainEntries.length; _i++) {
    var _prevDomainEntries$_i = _slicedToArray$4(_prevDomainEntries[_i], 2),
        key = _prevDomainEntries$_i[0],
        value = _prevDomainEntries$_i[1];

    if (nextDomain[key] !== value) {
      return false;
    }
  }

  return true;
}

var TableRow$2 = /*#__PURE__*/memo(TableRowComponent, areEqual$1);

var _StyledButton$e = styled(Button).withConfig({
  displayName: "table-row___StyledButton",
  componentId: "sc-1ewjrqd-0"
})(["svg{transition:0.2s;transform:", ";}"], function (p) {
  return p.$_css;
});

function DomainsListTable$1(_ref) {
  var toggleSelected = _ref.toggleSelected,
      selected = _ref.selected;

  var _useDomains = useDomains(),
      domains = _useDomains.domains;

  var _useSortState = useSortState(domains),
      sortState = _useSortState.sortState,
      handleToggleSort = _useSortState.handleToggleSort,
      sortedDomains = _useSortState.sortedItems;

  return /*#__PURE__*/jsxs(Stack$1, {
    children: [/*#__PURE__*/jsxs(Grid, {
      gridTemplateColumns: "2fr 1fr 1fr 1fr 2fr",
      alignItems: "center",
      backgroundColor: "neutral-100",
      p: "24px 16px",
      gap: 4,
      borderBottom: "1px solid",
      borderColor: "neutral-200",
      children: [/*#__PURE__*/jsx$1(SortableHeader, {
        field: "DomainName",
        label: "Domain Name",
        sortState: sortState,
        onToggleSort: handleToggleSort
      }), /*#__PURE__*/jsx$1(SortableHeader, {
        field: "Status",
        label: "Status",
        sortState: sortState,
        onToggleSort: handleToggleSort
      }), /*#__PURE__*/jsx$1(SortableHeader, {
        field: "PaidExpiryDate",
        label: "Expiry Date",
        sortState: sortState,
        onToggleSort: handleToggleSort
      }), /*#__PURE__*/jsx$1(SortableHeader, {
        field: "NextBillingAt",
        label: "Next Billing",
        sortState: sortState,
        onToggleSort: handleToggleSort
      })]
    }), sortedDomains ? sortedDomains.map(function (domain) {
      return /*#__PURE__*/jsx$1(TableRow$2, {
        domain: domain,
        toggleSelected: toggleSelected,
        isSelected: Boolean(selected.find(function (id) {
          return id === domain.DomainID;
        }))
      }, domain.DomainID);
    }) : Array.from({
      length: 4
    }).map(function (_, index) {
      return /*#__PURE__*/jsx$1(Skeleton, {
        height: "64px",
        borderRadius: "base"
      }, index);
    })]
  });
}

function DomainsManager() {
  var _useState = useState([]),
      _useState2 = _slicedToArray$4(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var _useDomains = useDomains(),
      domains = _useDomains.domains,
      searchTerm = _useDomains.searchTerm,
      setSearchTerm = _useDomains.setSearchTerm,
      showAll = _useDomains.showAll;

  function _toggleSelected(domainId) {
    setSelected(function (prev) {
      if (prev.includes(domainId)) {
        return prev.filter(function (d) {
          return d !== domainId;
        });
      }

      return [].concat(_toConsumableArray$1(prev), [domainId]);
    });
  }

  useEffect(function () {
    setSelected([]);
  }, [domains]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Header$1, {
      header: "Managers"
    }), /*#__PURE__*/jsx$1(Tabs, {
      tabs: TABS.managers
    }), /*#__PURE__*/jsxs(Stack$1, {
      gap: 3,
      children: [/*#__PURE__*/jsxs(Box, {
        justifyContent: "space-between",
        alignItems: "center",
        gap: 6,
        children: [/*#__PURE__*/jsxs(Stack$1, {
          gap: 2,
          width: ['100%', '50%', '50%'],
          children: [/*#__PURE__*/jsx$1(Text, {
            variant: "heading-h5",
            fontWeight: "bold",
            color: "primary-600",
            children: "Domains"
          }), /*#__PURE__*/jsx$1(Text, {
            color: "primary-600",
            children: "Here, you'll find information about your account. You have the ability to review your Domain List, Active and Canceled Subscriptions, and Login History."
          }), /*#__PURE__*/jsx$1(PortfolioButton, {})]
        }), /*#__PURE__*/jsx$1(Stack$1, {
          justifyContent: "end",
          height: "100%",
          children: /*#__PURE__*/jsx$1(StyledInput, {
            value: searchTerm,
            onChange: function onChange(e) {
              return setSearchTerm(e.target.value.trim());
            },
            placeholder: "Type your domain name"
          })
        })]
      }), /*#__PURE__*/jsx$1(ViewManager, {
        items: domains,
        gridView: /*#__PURE__*/jsx$1(DomainsListGrid$1, {
          toggleSelected: function toggleSelected(domainId) {
            return _toggleSelected(domainId);
          },
          selected: selected
        }),
        tableView: /*#__PURE__*/jsx$1(DomainsListTable$1, {
          toggleSelected: function toggleSelected(domainId) {
            return _toggleSelected(domainId);
          },
          selected: selected
        }),
        headerBar: /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsxs(Box, {
            alignItems: "center",
            gap: 2,
            color: "primary-600",
            children: [/*#__PURE__*/jsx$1(Checkbox$1, {
              id: "select-all-domains",
              checked: selected.length === (domains === null || domains === void 0 ? void 0 : domains.length),
              onChange: function onChange(e) {
                return e.target.checked ? setSelected(domains ? domains.map(function (domain) {
                  return domain.DomainID;
                }) : []) : setSelected([]);
              }
            }), /*#__PURE__*/jsxs("label", {
              htmlFor: "select-all-domains",
              style: {
                cursor: 'pointer',
                userSelect: 'none'
              },
              children: ["Select All ", domains ? "(".concat(domains.length, ")") : null]
            })]
          }), /*#__PURE__*/jsx$1(_StyledBox$n, {
            alignItems: "center",
            ml: "auto",
            children: /*#__PURE__*/jsx$1(ActionsBar, {
              selected: selected,
              domains: domains || []
            })
          })]
        })
      }), domains && showAll && /*#__PURE__*/jsx$1(Button, {
        variant: "secondary",
        disabled: showAll === undefined,
        width: ['100%', '50%', '50%'],
        mt: 2,
        mx: "auto",
        onClick: function onClick() {
          if (showAll) {
            showAll();
          }
        },
        children: "Show All"
      })]
    })]
  });
}

function DomainManager() {
  return /*#__PURE__*/jsx$1(PricingProvider, {
    children: /*#__PURE__*/jsx$1(DomainsProvider, {
      children: /*#__PURE__*/jsxs(Router, {
        children: [/*#__PURE__*/jsx$1(Route, {
          component: DomainsManager,
          path: "/",
          title: "Domain Manager"
        }), /*#__PURE__*/jsx$1(Route, {
          component: DomainDetails,
          path: "/:domainName/*"
        })]
      })
    })
  });
}

var _StyledBox$n = styled(Box).withConfig({
  displayName: "domain-manager___StyledBox",
  componentId: "sc-64n7zt-0"
})(["button{font-weight:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.regular;
});

function HostingTab() {
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Header$1, {
      header: "Managers"
    }), /*#__PURE__*/jsx$1(Tabs, {
      tabs: TABS.managers
    }), /*#__PURE__*/jsx$1("h3", {
      children: "Hosting"
    })]
  });
}

function SEOTab() {
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Header$1, {
      header: "Managers"
    }), /*#__PURE__*/jsx$1(Tabs, {
      tabs: TABS.managers
    }), /*#__PURE__*/jsx$1("h3", {
      children: "SEO"
    })]
  });
}

function SSLTab() {
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Header$1, {
      header: "Managers"
    }), /*#__PURE__*/jsx$1(Tabs, {
      tabs: TABS.managers
    }), /*#__PURE__*/jsx$1("h3", {
      children: "SSL"
    })]
  });
}

var TransferContext = /*#__PURE__*/createContext(undefined);

function TransferProvider(_ref) {
  var children = _ref.children;

  var _useState = useState([]),
      _useState2 = _slicedToArray$4(_useState, 2),
      transferDomains = _useState2[0],
      setTransferDomains = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$4(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var resetTransferState = function resetTransferState() {
    setTransferDomains([]);
    setLoading(false);
  };

  return /*#__PURE__*/jsx$1(TransferContext.Provider, {
    value: {
      transferDomains: transferDomains,
      loading: loading,
      setTransferDomains: setTransferDomains,
      setLoading: setLoading,
      resetTransferState: resetTransferState
    },
    children: children
  });
}

var useTransfer = function useTransfer() {
  var ctx = useContext(TransferContext);
  if (!ctx) throw new Error('useTransfer must be used within a TransferProvider');
  return ctx;
};

var _templateObject$w;

function BulkTransferContent() {
  var _useState = useState(''),
      _useState2 = _slicedToArray$4(_useState, 2),
      userInput = _useState2[0],
      setUserInput = _useState2[1];

  var _useTransfer = useTransfer(),
      setTransferDomains = _useTransfer.setTransferDomains;

  var closeAndSearch = function closeAndSearch() {
    var search = {
      validDomains: [],
      invalidDomains: []
    }; // Just to make sure we catch all cases, probably a better way to do this.

    var list = userInput.split('\r\n').join(',').split('\n').join(',').split(',');
    list.forEach(function (domain) {
      var clean = domain.trim();

      if (isValidDomain(clean)) {
        search.validDomains.push(clean);
      } else {
        search.invalidDomains.push(clean);
      }
    });
    setTransferDomains(search.validDomains);
  };

  var handleFile = function handleFile(file) {
    if (file.type === 'text/plain' || file.name.endsWith('.csv')) {
      var reader = new FileReader();

      reader.onload = function (e) {
        var _e$target;

        var text = (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.result;
        var newEntries = text.split(',').map(function (line) {
          return line.trim();
        }).join('\r\n');
        setUserInput(function (prev) {
          return prev ? "".concat(prev, "\r\n").concat(newEntries) : newEntries;
        });
      };

      reader.readAsText(file);
    }
  };

  return /*#__PURE__*/jsx$1(Box, {
    height: "100%",
    width: "100%",
    pb: "48px",
    px: "56px",
    flex: 1,
    alignItems: "start",
    justifyContent: "start",
    children: /*#__PURE__*/jsxs(Stack$1, {
      gap: 3,
      width: "100%",
      children: [/*#__PURE__*/jsx$1(Text, {
        color: "primary-600",
        fontWeight: "semi",
        variant: "heading-h3",
        children: /*#__PURE__*/jsx$1(BackButton$1, {
          text: "Back to Transfer",
          "data-testid": "back-to-transfer",
          to: "".concat(BASEPATH, "/managers/transfer")
        })
      }), /*#__PURE__*/jsxs(Stack$1, {
        "data-testid": "bulk-search-view",
        gap: 4,
        children: [/*#__PURE__*/jsx$1(Box, {
          width: "100%",
          flex: 1,
          alignItems: "start",
          justifyContent: "start",
          children: /*#__PURE__*/jsx$1(Text, {
            color: "primary-600",
            fontWeight: "semi",
            variant: "heading-h3",
            children: "Bulk Transfer"
          })
        }), /*#__PURE__*/jsxs(Stack$1, {
          width: "100%",
          pb: "48px",
          flex: 1,
          alignItems: "start",
          justifyContent: "start",
          children: [/*#__PURE__*/jsx$1(Text, {
            color: "neutral-700",
            variant: "paragraph-large",
            fontFamily: "Inter",
            children: "Transfer all your domains quickly and effortlessly with our bulk domain transfer."
          }), /*#__PURE__*/jsxs(Text, {
            color: "neutral-700",
            variant: "paragraph-large",
            fontFamily: "Inter",
            children: ["Please include one domain per line, following the format bellow.", ' ']
          }), /*#__PURE__*/jsx$1(Text, {
            color: "neutral-700",
            variant: "paragraph-large",
            fontFamily: "Inter",
            children: "Do not include \u201Chttp://\u201D or \u201Cwww\u201D."
          }), ' ']
        }), /*#__PURE__*/jsx$1(Box, {
          width: "100%",
          borderBottom: "1px solid",
          borderColor: "neutral-300",
          my: 2
        }), /*#__PURE__*/jsxs(Grid, {
          gridTemplateColumns: ['1fr', '1fr', '1fr 1fr'],
          gap: 4,
          children: [/*#__PURE__*/jsxs(_StyledStack$i, {
            minHeight: "300px",
            gap: 3,
            children: [/*#__PURE__*/jsx$1(Text, {
              variant: "paragraph-large",
              color: "primary-600",
              mb: 2,
              children: "Enter one domain per line (up to 500 domains)"
            }), /*#__PURE__*/jsx$1(Textarea, {
              "data-testid": "bulk-search-input",
              id: "input-box-bulk-search",
              style: {
                fontSize: '20px'
              },
              m: 0,
              flex: 1,
              value: userInput,
              onChange: function onChange(e) {
                return setUserInput(e.target.value);
              },
              onDragOver: function onDragOver(e) {
                return e.preventDefault();
              },
              placeholder: "example.com",
              rows: 8
            })]
          }), /*#__PURE__*/jsx$1(Uploader, {
            onFileUpload: handleFile
          })]
        }), /*#__PURE__*/jsx$1(_StyledButton$d, {
          "data-testid": "generate-bulk-search",
          onClick: closeAndSearch,
          variant: "secondary",
          children: "Check Availability"
        })]
      })]
    })
  });
}

function BulkTransfer() {
  return /*#__PURE__*/jsx$1(TransferProvider, {
    children: /*#__PURE__*/jsx$1(BulkTransferContent, {})
  });
}

var _StyledStack$i = styled(Stack$1)(_templateObject$w || (_templateObject$w = _taggedTemplateLiteral$1(["\n                & > div {\n                  margin: 0;\n                }\n\n                div {\n                  height: 100%;\n                }\n\n                textarea {\n                  flex: 1;\n                  padding: 2rem;\n                  height: 100%;\n                  border-radius: ", ";\n                  border: 1px dashed\n                    ", ";\n                }\n              "])), function (_ref) {
  var theme = _ref.theme;
  return theme.radii.base;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors['neutral-400'];
});

var _StyledButton$d = styled(Button).withConfig({
  displayName: "bulk-transfer___StyledButton",
  componentId: "sc-1k5j7k9-0"
})(["margin-left:auto;"]);

function Transfer() {
  var _useState = useState(''),
      _useState2 = _slicedToArray$4(_useState, 2),
      domain = _useState2[0],
      setDomain = _useState2[1];

  var _useTransfer = useTransfer(),
      setTransferDomains = _useTransfer.setTransferDomains;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Header$1, {
      header: "Managers"
    }), /*#__PURE__*/jsx$1(Tabs, {
      tabs: TABS.managers
    }), /*#__PURE__*/jsxs(Stack$1, {
      gap: 3,
      mr: "56px",
      fontFamily: "Inter",
      children: [/*#__PURE__*/jsx$1(Box, {
        justifyContent: "space-between",
        alignItems: "center",
        gap: 6,
        children: /*#__PURE__*/jsxs(Stack$1, {
          gap: 2,
          width: "75%",
          mt: "48px",
          mb: "24px",
          children: [/*#__PURE__*/jsx$1(Text, {
            variant: "heading-h5",
            fontWeight: "bold",
            color: "primary-600",
            children: "Transfer Domain"
          }), /*#__PURE__*/jsx$1(Text, {
            color: "primary-600",
            mt: "16px",
            children: "If you have a domain name elsewhere, you can transfer it to us for better support and service. All transfers include a one year extension to the term of your domain. You can also migrate many domains at once \u2014 your whole portfolio \u2014 with our Bulk Transfer tool. Here, you'll find information about your account. You have the ability to review your Domain List, Active and Canceled Subscriptions, and Login History."
          })]
        })
      }), /*#__PURE__*/jsxs(Box, {
        width: "100%",
        height: "100%",
        overflow: "hidden",
        display: "inline-flex",
        justifyContent: "space-between",
        alignItems: "center",
        border: "1px solid",
        borderColor: "primary-300",
        borderRadius: "rounded",
        style: {
          boxShadow: '0px 20px 26px -20px rgba(0, 0, 0, 0.15)'
        },
        children: [/*#__PURE__*/jsx$1(Box, {
          width: "100%",
          children: /*#__PURE__*/jsx$1(Input$3, {
            id: "transferDomain",
            "data-testid": "transfer-domain",
            placeholder: "Enter your domain to transfer",
            autoFocus: true,
            ml: "24px",
            color: "neutral-700",
            width: "100%",
            my: "12px",
            height: "28px",
            border: "none",
            onChange: function onChange(e) {
              setDomain(e.target.value);
            },
            style: {
              background: 'none',
              outline: 'none',
              fontSize: '20px'
            }
          })
        }), /*#__PURE__*/jsxs(Box, {
          width: "308px",
          mr: "24px",
          my: "12px",
          gap: 2,
          justifyContent: "flex-end",
          children: [/*#__PURE__*/jsx$1(Link, {
            "data-testid": "to-bulk-transfer",
            to: "".concat(BASEPATH, "/managers/transfer/bulk-transfer"),
            children: /*#__PURE__*/jsx$1(Button, {
              height: "48px",
              variant: "minimal",
              mr: "24px",
              children: "Bulk Transfer"
            })
          }), /*#__PURE__*/jsx$1(Button, {
            height: "48px",
            "data-testid": "btn-transfer",
            onClick: function onClick() {
              if (isValidDomain(domain)) {
                setTransferDomains([domain]);
              } else {
                toast.warning('Please enter a valid domain name');
              }
            },
            variant: "secondary",
            children: "Transfer"
          })]
        })]
      }), /*#__PURE__*/jsx$1(Box, {
        justifyContent: "space-between",
        alignItems: "center",
        gap: 6,
        children: /*#__PURE__*/jsxs(Stack$1, {
          gap: 2,
          children: [/*#__PURE__*/jsx$1(Text, {
            variant: "heading-h5",
            mt: "48px",
            mb: "16px",
            fontWeight: "bold",
            color: "primary-600",
            children: "Pending Transfers"
          }), /*#__PURE__*/jsxs(Box, {
            mr: "56px",
            children: [/*#__PURE__*/jsx$1(Stack$1, {
              gap: 2,
              width: "50%",
              children: /*#__PURE__*/jsx$1(Text, {
                color: "primary-600",
                children: "During the domain transfer process, you can monitor the timeline, review the steps involved, and receive updates on the transfer status. It may take 24 hours for transfers to be processed and appear."
              })
            }), /*#__PURE__*/jsx$1(Box, {
              gap: 2,
              width: "50%",
              display: "flex",
              justifyContent: "flex-end",
              children: /*#__PURE__*/jsx$1(Box, {
                width: "132px",
                children: /*#__PURE__*/jsx$1(Button, {
                  height: "48px",
                  variant: "secondary",
                  children: "Review Transfers"
                })
              })
            })]
          })]
        })
      })]
    })]
  });
}

function TransferTab() {
  return /*#__PURE__*/jsx$1(TransferProvider, {
    children: /*#__PURE__*/jsxs(Router, {
      children: [/*#__PURE__*/jsx$1(Route, {
        component: Transfer,
        path: "/*"
      }), /*#__PURE__*/jsx$1(Route, {
        component: BulkTransfer,
        path: "/bulk-transfer/*"
      })]
    })
  });
}

function WebsiteBuilderTab() {
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Header$1, {
      header: "Managers"
    }), /*#__PURE__*/jsx$1(Tabs, {
      tabs: TABS.managers
    }), /*#__PURE__*/jsx$1("h3", {
      children: "WebsiteBuilder"
    })]
  });
}

function WebsiteSecurityTab() {
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Header$1, {
      header: "Managers"
    }), /*#__PURE__*/jsx$1(Tabs, {
      tabs: TABS.managers
    }), /*#__PURE__*/jsx$1("h3", {
      children: "WebsiteSecurity"
    })]
  });
}

function ManagersPage() {
  return /*#__PURE__*/jsxs(Router, {
    children: [/*#__PURE__*/jsx$1(Route, {
      component: DomainManager,
      path: "/domains/*"
    }), /*#__PURE__*/jsx$1(Route, {
      component: TransferTab,
      path: "/transfer/*",
      title: "Transfer Manager"
    }), /*#__PURE__*/jsx$1(Route, {
      component: HostingTab,
      path: "/hosting",
      title: "Hosting Manager"
    }), /*#__PURE__*/jsx$1(Route, {
      component: SSLTab,
      path: "/ssl",
      title: "SSL Manager"
    }), /*#__PURE__*/jsx$1(Route, {
      component: SEOTab,
      path: "/seo",
      title: "SEO Manager"
    }), /*#__PURE__*/jsx$1(Route, {
      component: WebsiteBuilderTab,
      path: "/website-builder",
      title: "Website Builder"
    }), /*#__PURE__*/jsx$1(Route, {
      component: WebsiteSecurityTab,
      path: "/website-security",
      title: "Website Security"
    }), /*#__PURE__*/jsx$1(Redirect, {
      from: "*",
      to: "domains",
      noThrow: true
    })]
  });
}

function simplifyExtendedContacts(contactDetails) {
  return contactDetails === null || contactDetails === void 0 ? void 0 : contactDetails.map(function (contact) {
    var _contact$domains;

    return {
      id: contact.id,
      lastUpdate: contact.lastUpdate,
      verified: contact.active.toLowerCase() === 'notverified' ? 'Unverified' : 'Verified',
      company: contact.company,
      firstName: contact.firstName,
      lastName: contact.lastName,
      address: contact.address,
      email: contact.email,
      extraInfo: contact.extraInfo,
      domains: contact.domains,
      phone: contact.phone,
      consent: contact.consent,
      domainCount: (_contact$domains = contact.domains) === null || _contact$domains === void 0 ? void 0 : _contact$domains.length,
      contactName: "".concat(contact.firstName, " ").concat(contact.lastName, " ").concat(contact.company).trim(),
      sortableAddress: [contact.address.apartment ? "".concat(contact.address.apartment, "-").concat(contact.address.streetNumber) : contact.address.streetNumber, contact.address.streetName, contact.address.streetType, contact.address.city, contact.address.province, contact.address.countryName, contact.address.postalCode].filter(Boolean).join(' ').trim()
    };
  });
}

function _regenerator$1a() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1a(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1a(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1a(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1a(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1a(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1a(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1a(u), _regeneratorDefine2$1a(u, o, "Generator"), _regeneratorDefine2$1a(u, n, function () {
    return this;
  }), _regeneratorDefine2$1a(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1a = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1a(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1a = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1a(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1a(e, r, n, t);
}

function ownKeys$1A(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1A(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1A(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1A(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var ContactsContext = /*#__PURE__*/createContext(undefined);

function ContactsProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(),
      _useState2 = _slicedToArray$4(_useState, 2),
      extendedContactsDetails = _useState2[0],
      setExtendedContactsDetails = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray$4(_useState3, 2),
      searchTerm = _useState4[0],
      setSearchTerm = _useState4[1];

  var _useState5 = useState('All'),
      _useState6 = _slicedToArray$4(_useState5, 2),
      verifiedFilter = _useState6[0],
      setVerifiedFilter = _useState6[1];

  var simplifiedContacts = useMemo(function () {
    return simplifyExtendedContacts(extendedContactsDetails);
  }, [extendedContactsDetails]);
  var filteredContacts = useMemo(function () {
    if (simplifiedContacts && (searchTerm || verifiedFilter)) {
      var lowerSearch = (searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toLowerCase()) || '';
      return simplifiedContacts.filter(function (contact) {
        return Object.values(contact).some(function (value) {
          return String(value).toLowerCase().includes(lowerSearch);
        });
      }).filter(function (contact) {
        return (verifiedFilter === null || verifiedFilter === void 0 ? void 0 : verifiedFilter.includes(contact.verified)) || (verifiedFilter === null || verifiedFilter === void 0 ? void 0 : verifiedFilter.includes('All'));
      });
    }

    return simplifiedContacts;
  }, [searchTerm, verifiedFilter, simplifiedContacts]);
  var attachDomainsList = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$1a().m(function _callee(contacts) {
      var _yield$api$contacts$f, _yield$api$contacts$f2, resp, error, completeContactDetails;

      return _regenerator$1a().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              if (!(Object.values(contacts).length === 0)) {
                _context.n = 1;
                break;
              }

              return _context.a(2);

            case 1:
              _context.n = 2;
              return api.contacts.fetchAllLinkedDomains(Object.values(contacts).map(function (contact) {
                return contact.id;
              }));

            case 2:
              _yield$api$contacts$f = _context.v;
              _yield$api$contacts$f2 = _slicedToArray$4(_yield$api$contacts$f, 2);
              resp = _yield$api$contacts$f2[0];
              error = _yield$api$contacts$f2[1];

              if (!error) {
                _context.n = 3;
                break;
              }

              toast.error(error);
              return _context.a(2, Object.values(contacts));

            case 3:
              completeContactDetails = Object.values(contacts).map(function (detail) {
                var contactInfo = resp === null || resp === void 0 ? void 0 : resp.result[detail.id];
                return _objectSpread$1A(_objectSpread$1A({}, detail), {}, {
                  domains: contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.list
                });
              });
              return _context.a(2, completeContactDetails);
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), []);
  var loadContacts = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1a().m(function _callee2() {
    var _yield$api$contacts$f3, _yield$api$contacts$f4, response, error, contacts;

    return _regenerator$1a().w(function (_context2) {
      while (1) {
        switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return api.contacts.fetchAll();

          case 1:
            _yield$api$contacts$f3 = _context2.v;
            _yield$api$contacts$f4 = _slicedToArray$4(_yield$api$contacts$f3, 2);
            response = _yield$api$contacts$f4[0];
            error = _yield$api$contacts$f4[1];

            if (!error) {
              _context2.n = 2;
              break;
            }

            toast.error(error);
            _context2.n = 4;
            break;

          case 2:
            _context2.n = 3;
            return attachDomainsList(response.result);

          case 3:
            contacts = _context2.v;
            setExtendedContactsDetails(contacts);

          case 4:
            return _context2.a(2);
        }
      }
    }, _callee2);
  })), [attachDomainsList]);
  var reloadContacts = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1a().m(function _callee3() {
    return _regenerator$1a().w(function (_context3) {
      while (1) {
        switch (_context3.n) {
          case 0:
            setExtendedContactsDetails(undefined);
            _context3.n = 1;
            return loadContacts();

          case 1:
            return _context3.a(2);
        }
      }
    }, _callee3);
  })), [loadContacts]);
  var deleteUnusedContacts = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$1a().m(function _callee4() {
    var _yield$api$contacts$d, _yield$api$contacts$d2, response, error;

    return _regenerator$1a().w(function (_context4) {
      while (1) {
        switch (_context4.n) {
          case 0:
            _context4.n = 1;
            return api.contacts.deleteUnused();

          case 1:
            _yield$api$contacts$d = _context4.v;
            _yield$api$contacts$d2 = _slicedToArray$4(_yield$api$contacts$d, 2);
            response = _yield$api$contacts$d2[0];
            error = _yield$api$contacts$d2[1];

            if (error) {
              toast.error(error);
            } else {
              setExtendedContactsDetails(Object.values(response.result));
              toast.success('Successfully deleted unused contacts!');
            }

          case 2:
            return _context4.a(2);
        }
      }
    }, _callee4);
  })), []);
  var deleteContact = useCallback( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regenerator$1a().m(function _callee5(contactId) {
      var _yield$api$contacts$d3, _yield$api$contacts$d4, error;

      return _regenerator$1a().w(function (_context5) {
        while (1) {
          switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return api.contacts.deleteContact(contactId);

            case 1:
              _yield$api$contacts$d3 = _context5.v;
              _yield$api$contacts$d4 = _slicedToArray$4(_yield$api$contacts$d3, 2);
              error = _yield$api$contacts$d4[1];

              if (error) {
                toast.error(error);
              }

              toast.success('Successfully deleted contact!');

            case 2:
              return _context5.a(2);
          }
        }
      }, _callee5);
    }));

    return function (_x2) {
      return _ref6.apply(this, arguments);
    };
  }(), []);
  var resendVerification = useCallback( /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regenerator$1a().m(function _callee6(contactId) {
      var _yield$api$contacts$r, _yield$api$contacts$r2, error;

      return _regenerator$1a().w(function (_context6) {
        while (1) {
          switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return api.contacts.resendVerification(contactId);

            case 1:
              _yield$api$contacts$r = _context6.v;
              _yield$api$contacts$r2 = _slicedToArray$4(_yield$api$contacts$r, 2);
              error = _yield$api$contacts$r2[1];

              if (error) {
                toast.error(error);
              } else {
                toast.success('Resent verification!');
              }

            case 2:
              return _context6.a(2);
          }
        }
      }, _callee6);
    }));

    return function (_x3) {
      return _ref7.apply(this, arguments);
    };
  }(), []);
  var addContact = useCallback( /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regenerator$1a().m(function _callee7(contact) {
      var _yield$api$contacts$a, _yield$api$contacts$a2, response, error;

      return _regenerator$1a().w(function (_context7) {
        while (1) {
          switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return api.contacts.addContact(contact);

            case 1:
              _yield$api$contacts$a = _context7.v;
              _yield$api$contacts$a2 = _slicedToArray$4(_yield$api$contacts$a, 2);
              response = _yield$api$contacts$a2[0];
              error = _yield$api$contacts$a2[1];

              if (error) {
                toast.error(error);
              }

              return _context7.a(2, !!(response !== null && response !== void 0 && response.success));
          }
        }
      }, _callee7);
    }));

    return function (_x4) {
      return _ref8.apply(this, arguments);
    };
  }(), []);
  var updateContact = useCallback( /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regenerator$1a().m(function _callee8(contact) {
      var _yield$api$contacts$u, _yield$api$contacts$u2, response, error;

      return _regenerator$1a().w(function (_context8) {
        while (1) {
          switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return api.contacts.updateContact(contact);

            case 1:
              _yield$api$contacts$u = _context8.v;
              _yield$api$contacts$u2 = _slicedToArray$4(_yield$api$contacts$u, 2);
              response = _yield$api$contacts$u2[0];
              error = _yield$api$contacts$u2[1];

              if (error) {
                toast.error(error);
              }

              return _context8.a(2, !!(response !== null && response !== void 0 && response.success));
          }
        }
      }, _callee8);
    }));

    return function (_x5) {
      return _ref9.apply(this, arguments);
    };
  }(), []);
  useEffect(function () {
    loadContacts();
  }, [loadContacts]);
  var contextValue = {
    contacts: filteredContacts,
    unFilteredContacts: simplifiedContacts,
    searchTerm: searchTerm,
    setSearchTerm: setSearchTerm,
    verifiedFilter: verifiedFilter,
    setVerifiedFilter: setVerifiedFilter,
    reloadContacts: reloadContacts,
    deleteUnusedContacts: deleteUnusedContacts,
    deleteContact: deleteContact,
    addContact: addContact,
    updateContact: updateContact,
    resendVerification: resendVerification
  };
  return /*#__PURE__*/jsx$1(ContactsContext.Provider, {
    value: contextValue,
    children: children
  });
}

function useContacts() {
  var context = useContext(ContactsContext);

  if (!context) {
    throw new Error('useContacts must be used within a ContactsProvider');
  }

  return context;
}

var sharedCountries;
var sharedTldOptions;
var sharedFetchingCountries = false;
var sharedFetchingOptions = false;
var countriesListeners = [];
var optionsListeners = [];

function useContactDropdownData() {
  var _useState = useState([]),
      _useState2 = _slicedToArray$4(_useState, 2),
      countries = _useState2[0],
      setCountries = _useState2[1];

  var _useState3 = useState(sharedTldOptions),
      _useState4 = _slicedToArray$4(_useState3, 2),
      tldOptions = _useState4[0],
      setTldOptions = _useState4[1];

  useEffect(function () {
    if (!sharedCountries && !sharedFetchingCountries) {
      sharedFetchingCountries = true;
      api.contacts.fetchCountries().then(function (_ref) {
        var _ref2 = _slicedToArray$4(_ref, 2),
            response = _ref2[0],
            error = _ref2[1];

        if (error) toast.error(error);else {
          sharedCountries = response.map(function (e) {
            return {
              DisplayName: e._Country,
              Value: e._TwoLetterCode,
              Children: []
            };
          });

          if (sharedCountries) {
            countriesListeners.forEach(function (cb) {
              return cb(sharedCountries);
            });
          }
        }
        sharedFetchingCountries = false;
      });
    }

    if (!sharedTldOptions && !sharedFetchingOptions) {
      sharedFetchingOptions = true;
      api.contacts.fetchTLDOptions().then(function (_ref3) {
        var _ref4 = _slicedToArray$4(_ref3, 2),
            response = _ref4[0],
            error = _ref4[1];

        if (error) toast.error(error);else {
          sharedTldOptions = response;

          if (sharedTldOptions) {
            optionsListeners.forEach(function (cb) {
              return cb(sharedTldOptions);
            });
          }
        }
        sharedFetchingOptions = false;
      });
    } // register listeners


    var countriesCb = function countriesCb(data) {
      return setCountries(data);
    };

    var optionsCb = function optionsCb(data) {
      return setTldOptions(data);
    };

    countriesListeners.push(countriesCb);
    optionsListeners.push(optionsCb); // cleanup

    return function () {
      countriesListeners = countriesListeners.filter(function (cb) {
        return cb !== countriesCb;
      });
      optionsListeners = optionsListeners.filter(function (cb) {
        return cb !== optionsCb;
      });
    };
  }, []);
  return {
    countries: countries,
    tldOptions: tldOptions
  };
}

var _templateObject$v;

var _excluded$F = ["id", "text", "checked", "onChange", "checkBG"];

function ownKeys$1z(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1z(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1z(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1z(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var focus$1 = theme.focus,
    colors$n = theme.colors,
    radii = theme.radii;
var wrapperStyles = css$3(["display:inline-block;position:relative;cursor:pointer;min-height:2.6rem;min-width:2.6rem;line-height:2.6rem;> input[type='checkbox']{position:absolute;opacity:0;top:0;left:0;}> input[type='checkbox']:focus ~ label::before{color:", ";", ";}> label{padding-left:3.5rem;font-size:1.4rem;}> input[type='checkbox']:not(:checked) + svg{display:none;}"], focus$1.color, focus$1.style);
var labelStyles$1 = css$3(["cursor:pointer;vertical-align:top;display:flex;align-items:center;user-select:none;::before{background:", ";position:absolute;content:'';display:inline-block;border:1px solid ", ";border-radius:", ";height:2.4rem;width:2.4rem;left:0;top:0;bottom:0;margin:auto;}"], function (props) {
  return props.checkBG || 'transparent';
}, colors$n.greyDark, radii.small);
var defaultProps$P = {
  checkBG: 'transparent',
  checked: false,
  // className: '',
  onChange: function onChange() {}
};
var propTypes$1u = {
  checkBG: PropTypes.string,
  checked: PropTypes.bool,
  // className: PropTypes.string,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  text: PropTypes.node.isRequired
};

function Checkbox(_ref) {
  var id = _ref.id,
      text = _ref.text,
      checked = _ref.checked,
      onChange = _ref.onChange,
      checkBG = _ref.checkBG,
      rest = _objectWithoutProperties$8(_ref, _excluded$F);

  var handleInputChange = function handleInputChange(event) {
    var target = event.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    onChange({
      id: id,
      value: value
    });
  };

  return /*#__PURE__*/jsxs(_StyledBox$m, _objectSpread$1z(_objectSpread$1z({}, rest), {}, {
    children: [/*#__PURE__*/jsx$1("input", {
      checked: checked,
      id: id,
      onChange: handleInputChange,
      type: "checkbox"
    }), /*#__PURE__*/jsxs(_StyledText$o, {
      as: "label",
      checkBG: checkBG,
      htmlFor: id,
      children: [checked && /*#__PURE__*/jsx$1(Icon$2, {
        bottom: "0",
        color: "black",
        height: "2rem",
        left: "0.2rem",
        m: "auto",
        name: "checkmark",
        position: "absolute",
        title: "Chat",
        titleId: "supportChatIcon-".concat(id),
        top: "0",
        width: "2rem",
        zIndex: 1
      }), text]
    })]
  }));
}

Checkbox.defaultProps = defaultProps$P;
Checkbox.propTypes = propTypes$1u;
Checkbox.demo = true;
Checkbox.options = {
  id: {
    type: 'string',
    "default": 'checkbox-1'
  },
  text: {
    type: 'string',
    "default": 'Toggle this checkbox example'
  }
};

var _StyledBox$m = styled(Box$1)(_templateObject$v || (_templateObject$v = _taggedTemplateLiteral$1(["", ""])), wrapperStyles);

var _StyledText$o = styled(Text$1).withConfig({
  displayName: "checkbox___StyledText",
  componentId: "sc-coqxxu-0"
})(["", ""], labelStyles$1);

var _excluded$E = ["label", "name", "errors", "control", "id"];

function ownKeys$1y(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1y(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1y(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1y(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function CheckboxFormField(_ref) {
  var label = _ref.label,
      name = _ref.name,
      errors = _ref.errors,
      control = _ref.control,
      id = _ref.id,
      rest = _objectWithoutProperties$8(_ref, _excluded$E);

  var fieldError = errors ? get$4(errors, name) : undefined;
  var showError = Boolean(fieldError);
  return /*#__PURE__*/jsx$1(Controller, {
    name: name,
    control: control,
    render: function render(_ref2) {
      var field = _ref2.field;
      return /*#__PURE__*/jsx$1(Checkbox, _objectSpread$1y({
        id: id,
        checkBG: "white",
        text: label,
        color: showError ? 'destructive-400' : '',
        checked: field.value,
        onChange: function onChange(_ref3) {
          var value = _ref3.value;
          return field.onChange(value);
        }
      }, rest));
    }
  });
}

var _excluded$D = ["height", "width", "defaultValue", "onChange", "isSearchable", "isClearable", "placeholder", "options", "title", "value", "inputStyles", "menuPortalTarget", "menuPlacement", "isLoading"];

function ownKeys$1x(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1x(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1x(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1x(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var sizes$1 = redesignTheme.sizes,
    fonts$3 = redesignTheme.fonts;
var propTypes$1t = {
  height: PropTypes.number,
  isSearchable: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  placeholder: PropTypes.string,
  title: PropTypes.string,
  width: PropTypes.string,
  padding: PropTypes.string,
  isClearable: PropTypes.bool,
  inputStyles: PropTypes.any,
  isLoading: PropTypes.bool
};
var defaultProps$O = {
  height: null,
  isSearchable: true,
  placeholder: 'Choose from below...',
  title: '',
  width: sizes$1.containers.sm,
  padding: '5px',
  inputStyles: null,
  isClearable: false,
  isLoading: false
};

function RenderOption(props) {
  var data = props.data;
  var component = data.component,
      label = data.label,
      value = data.value;
  return /*#__PURE__*/jsx$1(components.Option, _objectSpread$1x(_objectSpread$1x({}, props), {}, {
    children: component || label || value
  }));
}

var baseStyles = {
  menu: function menu(provided, state) {
    return _objectSpread$1x(_objectSpread$1x({}, provided), {}, {
      width: state.selectProps.width,
      minWidth: '3rem',
      fontFamily: fonts$3.body
    });
  },
  option: function option(provided) {
    return _objectSpread$1x(_objectSpread$1x({}, provided), {}, {
      color: 'black',
      backgroundColor: 'white',
      borderBottom: 'Gainsboro 1px solid'
    });
  },
  control: function control(provided, state) {
    return _objectSpread$1x(_objectSpread$1x({}, provided), {}, {
      width: state.selectProps.width,
      borderRadius: '0%',
      borderColor: 'black',
      padding: state.selectProps.padding,
      minWidth: '3rem',
      fontFamily: fonts$3.body,
      height: state.selectProps.height,
      minHeight: state.selectProps.height + 5
    });
  },
  valueContainer: function valueContainer(provided, state) {
    return _objectSpread$1x(_objectSpread$1x({}, provided), {}, {
      height: state.selectProps.height
    });
  },
  indicatorsContainer: function indicatorsContainer(provided, state) {
    return _objectSpread$1x(_objectSpread$1x({}, provided), {}, {
      height: state.selectProps.height,
      color: 'black'
    });
  },
  indicatorSeparator: function indicatorSeparator(provided) {
    return _objectSpread$1x(_objectSpread$1x({}, provided), {}, {
      color: 'black'
    });
  },
  dropdownIndicator: function dropdownIndicator(provided) {
    return _objectSpread$1x(_objectSpread$1x({}, provided), {}, {
      color: 'black'
    });
  }
};

function Dropdown(_ref) {
  var height = _ref.height,
      width = _ref.width,
      defaultValue = _ref.defaultValue,
      onChange = _ref.onChange,
      isSearchable = _ref.isSearchable,
      isClearable = _ref.isClearable,
      placeholder = _ref.placeholder,
      options = _ref.options,
      title = _ref.title,
      value = _ref.value,
      inputStyles = _ref.inputStyles,
      menuPortalTarget = _ref.menuPortalTarget,
      menuPlacement = _ref.menuPlacement,
      isLoading = _ref.isLoading,
      rest = _objectWithoutProperties$8(_ref, _excluded$D);

  return /*#__PURE__*/jsxs(Stack$2, _objectSpread$1x(_objectSpread$1x({
    width: width
  }, rest), {}, {
    children: [title ? /*#__PURE__*/jsx$1(Heading, {
      mb: 2,
      children: title
    }) : null, /*#__PURE__*/jsx$1(Select, {
      components: {
        Option: RenderOption
      },
      isSearchable: isSearchable,
      onChange: onChange,
      options: options,
      placeholder: placeholder,
      styles: inputStyles || baseStyles,
      defaultValue: defaultValue,
      value: options[value - 1],
      width: width || sizes$1.containers.sm,
      height: height,
      isClearable: isClearable,
      isLoading: isLoading,
      menuPortalTarget: menuPortalTarget,
      menuPlacement: menuPlacement
    })]
  }));
}

Dropdown.propTypes = propTypes$1t;
Dropdown.defaultProps = defaultProps$O;
var _excluded$C = ["label", "dropDownValues", "name", "control", "width", "errors", "customOnChange"];

function ownKeys$1w(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1w(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1w(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1w(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function getDropDownOptions(options) {
  return options.map(function (opt) {
    return {
      label: opt.DisplayName,
      value: opt.Value
    };
  });
}

function DropDownFormField(props) {
  var label = props.label,
      dropDownValues = props.dropDownValues,
      name = props.name,
      control = props.control,
      _props$width = props.width,
      width = _props$width === void 0 ? '100%' : _props$width,
      errors = props.errors,
      customOnChange = props.customOnChange,
      rest = _objectWithoutProperties$8(props, _excluded$C);

  var fieldError = errors ? get$4(errors, name) : undefined;
  var showError = Boolean(fieldError);
  return /*#__PURE__*/jsxs(Stack$1, {
    mt: 3,
    mr: 3,
    children: [/*#__PURE__*/jsx$1(Box, {
      children: /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        fontWeight: "regular",
        color: "neutral-400",
        children: label
      })
    }), /*#__PURE__*/jsx$1(Controller, {
      control: control,
      name: name,
      render: function render(_ref) {
        var _fieldError$message;

        var field = _ref.field;
        var options = getDropDownOptions(dropDownValues);
        var selectedIndex = options.findIndex(function (opt) {
          return opt.value === field.value;
        }) + 1;
        return /*#__PURE__*/jsxs(Stack$1, {
          children: [/*#__PURE__*/jsx$1(Dropdown, _objectSpread$1w({
            width: width,
            style: {
              cursor: 'pointer'
            },
            padding: "0",
            options: options,
            onChange: function onChange(selected) {
              if (customOnChange) {
                customOnChange(selected);
                return;
              }

              field.onChange(selected === null || selected === void 0 ? void 0 : selected.value);
            },
            value: selectedIndex,
            menuPortalTarget: document.body,
            inputStyles: {
              menuPortal: function menuPortal(base) {
                return _objectSpread$1w(_objectSpread$1w({}, base), {}, {
                  zIndex: 9999
                });
              }
            },
            border: "none",
            borderBottom: showError ? '1px solid' : 'none',
            borderColor: showError ? 'destructive-400' : ''
          }, rest)), showError && fieldError && /*#__PURE__*/jsx$1(Box, {
            children: /*#__PURE__*/jsx$1(Text, {
              variant: "paragraph-xsmall",
              fontWeight: "regular",
              color: "destructive-400",
              children: fieldError === null || fieldError === void 0 ? void 0 : (_fieldError$message = fieldError.message) === null || _fieldError$message === void 0 ? void 0 : _fieldError$message.toString()
            })
          })]
        });
      }
    })]
  });
}

var _excluded$B = ["label", "errors", "formRegister", "width"];

function ownKeys$1v(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1v(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1v(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1v(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function InputFormField(_ref) {
  var _fieldError$message;

  var label = _ref.label,
      errors = _ref.errors,
      formRegister = _ref.formRegister,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      rest = _objectWithoutProperties$8(_ref, _excluded$B);

  var fieldName = formRegister.name;
  var fieldError = errors ? get$4(errors, fieldName) : undefined;
  var showError = Boolean(fieldError);
  return /*#__PURE__*/jsxs(Stack$1, {
    width: width,
    mt: 3,
    mr: 3,
    children: [/*#__PURE__*/jsxs(Stack$1, {
      borderBottom: "1px solid",
      borderColor: showError ? 'destructive-400' : 'neutral-200',
      children: [/*#__PURE__*/jsx$1(Box, {
        children: /*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-xsmall",
          fontWeight: "regular",
          color: "neutral-400",
          children: label
        })
      }), /*#__PURE__*/jsx$1(Input$3, _objectSpread$1v(_objectSpread$1v({}, formRegister), {}, {
        style: {
          outline: 'none'
        },
        padding: "3px",
        border: "none"
      }, rest))]
    }), showError && fieldError && /*#__PURE__*/jsx$1(Box, {
      children: /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        fontWeight: "regular",
        color: "destructive-400",
        children: fieldError === null || fieldError === void 0 ? void 0 : (_fieldError$message = fieldError.message) === null || _fieldError$message === void 0 ? void 0 : _fieldError$message.toString()
      })
    })]
  });
}

function optionalTouchedObject(schema) {
  return preprocessType(function (val) {
    return val && _typeof$2(val) === 'object' && Object.values(val).some(function (v) {
      return v !== '' && v !== undefined;
    }) ? val : undefined;
  }, schema).optional();
}

var addressSchema = objectType({
  apartment: stringType().optional(),
  streetNumber: stringType().nonempty('Street number is required'),
  streetName: stringType().nonempty('Street name is required'),
  streetType: stringType().nonempty('Street type is required'),
  city: stringType().nonempty('City is required'),
  province: stringType().nonempty('Province is required'),
  countryCode: stringType().nonempty('Country code is required'),
  countryName: stringType().nonempty('Country name is required'),
  postalCode: stringType().nonempty('Postal code is required')
});
var ciraExtraInfoSchema = optionalTouchedObject(objectType({
  CPRCategory: stringType().nonempty('CPR Category is required'),
  CPRChildrenCategory: stringType().optional(),
  Company: stringType().optional(),
  Language: stringType().nonempty('Language is required'),
  WhoisDisplaySetting: booleanType()["default"](false).optional(),
  AgreementValue: booleanType({
    required_error: 'You must agree to the terms and conditions',
    invalid_type_error: 'You must agree to the terms and conditions'
  })["default"](false).refine(function (val) {
    return val === true;
  }, {
    message: 'You must agree to the terms and conditions'
  })
}).superRefine(function (data, ctx) {
  var _data$CPRChildrenCate, _data$Company;

  if (data.CPRCategory === 'RES' && !((_data$CPRChildrenCate = data.CPRChildrenCategory) !== null && _data$CPRChildrenCate !== void 0 && _data$CPRChildrenCate.trim())) {
    ctx.addIssue({
      path: ['CPRChildrenCategory'],
      code: ZodIssueCode.custom,
      message: 'Other type is required when registrant type is "other".'
    });
  }

  if (data.CPRCategory === 'CCO' && !((_data$Company = data.Company) !== null && _data$Company !== void 0 && _data$Company.trim())) {
    ctx.addIssue({
      path: ['Company'],
      code: ZodIssueCode.custom,
      message: 'Company is required when CPRCategory is "corporation".'
    });
  }
}));
var nexusExtraInfoSchema = optionalTouchedObject(objectType({
  Purpose: stringType().nonempty('Purpose is required'),
  Category: stringType().nonempty('Category is required'),
  CountryCodeId: numberType()
}));
var cEDExtraInfoSchema = optionalTouchedObject(objectType({
  IdNumber: stringType().nonempty('Id Number is required'),
  FormType: stringType().nonempty('Form Type is required'),
  FormTypeOther: stringType().optional(),
  LegalEntityType: stringType().nonempty('Legal Entity Type is required'),
  LegalEntityTypeOther: stringType().optional()
}).superRefine(function (data, ctx) {
  var _data$FormTypeOther, _data$LegalEntityType;

  if (data.FormType === 'Other' && !((_data$FormTypeOther = data.FormTypeOther) !== null && _data$FormTypeOther !== void 0 && _data$FormTypeOther.trim())) {
    ctx.addIssue({
      path: ['FormTypeOther'],
      code: ZodIssueCode.custom,
      message: 'FormTypeOther is required when FormType is "Other".'
    });
  }

  if (data.LegalEntityType === 'Other' && !((_data$LegalEntityType = data.LegalEntityTypeOther) !== null && _data$LegalEntityType !== void 0 && _data$LegalEntityType.trim())) {
    ctx.addIssue({
      path: ['LegalEntityTypeOther'],
      code: ZodIssueCode.custom,
      message: 'LegalEntityTypeOther is required when LegalEntityType is "Other".'
    });
  }
}));
var membershipExtraInfoSchema = optionalTouchedObject(objectType({
  MembershipId: stringType().nonempty('Membership ID is required')
}));
var lAWExtraInfoSchema = optionalTouchedObject(objectType({
  AccreditationId: stringType().nonempty('Accreditation ID is required'),
  AccreditationYear: numberType(),
  AccreditationCountryId: numberType(),
  JurisdictionSP: stringType().nonempty('Jurisdiction SP is required'),
  AccreditationBody: stringType().nonempty('Accreditation Body is required')
}));
var aUExtraInfoSchema = optionalTouchedObject(objectType({
  AcceptanceAgreement: booleanType()["default"](false),
  RegistrantName: stringType().nonempty('Registrant Name is required'),
  RegistrantID: stringType().nonempty('Registrant ID is required'),
  RegistrantIDType: stringType().nonempty('Registrant ID Type is required'),
  EligibilityName: stringType().nonempty('Eligibility Name is required'),
  EligibilityID: stringType().nonempty('Eligibility ID is required'),
  EligibilityIDType: stringType().nonempty('Eligibility ID Type is required'),
  AuEligibilityType: stringType().nonempty('AU Eligibility Type is required'),
  AuToken: stringType().nonempty('AU Token is required'),
  AuTokenMembership: stringType().nonempty('AU Token Membership is required')
}));
var extraInfoSchema = objectType({
  CiraExtraInfo: ciraExtraInfoSchema.optional(),
  NexusExtraInfo: nexusExtraInfoSchema.optional(),
  CEDExtraInfo: cEDExtraInfoSchema.optional(),
  MembershipExtraInfo: membershipExtraInfoSchema.optional(),
  LAWExtraInfo: lAWExtraInfoSchema.optional(),
  AUExtraInfo: aUExtraInfoSchema.optional()
});
var contactDetailsSchema = objectType({
  id: numberType().optional(),
  company: stringType().optional(),
  firstName: stringType().nonempty('First name is required'),
  lastName: stringType().nonempty('Last name is required'),
  address: addressSchema,
  phone: stringType().nonempty('Phone number is required'),
  email: stringType().email('Must be a valid email address'),
  consent: booleanType()["default"](false),
  extraInfo: extraInfoSchema.optional()
});

function DomainsList$1(_ref) {
  var domains = _ref.domains;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Grid, {
      gridTemplateColumns: "1fr",
      alignItems: "center",
      p: "24px 16px",
      backgroundColor: "neutral-100",
      gap: 4,
      fontWeight: "medium",
      style: {
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'anywhere'
      },
      children: /*#__PURE__*/jsx$1(Text, {
        children: "Domain Name"
      })
    }), /*#__PURE__*/jsx$1(Stack$1, {
      style: {
        maxHeight: '400px',
        overflowY: 'auto',
        scrollBehavior: 'smooth'
      },
      tabIndex: -1,
      children: domains.sort().map(function (domain) {
        return /*#__PURE__*/jsx$1(Grid, {
          gridTemplateColumns: "1fr",
          alignItems: "center",
          p: "24px 16px",
          borderBottom: "1px solid",
          borderColor: "neutral-200",
          gap: 4,
          fontWeight: "medium",
          style: {
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            overflowWrap: 'anywhere'
          },
          children: /*#__PURE__*/jsx$1(Text, {
            children: domain
          })
        });
      })
    })]
  });
}

function ExtraInfoCard(_ref) {
  var title = _ref.title,
      details = _ref.details,
      clickEvent = _ref.clickEvent,
      hasError = _ref.hasError;
  return /*#__PURE__*/jsxs(Box, {
    onClick: clickEvent,
    style: {
      cursor: 'pointer'
    },
    padding: "24px",
    gap: 4,
    border: "1px solid",
    borderColor: hasError ? 'destructive-400' : 'neutral-200',
    borderRadius: "base",
    fontWeight: "bold",
    maxWidth: "350px",
    children: [/*#__PURE__*/jsxs(Stack$1, {
      children: [/*#__PURE__*/jsx$1(Text, {
        children: title
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        fontWeight: "regular",
        color: "neutral-400",
        mt: 3,
        children: details
      })]
    }), /*#__PURE__*/jsx$1(Button, {
      variant: "minimal",
      alignItems: "center",
      children: /*#__PURE__*/jsx$1(ArrowRight, {})
    })]
  });
}

function isExtraInfoSectionInvalid(schema, data) {
  var result = schema.safeParse(data);
  return !result.success;
}

function ExtraInfo(_ref) {
  var _formValues$extraInfo, _formValues$extraInfo2, _formValues$extraInfo3, _formValues$extraInfo4, _formValues$extraInfo5;

  var setView = _ref.setView,
      showAUInfo = _ref.showAUInfo,
      formValues = _ref.formValues;
  var fieldErrors = {
    cira: isExtraInfoSectionInvalid(ciraExtraInfoSchema, formValues === null || formValues === void 0 ? void 0 : (_formValues$extraInfo = formValues.extraInfo) === null || _formValues$extraInfo === void 0 ? void 0 : _formValues$extraInfo.CiraExtraInfo),
    nexus: isExtraInfoSectionInvalid(nexusExtraInfoSchema, formValues === null || formValues === void 0 ? void 0 : (_formValues$extraInfo2 = formValues.extraInfo) === null || _formValues$extraInfo2 === void 0 ? void 0 : _formValues$extraInfo2.NexusExtraInfo),
    ced: isExtraInfoSectionInvalid(cEDExtraInfoSchema, formValues === null || formValues === void 0 ? void 0 : (_formValues$extraInfo3 = formValues.extraInfo) === null || _formValues$extraInfo3 === void 0 ? void 0 : _formValues$extraInfo3.CEDExtraInfo),
    membership: isExtraInfoSectionInvalid(membershipExtraInfoSchema, formValues === null || formValues === void 0 ? void 0 : (_formValues$extraInfo4 = formValues.extraInfo) === null || _formValues$extraInfo4 === void 0 ? void 0 : _formValues$extraInfo4.MembershipExtraInfo),
    law: isExtraInfoSectionInvalid(lAWExtraInfoSchema, formValues === null || formValues === void 0 ? void 0 : (_formValues$extraInfo5 = formValues.extraInfo) === null || _formValues$extraInfo5 === void 0 ? void 0 : _formValues$extraInfo5.LAWExtraInfo)
  };
  return /*#__PURE__*/jsxs(Grid, {
    mt: 3,
    gridTemplateColumns: ['repeat(2, 1fr)'],
    gap: 3,
    children: [/*#__PURE__*/jsx$1(ExtraInfoCard, {
      title: ".CA Information",
      details: "required for registering .CA domains",
      clickEvent: function clickEvent() {
        setView('CA');
      },
      hasError: fieldErrors.cira
    }), /*#__PURE__*/jsx$1(ExtraInfoCard, {
      title: ".US Information",
      details: "required for registering .US domains",
      clickEvent: function clickEvent() {
        setView('US');
      },
      hasError: fieldErrors.nexus
    }), /*#__PURE__*/jsx$1(ExtraInfoCard, {
      title: ".ASIA Information",
      details: "required for registering .ASIA domains",
      clickEvent: function clickEvent() {
        setView('ASIA');
      },
      hasError: fieldErrors.ced
    }), /*#__PURE__*/jsx$1(ExtraInfoCard, {
      title: ".XXX Information",
      details: "required for registering .XXX domains",
      clickEvent: function clickEvent() {
        setView('XXX');
      },
      hasError: fieldErrors.membership
    }), /*#__PURE__*/jsx$1(ExtraInfoCard, {
      title: ".LAW Information",
      details: "required for registering .LAW domains",
      clickEvent: function clickEvent() {
        setView('LAW');
      },
      hasError: fieldErrors.law
    }), showAUInfo && /*#__PURE__*/jsx$1(ExtraInfoCard, {
      title: ".AU Information",
      details: "required for registering .AU domains",
      clickEvent: function clickEvent() {
        setView('AU');
      },
      hasError: false
    })]
  });
}

var Contacts = {
  internic: {
    learnMore: {
      ca: 'https://support.internic.ca/hc/en-us/articles/229945288-What-information-is-required-when-registering-a-CA-domain',
      xxx: 'https://support.internic.ca/hc/en-us/articles/229601787-Who-can-register-a-XXX-domain-What-happens-when-I-am-verified-as-a-member-of-the-XXX-sponsored-community',
      us: 'https://support.internic.ca/hc/en-us/articles/229946448-Who-is-allowed-to-register-US-domains',
      asia: 'https://support.internic.ca',
      law: 'https://support.internic.ca/hc/en-us/articles/360003462334-About-law-domains'
    }
  },
  rebel: {
    learnMore: {
      ca: 'https://support.rebel.com/hc/en-us/articles/227886127-What-information-is-required-when-registering-a-CA-domain',
      xxx: 'https://support.rebel.com/hc/en-us/articles/228072288-Who-can-register-a-XXX-domain-What-happens-when-I-am-verified-as-a-member-of-the-XXX-sponsored-community',
      us: 'https://support.rebel.com/hc/en-us/articles/227880947-Who-is-allowed-to-register-US-domains-',
      asia: 'https://support.rebel.com/hc/en-us/articles/227880647-What-is-required-to-register-names-under-the-ASIA-TLD',
      law: 'https://support.rebel.com/hc/en-us/articles/360003461774-About-LAW-domains',
      au: 'https://support.rebel.com/hc/en-us/articles/4492251998619'
    }
  },
  terms: {
    ca: 'https://cira.ca/registrant-agreement'
  }
};

var Config = /*#__PURE__*/function () {
  function Config() {
    _classCallCheck$a(this, Config);
  }

  return _createClass$a(Config, null, [{
    key: "host",
    get: function get() {
      return window.configs ? window.configs.host : null;
    }
  }, {
    key: "brand",
    get: function get() {
      return isInternic ? 'internic' : 'rebel';
    }
  }, {
    key: "contacts",
    get: function get() {
      var brand = Config.brand;
      return {
        kb: {
          ca: Contacts[brand].learnMore.ca,
          xxx: Contacts[brand].learnMore.xxx,
          asia: Contacts[brand].learnMore.asia,
          us: Contacts[brand].learnMore.us,
          law: Contacts[brand].learnMore.law,
          au: Contacts[brand].learnMore.au
        },
        terms: {
          ca: Contacts.terms.ca
        }
      };
    }
  }]);
}();

function ASIAExtraInfo(_ref) {
  var dropDownValues = _ref.dropDownValues,
      register = _ref.register,
      control = _ref.control,
      errors = _ref.errors;
  var selectedFormType = useWatch({
    control: control,
    name: 'extraInfo.CEDExtraInfo.FormType'
  });
  var selectedLegalEntityType = useWatch({
    control: control,
    name: 'extraInfo.CEDExtraInfo.LegalEntityType'
  });
  return /*#__PURE__*/jsxs(Stack$1, {
    gap: 3,
    width: "663px",
    children: [/*#__PURE__*/jsxs(Text, {
      mt: 3,
      children: ["Contacts Associated to .ASIA domains require additional information.", ' ', /*#__PURE__*/jsx$1("a", {
        target: "_blank",
        href: Config.contacts.kb.asia,
        rel: "noreferrer",
        children: "Learn More"
      })]
    }), /*#__PURE__*/jsx$1(DropDownFormField, {
      label: "CED Type of Legal Entity",
      name: "extraInfo.CEDExtraInfo.LegalEntityType",
      errors: errors,
      dropDownValues: dropDownValues.LegalEntityType,
      control: control
    }), selectedLegalEntityType === 'Other' && /*#__PURE__*/jsx$1(InputFormField, {
      label: "Other Legal Entity",
      formRegister: register('extraInfo.CEDExtraInfo.LegalEntityTypeOther'),
      errors: errors
    }), /*#__PURE__*/jsx$1(DropDownFormField, {
      label: "CED Form of Identification",
      name: "extraInfo.CEDExtraInfo.FormType",
      errors: errors,
      dropDownValues: dropDownValues.FormType,
      control: control
    }), selectedFormType === 'Other' && /*#__PURE__*/jsx$1(InputFormField, {
      label: "Other Form Type",
      formRegister: register('extraInfo.CEDExtraInfo.FormTypeOther'),
      errors: errors
    }), /*#__PURE__*/jsx$1(InputFormField, {
      label: "CED Identification Number",
      formRegister: register('extraInfo.CEDExtraInfo.IdNumber'),
      errors: errors
    })]
  });
}

var strings$5 = {
  cancel: 'Cancel',
  clear: 'Clear',
  chooseContact: 'Choose contact',
  userHeader: 'Contact Information',
  email: 'Email',
  emailRequired: 'Email is required',
  aptNumber: 'apt #',
  city: 'City',
  cityRequired: 'City is required',
  country: 'Country',
  countryRequired: 'Country is required',
  stateProvince: 'State / Province',
  stateProvinceRequired: 'State / Province is required',
  streetAddress: 'Street address',
  streetAddressRequired: 'Street address is required',
  zipPostal: 'Zip / Postal Code',
  zipPostalRequired: 'Zip / Postal code is required',
  firstName: 'First name',
  firstNameRequired: 'First name is required',
  lastName: 'Last name',
  lastNameRequired: 'Last name is required',
  phone: 'Phone number',
  phoneRequired: 'Phone number is required',
  ext: 'ext',
  optional: '(optional)',
  addressLookup: 'Address lookup',
  "continue": 'Continue',
  summaryContactName: 'Name',
  summaryPhone: 'Phone',
  summaryAddress: 'Address',
  contactNeedsUpdating: 'There is a problem with this contact. You can update your contact in your {{link}}, choose another contact or create a new one.',
  contactAddingError: 'There was a problem adding your contact. Please try again or contact customer support.',
  contactNeedsUpdatingLink: 'Contact Manager',
  caExtraInfo: '.CA Information',
  summary: {
    ca: {
      registerAs: 'Registered as',
      communicate: 'Communicate in',
      privacy: 'Privacy'
    }
  },
  ca: {
    registerAs: 'i am registering as',
    registerAsView: 'registered as',
    other: 'select other',
    otherView: 'Other Subtype',
    language: 'I communicate in',
    languageView: 'communication language',
    header: '.CA Information',
    note: 'Contacts associated to .CA domains require additional information.',
    faqLink: 'Learn more',
    terms: 'Terms and conditions of the CIRA Registrant Agreement',
    company: 'Company',
    companyReq: 'Company name is required',
    invalidCompanyName: 'Company name is invalid',
    companyReqPrefix: '*Click ',
    companyReqLink: 'here',
    companyReqSuffix: ' for the complete Company requirement information.',
    companyReqLinkTitle: 'Company Requirements',
    makeInfoPublic: 'Make my info public',
    infoPublicView: 'My info is not private.',
    infoPrivateView: 'My info is private.'
  },
  law: {
    header: '.Law Information',
    accId: 'Accreditation ID',
    accBody: 'Accreditation Body',
    accYear: 'Accreditation Year',
    jurisdiction: 'Jurisdiction',
    country: 'Country'
  },
  xxx: {
    membershipId: 'Membership ID'
  },
  asia: {
    legalEntity: 'CED Type of Legal Entity',
    formId: 'CED Form of Identification',
    idNum: 'CED Identification Number'
  },
  us: {
    category: 'Category',
    header: '.US Information',
    purpose: 'Purpose',
    country: 'Country'
  },
  au: {
    AuEligibilityType: 'Registration Category',
    AuEligibilityTypeRequired: 'Registration Category Required',
    CompanyName: 'Company Name',
    CompanyNameRequired: 'Company Name Required',
    CompanyID: 'Company ID',
    CompanyIDRequired: 'Company ID Required',
    AcceptanceAgreement: 'Acceptance Agreement',
    AcceptanceAgreementRequired: 'Acceptance Agreement Required',
    BusinessIDType: 'Business ID Type',
    BusinessOwner: 'Business Owner',
    BusinessOwnerRequired: 'Business Owner Required',
    ID: 'ID',
    IDType: 'ID Type',
    IDRequired: 'ID Required',
    BusinessName: 'Business Name',
    BusinessNameRequired: 'Business Name Required',
    BusinessID: 'Business ID',
    BusinessIDRequired: 'Business ID Required',
    SoleTraderName: 'Sole Trader Name',
    SoleTraderNameRequired: 'Sole Trader Name Required',
    PartnerName: 'Partner Name',
    PartnerNameRequired: 'Partner Name Required',
    PartnershipName: 'Partnership Name',
    PartnershipNameRequired: 'Partnership Name Required',
    TrademarkOwner: 'Trademark Owner',
    TrademarkOwnerRequired: 'Trademark Owner Required',
    TrademarkName: 'Trademark Name',
    TrademarkNameRequired: 'Trademark Name Required',
    TrademarkNumber: 'Trademark Number',
    TrademarkIDType: 'Trademark ID Type',
    TrademarkNumberRequired: 'Trademark Number Required',
    PendingTrademarkName: 'Pending Trademark Name',
    PendingTrademarkNameRequired: 'Pending Trademark Name Required',
    Name: 'Name',
    NameRequired: 'Name Required',
    AssociationName: 'Association Name',
    AssociationNameRequired: 'Association Name Required',
    ClubName: 'Club Name',
    ClubNameRequired: 'Club Name Required',
    OrganizationName: 'Organization Name',
    OrganizationNameRequired: 'Organization Name Required',
    CharityName: 'Charity Name',
    CharityNameRequired: 'Charity Name Required',
    OrganizationNumber: 'Organization Number',
    OrganizationNumberRequired: 'Organization Number Required',
    StatutoryBody: 'Statutory Body',
    StatutoryBodyRequired: 'Statutory Body Required',
    PartyName: 'Party Name',
    PartyNameRequired: 'Party Name Required'
  }
};

function AUExtraInfo(_ref) {
  var dropDownValues = _ref.dropDownValues,
      register = _ref.register,
      control = _ref.control;

  var _useState = useState({
    RegistrantNameLabel: '',
    RegistrantIDLabel: '',
    RegistrantIDTypeLabel: '',
    EligibilityNameLabel: '',
    EligibilityIDLabel: '',
    EligibilityIDTypeLabel: '',
    AuEligibilityTypeLabel: ''
  }),
      _useState2 = _slicedToArray$4(_useState, 2),
      requiredExtraInfoLabels = _useState2[0],
      setrequiredExtraInfoLabels = _useState2[1];

  var toggleFieldsForCategory = function toggleFieldsForCategory(value) {
    var _extraInfoRequired$0$, _extraInfoRequired$;

    var extraInfoRequired = dropDownValues.RegistrationCategories.filter(function (x) {
      return x.Value === value;
    }).map(function (x) {
      return {
        display: x.DisplayName,
        value: x.Value,
        children: x.Children
      };
    });
    var requiredChildren = (_extraInfoRequired$0$ = (_extraInfoRequired$ = extraInfoRequired[0]) === null || _extraInfoRequired$ === void 0 ? void 0 : _extraInfoRequired$.children) !== null && _extraInfoRequired$0$ !== void 0 ? _extraInfoRequired$0$ : [];
    var labels = {
      RegistrantNameLabel: '',
      RegistrantIDLabel: '',
      RegistrantIDTypeLabel: '',
      EligibilityNameLabel: '',
      EligibilityIDLabel: '',
      EligibilityIDTypeLabel: '',
      AuEligibilityTypeLabel: ''
    };
    requiredChildren.forEach(function (child) {
      switch (child.Value) {
        case 'BusinessName':
        case 'PartnershipName':
        case 'TrademarkName':
        case 'PendingTrademarkName':
        case 'ClubName':
          labels.EligibilityNameLabel = strings$5.au[child.Value];
          break;

        case 'TrademarkNumber':
        case 'BusinessID':
          labels.EligibilityIDLabel = strings$5.au[child.Value];
          break;

        case 'TrademarkIDType':
        case 'BusinessIDType':
          labels.EligibilityIDTypeLabel = strings$5.au[child.Value];
          break;

        case 'CompanyName':
        case 'BusinessOwner':
        case 'SoleTraderName':
        case 'PartnerName':
        case 'TrademarkOwner':
        case 'Name':
        case 'AssociationName':
        case 'OrganizationName':
        case 'CharityName':
        case 'StatutoryBody':
        case 'PartyName':
          labels.RegistrantNameLabel = strings$5.au[child.Value];
          break;

        case 'ID':
        case 'CompanyID':
        case 'OrganizationNumber':
          labels.RegistrantIDLabel = strings$5.au[child.Value];
          break;

        case 'IDType':
          labels.RegistrantIDTypeLabel = strings$5.au[child.Value];
          break;
      }
    });
    setrequiredExtraInfoLabels(labels); // setrequiredExtraInfo(requiredChildren)
  };

  var selectedAuEligibilityType = useWatch({
    control: control,
    name: 'extraInfo.AUExtraInfo.AuEligibilityType'
  });
  useEffect(function () {
    if (selectedAuEligibilityType) {
      toggleFieldsForCategory(selectedAuEligibilityType);
    }
  }, [selectedAuEligibilityType]);
  return /*#__PURE__*/jsxs(Stack$1, {
    gap: 3,
    width: "663px",
    children: [/*#__PURE__*/jsxs(Text, {
      mt: 3,
      children: ["Contacts Associated to .AU domains require additional information.", ' ', /*#__PURE__*/jsx$1("a", {
        target: "_blank",
        href: Config.contacts.kb.au,
        rel: "noreferrer",
        children: "Learn More"
      })]
    }), /*#__PURE__*/jsx$1(DropDownFormField, {
      label: "Restriction Category",
      name: "extraInfo.AUExtraInfo.AuEligibilityType",
      dropDownValues: dropDownValues.RegistrationCategories,
      control: control
    }), requiredExtraInfoLabels.RegistrantNameLabel && /*#__PURE__*/jsx$1(InputFormField, {
      label: requiredExtraInfoLabels.RegistrantNameLabel,
      formRegister: register('extraInfo.AUExtraInfo.RegistrantName')
    }), requiredExtraInfoLabels.RegistrantIDLabel && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx$1(DropDownFormField, {
        label: requiredExtraInfoLabels.RegistrantIDTypeLabel,
        name: "extraInfo.AUExtraInfo.RegistrantIDType",
        dropDownValues: dropDownValues.AuEligibilityIDType,
        control: control
      }), /*#__PURE__*/jsx$1(InputFormField, {
        label: requiredExtraInfoLabels.RegistrantIDLabel,
        formRegister: register('extraInfo.AUExtraInfo.EligibilityID')
      })]
    }), requiredExtraInfoLabels.EligibilityNameLabel && /*#__PURE__*/jsx$1(InputFormField, {
      label: requiredExtraInfoLabels.EligibilityNameLabel,
      formRegister: register('extraInfo.AUExtraInfo.EligibilityName')
    }), requiredExtraInfoLabels.EligibilityIDTypeLabel && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx$1(DropDownFormField, {
        label: requiredExtraInfoLabels.EligibilityIDTypeLabel,
        name: "extraInfo.AUExtraInfo.EligibilityIDType",
        dropDownValues: dropDownValues.AuEligibilityIDType,
        control: control
      }), /*#__PURE__*/jsx$1(InputFormField, {
        label: requiredExtraInfoLabels.EligibilityIDLabel,
        formRegister: register('extraInfo.AUExtraInfo.EligibilityID')
      })]
    }), /*#__PURE__*/jsx$1(CheckboxFormField, {
      name: "extraInfo.AUExtraInfo.AcceptanceAgreement",
      label: "By submitting this application, you represent and warrant that: (a) all information provided to register or renew the domain name (including all supporting documents, if any) are true, complete and correct, and are not misleading in any way, and the application is made in good faith; (b) you meet, and will continue to meet, the eligibility criteria prescribed in auDA Published Policies for the domain name for the duration of the domain name license; (c) you have not previously submitted an application for the domain name with another registrar using the same eligibility criteria, and the other registrar has rejected the application; (d) you acknowledge and agree that even if the domain name is accepted for registration, your entitlement to register the domain name may be challenged by others who claim to have an entitlement to the domain name; and (e) you acknowledge and agree that auDA or the registrar can cancel the registration of the domain name if any of the warranties set forth above are found to be untrue, incomplete, incorrect or misleading.",
      id: "extraInfo.AUExtraInfo.AcceptanceAgreement",
      control: control
    })]
  });
}

function CAExtraInfo(_ref) {
  var _dropDownValues$CPRCa;

  var dropDownValues = _ref.dropDownValues,
      register = _ref.register,
      control = _ref.control,
      errors = _ref.errors;
  var selectedRegistrantType = useWatch({
    control: control,
    name: 'extraInfo.CiraExtraInfo.CPRCategory'
  });
  var languageDropDownValues = [{
    DisplayName: 'English',
    Value: 'en',
    Children: []
  }, {
    DisplayName: 'Français',
    Value: 'fr',
    Children: []
  }];
  return /*#__PURE__*/jsxs(Stack$1, {
    gap: 3,
    width: "663px",
    children: [/*#__PURE__*/jsxs(Text, {
      mt: 3,
      children: ["Contacts Associated to .CA domains require additional information.", ' ', /*#__PURE__*/jsx$1("a", {
        target: "_blank",
        rel: "noreferrer",
        href: Config.contacts.kb.ca,
        children: "Learn More"
      })]
    }), /*#__PURE__*/jsx$1(DropDownFormField, {
      label: "I am registering as a",
      dropDownValues: dropDownValues.CPRCategory,
      errors: errors,
      name: "extraInfo.CiraExtraInfo.CPRCategory",
      control: control
    }), selectedRegistrantType === 'RES' && /*#__PURE__*/jsx$1(DropDownFormField, {
      label: "Other Type",
      errors: errors,
      dropDownValues: ((_dropDownValues$CPRCa = dropDownValues.CPRCategory.find(function (item) {
        return item.Value === 'RES';
      })) === null || _dropDownValues$CPRCa === void 0 ? void 0 : _dropDownValues$CPRCa.Children) || [],
      name: "extraInfo.CiraExtraInfo.CPRChildrenCategory",
      control: control
    }), selectedRegistrantType === 'CCO' && /*#__PURE__*/jsx$1(InputFormField, {
      label: "Company",
      errors: errors,
      formRegister: register('extraInfo.CiraExtraInfo.Company')
    }), /*#__PURE__*/jsx$1(DropDownFormField, {
      label: "I communicate in",
      errors: errors,
      defaultValue: {
        label: 'English',
        value: 'en'
      },
      dropDownValues: languageDropDownValues,
      name: "extraInfo.CiraExtraInfo.Language",
      control: control
    }), /*#__PURE__*/jsx$1("a", {
      target: "_blank",
      rel: "noreferrer",
      href: Config.contacts.terms.ca,
      children: "Terms and conditions of the CIRA Registrant Agreement"
    }), /*#__PURE__*/jsx$1(CheckboxFormField, {
      name: "extraInfo.CiraExtraInfo.AgreementValue",
      errors: errors,
      label: "I have read and agree to the terms and conditions of the Registrant Agreement.",
      id: "extraInfo.CiraExtraInfo.AgreementValue",
      control: control
    }), selectedRegistrantType !== 'CCO' && /*#__PURE__*/jsx$1(CheckboxFormField, {
      name: "extraInfo.CiraExtraInfo.WhoisDisplaySetting",
      errors: errors,
      label: "Make it Public",
      id: "extraInfo.CiraExtraInfo.WhoisDisplaySetting",
      control: control
    })]
  });
}

function LAWExtraInfo(_ref) {
  var dropDownValues = _ref.dropDownValues,
      register = _ref.register,
      control = _ref.control,
      errors = _ref.errors;
  return /*#__PURE__*/jsxs(Stack$1, {
    gap: 3,
    width: "663px",
    children: [/*#__PURE__*/jsxs(Text, {
      mt: 3,
      children: ["Contacts Associated to .LAW domains require additional information.", ' ', /*#__PURE__*/jsx$1("a", {
        target: "_blank",
        href: Config.contacts.kb.law,
        rel: "noreferrer",
        children: "Learn More"
      })]
    }), /*#__PURE__*/jsx$1(InputFormField, {
      label: "Accreditation Id",
      errors: errors,
      formRegister: register('extraInfo.LAWExtraInfo.AccreditationId')
    }), /*#__PURE__*/jsx$1(InputFormField, {
      label: "Accreditation Body",
      errors: errors,
      formRegister: register('extraInfo.LAWExtraInfo.AccreditationBody')
    }), /*#__PURE__*/jsx$1(InputFormField, {
      label: "Accreditation Year",
      errors: errors,
      formRegister: register('extraInfo.LAWExtraInfo.AccreditationYear')
    }), /*#__PURE__*/jsx$1(InputFormField, {
      label: "Jurisdiction",
      errors: errors,
      formRegister: register('extraInfo.LAWExtraInfo.JurisdictionSP')
    }), /*#__PURE__*/jsx$1(DropDownFormField, {
      label: "Country*",
      direction: "top",
      errors: errors,
      name: "extraInfo.LAWExtraInfo.AccreditationCountryId",
      dropDownValues: dropDownValues.CountryCodeId,
      control: control
    })]
  });
}

function USExtraInfo(_ref) {
  var dropDownValues = _ref.dropDownValues,
      control = _ref.control,
      errors = _ref.errors;
  var selectedCategory = useWatch({
    control: control,
    name: 'extraInfo.NexusExtraInfo.Category'
  });
  return /*#__PURE__*/jsxs(Stack$1, {
    gap: 3,
    width: "663px",
    children: [/*#__PURE__*/jsxs(Text, {
      mt: 3,
      children: ["Contacts Associated to .US domains require additional information.", ' ', /*#__PURE__*/jsx$1("a", {
        target: "_blank",
        href: Config.contacts.kb.us,
        rel: "noreferrer",
        children: "Learn More"
      })]
    }), /*#__PURE__*/jsx$1(DropDownFormField, {
      label: "Category",
      errors: errors,
      dropDownValues: dropDownValues.Category,
      name: "extraInfo.NexusExtraInfo.Category",
      control: control
    }), (selectedCategory === 'C31' || selectedCategory === 'C32') && /*#__PURE__*/jsx$1(DropDownFormField, {
      label: "Country",
      errors: errors,
      menuPlacement: "top",
      dropDownValues: dropDownValues.CountryCodeId,
      name: "extraInfo.NexusExtraInfo.CountryCodeId",
      control: control
    }), /*#__PURE__*/jsx$1(DropDownFormField, {
      label: "Purpose",
      errors: errors,
      menuPlacement: "top",
      dropDownValues: dropDownValues.Purpose,
      name: "extraInfo.NexusExtraInfo.Purpose",
      control: control
    })]
  });
}

function XXXExtraInfo(_ref) {
  var register = _ref.register,
      errors = _ref.errors;
  return /*#__PURE__*/jsxs(Stack$1, {
    gap: 3,
    width: "663px",
    children: [/*#__PURE__*/jsxs(Text, {
      mt: 3,
      children: ["Contacts Associated to .XXX domains require additional information.", ' ', /*#__PURE__*/jsx$1("a", {
        target: "_blank",
        href: Config.contacts.kb.xxx,
        rel: "noreferrer",
        children: "Learn More"
      })]
    }), /*#__PURE__*/jsx$1(InputFormField, {
      label: "Membership Id",
      formRegister: register('extraInfo.MembershipExtraInfo.MembershipId'),
      errors: errors
    })]
  });
}

function _regenerator$19() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$19(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$19(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$19(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$19(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$19(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$19(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$19(u), _regeneratorDefine2$19(u, o, "Generator"), _regeneratorDefine2$19(u, n, function () {
    return this;
  }), _regeneratorDefine2$19(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$19 = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$19(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$19 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$19(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$19(e, r, n, t);
}

function ContactModal(_ref) {
  var _contact$extraInfo, _contact$extraInfo$AU, _contact$domains;

  var contact = _ref.contact,
      isOpen = _ref.isOpen,
      setIsOpen = _ref.setIsOpen;

  var _useState = useState(),
      _useState2 = _slicedToArray$4(_useState, 2),
      view = _useState2[0],
      setView = _useState2[1];

  var _useContactDropdownDa = useContactDropdownData(),
      countries = _useContactDropdownDa.countries,
      tldOptions = _useContactDropdownDa.tldOptions;

  var form = useForm({
    resolver: zodResolver(contactDetailsSchema),
    defaultValues: contact !== null && contact !== void 0 ? contact : {
      address: {
        countryCode: 'CA',
        countryName: 'Canada'
      }
    }
  });
  var control = form.control;
  var register = form.register,
      handleSubmit = form.handleSubmit,
      setValue = form.setValue,
      reset = form.reset,
      getValues = form.getValues,
      errors = form.formState.errors;
  useEffect(function () {
    if (contact) {
      reset(contact);
    }
  }, [contact, reset]);

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$4(_useState3, 2),
      isSaving = _useState4[0],
      setIsSaving = _useState4[1];

  var _useContacts = useContacts(),
      addContact = _useContacts.addContact,
      reloadContacts = _useContacts.reloadContacts,
      updateContact = _useContacts.updateContact;

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$19().m(function _callee(data) {
      var success;
      return _regenerator$19().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              setIsSaving(true);
              success = false;

              if (contact) {
                _context.n = 2;
                break;
              }

              _context.n = 1;
              return addContact(data);

            case 1:
              success = _context.v;
              _context.n = 4;
              break;

            case 2:
              _context.n = 3;
              return updateContact(data);

            case 3:
              success = _context.v;

            case 4:
              reloadContacts();
              setIsSaving(false);

              if (success) {
                setIsOpen(false);
              }

            case 5:
              return _context.a(2);
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var title = function () {
    switch (view) {
      case 'US':
        return 'Nexus Information';

      case 'CA':
        return 'CIRA Information';

      case 'LAW':
        return 'LAW Information';

      case 'XXX':
        return 'Membership Information';

      case 'AU':
        return 'AU Informtion';

      case 'ASIA':
        return 'CED Information';

      case 'LINKED_DOMAINS':
        return 'Domains';

      default:
        return 'Contact';
    }
  }();

  return /*#__PURE__*/jsx$1(Stack$1, {
    color: "neutral-700",
    children: /*#__PURE__*/jsx$1(Modal, {
      title: title,
      onBack: view ? function () {
        setView(undefined);
      } : undefined,
      isOpen: isOpen,
      onClose: function onClose() {
        setIsOpen(false);
      },
      children: /*#__PURE__*/jsxs("form", {
        onSubmit: handleSubmit(onSubmit),
        children: [view === undefined && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx$1(Stack$1, {
            gap: 2,
            borderBottom: "1px solid",
            borderColor: "neutral-200",
            children: /*#__PURE__*/jsx$1(Text, {
              variant: "paragraph-xsmall",
              fontWeight: "regular",
              color: "neutral-400",
              mb: 3,
              children: "Fields with (*) are mandatory"
            })
          }), /*#__PURE__*/jsxs(Stack$1, {
            gap: 3,
            width: "663px",
            children: [/*#__PURE__*/jsx$1(InputFormField, {
              label: "Email Address*",
              formRegister: register('email'),
              errors: errors
            }), /*#__PURE__*/jsxs(Box, {
              children: [/*#__PURE__*/jsx$1(InputFormField, {
                label: "First Name*",
                formRegister: register('firstName'),
                errors: errors
              }), /*#__PURE__*/jsx$1(InputFormField, {
                label: "Last Name*",
                formRegister: register('lastName'),
                errors: errors
              })]
            }), /*#__PURE__*/jsx$1(InputFormField, {
              label: "Phone Number*",
              formRegister: register('phone'),
              errors: errors
            }), /*#__PURE__*/jsxs(Box, {
              children: [/*#__PURE__*/jsx$1(InputFormField, {
                label: "Apartment Number",
                width: "120px",
                formRegister: register('address.apartment'),
                errors: errors
              }), /*#__PURE__*/jsx$1(InputFormField, {
                label: "Street Number",
                width: "120px",
                formRegister: register('address.streetNumber'),
                errors: errors
              }), /*#__PURE__*/jsx$1(InputFormField, {
                label: "Street Name",
                width: "255px",
                formRegister: register('address.streetName'),
                errors: errors
              }), /*#__PURE__*/jsx$1(InputFormField, {
                label: "Street Type",
                width: "120px",
                formRegister: register('address.streetType'),
                errors: errors
              })]
            }), /*#__PURE__*/jsxs(Box, {
              children: [/*#__PURE__*/jsx$1(InputFormField, {
                label: "City*",
                formRegister: register('address.city'),
                errors: errors
              }), /*#__PURE__*/jsx$1(InputFormField, {
                label: "Province*",
                formRegister: register('address.province'),
                errors: errors
              })]
            }), /*#__PURE__*/jsxs(Box, {
              children: [/*#__PURE__*/jsx$1(DropDownFormField, {
                label: "Country*",
                menuPlacement: "top",
                name: "address.countryCode",
                errors: errors,
                control: control,
                customOnChange: function customOnChange(selected) {
                  setValue('address.countryCode', (selected === null || selected === void 0 ? void 0 : selected.value) || '');
                  setValue('address.countryName', (selected === null || selected === void 0 ? void 0 : selected.label) || '');
                },
                defaultValue: {
                  label: 'Canada',
                  value: 'CA'
                },
                placeholder: "Country",
                width: "180px",
                dropDownValues: countries
              }), /*#__PURE__*/jsx$1(InputFormField, {
                label: "Postal/Zip",
                formRegister: register('address.postalCode'),
                errors: errors
              })]
            }), /*#__PURE__*/jsx$1(InputFormField, {
              label: "Company",
              formRegister: register('company'),
              errors: errors
            })]
          }), /*#__PURE__*/jsxs(Stack$1, {
            mt: 3,
            mb: 4,
            children: [/*#__PURE__*/jsxs(Box, {
              children: [/*#__PURE__*/jsxs(Text, {
                variant: "paragraph-small",
                fontWeight: "regular",
                color: "neutral-600",
                mb: 2,
                style: {
                  verticalAlign: 'middle'
                },
                children: ["This Information is Private", "\xA0"]
              }), /*#__PURE__*/jsx$1(Popover, {
                style: {
                  backgroundColor: '#3F395B',
                  color: 'white'
                },
                trigger: /*#__PURE__*/jsx$1(Info, {}),
                children: /*#__PURE__*/jsxs(Stack$1, {
                  width: "225px",
                  m: 3,
                  style: {
                    whiteSpace: 'normal'
                  },
                  children: [/*#__PURE__*/jsx$1(Info, {
                    style: {
                      verticalAlign: 'middle',
                      marginBottom: '15px'
                    }
                  }), /*#__PURE__*/jsx$1(Text, {
                    children: "What does this mean for your privacy?"
                  }), /*#__PURE__*/jsx$1(Text, {
                    mt: 2,
                    variant: "paragraph-xsmall",
                    fontWeight: "regular",
                    children: "If your contact information is publicly listed in the WHOIS database, it becomes accessible to anyone, increasing your risk of receiving spam emails and phone calls. This information includes your name, email address, street address, and phone number."
                  })]
                })
              })]
            }), /*#__PURE__*/jsx$1(CheckboxFormField, {
              name: "consent",
              id: "consent",
              label: "Make it Public",
              errors: errors,
              control: control
            })]
          }), contact && /*#__PURE__*/jsxs(Stack$1, {
            children: [/*#__PURE__*/jsx$1(Text, {
              pb: 3,
              fontWeight: "bold",
              children: "Associations"
            }), /*#__PURE__*/jsxs(Box, {
              onClick: function onClick() {
                return setView('LINKED_DOMAINS');
              },
              style: {
                cursor: 'pointer'
              },
              padding: "24px",
              gap: 4,
              border: "1px solid",
              borderColor: "neutral-200",
              borderRadius: "base",
              fontWeight: "bold",
              children: [/*#__PURE__*/jsxs(Stack$1, {
                width: "100%",
                children: [/*#__PURE__*/jsx$1(Text, {
                  children: contact && "Domains (".concat(contact === null || contact === void 0 ? void 0 : contact.domainCount, ")")
                }), /*#__PURE__*/jsx$1(Text, {
                  variant: "paragraph-xsmall",
                  fontWeight: "regular",
                  color: "neutral-400",
                  mt: 3,
                  children: "Domains associated with this contact"
                })]
              }), /*#__PURE__*/jsxs(Button, {
                variant: "minimal",
                alignItems: "center",
                children: [/*#__PURE__*/jsx$1(Text, {
                  variant: "paragraph-small",
                  children: "View"
                }), " ", /*#__PURE__*/jsx$1(ArrowRight, {})]
              })]
            })]
          }), /*#__PURE__*/jsx$1(ExtraInfo, {
            setView: setView,
            showAUInfo: !!(contact !== null && contact !== void 0 && (_contact$extraInfo = contact.extraInfo) !== null && _contact$extraInfo !== void 0 && (_contact$extraInfo$AU = _contact$extraInfo.AUExtraInfo) !== null && _contact$extraInfo$AU !== void 0 && _contact$extraInfo$AU.RegistrantName),
            formValues: getValues()
          }), isSaving ? /*#__PURE__*/jsx$1(Skeleton, {
            borderRadius: "base",
            height: "50px"
          }, 'save-loader') : /*#__PURE__*/jsx$1(Button, {
            mt: 3,
            variant: "secondary",
            type: "submit",
            children: "Save"
          })]
        }), view === 'CA' && tldOptions && /*#__PURE__*/jsx$1(CAExtraInfo, {
          register: register,
          control: control,
          dropDownValues: tldOptions.ca,
          errors: errors
        }), view === 'US' && tldOptions && /*#__PURE__*/jsx$1(USExtraInfo, {
          control: control,
          dropDownValues: tldOptions.us,
          errors: errors
        }), view === 'XXX' && /*#__PURE__*/jsx$1(XXXExtraInfo, {
          register: register,
          errors: errors
        }), view === 'LAW' && tldOptions && /*#__PURE__*/jsx$1(LAWExtraInfo, {
          register: register,
          control: control,
          dropDownValues: tldOptions.law,
          errors: errors
        }), view === 'ASIA' && tldOptions && /*#__PURE__*/jsx$1(ASIAExtraInfo, {
          register: register,
          control: control,
          dropDownValues: tldOptions.asia,
          errors: errors
        }), view === 'AU' && tldOptions && /*#__PURE__*/jsx$1(AUExtraInfo, {
          register: register,
          control: control,
          dropDownValues: tldOptions.au
        }), view === 'LINKED_DOMAINS' && /*#__PURE__*/jsx$1(DomainsList$1, {
          domains: (_contact$domains = contact === null || contact === void 0 ? void 0 : contact.domains) !== null && _contact$domains !== void 0 ? _contact$domains : []
        })]
      })
    })
  });
}

function FormattedAddress(_ref) {
  var address = _ref.address;
  var streetNumber = address.streetNumber,
      streetName = address.streetName,
      streetType = address.streetType,
      city = address.city,
      province = address.province,
      postalCode = address.postalCode,
      apartment = address.apartment,
      countryName = address.countryName;
  var streetParts = [apartment && streetNumber ? "".concat(apartment, "-").concat(streetNumber) : streetNumber, streetName, streetType].filter(Boolean);
  var cityProvince = [city, province].filter(Boolean).join(', ');
  return /*#__PURE__*/jsxs(Stack$1, {
    children: [streetParts.length > 0 && /*#__PURE__*/jsx$1(Text, {
      variant: "paragraph-small",
      color: "neutral-700",
      children: streetParts.join(' ')
    }), cityProvince && /*#__PURE__*/jsx$1(Text, {
      variant: "paragraph-small",
      color: "neutral-700",
      children: cityProvince
    }), countryName && /*#__PURE__*/jsx$1(Text, {
      variant: "paragraph-small",
      color: "neutral-700",
      children: countryName
    }), postalCode && /*#__PURE__*/jsx$1(Text, {
      variant: "paragraph-small",
      color: "neutral-700",
      children: postalCode
    })]
  });
}

function ManageContact(_ref) {
  var contact = _ref.contact,
      setIsContactModalOpen = _ref.setIsContactModalOpen,
      setModalContact = _ref.setModalContact;

  var _useContacts = useContacts(),
      resendVerification = _useContacts.resendVerification,
      deleteContact = _useContacts.deleteContact,
      reloadContacts = _useContacts.reloadContacts;

  return /*#__PURE__*/jsx$1(Popover, {
    trigger: /*#__PURE__*/jsxs(Button, {
      variant: "minimal",
      onClick: function onClick() {
        return undefined;
      },
      px: 0,
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-small",
        children: "Manage"
      }), /*#__PURE__*/jsx$1(ArrowRight, {
        size: 18
      })]
    }),
    children: /*#__PURE__*/jsxs(Stack$1, {
      children: [/*#__PURE__*/jsx$1(Button, {
        justifyContent: "left",
        variant: "minimal",
        onClick: function onClick() {
          setModalContact(contact);
          setIsContactModalOpen(true);
        },
        children: /*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-small",
          children: "Edit Contact"
        })
      }), /*#__PURE__*/jsx$1(Button, {
        justifyContent: "left",
        variant: "minimal",
        onClick: function onClick() {
          deleteContact([contact.id]);
          document.dispatchEvent(new MouseEvent('mousedown', {
            bubbles: true
          }));
          reloadContacts();
        },
        children: /*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-small",
          children: "Delete Contact"
        })
      }), /*#__PURE__*/jsx$1(Button, {
        justifyContent: "left",
        variant: "minimal",
        onClick: function onClick() {
          resendVerification(contact.id);
          document.dispatchEvent(new MouseEvent('mousedown', {
            bubbles: true
          }));
        },
        children: /*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-small",
          children: "Resend Verification"
        })
      })]
    })
  });
}

function ContactsListGridCard(_ref) {
  var contact = _ref.contact,
      setIsContactModalOpen = _ref.setIsContactModalOpen,
      setModalContact = _ref.setModalContact;
  var verified = contact.verified,
      email = contact.email,
      lastUpdate = contact.lastUpdate,
      id = contact.id,
      firstName = contact.firstName,
      lastName = contact.lastName,
      company = contact.company,
      domainCount = contact.domainCount;
  return /*#__PURE__*/jsxs(Stack$1, {
    padding: "32px 24px 16px 24px",
    gap: 4,
    border: "1px solid",
    borderColor: "neutral-200",
    borderRadius: "base",
    fontWeight: "bold",
    maxWidth: "330px",
    style: {
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      overflowWrap: 'anywhere'
    },
    children: [/*#__PURE__*/jsxs(Stack$1, {
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        fontWeight: "regular",
        color: "neutral-400",
        children: verified
      }), (firstName || lastName) && /*#__PURE__*/jsxs(Text, {
        variant: "paragraph-medium",
        fontWeight: "semi",
        color: "neutral-700",
        children: [firstName, " ", lastName]
      }), company && /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-medium",
        fontWeight: "semi",
        color: "neutral-700",
        children: company
      }), /*#__PURE__*/jsxs(Text, {
        variant: "paragraph-xsmall",
        fontWeight: "regular",
        color: "neutral-400",
        children: [domainCount, " domain", domainCount !== 1 ? 's' : '']
      })]
    }), /*#__PURE__*/jsxs(Stack$1, {
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        fontWeight: "regular",
        color: "neutral-500",
        children: "Email"
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-small",
        color: "neutral-700",
        children: email
      })]
    }), /*#__PURE__*/jsxs(Stack$1, {
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        fontWeight: "regular",
        color: "neutral-500",
        children: "Last Update"
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-small",
        color: "neutral-700",
        children: lastUpdate
      })]
    }), /*#__PURE__*/jsxs(Stack$1, {
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        fontWeight: "regular",
        color: "neutral-500",
        children: "Address"
      }), /*#__PURE__*/jsx$1(FormattedAddress, {
        address: contact.address
      })]
    }), /*#__PURE__*/jsx$1(Stack$1, {
      padding: "12px 0px",
      borderTop: "1px solid",
      borderColor: "neutral-200",
      alignItems: "start",
      mt: "auto",
      children: /*#__PURE__*/jsx$1(ManageContact, {
        contact: contact,
        setIsContactModalOpen: setIsContactModalOpen,
        setModalContact: setModalContact
      })
    })]
  }, id);
}

function ContactsListGrid(_ref) {
  var setIsContactModalOpen = _ref.setIsContactModalOpen,
      setModalContact = _ref.setModalContact;

  var _useContacts = useContacts(),
      contacts = _useContacts.contacts;

  return /*#__PURE__*/jsx$1(Grid, {
    gridTemplateColumns: ['1fr', 'repeat(2, 1fr)', 'repeat(4, 1fr)'],
    gap: 3,
    children: contacts ? contacts.map(function (contact) {
      return /*#__PURE__*/jsx$1(ContactsListGridCard, {
        contact: contact,
        setIsContactModalOpen: setIsContactModalOpen,
        setModalContact: setModalContact
      }, contact.id);
    }) : Array.from({
      length: 4
    }).map(function (_, index) {
      return /*#__PURE__*/jsx$1(Skeleton, {
        borderRadius: "base",
        height: "400px"
      }, "".concat(index, "-loader"));
    })
  });
}

function TableRow$1(_ref) {
  var contact = _ref.contact,
      setIsContactModalOpen = _ref.setIsContactModalOpen,
      setModalContact = _ref.setModalContact;
  var email = contact.email,
      lastUpdate = contact.lastUpdate,
      domainCount = contact.domainCount,
      firstName = contact.firstName,
      lastName = contact.lastName,
      verified = contact.verified,
      company = contact.company;
  return /*#__PURE__*/jsxs(Grid, {
    gridTemplateColumns: "repeat(6, 1fr)",
    alignItems: "center",
    p: "24px 16px",
    borderBottom: "1px solid",
    borderColor: "neutral-200",
    gap: 4,
    fontWeight: "medium",
    style: {
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      overflowWrap: 'anywhere'
    },
    children: [/*#__PURE__*/jsxs(Stack$1, {
      children: [(firstName || lastName) && /*#__PURE__*/jsxs(Text, {
        variant: "paragraph-medium",
        fontWeight: "semi",
        color: "neutral-700",
        children: [firstName, " ", lastName]
      }), company && /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-medium",
        fontWeight: "semi",
        color: "neutral-700",
        children: company
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        fontWeight: "regular",
        color: "neutral-400",
        children: verified
      })]
    }), /*#__PURE__*/jsx$1(FormattedAddress, {
      address: contact.address
    }), /*#__PURE__*/jsx$1(Text, {
      variant: "paragraph-small",
      color: "neutral-700",
      fontWeight: "medium",
      children: email
    }), /*#__PURE__*/jsx$1(Text, {
      variant: "paragraph-small",
      textAlign: "center",
      width: "152px",
      color: "neutral-700",
      children: domainCount || /*#__PURE__*/jsx$1(Skeleton, {
        width: "30px",
        height: "15px"
      })
    }), /*#__PURE__*/jsx$1(Text, {
      variant: "paragraph-small",
      color: "neutral-700",
      children: lastUpdate
    }), /*#__PURE__*/jsx$1(ManageContact, {
      contact: contact,
      setIsContactModalOpen: setIsContactModalOpen,
      setModalContact: setModalContact
    })]
  }, contact.id);
}

function ContactsListTable(_ref) {
  var setIsContactModalOpen = _ref.setIsContactModalOpen,
      setModalContact = _ref.setModalContact;

  var _useContacts = useContacts(),
      contacts = _useContacts.contacts;

  var _useSortState = useSortState(contacts),
      sortState = _useSortState.sortState,
      handleToggleSort = _useSortState.handleToggleSort,
      sortedContacts = _useSortState.sortedItems;

  return /*#__PURE__*/jsxs(Stack$1, {
    children: [/*#__PURE__*/jsxs(Grid, {
      gridTemplateColumns: "repeat(6, 1fr)",
      alignItems: "center",
      backgroundColor: "neutral-100",
      p: "24px 16px",
      gap: 4,
      borderBottom: "1px solid",
      borderColor: "neutral-200",
      children: [/*#__PURE__*/jsx$1(SortableHeader, {
        field: "contactName",
        label: "Contact Name",
        sortState: sortState,
        onToggleSort: handleToggleSort
      }), /*#__PURE__*/jsx$1(SortableHeader, {
        field: "sortableAddress",
        label: "Address",
        sortState: sortState,
        onToggleSort: handleToggleSort
      }), /*#__PURE__*/jsx$1(SortableHeader, {
        field: "email",
        label: "Email",
        sortState: sortState,
        onToggleSort: handleToggleSort
      }), /*#__PURE__*/jsx$1(SortableHeader, {
        field: "domainCount",
        label: "Related Domains",
        sortState: sortState,
        onToggleSort: handleToggleSort
      }), /*#__PURE__*/jsx$1(SortableHeader, {
        field: "lastUpdate",
        label: "Last Update",
        sortState: sortState,
        onToggleSort: handleToggleSort
      })]
    }), sortedContacts ? sortedContacts.map(function (contact) {
      return /*#__PURE__*/jsx$1(TableRow$1, {
        contact: contact,
        setIsContactModalOpen: setIsContactModalOpen,
        setModalContact: setModalContact
      }, contact.id);
    }) : Array.from({
      length: 4
    }).map(function (_, index) {
      return /*#__PURE__*/jsx$1(Skeleton, {
        height: "64px",
        borderRadius: "base"
      }, index);
    })]
  });
}

function ContactsList() {
  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isDeleting = _useState2[0],
      setIsDeleting = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$4(_useState3, 2),
      isContactModalOpen = _useState4[0],
      setIsContactModalOpen = _useState4[1];

  var _useState5 = useState(undefined),
      _useState6 = _slicedToArray$4(_useState5, 2),
      modalContact = _useState6[0],
      setModalContact = _useState6[1];

  var _useContacts = useContacts(),
      reloadContacts = _useContacts.reloadContacts,
      contacts = _useContacts.contacts,
      unFilteredContacts = _useContacts.unFilteredContacts,
      searchTerm = _useContacts.searchTerm,
      setSearchTerm = _useContacts.setSearchTerm,
      verifiedFilter = _useContacts.verifiedFilter,
      setVerifiedFilter = _useContacts.setVerifiedFilter,
      deleteUnusedContacts = _useContacts.deleteUnusedContacts;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(ContactModal, {
      contact: modalContact,
      isOpen: isContactModalOpen,
      setIsOpen: setIsContactModalOpen
    }), /*#__PURE__*/jsxs(Stack$1, {
      gap: 3,
      children: [/*#__PURE__*/jsxs(Box, {
        justifyContent: "space-between",
        alignItems: "center",
        gap: 6,
        children: [/*#__PURE__*/jsxs(Stack$1, {
          gap: 2,
          width: ['100%', '50%', '50%'],
          children: [/*#__PURE__*/jsx$1(Text, {
            variant: "heading-h5",
            fontWeight: "bold",
            color: "primary-600",
            children: "Contacts"
          }), /*#__PURE__*/jsx$1(Text, {
            color: "primary-600",
            children: "Here, you'll find information about your account. You have the ability to review your Contact List, Active and Canceled Subscriptions, and Login History."
          })]
        }), /*#__PURE__*/jsx$1(Stack$1, {
          justifyContent: "end",
          height: "100%",
          children: /*#__PURE__*/jsx$1(StyledInput, {
            value: searchTerm,
            onChange: function onChange(e) {
              return setSearchTerm(e.target.value);
            },
            placeholder: "Type your contact name"
          })
        })]
      }), /*#__PURE__*/jsx$1(ViewManager, {
        items: contacts,
        gridView: /*#__PURE__*/jsx$1(ContactsListGrid, {
          setIsContactModalOpen: setIsContactModalOpen,
          setModalContact: setModalContact
        }),
        tableView: /*#__PURE__*/jsx$1(ContactsListTable, {
          setIsContactModalOpen: setIsContactModalOpen,
          setModalContact: setModalContact
        }),
        headerBar: /*#__PURE__*/jsxs(Box, {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 4,
          width: "100%",
          children: [/*#__PURE__*/jsx$1(Box, {
            display: "flex",
            gap: 4,
            children: /*#__PURE__*/jsx$1(Popover, {
              trigger: /*#__PURE__*/jsxs(Button, {
                variant: "minimal",
                onClick: function onClick() {
                  return undefined;
                },
                px: 0,
                children: [/*#__PURE__*/jsx$1(Text, {
                  children: verifiedFilter
                }), /*#__PURE__*/jsx$1(ChevronDown, {})]
              }),
              children: /*#__PURE__*/jsxs(Stack$1, {
                children: [/*#__PURE__*/jsxs(Text, {
                  mb: 3,
                  onClick: function onClick(e) {
                    var _e$currentTarget$text;

                    return setVerifiedFilter((_e$currentTarget$text = e.currentTarget.textContent) !== null && _e$currentTarget$text !== void 0 ? _e$currentTarget$text : '');
                  },
                  children: ["Show All (", unFilteredContacts === null || unFilteredContacts === void 0 ? void 0 : unFilteredContacts.length, ")"]
                }), /*#__PURE__*/jsxs(Text, {
                  mb: 3,
                  onClick: function onClick(e) {
                    var _e$currentTarget$text2;

                    return setVerifiedFilter((_e$currentTarget$text2 = e.currentTarget.textContent) !== null && _e$currentTarget$text2 !== void 0 ? _e$currentTarget$text2 : '');
                  },
                  children: ["Verified (", unFilteredContacts === null || unFilteredContacts === void 0 ? void 0 : unFilteredContacts.filter(function (contact) {
                    return contact.verified === 'Verified';
                  }).length, ")"]
                }), /*#__PURE__*/jsxs(Text, {
                  mb: 3,
                  onClick: function onClick(e) {
                    var _e$currentTarget$text3;

                    return setVerifiedFilter((_e$currentTarget$text3 = e.currentTarget.textContent) !== null && _e$currentTarget$text3 !== void 0 ? _e$currentTarget$text3 : '');
                  },
                  children: ["Unverified (", unFilteredContacts === null || unFilteredContacts === void 0 ? void 0 : unFilteredContacts.filter(function (contact) {
                    return contact.verified === 'Unverified';
                  }).length, ")"]
                })]
              })
            })
          }), /*#__PURE__*/jsxs(Box, {
            display: "flex",
            gap: 2,
            children: [/*#__PURE__*/jsxs(Button, {
              justifyContent: "left",
              variant: "minimal",
              onClick: function onClick() {
                return setIsContactModalOpen(true);
              },
              children: [/*#__PURE__*/jsx$1(Plus, {}), /*#__PURE__*/jsx$1(Text, {
                fontWeight: "regular",
                color: "neutral-700",
                children: "Add Contact"
              })]
            }), isDeleting ? /*#__PURE__*/jsx$1(Skeleton, {
              borderRadius: "base",
              height: "50px"
            }, 'delete-loader') : /*#__PURE__*/jsxs(Button, {
              variant: "minimal",
              onClick: function onClick() {
                setIsDeleting(true);
                deleteUnusedContacts();
                reloadContacts();
                setIsDeleting(false);
              },
              px: 0,
              children: [/*#__PURE__*/jsx$1(Trash2, {}), ' ', /*#__PURE__*/jsx$1(Text, {
                color: "neutral-700",
                fontWeight: "regular",
                children: "Delete Unused"
              })]
            })]
          })]
        })
      })]
    })]
  });
}

function ContactsListTab() {
  return /*#__PURE__*/jsxs(ContactsProvider, {
    children: [/*#__PURE__*/jsx$1(Header$1, {
      header: "My Account"
    }), /*#__PURE__*/jsx$1(Tabs, {
      tabs: TABS.myAccount
    }), /*#__PURE__*/jsx$1(ContactsList, {})]
  });
}

function DomainsListGridCard(_ref) {
  var domain = _ref.domain;
  var DomainName = domain.DomainName,
      Status = domain.Status,
      PaidExpiryDate = domain.PaidExpiryDate;
  var domainHasProducts = domain.HasExpiryProtection || domain.HasOwnershipProtection || domain.HasPrivacyProtection;
  return /*#__PURE__*/jsxs(Stack$1, {
    padding: "32px 24px 16px 24px",
    gap: 4,
    border: "1px solid",
    borderColor: "neutral-200",
    borderRadius: "base",
    backgroundColor: "card",
    children: [/*#__PURE__*/jsxs(Stack$1, {
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        color: "neutral-500",
        children: "Domain"
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        color: "neutral-700",
        fontWeight: "bold",
        children: DomainName
      })]
    }), /*#__PURE__*/jsxs(Stack$1, {
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        color: "neutral-500",
        children: "Status"
      }), /*#__PURE__*/jsx$1(Text, {
        color: "neutral-700",
        fontWeight: "semi",
        children: Status
      })]
    }), /*#__PURE__*/jsxs(Stack$1, {
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        color: "neutral-500",
        children: "Expiry Date"
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        color: "neutral-700",
        fontWeight: "bold",
        children: PaidExpiryDate
      })]
    }), /*#__PURE__*/jsxs(Stack$1, {
      gap: 2,
      display: domainHasProducts ? 'flex' : 'none',
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-xsmall",
        color: "neutral-500",
        children: "Products associated:"
      }), domain.HasExpiryProtection && /*#__PURE__*/jsx$1(Text, {
        ml: 2,
        fontWeight: "semi",
        color: "neutral-700",
        variant: "paragraph-xsmall",
        children: "\u2022 Expiry Protection"
      }), domain.HasOwnershipProtection && /*#__PURE__*/jsx$1(Text, {
        ml: 2,
        fontWeight: "semi",
        color: "neutral-700",
        variant: "paragraph-xsmall",
        children: "\u2022 Ownership Protection"
      }), domain.HasPrivacyProtection && /*#__PURE__*/jsx$1(Text, {
        ml: 2,
        fontWeight: "semi",
        color: "neutral-700",
        variant: "paragraph-xsmall",
        children: "\u2022 Privacy Protection"
      })]
    }), /*#__PURE__*/jsx$1(Stack$1, {
      padding: "12px 0px",
      borderTop: "1px solid",
      borderColor: "neutral-200",
      alignItems: "start",
      mt: "auto",
      children: /*#__PURE__*/jsx$1(Link, {
        to: "".concat(BASEPATH, "/managers/domains/").concat(domain.DomainName),
        children: /*#__PURE__*/jsxs(Button, {
          variant: "minimal",
          px: 0,
          children: [/*#__PURE__*/jsx$1(Text, {
            variant: "paragraph-small",
            children: "Manage"
          }), /*#__PURE__*/jsx$1(ArrowRight, {})]
        })
      })
    })]
  });
}

function DomainsListGrid() {
  var _useDomains = useDomains(),
      domains = _useDomains.domains;

  return /*#__PURE__*/jsx$1(Grid, {
    gridTemplateColumns: ['1fr', 'repeat(2, 1fr)', 'repeat(4, 1fr)'],
    gap: 3,
    children: domains ? domains.map(function (domain) {
      return /*#__PURE__*/jsx$1(DomainsListGridCard, {
        domain: domain
      }, domain.DomainName);
    }) : // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Array.from({
      length: 4
    }).map(function (_, i) {
      return /*#__PURE__*/jsx$1(Skeleton, {
        borderRadius: "base",
        height: "400px"
      }, i);
    })
  });
}

function DomainsListTableProducts(_ref) {
  var domain = _ref.domain;
  return /*#__PURE__*/jsx$1(Popover, {
    trigger: /*#__PURE__*/jsx$1(Box, {
      width: "fit-content",
      position: "relative",
      children: /*#__PURE__*/jsxs(Button, {
        variant: "minimal",
        fontWeight: "medium",
        children: ["Products", /*#__PURE__*/jsx$1(ChevronDown, {
          size: 15,
          className: "chevron"
        })]
      })
    }),
    children: /*#__PURE__*/jsxs(Stack$1, {
      gap: 2,
      children: [/*#__PURE__*/jsxs(Stack$1, {
        p: "8px",
        borderBottom: "1px solid",
        borderColor: "neutral-200",
        gap: 1,
        children: [/*#__PURE__*/jsx$1(Text, {
          color: "primary-700",
          variant: "paragraph-xsmall",
          children: "Expiry Protection"
        }), /*#__PURE__*/jsx$1(Text, {
          fontWeight: "bold",
          variant: "paragraph-xsmall",
          children: domain.HasExpiryProtection ? 'Protected' : 'Not Protected'
        })]
      }), /*#__PURE__*/jsxs(Stack$1, {
        p: "8px",
        borderBottom: "1px solid",
        borderColor: "neutral-200",
        gap: 1,
        children: [/*#__PURE__*/jsx$1(Text, {
          color: "primary-700",
          variant: "paragraph-xsmall",
          children: "Ownership Protection"
        }), /*#__PURE__*/jsx$1(Text, {
          fontWeight: "bold",
          variant: "paragraph-xsmall",
          children: domain.HasOwnershipProtection ? 'Protected' : 'Not Protected'
        })]
      }), /*#__PURE__*/jsxs(Stack$1, {
        p: "8px",
        gap: 1,
        children: [/*#__PURE__*/jsx$1(Text, {
          color: "primary-700",
          variant: "paragraph-xsmall",
          children: "Privacy Protection"
        }), /*#__PURE__*/jsx$1(Text, {
          fontWeight: "bold",
          variant: "paragraph-xsmall",
          children: domain.HasPrivacyProtection ? 'Protected' : 'Not Protected'
        })]
      })]
    })
  });
}

function DomainsListTable() {
  var _useDomains = useDomains(),
      domains = _useDomains.domains;

  var _useSortState = useSortState(domains),
      sortState = _useSortState.sortState,
      handleToggleSort = _useSortState.handleToggleSort,
      sortedDomains = _useSortState.sortedItems;

  return /*#__PURE__*/jsxs(Stack$1, {
    children: [/*#__PURE__*/jsxs(Grid, {
      gridTemplateColumns: "2fr 1fr 1fr 1fr 2fr",
      alignItems: "center",
      backgroundColor: "neutral-100",
      p: "24px 16px",
      gap: 4,
      borderBottom: "1px solid",
      borderColor: "neutral-200",
      children: [/*#__PURE__*/jsx$1(SortableHeader, {
        field: "DomainName",
        label: "Domain Name",
        sortState: sortState,
        onToggleSort: handleToggleSort
      }), /*#__PURE__*/jsx$1(SortableHeader, {
        field: "Status",
        label: "Status",
        sortState: sortState,
        onToggleSort: handleToggleSort
      }), /*#__PURE__*/jsx$1(SortableHeader, {
        field: "PaidExpiryDate",
        label: "Expiry Date",
        sortState: sortState,
        onToggleSort: handleToggleSort
      }), /*#__PURE__*/jsx$1(Text, {
        fontWeight: "medium",
        color: "neutral-700",
        children: "Products"
      })]
    }), sortedDomains ? sortedDomains.map(function (domain) {
      return /*#__PURE__*/jsxs(Grid, {
        gridTemplateColumns: "2fr 1fr 1fr 1fr 2fr",
        alignItems: "center",
        p: "24px 16px",
        borderBottom: "1px solid",
        borderColor: "neutral-200",
        gap: 4,
        fontWeight: "medium",
        children: [/*#__PURE__*/jsx$1(Text, {
          color: "neutral-700",
          children: domain.DomainName
        }), /*#__PURE__*/jsx$1(Text, {
          color: "neutral-700",
          children: domain.Status
        }), /*#__PURE__*/jsx$1(Text, {
          color: "neutral-700",
          children: domain.PaidExpiryDate
        }), /*#__PURE__*/jsx$1(DomainsListTableProducts, {
          domain: domain
        }), /*#__PURE__*/jsxs(Button, {
          p: 0,
          variant: "link",
          fontWeight: "medium",
          color: "primary-700",
          onClick: function onClick() {
            return navigate("".concat(BASEPATH, "/managers/domains/").concat(domain.DomainName, "/dns"));
          },
          children: [/*#__PURE__*/jsx$1(Text, {
            variant: "paragraph-small",
            children: "Manage"
          }), /*#__PURE__*/jsx$1(ArrowRight, {
            size: 18
          })]
        })]
      }, domain.DomainID);
    }) : Array.from({
      length: 4
    }).map(function (_, index) {
      return /*#__PURE__*/jsx$1(Skeleton, {
        height: "64px",
        borderRadius: "base"
      }, index);
    })]
  });
}

function DomainsList() {
  var _useDomains = useDomains(),
      domains = _useDomains.domains,
      searchTerm = _useDomains.searchTerm,
      setSearchTerm = _useDomains.setSearchTerm,
      showAll = _useDomains.showAll;

  return /*#__PURE__*/jsxs(Stack$1, {
    gap: 3,
    children: [/*#__PURE__*/jsxs(Box, {
      justifyContent: "space-between",
      alignItems: "center",
      gap: 6,
      children: [/*#__PURE__*/jsxs(Stack$1, {
        gap: 2,
        width: ['100%', '50%', '50%'],
        children: [/*#__PURE__*/jsx$1(Text, {
          variant: "heading-h5",
          fontWeight: "bold",
          color: "primary-600",
          children: "Domain List"
        }), /*#__PURE__*/jsx$1(Text, {
          color: "primary-600",
          children: "Here, you'll find information about your account. You have the ability to review your Domain List, Active and Canceled Subscriptions, and Login History."
        })]
      }), /*#__PURE__*/jsx$1(Stack$1, {
        justifyContent: "end",
        height: "100%",
        children: /*#__PURE__*/jsx$1(StyledInput, {
          value: searchTerm,
          onChange: function onChange(e) {
            return setSearchTerm(e.target.value);
          },
          placeholder: "Type your domain name"
        })
      })]
    }), /*#__PURE__*/jsx$1(ViewManager, {
      items: domains,
      gridView: /*#__PURE__*/jsx$1(DomainsListGrid, {}),
      tableView: /*#__PURE__*/jsx$1(DomainsListTable, {})
    }), domains && showAll && /*#__PURE__*/jsx$1(Button, {
      variant: "secondary",
      disabled: showAll === undefined,
      width: ['100%', '50%', '50%'],
      mt: 2,
      mx: "auto",
      onClick: function onClick() {
        if (showAll) {
          showAll();
        }
      },
      children: "Show All"
    })]
  });
}

function DomainsListTab() {
  return /*#__PURE__*/jsxs(DomainsProvider, {
    children: [/*#__PURE__*/jsx$1(Header$1, {
      header: "My Account"
    }), /*#__PURE__*/jsx$1(Tabs, {
      tabs: TABS.myAccount
    }), /*#__PURE__*/jsx$1(DomainsList, {})]
  });
}

function _regenerator$18() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$18(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$18(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$18(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$18(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$18(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$18(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$18(u), _regeneratorDefine2$18(u, o, "Generator"), _regeneratorDefine2$18(u, n, function () {
    return this;
  }), _regeneratorDefine2$18(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$18 = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$18(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$18 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$18(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$18(e, r, n, t);
}

var SubscriptionsContext = /*#__PURE__*/createContext(undefined);
var PAGINATION_COUNT$1 = 10;

function SubscriptionsProvider(_ref) {
  var children = _ref.children,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? 'active' : _ref$status;

  var _useState = useState(),
      _useState2 = _slicedToArray$4(_useState, 2),
      subscriptions = _useState2[0],
      setSubscriptions = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray$4(_useState3, 2),
      searchTerm = _useState4[0],
      setSearchTerm = _useState4[1];

  var _useState5 = useState(PAGINATION_COUNT$1),
      _useState6 = _slicedToArray$4(_useState5, 2),
      visibleCount = _useState6[0],
      setVisibleCount = _useState6[1];

  var filteredSubscriptions = useMemo(function () {
    if (!subscriptions) return undefined;
    var filtered = subscriptions;

    if (searchTerm && searchTerm.length > 2) {
      filtered = filtered.filter(function (subscription) {
        return subscription.SubscriptionTitle.toLowerCase().includes(searchTerm.toLowerCase());
      });
    }

    return filtered.slice(0, visibleCount);
  }, [visibleCount, searchTerm, subscriptions]);
  var showMore = useMemo(function () {
    if (!subscriptions) return undefined;
    return subscriptions.length > visibleCount ? function () {
      return setVisibleCount(visibleCount + PAGINATION_COUNT$1);
    } : undefined;
  }, [subscriptions, visibleCount]);
  useEffect(function () {
    function getSubscriptions() {
      return _getSubscriptions.apply(this, arguments);
    }

    function _getSubscriptions() {
      _getSubscriptions = _asyncToGenerator( /*#__PURE__*/_regenerator$18().m(function _callee() {
        var _yield$api$subscripti, _yield$api$subscripti2, response, error;

        return _regenerator$18().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.n = 1;
                return api.subscriptions.fetch(status);

              case 1:
                _yield$api$subscripti = _context.v;
                _yield$api$subscripti2 = _slicedToArray$4(_yield$api$subscripti, 2);
                response = _yield$api$subscripti2[0];
                error = _yield$api$subscripti2[1];

                if (error) {
                  toast.error(error);
                } else {
                  setSubscriptions(response);
                }

              case 2:
                return _context.a(2);
            }
          }
        }, _callee);
      }));
      return _getSubscriptions.apply(this, arguments);
    }

    getSubscriptions();
  }, [status]);
  return /*#__PURE__*/jsx$1(SubscriptionsContext.Provider, {
    value: {
      status: status,
      showMore: showMore,
      searchTerm: searchTerm,
      setSearchTerm: setSearchTerm,
      subscriptions: filteredSubscriptions,
      totalSubscriptions: subscriptions ? subscriptions.length : 0
    },
    children: children
  });
}

function useSubscriptions() {
  var context = useContext(SubscriptionsContext);

  if (!context) {
    throw new Error('useSubscriptions must be used within a SubscriptionsProvider');
  }

  return context;
} // for use in tests


function AdditionalDomainsModal(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      primaryDomain = _ref.primaryDomain,
      additionalDomains = _ref.additionalDomains;
  var sortedDomainNames = useMemo(function () {
    if (!additionalDomains) return additionalDomains;
    return _toConsumableArray$1(additionalDomains).sort(function (a, b) {
      return String(a).localeCompare(String(b));
    });
  }, [additionalDomains]);
  return /*#__PURE__*/jsx$1(Modal, {
    isOpen: isOpen,
    onClose: onClose,
    title: "More Domains",
    children: /*#__PURE__*/jsxs(Stack$1, {
      minWidth: ['100%', '500px', '500px'],
      children: [/*#__PURE__*/jsx$1(Stack$1, {
        backgroundColor: "neutral-100",
        p: "24px 16px",
        children: /*#__PURE__*/jsx$1(Text, {
          color: "neutral-700",
          variant: "paragraph-medium",
          fontWeight: "medium",
          children: "Domain Name"
        })
      }), /*#__PURE__*/jsxs(Grid, {
        gridTemplateColumns: "1fr",
        alignItems: "center",
        borderBottom: "1px solid",
        borderColor: "neutral-200",
        children: [/*#__PURE__*/jsxs(Stack$1, {
          p: "24px 16px",
          children: [/*#__PURE__*/jsx$1(Text, {
            variant: "paragraph-xsmall",
            color: "neutral-500",
            children: "Primary Domain"
          }), /*#__PURE__*/jsx$1(Text, {
            variant: "paragraph-small",
            color: "neutral-700",
            children: primaryDomain
          })]
        }), sortedDomainNames.map(function (domain, idx) {
          return /*#__PURE__*/jsx$1(Box, {
            alignItems: "center",
            p: "24px 16px",
            gap: 4,
            borderTop: "1px solid",
            borderColor: "neutral-200",
            children: /*#__PURE__*/jsx$1(Text, {
              variant: "paragraph-small",
              color: "neutral-700",
              fontWeight: "medium",
              children: domain
            })
          }, idx);
        })]
      })]
    })
  });
}

function SubscriptionsListGridCard(_ref) {
  var subscription = _ref.subscription;
  var success = subscription.success,
      SubscriptionID = subscription.SubscriptionID,
      SubscriptionTitle = subscription.SubscriptionTitle,
      PrimaryConnectedDomain = subscription.PrimaryConnectedDomain,
      AdditionalConnectedDomains = subscription.AdditionalConnectedDomains,
      LastBillingDate = subscription.LastBillingDate,
      NextBillingDate = subscription.NextBillingDate,
      Interval = subscription.Interval,
      PackageCategory = subscription.PackageCategory;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isModalOpen = _useState2[0],
      setModalOpen = _useState2[1];

  var openModal = function openModal() {
    return setModalOpen(true);
  };

  var closeModal = function closeModal() {
    return setModalOpen(false);
  };

  var hasAdditionalDomains = Object.values(subscription).includes(AdditionalConnectedDomains) && AdditionalConnectedDomains.length > 1;
  var additionalDomainsCount = AdditionalConnectedDomains.length;
  if (!success) return null;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(Stack$1, {
      padding: "32px 24px 16px 24px",
      gap: 4,
      border: "1px solid",
      borderColor: "neutral-200",
      borderRadius: "base",
      backgroundColor: "card",
      children: [/*#__PURE__*/jsxs(Stack$1, {
        children: [/*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-medium",
          color: "neutral-700",
          fontWeight: "bold",
          children: SubscriptionTitle
        }), /*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-small",
          color: "neutral-500",
          children: PackageCategory
        })]
      }), PrimaryConnectedDomain && /*#__PURE__*/jsxs(Stack$1, {
        children: [/*#__PURE__*/jsxs(Box, {
          gap: 1,
          alignItems: "center",
          color: "neutral-500",
          children: [/*#__PURE__*/jsx$1(Link2, {}), /*#__PURE__*/jsx$1(Text, {
            variant: "paragraph-small",
            color: "neutral-500",
            pb: 1,
            children: "Connected to:"
          })]
        }), /*#__PURE__*/jsx$1(Text, {
          color: "neutral-700",
          fontWeight: "semi",
          children: PrimaryConnectedDomain
        }), hasAdditionalDomains && /*#__PURE__*/jsx$1(Button, {
          onClick: openModal,
          variant: "minimal",
          width: "fit-content",
          px: 0,
          children: /*#__PURE__*/jsxs(Text, {
            variant: "paragraph-xsmall",
            color: "neutral-500",
            children: ["see ", additionalDomainsCount, " more", ' ', additionalDomainsCount === 1 ? 'domain' : 'domains']
          })
        })]
      }), /*#__PURE__*/jsxs(Stack$1, {
        mt: "auto",
        flex: "1",
        gap: 4,
        justifyContent: "flex-end",
        children: [/*#__PURE__*/jsxs(Stack$1, {
          children: [/*#__PURE__*/jsx$1(Text, {
            variant: "paragraph-xsmall",
            color: "neutral-500",
            children: "Period"
          }), /*#__PURE__*/jsx$1(Text, {
            variant: "paragraph-xsmall",
            color: "neutral-700",
            fontWeight: "bold",
            children: Interval
          })]
        }), /*#__PURE__*/jsxs(Stack$1, {
          gap: 1,
          children: [/*#__PURE__*/jsxs(Box, {
            gap: 1,
            children: [/*#__PURE__*/jsx$1(Text, {
              variant: "paragraph-xsmall",
              color: "neutral-500",
              children: "Last Billing Date:"
            }), /*#__PURE__*/jsx$1(Text, {
              variant: "paragraph-xsmall",
              color: "neutral-700",
              fontWeight: "bold",
              children: LastBillingDate
            })]
          }), /*#__PURE__*/jsxs(Box, {
            gap: 1,
            children: [/*#__PURE__*/jsx$1(Text, {
              variant: "paragraph-xsmall",
              color: "neutral-500",
              children: "Next Billing Date:"
            }), /*#__PURE__*/jsx$1(Text, {
              variant: "paragraph-xsmall",
              color: "neutral-700",
              fontWeight: "bold",
              children: NextBillingDate
            })]
          })]
        })]
      }), /*#__PURE__*/jsx$1(Stack$1, {
        padding: "12px 0px",
        borderTop: "1px solid",
        borderColor: "neutral-200",
        alignItems: "start",
        mt: "auto",
        children: /*#__PURE__*/jsx$1(Link, {
          to: "".concat(BASEPATH, "/managers"),
          children: /*#__PURE__*/jsxs(Button, {
            variant: "minimal",
            px: 0,
            children: [/*#__PURE__*/jsx$1(Text, {
              variant: "paragraph-small",
              children: "Manage"
            }), /*#__PURE__*/jsx$1(ArrowRight, {})]
          })
        })
      })]
    }, SubscriptionID), /*#__PURE__*/jsx$1(AdditionalDomainsModal, {
      isOpen: isModalOpen,
      onClose: closeModal,
      primaryDomain: PrimaryConnectedDomain,
      additionalDomains: AdditionalConnectedDomains
    })]
  });
}

function SubscriptionsListGrid() {
  var _useSubscriptions = useSubscriptions(),
      subscriptions = _useSubscriptions.subscriptions;

  return /*#__PURE__*/jsx$1(Grid, {
    gridTemplateColumns: ['1fr', 'repeat(2, 1fr)', 'repeat(4, 1fr)'],
    gap: 3,
    children: subscriptions ? subscriptions.map(function (subscription) {
      return /*#__PURE__*/jsx$1(SubscriptionsListGridCard, {
        subscription: subscription
      }, subscription.SubscriptionID);
    }) : Array.from({
      length: 4
    }).map(function (_, idx) {
      return /*#__PURE__*/jsx$1(Skeleton, {
        borderRadius: "base",
        height: "400px"
      }, idx);
    })
  });
}

function TableRow(_ref) {
  var subscription = _ref.subscription,
      openModal = _ref.openModal;
  return /*#__PURE__*/jsxs(Grid, {
    gridTemplateColumns: "2fr 1fr 1fr 1fr 2fr",
    alignItems: "center",
    p: "24px 16px",
    borderBottom: "1px solid",
    borderColor: "neutral-200",
    gap: 4,
    fontWeight: "medium",
    children: [/*#__PURE__*/jsxs(Stack$1, {
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-medium",
        color: "neutral-700",
        fontWeight: "bold",
        children: subscription.SubscriptionTitle
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-small",
        color: "neutral-500",
        children: subscription.PackageCategory
      }), subscription.PrimaryConnectedDomain && /*#__PURE__*/jsxs(Stack$1, {
        children: [/*#__PURE__*/jsxs(Box, {
          gap: 1,
          children: [/*#__PURE__*/jsx$1(Link2, {}), /*#__PURE__*/jsx$1(Text, {
            variant: "paragraph-small",
            color: "neutral-500",
            children: "Connected to:"
          })]
        }), /*#__PURE__*/jsx$1(Text, {
          color: "neutral-700",
          fontWeight: "semi",
          children: subscription.PrimaryConnectedDomain
        }), subscription.AdditionalConnectedDomains.length > 0 && /*#__PURE__*/jsx$1(Button, {
          onClick: function onClick() {
            return openModal(subscription);
          },
          variant: "minimal",
          width: "fit-content",
          px: 0,
          children: /*#__PURE__*/jsxs(Text, {
            variant: "paragraph-xsmall",
            color: "neutral-500",
            children: ["see ", subscription.AdditionalConnectedDomains.length, " more", ' ', subscription.AdditionalConnectedDomains.length === 1 ? 'domain' : 'domains']
          })
        })]
      })]
    }), /*#__PURE__*/jsx$1(Text, {
      variant: "paragraph-xsmall",
      color: "neutral-700",
      fontWeight: "bold",
      children: subscription.Interval
    }), /*#__PURE__*/jsx$1(Text, {
      variant: "paragraph-xsmall",
      color: "neutral-700",
      fontWeight: "bold",
      children: subscription.LastBillingDate
    }), /*#__PURE__*/jsx$1(Text, {
      variant: "paragraph-xsmall",
      color: "neutral-700",
      fontWeight: "bold",
      children: subscription.NextBillingDate
    }), /*#__PURE__*/jsx$1(Link, {
      to: "".concat(BASEPATH, "/managers"),
      children: /*#__PURE__*/jsxs(Button, {
        variant: "minimal",
        px: 0,
        children: [/*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-small",
          children: "Manage"
        }), /*#__PURE__*/jsx$1(ArrowRight, {})]
      })
    })]
  }, subscription.SubscriptionID);
}

function SubscriptionsListTable() {
  var _useState = useState(),
      _useState2 = _slicedToArray$4(_useState, 2),
      selectedSubscription = _useState2[0],
      setSelectedSubscription = _useState2[1];

  var _useSubscriptions = useSubscriptions(),
      subscriptions = _useSubscriptions.subscriptions;

  var _useSortState = useSortState(subscriptions),
      sortState = _useSortState.sortState,
      handleToggleSort = _useSortState.handleToggleSort,
      sortedSubscriptions = _useSortState.sortedItems;

  var closeModal = function closeModal() {
    return setSelectedSubscription(undefined);
  };

  return /*#__PURE__*/jsxs(Stack$1, {
    children: [/*#__PURE__*/jsxs(Grid, {
      gridTemplateColumns: "2fr 1fr 1fr 1fr 2fr",
      alignItems: "center",
      backgroundColor: "neutral-100",
      p: "24px 16px",
      gap: 4,
      borderBottom: "1px solid",
      borderColor: "neutral-200",
      children: [/*#__PURE__*/jsx$1(SortableHeader, {
        field: "SubscriptionTitle",
        label: "Subscription",
        sortState: sortState,
        onToggleSort: handleToggleSort
      }), /*#__PURE__*/jsx$1(SortableHeader, {
        field: "Interval",
        label: "Period",
        sortState: sortState,
        onToggleSort: handleToggleSort
      }), /*#__PURE__*/jsx$1(SortableHeader, {
        field: "LastBillingDate",
        label: "Last Billing Date",
        sortState: sortState,
        onToggleSort: handleToggleSort
      }), /*#__PURE__*/jsx$1(SortableHeader, {
        field: "NextBillingDate",
        label: "Next Billing Date",
        sortState: sortState,
        onToggleSort: handleToggleSort
      })]
    }), sortedSubscriptions ? sortedSubscriptions.filter(function (subscription) {
      return subscription.success;
    }).map(function (subscription) {
      return /*#__PURE__*/jsx$1(TableRow, {
        subscription: subscription,
        openModal: function openModal() {
          return setSelectedSubscription(subscription);
        }
      }, subscription.SubscriptionID);
    }) : Array.from({
      length: 4
    }).map(function (_, index) {
      return /*#__PURE__*/jsx$1(Skeleton, {
        height: "64px",
        borderRadius: "base"
      }, index);
    }), selectedSubscription && /*#__PURE__*/jsx$1(AdditionalDomainsModal, {
      isOpen: !!selectedSubscription,
      onClose: closeModal,
      primaryDomain: selectedSubscription.PrimaryConnectedDomain,
      additionalDomains: selectedSubscription.AdditionalConnectedDomains
    })]
  });
}

function SubscriptionsList() {
  var _useSubscriptions = useSubscriptions(),
      status = _useSubscriptions.status,
      showMore = _useSubscriptions.showMore,
      searchTerm = _useSubscriptions.searchTerm,
      subscriptions = _useSubscriptions.subscriptions,
      setSearchTerm = _useSubscriptions.setSearchTerm,
      totalSubscriptions = _useSubscriptions.totalSubscriptions;

  return /*#__PURE__*/jsxs(Stack$1, {
    gap: 3,
    children: [/*#__PURE__*/jsxs(Box, {
      justifyContent: "space-between",
      alignItems: "center",
      gap: 6,
      children: [/*#__PURE__*/jsxs(Stack$1, {
        gap: 2,
        width: ['100%', '50%', '50%'],
        children: [/*#__PURE__*/jsxs(Text, {
          variant: "heading-h5",
          fontWeight: "bold",
          color: "primary-600",
          style: {
            textTransform: 'capitalize'
          },
          children: [status, " Subscription List"]
        }), /*#__PURE__*/jsx$1(Text, {
          color: "primary-600",
          children: "Here, you'll find information about your account. You have the ability to review your Domain List, Active and Canceled Subscriptions, and Login History."
        })]
      }), /*#__PURE__*/jsx$1(Stack$1, {
        justifyContent: "end",
        height: "100%",
        children: /*#__PURE__*/jsx$1(StyledInput, {
          onChange: function onChange(e) {
            return setSearchTerm(e.target.value);
          },
          value: searchTerm,
          placeholder: "Type your subscription title"
        })
      })]
    }), /*#__PURE__*/jsx$1(ViewManager, {
      items: subscriptions,
      gridView: /*#__PURE__*/jsx$1(SubscriptionsListGrid, {}),
      tableView: /*#__PURE__*/jsx$1(SubscriptionsListTable, {})
    }), showMore && subscriptions && /*#__PURE__*/jsxs(Box, {
      gap: 5,
      alignItems: "center",
      mt: 5,
      children: [/*#__PURE__*/jsxs(Text, {
        color: "neutral-900",
        variant: "paragraph-large",
        children: ["Showing ", subscriptions.length, " of ", totalSubscriptions, ' ', status.toLowerCase(), " subscriptions"]
      }), /*#__PURE__*/jsx$1(Button, {
        disabled: !showMore,
        onClick: showMore,
        variant: "outlined",
        width: "fit-content",
        children: /*#__PURE__*/jsx$1(Text, {
          fontWeight: "semi",
          children: "Load 10 more"
        })
      })]
    })]
  });
}

function ActiveSubscriptions() {
  return /*#__PURE__*/jsxs(SubscriptionsProvider, {
    status: "active",
    children: [/*#__PURE__*/jsx$1(Header$1, {
      header: "My Account"
    }), /*#__PURE__*/jsx$1(Tabs, {
      tabs: TABS.myAccount
    }), /*#__PURE__*/jsx$1(SubscriptionsList, {})]
  });
}

function CanceledSubscriptions() {
  return /*#__PURE__*/jsxs(SubscriptionsProvider, {
    status: "cancelled",
    children: [/*#__PURE__*/jsx$1(Header$1, {
      header: "My Account"
    }), /*#__PURE__*/jsx$1(Tabs, {
      tabs: TABS.myAccount
    }), /*#__PURE__*/jsx$1(SubscriptionsList, {})]
  });
}

function MyAccountPage() {
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Header$1, {
      header: "My Account"
    }), /*#__PURE__*/jsxs(Router, {
      children: [/*#__PURE__*/jsx$1(Route, {
        component: DomainsListTab,
        path: "/domains",
        title: "My Domains"
      }), /*#__PURE__*/jsx$1(Route, {
        component: ActiveSubscriptions,
        path: "/active-subscriptions",
        title: "Active Subscriptions"
      }), /*#__PURE__*/jsx$1(Route, {
        component: CanceledSubscriptions,
        path: "/canceled-subscriptions",
        title: "Canceled Subscriptions"
      }), /*#__PURE__*/jsx$1(Route, {
        component: ContactsListTab,
        path: "/contacts",
        title: "Contacts"
      }), /*#__PURE__*/jsx$1(Redirect, {
        from: "*",
        to: "domains",
        noThrow: true
      })]
    })]
  });
}

function BillingHistory() {
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Header$1, {
      header: "Settings"
    }), /*#__PURE__*/jsx$1(Tabs, {
      tabs: TABS.settings
    }), /*#__PURE__*/jsx$1("h3", {
      children: "Billing History"
    })]
  });
}

function _regenerator$17() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$17(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$17(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$17(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$17(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$17(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$17(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$17(u), _regeneratorDefine2$17(u, o, "Generator"), _regeneratorDefine2$17(u, n, function () {
    return this;
  }), _regeneratorDefine2$17(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$17 = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$17(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$17 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$17(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$17(e, r, n, t);
}

var LoginHistoryContext = /*#__PURE__*/createContext(undefined);
var PAGINATION_COUNT = 10;

function LoginHistoryProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(),
      _useState2 = _slicedToArray$4(_useState, 2),
      loginHistory = _useState2[0],
      setLoginHistory = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray$4(_useState3, 2),
      searchTerm = _useState4[0],
      setSearchTerm = _useState4[1];

  var _useState5 = useState(PAGINATION_COUNT),
      _useState6 = _slicedToArray$4(_useState5, 2),
      visibleCount = _useState6[0],
      setVisibleCount = _useState6[1];

  var filteredHistory = useMemo(function () {
    if (!loginHistory) return undefined;
    var filtered = loginHistory;

    if (searchTerm && searchTerm.length > 2) {
      filtered = filtered.filter(function (login) {
        return login.loginDate.toLowerCase().includes(searchTerm.toLowerCase()) || login.browser.toLowerCase().includes(searchTerm.toLowerCase()) || login.loginResult.toLowerCase().includes(searchTerm.toLowerCase());
      });
    }

    return filtered.slice(0, visibleCount);
  }, [visibleCount, searchTerm, loginHistory]);
  var showMore = useMemo(function () {
    if (!loginHistory) return undefined;
    return loginHistory.length > visibleCount ? function () {
      return setVisibleCount(visibleCount + PAGINATION_COUNT);
    } : undefined;
  }, [loginHistory, visibleCount]);
  useEffect(function () {
    function loadLoginHistory() {
      return _loadLoginHistory.apply(this, arguments);
    }

    function _loadLoginHistory() {
      _loadLoginHistory = _asyncToGenerator( /*#__PURE__*/_regenerator$17().m(function _callee() {
        var _yield$api$user$fetch, _yield$api$user$fetch2, loginHistoryData, loginHistoryError;

        return _regenerator$17().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.n = 1;
                return api.user.fetchLoginHistory();

              case 1:
                _yield$api$user$fetch = _context.v;
                _yield$api$user$fetch2 = _slicedToArray$4(_yield$api$user$fetch, 2);
                loginHistoryData = _yield$api$user$fetch2[0];
                loginHistoryError = _yield$api$user$fetch2[1];

                if (!loginHistoryError) {
                  _context.n = 2;
                  break;
                }

                toast.error(loginHistoryError.message);
                return _context.a(2);

              case 2:
                setLoginHistory(loginHistoryData);

              case 3:
                return _context.a(2);
            }
          }
        }, _callee);
      }));
      return _loadLoginHistory.apply(this, arguments);
    }

    loadLoginHistory();
  }, []);
  return /*#__PURE__*/jsx$1(LoginHistoryContext.Provider, {
    value: {
      loginHistory: filteredHistory,
      showMore: showMore,
      searchTerm: searchTerm,
      setSearchTerm: setSearchTerm,
      totalLogins: loginHistory ? loginHistory.length : 0
    },
    children: children
  });
}

function useLoginHistory() {
  var context = useContext(LoginHistoryContext);

  if (!context) {
    throw new Error('useLoginHistory must be used within a LoginHistoryProvider');
  }

  return context;
}

function LoginHistoryGridCard(_ref) {
  var login = _ref.login;
  var loginDate = login.loginDate,
      ip = login.ip,
      browser = login.browser,
      loginResult = login.loginResult;
  return /*#__PURE__*/jsxs(Stack$1, {
    padding: "40px 24px 40px 24px",
    gap: 4,
    border: "1px solid",
    borderColor: "neutral-200",
    borderRadius: "base",
    backgroundColor: "card",
    children: [/*#__PURE__*/jsxs(Stack$1, {
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-small",
        color: "neutral-500",
        children: "Login Date"
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-medium",
        fontWeight: "bold",
        children: loginDate
      })]
    }), /*#__PURE__*/jsxs(Stack$1, {
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-small",
        color: "neutral-500",
        children: "IP Address"
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-small",
        fontWeight: "bold",
        children: ip
      })]
    }), /*#__PURE__*/jsxs(Stack$1, {
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-small",
        color: "neutral-500",
        children: "Browser"
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-small",
        fontWeight: "bold",
        children: browser
      })]
    }), /*#__PURE__*/jsxs(Stack$1, {
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-small",
        color: "neutral-500",
        children: "Result"
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-small",
        fontWeight: "bold",
        children: loginResult
      })]
    })]
  });
}

function LoginHistoryListGrid() {
  var _useLoginHistory = useLoginHistory(),
      loginHistory = _useLoginHistory.loginHistory;

  return /*#__PURE__*/jsx$1(Grid, {
    gridTemplateColumns: ['1fr', 'repeat(2, 1fr)', 'repeat(4, 1fr)'],
    gap: 3,
    children: loginHistory ? loginHistory.map(function (login, index) {
      return /*#__PURE__*/jsx$1(LoginHistoryGridCard, {
        login: login
      }, index);
    }) : // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Array.from({
      length: 4
    }).map(function (_, i) {
      return /*#__PURE__*/jsx$1(Skeleton, {
        borderRadius: "base",
        height: "400px"
      }, i);
    })
  });
}

function LoginHistoryListTable() {
  var _useLoginHistory = useLoginHistory(),
      loginHistory = _useLoginHistory.loginHistory;

  var _useSortState = useSortState(loginHistory),
      sortState = _useSortState.sortState,
      handleToggleSort = _useSortState.handleToggleSort,
      sortedLogins = _useSortState.sortedItems;

  return /*#__PURE__*/jsxs(Stack$1, {
    children: [/*#__PURE__*/jsxs(Grid, {
      gridTemplateColumns: "1fr 1fr 1fr 1fr",
      alignItems: "center",
      backgroundColor: "neutral-100",
      p: "24px 16px",
      gap: 4,
      borderBottom: "1px solid",
      borderColor: "neutral-200",
      children: [/*#__PURE__*/jsx$1(SortableHeader, {
        field: "loginDate",
        label: "Login Date",
        sortState: sortState,
        onToggleSort: handleToggleSort
      }), /*#__PURE__*/jsx$1(Text, {
        fontWeight: "medium",
        children: "IP Address"
      }), /*#__PURE__*/jsx$1(SortableHeader, {
        field: "browser",
        label: "Browser",
        sortState: sortState,
        onToggleSort: handleToggleSort
      }), /*#__PURE__*/jsx$1(SortableHeader, {
        field: "loginResult",
        label: "Result",
        sortState: sortState,
        onToggleSort: handleToggleSort
      })]
    }), sortedLogins ? sortedLogins.map(function (login, index) {
      return /*#__PURE__*/jsxs(Grid, {
        gridTemplateColumns: "1fr 1fr 1fr 1fr",
        alignItems: "center",
        p: "24px 16px",
        borderBottom: "1px solid",
        borderColor: "neutral-200",
        gap: 4,
        fontWeight: "medium",
        children: [/*#__PURE__*/jsx$1(Text, {
          children: login.loginDate
        }), /*#__PURE__*/jsx$1(Text, {
          children: login.ip
        }), /*#__PURE__*/jsx$1(Text, {
          children: login.browser
        }), /*#__PURE__*/jsx$1(Text, {
          children: login.loginResult
        })]
      }, index);
    }) : Array.from({
      length: 4
    }).map(function (_, index) {
      return /*#__PURE__*/jsx$1(Skeleton, {
        height: "64px",
        borderRadius: "base"
      }, index);
    })]
  });
}

function LoginHistoryComponent() {
  var _useLoginHistory = useLoginHistory(),
      loginHistory = _useLoginHistory.loginHistory,
      showMore = _useLoginHistory.showMore,
      totalLogins = _useLoginHistory.totalLogins,
      searchTerm = _useLoginHistory.searchTerm,
      setSearchTerm = _useLoginHistory.setSearchTerm;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Header$1, {
      header: "Settings"
    }), /*#__PURE__*/jsx$1(Tabs, {
      tabs: TABS.settings
    }), /*#__PURE__*/jsx$1(Stack$1, {
      gap: 3,
      children: /*#__PURE__*/jsxs(Box, {
        justifyContent: "space-between",
        alignItems: "center",
        gap: 6,
        children: [/*#__PURE__*/jsxs(Stack$1, {
          gap: 2,
          width: ['100%', '50%', '50%'],
          children: [/*#__PURE__*/jsx$1(Text, {
            variant: "heading-h5",
            fontWeight: "bold",
            color: "primary-600",
            children: "Login History"
          }), /*#__PURE__*/jsx$1(Text, {
            color: "primary-600",
            children: "Here, you'll find information about your account. You have the ability to review your Domain List, Active and Canceled Subscriptions, and Login History."
          })]
        }), /*#__PURE__*/jsx$1(Stack$1, {
          justifyContent: "end",
          height: "100%",
          children: /*#__PURE__*/jsx$1(StyledInput, {
            value: searchTerm,
            onChange: function onChange(e) {
              return setSearchTerm(e.target.value.trim());
            },
            placeholder: "Search login history"
          })
        })]
      })
    }), /*#__PURE__*/jsx$1(ViewManager, {
      items: loginHistory,
      gridView: /*#__PURE__*/jsx$1(LoginHistoryListGrid, {}),
      tableView: /*#__PURE__*/jsx$1(LoginHistoryListTable, {})
    }), showMore && loginHistory && /*#__PURE__*/jsxs(Box, {
      gap: 5,
      alignItems: "center",
      mt: 5,
      children: [/*#__PURE__*/jsxs(Text, {
        color: "neutral-900",
        variant: "paragraph-large",
        children: ["Showing ", loginHistory.length, " of ", totalLogins, " logins"]
      }), /*#__PURE__*/jsx$1(Button, {
        disabled: !showMore,
        onClick: showMore,
        variant: "outlined",
        width: "fit-content",
        children: /*#__PURE__*/jsx$1(Text, {
          fontWeight: "semi",
          children: "Load 10 more"
        })
      })]
    })]
  });
}

function LoginHistory() {
  return /*#__PURE__*/jsx$1(LoginHistoryProvider, {
    children: /*#__PURE__*/jsx$1(LoginHistoryComponent, {})
  });
}

function _regenerator$16() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$16(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$16(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$16(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$16(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$16(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$16(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$16(u), _regeneratorDefine2$16(u, o, "Generator"), _regeneratorDefine2$16(u, n, function () {
    return this;
  }), _regeneratorDefine2$16(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$16 = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$16(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$16 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$16(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$16(e, r, n, t);
}

function getInitConfig$1() {
  if (__PROD__) {
    var integrationIds = {
      'rebel.com': {
        site: 'rebelcom',
        publishableKey: 'live_mOw7LcCFU88NZYRKF5I8tbTgswQ2WMzI'
      },
      'rebel.ca': {
        site: 'rebelca',
        publishableKey: 'live_DWFaw0TRNVStp7rvDjPy7wR0U31Y1zAB'
      },
      'internic.ca': {
        site: 'internic',
        publishableKey: 'live_bTgUNScusijj1NqRNhReQ3cHNcurcaojJg'
      }
    };
    return integrationIds[RESELLER.toLowerCase()];
  } // DEV KEY


  return {
    site: 'rebelcom-test',
    publishableKey: 'test_UEImwBzjx4Pknt3fnoemXVpfAEtpcuR48'
  };
}

var SCRIPT_ID$1 = 'CHARGEBEE_JS_SCRIPT';

function loadAndExecuteScript$1() {
  if (document.getElementById(SCRIPT_ID$1)) {
    return Promise.resolve();
  }

  return new Promise(function (resolve) {
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://js.chargebee.com/v2/chargebee.js';
    script.id = SCRIPT_ID$1;

    script.onload = function () {
      return resolve(true);
    };

    document.head.appendChild(script);
  });
}

function useChargebeeJs() {
  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      hasChargeBeeInitialized = _useState2[0],
      setHasChargeBeeInitialized = _useState2[1];

  useEffect(function () {
    function initCBJS() {
      return _initCBJS.apply(this, arguments);
    }

    function _initCBJS() {
      _initCBJS = _asyncToGenerator( /*#__PURE__*/_regenerator$16().m(function _callee() {
        var _window$Chargebee;

        var cbInstance;
        return _regenerator$16().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                if (window.Chargebee) {
                  _context.n = 1;
                  break;
                }

                _context.n = 1;
                return loadAndExecuteScript$1();

              case 1:
                cbInstance = (_window$Chargebee = window.Chargebee) === null || _window$Chargebee === void 0 ? void 0 : _window$Chargebee.init(getInitConfig$1());

                if (cbInstance) {
                  _context.n = 2;
                  break;
                }

                return _context.a(2);

              case 2:
                setHasChargeBeeInitialized(true);

              case 3:
                return _context.a(2);
            }
          }
        }, _callee);
      }));
      return _initCBJS.apply(this, arguments);
    }

    initCBJS();
  }, []);
  return {
    hasChargeBeeInitialized: hasChargeBeeInitialized
  };
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


function __rest$1(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
} // Equality comparison for objects


function isEqual(left, right) {
  var OBJECT_STRING = '[object Object]';

  if (typeof left !== 'object' || typeof right !== 'object') {
    return left === right;
  }

  if (left === null || right === null) return left === right;
  var leftArray = Array.isArray(left);
  var rightArray = Array.isArray(right);
  if (leftArray !== rightArray) return false;
  var leftPlainObject = Object.prototype.toString.call(left) === OBJECT_STRING;
  var rightPlainObject = Object.prototype.toString.call(right) === OBJECT_STRING;
  if (leftPlainObject !== rightPlainObject) return false;
  if (!leftPlainObject && !leftArray) return false;
  var leftKeys = Object.keys(left);
  var rightKeys = Object.keys(right);
  if (leftKeys.length !== rightKeys.length) return false;
  var keySet = {};

  for (var _i16 = 0; _i16 < leftKeys.length; _i16 += 1) {
    keySet[leftKeys[_i16]] = true;
  }

  for (var _i17 = 0; _i17 < rightKeys.length; _i17 += 1) {
    keySet[rightKeys[_i17]] = true;
  }

  var allKeys = Object.keys(keySet);

  if (allKeys.length !== leftKeys.length) {
    return false;
  }

  var l = left;
  var r = right;

  var pred = function pred(key) {
    return isEqual(l[key], r[key]);
  };

  return allKeys.every(pred);
}

function genUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

function validateCbInstance(cbInstance) {
  if (cbInstance != null) {
    var site = cbInstance.site;
    var key = cbInstance.publishableKey;
    if (!(site != null && typeof site == "string" && site.length > 0)) return false;
    if (!(key != null && typeof key == "string" && key.length > 0)) return false;
    return true;
  } else return false;
}

function makeCancelablePromise(promise) {
  var isCancelled = false;

  var _resolve;

  var wrappedPromise = new Promise(function (resolve, reject) {
    _resolve = resolve;
    promise.then(function (value) {
      return resolve({
        isCancelled: isCancelled,
        value: value
      });
    }).catch(function (error) {
      return reject({
        isCancelled: isCancelled,
        error: error
      });
    });
  });
  return {
    promise: wrappedPromise,
    cancel: function cancel() {
      isCancelled = true;

      _resolve({
        isCancelled: isCancelled
      });
    }
  };
}

var Element$1 = /*#__PURE__*/function (_React$Component4) {
  _inherits2(Element$1, _React$Component4);

  var _super48 = _createSuper2(Element$1);

  function Element$1(props) {
    var _this31;

    _classCallCheck2(this, Element$1);

    _this31 = _super48.call(this, props);
    _this31.field = null;
    _this31.id = "card-".concat(props.type, "-").concat(genUUID());
    _this31.ElementRef = React.createRef();
    return _this31;
  }

  _createClass2(Element$1, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props15 = this.props,
          cbComponent = _this$props15.cbComponent,
          type = _this$props15.type,
          listeners = _this$props15.listeners;
      var options = this.getPropOptions(this.props);
      this.field = cbComponent.createField(type, options).at("#".concat(this.id)); // Attaching listeners if any

      if (listeners) {
        if (listeners.onBlur) this.field.on('blur', listeners.onBlur);
        if (listeners.onFocus) this.field.on('focus', listeners.onFocus);
        if (listeners.onReady) this.field.on('ready', listeners.onReady);
        if (listeners.onChange) this.field.on('change', listeners.onChange);
      }
    }
  }, {
    key: "getPropOptions",
    value: function getPropOptions(props) {
      var icon = props.icon,
          style = props.styles,
          placeholder = props.placeholder,
          ariaLabel = props.ariaLabel;
      return {
        icon: icon,
        style: style,
        placeholder: placeholder,
        ariaLabel: ariaLabel
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevOptions = this.getPropOptions(prevProps);
      var currentOptions = this.getPropOptions(this.props);

      if (!isEqual(prevOptions, currentOptions) && this.field) {
        this.field.update(currentOptions);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.field.destroy();
    }
  }, {
    key: "focus",
    value: function focus() {
      this.field.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.field.blur();
    }
  }, {
    key: "clear",
    value: function clear() {
      this.field.clear();
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      return React.createElement("div", {
        id: this.id,
        ref: this.ElementRef,
        className: className
      }, this.props.children);
    }
  }]);

  return Element$1;
}(React.Component);

var ComponentDefaultContext = {
  cbComponent: null
};
var ComponentContext = React.createContext(ComponentDefaultContext);

function getPropOptions(props) {
  var fonts = props.fonts,
      classes = props.classes,
      icon = props.icon,
      style = props.styles,
      showTestCards = props.showTestCards,
      locale = props.locale,
      placeholder = props.placeholder,
      currency = props.currency,
      ariaLabel = props.ariaLabel;
  return {
    fonts: fonts,
    classes: classes,
    locale: locale,
    style: style,
    showTestCards: showTestCards,
    placeholder: placeholder,
    ariaLabel: ariaLabel,
    icon: icon,
    currency: currency
  };
}

var FieldContainer = /*#__PURE__*/function (_React$Component5) {
  _inherits2(FieldContainer, _React$Component5);

  var _super49 = _createSuper2(FieldContainer);

  function FieldContainer(props) {
    var _this32;

    _classCallCheck2(this, FieldContainer);

    _this32 = _super49.call(this, props);
    _this32.containerRef = React.createRef();
    _this32.id = "".concat(_this32.props.type, "-field-").concat(genUUID());
    _this32.state = {
      cbComponent: null,
      cbInstance: _this32.props.cbInstance,
      id: _this32.id,
      ready: false
    };
    return _this32;
  }

  _createClass2(FieldContainer, [{
    key: "createCardComponent",
    value: function createCardComponent() {
      var _this$props16 = this.props,
          type = _this$props16.type,
          onBlur = _this$props16.onBlur,
          onChange = _this$props16.onChange,
          onFocus = _this$props16.onFocus,
          onReady = _this$props16.onReady,
          onKeyPress = _this$props16.onKeyPress;
      var options = getPropOptions(this.props);
      var cbComponent = this.props.cbInstance.createComponent(type, options); // Attach listeners if specified (only applicable for combined field)

      if (onReady) cbComponent.on('ready', onReady);
      if (onBlur) cbComponent.on('blur', onBlur);
      if (onFocus) cbComponent.on('focus', onFocus);
      if (onChange) cbComponent.on('change', onChange);
      if (onKeyPress) cbComponent.on('keyPress', onKeyPress);
      return cbComponent;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.cbComponent) {
        this.state.cbComponent.destroy();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var cbComponent = this.state.cbComponent;
      var prevOptions = getPropOptions(prevProps);
      var currentOptions = getPropOptions(this.props);

      if (!isEqual(prevOptions, currentOptions) && cbComponent) {
        cbComponent.update(currentOptions);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this33 = this;

      var cbComponent = this.createCardComponent();
      this.setState({
        cbComponent: cbComponent,
        ready: true
      }, function () {
        if (_this33.state.cbComponent && _this33.state.cbComponent.status === 0) {
          if (_this33.containerRef.current) {
            _this33.state.cbComponent.mount(_this33.containerRef.current);
          }
        }
      });
    }
  }, {
    key: "tokenize",
    value: function tokenize(additionalData) {
      var cbComponent = this.state.cbComponent;
      return cbComponent.tokenize(additionalData);
    }
  }, {
    key: "authorizeWith3ds",
    value: function authorizeWith3ds(paymentIntent, additionalData, callbacks) {
      var cbComponent = this.state.cbComponent;
      return cbComponent.authorizeWith3ds(paymentIntent, additionalData, callbacks);
    }
  }, {
    key: "focus",
    value: function focus() {
      var cbComponent = this.state.cbComponent;
      cbComponent.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      var cbComponent = this.state.cbComponent;
      cbComponent.blur();
    }
  }, {
    key: "clear",
    value: function clear() {
      var cbComponent = this.state.cbComponent;
      cbComponent.clear();
    }
  }, {
    key: "render",
    value: function render() {
      var ready = this.state.ready; // Destructure ready state

      return React.createElement(ComponentContext.Provider, {
        value: this.state
      }, React.createElement("div", {
        ref: this.containerRef,
        id: this.id,
        className: this.props.className || ''
      }, ready && this.props.children || []));
    }
  }]);

  return FieldContainer;
}(React.Component);

var CardNumber = React.forwardRef(function (props, ref) {
  var onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      onReady = props.onReady,
      rest = __rest$1(props, ["onBlur", "onChange", "onFocus", "onReady"]);

  var listeners = {
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    onReady: onReady
  };
  return React.createElement(ComponentContext.Consumer, null, function (ctx) {
    return React.createElement(Element$1, Object.assign({
      type: 'number',
      cbComponent: ctx.cbComponent,
      ref: ref,
      listeners: listeners
    }, rest));
  });
});
var CardExpiry = React.forwardRef(function (props, ref) {
  var onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      onReady = props.onReady,
      rest = __rest$1(props, ["onBlur", "onChange", "onFocus", "onReady"]);

  var listeners = {
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    onReady: onReady
  };
  return React.createElement(ComponentContext.Consumer, null, function (ctx) {
    return React.createElement(Element$1, Object.assign({
      type: 'expiry',
      cbComponent: ctx.cbComponent,
      ref: ref,
      listeners: listeners
    }, rest));
  });
});
var CardCVV = React.forwardRef(function (props, ref) {
  var onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      onReady = props.onReady,
      rest = __rest$1(props, ["onBlur", "onChange", "onFocus", "onReady"]);

  var listeners = {
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    onReady: onReady
  };
  return React.createElement(ComponentContext.Consumer, null, function (ctx) {
    return React.createElement(Element$1, Object.assign({
      type: 'cvv',
      cbComponent: ctx.cbComponent,
      ref: ref,
      listeners: listeners
    }, rest));
  });
});

var ChargebeeComponents = /*#__PURE__*/function (_React$Component6) {
  _inherits2(ChargebeeComponents, _React$Component6);

  var _super50 = _createSuper2(ChargebeeComponents);

  function ChargebeeComponents(props) {
    var _this34;

    _classCallCheck2(this, ChargebeeComponents);

    _this34 = _super50.call(this, props);
    _this34.state = {
      moduleLoaded: false,
      cbInstance: null
    };
    return _this34;
  }

  _createClass2(ChargebeeComponents, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.loader.cancel();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this35 = this;

      // @ts-ignore
      var cbInstance = Chargebee.getInstance();
      this.loader = makeCancelablePromise(cbInstance.load("components"));
      this.loader.promise.then(function (_ref73) {
        var isCancelled = _ref73.isCancelled;

        if (isCancelled) {
          return;
        }

        _this35.setState({
          cbInstance: cbInstance,
          moduleLoaded: true
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          forwardedRef = _a.forwardedRef,
          rest = __rest$1(_a, ["forwardedRef"]);

      return React.createElement(React.Fragment, null, this.state.moduleLoaded ? React.createElement(FieldContainer, Object.assign({
        ref: forwardedRef
      }, Object.assign(Object.assign({}, rest), {
        cbInstance: this.state.cbInstance
      }))) : '');
    }
  }]);

  return ChargebeeComponents;
}(React.Component);

var CardComponent = React.forwardRef(function (props, ref) {
  return React.createElement(ChargebeeComponents, Object.assign({
    type: 'card',
    forwardedRef: ref
  }, props));
});
React.forwardRef(function (props, ref) {
  if (props.cbInstance && validateCbInstance(props.cbInstance)) {
    return React.createElement(React.Fragment, null, props.children);
  } else {
    return null;
  }
});

function _regenerator$15() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$15(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$15(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$15(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$15(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$15(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$15(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$15(u), _regeneratorDefine2$15(u, o, "Generator"), _regeneratorDefine2$15(u, n, function () {
    return this;
  }), _regeneratorDefine2$15(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$15 = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$15(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$15 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$15(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$15(e, r, n, t);
}

function ownKeys$1u(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1u(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1u(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1u(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var addNewPayPal = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$15().m(function _callee(_ref) {
    var card, _yield$post, _yield$post$data, success, message;

    return _regenerator$15().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            card = _ref.card;
            _context.n = 1;
            return post$1(creditCardEndpoints.card, _objectSpread$1u({}, card));

          case 1:
            _yield$post = _context.v;
            _yield$post$data = _yield$post.data;
            success = _yield$post$data.success;
            message = _yield$post$data.message;

            if (success) {
              _context.n = 2;
              break;
            }

            throw new Error(message);

          case 2:
            return _context.a(2);
        }
      }
    }, _callee);
  }));

  return function addNewPayPal(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var setupPayPal = function setupPayPal() {
  window.paypal.checkout.setup(LS.getItem(storageKeys.MerchantId), {
    locale: 'en_US',
    environment: LS.getItem(storageKeys.PaypalEnv),
    container: ['payPalAgreement']
  });
};

var insertPayPalScript = function insertPayPalScript() {
  var scripts = _toConsumableArray$1(document.getElementsByTagName('script'));

  var isPayPalLoaded = scripts.some(function (script) {
    return script.src.includes(payPalUrl);
  });

  if (isPayPalLoaded) {
    setupPayPal();
    return;
  }

  var script = document.createElement('script');
  script.async = true;
  script.defer = true;
  script.src = payPalUrl;
  document.body.appendChild(script);
  script.onload = setupPayPal;
};

var _excluded$A = ["children", "payPal", "preSubmit"];

function ownKeys$1t(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1t(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1t(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1t(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var propTypes$1s = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  payPal: PropTypes.shape({
    cancelUrl: PropTypes.string,
    returnUrl: PropTypes.string
  })
};
var defaultProps$N = {
  payPal: {
    cancelUrl: '/my-account/settings/payment',
    returnUrl: '/my-account/settings/payment'
  }
};

function PayPalButton(_ref) {
  var children = _ref.children,
      payPal = _ref.payPal,
      _ref$preSubmit = _ref.preSubmit,
      preSubmit = _ref$preSubmit === void 0 ? null : _ref$preSubmit,
      rest = _objectWithoutProperties$8(_ref, _excluded$A);

  var _useState = useState(true),
      _useState2 = _slicedToArray$4(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var payPalButton = useRef(null);
  var payPalContainer = useRef(null);
  useEffect(function () {
    insertPayPalScript();
    var payPalPolling = setInterval(function () {
      payPalContainer.current = document.querySelector('#payPalAgreement');
      payPalButton.current = document.querySelector('#payPalAgreement button');

      if (payPalContainer.current && payPalButton.current) {
        setLoading(false);
      }
    }, 200);
    return function () {
      clearInterval(payPalPolling);
    };
  }, []);

  var handlePaypal = function handlePaypal() {
    if (preSubmit) {
      preSubmit();
    }

    if (payPalContainer.current) {
      payPalContainer.current.href = "/MyAccount/PayPalAuthentication.aspx?r=".concat(payPal.returnUrl, "&c=").concat(payPal.cancelUrl);

      if (payPalButton.current) {
        if (hasDOM && window.history) {
          window.history.replaceState({}, document.title, window.location.pathname);
        }

        payPalButton.current.click();
      }
    }
  };

  var payPalHidden = css$3(["clip:rect(0 0 0 0);clip-path:inset(50%);height:1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px;"]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Button$1, _objectSpread$1t(_objectSpread$1t({}, rest), {}, {
      disabled: loading,
      id: "add-paypal",
      onClick: handlePaypal,
      children: children
    })), /*#__PURE__*/jsx$1(_StyledA, {
      "aria-hidden": "true",
      href: "/#",
      id: "payPalAgreement",
      $_css: payPalHidden,
      children: "paypal"
    })]
  });
}

PayPalButton.propTypes = propTypes$1s;
PayPalButton.defaultProps = defaultProps$N;

var _StyledA = styled("a").withConfig({
  displayName: "paypal-button___StyledA",
  componentId: "sc-6k9zrb-0"
})(["", ""], function (p) {
  return p.$_css;
});

function OpenPayPalButton() {
  return /*#__PURE__*/jsx$1(Fragment, {
    children: /*#__PURE__*/jsx$1(ThemeProvider, {
      theme: theme,
      children: /*#__PURE__*/jsx$1(_StyledPayPalButton$1, {
        payPal: {
          cancelUrl: '/dashboard/settings/payment-settings',
          returnUrl: '/dashboard/settings/payment-settings'
        },
        variant: "inverse",
        width: "121px",
        height: "101px",
        style: {
          borderColor: '#E5E7EB',
          borderRadius: '8px'
        },
        children: /*#__PURE__*/jsxs("svg", {
          width: "85",
          height: "74",
          viewBox: "0 0 85 74",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [/*#__PURE__*/jsx$1("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.58 51.1389H4.04645C3.59934 51.1389 3.21909 51.4645 3.14937 51.9066L0.506854 68.6939C0.454332 69.0253 0.710358 69.3239 1.0457 69.3239H4.16489C4.61199 69.3239 4.99224 68.9983 5.06196 68.5553L5.77468 64.0276C5.84343 63.5841 6.22462 63.259 6.67079 63.259H8.7391C13.043 63.259 15.5268 61.1721 16.1758 57.0368C16.468 55.2277 16.1881 53.8061 15.3424 52.8103C14.414 51.7175 12.7667 51.1389 10.58 51.1389ZM11.3338 57.2703C10.9766 59.6194 9.18527 59.6194 7.45323 59.6194H6.46729L7.15897 55.2321C7.20004 54.9672 7.42931 54.7719 7.69683 54.7719H8.14871C9.32856 54.7719 10.4416 54.7719 11.0168 55.4456C11.3595 55.8479 11.4647 56.445 11.3338 57.2703ZM30.1105 57.195H26.9817C26.7151 57.195 26.4848 57.3903 26.4437 57.6557L26.3053 58.5323L26.0865 58.2147C25.4092 57.2295 23.8989 56.9004 22.3913 56.9004C18.9336 56.9004 15.9808 59.5242 15.4056 63.2049C15.1068 65.0407 15.5316 66.7962 16.571 68.0206C17.5246 69.1462 18.889 69.6153 20.5119 69.6153C23.2977 69.6153 24.8428 67.8204 24.8428 67.8204L24.7031 68.6917C24.6505 69.0249 24.9065 69.3234 25.2398 69.3234H28.0583C28.5066 69.3234 28.8846 68.9978 28.9553 68.5548L30.6463 57.8249C30.6998 57.4949 30.4447 57.195 30.1105 57.195ZM25.7491 63.2966C25.4472 65.0876 24.0285 66.2899 22.2194 66.2899C21.3108 66.2899 20.5845 65.9979 20.1185 65.4447C19.656 64.8954 19.4801 64.1131 19.6273 63.2421C19.9094 61.4662 21.3519 60.225 23.1336 60.225C24.0218 60.225 24.7442 60.5204 25.2199 61.0786C25.6965 61.6425 25.8857 62.4293 25.7491 63.2966ZM43.6297 57.1945H46.7739C47.2143 57.1945 47.4712 57.6893 47.2209 58.0513L36.7638 73.1756C36.5944 73.4206 36.3155 73.5663 36.0175 73.5663H32.8772C32.4351 73.5663 32.1769 73.0675 32.4329 72.7047L35.689 68.0995L32.226 57.9161C32.1062 57.5622 32.367 57.1945 32.7428 57.1945H35.8323C36.2337 57.1945 36.5878 57.4586 36.7037 57.8435L38.5415 63.9939L42.8781 57.5937C43.0479 57.3438 43.3299 57.1945 43.6297 57.1945Z",
            fill: "#253B80"
          }), /*#__PURE__*/jsx$1("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M77.7192 68.6938L80.4006 51.5995C80.4417 51.3342 80.6711 51.1388 80.9377 51.138H83.9564C84.2898 51.138 84.5457 51.4374 84.4931 51.7688L81.8489 68.5552C81.7799 68.9982 81.3997 69.3238 80.9519 69.3238H78.2559C77.9226 69.3238 77.6666 69.0252 77.7192 68.6938ZM57.1838 51.1388H50.649C50.2029 51.1388 49.8227 51.4644 49.7529 51.9065L47.1104 68.6938C47.0578 69.0252 47.3138 69.3238 47.6476 69.3238H51.0005C51.3122 69.3238 51.5788 69.0961 51.6274 68.786L52.3772 64.0274C52.4462 63.584 52.8273 63.2589 53.2734 63.2589H55.3406C59.6454 63.2589 62.1287 61.172 62.7782 57.0367C63.0713 55.2276 62.7897 53.806 61.9444 52.8102C61.0164 51.7174 59.3704 51.1388 57.1838 51.1388ZM57.9376 57.2702C57.5812 59.6193 55.7898 59.6193 54.0568 59.6193H53.0717L53.7645 55.232C53.8056 54.9671 54.0329 54.7717 54.3013 54.7717H54.7531C55.9322 54.7717 57.0463 54.7717 57.621 55.4455C57.9641 55.8478 58.0684 56.4449 57.9376 57.2702ZM76.7125 57.1949H73.5859C73.3171 57.1949 73.089 57.3902 73.0488 57.6556L72.9104 58.5322L72.6907 58.2146C72.0134 57.2294 70.504 56.9003 68.9964 56.9003C65.5387 56.9003 62.5868 59.5241 62.0116 63.2048C61.7136 65.0406 62.1367 66.7961 63.1761 68.0205C64.1315 69.1461 65.4941 69.6152 67.117 69.6152C69.9027 69.6152 71.4475 67.8203 71.4475 67.8203L71.3082 68.6916C71.2556 69.0247 71.5116 69.3233 71.8471 69.3233H74.6642C75.1103 69.3233 75.4905 68.9977 75.5604 68.5547L77.2523 57.8248C77.304 57.4948 77.0481 57.1949 76.7125 57.1949ZM72.3516 63.2965C72.0514 65.0875 70.6309 66.2898 68.8214 66.2898C67.9146 66.2898 67.1869 65.9978 66.7205 65.4446C66.258 64.8953 66.0843 64.1129 66.2297 63.242C66.5131 61.4661 67.9539 60.2249 69.7356 60.2249C70.6243 60.2249 71.3462 60.5203 71.8224 61.0785C72.3007 61.6424 72.49 62.4292 72.3516 63.2965Z",
            fill: "#179BD7"
          }), /*#__PURE__*/jsx$1("path", {
            d: "M34.7591 45.1334L35.5624 40.0213L33.7732 39.9797H25.2295L31.167 2.25689C31.1851 2.143 31.2452 2.03682 31.3328 1.96142C31.4203 1.88603 31.5326 1.84447 31.6493 1.84447H46.0553C50.8381 1.84447 54.1384 2.84167 55.8617 4.8099C56.6694 5.73325 57.184 6.69811 57.433 7.75994C57.6938 8.87414 57.6987 10.2053 57.4436 11.8288L57.425 11.9473V12.9875L58.2332 13.4462C58.9136 13.8078 59.4538 14.2217 59.8685 14.6957C60.56 15.4852 61.0069 16.4885 61.1957 17.6781C61.3907 18.9015 61.3261 20.3573 61.0069 22.0055C60.6382 23.9014 60.0423 25.5526 59.2376 26.9037C58.4971 28.1487 57.5541 29.1811 56.4347 29.9815C55.3657 30.7417 54.0955 31.3189 52.6595 31.6884C51.2678 32.0512 49.6815 32.2346 47.9414 32.2346H46.8202C46.0187 32.2346 45.2397 32.5238 44.6287 33.0426C44.0159 33.5719 43.6101 34.2949 43.4858 35.086L43.4014 35.5463L41.9822 44.5561L41.9177 44.8871C41.9009 44.992 41.8717 45.0443 41.8288 45.0798C41.7904 45.1116 41.7351 45.1334 41.6811 45.1334H34.7591Z",
            fill: "#253B80"
          }), /*#__PURE__*/jsx$1("path", {
            d: "M58.9983 12.0678C58.9554 12.3432 58.9063 12.6249 58.8511 12.9142C56.9509 22.6877 50.4515 26.064 42.1501 26.064H37.9235C36.9084 26.064 36.053 26.8026 35.8947 27.806L33.7306 41.5577L33.1178 45.4555C33.0148 46.1142 33.5219 46.7082 34.1851 46.7082H41.6819C42.5696 46.7082 43.3234 46.0619 43.4631 45.1848L43.5369 44.8029L44.9486 35.8281L45.0392 35.336C45.1772 34.4557 45.9327 33.8094 46.8205 33.8094H47.9417C55.2046 33.8094 60.8905 30.8547 62.5524 22.3045C63.2465 18.7327 62.8871 15.7504 61.0501 13.6528C60.4944 13.0203 59.8047 12.4956 58.9983 12.0678Z",
            fill: "#179BD7"
          }), /*#__PURE__*/jsx$1("path", {
            d: "M57.0099 11.2744C56.7199 11.1897 56.4201 11.1128 56.1128 11.0436C55.8043 10.9759 55.4877 10.9158 55.1623 10.8635C54.0226 10.6788 52.7741 10.5911 51.4362 10.5911H40.1448C39.8668 10.5911 39.6028 10.6542 39.3663 10.7681C38.8455 11.0189 38.4587 11.5129 38.3649 12.1177L35.9625 27.362L35.8936 27.8067C36.0518 26.8033 36.9073 26.0646 37.9224 26.0646H42.1489C50.4503 26.0646 56.9502 22.6868 58.8499 12.9148C58.9065 12.6255 58.9543 12.3439 58.9971 12.0685C58.5166 11.813 57.9958 11.5945 57.4352 11.4083C57.2972 11.3621 57.1545 11.3175 57.0099 11.2744Z",
            fill: "#222D65"
          }), /*#__PURE__*/jsx$1("path", {
            d: "M38.365 12.1174C38.4587 11.5126 38.846 11.0186 39.3664 10.7693C39.6047 10.6554 39.8673 10.5923 40.1449 10.5923H51.4367C52.7746 10.5923 54.0231 10.68 55.1624 10.8647C55.4882 10.917 55.8048 10.977 56.1133 11.0447C56.4206 11.114 56.7199 11.191 57.0104 11.2756C57.1545 11.3187 57.2973 11.3633 57.437 11.4079C57.9976 11.5941 58.5184 11.8142 58.999 12.0681C59.5644 8.45633 58.9946 5.99719 57.0458 3.77041C54.8971 1.31898 51.019 0.269463 46.0568 0.269463H31.6503C30.6365 0.269463 29.7722 1.00809 29.6153 2.013L23.615 40.1236C23.4965 40.8775 24.077 41.558 24.8357 41.558H33.73L35.963 27.3616L38.365 12.1174Z",
            fill: "#253B80"
          })]
        })
      })
    })
  });
}

var _StyledPayPalButton$1 = styled(PayPalButton).withConfig({
  displayName: "paypal-button___StyledPayPalButton",
  componentId: "sc-1w76ys6-0"
})(["&:hover{transition:all 0.2s ease;transform:scale(1.02);}"]);

function ownKeys$1s(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1s(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1s(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1s(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _regenerator$14() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$14(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$14(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$14(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$14(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$14(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$14(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$14(u), _regeneratorDefine2$14(u, o, "Generator"), _regeneratorDefine2$14(u, n, function () {
    return this;
  }), _regeneratorDefine2$14(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$14 = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$14(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$14 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$14(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$14(e, r, n, t);
}

var schema$2 = objectType({
  ccFirstName: stringType().min(1, 'First name required'),
  ccLastName: stringType().min(1, 'Last name required'),
  ccIsPrimary: booleanType().optional()["default"](false),
  ccIsBackup: booleanType().optional()["default"](false)
});

function PaymentCardForm(_ref) {
  var setIsOpen = _ref.setIsOpen;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isSubmitting = _useState2[0],
      setIsSubmitting = _useState2[1];

  var _useState3 = useState('unknown'),
      _useState4 = _slicedToArray$4(_useState3, 2),
      cardType = _useState4[0],
      setCardType = _useState4[1];

  var cardRef = useRef(null);

  var _useUserService = useUserService(),
      creditCards = _useUserService.user.creditCards,
      fetchUserInfo = _useUserService.fetchUserInfo; // Chargebee validation state


  var _useState5 = useState(null),
      _useState6 = _slicedToArray$4(_useState5, 2),
      cardNumberValid = _useState6[0],
      setCardNumberValid = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray$4(_useState7, 2),
      cardExpiryValid = _useState8[0],
      setCardExpiryValid = _useState8[1];

  var _useState9 = useState(null),
      _useState0 = _slicedToArray$4(_useState9, 2),
      cardCVVValid = _useState0[0],
      setCardCVVValid = _useState0[1];

  function isChargeBeeCardInfoValid() {
    if (cardNumberValid !== true || cardExpiryValid !== true || cardCVVValid !== true) {
      toast.error('Please fill in all card details correctly'); // Mark any missing validation to show errors

      if (cardNumberValid !== true) setCardNumberValid(false);
      if (cardExpiryValid !== true) setCardExpiryValid(false);
      if (cardCVVValid !== true) setCardCVVValid(false);
    }

    return cardNumberValid === true && cardExpiryValid === true && cardCVVValid === true;
  }

  function addCardWithToken(_x, _x2, _x3, _x4) {
    return _addCardWithToken.apply(this, arguments);
  }

  function _addCardWithToken() {
    _addCardWithToken = _asyncToGenerator( /*#__PURE__*/_regenerator$14().m(function _callee2(token, kindOfCard, ccIsPrimary, ccIsBackup) {
      var ccRole, _yield$api$creditCard, _yield$api$creditCard2, error;

      return _regenerator$14().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              ccRole = 'none';

              if (ccIsPrimary) {
                ccRole = 'primary';
              } else if (ccIsBackup) {
                ccRole = 'backup';
              }

              _context2.n = 1;
              return api.creditCards.addCard(token, kindOfCard, ccRole);

            case 1:
              _yield$api$creditCard = _context2.v;
              _yield$api$creditCard2 = _slicedToArray$4(_yield$api$creditCard, 2);
              error = _yield$api$creditCard2[1];

              if (!error) {
                _context2.n = 2;
                break;
              }

              toast.error(error);
              _context2.n = 3;
              break;

            case 2:
              toast.success('Successfully added card!');
              _context2.n = 3;
              return fetchUserInfo();

            case 3:
              return _context2.a(2);
          }
        }
      }, _callee2);
    }));
    return _addCardWithToken.apply(this, arguments);
  }

  var saveCard = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$14().m(function _callee(values) {
      var _yield$cardRef$curren, token;

      return _regenerator$14().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              if (isChargeBeeCardInfoValid()) {
                _context.n = 1;
                break;
              }

              return _context.a(2);

            case 1:
              if (cardRef.current) {
                _context.n = 2;
                break;
              }

              return _context.a(2);

            case 2:
              setIsSubmitting(true);
              _context.p = 3;
              _context.n = 4;
              return cardRef.current.tokenize({
                firstName: values.ccFirstName,
                lastName: values.ccLastName
              });

            case 4:
              _yield$cardRef$curren = _context.v;
              token = _yield$cardRef$curren.token;
              _context.n = 5;
              return addCardWithToken(token, cardType, values.ccIsPrimary, values.ccIsBackup);

            case 5:
              setIsOpen(false);
              _context.n = 7;
              break;

            case 6:
              _context.p = 6;
              toast.error('Failed to add card');

            case 7:
              setIsSubmitting(false);

            case 8:
              return _context.a(2);
          }
        }
      }, _callee, null, [[3, 6]]);
    }));

    return function saveCard(_x5) {
      return _ref2.apply(this, arguments);
    };
  }();

  var methods = useForm({
    resolver: zodResolver(schema$2),
    defaultValues: {
      ccFirstName: '',
      ccLastName: '',
      ccIsPrimary: false,
      ccIsBackup: false
    }
  });
  var handleSubmit = methods.handleSubmit;

  function onCardNumberBlur(e) {
    var _e$complete;

    if (e.cardType) setCardType(e.cardType);
    setCardNumberValid((_e$complete = e.complete) !== null && _e$complete !== void 0 ? _e$complete : false);
  }

  function onCardExpiryBlur(e) {
    var _e$complete2;

    setCardExpiryValid((_e$complete2 = e.complete) !== null && _e$complete2 !== void 0 ? _e$complete2 : false);
  }

  function onCardCVVBlur(e) {
    var _e$complete3;

    setCardCVVValid((_e$complete3 = e.complete) !== null && _e$complete3 !== void 0 ? _e$complete3 : false);
  }

  return /*#__PURE__*/jsx$1(FormProvider, _objectSpread$1s(_objectSpread$1s({}, methods), {}, {
    children: /*#__PURE__*/jsxs("form", {
      onSubmit: function onSubmit(e) {
        e.preventDefault();
        handleSubmit(saveCard)(e);
      },
      children: [/*#__PURE__*/jsx$1(Box, {
        border: "1px solid",
        borderColor: "neutral-200",
        borderRadius: "base",
        width: "100%",
        children: /*#__PURE__*/jsx$1(Stack$1, {
          ml: "24px",
          mr: "24px",
          mb: "16px",
          mt: "16px",
          width: "100%",
          children: /*#__PURE__*/jsx$1(CardComponent, {
            ref: cardRef,
            children: /*#__PURE__*/jsxs(Stack$1, {
              children: [/*#__PURE__*/jsxs(Stack$1, {
                mb: "24px",
                children: [/*#__PURE__*/jsx$1(Text, {
                  variant: "paragraph-xsmall",
                  color: "neutral-500",
                  children: "Card Number"
                }), /*#__PURE__*/jsx$1(Box, {
                  p: "8px 16px",
                  borderBottom: "1px solid",
                  borderColor: cardNumberValid === false ? 'destructive-400' : 'neutral-200',
                  display: "block",
                  children: /*#__PURE__*/jsx$1(CardNumber, {
                    placeholder: "1111 1111 1111 1111",
                    onBlur: onCardNumberBlur
                  })
                }), cardNumberValid === false && /*#__PURE__*/jsx$1(Text, {
                  color: "destructive-400",
                  variant: "paragraph-xsmall",
                  mt: "4px",
                  children: "Please enter a valid card number"
                })]
              }), /*#__PURE__*/jsxs(Box, {
                width: "100%",
                children: [/*#__PURE__*/jsx$1(Stack$1, {
                  width: "100%",
                  children: /*#__PURE__*/jsx$1(FormInput, {
                    width: "100%",
                    label: "First Name",
                    name: "ccFirstName",
                    placeholder: "Jane"
                  })
                }), /*#__PURE__*/jsx$1(Stack$1, {
                  ml: "24px",
                  width: "100%",
                  children: /*#__PURE__*/jsx$1(FormInput, {
                    width: "100%",
                    label: "Last Name",
                    name: "ccLastName",
                    placeholder: "Doe"
                  })
                })]
              }), /*#__PURE__*/jsxs(Box, {
                mt: "24px",
                children: [/*#__PURE__*/jsxs(Stack$1, {
                  mb: "8px",
                  width: "100%",
                  children: [/*#__PURE__*/jsx$1(Text, {
                    variant: "paragraph-xsmall",
                    color: "neutral-500",
                    children: "Expiry"
                  }), /*#__PURE__*/jsx$1(Box, {
                    p: "8px 16px",
                    borderBottom: "1px solid",
                    borderColor: cardExpiryValid === false ? 'destructive-400' : 'neutral-200',
                    display: "block",
                    children: /*#__PURE__*/jsx$1(CardExpiry, {
                      placeholder: "MM / YY",
                      onBlur: onCardExpiryBlur
                    })
                  }), cardExpiryValid === false && /*#__PURE__*/jsx$1(Text, {
                    color: "destructive-400",
                    variant: "paragraph-xsmall",
                    mt: "4px",
                    children: "Please enter a valid expiry date"
                  })]
                }), /*#__PURE__*/jsxs(Stack$1, {
                  mb: "8px",
                  ml: "24px",
                  width: "100%",
                  children: [/*#__PURE__*/jsx$1(Text, {
                    variant: "paragraph-xsmall",
                    color: "neutral-500",
                    children: "CVV"
                  }), /*#__PURE__*/jsx$1(Box, {
                    p: "8px 16px",
                    borderBottom: "1px solid",
                    borderColor: cardCVVValid === false ? 'destructive-400' : 'neutral-200',
                    display: "block",
                    children: /*#__PURE__*/jsx$1(CardCVV, {
                      placeholder: "123",
                      onBlur: onCardCVVBlur
                    })
                  }), cardCVVValid === false && /*#__PURE__*/jsx$1(Text, {
                    color: "destructive-400",
                    variant: "paragraph-xsmall",
                    mt: "4px",
                    children: "Please enter a valid CVV"
                  })]
                })]
              })]
            })
          })
        })
      }), /*#__PURE__*/jsxs(Stack$1, {
        mt: "24px",
        display: "flex",
        alignItems: "center",
        children: [/*#__PURE__*/jsx$1(Text, {
          mb: "24px",
          variant: "paragraph-small",
          children: "or use other payment method"
        }), /*#__PURE__*/jsx$1(OpenPayPalButton, {})]
      }), creditCards.length >= 1 && /*#__PURE__*/jsx$1(Box, {
        mt: "24px",
        children: /*#__PURE__*/jsx$1(FormCheckbox, {
          pb: "16px",
          label: "Save as Primary Payment Method",
          name: "ccIsPrimary"
        })
      }), creditCards.length >= 2 && /*#__PURE__*/jsx$1(Box, {
        mt: "16px",
        children: /*#__PURE__*/jsx$1(FormCheckbox, {
          label: "Save as Backup Payment Method",
          name: "ccIsBackup"
        })
      }), /*#__PURE__*/jsx$1(Button, {
        type: "submit",
        variant: "secondary",
        width: "fit-content",
        mt: 4,
        loading: isSubmitting,
        children: "Add Card"
      })]
    })
  }));
}

function AddPaymentMethodModal(_ref) {
  var hasChargeBeeInitialized = _ref.hasChargeBeeInitialized;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Button, {
      ml: "24px",
      variant: "secondary",
      onClick: function onClick() {
        return setIsOpen(true);
      },
      children: "Add payment method"
    }), /*#__PURE__*/jsxs(Modal, {
      title: "Add Payment Method",
      isOpen: isOpen,
      onClose: function onClose() {
        return setIsOpen(false);
      },
      children: [/*#__PURE__*/jsxs(Box, {
        color: "neutral-700",
        backgroundColor: "warning-100",
        p: "16px",
        width: "700px",
        borderRadius: "base",
        mb: "24px",
        gap: 3,
        children: [/*#__PURE__*/jsx$1(Box, {
          mt: 2,
          children: /*#__PURE__*/jsx$1(RiErrorWarningFill, {})
        }), /*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-small",
          children: "By proceeding, you acknowledge that any outstanding balance will be charged to your updated payment method."
        })]
      }), hasChargeBeeInitialized ? /*#__PURE__*/jsx$1(PaymentCardForm, {
        setIsOpen: setIsOpen
      }) : /*#__PURE__*/jsx$1(Skeleton, {
        height: "300px",
        borderRadius: "base"
      })]
    })]
  });
}

var CARD_ROLE_PRIORITY = {
  primary: 0,
  backup: 1,
  none: 2
};

function determineCardRole(creditCard) {
  if (creditCard.isPrimary === 'True') {
    return 'primary';
  }

  if (creditCard.isBackup === 'True') {
    return 'backup';
  }

  return 'none';
}

function sortByCardRole(a, b) {
  var roleA = determineCardRole(a);
  var roleB = determineCardRole(b);
  return CARD_ROLE_PRIORITY[roleA] - CARD_ROLE_PRIORITY[roleB];
}

function _regenerator$13() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$13(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$13(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$13(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$13(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$13(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$13(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$13(u), _regeneratorDefine2$13(u, o, "Generator"), _regeneratorDefine2$13(u, n, function () {
    return this;
  }), _regeneratorDefine2$13(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$13 = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$13(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$13 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$13(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$13(e, r, n, t);
}

function DeleteConfirmationModal(_ref) {
  var isLoading = _ref.isLoading,
      confirmFunction = _ref.onConfirm;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isConfirmationOpen = _useState2[0],
      setConfirmationIsOpen = _useState2[1];

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(Button, {
      variant: "minimal",
      onClick: function onClick() {
        return setConfirmationIsOpen(true);
      },
      disabled: isLoading,
      children: [/*#__PURE__*/jsx$1(RiDeleteBinLine, {}), /*#__PURE__*/jsx$1(Text, {
        ml: "8px",
        variant: "paragraph-medium",
        fontWeight: "regular",
        children: "Delete"
      })]
    }), /*#__PURE__*/jsx$1(Modal, {
      title: "Confirm Deletion",
      isOpen: isConfirmationOpen,
      onClose: function onClose() {
        return setConfirmationIsOpen(false);
      },
      children: /*#__PURE__*/jsxs(Stack$1, {
        children: [/*#__PURE__*/jsx$1(Text, {
          children: "Are you sure you want to delete this payment method?"
        }), /*#__PURE__*/jsx$1(Button, {
          mt: "56px",
          variant: "secondary",
          width: "fit-content",
          loading: isLoading,
          onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$13().m(function _callee() {
            return _regenerator$13().w(function (_context) {
              while (1) {
                switch (_context.n) {
                  case 0:
                    _context.n = 1;
                    return confirmFunction();

                  case 1:
                    setConfirmationIsOpen(false);

                  case 2:
                    return _context.a(2);
                }
              }
            }, _callee);
          })),
          children: "Confirm"
        })]
      })
    })]
  });
}

function CcPaymentDetails(_ref) {
  var creditCard = _ref.creditCard;
  var ccNumber = creditCard.ccNumber,
      ccMonthExpiry = creditCard.ccMonthExpiry,
      ccYearExpiry = creditCard.ccYearExpiry,
      ccName = creditCard.ccName,
      ccType = creditCard.ccType;
  return /*#__PURE__*/jsx$1(Box, {
    border: "1px solid",
    borderColor: "neutral-200",
    borderRadius: "base",
    width: "100%",
    children: /*#__PURE__*/jsxs(Stack$1, {
      width: "100%",
      gap: "24px",
      p: "24px",
      children: [/*#__PURE__*/jsxs(Stack$1, {
        children: [/*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-xsmall",
          color: "neutral-500",
          children: "Card Number"
        }), /*#__PURE__*/jsx$1(Text, {
          borderBottom: "1px solid",
          borderColor: "neutral-200",
          p: "8px 16px",
          children: /*#__PURE__*/jsxs(Box, {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            style: {
              letterSpacing: '0.15ch'
            },
            children: [/*#__PURE__*/jsx$1(Text, {
              fontWeight: "medium",
              children: ccNumber === null || ccNumber === void 0 ? void 0 : ccNumber.replaceAll('*', 'x')
            }), /*#__PURE__*/jsx$1(Icon$2, {
              alignContent: "right",
              alignItems: "flex-end",
              height: "2rem",
              mr: "2" // Replace is for "american_express"
              ,
              name: ccType ? ccType.toLowerCase().replace('_', ' ') : '',
              title: ccType,
              width: "8rem"
            })]
          })
        })]
      }), /*#__PURE__*/jsxs(Stack$1, {
        children: [/*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-xsmall",
          color: "neutral-500",
          children: "Expiry Date"
        }), /*#__PURE__*/jsxs(Text, {
          borderBottom: "1px solid",
          borderColor: "neutral-200",
          p: "8px 16px",
          fontWeight: "medium",
          children: [(ccMonthExpiry === null || ccMonthExpiry === void 0 ? void 0 : ccMonthExpiry.length) === 1 ? 0 : null, ccMonthExpiry, "/", ccYearExpiry]
        })]
      }), /*#__PURE__*/jsxs(Stack$1, {
        children: [/*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-xsmall",
          color: "neutral-500",
          children: "Name On Card"
        }), /*#__PURE__*/jsx$1(Text, {
          borderBottom: "1px solid",
          borderColor: "neutral-200",
          p: "8px 16px",
          fontWeight: "medium",
          children: ccName
        })]
      })]
    })
  });
}

function PaypalPaymentDetails(_ref) {
  var creditCard = _ref.creditCard;
  return /*#__PURE__*/jsx$1(Box, {
    border: "1px solid",
    borderColor: "neutral-200",
    borderRadius: "base",
    width: "100%",
    children: /*#__PURE__*/jsx$1(Stack$1, {
      width: "100%",
      gap: "24px",
      p: "24px",
      children: /*#__PURE__*/jsxs(Stack$1, {
        children: [/*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-xsmall",
          color: "neutral-500",
          children: "Paypal Email"
        }), /*#__PURE__*/jsx$1(Text, {
          borderBottom: "1px solid",
          borderColor: "neutral-200",
          p: "8px 16px",
          children: /*#__PURE__*/jsxs(Box, {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            children: [/*#__PURE__*/jsx$1(Text, {
              fontWeight: "medium",
              children: creditCard.paypalEmail
            }), /*#__PURE__*/jsx$1(Icon$2, {
              alignContent: "right",
              alignItems: "flex-end",
              height: "2rem",
              mr: "2",
              name: "paypal",
              title: "paypal",
              width: "8rem"
            })]
          })
        })]
      })
    })
  });
}

function PaymentMethodCard(_ref) {
  var creditCard = _ref.creditCard,
      fetchUserInfo = _ref.fetchUserInfo;

  var _useMutation = useMutation$1({
    fn: function fn(action) {
      if (action === 'primary') {
        return api.creditCards.setPrimary(creditCard.id);
      }

      if (action === 'backup') {
        return api.creditCards.setBackup(creditCard.id);
      }

      return api.creditCards.deleteCard(creditCard.id);
    },
    successMessage: 'Payment method updated successfully',
    failureMessage: "Couldn't update payment method",
    onSuccess: fetchUserInfo
  }),
      mutate = _useMutation.mutate,
      isLoading = _useMutation.isLoading;

  var cardRole = determineCardRole(creditCard);
  return /*#__PURE__*/jsxs(Stack$1, {
    mr: "52px",
    m: "24px",
    children: [/*#__PURE__*/jsxs(Box, {
      mb: "24px",
      children: [/*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-large",
        fontWeight: "semi",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        children: "".concat(cardRole === 'none' ? 'Additional' : capitalize$1(cardRole), " Payment Details")
      }), /*#__PURE__*/jsx$1(DeleteConfirmationModal, {
        isLoading: isLoading,
        onConfirm: function onConfirm() {
          return mutate('delete');
        }
      })]
    }), /*#__PURE__*/jsx$1(Box, {
      border: "1px solid",
      borderColor: "neutral-200",
      borderRadius: "base",
      children: creditCard.ccType === 'paypal' ? /*#__PURE__*/jsx$1(PaypalPaymentDetails, {
        creditCard: creditCard
      }) : /*#__PURE__*/jsx$1(CcPaymentDetails, {
        creditCard: creditCard
      })
    }), /*#__PURE__*/jsxs(Stack$1, {
      alignItems: "flex-start",
      mt: "24px",
      gap: "16px",
      children: [cardRole !== 'primary' && /*#__PURE__*/jsxs(Button, {
        variant: "minimal",
        onClick: function onClick() {
          return mutate('primary');
        },
        disabled: isLoading,
        children: [/*#__PURE__*/jsx$1(Repeat2, {}), /*#__PURE__*/jsx$1(Text, {
          ml: "12px",
          children: "Set as primary payment method"
        })]
      }), cardRole === 'none' && /*#__PURE__*/jsxs(Button, {
        variant: "minimal",
        onClick: function onClick() {
          return mutate('backup');
        },
        disabled: isLoading,
        children: [/*#__PURE__*/jsx$1(Repeat2, {}), /*#__PURE__*/jsx$1(Text, {
          ml: "12px",
          children: "Set as backup payment method"
        })]
      })]
    })]
  });
}

function PaymentSettings$1() {
  var _useUserService = useUserService(),
      user = _useUserService.user,
      fetchUserInfo = _useUserService.fetchUserInfo;

  var _useChargebeeJs = useChargebeeJs(),
      hasChargeBeeInitialized = _useChargebeeJs.hasChargeBeeInitialized;

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Header$1, {
      header: "Settings"
    }), /*#__PURE__*/jsx$1(Tabs, {
      tabs: TABS.settings
    }), /*#__PURE__*/jsx$1(Grid, {
      gridTemplateColumns: ['1fr', 'repeat(2, 1fr)'],
      gap: 3,
      color: "neutral-700",
      fontFamily: "Inter",
      children: user.creditCards ? user.creditCards.sort(sortByCardRole).map(function (creditCard) {
        return /*#__PURE__*/jsx$1(PaymentMethodCard, {
          creditCard: creditCard,
          fetchUserInfo: fetchUserInfo
        }, creditCard.id);
      }) : Array.from({
        length: 2
      }).map(function (_, index) {
        return /*#__PURE__*/jsx$1(Skeleton, {
          height: "300px",
          borderRadius: "base"
        }, index);
      })
    }), /*#__PURE__*/jsx$1(AddPaymentMethodModal, {
      hasChargeBeeInitialized: hasChargeBeeInitialized
    })]
  });
}

var _excluded$z = ["label", "value"];

function ownKeys$1r(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1r(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1r(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1r(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var FakeInputBox = styled.div.withConfig({
  displayName: "fake-input__FakeInputBox",
  componentId: "sc-19mgjxn-0"
})(["border:none;padding:8px 16px;border-bottom:1px solid ", ";background-color:", ";font-family:", ";cursor:default;min-height:40px;color:", ";font-weight:500;font-size:1.6rem;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors['neutral-200'];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.none;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.body;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors['neutral-700'];
});

function FakeInput(_ref5) {
  var label = _ref5.label,
      value = _ref5.value,
      props = _objectWithoutProperties$8(_ref5, _excluded$z);

  return /*#__PURE__*/jsxs(Stack$1, _objectSpread$1r(_objectSpread$1r({
    gap: 1
  }, props), {}, {
    children: [/*#__PURE__*/jsx$1(Text, {
      color: "neutral-700",
      variant: "paragraph-xsmall",
      children: label
    }), /*#__PURE__*/jsx$1(FakeInputBox, {
      children: value
    })]
  }));
}

var schema$1 = objectType({
  firstName: stringType().min(1),
  lastName: stringType().min(1),
  email: stringType().email(),
  phone: stringType(),
  extension: stringType().optional(),
  address: stringType(),
  postalCode: stringType(),
  city: stringType(),
  province: stringType(),
  country: stringType(),
  company: stringType().optional(),
  sameBillingAddress: booleanType()["default"](false)
});

function ownKeys$1q(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1q(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1q(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1q(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _regenerator$12() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$12(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$12(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$12(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$12(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$12(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$12(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$12(u), _regeneratorDefine2$12(u, o, "Generator"), _regeneratorDefine2$12(u, n, function () {
    return this;
  }), _regeneratorDefine2$12(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$12 = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$12(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$12 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$12(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$12(e, r, n, t);
}

function AddressCardModal(_ref) {
  var type = _ref.type,
      onSuccess = _ref.onSuccess,
      hideButton = _ref.hideButton,
      externalOpen = _ref.externalOpen,
      setExternalOpen = _ref.setExternalOpen,
      addressResponse = _ref.addressResponse;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      internalOpen = _useState2[0],
      setInternalOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$4(_useState3, 2),
      isSubmitting = _useState4[0],
      setIsSubmitting = _useState4[1];

  var isOpen = externalOpen !== null && externalOpen !== void 0 ? externalOpen : internalOpen;
  var setIsOpen = setExternalOpen !== null && setExternalOpen !== void 0 ? setExternalOpen : setInternalOpen;
  var address = addressResponse.sameBillingAddress ? addressResponse.primary : addressResponse[type];
  var methods = useForm({
    resolver: zodResolver(schema$1),
    defaultValues: {
      firstName: address.firstName,
      lastName: address.lastName,
      email: address.email,
      phone: address.phone,
      extension: address.phoneExt,
      address: address.streetName,
      city: address.city,
      province: address.province,
      postalCode: address.postalCode,
      country: address.country,
      company: addressResponse.company,
      sameBillingAddress: type === 'primary' ? addressResponse.sameBillingAddress : false
    }
  });
  var handleSubmit = methods.handleSubmit,
      reset = methods.reset;

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$12().m(function _callee(data) {
      var newAddress, _yield$api$user$updat, _yield$api$user$updat2, error;

      return _regenerator$12().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              setIsSubmitting(true);
              newAddress = {
                firstName: data.firstName,
                lastName: data.lastName,
                email: data.email,
                streetName: data.address,
                city: data.city,
                province: data.province,
                postalCode: data.postalCode,
                country: data.country,
                phoneExt: data.extension || undefined,
                phone: data.phone
              };
              _context.n = 1;
              return api.user.updateAddress({
                company: data.company,
                primary: type === 'primary' ? newAddress : undefined,
                billing: type === 'billing' ? newAddress : undefined,
                sameBillingAddress: data.sameBillingAddress
              });

            case 1:
              _yield$api$user$updat = _context.v;
              _yield$api$user$updat2 = _slicedToArray$4(_yield$api$user$updat, 2);
              error = _yield$api$user$updat2[1];

              if (error) {
                toast.error(error);
              } else {
                onSuccess();
                setIsOpen(false);
                toast.success('Personal info updated successfully');
              }

              setIsSubmitting(false);

            case 2:
              return _context.a(2);
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/jsxs(Fragment, {
    children: [!hideButton && /*#__PURE__*/jsxs(Button, {
      variant: "minimal",
      onClick: function onClick() {
        return setIsOpen(true);
      },
      px: 0,
      width: "fit-content",
      children: [/*#__PURE__*/jsx$1(RiEditLine, {}), /*#__PURE__*/jsx$1(Text, {
        children: "Edit"
      })]
    }), /*#__PURE__*/jsx$1(Modal, {
      isOpen: isOpen,
      onClose: function onClose() {
        setIsOpen(false);
        setExternalOpen === null || setExternalOpen === void 0 ? void 0 : setExternalOpen(false);
        reset();
      },
      title: "Edit ".concat(type === 'primary' ? 'Personal' : 'Billing', " Details"),
      children: /*#__PURE__*/jsx$1(FormProvider, _objectSpread$1q(_objectSpread$1q({}, methods), {}, {
        children: /*#__PURE__*/jsx$1("form", {
          onSubmit: handleSubmit(onSubmit),
          children: /*#__PURE__*/jsxs(Stack$1, {
            gap: "24px",
            minWidth: ['300px', '400px', '500px'],
            maxWidth: "663px",
            children: [/*#__PURE__*/jsx$1(FormInput, {
              name: "firstName",
              label: "First Name*"
            }), /*#__PURE__*/jsx$1(FormInput, {
              name: "lastName",
              label: "Last Name*",
              fontWeight: "medium"
            }), /*#__PURE__*/jsx$1(FormInput, {
              name: "email",
              label: "Email Address*"
            }), /*#__PURE__*/jsxs(Stack$1, {
              flexDirection: ['column', 'row'],
              gap: "24px",
              width: "100%",
              children: [/*#__PURE__*/jsx$1(FormInput, {
                name: "phone",
                label: "Phone Number*",
                flex: "1"
              }), /*#__PURE__*/jsx$1(FormInput, {
                name: "extension",
                label: "Extension (Optional)",
                flex: "1"
              })]
            }), /*#__PURE__*/jsxs(Box, {
              flexDirection: ['column', 'row'],
              gap: "24px",
              children: [/*#__PURE__*/jsx$1(FormInput, {
                name: "address",
                label: "Address*"
              }), /*#__PURE__*/jsx$1(FormInput, {
                name: "postalCode",
                label: "Postal Code*"
              })]
            }), /*#__PURE__*/jsxs(Box, {
              gap: "24px",
              flexDirection: ['column', 'row'],
              children: [/*#__PURE__*/jsx$1(FormInput, {
                name: "city",
                label: "City*",
                color: "neutral-700"
              }), /*#__PURE__*/jsx$1(FormInput, {
                name: "province",
                label: "Province/State*"
              })]
            }), /*#__PURE__*/jsx$1(FormInput, {
              name: "country",
              label: "Country*"
            }), /*#__PURE__*/jsx$1(FormInput, {
              name: "company",
              label: "Company Name (Optional)"
            }), /*#__PURE__*/jsx$1(Button, {
              width: "fit-content",
              variant: "secondary",
              loading: isSubmitting,
              children: "Save Changes"
            })]
          })
        })
      }))
    })]
  });
}

function _regenerator$11() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$11(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$11(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$11(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$11(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$11(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$11(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$11(u), _regeneratorDefine2$11(u, o, "Generator"), _regeneratorDefine2$11(u, n, function () {
    return this;
  }), _regeneratorDefine2$11(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$11 = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$11(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$11 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$11(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$11(e, r, n, t);
}

function AddressCard(_ref) {
  var type = _ref.type,
      fetchAddress = _ref.fetchAddress,
      addressResponse = _ref.addressResponse;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isAddressModalOpen = _useState2[0],
      setIsAddressModalOpen = _useState2[1];

  var _useMutation = useMutation$1({
    fn: api.user.updateAddress,
    successMessage: 'Personal info updated successfully',
    failureMessage: 'Failed to update personal info',
    onSuccess: fetchAddress
  }),
      updateAddress = _useMutation.mutate,
      isLoading = _useMutation.isLoading;

  if (!addressResponse) {
    return /*#__PURE__*/jsx$1(Skeleton, {
      height: "165px"
    });
  }

  var address = addressResponse.sameBillingAddress ? addressResponse.primary : addressResponse[type];
  return /*#__PURE__*/jsxs(Stack$1, {
    gap: "16px",
    children: [/*#__PURE__*/jsx$1(FakeInput, {
      label: "Email Address",
      value: address.email
    }), /*#__PURE__*/jsx$1(FakeInput, {
      label: "First Name",
      value: address.firstName
    }), /*#__PURE__*/jsx$1(FakeInput, {
      label: "Last Name",
      value: address.lastName
    }), /*#__PURE__*/jsxs(Stack$1, {
      flexDirection: ['column', 'row'],
      gap: "24px",
      minWidth: "0",
      width: "100%",
      children: [/*#__PURE__*/jsx$1(FakeInput, {
        label: "Phone Number",
        flex: "2",
        value: address.phone
      }), /*#__PURE__*/jsx$1(FakeInput, {
        label: "Extension",
        flex: "1",
        value: address.phoneExt
      })]
    }), /*#__PURE__*/jsxs(Box, {
      flexDirection: ['column', 'row'],
      gap: "24px",
      children: [/*#__PURE__*/jsx$1(FakeInput, {
        label: "Address",
        flex: "2",
        value: address.streetName
      }), /*#__PURE__*/jsx$1(FakeInput, {
        label: "Postal Code",
        flex: "1",
        value: address.postalCode
      })]
    }), /*#__PURE__*/jsxs(Box, {
      gap: "24px",
      flexDirection: ['column', 'row'],
      children: [/*#__PURE__*/jsx$1(FakeInput, {
        label: "City",
        value: address.city,
        flex: "1"
      }), /*#__PURE__*/jsx$1(FakeInput, {
        label: "Province/State",
        value: address.province,
        flex: "1"
      }), /*#__PURE__*/jsx$1(FakeInput, {
        label: "Country",
        value: address.country,
        flex: "1"
      })]
    }), /*#__PURE__*/jsx$1(FakeInput, {
      label: "Company Name",
      value: addressResponse.company
    }), type === 'primary' && /*#__PURE__*/jsxs(Box, {
      gap: "8px",
      children: [isLoading ? /*#__PURE__*/jsx$1(Spinner, {}) : /*#__PURE__*/jsx$1(Checkbox$1, {
        id: "toggle-same-billing-address",
        name: "sameBillingAddress",
        checked: addressResponse.sameBillingAddress,
        disabled: isLoading,
        onChange: /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$11().m(function _callee(e) {
            return _regenerator$11().w(function (_context) {
              while (1) {
                switch (_context.n) {
                  case 0:
                    if (!e.target.checked) {
                      setIsAddressModalOpen(true);
                    } else {
                      updateAddress({
                        company: addressResponse.company,
                        primary: address,
                        billing: address,
                        sameBillingAddress: true
                      });
                    }

                  case 1:
                    return _context.a(2);
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }()
      }), /*#__PURE__*/jsx$1(Text, {
        as: "label",
        variant: "paragraph-xsmall",
        color: "neutral-700",
        htmlFor: "toggle-same-billing-address",
        style: {
          cursor: 'pointer'
        },
        children: "Use as Billing Address"
      }), /*#__PURE__*/jsx$1(AddressCardModal, {
        type: "billing",
        onSuccess: fetchAddress,
        externalOpen: isAddressModalOpen,
        addressResponse: addressResponse,
        setExternalOpen: setIsAddressModalOpen,
        hideButton: true
      })]
    })]
  });
}

function UserCard(_ref) {
  var userDetails = _ref.userDetails;

  if (!userDetails) {
    return /*#__PURE__*/jsx$1(Skeleton, {
      height: "165px"
    });
  }

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(FakeInput, {
      label: "User Login",
      value: userDetails.userLogin
    }), /*#__PURE__*/jsx$1(FakeInput, {
      label: "First Name",
      value: userDetails.firstName
    }), /*#__PURE__*/jsx$1(FakeInput, {
      label: "Last Name",
      value: userDetails.lastName
    })]
  });
}

var schema = objectType({
  firstName: stringType().min(1),
  lastName: stringType().min(1),
  userLogin: stringType().email()
});

function ownKeys$1p(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1p(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1p(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1p(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _regenerator$10() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$10(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$10(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$10(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$10(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$10(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$10(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$10(u), _regeneratorDefine2$10(u, o, "Generator"), _regeneratorDefine2$10(u, n, function () {
    return this;
  }), _regeneratorDefine2$10(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$10 = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$10(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$10 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$10(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$10(e, r, n, t);
}

function UserCardModal(_ref) {
  var userDetails = _ref.userDetails,
      onSuccess = _ref.onSuccess;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$4(_useState3, 2),
      isSubmitting = _useState4[0],
      setIsSubmitting = _useState4[1];

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$10().m(function _callee(data) {
      var _yield$api$user$updat, _yield$api$user$updat2, error;

      return _regenerator$10().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              setIsSubmitting(true);
              _context.n = 1;
              return api.user.updateUserDetails(data);

            case 1:
              _yield$api$user$updat = _context.v;
              _yield$api$user$updat2 = _slicedToArray$4(_yield$api$user$updat, 2);
              error = _yield$api$user$updat2[1];

              if (error) {
                toast.error(error);
              } else {
                onSuccess();
                setIsOpen(false);
                toast.success('Personal info updated successfully');
              }

              setIsOpen(false);
              setIsSubmitting(false);

            case 2:
              return _context.a(2);
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var methods = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      userLogin: userDetails.userLogin,
      firstName: userDetails.firstName,
      lastName: userDetails.lastName
    }
  });
  var handleSubmit = methods.handleSubmit;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(Button, {
      variant: "minimal",
      onClick: function onClick() {
        return setIsOpen(true);
      },
      px: 0,
      width: "fit-content",
      children: [/*#__PURE__*/jsx$1(RiEditLine, {}), /*#__PURE__*/jsx$1(Text, {
        children: "Edit"
      })]
    }), /*#__PURE__*/jsx$1(Modal, {
      isOpen: isOpen,
      onClose: function onClose() {
        return setIsOpen(false);
      },
      title: "Edit User Details",
      children: /*#__PURE__*/jsx$1(FormProvider, _objectSpread$1p(_objectSpread$1p({}, methods), {}, {
        children: /*#__PURE__*/jsx$1("form", {
          onSubmit: handleSubmit(onSubmit),
          children: /*#__PURE__*/jsxs(Stack$1, {
            gap: "24px",
            minWidth: ['300px', '400px', '500px'],
            maxWidth: "663px",
            children: [/*#__PURE__*/jsx$1(FormInput, {
              name: "userLogin",
              label: "User Login"
            }), /*#__PURE__*/jsx$1(FormInput, {
              name: "firstName",
              label: "First Name"
            }), /*#__PURE__*/jsx$1(FormInput, {
              name: "lastName",
              label: "Last Name"
            }), /*#__PURE__*/jsx$1(Button, {
              width: "fit-content",
              variant: "secondary",
              loading: isSubmitting,
              children: "Save Changes"
            })]
          })
        })
      }))
    })]
  });
}

function _regenerator$$() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$$(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$$(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$$(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$$(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$$(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$$(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$$(u), _regeneratorDefine2$$(u, o, "Generator"), _regeneratorDefine2$$(u, n, function () {
    return this;
  }), _regeneratorDefine2$$(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$$ = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$$(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$$ = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$$(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$$(e, r, n, t);
}

function PersonalSettings() {
  var _useState = useState(),
      _useState2 = _slicedToArray$4(_useState, 2),
      addressResponse = _useState2[0],
      setAddressResponse = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray$4(_useState3, 2),
      userDetails = _useState4[0],
      setUserDetails = _useState4[1];

  var fetchAddress = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$$().m(function _callee() {
    var _yield$api$user$fetch, _yield$api$user$fetch2, response, error;

    return _regenerator$$().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            _context.n = 1;
            return api.user.fetchAddress();

          case 1:
            _yield$api$user$fetch = _context.v;
            _yield$api$user$fetch2 = _slicedToArray$4(_yield$api$user$fetch, 2);
            response = _yield$api$user$fetch2[0];
            error = _yield$api$user$fetch2[1];

            if (!error) {
              _context.n = 2;
              break;
            }

            toast.error(error);
            return _context.a(2);

          case 2:
            setAddressResponse(response);

          case 3:
            return _context.a(2);
        }
      }
    }, _callee);
  })), []);
  var fetchUserDetails = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator$$().m(function _callee2() {
    var _yield$api$user$fetch3, _yield$api$user$fetch4, response, error;

    return _regenerator$$().w(function (_context2) {
      while (1) {
        switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return api.user.fetchUserDetails();

          case 1:
            _yield$api$user$fetch3 = _context2.v;
            _yield$api$user$fetch4 = _slicedToArray$4(_yield$api$user$fetch3, 2);
            response = _yield$api$user$fetch4[0];
            error = _yield$api$user$fetch4[1];

            if (!error) {
              _context2.n = 2;
              break;
            }

            toast.error(error);
            return _context2.a(2);

          case 2:
            setUserDetails(response.userDetails);

          case 3:
            return _context2.a(2);
        }
      }
    }, _callee2);
  })), []);
  useEffect(function () {
    Promise.all([fetchAddress(), fetchUserDetails()]);
  }, [fetchAddress, fetchUserDetails]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Header$1, {
      header: "Settings"
    }), /*#__PURE__*/jsx$1(Tabs, {
      tabs: TABS.settings
    }), /*#__PURE__*/jsxs(Grid, {
      gap: "24px",
      gridTemplateColumns: "1fr 1fr",
      children: [/*#__PURE__*/jsxs(Stack$1, {
        padding: "24px",
        gap: "24px",
        border: "1px solid",
        borderColor: "neutral-200",
        borderRadius: "base",
        children: [/*#__PURE__*/jsxs(Box, {
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          children: [/*#__PURE__*/jsx$1(Text, {
            variant: "heading-h6",
            children: "Personal Details"
          }), addressResponse && /*#__PURE__*/jsx$1(AddressCardModal, {
            type: "primary",
            onSuccess: fetchAddress,
            addressResponse: addressResponse
          })]
        }), /*#__PURE__*/jsx$1(AddressCard, {
          type: "primary",
          fetchAddress: fetchAddress,
          addressResponse: addressResponse
        })]
      }), /*#__PURE__*/jsxs(Stack$1, {
        padding: "24px",
        gap: "24px",
        border: "1px solid",
        borderColor: "neutral-200",
        borderRadius: "base",
        width: "100%",
        alignSelf: "flex-start",
        children: [/*#__PURE__*/jsxs(Box, {
          alignItems: "center",
          justifyContent: "space-between",
          children: [/*#__PURE__*/jsx$1(Text, {
            variant: "heading-h6",
            children: "User Details"
          }), /*#__PURE__*/jsx$1(Box, {
            alignItems: "center",
            gap: "8px",
            children: userDetails && /*#__PURE__*/jsx$1(UserCardModal, {
              userDetails: userDetails,
              onSuccess: fetchUserDetails
            })
          })]
        }), /*#__PURE__*/jsx$1(UserCard, {
          userDetails: userDetails
        })]
      }), addressResponse && !addressResponse.sameBillingAddress && /*#__PURE__*/jsxs(Stack$1, {
        padding: "24px",
        gap: "24px",
        border: "1px solid",
        borderColor: "neutral-200",
        borderRadius: "base",
        children: [/*#__PURE__*/jsxs(Box, {
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          children: [/*#__PURE__*/jsx$1(Text, {
            variant: "heading-h6",
            children: "Billing Details"
          }), /*#__PURE__*/jsx$1(Box, {
            alignItems: "center",
            gap: "8px",
            children: /*#__PURE__*/jsx$1(AddressCardModal, {
              type: "billing",
              onSuccess: fetchAddress,
              addressResponse: addressResponse
            })
          })]
        }), /*#__PURE__*/jsx$1(AddressCard, {
          type: "billing",
          fetchAddress: fetchAddress,
          addressResponse: addressResponse
        })]
      })]
    })]
  });
}

function SecuritySettings$1() {
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Header$1, {
      header: "Settings"
    }), /*#__PURE__*/jsx$1(Tabs, {
      tabs: TABS.settings
    }), /*#__PURE__*/jsx$1("h3", {
      children: "Security Settings"
    })]
  });
}

function SettingsPage() {
  return /*#__PURE__*/jsxs(Router, {
    children: [/*#__PURE__*/jsx$1(Route, {
      component: PersonalSettings,
      path: "/personal-info",
      title: "Personal Info"
    }), /*#__PURE__*/jsx$1(Route, {
      component: PaymentSettings$1,
      path: "/payment-settings",
      title: "Payment Settings"
    }), /*#__PURE__*/jsx$1(Route, {
      component: BillingHistory,
      path: "/billing-history",
      title: "Billing History"
    }), /*#__PURE__*/jsx$1(Route, {
      component: SecuritySettings$1,
      path: "/security-settings",
      title: "Security Settings"
    }), /*#__PURE__*/jsx$1(Route, {
      component: LoginHistory,
      path: "/login-history",
      title: "Login History"
    }), /*#__PURE__*/jsx$1(Redirect, {
      from: "*",
      to: "personal-info",
      noThrow: true
    })]
  });
}

function Dashboard() {
  return /*#__PURE__*/jsx$1(ToastProvider, {
    children: /*#__PURE__*/jsx$1(ViewProvider, {
      children: /*#__PURE__*/jsx$1(HeaderProvider, {
        children: /*#__PURE__*/jsxs(Box, {
          minHeight: "100vh",
          children: [/*#__PURE__*/jsx$1(Sidebar, {}), /*#__PURE__*/jsx$1(PageWrapper, {
            children: /*#__PURE__*/jsxs(_StyledStack$h, {
              width: "100%",
              pb: 5,
              children: [/*#__PURE__*/jsx$1(Navbar, {}), /*#__PURE__*/jsxs(Router, {
                basepath: BASEPATH,
                children: [/*#__PURE__*/jsx$1(Route, {
                  component: MyAccountPage,
                  path: "/my-account/*"
                }), /*#__PURE__*/jsx$1(Route, {
                  component: ManagersPage,
                  path: "/managers/*"
                }), /*#__PURE__*/jsx$1(Route, {
                  component: SettingsPage,
                  path: "/settings/*"
                }), /*#__PURE__*/jsx$1(Redirect, {
                  from: "*",
                  to: "my-account/domains",
                  noThrow: true
                })]
              })]
            })
          }), /*#__PURE__*/jsx$1(Finder, {
            links: FINDER_LINKS
          })]
        })
      })
    })
  });
}

var _StyledStack$h = styled(Stack$1).withConfig({
  displayName: "dashboard___StyledStack",
  componentId: "sc-zjgvk4-0"
})(["& > div{width:100%;}"]);

var containerVariants = {
  light: {
    bg: 'greys.8',
    text: 'greys.1'
  },
  dark: {
    bg: 'greys.1',
    text: 'greys.8'
  },
  white: {
    bg: 'white',
    text: 'greys.1'
  }
};
/**
  Scrolls the slider by one panel width in the specified direction, and loops the slider around if necessary.
  To implement, make a flex container with overflow: scroll, hidden scrollbars, and justify-content: flex-start. 
  Fill it with full-width slider items, each with the className 'slider-item'.
  @param {Object} slider - The DOM node representing the slider container. If using Ref, pass in Ref.current.
  @param {string} scrollDirection - The direction to scroll the slider. '+' scrolls right, '-' scrolls left. It's '+' by default.
  @throws {Error} If the slider component is not found.
  @summary 'Position' variable name refers to the distance in px from the start of the slider to the left side of the panel in question.
*/

var sliderScroller = function sliderScroller(slider) {
  var scrollDirection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '+';

  if (!slider) {
    throw new Error('Slider component not found');
  }

  if (scrollDirection !== '+' && scrollDirection !== '-') {
    throw new Error('Scroll direction must be + or -');
  }

  var singlePanelWidth = slider.offsetWidth;
  slider.scrollBy({
    left: (scrollDirection === '+' ? 1 : -1) * singlePanelWidth,
    behavior: 'smooth'
  }); // Loops slider around.

  var numItemsInSlider = slider.querySelectorAll('.slider-item').length;
  var currentPanelPosition = slider.scrollLeft;
  var lastPanelPosition = singlePanelWidth * (numItemsInSlider - 1);
  var isFirstPanel = currentPanelPosition === 0;
  var isLastPanel = currentPanelPosition === lastPanelPosition;
  var isGoingLeftFromFirstPanel = isFirstPanel && scrollDirection === '-';
  var isGoingRightFromLastPanel = isLastPanel && scrollDirection === '+';

  if (isGoingLeftFromFirstPanel) {
    slider.scrollTo({
      left: lastPanelPosition,
      behavior: 'smooth'
    });
  }

  if (isGoingRightFromLastPanel) {
    slider.scrollTo({
      left: 0,
      behavior: 'smooth'
    });
  } // Ensures complete scroll.


  var isPanelNotFullyScrolled = currentPanelPosition % singlePanelWidth !== 0;
  var nearestPanelPosition = Math.round(currentPanelPosition / singlePanelWidth) * singlePanelWidth;

  if (isPanelNotFullyScrolled) {
    slider.scrollTo({
      left: nearestPanelPosition,
      behavior: 'smooth'
    });
  }
};

var _templateObject$u, _templateObject2$k, _templateObject3$d;

function Carousel(_ref) {
  var data = _ref.data;
  var items = data.items,
      id = data.id,
      bg = data.bg,
      theme = data.theme,
      color = data.color;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isCurrentlyScrolling = _useState2[0],
      setIsCurrentlyScrolling = _useState2[1];

  function handleSliderNavigation() {
    var scrollDirection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '+';

    if (isCurrentlyScrolling) {
      return;
    } // Stops spam


    setIsCurrentlyScrolling(true);

    try {
      var sliderNode = document.getElementById('carouselSlider');
      sliderScroller(sliderNode, scrollDirection);
      setTimeout(function () {
        return setIsCurrentlyScrolling(false);
      }, 700);
    } catch (err) {
      console.log(err.message || 'Slider is not working correctly.');
      setIsCurrentlyScrolling(false);
    }
  }

  return /*#__PURE__*/jsxs(Section, {
    bg: bg || containerVariants[theme || 'light'].bg,
    color: containerVariants[theme || 'light'].text,
    containerProps: {
      maxWidth: 'containers.lg'
    },
    id: id,
    py: [4, 5],
    style: {
      fontFamily: 'Inter'
    },
    position: "relative",
    overflow: "hidden",
    children: [/*#__PURE__*/jsx$1(Box$1, {
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      maxWidth: "100%",
      children: /*#__PURE__*/jsx$1(Text$1, {
        color: color,
        mb: 3,
        style: {
          fontWeight: 500,
          fontSize: '20px',
          lineHeight: '28px',
          letterSpacing: '-2%'
        },
        children: "TESTIMONIALS"
      })
    }), /*#__PURE__*/jsx$1(Box$1, {
      children: /*#__PURE__*/jsx$1(Text$1, {
        color: color,
        lineHeight: "body",
        mb: 5,
        textAlign: "center",
        style: {
          fontWeight: 700,
          fontSize: '56px',
          lineHeight: '72px',
          letterSpacing: '-2%'
        },
        children: "What our clients say"
      })
    }), /*#__PURE__*/jsx$1(Box$1, {
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      maxWidth: "100%",
      mb: 5,
      children: items ? /*#__PURE__*/jsx$1(_StyledBox$l, {
        alignItems: "center",
        justifyContent: "flex-start",
        overflowX: "auto",
        width: "100%",
        id: "carouselSlider",
        tabIndex: 0,
        children: items.map(function (item, i) {
          var content = item.content,
              reviewer = item.reviewer;
          return /*#__PURE__*/jsxs(Box$1, {
            className: "slider-item",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "center",
            minWidth: "100%",
            maxWidth: "100rem",
            px: [4, 4],
            children: [/*#__PURE__*/jsx$1(Box$1, {
              alignItems: "center",
              flexDirection: ['column', 'row', 'row'],
              mb: 2,
              textAlign: "center",
              justifyContent: "center",
              width: "65%",
              zIndex: 1,
              children: /*#__PURE__*/jsx$1(Text$1, {
                textAlign: "center",
                color: color,
                style: {
                  fontWeight: 500,
                  fontSize: '20px',
                  lineHeight: '28px',
                  letterSpacing: '0%'
                },
                children: content
              })
            }), /*#__PURE__*/jsx$1(Box$1, {
              alignItems: "center",
              textAlign: "center",
              flexDirection: ['column', 'row', 'row'],
              mt: 4,
              zIndex: 1,
              children: /*#__PURE__*/jsx$1(Text$1, {
                color: color,
                style: {
                  fontWeight: 700,
                  fontSize: '13.33px',
                  lineHeight: '16.8px',
                  letterSpacing: '0%'
                },
                children: reviewer
              })
            })]
          }, i);
        })
      }) : /*#__PURE__*/jsx$1(Skeleton$1, {
        minHeight: 5
      })
    }), /*#__PURE__*/jsxs(Box$1, {
      mb: 3,
      children: [/*#__PURE__*/jsx$1(Button$1, {
        variant: "rounded",
        mr: 3,
        children: /*#__PURE__*/jsx$1(_StyledIcon$2, {
          height: "2rem",
          width: "2rem",
          name: "arrow-right",
          onClick: function onClick() {
            return handleSliderNavigation('-');
          },
          scale: "(-1, -1)",
          title: "previous-testimonial",
          titleId: "chevron-left"
        })
      }), /*#__PURE__*/jsx$1(Button$1, {
        variant: "rounded",
        ml: 3,
        children: /*#__PURE__*/jsx$1(_StyledIcon2$1, {
          height: "2rem",
          width: "2rem",
          name: "arrow-right",
          onClick: function onClick() {
            return handleSliderNavigation('+');
          },
          title: "next-testimonial",
          titleId: "chevron-right"
        })
      })]
    }), /*#__PURE__*/jsx$1(_StyledBox2$8, {
      position: "absolute",
      width: "578px",
      height: "578px",
      borderRadius: "50%",
      bg: "#c8d9ffcc"
    }), /*#__PURE__*/jsx$1(_StyledBox3$3, {
      position: "absolute",
      width: "578px",
      height: "578px",
      borderRadius: "50%",
      backgroundImage: "linear-gradient(215.82deg, #BCA5FF 21.75%, #F8A5FF 57.22%)"
    })]
  });
}

var _StyledBox$l = styled(Box$1)(_templateObject$u || (_templateObject$u = _taggedTemplateLiteral$1(["\n              scrollbar-width: none;\n              -ms-overflow-style: none;\n              &::-webkit-scrollbar {\n                display: none;\n              }\n            "])));

var _StyledIcon$2 = styled(Icon$2)(_templateObject2$k || (_templateObject2$k = _taggedTemplateLiteral$1(["\n              cursor: pointer;\n              transform: rotate(180deg);\n              transition: 0.2s;\n              &:hover {\n                transform: rotate(180deg) translate(2px);\n              }\n            "])));

var _StyledIcon2$1 = styled(Icon$2)(_templateObject3$d || (_templateObject3$d = _taggedTemplateLiteral$1(["\n              cursor: pointer;\n              transition: 0.2s;\n              &:hover {\n                transform: translate(2px);\n              }\n            "])));

var _StyledBox2$8 = styled(Box$1)({
  opacity: '80%',
  bottom: '-80%',
  left: '-5%',
  filter: 'blur(60px)'
});

var _StyledBox3$3 = styled(Box$1).withConfig({
  displayName: "carousel___StyledBox3",
  componentId: "sc-jqm5md-0"
})({
  opacity: '45%',
  bottom: '-85%',
  right: '-5%',
  filter: 'blur(141px)'
});

function Confirmation(_ref) {
  var title = _ref.title,
      content = _ref.content,
      children = _ref.children,
      onConfirm = _ref.onConfirm,
      onCancel = _ref.onCancel,
      containerRef = _ref.containerRef,
      btnColor = _ref.btnColor,
      btnText = _ref.btnText,
      isLoading = _ref.isLoading;
  var lastFocused;

  if (hasDOM) {
    lastFocused = document.activeElement;
  }

  useEffect(function () {
    if (containerRef && containerRef.current) {
      containerRef.current.focus();
    }
  }, []);

  if (process.env.NODE_ENV !== 'test') {
    useTabTrapper(containerRef, [], lastFocused);
  }

  return /*#__PURE__*/jsxs(Stack$2, {
    ref: containerRef,
    children: [/*#__PURE__*/jsx$1(Heading, {
      headingStyle: 2,
      mb: 3,
      children: title
    }), content || children, /*#__PURE__*/jsx$1(Box$1, {
      justifyContent: "flex-end",
      mt: 4,
      children: isLoading ? /*#__PURE__*/jsx$1(Spinner$1, {
        size: "3rem",
        stroke: ".3rem"
      }) : /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx$1(Button$1, {
          color: btnColor || 'greenDark',
          mr: 4,
          onClick: onCancel,
          variant: "minimal",
          children: "Cancel"
        }), /*#__PURE__*/jsx$1(Button$1, {
          color: btnColor || 'greenDark',
          onClick: onConfirm,
          children: btnText || 'Confirm'
        }), ' ']
      })
    })]
  });
}

var _excluded$y = ["autoSearch", "background", "bordered", "btnAriaLabel", "btnColor", "btnText", "disabled", "id", "onClear", "onSearch", "onType", "placeholder", "theme"];

function ownKeys$1o(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1o(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1o(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1o(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var colors$m = theme.colors,
    fonts$2 = theme.fonts,
    textVariants = theme.textVariants;
var SearchBarInputContainer = styled.div.withConfig({
  displayName: "search-bar__SearchBarInputContainer",
  componentId: "sc-1ctr91s-0"
})(["flex:1;display:flex;border:none;padding:0;", " ", " ", " ", " input{flex:1;font-family:", ";background:transparent;border:none;width:100%;line-height:34px;font-weight:300;font-size:2.2rem;padding:0 1.5rem;", " ", " &::-webkit-input-placeholder{", " font-weight:500;font-size:", ";}&::-moz-placeholder{", " font-weight:500;font-size:", ";}&:-ms-input-placeholder{", " font-weight:500;font-size:", ";}&:-moz-placeholder{", " font-weight:500;font-size:", ";}}"], function (_ref) {
  var background = _ref.background;
  return background && "background: ".concat(colors$m[background], ";");
}, function (_ref2) {
  var variant = _ref2.variant;
  return variant === 'dark' && "border-color: ".concat(colors$m.whiteDark, " !important;");
}, function (_ref3) {
  var bordered = _ref3.bordered;
  return bordered && "border: 1px solid ".concat(colors$m.greyDarker, ";");
}, function (_ref4) {
  var variant = _ref4.variant,
      bordered = _ref4.bordered;
  return variant === 'dark' && bordered && 'background-color: rgba(0,0,0,.6);';
}, fonts$2["default"], function (_ref5) {
  var bordered = _ref5.bordered;
  return bordered && 'font-size: 1.7rem;';
}, function (_ref6) {
  var variant = _ref6.variant;
  return variant === 'dark' ? "color: ".concat(colors$m.whiteDark, ";") : "color: ".concat(colors$m.blackLighter, ";");
}, function (_ref7) {
  var variant = _ref7.variant;
  return variant === 'dark' ? "color: ".concat(colors$m.greyDark, ";") : "color: ".concat(colors$m.greyDarker, ";");
}, textVariants.mega.fontSize, function (_ref8) {
  var variant = _ref8.variant;
  return variant === 'dark' ? "color: ".concat(colors$m.greyDark, ";") : "color: ".concat(colors$m.greyDarker, ";");
}, textVariants.mega.fontSize, function (_ref9) {
  var variant = _ref9.variant;
  return variant === 'dark' ? "color: ".concat(colors$m.greyDark, ";") : "color: ".concat(colors$m.greyDarker, ";");
}, textVariants.mega.fontSize, function (_ref0) {
  var variant = _ref0.variant;
  return variant === 'dark' ? "color: ".concat(colors$m.greyDark, ";") : "color: ".concat(colors$m.greyDarker, ";");
}, textVariants.mega.fontSize);
var ClearButton = styled.button.withConfig({
  displayName: "search-bar__ClearButton",
  componentId: "sc-1ctr91s-1"
})(["background:none;border:none;padding:0 1rem;margin-top:3px;", ""], function (_ref1) {
  var variant = _ref1.variant;
  return variant === 'dark' ? "color: ".concat(colors$m.whiteDark, ";") : "color: ".concat(colors$m.blackLighter, ";");
});
var defaultProps$M = {
  autoSearch: false,
  background: 'whiteDark',
  bordered: false,
  btnAriaLabel: 'Search',
  btnColor: undefined,
  btnText: 'Search',
  disabled: false,
  onClear: undefined,
  onType: undefined,
  theme: 'light'
};
var propTypes$1r = {
  autoSearch: PropTypes.bool,
  background: PropTypes.string,
  bordered: PropTypes.bool,
  btnAriaLabel: PropTypes.string,
  btnColor: PropTypes.string,
  btnText: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  onClear: PropTypes.func,
  onSearch: PropTypes.func.isRequired,
  onType: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
  theme: PropTypes.oneOf(['light', 'dark'])
};

function SearchBar(_ref10) {
  var autoSearch = _ref10.autoSearch,
      background = _ref10.background,
      bordered = _ref10.bordered,
      btnAriaLabel = _ref10.btnAriaLabel,
      btnColor = _ref10.btnColor,
      btnText = _ref10.btnText,
      disabled = _ref10.disabled,
      id = _ref10.id,
      onClear = _ref10.onClear,
      onSearch = _ref10.onSearch,
      onType = _ref10.onType,
      placeholder = _ref10.placeholder,
      theme = _ref10.theme,
      rest = _objectWithoutProperties$8(_ref10, _excluded$y);

  var _useState = useState(''),
      _useState2 = _slicedToArray$4(_useState, 2),
      term = _useState2[0],
      setTerm = _useState2[1];

  var inputEl = useRef(null);
  var debounced = useRef(debounce(function (newTerm) {
    if (newTerm) {
      onSearch(newTerm);
    }
  }, 700));
  useEffect(function () {
    if (!autoSearch) {
      return;
    }

    debounced.current(term);
  }, [term]);

  var inputChangeHandler = function inputChangeHandler(value) {
    setTerm(value);

    if (onType) {
      onType(value);
    }
  };

  var keyPressHandler = function keyPressHandler(event) {
    // clearTimeout(this.timeout)
    if (event.key === 'Enter') {
      onSearch(term);
    }
  };

  var handleTermClear = function handleTermClear(e) {
    e.preventDefault();
    setTerm('');

    if (onType) {
      onType('');
    }

    if (onClear) {
      onClear();
    }

    inputEl.current.focus();
  };

  return /*#__PURE__*/jsxs(Box$1, _objectSpread$1o(_objectSpread$1o({
    display: "flex",
    height: "4rem",
    minWidth: "30rem",
    mx: "auto",
    padding: "0",
    width: "100%"
  }, rest), {}, {
    children: [/*#__PURE__*/jsxs(SearchBarInputContainer, {
      background: background,
      bordered: bordered,
      variant: theme,
      children: [/*#__PURE__*/jsx$1("input", {
        ref: inputEl,
        "aria-label": placeholder,
        disabled: disabled,
        display: "flex",
        id: id,
        onChange: function onChange(event) {
          return inputChangeHandler(event.target.value);
        },
        onKeyPress: function onKeyPress(event) {
          return keyPressHandler(event);
        },
        placeholder: placeholder,
        value: term
      }), term.length > 0 && /*#__PURE__*/jsx$1(ClearButton, {
        "aria-label": "clear field",
        "aria-pressed": "true",
        onClick: handleTermClear,
        onKeyPress: function onKeyPress() {},
        role: "button",
        tabIndex: "0",
        variant: theme,
        children: /*#__PURE__*/jsx$1(Icon$2, {
          color: theme === 'dark' ? colors$m.whiteDark : colors$m.blackLighter,
          height: 32,
          name: "close",
          title: "clear search field",
          titleId: "clearSearchFieldIcon",
          width: 32
        })
      })]
    }), !onType && /*#__PURE__*/jsx$1(Box$1, {
      alignContent: "center",
      display: "flex",
      pl: "0",
      children: /*#__PURE__*/jsxs(Button$1, {
        ariaLabel: btnAriaLabel,
        color: btnColor,
        disabled: disabled,
        id: "search-btn",
        onClick: function onClick() {
          return onSearch(term);
        },
        children: [/*#__PURE__*/jsx$1(Text$1, {
          display: ['none', 'flex'],
          fontSize: "1.6rem",
          children: btnText
        }), /*#__PURE__*/jsx$1(Box$1, {
          display: ['block', 'none'],
          children: /*#__PURE__*/jsx$1(Icon$2, {
            color: "white",
            height: 25,
            mt: "-0.5rem",
            name: "search",
            title: "search",
            titleId: "searchMagnifyingGlassIcon",
            width: 20
          })
        })]
      })
    })]
  }));
}

SearchBar.defaultProps = defaultProps$M;
SearchBar.propTypes = propTypes$1r;
var _excluded$x = ["id", "inputBackground", "btnColor", "btnText", "btnAriaLabel", "theme", "bulkSearch", "onSearch", "tlds", "autoSearch", "placeholder", "promoTLDs", "containerProps"];

function ownKeys$1n(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1n(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1n(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1n(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var defaultProps$L = {
  autoSearch: false,
  bordered: false,
  btnAriaLabel: 'Search your domain or keyword',
  btnColor: '',
  btnText: 'Search',
  bulkSearch: false,
  containerProps: {},
  disabled: false,
  inputBackground: 'whiteDark',
  onSearch: null,
  placeholder: 'Search your keyword or domain',
  promoTLDs: [],
  theme: 'light',
  tlds: []
};
var propTypes$1q = {
  autoSearch: PropTypes.bool,
  bordered: PropTypes.bool,
  btnAriaLabel: PropTypes.string,
  btnColor: PropTypes.string,
  btnText: PropTypes.string,
  bulkSearch: PropTypes.bool,
  containerProps: PropTypes.shape({}),
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  inputBackground: PropTypes.string,
  onSearch: PropTypes.func,
  placeholder: PropTypes.string,
  promoTLDs: PropTypes.array,
  theme: PropTypes.oneOf(['light', 'dark']),
  tlds: PropTypes.arrayOf(PropTypes.string)
};

function DomainSearchBar(_ref) {
  var id = _ref.id,
      inputBackground = _ref.inputBackground,
      btnColor = _ref.btnColor,
      btnText = _ref.btnText,
      btnAriaLabel = _ref.btnAriaLabel,
      theme = _ref.theme,
      bulkSearch = _ref.bulkSearch,
      onSearch = _ref.onSearch,
      tlds = _ref.tlds,
      autoSearch = _ref.autoSearch,
      placeholder = _ref.placeholder,
      promoTLDs = _ref.promoTLDs,
      containerProps = _ref.containerProps,
      rest = _objectWithoutProperties$8(_ref, _excluded$x);

  var redirectCB = function redirectCB(domain) {
    var tldString = tlds && tlds.length > 0 ? "&tldonly=".concat(tlds.join(',')) : '';
    var exact = 'true';

    if (tldString !== '') {
      exact = 'false';
    }

    window.location = "/search/?exact=".concat(exact, "&q=").concat(domain).concat(tldString);
  };

  var handleSearch = function handleSearch(term) {
    var domain = cleanDomain(term);

    if (onSearch) {
      onSearch(domain);
    } else {
      redirectCB(domain);
    }
  };

  var suffix;

  if (tlds && tlds.length === 1) {
    suffix = ".".concat(tlds[0]);
  }

  var hasPromoTLDs = promoTLDs && promoTLDs.length > 0;
  return /*#__PURE__*/jsxs(Box$1, _objectSpread$1n(_objectSpread$1n({
    flexDirection: ['column', 'column', 'column', 'row'],
    mx: "auto",
    my: "2rem",
    width: "100%"
  }, containerProps), {}, {
    children: [/*#__PURE__*/jsxs(Box$1, {
      alignItems: "flex-end",
      flexDirection: "column",
      width: "100%",
      children: [/*#__PURE__*/jsx$1(SearchBar, _objectSpread$1n({
        autoSearch: autoSearch,
        background: inputBackground,
        btnAriaLabel: btnAriaLabel,
        btnColor: btnColor,
        btnText: btnText,
        id: id,
        onSearch: handleSearch,
        placeholder: placeholder || defaultProps$L.placeholder,
        suffix: suffix,
        theme: theme
      }, rest)), bulkSearch && /*#__PURE__*/jsx$1(Box$1, {
        mt: 3,
        children: /*#__PURE__*/jsx$1(Link$1, {
          ariaLabel: "Search for domains in bulk",
          color: theme === 'light' ? 'black' : 'white',
          href: "/search#bulk",
          variant: "link",
          children: /*#__PURE__*/jsx$1(Text$1, {
            textTransform: "uppercase",
            variant: "kiloBold",
            children: "bulk search"
          })
        })
      })]
    }), hasPromoTLDs && /*#__PURE__*/jsx$1(_StyledBox$k, {
      alignItems: "center",
      alignSelf: ['center', 'center', 'center', 'flex-start'],
      display: ['none', 'none', 'flex'],
      height: "4rem",
      mt: [3, 3, 3, 0],
      children: promoTLDs.map(function (tld) {
        var link = tld.link,
            price = tld.price;
        return /*#__PURE__*/jsx$1(Link$1, {
          ariaLabel: link.title,
          color: link.color,
          href: link.href,
          id: link.id,
          ml: [0, 0, 4],
          title: link.title,
          children: /*#__PURE__*/jsxs(Text$1, {
            fontSize: ['1rem', '1rem', 0],
            children: [/*#__PURE__*/jsx$1(Text$1, {
              as: "span",
              mr: 1,
              variant: "milliBold",
              children: link.text
            }), price]
          })
        }, link.id);
      })
    })]
  }));
}

DomainSearchBar.defaultProps = defaultProps$L;
DomainSearchBar.propTypes = propTypes$1q;

var _StyledBox$k = styled(Box$1).withConfig({
  displayName: "domain-search-bar___StyledBox",
  componentId: "sc-jhhd98-0"
})(["", ""], function (_ref2) {
  var systemTheme = _ref2.theme;
  return "\n        @media screen and (max-width: ".concat(systemTheme.breakpoints[2], ") {\n          & >:first-child {\n            margin-left: 0;\n          }\n        }\n        ");
});
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


var _extendStatics$2 = function extendStatics$1(d, b) {
  _extendStatics$2 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    }
  };

  return _extendStatics$2(d, b);
};

function __extends$1(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

  _extendStatics$2(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign$7 = function __assign$2() {
  _assign$7 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign$7.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
var genericMessage = "Invariant Violation";
var _a$2 = Object.setPrototypeOf,
    setPrototypeOf = _a$2 === void 0 ? function (obj, proto) {
  obj.__proto__ = proto;
  return obj;
} : _a$2;

var InvariantError = function (_super) {
  __extends$1(InvariantError, _super);

  function InvariantError(message) {
    if (message === void 0) {
      message = genericMessage;
    }

    var _this = _super.call(this, typeof message === "number" ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;

    _this.framesToPop = 1;
    _this.name = genericMessage;
    setPrototypeOf(_this, InvariantError.prototype);
    return _this;
  }

  return InvariantError;
}(Error);

function invariant(condition, message) {
  if (!condition) {
    throw new InvariantError(message);
  }
}

var verbosityLevels = ["debug", "log", "warn", "error", "silent"];
var verbosityLevel = verbosityLevels.indexOf("log");

function wrapConsoleMethod(name) {
  return function () {
    if (verbosityLevels.indexOf(name) >= verbosityLevel) {
      // Default to console.log if this host environment happens not to provide
      // all the console.* methods we need.
      var method = console[name] || console.log;
      return method.apply(console, arguments);
    }
  };
}

(function (invariant) {
  invariant.debug = wrapConsoleMethod("debug");
  invariant.log = wrapConsoleMethod("log");
  invariant.warn = wrapConsoleMethod("warn");
  invariant.error = wrapConsoleMethod("error");
})(invariant || (invariant = {}));

function maybe$2(thunk) {
  try {
    return thunk();
  } catch (_a) {}
}

var global$1 = maybe$2(function () {
  return globalThis;
}) || maybe$2(function () {
  return window;
}) || maybe$2(function () {
  return self;
}) || maybe$2(function () {
  return global$2;
}) || maybe$2(function () {
  return maybe$2.constructor("return this")();
});
var __ = "__";
var GLOBAL_KEY = [__, __].join("DEV");

function getDEV() {
  try {
    return Boolean(__DEV__);
  } catch (_a) {
    Object.defineProperty(global$1, GLOBAL_KEY, {
      value: maybe$2(function () {
        return process$1.env.NODE_ENV;
      }) !== "production",
      enumerable: false,
      configurable: true,
      writable: true
    });
    return global$1[GLOBAL_KEY];
  }
}

var DEV = getDEV();

function maybe$1(thunk) {
  try {
    return thunk();
  } catch (_) {}
}

var safeGlobal = maybe$1(function () {
  return globalThis;
}) || maybe$1(function () {
  return window;
}) || maybe$1(function () {
  return self;
}) || maybe$1(function () {
  return global$2;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
maybe$1(function () {
  return maybe$1.constructor("return this")();
});
var needToRemove = false;

function install() {
  if (safeGlobal && !maybe$1(function () {
    return process$1.env.NODE_ENV;
  }) && !maybe$1(function () {
    return process$1;
  })) {
    Object.defineProperty(safeGlobal, "process", {
      value: {
        env: {
          // This default needs to be "production" instead of "development", to
          // avoid the problem https://github.com/graphql/graphql-js/pull/2894
          // will eventually solve, once merged and released.
          NODE_ENV: "production"
        }
      },
      // Let anyone else change global.process as they see fit, but hide it from
      // Object.keys(global) enumeration.
      configurable: true,
      enumerable: false,
      writable: true
    });
    needToRemove = true;
  }
} // Call install() at least once, when this module is imported.


install();

function remove() {
  if (needToRemove) {
    delete safeGlobal.process;
    needToRemove = false;
  }
}

function removeTemporaryGlobals() {
  return typeof Source === "function" ? remove() : remove();
}

function checkDEV() {
  __DEV__ ? invariant("boolean" === typeof DEV, DEV) : invariant("boolean" === typeof DEV, 36);
}

removeTemporaryGlobals();
checkDEV();

function shouldInclude(_a, variables) {
  var directives = _a.directives;

  if (!directives || !directives.length) {
    return true;
  }

  return getInclusionDirectives(directives).every(function (_a) {
    var directive = _a.directive,
        ifArgument = _a.ifArgument;
    var evaledValue = false;

    if (ifArgument.value.kind === 'Variable') {
      evaledValue = variables && variables[ifArgument.value.name.value];
      __DEV__ ? invariant(evaledValue !== void 0, "Invalid variable referenced in @".concat(directive.name.value, " directive.")) : invariant(evaledValue !== void 0, 37);
    } else {
      evaledValue = ifArgument.value.value;
    }

    return directive.name.value === 'skip' ? !evaledValue : evaledValue;
  });
}

function getDirectiveNames(root) {
  var names = [];
  visit(root, {
    Directive: function Directive(node) {
      names.push(node.name.value);
    }
  });
  return names;
}

function hasDirectives(names, root) {
  return getDirectiveNames(root).some(function (name) {
    return names.indexOf(name) > -1;
  });
}

function hasClientExports(document) {
  return document && hasDirectives(['client'], document) && hasDirectives(['export'], document);
}

function isInclusionDirective(_a) {
  var value = _a.name.value;
  return value === 'skip' || value === 'include';
}

function getInclusionDirectives(directives) {
  var result = [];

  if (directives && directives.length) {
    directives.forEach(function (directive) {
      if (!isInclusionDirective(directive)) return;
      var directiveArguments = directive.arguments;
      var directiveName = directive.name.value;
      __DEV__ ? invariant(directiveArguments && directiveArguments.length === 1, "Incorrect number of arguments for the @".concat(directiveName, " directive.")) : invariant(directiveArguments && directiveArguments.length === 1, 38);
      var ifArgument = directiveArguments[0];
      __DEV__ ? invariant(ifArgument.name && ifArgument.name.value === 'if', "Invalid argument for the @".concat(directiveName, " directive.")) : invariant(ifArgument.name && ifArgument.name.value === 'if', 39);
      var ifValue = ifArgument.value;
      __DEV__ ? invariant(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), "Argument for the @".concat(directiveName, " directive must be a variable or a boolean value.")) : invariant(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 40);
      result.push({
        directive: directive,
        ifArgument: ifArgument
      });
    });
  }

  return result;
}

function getFragmentQueryDocument(document, fragmentName) {
  var actualFragmentName = fragmentName;
  var fragments = [];
  document.definitions.forEach(function (definition) {
    if (definition.kind === 'OperationDefinition') {
      throw __DEV__ ? new InvariantError("Found a ".concat(definition.operation, " operation").concat(definition.name ? " named '".concat(definition.name.value, "'") : '', ". ") + 'No operations are allowed when using a fragment as a query. Only fragments are allowed.') : new InvariantError(41);
    }

    if (definition.kind === 'FragmentDefinition') {
      fragments.push(definition);
    }
  });

  if (typeof actualFragmentName === 'undefined') {
    __DEV__ ? invariant(fragments.length === 1, "Found ".concat(fragments.length, " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.")) : invariant(fragments.length === 1, 42);
    actualFragmentName = fragments[0].name.value;
  }

  var query = _assign$7(_assign$7({}, document), {
    definitions: __spreadArray([{
      kind: 'OperationDefinition',
      operation: 'query',
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{
          kind: 'FragmentSpread',
          name: {
            kind: 'Name',
            value: actualFragmentName
          }
        }]
      }
    }], document.definitions, true)
  });

  return query;
}

function createFragmentMap(fragments) {
  if (fragments === void 0) {
    fragments = [];
  }

  var symTable = {};
  fragments.forEach(function (fragment) {
    symTable[fragment.name.value] = fragment;
  });
  return symTable;
}

function getFragmentFromSelection(selection, fragmentMap) {
  switch (selection.kind) {
    case 'InlineFragment':
      return selection;

    case 'FragmentSpread':
      {
        var fragment = fragmentMap && fragmentMap[selection.name.value];
        __DEV__ ? invariant(fragment, "No fragment named ".concat(selection.name.value, ".")) : invariant(fragment, 43);
        return fragment;
      }

    default:
      return null;
  }
}

function isNonNullObject$1(obj) {
  return obj !== null && typeof obj === 'object';
}

function makeReference(id) {
  return {
    __ref: String(id)
  };
}

function isReference(obj) {
  return Boolean(obj && typeof obj === 'object' && typeof obj.__ref === 'string');
}

function isDocumentNode(value) {
  return isNonNullObject$1(value) && value.kind === "Document" && Array.isArray(value.definitions);
}

function isStringValue(value) {
  return value.kind === 'StringValue';
}

function isBooleanValue(value) {
  return value.kind === 'BooleanValue';
}

function isIntValue(value) {
  return value.kind === 'IntValue';
}

function isFloatValue(value) {
  return value.kind === 'FloatValue';
}

function isVariable(value) {
  return value.kind === 'Variable';
}

function isObjectValue(value) {
  return value.kind === 'ObjectValue';
}

function isListValue(value) {
  return value.kind === 'ListValue';
}

function isEnumValue(value) {
  return value.kind === 'EnumValue';
}

function isNullValue(value) {
  return value.kind === 'NullValue';
}

function valueToObjectRepresentation(argObj, name, value, variables) {
  if (isIntValue(value) || isFloatValue(value)) {
    argObj[name.value] = Number(value.value);
  } else if (isBooleanValue(value) || isStringValue(value)) {
    argObj[name.value] = value.value;
  } else if (isObjectValue(value)) {
    var nestedArgObj_1 = {};
    value.fields.map(function (obj) {
      return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
    });
    argObj[name.value] = nestedArgObj_1;
  } else if (isVariable(value)) {
    var variableValue = (variables || {})[value.name.value];
    argObj[name.value] = variableValue;
  } else if (isListValue(value)) {
    argObj[name.value] = value.values.map(function (listValue) {
      var nestedArgArrayObj = {};
      valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
      return nestedArgArrayObj[name.value];
    });
  } else if (isEnumValue(value)) {
    argObj[name.value] = value.value;
  } else if (isNullValue(value)) {
    argObj[name.value] = null;
  } else {
    throw __DEV__ ? new InvariantError("The inline argument \"".concat(name.value, "\" of kind \"").concat(value.kind, "\"") + 'is not supported. Use variables instead of inline arguments to ' + 'overcome this limitation.') : new InvariantError(52);
  }
}

function storeKeyNameFromField(field, variables) {
  var directivesObj = null;

  if (field.directives) {
    directivesObj = {};
    field.directives.forEach(function (directive) {
      directivesObj[directive.name.value] = {};

      if (directive.arguments) {
        directive.arguments.forEach(function (_a) {
          var name = _a.name,
              value = _a.value;
          return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
        });
      }
    });
  }

  var argObj = null;

  if (field.arguments && field.arguments.length) {
    argObj = {};
    field.arguments.forEach(function (_a) {
      var name = _a.name,
          value = _a.value;
      return valueToObjectRepresentation(argObj, name, value, variables);
    });
  }

  return getStoreKeyName(field.name.value, argObj, directivesObj);
}

var KNOWN_DIRECTIVES = ['connection', 'include', 'skip', 'client', 'rest', 'export'];
var getStoreKeyName = Object.assign(function (fieldName, args, directives) {
  if (args && directives && directives['connection'] && directives['connection']['key']) {
    if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
      var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
      filterKeys.sort();
      var filteredArgs_1 = {};
      filterKeys.forEach(function (key) {
        filteredArgs_1[key] = args[key];
      });
      return "".concat(directives['connection']['key'], "(").concat(stringify(filteredArgs_1), ")");
    } else {
      return directives['connection']['key'];
    }
  }

  var completeFieldName = fieldName;

  if (args) {
    var stringifiedArgs = stringify(args);
    completeFieldName += "(".concat(stringifiedArgs, ")");
  }

  if (directives) {
    Object.keys(directives).forEach(function (key) {
      if (KNOWN_DIRECTIVES.indexOf(key) !== -1) return;

      if (directives[key] && Object.keys(directives[key]).length) {
        completeFieldName += "@".concat(key, "(").concat(stringify(directives[key]), ")");
      } else {
        completeFieldName += "@".concat(key);
      }
    });
  }

  return completeFieldName;
}, {
  setStringify: function setStringify(s) {
    var previous = stringify;
    stringify = s;
    return previous;
  }
});

var stringify = function defaultStringify(value) {
  return JSON.stringify(value, stringifyReplacer);
};

function stringifyReplacer(_key, value) {
  if (isNonNullObject$1(value) && !Array.isArray(value)) {
    value = Object.keys(value).sort().reduce(function (copy, key) {
      copy[key] = value[key];
      return copy;
    }, {});
  }

  return value;
}

function argumentsObjectFromField(field, variables) {
  if (field.arguments && field.arguments.length) {
    var argObj_1 = {};
    field.arguments.forEach(function (_a) {
      var name = _a.name,
          value = _a.value;
      return valueToObjectRepresentation(argObj_1, name, value, variables);
    });
    return argObj_1;
  }

  return null;
}

function resultKeyNameFromField(field) {
  return field.alias ? field.alias.value : field.name.value;
}

function getTypenameFromResult(result, selectionSet, fragmentMap) {
  if (typeof result.__typename === 'string') {
    return result.__typename;
  }

  for (var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++) {
    var selection = _a[_i];

    if (isField(selection)) {
      if (selection.name.value === '__typename') {
        return result[resultKeyNameFromField(selection)];
      }
    } else {
      var typename = getTypenameFromResult(result, getFragmentFromSelection(selection, fragmentMap).selectionSet, fragmentMap);

      if (typeof typename === 'string') {
        return typename;
      }
    }
  }
}

function isField(selection) {
  return selection.kind === 'Field';
}

function isInlineFragment(selection) {
  return selection.kind === 'InlineFragment';
}

function checkDocument(doc) {
  __DEV__ ? invariant(doc && doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql") : invariant(doc && doc.kind === 'Document', 44);
  var operations = doc.definitions.filter(function (d) {
    return d.kind !== 'FragmentDefinition';
  }).map(function (definition) {
    if (definition.kind !== 'OperationDefinition') {
      throw __DEV__ ? new InvariantError("Schema type definitions not allowed in queries. Found: \"".concat(definition.kind, "\"")) : new InvariantError(45);
    }

    return definition;
  });
  __DEV__ ? invariant(operations.length <= 1, "Ambiguous GraphQL document: contains ".concat(operations.length, " operations")) : invariant(operations.length <= 1, 46);
  return doc;
}

function getOperationDefinition(doc) {
  checkDocument(doc);
  return doc.definitions.filter(function (definition) {
    return definition.kind === 'OperationDefinition';
  })[0];
}

function getOperationName(doc) {
  return doc.definitions.filter(function (definition) {
    return definition.kind === 'OperationDefinition' && definition.name;
  }).map(function (x) {
    return x.name.value;
  })[0] || null;
}

function getFragmentDefinitions(doc) {
  return doc.definitions.filter(function (definition) {
    return definition.kind === 'FragmentDefinition';
  });
}

function getQueryDefinition(doc) {
  var queryDef = getOperationDefinition(doc);
  __DEV__ ? invariant(queryDef && queryDef.operation === 'query', 'Must contain a query definition.') : invariant(queryDef && queryDef.operation === 'query', 47);
  return queryDef;
}

function getFragmentDefinition(doc) {
  __DEV__ ? invariant(doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql") : invariant(doc.kind === 'Document', 48);
  __DEV__ ? invariant(doc.definitions.length <= 1, 'Fragment must have exactly one definition.') : invariant(doc.definitions.length <= 1, 49);
  var fragmentDef = doc.definitions[0];
  __DEV__ ? invariant(fragmentDef.kind === 'FragmentDefinition', 'Must be a fragment definition.') : invariant(fragmentDef.kind === 'FragmentDefinition', 50);
  return fragmentDef;
}

function getMainDefinition(queryDoc) {
  checkDocument(queryDoc);
  var fragmentDefinition;

  for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
    var definition = _a[_i];

    if (definition.kind === 'OperationDefinition') {
      var operation = definition.operation;

      if (operation === 'query' || operation === 'mutation' || operation === 'subscription') {
        return definition;
      }
    }

    if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
      fragmentDefinition = definition;
    }
  }

  if (fragmentDefinition) {
    return fragmentDefinition;
  }

  throw __DEV__ ? new InvariantError('Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.') : new InvariantError(51);
}

function getDefaultValues(definition) {
  var defaultValues = Object.create(null);
  var defs = definition && definition.variableDefinitions;

  if (defs && defs.length) {
    defs.forEach(function (def) {
      if (def.defaultValue) {
        valueToObjectRepresentation(defaultValues, def.variable.name, def.defaultValue);
      }
    });
  }

  return defaultValues;
}

function filterInPlace(array, test, context) {
  var target = 0;
  array.forEach(function (elem, i) {
    if (test.call(this, elem, i, array)) {
      array[target++] = elem;
    }
  }, context);
  array.length = target;
  return array;
}

var TYPENAME_FIELD = {
  kind: 'Field',
  name: {
    kind: 'Name',
    value: '__typename'
  }
};

function isEmpty(op, fragments) {
  return op.selectionSet.selections.every(function (selection) {
    return selection.kind === 'FragmentSpread' && isEmpty(fragments[selection.name.value], fragments);
  });
}

function nullIfDocIsEmpty(doc) {
  return isEmpty(getOperationDefinition(doc) || getFragmentDefinition(doc), createFragmentMap(getFragmentDefinitions(doc))) ? null : doc;
}

function getDirectiveMatcher(directives) {
  return function directiveMatcher(directive) {
    return directives.some(function (dir) {
      return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
    });
  };
}

function removeDirectivesFromDocument(directives, doc) {
  var variablesInUse = Object.create(null);
  var variablesToRemove = [];
  var fragmentSpreadsInUse = Object.create(null);
  var fragmentSpreadsToRemove = [];
  var modifiedDoc = nullIfDocIsEmpty(visit(doc, {
    Variable: {
      enter: function enter(node, _key, parent) {
        if (parent.kind !== 'VariableDefinition') {
          variablesInUse[node.name.value] = true;
        }
      }
    },
    Field: {
      enter: function enter(node) {
        if (directives && node.directives) {
          var shouldRemoveField = directives.some(function (directive) {
            return directive.remove;
          });

          if (shouldRemoveField && node.directives && node.directives.some(getDirectiveMatcher(directives))) {
            if (node.arguments) {
              node.arguments.forEach(function (arg) {
                if (arg.value.kind === 'Variable') {
                  variablesToRemove.push({
                    name: arg.value.name.value
                  });
                }
              });
            }

            if (node.selectionSet) {
              getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function (frag) {
                fragmentSpreadsToRemove.push({
                  name: frag.name.value
                });
              });
            }

            return null;
          }
        }
      }
    },
    FragmentSpread: {
      enter: function enter(node) {
        fragmentSpreadsInUse[node.name.value] = true;
      }
    },
    Directive: {
      enter: function enter(node) {
        if (getDirectiveMatcher(directives)(node)) {
          return null;
        }
      }
    }
  }));

  if (modifiedDoc && filterInPlace(variablesToRemove, function (v) {
    return !!v.name && !variablesInUse[v.name];
  }).length) {
    modifiedDoc = removeArgumentsFromDocument(variablesToRemove, modifiedDoc);
  }

  if (modifiedDoc && filterInPlace(fragmentSpreadsToRemove, function (fs) {
    return !!fs.name && !fragmentSpreadsInUse[fs.name];
  }).length) {
    modifiedDoc = removeFragmentSpreadFromDocument(fragmentSpreadsToRemove, modifiedDoc);
  }

  return modifiedDoc;
}

var addTypenameToDocument = Object.assign(function (doc) {
  return visit(checkDocument(doc), {
    SelectionSet: {
      enter: function enter(node, _key, parent) {
        if (parent && parent.kind === 'OperationDefinition') {
          return;
        }

        var selections = node.selections;

        if (!selections) {
          return;
        }

        var skip = selections.some(function (selection) {
          return isField(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
        });

        if (skip) {
          return;
        }

        var field = parent;

        if (isField(field) && field.directives && field.directives.some(function (d) {
          return d.name.value === 'export';
        })) {
          return;
        }

        return _assign$7(_assign$7({}, node), {
          selections: __spreadArray(__spreadArray([], selections, true), [TYPENAME_FIELD], false)
        });
      }
    }
  });
}, {
  added: function added(field) {
    return field === TYPENAME_FIELD;
  }
});
var connectionRemoveConfig = {
  test: function test(directive) {
    var willRemove = directive.name.value === 'connection';

    if (willRemove) {
      if (!directive.arguments || !directive.arguments.some(function (arg) {
        return arg.name.value === 'key';
      })) {
        __DEV__ && invariant.warn('Removing an @connection directive even though it does not have a key. ' + 'You may want to use the key parameter to specify a store key.');
      }
    }

    return willRemove;
  }
};

function removeConnectionDirectiveFromDocument(doc) {
  return removeDirectivesFromDocument([connectionRemoveConfig], checkDocument(doc));
}

function getArgumentMatcher(config) {
  return function argumentMatcher(argument) {
    return config.some(function (aConfig) {
      return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
    });
  };
}

function removeArgumentsFromDocument(config, doc) {
  var argMatcher = getArgumentMatcher(config);
  return nullIfDocIsEmpty(visit(doc, {
    OperationDefinition: {
      enter: function enter(node) {
        return _assign$7(_assign$7({}, node), {
          variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function (varDef) {
            return !config.some(function (arg) {
              return arg.name === varDef.variable.name.value;
            });
          }) : []
        });
      }
    },
    Field: {
      enter: function enter(node) {
        var shouldRemoveField = config.some(function (argConfig) {
          return argConfig.remove;
        });

        if (shouldRemoveField) {
          var argMatchCount_1 = 0;

          if (node.arguments) {
            node.arguments.forEach(function (arg) {
              if (argMatcher(arg)) {
                argMatchCount_1 += 1;
              }
            });
          }

          if (argMatchCount_1 === 1) {
            return null;
          }
        }
      }
    },
    Argument: {
      enter: function enter(node) {
        if (argMatcher(node)) {
          return null;
        }
      }
    }
  }));
}

function removeFragmentSpreadFromDocument(config, doc) {
  function enter(node) {
    if (config.some(function (def) {
      return def.name === node.name.value;
    })) {
      return null;
    }
  }

  return nullIfDocIsEmpty(visit(doc, {
    FragmentSpread: {
      enter: enter
    },
    FragmentDefinition: {
      enter: enter
    }
  }));
}

function getAllFragmentSpreadsFromSelectionSet(selectionSet) {
  var allFragments = [];
  selectionSet.selections.forEach(function (selection) {
    if ((isField(selection) || isInlineFragment(selection)) && selection.selectionSet) {
      getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function (frag) {
        return allFragments.push(frag);
      });
    } else if (selection.kind === 'FragmentSpread') {
      allFragments.push(selection);
    }
  });
  return allFragments;
}

function buildQueryFromSelectionSet(document) {
  var definition = getMainDefinition(document);
  var definitionOperation = definition.operation;

  if (definitionOperation === 'query') {
    return document;
  }

  var modifiedDoc = visit(document, {
    OperationDefinition: {
      enter: function enter(node) {
        return _assign$7(_assign$7({}, node), {
          operation: 'query'
        });
      }
    }
  });
  return modifiedDoc;
}

function removeClientSetsFromDocument(document) {
  checkDocument(document);
  var modifiedDoc = removeDirectivesFromDocument([{
    test: function test(directive) {
      return directive.name.value === 'client';
    },
    remove: true
  }], document);

  if (modifiedDoc) {
    modifiedDoc = visit(modifiedDoc, {
      FragmentDefinition: {
        enter: function enter(node) {
          if (node.selectionSet) {
            var isTypenameOnly = node.selectionSet.selections.every(function (selection) {
              return isField(selection) && selection.name.value === '__typename';
            });

            if (isTypenameOnly) {
              return null;
            }
          }
        }
      }
    });
  }

  return modifiedDoc;
}

var hasOwnProperty$g = Object.prototype.hasOwnProperty;

function mergeDeep() {
  var sources = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    sources[_i] = arguments[_i];
  }

  return mergeDeepArray(sources);
}

function mergeDeepArray(sources) {
  var target = sources[0] || {};
  var count = sources.length;

  if (count > 1) {
    var merger = new DeepMerger();

    for (var i = 1; i < count; ++i) {
      target = merger.merge(target, sources[i]);
    }
  }

  return target;
}

var defaultReconciler = function defaultReconciler(target, source, property) {
  return this.merge(target[property], source[property]);
};

var DeepMerger = function () {
  function DeepMerger(reconciler) {
    if (reconciler === void 0) {
      reconciler = defaultReconciler;
    }

    this.reconciler = reconciler;
    this.isObject = isNonNullObject$1;
    this.pastCopies = new Set();
  }

  DeepMerger.prototype.merge = function (target, source) {
    var _this = this;

    var context = [];

    for (var _i = 2; _i < arguments.length; _i++) {
      context[_i - 2] = arguments[_i];
    }

    if (isNonNullObject$1(source) && isNonNullObject$1(target)) {
      Object.keys(source).forEach(function (sourceKey) {
        if (hasOwnProperty$g.call(target, sourceKey)) {
          var targetValue = target[sourceKey];

          if (source[sourceKey] !== targetValue) {
            var result = _this.reconciler.apply(_this, __spreadArray([target, source, sourceKey], context, false));

            if (result !== targetValue) {
              target = _this.shallowCopyForMerge(target);
              target[sourceKey] = result;
            }
          }
        } else {
          target = _this.shallowCopyForMerge(target);
          target[sourceKey] = source[sourceKey];
        }
      });
      return target;
    }

    return source;
  };

  DeepMerger.prototype.shallowCopyForMerge = function (value) {
    if (isNonNullObject$1(value)) {
      if (this.pastCopies.has(value)) {
        if (!Object.isFrozen(value)) return value;
        this.pastCopies.delete(value);
      }

      if (Array.isArray(value)) {
        value = value.slice(0);
      } else {
        value = _assign$7({
          __proto__: Object.getPrototypeOf(value)
        }, value);
      }

      this.pastCopies.add(value);
    }

    return value;
  };

  return DeepMerger;
}();

function _createForOfIteratorHelperLoose$b(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray$e(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray$e(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$e(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$e(o, minLen);
}

function _arrayLikeToArray$e(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _defineProperties$8(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$8(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$8(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$8(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
} // === Symbol Support ===


var hasSymbols = function hasSymbols() {
  return typeof Symbol === 'function';
};

var hasSymbol = function hasSymbol(name) {
  return hasSymbols() && Boolean(Symbol[name]);
};

var getSymbol = function getSymbol(name) {
  return hasSymbol(name) ? Symbol[name] : '@@' + name;
};

if (hasSymbols() && !hasSymbol('observable')) {
  Symbol.observable = Symbol('observable');
}

var SymbolIterator = getSymbol('iterator');
var SymbolObservable = getSymbol('observable');
var SymbolSpecies = getSymbol('species'); // === Abstract Operations ===

function getMethod(obj, key) {
  var value = obj[key];
  if (value == null) return undefined;
  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
  return value;
}

function getSpecies(obj) {
  var ctor = obj.constructor;

  if (ctor !== undefined) {
    ctor = ctor[SymbolSpecies];

    if (ctor === null) {
      ctor = undefined;
    }
  }

  return ctor !== undefined ? ctor : Observable;
}

function isObservable(x) {
  return x instanceof Observable; // SPEC: Brand check
}

function hostReportError(e) {
  if (hostReportError.log) {
    hostReportError.log(e);
  } else {
    setTimeout(function () {
      throw e;
    });
  }
}

function enqueue(fn) {
  Promise.resolve().then(function () {
    try {
      fn();
    } catch (e) {
      hostReportError(e);
    }
  });
}

function cleanupSubscription(subscription) {
  var cleanup = subscription._cleanup;
  if (cleanup === undefined) return;
  subscription._cleanup = undefined;

  if (!cleanup) {
    return;
  }

  try {
    if (typeof cleanup === 'function') {
      cleanup();
    } else {
      var unsubscribe = getMethod(cleanup, 'unsubscribe');

      if (unsubscribe) {
        unsubscribe.call(cleanup);
      }
    }
  } catch (e) {
    hostReportError(e);
  }
}

function closeSubscription(subscription) {
  subscription._observer = undefined;
  subscription._queue = undefined;
  subscription._state = 'closed';
}

function flushSubscription(subscription) {
  var queue = subscription._queue;

  if (!queue) {
    return;
  }

  subscription._queue = undefined;
  subscription._state = 'ready';

  for (var i = 0; i < queue.length; ++i) {
    notifySubscription(subscription, queue[i].type, queue[i].value);
    if (subscription._state === 'closed') break;
  }
}

function notifySubscription(subscription, type, value) {
  subscription._state = 'running';
  var observer = subscription._observer;

  try {
    var m = getMethod(observer, type);

    switch (type) {
      case 'next':
        if (m) m.call(observer, value);
        break;

      case 'error':
        closeSubscription(subscription);
        if (m) m.call(observer, value);else throw value;
        break;

      case 'complete':
        closeSubscription(subscription);
        if (m) m.call(observer);
        break;
    }
  } catch (e) {
    hostReportError(e);
  }

  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
}

function onNotify(subscription, type, value) {
  if (subscription._state === 'closed') return;

  if (subscription._state === 'buffering') {
    subscription._queue.push({
      type: type,
      value: value
    });

    return;
  }

  if (subscription._state !== 'ready') {
    subscription._state = 'buffering';
    subscription._queue = [{
      type: type,
      value: value
    }];
    enqueue(function () {
      return flushSubscription(subscription);
    });
    return;
  }

  notifySubscription(subscription, type, value);
}

var Subscription = /*#__PURE__*/function () {
  function Subscription(observer, subscriber) {
    // ASSERT: observer is an object
    // ASSERT: subscriber is callable
    this._cleanup = undefined;
    this._observer = observer;
    this._queue = undefined;
    this._state = 'initializing';
    var subscriptionObserver = new SubscriptionObserver(this);

    try {
      this._cleanup = subscriber.call(undefined, subscriptionObserver);
    } catch (e) {
      subscriptionObserver.error(e);
    }

    if (this._state === 'initializing') this._state = 'ready';
  }

  var _proto = Subscription.prototype;

  _proto.unsubscribe = function unsubscribe() {
    if (this._state !== 'closed') {
      closeSubscription(this);
      cleanupSubscription(this);
    }
  };

  _createClass$8(Subscription, [{
    key: "closed",
    get: function get() {
      return this._state === 'closed';
    }
  }]);

  return Subscription;
}();

var SubscriptionObserver = /*#__PURE__*/function () {
  function SubscriptionObserver(subscription) {
    this._subscription = subscription;
  }

  var _proto2 = SubscriptionObserver.prototype;

  _proto2.next = function next(value) {
    onNotify(this._subscription, 'next', value);
  };

  _proto2.error = function error(value) {
    onNotify(this._subscription, 'error', value);
  };

  _proto2.complete = function complete() {
    onNotify(this._subscription, 'complete');
  };

  _createClass$8(SubscriptionObserver, [{
    key: "closed",
    get: function get() {
      return this._subscription._state === 'closed';
    }
  }]);

  return SubscriptionObserver;
}();

var Observable = /*#__PURE__*/function () {
  function Observable(subscriber) {
    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
    this._subscriber = subscriber;
  }

  var _proto3 = Observable.prototype;

  _proto3.subscribe = function subscribe(observer) {
    if (typeof observer !== 'object' || observer === null) {
      observer = {
        next: observer,
        error: arguments[1],
        complete: arguments[2]
      };
    }

    return new Subscription(observer, this._subscriber);
  };

  _proto3.forEach = function forEach(fn) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (typeof fn !== 'function') {
        reject(new TypeError(fn + ' is not a function'));
        return;
      }

      function done() {
        subscription.unsubscribe();
        resolve();
      }

      var subscription = _this.subscribe({
        next: function next(value) {
          try {
            fn(value, done);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  };

  _proto3.map = function map(fn) {
    var _this2 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      return _this2.subscribe({
        next: function next(value) {
          try {
            value = fn(value);
          } catch (e) {
            return observer.error(e);
          }

          observer.next(value);
        },
        error: function error(e) {
          observer.error(e);
        },
        complete: function complete() {
          observer.complete();
        }
      });
    });
  };

  _proto3.filter = function filter(fn) {
    var _this3 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      return _this3.subscribe({
        next: function next(value) {
          try {
            if (!fn(value)) return;
          } catch (e) {
            return observer.error(e);
          }

          observer.next(value);
        },
        error: function error(e) {
          observer.error(e);
        },
        complete: function complete() {
          observer.complete();
        }
      });
    });
  };

  _proto3.reduce = function reduce(fn) {
    var _this4 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    var hasSeed = arguments.length > 1;
    var hasValue = false;
    var seed = arguments[1];
    var acc = seed;
    return new C(function (observer) {
      return _this4.subscribe({
        next: function next(value) {
          var first = !hasValue;
          hasValue = true;

          if (!first || hasSeed) {
            try {
              acc = fn(acc, value);
            } catch (e) {
              return observer.error(e);
            }
          } else {
            acc = value;
          }
        },
        error: function error(e) {
          observer.error(e);
        },
        complete: function complete() {
          if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
          observer.next(acc);
          observer.complete();
        }
      });
    });
  };

  _proto3.concat = function concat() {
    var _this5 = this;

    for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
      sources[_key] = arguments[_key];
    }

    var C = getSpecies(this);
    return new C(function (observer) {
      var subscription;
      var index = 0;

      function startNext(next) {
        subscription = next.subscribe({
          next: function next(v) {
            observer.next(v);
          },
          error: function error(e) {
            observer.error(e);
          },
          complete: function complete() {
            if (index === sources.length) {
              subscription = undefined;
              observer.complete();
            } else {
              startNext(C.from(sources[index++]));
            }
          }
        });
      }

      startNext(_this5);
      return function () {
        if (subscription) {
          subscription.unsubscribe();
          subscription = undefined;
        }
      };
    });
  };

  _proto3.flatMap = function flatMap(fn) {
    var _this6 = this;

    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
    var C = getSpecies(this);
    return new C(function (observer) {
      var subscriptions = [];

      var outer = _this6.subscribe({
        next: function next(value) {
          if (fn) {
            try {
              value = fn(value);
            } catch (e) {
              return observer.error(e);
            }
          }

          var inner = C.from(value).subscribe({
            next: function next(value) {
              observer.next(value);
            },
            error: function error(e) {
              observer.error(e);
            },
            complete: function complete() {
              var i = subscriptions.indexOf(inner);
              if (i >= 0) subscriptions.splice(i, 1);
              completeIfDone();
            }
          });
          subscriptions.push(inner);
        },
        error: function error(e) {
          observer.error(e);
        },
        complete: function complete() {
          completeIfDone();
        }
      });

      function completeIfDone() {
        if (outer.closed && subscriptions.length === 0) observer.complete();
      }

      return function () {
        subscriptions.forEach(function (s) {
          return s.unsubscribe();
        });
        outer.unsubscribe();
      };
    });
  };

  _proto3[SymbolObservable] = function () {
    return this;
  };

  Observable.from = function from(x) {
    var C = typeof this === 'function' ? this : Observable;
    if (x == null) throw new TypeError(x + ' is not an object');
    var method = getMethod(x, SymbolObservable);

    if (method) {
      var observable = method.call(x);
      if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
      if (isObservable(observable) && observable.constructor === C) return observable;
      return new C(function (observer) {
        return observable.subscribe(observer);
      });
    }

    if (hasSymbol('iterator')) {
      method = getMethod(x, SymbolIterator);

      if (method) {
        return new C(function (observer) {
          enqueue(function () {
            if (observer.closed) return;

            for (var _iterator = _createForOfIteratorHelperLoose$b(method.call(x)), _step; !(_step = _iterator()).done;) {
              var item = _step.value;
              observer.next(item);
              if (observer.closed) return;
            }

            observer.complete();
          });
        });
      }
    }

    if (Array.isArray(x)) {
      return new C(function (observer) {
        enqueue(function () {
          if (observer.closed) return;

          for (var i = 0; i < x.length; ++i) {
            observer.next(x[i]);
            if (observer.closed) return;
          }

          observer.complete();
        });
      });
    }

    throw new TypeError(x + ' is not observable');
  };

  Observable.of = function of() {
    for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      items[_key2] = arguments[_key2];
    }

    var C = typeof this === 'function' ? this : Observable;
    return new C(function (observer) {
      enqueue(function () {
        if (observer.closed) return;

        for (var i = 0; i < items.length; ++i) {
          observer.next(items[i]);
          if (observer.closed) return;
        }

        observer.complete();
      });
    });
  };

  _createClass$8(Observable, null, [{
    key: SymbolSpecies,
    get: function get() {
      return this;
    }
  }]);

  return Observable;
}();

if (hasSymbols()) {
  Object.defineProperty(Observable, Symbol('extensions'), {
    value: {
      symbol: SymbolObservable,
      hostReportError: hostReportError
    },
    configurable: true
  });
}

function symbolObservablePonyfill(root) {
  var result;
  var Symbol = root.Symbol;

  if (typeof Symbol === 'function') {
    if (Symbol.observable) {
      result = Symbol.observable;
    } else {
      if (typeof Symbol.for === 'function') {
        // This just needs to be something that won't trample other user's Symbol.for use
        // It also will guide people to the source of their issues, if this is problematic.
        // META: It's a resource locator!
        result = Symbol.for('https://github.com/benlesh/symbol-observable');
      } else {
        // Symbol.for didn't exist! The best we can do at this point is a totally 
        // unique symbol. Note that the string argument here is a descriptor, not
        // an identifier. This symbol is unique.
        result = Symbol('https://github.com/benlesh/symbol-observable');
      }

      try {
        Symbol.observable = result;
      } catch (err) {// Do nothing. In some environments, users have frozen `Symbol` for security reasons,
        // if it is frozen assigning to it will throw. In this case, we don't care, because
        // they will need to use the returned value from the ponyfill.
      }
    }
  } else {
    result = '@@observable';
  }

  return result;
}

var root$2;

if (typeof self !== 'undefined') {
  root$2 = self;
} else if (typeof window !== 'undefined') {
  root$2 = window;
} else if (typeof global$2 !== 'undefined') {
  root$2 = global$2;
} else if (typeof module !== 'undefined') {
  root$2 = module;
} else {
  root$2 = Function('return this')();
}

symbolObservablePonyfill(root$2);
var prototype = Observable.prototype;
var fakeObsSymbol = '@@observable';

if (!prototype[fakeObsSymbol]) {
  prototype[fakeObsSymbol] = function () {
    return this;
  };
}

var toString$3 = Object.prototype.toString;

function cloneDeep(value) {
  return cloneDeepHelper(value);
}

function cloneDeepHelper(val, seen) {
  switch (toString$3.call(val)) {
    case "[object Array]":
      {
        seen = seen || new Map();
        if (seen.has(val)) return seen.get(val);
        var copy_1 = val.slice(0);
        seen.set(val, copy_1);
        copy_1.forEach(function (child, i) {
          copy_1[i] = cloneDeepHelper(child, seen);
        });
        return copy_1;
      }

    case "[object Object]":
      {
        seen = seen || new Map();
        if (seen.has(val)) return seen.get(val);
        var copy_2 = Object.create(Object.getPrototypeOf(val));
        seen.set(val, copy_2);
        Object.keys(val).forEach(function (key) {
          copy_2[key] = cloneDeepHelper(val[key], seen);
        });
        return copy_2;
      }

    default:
      return val;
  }
}

function deepFreeze(value) {
  var workSet = new Set([value]);
  workSet.forEach(function (obj) {
    if (isNonNullObject$1(obj) && shallowFreeze(obj) === obj) {
      Object.getOwnPropertyNames(obj).forEach(function (name) {
        if (isNonNullObject$1(obj[name])) workSet.add(obj[name]);
      });
    }
  });
  return value;
}

function shallowFreeze(obj) {
  if (__DEV__ && !Object.isFrozen(obj)) {
    try {
      Object.freeze(obj);
    } catch (e) {
      if (e instanceof TypeError) return null;
      throw e;
    }
  }

  return obj;
}

function maybeDeepFreeze(obj) {
  if (__DEV__) {
    deepFreeze(obj);
  }

  return obj;
}

function iterateObserversSafely(observers, method, argument) {
  var observersWithMethod = [];
  observers.forEach(function (obs) {
    return obs[method] && observersWithMethod.push(obs);
  });
  observersWithMethod.forEach(function (obs) {
    return obs[method](argument);
  });
}

function asyncMap(observable, mapFn, catchFn) {
  return new Observable(function (observer) {
    var next = observer.next,
        error = observer.error,
        _complete2 = observer.complete;
    var activeCallbackCount = 0;
    var completed = false;
    var promiseQueue = {
      then: function then(callback) {
        return new Promise(function (resolve) {
          return resolve(callback());
        });
      }
    };

    function makeCallback(examiner, delegate) {
      if (examiner) {
        return function (arg) {
          ++activeCallbackCount;

          var both = function both() {
            return examiner(arg);
          };

          promiseQueue = promiseQueue.then(both, both).then(function (result) {
            --activeCallbackCount;
            next && next.call(observer, result);

            if (completed) {
              handler.complete();
            }
          }, function (error) {
            --activeCallbackCount;
            throw error;
          }).catch(function (caught) {
            error && error.call(observer, caught);
          });
        };
      } else {
        return function (arg) {
          return delegate && delegate.call(observer, arg);
        };
      }
    }

    var handler = {
      next: makeCallback(mapFn, next),
      error: makeCallback(catchFn, error),
      complete: function complete() {
        completed = true;

        if (!activeCallbackCount) {
          _complete2 && _complete2.call(observer);
        }
      }
    };
    var sub = observable.subscribe(handler);
    return function () {
      return sub.unsubscribe();
    };
  });
}

var canUseWeakMap = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var canUseWeakSet = typeof WeakSet === 'function';
var canUseSymbol$1 = typeof Symbol === 'function' && typeof Symbol.for === 'function';

function fixObservableSubclass(subclass) {
  function set(key) {
    Object.defineProperty(subclass, key, {
      value: Observable
    });
  }

  if (canUseSymbol$1 && Symbol.species) {
    set(Symbol.species);
  }

  set("@@species");
  return subclass;
}

function isPromiseLike(value) {
  return value && typeof value.then === "function";
}

var Concast = function (_super) {
  __extends$1(Concast, _super);

  function Concast(sources) {
    var _this = _super.call(this, function (observer) {
      _this.addObserver(observer);

      return function () {
        return _this.removeObserver(observer);
      };
    }) || this;

    _this.observers = new Set();
    _this.addCount = 0;
    _this.promise = new Promise(function (resolve, reject) {
      _this.resolve = resolve;
      _this.reject = reject;
    });
    _this.handlers = {
      next: function next(result) {
        if (_this.sub !== null) {
          _this.latest = ["next", result];
          iterateObserversSafely(_this.observers, "next", result);
        }
      },
      error: function error(_error3) {
        var sub = _this.sub;

        if (sub !== null) {
          if (sub) setTimeout(function () {
            return sub.unsubscribe();
          });
          _this.sub = null;
          _this.latest = ["error", _error3];

          _this.reject(_error3);

          iterateObserversSafely(_this.observers, "error", _error3);
        }
      },
      complete: function complete() {
        if (_this.sub !== null) {
          var value = _this.sources.shift();

          if (!value) {
            _this.sub = null;

            if (_this.latest && _this.latest[0] === "next") {
              _this.resolve(_this.latest[1]);
            } else {
              _this.resolve();
            }

            iterateObserversSafely(_this.observers, "complete");
          } else if (isPromiseLike(value)) {
            value.then(function (obs) {
              return _this.sub = obs.subscribe(_this.handlers);
            });
          } else {
            _this.sub = value.subscribe(_this.handlers);
          }
        }
      }
    };

    _this.cancel = function (reason) {
      _this.reject(reason);

      _this.sources = [];

      _this.handlers.complete();
    };

    _this.promise.catch(function (_) {});

    if (typeof sources === "function") {
      sources = [new Observable(sources)];
    }

    if (isPromiseLike(sources)) {
      sources.then(function (iterable) {
        return _this.start(iterable);
      }, _this.handlers.error);
    } else {
      _this.start(sources);
    }

    return _this;
  }

  Concast.prototype.start = function (sources) {
    if (this.sub !== void 0) return;
    this.sources = Array.from(sources);
    this.handlers.complete();
  };

  Concast.prototype.deliverLastMessage = function (observer) {
    if (this.latest) {
      var nextOrError = this.latest[0];
      var method = observer[nextOrError];

      if (method) {
        method.call(observer, this.latest[1]);
      }

      if (this.sub === null && nextOrError === "next" && observer.complete) {
        observer.complete();
      }
    }
  };

  Concast.prototype.addObserver = function (observer) {
    if (!this.observers.has(observer)) {
      this.deliverLastMessage(observer);
      this.observers.add(observer);
      ++this.addCount;
    }
  };

  Concast.prototype.removeObserver = function (observer, quietly) {
    if (this.observers.delete(observer) && --this.addCount < 1 && !quietly) {
      this.handlers.error(new Error("Observable cancelled prematurely"));
    }
  };

  Concast.prototype.cleanup = function (callback) {
    var _this = this;

    var called = false;

    var once = function once() {
      if (!called) {
        called = true;

        _this.observers.delete(observer);

        callback();
      }
    };

    var observer = {
      next: once,
      error: once,
      complete: once
    };
    var count = this.addCount;
    this.addObserver(observer);
    this.addCount = count;
  };

  return Concast;
}(Observable);

fixObservableSubclass(Concast);

function isNonEmptyArray(value) {
  return Array.isArray(value) && value.length > 0;
}

function graphQLResultHasError(result) {
  return result.errors && result.errors.length > 0 || false;
}

function compact() {
  var objects = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    objects[_i] = arguments[_i];
  }

  var result = Object.create(null);
  objects.forEach(function (obj) {
    if (!obj) return;
    Object.keys(obj).forEach(function (key) {
      var value = obj[key];

      if (value !== void 0) {
        result[key] = value;
      }
    });
  });
  return result;
}

var prefixCounts = new Map();

function makeUniqueId(prefix) {
  var count = prefixCounts.get(prefix) || 1;
  prefixCounts.set(prefix, count + 1);
  return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}

function stringifyForDisplay(value) {
  var undefId = makeUniqueId("stringifyForDisplay");
  return JSON.stringify(value, function (key, value) {
    return value === void 0 ? undefId : value;
  }).split(JSON.stringify(undefId)).join("<undefined>");
}

function fromError(errorValue) {
  return new Observable(function (observer) {
    observer.error(errorValue);
  });
}

var throwServerError = function throwServerError(response, result, message) {
  var error = new Error(message);
  error.name = 'ServerError';
  error.response = response;
  error.statusCode = response.status;
  error.result = result;
  throw error;
};

function validateOperation(operation) {
  var OPERATION_FIELDS = ['query', 'operationName', 'variables', 'extensions', 'context'];

  for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
    var key = _a[_i];

    if (OPERATION_FIELDS.indexOf(key) < 0) {
      throw __DEV__ ? new InvariantError("illegal argument: ".concat(key)) : new InvariantError(24);
    }
  }

  return operation;
}

function createOperation(starting, operation) {
  var context = _assign$7({}, starting);

  var setContext = function setContext(next) {
    if (typeof next === 'function') {
      context = _assign$7(_assign$7({}, context), next(context));
    } else {
      context = _assign$7(_assign$7({}, context), next);
    }
  };

  var getContext = function getContext() {
    return _assign$7({}, context);
  };

  Object.defineProperty(operation, 'setContext', {
    enumerable: false,
    value: setContext
  });
  Object.defineProperty(operation, 'getContext', {
    enumerable: false,
    value: getContext
  });
  return operation;
}

function transformOperation(operation) {
  var transformedOperation = {
    variables: operation.variables || {},
    extensions: operation.extensions || {},
    operationName: operation.operationName,
    query: operation.query
  };

  if (!transformedOperation.operationName) {
    transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? getOperationName(transformedOperation.query) || undefined : '';
  }

  return transformedOperation;
}

function passthrough(op, forward) {
  return forward ? forward(op) : Observable.of();
}

function toLink(handler) {
  return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}

function isTerminating(link) {
  return link.request.length <= 1;
}

var LinkError = function (_super) {
  __extends$1(LinkError, _super);

  function LinkError(message, link) {
    var _this = _super.call(this, message) || this;

    _this.link = link;
    return _this;
  }

  return LinkError;
}(Error);

var ApolloLink = function () {
  function ApolloLink(request) {
    if (request) this.request = request;
  }

  ApolloLink.empty = function () {
    return new ApolloLink(function () {
      return Observable.of();
    });
  };

  ApolloLink.from = function (links) {
    if (links.length === 0) return ApolloLink.empty();
    return links.map(toLink).reduce(function (x, y) {
      return x.concat(y);
    });
  };

  ApolloLink.split = function (test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));

    if (isTerminating(leftLink) && isTerminating(rightLink)) {
      return new ApolloLink(function (operation) {
        return test(operation) ? leftLink.request(operation) || Observable.of() : rightLink.request(operation) || Observable.of();
      });
    } else {
      return new ApolloLink(function (operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || Observable.of() : rightLink.request(operation, forward) || Observable.of();
      });
    }
  };

  ApolloLink.execute = function (link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || Observable.of();
  };

  ApolloLink.concat = function (first, second) {
    var firstLink = toLink(first);

    if (isTerminating(firstLink)) {
      __DEV__ && invariant.warn(new LinkError("You are calling concat on a terminating link, which will have no effect", firstLink));
      return firstLink;
    }

    var nextLink = toLink(second);

    if (isTerminating(nextLink)) {
      return new ApolloLink(function (operation) {
        return firstLink.request(operation, function (op) {
          return nextLink.request(op) || Observable.of();
        }) || Observable.of();
      });
    } else {
      return new ApolloLink(function (operation, forward) {
        return firstLink.request(operation, function (op) {
          return nextLink.request(op, forward) || Observable.of();
        }) || Observable.of();
      });
    }
  };

  ApolloLink.prototype.split = function (test, left, right) {
    return this.concat(ApolloLink.split(test, left, right || new ApolloLink(passthrough)));
  };

  ApolloLink.prototype.concat = function (next) {
    return ApolloLink.concat(this, next);
  };

  ApolloLink.prototype.request = function (operation, forward) {
    throw __DEV__ ? new InvariantError('request is not implemented') : new InvariantError(19);
  };

  ApolloLink.prototype.onError = function (error, observer) {
    if (observer && observer.error) {
      observer.error(error);
      return false;
    }

    throw error;
  };

  ApolloLink.prototype.setOnError = function (fn) {
    this.onError = fn;
    return this;
  };

  return ApolloLink;
}();

var from = ApolloLink.from;
var execute = ApolloLink.execute;
var version$1 = '3.5.10';
var hasOwnProperty$f = Object.prototype.hasOwnProperty;

function parseAndCheckHttpResponse(operations) {
  return function (response) {
    return response.text().then(function (bodyText) {
      try {
        return JSON.parse(bodyText);
      } catch (err) {
        var parseError = err;
        parseError.name = 'ServerParseError';
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
      }
    }).then(function (result) {
      if (response.status >= 300) {
        throwServerError(response, result, "Response not successful: Received status code ".concat(response.status));
      }

      if (!Array.isArray(result) && !hasOwnProperty$f.call(result, 'data') && !hasOwnProperty$f.call(result, 'errors')) {
        throwServerError(response, result, "Server response was missing for query '".concat(Array.isArray(operations) ? operations.map(function (op) {
          return op.operationName;
        }) : operations.operationName, "'."));
      }

      return result;
    });
  };
}

var serializeFetchParameter = function serializeFetchParameter(p, label) {
  var serialized;

  try {
    serialized = JSON.stringify(p);
  } catch (e) {
    var parseError = __DEV__ ? new InvariantError("Network request failed. ".concat(label, " is not serializable: ").concat(e.message)) : new InvariantError(21);
    parseError.parseError = e;
    throw parseError;
  }

  return serialized;
};

var defaultHttpOptions = {
  includeQuery: true,
  includeExtensions: false
};
var defaultHeaders = {
  accept: '*/*',
  'content-type': 'application/json'
};
var defaultOptions = {
  method: 'POST'
};
var fallbackHttpConfig = {
  http: defaultHttpOptions,
  headers: defaultHeaders,
  options: defaultOptions
};

var defaultPrinter = function defaultPrinter(ast, printer) {
  return printer(ast);
};

function selectHttpOptionsAndBodyInternal(operation, printer) {
  var configs = [];

  for (var _i = 2; _i < arguments.length; _i++) {
    configs[_i - 2] = arguments[_i];
  }

  var options = {};
  var http = {};
  configs.forEach(function (config) {
    options = _assign$7(_assign$7(_assign$7({}, options), config.options), {
      headers: _assign$7(_assign$7({}, options.headers), headersToLowerCase(config.headers))
    });

    if (config.credentials) {
      options.credentials = config.credentials;
    }

    http = _assign$7(_assign$7({}, http), config.http);
  });
  var operationName = operation.operationName,
      extensions = operation.extensions,
      variables = operation.variables,
      query = operation.query;
  var body = {
    operationName: operationName,
    variables: variables
  };
  if (http.includeExtensions) body.extensions = extensions;
  if (http.includeQuery) body.query = printer(query, print);
  return {
    options: options,
    body: body
  };
}

function headersToLowerCase(headers) {
  if (headers) {
    var normalized_1 = Object.create(null);
    Object.keys(Object(headers)).forEach(function (name) {
      normalized_1[name.toLowerCase()] = headers[name];
    });
    return normalized_1;
  }

  return headers;
}

var checkFetcher = function checkFetcher(fetcher) {
  if (!fetcher && typeof fetch === 'undefined') {
    throw __DEV__ ? new InvariantError("\n\"fetch\" has not been found globally and no fetcher has been configured. To fix this, install a fetch package (like https://www.npmjs.com/package/cross-fetch), instantiate the fetcher, and pass it into your HttpLink constructor. For example:\n\nimport fetch from 'cross-fetch';\nimport { ApolloClient, HttpLink } from '@apollo/client';\nconst client = new ApolloClient({\n  link: new HttpLink({ uri: '/graphql', fetch })\n});\n    ") : new InvariantError(20);
  }
};

var createSignalIfSupported = function createSignalIfSupported() {
  if (typeof AbortController === 'undefined') return {
    controller: false,
    signal: false
  };
  var controller = new AbortController();
  var signal = controller.signal;
  return {
    controller: controller,
    signal: signal
  };
};

var selectURI = function selectURI(operation, fallbackURI) {
  var context = operation.getContext();
  var contextURI = context.uri;

  if (contextURI) {
    return contextURI;
  } else if (typeof fallbackURI === 'function') {
    return fallbackURI(operation);
  } else {
    return fallbackURI || '/graphql';
  }
};

function rewriteURIForGET(chosenURI, body) {
  var queryParams = [];

  var addQueryParam = function addQueryParam(key, value) {
    queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
  };

  if ('query' in body) {
    addQueryParam('query', body.query);
  }

  if (body.operationName) {
    addQueryParam('operationName', body.operationName);
  }

  if (body.variables) {
    var serializedVariables = void 0;

    try {
      serializedVariables = serializeFetchParameter(body.variables, 'Variables map');
    } catch (parseError) {
      return {
        parseError: parseError
      };
    }

    addQueryParam('variables', serializedVariables);
  }

  if (body.extensions) {
    var serializedExtensions = void 0;

    try {
      serializedExtensions = serializeFetchParameter(body.extensions, 'Extensions map');
    } catch (parseError) {
      return {
        parseError: parseError
      };
    }

    addQueryParam('extensions', serializedExtensions);
  }

  var fragment = '',
      preFragment = chosenURI;
  var fragmentStart = chosenURI.indexOf('#');

  if (fragmentStart !== -1) {
    fragment = chosenURI.substr(fragmentStart);
    preFragment = chosenURI.substr(0, fragmentStart);
  }

  var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
  var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
  return {
    newURI: newURI
  };
}

var backupFetch = maybe$2(function () {
  return fetch;
});

var createHttpLink = function createHttpLink(linkOptions) {
  if (linkOptions === void 0) {
    linkOptions = {};
  }

  var _a = linkOptions.uri,
      uri = _a === void 0 ? '/graphql' : _a,
      preferredFetch = linkOptions.fetch,
      _b = linkOptions.print,
      print = _b === void 0 ? defaultPrinter : _b,
      includeExtensions = linkOptions.includeExtensions,
      useGETForQueries = linkOptions.useGETForQueries,
      _c = linkOptions.includeUnusedVariables,
      includeUnusedVariables = _c === void 0 ? false : _c,
      requestOptions = __rest(linkOptions, ["uri", "fetch", "print", "includeExtensions", "useGETForQueries", "includeUnusedVariables"]);

  if (__DEV__) {
    checkFetcher(preferredFetch || backupFetch);
  }

  var linkConfig = {
    http: {
      includeExtensions: includeExtensions
    },
    options: requestOptions.fetchOptions,
    credentials: requestOptions.credentials,
    headers: requestOptions.headers
  };
  return new ApolloLink(function (operation) {
    var chosenURI = selectURI(operation, uri);
    var context = operation.getContext();
    var clientAwarenessHeaders = {};

    if (context.clientAwareness) {
      var _a = context.clientAwareness,
          name_1 = _a.name,
          version = _a.version;

      if (name_1) {
        clientAwarenessHeaders['apollographql-client-name'] = name_1;
      }

      if (version) {
        clientAwarenessHeaders['apollographql-client-version'] = version;
      }
    }

    var contextHeaders = _assign$7(_assign$7({}, clientAwarenessHeaders), context.headers);

    var contextConfig = {
      http: context.http,
      options: context.fetchOptions,
      credentials: context.credentials,
      headers: contextHeaders
    };

    var _b = selectHttpOptionsAndBodyInternal(operation, print, fallbackHttpConfig, linkConfig, contextConfig),
        options = _b.options,
        body = _b.body;

    if (body.variables && !includeUnusedVariables) {
      var unusedNames_1 = new Set(Object.keys(body.variables));
      visit(operation.query, {
        Variable: function Variable(node, _key, parent) {
          if (parent && parent.kind !== 'VariableDefinition') {
            unusedNames_1.delete(node.name.value);
          }
        }
      });

      if (unusedNames_1.size) {
        body.variables = _assign$7({}, body.variables);
        unusedNames_1.forEach(function (name) {
          delete body.variables[name];
        });
      }
    }

    var controller;

    if (!options.signal) {
      var _c = createSignalIfSupported(),
          _controller = _c.controller,
          signal = _c.signal;

      controller = _controller;
      if (controller) options.signal = signal;
    }

    var definitionIsMutation = function definitionIsMutation(d) {
      return d.kind === 'OperationDefinition' && d.operation === 'mutation';
    };

    if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) {
      options.method = 'GET';
    }

    if (options.method === 'GET') {
      var _d = rewriteURIForGET(chosenURI, body),
          newURI = _d.newURI,
          parseError = _d.parseError;

      if (parseError) {
        return fromError(parseError);
      }

      chosenURI = newURI;
    } else {
      try {
        options.body = serializeFetchParameter(body, 'Payload');
      } catch (parseError) {
        return fromError(parseError);
      }
    }

    return new Observable(function (observer) {
      var currentFetch = preferredFetch || maybe$2(function () {
        return fetch;
      }) || backupFetch;
      currentFetch(chosenURI, options).then(function (response) {
        operation.setContext({
          response: response
        });
        return response;
      }).then(parseAndCheckHttpResponse(operation)).then(function (result) {
        observer.next(result);
        observer.complete();
        return result;
      }).catch(function (err) {
        if (err.name === 'AbortError') return;

        if (err.result && err.result.errors && err.result.data) {
          observer.next(err.result);
        }

        observer.error(err);
      });
      return function () {
        if (controller) controller.abort();
      };
    });
  });
};

var HttpLink = function (_super) {
  __extends$1(HttpLink, _super);

  function HttpLink(options) {
    if (options === void 0) {
      options = {};
    }

    var _this = _super.call(this, createHttpLink(options).request) || this;

    _this.options = options;
    return _this;
  }

  return HttpLink;
}(ApolloLink);

var _Object$prototype = Object.prototype,
    toString$2 = _Object$prototype.toString,
    hasOwnProperty$e = _Object$prototype.hasOwnProperty;
var fnToStr = Function.prototype.toString;
var previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */

function equal(a, b) {
  try {
    return check(a, b);
  } finally {
    previousComparisons.clear();
  }
}

function check(a, b) {
  // If the two values are strictly equal, our job is easy.
  if (a === b) {
    return true;
  } // Object.prototype.toString returns a representation of the runtime type of
  // the given value that is considerably more precise than typeof.


  var aTag = toString$2.call(a);
  var bTag = toString$2.call(b); // If the runtime types of a and b are different, they could maybe be equal
  // under some interpretation of equality, but for simplicity and performance
  // we just return false instead.

  if (aTag !== bTag) {
    return false;
  }

  switch (aTag) {
    case '[object Array]':
      // Arrays are a lot like other objects, but we can cheaply compare their
      // lengths as a short-cut before comparing their elements.
      if (a.length !== b.length) return false;
    // Fall through to object case...

    case '[object Object]':
      {
        if (previouslyCompared(a, b)) return true;
        var aKeys = definedKeys(a);
        var bKeys = definedKeys(b); // If `a` and `b` have a different number of enumerable keys, they
        // must be different.

        var keyCount = aKeys.length;
        if (keyCount !== bKeys.length) return false; // Now make sure they have the same keys.

        for (var _k3 = 0; _k3 < keyCount; ++_k3) {
          if (!hasOwnProperty$e.call(b, aKeys[_k3])) {
            return false;
          }
        } // Finally, check deep equality of all child properties.


        for (var _k4 = 0; _k4 < keyCount; ++_k4) {
          var key = aKeys[_k4];

          if (!check(a[key], b[key])) {
            return false;
          }
        }

        return true;
      }

    case '[object Error]':
      return a.name === b.name && a.message === b.message;

    case '[object Number]':
      // Handle NaN, which is !== itself.
      if (a !== a) return b !== b;
    // Fall through to shared +a === +b case...

    case '[object Boolean]':
    case '[object Date]':
      return +a === +b;

    case '[object RegExp]':
    case '[object String]':
      return a == "".concat(b);

    case '[object Map]':
    case '[object Set]':
      {
        if (a.size !== b.size) return false;
        if (previouslyCompared(a, b)) return true;
        var aIterator = a.entries();

        var _isMap = aTag === '[object Map]';

        while (true) {
          var info = aIterator.next();
          if (info.done) break; // If a instanceof Set, aValue === aKey.

          var _info$value = _slicedToArray2(info.value, 2),
              aKey = _info$value[0],
              aValue = _info$value[1]; // So this works the same way for both Set and Map.


          if (!b.has(aKey)) {
            return false;
          } // However, we care about deep equality of values only when dealing
          // with Map structures.


          if (_isMap && !check(aValue, b.get(aKey))) {
            return false;
          }
        }

        return true;
      }

    case '[object Uint16Array]':
    case '[object Uint8Array]': // Buffer, in Node.js.

    case '[object Uint32Array]':
    case '[object Int32Array]':
    case '[object Int8Array]':
    case '[object Int16Array]':
    case '[object ArrayBuffer]':
      // DataView doesn't need these conversions, but the equality check is
      // otherwise the same.
      a = new Uint8Array(a);
      b = new Uint8Array(b);
    // Fall through...

    case '[object DataView]':
      {
        var len = a.byteLength;

        if (len === b.byteLength) {
          while (len-- && a[len] === b[len]) {// Keep looping as long as the bytes are equal.
          }
        }

        return len === -1;
      }

    case '[object AsyncFunction]':
    case '[object GeneratorFunction]':
    case '[object AsyncGeneratorFunction]':
    case '[object Function]':
      {
        var aCode = fnToStr.call(a);

        if (aCode !== fnToStr.call(b)) {
          return false;
        } // We consider non-native functions equal if they have the same code
        // (native functions require === because their code is censored).
        // Note that this behavior is not entirely sound, since !== function
        // objects with the same code can behave differently depending on
        // their closure scope. However, any function can behave differently
        // depending on the values of its input arguments (including this)
        // and its calling context (including its closure scope), even
        // though the function object is === to itself; and it is entirely
        // possible for functions that are not === to behave exactly the
        // same under all conceivable circumstances. Because none of these
        // factors are statically decidable in JavaScript, JS function
        // equality is not well-defined. This ambiguity allows us to
        // consider the best possible heuristic among various imperfect
        // options, and equating non-native functions that have the same
        // code has enormous practical benefits, such as when comparing
        // functions that are repeatedly passed as fresh function
        // expressions within objects that are otherwise deeply equal. Since
        // any function created from the same syntactic expression (in the
        // same code location) will always stringify to the same code
        // according to fnToStr.call, we can reasonably expect these
        // repeatedly passed function expressions to have the same code, and
        // thus behave "the same" (with all the caveats mentioned above),
        // even though the runtime function objects are !== to one another.


        return !endsWith(aCode, nativeCodeSuffix);
      }
  } // Otherwise the values are not equal.


  return false;
}

function definedKeys(obj) {
  // Remember that the second argument to Array.prototype.filter will be
  // used as `this` within the callback function.
  return Object.keys(obj).filter(isDefinedKey, obj);
}

function isDefinedKey(key) {
  return this[key] !== void 0;
}

var nativeCodeSuffix = "{ [native code] }";

function endsWith(full, suffix) {
  var fromIndex = full.length - suffix.length;
  return fromIndex >= 0 && full.indexOf(suffix, fromIndex) === fromIndex;
}

function previouslyCompared(a, b) {
  // Though cyclic references can make an object graph appear infinite from the
  // perspective of a depth-first traversal, the graph still contains a finite
  // number of distinct object references. We use the previousComparisons cache
  // to avoid comparing the same pair of object references more than once, which
  // guarantees termination (even if we end up comparing every object in one
  // graph to every object in the other graph, which is extremely unlikely),
  // while still allowing weird isomorphic structures (like rings with different
  // lengths) a chance to pass the equality test.
  var bSet = previousComparisons.get(a);

  if (bSet) {
    // Return true here because we can be sure false will be returned somewhere
    // else if the objects are not equivalent.
    if (bSet.has(b)) return true;
  } else {
    previousComparisons.set(a, bSet = new Set());
  }

  bSet.add(b);
  return false;
} // A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.


var defaultMakeData = function defaultMakeData() {
  return Object.create(null);
}; // Useful for processing arguments objects as well as arrays.


var _a$1 = Array.prototype,
    forEach = _a$1.forEach,
    slice = _a$1.slice;

var Trie = function () {
  function Trie(weakness, makeData) {
    if (weakness === void 0) {
      weakness = true;
    }

    if (makeData === void 0) {
      makeData = defaultMakeData;
    }

    this.weakness = weakness;
    this.makeData = makeData;
  }

  Trie.prototype.lookup = function () {
    var array = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      array[_i] = arguments[_i];
    }

    return this.lookupArray(array);
  };

  Trie.prototype.lookupArray = function (array) {
    var node = this;
    forEach.call(array, function (key) {
      return node = node.getChildTrie(key);
    });
    return node.data || (node.data = this.makeData(slice.call(array)));
  };

  Trie.prototype.getChildTrie = function (key) {
    var map = this.weakness && isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
    var child = map.get(key);
    if (!child) map.set(key, child = new Trie(this.weakness, this.makeData));
    return child;
  };

  return Trie;
}();

function isObjRef(value) {
  switch (typeof value) {
    case "object":
      if (value === null) break;
    // Fall through to return true...

    case "function":
      return true;
  }

  return false;
} // This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.


var currentContext$1 = null; // This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.

var MISSING_VALUE$1 = {};
var idCounter$1 = 1; // Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.

var makeSlotClass$1 = function makeSlotClass$1() {
  return /*#__PURE__*/function () {
    function Slot() {
      _classCallCheck2(this, Slot);

      // If you have a Slot object, you can find out its slot.id, but you cannot
      // guess the slot.id of a Slot you don't have access to, thanks to the
      // randomized suffix.
      this.id = ["slot", idCounter$1++, Date.now(), Math.random().toString(36).slice(2)].join(":");
    }

    _createClass2(Slot, [{
      key: "hasValue",
      value: function hasValue() {
        for (var context = currentContext$1; context; context = context.parent) {
          // We use the Slot object iself as a key to its value, which means the
          // value cannot be obtained without a reference to the Slot object.
          if (this.id in context.slots) {
            var value = context.slots[this.id];
            if (value === MISSING_VALUE$1) break;

            if (context !== currentContext$1) {
              // Cache the value in currentContext.slots so the next lookup will
              // be faster. This caching is safe because the tree of contexts and
              // the values of the slots are logically immutable.
              currentContext$1.slots[this.id] = value;
            }

            return true;
          }
        }

        if (currentContext$1) {
          // If a value was not found for this Slot, it's never going to be found
          // no matter how many times we look it up, so we might as well cache
          // the absence of the value, too.
          currentContext$1.slots[this.id] = MISSING_VALUE$1;
        }

        return false;
      }
    }, {
      key: "getValue",
      value: function getValue() {
        if (this.hasValue()) {
          return currentContext$1.slots[this.id];
        }
      }
    }, {
      key: "withValue",
      value: function withValue(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
      // to be much more common than specifying `this`, hence this ordering:
      args, thisArg) {
        var slots = _defineProperty2({
          __proto__: null
        }, this.id, value);

        var parent = currentContext$1;
        currentContext$1 = {
          parent: parent,
          slots: slots
        };

        try {
          // Function.prototype.apply allows the arguments array argument to be
          // omitted or undefined, so args! is fine here.
          return callback.apply(thisArg, args);
        } finally {
          currentContext$1 = parent;
        }
      } // Capture the current context and wrap a callback function so that it
      // reestablishes the captured context when called.

    }], [{
      key: "bind",
      value: function bind(callback) {
        var context = currentContext$1;
        return function () {
          var saved = currentContext$1;

          try {
            currentContext$1 = context;
            return callback.apply(this, arguments);
          } finally {
            currentContext$1 = saved;
          }
        };
      } // Immediately run a callback function without any captured context.

    }, {
      key: "noContext",
      value: function noContext(callback, // Given the prevalence of arrow functions, specifying arguments is likely
      // to be much more common than specifying `this`, hence this ordering:
      args, thisArg) {
        if (currentContext$1) {
          var saved = currentContext$1;

          try {
            currentContext$1 = null; // Function.prototype.apply allows the arguments array argument to be
            // omitted or undefined, so args! is fine here.

            return callback.apply(thisArg, args);
          } finally {
            currentContext$1 = saved;
          }
        } else {
          return callback.apply(thisArg, args);
        }
      }
    }]);

    return Slot;
  }();
};

function maybe(fn) {
  try {
    return fn();
  } catch (ignored) {}
} // We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.


var globalKey$1 = "@wry/context:Slot";
var host$1 = // Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
maybe(function () {
  return globalThis;
}) || // Fall back to global, which works in Node.js and may be converted by some
// bundlers to the appropriate identifier (window, self, ...) depending on the
// bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
maybe(function () {
  return global$2;
}) || // Otherwise, use a dummy host that's local to this module. We used to fall
// back to using the Array constructor as a namespace, but that was flagged in
// https://github.com/benjamn/wryware/issues/347, and can be avoided.
Object.create(null); // Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.

var globalHost = host$1;

var Slot$1 = globalHost[globalKey$1] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[globalKey$1] || function (Slot) {
  try {
    Object.defineProperty(globalHost, globalKey$1, {
      value: Slot,
      enumerable: false,
      writable: false,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: true
    });
  } finally {
    return Slot;
  }
}(makeSlotClass$1());

function defaultDispose() {}

var Cache = function () {
  function Cache(max, dispose) {
    if (max === void 0) {
      max = Infinity;
    }

    if (dispose === void 0) {
      dispose = defaultDispose;
    }

    this.max = max;
    this.dispose = dispose;
    this.map = new Map();
    this.newest = null;
    this.oldest = null;
  }

  Cache.prototype.has = function (key) {
    return this.map.has(key);
  };

  Cache.prototype.get = function (key) {
    var node = this.getNode(key);
    return node && node.value;
  };

  Cache.prototype.getNode = function (key) {
    var node = this.map.get(key);

    if (node && node !== this.newest) {
      var older = node.older,
          newer = node.newer;

      if (newer) {
        newer.older = older;
      }

      if (older) {
        older.newer = newer;
      }

      node.older = this.newest;
      node.older.newer = node;
      node.newer = null;
      this.newest = node;

      if (node === this.oldest) {
        this.oldest = newer;
      }
    }

    return node;
  };

  Cache.prototype.set = function (key, value) {
    var node = this.getNode(key);

    if (node) {
      return node.value = value;
    }

    node = {
      key: key,
      value: value,
      newer: null,
      older: this.newest
    };

    if (this.newest) {
      this.newest.newer = node;
    }

    this.newest = node;
    this.oldest = this.oldest || node;
    this.map.set(key, node);
    return node.value;
  };

  Cache.prototype.clean = function () {
    while (this.oldest && this.map.size > this.max) {
      this.delete(this.oldest.key);
    }
  };

  Cache.prototype.delete = function (key) {
    var node = this.map.get(key);

    if (node) {
      if (node === this.newest) {
        this.newest = node.older;
      }

      if (node === this.oldest) {
        this.oldest = node.newer;
      }

      if (node.newer) {
        node.newer.older = node.older;
      }

      if (node.older) {
        node.older.newer = node.newer;
      }

      this.map.delete(key);
      this.dispose(node.value, key);
      return true;
    }

    return false;
  };

  return Cache;
}();

var parentEntrySlot = new Slot$1();

var _a;

var hasOwnProperty$d = Object.prototype.hasOwnProperty;
var // This Array.from polyfill is restricted to working with Set<any> for now,
// but we can improve the polyfill and add other input types, as needed. Note
// that this fallback implementation will only be used if the host environment
// does not support a native Array.from function. In most modern JS runtimes,
// the toArray function exported here will be === Array.from.
toArray$1 = (_a = Array.from, _a === void 0 ? function (collection) {
  var array = [];
  collection.forEach(function (item) {
    return array.push(item);
  });
  return array;
} : _a);

function maybeUnsubscribe(entryOrDep) {
  var unsubscribe = entryOrDep.unsubscribe;

  if (typeof unsubscribe === "function") {
    entryOrDep.unsubscribe = void 0;
    unsubscribe();
  }
}

var emptySetPool = [];
var POOL_TARGET_SIZE = 100; // Since this package might be used browsers, we should avoid using the
// Node built-in assert module.

function assert(condition, optionalMessage) {
  if (!condition) {
    throw new Error(optionalMessage || "assertion failure");
  }
}

function valueIs(a, b) {
  var len = a.length;
  return (// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]
  );
}

function valueGet(value) {
  switch (value.length) {
    case 0:
      throw new Error("unknown value");

    case 1:
      return value[0];

    case 2:
      throw value[1];
  }
}

function valueCopy(value) {
  return value.slice(0);
}

var Entry = function () {
  function Entry(fn) {
    this.fn = fn;
    this.parents = new Set();
    this.childValues = new Map(); // When this Entry has children that are dirty, this property becomes
    // a Set containing other Entry objects, borrowed from emptySetPool.
    // When the set becomes empty, it gets recycled back to emptySetPool.

    this.dirtyChildren = null;
    this.dirty = true;
    this.recomputing = false;
    this.value = [];
    this.deps = null;
    ++Entry.count;
  }

  Entry.prototype.peek = function () {
    if (this.value.length === 1 && !mightBeDirty(this)) {
      rememberParent(this);
      return this.value[0];
    }
  }; // This is the most important method of the Entry API, because it
  // determines whether the cached this.value can be returned immediately,
  // or must be recomputed. The overall performance of the caching system
  // depends on the truth of the following observations: (1) this.dirty is
  // usually false, (2) this.dirtyChildren is usually null/empty, and thus
  // (3) valueGet(this.value) is usually returned without recomputation.


  Entry.prototype.recompute = function (args) {
    assert(!this.recomputing, "already recomputing");
    rememberParent(this);
    return mightBeDirty(this) ? reallyRecompute(this, args) : valueGet(this.value);
  };

  Entry.prototype.setDirty = function () {
    if (this.dirty) return;
    this.dirty = true;
    this.value.length = 0;
    reportDirty(this); // We can go ahead and unsubscribe here, since any further dirty
    // notifications we receive will be redundant, and unsubscribing may
    // free up some resources, e.g. file watchers.

    maybeUnsubscribe(this);
  };

  Entry.prototype.dispose = function () {
    var _this = this;

    this.setDirty(); // Sever any dependency relationships with our own children, so those
    // children don't retain this parent Entry in their child.parents sets,
    // thereby preventing it from being fully garbage collected.

    forgetChildren(this); // Because this entry has been kicked out of the cache (in index.js),
    // we've lost the ability to find out if/when this entry becomes dirty,
    // whether that happens through a subscription, because of a direct call
    // to entry.setDirty(), or because one of its children becomes dirty.
    // Because of this loss of future information, we have to assume the
    // worst (that this entry might have become dirty very soon), so we must
    // immediately mark this entry's parents as dirty. Normally we could
    // just call entry.setDirty() rather than calling parent.setDirty() for
    // each parent, but that would leave this entry in parent.childValues
    // and parent.dirtyChildren, which would prevent the child from being
    // truly forgotten.

    eachParent(this, function (parent, child) {
      parent.setDirty();
      forgetChild(parent, _this);
    });
  };

  Entry.prototype.forget = function () {
    // The code that creates Entry objects in index.ts will replace this method
    // with one that actually removes the Entry from the cache, which will also
    // trigger the entry.dispose method.
    this.dispose();
  };

  Entry.prototype.dependOn = function (dep) {
    dep.add(this);

    if (!this.deps) {
      this.deps = emptySetPool.pop() || new Set();
    }

    this.deps.add(dep);
  };

  Entry.prototype.forgetDeps = function () {
    var _this = this;

    if (this.deps) {
      toArray$1(this.deps).forEach(function (dep) {
        return dep.delete(_this);
      });
      this.deps.clear();
      emptySetPool.push(this.deps);
      this.deps = null;
    }
  };

  Entry.count = 0;
  return Entry;
}();

function rememberParent(child) {
  var parent = parentEntrySlot.getValue();

  if (parent) {
    child.parents.add(parent);

    if (!parent.childValues.has(child)) {
      parent.childValues.set(child, []);
    }

    if (mightBeDirty(child)) {
      reportDirtyChild(parent, child);
    } else {
      reportCleanChild(parent, child);
    }

    return parent;
  }
}

function reallyRecompute(entry, args) {
  forgetChildren(entry); // Set entry as the parent entry while calling recomputeNewValue(entry).

  parentEntrySlot.withValue(entry, recomputeNewValue, [entry, args]);

  if (maybeSubscribe(entry, args)) {
    // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    setClean(entry);
  }

  return valueGet(entry.value);
}

function recomputeNewValue(entry, args) {
  entry.recomputing = true; // Set entry.value as unknown.

  entry.value.length = 0;

  try {
    // If entry.fn succeeds, entry.value will become a normal Value.
    entry.value[0] = entry.fn.apply(null, args);
  } catch (e) {
    // If entry.fn throws, entry.value will become exceptional.
    entry.value[1] = e;
  } // Either way, this line is always reached.


  entry.recomputing = false;
}

function mightBeDirty(entry) {
  return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}

function setClean(entry) {
  entry.dirty = false;

  if (mightBeDirty(entry)) {
    // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
  }

  reportClean(entry);
}

function reportDirty(child) {
  eachParent(child, reportDirtyChild);
}

function reportClean(child) {
  eachParent(child, reportCleanChild);
}

function eachParent(child, callback) {
  var parentCount = child.parents.size;

  if (parentCount) {
    var parents = toArray$1(child.parents);

    for (var i = 0; i < parentCount; ++i) {
      callback(parents[i], child);
    }
  }
} // Let a parent Entry know that one of its children may be dirty.


function reportDirtyChild(parent, child) {
  // Must have called rememberParent(child) before calling
  // reportDirtyChild(parent, child).
  assert(parent.childValues.has(child));
  assert(mightBeDirty(child));
  var parentWasClean = !mightBeDirty(parent);

  if (!parent.dirtyChildren) {
    parent.dirtyChildren = emptySetPool.pop() || new Set();
  } else if (parent.dirtyChildren.has(child)) {
    // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
  }

  parent.dirtyChildren.add(child); // If parent was clean before, it just became (possibly) dirty (according to
  // mightBeDirty), since we just added child to parent.dirtyChildren.

  if (parentWasClean) {
    reportDirty(parent);
  }
} // Let a parent Entry know that one of its children is no longer dirty.


function reportCleanChild(parent, child) {
  // Must have called rememberChild(child) before calling
  // reportCleanChild(parent, child).
  assert(parent.childValues.has(child));
  assert(!mightBeDirty(child));
  var childValue = parent.childValues.get(child);

  if (childValue.length === 0) {
    parent.childValues.set(child, valueCopy(child.value));
  } else if (!valueIs(childValue, child.value)) {
    parent.setDirty();
  }

  removeDirtyChild(parent, child);

  if (mightBeDirty(parent)) {
    return;
  }

  reportClean(parent);
}

function removeDirtyChild(parent, child) {
  var dc = parent.dirtyChildren;

  if (dc) {
    dc.delete(child);

    if (dc.size === 0) {
      if (emptySetPool.length < POOL_TARGET_SIZE) {
        emptySetPool.push(dc);
      }

      parent.dirtyChildren = null;
    }
  }
} // Removes all children from this entry and returns an array of the
// removed children.


function forgetChildren(parent) {
  if (parent.childValues.size > 0) {
    parent.childValues.forEach(function (_value, child) {
      forgetChild(parent, child);
    });
  } // Remove this parent Entry from any sets to which it was added by the
  // addToSet method.


  parent.forgetDeps(); // After we forget all our children, this.dirtyChildren must be empty
  // and therefore must have been reset to null.

  assert(parent.dirtyChildren === null);
}

function forgetChild(parent, child) {
  child.parents.delete(parent);
  parent.childValues.delete(child);
  removeDirtyChild(parent, child);
}

function maybeSubscribe(entry, args) {
  if (typeof entry.subscribe === "function") {
    try {
      maybeUnsubscribe(entry); // Prevent double subscriptions.

      entry.unsubscribe = entry.subscribe.apply(null, args);
    } catch (e) {
      // If this Entry has a subscribe function and it threw an exception
      // (or an unsubscribe function it previously returned now throws),
      // return false to indicate that we were not able to subscribe (or
      // unsubscribe), and this Entry should remain dirty.
      entry.setDirty();
      return false;
    }
  } // Returning true indicates either that there was no entry.subscribe
  // function or that it succeeded.


  return true;
}

var EntryMethods = {
  setDirty: true,
  dispose: true,
  forget: true // Fully remove parent Entry from LRU cache and computation graph

};

function dep(options) {
  var depsByKey = new Map();
  var subscribe = options && options.subscribe;

  function depend(key) {
    var parent = parentEntrySlot.getValue();

    if (parent) {
      var dep_1 = depsByKey.get(key);

      if (!dep_1) {
        depsByKey.set(key, dep_1 = new Set());
      }

      parent.dependOn(dep_1);

      if (typeof subscribe === "function") {
        maybeUnsubscribe(dep_1);
        dep_1.unsubscribe = subscribe(key);
      }
    }
  }

  depend.dirty = function dirty(key, entryMethodName) {
    var dep = depsByKey.get(key);

    if (dep) {
      var m_1 = entryMethodName && hasOwnProperty$d.call(EntryMethods, entryMethodName) ? entryMethodName : "setDirty"; // We have to use toArray(dep).forEach instead of dep.forEach, because
      // modifying a Set while iterating over it can cause elements in the Set
      // to be removed from the Set before they've been iterated over.

      toArray$1(dep).forEach(function (entry) {
        return entry[m_1]();
      });
      depsByKey.delete(key);
      maybeUnsubscribe(dep);
    }
  };

  return depend;
}

function makeDefaultMakeCacheKeyFunction() {
  var keyTrie = new Trie(typeof WeakMap === "function");
  return function () {
    return keyTrie.lookupArray(arguments);
  };
} // The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.


makeDefaultMakeCacheKeyFunction();
var caches = new Set();

function wrap(originalFunction, options) {
  if (options === void 0) {
    options = Object.create(null);
  }

  var cache = new Cache(options.max || Math.pow(2, 16), function (entry) {
    return entry.dispose();
  });
  var keyArgs = options.keyArgs;
  var makeCacheKey = options.makeCacheKey || makeDefaultMakeCacheKeyFunction();

  var optimistic = function optimistic() {
    var key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);

    if (key === void 0) {
      return originalFunction.apply(null, arguments);
    }

    var entry = cache.get(key);

    if (!entry) {
      cache.set(key, entry = new Entry(originalFunction));
      entry.subscribe = options.subscribe; // Give the Entry the ability to trigger cache.delete(key), even though
      // the Entry itself does not know about key or cache.

      entry.forget = function () {
        return cache.delete(key);
      };
    }

    var value = entry.recompute(Array.prototype.slice.call(arguments)); // Move this entry to the front of the least-recently used queue,
    // since we just finished computing its value.

    cache.set(key, entry);
    caches.add(cache); // Clean up any excess entries in the cache, but only if there is no
    // active parent entry, meaning we're not in the middle of a larger
    // computation that might be flummoxed by the cleaning.

    if (!parentEntrySlot.hasValue()) {
      caches.forEach(function (cache) {
        return cache.clean();
      });
      caches.clear();
    }

    return value;
  };

  Object.defineProperty(optimistic, "size", {
    get: function get() {
      return cache["map"].size;
    },
    configurable: false,
    enumerable: false
  });

  function dirtyKey(key) {
    var entry = cache.get(key);

    if (entry) {
      entry.setDirty();
    }
  }

  optimistic.dirtyKey = dirtyKey;

  optimistic.dirty = function dirty() {
    dirtyKey(makeCacheKey.apply(null, arguments));
  };

  function peekKey(key) {
    var entry = cache.get(key);

    if (entry) {
      return entry.peek();
    }
  }

  optimistic.peekKey = peekKey;

  optimistic.peek = function peek() {
    return peekKey(makeCacheKey.apply(null, arguments));
  };

  function forgetKey(key) {
    return cache.delete(key);
  }

  optimistic.forgetKey = forgetKey;

  optimistic.forget = function forget() {
    return forgetKey(makeCacheKey.apply(null, arguments));
  };

  optimistic.makeCacheKey = makeCacheKey;
  optimistic.getKey = keyArgs ? function getKey() {
    return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
  } : makeCacheKey;
  return Object.freeze(optimistic);
}

var ApolloCache = function () {
  function ApolloCache() {
    this.getFragmentDoc = wrap(getFragmentQueryDocument);
  }

  ApolloCache.prototype.batch = function (options) {
    var _this = this;

    var optimisticId = typeof options.optimistic === "string" ? options.optimistic : options.optimistic === false ? null : void 0;
    var updateResult;
    this.performTransaction(function () {
      return updateResult = options.update(_this);
    }, optimisticId);
    return updateResult;
  };

  ApolloCache.prototype.recordOptimisticTransaction = function (transaction, optimisticId) {
    this.performTransaction(transaction, optimisticId);
  };

  ApolloCache.prototype.transformDocument = function (document) {
    return document;
  };

  ApolloCache.prototype.identify = function (object) {
    return;
  };

  ApolloCache.prototype.gc = function () {
    return [];
  };

  ApolloCache.prototype.modify = function (options) {
    return false;
  };

  ApolloCache.prototype.transformForLink = function (document) {
    return document;
  };

  ApolloCache.prototype.readQuery = function (options, optimistic) {
    if (optimistic === void 0) {
      optimistic = !!options.optimistic;
    }

    return this.read(_assign$7(_assign$7({}, options), {
      rootId: options.id || 'ROOT_QUERY',
      optimistic: optimistic
    }));
  };

  ApolloCache.prototype.readFragment = function (options, optimistic) {
    if (optimistic === void 0) {
      optimistic = !!options.optimistic;
    }

    return this.read(_assign$7(_assign$7({}, options), {
      query: this.getFragmentDoc(options.fragment, options.fragmentName),
      rootId: options.id,
      optimistic: optimistic
    }));
  };

  ApolloCache.prototype.writeQuery = function (_a) {
    var id = _a.id,
        data = _a.data,
        options = __rest(_a, ["id", "data"]);

    return this.write(Object.assign(options, {
      dataId: id || 'ROOT_QUERY',
      result: data
    }));
  };

  ApolloCache.prototype.writeFragment = function (_a) {
    var id = _a.id,
        data = _a.data,
        fragment = _a.fragment,
        fragmentName = _a.fragmentName,
        options = __rest(_a, ["id", "data", "fragment", "fragmentName"]);

    return this.write(Object.assign(options, {
      query: this.getFragmentDoc(fragment, fragmentName),
      dataId: id,
      result: data
    }));
  };

  ApolloCache.prototype.updateQuery = function (options, _update) {
    return this.batch({
      update: function update(cache) {
        var value = cache.readQuery(options);

        var data = _update(value);

        if (data === void 0 || data === null) return value;
        cache.writeQuery(_assign$7(_assign$7({}, options), {
          data: data
        }));
        return data;
      }
    });
  };

  ApolloCache.prototype.updateFragment = function (options, _update2) {
    return this.batch({
      update: function update(cache) {
        var value = cache.readFragment(options);

        var data = _update2(value);

        if (data === void 0 || data === null) return value;
        cache.writeFragment(_assign$7(_assign$7({}, options), {
          data: data
        }));
        return data;
      }
    });
  };

  return ApolloCache;
}();

var MissingFieldError = function () {
  function MissingFieldError(message, path, query, variables) {
    this.message = message;
    this.path = path;
    this.query = query;
    this.variables = variables;
  }

  return MissingFieldError;
}();

var hasOwn = Object.prototype.hasOwnProperty;

function defaultDataIdFromObject(_a, context) {
  var __typename = _a.__typename,
      id = _a.id,
      _id = _a._id;

  if (typeof __typename === "string") {
    if (context) {
      context.keyObject = id !== void 0 ? {
        id: id
      } : _id !== void 0 ? {
        _id: _id
      } : void 0;
    }

    if (id === void 0) id = _id;

    if (id !== void 0) {
      return "".concat(__typename, ":").concat(typeof id === "number" || typeof id === "string" ? id : JSON.stringify(id));
    }
  }
}

var defaultConfig = {
  dataIdFromObject: defaultDataIdFromObject,
  addTypename: true,
  resultCaching: true,
  canonizeResults: false
};

function normalizeConfig(config) {
  return compact(defaultConfig, config);
}

function shouldCanonizeResults(config) {
  var value = config.canonizeResults;
  return value === void 0 ? defaultConfig.canonizeResults : value;
}

function getTypenameFromStoreObject(store, objectOrReference) {
  return isReference(objectOrReference) ? store.get(objectOrReference.__ref, "__typename") : objectOrReference && objectOrReference.__typename;
}

var TypeOrFieldNameRegExp = /^[_a-z][_0-9a-z]*/i;

function fieldNameFromStoreName(storeFieldName) {
  var match = storeFieldName.match(TypeOrFieldNameRegExp);
  return match ? match[0] : storeFieldName;
}

function selectionSetMatchesResult(selectionSet, result, variables) {
  if (isNonNullObject$1(result)) {
    return isArray$2(result) ? result.every(function (item) {
      return selectionSetMatchesResult(selectionSet, item, variables);
    }) : selectionSet.selections.every(function (field) {
      if (isField(field) && shouldInclude(field, variables)) {
        var key = resultKeyNameFromField(field);
        return hasOwn.call(result, key) && (!field.selectionSet || selectionSetMatchesResult(field.selectionSet, result[key], variables));
      }

      return true;
    });
  }

  return false;
}

function storeValueIsStoreObject(value) {
  return isNonNullObject$1(value) && !isReference(value) && !isArray$2(value);
}

function makeProcessedFieldsMerger() {
  return new DeepMerger();
}

var isArray$2 = function isArray$2(a) {
  return Array.isArray(a);
};

var DELETE = Object.create(null);

var delModifier = function delModifier() {
  return DELETE;
};

var INVALIDATE = Object.create(null);

var EntityStore = function () {
  function EntityStore(policies, group) {
    var _this = this;

    this.policies = policies;
    this.group = group;
    this.data = Object.create(null);
    this.rootIds = Object.create(null);
    this.refs = Object.create(null);

    this.getFieldValue = function (objectOrReference, storeFieldName) {
      return maybeDeepFreeze(isReference(objectOrReference) ? _this.get(objectOrReference.__ref, storeFieldName) : objectOrReference && objectOrReference[storeFieldName]);
    };

    this.canRead = function (objOrRef) {
      return isReference(objOrRef) ? _this.has(objOrRef.__ref) : typeof objOrRef === "object";
    };

    this.toReference = function (objOrIdOrRef, mergeIntoStore) {
      if (typeof objOrIdOrRef === "string") {
        return makeReference(objOrIdOrRef);
      }

      if (isReference(objOrIdOrRef)) {
        return objOrIdOrRef;
      }

      var id = _this.policies.identify(objOrIdOrRef)[0];

      if (id) {
        var ref = makeReference(id);

        if (mergeIntoStore) {
          _this.merge(id, objOrIdOrRef);
        }

        return ref;
      }
    };
  }

  EntityStore.prototype.toObject = function () {
    return _assign$7({}, this.data);
  };

  EntityStore.prototype.has = function (dataId) {
    return this.lookup(dataId, true) !== void 0;
  };

  EntityStore.prototype.get = function (dataId, fieldName) {
    this.group.depend(dataId, fieldName);

    if (hasOwn.call(this.data, dataId)) {
      var storeObject = this.data[dataId];

      if (storeObject && hasOwn.call(storeObject, fieldName)) {
        return storeObject[fieldName];
      }
    }

    if (fieldName === "__typename" && hasOwn.call(this.policies.rootTypenamesById, dataId)) {
      return this.policies.rootTypenamesById[dataId];
    }

    if (this instanceof Layer) {
      return this.parent.get(dataId, fieldName);
    }
  };

  EntityStore.prototype.lookup = function (dataId, dependOnExistence) {
    if (dependOnExistence) this.group.depend(dataId, "__exists");

    if (hasOwn.call(this.data, dataId)) {
      return this.data[dataId];
    }

    if (this instanceof Layer) {
      return this.parent.lookup(dataId, dependOnExistence);
    }

    if (this.policies.rootTypenamesById[dataId]) {
      return Object.create(null);
    }
  };

  EntityStore.prototype.merge = function (older, newer) {
    var _this = this;

    var dataId;
    if (isReference(older)) older = older.__ref;
    if (isReference(newer)) newer = newer.__ref;
    var existing = typeof older === "string" ? this.lookup(dataId = older) : older;
    var incoming = typeof newer === "string" ? this.lookup(dataId = newer) : newer;
    if (!incoming) return;
    __DEV__ ? invariant(typeof dataId === "string", "store.merge expects a string ID") : invariant(typeof dataId === "string", 1);
    var merged = new DeepMerger(storeObjectReconciler).merge(existing, incoming);
    this.data[dataId] = merged;

    if (merged !== existing) {
      delete this.refs[dataId];

      if (this.group.caching) {
        var fieldsToDirty_1 = Object.create(null);
        if (!existing) fieldsToDirty_1.__exists = 1;
        Object.keys(incoming).forEach(function (storeFieldName) {
          if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
            fieldsToDirty_1[storeFieldName] = 1;
            var fieldName = fieldNameFromStoreName(storeFieldName);

            if (fieldName !== storeFieldName && !_this.policies.hasKeyArgs(merged.__typename, fieldName)) {
              fieldsToDirty_1[fieldName] = 1;
            }

            if (merged[storeFieldName] === void 0 && !(_this instanceof Layer)) {
              delete merged[storeFieldName];
            }
          }
        });

        if (fieldsToDirty_1.__typename && !(existing && existing.__typename) && this.policies.rootTypenamesById[dataId] === merged.__typename) {
          delete fieldsToDirty_1.__typename;
        }

        Object.keys(fieldsToDirty_1).forEach(function (fieldName) {
          return _this.group.dirty(dataId, fieldName);
        });
      }
    }
  };

  EntityStore.prototype.modify = function (dataId, fields) {
    var _this = this;

    var storeObject = this.lookup(dataId);

    if (storeObject) {
      var changedFields_1 = Object.create(null);
      var needToMerge_1 = false;
      var allDeleted_1 = true;
      var sharedDetails_1 = {
        DELETE: DELETE,
        INVALIDATE: INVALIDATE,
        isReference: isReference,
        toReference: this.toReference,
        canRead: this.canRead,
        readField: function readField(fieldNameOrOptions, from) {
          return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
            fieldName: fieldNameOrOptions,
            from: from || makeReference(dataId)
          } : fieldNameOrOptions, {
            store: _this
          });
        }
      };
      Object.keys(storeObject).forEach(function (storeFieldName) {
        var fieldName = fieldNameFromStoreName(storeFieldName);
        var fieldValue = storeObject[storeFieldName];
        if (fieldValue === void 0) return;
        var modify = typeof fields === "function" ? fields : fields[storeFieldName] || fields[fieldName];

        if (modify) {
          var newValue = modify === delModifier ? DELETE : modify(maybeDeepFreeze(fieldValue), _assign$7(_assign$7({}, sharedDetails_1), {
            fieldName: fieldName,
            storeFieldName: storeFieldName,
            storage: _this.getStorage(dataId, storeFieldName)
          }));

          if (newValue === INVALIDATE) {
            _this.group.dirty(dataId, storeFieldName);
          } else {
            if (newValue === DELETE) newValue = void 0;

            if (newValue !== fieldValue) {
              changedFields_1[storeFieldName] = newValue;
              needToMerge_1 = true;
              fieldValue = newValue;
            }
          }
        }

        if (fieldValue !== void 0) {
          allDeleted_1 = false;
        }
      });

      if (needToMerge_1) {
        this.merge(dataId, changedFields_1);

        if (allDeleted_1) {
          if (this instanceof Layer) {
            this.data[dataId] = void 0;
          } else {
            delete this.data[dataId];
          }

          this.group.dirty(dataId, "__exists");
        }

        return true;
      }
    }

    return false;
  };

  EntityStore.prototype.delete = function (dataId, fieldName, args) {
    var _a;

    var storeObject = this.lookup(dataId);

    if (storeObject) {
      var typename = this.getFieldValue(storeObject, "__typename");
      var storeFieldName = fieldName && args ? this.policies.getStoreFieldName({
        typename: typename,
        fieldName: fieldName,
        args: args
      }) : fieldName;
      return this.modify(dataId, storeFieldName ? (_a = {}, _a[storeFieldName] = delModifier, _a) : delModifier);
    }

    return false;
  };

  EntityStore.prototype.evict = function (options, limit) {
    var evicted = false;

    if (options.id) {
      if (hasOwn.call(this.data, options.id)) {
        evicted = this.delete(options.id, options.fieldName, options.args);
      }

      if (this instanceof Layer && this !== limit) {
        evicted = this.parent.evict(options, limit) || evicted;
      }

      if (options.fieldName || evicted) {
        this.group.dirty(options.id, options.fieldName || "__exists");
      }
    }

    return evicted;
  };

  EntityStore.prototype.clear = function () {
    this.replace(null);
  };

  EntityStore.prototype.extract = function () {
    var _this = this;

    var obj = this.toObject();
    var extraRootIds = [];
    this.getRootIdSet().forEach(function (id) {
      if (!hasOwn.call(_this.policies.rootTypenamesById, id)) {
        extraRootIds.push(id);
      }
    });

    if (extraRootIds.length) {
      obj.__META = {
        extraRootIds: extraRootIds.sort()
      };
    }

    return obj;
  };

  EntityStore.prototype.replace = function (newData) {
    var _this = this;

    Object.keys(this.data).forEach(function (dataId) {
      if (!(newData && hasOwn.call(newData, dataId))) {
        _this.delete(dataId);
      }
    });

    if (newData) {
      var __META = newData.__META,
          rest_1 = __rest(newData, ["__META"]);

      Object.keys(rest_1).forEach(function (dataId) {
        _this.merge(dataId, rest_1[dataId]);
      });

      if (__META) {
        __META.extraRootIds.forEach(this.retain, this);
      }
    }
  };

  EntityStore.prototype.retain = function (rootId) {
    return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
  };

  EntityStore.prototype.release = function (rootId) {
    if (this.rootIds[rootId] > 0) {
      var count = --this.rootIds[rootId];
      if (!count) delete this.rootIds[rootId];
      return count;
    }

    return 0;
  };

  EntityStore.prototype.getRootIdSet = function (ids) {
    if (ids === void 0) {
      ids = new Set();
    }

    Object.keys(this.rootIds).forEach(ids.add, ids);

    if (this instanceof Layer) {
      this.parent.getRootIdSet(ids);
    } else {
      Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
    }

    return ids;
  };

  EntityStore.prototype.gc = function () {
    var _this = this;

    var ids = this.getRootIdSet();
    var snapshot = this.toObject();
    ids.forEach(function (id) {
      if (hasOwn.call(snapshot, id)) {
        Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
        delete snapshot[id];
      }
    });
    var idsToRemove = Object.keys(snapshot);

    if (idsToRemove.length) {
      var root_1 = this;

      while (root_1 instanceof Layer) {
        root_1 = root_1.parent;
      }

      idsToRemove.forEach(function (id) {
        return root_1.delete(id);
      });
    }

    return idsToRemove;
  };

  EntityStore.prototype.findChildRefIds = function (dataId) {
    if (!hasOwn.call(this.refs, dataId)) {
      var found_1 = this.refs[dataId] = Object.create(null);
      var root = this.data[dataId];
      if (!root) return found_1;
      var workSet_1 = new Set([root]);
      workSet_1.forEach(function (obj) {
        if (isReference(obj)) {
          found_1[obj.__ref] = true;
        }

        if (isNonNullObject$1(obj)) {
          Object.keys(obj).forEach(function (key) {
            var child = obj[key];

            if (isNonNullObject$1(child)) {
              workSet_1.add(child);
            }
          });
        }
      });
    }

    return this.refs[dataId];
  };

  EntityStore.prototype.makeCacheKey = function () {
    return this.group.keyMaker.lookupArray(arguments);
  };

  return EntityStore;
}();

var CacheGroup = function () {
  function CacheGroup(caching, parent) {
    if (parent === void 0) {
      parent = null;
    }

    this.caching = caching;
    this.parent = parent;
    this.d = null;
    this.resetCaching();
  }

  CacheGroup.prototype.resetCaching = function () {
    this.d = this.caching ? dep() : null;
    this.keyMaker = new Trie(canUseWeakMap);
  };

  CacheGroup.prototype.depend = function (dataId, storeFieldName) {
    if (this.d) {
      this.d(makeDepKey(dataId, storeFieldName));
      var fieldName = fieldNameFromStoreName(storeFieldName);

      if (fieldName !== storeFieldName) {
        this.d(makeDepKey(dataId, fieldName));
      }

      if (this.parent) {
        this.parent.depend(dataId, storeFieldName);
      }
    }
  };

  CacheGroup.prototype.dirty = function (dataId, storeFieldName) {
    if (this.d) {
      this.d.dirty(makeDepKey(dataId, storeFieldName), storeFieldName === "__exists" ? "forget" : "setDirty");
    }
  };

  return CacheGroup;
}();

function makeDepKey(dataId, storeFieldName) {
  return storeFieldName + '#' + dataId;
}

function maybeDependOnExistenceOfEntity(store, entityId) {
  if (supportsResultCaching(store)) {
    store.group.depend(entityId, "__exists");
  }
}

(function (EntityStore) {
  var Root = function (_super) {
    __extends$1(Root, _super);

    function Root(_a) {
      var policies = _a.policies,
          _b = _a.resultCaching,
          resultCaching = _b === void 0 ? true : _b,
          seed = _a.seed;

      var _this = _super.call(this, policies, new CacheGroup(resultCaching)) || this;

      _this.stump = new Stump(_this);
      _this.storageTrie = new Trie(canUseWeakMap);
      if (seed) _this.replace(seed);
      return _this;
    }

    Root.prototype.addLayer = function (layerId, replay) {
      return this.stump.addLayer(layerId, replay);
    };

    Root.prototype.removeLayer = function () {
      return this;
    };

    Root.prototype.getStorage = function () {
      return this.storageTrie.lookupArray(arguments);
    };

    return Root;
  }(EntityStore);

  EntityStore.Root = Root;
})(EntityStore || (EntityStore = {}));

var Layer = function (_super) {
  __extends$1(Layer, _super);

  function Layer(id, parent, replay, group) {
    var _this = _super.call(this, parent.policies, group) || this;

    _this.id = id;
    _this.parent = parent;
    _this.replay = replay;
    _this.group = group;
    replay(_this);
    return _this;
  }

  Layer.prototype.addLayer = function (layerId, replay) {
    return new Layer(layerId, this, replay, this.group);
  };

  Layer.prototype.removeLayer = function (layerId) {
    var _this = this;

    var parent = this.parent.removeLayer(layerId);

    if (layerId === this.id) {
      if (this.group.caching) {
        Object.keys(this.data).forEach(function (dataId) {
          var ownStoreObject = _this.data[dataId];
          var parentStoreObject = parent["lookup"](dataId);

          if (!parentStoreObject) {
            _this.delete(dataId);
          } else if (!ownStoreObject) {
            _this.group.dirty(dataId, "__exists");

            Object.keys(parentStoreObject).forEach(function (storeFieldName) {
              _this.group.dirty(dataId, storeFieldName);
            });
          } else if (ownStoreObject !== parentStoreObject) {
            Object.keys(ownStoreObject).forEach(function (storeFieldName) {
              if (!equal(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) {
                _this.group.dirty(dataId, storeFieldName);
              }
            });
          }
        });
      }

      return parent;
    }

    if (parent === this.parent) return this;
    return parent.addLayer(this.id, this.replay);
  };

  Layer.prototype.toObject = function () {
    return _assign$7(_assign$7({}, this.parent.toObject()), this.data);
  };

  Layer.prototype.findChildRefIds = function (dataId) {
    var fromParent = this.parent.findChildRefIds(dataId);
    return hasOwn.call(this.data, dataId) ? _assign$7(_assign$7({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
  };

  Layer.prototype.getStorage = function () {
    var p = this.parent;

    while (p.parent) {
      p = p.parent;
    }

    return p.getStorage.apply(p, arguments);
  };

  return Layer;
}(EntityStore);

var Stump = function (_super) {
  __extends$1(Stump, _super);

  function Stump(root) {
    return _super.call(this, "EntityStore.Stump", root, function () {}, new CacheGroup(root.group.caching, root.group)) || this;
  }

  Stump.prototype.removeLayer = function () {
    return this;
  };

  Stump.prototype.merge = function () {
    return this.parent.merge.apply(this.parent, arguments);
  };

  return Stump;
}(Layer);

function storeObjectReconciler(existingObject, incomingObject, property) {
  var existingValue = existingObject[property];
  var incomingValue = incomingObject[property];
  return equal(existingValue, incomingValue) ? existingValue : incomingValue;
}

function supportsResultCaching(store) {
  return !!(store instanceof EntityStore && store.group.caching);
}

function shallowCopy(value) {
  if (isNonNullObject$1(value)) {
    return isArray$2(value) ? value.slice(0) : _assign$7({
      __proto__: Object.getPrototypeOf(value)
    }, value);
  }

  return value;
}

var ObjectCanon = function () {
  function ObjectCanon() {
    this.known = new (canUseWeakSet ? WeakSet : Set)();
    this.pool = new Trie(canUseWeakMap);
    this.passes = new WeakMap();
    this.keysByJSON = new Map();
    this.empty = this.admit({});
  }

  ObjectCanon.prototype.isKnown = function (value) {
    return isNonNullObject$1(value) && this.known.has(value);
  };

  ObjectCanon.prototype.pass = function (value) {
    if (isNonNullObject$1(value)) {
      var copy = shallowCopy(value);
      this.passes.set(copy, value);
      return copy;
    }

    return value;
  };

  ObjectCanon.prototype.admit = function (value) {
    var _this = this;

    if (isNonNullObject$1(value)) {
      var original = this.passes.get(value);
      if (original) return original;
      var proto = Object.getPrototypeOf(value);

      switch (proto) {
        case Array.prototype:
          {
            if (this.known.has(value)) return value;
            var array = value.map(this.admit, this);
            var node = this.pool.lookupArray(array);

            if (!node.array) {
              this.known.add(node.array = array);

              if (__DEV__) {
                Object.freeze(array);
              }
            }

            return node.array;
          }

        case null:
        case Object.prototype:
          {
            if (this.known.has(value)) return value;
            var proto_1 = Object.getPrototypeOf(value);
            var array_1 = [proto_1];
            var keys = this.sortedKeys(value);
            array_1.push(keys.json);
            var firstValueIndex_1 = array_1.length;
            keys.sorted.forEach(function (key) {
              array_1.push(_this.admit(value[key]));
            });
            var node = this.pool.lookupArray(array_1);

            if (!node.object) {
              var obj_1 = node.object = Object.create(proto_1);
              this.known.add(obj_1);
              keys.sorted.forEach(function (key, i) {
                obj_1[key] = array_1[firstValueIndex_1 + i];
              });

              if (__DEV__) {
                Object.freeze(obj_1);
              }
            }

            return node.object;
          }
      }
    }

    return value;
  };

  ObjectCanon.prototype.sortedKeys = function (obj) {
    var keys = Object.keys(obj);
    var node = this.pool.lookupArray(keys);

    if (!node.keys) {
      keys.sort();
      var json = JSON.stringify(keys);

      if (!(node.keys = this.keysByJSON.get(json))) {
        this.keysByJSON.set(json, node.keys = {
          sorted: keys,
          json: json
        });
      }
    }

    return node.keys;
  };

  return ObjectCanon;
}();

var canonicalStringify = Object.assign(function (value) {
  if (isNonNullObject$1(value)) {
    if (stringifyCanon === void 0) {
      resetCanonicalStringify();
    }

    var canonical = stringifyCanon.admit(value);
    var json = stringifyCache.get(canonical);

    if (json === void 0) {
      stringifyCache.set(canonical, json = JSON.stringify(canonical));
    }

    return json;
  }

  return JSON.stringify(value);
}, {
  reset: resetCanonicalStringify
});
var stringifyCanon;
var stringifyCache;

function resetCanonicalStringify() {
  stringifyCanon = new ObjectCanon();
  stringifyCache = new (canUseWeakMap ? WeakMap : Map)();
}

function execSelectionSetKeyArgs(options) {
  return [options.selectionSet, options.objectOrReference, options.context, options.context.canonizeResults];
}

var StoreReader = function () {
  function StoreReader(config) {
    var _this = this;

    this.knownResults = new (canUseWeakMap ? WeakMap : Map)();
    this.config = compact(config, {
      addTypename: config.addTypename !== false,
      canonizeResults: shouldCanonizeResults(config)
    });
    this.canon = config.canon || new ObjectCanon();
    this.executeSelectionSet = wrap(function (options) {
      var _a;

      var canonizeResults = options.context.canonizeResults;
      var peekArgs = execSelectionSetKeyArgs(options);
      peekArgs[3] = !canonizeResults;

      var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);

      if (other) {
        if (canonizeResults) {
          return _assign$7(_assign$7({}, other), {
            result: _this.canon.admit(other.result)
          });
        }

        return other;
      }

      maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
      return _this.execSelectionSetImpl(options);
    }, {
      max: this.config.resultCacheMaxSize,
      keyArgs: execSelectionSetKeyArgs,
      makeCacheKey: function makeCacheKey(selectionSet, parent, context, canonizeResults) {
        if (supportsResultCaching(context.store)) {
          return context.store.makeCacheKey(selectionSet, isReference(parent) ? parent.__ref : parent, context.varString, canonizeResults);
        }
      }
    });
    this.executeSubSelectedArray = wrap(function (options) {
      maybeDependOnExistenceOfEntity(options.context.store, options.enclosingRef.__ref);
      return _this.execSubSelectedArrayImpl(options);
    }, {
      max: this.config.resultCacheMaxSize,
      makeCacheKey: function makeCacheKey(_a) {
        var field = _a.field,
            array = _a.array,
            context = _a.context;

        if (supportsResultCaching(context.store)) {
          return context.store.makeCacheKey(field, array, context.varString);
        }
      }
    });
  }

  StoreReader.prototype.resetCanon = function () {
    this.canon = new ObjectCanon();
  };

  StoreReader.prototype.diffQueryAgainstStore = function (_a) {
    var store = _a.store,
        query = _a.query,
        _b = _a.rootId,
        rootId = _b === void 0 ? 'ROOT_QUERY' : _b,
        variables = _a.variables,
        _c = _a.returnPartialData,
        returnPartialData = _c === void 0 ? true : _c,
        _d = _a.canonizeResults,
        canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
    var policies = this.config.cache.policies;
    variables = _assign$7(_assign$7({}, getDefaultValues(getQueryDefinition(query))), variables);
    var rootRef = makeReference(rootId);
    var merger = new DeepMerger();
    var execResult = this.executeSelectionSet({
      selectionSet: getMainDefinition(query).selectionSet,
      objectOrReference: rootRef,
      enclosingRef: rootRef,
      context: {
        store: store,
        query: query,
        policies: policies,
        variables: variables,
        varString: canonicalStringify(variables),
        canonizeResults: canonizeResults,
        fragmentMap: createFragmentMap(getFragmentDefinitions(query)),
        merge: function merge(a, b) {
          return merger.merge(a, b);
        }
      }
    });
    var missing;

    if (execResult.missing) {
      missing = [new MissingFieldError(firstMissing(execResult.missing), execResult.missing, query, variables)];

      if (!returnPartialData) {
        throw missing[0];
      }
    }

    return {
      result: execResult.result,
      complete: !missing,
      missing: missing
    };
  };

  StoreReader.prototype.isFresh = function (result, parent, selectionSet, context) {
    if (supportsResultCaching(context.store) && this.knownResults.get(result) === selectionSet) {
      var latest = this.executeSelectionSet.peek(selectionSet, parent, context, this.canon.isKnown(result));

      if (latest && result === latest.result) {
        return true;
      }
    }

    return false;
  };

  StoreReader.prototype.execSelectionSetImpl = function (_a) {
    var _this = this;

    var selectionSet = _a.selectionSet,
        objectOrReference = _a.objectOrReference,
        enclosingRef = _a.enclosingRef,
        context = _a.context;

    if (isReference(objectOrReference) && !context.policies.rootTypenamesById[objectOrReference.__ref] && !context.store.has(objectOrReference.__ref)) {
      return {
        result: this.canon.empty,
        missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object")
      };
    }

    var variables = context.variables,
        policies = context.policies,
        store = context.store;
    var typename = store.getFieldValue(objectOrReference, "__typename");
    var result = {};
    var missing;

    if (this.config.addTypename && typeof typename === "string" && !policies.rootIdsByTypename[typename]) {
      result = {
        __typename: typename
      };
    }

    function handleMissing(result, resultName) {
      var _a;

      if (result.missing) {
        missing = context.merge(missing, (_a = {}, _a[resultName] = result.missing, _a));
      }

      return result.result;
    }

    var workSet = new Set(selectionSet.selections);
    workSet.forEach(function (selection) {
      var _a, _b;

      if (!shouldInclude(selection, variables)) return;

      if (isField(selection)) {
        var fieldValue = policies.readField({
          fieldName: selection.name.value,
          field: selection,
          variables: context.variables,
          from: objectOrReference
        }, context);
        var resultName = resultKeyNameFromField(selection);

        if (fieldValue === void 0) {
          if (!addTypenameToDocument.added(selection)) {
            missing = context.merge(missing, (_a = {}, _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat(isReference(objectOrReference) ? objectOrReference.__ref + " object" : "object " + JSON.stringify(objectOrReference, null, 2)), _a));
          }
        } else if (isArray$2(fieldValue)) {
          fieldValue = handleMissing(_this.executeSubSelectedArray({
            field: selection,
            array: fieldValue,
            enclosingRef: enclosingRef,
            context: context
          }), resultName);
        } else if (!selection.selectionSet) {
          if (context.canonizeResults) {
            fieldValue = _this.canon.pass(fieldValue);
          }
        } else if (fieldValue != null) {
          fieldValue = handleMissing(_this.executeSelectionSet({
            selectionSet: selection.selectionSet,
            objectOrReference: fieldValue,
            enclosingRef: isReference(fieldValue) ? fieldValue : enclosingRef,
            context: context
          }), resultName);
        }

        if (fieldValue !== void 0) {
          result = context.merge(result, (_b = {}, _b[resultName] = fieldValue, _b));
        }
      } else {
        var fragment = getFragmentFromSelection(selection, context.fragmentMap);

        if (fragment && policies.fragmentMatches(fragment, typename)) {
          fragment.selectionSet.selections.forEach(workSet.add, workSet);
        }
      }
    });
    var finalResult = {
      result: result,
      missing: missing
    };
    var frozen = context.canonizeResults ? this.canon.admit(finalResult) : maybeDeepFreeze(finalResult);

    if (frozen.result) {
      this.knownResults.set(frozen.result, selectionSet);
    }

    return frozen;
  };

  StoreReader.prototype.execSubSelectedArrayImpl = function (_a) {
    var _this = this;

    var field = _a.field,
        array = _a.array,
        enclosingRef = _a.enclosingRef,
        context = _a.context;
    var missing;

    function handleMissing(childResult, i) {
      var _a;

      if (childResult.missing) {
        missing = context.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
      }

      return childResult.result;
    }

    if (field.selectionSet) {
      array = array.filter(context.store.canRead);
    }

    array = array.map(function (item, i) {
      if (item === null) {
        return null;
      }

      if (isArray$2(item)) {
        return handleMissing(_this.executeSubSelectedArray({
          field: field,
          array: item,
          enclosingRef: enclosingRef,
          context: context
        }), i);
      }

      if (field.selectionSet) {
        return handleMissing(_this.executeSelectionSet({
          selectionSet: field.selectionSet,
          objectOrReference: item,
          enclosingRef: isReference(item) ? item : enclosingRef,
          context: context
        }), i);
      }

      if (__DEV__) {
        assertSelectionSetForIdValue(context.store, field, item);
      }

      return item;
    });
    return {
      result: context.canonizeResults ? this.canon.admit(array) : array,
      missing: missing
    };
  };

  return StoreReader;
}();

function firstMissing(tree) {
  try {
    JSON.stringify(tree, function (_, value) {
      if (typeof value === "string") throw value;
      return value;
    });
  } catch (result) {
    return result;
  }
}

function assertSelectionSetForIdValue(store, field, fieldValue) {
  if (!field.selectionSet) {
    var workSet_1 = new Set([fieldValue]);
    workSet_1.forEach(function (value) {
      if (isNonNullObject$1(value)) {
        __DEV__ ? invariant(!isReference(value), "Missing selection set for object of type ".concat(getTypenameFromStoreObject(store, value), " returned for query field ").concat(field.name.value)) : invariant(!isReference(value), 5);
        Object.values(value).forEach(workSet_1.add, workSet_1);
      }
    });
  }
} // This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.


var currentContext = null; // This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.

var MISSING_VALUE = {};
var idCounter = 1; // Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.

var makeSlotClass = function makeSlotClass() {
  return function () {
    function Slot() {
      // If you have a Slot object, you can find out its slot.id, but you cannot
      // guess the slot.id of a Slot you don't have access to, thanks to the
      // randomized suffix.
      this.id = ["slot", idCounter++, Date.now(), Math.random().toString(36).slice(2)].join(":");
    }

    Slot.prototype.hasValue = function () {
      for (var context_1 = currentContext; context_1; context_1 = context_1.parent) {
        // We use the Slot object iself as a key to its value, which means the
        // value cannot be obtained without a reference to the Slot object.
        if (this.id in context_1.slots) {
          var value = context_1.slots[this.id];
          if (value === MISSING_VALUE) break;

          if (context_1 !== currentContext) {
            // Cache the value in currentContext.slots so the next lookup will
            // be faster. This caching is safe because the tree of contexts and
            // the values of the slots are logically immutable.
            currentContext.slots[this.id] = value;
          }

          return true;
        }
      }

      if (currentContext) {
        // If a value was not found for this Slot, it's never going to be found
        // no matter how many times we look it up, so we might as well cache
        // the absence of the value, too.
        currentContext.slots[this.id] = MISSING_VALUE;
      }

      return false;
    };

    Slot.prototype.getValue = function () {
      if (this.hasValue()) {
        return currentContext.slots[this.id];
      }
    };

    Slot.prototype.withValue = function (value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
      var _a;

      var slots = (_a = {
        __proto__: null
      }, _a[this.id] = value, _a);
      var parent = currentContext;
      currentContext = {
        parent: parent,
        slots: slots
      };

      try {
        // Function.prototype.apply allows the arguments array argument to be
        // omitted or undefined, so args! is fine here.
        return callback.apply(thisArg, args);
      } finally {
        currentContext = parent;
      }
    }; // Capture the current context and wrap a callback function so that it
    // reestablishes the captured context when called.


    Slot.bind = function (callback) {
      var context = currentContext;
      return function () {
        var saved = currentContext;

        try {
          currentContext = context;
          return callback.apply(this, arguments);
        } finally {
          currentContext = saved;
        }
      };
    }; // Immediately run a callback function without any captured context.


    Slot.noContext = function (callback, // Given the prevalence of arrow functions, specifying arguments is likely
    // to be much more common than specifying `this`, hence this ordering:
    args, thisArg) {
      if (currentContext) {
        var saved = currentContext;

        try {
          currentContext = null; // Function.prototype.apply allows the arguments array argument to be
          // omitted or undefined, so args! is fine here.

          return callback.apply(thisArg, args);
        } finally {
          currentContext = saved;
        }
      } else {
        return callback.apply(thisArg, args);
      }
    };

    return Slot;
  }();
}; // We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.


var globalKey = "@wry/context:Slot";
var host = Array;

var Slot = host[globalKey] || function () {
  var Slot = makeSlotClass();

  try {
    Object.defineProperty(host, globalKey, {
      value: host[globalKey] = Slot,
      enumerable: false,
      writable: false,
      configurable: false
    });
  } finally {
    return Slot;
  }
}();

Slot.bind;
Slot.noContext;
var cacheSlot = new Slot();
var cacheInfoMap = new WeakMap();

function getCacheInfo(cache) {
  var info = cacheInfoMap.get(cache);

  if (!info) {
    cacheInfoMap.set(cache, info = {
      vars: new Set(),
      dep: dep()
    });
  }

  return info;
}

function forgetCache(cache) {
  getCacheInfo(cache).vars.forEach(function (rv) {
    return rv.forgetCache(cache);
  });
}

function recallCache(cache) {
  getCacheInfo(cache).vars.forEach(function (rv) {
    return rv.attachCache(cache);
  });
}

function makeVar(value) {
  var caches = new Set();
  var listeners = new Set();

  var rv = function rv(newValue) {
    if (arguments.length > 0) {
      if (value !== newValue) {
        value = newValue;
        caches.forEach(function (cache) {
          getCacheInfo(cache).dep.dirty(rv);
          broadcast(cache);
        });
        var oldListeners = Array.from(listeners);
        listeners.clear();
        oldListeners.forEach(function (listener) {
          return listener(value);
        });
      }
    } else {
      var cache = cacheSlot.getValue();

      if (cache) {
        attach(cache);
        getCacheInfo(cache).dep(rv);
      }
    }

    return value;
  };

  rv.onNextChange = function (listener) {
    listeners.add(listener);
    return function () {
      listeners.delete(listener);
    };
  };

  var attach = rv.attachCache = function (cache) {
    caches.add(cache);
    getCacheInfo(cache).vars.add(rv);
    return rv;
  };

  rv.forgetCache = function (cache) {
    return caches.delete(cache);
  };

  return rv;
}

function broadcast(cache) {
  if (cache.broadcastWatches) {
    cache.broadcastWatches();
  }
}

var specifierInfoCache = Object.create(null);

function lookupSpecifierInfo(spec) {
  var cacheKey = JSON.stringify(spec);
  return specifierInfoCache[cacheKey] || (specifierInfoCache[cacheKey] = Object.create(null));
}

function keyFieldsFnFromSpecifier(specifier) {
  var info = lookupSpecifierInfo(specifier);
  return info.keyFieldsFn || (info.keyFieldsFn = function (object, context) {
    var extract = function extract(from, key) {
      return context.readField(key, from);
    };

    var keyObject = context.keyObject = collectSpecifierPaths(specifier, function (schemaKeyPath) {
      var extracted = extractKeyPath(context.storeObject, schemaKeyPath, extract);

      if (extracted === void 0 && object !== context.storeObject && hasOwn.call(object, schemaKeyPath[0])) {
        extracted = extractKeyPath(object, schemaKeyPath, extractKey);
      }

      __DEV__ ? invariant(extracted !== void 0, "Missing field '".concat(schemaKeyPath.join('.'), "' while extracting keyFields from ").concat(JSON.stringify(object))) : invariant(extracted !== void 0, 2);
      return extracted;
    });
    return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
  });
}

function keyArgsFnFromSpecifier(specifier) {
  var info = lookupSpecifierInfo(specifier);
  return info.keyArgsFn || (info.keyArgsFn = function (args, _a) {
    var field = _a.field,
        variables = _a.variables,
        fieldName = _a.fieldName;
    var collected = collectSpecifierPaths(specifier, function (keyPath) {
      var firstKey = keyPath[0];
      var firstChar = firstKey.charAt(0);

      if (firstChar === "@") {
        if (field && isNonEmptyArray(field.directives)) {
          var directiveName_1 = firstKey.slice(1);
          var d = field.directives.find(function (d) {
            return d.name.value === directiveName_1;
          });
          var directiveArgs = d && argumentsObjectFromField(d, variables);
          return directiveArgs && extractKeyPath(directiveArgs, keyPath.slice(1));
        }

        return;
      }

      if (firstChar === "$") {
        var variableName = firstKey.slice(1);

        if (variables && hasOwn.call(variables, variableName)) {
          var varKeyPath = keyPath.slice(0);
          varKeyPath[0] = variableName;
          return extractKeyPath(variables, varKeyPath);
        }

        return;
      }

      if (args) {
        return extractKeyPath(args, keyPath);
      }
    });
    var suffix = JSON.stringify(collected);

    if (args || suffix !== "{}") {
      fieldName += ":" + suffix;
    }

    return fieldName;
  });
}

function collectSpecifierPaths(specifier, extractor) {
  var merger = new DeepMerger();
  return getSpecifierPaths(specifier).reduce(function (collected, path) {
    var _a;

    var toMerge = extractor(path);

    if (toMerge !== void 0) {
      for (var i = path.length - 1; i >= 0; --i) {
        toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
      }

      collected = merger.merge(collected, toMerge);
    }

    return collected;
  }, Object.create(null));
}

function getSpecifierPaths(spec) {
  var info = lookupSpecifierInfo(spec);

  if (!info.paths) {
    var paths_1 = info.paths = [];
    var currentPath_1 = [];
    spec.forEach(function (s, i) {
      if (isArray$2(s)) {
        getSpecifierPaths(s).forEach(function (p) {
          return paths_1.push(currentPath_1.concat(p));
        });
        currentPath_1.length = 0;
      } else {
        currentPath_1.push(s);

        if (!isArray$2(spec[i + 1])) {
          paths_1.push(currentPath_1.slice(0));
          currentPath_1.length = 0;
        }
      }
    });
  }

  return info.paths;
}

function extractKey(object, key) {
  return object[key];
}

function extractKeyPath(object, path, extract) {
  extract = extract || extractKey;
  return normalize$1(path.reduce(function reducer(obj, key) {
    return isArray$2(obj) ? obj.map(function (child) {
      return reducer(child, key);
    }) : obj && extract(obj, key);
  }, object));
}

function normalize$1(value) {
  if (isNonNullObject$1(value)) {
    if (isArray$2(value)) {
      return value.map(normalize$1);
    }

    return collectSpecifierPaths(Object.keys(value).sort(), function (path) {
      return extractKeyPath(value, path);
    });
  }

  return value;
}

getStoreKeyName.setStringify(canonicalStringify);

function argsFromFieldSpecifier(spec) {
  return spec.args !== void 0 ? spec.args : spec.field ? argumentsObjectFromField(spec.field, spec.variables) : null;
}

var nullKeyFieldsFn = function nullKeyFieldsFn() {
  return void 0;
};

var simpleKeyArgsFn = function simpleKeyArgsFn(_args, context) {
  return context.fieldName;
};

var mergeTrueFn = function mergeTrueFn(existing, incoming, _a) {
  var mergeObjects = _a.mergeObjects;
  return mergeObjects(existing, incoming);
};

var mergeFalseFn = function mergeFalseFn(_, incoming) {
  return incoming;
};

var Policies = function () {
  function Policies(config) {
    this.config = config;
    this.typePolicies = Object.create(null);
    this.toBeAdded = Object.create(null);
    this.supertypeMap = new Map();
    this.fuzzySubtypes = new Map();
    this.rootIdsByTypename = Object.create(null);
    this.rootTypenamesById = Object.create(null);
    this.usingPossibleTypes = false;
    this.config = _assign$7({
      dataIdFromObject: defaultDataIdFromObject
    }, config);
    this.cache = this.config.cache;
    this.setRootTypename("Query");
    this.setRootTypename("Mutation");
    this.setRootTypename("Subscription");

    if (config.possibleTypes) {
      this.addPossibleTypes(config.possibleTypes);
    }

    if (config.typePolicies) {
      this.addTypePolicies(config.typePolicies);
    }
  }

  Policies.prototype.identify = function (object, partialContext) {
    var _a;

    var policies = this;
    var typename = partialContext && (partialContext.typename || ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename)) || object.__typename;

    if (typename === this.rootTypenamesById.ROOT_QUERY) {
      return ["ROOT_QUERY"];
    }

    var storeObject = partialContext && partialContext.storeObject || object;

    var context = _assign$7(_assign$7({}, partialContext), {
      typename: typename,
      storeObject: storeObject,
      readField: partialContext && partialContext.readField || function () {
        var options = normalizeReadFieldOptions(arguments, storeObject);
        return policies.readField(options, {
          store: policies.cache["data"],
          variables: options.variables
        });
      }
    });

    var id;
    var policy = typename && this.getTypePolicy(typename);
    var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;

    while (keyFn) {
      var specifierOrId = keyFn(object, context);

      if (isArray$2(specifierOrId)) {
        keyFn = keyFieldsFnFromSpecifier(specifierOrId);
      } else {
        id = specifierOrId;
        break;
      }
    }

    id = id ? String(id) : void 0;
    return context.keyObject ? [id, context.keyObject] : [id];
  };

  Policies.prototype.addTypePolicies = function (typePolicies) {
    var _this = this;

    Object.keys(typePolicies).forEach(function (typename) {
      var _a = typePolicies[typename],
          queryType = _a.queryType,
          mutationType = _a.mutationType,
          subscriptionType = _a.subscriptionType,
          incoming = __rest(_a, ["queryType", "mutationType", "subscriptionType"]);

      if (queryType) _this.setRootTypename("Query", typename);
      if (mutationType) _this.setRootTypename("Mutation", typename);
      if (subscriptionType) _this.setRootTypename("Subscription", typename);

      if (hasOwn.call(_this.toBeAdded, typename)) {
        _this.toBeAdded[typename].push(incoming);
      } else {
        _this.toBeAdded[typename] = [incoming];
      }
    });
  };

  Policies.prototype.updateTypePolicy = function (typename, incoming) {
    var _this = this;

    var existing = this.getTypePolicy(typename);
    var keyFields = incoming.keyFields,
        fields = incoming.fields;

    function setMerge(existing, merge) {
      existing.merge = typeof merge === "function" ? merge : merge === true ? mergeTrueFn : merge === false ? mergeFalseFn : existing.merge;
    }

    setMerge(existing, incoming.merge);
    existing.keyFn = keyFields === false ? nullKeyFieldsFn : isArray$2(keyFields) ? keyFieldsFnFromSpecifier(keyFields) : typeof keyFields === "function" ? keyFields : existing.keyFn;

    if (fields) {
      Object.keys(fields).forEach(function (fieldName) {
        var existing = _this.getFieldPolicy(typename, fieldName, true);

        var incoming = fields[fieldName];

        if (typeof incoming === "function") {
          existing.read = incoming;
        } else {
          var keyArgs = incoming.keyArgs,
              read = incoming.read,
              merge = incoming.merge;
          existing.keyFn = keyArgs === false ? simpleKeyArgsFn : isArray$2(keyArgs) ? keyArgsFnFromSpecifier(keyArgs) : typeof keyArgs === "function" ? keyArgs : existing.keyFn;

          if (typeof read === "function") {
            existing.read = read;
          }

          setMerge(existing, merge);
        }

        if (existing.read && existing.merge) {
          existing.keyFn = existing.keyFn || simpleKeyArgsFn;
        }
      });
    }
  };

  Policies.prototype.setRootTypename = function (which, typename) {
    if (typename === void 0) {
      typename = which;
    }

    var rootId = "ROOT_" + which.toUpperCase();
    var old = this.rootTypenamesById[rootId];

    if (typename !== old) {
      __DEV__ ? invariant(!old || old === which, "Cannot change root ".concat(which, " __typename more than once")) : invariant(!old || old === which, 3);
      if (old) delete this.rootIdsByTypename[old];
      this.rootIdsByTypename[typename] = rootId;
      this.rootTypenamesById[rootId] = typename;
    }
  };

  Policies.prototype.addPossibleTypes = function (possibleTypes) {
    var _this = this;

    this.usingPossibleTypes = true;
    Object.keys(possibleTypes).forEach(function (supertype) {
      _this.getSupertypeSet(supertype, true);

      possibleTypes[supertype].forEach(function (subtype) {
        _this.getSupertypeSet(subtype, true).add(supertype);

        var match = subtype.match(TypeOrFieldNameRegExp);

        if (!match || match[0] !== subtype) {
          _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
        }
      });
    });
  };

  Policies.prototype.getTypePolicy = function (typename) {
    var _this = this;

    if (!hasOwn.call(this.typePolicies, typename)) {
      var policy_1 = this.typePolicies[typename] = Object.create(null);
      policy_1.fields = Object.create(null);
      var supertypes = this.supertypeMap.get(typename);

      if (supertypes && supertypes.size) {
        supertypes.forEach(function (supertype) {
          var _a = _this.getTypePolicy(supertype),
              fields = _a.fields,
              rest = __rest(_a, ["fields"]);

          Object.assign(policy_1, rest);
          Object.assign(policy_1.fields, fields);
        });
      }
    }

    var inbox = this.toBeAdded[typename];

    if (inbox && inbox.length) {
      inbox.splice(0).forEach(function (policy) {
        _this.updateTypePolicy(typename, policy);
      });
    }

    return this.typePolicies[typename];
  };

  Policies.prototype.getFieldPolicy = function (typename, fieldName, createIfMissing) {
    if (typename) {
      var fieldPolicies = this.getTypePolicy(typename).fields;
      return fieldPolicies[fieldName] || createIfMissing && (fieldPolicies[fieldName] = Object.create(null));
    }
  };

  Policies.prototype.getSupertypeSet = function (subtype, createIfMissing) {
    var supertypeSet = this.supertypeMap.get(subtype);

    if (!supertypeSet && createIfMissing) {
      this.supertypeMap.set(subtype, supertypeSet = new Set());
    }

    return supertypeSet;
  };

  Policies.prototype.fragmentMatches = function (fragment, typename, result, variables) {
    var _this = this;

    if (!fragment.typeCondition) return true;
    if (!typename) return false;
    var supertype = fragment.typeCondition.name.value;
    if (typename === supertype) return true;

    if (this.usingPossibleTypes && this.supertypeMap.has(supertype)) {
      var typenameSupertypeSet = this.getSupertypeSet(typename, true);
      var workQueue_1 = [typenameSupertypeSet];

      var maybeEnqueue_1 = function maybeEnqueue_1(subtype) {
        var supertypeSet = _this.getSupertypeSet(subtype, false);

        if (supertypeSet && supertypeSet.size && workQueue_1.indexOf(supertypeSet) < 0) {
          workQueue_1.push(supertypeSet);
        }
      };

      var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
      var checkingFuzzySubtypes = false;

      for (var i = 0; i < workQueue_1.length; ++i) {
        var supertypeSet = workQueue_1[i];

        if (supertypeSet.has(supertype)) {
          if (!typenameSupertypeSet.has(supertype)) {
            if (checkingFuzzySubtypes) {
              __DEV__ && invariant.warn("Inferring subtype ".concat(typename, " of supertype ").concat(supertype));
            }

            typenameSupertypeSet.add(supertype);
          }

          return true;
        }

        supertypeSet.forEach(maybeEnqueue_1);

        if (needToCheckFuzzySubtypes && i === workQueue_1.length - 1 && selectionSetMatchesResult(fragment.selectionSet, result, variables)) {
          needToCheckFuzzySubtypes = false;
          checkingFuzzySubtypes = true;
          this.fuzzySubtypes.forEach(function (regExp, fuzzyString) {
            var match = typename.match(regExp);

            if (match && match[0] === typename) {
              maybeEnqueue_1(fuzzyString);
            }
          });
        }
      }
    }

    return false;
  };

  Policies.prototype.hasKeyArgs = function (typename, fieldName) {
    var policy = this.getFieldPolicy(typename, fieldName, false);
    return !!(policy && policy.keyFn);
  };

  Policies.prototype.getStoreFieldName = function (fieldSpec) {
    var typename = fieldSpec.typename,
        fieldName = fieldSpec.fieldName;
    var policy = this.getFieldPolicy(typename, fieldName, false);
    var storeFieldName;
    var keyFn = policy && policy.keyFn;

    if (keyFn && typename) {
      var context = {
        typename: typename,
        fieldName: fieldName,
        field: fieldSpec.field || null,
        variables: fieldSpec.variables
      };
      var args = argsFromFieldSpecifier(fieldSpec);

      while (keyFn) {
        var specifierOrString = keyFn(args, context);

        if (isArray$2(specifierOrString)) {
          keyFn = keyArgsFnFromSpecifier(specifierOrString);
        } else {
          storeFieldName = specifierOrString || fieldName;
          break;
        }
      }
    }

    if (storeFieldName === void 0) {
      storeFieldName = fieldSpec.field ? storeKeyNameFromField(fieldSpec.field, fieldSpec.variables) : getStoreKeyName(fieldName, argsFromFieldSpecifier(fieldSpec));
    }

    if (storeFieldName === false) {
      return fieldName;
    }

    return fieldName === fieldNameFromStoreName(storeFieldName) ? storeFieldName : fieldName + ":" + storeFieldName;
  };

  Policies.prototype.readField = function (options, context) {
    var objectOrReference = options.from;
    if (!objectOrReference) return;
    var nameOrField = options.field || options.fieldName;
    if (!nameOrField) return;

    if (options.typename === void 0) {
      var typename = context.store.getFieldValue(objectOrReference, "__typename");
      if (typename) options.typename = typename;
    }

    var storeFieldName = this.getStoreFieldName(options);
    var fieldName = fieldNameFromStoreName(storeFieldName);
    var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
    var policy = this.getFieldPolicy(options.typename, fieldName, false);
    var read = policy && policy.read;

    if (read) {
      var readOptions = makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage(isReference(objectOrReference) ? objectOrReference.__ref : objectOrReference, storeFieldName));
      return cacheSlot.withValue(this.cache, read, [existing, readOptions]);
    }

    return existing;
  };

  Policies.prototype.getReadFunction = function (typename, fieldName) {
    var policy = this.getFieldPolicy(typename, fieldName, false);
    return policy && policy.read;
  };

  Policies.prototype.getMergeFunction = function (parentTypename, fieldName, childTypename) {
    var policy = this.getFieldPolicy(parentTypename, fieldName, false);
    var merge = policy && policy.merge;

    if (!merge && childTypename) {
      policy = this.getTypePolicy(childTypename);
      merge = policy && policy.merge;
    }

    return merge;
  };

  Policies.prototype.runMergeFunction = function (existing, incoming, _a, context, storage) {
    var field = _a.field,
        typename = _a.typename,
        merge = _a.merge;

    if (merge === mergeTrueFn) {
      return makeMergeObjectsFunction(context.store)(existing, incoming);
    }

    if (merge === mergeFalseFn) {
      return incoming;
    }

    if (context.overwrite) {
      existing = void 0;
    }

    return merge(existing, incoming, makeFieldFunctionOptions(this, void 0, {
      typename: typename,
      fieldName: field.name.value,
      field: field,
      variables: context.variables
    }, context, storage || Object.create(null)));
  };

  return Policies;
}();

function makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
  var storeFieldName = policies.getStoreFieldName(fieldSpec);
  var fieldName = fieldNameFromStoreName(storeFieldName);
  var variables = fieldSpec.variables || context.variables;
  var _a = context.store,
      toReference = _a.toReference,
      canRead = _a.canRead;
  return {
    args: argsFromFieldSpecifier(fieldSpec),
    field: fieldSpec.field || null,
    fieldName: fieldName,
    storeFieldName: storeFieldName,
    variables: variables,
    isReference: isReference,
    toReference: toReference,
    storage: storage,
    cache: policies.cache,
    canRead: canRead,
    readField: function readField() {
      return policies.readField(normalizeReadFieldOptions(arguments, objectOrReference, context), context);
    },
    mergeObjects: makeMergeObjectsFunction(context.store)
  };
}

function normalizeReadFieldOptions(readFieldArgs, objectOrReference, variables) {
  var fieldNameOrOptions = readFieldArgs[0],
      from = readFieldArgs[1],
      argc = readFieldArgs.length;
  var options;

  if (typeof fieldNameOrOptions === "string") {
    options = {
      fieldName: fieldNameOrOptions,
      from: argc > 1 ? from : objectOrReference
    };
  } else {
    options = _assign$7({}, fieldNameOrOptions);

    if (!hasOwn.call(options, "from")) {
      options.from = objectOrReference;
    }
  }

  if (__DEV__ && options.from === void 0) {
    __DEV__ && invariant.warn("Undefined 'from' passed to readField with arguments ".concat(stringifyForDisplay(Array.from(readFieldArgs))));
  }

  if (void 0 === options.variables) {
    options.variables = variables;
  }

  return options;
}

function makeMergeObjectsFunction(store) {
  return function mergeObjects(existing, incoming) {
    if (isArray$2(existing) || isArray$2(incoming)) {
      throw __DEV__ ? new InvariantError("Cannot automatically merge arrays") : new InvariantError(4);
    }

    if (isNonNullObject$1(existing) && isNonNullObject$1(incoming)) {
      var eType = store.getFieldValue(existing, "__typename");
      var iType = store.getFieldValue(incoming, "__typename");
      var typesDiffer = eType && iType && eType !== iType;

      if (typesDiffer) {
        return incoming;
      }

      if (isReference(existing) && storeValueIsStoreObject(incoming)) {
        store.merge(existing.__ref, incoming);
        return existing;
      }

      if (storeValueIsStoreObject(existing) && isReference(incoming)) {
        store.merge(existing, incoming.__ref);
        return incoming;
      }

      if (storeValueIsStoreObject(existing) && storeValueIsStoreObject(incoming)) {
        return _assign$7(_assign$7({}, existing), incoming);
      }
    }

    return incoming;
  };
}

function getContextFlavor(context, clientOnly, deferred) {
  var key = "".concat(clientOnly).concat(deferred);
  var flavored = context.flavors.get(key);

  if (!flavored) {
    context.flavors.set(key, flavored = context.clientOnly === clientOnly && context.deferred === deferred ? context : _assign$7(_assign$7({}, context), {
      clientOnly: clientOnly,
      deferred: deferred
    }));
  }

  return flavored;
}

var StoreWriter = function () {
  function StoreWriter(cache, reader) {
    this.cache = cache;
    this.reader = reader;
  }

  StoreWriter.prototype.writeToStore = function (store, _a) {
    var _this = this;

    var query = _a.query,
        result = _a.result,
        dataId = _a.dataId,
        variables = _a.variables,
        overwrite = _a.overwrite;
    var operationDefinition = getOperationDefinition(query);
    var merger = makeProcessedFieldsMerger();
    variables = _assign$7(_assign$7({}, getDefaultValues(operationDefinition)), variables);
    var context = {
      store: store,
      written: Object.create(null),
      merge: function merge(existing, incoming) {
        return merger.merge(existing, incoming);
      },
      variables: variables,
      varString: canonicalStringify(variables),
      fragmentMap: createFragmentMap(getFragmentDefinitions(query)),
      overwrite: !!overwrite,
      incomingById: new Map(),
      clientOnly: false,
      deferred: false,
      flavors: new Map()
    };
    var ref = this.processSelectionSet({
      result: result || Object.create(null),
      dataId: dataId,
      selectionSet: operationDefinition.selectionSet,
      mergeTree: {
        map: new Map()
      },
      context: context
    });

    if (!isReference(ref)) {
      throw __DEV__ ? new InvariantError("Could not identify object ".concat(JSON.stringify(result))) : new InvariantError(6);
    }

    context.incomingById.forEach(function (_a, dataId) {
      var storeObject = _a.storeObject,
          mergeTree = _a.mergeTree,
          fieldNodeSet = _a.fieldNodeSet;
      var entityRef = makeReference(dataId);

      if (mergeTree && mergeTree.map.size) {
        var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);

        if (isReference(applied)) {
          return;
        }

        storeObject = applied;
      }

      if (__DEV__ && !context.overwrite) {
        var fieldsWithSelectionSets_1 = Object.create(null);
        fieldNodeSet.forEach(function (field) {
          if (field.selectionSet) {
            fieldsWithSelectionSets_1[field.name.value] = true;
          }
        });

        var hasSelectionSet_1 = function hasSelectionSet_1(storeFieldName) {
          return fieldsWithSelectionSets_1[fieldNameFromStoreName(storeFieldName)] === true;
        };

        var hasMergeFunction_1 = function hasMergeFunction_1(storeFieldName) {
          var childTree = mergeTree && mergeTree.map.get(storeFieldName);
          return Boolean(childTree && childTree.info && childTree.info.merge);
        };

        Object.keys(storeObject).forEach(function (storeFieldName) {
          if (hasSelectionSet_1(storeFieldName) && !hasMergeFunction_1(storeFieldName)) {
            warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
          }
        });
      }

      store.merge(dataId, storeObject);
    });
    store.retain(ref.__ref);
    return ref;
  };

  StoreWriter.prototype.processSelectionSet = function (_a) {
    var _this = this;

    var dataId = _a.dataId,
        result = _a.result,
        selectionSet = _a.selectionSet,
        context = _a.context,
        mergeTree = _a.mergeTree;
    var policies = this.cache.policies;
    var incoming = Object.create(null);
    var typename = dataId && policies.rootTypenamesById[dataId] || getTypenameFromResult(result, selectionSet, context.fragmentMap) || dataId && context.store.get(dataId, "__typename");

    if ("string" === typeof typename) {
      incoming.__typename = typename;
    }

    var readField = function readField() {
      var options = normalizeReadFieldOptions(arguments, incoming, context.variables);

      if (isReference(options.from)) {
        var info = context.incomingById.get(options.from.__ref);

        if (info) {
          var result_1 = policies.readField(_assign$7(_assign$7({}, options), {
            from: info.storeObject
          }), context);

          if (result_1 !== void 0) {
            return result_1;
          }
        }
      }

      return policies.readField(options, context);
    };

    var fieldNodeSet = new Set();
    this.flattenFields(selectionSet, result, context, typename).forEach(function (context, field) {
      var _a;

      var resultFieldKey = resultKeyNameFromField(field);
      var value = result[resultFieldKey];
      fieldNodeSet.add(field);

      if (value !== void 0) {
        var storeFieldName = policies.getStoreFieldName({
          typename: typename,
          fieldName: field.name.value,
          field: field,
          variables: context.variables
        });
        var childTree = getChildMergeTree(mergeTree, storeFieldName);

        var incomingValue = _this.processFieldValue(value, field, field.selectionSet ? getContextFlavor(context, false, false) : context, childTree);

        var childTypename = void 0;

        if (field.selectionSet && (isReference(incomingValue) || storeValueIsStoreObject(incomingValue))) {
          childTypename = readField("__typename", incomingValue);
        }

        var merge = policies.getMergeFunction(typename, field.name.value, childTypename);

        if (merge) {
          childTree.info = {
            field: field,
            typename: typename,
            merge: merge
          };
        } else {
          maybeRecycleChildMergeTree(mergeTree, storeFieldName);
        }

        incoming = context.merge(incoming, (_a = {}, _a[storeFieldName] = incomingValue, _a));
      } else if (__DEV__ && !context.clientOnly && !context.deferred && !addTypenameToDocument.added(field) && !policies.getReadFunction(typename, field.name.value)) {
        __DEV__ && invariant.error("Missing field '".concat(resultKeyNameFromField(field), "' while writing result ").concat(JSON.stringify(result, null, 2)).substring(0, 1000));
      }
    });

    try {
      var _b = policies.identify(result, {
        typename: typename,
        selectionSet: selectionSet,
        fragmentMap: context.fragmentMap,
        storeObject: incoming,
        readField: readField
      }),
          id = _b[0],
          keyObject = _b[1];

      dataId = dataId || id;

      if (keyObject) {
        incoming = context.merge(incoming, keyObject);
      }
    } catch (e) {
      if (!dataId) throw e;
    }

    if ("string" === typeof dataId) {
      var dataRef = makeReference(dataId);
      var sets = context.written[dataId] || (context.written[dataId] = []);
      if (sets.indexOf(selectionSet) >= 0) return dataRef;
      sets.push(selectionSet);

      if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) {
        return dataRef;
      }

      var previous_1 = context.incomingById.get(dataId);

      if (previous_1) {
        previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
        previous_1.mergeTree = mergeMergeTrees(previous_1.mergeTree, mergeTree);
        fieldNodeSet.forEach(function (field) {
          return previous_1.fieldNodeSet.add(field);
        });
      } else {
        context.incomingById.set(dataId, {
          storeObject: incoming,
          mergeTree: mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
          fieldNodeSet: fieldNodeSet
        });
      }

      return dataRef;
    }

    return incoming;
  };

  StoreWriter.prototype.processFieldValue = function (value, field, context, mergeTree) {
    var _this = this;

    if (!field.selectionSet || value === null) {
      return __DEV__ ? cloneDeep(value) : value;
    }

    if (isArray$2(value)) {
      return value.map(function (item, i) {
        var value = _this.processFieldValue(item, field, context, getChildMergeTree(mergeTree, i));

        maybeRecycleChildMergeTree(mergeTree, i);
        return value;
      });
    }

    return this.processSelectionSet({
      result: value,
      selectionSet: field.selectionSet,
      context: context,
      mergeTree: mergeTree
    });
  };

  StoreWriter.prototype.flattenFields = function (selectionSet, result, context, typename) {
    if (typename === void 0) {
      typename = getTypenameFromResult(result, selectionSet, context.fragmentMap);
    }

    var fieldMap = new Map();
    var policies = this.cache.policies;
    var limitingTrie = new Trie(false);

    (function flatten(selectionSet, inheritedContext) {
      var visitedNode = limitingTrie.lookup(selectionSet, inheritedContext.clientOnly, inheritedContext.deferred);
      if (visitedNode.visited) return;
      visitedNode.visited = true;
      selectionSet.selections.forEach(function (selection) {
        if (!shouldInclude(selection, context.variables)) return;
        var clientOnly = inheritedContext.clientOnly,
            deferred = inheritedContext.deferred;

        if (!(clientOnly && deferred) && isNonEmptyArray(selection.directives)) {
          selection.directives.forEach(function (dir) {
            var name = dir.name.value;
            if (name === "client") clientOnly = true;

            if (name === "defer") {
              var args = argumentsObjectFromField(dir, context.variables);

              if (!args || args.if !== false) {
                deferred = true;
              }
            }
          });
        }

        if (isField(selection)) {
          var existing = fieldMap.get(selection);

          if (existing) {
            clientOnly = clientOnly && existing.clientOnly;
            deferred = deferred && existing.deferred;
          }

          fieldMap.set(selection, getContextFlavor(context, clientOnly, deferred));
        } else {
          var fragment = getFragmentFromSelection(selection, context.fragmentMap);

          if (fragment && policies.fragmentMatches(fragment, typename, result, context.variables)) {
            flatten(fragment.selectionSet, getContextFlavor(context, clientOnly, deferred));
          }
        }
      });
    })(selectionSet, context);

    return fieldMap;
  };

  StoreWriter.prototype.applyMerges = function (mergeTree, existing, incoming, context, getStorageArgs) {
    var _a;

    var _this = this;

    if (mergeTree.map.size && !isReference(incoming)) {
      var e_1 = !isArray$2(incoming) && (isReference(existing) || storeValueIsStoreObject(existing)) ? existing : void 0;
      var i_1 = incoming;

      if (e_1 && !getStorageArgs) {
        getStorageArgs = [isReference(e_1) ? e_1.__ref : e_1];
      }

      var changedFields_1;

      var getValue_1 = function getValue_1(from, name) {
        return isArray$2(from) ? typeof name === "number" ? from[name] : void 0 : context.store.getFieldValue(from, String(name));
      };

      mergeTree.map.forEach(function (childTree, storeFieldName) {
        var eVal = getValue_1(e_1, storeFieldName);
        var iVal = getValue_1(i_1, storeFieldName);
        if (void 0 === iVal) return;

        if (getStorageArgs) {
          getStorageArgs.push(storeFieldName);
        }

        var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);

        if (aVal !== iVal) {
          changedFields_1 = changedFields_1 || new Map();
          changedFields_1.set(storeFieldName, aVal);
        }

        if (getStorageArgs) {
          invariant(getStorageArgs.pop() === storeFieldName);
        }
      });

      if (changedFields_1) {
        incoming = isArray$2(i_1) ? i_1.slice(0) : _assign$7({}, i_1);
        changedFields_1.forEach(function (value, name) {
          incoming[name] = value;
        });
      }
    }

    if (mergeTree.info) {
      return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
    }

    return incoming;
  };

  return StoreWriter;
}();

var emptyMergeTreePool = [];

function getChildMergeTree(_a, name) {
  var map = _a.map;

  if (!map.has(name)) {
    map.set(name, emptyMergeTreePool.pop() || {
      map: new Map()
    });
  }

  return map.get(name);
}

function mergeMergeTrees(left, right) {
  if (left === right || !right || mergeTreeIsEmpty(right)) return left;
  if (!left || mergeTreeIsEmpty(left)) return right;
  var info = left.info && right.info ? _assign$7(_assign$7({}, left.info), right.info) : left.info || right.info;
  var needToMergeMaps = left.map.size && right.map.size;
  var map = needToMergeMaps ? new Map() : left.map.size ? left.map : right.map;
  var merged = {
    info: info,
    map: map
  };

  if (needToMergeMaps) {
    var remainingRightKeys_1 = new Set(right.map.keys());
    left.map.forEach(function (leftTree, key) {
      merged.map.set(key, mergeMergeTrees(leftTree, right.map.get(key)));
      remainingRightKeys_1.delete(key);
    });
    remainingRightKeys_1.forEach(function (key) {
      merged.map.set(key, mergeMergeTrees(right.map.get(key), left.map.get(key)));
    });
  }

  return merged;
}

function mergeTreeIsEmpty(tree) {
  return !tree || !(tree.info || tree.map.size);
}

function maybeRecycleChildMergeTree(_a, name) {
  var map = _a.map;
  var childTree = map.get(name);

  if (childTree && mergeTreeIsEmpty(childTree)) {
    emptyMergeTreePool.push(childTree);
    map.delete(name);
  }
}

var warnings = new Set();

function warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
  var getChild = function getChild(objOrRef) {
    var child = store.getFieldValue(objOrRef, storeFieldName);
    return typeof child === "object" && child;
  };

  var existing = getChild(existingRef);
  if (!existing) return;
  var incoming = getChild(incomingObj);
  if (!incoming) return;
  if (isReference(existing)) return;
  if (equal(existing, incoming)) return;

  if (Object.keys(existing).every(function (key) {
    return store.getFieldValue(incoming, key) !== void 0;
  })) {
    return;
  }

  var parentType = store.getFieldValue(existingRef, "__typename") || store.getFieldValue(incomingObj, "__typename");
  var fieldName = fieldNameFromStoreName(storeFieldName);
  var typeDotName = "".concat(parentType, ".").concat(fieldName);
  if (warnings.has(typeDotName)) return;
  warnings.add(typeDotName);
  var childTypenames = [];

  if (!isArray$2(existing) && !isArray$2(incoming)) {
    [existing, incoming].forEach(function (child) {
      var typename = store.getFieldValue(child, "__typename");

      if (typeof typename === "string" && !childTypenames.includes(typename)) {
        childTypenames.push(typename);
      }
    });
  }

  __DEV__ && invariant.warn("Cache data may be lost when replacing the ".concat(fieldName, " field of a ").concat(parentType, " object.\n\nTo address this problem (which is not a bug in Apollo Client), ").concat(childTypenames.length ? "either ensure all objects of type " + childTypenames.join(" and ") + " have an ID or a custom merge function, or " : "", "define a custom merge function for the ").concat(typeDotName, " field, so InMemoryCache can safely merge these objects:\n\n  existing: ").concat(JSON.stringify(existing).slice(0, 1000), "\n  incoming: ").concat(JSON.stringify(incoming).slice(0, 1000), "\n\nFor more information about these options, please refer to the documentation:\n\n  * Ensuring entity objects have IDs: https://go.apollo.dev/c/generating-unique-identifiers\n  * Defining custom merge functions: https://go.apollo.dev/c/merging-non-normalized-objects\n"));
}

var InMemoryCache = function (_super) {
  __extends$1(InMemoryCache, _super);

  function InMemoryCache(config) {
    if (config === void 0) {
      config = {};
    }

    var _this = _super.call(this) || this;

    _this.watches = new Set();
    _this.typenameDocumentCache = new Map();
    _this.makeVar = makeVar;
    _this.txCount = 0;
    _this.config = normalizeConfig(config);
    _this.addTypename = !!_this.config.addTypename;
    _this.policies = new Policies({
      cache: _this,
      dataIdFromObject: _this.config.dataIdFromObject,
      possibleTypes: _this.config.possibleTypes,
      typePolicies: _this.config.typePolicies
    });

    _this.init();

    return _this;
  }

  InMemoryCache.prototype.init = function () {
    var rootStore = this.data = new EntityStore.Root({
      policies: this.policies,
      resultCaching: this.config.resultCaching
    });
    this.optimisticData = rootStore.stump;
    this.resetResultCache();
  };

  InMemoryCache.prototype.resetResultCache = function (resetResultIdentities) {
    var _this = this;

    var previousReader = this.storeReader;
    this.storeWriter = new StoreWriter(this, this.storeReader = new StoreReader({
      cache: this,
      addTypename: this.addTypename,
      resultCacheMaxSize: this.config.resultCacheMaxSize,
      canonizeResults: shouldCanonizeResults(this.config),
      canon: resetResultIdentities ? void 0 : previousReader && previousReader.canon
    }));
    this.maybeBroadcastWatch = wrap(function (c, options) {
      return _this.broadcastWatch(c, options);
    }, {
      max: this.config.resultCacheMaxSize,
      makeCacheKey: function makeCacheKey(c) {
        var store = c.optimistic ? _this.optimisticData : _this.data;

        if (supportsResultCaching(store)) {
          var optimistic = c.optimistic,
              rootId = c.rootId,
              variables = c.variables;
          return store.makeCacheKey(c.query, c.callback, canonicalStringify({
            optimistic: optimistic,
            rootId: rootId,
            variables: variables
          }));
        }
      }
    });
    new Set([this.data.group, this.optimisticData.group]).forEach(function (group) {
      return group.resetCaching();
    });
  };

  InMemoryCache.prototype.restore = function (data) {
    this.init();
    if (data) this.data.replace(data);
    return this;
  };

  InMemoryCache.prototype.extract = function (optimistic) {
    if (optimistic === void 0) {
      optimistic = false;
    }

    return (optimistic ? this.optimisticData : this.data).extract();
  };

  InMemoryCache.prototype.read = function (options) {
    var _a = options.returnPartialData,
        returnPartialData = _a === void 0 ? false : _a;

    try {
      return this.storeReader.diffQueryAgainstStore(_assign$7(_assign$7({}, options), {
        store: options.optimistic ? this.optimisticData : this.data,
        config: this.config,
        returnPartialData: returnPartialData
      })).result || null;
    } catch (e) {
      if (e instanceof MissingFieldError) {
        return null;
      }

      throw e;
    }
  };

  InMemoryCache.prototype.write = function (options) {
    try {
      ++this.txCount;
      return this.storeWriter.writeToStore(this.data, options);
    } finally {
      if (! --this.txCount && options.broadcast !== false) {
        this.broadcastWatches();
      }
    }
  };

  InMemoryCache.prototype.modify = function (options) {
    if (hasOwn.call(options, "id") && !options.id) {
      return false;
    }

    var store = options.optimistic ? this.optimisticData : this.data;

    try {
      ++this.txCount;
      return store.modify(options.id || "ROOT_QUERY", options.fields);
    } finally {
      if (! --this.txCount && options.broadcast !== false) {
        this.broadcastWatches();
      }
    }
  };

  InMemoryCache.prototype.diff = function (options) {
    return this.storeReader.diffQueryAgainstStore(_assign$7(_assign$7({}, options), {
      store: options.optimistic ? this.optimisticData : this.data,
      rootId: options.id || "ROOT_QUERY",
      config: this.config
    }));
  };

  InMemoryCache.prototype.watch = function (watch) {
    var _this = this;

    if (!this.watches.size) {
      recallCache(this);
    }

    this.watches.add(watch);

    if (watch.immediate) {
      this.maybeBroadcastWatch(watch);
    }

    return function () {
      if (_this.watches.delete(watch) && !_this.watches.size) {
        forgetCache(_this);
      }

      _this.maybeBroadcastWatch.forget(watch);
    };
  };

  InMemoryCache.prototype.gc = function (options) {
    canonicalStringify.reset();
    var ids = this.optimisticData.gc();

    if (options && !this.txCount) {
      if (options.resetResultCache) {
        this.resetResultCache(options.resetResultIdentities);
      } else if (options.resetResultIdentities) {
        this.storeReader.resetCanon();
      }
    }

    return ids;
  };

  InMemoryCache.prototype.retain = function (rootId, optimistic) {
    return (optimistic ? this.optimisticData : this.data).retain(rootId);
  };

  InMemoryCache.prototype.release = function (rootId, optimistic) {
    return (optimistic ? this.optimisticData : this.data).release(rootId);
  };

  InMemoryCache.prototype.identify = function (object) {
    if (isReference(object)) return object.__ref;

    try {
      return this.policies.identify(object)[0];
    } catch (e) {
      __DEV__ && invariant.warn(e);
    }
  };

  InMemoryCache.prototype.evict = function (options) {
    if (!options.id) {
      if (hasOwn.call(options, "id")) {
        return false;
      }

      options = _assign$7(_assign$7({}, options), {
        id: "ROOT_QUERY"
      });
    }

    try {
      ++this.txCount;
      return this.optimisticData.evict(options, this.data);
    } finally {
      if (! --this.txCount && options.broadcast !== false) {
        this.broadcastWatches();
      }
    }
  };

  InMemoryCache.prototype.reset = function (options) {
    var _this = this;

    this.init();
    canonicalStringify.reset();

    if (options && options.discardWatches) {
      this.watches.forEach(function (watch) {
        return _this.maybeBroadcastWatch.forget(watch);
      });
      this.watches.clear();
      forgetCache(this);
    } else {
      this.broadcastWatches();
    }

    return Promise.resolve();
  };

  InMemoryCache.prototype.removeOptimistic = function (idToRemove) {
    var newOptimisticData = this.optimisticData.removeLayer(idToRemove);

    if (newOptimisticData !== this.optimisticData) {
      this.optimisticData = newOptimisticData;
      this.broadcastWatches();
    }
  };

  InMemoryCache.prototype.batch = function (options) {
    var _this = this;

    var update = options.update,
        _a = options.optimistic,
        optimistic = _a === void 0 ? true : _a,
        removeOptimistic = options.removeOptimistic,
        _onWatchUpdated = options.onWatchUpdated;
    var updateResult;

    var perform = function perform(layer) {
      var _a = _this,
          data = _a.data,
          optimisticData = _a.optimisticData;
      ++_this.txCount;

      if (layer) {
        _this.data = _this.optimisticData = layer;
      }

      try {
        return updateResult = update(_this);
      } finally {
        --_this.txCount;
        _this.data = data;
        _this.optimisticData = optimisticData;
      }
    };

    var alreadyDirty = new Set();

    if (_onWatchUpdated && !this.txCount) {
      this.broadcastWatches(_assign$7(_assign$7({}, options), {
        onWatchUpdated: function onWatchUpdated(watch) {
          alreadyDirty.add(watch);
          return false;
        }
      }));
    }

    if (typeof optimistic === 'string') {
      this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
    } else if (optimistic === false) {
      perform(this.data);
    } else {
      perform();
    }

    if (typeof removeOptimistic === "string") {
      this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
    }

    if (_onWatchUpdated && alreadyDirty.size) {
      this.broadcastWatches(_assign$7(_assign$7({}, options), {
        onWatchUpdated: function onWatchUpdated(watch, diff) {
          var result = _onWatchUpdated.call(this, watch, diff);

          if (result !== false) {
            alreadyDirty.delete(watch);
          }

          return result;
        }
      }));

      if (alreadyDirty.size) {
        alreadyDirty.forEach(function (watch) {
          return _this.maybeBroadcastWatch.dirty(watch);
        });
      }
    } else {
      this.broadcastWatches(options);
    }

    return updateResult;
  };

  InMemoryCache.prototype.performTransaction = function (update, optimisticId) {
    return this.batch({
      update: update,
      optimistic: optimisticId || optimisticId !== null
    });
  };

  InMemoryCache.prototype.transformDocument = function (document) {
    if (this.addTypename) {
      var result = this.typenameDocumentCache.get(document);

      if (!result) {
        result = addTypenameToDocument(document);
        this.typenameDocumentCache.set(document, result);
        this.typenameDocumentCache.set(result, result);
      }

      return result;
    }

    return document;
  };

  InMemoryCache.prototype.broadcastWatches = function (options) {
    var _this = this;

    if (!this.txCount) {
      this.watches.forEach(function (c) {
        return _this.maybeBroadcastWatch(c, options);
      });
    }
  };

  InMemoryCache.prototype.broadcastWatch = function (c, options) {
    var lastDiff = c.lastDiff;
    var diff = this.diff(c);

    if (options) {
      if (c.optimistic && typeof options.optimistic === "string") {
        diff.fromOptimisticTransaction = true;
      }

      if (options.onWatchUpdated && options.onWatchUpdated.call(this, c, diff, lastDiff) === false) {
        return;
      }
    }

    if (!lastDiff || !equal(lastDiff.result, diff.result)) {
      c.callback(c.lastDiff = diff, lastDiff);
    }
  };

  return InMemoryCache;
}(ApolloCache);

function isApolloError(err) {
  return err.hasOwnProperty('graphQLErrors');
}

var generateErrorMessage = function generateErrorMessage(err) {
  var message = '';

  if (isNonEmptyArray(err.graphQLErrors) || isNonEmptyArray(err.clientErrors)) {
    var errors = (err.graphQLErrors || []).concat(err.clientErrors || []);
    errors.forEach(function (error) {
      var errorMessage = error ? error.message : 'Error message not found.';
      message += "".concat(errorMessage, "\n");
    });
  }

  if (err.networkError) {
    message += "".concat(err.networkError.message, "\n");
  }

  message = message.replace(/\n$/, '');
  return message;
};

var ApolloError = function (_super) {
  __extends$1(ApolloError, _super);

  function ApolloError(_a) {
    var graphQLErrors = _a.graphQLErrors,
        clientErrors = _a.clientErrors,
        networkError = _a.networkError,
        errorMessage = _a.errorMessage,
        extraInfo = _a.extraInfo;

    var _this = _super.call(this, errorMessage) || this;

    _this.graphQLErrors = graphQLErrors || [];
    _this.clientErrors = clientErrors || [];
    _this.networkError = networkError || null;
    _this.message = errorMessage || generateErrorMessage(_this);
    _this.extraInfo = extraInfo;
    _this.__proto__ = ApolloError.prototype;
    return _this;
  }

  return ApolloError;
}(Error);

var NetworkStatus;

(function (NetworkStatus) {
  NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
  NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
  NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
  NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
  NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
  NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
  NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));

function isNetworkRequestInFlight(networkStatus) {
  return networkStatus ? networkStatus < 7 : false;
}

var assign$1 = Object.assign,
    hasOwnProperty$c = Object.hasOwnProperty;
var warnedAboutUpdateQuery = false;

var ObservableQuery = function (_super) {
  __extends$1(ObservableQuery, _super);

  function ObservableQuery(_a) {
    var queryManager = _a.queryManager,
        queryInfo = _a.queryInfo,
        options = _a.options;

    var _this = _super.call(this, function (observer) {
      try {
        var subObserver = observer._subscription._observer;

        if (subObserver && !subObserver.error) {
          subObserver.error = defaultSubscriptionObserverErrorCallback;
        }
      } catch (_a) {}

      var first = !_this.observers.size;

      _this.observers.add(observer);

      var last = _this.last;

      if (last && last.error) {
        observer.error && observer.error(last.error);
      } else if (last && last.result) {
        observer.next && observer.next(last.result);
      }

      if (first) {
        _this.reobserve().catch(function () {});
      }

      return function () {
        if (_this.observers.delete(observer) && !_this.observers.size) {
          _this.tearDownQuery();
        }
      };
    }) || this;

    _this.observers = new Set();
    _this.subscriptions = new Set();
    _this.isTornDown = false;
    _this.options = options;
    _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
    var opDef = getOperationDefinition(options.query);
    _this.queryName = opDef && opDef.name && opDef.name.value;
    _this.initialFetchPolicy = options.fetchPolicy || "cache-first";
    _this.queryManager = queryManager;
    _this.queryInfo = queryInfo;
    return _this;
  }

  Object.defineProperty(ObservableQuery.prototype, "variables", {
    get: function get() {
      return this.options.variables;
    },
    enumerable: false,
    configurable: true
  });

  ObservableQuery.prototype.result = function () {
    var _this = this;

    return new Promise(function (resolve, reject) {
      var observer = {
        next: function next(result) {
          resolve(result);

          _this.observers.delete(observer);

          if (!_this.observers.size) {
            _this.queryManager.removeQuery(_this.queryId);
          }

          setTimeout(function () {
            subscription.unsubscribe();
          }, 0);
        },
        error: reject
      };

      var subscription = _this.subscribe(observer);
    });
  };

  ObservableQuery.prototype.getCurrentResult = function (saveAsLastResult) {
    if (saveAsLastResult === void 0) {
      saveAsLastResult = true;
    }

    var lastResult = this.getLastResult(true);
    var networkStatus = this.queryInfo.networkStatus || lastResult && lastResult.networkStatus || NetworkStatus.ready;

    var result = _assign$7(_assign$7({}, lastResult), {
      loading: isNetworkRequestInFlight(networkStatus),
      networkStatus: networkStatus
    });

    var _a = this.options.fetchPolicy,
        fetchPolicy = _a === void 0 ? "cache-first" : _a;
    if (fetchPolicy === 'network-only' || fetchPolicy === 'no-cache' || fetchPolicy === 'standby' || this.queryManager.transform(this.options.query).hasForcedResolvers) ;else {
      var diff = this.queryInfo.getDiff();

      if (diff.complete || this.options.returnPartialData) {
        result.data = diff.result;
      }

      if (equal(result.data, {})) {
        result.data = void 0;
      }

      if (diff.complete) {
        delete result.partial;

        if (diff.complete && result.networkStatus === NetworkStatus.loading && (fetchPolicy === 'cache-first' || fetchPolicy === 'cache-only')) {
          result.networkStatus = NetworkStatus.ready;
          result.loading = false;
        }
      } else {
        result.partial = true;
      }

      if (__DEV__ && !diff.complete && !this.options.partialRefetch && !result.loading && !result.data && !result.error) {
        logMissingFieldErrors(diff.missing);
      }
    }

    if (saveAsLastResult) {
      this.updateLastResult(result);
    }

    return result;
  };

  ObservableQuery.prototype.isDifferentFromLastResult = function (newResult) {
    return !this.last || !equal(this.last.result, newResult);
  };

  ObservableQuery.prototype.getLast = function (key, variablesMustMatch) {
    var last = this.last;

    if (last && last[key] && (!variablesMustMatch || equal(last.variables, this.variables))) {
      return last[key];
    }
  };

  ObservableQuery.prototype.getLastResult = function (variablesMustMatch) {
    return this.getLast("result", variablesMustMatch);
  };

  ObservableQuery.prototype.getLastError = function (variablesMustMatch) {
    return this.getLast("error", variablesMustMatch);
  };

  ObservableQuery.prototype.resetLastResults = function () {
    delete this.last;
    this.isTornDown = false;
  };

  ObservableQuery.prototype.resetQueryStoreErrors = function () {
    this.queryManager.resetErrors(this.queryId);
  };

  ObservableQuery.prototype.refetch = function (variables) {
    var _a;

    var reobserveOptions = {
      pollInterval: 0
    };
    var fetchPolicy = this.options.fetchPolicy;

    if (fetchPolicy === 'cache-and-network') {
      reobserveOptions.fetchPolicy = fetchPolicy;
    } else if (fetchPolicy === 'no-cache') {
      reobserveOptions.fetchPolicy = 'no-cache';
    } else {
      reobserveOptions.fetchPolicy = 'network-only';
    }

    if (__DEV__ && variables && hasOwnProperty$c.call(variables, "variables")) {
      var queryDef = getQueryDefinition(this.options.query);
      var vars = queryDef.variableDefinitions;

      if (!vars || !vars.some(function (v) {
        return v.variable.name.value === "variables";
      })) {
        __DEV__ && invariant.warn("Called refetch(".concat(JSON.stringify(variables), ") for query ").concat(((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || JSON.stringify(queryDef), ", which does not declare a $variables variable.\nDid you mean to call refetch(variables) instead of refetch({ variables })?"));
      }
    }

    if (variables && !equal(this.options.variables, variables)) {
      reobserveOptions.variables = this.options.variables = _assign$7(_assign$7({}, this.options.variables), variables);
    }

    this.queryInfo.resetLastWrite();
    return this.reobserve(reobserveOptions, NetworkStatus.refetch);
  };

  ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
    var _this = this;

    var combinedOptions = _assign$7(_assign$7({}, fetchMoreOptions.query ? fetchMoreOptions : _assign$7(_assign$7(_assign$7({}, this.options), fetchMoreOptions), {
      variables: _assign$7(_assign$7({}, this.options.variables), fetchMoreOptions.variables)
    })), {
      fetchPolicy: "no-cache"
    });

    var qid = this.queryManager.generateQueryId();

    if (combinedOptions.notifyOnNetworkStatusChange) {
      this.queryInfo.networkStatus = NetworkStatus.fetchMore;
      this.observe();
    }

    return this.queryManager.fetchQuery(qid, combinedOptions, NetworkStatus.fetchMore).then(function (fetchMoreResult) {
      var data = fetchMoreResult.data;
      var updateQuery = fetchMoreOptions.updateQuery;

      if (updateQuery) {
        if (__DEV__ && !warnedAboutUpdateQuery) {
          __DEV__ && invariant.warn("The updateQuery callback for fetchMore is deprecated, and will be removed\nin the next major version of Apollo Client.\n\nPlease convert updateQuery functions to field policies with appropriate\nread and merge functions, or use/adapt a helper function (such as\nconcatPagination, offsetLimitPagination, or relayStylePagination) from\n@apollo/client/utilities.\n\nThe field policy system handles pagination more effectively than a\nhand-written updateQuery function, and you only need to define the policy\nonce, rather than every time you call fetchMore.");
          warnedAboutUpdateQuery = true;
        }

        _this.updateQuery(function (previous) {
          return updateQuery(previous, {
            fetchMoreResult: data,
            variables: combinedOptions.variables
          });
        });
      } else {
        _this.queryManager.cache.writeQuery({
          query: combinedOptions.query,
          variables: combinedOptions.variables,
          data: data
        });
      }

      return fetchMoreResult;
    }).finally(function () {
      _this.queryManager.stopQuery(qid);

      _this.reobserve();
    });
  };

  ObservableQuery.prototype.subscribeToMore = function (options) {
    var _this = this;

    var subscription = this.queryManager.startGraphQLSubscription({
      query: options.document,
      variables: options.variables,
      context: options.context
    }).subscribe({
      next: function next(subscriptionData) {
        var updateQuery = options.updateQuery;

        if (updateQuery) {
          _this.updateQuery(function (previous, _a) {
            var variables = _a.variables;
            return updateQuery(previous, {
              subscriptionData: subscriptionData,
              variables: variables
            });
          });
        }
      },
      error: function error(err) {
        if (options.onError) {
          options.onError(err);
          return;
        }

        __DEV__ && invariant.error('Unhandled GraphQL subscription error', err);
      }
    });
    this.subscriptions.add(subscription);
    return function () {
      if (_this.subscriptions.delete(subscription)) {
        subscription.unsubscribe();
      }
    };
  };

  ObservableQuery.prototype.setOptions = function (newOptions) {
    return this.reobserve(newOptions);
  };

  ObservableQuery.prototype.setVariables = function (variables) {
    if (equal(this.variables, variables)) {
      return this.observers.size ? this.result() : Promise.resolve();
    }

    this.options.variables = variables;

    if (!this.observers.size) {
      return Promise.resolve();
    }

    return this.reobserve({
      fetchPolicy: this.initialFetchPolicy,
      variables: variables
    }, NetworkStatus.setVariables);
  };

  ObservableQuery.prototype.updateQuery = function (mapFn) {
    var queryManager = this.queryManager;
    var result = queryManager.cache.diff({
      query: this.options.query,
      variables: this.variables,
      returnPartialData: true,
      optimistic: false
    }).result;
    var newResult = mapFn(result, {
      variables: this.variables
    });

    if (newResult) {
      queryManager.cache.writeQuery({
        query: this.options.query,
        data: newResult,
        variables: this.variables
      });
      queryManager.broadcastQueries();
    }
  };

  ObservableQuery.prototype.startPolling = function (pollInterval) {
    this.options.pollInterval = pollInterval;
    this.updatePolling();
  };

  ObservableQuery.prototype.stopPolling = function () {
    this.options.pollInterval = 0;
    this.updatePolling();
  };

  ObservableQuery.prototype.fetch = function (options, newNetworkStatus) {
    this.queryManager.setObservableQuery(this);
    return this.queryManager.fetchQueryObservable(this.queryId, options, newNetworkStatus);
  };

  ObservableQuery.prototype.updatePolling = function () {
    var _this = this;

    if (this.queryManager.ssrMode) {
      return;
    }

    var _a = this,
        pollingInfo = _a.pollingInfo,
        pollInterval = _a.options.pollInterval;

    if (!pollInterval) {
      if (pollingInfo) {
        clearTimeout(pollingInfo.timeout);
        delete this.pollingInfo;
      }

      return;
    }

    if (pollingInfo && pollingInfo.interval === pollInterval) {
      return;
    }

    __DEV__ ? invariant(pollInterval, 'Attempted to start a polling query without a polling interval.') : invariant(pollInterval, 10);
    var info = pollingInfo || (this.pollingInfo = {});
    info.interval = pollInterval;

    var maybeFetch = function maybeFetch() {
      if (_this.pollingInfo) {
        if (!isNetworkRequestInFlight(_this.queryInfo.networkStatus)) {
          _this.reobserve({
            fetchPolicy: "network-only"
          }, NetworkStatus.poll).then(poll, poll);
        } else {
          poll();
        }
      }
    };

    var poll = function poll() {
      var info = _this.pollingInfo;

      if (info) {
        clearTimeout(info.timeout);
        info.timeout = setTimeout(maybeFetch, info.interval);
      }
    };

    poll();
  };

  ObservableQuery.prototype.updateLastResult = function (newResult, variables) {
    if (variables === void 0) {
      variables = this.variables;
    }

    this.last = _assign$7(_assign$7({}, this.last), {
      result: this.queryManager.assumeImmutableResults ? newResult : cloneDeep(newResult),
      variables: variables
    });

    if (!isNonEmptyArray(newResult.errors)) {
      delete this.last.error;
    }

    return this.last;
  };

  ObservableQuery.prototype.reobserve = function (newOptions, newNetworkStatus) {
    var _this = this;

    this.isTornDown = false;
    var useDisposableConcast = newNetworkStatus === NetworkStatus.refetch || newNetworkStatus === NetworkStatus.fetchMore || newNetworkStatus === NetworkStatus.poll;
    var oldVariables = this.options.variables;
    var options = useDisposableConcast ? compact(this.options, newOptions) : assign$1(this.options, compact(newOptions));

    if (!useDisposableConcast) {
      this.updatePolling();

      if (newOptions && newOptions.variables && !newOptions.fetchPolicy && !equal(newOptions.variables, oldVariables)) {
        options.fetchPolicy = this.initialFetchPolicy;

        if (newNetworkStatus === void 0) {
          newNetworkStatus = NetworkStatus.setVariables;
        }
      }
    }

    var variables = options.variables && _assign$7({}, options.variables);

    var concast = this.fetch(options, newNetworkStatus);
    var observer = {
      next: function next(result) {
        _this.reportResult(result, variables);
      },
      error: function error(_error4) {
        _this.reportError(_error4, variables);
      }
    };

    if (!useDisposableConcast) {
      if (this.concast && this.observer) {
        this.concast.removeObserver(this.observer, true);
      }

      this.concast = concast;
      this.observer = observer;
    }

    concast.addObserver(observer);
    return concast.promise;
  };

  ObservableQuery.prototype.observe = function () {
    this.reportResult(this.getCurrentResult(false), this.variables);
  };

  ObservableQuery.prototype.reportResult = function (result, variables) {
    var lastError = this.getLastError();

    if (lastError || this.isDifferentFromLastResult(result)) {
      if (lastError || !result.partial || this.options.returnPartialData) {
        this.updateLastResult(result, variables);
      }

      iterateObserversSafely(this.observers, 'next', result);
    }
  };

  ObservableQuery.prototype.reportError = function (error, variables) {
    var errorResult = _assign$7(_assign$7({}, this.getLastResult()), {
      error: error,
      errors: error.graphQLErrors,
      networkStatus: NetworkStatus.error,
      loading: false
    });

    this.updateLastResult(errorResult, variables);
    iterateObserversSafely(this.observers, 'error', this.last.error = error);
  };

  ObservableQuery.prototype.hasObservers = function () {
    return this.observers.size > 0;
  };

  ObservableQuery.prototype.tearDownQuery = function () {
    if (this.isTornDown) return;

    if (this.concast && this.observer) {
      this.concast.removeObserver(this.observer);
      delete this.concast;
      delete this.observer;
    }

    this.stopPolling();
    this.subscriptions.forEach(function (sub) {
      return sub.unsubscribe();
    });
    this.subscriptions.clear();
    this.queryManager.stopQuery(this.queryId);
    this.observers.clear();
    this.isTornDown = true;
  };

  return ObservableQuery;
}(Observable);

fixObservableSubclass(ObservableQuery);

function defaultSubscriptionObserverErrorCallback(error) {
  __DEV__ && invariant.error('Unhandled error', error.message, error.stack);
}

function logMissingFieldErrors(missing) {
  if (__DEV__ && missing) {
    __DEV__ && invariant.debug("Missing cache result fields: ".concat(JSON.stringify(missing)), missing);
  }
}

function applyNextFetchPolicy(options) {
  var _a = options.fetchPolicy,
      fetchPolicy = _a === void 0 ? "cache-first" : _a,
      nextFetchPolicy = options.nextFetchPolicy;

  if (nextFetchPolicy) {
    options.fetchPolicy = typeof nextFetchPolicy === "function" ? nextFetchPolicy.call(options, fetchPolicy) : nextFetchPolicy;
  }
}

var LocalState = function () {
  function LocalState(_a) {
    var cache = _a.cache,
        client = _a.client,
        resolvers = _a.resolvers,
        fragmentMatcher = _a.fragmentMatcher;
    this.cache = cache;

    if (client) {
      this.client = client;
    }

    if (resolvers) {
      this.addResolvers(resolvers);
    }

    if (fragmentMatcher) {
      this.setFragmentMatcher(fragmentMatcher);
    }
  }

  LocalState.prototype.addResolvers = function (resolvers) {
    var _this = this;

    this.resolvers = this.resolvers || {};

    if (Array.isArray(resolvers)) {
      resolvers.forEach(function (resolverGroup) {
        _this.resolvers = mergeDeep(_this.resolvers, resolverGroup);
      });
    } else {
      this.resolvers = mergeDeep(this.resolvers, resolvers);
    }
  };

  LocalState.prototype.setResolvers = function (resolvers) {
    this.resolvers = {};
    this.addResolvers(resolvers);
  };

  LocalState.prototype.getResolvers = function () {
    return this.resolvers || {};
  };

  LocalState.prototype.runResolvers = function (_a) {
    var document = _a.document,
        remoteResult = _a.remoteResult,
        context = _a.context,
        variables = _a.variables,
        _b = _a.onlyRunForcedResolvers,
        onlyRunForcedResolvers = _b === void 0 ? false : _b;
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_c) {
        if (document) {
          return [2, this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function (localResult) {
            return _assign$7(_assign$7({}, remoteResult), {
              data: localResult.result
            });
          })];
        }

        return [2, remoteResult];
      });
    });
  };

  LocalState.prototype.setFragmentMatcher = function (fragmentMatcher) {
    this.fragmentMatcher = fragmentMatcher;
  };

  LocalState.prototype.getFragmentMatcher = function () {
    return this.fragmentMatcher;
  };

  LocalState.prototype.clientQuery = function (document) {
    if (hasDirectives(['client'], document)) {
      if (this.resolvers) {
        return document;
      }
    }

    return null;
  };

  LocalState.prototype.serverQuery = function (document) {
    return removeClientSetsFromDocument(document);
  };

  LocalState.prototype.prepareContext = function (context) {
    var cache = this.cache;
    return _assign$7(_assign$7({}, context), {
      cache: cache,
      getCacheKey: function getCacheKey(obj) {
        return cache.identify(obj);
      }
    });
  };

  LocalState.prototype.addExportedVariables = function (document, variables, context) {
    if (variables === void 0) {
      variables = {};
    }

    if (context === void 0) {
      context = {};
    }

    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (document) {
          return [2, this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function (data) {
            return _assign$7(_assign$7({}, variables), data.exportedVariables);
          })];
        }

        return [2, _assign$7({}, variables)];
      });
    });
  };

  LocalState.prototype.shouldForceResolvers = function (document) {
    var forceResolvers = false;
    visit(document, {
      Directive: {
        enter: function enter(node) {
          if (node.name.value === 'client' && node.arguments) {
            forceResolvers = node.arguments.some(function (arg) {
              return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
            });

            if (forceResolvers) {
              return BREAK;
            }
          }
        }
      }
    });
    return forceResolvers;
  };

  LocalState.prototype.buildRootValueFromCache = function (document, variables) {
    return this.cache.diff({
      query: buildQueryFromSelectionSet(document),
      variables: variables,
      returnPartialData: true,
      optimistic: false
    }).result;
  };

  LocalState.prototype.resolveDocument = function (document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
    if (context === void 0) {
      context = {};
    }

    if (variables === void 0) {
      variables = {};
    }

    if (fragmentMatcher === void 0) {
      fragmentMatcher = function fragmentMatcher() {
        return true;
      };
    }

    if (onlyRunForcedResolvers === void 0) {
      onlyRunForcedResolvers = false;
    }

    return __awaiter(this, void 0, void 0, function () {
      var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;

      return __generator(this, function (_b) {
        mainDefinition = getMainDefinition(document);
        fragments = getFragmentDefinitions(document);
        fragmentMap = createFragmentMap(fragments);
        definitionOperation = mainDefinition.operation;
        defaultOperationType = definitionOperation ? definitionOperation.charAt(0).toUpperCase() + definitionOperation.slice(1) : 'Query';
        _a = this, cache = _a.cache, client = _a.client;
        execContext = {
          fragmentMap: fragmentMap,
          context: _assign$7(_assign$7({}, context), {
            cache: cache,
            client: client
          }),
          variables: variables,
          fragmentMatcher: fragmentMatcher,
          defaultOperationType: defaultOperationType,
          exportedVariables: {},
          onlyRunForcedResolvers: onlyRunForcedResolvers
        };
        return [2, this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function (result) {
          return {
            result: result,
            exportedVariables: execContext.exportedVariables
          };
        })];
      });
    });
  };

  LocalState.prototype.resolveSelectionSet = function (selectionSet, rootValue, execContext) {
    return __awaiter(this, void 0, void 0, function () {
      var fragmentMap, context, variables, resultsToMerge, execute;

      var _this = this;

      return __generator(this, function (_a) {
        fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
        resultsToMerge = [rootValue];

        execute = function execute(selection) {
          return __awaiter(_this, void 0, void 0, function () {
            var fragment, typeCondition;
            return __generator(this, function (_a) {
              if (!shouldInclude(selection, variables)) {
                return [2];
              }

              if (isField(selection)) {
                return [2, this.resolveField(selection, rootValue, execContext).then(function (fieldResult) {
                  var _a;

                  if (typeof fieldResult !== 'undefined') {
                    resultsToMerge.push((_a = {}, _a[resultKeyNameFromField(selection)] = fieldResult, _a));
                  }
                })];
              }

              if (isInlineFragment(selection)) {
                fragment = selection;
              } else {
                fragment = fragmentMap[selection.name.value];
                __DEV__ ? invariant(fragment, "No fragment named ".concat(selection.name.value)) : invariant(fragment, 9);
              }

              if (fragment && fragment.typeCondition) {
                typeCondition = fragment.typeCondition.name.value;

                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) {
                  return [2, this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function (fragmentResult) {
                    resultsToMerge.push(fragmentResult);
                  })];
                }
              }

              return [2];
            });
          });
        };

        return [2, Promise.all(selectionSet.selections.map(execute)).then(function () {
          return mergeDeepArray(resultsToMerge);
        })];
      });
    });
  };

  LocalState.prototype.resolveField = function (field, rootValue, execContext) {
    return __awaiter(this, void 0, void 0, function () {
      var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;

      var _this = this;

      return __generator(this, function (_a) {
        variables = execContext.variables;
        fieldName = field.name.value;
        aliasedFieldName = resultKeyNameFromField(field);
        aliasUsed = fieldName !== aliasedFieldName;
        defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
        resultPromise = Promise.resolve(defaultResult);

        if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
          resolverType = rootValue.__typename || execContext.defaultOperationType;
          resolverMap = this.resolvers && this.resolvers[resolverType];

          if (resolverMap) {
            resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];

            if (resolve) {
              resultPromise = Promise.resolve(cacheSlot.withValue(this.cache, resolve, [rootValue, argumentsObjectFromField(field, variables), execContext.context, {
                field: field,
                fragmentMap: execContext.fragmentMap
              }]));
            }
          }
        }

        return [2, resultPromise.then(function (result) {
          if (result === void 0) {
            result = defaultResult;
          }

          if (field.directives) {
            field.directives.forEach(function (directive) {
              if (directive.name.value === 'export' && directive.arguments) {
                directive.arguments.forEach(function (arg) {
                  if (arg.name.value === 'as' && arg.value.kind === 'StringValue') {
                    execContext.exportedVariables[arg.value.value] = result;
                  }
                });
              }
            });
          }

          if (!field.selectionSet) {
            return result;
          }

          if (result == null) {
            return result;
          }

          if (Array.isArray(result)) {
            return _this.resolveSubSelectedArray(field, result, execContext);
          }

          if (field.selectionSet) {
            return _this.resolveSelectionSet(field.selectionSet, result, execContext);
          }
        })];
      });
    });
  };

  LocalState.prototype.resolveSubSelectedArray = function (field, result, execContext) {
    var _this = this;

    return Promise.all(result.map(function (item) {
      if (item === null) {
        return null;
      }

      if (Array.isArray(item)) {
        return _this.resolveSubSelectedArray(field, item, execContext);
      }

      if (field.selectionSet) {
        return _this.resolveSelectionSet(field.selectionSet, item, execContext);
      }
    }));
  };

  return LocalState;
}();

var destructiveMethodCounts = new (canUseWeakMap ? WeakMap : Map)();

function wrapDestructiveCacheMethod(cache, methodName) {
  var original = cache[methodName];

  if (typeof original === "function") {
    cache[methodName] = function () {
      destructiveMethodCounts.set(cache, (destructiveMethodCounts.get(cache) + 1) % 1e15);
      return original.apply(this, arguments);
    };
  }
}

function cancelNotifyTimeout(info) {
  if (info["notifyTimeout"]) {
    clearTimeout(info["notifyTimeout"]);
    info["notifyTimeout"] = void 0;
  }
}

var QueryInfo = function () {
  function QueryInfo(queryManager, queryId) {
    if (queryId === void 0) {
      queryId = queryManager.generateQueryId();
    }

    this.queryId = queryId;
    this.listeners = new Set();
    this.document = null;
    this.lastRequestId = 1;
    this.subscriptions = new Set();
    this.stopped = false;
    this.dirty = false;
    this.observableQuery = null;
    var cache = this.cache = queryManager.cache;

    if (!destructiveMethodCounts.has(cache)) {
      destructiveMethodCounts.set(cache, 0);
      wrapDestructiveCacheMethod(cache, "evict");
      wrapDestructiveCacheMethod(cache, "modify");
      wrapDestructiveCacheMethod(cache, "reset");
    }
  }

  QueryInfo.prototype.init = function (query) {
    var networkStatus = query.networkStatus || NetworkStatus.loading;

    if (this.variables && this.networkStatus !== NetworkStatus.loading && !equal(this.variables, query.variables)) {
      networkStatus = NetworkStatus.setVariables;
    }

    if (!equal(query.variables, this.variables)) {
      this.lastDiff = void 0;
    }

    Object.assign(this, {
      document: query.document,
      variables: query.variables,
      networkError: null,
      graphQLErrors: this.graphQLErrors || [],
      networkStatus: networkStatus
    });

    if (query.observableQuery) {
      this.setObservableQuery(query.observableQuery);
    }

    if (query.lastRequestId) {
      this.lastRequestId = query.lastRequestId;
    }

    return this;
  };

  QueryInfo.prototype.reset = function () {
    cancelNotifyTimeout(this);
    this.lastDiff = void 0;
    this.dirty = false;
  };

  QueryInfo.prototype.getDiff = function (variables) {
    if (variables === void 0) {
      variables = this.variables;
    }

    var options = this.getDiffOptions(variables);

    if (this.lastDiff && equal(options, this.lastDiff.options)) {
      return this.lastDiff.diff;
    }

    this.updateWatch(this.variables = variables);
    var oq = this.observableQuery;

    if (oq && oq.options.fetchPolicy === "no-cache") {
      return {
        complete: false
      };
    }

    var diff = this.cache.diff(options);
    this.updateLastDiff(diff, options);
    return diff;
  };

  QueryInfo.prototype.updateLastDiff = function (diff, options) {
    this.lastDiff = diff ? {
      diff: diff,
      options: options || this.getDiffOptions()
    } : void 0;
  };

  QueryInfo.prototype.getDiffOptions = function (variables) {
    var _a;

    if (variables === void 0) {
      variables = this.variables;
    }

    return {
      query: this.document,
      variables: variables,
      returnPartialData: true,
      optimistic: true,
      canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults
    };
  };

  QueryInfo.prototype.setDiff = function (diff) {
    var _this = this;

    var oldDiff = this.lastDiff && this.lastDiff.diff;
    this.updateLastDiff(diff);

    if (!this.dirty && !equal(oldDiff && oldDiff.result, diff && diff.result)) {
      this.dirty = true;

      if (!this.notifyTimeout) {
        this.notifyTimeout = setTimeout(function () {
          return _this.notify();
        }, 0);
      }
    }
  };

  QueryInfo.prototype.setObservableQuery = function (oq) {
    var _this = this;

    if (oq === this.observableQuery) return;

    if (this.oqListener) {
      this.listeners.delete(this.oqListener);
    }

    this.observableQuery = oq;

    if (oq) {
      oq["queryInfo"] = this;
      this.listeners.add(this.oqListener = function () {
        if (_this.getDiff().fromOptimisticTransaction) {
          oq["observe"]();
        } else {
          oq.reobserve();
        }
      });
    } else {
      delete this.oqListener;
    }
  };

  QueryInfo.prototype.notify = function () {
    var _this = this;

    cancelNotifyTimeout(this);

    if (this.shouldNotify()) {
      this.listeners.forEach(function (listener) {
        return listener(_this);
      });
    }

    this.dirty = false;
  };

  QueryInfo.prototype.shouldNotify = function () {
    if (!this.dirty || !this.listeners.size) {
      return false;
    }

    if (isNetworkRequestInFlight(this.networkStatus) && this.observableQuery) {
      var fetchPolicy = this.observableQuery.options.fetchPolicy;

      if (fetchPolicy !== "cache-only" && fetchPolicy !== "cache-and-network") {
        return false;
      }
    }

    return true;
  };

  QueryInfo.prototype.stop = function () {
    if (!this.stopped) {
      this.stopped = true;
      this.reset();
      this.cancel();
      this.cancel = QueryInfo.prototype.cancel;
      this.subscriptions.forEach(function (sub) {
        return sub.unsubscribe();
      });
      var oq = this.observableQuery;
      if (oq) oq.stopPolling();
    }
  };

  QueryInfo.prototype.cancel = function () {};

  QueryInfo.prototype.updateWatch = function (variables) {
    var _this = this;

    if (variables === void 0) {
      variables = this.variables;
    }

    var oq = this.observableQuery;

    if (oq && oq.options.fetchPolicy === "no-cache") {
      return;
    }

    var watchOptions = _assign$7(_assign$7({}, this.getDiffOptions(variables)), {
      watcher: this,
      callback: function callback(diff) {
        return _this.setDiff(diff);
      }
    });

    if (!this.lastWatch || !equal(watchOptions, this.lastWatch)) {
      this.cancel();
      this.cancel = this.cache.watch(this.lastWatch = watchOptions);
    }
  };

  QueryInfo.prototype.resetLastWrite = function () {
    this.lastWrite = void 0;
  };

  QueryInfo.prototype.shouldWrite = function (result, variables) {
    var lastWrite = this.lastWrite;
    return !(lastWrite && lastWrite.dmCount === destructiveMethodCounts.get(this.cache) && equal(variables, lastWrite.variables) && equal(result.data, lastWrite.result.data));
  };

  QueryInfo.prototype.markResult = function (result, options, cacheWriteBehavior) {
    var _this = this;

    this.graphQLErrors = isNonEmptyArray(result.errors) ? result.errors : [];
    this.reset();

    if (options.fetchPolicy === 'no-cache') {
      this.updateLastDiff({
        result: result.data,
        complete: true
      }, this.getDiffOptions(options.variables));
    } else if (cacheWriteBehavior !== 0) {
      if (shouldWriteResult(result, options.errorPolicy)) {
        this.cache.performTransaction(function (cache) {
          if (_this.shouldWrite(result, options.variables)) {
            cache.writeQuery({
              query: _this.document,
              data: result.data,
              variables: options.variables,
              overwrite: cacheWriteBehavior === 1
            });
            _this.lastWrite = {
              result: result,
              variables: options.variables,
              dmCount: destructiveMethodCounts.get(_this.cache)
            };
          } else {
            if (_this.lastDiff && _this.lastDiff.diff.complete) {
              result.data = _this.lastDiff.diff.result;
              return;
            }
          }

          var diffOptions = _this.getDiffOptions(options.variables);

          var diff = cache.diff(diffOptions);

          if (!_this.stopped) {
            _this.updateWatch(options.variables);
          }

          _this.updateLastDiff(diff, diffOptions);

          if (diff.complete) {
            result.data = diff.result;
          }
        });
      } else {
        this.lastWrite = void 0;
      }
    }
  };

  QueryInfo.prototype.markReady = function () {
    this.networkError = null;
    return this.networkStatus = NetworkStatus.ready;
  };

  QueryInfo.prototype.markError = function (error) {
    this.networkStatus = NetworkStatus.error;
    this.lastWrite = void 0;
    this.reset();

    if (error.graphQLErrors) {
      this.graphQLErrors = error.graphQLErrors;
    }

    if (error.networkError) {
      this.networkError = error.networkError;
    }

    return error;
  };

  return QueryInfo;
}();

function shouldWriteResult(result, errorPolicy) {
  if (errorPolicy === void 0) {
    errorPolicy = "none";
  }

  var ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
  var writeWithErrors = !graphQLResultHasError(result);

  if (!writeWithErrors && ignoreErrors && result.data) {
    writeWithErrors = true;
  }

  return writeWithErrors;
}

var hasOwnProperty$b = Object.prototype.hasOwnProperty;

var QueryManager = function () {
  function QueryManager(_a) {
    var cache = _a.cache,
        link = _a.link,
        _b = _a.queryDeduplication,
        queryDeduplication = _b === void 0 ? false : _b,
        onBroadcast = _a.onBroadcast,
        _c = _a.ssrMode,
        ssrMode = _c === void 0 ? false : _c,
        _d = _a.clientAwareness,
        clientAwareness = _d === void 0 ? {} : _d,
        localState = _a.localState,
        assumeImmutableResults = _a.assumeImmutableResults;
    this.clientAwareness = {};
    this.queries = new Map();
    this.fetchCancelFns = new Map();
    this.transformCache = new (canUseWeakMap ? WeakMap : Map)();
    this.queryIdCounter = 1;
    this.requestIdCounter = 1;
    this.mutationIdCounter = 1;
    this.inFlightLinkObservables = new Map();
    this.cache = cache;
    this.link = link;
    this.queryDeduplication = queryDeduplication;
    this.clientAwareness = clientAwareness;
    this.localState = localState || new LocalState({
      cache: cache
    });
    this.ssrMode = ssrMode;
    this.assumeImmutableResults = !!assumeImmutableResults;

    if (this.onBroadcast = onBroadcast) {
      this.mutationStore = Object.create(null);
    }
  }

  QueryManager.prototype.stop = function () {
    var _this = this;

    this.queries.forEach(function (_info, queryId) {
      _this.stopQueryNoBroadcast(queryId);
    });
    this.cancelPendingFetches(__DEV__ ? new InvariantError('QueryManager stopped while query was in flight') : new InvariantError(11));
  };

  QueryManager.prototype.cancelPendingFetches = function (error) {
    this.fetchCancelFns.forEach(function (cancel) {
      return cancel(error);
    });
    this.fetchCancelFns.clear();
  };

  QueryManager.prototype.mutate = function (_a) {
    var mutation = _a.mutation,
        variables = _a.variables,
        optimisticResponse = _a.optimisticResponse,
        updateQueries = _a.updateQueries,
        _b = _a.refetchQueries,
        refetchQueries = _b === void 0 ? [] : _b,
        _c = _a.awaitRefetchQueries,
        awaitRefetchQueries = _c === void 0 ? false : _c,
        updateWithProxyFn = _a.update,
        onQueryUpdated = _a.onQueryUpdated,
        _d = _a.errorPolicy,
        errorPolicy = _d === void 0 ? 'none' : _d,
        _e = _a.fetchPolicy,
        fetchPolicy = _e === void 0 ? 'network-only' : _e,
        keepRootFields = _a.keepRootFields,
        context = _a.context;
    return __awaiter(this, void 0, void 0, function () {
      var mutationId, mutationStoreValue, self;
      return __generator(this, function (_f) {
        switch (_f.label) {
          case 0:
            __DEV__ ? invariant(mutation, 'mutation option is required. You must specify your GraphQL document in the mutation option.') : invariant(mutation, 12);
            __DEV__ ? invariant(fetchPolicy === 'network-only' || fetchPolicy === 'no-cache', "Mutations support only 'network-only' or 'no-cache' fetchPolicy strings. The default `network-only` behavior automatically writes mutation results to the cache. Passing `no-cache` skips the cache write.") : invariant(fetchPolicy === 'network-only' || fetchPolicy === 'no-cache', 13);
            mutationId = this.generateMutationId();
            mutation = this.transform(mutation).document;
            variables = this.getVariables(mutation, variables);
            if (!this.transform(mutation).hasClientExports) return [3, 2];
            return [4, this.localState.addExportedVariables(mutation, variables, context)];

          case 1:
            variables = _f.sent();
            _f.label = 2;

          case 2:
            mutationStoreValue = this.mutationStore && (this.mutationStore[mutationId] = {
              mutation: mutation,
              variables: variables,
              loading: true,
              error: null
            });

            if (optimisticResponse) {
              this.markMutationOptimistic(optimisticResponse, {
                mutationId: mutationId,
                document: mutation,
                variables: variables,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy,
                context: context,
                updateQueries: updateQueries,
                update: updateWithProxyFn,
                keepRootFields: keepRootFields
              });
            }

            this.broadcastQueries();
            self = this;
            return [2, new Promise(function (resolve, reject) {
              return asyncMap(self.getObservableFromLink(mutation, _assign$7(_assign$7({}, context), {
                optimisticResponse: optimisticResponse
              }), variables, false), function (result) {
                if (graphQLResultHasError(result) && errorPolicy === 'none') {
                  throw new ApolloError({
                    graphQLErrors: result.errors
                  });
                }

                if (mutationStoreValue) {
                  mutationStoreValue.loading = false;
                  mutationStoreValue.error = null;
                }

                var storeResult = _assign$7({}, result);

                if (typeof refetchQueries === "function") {
                  refetchQueries = refetchQueries(storeResult);
                }

                if (errorPolicy === 'ignore' && graphQLResultHasError(storeResult)) {
                  delete storeResult.errors;
                }

                return self.markMutationResult({
                  mutationId: mutationId,
                  result: storeResult,
                  document: mutation,
                  variables: variables,
                  fetchPolicy: fetchPolicy,
                  errorPolicy: errorPolicy,
                  context: context,
                  update: updateWithProxyFn,
                  updateQueries: updateQueries,
                  awaitRefetchQueries: awaitRefetchQueries,
                  refetchQueries: refetchQueries,
                  removeOptimistic: optimisticResponse ? mutationId : void 0,
                  onQueryUpdated: onQueryUpdated,
                  keepRootFields: keepRootFields
                });
              }).subscribe({
                next: function next(storeResult) {
                  self.broadcastQueries();
                  resolve(storeResult);
                },
                error: function error(err) {
                  if (mutationStoreValue) {
                    mutationStoreValue.loading = false;
                    mutationStoreValue.error = err;
                  }

                  if (optimisticResponse) {
                    self.cache.removeOptimistic(mutationId);
                  }

                  self.broadcastQueries();
                  reject(err instanceof ApolloError ? err : new ApolloError({
                    networkError: err
                  }));
                }
              });
            })];
        }
      });
    });
  };

  QueryManager.prototype.markMutationResult = function (mutation, cache) {
    var _this = this;

    if (cache === void 0) {
      cache = this.cache;
    }

    var result = mutation.result;
    var cacheWrites = [];
    var skipCache = mutation.fetchPolicy === "no-cache";

    if (!skipCache && shouldWriteResult(result, mutation.errorPolicy)) {
      cacheWrites.push({
        result: result.data,
        dataId: 'ROOT_MUTATION',
        query: mutation.document,
        variables: mutation.variables
      });
      var updateQueries_1 = mutation.updateQueries;

      if (updateQueries_1) {
        this.queries.forEach(function (_a, queryId) {
          var observableQuery = _a.observableQuery;
          var queryName = observableQuery && observableQuery.queryName;

          if (!queryName || !hasOwnProperty$b.call(updateQueries_1, queryName)) {
            return;
          }

          var updater = updateQueries_1[queryName];

          var _b = _this.queries.get(queryId),
              document = _b.document,
              variables = _b.variables;

          var _c = cache.diff({
            query: document,
            variables: variables,
            returnPartialData: true,
            optimistic: false
          }),
              currentQueryResult = _c.result,
              complete = _c.complete;

          if (complete && currentQueryResult) {
            var nextQueryResult = updater(currentQueryResult, {
              mutationResult: result,
              queryName: document && getOperationName(document) || void 0,
              queryVariables: variables
            });

            if (nextQueryResult) {
              cacheWrites.push({
                result: nextQueryResult,
                dataId: 'ROOT_QUERY',
                query: document,
                variables: variables
              });
            }
          }
        });
      }
    }

    if (cacheWrites.length > 0 || mutation.refetchQueries || mutation.update || mutation.onQueryUpdated || mutation.removeOptimistic) {
      var results_1 = [];
      this.refetchQueries({
        updateCache: function updateCache(cache) {
          if (!skipCache) {
            cacheWrites.forEach(function (write) {
              return cache.write(write);
            });
          }

          var update = mutation.update;

          if (update) {
            if (!skipCache) {
              var diff = cache.diff({
                id: "ROOT_MUTATION",
                query: _this.transform(mutation.document).asQuery,
                variables: mutation.variables,
                optimistic: false,
                returnPartialData: true
              });

              if (diff.complete) {
                result = _assign$7(_assign$7({}, result), {
                  data: diff.result
                });
              }
            }

            update(cache, result, {
              context: mutation.context,
              variables: mutation.variables
            });
          }

          if (!skipCache && !mutation.keepRootFields) {
            cache.modify({
              id: 'ROOT_MUTATION',
              fields: function fields(value, _a) {
                var fieldName = _a.fieldName,
                    DELETE = _a.DELETE;
                return fieldName === "__typename" ? value : DELETE;
              }
            });
          }
        },
        include: mutation.refetchQueries,
        optimistic: false,
        removeOptimistic: mutation.removeOptimistic,
        onQueryUpdated: mutation.onQueryUpdated || null
      }).forEach(function (result) {
        return results_1.push(result);
      });

      if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) {
        return Promise.all(results_1).then(function () {
          return result;
        });
      }
    }

    return Promise.resolve(result);
  };

  QueryManager.prototype.markMutationOptimistic = function (optimisticResponse, mutation) {
    var _this = this;

    var data = typeof optimisticResponse === "function" ? optimisticResponse(mutation.variables) : optimisticResponse;
    return this.cache.recordOptimisticTransaction(function (cache) {
      try {
        _this.markMutationResult(_assign$7(_assign$7({}, mutation), {
          result: {
            data: data
          }
        }), cache);
      } catch (error) {
        __DEV__ && invariant.error(error);
      }
    }, mutation.mutationId);
  };

  QueryManager.prototype.fetchQuery = function (queryId, options, networkStatus) {
    return this.fetchQueryObservable(queryId, options, networkStatus).promise;
  };

  QueryManager.prototype.getQueryStore = function () {
    var store = Object.create(null);
    this.queries.forEach(function (info, queryId) {
      store[queryId] = {
        variables: info.variables,
        networkStatus: info.networkStatus,
        networkError: info.networkError,
        graphQLErrors: info.graphQLErrors
      };
    });
    return store;
  };

  QueryManager.prototype.resetErrors = function (queryId) {
    var queryInfo = this.queries.get(queryId);

    if (queryInfo) {
      queryInfo.networkError = undefined;
      queryInfo.graphQLErrors = [];
    }
  };

  QueryManager.prototype.transform = function (document) {
    var transformCache = this.transformCache;

    if (!transformCache.has(document)) {
      var transformed = this.cache.transformDocument(document);
      var forLink = removeConnectionDirectiveFromDocument(this.cache.transformForLink(transformed));
      var clientQuery = this.localState.clientQuery(transformed);
      var serverQuery = forLink && this.localState.serverQuery(forLink);
      var cacheEntry_1 = {
        document: transformed,
        hasClientExports: hasClientExports(transformed),
        hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
        clientQuery: clientQuery,
        serverQuery: serverQuery,
        defaultVars: getDefaultValues(getOperationDefinition(transformed)),
        asQuery: _assign$7(_assign$7({}, transformed), {
          definitions: transformed.definitions.map(function (def) {
            if (def.kind === "OperationDefinition" && def.operation !== "query") {
              return _assign$7(_assign$7({}, def), {
                operation: "query"
              });
            }

            return def;
          })
        })
      };

      var add = function add(doc) {
        if (doc && !transformCache.has(doc)) {
          transformCache.set(doc, cacheEntry_1);
        }
      };

      add(document);
      add(transformed);
      add(clientQuery);
      add(serverQuery);
    }

    return transformCache.get(document);
  };

  QueryManager.prototype.getVariables = function (document, variables) {
    return _assign$7(_assign$7({}, this.transform(document).defaultVars), variables);
  };

  QueryManager.prototype.watchQuery = function (options) {
    options = _assign$7(_assign$7({}, options), {
      variables: this.getVariables(options.query, options.variables)
    });

    if (typeof options.notifyOnNetworkStatusChange === 'undefined') {
      options.notifyOnNetworkStatusChange = false;
    }

    var queryInfo = new QueryInfo(this);
    var observable = new ObservableQuery({
      queryManager: this,
      queryInfo: queryInfo,
      options: options
    });
    this.queries.set(observable.queryId, queryInfo);
    queryInfo.init({
      document: options.query,
      observableQuery: observable,
      variables: options.variables
    });
    return observable;
  };

  QueryManager.prototype.query = function (options, queryId) {
    var _this = this;

    if (queryId === void 0) {
      queryId = this.generateQueryId();
    }

    __DEV__ ? invariant(options.query, 'query option is required. You must specify your GraphQL document ' + 'in the query option.') : invariant(options.query, 14);
    __DEV__ ? invariant(options.query.kind === 'Document', 'You must wrap the query string in a "gql" tag.') : invariant(options.query.kind === 'Document', 15);
    __DEV__ ? invariant(!options.returnPartialData, 'returnPartialData option only supported on watchQuery.') : invariant(!options.returnPartialData, 16);
    __DEV__ ? invariant(!options.pollInterval, 'pollInterval option only supported on watchQuery.') : invariant(!options.pollInterval, 17);
    return this.fetchQuery(queryId, options).finally(function () {
      return _this.stopQuery(queryId);
    });
  };

  QueryManager.prototype.generateQueryId = function () {
    return String(this.queryIdCounter++);
  };

  QueryManager.prototype.generateRequestId = function () {
    return this.requestIdCounter++;
  };

  QueryManager.prototype.generateMutationId = function () {
    return String(this.mutationIdCounter++);
  };

  QueryManager.prototype.stopQueryInStore = function (queryId) {
    this.stopQueryInStoreNoBroadcast(queryId);
    this.broadcastQueries();
  };

  QueryManager.prototype.stopQueryInStoreNoBroadcast = function (queryId) {
    var queryInfo = this.queries.get(queryId);
    if (queryInfo) queryInfo.stop();
  };

  QueryManager.prototype.clearStore = function (options) {
    if (options === void 0) {
      options = {
        discardWatches: true
      };
    }

    this.cancelPendingFetches(__DEV__ ? new InvariantError('Store reset while query was in flight (not completed in link chain)') : new InvariantError(18));
    this.queries.forEach(function (queryInfo) {
      if (queryInfo.observableQuery) {
        queryInfo.networkStatus = NetworkStatus.loading;
      } else {
        queryInfo.stop();
      }
    });

    if (this.mutationStore) {
      this.mutationStore = Object.create(null);
    }

    return this.cache.reset(options);
  };

  QueryManager.prototype.getObservableQueries = function (include) {
    var _this = this;

    if (include === void 0) {
      include = "active";
    }

    var queries = new Map();
    var queryNamesAndDocs = new Map();
    var legacyQueryOptions = new Set();

    if (Array.isArray(include)) {
      include.forEach(function (desc) {
        if (typeof desc === "string") {
          queryNamesAndDocs.set(desc, false);
        } else if (isDocumentNode(desc)) {
          queryNamesAndDocs.set(_this.transform(desc).document, false);
        } else if (isNonNullObject$1(desc) && desc.query) {
          legacyQueryOptions.add(desc);
        }
      });
    }

    this.queries.forEach(function (_a, queryId) {
      var oq = _a.observableQuery,
          document = _a.document;

      if (oq) {
        if (include === "all") {
          queries.set(queryId, oq);
          return;
        }

        var queryName = oq.queryName,
            fetchPolicy = oq.options.fetchPolicy;

        if (fetchPolicy === "standby" || include === "active" && !oq.hasObservers()) {
          return;
        }

        if (include === "active" || queryName && queryNamesAndDocs.has(queryName) || document && queryNamesAndDocs.has(document)) {
          queries.set(queryId, oq);
          if (queryName) queryNamesAndDocs.set(queryName, true);
          if (document) queryNamesAndDocs.set(document, true);
        }
      }
    });

    if (legacyQueryOptions.size) {
      legacyQueryOptions.forEach(function (options) {
        var queryId = makeUniqueId("legacyOneTimeQuery");

        var queryInfo = _this.getQuery(queryId).init({
          document: options.query,
          variables: options.variables
        });

        var oq = new ObservableQuery({
          queryManager: _this,
          queryInfo: queryInfo,
          options: _assign$7(_assign$7({}, options), {
            fetchPolicy: "network-only"
          })
        });
        invariant(oq.queryId === queryId);
        queryInfo.setObservableQuery(oq);
        queries.set(queryId, oq);
      });
    }

    if (__DEV__ && queryNamesAndDocs.size) {
      queryNamesAndDocs.forEach(function (included, nameOrDoc) {
        if (!included) {
          __DEV__ && invariant.warn("Unknown query ".concat(typeof nameOrDoc === "string" ? "named " : "").concat(JSON.stringify(nameOrDoc, null, 2), " requested in refetchQueries options.include array"));
        }
      });
    }

    return queries;
  };

  QueryManager.prototype.reFetchObservableQueries = function (includeStandby) {
    var _this = this;

    if (includeStandby === void 0) {
      includeStandby = false;
    }

    var observableQueryPromises = [];
    this.getObservableQueries(includeStandby ? "all" : "active").forEach(function (observableQuery, queryId) {
      var fetchPolicy = observableQuery.options.fetchPolicy;
      observableQuery.resetLastResults();

      if (includeStandby || fetchPolicy !== "standby" && fetchPolicy !== "cache-only") {
        observableQueryPromises.push(observableQuery.refetch());
      }

      _this.getQuery(queryId).setDiff(null);
    });
    this.broadcastQueries();
    return Promise.all(observableQueryPromises);
  };

  QueryManager.prototype.setObservableQuery = function (observableQuery) {
    this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
  };

  QueryManager.prototype.startGraphQLSubscription = function (_a) {
    var _this = this;

    var query = _a.query,
        fetchPolicy = _a.fetchPolicy,
        errorPolicy = _a.errorPolicy,
        variables = _a.variables,
        _b = _a.context,
        context = _b === void 0 ? {} : _b;
    query = this.transform(query).document;
    variables = this.getVariables(query, variables);

    var makeObservable = function makeObservable(variables) {
      return _this.getObservableFromLink(query, context, variables).map(function (result) {
        if (fetchPolicy !== 'no-cache') {
          if (shouldWriteResult(result, errorPolicy)) {
            _this.cache.write({
              query: query,
              result: result.data,
              dataId: 'ROOT_SUBSCRIPTION',
              variables: variables
            });
          }

          _this.broadcastQueries();
        }

        if (graphQLResultHasError(result)) {
          throw new ApolloError({
            graphQLErrors: result.errors
          });
        }

        return result;
      });
    };

    if (this.transform(query).hasClientExports) {
      var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
      return new Observable(function (observer) {
        var sub = null;
        observablePromise_1.then(function (observable) {
          return sub = observable.subscribe(observer);
        }, observer.error);
        return function () {
          return sub && sub.unsubscribe();
        };
      });
    }

    return makeObservable(variables);
  };

  QueryManager.prototype.stopQuery = function (queryId) {
    this.stopQueryNoBroadcast(queryId);
    this.broadcastQueries();
  };

  QueryManager.prototype.stopQueryNoBroadcast = function (queryId) {
    this.stopQueryInStoreNoBroadcast(queryId);
    this.removeQuery(queryId);
  };

  QueryManager.prototype.removeQuery = function (queryId) {
    this.fetchCancelFns.delete(queryId);
    this.getQuery(queryId).stop();
    this.queries.delete(queryId);
  };

  QueryManager.prototype.broadcastQueries = function () {
    if (this.onBroadcast) this.onBroadcast();
    this.queries.forEach(function (info) {
      return info.notify();
    });
  };

  QueryManager.prototype.getLocalState = function () {
    return this.localState;
  };

  QueryManager.prototype.getObservableFromLink = function (query, context, variables, deduplication) {
    var _this = this;

    var _a;

    if (deduplication === void 0) {
      deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication;
    }

    var observable;
    var serverQuery = this.transform(query).serverQuery;

    if (serverQuery) {
      var _b = this,
          inFlightLinkObservables_1 = _b.inFlightLinkObservables,
          link = _b.link;

      var operation = {
        query: serverQuery,
        variables: variables,
        operationName: getOperationName(serverQuery) || void 0,
        context: this.prepareContext(_assign$7(_assign$7({}, context), {
          forceFetch: !deduplication
        }))
      };
      context = operation.context;

      if (deduplication) {
        var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
        inFlightLinkObservables_1.set(serverQuery, byVariables_1);
        var varJson_1 = canonicalStringify(variables);
        observable = byVariables_1.get(varJson_1);

        if (!observable) {
          var concast = new Concast([execute(link, operation)]);
          byVariables_1.set(varJson_1, observable = concast);
          concast.cleanup(function () {
            if (byVariables_1.delete(varJson_1) && byVariables_1.size < 1) {
              inFlightLinkObservables_1.delete(serverQuery);
            }
          });
        }
      } else {
        observable = new Concast([execute(link, operation)]);
      }
    } else {
      observable = new Concast([Observable.of({
        data: {}
      })]);
      context = this.prepareContext(context);
    }

    var clientQuery = this.transform(query).clientQuery;

    if (clientQuery) {
      observable = asyncMap(observable, function (result) {
        return _this.localState.runResolvers({
          document: clientQuery,
          remoteResult: result,
          context: context,
          variables: variables
        });
      });
    }

    return observable;
  };

  QueryManager.prototype.getResultsFromLink = function (queryInfo, cacheWriteBehavior, options) {
    var requestId = queryInfo.lastRequestId = this.generateRequestId();
    return asyncMap(this.getObservableFromLink(queryInfo.document, options.context, options.variables), function (result) {
      var hasErrors = isNonEmptyArray(result.errors);

      if (requestId >= queryInfo.lastRequestId) {
        if (hasErrors && options.errorPolicy === "none") {
          throw queryInfo.markError(new ApolloError({
            graphQLErrors: result.errors
          }));
        }

        queryInfo.markResult(result, options, cacheWriteBehavior);
        queryInfo.markReady();
      }

      var aqr = {
        data: result.data,
        loading: false,
        networkStatus: queryInfo.networkStatus || NetworkStatus.ready
      };

      if (hasErrors && options.errorPolicy !== "ignore") {
        aqr.errors = result.errors;
      }

      return aqr;
    }, function (networkError) {
      var error = isApolloError(networkError) ? networkError : new ApolloError({
        networkError: networkError
      });

      if (requestId >= queryInfo.lastRequestId) {
        queryInfo.markError(error);
      }

      throw error;
    });
  };

  QueryManager.prototype.fetchQueryObservable = function (queryId, options, networkStatus) {
    var _this = this;

    if (networkStatus === void 0) {
      networkStatus = NetworkStatus.loading;
    }

    var query = this.transform(options.query).document;
    var variables = this.getVariables(query, options.variables);
    var queryInfo = this.getQuery(queryId);
    var _a = options.fetchPolicy,
        fetchPolicy = _a === void 0 ? "cache-first" : _a,
        _b = options.errorPolicy,
        errorPolicy = _b === void 0 ? "none" : _b,
        _c = options.returnPartialData,
        returnPartialData = _c === void 0 ? false : _c,
        _d = options.notifyOnNetworkStatusChange,
        notifyOnNetworkStatusChange = _d === void 0 ? false : _d,
        _e = options.context,
        context = _e === void 0 ? {} : _e;
    var normalized = Object.assign({}, options, {
      query: query,
      variables: variables,
      fetchPolicy: fetchPolicy,
      errorPolicy: errorPolicy,
      returnPartialData: returnPartialData,
      notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
      context: context
    });

    var fromVariables = function fromVariables(variables) {
      normalized.variables = variables;
      return _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
    };

    this.fetchCancelFns.set(queryId, function (reason) {
      setTimeout(function () {
        return concast.cancel(reason);
      });
    });
    var concast = new Concast(this.transform(normalized.query).hasClientExports ? this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables) : fromVariables(normalized.variables));
    concast.cleanup(function () {
      _this.fetchCancelFns.delete(queryId);

      applyNextFetchPolicy(options);
    });
    return concast;
  };

  QueryManager.prototype.refetchQueries = function (_a) {
    var _this = this;

    var updateCache = _a.updateCache,
        include = _a.include,
        _b = _a.optimistic,
        optimistic = _b === void 0 ? false : _b,
        _c = _a.removeOptimistic,
        removeOptimistic = _c === void 0 ? optimistic ? makeUniqueId("refetchQueries") : void 0 : _c,
        onQueryUpdated = _a.onQueryUpdated;
    var includedQueriesById = new Map();

    if (include) {
      this.getObservableQueries(include).forEach(function (oq, queryId) {
        includedQueriesById.set(queryId, {
          oq: oq,
          lastDiff: _this.getQuery(queryId).getDiff()
        });
      });
    }

    var results = new Map();

    if (updateCache) {
      this.cache.batch({
        update: updateCache,
        optimistic: optimistic && removeOptimistic || false,
        removeOptimistic: removeOptimistic,
        onWatchUpdated: function onWatchUpdated(watch, diff, lastDiff) {
          var oq = watch.watcher instanceof QueryInfo && watch.watcher.observableQuery;

          if (oq) {
            if (onQueryUpdated) {
              includedQueriesById.delete(oq.queryId);
              var result = onQueryUpdated(oq, diff, lastDiff);

              if (result === true) {
                result = oq.refetch();
              }

              if (result !== false) {
                results.set(oq, result);
              }

              return result;
            }

            if (onQueryUpdated !== null) {
              includedQueriesById.set(oq.queryId, {
                oq: oq,
                lastDiff: lastDiff,
                diff: diff
              });
            }
          }
        }
      });
    }

    if (includedQueriesById.size) {
      includedQueriesById.forEach(function (_a, queryId) {
        var oq = _a.oq,
            lastDiff = _a.lastDiff,
            diff = _a.diff;
        var result;

        if (onQueryUpdated) {
          if (!diff) {
            var info = oq["queryInfo"];
            info.reset();
            diff = info.getDiff();
          }

          result = onQueryUpdated(oq, diff, lastDiff);
        }

        if (!onQueryUpdated || result === true) {
          result = oq.refetch();
        }

        if (result !== false) {
          results.set(oq, result);
        }

        if (queryId.indexOf("legacyOneTimeQuery") >= 0) {
          _this.stopQueryNoBroadcast(queryId);
        }
      });
    }

    if (removeOptimistic) {
      this.cache.removeOptimistic(removeOptimistic);
    }

    return results;
  };

  QueryManager.prototype.fetchQueryByPolicy = function (queryInfo, _a, networkStatus) {
    var _this = this;

    var query = _a.query,
        variables = _a.variables,
        fetchPolicy = _a.fetchPolicy,
        refetchWritePolicy = _a.refetchWritePolicy,
        errorPolicy = _a.errorPolicy,
        returnPartialData = _a.returnPartialData,
        context = _a.context,
        notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
    var oldNetworkStatus = queryInfo.networkStatus;
    queryInfo.init({
      document: query,
      variables: variables,
      networkStatus: networkStatus
    });

    var readCache = function readCache() {
      return queryInfo.getDiff(variables);
    };

    var resultsFromCache = function resultsFromCache(diff, networkStatus) {
      if (networkStatus === void 0) {
        networkStatus = queryInfo.networkStatus || NetworkStatus.loading;
      }

      var data = diff.result;

      if (__DEV__ && !returnPartialData && !equal(data, {})) {
        logMissingFieldErrors(diff.missing);
      }

      var fromData = function fromData(data) {
        return Observable.of(_assign$7({
          data: data,
          loading: isNetworkRequestInFlight(networkStatus),
          networkStatus: networkStatus
        }, diff.complete ? null : {
          partial: true
        }));
      };

      if (data && _this.transform(query).hasForcedResolvers) {
        return _this.localState.runResolvers({
          document: query,
          remoteResult: {
            data: data
          },
          context: context,
          variables: variables,
          onlyRunForcedResolvers: true
        }).then(function (resolved) {
          return fromData(resolved.data || void 0);
        });
      }

      return fromData(data);
    };

    var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 : networkStatus === NetworkStatus.refetch && refetchWritePolicy !== "merge" ? 1 : 2;

    var resultsFromLink = function resultsFromLink() {
      return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
        variables: variables,
        context: context,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy
      });
    };

    var shouldNotify = notifyOnNetworkStatusChange && typeof oldNetworkStatus === "number" && oldNetworkStatus !== networkStatus && isNetworkRequestInFlight(networkStatus);

    switch (fetchPolicy) {
      default:
      case "cache-first":
        {
          var diff = readCache();

          if (diff.complete) {
            return [resultsFromCache(diff, queryInfo.markReady())];
          }

          if (returnPartialData || shouldNotify) {
            return [resultsFromCache(diff), resultsFromLink()];
          }

          return [resultsFromLink()];
        }

      case "cache-and-network":
        {
          var diff = readCache();

          if (diff.complete || returnPartialData || shouldNotify) {
            return [resultsFromCache(diff), resultsFromLink()];
          }

          return [resultsFromLink()];
        }

      case "cache-only":
        return [resultsFromCache(readCache(), queryInfo.markReady())];

      case "network-only":
        if (shouldNotify) {
          return [resultsFromCache(readCache()), resultsFromLink()];
        }

        return [resultsFromLink()];

      case "no-cache":
        if (shouldNotify) {
          return [resultsFromCache(queryInfo.getDiff()), resultsFromLink()];
        }

        return [resultsFromLink()];

      case "standby":
        return [];
    }
  };

  QueryManager.prototype.getQuery = function (queryId) {
    if (queryId && !this.queries.has(queryId)) {
      this.queries.set(queryId, new QueryInfo(this, queryId));
    }

    return this.queries.get(queryId);
  };

  QueryManager.prototype.prepareContext = function (context) {
    if (context === void 0) {
      context = {};
    }

    var newContext = this.localState.prepareContext(context);
    return _assign$7(_assign$7({}, newContext), {
      clientAwareness: this.clientAwareness
    });
  };

  return QueryManager;
}();

var hasSuggestedDevtools = false;

function mergeOptions(defaults, options) {
  return compact(defaults, options, options.variables && {
    variables: _assign$7(_assign$7({}, defaults.variables), options.variables)
  });
}

var ApolloClient = function () {
  function ApolloClient(options) {
    var _this = this;

    this.defaultOptions = {};
    this.resetStoreCallbacks = [];
    this.clearStoreCallbacks = [];
    var uri = options.uri,
        credentials = options.credentials,
        headers = options.headers,
        cache = options.cache,
        _a = options.ssrMode,
        ssrMode = _a === void 0 ? false : _a,
        _b = options.ssrForceFetchDelay,
        ssrForceFetchDelay = _b === void 0 ? 0 : _b,
        _c = options.connectToDevTools,
        connectToDevTools = _c === void 0 ? typeof window === 'object' && !window.__APOLLO_CLIENT__ && __DEV__ : _c,
        _d = options.queryDeduplication,
        queryDeduplication = _d === void 0 ? true : _d,
        defaultOptions = options.defaultOptions,
        _e = options.assumeImmutableResults,
        assumeImmutableResults = _e === void 0 ? false : _e,
        resolvers = options.resolvers,
        typeDefs = options.typeDefs,
        fragmentMatcher = options.fragmentMatcher,
        clientAwarenessName = options.name,
        clientAwarenessVersion = options.version;
    var link = options.link;

    if (!link) {
      link = uri ? new HttpLink({
        uri: uri,
        credentials: credentials,
        headers: headers
      }) : ApolloLink.empty();
    }

    if (!cache) {
      throw __DEV__ ? new InvariantError("To initialize Apollo Client, you must specify a 'cache' property " + "in the options object. \n" + "For more information, please visit: https://go.apollo.dev/c/docs") : new InvariantError(7);
    }

    this.link = link;
    this.cache = cache;
    this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
    this.queryDeduplication = queryDeduplication;
    this.defaultOptions = defaultOptions || {};
    this.typeDefs = typeDefs;

    if (ssrForceFetchDelay) {
      setTimeout(function () {
        return _this.disableNetworkFetches = false;
      }, ssrForceFetchDelay);
    }

    this.watchQuery = this.watchQuery.bind(this);
    this.query = this.query.bind(this);
    this.mutate = this.mutate.bind(this);
    this.resetStore = this.resetStore.bind(this);
    this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);

    if (connectToDevTools && typeof window === 'object') {
      window.__APOLLO_CLIENT__ = this;
    }

    if (!hasSuggestedDevtools && __DEV__) {
      hasSuggestedDevtools = true;

      if (typeof window !== 'undefined' && window.document && window.top === window.self && !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
        var nav = window.navigator;
        var ua = nav && nav.userAgent;
        var url = void 0;

        if (typeof ua === "string") {
          if (ua.indexOf("Chrome/") > -1) {
            url = "https://chrome.google.com/webstore/detail/" + "apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
          } else if (ua.indexOf("Firefox/") > -1) {
            url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
          }
        }

        if (url) {
          __DEV__ && invariant.log("Download the Apollo DevTools for a better development " + "experience: " + url);
        }
      }
    }

    this.version = version$1;
    this.localState = new LocalState({
      cache: cache,
      client: this,
      resolvers: resolvers,
      fragmentMatcher: fragmentMatcher
    });
    this.queryManager = new QueryManager({
      cache: this.cache,
      link: this.link,
      queryDeduplication: queryDeduplication,
      ssrMode: ssrMode,
      clientAwareness: {
        name: clientAwarenessName,
        version: clientAwarenessVersion
      },
      localState: this.localState,
      assumeImmutableResults: assumeImmutableResults,
      onBroadcast: connectToDevTools ? function () {
        if (_this.devToolsHookCb) {
          _this.devToolsHookCb({
            action: {},
            state: {
              queries: _this.queryManager.getQueryStore(),
              mutations: _this.queryManager.mutationStore || {}
            },
            dataWithOptimisticResults: _this.cache.extract(true)
          });
        }
      } : void 0
    });
  }

  ApolloClient.prototype.stop = function () {
    this.queryManager.stop();
  };

  ApolloClient.prototype.watchQuery = function (options) {
    if (this.defaultOptions.watchQuery) {
      options = mergeOptions(this.defaultOptions.watchQuery, options);
    }

    if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) {
      options = _assign$7(_assign$7({}, options), {
        fetchPolicy: 'cache-first'
      });
    }

    return this.queryManager.watchQuery(options);
  };

  ApolloClient.prototype.query = function (options) {
    if (this.defaultOptions.query) {
      options = mergeOptions(this.defaultOptions.query, options);
    }

    __DEV__ ? invariant(options.fetchPolicy !== 'cache-and-network', 'The cache-and-network fetchPolicy does not work with client.query, because ' + 'client.query can only return a single result. Please use client.watchQuery ' + 'to receive multiple results from the cache and the network, or consider ' + 'using a different fetchPolicy, such as cache-first or network-only.') : invariant(options.fetchPolicy !== 'cache-and-network', 8);

    if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') {
      options = _assign$7(_assign$7({}, options), {
        fetchPolicy: 'cache-first'
      });
    }

    return this.queryManager.query(options);
  };

  ApolloClient.prototype.mutate = function (options) {
    if (this.defaultOptions.mutate) {
      options = mergeOptions(this.defaultOptions.mutate, options);
    }

    return this.queryManager.mutate(options);
  };

  ApolloClient.prototype.subscribe = function (options) {
    return this.queryManager.startGraphQLSubscription(options);
  };

  ApolloClient.prototype.readQuery = function (options, optimistic) {
    if (optimistic === void 0) {
      optimistic = false;
    }

    return this.cache.readQuery(options, optimistic);
  };

  ApolloClient.prototype.readFragment = function (options, optimistic) {
    if (optimistic === void 0) {
      optimistic = false;
    }

    return this.cache.readFragment(options, optimistic);
  };

  ApolloClient.prototype.writeQuery = function (options) {
    this.cache.writeQuery(options);
    this.queryManager.broadcastQueries();
  };

  ApolloClient.prototype.writeFragment = function (options) {
    this.cache.writeFragment(options);
    this.queryManager.broadcastQueries();
  };

  ApolloClient.prototype.__actionHookForDevTools = function (cb) {
    this.devToolsHookCb = cb;
  };

  ApolloClient.prototype.__requestRaw = function (payload) {
    return execute(this.link, payload);
  };

  ApolloClient.prototype.resetStore = function () {
    var _this = this;

    return Promise.resolve().then(function () {
      return _this.queryManager.clearStore({
        discardWatches: false
      });
    }).then(function () {
      return Promise.all(_this.resetStoreCallbacks.map(function (fn) {
        return fn();
      }));
    }).then(function () {
      return _this.reFetchObservableQueries();
    });
  };

  ApolloClient.prototype.clearStore = function () {
    var _this = this;

    return Promise.resolve().then(function () {
      return _this.queryManager.clearStore({
        discardWatches: true
      });
    }).then(function () {
      return Promise.all(_this.clearStoreCallbacks.map(function (fn) {
        return fn();
      }));
    });
  };

  ApolloClient.prototype.onResetStore = function (cb) {
    var _this = this;

    this.resetStoreCallbacks.push(cb);
    return function () {
      _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function (c) {
        return c !== cb;
      });
    };
  };

  ApolloClient.prototype.onClearStore = function (cb) {
    var _this = this;

    this.clearStoreCallbacks.push(cb);
    return function () {
      _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function (c) {
        return c !== cb;
      });
    };
  };

  ApolloClient.prototype.reFetchObservableQueries = function (includeStandby) {
    return this.queryManager.reFetchObservableQueries(includeStandby);
  };

  ApolloClient.prototype.refetchQueries = function (options) {
    var map = this.queryManager.refetchQueries(options);
    var queries = [];
    var results = [];
    map.forEach(function (result, obsQuery) {
      queries.push(obsQuery);
      results.push(result);
    });
    var result = Promise.all(results);
    result.queries = queries;
    result.results = results;
    result.catch(function (error) {
      __DEV__ && invariant.debug("In client.refetchQueries, Promise.all promise rejected with error ".concat(error));
    });
    return result;
  };

  ApolloClient.prototype.getObservableQueries = function (include) {
    if (include === void 0) {
      include = "active";
    }

    return this.queryManager.getObservableQueries(include);
  };

  ApolloClient.prototype.extract = function (optimistic) {
    return this.cache.extract(optimistic);
  };

  ApolloClient.prototype.restore = function (serializedState) {
    return this.cache.restore(serializedState);
  };

  ApolloClient.prototype.addResolvers = function (resolvers) {
    this.localState.addResolvers(resolvers);
  };

  ApolloClient.prototype.setResolvers = function (resolvers) {
    this.localState.setResolvers(resolvers);
  };

  ApolloClient.prototype.getResolvers = function () {
    return this.localState.getResolvers();
  };

  ApolloClient.prototype.setLocalStateFragmentMatcher = function (fragmentMatcher) {
    this.localState.setFragmentMatcher(fragmentMatcher);
  };

  ApolloClient.prototype.setLink = function (newLink) {
    this.link = this.queryManager.link = newLink;
  };

  return ApolloClient;
}();

var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;

function normalize(string) {
  return string.replace(/[\s,]+/g, ' ').trim();
}

function cacheKeyFromLoc(loc) {
  return normalize(loc.source.body.substring(loc.start, loc.end));
}

function processFragments(ast) {
  var seenKeys = new Set();
  var definitions = [];
  ast.definitions.forEach(function (fragmentDefinition) {
    if (fragmentDefinition.kind === 'FragmentDefinition') {
      var fragmentName = fragmentDefinition.name.value;
      var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
      var sourceKeySet = fragmentSourceMap.get(fragmentName);

      if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
        if (printFragmentWarnings) {
          console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
        }
      } else if (!sourceKeySet) {
        fragmentSourceMap.set(fragmentName, sourceKeySet = new Set());
      }

      sourceKeySet.add(sourceKey);

      if (!seenKeys.has(sourceKey)) {
        seenKeys.add(sourceKey);
        definitions.push(fragmentDefinition);
      }
    } else {
      definitions.push(fragmentDefinition);
    }
  });
  return _assign$7(_assign$7({}, ast), {
    definitions: definitions
  });
}

function stripLoc(doc) {
  var workSet = new Set(doc.definitions);
  workSet.forEach(function (node) {
    if (node.loc) delete node.loc;
    Object.keys(node).forEach(function (key) {
      var value = node[key];

      if (value && typeof value === 'object') {
        workSet.add(value);
      }
    });
  });
  var loc = doc.loc;

  if (loc) {
    delete loc.startToken;
    delete loc.endToken;
  }

  return doc;
}

function parseDocument(source) {
  var cacheKey = normalize(source);

  if (!docCache.has(cacheKey)) {
    var parsed = parse$2(source, {
      experimentalFragmentVariables: experimentalFragmentVariables,
      allowLegacyFragmentVariables: experimentalFragmentVariables
    });

    if (!parsed || parsed.kind !== 'Document') {
      throw new Error('Not a valid GraphQL document.');
    }

    docCache.set(cacheKey, stripLoc(processFragments(parsed)));
  }

  return docCache.get(cacheKey);
}

function gql(literals) {
  var args = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    args[_i - 1] = arguments[_i];
  }

  if (typeof literals === 'string') {
    literals = [literals];
  }

  var result = literals[0];
  args.forEach(function (arg, i) {
    if (arg && arg.kind === 'Document') {
      result += arg.loc.source.body;
    } else {
      result += arg;
    }

    result += literals[i + 1];
  });
  return parseDocument(result);
}

function resetCaches() {
  docCache.clear();
  fragmentSourceMap.clear();
}

function disableFragmentWarnings() {
  printFragmentWarnings = false;
}

function enableExperimentalFragmentVariables() {
  experimentalFragmentVariables = true;
}

function disableExperimentalFragmentVariables() {
  experimentalFragmentVariables = false;
}

var extras = {
  gql: gql,
  resetCaches: resetCaches,
  disableFragmentWarnings: disableFragmentWarnings,
  enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
  disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};

(function (gql_1) {
  gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));

gql["default"] = gql;
var contextKey = canUseSymbol$1 ? Symbol.for('__APOLLO_CONTEXT__') : '__APOLLO_CONTEXT__';

function getApolloContext() {
  var context = React.createContext[contextKey];

  if (!context) {
    Object.defineProperty(React.createContext, contextKey, {
      value: context = React.createContext({}),
      enumerable: false,
      writable: false,
      configurable: true
    });
    context.displayName = 'ApolloContext';
  }

  return context;
}

var ApolloProvider = function ApolloProvider(_a) {
  var client = _a.client,
      children = _a.children;
  var ApolloContext = getApolloContext();
  return React.createElement(ApolloContext.Consumer, null, function (context) {
    if (context === void 0) {
      context = {};
    }

    if (client && context.client !== client) {
      context = Object.assign({}, context, {
        client: client
      });
    }

    __DEV__ ? invariant(context.client, 'ApolloProvider was not passed a client instance. Make ' + 'sure you pass in your client via the "client" prop.') : invariant(context.client, 26);
    return React.createElement(ApolloContext.Provider, {
      value: context
    }, children);
  });
};

function useApolloClient(override) {
  var context = useContext(getApolloContext());
  var client = override || context.client;
  __DEV__ ? invariant(!!client, 'Could not find "client" in the context or passed in as an option. ' + 'Wrap the root component in an <ApolloProvider>, or pass an ApolloClient ' + 'instance in via options.') : invariant(!!client, 29);
  return client;
}

var DocumentType;

(function (DocumentType) {
  DocumentType[DocumentType["Query"] = 0] = "Query";
  DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
  DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})(DocumentType || (DocumentType = {}));

var cache$1 = new Map();

function operationName(type) {
  var name;

  switch (type) {
    case DocumentType.Query:
      name = 'Query';
      break;

    case DocumentType.Mutation:
      name = 'Mutation';
      break;

    case DocumentType.Subscription:
      name = 'Subscription';
      break;
  }

  return name;
}

function parser(document) {
  var cached = cache$1.get(document);
  if (cached) return cached;
  var variables, type, name;
  __DEV__ ? invariant(!!document && !!document.kind, "Argument of ".concat(document, " passed to parser was not a valid GraphQL ") + "DocumentNode. You may need to use 'graphql-tag' or another method " + "to convert your operation into a document") : invariant(!!document && !!document.kind, 30);
  var fragments = document.definitions.filter(function (x) {
    return x.kind === 'FragmentDefinition';
  });
  var queries = document.definitions.filter(function (x) {
    return x.kind === 'OperationDefinition' && x.operation === 'query';
  });
  var mutations = document.definitions.filter(function (x) {
    return x.kind === 'OperationDefinition' && x.operation === 'mutation';
  });
  var subscriptions = document.definitions.filter(function (x) {
    return x.kind === 'OperationDefinition' && x.operation === 'subscription';
  });
  __DEV__ ? invariant(!fragments.length || queries.length || mutations.length || subscriptions.length, "Passing only a fragment to 'graphql' is not yet supported. " + "You must include a query, subscription or mutation as well") : invariant(!fragments.length || queries.length || mutations.length || subscriptions.length, 31);
  __DEV__ ? invariant(queries.length + mutations.length + subscriptions.length <= 1, "react-apollo only supports a query, subscription, or a mutation per HOC. " + "".concat(document, " had ").concat(queries.length, " queries, ").concat(subscriptions.length, " ") + "subscriptions and ".concat(mutations.length, " mutations. ") + "You can use 'compose' to join multiple operation types to a component") : invariant(queries.length + mutations.length + subscriptions.length <= 1, 32);
  type = queries.length ? DocumentType.Query : DocumentType.Mutation;
  if (!queries.length && !mutations.length) type = DocumentType.Subscription;
  var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
  __DEV__ ? invariant(definitions.length === 1, "react-apollo only supports one definition per HOC. ".concat(document, " had ") + "".concat(definitions.length, " definitions. ") + "You can use 'compose' to join multiple operation types to a component") : invariant(definitions.length === 1, 33);
  var definition = definitions[0];
  variables = definition.variableDefinitions || [];

  if (definition.name && definition.name.kind === 'Name') {
    name = definition.name.value;
  } else {
    name = 'data';
  }

  var payload = {
    name: name,
    type: type,
    variables: variables
  };
  cache$1.set(document, payload);
  return payload;
}

function verifyDocumentType(document, type) {
  var operation = parser(document);
  var requiredOperationName = operationName(type);
  var usedOperationName = operationName(operation.type);
  __DEV__ ? invariant(operation.type === type, "Running a ".concat(requiredOperationName, " requires a graphql ") + "".concat(requiredOperationName, ", but a ").concat(usedOperationName, " was used instead.")) : invariant(operation.type === type, 34);
}

function useQuery(query, options) {
  var _a;

  var context = useContext(getApolloContext());
  var client = useApolloClient(options === null || options === void 0 ? void 0 : options.client);
  var defaultWatchQueryOptions = client.defaultOptions.watchQuery;
  verifyDocumentType(query, DocumentType.Query);

  var _b = useState(function () {
    var watchQueryOptions = createWatchQueryOptions(query, options, defaultWatchQueryOptions);
    var obsQuery = null;

    if (context.renderPromises) {
      obsQuery = context.renderPromises.getSSRObservable(watchQueryOptions);
    }

    if (!obsQuery) {
      obsQuery = client.watchQuery(watchQueryOptions);

      if (context.renderPromises) {
        context.renderPromises.registerSSRObservable(obsQuery, watchQueryOptions);
      }
    }

    if (context.renderPromises && (options === null || options === void 0 ? void 0 : options.ssr) !== false && !(options === null || options === void 0 ? void 0 : options.skip) && obsQuery.getCurrentResult().loading) {
      context.renderPromises.addQueryPromise({
        getOptions: function getOptions() {
          return createWatchQueryOptions(query, options, defaultWatchQueryOptions);
        },
        fetchData: function fetchData() {
          return new Promise(function (resolve) {
            var sub = obsQuery.subscribe({
              next: function next(result) {
                if (!result.loading) {
                  resolve();
                  sub.unsubscribe();
                }
              },
              error: function error() {
                resolve();
                sub.unsubscribe();
              },
              complete: function complete() {
                resolve();
              }
            });
          });
        }
      }, function () {
        return null;
      });
    }

    return obsQuery;
  }),
      obsQuery = _b[0],
      setObsQuery = _b[1];

  var _c = useState(function () {
    var _a, _b;

    var result = obsQuery.getCurrentResult();

    if (!result.loading && options) {
      if (result.error) {
        (_a = options.onError) === null || _a === void 0 ? void 0 : _a.call(options, result.error);
      } else if (result.data) {
        (_b = options.onCompleted) === null || _b === void 0 ? void 0 : _b.call(options, result.data);
      }
    }

    return result;
  }),
      result = _c[0],
      setResult = _c[1];

  var ref = useRef({
    client: client,
    query: query,
    options: options,
    result: result,
    previousData: void 0,
    watchQueryOptions: createWatchQueryOptions(query, options, defaultWatchQueryOptions)
  });
  useEffect(function () {
    var _a, _b;

    var watchQueryOptions = createWatchQueryOptions(query, options, defaultWatchQueryOptions);
    var nextResult;

    if (ref.current.client !== client || !equal(ref.current.query, query)) {
      var obsQuery_1 = client.watchQuery(watchQueryOptions);
      setObsQuery(obsQuery_1);
      nextResult = obsQuery_1.getCurrentResult();
    } else if (!equal(ref.current.watchQueryOptions, watchQueryOptions)) {
      obsQuery.setOptions(watchQueryOptions).catch(function () {});
      nextResult = obsQuery.getCurrentResult();
      ref.current.watchQueryOptions = watchQueryOptions;
    }

    if (nextResult) {
      var previousResult = ref.current.result;

      if (previousResult.data) {
        ref.current.previousData = previousResult.data;
      }

      setResult(ref.current.result = nextResult);

      if (!nextResult.loading && options) {
        if (nextResult.error) {
          (_a = options.onError) === null || _a === void 0 ? void 0 : _a.call(options, nextResult.error);
        } else if (nextResult.data) {
          (_b = options.onCompleted) === null || _b === void 0 ? void 0 : _b.call(options, nextResult.data);
        }
      }
    }

    Object.assign(ref.current, {
      client: client,
      query: query
    });
  }, [obsQuery, client, query, options]);
  useEffect(function () {
    if (context.renderPromises) {
      return;
    }

    var subscription = obsQuery.subscribe(onNext, onError);

    function onNext() {
      var _a, _b;

      var previousResult = ref.current.result;
      var result = obsQuery.getCurrentResult();

      if (previousResult && previousResult.loading === result.loading && previousResult.networkStatus === result.networkStatus && equal(previousResult.data, result.data)) {
        return;
      }

      if (previousResult.data) {
        ref.current.previousData = previousResult.data;
      }

      setResult(ref.current.result = result);

      if (!result.loading) {
        (_b = (_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onCompleted) === null || _b === void 0 ? void 0 : _b.call(_a, result.data);
      }
    }

    function onError(error) {
      var _a, _b;

      var last = obsQuery["last"];
      subscription.unsubscribe();

      try {
        obsQuery.resetLastResults();
        subscription = obsQuery.subscribe(onNext, onError);
      } finally {
        obsQuery["last"] = last;
      }

      if (!error.hasOwnProperty('graphQLErrors')) {
        throw error;
      }

      var previousResult = ref.current.result;

      if (previousResult && previousResult.loading || !equal(error, previousResult.error)) {
        setResult(ref.current.result = {
          data: previousResult.data,
          error: error,
          loading: false,
          networkStatus: NetworkStatus.error
        });
        (_b = (_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError) === null || _b === void 0 ? void 0 : _b.call(_a, error);
      }
    }

    return function () {
      return subscription.unsubscribe();
    };
  }, [obsQuery, context.renderPromises, client.disableNetworkFetches]);
  var partial;
  _a = result, partial = _a.partial, result = __rest(_a, ["partial"]);
  {
    if (partial && (options === null || options === void 0 ? void 0 : options.partialRefetch) && !result.loading && (!result.data || Object.keys(result.data).length === 0) && obsQuery.options.fetchPolicy !== 'cache-only') {
      result = _assign$7(_assign$7({}, result), {
        loading: true,
        networkStatus: NetworkStatus.refetch
      });
      obsQuery.refetch();
    }

    if (context.renderPromises && (options === null || options === void 0 ? void 0 : options.ssr) !== false && !(options === null || options === void 0 ? void 0 : options.skip) && result.loading) {
      obsQuery.setOptions(createWatchQueryOptions(query, options, defaultWatchQueryOptions)).catch(function () {});
    }

    Object.assign(ref.current, {
      options: options
    });
  }

  if ((context.renderPromises || client.disableNetworkFetches) && (options === null || options === void 0 ? void 0 : options.ssr) === false) {
    result = ref.current.result = {
      loading: true,
      data: void 0,
      error: void 0,
      networkStatus: NetworkStatus.loading
    };
  } else if ((options === null || options === void 0 ? void 0 : options.skip) || (options === null || options === void 0 ? void 0 : options.fetchPolicy) === 'standby') {
    result = {
      loading: false,
      data: void 0,
      error: void 0,
      networkStatus: NetworkStatus.ready
    };
  }

  if (result.errors && result.errors.length) {
    result = _assign$7(_assign$7({}, result), {
      error: result.error || new ApolloError({
        graphQLErrors: result.errors
      })
    });
  }

  var obsQueryFields = useMemo(function () {
    return {
      refetch: obsQuery.refetch.bind(obsQuery),
      fetchMore: obsQuery.fetchMore.bind(obsQuery),
      updateQuery: obsQuery.updateQuery.bind(obsQuery),
      startPolling: obsQuery.startPolling.bind(obsQuery),
      stopPolling: obsQuery.stopPolling.bind(obsQuery),
      subscribeToMore: obsQuery.subscribeToMore.bind(obsQuery)
    };
  }, [obsQuery]);
  return _assign$7(_assign$7(_assign$7({}, obsQueryFields), {
    variables: createWatchQueryOptions(query, options, defaultWatchQueryOptions).variables,
    client: client,
    called: true,
    previousData: ref.current.previousData
  }), result);
}

function createWatchQueryOptions(query, options, defaultOptions) {
  var _a;

  if (options === void 0) {
    options = {};
  }

  var skip = options.skip;
  options.ssr;
  options.onCompleted;
  options.onError;
  options.displayName;

  var otherOptions = __rest(options, ["skip", "ssr", "onCompleted", "onError", "displayName"]);

  var watchQueryOptions = _assign$7({
    query: query
  }, otherOptions);

  if (defaultOptions) {
    watchQueryOptions = mergeOptions(defaultOptions, watchQueryOptions);
  }

  if (skip) {
    watchQueryOptions.fetchPolicy = 'standby';
  } else if (((_a = watchQueryOptions.context) === null || _a === void 0 ? void 0 : _a.renderPromises) && (watchQueryOptions.fetchPolicy === 'network-only' || watchQueryOptions.fetchPolicy === 'cache-and-network')) {
    watchQueryOptions.fetchPolicy = 'cache-first';
  } else if (!watchQueryOptions.fetchPolicy) {
    watchQueryOptions.fetchPolicy = 'cache-first';
  }

  if (!watchQueryOptions.variables) {
    watchQueryOptions.variables = {};
  }

  return watchQueryOptions;
}

var EAGER_METHODS = ['refetch', 'fetchMore', 'updateQuery', 'startPolling', 'subscribeToMore'];

function useLazyQuery(query, options) {
  var _a = useState({
    called: false
  }),
      execution = _a[0],
      setExecution = _a[1];

  var result = useQuery(query, _assign$7(_assign$7(_assign$7({}, options), execution.options), {
    fetchPolicy: execution.called ? options === null || options === void 0 ? void 0 : options.fetchPolicy : 'standby',
    skip: undefined
  }));

  if (!execution.called) {
    result = _assign$7(_assign$7({}, result), {
      loading: false,
      data: void 0,
      error: void 0,
      called: false
    });
  }

  var eagerMethods = useMemo(function () {
    var eagerMethods = {};

    var _loop_1 = function _loop_1(key) {
      var method = result[key];

      eagerMethods[key] = function () {
        var args = [];

        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }

        setExecution(function (execution) {
          return _assign$7(_assign$7({}, execution), {
            called: true
          });
        });
        return method.apply(void 0, args);
      };
    };

    for (var _i = 0, EAGER_METHODS_1 = EAGER_METHODS; _i < EAGER_METHODS_1.length; _i++) {
      var key = EAGER_METHODS_1[_i];

      _loop_1(key);
    }

    return eagerMethods;
  }, []);
  result.error = result.error || void 0;
  Object.assign(result, eagerMethods);
  var execute = useCallback(function (executeOptions) {
    setExecution({
      called: true,
      options: executeOptions
    });
    var promise = result.refetch(executeOptions === null || executeOptions === void 0 ? void 0 : executeOptions.variables).then(function (result1) {
      var result2 = _assign$7(_assign$7({}, result), {
        data: result1.data,
        error: result1.error,
        called: true,
        loading: false
      });

      Object.assign(result2, eagerMethods);
      return result2;
    });
    promise.catch(function () {});
    return promise;
  }, []);
  return [execute, result];
}

function useMutation(mutation, options) {
  var client = useApolloClient(options === null || options === void 0 ? void 0 : options.client);
  verifyDocumentType(mutation, DocumentType.Mutation);

  var _a = useState({
    called: false,
    loading: false,
    client: client
  }),
      result = _a[0],
      setResult = _a[1];

  var ref = useRef({
    result: result,
    mutationId: 0,
    isMounted: true,
    client: client,
    mutation: mutation,
    options: options
  });
  {
    Object.assign(ref.current, {
      client: client,
      options: options,
      mutation: mutation
    });
  }
  var execute = useCallback(function (executeOptions) {
    if (executeOptions === void 0) {
      executeOptions = {};
    }

    var _a = ref.current,
        client = _a.client,
        options = _a.options,
        mutation = _a.mutation;

    var baseOptions = _assign$7(_assign$7({}, options), {
      mutation: mutation
    });

    if (!ref.current.result.loading && !baseOptions.ignoreResults) {
      setResult(ref.current.result = {
        loading: true,
        error: void 0,
        data: void 0,
        called: true,
        client: client
      });
    }

    var mutationId = ++ref.current.mutationId;
    var clientOptions = mergeOptions(baseOptions, executeOptions);
    return client.mutate(clientOptions).then(function (response) {
      var _a, _b;

      var data = response.data,
          errors = response.errors;
      var error = errors && errors.length > 0 ? new ApolloError({
        graphQLErrors: errors
      }) : void 0;

      if (mutationId === ref.current.mutationId && !clientOptions.ignoreResults) {
        var result_1 = {
          called: true,
          loading: false,
          data: data,
          error: error,
          client: client
        };

        if (ref.current.isMounted && !equal(ref.current.result, result_1)) {
          setResult(ref.current.result = result_1);
        }
      }

      (_a = baseOptions.onCompleted) === null || _a === void 0 ? void 0 : _a.call(baseOptions, response.data);
      (_b = executeOptions.onCompleted) === null || _b === void 0 ? void 0 : _b.call(executeOptions, response.data);
      return response;
    }).catch(function (error) {
      var _a, _b;

      if (mutationId === ref.current.mutationId && ref.current.isMounted) {
        var result_2 = {
          loading: false,
          error: error,
          data: void 0,
          called: true,
          client: client
        };

        if (!equal(ref.current.result, result_2)) {
          setResult(ref.current.result = result_2);
        }
      }

      if (baseOptions.onError || clientOptions.onError) {
        (_a = baseOptions.onError) === null || _a === void 0 ? void 0 : _a.call(baseOptions, error);
        (_b = executeOptions.onError) === null || _b === void 0 ? void 0 : _b.call(executeOptions, error);
        return {
          data: void 0,
          errors: error
        };
      }

      throw error;
    });
  }, []);
  var reset = useCallback(function () {
    setResult({
      called: false,
      loading: false,
      client: client
    });
  }, []);
  useEffect(function () {
    return function () {
      ref.current.isMounted = false;
    };
  }, []);
  return [execute, _assign$7({
    reset: reset
  }, result)];
}

function _regenerator$_() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$_(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$_(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$_(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$_(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$_(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$_(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$_(u), _regeneratorDefine2$_(u, o, "Generator"), _regeneratorDefine2$_(u, n, function () {
    return this;
  }), _regeneratorDefine2$_(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$_ = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$_(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$_ = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$_(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$_(e, r, n, t);
}

function ownKeys$1m(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1m(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1m(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1m(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var createHash = function createHash(components) {
  var values = components.map(function (c) {
    return c.value;
  });
  return fingerprint2.x64hash128(values.join(''), 31);
};

var fingerprint;

var getFingerprint = function getFingerprint() {
  var options = {
    excludes: {
      audio: true,
      enumerateDevices: true,
      fontsFlash: true
    }
  };

  if (hasDOM && window.requestIdleCallback) {
    window.requestIdleCallback(function () {
      fingerprint2.get(options, function (components) {
        fingerprint = createHash(components);
      });
    });
  } else {
    setTimeout(function () {
      fingerprint2.get(options, function (components) {
        fingerprint = createHash(components);
      });
    }, 500);
  }
};

getFingerprint();

var getBrowserInfo = function getBrowserInfo() {
  var screen = {
    height: null,
    width: null
  };

  if (hasDOM) {
    screen.height = window.screen.height;
    screen.width = window.screen.width;
  }

  return {
    osVersion: osVersion,
    osName: osName,
    isMobile: isMobile,
    isBrowser: isBrowser$7,
    browser: {
      version: fullBrowserVersion,
      name: browserName
    },
    mobile: {
      vendor: mobileVendor,
      model: mobileModel
    },
    userAgent: getUA,
    screen: _objectSpread$1m({}, screen)
  };
};

var getCurrentUrlInfo = function getCurrentUrlInfo() {
  if (!hasDOM) {
    return {};
  }

  var decoded = decodeURIComponent(window.location.search);
  var params = queryString.parse(decoded);
  return {
    referrer: document.referrer,
    host: window.location.host,
    path: window.location.pathname,
    queryString: params
  };
};

var getCustomerId = function getCustomerId() {
  if (!hasDOM) {
    return;
  }

  var user = LS.getItem(storageKeys.User);
  return user ? user.customerId : null;
};

var wait = function wait(ms) {
  return new Promise(function (r) {
    return setTimeout(r, ms);
  });
};

var tracker$1 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$_().m(function _callee(name, _ref) {
    var rest, browserInfo, currentUrlInfo, customerId, data, toBeTracked;
    return _regenerator$_().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            rest = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));

            if (name) {
              _context.n = 1;
              break;
            }

            console.warn('You must supply a name to tracker');
            return _context.a(2);

          case 1:
            browserInfo = getBrowserInfo();
            currentUrlInfo = getCurrentUrlInfo();
            customerId = getCustomerId();
            data = rest;

            if (rest.error) {
              data.error = Object.getOwnPropertyNames(rest.error).reduce(function (acc, key) {
                acc[key] = rest.error[key];
                return acc;
              }, {});
            } // In the off chance an error occurs as soon as a user gets to our page
            // and fingerprint hasn't initialized


            if (fingerprint) {
              _context.n = 2;
              break;
            }

            _context.n = 2;
            return wait(1000);

          case 2:
            toBeTracked = {
              name: name,
              client: _objectSpread$1m({}, browserInfo),
              request: _objectSpread$1m({}, currentUrlInfo),
              reseller: RESELLER,
              data: data,
              fingerprint: fingerprint,
              customerId: customerId,
              properties: {
                time: new Date().getTime()
              }
            };
            post$1("".concat(marketingEndpoint, "/track"), {
              data: base64Encode(JSON.stringify(toBeTracked))
            });

          case 3:
            return _context.a(2);
        }
      }
    }, _callee);
  }));

  return function tracker(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}(); /// / NEW


var cachedOrder = {};

var mapItem = function mapItem(item) {
  try {
    var prices = item.prices && item.prices.regular && item.prices.regular.price ? item.prices.regular.price : null;
    return {
      ItemCode: item.assetType,
      ItemID: item.id,
      ItemName: item.display.name,
      ItemTypeName: item.productType,
      Price: prices,
      Quantity: item.term ? item.term.count : 1
    };
  } catch (ex) {
    console.error('Problem with translating object.', item, ex);
    return {};
  }
};

var mapToOrderFormat = function mapToOrderFormat(items) {
  return items.map(mapItem);
};

var track$2 = function track(operationName, trackingData) {
  var eventName = null;

  switch (operationName) {
    case 'AddSecurity':
    case 'AddPrivacy':
      eventName = 'AddToCart';
      break;

    case 'RemoveItem':
      eventName = 'RemoveFromCart';
      break;

    default:
      eventName = operationName;
      break;
  }

  tracker$1(eventName, trackingData);
};

var trackerLink = new ApolloLink(function (operation, forward) {
  var operationName = operation.operationName,
      variables = operation.variables;

  if (variables.tracking) {
    track$2(operationName, variables.tracking);
  }

  return forward(operation).map(function (response) {
    var data = response.data;

    if (data && data.order) {
      var order = data.order;

      if (!isEqual$2(order, cachedOrder)) {
        if (hasDOM && window.dataLayer) {
          window.dataLayer.push({
            event: 'Shopping Cart Items',
            shoppingCartItems: mapToOrderFormat(order.items)
          });
        }
      }

      cachedOrder = order;
    }

    return response;
  });
});

var base64Encode = function base64Encode(data) {
  var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  var o1;
  var o2;
  var o3;
  var h1;
  var h2;
  var h3;
  var h4;
  var bits;
  var i = 0;
  var ac = 0;
  var enc = '';
  var tmp_arr = [];

  if (!data) {
    return data;
  }

  data = utf8Encode(data);

  do {
    // pack three octets into four hexets
    o1 = data.charCodeAt(i++);
    o2 = data.charCodeAt(i++);
    o3 = data.charCodeAt(i++);
    bits = o1 << 16 | o2 << 8 | o3;
    h1 = bits >> 18 & 0x3f;
    h2 = bits >> 12 & 0x3f;
    h3 = bits >> 6 & 0x3f;
    h4 = bits & 0x3f; // use hexets to index into b64, and append result to encoded string

    tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
  } while (i < data.length);

  enc = tmp_arr.join('');

  switch (data.length % 3) {
    case 1:
      enc = "".concat(enc.slice(0, -2), "==");
      break;

    case 2:
      enc = "".concat(enc.slice(0, -1), "=");
      break;
  }

  return enc;
};

var utf8Encode = function utf8Encode(string) {
  string = "".concat(string).replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  var utftext = '';
  var start;
  var end;
  var stringl = 0;
  var n;
  start = end = 0;
  stringl = string.length;

  for (n = 0; n < stringl; n++) {
    var c1 = string.charCodeAt(n);
    var enc = null;

    if (c1 < 128) {
      end++;
    } else if (c1 > 127 && c1 < 2048) {
      enc = String.fromCharCode(c1 >> 6 | 192, c1 & 63 | 128);
    } else {
      enc = String.fromCharCode(c1 >> 12 | 224, c1 >> 6 & 63 | 128, c1 & 63 | 128);
    }

    if (enc !== null) {
      if (end > start) {
        utftext += string.substring(start, end);
      }

      utftext += enc;
      start = end = n + 1;
    }
  }

  if (end > start) {
    utftext += string.substring(start, string.length);
  }

  return utftext;
};

function _callSuper$1(t, o, e) {
  return o = _getPrototypeOf$1(o), _possibleConstructorReturn$2(t, _isNativeReflectConstruct$1() ? Reflect.construct(o, e || [], _getPrototypeOf$1(t).constructor) : o.apply(t, e));
}

function _isNativeReflectConstruct$1() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

var propTypes$1p = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node,
  location: PropTypes.string.isRequired,
  panel: PropTypes.string
};
var defaultProps$K = {
  fallback: null,
  panel: ''
};
var strings$4 = {
  errorMessage: "Oops! Something went wrong.",
  contactUs: 'Try reloading or contacting support below.'
};

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  function ErrorBoundary(props) {
    var _this;

    _classCallCheck$a(this, ErrorBoundary);

    _this = _callSuper$1(this, ErrorBoundary, [props]);
    _this.state = {
      hasError: false,
      error: null,
      info: null
    };
    return _this;
  }

  _inherits$2(ErrorBoundary, _React$Component);

  return _createClass$a(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      this.setState({
        error: error,
        info: info
      });
      var _this$props = this.props,
          location = _this$props.location,
          panel = _this$props.panel;
      tracker$1('Client Error', {
        type: 'error-boundary',
        location: location,
        info: info,
        error: error,
        panel: panel
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          hasError = _this$state.hasError,
          error = _this$state.error,
          info = _this$state.info;
      var _this$props2 = this.props,
          children = _this$props2.children,
          fallback = _this$props2.fallback;

      if (hasError) {
        if (fallback) {
          var Component = fallback;
          return /*#__PURE__*/jsx$1(Component, {
            error: error,
            info: info
          });
        }

        return /*#__PURE__*/jsx$1(Box$1, {
          alignItems: "center",
          justifyContent: "center",
          py: 5,
          width: "100%",
          children: /*#__PURE__*/jsx$1(Message, {
            variant: "error",
            children: /*#__PURE__*/jsxs(Box$1, {
              flexDirection: "column",
              children: [/*#__PURE__*/jsx$1(Text$1, {
                children: strings$4.errorMessage
              }), /*#__PURE__*/jsx$1(Text$1, {
                mt: 3,
                children: strings$4.contactUs
              })]
            })
          })
        });
      }

      return children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      // Update state so the next render will show the fallback UI.
      return {
        hasError: true
      };
    }
  }]);
}(React__default.Component);

ErrorBoundary.propTypes = propTypes$1p;
ErrorBoundary.defaultProps = defaultProps$K;

function ownKeys$1l(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1l(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1l(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1l(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function InfoCollector$1(_ref) {
  var errorMessage = _ref.errorMessage,
      containerRef = _ref.containerRef,
      isSubmitting = _ref.isSubmitting,
      submitHandler = _ref.submitHandler,
      title = _ref.title,
      fields = _ref.fields,
      source = _ref.source;

  var _useState = useState({}),
      _useState2 = _slicedToArray$4(_useState, 2),
      values = _useState2[0],
      setValues = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$4(_useState3, 2),
      abuseCheck = _useState4[0],
      setAbuseCheck = _useState4[1];

  var handleInput = function handleInput(e) {
    var _e$target = e.target,
        value = _e$target.value,
        id = _e$target.id;
    setValues(_objectSpread$1l(_objectSpread$1l({}, values), {}, _defineProperty$6({}, id, value)));
  };

  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();

    if (isSubmitting) {
      return;
    }

    submitHandler(values);
  };

  var _useUserService = useUserService(),
      user = _useUserService.user;

  var autoFillValues = ['name', 'email', 'phone'];
  useEffect(function () {
    if (user) {
      var _user$primaryAddress;

      var userInfo = {
        name: "".concat(user.firstname, " ").concat(user.lastname),
        email: user.email,
        phone: (_user$primaryAddress = user.primaryAddress) === null || _user$primaryAddress === void 0 ? void 0 : _user$primaryAddress.phone
      };
      var userValues = {};
      fields.forEach(function (field) {
        if (autoFillValues.includes(field.id)) {
          userValues = _objectSpread$1l(_objectSpread$1l({}, userValues), {}, _defineProperty$6({}, field.id, userInfo[field.id]));
        }
      });
      setValues(_objectSpread$1l(_objectSpread$1l({}, values), userValues));
    }
  }, [user]);
  useEffect(function () {
    source.includes('abuse') ? setAbuseCheck(true) : setAbuseCheck(false);
  }, [source]);
  var embeddedMailToUrl = "?subject=[HELP]%20-%20".concat(source, "&body=Your%20Domain%20or%20Service:%0D%0A%0D%0A%0D%0APhone%20Number:%0D%0A%0D%0A%0D%0AName%20of%20Account%20Holder%20(if known):%0D%0A%0D%0A%0D%0AInquiry:%0D%0A%0D%0A%0D%0A%0D%0A%0D%0AIMPORTANT:%20Are%20you%20emailing%20us%20from%20your%20primary%20address%20on%20file?%20If%20not,%20make%20sure%20to%20cc%20that%20email%20address.");
  var helpSection = OrderStrings.purchaseFlow.helpSection;
  var space = theme.space;

  var track = function track(data) {
    trackEvent({
      event: 'InfoCollector',
      data: data
    });
  };

  return /*#__PURE__*/jsxs(Stack$2, {
    ref: containerRef,
    children: [/*#__PURE__*/jsx$1(Heading, {
      headingStyle: 4,
      children: title
    }), /*#__PURE__*/jsxs("form", {
      onSubmit: handleSubmit,
      children: [fields.map(function (field) {
        return /*#__PURE__*/jsx$1(Input$5, {
          id: field.id,
          label: field.display,
          mt: 3,
          onChange: handleInput,
          required: field.required,
          textarea: field.type === 'textarea',
          type: field.type ? field.type : 'text',
          value: values[field.id]
        }, field.id);
      }), errorMessage && /*#__PURE__*/jsx$1(Message, {
        mt: 3,
        variant: "error",
        children: errorMessage
      }), /*#__PURE__*/jsx$1(Box$1, {
        alignItems: "center",
        justifyContent: "space-between",
        mt: 3,
        children: isSubmitting ? /*#__PURE__*/jsx$1(Spinner$1, {
          size: "3rem",
          stroke: ".3rem"
        }) : /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsxs("div", {
            style: {
              display: 'flex',
              flexDirection: 'column',
              borderTop: '1px solid rgba(0,0,0,0.2)',
              paddingTop: '0.8rem'
            },
            children: [/*#__PURE__*/jsx$1("p", {
              style: {
                color: 'rgba(0,0,0,0.6)'
              },
              children: abuseCheck ? 'This form is for abuse reports. For other inquiries, please contact customer service.' : 'Or email us!'
            }), !abuseCheck && /*#__PURE__*/jsxs(Link$1, {
              ariaLabel: "Email us",
              display: "flex",
              fontSize: "1.4rem",
              fontWeight: "regular",
              href: "mailto:".concat(SUPPORT_STRINGS.email).concat(embeddedMailToUrl),
              onClick: function onClick() {
                return track('support-email');
              },
              py: 2,
              title: helpSection.emailTitle,
              variant: "light",
              children: [/*#__PURE__*/jsx$1(Icon$2, {
                height: "2rem",
                mr: space.regular,
                name: "email",
                title: "email",
                titleId: "emailIcon",
                width: "2rem"
              }), SUPPORT_STRINGS.email]
            })]
          }), /*#__PURE__*/jsx$1(Button$1, {
            color: "blueDark",
            id: "submit-info",
            type: "submit",
            children: "Submit"
          })]
        })
      })]
    })]
  });
}

InfoCollector$1.defaultProps = {
  containerRef: null,
  errorMessage: '',
  fields: [{
    id: 'firstName',
    display: "what's your first name?",
    required: true
  }, {
    id: 'lastName',
    display: "what's your last name?",
    required: true
  }, {
    id: 'email',
    display: 'your best email address?',
    required: true
  }, {
    id: 'comments',
    display: 'leave a comment?',
    type: 'textarea'
  }],
  isSubmitting: false,
  submitHandler: function submitHandler() {},
  title: 'Title Goes Here'
};
InfoCollector$1.propTypes = {
  containerRef: PropTypes.object,
  errorMessage: PropTypes.string,
  fields: PropTypes.arrayOf(PropTypes.object),
  isSubmitting: PropTypes.bool,
  submitHandler: PropTypes.func,
  title: PropTypes.string
};

function ownKeys$1k(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1k(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1k(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1k(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _regenerator$Z() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$Z(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$Z(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$Z(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$Z(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$Z(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$Z(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$Z(u), _regeneratorDefine2$Z(u, o, "Generator"), _regeneratorDefine2$Z(u, n, function () {
    return this;
  }), _regeneratorDefine2$Z(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$Z = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$Z(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$Z = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$Z(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$Z(e, r, n, t);
}

var track$1 = function track(data) {
  trackEvent({
    event: 'InfoCollector',
    data: data
  });
};

function InfoCollectorModal(_ref) {
  var id = _ref.id,
      btnProps = _ref.btnProps,
      buttonText = _ref.buttonText,
      errorMessage = _ref.errorMessage,
      successMessage = _ref.successMessage,
      title = _ref.title,
      source = _ref.source,
      fields = _ref.fields;

  var _useModal = useModal(),
      openModal = _useModal.openModal,
      closeModal = _useModal.closeModal,
      Modal = _useModal.Modal,
      containerRef = _useModal.containerRef;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      success = _useState2[0],
      setSuccess = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray$4(_useState3, 2),
      error = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray$4(_useState5, 2),
      submitting = _useState6[0],
      setSubmitting = _useState6[1];

  var url = "".concat(marketingEndpoint, "/web-form/").concat(source);

  var openInfoModal = function openInfoModal() {
    track$1({
      type: 'modal open'
    });
    setErrorMessage('');
    setSuccess(false);
    openModal();
  };

  var closeInfoModal = function closeInfoModal() {
    track$1({
      type: 'modal close'
    });
    setErrorMessage('');
    setSuccess(false);
    closeModal();
  };

  var submitHandler = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$Z().m(function _callee(info) {
      var urlParams, handleErrorResponse, _yield$post, data;

      return _regenerator$Z().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              setSubmitting(true);
              setErrorMessage('');
              info.reseller = RESELLER;
              urlParams = queryString.parse(window.location.search);

              if (urlParams.utm_campaign) {
                info.utm_campaign = urlParams.utm_campaign;
              }

              if (urlParams.utm_source) {
                info.utm_source = urlParams.utm_source;
              }

              if (urlParams.utm_medium) {
                info.utm_medium = urlParams.utm_medium;
              }

              if (urlParams.utm_content) {
                info.utm_content = urlParams.utm_content;
              }

              handleErrorResponse = function handleErrorResponse(responseErrorMessage) {
                setErrorMessage(responseErrorMessage);
              };

              _context.p = 1;
              _context.n = 2;
              return post$1(url, info, {
                dontSetAuthorizationHeader: true
              });

            case 2:
              _yield$post = _context.v;
              data = _yield$post.data;

              if (data.success) {
                track$1({
                  type: 'success'
                });
                setSubmitting(false);
                setErrorMessage('');
                setSuccess(true);
              } else {
                handleErrorResponse(data.message);
              }

              _context.n = 4;
              break;

            case 3:
              _context.p = 3;
              handleErrorResponse(errorMessage);
              setSubmitting(false);

            case 4:
              return _context.a(2);
          }
        }
      }, _callee, null, [[1, 3]]);
    }));

    return function submitHandler(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Button$1, _objectSpread$1k(_objectSpread$1k({
      ariaLabel: buttonText,
      color: "white",
      id: id,
      variant: source === 'abuse-link' ? 'Link' : undefined,
      onClick: function onClick() {
        openInfoModal();
      },
      width: "100%"
    }, btnProps), {}, {
      children: /*#__PURE__*/jsx$1(Text$1, {
        lineHeight: "body",
        children: buttonText
      })
    })), /*#__PURE__*/jsx$1(Modal, {
      closeBtnCb: closeInfoModal,
      id: "info-collector-modal",
      onBgClick: closeInfoModal,
      onCancel: closeInfoModal,
      onEscapeKey: closeInfoModal,
      width: "60rem",
      children: /*#__PURE__*/jsxs(ErrorBoundary, {
        location: "info-collector",
        children: [success && /*#__PURE__*/jsx$1(Box$1, {
          alignItems: "center",
          justifyContent: "center",
          children: /*#__PURE__*/jsxs(Text$1, {
            fontSize: 4,
            children: [successMessage, " "]
          })
        }), !success && /*#__PURE__*/jsx$1(InfoCollector$1, {
          containerRef: containerRef,
          errorMessage: error,
          fields: fields,
          isSubmitting: submitting,
          submitHandler: submitHandler,
          title: title,
          source: source
        })]
      })
    })]
  });
}

var _templateObject$t, _templateObject2$j;

var space$3 = theme.space,
    colors$l = theme.colors;
var linksStyles = css$3(["& > *:not(:last-child){margin-bottom:", ";}"], space$3.regular);
var hoverStyles = css$3(["&:hover,&:focus{text-decoration:underline;}"]);
var linkStyles$1 = css$3(["display:flex;align-items:center;font-size:1.4rem;letter-spacing:1px;transition:all 0.2s;&,&:link,&:visited{color:", ";}&:hover,&:focus{color:", ";text-decoration:underline;}", ""], function (_ref) {
  var variant = _ref.variant;
  return variant === 'dark' ? "".concat(colors$l.white) : "".concat(colors$l.blackLight);
}, function (_ref2) {
  var variant = _ref2.variant;
  return variant === 'dark' ? "".concat(colors$l.white) : "".concat(colors$l.black);
}, function (_ref3) {
  var highlight = _ref3.highlight,
      variant = _ref3.variant;

  if (highlight) {
    return variant === 'dark' ? "\n            color: ".concat(colors$l.white, " !important\n            font-weight: 600;\n          ") : "\n            color: ".concat(colors$l.green, " !important;\n            font-weight: 600;\n          ");
  }

  return '';
});
var helpSection$1 = OrderStrings.purchaseFlow.helpSection;
var variants = {
  light: {
    heading: 'black',
    button: 'black',
    chat: 'blue'
  },
  dark: {
    heading: 'white',
    button: 'white',
    chat: 'white'
  }
};

function HelpSection(_ref4) {
  var testId = _ref4.testId,
      _ref4$variant = _ref4.variant,
      variant = _ref4$variant === void 0 ? 'light' : _ref4$variant;
  var phone = SUPPORT_STRINGS.phone;

  var _useSunshine = useSunshine(),
      openChat = _useSunshine.openChat;

  var onChatClick = function onChatClick() {
    if (hasDOM && openChat) {
      openChat();
    }
  };

  var track = function track(type) {
    trackEvent({
      event: ANALYTICS_EVENTS.helpSection,
      eventCategory: ANALYTICS_CATEGORIES.user,
      data: {
        type: type
      }
    });
  };

  return /*#__PURE__*/jsxs(Stack$2, {
    "data-testid": testId,
    children: [/*#__PURE__*/jsx$1(Heading, {
      color: variants[variant].heading,
      headingStyle: "3",
      size: "3",
      children: helpSection$1.heading
    }), /*#__PURE__*/jsxs(_StyledStack$g, {
      alignItems: "flex-start",
      display: "flex",
      mt: space$3.big,
      children: [/*#__PURE__*/jsxs(Button$1, {
        alignItems: "center",
        ariaLabel: "Chat with us",
        color: variants[variant].button,
        display: "flex",
        highlight: true,
        href: "#",
        id: "support-chat",
        letterSpacing: "1px",
        onClick: function onClick() {
          onChatClick();
          track('support-chat');
        },
        title: helpSection$1.chatTitle,
        variant: "minimal",
        children: [/*#__PURE__*/jsx$1(Icon$2, {
          height: "2rem",
          mr: space$3.regular,
          name: "chat",
          title: "Chat",
          titleId: "supportChatIcon-help-section",
          width: "2rem"
        }), /*#__PURE__*/jsxs(_StyledText$n, {
          alignItems: "center",
          display: "flex",
          fontSize: "1.4rem",
          fontWeight: "regular",
          children: [/*#__PURE__*/jsx$1(Text$1, {
            color: variants[variant].chat,
            fontWeight: "semi",
            mr: space$3.quarter,
            textTransform: "capitalize",
            children: helpSection$1.liveChat
          }), /*#__PURE__*/jsx$1(Text$1, {
            textTransform: "capitalize",
            variant: "milliBold",
            children: helpSection$1.officeHours
          })]
        })]
      }), /*#__PURE__*/jsxs(_StyledLink$7, {
        ariaLabel: helpSection$1.phoneTitle,
        display: "flex",
        fontSize: "1.4rem",
        href: "tel:".concat(phone),
        letterSpacing: "1px",
        onClick: function onClick() {
          track('support-phone');
        },
        title: helpSection$1.phoneTitle,
        variant: variant,
        children: [/*#__PURE__*/jsx$1(Icon$2, {
          height: "2rem",
          mr: space$3.regular,
          name: "phone",
          title: "phone",
          titleId: "phoneIcon",
          width: "2rem"
        }), /*#__PURE__*/jsx$1(Text$1, {
          mr: space$3.quarter,
          children: phone
        }), /*#__PURE__*/jsx$1(Text$1, {
          fontSize: "1.2rem",
          children: "(9am-5pm EST daily)"
        })]
      }), /*#__PURE__*/jsx$1(InfoCollectorModal, {
        id: "contact_modal_payment",
        fields: [{
          id: 'name',
          display: 'Full name',
          required: true
        }, {
          id: 'email',
          display: 'Email address',
          type: 'email',
          required: true
        }, {
          id: 'message',
          display: 'Error or Inquiry',
          required: true,
          type: 'textarea'
        }],
        btnProps: {
          color: 'blueDark'
        },
        source: "payment-settings",
        successMessage: "Thanks! We'll contact you within 24 hours.",
        errorMessage: "Something went wrong.",
        title: "We're here to help! Ready to chat? Give us a few details so we know where to start",
        buttonText: "Email Us"
      })]
    })]
  });
}

var _StyledStack$g = styled(Stack$2)(_templateObject$t || (_templateObject$t = _taggedTemplateLiteral$1(["", ""])), linksStyles);

var _StyledText$n = styled(Text$1)(_templateObject2$j || (_templateObject2$j = _taggedTemplateLiteral$1(["", ""])), hoverStyles);

var _StyledLink$7 = styled(Link$1).withConfig({
  displayName: "help-section___StyledLink",
  componentId: "sc-1s46q13-0"
})(["", ""], linkStyles$1);

var _excluded$w = ["containerProps"];

function ownKeys$1j(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1j(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1j(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1j(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var LoadingSpinner = function LoadingSpinner(_ref) {
  var containerProps = _ref.containerProps,
      rest = _objectWithoutProperties$8(_ref, _excluded$w);

  return /*#__PURE__*/jsx$1(_StyledSection, _objectSpread$1j(_objectSpread$1j({
    containerProps: containerProps
  }, rest), {}, {
    children: /*#__PURE__*/jsx$1(Text$1, {
      as: "span",
      ml: 2,
      children: /*#__PURE__*/jsx$1(Spinner$1, {
        size: "1.5rem",
        stroke: ".3rem"
      })
    })
  }));
};

var _StyledSection = styled(Section).withConfig({
  displayName: "loading-spinner___StyledSection",
  componentId: "sc-v924bl-0"
})(["overflow:hidden;"]);
/*! https://mths.be/punycode v1.4.1 by @mathias */

/** Highest positive signed 32-bit float value */


var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1

/** Bootstring parameters */

var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80

var delimiter = '-'; // '\x2D'

/** Regular expressions */

var regexPunycode = /^xn--/;
var regexNonASCII = /[^\x20-\x7E]/; // unprintable ASCII chars + non-ASCII chars

var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators

/** Error messages */

var errors = {
  'overflow': 'Overflow: input needs wider integers to process',
  'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
  'invalid-input': 'Invalid input'
};
/** Convenience shortcuts */

var baseMinusTMin = base - tMin;
var floor = Math.floor;
var stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/

/**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */

function error(type) {
  throw new RangeError(errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */


function map$1(array, fn) {
  var length = array.length;
  var result = [];

  while (length--) {
    result[length] = fn(array[length]);
  }

  return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {Array} A new string of characters returned by the callback
 * function.
 */


function mapDomain(string, fn) {
  var parts = string.split('@');
  var result = '';

  if (parts.length > 1) {
    // In email addresses, only the domain name should be punycoded. Leave
    // the local part (i.e. everything up to `@`) intact.
    result = parts[0] + '@';
    string = parts[1];
  } // Avoid `split(regex)` for IE8 compatibility. See #17.


  string = string.replace(regexSeparators, '\x2E');
  var labels = string.split('.');
  var encoded = map$1(labels, fn).join('.');
  return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */


function ucs2decode(string) {
  var output = [],
      counter = 0,
      length = string.length,
      value,
      extra;

  while (counter < length) {
    value = string.charCodeAt(counter++);

    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // high surrogate, and there is a next character
      extra = string.charCodeAt(counter++);

      if ((extra & 0xFC00) == 0xDC00) {
        // low surrogate
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // unmatched surrogate; only append this code unit, in case the next
        // code unit is the high surrogate of a surrogate pair
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }

  return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */


function ucs2encode(array) {
  return map$1(array, function (value) {
    var output = '';

    if (value > 0xFFFF) {
      value -= 0x10000;
      output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
      value = 0xDC00 | value & 0x3FF;
    }

    output += stringFromCharCode(value);
    return output;
  }).join('');
}
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */


function basicToDigit(codePoint) {
  if (codePoint - 48 < 10) {
    return codePoint - 22;
  }

  if (codePoint - 65 < 26) {
    return codePoint - 65;
  }

  if (codePoint - 97 < 26) {
    return codePoint - 97;
  }

  return base;
}
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */


function digitToBasic(digit, flag) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
}
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */


function adapt(delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor(delta / damp) : delta >> 1;
  delta += floor(delta / numPoints);

  for (; delta > baseMinusTMin * tMax >> 1; k += base) {
    delta = floor(delta / baseMinusTMin);
  }

  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
}
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */


function decode(input) {
  // Don't use UCS-2
  var output = [],
      inputLength = input.length,
      out,
      i = 0,
      n = initialN,
      bias = initialBias,
      basic,
      j,
      index,
      oldi,
      w,
      k,
      digit,
      t,

  /** Cached calculation results */
  baseMinusT; // Handle the basic code points: let `basic` be the number of input code
  // points before the last delimiter, or `0` if there is none, then copy
  // the first basic code points to the output.

  basic = input.lastIndexOf(delimiter);

  if (basic < 0) {
    basic = 0;
  }

  for (j = 0; j < basic; ++j) {
    // if it's not a basic code point
    if (input.charCodeAt(j) >= 0x80) {
      error('not-basic');
    }

    output.push(input.charCodeAt(j));
  } // Main decoding loop: start just after the last delimiter if any basic code
  // points were copied; start at the beginning otherwise.


  for (index = basic > 0 ? basic + 1 : 0; index < inputLength;) {
    // `index` is the index of the next character to be consumed.
    // Decode a generalized variable-length integer into `delta`,
    // which gets added to `i`. The overflow checking is easier
    // if we increase `i` as we go, then subtract off its starting
    // value at the end to obtain `delta`.
    for (oldi = i, w = 1, k = base;; k += base) {
      if (index >= inputLength) {
        error('invalid-input');
      }

      digit = basicToDigit(input.charCodeAt(index++));

      if (digit >= base || digit > floor((maxInt - i) / w)) {
        error('overflow');
      }

      i += digit * w;
      t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;

      if (digit < t) {
        break;
      }

      baseMinusT = base - t;

      if (w > floor(maxInt / baseMinusT)) {
        error('overflow');
      }

      w *= baseMinusT;
    }

    out = output.length + 1;
    bias = adapt(i - oldi, out, oldi == 0); // `i` was supposed to wrap around from `out` to `0`,
    // incrementing `n` each time, so we'll fix that now:

    if (floor(i / out) > maxInt - n) {
      error('overflow');
    }

    n += floor(i / out);
    i %= out; // Insert `n` at position `i` of the output

    output.splice(i++, 0, n);
  }

  return ucs2encode(output);
}
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */


function encode(input) {
  var n,
      delta,
      handledCPCount,
      basicLength,
      bias,
      j,
      m,
      q,
      k,
      t,
      currentValue,
      output = [],

  /** `inputLength` will hold the number of code points in `input`. */
  inputLength,

  /** Cached calculation results */
  handledCPCountPlusOne,
      baseMinusT,
      qMinusT; // Convert the input in UCS-2 to Unicode

  input = ucs2decode(input); // Cache the length

  inputLength = input.length; // Initialize the state

  n = initialN;
  delta = 0;
  bias = initialBias; // Handle the basic code points

  for (j = 0; j < inputLength; ++j) {
    currentValue = input[j];

    if (currentValue < 0x80) {
      output.push(stringFromCharCode(currentValue));
    }
  }

  handledCPCount = basicLength = output.length; // `handledCPCount` is the number of code points that have been handled;
  // `basicLength` is the number of basic code points.
  // Finish the basic string - if it is not empty - with a delimiter

  if (basicLength) {
    output.push(delimiter);
  } // Main encoding loop:


  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next
    // larger one:
    for (m = maxInt, j = 0; j < inputLength; ++j) {
      currentValue = input[j];

      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    } // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
    // but guard against overflow


    handledCPCountPlusOne = handledCPCount + 1;

    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
      error('overflow');
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (j = 0; j < inputLength; ++j) {
      currentValue = input[j];

      if (currentValue < n && ++delta > maxInt) {
        error('overflow');
      }

      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer
        for (q = delta, k = base;; k += base) {
          t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;

          if (q < t) {
            break;
          }

          qMinusT = q - t;
          baseMinusT = base - t;
          output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
          q = floor(qMinusT / baseMinusT);
        }

        output.push(stringFromCharCode(digitToBasic(q, 0)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        ++handledCPCount;
      }
    }

    ++delta;
    ++n;
  }

  return output.join('');
}
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */


function toUnicode(input) {
  return mapDomain(input, function (string) {
    return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
  });
}
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */


function toASCII(input) {
  return mapDomain(input, function (string) {
    return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
  });
}

var version = '1.4.1';
/**
 * An object of methods to convert from JavaScript's internal character
 * representation (UCS-2) to Unicode code points, and back.
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode
 * @type Object
 */

var ucs2 = {
  decode: ucs2decode,
  encode: ucs2encode
};
var punycode = {
  version: version,
  ucs2: ucs2,
  toASCII: toASCII,
  toUnicode: toUnicode,
  encode: encode,
  decode: decode
};

var binSearchStartsWith = function binSearchStartsWith(array, value, getElementValue, listIsAscending) {
  var compare = listIsAscending ? function (a, b) {
    return a > b;
  } : function (a, b) {
    return a < b;
  };

  var _recBinSearchStartsWith = function recBinSearchStartsWith(start, end) {
    if (start > end) {
      return -1;
    }

    var mid = Math.floor((start + end) / 2);

    if (getElementValue(array[mid]).startsWith(value)) {
      return mid;
    }

    if (compare(getElementValue(array[mid]), value)) {
      return _recBinSearchStartsWith(start, mid - 1);
    }

    return _recBinSearchStartsWith(mid + 1, end);
  };

  return _recBinSearchStartsWith(0, array.length - 1);
};
/* 
Takes a sorted array and returns a shallow copy of array with all elements that 
start with startsWith. getElementvalue is a function that acceses the property 
of the elements in array that array is sorted by.
*/


var sortedFilterStartsWith = function sortedFilterStartsWith(array, startsWith, getElementValue, listIsAscending) {
  var elementIndx = binSearchStartsWith(array, startsWith, getElementValue, listIsAscending);

  if (elementIndx === -1) {
    return [];
  }

  var leftIndx = elementIndx;

  while (leftIndx > 0) {
    if (getElementValue(array[leftIndx - 1]).startsWith(startsWith)) {
      leftIndx -= 1;
    } else {
      break;
    }
  }

  var rightIndx = elementIndx + 1;

  while (rightIndx <= array.length - 1) {
    if (getElementValue(array[rightIndx]).startsWith(startsWith)) {
      rightIndx += 1;
    } else {
      break;
    }
  }

  return array.slice(leftIndx, rightIndx);
};

var sortedFilterStartsWithPropTypes = {
  array: PropTypes.array.isRequired,
  getElementValue: PropTypes.func,
  startsWith: PropTypes.string.isRequired
};
var sortedFilterStartsWithDefaultPropTypes = {
  getElementValue: function getElementValue(element) {
    return element;
  }
};
sortedFilterStartsWith.propTypes = sortedFilterStartsWithPropTypes;
sortedFilterStartsWith.defaultProps = sortedFilterStartsWithDefaultPropTypes;

var getLowestPrice = function getLowestPrice(price) {
  if (!price) {
    return '...';
  }

  if (typeof price === 'string') {
    return price;
  }

  var _price$regular = price.regular,
      regPrice = _price$regular.price,
      promoPrice = _price$regular.promo;
  return "$".concat(Math.min(regPrice, promoPrice).toFixed(2));
};

var getCurrentPrice = function getCurrentPrice(priceObj, currencyCode) {
  if (!priceObj) {
    return '';
  }

  var currentPrice = priceObj[currencyCode]; // if no price for this currency or price has no regular or sale component

  if (!currentPrice || !currentPrice.regular && !currentPrice.sale) {
    return '';
  }

  var firstTerm = priceObj.firstTerm,
      color = priceObj.color,
      _priceObj$prefix = priceObj.prefix,
      globalPrefix = _priceObj$prefix === void 0 ? '' : _priceObj$prefix,
      _priceObj$suffix = priceObj.suffix,
      globalSuffix = _priceObj$suffix === void 0 ? '' : _priceObj$suffix,
      _priceObj$strikeout = priceObj.strikeout,
      globalStrikeout = _priceObj$strikeout === void 0 ? false : _priceObj$strikeout;
  var itemCode = priceObj.itemCode ? priceObj.itemCode : null;
  var sale = currentPrice.sale,
      _currentPrice$strikeo = currentPrice.strikeout,
      strikeout = _currentPrice$strikeo === void 0 ? globalStrikeout : _currentPrice$strikeo;
  var renew = currentPrice.renew,
      regular = currentPrice.regular,
      _currentPrice$prefix = currentPrice.prefix,
      prefix = _currentPrice$prefix === void 0 ? globalPrefix : _currentPrice$prefix,
      _currentPrice$suffix = currentPrice.suffix,
      suffix = _currentPrice$suffix === void 0 ? globalSuffix : _currentPrice$suffix; // if regular or sale are missing, strikeout must be false

  strikeout = regular && sale ? strikeout : false; // use regular price as sale if sale is missing

  sale = !sale && regular ? regular : sale; // return new object with modified values

  return {
    firstTerm: firstTerm,
    color: color,
    regular: regular,
    sale: sale,
    renew: renew,
    strikeout: strikeout,
    prefix: prefix,
    suffix: suffix,
    itemCode: itemCode
  };
};

var getDisplayPrice = function getDisplayPrice(price, currencyCode) {
  if (!price || !currencyCode) {
    return null;
  }
  /* This if statement is a temporary solution for integrating dynamic prices */


  if (price[currencyCode]) {
    if (price[currencyCode].regular === 0) {
      if (price[currencyCode].renew === 0) {
        price[currencyCode].sale = 'Free';
      } else {
        price[currencyCode].sale = price[currencyCode].renew;
      }

      var _sale = price[currencyCode].sale;

      var _symbol = Number.isNaN(parseFloat(_sale)) ? '' : '$';

      if (typeof _sale === 'number') {
        return "".concat(_symbol).concat(_sale.toFixed(2));
      }

      return "".concat(_symbol).concat(_sale);
    }
  }

  var currentPrice = getCurrentPrice(price, currencyCode);

  if (!currentPrice) {
    return '';
  }

  var sale = currentPrice.sale;
  var symbol = Number.isNaN(parseFloat(sale)) ? '' : '$';

  if (typeof sale === 'number') {
    return "".concat(symbol).concat(sale.toFixed(2));
  }

  return "".concat(symbol).concat(sale);
};

var getFloatPrice = function getFloatPrice(price, currencyCode) {
  if (!price || !currencyCode) {
    return null;
  }

  var currentPrice = getCurrentPrice(price, currencyCode);

  if (!currentPrice) {
    return 0;
  }

  var sale = currentPrice.sale;
  var parsedSale = parseFloat(sale);
  return Number.isNaN(parsedSale) ? 0 : parsedSale;
};

function ownKeys$1i(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1i(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1i(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1i(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var defaultProps$J = {
  variant: 'default'
};
var propTypes$1o = {
  currencyCode: PropTypes.string.isRequired,
  price: PropTypes.shape({
    firstTerm: PropTypes.object,
    prefix: PropTypes.string,
    regular: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    sale: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    strikeout: PropTypes.bool,
    suffix: PropTypes.string
  }).isRequired,
  variant: PropTypes.string
};

var PricingWrapper$1 = function PricingWrapper(_ref) {
  var price = _ref.price,
      currencyCode = _ref.currencyCode,
      children = _ref.children;
  var currentPrice = getCurrentPrice(price, currencyCode);

  if (!currentPrice) {
    return '';
  }

  if (currentPrice.sale === 0 || typeof currentPrice.sale === 'number') {
    currentPrice.sale = currentPrice.sale.toFixed(2);
  }

  if (currentPrice.regular === 0 || typeof currentPrice.regular === 'number') {
    currentPrice.regular = currentPrice.regular.toFixed(2);
  }

  if (currentPrice.renew === 0 || typeof currentPrice.renew === 'number') {
    currentPrice.renew = currentPrice.renew.toFixed(2);
  }

  var sale = currentPrice.sale,
      renew = currentPrice.renew;
  var symbol = '$';

  if (Number.isNaN(parseFloat(sale)) && Number.isNaN(parseFloat(renew))) {
    symbol = '';
  }

  return children(_objectSpread$1i(_objectSpread$1i({}, currentPrice), {}, {
    symbol: symbol
  }));
};

function Price(_ref2) {
  var currencyCode = _ref2.currencyCode,
      price = _ref2.price,
      variant = _ref2.variant;
  return /*#__PURE__*/jsx$1(PricingWrapper$1, {
    currencyCode: currencyCode,
    price: price,
    children: function children(_ref3) {
      var firstTerm = _ref3.firstTerm,
          prefix = _ref3.prefix,
          suffix = _ref3.suffix,
          symbol = _ref3.symbol,
          sale = _ref3.sale,
          regular = _ref3.regular,
          renew = _ref3.renew,
          strikeout = _ref3.strikeout,
          itemCode = _ref3.itemCode;

      var shouldShowRenew = function shouldShowRenew() {
        return renew && (renew !== regular || sale && sale !== renew);
      };

      return /*#__PURE__*/jsxs(Stack$2, {
        mt: 4,
        children: [firstTerm && (!variant || variant === 'default') && /*#__PURE__*/jsx$1(Box$1, {
          alignItems: "flex-end",
          bg: "".concat(firstTerm.color, "Light"),
          my: 2,
          children: /*#__PURE__*/jsx$1(Text$1, {
            color: "".concat(firstTerm.color, "Dark"),
            fontFamily: "title",
            mx: 2,
            variant: "gigaBold",
            children: firstTerm.text
          })
        }), prefix ? /*#__PURE__*/jsx$1(Text$1, {
          variant: "milli",
          children: prefix
        }) : null, /*#__PURE__*/jsx$1(Box$1, {
          alignItems: "flex-end",
          children: strikeout && !renew ? /*#__PURE__*/jsxs(Box$1, {
            alignItems: "flex-end",
            children: [/*#__PURE__*/jsx$1(Text$1, {
              as: "strike",
              color: "black",
              "data-testid": itemCode,
              fontFamily: "title",
              lineHeight: "1.4",
              mr: 2,
              variant: "giga",
              children: "".concat(symbol).concat(regular)
            }), /*#__PURE__*/jsx$1(Text$1, {
              fontFamily: "title",
              lineHeight: "1.2",
              variant: "peta",
              children: "".concat(symbol).concat(sale)
            }), suffix ? /*#__PURE__*/jsx$1(Text$1, {
              ml: 1,
              variant: "milli",
              children: suffix
            }) : null]
          }) : /*#__PURE__*/jsxs(Box$1, {
            flexDirection: "column",
            children: [/*#__PURE__*/jsxs(Box$1, {
              alignItems: "flex-end",
              flexDirection: "row",
              children: [/*#__PURE__*/jsx$1(Text$1, {
                color: "black",
                "data-testid": itemCode,
                fontFamily: "title",
                lineHeight: "1.3",
                mr: 2,
                variant: "peta",
                children: "".concat(symbol).concat(regular)
              }), suffix ? /*#__PURE__*/jsx$1(Text$1, {
                ml: 1,
                variant: "milli",
                children: suffix
              }) : null]
            }), shouldShowRenew() && /*#__PURE__*/jsxs(Text$1, {
              lineHeight: "1.3",
              mr: 2,
              mt: 1,
              variant: "milli",
              children: ["Renews at ", "".concat(symbol).concat(renew)]
            })]
          })
        }), firstTerm && variant === 'inverted' && /*#__PURE__*/jsx$1(Box$1, {
          alignItems: "flex-end",
          bg: "".concat(firstTerm.color, "Light"),
          mt: 2,
          children: /*#__PURE__*/jsx$1(Text$1, {
            color: "".concat(firstTerm.color, "Dark"),
            fontFamily: "title",
            mx: 2,
            variant: "gigaBold",
            children: firstTerm.text
          })
        })]
      });
    }
  });
}

Price.getCurrentPrice = getCurrentPrice;
Price.getDisplayPrice = getDisplayPrice;
Price.getFloatPrice = getFloatPrice;
Price.getLowestPrice = getLowestPrice;
Price.propTypes = propTypes$1o;
Price.defaultProps = defaultProps$J;
var propTypes$1n = {
  price: PropTypes.shape({
    firstTerm: PropTypes.shape({
      color: PropTypes.string,
      text: PropTypes.string
    })
  }).isRequired
};

function SaleBox(_ref) {
  var price = _ref.price;
  return price.firstTerm ? /*#__PURE__*/jsx$1(Stack$2, {
    children: /*#__PURE__*/jsx$1(Box$1, {
      alignItems: "flex-end",
      bg: "".concat(price.firstTerm.color, "Light"),
      children: /*#__PURE__*/jsx$1(Text$1, {
        color: "".concat(price.firstTerm.color, "Dark"),
        fontFamily: "title",
        mx: 2,
        variant: "gigaBold",
        children: price.firstTerm.text
      })
    })
  }) : null;
}

SaleBox.propTypes = propTypes$1n;

function ownKeys$1h(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1h(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1h(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1h(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var propTypes$1m = {
  currencyCode: PropTypes.string.isRequired,
  price: PropTypes.shape({
    prefix: PropTypes.string,
    regular: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    sale: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    strikeout: PropTypes.bool,
    suffix: PropTypes.string
  }).isRequired
};

var PricingWrapper = function PricingWrapper(_ref) {
  var price = _ref.price,
      currencyCode = _ref.currencyCode,
      children = _ref.children;
  var currentPrice = getCurrentPrice(price, currencyCode);

  if (!currentPrice) {
    return '';
  }

  if (currentPrice.sale === 0 || typeof currentPrice.sale === 'number') {
    currentPrice.sale = currentPrice.sale.toFixed(2);
  }

  if (currentPrice.regular === 0 || typeof currentPrice.regular === 'number') {
    currentPrice.regular = currentPrice.regular.toFixed(2);
  }

  if (currentPrice.renew === 0 || typeof currentPrice.renew === 'number') {
    currentPrice.renew = currentPrice.renew.toFixed(2);
  }

  var sale = currentPrice.sale,
      renew = currentPrice.renew;
  var symbol = '$';

  if (Number.isNaN(parseFloat(sale)) && Number.isNaN(parseFloat(renew))) {
    symbol = '';
  }

  return children(_objectSpread$1h(_objectSpread$1h({}, currentPrice), {}, {
    symbol: symbol
  }));
};

function PriceBox(_ref2) {
  var currencyCode = _ref2.currencyCode,
      price = _ref2.price;
  return /*#__PURE__*/jsx$1(PricingWrapper, {
    currencyCode: currencyCode,
    price: price,
    children: function children(_ref3) {
      var prefix = _ref3.prefix,
          suffix = _ref3.suffix,
          symbol = _ref3.symbol,
          sale = _ref3.sale,
          regular = _ref3.regular,
          renew = _ref3.renew,
          strikeout = _ref3.strikeout,
          itemCode = _ref3.itemCode;

      var shouldShowRenew = function shouldShowRenew() {
        return renew && (renew !== regular || sale && sale !== renew);
      };

      return /*#__PURE__*/jsxs(Stack$2, {
        children: [prefix ? /*#__PURE__*/jsx$1(Text$1, {
          variant: "milli",
          children: prefix
        }) : null, /*#__PURE__*/jsx$1(Box$1, {
          alignItems: "flex-end",
          children: strikeout && !renew ? /*#__PURE__*/jsxs(Box$1, {
            alignItems: "flex-end",
            children: [/*#__PURE__*/jsx$1(Text$1, {
              as: "strike",
              color: "black",
              "data-testid": itemCode,
              fontFamily: "title",
              lineHeight: "1.4",
              mr: 2,
              variant: "giga",
              children: "".concat(symbol).concat(regular)
            }), /*#__PURE__*/jsx$1(Text$1, {
              fontFamily: "title",
              lineHeight: "1.2",
              variant: "peta",
              children: "".concat(symbol).concat(sale)
            }), suffix ? /*#__PURE__*/jsx$1(Text$1, {
              ml: 1,
              variant: "milli",
              children: suffix
            }) : null]
          }) : /*#__PURE__*/jsxs(Box$1, {
            flexDirection: "column",
            children: [/*#__PURE__*/jsxs(Box$1, {
              alignItems: "flex-end",
              flexDirection: "row",
              children: [/*#__PURE__*/jsx$1(Text$1, {
                color: "black",
                "data-testid": itemCode,
                fontFamily: "title",
                lineHeight: "1.3",
                mr: 2,
                variant: "peta",
                children: "".concat(symbol).concat(regular)
              }), suffix ? /*#__PURE__*/jsx$1(Text$1, {
                ml: 1,
                variant: "milli",
                children: suffix
              }) : null]
            }), shouldShowRenew() && /*#__PURE__*/jsxs(Text$1, {
              lineHeight: "1.3",
              mr: 2,
              mt: 1,
              variant: "milli",
              children: ["Renews at ", "".concat(symbol).concat(renew)]
            })]
          })
        })]
      });
    }
  });
}

PriceBox.getCurrentPrice = getCurrentPrice;
PriceBox.getDisplayPrice = getDisplayPrice;
PriceBox.getFloatPrice = getFloatPrice;
PriceBox.getLowestPrice = getLowestPrice;
PriceBox.propTypes = propTypes$1m;
var _excluded$v = ["buttonColour", "buttonMarginTop", "buttonTextElement", "buttonWidth", "list", "listGridColumn", "listGridRow", "renderListItem", "renderOffset", "useButtonVariant"];

function ownKeys$1g(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1g(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1g(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1g(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var defaultProps$I = {
  buttonColour: '',
  buttonMarginTop: '',
  buttonTextElement: /*#__PURE__*/jsx$1(Text$1, {
    variant: "giga",
    children: " Load More"
  }),
  buttonWidth: '',
  listGridColumn: '1fr',
  listGridRow: '',
  useButtonVariant: true
};
var propTypes$1l = {
  buttonColour: PropTypes.string,
  buttonMarginTop: PropTypes.string,
  buttonTextElement: PropTypes.object,
  buttonWidth: PropTypes.string,
  list: PropTypes.array.isRequired,
  listGridColumn: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  listGridRow: PropTypes.string,
  renderListItem: PropTypes.func.isRequired,
  renderOffset: PropTypes.number.isRequired,
  useButtonVariant: PropTypes.bool
};

function LoadMoreContainer(_ref) {
  var buttonColour = _ref.buttonColour,
      buttonMarginTop = _ref.buttonMarginTop,
      buttonTextElement = _ref.buttonTextElement,
      buttonWidth = _ref.buttonWidth,
      list = _ref.list,
      listGridColumn = _ref.listGridColumn,
      listGridRow = _ref.listGridRow,
      renderListItem = _ref.renderListItem,
      renderOffset = _ref.renderOffset,
      useButtonVariant = _ref.useButtonVariant,
      rest = _objectWithoutProperties$8(_ref, _excluded$v);

  var _useState = useState(list.slice(0, renderOffset)),
      _useState2 = _slicedToArray$4(_useState, 2),
      renderedList = _useState2[0],
      setRenderList = _useState2[1];

  var loadMore = function loadMore() {
    var loadedItems = list.slice(renderedList.length, renderedList.length + renderOffset);
    setRenderList(renderedList.concat(loadedItems));
  };

  useEffect(function () {
    setRenderList(list.slice(0, renderOffset));
  }, [list]);

  function setButtonColour() {
    if (buttonColour === '' || buttonColour === 'undefined') {
      return isInternic ? 'blueDark' : 'greenDark';
    }

    return buttonColour;
  }

  function setButtonVariant() {
    return useButtonVariant ? 'inverse' : 'solid';
  }

  var finalButtonColour = setButtonColour();
  var buttonVariant = setButtonVariant();
  return /*#__PURE__*/jsxs(Stack$2, _objectSpread$1g(_objectSpread$1g({}, rest), {}, {
    width: "100%",
    children: [/*#__PURE__*/jsx$1(Grid$1, {
      gridTemplateColumns: listGridColumn,
      gridTemplateRows: "repeat(".concat(renderedList.length, ", ").concat(listGridRow, ")"),
      width: "100%",
      children: renderedList && renderedList.map(renderListItem)
    }), renderedList.length < list.length ? /*#__PURE__*/jsx$1(Button$1, {
      alignSelf: "center",
      color: finalButtonColour,
      mt: buttonMarginTop !== '' ? buttonMarginTop : 4,
      onClick: loadMore,
      variant: buttonVariant,
      width: buttonWidth !== '' ? buttonWidth : '20rem',
      children: buttonTextElement
    }) : null]
  }));
}

LoadMoreContainer.defaultProps = defaultProps$I;
LoadMoreContainer.propTypes = propTypes$1l;

function _regenerator$Y() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$Y(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$Y(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$Y(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$Y(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$Y(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$Y(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$Y(u), _regeneratorDefine2$Y(u, o, "Generator"), _regeneratorDefine2$Y(u, n, function () {
    return this;
  }), _regeneratorDefine2$Y(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$Y = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$Y(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$Y = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$Y(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$Y(e, r, n, t);
}

var defaultProps$H = {
  placeholder: 'Search...',
  promoTLDs: [],
  searchColor: 'greenLight'
};
var propTypes$1k = {
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  promoTLDs: PropTypes.arrayOf(PropTypes.shape({
    price: PropTypes.shape({})
  })),
  searchColor: PropTypes.string
};

function TLDSearchBox(_ref) {
  var id = _ref.id,
      tldSearchConfig = _ref.tldSearchConfig,
      promoTLDs = _ref.promoTLDs,
      placeholder = _ref.placeholder,
      searchColor = _ref.searchColor,
      allTldPrices = _ref.allTldPrices;

  var _useState = useState([]),
      _useState2 = _slicedToArray$4(_useState, 2),
      allTLDs = _useState2[0],
      setAllTLDs = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$4(_useState3, 2),
      drawnTLDs = _useState4[0],
      setDrawnTLDs = _useState4[1];

  var popularTlds = tldSearchConfig.popularTlds,
      newestTlds = tldSearchConfig.newestTlds,
      onSaleTlds = tldSearchConfig.onSaleTlds;

  var _useSessionService = useSessionService(),
      currentCode = _useSessionService.data.currentCurrency.code;

  var getTLDsPrices = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$Y().m(function _callee() {
      var prices;
      return _regenerator$Y().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              prices = allTldPrices;

              if (prices) {
                prices.forEach(function (tld) {
                  tld.name = punycode.toUnicode(tld.name);
                });
                prices.sort(function (tld1, tld2) {
                  return tld1.name.localeCompare(tld2.name);
                });
                setAllTLDs(prices);
                setDrawnTLDs(prices);
              }

            case 1:
              return _context.a(2);
          }
        }
      }, _callee);
    }));

    return function getTLDsPrices() {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    getTLDsPrices();
  }, [currentCode]);

  var onSearch = function onSearch(searchBarText) {
    if (searchBarText === '') {
      setDrawnTLDs(allTLDs);
      return;
    }

    var parsedSearch = searchBarText.startsWith('.') ? searchBarText.substring(1).toLowerCase() : searchBarText.toLowerCase();
    var newDrawnTLDs = sortedFilterStartsWith(allTLDs, parsedSearch, function (tld) {
      return tld.name;
    }, true);
    setDrawnTLDs(newDrawnTLDs);
  };

  var onSortAlpha = function onSortAlpha() {
    setDrawnTLDs(allTLDs);
  };

  var onSortPopular = function onSortPopular() {
    var prices = [];
    popularTlds.forEach(function (popularTld) {
      prices.push(allTLDs.find(function (tld) {
        return tld.name.toLowerCase() === popularTld.toLowerCase();
      }));
    });
    setDrawnTLDs(prices);
  };

  var onSortNewest = function onSortNewest() {
    var prices = [];
    newestTlds.forEach(function (newTld) {
      prices.push(allTLDs.find(function (tld) {
        return tld.name.toLowerCase() === newTld.toLowerCase();
      }));
    });
    setDrawnTLDs(prices);
  };

  var onSortSale = function onSortSale() {
    var prices = [];
    onSaleTlds.forEach(function (onSaleTld) {
      prices.push(allTLDs.find(function (tld) {
        return tld.name.toLowerCase() === onSaleTld.toLowerCase();
      }));
    });
    setDrawnTLDs(prices);
  };

  var onSortTwoLetter = function onSortTwoLetter() {
    var prices = allTLDs.filter(function (tld) {
      return tld.name.length === 2;
    });
    setDrawnTLDs(prices);
  };

  var onSortPriceLow = function onSortPriceLow() {
    var prices = _toConsumableArray$1(allTLDs);

    prices.sort(function (a, b) {
      if (!a.prices.CAD || !b.prices.CAD) {
        return -1;
      }

      return a.prices.CAD.regular - b.prices.CAD.regular;
    });
    setDrawnTLDs(prices);
  };

  var renderRow = function renderRow(tld) {
    var tldPrice = tld.prices[currentCode.toUpperCase()];
    var tldRegular = tldPrice ? tldPrice.regular.toFixed(2).toString() : '';
    var tldRenew = tldPrice ? tldPrice.renew.toFixed(2).toString() : '';
    return [/*#__PURE__*/jsx$1(Box$1, {
      alignItems: "center",
      bg: "white",
      borderBottom: "light",
      borderLeft: "light",
      pl: [3, 4],
      width: "100%",
      children: /*#__PURE__*/jsx$1(Link$1, {
        href: "/tlds/".concat(tld.name),
        children: ".".concat(tld.name)
      })
    }, "tld-".concat(tld.name, "-redirect")), /*#__PURE__*/jsx$1(Box$1, {
      alignItems: "center",
      bg: "white",
      borderBottom: "light",
      justifyContent: "flex-end",
      pr: [3, 4],
      width: "100%",
      children: tldRegular === tldRenew ? /*#__PURE__*/jsx$1(Text$1, {
        children: tldRegular
      }) : /*#__PURE__*/jsx$1(Text$1, {
        color: "mintGreenDark",
        variant: "megaBold",
        children: tldRegular
      })
    }, "tld-".concat(tld.name, "-price")), /*#__PURE__*/jsx$1(Box$1, {
      alignItems: "center",
      bg: "white",
      borderBottom: "light",
      borderRight: "light",
      justifyContent: "flex-end",
      pr: [3, 4],
      width: "100%",
      children: /*#__PURE__*/jsx$1(Text$1, {
        alignSelf: "center",
        children: tldRenew
      })
    }, "tld-".concat(tld.name, "-renewal"))];
  };

  var content;

  if (!drawnTLDs) {
    content = /*#__PURE__*/jsxs(Stack$2, {
      width: "100%",
      children: [/*#__PURE__*/jsx$1(Skeleton$1, {
        height: "8rem",
        mb: 2,
        width: "100%"
      }), /*#__PURE__*/jsx$1(Skeleton$1, {
        height: "8rem",
        mb: 2,
        width: "100%"
      }), /*#__PURE__*/jsx$1(Skeleton$1, {
        height: "8rem",
        mb: 2,
        width: "100%"
      }), /*#__PURE__*/jsx$1(Skeleton$1, {
        height: "8rem",
        width: "100%"
      })]
    });
  } else if (drawnTLDs.length > 0) {
    content = /*#__PURE__*/jsx$1(LoadMoreContainer, {
      list: drawnTLDs,
      listGridColumn: ['1fr 1fr 1fr', '2fr 1fr 1fr'],
      listGridRow: "8rem",
      renderListItem: renderRow,
      renderOffset: 10
    });
  } else {
    content = /*#__PURE__*/jsx$1(Box$1, {
      alignItems: "center",
      bg: "white",
      borderBottom: "light",
      borderX: "light",
      height: "38rem",
      width: "100%",
      children: /*#__PURE__*/jsx$1(Text$1, {
        alignSelf: "center",
        textAlign: "center",
        variant: ['teraBold', 'petaBold'],
        width: "100%",
        children: "Sorry, we could not find any results"
      })
    });
  }

  return /*#__PURE__*/jsxs(Stack$2, {
    width: "100%",
    children: [/*#__PURE__*/jsx$1(Box$1, {
      bg: searchColor,
      justifyContent: "center",
      width: "100%",
      children: /*#__PURE__*/jsxs(Box$1, {
        flexDirection: ['column', 'column', 'row'],
        gridGap: [0, 2, 3],
        justifyContent: "center",
        maxWidth: ['containers.lg'],
        pt: 2,
        px: 3,
        width: "100%",
        children: [/*#__PURE__*/jsx$1(Box$1, {
          display: "flex",
          height: "4rem",
          maxWidth: "45rem",
          mx: "auto",
          my: "2rem",
          width: "100%",
          children: /*#__PURE__*/jsx$1(SearchBar, {
            background: "white",
            id: id,
            onType: onSearch,
            placeholder: placeholder
          })
        }), /*#__PURE__*/jsx$1(Box$1, {
          alignItems: "center",
          display: ['none', 'none', 'flex'],
          flex: "1 1 50%",
          flexWrap: "wrap",
          justifyContent: "space-around",
          children: promoTLDs && promoTLDs.map(function (tld) {
            return /*#__PURE__*/jsxs(Box$1, {
              alignItems: "center",
              mb: 3,
              children: [tld.text ? /*#__PURE__*/jsx$1(Text$1, {
                variant: "gigaBold",
                children: tld.text
              }) : null, tld.icon ? /*#__PURE__*/jsx$1(Icon$2, {
                height: "2rem",
                name: tld.icon.name,
                title: tld.icon.name,
                titleId: tld.icon.name,
                width: tld.icon.width || '5rem'
              }) : null, tld.price ? /*#__PURE__*/jsx$1(Text$1, {
                ml: 3,
                variant: "mega",
                children: "".concat(Price.getDisplayPrice(tld.price.dynamicPrice.prices, currentCode.toUpperCase()))
              }) : null]
            }, tld.id);
          })
        })]
      })
    }), /*#__PURE__*/jsx$1(Box$1, {
      bg: searchColor,
      justifyContent: "center",
      width: "100%",
      children: /*#__PURE__*/jsxs(Box$1, {
        alignItems: "center",
        flex: "1 1 50%",
        flexWrap: "wrap",
        justifyContent: "space-evenly",
        mb: "2",
        mx: "3",
        children: [/*#__PURE__*/jsx$1(Button$1, {
          color: "black",
          mx: "1",
          onClick: onSortAlpha,
          variant: "underlined",
          children: "All A-Z"
        }), /*#__PURE__*/jsx$1(Button$1, {
          color: "black",
          mx: "1",
          onClick: onSortPriceLow,
          variant: "underlined",
          children: "Lowest prices"
        }), /*#__PURE__*/jsx$1(Button$1, {
          color: "black",
          mx: "1",
          onClick: onSortPopular,
          variant: "underlined",
          children: "Most Popular"
        }), /*#__PURE__*/jsx$1(Button$1, {
          color: "black",
          mx: "1",
          onClick: onSortSale,
          variant: "underlined",
          children: "On Sale"
        }), /*#__PURE__*/jsx$1(Button$1, {
          color: "black",
          display: ['none', 'none', 'flex'],
          mx: "1",
          onClick: onSortNewest,
          variant: "underlined",
          children: "Newest"
        }), /*#__PURE__*/jsx$1(Button$1, {
          color: "black",
          display: ['none', 'none', 'flex'],
          mx: "1",
          onClick: onSortTwoLetter,
          variant: "underlined",
          children: "Two Letters"
        })]
      })
    }), /*#__PURE__*/jsxs(Grid$1, {
      alignSelf: "center",
      bg: "white",
      border: "light",
      gridTemplateColumns: ['1fr 1fr 1fr', '2fr 1fr 1fr'],
      gridTemplateRows: "8rem",
      width: "100%",
      children: [/*#__PURE__*/jsx$1(Box$1, {
        alignItems: "center",
        width: "100%",
        children: /*#__PURE__*/jsx$1(Heading, {
          pl: [3, 4],
          variant: ['megaBold', 'gigaBold'],
          children: "TLD"
        })
      }), /*#__PURE__*/jsx$1(Box$1, {
        alignItems: "center",
        justifyContent: "flex-end",
        width: "100%",
        children: /*#__PURE__*/jsx$1(Heading, {
          pr: [3, 4],
          variant: ['megaBold', 'gigaBold'],
          children: "Registration"
        })
      }), /*#__PURE__*/jsx$1(Box$1, {
        alignItems: "center",
        justifyContent: "flex-end",
        width: "100%",
        children: /*#__PURE__*/jsx$1(Heading, {
          pr: [3, 4],
          variant: ['megaBold', 'gigaBold'],
          children: "Renewals"
        })
      })]
    }), content]
  });
}

TLDSearchBox.defaultProps = defaultProps$H;
TLDSearchBox.propTypes = propTypes$1k;
var defaultProps$G = {
  height: '100px',
  templateId: '53aa8807dec7e10d38f59f32',
  theme: 'dark',
  width: '150px'
};
var propTypes$1j = {
  height: PropTypes.string,
  templateId: PropTypes.string,
  theme: PropTypes.oneOf(['light', 'dark']),
  width: PropTypes.string
};

function TrustPilotWidget(_ref) {
  var templateId = _ref.templateId,
      theme = _ref.theme,
      height = _ref.height,
      width = _ref.width;
  var ref = useRef();
  useEffect(function () {
    if (hasDOM && window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current);
    }
  }, []);
  return /*#__PURE__*/jsx$1(Box$1, {
    ref: ref,
    className: "trustpilot-widget",
    "data-businessunit-id": "5a737c2d6d85700001b19b9c",
    "data-locale": "en-US",
    "data-stars": "4,5",
    "data-style-height": height,
    "data-style-width": width,
    "data-template-id": templateId,
    "data-theme": theme,
    height: height,
    role: "button",
    width: width,
    children: /*#__PURE__*/jsx$1(Link$1, {
      ariaLabel: "Rebel's Trustpilot score",
      color: theme === 'dark' ? 'white' : 'black',
      href: "https://www.trustpilot.com/review/rebel.com",
      newTab: true,
      children: "Trustpilot"
    })
  });
}

TrustPilotWidget.defaultProps = defaultProps$G;
TrustPilotWidget.propTypes = propTypes$1j;

function hasDocumentCookie() {
  // Can we get/set cookies on document.cookie?
  return typeof document === 'object' && typeof document.cookie === 'string';
}

function parseCookies(cookies, options) {
  if (typeof cookies === 'string') {
    return cookie.parse(cookies, options);
  } else if (typeof cookies === 'object' && cookies !== null) {
    return cookies;
  } else {
    return {};
  }
}

function isParsingCookie(value, doNotParse) {
  if (typeof doNotParse === 'undefined') {
    // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
  }

  return !doNotParse;
}

function readCookie(value, options) {
  if (options === void 0) {
    options = {};
  }

  var cleanValue = cleanupCookieValue(value);

  if (isParsingCookie(cleanValue, options.doNotParse)) {
    try {
      return JSON.parse(cleanValue);
    } catch (e) {// At least we tried
    }
  } // Ignore clean value if we failed the deserialization
  // It is not relevant anymore to trim those values


  return value;
}

function cleanupCookieValue(value) {
  // express prepend j: before serializing a cookie
  if (value && value[0] === 'j' && value[1] === ':') {
    return value.substr(2);
  }

  return value;
}

var __assign$1 = undefined && undefined.__assign || function () {
  __assign$1 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$1.apply(this, arguments);
};

var Cookies = function () {
  function Cookies(cookies, options) {
    var _this = this;

    this.changeListeners = [];
    this.HAS_DOCUMENT_COOKIE = false;
    this.cookies = parseCookies(cookies, options);
    new Promise(function () {
      _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
    }).catch(function () {});
  }

  Cookies.prototype._updateBrowserValues = function (parseOptions) {
    if (!this.HAS_DOCUMENT_COOKIE) {
      return;
    }

    this.cookies = cookie.parse(document.cookie, parseOptions);
  };

  Cookies.prototype._emitChange = function (params) {
    for (var i = 0; i < this.changeListeners.length; ++i) {
      this.changeListeners[i](params);
    }
  };

  Cookies.prototype.get = function (name, options, parseOptions) {
    if (options === void 0) {
      options = {};
    }

    this._updateBrowserValues(parseOptions);

    return readCookie(this.cookies[name], options);
  };

  Cookies.prototype.getAll = function (options, parseOptions) {
    if (options === void 0) {
      options = {};
    }

    this._updateBrowserValues(parseOptions);

    var result = {};

    for (var name_1 in this.cookies) {
      result[name_1] = readCookie(this.cookies[name_1], options);
    }

    return result;
  };

  Cookies.prototype.set = function (name, value, options) {
    var _a;

    if (typeof value === 'object') {
      value = JSON.stringify(value);
    }

    this.cookies = __assign$1(__assign$1({}, this.cookies), (_a = {}, _a[name] = value, _a));

    if (this.HAS_DOCUMENT_COOKIE) {
      document.cookie = cookie.serialize(name, value, options);
    }

    this._emitChange({
      name: name,
      value: value,
      options: options
    });
  };

  Cookies.prototype.remove = function (name, options) {
    var finalOptions = options = __assign$1(__assign$1({}, options), {
      expires: new Date(1970, 1, 1, 0, 0, 1),
      maxAge: 0
    });

    this.cookies = __assign$1({}, this.cookies);
    delete this.cookies[name];

    if (this.HAS_DOCUMENT_COOKIE) {
      document.cookie = cookie.serialize(name, '', finalOptions);
    }

    this._emitChange({
      name: name,
      value: undefined,
      options: options
    });
  };

  Cookies.prototype.addChangeListener = function (callback) {
    this.changeListeners.push(callback);
  };

  Cookies.prototype.removeChangeListener = function (callback) {
    var idx = this.changeListeners.indexOf(callback);

    if (idx >= 0) {
      this.changeListeners.splice(idx, 1);
    }
  };

  return Cookies;
}();

var Cookies$1 = Cookies;
var CookiesContext = React.createContext(new Cookies$1());
CookiesContext.Provider;
CookiesContext.Consumer;
var CookiesContext$1 = CookiesContext;

function isInBrowser() {
  return typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';
}

function useCookies(dependencies) {
  var cookies = useContext(CookiesContext$1);

  if (!cookies) {
    throw new Error('Missing <CookiesProvider>');
  }

  var initialCookies = cookies.getAll();

  var _a = useState(initialCookies),
      allCookies = _a[0],
      setCookies = _a[1];

  var previousCookiesRef = useRef(allCookies);

  if (isInBrowser()) {
    useLayoutEffect(function () {
      function onChange() {
        var newCookies = cookies.getAll();

        if (shouldUpdate(dependencies || null, newCookies, previousCookiesRef.current)) {
          setCookies(newCookies);
        }

        previousCookiesRef.current = newCookies;
      }

      cookies.addChangeListener(onChange);
      return function () {
        cookies.removeChangeListener(onChange);
      };
    }, [cookies]);
  }

  var setCookie = useMemo(function () {
    return cookies.set.bind(cookies);
  }, [cookies]);
  var removeCookie = useMemo(function () {
    return cookies.remove.bind(cookies);
  }, [cookies]);
  return [allCookies, setCookie, removeCookie];
}

function shouldUpdate(dependencies, newCookies, oldCookies) {
  if (!dependencies) {
    return true;
  }

  for (var _i = 0, dependencies_1 = dependencies; _i < dependencies_1.length; _i++) {
    var dependency = dependencies_1[_i];

    if (newCookies[dependency] !== oldCookies[dependency]) {
      return true;
    }
  }

  return false;
}

function _regenerator$X() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$X(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$X(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$X(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$X(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$X(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$X(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$X(u), _regeneratorDefine2$X(u, o, "Generator"), _regeneratorDefine2$X(u, n, function () {
    return this;
  }), _regeneratorDefine2$X(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$X = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$X(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$X = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$X(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$X(e, r, n, t);
}

function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");

  return "symbol" == _typeof$2(i) ? i : i + "";
}

function _toPrimitive(t, r) {
  if ("object" != _typeof$2(t) || !t) return t;
  var e = t[Symbol.toPrimitive];

  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof$2(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return ("string" === r ? String : Number)(t);
}

function ownKeys$1f(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1f(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1f(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1f(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var SupportRequests = storageKeys.SupportRequests;
var REBEL_WEB_DESIGN = 'rebel-web-design';
var HOSTING_MIGRATION = 'hosting-migration';
var ONE_ON_ONE_SETUP = 'one-on-one-setup';
var SUPPORT_REQUEST_TYPES = {
  REBEL_WEB_DESIGN: REBEL_WEB_DESIGN,
  HOSTING_MIGRATION: HOSTING_MIGRATION,
  ONE_ON_ONE_SETUP: ONE_ON_ONE_SETUP
};

var setSupportRequest = function setSupportRequest(requestType) {
  var currentSupportRequests = LS.getItem(SupportRequests);

  var newSupportRequest = _objectSpread$1f(_objectSpread$1f({}, currentSupportRequests), {}, _defineProperty$6({}, requestType, {
    requestType: requestType
  }));

  LS.setItem(SupportRequests, newSupportRequest);
};

var getSupportRequest = function getSupportRequest(type) {
  // gets the support request by type if it exists, otherwise it returns null
  var currentSupportRequests = LS.getItem(SupportRequests);
  return currentSupportRequests && currentSupportRequests[type] ? currentSupportRequests[type] : null;
};

var removeSupportRequest = function removeSupportRequest(type) {
  // gets the support request by type if it exists, otherwise it returns null
  var currentSupportRequests = LS.getItem(SupportRequests);

  if (!currentSupportRequests) {
    return;
  }

  currentSupportRequests[type];

  var rest = _objectWithoutProperties$8(currentSupportRequests, [type].map(_toPropertyKey));

  var updatedSupportRequests = _objectSpread$1f({}, rest);

  if (Object.keys(updatedSupportRequests).length > 0) {
    LS.setItem(SupportRequests, updatedSupportRequests);
  } else {
    // remove it completely if it's empty
    LS.removeItem(SupportRequests);
  }
};

var submitSupportRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$X().m(function _callee(request) {
    var result;
    return _regenerator$X().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            _context.n = 1;
            return axios.post(supportRequestEndpoint, request);

          case 1:
            result = _context.v;
            return _context.a(2, result);
        }
      }
    }, _callee);
  }));

  return function submitSupportRequest(_x) {
    return _ref.apply(this, arguments);
  };
}();

var trackSupportRequest = function trackSupportRequest(request) {
  trackEvent(ANALYTICS_EVENTS.supportRequest);
};

var submitSupportRequests = function submitSupportRequests(userData) {
  // gets support requests from localStorage
  var updatedSupportRequests = _objectSpread$1f({}, LS.getItem(SupportRequests));

  var requestKeys = Object.keys(updatedSupportRequests);
  var user = {
    firstname: userData.firstname,
    lastname: userData.lastname,
    name: userData.name ? userData.name : " ".concat(userData.firstname, " ").concat(userData.lastname),
    email: userData.email,
    customerId: userData.customerId,
    reseller: userData.reseller ? userData.reseller : host$2
  }; // loop through each request in the queue

  requestKeys.forEach(function (type) {
    // const currentSupportRequests = LS.getItem(SupportRequests)
    try {
      var request = getSupportRequest(type);

      var submissionData = _objectSpread$1f(_objectSpread$1f({}, request), user); // fire the form submission


      submitSupportRequest(submissionData); // add to the data layer   // trackEvent(eventObj)

      trackSupportRequest(submissionData); // remove from LS.  This section is fucking brilliant.

      removeSupportRequest(type);
    } catch (_unused) {
      // eslint-disable-next-line no-console
      console.error('Error submitting support request', {
        data: updatedSupportRequests[type]
      });
    }
  });
};

var supportRequestService = {
  setSupportRequest: setSupportRequest,
  getSupportRequest: getSupportRequest,
  trackSupportRequest: trackSupportRequest,
  removeSupportRequest: removeSupportRequest,
  submitSupportRequests: submitSupportRequests,
  SUPPORT_REQUEST_TYPES: SUPPORT_REQUEST_TYPES
};

var _templateObject$s, _templateObject2$i, _templateObject3$c, _templateObject4$8, _templateObject5$6, _templateObject6$5, _templateObject7$5, _templateObject8$4, _templateObject9$3, _templateObject0$2, _templateObject1$1, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22;

var OrderFragment = gql(_templateObject$s || (_templateObject$s = _taggedTemplateLiteral$1(["\n  fragment OrderFragment on Order {\n    id\n    totals {\n      subTotal\n      tax {\n        type\n        label\n        amount\n      }\n      savings\n      total\n    }\n    missingPrices {\n      Name\n      AssetType\n      ProductType\n      ProductTypeIndex\n      ExtendedPrice\n      RenewalPrice\n      Taxes {\n        TaxType\n        TaxLabel\n        TaxAmount\n      }\n      Currency\n      ItemCode\n      PriceLevel\n      PromoCode\n      PromoName\n      Parent {\n        Name\n        AssetType\n        ProductType\n        ProductTypeIndex\n        ExtendedPrice\n        RenewalPrice\n        Taxes {\n          TaxType\n          TaxLabel\n          TaxAmount\n        }\n        Currency\n        ItemCode\n        PriceLevel\n        PromoCode\n        PromoName\n      }\n    }\n    promocodes\n    items {\n      id\n      createdOn\n      productType\n      itemCode\n      parent\n      term {\n        count\n        period\n      }\n      display {\n        name\n      }\n      prices {\n        regular {\n          price\n          currency\n          renewal\n        }\n        promo {\n          price\n          currency\n          promocode\n          promoname\n        }\n      }\n      details {\n        ... on DomainDetails {\n          domainName\n          tld\n        }\n        ... on DomainRegistrationDetails {\n          domainName\n          tld\n          phase\n          bundleId\n        }\n        ... on PremiumRegistrationDetails {\n          domainName\n          tld\n          phase\n          status\n          broker\n          listingType\n        }\n        ... on DomainTransferDetails {\n          domainName\n          tld\n          authCode\n        }\n        ... on PackageDetails {\n          packageId\n        }\n        ... on LocationPackageDetails {\n          packageId\n          location\n        }\n        ... on SecurityDetails {\n          domainName\n          tld\n          securityProductType\n        }\n        ... on DomainRenewalDetails {\n          domainId\n        }\n        ... on GoogleWorkspaceUserDetails {\n          users\n          userPrice\n        }\n      }\n      assetType\n    }\n  }\n"])));
gql(_templateObject2$i || (_templateObject2$i = _taggedTemplateLiteral$1(["\n  fragment TLDSFragment on Order {\n    id\n    items {\n      id\n      display {\n        name\n      }\n      details {\n        ... on DomainDetails {\n          domainName\n          tld\n        }\n        ... on DomainRegistrationDetails {\n          domainName\n          tld\n          phase\n        }\n        ... on PremiumRegistrationDetails {\n          domainName\n          tld\n          phase\n          status\n          broker\n          listingType\n        }\n        ... on DomainTransferDetails {\n          domainName\n          tld\n          authCode\n        }\n        ... on PackageDetails {\n          packageId\n        }\n        ... on SecurityDetails {\n          domainName\n          tld\n          securityProductType\n        }\n        ... on DomainRenewalDetails {\n          domainId\n          domainName\n        }\n      }\n    }\n  }\n"])));
gql(_templateObject3$c || (_templateObject3$c = _taggedTemplateLiteral$1(["\n  query GetUpsell($id: ID!, $itemCodes: String!, $currency: Currency) {\n    upsells(id: $id, itemCodes: $itemCodes, currency: $currency) {\n      planId\n      resellerPlanId\n      itemCode\n      productType\n      name\n      description\n      regular {\n        price\n        currency\n      }\n      promo {\n        price\n        currency\n      }\n      annual {\n        price\n        currency\n      }\n    }\n  }\n"])));
gql(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteral$1(["\n  mutation AddVPS(\n    $id: ID!\n    $parent: String\n    $details: AddHostingDetailsInput\n    $term: TermInput\n    $currency: Currency\n  ) {\n    addVpsHosting(\n      id: $id\n      parent: $parent\n      details: $details\n      term: $term\n      currency: $currency\n    ) {\n      ...OrderFragment\n    }\n  }\n  ", "\n"])), OrderFragment);
var ADD_ADVANCED_HOSTING = gql(_templateObject5$6 || (_templateObject5$6 = _taggedTemplateLiteral$1(["\n  mutation AddAdvanced(\n    $id: ID!\n    $parent: String\n    $details: AddHostingDetailsInput\n    $term: TermInput!\n    $currency: Currency\n  ) {\n    addAdvancedHosting(\n      id: $id\n      parent: $parent\n      details: $details\n      term: $term\n      currency: $currency\n    ) {\n      ...OrderFragment\n    }\n  }\n  ", "\n"])), OrderFragment);
gql(_templateObject6$5 || (_templateObject6$5 = _taggedTemplateLiteral$1(["\n  mutation AddPartnerWebsite(\n    $id: ID!\n    $parent: String!\n    $details: AddHostingDetailsDomainRequiredInput\n    $term: TermInput\n    $currency: Currency\n  ) {\n    addPartnerWebsite(\n      id: $id\n      parent: $parent\n      details: $details\n      term: $term\n      currency: $currency\n    ) {\n      ...OrderFragment\n    }\n  }\n  ", "\n"])), OrderFragment);
gql(_templateObject7$5 || (_templateObject7$5 = _taggedTemplateLiteral$1(["\n  mutation AddHosting(\n    $id: ID!\n    $parent: String!\n    $details: AddHostingDetailsDomainRequiredInput\n    $term: TermInput!\n    $currency: Currency\n  ) {\n    addHosting(\n      id: $id\n      parent: $parent\n      details: $details\n      term: $term\n      currency: $currency\n    ) {\n      ...OrderFragment\n    }\n  }\n  ", "\n"])), OrderFragment);
var ADD_PRIVACY_MUTATION = gql(_templateObject8$4 || (_templateObject8$4 = _taggedTemplateLiteral$1(["\n  mutation AddPrivacy(\n    $id: ID!\n    $parent: String!\n    $details: AddPrivacyDetailsInput!\n    $term: TermInput!\n    $currency: Currency\n  ) {\n    addPrivacy(\n      id: $id\n      parent: $parent\n      details: $details\n      term: $term\n      currency: $currency\n    ) {\n      ...OrderFragment\n    }\n  }\n  ", "\n"])), OrderFragment);
var ADD_SECURITY_MUTATION = gql(_templateObject9$3 || (_templateObject9$3 = _taggedTemplateLiteral$1(["\n  mutation AddSecurity(\n    $id: ID!\n    $parent: String!\n    $details: AddSecurityDetailsInput!\n    $term: TermInput!\n    $currency: Currency\n  ) {\n    addSecurity(\n      id: $id\n      parent: $parent\n      details: $details\n      term: $term\n      currency: $currency\n    ) {\n      ...OrderFragment\n    }\n  }\n  ", "\n"])), OrderFragment);
var ORDER_PRICES_QUERY = gql(_templateObject0$2 || (_templateObject0$2 = _taggedTemplateLiteral$1(["\n  query OrderPrices($id: ID!, $currency: Currency) {\n    order(currency: $currency, id: $id) {\n      ...OrderFragment\n    }\n  }\n  ", "\n"])), OrderFragment);
var ADD_PROMO_MUTATION = gql(_templateObject1$1 || (_templateObject1$1 = _taggedTemplateLiteral$1(["\n  mutation AddPromoCode($id: ID!, $promoCode: String!, $currency: Currency) {\n    addPromocode(id: $id, promocode: $promoCode, currency: $currency) {\n      ...OrderFragment\n    }\n  }\n  ", "\n"])), OrderFragment);
var REMOVE_PROMO_MUTATION = gql(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral$1(["\n  mutation RemovePromoCode($id: ID!, $promoCode: String!, $currency: Currency) {\n    removePromocode(id: $id, promocode: $promoCode, currency: $currency) {\n      ...OrderFragment\n    }\n  }\n  ", "\n"])), OrderFragment);
var REMOVE_ITEM_MUTATION = gql(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral$1(["\n  mutation RemoveItem($id: ID!, $itemId: String!, $currency: Currency) {\n    removeItem(id: $id, itemId: $itemId, currency: $currency) {\n      ...OrderFragment\n    }\n  }\n  ", "\n"])), OrderFragment);
var CLEAR_ORDER_MUTATION = gql(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral$1(["\n  mutation ClearOrder($id: ID!, $currency: Currency) {\n    clearOrder(id: $id, currency: $currency) {\n      ...OrderFragment\n    }\n  }\n  ", "\n"])), OrderFragment);
var ADD_AUTO_SECURITY_MUTATION = gql(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral$1(["\n  mutation AutoApplySecurity($id: ID!, $currency: Currency) {\n    autoApplySecurity(id: $id, currency: $currency) {\n      ...OrderFragment\n    }\n  }\n  ", "\n"])), OrderFragment);
var REMOVE_AUTO_SECURITY_MUTATION = gql(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral$1(["\n  mutation RemoveAutoSecurity($id: ID!, $currency: Currency) {\n    removeAutoSecurity(id: $id, currency: $currency) {\n      ...OrderFragment\n    }\n  }\n  ", "\n"])), OrderFragment);
var UPDATE_LOCATION_MUTATION = gql(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral$1(["\n  mutation UpdateServerLocation(\n    $id: ID!\n    $itemId: String!\n    $newServerLocation: ServerLocation!\n    $currency: Currency\n  ) {\n    updateServerLocation(\n      id: $id\n      itemId: $itemId\n      newServerLocation: $newServerLocation\n      currency: $currency\n    ) {\n      ...OrderFragment\n    }\n  }\n  ", "\n"])), OrderFragment);
var SERVER_LOCATIONS_QUERY = gql(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral$1(["\n  query ServerLocations($productType: String!, $itemCode: String!) {\n    serverLocations(productType: $productType, itemCode: $itemCode) {\n      key\n      value\n    }\n  }\n"])));
var UPDATE_TERM_MUTATION = gql(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral$1(["\n  mutation UpdateTerm(\n    $id: ID!\n    $itemId: String!\n    $newTerm: TermInput!\n    $currency: Currency\n  ) {\n    updateTerm(\n      id: $id\n      itemId: $itemId\n      newTerm: $newTerm\n      currency: $currency\n    ) {\n      ...OrderFragment\n    }\n  }\n  ", "\n"])), OrderFragment);
var PROCESS_ORDER_MUTATION = gql(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral$1(["\n  mutation ProcessOrder(\n    $id: ID!\n    $cardId: String\n    $contactId: Int\n    $currency: Currency!\n  ) {\n    processOrder(\n      id: $id\n      cardId: $cardId\n      contactId: $contactId\n      currency: $currency\n    ) {\n      ...OrderFragment\n    }\n  }\n  ", "\n"])), OrderFragment);
var PERSIST_ORDER_MUTATION = gql(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral$1(["\n  mutation Persist($id: ID!, $currency: Currency) {\n    persist(id: $id, currency: $currency) {\n      ...OrderFragment\n    }\n  }\n  ", "\n"])), OrderFragment);
var GET_ADDON_PRICES_QUERY = gql(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral$1(["\n  query PricesByProductType(\n    $currency: Currency!\n    $reseller: Reseller!\n    $productType: String!\n  ) {\n    pricesByProductType(\n      currency: $currency\n      reseller: $reseller\n      productType: $productType\n    ) {\n      regular {\n        price\n        promo\n      }\n    }\n  }\n"])));
var GET_DOMAIN_UPSELLS_QUERY = gql(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral$1(["\n  query GetDomainUpsells($domain: String!) {\n    domainUpsells(domain: $domain) {\n      type\n      title\n      matcher\n      securityProductType\n    }\n  }\n"])));
var GET_PRODUCT_PURCHASE_TERMS_QUERY = gql(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral$1(["\n  query ProductsPurchaseTerms(\n    $productType: String!\n    $itemCode: String!\n    $domain: String\n  ) {\n    productsPurchaseTerms(\n      productType: $productType\n      itemCode: $itemCode\n      domain: $domain\n    ) {\n      display\n      value\n    }\n  }\n"])));

function ownKeys$1e(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1e(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1e(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1e(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _regenerator$W() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$W(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$W(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$W(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$W(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$W(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$W(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$W(u), _regeneratorDefine2$W(u, o, "Generator"), _regeneratorDefine2$W(u, n, function () {
    return this;
  }), _regeneratorDefine2$W(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$W = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$W(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$W = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$W(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$W(e, r, n, t);
}

var OrderContext = /*#__PURE__*/React__default.createContext();

function OrderProvider(props) {
  var _useCookies = useCookies(['orderId']),
      _useCookies2 = _slicedToArray$4(_useCookies, 2),
      cookies = _useCookies2[0],
      setCookie = _useCookies2[1];

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isReady = _useState2[0],
      setIsReady = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray$4(_useState3, 2),
      loggedOut = _useState4[0],
      setLoggedOut = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray$4(_useState5, 2),
      order = _useState6[0],
      setOrder = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray$4(_useState7, 2),
      orderIsReady = _useState8[0],
      setOrderIsReady = _useState8[1];

  var _useState9 = useState({
    itemId: 0,
    requiresFullUpdate: false,
    hasUpdatedPrice: false
  }),
      _useState0 = _slicedToArray$4(_useState9, 2),
      updatePrice = _useState0[0],
      setUpdatePrice = _useState0[1];

  var submitSupportRequests = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$W().m(function _callee(userData) {
      return _regenerator$W().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              supportRequestService.submitSupportRequests(userData);

            case 1:
              return _context.a(2);
          }
        }
      }, _callee);
    }));

    return function submitSupportRequests(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var _useSessionService = useSessionService(),
      currentCurrency = _useSessionService.data.currentCurrency;

  var _useLazyQuery = useLazyQuery(ORDER_PRICES_QUERY, {
    variables: {
      id: String(cookies.orderId),
      currency: currentCurrency.code.toUpperCase()
    },
    onCompleted: function onCompleted(data) {
      setOrder(data.order);
      setOrderIsReady(true);
    }
  }),
      _useLazyQuery2 = _slicedToArray$4(_useLazyQuery, 2),
      getOrder = _useLazyQuery2[0];

  _useLazyQuery2[1];
  useEffect(function () {
    if (isReady) {
      getOrder();
    }
  }, [isReady]);
  var value = React__default.useMemo(function () {
    return {
      orderId: cookies.orderId || 0,
      setCookie: setCookie,
      isReady: isReady,
      setIsReady: setIsReady,
      loggedOut: loggedOut,
      setLoggedOut: setLoggedOut,
      updatePrice: updatePrice,
      setUpdatePrice: setUpdatePrice,
      submitSupportRequests: submitSupportRequests,
      order: order,
      orderIsReady: orderIsReady
    };
  }, [cookies.orderId, isReady, loggedOut, setCookie, updatePrice, orderIsReady]);
  return /*#__PURE__*/jsx$1(OrderContext.Provider, _objectSpread$1e({
    value: value
  }, props));
}

function useOrderService() {
  var context = React__default.useContext(OrderContext);

  if (!context) {
    throw new Error("useOrderService must be used within an OrderProvider");
  }

  return context;
}

function _regenerator$V() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$V(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$V(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$V(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$V(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$V(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$V(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$V(u), _regeneratorDefine2$V(u, o, "Generator"), _regeneratorDefine2$V(u, n, function () {
    return this;
  }), _regeneratorDefine2$V(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$V = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$V(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$V = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$V(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$V(e, r, n, t);
}

function ownKeys$1d(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1d(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1d(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1d(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var RWT$1 = storageKeys.LSToken;
var requiredAddToCartFields = ['addToCartPath', 'returnPath', 'product', 'productCategory', 'source', 'itemCode', 'itemDescription', 'amount'];

var validateAddToCartParams = function validateAddToCartParams(params) {
  var missingFields = [];
  var valid = true;
  requiredAddToCartFields.forEach(function (f) {
    // allow free items to be valid
    if (isNil(params[f]) || params[f].length === 0) {
      missingFields.push(f);
      valid = false;
    }
  });
  return [valid, missingFields];
};

var addToCart = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$V().m(function _callee(params) {
    var _validateAddToCartPar, _validateAddToCartPar2, valid, validationErrors, apiPath, _t;

    return _regenerator$V().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            // validate call
            _validateAddToCartPar = validateAddToCartParams(params), _validateAddToCartPar2 = _slicedToArray$4(_validateAddToCartPar, 2), valid = _validateAddToCartPar2[0], validationErrors = _validateAddToCartPar2[1];

            if (valid) {
              _context.n = 1;
              break;
            }

            return _context.a(2, {
              valid: valid,
              validationErrors: validationErrors
            });

          case 1:
            apiPath = "https://".concat(host$2).concat(params.addToCartPath); // call add to cart endpoint

            _context.p = 2;

            if (!(params.method === 'post')) {
              _context.n = 4;
              break;
            }

            _context.n = 3;
            return post$1(apiPath, _objectSpread$1d({}, params.addToCartParams));

          case 3:
            _context.n = 5;
            break;

          case 4:
            _context.n = 5;
            return get$3(apiPath);

          case 5:
            trackEvent({
              event: ANALYTICS_EVENTS.addToCart,
              eventCategory: ANALYTICS_CATEGORIES.purchase,
              data: {
                products: [{
                  itemCode: params.itemCode,
                  itemDescription: params.itemDescription,
                  product: params.product,
                  productCategory: params.productCategory,
                  amount: params.amount
                }],
                currency: params.currency,
                path: params.addToCartPath,
                source: params.source
              }
            });

            if (window) {
              window.location = params.returnPath;
            }

            return _context.a(2, {
              valid: valid
            });

          case 6:
            _context.p = 6;
            _t = _context.v;
            return _context.a(2, {
              valid: false,
              error: _t
            });
        }
      }
    }, _callee, null, [[2, 6]]);
  }));

  return function addToCart(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getRWT = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$V().m(function _callee2(forceNew) {
    var rwt, _yield$fetchToken, token;

    return _regenerator$V().w(function (_context2) {
      while (1) {
        switch (_context2.n) {
          case 0:
            if (!forceNew) {
              rwt = LS.getItem(RWT$1);
            }

            if (rwt) {
              _context2.n = 2;
              break;
            }

            _context2.n = 1;
            return fetchToken({
              force: true
            });

          case 1:
            _yield$fetchToken = _context2.v;
            token = _yield$fetchToken.data.token;
            rwt = token;
            LS.setItem(RWT$1, rwt);

          case 2:
            return _context2.a(2, rwt);
        }
      }
    }, _callee2);
  }));

  return function getRWT(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var createOrder = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator$V().m(function _callee3() {
    var rwt;
    return _regenerator$V().w(function (_context3) {
      while (1) {
        switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return getRWT(true);

          case 1:
            rwt = _context3.v;
            return _context3.a(2, axios.post(orderEndpoints.get, {}, {
              headers: {
                Authorization: rwt
              },
              withCredentials: false
            }));
        }
      }
    }, _callee3);
  }));

  return function createOrder() {
    return _ref3.apply(this, arguments);
  };
}();

var overwriteOrderFromSession = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regenerator$V().m(function _callee4(orderId, currency) {
    var rwt;
    return _regenerator$V().w(function (_context4) {
      while (1) {
        switch (_context4.n) {
          case 0:
            _context4.n = 1;
            return getRWT(true);

          case 1:
            rwt = _context4.v;
            return _context4.a(2, axios.post("".concat(orderEndpoints.get, "/").concat(orderId, "/overwrite?includePricing=true&currency=").concat(currency, "&reseller=").concat(SERVER_RESELLER), {}, {
              headers: {
                Authorization: rwt
              },
              withCredentials: false
            }));
        }
      }
    }, _callee4);
  }));

  return function overwriteOrderFromSession(_x3, _x4) {
    return _ref4.apply(this, arguments);
  };
}();

var isPollingError = function isPollingError(error) {
  if (typeof error !== 'undefined' && error.graphQLErrors) {
    var graphQLErrors = error.graphQLErrors;
    var pollErrs = graphQLErrors.filter(function (e) {
      return e.message.includes('404');
    });
    return pollErrs.length > 0;
  }

  return false;
};

var processOrderQuery = function processOrderQuery(_ref) {
  var loading = _ref.loading,
      error = _ref.error,
      data = _ref.data,
      refetch = _ref.refetch;
  var isPolling = isPollingError(error);

  var _ref2 = data || {},
      order = _ref2.order;

  return {
    order: order,
    loading: loading || isPolling,
    error: isPolling ? undefined : error,
    refetch: refetch
  };
}; // if (hasDOM && (!window.configs || !window.configs.supportedProducts)) {
//   console.error('SupportedProducts not initialized.')
// }


var redirectIfNotSupported = function redirectIfNotSupported(data) {
  if (hasDOM && data) {
    var items = Object.values(data)[0].items;

    if (items && items.length > 0) {
      items.forEach(function (item) {
        if (!window.configs.supportedProducts.includes(item.productType)) {
          console.warn("[redirectIfNotSupported] ".concat(item.productType, " is not supported."));
          window.location.href = '/MyAccount/ShoppingCart.aspx?optOutCart=true';
        }
      });
    }
  }
};

function ownKeys$1c(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1c(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1c(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1c(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var ProductTypes = {
  // keys need to match Rebel Product Type
  display: {
    Registration: 'Domain Registration',
    PremiumDomain: 'Premium Domain',
    PWPackage: 'Website Package',
    VpsPackage: 'VPS Hosting',
    PleskPackage: 'Hosting',
    HostingPackage: 'Hosting',
    AppliedAccountCredit: 'Applied Account Credit',
    TransferII: 'Domain Transfer',
    Renew: 'Domain Renewal',
    Difm: 'Do It For Me',
    MarketgooSubscription: 'Marketgoo Subscription',
    Sitelock: 'Sitelock',
    GoogleWorkspace: 'Billing',
    Backorder: 'Backorder',
    ProfessionalServicesSubscription: 'Professional Services'
  },
  Registration: 'Registration',
  PartnerWebsite: 'PWPackage',
  ClusteredHosting: 'HostingPackage',
  Security: 'Security',
  PleskPackage: 'PleskPackage',
  TransferII: 'TransferII',
  VpsPackage: 'VpsPackage',
  Privacy: 'Privacy',
  OwnershipLock: 'OwnershipLock',
  ExpiryProtection: 'ExpiryInsurance',
  accountCredit: 'AppliedAccountCredit',
  icannFee: 'ICANNFee',
  outstandingBalance: 'OutstandingBalancePayment',
  Difm: 'Difm',
  Marketgoo: 'MarketgooSubscription',
  Sitelock: 'Sitelock',
  GoogleWorkspace: 'GoogleWorkspace',
  GoogleWorkspaceUser: 'GoogleWorkspaceUser',
  Renew: 'Renew',
  Backorder: 'Backorder',
  RegistrationFee: 'RegistrationFee',
  ProfessionalServicesSubscription: 'ProfessionalServicesSubscription',
  OpenExchangeEmail: 'OpenExchangeEmail',
  OpenExchangeUser: 'OpenExchangeUser'
};

var isSubscriptionProduct = function isSubscriptionProduct(productType) {
  return productType === ProductTypes.PleskPackage || productType === ProductTypes.VpsPackage || productType === ProductTypes.PartnerWebsite || productType === ProductTypes.ClusteredHosting || productType === ProductTypes.Marketgoo || productType === ProductTypes.Sitelock || productType === ProductTypes.GoogleWorkspace || productType === ProductTypes.ProfessionalServicesSubscription || productType === ProductTypes.OpenExchangeEmail;
};

var isOneTimeSubscriptionPurchase = function isOneTimeSubscriptionPurchase(productType, itemCode) {
  return productType === ProductTypes.Sitelock && itemCode.includes('SITELOCK911');
};

var getSubtitle = function getSubtitle(productType, term, itemCode) {
  if (isDomainType(productType)) {
    return getDomainType(productType);
  }
  /* removed at request of Benoit, keepng just in case
  const productTypeString = ProductTypes.display[productType]
   if (term && productType !== ProductTypes.Difm) {
    if (isSubscriptionProduct(productType)) {
      if (isOneTimeSubscriptionPurchase(productType, itemCode)) {
        return productTypeString
      }
      return term.period === 'year'
        ? `Annual ${productTypeString}`
        : `Monthly ${productTypeString}`
    }
    return `${term.count} ${term.period} ${productTypeString}`
  }
   return productTypeString
  */

};

var getTitle = function getTitle(item) {
  var name = item.display.name;
  var displayName = name.split(' - ')[0];

  if (item.productType === ProductTypes.PleskPackage || item.productType === ProductTypes.Sitelock || item.productType === ProductTypes.Marketgoo || item.productType === ProductTypes.GoogleWorkspace) {
    return name;
  }

  if (item.productType === ProductTypes.OpenExchangeEmail) {
    return "".concat(displayName, " Email");
  }

  if (item.productType === ProductTypes.Difm) {
    return name.split("".concat(displayName, " - "))[1];
  }

  return displayName;
};

var isDisplayableParent = function isDisplayableParent(i) {
  return i.parent === null && i.productType !== ProductTypes.icannFee && i.productType !== ProductTypes.accountCredit && i.productType !== ProductTypes.outstandingBalance;
};

var isDisplayableAddon = function isDisplayableAddon(i, g) {
  return i.parent === g.id && i.prices !== null && i.prices.regular !== null && i.productType && i.productType !== ProductTypes.icannFee && i.productType !== ProductTypes.PartnerWebsite && i.productType !== ProductTypes.ClusteredHosting;
};

var sortByCreatedOn = function sortByCreatedOn(a, b) {
  if (a.createdOn < b.createdOn) {
    return -1;
  }

  if (a.createdOn > b.createdOn) {
    return 1;
  }

  return 0;
};

var getGroupedItems = function getGroupedItems(items) {
  if (!items || items.length === 0) {
    return [];
  }

  return items.filter(function (i) {
    return isDisplayableParent(i);
  }).map(function (g) {
    return _objectSpread$1c(_objectSpread$1c({}, g), {}, {
      addons: items.filter(function (i) {
        return isDisplayableAddon(i, g);
      })
    });
  }).sort(sortByCreatedOn);
};

var getAssociatedItems = function getAssociatedItems(orderItems, item) {
  return orderItems.filter(function (i) {
    return i.parent === item.id && (i.productType === ProductTypes.PartnerWebsite || i.productType === ProductTypes.ClusteredHosting);
  });
};

var getItemTermPrice = function getItemTermPrice(item) {
  if (!item.prices) {
    return {};
  }

  var _item$prices = item.prices,
      regular = _item$prices.regular,
      promo = _item$prices.promo;
  return {
    sale: promo && promo.price ? regular.price + promo.price : null,
    regular: regular.price,
    renew: regular.renewal //* Number(term.count),

  };
};

var getUserGWSPrice = function getUserGWSPrice(item) {
  if (!item || !item.addons) {
    return '';
  }

  var addon = item.addons.find(function (a) {
    return a.productType === ProductTypes.GoogleWorkspaceUser;
  });

  if (addon) {
    return addon.details.userPrice;
  }

  return '';
};

var getUserOXPrice = function getUserOXPrice(item) {
  if (!item || !item.addons) {
    return '';
  }

  var addon = item.addons.find(function (a) {
    return a.productType === ProductTypes.OpenExchangeUser;
  });

  if (addon) {
    return addon.details.userPrice;
  }

  return '';
};

var isEditableProduct = function isEditableProduct(productType) {
  if (productType === ProductTypes.accountCredit) {
    return false;
  }

  return true;
};

var productCheckoutNotes = {
  notes: [{
    note: '<p>.DEV is a secure namespace. You may purchase this domain now but it will require an SSL certificate for website connection. To make this easier most Rebel hosting packages include a free SSL certificate.<a href="{link}" target="_blank">Learn more.</a></p>',
    tlds: ['dev'],
    resellerReplacement: {
      rebel: [{
        search: 'link',
        replace: 'https://support.rebel.com/hc/en-us/articles/360002701033-How-to-purchase-and-install-an-SSL-Certificate-Plesk-Hosting-packages-'
      }],
      internic: [{
        search: 'link',
        replace: 'https://support.internic.ca/hc/en-us/articles/360021417474-Purchase-and-Install-an-SSL-Certificate-Full-Control-Hosting-Managed-WordPress-or-VPS-'
      }]
    }
  }, {
    note: '<p>.DAY is a secure namespace. You may purchase this domain now but it will require an SSL certificate for website connection. To make this easier most Rebel hosting packages include a free SSL certificate.<a href="{link}" target="_blank">Learn more.</a></p>',
    tlds: ['day'],
    resellerReplacement: {
      rebel: [{
        search: 'link',
        replace: 'https://support.rebel.com/hc/en-us/articles/360002701033-How-to-purchase-and-install-an-SSL-Certificate-Plesk-Hosting-packages-'
      }],
      internic: [{
        search: 'link',
        replace: 'https://support.internic.ca/hc/en-us/articles/360021417474-Purchase-and-Install-an-SSL-Certificate-Full-Control-Hosting-Managed-WordPress-or-VPS-'
      }]
    }
  }, {
    note: '<p>.BOO is a secure namespace. You may purchase this domain now but it will require an SSL certificate for website connection. To make this easier most Rebel hosting packages include a free SSL certificate.<a href="{link}" target="_blank">Learn more.</a></p>',
    tlds: ['boo'],
    resellerReplacement: {
      rebel: [{
        search: 'link',
        replace: 'https://support.rebel.com/hc/en-us/articles/360002701033-How-to-purchase-and-install-an-SSL-Certificate-Plesk-Hosting-packages-'
      }],
      internic: [{
        search: 'link',
        replace: 'https://support.internic.ca/hc/en-us/articles/360021417474-Purchase-and-Install-an-SSL-Certificate-Full-Control-Hosting-Managed-WordPress-or-VPS-'
      }]
    }
  }, {
    note: '<p>.RSVP is a secure namespace. You may purchase this domain now but it will require an SSL certificate for website connection. To make this easier most Rebel hosting packages include a free SSL certificate.<a href="{link}" target="_blank">Learn more.</a></p>',
    tlds: ['rsvp'],
    resellerReplacement: {
      rebel: [{
        search: 'link',
        replace: 'https://support.rebel.com/hc/en-us/articles/360002701033-How-to-purchase-and-install-an-SSL-Certificate-Plesk-Hosting-packages-'
      }],
      internic: [{
        search: 'link',
        replace: 'https://support.internic.ca/hc/en-us/articles/360021417474-Purchase-and-Install-an-SSL-Certificate-Full-Control-Hosting-Managed-WordPress-or-VPS-'
      }]
    }
  }, {
    note: '<p>.APP is a secure namespace. You may purchase this domain now but it will require an SSL certificate for website connection. To make this easier most Rebel hosting packages include a free SSL certificate.<a href="{link}" target="_blank">Learn more.</a></p>',
    tlds: ['app'],
    resellerReplacement: {
      rebel: [{
        search: 'link',
        replace: 'https://support.rebel.com/hc/en-us/articles/360002701033-How-to-purchase-and-install-an-SSL-Certificate-Plesk-Hosting-packages-'
      }],
      internic: [{
        search: 'link',
        replace: 'https://support.internic.ca/hc/en-us/articles/360021417474-Purchase-and-Install-an-SSL-Certificate-Full-Control-Hosting-Managed-WordPress-or-VPS-'
      }]
    }
  }, {
    note: '<p>.PAGE is a secure namespace. You may purchase this domain now but it will require an SSL certificate for website connection. To make this easier most Rebel hosting packages include a free SSL certificate.<a href="{link}" target="_blank">Learn more.</a></p>',
    tlds: ['page'],
    resellerReplacement: {
      rebel: [{
        search: 'link',
        replace: 'https://support.rebel.com/hc/en-us/articles/360002701033-How-to-purchase-and-install-an-SSL-Certificate-Plesk-Hosting-packages-'
      }],
      internic: [{
        search: 'link',
        replace: 'https://support.internic.ca/hc/en-us/articles/360021417474-Purchase-and-Install-an-SSL-Certificate-Full-Control-Hosting-Managed-WordPress-or-VPS-'
      }]
    }
  }, {
    note: '<p>.COOP domains are avaible only to cooperatives, cooperative service organizations and subsidiaries of cooperatives. You will be contacted by the registry for verification.  If your registration cannot be verified for any reason, no refund of registration fees will be given. <a href="{link}" target="_blank">Learn more.</a></p>',
    tlds: ['coop'],
    resellerReplacement: {
      rebel: [{
        search: 'link',
        replace: 'https://support.rebel.com/hc/en-us/articles/360042278254-About-COOP-domains'
      }],
      internic: [{
        search: 'link',
        replace: 'https://support.internic.ca/hc/en-us/articles/360042278274'
      }]
    }
  }, {
    note: '<p>.NEW domains must be used for action generation or online content creation, and must bring a user directly into the action generation or online creation flow within 100 days. Domains that don\'t comply with this usage policy may be suspended or deleted by Google Registry without refund. .NEW is a secure namespace. You may purchase this domain now but it will require an SSL certificate for website connection. To make this easier most Rebel hosting packages include a free SSL certificate. <a href="{link}" target="_blank">Learn more.</a></p>',
    tlds: ['new'],
    resellerReplacement: {
      rebel: [{
        search: 'link',
        replace: 'https://support.rebel.com/hc/en-us/articles/360002701033-How-to-purchase-and-install-an-SSL-Certificate-Plesk-Hosting-packages-'
      }],
      internic: [{
        search: 'link',
        replace: 'https://support.internic.ca/hc/en-us/articles/360021417474-Purchase-and-Install-an-SSL-Certificate-Full-Control-Hosting-Managed-WordPress-or-VPS-'
      }]
    }
  }, {
    note: '<p>.ES domains require company registration number or personal identification number, and Admin, Tech and Billing contacts must be individuals. If needed, a customer service agent will contact you to verify your information. <a href="{link}" target="_blank">Learn more.</a></p>',
    tlds: ['es'],
    resellerReplacement: {
      rebel: [{
        search: 'link',
        replace: 'https://support.rebel.com/hc/en-us/articles/360001428973-About-ES-domains'
      }],
      internic: [{
        search: 'link',
        replace: 'https://support.internic.ca/hc/en-us'
      }]
    }
  }, {
    note: '<p>.AU domains have restrictions.  Please visit our <a href="{link}" target="_blank">support page</a> to learn more.</p>',
    tlds: ['au'],
    resellerReplacement: {
      rebel: [{
        search: 'link',
        replace: 'https://support.rebel.com/hc/en-us/articles/4492251998619'
      }]
    }
  }]
};

var getItemCode = function getItemCode(details) {
  var itemCode;

  if (details) {
    if (details.tld) {
      itemCode = details.tld;
    } else {
      itemCode = details.packageId;
    }
  }

  return itemCode ? itemCode.toString() : '';
};

var hasLocationSelector = function hasLocationSelector(productType) {
  return productType === ProductTypes.PleskPackage || productType === ProductTypes.VpsPackage;
};

var isDomainType = function isDomainType(productType) {
  return productType === ProductTypes.Registration || productType === ProductTypes.Renew || productType === ProductTypes.TransferII || productType === ProductTypes.PremiumDomain || productType === ProductTypes.PartnerWebsite;
};

var getDomainType = function getDomainType(productType) {
  switch (productType) {
    case ProductTypes.Registration:
      return ProductTypes.display.Registration;

    case ProductTypes.Renew:
      return ProductTypes.display.Renew;

    case ProductTypes.PremiumDomain:
      return ProductTypes.display.PremiumDomain;

    case ProductTypes.TransferII:
      return ProductTypes.display.TransferII;

    case ProductTypes.PartnerWebsite:
      return ProductTypes.display.PWPackage;

    default:
      return '';
  }
};

var _excluded$u = ["orderId"];

function ownKeys$1b(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1b(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1b(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1b(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var propTypes$1i = {
  orderId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};
var OrderQueryContext = /*#__PURE__*/React__default.createContext();

function OrderQueryProvider(_ref) {
  var orderId = _ref.orderId,
      rest = _objectWithoutProperties$8(_ref, _excluded$u);

  var _useSessionService = useSessionService(),
      currentCurrency = _useSessionService.data.currentCurrency;

  var orderQueryResult = useQuery(ORDER_PRICES_QUERY, {
    variables: {
      id: String(orderId),
      currency: currentCurrency.code.toUpperCase()
    },
    onCompleted: function onCompleted(data) {
      return redirectIfNotSupported(data);
    }
  });

  var useAddPromo = function useAddPromo(config) {
    return useMutation(ADD_PROMO_MUTATION, config);
  };

  var useRemovePromo = function useRemovePromo(config) {
    return useMutation(REMOVE_PROMO_MUTATION, config);
  };

  var useRemoveItem = function useRemoveItem(config) {
    return useMutation(REMOVE_ITEM_MUTATION, config);
  };

  var useClearOrder = function useClearOrder(config) {
    return useMutation(CLEAR_ORDER_MUTATION, config);
  };

  var useAddAutoSecurity = function useAddAutoSecurity(config) {
    return useMutation(ADD_AUTO_SECURITY_MUTATION, config);
  };

  var useRemoveAutoSecurity = function useRemoveAutoSecurity(config) {
    return useMutation(REMOVE_AUTO_SECURITY_MUTATION, config);
  };

  var useUpdateLocation = function useUpdateLocation(config) {
    return useMutation(UPDATE_LOCATION_MUTATION, config);
  };

  var useGetServerLocations = function useGetServerLocations(config) {
    return useQuery(SERVER_LOCATIONS_QUERY, config);
  };

  var useAddPrivacy = function useAddPrivacy(config) {
    return useMutation(ADD_PRIVACY_MUTATION, config);
  };

  var useAddSecurity = function useAddSecurity(config) {
    return useMutation(ADD_SECURITY_MUTATION, config);
  };

  var useUpdateTerm = function useUpdateTerm(config) {
    return useMutation(UPDATE_TERM_MUTATION, config);
  };

  var useProcessOrder = function useProcessOrder(config) {
    return useMutation(PROCESS_ORDER_MUTATION, config);
  };

  var usePersistOrder = function usePersistOrder(config) {
    return useMutation(PERSIST_ORDER_MUTATION, config);
  };

  var useGetAddonPrices = function useGetAddonPrices(config) {
    return useQuery(GET_ADDON_PRICES_QUERY, config);
  };

  var useGetDomainUpsells = function useGetDomainUpsells(config) {
    return useQuery(GET_DOMAIN_UPSELLS_QUERY, config);
  };

  var useGetProductPurchaseTerms = function useGetProductPurchaseTerms(config) {
    return useQuery(GET_PRODUCT_PURCHASE_TERMS_QUERY, config);
  };

  var value = _objectSpread$1b({
    useAddPromo: useAddPromo,
    useRemovePromo: useRemovePromo,
    useRemoveItem: useRemoveItem,
    useClearOrder: useClearOrder,
    useRemoveAutoSecurity: useRemoveAutoSecurity,
    useAddAutoSecurity: useAddAutoSecurity,
    useUpdateLocation: useUpdateLocation,
    useGetServerLocations: useGetServerLocations,
    useAddPrivacy: useAddPrivacy,
    useAddSecurity: useAddSecurity,
    useUpdateTerm: useUpdateTerm,
    useProcessOrder: useProcessOrder,
    usePersistOrder: usePersistOrder,
    useGetAddonPrices: useGetAddonPrices,
    useGetDomainUpsells: useGetDomainUpsells,
    useGetProductPurchaseTerms: useGetProductPurchaseTerms
  }, processOrderQuery(orderQueryResult));

  return /*#__PURE__*/jsx$1(OrderQueryContext.Provider, _objectSpread$1b({
    value: value
  }, rest));
}

function useOrderQuery() {
  var context = React__default.useContext(OrderQueryContext);

  if (!context) {
    throw new Error('useOrderQuery must be used within a OrderQueryProvider');
  }

  return context;
}

OrderQueryProvider.propTypes = propTypes$1i;

function ownKeys$1a(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1a(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1a(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1a(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function OrderLoader(_ref) {
  var rest = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/jsxs(Stack$2, _objectSpread$1a(_objectSpread$1a({}, rest), {}, {
    children: [/*#__PURE__*/jsx$1(Skeleton$1, {
      height: "2.8rem",
      mb: 2,
      width: "20rem"
    }), /*#__PURE__*/jsx$1(Skeleton$1, {
      height: "11.8rem",
      mb: 2,
      width: "40rem"
    }), /*#__PURE__*/jsx$1(Skeleton$1, {
      height: "33.1rem",
      mb: 2,
      width: "40rem"
    })]
  }));
}

var recStyle = css$3(["&:first-child{margin-top:0px;}"]);
var propTypes$1h = {
  product: PropTypes.shape({
    cta: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    endpoint: PropTypes.string,
    id: PropTypes.string,
    itemCode: PropTypes.string.isRequired,
    price: PropTypes.oneOfType([PropTypes.string, // addProduct wont work, do we need this?
    PropTypes.shape({
      regular: PropTypes.shape({
        currency: PropTypes.string,
        price: PropTypes.number,
        promo: PropTypes.number
      }),
      resellerPlanId: PropTypes.number
    })]),
    subprice: PropTypes.string,
    title: PropTypes.string.isRequired
  }).isRequired
};

function Recommendation(_ref) {
  var _ref$product = _ref.product,
      id = _ref$product.id,
      title = _ref$product.title,
      description = _ref$product.description,
      price = _ref$product.price,
      itemCode = _ref$product.itemCode,
      cta = _ref$product.cta,
      subprice = _ref$product.subprice;

  var _useMutation = useMutation(ADD_ADVANCED_HOSTING),
      _useMutation2 = _slicedToArray$4(_useMutation, 2),
      addProduct = _useMutation2[0],
      loading = _useMutation2[1].loading;

  var _useOrderService = useOrderService(),
      orderId = _useOrderService.orderId;

  var _useSessionService = useSessionService(),
      currentCurrency = _useSessionService.data.currentCurrency;

  var getButtonContent = function getButtonContent() {
    if (loading) {
      return 'Adding...';
    }

    return cta;
  };

  var onButtonClick = function onButtonClick() {
    addProduct({
      variables: {
        id: orderId,
        details: {
          packageId: price.resellerPlanId
        },
        term: {
          count: '1',
          period: 'year'
        },
        currency: currentCurrency.code.toUpperCase(),
        tracking: {
          productType: 'Privacy',
          source: 'EmptyOrder'
        }
      }
    });
  };

  return /*#__PURE__*/jsxs(_StyledBox$j, {
    justifyContent: "space-between",
    mt: 4,
    children: [/*#__PURE__*/jsxs(Stack$2, {
      justifyContent: "space-between",
      children: [/*#__PURE__*/jsx$1(Text$1, {
        mb: 1,
        variant: "megaBold",
        children: title
      }), /*#__PURE__*/jsx$1(Text$1, {
        variant: "milli",
        children: description
      })]
    }), /*#__PURE__*/jsxs(Stack$2, {
      alignItems: "flex-end",
      flex: "1 0 auto",
      ml: 3,
      children: [/*#__PURE__*/jsx$1(Text$1, {
        color: "reds.0",
        fontWeight: "semi",
        children: getLowestPrice(price)
      }), subprice && /*#__PURE__*/jsx$1(Text$1, {
        fontSize: 0,
        children: subprice
      }), /*#__PURE__*/jsx$1(Button$1, {
        ariaLabel: "Add to Cart",
        color: "blue",
        disabled: price === undefined,
        id: "add-".concat(itemCode),
        onClick: onButtonClick,
        variant: "inverse",
        children: getButtonContent()
      })]
    })]
  }, id);
}

Recommendation.propTypes = propTypes$1h;

var _StyledBox$j = styled(Box$1).withConfig({
  displayName: "recommendation___StyledBox",
  componentId: "sc-12zfrnm-0"
})(["", ""], recStyle);

function _regenerator$U() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$U(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$U(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$U(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$U(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$U(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$U(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$U(u), _regeneratorDefine2$U(u, o, "Generator"), _regeneratorDefine2$U(u, n, function () {
    return this;
  }), _regeneratorDefine2$U(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$U = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$U(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$U = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$U(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$U(e, r, n, t);
}

function ownKeys$19(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$19(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$19(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$19(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var propTypes$1g = {
  loading: PropTypes.bool.isRequired,
  recommendations: PropTypes.arrayOf(PropTypes.shape({
    cta: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    endpoint: PropTypes.string,
    id: PropTypes.string,
    itemCode: PropTypes.string.isRequired,
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
      regular: PropTypes.shape({
        currency: PropTypes.string,
        price: PropTypes.number,
        promo: PropTypes.number
      })
    })]),
    subprice: PropTypes.string,
    title: PropTypes.string.isRequired
  }).isRequired),
  outstandingBalance: PropTypes.shape({
    display: PropTypes.shape({
      name: PropTypes.string.isRequired
    }),
    price: PropTypes.shape({
      regular: PropTypes.number.isRequired,
      renew: PropTypes.number,
      sale: PropTypes.number
    }),
    productType: PropTypes.string.isRequired,
    term: PropTypes.shape({
      count: PropTypes.string,
      period: PropTypes.oneOf(['month', 'year'])
    })
  })
};
var defaultProps$F = {
  recommendations: []
};

function EmptyOrder(_ref) {
  var recommendations = _ref.recommendations,
      loading = _ref.loading,
      outstandingBalance = _ref.outstandingBalance;

  var _useState = useState(_toConsumableArray$1(recommendations)),
      _useState2 = _slicedToArray$4(_useState, 2),
      loadedRecommendations = _useState2[0],
      setLoadedRecommendations = _useState2[1];

  var _useSessionService = useSessionService(),
      currentCurrency = _useSessionService.data.currentCurrency;

  useEffect(function () {
    var loadRecommendationPrices = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$U().m(function _callee() {
        var _yield$get, prices, itemCodes, productPrices;

        return _regenerator$U().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.n = 1;
                return get$3("".concat(pricesEndpoint$1, "?currency=").concat(currentCurrency.code.toUpperCase(), "&reseller=").concat(SERVER_RESELLER));

              case 1:
                _yield$get = _context.v;
                prices = _yield$get.data;

                if (prices) {
                  itemCodes = recommendations.map(function (_ref3) {
                    var itemCode = _ref3.itemCode;
                    return itemCode;
                  });
                  productPrices = prices.filter(function (price) {
                    return itemCodes.includes(price.itemCode);
                  });
                  setLoadedRecommendations(loadedRecommendations.map(function (rec) {
                    var priceData = productPrices.find(function (_ref4) {
                      var itemCode = _ref4.itemCode;
                      return rec.itemCode === itemCode;
                    });
                    return _objectSpread$19(_objectSpread$19({}, rec), {}, {
                      description: priceData && priceData.description ? priceData.description : rec.description,
                      price: priceData
                    });
                  }));
                }

              case 2:
                return _context.a(2);
            }
          }
        }, _callee);
      }));

      return function loadRecommendationPrices() {
        return _ref2.apply(this, arguments);
      };
    }();

    loadRecommendationPrices();
  }, [currentCurrency]);

  if (loading) {
    return /*#__PURE__*/jsx$1(OrderLoader, {
      mb: 3
    });
  }

  return /*#__PURE__*/jsxs(Stack$2, {
    alignSelf: "stretch",
    mb: 4,
    width: "100%",
    children: [/*#__PURE__*/jsx$1(Heading, {
      mb: 2,
      variant: "tera",
      children: "Your order is empty"
    }), /*#__PURE__*/jsxs(Stack$2, {
      bg: "white",
      border: 2,
      borderRadius: 2,
      px: 4,
      py: 3,
      children: [/*#__PURE__*/jsx$1(Link$1, {
        ariaLabel: "Search Hosting Options",
        color: isInternic ? 'blue' : 'magenta',
        href: "/web-hosting",
        mb: 1,
        variant: "solid",
        children: "Search Hosting Options"
      }), /*#__PURE__*/jsx$1(Link$1, {
        ariaLabel: "Search Domains",
        color: isInternic ? 'blue' : 'magenta',
        href: "/register",
        variant: "inverse",
        children: /*#__PURE__*/jsx$1(Text$1, {
          children: "Search Domains"
        })
      })]
    }), recommendations && recommendations.length > 0 ? /*#__PURE__*/jsx$1(Stack$2, {
      bg: "white",
      border: 2,
      borderRadius: 2,
      mt: 2,
      px: 4,
      py: 4,
      children: loadedRecommendations.map(function (product) {
        return /*#__PURE__*/jsx$1(Recommendation, {
          product: product
        }, product.id);
      })
    }) : null, outstandingBalance && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx$1(Box$1, {
        height: "1px",
        border: "1px solid LightGray",
        mb: 1,
        mt: 3,
        width: "100%"
      }), /*#__PURE__*/jsxs(Box$1, {
        width: "100%",
        mt: 2,
        children: [/*#__PURE__*/jsx$1(Box$1, {
          width: "100%",
          children: /*#__PURE__*/jsxs(Text$1, {
            justifyContent: "left",
            variant: "megaBold",
            children: ["Outstanding Balance:", ' ']
          })
        }), /*#__PURE__*/jsx$1(Box$1, {
          children: /*#__PURE__*/jsxs(Text$1, {
            justifyContent: "right",
            variant: "megaBold",
            children: ["$", "".concat(Math.abs(outstandingBalance.prices.regular.price).toFixed(2))]
          })
        })]
      })]
    })]
  });
}

EmptyOrder.propTypes = propTypes$1g;
EmptyOrder.defaultProps = defaultProps$F;
var color$1 = {
  white: '#fff',
  whiteDark: '#f7f7f7',
  greyLightest: '#e7e7e7',
  greyLight: '#d7d7d7',
  grey: '#B2B2B2',
  greyDark: '#999999',
  greyDarker: '#666',
  blackLighter: '#333',
  blackLight: '#222328',
  black: '#000',
  greenLightest: '#f3f5e6',
  greenLighter: '#D3DCA3',
  greenLight: '#A5C20F',
  green: '#859F00',
  greenDark: '#6B8000',
  redLighter: '#F9BEAE',
  redLight: '#E37054',
  red: '#F04A22',
  redDark: '#CC3E1C',
  redNew: '#d82a29',
  blueLightest: '#C1D5F7',
  blue: '#1B50B8',
  orange: '#ff9600',
  orangeLight: '#fee7c5',
  clear: 'transparent',
  focus: '#406198',
  overlay: 'rgba(0,0,0,.6)',
  success: '#859f00',
  successLight: '#e4eeaa',
  warning: '#d49e03',
  warningLight: '#f7eac9',
  error: '#f04822',
  errorLight: '#ffd1c7',
  facebook: '#3b5998'
};
var font = {
  "new": '"Montserrat", sans-serif'
};
var gutter$5 = {
  eigth: '0.2rem',
  quarter: '0.4rem',
  half: '0.8rem',
  "default": '1.6rem',
  big: '2.4rem',
  bigger: '4rem',
  biggest: '8rem'
};
var border = {
  radius: '2px',
  color: color$1.greyLight,
  dark: '#2d2e33'
};
var html = {
  fontSize: '62.5%'
};
var body = {
  margin: '0',
  padding: '0',
  fontFamily: "".concat(font["new"]),
  fontWeight: '300',
  fontSize: '1.6rem',
  lineHeight: '1.7',
  color: color$1.blackLighter
};
var animations = {
  scaleout: keyframes$3(["from{transform:scale(0);}to{transform:scale(1.0);opacity:0;}"]),
  slideUp: keyframes$3(["from{transform:translate3d(0,2rem,0);opacity:0;}to{transform:translate3d(0,0,0);opacity:1}"]),
  bounceTop: keyframes$3(["0%{transform:translateY(-35px);animation-timing-function:ease-in;opacity:1;}24%{opacity:1;}40%{transform:translateY(-24px);animation-timing-function:ease-in;}65%{transform:translateY(-12px);animation-timing-function:ease-in;}82%{transform:translateY(-6px);animation-timing-function:ease-in;}93%{transform:translateY(-4px);animation-timing-function:ease-in;}25%,55%,75%,87%{transform:translateY(0px);animation-timing-function:ease-out;}100%{transform:translateY(0px);animation-timing-function:ease-out;opacity:1;}"]),
  lightSpeedIn: keyframes$3(["from{transform:translate3d(100%,0,0) skewX(-30deg);opacity:0;}60%{transform:skewX(20deg);opacity:1;}80%{transform:skewX(-5deg);}to{transform:translate3d(0,0,0);}"]),
  shine: keyframes$3(["to{background-position:200% center;}"])
};
css$3(["background:linear-gradient( to right,", " 20%,", " 40%,", " 60%,", " 80% );background-size:200% auto;content:'';animation:", " 0.8s linear infinite;"], color$1.greyLightest, color$1.white, color$1.white, color$1.greyLightest, animations.shine);
css$3(["background:linear-gradient(to right,#000 20%,#fff 40%,#fff 60%,#000 80%);background-size:200% auto;color:#000;background-clip:text;text-fill-color:transparent;-webkit-background-clip:text;-webkit-text-fill-color:transparent;animation:", " 0.8s linear infinite;"], animations.shine);
createGlobalStyle(["html{font-size:", ";}body{margin:", ";padding:", ";font-family:", ";font-weight:", ";line-height:", ";color:", ";font-size:", ";}h1,h2,h3,h4,h5,h6{margin:0;padding:0;font-family:", ";}*,*:before,*:after{-webkit-box-sizing:border-box !important;-moz-box-sizing:border-box !important;-ms-box-sizing:border-box !important;box-sizing:border-box !important;}ul{list-style-type:none;padding:0;}"], html.fontSize, body.margin, body.padding, body.fontFamily, body.fontWeight, body.lineHeight, body.color, body.fontSize, body.fontFamily);
var strings$3 = {
  promo_section_label: 'Applied Promos:',
  applied_credit_label: 'Applied Credit',
  subtitle_label: 'Subtotal',
  icann_label: 'ICANN fees',
  outstanding_label: 'Outstanding balance',
  savings_label: 'You saved',
  total_label: 'Total',
  checkout_button_text: 'Secure Checkout',
  summary_notes_1: 'Just a few more steps are ',
  summary_notes_2: 'Required before you are billed.',
  summary_terms_1: 'By clicking process payment you agree to the ',
  error: 'Error loading your order',
  invalidPromo: "Sorry, that's an invalid code",
  ignoredPromo: "Nice, you already have the best price!",
  wireTransferHeader: 'Wire Transfer Required',
  wireTransferContent: function wireTransferContent(amount) {
    return "As a security precaution, orders over $".concat(amount, " require a wire transfer.  You may complete the order now, but it cannot be fully processed until the wire transfer payment is received.  Instructions for completing the wire transfer will be provided after initiating processing the order.");
  }
};
var strings$2 = {
  promo_section_label: 'Applied promotions',
  applied_credit_label: 'Applied credit',
  subtitle_label: 'Subtotal',
  icann_label: 'ICANN fees',
  outstanding_label: 'Outstanding balance',
  savings_label: 'You saved',
  total_label: 'Total',
  checkout_button_text: 'Secure Checkout',
  summary_notes_1: 'Just a few more steps are ',
  summary_notes_2: 'Required before you are billed.',
  summary_terms_1: 'By clicking process payment you agree to the ',
  error: 'Error loading your order',
  invalidPromo: "Sorry, that's an invalid code",
  ignoredPromo: "Nice, you already have the best price!",
  wireTransferHeader: 'Wire Transfer Required',
  wireTransferContent: function wireTransferContent(amount) {
    return "As a security precaution, orders over $".concat(amount, " require a wire transfer.  You may complete the order now, but it cannot be fully processed until the wire transfer payment is received.  Instructions for completing the wire transfer will be provided after initiating processing the order.");
  }
};
var defaultProps$E = {
  isLoading: false
};
var propTypes$1f = {
  isLoading: PropTypes.bool,
  count: PropTypes.number
};

function OrderSummaryHeader(_ref) {
  var isLoading = _ref.isLoading,
      error = _ref.error,
      order = _ref.order,
      currency = _ref.currency,
      count = _ref.count;

  var getHeading = function getHeading() {
    var headingText = 'Cart';

    if (error) {
      headingText = strings$2.error;
    } else if (!isLoading && order) {
      headingText = count > 0 ? "Cart (".concat(count, " item").concat(count !== 1 ? 's' : '', ")") : ' ';
    } else {
      headingText = 'Your order is empty';
    }

    return headingText;
  };

  var _useOrderQuery = useOrderQuery(),
      useClearOrder = _useOrderQuery.useClearOrder;

  var _useClearOrder = useClearOrder(),
      _useClearOrder2 = _slicedToArray$4(_useClearOrder, 1),
      clearOrder = _useClearOrder2[0];

  var clearHandler = function clearHandler() {
    clearOrder({
      variables: {
        id: order.id,
        tracking: order,
        currency: currency.code.toUpperCase()
      }
    });
  };
  /*
   */


  return /*#__PURE__*/jsxs(Box$1, {
    alignItems: "center",
    as: "heading",
    justifyContent: "space-between",
    children: [/*#__PURE__*/jsx$1(Heading, {
      as: "h2",
      variant: "tera",
      children: getHeading()
    }), order && order.items && order.items.length > 0 ? /*#__PURE__*/jsx$1(Button$1, {
      clean: true,
      color: "black",
      id: "clear-cart",
      onClick: clearHandler,
      variant: "underlined",
      title: "clear-cart",
      children: "Clear Order"
    }) : null]
  });
}

OrderSummaryHeader.defaultProps = defaultProps$E;
OrderSummaryHeader.propTypes = propTypes$1f;

function _regenerator$T() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$T(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$T(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$T(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$T(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$T(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$T(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$T(u), _regeneratorDefine2$T(u, o, "Generator"), _regeneratorDefine2$T(u, n, function () {
    return this;
  }), _regeneratorDefine2$T(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$T = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$T(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$T = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$T(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$T(e, r, n, t);
}

var BulkSecurity = storageKeys.BulkSecurity;

var trackBulkSecurity = function trackBulkSecurity(didAddBulkSecurity) {
  trackEvent(ANALYTICS_EVENTS.bulkSecurity);
};

var addBulkSecurity = function addBulkSecurity() {
  LS.setItem(BulkSecurity, {
    hasBulkSecurity: true
  });
};

var hasBulkSecurity$1 = function hasBulkSecurity() {
  return Boolean(LS.getItem(BulkSecurity));
};

var removeBulkSecurity = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$T().m(function _callee() {
    var result;
    return _regenerator$T().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            _context.n = 1;
            return axios.post(bulkSecurityEndpoints.remove);

          case 1:
            result = _context.v;
            LS.removeItem(BulkSecurity);
            trackBulkSecurity();
            return _context.a(2, result);
        }
      }
    }, _callee);
  }));

  return function removeBulkSecurity() {
    return _ref.apply(this, arguments);
  };
}();

var clearBulkSecurity = function clearBulkSecurity() {
  LS.removeItem(BulkSecurity);
};

var applyBulkSecurity$1 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$T().m(function _callee2(types) {
    var _yield$axios$post, data, applied;

    return _regenerator$T().w(function (_context2) {
      while (1) {
        switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return axios.post(bulkSecurityEndpoints.add, {
              productsToAdd: types
            });

          case 1:
            _yield$axios$post = _context2.v;
            data = _yield$axios$post.data;
            applied = data && data.toLowerCase() === 'true';

            if (applied) {
              addBulkSecurity();
              trackBulkSecurity();
            }

            return _context2.a(2, applied);
        }
      }
    }, _callee2);
  }));

  return function applyBulkSecurity(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var bulkSecurityCodes = ['PRIVACY', 'DMLOCK', 'DMEXPINSURANCE'];
var bulkSecurityService = {
  addBulkSecurity: addBulkSecurity,
  removeBulkSecurity: removeBulkSecurity,
  applyBulkSecurity: applyBulkSecurity$1,
  hasBulkSecurity: hasBulkSecurity$1,
  clearBulkSecurity: clearBulkSecurity
};
redesignTheme.colors;
var gutter$4 = {
  eigth: '0.2rem',
  quarter: '0.4rem',
  half: '0.8rem',
  "default": '1.6rem',
  big: '2.4rem',
  bigger: '4rem',
  biggest: '8rem'
};
var Check = styled.div.withConfig({
  displayName: "OptionToggle__Check",
  componentId: "sc-18599ll-0"
})(["transition:all ease-out 200ms;float:left;display:inline-block;content:'';width:0;height:100%;background:#453e63;text-align:center;line-height:2rem;&::before{transition:all ease-out 200ms;content:'';display:inline-block;transform:rotate(-45deg);margin-top:-0.25rem;height:0.5rem;width:1.25rem;border-bottom:1px solid white;border-left:1px solid white;vertical-align:middle;opacity:0;}"]);
var InnerContainer = styled.div.withConfig({
  displayName: "OptionToggle__InnerContainer",
  componentId: "sc-18599ll-1"
})(["display:flex;transition:all ease-out 200ms;input{position:absolute;opacity:0;}img{float:left;width:3rem;padding:0.2rem 0 0.2rem 0.2rem;}input[type='radio']:checked + label{border-color:#453E63;", "{width:", ";&::before{opacity:1;}}}input[type='radio']:focus + label{outline:rgb(59,153,252) auto 5px;}}"], Check, gutter$4.big);
var labelStyles = css$3(["float:left;display:flex;flex:1;width:15rem;margin-right:", ";margin-top:", ";line-height:2.2rem;font-weight:600;font-size:1rem;cursor:pointer;text-transform:uppercase;border:1px solid LightGray;background:white;height:", ";cursor:pointer;span{padding:", ";padding-right:", ";}img{width:2rem;height:2rem;margin-top:1px;margin-right:0.5rem;margin-left:2px;}"], gutter$4.quarter, gutter$4.quarter, gutter$4.big, gutter$4.quarter, gutter$4.big);
var propTypes$1e = {
  isSaving: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    display: PropTypes.string.isRequired,
    icon: PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    }),
    value: PropTypes.string.isRequired
  })),
  selected: PropTypes.number.isRequired
};
var defaultProps$D = {
  options: [],
  isSaving: false
};

function OptionToggle(_ref) {
  var options = _ref.options,
      name = _ref.name,
      onSelect = _ref.onSelect,
      selected = _ref.selected,
      isSaving = _ref.isSaving;

  if (options && options.length < 1) {
    return null;
  }

  return /*#__PURE__*/jsx$1(Box$1, {
    flexWrap: "wrap",
    width: 1,
    children: options.map(function (op, idx) {
      return /*#__PURE__*/jsxs(InnerContainer, {
        children: [/*#__PURE__*/jsx$1("input", {
          checked: selected === idx,
          id: "".concat(op.display).concat(name),
          name: name,
          onChange: function onChange() {
            onSelect(idx);
          },
          type: "radio",
          value: op.value
        }), /*#__PURE__*/jsxs(_StyledText$m, {
          as: "label",
          htmlFor: "".concat(op.display).concat(name),
          isLoading: isSaving && selected === idx,
          children: [/*#__PURE__*/jsx$1(Check, {}), op.icon && /*#__PURE__*/jsx$1("img", {
            alt: op.icon.title,
            "aria-hidden": "true",
            src: op.icon.url
          }), op.display]
        })]
      }, op.display);
    })
  });
}

OptionToggle.propTypes = propTypes$1e;
OptionToggle.defaultProps = defaultProps$D;

var _StyledText$m = styled(Text$1).withConfig({
  displayName: "OptionToggle___StyledText",
  componentId: "sc-18599ll-2"
})(["", ""], labelStyles);

var ImageMap = {
  us_east_1: '//s3.amazonaws.com/rebel.com/flags/049-united-states.svg',
  ca_central_1: '//s3.amazonaws.com/rebel.com/flags/038-canada.svg',
  us_west_1: '//s3.amazonaws.com/rebel.com/flags/049-united-states.svg',
  ap_southeast_2: '//s3.amazonaws.com/rebel.com/flags/035-australia.svg',
  ap_south_1: '//s3.amazonaws.com/rebel.com/flags/india.svg',
  ap_northeast_2: '//s3.amazonaws.com/rebel.com/flags/southkorea.svg',
  ap_northeast_1: '//s3.amazonaws.com/rebel.com/flags/japan.svg',
  eu_central_1: '//s3.amazonaws.com/rebel.com/flags/046-germany.svg',
  eu_west_1: '//s3.amazonaws.com/rebel.com/flags/ireland.svg',
  eu_west_2: '//s3.amazonaws.com/rebel.com/flags/050-united-kingdom.svg',
  sa_east_1: '//s3.amazonaws.com/rebel.com/flags/brazil.svg',
  ap_southeast_1: '//s3.amazonaws.com/rebel.com/flags/singapore.svg',
  eu_west_3: '//s3.amazonaws.com/rebel.com/flags/048-france.svg'
};

var mapToComponent = function mapToComponent(list, strings) {
  return list.map(function (item) {
    return {
      display: strings[item.key],
      icon: {
        title: strings[item.key],
        url: ImageMap[item.key]
      },
      value: item.key
    };
  });
};

var moveToStartOfList = function moveToStartOfList(mapped, idx) {
  if (mapped.length < 2) {
    return mapped;
  }

  var removed = mapped.splice(idx, 1);
  mapped.unshift(removed[0]);
  return mapped;
};

var getObjIndex = function getObjIndex(mapped, item) {
  return mapped.map(function (e) {
    return e.value;
  }).indexOf(item.details.location);
};

var propTypes$1d = {
  options: PropTypes.number.isRequired
};
var defaultProps$C = {};

function LocationOptionSkeleton(_ref) {
  var options = _ref.options;
  return /*#__PURE__*/jsx$1(Box$1, {
    children: Array(options).fill().map(function (_, idx) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        jsx$1("select", {}, idx)
      );
    })
  });
}

LocationOptionSkeleton.propTypes = propTypes$1d;
LocationOptionSkeleton.defaultProps = defaultProps$C;
var strings$1 = {
  title: 'Server & data location:',
  error: 'Error retrieving server locations',
  errorUpdating: 'Error updating your server location',
  locations: {
    us_east_1: 'Virginia',
    ca_central_1: 'Montreal',
    us_west_1: 'California',
    ap_southeast_2: 'Sydney',
    ap_south_1: 'Mumbai',
    ap_northeast_2: 'Seoul',
    ap_northeast_1: 'Tokyo',
    eu_central_1: 'Frankfurt',
    eu_west_1: 'Ireland',
    eu_west_2: 'London',
    sa_east_1: 'São Paulo',
    ap_southeast_1: 'Singapore',
    eu_west_3: 'Paris'
  }
};
var propTypes$1c = {
  item: PropTypes.shape({
    details: PropTypes.shape({}),
    productType: PropTypes.string
  }).isRequired,
  orderId: PropTypes.string.isRequired
};

function LocationOptionToggle(_ref) {
  var item = _ref.item,
      orderId = _ref.orderId;
  return /*#__PURE__*/jsxs(Stack$2, {
    children: [/*#__PURE__*/jsx$1("legend", {
      children: /*#__PURE__*/jsx$1(Heading, {
        children: strings$1.title
      })
    }), /*#__PURE__*/jsx$1(LocationOptions, {
      item: item,
      orderId: orderId
    })]
  });
}

function LocationOptions(_ref2) {
  var item = _ref2.item,
      orderId = _ref2.orderId;
  var currencyCode = getCurrencyByCode(LS.getItem(storageKeys.Currency)).code.toUpperCase(); // API requires 'USD', 'CAD', etc.

  var _useState = useState(0),
      _useState2 = _slicedToArray$4(_useState, 2),
      selectedOption = _useState2[0],
      setSelectedOption = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$4(_useState3, 2),
      isSaving = _useState4[0],
      setIsSaving = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray$4(_useState5, 2),
      serverLocations = _useState6[0],
      setServerLocations = _useState6[1];

  var _useOrderQuery = useOrderQuery(),
      useUpdateLocation = _useOrderQuery.useUpdateLocation,
      useGetServerLocations = _useOrderQuery.useGetServerLocations;

  var _useUpdateLocation = useUpdateLocation({
    onCompleted: function onCompleted() {
      setIsSaving(false);
    }
  }),
      _useUpdateLocation2 = _slicedToArray$4(_useUpdateLocation, 2),
      updateLocation = _useUpdateLocation2[0],
      updateLocationResult = _useUpdateLocation2[1];

  var _useGetServerLocation = useGetServerLocations({
    variables: {
      productType: item.productType,
      itemCode: getItemCode(item.details)
    }
  }),
      loading = _useGetServerLocation.loading,
      error = _useGetServerLocation.error,
      data = _useGetServerLocation.data;

  useEffect(function () {
    if (data && data.serverLocations) {
      var locations = mapToComponent(data.serverLocations, strings$1.locations);
      var selectedIdx = getObjIndex(locations, item);
      locations = moveToStartOfList(locations, selectedIdx);
      setServerLocations(locations);
    }
  }, [data]);

  if (error) {
    return /*#__PURE__*/jsx$1(Text$1, {
      children: strings$1.error
    });
  }

  if (loading) {
    return /*#__PURE__*/jsx$1(LocationOptionSkeleton, {
      options: 3
    });
  }

  var updateError = updateLocationResult.error;

  if (updateError) {
    return /*#__PURE__*/jsx$1(Text$1, {
      children: strings$1.errorUpdating
    });
  }

  return /*#__PURE__*/jsx$1(OptionToggle, {
    isSaving: isSaving,
    name: item.id,
    onSelect: function onSelect(idx) {
      if (selectedOption === idx) {
        return;
      }

      setIsSaving(true);
      setSelectedOption(idx);
      updateLocation({
        variables: {
          id: orderId,
          itemId: item.id,
          newServerLocation: serverLocations[idx].value,
          currency: currencyCode
        }
      });
    },
    options: serverLocations,
    selected: selectedOption
  });
}

LocationOptions.propTypes = propTypes$1c;
LocationOptionToggle.propTypes = propTypes$1c;

function ownKeys$18(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$18(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$18(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$18(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var propTypes$1b = {
  containerProps: PropTypes.shape({}),
  iconColor: PropTypes.string,
  id: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  text: PropTypes.string
};
var defaultProps$B = {
  containerProps: {},
  iconColor: 'white',
  text: 'Are you sure you want to delete this item?'
};

function OrderItemDeleteButton(_ref) {
  _ref.iconColor;
  _ref.id;
  var onConfirm = _ref.onConfirm;
  _ref.text;
  var containerProps = _ref.containerProps;

  var confirmHandler = function confirmHandler() {
    onConfirm();
  };

  return /*#__PURE__*/jsx$1(Box$1, _objectSpread$18(_objectSpread$18({}, containerProps), {}, {
    children: /*#__PURE__*/jsx$1(Button$1, {
      color: "black",
      height: "3rem",
      variant: "minimal",
      width: "3rem",
      children: /*#__PURE__*/jsx$1(Icon$2, {
        height: "100%",
        name: "close",
        onClick: confirmHandler,
        title: "remove-item",
        width: "100%"
      })
    })
  }));
}

OrderItemDeleteButton.defaultProps = defaultProps$B;
OrderItemDeleteButton.propTypes = propTypes$1b;

function ownKeys$17(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$17(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$17(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$17(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var getPeriod = function getPeriod(newCount, item) {
  if (isSubscriptionProduct(item.productType)) {
    if (newCount === '12') {
      return 'year';
    }

    if (newCount === '1') {
      return 'month';
    }
  }

  return item.term.period;
};

function OrderTermDropdown(_ref) {
  var orderId = _ref.orderId,
      item = _ref.item,
      options = _ref.options,
      isLoading = _ref.isLoading,
      currency = _ref.currency;

  var _useOrderService = useOrderService(),
      setUpdatePrice = _useOrderService.setUpdatePrice,
      updatePrice = _useOrderService.updatePrice;

  var _useOrderQuery = useOrderQuery(),
      useUpdateTerm = _useOrderQuery.useUpdateTerm;

  var _useUpdateTerm = useUpdateTerm(),
      _useUpdateTerm2 = _slicedToArray$4(_useUpdateTerm, 2),
      updateTerm = _useUpdateTerm2[0],
      loading = _useUpdateTerm2[1].loading;

  var formattedOptions = options.map(function (option) {
    return {
      display: "Term: ".concat(option.display),
      label: "Term: ".concat(option.display),
      value: option.value
    };
  });
  useEffect(function () {
    if (loading) {
      setUpdatePrice({
        itemId: item.id,
        requiresFullUpdate: false
      });
    } else if (updatePrice && updatePrice.itemId === item.id) {
      setUpdatePrice({
        itemId: 0,
        requiresFullUpdate: false
      });
    }
  }, [loading]);
  return /*#__PURE__*/jsx$1(Select$2, {
    disabled: loading,
    id: "".concat(item.id, "-term"),
    inline: true,
    isLoading: isLoading,
    onChange: function onChange(value) {
      var newTermCount = parseInt(value, 10).toString();
      updateTerm({
        variables: {
          id: orderId,
          itemId: item.id,
          newTerm: {
            count: newTermCount,
            period: getPeriod(newTermCount, item)
          },
          currency: currency.code.toUpperCase(),
          tracking: _objectSpread$17(_objectSpread$17({}, item), {}, {
            term: _objectSpread$17(_objectSpread$17({}, item.term), {}, {
              count: newTermCount
            })
          })
        }
      });
    },
    options: formattedOptions,
    selected: item.term.count,
    value: item.term.count
  });
}

OrderTermDropdown.defaultProps = {
  item: {},
  options: [],
  isLoading: false
};
OrderTermDropdown.propTypes = {
  isLoading: PropTypes.bool,
  item: PropTypes.shape({}),
  options: PropTypes.arrayOf(PropTypes.shape({
    display: PropTypes.string,
    value: PropTypes.string
  }))
};
var Strings = {
  error: 'Unable to load term'
};

function ownKeys$16(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$16(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$16(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$16(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var propTypes$1a = {
  item: PropTypes.shape({
    details: PropTypes.shape({
      domainName: PropTypes.string
    }),
    productType: PropTypes.string,
    term: PropTypes.shape({})
  }),
  orderId: PropTypes.string
};
var defaultProps$A = {
  item: {},
  orderId: '0'
};

var getTermVariables = function getTermVariables(item) {
  var variables = {
    productType: item.productType,
    itemCode: getItemCode(item.details)
  };

  if (item.productType.toLowerCase() === 'renew') {
    var vars = _objectSpread$16(_objectSpread$16({}, variables), {}, {
      domain: item.details.domainName
    });

    return vars;
  }

  return variables;
};

function OrderTerm(_ref) {
  var orderId = _ref.orderId,
      item = _ref.item,
      currency = _ref.currency;

  var _useOrderQuery = useOrderQuery(),
      useGetProductPurchaseTerms = _useOrderQuery.useGetProductPurchaseTerms;

  var _useGetProductPurchas = useGetProductPurchaseTerms({
    variables: getTermVariables(item)
  }),
      loading = _useGetProductPurchas.loading,
      data = _useGetProductPurchas.data,
      error = _useGetProductPurchas.error;

  if (loading) {
    return /*#__PURE__*/jsx$1(Skeleton$1, {
      width: "100%",
      minHeight: "20px"
    });
  }

  if (!item.term || item.productType === ProductTypes.Backorder) {
    return null;
  }

  if (error) {
    return /*#__PURE__*/jsx$1(Text$1, {
      children: Strings.error
    });
  }

  return /*#__PURE__*/jsx$1(OrderTermDropdown, {
    isLoading: loading,
    item: item,
    options: data && data.productsPurchaseTerms,
    orderId: orderId,
    currency: currency
  });
}

OrderTerm.defaultProps = defaultProps$A;
OrderTerm.propTypes = propTypes$1a;
var strikethrough = css$3(["text-decoration:line-through;"]);

function Pricing(_ref) {
  var price = _ref.price,
      term = _ref.term,
      showTerm = _ref.showTerm,
      isFreeTrial = _ref.isFreeTrial,
      loading = _ref.loading,
      testId = _ref.testId,
      color = _ref.color,
      variant = _ref.variant;
  var salePrice = Pricing.getSaleDisplayPrice(price);
  var regularPrice = Pricing.getRegularDisplayPrice(price);
  var renewPrice = Pricing.getRenewDisplayPrice(price);
  var showRenewPrice = Boolean(renewPrice && parseFloat(renewPrice.slice(1)) > parseFloat(regularPrice.slice(1)));
  var hasSale = Boolean(salePrice) && salePrice !== regularPrice;
  var termDisplay = showTerm ? /*#__PURE__*/jsx$1("span", {
    children: "/".concat(term)
  }) : '';

  if (isFreeTrial) {
    if (hasSale) {
      salePrice = 'Free Trial';
    } else {
      regularPrice = 'Free Trial';
    }
  }

  return /*#__PURE__*/jsx$1(Box$1, {
    "data-testid": testId,
    isLoading: loading,
    ml: 2,
    children: /*#__PURE__*/jsxs(Box$1, {
      children: [(hasSale || showRenewPrice) && /*#__PURE__*/jsx$1(_StyledText$l, {
        mr: 2,
        variant: variant || null,
        children: showRenewPrice ? renewPrice : regularPrice
      }), /*#__PURE__*/jsxs(Text$1, {
        hasSale: hasSale || showRenewPrice,
        color: color || 'black',
        variant: variant || null,
        children: [hasSale ? salePrice : regularPrice, termDisplay]
      })]
    })
  });
}

Pricing.getRenewDisplayPrice = function (_ref2) {
  var renew = _ref2.renew;
  return Pricing.formatPrice(renew);
};

Pricing.getRegularDisplayPrice = function (_ref3) {
  var regular = _ref3.regular;
  return Pricing.formatPrice(regular);
};

Pricing.getSaleDisplayPrice = function (_ref4) {
  var sale = _ref4.sale;

  if (!isNil(sale)) {
    return Pricing.formatPrice(sale);
  }

  return '';
};

Pricing.getSavedDisplayPrice = function (price) {
  var sale = Pricing.getPriceToCharge(price);
  var regular = Pricing.getRegularPrice(price);
  var saved = regular - sale;
  return Pricing.formatPrice(saved);
};

Pricing.getPriceToCharge = function (_ref5) {
  var sale = _ref5.sale,
      regular = _ref5.regular;
  return typeof sale !== 'undefined' && sale !== null ? sale : regular;
};

Pricing.getRegularPrice = function (_ref6) {
  var renew = _ref6.renew,
      regular = _ref6.regular;
  return typeof regular !== 'undefined' && regular !== null ? regular : renew;
};

Pricing.formatPrice = function (price) {
  if (isNil(price)) {
    return '';
  }

  var priceAsFloat = price;

  if (typeof price === 'string') {
    priceAsFloat = parseFloat(price);
  }

  if (priceAsFloat === 0) {
    return 'Free';
  }

  return "$".concat(priceAsFloat.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'));
};

Pricing.defaultProps = {
  loading: false,
  price: {},
  term: 'yr',
  showTerm: false,
  testId: ''
};
Pricing.propTypes = {
  loading: PropTypes.bool,
  price: PropTypes.shape({
    currency: PropTypes.string,
    regular: PropTypes.number,
    renew: PropTypes.number,
    sale: PropTypes.number
  }),
  showTerm: PropTypes.bool,
  term: PropTypes.oneOf(['yr', 'mth']),
  testId: PropTypes.string
};
Pricing.demo = true;
Pricing.options = {
  loading: false,
  price: {
    type: 'object',
    "default": {
      regular: 19.99,
      sale: 4.5,
      renew: 25.99
    }
  },
  showTerm: {
    type: 'boolean',
    "default": false,
    demo: true
  },
  size: {
    type: 'number'
  }
};

var _StyledText$l = styled(Text$1).withConfig({
  displayName: "pricing___StyledText",
  componentId: "sc-1uwllk8-0"
})(["", ""], strikethrough);

var propTypes$19 = {
  beingUpdated: PropTypes.bool.isRequired,
  item: PropTypes.shape({}).isRequired,
  orderId: PropTypes.string.isRequired
};

var getDecimalPlace = function getDecimalPlace(price) {
  if (price.toString().indexOf('.') < 0) {
    return price;
  }

  return Number(price).toFixed(2);
};

function OrderMutableItemBody(_ref) {
  var item = _ref.item,
      orderId = _ref.orderId,
      beingUpdated = _ref.beingUpdated,
      currency = _ref.currency,
      associatedItems = _ref.associatedItems;

  var _useOrderQuery = useOrderQuery(),
      useRemoveItem = _useOrderQuery.useRemoveItem;

  var _useRemoveItem = useRemoveItem(),
      _useRemoveItem2 = _slicedToArray$4(_useRemoveItem, 1),
      removeItem = _useRemoveItem2[0];

  var termPrice = getItemTermPrice(item);

  var renderItemRenewalPrice = function renderItemRenewalPrice() {
    if (termPrice.sale || termPrice.regular !== termPrice.renew) {
      var numValue = Number(termPrice.renew);

      if (numValue > 0) {
        return /*#__PURE__*/jsxs(Text$1, {
          fontSize: "1rem",
          pr: "1.2rem",
          textAlign: "right",
          children: ["Renews at $", getDecimalPlace(termPrice.renew), "/", item.term.period]
        });
      }
    }

    return null;
  };

  var showTermDropdown = item.productType !== ProductTypes.TransferII && item.productType !== ProductTypes.Difm && !isOneTimeSubscriptionPurchase(item.productType, item.itemCode);
  var canRemove = !beingUpdated;
  var isGoogleWorkspace = item.productType === ProductTypes.GoogleWorkspace;
  var isOpenExchange = item.productType === ProductTypes.OpenExchangeEmail;
  var hasAssociatedItems = (associatedItems === null || associatedItems === void 0 ? void 0 : associatedItems.length) > 0; // if term is not readonly that means there is associated items
  // if it is open exchange with no associated items, we need to not

  var templateAreas = isGoogleWorkspace || isOpenExchange && hasAssociatedItems ? "'dropdown dropdown' '. price'" : "'dropdown price'";

  var displayadditionalSubscriptionText = function displayadditionalSubscriptionText(item) {
    if (isGoogleWorkspace) {
      return /*#__PURE__*/jsxs(Text$1, {
        children: ["@ ", "$".concat(getUserGWSPrice(item), "/user/mo")]
      });
    }

    if (isOpenExchange && hasAssociatedItems) {
      return /*#__PURE__*/jsxs(Text$1, {
        children: ["@ ", "$".concat(getUserOXPrice(item), "/user/mo")]
      });
    }

    return '';
  };

  return /*#__PURE__*/jsxs(Box$1, {
    display: "block",
    children: [/*#__PURE__*/jsxs(Grid$1, {
      alignItems: "center",
      as: "li",
      "data-testid": "".concat(item.display.name, "-container"),
      fontSize: 0,
      gridGap: 3,
      gridTemplateAreas: templateAreas,
      gridTemplateColumns: "0.75fr 1fr",
      justifyContent: showTermDropdown ? 'space-between' : 'flex-end',
      children: [showTermDropdown && /*#__PURE__*/jsxs(Text$1, {
        alignItems: "center",
        alignSelf: "stretch",
        as: Box$1,
        color: "greyDarker",
        "data-testid": item.display.name,
        flex: "1",
        fontSize: "1rem",
        fontWeight: "regular",
        gridArea: "dropdown",
        letterSpacing: "1px",
        textStyle: "caps",
        children: ["@", isOpenExchange && !hasAssociatedItems ? item.display.name.split('- ')[1] : /*#__PURE__*/jsx$1(OrderTerm, {
          item: item,
          orderId: orderId,
          currency: currency
        })]
      }), /*#__PURE__*/jsxs(Box$1, {
        alignItems: "center",
        gridArea: "price",
        justifyContent: "flex-end",
        children: [isGoogleWorkspace || isOpenExchange && hasAssociatedItems ? displayadditionalSubscriptionText(item) : /*#__PURE__*/jsx$1(Pricing, {
          loading: beingUpdated,
          price: termPrice,
          isFreeTrial: isOpenExchange && !hasAssociatedItems,
          testId: "price-".concat(item.display.name, "-").concat(beingUpdated ? 'updating' : 'loaded'),
          color: isInternic ? 'success' : 'magenta',
          variant: "gigaBold"
        }), canRemove && /*#__PURE__*/jsx$1(OrderItemDeleteButton, {
          containerProps: {
            ml: 2
          },
          id: "".concat(item.id, "-remove"),
          onConfirm: function onConfirm() {
            removeItem({
              variables: {
                id: orderId,
                itemId: item.id,
                currency: currency.code.toUpperCase(),
                tracking: item
              }
            });
          }
        })]
      })]
    }), renderItemRenewalPrice()]
  });
}

OrderMutableItemBody.propTypes = propTypes$19;
var defaultProps$z = {
  name: ''
};
var propTypes$18 = {
  name: PropTypes.string.isRequired
};

var OrderItemDisplayName = function OrderItemDisplayName(_ref) {
  var item = _ref.item;
  var name = item.display.name;

  if (name.indexOf('xn--') >= 0) {
    return punycode.toUnicode(name);
  }

  return getTitle(item);
};

OrderItemDisplayName.defaultProps = defaultProps$z;
OrderItemDisplayName.propTypes = propTypes$18;
var _excluded$t = ["item", "maxHeadingWidth"];

function ownKeys$15(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$15(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$15(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$15(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var propTypes$17 = {
  item: PropTypes.shape({
    productType: PropTypes.string,
    term: PropTypes.string
  }).isRequired,
  maxHeadingWidth: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string])
};
var defaultProps$y = {
  maxHeadingWidth: null
};

function OrderItemHeader(_ref) {
  var item = _ref.item,
      maxHeadingWidth = _ref.maxHeadingWidth,
      rest = _objectWithoutProperties$8(_ref, _excluded$t);

  var productType = item.productType,
      details = item.details;
  return /*#__PURE__*/jsxs(Stack$2, _objectSpread$15(_objectSpread$15({}, rest), {}, {
    children: [// If domain is part of a bundle, show BUNDLE flag.
    details.bundleId ? /*#__PURE__*/jsx$1(Text$1, {
      fontSize: "10px",
      color: "primary-700",
      fontWeight: "semi",
      children: "BUNDLE"
    }) : null, /*#__PURE__*/jsx$1(_StyledText$k, {
      as: "h3",
      "data-testid": "orderItem-".concat(productType),
      headingStyle: 4,
      maxWidth: maxHeadingWidth,
      overflow: "hidden",
      variant: "gigaBold",
      children: /*#__PURE__*/jsx$1(OrderItemDisplayName, {
        item: item
      })
    }), /*#__PURE__*/jsx$1(Text$1, {
      variant: "milliBold",
      children: getSubtitle(productType)
    })]
  }));
}

OrderItemHeader.propTypes = propTypes$17;
OrderItemHeader.defaultProps = defaultProps$y;

var _StyledText$k = styled(Text$1).withConfig({
  displayName: "order-item-header___StyledText",
  componentId: "sc-b3arpv-0"
})(["text-overflow:ellipsis;"]);

var _excluded$s = ["parentId", "item", "orderMutableItemProductType", "prices", "removeAddon", "readOnly", "withBorder"];

function ownKeys$14(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$14(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$14(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$14(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var propTypes$16 = {
  item: PropTypes.shape({
    display: PropTypes.shape({
      name: PropTypes.string.isRequired
    }),
    productType: PropTypes.string
  }).isRequired,
  orderMutableItemProductType: PropTypes.string.isRequired,
  parentId: PropTypes.string.isRequired,
  prices: PropTypes.shape({}).isRequired,
  readOnly: PropTypes.bool,
  removeAddon: PropTypes.func,
  term: PropTypes.shape({}).isRequired,
  withBorder: PropTypes.bool
};
var defaultProps$x = {
  readOnly: false,
  removeAddon: null,
  withBorder: true
};

function OrderReadOnlySubItem(_ref) {
  var parentId = _ref.parentId,
      item = _ref.item,
      orderMutableItemProductType = _ref.orderMutableItemProductType,
      prices = _ref.prices,
      removeAddon = _ref.removeAddon,
      readOnly = _ref.readOnly,
      withBorder = _ref.withBorder,
      rest = _objectWithoutProperties$8(_ref, _excluded$s);

  var _useOrderService = useOrderService(),
      updatePrice = _useOrderService.updatePrice;

  var beingUpdated = updatePrice.itemId === parentId;
  var price = {};
  var isGoogleWorkspace = item.productType === ProductTypes.GoogleWorkspaceUser;
  var isOpenExchangeUser = item.productType === ProductTypes.OpenExchangeUser;
  var isRenewal = orderMutableItemProductType === ProductTypes.Renew;
  var isRegistrationFee = item.productType === ProductTypes.RegistrationFee;
  var isSensitiveAddOn = [ProductTypes.OwnershipLock, ProductTypes.Privacy, ProductTypes.Security].includes(item.productType) && isRenewal;

  if (prices) {
    price = {
      sale: prices.promo ? prices.regular.price + prices.promo.price : null,
      regular: prices.regular.price
    };
  }

  return /*#__PURE__*/jsxs(Text$1, _objectSpread$14(_objectSpread$14({
    alignItems: "center",
    as: "li",
    display: "flex",
    fontSize: "1rem",
    justifyContent: "space-between"
  }, rest), {}, {
    children: [/*#__PURE__*/jsxs(Box$1, {
      alignItems: "center",
      alignSelf: "stretch",
      as: Text$1,
      flex: "1",
      fontSize: 0,
      fontWeight: "semi",
      children: [withBorder && /*#__PURE__*/jsx$1(Box$1, {
        alignSelf: "stretch",
        borderLeft: 2,
        borderRadius: "25%",
        mr: 2
      }), getTitle(item)]
    }), /*#__PURE__*/jsx$1(Pricing, {
      loading: beingUpdated,
      price: price,
      showTerm: false
    }), !readOnly && !beingUpdated && !isGoogleWorkspace && !isOpenExchangeUser && !isRenewal && !isRegistrationFee && !isSensitiveAddOn && /*#__PURE__*/jsx$1(OrderItemDeleteButton, {
      containerProps: {
        ml: 2
      },
      id: "remove-".concat(parentId, "-").concat(item.display.name),
      onConfirm: removeAddon
    })]
  }));
}

OrderReadOnlySubItem.propTypes = propTypes$16;
OrderReadOnlySubItem.defaultProps = defaultProps$x;

function OrderItemToggleContent(_ref) {
  var title = _ref.title,
      isLoading = _ref.isLoading,
      error = _ref.error,
      price = _ref.price,
      isApplied = _ref.isApplied,
      isRefreshing = _ref.isRefreshing;
  return /*#__PURE__*/jsxs(ContentWrapper, {
    children: [/*#__PURE__*/jsx$1(Heading, {
      children: title
    }), !isLoading && !error && price && price.regular && /*#__PURE__*/jsx$1(Pricing, {
      price: {
        regular: price.regular.price,
        sale: price.regular.promo
      },
      showTerm: true,
      term: "yr"
    }), !isLoading && !error && !isRefreshing && /*#__PURE__*/jsx$1(OrderItemToggleAction, {
      isApplied: isApplied,
      children: "+"
    })]
  });
}

OrderItemToggleContent.defaultProps = {
  isApplied: false,
  isLoading: false,
  isRefreshing: false,
  error: false,
  price: null
};
OrderItemToggleContent.propTypes = {
  error: PropTypes.bool,
  isApplied: PropTypes.bool,
  isLoading: PropTypes.bool,
  isRefreshing: PropTypes.bool,
  price: PropTypes.shape({
    regular: PropTypes.shape({
      price: PropTypes.number,
      promo: PropTypes.number
    })
  }),
  title: PropTypes.string.isRequired
};
var gutter$3 = {
  eigth: '0.2rem',
  quarter: '0.4rem',
  half: '0.8rem',
  "default": '1.6rem',
  big: '2.4rem',
  bigger: '4rem',
  biggest: '8rem'
};
var ContentWrapper = styled.div.withConfig({
  displayName: "order-item-toggle-content__ContentWrapper",
  componentId: "sc-1vviv6x-0"
})(["display:flex;justify-content:space-between;font-size:1rem;align-items:center;border:1px solid LightGray;padding:", ";padding-left:", ";"], gutter$3.half, gutter$3["default"]);
var OrderItemToggleAction = styled.div.withConfig({
  displayName: "order-item-toggle-content__OrderItemToggleAction",
  componentId: "sc-1vviv6x-1"
})(["font-size:2.6rem;height:2rem;width:2rem;display:flex;justify-content:center;align-items:center;font-weight:400;border:1px solid LightGray;color:LightGray;border-radius:2px;padding:", " ", ";margin-left:", ";cursor:pointer;transition:all 0.2s;&:hover{background:LightGray;color:white;}"], gutter$3.eigth, gutter$3.quarter, gutter$3["default"]);

function ownKeys$13(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$13(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$13(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$13(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function PrivacyItem(_ref) {
  var id = _ref.id,
      isApplied = _ref.isApplied,
      isLoading = _ref.isLoading,
      error = _ref.error,
      title = _ref.title,
      price = _ref.price,
      orderId = _ref.orderId,
      item = _ref.item,
      currency = _ref.currency;

  var _useOrderService = useOrderService(),
      updatePrice = _useOrderService.updatePrice;

  var _useOrderQuery = useOrderQuery(),
      useAddPrivacy = _useOrderQuery.useAddPrivacy;

  var _useAddPrivacy = useAddPrivacy(),
      _useAddPrivacy2 = _slicedToArray$4(_useAddPrivacy, 2),
      addPrivacy = _useAddPrivacy2[0],
      loading = _useAddPrivacy2[1].loading;

  var beingUpdated = updatePrice.itemId === item.id;
  return /*#__PURE__*/jsxs(OrderItemToggleWrapper$1, {
    htmlFor: id,
    children: [/*#__PURE__*/jsx$1("input", {
      id: id,
      onChange: function onChange() {
        addPrivacy({
          variables: {
            id: orderId,
            parent: item.id,
            details: {
              domainName: item.display.name,
              tld: item.details.tld
            },
            term: {
              count: item.term.count,
              period: item.term.period
            },
            currency: currency.code.toUpperCase(),
            tracking: _objectSpread$13(_objectSpread$13({}, item.details), {}, {
              productType: 'Privacy',
              source: 'Checkout'
            })
          }
        });
      },
      type: "checkbox"
    }), /*#__PURE__*/jsx$1(OrderItemToggleContent, {
      error: error,
      isApplied: isApplied,
      isLoading: isLoading,
      isRefreshing: beingUpdated,
      price: price,
      title: title
    }), loading && /*#__PURE__*/jsx$1(Text$1, {
      children: "Adding..."
    })]
  }, item.id);
}

PrivacyItem.defaultProps = {
  isApplied: false,
  isLoading: false,
  error: false,
  securityProductType: null,
  price: null
};
PrivacyItem.propTypes = {
  error: PropTypes.bool,
  id: PropTypes.string.isRequired,
  isApplied: PropTypes.bool,
  isLoading: PropTypes.bool,
  item: PropTypes.shape({}).isRequired,
  orderId: PropTypes.string.isRequired,
  price: PropTypes.shape({
    regular: PropTypes.shape({
      price: PropTypes.number
    })
  }),
  securityProductType: PropTypes.string,
  title: PropTypes.string.isRequired
};
var gutter$2 = {
  eigth: '0.2rem',
  quarter: '0.4rem',
  half: '0.8rem',
  "default": '1.6rem',
  big: '2.4rem',
  bigger: '4rem',
  biggest: '8rem'
};
var OrderItemToggleWrapper$1 = styled.label.withConfig({
  displayName: "privacy-item__OrderItemToggleWrapper",
  componentId: "sc-1i0jm7j-0"
})(["position:relative;margin-bottom:", ";background:white;border:1px solid LightGray;&:last-child{margin-bottom:0;}> input[type='checkbox']{opacity:0;position:absolute;}> input[type='checkbox']:focus + div{outline:rgb(59,153,252) auto 5px;}> input[type='checkbox']:checked + div{border-color:LightGray;}"], gutter$2.quarter);

function ownKeys$12(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$12(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$12(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$12(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function SecurityItem(_ref) {
  var id = _ref.id,
      isApplied = _ref.isApplied,
      isLoading = _ref.isLoading,
      error = _ref.error,
      title = _ref.title,
      price = _ref.price,
      orderId = _ref.orderId,
      item = _ref.item,
      securityProductType = _ref.securityProductType,
      currency = _ref.currency;

  var _useOrderService = useOrderService(),
      updatePrice = _useOrderService.updatePrice;

  var _useOrderQuery = useOrderQuery(),
      useAddSecurity = _useOrderQuery.useAddSecurity;

  var _useAddSecurity = useAddSecurity(),
      _useAddSecurity2 = _slicedToArray$4(_useAddSecurity, 2),
      addSecurity = _useAddSecurity2[0],
      loading = _useAddSecurity2[1].loading;

  var beingUpdated = updatePrice.itemId === item.id;
  return /*#__PURE__*/jsxs(OrderItemToggleWrapper, {
    htmlFor: id,
    children: [/*#__PURE__*/jsx$1("input", {
      id: id,
      onChange: function onChange() {
        addSecurity({
          variables: {
            id: orderId,
            parent: item.id,
            details: {
              domainName: item.display.name,
              tld: item.details.tld,
              securityProductType: securityProductType
            },
            term: {
              count: item.term.count,
              period: item.term.period
            },
            currency: currency.code.toUpperCase(),
            tracking: _objectSpread$12(_objectSpread$12({}, item.details), {}, {
              productType: 'Security Bundle',
              source: 'Checkout'
            })
          }
        });
      },
      type: "checkbox"
    }), /*#__PURE__*/jsx$1(OrderItemToggleContent, {
      error: error,
      isApplied: isApplied,
      isLoading: isLoading,
      isRefreshing: beingUpdated,
      price: price,
      title: title
    }), loading && /*#__PURE__*/jsx$1(Text$1, {
      children: "Adding..."
    })]
  }, item.id);
}

SecurityItem.defaultProps = {
  isApplied: false,
  isLoading: false,
  error: false,
  securityProductType: null,
  price: null
};
SecurityItem.propTypes = {
  error: PropTypes.bool,
  id: PropTypes.string.isRequired,
  isApplied: PropTypes.bool,
  isLoading: PropTypes.bool,
  item: PropTypes.shape({}).isRequired,
  orderId: PropTypes.string.isRequired,
  price: PropTypes.shape({
    regular: PropTypes.shape({
      price: PropTypes.number
    })
  }),
  securityProductType: PropTypes.string,
  title: PropTypes.string.isRequired
};
var gutter$1 = {
  eigth: '0.2rem',
  quarter: '0.4rem',
  half: '0.8rem',
  "default": '1.6rem',
  big: '2.4rem',
  bigger: '4rem',
  biggest: '8rem'
};
var OrderItemToggleWrapper = styled.label.withConfig({
  displayName: "security-item__OrderItemToggleWrapper",
  componentId: "sc-ps417t-0"
})(["position:relative;margin-bottom:", ";background:white;border:1px solid LightGray;&:last-child{margin-bottom:0;}> input[type='checkbox']{opacity:0;position:absolute;}> input[type='checkbox']:focus + div{outline:rgb(59,153,252) auto 5px;}> input[type='checkbox']:checked + div{border-color:LightGray;}"], gutter$1.quarter);

function ownKeys$11(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$11(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$11(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$11(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function OrderItemToggle(_ref) {
  var id = _ref.id,
      type = _ref.type,
      isApplied = _ref.isApplied,
      title = _ref.title,
      orderId = _ref.orderId,
      item = _ref.item,
      securityProductType = _ref.securityProductType,
      currency = _ref.currency;

  var _useOrderQuery = useOrderQuery(),
      useGetAddonPrices = _useOrderQuery.useGetAddonPrices;

  var _useGetAddonPrices = useGetAddonPrices({
    variables: {
      productType: securityProductType,
      currency: currency.code.toUpperCase(),
      reseller: 'Rebel'
    }
  }),
      data = _useGetAddonPrices.data,
      isLoading = _useGetAddonPrices.loading,
      error = _useGetAddonPrices.error;

  var _data = _objectSpread$11({}, data),
      pricesByProductType = _data.pricesByProductType;

  var price = !error ? pricesByProductType : {};

  if (isApplied) {
    return null;
  }

  if (type === 'security') {
    return /*#__PURE__*/jsx$1(SecurityItem, {
      error: Boolean(error),
      id: id,
      isApplied: isApplied,
      isLoading: isLoading,
      item: item,
      orderId: orderId,
      price: price,
      securityProductType: securityProductType,
      title: title,
      currency: currency
    });
  }

  return /*#__PURE__*/jsx$1(PrivacyItem, {
    error: Boolean(error),
    id: id,
    isApplied: isApplied,
    isLoading: isLoading,
    item: item,
    orderId: orderId,
    price: price,
    title: title,
    currency: currency
  });
}

var _excluded$r = ["orderId", "item", "currency"];

function ownKeys$10(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$10(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$10(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$10(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var isAddonApplied = function isAddonApplied(item, addonType) {
  if (!item.addons || !item.addons.length) {
    return false;
  }

  var addonMatches = item.addons.find(function (a) {
    return a.display.name.split(' - ')[0] === addonType;
  });
  return Boolean(addonMatches);
};

var getAddonsToDisplay = function getAddonsToDisplay(item, upsells) {
  return upsells.filter(function (addon) {
    return !isAddonApplied(item, addon.matcher);
  });
};

function UpsellList(_ref) {
  var orderId = _ref.orderId,
      item = _ref.item,
      currency = _ref.currency,
      rest = _objectWithoutProperties$8(_ref, _excluded$r);

  var _useOrderQuery = useOrderQuery(),
      useGetDomainUpsells = _useOrderQuery.useGetDomainUpsells;

  var _useGetDomainUpsells = useGetDomainUpsells({
    variables: {
      domain: item.display.name
    }
  }),
      loading = _useGetDomainUpsells.loading,
      data = _useGetDomainUpsells.data,
      error = _useGetDomainUpsells.error; // We want to fail silently since this is an upsell


  if (loading || error || !data || !data.domainUpsells.length) {
    return null;
  }

  var typeAddons = getAddonsToDisplay(item, data.domainUpsells);

  if (!typeAddons.length) {
    return null;
  }

  return /*#__PURE__*/jsxs(Box$1, _objectSpread$10(_objectSpread$10({
    flexDirection: "column"
  }, rest), {}, {
    children: [/*#__PURE__*/jsx$1(Heading, {
      as: "h3",
      fontSize: 2,
      fontWeight: "regular",
      mb: 2,
      children: "Frequently bought together"
    }), typeAddons.map(function (_ref2) {
      var type = _ref2.type,
          title = _ref2.title,
          securityProductType = _ref2.securityProductType,
          matcher = _ref2.matcher;
      return /*#__PURE__*/jsx$1(OrderItemToggle, {
        id: "".concat(item.id, "-").concat(title),
        isApplied: isAddonApplied(matcher),
        item: item,
        orderId: orderId,
        securityProductType: securityProductType,
        title: title,
        type: type,
        currency: currency
      }, "".concat(item.id, "-").concat(title));
    })]
  }));
}

UpsellList.defaultProps = {
  item: {},
  orderId: '0'
};
UpsellList.propTypes = {
  item: PropTypes.shape({
    display: PropTypes.shape({
      name: PropTypes.string
    })
  }),
  orderId: PropTypes.string
};
var colors$k = theme.colors;
var hasBulkSecurity = bulkSecurityService.hasBulkSecurity;

function AssociatedItems(_ref) {
  var orderId = _ref.orderId,
      associatedItems = _ref.associatedItems,
      updatePrice = _ref.updatePrice;
  return /*#__PURE__*/jsx$1(Stack$2, {
    pt: 3,
    children: /*#__PURE__*/jsx$1(Box$1, {
      flexDirection: "column",
      children: associatedItems.map(function (i) {
        var updatingAsscItem = updatePrice.itemId === i.id;
        return /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx$1(OrderItemHeader, {
            item: i
          }), /*#__PURE__*/jsx$1("ul", {
            children: /*#__PURE__*/jsx$1(OrderMutableItemBody, {
              beingUpdated: updatingAsscItem,
              item: i,
              orderId: orderId
            })
          })]
        });
      })
    })
  });
}

function OrderReadOnlyItem(_ref2) {
  var item = _ref2.item,
      orderId = _ref2.orderId,
      currency = _ref2.currency,
      associatedItems = _ref2.associatedItems;

  var _useOrderQuery = useOrderQuery(),
      useRemoveItem = _useOrderQuery.useRemoveItem;

  var _useRemoveItem = useRemoveItem(),
      _useRemoveItem2 = _slicedToArray$4(_useRemoveItem, 1),
      removeItem = _useRemoveItem2[0];

  var id = item.id,
      addons = item.addons,
      productType = item.productType;
  item.details;

  var _useOrderService = useOrderService(),
      updatePrice = _useOrderService.updatePrice;

  var beingUpdated = updatePrice.itemId === id;
  getItemTermPrice(item);
  var hasBulkSec = hasBulkSecurity();
  var canEdit = isEditableProduct(item.productType);

  var renderSubItems = function renderSubItems() {
    if (!addons || addons.length === 0) {
      return null;
    }

    var orderMutableItemProductType = item.productType;
    return /*#__PURE__*/jsx$1(Box$1, {
      as: "ul",
      flexDirection: "column",
      pl: 3,
      pt: 3,
      children: addons.map(function (addon, index) {
        addon.parent;
        var prices = addon.prices,
            id = addon.id,
            term = addon.term,
            type = addon.type;
        return /*#__PURE__*/jsx$1(OrderReadOnlySubItem, {
          orderMutableItemProductType: orderMutableItemProductType,
          id: "".concat(index, "-").concat(type),
          item: addon,
          parentId: id,
          prices: prices,
          py: 1,
          term: term,
          withBorder: !hasBulkSec,
          currency: currency,
          removeAddon: function removeAddon() {
            return removeItem({
              variables: {
                id: orderId,
                itemId: id,
                currency: currency.code.toUpperCase(),
                tracking: addon
              }
            });
          }
        }, "".concat(index, "-").concat(type));
      })
    });
  };

  var getNotes = function getNotes() {
    var productType = item.productType,
        details = item.details;
    var notes = [];
    productCheckoutNotes.notes.forEach(function (n) {
      if ((productType === ProductTypes.Registration || productType === ProductTypes.Backorder) && n.tlds && n.tlds.some(function (tld) {
        return details.tld.endsWith(".".concat(tld));
      }) || productType === ProductTypes.PleskPackage && n.packageIds && n.packageIds.includes(details.packageId) || associatedItems[0] && associatedItems[0].assetType === 'Hosting' && n.packageIds && n.packageIds.includes(associatedItems[0].details.packageId)) {
        var str = n.note;

        if (n.resellerReplacement && n.resellerReplacement[isInternic ? 'internic' : 'rebel']) {
          n.resellerReplacement[isInternic ? 'internic' : 'rebel'].forEach(function (s) {
            str = str.replace("{".concat(s.search, "}"), s.replace);
          });
        }

        notes.push(str);
      }
    });

    if (notes.length === 0) {
      return null;
    }

    return notes.map(function (note, i) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        jsx$1(Box$1, {
          flex: "1",
          mt: 2,
          bg: "white",
          border: "1px solid",
          borderColor: colors$k.blueLight,
          children: /*#__PURE__*/jsx$1(Box$1, {
            display: "flex",
            justifyContent: "space-between",
            p: 1,
            children: /*#__PURE__*/jsx$1(Stack$2, {
              children: /*#__PURE__*/jsx$1(Text$1, {
                children: /*#__PURE__*/jsx$1("div", {
                  dangerouslySetInnerHTML: {
                    __html: "".concat(note)
                  }
                })
              })
            })
          })
        }, "key-".concat(i))
      );
    });
  };

  var getMainControl = function getMainControl() {
    return /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx$1(OrderItemHeader, {
        item: item,
        mb: 2
      }), /*#__PURE__*/jsx$1("ul", {
        children: /*#__PURE__*/jsx$1(OrderMutableItemBody, {
          beingUpdated: beingUpdated,
          item: item,
          orderId: orderId,
          termIsReadOnly: associatedItems.length > 0 || productType === ProductTypes.Difm,
          associatedItems: associatedItems,
          currency: currency
        })
      }), item && hasLocationSelector(productType) && /*#__PURE__*/jsx$1(Box$1, {
        pt: 2,
        children: /*#__PURE__*/jsx$1(LocationOptionToggle, {
          item: item,
          orderId: orderId,
          currency: currency
        })
      }), canEdit && renderSubItems()]
    });
  };

  var excludedUpsells = [ProductTypes.TransferII, ProductTypes.PartnerWebsite, ProductTypes.OpenExchangeEmail, ProductTypes.Marketgoo, ProductTypes.Renew];
  return /*#__PURE__*/jsxs(Stack$2, {
    mb: 3,
    width: "100%",
    children: [/*#__PURE__*/jsx$1(Stack$2, {
      children: getMainControl()
    }), !excludedUpsells.includes(item.productType) && /*#__PURE__*/jsx$1(Box$1, {
      children: /*#__PURE__*/jsx$1(UpsellList, {
        item: item,
        orderId: orderId,
        currency: currency
      })
    }), /*#__PURE__*/jsx$1(Box$1, {
      children: getNotes()
    }), associatedItems && /*#__PURE__*/jsx$1(AssociatedItems, {
      orderId: orderId,
      associatedItems: associatedItems,
      updatePrice: updatePrice
    })]
  });
}

OrderReadOnlyItem.defaultProps = {
  domains: {
    termOptions: []
  },
  item: {}
};
OrderReadOnlyItem.propTypes = {
  domains: PropTypes.shape({
    termOptions: PropTypes.arrayOf(PropTypes.shape({
      display: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])
    }))
  }),
  item: PropTypes.shape({
    addons: PropTypes.arrayOf(PropTypes.shape({})),
    display: PropTypes.shape({
      name: PropTypes.string.isRequired
    }),
    id: PropTypes.string,
    prices: PropTypes.shape({}),
    productType: PropTypes.string.isRequired,
    term: PropTypes.shape({
      count: PropTypes.string,
      period: PropTypes.oneOf(['month', 'year'])
    })
  })
};

var OrderSummaryBox = function OrderSummaryBox(_ref) {
  var order = _ref.order,
      orderId = _ref.orderId,
      currency = _ref.currency;
  return getGroupedItems(order.items).map(function (item, index) {
    var asscItems = getAssociatedItems(order.items, item);
    return item.productType === ProductTypes.icannFee || item.productType === ProductTypes.accountCredit ? null : /*#__PURE__*/jsx$1(Box$1, {
      mt: 4,
      children: /*#__PURE__*/jsx$1(OrderReadOnlyItem, {
        item: item,
        orderId: orderId,
        currency: currency,
        associatedItems: asscItems
      }, index)
    });
  });
};

function OrderTotal(_ref) {
  var order = _ref.order,
      currency = _ref.currency;
  var totals = order.totals;
  var savings = totals.savings,
      subTotal = totals.subTotal,
      tax = totals.tax,
      total = totals.total;
  var ICANNFees = order.items.reduce(function (sum, item) {
    if (item.productType === ProductTypes.icannFee) {
      var price = 0;

      if (item.prices) {
        price = item.prices.promo ? item.prices.regular.price + item.prices.promo.price : item.prices.regular.price;
      }

      return sum + price;
    }

    if (isNaN(sum)) {
      return 0;
    }

    return sum;
  }, 0);
  var accountCredit = order.items.find(function (item) {
    return item.productType === ProductTypes.accountCredit;
  });
  var outstandingBalance = order.items.find(function (item) {
    return item.productType === ProductTypes.outstandingBalance;
  }); // CA, US, AU, MXN

  var currencyCode = currency.code.toUpperCase().replace(/D/g, '');
  return /*#__PURE__*/jsxs(Stack$2, {
    width: "100%",
    children: [/*#__PURE__*/jsx$1(Box$1, {
      height: "1px",
      border: "1px solid LightGray",
      mb: 1,
      mt: 3,
      width: "100%"
    }), ICANNFees > 0 ? /*#__PURE__*/jsxs(Box$1, {
      width: "100%",
      mt: 2,
      children: [/*#__PURE__*/jsx$1(Box$1, {
        width: "100%",
        children: /*#__PURE__*/jsxs(Text$1, {
          justifyContent: "left",
          variant: "megaBold",
          children: ["ICANN Fees:", ' ']
        })
      }), /*#__PURE__*/jsx$1(Box$1, {
        children: /*#__PURE__*/jsxs(Text$1, {
          justifyContent: "right",
          variant: "megaBold",
          children: ["$", "".concat(Math.abs(ICANNFees).toFixed(2))]
        })
      })]
    }) : null, outstandingBalance && /*#__PURE__*/jsxs(Box$1, {
      width: "100%",
      mt: 2,
      children: [/*#__PURE__*/jsx$1(Box$1, {
        width: "100%",
        children: /*#__PURE__*/jsxs(Text$1, {
          justifyContent: "left",
          variant: "megaBold",
          children: ["Outstanding Balance:", ' ']
        })
      }), /*#__PURE__*/jsx$1(Box$1, {
        children: /*#__PURE__*/jsxs(Text$1, {
          justifyContent: "right",
          variant: "megaBold",
          children: ["$", "".concat(Math.abs(outstandingBalance.prices.regular.price).toFixed(2))]
        })
      })]
    }), /*#__PURE__*/jsxs(Box$1, {
      width: "100%",
      mt: 2,
      children: [/*#__PURE__*/jsx$1(Box$1, {
        width: "100%",
        children: /*#__PURE__*/jsxs(Text$1, {
          justifyContent: "left",
          variant: "megaBold",
          children: ["Subtotal:", ' ']
        })
      }), /*#__PURE__*/jsx$1(Box$1, {
        children: /*#__PURE__*/jsxs(Text$1, {
          justifyContent: "right",
          variant: "megaBold",
          children: ["$", "".concat(Math.abs(subTotal).toFixed(2))]
        })
      })]
    }), tax && tax.map(function (taxItem, index) {
      return /*#__PURE__*/jsxs(Box$1, {
        width: "100%",
        mt: 2,
        children: [/*#__PURE__*/jsx$1(Box$1, {
          width: "100%",
          children: /*#__PURE__*/jsx$1(Text$1, {
            justifyContent: "left",
            variant: "megaBold",
            children: taxItem.label
          })
        }), /*#__PURE__*/jsx$1(Box$1, {
          children: /*#__PURE__*/jsxs(Text$1, {
            justifyContent: "right",
            variant: "megaBold",
            children: ["$", Math.abs(taxItem.amount).toFixed(2)]
          })
        })]
      }, index);
    }), accountCredit && /*#__PURE__*/jsxs(Box$1, {
      width: "100%",
      mt: 2,
      children: [/*#__PURE__*/jsx$1(Box$1, {
        color: "#16A34A",
        width: "100%",
        children: /*#__PURE__*/jsxs(Text$1, {
          justifyContent: "left",
          variant: "megaBold",
          children: ["Account Credit:", ' ']
        })
      }), /*#__PURE__*/jsx$1(Box$1, {
        children: /*#__PURE__*/jsxs(Text$1, {
          color: "#16A34A",
          justifyContent: "right",
          variant: "megaBold",
          children: ["$", accountCredit.prices.regular.price]
        })
      })]
    }), /*#__PURE__*/jsx$1(Box$1, {
      height: "1px",
      border: "1px solid LightGray",
      mb: 1,
      mt: 3,
      width: "100%"
    }), savings !== 0 && /*#__PURE__*/jsxs(Box$1, {
      color: isInternic ? 'success' : 'magenta',
      width: "100%",
      mt: 2,
      children: [/*#__PURE__*/jsx$1(Box$1, {
        width: "100%",
        children: /*#__PURE__*/jsxs(Text$1, {
          justifyContent: "left",
          variant: "megaBold",
          children: ["You Saved:", ' ']
        })
      }), /*#__PURE__*/jsx$1(Box$1, {
        children: /*#__PURE__*/jsxs(Text$1, {
          justifyContent: "right",
          variant: "megaBold",
          children: ["$", "".concat(Math.abs(savings).toFixed(2))]
        })
      })]
    }), /*#__PURE__*/jsxs(Box$1, {
      width: "100%",
      mt: 2,
      children: [/*#__PURE__*/jsx$1(Box$1, {
        width: "100%",
        children: /*#__PURE__*/jsxs(Text$1, {
          justifyContent: "left",
          variant: "gigaBold",
          children: ["Total:", ' ']
        })
      }), /*#__PURE__*/jsx$1(Box$1, {
        children: /*#__PURE__*/jsxs(Text$1, {
          justifyContent: "right",
          variant: "gigaBold",
          children: [currencyCode, "\xA0$", "".concat(Math.abs(total).toFixed(2))]
        })
      })]
    })]
  });
}

var _excluded$q = ["autoFocus", "className", "disabled", "id", "label", "labelColor", "loading", "noDisable", "onChange", "onClearValue", "onSubmit", "small", "submitText", "value", "submitAriaLabel", "color", "placeholder", "borderColor"];

function ownKeys$$(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$$(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$$(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$$(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var fonts$1 = theme.fonts,
    colors$j = theme.colors,
    space$2 = theme.space;
var propTypes$15 = {
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  labelColor: PropTypes.string,
  loading: PropTypes.bool,
  noDisable: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onClearValue: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  small: PropTypes.bool,
  submitAriaLabel: PropTypes.string.isRequired,
  submitText: PropTypes.string,
  value: PropTypes.string.isRequired
};
var defaultProps$w = {
  autoFocus: false,
  borderColor: colors$j.grey,
  className: '',
  color: 'blue',
  labelColor: colors$j.greys[8],
  disabled: false,
  loading: false,
  noDisable: false,
  onClearValue: function onClearValue() {},
  placeholder: '',
  small: false,
  submitText: 'submit'
};
var SubmitFieldLabel = styled.label.withConfig({
  displayName: "submit-field__SubmitFieldLabel",
  componentId: "sc-1n30bcp-0"
})(["position:absolute;top:-2.2rem;font-size:1rem;font-weight:500;letter-spacing:1px;color:", ";text-transform:uppercase;transition:all 0.2s;"], function (props) {
  return props.labelColor;
});
var SubmitFieldInput = styled.input.withConfig({
  displayName: "submit-field__SubmitFieldInput",
  componentId: "sc-1n30bcp-1"
})(["border:none;background:transparent;font-size:1.2rem;flex:1;flex-basis:auto;padding-left:", ";font-family:", ";padding-right:2.5rem;&:focus + label{color:", ";top:-2.2rem;left:0;transform:translateY(0);}"], space$2.half, fonts$1["default"], function (props) {
  return props.borderColor;
});
var ClearTermButton = styled.button.withConfig({
  displayName: "submit-field__ClearTermButton",
  componentId: "sc-1n30bcp-2"
})(["display:flex;align-items:center;border:none;background:transparent;padding:0;transition:all 0.2s;position:absolute;top:50%;transform:translateY(-50%);right:0;", ""], function (_ref) {
  var hide = _ref.hide;
  return hide && 'opacity: 0;';
});

function SubmitField(_ref2) {
  var autoFocus = _ref2.autoFocus,
      className = _ref2.className,
      disabled = _ref2.disabled,
      id = _ref2.id,
      label = _ref2.label,
      labelColor = _ref2.labelColor,
      loading = _ref2.loading,
      noDisable = _ref2.noDisable,
      onChange = _ref2.onChange,
      onClearValue = _ref2.onClearValue,
      onSubmit = _ref2.onSubmit,
      small = _ref2.small,
      submitText = _ref2.submitText,
      value = _ref2.value,
      submitAriaLabel = _ref2.submitAriaLabel,
      color = _ref2.color,
      placeholder = _ref2.placeholder,
      borderColor = _ref2.borderColor,
      rest = _objectWithoutProperties$8(_ref2, _excluded$q);

  var inputRef = useRef();
  useEffect(function () {
    if (autoFocus) {
      inputRef.current.focus();
    }
  }, []);

  var handleClearTerm = function handleClearTerm() {
    inputRef.current.focus();
    onClearValue();
  };

  var handleSubmitClick = function handleSubmitClick(event) {
    if (event) {
      event.preventDefault();
    }

    onSubmit(value);
  };

  var handleKeyPress = function handleKeyPress(event) {
    if (event.key !== 'Enter') {
      return;
    }

    handleSubmitClick();
  };

  var isDisabled = noDisable ? false : disabled || loading || value.length === 0;
  return /*#__PURE__*/jsxs(Box$1, _objectSpread$$(_objectSpread$$({
    className: className
  }, rest), {}, {
    children: [/*#__PURE__*/jsxs(Box$1, {
      bg: "white",
      border: "1px solid ".concat(borderColor),
      flex: "1",
      position: "relative",
      children: [/*#__PURE__*/jsx$1(SubmitFieldInput, {
        ref: inputRef,
        "aria-label": label,
        id: "".concat(id, "-input"),
        onChange: onChange,
        onKeyPress: handleKeyPress,
        placeholder: placeholder,
        type: "email",
        value: value
      }), /*#__PURE__*/jsx$1(SubmitFieldLabel, {
        labelColor: labelColor,
        hide: value.length > 0,
        htmlFor: "".concat(id, "-input"),
        children: label
      }), /*#__PURE__*/jsx$1(ClearTermButton, {
        "aria-label": "clear field",
        disabled: value.length === 0,
        hide: value.length === 0,
        onClick: handleClearTerm,
        onKeyPress: handleClearTerm,
        type: "button",
        children: /*#__PURE__*/jsx$1(Icon$2, {
          color: "black",
          height: "2.2rem",
          name: "close",
          title: "clear field",
          titleId: "".concat(id, "-clearFieldIcon"),
          width: "2.2rem"
        })
      })]
    }), /*#__PURE__*/jsx$1(Button$1, {
      ariaLabel: submitAriaLabel,
      color: color,
      disabled: isDisabled,
      id: "".concat(id, "-button"),
      onClick: handleSubmitClick,
      type: "button",
      children: small ? /*#__PURE__*/jsx$1(Icon$2, {
        "data-testid": "submit-icon",
        name: "submit-icon",
        title: "Submit email",
        titleId: "submitEmailIcon"
      }) : submitText
    })]
  }));
}

SubmitField.defaultProps = defaultProps$w;
SubmitField.propTypes = propTypes$15;
var defaultProps$v = {
  loading: false
};
var propTypes$14 = {
  loading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired
};

function PromoField(_ref) {
  var onSubmit = _ref.onSubmit,
      loading = _ref.loading;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      fieldIsVisible = _useState2[0],
      setFieldIsVisible = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray$4(_useState3, 2),
      promoCode = _useState4[0],
      setPromoCode = _useState4[1];

  var handlePromoChange = function handlePromoChange(newPromoCode) {
    setPromoCode(newPromoCode.target.value);
  };

  var handleSubmit = function handleSubmit() {
    onSubmit(promoCode);
    setPromoCode('');
    setFieldIsVisible(false);
  };

  return fieldIsVisible ? /*#__PURE__*/jsx$1(SubmitField, {
    autofocus: true,
    color: isInternic ? 'blueDark' : 'deepKoamaru',
    labelColor: "black",
    disabled: promoCode.length === 0 || loading,
    id: "promo-field",
    label: "have a promo code?",
    onChange: handlePromoChange,
    onClearValue: function onClearValue() {
      return handlePromoChange('');
    },
    onSubmit: handleSubmit,
    placeholder: "Have a promo code?",
    submitText: "Apply",
    value: promoCode,
    width: "100%",
    borderColor: "black"
  }) : /*#__PURE__*/jsx$1(Button$1, {
    color: "deepKoamaru",
    id: "checkout-promo",
    minimal: true,
    onClick: function onClick() {
      setFieldIsVisible(true);
    },
    small: true,
    variant: "link",
    white: true,
    children: /*#__PURE__*/jsx$1(Text$1, {
      children: "have a promo code?"
    })
  });
}

PromoField.defaultProps = defaultProps$v;
PromoField.propTypes = propTypes$14;
var defaultProps$u = {
  loading: false,
  order: {
    items: []
  }
};
var propTypes$13 = {
  currency: PropTypes.shape({
    code: PropTypes.string,
    country: PropTypes.string,
    symbol: PropTypes.string
  }).isRequired,
  loading: PropTypes.bool,
  count: PropTypes.number,
  order: PropTypes.shape({
    id: PropTypes.any,
    items: PropTypes.arrayOf(PropTypes.shape({
      display: PropTypes.shape({
        name: PropTypes.string.isRequired
      }),
      price: PropTypes.shape({
        regular: PropTypes.number.isRequired,
        renew: PropTypes.number,
        sale: PropTypes.number
      }),
      productType: PropTypes.string.isRequired,
      term: PropTypes.shape({
        count: PropTypes.string,
        period: PropTypes.oneOf(['month', 'year'])
      })
    })),
    promocodes: PropTypes.array
  })
};

function OrderSummaryDetails(_ref) {
  var loading = _ref.loading,
      order = _ref.order,
      orderId = _ref.orderId,
      currency = _ref.currency,
      count = _ref.count;

  var _useOrderService = useOrderService(),
      updatePrice = _useOrderService.updatePrice;

  _useOrderService.setUpdatePrice;
  var isReady = _useOrderService.isReady;
  _useOrderService.submitSupportRequests;
  var isLoading = !isReady || loading || updatePrice.requiresFullUpdate;

  var _useState = useState(),
      _useState2 = _slicedToArray$4(_useState, 2),
      promoError = _useState2[0],
      setPromoError = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$4(_useState3, 2),
      ignoredPromo = _useState4[0],
      setIgnoredPromo = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray$4(_useState5, 2),
      promocodes = _useState6[0],
      setPromocodes = _useState6[1];

  var _useOrderQuery = useOrderQuery(),
      useAddPromo = _useOrderQuery.useAddPromo,
      useRemovePromo = _useOrderQuery.useRemovePromo;

  var _useRemovePromo = useRemovePromo(),
      _useRemovePromo2 = _slicedToArray$4(_useRemovePromo, 1),
      removePromocode = _useRemovePromo2[0];

  var _useAddPromo = useAddPromo({
    onError: function onError() {
      setPromoError(true);
      setIgnoredPromo(false);
    }
  }),
      _useAddPromo2 = _slicedToArray$4(_useAddPromo, 2),
      addPromoCode = _useAddPromo2[0],
      addPromoLoading = _useAddPromo2[1].loading;

  var showPromoSection = order.promocodes && order.promocodes.length > 0;

  var getUniquePromos = function getUniquePromos() {
    if (!order || !showPromoSection) {
      return null;
    }

    var itemsWithPromos = order === null || order === void 0 ? void 0 : order.items.filter(function (item) {
      var _item$prices;

      return (item === null || item === void 0 ? void 0 : (_item$prices = item.prices) === null || _item$prices === void 0 ? void 0 : _item$prices.promo) != null;
    }).map(function (item) {
      return item.prices.promo;
    });
    return _toConsumableArray$1(new Map(itemsWithPromos.map(function (item) {
      return [item.promocode, item];
    })).values());
  };

  var promos = getUniquePromos();
  useEffect(function () {
    if (addPromoLoading) {
      setPromoError(false);
      setIgnoredPromo(false);
    } else if (isEqual$2(promocodes, order.promocodes) && promocodes.length === order.promocodes.length && !promoError) {
      // promo fetch complete, promo ignored
      setIgnoredPromo(true);
    }

    setPromocodes(order.promocodes);
  }, [addPromoLoading]);
  var totalSaved = 0;

  if (order && order.items && count > 0) {
    return /*#__PURE__*/jsxs(Stack$2, {
      width: "100%",
      px: 1,
      children: [/*#__PURE__*/jsx$1(OrderSummaryHeader, {
        count: count,
        isLoading: isLoading,
        order: order,
        orderId: orderId,
        currency: currency
      }), /*#__PURE__*/jsx$1(OrderSummaryBox, {
        orderId: orderId,
        currency: currency,
        order: order
      }), /*#__PURE__*/jsxs(Stack$2, {
        alignItems: "center",
        width: "100%",
        children: [showPromoSection && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx$1(Box$1, {
            height: "1px",
            border: "1px solid LightGray",
            mt: 1,
            mb: 3,
            width: "100%"
          }), /*#__PURE__*/jsxs(Box$1, {
            width: "100%",
            justifyContent: "space-between",
            children: [/*#__PURE__*/jsx$1(Box$1, {
              children: /*#__PURE__*/jsx$1(Text$1, {
                variant: "megaBold",
                children: strings$3.promo_section_label
              })
            }), /*#__PURE__*/jsx$1(Box$1, {
              children: promos.map(function (promo, index) {
                totalSaved = promo && promo.price ? totalSaved + promo.price : totalSaved;
                return /*#__PURE__*/jsx$1(Box$1, {
                  children: /*#__PURE__*/jsx$1(Button$1, {
                    borderRadius: border.radius,
                    color: "sunflowerBlack",
                    "font-size": "1rem",
                    margin: "0 ".concat(gutter$5.quarter, " 0 ").concat(gutter$5.quarter),
                    onClick: function onClick() {
                      return removePromocode({
                        variables: {
                          id: order.id,
                          promoCode: promo.promocode,
                          currency: currency.code.toUpperCase()
                        }
                      });
                    },
                    padding: "0 ".concat(gutter$5.half, " 0 ").concat(gutter$5.half),
                    children: "".concat(promo === null || promo === void 0 ? void 0 : promo.promoname, " X")
                  }, promo && promo.promocode ? promo.promocode : index)
                }, promo && promo.promocode ? promo.promocode : index);
              })
            })]
          })]
        }), /*#__PURE__*/jsx$1(OrderTotal, {
          order: order,
          currency: currency,
          promos: promos
        })]
      }), /*#__PURE__*/jsxs(Box$1, {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        mb: "3",
        mt: "4",
        children: [promoError && /*#__PURE__*/jsx$1(Message, {
          dismissCallback: function dismissCallback() {
            return setPromoError(false);
          },
          p: 3,
          type: "error",
          width: "100%",
          children: strings$3.invalidPromo
        }), ignoredPromo && /*#__PURE__*/jsx$1(Message, {
          dismissCallback: function dismissCallback() {
            return setIgnoredPromo(false);
          },
          p: 3,
          type: "success",
          width: "100%",
          children: strings$3.ignoredPromo
        }), /*#__PURE__*/jsx$1(PromoField, {
          loading: loading,
          onSubmit: function onSubmit(promoCode) {
            addPromoCode({
              variables: {
                id: order.id,
                promoCode: promoCode,
                currency: currency.code.toUpperCase(),
                tracking: {
                  promoCode: promoCode
                }
              }
            });
          }
        })]
      })]
    });
  }

  return null;
}

OrderSummaryDetails.defaultProps = defaultProps$u;
OrderSummaryDetails.propTypes = propTypes$13;
getCurrencyByCode(LS.getItem(storageKeys.Currency));

var getOrderCount = function getOrderCount(items) {
  if (isEmpty$2(items)) {
    return 0;
  }

  return items.filter(function (item) {
    return item.productType !== ProductTypes.icannFee && item.productType !== ProductTypes.accountCredit && item.productType !== ProductTypes.outstandingBalance && item.productType !== ProductTypes.GoogleWorkspace;
  }).reduce(function (acc, item) {
    acc += 1;

    if (!isEmpty$2(item.addons)) {
      return item.addons.reduce(function (total, addon) {
        if (addon.productType === ProductTypes.icannFee) {
          return total;
        }

        total += 1;
        return total;
      }, acc);
    }

    return acc;
  }, 0);
};

function OrderSummary(_ref) {
  var orderId = _ref.orderId,
      currency = _ref.currency;

  var _useOrderQuery = useOrderQuery(),
      loading = _useOrderQuery.loading,
      order = _useOrderQuery.order;

  _useOrderQuery.error;
  var refetch = _useOrderQuery.refetch;

  var _useOrderService = useOrderService(),
      updatePrice = _useOrderService.updatePrice;

  _useOrderService.setUpdatePrice;
  var isReady = _useOrderService.isReady;
  _useOrderService.submitSupportRequests;

  var _useUserService = useUserService(),
      user = _useUserService.user;

  useEffect(function () {
    refetch();
  }, [user]);
  var isLoading = !isReady || loading || updatePrice.requiresFullUpdate;
  var outstandingBalance = order && order.items.find(function (item) {
    return item.productType === ProductTypes.outstandingBalance;
  });

  if (order && order.items && getOrderCount(order.items) > 0 && !isLoading) {
    return /*#__PURE__*/jsx$1(OrderSummaryDetails, {
      count: getOrderCount(order.items),
      currency: currency,
      isLoading: isLoading,
      order: order,
      orderId: orderId
    });
  }

  return /*#__PURE__*/jsx$1(Box$1, {
    justifyContent: "center",
    width: "100%",
    children: /*#__PURE__*/jsx$1(EmptyOrder, {
      loading: isLoading,
      outstandingBalance: outstandingBalance
    })
  });
}

function _regenerator$S() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$S(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$S(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$S(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$S(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$S(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$S(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$S(u), _regeneratorDefine2$S(u, o, "Generator"), _regeneratorDefine2$S(u, n, function () {
    return this;
  }), _regeneratorDefine2$S(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$S = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$S(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$S = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$S(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$S(e, r, n, t);
}

function Order() {
  var currency = getCurrencyByCode(LS.getItem(storageKeys.Currency));

  var _useOrderService = useOrderService(),
      orderId = _useOrderService.orderId,
      setCookie = _useOrderService.setCookie,
      setIsReady = _useOrderService.setIsReady,
      isReady = _useOrderService.isReady;

  _useOrderService.loggedOut;
  _useOrderService.setLoggedOut;
  _useOrderService.setUpdatePrice;

  var _useSessionService = useSessionService(),
      currentCode = _useSessionService.data.currentCurrency.code;

  var createMissingOrder = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$S().m(function _callee() {
      var _yield$createOrder, id;

      return _regenerator$S().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              _context.n = 1;
              return createOrder();

            case 1:
              _yield$createOrder = _context.v;
              id = _yield$createOrder.data.id;
              setCookie('orderId', id, {
                path: '/'
              });

            case 2:
              return _context.a(2);
          }
        }
      }, _callee);
    }));

    return function createMissingOrder() {
      return _ref.apply(this, arguments);
    };
  }();

  var overwriteOrder = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$S().m(function _callee2() {
      var _t;

      return _regenerator$S().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return overwriteOrderFromSession(orderId, currentCode.toUpperCase());

            case 1:
              setIsReady(true);
              _context2.n = 3;
              break;

            case 2:
              _context2.p = 2;
              _t = _context2.v;
              console.error('error overwriting order', _t);

            case 3:
              return _context2.a(2);
          }
        }
      }, _callee2, null, [[0, 2]]);
    }));

    return function overwriteOrder() {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    var supportedProducts = ['Registration', 'ICANNFee', 'Privacy', 'PromoDiscount', 'Security', 'OwnershipLock', 'ExpiryInsurance', 'AppliedAccountCredit', 'OutstandingBalancePayment', 'TransferII', 'Renew', 'Difm', 'MarketgooSubscription', 'Sitelock', 'VpsPackage', 'PleskPackage', 'PWPackage', 'PremiumDomain', 'GoogleWorkspace', 'GoogleWorkspaceUser', 'RegistrationFee', 'Backorder', 'AccountManagementSubscription', 'OpenExchangeEmail', 'OpenExchangeUser'];

    if (!window.configs) {
      window.configs = {
        supportedProducts: supportedProducts
      };
    } else if (!window.configs.supportedProducts) {
      window.configs.supportedProducts = supportedProducts;
    }
  });
  useEffect(function () {
    if (!orderId) {
      createMissingOrder();
    }
  }, [orderId]);
  useEffect(function () {
    if (orderId) {
      overwriteOrder();
    }
  }, [orderId]);

  if (!isReady) {
    return null;
  }

  return /*#__PURE__*/jsxs(OrderQueryProvider, {
    orderId: orderId,
    children: [/*#__PURE__*/jsx$1(OrderSummary, {
      orderId: orderId,
      currency: currency
    }), /*#__PURE__*/jsx$1(HelpSection, {})]
  });
}

function _regenerator$R() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$R(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$R(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$R(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$R(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$R(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$R(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$R(u), _regeneratorDefine2$R(u, o, "Generator"), _regeneratorDefine2$R(u, n, function () {
    return this;
  }), _regeneratorDefine2$R(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$R = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$R(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$R = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$R(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$R(e, r, n, t);
}

var propTypes$12 = {
  button: PropTypes.shape({
    text: PropTypes.string.isRequired
  }).isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({
    cta: PropTypes.shape({
      href: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    }),
    description: PropTypes.string.isRequired,
    icon: PropTypes.shape({
      alt: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired
    }),
    name: PropTypes.string.isRequired,
    price: PropTypes.shape({
      firstTerm: PropTypes.shape({
        color: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired
      }),
      itemCode: PropTypes.string,
      prefix: PropTypes.string,
      suffix: PropTypes.string
    }).isRequired,
    recommended: PropTypes.bool
  })).isRequired,
  title: PropTypes.string.isRequired
};

function RecommendationModal(_ref) {
  var title = _ref.title,
      products = _ref.products,
      button = _ref.button;

  var _useModal = useModal(),
      openModal = _useModal.openModal,
      closeModal = _useModal.closeModal,
      isOpen = _useModal.isOpen,
      Modal = _useModal.Modal;

  var _useSessionService = useSessionService(),
      currency = _useSessionService.data.currentCurrency.code;

  var _useState = useState(null),
      _useState2 = _slicedToArray$4(_useState, 2),
      allPrices = _useState2[0],
      setAllPrices = _useState2[1];

  var handleRedirect = function handleRedirect(path) {
    window.location.href = path;
  };

  var getPrices = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$R().m(function _callee(itemcodes) {
      var url, prices;
      return _regenerator$R().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              url = getDynamicPriceEndpoint(itemcodes);
              _context.n = 1;
              return axios.get(url);

            case 1:
              prices = _context.v;
              return _context.a(2, prices.data);
          }
        }
      }, _callee);
    }));

    return function getPrices(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var renderPrice = function renderPrice(price) {
    if (!price) {
      return null;
    }

    if (price.itemCode) {
      var item = allPrices === null || allPrices === void 0 ? void 0 : allPrices.find(function (dp) {
        return dp.itemCode === price.itemCode;
      });

      if (!item) {
        return null;
      }

      return item.prices[currency.toUpperCase()].regular.toFixed(2);
    }

    return null;
  };

  useEffect(function () {
    var requiredProducts = [];
    products.forEach(function (product) {
      requiredProducts.push(product.price.itemCode);
    });

    function fetchPrices() {
      return _fetchPrices.apply(this, arguments);
    }

    function _fetchPrices() {
      _fetchPrices = _asyncToGenerator( /*#__PURE__*/_regenerator$R().m(function _callee2() {
        var prices;
        return _regenerator$R().w(function (_context2) {
          while (1) {
            switch (_context2.n) {
              case 0:
                _context2.n = 1;
                return getPrices(requiredProducts);

              case 1:
                prices = _context2.v;
                setAllPrices(prices);

              case 2:
                return _context2.a(2);
            }
          }
        }, _callee2);
      }));
      return _fetchPrices.apply(this, arguments);
    }

    fetchPrices();
  }, []);
  var count = products.length;
  var mobileGrid = '1fr';
  var smallGrid = count % 2 === 0 ? 'repeat(2, 1fr)' : '1fr';
  var largeGrid = "repeat(".concat(3, ", 1fr)");
  return /*#__PURE__*/jsxs("div", {
    children: [/*#__PURE__*/jsx$1(Button$1, {
      onClick: openModal,
      style: button,
      children: button.text
    }), /*#__PURE__*/jsx$1(Modal, {
      closeBtnCb: closeModal,
      id: "recommendation-modal",
      isOpen: isOpen,
      onBgClick: closeModal,
      onEscapeKey: closeModal,
      width: "auto",
      children: /*#__PURE__*/jsxs(Stack$2, {
        height: "49rem",
        children: [/*#__PURE__*/jsx$1(Box$1, {
          justifyContent: "center",
          children: /*#__PURE__*/jsx$1(Text$1, {
            mb: 3,
            textAlign: "center",
            variant: "petaBold",
            width: "auto",
            children: title
          })
        }), /*#__PURE__*/jsx$1(Grid$1, {
          alignSelf: "stretch",
          gridGap: 1,
          gridTemplateColumns: [mobileGrid, smallGrid, smallGrid, largeGrid],
          justifyContent: "center",
          maxWidth: "120rem",
          pb: [6, 4],
          children: products.map(function (product, index) {
            return /*#__PURE__*/jsxs(Stack$2, {
              mx: 1,
              children: [/*#__PURE__*/jsx$1(Box$1, {
                height: "3.5rem",
                children: product.recommended && /*#__PURE__*/jsx$1(Badge, {
                  bg: "blue",
                  fontWeight: "bold",
                  position: "absolute",
                  width: 1,
                  children: /*#__PURE__*/jsx$1(Text$1, {
                    fontFamily: "body",
                    fontSize: 1,
                    letterSpacing: 2,
                    py: 2,
                    children: "RECOMMENDED"
                  })
                })
              }), /*#__PURE__*/jsx$1(Box$1, {
                alignItems: "center",
                border: 2,
                padding: 4,
                children: /*#__PURE__*/jsxs(Stack$2, {
                  alignItems: "flex-start",
                  width: 1,
                  children: [/*#__PURE__*/jsx$1(Box$1, {
                    alignItems: "flex-start",
                    height: "4rem",
                    children: product.icon ? /*#__PURE__*/jsx$1("img", {
                      alt: product.icon.alt,
                      src: product.icon.path,
                      width: "150px"
                    }) : null
                  }), /*#__PURE__*/jsx$1(Text$1, {
                    fontFamily: "title",
                    fontSize: 3,
                    fontWeight: "bold",
                    py: 2,
                    children: product.name
                  }), /*#__PURE__*/jsx$1(Box$1, {
                    alignItems: "flex-start",
                    height: "5rem",
                    children: /*#__PURE__*/jsx$1(Text$1, {
                      fontFamily: "body",
                      fontSize: 1,
                      fontWeight: "light",
                      mb: 4,
                      textAlign: "left",
                      children: product.description
                    })
                  }), /*#__PURE__*/jsx$1(Box$1, {
                    height: "5rem",
                    children: product.price.firstTerm && /*#__PURE__*/jsx$1(Text$1, {
                      bg: "#E6E4F4",
                      fontSize: 2,
                      fontWeight: "bold",
                      mb: 3,
                      px: 3,
                      py: 1,
                      children: product.price.firstTerm.text
                    })
                  }), /*#__PURE__*/jsx$1(Text$1, {
                    fontFamily: "body",
                    fontSize: 1,
                    fontWeight: "light",
                    children: product.price.prefix
                  }), product.price ? /*#__PURE__*/jsxs(Box$1, {
                    flexDirection: "row",
                    children: [/*#__PURE__*/jsxs(Text$1, {
                      fontFamily: "body",
                      fontSize: 5,
                      fontWeight: "semi",
                      mr: 1,
                      children: ["$", renderPrice(product.price)]
                    }), /*#__PURE__*/jsx$1(Text$1, {
                      fontFamily: "body",
                      fontSize: 1,
                      fontWeight: "light",
                      mt: 3,
                      children: product.price.suffix
                    })]
                  }) : null, /*#__PURE__*/jsx$1(Button$1, {
                    alignSelf: "center",
                    ariaLabel: product.ctaTitle,
                    color: "blueDark",
                    onClick: function onClick() {
                      return handleRedirect(product.cta.href);
                    },
                    variant: "solid",
                    width: "100%",
                    children: product.cta.title
                  })]
                })
              })]
            }, index);
          })
        })]
      })
    })]
  });
}

RecommendationModal.propTypes = propTypes$12;
var propTypes$11 = {
  answerActionList: PropTypes$1.arrayOf(PropTypes$1.shape({
    actionLink: PropTypes$1.shape({
      ariaLabel: PropTypes$1.string,
      as: PropTypes$1.string,
      className: PropTypes$1.string,
      color: PropTypes$1.string,
      display: PropTypes$1.string,
      href: PropTypes$1.string,
      id: PropTypes$1.string,
      newTab: PropTypes$1.bool,
      onClick: PropTypes$1.func,
      testId: PropTypes$1.string,
      text: PropTypes$1.string,
      to: PropTypes$1.string,
      variant: PropTypes$1.string
    }),
    actionText: PropTypes$1.string,
    icon: PropTypes$1.shape({
      ariaHidden: PropTypes$1.bool,
      classes: PropTypes$1.string,
      className: PropTypes$1.string,
      color: PropTypes$1.string,
      iconName: PropTypes$1.string.isRequired,
      style: PropTypes$1.shape({}),
      title: PropTypes$1.string
    })
  })).isRequired,
  domainRenwalsLoading: PropTypes$1.bool.isRequired
};

function AnswerActions(_ref) {
  var answerActionList = _ref.answerActionList,
      domainRenwalsLoading = _ref.domainRenwalsLoading;
  var skeletonWhileLoading = /*#__PURE__*/jsx$1(Box$1, {
    children: /*#__PURE__*/jsx$1(Skeleton$1, {
      height: "4rem",
      mb: 2,
      width: "100%"
    })
  });

  var mapAnswerActions = function mapAnswerActions() {
    return answerActionList.map(function (value, index) {
      var leftMargin = 0;
      var iconPresent = false;

      if (!value.icon) {
        iconPresent = false;
      } else {
        iconPresent = true;
      }

      if (iconPresent) {
        leftMargin = 2;
      }

      if (!iconPresent) {
        leftMargin = 4;
      }

      return /*#__PURE__*/jsxs(Box$1, {
        mb: 1,
        ml: leftMargin,
        children: [iconPresent ? /*#__PURE__*/jsx$1(Icon$2, {
          color: value.icon.color,
          height: "2rem",
          ml: 4,
          mr: 2,
          name: value.icon.iconName,
          title: value.icon.title,
          titleId: value.icon.title,
          width: "2rem"
        }) : "", !value.actionText ? "" : /*#__PURE__*/jsx$1(Text$1, {
          fontSize: "1.3rem",
          children: /*#__PURE__*/jsx$1(HtmlBlock, {
            children: value.actionText
          })
        }), !value.actionLink ? "" : /*#__PURE__*/jsx$1(Link$1, {
          ariaLabel: value.actionLink.ariaLabel,
          color: value.actionLink.color,
          display: value.actionLink.display,
          fontSize: "1.3rem",
          href: value.actionLink.href,
          id: value.actionLink.id,
          ml: 2,
          newTab: value.actionLink.newTab,
          onClick: value.actionLink.onClick || null,
          style: {
            textDecoration: 'underline'
          },
          children: value.actionLink.text
        })]
      }, index);
    });
  };

  return /*#__PURE__*/jsxs(Stack$2, {
    mb: 2,
    children: [domainRenwalsLoading && skeletonWhileLoading, !domainRenwalsLoading && mapAnswerActions()]
  });
}

AnswerActions.propTypes = propTypes$11;
var propTypes$10 = {
  answerActionList: PropTypes$1.arrayOf(PropTypes$1.shape({
    actionLink: PropTypes$1.shape({
      ariaLabel: PropTypes$1.string,
      as: PropTypes$1.string,
      className: PropTypes$1.string,
      color: PropTypes$1.string,
      display: PropTypes$1.string,
      href: PropTypes$1.string,
      id: PropTypes$1.string,
      newTab: PropTypes$1.bool,
      onClick: PropTypes$1.func,
      testId: PropTypes$1.string,
      text: PropTypes$1.string,
      to: PropTypes$1.string,
      variant: PropTypes$1.string
    }),
    actionText: PropTypes$1.string,
    icon: PropTypes$1.shape({
      ariaHidden: PropTypes$1.bool,
      classes: PropTypes$1.string,
      className: PropTypes$1.string,
      color: PropTypes$1.string,
      iconName: PropTypes$1.string.isRequired,
      style: PropTypes$1.shape({}),
      title: PropTypes$1.string
    })
  })),
  answerText: PropTypes$1.string.isRequired,
  domainRenwalsLoading: PropTypes$1.bool.isRequired,
  radioSelect: PropTypes$1.string.isRequired,
  setRadioSelect: PropTypes$1.func.isRequired
};
var defaultProps$t = {
  answerActionList: undefined
};

function SurveyAnswer(_ref) {
  var answerActionList = _ref.answerActionList,
      answerText = _ref.answerText,
      domainRenwalsLoading = _ref.domainRenwalsLoading,
      radioSelect = _ref.radioSelect,
      setRadioSelect = _ref.setRadioSelect;

  var onChangeHandler = function onChangeHandler() {
    setRadioSelect(answerText);
  };

  return /*#__PURE__*/jsxs(Stack$2, {
    mb: 2,
    children: [/*#__PURE__*/jsx$1(Radio, {
      id: answerText,
      isChecked: radioSelect === answerText,
      name: "answerRadioList",
      onChange: onChangeHandler,
      text: /*#__PURE__*/jsx$1(Text$1, {
        ml: 2,
        variant: "gigaBold",
        children: answerText
      }),
      value: answerText
    }), radioSelect === answerText && answerActionList !== undefined && /*#__PURE__*/jsx$1(AnswerActions, {
      answerActionList: answerActionList,
      domainRenwalsLoading: domainRenwalsLoading
    })]
  });
}

SurveyAnswer.defaultProps = defaultProps$t;
SurveyAnswer.propTypes = propTypes$10;
var propTypes$$ = {
  answerObjectList: PropTypes$1.arrayOf(PropTypes$1.shape({
    answerActionList: PropTypes$1.arrayOf(PropTypes$1.shape({
      actionLink: PropTypes$1.shape({
        ariaLabel: PropTypes$1.string,
        as: PropTypes$1.string,
        className: PropTypes$1.string,
        color: PropTypes$1.string,
        display: PropTypes$1.string,
        href: PropTypes$1.string,
        id: PropTypes$1.string,
        newTab: PropTypes$1.bool,
        onClick: PropTypes$1.func,
        testId: PropTypes$1.string,
        text: PropTypes$1.string,
        to: PropTypes$1.string,
        variant: PropTypes$1.string
      }),
      actionText: PropTypes$1.string,
      icon: PropTypes$1.shape({
        ariaHidden: PropTypes$1.bool,
        classes: PropTypes$1.string,
        className: PropTypes$1.string,
        color: PropTypes$1.string,
        iconName: PropTypes$1.string.isRequired,
        style: PropTypes$1.shape({}),
        title: PropTypes$1.string
      })
    })),
    answerText: PropTypes$1.string.isRequired
  })).isRequired,
  domainRenwalsLoading: PropTypes$1.bool.isRequired,
  questionText: PropTypes$1.string.isRequired,
  radioSelect: PropTypes$1.string.isRequired,
  setRadioSelect: PropTypes$1.func.isRequired,
  showRequired: PropTypes$1.bool.isRequired
};

function SurveyQuestions(_ref) {
  var answerObjectList = _ref.answerObjectList,
      domainRenwalsLoading = _ref.domainRenwalsLoading,
      questionText = _ref.questionText,
      radioSelect = _ref.radioSelect,
      setRadioSelect = _ref.setRadioSelect,
      showRequired = _ref.showRequired;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(Text$1, {
      fontSize: "1.5rem",
      mb: 3,
      children: [showRequired ? /*#__PURE__*/jsx$1("span", {
        fontSize: "1.5rem",
        mb: 3,
        style: {
          color: 'red'
        },
        children: "*\xA0"
      }) : "", questionText]
    }), /*#__PURE__*/jsx$1(Stack$2, {
      as: "fieldset",
      id: "answerRadioList",
      mb: 2,
      children: answerObjectList.map(function (value, index) {
        return /*#__PURE__*/jsx$1(SurveyAnswer, {
          answerActionList: value.answerActionList,
          answerText: value.answerText,
          domainRenwalsLoading: domainRenwalsLoading,
          radioSelect: radioSelect,
          setRadioSelect: setRadioSelect
        }, index);
      })
    })]
  });
}

SurveyQuestions.propTypes = propTypes$$;
var errorColour = 'errorLight';

function CancellationRetentionGenericError() {
  return /*#__PURE__*/jsx$1(Stack$2, {
    children: /*#__PURE__*/jsx$1(Box$1, {
      alignItems: "center",
      bg: errorColour,
      flexDirection: "column",
      justifyContent: "center",
      mt: 3,
      pb: 3,
      pl: 3,
      pt: 3,
      width: "100%",
      children: /*#__PURE__*/jsx$1(Text$1, {
        children: "An error occurred processing your request. Please try your request again. If this error persists, please contact support."
      })
    })
  });
}

var propTypes$_ = {
  failedRenewals: PropTypes$1.arrayOf(PropTypes$1.shape({
    failedRenewal: PropTypes$1.shape({
      actionedTime: PropTypes$1.string,
      domainName: PropTypes$1.string,
      id: PropTypes$1.string,
      message: PropTypes$1.string,
      newExpiryDate: PropTypes$1.string
    })
  })),
  goodRenewals: PropTypes$1.arrayOf(PropTypes$1.shape({
    goodRenewal: PropTypes$1.shape({
      actionedTime: PropTypes$1.string,
      domainName: PropTypes$1.string,
      id: PropTypes$1.string,
      message: PropTypes$1.string,
      newExpiryDate: PropTypes$1.string
    })
  }))
};
var defaultPropTypes = {
  failedRenewals: null,
  goodRenewals: null
};

function CancellationRetentionRenewSuccess(_ref) {
  var failedRenewals = _ref.failedRenewals,
      goodRenewals = _ref.goodRenewals;

  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      cartIsLoading = _React$useState2[0],
      setCartIsLoading = _React$useState2[1];

  var renderGoodRenewalRow = function renderGoodRenewalRow(renewal) {
    return [/*#__PURE__*/jsx$1(Box$1, {
      alignItems: "center",
      bg: "white",
      borderBottom: "light",
      borderLeft: "light",
      borderRight: "light",
      justifyContent: "left",
      pl: 2,
      width: "auto",
      children: renewal.domainName
    }, "goodRenewal-".concat(renewal.domainName))];
  };

  var renderBadRenewalRow = function renderBadRenewalRow(renewal) {
    return [/*#__PURE__*/jsx$1(Box$1, {
      alignItems: "center",
      bg: "white",
      borderBottom: "light",
      borderLeft: "light",
      borderRight: "light",
      justifyContent: "left",
      pl: 2,
      width: "auto",
      children: renewal.domainName
    }, "badRenewal-".concat(renewal.domainName)), /*#__PURE__*/jsx$1(Box$1, {
      alignItems: "left",
      bg: "white",
      borderBottom: "light",
      borderRight: "light",
      justifyContent: "left",
      minHeight: "4rem",
      pb: 2,
      pl: 2,
      pt: 2,
      width: "auto",
      children: renewal.message
    }, "badRenewalReason-".concat(renewal.domainName))];
  };

  var handleNextButtonClick = function handleNextButtonClick() {
    var linkId = 'Go To Shopping Cart';
    tracker$1('LinkClicked', {
      type: 'Domain / Cancel Retention / Link',
      linkId: linkId,
      goodRenewals: goodRenewals
    });
    setCartIsLoading(true);
    window.location = createEndpoint('/MyAccount/ShoppingCart.aspx');
  };

  var buttonMarginTop = '2';
  var buttonColour = 'deepKoamaru';
  var buttonTextElement = /*#__PURE__*/jsx$1(Text$1, {
    lineHeight: "1.7",
    children: "Load More"
  });
  var buttonWidth = '10rem';
  var goodRenewalContent = /*#__PURE__*/jsx$1(LoadMoreContainer, {
    buttonColour: buttonColour,
    buttonMarginTop: buttonMarginTop,
    buttonTextElement: buttonTextElement,
    buttonWidth: buttonWidth,
    list: goodRenewals,
    listGridColumn: ['1fr', '1fr'],
    listGridRow: "4rem",
    renderListItem: renderGoodRenewalRow,
    renderOffset: 5,
    useButtonVariant: false
  });
  var badRenewalContent = /*#__PURE__*/jsx$1(LoadMoreContainer, {
    buttonColour: buttonColour,
    buttonMarginTop: buttonMarginTop,
    buttonTextElement: buttonTextElement,
    buttonWidth: buttonWidth,
    list: failedRenewals,
    listGridColumn: ['1fr 1fr', '1fr 1fr'],
    renderListItem: renderBadRenewalRow,
    renderOffset: 5,
    useButtonVariant: false
  });
  return /*#__PURE__*/jsx$1(Fragment, {
    children: cartIsLoading ? /*#__PURE__*/jsxs(Stack$2, {
      mx: 4,
      my: 4,
      children: [/*#__PURE__*/jsx$1(Heading, {
        fontSize: "2.5rem",
        children: "Loading shopping cart..."
      }), /*#__PURE__*/jsx$1(Box$1, {
        children: /*#__PURE__*/jsx$1(Skeleton$1, {
          height: "16rem",
          mb: 2,
          width: "100%"
        })
      })]
    }) : /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsxs(Stack$2, {
        mx: 4,
        my: 4,
        children: [/*#__PURE__*/jsx$1(Heading, {
          fontSize: "2.5rem",
          children: " Domain Renewals "
        }), goodRenewals && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx$1(Box$1, {
            children: /*#__PURE__*/jsx$1(Text$1, {
              children: "The following domain renewals were successfully added to your cart:"
            })
          }), /*#__PURE__*/jsxs(Stack$2, {
            children: [/*#__PURE__*/jsx$1(Grid$1, {
              alignSelf: "center",
              bg: "white",
              border: "light",
              gridTemplateColumns: ['1fr', '1fr'],
              gridTemplateRows: "4rem",
              mt: 3,
              width: "100%",
              children: /*#__PURE__*/jsx$1(Box$1, {
                alignItems: "left",
                borderBottom: "light",
                justifyContent: "left",
                pl: 2,
                width: "100%",
                children: /*#__PURE__*/jsx$1(Heading, {
                  variant: ['megaBold', 'gigaBold'],
                  children: "Added To Cart"
                })
              })
            }), goodRenewals && goodRenewalContent]
          })]
        }), failedRenewals && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx$1(Box$1, {
            mt: 4,
            children: /*#__PURE__*/jsx$1(Text$1, {
              children: "The following domains could not be renewed:"
            })
          }), /*#__PURE__*/jsxs(Stack$2, {
            children: [/*#__PURE__*/jsxs(Grid$1, {
              alignSelf: "center",
              bg: "white",
              border: "light",
              gridTemplateColumns: ['1fr 1fr', '1fr 1fr'],
              gridTemplateRows: "4rem",
              mt: 3,
              width: "100%",
              children: [/*#__PURE__*/jsx$1(Box$1, {
                alignItems: "left",
                borderBottom: "light",
                justifyContent: "left",
                pl: 2,
                width: "100%",
                children: /*#__PURE__*/jsx$1(Heading, {
                  variant: ['megaBold', 'gigaBold'],
                  children: "Domain"
                })
              }), /*#__PURE__*/jsx$1(Box$1, {
                alignItems: "left",
                borderBottom: "light",
                justifyContent: "left",
                pl: 2,
                width: "100%",
                children: /*#__PURE__*/jsx$1(Heading, {
                  variant: ['megaBold', 'gigaBold'],
                  children: "Reason"
                })
              })]
            }), badRenewalContent]
          })]
        })]
      }), /*#__PURE__*/jsx$1(Box$1, {
        bg: "deepKoamaru",
        justifyContent: "flex-end",
        mt: 4,
        px: 4,
        py: 4,
        children: /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx$1(Button$1, {
            color: "white",
            ml: 4,
            onClick: handleNextButtonClick,
            style: {
              lineHeight: 1.7
            },
            variant: "solid",
            children: /*#__PURE__*/jsx$1(Text$1, {
              variant: "kiloBold",
              children: "Go To Shopping Cart"
            })
          }), ' ']
        })
      })]
    })
  });
}

CancellationRetentionRenewSuccess.propTypes = propTypes$_;
CancellationRetentionRenewSuccess.defaultProps = defaultPropTypes;

function _regenerator$Q() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$Q(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$Q(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$Q(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$Q(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$Q(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$Q(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$Q(u), _regeneratorDefine2$Q(u, o, "Generator"), _regeneratorDefine2$Q(u, n, function () {
    return this;
  }), _regeneratorDefine2$Q(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$Q = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$Q(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$Q = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$Q(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$Q(e, r, n, t);
}

var propTypes$Z = {
  domainIds: PropTypes$1.arrayOf(PropTypes$1.string).isRequired,
  setApiAllFail: PropTypes$1.func.isRequired,
  setDomainRenewalsLoading: PropTypes$1.func.isRequired,
  setFailedRenewals: PropTypes$1.func.isRequired,
  setGoodRenewals: PropTypes$1.func.isRequired,
  setPageNumber: PropTypes$1.func.isRequired
};
var NicSupportDomain = "https://support.internic.ca";
var RebelSupportDomain = "https://support.rebel.com";
var SupportDomain = isInternic ? NicSupportDomain : RebelSupportDomain;

var CancellationRetentionSurveyConfig = function CancellationRetentionSurveyConfig(_ref) {
  var domainIds = _ref.domainIds,
      setApiAllFail = _ref.setApiAllFail,
      setDomainRenewalsLoading = _ref.setDomainRenewalsLoading,
      setFailedRenewals = _ref.setFailedRenewals,
      setGoodRenewals = _ref.setGoodRenewals,
      setPageNumber = _ref.setPageNumber;

  var setRenewalResponse = function setRenewalResponse(badRenewals, goodRenewals) {
    if (goodRenewals) {
      setGoodRenewals(goodRenewals);
    }

    if (badRenewals) {
      setFailedRenewals(badRenewals);
    }
  };

  var handleLinkTracking = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$Q().m(function _callee(e) {
      var linkID;
      return _regenerator$Q().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              linkID = e.target.id;
              tracker$1('LinkClicked', {
                type: 'Domain / Cancel Retention / Link',
                linkID: linkID,
                domainIds: domainIds
              });

            case 1:
              return _context.a(2);
          }
        }
      }, _callee);
    }));

    return function handleLinkTracking(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var addDomainsWithDiscount = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator$Q().m(function _callee2(e) {
      var url, promoCode, requestObject, response;
      return _regenerator$Q().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              e.stopPropagation();
              e.preventDefault();
              handleLinkTracking(e);
              setDomainRenewalsLoading(true);
              url = createEndpoint('/api/domains/renewdomain');
              promoCode = 'renewret21';
              requestObject = {
                domainIds: domainIds,
                promoCode: promoCode
              };
              _context2.p = 1;
              _context2.n = 2;
              return post$1(url, requestObject);

            case 2:
              response = _context2.v;
              _context2.n = 4;
              break;

            case 3:
              _context2.p = 3;
              setApiAllFail(true);
              setDomainRenewalsLoading(false);

            case 4:
              setRenewalResponse(response.data.failedToRenew, response.data.sentForRenewal);
              setDomainRenewalsLoading(false);
              setPageNumber(3);

            case 5:
              return _context2.a(2);
          }
        }
      }, _callee2, null, [[1, 3]]);
    }));

    return function addDomainsWithDiscount(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var modalJSON = {
    cancelText: "Nevermind, I don't want to delete",
    commentBoxPlaceholderText: 'Any other comments',
    nextActionText: 'Next',
    openModalButtonText: 'open',
    showOpenModalButton: false,
    surveyQuestionHeaderText: "We're sorry you'd like to delete your domain.",
    surveyQuestions: [{
      questionText: 'Got a second to tell us why? Every bit of feedback helps!',
      answerObjectList: [{
        answerText: 'My domain renewal is too expensive',
        answerActionList: [{
          actionText: 'Renew your domain at 15% off.',
          actionLink: {
            ariaLabel: 'renewAtDiscount',
            as: '',
            className: '',
            color: 'deepKoamaru',
            display: 'flex',
            href: createEndpoint('/MyAccount/ShoppingCart.aspx'),
            id: 'lnk_renewAtDiscount',
            onClick: addDomainsWithDiscount,
            newTab: true,
            testId: '',
            text: 'Renew Now',
            to: '',
            variant: ''
          }
        }, {
          actionText: 'You may be eligible for bulk rates.',
          actionLink: {
            ariaLabel: 'renewAtDiscountBulk',
            as: '',
            className: '',
            color: 'deepKoamaru',
            display: 'flex',
            href: "".concat(SupportDomain, "/hc/en-us#contact"),
            id: 'lnk_renewAtDiscountBulk',
            onClick: handleLinkTracking,
            newTab: true,
            testId: '',
            text: 'Chat With Us',
            to: '',
            variant: ''
          }
        }]
      }, {
        answerText: 'I am not using my domain',
        answerActionList: [{
          icon: {
            className: 'forward',
            iconName: 'forward',
            title: 'forward'
          },
          actionText: 'Easily forward your domain for free.',
          actionLink: {
            ariaLabel: 'forwardDomainFree',
            as: '',
            className: '',
            color: 'deepKoamaru',
            display: 'flex',
            href: createSupportArticleEndpoint('229862968-How-do-I-forward-my-domain-to-a-URL-', '227972188-How-do-I-forward-my-domain-to-a-URL-`'),
            id: 'lnk_forwardDomainFree',
            onClick: handleLinkTracking,
            newTab: true,
            testId: '',
            text: 'Learn More',
            to: '',
            variant: ''
          }
        }, {
          icon: {
            className: 'custom-email',
            iconName: 'custom-email',
            title: 'custom-email'
          },
          actionText: 'Add a custom email that matches your domain.',
          actionLink: {
            ariaLabel: 'customEmail',
            as: '',
            className: '',
            color: 'deepKoamaru',
            display: 'flex',
            href: createEndpoint('/email/email-overview'),
            id: 'lnk_customEmail',
            onClick: handleLinkTracking,
            newTab: true,
            testId: '',
            text: 'Learn More',
            to: '',
            variant: ''
          }
        }]
      }, {
        answerText: 'Other - Please let us know below.'
      }]
    }]
  };
  return modalJSON;
};

CancellationRetentionSurveyConfig.propTypes = propTypes$Z;

function _regenerator$P() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$P(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$P(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$P(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$P(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$P(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$P(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$P(u), _regeneratorDefine2$P(u, o, "Generator"), _regeneratorDefine2$P(u, n, function () {
    return this;
  }), _regeneratorDefine2$P(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$P = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$P(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$P = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$P(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$P(e, r, n, t);
}

function ownKeys$_(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$_(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$_(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$_(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var propTypes$Y = {
  apiAllFail: PropTypes$1.bool.isRequired,
  cancelText: PropTypes$1.string.isRequired,
  closeModal: PropTypes$1.func.isRequired,
  domainIds: PropTypes$1.arrayOf(PropTypes$1.string).isRequired,
  domainNames: PropTypes$1.arrayOf(PropTypes$1.string).isRequired,
  setApiAllFail: PropTypes$1.func.isRequired,
  setPageNumber: PropTypes$1.func.isRequired,
  surveyAnswers: PropTypes$1.object.isRequired
};
var warningColour = 'alert';
var defaultCurrencyOptions = {
  significantDigits: 2,
  thousandsSeparator: ',',
  decimalSeparator: '.',
  symbol: '$'
}; // taken from https://stackoverflow.com/questions/55556221/how-do-you-format-a-number-to-currency-when-using-react-native-expo

var currencyFormatter = function currencyFormatter(value, options) {
  if (typeof value !== 'number') {
    value = 0.0;
  }

  options = _objectSpread$_(_objectSpread$_({}, defaultCurrencyOptions), options);
  value = value.toFixed(options.significantDigits);

  var _value$split = value.split('.'),
      _value$split2 = _slicedToArray$4(_value$split, 2),
      currency = _value$split2[0],
      decimal = _value$split2[1];

  return "".concat(options.symbol).concat(currency.replace(/\B(?=(\d{3})+(?!\d))/g, options.thousandsSeparator)).concat(options.decimalSeparator).concat(decimal);
};

function RetentionSurveyConfirmation(_ref) {
  var apiAllFail = _ref.apiAllFail,
      cancelText = _ref.cancelText,
      closeModal = _ref.closeModal,
      domainNames = _ref.domainNames,
      domainIds = _ref.domainIds,
      setApiAllFail = _ref.setApiAllFail,
      setPageNumber = _ref.setPageNumber,
      surveyAnswers = _ref.surveyAnswers;

  var _React$useState = React.useState([]),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      domains = _React$useState2[0],
      setDomains = _React$useState2[1];

  var _React$useState3 = React.useState(true),
      _React$useState4 = _slicedToArray$4(_React$useState3, 2),
      appraisalLoading = _React$useState4[0],
      setAppraisalLoading = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray$4(_React$useState5, 2),
      cancellingDomains = _React$useState6[0],
      setCancellingDomains = _React$useState6[1];

  var getCancelMessage = function getCancelMessage() {
    if (domainNames.length > 1) {
      return 'Cancelling domains...';
    }

    return 'Cancelling domain...';
  };

  var cancelDomains = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$P().m(function _callee() {
      var url;
      return _regenerator$P().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              setCancellingDomains(true);
              url = createEndpoint('/api/domains/canceldomain');
              _context.p = 1;
              _context.n = 2;
              return post$1(url, {
                domainIds: domainIds
              });

            case 2:
              _context.n = 4;
              break;

            case 3:
              _context.p = 3;
              setCancellingDomains(false);
              setApiAllFail(true);

            case 4:
              window.location = createEndpoint('/MyAccount/Portfolio.aspx');

            case 5:
              return _context.a(2);
          }
        }
      }, _callee, null, [[1, 3]]);
    }));

    return function cancelDomains() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleNextButtonClick = function handleNextButtonClick() {
    tracker$1('CustomerExit', {
      type: 'Domain / Cancel Retention',
      surveyAnswers: surveyAnswers,
      domainIds: domainIds
    });
    cancelDomains(domainIds, setApiAllFail, setPageNumber);
  };

  var handleLinkTracking = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator$P().m(function _callee2(e) {
      var linkID;
      return _regenerator$P().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              linkID = e.target.id;
              tracker$1('LinkClicked', {
                type: 'Domain / Cancel Retention / Link',
                linkID: linkID,
                domainIds: domainIds
              });

            case 1:
              return _context2.a(2);
          }
        }
      }, _callee2);
    }));

    return function handleLinkTracking(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  React.useEffect(function () {
    var populateAppraisals = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regenerator$P().m(function _callee3() {
        var domainMap, i, _t2, _t3;

        return _regenerator$P().w(function (_context3) {
          while (1) {
            switch (_context3.n) {
              case 0:
                setAppraisalLoading(true);
                domainMap = [];
                i = 0;

              case 1:
                if (!(i < domainNames.length)) {
                  _context3.n = 4;
                  break;
                }

                _t2 = domainMap;
                _context3.n = 2;
                return getDomainAppraisal(domainNames[i]);

              case 2:
                _t3 = _context3.v;

                _t2.push.call(_t2, _t3);

              case 3:
                i += 1;
                _context3.n = 1;
                break;

              case 4:
                setDomains(domainMap);
                setAppraisalLoading(false);

              case 5:
                return _context3.a(2);
            }
          }
        }, _callee3);
      }));

      return function populateAppraisals() {
        return _ref4.apply(this, arguments);
      };
    }();

    populateAppraisals(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [domainNames]);

  function getDomainAppraisal(_x2) {
    return _getDomainAppraisal.apply(this, arguments);
  }

  function _getDomainAppraisal() {
    _getDomainAppraisal = _asyncToGenerator( /*#__PURE__*/_regenerator$P().m(function _callee4(domainName) {
      var url, result;
      return _regenerator$P().w(function (_context4) {
        while (1) {
          switch (_context4.n) {
            case 0:
              url = createEndpoint("/api/domains/".concat(domainName, "/domainappraisal"));
              _context4.p = 1;
              _context4.n = 2;
              return get$3(url);

            case 2:
              result = _context4.v;
              _context4.n = 4;
              break;

            case 3:
              _context4.p = 3;
              setApiAllFail(true);

            case 4:
              if (result) {
                _context4.n = 5;
                break;
              }

              return _context4.a(2, '');

            case 5:
              return _context4.a(2, result.data.result);
          }
        }
      }, _callee4, null, [[1, 3]]);
    }));
    return _getDomainAppraisal.apply(this, arguments);
  }

  var skeletonWhileLoading = /*#__PURE__*/jsx$1(Box$1, {
    children: /*#__PURE__*/jsx$1(Skeleton$1, {
      height: "4rem",
      mb: 2,
      width: "100%"
    })
  });
  var buttonMarginTop = '2';
  var buttonColour = 'deepKoamaru';
  var buttonTextElement = /*#__PURE__*/jsx$1(Text$1, {
    lineHeight: "1.7",
    children: "Load More"
  });
  var buttonWidth = '10rem';

  var renderDomainAppraisalRow = function renderDomainAppraisalRow(domainAppraisal) {
    return [/*#__PURE__*/jsx$1(Box$1, {
      alignItems: "center",
      bg: "white",
      borderBottom: "light",
      borderLeft: "light",
      borderRight: "light",
      justifyContent: "left",
      pl: 2,
      width: "auto",
      children: domainAppraisal.Domain
    }, "appraisalName-".concat(domainAppraisal.Domain)), /*#__PURE__*/jsx$1(Box$1, {
      alignItems: "left",
      bg: "white",
      borderBottom: "light",
      borderRight: "light",
      justifyContent: "left",
      minHeight: "4rem",
      pb: 2,
      pl: 2,
      pt: 2,
      width: "auto",
      children: currencyFormatter(domainAppraisal.EstimatedValue)
    }, "appraisalValue-".concat(domainAppraisal.Domain))];
  };

  var domainAppraisalContent = /*#__PURE__*/jsx$1(LoadMoreContainer, {
    buttonColour: buttonColour,
    buttonMarginTop: buttonMarginTop,
    buttonTextElement: buttonTextElement,
    buttonWidth: buttonWidth,
    list: domains,
    listGridColumn: ['1fr 1fr', '1fr 1fr'],
    listGridRow: "4rem",
    renderListItem: renderDomainAppraisalRow,
    renderOffset: 5,
    useButtonVariant: false
  });
  return /*#__PURE__*/jsx$1(Fragment, {
    children: cancellingDomains ? /*#__PURE__*/jsxs(Stack$2, {
      mx: 4,
      my: 4,
      children: [/*#__PURE__*/jsx$1(Heading, {
        fontSize: "2.5rem",
        children: getCancelMessage()
      }), /*#__PURE__*/jsx$1(Box$1, {
        children: /*#__PURE__*/jsx$1(Skeleton$1, {
          height: "16rem",
          mb: 2,
          width: "100%"
        })
      })]
    }) : /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsxs(Stack$2, {
        mx: 4,
        my: 4,
        children: [/*#__PURE__*/jsx$1(Heading, {
          fontSize: "2.5rem",
          children: "Before you delete, did you know..."
        }), /*#__PURE__*/jsx$1(Text$1, {
          children: "Your domain could be worth something on the domain marketplace."
        }), /*#__PURE__*/jsx$1(Box$1, {
          children: /*#__PURE__*/jsx$1(Link$1, {
            alignSelf: "flex-start",
            ariaLabel: "sellingDomain",
            as: Link$1,
            color: "deepKoamaru",
            display: "flex",
            href: createSupportArticleEndpoint('4412961680283', '4412950356891'),
            id: "lnk_sellingDomain",
            newTab: "true",
            onClick: handleLinkTracking,
            variant: "solid",
            width: "19rem",
            children: "Click here to learn more."
          })
        }), /*#__PURE__*/jsxs(Grid$1, {
          alignSelf: "center",
          bg: "white",
          border: "light",
          gridTemplateColumns: ['1fr 1fr', '1fr 1fr'],
          gridTemplateRows: "4rem",
          mt: 3,
          width: "100%",
          children: [/*#__PURE__*/jsx$1(Box$1, {
            alignItems: "center",
            borderBottom: "light",
            justifyContent: "center",
            width: "100%",
            children: /*#__PURE__*/jsx$1(Heading, {
              variant: ['megaBold', 'gigaBold'],
              children: "Domain"
            })
          }), /*#__PURE__*/jsx$1(Box$1, {
            alignItems: "center",
            borderBottom: "light",
            justifyContent: "center",
            width: "100%",
            children: /*#__PURE__*/jsx$1(Heading, {
              variant: ['megaBold', 'gigaBold'],
              children: "Approx. Value"
            })
          })]
        }), appraisalLoading && skeletonWhileLoading, !appraisalLoading && domainAppraisalContent, /*#__PURE__*/jsxs(Box$1, {
          alignItems: "center",
          bg: warningColour,
          flexDirection: "column",
          justifyContent: "center",
          mt: 3,
          pb: 3,
          pl: 3,
          pt: 3,
          width: "100%",
          children: [/*#__PURE__*/jsx$1(Text$1, {
            variant: "pound",
            children: "Cancelling this domain will set it to expire immediately. If you would like your domain to simply not automatically renew instead, please contact customer service. Once it is cancelled, you will only be able to recover it with a recovery fee within 30 days."
          }), /*#__PURE__*/jsx$1(Text$1, {
            variant: "poundBold",
            children: "Please note, no credit or refund will be given for domain names that are cancelled prior to the next billing date."
          })]
        }), apiAllFail && /*#__PURE__*/jsx$1(CancellationRetentionGenericError, {})]
      }), /*#__PURE__*/jsx$1(Box$1, {
        bg: "deepKoamaru",
        justifyContent: "flex-end",
        mt: 4,
        px: 4,
        py: 4,
        children: /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx$1("div", {
            className: "ngdialog-close",
            onClick: closeModal,
            onKeyDown: function onKeyDown() {},
            role: "button",
            style: {
              textDecoration: 'underline',
              cursor: 'pointer',
              marginTop: '3px',
              color: 'white'
            },
            tabIndex: "0",
            children: cancelText
          }), /*#__PURE__*/jsx$1(Button$1, {
            color: "white",
            ml: 4,
            onClick: handleNextButtonClick,
            style: {
              lineHeight: 1.7
            },
            variant: "solid",
            children: /*#__PURE__*/jsx$1(Text$1, {
              variant: "kiloBold",
              children: "Confirm Delete"
            })
          }), ' ']
        })
      })]
    })
  });
}

RetentionSurveyConfirmation.propTypes = propTypes$Y;
var propTypes$X = {
  configType: PropTypes$1.string.isRequired,
  domainIds: PropTypes$1.arrayOf(PropTypes$1.string).isRequired,
  domainNames: PropTypes$1.arrayOf(PropTypes$1.string).isRequired
};
var surveyAnswers = {
  surveyType: '',
  reason: '',
  otherDetails: ''
};

function RetentionSurveyModal(_ref) {
  var configType = _ref.configType,
      domainIds = _ref.domainIds,
      domainNames = _ref.domainNames;

  var _useModal = useModal(),
      openModal = _useModal.openModal,
      closeModal = _useModal.closeModal,
      isOpen = _useModal.isOpen,
      Modal = _useModal.Modal;

  var _React$useState = React.useState(''),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      radioSelect = _React$useState2[0],
      setRadioSelect = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray$4(_React$useState3, 2),
      answerRequired = _React$useState4[0],
      setAnswerRequired = _React$useState4[1];

  var _useState = useState(1),
      _useState2 = _slicedToArray$4(_useState, 2),
      pageNumber = _useState2[0],
      setPageNumber = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$4(_useState3, 2),
      apiAllFail = _useState4[0],
      setApiAllFail = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray$4(_useState5, 2),
      goodRenewals = _useState6[0],
      setGoodRenewals = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray$4(_useState7, 2),
      failedRenewals = _useState8[0],
      setFailedRenewals = _useState8[1];

  var _useState9 = useState(false),
      _useState0 = _slicedToArray$4(_useState9, 2),
      domainRenwalsLoading = _useState0[0],
      setDomainRenewalsLoading = _useState0[1];

  var modalJSON;

  if (configType === 'cancellation') {
    modalJSON = CancellationRetentionSurveyConfig({
      domainIds: domainIds,
      setApiAllFail: setApiAllFail,
      setDomainRenewalsLoading: setDomainRenewalsLoading,
      setFailedRenewals: setFailedRenewals,
      setGoodRenewals: setGoodRenewals,
      setPageNumber: setPageNumber
    });
  }

  var setRadio = function setRadio(value) {
    setRadioSelect(value);
  };

  var setRequired = function setRequired(value) {
    setAnswerRequired(value);
  };

  var changePage = function changePage() {
    if (pageNumber === 1) {
      if (!radioSelect) {
        setRequired(true);
        return;
      }

      setRequired(false);
      setApiAllFail(false);
      setPageNumber(2);
      surveyAnswers = {
        surveyType: configType,
        reason: radioSelect,
        otherDetails: document.getElementById('otherDetails').value
      };
    } else {
      setPageNumber(1);
    }
  };

  var handleCancelButtonClick = function handleCancelButtonClick() {
    setRadioSelect('');
    setAnswerRequired(false);
    setPageNumber(1);
    closeModal();
  };

  var page1Html = /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(Stack$2, {
      mx: 4,
      my: 4,
      children: [/*#__PURE__*/jsx$1(Heading, {
        fontSize: "2.5rem",
        children: modalJSON.surveyQuestionHeaderText
      }), modalJSON.surveyQuestions.map(function (value, index) {
        return /*#__PURE__*/jsx$1(SurveyQuestions, {
          answerObjectList: value.answerObjectList,
          domainRenwalsLoading: domainRenwalsLoading,
          questionText: value.questionText,
          radioSelect: radioSelect,
          setRadioSelect: setRadio,
          showRequired: answerRequired
        }, index);
      }), /*#__PURE__*/jsx$1(Box$1, {
        mt: 3,
        children: /*#__PURE__*/jsx$1("textarea", {
          cols: 71,
          id: "otherDetails",
          maxLength: 500,
          pl: 2,
          placeholder: modalJSON.commentBoxPlaceholderText,
          pt: 2,
          rows: 5,
          style: {
            padding: '10px'
          }
        })
      }), apiAllFail && /*#__PURE__*/jsx$1(CancellationRetentionGenericError, {})]
    }), /*#__PURE__*/jsx$1(Box$1, {
      bg: "deepKoamaru",
      justifyContent: "flex-end",
      mt: 4,
      px: 4,
      py: 4,
      children: /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx$1("div", {
          className: "ngdialog-close",
          onClick: handleCancelButtonClick,
          onKeyDown: function onKeyDown() {},
          role: "button",
          style: {
            textDecoration: 'underline',
            cursor: 'pointer',
            marginTop: '3px',
            color: 'white'
          },
          tabIndex: "0",
          children: modalJSON.cancelText
        }), /*#__PURE__*/jsx$1(Button$1, {
          color: "white",
          ml: 4,
          onClick: changePage,
          style: {
            lineHeight: 1.7
          },
          variant: "solid",
          children: /*#__PURE__*/jsxs(Text$1, {
            variant: "kiloBold",
            children: [modalJSON.nextActionText || 'Confirm', ' ']
          })
        }), ' ']
      })
    })]
  });
  var page2Html = /*#__PURE__*/jsx$1(RetentionSurveyConfirmation, {
    apiAllFail: apiAllFail,
    cancelText: modalJSON.cancelText,
    closeModal: handleCancelButtonClick,
    domainIds: domainIds,
    domainNames: domainNames,
    setApiAllFail: setApiAllFail,
    setPageNumber: setPageNumber,
    surveyAnswers: surveyAnswers
  });
  var page3Html = /*#__PURE__*/jsx$1(CancellationRetentionRenewSuccess, {
    cancelText: modalJSON.cancelText,
    closeModal: handleCancelButtonClick,
    failedRenewals: failedRenewals,
    goodRenewals: goodRenewals
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Button$1, {
      id: "openRetentionSurvey",
      onClick: openModal,
      style: {
        display: modalJSON.showOpenModalButton ? '' : 'none',
        lineHeight: 1.7
      },
      children: modalJSON.openModalButtonText
    }), /*#__PURE__*/jsx$1(Modal, {
      closeBtnCb: handleCancelButtonClick,
      containerProps: {
        p: 0
      },
      id: "retention-survey-modal",
      isOpen: isOpen,
      onBgClick: handleCancelButtonClick,
      onEscapeKey: handleCancelButtonClick,
      width: "35%",
      children: {
        1: page1Html,
        2: page2Html,
        3: page3Html
      }[pageNumber]
    })]
  });
}

RetentionSurveyModal.propTypes = propTypes$X;
var _excluded$p = ["isOpen", "onClick", "ariaID"];

function ownKeys$Z(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$Z(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$Z(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$Z(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var propTypes$W = {
  ariaID: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};
var IconBox = motion.custom(styled(Box$1).withConfig({
  displayName: "toggle-arrow-icon__IconBox",
  componentId: "sc-i9deuw-0"
})([""]));
var iconBoxVariants = {
  open: {
    rotate: 180
  },
  closed: {
    rotate: 0
  }
};

function ToggleArrowIcon(_ref) {
  var isOpen = _ref.isOpen,
      onClick = _ref.onClick,
      ariaID = _ref.ariaID,
      rest = _objectWithoutProperties$8(_ref, _excluded$p);

  return /*#__PURE__*/jsx$1(IconBox, _objectSpread$Z(_objectSpread$Z({}, rest), {}, {
    animate: isOpen ? 'open' : 'closed',
    variants: iconBoxVariants,
    children: /*#__PURE__*/jsx$1(Icon$2, {
      height: "3rem",
      name: "arrow-down",
      onClick: onClick,
      title: "back",
      titleId: "chevron-down-".concat(ariaID),
      width: "3rem"
    })
  }));
}

ToggleArrowIcon.propTypes = propTypes$W;

var _templateObject$r, _templateObject2$h, _templateObject3$b, _templateObject4$7, _templateObject5$5, _templateObject6$4, _templateObject7$4;

var media$3 = theme.media,
    sizes = theme.sizes;
var propTypes$V = {
  alert: PropTypes.string,
  customFilters: PropTypes.object,
  datasetSize: PropTypes.number,
  headers: PropTypes.arrayOf(PropTypes.shape({
    sortable: PropTypes.bool,
    sortFunction: PropTypes.func,
    sortKey: PropTypes.string.isRequired,
    title: PropTypes.string,
    type: PropTypes.string
  })).isRequired,
  loading: PropTypes.bool,
  onPaginationChange: PropTypes.func,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  rowsPerPage: PropTypes.number,
  showPagination: PropTypes.bool,
  showResultCount: PropTypes.bool,
  showRowSelector: PropTypes.bool,
  subtitle: PropTypes.string,
  title: PropTypes.string
};
var defaultProptypes = {
  alert: null,
  customFilters: null,
  datasetSize: null,
  loading: false,
  onPaginationChange: function onPaginationChange() {},
  rowsPerPage: 10,
  showPagination: false,
  showResultCount: true,
  showRowSelector: true,
  subtitle: null,
  title: null
};
var alertStyles = css$3(["background-color:", ";width:inherit;"], function (_ref) {
  var colors = _ref.theme.colors;
  return colors.alert;
});

function Table$1(_ref2) {
  var title = _ref2.title,
      headers = _ref2.headers,
      rows = _ref2.rows,
      subtitle = _ref2.subtitle,
      alert = _ref2.alert,
      customFilters = _ref2.customFilters,
      datasetSize = _ref2.datasetSize,
      showPagination = _ref2.showPagination,
      onPaginationChange = _ref2.onPaginationChange,
      rowsPerPage = _ref2.rowsPerPage,
      showResultCount = _ref2.showResultCount,
      showRowSelector = _ref2.showRowSelector,
      loading = _ref2.loading;

  var _useState = useState(),
      _useState2 = _slicedToArray$4(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$4(_useState3, 2),
      isAscending = _useState4[0],
      setAscending = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray$4(_useState5, 2),
      currentSort = _useState6[0],
      setCurrentSort = _useState6[1];

  useEffect(function () {
    setData(rows);
  }, [rows]);

  var sortData = function sortData(key, sortAsc) {
    var sortFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _$1.orderBy;
    var sortedObjs = sortFunc(data, [key], [sortAsc ? 'asc' : 'desc']);
    setData(sortedObjs);
  };

  var renderRow = function renderRow(row, index) {
    return [headers.map(function (heading, idx) {
      return /*#__PURE__*/jsx$1(Box$1, {
        alignItems: "center",
        bg: "white",
        borderBottom: index === data.length - 1 ? null : 'light',
        justifyContent: "center",
        width: "100%",
        children: heading.type !== 'node' ? /*#__PURE__*/jsx$1(_StyledText$j, {
          ml: idx === 0 ? 2 : 0,
          children: row[heading.sortKey]
        }) : row[heading.sortKey]
      }, "".concat(heading.sortKey, "-").concat(idx));
    })];
  };

  return /*#__PURE__*/jsxs(Section, {
    overflow: "auto",
    width: "100%",
    children: [/*#__PURE__*/jsx$1(Stack$2, {
      flexDirection: "row",
      width: "100%",
      children: /*#__PURE__*/jsxs(_StyledBox$i, {
        flexDirection: "column",
        justifyContent: "flex-start",
        width: "100%",
        $_css: media$3.mediumAndDown(_templateObject$r || (_templateObject$r = _taggedTemplateLiteral$1(["\n              min-width: ", "\n            "])), sizes.containers.md),
        children: [subtitle && /*#__PURE__*/jsx$1(Text$1, {
          mb: 2,
          ml: 3,
          variant: ['milli', 'mega'],
          children: subtitle
        }), /*#__PURE__*/jsx$1(Heading, {
          mb: [2, 3],
          ml: 3,
          variant: ['gigaBold', 'teraBold'],
          children: title
        }), customFilters && /*#__PURE__*/jsx$1(Box$1, {
          display: "flex",
          flexDirection: "row",
          children: customFilters
        })]
      })
    }), /*#__PURE__*/jsx$1(Stack$2, {
      flexDirection: "row",
      width: "100%",
      children: /*#__PURE__*/jsx$1(_StyledGrid$3, {
        alignSelf: "center",
        bg: "white",
        border: "light",
        gridTemplateColumns: "repeat(".concat(headers.length, ", 1fr)"),
        gridTemplateRows: "6rem",
        pl: 3,
        pr: 3,
        width: "100%",
        $_css2: media$3.mediumAndDown(_templateObject2$h || (_templateObject2$h = _taggedTemplateLiteral$1(["\n              min-width: ", "\n            "])), sizes.containers.md),
        children: headers.map(function (heading, idx) {
          return /*#__PURE__*/jsxs(Box$1, {
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            children: [/*#__PURE__*/jsx$1(Heading, {
              variant: ['megaBold', 'gigaBold'],
              children: heading.title
            }), heading.sortable ? /*#__PURE__*/jsx$1(ToggleArrowIcon, {
              ariaID: "sort-".concat(heading.title),
              isOpen: currentSort === heading.sortKey && isAscending,
              onClick: function onClick() {
                setAscending(!isAscending);
                setCurrentSort(heading.sortKey);
                sortData(heading.sortKey, !isAscending, heading.sortFunction);
              }
            }) : null]
          }, "".concat(heading, "-").concat(idx));
        })
      })
    }), /*#__PURE__*/jsxs(Stack$2, {
      width: "100%",
      children: [data && !loading && /*#__PURE__*/jsx$1(_StyledGrid2, {
        borderBottom: alert ? null : 'light',
        borderLeft: "light",
        borderRight: "light",
        gridTemplateColumns: "repeat(".concat(headers.length, ", 1fr)"),
        gridTemplateRows: "repeat(".concat((data === null || data === void 0 ? void 0 : data.length) || null, ", 6rem)"),
        width: "100%",
        $_css3: media$3.mediumAndDown(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteral$1(["\n              min-width: ", "\n            "])), sizes.containers.md),
        children: data.map(function (row, index) {
          return renderRow(row, index);
        })
      }), loading && /*#__PURE__*/jsx$1(Box$1, {
        borderBottom: "light",
        borderLeft: "light",
        borderRight: "light",
        justifyContent: "flex-start",
        mb: 3,
        px: [3, 4],
        py: [4, 5],
        children: /*#__PURE__*/jsx$1(LoadingSpinner, {})
      }), !!alert && /*#__PURE__*/jsx$1(Box$1, {
        borderBottom: "light",
        borderLeft: "light",
        borderRight: "light",
        justifyContent: "flex-start",
        pl: [3, 5],
        pr: [3, 5],
        width: "100%",
        children: /*#__PURE__*/jsx$1(_StyledBox2$7, {
          mb: [2, 4],
          mt: 2,
          pb: [1, 2],
          pl: [1, 2],
          pr: [1, 2],
          pt: [1, 2],
          children: /*#__PURE__*/jsx$1(Text$1, {
            variant: "milli",
            children: alert
          })
        })
      })]
    }), showPagination && /*#__PURE__*/jsx$1(Pagination, {
      justifyContent: "flex-end",
      onPageChange: onPaginationChange,
      rowsPerPage: rowsPerPage,
      showResultCount: showResultCount,
      showRowSelector: showRowSelector,
      total: datasetSize
    })]
  });
}

Table$1.propTypes = propTypes$V;
Table$1.defaultProps = defaultProptypes;

var _StyledText$j = styled(Text$1)(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteral$1(["\n              word-break: break-word;\n              text-align: center;\n            "])));

var _StyledBox$i = styled(Box$1)(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteral$1(["\n            ", ";\n          "])), function (p) {
  return p.$_css;
});

var _StyledGrid$3 = styled(Grid$1)(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteral$1(["\n            ", ";\n          "])), function (p) {
  return p.$_css2;
});

var _StyledGrid2 = styled(Grid$1)(_templateObject7$4 || (_templateObject7$4 = _taggedTemplateLiteral$1(["\n              ", ";\n            "])), function (p) {
  return p.$_css3;
});

var _StyledBox2$7 = styled(Box$1).withConfig({
  displayName: "table___StyledBox2",
  componentId: "sc-axjq0c-0"
})(["", ""], alertStyles);

var propTypes$U = {
  children: PropTypes.node.isRequired,
  location: PropTypes.string,
  theme: PropTypes.shape({})
};
var defaultProps$s = {
  location: 'Fill in this location',
  theme: undefined
};
var fontLink = 'https://use.typekit.net/qqu3ueq.css';

function CoreProvider(_ref) {
  var children = _ref.children,
      location = _ref.location,
      theme = _ref.theme;
  useEffect(function () {
    if (hasDOM) {
      window.rw_tracker = tracker$1;

      if (window.rw_tracker_events && window.rw_tracker_events.length > 0) {
        window.rw_tracker_events.forEach(function (event) {
          tracker$1(event[0], event[1]);
        });
      }
    }
  }, []);
  return /*#__PURE__*/jsx$1(ThemeProvider$1, {
    theme: theme,
    children: /*#__PURE__*/jsxs(ErrorBoundary, {
      location: location,
      children: [/*#__PURE__*/jsxs(Helmet, {
        children: [/*#__PURE__*/jsx$1("link", {
          crossOrigin: "true",
          href: "https://use.typekit.net",
          rel: "preconnect"
        }), /*#__PURE__*/jsx$1("link", {
          as: "style",
          href: fontLink,
          rel: "preload"
        }), /*#__PURE__*/jsx$1("link", {
          href: fontLink,
          media: "print",
          onLoad: "this.media='all'",
          rel: "stylesheet"
        }), /*#__PURE__*/jsx$1("link", {
          rel: "stylesheet",
          href: "https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&family=DM+Sans:wght@300;400;500;600;700;800&family=Montserrat:wght@300;400;500;600;700;800&display=swap"
        }), /*#__PURE__*/jsx$1("link", {
          href: "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100..900;1,100..900&display=swap",
          rel: "stylesheet"
        })]
      }), /*#__PURE__*/jsxs(ErrorProvider$1, {
        children: [/*#__PURE__*/jsx$1(GlobalStyle$1, {}), /*#__PURE__*/jsx$1(LoaderProvider, {
          children: /*#__PURE__*/jsx$1(ModalProvider, {
            children: children
          })
        })]
      })]
    })
  });
}

CoreProvider.defaultProps = defaultProps$s;
CoreProvider.propTypes = propTypes$U;

function ownKeys$Y(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$Y(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$Y(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$Y(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _regenerator$O() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$O(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$O(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$O(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$O(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$O(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$O(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$O(u), _regeneratorDefine2$O(u, o, "Generator"), _regeneratorDefine2$O(u, n, function () {
    return this;
  }), _regeneratorDefine2$O(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$O = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$O(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$O = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$O(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$O(e, r, n, t);
}

function AddToCartWithDomainModal(_ref) {
  var id = _ref.id,
      btnProps = _ref.btnProps,
      buttonText = _ref.buttonText,
      description = _ref.description,
      fields = _ref.fields,
      onSubmit = _ref.onSubmit,
      successMessage = _ref.successMessage,
      title = _ref.title;

  var _useModal = useModal(),
      openModal = _useModal.openModal,
      closeModal = _useModal.closeModal,
      Modal = _useModal.Modal,
      containerRef = _useModal.containerRef;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      success = _useState2[0],
      setSuccess = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray$4(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray$4(_useState5, 2),
      submitting = _useState6[0],
      setSubmitting = _useState6[1];

  var _useState7 = useState({}),
      _useState8 = _slicedToArray$4(_useState7, 2),
      values = _useState8[0],
      setValues = _useState8[1];

  var openInfoModal = function openInfoModal() {
    setErrorMessage('');
    setSuccess(false);
    openModal();
  };

  var closeInfoModal = function closeInfoModal() {
    setErrorMessage('');
    setSuccess(false);
    closeModal();
  };

  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$O().m(function _callee() {
      var result, message, _t;

      return _regenerator$O().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              setSubmitting(true);
              setErrorMessage('');
              _context.p = 1;
              _context.n = 2;
              return onSubmit(values);

            case 2:
              result = _context.v;
              setSubmitting(false);

              if (!result || result.error) {
                message = result.error.response ? result.error.response.data.message : 'Something went wrong';
                setErrorMessage(message);
                setSuccess(false);
              } else {
                setSuccess(true);
              }

              _context.n = 4;
              break;

            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error(_t);
              setErrorMessage('Something went wrong');
              setSubmitting(false);
              setSuccess(false);

            case 4:
              return _context.a(2);
          }
        }
      }, _callee, null, [[1, 3]]);
    }));

    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleInput = function handleInput(e) {
    var _e$target = e.target,
        value = _e$target.value,
        id = _e$target.id;
    setValues(_objectSpread$Y(_objectSpread$Y({}, values), {}, _defineProperty$6({}, id, value)));
  };

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Button$1, _objectSpread$Y(_objectSpread$Y({
      ariaLabel: buttonText,
      color: "blueDark",
      id: id,
      onClick: function onClick() {
        openInfoModal();
      },
      width: "100%"
    }, btnProps), {}, {
      children: buttonText
    })), /*#__PURE__*/jsx$1(Modal, {
      closeBtnCb: closeInfoModal,
      id: "add-to-cart-with-domain",
      onBgClick: closeInfoModal,
      onCancel: closeInfoModal,
      onEscapeKey: closeInfoModal,
      width: "60rem",
      children: /*#__PURE__*/jsxs(ErrorBoundary, {
        location: "info-collector",
        children: [success && /*#__PURE__*/jsx$1(Box$1, {
          alignItems: "center",
          justifyContent: "center",
          children: /*#__PURE__*/jsxs(Text$1, {
            variant: "gigaBold",
            children: [successMessage, " "]
          })
        }), !success && /*#__PURE__*/jsxs(Stack$2, {
          ref: containerRef,
          children: [/*#__PURE__*/jsx$1(Heading, {
            variant: "gigaBold",
            children: title
          }), /*#__PURE__*/jsx$1(Text$1, {
            mt: 3,
            variant: "pound",
            children: description
          }), fields.map(function (field) {
            return /*#__PURE__*/jsx$1(Input$5, {
              id: field.id,
              label: field.display,
              mt: 3,
              onChange: handleInput,
              required: true,
              type: field.type ? field.type : 'text',
              value: values[field.id]
            }, field.id);
          }), errorMessage && /*#__PURE__*/jsx$1(Message, {
            mt: 3,
            variant: "error",
            children: errorMessage
          }), /*#__PURE__*/jsx$1(Box$1, {
            alignItems: "center",
            justifyContent: "flex-end",
            mt: 3,
            children: submitting ? /*#__PURE__*/jsx$1(Spinner$1, {
              size: "3rem",
              stroke: ".3rem"
            }) : /*#__PURE__*/jsx$1(Button$1, {
              id: "submit-info",
              onClick: handleSubmit,
              type: "submit",
              children: buttonText
            })
          })]
        })]
      })
    })]
  });
}

var isMergeableObject = function isMergeableObject(value) {
  return isNonNullObject(value) && !isSpecial(value);
};

function isNonNullObject(value) {
  return !!value && typeof value === 'object';
}

function isSpecial(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
} // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25


var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
  return value.$$typeof === REACT_ELEMENT_TYPE;
}

function emptyTarget(val) {
  return Array.isArray(val) ? [] : {};
}

function cloneUnlessOtherwiseSpecified(value, options) {
  return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
}

function defaultArrayMerge(target, source, options) {
  return target.concat(source).map(function (element) {
    return cloneUnlessOtherwiseSpecified(element, options);
  });
}

function mergeObject(target, source, options) {
  var destination = {};

  if (options.isMergeableObject(target)) {
    Object.keys(target).forEach(function (key) {
      destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
    });
  }

  Object.keys(source).forEach(function (key) {
    if (!options.isMergeableObject(source[key]) || !target[key]) {
      destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
    } else {
      destination[key] = deepmerge(target[key], source[key], options);
    }
  });
  return destination;
}

function deepmerge(target, source, options) {
  options = options || {};
  options.arrayMerge = options.arrayMerge || defaultArrayMerge;
  options.isMergeableObject = options.isMergeableObject || isMergeableObject;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified(source, options);
  } else if (sourceIsArray) {
    return options.arrayMerge(target, source, options);
  } else {
    return mergeObject(target, source, options);
  }
}

deepmerge.all = function deepmergeAll(array, options) {
  if (!Array.isArray(array)) {
    throw new Error('first argument should be an array');
  }

  return array.reduce(function (prev, next) {
    return deepmerge(prev, next, options);
  }, {});
};

var deepmerge_1 = deepmerge;
/** Detect free variable `global` from Node.js. */

var freeGlobal = typeof global$2 == 'object' && global$2 && global$2.Object === Object && global$2;
var freeGlobal$1 = freeGlobal;
/** Detect free variable `self`. */

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */

var root = freeGlobal$1 || freeSelf || Function('return this')();
var root$1 = root;
/** Built-in value references. */

var Symbol$1 = root$1.Symbol;
var Symbol$2 = Symbol$1;
/** Used for built-in method references. */

var objectProto$d = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$a = objectProto$d.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString$1 = objectProto$d.toString;
/** Built-in value references. */

var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */

function getRawTag(value) {
  var isOwn = hasOwnProperty$a.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);

  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }

  return result;
}
/** Used for built-in method references. */


var objectProto$c = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */

var nativeObjectToString = objectProto$c.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */

function objectToString(value) {
  return nativeObjectToString.call(value);
}
/** `Object#toString` result references. */


var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';
/** Built-in value references. */

var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }

  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */


function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}
/** Built-in value references. */


var getPrototype = overArg(Object.getPrototypeOf, Object);
var getPrototype$1 = getPrototype;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike(value) {
  return value != null && typeof value == 'object';
}
/** `Object#toString` result references. */


var objectTag$3 = '[object Object]';
/** Used for built-in method references. */

var funcProto$2 = Function.prototype,
    objectProto$b = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$2 = funcProto$2.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$9 = objectProto$b.hasOwnProperty;
/** Used to infer the `Object` constructor. */

var objectCtorString = funcToString$2.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */

function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag$3) {
    return false;
  }

  var proto = getPrototype$1(value);

  if (proto === null) {
    return true;
  }

  var Ctor = hasOwnProperty$9.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString$2.call(Ctor) == objectCtorString;
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */


function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */


function eq(value, other) {
  return value === other || value !== value && other !== other;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */


function assocIndexOf(array, key) {
  var length = array.length;

  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }

  return -1;
}
/** Used for built-in method references. */


var arrayProto = Array.prototype;
/** Built-in value references. */

var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }

  var lastIndex = data.length - 1;

  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }

  --this.size;
  return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */


function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }

  return this;
}
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */


function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `ListCache`.


ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */

function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);
  this.size = data.size;
  return result;
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function stackGet(key) {
  return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function stackHas(key) {
  return this.__data__.has(key);
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */


function isObject$3(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}
/** `Object#toString` result references. */


var asyncTag = '[object AsyncFunction]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */

function isFunction$1(value) {
  if (!isObject$3(value)) {
    return false;
  } // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.


  var tag = baseGetTag(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}
/** Used to detect overreaching core-js shims. */


var coreJsData = root$1['__core-js_shared__'];
var coreJsData$1 = coreJsData;
/** Used to detect methods masquerading as native. */

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */


function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
/** Used for built-in method references. */


var funcProto$1 = Function.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString$1 = funcProto$1.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */

function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}

    try {
      return func + '';
    } catch (e) {}
  }

  return '';
}
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */


var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */

var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */

var funcProto = Function.prototype,
    objectProto$a = Object.prototype;
/** Used to resolve the decompiled source of functions. */

var funcToString = funcProto.toString;
/** Used to check objects for own properties. */

var hasOwnProperty$8 = objectProto$a.hasOwnProperty;
/** Used to detect if a method is native. */

var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty$8).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */

function baseIsNative(value) {
  if (!isObject$3(value) || isMasked(value)) {
    return false;
  }

  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */


function getValue(object, key) {
  return object == null ? undefined : object[key];
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */


function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}
/* Built-in method references that are verified to be native. */


var Map$1 = getNative(root$1, 'Map');
var Map$2 = Map$1;
/* Built-in method references that are verified to be native. */

var nativeCreate = getNative(Object, 'create');
var nativeCreate$1 = nativeCreate;
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */

function hashClear() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
  this.size = 0;
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
/** Used to stand-in for `undefined` hash values. */


var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
/** Used for built-in method references. */

var objectProto$9 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function hashGet(key) {
  var data = this.__data__;

  if (nativeCreate$1) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? undefined : result;
  }

  return hasOwnProperty$7.call(data, key) ? data[key] : undefined;
}
/** Used for built-in method references. */


var objectProto$8 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$6 = objectProto$8.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function hashHas(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== undefined : hasOwnProperty$6.call(data, key);
}
/** Used to stand-in for `undefined` hash values. */


var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */

function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate$1 && value === undefined ? HASH_UNDEFINED : value;
  return this;
}
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */


function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `Hash`.


Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */

function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map$2 || ListCache)(),
    'string': new Hash()
  };
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */


function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */


function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */


function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */


function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */


function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */


function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */


function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;
  this.clear();

  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
} // Add methods to `MapCache`.


MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/** Used as the size to enable large array optimizations. */

var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */

function stackSet(key, value) {
  var data = this.__data__;

  if (data instanceof ListCache) {
    var pairs = data.__data__;

    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }

    data = this.__data__ = new MapCache(pairs);
  }

  data.set(key, value);
  this.size = data.size;
  return this;
}
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */


function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
} // Add methods to `Stack`.


Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */

function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }

  return array;
}

var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

var defineProperty$1 = defineProperty;
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty$1) {
    defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}
/** Used for built-in method references. */


var objectProto$7 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$5 = objectProto$7.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */

function assignValue(object, key, value) {
  var objValue = object[key];

  if (!(hasOwnProperty$5.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */


function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }

    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }

  return object;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */


function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }

  return result;
}
/** `Object#toString` result references. */


var argsTag$2 = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */

function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$2;
}
/** Used for built-in method references. */


var objectProto$6 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$4 = objectProto$6.hasOwnProperty;
/** Built-in value references. */

var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */

var isArguments = baseIsArguments(function () {
  return arguments;
}()) ? baseIsArguments : function (value) {
  return isObjectLike(value) && hasOwnProperty$4.call(value, 'callee') && !propertyIsEnumerable$1.call(value, 'callee');
};
var isArguments$1 = isArguments;
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray = Array.isArray;
var isArray$1 = isArray;
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}
/** Detect free variable `exports`. */


var freeExports$2 = typeof exports == 'object' && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule$2 = freeExports$2 && typeof module == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;
/** Built-in value references. */

var Buffer$1 = moduleExports$2 ? root$1.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */

var isBuffer = nativeIsBuffer || stubFalse;
var isBuffer$1 = isBuffer;
/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$1 = 9007199254740991;
/** Used to detect unsigned integer values. */

var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */

function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/** Used as references for various `Number` constants. */


var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */

function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/** `Object#toString` result references. */


var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$4 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$2 = '[object String]',
    weakMapTag$2 = '[object WeakMap]';
var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */

var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$2] = typedArrayTags[boolTag$2] = typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$2] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$4] = typedArrayTags[numberTag$2] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$2] = typedArrayTags[setTag$4] = typedArrayTags[stringTag$2] = typedArrayTags[weakMapTag$2] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */

function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */


function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}
/** Detect free variable `exports`. */


var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
/** Detect free variable `process` from Node.js. */

var freeProcess = moduleExports$1 && freeGlobal$1.process;
/** Used to access faster Node.js helpers. */

var nodeUtil = function () {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;

    if (types) {
      return types;
    } // Legacy `process.binding('util')` for Node.js < 10.


    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

var nodeUtil$1 = nodeUtil;
/* Node.js helper references. */

var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */

var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray$1 = isTypedArray;
/** Used for built-in method references. */

var objectProto$5 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$3 = objectProto$5.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */

function arrayLikeKeys(value, inherited) {
  var isArr = isArray$1(value),
      isArg = !isArr && isArguments$1(value),
      isBuff = !isArr && !isArg && isBuffer$1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$3.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' || isBuff && (key == 'offset' || key == 'parent') || isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }

  return result;
}
/** Used for built-in method references. */


var objectProto$4 = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */

function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$4;
  return value === proto;
}
/* Built-in method references for those with the same name as other `lodash` methods. */


var nativeKeys = overArg(Object.keys, Object);
var nativeKeys$1 = nativeKeys;
/** Used for built-in method references. */

var objectProto$3 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$2 = objectProto$3.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys$1(object);
  }

  var result = [];

  for (var key in Object(object)) {
    if (hasOwnProperty$2.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }

  return result;
}
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */


function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction$1(value);
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */


function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */


function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */


function nativeKeysIn(object) {
  var result = [];

  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }

  return result;
}
/** Used for built-in method references. */


var objectProto$2 = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty$1 = objectProto$2.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function baseKeysIn(object) {
  if (!isObject$3(object)) {
    return nativeKeysIn(object);
  }

  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$1.call(object, key)))) {
      result.push(key);
    }
  }

  return result;
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */


function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */


function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}
/** Detect free variable `exports`. */


var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
/** Detect free variable `module`. */

var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */

var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */

var Buffer = moduleExports ? root$1.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */

function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }

  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  buffer.copy(result);
  return result;
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */


function copyArray(source, array) {
  var index = -1,
      length = source.length;
  array || (array = Array(length));

  while (++index < length) {
    array[index] = source[index];
  }

  return array;
}
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */


function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];

    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }

  return result;
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */


function stubArray() {
  return [];
}
/** Used for built-in method references. */


var objectProto$1 = Object.prototype;
/** Built-in value references. */

var propertyIsEnumerable = objectProto$1.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbols = !nativeGetSymbols$1 ? stubArray : function (object) {
  if (object == null) {
    return [];
  }

  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var getSymbols$1 = getSymbols;
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */

function copySymbols(source, object) {
  return copyObject(source, getSymbols$1(source), object);
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */


function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }

  return array;
}
/* Built-in method references for those with the same name as other `lodash` methods. */


var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */

var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
  var result = [];

  while (object) {
    arrayPush(result, getSymbols$1(object));
    object = getPrototype$1(object);
  }

  return result;
};
var getSymbolsIn$1 = getSymbolsIn;
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */

function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn$1(source), object);
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */


function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$1(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */


function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols$1);
}
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */


function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn$1);
}
/* Built-in method references that are verified to be native. */


var DataView = getNative(root$1, 'DataView');
var DataView$1 = DataView;
/* Built-in method references that are verified to be native. */

var Promise$1 = getNative(root$1, 'Promise');
var Promise$2 = Promise$1;
/* Built-in method references that are verified to be native. */

var Set$1 = getNative(root$1, 'Set');
var Set$2 = Set$1;
/* Built-in method references that are verified to be native. */

var WeakMap$1 = getNative(root$1, 'WeakMap');
var WeakMap$2 = WeakMap$1;
/** `Object#toString` result references. */

var mapTag$3 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$3 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';
var dataViewTag$2 = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */

var dataViewCtorString = toSource(DataView$1),
    mapCtorString = toSource(Map$2),
    promiseCtorString = toSource(Promise$2),
    setCtorString = toSource(Set$2),
    weakMapCtorString = toSource(WeakMap$2);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */

var getTag = baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

if (DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$2 || Map$2 && getTag(new Map$2()) != mapTag$3 || Promise$2 && getTag(Promise$2.resolve()) != promiseTag || Set$2 && getTag(new Set$2()) != setTag$3 || WeakMap$2 && getTag(new WeakMap$2()) != weakMapTag$1) {
  getTag = function getTag(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$2;

        case mapCtorString:
          return mapTag$3;

        case promiseCtorString:
          return promiseTag;

        case setCtorString:
          return setTag$3;

        case weakMapCtorString:
          return weakMapTag$1;
      }
    }

    return result;
  };
}

var getTag$1 = getTag;
/** Used for built-in method references. */

var objectProto = Object.prototype;
/** Used to check objects for own properties. */

var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */

function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length); // Add properties assigned by `RegExp#exec`.

  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }

  return result;
}
/** Built-in value references. */


var Uint8Array$1 = root$1.Uint8Array;
var Uint8Array$2 = Uint8Array$1;
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */

function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$2(result).set(new Uint8Array$2(arrayBuffer));
  return result;
}
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */


function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
/** Used to match `RegExp` flags from their coerced string values. */


var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */

function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}
/** Used to convert symbols to primitives and strings. */


var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */

function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */


function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/** `Object#toString` result references. */


var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$2 = '[object Symbol]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */

function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;

  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$1:
      return cloneDataView(object, isDeep);

    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object, isDeep);

    case mapTag$2:
      return new Ctor();

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return cloneRegExp(object);

    case setTag$2:
      return new Ctor();

    case symbolTag$2:
      return cloneSymbol(object);
  }
}
/** Built-in value references. */


var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */

var baseCreate = function () {
  function object() {}

  return function (proto) {
    if (!isObject$3(proto)) {
      return {};
    }

    if (objectCreate) {
      return objectCreate(proto);
    }

    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

var baseCreate$1 = baseCreate;
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */

function initCloneObject(object) {
  return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate$1(getPrototype$1(object)) : {};
}
/** `Object#toString` result references. */


var mapTag$1 = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */

function baseIsMap(value) {
  return isObjectLike(value) && getTag$1(value) == mapTag$1;
}
/* Node.js helper references. */


var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */

var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
var isMap$1 = isMap;
/** `Object#toString` result references. */

var setTag$1 = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */

function baseIsSet(value) {
  return isObjectLike(value) && getTag$1(value) == setTag$1;
}
/* Node.js helper references. */


var nodeIsSet = nodeUtil$1 && nodeUtil$1.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */

var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
var isSet$1 = isSet;
/** Used to compose bitmasks for cloning. */

var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG$1 = 4;
/** `Object#toString` result references. */

var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag$1 = '[object Symbol]',
    weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */

var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag$1] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */

function baseClone$1(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$1;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }

  if (result !== undefined) {
    return result;
  }

  if (!isObject$3(value)) {
    return value;
  }

  var isArr = isArray$1(value);

  if (isArr) {
    result = initCloneArray(value);

    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer$1(value)) {
      return cloneBuffer(value, isDeep);
    }

    if (tag == objectTag || tag == argsTag || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject(value);

      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }

      result = initCloneByTag(value, tag, isDeep);
    }
  } // Check for circular references and return its corresponding clone.


  stack || (stack = new Stack());
  var stacked = stack.get(value);

  if (stacked) {
    return stacked;
  }

  stack.set(value, result);

  if (isSet$1(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone$1(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap$1(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    } // Recursively populate clone (susceptible to call stack limits).


    assignValue(result, key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}
/** Used to compose bitmasks for cloning. */


var CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */

function clone$1(value) {
  return baseClone$1(value, CLONE_SYMBOLS_FLAG);
}
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */


function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }

  return result;
}
/** `Object#toString` result references. */


var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */

function isSymbol(value) {
  return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
/** Error message constants. */


var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */

function memoize(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }

  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }

    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };

  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
} // Expose `MapCache`.


memoize.Cache = MapCache;
/** Used as the maximum memoize cache size. */

var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */

function memoizeCapped(func) {
  var result = memoize(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }

    return key;
  });
  var cache = result.cache;
  return result;
}
/** Used to match property names within property paths. */


var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */

var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */

var stringToPath = memoizeCapped(function (string) {
  var result = [];

  if (string.charCodeAt(0) === 46
  /* . */
  ) {
    result.push('');
  }

  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});
var stringToPath$1 = stringToPath;
/** Used as references for various `Number` constants. */

var INFINITY$1 = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */

function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
}
/** Used as references for various `Number` constants. */


var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */

var symbolProto = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolToString$1 = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */

function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }

  if (isArray$1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }

  if (isSymbol(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : '';
  }

  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */


function toString$1(value) {
  return value == null ? '' : baseToString(value);
}
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */


function toPath(value) {
  if (isArray$1(value)) {
    return arrayMap(value, toKey);
  }

  return isSymbol(value) ? [value] : copyArray(stringToPath$1(toString$1(value)));
}

var isProduction = process$1.env.NODE_ENV === 'production';

function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

function _extends$8() {
  _extends$8 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$8.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$7(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/** @private is the given object a Function? */


var isFunction = function isFunction(obj) {
  return typeof obj === 'function';
};
/** @private is the given object an Object? */


var isObject$2 = function isObject(obj) {
  return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */


var isInteger = function isInteger(obj) {
  return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */


var isString = function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object/value a promise? */


var isPromise = function isPromise(value) {
  return isObject$2(value) && isFunction(value.then);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */


function getActiveElement(doc) {
  doc = doc || (typeof document !== 'undefined' ? document : undefined);

  if (typeof doc === 'undefined') {
    return null;
  }

  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}
/**
 * Deeply get a value from an object via its path.
 */


function getIn$1(obj, key, def, p) {
  if (p === void 0) {
    p = 0;
  }

  var path = toPath(key);

  while (obj && p < path.length) {
    obj = obj[path[p++]];
  }

  return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */


function setIn(obj, path, value) {
  var res = clone$1(obj); // this keeps inheritance when obj is a class

  var resVal = res;
  var i = 0;
  var pathArray = toPath(path);

  for (; i < pathArray.length - 1; i++) {
    var currentPath = pathArray[i];
    var currentObj = getIn$1(obj, pathArray.slice(0, i + 1));

    if (currentObj && (isObject$2(currentObj) || Array.isArray(currentObj))) {
      resVal = resVal[currentPath] = clone$1(currentObj);
    } else {
      var nextPath = pathArray[i + 1];
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
    }
  } // Return original object if new value is the same as current


  if ((i === 0 ? obj : resVal)[pathArray[i]] === value) {
    return obj;
  }

  if (value === undefined) {
    delete resVal[pathArray[i]];
  } else {
    resVal[pathArray[i]] = value;
  } // If the path array has a single element, the loop did not run.
  // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.


  if (i === 0 && value === undefined) {
    delete res[pathArray[i]];
  }

  return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */


function setNestedObjectValues(object, value, visited, response) {
  if (visited === void 0) {
    visited = new WeakMap();
  }

  if (response === void 0) {
    response = {};
  }

  for (var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++) {
    var k = _Object$keys[_i];
    var val = object[k];

    if (isObject$2(val)) {
      if (!visited.get(val)) {
        visited.set(val, true); // In order to keep array values consistent for both dot path  and
        // bracket syntax, we need to check if this is an array so that
        // this will output  { friends: [true] } and not { friends: { "0": true } }

        response[k] = Array.isArray(val) ? [] : {};
        setNestedObjectValues(val, value, visited, response[k]);
      }
    } else {
      response[k] = value;
    }
  }

  return response;
}

var FormikContext = /*#__PURE__*/createContext(undefined);
FormikContext.displayName = 'FormikContext';
FormikContext.Provider;
FormikContext.Consumer;

function useFormikContext() {
  var formik = useContext(FormikContext);
  !!!formik ? process$1.env.NODE_ENV !== "production" ? warning(false, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.") : warning(false) : void 0;
  return formik;
}

function formikReducer(state, msg) {
  switch (msg.type) {
    case 'SET_VALUES':
      return _extends$8({}, state, {
        values: msg.payload
      });

    case 'SET_TOUCHED':
      return _extends$8({}, state, {
        touched: msg.payload
      });

    case 'SET_ERRORS':
      if (isEqual$3(state.errors, msg.payload)) {
        return state;
      }

      return _extends$8({}, state, {
        errors: msg.payload
      });

    case 'SET_STATUS':
      return _extends$8({}, state, {
        status: msg.payload
      });

    case 'SET_ISSUBMITTING':
      return _extends$8({}, state, {
        isSubmitting: msg.payload
      });

    case 'SET_ISVALIDATING':
      return _extends$8({}, state, {
        isValidating: msg.payload
      });

    case 'SET_FIELD_VALUE':
      return _extends$8({}, state, {
        values: setIn(state.values, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_TOUCHED':
      return _extends$8({}, state, {
        touched: setIn(state.touched, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_ERROR':
      return _extends$8({}, state, {
        errors: setIn(state.errors, msg.payload.field, msg.payload.value)
      });

    case 'RESET_FORM':
      return _extends$8({}, state, msg.payload);

    case 'SET_FORMIK_STATE':
      return msg.payload(state);

    case 'SUBMIT_ATTEMPT':
      return _extends$8({}, state, {
        touched: setNestedObjectValues(state.values, true),
        isSubmitting: true,
        submitCount: state.submitCount + 1
      });

    case 'SUBMIT_FAILURE':
      return _extends$8({}, state, {
        isSubmitting: false
      });

    case 'SUBMIT_SUCCESS':
      return _extends$8({}, state, {
        isSubmitting: false
      });

    default:
      return state;
  }
} // Initial empty states // objects


var emptyErrors = {};
var emptyTouched = {};

function useFormik(_ref) {
  var _ref$validateOnChange = _ref.validateOnChange,
      validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange,
      _ref$validateOnBlur = _ref.validateOnBlur,
      validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur,
      _ref$validateOnMount = _ref.validateOnMount,
      validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount,
      isInitialValid = _ref.isInitialValid,
      _ref$enableReinitiali = _ref.enableReinitialize,
      enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali,
      onSubmit = _ref.onSubmit,
      rest = _objectWithoutPropertiesLoose$7(_ref, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]);

  var props = _extends$8({
    validateOnChange: validateOnChange,
    validateOnBlur: validateOnBlur,
    validateOnMount: validateOnMount,
    onSubmit: onSubmit
  }, rest);

  var initialValues = useRef(props.initialValues);
  var initialErrors = useRef(props.initialErrors || emptyErrors);
  var initialTouched = useRef(props.initialTouched || emptyTouched);
  var initialStatus = useRef(props.initialStatus);
  var isMounted = useRef(false);
  var fieldRegistry = useRef({});

  if (process$1.env.NODE_ENV !== "production") {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
      !(typeof isInitialValid === 'undefined') ? process$1.env.NODE_ENV !== "production" ? warning(false, 'isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead.') : warning(false) : void 0; // eslint-disable-next-line
    }, []);
  }

  useEffect(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);

  var _React$useReducer = useReducer(formikReducer, {
    values: props.initialValues,
    errors: props.initialErrors || emptyErrors,
    touched: props.initialTouched || emptyTouched,
    status: props.initialStatus,
    isSubmitting: false,
    isValidating: false,
    submitCount: 0
  }),
      state = _React$useReducer[0],
      dispatch = _React$useReducer[1];

  var runValidateHandler = useCallback(function (values, field) {
    return new Promise(function (resolve, reject) {
      var maybePromisedErrors = props.validate(values, field);

      if (maybePromisedErrors == null) {
        // use loose null check here on purpose
        resolve(emptyErrors);
      } else if (isPromise(maybePromisedErrors)) {
        maybePromisedErrors.then(function (errors) {
          resolve(errors || emptyErrors);
        }, function (actualException) {
          if (process$1.env.NODE_ENV !== 'production') {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", actualException);
          }

          reject(actualException);
        });
      } else {
        resolve(maybePromisedErrors);
      }
    });
  }, [props.validate]);
  /**
   * Run validation against a Yup schema and optionally run a function if successful
   */

  var runValidationSchema = useCallback(function (values, field) {
    var validationSchema = props.validationSchema;
    var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
    var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
    return new Promise(function (resolve, reject) {
      promise.then(function () {
        resolve(emptyErrors);
      }, function (err) {
        // Yup will throw a validation error if validation fails. We catch those and
        // resolve them into Formik errors. We can sniff if something is a Yup error
        // by checking error.name.
        // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
        if (err.name === 'ValidationError') {
          resolve(yupToFormErrors(err));
        } else {
          // We throw any other errors
          if (process$1.env.NODE_ENV !== 'production') {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", err);
          }

          reject(err);
        }
      });
    });
  }, [props.validationSchema]);
  var runSingleFieldLevelValidation = useCallback(function (field, value) {
    return new Promise(function (resolve) {
      return resolve(fieldRegistry.current[field].validate(value));
    });
  }, []);
  var runFieldLevelValidations = useCallback(function (values) {
    var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function (f) {
      return isFunction(fieldRegistry.current[f].validate);
    }); // Construct an array with all of the field validation functions

    var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function (f) {
      return runSingleFieldLevelValidation(f, getIn$1(values, f));
    }) : [Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')]; // use special case ;)

    return Promise.all(fieldValidations).then(function (fieldErrorsList) {
      return fieldErrorsList.reduce(function (prev, curr, index) {
        if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') {
          return prev;
        }

        if (curr) {
          prev = setIn(prev, fieldKeysWithValidation[index], curr);
        }

        return prev;
      }, {});
    });
  }, [runSingleFieldLevelValidation]); // Run all validations and return the result

  var runAllValidations = useCallback(function (values) {
    return Promise.all([runFieldLevelValidations(values), props.validationSchema ? runValidationSchema(values) : {}, props.validate ? runValidateHandler(values) : {}]).then(function (_ref2) {
      var fieldErrors = _ref2[0],
          schemaErrors = _ref2[1],
          validateErrors = _ref2[2];
      var combinedErrors = deepmerge_1.all([fieldErrors, schemaErrors, validateErrors], {
        arrayMerge: arrayMerge
      });
      return combinedErrors;
    });
  }, [props.validate, props.validationSchema, runFieldLevelValidations, runValidateHandler, runValidationSchema]); // Run all validations methods and update state accordingly

  var validateFormWithHighPriority = useEventCallback(function (values) {
    if (values === void 0) {
      values = state.values;
    }

    dispatch({
      type: 'SET_ISVALIDATING',
      payload: true
    });
    return runAllValidations(values).then(function (combinedErrors) {
      if (!!isMounted.current) {
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
        dispatch({
          type: 'SET_ERRORS',
          payload: combinedErrors
        });
      }

      return combinedErrors;
    });
  });
  useEffect(function () {
    if (validateOnMount && isMounted.current === true && isEqual$3(initialValues.current, props.initialValues)) {
      validateFormWithHighPriority(initialValues.current);
    }
  }, [validateOnMount, validateFormWithHighPriority]);
  var resetForm = useCallback(function (nextState) {
    var values = nextState && nextState.values ? nextState.values : initialValues.current;
    var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
    var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
    var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
    initialValues.current = values;
    initialErrors.current = errors;
    initialTouched.current = touched;
    initialStatus.current = status;

    var dispatchFn = function dispatchFn() {
      dispatch({
        type: 'RESET_FORM',
        payload: {
          isSubmitting: !!nextState && !!nextState.isSubmitting,
          errors: errors,
          touched: touched,
          status: status,
          values: values,
          isValidating: !!nextState && !!nextState.isValidating,
          submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
        }
      });
    };

    if (props.onReset) {
      var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);

      if (isPromise(maybePromisedOnReset)) {
        maybePromisedOnReset.then(dispatchFn);
      } else {
        dispatchFn();
      }
    } else {
      dispatchFn();
    }
  }, [props.initialErrors, props.initialStatus, props.initialTouched]);
  useEffect(function () {
    if (isMounted.current === true && !isEqual$3(initialValues.current, props.initialValues)) {
      if (enableReinitialize) {
        initialValues.current = props.initialValues;
        resetForm();
      }

      if (validateOnMount) {
        validateFormWithHighPriority(initialValues.current);
      }
    }
  }, [enableReinitialize, props.initialValues, resetForm, validateOnMount, validateFormWithHighPriority]);
  useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !isEqual$3(initialErrors.current, props.initialErrors)) {
      initialErrors.current = props.initialErrors || emptyErrors;
      dispatch({
        type: 'SET_ERRORS',
        payload: props.initialErrors || emptyErrors
      });
    }
  }, [enableReinitialize, props.initialErrors]);
  useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !isEqual$3(initialTouched.current, props.initialTouched)) {
      initialTouched.current = props.initialTouched || emptyTouched;
      dispatch({
        type: 'SET_TOUCHED',
        payload: props.initialTouched || emptyTouched
      });
    }
  }, [enableReinitialize, props.initialTouched]);
  useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !isEqual$3(initialStatus.current, props.initialStatus)) {
      initialStatus.current = props.initialStatus;
      dispatch({
        type: 'SET_STATUS',
        payload: props.initialStatus
      });
    }
  }, [enableReinitialize, props.initialStatus, props.initialTouched]);
  var validateField = useEventCallback(function (name) {
    // This will efficiently validate a single field by avoiding state
    // changes if the validation function is synchronous. It's different from
    // what is called when using validateForm.
    if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
      var value = getIn$1(state.values, name);
      var maybePromise = fieldRegistry.current[name].validate(value);

      if (isPromise(maybePromise)) {
        // Only flip isValidating if the function is async.
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: true
        });
        return maybePromise.then(function (x) {
          return x;
        }).then(function (error) {
          dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
              field: name,
              value: error
            }
          });
          dispatch({
            type: 'SET_ISVALIDATING',
            payload: false
          });
        });
      } else {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: maybePromise
          }
        });
        return Promise.resolve(maybePromise);
      }
    } else if (props.validationSchema) {
      dispatch({
        type: 'SET_ISVALIDATING',
        payload: true
      });
      return runValidationSchema(state.values, name).then(function (x) {
        return x;
      }).then(function (error) {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: error[name]
          }
        });
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
      });
    }

    return Promise.resolve();
  });
  var registerField = useCallback(function (name, _ref3) {
    var validate = _ref3.validate;
    fieldRegistry.current[name] = {
      validate: validate
    };
  }, []);
  var unregisterField = useCallback(function (name) {
    delete fieldRegistry.current[name];
  }, []);
  var setTouched = useEventCallback(function (touched, shouldValidate) {
    dispatch({
      type: 'SET_TOUCHED',
      payload: touched
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var setErrors = useCallback(function (errors) {
    dispatch({
      type: 'SET_ERRORS',
      payload: errors
    });
  }, []);
  var setValues = useEventCallback(function (values, shouldValidate) {
    var resolvedValues = isFunction(values) ? values(state.values) : values;
    dispatch({
      type: 'SET_VALUES',
      payload: resolvedValues
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
  });
  var setFieldError = useCallback(function (field, value) {
    dispatch({
      type: 'SET_FIELD_ERROR',
      payload: {
        field: field,
        value: value
      }
    });
  }, []);
  var setFieldValue = useEventCallback(function (field, value, shouldValidate) {
    dispatch({
      type: 'SET_FIELD_VALUE',
      payload: {
        field: field,
        value: value
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
  });
  var executeChange = useCallback(function (eventOrTextValue, maybePath) {
    // By default, assume that the first argument is a string. This allows us to use
    // handleChange with React Native and React Native Web's onChangeText prop which
    // provides just the value of the input.
    var field = maybePath;
    var val = eventOrTextValue;
    var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
    // so we handle like we would a normal HTML change event.

    if (!isString(eventOrTextValue)) {
      // If we can, persist the event
      // @see https://reactjs.org/docs/events.html#event-pooling
      if (eventOrTextValue.persist) {
        eventOrTextValue.persist();
      }

      var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
      var type = target.type,
          name = target.name,
          id = target.id,
          value = target.value,
          checked = target.checked,
          outerHTML = target.outerHTML,
          options = target.options,
          multiple = target.multiple;
      field = maybePath ? maybePath : name ? name : id;

      if (!field && process$1.env.NODE_ENV !== "production") {
        warnAboutMissingIdentifier({
          htmlContent: outerHTML,
          documentationAnchorLink: 'handlechange-e-reactchangeeventany--void',
          handlerName: 'handleChange'
        });
      }

      val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
      ? getValueForCheckbox(getIn$1(state.values, field), checked, value) : options && multiple // <select multiple>
      ? getSelectedValues(options) : value;
    }

    if (field) {
      // Set form fields by name
      setFieldValue(field, val);
    }
  }, [setFieldValue, state.values]);
  var handleChange = useEventCallback(function (eventOrPath) {
    if (isString(eventOrPath)) {
      return function (event) {
        return executeChange(event, eventOrPath);
      };
    } else {
      executeChange(eventOrPath);
    }
  });
  var setFieldTouched = useEventCallback(function (field, touched, shouldValidate) {
    if (touched === void 0) {
      touched = true;
    }

    dispatch({
      type: 'SET_FIELD_TOUCHED',
      payload: {
        field: field,
        value: touched
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var executeBlur = useCallback(function (e, path) {
    if (e.persist) {
      e.persist();
    }

    var _e$target = e.target,
        name = _e$target.name,
        id = _e$target.id,
        outerHTML = _e$target.outerHTML;
    var field = path ? path : name ? name : id;

    if (!field && process$1.env.NODE_ENV !== "production") {
      warnAboutMissingIdentifier({
        htmlContent: outerHTML,
        documentationAnchorLink: 'handleblur-e-any--void',
        handlerName: 'handleBlur'
      });
    }

    setFieldTouched(field, true);
  }, [setFieldTouched]);
  var handleBlur = useEventCallback(function (eventOrString) {
    if (isString(eventOrString)) {
      return function (event) {
        return executeBlur(event, eventOrString);
      };
    } else {
      executeBlur(eventOrString);
    }
  });
  var setFormikState = useCallback(function (stateOrCb) {
    if (isFunction(stateOrCb)) {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: stateOrCb
      });
    } else {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: function payload() {
          return stateOrCb;
        }
      });
    }
  }, []);
  var setStatus = useCallback(function (status) {
    dispatch({
      type: 'SET_STATUS',
      payload: status
    });
  }, []);
  var setSubmitting = useCallback(function (isSubmitting) {
    dispatch({
      type: 'SET_ISSUBMITTING',
      payload: isSubmitting
    });
  }, []);
  var submitForm = useEventCallback(function () {
    dispatch({
      type: 'SUBMIT_ATTEMPT'
    });
    return validateFormWithHighPriority().then(function (combinedErrors) {
      // In case an error was thrown and passed to the resolved Promise,
      // `combinedErrors` can be an instance of an Error. We need to check
      // that and abort the submit.
      // If we don't do that, calling `Object.keys(new Error())` yields an
      // empty array, which causes the validation to pass and the form
      // to be submitted.
      var isInstanceOfError = combinedErrors instanceof Error;
      var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;

      if (isActuallyValid) {
        // Proceed with submit...
        //
        // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
        // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
        // This would be fine in simple cases, but make it impossible to disable submit
        // buttons where people use callbacks or promises as side effects (which is basically
        // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
        //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
        // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
        // cleanup of isSubmitting on behalf of the consumer.
        var promiseOrUndefined;

        try {
          promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
          // via setSubmitting(false)

          if (promiseOrUndefined === undefined) {
            return;
          }
        } catch (error) {
          throw error;
        }

        return Promise.resolve(promiseOrUndefined).then(function (result) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_SUCCESS'
            });
          }

          return result;
        })["catch"](function (_errors) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_FAILURE'
            }); // This is a legit error rejected by the onSubmit fn
            // so we don't want to break the promise chain

            throw _errors;
          }
        });
      } else if (!!isMounted.current) {
        // ^^^ Make sure Formik is still mounted before updating state
        dispatch({
          type: 'SUBMIT_FAILURE'
        }); // throw combinedErrors;

        if (isInstanceOfError) {
          throw combinedErrors;
        }
      }

      return;
    });
  });
  var handleSubmit = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    } // Warn if form submission is triggered by a <button> without a
    // specified `type` attribute during development. This mitigates
    // a common gotcha in forms with both reset and submit buttons,
    // where the dev forgets to add type="button" to the reset button.


    if (process$1.env.NODE_ENV !== "production" && typeof document !== 'undefined') {
      // Safely get the active element (works with IE)
      var activeElement = getActiveElement();

      if (activeElement !== null && activeElement instanceof HTMLButtonElement) {
        !(activeElement.attributes && activeElement.attributes.getNamedItem('type')) ? process$1.env.NODE_ENV !== "production" ? warning(false, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : warning(false) : void 0;
      }
    }

    submitForm()["catch"](function (reason) {
      console.warn("Warning: An unhandled error was caught from submitForm()", reason);
    });
  });
  var imperativeMethods = {
    resetForm: resetForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    setErrors: setErrors,
    setFieldError: setFieldError,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    setFormikState: setFormikState,
    submitForm: submitForm
  };
  var executeSubmit = useEventCallback(function () {
    return onSubmit(state.values, imperativeMethods);
  });
  var handleReset = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    }

    resetForm();
  });
  var getFieldMeta = useCallback(function (name) {
    return {
      value: getIn$1(state.values, name),
      error: getIn$1(state.errors, name),
      touched: !!getIn$1(state.touched, name),
      initialValue: getIn$1(initialValues.current, name),
      initialTouched: !!getIn$1(initialTouched.current, name),
      initialError: getIn$1(initialErrors.current, name)
    };
  }, [state.errors, state.touched, state.values]);
  var getFieldHelpers = useCallback(function (name) {
    return {
      setValue: function setValue(value, shouldValidate) {
        return setFieldValue(name, value, shouldValidate);
      },
      setTouched: function setTouched(value, shouldValidate) {
        return setFieldTouched(name, value, shouldValidate);
      },
      setError: function setError(value) {
        return setFieldError(name, value);
      }
    };
  }, [setFieldValue, setFieldTouched, setFieldError]);
  var getFieldProps = useCallback(function (nameOrOptions) {
    var isAnObject = isObject$2(nameOrOptions);
    var name = isAnObject ? nameOrOptions.name : nameOrOptions;
    var valueState = getIn$1(state.values, name);
    var field = {
      name: name,
      value: valueState,
      onChange: handleChange,
      onBlur: handleBlur
    };

    if (isAnObject) {
      var type = nameOrOptions.type,
          valueProp = nameOrOptions.value,
          is = nameOrOptions.as,
          multiple = nameOrOptions.multiple;

      if (type === 'checkbox') {
        if (valueProp === undefined) {
          field.checked = !!valueState;
        } else {
          field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
          field.value = valueProp;
        }
      } else if (type === 'radio') {
        field.checked = valueState === valueProp;
        field.value = valueProp;
      } else if (is === 'select' && multiple) {
        field.value = field.value || [];
        field.multiple = true;
      }
    }

    return field;
  }, [handleBlur, handleChange, state.values]);
  var dirty = useMemo(function () {
    return !isEqual$3(initialValues.current, state.values);
  }, [initialValues.current, state.values]);
  var isValid = useMemo(function () {
    return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
  }, [isInitialValid, dirty, state.errors, props]);

  var ctx = _extends$8({}, state, {
    initialValues: initialValues.current,
    initialErrors: initialErrors.current,
    initialTouched: initialTouched.current,
    initialStatus: initialStatus.current,
    handleBlur: handleBlur,
    handleChange: handleChange,
    handleReset: handleReset,
    handleSubmit: handleSubmit,
    resetForm: resetForm,
    setErrors: setErrors,
    setFormikState: setFormikState,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setFieldError: setFieldError,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    submitForm: submitForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    isValid: isValid,
    dirty: dirty,
    unregisterField: unregisterField,
    registerField: registerField,
    getFieldProps: getFieldProps,
    getFieldMeta: getFieldMeta,
    getFieldHelpers: getFieldHelpers,
    validateOnBlur: validateOnBlur,
    validateOnChange: validateOnChange,
    validateOnMount: validateOnMount
  });

  return ctx;
}

function warnAboutMissingIdentifier(_ref4) {
  var htmlContent = _ref4.htmlContent,
      documentationAnchorLink = _ref4.documentationAnchorLink,
      handlerName = _ref4.handlerName;
  console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */


function yupToFormErrors(yupError) {
  var errors = {};

  if (yupError.inner) {
    if (yupError.inner.length === 0) {
      return setIn(errors, yupError.path, yupError.message);
    }

    for (var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref5;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref5 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref5 = _i.value;
      }

      var err = _ref5;

      if (!getIn$1(errors, err.path)) {
        errors = setIn(errors, err.path, err.message);
      }
    }
  }

  return errors;
}
/**
 * Validate a yup schema.
 */


function validateYupSchema(values, schema, sync, context) {
  if (sync === void 0) {
    sync = false;
  }

  if (context === void 0) {
    context = {};
  }

  var validateData = prepareDataForValidation(values);
  return schema[sync ? 'validateSync' : 'validate'](validateData, {
    abortEarly: false,
    context: context
  });
}
/**
 * Recursively prepare values.
 */


function prepareDataForValidation(values) {
  var data = Array.isArray(values) ? [] : {};

  for (var k in values) {
    if (Object.prototype.hasOwnProperty.call(values, k)) {
      var key = String(k);

      if (Array.isArray(values[key]) === true) {
        data[key] = values[key].map(function (value) {
          if (Array.isArray(value) === true || isPlainObject(value)) {
            return prepareDataForValidation(value);
          } else {
            return value !== '' ? value : undefined;
          }
        });
      } else if (isPlainObject(values[key])) {
        data[key] = prepareDataForValidation(values[key]);
      } else {
        data[key] = values[key] !== '' ? values[key] : undefined;
      }
    }
  }

  return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */


function arrayMerge(target, source, options) {
  var destination = target.slice();
  source.forEach(function merge(e, i) {
    if (typeof destination[i] === 'undefined') {
      var cloneRequested = options.clone !== false;
      var shouldClone = cloneRequested && options.isMergeableObject(e);
      destination[i] = shouldClone ? deepmerge_1(Array.isArray(e) ? [] : {}, e, options) : e;
    } else if (options.isMergeableObject(e)) {
      destination[i] = deepmerge_1(target[i], e, options);
    } else if (target.indexOf(e) === -1) {
      destination.push(e);
    }
  });
  return destination;
}
/** Return multi select values based on an array of options */


function getSelectedValues(options) {
  return Array.from(options).filter(function (el) {
    return el.selected;
  }).map(function (el) {
    return el.value;
  });
}
/** Return the next value for a checkbox */


function getValueForCheckbox(currentValue, checked, valueProp) {
  // If the current value was a boolean, return a boolean
  if (typeof currentValue === 'boolean') {
    return Boolean(checked);
  } // If the currentValue was not a boolean we want to return an array


  var currentArrayOfValues = [];
  var isValueInArray = false;
  var index = -1;

  if (!Array.isArray(currentValue)) {
    // eslint-disable-next-line eqeqeq
    if (!valueProp || valueProp == 'true' || valueProp == 'false') {
      return Boolean(checked);
    }
  } else {
    // If the current value is already an array, use it
    currentArrayOfValues = currentValue;
    index = currentValue.indexOf(valueProp);
    isValueInArray = index >= 0;
  } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values


  if (checked && valueProp && !isValueInArray) {
    return currentArrayOfValues.concat(valueProp);
  } // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values


  if (!isValueInArray) {
    return currentArrayOfValues;
  } // If the checkbox was unchecked and the value is in the array, remove the value and return the array


  return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85


var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? useLayoutEffect : useEffect;

function useEventCallback(fn) {
  var ref = useRef(fn); // we copy a ref to the callback scoped to the current state/props on each render

  useIsomorphicLayoutEffect(function () {
    ref.current = fn;
  });
  return useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return ref.current.apply(void 0, args);
  }, []);
}

var Form = /*#__PURE__*/forwardRef$1(function (props, ref) {
  // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
  // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
  var action = props.action,
      rest = _objectWithoutPropertiesLoose$7(props, ["action"]);

  var _action = action != null ? action : '#';

  var _useFormikContext = useFormikContext(),
      handleReset = _useFormikContext.handleReset,
      handleSubmit = _useFormikContext.handleSubmit;

  return createElement("form", Object.assign({
    onSubmit: handleSubmit,
    ref: ref,
    onReset: handleReset,
    action: _action
  }, rest));
});
Form.displayName = 'Form'; // ES6 Map

var map;

try {
  map = Map;
} catch (_) {}

var set; // ES6 Set

try {
  set = Set;
} catch (_) {}

function baseClone(src, circulars, clones) {
  // Null/undefined/functions/etc
  if (!src || typeof src !== 'object' || typeof src === 'function') {
    return src;
  } // DOM Node


  if (src.nodeType && 'cloneNode' in src) {
    return src.cloneNode(true);
  } // Date


  if (src instanceof Date) {
    return new Date(src.getTime());
  } // RegExp


  if (src instanceof RegExp) {
    return new RegExp(src);
  } // Arrays


  if (Array.isArray(src)) {
    return src.map(_clone);
  } // ES6 Maps


  if (map && src instanceof map) {
    return new Map(Array.from(src.entries()));
  } // ES6 Sets


  if (set && src instanceof set) {
    return new Set(Array.from(src.values()));
  } // Object


  if (src instanceof Object) {
    circulars.push(src);
    var obj = Object.create(src);
    clones.push(obj);

    for (var key in src) {
      var idx = circulars.findIndex(function (i) {
        return i === src[key];
      });
      obj[key] = idx > -1 ? clones[idx] : baseClone(src[key], circulars, clones);
    }

    return obj;
  } // ???


  return src;
}

function _clone(src) {
  return baseClone(src, [], []);
}

var toString = Object.prototype.toString;
var errorToString = Error.prototype.toString;
var regExpToString = RegExp.prototype.toString;
var symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : function () {
  return '';
};
var SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;

function printNumber(val) {
  if (val != +val) return 'NaN';
  var isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}

function printSimpleValue(val) {
  var quoteStrings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (val == null || val === true || val === false) return '' + val;
  var typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? "\"".concat(val, "\"") : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  var tag = toString.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}

function printValue(value, quoteStrings) {
  var result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    var result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}

var mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: function notType(_ref74) {
    var path = _ref74.path,
        type = _ref74.type,
        value = _ref74.value,
        originalValue = _ref74.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = "".concat(path, " must be a `").concat(type, "` type, ") + "but the final value was: `".concat(printValue(value, true), "`") + (isCast ? " (cast from the value `".concat(printValue(originalValue, true), "`).") : '.');

    if (value === null) {
      msg += "\n If \"null\" is intended as an empty value be sure to mark the schema as `.nullable()`";
    }

    return msg;
  },
  defined: '${path} must be defined'
};
var string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  uuid: '${path} must be a valid UUID',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
var number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
var date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
var boolean = {
  isValue: '${path} field must be ${value}'
};
var object = {
  noUnknown: '${path} field has unspecified keys: ${unknown}'
};
var array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items',
  length: '${path} must have ${length} items'
};
Object.assign(Object.create(null), {
  mixed: mixed,
  string: string,
  number: number,
  date: date,
  object: object,
  array: array,
  boolean: boolean
});

var isSchema = function isSchema(obj) {
  return obj && obj.__isYupSchema__;
};

var Condition = /*#__PURE__*/function () {
  function Condition(refs, options) {
    _classCallCheck2(this, Condition);

    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;

    if (typeof options === 'function') {
      this.fn = options;
      return;
    }

    if (!has$1(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
    if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    var is = options.is,
        then = options.then,
        otherwise = options.otherwise;
    var check = typeof is === 'function' ? is : function () {
      for (var _len7 = arguments.length, values = new Array(_len7), _key11 = 0; _key11 < _len7; _key11++) {
        values[_key11] = arguments[_key11];
      }

      return values.every(function (value) {
        return value === is;
      });
    };

    this.fn = function () {
      for (var _len8 = arguments.length, args = new Array(_len8), _key12 = 0; _key12 < _len8; _key12++) {
        args[_key12] = arguments[_key12];
      }

      var options = args.pop();
      var schema = args.pop();
      var branch = check.apply(void 0, args) ? then : otherwise;
      if (!branch) return undefined;
      if (typeof branch === 'function') return branch(schema);
      return schema.concat(branch.resolve(options));
    };
  }

  _createClass2(Condition, [{
    key: "resolve",
    value: function resolve(base, options) {
      var values = this.refs.map(function (ref) {
        return ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
      });
      var schema = this.fn.apply(base, values.concat(base, options));
      if (schema === undefined || schema === base) return base;
      if (!isSchema(schema)) throw new TypeError('conditions must return a schema object');
      return schema.resolve(options);
    }
  }]);

  return Condition;
}();

function toArray(value) {
  return value == null ? [] : [].concat(value);
}

function _extends$7() {
  _extends$7 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$7.apply(this, arguments);
}

var strReg = /\$\{\s*(\w+)\s*\}/g;

var ValidationError = /*#__PURE__*/function (_Error2) {
  _inherits2(ValidationError, _Error2);

  var _super51 = _createSuper2(ValidationError);

  function ValidationError(errorOrErrors, value, field, type) {
    var _this36;

    _classCallCheck2(this, ValidationError);

    _this36 = _super51.call(this);
    _this36.value = void 0;
    _this36.path = void 0;
    _this36.type = void 0;
    _this36.errors = void 0;
    _this36.params = void 0;
    _this36.inner = void 0;
    _this36.name = 'ValidationError';
    _this36.value = value;
    _this36.path = field;
    _this36.type = type;
    _this36.errors = [];
    _this36.inner = [];
    toArray(errorOrErrors).forEach(function (err) {
      if (ValidationError.isError(err)) {
        var _this36$errors;

        (_this36$errors = _this36.errors).push.apply(_this36$errors, _toConsumableArray2(err.errors));

        _this36.inner = _this36.inner.concat(err.inner.length ? err.inner : err);
      } else {
        _this36.errors.push(err);
      }
    });
    _this36.message = _this36.errors.length > 1 ? "".concat(_this36.errors.length, " errors occurred") : _this36.errors[0];
    if (Error.captureStackTrace) Error.captureStackTrace(_assertThisInitialized2(_this36), ValidationError);
    return _this36;
  }

  _createClass2(ValidationError, null, [{
    key: "formatError",
    value: function formatError(message, params) {
      var path = params.label || params.path || 'this';
      if (path !== params.path) params = _extends$7({}, params, {
        path: path
      });
      if (typeof message === 'string') return message.replace(strReg, function (_, key) {
        return printValue(params[key]);
      });
      if (typeof message === 'function') return message(params);
      return message;
    }
  }, {
    key: "isError",
    value: function isError(err) {
      return err && err.name === 'ValidationError';
    }
  }]);

  return ValidationError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var once = function once(cb) {
  var fired = false;
  return function () {
    if (fired) return;
    fired = true;
    cb.apply(void 0, arguments);
  };
};

function runTests(options, cb) {
  var endEarly = options.endEarly,
      tests = options.tests,
      args = options.args,
      value = options.value,
      errors = options.errors,
      sort = options.sort,
      path = options.path;
  var callback = once(cb);
  var count = tests.length;
  var nestedErrors = [];
  errors = errors ? errors : [];
  if (!count) return errors.length ? callback(new ValidationError(errors, value, path)) : callback(null, value);

  for (var _i18 = 0; _i18 < tests.length; _i18++) {
    var test = tests[_i18];
    test(args, function finishTestRun(err) {
      if (err) {
        // always return early for non validation errors
        if (!ValidationError.isError(err)) {
          return callback(err, value);
        }

        if (endEarly) {
          err.value = value;
          return callback(err, value);
        }

        nestedErrors.push(err);
      }

      if (--count <= 0) {
        if (nestedErrors.length) {
          if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name

          if (errors.length) nestedErrors.push.apply(nestedErrors, _toConsumableArray2(errors));
          errors = nestedErrors;
        }

        if (errors.length) {
          callback(new ValidationError(errors, value, path), value);
          return;
        }

        callback(null, value);
      }
    });
  }
}

var prefixes = {
  context: '$',
  value: '.'
};

var Reference = /*#__PURE__*/function () {
  function Reference(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck2(this, Reference);

    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    var prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && getter(this.path, true);
    this.map = options.map;
  }

  _createClass2(Reference, [{
    key: "getValue",
    value: function getValue(value, parent, context) {
      var result = this.isContext ? context : this.isValue ? value : parent;
      if (this.getter) result = this.getter(result || {});
      if (this.map) result = this.map(result);
      return result;
    }
    /**
     *
     * @param {*} value
     * @param {Object} options
     * @param {Object=} options.context
     * @param {Object=} options.parent
     */

  }, {
    key: "cast",
    value: function cast(value, options) {
      return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
  }, {
    key: "resolve",
    value: function resolve() {
      return this;
    }
  }, {
    key: "describe",
    value: function describe() {
      return {
        type: 'ref',
        key: this.key
      };
    }
  }, {
    key: "toString",
    value: function toString() {
      return "Ref(".concat(this.key, ")");
    }
  }], [{
    key: "isRef",
    value: function isRef(value) {
      return value && value.__isYupRef;
    }
  }]);

  return Reference;
}(); // @ts-ignore


Reference.prototype.__isYupRef = true;

function _extends$6() {
  _extends$6 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$6.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$6(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function createValidation(config) {
  function validate(_ref, cb) {
    var value = _ref.value,
        _ref$path = _ref.path,
        path = _ref$path === void 0 ? '' : _ref$path,
        label = _ref.label,
        options = _ref.options,
        originalValue = _ref.originalValue,
        sync = _ref.sync,
        rest = _objectWithoutPropertiesLoose$6(_ref, ["value", "path", "label", "options", "originalValue", "sync"]);

    var name = config.name,
        test = config.test,
        params = config.params,
        message = config.message;
    var parent = options.parent,
        context = options.context;

    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent, context) : item;
    }

    function createError() {
      var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var nextParams = mapValues$1(_extends$6({
        value: value,
        originalValue: originalValue,
        label: label,
        path: overrides.path || path
      }, params, overrides.params), resolve);
      var error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
      error.params = nextParams;
      return error;
    }

    var ctx = _extends$6({
      path: path,
      parent: parent,
      type: name,
      createError: createError,
      resolve: resolve,
      options: options,
      originalValue: originalValue
    }, rest);

    if (!sync) {
      try {
        Promise.resolve(test.call(ctx, value, ctx)).then(function (validOrError) {
          if (ValidationError.isError(validOrError)) cb(validOrError);else if (!validOrError) cb(createError());else cb(null, validOrError);
        }).catch(cb);
      } catch (err) {
        cb(err);
      }

      return;
    }

    var result;

    try {
      var _ref2;

      result = test.call(ctx, value, ctx);

      if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === 'function') {
        throw new Error("Validation test of type: \"".concat(ctx.type, "\" returned a Promise during a synchronous validate. ") + "This test will finish after the validate call has returned");
      }
    } catch (err) {
      cb(err);
      return;
    }

    if (ValidationError.isError(result)) cb(result);else if (!result) cb(createError());else cb(null, result);
  }

  validate.OPTIONS = config;
  return validate;
}

var trim = function trim(part) {
  return part.substr(0, part.length - 1).substr(1);
};

function getIn(schema, path, value) {
  var context = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : value;
  var parent, lastPart, lastPartDebug; // root path: ''

  if (!path) return {
    parent: parent,
    parentPath: path,
    schema: schema
  };
  forEach$1(path, function (_part, isBracket, isArray) {
    var part = isBracket ? trim(_part) : _part;
    schema = schema.resolve({
      context: context,
      parent: parent,
      value: value
    });

    if (schema.innerType) {
      var idx = isArray ? parseInt(part, 10) : 0;

      if (value && idx >= value.length) {
        throw new Error("Yup.reach cannot resolve an array item at index: ".concat(_part, ", in the path: ").concat(path, ". ") + "because there is no value at that index. ");
      }

      parent = value;
      value = value && value[idx];
      schema = schema.innerType;
    } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
    // in these cases the current part is the next schema and should be processed
    // in this iteration. For cases where the index signature is included this
    // check will fail and we'll handle the `child` part on the next iteration like normal


    if (!isArray) {
      if (!schema.fields || !schema.fields[part]) throw new Error("The schema does not contain the path: ".concat(path, ". ") + "(failed at: ".concat(lastPartDebug, " which is a type: \"").concat(schema._type, "\")"));
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }

    lastPart = part;
    lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
  });
  return {
    schema: schema,
    parent: parent,
    parentPath: lastPart
  };
}

var ReferenceSet = /*#__PURE__*/function () {
  function ReferenceSet() {
    _classCallCheck2(this, ReferenceSet);

    this.list = void 0;
    this.refs = void 0;
    this.list = new Set();
    this.refs = new Map();
  }

  _createClass2(ReferenceSet, [{
    key: "size",
    get: function get() {
      return this.list.size + this.refs.size;
    }
  }, {
    key: "describe",
    value: function describe() {
      var description = [];

      var _iterator55 = _createForOfIteratorHelper(this.list),
          _step55;

      try {
        for (_iterator55.s(); !(_step55 = _iterator55.n()).done;) {
          var item = _step55.value;
          description.push(item);
        }
      } catch (err) {
        _iterator55.e(err);
      } finally {
        _iterator55.f();
      }

      var _iterator56 = _createForOfIteratorHelper(this.refs),
          _step56;

      try {
        for (_iterator56.s(); !(_step56 = _iterator56.n()).done;) {
          var _step56$value = _slicedToArray2(_step56.value, 2),
              _ref75 = _step56$value[1];

          description.push(_ref75.describe());
        }
      } catch (err) {
        _iterator56.e(err);
      } finally {
        _iterator56.f();
      }

      return description;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      return Array.from(this.list).concat(Array.from(this.refs.values()));
    }
  }, {
    key: "resolveAll",
    value: function resolveAll(resolve) {
      return this.toArray().reduce(function (acc, e) {
        return acc.concat(Reference.isRef(e) ? resolve(e) : e);
      }, []);
    }
  }, {
    key: "add",
    value: function add(value) {
      Reference.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
    }
  }, {
    key: "delete",
    value: function _delete(value) {
      Reference.isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
    }
  }, {
    key: "clone",
    value: function clone() {
      var next = new ReferenceSet();
      next.list = new Set(this.list);
      next.refs = new Map(this.refs);
      return next;
    }
  }, {
    key: "merge",
    value: function merge(newItems, removeItems) {
      var next = this.clone();
      newItems.list.forEach(function (value) {
        return next.add(value);
      });
      newItems.refs.forEach(function (value) {
        return next.add(value);
      });
      removeItems.list.forEach(function (value) {
        return next.delete(value);
      });
      removeItems.refs.forEach(function (value) {
        return next.delete(value);
      });
      return next;
    }
  }]);

  return ReferenceSet;
}();

function _extends$5() {
  _extends$5 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$5.apply(this, arguments);
}

var BaseSchema = /*#__PURE__*/function () {
  function BaseSchema(options) {
    var _this37 = this;

    _classCallCheck2(this, BaseSchema);

    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this._typeError = void 0;
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(function () {
      _this37.typeError(mixed.notType);
    });
    this.type = (options == null ? void 0 : options.type) || 'mixed';
    this.spec = _extends$5({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      nullable: false,
      presence: 'optional'
    }, options == null ? void 0 : options.spec);
  } // TODO: remove


  _createClass2(BaseSchema, [{
    key: "_type",
    get: function get() {
      return this.type;
    }
  }, {
    key: "_typeCheck",
    value: function _typeCheck(_value) {
      return true;
    }
  }, {
    key: "clone",
    value: function clone(spec) {
      if (this._mutate) {
        if (spec) Object.assign(this.spec, spec);
        return this;
      } // if the nested value is a schema we can skip cloning, since
      // they are already immutable


      var next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly

      next.type = this.type;
      next._typeError = this._typeError;
      next._whitelistError = this._whitelistError;
      next._blacklistError = this._blacklistError;
      next._whitelist = this._whitelist.clone();
      next._blacklist = this._blacklist.clone();
      next.exclusiveTests = _extends$5({}, this.exclusiveTests); // @ts-expect-error this is readonly

      next.deps = _toConsumableArray2(this.deps);
      next.conditions = _toConsumableArray2(this.conditions);
      next.tests = _toConsumableArray2(this.tests);
      next.transforms = _toConsumableArray2(this.transforms);
      next.spec = _clone(_extends$5({}, this.spec, spec));
      return next;
    }
  }, {
    key: "label",
    value: function label(_label) {
      var next = this.clone();
      next.spec.label = _label;
      return next;
    }
  }, {
    key: "meta",
    value: function meta() {
      if (arguments.length === 0) return this.spec.meta;
      var next = this.clone();
      next.spec.meta = Object.assign(next.spec.meta || {}, arguments.length <= 0 ? undefined : arguments[0]);
      return next;
    } // withContext<TContext extends AnyObject>(): BaseSchema<
    //   TCast,
    //   TContext,
    //   TOutput
    // > {
    //   return this as any;
    // }

  }, {
    key: "withMutation",
    value: function withMutation(fn) {
      var before = this._mutate;
      this._mutate = true;
      var result = fn(this);
      this._mutate = before;
      return result;
    }
  }, {
    key: "concat",
    value: function concat(schema) {
      if (!schema || schema === this) return this;
      if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError("You cannot `concat()` schema's of different types: ".concat(this.type, " and ").concat(schema.type));
      var base = this;
      var combined = schema.clone();

      var mergedSpec = _extends$5({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
      //   mergedSpec.nullable = base.spec.nullable;
      // if (combined.spec.presence === UNSET)
      //   mergedSpec.presence = base.spec.presence;


      combined.spec = mergedSpec;
      combined._typeError || (combined._typeError = base._typeError);
      combined._whitelistError || (combined._whitelistError = base._whitelistError);
      combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
      // precedence in case of conflicts)

      combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
      combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests

      combined.tests = base.tests;
      combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
      // the deduping logic is consistent

      combined.withMutation(function (next) {
        schema.tests.forEach(function (fn) {
          next.test(fn.OPTIONS);
        });
      });
      combined.transforms = [].concat(_toConsumableArray2(base.transforms), _toConsumableArray2(combined.transforms));
      return combined;
    }
  }, {
    key: "isType",
    value: function isType(v) {
      if (this.spec.nullable && v === null) return true;
      return this._typeCheck(v);
    }
  }, {
    key: "resolve",
    value: function resolve(options) {
      var schema = this;

      if (schema.conditions.length) {
        var conditions = schema.conditions;
        schema = schema.clone();
        schema.conditions = [];
        schema = conditions.reduce(function (schema, condition) {
          return condition.resolve(schema, options);
        }, schema);
        schema = schema.resolve(options);
      }

      return schema;
    }
    /**
     *
     * @param {*} value
     * @param {Object} options
     * @param {*=} options.parent
     * @param {*=} options.context
     */

  }, {
    key: "cast",
    value: function cast(value) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var resolvedSchema = this.resolve(_extends$5({
        value: value
      }, options));

      var result = resolvedSchema._cast(value, options);

      if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
        var formattedValue = printValue(value);
        var formattedResult = printValue(result);
        throw new TypeError("The value of ".concat(options.path || 'field', " could not be cast to a value ") + "that satisfies the schema type: \"".concat(resolvedSchema._type, "\". \n\n") + "attempted value: ".concat(formattedValue, " \n") + (formattedResult !== formattedValue ? "result of cast: ".concat(formattedResult) : ''));
      }

      return result;
    }
  }, {
    key: "_cast",
    value: function _cast(rawValue, _options) {
      var _this38 = this;

      var value = rawValue === undefined ? rawValue : this.transforms.reduce(function (value, fn) {
        return fn.call(_this38, value, rawValue, _this38);
      }, rawValue);

      if (value === undefined) {
        value = this.getDefault();
      }

      return value;
    }
  }, {
    key: "_validate",
    value: function _validate(_value) {
      var _this39 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 ? arguments[2] : undefined;
      var sync = options.sync,
          path = options.path,
          _options$from = options.from,
          from = _options$from === void 0 ? [] : _options$from,
          _options$originalValu = options.originalValue,
          originalValue = _options$originalValu === void 0 ? _value : _options$originalValu,
          _options$strict = options.strict,
          strict = _options$strict === void 0 ? this.spec.strict : _options$strict,
          _options$abortEarly = options.abortEarly,
          abortEarly = _options$abortEarly === void 0 ? this.spec.abortEarly : _options$abortEarly;
      var value = _value;

      if (!strict) {
        // this._validating = true;
        value = this._cast(value, _extends$5({
          assert: false
        }, options)); // this._validating = false;
      } // value is cast, we can check if it meets type requirements


      var args = {
        value: value,
        path: path,
        options: options,
        originalValue: originalValue,
        schema: this,
        label: this.spec.label,
        sync: sync,
        from: from
      };
      var initialTests = [];
      if (this._typeError) initialTests.push(this._typeError);
      var finalTests = [];
      if (this._whitelistError) finalTests.push(this._whitelistError);
      if (this._blacklistError) finalTests.push(this._blacklistError);
      runTests({
        args: args,
        value: value,
        path: path,
        sync: sync,
        tests: initialTests,
        endEarly: abortEarly
      }, function (err) {
        if (err) return void cb(err, value);
        runTests({
          tests: _this39.tests.concat(finalTests),
          args: args,
          path: path,
          sync: sync,
          value: value,
          endEarly: abortEarly
        }, cb);
      });
    }
  }, {
    key: "validate",
    value: function validate(value, options, maybeCb) {
      var schema = this.resolve(_extends$5({}, options, {
        value: value
      })); // callback case is for nested validations

      return typeof maybeCb === 'function' ? schema._validate(value, options, maybeCb) : new Promise(function (resolve, reject) {
        return schema._validate(value, options, function (err, value) {
          if (err) reject(err);else resolve(value);
        });
      });
    }
  }, {
    key: "validateSync",
    value: function validateSync(value, options) {
      var schema = this.resolve(_extends$5({}, options, {
        value: value
      }));
      var result;

      schema._validate(value, _extends$5({}, options, {
        sync: true
      }), function (err, value) {
        if (err) throw err;
        result = value;
      });

      return result;
    }
  }, {
    key: "isValid",
    value: function isValid(value, options) {
      return this.validate(value, options).then(function () {
        return true;
      }, function (err) {
        if (ValidationError.isError(err)) return false;
        throw err;
      });
    }
  }, {
    key: "isValidSync",
    value: function isValidSync(value, options) {
      try {
        this.validateSync(value, options);
        return true;
      } catch (err) {
        if (ValidationError.isError(err)) return false;
        throw err;
      }
    }
  }, {
    key: "_getDefault",
    value: function _getDefault() {
      var defaultValue = this.spec.default;

      if (defaultValue == null) {
        return defaultValue;
      }

      return typeof defaultValue === 'function' ? defaultValue.call(this) : _clone(defaultValue);
    }
  }, {
    key: "getDefault",
    value: function getDefault(options) {
      var schema = this.resolve(options || {});
      return schema._getDefault();
    }
  }, {
    key: "default",
    value: function _default(def) {
      if (arguments.length === 0) {
        return this._getDefault();
      }

      var next = this.clone({
        default: def
      });
      return next;
    }
  }, {
    key: "strict",
    value: function strict() {
      var isStrict = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var next = this.clone();
      next.spec.strict = isStrict;
      return next;
    }
  }, {
    key: "_isPresent",
    value: function _isPresent(value) {
      return value != null;
    }
  }, {
    key: "defined",
    value: function defined() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mixed.defined;
      return this.test({
        message: message,
        name: 'defined',
        exclusive: true,
        test: function test(value) {
          return value !== undefined;
        }
      });
    }
  }, {
    key: "required",
    value: function required() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : mixed.required;
      return this.clone({
        presence: 'required'
      }).withMutation(function (s) {
        return s.test({
          message: message,
          name: 'required',
          exclusive: true,
          test: function test(value) {
            return this.schema._isPresent(value);
          }
        });
      });
    }
  }, {
    key: "notRequired",
    value: function notRequired() {
      var next = this.clone({
        presence: 'optional'
      });
      next.tests = next.tests.filter(function (test) {
        return test.OPTIONS.name !== 'required';
      });
      return next;
    }
  }, {
    key: "nullable",
    value: function nullable() {
      var isNullable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var next = this.clone({
        nullable: isNullable !== false
      });
      return next;
    }
  }, {
    key: "transform",
    value: function transform(fn) {
      var next = this.clone();
      next.transforms.push(fn);
      return next;
    }
    /**
     * Adds a test function to the schema's queue of tests.
     * tests can be exclusive or non-exclusive.
     *
     * - exclusive tests, will replace any existing tests of the same name.
     * - non-exclusive: can be stacked
     *
     * If a non-exclusive test is added to a schema with an exclusive test of the same name
     * the exclusive test is removed and further tests of the same name will be stacked.
     *
     * If an exclusive test is added to a schema with non-exclusive tests of the same name
     * the previous tests are removed and further tests of the same name will replace each other.
     */

  }, {
    key: "test",
    value: function test() {
      var opts;

      if (arguments.length === 1) {
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'function') {
          opts = {
            test: arguments.length <= 0 ? undefined : arguments[0]
          };
        } else {
          opts = arguments.length <= 0 ? undefined : arguments[0];
        }
      } else if (arguments.length === 2) {
        opts = {
          name: arguments.length <= 0 ? undefined : arguments[0],
          test: arguments.length <= 1 ? undefined : arguments[1]
        };
      } else {
        opts = {
          name: arguments.length <= 0 ? undefined : arguments[0],
          message: arguments.length <= 1 ? undefined : arguments[1],
          test: arguments.length <= 2 ? undefined : arguments[2]
        };
      }

      if (opts.message === undefined) opts.message = mixed.default;
      if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
      var next = this.clone();
      var validate = createValidation(opts);
      var isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;

      if (opts.exclusive) {
        if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
      }

      if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
      next.tests = next.tests.filter(function (fn) {
        if (fn.OPTIONS.name === opts.name) {
          if (isExclusive) return false;
          if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
        }

        return true;
      });
      next.tests.push(validate);
      return next;
    }
  }, {
    key: "when",
    value: function when(keys, options) {
      if (!Array.isArray(keys) && typeof keys !== 'string') {
        options = keys;
        keys = '.';
      }

      var next = this.clone();
      var deps = toArray(keys).map(function (key) {
        return new Reference(key);
      });
      deps.forEach(function (dep) {
        // @ts-ignore
        if (dep.isSibling) next.deps.push(dep.key);
      });
      next.conditions.push(new Condition(deps, options));
      return next;
    }
  }, {
    key: "typeError",
    value: function typeError(message) {
      var next = this.clone();
      next._typeError = createValidation({
        message: message,
        name: 'typeError',
        test: function test(value) {
          if (value !== undefined && !this.schema.isType(value)) return this.createError({
            params: {
              type: this.schema._type
            }
          });
          return true;
        }
      });
      return next;
    }
  }, {
    key: "oneOf",
    value: function oneOf(enums) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : mixed.oneOf;
      var next = this.clone();
      enums.forEach(function (val) {
        next._whitelist.add(val);

        next._blacklist.delete(val);
      });
      next._whitelistError = createValidation({
        message: message,
        name: 'oneOf',
        test: function test(value) {
          if (value === undefined) return true;
          var valids = this.schema._whitelist;
          var resolved = valids.resolveAll(this.resolve);
          return resolved.includes(value) ? true : this.createError({
            params: {
              values: valids.toArray().join(', '),
              resolved: resolved
            }
          });
        }
      });
      return next;
    }
  }, {
    key: "notOneOf",
    value: function notOneOf(enums) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : mixed.notOneOf;
      var next = this.clone();
      enums.forEach(function (val) {
        next._blacklist.add(val);

        next._whitelist.delete(val);
      });
      next._blacklistError = createValidation({
        message: message,
        name: 'notOneOf',
        test: function test(value) {
          var invalids = this.schema._blacklist;
          var resolved = invalids.resolveAll(this.resolve);
          if (resolved.includes(value)) return this.createError({
            params: {
              values: invalids.toArray().join(', '),
              resolved: resolved
            }
          });
          return true;
        }
      });
      return next;
    }
  }, {
    key: "strip",
    value: function strip() {
      var _strip = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var next = this.clone();
      next.spec.strip = _strip;
      return next;
    }
  }, {
    key: "describe",
    value: function describe() {
      var next = this.clone();
      var _next$spec = next.spec,
          label = _next$spec.label,
          meta = _next$spec.meta;
      var description = {
        meta: meta,
        label: label,
        type: next.type,
        oneOf: next._whitelist.describe(),
        notOneOf: next._blacklist.describe(),
        tests: next.tests.map(function (fn) {
          return {
            name: fn.OPTIONS.name,
            params: fn.OPTIONS.params
          };
        }).filter(function (n, idx, list) {
          return list.findIndex(function (c) {
            return c.name === n.name;
          }) === idx;
        })
      };
      return description;
    }
  }]);

  return BaseSchema;
}(); // eslint-disable-next-line @typescript-eslint/no-unused-vars
// @ts-expect-error


BaseSchema.prototype.__isYupSchema__ = true;

var _loop3 = function _loop3() {
  var method = _arr2[_i19];

  BaseSchema.prototype["".concat(method, "At")] = function (path, value) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var _getIn = getIn(this, path, value, options.context),
        parent = _getIn.parent,
        parentPath = _getIn.parentPath,
        schema = _getIn.schema;

    return schema[method](parent && parent[parentPath], _extends$5({}, options, {
      parent: parent,
      path: path
    }));
  };
};

for (var _i19 = 0, _arr2 = ['validate', 'validateSync']; _i19 < _arr2.length; _i19++) {
  _loop3();
}

for (var _i20 = 0, _arr3 = ['equals', 'is']; _i20 < _arr3.length; _i20++) {
  var alias = _arr3[_i20];
  BaseSchema.prototype[alias] = BaseSchema.prototype.oneOf;
}

for (var _i21 = 0, _arr4 = ['not', 'nope']; _i21 < _arr4.length; _i21++) {
  var _alias = _arr4[_i21];
  BaseSchema.prototype[_alias] = BaseSchema.prototype.notOneOf;
}

BaseSchema.prototype.optional = BaseSchema.prototype.notRequired;

var isAbsent = function isAbsent(value) {
  return value == null;
};

var rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line

var rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line

var rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

var isTrimmed = function isTrimmed(value) {
  return isAbsent(value) || value === value.trim();
};

var objStringTag = {}.toString();

function create$2() {
  return new StringSchema();
}

var StringSchema = /*#__PURE__*/function (_BaseSchema) {
  _inherits2(StringSchema, _BaseSchema);

  var _super52 = _createSuper2(StringSchema);

  function StringSchema() {
    var _this40;

    _classCallCheck2(this, StringSchema);

    _this40 = _super52.call(this, {
      type: 'string'
    });

    _this40.withMutation(function () {
      _this40.transform(function (value) {
        if (this.isType(value)) return value;
        if (Array.isArray(value)) return value;
        var strValue = value != null && value.toString ? value.toString() : value;
        if (strValue === objStringTag) return value;
        return strValue;
      });
    });

    return _this40;
  }

  _createClass2(StringSchema, [{
    key: "_typeCheck",
    value: function _typeCheck(value) {
      if (value instanceof String) value = value.valueOf();
      return typeof value === 'string';
    }
  }, {
    key: "_isPresent",
    value: function _isPresent(value) {
      return _get3(_getPrototypeOf2(StringSchema.prototype), "_isPresent", this).call(this, value) && !!value.length;
    }
  }, {
    key: "length",
    value: function length(_length) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : string.length;
      return this.test({
        message: message,
        name: 'length',
        exclusive: true,
        params: {
          length: _length
        },
        test: function test(value) {
          return isAbsent(value) || value.length === this.resolve(_length);
        }
      });
    }
  }, {
    key: "min",
    value: function min(_min) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : string.min;
      return this.test({
        message: message,
        name: 'min',
        exclusive: true,
        params: {
          min: _min
        },
        test: function test(value) {
          return isAbsent(value) || value.length >= this.resolve(_min);
        }
      });
    }
  }, {
    key: "max",
    value: function max(_max) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : string.max;
      return this.test({
        name: 'max',
        exclusive: true,
        message: message,
        params: {
          max: _max
        },
        test: function test(value) {
          return isAbsent(value) || value.length <= this.resolve(_max);
        }
      });
    }
  }, {
    key: "matches",
    value: function matches(regex, options) {
      var excludeEmptyString = false;
      var message;
      var name;

      if (options) {
        if (typeof options === 'object') {
          var _options$excludeEmpty = options.excludeEmptyString;
          excludeEmptyString = _options$excludeEmpty === void 0 ? false : _options$excludeEmpty;
          message = options.message;
          name = options.name;
        } else {
          message = options;
        }
      }

      return this.test({
        name: name || 'matches',
        message: message || string.matches,
        params: {
          regex: regex
        },
        test: function test(value) {
          return isAbsent(value) || value === '' && excludeEmptyString || value.search(regex) !== -1;
        }
      });
    }
  }, {
    key: "email",
    value: function email() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.email;
      return this.matches(rEmail, {
        name: 'email',
        message: message,
        excludeEmptyString: true
      });
    }
  }, {
    key: "url",
    value: function url() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.url;
      return this.matches(rUrl, {
        name: 'url',
        message: message,
        excludeEmptyString: true
      });
    }
  }, {
    key: "uuid",
    value: function uuid() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.uuid;
      return this.matches(rUUID, {
        name: 'uuid',
        message: message,
        excludeEmptyString: false
      });
    } //-- transforms --

  }, {
    key: "ensure",
    value: function ensure() {
      return this.default('').transform(function (val) {
        return val === null ? '' : val;
      });
    }
  }, {
    key: "trim",
    value: function trim() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.trim;
      return this.transform(function (val) {
        return val != null ? val.trim() : val;
      }).test({
        message: message,
        name: 'trim',
        test: isTrimmed
      });
    }
  }, {
    key: "lowercase",
    value: function lowercase() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.lowercase;
      return this.transform(function (value) {
        return !isAbsent(value) ? value.toLowerCase() : value;
      }).test({
        message: message,
        name: 'string_case',
        exclusive: true,
        test: function test(value) {
          return isAbsent(value) || value === value.toLowerCase();
        }
      });
    }
  }, {
    key: "uppercase",
    value: function uppercase() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : string.uppercase;
      return this.transform(function (value) {
        return !isAbsent(value) ? value.toUpperCase() : value;
      }).test({
        message: message,
        name: 'string_case',
        exclusive: true,
        test: function test(value) {
          return isAbsent(value) || value === value.toUpperCase();
        }
      });
    }
  }]);

  return StringSchema;
}(BaseSchema);

create$2.prototype = StringSchema.prototype; //
// String Interfaces
//

var isNaN$1 = function isNaN$1(value) {
  return value != +value;
};

function create$1() {
  return new NumberSchema();
}

var NumberSchema = /*#__PURE__*/function (_BaseSchema2) {
  _inherits2(NumberSchema, _BaseSchema2);

  var _super53 = _createSuper2(NumberSchema);

  function NumberSchema() {
    var _this41;

    _classCallCheck2(this, NumberSchema);

    _this41 = _super53.call(this, {
      type: 'number'
    });

    _this41.withMutation(function () {
      _this41.transform(function (value) {
        var parsed = value;

        if (typeof parsed === 'string') {
          parsed = parsed.replace(/\s/g, '');
          if (parsed === '') return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings

          parsed = +parsed;
        }

        if (this.isType(parsed)) return parsed;
        return parseFloat(parsed);
      });
    });

    return _this41;
  }

  _createClass2(NumberSchema, [{
    key: "_typeCheck",
    value: function _typeCheck(value) {
      if (value instanceof Number) value = value.valueOf();
      return typeof value === 'number' && !isNaN$1(value);
    }
  }, {
    key: "min",
    value: function min(_min2) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : number.min;
      return this.test({
        message: message,
        name: 'min',
        exclusive: true,
        params: {
          min: _min2
        },
        test: function test(value) {
          return isAbsent(value) || value >= this.resolve(_min2);
        }
      });
    }
  }, {
    key: "max",
    value: function max(_max2) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : number.max;
      return this.test({
        message: message,
        name: 'max',
        exclusive: true,
        params: {
          max: _max2
        },
        test: function test(value) {
          return isAbsent(value) || value <= this.resolve(_max2);
        }
      });
    }
  }, {
    key: "lessThan",
    value: function lessThan(less) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : number.lessThan;
      return this.test({
        message: message,
        name: 'max',
        exclusive: true,
        params: {
          less: less
        },
        test: function test(value) {
          return isAbsent(value) || value < this.resolve(less);
        }
      });
    }
  }, {
    key: "moreThan",
    value: function moreThan(more) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : number.moreThan;
      return this.test({
        message: message,
        name: 'min',
        exclusive: true,
        params: {
          more: more
        },
        test: function test(value) {
          return isAbsent(value) || value > this.resolve(more);
        }
      });
    }
  }, {
    key: "positive",
    value: function positive() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : number.positive;
      return this.moreThan(0, msg);
    }
  }, {
    key: "negative",
    value: function negative() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : number.negative;
      return this.lessThan(0, msg);
    }
  }, {
    key: "integer",
    value: function integer() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : number.integer;
      return this.test({
        name: 'integer',
        message: message,
        test: function test(val) {
          return isAbsent(val) || Number.isInteger(val);
        }
      });
    }
  }, {
    key: "truncate",
    value: function truncate() {
      return this.transform(function (value) {
        return !isAbsent(value) ? value | 0 : value;
      });
    }
  }, {
    key: "round",
    value: function round(method) {
      var _method;

      var avail = ['ceil', 'floor', 'round', 'trunc'];
      method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round'; // this exists for symemtry with the new Math.trunc

      if (method === 'trunc') return this.truncate();
      if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
      return this.transform(function (value) {
        return !isAbsent(value) ? Math[method](value) : value;
      });
    }
  }]);

  return NumberSchema;
}(BaseSchema);

create$1.prototype = NumberSchema.prototype; //
// Number Interfaces
//

/* eslint-disable */

/**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */
//              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm

var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;

function parseIsoDate(date) {
  var numericKeys = [1, 4, 5, 6, 7, 10, 11],
      minutesOffset = 0,
      timestamp,
      struct;

  if (struct = isoReg.exec(date)) {
    // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
    for (var i = 0, k; k = numericKeys[i]; ++i) {
      struct[k] = +struct[k] || 0;
    } // allow undefined days and months


    struct[2] = (+struct[2] || 1) - 1;
    struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds

    struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time

    if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);else {
      if (struct[8] !== 'Z' && struct[9] !== undefined) {
        minutesOffset = struct[10] * 60 + struct[11];
        if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
      }

      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
    }
  } else timestamp = Date.parse ? Date.parse(date) : NaN;

  return timestamp;
} // @ts-ignore


var invalidDate = new Date('');

var isDate = function isDate(obj) {
  return Object.prototype.toString.call(obj) === '[object Date]';
};

var DateSchema = /*#__PURE__*/function (_BaseSchema3) {
  _inherits2(DateSchema, _BaseSchema3);

  var _super54 = _createSuper2(DateSchema);

  function DateSchema() {
    var _this42;

    _classCallCheck2(this, DateSchema);

    _this42 = _super54.call(this, {
      type: 'date'
    });

    _this42.withMutation(function () {
      _this42.transform(function (value) {
        if (this.isType(value)) return value;
        value = parseIsoDate(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.

        return !isNaN(value) ? new Date(value) : invalidDate;
      });
    });

    return _this42;
  }

  _createClass2(DateSchema, [{
    key: "_typeCheck",
    value: function _typeCheck(v) {
      return isDate(v) && !isNaN(v.getTime());
    }
  }, {
    key: "prepareParam",
    value: function prepareParam(ref, name) {
      var param;

      if (!Reference.isRef(ref)) {
        var cast = this.cast(ref);
        if (!this._typeCheck(cast)) throw new TypeError("`".concat(name, "` must be a Date or a value that can be `cast()` to a Date"));
        param = cast;
      } else {
        param = ref;
      }

      return param;
    }
  }, {
    key: "min",
    value: function min(_min3) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : date.min;
      var limit = this.prepareParam(_min3, 'min');
      return this.test({
        message: message,
        name: 'min',
        exclusive: true,
        params: {
          min: _min3
        },
        test: function test(value) {
          return isAbsent(value) || value >= this.resolve(limit);
        }
      });
    }
  }, {
    key: "max",
    value: function max(_max3) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : date.max;
      var limit = this.prepareParam(_max3, 'max');
      return this.test({
        message: message,
        name: 'max',
        exclusive: true,
        params: {
          max: _max3
        },
        test: function test(value) {
          return isAbsent(value) || value <= this.resolve(limit);
        }
      });
    }
  }]);

  return DateSchema;
}(BaseSchema);

DateSchema.INVALID_DATE = invalidDate;

function sortFields(fields) {
  var excludedEdges = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var edges = [];
  var nodes = new Set();
  var excludes = new Set(excludedEdges.map(function (_ref76) {
    var _ref77 = _slicedToArray2(_ref76, 2),
        a = _ref77[0],
        b = _ref77[1];

    return "".concat(a, "-").concat(b);
  }));

  function addNode(depPath, key) {
    var node = split(depPath)[0];
    nodes.add(node);
    if (!excludes.has("".concat(key, "-").concat(node))) edges.push([key, node]);
  }

  var _loop4 = function _loop4(key) {
    if (has$1(fields, key)) {
      var value = fields[key];
      nodes.add(key);
      if (Reference.isRef(value) && value.isSibling) addNode(value.path, key);else if (isSchema(value) && 'deps' in value) value.deps.forEach(function (path) {
        return addNode(path, key);
      });
    }
  };

  for (var key in fields) {
    _loop4(key);
  }

  return toposort.array(Array.from(nodes), edges).reverse();
}

function findIndex$1(arr, err) {
  var idx = Infinity;
  arr.some(function (key, ii) {
    var _err$path;

    if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
      idx = ii;
      return true;
    }
  });
  return idx;
}

function sortByKeyOrder(keys) {
  return function (a, b) {
    return findIndex$1(keys, a) - findIndex$1(keys, b);
  };
}

function _extends$4() {
  _extends$4 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$4.apply(this, arguments);
}

var isObject$1 = function isObject$1(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

function unknown(ctx, value) {
  var known = Object.keys(ctx.fields);
  return Object.keys(value).filter(function (key) {
    return known.indexOf(key) === -1;
  });
}

var defaultSort = sortByKeyOrder([]);

var ObjectSchema = /*#__PURE__*/function (_BaseSchema4) {
  _inherits2(ObjectSchema, _BaseSchema4);

  var _super55 = _createSuper2(ObjectSchema);

  function ObjectSchema(spec) {
    var _this43;

    _classCallCheck2(this, ObjectSchema);

    _this43 = _super55.call(this, {
      type: 'object'
    });
    _this43.fields = Object.create(null);
    _this43._sortErrors = defaultSort;
    _this43._nodes = [];
    _this43._excludedEdges = [];

    _this43.withMutation(function () {
      _this43.transform(function coerce(value) {
        if (typeof value === 'string') {
          try {
            value = JSON.parse(value);
          } catch (err) {
            value = null;
          }
        }

        if (this.isType(value)) return value;
        return null;
      });

      if (spec) {
        _this43.shape(spec);
      }
    });

    return _this43;
  }

  _createClass2(ObjectSchema, [{
    key: "_typeCheck",
    value: function _typeCheck(value) {
      return isObject$1(value) || typeof value === 'function';
    }
  }, {
    key: "_cast",
    value: function _cast(_value) {
      var _this44 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _options$stripUnknown;

      var value = _get3(_getPrototypeOf2(ObjectSchema.prototype), "_cast", this).call(this, _value, options); //should ignore nulls here


      if (value === undefined) return this.getDefault();
      if (!this._typeCheck(value)) return value;
      var fields = this.fields;
      var strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;

      var props = this._nodes.concat(Object.keys(value).filter(function (v) {
        return _this44._nodes.indexOf(v) === -1;
      }));

      var intermediateValue = {}; // is filled during the transform below

      var innerOptions = _extends$4({}, options, {
        parent: intermediateValue,
        __validating: options.__validating || false
      });

      var isChanged = false;

      var _iterator57 = _createForOfIteratorHelper(props),
          _step57;

      try {
        for (_iterator57.s(); !(_step57 = _iterator57.n()).done;) {
          var prop = _step57.value;
          var field = fields[prop];
          var exists = has$1(value, prop);

          if (field) {
            var fieldValue = void 0;
            var inputValue = value[prop]; // safe to mutate since this is fired in sequence

            innerOptions.path = (options.path ? "".concat(options.path, ".") : '') + prop; // innerOptions.value = value[prop];

            field = field.resolve({
              value: inputValue,
              context: options.context,
              parent: intermediateValue
            });
            var fieldSpec = 'spec' in field ? field.spec : undefined;
            var strict = fieldSpec == null ? void 0 : fieldSpec.strict;

            if (fieldSpec == null ? void 0 : fieldSpec.strip) {
              isChanged = isChanged || prop in value;
              continue;
            }

            fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
            field.cast(value[prop], innerOptions) : value[prop];

            if (fieldValue !== undefined) {
              intermediateValue[prop] = fieldValue;
            }
          } else if (exists && !strip) {
            intermediateValue[prop] = value[prop];
          }

          if (intermediateValue[prop] !== value[prop]) {
            isChanged = true;
          }
        }
      } catch (err) {
        _iterator57.e(err);
      } finally {
        _iterator57.f();
      }

      return isChanged ? intermediateValue : value;
    }
  }, {
    key: "_validate",
    value: function _validate(_value) {
      var _this45 = this;

      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callback = arguments.length > 2 ? arguments[2] : undefined;
      var errors = [];
      var sync = opts.sync,
          _opts$from = opts.from,
          from = _opts$from === void 0 ? [] : _opts$from,
          _opts$originalValue = opts.originalValue,
          originalValue = _opts$originalValue === void 0 ? _value : _opts$originalValue,
          _opts$abortEarly = opts.abortEarly,
          abortEarly = _opts$abortEarly === void 0 ? this.spec.abortEarly : _opts$abortEarly,
          _opts$recursive = opts.recursive,
          recursive = _opts$recursive === void 0 ? this.spec.recursive : _opts$recursive;
      from = [{
        schema: this,
        value: originalValue
      }].concat(_toConsumableArray2(from)); // this flag is needed for handling `strict` correctly in the context of
      // validation vs just casting. e.g strict() on a field is only used when validating

      opts.__validating = true;
      opts.originalValue = originalValue;
      opts.from = from;

      _get3(_getPrototypeOf2(ObjectSchema.prototype), "_validate", this).call(this, _value, opts, function (err, value) {
        if (err) {
          if (!ValidationError.isError(err) || abortEarly) {
            return void callback(err, value);
          }

          errors.push(err);
        }

        if (!recursive || !isObject$1(value)) {
          callback(errors[0] || null, value);
          return;
        }

        originalValue = originalValue || value;

        var tests = _this45._nodes.map(function (key) {
          return function (_, cb) {
            var path = key.indexOf('.') === -1 ? (opts.path ? "".concat(opts.path, ".") : '') + key : "".concat(opts.path || '', "[\"").concat(key, "\"]");
            var field = _this45.fields[key];

            if (field && 'validate' in field) {
              field.validate(value[key], _extends$4({}, opts, {
                // @ts-ignore
                path: path,
                from: from,
                // inner fields are always strict:
                // 1. this isn't strict so the casting will also have cast inner values
                // 2. this is strict in which case the nested values weren't cast either
                strict: true,
                parent: value,
                originalValue: originalValue[key]
              }), cb);
              return;
            }

            cb(null);
          };
        });

        runTests({
          sync: sync,
          tests: tests,
          value: value,
          errors: errors,
          endEarly: abortEarly,
          sort: _this45._sortErrors,
          path: opts.path
        }, callback);
      });
    }
  }, {
    key: "clone",
    value: function clone(spec) {
      var next = _get3(_getPrototypeOf2(ObjectSchema.prototype), "clone", this).call(this, spec);

      next.fields = _extends$4({}, this.fields);
      next._nodes = this._nodes;
      next._excludedEdges = this._excludedEdges;
      next._sortErrors = this._sortErrors;
      return next;
    }
  }, {
    key: "concat",
    value: function concat(schema) {
      var _this46 = this;

      var next = _get3(_getPrototypeOf2(ObjectSchema.prototype), "concat", this).call(this, schema);

      var nextFields = next.fields;

      for (var _i22 = 0, _Object$entries = Object.entries(this.fields); _i22 < _Object$entries.length; _i22++) {
        var _Object$entries$_i = _slicedToArray2(_Object$entries[_i22], 2),
            field = _Object$entries$_i[0],
            schemaOrRef = _Object$entries$_i[1];

        var target = nextFields[field];

        if (target === undefined) {
          nextFields[field] = schemaOrRef;
        } else if (target instanceof BaseSchema && schemaOrRef instanceof BaseSchema) {
          nextFields[field] = schemaOrRef.concat(target);
        }
      }

      return next.withMutation(function () {
        return next.shape(nextFields, _this46._excludedEdges);
      });
    }
  }, {
    key: "getDefaultFromShape",
    value: function getDefaultFromShape() {
      var _this47 = this;

      var dft = {};

      this._nodes.forEach(function (key) {
        var field = _this47.fields[key];
        dft[key] = 'default' in field ? field.getDefault() : undefined;
      });

      return dft;
    }
  }, {
    key: "_getDefault",
    value: function _getDefault() {
      if ('default' in this.spec) {
        return _get3(_getPrototypeOf2(ObjectSchema.prototype), "_getDefault", this).call(this);
      } // if there is no default set invent one


      if (!this._nodes.length) {
        return undefined;
      }

      return this.getDefaultFromShape();
    }
  }, {
    key: "shape",
    value: function shape(additions) {
      var excludes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var next = this.clone();
      var fields = Object.assign(next.fields, additions);
      next.fields = fields;
      next._sortErrors = sortByKeyOrder(Object.keys(fields));

      if (excludes.length) {
        // this is a convenience for when users only supply a single pair
        if (!Array.isArray(excludes[0])) excludes = [excludes];
        next._excludedEdges = [].concat(_toConsumableArray2(next._excludedEdges), _toConsumableArray2(excludes));
      }

      next._nodes = sortFields(fields, next._excludedEdges);
      return next;
    }
  }, {
    key: "pick",
    value: function pick(keys) {
      var picked = {};

      var _iterator58 = _createForOfIteratorHelper(keys),
          _step58;

      try {
        for (_iterator58.s(); !(_step58 = _iterator58.n()).done;) {
          var key = _step58.value;
          if (this.fields[key]) picked[key] = this.fields[key];
        }
      } catch (err) {
        _iterator58.e(err);
      } finally {
        _iterator58.f();
      }

      return this.clone().withMutation(function (next) {
        next.fields = {};
        return next.shape(picked);
      });
    }
  }, {
    key: "omit",
    value: function omit(keys) {
      var next = this.clone();
      var fields = next.fields;
      next.fields = {};

      var _iterator59 = _createForOfIteratorHelper(keys),
          _step59;

      try {
        for (_iterator59.s(); !(_step59 = _iterator59.n()).done;) {
          var key = _step59.value;
          delete fields[key];
        }
      } catch (err) {
        _iterator59.e(err);
      } finally {
        _iterator59.f();
      }

      return next.withMutation(function () {
        return next.shape(fields);
      });
    }
  }, {
    key: "from",
    value: function from(_from, to, alias) {
      var fromGetter = getter(_from, true);
      return this.transform(function (obj) {
        if (obj == null) return obj;
        var newObj = obj;

        if (has$1(obj, _from)) {
          newObj = _extends$4({}, obj);
          if (!alias) delete newObj[_from];
          newObj[to] = fromGetter(obj);
        }

        return newObj;
      });
    }
  }, {
    key: "noUnknown",
    value: function noUnknown() {
      var noAllow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : object.noUnknown;

      if (typeof noAllow === 'string') {
        message = noAllow;
        noAllow = true;
      }

      var next = this.test({
        name: 'noUnknown',
        exclusive: true,
        message: message,
        test: function test(value) {
          if (value == null) return true;
          var unknownKeys = unknown(this.schema, value);
          return !noAllow || unknownKeys.length === 0 || this.createError({
            params: {
              unknown: unknownKeys.join(', ')
            }
          });
        }
      });
      next.spec.noUnknown = noAllow;
      return next;
    }
  }, {
    key: "unknown",
    value: function unknown() {
      var allow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : object.noUnknown;
      return this.noUnknown(!allow, message);
    }
  }, {
    key: "transformKeys",
    value: function transformKeys(fn) {
      return this.transform(function (obj) {
        return obj && mapKeys(obj, function (_, key) {
          return fn(key);
        });
      });
    }
  }, {
    key: "camelCase",
    value: function camelCase() {
      return this.transformKeys(_camelCase);
    }
  }, {
    key: "snakeCase",
    value: function snakeCase() {
      return this.transformKeys(_snakeCase);
    }
  }, {
    key: "constantCase",
    value: function constantCase() {
      return this.transformKeys(function (key) {
        return _snakeCase(key).toUpperCase();
      });
    }
  }, {
    key: "describe",
    value: function describe() {
      var base = _get3(_getPrototypeOf2(ObjectSchema.prototype), "describe", this).call(this);

      base.fields = mapValues$1(this.fields, function (value) {
        return value.describe();
      });
      return base;
    }
  }]);

  return ObjectSchema;
}(BaseSchema);

function create(spec) {
  return new ObjectSchema(spec);
}

create.prototype = ObjectSchema.prototype;
var AUTH_VIEW_STATES = {
  LOGIN_VIEW: 'login',
  LOGOUT_VIEW: 'logout',
  SIGNUP_VIEW: 'signup',
  FORGOTPASSWORD_VIEW: 'forgot',
  FORGOTPASSWORDSENT_VIEW: 'passwordSent',
  TWO_FACTOR_VIEW: 'twoFactor'
};
var passwordStrengthRegex = /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*\(\),.:;\?<>~\_\[\]\{\}\-]).{8,40})/;

var testPasswordStrength = function testPasswordStrength(val) {
  return passwordStrengthRegex.test(val);
};

var SignupSchema = create().shape({
  firstName: create$2(),
  email: create$2().email(authStrings.emailInvalid).required(authStrings.emailRequired),
  password: create$2().required(authStrings.passwordRequired).test('regex', authStrings.passwordStrength, testPasswordStrength).min(8, authStrings.passwordLength8)
});
var LoginSchema = create().shape({
  email: create$2().required(authStrings.userOrEmailRequired),
  password: create$2().required(authStrings.passwordRequired)
});
var ForgotPasswordSchema = create().shape({
  username: create$2().required(authStrings.usernameRequired)
});
var ResetPasswordSchema = create().shape({
  password: create$2().required(authStrings.passwordRequired).test('regex', authStrings.passwordStrength, testPasswordStrength).min(8, authStrings.passwordLength8)
});
var propTypes$T = {
  error: PropTypes.oneOfType([PropTypes.shape({
    errorMessage: PropTypes.string
  }), PropTypes.string]),
  handleSubmit: PropTypes.func.isRequired
};
var defaultProps$r = {
  error: null
};

function ForgotPasswordForm(_ref) {
  var handleSubmit = _ref.handleSubmit,
      error = _ref.error;
  var formik = useFormik({
    initialValues: {
      username: ''
    },
    validationSchema: ForgotPasswordSchema,
    onSubmit: function onSubmit(values) {
      handleSubmit(values);
    }
  });
  var values = formik.values;

  var handleEnterSubmit = function handleEnterSubmit(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      formik.handleSubmit(values);
    }
  };

  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    jsxs("form", {
      id: "forgot-password-form",
      onKeyPress: handleEnterSubmit,
      children: [/*#__PURE__*/jsx$1(Text$1, {
        fontSize: 1,
        fontWeight: "light",
        mb: 4,
        textAlign: "center",
        children: authStrings.forgotMessageHelper
      }), /*#__PURE__*/jsx$1(Box$1, {
        children: /*#__PURE__*/jsx$1(Input$5, {
          errorMessage: formik.errors.username,
          hasError: formik.errors.username && formik.touched.username,
          id: "username",
          label: authStrings.forgotLabel,
          name: "username",
          onBlur: formik.handleBlur,
          onChange: formik.handleChange,
          value: formik.values.username,
          width: "100%"
        }, 'username')
      }), error && /*#__PURE__*/jsx$1(Message, {
        my: 2,
        size: "medium",
        variant: "error",
        children: error.status === 400 ? authStrings.invalidUserNameErrorMsg : authStrings.defaultForgotPassErrorMsg
      }), /*#__PURE__*/jsx$1(Button$1, {
        ariaLabel: authStrings.sendBtnTitle,
        id: "btnForgotPwd",
        mt: 3,
        onClick: function onClick() {
          formik.handleSubmit(values);
        },
        width: 1,
        color: "magenta",
        children: authStrings.send
      })]
    })
  );
}

ForgotPasswordForm.defaultProps = defaultProps$r;
ForgotPasswordForm.propTypes = propTypes$T;
var _excluded$o = ["error", "onSubmit", "onCancel", "onSignInClick", "messageSent"];

function ownKeys$X(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$X(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$X(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$X(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function ForgotPasswordView(_ref) {
  var error = _ref.error,
      onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel,
      onSignInClick = _ref.onSignInClick,
      messageSent = _ref.messageSent,
      props = _objectWithoutProperties$8(_ref, _excluded$o);

  return /*#__PURE__*/jsx$1(Box$1, {
    alignItems: "center",
    flexDirection: "column",
    mt: 3,
    children: messageSent ? /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx$1(Text$1, {
        fontSize: 1,
        textAlign: "center",
        children: authStrings.messageSent
      }), /*#__PURE__*/jsx$1(Text$1, {
        fontSize: 1,
        mt: 4,
        children: /*#__PURE__*/jsxs(Box$1, {
          alignItems: "center",
          justifyContent: "center",
          children: ["Return to", /*#__PURE__*/jsx$1(Button$1, {
            ariaLabel: authStrings.loginBtn,
            color: "greenDark",
            id: "return to login",
            ml: 2,
            onClick: onSignInClick,
            variant: "underlined",
            children: authStrings.loginBtn
          })]
        })
      })]
    }) : /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx$1(ForgotPasswordForm, _objectSpread$X({
        error: error,
        handleSubmit: onSubmit
      }, props)), /*#__PURE__*/jsx$1(Button$1, {
        ariaLabel: authStrings.sendBtnTitle,
        color: "black",
        id: "btnCancelForgotPwd",
        mt: 3,
        onClick: onCancel,
        variant: "underlined",
        children: authStrings.cancel
      })]
    })
  });
}

var _templateObject$q;

var _enableGoogleAuth$goo = {
  enableGoogleAuth: RESELLER === 'rebel.com',
  googleClientId: process.env.GATSBY_GOOGLE,
  enableFacebookAuth: RESELLER === 'rebel.com',
  facebookAppId: process.env.GATSBY_FACEBOOK
},
    enableGoogleAuth = _enableGoogleAuth$goo.enableGoogleAuth,
    googleClientId = _enableGoogleAuth$goo.googleClientId,
    enableFacebookAuth = _enableGoogleAuth$goo.enableFacebookAuth,
    facebookAppId = _enableGoogleAuth$goo.facebookAppId; // GOOGLE

var googlePropTypes = {
  buttonText: PropTypes.string.isRequired,
  clientId: PropTypes.string.isRequired,
  onFailure: PropTypes.func,
  onRequest: PropTypes.func,
  onSuccess: PropTypes.func.isRequired,
  prompt: PropTypes.string.isRequired,
  responseType: PropTypes.string.isRequired
};
var googleDefaultProps = {
  onFailure: function onFailure() {},
  onRequest: function onRequest() {}
};
var sharedStyles = css$3(["background:", ";border:none !important;box-shadow:none !important;color:", " !important;font-family:", " !important;font-size:", " !important;font-weight:500;letter-spacing:1px;padding:0;text-transform:uppercase;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.blackLighter;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts["default"];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes[0];
});

function GoogleLoginButton(_ref5) {
  var clientId = _ref5.clientId,
      onSuccess = _ref5.onSuccess,
      onFailure = _ref5.onFailure,
      onRequest = _ref5.onRequest,
      buttonText = _ref5.buttonText,
      responseType = _ref5.responseType,
      prompt = _ref5.prompt;
  return /*#__PURE__*/jsxs(Box$1, {
    alignItems: "center",
    border: 1,
    "data-testid": "google-sso",
    height: "3.5rem",
    justifyContent: "center",
    width: 1,
    children: [/*#__PURE__*/jsx$1(Icon$2, {
      mr: 2,
      name: "google",
      title: "google sign on",
      titleId: "googleSSOIcon"
    }), /*#__PURE__*/jsx$1(_StyledGoogleLogin, {
      buttonText: buttonText,
      clientId: clientId,
      icon: false,
      onFailure: onFailure,
      onRequest: onRequest,
      onSuccess: onSuccess,
      prompt: prompt,
      responseType: responseType
    })]
  });
}

GoogleLoginButton.propTypes = googlePropTypes;
GoogleLoginButton.defaultProps = googleDefaultProps; // FACEBOOK

function FacebookLoginButton(_ref6) {
  var appId = _ref6.appId,
      callback = _ref6.callback,
      buttonText = _ref6.buttonText;
  return /*#__PURE__*/jsxs(_StyledBox$h, {
    alignItems: "center",
    border: 1,
    borderRadius: 2,
    "data-testid": "fb-sso",
    height: "3.5rem",
    justifyContent: "center",
    mt: 4,
    width: 1,
    children: [/*#__PURE__*/jsx$1(Icon$2, {
      color: "facebook",
      mr: 2,
      name: "facebook",
      title: "facebook sign on",
      titleId: "facebookSSOIcon"
    }), /*#__PURE__*/jsx$1(FacebookLogin, {
      appId: appId,
      callback: callback,
      fields: "name,email",
      onClick: function onClick() {
        /* Loader.show(); */
      },
      textButton: buttonText
    })]
  });
}

FacebookLoginButton.defaultProps = {
  buttonText: 'facebook'
};
FacebookLoginButton.propTypes = {
  appId: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  callback: PropTypes.func.isRequired
}; // WRAPPER

var propTypes$S = {
  onSocialLoginSubmit: PropTypes.func.isRequired,
  ssoError: PropTypes.shape({
    errorMessage: PropTypes.string,
    Message: PropTypes.string
  })
};
var defaultProps$q = {
  ssoError: null
};

function SocialButtons(_ref7) {
  var ssoError = _ref7.ssoError,
      onSocialLoginSubmit = _ref7.onSocialLoginSubmit;

  var responseGoogle = function responseGoogle(response) {
    if (Object.prototype.hasOwnProperty.call(response, 'code')) {
      onSocialLoginSubmit({
        app: 'google',
        token: response.code
      }, Boolean(ssoError));
    }
  };

  var responseFacebook = function responseFacebook(response) {
    if (Object.prototype.hasOwnProperty.call(response, 'accessToken')) {
      onSocialLoginSubmit({
        app: 'facebook',
        token: response.accessToken
      }, Boolean(ssoError));
    }
  };

  var showGoogle = enableGoogleAuth && googleClientId;
  var showFacebook = enableFacebookAuth && facebookAppId;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [(showGoogle || showFacebook) && /*#__PURE__*/jsx$1(Divider, {
      my: 4,
      children: "or"
    }), /*#__PURE__*/jsxs(Box$1, {
      alignItems: "center",
      flexDirection: "column",
      children: [ssoError && /*#__PURE__*/jsx$1(Message, {
        variant: "error",
        children: ssoError.errorMessage || ssoError.Message || ssoError || authStrings.defaultSignupErrorMsg
      }), showGoogle && /*#__PURE__*/jsx$1(GoogleLoginButton, {
        buttonText: "continue with google",
        clientId: googleClientId,
        onFailure: function onFailure() {},
        onRequest: function onRequest() {
          /* Loader.show(); */
        },
        onSuccess: responseGoogle,
        prompt: "consent",
        responseType: "code"
      }), showFacebook && /*#__PURE__*/jsx$1(FacebookLoginButton, {
        appId: facebookAppId,
        buttonText: "continue with facebook",
        callback: responseFacebook
      })]
    })]
  });
}

SocialButtons.propTypes = propTypes$S;
SocialButtons.defaultProps = defaultProps$q;

var _StyledGoogleLogin = styled(GoogleLogin)(_templateObject$q || (_templateObject$q = _taggedTemplateLiteral$1(["", ""])), sharedStyles);

var _StyledBox$h = styled(Box$1).withConfig({
  displayName: "social-buttons___StyledBox",
  componentId: "sc-19g87yp-0"
})(["button{", "}"], sharedStyles);

var defaultProps$p = {
  error: null
};
var propTypes$R = {
  error: PropTypes.shape({
    errorMessage: PropTypes.string,
    Message: PropTypes.string
  }),
  handleSubmit: PropTypes.func.isRequired,
  resetCaptcha: PropTypes.func.isRequired
};

function LoginForm(_ref) {
  var error = _ref.error,
      handleSubmit = _ref.handleSubmit,
      resetCaptcha = _ref.resetCaptcha;
  var formik = useFormik({
    initialValues: {
      email: '',
      password: ''
    },
    onSubmit: function onSubmit(values) {
      handleSubmit({
        username: values.email,
        password: values.password
      });
    },
    validationSchema: LoginSchema
  });
  var errors = formik.errors,
      handleBlur = formik.handleBlur,
      handleChange = formik.handleChange,
      values = formik.values,
      touched = formik.touched;

  var onInputChange = function onInputChange(e) {
    if (error) {
      resetCaptcha();
    }

    handleChange(e);
  };

  var handleEnterSubmit = function handleEnterSubmit(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      formik.handleSubmit(values);
    }
  };

  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    jsxs("form", {
      id: "login-form",
      onKeyPress: handleEnterSubmit,
      children: [/*#__PURE__*/jsx$1(Input$5, {
        errorMessage: errors.email,
        hasError: errors.email && touched.email,
        id: "email",
        label: authStrings.username,
        name: "email",
        onBlur: handleBlur,
        onChange: onInputChange,
        value: values.email,
        width: "100%"
      }, 'email'), /*#__PURE__*/jsx$1(Input$5, {
        autoComplete: "password",
        errorMessage: errors.password,
        hasError: errors.password && touched.password,
        id: "password",
        label: authStrings.password,
        mt: 3,
        name: "password",
        onBlur: handleBlur,
        onChange: onInputChange,
        type: "password",
        value: values.password,
        width: "100%"
      }, 'password'), error && /*#__PURE__*/jsx$1(Message, {
        my: 2,
        variant: "error",
        children: error.errorMessage || error.Message || authStrings.defaultLoginErrorMsg
      }), /*#__PURE__*/jsx$1(Button$1, {
        ariaLabel: authStrings.loginBtn,
        id: "submitBtn",
        onClick: function onClick() {
          formik.handleSubmit(values);
        },
        size: "large",
        title: authStrings.loginBtn,
        width: "100%",
        mt: 2,
        color: isInternic ? 'blueDark' : 'magenta',
        children: authStrings.loginBtn
      })]
    })
  );
}

LoginForm.defaultProps = defaultProps$p;
LoginForm.propTypes = propTypes$R;
var _excluded$n = ["onSocialLoginSubmit", "onCreateAccountClick", "onForgotPasswordClick", "error", "onSubmit"];

function ownKeys$W(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$W(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$W(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$W(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function LoginView(_ref) {
  var onSocialLoginSubmit = _ref.onSocialLoginSubmit,
      onCreateAccountClick = _ref.onCreateAccountClick,
      onForgotPasswordClick = _ref.onForgotPasswordClick,
      error = _ref.error,
      onSubmit = _ref.onSubmit,
      props = _objectWithoutProperties$8(_ref, _excluded$n);

  var _useState = useState({}),
      _useState2 = _slicedToArray$4(_useState, 2),
      loginData = _useState2[0],
      setLoginData = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray$4(_useState3, 2),
      recaptchaResponse = _useState4[0],
      setRecaptchaResp = _useState4[1];

  var recaptcha = useRef();
  useEffect(function () {
    if (recaptchaResponse) {
      var userData = _objectSpread$W(_objectSpread$W({}, loginData), {}, {
        recaptchaResponse: recaptchaResponse
      });

      onSubmit(userData);
      recaptcha.current.reset();
    }
  }, [recaptchaResponse]);

  var resetCaptcha = function resetCaptcha() {
    setLoginData({});
    recaptcha.current.reset();
  };

  var submitHandler = function submitHandler(values) {
    setLoginData(values); // Bypass recaptcha

    if (process.env.NODE_ENV === 'test') {
      setRecaptchaResp('test');
      return;
    }

    if (recaptcha.current) {
      recaptcha.current.execute();
    }
  };

  var resolveRecaptcha = function resolveRecaptcha(response) {
    setRecaptchaResp(response);
  };

  return /*#__PURE__*/jsxs(Stack$2, {
    mt: 3,
    children: [/*#__PURE__*/jsxs(Box$1, {
      alignItems: "center",
      justifyContent: "center",
      mb: 2,
      children: [/*#__PURE__*/jsx$1(Text$1, {
        fontWeight: "light",
        children: authStrings.noAccount
      }), /*#__PURE__*/jsx$1(Button$1, {
        color: "black",
        ml: 1,
        ariaLabel: authStrings.getStartedTitle,
        id: "btnGoToCreateAccount",
        onClick: onCreateAccountClick,
        variant: "underlined",
        p: 0,
        children: authStrings.getStarted
      })]
    }), /*#__PURE__*/jsx$1(LoginForm, _objectSpread$W({
      error: error,
      handleSubmit: submitHandler,
      resetCaptcha: resetCaptcha
    }, props)), /*#__PURE__*/jsx$1(Box$1, {
      justifyContent: "center",
      children: /*#__PURE__*/jsx$1(Button$1, {
        mt: 3,
        ariaLabel: authStrings.forgotPassword,
        color: "black",
        id: "btnGoToForgotPwd",
        onClick: onForgotPasswordClick,
        variant: "underlined",
        children: authStrings.forgotPassword
      })
    }), process.env.NODE_ENV !== 'test' && /*#__PURE__*/jsx$1(SocialButtons, {
      onSocialLoginSubmit: onSocialLoginSubmit
    }), /*#__PURE__*/jsx$1(Recaptcha, {
      ref: recaptcha,
      onResolved: resolveRecaptcha,
      sitekey: process.env.GATSBY_RECAPTCHA || '6LfIj2QpAAAAAOLsuy2dyplcb371IcqhUzGE9unA'
    })]
  });
}

function LogoutView(_ref) {
  var userName = _ref.userName,
      onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel,
      showCancel = _ref.showCancel;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      hasMounted = _useState2[0],
      setHasMounted = _useState2[1];

  useEffect(function () {
    setHasMounted(true);
  }, []);

  if (!hasMounted) {
    return null;
  }

  return /*#__PURE__*/jsxs(Stack$2, {
    alignItems: "center",
    my: 3,
    children: [/*#__PURE__*/jsx$1(Text$1, {
      "data-ls-disabled": true,
      children: userName
    }), /*#__PURE__*/jsxs(Box$1, {
      mt: 4,
      children: [/*#__PURE__*/jsx$1(Button$1, {
        ariaLabel: authStrings.logoutBtn,
        id: "logout",
        onClick: onSubmit,
        children: authStrings.logoutBtn
      }), showCancel && /*#__PURE__*/jsx$1(Button$1, {
        ariaLabel: authStrings.cancel,
        id: "logout-cancel",
        ml: 4,
        onClick: onCancel,
        variant: "underlined",
        children: authStrings.cancel
      })]
    })]
  });
}

var propTypes$Q = {
  error: PropTypes.oneOfType([PropTypes.shape({
    errorMessage: PropTypes.string,
    Message: PropTypes.string
  }), PropTypes.array]),
  handleSubmit: PropTypes.func.isRequired,
  isRedesign: PropTypes.bool
};
var defaultProps$o = {
  error: null,
  isRedesign: false
};

function SignupForm(_ref) {
  var error = _ref.error,
      handleSubmit = _ref.handleSubmit,
      isRedesign = _ref.isRedesign;
  var recaptcha = useRef(null);

  var _useState = useState(null),
      _useState2 = _slicedToArray$4(_useState, 2),
      recaptchaValue = _useState2[0],
      setRecaptchaValue = _useState2[1];

  var formik = useFormik({
    initialValues: {
      firstName: '',
      email: '',
      password: '',
      recaptchaResponse: ''
    },
    validationSchema: SignupSchema,
    onSubmit: function onSubmit(values) {
      handleSubmit(values);
      recaptcha.current.reset();
    }
  });
  var shouldShowErrorMessage = error && !Array.isArray(error); // Current implementation is only for email

  var hasInputLevelErrorFromBackend = error && Array.isArray(error);

  var getEmailErrorMessage = function getEmailErrorMessage() {
    if (hasInputLevelErrorFromBackend) {
      return error[0].message;
    }

    return 'Error';
  };

  var handleInput = function handleInput(e) {
    if (error) {
      recaptcha.current.reset();
    }

    formik.handleChange(e);
  };

  var errors = formik.errors,
      touched = formik.touched,
      values = formik.values,
      handleBlur = formik.handleBlur;

  var handleEnterSubmit = function handleEnterSubmit(e) {
    if (e.key === 'Enter') {
      e.preventDefault();

      if (recaptcha) {
        recaptcha.current.execute();
      }
    }
  };

  var resolveRecaptcha = function resolveRecaptcha(value) {
    setRecaptchaValue(value);
  };

  function handleClick() {
    if (recaptcha) {
      recaptcha.current.execute();
    }
  }

  useEffect(function () {
    if (recaptchaValue) {
      values.recaptchaResponse = recaptchaValue;
      formik.handleSubmit(values);
    }
  }, [recaptchaValue]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs("form", {
      id: "signup-form",
      onKeyPress: handleEnterSubmit,
      children: [isRedesign && /*#__PURE__*/jsx$1(Input$5, {
        errorMessage: errors.firstName,
        hasError: errors.firstName && touched.firstName,
        id: "firstName",
        label: authStrings.firstName,
        name: "firstName",
        onBlur: handleBlur,
        onChange: handleInput,
        value: values.firstName,
        width: "100%",
        mb: 3
      }, 'firstName'), /*#__PURE__*/jsx$1(Input$5, {
        errorMessage: errors.email || getEmailErrorMessage(),
        hasError: errors.email && touched.email || hasInputLevelErrorFromBackend,
        id: "email",
        label: authStrings.email,
        name: "email",
        onBlur: handleBlur,
        onChange: handleInput,
        value: values.email,
        width: "100%"
      }, 'email'), /*#__PURE__*/jsx$1(Input$5, {
        autoComplete: "new-password",
        errorMessage: errors.password,
        hasError: errors.password && touched.password,
        id: "new-password",
        label: authStrings.password,
        mb: 3,
        mt: 3,
        name: "password",
        onBlur: handleBlur,
        onChange: handleInput,
        type: "password",
        value: values.password,
        width: "100%"
      }, 'password'), shouldShowErrorMessage && /*#__PURE__*/jsx$1(Message, {
        containerProps: {
          my: 3
        },
        variant: "error",
        children: error.errorMessage || error.Message || authStrings.defaultSignupErrorMsg
      }), /*#__PURE__*/jsx$1(Button$1, {
        ariaLabel: authStrings.createBtnTitle,
        id: "submitBtn",
        onClick: handleClick,
        size: "large",
        testId: "create",
        title: authStrings.createBtnTitle,
        width: 1,
        mt: 2,
        color: isInternic ? 'blueDark' : 'magenta',
        children: authStrings.createBtn
      }), /*#__PURE__*/jsxs(Text$1, {
        fontSize: 1,
        fontWeight: "light",
        my: 3,
        textAlign: "center",
        children: [authStrings.byCreatingAccount, " ", /*#__PURE__*/jsx$1("br", {}), /*#__PURE__*/jsx$1(Link$1, {
          ariaLabel: authStrings.termsOfService,
          color: "black",
          href: "https://www.rebel.com/terms-conditions.aspx",
          newTab: true,
          title: authStrings.termsOfService,
          textDecoration: "underline",
          children: authStrings.termsOfService
        }), ' ', "and", ' ', /*#__PURE__*/jsx$1(Link$1, {
          ariaLabel: authStrings.privacyPolicy,
          color: "black",
          href: "https://www.rebel.com/privacy-policy",
          newTab: true,
          title: authStrings.privacyPolicy,
          textDecoration: "underline",
          children: authStrings.privacyPolicy
        })]
      })]
    }), /*#__PURE__*/jsx$1(Recaptcha, {
      ref: recaptcha,
      onResolved: resolveRecaptcha,
      sitekey: process.env.GATSBY_RECAPTCHA || '6LfIj2QpAAAAAOLsuy2dyplcb371IcqhUzGE9unA'
    })]
  });
}

SignupForm.propTypes = propTypes$Q;
SignupForm.defaultProps = defaultProps$o;
var _excluded$m = ["onSocialLoginSubmit", "onSignInClick", "onSubmit", "error"];

function ownKeys$V(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$V(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$V(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$V(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function SignupView(_ref) {
  var onSocialLoginSubmit = _ref.onSocialLoginSubmit,
      onSignInClick = _ref.onSignInClick,
      onSubmit = _ref.onSubmit,
      error = _ref.error,
      props = _objectWithoutProperties$8(_ref, _excluded$m);

  useRef(null);

  var handleSignupClick = function handleSignupClick(data) {
    onSubmit(data);
  };

  return /*#__PURE__*/jsxs(Box$1, {
    flexDirection: "column",
    mt: 3,
    children: [/*#__PURE__*/jsxs(Box$1, {
      alignItems: "center",
      justifyContent: "center",
      mb: 2,
      children: [/*#__PURE__*/jsx$1(Text$1, {
        fontWeight: "light",
        children: authStrings.existingAccount
      }), /*#__PURE__*/jsx$1(Button$1, {
        ml: 1,
        color: "black",
        ariaLabel: authStrings.signIn,
        "data-testid": "goToSignIn",
        id: "btnGoToCreateAccount",
        onClick: onSignInClick,
        variant: "underlined",
        p: 0,
        children: authStrings.signIn
      })]
    }), /*#__PURE__*/jsx$1(SignupForm, _objectSpread$V({
      error: error,
      handleSubmit: handleSignupClick
    }, props)), process.env.NODE_ENV !== 'test' && /*#__PURE__*/jsx$1(SocialButtons, {
      onSocialLoginSubmit: onSocialLoginSubmit
    })]
  });
}

var _templateObject$p, _templateObject2$g, _templateObject3$a, _templateObject4$6, _templateObject5$4, _templateObject6$3, _templateObject7$3, _templateObject8$3, _templateObject9$2, _templateObject0$1;

function _regenerator$N() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$N(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$N(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$N(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$N(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$N(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$N(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$N(u), _regeneratorDefine2$N(u, o, "Generator"), _regeneratorDefine2$N(u, n, function () {
    return this;
  }), _regeneratorDefine2$N(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$N = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$N(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$N = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$N(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$N(e, r, n, t);
}

function ownKeys$U(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$U(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$U(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$U(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function TwoFactorView(_ref) {
  var error = _ref.error,
      contactInfo = _ref.contactInfo,
      currentType = _ref.currentType,
      showSixDigit = _ref.showSixDigit,
      showMFAInfoPage = _ref.showMFAInfoPage,
      showContactMethodPicker = _ref.showContactMethodPicker,
      isSending = _ref.isSending,
      onGoBack = _ref.onGoBack,
      onResendCode = _ref.onResendCode,
      onSubmitCode = _ref.onSubmitCode,
      onGoToContactOptions = _ref.onGoToContactOptions,
      onSubmitContactMethod = _ref.onSubmitContactMethod;

  var _useState = useState(10),
      _useState2 = _slicedToArray$4(_useState, 2),
      secondsLeft = _useState2[0],
      setSecondsLeft = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray$4(_useState3, 2),
      selectedRadio = _useState4[0],
      setSelectedRadio = _useState4[1];

  var _useState5 = useState({
    0: '',
    1: '',
    2: '',
    3: '',
    4: '',
    5: ''
  }),
      _useState6 = _slicedToArray$4(_useState5, 2),
      codeValues = _useState6[0],
      setCodeValues = _useState6[1];

  var workingState = !showMFAInfoPage && !showSixDigit && !showContactMethodPicker || isSending;

  if (currentType === 'phone' && !contactInfo.phone) {
    currentType = 'email';
  } // edge case for new users


  var handleResendClick = function handleResendClick() {
    if (secondsLeft === 0) {
      setSecondsLeft(10);
      onResendCode();
    }
  };

  function getRadio(contactMethod) {
    var display = (contactMethod.includes('alternate') ? contactMethod.replace(/([a-z])([A-Z])/g, '$1 $2') : contactMethod).replace(contactMethod[0], contactMethod[0].toUpperCase()); // adds space and capitalizes

    var typeAvailable = contactInfo[contactMethod];
    var isChecked = selectedRadio === contactMethod;
    return /*#__PURE__*/jsxs(_StyledBox$g, {
      justifyContent: "flex-start",
      alignItems: "center",
      width: "100%",
      py: 4,
      border: "1px solid rgba(0,0,0,0.15)",
      onClick: function onClick(event) {
        event.stopPropagation();
        var firstChild = event.target.querySelector('input[type="radio"]');

        if (firstChild.value && typeAvailable) {
          setSelectedRadio(firstChild.value);
        }
      },
      $_css: isChecked ? '#E6E4F4;' : 'transparent;',
      children: [/*#__PURE__*/jsx$1(_StyledInput$2, {
        type: "radio",
        name: "contact-options",
        value: contactMethod,
        id: contactMethod,
        disabled: !typeAvailable,
        checked: isChecked,
        width: "fit-content"
      }), /*#__PURE__*/jsx$1("label", {
        htmlFor: contactMethod,
        style: {
          fontWeight: 600,
          color: !typeAvailable ? 'rgba(0,0,0,0.4)' : '',
          pointerEvents: 'none'
        },
        children: typeAvailable ? contactInfo[contactMethod] : "".concat(display, " is not available on your account")
      })]
    });
  }

  function onSubmitForm() {
    return _onSubmitForm.apply(this, arguments);
  }

  function _onSubmitForm() {
    _onSubmitForm = _asyncToGenerator( /*#__PURE__*/_regenerator$N().m(function _callee() {
      var form, selectedRadio, value;
      return _regenerator$N().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              form = document.getElementById('contact-options-selector');
              selectedRadio = form === null || form === void 0 ? void 0 : form.querySelector('input[name="contact-options"]:checked');

              if (selectedRadio) {
                value = selectedRadio.value;
                onSubmitContactMethod(value);
              }

            case 1:
              return _context.a(2);
          }
        }
      }, _callee);
    }));
    return _onSubmitForm.apply(this, arguments);
  }

  function arrToText(arr) {
    var first = arr[0];
    var second = arr[1];
    return /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx$1("span", {
        children: first
      }), /*#__PURE__*/jsx$1("span", {
        style: {
          fontWeight: '700'
        },
        children: contactInfo[currentType || 'phone']
      }), /*#__PURE__*/jsx$1("span", {
        children: second
      })]
    });
  }

  function getText() {
    switch (currentType) {
      case 'app':
        return /*#__PURE__*/jsx$1(Text$1, {
          mb: 2,
          width: "75%",
          textAlign: "center",
          children: authStrings.enter6DigitCodeApp
        });

      case 'email':
        return /*#__PURE__*/jsx$1(Text$1, {
          mb: 2,
          width: "75%",
          textAlign: "center",
          children: arrToText(authStrings.enter6DigitCodeEmail.split('$$EMAIL$$'))
        });

      case 'alternateEmail':
        return /*#__PURE__*/jsx$1(Text$1, {
          mb: 2,
          width: "75%",
          textAlign: "center",
          children: arrToText(authStrings.enter6DigitCodeEmail.split('$$EMAIL$$'))
        });

      case 'phone':
        return /*#__PURE__*/jsx$1(Text$1, {
          mb: 2,
          width: "75%",
          textAlign: "center",
          children: arrToText(authStrings.enter6DigitCodePhone.split('$$PHONE$$'))
        });

      default:
        return /*#__PURE__*/jsx$1(Text$1, {
          mb: 2,
          width: "75%",
          textAlign: "center",
          children: authStrings.enter6DigitCode
        });
    }
  }

  function moveInDirection(direction, currentIndex) {
    if (direction < 0 && currentIndex == 0) {
      return;
    }

    if (direction > 0 && currentIndex == 5) {
      return;
    }

    var form = document.getElementById('codeForm');
    var inputs = form === null || form === void 0 ? void 0 : form.querySelectorAll('input');

    if (!inputs) {
      return;
    }

    var nextInput = inputs[currentIndex + direction];
    nextInput.focus();
  }

  function handleChange(event, currentIndex) {
    var currentLength = event.target.value.length;

    if (currentLength === 0) {
      return;
    }

    if (currentLength === 1) {
      setCodeValues(_objectSpread$U(_objectSpread$U({}, codeValues), {}, _defineProperty$6({}, currentIndex, event.target.value)));

      if (currentIndex === 5) {
        var code = Object.values(codeValues).join('') + event.target.value;

        if (code.length === 6) {
          setCodeValues({
            0: '',
            1: '',
            2: '',
            3: '',
            4: '',
            5: ''
          });
          return onSubmitCode(code);
        }
      }

      moveInDirection(1, currentIndex);
    }

    if (currentLength > 1 && currentLength < 6) {
      setCodeValues(_objectSpread$U(_objectSpread$U({}, codeValues), {}, _defineProperty$6({}, currentIndex, codeValues[currentIndex] ? event.target.value.replace(codeValues[currentIndex], '')[0] : event.target.value[0])));
      moveInDirection(1, currentIndex);
    }
  }

  function handleKeyDown(event, currentIndex) {
    switch (event.key) {
      case 'Backspace':
        setCodeValues(_objectSpread$U(_objectSpread$U({}, codeValues), {}, _defineProperty$6({}, currentIndex, '')));
        moveInDirection(-1, currentIndex);
        break;

      case 'ArrowRight':
        moveInDirection(1, currentIndex);
        break;

      case 'ArrowLeft':
        moveInDirection(-1, currentIndex);
        break;

      case 'Delete':
        setCodeValues(_objectSpread$U(_objectSpread$U({}, codeValues), {}, _defineProperty$6({}, currentIndex, '')));
        break;
    }
  }

  function handlePaste(event) {
    var pastedData = event.clipboardData.getData('text');
    var pastedLength = pastedData.length;

    if (pastedLength === 6) {
      setCodeValues({
        0: pastedData[0],
        1: pastedData[1],
        2: pastedData[2],
        3: pastedData[3],
        4: pastedData[4],
        5: pastedData[5]
      });
      onSubmitCode(pastedData);
      setTimeout(function () {
        setCodeValues({
          0: '',
          1: '',
          2: '',
          3: '',
          4: '',
          5: ''
        });
      }, 500);
    }
  }

  var formStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '1rem',
    width: '65%'
  };
  var inputStyles = "\n    display: flex;\n    width: 3rem;\n    justify-content: center;\n    align-items: center;\n    border-bottom: ".concat(error ? '2px solid #5c0000 !important;' : '2px solid rgba(0,0,0,0.4) !important;', "\n    cursor: pointer;\n    transition: 0.2s;\n    input {\n      cursor: pointer;\n      border: none !important;\n      outline: none;\n      width: 100%;\n      padding: 0;\n      padding-bottom: 4px;\n      caret-color: transparent;\n      font-size: 3rem;\n      text-align: center;\n      &:focus {\n        box-shadow: none !important;\n      }\n    }\n    &:focus-within {\n      transform: translateY(-2px);\n      border-bottom: 2px solid rgba(180, 0, 0, 0.795) !important;\n    }\n  ");
  useEffect(function () {
    if (isSending) {
      return;
    }

    var firstInput = document.getElementById('first-input');

    if (firstInput) {
      setTimeout(function () {
        firstInput.focus();
      }, 300);
    }
  }, [showSixDigit, isSending, error]);
  useEffect(function () {
    if (!showSixDigit) {
      return;
    }

    if (secondsLeft > 0) {
      var timer = setTimeout(function () {
        setSecondsLeft(secondsLeft - 1);
      }, 1000);
      return function () {
        return clearTimeout(timer);
      };
    }
  }, [secondsLeft, showSixDigit]);
  return /*#__PURE__*/jsx$1(Box$1, {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    mt: 3,
    children: workingState ? /*#__PURE__*/jsx$1(Skeleton$1, {
      height: "16rem",
      width: "100%"
    }) : /*#__PURE__*/jsxs(Fragment, {
      children: [showMFAInfoPage && /*#__PURE__*/jsxs(_StyledStack$f, {
        alignItems: "center",
        justifyContent: "space-between",
        flex: "1",
        children: [/*#__PURE__*/jsx$1(_StyledAlertInline, {
          body: /*#__PURE__*/jsx$1(Text$1, {
            mb: 2,
            width: "100%",
            children: authStrings.twoFactorNotice.replace('$$RESELLER$$', resellerTitle)
          }),
          variant: "warning",
          showTitle: false,
          width: ['100%', '100%', '100%']
        }), /*#__PURE__*/jsxs(Text$1, {
          children: [authStrings.twoFactorSubNotice.replace('$$RESELLER$$', resellerTitle), /*#__PURE__*/jsx$1("a", {
            href: "https://blog.rebel.com/why-multi-factor-authentication-is-essential-in-todays-digital-world/",
            target: "_blank",
            style: {
              color: 'black',
              textDecoration: 'underline'
            },
            rel: "noreferrer",
            children: "click here"
          }), ' ', "to learn more."]
        }), /*#__PURE__*/jsx$1(Button$1, {
          id: "advance",
          onClick: onGoBack,
          children: "Continue to sign in"
        })]
      }), showSixDigit && /*#__PURE__*/jsxs(_StyledStack2$2, {
        alignItems: "center",
        justifyContent: "space-between",
        flex: "1",
        children: [getText(), /*#__PURE__*/jsx$1("form", {
          id: "codeForm",
          style: formStyles,
          children: Array(6).fill('').map(function (_, i) {
            return /*#__PURE__*/jsx$1(_StyledInput2$1, {
              id: i === 0 ? 'first-input' : "".concat(i + 1),
              type: "text",
              autoComplete: "off",
              value: codeValues[i],
              onPaste: function onPaste(e) {
                return handlePaste(e);
              },
              onChange: function onChange(e) {
                return handleChange(e, i);
              },
              onKeyDown: function onKeyDown(e) {
                return handleKeyDown(e, i);
              },
              $_css2: inputStyles
            });
          })
        }), error && /*#__PURE__*/jsxs(_StyledText$i, {
          display: "flex",
          children: [/*#__PURE__*/jsx$1(Icon$2, {
            mr: 2,
            name: "error"
          }), authStrings.default6DigitCodeErrorMsg]
        }), currentType !== 'app' && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx$1(Text$1, {
            width: "70%",
            variant: "mega",
            textAlign: "center",
            children: "It may take a minute to receive your code."
          }), /*#__PURE__*/jsxs(_StyledBox2$6, {
            justifyContent: "space-between",
            width: "100%",
            pt: 4,
            children: [/*#__PURE__*/jsx$1(Button$1, {
              variant: secondsLeft === 0 ? 'solid' : 'inverse',
              onClick: handleResendClick,
              color: isInternic ? 'blueDark' : 'deepKoamaru',
              children: "Resend Code",
              minWidth: "40%",
              disabled: secondsLeft > 0
            }), secondsLeft > 0 && /*#__PURE__*/jsxs(Text$1, {
              variant: "poundBold",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              children: ["(", secondsLeft, ")"]
            }), /*#__PURE__*/jsx$1(Button$1, {
              variant: "solid",
              onClick: onGoToContactOptions,
              color: isInternic ? 'blueDark' : 'deepKoamaru',
              children: "Alternate contact methods",
              minWidth: "40%"
            })]
          })]
        })]
      }), showContactMethodPicker && /*#__PURE__*/jsxs(_StyledStack3$2, {
        flex: "1",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        children: [/*#__PURE__*/jsx$1(_StyledAlertInline2, {
          body: /*#__PURE__*/jsx$1(Text$1, {
            mb: 2,
            width: "100%",
            children: arrToText(authStrings.pickContactMethod.split('$$METHOD$$'))
          }),
          variant: "warning",
          showTitle: false,
          width: ['100%', '100%', '100%']
        }), /*#__PURE__*/jsxs(Stack$2, {
          justifyContent: "center",
          alignItems: "center",
          id: "contact-options-selector",
          width: "100%",
          children: [currentType != 'phone' && getRadio('phone'), currentType != 'email' && getRadio('email'), currentType != 'alternateEmail' && getRadio('alternateEmail')]
        }), /*#__PURE__*/jsxs(Box$1, {
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          children: [/*#__PURE__*/jsx$1(Button$1, {
            ariaLabel: "Go Back",
            id: "go-back",
            onClick: onGoBack,
            variant: "link",
            children: "Go Back"
          }), /*#__PURE__*/jsx$1(_StyledButton$c, {
            disabled: !selectedRadio,
            onClick: function onClick() {
              return onSubmitForm();
            },
            color: "purpleDark",
            py: 2,
            children: selectedRadio ? selectedRadio.includes('mail') ? 'Email me a new code' : 'Text me a new code' : 'Choose an option'
          })]
        })]
      })]
    })
  });
}

var _StyledBox$g = styled(Box$1)(_templateObject$p || (_templateObject$p = _taggedTemplateLiteral$1(["\n          background: ", "\n          transition: 0.2s;\n          cursor: pointer;\n          &:hover {\n            background: #e6e4f4b5;\n          }\n        "])), function (p) {
  return p.$_css;
});

var _StyledInput$2 = styled(Input$5)(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteral$1(["\n            cursor: pointer;\n            gap: '1rem';\n            pointer-events: none;\n            input {\n              margin-left: 1rem;\n              margin-right: 1rem;\n              accent-color: #2b002b;\n              &:focus {\n                box-shadow: none;\n              }\n            }\n          "])));

var _StyledStack$f = styled(Stack$2)(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteral$1(["\n                gap: 4rem;\n              "])));

var _StyledAlertInline = styled(AlertInline)(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteral$1(["\n                  border: 1px solid #fbe694;\n                  & > div > div:first-child {\n                    margin-top: 2px;\n                  }\n                "])));

var _StyledStack2$2 = styled(Stack$2)(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteral$1(["\n                gap: 4rem;\n              "])));

var _StyledInput2$1 = styled(Input$5)(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteral$1(["", ""])), function (p) {
  return p.$_css2;
});

var _StyledText$i = styled(Text$1)(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteral$1(["\n                    font-size: 1.25rem;\n                    align-items: center;\n                    color: #5c0000;\n                  "])));

var _StyledBox2$6 = styled(Box$1)(_templateObject8$3 || (_templateObject8$3 = _taggedTemplateLiteral$1(["\n                      border-top: 1px solid rgba(0, 0, 0, 0.1);\n                    "])));

var _StyledStack3$2 = styled(Stack$2)(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteral$1(["\n                gap: 3rem;\n              "])));

var _StyledAlertInline2 = styled(AlertInline)(_templateObject0$1 || (_templateObject0$1 = _taggedTemplateLiteral$1(["\n                  border: 1px solid #fbe694;\n                  & > div > div:first-child {\n                    margin-top: 2px;\n                  }\n                "])));

var _StyledButton$c = styled(Button$1).withConfig({
  displayName: "two-factor-view___StyledButton",
  componentId: "sc-18v8ewb-0"
})(["text-transform:none;"]);

var _excluded$l = ["showHeading", "showLogoutPanel", "showLogoutCancel", "stopRedirect"];

function ownKeys$T(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$T(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$T(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$T(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}
/**
 *
 * Used in:
 * Navbar
 * rebel.com/account page
 * Order page
 *
 * Remember to check these 3 places if you make a change!!!
 *
 */


function UserAuth(_ref) {
  var _currentState$context, _currentState$context2, _currentState$context3, _currentState$context4;

  var showHeading = _ref.showHeading,
      _ref$showLogoutPanel = _ref.showLogoutPanel,
      showLogoutPanel = _ref$showLogoutPanel === void 0 ? true : _ref$showLogoutPanel,
      showLogoutCancel = _ref.showLogoutCancel,
      stopRedirect = _ref.stopRedirect,
      props = _objectWithoutProperties$8(_ref, _excluded$l);

  var _useUserService = useUserService(),
      containerRef = _useUserService.containerRef,
      currentState = _useUserService.currentState,
      send = _useUserService.send,
      userName = _useUserService.userName;

  var lastFocused;

  if (hasDOM) {
    lastFocused = document.activeElement;
  }

  useEffect(function () {
    return (// When we close the modal, send a reset event
      function () {
        if (!isTest) {
          send(events$c.RESET);
        }
      }
    );
  }, []);
  useEffect(function () {
    if (containerRef && containerRef.current) {
      containerRef.current.focus();
    }
  }, [currentState]); // This affects userauth tests. beware!
  // issues with document.activeElement being null when we switch between UI states (login->logout)

  if (process.env.NODE_ENV !== 'test') {
    useTabTrapper(containerRef, [currentState], lastFocused);
  }

  var showLogin = currentState.matches(authStates.login);
  var showSignup = currentState.matches(authStates.signUp);
  var showForgotPassword = currentState.matches(authStates.forgotPassword);
  var show2FA = currentState.matches(authStates.twoFA);
  var showLogout = currentState.matches(authStates.loggedIn);

  var getHeadingText = function getHeadingText() {
    if (showLogin) {
      return authStrings.signIn;
    }

    if (showSignup) {
      return authStrings.createAccountHeader;
    }

    if (showForgotPassword) {
      return authStrings.forgotPassword;
    }

    if (show2FA) {
      return authStrings.twoFactorCodeHeading;
    }

    if (showLogout) {
      return authStrings.logoutBtn;
    }

    return null;
  };

  var getHeading = function getHeading() {
    if (!showHeading || showLogout && !showLogoutPanel) {
      return null;
    }

    var headingText = getHeadingText();

    if (headingText) {
      return /*#__PURE__*/jsx$1(_StyledHeading$2, {
        headingStyle: 2,
        textAlign: "center",
        children: headingText
      });
    }
  };

  var type = stopRedirect ? events$c.SUBMITNOREDIRECT : events$c.SUBMIT;
  return /*#__PURE__*/jsx$1(ErrorBoundary, {
    location: "user-auth",
    children: /*#__PURE__*/jsxs(Stack$2, {
      children: [getHeading(), showSignup && /*#__PURE__*/jsx$1(SignupView, _objectSpread$T({
        error: currentState.context.error,
        onSignInClick: function onSignInClick() {
          return send(events$c.LOGIN);
        },
        onSocialLoginSubmit: function onSocialLoginSubmit(payload) {
          return send({
            type: events$c.SOCIAL,
            payload: payload
          });
        },
        onSubmit: function onSubmit(payload) {
          return send({
            type: type,
            payload: payload
          });
        }
      }, props)), showLogin && /*#__PURE__*/jsx$1(LoginView, _objectSpread$T({
        error: currentState.context.error,
        onCreateAccountClick: function onCreateAccountClick() {
          return send(events$c.SIGN_UP);
        },
        onForgotPasswordClick: function onForgotPasswordClick() {
          return send(events$c.FORGOT_PW);
        },
        onSocialLoginSubmit: function onSocialLoginSubmit(payload) {
          return send({
            type: events$c.SOCIAL,
            payload: payload
          });
        },
        onSubmit: function onSubmit(payload) {
          return send({
            type: type,
            payload: payload
          });
        }
      }, props)), showForgotPassword && /*#__PURE__*/jsx$1(ForgotPasswordView, _objectSpread$T({
        error: currentState.context.error,
        messageSent: currentState.matches("".concat(authStates.forgotPassword, ".checkEmail")),
        onCancel: function onCancel() {
          return send(events$c.CANCEL);
        },
        onSignInClick: function onSignInClick() {
          return send(events$c.LOGIN);
        },
        onSubmit: function onSubmit(payload) {
          return send({
            type: events$c.SUBMIT,
            payload: payload
          });
        }
      }, props)), showLogout && showLogoutPanel && /*#__PURE__*/jsx$1(LogoutView, {
        onCancel: function onCancel() {
          return send(events$c.CANCEL);
        },
        onSubmit: function onSubmit() {
          return send(events$c.LOG_OUT);
        },
        showCancel: showLogoutCancel,
        userName: userName
      }), show2FA && /*#__PURE__*/jsx$1(TwoFactorView, {
        error: !!((_currentState$context = currentState.context.error) !== null && _currentState$context !== void 0 && _currentState$context.errorMessage),
        currentType: (currentState === null || currentState === void 0 ? void 0 : (_currentState$context2 = currentState.context) === null || _currentState$context2 === void 0 ? void 0 : _currentState$context2.contactMethod) || getmfaTypeFromInt(currentState === null || currentState === void 0 ? void 0 : (_currentState$context3 = currentState.context) === null || _currentState$context3 === void 0 ? void 0 : (_currentState$context4 = _currentState$context3.currentInfo) === null || _currentState$context4 === void 0 ? void 0 : _currentState$context4.mfaType),
        contactInfo: {
          email: currentState.context.currentInfo.email,
          phone: currentState.context.currentInfo.phone,
          alternateEmail: currentState.context.currentInfo.alternateEmail
        },
        onSubmitCode: function onSubmitCode(token) {
          return send({
            type: events$c.CODE,
            token: token
          });
        },
        onSubmitContactMethod: function onSubmitContactMethod(contactMethod) {
          return send({
            type: events$c.SUBMIT,
            contactMethod: contactMethod
          });
        },
        onGoToContactOptions: function onGoToContactOptions() {
          return send(events$c.OPTIONS);
        },
        onResendCode: function onResendCode() {
          return send(events$c.RESEND);
        },
        onGoBack: function onGoBack() {
          return send(events$c.BACK);
        },
        showMFAInfoPage: currentState.matches("".concat(authStates.twoFA, ".mfaInfoPage")),
        showSixDigit: currentState.matches("".concat(authStates.twoFA, ".enterSixDigit")),
        showContactMethodPicker: currentState.matches("".concat(authStates.twoFA, ".contactOptions")),
        isSending: currentState.matches("".concat(authStates.twoFA, ".contactOptions.sendTokenWithNewMethod")) || currentState.matches("".concat(authStates.twoFA, ".enterSixDigit.resendCode"))
      })]
    })
  });
}

var _StyledHeading$2 = styled(Heading).withConfig({
  displayName: "user-auth___StyledHeading",
  componentId: "sc-1cat76s-0"
})(["font-size:1.75rem;font-weight:600;padding-bottom:2rem;border-bottom:2px solid rgba(0,0,0,0.1);"]);

function PasswordReset(_ref) {
  var guid = _ref.guid,
      containerRef = _ref.containerRef,
      onLoginClick = _ref.onLoginClick;

  var _useUserService = useUserService(),
      onResetPassword = _useUserService.onResetPassword,
      onResetPasswordError = _useUserService.onResetPasswordError,
      openUserAuthModal = _useUserService.openUserAuthModal;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isComplete = _useState2[0],
      setIsComplete = _useState2[1];

  var formik = useFormik({
    initialValues: {
      password: ''
    },
    validationSchema: ResetPasswordSchema,
    onSubmit: function onSubmit(values) {
      var password = values.password;
      onResetPassword({
        payload: {
          password: password,
          guid: guid
        },
        cb: onSuccessfulPasswordReset
      });
    }
  });
  useEffect(function () {
    containerRef.current.focus();
  }, []);
  useTabTrapper(containerRef, [], null);

  var onSuccessfulPasswordReset = function onSuccessfulPasswordReset() {
    setIsComplete(true);
  };

  var onPasswordResetToLogin = function onPasswordResetToLogin() {
    onLoginClick();
    openUserAuthModal(AUTH_VIEW_STATES.LOGIN_VIEW);
  };

  var errors = formik.errors,
      values = formik.values,
      dirty = formik.dirty,
      handleChange = formik.handleChange,
      handleSubmit = formik.handleSubmit;
  return /*#__PURE__*/jsxs(Box$1, {
    flexDirection: "column",
    px: "half",
    children: [/*#__PURE__*/jsx$1(Heading, {
      as: "h2",
      headingStyle: 2,
      mb: 3,
      textAlign: "center",
      children: "Reset your password"
    }), /*#__PURE__*/jsxs(Fragment, {
      children: [!isComplete && /*#__PURE__*/jsxs("form", {
        id: "reset-password-form",
        onSubmit: handleSubmit,
        children: [/*#__PURE__*/jsx$1(Text$1, {
          mb: 3,
          textAlign: "center",
          children: "Please enter your new password. It must contain at least one lowercase, one uppercase, one number, and one symbol."
        }), /*#__PURE__*/jsx$1(Input$5, {
          name: "password",
          errorMessage: errors.password,
          hasError: !!errors.password,
          id: "new-password",
          label: "new password",
          onChange: handleChange,
          type: "password",
          mb: 2,
          value: values.password
        }, 'password'), onResetPasswordError && /*#__PURE__*/jsx$1(Message, {
          mb: 2,
          variant: "error",
          children: onResetPasswordError.errorMessage || onResetPasswordError.Message || onResetPasswordError.toString()
        }), /*#__PURE__*/jsx$1(Button$1, {
          type: "submit",
          ariaLabel: "submit new password",
          color: "greenDark",
          id: "new-password-submit",
          disabled: !!errors.password || !dirty,
          children: "set new password"
        })]
      }), isComplete && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx$1(Text$1, {
          mb: "big",
          textAlign: "center",
          children: "Your password was updated successfully."
        }), /*#__PURE__*/jsx$1(Button$1, {
          ariaLabel: "go to login",
          color: "greenDark",
          id: "back-to-login",
          onClick: onPasswordResetToLogin,
          children: "log in here"
        })]
      })]
    })]
  });
}

function PasswordResetModal() {
  var _useUserService2 = useUserService(),
      validatePasswordGUID = _useUserService2.validatePasswordGUID;

  var _useModal = useModal(),
      openModal = _useModal.openModal,
      closeModal = _useModal.closeModal,
      Modal = _useModal.Modal,
      containerRef = _useModal.containerRef,
      isOpen = _useModal.isOpen;

  var _useState3 = useState(),
      _useState4 = _slicedToArray$4(_useState3, 2),
      guid = _useState4[0],
      setGUID = _useState4[1];

  useEffect(function () {
    // Update the document title using the browser API
    var decoded = decodeURIComponent(window.location.search);
    var params = queryString.parse(decoded);

    if (params.reset) {
      setGUID(params.GUID);
      validatePasswordGUID({
        guid: params.GUID,
        cb: openModal
      });
    }
  }, []); // if (!guid) return null

  return /*#__PURE__*/jsx$1(Modal, {
    closeBtnCb: closeModal,
    id: "password-reset-modal",
    isOpen: isOpen,
    onBgClick: closeModal,
    onCancel: closeModal,
    onEscapeKey: closeModal,
    children: /*#__PURE__*/jsx$1(PasswordReset, {
      containerRef: containerRef,
      guid: guid,
      onLoginClick: closeModal
    })
  });
}

var events$b = {
  CHOOSE: 'choose',
  DONE: 'done-selecting-card'
};
var machineOpts$b = {
  actions: {
    handleSelectedPaymentOption: assign$2(function (_, evt) {
      return {
        selectedPaymentOptions: evt.payload
      };
    })
  }
};
var selectPaymentMachine = createMachine({
  id: 'default',
  initial: 'idle',
  context: {
    selectedPaymentOptions: null,
    allPaymentOptions: null
  },
  states: {
    idle: {
      on: _defineProperty$6({}, events$b.CHOOSE, {
        target: 'idle',
        actions: 'handleSelectedPaymentOption'
      })
    },
    done: {
      on: _defineProperty$6({}, events$b.DONE, [{
        target: 'idle'
      }])
    }
  }
}, machineOpts$b);
var paymentTypes = {
  creditCard: 'creditCard',
  paypal: 'PayPal'
}; // Example usage:
// export const SelectorTest = () => {
//   const [selected, setSelected] = useState(paymentTypes.creditCard)
//   const handleSelected = id => {
//     setSelected(id)
//   }
//   return (
//     <Selector
//       onChange={handleSelected}
//       options={paymentSelectorOptions}
//       selected={selected}
//       withRadio
//     />
//   )
// }

function _regenerator$M() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$M(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$M(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$M(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$M(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$M(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$M(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$M(u), _regeneratorDefine2$M(u, o, "Generator"), _regeneratorDefine2$M(u, n, function () {
    return this;
  }), _regeneratorDefine2$M(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$M = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$M(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$M = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$M(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$M(e, r, n, t);
} // SERVICES


var addCard = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$M().m(function _callee(ctx, evt) {
    var _evt$payload, user, card;

    return _regenerator$M().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            _evt$payload = evt.payload, user = _evt$payload.user, card = _evt$payload.card;

            if (!(card.type === paymentTypes.paypal)) {
              _context.n = 1;
              break;
            }

            return _context.a(2, addNewPayPal({
              user: user,
              card: card
            }));

          case 1:
            return _context.a(2);
        }
      }
    }, _callee);
  }));

  return function addCard(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}(); // EVENTS


var events$a = {
  ADD: 'add',
  RETRY: 'retry'
}; // ADD CREDIT CARD MACHINE

var machineOpts$a = {
  services: {
    addCard: addCard
  },
  actions: {
    cacheError: assign$2({
      error: function error(ctx, evt) {
        var _evt$data, _evt$data$response;

        var error = (evt === null || evt === void 0 ? void 0 : (_evt$data = evt.data) === null || _evt$data === void 0 ? void 0 : (_evt$data$response = _evt$data.response) === null || _evt$data$response === void 0 ? void 0 : _evt$data$response.data) || (evt === null || evt === void 0 ? void 0 : evt.data); // backend returns either message or card prop

        tracker$1('Client Error', {
          type: 'add-card-machine-error',
          location: 'add-card.machine',
          error: error
        });
        var message = error === null || error === void 0 ? void 0 : error.message;

        if (!message) {
          message = error === null || error === void 0 ? void 0 : error.card;
        }

        return {
          message: message
        };
      }
    }),
    onSuccess: function onSuccess() {// Placeholder - overridden when used by component
    }
  },
  guards: {
    maxRetriesReached: function maxRetriesReached(ctx) {
      return ctx.retries >= 2;
    }
  }
};
var addCardMachine = Machine({
  id: 'add',
  initial: 'idle',
  context: {
    retries: 0,
    error: null
  },
  states: {
    idle: {
      on: _defineProperty$6({}, events$a.ADD, 'loading')
    },
    loading: {
      invoke: {
        id: 'add-card',
        src: 'addCard',
        onDone: {
          target: 'success',
          actions: 'onSuccess'
        },
        onError: {
          target: 'failure',
          actions: 'cacheError'
        }
      }
    },
    success: {
      after: {
        500: {
          target: 'idle'
        }
      }
    },
    failure: {
      on: _defineProperty$6({}, events$a.RETRY, [{
        cond: 'maxRetriesReached',
        target: 'maxAddRetries'
      }, {
        target: 'loading',
        actions: assign$2({
          retries: function retries(context) {
            return context.retries + 1;
          }
        })
      }])
    },
    maxAddRetries: {
      after: {
        500: {
          target: 'idle'
        }
      }
    }
  }
}, machineOpts$a); // SERVICES

var setDefaultCard = function setDefaultCard(ctx, evt) {
  var creditCardID = evt.payload.creditCardID;
  return put$1("".concat(creditCardEndpoints["default"], "/").concat(creditCardID));
}; // EVENTS


var events$9 = {
  DEFAULT: 'default',
  ERROR: 'error'
}; // SET DEFAULT CREDIT CARD MACHINE

var machineOpts$9 = {
  services: {
    setDefaultCard: setDefaultCard
  },
  actions: {
    cacheError: assign$2({
      error: function error(ctx, evt) {
        var _evt$data, _evt$data$response;

        var error = evt === null || evt === void 0 ? void 0 : (_evt$data = evt.data) === null || _evt$data === void 0 ? void 0 : (_evt$data$response = _evt$data.response) === null || _evt$data$response === void 0 ? void 0 : _evt$data$response.data;
        tracker$1('Client Error', {
          type: 'default-card-machine-error',
          location: 'default-card.machine',
          error: error
        });
        return error;
      }
    }),
    cacheCardID: assign$2({
      cardId: function cardId(ctx, evt) {
        return evt.payload.creditCardID;
      }
    }),
    removeCardID: assign$2({
      cardId: null
    }),
    onSuccess: function onSuccess() {}
  },
  guards: {
    maxRetriesReached: function maxRetriesReached(ctx) {
      return ctx.retries >= 3;
    }
  }
};
var defaultCardMachine = Machine({
  id: 'default',
  initial: 'idle',
  context: {
    cardId: null,
    retries: 0,
    error: null
  },
  states: {
    idle: {
      on: _defineProperty$6({}, events$9.DEFAULT, 'loading')
    },
    loading: {
      entry: 'cacheCardID',
      invoke: {
        id: 'setDefaultCard',
        src: 'setDefaultCard',
        onDone: {
          target: 'success',
          actions: 'onSuccess'
        },
        onError: {
          target: 'failure',
          actions: 'cacheError'
        }
      },
      exit: 'removeCardID'
    },
    success: {
      after: {
        500: {
          target: 'idle'
        }
      }
    },
    failure: {
      on: _defineProperty$6({}, events$9.ERROR, [{// TODO error message
      }, {
        target: 'loading',
        actions: assign$2({
          retries: function retries(context) {
            return context.retries + 1;
          }
        })
      }])
    }
  }
}, machineOpts$9); // SERVICES

var deleteCard = function deleteCard(ctx, evt) {
  var creditCardID = evt.payload.creditCardID;
  return del$1("".concat(creditCardEndpoints.card, "/").concat(creditCardID));
}; // EVENTS


var events$8 = {
  DELETE: 'delete',
  RETRY: 'retry'
}; // DELETE CREDIT CARD MACHINE

var machineOpts$8 = {
  services: {
    deleteCard: deleteCard
  },
  actions: {
    cacheError: assign$2({
      error: function error(ctx, evt) {
        var _evt$data, _evt$data$response;

        var error = evt === null || evt === void 0 ? void 0 : (_evt$data = evt.data) === null || _evt$data === void 0 ? void 0 : (_evt$data$response = _evt$data.response) === null || _evt$data$response === void 0 ? void 0 : _evt$data$response.data;
        tracker$1('Client Error', {
          type: 'delete-card-machine-error',
          location: 'delete-card.machine',
          error: error
        });
        return error;
      }
    }),
    onSuccess: function onSuccess() {// Placeholder - overridden when used by component
    }
  },
  guards: {
    maxRetriesReached: function maxRetriesReached(ctx) {
      return ctx.retries >= 3;
    }
  }
};
var delCardMachine = Machine({
  id: 'delete',
  initial: 'idle',
  context: {
    retries: 0,
    error: null
  },
  states: {
    idle: {
      on: _defineProperty$6({}, events$8.DELETE, 'loading')
    },
    loading: {
      invoke: {
        id: 'delete-card',
        src: 'deleteCard',
        onDone: {
          target: 'success',
          actions: 'onSuccess'
        },
        onError: {
          target: 'failure',
          actions: 'cacheError'
        }
      }
    },
    success: {
      after: {
        500: {
          target: 'idle'
        }
      }
    },
    failure: {
      on: _defineProperty$6({}, events$8.RETRY, [{
        cond: 'maxRetriesReached',
        target: 'maxDeleteRetries'
      }, {
        target: 'loading',
        actions: assign$2({
          retries: function retries(context) {
            return context.retries + 1;
          }
        })
      }])
    },
    maxDeleteRetries: {
      type: 'final'
    }
  }
}, machineOpts$8); // SERVICES

var editCard = function editCard(ctx, evt) {
  var _evt$payload = evt.payload,
      creditCardID = _evt$payload.creditCardID,
      cardExpiry = _evt$payload.cardExpiry,
      cardName = _evt$payload.cardName,
      cardCVV = _evt$payload.cardCVV;
  return put$1("".concat(creditCardEndpoints.card, "/").concat(creditCardID), {
    cardExpiry: cardExpiry,
    cardName: cardName,
    cardCVV: cardCVV
  });
}; // EVENTS


var events$7 = {
  EDIT: 'edit',
  RETRY: 'retry'
}; // EDIT CREDIT CARD MACHINE

var machineOpts$7 = {
  services: {
    editCard: editCard
  },
  actions: {
    cacheError: assign$2({
      error: function error(ctx, evt) {
        var _evt$data, _evt$data$response;

        var error = evt === null || evt === void 0 ? void 0 : (_evt$data = evt.data) === null || _evt$data === void 0 ? void 0 : (_evt$data$response = _evt$data.response) === null || _evt$data$response === void 0 ? void 0 : _evt$data$response.data;
        tracker$1('Client Error', {
          type: 'edit-card-machine-error',
          location: 'edit-card.machine',
          error: error
        });
        return error;
      }
    }),
    onSuccess: function onSuccess() {// Placeholder - overridden when used by component
    }
  },
  guards: {
    maxRetriesReached: function maxRetriesReached(ctx) {
      return ctx.retries >= 3;
    }
  }
};
var editCardMachine = Machine({
  id: 'edit',
  initial: 'idle',
  context: {
    retries: 0,
    error: null
  },
  states: {
    idle: {
      on: _defineProperty$6({}, events$7.EDIT, 'loading')
    },
    loading: {
      invoke: {
        id: 'edit-card',
        src: 'editCard',
        onDone: {
          target: 'success',
          actions: 'onSuccess'
        },
        onError: {
          target: 'failure',
          actions: 'cacheError'
        }
      }
    },
    success: {
      after: {
        500: {
          target: 'idle'
        }
      }
    },
    failure: {
      on: _defineProperty$6({}, events$7.RETRY, [{
        cond: 'maxRetriesReached',
        target: 'maxEditRetries'
      }, {
        target: 'loading',
        actions: assign$2({
          retries: function retries(context) {
            return context.retries + 1;
          }
        })
      }])
    },
    maxEditRetries: {
      type: 'final'
    }
  }
}, machineOpts$7);

function ownKeys$S(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$S(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$S(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$S(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var CreditCardPaymentContext = /*#__PURE__*/React__default.createContext({});

function CreditCardServiceProvider(props) {
  var _useUserService = useUserService(),
      fetchUserInfo = _useUserService.fetchUserInfo;

  var _useMachine = useMachine(delCardMachine),
      _useMachine2 = _slicedToArray$4(_useMachine, 2),
      currentDeleteState = _useMachine2[0],
      sendDelEvents = _useMachine2[1];

  var isDeleteLoading = currentDeleteState.matches('loading');
  var hasDeleteError = currentDeleteState.matches('failure');
  var deleteMaxRetriesReached = currentDeleteState.matches('maxDeleteRetries');
  var isDeleteSuccessful = currentDeleteState.matches('success');

  var _useMachine3 = useMachine(editCardMachine, {
    actions: {
      onSuccess: fetchUserInfo
    }
  }),
      _useMachine4 = _slicedToArray$4(_useMachine3, 2),
      currentEditState = _useMachine4[0],
      sendEditEvents = _useMachine4[1];

  var isEditLoading = currentEditState.matches('loading');
  var hasEditError = currentEditState.matches('failure');
  var editMaxRetriesReached = currentEditState.matches('maxEditRetries');
  var isEditSuccessful = currentEditState.matches('success');

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isNewCard = _useState2[0],
      setNewCard = _useState2[1];

  var _useMachine5 = useMachine(defaultCardMachine, {
    actions: {
      onSuccess: fetchUserInfo
    }
  }),
      _useMachine6 = _slicedToArray$4(_useMachine5, 2),
      currentDefaultState = _useMachine6[0],
      sendDefaultEvents = _useMachine6[1];

  var _useMachine7 = useMachine(addCardMachine, {
    actions: {
      onSuccess: fetchUserInfo
    }
  }),
      _useMachine8 = _slicedToArray$4(_useMachine7, 2),
      currentAddCardState = _useMachine8[0],
      sendAddCardEvents = _useMachine8[1];

  var _useMachine9 = useMachine(selectPaymentMachine),
      _useMachine0 = _slicedToArray$4(_useMachine9, 2),
      paymentOption = _useMachine0[0],
      sendSelectPaymentEvents = _useMachine0[1];

  var delCreditCard = function delCreditCard(shouldRetry, cardId) {
    sendDelEvents({
      type: shouldRetry ? events$8.RETRY : events$8.DELETE,
      payload: {
        creditCardID: cardId
      }
    });
  };

  var editCreditCard = function editCreditCard(shouldRetry, cardId, cardExpiry, cardName, cardCVV) {
    sendEditEvents({
      type: shouldRetry ? events$7.RETRY : events$7.EDIT,
      payload: {
        creditCardID: cardId,
        cardExpiry: cardExpiry,
        cardName: cardName,
        cardCVV: cardCVV
      }
    });
  };

  var setDefaultCreditCard = function setDefaultCreditCard(cardId) {
    sendDefaultEvents({
      type: events$9.DEFAULT,
      payload: {
        creditCardID: cardId
      }
    });
  };

  var hasErrorSettingDefaultCard = currentDefaultState.matches('error');
  var isDefaultLoading = currentDefaultState.matches('loading');
  var defaultCardId = currentDefaultState.context.cardId;

  var addCard = function addCard(shouldRetry, payload) {
    sendAddCardEvents({
      type: shouldRetry ? events$a.RETRY : events$a.ADD,
      payload: payload
    });
  };

  var selectPaymentOption = function selectPaymentOption(payload) {
    sendSelectPaymentEvents({
      type: events$b.CHOOSE,
      payload: payload
    });
  };

  var _useMachine1 = useMachine(addCardMachine, {
    actions: {
      onSuccess: function onSuccess(_, _ref) {
        var data = _ref.data;
        return selectPaymentOption(data);
      }
    }
  }),
      _useMachine10 = _slicedToArray$4(_useMachine1, 2),
      addCardStateNoReload = _useMachine10[0],
      sendNoReloadEvent = _useMachine10[1];

  var addCardNoReload = function addCardNoReload(shouldRetry, payload) {
    sendNoReloadEvent({
      type: shouldRetry ? events$a.RETRY : events$a.ADD,
      payload: payload
    });
  };

  var hasAddCardError = currentAddCardState.matches('failure') || addCardStateNoReload.matches('failure');
  var isAddCardSuccessful = currentAddCardState.matches('success') || addCardStateNoReload.matches('success');
  var isAddCardLoading = currentAddCardState.matches('loading') || addCardStateNoReload.matches('loading');
  var addCardMaxRetriesReached = currentAddCardState.matches('maxAddRetries');
  var addCardErrorMessage;

  if (currentAddCardState.context.error) {
    var _currentAddCardState$;

    addCardErrorMessage = (_currentAddCardState$ = currentAddCardState.context.error) === null || _currentAddCardState$ === void 0 ? void 0 : _currentAddCardState$.message;
  } else if (addCardStateNoReload.context.error) {
    var _addCardStateNoReload;

    addCardErrorMessage = (_addCardStateNoReload = addCardStateNoReload.context.error) === null || _addCardStateNoReload === void 0 ? void 0 : _addCardStateNoReload.message;
  }

  var value = useMemo(function () {
    return {
      isNewCard: isNewCard,
      setNewCard: setNewCard,
      currentDeleteState: currentDeleteState,
      delCreditCard: delCreditCard,
      editCreditCard: editCreditCard,
      addCard: addCard,
      setDefaultCreditCard: setDefaultCreditCard,
      addCardNoReload: addCardNoReload,
      addCardStateNoReload: addCardStateNoReload,
      hasAddCardError: hasAddCardError,
      isAddCardSuccessful: isAddCardSuccessful,
      isAddCardLoading: isAddCardLoading,
      addCardMaxRetriesReached: addCardMaxRetriesReached,
      addCardErrorMessage: addCardErrorMessage,
      hasErrorSettingDefaultCard: hasErrorSettingDefaultCard,
      isDefaultLoading: isDefaultLoading,
      defaultCardId: defaultCardId,
      isDeleteLoading: isDeleteLoading,
      isDeleteSuccessful: isDeleteSuccessful,
      hasDeleteError: hasDeleteError,
      deleteMaxRetriesReached: deleteMaxRetriesReached,
      isEditLoading: isEditLoading,
      isEditSuccessful: isEditSuccessful,
      hasEditError: hasEditError,
      editMaxRetriesReached: editMaxRetriesReached,
      paymentOption: paymentOption,
      selectPaymentOption: selectPaymentOption
    };
  }, [setNewCard, isNewCard, currentDeleteState, delCreditCard, editCreditCard, addCard, setDefaultCreditCard, addCardNoReload, addCardStateNoReload, hasAddCardError, isAddCardSuccessful, isAddCardLoading, addCardMaxRetriesReached, addCardErrorMessage, hasErrorSettingDefaultCard, isDefaultLoading, defaultCardId, isDeleteLoading, isDeleteSuccessful, hasDeleteError, deleteMaxRetriesReached, isEditLoading, isEditSuccessful, hasEditError, editMaxRetriesReached, paymentOption, selectPaymentOption]);
  return /*#__PURE__*/jsx$1(CreditCardPaymentContext.Provider, _objectSpread$S({
    value: value
  }, props));
}

function useCreditCardService() {
  var ccPaymentCtx = React__default.useContext(CreditCardPaymentContext);

  if (!ccPaymentCtx) {
    throw new Error("useCreditCardService must be used within a CreditCardServiceProvider");
  }

  return ccPaymentCtx;
}

var _excluded$k = ["userName", "onSwitchAccounts"];

function ownKeys$R(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$R(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$R(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$R(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var UserNamePanel = function UserNamePanel(_ref) {
  var userName = _ref.userName,
      onSwitchAccounts = _ref.onSwitchAccounts,
      rest = _objectWithoutProperties$8(_ref, _excluded$k);

  return /*#__PURE__*/jsxs(Box$1, _objectSpread$R(_objectSpread$R({
    justifyContent: ['center', 'space-between', 'center', 'space-between'],
    display: ['block', 'flex', 'block', 'flex'],
    width: "100%"
  }, rest), {}, {
    children: [/*#__PURE__*/jsxs(Text$1, {
      display: "flex",
      alignSelf: "center",
      children: ["Account:", /*#__PURE__*/jsx$1(Text$1, {
        fontWeight: "bold",
        ml: 1,
        mr: 3,
        children: userName
      })]
    }), /*#__PURE__*/jsx$1(Button$1, {
      ariaLabel: "switch account",
      id: "switch-account-link",
      onClick: onSwitchAccounts,
      variant: "underlined",
      color: "black",
      py: [2, 0, 2, 0],
      children: "Switch account"
    })]
  }));
};

var propTypes$P = {
  strings: PropTypes.shape({
    defaultCardError: PropTypes.string.isRequired
  }).isRequired
};

function DefaultCardErrorMessage(_ref) {
  var strings = _ref.strings;

  var _useCreditCardService = useCreditCardService(),
      hasErrorSettingDefaultCard = _useCreditCardService.hasErrorSettingDefaultCard;

  if (!hasErrorSettingDefaultCard) {
    return null;
  }

  return /*#__PURE__*/jsx$1(Stack$2, {
    my: 3,
    children: /*#__PURE__*/jsx$1(Message, {
      variant: "error",
      children: strings.defaultCardError
    })
  });
}

DefaultCardErrorMessage.propTypes = propTypes$P; // This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239

var metadata$1 = {
  "version": 4,
  "country_calling_codes": {
    "1": ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"],
    "7": ["RU", "KZ"],
    "20": ["EG"],
    "27": ["ZA"],
    "30": ["GR"],
    "31": ["NL"],
    "32": ["BE"],
    "33": ["FR"],
    "34": ["ES"],
    "36": ["HU"],
    "39": ["IT", "VA"],
    "40": ["RO"],
    "41": ["CH"],
    "43": ["AT"],
    "44": ["GB", "GG", "IM", "JE"],
    "45": ["DK"],
    "46": ["SE"],
    "47": ["NO", "SJ"],
    "48": ["PL"],
    "49": ["DE"],
    "51": ["PE"],
    "52": ["MX"],
    "53": ["CU"],
    "54": ["AR"],
    "55": ["BR"],
    "56": ["CL"],
    "57": ["CO"],
    "58": ["VE"],
    "60": ["MY"],
    "61": ["AU", "CC", "CX"],
    "62": ["ID"],
    "63": ["PH"],
    "64": ["NZ"],
    "65": ["SG"],
    "66": ["TH"],
    "81": ["JP"],
    "82": ["KR"],
    "84": ["VN"],
    "86": ["CN"],
    "90": ["TR"],
    "91": ["IN"],
    "92": ["PK"],
    "93": ["AF"],
    "94": ["LK"],
    "95": ["MM"],
    "98": ["IR"],
    "211": ["SS"],
    "212": ["MA", "EH"],
    "213": ["DZ"],
    "216": ["TN"],
    "218": ["LY"],
    "220": ["GM"],
    "221": ["SN"],
    "222": ["MR"],
    "223": ["ML"],
    "224": ["GN"],
    "225": ["CI"],
    "226": ["BF"],
    "227": ["NE"],
    "228": ["TG"],
    "229": ["BJ"],
    "230": ["MU"],
    "231": ["LR"],
    "232": ["SL"],
    "233": ["GH"],
    "234": ["NG"],
    "235": ["TD"],
    "236": ["CF"],
    "237": ["CM"],
    "238": ["CV"],
    "239": ["ST"],
    "240": ["GQ"],
    "241": ["GA"],
    "242": ["CG"],
    "243": ["CD"],
    "244": ["AO"],
    "245": ["GW"],
    "246": ["IO"],
    "247": ["AC"],
    "248": ["SC"],
    "249": ["SD"],
    "250": ["RW"],
    "251": ["ET"],
    "252": ["SO"],
    "253": ["DJ"],
    "254": ["KE"],
    "255": ["TZ"],
    "256": ["UG"],
    "257": ["BI"],
    "258": ["MZ"],
    "260": ["ZM"],
    "261": ["MG"],
    "262": ["RE", "YT"],
    "263": ["ZW"],
    "264": ["NA"],
    "265": ["MW"],
    "266": ["LS"],
    "267": ["BW"],
    "268": ["SZ"],
    "269": ["KM"],
    "290": ["SH", "TA"],
    "291": ["ER"],
    "297": ["AW"],
    "298": ["FO"],
    "299": ["GL"],
    "350": ["GI"],
    "351": ["PT"],
    "352": ["LU"],
    "353": ["IE"],
    "354": ["IS"],
    "355": ["AL"],
    "356": ["MT"],
    "357": ["CY"],
    "358": ["FI", "AX"],
    "359": ["BG"],
    "370": ["LT"],
    "371": ["LV"],
    "372": ["EE"],
    "373": ["MD"],
    "374": ["AM"],
    "375": ["BY"],
    "376": ["AD"],
    "377": ["MC"],
    "378": ["SM"],
    "380": ["UA"],
    "381": ["RS"],
    "382": ["ME"],
    "383": ["XK"],
    "385": ["HR"],
    "386": ["SI"],
    "387": ["BA"],
    "389": ["MK"],
    "420": ["CZ"],
    "421": ["SK"],
    "423": ["LI"],
    "500": ["FK"],
    "501": ["BZ"],
    "502": ["GT"],
    "503": ["SV"],
    "504": ["HN"],
    "505": ["NI"],
    "506": ["CR"],
    "507": ["PA"],
    "508": ["PM"],
    "509": ["HT"],
    "590": ["GP", "BL", "MF"],
    "591": ["BO"],
    "592": ["GY"],
    "593": ["EC"],
    "594": ["GF"],
    "595": ["PY"],
    "596": ["MQ"],
    "597": ["SR"],
    "598": ["UY"],
    "599": ["CW", "BQ"],
    "670": ["TL"],
    "672": ["NF"],
    "673": ["BN"],
    "674": ["NR"],
    "675": ["PG"],
    "676": ["TO"],
    "677": ["SB"],
    "678": ["VU"],
    "679": ["FJ"],
    "680": ["PW"],
    "681": ["WF"],
    "682": ["CK"],
    "683": ["NU"],
    "685": ["WS"],
    "686": ["KI"],
    "687": ["NC"],
    "688": ["TV"],
    "689": ["PF"],
    "690": ["TK"],
    "691": ["FM"],
    "692": ["MH"],
    "850": ["KP"],
    "852": ["HK"],
    "853": ["MO"],
    "855": ["KH"],
    "856": ["LA"],
    "880": ["BD"],
    "886": ["TW"],
    "960": ["MV"],
    "961": ["LB"],
    "962": ["JO"],
    "963": ["SY"],
    "964": ["IQ"],
    "965": ["KW"],
    "966": ["SA"],
    "967": ["YE"],
    "968": ["OM"],
    "970": ["PS"],
    "971": ["AE"],
    "972": ["IL"],
    "973": ["BH"],
    "974": ["QA"],
    "975": ["BT"],
    "976": ["MN"],
    "977": ["NP"],
    "992": ["TJ"],
    "993": ["TM"],
    "994": ["AZ"],
    "995": ["GE"],
    "996": ["KG"],
    "998": ["UZ"]
  },
  "countries": {
    "AC": ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]],
    "AD": ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]],
    "AE": ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"],
    "AF": ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"],
    "AG": ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"],
    "AI": ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"],
    "AL": ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"],
    "AM": ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"],
    "AO": ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]],
    "AR": ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"],
    "AS": ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"],
    "AT": ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"],
    "AU": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:2(?:(?:[0-26-9]\\d|3[0-8]|5[0135-9])\\d|4(?:[02-9]\\d|10))|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90))|7(?:[013-57-9]\\d|2[0-8])\\d)\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|[34]\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"],
    "AW": ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]],
    "AX": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"],
    "AZ": ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"],
    "BA": ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"],
    "BB": ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"],
    "BD": ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"],
    "BE": ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"],
    "BF": ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]],
    "BG": ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"],
    "BH": ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]],
    "BI": ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]],
    "BJ": ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]],
    "BL": ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]],
    "BM": ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"],
    "BN": ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]],
    "BO": ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"],
    "BQ": ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"],
    "BR": ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37|86)", "300|4(?:0(?:0|20)|370|864)"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"],
    "BS": ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"],
    "BT": ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]],
    "BW": ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]],
    "BY": ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"],
    "BZ": ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]],
    "CA": ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]],
    "CC": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"],
    "CD": ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"],
    "CF": ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]],
    "CG": ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]],
    "CH": ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"],
    "CI": ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]],
    "CK": ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]],
    "CL": ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]],
    "CM": ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]],
    "CN": ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"],
    "CO": ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|9[14]"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"],
    "CR": ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"],
    "CU": ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"],
    "CV": ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]],
    "CW": ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"],
    "CX": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"],
    "CY": ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]],
    "CZ": ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]],
    "DE": ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"],
    "DJ": ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]],
    "DK": ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]],
    "DM": ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"],
    "DO": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"],
    "DZ": ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"],
    "EC": ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"],
    "EE": ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]],
    "EG": ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"],
    "EH": ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"],
    "ER": ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"],
    "ES": ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]],
    "ET": ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"],
    "FI": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"],
    "FJ": ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
    "FK": ["500", "00", "[2-7]\\d{4}", [5]],
    "FM": ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]],
    "FO": ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"],
    "FR": ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"],
    "GA": ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"],
    "GB": ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"],
    "GD": ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"],
    "GE": ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"],
    "GF": ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"],
    "GG": ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]],
    "GH": ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"],
    "GI": ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]],
    "GL": ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]],
    "GM": ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]],
    "GN": ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]],
    "GP": ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]],
    "GQ": ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]],
    "GR": ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]],
    "GT": ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]],
    "GU": ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"],
    "GW": ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]],
    "GY": ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]],
    "HK": ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
    "HN": ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]],
    "HR": ["385", "00", "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}", [7, 8, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"],
    "HT": ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]],
    "HU": ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"],
    "ID": ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"],
    "IE": ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"],
    "IL": ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"],
    "IM": ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"],
    "IN": ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"],
    "IO": ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]],
    "IQ": ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"],
    "IR": ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"],
    "IS": ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
    "IT": ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]],
    "JE": ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]],
    "JM": ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"],
    "JO": ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"],
    "JP": ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"],
    "KE": ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"],
    "KG": ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"],
    "KH": ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"],
    "KI": ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"],
    "KM": ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]],
    "KN": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"],
    "KP": ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"],
    "KR": ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"],
    "KW": ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]],
    "KY": ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"],
    "KZ": ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"],
    "LA": ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["3"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"],
    "LB": ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-6]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"],
    "LC": ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"],
    "LI": ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"],
    "LK": ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"],
    "LR": ["231", "00", "(?:[2457]\\d|33|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"],
    "LS": ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]],
    "LT": ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"],
    "LU": ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"],
    "LV": ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]],
    "LY": ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"],
    "MA": ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-467]|5[0-3]|8[0-7]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]],
    "MC": ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"],
    "MD": ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"],
    "ME": ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"],
    "MF": ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]],
    "MG": ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"],
    "MH": ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"],
    "MK": ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"],
    "ML": ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]],
    "MM": ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"],
    "MN": ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"],
    "MO": ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]],
    "MP": ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"],
    "MQ": ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"],
    "MR": ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]],
    "MS": ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"],
    "MT": ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]],
    "MU": ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"],
    "MV": ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
    "MW": ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"],
    "MX": ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
    "MY": ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"],
    "MZ": ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]],
    "NA": ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"],
    "NC": ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]],
    "NE": ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]],
    "NF": ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"],
    "NG": ["234", "009", "(?:20|9\\d)\\d{8}|[78]\\d{9,13}", [10, 11, 12, 13, 14], [["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"],
    "NI": ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]],
    "NL": ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"],
    "NO": ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"],
    "NP": ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"],
    "NR": ["674", "00", "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[24-9]"]]]],
    "NU": ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]],
    "NZ": ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"],
    "OM": ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]],
    "PA": ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]],
    "PE": ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "],
    "PF": ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]],
    "PG": ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
    "PH": ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"],
    "PK": ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"],
    "PL": ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]],
    "PM": ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"],
    "PR": ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"],
    "PS": ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"],
    "PT": ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]],
    "PW": ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]],
    "PY": ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"],
    "QA": ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[136]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]],
    "RE": ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]],
    "RO": ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "],
    "RS": ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"],
    "RU": ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"],
    "RW": ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"],
    "SA": ["966", "00", "(?:[15]\\d|800|92)\\d{7}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"],
    "SB": ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]],
    "SC": ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
    "SD": ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"],
    "SE": ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"],
    "SG": ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]],
    "SH": ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"],
    "SI": ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"],
    "SJ": ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"],
    "SK": ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"],
    "SL": ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"],
    "SM": ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"],
    "SN": ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]],
    "SO": ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"],
    "SR": ["597", "00", "(?:[2-5]|68|[78]\\d|90)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-9]"]]]],
    "SS": ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"],
    "ST": ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]],
    "SV": ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]],
    "SX": ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"],
    "SY": ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"],
    "SZ": ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]],
    "TA": ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"],
    "TC": ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"],
    "TD": ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
    "TG": ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]],
    "TH": ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"],
    "TJ": ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"],
    "TK": ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]],
    "TL": ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]],
    "TM": ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"],
    "TN": ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]],
    "TO": ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]],
    "TR": ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"],
    "TT": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"],
    "TV": ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]],
    "TW": ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"],
    "TZ": ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"],
    "UA": ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"],
    "UG": ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"],
    "US": ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[0-68]))\\d{4}|(?:2742|305[3-9]|472[247-9]|505[2-57-9]|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]],
    "UY": ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "],
    "UZ": ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]],
    "VA": ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"],
    "VC": ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"],
    "VE": ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"],
    "VG": ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"],
    "VI": ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"],
    "VN": ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"],
    "VU": ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]],
    "WF": ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]],
    "WS": ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]],
    "XK": ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"],
    "YE": ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"],
    "YT": ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]],
    "ZA": ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"],
    "ZM": ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0"],
    "ZW": ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"]
  },
  "nonGeographic": {
    "800": ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]],
    "808": ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]],
    "870": ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]],
    "878": ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]],
    "881": ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]],
    "882": ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]],
    "883": ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]],
    "888": ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]],
    "979": ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]]
  }
}; // Edits text `value` (if `operation` is passed) and repositions the `caret` if needed.
//
// Example:
//
// value - '88005553535'
// caret - 2 // starting from 0; is positioned before the first zero
// operation - 'Backspace'
//
// Returns
// {
// 	value: '8005553535'
// 	caret: 1
// }
//
// Currently supports just 'Delete' and 'Backspace' operations
//

function edit(value, caret, operation) {
  switch (operation) {
    case 'Backspace':
      // If there exists the previous character,
      // then erase it and reposition the caret.
      if (caret > 0) {
        // Remove the previous character
        value = value.slice(0, caret - 1) + value.slice(caret); // Position the caret where the previous (erased) character was

        caret--;
      }

      break;

    case 'Delete':
      // Remove current digit (if any)
      value = value.slice(0, caret) + value.slice(caret + 1);
      break;
  }

  return {
    value: value,
    caret: caret
  };
} // Parses the `text`.
//
// Returns `{ value, caret }` where `caret` is
// the caret position inside `value`
// corresponding to the `caret_position` inside `text`.
//
// The `text` is parsed by feeding each character sequentially to
// `parse_character(character, value, context)` function
// and appending the result (if it's not `undefined`) to `value`.
//
// `context` argument is just a utility empty object that is shared within the bounds
// of parsing a single input string. The `_parse()` function could use that object
// to store any kind of "flags" in it in order to alter its behavior based when
// parsing next characters within the same string. Or it could completely ignore it.
//
// Example:
//
// `text` is `8 (800) 555-35-35`,
// `caret_position` is `4` (before the first `0`).
// `parse_character` is `(character, value) =>
//   if (character >= '0' && character <= '9') { return character }`.
//
// then `parse()` outputs `{ value: '88005553535', caret: 2 }`.
//


function parse(text, caret_position, parse_character) {
  var context = {};
  var value = '';
  var focused_input_character_index = 0;
  var index = 0;

  while (index < text.length) {
    var character = parse_character(text[index], value, context);

    if (character !== undefined) {
      value += character;

      if (caret_position !== undefined) {
        if (caret_position === index) {
          focused_input_character_index = value.length - 1;
        } else if (caret_position > index) {
          focused_input_character_index = value.length;
        }
      }
    }

    index++;
  } // If caret position wasn't specified


  if (caret_position === undefined) {
    // Then set caret position to "after the last input character"
    focused_input_character_index = value.length;
  }

  var result = {
    value: value,
    caret: focused_input_character_index
  };
  return result;
}

function _createForOfIteratorHelperLoose$a(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray$d(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray$d(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$d(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$d(o, minLen);
}

function _arrayLikeToArray$d(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
} // Counts all occurences of a symbol in a string


function count_occurences(symbol, string) {
  var count = 0; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes)
  // but template placeholder characters don't fall into that range
  // so skipping such miscellaneous "exotic" characters
  // won't matter here for just counting placeholder character occurrences.

  for (var _iterator = _createForOfIteratorHelperLoose$a(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;

    if (character === symbol) {
      count++;
    }
  }

  return count;
}

function closeBraces(retained_template, template) {
  var placeholder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'x';
  var empty_placeholder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';
  var cut_before = retained_template.length;
  var opening_braces = count_occurences('(', retained_template);
  var closing_braces = count_occurences(')', retained_template);
  var dangling_braces = opening_braces - closing_braces;

  while (dangling_braces > 0 && cut_before < template.length) {
    retained_template += template[cut_before].replace(placeholder, empty_placeholder);

    if (template[cut_before] === ')') {
      dangling_braces--;
    }

    cut_before++;
  }

  return retained_template;
}

function _createForOfIteratorHelperLoose$9(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray$c(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray$c(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$c(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$c(o, minLen);
}

function _arrayLikeToArray$c(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
} // are denoted by 'x'es (e.g. 'x (xxx) xxx-xx-xx').
//
// Returns a function which takes `value` characters
// and returns the `template` filled with those characters.
// If the `template` can only be partially filled
// then it is cut off.
//
// If `shouldCloseBraces` is `true`,
// then it will also make sure all dangling braces are closed,
// e.g. "8 (8" -> "8 (8  )" (iPhone style phone number input).
//


function template_formatter(template) {
  var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';
  var shouldCloseBraces = arguments.length > 2 ? arguments[2] : undefined;

  if (!template) {
    return function (value) {
      return {
        text: value
      };
    };
  }

  var placeholdersCountInTemplate = count_occurences(placeholder, template);
  return function (value) {
    if (!value) {
      return {
        text: '',
        template: template
      };
    }

    var characterIndexInValue = 0;
    var templateWithFilledInPlaceholders = ''; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes)
    // but template placeholder characters don't fall into that range
    // and appending UTF-8 characters to a string in parts still works.

    for (var _iterator = _createForOfIteratorHelperLoose$9(template.split('')), _step; !(_step = _iterator()).done;) {
      var character = _step.value;

      if (character !== placeholder) {
        templateWithFilledInPlaceholders += character;
        continue;
      }

      templateWithFilledInPlaceholders += value[characterIndexInValue];
      characterIndexInValue++; // If the last available value character has been filled in,
      // then return the filled in template
      // (either trim the right part or retain it,
      //  if no more character placeholders in there)

      if (characterIndexInValue === value.length) {
        // If there are more character placeholders
        // in the right part of the template
        // then simply trim it.
        if (value.length < placeholdersCountInTemplate) {
          break;
        }
      }
    }

    if (shouldCloseBraces) {
      templateWithFilledInPlaceholders = closeBraces(templateWithFilledInPlaceholders, template);
    }

    return {
      text: templateWithFilledInPlaceholders,
      template: template
    };
  };
} //
// `{ value, caret }` attribute is the result of `parse()` function call.
//
// Returns `{ text, caret }` where the new `caret` is the caret position
// inside `text` text corresponding to the original `caret` position inside `value`.
//
// `formatter(value)` is a function returning `{ text, template }`.
//
// `text` is the `value` value formatted using `template`.
// It may either cut off the non-filled right part of the `template`
// or it may fill the non-filled character placeholders
// in the right part of the `template` with `spacer`
// which is a space (' ') character by default.
//
// `template` is the template used to format the `value`.
// It can be either a full-length template or a partial template.
//
// `formatter` can also be a string — a `template`
// where character placeholders are denoted by 'x'es.
// In this case `formatter` function is automatically created.
//
// Example:
//
// `value` is '880',
// `caret` is `2` (before the first `0`)
//
// `formatter` is `'880' =>
//   { text: '8 (80 )', template: 'x (xxx) xxx-xx-xx' }`
//
// The result is `{ text: '8 (80 )', caret: 4 }`.
//


function format$1(value, caret, formatter) {
  if (typeof formatter === 'string') {
    formatter = template_formatter(formatter);
  }

  var _ref = formatter(value) || {},
      text = _ref.text,
      template = _ref.template;

  if (text === undefined) {
    text = value;
  }

  if (template) {
    if (caret === undefined) {
      caret = text.length;
    } else {
      var index = 0;
      var found = false;
      var possibly_last_input_character_index = -1;

      while (index < text.length && index < template.length) {
        // Character placeholder found
        if (text[index] !== template[index]) {
          if (caret === 0) {
            found = true;
            caret = index;
            break;
          }

          possibly_last_input_character_index = index;
          caret--;
        }

        index++;
      } // If the caret was positioned after last input character,
      // then the text caret index is just after the last input character.


      if (!found) {
        caret = possibly_last_input_character_index + 1;
      }
    }
  }

  return {
    text: text,
    caret: caret
  };
}

function isReadOnly(element) {
  return element.hasAttribute('readonly');
} // Gets <input/> selection bounds


function getSelection(element) {
  // If no selection, return nothing
  if (element.selectionStart === element.selectionEnd) {
    return;
  }

  return {
    start: element.selectionStart,
    end: element.selectionEnd
  };
} // Key codes


var Keys = {
  Backspace: 8,
  Delete: 46
}; // Finds out the operation to be intercepted and performed
// based on the key down event `keyCode`.

function getOperation(event) {
  switch (event.keyCode) {
    case Keys.Backspace:
      return 'Backspace';

    case Keys.Delete:
      return 'Delete';
  }
} // Gets <input/> caret position


function getCaretPosition$1(element) {
  return element.selectionStart;
} // Sets <input/> caret position


function setCaretPosition(element, caret_position) {
  // Sanity check
  if (caret_position === undefined) {
    return;
  } // Set caret position.
  // There has been an issue with caret positioning on Android devices.
  // https://github.com/catamphetamine/input-format/issues/2
  // I was revisiting this issue and looked for similar issues in other libraries.
  // For example, there's [`text-mask`](https://github.com/text-mask/text-mask) library.
  // They've had exactly the same issue when the caret seemingly refused to be repositioned programmatically.
  // The symptoms were the same: whenever the caret passed through a non-digit character of a mask (a whitespace, a bracket, a dash, etc), it looked as if it placed itself one character before its correct position.
  // https://github.com/text-mask/text-mask/issues/300
  // They seem to have found a basic fix for it: calling `input.setSelectionRange()` in a timeout rather than instantly for Android devices.
  // https://github.com/text-mask/text-mask/pull/400/files
  // I've implemented the same workaround here.


  if (isAndroid()) {
    setTimeout(function () {
      return element.setSelectionRange(caret_position, caret_position);
    }, 0);
  } else {
    element.setSelectionRange(caret_position, caret_position);
  }
}

function isAndroid() {
  // `navigator` is not defined when running mocha tests.
  if (typeof navigator !== 'undefined') {
    return ANDROID_USER_AGENT_REG_EXP.test(navigator.userAgent);
  }
}

var ANDROID_USER_AGENT_REG_EXP = /Android/i;

function onChange(event, input, _parse, _format, on_change) {
  formatInputText(input, _parse, _format, undefined, on_change);
} // "Delete" and "Backspace" keys are special
// in a way that they're not handled by the regular `onChange()` handler
// and instead are intercepted and re-applied manually.
// The reason is that normally hitting "Backspace" or "Delete"
// results in erasing a character, but that character might be any character,
// while it would be a better "user experience" if it erased not just any character
// but the closest "meaningful" character.
// For example, if a template is `(xxx) xxx-xxxx`,
// and the `<input/>` value is `(111) 222-3333`,
// then, if a user begins erasing the `3333` part via "Backspace"
// and reaches the "-" character, then it would just erase the "-" character.
// Nothing wrong with that, but it would be a better "user experience"
// if hitting "Backspace" at that position would erase the closest "meaningful"
// character, which would be the rightmost `2`.
// So, what this `onKeyDown()` handler does is it intercepts
// "Backspace" and "Delete" keys and re-applies those operations manually
// following the logic described above.


function onKeyDown(event, input, _parse, _format, on_change) {
  if (isReadOnly(input)) {
    return;
  }

  var operation = getOperation(event);

  switch (operation) {
    case 'Delete':
    case 'Backspace':
      // Intercept this operation and perform it manually.
      event.preventDefault();
      var selection = getSelection(input); // If a selection is made, just erase the selected text.

      if (selection) {
        eraseSelection(input, selection);
        return formatInputText(input, _parse, _format, undefined, on_change);
      } // Else, perform the (character erasing) operation manually.


      return formatInputText(input, _parse, _format, operation, on_change);
  }
}
/**
 * Erases the selected text inside an `<input/>`.
 * @param  {DOMElement} input
 * @param  {Selection} selection
 */


function eraseSelection(input, selection) {
  var text = input.value;
  text = text.slice(0, selection.start) + text.slice(selection.end);
  input.value = text;
  setCaretPosition(input, selection.start);
}
/**
 * Parses and re-formats `<input/>` textual value.
 * E.g. when a user enters something into the `<input/>`
 * that raw input must first be parsed and the re-formatted properly.
 * Is called either after some user input (e.g. entered a character, pasted something)
 * or after the user performed an `operation` (e.g. "Backspace", "Delete").
 * @param  {DOMElement} input
 * @param  {Function} parse
 * @param  {Function} format
 * @param  {string} [operation] - The operation that triggered `<input/>` textual value change. E.g. "Backspace", "Delete".
 * @param  {Function} onChange
 */


function formatInputText(input, _parse, _format, operation, on_change) {
  // Parse `<input/>` textual value.
  // Get the `value` and `caret` position.
  var _parse2 = parse(input.value, getCaretPosition$1(input), _parse),
      value = _parse2.value,
      caret = _parse2.caret; // If a user performed an operation ("Backspace", "Delete")
  // then apply that operation and get the new `value` and `caret` position.


  if (operation) {
    var newValueAndCaret = edit(value, caret, operation);
    value = newValueAndCaret.value;
    caret = newValueAndCaret.caret;
  } // Format the `value`.
  // (and reposition the caret accordingly)


  var formatted = format$1(value, caret, _format);
  var text = formatted.text;
  caret = formatted.caret; // Set `<input/>` textual value manually
  // to prevent React from resetting the caret position
  // later inside a subsequent `render()`.
  // Doesn't work for custom `inputComponent`s for some reason.

  input.value = text; // Position the caret properly.

  setCaretPosition(input, caret); // If the `<input/>` textual value did change,
  // then the parsed `value` may have changed too.

  if (on_change) {
    on_change(value);
  }
}

var _excluded$j = ["ref", "parse", "format", "value", "defaultValue", "controlled", "onChange", "onKeyDown"];

function ownKeys$Q(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$Q(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$Q(Object(source), !0).forEach(function (key) {
      _defineProperty$3(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$Q(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties$5(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$5(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$5(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function useInput(_ref) {
  var ref = _ref.ref,
      parse = _ref.parse,
      format = _ref.format,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      _ref$controlled = _ref.controlled,
      controlled = _ref$controlled === void 0 ? true : _ref$controlled,
      onChange$1 = _ref.onChange,
      onKeyDown$1 = _ref.onKeyDown,
      rest = _objectWithoutProperties$5(_ref, _excluded$j); // It doesn't seem to be required to alert a developer about controlled/uncontrolled misuse:
  // if `controlled` is `true` then `defaultValue` is simply ignored.
  //
  // if (defaultValue && controlled) {
  // 	console.error('[input-format] You\'ve passed both `defaultValue` and `controlled: true` properties which is an invalid use case')
  // }


  var internalRef = useRef();
  var setRef = useCallback(function (instance) {
    internalRef.current = instance;

    if (ref) {
      if (typeof ref === 'function') {
        ref(instance);
      } else {
        ref.current = instance;
      }
    }
  }, [ref]);

  var _onChange = useCallback(function (event) {
    return onChange(event, internalRef.current, parse, format, onChange$1);
  }, [internalRef, parse, format, onChange$1]);

  var _onKeyDown = useCallback(function (event) {
    if (onKeyDown$1) {
      onKeyDown$1(event);
    } // If `onKeyDown()` handler above has called `event.preventDefault()`
    // then ignore this `keydown` event.


    if (event.defaultPrevented) {
      return;
    }

    return onKeyDown(event, internalRef.current, parse, format, onChange$1);
  }, [internalRef, parse, format, onChange$1, onKeyDown$1]);

  var commonProps = _objectSpread$Q(_objectSpread$Q({}, rest), {}, {
    ref: setRef,
    onChange: _onChange,
    onKeyDown: _onKeyDown
  });

  if (controlled) {
    return _objectSpread$Q(_objectSpread$Q({}, commonProps), {}, {
      value: format(isEmptyValue(value) ? '' : value).text
    });
  }

  return _objectSpread$Q(_objectSpread$Q({}, commonProps), {}, {
    defaultValue: format(isEmptyValue(defaultValue) ? '' : defaultValue).text
  });
}

function isEmptyValue(value) {
  return value === undefined || value === null;
}

var _excluded$i = ["inputComponent", "parse", "format", "value", "defaultValue", "onChange", "controlled", "onKeyDown", "type"];

function ownKeys$P(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$P(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$P(Object(source), !0).forEach(function (key) {
      _defineProperty$2(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$P(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties$4(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$4(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$4(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
} //
// <ReactInput
// 	value={this.state.phone}
// 	onChange={phone => this.setState({ phone })}
// 	parse={character => character}
// 	format={value => ({ text: value, template: 'xxxxxxxx' })}/>
//


function Input$1(_ref, ref) {
  var _ref$inputComponent = _ref.inputComponent,
      InputComponent = _ref$inputComponent === void 0 ? 'input' : _ref$inputComponent,
      parse = _ref.parse,
      format = _ref.format,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      onChange = _ref.onChange,
      controlled = _ref.controlled,
      onKeyDown = _ref.onKeyDown,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      rest = _objectWithoutProperties$4(_ref, _excluded$i);

  var inputProps = useInput(_objectSpread$P({
    ref: ref,
    parse: parse,
    format: format,
    value: value,
    defaultValue: defaultValue,
    onChange: onChange,
    controlled: controlled,
    onKeyDown: onKeyDown,
    type: type
  }, rest));
  return /*#__PURE__*/React__default.createElement(InputComponent, inputProps);
}

Input$1 = /*#__PURE__*/React__default.forwardRef(Input$1);
Input$1.propTypes = {
  // Parses a single characher of `<input/>` text.
  parse: PropTypes.func.isRequired,
  // Formats `value` into `<input/>` text.
  format: PropTypes.func.isRequired,
  // Renders `<input/>` by default.
  inputComponent: PropTypes.elementType,
  // `<input/>` `type` attribute.
  type: PropTypes.string,
  // Is parsed from <input/> text.
  value: PropTypes.string,
  // An initial value for an "uncontrolled" <input/>.
  defaultValue: PropTypes.string,
  // This handler is called each time `<input/>` text is changed.
  onChange: PropTypes.func,
  // Whether this input should be "controlled" or "uncontrolled".
  // The default value is `true` meaning "uncontrolled".
  controlled: PropTypes.bool,
  // Passthrough
  onKeyDown: PropTypes.func,
  onCut: PropTypes.func,
  onPaste: PropTypes.func
};
var Input$2 = Input$1; // Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381

function compare(a, b) {
  a = a.split('-');
  b = b.split('-');
  var pa = a[0].split('.');
  var pb = b[0].split('.');

  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }

  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }

  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}

var objectConstructor = {}.constructor;

function isObject(object) {
  return object !== undefined && object !== null && object.constructor === objectConstructor;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck$7(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$7(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$7(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$7(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$7(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

var V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.

var V4 = '1.7.35';
var DEFAULT_EXT_PREFIX = ' ext. ';
var CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */

var Metadata = /*#__PURE__*/function () {
  function Metadata(metadata) {
    _classCallCheck$7(this, Metadata);

    validateMetadata(metadata);
    this.metadata = metadata;
    setVersion.call(this, metadata);
  }

  _createClass$7(Metadata, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function (_) {
        return _ !== '001';
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
      // It's present in metadata generated from `1.7.35` to `1.7.37`.
      // The test case could be found by searching for "nonGeographical".

      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== undefined;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }

      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    } // Deprecated.

  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      // Supports just passing `callingCode` as the first argument.
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }

      if (countryCode && countryCode !== '001') {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }

        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }

        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = undefined;
      }

      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];

      if (countryCodes) {
        // Metadata before V4 included "non-geographic entity" calling codes
        // inside `country_calling_codes` (for example, `"881":["001"]`).
        // Now the semantics of `country_calling_codes` has changed:
        // it's specifically for "countries" now.
        // Older versions of custom metadata will simply skip parsing
        // "non-geographic entity" phone numbers with new versions
        // of this library: it's not considered a bug,
        // because such numbers are extremely rare,
        // and developers extremely rarely use custom metadata.
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }

        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);

      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);

      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }

      if (this.nonGeographic()) {
        var metadata = this.nonGeographic()[callingCode];

        if (metadata) {
          return metadata;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        // In that metadata, there was no concept of "non-geographic" metadata
        // so metadata for `001` country code was stored along with other countries.
        // The test case can be found by searching for:
        // "should work around `nonGeographic` metadata not existing".
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return this.metadata.countries['001'];
        }
      }
    } // Deprecated.

  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    } // Deprecated.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    } // Deprecated.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    } // Deprecated.

  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    } // Deprecated.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    } // Deprecated.

  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    } // Deprecated.

  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    } // Deprecated.

  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    } // Deprecated.

  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    } // Deprecated.

  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    } // Deprecated.

  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    } // Deprecated.

  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1) return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    } // Deprecated.

  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== undefined;
    }
  }]);

  return Metadata;
}();

var NumberingPlan = /*#__PURE__*/function () {
  function NumberingPlan(metadata, globalMetadataObject) {
    _classCallCheck$7(this, NumberingPlan);

    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata;
    setVersion.call(this, globalMetadataObject.metadata);
  }

  _createClass$7(NumberingPlan, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    } // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.

  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    } // Is always present.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[1];
    } // Is only present when a country supports multiple IDD prefixes.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2) return this.metadata[1];
      return this.metadata[2];
    } // "possible length" data is always present in Google's metadata.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1) return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata) {
      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
    } // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "formats",
    value: function formats() {
      var _this = this;

      var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats.map(function (_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata) {
      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
    } // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      // If `national_prefix_for_parsing` is not set explicitly,
      // then infer it from `national_prefix` (if any)
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    } // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      // Versions 1.2.0 - 1.2.4: can be `[]`.

      /* istanbul ignore next */
      if (this.types() && this.types().length === 0) {
        return false;
      } // Versions <= 1.2.4: can be `undefined`.
      // Version >= 1.2.5: can be `0`.


      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);

  return NumberingPlan;
}();

var Format = /*#__PURE__*/function () {
  function Format(format, metadata) {
    _classCallCheck$7(this, Format);

    this._format = format;
    this.metadata = metadata;
  }

  _createClass$7(Format, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      // National prefix is omitted if there's no national prefix formatting rule
      // set for this country, or when the national prefix formatting rule
      // contains no national prefix itself, or when this rule is set but
      // national prefix is optional for this phone number format
      // (and it is not enforced explicitly)
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    } // Checks whether national prefix formatting rule contains national prefix.

  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
      // when `national_prefix_formatting_rule` is not present.
      // So, `true` or `false` are returned explicitly here, so that
      // `0` number isn't returned.
      ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);

  return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */


var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;

var Type = /*#__PURE__*/function () {
  function Type(type, metadata) {
    _classCallCheck$7(this, Type);

    this.type = type;
    this.metadata = metadata;
  }

  _createClass$7(Type, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1) return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1) return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);

  return Type;
}();

function getType(types, type) {
  switch (type) {
    case 'FIXED_LINE':
      return types[0];

    case 'MOBILE':
      return types[1];

    case 'TOLL_FREE':
      return types[2];

    case 'PREMIUM_RATE':
      return types[3];

    case 'PERSONAL_NUMBER':
      return types[4];

    case 'VOICEMAIL':
      return types[5];

    case 'UAN':
      return types[6];

    case 'PAGER':
      return types[7];

    case 'VOIP':
      return types[8];

    case 'SHARED_COST':
      return types[9];
  }
}

function validateMetadata(metadata) {
  if (!metadata) {
    throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
  } // `country_phone_code_to_countries` was renamed to `country_calling_codes` in `1.0.18`.
  // For that reason, it's not used in this detection algorithm.
  // Instead, it detects by `countries: {}` property existence.


  if (!isObject(metadata) || !isObject(metadata.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(isObject(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + typeOf(metadata) + ': ' + metadata, "."));
  }
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */


var typeOf = function typeOf(_) {
  return _typeof(_);
};
/**
 * Returns "country calling code" for a country.
 * Throws an error if the country doesn't exist or isn't supported by this library.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string}
 * @example
 * // Returns "44"
 * getCountryCallingCode("GB")
 */


function getCountryCallingCode$1(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).countryCallingCode();
  }

  throw new Error("Unknown country: ".concat(country));
}

function setVersion(metadata) {
  var version = metadata.version;

  if (typeof version === 'number') {
    this.v1 = version === 1;
    this.v2 = version === 2;
    this.v3 = version === 3;
    this.v4 = version === 4;
  } else {
    if (!version) {
      this.v1 = true;
    } else if (compare(version, V3) === -1) {
      this.v2 = true;
    } else if (compare(version, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
// function isCountryCode(countryCode) {
// 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
// }


function _createForOfIteratorHelperLoose$8(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray$b(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray$b(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$b(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$b(o, minLen);
}

function _arrayLikeToArray$b(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
/**
 * Merges two arrays.
 * @param  {*} a
 * @param  {*} b
 * @return {*}
 */


function mergeArrays(a, b) {
  var merged = a.slice();

  for (var _iterator = _createForOfIteratorHelperLoose$8(b), _step; !(_step = _iterator()).done;) {
    var element = _step.value;

    if (a.indexOf(element) < 0) {
      merged.push(element);
    }
  }

  return merged.sort(function (a, b) {
    return a - b;
  }); // ES6 version, requires Set polyfill.
  // let merged = new Set(a)
  // for (const element of b) {
  // 	merged.add(i)
  // }
  // return Array.from(merged).sort((a, b) => a - b)
}

function checkNumberLength(nationalNumber, metadata) {
  return checkNumberLengthForType(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
// Should only be called for the "new" metadata which has "possible lengths".


function checkNumberLengthForType(nationalNumber, type, metadata) {
  var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
  // This is declared in the XML schema.
  // For size efficiency, where a sub-description (e.g. fixed-line)
  // has the same "<possiblePengths/>" as the "general description", this is missing,
  // so we fall back to the "general description". Where no numbers of the type
  // exist at all, there is one possible length (-1) which is guaranteed
  // not to match the length of any real phone number.

  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
  // Metadata before version `1.0.18` didn't contain `possible_lengths`.

  if (!possible_lengths) {
    return 'IS_POSSIBLE';
  }

  if (type === 'FIXED_LINE_OR_MOBILE') {
    // No such country in metadata.

    /* istanbul ignore next */
    if (!metadata.type('FIXED_LINE')) {
      // The rare case has been encountered where no fixedLine data is available
      // (true for some non-geographic entities), so we just check mobile.
      return checkNumberLengthForType(nationalNumber, 'MOBILE', metadata);
    }

    var mobile_type = metadata.type('MOBILE');

    if (mobile_type) {
      // Merge the mobile data in if there was any. "Concat" creates a new
      // array, it doesn't edit possible_lengths in place, so we don't need a copy.
      // Note that when adding the possible lengths from mobile, we have
      // to again check they aren't empty since if they are this indicates
      // they are the same as the general desc and should be obtained from there.
      possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
      // re-sort (duplicates are okay). Sorting isn't so expensive because
      // the lists are very small.
      // if (local_lengths) {
      // 	local_lengths = mergeArrays(local_lengths, mobile_type.possibleLengthsLocal())
      // } else {
      // 	local_lengths = mobile_type.possibleLengthsLocal()
      // }
    }
  } // If the type doesn't exist then return 'INVALID_LENGTH'.
  else if (type && !type_info) {
    return 'INVALID_LENGTH';
  }

  var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
  // // This is safe because there is never an overlap beween the possible lengths
  // // and the local-only lengths; this is checked at build time.
  // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
  // {
  // 	return 'IS_POSSIBLE_LOCAL_ONLY'
  // }

  var minimum_length = possible_lengths[0];

  if (minimum_length === actual_length) {
    return 'IS_POSSIBLE';
  }

  if (minimum_length > actual_length) {
    return 'TOO_SHORT';
  }

  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return 'TOO_LONG';
  } // We skip the first element since we've already checked it.


  return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}
/**
 * Checks if a phone number is "possible" (basically just checks its length).
 *
 * isPossible(phoneNumberInstance, { ..., v2: true }, metadata)
 *
 * isPossible({ phone: '8005553535', country: 'RU' }, { ... }, metadata)
 * isPossible({ phone: '8005553535', country: 'RU' }, undefined, metadata)
 *
 * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
 * @param  {object} [options]
 * @param  {object} metadata
 * @return {string}
 */


function isPossiblePhoneNumber(input, options, metadata) {
  /* istanbul ignore if */
  if (options === undefined) {
    options = {};
  }

  metadata = new Metadata(metadata);

  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error('Invalid phone number object passed');
    }

    metadata.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }

    if (input.country) {
      if (!metadata.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }

      metadata.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error('Invalid phone number object passed');
      }

      metadata.selectNumberingPlan(input.countryCallingCode);
    }
  } // Old metadata (< 1.0.18) had no "possible length" data.


  if (metadata.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata);
  } else {
    // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
    // were missing for "non-geographical" numbering plans.
    // Just assume the number is possible in such cases:
    // it's unlikely that anyone generated their custom metadata
    // in that short period of time (one day).
    // This code can be removed in some future major version update.
    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
      // "Non-geographic entities" did't have `possibleLengths`
      // due to a bug in metadata generation process.
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}

function isPossibleNumber(nationalNumber, metadata) {
  //, isInternational) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case 'IS_POSSIBLE':
      return true;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational

    default:
      return false;
  }
}
/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */


function matchesEntirely(text, regular_expression) {
  // If assigning the `''` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  text = text || '';
  return new RegExp('^(?:' + regular_expression + ')$').test(text);
}

function _createForOfIteratorHelperLoose$7(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray$a(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray$a(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$a(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$a(o, minLen);
}

function _arrayLikeToArray$a(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var NON_FIXED_LINE_PHONE_TYPES = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL']; // Finds out national phone number type (fixed line, mobile, etc)

function getNumberType(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {}; // When `parse()` returns an empty object — `{}` —
  // that means that the phone number is malformed,
  // so it can't possibly be valid.

  if (!input.country && !input.countryCallingCode) {
    return;
  }

  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
  // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
  // Is this national number even valid for this country

  if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern())) {
    return;
  } // Is it fixed line number


  if (isNumberTypeEqualTo(nationalNumber, 'FIXED_LINE', metadata)) {
    // Because duplicate regular expressions are removed
    // to reduce metadata size, if "mobile" pattern is ""
    // then it means it was removed due to being a duplicate of the fixed-line pattern.
    //
    if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
      return 'FIXED_LINE_OR_MOBILE';
    } // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
    // For example, for "US" country.
    // Old metadata (< `1.0.18`) had a specific "types" data structure
    // that happened to be `undefined` for `MOBILE` in that case.
    // Newer metadata (>= `1.0.18`) has another data structure that is
    // not `undefined` for `MOBILE` in that case (it's just an empty array).
    // So this `if` is just for backwards compatibility with old metadata.


    if (!metadata.type('MOBILE')) {
      return 'FIXED_LINE_OR_MOBILE';
    } // Check if the number happens to qualify as both fixed line and mobile.
    // (no such country in the minimal metadata set)

    /* istanbul ignore if */


    if (isNumberTypeEqualTo(nationalNumber, 'MOBILE', metadata)) {
      return 'FIXED_LINE_OR_MOBILE';
    }

    return 'FIXED_LINE';
  }

  for (var _iterator = _createForOfIteratorHelperLoose$7(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;) {
    var type = _step.value;

    if (isNumberTypeEqualTo(nationalNumber, type, metadata)) {
      return type;
    }
  }
}

function isNumberTypeEqualTo(nationalNumber, type, metadata) {
  type = metadata.type(type);

  if (!type || !type.pattern()) {
    return false;
  } // Check if any possible number lengths are present;
  // if so, we use them to avoid checking
  // the validation pattern if they don't match.
  // If they are absent, this means they match
  // the general description, which we have
  // already checked before a specific number type.


  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }

  return matchesEntirely(nationalNumber, type.pattern());
}
/**
 * Checks if a given phone number is valid.
 *
 * isValid(phoneNumberInstance, { ..., v2: true }, metadata)
 *
 * isPossible({ phone: '8005553535', country: 'RU' }, { ... }, metadata)
 * isPossible({ phone: '8005553535', country: 'RU' }, undefined, metadata)
 *
 * If the `number` is a string, it will be parsed to an object,
 * but only if it contains only valid phone number characters (including punctuation).
 * If the `number` is an object, it is used as is.
 *
 * The optional `defaultCountry` argument is the default country.
 * I.e. it does not restrict to just that country,
 * e.g. in those cases where several countries share
 * the same phone numbering rules (NANPA, Britain, etc).
 * For example, even though the number `07624 369230`
 * belongs to the Isle of Man ("IM" country code)
 * calling `isValidNumber('07624369230', 'GB', metadata)`
 * still returns `true` because the country is not restricted to `GB`,
 * it's just that `GB` is the default one for the phone numbering rules.
 * For restricting the country see `isValidNumberForRegion()`
 * though restricting a country might not be a good idea.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 *
 * Examples:
 *
 * ```js
 * isValidNumber('+78005553535', metadata)
 * isValidNumber('8005553535', 'RU', metadata)
 * isValidNumber('88005553535', 'RU', metadata)
 * isValidNumber({ phone: '8005553535', country: 'RU' }, metadata)
 * ```
 */


function isValidNumber(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
  // distinguishing different countries having the same `countryCallingCode`.

  if (metadata.hasTypes()) {
    return getNumberType(input, options, metadata.metadata) !== undefined;
  } // If there are no type regexps for this country in metadata then use
  // `nationalNumberPattern` as a "better than nothing" replacement.


  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(nationalNumber, metadata.nationalNumberPattern());
}
/**
 * Returns a list of countries that the phone number could potentially belong to.
 * @param  {string} callingCode — Calling code.
 * @param  {string} nationalNumber — National (significant) number.
 * @param  {object} metadata — Metadata.
 * @return {string[]} A list of possible countries.
 */


function getPossibleCountriesForNumber(callingCode, nationalNumber, metadata) {
  var _metadata = new Metadata(metadata);

  var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);

  if (!possibleCountries) {
    return [];
  }

  return possibleCountries.filter(function (country) {
    return couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
  });
}

function couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
  var _metadata = new Metadata(metadata);

  _metadata.selectNumberingPlan(country);

  if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) {
    return true;
  }

  return false;
} // The minimum length of the national significant number.


var MAX_LENGTH_COUNTRY_CODE = 3; // Digits accepted in phone numbers
// (ascii, fullwidth, arabic-indic, and eastern arabic digits).

var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"

var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['

var TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
// excludes punctuation found as a leading character only. This consists of dash
// characters, white space characters, full stops, slashes, square brackets,
// parentheses and tildes. Full-width variants are also present.

var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')

var CAPTURING_DIGIT_PATTERN = new RegExp('([' + VALID_DIGITS + '])');

function stripIddPrefix(number, country, callingCode, metadata) {
  if (!country) {
    return;
  } // Check if the number is IDD-prefixed.


  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());

  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  } // Strip IDD prefix.


  number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
  // then those digits are a country calling code.
  // Since no country code starts with a `0`,
  // the code below validates that the next digit (if present) is not `0`.

  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);

  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === '0') {
      return;
    }
  }

  return number;
}
/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */


function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
  if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
    // See METADATA.md for the description of
    // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
    // Attempt to parse the first digits as a national prefix.
    var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
    var prefixMatch = prefixPattern.exec(number);

    if (prefixMatch) {
      var nationalNumber;
      var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
      // If a `national_prefix_for_parsing` has any "capturing groups"
      // then it means that the national (significant) number is equal to
      // those "capturing groups" transformed via `national_prefix_transform_rule`,
      // and nothing could be said about the actual national prefix:
      // what is it and was it even there.
      // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
      // then everything it matches is a national prefix.
      // To determine whether `national_prefix_for_parsing` matched any
      // "capturing groups", the value of the result of calling `.exec()`
      // is looked at, and if it has non-undefined values where there're
      // "capturing groups" in the regular expression, then it means
      // that "capturing groups" have been matched.
      // It's not possible to tell whether there'll be any "capturing gropus"
      // before the matching process, because a `national_prefix_for_parsing`
      // could exhibit both behaviors.

      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];

      if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
        // then carrier code is the second one.

        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      } // If there're no "capturing groups",
      // or if there're "capturing groups" but no
      // `national_prefix_transform_rule`,
      // then just strip the national prefix from the number,
      // and possibly a carrier code.
      // Seems like there could be more.
      else {
        // `prefixBeforeNationalNumber` is the whole substring matched by
        // the `national_prefix_for_parsing` regular expression.
        // There seem to be no guarantees that it's just a national prefix.
        // For example, if there's a carrier code, it's gonna be a
        // part of `prefixBeforeNationalNumber` too.
        var prefixBeforeNationalNumber = prefixMatch[0];
        nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
        // then carrier code is the first one.

        if (hasCapturedGroups) {
          carrierCode = prefixMatch[1];
        }
      } // Tries to guess whether a national prefix was present in the input.
      // This is not something copy-pasted from Google's library:
      // they don't seem to have an equivalent for that.
      // So this isn't an "officially approved" way of doing something like that.
      // But since there seems no other existing method, this library uses it.


      var nationalPrefix;

      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
        // `prefixMatch[0]` is `01115`, and `$1` is `11`,
        // and the rest of the phone number is `23456789`.
        // The national number is transformed via `9$1` to `91123456789`.
        // National prefix `0` is detected being present at the start.
        // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {

        if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }

      return {
        nationalNumber: nationalNumber,
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode
      };
    }
  }

  return {
    nationalNumber: number
  };
}
/**
 * Strips national prefix and carrier code from a complete phone number.
 * The difference from the non-"FromCompleteNumber" function is that
 * it won't extract national prefix if the resultant number is too short
 * to be a complete number for the selected phone numbering plan.
 * @param  {string} number — Complete phone number digits.
 * @param  {Metadata} metadata — Metadata with a phone numbering plan selected.
 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
 */


function extractNationalNumber(number, metadata) {
  // Parsing national prefixes and carrier codes
  // is only required for local phone numbers
  // but some people don't understand that
  // and sometimes write international phone numbers
  // with national prefixes (or maybe even carrier codes).
  // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
  // Google's original library forgives such mistakes
  // and so does this library, because it has been requested:
  // https://github.com/catamphetamine/libphonenumber-js/issues/127
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number, metadata),
      carrierCode = _extractNationalNumbe.carrierCode,
      nationalNumber = _extractNationalNumbe.nationalNumber;

  if (nationalNumber !== number) {
    if (!shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) {
      // Don't strip the national prefix.
      return {
        nationalNumber: number
      };
    } // Check the national (significant) number length after extracting national prefix and carrier code.
    // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.


    if (metadata.possibleLengths()) {
      // The number remaining after stripping the national prefix and carrier code
      // should be long enough to have a possible length for the country.
      // Otherwise, don't strip the national prefix and carrier code,
      // since the original number could be a valid number.
      // This check has been copy-pasted "as is" from Google's original library:
      // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
      // It doesn't check for the "possibility" of the original `number`.
      // I guess it's fine not checking that one. It works as is anyway.
      if (!isPossibleIncompleteNationalNumber(nationalNumber, metadata)) {
        // Don't strip the national prefix.
        return {
          nationalNumber: number
        };
      }
    }
  }

  return {
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.


function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
  // The equivalent in Google's code is:
  // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
  if (matchesEntirely(nationalNumberBefore, metadata.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata.nationalNumberPattern())) {
    return false;
  } // This "is possible" national number (length) check has been commented out
  // because it's superceded by the (effectively) same check done in the
  // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
  // In other words, why run the same check twice if it could only be run once.
  // // Check the national (significant) number length after extracting national prefix and carrier code.
  // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
  // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
  // if (metadata.possibleLengths()) {
  // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
  // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
  // 		return false
  // 	}
  // }


  return true;
}

function isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case 'TOO_SHORT':
    case 'INVALID_LENGTH':
      // This library ignores "local-only" phone numbers (for simplicity).
      // See the readme for more info on what are "local-only" phone numbers.
      // case 'IS_POSSIBLE_LOCAL_ONLY':
      return false;

    default:
      return true;
  }
}
/**
 * Sometimes some people incorrectly input international phone numbers
 * without the leading `+`. This function corrects such input.
 * @param  {string} number — Phone number digits.
 * @param  {string?} country
 * @param  {string?} callingCode
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`.
 */


function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata) {
  var countryCallingCode = country ? getCountryCallingCode$1(country, metadata) : callingCode;

  if (number.indexOf(countryCallingCode) === 0) {
    metadata = new Metadata(metadata);
    metadata.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);

    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata),
        possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;

    var _extractNationalNumbe2 = extractNationalNumber(number, metadata),
        nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
    // or if it was too long before, we consider the number
    // with the country calling code stripped to be a better result
    // and keep that instead.
    // For example, in Germany (+49), `49` is a valid area code,
    // so if a number starts with `49`, it could be both a valid
    // national German number or an international number without
    // a leading `+`.


    if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata) === 'TOO_LONG') {
      return {
        countryCallingCode: countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }

  return {
    number: number
  };
}
/**
 * Converts a phone number digits (possibly with a `+`)
 * into a calling code and the rest phone number digits.
 * The "rest phone number digits" could include
 * a national prefix, carrier code, and national
 * (significant) number.
 * @param  {string} number — Phone number digits (possibly with a `+`).
 * @param  {string} [country] — Default country.
 * @param  {string} [callingCode] — Default calling code (some phone numbering plans are non-geographic).
 * @param  {object} metadata
 * @return {object} `{ countryCallingCodeSource: string?, countryCallingCode: string?, number: string }`
 * @example
 * // Returns `{ countryCallingCode: "1", number: "2133734253" }`.
 * extractCountryCallingCode('2133734253', 'US', null, metadata)
 * extractCountryCallingCode('2133734253', null, '1', metadata)
 * extractCountryCallingCode('+12133734253', null, null, metadata)
 * extractCountryCallingCode('+12133734253', 'RU', null, metadata)
 */


function extractCountryCallingCode(number, country, callingCode, metadata) {
  if (!number) {
    return {};
  }

  var isNumberWithIddPrefix; // If this is not an international phone number,
  // then either extract an "IDD" prefix, or extract a
  // country calling code from a number by autocorrecting it
  // by prepending a leading `+` in cases when it starts
  // with the country calling code.
  // https://wikitravel.org/en/International_dialling_prefix
  // https://github.com/catamphetamine/libphonenumber-js/issues/376

  if (number[0] !== '+') {
    // Convert an "out-of-country" dialing phone number
    // to a proper international phone number.
    var numberWithoutIDD = stripIddPrefix(number, country, callingCode, metadata); // If an IDD prefix was stripped then
    // convert the number to international one
    // for subsequent parsing.

    if (numberWithoutIDD && numberWithoutIDD !== number) {
      isNumberWithIddPrefix = true;
      number = '+' + numberWithoutIDD;
    } else {
      // Check to see if the number starts with the country calling code
      // for the default country. If so, we remove the country calling code,
      // and do some checks on the validity of the number before and after.
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      if (country || callingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata),
            countryCallingCode = _extractCountryCallin.countryCallingCode,
            shorterNumber = _extractCountryCallin.number;

        if (countryCallingCode) {
          return {
            countryCallingCodeSource: 'FROM_NUMBER_WITHOUT_PLUS_SIGN',
            countryCallingCode: countryCallingCode,
            number: shorterNumber
          };
        }
      }

      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: number
      };
    }
  } // Fast abortion: country codes do not begin with a '0'


  if (number[1] === '0') {
    return {};
  }

  metadata = new Metadata(metadata); // The thing with country phone codes
  // is that they are orthogonal to each other
  // i.e. there's no such country phone code A
  // for which country phone code B exists
  // where B starts with A.
  // Therefore, while scanning digits,
  // if a valid country code is found,
  // that means that it is the country code.
  //

  var i = 2;

  while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);

    if (metadata.hasCallingCode(_countryCallingCode)) {
      metadata.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCodeSource: isNumberWithIddPrefix ? 'FROM_NUMBER_WITH_IDD' : 'FROM_NUMBER_WITH_PLUS_SIGN',
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }

    i++;
  }

  return {};
} // The possible values for the returned `countryCallingCodeSource` are:
//
// Copy-pasted from:
// https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
//
// // The source from which the country_code is derived. This is not set in the
// // general parsing method, but in the method that parses and keeps raw_input.
// // New fields could be added upon request.
// enum CountryCodeSource {
//  // Default value returned if this is not set, because the phone number was
//  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
//  // return false if this is the case.
//  UNSPECIFIED = 0;
//
//  // The country_code is derived based on a phone number with a leading "+",
//  // e.g. the French number "+33 1 42 68 53 00".
//  FROM_NUMBER_WITH_PLUS_SIGN = 1;
//
//  // The country_code is derived based on a phone number with a leading IDD,
//  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
//  FROM_NUMBER_WITH_IDD = 5;
//
//  // The country_code is derived based on a phone number without a leading
//  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
//  // supplied as France.
//  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
//
//  // The country_code is derived NOT based on the phone number itself, but
//  // from the defaultCountry parameter provided in the parsing function by the
//  // clients. This happens mostly for numbers written in the national format
//  // (without country code). For example, this would be set when parsing the
//  // French number "01 42 68 53 00", when defaultCountry is supplied as
//  // France.
//  FROM_DEFAULT_COUNTRY = 20;
// }
//
// E.g. "(999) 111-22-33" -> "999 111 22 33"
//
// For some reason Google's metadata contains `<intlFormat/>`s with brackets and dashes.
// Meanwhile, there's no single opinion about using punctuation in international phone numbers.
//
// For example, Google's `<intlFormat/>` for USA is `+1 213-373-4253`.
// And here's a quote from WikiPedia's "North American Numbering Plan" page:
// https://en.wikipedia.org/wiki/North_American_Numbering_Plan
//
// "The country calling code for all countries participating in the NANP is 1.
// In international format, an NANP number should be listed as +1 301 555 01 00,
// where 301 is an area code (Maryland)."
//
// I personally prefer the international format without any punctuation.
// For example, brackets are remnants of the old age, meaning that the
// phone number part in brackets (so called "area code") can be omitted
// if dialing within the same "area".
// And hyphens were clearly introduced for splitting local numbers into memorizable groups.
// For example, remembering "5553535" is difficult but "555-35-35" is much simpler.
// Imagine a man taking a bus from home to work and seeing an ad with a phone number.
// He has a couple of seconds to memorize that number until it passes by.
// If it were spaces instead of hyphens the man wouldn't necessarily get it,
// but with hyphens instead of spaces the grouping is more explicit.
// I personally think that hyphens introduce visual clutter,
// so I prefer replacing them with spaces in international numbers.
// In the modern age all output is done on displays where spaces are clearly distinguishable
// so hyphens can be safely replaced with spaces without losing any legibility.
//


function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), 'g'), ' ').trim();
} // first group is not used in the national pattern (e.g. Argentina) so the $1
// group does not match correctly. Therefore, we use `\d`, so that the first
// group actually used in the pattern will be matched.


var FIRST_GROUP_PATTERN = /(\$\d)/;

function formatNationalNumberUsingFormat(number, format, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat,
      withNationalPrefix = _ref.withNationalPrefix;
  _ref.carrierCode;
  _ref.metadata;
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // This library doesn't use `domestic_carrier_code_formatting_rule`,
  // because that one is only used when formatting phone numbers
  // for dialing from a mobile phone, and this is not a dialing library.
  // carrierCode && format.domesticCarrierCodeFormattingRule()
  // 	// First, replace the $CC in the formatting rule with the desired carrier code.
  // 	// Then, replace the $FG in the formatting rule with the first group
  // 	// and the carrier code combined in the appropriate way.
  // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
  // 	: (
  // 		withNationalPrefix && format.nationalPrefixFormattingRule()
  // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
  // 			: format.format()
  // 	)
  withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());

  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }

  return formattedNumber;
}
/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */


var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
// a preferred IDD prefix is returned.

function getIddPrefix(country, callingCode, metadata) {
  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);

  if (countryMetadata.defaultIDDPrefix()) {
    return countryMetadata.defaultIDDPrefix();
  }

  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }
}
/**
 * @param  {object} - `{ ?number, ?extension }`.
 * @return {string} Phone URI (RFC 3966).
 */


function formatRFC3966(_ref) {
  var number = _ref.number,
      ext = _ref.ext;

  if (!number) {
    return '';
  }

  if (number[0] !== '+') {
    throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
  }

  return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}

function _createForOfIteratorHelperLoose$6(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray$9(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray$9(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$9(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$9(o, minLen);
}

function _arrayLikeToArray$9(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys$O(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$O(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$O(Object(source), !0).forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$O(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
  }
};
/**
 * Formats a phone number.
 *
 * format(phoneNumberInstance, 'INTERNATIONAL', { ..., v2: true }, metadata)
 * format(phoneNumberInstance, 'NATIONAL', { ..., v2: true }, metadata)
 *
 * format({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', { ... }, metadata)
 * format({ phone: '8005553535', country: 'RU' }, 'NATIONAL', undefined, metadata)
 *
 * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
 * @param  {string} format
 * @param  {object} [options]
 * @param  {object} metadata
 * @return {string}
 */

function formatNumber(input, format, options, metadata) {
  // Apply default options.
  if (options) {
    options = _objectSpread$O(_objectSpread$O({}, DEFAULT_OPTIONS), options);
  } else {
    options = DEFAULT_OPTIONS;
  }

  metadata = new Metadata(metadata);

  if (input.country && input.country !== '001') {
    // Validate `input.country`.
    if (!metadata.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }

    metadata.country(input.country);
  } else if (input.countryCallingCode) {
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else return input.phone || '';

  var countryCallingCode = metadata.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
  // but Babel has a bug and it says "duplicate variable declaration".

  var number;

  switch (format) {
    case 'NATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return '';
      }

      number = formatNationalNumber$1(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'INTERNATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }

      number = formatNationalNumber$1(nationalNumber, null, 'INTERNATIONAL', metadata, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'E.164':
      // `E.164` doesn't define "phone number extensions".
      return "+".concat(countryCallingCode).concat(nationalNumber);

    case 'RFC3966':
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?

    case 'IDD':
      if (!options.fromCountry) {
        return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
      }

      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
      return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);

    default:
      throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
  }
}

function formatNationalNumber$1(number, carrierCode, formatAs, metadata, options) {
  var format = chooseFormatForNumber(metadata.formats(), number);

  if (!format) {
    return number;
  }

  return formatNationalNumberUsingFormat(number, format, {
    useInternationalFormat: formatAs === 'INTERNATIONAL',
    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode: carrierCode,
    metadata: metadata
  });
}

function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = _createForOfIteratorHelperLoose$6(availableFormats), _step; !(_step = _iterator()).done;) {
    var format = _step.value; // Validate leading digits.
    // The test case for "else path" could be found by searching for
    // "format.leadingDigitsPatterns().length === 0".

    if (format.leadingDigitsPatterns().length > 0) {
      // The last leading_digits_pattern is used here, as it is the most detailed
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format

      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    } // Check that the national number matches the phone number format regular expression


    if (matchesEntirely(nationalNnumber, format.pattern())) {
      return format;
    }
  }
}

function addExtension(formattedNumber, ext, metadata, formatExtension) {
  return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}

function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
  var fromCountryCallingCode = getCountryCallingCode$1(fromCountry, metadata.metadata); // When calling within the same country calling code.

  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber$1(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
    // but prefix it with the country calling code.

    if (countryCallingCode === '1') {
      return countryCallingCode + ' ' + formattedNumber;
    } // If regions share a country calling code, the country calling code need
    // not be dialled. This also applies when dialling within a region, so this
    // if clause covers both these cases. Technically this is the case for
    // dialling from La Reunion to other overseas departments of France (French
    // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
    // this edge case for now and for those cases return the version including
    // country calling code. Details here:
    // http://www.petitfute.com/voyage/225-info-pratiques-reunion
    //


    return formattedNumber;
  }

  var iddPrefix = getIddPrefix(fromCountry, undefined, metadata.metadata);

  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber$1(nationalNumber, null, 'INTERNATIONAL', metadata));
  }
}

function ownKeys$N(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$N(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$N(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$N(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck$6(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$6(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$6(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$6(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$6(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

var PhoneNumber = /*#__PURE__*/function () {
  /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */
  function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
    _classCallCheck$6(this, PhoneNumber); // Validate `countryOrCountryCallingCode` argument.


    if (!countryOrCountryCallingCode) {
      throw new TypeError('First argument is required');
    }

    if (typeof countryOrCountryCallingCode !== 'string') {
      throw new TypeError('First argument must be a string');
    } // In case of public API use: `constructor(number, metadata)`.
    // Transform the arguments from `constructor(number, metadata)` to
    // `constructor(countryOrCountryCallingCode, nationalNumber, metadata)`.


    if (typeof countryOrCountryCallingCode === 'string') {
      if (countryOrCountryCallingCode[0] === '+' && !nationalNumber) {
        throw new TypeError('`metadata` argument not passed');
      }

      if (isObject(nationalNumber) && isObject(nationalNumber.countries)) {
        metadata = nationalNumber;
        var e164Number = countryOrCountryCallingCode;

        if (!E164_NUMBER_REGEXP.test(e164Number)) {
          throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
        }

        var _extractCountryCallin = extractCountryCallingCode(e164Number, undefined, undefined, metadata),
            _countryCallingCode = _extractCountryCallin.countryCallingCode,
            number = _extractCountryCallin.number;

        nationalNumber = number;
        countryOrCountryCallingCode = _countryCallingCode;

        if (!nationalNumber) {
          throw new Error('Invalid `number` argument passed: too short');
        }
      }
    } // Validate `nationalNumber` argument.


    if (!nationalNumber) {
      throw new TypeError('`nationalNumber` argument is required');
    }

    if (typeof nationalNumber !== 'string') {
      throw new TypeError('`nationalNumber` argument must be a string');
    } // Validate `metadata` argument.


    validateMetadata(metadata); // Initialize properties.

    var _getCountryAndCountry = getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata),
        country = _getCountryAndCountry.country,
        countryCallingCode = _getCountryAndCountry.countryCallingCode;

    this.country = country;
    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = '+' + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
    // so that it doesn't clutter the console output of Node.js.
    // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
    // it would output the whole internal structure of the `metadata` object.

    this.getMetadata = function () {
      return metadata;
    };
  }

  _createClass$6(PhoneNumber, [{
    key: "setExt",
    value: function setExt(ext) {
      this.ext = ext;
    }
  }, {
    key: "getPossibleCountries",
    value: function getPossibleCountries() {
      if (this.country) {
        return [this.country];
      }

      return getPossibleCountriesForNumber(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return isValidNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata = new Metadata(this.getMetadata());
      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }

  }, {
    key: "getType",
    value: function getType() {
      return getNumberType(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return formatNumber(this, _format, options ? _objectSpread$N(_objectSpread$N({}, options), {}, {
        v2: true
      }) : {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format('NATIONAL', options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format('INTERNATIONAL', options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format('RFC3966', options);
    }
  }]);

  return PhoneNumber;
}();

var isCountryCode = function isCountryCode(value) {
  return /^[A-Z]{2}$/.test(value);
};

function getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
  var country;
  var countryCallingCode;
  var metadata = new Metadata(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
  // Also store the country code as `.country`.

  if (isCountryCode(countryOrCountryCallingCode)) {
    country = countryOrCountryCallingCode;
    metadata.selectNumberingPlan(country);
    countryCallingCode = metadata.countryCallingCode();
  } else {
    countryCallingCode = countryOrCountryCallingCode;
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode
  };
}

var E164_NUMBER_REGEXP = /^\+\d+$/;

function _createForOfIteratorHelperLoose$5(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray$8(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray$8(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$8(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$8(o, minLen);
}

function _arrayLikeToArray$8(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
} // These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//


var DIGITS = {
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  "\uFF10": '0',
  // Fullwidth digit 0
  "\uFF11": '1',
  // Fullwidth digit 1
  "\uFF12": '2',
  // Fullwidth digit 2
  "\uFF13": '3',
  // Fullwidth digit 3
  "\uFF14": '4',
  // Fullwidth digit 4
  "\uFF15": '5',
  // Fullwidth digit 5
  "\uFF16": '6',
  // Fullwidth digit 6
  "\uFF17": '7',
  // Fullwidth digit 7
  "\uFF18": '8',
  // Fullwidth digit 8
  "\uFF19": '9',
  // Fullwidth digit 9
  "\u0660": '0',
  // Arabic-indic digit 0
  "\u0661": '1',
  // Arabic-indic digit 1
  "\u0662": '2',
  // Arabic-indic digit 2
  "\u0663": '3',
  // Arabic-indic digit 3
  "\u0664": '4',
  // Arabic-indic digit 4
  "\u0665": '5',
  // Arabic-indic digit 5
  "\u0666": '6',
  // Arabic-indic digit 6
  "\u0667": '7',
  // Arabic-indic digit 7
  "\u0668": '8',
  // Arabic-indic digit 8
  "\u0669": '9',
  // Arabic-indic digit 9
  "\u06F0": '0',
  // Eastern-Arabic digit 0
  "\u06F1": '1',
  // Eastern-Arabic digit 1
  "\u06F2": '2',
  // Eastern-Arabic digit 2
  "\u06F3": '3',
  // Eastern-Arabic digit 3
  "\u06F4": '4',
  // Eastern-Arabic digit 4
  "\u06F5": '5',
  // Eastern-Arabic digit 5
  "\u06F6": '6',
  // Eastern-Arabic digit 6
  "\u06F7": '7',
  // Eastern-Arabic digit 7
  "\u06F8": '8',
  // Eastern-Arabic digit 8
  "\u06F9": '9' // Eastern-Arabic digit 9

};

function parseDigit(character) {
  return DIGITS[character];
}
/**
 * Parses phone number digits from a string.
 * Drops all punctuation leaving only digits.
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * parseDigits('8 (800) 555')
 * // Outputs '8800555'.
 * ```
 */


function parseDigits(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = _createForOfIteratorHelperLoose$5(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;
    var digit = parseDigit(character);

    if (digit) {
      result += digit;
    }
  }

  return result;
}

function _createForOfIteratorHelperLoose$4(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray$7(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray$7(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$7(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen);
}

function _arrayLikeToArray$7(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
/**
 * Parses phone number characters from a string.
 * Drops all punctuation leaving only digits and the leading `+` sign (if any).
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * // Outputs '8800555'.
 * parseIncompletePhoneNumber('8 (800) 555')
 * // Outputs '+7800555'.
 * parseIncompletePhoneNumber('+7 800 555')
 * ```
 */


function parseIncompletePhoneNumber(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = _createForOfIteratorHelperLoose$4(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;
    result += parsePhoneNumberCharacter(character, result) || '';
  }

  return result;
}
/**
 * Parses next character while parsing phone number digits (including a `+`)
 * from text: discards everything except `+` and digits, and `+` is only allowed
 * at the start of a phone number.
 * For example, is used in `react-phone-number-input` where it uses
 * [`input-format`](https://gitlab.com/catamphetamine/input-format).
 * @param  {string} character - Yet another character from raw input string.
 * @param  {string?} prevParsedCharacters - Previous parsed characters.
 * @param  {function?} emitEvent - An optional "emit event" function.
 * @return {string?} The parsed character.
 */


function parsePhoneNumberCharacter(character, prevParsedCharacters, emitEvent) {
  // Only allow a leading `+`.
  if (character === '+') {
    // If this `+` is not the first parsed character
    // then discard it.
    if (prevParsedCharacters) {
      // `emitEvent` argument was added to this `export`ed function on Dec 26th, 2023.
      // Any 3rd-party code that used to `import` and call this function before that
      // won't be passing any `emitEvent` argument.
      //
      // The addition of the `emitEvent` argument was to fix the slightly-weird behavior
      // of parsing an input string when the user inputs something like `"2+7"
      // https://github.com/catamphetamine/react-phone-number-input/issues/437
      //
      // If the parser encounters an unexpected `+` in a string being parsed
      // then it simply discards that out-of-place `+` and any following characters.
      //
      if (typeof emitEvent === 'function') {
        emitEvent('end');
      }

      return;
    }

    return '+';
  } // Allow digits.


  return parseDigit(character);
}

function _createForOfIteratorHelperLoose$3(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray$6(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray$6(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$6(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen);
}

function _arrayLikeToArray$6(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function getCountryByNationalNumber(nationalPhoneNumber, _ref) {
  var countries = _ref.countries;
  _ref.defaultCountry;
  var metadata = _ref.metadata; // Re-create `metadata` because it will be selecting a `country`.

  metadata = new Metadata(metadata); // const matchingCountries = []

  for (var _iterator = _createForOfIteratorHelperLoose$3(countries), _step; !(_step = _iterator()).done;) {
    var country = _step.value;
    metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
    // By definition, matching "leading digits" is a sufficient but not a necessary
    // condition for a phone number to belong to a country.
    // The point of "leading digits" check is that it's the fastest one to get a match.
    // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
    // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
    // because of the intended use of that feature.

    if (metadata.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
        return country;
      }
    } // Else perform full validation with all of those
    // fixed-line/mobile/etc regular expressions.
    else if (getNumberType({
      phone: nationalPhoneNumber,
      country: country
    }, undefined, metadata.metadata)) {
      // If both the `defaultCountry` and the "main" one match the phone number,
      // don't prefer the `defaultCountry` over the "main" one.
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/154
      return country; // // If the `defaultCountry` is among the `matchingCountries` then return it.
      // if (defaultCountry) {
      // 	if (country === defaultCountry) {
      // 		return country
      // 	}
      // 	matchingCountries.push(country)
      // } else {
      // 	return country
      // }
    }
  } // // Return the first ("main") one of the `matchingCountries`.
  // if (matchingCountries.length > 0) {
  // 	return matchingCountries[0]
  // }

}

var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;

function getCountryByCallingCode(callingCode, _ref) {
  var nationalPhoneNumber = _ref.nationalNumber,
      defaultCountry = _ref.defaultCountry,
      metadata = _ref.metadata;
  /* istanbul ignore if */

  if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
    if (metadata.isNonGeographicCallingCode(callingCode)) {
      return '001';
    }
  }

  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);

  if (!possibleCountries) {
    return;
  } // If there's just one country corresponding to the country code,
  // then just return it, without further phone number digits validation.


  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }

  return getCountryByNationalNumber(nationalPhoneNumber, {
    countries: possibleCountries,
    defaultCountry: defaultCountry,
    metadata: metadata.metadata
  });
}

function _classCallCheck$5(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$5(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$5(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$5(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$5(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
} // This "state" object simply holds the state of the "AsYouType" parser:
//
// * `country?: string`
// * `callingCode?: string`
// * `digits: string`
// * `international: boolean`
// * `missingPlus: boolean`
// * `IDDPrefix?: string`
// * `carrierCode?: string`
// * `nationalPrefix?: string`
// * `nationalSignificantNumber?: string`
// * `nationalSignificantNumberMatchesInput: boolean`
// * `complexPrefixBeforeNationalSignificantNumber?: string`
//
// `state.country` and `state.callingCode` aren't required to be in sync.
// For example, `state.country` could be `"AR"` and `state.callingCode` could be `undefined`.
// So `state.country` and `state.callingCode` are totally independent.
//


var AsYouTypeState = /*#__PURE__*/function () {
  function AsYouTypeState(_ref) {
    var onCountryChange = _ref.onCountryChange,
        onCallingCodeChange = _ref.onCallingCodeChange;

    _classCallCheck$5(this, AsYouTypeState);

    this.onCountryChange = onCountryChange;
    this.onCallingCodeChange = onCallingCodeChange;
  }

  _createClass$5(AsYouTypeState, [{
    key: "reset",
    value: function reset(_ref2) {
      var country = _ref2.country,
          callingCode = _ref2.callingCode;
      this.international = false;
      this.missingPlus = false;
      this.IDDPrefix = undefined;
      this.callingCode = undefined;
      this.digits = '';
      this.resetNationalSignificantNumber();
      this.initCountryAndCallingCode(country, callingCode);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function resetNationalSignificantNumber() {
      this.nationalSignificantNumber = this.getNationalDigits();
      this.nationalSignificantNumberMatchesInput = true;
      this.nationalPrefix = undefined;
      this.carrierCode = undefined;
      this.complexPrefixBeforeNationalSignificantNumber = undefined;
    }
  }, {
    key: "update",
    value: function update(properties) {
      for (var _i = 0, _Object$keys = Object.keys(properties); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        this[key] = properties[key];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function initCountryAndCallingCode(country, callingCode) {
      this.setCountry(country);
      this.setCallingCode(callingCode);
    }
  }, {
    key: "setCountry",
    value: function setCountry(country) {
      this.country = country;
      this.onCountryChange(country);
    }
  }, {
    key: "setCallingCode",
    value: function setCallingCode(callingCode) {
      this.callingCode = callingCode;
      this.onCallingCodeChange(callingCode, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber(country, callingCode) {
      // Prepend the `+` to parsed input.
      this.international = true; // If a default country was set then reset it
      // because an explicitly international phone
      // number is being entered.

      this.initCountryAndCallingCode(country, callingCode);
    }
  }, {
    key: "appendDigits",
    value: function appendDigits(nextDigits) {
      this.digits += nextDigits;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function appendNationalSignificantNumberDigits(nextDigits) {
      this.nationalSignificantNumber += nextDigits;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */

  }, {
    key: "getNationalDigits",
    value: function getNationalDigits() {
      if (this.international) {
        return this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0));
      }

      return this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function getDigitsWithoutInternationalPrefix() {
      if (this.international) {
        if (this.IDDPrefix) {
          return this.digits.slice(this.IDDPrefix.length);
        }
      }

      return this.digits;
    }
  }]);

  return AsYouTypeState;
}();

function _createForOfIteratorHelperLoose$2(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray$5(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray$5(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$5(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen);
}

function _arrayLikeToArray$5(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
} // Should be the same as `DIGIT_PLACEHOLDER` in `libphonenumber-metadata-generator`.


var DIGIT_PLACEHOLDER = 'x'; // '\u2008' (punctuation space)

var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER); // Counts all occurences of a symbol in a string.
// http://stackoverflow.com/questions/202605/repeat-string-javascript

function repeat(string, times) {
  if (times < 1) {
    return '';
  }

  var result = '';

  while (times > 1) {
    if (times & 1) {
      result += string;
    }

    times >>= 1;
    string += string;
  }

  return result + string;
}

function cutAndStripNonPairedParens(string, cutBeforeIndex) {
  if (string[cutBeforeIndex] === ')') {
    cutBeforeIndex++;
  }

  return stripNonPairedParens(string.slice(0, cutBeforeIndex));
}

function stripNonPairedParens(string) {
  var dangling_braces = [];
  var i = 0;

  while (i < string.length) {
    if (string[i] === '(') {
      dangling_braces.push(i);
    } else if (string[i] === ')') {
      dangling_braces.pop();
    }

    i++;
  }

  var start = 0;
  var cleared_string = '';
  dangling_braces.push(string.length);

  for (var _i = 0, _dangling_braces = dangling_braces; _i < _dangling_braces.length; _i++) {
    var index = _dangling_braces[_i];
    cleared_string += string.slice(start, index);
    start = index + 1;
  }

  return cleared_string;
}

function populateTemplateWithDigits(template, position, digits) {
  // Using `.split('')` to iterate through a string here
  // to avoid requiring `Symbol.iterator` polyfill.
  // `.split('')` is generally not safe for Unicode,
  // but in this particular case for `digits` it is safe.
  // for (const digit of digits)
  for (var _iterator2 = _createForOfIteratorHelperLoose$2(digits.split('')), _step2; !(_step2 = _iterator2()).done;) {
    var digit = _step2.value; // If there is room for more digits in current `template`,
    // then set the next digit in the `template`,
    // and return the formatted digits so far.
    // If more digits are entered than the current format could handle.

    if (template.slice(position + 1).search(DIGIT_PLACEHOLDER_MATCHER) < 0) {
      return;
    }

    position = template.search(DIGIT_PLACEHOLDER_MATCHER);
    template = template.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
  }

  return [template, position];
}

function formatCompleteNumber(state, format, _ref) {
  var metadata = _ref.metadata,
      shouldTryNationalPrefixFormattingRule = _ref.shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref.getSeparatorAfterNationalPrefix;
  var matcher = new RegExp("^(?:".concat(format.pattern(), ")$"));

  if (matcher.test(state.nationalSignificantNumber)) {
    return formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, {
      metadata: metadata,
      shouldTryNationalPrefixFormattingRule: shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix
    });
  }
}

function canFormatCompleteNumber(nationalSignificantNumber, metadata) {
  return checkNumberLength(nationalSignificantNumber, metadata) === 'IS_POSSIBLE';
}

function formatNationalNumberWithAndWithoutNationalPrefixFormattingRule(state, format, _ref2) {
  var metadata = _ref2.metadata,
      shouldTryNationalPrefixFormattingRule = _ref2.shouldTryNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref2.getSeparatorAfterNationalPrefix; // `format` has already been checked for `nationalPrefix` requirement.

  state.nationalSignificantNumber;
  state.international;
  state.nationalPrefix;
  state.carrierCode; // Format the number with using `national_prefix_formatting_rule`.
  // If the resulting formatted number is a valid formatted number, then return it.
  //
  // Google's AsYouType formatter is different in a way that it doesn't try
  // to format using the "national prefix formatting rule", and instead it
  // simply prepends a national prefix followed by a " " character.
  // This code does that too, but as a fallback.
  // The reason is that "national prefix formatting rule" may use parentheses,
  // which wouldn't be included has it used the simpler Google's way.
  //

  if (shouldTryNationalPrefixFormattingRule(format)) {
    var formattedNumber = formatNationalNumber(state, format, {
      useNationalPrefixFormattingRule: true,
      getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
      metadata: metadata
    });

    if (formattedNumber) {
      return formattedNumber;
    }
  } // Format the number without using `national_prefix_formatting_rule`.


  return formatNationalNumber(state, format, {
    useNationalPrefixFormattingRule: false,
    getSeparatorAfterNationalPrefix: getSeparatorAfterNationalPrefix,
    metadata: metadata
  });
}

function formatNationalNumber(state, format, _ref3) {
  var metadata = _ref3.metadata,
      useNationalPrefixFormattingRule = _ref3.useNationalPrefixFormattingRule,
      getSeparatorAfterNationalPrefix = _ref3.getSeparatorAfterNationalPrefix;
  var formattedNationalNumber = formatNationalNumberUsingFormat(state.nationalSignificantNumber, format, {
    carrierCode: state.carrierCode,
    useInternationalFormat: state.international,
    withNationalPrefix: useNationalPrefixFormattingRule,
    metadata: metadata
  });

  if (!useNationalPrefixFormattingRule) {
    if (state.nationalPrefix) {
      // If a national prefix was extracted, then just prepend it,
      // followed by a " " character.
      formattedNationalNumber = state.nationalPrefix + getSeparatorAfterNationalPrefix(format) + formattedNationalNumber;
    } else if (state.complexPrefixBeforeNationalSignificantNumber) {
      formattedNationalNumber = state.complexPrefixBeforeNationalSignificantNumber + ' ' + formattedNationalNumber;
    }
  }

  if (isValidFormattedNationalNumber(formattedNationalNumber, state)) {
    return formattedNationalNumber;
  }
} // Check that the formatted phone number contains exactly
// the same digits that have been input by the user.
// For example, when "0111523456789" is input for `AR` country,
// the extracted `this.nationalSignificantNumber` is "91123456789",
// which means that the national part of `this.digits` isn't simply equal to
// `this.nationalPrefix` + `this.nationalSignificantNumber`.
//
// Also, a `format` can add extra digits to the `this.nationalSignificantNumber`
// being formatted via `metadata[country].national_prefix_transform_rule`.
// For example, for `VI` country, it prepends `340` to the national number,
// and if this check hasn't been implemented, then there would be a bug
// when `340` "area coude" is "duplicated" during input for `VI` country:
// https://github.com/catamphetamine/libphonenumber-js/issues/318
//
// So, all these "gotchas" are filtered out.
//
// In the original Google's code, the comments say:
// "Check that we didn't remove nor add any extra digits when we matched
// this formatting pattern. This usually happens after we entered the last
// digit during AYTF. Eg: In case of MX, we swallow mobile token (1) when
// formatted but AYTF should retain all the number entered and not change
// in order to match a format (of same leading digits and length) display
// in that way."
// "If it's the same (i.e entered number and format is same), then it's
// safe to return this in formatted number as nothing is lost / added."
// Otherwise, don't use this format.
// https://github.com/google/libphonenumber/commit/3e7c1f04f5e7200f87fb131e6f85c6e99d60f510#diff-9149457fa9f5d608a11bb975c6ef4bc5
// https://github.com/google/libphonenumber/commit/3ac88c7106e7dcb553bcc794b15f19185928a1c6#diff-2dcb77e833422ee304da348b905cde0b
//


function isValidFormattedNationalNumber(formattedNationalNumber, state) {
  return parseDigits(formattedNationalNumber) === state.getNationalDigits();
}

function _classCallCheck$4(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$4(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$4(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$4(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$4(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

var PatternParser = /*#__PURE__*/function () {
  function PatternParser() {
    _classCallCheck$4(this, PatternParser);
  }

  _createClass$4(PatternParser, [{
    key: "parse",
    value: function parse(pattern) {
      this.context = [{
        or: true,
        instructions: []
      }];
      this.parsePattern(pattern);

      if (this.context.length !== 1) {
        throw new Error('Non-finalized contexts left when pattern parse ended');
      }

      var _this$context$ = this.context[0],
          branches = _this$context$.branches,
          instructions = _this$context$.instructions;

      if (branches) {
        return {
          op: '|',
          args: branches.concat([expandSingleElementArray(instructions)])
        };
      }
      /* istanbul ignore if */


      if (instructions.length === 0) {
        throw new Error('Pattern is required');
      }

      if (instructions.length === 1) {
        return instructions[0];
      }

      return instructions;
    }
  }, {
    key: "startContext",
    value: function startContext(context) {
      this.context.push(context);
    }
  }, {
    key: "endContext",
    value: function endContext() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function getContext() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function parsePattern(pattern) {
      if (!pattern) {
        throw new Error('Pattern is required');
      }

      var match = pattern.match(OPERATOR);

      if (!match) {
        if (ILLEGAL_CHARACTER_REGEXP.test(pattern)) {
          throw new Error("Illegal characters found in a pattern: ".concat(pattern));
        }

        this.getContext().instructions = this.getContext().instructions.concat(pattern.split(''));
        return;
      }

      var operator = match[1];
      var before = pattern.slice(0, match.index);
      var rightPart = pattern.slice(match.index + operator.length);

      switch (operator) {
        case '(?:':
          if (before) {
            this.parsePattern(before);
          }

          this.startContext({
            or: true,
            instructions: [],
            branches: []
          });
          break;

        case ')':
          if (!this.getContext().or) {
            throw new Error('")" operator must be preceded by "(?:" operator');
          }

          if (before) {
            this.parsePattern(before);
          }

          if (this.getContext().instructions.length === 0) {
            throw new Error('No instructions found after "|" operator in an "or" group');
          }

          var _this$getContext = this.getContext(),
              branches = _this$getContext.branches;

          branches.push(expandSingleElementArray(this.getContext().instructions));
          this.endContext();
          this.getContext().instructions.push({
            op: '|',
            args: branches
          });
          break;

        case '|':
          if (!this.getContext().or) {
            throw new Error('"|" operator can only be used inside "or" groups');
          }

          if (before) {
            this.parsePattern(before);
          } // The top-level is an implicit "or" group, if required.


          if (!this.getContext().branches) {
            // `branches` are not defined only for the root implicit "or" operator.

            /* istanbul ignore else */
            if (this.context.length === 1) {
              this.getContext().branches = [];
            } else {
              throw new Error('"branches" not found in an "or" group context');
            }
          }

          this.getContext().branches.push(expandSingleElementArray(this.getContext().instructions));
          this.getContext().instructions = [];
          break;

        case '[':
          if (before) {
            this.parsePattern(before);
          }

          this.startContext({
            oneOfSet: true
          });
          break;

        case ']':
          if (!this.getContext().oneOfSet) {
            throw new Error('"]" operator must be preceded by "[" operator');
          }

          this.endContext();
          this.getContext().instructions.push({
            op: '[]',
            args: parseOneOfSet(before)
          });
          break;

        /* istanbul ignore next */

        default:
          throw new Error("Unknown operator: ".concat(operator));
      }

      if (rightPart) {
        this.parsePattern(rightPart);
      }
    }
  }]);

  return PatternParser;
}();

function parseOneOfSet(pattern) {
  var values = [];
  var i = 0;

  while (i < pattern.length) {
    if (pattern[i] === '-') {
      if (i === 0 || i === pattern.length - 1) {
        throw new Error("Couldn't parse a one-of set pattern: ".concat(pattern));
      }

      var prevValue = pattern[i - 1].charCodeAt(0) + 1;
      var nextValue = pattern[i + 1].charCodeAt(0) - 1;
      var value = prevValue;

      while (value <= nextValue) {
        values.push(String.fromCharCode(value));
        value++;
      }
    } else {
      values.push(pattern[i]);
    }

    i++;
  }

  return values;
}

var ILLEGAL_CHARACTER_REGEXP = /[\(\)\[\]\?\:\|]/;
var OPERATOR = new RegExp( // any of:
'(' + // or operator
'\\|' + // or
'|' + // or group start
'\\(\\?\\:' + // or
'|' + // or group end
'\\)' + // or
'|' + // one-of set start
'\\[' + // or
'|' + // one-of set end
'\\]' + ')');

function expandSingleElementArray(array) {
  if (array.length === 1) {
    return array[0];
  }

  return array;
}

function _createForOfIteratorHelperLoose$1(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray$4(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$4(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen);
}

function _arrayLikeToArray$4(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$3(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$3(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$3(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$3(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

var PatternMatcher = /*#__PURE__*/function () {
  function PatternMatcher(pattern) {
    _classCallCheck$3(this, PatternMatcher);

    this.matchTree = new PatternParser().parse(pattern);
  }

  _createClass$3(PatternMatcher, [{
    key: "match",
    value: function match(string) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          allowOverflow = _ref.allowOverflow;

      if (!string) {
        throw new Error('String is required');
      }

      var result = _match(string.split(''), this.matchTree, true);

      if (result && result.match) {
        delete result.matchedChars;
      }

      if (result && result.overflow) {
        if (!allowOverflow) {
          return;
        }
      }

      return result;
    }
  }]);

  return PatternMatcher;
}();

function _match(characters, tree, last) {
  // If `tree` is a string, then `tree` is a single character.
  // That's because when a pattern is parsed, multi-character-string parts
  // of a pattern are compiled into arrays of single characters.
  // I still wrote this piece of code for a "general" hypothetical case
  // when `tree` could be a string of several characters, even though
  // such case is not possible with the current implementation.
  if (typeof tree === 'string') {
    var characterString = characters.join('');

    if (tree.indexOf(characterString) === 0) {
      // `tree` is always a single character.
      // If `tree.indexOf(characterString) === 0`
      // then `characters.length === tree.length`.

      /* istanbul ignore else */
      if (characters.length === tree.length) {
        return {
          match: true,
          matchedChars: characters
        };
      } // `tree` is always a single character.
      // If `tree.indexOf(characterString) === 0`
      // then `characters.length === tree.length`.

      /* istanbul ignore next */


      return {
        partialMatch: true // matchedChars: characters

      };
    }

    if (characterString.indexOf(tree) === 0) {
      if (last) {
        // The `else` path is not possible because `tree` is always a single character.
        // The `else` case for `characters.length > tree.length` would be
        // `characters.length <= tree.length` which means `characters.length <= 1`.
        // `characters` array can't be empty, so that means `characters === [tree]`,
        // which would also mean `tree.indexOf(characterString) === 0` and that'd mean
        // that the `if (tree.indexOf(characterString) === 0)` condition before this
        // `if` condition would be entered, and returned from there, not reaching this code.

        /* istanbul ignore else */
        if (characters.length > tree.length) {
          return {
            overflow: true
          };
        }
      }

      return {
        match: true,
        matchedChars: characters.slice(0, tree.length)
      };
    }

    return;
  }

  if (Array.isArray(tree)) {
    var restCharacters = characters.slice();
    var i = 0;

    while (i < tree.length) {
      var subtree = tree[i];

      var result = _match(restCharacters, subtree, last && i === tree.length - 1);

      if (!result) {
        return;
      } else if (result.overflow) {
        return result;
      } else if (result.match) {
        // Continue with the next subtree with the rest of the characters.
        restCharacters = restCharacters.slice(result.matchedChars.length);

        if (restCharacters.length === 0) {
          if (i === tree.length - 1) {
            return {
              match: true,
              matchedChars: characters
            };
          } else {
            return {
              partialMatch: true // matchedChars: characters

            };
          }
        }
      } else {
        /* istanbul ignore else */
        if (result.partialMatch) {
          return {
            partialMatch: true // matchedChars: characters

          };
        } else {
          throw new Error("Unsupported match result:\n".concat(JSON.stringify(result, null, 2)));
        }
      }

      i++;
    } // If `last` then overflow has already been checked
    // by the last element of the `tree` array.

    /* istanbul ignore if */


    if (last) {
      return {
        overflow: true
      };
    }

    return {
      match: true,
      matchedChars: characters.slice(0, characters.length - restCharacters.length)
    };
  }

  switch (tree.op) {
    case '|':
      var partialMatch;

      for (var _iterator = _createForOfIteratorHelperLoose$1(tree.args), _step; !(_step = _iterator()).done;) {
        var branch = _step.value;

        var _result = _match(characters, branch, last);

        if (_result) {
          if (_result.overflow) {
            return _result;
          } else if (_result.match) {
            return {
              match: true,
              matchedChars: _result.matchedChars
            };
          } else {
            /* istanbul ignore else */
            if (_result.partialMatch) {
              partialMatch = true;
            } else {
              throw new Error("Unsupported match result:\n".concat(JSON.stringify(_result, null, 2)));
            }
          }
        }
      }

      if (partialMatch) {
        return {
          partialMatch: true // matchedChars: ...

        };
      } // Not even a partial match.


      return;

    case '[]':
      for (var _iterator2 = _createForOfIteratorHelperLoose$1(tree.args), _step2; !(_step2 = _iterator2()).done;) {
        var _char = _step2.value;

        if (characters[0] === _char) {
          if (characters.length === 1) {
            return {
              match: true,
              matchedChars: characters
            };
          }

          if (last) {
            return {
              overflow: true
            };
          }

          return {
            match: true,
            matchedChars: [_char]
          };
        }
      } // No character matches.


      return;

    /* istanbul ignore next */

    default:
      throw new Error("Unsupported instruction tree: ".concat(tree));
  }
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray$3(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen);
}

function _arrayLikeToArray$3(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$2(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
} // Could be any digit, I guess.


var DUMMY_DIGIT = '9'; // I don't know why is it exactly `15`

var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15; // Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.

var LONGEST_DUMMY_PHONE_NUMBER = repeat(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH); // A set of characters that, if found in a national prefix formatting rules, are an indicator to
// us that we should separate the national prefix from the number when formatting.

var NATIONAL_PREFIX_SEPARATORS_PATTERN = /[- ]/; // Deprecated: Google has removed some formatting pattern related code from their repo.
// An example of a character class is "[1-4]".

var CREATE_CHARACTER_CLASS_PATTERN = function CREATE_CHARACTER_CLASS_PATTERN() {
  return /\[([^\[\]])*\]/g;
}; // Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.


var CREATE_STANDALONE_DIGIT_PATTERN = function CREATE_STANDALONE_DIGIT_PATTERN() {
  return /\d(?=[^,}][^,}])/g;
}; // A regular expression that is used to determine if a `format` is
// suitable to be used in the "as you type formatter".
// A `format` is suitable when the resulting formatted number has
// the same digits as the user has entered.
//
// In the simplest case, that would mean that the format
// doesn't add any additional digits when formatting a number.
// Google says that it also shouldn't add "star" (`*`) characters,
// like it does in some Israeli formats.
// Such basic format would only contain "valid punctuation"
// and "captured group" identifiers ($1, $2, etc).
//
// An example of a format that adds additional digits:
//
// Country: `AR` (Argentina).
// Format:
// {
//    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
//    "leading_digits_patterns": ["91"],
//    "national_prefix_formatting_rule": "0$1",
//    "format": "$2 15-$3-$4",
//    "international_format": "$1 $2 $3-$4"
// }
//
// In the format above, the `format` adds `15` to the digits when formatting a number.
// A sidenote: this format actually is suitable because `national_prefix_for_parsing`
// has previously removed `15` from a national number, so re-adding `15` in `format`
// doesn't actually result in any extra digits added to user's input.
// But verifying that would be a complex procedure, so the code chooses a simpler path:
// it simply filters out all `format`s that contain anything but "captured group" ids.
//
// This regular expression is called `ELIGIBLE_FORMAT_PATTERN` in Google's
// `libphonenumber` code.
//


var NON_ALTERING_FORMAT_REG_EXP = new RegExp('[' + VALID_PUNCTUATION + ']*' + // Google developers say:
// "We require that the first matching group is present in the
//  output pattern to ensure no data is lost while formatting."
'\\$1' + '[' + VALID_PUNCTUATION + ']*' + '(\\$\\d[' + VALID_PUNCTUATION + ']*)*' + '$'); // This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.

var MIN_LEADING_DIGITS_LENGTH = 3;

var AsYouTypeFormatter = /*#__PURE__*/function () {
  function AsYouTypeFormatter(_ref) {
    _ref.state;
    var metadata = _ref.metadata;

    _classCallCheck$2(this, AsYouTypeFormatter);

    this.metadata = metadata;
    this.resetFormat();
  }

  _createClass$2(AsYouTypeFormatter, [{
    key: "resetFormat",
    value: function resetFormat() {
      this.chosenFormat = undefined;
      this.template = undefined;
      this.nationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplate = undefined;
      this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan, state) {
      this.resetFormat();

      if (numberingPlan) {
        this.isNANP = numberingPlan.callingCode() === '1';
        this.matchingFormats = numberingPlan.formats();

        if (state.nationalSignificantNumber) {
          this.narrowDownMatchingFormats(state);
        }
      } else {
        this.isNANP = undefined;
        this.matchingFormats = [];
      }
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */

  }, {
    key: "format",
    value: function format(nextDigits, state) {
      var _this = this; // See if the phone number digits can be formatted as a complete phone number.
      // If not, use the results from `formatNationalNumberWithNextDigits()`,
      // which formats based on the chosen formatting pattern.
      //
      // Attempting to format complete phone number first is how it's done
      // in Google's `libphonenumber`, so this library just follows it.
      // Google's `libphonenumber` code doesn't explain in detail why does it
      // attempt to format digits as a complete phone number
      // instead of just going with a previoulsy (or newly) chosen `format`:
      //
      // "Checks to see if there is an exact pattern match for these digits.
      //  If so, we should use this instead of any other formatting template
      //  whose leadingDigitsPattern also matches the input."
      //


      if (canFormatCompleteNumber(state.nationalSignificantNumber, this.metadata)) {
        for (var _iterator = _createForOfIteratorHelperLoose(this.matchingFormats), _step; !(_step = _iterator()).done;) {
          var format = _step.value;
          var formattedCompleteNumber = formatCompleteNumber(state, format, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function shouldTryNationalPrefixFormattingRule(format) {
              return _this.shouldTryNationalPrefixFormattingRule(format, {
                international: state.international,
                nationalPrefix: state.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function getSeparatorAfterNationalPrefix(format) {
              return _this.getSeparatorAfterNationalPrefix(format);
            }
          });

          if (formattedCompleteNumber) {
            this.resetFormat();
            this.chosenFormat = format;
            this.setNationalNumberTemplate(formattedCompleteNumber.replace(/\d/g, DIGIT_PLACEHOLDER), state);
            this.populatedNationalNumberTemplate = formattedCompleteNumber; // With a new formatting template, the matched position
            // using the old template needs to be reset.

            this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(DIGIT_PLACEHOLDER);
            return formattedCompleteNumber;
          }
        }
      } // Format the digits as a partial (incomplete) phone number
      // using the previously chosen formatting pattern (or a newly chosen one).


      return this.formatNationalNumberWithNextDigits(nextDigits, state);
    } // Formats the next phone number digits.

  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function formatNationalNumberWithNextDigits(nextDigits, state) {
      var previouslyChosenFormat = this.chosenFormat; // Choose a format from the list of matching ones.

      var newlyChosenFormat = this.chooseFormat(state);

      if (newlyChosenFormat) {
        if (newlyChosenFormat === previouslyChosenFormat) {
          // If it can format the next (current) digits
          // using the previously chosen phone number format
          // then return the updated formatted number.
          return this.formatNextNationalNumberDigits(nextDigits);
        } else {
          // If a more appropriate phone number format
          // has been chosen for these "leading digits",
          // then re-format the national phone number part
          // using the newly selected format.
          return this.formatNextNationalNumberDigits(state.getNationalDigits());
        }
      }
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function narrowDownMatchingFormats(_ref2) {
      var _this2 = this;

      var nationalSignificantNumber = _ref2.nationalSignificantNumber,
          nationalPrefix = _ref2.nationalPrefix,
          international = _ref2.international;
      var leadingDigits = nationalSignificantNumber; // "leading digits" pattern list starts with a
      // "leading digits" pattern fitting a maximum of 3 leading digits.
      // So, after a user inputs 3 digits of a national (significant) phone number
      // this national (significant) number can already be formatted.
      // The next "leading digits" pattern is for 4 leading digits max,
      // and the "leading digits" pattern after it is for 5 leading digits max, etc.
      // This implementation is different from Google's
      // in that it searches for a fitting format
      // even if the user has entered less than
      // `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
      // Because some leading digit patterns already match for a single first digit.

      var leadingDigitsPatternIndex = leadingDigits.length - MIN_LEADING_DIGITS_LENGTH;

      if (leadingDigitsPatternIndex < 0) {
        leadingDigitsPatternIndex = 0;
      }

      this.matchingFormats = this.matchingFormats.filter(function (format) {
        return _this2.formatSuits(format, international, nationalPrefix) && _this2.formatMatches(format, leadingDigits, leadingDigitsPatternIndex);
      }); // If there was a phone number format chosen
      // and it no longer holds given the new leading digits then reset it.
      // The test for this `if` condition is marked as:
      // "Reset a chosen format when it no longer holds given the new leading digits".
      // To construct a valid test case for this one can find a country
      // in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
      // and yielding another format for 4 `<leadingDigits>` (Australia in this case).

      if (this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1) {
        this.resetFormat();
      }
    }
  }, {
    key: "formatSuits",
    value: function formatSuits(format, international, nationalPrefix) {
      // When a prefix before a national (significant) number is
      // simply a national prefix, then it's parsed as `this.nationalPrefix`.
      // In more complex cases, a prefix before national (significant) number
      // could include a national prefix as well as some "capturing groups",
      // and in that case there's no info whether a national prefix has been parsed.
      // If national prefix is not used when formatting a phone number
      // using this format, but a national prefix has been entered by the user,
      // and was extracted, then discard such phone number format.
      // In Google's "AsYouType" formatter code, the equivalent would be this part:
      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L175-L184
      if (nationalPrefix && !format.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !format.nationalPrefixIsOptionalWhenFormattingInNationalFormat()) {
        return false;
      } // If national prefix is mandatory for this phone number format
      // and there're no guarantees that a national prefix is present in user input
      // then discard this phone number format as not suitable.
      // In Google's "AsYouType" formatter code, the equivalent would be this part:
      // https://github.com/google/libphonenumber/blob/0a45cfd96e71cad8edb0e162a70fcc8bd9728933/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L185-L193


      if (!international && !nationalPrefix && format.nationalPrefixIsMandatoryWhenFormattingInNationalFormat()) {
        return false;
      }

      return true;
    }
  }, {
    key: "formatMatches",
    value: function formatMatches(format, leadingDigits, leadingDigitsPatternIndex) {
      var leadingDigitsPatternsCount = format.leadingDigitsPatterns().length; // If this format is not restricted to a certain
      // leading digits pattern then it fits.
      // The test case could be found by searching for "leadingDigitsPatternsCount === 0".

      if (leadingDigitsPatternsCount === 0) {
        return true;
      } // Start narrowing down the list of possible formats based on the leading digits.
      // (only previously matched formats take part in the narrowing down process)
      // `leading_digits_patterns` start with 3 digits min
      // and then go up from there one digit at a time.


      leadingDigitsPatternIndex = Math.min(leadingDigitsPatternIndex, leadingDigitsPatternsCount - 1);
      var leadingDigitsPattern = format.leadingDigitsPatterns()[leadingDigitsPatternIndex]; // Google imposes a requirement on the leading digits
      // to be minimum 3 digits long in order to be eligible
      // for checking those with a leading digits pattern.
      //
      // Since `leading_digits_patterns` start with 3 digits min,
      // Google's original `libphonenumber` library only starts
      // excluding any non-matching formats only when the
      // national number entered so far is at least 3 digits long,
      // otherwise format matching would give false negatives.
      //
      // For example, when the digits entered so far are `2`
      // and the leading digits pattern is `21` –
      // it's quite obvious in this case that the format could be the one
      // but due to the absence of further digits it would give false negative.
      //
      // Also, `leading_digits_patterns` doesn't always correspond to a single
      // digits count. For example, `60|8` pattern would already match `8`
      // but the `60` part would require having at least two leading digits,
      // so the whole pattern would require inputting two digits first in order to
      // decide on whether it matches the input, even when the input is "80".
      //
      // This library — `libphonenumber-js` — allows filtering by `leading_digits_patterns`
      // even when there's only 1 or 2 digits of the national (significant) number.
      // To do that, it uses a non-strict pattern matcher written specifically for that.
      //

      if (leadingDigits.length < MIN_LEADING_DIGITS_LENGTH) {
        // Before leading digits < 3 matching was implemented:
        // return true
        //
        // After leading digits < 3 matching was implemented:
        try {
          return new PatternMatcher(leadingDigitsPattern).match(leadingDigits, {
            allowOverflow: true
          }) !== undefined;
        } catch (error)
        /* istanbul ignore next */
        {
          // There's a slight possibility that there could be some undiscovered bug
          // in the pattern matcher code. Since the "leading digits < 3 matching"
          // feature is not "essential" for operation, it can fall back to the old way
          // in case of any issues rather than halting the application's execution.
          console.error(error);
          return true;
        }
      } // If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are
      // available then use the usual regular expression matching.
      //
      // The whole pattern is wrapped in round brackets (`()`) because
      // the pattern can use "or" operator (`|`) at the top level of the pattern.
      //


      return new RegExp("^(".concat(leadingDigitsPattern, ")")).test(leadingDigits);
    }
  }, {
    key: "getFormatFormat",
    value: function getFormatFormat(format, international) {
      return international ? format.internationalFormat() : format.format();
    }
  }, {
    key: "chooseFormat",
    value: function chooseFormat(state) {
      var _this3 = this;

      var _loop = function _loop() {
        var format = _step2.value; // If this format is currently being used
        // and is still suitable, then stick to it.

        if (_this3.chosenFormat === format) {
          return "break";
        } // Sometimes, a formatting rule inserts additional digits in a phone number,
        // and "as you type" formatter can't do that: it should only use the digits
        // that the user has input.
        //
        // For example, in Argentina, there's a format for mobile phone numbers:
        //
        // {
        //    "pattern": "(\\d)(\\d{2})(\\d{4})(\\d{4})",
        //    "leading_digits_patterns": ["91"],
        //    "national_prefix_formatting_rule": "0$1",
        //    "format": "$2 15-$3-$4",
        //    "international_format": "$1 $2 $3-$4"
        // }
        //
        // In that format, `international_format` is used instead of `format`
        // because `format` inserts `15` in the formatted number,
        // and `AsYouType` formatter should only use the digits
        // the user has actually input, without adding any extra digits.
        // In this case, it wouldn't make a difference, because the `15`
        // is first stripped when applying `national_prefix_for_parsing`
        // and then re-added when using `format`, so in reality it doesn't
        // add any new digits to the number, but to detect that, the code
        // would have to be more complex: it would have to try formatting
        // the digits using the format and then see if any digits have
        // actually been added or removed, and then, every time a new digit
        // is input, it should re-check whether the chosen format doesn't
        // alter the digits.
        //
        // Google's code doesn't go that far, and so does this library:
        // it simply requires that a `format` doesn't add any additonal
        // digits to user's input.
        //
        // Also, people in general should move from inputting phone numbers
        // in national format (possibly with national prefixes)
        // and use international phone number format instead:
        // it's a logical thing in the modern age of mobile phones,
        // globalization and the internet.
        //

        /* istanbul ignore if */


        if (!NON_ALTERING_FORMAT_REG_EXP.test(_this3.getFormatFormat(format, state.international))) {
          return "continue";
        }

        if (!_this3.createTemplateForFormat(format, state)) {
          // Remove the format if it can't generate a template.
          _this3.matchingFormats = _this3.matchingFormats.filter(function (_) {
            return _ !== format;
          });
          return "continue";
        }

        _this3.chosenFormat = format;
        return "break";
      }; // When there are multiple available formats, the formatter uses the first
      // format where a formatting template could be created.
      //
      // For some weird reason, `istanbul` says "else path not taken"
      // for the `for of` line below. Supposedly that means that
      // the loop doesn't ever go over the last element in the list.
      // That's true because there always is `this.chosenFormat`
      // when `this.matchingFormats` is non-empty.
      // And, for some weird reason, it doesn't think that the case
      // with empty `this.matchingFormats` qualifies for a valid "else" path.
      // So simply muting this `istanbul` warning.
      // It doesn't skip the contents of the `for of` loop,
      // it just skips the `for of` line.
      //

      /* istanbul ignore next */


      for (var _iterator2 = _createForOfIteratorHelperLoose(this.matchingFormats.slice()), _step2; !(_step2 = _iterator2()).done;) {
        var _ret = _loop();

        if (_ret === "break") break;
        if (_ret === "continue") continue;
      }

      if (!this.chosenFormat) {
        // No format matches the national (significant) phone number.
        this.resetFormat();
      }

      return this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function createTemplateForFormat(format, state) {
      // The formatter doesn't format numbers when numberPattern contains '|', e.g.
      // (20|3)\d{4}. In those cases we quickly return.
      // (Though there's no such format in current metadata)

      /* istanbul ignore if */
      if (format.pattern().indexOf('|') >= 0) {
        return;
      } // Get formatting template for this phone number format


      var template = this.getTemplateForFormat(format, state); // If the national number entered is too long
      // for any phone number format, then abort.

      if (template) {
        this.setNationalNumberTemplate(template, state);
        return true;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function getSeparatorAfterNationalPrefix(format) {
      // `US` metadata doesn't have a `national_prefix_formatting_rule`,
      // so the `if` condition below doesn't apply to `US`,
      // but in reality there shoudl be a separator
      // between a national prefix and a national (significant) number.
      // So `US` national prefix separator is a "special" "hardcoded" case.
      if (this.isNANP) {
        return ' ';
      } // If a `format` has a `national_prefix_formatting_rule`
      // and that rule has a separator after a national prefix,
      // then it means that there should be a separator
      // between a national prefix and a national (significant) number.


      if (format && format.nationalPrefixFormattingRule() && NATIONAL_PREFIX_SEPARATORS_PATTERN.test(format.nationalPrefixFormattingRule())) {
        return ' ';
      } // At this point, there seems to be no clear evidence that
      // there should be a separator between a national prefix
      // and a national (significant) number. So don't insert one.


      return '';
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function getInternationalPrefixBeforeCountryCallingCode(_ref3, options) {
      var IDDPrefix = _ref3.IDDPrefix,
          missingPlus = _ref3.missingPlus;

      if (IDDPrefix) {
        return options && options.spacing === false ? IDDPrefix : IDDPrefix + ' ';
      }

      if (missingPlus) {
        return '';
      }

      return '+';
    }
  }, {
    key: "getTemplate",
    value: function getTemplate(state) {
      if (!this.template) {
        return;
      } // `this.template` holds the template for a "complete" phone number.
      // The currently entered phone number is most likely not "complete",
      // so trim all non-populated digits.


      var index = -1;
      var i = 0;
      var internationalPrefix = state.international ? this.getInternationalPrefixBeforeCountryCallingCode(state, {
        spacing: false
      }) : '';

      while (i < internationalPrefix.length + state.getDigitsWithoutInternationalPrefix().length) {
        index = this.template.indexOf(DIGIT_PLACEHOLDER, index + 1);
        i++;
      }

      return cutAndStripNonPairedParens(this.template, index + 1);
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function setNationalNumberTemplate(template, state) {
      this.nationalNumberTemplate = template;
      this.populatedNationalNumberTemplate = template; // With a new formatting template, the matched position
      // using the old template needs to be reset.

      this.populatedNationalNumberTemplatePosition = -1; // For convenience, the public `.template` property
      // contains the whole international number
      // if the phone number being input is international:
      // 'x' for the '+' sign, 'x'es for the country phone code,
      // a spacebar and then the template for the formatted national number.

      if (state.international) {
        this.template = this.getInternationalPrefixBeforeCountryCallingCode(state).replace(/[\d\+]/g, DIGIT_PLACEHOLDER) + repeat(DIGIT_PLACEHOLDER, state.callingCode.length) + ' ' + template;
      } else {
        this.template = template;
      }
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */

  }, {
    key: "getTemplateForFormat",
    value: function getTemplateForFormat(format, _ref4) {
      var nationalSignificantNumber = _ref4.nationalSignificantNumber,
          international = _ref4.international,
          nationalPrefix = _ref4.nationalPrefix,
          complexPrefixBeforeNationalSignificantNumber = _ref4.complexPrefixBeforeNationalSignificantNumber;
      var pattern = format.pattern();
      /* istanbul ignore else */

      {
        pattern = pattern // Replace anything in the form of [..] with \d
        .replace(CREATE_CHARACTER_CLASS_PATTERN(), '\\d') // Replace any standalone digit (not the one in `{}`) with \d
        .replace(CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');
      } // Generate a dummy national number (consisting of `9`s)
      // that fits this format's `pattern`.
      //
      // This match will always succeed,
      // because the "longest dummy phone number"
      // has enough length to accomodate any possible
      // national phone number format pattern.
      //

      var digits = LONGEST_DUMMY_PHONE_NUMBER.match(pattern)[0]; // If the national number entered is too long
      // for any phone number format, then abort.

      if (nationalSignificantNumber.length > digits.length) {
        return;
      } // Get a formatting template which can be used to efficiently format
      // a partial number where digits are added one by one.
      // Below `strictPattern` is used for the
      // regular expression (with `^` and `$`).
      // This wasn't originally in Google's `libphonenumber`
      // and I guess they don't really need it
      // because they're not using "templates" to format phone numbers
      // but I added `strictPattern` after encountering
      // South Korean phone number formatting bug.
      //
      // Non-strict regular expression bug demonstration:
      //
      // this.nationalSignificantNumber : `111111111` (9 digits)
      //
      // pattern : (\d{2})(\d{3,4})(\d{4})
      // format : `$1 $2 $3`
      // digits : `9999999999` (10 digits)
      //
      // '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
      //
      // template : xx xxxx xxxx
      //
      // But the correct template in this case is `xx xxx xxxx`.
      // The template was generated incorrectly because of the
      // `{3,4}` variability in the `pattern`.
      //
      // The fix is, if `this.nationalSignificantNumber` has already sufficient length
      // to satisfy the `pattern` completely then `this.nationalSignificantNumber`
      // is used instead of `digits`.


      var strictPattern = new RegExp('^' + pattern + '$');
      var nationalNumberDummyDigits = nationalSignificantNumber.replace(/\d/g, DUMMY_DIGIT); // If `this.nationalSignificantNumber` has already sufficient length
      // to satisfy the `pattern` completely then use it
      // instead of `digits`.

      if (strictPattern.test(nationalNumberDummyDigits)) {
        digits = nationalNumberDummyDigits;
      }

      var numberFormat = this.getFormatFormat(format, international);
      var nationalPrefixIncludedInTemplate; // If a user did input a national prefix (and that's guaranteed),
      // and if a `format` does have a national prefix formatting rule,
      // then see if that national prefix formatting rule
      // prepends exactly the same national prefix the user has input.
      // If that's the case, then use the `format` with the national prefix formatting rule.
      // Otherwise, use  the `format` without the national prefix formatting rule,
      // and prepend a national prefix manually to it.

      if (this.shouldTryNationalPrefixFormattingRule(format, {
        international: international,
        nationalPrefix: nationalPrefix
      })) {
        var numberFormatWithNationalPrefix = numberFormat.replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()); // If `national_prefix_formatting_rule` of a `format` simply prepends
        // national prefix at the start of a national (significant) number,
        // then such formatting can be used with `AsYouType` formatter.
        // There seems to be no `else` case: everywhere in metadata,
        // national prefix formatting rule is national prefix + $1,
        // or `($1)`, in which case such format isn't even considered
        // when the user has input a national prefix.

        /* istanbul ignore else */

        if (parseDigits(format.nationalPrefixFormattingRule()) === (nationalPrefix || '') + parseDigits('$1')) {
          numberFormat = numberFormatWithNationalPrefix;
          nationalPrefixIncludedInTemplate = true; // Replace all digits of the national prefix in the formatting template
          // with `DIGIT_PLACEHOLDER`s.

          if (nationalPrefix) {
            var i = nationalPrefix.length;

            while (i > 0) {
              numberFormat = numberFormat.replace(/\d/, DIGIT_PLACEHOLDER);
              i--;
            }
          }
        }
      } // Generate formatting template for this phone number format.


      var template = digits // Format the dummy phone number according to the format.
      .replace(new RegExp(pattern), numberFormat) // Replace each dummy digit with a DIGIT_PLACEHOLDER.
      .replace(new RegExp(DUMMY_DIGIT, 'g'), DIGIT_PLACEHOLDER); // If a prefix of a national (significant) number is not as simple
      // as just a basic national prefix, then just prepend such prefix
      // before the national (significant) number, optionally spacing
      // the two with a whitespace.

      if (!nationalPrefixIncludedInTemplate) {
        if (complexPrefixBeforeNationalSignificantNumber) {
          // Prepend the prefix to the template manually.
          template = repeat(DIGIT_PLACEHOLDER, complexPrefixBeforeNationalSignificantNumber.length) + ' ' + template;
        } else if (nationalPrefix) {
          // Prepend national prefix to the template manually.
          template = repeat(DIGIT_PLACEHOLDER, nationalPrefix.length) + this.getSeparatorAfterNationalPrefix(format) + template;
        }
      }

      if (international) {
        template = applyInternationalSeparatorStyle(template);
      }

      return template;
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function formatNextNationalNumberDigits(digits) {
      var result = populateTemplateWithDigits(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, digits);

      if (!result) {
        // Reset the format.
        this.resetFormat();
        return;
      }

      this.populatedNationalNumberTemplate = result[0];
      this.populatedNationalNumberTemplatePosition = result[1]; // Return the formatted phone number so far.

      return cutAndStripNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1); // The old way which was good for `input-format` but is not so good
      // for `react-phone-number-input`'s default input (`InputBasic`).
      // return closeNonPairedParens(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1)
      // 	.replace(new RegExp(DIGIT_PLACEHOLDER, 'g'), ' ')
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function shouldTryNationalPrefixFormattingRule(format, _ref5) {
      var international = _ref5.international,
          nationalPrefix = _ref5.nationalPrefix;

      if (format.nationalPrefixFormattingRule()) {
        // In some countries, `national_prefix_formatting_rule` is `($1)`,
        // so it applies even if the user hasn't input a national prefix.
        // `format.usesNationalPrefix()` detects such cases.
        var usesNationalPrefix = format.usesNationalPrefix();

        if (usesNationalPrefix && nationalPrefix || !usesNationalPrefix && !international) {
          return true;
        }
      }
    }
  }]);

  return AsYouTypeFormatter;
}();

function _slicedToArray$2(arr, i) {
  return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$2();
}

function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray$2(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
}

function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit$2(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART = '[' + VALID_PUNCTUATION + VALID_DIGITS + ']+';
var VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN = new RegExp('^' + VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART + '$', 'i');
var VALID_FORMATTED_PHONE_NUMBER_PART = '(?:' + '[' + PLUS_CHARS + ']' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*' + '|' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']+' + ')';
var AFTER_PHONE_NUMBER_DIGITS_END_PATTERN = new RegExp('[^' + VALID_PUNCTUATION + VALID_DIGITS + ']+' + '.*' + '$'); // Tests whether `national_prefix_for_parsing` could match
// different national prefixes.
// Matches anything that's not a digit or a square bracket.

var COMPLEX_NATIONAL_PREFIX = /[^\d\[\]]/;

var AsYouTypeParser = /*#__PURE__*/function () {
  function AsYouTypeParser(_ref) {
    var defaultCountry = _ref.defaultCountry,
        defaultCallingCode = _ref.defaultCallingCode,
        metadata = _ref.metadata,
        onNationalSignificantNumberChange = _ref.onNationalSignificantNumberChange;

    _classCallCheck$1(this, AsYouTypeParser);

    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.metadata = metadata;
    this.onNationalSignificantNumberChange = onNationalSignificantNumberChange;
  }

  _createClass$1(AsYouTypeParser, [{
    key: "input",
    value: function input(text, state) {
      var _extractFormattedDigi = extractFormattedDigitsAndPlus(text),
          _extractFormattedDigi2 = _slicedToArray$2(_extractFormattedDigi, 2),
          formattedDigits = _extractFormattedDigi2[0],
          hasPlus = _extractFormattedDigi2[1];

      var digits = parseDigits(formattedDigits); // Checks for a special case: just a leading `+` has been entered.

      var justLeadingPlus;

      if (hasPlus) {
        if (!state.digits) {
          state.startInternationalNumber();

          if (!digits) {
            justLeadingPlus = true;
          }
        }
      }

      if (digits) {
        this.inputDigits(digits, state);
      }

      return {
        digits: digits,
        justLeadingPlus: justLeadingPlus
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */

  }, {
    key: "inputDigits",
    value: function inputDigits(nextDigits, state) {
      var digits = state.digits;
      var hasReceivedThreeLeadingDigits = digits.length < 3 && digits.length + nextDigits.length >= 3; // Append phone number digits.

      state.appendDigits(nextDigits); // Attempt to extract IDD prefix:
      // Some users input their phone number in international format,
      // but in an "out-of-country" dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers as soon as there're at least 3 digits.
      // Google's library attempts to extract IDD prefix at 3 digits,
      // so this library just copies that behavior.
      // I guess that's because the most commot IDD prefixes are
      // `00` (Europe) and `011` (US).
      // There exist really long IDD prefixes too:
      // for example, in Australia the default IDD prefix is `0011`,
      // and it could even be as long as `14880011`.
      // An IDD prefix is extracted here, and then every time when
      // there's a new digit and the number couldn't be formatted.

      if (hasReceivedThreeLeadingDigits) {
        this.extractIddPrefix(state);
      }

      if (this.isWaitingForCountryCallingCode(state)) {
        if (!this.extractCountryCallingCode(state)) {
          return;
        }
      } else {
        state.appendNationalSignificantNumberDigits(nextDigits);
      } // If a phone number is being input in international format,
      // then it's not valid for it to have a national prefix.
      // Still, some people incorrectly input such numbers with a national prefix.
      // In such cases, only attempt to strip a national prefix if the number becomes too long.
      // (but that is done later, not here)


      if (!state.international) {
        if (!this.hasExtractedNationalSignificantNumber) {
          this.extractNationalSignificantNumber(state.getNationalDigits(), function (stateUpdate) {
            return state.update(stateUpdate);
          });
        }
      }
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function isWaitingForCountryCallingCode(_ref2) {
      var international = _ref2.international,
          callingCode = _ref2.callingCode;
      return international && !callingCode;
    } // Extracts a country calling code from a number
    // being entered in internatonal format.

  }, {
    key: "extractCountryCallingCode",
    value: function extractCountryCallingCode$1(state) {
      var _extractCountryCallin = extractCountryCallingCode('+' + state.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
          countryCallingCode = _extractCountryCallin.countryCallingCode,
          number = _extractCountryCallin.number;

      if (countryCallingCode) {
        state.setCallingCode(countryCallingCode);
        state.update({
          nationalSignificantNumber: number
        });
        return true;
      }
    }
  }, {
    key: "reset",
    value: function reset(numberingPlan) {
      if (numberingPlan) {
        this.hasSelectedNumberingPlan = true;

        var nationalPrefixForParsing = numberingPlan._nationalPrefixForParsing();

        this.couldPossiblyExtractAnotherNationalSignificantNumber = nationalPrefixForParsing && COMPLEX_NATIONAL_PREFIX.test(nationalPrefixForParsing);
      } else {
        this.hasSelectedNumberingPlan = undefined;
        this.couldPossiblyExtractAnotherNationalSignificantNumber = undefined;
      }
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */

  }, {
    key: "extractNationalSignificantNumber",
    value: function extractNationalSignificantNumber(nationalDigits, setState) {
      if (!this.hasSelectedNumberingPlan) {
        return;
      }

      var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata),
          nationalPrefix = _extractNationalNumbe.nationalPrefix,
          nationalNumber = _extractNationalNumbe.nationalNumber,
          carrierCode = _extractNationalNumbe.carrierCode;

      if (nationalNumber === nationalDigits) {
        return;
      }

      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */

  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function extractAnotherNationalSignificantNumber(nationalDigits, prevNationalSignificantNumber, setState) {
      if (!this.hasExtractedNationalSignificantNumber) {
        return this.extractNationalSignificantNumber(nationalDigits, setState);
      }

      if (!this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        return;
      }

      var _extractNationalNumbe2 = extractNationalNumberFromPossiblyIncompleteNumber(nationalDigits, this.metadata),
          nationalPrefix = _extractNationalNumbe2.nationalPrefix,
          nationalNumber = _extractNationalNumbe2.nationalNumber,
          carrierCode = _extractNationalNumbe2.carrierCode; // If a national prefix has been extracted previously,
      // then it's always extracted as additional digits are added.
      // That's assuming `extractNationalNumberFromPossiblyIncompleteNumber()`
      // doesn't do anything different from what it currently does.
      // So, just in case, here's this check, though it doesn't occur.

      /* istanbul ignore if */


      if (nationalNumber === prevNationalSignificantNumber) {
        return;
      }

      this.onExtractedNationalNumber(nationalPrefix, carrierCode, nationalNumber, nationalDigits, setState);
      return true;
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function onExtractedNationalNumber(nationalPrefix, carrierCode, nationalSignificantNumber, nationalDigits, setState) {
      var complexPrefixBeforeNationalSignificantNumber;
      var nationalSignificantNumberMatchesInput; // This check also works with empty `this.nationalSignificantNumber`.

      var nationalSignificantNumberIndex = nationalDigits.lastIndexOf(nationalSignificantNumber); // If the extracted national (significant) number is the
      // last substring of the `digits`, then it means that it hasn't been altered:
      // no digits have been removed from the national (significant) number
      // while applying `national_prefix_transform_rule`.
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule

      if (nationalSignificantNumberIndex >= 0 && nationalSignificantNumberIndex === nationalDigits.length - nationalSignificantNumber.length) {
        nationalSignificantNumberMatchesInput = true; // If a prefix of a national (significant) number is not as simple
        // as just a basic national prefix, then such prefix is stored in
        // `this.complexPrefixBeforeNationalSignificantNumber` property and will be
        // prepended "as is" to the national (significant) number to produce
        // a formatted result.

        var prefixBeforeNationalNumber = nationalDigits.slice(0, nationalSignificantNumberIndex); // `prefixBeforeNationalNumber` is always non-empty,
        // because `onExtractedNationalNumber()` isn't called
        // when a national (significant) number hasn't been actually "extracted":
        // when a national (significant) number is equal to the national part of `digits`,
        // then `onExtractedNationalNumber()` doesn't get called.

        if (prefixBeforeNationalNumber !== nationalPrefix) {
          complexPrefixBeforeNationalSignificantNumber = prefixBeforeNationalNumber;
        }
      }

      setState({
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode,
        nationalSignificantNumber: nationalSignificantNumber,
        nationalSignificantNumberMatchesInput: nationalSignificantNumberMatchesInput,
        complexPrefixBeforeNationalSignificantNumber: complexPrefixBeforeNationalSignificantNumber
      }); // `onExtractedNationalNumber()` is only called when
      // the national (significant) number actually did change.

      this.hasExtractedNationalSignificantNumber = true;
      this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function reExtractNationalSignificantNumber(state) {
      // Attempt to extract a national prefix.
      //
      // Some people incorrectly input national prefix
      // in an international phone number.
      // For example, some people write British phone numbers as `+44(0)...`.
      //
      // Also, in some rare cases, it is valid for a national prefix
      // to be a part of an international phone number.
      // For example, mobile phone numbers in Mexico are supposed to be
      // dialled internationally using a `1` national prefix,
      // so the national prefix will be part of an international number.
      //
      // Quote from:
      // https://www.mexperience.com/dialing-cell-phones-in-mexico/
      //
      // "Dialing a Mexican cell phone from abroad
      // When you are calling a cell phone number in Mexico from outside Mexico,
      // it’s necessary to dial an additional “1” after Mexico’s country code
      // (which is “52”) and before the area code.
      // You also ignore the 045, and simply dial the area code and the
      // cell phone’s number.
      //
      // If you don’t add the “1”, you’ll receive a recorded announcement
      // asking you to redial using it.
      //
      // For example, if you are calling from the USA to a cell phone
      // in Mexico City, you would dial +52 – 1 – 55 – 1234 5678.
      // (Note that this is different to calling a land line in Mexico City
      // from abroad, where the number dialed would be +52 – 55 – 1234 5678)".
      //
      // Google's demo output:
      // https://libphonenumber.appspot.com/phonenumberparser?number=%2b5215512345678&country=MX
      //
      if (this.extractAnotherNationalSignificantNumber(state.getNationalDigits(), state.nationalSignificantNumber, function (stateUpdate) {
        return state.update(stateUpdate);
      })) {
        return true;
      } // If no format matches the phone number, then it could be
      // "a really long IDD" (quote from a comment in Google's library).
      // An IDD prefix is first extracted when the user has entered at least 3 digits,
      // and then here — every time when there's a new digit and the number
      // couldn't be formatted.
      // For example, in Australia the default IDD prefix is `0011`,
      // and it could even be as long as `14880011`.
      //
      // Could also check `!hasReceivedThreeLeadingDigits` here
      // to filter out the case when this check duplicates the one
      // already performed when there're 3 leading digits,
      // but it's not a big deal, and in most cases there
      // will be a suitable `format` when there're 3 leading digits.
      //


      if (this.extractIddPrefix(state)) {
        this.extractCallingCodeAndNationalSignificantNumber(state);
        return true;
      } // Google's AsYouType formatter supports sort of an "autocorrection" feature
      // when it "autocorrects" numbers that have been input for a country
      // with that country's calling code.
      // Such "autocorrection" feature looks weird, but different people have been requesting it:
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      // https://github.com/catamphetamine/libphonenumber-js/issues/375
      // https://github.com/catamphetamine/libphonenumber-js/issues/316


      if (this.fixMissingPlus(state)) {
        this.extractCallingCodeAndNationalSignificantNumber(state);
        return true;
      }
    }
  }, {
    key: "extractIddPrefix",
    value: function extractIddPrefix(state) {
      // An IDD prefix can't be present in a number written with a `+`.
      // Also, don't re-extract an IDD prefix if has already been extracted.
      var international = state.international,
          IDDPrefix = state.IDDPrefix,
          digits = state.digits;
      state.nationalSignificantNumber;

      if (international || IDDPrefix) {
        return;
      } // Some users input their phone number in "out-of-country"
      // dialing format instead of using the leading `+`.
      // https://github.com/catamphetamine/libphonenumber-js/issues/185
      // Detect such numbers.


      var numberWithoutIDD = stripIddPrefix(digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);

      if (numberWithoutIDD !== undefined && numberWithoutIDD !== digits) {
        // If an IDD prefix was stripped then convert the IDD-prefixed number
        // to international number for subsequent parsing.
        state.update({
          IDDPrefix: digits.slice(0, digits.length - numberWithoutIDD.length)
        });
        this.startInternationalNumber(state, {
          country: undefined,
          callingCode: undefined
        });
        return true;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function fixMissingPlus(state) {
      if (!state.international) {
        var _extractCountryCallin2 = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(state.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
            newCallingCode = _extractCountryCallin2.countryCallingCode;

        _extractCountryCallin2.number;

        if (newCallingCode) {
          state.update({
            missingPlus: true
          });
          this.startInternationalNumber(state, {
            country: state.country,
            callingCode: newCallingCode
          });
          return true;
        }
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function startInternationalNumber(state, _ref3) {
      var country = _ref3.country,
          callingCode = _ref3.callingCode;
      state.startInternationalNumber(country, callingCode); // If a national (significant) number has been extracted before, reset it.

      if (state.nationalSignificantNumber) {
        state.resetNationalSignificantNumber();
        this.onNationalSignificantNumberChange();
        this.hasExtractedNationalSignificantNumber = undefined;
      }
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function extractCallingCodeAndNationalSignificantNumber(state) {
      if (this.extractCountryCallingCode(state)) {
        // `this.extractCallingCode()` is currently called when the number
        // couldn't be formatted during the standard procedure.
        // Normally, the national prefix would be re-extracted
        // for an international number if such number couldn't be formatted,
        // but since it's already not able to be formatted,
        // there won't be yet another retry, so also extract national prefix here.
        this.extractNationalSignificantNumber(state.getNationalDigits(), function (stateUpdate) {
          return state.update(stateUpdate);
        });
      }
    }
  }]);

  return AsYouTypeParser;
}();

function extractFormattedPhoneNumber(text) {
  // Attempt to extract a possible number from the string passed in.
  var startsAt = text.search(VALID_FORMATTED_PHONE_NUMBER_PART);

  if (startsAt < 0) {
    return;
  } // Trim everything to the left of the phone number.


  text = text.slice(startsAt); // Trim the `+`.

  var hasPlus;

  if (text[0] === '+') {
    hasPlus = true;
    text = text.slice('+'.length);
  } // Trim everything to the right of the phone number.


  text = text.replace(AFTER_PHONE_NUMBER_DIGITS_END_PATTERN, ''); // Re-add the previously trimmed `+`.

  if (hasPlus) {
    text = '+' + text;
  }

  return text;
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */


function _extractFormattedDigitsAndPlus(text) {
  // Extract a formatted phone number part from text.
  var extractedNumber = extractFormattedPhoneNumber(text) || ''; // Trim a `+`.

  if (extractedNumber[0] === '+') {
    return [extractedNumber.slice('+'.length), true];
  }

  return [extractedNumber];
}
/**
 * Extracts formatted phone number digits (and a `+`) from text (if there're any).
 * @param  {string} text
 * @return {any[]}
 */


function extractFormattedDigitsAndPlus(text) {
  var _extractFormattedDigi3 = _extractFormattedDigitsAndPlus(text),
      _extractFormattedDigi4 = _slicedToArray$2(_extractFormattedDigi3, 2),
      formattedDigits = _extractFormattedDigi4[0],
      hasPlus = _extractFormattedDigi4[1]; // If the extracted phone number part
  // can possibly be a part of some valid phone number
  // then parse phone number characters from a formatted phone number.


  if (!VALID_FORMATTED_PHONE_NUMBER_DIGITS_PART_PATTERN.test(formattedDigits)) {
    formattedDigits = '';
  }

  return [formattedDigits, hasPlus];
}

function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1();
}

function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit$1(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

var AsYouType = /*#__PURE__*/function () {
  /**
   * @param {(string|object)?} [optionsOrDefaultCountry] - The default country used for parsing non-international phone numbers. Can also be an `options` object.
   * @param {Object} metadata
   */
  function AsYouType(optionsOrDefaultCountry, metadata) {
    _classCallCheck(this, AsYouType);

    this.metadata = new Metadata(metadata);

    var _this$getCountryAndCa = this.getCountryAndCallingCode(optionsOrDefaultCountry),
        _this$getCountryAndCa2 = _slicedToArray$1(_this$getCountryAndCa, 2),
        defaultCountry = _this$getCountryAndCa2[0],
        defaultCallingCode = _this$getCountryAndCa2[1]; // `this.defaultCountry` and `this.defaultCallingCode` aren't required to be in sync.
    // For example, `this.defaultCountry` could be `"AR"` and `this.defaultCallingCode` could be `undefined`.
    // So `this.defaultCountry` and `this.defaultCallingCode` are totally independent.


    this.defaultCountry = defaultCountry;
    this.defaultCallingCode = defaultCallingCode;
    this.reset();
  }

  _createClass(AsYouType, [{
    key: "getCountryAndCallingCode",
    value: function getCountryAndCallingCode(optionsOrDefaultCountry) {
      // Set `defaultCountry` and `defaultCallingCode` options.
      var defaultCountry;
      var defaultCallingCode; // Turns out `null` also has type "object". Weird.

      if (optionsOrDefaultCountry) {
        if (isObject(optionsOrDefaultCountry)) {
          defaultCountry = optionsOrDefaultCountry.defaultCountry;
          defaultCallingCode = optionsOrDefaultCountry.defaultCallingCode;
        } else {
          defaultCountry = optionsOrDefaultCountry;
        }
      }

      if (defaultCountry && !this.metadata.hasCountry(defaultCountry)) {
        defaultCountry = undefined;
      }

      return [defaultCountry, defaultCallingCode];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */

  }, {
    key: "input",
    value: function input(text) {
      var _this$parser$input = this.parser.input(text, this.state),
          digits = _this$parser$input.digits,
          justLeadingPlus = _this$parser$input.justLeadingPlus;

      if (justLeadingPlus) {
        this.formattedOutput = '+';
      } else if (digits) {
        this.determineTheCountryIfNeeded(); // Match the available formats by the currently available leading digits.

        if (this.state.nationalSignificantNumber) {
          this.formatter.narrowDownMatchingFormats(this.state);
        }

        var formattedNationalNumber;

        if (this.metadata.hasSelectedNumberingPlan()) {
          formattedNationalNumber = this.formatter.format(digits, this.state);
        }

        if (formattedNationalNumber === undefined) {
          // See if another national (significant) number could be re-extracted.
          if (this.parser.reExtractNationalSignificantNumber(this.state)) {
            this.determineTheCountryIfNeeded(); // If it could, then re-try formatting the new national (significant) number.

            var nationalDigits = this.state.getNationalDigits();

            if (nationalDigits) {
              formattedNationalNumber = this.formatter.format(nationalDigits, this.state);
            }
          }
        }

        this.formattedOutput = formattedNationalNumber ? this.getFullNumber(formattedNationalNumber) : this.getNonFormattedNumber();
      }

      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this = this;

      this.state = new AsYouTypeState({
        onCountryChange: function onCountryChange(country) {
          // Before version `1.6.0`, the official `AsYouType` formatter API
          // included the `.country` property of an `AsYouType` instance.
          // Since that property (along with the others) have been moved to
          // `this.state`, `this.country` property is emulated for compatibility
          // with the old versions.
          _this.country = country;
        },
        onCallingCodeChange: function onCallingCodeChange(callingCode, country) {
          _this.metadata.selectNumberingPlan(country, callingCode);

          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);

          _this.parser.reset(_this.metadata.numberingPlan);
        }
      });
      this.formatter = new AsYouTypeFormatter({
        state: this.state,
        metadata: this.metadata
      });
      this.parser = new AsYouTypeParser({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function onNationalSignificantNumberChange() {
          _this.determineTheCountryIfNeeded();

          _this.formatter.reset(_this.metadata.numberingPlan, _this.state);
        }
      });
      this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      });
      this.formattedOutput = '';
      return this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */

  }, {
    key: "isInternational",
    value: function isInternational() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */

  }, {
    key: "getCallingCode",
    value: function getCallingCode() {
      // If the number is being input in national format and some "default calling code"
      // has been passed to `AsYouType` constructor, then `this.state.callingCode`
      // is equal to that "default calling code".
      //
      // If the number is being input in national format and no "default calling code"
      // has been passed to `AsYouType` constructor, then returns `undefined`,
      // even if a "default country" has been passed to `AsYouType` constructor.
      //
      if (this.isInternational()) {
        return this.state.callingCode;
      }
    } // A legacy alias.

  }, {
    key: "getCountryCallingCode",
    value: function getCountryCallingCode() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */

  }, {
    key: "getCountry",
    value: function getCountry() {
      var digits = this.state.digits; // Return `undefined` if no digits have been input yet.

      if (digits) {
        return this._getCountry();
      }
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */

  }, {
    key: "_getCountry",
    value: function _getCountry() {
      var country = this.state.country;
      return country;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function determineTheCountryIfNeeded() {
      // Suppose a user enters a phone number in international format,
      // and there're several countries corresponding to that country calling code,
      // and a country has been derived from the number, and then
      // a user enters one more digit and the number is no longer
      // valid for the derived country, so the country should be re-derived
      // on every new digit in those cases.
      //
      // If the phone number is being input in national format,
      // then it could be a case when `defaultCountry` wasn't specified
      // when creating `AsYouType` instance, and just `defaultCallingCode` was specified,
      // and that "calling code" could correspond to a "non-geographic entity",
      // or there could be several countries corresponding to that country calling code.
      // In those cases, `this.country` is `undefined` and should be derived
      // from the number. Again, if country calling code is ambiguous, then
      // `this.country` should be re-derived with each new digit.
      //
      if (!this.state.country || this.isCountryCallingCodeAmbiguous()) {
        this.determineTheCountry();
      }
    } // Prepends `+CountryCode ` in case of an international phone number

  }, {
    key: "getFullNumber",
    value: function getFullNumber(formattedNationalNumber) {
      var _this2 = this;

      if (this.isInternational()) {
        var prefix = function prefix(text) {
          return _this2.formatter.getInternationalPrefixBeforeCountryCallingCode(_this2.state, {
            spacing: text ? true : false
          }) + text;
        };

        var callingCode = this.state.callingCode;

        if (!callingCode) {
          return prefix("".concat(this.state.getDigitsWithoutInternationalPrefix()));
        }

        if (!formattedNationalNumber) {
          return prefix(callingCode);
        }

        return prefix("".concat(callingCode, " ").concat(formattedNationalNumber));
      }

      return formattedNationalNumber;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function getNonFormattedNationalNumberWithPrefix() {
      var _this$state = this.state,
          nationalSignificantNumber = _this$state.nationalSignificantNumber,
          complexPrefixBeforeNationalSignificantNumber = _this$state.complexPrefixBeforeNationalSignificantNumber,
          nationalPrefix = _this$state.nationalPrefix;
      var number = nationalSignificantNumber;
      var prefix = complexPrefixBeforeNationalSignificantNumber || nationalPrefix;

      if (prefix) {
        number = prefix + number;
      }

      return number;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function getNonFormattedNumber() {
      var nationalSignificantNumberMatchesInput = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(nationalSignificantNumberMatchesInput ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function getNonFormattedTemplate() {
      var number = this.getNonFormattedNumber();

      if (number) {
        return number.replace(/[\+\d]/g, DIGIT_PLACEHOLDER);
      }
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function isCountryCallingCodeAmbiguous() {
      var callingCode = this.state.callingCode;
      var countryCodes = this.metadata.getCountryCodesForCallingCode(callingCode);
      return countryCodes && countryCodes.length > 1;
    } // Determines the country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.

  }, {
    key: "determineTheCountry",
    value: function determineTheCountry() {
      this.state.setCountry(getCountryByCallingCode(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        defaultCountry: this.defaultCountry,
        metadata: this.metadata
      }));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */

  }, {
    key: "getNumberValue",
    value: function getNumberValue() {
      var _this$state2 = this.state,
          digits = _this$state2.digits,
          callingCode = _this$state2.callingCode,
          country = _this$state2.country,
          nationalSignificantNumber = _this$state2.nationalSignificantNumber; // Will return `undefined` if no digits have been input.

      if (!digits) {
        return;
      }

      if (this.isInternational()) {
        if (callingCode) {
          return '+' + callingCode + nationalSignificantNumber;
        } else {
          return '+' + digits;
        }
      } else {
        if (country || callingCode) {
          var callingCode_ = country ? this.metadata.countryCallingCode() : callingCode;
          return '+' + callingCode_ + nationalSignificantNumber;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */

  }, {
    key: "getNumber",
    value: function getNumber() {
      var _this$state3 = this.state,
          nationalSignificantNumber = _this$state3.nationalSignificantNumber,
          carrierCode = _this$state3.carrierCode,
          callingCode = _this$state3.callingCode; // `this._getCountry()` is basically same as `this.state.country`
      // with the only change that it return `undefined` in case of a
      // "non-geographic" numbering plan instead of `"001"` "internal use" value.

      var country = this._getCountry();

      if (!nationalSignificantNumber) {
        return;
      } // `state.country` and `state.callingCode` aren't required to be in sync.
      // For example, `country` could be `"AR"` and `callingCode` could be `undefined`.
      // So `country` and `callingCode` are totally independent.


      if (!country && !callingCode) {
        return;
      } // By default, if `defaultCountry` parameter was passed when
      // creating `AsYouType` instance, `state.country` is gonna be
      // that `defaultCountry`, which doesn't entirely conform with
      // `parsePhoneNumber()`'s behavior where it attempts to determine
      // the country more precisely in cases when multiple countries
      // could correspond to the same `countryCallingCode`.
      // https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/103#note_1417192969
      //
      // Because `AsYouType.getNumber()` method is supposed to be a 1:1
      // equivalent for `parsePhoneNumber(AsYouType.getNumberValue())`,
      // then it should also behave accordingly in cases of `country` ambiguity.
      // That's how users of this library would expect it to behave anyway.
      //


      if (country) {
        if (country === this.defaultCountry) {
          // `state.country` and `state.callingCode` aren't required to be in sync.
          // For example, `state.country` could be `"AR"` and `state.callingCode` could be `undefined`.
          // So `state.country` and `state.callingCode` are totally independent.
          var metadata = new Metadata(this.metadata.metadata);
          metadata.selectNumberingPlan(country);

          var _callingCode = metadata.numberingPlan.callingCode();

          var ambiguousCountries = this.metadata.getCountryCodesForCallingCode(_callingCode);

          if (ambiguousCountries.length > 1) {
            var exactCountry = getCountryByNationalNumber(nationalSignificantNumber, {
              countries: ambiguousCountries,
              defaultCountry: this.defaultCountry,
              metadata: this.metadata.metadata
            });

            if (exactCountry) {
              country = exactCountry;
            }
          }
        }
      }

      var phoneNumber = new PhoneNumber(country || callingCode, nationalSignificantNumber, this.metadata.metadata);

      if (carrierCode) {
        phoneNumber.carrierCode = carrierCode;
      } // Phone number extensions are not supported by "As You Type" formatter.


      return phoneNumber;
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */

  }, {
    key: "isPossible",
    value: function isPossible() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isPossible();
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */

  }, {
    key: "isValid",
    value: function isValid() {
      var phoneNumber = this.getNumber();

      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isValid();
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */

  }, {
    key: "getNationalNumber",
    value: function getNationalNumber() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */

  }, {
    key: "getChars",
    value: function getChars() {
      return (this.state.international ? '+' : '') + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */

  }, {
    key: "getTemplate",
    value: function getTemplate() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || '';
    }
  }]);

  return AsYouType;
}();
/**
 * Formats a (possibly incomplete) phone number.
 * The phone number can be either in E.164 format
 * or in a form of national number digits.
 * @param {string} value - A possibly incomplete phone number. Either in E.164 format or in a form of national number digits.
 * @param {string|object} [optionsOrDefaultCountry] - A two-letter ("ISO 3166-1 alpha-2") country code, or an object of shape `{ defaultCountry?: string, defaultCallingCode?: string }`.
 * @return {string} Formatted (possibly incomplete) phone number.
 */


function formatIncompletePhoneNumber(value, optionsOrDefaultCountry, metadata) {
  if (!metadata) {
    metadata = optionsOrDefaultCountry;
    optionsOrDefaultCountry = undefined;
  }

  return new AsYouType(optionsOrDefaultCountry, metadata).input(value);
}

function getPrefixForFormattingValueAsPhoneNumber(_ref) {
  var inputFormat = _ref.inputFormat,
      country = _ref.country,
      metadata = _ref.metadata;
  return inputFormat === 'NATIONAL_PART_OF_INTERNATIONAL' ? "+".concat(getCountryCallingCode$1(country, metadata)) : '';
}

function removePrefixFromFormattedPhoneNumber(value, prefix) {
  if (prefix) {
    value = value.slice(prefix.length);

    if (value[0] === ' ') {
      value = value.slice(1);
    }
  }

  return value;
}
/**
 * Parses next character while parsing phone number digits (including a `+`)
 * from text: discards everything except `+` and digits, and `+` is only allowed
 * at the start of a phone number.
 * For example, is used in `react-phone-number-input` where it uses
 * [`input-format`](https://gitlab.com/catamphetamine/input-format).
 * @param  {string} character - Yet another character from raw input string.
 * @param  {string?} prevParsedCharacters - Previous parsed characters.
 * @param  {object?} context - An optional object that could be used by this function to set arbitrary "flags". The object should be shared within the parsing of the whole string.
 * @return {string?} The parsed character.
 */


function parsePhoneNumberCharacter_(character, prevParsedCharacters, context) {
  // `context` argument was added as a third argument of `parse()` function
  // in `input-format` package on Dec 26th, 2023. So it could potentially be
  // `undefined` here if a 3rd-party app somehow ends up with this newer version
  // of `react-phone-number-input` and an older version of `input-format`.
  // Dunno how, but just in case, it could be `undefined` here and it wouldn't break.
  // Maybe it's not required to handle `undefined` case here.
  //
  // The addition of the `context` argument was to fix the slightly-weird behavior
  // of parsing an input string when the user inputs something like `"2+7"
  // https://github.com/catamphetamine/react-phone-number-input/issues/437
  //
  // If the parser encounters an unexpected `+` in a string being parsed
  // then it simply discards that out-of-place `+` and any following characters.
  //
  if (context && context.ignoreRest) {
    return;
  }

  var emitEvent = function emitEvent(eventName) {
    if (context) {
      switch (eventName) {
        case 'end':
          context.ignoreRest = true;
          break;
      }
    }
  };

  return parsePhoneNumberCharacter(character, prevParsedCharacters, emitEvent);
} // Returns a custom `onKeyDown` handler that works around a Backspace keypress edge case:
// * `<PhoneInputWithCountrySelect international countryCallingCodeEditable={false}/>`
// * When placing the caret before the leading plus character and pressing Backspace,
//   it duplicates the country calling code in the `<input/>`.
// https://github.com/catamphetamine/react-phone-number-input/issues/442


function useInputKeyDownHandler(_ref) {
  var onKeyDown = _ref.onKeyDown,
      inputFormat = _ref.inputFormat;
  return useCallback(function (event) {
    // Usability:
    // Don't allow the user to erase a leading "+" character when "international" input mode is forced.
    // That indicates to the user that they can't possibly enter the phone number in a non-international format.
    if (event.keyCode === BACKSPACE_KEY_CODE && inputFormat === 'INTERNATIONAL') {
      // It checks `event.target` here for being an `<input/>` element
      // because "keydown" events may bubble from arbitrary child elements
      // so there's no guarantee that `event.target` represents an `<input/>` element.
      // Also, since `inputComponent` is not neceesarily an `<input/>`, this check is required too.
      if (event.target instanceof HTMLInputElement) {
        if (getCaretPosition(event.target) === LEADING_PLUS.length) {
          event.preventDefault();
          return;
        }
      }
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  }, [onKeyDown, inputFormat]);
} // Gets the caret position in an `<input/>` field.
// The caret position starts with `0` which means "before the first character".


function getCaretPosition(element) {
  return element.selectionStart;
}

var BACKSPACE_KEY_CODE = 8;
var LEADING_PLUS = '+';
var _excluded$h = ["onKeyDown", "country", "inputFormat", "metadata", "international", "withCountryCallingCode"];

function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$3.apply(this, arguments);
}

function _objectWithoutProperties$3(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$3(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function createInput$2(defaultMetadata) {
  /**
   * `InputSmart` is a "smarter" implementation of a `Component`
   * that can be passed to `<PhoneInput/>`. It parses and formats
   * the user's and maintains the caret's position in the process.
   * The caret positioning is maintained using `input-format` library.
   * Relies on being run in a DOM environment for calling caret positioning functions.
   */
  function InputSmart(_ref, ref) {
    var onKeyDown = _ref.onKeyDown,
        country = _ref.country,
        inputFormat = _ref.inputFormat,
        _ref$metadata = _ref.metadata,
        metadata = _ref$metadata === void 0 ? defaultMetadata : _ref$metadata;
    _ref.international;
    _ref.withCountryCallingCode;

    var rest = _objectWithoutProperties$3(_ref, _excluded$h);

    var format = useCallback(function (value) {
      // "As you type" formatter.
      var formatter = new AsYouType(country, metadata);
      var prefix = getPrefixForFormattingValueAsPhoneNumber({
        inputFormat: inputFormat,
        country: country,
        metadata: metadata
      }); // Format the number.

      var text = formatter.input(prefix + value);
      var template = formatter.getTemplate();

      if (prefix) {
        text = removePrefixFromFormattedPhoneNumber(text, prefix); // `AsYouType.getTemplate()` can be `undefined`.

        if (template) {
          template = removePrefixFromFormattedPhoneNumber(template, prefix);
        }
      }

      return {
        text: text,
        template: template
      };
    }, [country, metadata]);

    var _onKeyDown = useInputKeyDownHandler({
      onKeyDown: onKeyDown,
      inputFormat: inputFormat
    });

    return /*#__PURE__*/React__default.createElement(Input$2, _extends$3({}, rest, {
      ref: ref,
      parse: parsePhoneNumberCharacter_,
      format: format,
      onKeyDown: _onKeyDown
    }));
  }

  InputSmart = /*#__PURE__*/React__default.forwardRef(InputSmart);
  InputSmart.propTypes = {
    /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */
    value: PropTypes.string.isRequired,

    /**
     * A function of `value: string`.
     * Updates the `value` property.
     */
    onChange: PropTypes.func.isRequired,

    /**
     * A function of `event: Event`.
     * Handles `keydown` events.
     */
    onKeyDown: PropTypes.func,

    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * This property should've been called `defaultCountry`
     * because it only applies when the user inputs a phone number in a national format
     * and is completely ignored when the user inputs a phone number in an international format.
     */
    country: PropTypes.string,

    /**
     * The format that the input field value is being input/output in.
     */
    inputFormat: PropTypes.oneOf(['INTERNATIONAL', 'NATIONAL_PART_OF_INTERNATIONAL', 'NATIONAL', 'INTERNATIONAL_OR_NATIONAL']).isRequired,

    /**
     * `libphonenumber-js` metadata.
     */
    metadata: PropTypes.object
  };
  return InputSmart;
}

var InputSmart = createInput$2();
var _excluded$g = ["value", "onChange", "onKeyDown", "country", "inputFormat", "metadata", "inputComponent", "international", "withCountryCallingCode"];

function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$2.apply(this, arguments);
}

function _objectWithoutProperties$2(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$2(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function createInput$1(defaultMetadata) {
  /**
   * `InputBasic` is the most basic implementation of a `Component`
   * that can be passed to `<PhoneInput/>`. It parses and formats
   * the user's input but doesn't control the caret in the process:
   * when erasing or inserting digits in the middle of a phone number
   * the caret usually jumps to the end (this is the expected behavior).
   * Why does `InputBasic` exist when there's `InputSmart`?
   * One reason is working around the [Samsung Galaxy smart caret positioning bug]
   * (https://github.com/catamphetamine/react-phone-number-input/issues/75).
   * Another reason is that, unlike `InputSmart`, it doesn't require DOM environment.
   */
  function InputBasic(_ref, ref) {
    var value = _ref.value,
        onChange = _ref.onChange,
        onKeyDown = _ref.onKeyDown,
        country = _ref.country,
        inputFormat = _ref.inputFormat,
        _ref$metadata = _ref.metadata,
        metadata = _ref$metadata === void 0 ? defaultMetadata : _ref$metadata,
        _ref$inputComponent = _ref.inputComponent,
        Input = _ref$inputComponent === void 0 ? 'input' : _ref$inputComponent;
    _ref.international;
    _ref.withCountryCallingCode;

    var rest = _objectWithoutProperties$2(_ref, _excluded$g);

    var prefix = getPrefixForFormattingValueAsPhoneNumber({
      inputFormat: inputFormat,
      country: country,
      metadata: metadata
    });

    var _onChange = useCallback(function (event) {
      var newValue = parseIncompletePhoneNumber(event.target.value); // By default, if a value is something like `"(123)"`
      // then Backspace would only erase the rightmost brace
      // becoming something like `"(123"`
      // which would give the same `"123"` value
      // which would then be formatted back to `"(123)"`
      // and so a user wouldn't be able to erase the phone number.
      //
      // This issue is worked around with this simple hack:
      // when "old" and "new" parsed values are the same,
      // it checks if the "new" formatted value could be obtained
      // from the "old" formatted value by erasing some (or no) characters at the right side.
      // If it could then it's likely that the user has hit a Backspace key
      // and what they really intended was to erase a rightmost digit rather than
      // a rightmost punctuation character.
      //

      if (newValue === value) {
        var newValueFormatted = format(prefix, newValue, country, metadata);

        if (newValueFormatted.indexOf(event.target.value) === 0) {
          // Trim the last digit (or plus sign).
          newValue = newValue.slice(0, -1);
        }
      }

      onChange(newValue);
    }, [prefix, value, onChange, country, metadata]);

    var _onKeyDown = useInputKeyDownHandler({
      onKeyDown: onKeyDown,
      inputFormat: inputFormat
    });

    return /*#__PURE__*/React__default.createElement(Input, _extends$2({}, rest, {
      ref: ref,
      value: format(prefix, value, country, metadata),
      onChange: _onChange,
      onKeyDown: _onKeyDown
    }));
  }

  InputBasic = /*#__PURE__*/React__default.forwardRef(InputBasic);
  InputBasic.propTypes = {
    /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */
    value: PropTypes.string.isRequired,

    /**
     * A function of `value: string`.
     * Updates the `value` property.
     */
    onChange: PropTypes.func.isRequired,

    /**
     * A function of `event: Event`.
     * Handles `keydown` events.
     */
    onKeyDown: PropTypes.func,

    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * This property should've been called `defaultCountry`
     * because it only applies when the user inputs a phone number in a national format
     * and is completely ignored when the user inputs a phone number in an international format.
     */
    country: PropTypes.string,

    /**
     * The format that the input field value is being input/output in.
     */
    inputFormat: PropTypes.oneOf(['INTERNATIONAL', 'NATIONAL_PART_OF_INTERNATIONAL', 'NATIONAL', 'INTERNATIONAL_OR_NATIONAL']).isRequired,

    /**
     * `libphonenumber-js` metadata.
     */
    metadata: PropTypes.object,

    /**
     * The `<input/>` component.
     */
    inputComponent: PropTypes.elementType
  };
  return InputBasic;
}

var InputBasic = createInput$1();

function format(prefix, value, country, metadata) {
  return removePrefixFromFormattedPhoneNumber(formatIncompletePhoneNumber(prefix + value, country, metadata), prefix);
} // Tells if `value: string` is an `E.164` phone number.
//
// Returns a boolean.
//
// It doesn't validate that the minimum national (significant) number length
// is at least 2 characters.
//


function isE164Number(value) {
  if (value.length < 2) {
    return false;
  }

  if (value[0] !== '+') {
    return false;
  }

  var i = 1;

  while (i < value.length) {
    var character = value.charCodeAt(i);
    if (character >= 48 && character <= 57) ;else {
      return false;
    }
    i++;
  }

  return true;
}

function validateE164Number(value) {
  if (!isE164Number(value)) {
    console.error('[react-phone-number-input] Expected the initial `value` to be a E.164 phone number. Got', value);
  }
}

var metadata = PropTypes.shape({
  country_calling_codes: PropTypes.object.isRequired,
  countries: PropTypes.object.isRequired
});
PropTypes.objectOf(PropTypes.string);

function getInternationalPhoneNumberPrefix(country, metadata) {
  // Standard international phone number prefix: "+" and "country calling code".
  var prefix = '+' + getCountryCallingCode$1(country, metadata); // "Leading digits" can't be used to rule out any countries.
  // So the "pre-fill with leading digits on country selection" feature had to be reverted.
  // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/10#note_1231042367
  // // Get "leading digits" for a phone number of the country.
  // // If there're "leading digits" then they can be part of the prefix too.
  // // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/10
  // metadata = new Metadata(metadata)
  // metadata.selectNumberingPlan(country)
  // // "Leading digits" patterns are only defined for about 20% of all countries.
  // // By definition, matching "leading digits" is a sufficient but not a necessary
  // // condition for a phone number to belong to a country.
  // // The point of "leading digits" check is that it's the fastest one to get a match.
  // // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
  // const leadingDigits = metadata.numberingPlan.leadingDigits()
  // if (leadingDigits && ONLY_DIGITS_REGEXP.test(leadingDigits)) {
  // 	prefix += leadingDigits
  // }

  return prefix;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];

  if (null != t) {
    var e,
        n,
        i,
        u,
        a = [],
        f = !0,
        o = !1;

    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }

    return a;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
/**
 * Returns `[phoneDigits, setPhoneDigits]`.
 * "Phone digits" includes not only "digits" but also a `+` sign.
 */


function usePhoneDigits(_ref) {
  var _this = this;

  var value = _ref.value,
      onChange = _ref.onChange,
      country = _ref.country,
      defaultCountry = _ref.defaultCountry,
      international = _ref.international,
      withCountryCallingCode = _ref.withCountryCallingCode,
      useNationalFormatForDefaultCountryValue = _ref.useNationalFormatForDefaultCountryValue,
      metadata = _ref.metadata; // Validate the use of `withCountryCallingCode` property.

  if (typeof withCountryCallingCode === 'boolean' && !(country && international)) {
    console.error('[react-phone-number-input] `withCountryCallingCode` property can only be used together with `country` and `international` properties');
  } // Validate the use of `country` and `defaultCountry` properties.


  if (country && defaultCountry) {
    console.error('[react-phone-number-input] When `country` property is passed, `defaultCountry` property has no effect and therefore shouldn\'t be passed');
  } // Validate the use of `international` property.


  if (typeof international === 'boolean' && !country) {
    console.error('[react-phone-number-input] `international` property can only be used together with `country` property');
  }

  var inputFormat = getInputFormat({
    international: international,
    country: country,
    defaultCountry: defaultCountry,
    withCountryCallingCode: withCountryCallingCode
  });
  var countryMismatchDetected = useRef();

  var onCountryMismatch = function onCountryMismatch(value, country, actualCountry) {
    console.error("[react-phone-number-input] Expected phone number ".concat(value, " to correspond to country ").concat(country, " but ").concat(actualCountry ? 'in reality it corresponds to country ' + actualCountry : 'it doesn\'t', "."));
    countryMismatchDetected.current = true;
  };

  var getInitialPhoneDigits = function getInitialPhoneDigits(options) {
    // Validate that the initially-supplied `value` is in `E.164` format.
    // Because sometimes people attempt to supply a `value` like "+1 (879) 490-8676".
    // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/231#note_2016334796
    if (value) {
      validateE164Number(value);
    }

    return getPhoneDigitsForValue(value, country, defaultCountry, inputFormat, useNationalFormatForDefaultCountryValue, metadata, function () {
      if (options && options.onCountryMismatch) {
        options.onCountryMismatch();
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      onCountryMismatch.apply(_this, args);
    });
  }; // This is only used to detect `country` property change.


  var _useState = useState(country),
      _useState2 = _slicedToArray(_useState, 2),
      prevCountry = _useState2[0],
      setPrevCountry = _useState2[1]; // This is only used to detect `defaultCountry` property change.


  var _useState3 = useState(defaultCountry),
      _useState4 = _slicedToArray(_useState3, 2),
      prevDefaultCountry = _useState4[0],
      setPrevDefaultCountry = _useState4[1]; // `phoneDigits` is the a property that gets passed to the `<input/>` component as its "value":
  // * `phoneDigits` is the `<input value/>` property.
  // * `value` is the `<PhoneInput value/>` property.


  var _useState5 = useState(getInitialPhoneDigits()),
      _useState6 = _slicedToArray(_useState5, 2),
      phoneDigits = _useState6[0],
      setPhoneDigits = _useState6[1]; // This is only used to detect `value` property changes.


  var _useState7 = useState(value),
      _useState8 = _slicedToArray(_useState7, 2),
      valueForPhoneDigits = _useState8[0],
      setValueForPhoneDigits = _useState8[1]; // Rerender hack.


  var _useState9 = useState(),
      _useState10 = _slicedToArray(_useState9, 2);

  _useState10[0];
  var setRerenderTrigger = _useState10[1];
  var rerender = useCallback(function () {
    return setRerenderTrigger({});
  }, [setRerenderTrigger]);

  function getValueForPhoneDigits(phoneDigits) {
    // If the user hasn't input any digits then `value` is `undefined`.
    if (!phoneDigits) {
      return;
    }

    if (inputFormat === 'NATIONAL_PART_OF_INTERNATIONAL') {
      phoneDigits = "+".concat(getCountryCallingCode$1(country, metadata)).concat(phoneDigits);
    } // Return the E.164 phone number value.
    //
    // Even if no "national (significant) number" digits have been input,
    // still return a non-`undefined` value.
    // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/113
    //
    // For example, if the user has selected country `US` and entered `"1"`
    // then that `"1"` is just a "national prefix" and no "national (significant) number"
    // digits have been input yet. Still, return `"+1"` as `value` in such cases,
    // because otherwise the app would think that the input is empty and mark it as such
    // while in reality it isn't empty, which might be thought of as a "bug", or just
    // a "weird" behavior.
    //
    // The only case when there's any input and `getNumberValue()` still returns `undefined`
    // is when that input is `"+"`.
    //


    var asYouType = new AsYouType(country || defaultCountry, metadata);
    asYouType.input(phoneDigits);
    return asYouType.getNumberValue();
  } // If `value` property has been changed externally
  // then re-initialize the component.


  useEffect(function () {
    if (value !== valueForPhoneDigits) {
      setValueForPhoneDigits(value);
      setPhoneDigits(getInitialPhoneDigits());
    }
  }, [value]); // If the `country` has been changed then re-initialize the component.

  useEffect(function () {
    if (country !== prevCountry) {
      setPrevCountry(country);

      var _countryMismatchDetected;

      var _phoneDigits = getInitialPhoneDigits({
        onCountryMismatch: function onCountryMismatch() {
          _countryMismatchDetected = true;
        }
      });

      setPhoneDigits(_phoneDigits);

      if (_countryMismatchDetected) {
        setValueForPhoneDigits(getValueForPhoneDigits(_phoneDigits));
      }
    }
  }, [country]); // If the `defaultCountry` has been changed then re-initialize the component.

  useEffect(function () {
    if (defaultCountry !== prevDefaultCountry) {
      setPrevDefaultCountry(defaultCountry);
      setPhoneDigits(getInitialPhoneDigits());
    }
  }, [defaultCountry]); // Update the `value` after `valueForPhoneDigits` has been updated.

  useEffect(function () {
    if (valueForPhoneDigits !== value) {
      onChange(valueForPhoneDigits);
    }
  }, [valueForPhoneDigits]);
  var onSetPhoneDigits = useCallback(function (phoneDigits) {
    var value;

    if (country) {
      if (inputFormat === 'INTERNATIONAL') {
        // The `<input/>` value must start with the country calling code.
        var prefix = getInternationalPhoneNumberPrefix(country, metadata);

        if (phoneDigits.indexOf(prefix) !== 0) {
          // If a user tabs into a phone number input field
          // that is in `withCountryCallingCode` mode,
          // and then starts inputting local phone number digits,
          // the first digit would get "swallowed" if the fix below wasn't implemented.
          // https://gitlab.com/catamphetamine/react-phone-number-input/-/issues/43
          if (phoneDigits && phoneDigits[0] !== '+') {
            phoneDigits = prefix + phoneDigits;
          } else {
            // // Reset phone digits if they don't start with the correct prefix.
            // // Undo the `<input/>` value change if it doesn't.
            if (countryMismatchDetected.current) ;else {
              // If it simply did `phoneDigits = prefix` here,
              // then it could have no effect when erasing phone number
              // via Backspace, because `phoneDigits` in `state` wouldn't change
              // as a result, because it was `prefix` and it became `prefix`,
              // so the component wouldn't rerender, and the user would be able
              // to erase the country calling code part, and that part is
              // assumed to be non-eraseable. That's why the component is
              // forcefully rerendered here.
              setPhoneDigits(prefix);
              setValueForPhoneDigits(undefined); // Force a re-render of the `<input/>` with previous `phoneDigits` value.

              return rerender();
            }
          }
        }
      } else {
        // Entering phone number either in "NATIONAL" or in "NATIONAL_PART_OF_INTERNATIONAL" format.
        // Therefore, `+` is not allowed.
        if (phoneDigits && phoneDigits[0] === '+') {
          // Remove the `+`.
          phoneDigits = phoneDigits.slice(1);
        }
      }
    } else if (!defaultCountry) {
      // Force a `+` in the beginning of a `value`
      // when no `country` and `defaultCountry` have been specified.
      if (phoneDigits && phoneDigits[0] !== '+') {
        // Prepend a `+`.
        phoneDigits = '+' + phoneDigits;
      }
    } // Convert `phoneDigits` to `value`.


    if (phoneDigits) {
      value = getValueForPhoneDigits(phoneDigits);
    }

    setPhoneDigits(phoneDigits);
    setValueForPhoneDigits(value);
  }, [country, inputFormat, defaultCountry, metadata, setPhoneDigits, setValueForPhoneDigits, rerender, countryMismatchDetected]);
  return {
    phoneDigits: phoneDigits,
    setPhoneDigits: onSetPhoneDigits,
    inputFormat: inputFormat
  };
}
/**
 * Returns phone number input field value for a E.164 phone number `value`.
 * @param  {string} [value]
 * @param  {string} [country]
 * @param  {string} [inputFormat]
 * @param  {string} [defaultCountry]
 * @param  {boolean} [useNationalFormatForDefaultCountryValue]
 * @param  {object} metadata
 * @return {string}
 */


function getPhoneDigitsForValue(value, country, defaultCountry, inputFormat, useNationalFormatForDefaultCountryValue, metadata, onCountryMismatch) {
  if (country && inputFormat === 'INTERNATIONAL') {
    var prefix = getInternationalPhoneNumberPrefix(country, metadata);

    if (value) {
      if (value.indexOf(prefix) !== 0) {
        onCountryMismatch(value, country);
      }

      return value;
    }

    return prefix;
  }

  if (!value) {
    return '';
  }

  if (!country && !defaultCountry) {
    return value;
  }

  var asYouType = new AsYouType(undefined, metadata);
  asYouType.input(value);
  var phoneNumber = asYouType.getNumber();

  if (phoneNumber) {
    if (country) {
      // Check for `country` property mismatch for the actual `value`.
      if (phoneNumber.country && phoneNumber.country !== country) {
        onCountryMismatch(value, country, phoneNumber.country);
      } else if (phoneNumber.countryCallingCode !== getCountryCallingCode$1(country, metadata)) {
        onCountryMismatch(value, country);
      }

      switch (inputFormat) {
        case 'NATIONAL':
          return parseDigits(phoneNumber.formatNational());

        case 'NATIONAL_PART_OF_INTERNATIONAL':
          return parseDigits(removePrefixFromFormattedPhoneNumber(phoneNumber.formatInternational(), getInternationalPhoneNumberPrefix(country, metadata)));

        case 'INTERNATIONAL':
          throw new Error('`inputFormat: "INTERNATIONAL"` case should\'ve already been handled earlier in the code');

        case 'INTERNATIONAL_OR_NATIONAL':
          throw new Error('`inputFormat: "INTERNATIONAL_OR_NATIONAL"` is not possible when `country` is fixed');

        default:
          throw new Error("Unknown `inputFormat`: ".concat(inputFormat));
      }
    } else {
      // `phoneNumber.countryCallingCode` is compared here  instead of
      // `phoneNumber.country`, because, for example, a person could have
      // previously input a phone number (in "national" format) that isn't
      // 100% valid for the `defaultCountry`, and if `phoneNumber.country`
      // was compared, then it wouldn't match, and such phone number
      // wouldn't be formatted as a "national" one, and instead would be
      // formatted as an "international" one, confusing the user.
      // Comparing `phoneNumber.countryCallingCode` works around such issues.
      //
      // Example: `defaultCountry="US"` and the `<input/>` is empty.
      // The user inputs: "222 333 4444", which gets formatted to "(222) 333-4444".
      // The user then clicks "Save", the page is refreshed, and the user sees
      // that the `<input/>` value is now "+1 222 333 4444" which confuses the user:
      // the user expected the `<input/>` value to be "(222) 333-4444", same as it
      // was when they've just typed it in. The cause of the issue is that "222 333 4444"
      // is not a valid national number for US, and `phoneNumber.country` is compared
      // instead of `phoneNumber.countryCallingCode`. After the `phoneNumber.country`
      // comparison is replaced with `phoneNumber.countryCallingCode` one, the issue
      // is no longer the case.
      //
      if (phoneNumber.countryCallingCode && phoneNumber.countryCallingCode === getCountryCallingCode$1(defaultCountry, metadata) && useNationalFormatForDefaultCountryValue) {
        return parseDigits(phoneNumber.formatNational());
      }

      return value;
    }
  } else {
    return '';
  }
}

function getInputFormat(_ref2) {
  var international = _ref2.international,
      country = _ref2.country,
      defaultCountry = _ref2.defaultCountry,
      withCountryCallingCode = _ref2.withCountryCallingCode;
  return country ? international ? withCountryCallingCode ? 'INTERNATIONAL' : 'NATIONAL_PART_OF_INTERNATIONAL' : 'NATIONAL' : defaultCountry ? 'INTERNATIONAL_OR_NATIONAL' : 'INTERNATIONAL';
}

var _excluded$f = ["Component", "country", "defaultCountry", "useNationalFormatForDefaultCountryValue", "value", "onChange", "metadata", "international", "withCountryCallingCode"];

function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$1.apply(this, arguments);
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$1(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function PhoneInput(_ref, ref) {
  var Component = _ref.Component,
      country = _ref.country,
      defaultCountry = _ref.defaultCountry,
      _ref$useNationalForma = _ref.useNationalFormatForDefaultCountryValue,
      useNationalFormatForDefaultCountryValue = _ref$useNationalForma === void 0 ? true : _ref$useNationalForma,
      value = _ref.value,
      onChange = _ref.onChange,
      metadata = _ref.metadata,
      international = _ref.international,
      withCountryCallingCode = _ref.withCountryCallingCode,
      rest = _objectWithoutProperties$1(_ref, _excluded$f); // "Phone digits" includes not only "digits" but also a `+` sign.


  var _usePhoneDigits = usePhoneDigits({
    value: value,
    onChange: onChange,
    country: country,
    defaultCountry: defaultCountry,
    international: international,
    withCountryCallingCode: withCountryCallingCode,
    useNationalFormatForDefaultCountryValue: useNationalFormatForDefaultCountryValue,
    metadata: metadata
  }),
      phoneDigits = _usePhoneDigits.phoneDigits,
      setPhoneDigits = _usePhoneDigits.setPhoneDigits,
      inputFormat = _usePhoneDigits.inputFormat; // * Passing `international` property is deprecated.
  // * Passing `withCountryCallingCode` property is deprecated.
  // * Passing `country` property: it should've been called `defaultCountry` instead
  //   because it only applies when the user inputs a phone number in a national format
  //   and is completely ignored when the user inputs a phone number in an international format.


  return /*#__PURE__*/React__default.createElement(Component, _extends$1({}, rest, {
    ref: ref,
    metadata: metadata,
    inputFormat: inputFormat,
    international: international,
    withCountryCallingCode: withCountryCallingCode,
    country: country || defaultCountry,
    value: phoneDigits,
    onChange: setPhoneDigits
  }));
}

PhoneInput = /*#__PURE__*/React__default.forwardRef(PhoneInput);
PhoneInput.propTypes = {
  /**
   * The phone number (in E.164 format).
   * Examples: `"+12"`, `"+12133734253"`.
   * An "empty" `value` could be represented by any "falsy" value like `undefined`, `null` or an empty string `""`.
   */
  value: PropTypes.string,

  /**
   * A function of `value: string?`.
   * Updates the `value` property (to `undefined` in case it's empty).
   */
  onChange: PropTypes.func.isRequired,

  /**
   * A two-letter country code for formatting `value`
   * as a national phone number (example: `(213) 373-4253`),
   * or as an international phone number without "country calling code"
   * if `international` property is passed (example: `213 373 4253`).
   * Example: "US".
   * If no `country` is passed then `value`
   * is formatted as an international phone number.
   * (example: `+1 213 373 4253`)
   */
  country: PropTypes.string,

  /**
   * A two-letter country code for formatting `value`
   * when a user inputs a national phone number (example: `(213) 373-4253`).
   * The user can still input a phone number in international format.
   * Example: "US".
   * `country` and `defaultCountry` properties are mutually exclusive.
   */
  defaultCountry: PropTypes.string,

  /**
   * If `country` property is passed along with `international={true}` property
   * then the phone number will be input in "international" format for that `country`
   * (without "country calling code").
   * For example, if `country="US"` property is passed to "without country select" input
   * then the phone number will be input in the "national" format for `US` (`(213) 373-4253`).
   * But if both `country="US"` and `international={true}` properties are passed then
   * the phone number will be input in the "international" format for `US` (`213 373 4253`)
   * (without "country calling code" `+1`).
   */
  international: PropTypes.bool,

  /**
   * If `country` and `international` properties are set,
   * then by default it won't include "country calling code" in the input field.
   * To change that, pass `withCountryCallingCode` property,
   * and it will include "country calling code" in the input field.
   */
  withCountryCallingCode: PropTypes.bool,

  /**
   * A component that renders the `<input/>` itself and also
   * parses and formats its `value` as the user inputs it.
   * See `InputBasic.js` and `InputSmart.js` for an example.
   */
  Component: PropTypes.elementType.isRequired,

  /**
   * When `defaultCountry` is defined and the initial `value` corresponds to `defaultCountry`,
   * then the `value` will be formatted as a national phone number by default.
   * To format the initial `value` of `defaultCountry` as an international number instead
   * set `useNationalFormatForDefaultCountryValue` property to `true`.
   */
  useNationalFormatForDefaultCountryValue: PropTypes.bool,

  /**
   * `libphonenumber-js` metadata.
   */
  metadata: metadata
};
var PhoneInput_ = PhoneInput;
var _excluded$e = ["type", "autoComplete", "smartCaret", "metadata"];

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function createInput(defaultMetadata) {
  function PhoneInput(_ref, ref) {
    var _ref$type = _ref.type,
        type = _ref$type === void 0 ? 'tel' : _ref$type,
        _ref$autoComplete = _ref.autoComplete,
        autoComplete = _ref$autoComplete === void 0 ? 'tel' : _ref$autoComplete,
        _ref$smartCaret = _ref.smartCaret,
        smartCaret = _ref$smartCaret === void 0 ? true : _ref$smartCaret,
        _ref$metadata = _ref.metadata,
        metadata = _ref$metadata === void 0 ? defaultMetadata : _ref$metadata,
        rest = _objectWithoutProperties(_ref, _excluded$e);

    return /*#__PURE__*/React__default.createElement(PhoneInput_, _extends({}, rest, {
      type: type,
      autoComplete: autoComplete,
      metadata: metadata,
      ref: ref,
      Component: smartCaret ? InputSmart : InputBasic
    }));
  }

  PhoneInput = /*#__PURE__*/React__default.forwardRef(PhoneInput);
  PhoneInput.propTypes = {
    /**
     * HTML `<input/>` `type` attribute.
     */
    type: PropTypes.string,

    /**
     * HTML `<input/>` `autocomplete` attribute.
     */
    autoComplete: PropTypes.string,

    /**
     * By default, the caret position is being "intelligently" managed
     * while a user inputs a phone number.
     * This "smart" caret behavior can be turned off
     * by passing `smartCaret={false}` property.
     * This is just an "escape hatch" for any possible caret position issues.
     */
    // Is `true` by default.
    smartCaret: PropTypes.bool,

    /**
     * `libphonenumber-js` metadata.
     */
    metadata: PropTypes.object
  };
  return PhoneInput;
}

createInput();

function call(func, _arguments) {
  var args = Array.prototype.slice.call(_arguments);
  args.push(metadata$1);
  return func.apply(this, args);
}

createInput(metadata$1);

function getCountryCallingCode() {
  return call(getCountryCallingCode$1, arguments);
} // Backend and Front end countries may be different.


var checkCountry = function checkCountry(country) {
  if (country === 'Turks and Caicos Islands') {
    return 'Turks & Caicos Islands';
  }

  return country;
};

var splitStreetAddress = function splitStreetAddress(streetAddress, origNum, origName, origType) {
  try {
    if (typeof streetAddress === 'string') {
      var trimmedAddress = streetAddress.trim();
      var addrArr = trimmedAddress.split(' ');

      if (addrArr.length >= 3) {
        var num = addrArr.shift();
        var type = addrArr.pop();
        var name = addrArr.join(' ');
        return {
          number: num || '',
          name: name || '',
          type: type || ''
        };
      }
    }
  } catch (error) {
    tracker$1('Client Error', {
      type: 'error',
      location: 'splitStreetAddress',
      info: {
        streetAddress: streetAddress,
        origNum: origNum,
        origName: origName,
        origType: origType
      },
      error: error
    });
  }

  if (origNum || origName || origType) {
    return {
      number: origNum,
      name: origName,
      type: origType
    };
  }

  if (streetAddress) {
    // did not return = funky address
    tracker$1('Client Error', {
      type: 'warning',
      location: 'splitStreetAddress',
      info: {
        reason: 'Irregular Street Address Format',
        streetAddress: streetAddress,
        origNum: origNum,
        origName: origName,
        origType: origType
      }
    });
  }

  return {
    number: ' ',
    name: streetAddress,
    type: ' '
  };
};

var createContactPayload = function createContactPayload(data) {
  var isNewUserContact = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _data$apartment = data.apartment,
      apartment = _data$apartment === void 0 ? '' : _data$apartment,
      email = data.email,
      firstName = data.firstName,
      lastName = data.lastName,
      phone = data.phone,
      streetAddress = data.streetAddress;
  data.streetName;
  data.streetNumber;
  data.streetType;
  var formattedAddress = data.formattedAddress,
      city = data.city,
      province = data.province,
      country = data.country,
      postalCode = data.postalCode,
      _data$extraInfo = data.extraInfo,
      extraInfo = _data$extraInfo === void 0 ? {} : _data$extraInfo,
      _data$countryCode = data.countryCode,
      countryCode = _data$countryCode === void 0 ? 'ca' : _data$countryCode,
      _data$company = data.company,
      company = _data$company === void 0 ? '' : _data$company;
  var correctCountry = checkCountry(country);
  var formattedCountry = startCase(correctCountry.toLowerCase());
  var splitAddress = splitStreetAddress(streetAddress, data.streetNumber, data.streetName, data.streetType);

  if (!isNewUserContact) {
    return {
      email: email,
      firstName: firstName,
      lastName: lastName,
      address: {
        apartment: apartment,
        streetAddress: "".concat(streetAddress),
        streetNumber: splitAddress.number,
        streetName: splitAddress.name.trim(),
        streetType: splitAddress.type,
        formattedAddress: formattedAddress,
        countryCode: countryCode.toUpperCase(),
        province: province,
        postalCode: postalCode,
        country: formattedCountry,
        city: city
      },
      phone: phone,
      company: company,
      extraInfo: extraInfo,
      consent: false
    };
  }

  return {
    primary: {
      firstName: firstName,
      lastName: lastName,
      streetAddress: "".concat(streetAddress),
      streetNumber: splitAddress.number,
      streetName: splitAddress.name.trim(),
      streetType: splitAddress.type,
      city: city,
      province: province,
      postalCode: postalCode,
      country: country,
      phone: phone
    },
    sameBillingAddress: true,
    company: company
  };
};

var getCallingCode = function getCallingCode(country) {
  if (country) {
    var countryCode = findKey$1(en, function (c) {
      return c === country;
    });

    if (countryCode) {
      var callingCode = getCountryCallingCode(countryCode);
      return callingCode;
    }
  }

  return 1; // default to +1
};

var parseContact = function parseContact(data) {
  // TODO: extract extraInfo
  var email = data.email,
      address = data.address,
      lastName = data.lastName,
      firstName = data.firstName,
      company = data.company,
      phone = data.phone,
      id = data.id,
      _data$isDefault = data.isDefault,
      isDefault = _data$isDefault === void 0 ? false : _data$isDefault,
      extraInfo = data.extraInfo;

  var _ref = address || {},
      apartment = _ref.apartment,
      city = _ref.city,
      country = _ref.countryName,
      countryCode = _ref.countryCode,
      postalCode = _ref.postalCode,
      province = _ref.province,
      streetName = _ref.streetName,
      streetNumber = _ref.streetNumber,
      streetType = _ref.streetType;

  return {
    email: email,
    apartment: apartment,
    city: city,
    id: id,
    country: country,
    countryCode: countryCode,
    extraInfo: extraInfo,
    firstName: firstName,
    lastName: lastName,
    company: company,
    phone: phone,
    postalCode: postalCode,
    province: province,
    streetName: streetName,
    streetNumber: streetNumber,
    streetType: streetType,
    isDefault: isDefault
  };
};

function _regenerator$L() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$L(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$L(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$L(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$L(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$L(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$L(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$L(u), _regeneratorDefine2$L(u, o, "Generator"), _regeneratorDefine2$L(u, n, function () {
    return this;
  }), _regeneratorDefine2$L(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$L = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$L(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$L = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$L(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$L(e, r, n, t);
}

var contactStates = {
  contact: 'contact'
};
var events$6 = {
  ADD_CONTACT: 'add-contact',
  UPDATE_CONTACT: 'update-contact',
  GET_CONTACTS: 'get-contacts',
  SELECT_CONTACT: 'select-contact',
  TOGGLE_ADD_NEW: 'toggle-add-new',
  SET_SUCCESSFUL: 'set-successful'
};

var fetchContactAsync = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$L().m(function _callee() {
    var _yield$get, data, result, _yield$get2, defaultContact, allContacts, def;

    return _regenerator$L().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            _context.n = 1;
            return get$3(contactEndpoints.contact);

          case 1:
            _yield$get = _context.v;
            data = _yield$get.data;
            result = data.result;
            _context.n = 2;
            return get$3(userEndpoints.defaultContact);

          case 2:
            _yield$get2 = _context.v;
            defaultContact = _yield$get2.data;
            allContacts = result.map(function (c) {
              var parsed = parseContact(c);

              if (c.id === defaultContact.id) {
                parsed.isDefault = true;
              }

              return parsed;
            });
            def = allContacts.find(function (c) {
              return c.isDefault;
            });
            return _context.a(2, {
              defaultContact: def,
              contacts: allContacts
            });
        }
      }
    }, _callee);
  }));

  return function fetchContactAsync() {
    return _ref.apply(this, arguments);
  };
}();

var contactOptions = {
  services: {
    fetchContacts: function fetchContacts() {
      return fetchContactAsync();
    },
    updateContact: function updateContact(_, evt) {
      var contact = evt.payload;
      return post$1("".concat(contactEndpoints.contact, "/").concat(contact.id), contact);
    },
    addContact: function addContact(_, evt) {
      if (evt.isNewUser) {
        return post$1(contactEndpoints.primaryContact, evt.payload);
      }

      return post$1(contactEndpoints.contact, evt.payload);
    }
  },
  actions: {
    setSuccessfulStatus: assign$2(function (_, evt) {
      return {
        success: evt.payload
      };
    }),
    toggleAddNew: assign$2(function (_, evt) {
      return {
        addNew: evt.payload
      };
    }),
    handleAddInfoRequired: assign$2(function (_, evt) {
      return {
        addInfoRequired: evt.data.addInfoRequired
      };
    }),
    handleContacts: assign$2(function (_, evt) {
      return {
        contacts: evt.data.contacts
      };
    }),
    handleDefaultContact: assign$2(function (_, evt) {
      return {
        defaultContact: evt.data.defaultContact
      };
    }),
    handleSelectedContact: assign$2(function (_, evt) {
      var info = evt.data ? evt.data.defaultContact : evt.payload;
      return {
        selectedContact: info
      };
    })
  }
};
var sharedOptions = {
  actions: {
    onSuccess: function onSuccess() {// Placeholder - overridden when used by component
    },
    handleError: assign$2({
      error: function error(_, evt) {
        var error;

        var data = _get(evt, 'data.response.data'); // Error is from level from backend


        if (data && Array.isArray(data)) {
          error = data;
        }

        if (!error) {
          error = _get(evt, 'data.response.data.errorMessage');
        }

        var message = _get(evt, 'data.message');

        if (!error && typeof message === 'string') {
          error = message;
        }

        if (!error) {
          error = _get(evt, 'data.response.data', 'Network Error');
        } // Anything using auth.machine is expecting a property `errorMessage`


        return typeof error === 'string' ? {
          errorMessage: error,
          status: _get(evt, 'data.response.status', 500)
        } : error;
      }
    }),
    removeError: assign$2({
      error: null
    })
  }
};
var ContactMachine = createMachine({
  id: 'contact',
  initial: contactStates.contact,
  context: {
    addNew: false,
    defaultContact: null,
    selectedContact: null,
    contacts: null,
    loading: false,
    error: null,
    success: false
  },
  states: _defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6({}, contactStates.contact, {
    onEntry: [
      /* ctx => logger(`XState.${contactStates.contact} - idle`, ctx) */
    ],
    on: _defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6({}, events$6.SET_SUCCESSFUL, {
      actions: 'setSuccessfulStatus'
    }), events$6.TOGGLE_ADD_NEW, {
      actions: 'toggleAddNew'
    }), events$6.GET_CONTACTS, 'getContacts'), events$6.SELECT_CONTACT, {
      actions: 'handleSelectedContact'
    }), events$6.ADD_CONTACT, 'createContact'), events$6.UPDATE_CONTACT, 'updateContact')
  }), "getContacts", {
    onEntry: [assign$2({
      loading: true
    }) // ctx => logger(`XState.${contactStates.contact} - getContacts`, ctx),
    ],
    invoke: {
      id: 'fetch-contacts',
      src: 'fetchContacts',
      onDone: {
        target: contactStates.contact,
        actions: ['handleDefaultContact', 'handleSelectedContact', 'handleContacts', assign$2({
          loading: false
        })]
      },
      onError: {
        actions: [assign$2({
          loading: false
        }), 'handleError']
      }
    }
  }), "createContact", {
    onEntry: [assign$2({
      loading: true
    }), 'removeError' // ctx => logger(`XState.${contactStates.contact} - createContact`, ctx),
    ],
    invoke: {
      id: 'add-contact',
      onDone: {
        target: 'success',
        actions: 'onSuccess'
      },
      src: 'addContact',
      onError: {
        actions: [assign$2({
          loading: false
        }), 'handleError']
      }
    }
  }), "updateContact", {
    onEntry: [assign$2({
      loading: true
    }), 'removeError' // ctx => logger(`XState.${contactStates.contact} - updateContact`, ctx),
    ],
    invoke: {
      id: 'update-existing-contact',
      src: 'updateContact',
      onDone: {
        target: 'success',
        actions: 'onSuccess'
      },
      onError: {
        actions: [assign$2({
          loading: false
        }), 'handleError']
      }
    }
  }), "success", {
    after: {
      500: {
        target: contactStates.contact
      }
    }
  })
}, contactOptions).withConfig(sharedOptions);

function ownKeys$M(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$M(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$M(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$M(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var ContactContext = /*#__PURE__*/React__default.createContext();

function ContactProvider(props) {
  var _useMachine = useMachine(ContactMachine),
      _useMachine2 = _slicedToArray$4(_useMachine, 2),
      contact = _useMachine2[0],
      send = _useMachine2[1];

  var toggleAddNew = useCallback(function (payload) {
    return send({
      type: events$6.TOGGLE_ADD_NEW,
      payload: payload
    });
  }, [send]);
  var createContact = useCallback(function (payload) {
    var isNewUser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return send({
      type: events$6.ADD_CONTACT,
      payload: payload,
      isNewUser: isNewUser
    });
  }, [send]);
  var updateContact = useCallback(function (payload) {
    return send({
      type: events$6.UPDATE_CONTACT,
      payload: payload
    });
  }, [send]);
  var fetchContacts = useCallback(function () {
    send({
      type: events$6.GET_CONTACTS
    });
  }, [send]);
  var selectContact = useCallback(function (payload) {
    return send({
      type: events$6.SELECT_CONTACT,
      payload: payload
    });
  }, [send]);
  var setContactSuccessful = useCallback(function (payload) {
    return send({
      type: events$6.SET_SUCCESSFUL,
      payload: payload
    });
  }, [send]);
  var value = React__default.useMemo(function () {
    return {
      send: send,
      contact: contact.context,
      createContact: createContact,
      updateContact: updateContact,
      fetchContacts: fetchContacts,
      selectContact: selectContact,
      toggleAddNew: toggleAddNew,
      setContactSuccessful: setContactSuccessful
    };
  }, [send, contact, createContact, updateContact, fetchContacts, selectContact, toggleAddNew, setContactSuccessful]);
  return /*#__PURE__*/jsx$1(ContactContext.Provider, _objectSpread$M({
    value: value
  }, props));
}

function useContactService() {
  var context = React__default.useContext(ContactContext);

  if (!context) {
    throw new Error("useContactProvider must be used within a ContactProvider");
  }

  return context;
}

var _templateObject$o, _templateObject2$f, _templateObject3$9;
/* import { gutter, media } from 'utilities/styles' */


var color = {
  white: '#fff',
  whiteDark: '#f7f7f7',
  greyLightest: '#e7e7e7',
  greyLight: '#d7d7d7',
  grey: '#B2B2B2',
  greyDark: '#999999',
  greyDarker: '#666',
  blackLighter: '#333',
  blackLight: '#222328',
  black: '#000',
  greenLightest: '#f3f5e6',
  greenLighter: '#D3DCA3',
  greenLight: '#A5C20F',
  green: '#859F00',
  greenDark: '#6B8000',
  redLighter: '#F9BEAE',
  redLight: '#E37054',
  red: '#F04A22',
  redDark: '#CC3E1C',
  redNew: '#d82a29',
  blueLightest: '#C1D5F7',
  blue: '#1B50B8',
  orange: '#ff9600',
  orangeLight: '#fee7c5',
  clear: 'transparent',
  focus: '#406198',
  overlay: 'rgba(0,0,0,.6)',
  success: '#859f00',
  successLight: '#e4eeaa',
  warning: '#d49e03',
  warningLight: '#f7eac9',
  error: '#f04822',
  errorLight: '#ffd1c7',
  facebook: '#3b5998'
};
var gutter = {
  eigth: '0.2rem',
  quarter: '0.4rem',
  half: '0.8rem',
  "default": '1.6rem',
  big: '2.4rem',
  bigger: '4rem',
  biggest: '8rem'
};
var screen = {
  small: '600px',
  smallUp: '601px',
  smallish: '768px',
  medium: '992px',
  mediumUp: '993px',
  large: '1200px',
  largeUp: '1201px'
};
var media$2 = {
  smallLaptop: function smallLaptop() {
    return css$3(["@media only screen and (max-width:700px) and (max-height:400px) and (orientation:portrait){", ";}"], css$3.apply(void 0, arguments));
  },
  smallAndDown: function smallAndDown() {
    return css$3(["@media only screen and (max-width:", "){", ";}"], screen.small, css$3.apply(void 0, arguments));
  },
  mediumOnly: function mediumOnly() {
    return css$3(["@media only screen and (min-width:", ") and (max-width:", "){", ";}"], screen.smallUp, screen.medium, css$3.apply(void 0, arguments));
  },
  smallishAndDown: function smallishAndDown() {
    return css$3(["@media only screen and (max-width:", "){", ""], screen.smallish, css$3.apply(void 0, arguments));
  },
  mediumAndDown: function mediumAndDown() {
    return css$3(["@media only screen and (max-width:", "){", ";}"], screen.medium, css$3.apply(void 0, arguments));
  },
  mediumAndUp: function mediumAndUp() {
    return css$3(["@media only screen and (min-width:", "){", ";}"], screen.smallUp, css$3.apply(void 0, arguments));
  },
  largeAndDown: function largeAndDown() {
    return css$3(["@media only screen and (max-width:", "){", ";}"], screen.large, css$3.apply(void 0, arguments));
  },
  largeAndUp: function largeAndUp() {
    return css$3(["@media only screen and (min-width:", "){", ";}"], screen.mediumUp, css$3.apply(void 0, arguments));
  },
  veryLarge: function veryLarge() {
    return css$3(["@media only screen and (min-width:", "){", ";}"], screen.largeUp, css$3.apply(void 0, arguments));
  },
  rotated: function rotated() {
    return css$3(["@media only screen and (orientation:landscape){", ";}"], css$3.apply(void 0, arguments));
  },
  touch: function touch() {
    return css$3(["@media (hover:none){", ";}"], css$3.apply(void 0, arguments));
  }
};

var withErrorHighlight = function withErrorHighlight(_ref) {
  var hasError = _ref.hasError;

  if (!hasError) {
    return '';
  }

  return {
    'background-color': color.errorLight,
    color: color.error
  };
};

var Row = styled.div.withConfig({
  displayName: "TLDInfostyles__Row",
  componentId: "sc-anxmi2-0"
})(["display:flex;justify-content:space-between;align-items:flex-start;", " & > *{flex:1;width:100%;}& > *:not(:last-child){margin-right:", ";", "}"], media$2.mediumAndDown(_templateObject$o || (_templateObject$o = _taggedTemplateLiteral$1(["\n    flex-flow: column;\n  "]))), gutter.half, media$2.mediumAndDown(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteral$1(["\n      margin-right: 0;\n      margin-bottom: 1.6rem;\n    "]))));
styled.div.withConfig({
  displayName: "TLDInfostyles__FormContentWrapper",
  componentId: "sc-anxmi2-1"
})(["margin-bottom:", ";"], gutter.big);
styled(Row).withConfig({
  displayName: "TLDInfostyles__RowPhone",
  componentId: "sc-anxmi2-2"
})(["", ""], media$2.mediumAndDown(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteral$1(["\n    flex-flow: wrap;\n\n    & > div:first-child {\n      padding-right: 2rem;\n      flex-grow: 2;\n    }\n  "]))));
styled.div.withConfig({
  displayName: "TLDInfostyles__ButtonStack",
  componentId: "sc-anxmi2-3"
})(["display:flex;margin-top:1.5rem;flex-direction:column;align-items:center;& > *:not(:last-child){margin-bottom:", ";}"], gutter["default"]);
styled.div.withConfig({
  displayName: "TLDInfostyles__MessageWrapper",
  componentId: "sc-anxmi2-4"
})(["margin:", " 0;"], gutter["default"]);
var TLDInfoWrapper = styled(Stack$2).withConfig({
  displayName: "TLDInfostyles__TLDInfoWrapper",
  componentId: "sc-anxmi2-5"
})(["width:100%;"]);
var TLDInfoFieldWrapper = styled.div.withConfig({
  displayName: "TLDInfostyles__TLDInfoFieldWrapper",
  componentId: "sc-anxmi2-6"
})(["margin:", " 0;margin-bottom:", ";"], gutter["default"], function (props) {
  return props.noBottomMargin ? '0' : '1rem';
});
styled.h3.withConfig({
  displayName: "TLDInfostyles__TLDInfoHeader",
  componentId: "sc-anxmi2-7"
})([""]);
var TLDInfoNote = styled.div.withConfig({
  displayName: "TLDInfostyles__TLDInfoNote",
  componentId: "sc-anxmi2-8"
})(["font-size:1.4rem;padding:1rem 0;font-weight:400;", ""], withErrorHighlight);
styled.span.withConfig({
  displayName: "TLDInfostyles__LinkWrap",
  componentId: "sc-anxmi2-9"
})(["padding-left:0.25rem;text-transform:uppercase;"]);
var TLD_KEYS = {
  ca: 'ca',
  us: 'us',
  au: 'au',
  asia: 'asia',
  xxx: 'xxx',
  law: 'law'
};
var TLDExtraNameMap = {
  ca: 'CiraExtraInfo',
  asia: 'CEDExtraInfo',
  law: 'LAWExtraInfo',
  us: 'NexusExtraInfo',
  xxx: 'MembershipExtraInfo',
  au: 'AUExtraInfo'
};
var ALLOW_PRIVACY = ['CCT', 'RES', 'ABO', 'LGR'];

var tldDefaults = _defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6({}, TLD_KEYS.ca, {
  CPRCategory: 'CCT',
  Language: 'EN',
  AgreementVersion: '2.0',
  AgreementValue: true,
  WhoisDisplaySetting: false,
  CAContactStatus: 'New',
  valid: false
}), TLD_KEYS.us, {
  Purpose: '',
  Category: '',
  CountryCodeId: '',
  valid: false
}), TLD_KEYS.asia, {
  LegalEntityType: '',
  FormType: '',
  IdNumber: '',
  valid: false
}), TLD_KEYS.xxx, {
  MembershipId: '',
  valid: true
}), TLD_KEYS.law, {
  AccreditationId: '',
  AccreditationYear: 2017,
  AccreditationCountryId: 38,
  JurisdictionSP: '',
  AccreditationBody: '',
  valid: false
}), TLD_KEYS.au, {
  AcceptanceAgreement: false,
  RegistrantName: '',
  RegistrantID: '',
  RegistrantIDType: '',
  EligibilityName: '',
  EligibilityID: '',
  EligibilityIDType: '',
  AuEligibilityType: '',
  AuToken: '',
  AuTokenMembership: ''
});

var validation = _defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6({}, TLD_KEYS.ca, function (extraInfo) {
  return extraInfo.AgreementValue;
}), TLD_KEYS.asia, function (extraInfo, options) {
  var FormType = options.FormType,
      LegalEntityType = options.LegalEntityType;
  var lastFormType = FormType[FormType.length - 1];
  var lastLegalType = LegalEntityType[LegalEntityType.length - 1];
  var errors = 0;

  if (extraInfo.IdNumber.length < 1) {
    errors += 1;
  }

  if (extraInfo.FormType === lastFormType.Value && extraInfo.FormTypeOther.length < 1) {
    errors += 1;
  }

  if (extraInfo.LegalEntityType === lastLegalType.Value && extraInfo.LegalEntityTypeOther.length < 1) {
    errors += 1;
  }

  return errors < 1;
}), TLD_KEYS.us, function (extraInfo, showCountries) {
  var errors = 0;

  if (extraInfo.Purpose === 'None') {
    errors += 1;
  }

  if (extraInfo.Category === 'None') {
    errors += 1;
  }

  if (showCountries && extraInfo.CountryCodeId === 'None') {
    errors += 1;
  }

  return errors < 1;
}), TLD_KEYS.au, function (extraInfo) {
  var errors = 0;

  switch (extraInfo.AuEligibilityType) {
    case 'Company':
      if (extraInfo.CompanyName.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuEligibilityIDType.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuEligibilityID.length < 1) {
        errors += 1;
      }

      if (extraInfo.AcceptanceAgreement !== true) {
        errors += 1;
      }

      break;

    case 'Registered Business':
      if (extraInfo.BusinessOwner.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuRegistrantIdType.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuRegistrantId.length < 1) {
        errors += 1;
      }

      if (extraInfo.BusinessName.length < 1) {
        errors += 1;
      }

      if (extraInfo.BusinessIDType.length < 1) {
        errors += 1;
      }

      if (extraInfo.BusinessID.length < 1) {
        errors += 1;
      }

      if (extraInfo.AcceptanceAgreement !== true) {
        errors += 1;
      }

      break;

    case 'Sole Trader':
      if (extraInfo.SoleTraderName.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuRegistrantIdType.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuRegistrantId.length < 1) {
        errors += 1;
      }

      if (extraInfo.AcceptanceAgreement !== true) {
        errors += 1;
      }

      break;

    case 'Partnership':
      if (extraInfo.PartnerName.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuEligibilityIDType.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuEligibilityID.length < 1) {
        errors += 1;
      }

      if (extraInfo.PartnershipName.length < 1) {
        errors += 1;
      }

      if (extraInfo.AcceptanceAgreement !== true) {
        errors += 1;
      }

      break;

    case 'Trademark Owner':
      if (extraInfo.TrademarkOwner.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuEligibilityIDType.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuEligibilityID.length < 1) {
        errors += 1;
      }

      if (extraInfo.TrademarkName.length < 1) {
        errors += 1;
      }

      if (extraInfo.TrademarkNumberType.length < 1) {
        errors += 1;
      }

      if (extraInfo.TrademarkNumber.length < 1) {
        errors += 1;
      }

      if (extraInfo.AcceptanceAgreement !== true) {
        errors += 1;
      }

      break;

    case 'Pending Trademark Owner':
      if (extraInfo.TrademarkOwner.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuEligibilityIDType.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuEligibilityID.length < 1) {
        errors += 1;
      }

      if (extraInfo.PendingTrademarkName.length < 1) {
        errors += 1;
      }

      if (extraInfo.AcceptanceAgreement !== true) {
        errors += 1;
      }

      break;

    case 'Citizen/Resident':
      if (extraInfo.Name.length < 1) {
        errors += 1;
      }

      break;

    case 'Incorporated Association':
      if (extraInfo.AssociationName.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuEligibilityIDType.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuEligibilityID.length < 1) {
        errors += 1;
      }

      if (extraInfo.AcceptanceAgreement !== true) {
        errors += 1;
      }

      break;

    case 'Club':
      if (extraInfo.Name.length < 1) {
        errors += 1;
      }

      if (extraInfo.ClubName.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuEligibilityIDType.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuEligibilityID.length < 1) {
        errors += 1;
      }

      if (extraInfo.AcceptanceAgreement !== true) {
        errors += 1;
      }

      break;

    case 'Non-profit Organization':
      if (extraInfo.OrganizationName.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuEligibilityIDType.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuEligibilityID.length < 1) {
        errors += 1;
      }

      if (extraInfo.AcceptanceAgreement !== true) {
        errors += 1;
      }

      break;

    case 'Charity':
      if (extraInfo.CharityName.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuEligibilityIDType.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuEligibilityID.length < 1) {
        errors += 1;
      }

      if (extraInfo.AcceptanceAgreement !== true) {
        errors += 1;
      }

      break;

    case 'Trade Union':
      if (extraInfo.OrganizationName.length < 1) {
        errors += 1;
      }

      if (extraInfo.OrganizationNumber.length < 1) {
        errors += 1;
      }

      if (extraInfo.AcceptanceAgreement !== true) {
        errors += 1;
      }

      break;

    case 'Industry Body':
      if (extraInfo.Name.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuRegistrantIdType.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuRegistrantId.length < 1) {
        errors += 1;
      }

      if (extraInfo.AcceptanceAgreement !== true) {
        errors += 1;
      }

      break;

    case 'Commercial Statutory Body':
      if (extraInfo.StatutoryBody.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuRegistrantIdType.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuRegistrantId.length < 1) {
        errors += 1;
      }

      if (extraInfo.AcceptanceAgreement !== true) {
        errors += 1;
      }

      break;

    case 'Political Party':
      if (extraInfo.PartyName.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuRegistrantIdType.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuRegistrantId.length < 1) {
        errors += 1;
      }

      if (extraInfo.AcceptanceAgreement !== true) {
        errors += 1;
      }

      break;

    case 'Other':
      if (extraInfo.Name.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuRegistrantIdType.length < 1) {
        errors += 1;
      }

      if (extraInfo.AuRegistrantId.length < 1) {
        errors += 1;
      }

      if (extraInfo.AcceptanceAgreement !== true) {
        errors += 1;
      }

      break;

    default:
      errors += 1;
      break;
  }

  return errors < 1;
});

mapValues$1(TLD_KEYS, function (key) {
  return {
    defaults: tldDefaults[key],
    validation: validation[key]
  };
});
var LANGUAGE_OPTIONS = [{
  value: 'en',
  label: 'English'
}, {
  value: 'fr',
  label: 'French'
}]; // export const VALID_COMPANY_NAMES = get(window, 'validCompanyNames', [])
// export const VALID_COMPANY_REGEX = new RegExp(
//   VALID_COMPANY_NAMES.join('|'),
//   'i'
// )

function ownKeys$L(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$L(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$L(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$L(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var extraInfoKey$1 = TLDExtraNameMap[TLD_KEYS.au];
var propTypes$O = {
  currentContactInfo: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setValues: PropTypes.func.isRequired,
  tldOptions: PropTypes.shape({
    AuEligibilityIDType: PropTypes.arrayOf(PropTypes.shape({
      DisplayName: PropTypes.string,
      Value: PropTypes.string
    })),
    AuRegistrantIdType: PropTypes.arrayOf(PropTypes.shape({
      DisplayName: PropTypes.string,
      Value: PropTypes.string
    })),
    RegistrationCategories: PropTypes.arrayOf(PropTypes.shape({
      Children: PropTypes.arrayOf(PropTypes.shape({
        DisplayName: PropTypes.string,
        Value: PropTypes.string
      })),
      DisplayName: PropTypes.string,
      Value: PropTypes.string
    }))
  }),
  touched: PropTypes.shape({}).isRequired,
  // validateForm: PropTypes.func.isRequired,
  values: PropTypes.shape({}).isRequired
};
var defaultProps$n = {
  tldOptions: null
};

function TLDInfoAU(_ref) {
  var currentContactInfo = _ref.currentContactInfo,
      errors = _ref.errors,
      handleBlur = _ref.handleBlur,
      handleChange = _ref.handleChange,
      setFieldValue = _ref.setFieldValue,
      tldOptions = _ref.tldOptions,
      touched = _ref.touched,
      values = _ref.values,
      setValues = _ref.setValues;
  /* STATE */

  var _useState = useState([]),
      _useState2 = _slicedToArray$4(_useState, 2),
      requiredExtraInfo = _useState2[0],
      setrequiredExtraInfo = _useState2[1];

  var _useState3 = useState({
    RegistrantNameLabel: '',
    RegistrantIDLabel: '',
    RegistrantIDTypeLabel: '',
    EligibilityNameLabel: '',
    EligibilityIDLabel: '',
    EligibilityIDTypeLabel: '',
    AuEligibilityTypeLabel: ''
  }),
      _useState4 = _slicedToArray$4(_useState3, 2),
      requiredExtraInfoLabels = _useState4[0],
      setrequiredExtraInfoLabels = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray$4(_useState5, 2),
      hasPriorityToken = _useState6[0],
      setHasPriorityToken = _useState6[1];
  /* END STATE */


  var auDefaults = tldDefaults[TLD_KEYS.au];

  var mergeValuesWithDefaults = function mergeValuesWithDefaults() {
    var extraInfo = values.extraInfo;
    keys$1(auDefaults).forEach(function (key) {
      if (!extraInfo || !extraInfo[TLDExtraNameMap[TLD_KEYS.au]] || typeof extraInfo[TLDExtraNameMap[TLD_KEYS.au]][key] === 'undefined') {
        // setting default value
        setFieldValue("extraInfo[".concat(extraInfoKey$1, "][").concat(key, "]"), auDefaults[key]);
      }
    });
  };

  var addDefaultAUInfo = function addDefaultAUInfo() {
    var extraInfo = values.extraInfo;

    if (isEmpty$2(extraInfo)) {
      var extra = _objectSpread$L(_objectSpread$L({}, values), {}, {
        extraInfo: _defineProperty$6({}, extraInfoKey$1, _objectSpread$L({}, auDefaults))
      });

      setValues(extra);
    } else {
      setValues(_objectSpread$L(_objectSpread$L({}, values), {}, {
        extraInfo: _objectSpread$L(_objectSpread$L({}, extraInfo), {}, _defineProperty$6({}, extraInfoKey$1, _objectSpread$L({}, auDefaults)))
      }));
    }
  };

  var hasExtraAUInfo = _$1.get(currentContactInfo.extraInfo, extraInfoKey$1, false);

  useEffect(function () {
    if (hasExtraAUInfo) {
      return;
    }

    if (!hasExtraAUInfo) {
      addDefaultAUInfo();
      return;
    }

    mergeValuesWithDefaults();
  }, [currentContactInfo]);
  var extraInfo = values.extraInfo ? values.extraInfo[extraInfoKey$1] || {} : {};
  var hasToken = values.hasToken; // User's can't update AU extra info - ONLY add

  if (hasExtraAUInfo) {
    return null;
  }

  if (!tldOptions) {
    return null;
  }

  var categoryOptions = tldOptions.RegistrationCategories.map(function (opt) {
    return {
      label: opt.DisplayName,
      value: opt.Value
    };
  });
  var hasPriorityTokenOptions = [{
    label: 'Yes',
    value: true
  }, {
    label: 'No',
    value: false
  }];
  var AuRegistrantIdTypeOptions = tldOptions.AuRegistrantIdType.map(function (opt) {
    return {
      label: opt.DisplayName,
      value: opt.Value
    };
  });
  var AuEligibilityIDTypeOptions = tldOptions.AuEligibilityIDType.map(function (opt) {
    return {
      label: opt.DisplayName,
      value: opt.Value
    };
  });

  var toggleFieldsForCategory = function toggleFieldsForCategory(value) {
    var extraInfoRequired = tldOptions.RegistrationCategories.filter(function (x) {
      return x.Value === value;
    }).map(function (x) {
      return {
        display: x.DisplayName,
        value: x.Value,
        children: x.Children
      };
    });
    var requiredChildren = extraInfoRequired[0].children;
    var labels = {
      RegistrantNameLabel: '',
      RegistrantIDLabel: '',
      RegistrantIDTypeLabel: '',
      EligibilityNameLabel: '',
      EligibilityIDLabel: '',
      EligibilityIDTypeLabel: '',
      AuEligibilityTypeLabel: ''
    };
    requiredChildren.forEach(function (child) {
      switch (child.Value) {
        case 'BusinessName':
        case 'PartnershipName':
        case 'TrademarkName':
        case 'PendingTrademarkName':
        case 'ClubName':
          labels.EligibilityNameLabel = strings$5.au[child.Value];
          break;

        case 'TrademarkNumber':
        case 'BusinessID':
          labels.EligibilityIDLabel = strings$5.au[child.Value];
          break;

        case 'TrademarkIDType':
        case 'BusinessIDType':
          labels.EligibilityIDTypeLabel = strings$5.au[child.Value];
          break;

        case 'CompanyName':
        case 'BusinessOwner':
        case 'SoleTraderName':
        case 'PartnerName':
        case 'TrademarkOwner':
        case 'Name':
        case 'AssociationName':
        case 'OrganizationName':
        case 'CharityName':
        case 'StatutoryBody':
        case 'PartyName':
          labels.RegistrantNameLabel = strings$5.au[child.Value];
          break;

        case 'ID':
        case 'CompanyID':
        case 'OrganizationNumber':
          labels.RegistrantIDLabel = strings$5.au[child.Value];
          break;

        case 'IDType':
        case 'CompanyIDType':
          labels.RegistrantIDTypeLabel = strings$5.au[child.Value];
          break;
      }
    });
    setrequiredExtraInfoLabels(labels);
    setrequiredExtraInfo(requiredChildren);
  };

  var isFieldRequired = function isFieldRequired(field) {
    var isReq = requiredExtraInfo.filter(function (x) {
      return x.Value === field;
    }).length > 0;
    return isReq;
  };

  return /*#__PURE__*/jsxs(Stack$2, {
    children: [/*#__PURE__*/jsx$1(Heading, {
      mt: 3,
      textAlign: "left",
      variant: "gigaBold",
      children: ".AU Information"
    }), /*#__PURE__*/jsxs(Stack$2, {
      ml: 2,
      children: [/*#__PURE__*/jsxs(Text$1, {
        children: ["Important: .au domains have restrictions. Please visit our", ' ', /*#__PURE__*/jsx$1(Link$1, {
          href: Config.contacts.kb.au,
          newTab: true,
          children: "support page"
        }), ' ', "to learn more about the Australian Presence Requirements and which legal type you should choose."]
      }), /*#__PURE__*/jsxs(TLDInfoFieldWrapper, {
        children: [/*#__PURE__*/jsx$1(Text$1, {
          textTransform: "capitalize",
          variant: "milliBold",
          children: "Do you own a corresponding third-level .au domain for this domain (for example, yourdomain.com.au)?"
        }), /*#__PURE__*/jsx$1(Dropdown
        /* emptyOption
        emptyOptionText="No" - placeholder attribute instead? */
        , {
          id: "HasPriorityToken",
          onChange: function onChange(value) {
            handleChange({
              target: {
                name: "hasToken",
                value: value.value
              }
            });
            setHasPriorityToken(value);
          },
          options: hasPriorityTokenOptions,
          padding: "0",
          width: "100%",
          value: hasToken
        })]
      }), hasPriorityToken && hasPriorityToken.value ? /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsxs(Text$1, {
          children: ["To register your reserved second-level .au domain, we may require the priority token and contact id from the registry. These details can be obtained", ' ', /*#__PURE__*/jsx$1(Link$1, {
            href: "https://priority.auda.org.au",
            newTab: true,
            children: "here"
          }), ". If you are not able to retrieve the token you can still leave the priority token fields blank and purchase the domain. We will be in touch to retrieve your token."]
        }), /*#__PURE__*/jsx$1(TLDInfoFieldWrapper, {
          children: /*#__PURE__*/jsx$1(Input$5, {
            id: "AuToken",
            label: "Priority Token",
            name: "extraInfo[".concat(extraInfoKey$1, "].AuToken"),
            onBlur: handleBlur,
            onChange: handleChange,
            value: extraInfo.AuToken
          }, 'AuToken')
        }), /*#__PURE__*/jsx$1(TLDInfoFieldWrapper, {
          children: /*#__PURE__*/jsx$1(Input$5, {
            id: "AuTokenMembership",
            label: "Priority Contact ID",
            name: "extraInfo[".concat(extraInfoKey$1, "].AuTokenMembership"),
            onBlur: handleBlur,
            onChange: handleChange,
            value: extraInfo.AuTokenMembership
          }, 'AuTokenMembership')
        })]
      }) : '', /*#__PURE__*/jsxs(TLDInfoFieldWrapper, {
        children: [/*#__PURE__*/jsx$1(Text$1, {
          textTransform: "capitalize",
          variant: "milliBold",
          children: strings$5.au.AuEligibilityType
        }), /*#__PURE__*/jsx$1(Dropdown, {
          onChange: function onChange(value) {
            handleChange({
              target: {
                name: "extraInfo[".concat(extraInfoKey$1, "].AuEligibilityType"),
                value: value.value
              }
            });
            toggleFieldsForCategory(value.value);
          },
          options: categoryOptions,
          padding: "0",
          width: "100%",
          value: extraInfo.AuEligibilityType
        })]
      }), requiredExtraInfoLabels.RegistrantNameLabel !== '' ? /*#__PURE__*/jsx$1(TLDInfoFieldWrapper, {
        children: /*#__PURE__*/jsx$1(Input$5, {
          hasError: touched.extraInfo && errors.extraInfo && errors.extraInfo[extraInfoKey$1].RegistrantName && touched.extraInfo[extraInfoKey$1].RegistrantName,
          id: "RegistrantName",
          label: requiredExtraInfoLabels.RegistrantNameLabel,
          name: "extraInfo[".concat(extraInfoKey$1, "].RegistrantName"),
          onBlur: handleBlur,
          onChange: handleChange,
          value: extraInfo.RegistrantName
        }, 'RegistrantName')
      }) : '', requiredExtraInfoLabels.RegistrantIDTypeLabel !== '' ? /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsxs(TLDInfoFieldWrapper, {
          children: [/*#__PURE__*/jsx$1(Text$1, {
            textTransform: "capitalize",
            variant: "milliBold",
            children: requiredExtraInfoLabels.RegistrantIDTypeLabel
          }), /*#__PURE__*/jsx$1(Dropdown, {
            onChange: function onChange(value) {
              handleChange({
                target: {
                  name: "extraInfo[".concat(extraInfoKey$1, "].RegistrantIDType"),
                  value: value.value
                }
              });
            },
            options: AuRegistrantIdTypeOptions,
            padding: "0",
            width: "100%",
            value: extraInfo.RegistrantIDType
          })]
        }), /*#__PURE__*/jsx$1(TLDInfoFieldWrapper, {
          children: /*#__PURE__*/jsx$1(Input$5, {
            hasError: touched.extraInfo && errors.extraInfo && errors.extraInfo[extraInfoKey$1].RegistrantID && touched.extraInfo[extraInfoKey$1].RegistrantID,
            id: "RegistrantID",
            label: requiredExtraInfoLabels.RegistrantIDLabel,
            name: "extraInfo[".concat(extraInfoKey$1, "].RegistrantID"),
            onBlur: handleBlur,
            onChange: handleChange,
            value: extraInfo.RegistrantID
          }, 'RegistrantID')
        })]
      }) : '', requiredExtraInfoLabels.EligibilityNameLabel !== '' ? /*#__PURE__*/jsx$1(TLDInfoFieldWrapper, {
        children: /*#__PURE__*/jsx$1(Input$5, {
          hasError: touched.extraInfo && errors.extraInfo && errors.extraInfo[extraInfoKey$1].EligibilityName && touched.extraInfo[extraInfoKey$1].EligibilityName,
          id: "EligibilityName",
          label: requiredExtraInfoLabels.EligibilityNameLabel,
          name: "extraInfo[".concat(extraInfoKey$1, "].EligibilityName"),
          onBlur: handleBlur,
          onChange: handleChange,
          value: values.extraInfo[extraInfoKey$1].EligibilityName
        }, 'EligibilityName')
      }) : '', requiredExtraInfoLabels.EligibilityIDTypeLabel !== '' ? /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsxs(TLDInfoFieldWrapper, {
          children: [/*#__PURE__*/jsx$1(Text$1, {
            textTransform: "capitalize",
            variant: "milliBold",
            children: requiredExtraInfoLabels.EligibilityIDTypeLabel
          }), /*#__PURE__*/jsx$1(Dropdown, {
            onChange: function onChange(value) {
              handleChange({
                target: {
                  name: "extraInfo[".concat(extraInfoKey$1, "].EligibilityIDType"),
                  value: value.value
                }
              });
            },
            options: AuEligibilityIDTypeOptions,
            padding: "0",
            width: "100%",
            value: extraInfo.EligibilityIDType
          })]
        }), /*#__PURE__*/jsx$1(TLDInfoFieldWrapper, {
          children: /*#__PURE__*/jsx$1(Input$5, {
            hasError: touched.extraInfo && errors.extraInfo && errors.extraInfo[extraInfoKey$1].EligibilityID && touched.extraInfo[extraInfoKey$1].EligibilityID,
            id: "AuEligibilityID",
            label: requiredExtraInfoLabels.EligibilityIDLabel,
            name: "extraInfo[".concat(extraInfoKey$1, "].EligibilityID"),
            onBlur: handleBlur,
            onChange: handleChange,
            value: values.extraInfo[extraInfoKey$1].EligibilityID
          }, 'AuEligibilityID')
        })]
      }) : '', isFieldRequired('AcceptanceAgreement') ? /*#__PURE__*/jsx$1(TLDInfoFieldWrapper, {
        children: /*#__PURE__*/jsx$1(Checkbox, {
          checked: extraInfo.AcceptanceAgreement,
          id: "AcceptanceAgreement",
          onChange: function onChange(_ref2) {
            var value = _ref2.value;
            return handleChange({
              target: {
                name: "extraInfo[".concat(extraInfoKey$1, "].AcceptanceAgreement"),
                value: value
              }
            });
          },
          text: "By submitting this application, you represent and warrant that: (a) all information provided to register or renew the domain name (including all supporting documents, if any) are true, complete and correct, and are not misleading in any way, and the application is made in good faith; (b) you meet, and will continue to meet, the eligibility criteria prescribed in auDA Published Policies for the domain name for the duration of the domain name license; (c) you have not previously submitted an application for the domain name with another registrar using the same eligibility criteria, and the other registrar has rejected the application; (d) you acknowledge and agree that even if the domain name is accepted for registration, your entitlement to register the domain name may be challenged by others who claim to have an entitlement to the domain name; and (e) you acknowledge and agree that auDA or the registrar can cancel the registration of the domain name if any of the warranties set forth above are found to be untrue, incomplete, incorrect or misleading."
        })
      }) : '']
    })]
  });
}
/* END TLDInfoAu */


TLDInfoAU.propTypes = propTypes$O;
TLDInfoAU.defaultProps = defaultProps$n;

function ownKeys$K(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$K(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$K(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$K(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var caStrings$2 = strings$5.ca;
var defaultProps$m = {
  tldOptions: {
    CPRCategory: []
  },
  addNew: false
};
var extraInfoKey = TLDExtraNameMap[TLD_KEYS.ca];
var propTypes$N = {
  currentContactInfo: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  isCorporation: PropTypes.bool.isRequired,
  setCorporation: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setValues: PropTypes.func.isRequired,
  tldOptions: PropTypes.shape({}),
  touched: PropTypes.shape({}).isRequired,
  validateForm: PropTypes.func.isRequired,
  values: PropTypes.shape({}).isRequired,
  addNew: PropTypes.bool
};

function TLDInfoCAForm(_ref) {
  var currentContactInfo = _ref.currentContactInfo,
      setFieldTouched = _ref.setFieldTouched,
      errors = _ref.errors,
      handleBlur = _ref.handleBlur,
      handleChange = _ref.handleChange,
      setFieldValue = _ref.setFieldValue,
      tldOptions = _ref.tldOptions,
      touched = _ref.touched,
      values = _ref.values,
      setValues = _ref.setValues,
      validateForm = _ref.validateForm,
      isCorporation = _ref.isCorporation,
      setCorporation = _ref.setCorporation;
  _ref.addNew; // default to true since our defaults are canadian citizen

  var _useState = useState(true),
      _useState2 = _slicedToArray$4(_useState, 2),
      showPrivacy = _useState2[0],
      setShowPrivacy = _useState2[1];

  var caDefaults = tldDefaults[TLD_KEYS.ca];

  var mergeValuesWithDefaults = function mergeValuesWithDefaults() {
    var extraInfo = values.extraInfo;
    keys$1(caDefaults).forEach(function (key) {
      if (!extraInfo || !extraInfo[TLDExtraNameMap[TLD_KEYS.ca]] || typeof extraInfo[TLDExtraNameMap[TLD_KEYS.ca]][key] === 'undefined') {
        // setting default value
        setFieldValue("extraInfo[".concat(extraInfoKey, "][").concat(key, "]"), caDefaults[key]);
      }
    });
  };

  var addDefaultCAInfo = function addDefaultCAInfo() {
    var extraInfo = values.extraInfo;

    if (isEmpty$2(extraInfo)) {
      var extra = _objectSpread$K(_objectSpread$K({}, values), {}, {
        extraInfo: _defineProperty$6({}, extraInfoKey, _objectSpread$K({}, caDefaults))
      });

      setValues(extra);
    } else {
      setValues(_objectSpread$K(_objectSpread$K({}, values), {}, {
        extraInfo: _objectSpread$K(_objectSpread$K({}, extraInfo), {}, _defineProperty$6({}, extraInfoKey, _objectSpread$K({}, caDefaults)))
      }));
    }
  };

  var hasExtraCAInfo = _get(currentContactInfo.extraInfo, extraInfoKey, false);

  useEffect(function () {
    if (hasExtraCAInfo) {
      return;
    }

    if (!hasExtraCAInfo) {
      addDefaultCAInfo();
      return;
    }

    mergeValuesWithDefaults();
  }, [currentContactInfo]);
  var extraInfo = values.extraInfo ? values.extraInfo[extraInfoKey] || {} : {}; // User's can't update CIRA extra info - ONLY add
  // if (hasExtraCAInfo) return null

  var registrationOptions = tldOptions.CPRCategory.map(function (o) {
    return {
      label: o.DisplayName,
      value: o.Value
    };
  });

  var _tldOptions$CPRCatego = tldOptions.CPRCategory.filter(function (c) {
    return c.Value === 'RES';
  }),
      _tldOptions$CPRCatego2 = _slicedToArray$4(_tldOptions$CPRCatego, 1),
      otherCPRGategory = _tldOptions$CPRCatego2[0];

  var otherChildCats = (otherCPRGategory ? otherCPRGategory.Children : []).map(function (c) {
    return {
      label: c.DisplayName,
      value: c.Value
    };
  });
  var infoIsPublic = extraInfo.WhoisDisplaySetting;

  var handleRegisterType = function handleRegisterType(payload) {
    var value = payload.target.value;
    payload.target.value = value.value;

    if (includes(ALLOW_PRIVACY, value.value)) {
      setShowPrivacy(true);
    } else {
      setShowPrivacy(false);
    } // UserInfo needs to know if we're registering a corp or not for schema validation


    if (value.value === 'CCO') {
      setCorporation(true);

      if (values.company) {
        setFieldTouched('company', true);
        validateForm();
      }
    } else if (isCorporation && value.value !== 'CCO') {
      setCorporation(false);
      setFieldValue('company', '');
      setFieldTouched('company', false);
    }

    mergeValuesWithDefaults();
    handleChange(payload);
  };

  var hasError = errors.company && touched.company;
  var defaultValueCCT = {
    label: 'Canadian citizen',
    value: 'CCT'
  };
  var defaultLanguageValue = {
    label: 'English',
    value: 'en'
  };
  return /*#__PURE__*/jsxs(TLDInfoWrapper, {
    mt: "4",
    children: [/*#__PURE__*/jsx$1(Heading, {
      my: 0,
      textAlign: "left",
      variant: "gigaBold",
      children: caStrings$2.header
    }), /*#__PURE__*/jsxs(Stack$2, {
      ml: 2,
      children: [/*#__PURE__*/jsxs(TLDInfoNote, {
        children: [/*#__PURE__*/jsx$1("span", {
          children: "".concat(caStrings$2.note, " ")
        }), ' ', /*#__PURE__*/jsx$1(Link$1, {
          href: Config.contacts.kb.ca,
          newTab: true,
          title: "Ca Info",
          children: caStrings$2.faqLink
        })]
      }), /*#__PURE__*/jsxs(TLDInfoFieldWrapper, {
        children: [/*#__PURE__*/jsx$1(Text$1, {
          textTransform: "capitalize",
          variant: "milliBold",
          children: caStrings$2.registerAs
        }), /*#__PURE__*/jsx$1(Dropdown, {
          defaultValue: defaultValueCCT,
          isSearchable: false,
          onChange: function onChange(value) {
            return handleRegisterType({
              target: {
                name: "extraInfo[".concat(extraInfoKey, "].CPRCategory"),
                value: value
              }
            });
          },
          options: registrationOptions,
          value: extraInfo.CPRCategory,
          width: "100%",
          padding: "0"
        })]
      }), extraInfo.CPRCategory === 'RES' && /*#__PURE__*/jsxs(TLDInfoFieldWrapper, {
        children: [/*#__PURE__*/jsx$1(Text$1, {
          textTransform: "capitalize",
          variant: "milliBold",
          children: caStrings$2.other
        }), /*#__PURE__*/jsx$1(Dropdown, {
          isSearchable: false,
          onChange: function onChange(value) {
            return handleRegisterType({
              target: {
                name: "extraInfo[".concat(extraInfoKey, "].CPRChildrenCategory"),
                value: value
              }
            });
          },
          options: otherChildCats,
          value: extraInfo.CPRChildrenCategory,
          width: "100%",
          padding: "0"
        })]
      }), extraInfo.CPRCategory === 'CCO' && /*#__PURE__*/jsxs(TLDInfoFieldWrapper, {
        children: [/*#__PURE__*/jsx$1(Input$5, {
          errorMessage: errors.company,
          hasError: hasError,
          id: "company",
          label: "".concat(caStrings$2.company, "*"),
          name: "company",
          onBlur: handleBlur,
          onChange: handleChange,
          value: values.company
        }, 'company'), /*#__PURE__*/jsxs(TLDInfoNote, {
          hasError: hasError,
          children: [/*#__PURE__*/jsx$1("span", {
            children: "".concat(caStrings$2.companyReqPrefix, " ")
          }), /*#__PURE__*/jsx$1(Link$1, {
            href: Config.contacts.kb.ca,
            newTab: true,
            title: caStrings$2.companyReqLinkTitle,
            children: caStrings$2.companyReqLink
          }), /*#__PURE__*/jsx$1("span", {
            children: caStrings$2.companyReqSuffix
          })]
        })]
      }), /*#__PURE__*/jsxs(TLDInfoFieldWrapper, {
        children: [/*#__PURE__*/jsx$1(Text$1, {
          textTransform: "capitalize",
          variant: "milliBold",
          children: caStrings$2.language
        }), /*#__PURE__*/jsx$1(Dropdown, {
          defaultValue: defaultLanguageValue,
          isSearchable: false,
          onChange: function onChange(value) {
            var payload = {
              target: {
                name: "extraInfo[".concat(extraInfoKey, "].Language"),
                value: value
              }
            };
            payload.target.value = value.value;
            handleChange(payload);
          },
          options: LANGUAGE_OPTIONS,
          value: extraInfo.Language,
          width: "100%",
          padding: "0"
        })]
      }), showPrivacy && /*#__PURE__*/jsx$1(TLDInfoFieldWrapper, {
        children: /*#__PURE__*/jsx$1(Checkbox, {
          checked: infoIsPublic,
          id: "WhoisDisplaySetting",
          onChange: function onChange(_ref2) {
            var value = _ref2.value;
            return handleChange({
              target: {
                name: "extraInfo[".concat(extraInfoKey, "].WhoisDisplaySetting"),
                value: value
              }
            });
          },
          text: caStrings$2.makeInfoPublic
        })
      }), /*#__PURE__*/jsx$1(TLDInfoFieldWrapper, {
        noBottomMargin: true,
        children: /*#__PURE__*/jsx$1(TLDInfoNote, {
          children: /*#__PURE__*/jsx$1(Link$1, {
            href: Config.contacts.terms.ca,
            newTab: true,
            color: "black",
            style: {
              textDecoration: 'underline'
            },
            title: caStrings$2.terms,
            children: caStrings$2.terms
          })
        })
      })]
    })]
  });
}

TLDInfoCAForm.defaultProps = defaultProps$m;
TLDInfoCAForm.propTypes = propTypes$N;
var propTypes$M = {
  handleChange: PropTypes.func.isRequired,
  tldOptions: PropTypes.shape({}),
  values: PropTypes.shape({}).isRequired
};
var defaultProps$l = {
  tldOptions: null
};

function TLDInfoUSForm(_ref) {
  _ref.handleChange;
  var setFieldValue = _ref.setFieldValue,
      values = _ref.values,
      tldOptions = _ref.tldOptions;

  if (!tldOptions) {
    return null;
  }

  var categoryOptions = tldOptions.Category.map(function (opt) {
    return {
      label: opt.DisplayName,
      value: opt.Value
    };
  });
  var purposeOptions = tldOptions.Category.map(function (opt) {
    return {
      label: opt.DisplayName,
      value: opt.Value
    };
  });
  var countryOptions = tldOptions.CountryCodeId.map(function (opt) {
    return {
      label: opt.DisplayName,
      value: opt.Value
    };
  });
  var shouldShowCountryDropdown = values.usCategory === 'C31' || values.usCategory === 'C32';
  return /*#__PURE__*/jsxs(TLDInfoWrapper, {
    children: [/*#__PURE__*/jsx$1(Heading, {
      my: 0,
      mt: "3",
      textAlign: "left",
      variant: "gigaBold",
      children: ".US Information"
    }), /*#__PURE__*/jsxs(Stack$2, {
      ml: 2,
      children: [/*#__PURE__*/jsxs(TLDInfoNote, {
        children: [/*#__PURE__*/jsx$1("span", {
          children: "Contacts associated to .US domains require additional information."
        }), ' ', /*#__PURE__*/jsx$1(Link$1, {
          href: Config.contacts.kb.us,
          newTab: true,
          title: "US Info",
          children: "Learn more"
        })]
      }), /*#__PURE__*/jsxs(TLDInfoFieldWrapper, {
        children: [/*#__PURE__*/jsx$1(Text$1, {
          variant: "milliBold",
          children: strings$5.us.category
        }), /*#__PURE__*/jsx$1(Dropdown, {
          isSearchable: false,
          onChange: function onChange(e) {
            return setFieldValue('category', e.value);
          },
          options: categoryOptions,
          width: "100%",
          padding: "0"
        })]
      }), shouldShowCountryDropdown && /*#__PURE__*/jsxs(TLDInfoFieldWrapper, {
        children: [/*#__PURE__*/jsx$1(Text$1, {
          variant: "milliBold",
          children: strings$5.us.country
        }), /*#__PURE__*/jsx$1(Dropdown, {
          isSearchable: false,
          onChange: function onChange(e) {
            return setFieldValue('country', e.value);
          },
          options: countryOptions,
          width: "100%",
          padding: "0"
        })]
      }), /*#__PURE__*/jsxs(TLDInfoFieldWrapper, {
        children: [/*#__PURE__*/jsx$1(Text$1, {
          variant: "milliBold",
          children: strings$5.us.purpose
        }), /*#__PURE__*/jsx$1(Dropdown, {
          isSearchable: false,
          onChange: function onChange(e) {
            setFieldValue('purpose', e.value);
          },
          options: purposeOptions,
          width: "100%",
          padding: "0"
        })]
      })]
    })]
  });
}

TLDInfoUSForm.propTypes = propTypes$M;
TLDInfoUSForm.defaultProps = defaultProps$l;
var colors$i = redesignTheme.colors,
    space$1 = redesignTheme.space,
    borders$1 = redesignTheme.borders;
var ContactWrapper = styled(Box$1).withConfig({
  displayName: "styles__ContactWrapper",
  componentId: "sc-1aihih9-0"
})(["flex-direction:column;"]);
var DetailText = styled(Text$1).withConfig({
  displayName: "styles__DetailText",
  componentId: "sc-1aihih9-1"
})(["line-height:1.6;text-transform:uppercase;font-size:1.4rem;font-weight:400;"]);
var DetailTitleText = styled(Text$1).withConfig({
  displayName: "styles__DetailTitleText",
  componentId: "sc-1aihih9-2"
})(["line-height:1.6;text-transform:uppercase;font-size:1.4rem;font-weight:600;"]);
var StyledGeo = styled(Box$1).withConfig({
  displayName: "styles__StyledGeo",
  componentId: "sc-1aihih9-3"
})(["position:relative;display:flex;flex-direction:column;width:100%;input{height:34px;}input,textarea{width:100%;padding:", ";padding-right:", ";box-sizing:border-box;font-size:1.6rem;border:", ";border-radius:0;transition:all 0.2s;&[aria-invalid='true']{border:", ";position:relative;&::after,&:hover::after{content:'';color:", ";position:absolute;right:8px;top:8px;}}&:focus{border-color:transparent;outline:", ";box-shadow:0 0 0 2px ", ";}}.react-tel-input input[type='tel']{padding-left:48px;}ul{display:", ";border-left:", ";border-right:", ";border-bottom:", ";background:white;}li{padding-right:", ";padding-left:", ";}li:hover{background:", ";}input[type='text']:disabled{background-color:", ";color:", ";}"], space$1.half, space$1[4], borders$1.input, borders$1.error, colors$i.red, colors$i.focus, colors$i.focus, function (props) {
  return props.display || 'block';
}, borders$1.input, borders$1.input, borders$1.input, space$1.half, space$1.half, colors$i.sunflower, theme.colors.greyLightest, theme.colors.greyDark);
var caStrings$1 = strings$5.ca;
var defaultProps$k = {
  tldOptions: {
    CPRCategory: []
  }
};
var propTypes$L = {
  currentContactInfo: PropTypes.shape({}).isRequired,
  tldOptions: PropTypes.shape({})
};

function TLDInfoCAView(_ref) {
  var currentContactInfo = _ref.currentContactInfo,
      tldOptions = _ref.tldOptions;
  var registrationType = '';

  if (currentContactInfo.extraInfo.CiraExtraInfo && currentContactInfo.extraInfo.CiraExtraInfo.CPRCategory) {
    try {
      var registration = tldOptions.CPRCategory.find(function (x) {
        return x.Value === currentContactInfo.extraInfo.CiraExtraInfo.CPRCategory;
      });
      registrationType = registration.DisplayName;
    } catch (err) {
      registrationType = 'Other';
    }
  }

  var displayLanguage = '';

  if (currentContactInfo.extraInfo.CiraExtraInfo && currentContactInfo.extraInfo.CiraExtraInfo.Language) {
    var language = LANGUAGE_OPTIONS.find(function (x) {
      return x.value === currentContactInfo.extraInfo.CiraExtraInfo.Language;
    });
    displayLanguage = language.label;
  }

  var infoIsPublic = '';

  if (currentContactInfo.extraInfo.CiraExtraInfo && currentContactInfo.extraInfo.CiraExtraInfo.WhoisDisplaySetting) {
    infoIsPublic = currentContactInfo.extraInfo.CiraExtraInfo.WhoisDisplaySetting;
  }

  return /*#__PURE__*/jsxs(TLDInfoWrapper, {
    children: [/*#__PURE__*/jsx$1(Heading, {
      my: 0,
      textAlign: "left",
      variant: "gigaBold",
      children: caStrings$1.header
    }), /*#__PURE__*/jsx$1(TLDInfoFieldWrapper, {
      children: /*#__PURE__*/jsxs(Stack$2, {
        ml: 2,
        children: [/*#__PURE__*/jsxs(Box$1, {
          children: [/*#__PURE__*/jsxs(DetailTitleText, {
            children: [caStrings$1.registerAsView, ":\xA0"]
          }), /*#__PURE__*/jsx$1(DetailText, {
            children: registrationType
          })]
        }), /*#__PURE__*/jsxs(Box$1, {
          children: [/*#__PURE__*/jsxs(DetailTitleText, {
            children: [caStrings$1.languageView, ":\xA0"]
          }), /*#__PURE__*/jsx$1(DetailText, {
            children: displayLanguage
          })]
        }), infoIsPublic && infoIsPublic === true ? /*#__PURE__*/jsxs(DetailText, {
          children: [" ", caStrings$1.infoPublicView]
        }) : /*#__PURE__*/jsxs(DetailText, {
          children: [" ", caStrings$1.infoPrivateView]
        })]
      })
    })]
  });
}

TLDInfoCAView.defaultProps = defaultProps$k;
TLDInfoCAView.propTypes = propTypes$L;
var lawStrings = strings$5.law;
var propTypes$K = {
  currentContactInfo: PropTypes.shape({}).isRequired,
  tldOptions: PropTypes.shape({})
};
var defaultProps$j = {
  tldOptions: null
};

function TLDInfoLawView(_ref) {
  var currentContactInfo = _ref.currentContactInfo,
      tldOptions = _ref.tldOptions;
  var countryType = '';

  if (currentContactInfo.extraInfo && currentContactInfo.extraInfo.CountryCodeId) {
    var country = tldOptions.CountryCodeId.find(function (x) {
      return x.value === currentContactInfo.extraInfo.CountryCodeId;
    });
    countryType = country.label;
  }

  return /*#__PURE__*/jsxs(TLDInfoWrapper, {
    children: [/*#__PURE__*/jsx$1(Heading, {
      my: 0,
      textAlign: "left",
      variant: "gigaBold",
      children: lawStrings.header
    }), /*#__PURE__*/jsxs(TLDInfoFieldWrapper, {
      children: [/*#__PURE__*/jsxs(Box$1, {
        children: [/*#__PURE__*/jsxs(DetailTitleText, {
          children: [lawStrings.accId, ":\xA0"]
        }), /*#__PURE__*/jsx$1(DetailText, {})]
      }), /*#__PURE__*/jsxs(Box$1, {
        children: [/*#__PURE__*/jsxs(DetailTitleText, {
          children: [lawStrings.accBody, ":\xA0"]
        }), /*#__PURE__*/jsx$1(DetailText, {})]
      }), /*#__PURE__*/jsxs(Box$1, {
        children: [/*#__PURE__*/jsxs(DetailTitleText, {
          children: [lawStrings.accYear, ":\xA0"]
        }), /*#__PURE__*/jsx$1(DetailText, {})]
      }), /*#__PURE__*/jsxs(Box$1, {
        children: [/*#__PURE__*/jsxs(DetailTitleText, {
          children: [lawStrings.jurisdiction, ":\xA0"]
        }), /*#__PURE__*/jsx$1(DetailText, {})]
      }), /*#__PURE__*/jsxs(Box$1, {
        children: [/*#__PURE__*/jsxs(DetailTitleText, {
          children: [lawStrings.country, ":\xA0"]
        }), /*#__PURE__*/jsx$1(DetailText, {
          children: countryType
        })]
      })]
    })]
  });
}

TLDInfoLawView.propTypes = propTypes$K;
TLDInfoLawView.defaultProps = defaultProps$j;
var usStrings = strings$5.us;
var propTypes$J = {
  currentContactInfo: PropTypes.shape({}).isRequired,
  tldOptions: PropTypes.shape({})
};
var defaultProps$i = {
  tldOptions: null
};

function TLDInfoUSView(_ref) {
  var currentContactInfo = _ref.currentContactInfo,
      tldOptions = _ref.tldOptions;
  var categoryType = '';

  if (currentContactInfo.extraInfo && currentContactInfo.extraInfo.Category) {
    var category = tldOptions.Category.find(function (x) {
      return x.value === currentContactInfo.extraInfo.Category;
    });
    categoryType = category.label;
  }

  var countryType = '';

  if (currentContactInfo.extraInfo && currentContactInfo.extraInfo.CountryCodeId) {
    var country = tldOptions.CountryCodeId.find(function (x) {
      return x.value === currentContactInfo.extraInfo.CountryCodeId;
    });
    countryType = country.label;
  }

  var purposeType = '';

  if (currentContactInfo.extraInfo && currentContactInfo.extraInfo.Purpose) {
    var purpose = tldOptions.Purpose.find(function (x) {
      return x.value === currentContactInfo.extraInfo.Purpose;
    });
    purposeType = purpose.label;
  }

  return /*#__PURE__*/jsxs(TLDInfoWrapper, {
    children: [/*#__PURE__*/jsx$1(Heading, {
      my: 0,
      textAlign: "left",
      variant: "gigaBold",
      children: usStrings.header
    }), /*#__PURE__*/jsxs(TLDInfoFieldWrapper, {
      children: [/*#__PURE__*/jsxs(Box$1, {
        children: [/*#__PURE__*/jsxs(DetailTitleText, {
          children: [usStrings.category, ":\xA0"]
        }), /*#__PURE__*/jsx$1(DetailText, {
          children: categoryType
        })]
      }), /*#__PURE__*/jsxs(Box$1, {
        children: [/*#__PURE__*/jsxs(DetailTitleText, {
          children: [usStrings.country, ":\xA0"]
        }), /*#__PURE__*/jsx$1(DetailText, {
          children: countryType
        })]
      }), /*#__PURE__*/jsxs(Box$1, {
        children: [/*#__PURE__*/jsxs(DetailTitleText, {
          children: [usStrings.purpose, ":\xA0"]
        }), /*#__PURE__*/jsx$1(DetailText, {
          children: purposeType
        })]
      })]
    })]
  });
}

TLDInfoUSView.propTypes = propTypes$J;
TLDInfoUSView.defaultProps = defaultProps$i;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};
/* istanbul ignore next */

/* eslint-disable @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-empty-function */

/**
 * Default values
 */


var defaults = {
  autoActivateFirstSuggest: false,
  disabled: false,
  fixtures: [],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getSuggestLabel: function getSuggestLabel(suggest) {
    return suggest.description;
  },
  highlightMatch: true,
  ignoreEnter: false,
  ignoreTab: false,
  initialValue: '',
  maxFixtures: 10,
  minLength: 1,
  onKeyDown: function onKeyDown() {},
  onKeyPress: function onKeyPress() {},
  placeholder: 'Search places',
  queryDelay: 250,
  skipSuggest: function skipSuggest() {
    return false;
  },
  style: {},
  inputType: 'text'
};
/**
 * Attributes allowed on input elements
 */

var allowedAttributes = ['autoCapitalize', 'autoComplete', 'autoCorrect', 'autoFocus', 'disabled', 'form', 'formAction', 'formEncType', 'formMethod', 'formNoValidate', 'formTarget', 'height', 'inputMode', 'maxLength', 'name', 'onClick', 'onContextMenu', 'onCopy', 'onCut', 'onDoubleClick', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', 'onPaste', 'pattern', 'placeholder', 'readOnly', 'required', 'size', 'spellCheck', 'tabIndex', 'title', 'aria-atomic', 'aria-busy', 'aria-controls', 'aria-current', 'aria-describedby', 'aria-details', 'aria-disabled', 'aria-dropeffect', 'aria-errormessage', 'aria-flowto', 'aria-grabbed', 'aria-haspopup', 'aria-hidden', 'aria-invalid', 'aria-keyshortcuts', 'aria-label', 'aria-labelledby', 'aria-live', 'aria-owns', 'aria-relevant', 'aria-roledescription', 'aria-activedescendant', 'aria-autocomplete', 'aria-multiline', 'aria-placeholder', 'aria-readonly', 'aria-required'];
/**
 * Filter the properties for only allowed input properties
 */

function filterInputAttributes(props) {
  var attributes = {};
  Object.keys(props).forEach(function (attribute) {
    var isDataAttribute = attribute.startsWith('data-');
    var isAllowedAttribute = allowedAttributes.includes(attribute);

    if (isAllowedAttribute || isDataAttribute) {
      attributes[attribute] = props[attribute];
    }
  });
  return attributes;
}
/**
 * The input field
 */


var Input = function (_super) {
  __extends(Input, _super);
  /**
   * The constructor.
   */


  function Input(props) {
    var _this = _super.call(this, props) || this;
    /* eslint-enable @typescript-eslint/no-empty-function */

    /**
     * The reference to the input element
     */


    _this.input = null;
    _this.onChange = _this.onChange.bind(_this);
    _this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
    return _this;
  }
  /**
   * When the input got changed
   */


  Input.prototype.onChange = function () {
    if (this.input) {
      this.props.onChange(this.input.value);
    }
  };
  /**
   * When a key gets pressed in the input
   */
  // eslint-disable-next-line complexity


  Input.prototype.onInputKeyDown = function (event) {
    // Call props.onKeyDown if defined
    // Gives the developer a little bit more control if needed
    if (this.props.onKeyDown) {
      this.props.onKeyDown(event);
    }

    switch (event.which) {
      case 40:
        // DOWN
        if (!event.shiftKey) {
          event.preventDefault();
          this.props.onNext();
        }

        break;

      case 38:
        // UP
        if (!event.shiftKey) {
          event.preventDefault();
          this.props.onPrev();
        }

        break;

      case 13:
        // ENTER
        if (this.props.doNotSubmitOnEnter) {
          event.preventDefault();
        }

        if (!this.props.ignoreEnter) {
          this.props.onSelect();
        }

        break;

      case 9:
        // TAB
        if (!this.props.ignoreTab) {
          this.props.onSelect();
        }

        break;

      case 27:
        // ESC
        this.props.onEscape();
        break;
    }
  };
  /**
   * Focus the input
   */


  Input.prototype.focus = function () {
    if (this.input) {
      this.input.focus();
    }
  };
  /**
   * Blur the input
   */


  Input.prototype.blur = function () {
    if (this.input) {
      this.input.blur();
    }
  };
  /**
   * Render the view
   */


  Input.prototype.render = function () {
    var _this = this;

    var attributes = filterInputAttributes(this.props);
    var classes = classNames$1('geosuggest__input', this.props.className);
    var shouldRenderLabel = this.props.label && this.props.id;

    if (!attributes.tabIndex) {
      attributes.tabIndex = 0;
    }

    return createElement(Fragment$1, null, shouldRenderLabel && createElement("label", {
      className: "geosuggest__label",
      htmlFor: this.props.id
    }, this.props.label), createElement("input", _assign({
      className: classes,
      id: "geosuggest__input" + (this.props.id ? "--" + this.props.id : ''),
      ref: function ref(i) {
        return _this.input = i;
      },
      type: this.props.inputType
    }, attributes, {
      value: this.props.value,
      style: this.props.style,
      onKeyDown: this.onInputKeyDown,
      onChange: this.onChange,
      onKeyPress: this.props.onKeyPress,
      onFocus: this.props.onFocus,
      onBlur: this.props.onBlur,
      role: "combobox",
      "aria-expanded": !this.props.isSuggestsHidden,
      "aria-activedescendant": this.props.activeSuggest ? this.props.activeSuggest.placeId : // eslint-disable-next-line no-undefined
      undefined,
      "aria-owns": this.props.listId
    })));
  };
  /* eslint-disable @typescript-eslint/no-empty-function */

  /**
   * Default values for the properties
   */


  Input.defaultProps = {
    activeSuggest: null,
    autoComplete: 'nope',
    className: '',
    isSuggestsHidden: true,
    listId: '',
    inputType: 'text',
    onBlur: function onBlur() {},
    onChange: function onChange() {},
    onEscape: function onEscape() {},
    onFocus: function onFocus() {},
    onKeyDown: function onKeyDown() {},
    onKeyPress: function onKeyPress() {},
    onNext: function onNext() {},
    onPrev: function onPrev() {},
    onSelect: function onSelect() {},
    value: ''
  };
  return Input;
}(PureComponent);
/**
 * A single Geosuggest item in the list
 */


var default_1 = function (_super) {
  __extends(default_1, _super);
  /**
   * The constructor.
   */


  function default_1(props) {
    var _this = _super.call(this, props) || this;
    /**
     * The reference to the suggest element
     */


    _this.ref = null;
    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }
  /**
   * Makes a text bold
   */


  default_1.prototype.makeBold = function (element, key) {
    return createElement("b", {
      className: "geosuggest__item__matched-text",
      key: key
    }, element);
  };
  /**
   * Replace matched text with the same in bold
   */


  default_1.prototype.formatMatchedText = function (userInput, suggest) {
    if (!userInput || !suggest.matchedSubstrings) {
      return suggest.label;
    }

    var start = suggest.matchedSubstrings.offset;
    var length = suggest.matchedSubstrings.length;
    var end = start + length;
    var boldPart = this.makeBold(suggest.label.substring(start, end), suggest.label);
    var pre = '';
    var post = '';

    if (start > 0) {
      pre = suggest.label.slice(0, start);
    }

    if (end < suggest.label.length) {
      post = suggest.label.slice(end);
    }

    return createElement("span", null, pre, boldPart, post);
  };
  /**
   * Checking if item just became active and scrolling if needed.
   */


  default_1.prototype.componentDidUpdate = function (prevProps) {
    if (!prevProps.isActive && this.props.isActive) {
      this.scrollIfNeeded();
    }
  };
  /**
   * Scrolling current item to the center of the list if item needs scrolling.
   * Item is scrolled to the center of the list.
   */


  default_1.prototype.scrollIfNeeded = function () {
    var element = this.ref;
    var parent = element && element.parentElement;

    if (!element || !parent) {
      return;
    }

    var overTop = element.offsetTop - parent.offsetTop < parent.scrollTop;
    var overBottom = element.offsetTop - parent.offsetTop + element.clientHeight > parent.scrollTop + parent.clientHeight;

    if (overTop || overBottom) {
      parent.scrollTop = element.offsetTop - parent.offsetTop - parent.clientHeight / 2 + element.clientHeight / 2;
    }
  };
  /**
   * When the suggest item got clicked
   */


  default_1.prototype.onClick = function (event) {
    event.preventDefault();
    this.props.onSelect(this.props.suggest);
  };
  /**
   * Render the view
   */


  default_1.prototype.render = function () {
    var _a;

    var _this = this;

    var suggest = this.props.suggest;
    var classes = classNames$1('geosuggest__item', this.props.className, this.props.suggestItemClassName, {
      'geosuggest__item--active': this.props.isActive
    }, (_a = {}, _a[this.props.activeClassName || ''] = this.props.activeClassName ? this.props.isActive : null, _a));
    var content = suggest.label;

    if (this.props.renderSuggestItem) {
      content = this.props.renderSuggestItem(suggest, this.props.userInput);
    } else if (this.props.isHighlightMatch) {
      content = this.formatMatchedText(this.props.userInput, suggest);
    }

    return createElement("li", {
      className: classes,
      ref: function ref(li) {
        return _this.ref = li;
      },
      style: this.props.style,
      onMouseDown: this.props.onMouseDown,
      onMouseOut: this.props.onMouseOut,
      onClick: this.onClick,
      role: "option",
      "aria-selected": this.props.isActive,
      id: suggest.placeId
    }, content);
  };

  return default_1;
}(PureComponent);
/**
 * The list with suggestions.
 */


var default_1$1 = function (_super) {
  __extends(default_1$1, _super);

  function default_1$1() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Whether or not it is hidden
   */


  default_1$1.prototype.isHidden = function () {
    return this.props.isHidden || this.props.suggests.length === 0;
  };
  /**
   * There are new properties available for the list
   */


  default_1$1.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.suggests !== this.props.suggests) {
      if (this.props.suggests.length === 0) {
        this.props.onSuggestNoResults();
      }
    }
  };
  /**
   * Render the view
   * @return {Function} The React element to render
   */


  default_1$1.prototype.render = function () {
    var _a;

    var _this = this;

    var classes = classNames$1('geosuggest__suggests', this.props.suggestsClassName, {
      'geosuggest__suggests--hidden': this.isHidden()
    }, (_a = {}, _a[this.props.hiddenClassName || ''] = this.props.hiddenClassName ? this.isHidden() : null, _a));
    return createElement("ul", {
      className: classes,
      style: this.props.style,
      role: "listbox",
      id: this.props.listId
    }, this.props.suggests.map(function (suggest) {
      var isActive = _this.props.activeSuggest && suggest.placeId === _this.props.activeSuggest.placeId || false;
      return createElement(default_1, {
        key: suggest.placeId,
        className: suggest.className || '',
        userInput: _this.props.userInput,
        isHighlightMatch: _this.props.isHighlightMatch,
        suggest: suggest,
        style: _this.props.suggestItemStyle,
        suggestItemClassName: _this.props.suggestItemClassName,
        isActive: isActive,
        activeClassName: _this.props.suggestItemActiveClassName,
        onMouseDown: _this.props.onSuggestMouseDown,
        onMouseOut: _this.props.onSuggestMouseOut,
        onSelect: _this.props.onSuggestSelect,
        renderSuggestItem: _this.props.renderSuggestItem
      });
    }));
  };

  return default_1$1;
}(PureComponent);
/* global window */
// Escapes special characters in user input for regex


function escapeRegExp(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
/**
 * Entry point for the Geosuggest component
 */


var default_1$2 = function (_super) {
  __extends(default_1, _super);
  /**
   * The constructor. Sets the initial state.
   */
  // eslint-disable-next-line max-statements


  function default_1(props) {
    var _this = _super.call(this, props) || this;
    /**
     * The Google Map instance
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any


    _this.googleMaps = null;
    /**
     * The autocomple service to get suggests
     */

    _this.autocompleteService = null;
    /**
     * The places service to get place details
     */

    _this.placesService = null;
    /**
     * The sessionToken service to use session based monetization
     */

    _this.sessionToken = undefined;
    /**
     * The geocoder to get geocoded results
     */

    _this.geocoder = null;
    /**
     * The input component
     */

    _this.input = null;
    _this.state = {
      activeSuggest: null,
      ignoreBlur: false,
      isLoading: false,
      isSuggestsHidden: true,
      suggests: [],
      userInput: props.initialValue || ''
    };
    _this.onInputChange = _this.onInputChange.bind(_this);
    _this.onAfterInputChange = _this.onAfterInputChange.bind(_this);
    _this.onInputFocus = _this.onInputFocus.bind(_this);
    _this.onInputBlur = _this.onInputBlur.bind(_this);
    _this.onNext = _this.onNext.bind(_this);
    _this.onPrev = _this.onPrev.bind(_this);
    _this.onSelect = _this.onSelect.bind(_this);
    _this.onSuggestMouseDown = _this.onSuggestMouseDown.bind(_this);
    _this.onSuggestMouseOut = _this.onSuggestMouseOut.bind(_this);
    _this.onSuggestNoResults = _this.onSuggestNoResults.bind(_this);
    _this.hideSuggests = _this.hideSuggests.bind(_this);
    _this.selectSuggest = _this.selectSuggest.bind(_this);
    _this.listId = "geosuggest__list" + (props.id ? "--" + props.id : '');

    if (props.queryDelay) {
      _this.onAfterInputChange = debounce$1(_this.onAfterInputChange, props.queryDelay);
    }

    return _this;
  }
  /**
   * Change inputValue if prop changes
   */


  default_1.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.initialValue !== this.props.initialValue) {
      this.setState({
        userInput: this.props.initialValue || ''
      });
    }

    if (JSON.stringify(prevProps.fixtures) !== JSON.stringify(this.props.fixtures)) {
      this.searchSuggests();
    }
  };
  /**
   * Called on the client side after component is mounted.
   * Google api sdk object will be obtained and cached as a instance property.
   * Necessary objects of google api will also be determined and saved.
   */


  default_1.prototype.componentDidMount = function () {
    if (typeof window === 'undefined') {
      return;
    }

    var googleMaps = this.props.googleMaps || window.google && window.google.maps || this.googleMaps;
    /* istanbul ignore next */

    if (!googleMaps) {
      if (console) {
        // eslint-disable-next-line no-console
        console.error('Google maps API was not found in the page.');
      }

      return;
    }

    this.googleMaps = googleMaps;
    this.autocompleteService = new googleMaps.places.AutocompleteService();
    this.placesService = new googleMaps.places.PlacesService(document.createElement('div'));
    this.sessionToken = new googleMaps.places.AutocompleteSessionToken();
    this.geocoder = new googleMaps.Geocoder();
  };
  /**
   * When the component will unmount
   */


  default_1.prototype.componentWillUnmount = function () {
    clearTimeout(this.timer);
  };
  /**
   * When the input changed
   */


  default_1.prototype.onInputChange = function (userInput) {
    if (!userInput) {
      if (this.props.onSuggestSelect) {
        this.props.onSuggestSelect();
      }
    }

    this.setState({
      userInput: userInput
    }, this.onAfterInputChange);
  };
  /**
   * On After the input got changed
   */


  default_1.prototype.onAfterInputChange = function () {
    this.showSuggests();

    if (this.props.onChange) {
      this.props.onChange(this.state.userInput);
    }
  };
  /**
   * When the input gets focused
   */


  default_1.prototype.onInputFocus = function () {
    if (this.props.onFocus) {
      this.props.onFocus();
    }

    this.showSuggests();
  };
  /**
   * When the input gets blurred
   */


  default_1.prototype.onInputBlur = function () {
    if (!this.state.ignoreBlur) {
      this.hideSuggests();
    }
  };

  default_1.prototype.onNext = function () {
    this.activateSuggest('next');
  };

  default_1.prototype.onPrev = function () {
    this.activateSuggest('prev');
  };

  default_1.prototype.onSelect = function () {
    this.selectSuggest(this.state.activeSuggest);
  };

  default_1.prototype.onSuggestMouseDown = function () {
    this.setState({
      ignoreBlur: true
    });
  };

  default_1.prototype.onSuggestMouseOut = function () {
    this.setState({
      ignoreBlur: false
    });
  };

  default_1.prototype.onSuggestNoResults = function () {
    if (this.props.onSuggestNoResults) {
      this.props.onSuggestNoResults(this.state.userInput);
    }
  };
  /**
   * Focus the input
   */


  default_1.prototype.focus = function () {
    if (this.input) {
      this.input.focus();
    }
  };
  /**
   * Blur the input
   */


  default_1.prototype.blur = function () {
    if (this.input) {
      this.input.blur();
    }
  };
  /**
   * Update the value of the user input
   */


  default_1.prototype.update = function (userInput) {
    this.setState({
      userInput: userInput
    });

    if (this.props.onChange) {
      this.props.onChange(userInput);
    }
  };
  /*
   * Clear the input and close the suggestion pane
   */


  default_1.prototype.clear = function () {
    this.setState({
      userInput: ''
    }, this.hideSuggests);
  };
  /**
   * Search for new suggests
   */
  // eslint-disable-next-line complexity, max-statements


  default_1.prototype.searchSuggests = function () {
    var _this = this;

    if (!this.state.userInput) {
      this.updateSuggests();
      return;
    }

    var options = {
      input: this.state.userInput,
      sessionToken: this.sessionToken
    };
    var inputLength = this.state.userInput.length;
    var isShorterThanMinLength = this.props.minLength && inputLength < this.props.minLength;

    if (isShorterThanMinLength) {
      this.updateSuggests();
      return;
    }

    var _a = this.props,
        location = _a.location,
        radius = _a.radius,
        bounds = _a.bounds,
        types = _a.types,
        country = _a.country;
    /* eslint-disable curly */

    if (location) options.location = location;
    if (radius) options.radius = Number(this.props.radius);
    if (bounds) options.bounds = bounds;
    if (types) options.types = types;
    if (country) options.componentRestrictions = {
      country: country
    };
    /* eslint-enable curly */

    this.setState({
      isLoading: true
    }, function () {
      if (!_this.autocompleteService) {
        _this.setState({
          isLoading: false
        });

        return;
      }

      _this.autocompleteService.getPlacePredictions(options, function (suggestsGoogle) {
        _this.setState({
          isLoading: false
        });

        _this.updateSuggests(suggestsGoogle || [], // can be null
        function () {
          if (_this.props.autoActivateFirstSuggest && !_this.state.activeSuggest) {
            _this.activateSuggest('next');
          }
        });
      });
    });
  };
  /**
   * Update the suggests
   */


  default_1.prototype.updateSuggests = function (suggestsGoogle, // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-empty-function
  callback) {
    var _this = this;

    if (suggestsGoogle === void 0) {
      suggestsGoogle = [];
    }

    if (callback === void 0) {
      callback = function callback() {};
    }

    var suggests = [];
    var userInput = this.state.userInput;
    var _a = this.props,
        skipSuggest = _a.skipSuggest,
        maxFixtures = _a.maxFixtures,
        fixtures = _a.fixtures;
    var regex = new RegExp(escapeRegExp(userInput), 'gim');
    var fixturesSearched = 0;
    var activeSuggest = null;

    if (fixtures) {
      fixtures.forEach(function (fixture) {
        if (maxFixtures && fixturesSearched >= maxFixtures) {
          return;
        }

        if (skipSuggest && !skipSuggest(fixture) && fixture.label.match(regex)) {
          fixturesSearched++;
          suggests.push(_assign(_assign({}, fixture), {
            isFixture: true,
            matchedSubstrings: {
              length: userInput.length,
              offset: fixture.label.indexOf(userInput)
            },
            placeId: fixture.placeId || fixture.label
          }));
        }
      });
    }

    suggestsGoogle.forEach(function (suggest) {
      if (skipSuggest && !skipSuggest(suggest)) {
        suggests.push({
          description: suggest.description,
          isFixture: false,
          label: _this.props.getSuggestLabel ? _this.props.getSuggestLabel(suggest) : '',
          matchedSubstrings: suggest.matched_substrings[0],
          placeId: suggest.place_id
        });
      }
    });
    activeSuggest = this.updateActiveSuggest(suggests);

    if (this.props.onUpdateSuggests) {
      this.props.onUpdateSuggests(suggests, activeSuggest);
    }

    this.setState({
      suggests: suggests,
      activeSuggest: activeSuggest
    }, callback);
  };
  /**
   * Return the new activeSuggest object after suggests have been updated
   */


  default_1.prototype.updateActiveSuggest = function (suggests) {
    if (suggests === void 0) {
      suggests = [];
    }

    var activeSuggest = this.state.activeSuggest;

    if (activeSuggest) {
      var newSuggest = suggests.filter(function (listedSuggest) {
        return activeSuggest && activeSuggest.placeId === listedSuggest.placeId && activeSuggest.isFixture === listedSuggest.isFixture;
      })[0];
      activeSuggest = newSuggest || null;
    }

    return activeSuggest;
  };
  /**
   * Show the suggestions
   */


  default_1.prototype.showSuggests = function () {
    this.searchSuggests();
    this.setState({
      isSuggestsHidden: false
    });
  };
  /**
   * Hide the suggestions
   */


  default_1.prototype.hideSuggests = function () {
    var _this = this;

    if (this.props.onBlur) {
      this.props.onBlur(this.state.userInput);
    }

    this.timer = window.setTimeout(function () {
      _this.setState({
        activeSuggest: null,
        isSuggestsHidden: true
      });
    }, 100);
  };
  /**
   * Activate a new suggest
   */
  // eslint-disable-next-line complexity, max-statements


  default_1.prototype.activateSuggest = function (direction) {
    if (this.state.isSuggestsHidden) {
      this.showSuggests();
      return;
    }

    var suggestsCount = this.state.suggests.length - 1;
    var next = direction === 'next';
    var newActiveSuggest = null;
    var newIndex = 0;
    var i = 0;

    for (i; i <= suggestsCount; i++) {
      if (this.state.suggests[i] === this.state.activeSuggest) {
        newIndex = next ? i + 1 : i - 1;
      }
    }

    if (!this.state.activeSuggest) {
      newIndex = next ? 0 : suggestsCount;
    }

    if (newIndex >= 0 && newIndex <= suggestsCount) {
      newActiveSuggest = this.state.suggests[newIndex];
    }

    if (this.props.onActivateSuggest) {
      this.props.onActivateSuggest(newActiveSuggest);
    }

    this.setState({
      activeSuggest: newActiveSuggest
    });
  };
  /**
   * When an item got selected
   */
  // eslint-disable-next-line complexity


  default_1.prototype.selectSuggest = function (suggestToSelect) {
    var suggest = suggestToSelect || {
      isFixture: true,
      label: this.state.userInput,
      placeId: this.state.userInput
    };

    if (!suggestToSelect && this.props.autoActivateFirstSuggest && this.state.suggests.length > 0) {
      suggest = this.state.suggests[0];
    }

    this.setState({
      isSuggestsHidden: true,
      userInput: typeof suggest.label !== 'object' ? suggest.label : suggest.description || ''
    });

    if (suggest.location) {
      this.setState({
        ignoreBlur: false
      });

      if (this.props.onSuggestSelect) {
        this.props.onSuggestSelect(suggest);
      }

      return;
    }

    this.geocodeSuggest(suggest);
  };
  /**
   * Geocode a suggest
   */


  default_1.prototype.geocodeSuggest = function (suggestToGeocode) {
    var _this = this;

    if (!this.geocoder) {
      return;
    }

    if (suggestToGeocode.placeId && !suggestToGeocode.isFixture && this.placesService) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var options = {
        placeId: suggestToGeocode.placeId,
        sessionToken: this.sessionToken
      };

      if (this.props.placeDetailFields) {
        options.fields = this.props.placeDetailFields;
        options.fields.unshift('geometry');
      }

      this.placesService.getDetails(options, function (results, status) {
        if (status === _this.googleMaps.places.PlacesServiceStatus.OK) {
          var gmaps = results;
          var location_1 = gmaps.geometry && gmaps.geometry.location;

          var suggest = _assign(_assign({}, suggestToGeocode), {
            gmaps: gmaps,
            location: {
              lat: location_1.lat(),
              lng: location_1.lng()
            }
          });

          _this.sessionToken = new google.maps.places.AutocompleteSessionToken();

          if (_this.props.onSuggestSelect) {
            _this.props.onSuggestSelect(suggest);
          }
        }
      });
    } else {
      var options = {
        address: suggestToGeocode.label,
        bounds: this.props.bounds,
        componentRestrictions: this.props.country ? {
          country: this.props.country
        } : // eslint-disable-next-line no-undefined
        undefined,
        location: this.props.location
      };
      this.geocoder.geocode(options, function (results, status) {
        if (status === _this.googleMaps.GeocoderStatus.OK) {
          var gmaps = results[0];
          var location_2 = gmaps.geometry && gmaps.geometry.location;

          var suggest = _assign(_assign({}, suggestToGeocode), {
            gmaps: gmaps,
            location: {
              lat: location_2.lat(),
              lng: location_2.lng()
            }
          });

          if (_this.props.onSuggestSelect) {
            _this.props.onSuggestSelect(suggest);
          }
        }
      });
    }
  };
  /**
   * Render the view
   */


  default_1.prototype.render = function () {
    var _this = this;

    var attributes = filterInputAttributes(this.props);
    var classes = classNames$1('geosuggest', this.props.className, {
      'geosuggest--loading': this.state.isLoading
    });
    var input = createElement(Input, _assign({
      className: this.props.inputClassName,
      ref: function ref(i) {
        return _this.input = i;
      },
      value: this.state.userInput,
      doNotSubmitOnEnter: !this.state.isSuggestsHidden,
      ignoreTab: this.props.ignoreTab,
      ignoreEnter: this.props.ignoreEnter,
      style: this.props.style && this.props.style.input,
      onChange: this.onInputChange,
      onFocus: this.onInputFocus,
      onBlur: this.onInputBlur,
      onKeyDown: this.props.onKeyDown,
      onKeyPress: this.props.onKeyPress,
      inputType: this.props.inputType,
      onNext: this.onNext,
      onPrev: this.onPrev,
      onSelect: this.onSelect,
      onEscape: this.hideSuggests,
      isSuggestsHidden: this.state.isSuggestsHidden,
      activeSuggest: this.state.activeSuggest,
      label: this.props.label,
      id: this.props.id,
      listId: this.listId
    }, attributes));
    var suggestionsList = createElement(default_1$1, {
      isHidden: this.state.isSuggestsHidden,
      style: this.props.style && this.props.style.suggests,
      suggestItemStyle: this.props.style && this.props.style.suggestItem,
      userInput: this.state.userInput,
      isHighlightMatch: Boolean(this.props.highlightMatch),
      suggestsClassName: this.props.suggestsClassName,
      suggestItemClassName: this.props.suggestItemClassName,
      suggests: this.state.suggests,
      hiddenClassName: this.props.suggestsHiddenClassName,
      suggestItemActiveClassName: this.props.suggestItemActiveClassName,
      activeSuggest: this.state.activeSuggest,
      onSuggestNoResults: this.onSuggestNoResults,
      onSuggestMouseDown: this.onSuggestMouseDown,
      onSuggestMouseOut: this.onSuggestMouseOut,
      onSuggestSelect: this.selectSuggest,
      renderSuggestItem: this.props.renderSuggestItem,
      listId: this.listId
    });
    return createElement("div", {
      className: classes,
      id: this.props.id
    }, createElement("div", {
      className: "geosuggest__input-wrapper"
    }, input), createElement("div", {
      className: "geosuggest__suggests-wrapper"
    }, suggestionsList));
  };
  /**
   * Default values for the properties
   */


  default_1.defaultProps = defaults;
  return default_1;
}(Component);

var propTypes$I = {
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  tldOptions: PropTypes.shape({}),
  values: PropTypes.shape({}).isRequired
};
var defaultProps$h = {
  tldOptions: null
};

function TLDInfoAsia(_ref) {
  var handleBlur = _ref.handleBlur,
      handleChange = _ref.handleChange,
      setFieldValue = _ref.setFieldValue,
      values = _ref.values,
      tldOptions = _ref.tldOptions;

  if (!tldOptions) {
    return null;
  }

  tldOptions.FormType.map(function (opt) {
    return {
      label: opt.DisplayName,
      value: opt.Value
    };
  });
  tldOptions.LegalEntityType.map(function (opt) {
    return {
      label: opt.DisplayName,
      value: opt.Value
    };
  });
  return /*#__PURE__*/jsxs(TLDInfoWrapper, {
    children: [/*#__PURE__*/jsx$1(Heading, {
      my: 0,
      mt: "3",
      textAlign: "left",
      variant: "gigaBold",
      children: ".ASIA Information"
    }), /*#__PURE__*/jsxs(Stack$2, {
      ml: 2,
      children: [/*#__PURE__*/jsxs(TLDInfoNote, {
        children: [/*#__PURE__*/jsx$1("span", {
          children: "Contacts associated to .ASIA domains require additional information."
        }), ' ', /*#__PURE__*/jsx$1(Link$1, {
          href: Config.contacts.kb.asia,
          newTab: true,
          title: "Asia Info",
          children: "Learn more"
        })]
      }), /*#__PURE__*/jsxs(TLDInfoFieldWrapper, {
        children: [/*#__PURE__*/jsx$1(Text$1, {
          variant: "milliBold",
          children: strings$5.asia.legalEntity
        }), /*#__PURE__*/jsx$1(Dropdown, {
          isSearchable: false,
          onChange: function onChange(e) {
            return setFieldValue('legalEntity', e.value);
          },
          options: getLegalEntityOptions,
          width: "100%",
          padding: "0"
        })]
      }), /*#__PURE__*/jsxs(TLDInfoFieldWrapper, {
        children: [/*#__PURE__*/jsx$1(Text$1, {
          variant: "milliBold",
          children: strings$5.asia.formId
        }), /*#__PURE__*/jsx$1(Dropdown, {
          isSearchable: false,
          onChange: function onChange(e) {
            return setFieldValue('formId', e.value);
          },
          options: getFormIdOptions,
          width: "100%",
          padding: "0"
        })]
      }), /*#__PURE__*/jsx$1(TLDInfoFieldWrapper, {
        children: /*#__PURE__*/jsx$1(Input$5, {
          id: "idNum",
          label: strings$5.asia.idNum,
          name: "idNum",
          onBlur: handleBlur,
          onChange: handleChange,
          value: values.idNum
        }, 'idNum')
      })]
    })]
  });
}

TLDInfoAsia.propTypes = propTypes$I;
TLDInfoAsia.defaultProps = defaultProps$h;
var propTypes$H = {
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  tldOptions: PropTypes.shape({}),
  values: PropTypes.shape({}).isRequired
};
var defaultProps$g = {
  tldOptions: null
};

function TLDInfoLawForm(_ref) {
  var handleBlur = _ref.handleBlur,
      handleChange = _ref.handleChange,
      setFieldValue = _ref.setFieldValue,
      values = _ref.values,
      tldOptions = _ref.tldOptions;

  if (!tldOptions) {
    return null;
  }

  var countryOptions = tldOptions.CountryCodeId.map(function (opt) {
    return {
      label: opt.DisplayName,
      value: opt.Value
    };
  });
  return /*#__PURE__*/jsxs(TLDInfoWrapper, {
    children: [/*#__PURE__*/jsx$1(Heading, {
      my: 0,
      mt: "3",
      textAlign: "left",
      variant: "gigaBold",
      children: ".LAW Information"
    }), /*#__PURE__*/jsxs(Stack$2, {
      ml: 2,
      children: [/*#__PURE__*/jsxs(TLDInfoNote, {
        children: [/*#__PURE__*/jsx$1("span", {
          children: "Contacts associated to .LAW domains require additional information."
        }), ' ', /*#__PURE__*/jsx$1(Link$1, {
          href: Config.contacts.kb.law,
          newTab: true,
          title: "Law Info",
          children: "Learn more"
        })]
      }), /*#__PURE__*/jsxs(Row, {
        children: [/*#__PURE__*/jsx$1(Input$5, {
          id: "accId",
          label: strings$5.law.accId,
          name: "accId",
          onBlur: handleBlur,
          onChange: handleChange,
          value: values.accId
        }, 'accId'), /*#__PURE__*/jsx$1(Input$5, {
          id: "accBody",
          label: strings$5.law.accBody,
          name: "accBody",
          onBlur: handleBlur,
          onChange: handleChange,
          value: values.accBody
        }, 'accBody')]
      }), /*#__PURE__*/jsxs(Row, {
        children: [/*#__PURE__*/jsx$1(Input$5, {
          id: "accYear",
          label: strings$5.law.accYear,
          name: "accYear",
          onBlur: handleBlur,
          onChange: handleChange,
          value: values.accYear
        }, 'accYear'), /*#__PURE__*/jsx$1(Input$5, {
          id: "jurisdiction",
          label: strings$5.law.jurisdiction,
          name: "jurisdiction",
          onBlur: handleBlur,
          onChange: handleChange,
          value: values.jurisdiction
        }, 'jurisdiction')]
      }), /*#__PURE__*/jsxs(TLDInfoFieldWrapper, {
        children: [/*#__PURE__*/jsx$1(Text$1, {
          variant: "milliBold",
          children: strings$5.law.country
        }), /*#__PURE__*/jsx$1(Dropdown, {
          isSearchable: false,
          onChange: function onChange(e) {
            return setFieldValue('country', e.value);
          },
          options: countryOptions,
          width: "100%",
          padding: "0"
        })]
      })]
    })]
  });
}

TLDInfoLawForm.propTypes = propTypes$H;
TLDInfoLawForm.defaultProps = defaultProps$g;
var propTypes$G = {
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  values: PropTypes.shape({}).isRequired
};

function TLDInfoXXX(_ref) {
  var handleBlur = _ref.handleBlur,
      handleChange = _ref.handleChange,
      values = _ref.values;
  return /*#__PURE__*/jsxs(TLDInfoWrapper, {
    children: [/*#__PURE__*/jsx$1(Heading, {
      my: 0,
      mt: "3",
      textAlign: "left",
      variant: "gigaBold",
      children: ".XXX Information"
    }), /*#__PURE__*/jsxs(Stack$2, {
      ml: 2,
      children: [/*#__PURE__*/jsxs(TLDInfoNote, {
        children: [/*#__PURE__*/jsx$1("span", {
          children: "Contacts associated to .XXX domains require additional information."
        }), ' ', /*#__PURE__*/jsx$1(Link$1, {
          href: Config.contacts.kb.xxx,
          newTab: true,
          title: "XXX Info",
          children: "Learn more"
        })]
      }), /*#__PURE__*/jsx$1(TLDInfoFieldWrapper, {
        children: /*#__PURE__*/jsx$1(Input$5, {
          id: "membershipId",
          label: strings$5.xxx.membershipId,
          name: "membershipId",
          onBlur: handleBlur,
          onChange: handleChange,
          value: values.membershipId
        }, 'membershipId')
      })]
    })]
  });
}

TLDInfoXXX.propTypes = propTypes$G;
var caStrings = strings$5.ca;
/* We need to refactor the company names and regex below, accessing 'window' was something we could do in SRC but in UI it blows up. */

var VALID_COMPANY_NAMES = ['bank', 'banque', "caisse d'economie", "caisse d'epargne", 'caisse de credit', 'caisse populaire', 'compagnie', 'company', 'coop', 'cooperation', 'cooperative', 'cooprix', 'corp', 'corp.', 'corporation', 'credit union', "federation de societes mutuelles d'assurance", 'federation of mutual insurance associations', 'fideicommis', 'fiducie', 'inc', 'inc.', 'incorporated', 'incorporee', 'limited', 'limitee', 'ltd', 'ltd.', 'lte', 'lte.', 'ltee', 'ltee.', 'mutual benefit association', 's.a.', 's.a.r.f.', 's.c.c.', 'savings union', 'societe commerciale canadienne', "societe d'entraide economique", "societe d'epargne", 'societe de fiducie', 'societe de secours mutuels', "societe mutuelle d'assurance", 'societe par actions', 'trust', 'ulc', 'ulc.', 'unlimited liability company', 'limited liability company', 'llc', 'sarl', 'societe par actions a responsabilite limitee', 'limited liability partnership', 'llp', 'socit  responsabilit limite ', 's.r.l.', 'limited liability company', 'llc', 'sarl', 'societe par actions a responsabilite limitee', 'limited liability partnership', 'llp', 'socit responsabilit limite ', '(nfp)', '(nfp/osbl)', '(osbl)', '(osbl/nfp)'];
var VALID_COMPANY_REGEX = new RegExp(VALID_COMPANY_NAMES.join('|'), 'i');
var ContactSchema = create().shape({
  apartment: create$2(),
  city: create$2().required('Required'),
  country: create$2().required('Required'),
  email: create$2().required('Required'),
  firstName: create$2().required('Required'),
  lastName: create$2().required('Required'),
  phone: create$2().min(8, 'Required').required('Required'),
  postalCode: create$2().required('Required'),
  province: create$2().required('Required'),
  streetAddress: create$2().required('Required'),
  streetName: create$2(),
  streetNumber: create$2(),
  streetType: create$2(),
  extraInfo: create()
});

var ContactFieldLevelValidation = function ContactFieldLevelValidation(values, isCorporation) {
  if (isCorporation) {
    if (!values.company) ;
  }

  if (!values.firstName) ;
  if (!values.lastName) ;
  if (!values.phone || values.phone.length < 8) ;
  if (!values.email) ;
  if (!values.streetAddress) ;
  if (!values.streetNumber) ;
  if (!values.streetName) ;
  if (!values.streetType) ;
  if (!values.city) ;
  if (!values.country) ;else if (values.country === 'Canada' || values.country === 'United States') {
    if (!values.province) ;
    if (!values.postalCode) ;
  }
};

var ContactCASchema = create().shape({
  company: create$2().matches(VALID_COMPANY_REGEX, caStrings.invalidCompanyName).required(caStrings.companyReq)
}).concat(ContactSchema);
var contactStrings = {
  header: 'Contact Info',
  addressLookup: 'Address Lookup',
  createContact: 'Create Contact',
  searchAddress: 'Search address...',
  addNewContact: 'Add New Contact',
  chooseContact: 'Choose Contact',
  cancel: 'Cancel - Use Existing Contact'
};
var componentMapping = {
  street_number: 'streetNumber',
  route: 'streetName',
  locality: 'city',
  postal_town: 'city',
  administrative_area_level_1: 'province',
  country: 'countryCode',
  postal_code: 'postalCode'
};

function ParseAddress(_ref) {
  var rest = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  var gmaps;

  if (rest) {
    gmaps = rest.gmaps;
  }

  var MapAddressComponents = function MapAddressComponents(addressComponents, fullAddress, streetAddress) {
    var address = {
      streetNumber: '',
      streetName: '',
      streetType: '',
      countryCode: '',
      province: '',
      postalCode: '',
      country: '',
      formattedAddress: '',
      streetAddress: ''
    };
    addressComponents.forEach(function (ac) {
      ac.types.forEach(function (type) {
        if (componentMapping[type]) {
          if (type === 'street_number') {
            address.streetNumber = ac.long_name;
          } else if (type === 'route') {
            var street = ac.long_name.split(' ');
            address.streetType = street.pop();
            address.streetName = street.join(' ');
          } else if (componentMapping[type] === 'countryCode' || componentMapping[type] === 'province') {
            address[componentMapping[type]] = ac.short_name;

            if (type === 'country') {
              // Weird edge case with Turks needing the & instead of the word 'and
              if (ac.long_name === 'Turks and Caicos Islands') {
                address.country = 'Turks & Caicos Islands';
              } else {
                address.country = ac.long_name;
              }
            }
          } else {
            address[componentMapping[type]] = ac.long_name;
          }
        }
      });
    });
    address.formattedAddress = fullAddress;
    address.streetAddress = streetAddress;
    return address;
  };

  if (gmaps) {
    var _gmaps = gmaps,
        addressComponents = _gmaps.address_components,
        fullAddress = _gmaps.formatted_address,
        streetAddress = _gmaps.name;

    if (addressComponents) {
      return MapAddressComponents(addressComponents, fullAddress, streetAddress);
    }
  }

  return null;
}

function ownKeys$J(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$J(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$J(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$J(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var ContactFormProps = _defineProperty$6(_defineProperty$6({
  disabled: PropTypes.bool,
  initialContact: PropTypes.shape({
    apartment: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string,
    email: PropTypes.string,
    extraInfo: PropTypes.shape({}),
    firstName: PropTypes.string,
    id: PropTypes.number,
    lastName: PropTypes.string,
    phone: PropTypes.string,
    postalCode: PropTypes.string,
    province: PropTypes.string,
    streetName: PropTypes.string,
    streetNumber: PropTypes.string,
    streetType: PropTypes.string
  }),
  tldOptions: PropTypes.shape({}).isRequired,
  tlds: PropTypes.array,
  // TD: Make this required
  addNew: PropTypes.bool,
  formik: PropTypes.shape({}).isRequired
}, "tldOptions", PropTypes.shape({}).isRequired), "addInfoRequired", PropTypes.array.isRequired);

var ContactFormDefaultProps = {
  disabled: false,
  initialContact: {
    apartment: '',
    city: '',
    country: '',
    email: '',
    extraInfo: {},
    ext: '',
    firstName: '',
    id: -1,
    lastName: '',
    phone: '',
    postalCode: '',
    province: '',
    streetName: '',
    streetNumber: '',
    streetType: '',
    streetAddress: ''
  },
  initialAddressValue: '',
  addNew: false
};
var ContactForm = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var addInfoRequired = _ref.addInfoRequired,
      initialContact = _ref.initialContact,
      disabled = _ref.disabled,
      tldOptions = _ref.tldOptions,
      tlds = _ref.tlds,
      addNew = _ref.addNew,
      formik = _ref.formik;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isCorporation = _useState2[0],
      setCorporation = _useState2[1];

  var _useState3 = useState('none'),
      _useState4 = _slicedToArray$4(_useState3, 2),
      display = _useState4[0],
      setDisplay = _useState4[1];

  var errors = formik.errors,
      setFieldValue = formik.setFieldValue,
      touched = formik.touched;

  var handlePhone = function handlePhone(value) {
    setFieldValue('phone', value.replace('.', '').replace('-', '').trim());
  };

  var onCountryChange = function onCountryChange(country) {
    var code = getCallingCode(country);
    setFieldValue('phone', "+".concat(code));
  };

  var onSubmit = function onSubmit(e) {
    if (_$1.isEmpty(formik.errors)) {
      e.preventDefault();
      formik.handleSubmit(e);
    }
  };

  var hasErrorBasedOnCountry = function hasErrorBasedOnCountry(errors, touched) {
    var _document$getElementB, _document$getElementB2;

    var country = (_document$getElementB = document.getElementById('country')) === null || _document$getElementB === void 0 ? void 0 : (_document$getElementB2 = _document$getElementB.value) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.toLowerCase();

    if (country === 'canada' || country === 'united states') {
      return !!errors && touched;
    }

    return false;
  };

  React__default.useImperativeHandle(ref, function () {
    return {
      id: 'contact-form',
      submit: function submit(e) {
        return onSubmit(e);
      }
    };
  });

  var onSuggestSelect = function onSuggestSelect(value) {
    if (!value) {
      return;
    }

    var _ParseAddress = ParseAddress(value),
        apartment = _ParseAddress.apartment,
        city = _ParseAddress.city,
        country = _ParseAddress.country,
        countryCode = _ParseAddress.countryCode,
        postalCode = _ParseAddress.postalCode,
        province = _ParseAddress.province,
        streetAddress = _ParseAddress.streetAddress,
        streetName = _ParseAddress.streetName,
        streetNumber = _ParseAddress.streetNumber,
        streetType = _ParseAddress.streetType,
        formattedAddress = _ParseAddress.formattedAddress;

    setFieldValue('apartment', apartment || '', true);
    setFieldValue('city', city, true);
    setFieldValue('province', province, true);
    setFieldValue('postalCode', postalCode, true);
    setFieldValue('country', country, true);
    setFieldValue('countryCode', countryCode, true);
    setFieldValue('streetAddress', streetAddress, true);
    setFieldValue('streetName', streetName, true);
    setFieldValue('streetNumber', streetNumber, true);
    setFieldValue('streetType', streetType, true);
    setFieldValue('formattedAddress', formattedAddress, true);
    onCountryChange(country);
    setDisplay('none');
  };

  return /*#__PURE__*/jsxs("form", {
    id: "contact-form",
    ref: ref,
    onSubmit: onSubmit,
    children: [/*#__PURE__*/jsx$1(Box$1, {
      flexDirection: "row",
      children: /*#__PURE__*/jsx$1(Input$5, _objectSpread$J({
        id: "email",
        disabled: disabled,
        errorMessage: errors.email,
        hasError: !!errors.email,
        label: "Email",
        ml: 2,
        width: "100%"
      }, formik.getFieldProps('email')))
    }), /*#__PURE__*/jsxs(Box$1, {
      flexDirection: "row",
      mt: 2,
      children: [/*#__PURE__*/jsx$1(Input$5, _objectSpread$J({
        id: "firstName",
        disabled: disabled,
        errorMessage: errors.firstName,
        hasError: !!errors.firstName && touched.firstName,
        label: "First Name",
        ml: 2,
        width: "100%"
      }, formik.getFieldProps('firstName'))), /*#__PURE__*/jsx$1(Input$5, _objectSpread$J({
        id: "lastName",
        disabled: disabled,
        errorMessage: errors.lastName,
        hasError: !!errors.lastName && touched.lastName,
        label: "Last Name",
        ml: 2,
        width: "100%"
      }, formik.getFieldProps('lastName')))]
    }), /*#__PURE__*/jsxs(Box$1, {
      flexDirection: "column",
      ml: 2,
      mt: 2,
      width: "98.5%",
      children: [/*#__PURE__*/jsxs(Text$1, {
        variant: "milliBold",
        children: [contactStrings.addressLookup, " "]
      }), /*#__PURE__*/jsx$1(StyledGeo, {
        display: display,
        children: /*#__PURE__*/jsx$1(default_1$2, {
          disabled: disabled,
          initialValue: "",
          onBlur: function onBlur() {
            return setDisplay('none');
          },
          onFocus: function onFocus() {
            return setDisplay('block');
          },
          onSuggestSelect: onSuggestSelect,
          placeholder: contactStrings.searchAddress
        })
      })]
    }), /*#__PURE__*/jsxs(Box$1, {
      flexDirection: "row",
      mt: 2,
      children: [/*#__PURE__*/jsx$1(Input$5, _objectSpread$J({
        id: "apartment",
        disabled: disabled,
        label: "Apt # (optional)",
        ml: 2,
        width: "40%"
      }, formik.getFieldProps('apartment'))), /*#__PURE__*/jsx$1(Input$5, _objectSpread$J({
        id: "streetAddress",
        disabled: disabled,
        errorMessage: errors.streetAddress,
        hasError: !!errors.streetAddress && touched.streetAddress,
        label: "Street Address",
        ml: 2
      }, formik.getFieldProps('streetAddress')))]
    }), /*#__PURE__*/jsxs(Box$1, {
      flexDirection: "row",
      mt: 2,
      children: [/*#__PURE__*/jsx$1(Input$5, _objectSpread$J({
        id: "city",
        disabled: disabled,
        errorMessage: errors.city,
        hasError: !!errors.city && touched.city,
        label: "City",
        ml: 2
      }, formik.getFieldProps('city'))), /*#__PURE__*/jsx$1(Input$5, _objectSpread$J({
        id: "province",
        disabled: disabled,
        errorMessage: errors.province,
        hasError: hasErrorBasedOnCountry(errors.province, touched.province),
        label: "State/Province",
        ml: 2
      }, formik.getFieldProps('province')))]
    }), /*#__PURE__*/jsxs(Box$1, {
      mt: 2,
      children: [/*#__PURE__*/jsx$1(Input$5, _objectSpread$J({
        id: "postalCode",
        disabled: disabled,
        errorMessage: errors.postalCode,
        hasError: hasErrorBasedOnCountry(errors.postalCode, touched.postalCode),
        label: "Zip/Postal Code",
        ml: 2
      }, formik.getFieldProps('postalCode'))), /*#__PURE__*/jsx$1(Input$5, _objectSpread$J({
        id: "country",
        disabled: disabled,
        errorMessage: errors.country,
        hasError: !!errors.country && touched.country,
        label: "Country",
        ml: 2,
        onChange: function onChange(e) {
          onCountryChange(e.target.value);
          handleInput(e);
        }
      }, formik.getFieldProps('country')))]
    }), /*#__PURE__*/jsx$1(Box$1, {
      mt: 2,
      children: /*#__PURE__*/jsx$1(Input$5, _objectSpread$J({
        id: "phone",
        disabled: disabled,
        errorMessage: errors.phone,
        hasError: !!errors.phone,
        onChange: handlePhone,
        label: "Phone (eg. +12223334444)",
        ml: 2
      }, formik.getFieldProps('phone')))
    }), /*#__PURE__*/jsx$1(Box$1, {}), tldOptions && (addNew && tlds && tlds.includes('ca') || addInfoRequired && addInfoRequired.includes('CA')) ? /*#__PURE__*/jsx$1(Box$1, {
      children: /*#__PURE__*/jsx$1(TLDInfoCAForm, _objectSpread$J(_objectSpread$J({}, formik), {}, {
        currentContactInfo: initialContact,
        isCorporation: isCorporation,
        tldOptions: tldOptions.ca,
        setCorporation: setCorporation
      }))
    }) : null, tldOptions && addInfoRequired && addInfoRequired.includes('ASIA') ? /*#__PURE__*/jsx$1(Box$1, {
      children: /*#__PURE__*/jsx$1(TLDInfoAsia, _objectSpread$J(_objectSpread$J({}, formik), {}, {
        tldOptions: tldOptions.asia
      }))
    }) : null, addInfoRequired && addInfoRequired.includes('XXX') ? /*#__PURE__*/jsx$1(Box$1, {
      children: /*#__PURE__*/jsx$1(TLDInfoXXX, _objectSpread$J({}, formik))
    }) : null, tldOptions && addInfoRequired && addInfoRequired.includes('US') ? /*#__PURE__*/jsx$1(Box$1, {
      children: /*#__PURE__*/jsx$1(TLDInfoUSForm, _objectSpread$J(_objectSpread$J({}, formik), {}, {
        tldOptions: tldOptions.us
      }))
    }) : null, tldOptions && addInfoRequired && addInfoRequired.includes('LAW') ? /*#__PURE__*/jsx$1(Box$1, {
      children: /*#__PURE__*/jsx$1(TLDInfoLawForm, _objectSpread$J(_objectSpread$J({}, formik), {}, {
        tldOptions: tldOptions.law
      }))
    }) : null, tldOptions && (addNew && tlds && tlds.some(function (tld) {
      return ".".concat(tld).endsWith('.au');
    }) || addInfoRequired && addInfoRequired.includes('AU')) ? /*#__PURE__*/jsx$1(Box$1, {
      children: /*#__PURE__*/jsx$1(TLDInfoAU, _objectSpread$J(_objectSpread$J({}, formik), {}, {
        currentContactInfo: initialContact,
        tldOptions: tldOptions.au
      }))
    }) : null]
  });
});
ContactForm.propTypes = ContactFormProps;
ContactForm.defaultProps = ContactFormDefaultProps;

function ownKeys$I(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$I(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$I(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$I(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _regenerator$K() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$K(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$K(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$K(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$K(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$K(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$K(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$K(u), _regeneratorDefine2$K(u, o, "Generator"), _regeneratorDefine2$K(u, n, function () {
    return this;
  }), _regeneratorDefine2$K(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$K = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$K(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$K = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$K(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$K(e, r, n, t);
}

var getAddInfoRequired = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$K().m(function _callee(setAddInfoRequired) {
    var addInfoResponse;
    return _regenerator$K().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return post$1(addInfoRequiredEndpoint);

          case 1:
            addInfoResponse = _context.v;
            setAddInfoRequired(addInfoResponse.data.DomainsMissingData);
            _context.n = 3;
            break;

          case 2:
            _context.p = 2; // don't block order going through if validation errors.

            setAddInfoRequired([]);

          case 3:
            return _context.a(2);
        }
      }
    }, _callee, null, [[0, 2]]);
  }));

  return function getAddInfoRequired(_x) {
    return _ref.apply(this, arguments);
  };
}();

var ContactView = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _useUserService = useUserService(),
      isNew = _useUserService.isNew;

  var _useContactService = useContactService(),
      contactState = _useContactService.contact,
      selectContact = _useContactService.selectContact,
      fetchContacts = _useContactService.fetchContacts,
      toggleAddNew = _useContactService.toggleAddNew,
      setContactSuccessful = _useContactService.setContactSuccessful;

  var defaultContact = contactState.defaultContact,
      selectedContact = contactState.selectedContact,
      contacts = contactState.contacts,
      loading = contactState.loading; // const [addNew, setAddNew] = useState(false)

  var _useState = useState([]),
      _useState2 = _slicedToArray$4(_useState, 2),
      addInfoRequired = _useState2[0],
      setAddInfoRequired = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray$4(_useState3, 2),
      tldOptions = _useState4[0],
      setTldOptions = _useState4[1];

  var _useOrderQuery = useOrderQuery(),
      order = _useOrderQuery.order;

  var _useState5 = useState([]),
      _useState6 = _slicedToArray$4(_useState5, 2),
      tlds = _useState6[0],
      setTLDS = _useState6[1];

  var getTLDOptions = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$K().m(function _callee2() {
      var result;
      return _regenerator$K().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return get$3(getTLDOptionsEndpoint());

            case 1:
              result = _context2.v;
              setTldOptions(result.data);

            case 2:
              return _context2.a(2);
          }
        }
      }, _callee2);
    }));

    return function getTLDOptions() {
      return _ref2.apply(this, arguments);
    };
  }();

  var streetAddressFormat = "".concat(selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.streetNumber, " ").concat(selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.streetName, " ").concat(selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.streetType);
  var formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      apartment: (selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.apartment) || '',
      city: (selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.city) || '',
      country: (selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.country) || '',
      countryCode: (selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.countryCode) || '',
      email: (selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.email) || '',
      firstName: (selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.firstName) || '',
      lastName: (selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.lastName) || '',
      phone: (selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.phone) || "",
      postalCode: (selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.postalCode) || '',
      province: (selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.province) || '',
      formattedAddress: (selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.formattedAddress) || '',
      streetAddress: streetAddressFormat,
      streetName: (selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.streetName) || '',
      streetNumber: (selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.streetNumber) || '',
      streetType: (selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.streetType) || '',
      extraInfo: (selectedContact === null || selectedContact === void 0 ? void 0 : selectedContact.extraInfo) || {}
    },
    validationSchema: tlds && tlds.includes('ca') && isCorporation ? ContactCASchema : ContactSchema,
    validate: function validate(values) {
      return ContactFieldLevelValidation(values, tlds && tlds.includes('ca') && isCorporation);
    },
    onSubmit: function onSubmit(values) {
      return handleSubmit(values);
    }
  });

  var handleSubmit = function handleSubmit(values) {
    selectContact(values);
    setContactSuccessful(true);
  };

  var addInfoSubmit = function addInfoSubmit(e) {
    e.preventDefault();
    selectedContact.extraInfo = _objectSpread$I(_objectSpread$I({}, selectedContact.extraInfo), ref.current.value);
    selectContact(selectedContact);
  };

  var handleChangeContact = function handleChangeContact(_ref3) {
    var value = _ref3.value;
    var contact = contacts.find(function (x) {
      return x.id === value;
    });
    selectContact(contact);
  }; // If a user cancels a new contact form, use the default contact as the currently selected contact


  var handleCancel = function handleCancel() {
    selectContact(defaultContact);
    toggleAddNew(false);
    formik.resetForm();
  };

  var _useState7 = useState(false),
      _useState8 = _slicedToArray$4(_useState7, 2),
      isCorporation = _useState8[0],
      setCorporation = _useState8[1];

  var getLabel = function getLabel(contact) {
    return "".concat(contact.firstName, " ").concat(contact.lastName, " - ").concat(contact.email);
  };

  var getContactOptions = contacts ? contacts.map(function (contact) {
    return {
      value: contact.id,
      label: getLabel(contact)
    };
  }) : [];
  useEffect(function () {
    fetchContacts();

    if (!tldOptions) {
      getTLDOptions();
    }
  }, []);
  useEffect(function () {
    // Check if any of the items in the cart require CIRA informashowTLDFormstion,
    // and if so, get the name of the information we need to collect from user.
    if (addInfoRequired.length === 0) {
      getAddInfoRequired(setAddInfoRequired);
    }
  }, []);
  useEffect(function () {
    var items = _$1.get(order, 'items', []);

    if (items.length) {
      var tldMap = items.filter(function (item) {
        return item.details && item.details.tld;
      }).map(function (item) {
        return item.details.tld;
      });
      setTLDS(_toConsumableArray$1(new Set(tldMap)));
    }
  }, [order]);

  var showTLDForms = !isNew && !contactState.addNew && tlds && tldOptions && selectedContact && selectedContact.extraInfo && (tlds.includes('ca') && _$1.isEmpty(selectedContact.extraInfo.CiraExtraInfo) || tlds.includes('law') && _$1.isEmpty(selectedContact.extraInfo.LawExtraInfoObject) || tlds.some(function (tld) {
    return ".".concat(tld).endsWith('.au');
  }) && _$1.isEmpty(selectedContact.extraInfo.AUExtraInfo));

  useImperativeHandle(ref, function () {
    if (showTLDForms) {
      return {
        id: 'additionalInfo-form',
        submit: function submit(e) {
          return addInfoSubmit(e);
        },
        value: formik.values.extraInfo
      };
    }
  }, [showTLDForms, formik.values.extraInfo]);

  if (loading && !contacts) {
    return /*#__PURE__*/jsx$1(Stack$2, {
      style: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        width: '100%',
        overflow: 'hidden'
      },
      children: /*#__PURE__*/jsx$1(ContactWrapper, {
        children: /*#__PURE__*/jsx$1(Spinner$1, {
          size: "3rem",
          stroke: ".3rem"
        })
      })
    });
  }

  return contacts && /*#__PURE__*/jsx$1(Stack$2, {
    width: "100%",
    children: /*#__PURE__*/jsxs(ContactWrapper, {
      children: [/*#__PURE__*/jsxs(Box$1, {
        justifyContent: "space-between",
        display: ['block', 'flex', 'block', 'flex'],
        mb: 1,
        children: [/*#__PURE__*/jsx$1(Heading, {
          my: 0,
          textAlign: "left",
          variant: "gigaBold",
          children: contactStrings.header
        }), !isNew && !contactState.addNew && /*#__PURE__*/jsx$1(Button$1, {
          ariaLabel: contactStrings.addNewContact,
          color: "black",
          id: "add-new-contact",
          onClick: function onClick() {
            return toggleAddNew(true);
          },
          variant: "underlined",
          children: contactStrings.addNewContact
        })]
      }), isNew && /*#__PURE__*/jsx$1(ContactForm, {
        addInfoRequired: addInfoRequired,
        initialContact: selectedContact,
        tldOptions: tldOptions,
        tlds: tlds,
        formik: formik,
        ref: ref
      }), !isNew && !contactState.addNew && /*#__PURE__*/jsxs(Box$1, {
        flexDirection: "column",
        my: 2,
        children: [contacts && contacts.length > 1 && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx$1(Text$1, {
            variant: "milliBold",
            children: contactStrings.chooseContact
          }), /*#__PURE__*/jsx$1(Dropdown, {
            isSearchable: false,
            onChange: handleChangeContact,
            options: getContactOptions,
            placeholder: getLabel(selectedContact),
            width: "100%"
          })]
        }), /*#__PURE__*/jsxs(Box$1, {
          flexDirection: "column",
          mt: 2,
          children: [/*#__PURE__*/jsxs(Text$1, {
            variant: "megaBold",
            children: [" ", selectedContact.email, " "]
          }), /*#__PURE__*/jsxs(DetailText, {
            children: [selectedContact.firstName, " ", selectedContact.lastName]
          }), /*#__PURE__*/jsxs(DetailText, {
            children: [selectedContact.streetNumber, " ", selectedContact.streetName, ' ', selectedContact.streetType]
          }), /*#__PURE__*/jsxs(DetailText, {
            children: [selectedContact.city, ", ", selectedContact.province, " ,", ' ', selectedContact.country, ", ", selectedContact.postalCode]
          }), /*#__PURE__*/jsx$1(DetailText, {
            children: selectedContact.phone
          })]
        }), showTLDForms && /*#__PURE__*/jsxs("form", {
          id: "additionalInfo-form",
          ref: showTLDForms ? ref : null,
          onSubmit: addInfoSubmit,
          children: [tlds.includes('ca') && _$1.isEmpty(selectedContact.extraInfo.CiraExtraInfo) && /*#__PURE__*/jsx$1(Box$1, {
            flexDirection: "column",
            mt: 2,
            children: /*#__PURE__*/jsx$1(TLDInfoCAForm, _objectSpread$I(_objectSpread$I({}, formik), {}, {
              currentContactInfo: selectedContact,
              isCorporation: isCorporation,
              tldOptions: tldOptions.ca,
              setCorporation: setCorporation
            }))
          }), tlds.includes('law') && _$1.isEmpty(selectedContact.extraInfo.LawExtraInfoObject) && /*#__PURE__*/jsx$1(Box$1, {
            flexDirection: "column",
            mt: 2,
            children: /*#__PURE__*/jsx$1(TLDInfoUSForm, _objectSpread$I(_objectSpread$I({}, formik), {}, {
              tldOptions: tldOptions.law
            }))
          }), tlds.some(function (tld) {
            return ".".concat(tld).endsWith('.au');
          }) && /*#__PURE__*/jsx$1(Box$1, {
            children: /*#__PURE__*/jsx$1(TLDInfoAU, _objectSpread$I(_objectSpread$I({}, formik), {}, {
              currentContactInfo: selectedContact,
              tldOptions: tldOptions.au
            }))
          })]
        }), tldOptions && tlds && tlds.includes('ca') && selectedContact.extraInfo.CiraExtraInfo && /*#__PURE__*/jsx$1(Box$1, {
          flexDirection: "column",
          mt: 4,
          children: /*#__PURE__*/jsx$1(TLDInfoCAView, {
            currentContactInfo: selectedContact,
            tldOptions: tldOptions.ca
          })
        }), tldOptions && tlds && tlds.includes('us') && selectedContact.extraInfo.USNexusInfoObject && /*#__PURE__*/jsx$1(Box$1, {
          flexDirection: "column",
          mt: 4,
          children: /*#__PURE__*/jsx$1(TLDInfoUSView, {
            currentContactInfo: selectedContact,
            tldOptions: tldOptions.us
          })
        }), tldOptions && tlds && tlds.includes('law') && selectedContact.extraInfo.LawExtraInfoObject && /*#__PURE__*/jsx$1(Box$1, {
          flexDirection: "column",
          mt: 4,
          children: /*#__PURE__*/jsx$1(TLDInfoLawView, {
            currentContactInfo: selectedContact,
            tldOptions: tldOptions.law
          })
        })]
      }), !isNew && contactState.addNew && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx$1(ContactForm, {
          addInfoRequired: addInfoRequired,
          initialContact: selectedContact,
          tldOptions: tldOptions,
          tlds: tlds,
          addNew: contactState.addNew,
          formik: formik,
          ref: ref
        }), /*#__PURE__*/jsx$1(Box$1, {
          justifyContent: "center",
          mb: 2,
          mt: 2,
          children: /*#__PURE__*/jsx$1(Button$1, {
            ariaLabel: "cancel",
            color: "black",
            id: "btn-cancel-contact-form",
            onClick: handleCancel,
            variant: "underlined",
            children: contactStrings.cancel
          })
        })]
      })]
    })
  });
});

function FinePrint(_ref) {
  var plainText = _ref.plainText,
      hyperlinkedText = _ref.hyperlinkedText,
      URL = _ref.URL,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'black' : _ref$color,
      _ref$textSize = _ref.textSize,
      textSize = _ref$textSize === void 0 ? '1.35rem' : _ref$textSize;
  return /*#__PURE__*/jsx$1(Box$1, {
    my: 2,
    display: ['block', 'block', 'flex'],
    width: "100%",
    justifyContent: "center",
    children: /*#__PURE__*/jsxs(Text$1, {
      fontSize: textSize,
      mx: 2,
      textAlign: "center",
      children: [plainText, /*#__PURE__*/jsx$1(Link$1, {
        color: color,
        fontSize: textSize,
        href: URL,
        variant: "link",
        padding: "0rem",
        children: hyperlinkedText
      })]
    })
  });
}

var _excluded$d = ["skipValidation", "onSubmit", "children", "showAlias"];

function ownKeys$H(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$H(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$H(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$H(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var cardSchema = create().shape({
  ccAlias: create$2().max(50, paymentStrings.ccAliasLength),
  ccExpiration: create()["default"](null).nullable().shape({
    month: create$1(),
    year: create$1()
  }).required(paymentStrings.expireRequired),
  ccName: create$2().max(50, paymentStrings.ccNameLength).required(paymentStrings.ccNameRequired),
  ccNumber: create$2().required(paymentStrings.numRequired),
  cvv: create$2().required(paymentStrings.cvvRequired)
});

var getCardIcon = function getCardIcon(type) {
  return /*#__PURE__*/jsx$1(Icon$2, {
    height: "2.2rem",
    name: _camelCase(type),
    width: "5rem"
  });
};

var CreditCardForm = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var skipValidation = _ref.skipValidation,
      _onSubmit = _ref.onSubmit,
      children = _ref.children,
      showAlias = _ref.showAlias,
      rest = _objectWithoutProperties$8(_ref, _excluded$d);

  var _useState = useState({
    ccNumberValid: false,
    ccExpirationValid: false,
    cvvValid: false
  }),
      _useState2 = _slicedToArray$4(_useState, 2),
      ccState = _useState2[0],
      setCCState = _useState2[1];

  var ccNumberValid = ccState.ccNumberValid,
      ccExpirationValid = ccState.ccExpirationValid,
      cvvValid = ccState.cvvValid;
  var creditCardInvalid = !ccNumberValid || !ccExpirationValid || !cvvValid;
  var formik = useFormik({
    initialValues: {
      ccNumber: '',
      ccAlias: '',
      ccExpiration: '',
      ccType: '',
      makeDefault: true,
      cvv: '',
      ccName: ''
    },
    onSubmit: function onSubmit(values, _ref2) {
      var setSubmitting = _ref2.setSubmitting;

      if (creditCardInvalid) {
        return;
      }

      _onSubmit(values);

      setSubmitting(false);
    },
    validationSchema: skipValidation ? null : cardSchema
  });

  var handleCreditCardValidity = function handleCreditCardValidity(payload) {
    setCCState(_objectSpread$H(_objectSpread$H({}, ccState), payload));
  };

  var errors = formik.errors,
      values = formik.values,
      touched = formik.touched,
      handleBlur = formik.handleBlur,
      handleChange = formik.handleChange,
      setFieldValue = formik.setFieldValue,
      resetForm = formik.resetForm;

  var onRegularSubmission = function onRegularSubmission(e) {
    e.preventDefault();
    formik.handleSubmit(e);
  };

  var handleEnterSubmit = function handleEnterSubmit(e) {
    if (e.key === 'Enter') {
      onRegularSubmission(e);
    }
  };

  React__default.useImperativeHandle(ref, function () {
    return {
      submit: function submit(e) {
        return onRegularSubmission(e);
      }
    };
  });
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    jsxs("form", _objectSpread$H(_objectSpread$H({
      id: "credit-card-form",
      ref: ref,
      onSubmit: onRegularSubmission,
      onKeyPress: handleEnterSubmit
    }, rest), {}, {
      children: [/*#__PURE__*/jsx$1(Number$1, {
        onChange: function onChange(_ref3) {
          var type = _ref3.type,
              value = _ref3.value,
              valid = _ref3.valid;
          setFieldValue('ccNumber', value);
          setFieldValue('ccType', type);
          handleCreditCardValidity({
            ccNumberValid: valid
          });
        },
        render: function render(_ref4) {
          var getInputProps = _ref4.getInputProps,
              valid = _ref4.valid,
              type = _ref4.type;
          var hasError = (errors.ccNumber || !valid) && touched.ccNumber;
          return /*#__PURE__*/createElement(Input$5, _objectSpread$H(_objectSpread$H({}, getInputProps()), {}, {
            key: "ccNumber",
            "aria-invalid": hasError,
            "aria-required": true,
            cardTypes: ['American Express', 'Visa', 'Mastercard'],
            errorMessage: errors.ccNumber || 'CC Number is not valid',
            hasError: hasError,
            icon: getCardIcon(type),
            id: "ccNumber",
            label: paymentStrings.ccNumber,
            mb: 3,
            name: "ccNumber",
            onBlur: handleBlur
          }));
        },
        value: values.ccNumber
      }), /*#__PURE__*/jsx$1(Input$5, {
        "aria-invalid": errors.ccName,
        errorMessage: errors.ccName,
        hasError: errors.ccName && touched.ccName,
        id: "ccName",
        label: paymentStrings.ccName,
        mb: 3,
        name: "ccName",
        onBlur: handleBlur,
        onChange: function onChange(e) {
          setFieldValue('ccName', e.target.value);
        },
        value: values.ccName
      }), /*#__PURE__*/jsxs(_StyledBox$f, {
        alignItems: "flex-start",
        justifyContent: "space-between",
        mb: 3,
        children: [/*#__PURE__*/jsx$1(Expiration, {
          onChange: function onChange(_ref5) {
            var month = _ref5.month,
                year = _ref5.year,
                valid = _ref5.valid;
            setFieldValue('ccExpiration', {
              month: month,
              year: year
            });
            handleCreditCardValidity({
              ccExpirationValid: valid
            });
          },
          render: function render(_ref6) {
            var getInputProps = _ref6.getInputProps,
                valid = _ref6.valid,
                error = _ref6.error;
            var errMsg = errors.ccExpiration || paymentStrings[error];
            var hasError = (errors.ccExpiration || !valid) && touched.ccExpiration;
            return /*#__PURE__*/createElement(Input$5, _objectSpread$H(_objectSpread$H({}, getInputProps()), {}, {
              key: "ccExpiration",
              "aria-invalid": hasError,
              "aria-required": true,
              errorMessage: errMsg,
              hasError: hasError,
              id: "ccExpiration",
              label: paymentStrings.ccExpiration,
              maxLength: 7,
              mr: 1,
              name: "ccExpiration",
              onBlur: handleBlur
            }));
          },
          value: values.ccExpiration
        }), /*#__PURE__*/jsx$1(Cvc, {
          onChange: function onChange(_ref7) {
            var value = _ref7.value,
                valid = _ref7.valid;
            setFieldValue('cvv', value);
            handleCreditCardValidity({
              cvvValid: valid
            });
          },
          render: function render(_ref8) {
            var getInputProps = _ref8.getInputProps,
                valid = _ref8.valid;
            var hasError = (errors.cvv || !valid) && touched.cvv;
            return /*#__PURE__*/createElement(Input$5, _objectSpread$H(_objectSpread$H({}, getInputProps()), {}, {
              key: "cvv",
              "aria-invalid": hasError,
              "aria-required": true,
              errorMessage: errors.cvv || 'CVV is not valid',
              hasError: hasError,
              id: "cvv",
              label: paymentStrings.cvv,
              placeholder: "Security Code",
              name: "cvv",
              onBlur: handleBlur
            }));
          },
          value: values.cvv
        })]
      }), showAlias && /*#__PURE__*/jsx$1(Input$5, {
        "aria-invalid": errors.ccAlias,
        errorMessage: errors.ccAlias,
        hasError: errors.ccAlias && touched.ccAlias,
        id: "ccAlias",
        label: paymentStrings.alias,
        mb: 3,
        name: "ccAlias",
        onBlur: handleBlur,
        onChange: handleChange,
        value: values.ccAlias
      }), /*#__PURE__*/jsx$1(Checkbox, {
        checked: values.makeDefault,
        id: "make-default-checkbox",
        onChange: function onChange(_ref9) {
          var value = _ref9.value;
          setFieldValue('makeDefault', value);
        },
        text: paymentStrings.defaultCardOption
      }), children({
        triggerFormSubmit: function triggerFormSubmit() {
          return formik.handleSubmit(values);
        },
        creditCardInvalid: creditCardInvalid,
        resetForm: resetForm
      })]
    }))
  );
});

var _StyledBox$f = styled(Box$1).withConfig({
  displayName: "credit-card-form___StyledBox",
  componentId: "sc-9fz1ld-0"
})(["& > *{flex:1;}"]);

var _templateObject$n;

function _regenerator$J() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$J(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$J(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$J(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$J(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$J(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$J(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$J(u), _regeneratorDefine2$J(u, o, "Generator"), _regeneratorDefine2$J(u, n, function () {
    return this;
  }), _regeneratorDefine2$J(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$J = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$J(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$J = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$J(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$J(e, r, n, t);
}

var SCRIPT_ID = 'CHARGEBEE_JS_SCRIPT';

function loadAndExecuteScript() {
  if (document.getElementById(SCRIPT_ID)) {
    return Promise.resolve();
  }

  return new Promise(function (resolve) {
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://js.chargebee.com/v2/chargebee.js';
    script.id = SCRIPT_ID;

    script.onload = function () {
      return resolve(true);
    };

    document.head.appendChild(script);
  });
}

function getInitConfig() {
  if (__PROD__) {
    var integrationIds = {
      'rebel.com': {
        site: 'rebelcom',
        publishableKey: 'live_mOw7LcCFU88NZYRKF5I8tbTgswQ2WMzI'
      },
      'rebel.ca': {
        site: 'rebelca',
        publishableKey: 'live_DWFaw0TRNVStp7rvDjPy7wR0U31Y1zAB'
      },
      'internic.ca': {
        site: 'internic',
        publishableKey: 'live_bTgUNScusijj1NqRNhReQ3cHNcurcaojJg'
      }
    };
    return integrationIds[RESELLER.toLowerCase()];
  } // DEV KEY


  return {
    site: 'rebelcom-test',
    publishableKey: 'test_UEImwBzjx4Pknt3fnoemXVpfAEtpcuR48'
  };
}

function ChargebeeForm(_ref) {
  var user = _ref.user,
      onClose = _ref.onClose,
      onTokenCreated = _ref.onTokenCreated,
      customPrimaryAction = _ref.customPrimaryAction;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      hasInit = _useState2[0],
      setHasInit = _useState2[1];

  var _useState3 = useState('unknown'),
      _useState4 = _slicedToArray$4(_useState3, 2),
      cardType = _useState4[0],
      setCardType = _useState4[1];

  var cardRef = useRef(null);
  var validationSchema = create().shape({
    ccFirstName: create$2().min(2, 'Name must be at least 2 characters long').max(50, 'Name cannot be more than 50 characters long').required('Name is required'),
    ccLastName: create$2().min(2, 'Name must be at least 2 characters long').max(50, 'Name cannot be more than 50 characters long').required('Name is required')
  });
  var formik = useFormik({
    initialValues: {
      ccFirstName: (user === null || user === void 0 ? void 0 : user.firstname) || '',
      ccLastName: (user === null || user === void 0 ? void 0 : user.lastname) || ''
    },
    validationSchema: validationSchema,
    onSubmit: function () {
      var _onSubmit = _asyncToGenerator( /*#__PURE__*/_regenerator$J().m(function _callee(values, _ref2) {
        var setSubmitting, setStatus, _yield$cardRef$curren, token;

        return _regenerator$J().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                setSubmitting = _ref2.setSubmitting, setStatus = _ref2.setStatus;

                if (cardRef.current) {
                  _context.n = 1;
                  break;
                }

                return _context.a(2);

              case 1:
                _context.p = 1;
                _context.n = 2;
                return cardRef.current.tokenize({
                  firstName: values.ccFirstName,
                  lastName: values.ccLastName
                });

              case 2:
                _yield$cardRef$curren = _context.v;
                token = _yield$cardRef$curren.token;
                _context.n = 3;
                return onTokenCreated(token, cardType);

              case 3:
                _context.n = 5;
                break;

              case 4:
                _context.p = 4;
                setStatus({
                  success: false
                });

              case 5:
                setSubmitting(false);

              case 6:
                return _context.a(2);
            }
          }
        }, _callee, null, [[1, 4]]);
      }));

      function onSubmit(_x, _x2) {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  });
  var status = formik.status,
      errors = formik.errors,
      touched = formik.touched,
      handleChange = formik.handleChange,
      handleBlur = formik.handleBlur,
      handleSubmit = formik.handleSubmit,
      values = formik.values,
      isSubmitting = formik.isSubmitting;
  useEffect(function () {
    function initCBJS() {
      return _initCBJS.apply(this, arguments);
    }

    function _initCBJS() {
      _initCBJS = _asyncToGenerator( /*#__PURE__*/_regenerator$J().m(function _callee2() {
        return _regenerator$J().w(function (_context2) {
          while (1) {
            switch (_context2.n) {
              case 0:
                if (!document.getElementById(SCRIPT_ID)) {
                  _context2.n = 1;
                  break;
                }

                setHasInit(true);
                return _context2.a(2);

              case 1:
                _context2.n = 2;
                return loadAndExecuteScript();

              case 2:
                if (window.Chargebee) {
                  window.Chargebee.init(getInitConfig());
                  setHasInit(true);
                }

              case 3:
                return _context2.a(2);
            }
          }
        }, _callee2);
      }));
      return _initCBJS.apply(this, arguments);
    }

    initCBJS();
  }, []);
  return /*#__PURE__*/jsx$1(Stack$2, {
    alignItems: "center",
    width: "100%",
    py: 1,
    children: hasInit ? /*#__PURE__*/jsx$1(Stack$2, {
      alignItems: "center",
      width: "100%",
      children: /*#__PURE__*/jsx$1(Stack$2, {
        width: "100%",
        children: /*#__PURE__*/jsxs("form", {
          onSubmit: handleSubmit,
          children: [/*#__PURE__*/jsx$1(Input$5, {
            id: "ccFirstName",
            "aria-invalid": errors.ccFirstName,
            errorMessage: errors.ccFirstName,
            hasError: errors.ccFirstName && touched.ccFirstName,
            label: "First Name on Card",
            name: "ccFirstName",
            onBlur: handleBlur,
            onChange: handleChange,
            value: values.ccFirstName
          }), /*#__PURE__*/jsx$1(Input$5, {
            id: "ccLastName",
            "aria-invalid": errors.ccLastName,
            errorMessage: errors.ccLastName,
            hasError: errors.ccLastName && touched.ccLastName,
            label: "Last Name on Card",
            name: "ccLastName",
            onBlur: handleBlur,
            onChange: handleChange,
            value: values.ccLastName
          }), /*#__PURE__*/jsx$1(CardComponent, {
            styles: {
              base: {
                '::placeholder': {
                  color: '#a4a4a4'
                }
              },
              invalid: {
                fontWeight: 700
              }
            },
            ref: cardRef,
            children: /*#__PURE__*/jsxs(_StyledGrid$2, {
              children: [/*#__PURE__*/jsxs("div", {
                children: [/*#__PURE__*/jsx$1(Text$1, {
                  fontWeight: 700,
                  children: "Card Number"
                }), /*#__PURE__*/jsx$1(CardNumber, {
                  onBlur: function onBlur(e) {
                    if (e.cardType) {
                      setCardType(e.cardType);
                    }
                  },
                  placeholder: "4111 1111 1111 1111"
                })]
              }), /*#__PURE__*/jsxs("div", {
                children: [/*#__PURE__*/jsx$1(Text$1, {
                  fontWeight: 700,
                  children: "Expiry Date"
                }), /*#__PURE__*/jsx$1(CardExpiry, {
                  icon: true,
                  placeholder: "01 / 28"
                })]
              }), /*#__PURE__*/jsxs("div", {
                children: [/*#__PURE__*/jsx$1(Text$1, {
                  fontWeight: 700,
                  children: "CVV"
                }), /*#__PURE__*/jsx$1(CardCVV, {
                  placeholder: "123"
                })]
              })]
            })
          }), /*#__PURE__*/jsxs(_StyledBox$e, {
            justifyContent: "space-between",
            width: "100%",
            mt: 4,
            $_css: customPrimaryAction ? '600' : '400',
            $_css2: customPrimaryAction ? '1.5rem' : '1.3rem',
            children: [/*#__PURE__*/jsx$1(Button$1, {
              color: isInternic ? 'blueDark' : 'deepKoamaru',
              type: "submit",
              disabled: isSubmitting,
              children: customPrimaryAction || 'Add Card'
            }), !customPrimaryAction && /*#__PURE__*/jsx$1(Button$1, {
              onClick: onClose,
              color: isInternic ? 'blueDark' : 'deepKoamaru',
              variant: "inverse",
              disabled: isSubmitting,
              children: "Cancel"
            })]
          }), (status === null || status === void 0 ? void 0 : status.success) === false && /*#__PURE__*/jsx$1(Text$1, {
            display: "flex",
            p: 3,
            mt: 3,
            color: "destructive-600",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "destructive-100",
            border: "1px solid",
            borderColor: "destructive-600",
            borderRadius: "8px",
            children: "Unexpected error."
          })]
        })
      })
    }) : /*#__PURE__*/jsx$1(Skeleton$1, {})
  });
}

var _StyledGrid$2 = styled(Grid$1)(_templateObject$n || (_templateObject$n = _taggedTemplateLiteral$1(["\n                    display: grid;\n                    grid-template-columns: 1fr 1fr;\n                    grid-gap: 8px;\n                    margin-top: 8px;\n                    transition: 0.2s;\n\n                    & > div {\n                      width: 100%;\n                      padding: 4px;\n                      border: 1px solid #d7d7d7;\n\n                      &:first-child {\n                        grid-column: span 2;\n                      }\n                    }\n                  "])));

var _StyledBox$e = styled(Box$1).withConfig({
  displayName: "chargebee-form___StyledBox",
  componentId: "sc-om4u4s-0"
})(["gap:12px;& > button{flex:1;font-weight:", ";font-size:", ";}"], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
});

var _templateObject$m, _templateObject2$e, _templateObject3$8, _templateObject4$5, _templateObject5$3, _templateObject6$2, _templateObject7$2, _templateObject8$2, _templateObject9$1, _templateObject0, _templateObject1;

function _regenerator$I() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$I(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$I(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$I(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$I(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$I(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$I(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$I(u), _regeneratorDefine2$I(u, o, "Generator"), _regeneratorDefine2$I(u, n, function () {
    return this;
  }), _regeneratorDefine2$I(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$I = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$I(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$I = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$I(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$I(e, r, n, t);
}

function formatMonth(expiryMonth) {
  if (expiryMonth.length === 1) {
    return "0".concat(expiryMonth);
  }

  return expiryMonth;
}

function paypalSvg() {
  return /*#__PURE__*/jsx$1("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "100",
    height: "70",
    viewBox: "0 0 154.728 190.5",
    children: /*#__PURE__*/jsxs("g", {
      transform: "translate(898.192 276.071)",
      children: [/*#__PURE__*/jsx$1("path", {
        clipPath: "none",
        d: "M-837.663-237.968a5.49 5.49 0 0 0-5.423 4.633l-9.013 57.15-8.281 52.514-.005.044.01-.044 8.281-52.514c.421-2.669 2.719-4.633 5.42-4.633h26.404c26.573 0 49.127-19.387 53.246-45.658.314-1.996.482-3.973.52-5.924v-.003h-.003c-6.753-3.543-14.683-5.565-23.372-5.565z",
        fill: "#001c64"
      }), /*#__PURE__*/jsx$1("path", {
        clipPath: "none",
        d: "M-766.506-232.402c-.037 1.951-.207 3.93-.52 5.926-4.119 26.271-26.673 45.658-53.246 45.658h-26.404c-2.701 0-4.999 1.964-5.42 4.633l-8.281 52.514-5.197 32.947a4.46 4.46 0 0 0 4.405 5.153h28.66a5.49 5.49 0 0 0 5.423-4.633l7.55-47.881c.423-2.669 2.722-4.636 5.423-4.636h16.876c26.573 0 49.124-19.386 53.243-45.655 2.924-18.649-6.46-35.614-22.511-44.026z",
        fill: "#0070e0"
      }), /*#__PURE__*/jsx$1("path", {
        clipPath: "none",
        d: "M-870.225-276.071a5.49 5.49 0 0 0-5.423 4.636l-22.489 142.608a4.46 4.46 0 0 0 4.405 5.156h33.351l8.281-52.514 9.013-57.15a5.49 5.49 0 0 1 5.423-4.633h47.782c8.691 0 16.621 2.025 23.375 5.563.46-23.917-19.275-43.666-46.412-43.666z",
        fill: "#003087"
      })]
    })
  });
}

function CcView(_ref) {
  var selected = _ref.selected,
      setSelected = _ref.setSelected;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isFormOpen = _useState2[0],
      setIsFormOpen = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray$4(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray$4(_useState5, 2),
      isSwitchingCardRole = _useState6[0],
      setIsSwitchingCardRole = _useState6[1];

  var _useState7 = useState({
    cardId: null,
    showConfirm: false,
    isDeleting: false
  }),
      _useState8 = _slicedToArray$4(_useState7, 2),
      confirmDelete = _useState8[0],
      setConfirmDelete = _useState8[1];

  var _useUserService = useUserService(),
      user = _useUserService.user,
      fetchUserInfo = _useUserService.fetchUserInfo,
      isLoading = _useUserService.isLoading;

  var creditCards = (user === null || user === void 0 ? void 0 : user.creditCards) || undefined;
  var hasNoPaymentMethods = !creditCards || creditCards.length === 0;

  function onTokenCreated(_x, _x2) {
    return _onTokenCreated.apply(this, arguments);
  }

  function _onTokenCreated() {
    _onTokenCreated = _asyncToGenerator( /*#__PURE__*/_regenerator$I().m(function _callee(token, cardType) {
      return _regenerator$I().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              _context.n = 1;
              return post$1(creditCardEndpoints.card, {
                chargebeeToken: token,
                type: cardType
              });

            case 1:
              _context.n = 2;
              return fetchUserInfo();

            case 2:
              setIsFormOpen(false);

            case 3:
              return _context.a(2);
          }
        }
      }, _callee);
    }));
    return _onTokenCreated.apply(this, arguments);
  }

  function deletePaymentSource(_x3) {
    return _deletePaymentSource.apply(this, arguments);
  }

  function _deletePaymentSource() {
    _deletePaymentSource = _asyncToGenerator( /*#__PURE__*/_regenerator$I().m(function _callee2(paymentSourceId) {
      var _t, _t2;

      return _regenerator$I().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              setErrorMessage('');
              setConfirmDelete({
                cardId: paymentSourceId,
                showConfirm: true,
                isDeleting: true
              });
              _context2.p = 1;
              _context2.n = 2;
              return del$1("".concat(creditCardEndpoints.card, "/").concat(paymentSourceId));

            case 2:
              _context2.n = 3;
              return fetchUserInfo();

            case 3:
              _context2.n = 7;
              break;

            case 4:
              _context2.p = 4;
              _t = _context2.v;
              _t2 = _t.response.status;
              _context2.n = _t2 === 402 ? 5 : 6;
              break;

            case 5:
              setErrorMessage(_t.response.data);
              return _context2.a(3, 7);

            case 6:
              setErrorMessage('Failed to delete payment method.');

            case 7:
              setConfirmDelete({
                cardId: null,
                showConfirm: false,
                isDeleting: false
              });

            case 8:
              return _context2.a(2);
          }
        }
      }, _callee2, null, [[1, 4]]);
    }));
    return _deletePaymentSource.apply(this, arguments);
  }

  function updatePrimaryPaymentSource(_x4) {
    return _updatePrimaryPaymentSource.apply(this, arguments);
  }

  function _updatePrimaryPaymentSource() {
    _updatePrimaryPaymentSource = _asyncToGenerator( /*#__PURE__*/_regenerator$I().m(function _callee3(paymentSourceId) {
      return _regenerator$I().w(function (_context3) {
        while (1) {
          switch (_context3.n) {
            case 0:
              setErrorMessage('');
              setIsSwitchingCardRole(true);
              _context3.p = 1;
              _context3.n = 2;
              return put$1("".concat(creditCardEndpoints["default"], "/").concat(paymentSourceId));

            case 2:
              _context3.n = 3;
              return fetchUserInfo();

            case 3:
              _context3.n = 5;
              break;

            case 4:
              _context3.p = 4;
              setErrorMessage('Failed to set primary payment method.');

            case 5:
              setIsSwitchingCardRole(false);

            case 6:
              return _context3.a(2);
          }
        }
      }, _callee3, null, [[1, 4]]);
    }));
    return _updatePrimaryPaymentSource.apply(this, arguments);
  }

  function updateBackupPaymentSource(_x5) {
    return _updateBackupPaymentSource.apply(this, arguments);
  }

  function _updateBackupPaymentSource() {
    _updateBackupPaymentSource = _asyncToGenerator( /*#__PURE__*/_regenerator$I().m(function _callee4(paymentSourceId) {
      return _regenerator$I().w(function (_context4) {
        while (1) {
          switch (_context4.n) {
            case 0:
              setErrorMessage('');
              setIsSwitchingCardRole(true);
              _context4.p = 1;
              _context4.n = 2;
              return put$1("".concat(creditCardEndpoints.backup, "/").concat(paymentSourceId));

            case 2:
              _context4.n = 3;
              return fetchUserInfo();

            case 3:
              _context4.n = 5;
              break;

            case 4:
              _context4.p = 4;
              setErrorMessage('Failed to set backup payment method.');

            case 5:
              setIsSwitchingCardRole(false);

            case 6:
              return _context4.a(2);
          }
        }
      }, _callee4, null, [[1, 4]]);
    }));
    return _updateBackupPaymentSource.apply(this, arguments);
  }

  function ccFace(cc) {
    var _cc$ccNumber;

    var ccType = cc.ccType,
        ccMonthExpiry = cc.ccMonthExpiry,
        ccYearExpiry = cc.ccYearExpiry,
        ccName = cc.ccName,
        paypalEmail = cc.paypalEmail;
    cc.id;
    var ccNumber = (_cc$ccNumber = cc.ccNumber) === null || _cc$ccNumber === void 0 ? void 0 : _cc$ccNumber.replace(/\*/g, '•');
    return cc.paymentType === 'PaypalExpressCheckout' ? /*#__PURE__*/jsxs(Fragment, {
      children: [paypalSvg(), /*#__PURE__*/jsx$1(Stack$2, {
        justifyContent: "center",
        alignItems: "center",
        children: /*#__PURE__*/jsx$1(Text$1, {
          color: "#5c5c5c",
          fontSize: "1.2rem",
          children: paypalEmail
        })
      })]
    }) : /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx$1(Icon$2, {
        alignSelf: "center",
        height: "8rem",
        mr: "2" // Replace is for "american_express"
        ,
        name: ccType === null || ccType === void 0 ? void 0 : ccType.toLowerCase().replace('_', ' '),
        title: ccType,
        width: "8rem"
      }), /*#__PURE__*/jsxs(Stack$2, {
        justifyContent: "center",
        alignItems: "center",
        children: [/*#__PURE__*/jsx$1(Text$1, {
          color: "#5c5c5c",
          fontSize: "1.6rem",
          children: ccName
        }), /*#__PURE__*/jsxs(Text$1, {
          color: "#5c5c5c",
          fontSize: "1.2rem",
          children: [ccNumber, " | ", formatMonth(ccMonthExpiry || ''), "/", ccYearExpiry]
        })]
      })]
    });
  }

  function getCard(cc) {
    var _cc$ccType;

    var isPrimary = cc.isPrimary === 'True';
    var isBackup = cc.isBackup === 'True';
    return /*#__PURE__*/jsx$1(_StyledBox$d, {
      onClick: function onClick() {
        if (setSelected) {
          setSelected(cc.id);
        }
      },
      border: 1,
      borderColor: selected && selected === cc.id && 'blue',
      justifyContent: "space-between",
      p: 2,
      position: "relative",
      $_css: selected && setSelected && "\n          &:hover {\n            cursor: pointer;\n          }\n        ",
      children: confirmDelete.showConfirm && confirmDelete.cardId === cc.id ? /*#__PURE__*/jsxs(_StyledStack$e, {
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        children: [/*#__PURE__*/jsx$1(Text$1, {
          fontWeight: 400,
          fontSize: "1.5rem",
          display: "flex",
          alignItems: "center",
          children: cc.paymentType === 'PaypalExpressCheckout' ? /*#__PURE__*/jsxs(Fragment, {
            children: [paypalSvg(), cc.paypalEmail]
          }) : /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx$1(Icon$2 // Replace is for "american_express"
            , {
              name: (_cc$ccType = cc.ccType) === null || _cc$ccType === void 0 ? void 0 : _cc$ccType.toLowerCase().replace('_', ' '),
              height: "4rem",
              width: "4rem",
              mr: "2",
              alignSelf: "center",
              title: cc.ccType
            }), cc.ccNumber]
          })
        }), /*#__PURE__*/jsxs(Box$1, {
          width: "100%",
          justifyContent: "space-between",
          children: [/*#__PURE__*/jsx$1(Button$1, {
            width: "45%",
            onClick: function onClick() {
              return setConfirmDelete({
                cardId: null,
                showConfirm: false,
                isDeleting: false
              });
            },
            color: "red",
            variant: "inverse",
            disabled: confirmDelete.isDeleting,
            children: "Cancel"
          }), /*#__PURE__*/jsx$1(Button$1, {
            onClick: function onClick() {
              return deletePaymentSource(cc.id);
            },
            width: "45%",
            color: "red",
            disabled: confirmDelete.isDeleting,
            children: "Delete Card"
          })]
        })]
      }) : /*#__PURE__*/jsxs(Fragment, {
        children: [ccFace(cc), (isPrimary || isBackup) && /*#__PURE__*/jsxs(_StyledBox2$5, {
          children: [isPrimary && /*#__PURE__*/jsx$1(Star, {
            fill: "black",
            size: 12,
            children: /*#__PURE__*/jsx$1("title", {
              children: "This is your primary payment method"
            })
          }), isBackup && /*#__PURE__*/jsx$1(Shield, {
            fill: "black",
            size: 12,
            children: /*#__PURE__*/jsx$1("title", {
              children: "This is your backup payment method"
            })
          })]
        }), /*#__PURE__*/jsx$1(Popover$1, {
          trigger: /*#__PURE__*/jsx$1(EllipsisVertical, {}),
          children: /*#__PURE__*/jsxs(_StyledStack2$1, {
            children: [/*#__PURE__*/jsx$1(_StyledBox3$2, {
              mb: 2,
              children: "Card Options"
            }), /*#__PURE__*/jsxs(_StyledBox4$1, {
              p: 1,
              justifyContent: "space-between",
              alignItems: "center",
              onClick: function onClick() {
                if (!isPrimary && !isSwitchingCardRole) {
                  updatePrimaryPaymentSource(cc.id);
                }
              },
              $_css2: isPrimary ? 'default' : 'pointer',
              $_css3: isPrimary ? 0.5 : 1,
              children: ["Set as primary", isPrimary && /*#__PURE__*/jsx$1(Check$1, {})]
            }), /*#__PURE__*/jsxs(_StyledBox5$1, {
              p: 1,
              mt: 1,
              justifyContent: "space-between",
              alignItems: "center",
              onClick: function onClick() {
                if (!isBackup && !isPrimary && !isSwitchingCardRole) {
                  updateBackupPaymentSource(cc.id);
                }
              },
              $_css4: isBackup || isPrimary ? 'default' : 'pointer',
              $_css5: isBackup || isPrimary ? 0.5 : 1,
              children: ["Set as backup", isBackup && /*#__PURE__*/jsx$1(Check$1, {})]
            }), /*#__PURE__*/jsx$1(_StyledBox6$1, {}), /*#__PURE__*/jsx$1(_StyledBox7$1, {
              p: 1,
              justifyContent: "space-between",
              onClick: function onClick() {
                setConfirmDelete({
                  cardId: cc.id,
                  showConfirm: true,
                  isDeleting: false
                });
              },
              children: "Delete Card"
            })]
          })
        })]
      })
    }, cc.id);
  }

  return /*#__PURE__*/jsx$1(_StyledStack3$1, {
    my: 3,
    children: isLoading ? /*#__PURE__*/jsx$1(Skeleton$1, {
      height: "10rem",
      mb: 2,
      width: "100%"
    }) : /*#__PURE__*/jsxs(Fragment, {
      children: [errorMessage && /*#__PURE__*/jsx$1(Stack$2, {
        width: "100%",
        maxWidth: "400px",
        children: /*#__PURE__*/jsx$1(Message, {
          variant: "error",
          children: errorMessage
        })
      }), creditCards === null || creditCards === void 0 ? void 0 : creditCards.map(function (cc) {
        return getCard(cc);
      }), !isFormOpen && /*#__PURE__*/jsx$1(Box$1, {
        width: "100%",
        mt: 2,
        children: /*#__PURE__*/jsx$1(Button$1, {
          color: "blueDark",
          id: "replace-payment-method",
          onClick: function onClick() {
            return setIsFormOpen(true);
          },
          width: "100%",
          children: "Add Payment Method"
        })
      }), isFormOpen && /*#__PURE__*/jsxs(_StyledStack4, {
        borderTop: "light",
        pt: 4,
        pb: 2,
        mt: 4,
        children: [/*#__PURE__*/jsx$1(ChargebeeForm, {
          onClose: function onClose() {
            return setIsFormOpen(false);
          },
          user: user,
          onTokenCreated: onTokenCreated
        }), /*#__PURE__*/jsx$1(Divider, {
          my: 3,
          children: "or"
        }), /*#__PURE__*/jsx$1(_StyledPayPalButton, {
          payPal: {
            cancelUrl: '/my-account/settings/payment',
            returnUrl: '/my-account/settings/payment'
          },
          children: /*#__PURE__*/jsx$1(Icon$2, {
            name: "paypal",
            alignSelf: "center",
            width: "16rem",
            height: "3rem"
          })
        }), hasNoPaymentMethods && /*#__PURE__*/jsx$1(Message, {
          variant: "warning",
          children: "Any outstanding balance on your account will be charged"
        })]
      })]
    })
  });
}

var _StyledBox$d = styled(Box$1)(_templateObject$m || (_templateObject$m = _taggedTemplateLiteral$1(["", ""])), function (p) {
  return p.$_css;
});

var _StyledStack$e = styled(Stack$2)(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteral$1(["\n              gap: 8px;\n            "])));

var _StyledBox2$5 = styled(Box$1)(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteral$1(["\n                  position: absolute;\n                  top: 5px;\n                  left: 5px;\n                "])));

var _StyledStack2$1 = styled(Stack$2)(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteral$1(["\n                  min-width: 180px;\n                "])));

var _StyledBox3$2 = styled(Box$1)(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral$1(["\n                    font-weight: 700;\n                  "])));

var _StyledBox4$1 = styled(Box$1)(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral$1(["\n                    gap: 2.5rem;\n                    border-radius: 0.5rem;\n                    transition: 0.2s;\n                    cursor: ", ";\n                    opacity: ", ";\n                    &:hover {\n                      background: rgba(0, 0, 0, 0.1);\n                    }\n                  "])), function (p) {
  return p.$_css2;
}, function (p) {
  return p.$_css3;
});

var _StyledBox5$1 = styled(Box$1)(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteral$1(["\n                    gap: 2.5rem;\n                    border-radius: 0.5rem;\n                    transition: 0.2s;\n                    cursor: ", ";\n                    opacity: ", ";\n                    &:hover {\n                      background: rgba(0, 0, 0, 0.1);\n                    }\n                  "])), function (p) {
  return p.$_css4;
}, function (p) {
  return p.$_css5;
});

var _StyledBox6$1 = styled(Box$1)(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteral$1(["\n                    margin-top: 1rem;\n                    margin-bottom: 1rem;\n                    border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n                  "])));

var _StyledBox7$1 = styled(Box$1)(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral$1(["\n                    color: red;\n                    border-radius: 0.5rem;\n                    transition: 0.2s;\n                    cursor: pointer;\n                    &:hover {\n                      background: rgba(255, 0, 0, 0.1);\n                    }\n                  "])));

var _StyledStack3$1 = styled(Stack$2)(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral$1(["\n        gap: 4px;\n      "])));

var _StyledStack4 = styled(Stack$2)(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral$1(["\n                gap: 6px;\n              "])));

var _StyledPayPalButton = styled(PayPalButton).withConfig({
  displayName: "cc-view___StyledPayPalButton",
  componentId: "sc-1qmu2i1-0"
})(["border-radius:1000px;background:#fec43a;border:none;&:hover{background:#eeb329;}"]);

function ownKeys$G(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$G(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$G(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$G(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var propTypes$F = {
  strings: PropTypes.shape({
    addPaymentMaintenance: PropTypes.string,
    addPaymentMethod: PropTypes.string,
    cancel: PropTypes.string,
    continuePayPal: PropTypes.string,
    save: PropTypes.string,
    secondPaypalAccount: PropTypes.string
  }).isRequired
};
var PaymentView = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _useContactService = useContactService(),
      contact = _useContactService.contact,
      createContact = _useContactService.createContact;

  props.strings;
  props.contactRef;
  var selectedCardId = props.selectedCardId,
      setSelectedCardId = props.setSelectedCardId;
  var recaptcha = useRef(null);

  var _useCreditCardService = useCreditCardService(),
      addCardNoReload = _useCreditCardService.addCardNoReload,
      addCard = _useCreditCardService.addCard,
      hasAddCardError = _useCreditCardService.hasAddCardError,
      isAddCardSuccessful = _useCreditCardService.isAddCardSuccessful;

  _useCreditCardService.isAddCardLoading;
  var addCardMaxRetriesReached = _useCreditCardService.addCardMaxRetriesReached;
  _useCreditCardService.addCardErrorMessage;
  _useCreditCardService.defaultCardId;
  var selectPaymentOption = _useCreditCardService.selectPaymentOption;
  _useCreditCardService.isNewCard;
  var setNewCard = _useCreditCardService.setNewCard;

  var _useUserService = useUserService(),
      user = _useUserService.user,
      isNewUser = _useUserService.isNew;

  var _useState = useState(user === null || user === void 0 ? void 0 : user.creditCards),
      _useState2 = _slicedToArray$4(_useState, 2),
      creditCards = _useState2[0],
      setCreditCards = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray$4(_useState3, 2),
      cardData = _useState4[0];

  _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray$4(_useState5, 2),
      recaptchaResp = _useState6[0];

  _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray$4(_useState7, 2),
      paymentMethod = _useState8[0],
      setPaymentMethod = _useState8[1];

  var _useState9 = useState(null),
      _useState0 = _slicedToArray$4(_useState9, 2),
      payPalToken = _useState0[0],
      setPayPalToken = _useState0[1];

  var _useState1 = useState(null),
      _useState10 = _slicedToArray$4(_useState1, 2),
      defaultCCindex = _useState10[0],
      setDefaultCCindex = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray$4(_useState11, 2),
      creditCardOptions = _useState12[0],
      setCreditCardOptions = _useState12[1];

  var _useState13 = useState([]),
      _useState14 = _slicedToArray$4(_useState13, 2);

  _useState14[0];
  var setPayPalOptions = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray$4(_useState15, 2);

  _useState16[0];
  _useState16[1];

  var _useState17 = useState(creditCardOptions[defaultCCindex]),
      _useState18 = _slicedToArray$4(_useState17, 2),
      cardPaymentChoice = _useState18[0],
      setCardPaymentChoice = _useState18[1];

  var _useState19 = useState(null),
      _useState20 = _slicedToArray$4(_useState19, 2),
      paypalPaymentChoice = _useState20[0],
      setPayPalPaymentChoice = _useState20[1];

  var _useState21 = useState(false),
      _useState22 = _slicedToArray$4(_useState21, 2),
      submitPayPalContact = _useState22[0],
      setSubmitPayPalContact = _useState22[1];

  creditCards ? creditCards.some(function (card) {
    return card.ccType === paymentTypes.paypal;
  }) : false;
  useEffect(function () {
    if (submitPayPalContact) {
      var payload = createContactPayload(contact.selectedContact, isNewUser);
      createContact(payload, isNewUser);
    }

    setSubmitPayPalContact(false);
  }, [contact.addNew]);
  useEffect(function () {
    if (cardData && recaptchaResp) {
      var _recaptcha$current;

      addCardNoReload(hasAddCardError, {
        card: cardData,
        user: user,
        recaptchaResponse: recaptchaResp
      });
      recaptcha === null || recaptcha === void 0 ? void 0 : (_recaptcha$current = recaptcha.current) === null || _recaptcha$current === void 0 ? void 0 : _recaptcha$current.reset();
    }
  }, [recaptchaResp, cardData]);

  var renderIcon = function renderIcon(ccType) {
    switch (ccType) {
      case 'MasterCard':
        return /*#__PURE__*/jsx$1(Icon$2, {
          mr: 3,
          name: "mastercard",
          title: "mastercard",
          width: "3rem"
        });

      case 'Visa':
        return /*#__PURE__*/jsx$1(Icon$2, {
          mr: 3,
          name: "visa",
          title: "visa",
          width: "3rem"
        });

      case 'American Express':
        return /*#__PURE__*/jsx$1(Icon$2, {
          mr: 3,
          name: "americanExpress",
          title: "american express",
          width: "3rem"
        });

      case 'PayPal':
        return /*#__PURE__*/jsx$1(Icon$2, {
          mr: 3,
          name: "paypal",
          title: "paypal",
          width: "6rem"
        });

      default:
        return /*#__PURE__*/jsx$1(Icon$2, {
          mr: 3,
          name: "money",
          title: "other",
          width: "3rem"
        });
    }
  };

  var renderPaymentInfo = function renderPaymentInfo(cc) {
    return cc.ccType === 'PayPal' ? "".concat(cc.ccName) : "Ending in ".concat(cc.ccNumber, " - Exp ").concat(cc.ccMonthExpiry, "/\n      ").concat(cc.ccYearExpiry);
  };

  useEffect(function () {
    if ((creditCards === null || creditCards === void 0 ? void 0 : creditCards.length) > 0) {
      var ccOptions = [];
      var ppOptions = [];
      creditCards.forEach(function (cc, index) {
        var paymentOption = {
          fulldata: cc,
          value: cc.id,
          label: /*#__PURE__*/jsxs("div", {
            style: {
              display: 'flex',
              alignItems: 'center'
            },
            children: [renderIcon(cc.ccType), /*#__PURE__*/jsx$1(Text$1, {
              fontFamily: "body",
              mt: "0.5rem",
              children: renderPaymentInfo(cc)
            })]
          })
        };

        if (cc.ccType === 'PayPal') {
          ppOptions.push(paymentOption);
          setPayPalPaymentChoice(paymentOption.fulldata);

          if (cc.isDefault === 'True') {
            setDefaultCCindex(ppOptions.length - 1);
            selectPaymentOption(paymentOption.fulldata);
            setPaymentMethod(paymentTypes.paypal);
          }

          if (payPalToken) {
            selectPaymentOption(paymentOption.fulldata);
            setPaymentMethod(paymentTypes.paypal);
          }
        } else {
          ccOptions.push(paymentOption);

          if (cc.isDefault === 'True') {
            setDefaultCCindex(ccOptions.length - 1);
            setCardPaymentChoice(cc);
            selectPaymentOption(cc);
            setPaymentMethod(paymentTypes.creditCard);
          }
        }
      });
      setCreditCardOptions(ccOptions);
      setPayPalOptions(ppOptions);
      setNewCard(false);
    } else {
      setPaymentMethod(paymentTypes.creditCard);
      setNewCard(true);
    }
  }, [creditCards]);
  useEffect(function () {
    setCreditCards(user === null || user === void 0 ? void 0 : user.creditCards); // This way of selected card ID is only for Chargebee, new work.

    if (selectedCardId === undefined) {
      var _user$creditCards;

      var primaryCard = user === null || user === void 0 ? void 0 : (_user$creditCards = user.creditCards) === null || _user$creditCards === void 0 ? void 0 : _user$creditCards.find(function (cc) {
        return cc.isPrimary === 'True';
      });

      if (primaryCard) {
        setSelectedCardId(primaryCard.id);
      } else {
        setSelectedCardId(null);
      }
    }
  }, [user === null || user === void 0 ? void 0 : user.creditCards]);
  useEffect(function () {
    if (hasDOM) {
      var decoded = decodeURIComponent(window.location.search);

      var token = _get(queryString.parse(decoded), 'token');

      if (token) {
        setPayPalToken(token);
        setNewCard(true);
      }
    }
  }, []);
  useEffect(function () {
    if (payPalToken) {
      addCard(hasAddCardError, {
        card: _objectSpread$G(_objectSpread$G({}, cardData), {}, {
          payPalToken: payPalToken,
          type: paymentTypes.paypal
        }),
        user: user
      });
    }
  }, [payPalToken]);
  useEffect(function () {
    if (isAddCardSuccessful) {
      setNewCard(false);
    }
  }, [isAddCardSuccessful]);
  useEffect(function () {
    if (addCardMaxRetriesReached) {
      setNewCard(false);
    }
  }, [addCardMaxRetriesReached]);
  useEffect(function () {
    selectPaymentOption(paymentMethod === paymentTypes.paypal ? paypalPaymentChoice : cardPaymentChoice);
  }, [paymentMethod]);
  return /*#__PURE__*/jsxs(Stack$2, {
    width: "100%",
    children: [/*#__PURE__*/jsx$1(Heading, {
      variant: "gigaBold",
      mb: 1,
      children: "Payment Method"
    }), /*#__PURE__*/jsx$1(CcView, {
      selected: selectedCardId,
      setSelected: setSelectedCardId
    })]
  });
});
PaymentView.propTypes = propTypes$F;

function _regenerator$H() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$H(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$H(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$H(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$H(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$H(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$H(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$H(u), _regeneratorDefine2$H(u, o, "Generator"), _regeneratorDefine2$H(u, n, function () {
    return this;
  }), _regeneratorDefine2$H(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$H = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$H(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$H = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$H(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$H(e, r, n, t);
}

var errorStrings = {
  orderError: 'There is a problem processing your order. Please try again or contact customer support.',
  selectBillingOption: 'Please select a billing option from the dropdown, or add a new card to your account',
  selectAContact: 'Please choose another contact or create a new one.',
  billingError: 'There is a problem with your payment option. You can update your payment in your Payment Settings, choose another payment option or create a new one.',
  contactNeedsUpdating: 'There is a problem with this contact. You can update your contact in your Contact Manager, choose another contact or create a new one.',
  contactAddingError: 'There was a problem adding your contact. Please try again or contact customer support.',
  ownershipProtectionError: 'Contact cannot be updated due to ownership protection.',
  ownershipProtectionUserMessage: 'Due to ownership protection we could not update your contact information. Please choose another contact or contact customer support for assistance.',
  noItem: 'Please add an item to your cart.',
  noPaymentMethod: 'Your account does not have a payment method set, please create one using the form above.',
  cartThreshold: 'Your cart has exceeded the maximum checkout limit. Please contact customer support to assist you with your purchase.'
};
var ProcessOrder = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var selectedCardId = _ref.selectedCardId;

  var _useOrderService = useOrderService(),
      order = _useOrderService.order;

  var currency = getCurrencyByCode(LS.getItem(storageKeys.Currency));

  var _useContactService = useContactService(),
      contact = _useContactService.contact,
      setContactSuccessful = _useContactService.setContactSuccessful;

  var _useCreditCardService = useCreditCardService(),
      paymentOption = _useCreditCardService.paymentOption,
      isNewCard = _useCreditCardService.isNewCard,
      isAddCardSuccessful = _useCreditCardService.isAddCardSuccessful,
      hasAddCardError = _useCreditCardService.hasAddCardError;

  var _useUserService = useUserService(),
      isNewUser = _useUserService.isNew,
      user = _useUserService.user;

  var _useState = useState(),
      _useState2 = _slicedToArray$4(_useState, 2),
      cardId = _useState2[0],
      setCardId = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray$4(_useState3, 2),
      contactId = _useState4[0],
      setContactId = _useState4[1];

  var _React$useState = React__default.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      contactProcessed = _React$useState2[0],
      setContactProcessed = _React$useState2[1]; // step 1: contact, step 2: billing, step 3: order


  var _React$useState3 = React__default.useState(false),
      _React$useState4 = _slicedToArray$4(_React$useState3, 2),
      billingProcessed = _React$useState4[0],
      setBillingProcessed = _React$useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray$4(_useState5, 2),
      formErrors = _useState6[0],
      setError = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray$4(_useState7, 2),
      loading = _useState8[0],
      setLoading = _useState8[1];

  var context = paymentOption.context;
  var IsAddContactSuccessful = contact.success;
  var _ref$current = ref.current,
      contactRef = _ref$current.contactRef,
      paymentRef = _ref$current.paymentRef,
      surveyRef = _ref$current.surveyRef;

  if ((user === null || user === void 0 ? void 0 : user.status) === 'On Hold') {
    if (hasDOM) {
      window.location = '/OnHold.aspx';
    }
  }

  var _useOrderQuery = useOrderQuery(),
      useProcessOrder = _useOrderQuery.useProcessOrder;

  _useOrderQuery.order;

  if (!formErrors) {
    var _order$totals;

    if ((order === null || order === void 0 ? void 0 : (_order$totals = order.totals) === null || _order$totals === void 0 ? void 0 : _order$totals.total) > (user === null || user === void 0 ? void 0 : user.cartThreshold)) {
      setError(errorStrings.cartThreshold);
    }
  }

  var _useProcessOrder = useProcessOrder({
    onCompleted: function onCompleted() {
      window.location.href = "/MyAccount/ProcessOrder.aspx?betacart=true";
    },
    onError: function onError() {
      setError(errorStrings.orderError);
      setLoading(false);
      tracker$1('Client Error', {
        type: 'process-order',
        location: 'use-process-order',
        orderId: order.id,
        order: order,
        cardId: cardId,
        contactId: contactId,
        currency: currency.code.toUpperCase(),
        error: error
      });
    }
  }),
      _useProcessOrder2 = _slicedToArray$4(_useProcessOrder, 2),
      processOrder = _useProcessOrder2[0],
      error = _useProcessOrder2[1].error;

  var processEntireOrder = function processEntireOrder() {
    try {
      if (surveyRef.current) {
        tracker$1(ANALYTICS_EVENTS.checkout, {
          type: 'Survey / Checkout',
          surveyAnswers: {
            surveyType: 'Checkout',
            reason: surveyRef.current
          }
        });
      }

      processOrder({
        variables: {
          id: order.id,
          cardId: cardId ? String(cardId) : cardId,
          contactId: contactId,
          currency: currency.code.toUpperCase(),
          tracking: {
            order: order,
            customerId: contactId,
            currency: currency
          }
        }
      });
    } catch (_unused) {
      setError(errorStrings.orderError);
      setLoading(false);
    }
  };

  var processBillingInformation = function processBillingInformation() {
    try {
      var _order$items;

      if ((order === null || order === void 0 ? void 0 : (_order$items = order.items) === null || _order$items === void 0 ? void 0 : _order$items.length) < 1) {
        throw new Error(errorStrings.noItem);
      }

      if (!context.selectedPaymentOptions) {
        var _user$features;

        if (!(user !== null && user !== void 0 && (_user$features = user.features) !== null && _user$features !== void 0 && _user$features.invoicedCustomer)) {
          throw new Error(errorStrings.selectBillingOption);
        }
      }

      setCardId(Number(context.selectedPaymentOptions.id));
      setBillingProcessed(true);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  var processContactInformation = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$H().m(function _callee() {
      var payload, _yield$post, data, userFailedFraudCheck, result, err, defContact, id, extraInfoPayload, _yield$post2, _data, _err, _yield$post3, _data2, _result2, _err2, _yield$post4, _data3, _result3, _err3;

      return _regenerator$H().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              if (contact.selectedContact) {
                _context.n = 1;
                break;
              }

              setError(errorStrings.selectAContact);
              throw Error();

            case 1:
              _context.p = 1;
              /**
               * Tech Debt: Fix up the contact state machine to work like the payment state machine
               * For the time being, make the calls to create a new contact here and wait for the response
               *
               * If a user is new:
               *    their contact will have to go through fraud check. Check the response to see if fraud check passes or fails.
               *
               * If a user is existing but adds a new contact:
               *    Check the response is successful and carry on
               *
               * If a user is existing but TLD information is updated:
               *    Check the response for updating a contact and carry on.
               */

              payload = createContactPayload(contact.selectedContact, isNewUser);

              if (!(isNewUser || contact.addNew)) {
                _context.n = 14;
                break;
              }

              if (!isNewUser) {
                _context.n = 10;
                break;
              }

              _context.n = 2;
              return post$1(contactEndpoints.primaryContact, payload);

            case 2:
              _yield$post = _context.v;
              data = _yield$post.data;
              userFailedFraudCheck = data.userFailedFraudCheck, result = data.result, err = data.err;

              if (!err) {
                _context.n = 3;
                break;
              }

              setError(errorStrings.contactAddingError);
              throw err;

            case 3:
              if (!userFailedFraudCheck) {
                _context.n = 4;
                break;
              }

              if (hasDOM) {
                window.location = '/OnHold.aspx';
              }

              return _context.a(2);

            case 4:
              if (!(result === undefined)) {
                _context.n = 8;
                break;
              }

              _context.n = 5;
              return get$3(userEndpoints.defaultContact);

            case 5:
              defContact = _context.v;
              id = defContact.data.id;

              if (!contact.selectedContact.extraInfo) {
                _context.n = 7;
                break;
              }

              extraInfoPayload = createContactPayload(contact.selectedContact, false);
              _context.n = 6;
              return post$1("".concat(contactEndpoints.contact, "/").concat(id), extraInfoPayload);

            case 6:
              _yield$post2 = _context.v;
              _data = _yield$post2.data;
              _err = _data.err;

              if (!_err) {
                _context.n = 7;
                break;
              }

              if (_err.message === errorStrings.ownershipProtectionError) {
                setError(errorStrings.ownershipProtectionUserMessage);
              }

              setError(errorStrings.contactNeedsUpdating);
              throw _err;

            case 7:
              setContactId(id);
              _context.n = 9;
              break;

            case 8:
              setContactId(result.id);

            case 9:
              setContactProcessed(true);
              _context.n = 13;
              break;

            case 10:
              _context.n = 11;
              return post$1(contactEndpoints.contact, payload);

            case 11:
              _yield$post3 = _context.v;
              _data2 = _yield$post3.data;
              _result2 = _data2.result, _err2 = _data2.err;

              if (!_err2) {
                _context.n = 12;
                break;
              }

              setError(errorStrings.contactAddingError);
              throw _err2;

            case 12:
              setContactId(_result2.id);
              setContactProcessed(true);

            case 13:
              _context.n = 18;
              break;

            case 14:
              if (!(contactRef.current && contactRef.current.id === 'additionalInfo-form')) {
                _context.n = 17;
                break;
              }

              _context.n = 15;
              return post$1("".concat(contactEndpoints.contact, "/").concat(contact.selectedContact.id), payload);

            case 15:
              _yield$post4 = _context.v;
              _data3 = _yield$post4.data;
              _result3 = _data3.result, _err3 = _data3.err;

              if (!_err3) {
                _context.n = 16;
                break;
              }

              if (_err3.message === errorStrings.ownershipProtectionError) {
                setError(errorStrings.ownershipProtectionUserMessage);
              }

              setError(errorStrings.contactNeedsUpdating);
              throw _err3;

            case 16:
              setContactId(_result3.updatedContact.id);
              setContactProcessed(true);
              _context.n = 18;
              break;

            case 17:
              // if existing user + existing contact
              setContactId(contact.selectedContact.id);
              setContactProcessed(true);

            case 18:
              _context.n = 20;
              break;

            case 19:
              _context.p = 19;
              setLoading(false);
              setContactSuccessful(false);

            case 20:
              return _context.a(2);
          }
        }
      }, _callee, null, [[1, 19]]);
    }));

    return function processContactInformation() {
      return _ref2.apply(this, arguments);
    };
  }();

  var submitContactEvent = function submitContactEvent() {
    // Trigger the onSubmit event on the contact form
    if (contactRef.current) {
      contactRef.current.submit(new Event('submit', {
        cancelable: true
      }));
    }
  };

  var submitPaymentEvent = function submitPaymentEvent() {
    /*
     * Trigger the onSubmit event on the payment form
     * The payment machine handles all the processing of the card, we just have to trigger the onSubmit
     * and wait for isAddCardSuccessful to return true.
     */
    if (paymentRef.current) {
      paymentRef.current.submit(new Event('submit', {
        cancelable: true
      }));
    }
  };

  useEffect(function () {
    var _user$features2;

    if (selectedCardId) {
      setCardId(selectedCardId);
      setBillingProcessed(true);
    } else if (user !== null && user !== void 0 && (_user$features2 = user.features) !== null && _user$features2 !== void 0 && _user$features2.invoicedCustomer) {
      setCardId('0');
      setBillingProcessed(true);
    } else {
      setCardId(null);
      setBillingProcessed(false);
    }
  }, [selectedCardId, user]);
  useEffect(function () {
    if (IsAddContactSuccessful) {
      processContactInformation();
    }
  }, [IsAddContactSuccessful]);
  useEffect(function () {
    if (isAddCardSuccessful) {
      // If adding the card was successful, then process the entire order with all the data we have
      processBillingInformation();
    }
  }, [isAddCardSuccessful]); // Check if adding a card was successful or threw and error

  useEffect(function () {
    if (hasAddCardError) {
      setError(errorStrings.billingError);
      setLoading(false);
    }
  }, [hasAddCardError]);
  useEffect(function () {
    // do billing
    if (!billingProcessed && contactProcessed) {
      var _order$totals2;

      if ((isNewUser || isNewCard) && (order === null || order === void 0 ? void 0 : (_order$totals2 = order.totals) === null || _order$totals2 === void 0 ? void 0 : _order$totals2.total) !== 0) {
        submitPaymentEvent();
        setLoading(false);
      } else {
        processBillingInformation();
      }
    }
  }, [contactProcessed]);
  useEffect(function () {
    var _user$features3, _order$totals3; // If we have both cardId and contactId we can begin processing the order


    if ((user !== null && user !== void 0 && (_user$features3 = user.features) !== null && _user$features3 !== void 0 && _user$features3.invoicedCustomer || cardId || order && (order === null || order === void 0 ? void 0 : (_order$totals3 = order.totals) === null || _order$totals3 === void 0 ? void 0 : _order$totals3.total) === 0) && contactId) {
      processEntireOrder();
    }
  }, [billingProcessed, contactProcessed]);
  return /*#__PURE__*/jsxs(Stack$2, {
    width: "100%",
    children: [/*#__PURE__*/jsxs(Button$1, {
      py: 3,
      color: isInternic ? 'blueDark' : 'magenta',
      disabled: !!formErrors // If any errors present, disable submit.
      ,
      onClick: function onClick() {
        setError(false);
        setLoading(true); // If a user is new, or and existing user wants to add a NEW contact
        // or if the TLD forms were rendered, trigger the onSubmit events for the forms

        if (!contactProcessed) {
          if (isNewUser || contact.addNew) {
            submitContactEvent();
          } else {
            // if ref id is addinfo
            if (contactRef.current && contactRef.current.id === 'additionalInfo-form') {
              submitContactEvent();
            }

            processContactInformation();
          }
        }

        if (!billingProcessed && contactProcessed) {
          if (isNewUser || isNewCard) {
            submitPaymentEvent();
          } else {
            processBillingInformation();
          }
        }

        if (billingProcessed && contactProcessed) {
          processEntireOrder();
        }
      },
      children: [/*#__PURE__*/jsx$1(Icon$2, {
        name: "solid-padlock",
        mx: 2,
        color: "white"
      }), loading ? /*#__PURE__*/jsx$1(Stack$2, {
        style: {
          overflow: 'hidden'
        },
        children: /*#__PURE__*/jsx$1(Box$1, {
          flexDirection: "column",
          m: 2,
          children: /*#__PURE__*/jsx$1(Spinner$1, {
            size: "2rem",
            stroke: ".3rem"
          })
        })
      }) : /*#__PURE__*/jsx$1(Text$1, {
        mt: "1",
        children: "Process Order"
      })]
    }), (error || !!formErrors) && /*#__PURE__*/jsx$1(Stack$2, {
      children: /*#__PURE__*/jsx$1(Box$1, {
        alignItems: "center",
        bg: "errorLight",
        flexDirection: "column",
        justifyContent: "center",
        mt: 3,
        mb: 3,
        pb: 3,
        pl: 3,
        pt: 3,
        width: "100%",
        children: /*#__PURE__*/jsx$1(Text$1, {
          children: formErrors
        })
      })
    }), /*#__PURE__*/jsx$1(FinePrint, {
      plainText: "By clicking Process Order you agree to the ",
      hyperlinkedText: "Terms and Conditions",
      textSize: isMobile ? '1rem' : '1.35rem',
      URL: "/terms-conditions",
      color: "blue"
    })]
  });
});
var surveyAnswerOptions = [{
  value: 'google',
  label: 'Google'
}, {
  value: 'social-media',
  label: 'Social Media'
}, {
  value: 'email',
  label: 'Email'
}, {
  value: 'referral',
  label: 'Referral'
}, {
  value: 'adverstisement',
  label: 'Advertisement'
}, {
  value: 'friend',
  label: 'From a friend'
}, {
  value: 'existing-customer',
  label: 'Existing customer'
}];

function LeftHandContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/jsx$1(Box$1, {
    bg: "white",
    border: "light",
    mb: 2,
    px: 4,
    py: [3, 4],
    children: children
  });
}

function RightHandContainer(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/jsx$1(Box$1, {
    bg: "white",
    justifyContent: "center",
    border: "light",
    px: [3],
    py: [3, 4],
    width: "100%",
    mb: 2,
    children: children
  });
}

function CheckOutBlock(_ref3) {
  var _order$totals$total, _order$totals;

  var strings = _ref3.strings,
      user = _ref3.user; // This is used for the new cards through Chargebee.

  var _React$useState = React__default.useState(),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      selectedCardId = _React$useState2[0],
      _setSelectedCardId = _React$useState2[1];

  var _useUserService = useUserService(),
      send = _useUserService.send,
      currentState = _useUserService.currentState;

  var contactRef = React__default.useRef();
  var paymentRef = React__default.useRef();
  var surveyRef = React__default.useRef('');
  var ref = React__default.useRef({
    contactRef: contactRef,
    paymentRef: paymentRef,
    surveyRef: surveyRef
  });
  var isLoggedIn = currentState.matches(authStates.loggedIn);

  var _React$useState3 = React__default.useState(''),
      _React$useState4 = _slicedToArray$4(_React$useState3, 2),
      surveyAnswer = _React$useState4[0],
      setSurveyAnswer = _React$useState4[1];

  var _React$useState5 = React__default.useState(),
      _React$useState6 = _slicedToArray$4(_React$useState5, 2),
      cartCount = _React$useState6[0],
      setCartCount = _React$useState6[1];
  /* Start Order Provider */


  var currency = getCurrencyByCode(LS.getItem(storageKeys.Currency));

  var _useOrderService = useOrderService(),
      orderId = _useOrderService.orderId;

  var _useOrderQuery = useOrderQuery(),
      order = _useOrderQuery.order;

  useEffect(function () {
    setCartCount(order === null || order === void 0 ? void 0 : order.items.length);
  }, [order === null || order === void 0 ? void 0 : order.items]);
  return /*#__PURE__*/jsxs(Stack$2, {
    children: [/*#__PURE__*/jsxs(Box$1, {
      alignItems: "center",
      backgroundColor: "greyLightest",
      flexDirection: ['column', 'column', 'row'],
      height: "100%",
      justifyContent: ['space-between', 'space-between', 'center'],
      padding: 0,
      width: "100%",
      mb: [5, 5, 0],
      pt: "1.25rem",
      pb: ['110px', 0, 0],
      children: [cartCount > 0 ? /*#__PURE__*/jsx$1(Stack$2, {
        alignSelf: ['center', 'center', 'flex-start'],
        justifyContent: "center",
        maxWidth: ['100%', '100%', '500px'],
        mb: 2,
        mx: 2,
        px: 2,
        width: ['100%', '100%', '40%'],
        children: user ? /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx$1(LeftHandContainer, {
            children: /*#__PURE__*/jsx$1(UserNamePanel, {
              userName: user === null || user === void 0 ? void 0 : user.userName,
              onSwitchAccounts: function onSwitchAccounts() {
                send(events$c.LOG_OUT);
              }
            })
          }), /*#__PURE__*/jsx$1(LeftHandContainer, {
            children: /*#__PURE__*/jsx$1(ContactView, {
              ref: contactRef
            })
          }), /*#__PURE__*/jsxs(LeftHandContainer, {
            children: [/*#__PURE__*/jsx$1(DefaultCardErrorMessage, {
              strings: strings
            }), /*#__PURE__*/jsx$1(PaymentView, {
              selectedCardId: selectedCardId,
              setSelectedCardId: function setSelectedCardId(id) {
                return _setSelectedCardId(id);
              },
              contactRef: contactRef,
              ref: paymentRef,
              strings: strings,
              width: "100%",
              mb: 1
            })]
          }), /*#__PURE__*/jsx$1(LeftHandContainer, {
            children: /*#__PURE__*/jsx$1(Dropdown, {
              id: "survey-select",
              onChange: function onChange(value) {
                surveyRef.current = value.label;
                setSurveyAnswer(value.label);
              },
              options: surveyAnswerOptions,
              isSearchable: false,
              placeholder: surveyAnswer || 'Select one ...',
              title: "How did you hear about us?",
              width: "100%",
              mb: 1
            })
          }), !isMobile && /*#__PURE__*/jsx$1(ProcessOrder, {
            selectedCardId: selectedCardId,
            ref: ref
          })]
        }) : /*#__PURE__*/jsx$1(LeftHandContainer, {
          children: /*#__PURE__*/jsx$1(Box$1, {
            justifyContent: "center",
            mb: [3, 4, 0],
            px: [3],
            width: "100%",
            children: /*#__PURE__*/jsx$1(UserAuth, {
              id: "account",
              isRedesign: true,
              showHeading: true,
              stopRedirect: true,
              width: "100%"
            })
          })
        })
      }) : /*#__PURE__*/jsx$1(Fragment, {}), /*#__PURE__*/jsxs(Stack$2, {
        alignSelf: ['center', 'center', 'flex-start'],
        maxWidth: ['100%', '100%', '500px'],
        mb: 2,
        mx: 2,
        px: 2,
        position: ['static', 'static', 'sticky', 'sticky'],
        top: "9rem",
        width: ['100%', '100%', '40%'],
        children: [/*#__PURE__*/jsx$1(RightHandContainer, {
          children: /*#__PURE__*/jsx$1(OrderSummary, {
            orderId: orderId,
            currency: currency
          })
        }), /*#__PURE__*/jsx$1(FinePrint, {
          plainText: "Having Trouble? ",
          hyperlinkedText: "Try the old checkout",
          URL: "/checkout/?optOutCart=1"
        })]
      })]
    }), isMobile && isLoggedIn && /*#__PURE__*/jsxs(Stack$2, {
      width: "100vw",
      style: {
        position: 'fixed',
        bottom: '0px'
      },
      bg: "white",
      px: 3,
      py: 2,
      borderTop: "light",
      children: [/*#__PURE__*/jsxs(Box$1, {
        justifyContent: "space-between",
        mb: 1,
        children: [/*#__PURE__*/jsx$1(Text$1, {
          variant: "megaBold",
          children: "Total:"
        }), /*#__PURE__*/jsxs(Text$1, {
          variant: "megaBold",
          children: ["$", Math.abs((_order$totals$total = order === null || order === void 0 ? void 0 : (_order$totals = order.totals) === null || _order$totals === void 0 ? void 0 : _order$totals.total) !== null && _order$totals$total !== void 0 ? _order$totals$total : 0).toFixed(2)]
        })]
      }), /*#__PURE__*/jsx$1(ProcessOrder, {
        selectedCardId: selectedCardId,
        ref: ref
      })]
    })]
  });
}

function _regenerator$G() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$G(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$G(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$G(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$G(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$G(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$G(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$G(u), _regeneratorDefine2$G(u, o, "Generator"), _regeneratorDefine2$G(u, n, function () {
    return this;
  }), _regeneratorDefine2$G(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$G = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$G(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$G = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$G(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$G(e, r, n, t);
}

function CheckOutFlow(_ref) {
  var strings = _ref.strings,
      user = _ref.user;
  /* Start Order Provider */

  var _useOrderService = useOrderService(),
      orderId = _useOrderService.orderId,
      order = _useOrderService.order,
      orderIsReady = _useOrderService.orderIsReady,
      setCookie = _useOrderService.setCookie,
      setIsReady = _useOrderService.setIsReady,
      isReady = _useOrderService.isReady;

  var _useSessionService = useSessionService(),
      currentCode = _useSessionService.data.currentCurrency.code;

  var createMissingOrder = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$G().m(function _callee() {
      var _yield$createOrder, id;

      return _regenerator$G().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              _context.n = 1;
              return createOrder();

            case 1:
              _yield$createOrder = _context.v;
              id = _yield$createOrder.data.id;
              setCookie('orderId', id, {
                path: '/'
              });

            case 2:
              return _context.a(2);
          }
        }
      }, _callee);
    }));

    return function createMissingOrder() {
      return _ref2.apply(this, arguments);
    };
  }();

  var overwriteOrder = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator$G().m(function _callee2() {
      var _t;

      return _regenerator$G().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return overwriteOrderFromSession(orderId, currentCode.toUpperCase());

            case 1:
              setIsReady(true);
              _context2.n = 3;
              break;

            case 2:
              _context2.p = 2;
              _t = _context2.v;
              console.error('error overwriting order', _t);

            case 3:
              return _context2.a(2);
          }
        }
      }, _callee2, null, [[0, 2]]);
    }));

    return function overwriteOrder() {
      return _ref3.apply(this, arguments);
    };
  }();

  useEffect(function () {
    var supportedProducts = ['Registration', 'ICANNFee', 'Privacy', 'PromoDiscount', 'Security', 'OwnershipLock', 'ExpiryInsurance', 'AppliedAccountCredit', 'OutstandingBalancePayment', 'TransferII', 'Renew', 'Difm', 'MarketgooSubscription', 'Sitelock', 'VpsPackage', 'PleskPackage', 'PWPackage', 'PremiumDomain', 'GoogleWorkspace', 'GoogleWorkspaceUser', 'RegistrationFee', 'Backorder', 'AccountManagementSubscription', 'OpenExchangeEmail', 'OpenExchangeUser'];

    if (!window.configs) {
      window.configs = {
        supportedProducts: supportedProducts
      };
    } else if (!window.configs.supportedProducts) {
      window.configs.supportedProducts = supportedProducts;
    }
  });
  useEffect(function () {
    if (orderIsReady) {
      datalayerPush({
        ecommerce: null
      });
      datalayerPush({
        event: 'checkout',
        ecommerce: {
          checkout: {
            actionField: {
              id: order.id
            },
            products: order.items.map(function (item) {
              var _item$prices;

              return {
                itemCode: item.itemCode,
                itemDescription: item.display.name,
                product: item.productType,
                productCategory: item.assetType,
                amount: (_item$prices = item.prices) !== null && _item$prices !== void 0 && _item$prices.regular ? Math.round((item.prices.regular.price + (item.prices.promo ? item.prices.promo.price : 0)) * 100) / 100 : 0
              };
            })
          }
        }
      });
    }
  }, [orderIsReady]);
  useEffect(function () {
    if (!orderId) {
      createMissingOrder();
    }
  }, [orderId]);
  useEffect(function () {
    if (orderId) {
      overwriteOrder();
    }
  }, [orderId]);

  if (!isReady) {
    return null;
  }
  /* Start Order Provider */


  return /*#__PURE__*/jsx$1(OrderQueryProvider, {
    orderId: orderId,
    children: /*#__PURE__*/jsx$1(CreditCardServiceProvider, {
      children: /*#__PURE__*/jsx$1(CheckOutBlock, {
        strings: strings,
        user: user
      })
    })
  });
}

var propTypes$E = {
  containerRef: PropTypes.object.isRequired,
  currentCurrency: PropTypes.shape({
    code: PropTypes.string
  }),
  lastFocused: PropTypes.object.isRequired,
  setNewCurrency: PropTypes.func.isRequired
};
var defaultProps$f = {
  currentCurrency: ''
};

function CurrencyOptions(_ref) {
  var lastFocused = _ref.lastFocused,
      currentCurrency = _ref.currentCurrency,
      setNewCurrency = _ref.setNewCurrency,
      containerRef = _ref.containerRef;
  useEffect(function () {
    containerRef.current.focus();
  }, []);
  useTabTrapper(containerRef, [], lastFocused.current);
  return /*#__PURE__*/jsxs(Box$1, {
    alignItems: "center",
    flexDirection: "column",
    children: [/*#__PURE__*/jsx$1(Heading, {
      headingStyle: 2,
      mb: 3,
      children: currencyStrings.title
    }), /*#__PURE__*/jsx$1(Box$1, {
      flexDirection: "column",
      children: currencyOpts.map(function (opt) {
        var isSelected = currentCurrency.code === opt.code;
        return /*#__PURE__*/jsx$1(Button$1, {
          ariaLabel: "Currency option: ".concat(opt.code),
          color: "black",
          display: "flex",
          id: opt.code,
          mt: 3,
          onClick: function onClick() {
            return setNewCurrency(opt);
          },
          variant: "minimal",
          children: /*#__PURE__*/jsxs(Box$1, {
            alignItems: "center",
            position: "relative",
            children: [/*#__PURE__*/jsx$1(Icon$2, {
              display: isSelected ? 'block' : 'none',
              height: "2rem",
              left: "-2.5rem",
              name: "checkmark",
              position: "absolute",
              title: "Checkmark",
              titleId: "checkmarkIcon",
              top: "0"
            }), /*#__PURE__*/jsx$1(Icon$2, {
              height: "2rem",
              name: opt.code,
              title: "".concat(opt.name, " flag"),
              titleId: "".concat(opt.name, "Icon")
            }), /*#__PURE__*/jsx$1(Text$1, {
              fontWeight: "regular",
              ml: 2,
              children: opt.code.toUpperCase()
            })]
          })
        }, opt.code);
      })
    })]
  });
}

CurrencyOptions.propTypes = propTypes$E;
CurrencyOptions.defaultProps = defaultProps$f;
var _excluded$c = ["color"];

function ownKeys$F(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$F(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$F(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$F(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var propTypes$D = {
  btnProps: PropTypes.shape({}),
  containerProps: PropTypes.shape({
    color: PropTypes.string
  }),
  fetchOnStart: PropTypes.bool,
  id: PropTypes.string.isRequired
};
var defaultProps$e = {
  btnProps: {},
  containerProps: {
    color: 'white'
  },
  fetchOnStart: false
};

function CurrencySelector(_ref) {
  var id = _ref.id,
      containerProps = _ref.containerProps,
      btnProps = _ref.btnProps,
      fetchOnStart = _ref.fetchOnStart;

  var _useModal = useModal(),
      openModal = _useModal.openModal,
      closeModal = _useModal.closeModal,
      isOpen = _useModal.isOpen,
      Modal = _useModal.Modal,
      containerRef = _useModal.containerRef;

  var lastFocused = useRef();

  var _useSessionService = useSessionService(),
      data = _useSessionService.data,
      fetchCurrency = _useSessionService.fetchCurrency,
      setCurrency = _useSessionService.setCurrency;

  var error = useErrorStateService(ERROR_KEYS.session);

  var _useErrorDispatchServ = useErrorDispatchService(),
      removeError = _useErrorDispatchServ.removeError;

  var color = containerProps.color,
      rest = _objectWithoutProperties$8(containerProps, _excluded$c);

  useEffect(function () {
    if (!data.currentCurrency && fetchOnStart) {
      fetchCurrency();
    }
  }, []);

  var handleClose = function handleClose() {
    closeModal();

    if (error) {
      removeError(ERROR_KEYS.session);
    }
  };

  var currencyCode = _get(data, 'currentCurrency.code', '');

  if (currencyCode) {
    currencyCode = currencyCode.toUpperCase();
  }

  return /*#__PURE__*/jsxs(Text$1, _objectSpread$F(_objectSpread$F({}, rest), {}, {
    children: [/*#__PURE__*/jsxs(Button$1, _objectSpread$F(_objectSpread$F({
      ref: lastFocused,
      ariaLabel: "Change your currency: ".concat(currencyCode, " currently selected"),
      id: id,
      onClick: function onClick() {
        if (currencyCode) {
          openModal();
        }
      },
      variant: "navbar"
    }, btnProps), {}, {
      children: [/*#__PURE__*/jsx$1(Text$1, {
        color: color,
        letterSpacing: "0px",
        mr: 1,
        variant: "kilo",
        children: currencyCode
      }), currencyCode && /*#__PURE__*/jsx$1(Icon$2, {
        color: color,
        containerProps: {
          pb: '1px'
        },
        height: 20,
        mb: 1,
        name: "arrow-down",
        title: "Select currency",
        titleId: "".concat(id, "-selectCurrency")
      })]
    })), /*#__PURE__*/jsx$1(Modal, {
      closeBtnCb: handleClose,
      id: "currency-selector-modal",
      isOpen: isOpen,
      onBgClick: handleClose,
      onEscapeKey: handleClose,
      children: /*#__PURE__*/jsxs(ErrorBoundary, {
        location: "currency-selector",
        children: [/*#__PURE__*/jsx$1(CurrencyOptions, {
          containerRef: containerRef,
          currentCurrency: data.currentCurrency,
          lastFocused: lastFocused,
          setNewCurrency: function setNewCurrency(newCurrency) {
            return setCurrency(newCurrency);
          }
        }), error && /*#__PURE__*/jsx$1(Message, {
          containerProps: {
            mt: 3
          },
          dismissCallback: removeError,
          variant: "error",
          children: error
        })]
      })
    })]
  }));
}

CurrencySelector.propTypes = propTypes$D;
CurrencySelector.defaultProps = defaultProps$e;
var options = {
  systemOpts: [{
    name: 'Desktop',
    icon: 'desktop'
  }, {
    name: 'Mobile',
    icon: 'mobile'
  }],
  mobileOpts: [{
    name: 'iOS',
    icon: 'mac',
    emailClients: [{
      name: 'Apple Mail',
      level: 'App',
      icon: 'apple',
      doc: 'mobile-ios-mail'
    }, {
      name: 'Gmail',
      level: 'App',
      icon: 'gmail',
      doc: 'mobile-ios-gmail'
    }, {
      name: 'Outlook',
      level: 'App',
      icon: 'outlook',
      doc: 'mobile-ios-outlook'
    }]
  }, {
    name: 'Android',
    icon: 'android',
    emailClients: [{
      name: 'Gmail',
      level: 'App',
      icon: 'gmail',
      doc: 'mobile-android-gmail'
    }, {
      name: 'Outlook',
      level: 'App',
      icon: 'outlook',
      doc: 'mobile-android-outlook'
    }, {
      name: 'Samsung',
      level: 'App',
      icon: 'samsungmail',
      doc: 'mobile-android-samsungmail'
    }]
  }],
  desktopOpts: [{
    name: 'Mac',
    icon: 'mac',
    emailClients: [{
      name: 'Mac Mail',
      level: 'App',
      icon: 'macmail',
      doc: 'desktop-mac-macmail'
    }, {
      name: 'Outlook for Mac',
      level: 'App',
      icon: 'outlook',
      doc: 'desktop-mac-outlook'
    }, {
      name: 'Thunderbird',
      level: 'App',
      icon: 'thunderbird',
      doc: 'desktop-mac-thunderbird'
    }]
  }, {
    name: 'Windows',
    icon: 'windows',
    emailClients: [{
      name: 'Outlook 2019',
      level: 'App',
      icon: 'outlook',
      doc: 'desktop-windows-outlook2019'
    }, {
      name: 'Outlook 2013',
      level: 'App',
      icon: 'outlook',
      doc: 'desktop-windows-outlook2013'
    }, {
      name: 'Thunderbird',
      level: 'App',
      icon: 'thunderbird',
      doc: 'desktop-windows-thunderbird'
    }, {
      name: 'Windows Mail',
      level: 'App',
      icon: 'win10mail',
      doc: 'desktop-windows-win10mail'
    }]
  }]
};

function ownKeys$E(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$E(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$E(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$E(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _regenerator$F() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$F(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$F(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$F(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$F(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$F(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$F(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$F(u), _regeneratorDefine2$F(u, o, "Generator"), _regeneratorDefine2$F(u, n, function () {
    return this;
  }), _regeneratorDefine2$F(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$F = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$F(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$F = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$F(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$F(e, r, n, t);
}

var EmailSetupContext = /*#__PURE__*/React.createContext();

function EmailSetupProvider(props) {
  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      content = _React$useState2[0],
      setContent = _React$useState2[1];

  var _React$useState3 = React.useState({
    success: false,
    error: {
      message: ''
    }
  }),
      _React$useState4 = _slicedToArray$4(_React$useState3, 2),
      settings = _React$useState4[0],
      setSettings = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray$4(_React$useState5, 2),
      loading = _React$useState6[0],
      setLoading = _React$useState6[1];

  var getSettings = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$F().m(function _callee(emailAddress, captchaToken) {
      var re, _emailAddress$split, _emailAddress$split2, user, domain, result, out;

      return _regenerator$F().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              emailAddress = emailAddress.trim();
              re = new RegExp(/^(([^()\[\]\\.,;:\s@"]+(\.[^()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

              if (!(emailAddress === '' || !re.test(emailAddress))) {
                _context.n = 1;
                break;
              }

              setSettings({
                success: false,
                error: {
                  message: 'pleaseProvideValidEmailAddress'
                }
              });
              return _context.a(2);

            case 1:
              if (captchaToken === '') {
                setSettings({
                  success: false,
                  error: {
                    message: 'captchaIsntSet'
                  }
                });
              }

              _emailAddress$split = emailAddress.split('@'), _emailAddress$split2 = _slicedToArray$4(_emailAddress$split, 2), user = _emailAddress$split2[0], domain = _emailAddress$split2[1];
              setLoading(true);
              _context.p = 2;
              _context.n = 3;
              return get$3("".concat(emailSetupEndpoint, "/configuration/").concat(domain, "?captchaToken=").concat(captchaToken));

            case 3:
              result = _context.v;
              out = {};

              if (result.data.success) {
                out = result.data.data.connectionSettings;
                out.success = result.data.success;
                out.error = {
                  message: result.data.data.error
                };
                out.Username = emailAddress;
                out.User = user;
                out.Domain = domain;
                out.emailAddress = emailAddress;
                out.platform = result.data.data.platform;
              } else {
                out.error = {
                  message: result.data.data
                };
              }

              setSettings(out);
              _context.n = 5;
              break;

            case 4:
              _context.p = 4;

            case 5:
              setLoading(false);

            case 6:
              return _context.a(2);
          }
        }
      }, _callee, null, [[2, 4]]);
    }));

    return function getSettings(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  var getContent = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$F().m(function _callee2(doc) {
      var result, rawContent, settingsKeys;
      return _regenerator$F().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              setLoading(true);
              _context2.p = 1;
              _context2.n = 2;
              return get$3("".concat(emailSetupEndpoint, "/content/").concat(doc));

            case 2:
              result = _context2.v;
              rawContent = result.data.content;

              if (settings.success) {
                settingsKeys = Object.keys(settings);
                settingsKeys.forEach(function (item) {
                  rawContent = rawContent.replace(new RegExp("{".concat(item, "}"), 'g'), settings[item]);
                });
              }

              setContent(rawContent);
              _context2.n = 4;
              break;

            case 3:
              _context2.p = 3;

            case 4:
              setLoading(false);

            case 5:
              return _context2.a(2);
          }
        }
      }, _callee2, null, [[1, 3]]);
    }));

    return function getContent(_x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  var setContentEmpty = function setContentEmpty() {
    setContent(null);
  };

  var value = React.useMemo(function () {
    return {
      content: content,
      loading: loading,
      settings: settings,
      getSettings: getSettings,
      getContent: getContent,
      setContentEmpty: setContentEmpty,
      setLoading: setLoading
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [content, settings, loading]);
  return /*#__PURE__*/jsx$1(EmailSetupContext.Provider, _objectSpread$E({
    value: value
  }, props));
}

function useEmailSetupService() {
  var ctx = React.useContext(EmailSetupContext);

  if (!ctx) {
    throw new Error("useEmailSetupService must be used within an EmailSetupProvider");
  }

  return _objectSpread$E({}, ctx);
}

var icons = [{
  paths: ['M384.577 311.354c-0.758 0.155-1.863 2.246-1.607 3.084 0.956 3.14 2.705 5.67 7.203 3.827-0.898 1.677-1.421 2.661-2.287 4.279 2.124-0.934 3.499-1.539 5.243-2.307-0.253 1.596-0.434 2.73-0.825 5.195 6.516-1.893 12.24-3.556 15.43-4.483 7.13 1.122 12.054 1.897 17.474 2.75 0.326 1.644 0.294 3.863 1.212 5.569 1.631 3.034 4.498 5.512 5.675 8.661 3.069 8.21 5.554 16.643 8.121 25.035 0.324 1.062-0.494 2.429-0.369 3.611 0.141 1.35 0.351 3.193 1.243 3.838 1.37 0.989 3.348 1.137 6.109 1.948 0.459-1.263 1.928-3.218 1.513-4.606-0.889-2.974-2.754-5.657-4.342-8.694 0.529-0.201 1.905-0.723 4.169-1.584-3.637-9.873-7.002-19.655-10.855-29.244-2.449-6.091-5.3-12.074-8.563-17.765-2.786-4.857-4.749-4.955-8.219-1.724-0.183 0.171-0.562 0.128-0.981 0.211-0.603-0.815-1.232-1.664-2.302-3.112-1.937 2.351-3.65 4.432-5.531 6.709-1.589-1.867-2.967-4.935-4.754-5.193-1.955-0.284-4.286 2.030-7.161 3.596-4.295-3.699-6.865 2.279-11.267 4.016 0.848-4.438-1.985-4.094-4.329-3.614z', 'M343.111 245.918c2.873 5.419 6.573 10.398 9.997 15.716 7.623-7.808 9.329-16.801 4.379-22.407-0.695 3.913-1.155 7.605-2.085 11.171-0.342 1.307-1.802 2.321-2.754 3.466-0.432-1.632-1.395-3.336-1.182-4.882 0.397-2.899 1.86-5.662 2.166-8.558 0.357-3.371-0.053-6.824-0.13-10.242-0.524-0.002-1.047-0.002-1.569-0.005-1.095 4.345-2.193 8.692-3.288 13.036-0.595-0.073-1.19-0.146-1.785-0.218 0-1.471-0.266-3.002 0.050-4.402 0.883-3.897 2.218-7.702 2.906-11.623 0.204-1.167-0.984-2.72-1.824-3.887-0.788-1.094-2.342-1.729-2.896-2.884-1.81-3.769-3.32-7.682-5.077-11.857-5.833 4.302-8.255 11.427-5.595 18.251 2.56 6.578 5.384 13.094 8.687 19.325z', 'M317.683 254.417c0.407-1.090 0.713-1.516 0.697-1.928-0.151-4.025-1.25-8.382 4.104-10.313 0.16-0.058-0.258-2.833-0.999-3.945-0.703-1.052-2.385-1.398-3.296-2.374-4.854-5.206-9.522-10.594-14.464-15.711-0.866-0.898-2.738-0.821-4.148-1.194-0.289 1.448-0.834 2.902-0.793 4.34 0.042 1.366 0.612 2.748 1.1 4.068 3.77 10.187 10.242 18.592 17.799 27.056z', 'M372.016 252.393c0.908 2.395 2.542 3.275 4.977 0.756 1.481-1.529 4.010-2.048 6.535-3.242-0.587-1.576-1.375-3.694-2.435-6.546-2.332 1.948-4.126 3.446-6.217 5.191-2.705-3.624 0.022-6.445 1.82-7.71 4.189-2.947 1.31-4.435-0.479-6.797-1.297 1.21-2.385 2.223-3.471 3.237-0.442-0.091-0.884-0.181-1.327-0.274 3.587-8.204 2.971-15.554-3.291-22.691-3.401 5.363-5.431 10.247-3.931 15.478 2.196 7.652 4.994 15.144 7.82 22.598z', 'M294.357 257.699c-1.78 0.324-3.132 0.57-4.483 0.818-0.022 0.564-0.043 1.127-0.063 1.691 2.361 0.253 4.716 0.559 7.083 0.74 1.36 0.105 3.554-0.5 3.933 0.108 0.783 1.258 0.781 3.119 0.765 4.728-0.012 1.278-0.522 2.553-1.047 4.884 3.413-2.688 5.747-4.527 8.209-6.466-10.032-6.962-17.112-18.811-30.040-22.919-0.623 0.402-1.247 0.803-1.87 1.204 1.721 3.853 3.296 7.778 5.193 11.542 2.63 5.211 8.624 0.136 12.321 3.672z', 'M412.817 275.712c-0.873-3.325-1.612-6.139-2.233-8.505-2.404 0.367-4.979 0.761-7.55 1.155-0.103-0.741-0.464-2.046-0.269-2.133 1.805-0.82 3.705-1.428 6.049-2.266 0.726-2.595 2.053-5.865-3.715-3.747-0.61 0.224-1.679-0.798-2.535-1.243 0.748-0.618 1.563-1.827 2.234-1.754 3.707 0.409 3.368-1.642 2.868-4.096-0.914-4.465-1.717-8.953-2.605-13.644-6.661 6.433-8.006 27.51-2.465 35.348 3.454-5.067 6.463-1.119 10.222 0.884z', 'M381.364 325.921c-0.391-0.422-0.78-0.843-1.17-1.265-1.518 1.165-4.191 2.201-4.342 3.524-0.535 4.681-0.208 9.462-0.208 14.233 4.851-0.987 9.819-1.484 10.453-6.36-2.961-2.271-5.108-3.916-7.414-5.685 0.898-1.494 1.789-2.971 2.681-4.447z', 'M320.181 253.483c-1.366 3.208-0.166 5.288 3.107 7.020 1.268-4.478 2.356-8.902 8.137-9.199 0.101-0.402 0.203-0.803 0.304-1.207-2.133-1.554-4.167-4.179-6.425-4.387-2.771-0.258-4.352 2.48-4.332 5.579 0.005 0.731-0.484 1.476-0.791 2.194z', 'M407.062 276.693c-1.8 0.116-3.511 1.629-5.263 2.523 0.311 0.52 0.622 1.041 0.933 1.561 9.873-0.053 13.698 4.114 13.402 13.99 2.469-5.971-1.83-11.191-2.098-16.559-2.552-0.613-4.801-1.657-6.974-1.516z', 'M327.69 264.797c0.095 0.916 1.679 1.679 1.539 1.551 3.667-2.971 6.466-5.235 10.32-8.355-2.1-0.588-4.646-2.213-6.478-1.624-3.632 1.167-5.802 4.342-5.381 8.428z', 'M377.043 261.384c1.322 0.032 2.761 0.411 3.941 0.018 1.967-0.655 3.767-1.805 6.22-3.040-0.389-1.081-1.031-2.858-1.804-5-2.685 1.682-5.005 2.861-6.954 4.482-0.858 0.716-0.959 2.336-1.405 3.541z', 'M308.5 278.777c0.49 0.233 0.982 0.465 1.474 0.698 2.48-2.683 4.96-5.368 7.886-8.533-1.491-1.006-3.117-2.103-4.071-2.748-1.986 3.973-3.637 7.278-5.29 10.582z', 'M328.849 305.588c3.33 5.87-2.954 6.4-5.216 9.593 7.018 2.715 6.452-3.968 9.558-6.358-1.707-1.27-3.025-2.252-4.342-3.235z', 'M357.881 266.055c7.145-2.366 9.361-5.984 6.462-9.519-2.005 2.952-3.936 5.798-6.462 9.519z', 'M409.098 325.216c-0.768 1.288-1.538 2.578-2.362 3.965 3.104 1.423 5.424 2.487 9.028 4.139-1.44-2.806-1.985-4.498-3.049-5.75-0.894-1.051-2.389-1.589-3.617-2.354z', 'M333.079 321.355c1.671 0.226 4.648 1.175 4.994 0.582 1.32-2.251 1.792-5.002 2.578-7.565-0.273-0.013-0.545-0.028-0.818-0.040-1.95 2.026-3.902 4.056-6.754 7.023z', 'M400.987 333.706c-1.119-0.51-2.583-0.354-3.885-0.289-0.224 0.013-0.678 1.426-0.549 1.514 0.923 0.655 1.918 1.325 2.992 1.616 1.129 0.306 2.37 0.193 4.234 0.306-1.199-1.413-1.805-2.696-2.793-3.147z', 'M979.644 957.053c-9.738 1.124-19.481 0.64-29.219 0.878-1.212 0.032-2.412 0.575-3.617 0.881-0.002 0-0.003 0-0.005 0-14.185-0.304-28.306-2.191-42.523-1.854-1.583-0.138-3.168 0.909-4.749-0.012-4.249-1.712-8.697-2.018-13.209-1.912-10.662-2.156-21.328-4.294-32.125-5.687-0.012 0.030-0.022 0.060-0.033 0.091-0.005 0-0.008-0.003-0.012-0.007l0.043-0.085c-2.080-1.228-4.4-0.773-6.629-0.951-13.378-2.618-26.812-4.748-40.45-5.554-12.664-0.746-25.301-2.136-38.011-1.074-13.136 0.091-26.331-0.843-39.381 0.979-7.399 1.032-15.054-0.060-22.22 2.725-12.855 0.399-25.223 3.697-37.71 6.267-0.617-0.096-1.27 0.076-1.942 0.396-7.017 0.924-14.005 2.159-21.049 2.716-24.129 1.903-48.289 2.823-72.503 2.065-19.338-0.6-38.491-2.633-57.557-5.964-8.518-1.489-16.8-4.201-25.359-5.16-17.632-1.973-35.202-4.781-53.005-5.002-1.237-0.015-2.828 0.239-3.237-1.262-0.45-1.652 0.976-2.773 2.228-3.218 4.713-1.671 8.022-5.506 12.368-7.702 7.090-4.244 12.961-10.183 20.094-14.364 0.186-0.414 0.284-0.849 0.284-1.305 0.032-0.223 0.062-0.45 0.093-0.673 3.177-2.033 6.575-3.17 10.154-3.569 1.897 0.934 4.073-0.060 6.066 0.213 0.421 0.186 0.821 0.411 1.199 0.675 4.29-0.284 8.4 0.939 12.536 1.696 18.39 3.353 36.753 6.799 55.464 8.016 21.461 1.395 42.942 1.711 64.397 0.667 9.369-0.455 18.854-0.592 28.097-2.703 0.291-0.276 0.615-0.399 0.954-0.455-0.283 0.135-0.593 0.286-0.954 0.455 9.658 0.412 18.912-2.224 28.301-3.778 14.181-2.349 28.318-4.985 42.619-6.546 0.002 0 0.002 0 0.002 0.003 8.182-0.657 16.366-1.315 24.546-1.97 0.313-0.188 0.635-0.309 0.959-0.402-0.321 0.118-0.642 0.244-0.959 0.402 7.989-0.007 15.977 0.176 23.959-0.055 16.949-0.495 33.804 1.187 50.701 1.93 2.251 1.275 4.779 1.607 7.259 1.79 17.528 1.305 34.503 5.941 51.823 8.493 10.198 1.499 20.384 2.899 30.708 2.949 0.293 0.228 0.612 0.417 0.962 0.452 1.812 0.67 3.762 0.399 5.655 0.499 9.148 1.504 18.294 1.494 27.442 0.007 4.088-0.313 8.18 1.175 12.265-0.028 9.108 1.179 18.178-0.349 27.266-0.369 3.931-0.008 3.913-2.858 3.883-5.647-0.032-2.946-1.235-3.985-4.42-3.832-12.994 0.628-26.006 0.924-39.012 1.342v0.002c-7.524-1.313-15.094-1.588-22.703-0.962-6.305-0.098-12.547-1.461-18.882-0.919-1.209-0.303-2.404-0.695-3.631-0.893-10.016-1.652-20.234-2.008-30.077-4.773-3.506-0.984-7.103-1.092-10.717-0.954h-0.003c-6.27-3.069-13.061-3.423-19.848-3.792 0 0 0.002 0 0.002 0.002-0.002-0.002-0.002-0.002-0.002-0.002-6.142-0.080-12.055-1.975-18.061-2.573-14.025-1.393-28.142-2.387-42.223-2.424-6.008-0.015-12.17-2.116-18.156 0.284h-0.002c-0.765 0.421-1.559 0.532-2.362 0.537 0.79-0.141 1.576-0.313 2.362-0.537-6.974 0.288-14.023-1.332-20.917 0.831-0.002 0-0.003 0-0.005 0-9.53 0.17-19.094 0.048-28.356 2.881-7.723-0.303-15.161 1.646-22.683 2.917-11.756 1.986-23.505 4.051-35.255 6.089-0.869-0.042-1.735-0.020-2.553 0.444-7.645 0.519-15.284 1.12-22.935 1.541-20.621 1.13-41.251 0.858-61.886 0.319-1.792-1.197-3.817-0.833-5.783-0.864-4.088-0.396-8.142-1.242-12.286-0.873-1.275 0.025-2.55 0.048-3.825 0.073-4.399-0.994-8.792-1.986-13.189-2.981-8.383-0.070-16.494-1.905-24.603-3.749-0.386-2.359-2.329-2.766-4.156-3.22-3.313-0.816-6.644-1.541-10.014-2.071 0.605-0.417 1.343-0.698 1.717-1.36 1.541-2.668 3.403-5.068 5.504-7.348 1.298-1.408 3.19-2.868 2.49-5.177 0.153-0.012 0.306-0.022 0.457-0.060 0.178-0.085 0.344-0.193 0.514-0.291 4.048 3.498 7.84 7.374 12.241 10.351 9.557 6.473 12.469 7.216 20.532 2.259 4.224-2.597 6.425-7.093 8.059-11.316 2.582-6.671 7.238-9.008 13.734-9.223-0.005 0-0.007 0-0.010 0 0.003 0 0.005 0 0.010 0 0.623 0 1.247 0 1.87-0.003 0.891-0.578 2.026 0.77 2.901 0.085 0.409 0.583 0.919 1.077 1.37 1.622 4.417 2.583 8.165 6.116 12.687 8.596 3.968 2.174 7.339 1.948 11.317-0.148 3.858-2.031 6.334-5.404 9.582-7.986 0.582-0.424 1.212-0.756 1.858-1.064 0.628-0.384 1.258-0.771 1.888-1.154 0 0 0 0-0.002 0 0.002 0 0.002 0 0.002 0 1.593 0.073 3.182 0.141 4.773 0.214 1.872-0.012 3.742-0.022 5.612-0.035 2.204-0.103 4.409-0.209 6.614-0.313 5.812 0.474 11.611 1.004 17.466 0.803 2.066-0.073 3.993 0.296 4.505-2.407-0.002-0.003-0.003-0.005-0.005-0.008 3.858-0.351 7.718-0.702 11.575-1.052 0.105 0.221 0.224 0.432 0.379 0.635 0.352 0.332 0.761 0.572 1.223 0.698 2.204 0.249 3.614-1.556 5.499-2.138 1.847-0.080 3.699-0.158 5.546-0.238 0.068-0.259 0.145-0.517 0.229-0.77 2.321-1.32 4.974-1.428 7.495-2.011v0.003c3.195 0.396 6.29-0.372 9.412-0.803 3.004 0.319 5.996 0.796 8.988 1.047 2.597 0.216 5.768 0.801 6.877-2.929-0.060-0.381-0.148-0.702-0.258-0.976 2.43 0.096 4.636-0.8 6.874-1.561 0.567 0.196 1.13 0.396 1.686 0.62 1.090-0.294 2.236-0.381 3.265-0.898 0.593-0.048 1.189-0.098 1.782-0.145 0.224 0.204 0.459 0.389 0.733 0.519 0.796 0.243 1.513 0.018 2.204-0.372 2.515-0.662 5.030-1.327 7.549-1.99 5.841-1.963 11.856-0.537 17.777-0.906 6.087-0.381 12.261 0.913 18.276-0.936l-0.293-0.105c0.065-0.022 0.13-0.042 0.194-0.063 0.033 0.057 0.065 0.111 0.098 0.17 3.438 0.012 6.88 0.022 10.318 0.032 9.657-0.028 19.31-0.048 28.968-0.076 0.012 2.219 2.339 0.836 3.087 1.905 1.586 1.13 3.158 0.692 4.733-0.035 11.34 1.082 22.575 3.438 34.055 2.846 1.998 0.309 3.988 0.706 5.996 0.906 10.361 1.027 20.3 4.756 30.81 4.817 3.044 3.062 6.937 1.416 10.446 1.882 0.941 0.308 1.882 0.612 2.819 0.921 6.182 1.842 12.536 1.97 18.911 1.882 1.262 0.748 2.651 0.906 4.084 0.939 13.761 0.308 27.523 0.628 41.282 0.941 10.674 1.127 21.193-1.275 31.81-1.345 4.817-0.030 4.134-3.276 4.003-6.192-0.158-3.494-2.422-3.72-5.311-3.428-6.375 0.65-12.777 1.032-19.167 1.524-15.435-0.313-30.868-0.632-46.303-0.944-3.729-0.165-7.431 0.003-11.186-0.698-12.246-2.279-24.571-4.131-37.020-5.005-0.318-0.293-0.638-0.585-0.958-0.878-9.605-0.667-18.804-3.745-28.346-4.799-1.745-1.283-3.808-1.137-5.81-1.446-3.587-0.562-7.377-0.427-10.642-2.384 1.568-3.014 2.698-6.234 4.349-9.213 1.95-3.518 5.659-5.185 8.36-3.255 1.629 1.165 3.591 2.106 4.791 3.732 4.108 5.582 9.545 9.020 16.359 9.844 6.827 0.823 13.103-0.628 18.036-5.953 3.569-3.853 6.074-8.34 7.911-13.194 1.079-2.851 2.826-4.759 5.797-5.497 2.209 0.003 4.417 0.010 6.624 0.013l-0.025-0.055c0.018 0 0.035 0.003 0.050 0.003-0.008 0.018-0.017 0.035-0.027 0.052-0.002 0.309-0.003 0.612-0.003 0.918 5.361 0.161 10.652 1.425 16.050 0.958 1.448 0.972 3.095 0.898 4.728 0.898h0.002c13.202 0.093 26.415 0.467 39.609 0.176 9.401-0.208 18.788-1.298 28.173-2.038 1.287-0.103 3.020 0.326 3.13-1.892 0.186-3.764-2.494-6.486-6.408-6.55-16.454-0.263-32.914 1.639-49.365-0.058-2.846-0.791-3.925-2.384-2.56-5.27 3.702-7.828 4.804-16.261 5.333-24.751 0.249-3.996 2.146-5.723 5.863-5.823 3.777-0.103 7.559-0.032 11.335-0.095 2.597-0.045 5.23-0.066 7.377-1.794-1.145-2.665-4.468-1.081-5.703-3.827 2.425-1.046 5.68 0.934 7.474-2.384-9.427-2.296-18.944-0.834-28.175-2.372-1.578 0-3.153 0-4.734 0-4.023-0.103-5.502-4.038-8.524-5.647-2.926-2.011-5.775-4.177-9.427-4.741-3.042-1.947-6.513-3.348-8.521-6.626-2.605-1.428-3.576-3.667-3.391-6.573 0.313-4.934 2.651-8.756 6.355-11.854 0.843-0.703 2.244-0.959 2.1-2.422 4.314-0.514 7.464-3.494 7.898-7.1 0.811-6.764 0.597-13.781-2.608-20.211-0.918-1.594-1.835-3.188-2.751-4.784-1.35-4.028-5.102-5.428-8.33-7.133-7.855-4.153-8.116-4.041-6.684-12.391 0.715-4.174 1.749-8.076 4.786-11.786 6.884-8.401 9.886-18.467 1.735-29.181-0.612-4.292-3.797-6.739-6.716-9.382v0c-1.042-1.797-3.040-2.060-4.674-2.911-7.218-5.173-8.455-9.598-4.558-16.648 0.344-0.622 0.703-1.278 1.137-1.872 3.378-4.65 6.777-9.118 8.834-14.742 2.598-7.1 1.631-15.41-3.915-20.317-0.613-0.544-1.28-0.883-2.114-0.853-0.040 0.018-0.071 0.042-0.11 0.060 0.919-2.703-1.97-3.469-3.084-5.14-0.929-0.638-1.857-1.275-2.784-1.912-2.211-1.868-4.423-3.735-6.636-5.602-0.002-0.003-0.002-0.003-0.002-0.003s0 0 0.002 0c-1.627-3.675-4.488-6.947-3.77-11.397 1.288-3.926 5.295-5.469 7.537-8.614 3.045-4.264 3.271-9.354 4.748-14.073v0.002c1.814-7.412-1.445-13.3-5.674-18.901-0.956-0.943-1.912-1.888-2.871-2.833-2.48-1.935-4.583-4.37-7.52-5.7-2.228-1.16-4.204-2.622-5.674-4.696-0.314-0.63-0.63-1.26-0.943-1.892 0.411-4.405-0.349-8.894 0.946-13.236 4.34-2.976 6.423-7.339 7.56-12.286v0c2.706-5.67 3.155-11.34 0.002-17.012-1.538-4.44-3.461-8.623-7.585-11.332-1.458-2.306-3.634-3.887-5.657-5.622v0c0.319-0.652 0.638-1.302 0.956-1.953-0.422-1.543-1.049-2.934-2.417-3.926-3.451-2.502-3.526-5.471-1.548-9.065 1.834-3.335 4.114-6.325 6.292-9.406 8.062-11.414 5.697-28.662-3.458-36.267-4.217-3.503-8.629-6.791-12.642-10.513-3.858-3.577-3.953-6.53-1.041-10.893 2.008-3.012 4.299-5.856 6.074-8.997 5.295-9.362 7.243-18.921 1.95-29.162-3.232-6.252-8.696-9.851-14.281-13.29-7.648-4.711-7.702-9.494-3.933-17.094 2.572-5.191 6.214-9.819 7.861-15.501 3.29-11.35-0.427-26.742-14.735-33.639-8.531-4.116-9.425-8.975-4.131-16.633 0.359-0.519 0.72-1.036 1.1-1.534 12.095-15.806 10.26-36.798-9.886-48.675-5.72-3.373-6.453-7.367-2.543-12.837 4.397-6.147 8.28-12.271 9.068-20.337 1.232-12.647-3.469-22.476-13.851-29.739-11.48-8.029-13.217-10.172-10.077-22.403 1.395-5.439 0.572-10.807-0.721-15.857-1.425-5.57-4.158-11.089-9.66-13.975-5.416-2.841-11.169-5.040-16.751-7.567-1.932-0.876-3.644-0.806-5.182 0.756-3.463 0.091-6.927-2.086-10.385 0.007-0.951 0.625-1.902 1.25-2.851 1.875-3.2-0.394-6.297-0.332-8.697 2.262-2.771 2.994-5.589 5.94-7.602 9.562-4.139 7.452-5.321 7.572-11.56 1.43-0.447-0.442-0.896-0.881-1.337-1.33-9.499-9.618-24.857-8.403-32.52-3.070-4.934 3.434-8.44 8.388-11.716 13.402-2.179 3.335-4.57 4.041-7.677 1.132-1.83-1.714-3.68-3.501-5.81-4.776-4.058-2.432-7.82-6.049-13.265-4.437-3.148 0.324-6.437-1.955-9.289-0.469-6.053 3.15-12.537 5.868-16.555 11.914-1.391 2.091-2.721 4.234-4.241 6.23-2.557 3.363-4.746 3.439-7.653 0.286-5.895-6.398-12.981-9.668-21.808-8.51-1.78-0.806-3.629-1.107-5.507-0.459-7.266 2.502-13.782 5.655-17.187 13.46-3.644 8.355-8.408 9.065-15.029 2.56-3.795-3.73-8.43-5.516-13.294-6.663-7.693-1.815-14.793 0.788-20.596 5.426-4.041 3.228-7.673 7.339-9.996 12.364-1.536 3.325-4.284 4.256-7.801 2.021-2.41-1.529-4.64-3.187-6.681-5.172-3.66-3.557-11.284-5.632-17.33-2.745-0.314 0.002-0.628 0.003-0.941 0.005-1.481-0.637-3.065-1.212-4.517-0.229-5.296 3.584-11.159 6.556-13.914 12.926-0.613 1.42-1.654 2.666-2.58 3.933-2.194 2.994-4.689 3.557-7.436 0.708-5.772-5.986-13.093-8.305-21.105-9.233-2.613-0.303-4.65 0.158-6.232 2.279-0.311 0.003-0.622 0.007-0.933 0.010-9.545 0.143-14.76 6.47-18.412 13.965-3.429 7.037-5.158 7.783-10.863 1.962-5.291-5.399-11.562-8.514-19.087-8.927-11.463-0.63-19.035 5.491-24.915 14.534-4.133 6.352-8.461 6.565-13.27 0.768-5.102-6.147-13.51-8.624-21.203-6.244l0.002 0.003c-2.161-0.233-4.079-0.073-6.312 0.728-7.53 2.706-11.635 8.805-15.894 14.785-4.3 6.038-5.452 6.476-10.596 1.189-8.367-8.603-18.405-8.325-28.803-5.9-8.082 1.887-12.213 8.187-15.689 15.149-2.954 5.918-5.221 6.259-9.894 1.646-5.567-5.494-12.511-7.826-19.96-8.431-3.788-0.308-7.836-0.058-11.483 1.815-5.732 2.944-9.883 7.409-13.28 12.82-3.828 6.096-6.087 6.315-11.598 1.84-3.785-3.075-7.635-6.029-12.343-7.66-5.368-1.858-13.571-0.761-16.133 2.299h-0.013c-2.484-1.282-4.427-0.228-6.46 1.243-5.826 4.209-9.041 10.19-11.972 16.519-3.253 7.025-5.241 7.793-12.572 5.742-3.562-0.997-7.078-1.297-10.599 0.095-1.342-0.012-2.65 0.108-3.79 0.921-0.959 0.948-1.917 1.893-2.874 2.839-5.163 2.349-8.589 5.828-8.406 12.009 0.143 4.817-0.032 9.647-0.066 14.471-0.334 4.399 1.441 8.313 2.834 12.315 1.79 2.715 4.573 3.443 7.552 3.777 2.821 1.267 5.642 2.53 8.463 3.795 4.033 3.479 5.273 8.382 6.711 13.182 0.424 5.755 0.003 11.309-3.845 16.042 0 0.002 0 0.002 0 0.002-6.207 3.572-9.796 8.85-10.456 16.040 0 0 0 0.002 0 0.002-1.046 1.94-0.921 3.85-0.103 5.871 2.542 6.279 6.739 10.863 13.171 13.252 4.626 2.916 9.484 5.599 11.324 11.307 0.73 1.849 1.461 3.702 2.193 5.552 0.229 4.673-0.138 9.218-2.839 13.264-1.586 1.563-3.17 3.127-4.754 4.691-5.835 3.197-6.91 9.266-8.855 14.783-0.884 2.508-0.567 4.932 1.255 7.020 0.901 3.361 3.958 3.752 6.563 4.764 0 0.002 0 0.002 0 0.002 2.937 1.182 5.875 2.364 8.812 3.546 9.913 6.111 14.228 14.951 12.052 24.696-2.879 4.791-6.558 8.677-11.806 10.966-1.052 0.459-2.307 1.554-2.552 2.577-1.405 5.883-3.323 11.844 0.175 17.702 0 0 0.002 0 0.002 0 2.693 4.671 6.676 7.914 11.427 10.303 6.5 3.694 11.394 8.671 13.039 16.258 0 0 0 0 0 0.002 0.429 8.328-2.558 14.615-10.338 18.492-4.016 2-4.916 5.833-4.279 10.11 0.851 5.73 3.956 10.544 6.24 15.692 1.524 1.729 3.232 3.207 5.439 4.015 2.1 1.408 4.445 2.59 4.997 5.424-0.69 3.104-2.73 5.314-4.901 7.444v0c-3.2 2.126-6.663 3.882-9.381 6.686 0.793 2.113-0.7 3.017-2.090 4.001-1.641 1.16-3.089 2.482-3.483 4.596-0.598 0.816-1.199 1.634-1.797 2.45-0.091-0.136-0.196-0.276-0.318-0.416-2.951-1.534-4.475 1.009-5.86 2.523-4.191 4.578-7.8 9.665-11.851 14.376-1.541 3.017-4.593 4.756-6.466 7.416-7.76 11.015-16.788 21.015-23.828 32.69-6.242 10.355-11.819 20.957-17.142 31.737-7.557 15.305-12.529 31.573-16.512 48.090-4.881 20.232-7.19 40.8-7.118 61.679 0.037 10.238 1.195 20.324 1.913 30.481 0.916 12.94 4.106 25.417 6.872 37.921 2.394 10.822 6.566 21.326 10.72 31.664 8.639 21.489 20.144 41.548 34.239 59.829 12.316 15.967 25.871 30.988 42.122 43.352 8.121 6.174 15.754 13.068 24.445 18.414 15.907 9.786 32.367 18.489 49.822 25.399 14.695 5.82 29.819 10.22 45.197 13.004 16.146 2.924 32.588 4.665 49.15 4.485 16.248-0.181 32.431-1.421 48.341-4.317 19.634-3.572 38.751-9.281 57.121-17.351 6.505-2.858 12.537-6.623 20.656-5.635 12.883 1.569 26.006 1.047 38.967 2.121 22.217 1.842 43.897 7.191 65.834 10.88 6.862 1.368 13.754 2.367 20.784 1.888 1.521 1.037 3.258 1.007 4.997 1.059 19.122 0.539 38.214 1.662 57.376 1.031 20.272-0.667 40.401-2.47 60.404-5.723 4.485-0.73 9.022-1.408 13.31-3.069 7.999-0.444 15.819-2.106 23.665-3.567 4.827-0.151 9.708 0.098 14.276-1.945 0 0 0 0 0.002 0 7.874 0.65 15.641-1.361 23.509-0.948v0c14.502-0.052 29.001-0.101 43.503-0.151 0 0 0 0 0.002 0 3.263 1.952 6.774 0.236 10.19 0.643 11.362 1.355 22.786 2.198 34.186 3.237 20.329 4.404 40.757 8.219 61.467 10.378 5.951 1.022 11.859 2.826 17.967 0.972 0.299 0.015 0.598 0.018 0.898 0.015 4.681 1.12 9.374 2.138 14.205 0.894l0.474 0.008h0.472c8.451 1.767 17.012 0.613 25.52 0.951 8.952-0.322 17.9-0.703 26.852-0.938 2.922-0.078 4.262-1.225 4.347-4.234 0.138-4.914-0.989-6.604-5.926-6.036zM510.12 823.298c-7.781 14.901-16.981 28.875-27.387 42.050-1.099 0.858-2.144 1.76-2.907 2.971-0.037 0.228-0.088 0.442-0.148 0.647-1.31 1.348-2.62 2.695-3.931 4.043-0.578 0.327-1.162 0.655-1.711 1.017-0.979 1.092-1.844 2.252-2.543 3.511-0.821 0.883-1.644 1.762-2.467 2.646-2.71 0.396-4.292 3.124-6.503 4.538-1.042 1.185-1.902 2.467-2.302 3.996-0.371 0.033-0.648 0.243-0.859 0.588-0.032-0.063-0.070-0.12-0.1-0.186-0.145-0.060-0.293-0.103-0.442-0.138 2.156-3.193-0.557-6.377-0.685-9.563 2.861-3.138 5.72-6.277 8.579-9.414-3.16 0.708-4.666 3.486-6.834 5.439-1.707 1.541-3.353 3.489-5.652 3.775-2.114 0.261-6.965-6.684-6.829-8.95 0.085-1.405 0.59-2.984 0.387-4.325-0.128-1.568-0.844-3.012-2.863-4.146-3.546-0.711-5.329 1.032-6.021 4.307-0.294 1.395-0.743 2.736-1.418 3.988-3.255 6.051-10.247 8.478-16.078 5.602-5.664-2.791-7.904-9.176-4.935-15.274 2.317-4.756 6.623-6.995 11.804-7.364 3.258-0.229 5.644-1.421 5.625-4.952-0.015-3.366-2.701-4.307-5.466-4.802-6.548-1.177-11.394 1.852-16.081 6.031-11.131 9.922-9.776 23.737 0.484 32.692 4.872 4.249 10.77 4.759 16.495 6.206 0.125 0.066 0.244 0.115 0.366 0.166-1.014 1.908-1.508 4.023-2.011 6.131-0.002 0.003-0.003 0.003-0.003 0.007-1.285 2.334-2.382 4.802-3.902 6.972-2.161 3.090-4.447 6.468-9.038 5.394-4.596-1.074-8.142-3.394-8.405-8.749-0.081-1.684-0.482-3.376-2.472-3.421-4.049-0.085-5.539-3.082-7.18-5.916-0.791-1.365-1.398-2.821-2.813-3.692-6.33-8.548-12.265-10.594-22.423-7.733-12.308 3.468-17.435 21.195-8.795 30.422 0 0 0 0 0 0 0.595 2.239 4.788 3.428 2.826 6.016-2.043 2.695-5.551 3.057-8.882 1.591-0.141-0.060-0.278-0.131-0.416-0.198 0.136-2.966-1.318-5.536-2.065-8.282-0.342-0.514-0.404-1.084-0.389-1.669 0.13 0.555 0.261 1.11 0.389 1.669 0.617-5.891-1.149-11.492-2.291-17.137-0.495-2.447-2.256-4.177-5.21-3.416-2.786 0.716-2.384 2.735-2.055 4.869 0.527 3.439 1.82 6.796 1.561 11.329-2.435-2.976-3.956-5.647-6.209-7.367-2.364-1.804-5.17-5.627-8.458-0.864-0.61 0.108-1.22 0.221-1.83 0.332-0.62 0-1.242-0.003-1.862-0.003-1.809 0.088-3.202-2.881-4.965-1.165-1.44 1.398-0.171 3.511 0.093 5.303 0.022 0.153 0.081 0.299 0.123 0.447-0.098 0.246-0.136 0.502-0.121 0.765 0 0.002 0 0.005 0 0.005-1.744 3.127-4.349 5.826-4.768 9.61-0.485 0.909-0.969 1.819-1.569 2.939-2.238-4.733 0.030-9.824-2.036-14.294-0.201-0.916-0.462-1.825-0.588-2.754-0.173-1.25-0.11-2.715-1.962-2.518-1.337 0.138-2.389 0.954-2.671 2.304-0.221 1.049-0.126 2.169-0.141 3.262-0.11 8.167 1.283 16.198 2.259 24.268-0.241 0.319-0.48 0.638-0.723 0.958-1.358 1.165-2.858 2.008-4.701 2.071v0c-1.86-1.885 1.888-5.318-1.051-6.242-7.168-2.251-6.545-7.728-6.551-13.274-0.002-3.446 0.196-6.279 4.734-6.398 2.050-0.053 2.793-1.765 2.728-3.722-0.060-1.77-0.844-3.247-2.658-3.338-6.649-0.329-13.344-1.538-19.923 0.59-1.089 1.039-0.366 3.079-2.073 4.033-4.984-7.632-13.031-7.525-20.551-8.701-2.435-1.724-4.909-3.875-6.636 0.768-1.617-1.614 0.801-3.13-0.342-4.636-1.732-0.505-3.601 1.373-5.318-0.1-2.442-2.098-6.315-2.262-7.745-5.782-0.135-0.326-1.491-0.592-1.602-0.429-1.907 2.833-5.396 1.054-7.668 2.696 0 0 0.002 0 0.003 0-0.002 0-0.002 0-0.003 0-0.386 0.966-0.773 1.935-1.16 2.906-0.219 0.008-0.444 0.042-0.672 0.096-0.406 0.052-0.8 0.108-1.204 0.233-2.731-0.156-0.904-2.651-1.908-3.705-1.071-1.835-2.189-3.582-4.744-2.695-0.238-0.218-0.475-0.439-0.713-0.658-2.060-4.37-6.082-6.244-10.19-7.996-0.972 0.078-1.963 0.012-2.947-0.010-0.545-0.13-1.12-0.17-1.712-0.123-1.995 0.155-3.117-0.766-4.076-2.236v0c0 0 0 0 0 0-0.306-0.64-0.615-1.28-0.921-1.92-3.516-2.841-1.709-7.2-2.666-10.784-1.83 4.957-4.754 9.344-4.882 14.599 0-0.003 0.003-0.003 0.003-0.007 0 0.003-0.002 0.003-0.003 0.007-0.851 1.109-1.704 2.214-2.555 3.321-0.010-0.005-0.017-0.015-0.027-0.022-0.421-0.18-0.863-0.253-1.318-0.208-0.314 0.063-0.534 0.186-0.71 0.337-0.248-0.682-0.525-1.38-0.352-2.234 1.31-6.485 1.491-13.129 1.672-19.695 0.111-4.068 0.115-8.252-1.93-12.032 0.467 0.467 0.923 0.948 1.36 1.453 0.938 1.081 2.196 1.218 3.459 0.632-0.166 0.633-0.075 1.275 0.244 1.92 3.493 4.44 8.315 7.311 12.639 10.767 2.070 1.845 4.934 1.185 7.329 2.517 5.792 3.222 11.246 7.301 18.021 8.466 13.736 5.438 27.374 11.204 42.351 12.398 10.396 2.754 21.054 2.668 31.624 2.236 20.352-0.838 39.816-5.215 58.745-13.33 12.381-5.308 23.873-11.542 34.339-19.808 6.761-5.336 13.989-10.212 19.072-17.403 0.954-0.635 1.908-1.268 2.863-1.903 0.833-0.12 1.666-0.248 2.498-0.372 0.354 0.224 0.768 0.399 1.253 0.514 1.408 0.326 2.375-0.304 3.19-1.187 3.306-0.514 6.606-1.064 9.898-1.661-0.913 4.556 0.399 5.715 5.082 5.236 10.001-1.021 19.767-3.483 29.658-5.15 11.739-1.975 23.452-4.083 35.132-6.417-0.324 0.64-0.677 1.268-1.099 1.872-5.371 7.712-8.706 16.657-14.521 24.119-0.66 0.849-1.090 2.085 0.967 2.387 0.642-0.504 1.385-1.067 2.1-1.654 2.179-1.8 2.204-4.995 3.84-6.817 5.444-6.061 8.172-13.591 11.887-20.571 1.481-0.374 2.803-0.921 3.958-1.682-1.243 2.803-2.676 5.509-4.093 8.219zM406.089 920.172c-0.007 0.007-0.013 0.015-0.022 0.022-0.008-0.048-0.027-0.1-0.032-0.148-0.018-0.035-0.038-0.076-0.058-0.111 0.017 0.013 0.037 0.025 0.055 0.035 0.002 0.028 0 0.048 0.002 0.076 0.025 0.045 0.033 0.085 0.055 0.126zM331.658 945.463c-0.023 0.025-0.047 0.045-0.070 0.066-0.052 0.010-0.103 0.018-0.155 0.028-0.027-0.012-0.055-0.025-0.083-0.033 0.101-0.022 0.204-0.040 0.308-0.062zM264.466 943.965c-0.002-0.083-0.012-0.155-0.023-0.224 0.095 0.163 0.108 0.382 0.003 0.685-0.015 0.080-0.037 0.158-0.057 0.236 0-0.003 0-0.003-0.002-0.003 0 0 0 0.003 0 0.010 0 0 0 0 0 0.003v-0.013c0.015-0.060 0.018-0.113 0.030-0.17 0.007-0.022 0.022-0.045 0.028-0.063 0.030-0.158 0.040-0.313 0.020-0.46zM264.388 944.678v0c-0.032 0.025-0.062 0.047-0.090 0.071 0.015-0.033 0.028-0.063 0.043-0.093 0.015 0.005 0.032 0.012 0.047 0.022zM188.29 797.558c-0.578-0.439-1.155-0.874-1.847-1.114 0.023-0.022 0.045-0.035 0.068-0.052 1.204-2.201-0.083-3.639-1.659-4.778-1.734-1.25-2.813-2.902-3.67-4.776-1.346-1.391-1.799-3.222-2.454-4.947-2.588-5.336-5.075-10.724-7.564-16.105-7.459-16.115-9.033-33.265-10.263-50.548-0.381-5.329 0.954-10.601 0.82-15.934 0.062-1.031 0.128-2.066 0.13-3.099-0.296-1.903 0.552-4.044-0.53-5.782 0.116-0.136 0.231-0.274 0.346-0.407 0.78-0.894 1.461-1.835 1.308-3.12-0.357-2.356 1.215-4.118 1.915-6.142 0.386-2.636 1.385-5.167 2.060-7.756 0.404 1.963 1.479 3.709 4.056 4.959 4.588 2.226 9.176 4.447 13.764 6.673-0.066 5.318 3.12 9.218 5.858 13.314-0.539 3.717-1.925 7.126-3.737 10.386-0.407 2.459-2.62 3.717-3.772 5.684-1.25 1.586-2.502 3.17-3.752 4.756-1.892 4.548-2.661 9.224-1.328 14.058 1.3 4.721 4.073 8.656 6.94 12.522 0 0 0 0 0.002 0 0 0.003-0.002 0.003-0.002 0.003-1.243-0.442-2.487-0.879-3.73-1.318-2.819 1.046-2.311 3.301-1.072 4.806 1.75 2.119 3.484 4.334 5.785 6.019 4.423 3.238 8.333 6.998 10.84 12.004 0.906 1.812 2.070 3.138 4.003 2.814-0.434 1.398-1.539 2.412-2.339 3.602-0.263 0.022-0.539 0.018-0.846-0.033-2.871 0.984-3.78 3.286-4.049 6.021-0.484 1.13-0.738 2.45-1.489 3.36-3.75 4.535-4.532 9.58-3.79 14.929zM170.765 617.603c0.008 0 0.018-0.007 0.027-0.008 0.022-0.025 0.042-0.048 0.065-0.073-0.007 0.018-0.015 0.038-0.022 0.057-0.015 0.010-0.028 0.013-0.042 0.017-0.005 0.005-0.010 0.012-0.017 0.018-0.005-0.003-0.008-0.007-0.012-0.010zM182.034 623.189c0.966-1.559 1.932-3.12 2.897-4.678 3.471-3.325 6.724-6.892 10.049-10.335 8.002-8.283 17.195-14.989 26.898-20.817 4.099-2.46 5.994-4.791 5.617-8.77 0.15-0.063 0.298-0.126 0.447-0.186 0.364-0.060 0.721-0.161 1.069-0.281 1.031 1.91 2.346 2.538 3.827 2.419-1.584 2.344-2.906 4.826-5.138 6.718-1.524 0.081-2.427 1.092-3.311 2.128-1.702 0.994-3.353 2.070-4.964 3.205-0.52-0.155-1.11 0.098-1.521 0.49-1.975 1.882-4.533 3.195-6.209 5.374-0.894 0.706-1.79 1.411-2.686 2.113-1.814 0.303-2.858 1.752-3.941 3.142-2.74 2.326-5.281 4.839-7.78 7.394-0.332-0.136-0.916-0.161-1.001-0.032-1.938 2.921-5.718 4.389-6.844 7.943-0.196 0.186-0.386 0.381-0.585 0.565-1.087 1.85-1.747 3.843-2.023 5.971 0.527 1.18 0.951 2.274 0.667 3.321-0.221-0.060-0.441-0.12-0.66-0.176v-0.003c-2.808-0.991-3.406 2.981-6.4 2.711 0.991-2.771 4.049-5.113 1.593-8.215zM221.886 482.472c-2.492-0.171-3.878-1.451-4.723-3.863-1.333-3.812-1.908-5.386-0.941-6.987 1.883-0.718 3.782-1.396 5.708-2.008 0.755-0.588 1.538-1.147 2.011-2.021 0.1-0.183 0.173-0.361 0.239-0.539 0.68 1.127 2.078 0.58 3.232 0.406 1.177-0.178 1.817 0.18 1.631 1.479 1.187 2.402 3.355 2.173 5.314 1.669 4.415-1.132 8.9-1.952 13.324-3.054 11.741-2.922 23.713-4.708 35.744-5.612 10.139-0.761 20.314-0.8 30.547-0.392 5.692 0.226 11.327 0.667 16.933 1.3 0.243 1.112 0.414 2.231 0.47 3.353 0.209 4.134 1.991 6.722 3.624 9.41-17.835-2.211-35.775-2.786-53.881-1.265-18.168 1.524-35.561 6.039-53.014 10.664-0.003 0.314-0.007 0.628-0.010 0.943-1.109 1.421-2.725 2.005-4.329 2.588-0.643 0.234-1.248 0.502-1.634 0.967-0.778-1.358-4.39 0.577-4.565-1.835 0.996-1.222 3.499-1.574 4.171-3.641 0.118-0.076 0.238-0.153 0.354-0.228 0.196-0.487 0.128-0.931-0.206-1.335zM327.377 393.597c2.008 5.461 3.764 10.228 5.516 14.993 0.055 0.007 0.11 0.013 0.165 0.022-0.002 0.076-0.005 0.156-0.008 0.234 1.877 1.968 3.74 3.978 6.357 6.799-0.216-2.912-0.374-5.039-0.534-7.2 0.243-0.218 0.567-0.647 0.685-0.595 7.755 3.325 13.192-2.036 19.077-5.258 5.669-3.104 11.828-2.384 17.819-3.185 4.488-0.598 9.005-1.445 13.317-2.789 4.113-1.285 7.944-1.373 11.979 0.013 0.778 0.269 1.982-0.446 2.899-0.891 3.085-1.503 6.129-3.087 9.191-4.64 0.347 0.441 0.698 0.879 1.046 1.317-0.602 1.165-0.938 3.044-1.849 3.385-7.939 2.966-4.886 11.859-9.773 16.377 0.145 0.502 0.293 1.004 0.437 1.504 3.567 0.256 7.16 0.883 10.694 0.645 2.869-0.193 6.049-0.517 6.771 2.47 0.788 3.26-1.847 5.349-5.019 6.29-0.585 0.173-1.14 0.447-1.627 0.642-0.397-0.271-0.8-0.389-0.881-0.623-2.508-7.195-2.487-7.113-10.006-4.814-2.66 0.813-5.486 1.081-8.27 1.604 0.449 2.216-4.55 8.867-7.402 8.232-1.345-0.301-3.353-3.71-3.157-3.918 3.030-3.22 6.157-6.447 9.738-9.003 1.709-1.218 4.422-1.031 7.336-1.609-2.804-1.735-5.383-3.335-7.964-4.934 0.037-0.349 0.071-0.698 0.11-1.047 1.508 0.090 3.017 0.178 4.059 0.241 2.093-2.693 4.114-5.288 6.132-7.886-0.14-0.397-0.281-0.796-0.421-1.194-2.799 0.436-5.753 0.439-8.368 1.385-8.952 3.242-17.709 7.030-26.684 10.205-10.725 3.797-21.575 7.249-32.449 10.599-0.876 0.269-3.301-1.318-3.381-2.191-0.301-3.278 0.027-6.614 0.14-9.931-0.035-0.035-0.068-0.070-0.101-0.106-0.018-0.048-0.035-0.098-0.053-0.148-1.533-0.185-3.065-0.371-4.598-0.554 1.001-4.959-6.269-8.152-0.921-14.441zM321.265 368.033c0.489-0.904 2.176-1.732 3.197-1.617 1.074 0.123 2.748 1.308 2.892 2.228 0.678 4.332 0.921 8.734 1.318 13.111 0.554-0.007 1.107-0.015 1.661-0.023-0.161-2.528-0.296-5.062-0.49-7.589-0.186-2.41-2.821-5.642 1.094-6.821 3.552-1.071 5.913 1.165 6.644 4.851 0.052 0.263 0.341 0.479 0.866 1.174 0.46-1.539 0.828-2.761 1.247-4.166 2.086-0.224 4.214-0.455 6.653-0.72 0.379 2.223 0.728 4.259 1.355 7.931 1.93-6.377 4.515-5.943 8.721-4.134 2.424 1.044 6.126-1.114 9.292-1.521 4.104-0.527 8.249-0.748 12.376-1.1 0.057 0.647 0.111 1.295 0.166 1.942-1.669 0.377-3.338 0.758-5.009 1.135 0.010 0.266 0.018 0.532 0.028 0.796 2.026-0.095 4.074-0.399 6.073-0.199 1.064 0.106 2.043 1.077 3.062 1.661-0.715 0.923-1.242 2.319-2.176 2.686-3.85 1.524-7.823 2.74-11.749 4.066 0.080 0.554 0.161 1.107 0.241 1.659 3.173-0.397 6.377-0.635 9.514-1.228 5.462-1.034 10.87-3.062 16.326-3.153 3.192-0.055 6.631 2.54 9.582 4.508 1.955 1.305 0.216 5.133-2.49 5.679-7.801 1.563-15.579 3.29-23.442 4.457-3.059 0.455-6.327-0.723-9.475-0.597-3.878 0.158-7.851 0.477-11.562 1.518-3.587 1.007-6.774 3.404-10.35 4.495-4.64 1.413-9.489 2.134-13.317 2.956-1.302-5.981-2.322-10.674-3.503-16.098 2.302-1.918 3.371 1.175 4.824 2.828 1.626 1.85 3.117 3.818 5.913 5.477-0.138-2.083-0.274-4.166-0.505-7.683 3.325 1.132 6.201 2.108 9.018 3.065 0.962-1.481 1.759-4 3.418-4.866 1.396-0.728 3.797 0.464 6.177 0.878 0.771-0.858 1.978-2.211 3.2-3.549 1.105-1.212 2.231-2.407 4.023-4.335-8.012 1.692-14.976 3.376-22.024 4.571-4.683 0.793-9.492 1.267-14.231 1.182-4.965-0.090-10.923-11.081-8.556-15.451zM325.175 390.102c-0.916-0.071-2.532 0.075-2.635-0.253-0.56-1.8-0.753-3.715-1.072-5.59 0.926-0.103 1.85-0.206 2.774-0.309 0.309 2.053 0.62 4.103 0.933 6.152zM332.064 356.264c0.47-0.239 0.943-0.475 1.415-0.713 1.907 1.428 3.847 2.823 5.624 4.399 0.085 0.075-1.17 2.452-1.977 2.57-1.711 0.254-4.542 0.311-5.083-0.62-0.818-1.398-0.065-3.712 0.022-5.635zM348.715 360.157c0.047 0.821 0.093 1.641 0.141 2.459-2.181 0-4.365 0.068-6.533-0.106-0.211-0.017-0.301-1.531-0.447-2.352 2.282 0 4.56 0 6.839 0zM347.34 357.63c0.136-0.711 0.276-1.425 0.412-2.136 4.709 0.675 9.424 1.307 14.115 2.091 0.495 0.083 1.056 1.032 1.17 1.654 0.068 0.372-0.638 0.933-1.071 1.325-0.204 0.186-0.612 0.303-0.879 0.241-4.586-1.039-9.168-2.111-13.748-3.175zM384.050 374.393c1.985-2.159 3.34-3.634 4.508-4.907 1.39 1.047 2.824 2.128 4.257 3.207-0.083 0.567-0.168 1.134-0.251 1.699-2.507 0.002-5.012 0.002-8.514 0.002zM462.255 500.003c1.602-0.914 3.207-1.83 4.809-2.745 0.005-0.479 0.012-0.958 0.015-1.435-2.316-0.823-4.631-1.647-7.417-2.636-0.921-2.502 0.547-4.299 3.443-5.334 5.456-1.952 6.28-3.897 3.817-8.972-0.657-1.353-1.268-2.726-1.175-5.040 1.257 0.47 3.009 0.567 3.694 1.471 4.932 6.493 4.864 6.543 12.32 4.64 0.574-0.146 1.175-0.186 1.612-0.251-2.57 3.665-5.113 7.291-7.798 11.119 4.96-0.578 8.488-7.582 14.16-2.036-1.436 0.446-2.873 0.891-3.313 1.027-1.272 4.083-3.441 7.569-3.060 10.752 0.426 3.546 3.172 6.817 5.063 10.513-0.497 0.283-1.204 0.839-2.006 1.122-4.071 1.428-4.892 3.981-2.311 7.367 4.42 5.793 4.437 5.984-1.996 9.382-4.302 2.271-8.737 4.289-13.122 6.403-0.266 0.13-0.781 0.244-0.889 0.118-3.895-4.545-7.329 0.873-11.073 0.54-2.607-0.229-5.288 0.366-8.471 0.638 0.452-1.898 0.68-2.858 0.908-3.815-0.253-0.218-0.504-0.432-0.758-0.647-1.425 1.35-2.848 2.701-4.272 4.053-0.042-0.221-0.083-0.446-0.125-0.663-2.249 0.898-4.51 1.8-6.879 2.748-0.289-1.659-2.026-1.863-3.192-2.646-1.302-0.725-2.462-1.373-2.557-3.258-0.088-1.765-1.195-3.044-3.296-2.781-0.62-0.856-1.24-1.714-1.862-2.568 0.77-0.808 1.591-1.546 2.492-2.169 10.601-7.311 18.846-18.484 32.695-20.786 0.72-0.12 1.090-2.354 1.622-3.604-0.356-0.17-0.716-0.337-1.076-0.507zM408.342 829.322c-0.076-0.012-0.155-0.025-0.234-0.033-0.005-0.018-0.010-0.035-0.015-0.048 0.073-0.048 0.146-0.095 0.219-0.141 0.008 0.071 0.023 0.148 0.030 0.223zM361.76 828.341c-5.122 0.849-10.243 1.694-15.362 2.558 7.238-9.439 13.068-19.765 16.962-31.249 0.953-2.808 0.597-3.89-2.011-5.507-14.356-8.918-23.748-21.142-22.884-38.889 0.442-9.088 1.757-18.252 9.284-24.887 2.971-0.572 5.331-2.359 7.761-3.968 2.68-1.775 4.671-4.018 4.264-7.557-1.985-4.718-7.279-6.636-9.439-11.184-9.766-6.954-20.698-9.535-32.565-8.872-7.831 0.442-15.066 2.906-22.232 5.848-5.639 2.314-11.319 3.499-17.363 0.775-7.331-3.311-15.086-4.812-23.015-5.353-0.080-0.705-0.135-1.418-0.145-2.148-0.028-1.92-3.178-3.78 0.497-5.462-1.069-1.922-0.213-5.461-0.48-5.679-6.274-5.143-3.805-12.625-5.64-18.876-0.643-2.194 2.309-6.56-2.966-6.822 3.057-2.507 7.161-1.095 10.434-2.793-2.992-0.266-6.342-0.251-7.236-3.951-3.055-12.64-5.060-25.494-8.549-38.071-0.808-2.919-1.327-5.915-1.807-8.925 3.769-1.586 2.098-5.295 2.442-8.094 0.196-1.601-0.953-3.38 0.849-4.699 3.075-1.556 5.009-5.447 9.281-4.575 16.836-8.29 35.029-10.637 53.398-11.312 8.993-0.329 17.865 0.919 26.629 2.836-0.891 0.263-1.78 0.522-2.668 0.786-4.339 1.282-8.503 3.135-12.805 4.551-3.26 1.074-6.734 1.588-9.859 2.939-1.117 0.482-2.262 2.803-2.073 4.086 0.949 6.415 2.126 12.812 3.662 19.109 0.748 3.069 2.513 5.88 3.712 8.849 0.585 1.453 1.483 3.082 1.283 4.493-1.282 9.013 1.247 13.945 9.497 18.098 0.972 0.487 2.020 1.405 2.41 2.374 1.445 3.579 2.558 7.294 3.971 10.892 0.284 0.723 1.312 1.172 2.033 1.697 1.938 1.42 4.113 2.595 5.802 4.261 4.517 4.462 8.129 9.896 15.46 10.582 1.912 0.176 3.624 2.929 5.339 4.591 1.155 1.12 1.968 3.137 3.262 3.466 3.162 0.796 6.586 1.438 9.766 1.039 3.295-0.416 4.814 0.71 6.435 3.268 4.621 7.301 16.485 8.968 23.025 3.468 5.906 2.085 6.372 11.498 14.436 10.649 0.279-0.032 0.55-0.151 0.826-0.229 0.627-2.429 1.854-4.435 3.546-5.903 4.304-3.729 8.343-1.632 12.256 0.986 2.341 1.569 7.934 0.444 8.877-2.071 0.392-1.046 0.785-2.095 1.177-3.14 0.637 1.641 1.33 3.263 1.46 5.029 0.954 12.885 0.908 25.786-0.741 38.593-1.995 15.496-6.201 30.316-13.558 44.308-8.041 15.297-17.694 29.211-30.655 40.709-2.587 2.296-5.546 4.143-8.084 6.505-2.786-0.954-4.763 1.16-7.093 1.978 0.627-0.951 1.255-1.9 1.882-2.851-7.715 0.366-15.131 2.489-22.688 3.745zM217.204 834.979c0.022 0.010 0.042 0.022 0.063 0.032-0.108 0.033-0.216 0.063-0.329 0.105-0.055-0.028-0.101-0.052-0.155-0.083 0.14-0.015 0.279-0.025 0.421-0.053zM217.173 834.916c0.008 0.003 0.017 0.007 0.025 0.008 0 0.007-0.002 0.013-0.002 0.023-0.008-0.010-0.018-0.023-0.023-0.032zM236.316 572.742c0.143-0.042 0.293-0.071 0.444-0.105 0.821 0.936 2.046 1.217 3.069 0.525 2.307-1.556 4.026-0.344 5.891 0.647 4.063 0.706 7.111-2.131 10.702-3.102 12.738-3.439 25.588-5.92 38.797-7.052 11.066-0.948 22.023-0.439 32.864 1.004 11.015 1.465 21.519 4.826 31.879 8.667-2.633 0.75-5.266 1.501-7.898 2.259-1.785-0.603-3.591-1.15-5.426-1.604-10.174-2.507-20.402-4.325-30.923-5.328-14.989-1.428-29.4 0.961-43.937 3.383-9.997 1.664-18.957 6.508-28.567 9.366-2.051 0.966-3.589-0.278-5.133-1.272-0.554-0.354-1.076-0.755-1.636-0.936 0.183-0.105 0.369-0.214 0.554-0.329-3.858-2.040-1.92-4.081-0.68-6.124zM341.825 434.62c2.239-2.583 4.443-5.218 6.937-7.537 0.414-0.382 3.125 0.652 3.14 1.089 0.060 1.656-0.068 3.772-1.061 4.876-0.864 0.959-3.080 0.567-4.53 1.175-1.27 0.532-2.304 1.622-4.098 2.951-0.279-1.714-0.572-2.341-0.389-2.553zM354.041 429.029c0.314-2.058 0.63-4.119 0.946-6.177 1.529 0.455 3.060 0.913 4.588 1.371-0.864 1.903-1.729 3.808-2.593 5.713-0.981-0.303-1.962-0.603-2.941-0.908zM370.090 437.81c-0.494 0.547-0.986 1.094-1.479 1.639-1.413 0.209-2.828 0.417-4.593 0.678-0.194-1.935-0.379-3.777-0.564-5.617 0.583-0.371 1.165-0.743 1.749-1.112 1.629 1.471 3.258 2.941 4.887 4.412zM369.87 432.387c-0.156-0.828 1.29-1.958 2.021-2.954 1.109 1.152 2.435 2.181 3.192 3.527 0.234 0.417-1.079 1.706-2.151 3.285-1.443-1.707-2.838-2.673-3.062-3.858zM365.643 423.151c-1.614-0.231-3.155-0.977-4.721-1.546 0.221-0.8 0.446-1.598 0.665-2.397 1.797 0.263 3.594 0.525 5.389 0.788-0.452 1.105-1.046 3.197-1.333 3.155zM384.989 463.5c0.848-3.494 1.631-7.087 6.604-4.952-2.201 1.647-4.404 3.301-6.604 4.952zM425.41 528.327c0.199 0.389 0.442 0.77 0.735 1.139 0.578 0.723 1.327 1.626 0.668 2.51-0.773 1.036-1.666 0.076-2.489-0.251-0.377-0.146-0.756-0.299-1.134-0.446 0.716-1.024 1.446-2.020 2.219-2.952zM452.812 659.634c-1.2 5.491-1.411 10.857-0.726 16.155-0.406 0.367-0.771 0.81-1.097 1.337-1.844 2.991-4.676 4.869-7.376 6.912-0.028 0.018-0.055 0.028-0.081 0.042 1.569-4.329 3.072-8.682 4.39-13.086 1.609-5.381 2.361-11.018 3.498-16.539 1.187 1.036 1.406 1.93 1.479 2.836 0.065 0.775 0.078 1.591-0.086 2.344zM423.115 625.337c-1.164-0.509-2.234-1.418-3.165-2.44 2.502-2.597 4.798-5.413 6.879-8.473 0.675-0.991 1.802-1.674 2.72-2.5 0.547 0.45 1.090 0.896 1.636 1.346-1.86 3.418-3.584 6.914-5.617 10.22-0.485 0.793-0.991 1.568-1.508 2.344-0.286-0.175-0.593-0.344-0.944-0.497zM406.663 592.751c0.253 0.103 0.502 0.208 0.753 0.311-0.5 1.33-0.918 2.7-1.521 3.983-1.117 2.38-2.297 4.733-3.451 7.098-0.906-0.78-1.814-1.553-2.726-2.322 2.317-3.024 4.631-6.046 6.945-9.070zM393.208 610.326c0.977 0.778 1.938 1.578 2.853 2.44 0.404 0.199 0.803 0.401 1.207 0.6 0.12 0.048 0.228 0.108 0.341 0.163-2.296 2.836-5.349 3.976-9.504 3.461 1.701-2.223 3.403-4.445 5.103-6.664zM406.929 633.241c2.123-1.278 4.134-2.656 6.054-4.126 0.545 0.997 1.011 2.048 1.686 2.954 0.65 0.411 1.21 0.884 1.701 1.405-3.8 3.905-7.673 7.884-11.673 11.997-4.472-7.625-4.593-8.127 2.233-12.23zM418.871 405.19c-2.758-0.404-5.359-1.867-8.026-2.884 0.229-0.499 0.46-0.997 0.692-1.494 2.030-0.721 4.013-1.672 6.102-2.085 1.538-0.303 3.597-0.449 4.719 0.341 1.084 0.763 1.265 2.809 1.842 4.292-1.784 0.663-3.679 2.073-5.329 1.83zM422.566 433.021c-0.071 0.449-0.534 0.856-0.542 1.287-0.098 6.101-2.144 9.918-9.583 7.484-2.56-5.667-7.698-2.725-12.828-2.261 2.341-3.157 4.344-5.863 6.631-8.948 0.381 0.236 1.416 0.883 3.027 1.883 0-1.669 0-2.868 0-4.058 0.47-0.027 0.898-0.178 1.036-0.038 2.686 2.686 5.604 2.035 8.734 0.891 1.169-0.427 2.638-0.035 3.97-0.015-0.141 1.26-0.246 2.523-0.444 3.775zM375.371 428.609c4.261-3.527 6.546-3.594 8.611 2.091-3.235-0.785-5.364-1.3-8.611-2.091zM233.366 600.102c-0.1 1.431-0.446 2.858-1.059 4.252-0.284-1.307-0.617-2.612-0.919-3.918 0.813-0.407 1.451-0.527 1.978-0.334zM417.94 819.489c0.401-1.165 0.407-1.734 0.198-1.982 5.63-6.859 10.388-14.329 15.538-21.531 6.412-8.962 10.36-19.105 14.022-29.211 7.65-21.107 9.894-43.076 7.76-65.468-0.196-2.060-0.64-4.251 0.198-6.447 2.231 1.001 2.337 2.813 2.607 4.477 1.218 7.471 0.806 15.009 0.552 22.506-0.283 8.305-1.87 16.477-3.188 24.692-2.098 13.056-6.771 25.241-12.094 37.073-5.276 11.724-12.576 22.443-21.308 32.042-1.18 1.298-2.317 2.626-1.799 4.596 0.048 0.231 0.136 0.446 0.238 0.65-0.023 0.025-0.045 0.052-0.066 0.076-0.711 0.788-1.686 1.769-2.831 1.011-1.071-0.711-0.12-1.634 0.175-2.487zM437.905 813.9c0.318 0.003 0.635 0.007 0.954 0.010 6.247-10.062 13.202-19.729 17.593-30.825-1.573 4.482-3.266 8.903-5.152 13.274-2.62 6.069-6.272 11.515-9.472 17.22-2.011 0.303-4.028 0.577-6.049 0.818 0.502-0.437 1.157-0.678 2.126-0.497zM489.663 688.602c-1.514 0.765-1.967 2.527-3.075 3.672-2.296 2.375-3.742 2.025-4.807-1.282-0.258-0.803-0.525-1.544-1.094-2.133-2.374-1.822-5.157-2.168-7.958-2.422-1.819 0.101-2.675 1.755-3.94 2.748 0.091-0.329 0.196-0.655 0.314-0.984-0.389-0.635-0.976-0.951-1.701-1.042-0.896-0.078-1.779 0.229-2.668 0.47-0.138-7.665-0.725-15.322-1.115-22.98-0.090-1.784-0.013-3.576-0.013-5.735 11.595 0.638 10.956 12.685 18.068 16.81 0.527-0.163 1.504-0.836 2.213-0.622 2.628 0.793 5.373 1.534 7.687 2.936 0.839 0.509 1.674 1.042 2.495 1.599-0.74 3.388-1.92 6.535-4.405 8.965zM430.73 393.337c-7.949-2.748-15.533-5.368-24.578-8.493 3.080-2.041 5.225-4.192 7.795-5.022 6.407-2.065 7.143-1.335 9.334 5.032 0.396 1.152 2.364 2.447 3.637 2.48 3.391 0.088 4.453 1.529 3.812 6.003zM221.887 491.839c0.007 0.022 0.018 0.042 0.027 0.063-0.017 0-0.032 0-0.048 0 0.008-0.023 0.013-0.043 0.022-0.063zM222.166 492.388c0.372 0.555 0.949 0.918 1.686 0.962 1.76 0.103 2.764 1.205 3.948 2.143 0.442 0.19 0.904 0.321 1.381 0.379 2.685-1.428 5.845-0.577 8.576-1.785 13.014-4.415 26.654-5.717 40.086-8.062 7.773-1.358 15.571-1.3 23.439-1.225 6.744 0.065 13.46-0.261 20.231 0.274 5.083 0.404 9.818 2.64 14.767 2.645 1.92 0.002 3.792 0.173 5.637 0.439 4.543 8.31 9.008 16.668 13.989 24.711 0.992 1.604 2.148 3.107 3.373 4.568-0.258 0.736-0.529 1.471-0.841 2.181-3.082 7.037-5.423 14.328-8.249 21.441-1.559 3.918 0.279 5.632 3.408 6.786 3.461 1.278 5.353-0.565 6.36-3.682 0.436-1.345 0.713-2.74 1.132-4.089 0.359-1.154 0.318-2.966 1.797-2.984 1.819-0.018 2.013 1.953 1.985 3.228-0.075 3.343 0.585 6.553 1.378 9.728 1.041 4.169 4.947 5.384 8.092 5.050 3.805-0.407 2.008-4.289 1.765-6.626-0.304-2.934-0.921-5.956-1.757-8.716-0.748-2.477-0.554-3.975 0.475-5.095 0.66 1.001 1.165 2.036 1.423 3.129 1.322 5.615 4.154 6.879 8.752 7.514 1.307 0.18 2.405 0.567 3.301 1.144-1.617 6.708-0.544 13.558 4.108 19.14-4.954 0.884-9.971 1.571-14.831 2.814-11.227-5.403-22.806-10.017-35.401-12.233-10.187-1.795-20.209-3.968-30.609-4.292-3.857-0.12-7.874 1.18-11.64-0.698-1.044 0.293-2.083 0.808-3.138 0.843-17.228 0.519-33.661 4.768-49.785 10.498-1.957 1.282-4.581 0.369-6.442 1.96-0.607 1.318-1.393 2.502-2.414 3.493-1.858-2.366-4.527 1.8-6.648 0.813 0.693-2.487 2.897-2.916 4.412-4.129 1.76-1.408 0.399-1.639-0.808-1.854 1.765-1.205 4.146-1.159 5.684-2.818-1.553 0.048-3.105 0.133-4.658 0.145-4.379 0.032-6.299-3.262-4.199-7.163 0.437-0.813 0.858-1.637 1.285-2.457 3.918-1.657 6.987-3.694 3.798-8.519-0.741-2.59-2.593-2.853-4.842-2.337-1.691 0.389-3.393 0.193-3.943-1.616-1.754-5.777-3.652-11.538-4.832-17.438-1.342-6.708-1.378-13.716-3.125-20.29-0.977-3.655-0.667-5.926 1.895-7.916zM713.346 854.864c-0.002-0.003-0.005-0.010-0.010-0.012 0.003 0 0.005 0 0.007 0 0.002 0.002 0.003 0.005 0.007 0.008-0.002 0.003-0.002 0.003-0.003 0.003zM815.521 851.090c-0.030-0.008-0.055-0.018-0.081-0.027l-0.005 0.002c-0.003-0.002-0.007-0.002-0.008-0.005 0.003 0 0.008 0 0.013 0.003 0.028 0 0.055 0 0.086 0-0.002 0.010-0.005 0.018-0.005 0.027zM178.134 217.662c0.168-0.040 0.337-0.073 0.504-0.12 19.627-3.697 39.369-6.731 59.043-10.157 34.070-5.935 68.015-12.571 102.137-18.204 27.884-4.603 55.605-10.137 83.486-14.757 10.408-1.724 20.651-4.487 31.061-5.971 11.665-1.662 23.284-3.604 34.846-5.74 18.367-3.394 36.796-6.423 55.175-9.738 8.85-2.201 17.868-3.514 26.84-5.097 10.036-1.772 20.078-3.532 30.112-5.318-1.468 0.557-2.886 1.35-4.236 2.477 6.432 0.861 12.396-0.504 17.96-3.774-2.247 0.027-4.515-0.052-6.747 0.043 5.438-0.976 10.873-1.967 16.308-2.971-2.625 0.695-5.196 1.614-7.672 2.917 3.838 1.438 7.662 1.102 11.547 0.106 5.16-1.32 10.32-2.701 15.553-3.659 12.68-2.316 25.425-4.271 38.091-6.648 4.314-0.81 8.953-0.387 12.905-1.942 6.063-2.385 12.009-3.137 18.312-2.031-0.441-2.311-1.438-3.468-4.176-3.232-9.201 0.795-18.065 3.419-27.232 4.583-13.109 1.662-26.082 4.538-39.123 6.849-2.693 0.477-5.434 0.823-8.169 1.202 18.148-3.381 36.367-6.357 54.493-9.851 7.361-1.42 14.796-2.489 22.189-3.764 3.714-0.64 6.473 0.697 8.076 4.158 1.082 2.337 2.025 4.643 2.153 7.359 0.352 7.387 2.366 14.549 3.619 21.805 1.865 10.818 4.063 21.584 5.938 32.411 0.401 2.316 0.854 4.621 1.33 6.925-0.407-0.166-1.064-0.055-2.086 0.56-0.534 10.777 2.404 21.142 3.853 31.679 0.462 3.373 0.713 6.92 2.763 9.899 0.645-0.949 0.564-2.058 0.773-3.119 1.533-7.743-3.65-14.378-3.527-21.83 0.081-4.847-2.899-9.332-1.39-14.368 0.035-0.121 0.075-0.278 0.11-0.452 1.155 5.423 2.399 10.832 3.401 16.289 1.614 8.774 2.743 17.626 4.535 26.368 1.549 7.564 2.779 15.169 3.042 22.904 1.629 3.047 0.743 6.473 1.343 9.713 0.801 4.34 2.508 8.372 3.345 12.627 1.701 8.679 2.517 17.494 4.573 26.147 3.001 12.607 4.965 25.452 7.416 38.179 3.614 18.764 6.727 37.642 9.696 56.534 2.445 15.561 5.823 30.966 8.159 46.549 1.004 6.686 2.721 13.267 2.946 20.068-0.033 2.826-0.411 5.805 1.421 8.197 0.349 0.455 0.633 0.923 0.874 1.4 0.278 2.166 0.695 4.31 1.155 6.452 0.211 3.983 1.25 7.826 2.287 11.625 0.010 0.073 0.022 0.146 0.032 0.223 0.999 8.139 3.624 15.992 3.155 24.458-0.168 3.012-0.263 7.023 1.647 9.997 1.581 2.462 1.97 5.221 2.989 7.781 0.352 0.884 0.628 1.779 0.858 2.681 0.028 0.141 0.053 0.281 0.081 0.421 0.198 0.994 0.381 1.99 0.567 2.984 0.808 6.084 0.151 12.384 2.651 18.176 0.658 1.519-0.549 2.869-1.491 4.216-2.38 3.388-2.39 6.781 0.786 9.818 1.775 2.211 1.832 4.791 2.198 7.505 0.876 6.44 3.571 12.562 3.712 19.178 0.060 2.766 1.501 6.161-0.083 8.179-4.224 5.384-2.723 9.683 1.172 14.102 0.956 1.084 1.293 2.449 1.521 3.893 1.263 8.052 2.769 16.055 4.433 24.034 0.389 1.86 1.41 3.084 2.733 4.226 0.447 0.193 0.894 0.259 1.345 0.208-4.282 4.689-4.583 7.191-2.043 12.808 0.304 0.357 0.665 0.638 1.086 0.841 0.392 0.075 0.728 0.19 1.034 0.322 1.799 3.665 1.41 7.793 1.775 11.751 0.231 2.49-0.050 5.118 2.858 6.368 0 0 0 0 0.002 0 0.766-0.45 1.361-1.001 1.817-1.632 0.098 0.429 0.186 0.858 0.256 1.295 0.101 0.7 0.203 1.398 0.304 2.103-0.816 2.921 0.191 5.964 0.615 8.952 0.308 2.159 0.921 4.089-0.839 6.161-3.335 3.93-2.337 8.589 2.254 11.284 1.119 0.657 1.975 1.528 2.577 2.492 0.279 1.524 0.56 3.050 0.854 4.571-0.188 3.98 1.406 7.668 0.838 11.856-0.851 6.277-5.301 12.276-11.731 12.303-2.678 0.012-5.389-0.401-7.356 2.043 0.116 0.283 0.253 0.535 0.401 0.775-3.245-0.066-6.408 0.366-9.362 2.075-0.173 0.313-0.274 0.643-0.318 0.984-2.321 0-4.58 0.455-6.822 1.049v0c-8.681 0.444-16.919 3.316-25.442 4.611-7.19 0.994-14.378 1.986-21.569 2.977-0.002 0-0.002 0-0.003 0 0.002 0 0.002 0 0.003 0-4.221-4.686-9.326-3.198-14.381-2.061 0.743 0.166 1.865 0.093 2.151 0.542 0.6 0.961-0.537 1.242-1.172 1.504-1.144 0.47-2.321 0.931-3.529 1.172-6.141 1.214-12.738-0.015-18.464 3.581-0.14 0.088-0.296 0.168-0.455 0.243-0.878 0.155-1.755 0.309-2.633 0.465-0.196-0.020-0.386-0.045-0.565-0.091-5.969-1.568-11.204 1.764-16.843 2.409-9.274 1.064-18.224 4.555-27.68 4.477-6.319-0.052-11.941 2.62-17.89 3.961-3.175-0.507-6.149 0.642-9.184 1.179-23.923 4.234-47.865 8.343-71.781 12.609-3.145 0.562-6.699 0.539-8.762 3.774-2.912 0.625-5.891 1.032-8.719 1.92-4.025 1.263-4.385 5.321-4.816 8.441-0.454 3.286 3.142 2.573 5.273 3.152 5.1 1.391 10.323 0.223 15.478 0.858 13.099 1.611 26.283 1.371 39.449 1.438 2.449 0.008 4.96-1.438 7.364 0.204h0.002c-0.002 0-0.002 0-0.002 0-1.061 2.060-2.994 2.008-4.892 2.018-4.703 0.022-9.407 0.033-14.112 0.048-1.388 0.229-2.783 0.685-4.162 0.65-7.798-0.193-15.599-0.389-23.387-0.806-6.724-0.362-13.44-0.903-20.136-1.601-3.27-0.339-5.68-1.405-4.177-5.836 0.527-1.559 3.188-4.309 0.070-5.728-3.514-1.601-1.593 3.591-3.986 3.833v0 0c-0.592-0.632-1.185-1.257-1.777-1.885-0.037-0.603-0.075-1.212-0.113-1.815-3.348-1.589-6.319 0.881-9.517 0.891-1.967 0.007-3.602 0.459-4.967 1.302 0.555-3.187 1.692-6.159 2.861-9.118-0.013 0.098-0.032 0.193-0.042 0.294-0.166 1.503-1.533 3.498 0.583 4.571 1.82 0.928 3.749 1.014 5.782-0.088 3.311-1.794 6.217-4.089 9.11-6.438 1.649-3.649 3.032-7.387 3.78-11.337-1.071 0.776-1.471 1.945-2.015 3.092-1.706 3.597-4.65 5.772-8.451 6.824-3.717 1.027-5.86-0.035-5.61-4.249-0.304 0.331-0.574 0.678-0.826 1.032 0.047-0.155 0.096-0.309 0.141-0.459 5.401-18.442 9.336-37.142 10.785-56.501 0.662-8.875 0.731-17.704 0.386-26.504 4.779 2.444 9.65 4.728 14.339 7.336 3.83 2.129 11.038 2.495 13.654-0.173 3.66-3.735 7.090-7.695 10.814-11.773 2.612 3.257 2.507 5.3-0.166 7.457-2.804 2.267-5.411 4.811-7.876 7.446-0.673 0.723-1.084 2.568-0.637 3.242 0.532 0.791 2.306 1.446 3.24 1.162 8.852-2.673 14.188 4.181 21.768 7.037-1.594 0.858-2.277 1.225-2.962 1.594 0.090 0.386 0.176 0.776 0.264 1.165 3.017-0.392 6.033-0.831 9.058-1.165 1.666-0.181 3.961-0.951 4.927-0.166 6.237 5.077 13.649 6.084 21.195 7 1.318 0.158 2.645 1.057 3.76 1.888 2.746 2.046 5.649 2.299 8.343 0.381 4.608-3.283 8.571-2.241 13.016 0.575 9.012 5.702 13.914 4.799 19.906-2.523 4.904 1.706 9.509 3.692 14.308 4.879 5.438 1.348 7.022-0.658 5.399-5.981-0.48-1.583-0.903-3.18-1.353-4.771 0.303-0.332 0.603-0.662 0.906-0.994 4.982 2.962 9.809 6.237 14.991 8.8 5.509 2.721 11.485 3.542 18.317 2.394-1.019-1.815-1.558-3.097-2.377-4.164-4.113-5.353-8.275-10.667-12.471-15.957-3.31-4.174-7.22-7.979-9.903-12.514-3.062-5.177-3.522-11.52 4.588-14.675-0.291 5.225-0.934 10.084 3.765 14.097 4.204 3.594 6.433 9.427 12.499 11.505 0.929-1.27 1.872-2.555 2.951-4.026 0.796 2.267 0.974 5.27 2.169 5.75 6.969 2.808 14.161 5.080 21.324 7.377 0.8 0.256 1.91-0.442 4.158-1.032-3.453-3.428-6.039-6.295-8.932-8.81-9.367-8.154-18.892-16.128-28.238-24.31-1.583-1.386-2.568-3.454-3.832-5.21 4.718 1.435 8.32 4.054 12.348 5.444 3.918 1.353 8.295 2.053 12.439 1.93 4.468-0.133 8.267-2.51 10.93-7.037-11.146-2.58-20.167-8.358-28.586-15.318-2.379-1.963-3.697-3.665-1.478-6.585 11.719 12.96 36.887 9.765 42.526 0.971-19.853 2.464-35.815-5.971-50.901-16.911 5.521 0.372 10.828 1.573 16.199 2.090 5.645 0.539 11.091-0.419 16.19-5.014-24.659-0.507-44.315-12.398-64.569-22.684 0.053-0.404 0.11-0.808 0.166-1.212 3.828-0.75 7.655-1.498 12.7-2.484-2.5-2.018-3.783-3.423-5.364-4.267-18.527-9.941-36.523-21.167-58.016-24.002-1.541-0.206-3.983-1.501-4.162-2.593-0.539-3.29-3.243-2.741-5.072-3.78-6.752-3.843-13.719-7.384-20.146-11.718-16.173-10.908-32.173-22.078-48.090-33.36-10.228-7.256-11.58-21.898-3.584-31.779 3.725-4.606 6.701-9.809 10.278-14.545 1.745-2.314 4.169-4.108 6.116-6.285 0.866-0.964 1.313-2.299 1.948-3.468-1.684-0.48-3.478-1.583-5.029-1.312-3.257 0.57-6.383 1.865-10.122 3.037 1.642-8.749-3.986-2.013-6.327-4.219 2.706-1.586 5.022-2.937 8.714-5.1-3.225-1.089-5.336-2.149-7.555-2.487-9.44-1.433-17.154 4.294-25.693 6.593-9.435 2.54-17.071 0.417-23.018-7.924-13.543-19.001-18.419-41.622-26.42-62.923-2.803-7.459-4.59-15.297-6.949-22.927-1.027-3.32-6.322-6.824-9.259-6.583-6.144 0.505-12.509 2.242-17.794-2.858 2.38-3.521 1.34-6.703-1.669-9.324-2.522-2.198-8.38-1.543-11.091 0.841-0.79 0.692-1.88 1.039-2.833 1.544-0.482-1.079-1.303-2.133-1.385-3.242-0.286-3.883 2.075-5.368 6.272-4.513 3.672 0.75 7.419 1.142 11.144 1.612 0.258 0.033 0.602-0.593 1.165-1.189-1.963-1.87-4.011-3.519-5.672-5.496-1.375-1.636-3.679-3.311-0.859-5.938 0.718-0.668 0.716-3.476 0.058-3.963-1.182-0.871-3.114-0.728-4.731-1.011-0.224 1.375-0.638 2.753-0.602 4.119 0.020 0.7 0.55 1.38 0.645 1.446-1.533 2.759-2.351 5.060-3.892 6.661-0.864 0.899-3.695 1.398-4.339 0.763-3.802-3.76-7.256-7.876-10.7-11.982-0.241-0.286 0.537-1.43 0.638-1.676-2.316-1.275-4.763-2.625-7.652-4.216-0.306 1.425-0.843 3.936-1.295 6.048-3.644-0.542-6.242-0.928-8.463-1.258-1.647 1.079-3.17 2.181-4.817 3.045-0.261 0.138-1.089-0.808-1.656-1.255 1.317-1.189 2.583-2.437 3.96-3.551 2.085-1.686 4.247-3.275 6.889-5.3-5.57 1.194-10.207 2.186-14.964 3.205 0.271 1.15 0.559 2.377 0.849 3.602-0.286 0.346-0.57 0.692-0.856 1.036-2.741-1.431-5.482-2.866-8.224-4.295-0.045 0.042-0.090 0.086-0.135 0.128-0.012-0.030-0.022-0.062-0.033-0.091-2.154 0.617-4.299 1.267-6.465 1.839-3.441 0.906-6.373-0.716-7.309-3.443-2.361 0.391-4.606 1.247-6.716 0.992-2.716-0.327-3.115-2.307-2.42-4.979 0.648-2.49 1.586-3.68 4.169-2.889 1.787 0.549 3.918 0.76 5.24 1.89 3.486 2.984 6.929 3.336 11.254 0.377 0.843 2.334 1.543 4.279 2.249 6.214 0.052-0.015 0.101-0.030 0.151-0.045 0.005 0.002 0.010 0.005 0.015 0.007 1.622-1.538 3.253-3.080 5.359-5.075-1.88-0.868-3.19-1.699-4.623-2.091-4.392-1.205-8.844-2.188-13.246-3.358-6.239-1.657-12.426-4.645-18.688-4.789-7.296-0.17-13.056-3.798-19.518-5.733-3.926-1.177-7.51-3.508-10.142-4.784 0.243-3.441 0.045-5.665 0.617-7.67 1.046-3.665 2.239-7.381 4.149-10.616 0.334-0.564 4.465 1.35 6.902 1.709 1.425 0.211 3.458 0.126 4.35-0.73 1.393-1.338 2.134-3.406 2.972-5.248 0.243-0.534-0.133-1.346-0.224-2.031-0.77 0.288-1.84 0.349-2.252 0.901-1.245 1.669-2.234 3.527-4.124 6.624-2.414-4.174-4.167-7.21-5.667-9.801-1.534 3.305-4.601 3.062-8.641 0.283-3.546-2.44-8.076-3.594-12.325-4.748-0.876-0.239-3.117 1.814-3.554 3.187-1.518 4.756 1.922 8.174 3.797 12.064 1.722 3.576 3.243 7.362 4.066 11.221 0.748 3.516 0.071 7.316 0.673 10.88 1.011 5.991 6.668 10.119 11.54 8.77-0.753-2.5-1.819-4.965-2.103-7.517-0.115-1.052 1.453-2.287 2.256-3.441 1.27 1.159 3.399 2.166 3.637 3.506 0.554 3.147 0.15 6.455 0.254 9.693 0.027 0.849 0.386 1.757 0.843 2.479 0.143 0.226 1.499 0.11 1.627-0.163 0.414-0.888 0.766-1.94 0.69-2.894-0.173-2.174-0.848-4.329-0.838-6.49 0.003-0.866 1.518-2.568 1.925-2.45 2.721 0.79 6.202 1.004 5.438 5.497-0.336 1.965-0.057 4.033-0.057 6.056 0.457 0.033 0.916 0.066 1.375 0.1 0.607-2.495 1.212-4.992 1.898-7.815 5.173 0.884 10.104 1.543 14.941 2.617 3.24 0.718 2.774 3.185 2.005 5.667-0.78 2.512-1.342 5.019-4.926 4.247-2.864-0.615-3.812-2.424-3.606-5.17 0.11-1.474 0.020-2.964 0.020-4.445-0.465-0.027-0.931-0.055-1.396-0.083-0.276 2.49-0.554 4.979-0.846 7.614-1.794 0.446-3.532 0.879-6.102 1.518 2.038 2.618 4.138 4.48 5.108 6.811 0.884 2.124 0.778 4.783 0.542 7.148-0.047 0.477-2.631 0.703-4.091 1.056 0.936-2.651 2.628-5.014 2.020-6.207-1.381-2.718-3.89-4.864-6.043-7.362-1.649 4.304-3.971 5.19-8.576 3.551-2.723-0.967-7.826 0.723-8.751 2.897-3.127 7.359 0.801 18.359 7.928 22.516 1.413 0.825 2.553 2.119 4.34 3.641-7.359 1.356-7.356 1.356-7.648 8.031-0.012 0.286-0.186 0.625-0.391 0.834-2.681 2.754-0.61 5.143 0.436 7.728 1.112 2.754 1.822 5.672 2.799 8.485 2.223 6.392 4.502 12.765 6.734 19.082 2.452-0.623 3.857-0.981 5.261-1.338-0.537 1.646-1.726 2.347-2.51 3.36-0.936 1.205-2.45 3.007-2.105 3.981 1.498 4.232 3.675 8.217 5.431 12.368 0.859 2.026 1.86 4.049 2.866 6.074-14.193-0.65-28.388-2.196-42.634 0.116-9.444 1.533-19.057 1.985-28.577 3.069-10.356 1.177-20.039 5.403-30.341 6.874-0.314 0.311-0.63 0.625-0.944 0.938 0 0.316 0 0.63-0.002 0.944 1.247 0.052 2.56-1.346 4.079 0.454-0.426 0.256-0.791 0.539-1.202 0.713-0.761 0.322-1.544 0.688-2.003 1.252-0.256-0.976-0.768-1.922-1.087-2.911-1.601-4.937-1.785-5.15-5.675-2.286-0.030-0.249-0.135-0.484-0.326-0.702-2.756 0.058-5.822 0.158-6.166-3.479-0.711-7.545-2.922-14.655-5.022-21.89-4.076-14.042-3.345-29.073-8.855-43.013-1.267-3.205-1.799-7.732-2.329-11.719-0.65-4.896-1.192-9.941-2.513-14.619-1.039-3.679-1.684-7.131-1.837-10.922-0.203-5.024-0.919-10.062-2.843-14.833-0.697-1.73-1.13-3.592-1.486-5.433-1.396-7.213-2.617-14.461-4.108-21.654-0.598-2.887-2.425-5.464-2.259-8.591 0.382-7.135-0.923-14.318-2.876-20.869-4.588-15.405-6.701-31.159-8.948-46.928-1.396-9.743 0.901-13.329 10.215-17.22zM303.141 307.104c-1.809 1.73-3.617 3.459-5.426 5.19-0.54-0.574-1.081-1.145-1.622-1.719 1.825-1.716 3.65-3.429 5.474-5.143 0.525 0.557 1.049 1.115 1.574 1.672zM316.333 365.854c-0.233 2.495-0.462 4.994-0.692 7.489-0.874-0.066-1.749-0.133-2.623-0.199 0.311-2.513 0.622-5.024 0.934-7.535 0.793 0.083 1.586 0.165 2.38 0.246zM152.363 533.822c1.892-2.322 4.134-4.229 6.732-5.705 9.386-8.242 20.678-13.49 31.214-19.935 1.169-0.509 2.003-1.578 3.112-2.080 5.728-2.582 10.686-7.092 17.45-7.146 0.007 0.485 0.052 0.982 0.085 1.479 0.313 4.561 1.177 9.078 2.721 13.309 0.795 2.179 1.029 4.141 0.697 6.149-0.678-1.74-1.353-3.481-2.251-5.097-1.98-3.574-4.578-1.356-6.87-0.306-1.726 0.795-3.539 1.76-2.203 4.271 5.313 9.982 9.003 20.679 13.724 30.916 1.298 2.814 2.274 6.875 6.849 6.774 0.412 3.062 0.826 6.126 1.238 9.186-1.12 2.066-3.175 2.944-5.095 3.983-11.43 6.184-21.733 13.872-31.556 22.393-4.832 4.191-7.989 9.979-13.565 13.322 0 0.003 0 0.003-0.002 0.003 0 0 0 0 0-0.003-5.918 4.5-5.918 4.5-11.434-0.1 0 0 0 0 0 0v0c3.848-7.575 3.848-7.575-1.017-10.115-5.28-3.908-8.207-11.096-16.012-11.478-4.31-0.716-6.902-4.507-10.795-6.048-1.749-0.695-3.207-3.345-5.215-1.604-2.113 1.834-4.48 4.104-2.751 7.572 11.045 7.929 11.045 7.929 5.529 16.908v0c-4.537 1.228-6.99-2.74-10.361-4.322-2.636-1.235-4.457-3.263-7.030 0.401-2.395 3.416-2.281 5.476 1.496 7.251 1.789 0.843 2.826 2.447 3.795 4.083 0.909 0.407 1.82 0.816 2.73 1.223 4.648 1.361 7.758 5.364 12.094 7.259-0.088 0.291-0.175 0.6-0.264 0.939 0.090 0.47 0.276 0.913 0.564 1.295 2.836 2.939 6.272 4.984 9.967 6.641 1.779 0.796 3.557 1.32 5.052-0.565 0.19-0.233 0.381-0.464 0.569-0.702 2.105 1.087 3.566 2.562 4.144 4.561-0.876 0.987-1.777 1.957-2.204 3.205-1.087 6.55-6.091 11.277-8.101 17.4-0.005 0.467 0.048 0.928 0.151 1.383 0.156 1.332-0.068 2.56-0.454 3.739-0.176 0.432-0.341 0.866-0.489 1.31-0.82 1.968-1.888 3.863-2.168 5.984-0.293 0.808-0.618 1.622-0.409 2.432-0.108-0.003-0.213-0.013-0.326-0.013-1.095 0.313-2.055 0.818-2.665 1.834-0.916 11.746-4.483 23.18-4.074 35.077-0.254 5.025-0.728 10.052-0.723 15.077 0.023 16.284 2.873 32.168 7.693 47.671 3.26 10.479 7.191 20.665 13.018 30.132 3.772 6.129 7.416 12.356 11.171 18.508 0.304 1.927 1.262 3.562 2.409 5.068 4.628 6.079 6.88 13.033 7.896 20.523 0.464 3.416 1.202 6.817 2.096 10.149 0.625 2.332 0.342 4.254-1.036 6.215-4.116 5.871-8.099 11.833-12.203 17.711-4.129 5.911-4.108 11.259 0.194 16.863 4.807 6.257 15.451 6.732 19.479 0.868 0.578-0.948 1.157-1.893 1.734-2.838 2.055-0.263 4.216-1.767 6.081 0.411 1.933 2.254 0.499 4.455-0.329 6.545-1.192 3.009-3.262 5.732-2.698 9.248 0.45 0.64 0.873 1.812 1.356 1.835 5.431 0.288 5.524 4.859 6.864 8.386 0.66 1.737 1.637 3.646 0.148 5.356-0.322 0.369-0.648 0.574-0.979 0.68-1.82-1.104-3.572-2.341-5.354-3.519-2.967-1.797-6.26-2.936-9.286-4.633-19.76-11.086-37.195-25.161-52.814-41.475-10.351-10.81-19.3-22.794-27.505-35.288-9.008-13.721-15.468-28.792-21.481-43.949-6.518-16.431-10.218-33.787-12.167-51.298-2.314-20.801-2.309-41.76 1.031-62.506 3.255-20.232 8.726-39.909 17.328-58.577 1.556-3.373 2.771-7.057 5.469-9.848 0.233-4.369 1.373-8.258 5.098-11.073 0.934-0.706 1.533-1.977 2.093-3.095 5.183-10.39 11.611-19.893 19.815-28.145 1.273-2.093 3.724-3.609 3.514-6.43 1.556 0.251 2.444-1.081 3.368-2.331 1.358-2.745 5.208-3.014 6.126-6.189 0.741-1.115 1.767-1.958 2.713-2.878 0.293 1.779 0.913 3.454 2.114 4.892 2.236 2.675 3.908 5.602 4.746 8.993 2.479 3.295 3.717 8.021 9.143 7.908 0.038-0.037 0.070-0.073 0.106-0.111 0.199 0.492 0.524 0.984 0.796 1.524 2.543 5.087 5.954 9.279 11.116 11.874 1.958 2.241 3.913 4.487 5.88 6.719 1.358 1.544 2.996 2.622 4.901 1.15 5.083-3.926 10.059-7.998 15.076-12.009 1.086-0.866 1.852-2.036 0.898-3.232-1.446-1.809-2.415-4.259-4.66-5.143-2.111-0.834-2.608 1.819-4.030 2.63-1.627 0.936-3.22 1.962-4.723 3.084-1.453 1.087-2.716 2.129-4.493 0.455-1.767-1.664-2.75-3.519-1.709-5.845 0.494-1.105 1.501-1.983 2.274-2.966-0.080-0.256-0.208-0.48-0.362-0.683 6.659-5.943 6.553-7.366-0.47-11.838-2.896-1.39-3.657-4.197-4.586-6.895-0.341 0.022-0.683 0.042-1.024 0.065-4.979-5.649-5.253-5.655-11.458-0.231-2.050 0.148-3.754-0.831-5.492-1.697-1.732-2.033-4.307-3.498-5.298-6.031 0.477-0.294 0.956-0.583 1.436-0.866 1.654-2.159 3.404-4.209 5.976-5.329 0.414-0.143 0.796-0.351 1.122-0.657zM159.884 609.764c-0.711-0.304-1.421-0.615-2.148-0.866 0.218-3.396-3.080-3.782-5.371-5.029 0.226-0.208 0.465-0.344 0.718-0.432 0.856 0.698 1.717 1.383 2.695 1.847 1.466 0.8 2.889 1.77 4.537 1.903-1.436 0.831-1.539 1.473-0.431 2.577zM129.252 543.902c0.003-0.007 0.007-0.010 0.008-0.017 0.003 0 0.005 0 0.007 0-0.005 0.007-0.010 0.013-0.015 0.023 0-0.003 0-0.007 0-0.007zM147.828 560.155c0.045-0.155 0.101-0.294 0.168-0.424 0.196 0.367 0.416 0.731 0.61 1.109 0.903 1.727 3.227 2.688 3.295 4.861-0.858-0.78-1.74-1.534-2.583-2.329-0.914-0.864-1.915-1.767-1.489-3.217zM408.272 947.424c-0.191 0.178-0.382 0.362-0.569 0.552 0.057-0.078 0.116-0.155 0.171-0.236 0.008-0.003 0.015-0.007 0.023-0.012 0.123-0.105 0.248-0.203 0.374-0.304 0.012-0.013 0.025-0.022 0.037-0.035 0.002 0 0.005-0.003 0.007-0.003-0.015 0.013-0.030 0.022-0.043 0.038zM403.692 941.159c-15.835 7.409-32.233 13.402-49.238 17.328-12.82 2.956-25.863 5.103-39.085 5.684-2.392 0.105-4.766 0.459-5.733 3.195-1.214-0.007-2.429-0.015-3.642-0.022-7.505-0.204-15.011-0.547-22.518-0.587-10.877-0.053-21.442-3.069-32.301-3.21h-0.003c-2.068-0.943-4.191-1.614-6.35-2.088-2.078-1.812-4.638-2.763-7.406-3.341-10.882-3.634-21.89-6.859-32.741-10.604-5.556-1.917-10.666-4.585-15.922-7.060-16.692-7.856-32.633-16.933-47.018-28.569-8.172-6.613-16.1-13.452-23.542-20.939-11.69-11.758-22.593-24.184-31.789-37.891-10.26-15.298-18.814-31.671-25.444-48.898-7.756-20.156-13.104-40.92-15.721-62.461-1.584-13.038-1.849-26.074-1.318-39.058 0.515-12.68 1.047-25.479 3.858-37.953 2.794-12.406 5.602-24.804 10.147-36.751 1.518-3.986 3.749-8.072 2.277-12.685-0.103-0.118-0.211-0.228-0.319-0.332 3.788-9.429 9.164-18.053 13.693-27.088 7.364-14.693 17.566-27.217 27.309-40.162 4.588-4.191 9.161-8.41 14.582-11.542 2-2.824 4.814-5.26 4.558-9.136 2.053 0.77 3.511-0.559 4.832-1.716 2.131-1.87 4.45-3.481 6.648-5.251 2.798-5.107 7.928-7.088 12.632-9.635 0.519 1.516 0.971 3.052 0.873 4.773-0.070 1.248 0.243 2.412 1.212 2.653-0.888 2.146-0.374 3.677 1.78 4.487-7.52 5.875-14.747 12.094-21.592 18.75-2.282 2.533-4.563 5.072-6.844 7.604-2.673 3.228-5.346 6.458-8.019 9.683-0.018-0.003-0.032-0.015-0.050-0.018-3.283 0.436-4.186 3.363-5.812 5.536-2.533 3.945-4.852 8.052-7.642 11.809-8.834 11.899-15.423 25.043-21.575 38.423-5.306 11.538-9.188 23.587-12.552 35.845-3.463 12.612-5.722 25.379-6.626 38.405-0.071 0.13-0.128 0.259-0.176 0.392-1.086 2.375-1.144 4.869-0.756 7.416 0 0.003 0 0.003 0 0.005-0.381 10.965-0.682 21.903 0.032 32.888 1.167 17.978 3.92 35.667 9.565 52.746 7.331 22.181 16.224 43.663 29.987 62.878 4.543 6.338 8.396 13.304 13.498 19.145 13.021 14.911 26.747 29.137 42.905 40.844 16.984 12.308 34.523 23.519 54.41 30.61 2.191 2.735 5.527 3.95 8.107 6.309 8.736 7.989 19.301 12.875 31.164 12.19 6.385-0.369 12.737-2.773 19.356-2.545 6.207 1.714 12.541 2.168 18.947 1.885 0 0 0 0 0 0 2.469-0.276 4.939-0.554 7.407-0.828 6.661 1.509 13.324 1.503 19.985 0.003 0.002 0 0.003-0.003 0.007-0.003 2.962-0.273 5.923-0.522 8.884-0.818 17.927-1.807 35.627-4.911 52.61-11.010 11.472-4.119 22.621-9.138 33.913-13.753 0.69-0.632 1.272-1.513 2.083-1.863 14.6-6.297 26.488-16.756 39.414-25.617v0c4.021 1.629 8.052 3.25 9.796 7.386-0.231 0.115-0.477 0.209-0.746 0.266-2.247 4.044-5.536 6.762-10.012 8.056-1.375 0.396-2.427 1.405-3.483 2.337-12.695 9.317-26.23 17.233-40.495 23.904z', 'M183.304 305.069c1.696 3.225 2.186 6.761 2.605 10.298 0.208 1.737 0.409 3.393 1.94 4.527-0.367-6.48-0.67-12.975-3.782-18.904-1.594 1.107-1.576 2.533-0.763 4.079z', 'M181.233 288.702c0.329 3.935 0.321 7.954 2.834 11.344-0.329-3.935-0.319-7.954-2.834-11.344z', 'M181.231 286.815c0.025-3.587-0.364-7.098-1.893-10.4 0.256 3.534-0.854 7.318 1.893 10.4z', 'M729.424 192.296c1.543-9.321-2.284-18.025-3.158-27.071-0.076-0.786-1.022-1.489-1.564-2.229-0.545 8.396 1.090 16.564 2.605 24.744 0.318 1.711 0.547 3.441 2.118 4.556z', 'M488.405 848.52c-4.636 5.524-9.53 10.87-13.701 16.726-1.631 2.289-3.067 4.465-5.233 6.36-3.232 2.836-6.879 5.57-7.452 10.538 11.020-9.362 20.694-19.916 28.581-32.058 0.426-0.658 0.956-1.474 0.236-2.11-0.898-0.79-1.81-0.193-2.43 0.544z', 'M153.194 871.083c1.408-0.080 3.047 0.008 3.148-1.982 0.088-1.689-1.006-2.548-2.597-2.788-0.618-0.095-1.258-0.057-1.878-0.14-7.751-1.047-12.881-6.905-12.948-14.778-0.073-8.471 6.688-15.274 14.772-14.427 7.065 0.74 13.909 5.813 14.173 14.394 0.060 1.92 0.042 4.131 2.794 3.92 2.474-0.191 2.075-2.312 2.091-4.011 0.080-7.65-3.626-13.525-9.931-17.006-7.645-4.222-15.619-3.177-22.526 2.211-6.377 4.974-7.786 11.907-6.096 19.527 1.721 7.771 11.57 15.49 18.997 15.079z', 'M194.783 567.358c2.096 3.247 4.044 2.873 6.533 1.197 3.511-2.362 6.854-4.98 10.433-7.228 2.645-1.661 2.821-3.375 1.172-5.817-2.761-4.096-4.219-4.532-8.588-0.698-3.248 2.848-5.045 1.962-7.037-1.094-4.874-7.471-9.839-14.886-14.715-22.353-0.716-1.097-1.323-2.151-2.819-2.133-4.317 0.243-7.259 4.892-4.897 8.533 6.471 9.971 13.472 19.602 19.918 29.593z', 'M318.65 654.228c-5.127 0.356-9.632 2.64-14.321 4.36-1.2 1.912-3.084 3.069-4.771 4.475-9.962 8.312-16.208 18.597-16.422 31.917-0.033 2.114-0.218 4.495 3.247 4.507 7.417 0.032 13.93-2.64 19.463-7.155 11.788-9.613 17.2-22.41 17.337-37.526-1.416-0.958-2.939-0.692-4.532-0.578z', 'M473.013 842.561c1.905 0.685 3.941 1.007 5.921 1.496 1.832 0.326 3.025-0.366 3.579-2.178 0.567-1.85-0.465-2.615-2.015-3.012-10.754-2.751-21.512-5.487-32.268-8.245-3.657-0.936-4.829-0.018-3.054 3.689 4.861 10.145 9.63 20.334 14.393 30.527 0.977 2.093 1.991 1.45 3.173 0.266 1.524-1.529 1.245-3.416 0.249-4.769-4.656-6.312-3.037-11.008 2.663-15.849 2.548-2.171 4.362-3.002 7.358-1.925z', 'M247.233 533.492c7.409 10.689 17.471 14.068 29.603 9.297 5.652-2.224 9.794-6.114 11.964-12.444 2.251-6.565 1.591-12.607-0.264-18.866-0.58-0.733-1.25-1.411-1.727-2.204-6.157-10.232-20.407-14.76-30.472-8.638-9.904 6.026-16.711 17.576-11.237 29.749 0.713 1.036 1.42 2.073 2.134 3.105z', 'M321.661 541.708c7.097-0.083 7.118-0.133 8.33-7.146 0.477-2.773 1.117-5.519 1.694-8.277 0.554-2.643 1.714-3.484 4.668-2.651 7.339 2.065 7.988 1.491 9.543-6.048 0.095-0.46 0.191-0.923 0.286-1.383-3.032-1.574-6.588-0.46-9.662-1.902-2.030-0.948-2.833-2.489-2.276-4.588 0.539-2.035 2.203-1.868 3.84-1.691 2.025 0.219 4.059 0.504 6.091 0.49 2.784-0.020 2.979-2.319 3.406-4.324 0.346-1.629 0.55-3.506-1.541-3.808-5.29-0.763-10.198-3.301-15.692-3.129-2.997 0.095-4.232 1.275-5.083 4.279-1.805 6.378-2.299 12.945-3.591 19.383 0.266 4.724-0.796 9.296-1.561 13.909-0.414 2.487-0.82 5.005 1.548 6.885z'],
  tags: ['macmail']
}, {
  paths: ['M390.963 20.675c-30.095 15.647-55.777 35.707-81.050 63.795-18.053 19.661-33.3 31.293-67.011 49.756-109.548 60.989-166.922 126.392-199.025 227.103-12.442 38.523-16.046 154.481-6.42 208.65 24.873 143.647 110.346 265.226 224.297 319.396 20.46 9.636 25.283 10.435 26.081 5.622 1.608-7.629 8.028-7.629 27.279 0.399 17.254 6.82 16.046 5.622-10.035-14.438-22.067-16.855-38.124-38.922-47.749-65.802-16.855-44.933-15.647-46.94 12.042-24.074 27.279 23.276 79.442 45.742 79.442 34.509 0-1.608-4.413-9.226-10.035-16.855-12.042-16.046-12.442-20.060-2.806-20.060 8.428 0 306.156 99.912 311.368 104.724 9.236 8.028-33.3 46.95-97.905 89.477-26.081 17.254-32.102 22.866-26.88 24.873 14.848 5.622 103.117-10.435 137.626-24.873 32.102-13.65 25.682-2.007-10.435 18.452l-22.047 12.431 18.053-2.806c51.753-7.629 102.318-30.495 139.633-62.996 14.449-12.442 28.088-21.268 31.293-20.060 12.442 4.813 91.085-89.876 115.958-139.233 21.668-43.735 39.721-103.526 52.961-174.541 7.619-42.936 8.827-173.742 1.608-214.671-15.636-87.071-69.007-179.763-134.41-233.933-43.735-35.717-139.233-79.852-202.23-92.692-55.378-11.633-174.141-11.633-223.498 0l-12.042 2.806 13.64-14.848c19.661-20.46 12.442-22.467-13.64-4.014-33.3 23.276-46.141 30.894-48.957 28.088-3.205-3.215 16.046-28.088 41.728-53.77 17.654-17.654 19.261-20.869 12.032-20.869-4.792 0.020-17.633 4.833-28.867 10.455zM211.999 293.12c6.42 3.205 13.64 11.233 16.046 18.452 8.827 24.873 3.615 75.837-7.619 75.837-2.406 0-16.046-18.053-30.495-40.53-23.675-36.116-26.081-41.329-22.067-50.156 3.215-7.619 7.229-9.626 18.463-9.626 8.018 0 19.651 2.816 25.672 6.021zM335.985 307.569c1.608 18.862-7.629 28.488-24.873 26.88-10.035-0.799-12.841-3.205-13.64-11.633-1.608-14.848 13.24-32.502 26.88-30.894 8.827 1.198 10.435 3.205 11.633 15.647zM192.737 376.576c13.24 19.661 25.682 43.735 28.088 53.371 3.615 13.24 7.219 19.261 14.039 21.668 10.035 4.014 21.668 19.261 81.050 106.332 29.696 43.336 37.315 52.163 44.943 50.954 4.813-0.399 63.396-22.477 130.007-48.558 149.668-58.982 187.791-73.021 201.83-73.83l11.233-0.799-0.399 46.141c0 37.714-1.597 50.555-9.226 70.216-15.647 42.527-15.647 39.721 2.007 32.102 20.47-8.428 46.141-28.488 59.791-46.95 6.42-8.028 13.24-14.039 15.247-12.442 10.435 6.42-13.64 110.346-44.134 187.781-7.629 19.661-23.276 52.961-34.509 73.032-24.074 44.943-20.47 44.134-93.491 20.869-97.096-30.495-453.007-149.268-463.442-154.481-8.428-4.014-12.841-12.042-20.859-38.523-12.042-37.714-20.869-83.855-25.283-127.601l-2.806-30.095 22.467 20.869c12.442 11.633 25.682 21.268 30.095 21.268 7.219 0 6.82-1.608-2.406-29.286-17.254-49.756-12.442-137.226 10.035-180.562 5.612-11.233 6.021-11.233 14.039-4.014 4.403 4.024 18.842 23.286 31.683 42.537zM476.426 339.261c63.795 7.219 186.184 32.901 193.802 40.53 8.028 8.028 28.887 71.025 25.272 76.636-1.198 1.608-8.028 6.42-14.848 10.035-24.873 12.841-317.788 128.399-322.202 126.792s-89.078-127.601-99.912-148.859c-8.428-17.254-6.42-21.668 13.24-32.102 8.827-4.413 24.474-14.848 35.308-22.876 22.477-17.254 38.124-25.283 75.837-39.322 44.145-16.046 46.152-16.445 93.501-10.834z'],
  tags: ['thunderbird']
}, {
  paths: ['M112.64 143.36c-50.79 0-92.16 41.37-92.16 92.16v8.724l491.52 349.676 491.52-349.676v-8.724c0-50.79-41.37-92.16-92.16-92.16zM130.089 184.32h763.761l-381.85 266.24zM20.48 287.273v501.207c0 50.79 41.37 92.16 92.16 92.16h798.72c50.79 0 92.16-41.37 92.16-92.16v-501.207l-122.88 87.45v464.957h-737.28v-464.957z'],
  tags: ['gmail']
}, {
  paths: ['M942.298 27.234h-860.596c-45.052 0-81.702 36.653-81.702 81.702v653.617c0 45.049 36.65 81.702 81.702 81.702h315.915v119.83h-114.383c-9.024 0-16.34 7.316-16.34 16.34s7.316 16.34 16.34 16.34h457.532c9.024 0 16.34-7.316 16.34-16.34s-7.316-16.34-16.34-16.34h-114.383v-119.83h315.915c45.052 0 81.702-36.653 81.702-81.702v-653.617c0-45.049-36.65-81.702-81.702-81.702zM593.702 964.085h-163.404v-119.83h163.404v119.83zM991.319 762.553c0 27.029-21.99 49.021-49.021 49.021h-860.596c-27.031 0-49.021-21.992-49.021-49.021v-49.021h958.638v49.021zM991.319 680.851h-958.638v-571.915c0-27.029 21.99-49.021 49.021-49.021h860.596c27.031 0 49.021 21.992 49.021 49.021v571.915z', 'M942.298 92.596h-860.596c-9.024 0-16.34 7.316-16.34 16.34v522.894c0 9.024 7.316 16.34 16.34 16.34h708.085c9.024 0 16.34-7.316 16.34-16.34s-7.316-16.34-16.34-16.34h-691.745v-490.213h827.915v490.213h-70.809c-9.024 0-16.34 7.316-16.34 16.34s7.316 16.34 16.34 16.34h87.149c9.024 0 16.34-7.316 16.34-16.34v-522.894c0-9.024-7.316-16.34-16.34-16.34z'],
  tags: ['desktop']
}, {
  paths: ['M597.334 51.2h-170.666c-9.42 0-17.066 7.646-17.066 17.066s7.646 17.066 17.066 17.066h170.666c9.42 0 17.066-7.646 17.066-17.066s-7.646-17.066-17.066-17.066z', 'M716.8 51.2h-17.066c-9.42 0-17.066 7.646-17.066 17.066s7.646 17.066 17.066 17.066h17.066c9.42 0 17.066-7.646 17.066-17.066s-7.646-17.066-17.066-17.066z', 'M533.196 870.4h-42.376c-25.958 0-47.086 21.128-47.086 47.086v8.244c0 25.958 21.128 47.070 47.070 47.070h42.376c25.958 0 47.086-21.112 47.086-47.070v-8.244c0-25.958-21.128-47.086-47.070-47.086zM546.134 925.73c0 7.134-5.802 12.936-12.936 12.936h-42.378c-7.15 0-12.954-5.802-12.954-12.936v-8.244c0-7.15 5.802-12.954 12.954-12.954h42.36c7.152 0 12.954 5.802 12.954 12.954v8.244z', 'M740.454 0h-456.892c-34.014 0-61.696 27.682-61.696 61.696v900.608c0 34.014 27.682 61.696 61.696 61.696h456.874c34.014 0 61.696-27.682 61.696-61.678v-900.626c0.002-34.014-27.68-61.696-61.678-61.696zM768 962.304c0 15.19-12.356 27.562-27.546 27.562h-456.892c-15.206 0-27.562-12.374-27.562-27.546v-900.624c0-15.19 12.356-27.562 27.562-27.562h456.874c15.206 0 27.562 12.374 27.562 27.562v900.608z', 'M785.066 102.4h-546.132c-9.42 0-17.066 7.646-17.066 17.066v716.8c0 9.42 7.646 17.066 17.066 17.066h546.134c9.42 0 17.066-7.646 17.066-17.066v-716.8c0-9.42-7.646-17.066-17.068-17.066zM768 819.2h-512v-682.666h512v682.666z'],
  tags: ['mobile']
}, {
  paths: ['M791.498 544.092c-1.294-129.682 105.758-191.876 110.542-194.966-60.152-88.020-153.85-100.078-187.242-101.472-79.742-8.074-155.596 46.948-196.066 46.948-40.368 0-102.818-45.754-168.952-44.552-86.916 1.292-167.058 50.538-211.812 128.38-90.304 156.698-23.126 388.84 64.89 515.926 43.008 62.204 94.292 132.076 161.626 129.58 64.842-2.588 89.362-41.958 167.756-41.958s100.428 41.958 169.050 40.67c69.774-1.296 113.982-63.398 156.692-125.796 49.39-72.168 69.726-142.038 70.924-145.626-1.548-0.706-136.060-52.236-137.408-207.134zM662.562 163.522c35.738-43.358 59.86-103.512 53.28-163.522-51.478 2.096-113.878 34.29-150.81 77.55-33.142 38.376-62.148 99.626-54.374 158.436 57.466 4.484 116.128-29.204 151.904-72.464z'],
  tags: ['apple']
}, {
  paths: ['M702 960c-54.2 52.6-114 44.4-171 19.6-60.6-25.3-116-26.9-180 0-79.7 34.4-122 24.4-170-19.6-271-279-231-704 77-720 74.7 4 127 41.3 171 44.4 65.4-13.3 128-51.4 198-46.4 84.1 6.8 147 40 189 99.7-173 104-132 332 26.9 396-31.8 83.5-72.6 166-141 227zM423 237C414.9 113 515.4 11 631 1c15.9 143-130 250-208 236z'],
  tags: ['mac']
}, {
  paths: ['M896 384c-35.2 0-64 28.8-64 64v256c0 35.2 28.8 64 64 64s64-28.8 64-64v-256c0-35.2-28.8-64-64-64zM128 384c-35.2 0-64 28.8-64 64v256c0 35.2 28.8 64 64 64s64-28.8 64-64v-256c0-35.2-28.802-64-64-64zM224 736c0 53.020 42.98 96 96 96v0 128c0 35.2 28.8 64 64 64s64-28.8 64-64v-128h128v128c0 35.2 28.8 64 64 64s64-28.8 64-64v-128c53.020 0 96-42.98 96-96v-352h-576v352z', 'M798.216 320.002c-9.716-87.884-59.004-163.792-129.62-209.646l32.024-64.046c7.904-15.806 1.496-35.028-14.31-42.932s-35.030-1.496-42.932 14.312l-32.142 64.286-8.35-3.316c-28.568-9.502-59.122-14.66-90.886-14.66-31.762 0-62.316 5.158-90.888 14.656l-8.348 3.316-32.142-64.282c-7.904-15.808-27.128-22.212-42.932-14.312-15.808 7.904-22.214 27.126-14.312 42.932l32.022 64.046c-70.616 45.852-119.904 121.762-129.622 209.644v32h574.222v-31.998h-1.784zM416 256c-17.674 0-32-14.328-32-32 0-17.648 14.288-31.958 31.93-31.996 0.032 0 0.062 0.002 0.094 0.002 0.018 0 0.036-0.002 0.052-0.002 17.638 0.042 31.924 14.35 31.924 31.996 0 17.672-14.326 32-32 32zM608 256c-17.674 0-32-14.328-32-32 0-17.646 14.286-31.954 31.924-31.996 0.016 0 0.034 0.002 0.050 0.002 0.032 0 0.064-0.002 0.096-0.002 17.64 0.038 31.93 14.348 31.93 31.996 0 17.672-14.326 32-32 32z'],
  tags: ['android']
}, {
  paths: ['M0.35 512l-0.35-312.074 384-52.144v364.218zM448 138.482l511.872-74.482v448h-511.872zM959.998 576l-0.126 448-511.872-72.016v-375.984zM384 943.836l-383.688-52.594-0.020-315.242h383.708z'],
  tags: ['windows']
}, {
  paths: ['M594.272 42.994c0 19.474 0.137 27.296 0.301 17.385 0.167-9.911 0.167-25.844 0-35.406-0.164-9.562-0.301-1.452-0.301 18.022zM382.39 40.465c0 0.556 0.683 1.012 1.517 1.012s1.517-0.455 1.517-1.012c0-0.556-0.683-1.012-1.517-1.012s-1.517 0.455-1.517 1.012zM377.332 41.476c0 0.556 0.683 1.012 1.517 1.012s1.517-0.455 1.517-1.012c0-0.556-0.683-1.012-1.517-1.012s-1.517 0.455-1.517 1.012zM345.972 47.546c0 0.556 0.683 1.012 1.517 1.012s1.517-0.455 1.517-1.012c0-0.556-0.683-1.012-1.517-1.012s-1.517 0.455-1.517 1.012zM84.975 98.126c0 0.556 0.683 1.012 1.517 1.012s1.517-0.455 1.517-1.012c0-0.556-0.683-1.012-1.517-1.012s-1.517 0.455-1.517 1.012zM79.917 99.138c0 0.556 0.683 1.012 1.517 1.012s1.517-0.455 1.517-1.012c0-0.556-0.683-1.012-1.517-1.012s-1.517 0.455-1.517 1.012zM701.728 217.244c38.487 0.147 101.763 0.147 140.614 0s7.362-0.268-69.976-0.268c-77.338 0-109.125 0.121-70.638 0.268zM971.92 218.212c1.257 0.243 3.078 0.233 4.046-0.020 0.966-0.253-0.063-0.453-2.289-0.44-2.226 0.010-3.017 0.217-1.758 0.46zM996.998 227.613c2.208 2.504 5.066 5.918 6.35 7.587l2.339 3.035-1.813-3.295c-0.996-1.813-3.854-5.228-6.35-7.587l-4.54-4.292 4.014 4.552zM1007.301 242.797c0.875 2.233 1.775 3.874 2 3.652 0.486-0.488-2.435-7.708-3.118-7.708-0.263 0 0.24 1.826 1.118 4.057zM981.864 278.884c-9.964 6.854-17.807 12.461-17.43 12.461 0.693 0 33.717-21.76 35.477-23.378 4.057-3.723-2.729 0.382-18.047 10.918zM939.381 307.277c-5.503 3.756-10.716 7.284-11.583 7.84-0.87 0.556-2.127 1.507-2.795 2.112-0.67 0.604-3.551 2.597-6.406 4.428-2.853 1.831-4.982 3.536-4.732 3.786 0.541 0.544 24.681-15.42 27.099-17.921 0.926-0.959 3.316-2.752 5.311-3.983 3.101-1.917 4.38-3.090 3.369-3.090-0.144 0-4.762 3.073-10.263 6.828zM901.757 332.977l-1.927 2.18 2.782-1.791c2.868-1.846 3.412-2.569 1.927-2.569-0.47 0-1.722 0.981-2.782 2.18zM881.11 346.617c-20.594 13.697-18.735 12.311-17.784 13.262 0.417 0.417 1.29 0.040 1.94-0.837 0.65-0.875 8.237-6.282 16.861-12.013 15.121-10.048 18.128-12.185 17.142-12.185-0.253 0-8.424 5.298-18.158 11.773zM1002.268 343.708c-5.511 3.591-7.064 5.298-4.818 5.298 0.556 0 1.012-0.455 1.012-1.012s0.683-1.012 1.517-1.012c0.835 0 1.517-0.455 1.517-1.012s0.683-1.012 1.517-1.012c0.835 0 1.517-0.455 1.517-1.012s0.683-1.012 1.517-1.012c0.835 0 1.517-0.483 1.517-1.072s0.455-0.789 1.012-0.445c0.556 0.344 1.012 0.144 1.012-0.445 0-1.715-1.161-1.282-7.322 2.734zM1010.933 347.489c0.005 3.895 0.187 5.364 0.407 3.265s0.215-5.286-0.008-7.081c-0.225-1.796-0.405-0.078-0.4 3.816zM253.409 343.478c-1.669 0.766-2.352 1.396-1.517 1.401s2.655-0.642 4.046-1.436c3.199-1.828 1.49-1.803-2.529 0.035zM353.136 344.325c1.042 0.931 6.998 3.67 6.998 3.217 0-0.584-5.609-3.594-6.694-3.594-0.397 0-0.534 0.169-0.303 0.377zM989.863 351.748c-2.226 1.444-4.188 2.979-4.363 3.417-0.172 0.435-2.562 2.236-5.311 3.998-2.747 1.763-4.995 3.437-4.995 3.723 0 0.599 3.068-1.315 11.935-7.448 3.505-2.425 6.806-4.408 7.334-4.408 0.531 0 0.964-0.455 0.964-1.012 0-1.507-1.093-1.168-5.564 1.73zM226.095 360.364c-6.512 5.448-16.692 15.989-16.692 17.283 0 0.551 4.666-3.495 10.369-8.988 13.148-12.668 15.961-16.358 6.323-8.295zM374.297 357.906c0 1.017 3.333 4.251 4.378 4.251 1.419 0 0.524-1.586-1.882-3.336-1.373-0.999-2.496-1.411-2.496-0.916zM384.919 368.227c4.97 5.045 5.564 5.528 5.564 4.529 0-1.075-8.389-9.588-9.448-9.588-0.604 0 1.146 2.276 3.885 5.058zM831.827 379.704c-12.364 8.369-22.309 15.389-22.096 15.602 0.349 0.349 42.311-27.187 44.508-29.21 4.246-3.905-3.364 0.716-22.412 13.609zM937.785 386.426c-10.837 7.167-19.866 13.515-20.060 14.102s8.9-5.139 20.212-12.724c22.946-15.384 21.747-14.539 20.483-14.466-0.511 0.028-9.795 5.918-20.634 13.088zM391.537 375.055c0.073 1.277 7.929 9.818 8.503 9.244 0.296-0.296-0.291-1.429-1.302-2.514-1.012-1.087-2.653-3.217-3.647-4.732-1.697-2.59-3.649-3.687-3.553-1.998zM205.787 381.671c-4.633 5.475-4.876 5.867-3.255 5.245 1.679-0.645 6.275-6.472 5.62-7.129-0.23-0.23-1.295 0.617-2.365 1.884zM401.61 387.584c0.835 0.759 2.172 2.064 2.972 2.898 1.128 1.176 1.11 0.961-0.086-0.956-0.847-1.361-2.185-2.666-2.972-2.898-1.153-0.341-1.136-0.154 0.086 0.956zM294.885 399.587c0.344 0.556 2.848 1.012 5.564 1.012s5.22-0.455 5.564-1.012c0.392-0.632-1.694-1.012-5.564-1.012s-5.956 0.379-5.564 1.012zM274.822 404.309c-1.229 1.229-0.701 2.306 0.842 1.715 0.835-0.321 1.517-0.989 1.517-1.487 0-1.060-1.393-1.196-2.36-0.228zM328.774 405.652c0 0.521 0.9 1.426 2 2.016 1.606 0.86 1.889 0.781 1.439-0.392-0.652-1.702-3.439-3.017-3.439-1.624zM895.009 415.176c-9.987 6.76-15.971 11.33-9.78 7.471 7.066-4.406 20.781-13.353 21.631-14.109 3.293-2.936-2.484 0.298-11.851 6.639zM186.339 413.952c-1.211 2.868-2.043 5.377-1.846 5.571 0.197 0.197 1.361-1.978 2.587-4.83 1.229-2.853 2.059-5.359 1.846-5.571-0.21-0.212-1.376 1.963-2.587 4.83zM333.832 408.955c0 0.238 2.39 2.425 5.311 4.861 2.921 2.438 4.671 3.629 3.89 2.65-1.568-1.968-9.201-8.199-9.201-7.511zM414.832 409.197c0 0.556 0.652 2.15 1.447 3.541s1.447 2.074 1.447 1.517c0-0.556-0.652-2.15-1.447-3.541s-1.447-2.074-1.447-1.517zM777.425 416.329c-3.338 2.438-6.639 4.449-7.334 4.466-0.695 0.020-1.265 0.415-1.265 0.875 0 0.463-1.244 1.487-2.767 2.276-1.522 0.792-3.457 1.998-4.299 2.681-0.842 0.685-2.443 1.963-3.556 2.838-1.927 1.517-1.902 1.535 0.506 0.359 4.54-2.215 25.29-16.365 25.29-17.243 0-1.118 0.384-1.338-6.575 3.748zM632.814 419.693c2.031 1.874 20.956 13.346 21.358 12.946 0.23-0.233-3.126-2.615-7.458-5.296-4.335-2.681-8.108-5.129-8.386-5.44-0.761-0.852-4.929-3.096-5.754-3.096-0.397 0-0.288 0.4 0.24 0.885zM251.56 427.063c-3.285 3.743-5.131 6.927-4.003 6.902 0.711-0.018 7.797-10.098 7.096-10.098-0.159 0-1.55 1.439-3.093 3.197zM355.266 436.304c3.629 7.236 3.675 7.304 4.411 6.565 0.809-0.807-4.76-11.768-6.272-12.347-0.708-0.271 0.132 2.332 1.861 5.781zM866.151 434.126c-1.831 1.171-3.108 2.352-2.84 2.623 0.493 0.493 6.677-3.538 6.677-4.352 0-0.675-0.273-0.551-3.837 1.73zM244.378 437.884c-1.826 3.536-1.937 4.191-0.703 4.191 1.108 0 3.639-5.926 2.863-6.702-0.311-0.311-1.282 0.817-2.16 2.511zM739.742 441.18c-3.447 2.208-4.565 3.692-1.517 2.016 2.322-1.275 5.958-4.087 5.311-4.107-0.278-0.008-1.985 0.933-3.794 2.092zM845.541 447.28c-6.864 4.529-13.389 9.084-14.501 10.119s-2.934 2.595-4.046 3.47c-3.374 2.65 0.572 0.362 8.599-4.985 4.173-2.782 7.739-5.432 7.923-5.893 0.187-0.458 0.984-0.835 1.77-0.835 0.789 0 1.434-0.455 1.434-1.012s0.683-1.012 1.517-1.012c0.835 0 1.517-0.455 1.517-1.012s0.683-1.012 1.517-1.012c0.835 0 1.517-0.455 1.517-1.012s0.683-1.012 1.517-1.012c0.835 0 1.517-0.455 1.517-1.012s0.683-1.012 1.517-1.012c0.835 0 1.517-0.455 1.517-1.012 0-1.56-0.058-1.528-13.318 7.228zM240.928 445.658c-1.411 3.098-1.444 3.498-0.283 3.498 0.802 0 2.329-5.192 1.712-5.822-0.139-0.142-0.781 0.905-1.429 2.324zM720.026 453.488c-11.492 7.064-14.099 9.206-9.873 8.1 1.113-0.291 2.023-0.857 2.023-1.259s4.552-3.563 10.116-7.028c8.5-5.291 11.322-7.337 9.863-7.147-0.139 0.018-5.597 3.318-12.129 7.334zM678.792 447.484c0 0.301 4.666 3.169 10.369 6.376s10.685 6.292 11.072 6.856c0.387 0.564 1.032 0.698 1.434 0.296 0.908-0.908 1.267-0.645-7.195-5.22-3.895-2.104-9.016-4.957-11.381-6.34-2.365-1.381-4.299-2.266-4.299-1.968zM789.276 484.745c-8.505 5.609-15.268 10.394-15.030 10.632s7.423-4.196 15.968-9.848c16.97-11.231 16.79-11.105 15.452-11.034-0.511 0.028-7.886 4.638-16.391 10.25zM231.935 483.551c0 2.504 0.197 3.528 0.438 2.276 0.243-1.252 0.243-3.3 0-4.552-0.24-1.252-0.438-0.228-0.438 2.276zM368.953 484.31c-0.225 0.417-0.068 1.897 0.344 3.288 0.703 2.365 0.759 2.314 0.852-0.759 0.099-3.171-0.349-4.115-1.196-2.529zM167.728 488.164c-0.23 1.983-0.053 3.829 0.395 4.107 0.45 0.278 0.817-1.343 0.817-3.601 0-5.071-0.647-5.339-1.211-0.506zM434.382 509.347c0 7.789 0.159 10.842 0.352 6.783 0.192-4.057 0.192-10.43-0.003-14.163-0.195-3.73-0.352-0.41-0.349 7.38zM763.009 501.876c-1.808 1.158-3.288 2.521-3.288 3.027s1.588-0.106 3.528-1.363c1.94-1.257 3.533-2.628 3.541-3.045 0.018-1.034-0.048-1.012-3.781 1.381zM370.2 502.266c-0.377 3.758 0.008 26.089 0.455 26.537 0.334 0.334 0.607-5.614 0.607-13.217 0-10.66-0.589-18.050-1.062-13.32zM656.716 507.84c0.364 1.057 27.281 19.4 27.764 18.92 0.167-0.169-6.085-4.707-13.892-10.088-7.807-5.379-14.049-9.355-13.872-8.831zM754.208 507.749c-0.316 0.511-6.831 4.896-14.476 9.744s-14.355 9.294-14.911 9.878c-1.247 1.308 0.569 0.23 17.45-10.369 7.372-4.628 13.404-8.811 13.404-9.299 0-1.153-0.741-1.13-1.467 0.046zM167.591 533.879c-0.253 0.417-0.104 2.58 0.329 4.805l0.787 4.046 0.116-4.805c0.111-4.588-0.23-5.711-1.232-4.046zM231.915 539.695c0.010 2.226 0.217 3.017 0.46 1.758 0.243-1.257 0.233-3.078-0.020-4.046-0.253-0.966-0.453 0.063-0.44 2.289zM365.066 561.782c-0.071 0.372-0.19 1.017-0.268 1.434s-0.483 1.297-0.903 1.952c-0.417 0.658-0.344 1.452 0.162 1.765 1.001 0.617 2.597-4.363 1.689-5.271-0.303-0.306-0.609-0.25-0.68 0.119zM238.293 570.803c0.384 1.252 1.323 3.414 2.086 4.805l1.386 2.529-0.45-2.87c-0.248-1.578-0.923-3.439-1.502-4.137-0.582-0.701-0.756-1.571-0.389-1.937s0.104-0.665-0.582-0.665c-0.83 0-1.014 0.766-0.549 2.276zM359.712 576.258c-0.845 2.208 0.278 3.235 1.474 1.343s1.222-3.004 0.068-3.004c-0.498 0-1.191 0.749-1.543 1.662zM241.775 579.189c0 1.414 4.259 8.682 4.78 8.161 0.774-0.774-2.8-8.707-3.923-8.707-0.47 0-0.857 0.245-0.857 0.546zM355.805 585.218c-1.502 3.060-2.286 5.564-1.745 5.564 0.85 0 6.075-9.105 6.075-10.589 0-2.028-2.021 0.314-4.33 5.025zM247.845 590.782c0.594 1.113 1.525 2.023 2.066 2.023 0.546 0 0.422-0.903-0.278-2.023-0.695-1.113-1.624-2.023-2.066-2.023s-0.316 0.91 0.278 2.023zM180.138 597.084c-0.116 1.196 3.182 8.993 3.617 8.556 0.22-0.22-0.486-2.403-1.571-4.848s-2.006-4.115-2.046-3.708zM415.907 605.079c-1.196 2.883-2.011 5.41-1.806 5.612 0.205 0.205 1.351-1.988 2.549-4.868 1.196-2.883 2.011-5.41 1.806-5.612-0.205-0.205-1.351 1.988-2.549 4.868zM259.479 604.805c2.226 2.395 5.412 5.301 7.081 6.457 3.538 2.451 3.078 1.963-5.058-5.354-5.147-4.628-5.455-4.795-2.023-1.103zM270.101 614.006c0 0.541 0.91 1.472 2.023 2.066s2.023 0.721 2.023 0.278c0-0.443-0.91-1.371-2.023-2.066-1.12-0.701-2.023-0.824-2.023-0.278zM326.245 615.736c-5.88 3.030-6.087 3.184-5.326 3.945 0.802 0.802 10.89-4.431 10.89-5.65 0-1.244 0.405-1.368-5.564 1.705zM279.205 619.094c0 0.698 2.38 2.036 3.624 2.036 1.381 0 0.083-1.877-1.601-2.317-1.113-0.291-2.023-0.164-2.023 0.281zM285.275 621.13c0 0.556 0.683 1.012 1.517 1.012s1.517-0.455 1.517-1.012c0-0.556-0.683-1.012-1.517-1.012s-1.517 0.455-1.517 1.012zM197.925 632.83c4.954 7.069 7.438 9.878 8.126 9.188 0.367-0.364-0.989-2.37-3.010-4.454-2.023-2.084-4.648-4.927-5.837-6.318s-0.862-0.678 0.721 1.583zM395.472 639.086c-1.894 2.643-6.818 8.341-10.943 12.663s-7.271 8.088-6.99 8.366c0.554 0.554 14.211-13.611 17.496-18.148 1.113-1.535 2.82-3.735 3.794-4.889 1.99-2.355 2.137-2.797 0.931-2.797-0.463 0-2.39 2.162-4.287 4.805zM207.383 643.947c0.003 1.608 13.229 14.82 22.228 22.2l2.466 2.023-2.486-3.035c-3.943-4.815-22.21-22.243-22.207-21.188zM373.26 662.652c-1.022 1.912-0.948 1.97 0.976 0.769 2.19-1.368 2.764-2.838 1.108-2.838-0.536 0-1.474 0.931-2.084 2.069zM1011.016 684.356c-0.003 9.459 0.149 13.465 0.336 8.902 0.187-4.565 0.19-12.304 0.003-17.197-0.185-4.896-0.339-1.163-0.339 8.295zM355.076 674.746c-1.947 1.067-3.176 1.957-2.731 1.98 1.072 0.056 6.778-2.911 6.778-3.523 0-0.663-0.058-0.64-4.046 1.543zM346.983 678.286c-1.391 0.794-2.074 1.447-1.517 1.447s2.15-0.652 3.541-1.447c1.391-0.794 2.074-1.447 1.517-1.447s-2.15 0.652-3.541 1.447zM254.79 680.35c1.871 0.812 3.692 1.462 4.046 1.442 1.315-0.073-4.476-2.929-5.933-2.924-0.835 0.003 0.015 0.668 1.887 1.482zM339.396 681.357c-2.529 1.219-2.615 1.358-0.506 0.845 2.865-0.701 6.087-2.344 4.552-2.322-0.556 0.008-2.377 0.673-4.046 1.477zM295.179 687.636c3.498 0.197 8.96 0.195 12.139-0.005 3.176-0.2 0.314-0.362-6.363-0.359-6.677 0-9.276 0.164-5.776 0.364zM1006.623 731.695c-0.63 1.907-2.724 6.148-4.656 9.426-1.93 3.275-2.532 4.818-1.338 3.427 2.572-2.992 8.417-15.043 7.663-15.799-0.288-0.286-1.039 1.039-1.669 2.946zM954.722 763.472c1.257 0.243 3.078 0.233 4.046-0.020 0.966-0.253-0.063-0.453-2.289-0.44-2.226 0.010-3.017 0.217-1.758 0.46zM878.839 764.524c8.485 0.169 22.369 0.169 30.854 0s1.543-0.306-15.427-0.306c-16.97 0-23.912 0.137-15.427 0.306zM0.374 872.010c0 5.842 0.167 8.232 0.372 5.311s0.205-7.701 0-10.622c-0.205-2.921-0.372-0.531-0.372 5.311zM114.312 923.603c0 0.556 0.683 1.012 1.517 1.012s1.517-0.455 1.517-1.012c0-0.556-0.683-1.012-1.517-1.012s-1.517 0.455-1.517 1.012zM133.533 927.649c0 0.556 0.683 1.012 1.517 1.012s1.517-0.455 1.517-1.012c0-0.556-0.683-1.012-1.517-1.012s-1.517 0.455-1.517 1.012zM345.972 972.16c0 0.556 0.683 1.012 1.517 1.012s1.517-0.455 1.517-1.012c0-0.556-0.683-1.012-1.517-1.012s-1.517 0.455-1.517 1.012z', 'M571.055 5.164c-10.571 2.203-20.586 4.244-22.255 4.54s-3.945 0.698-5.058 0.893c-3.71 0.65-8.070 1.517-10.116 2.008-8.075 1.945-27.276 5.475-27.663 5.086-0.263-0.26-1.082 0.028-1.821 0.64-0.741 0.615-2.018 0.857-2.843 0.541s-1.78-0.116-2.127 0.443c-0.344 0.559-1.383 0.923-2.306 0.812-0.926-0.114-2.365 0.051-3.199 0.359-3.642 1.356-29.451 5.865-30.359 5.306-0.551-0.341-1.001-0.106-1.001 0.524s-1.024 1.044-2.276 0.921c-1.252-0.121-2.959 0.048-3.794 0.379-3.437 1.366-28.596 5.883-29.924 5.372-0.789-0.303-1.436-0.058-1.436 0.546 0 0.627-1.087 0.89-2.529 0.615-1.391-0.266-2.529-0.169-2.529 0.212 0 0.384-3.073 1.249-6.828 1.925-3.756 0.673-16.327 3.058-27.936 5.296s-21.76 3.819-22.561 3.513c-0.903-0.346-1.186-0.129-0.751 0.577 0.483 0.781-0.293 0.991-2.476 0.67-1.748-0.255-3.179-0.038-3.179 0.488 0 0.524-1.138 0.736-2.529 0.47s-2.529-0.164-2.529 0.225c0 0.392-3.3 1.29-7.334 1.998s-16.439 3.075-27.566 5.26c-11.128 2.183-21.826 4.206-23.773 4.497-1.947 0.288-4.302 0.746-5.23 1.014-1.955 0.567-7.387 1.679-14.496 2.972-1.113 0.202-5.164 1.080-9.003 1.952-3.839 0.87-7.213 1.353-7.494 1.070-0.283-0.283-1.12-0.010-1.859 0.602-0.741 0.615-2.018 0.857-2.843 0.541s-1.763-0.147-2.086 0.377c-0.324 0.524-1.591 0.941-2.815 0.923-1.224-0.015-3.591 0.253-5.26 0.597s-3.945 0.741-5.058 0.883c-1.113 0.142-2.706 0.539-3.541 0.883-3.111 1.28-23.295 4.884-24.205 4.32-0.518-0.321-1.244-0.101-1.611 0.493-0.364 0.592-1.421 0.984-2.344 0.873-0.926-0.114-2.365 0.076-3.199 0.417-3.090 1.267-28.75 5.812-30.032 5.321-0.731-0.281-1.328-0.018-1.328 0.587 0 0.627-1.087 0.89-2.529 0.615-1.391-0.266-2.529-0.164-2.529 0.225 0 0.964-13.834 3.381-15.048 2.63-0.531-0.329-1.118-0.205-1.305 0.273-0.43 1.103-45.007 9.595-46.269 8.814-0.516-0.319-1.098-0.096-1.295 0.496-0.197 0.589-2.691 1.161-5.544 1.27s-5.033 0.453-4.846 0.764c0.187 0.311-5.437 1.606-12.501 2.881-7.061 1.272-25.356 4.805-40.657 7.85-29.655 5.903-32.89 6.51-35.659 6.712-1.882 0.137-2.602 570.868-0.91 720.81 0.766 67.945-0.094 62.105 9.332 63.4 2.739 0.377 5.24 1.105 5.556 1.619 0.319 0.513 0.964 0.695 1.434 0.402 0.473-0.291 3.743 0.175 7.266 1.034s7.544 1.743 8.935 1.96c1.391 0.217 4.578 0.9 7.081 1.515s5.463 1.297 6.575 1.517c1.113 0.217 6.12 1.297 11.128 2.398 12.782 2.807 38.34 8.181 45.27 9.517 3.199 0.617 5.817 1.525 5.817 2.016s0.458 0.609 1.019 0.263c1.254-0.774 37.794 6.679 38.267 7.807 0.187 0.445 0.764 0.546 1.282 0.228 1.204-0.744 22.544 3.733 22.996 4.823 0.187 0.45 0.756 0.559 1.262 0.245 1.189-0.733 42.799 7.797 43.249 8.869 0.187 0.443 0.718 0.572 1.181 0.286 0.819-0.506 29.337 5.013 32.369 6.262 0.835 0.346 2.274 0.536 3.199 0.422 0.923-0.111 1.963 0.253 2.306 0.812 0.346 0.559 1.302 0.759 2.127 0.443s2.102-0.073 2.843 0.541c0.738 0.612 1.53 0.928 1.76 0.701 0.228-0.228 4.509 0.47 9.517 1.55 5.005 1.080 10.468 2.215 12.137 2.524 1.669 0.306 4.856 1.004 7.081 1.55 5.67 1.393 33.752 7.342 50.262 10.65 7.615 1.525 13.669 3.055 13.457 3.399s1.019 0.42 2.739 0.167c1.909-0.281 2.883-0.068 2.506 0.541-0.372 0.602 0.384 0.812 1.879 0.526 1.512-0.291 2.499-0.008 2.499 0.711 0 0.655 0.468 0.9 1.042 0.546 1.186-0.733 37.751 6.573 38.193 7.633 0.159 0.379 1.411 0.475 2.782 0.212 1.507-0.288 2.494-0.005 2.494 0.713 0 0.655 0.45 0.91 0.999 0.572 1.239-0.766 17.587 2.625 18.055 3.745 0.187 0.445 0.759 0.551 1.272 0.235 1.151-0.711 17.187 2.456 18.715 3.695 0.607 0.493 1.333 0.67 1.611 0.389 0.688-0.688 16.224 2.544 17.61 3.662 0.607 0.491 1.338 0.66 1.624 0.374 0.521-0.521 29.339 5.119 32.172 6.295 0.835 0.349 1.927 0.536 2.428 0.422 0.501-0.116 1.639 0.101 2.529 0.486 1.78 0.766 2.848 1.001 8.401 1.864 2.061 0.321 6.841 1.308 10.622 2.193s8.012 1.816 9.403 2.066c1.391 0.25 4.122 0.875 6.070 1.388 3.556 0.933 52.503 11.113 53.438 11.113 0.407 0-0.847-907.121-1.376-995.427-0.129-21.322-0.402-25.826-1.578-25.973-0.781-0.099-10.071 1.624-20.642 3.824zM772.114 218.177l-139.855 0.339 0.129 88.764c0.071 48.823 0.412 93.716 0.759 99.763l0.63 10.996 28.325 17.607c15.579 9.684 31.82 19.375 36.092 21.532 4.272 2.16 7.496 4.198 7.165 4.527-1.047 1.047 0.779 0.65 2.056-0.448 0.673-0.579 14.195-9.491 30.052-19.807 27.976-18.201 122.613-81.313 151.186-100.825 7.762-5.301 38.421-25.953 68.13-45.897l54.015-36.261-0.587-4.33c-2.521-18.561-19.041-34.648-36.026-35.085-37.508-0.966-82.871-1.161-202.070-0.875zM321.693 333.83c3.245 0.281 16.823 3.338 19.221 4.327 1.391 0.574 3.376 1.206 4.413 1.404 21.363 4.107 57.004 39.486 71.905 71.372 6.596 14.112 16.307 48.11 14.314 50.103-0.321 0.319-0.134 1.12 0.415 1.783 0.549 0.66 1.194 4.216 1.429 7.898 0.238 3.682 0.718 7.162 1.070 7.729 0.711 1.156 0.738 2.215 0.789 31.408 0.048 28.335-0.020 30.083-1.176 30.799-0.559 0.344-0.771 1.262-0.473 2.038 0.567 1.472-1.434 16.56-2.403 18.148-0.306 0.501-0.723 2.777-0.928 5.058s-0.792 4.292-1.308 4.466c-0.516 0.175-0.713 0.898-0.44 1.608 0.88 2.299-8.847 29.941-14.35 40.771-18.816 37.030-43.638 59.903-77.201 71.132-12.777 4.277-27.46 5.349-57.027 4.17-3.601-0.144-14.522-2.676-18.442-4.277-1.669-0.68-3.654-1.363-4.408-1.515-14.618-2.946-46.016-28.98-60.677-50.313-10.331-15.030-25.27-51.324-25.789-62.649-0.094-2.081-0.549-3.788-1.007-3.794-0.46-0.003-0.703-1.257-0.544-2.787 0.162-1.53-0.066-3.364-0.506-4.072-0.438-0.711-0.673-2.999-0.521-5.086 0.149-2.089-0.063-4.34-0.475-5.007-0.738-1.196-0.908-8.68-0.819-36.163 0.025-7.789 0.035-18.323 0.020-23.409-0.013-5.086 0.407-9.514 0.933-9.84s0.751-1.674 0.498-2.994c-1.694-8.867 9.211-46.112 19.547-66.761 21.077-42.101 58.724-71.996 94.449-74.998 2.934-0.248 5.551-0.668 5.817-0.933 0.397-0.395 28.358-0.076 33.672 0.384zM989.357 354.899c-19.198 12.6-31.871 20.976-119.37 78.891-105.863 70.069-134.716 88.923-151.57 99.047-15.086 9.062-14.83 9.13-44.731-11.94-17.984-12.673-37.971-26.12-39.951-26.881-1.29-0.493-1.477 16.542-1.477 134.593v135.159l149.466-0.013c175.459-0.018 192.7-0.556 202.575-6.323 9.608-5.609 19.704-18.538 23.437-30.009 3.52-10.812 5.448-385.556 1.985-385.485-0.352 0.008-9.514 5.84-20.364 12.961zM293.368 400.715c0 0.341-2.092 0.908-4.648 1.257-17.658 2.42-36.666 21.616-46.64 47.101-2.089 5.331-4.034 9.921-4.325 10.2-0.293 0.278-0.594 1.416-0.675 2.529-0.152 2.167-2.291 13.247-3.004 15.556-0.713 2.319-0.549 67.325 0.175 69.215 0.369 0.964 0.443 2.635 0.162 3.713-0.283 1.077-0.081 2.104 0.445 2.279 0.529 0.177 1.050 2.018 1.158 4.092s0.455 3.771 0.771 3.773c0.316 0.003 1.388 2.623 2.385 5.822 9.61 30.844 30.419 52.101 52.74 53.873 38.505 3.058 61.979-16.874 72.836-61.842 1.528-6.328 2.994-12.187 3.26-13.022s0.389-3.442 0.276-5.791c-0.114-2.352 0.106-4.78 0.488-5.397 0.933-1.512 0.979-36.734 0.051-38.239-0.405-0.655-0.65-3.799-0.546-6.988s-0.142-6.601-0.549-7.582c-0.405-0.981-0.536-3.144-0.293-4.805 0.245-1.662 0.015-3.022-0.508-3.022s-0.751-1.356-0.508-3.010c0.243-1.657 0.159-3.136-0.182-3.288-0.344-0.154-1.641-4.148-2.883-8.877-8.202-31.234-28.452-53.6-51.016-56.347-2.643-0.321-4.805-0.862-4.805-1.204 0-0.339-3.187-0.617-7.081-0.617s-7.081 0.281-7.081 0.622z', 'M593.235 29.337c0 11.962 0.147 16.856 0.324 10.875 0.18-5.981 0.18-15.769 0-21.75-0.177-5.981-0.324-1.087-0.324 10.875zM527.556 13.151c-2.8 0.713-2.84 0.781-0.506 0.878 1.391 0.056 3.212-0.339 4.046-0.878 1.722-1.113 0.832-1.113-3.541 0zM507.324 17.245c-1.411 0.637-0.797 0.728 2.023 0.301 2.226-0.339 4.236-0.784 4.469-0.989 0.867-0.766-4.55-0.192-6.492 0.688zM219.722 72.823c-1.836 0.435-3.624 1.075-3.973 1.424-0.855 0.855 5.905-0.46 7.817-1.52 1.811-1.004 0.678-0.976-3.844 0.096zM594.3 232.671c0 44.233 0.124 62.328 0.276 40.212s0.152-58.307 0-80.423c-0.152-22.116-0.276-4.021-0.276 40.212zM701.806 218.255c38.53 0.147 101.579 0.147 140.108 0s7.005-0.268-70.054-0.268c-77.060 0-108.584 0.121-70.054 0.268zM950.691 218.238c2.377 0.215 6.019 0.212 8.093-0.005 2.071-0.217 0.124-0.392-4.327-0.389-4.451 0.005-6.146 0.182-3.766 0.395zM969.884 219.222c1.252 0.243 3.3 0.243 4.552 0 1.252-0.24 0.228-0.438-2.276-0.438s-3.528 0.197-2.276 0.438zM983.288 220.243c0.835 0.311 2.769 1.199 4.299 1.97 1.53 0.774 2.782 1.179 2.782 0.9 0-0.794-5.822-3.604-7.284-3.513-0.883 0.053-0.817 0.263 0.202 0.642zM971.275 284.754c-3.548 2.428-6.962 4.97-7.587 5.642-0.627 0.673 2.504-1.184 6.955-4.125 9.403-6.214 9.216-6.072 8.009-5.996-0.511 0.033-3.831 2.049-7.377 4.479zM287.298 333.847c-1.067 0.698-0.468 0.802 2.023 0.344 4.363-0.802 5.187-1.376 1.94-1.356-1.345 0.008-3.128 0.463-3.963 1.012zM301.225 333.554c1.818 0.225 4.55 0.22 6.070-0.010s0.033-0.415-3.305-0.41c-3.338 0.005-4.583 0.195-2.764 0.42zM312.672 333.182c0.233 0.2 2.243 0.642 4.469 0.984 2.757 0.422 3.563 0.311 2.529-0.346-1.383-0.883-7.979-1.482-6.998-0.637zM275.28 335.393c-3.551 0.771-6.737 1.712-7.081 2.094-0.344 0.379 0.511 0.4 1.902 0.043s5.374-1.153 8.852-1.77c3.477-0.617 6.323-1.305 6.323-1.525 0-0.68-3.255-0.303-9.995 1.158zM326.245 335.372c2.782 0.716 5.969 1.29 7.081 1.277s-0.253-0.607-3.035-1.323c-2.782-0.716-5.969-1.29-7.081-1.277s0.253 0.607 3.035 1.323zM337.373 337.879c1.113 0.478 2.706 0.87 3.541 0.87 0.956 0 0.769-0.321-0.506-0.87-1.113-0.478-2.706-0.87-3.541-0.87-0.956 0-0.769 0.321 0.506 0.87zM261.502 339.361c-3.907 1.788-2.089 1.813 2.529 0.035 1.947-0.751 2.858-1.378 2.023-1.396-0.835-0.015-2.883 0.594-4.552 1.361zM956.986 375.308c-4.173 2.779-7.241 5.053-6.816 5.056 0.857 0.003 14.909-9.191 14.909-9.757 0-0.65-0.45-0.389-8.093 4.701zM1011.019 396.046c0.003 10.015 0.154 13.975 0.336 8.801 0.185-5.174 0.185-13.368 0-18.209-0.187-4.841-0.336-0.607-0.336 9.408zM813.564 390.902c-6.161 4.223-9.38 6.846-6.297 5.129 3.225-1.793 13.151-8.682 13.151-9.127 0-0.695-0.005-0.693-6.854 3.998zM632.42 407.872c-0.089 5.392 0.18 10.017 0.597 10.278 0.417 0.258 0.635-2.787 0.483-6.77-0.473-12.324-0.91-13.75-1.080-3.508zM415.844 409.197c0 0.556 0.652 2.15 1.447 3.541s1.447 2.074 1.447 1.517c0-0.556-0.652-2.15-1.447-3.541s-1.447-2.074-1.447-1.517zM261.464 417.037l-5.020 5.311 5.311-5.020c2.921-2.762 5.311-5.152 5.311-5.311 0-0.754-0.938 0.086-5.602 5.020zM420.399 419.819c0.372 1.391 1.1 3.212 1.614 4.046 0.652 1.055 0.733 0.746 0.263-1.012-0.372-1.391-1.1-3.212-1.614-4.046-0.652-1.055-0.733-0.746-0.263 1.012zM178.747 429.642c-0.309 0.996-1.285 4.072-2.167 6.836-0.885 2.764-1.209 4.585-0.723 4.046 1.151-1.275 4.456-11.692 3.89-12.258-0.238-0.238-0.688 0.379-0.999 1.376zM737.719 441.18c-3.447 2.208-4.565 3.692-1.517 2.016 2.322-1.275 5.958-4.087 5.311-4.107-0.278-0.008-1.985 0.933-3.794 2.092zM431.989 469.388c0 0.835 0.443 2.2 0.981 3.035 0.873 1.348 0.981 1.348 0.981 0 0-0.835-0.443-2.2-0.981-3.035-0.873-1.348-0.981-1.348-0.981 0zM804.854 475.954c-2.716 1.879-5.448 3.968-6.070 4.638-0.62 0.67 1.717-0.68 5.195-3.007 3.477-2.324 6.323-4.436 6.323-4.694 0-0.693-0.094-0.64-5.448 3.063zM433.041 478.179c0.228 2.628 1.811 4.856 1.882 2.65 0.038-1.219-0.384-2.499-0.941-2.843s-0.979-0.258-0.941 0.192zM167.655 479.105c-0.407 0.405-0.726 1.684-0.708 2.845 0.028 1.945 0.111 1.968 1.082 0.298 1.133-1.945 0.842-4.363-0.374-3.144zM232.519 499.484c-0.195 7.094-0.099 18.361 0.215 25.037 0.443 9.431 0.612 6.553 0.759-12.898 0.2-26.537-0.379-33.768-0.974-12.139zM434.098 490.126c0.175 4.125 1.692 7.554 1.791 4.046 0.048-1.669-0.357-3.718-0.895-4.552-0.807-1.249-0.966-1.161-0.895 0.506zM368.298 492.848c-0.038 1.497 0.384 3.004 0.941 3.348 1.209 0.746 1.209-1.237 0-4.046-0.776-1.806-0.878-1.732-0.941 0.698zM166.519 499.314c-0.85 2.208-0.582 24.628 0.329 27.736 0.407 1.391 0.784-4.641 0.835-13.404 0.094-15.948-0.018-17.319-1.163-14.332zM435.13 524.521c-0.089 1.113-0.417 3.161-0.726 4.552-0.486 2.183-0.405 2.284 0.584 0.733 0.63-0.989 0.959-3.037 0.728-4.552-0.273-1.798-0.478-2.051-0.587-0.733zM368.966 533.732c-0.407 0.405-0.726 1.684-0.708 2.845 0.028 1.945 0.111 1.968 1.082 0.298 1.133-1.945 0.842-4.363-0.374-3.144zM167.017 544.946c-0.056 1.775 0.354 3.51 0.91 3.854 1.163 0.718 1.163-0.921 0-4.552-0.774-2.415-0.814-2.385-0.91 0.698zM424.994 582.788c-0.62 1.78-1.095 3.74-1.057 4.352 0.040 0.612 0.723-0.668 1.522-2.845 0.797-2.177 1.272-4.135 1.057-4.35-0.217-0.217-0.9 1.062-1.522 2.843zM420.942 594.94c-0.622 1.788-0.956 3.429-0.738 3.644 0.217 0.217 0.903-1.070 1.528-2.855 0.622-1.788 0.956-3.429 0.738-3.644-0.217-0.217-0.903 1.070-1.528 2.855zM1011.031 613.543c0.003 12.241 0.149 17.109 0.326 10.819s0.177-16.305-0.003-22.255c-0.177-5.951-0.324-0.804-0.324 11.436zM415.449 608.533c-2.377 4.982-2.043 5.829 0.443 1.12 1.128-2.14 1.871-4.067 1.654-4.287-0.22-0.217-1.163 1.206-2.097 3.166zM290.907 621.239c0.306 0.498 4.6 0.903 9.542 0.903s9.236-0.405 9.542-0.903c0.311-0.503-3.887-0.9-9.542-0.9s-9.853 0.397-9.542 0.9zM332.821 684.356c-1.947 0.751-2.858 1.363-2.023 1.363s3.111-0.612 5.058-1.363c1.947-0.751 2.858-1.363 2.023-1.363s-3.111 0.612-5.058 1.363zM267 685.459c2.468 0.774 6.793 1.644 9.61 1.932 3.419 0.352 2.094-0.144-3.981-1.49-10.468-2.319-11.99-2.438-5.63-0.443zM322.705 686.885c-2.084 0.668-2.172 0.824-0.506 0.895 1.113 0.048 2.706-0.357 3.541-0.895 1.773-1.146 0.541-1.146-3.035 0zM283.32 687.96c1.338 0.847 12.933 1.406 11.988 0.579-0.233-0.202-3.351-0.622-6.93-0.933-4.064-0.352-5.963-0.217-5.058 0.354zM311.071 687.897l-6.070 0.673 6.070 0.154c3.338 0.083 6.753-0.288 7.587-0.827 1.725-1.113 2.484-1.113-7.587 0zM1009.825 712.175c0 1.947 0.207 2.744 0.463 1.77 0.253-0.974 0.253-2.567 0-3.541-0.255-0.974-0.463-0.177-0.463 1.77zM993.862 749.858l-3.998 4.299 4.299-3.998c2.365-2.2 4.299-4.135 4.299-4.299 0-0.766-0.88 0-4.6 3.998zM940.56 763.472c1.257 0.243 3.078 0.233 4.046-0.020 0.966-0.253-0.063-0.453-2.289-0.44-2.226 0.010-3.017 0.217-1.758 0.46zM0.438 816.877c0 13.353 0.144 18.677 0.319 11.828s0.175-17.774 0-24.279c-0.177-6.505-0.321-0.903-0.319 12.45zM18.715 902.359c1.113 0.478 2.934 0.855 4.046 0.84 1.626-0.023 1.528-0.19-0.506-0.84-3.46-1.108-6.118-1.108-3.541 0zM229.833 946.316c0.943 1.047 13.042 3.541 12.44 2.564-0.26-0.422-2.585-1.082-5.167-1.469s-5.432-0.969-6.335-1.29c-0.903-0.321-1.325-0.233-0.938 0.195zM476.47 998.267c1.828 1.103 19.233 4.565 19.848 3.95 0.24-0.238-3.561-1.206-8.442-2.152-4.884-0.946-9.787-1.942-10.9-2.215-1.548-0.379-1.667-0.281-0.506 0.417z', 'M594.257 103.185c0 14.188 0.142 19.992 0.316 12.898s0.175-18.702 0-25.796c-0.175-7.094-0.316-1.29-0.316 12.898zM995.933 227.613c2.172 2.226 4.178 4.046 4.456 4.046s-1.272-1.821-3.445-4.046c-2.172-2.226-4.178-4.046-4.456-4.046s1.272 1.821 3.445 4.046zM1010.955 362.157c0 4.729 0.175 6.664 0.387 4.299s0.212-6.234 0-8.599c-0.212-2.365-0.387-0.43-0.387 4.299zM340.914 416.279c1.887 1.947 3.66 3.541 3.938 3.541s-1.039-1.593-2.926-3.541c-1.887-1.947-3.66-3.541-3.938-3.541s1.039 1.593 2.926 3.541zM231.948 492.15c0.008 2.782 0.205 3.801 0.438 2.263 0.233-1.54 0.228-3.816-0.013-5.058-0.24-1.244-0.432 0.013-0.425 2.795zM435.368 509.853c0 5.842 0.167 8.232 0.372 5.311s0.205-7.701 0-10.622c-0.205-2.921-0.372-0.531-0.372 5.311zM369.618 515.417c0.003 6.12 0.167 8.492 0.369 5.273s0.2-8.227-0.005-11.128c-0.202-2.901-0.367-0.266-0.364 5.855zM231.963 531.097c0 3.060 0.19 4.312 0.422 2.782 0.23-1.53 0.23-4.034 0-5.564-0.233-1.53-0.422-0.278-0.422 2.782zM708.888 536.734c-3.923 2.127-3.477 2.863 0.506 0.835 3.814-1.937 4.489-2.441 3.204-2.385-0.511 0.023-2.18 0.721-3.71 1.55zM384.413 654.008c-2.458 2.504-4.241 4.552-3.963 4.552s2.516-2.049 4.975-4.552c2.458-2.504 4.241-4.552 3.963-4.552s-2.516 2.049-4.975 4.552zM1010.965 658.56c0 5.286 0.172 7.448 0.379 4.805s0.207-6.967 0-9.61c-0.207-2.643-0.379-0.481-0.379 4.805zM689.589 764.526c31.81 0.149 84.161 0.149 116.335 0s6.148-0.271-57.836-0.271c-63.985 0-90.309 0.121-58.499 0.271zM0.339 854.813c0 4.173 0.18 5.88 0.397 3.794 0.22-2.086 0.22-5.501 0-7.587-0.217-2.086-0.397-0.379-0.397 3.794z', 'M594.206 140.614c0 6.955 0.162 9.8 0.359 6.323s0.197-9.168 0-12.645c-0.197-3.477-0.359-0.632-0.359 6.323zM385.93 367.215c2.172 2.226 4.178 4.046 4.456 4.046s-1.272-1.821-3.445-4.046c-2.172-2.226-4.178-4.046-4.456-4.046s1.272 1.821 3.445 4.046zM1010.877 374.297c0 2.504 0.197 3.528 0.438 2.276 0.243-1.252 0.243-3.3 0-4.552-0.24-1.252-0.438-0.228-0.438 2.276zM231.991 503.277c0.005 3.895 0.187 5.364 0.407 3.265s0.215-5.286-0.008-7.081c-0.225-1.796-0.405-0.078-0.4 3.816zM167.151 514.911c0 1.947 0.207 2.744 0.463 1.77 0.253-0.974 0.253-2.567 0-3.541-0.255-0.974-0.463-0.177-0.463 1.77zM231.983 519.969c0 3.617 0.185 5.096 0.407 3.288 0.225-1.808 0.225-4.767 0-6.575-0.223-1.808-0.407-0.329-0.407 3.288zM1010.94 642.374c0 4.173 0.18 5.88 0.397 3.794 0.22-2.086 0.22-5.501 0-7.587-0.217-2.086-0.397-0.379-0.397 3.794zM297.667 688.623c1.53 0.23 4.034 0.23 5.564 0 1.53-0.233 0.278-0.422-2.782-0.422s-4.312 0.19-2.782 0.422zM0.255 844.191c0.010 2.226 0.217 3.017 0.46 1.758 0.243-1.257 0.233-3.078-0.020-4.046-0.253-0.966-0.453 0.063-0.44 2.289z'],
  tags: ['outlook']
}, {
  paths: ['M0 0h1024v1024h-1024v-1024zM843.102 406.171h-660.47v344.771h660.47v-344.771zM182.632 406.171l556.336 274.798-167.21-145.055 271.337-129.744h-660.464zM843.102 406.171l-331.102-165.535-329.368 165.535h660.47z'],
  tags: ['win10mail']
}, {
  paths: ['M0 512.248c0.889-73.291 5.646-145.961 22.748-217.411 9.727-38.959 22.748-73.018 39.266-104.977l-1.256 2.672c35.777-71.719 93.392-118.663 166.393-148.67 49.508-20.37 101.002-31.020 153.902-37.224 62.847-7.404 125.86-7.714 188.831-5.377 65.763 2.42 130.864 10.609 194.001 31.186 111.032 36.232 185.17 108.86 221.754 220.037 15.82 48.019 26.036 97.197 28.642 147.45 2.937 56.705 5.191 113.596 3.826 170.322-1.696 70.313-11.126 139.695-34.226 206.802-37.741 109.729-112.355 180.393-222.188 215.57-54.161 17.351-109.77 26.222-166.269 28.725-47.461 2.068-95.129 3.474-142.549 1.758-75.152-2.688-149.228-12.512-220.265-40.078-95.377-36.914-158.617-103.897-193.339-199.316-18.757-51.494-28.952-104.704-33.088-159.093-2.813-37.41-4.177-74.924-6.183-112.376zM510.346 739.234q123.564 0 247.108 0c34.122 0 55.568-21.321 55.588-55.319 0-113.389-0.496-226.758 0.352-340.148 0.227-30.669-22.211-56.229-56.519-56.188q-246.549 0.372-493.14 0c-34.35 0-56.705 25.581-56.478 56.229q1.261 169.578 0 339.155c-0.31 34.95 27.236 57.015 57.057 56.664 82.018-1.034 164.035-0.393 246.032-0.393zM510.139 602.228c3.536-2.75 6.535-4.984 9.409-7.362q67.438-55.547 134.814-111.135c28.704-23.679 57.553-47.213 86.050-71.14 7.296-5.793 11.934-14.662 11.934-24.614 0-4.979-1.161-9.688-3.227-13.869l0.082 0.183c-4.75-10.807-15.361-18.217-27.703-18.217-2.222 0-4.389 0.24-6.474 0.696l0.2-0.037c-7.608 2.030-14.207 5.605-19.728 10.392l0.061-0.052q-88.801 72.629-177.064 145.981c-6.369 5.294-10.237 5.108-16.42-0.124-27.629-23.348-55.712-46.179-83.631-69.196-32.178-26.45-64.212-53.148-96.576-79.329-19.377-15.738-45.931-8.003-52.135 15.055-4.136 15.055 2.068 26.595 13.732 36.211q74.449 60.924 148.422 122.22zM519.548 594.865q67.438-55.547 134.814-111.135c28.704-23.679 57.553-47.213 86.050-71.14 7.296-5.793 11.934-14.662 11.934-24.614 0-4.979-1.161-9.688-3.227-13.869l0.082 0.183c-4.75-10.807-15.361-18.217-27.703-18.217-2.222 0-4.389 0.24-6.474 0.696l0.2-0.037c-7.608 2.030-14.207 5.605-19.728 10.392l0.061-0.052q-88.801 72.629-177.064 145.981c-6.369 5.294-10.237 5.108-16.42-0.124-27.629-23.348-55.712-46.179-83.631-69.196-32.178-26.45-64.212-53.148-96.576-79.329-19.377-15.738-45.931-8.003-52.135 15.055-4.136 15.055 2.068 26.595 13.732 36.211q74.449 60.924 148.422 122.22l78.254 64.336c3.536-2.709 6.535-4.943 9.409-7.321z'],
  tags: ['samsungmail']
}, {
  paths: ['M1019.008 919.736l-486.256-842.204c-4.302-7.461-12.263-12.048-20.867-12.048s-16.568 4.59-20.87 12.048l-487.787 844.836c-4.305 7.461-4.305 16.643 0 24.104 4.302 7.461 12.263 12.048 20.87 12.048h975.564c0.078 0 0.159 0 0.24 0 13.309 0 24.101-10.778 24.101-24.104 0-5.53-1.867-10.608-4.994-14.679zM65.844 910.32l446.042-772.541 446.039 772.541h-892.081z', 'M487.785 381.69v345.676c0 13.317 10.789 24.101 24.101 24.101 13.309 0 24.098-10.778 24.098-24.101v-345.676c0-13.298-10.789-24.098-24.098-24.098-13.312 0.003-24.101 10.803-24.101 24.098z', 'M511.886 779.539c-16.523 0-29.924 13.393-29.924 29.916s13.401 29.935 29.924 29.935c16.52 0 29.924-13.418 29.924-29.935 0-16.523-13.401-29.916-29.924-29.916z'],
  tags: ['error']
}, {
  paths: ["M1097.227,735V525.14c1.004-159.996-106.587-266.116-199.033-308.373\n      c-26.483-12.11-53.783-21.443-81.526-28.373V175c0-64.33-52.337-116.667-116.667-116.667S583.333,110.67,583.333,175v15.423\n      c-24.989,6.743-49.56,15.54-73.406,26.553C407.773,264.063,304.267,377.557,303.333,525v210\n      c0,149.054-52.64,276.943-156.45,380.123c-6.183,6.16-8.423,15.237-5.81,23.566c2.613,8.33,9.684,14.49,18.293,15.984\n      l221.457,38.243c41.253,7.116,79.24,12.95,115.384,17.757c40.717,79.8,120.68,131.017,208.039,131.017\n      c87.384,0,167.371-51.24,208.064-131.087c36.003-4.783,73.803-10.594,114.823-17.687l221.433-38.243\n      c8.61-1.471,15.657-7.654,18.294-15.984c2.637-8.307,0.396-17.406-5.811-23.566C1152.363,1007.066,1097.227,879.177,1097.227,735z\n       M630,175c0-38.593,31.406-70,70-70s70,31.407,70,70v4.247c-46.503-6.673-93.684-6.393-140,1.097V175z M704.27,1295\n      c-59.079,0-114.286-29.354-149.729-77.35c52.15,5.366,100.823,8.073,149.474,8.073c48.836,0,97.673-2.707,150.033-8.144\n      C818.58,1265.623,763.35,1295,704.27,1295z M1019.224,1146.903c-44.776,7.724-85.82,14-124.601,18.946c-0.047,0-0.093,0-0.163,0\n      c-17.104,2.17-33.717,4.061-49.979,5.693c-0.141,0-0.257,0.023-0.396,0.023c-14.91,1.493-29.471,2.707-43.891,3.733\n      c-2.707,0.187-5.413,0.374-8.097,0.537c-12.483,0.816-24.827,1.47-37.1,1.937c-2.497,0.094-5.017,0.233-7.514,0.303\n      c-29.026,0.98-57.656,0.98-86.66,0.023c-2.59-0.093-5.203-0.232-7.793-0.326c-12.063-0.49-24.22-1.097-36.517-1.913\n      c-2.917-0.187-5.834-0.374-8.773-0.584c-13.977-1.003-28.117-2.17-42.561-3.616c-0.536-0.047-1.05-0.094-1.586-0.141\n      c-16.146-1.609-32.62-3.5-49.561-5.646c-0.07,0-0.14,0-0.21,0c-38.92-4.923-80.127-11.246-125.09-18.993L210,1116.033\n      c92.937-106.26,140-234.22,140-381.033V525.14c0.793-126.816,90.72-224.863,179.457-265.79\n      c26.39-12.157,53.76-21.233,81.597-27.604c0.233-0.046,0.489-0.023,0.723-0.07c57.517-12.927,118.697-13.51,176.867-1.587\n      c0.304,0.07,0.606-0.07,0.91-0.023c30.427,6.347,60.387,15.96,89.25,29.144c86.076,39.363,172.573,136.757,171.757,265.813v210\n      c0,140.77,50.75,271.67,147.303,381.057L1019.224,1146.903z", "M849.73,322.887c-90.417-41.323-201.134-41.37-290.943,0.047C507.57,346.547,420.7,415.637,420,524.86\n      c-0.07,12.88,10.29,23.38,23.193,23.473c0.047,0,0.094,0,0.14,0c12.811,0,23.264-10.336,23.334-23.193\n      c0.536-85.796,70.443-140.816,111.649-159.833c77.7-35.863,173.74-35.77,251.977,0c11.737,5.367,25.574,0.21,30.94-11.503\n      C866.6,342.066,861.42,328.23,849.73,322.887z", "M112.047,531.837c-9.124-9.124-23.87-9.124-32.994,0C28.07,582.82,0,650.674,0,722.937\n      c0,72.264,28.07,140.14,79.053,191.101c4.55,4.55,10.523,6.836,16.497,6.836c5.974,0,11.947-2.286,16.497-6.836\n      c9.123-9.124,9.123-23.87,0-32.994c-42.164-42.163-65.38-98.303-65.38-158.106c0-59.803,23.217-115.967,65.38-158.106\n      C121.146,555.707,121.146,540.96,112.047,531.837z", "M193.783,867.767c5.974,0,11.947-2.286,16.497-6.837c9.123-9.123,9.123-23.869,0-32.993\n      c-59.687-59.687-59.687-156.776,0-216.44c9.123-9.123,9.123-23.869,0-32.993c-9.124-9.123-23.87-9.123-32.994,0\n      c-77.863,77.863-77.863,204.587,0,282.427C181.837,865.503,187.81,867.767,193.783,867.767z", "M1320.946,531.837c-9.123-9.124-23.87-9.124-32.993,0c-9.123,9.123-9.123,23.87,0,32.993\n      c42.164,42.163,65.38,98.304,65.38,158.106c0,59.804-23.216,115.943-65.38,158.106c-9.123,9.124-9.123,23.87,0,32.994\n      c4.55,4.55,10.523,6.836,16.497,6.836s11.946-2.286,16.496-6.836C1371.93,863.076,1400,795.2,1400,722.937\n      C1400,650.674,1371.93,582.82,1320.946,531.837z", "M1189.72,578.503c-9.123,9.124-9.123,23.87,0,32.994c59.687,59.687,59.687,156.776,0,216.439\n      c-9.123,9.123-9.123,23.87,0,32.993c4.55,4.551,10.523,6.837,16.497,6.837s11.946-2.286,16.496-6.837\n      c77.863-77.863,77.863-204.586,0-282.427C1213.59,569.38,1198.82,569.38,1189.72,578.503z"],
  tags: ['alarm']
}];

function ownKeys$D(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$D(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$D(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$D(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var SVG = styled.svg.withConfig({
  displayName: "Icon__SVG",
  componentId: "sc-1vv574n-0"
})(["", ""], space$5);
var propTypes$C = {
  name: PropTypes.string.isRequired
};

function Icon(props) {
  var name = props.name;
  var selected = icons.find(function (icon) {
    return icon.tags[0] === name;
  });

  if (!selected) {
    return /*#__PURE__*/jsxs("div", {
      children: ["Invalid icon name: ", name]
    });
  }

  return /*#__PURE__*/jsx$1(SVG, _objectSpread$D(_objectSpread$D({
    viewBox: "0 0 1024 1024"
  }, props), {}, {
    children: /*#__PURE__*/jsx$1("path", {
      d: selected.paths.join('')
    })
  }));
}

Icon.propTypes = propTypes$C;
var propTypes$B = {
  onSelect: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
var IconWrapper = styled.div.withConfig({
  displayName: "selection__IconWrapper",
  componentId: "sc-wvg2bh-0"
})(["margin:0 3rem;padding:3rem 3rem 0 3rem;cursor:pointer;display:flex;flex-direction:column;align-items:center;"]);
var IconTitle = styled.span.withConfig({
  displayName: "selection__IconTitle",
  componentId: "sc-wvg2bh-1"
})(["padding-top:1.4rem;text-align:center;"]);
var SelectorWrapper = styled(Selector).withConfig({
  displayName: "selection__SelectorWrapper",
  componentId: "sc-wvg2bh-2"
})(["margin:2rem 0;"]);

function Selection(_ref) {
  var onSelect = _ref.onSelect,
      options = _ref.options;

  var _useState = useState(),
      _useState2 = _slicedToArray$4(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var handleChange = function handleChange(item) {
    setSelected(item);
    onSelect(options.find(function (o) {
      return o.name === item;
    }));
  };

  var opts = options.map(function (opt) {
    var content = /*#__PURE__*/jsxs(IconWrapper, {
      children: [/*#__PURE__*/jsx$1(Icon, {
        height: 80,
        name: opt.icon,
        width: 80
      }), /*#__PURE__*/jsx$1(IconTitle, {
        children: opt.name
      })]
    }, opt.name);
    return {
      id: opt.name,
      content: content
    };
  });
  return /*#__PURE__*/jsx$1(SelectorWrapper, {
    onChange: handleChange,
    options: opts,
    selected: selected,
    withRadio: true
  });
}

Selection.propTypes = propTypes$B;

function ownKeys$C(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$C(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$C(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$C(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var Content = styled.div.withConfig({
  displayName: "email-setup__Content",
  componentId: "sc-1edctw-0"
})(["width:100%;img{border-radius:7px;width:40rem;box-shadow:0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);@media (max-width:768px){width:90%;}}h1{font-size:2.5rem;text-align:center;}h2{font-size:2rem;font-weight:800;}strong{font-weight:800;}ul{padding-left:2rem;}li{list-style-type:disc;}"]);
var stackCss = css$3(["min-height:100vh;width:60%;padding-top:4rem;padding-bottom:4rem;@media (max-width:768px){width:100%;padding:4rem;}"]);
var linkCss = css$3(["display:block;margin-top:2rem;&,&:link,&:visited{text-decoration:underline;}&:hover,&:focus{text-decoration:underline;}"]);
var boxCss = css$3(["     border:1px solid rgb(215,215,215);border-radius:2px;padding:4rem;margin-top:2rem;}"]);
var Separator = styled.hr.withConfig({
  displayName: "email-setup__Separator",
  componentId: "sc-1edctw-1"
})([""]);
var DescList = styled.dl.withConfig({
  displayName: "email-setup__DescList",
  componentId: "sc-1edctw-2"
})(["width:50rem;@media (max-width:768px){width:100%;}"]);
var DescTerm = styled.dt.withConfig({
  displayName: "email-setup__DescTerm",
  componentId: "sc-1edctw-3"
})(["font-weight:700;width:90%;"]);
var DescDetails = styled.dd.withConfig({
  displayName: "email-setup__DescDetails",
  componentId: "sc-1edctw-4"
})(["margin-left:0;flex:1;"]);

function EmailSetup(_ref) {
  var _settings$error;

  var strings = _ref.strings;

  var _useState = useState(''),
      _useState2 = _slicedToArray$4(_useState, 2),
      emailAddress = _useState2[0],
      setEmailAddress = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray$4(_useState3, 2),
      system = _useState4[0],
      setSystem = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray$4(_useState5, 2),
      device = _useState6[0],
      setDevice = _useState6[1];

  var _useState7 = useState(1),
      _useState8 = _slicedToArray$4(_useState7, 2),
      currentStep = _useState8[0],
      setStep = _useState8[1];

  var _useState9 = useState(),
      _useState0 = _slicedToArray$4(_useState9, 2),
      emailClient = _useState0[0],
      setEmailClient = _useState0[1];

  var _useState1 = useState(),
      _useState10 = _slicedToArray$4(_useState1, 2),
      showFeedbackForm = _useState10[0],
      setShowFeedbackForm = _useState10[1];

  var _useState11 = useState(),
      _useState12 = _slicedToArray$4(_useState11, 2),
      missingFeedback = _useState12[0],
      setMissingFeedback = _useState12[1];

  var _useState13 = useState(),
      _useState14 = _slicedToArray$4(_useState13, 2),
      recaptchaResp = _useState14[0],
      setRecaptchaResp = _useState14[1];

  var recaptchaRef = useRef(null);

  var _useState15 = useState(),
      _useState16 = _slicedToArray$4(_useState15, 2),
      showMissingFeedbackFormSuccess = _useState16[0],
      setShowMissingFeedbackFormSuccess = _useState16[1];

  var _useState17 = useState(),
      _useState18 = _slicedToArray$4(_useState17, 2),
      showHelpfulFeedbackFormSuccess = _useState18[0],
      setShowHelpfulFeedbackFormSuccess = _useState18[1];

  var _useEmailSetupService = useEmailSetupService(),
      content = _useEmailSetupService.content,
      settings = _useEmailSetupService.settings,
      loading = _useEmailSetupService.loading,
      setLoading = _useEmailSetupService.setLoading,
      getSettings = _useEmailSetupService.getSettings,
      getContent = _useEmailSetupService.getContent,
      setContentEmpty = _useEmailSetupService.setContentEmpty;

  var handleSubmit = function handleSubmit() {
    setLoading(true);
    setStep(2);
    recaptchaRef.current.execute();
  };

  var handleChange = function handleChange(event) {
    setEmailAddress(event.target.value);
  };

  useEffect(function () {
    var email = window.location.search.replace('?', '');

    if (email && email !== '') {
      setEmailAddress(email);
    }
  }, []);
  useEffect(function () {
    if (emailAddress && emailAddress !== '') {
      var newurl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?").concat(emailAddress);
      window.history.pushState({
        path: newurl
      }, '', newurl);
    }
  }, [emailAddress]);
  useEffect(function () {
    tracker$1('Email Setup Assistant', _objectSpread$C({
      type: 'GET_SETTINGS'
    }, settings));
  }, [settings]);
  useEffect(function () {
    if (recaptchaResp && emailAddress) {
      setStep(2);
      getSettings(emailAddress, recaptchaResp);
      recaptchaRef.current.reset();
    }
  }, [recaptchaResp]);

  var resolveRecaptcha = function resolveRecaptcha(response) {
    setRecaptchaResp(response);
  };

  var handleDevicePicker = function handleDevicePicker(value) {
    var currentDeviceOpt = options["".concat(system.name.toLowerCase(), "Opts")];
    var pickedDevice = currentDeviceOpt.find(function (opt) {
      return opt.name === value.name;
    });
    setStep(3);
    setContentEmpty();
    setDevice(pickedDevice);
  };

  var handleSystemSelect = function handleSystemSelect(value) {
    if (device && system !== value) {
      setDevice();
    }

    setContentEmpty();
    setEmailClient();
    setSystem(value);
  };

  var handleEmailClientSelect = function handleEmailClientSelect(value) {
    setContentEmpty();
    setEmailClient(value);
  };

  var getEmailInstructions = function getEmailInstructions() {
    tracker$1('Email Setup Assistant', {
      type: 'GET_CONTENT',
      feedback: emailClient.doc
    });
    getContent(emailClient.doc);
  };

  var sendMissingFeedback = function sendMissingFeedback() {
    tracker$1('Email Setup Assistant', {
      type: 'FEEDBACK_MISSING',
      feedback: missingFeedback
    });
    setShowMissingFeedbackFormSuccess(true);
  };

  var sendHelpfulFeedback = function sendHelpfulFeedback(type) {
    tracker$1('Email Setup Assistant', {
      type: 'FEEDBACK_HELPFUL',
      feedback: type
    });
    setShowHelpfulFeedbackFormSuccess(true);
  };

  var deviceOptsForDropdown = function deviceOptsForDropdown() {
    if (!system) {
      return null;
    }

    return options["".concat(system.name.toLowerCase(), "Opts")];
  };

  var showStepTwo = currentStep > 1;
  var showStepThree = currentStep > 2 && device;
  return /*#__PURE__*/jsx$1(_StyledStack$d, {
    alignItems: "center",
    alignSelf: "center",
    flexDirection: "column",
    justifyContent: "flex-start",
    children: /*#__PURE__*/jsxs(Box$1, {
      flexDirection: "column",
      children: [/*#__PURE__*/jsxs(Box$1, {
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        children: [/*#__PURE__*/jsx$1(Heading, {
          as: "h1",
          variant: "exaBold",
          children: strings.assistanceHeader
        }), /*#__PURE__*/jsx$1(Heading, {
          variant: "gigaBold",
          children: strings.headerHelp
        })]
      }), /*#__PURE__*/jsxs(_StyledBox$c, {
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        children: [/*#__PURE__*/jsx$1(Heading, {
          variant: "teraBold",
          children: strings.stepOne
        }), /*#__PURE__*/jsx$1(Input$5, {
          id: "emailAddress",
          label: "".concat(strings.emailAddress),
          name: "emailAddress",
          onChange: handleChange,
          value: emailAddress
        }, 'emailAddress'), /*#__PURE__*/jsx$1(Button$1, {
          alignSelf: "stretch",
          id: "submitBtn",
          mt: 3,
          onClick: handleSubmit,
          type: "submit",
          children: "Submit"
        })]
      }), /*#__PURE__*/jsx$1(Recaptcha, {
        ref: recaptchaRef,
        onLoaded: function onLoaded() {
          if (emailAddress) {
            recaptchaRef.current.execute();
          }
        },
        onResolved: resolveRecaptcha,
        sitekey: "6LfQpx0UAAAAAFeKSO7GEcLUpyLbtH8NLLs6C64n"
      }), loading && /*#__PURE__*/jsx$1(Box$1, {
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        mt: 3,
        children: /*#__PURE__*/jsx$1(Spinner$1, {})
      }), settings && settings.success === false && ((_settings$error = settings.error) === null || _settings$error === void 0 ? void 0 : _settings$error.message) && /*#__PURE__*/jsx$1(_StyledBox2$4, {
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/jsxs(Text$1, {
          children: [strings[settings.error.message] ? strings[settings.error.message] : settings.error.message, ' ']
        })
      }), settings && settings.success !== false && emailAddress && (settings.platform === 'Outlook' || settings.platform === 'Google') && /*#__PURE__*/jsxs(_StyledBox3$1, {
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        children: [/*#__PURE__*/jsx$1(Heading, {
          variant: "gigaBold",
          children: "For more information on how to set up your ".concat(settings.platform === 'Google' ? 'Google ' : 'Microsoft ', " email, please click the link below:")
        }), /*#__PURE__*/jsx$1(_StyledLink$6, {
          href: settings.Link,
          newTab: true,
          children: settings.Link
        })]
      }), settings && settings.success !== false && emailAddress && !(settings.platform === 'Outlook' || settings.platform === 'Google') && /*#__PURE__*/jsxs(_StyledBox4, {
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        children: [/*#__PURE__*/jsx$1(Heading, {
          variant: "gigaBold",
          children: strings.headerSettings
        }), /*#__PURE__*/jsxs(DescList, {
          children: [/*#__PURE__*/jsx$1(DescTerm, {
            children: "Mail server username"
          }), /*#__PURE__*/jsx$1(DescDetails, {
            children: settings.Username
          }), /*#__PURE__*/jsx$1(Separator, {}), /*#__PURE__*/jsx$1(DescTerm, {
            children: "Incoming mail server"
          }), /*#__PURE__*/jsx$1(DescDetails, {
            children: settings.IncomingServer
          }), /*#__PURE__*/jsx$1(Separator, {}), /*#__PURE__*/jsx$1(DescTerm, {
            children: "Outgoing mail server"
          }), /*#__PURE__*/jsx$1(DescDetails, {
            children: settings.OutgoingServer
          }), /*#__PURE__*/jsx$1(Separator, {}), /*#__PURE__*/jsx$1(DescTerm, {
            children: "Supported incoming mail protocols"
          }), /*#__PURE__*/jsx$1(DescDetails, {
            children: settings.IncomingProtocols
          }), /*#__PURE__*/jsx$1(Separator, {}), /*#__PURE__*/jsx$1(DescTerm, {
            children: "Supported outgoing mail protocols"
          }), /*#__PURE__*/jsx$1(DescDetails, {
            children: settings.OutgoingProtocols
          }), /*#__PURE__*/jsx$1(Separator, {}), /*#__PURE__*/jsx$1(DescTerm, {
            children: "Incoming Encryption"
          }), /*#__PURE__*/jsx$1(DescDetails, {
            children: settings.IncomingEncryption
          }), /*#__PURE__*/jsx$1(Separator, {}), /*#__PURE__*/jsx$1(DescTerm, {
            children: "Outgoing Encryption"
          }), /*#__PURE__*/jsx$1(DescDetails, {
            children: settings.OutgoingEncryption
          }), /*#__PURE__*/jsx$1(Separator, {}), /*#__PURE__*/jsx$1(DescTerm, {
            children: "Webmail"
          }), /*#__PURE__*/jsx$1(DescDetails, {
            children: settings.WebmailList
          })]
        })]
      }), /*#__PURE__*/jsxs(_StyledBox5, {
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        children: [/*#__PURE__*/jsx$1(Heading, {
          variant: "teraBold",
          children: strings.stepTwo
        }), showStepTwo && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx$1(Selection, {
            onSelect: handleSystemSelect,
            options: options.systemOpts
          }), deviceOptsForDropdown() && /*#__PURE__*/jsx$1(Selection, {
            onSelect: handleDevicePicker,
            options: deviceOptsForDropdown()
          })]
        })]
      }), /*#__PURE__*/jsxs(_StyledBox6, {
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        children: [/*#__PURE__*/jsx$1(Heading, {
          variant: "teraBold",
          children: strings.stepThree
        }), showStepThree && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx$1(Selection, {
            onSelect: handleEmailClientSelect,
            options: device.emailClients
          }), /*#__PURE__*/jsx$1(Button$1, {
            alignSelf: "stretch",
            disabled: !emailClient,
            id: "continue",
            mt: 4,
            onClick: getEmailInstructions,
            children: strings.viewSetupInstructions
          }), /*#__PURE__*/jsx$1(Button$1, {
            alignSelf: "stretch",
            id: "showFeedbackForm",
            minimal: true,
            mt: 4,
            onClick: function onClick() {
              return setShowFeedbackForm(true);
            },
            children: strings.dontSeeYourDevice
          }), showFeedbackForm && /*#__PURE__*/jsxs(Box$1, {
            alignItems: "center",
            alignSelf: "stretch",
            flexDirection: "column",
            justifyContent: "center",
            p: 2,
            children: [/*#__PURE__*/jsx$1(Input$5, {
              alignSelf: "stretch",
              id: "missingFeedback",
              onChange: function onChange(e) {
                setMissingFeedback(e.target.value);
              },
              value: missingFeedback
            }), /*#__PURE__*/jsx$1(Button$1, {
              alignSelf: "stretch",
              id: "sendFeedback",
              onClick: function onClick() {
                return sendMissingFeedback();
              },
              children: "Submit"
            }), showMissingFeedbackFormSuccess && /*#__PURE__*/jsx$1(Text$1, {
              children: "Thank you!"
            })]
          })]
        })]
      }), content && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsxs(_StyledBox7, {
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
          children: [/*#__PURE__*/jsx$1(Heading, {
            variant: "petaBold",
            children: strings.emailSetup
          }), /*#__PURE__*/jsx$1(Content, {
            children: /*#__PURE__*/jsx$1("div", {
              dangerouslySetInnerHTML: {
                __html: content
              }
            })
          })]
        }), /*#__PURE__*/jsxs(_StyledBox8, {
          children: [/*#__PURE__*/jsx$1(Text$1, {
            mr: 3,
            children: "Was this article helpful?"
          }), /*#__PURE__*/jsx$1(Button$1, {
            id: "sendFeedback",
            mr: 3,
            onClick: function onClick() {
              return sendHelpfulFeedback('Yes');
            },
            children: "Yes"
          }), /*#__PURE__*/jsx$1(Button$1, {
            id: "sendFeedback",
            mr: 3,
            onClick: function onClick() {
              return sendHelpfulFeedback('No');
            },
            children: "No"
          }), showHelpfulFeedbackFormSuccess && /*#__PURE__*/jsx$1(Text$1, {
            children: "Thank you!"
          })]
        })]
      })]
    })
  });
}

var propTypes$A = {
  strings: PropTypes.shape({
    assistanceHeader: PropTypes.string.isRequired,
    captchaIsntSet: PropTypes.string.isRequired,
    "continue": PropTypes.string.isRequired,
    dontSeeYourDevice: PropTypes.string.isRequired,
    emailAddress: PropTypes.string.isRequired,
    emailSetup: PropTypes.string.isRequired,
    headerHelp: PropTypes.string.isRequired,
    headerSettings: PropTypes.string.isRequired,
    pleaseProvideValidEmailAddress: PropTypes.string.isRequired,
    stepOne: PropTypes.string.isRequired,
    stepThree: PropTypes.string.isRequired,
    stepTwo: PropTypes.string.isRequired,
    viewSetupInstructions: PropTypes.string.isRequired,
    whichDevice: PropTypes.string.isRequired
  }).isRequired
};
EmailSetup.propTypes = propTypes$A;

function EmailSetupContainer(_ref2) {
  var strings = _ref2.strings;
  return /*#__PURE__*/jsx$1(EmailSetupProvider, {
    children: /*#__PURE__*/jsx$1(EmailSetup, {
      strings: strings
    })
  });
}

EmailSetupContainer.propTypes = propTypes$A;

var _StyledStack$d = styled(Stack$2).withConfig({
  displayName: "email-setup___StyledStack",
  componentId: "sc-1edctw-5"
})(["", ""], stackCss);

var _StyledBox$c = styled(Box$1).withConfig({
  displayName: "email-setup___StyledBox",
  componentId: "sc-1edctw-6"
})(["", ""], boxCss);

var _StyledBox2$4 = styled(Box$1).withConfig({
  displayName: "email-setup___StyledBox2",
  componentId: "sc-1edctw-7"
})(["", ""], boxCss);

var _StyledBox3$1 = styled(Box$1).withConfig({
  displayName: "email-setup___StyledBox3",
  componentId: "sc-1edctw-8"
})(["", ""], boxCss);

var _StyledLink$6 = styled(Link$1).withConfig({
  displayName: "email-setup___StyledLink",
  componentId: "sc-1edctw-9"
})(["", ""], linkCss);

var _StyledBox4 = styled(Box$1).withConfig({
  displayName: "email-setup___StyledBox4",
  componentId: "sc-1edctw-10"
})(["", ""], boxCss);

var _StyledBox5 = styled(Box$1).withConfig({
  displayName: "email-setup___StyledBox5",
  componentId: "sc-1edctw-11"
})(["", ""], boxCss);

var _StyledBox6 = styled(Box$1).withConfig({
  displayName: "email-setup___StyledBox6",
  componentId: "sc-1edctw-12"
})(["", ""], boxCss);

var _StyledBox7 = styled(Box$1).withConfig({
  displayName: "email-setup___StyledBox7",
  componentId: "sc-1edctw-13"
})(["", ""], boxCss);

var _StyledBox8 = styled(Box$1).withConfig({
  displayName: "email-setup___StyledBox8",
  componentId: "sc-1edctw-14"
})(["", ""], boxCss);

function _regenerator$E() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$E(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$E(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$E(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$E(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$E(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$E(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$E(u), _regeneratorDefine2$E(u, o, "Generator"), _regeneratorDefine2$E(u, n, function () {
    return this;
  }), _regeneratorDefine2$E(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$E = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$E(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$E = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$E(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$E(e, r, n, t);
} // SERVICES


var addGWSeats = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$E().m(function _callee(ctx, evt) {
    var _evt$payload, seatsToAdd, subscriptionId;

    return _regenerator$E().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            _evt$payload = evt.payload, seatsToAdd = _evt$payload.seatsToAdd, subscriptionId = _evt$payload.subscriptionId;
            return _context.a(2, post$1("".concat(googleWorkspaceEndpoint, "/subscriptions/").concat(subscriptionId, "/edit-seats"), {
              seatsToAdd: seatsToAdd
            }));
        }
      }
    }, _callee);
  }));

  return function addGWSeats(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}(); // EVENTS


var events$5 = {
  ADD: 'add',
  RETRY: 'retry',
  RESET: 'reset'
}; // ADD GW SEATS MACHINE

var machineOpts$6 = {
  services: {
    addGWSeats: addGWSeats
  },
  actions: {
    cacheError: assign$2({
      error: function error(ctx, evt) {
        var _evt$data, _evt$data$response;

        var error = (evt === null || evt === void 0 ? void 0 : (_evt$data = evt.data) === null || _evt$data === void 0 ? void 0 : (_evt$data$response = _evt$data.response) === null || _evt$data$response === void 0 ? void 0 : _evt$data$response.data) || (evt === null || evt === void 0 ? void 0 : evt.data); // backend returns either message or card prop

        tracker$1('Client Error', {
          type: 'add-gw-seats-machine-error',
          location: 'add-gw-seats.machine',
          error: error
        });
        var message = error === null || error === void 0 ? void 0 : error.message;

        if (!message) {
          message = error === null || error === void 0 ? void 0 : error.card;
        }

        return {
          message: message
        };
      }
    }),
    onSuccess: function onSuccess() {// Placeholder - overridden when used by component
    }
  },
  guards: {
    maxRetriesReached: function maxRetriesReached(ctx) {
      return ctx.retries >= 2;
    }
  }
};
var addGWSeatsMachine = Machine({
  id: 'add',
  initial: 'idle',
  context: {
    retries: 0,
    error: null
  },
  states: {
    idle: {
      on: _defineProperty$6({}, events$5.ADD, 'loading')
    },
    loading: {
      invoke: {
        id: 'add-gw-seats',
        src: 'addGWSeats',
        onDone: {
          target: 'success',
          actions: 'onSuccess'
        },
        onError: {
          target: 'failure',
          actions: 'cacheError'
        }
      }
    },
    success: {
      on: _defineProperty$6({}, events$5.RESET, [{
        target: 'idle',
        actions: assign$2({
          retries: 0,
          error: null
        })
      }]) // after: {
      //   500: {
      //     target: 'idle',
      //   },
      // },

    },
    failure: {
      on: _defineProperty$6(_defineProperty$6({}, events$5.RETRY, [{
        cond: 'maxRetriesReached',
        target: 'maxAddRetries'
      }, {
        target: 'loading',
        actions: assign$2({
          retries: function retries(context) {
            return context.retries + 1;
          }
        })
      }]), events$5.RESET, [{
        target: 'idle',
        actions: assign$2({
          retries: 0,
          error: null
        })
      }])
    },
    maxAddRetries: {
      on: _defineProperty$6({}, events$5.RESET, [{
        target: 'idle',
        actions: assign$2({
          retries: 0,
          error: null
        })
      }]) // after: {
      //   500: {
      //     target: 'idle',
      //   },
      // },

    }
  }
}, machineOpts$6); // SERVICES

var cancelGWSubscription = function cancelGWSubscription(ctx, evt) {
  var subscriptionId = evt.payload.subscriptionId;
  return post$1("".concat(googleWorkspaceEndpoint, "/subscriptions/").concat(subscriptionId, "/cancel"));
}; // EVENTS


var events$4 = {
  CANCEL_SUBSCRIPTION: 'cancel_subscription',
  RETRY: 'retry',
  RESET: 'reset'
}; // CANCEL GW SUBSCRIPTION MACHINE

var machineOpts$5 = {
  services: {
    cancelGWSubscription: cancelGWSubscription
  },
  actions: {
    cacheError: assign$2({
      error: function error(ctx, evt) {
        var _evt$data, _evt$data$response;

        var error = evt === null || evt === void 0 ? void 0 : (_evt$data = evt.data) === null || _evt$data === void 0 ? void 0 : (_evt$data$response = _evt$data.response) === null || _evt$data$response === void 0 ? void 0 : _evt$data$response.data;
        tracker$1('Client Error', {
          type: 'cancel-subscription-machine-error',
          location: 'cancel-gw.machine',
          error: error
        });
        return error;
      }
    }),
    reset: assign$2({
      retries: function retries() {
        return 0;
      },
      error: function error() {
        return null;
      }
    }),
    onSuccess: function onSuccess() {// Placeholder - overridden when used by component
    }
  },
  guards: {
    maxRetriesReached: function maxRetriesReached(ctx) {
      return ctx.retries >= 3;
    }
  }
};
var cancelSubscriptionMachine = Machine({
  id: 'cancel-gw',
  initial: 'idle',
  context: {
    retries: 0,
    error: null
  },
  states: {
    idle: {
      on: _defineProperty$6({}, events$4.CANCEL_SUBSCRIPTION, 'loading')
    },
    loading: {
      invoke: {
        id: 'cancel-gw-sub',
        src: 'cancelGWSubscription',
        onDone: {
          target: 'success',
          actions: 'onSuccess'
        },
        onError: {
          target: 'failure',
          actions: 'cacheError'
        }
      }
    },
    success: {
      after: {
        500: {
          target: 'idle'
        }
      }
    },
    failure: {
      on: _defineProperty$6(_defineProperty$6({}, events$4.RETRY, [{
        cond: 'maxRetriesReached',
        target: 'maxCancelRetries'
      }, {
        target: 'loading',
        actions: assign$2({
          retries: function retries(context) {
            return context.retries + 1;
          }
        })
      }]), events$4.RESET, {
        target: 'idle',
        actions: 'reset'
      })
    },
    maxCancelRetries: {
      on: _defineProperty$6({}, events$4.RESET, {
        target: 'idle',
        actions: 'reset'
      })
    }
  }
}, machineOpts$5);

function _regenerator$D() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$D(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$D(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$D(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$D(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$D(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$D(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$D(u), _regeneratorDefine2$D(u, o, "Generator"), _regeneratorDefine2$D(u, n, function () {
    return this;
  }), _regeneratorDefine2$D(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$D = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$D(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$D = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$D(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$D(e, r, n, t);
} // SERVICES


var getDomains = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$D().m(function _callee() {
    return _regenerator$D().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            return _context.a(2, get$3(buildSkywalkerEndpoint(SKYWALKER_ENDPOINTS.domains)));
        }
      }
    }, _callee);
  }));

  return function getDomains() {
    return _ref.apply(this, arguments);
  };
}(); // EVENTS


var events$3 = {
  GET: 'get',
  RETRY: 'retry'
}; // DOMAINS MACHINE

var machineOpts$4 = {
  services: {
    getDomains: getDomains
  },
  actions: {
    cacheError: assign$2({
      error: function error(ctx, evt) {
        var _evt$data, _evt$data$response;

        var error = (evt === null || evt === void 0 ? void 0 : (_evt$data = evt.data) === null || _evt$data === void 0 ? void 0 : (_evt$data$response = _evt$data.response) === null || _evt$data$response === void 0 ? void 0 : _evt$data$response.data) || (evt === null || evt === void 0 ? void 0 : evt.data); // backend returns either message or card prop

        tracker$1('Client Error', {
          type: 'domains-machine-error',
          location: 'domains.machine',
          error: error
        });
        var message = error === null || error === void 0 ? void 0 : error.message;

        if (!message) {
          message = error === null || error === void 0 ? void 0 : error.card;
        }

        return {
          message: message
        };
      }
    }),
    cacheDomains: assign$2({
      domains: function domains(ctx, evt) {
        var _evt$data2, _evt$data2$data;

        return evt === null || evt === void 0 ? void 0 : (_evt$data2 = evt.data) === null || _evt$data2 === void 0 ? void 0 : (_evt$data2$data = _evt$data2.data) === null || _evt$data2$data === void 0 ? void 0 : _evt$data2$data.domains;
      }
    }),
    onSuccess: function onSuccess() {// Placeholder - overridden when used by component
    }
  },
  guards: {
    maxRetriesReached: function maxRetriesReached(ctx) {
      return ctx.retries >= 2;
    }
  }
};
var domainsMachine = Machine({
  id: 'gw-domains',
  initial: 'idle',
  context: {
    retries: 0,
    domains: [],
    error: null
  },
  states: {
    idle: {
      on: _defineProperty$6({}, events$3.GET, 'loading')
    },
    loading: {
      invoke: {
        id: 'get-domains',
        src: 'getDomains',
        onDone: {
          target: 'success',
          actions: ['cacheDomains', 'onSuccess']
        },
        onError: {
          target: 'failure',
          actions: 'cacheError'
        }
      }
    },
    success: {
      target: 'idle'
    },
    failure: {
      on: _defineProperty$6({}, events$3.RETRY, [{
        cond: 'maxRetriesReached',
        target: 'maxAddRetries'
      }, {
        target: 'loading',
        actions: assign$2({
          retries: function retries(context) {
            return context.retries + 1;
          }
        })
      }])
    },
    maxAddRetries: {
      after: {
        500: {
          target: 'idle'
        }
      }
    }
  }
}, machineOpts$4); // SERVICES

var getLoginUrl = function getLoginUrl(ctx, evt) {
  var subscriptionId = evt.payload.subscriptionId;
  return get$3("".concat(googleWorkspaceEndpoint, "/subscriptions/").concat(subscriptionId, "/loginUrl"));
}; // EVENTS


var events$2 = {
  GET_LOGIN_URL: 'get_login_url',
  RETRY: 'retry'
}; // CANCEL GW SUBSCRIPTION MACHINE

var machineOpts$3 = {
  services: {
    getLoginUrl: getLoginUrl
  },
  actions: {
    cacheError: assign$2({
      error: function error(ctx, evt) {
        var _evt$data, _evt$data$response;

        var error = (evt === null || evt === void 0 ? void 0 : (_evt$data = evt.data) === null || _evt$data === void 0 ? void 0 : (_evt$data$response = _evt$data.response) === null || _evt$data$response === void 0 ? void 0 : _evt$data$response.data) || (evt === null || evt === void 0 ? void 0 : evt.data);
        tracker('Client Error', {
          type: 'subscriptions-machine-error',
          location: 'subscriptions.machine',
          error: error
        });
        var message = (error === null || error === void 0 ? void 0 : error.message) || 'There was an error with the request';
        return {
          message: message
        };
      }
    }),
    cacheLoginUrl: assign$2({
      loginUrl: function loginUrl(ctx, evt) {
        var _evt$data2, _evt$data2$data;

        return evt === null || evt === void 0 ? void 0 : (_evt$data2 = evt.data) === null || _evt$data2 === void 0 ? void 0 : (_evt$data2$data = _evt$data2.data) === null || _evt$data2$data === void 0 ? void 0 : _evt$data2$data.loginUrl;
      }
    }),
    onSuccess: function onSuccess() {// Placeholder - overridden when used by component
    }
  },
  guards: {
    maxRetriesReached: function maxRetriesReached(ctx) {
      return ctx.retries >= 3;
    }
  }
};
var loginUrlMachine = Machine({
  id: 'login-url',
  initial: 'idle',
  context: {
    retries: 0,
    error: null,
    loginUrl: null
  },
  states: {
    idle: {
      on: _defineProperty$6({}, events$2.GET_LOGIN_URL, 'loading')
    },
    loading: {
      invoke: {
        id: 'login-url-sub',
        src: 'getLoginUrl',
        onDone: {
          target: 'success',
          actions: ['cacheLoginUrl', 'onSuccess']
        },
        onError: {
          target: 'failure',
          actions: 'cacheError'
        }
      }
    },
    success: {
      after: {
        500: {
          target: 'idle'
        }
      }
    },
    failure: {
      on: _defineProperty$6({}, events$2.RETRY, [{
        cond: 'maxRetriesReached',
        target: 'maxRetries'
      }, {
        target: 'loading',
        actions: assign$2({
          retries: function retries(context) {
            return context.retries + 1;
          }
        })
      }])
    },
    maxRetries: {
      after: {
        500: {
          target: 'idle'
        }
      }
    }
  }
}, machineOpts$3);

function _regenerator$C() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$C(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$C(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$C(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$C(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$C(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$C(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$C(u), _regeneratorDefine2$C(u, o, "Generator"), _regeneratorDefine2$C(u, n, function () {
    return this;
  }), _regeneratorDefine2$C(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$C = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$C(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$C = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$C(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$C(e, r, n, t);
} // SERVICES


var saveForm = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$C().m(function _callee(ctx, evt) {
    var subscriptionId;
    return _regenerator$C().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            subscriptionId = evt.payload.subscriptionId;
            return _context.a(2, post$1("".concat(googleWorkspaceEndpoint, "/subscriptions/").concat(subscriptionId, "/provision-form"), evt.payload));
        }
      }
    }, _callee);
  }));

  return function saveForm(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}(); // EVENTS


var events$1 = {
  SAVE: 'save',
  RETRY: 'retry'
}; // ONBOARDING MACHINE

var machineOpts$2 = {
  services: {
    saveForm: saveForm
  },
  actions: {
    cacheError: assign$2({
      error: function error(ctx, evt) {
        var _evt$data, _evt$data$response;

        var error = (evt === null || evt === void 0 ? void 0 : (_evt$data = evt.data) === null || _evt$data === void 0 ? void 0 : (_evt$data$response = _evt$data.response) === null || _evt$data$response === void 0 ? void 0 : _evt$data$response.data) || (evt === null || evt === void 0 ? void 0 : evt.data);
        tracker$1('Client Error', {
          type: 'onboarding-machine-error',
          location: 'onboarding-form.machine',
          error: error
        });
        var message = (error === null || error === void 0 ? void 0 : error.message) || 'There was an error with the request';
        return {
          message: message
        };
      }
    }),
    onSuccess: function onSuccess() {// Placeholder - overridden when used by component
    }
  },
  guards: {
    maxRetriesReached: function maxRetriesReached(ctx) {
      return ctx.retries >= 2;
    }
  }
};
var onboardingFormMachine = Machine({
  id: 'gw-onboarding',
  initial: 'idle',
  context: {
    retries: 0,
    error: null
  },
  states: {
    idle: {
      on: _defineProperty$6({}, events$1.SAVE, 'loading')
    },
    loading: {
      invoke: {
        id: 'save-form',
        src: 'saveForm',
        onDone: {
          target: 'success',
          actions: 'onSuccess'
        },
        onError: {
          target: 'failure',
          actions: 'cacheError'
        }
      }
    },
    success: {
      type: 'final'
    },
    failure: {
      on: _defineProperty$6({}, events$1.RETRY, [{
        cond: 'maxRetriesReached',
        target: 'maxAddRetries'
      }, {
        target: 'loading',
        actions: assign$2({
          retries: function retries(context) {
            return context.retries + 1;
          }
        })
      }])
    },
    maxAddRetries: {
      after: {
        500: {
          target: 'idle'
        }
      }
    }
  }
}, machineOpts$2);

function ownKeys$B(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$B(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$B(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$B(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _regenerator$B() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$B(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$B(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$B(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$B(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$B(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$B(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$B(u), _regeneratorDefine2$B(u, o, "Generator"), _regeneratorDefine2$B(u, n, function () {
    return this;
  }), _regeneratorDefine2$B(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$B = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$B(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$B = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$B(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$B(e, r, n, t);
} // SERVICES


var getSubscriptions = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$B().m(function _callee() {
    return _regenerator$B().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            return _context.a(2, get$3("".concat(googleWorkspaceEndpoint, "/subscriptions")));
        }
      }
    }, _callee);
  }));

  return function getSubscriptions() {
    return _ref.apply(this, arguments);
  };
}(); // EVENTS


var events = {
  GET: 'get',
  RETRY: 'retry',
  SET_AS_CANCELLED: 'set-subscription-as-cancelled',
  SET_AS_PROVISIONING: 'set-subscription-as-provisioning',
  SET_NEW_SEATS_AMOUNT: 'set-subscription-new-seats-amount'
}; // SUBSCRIPTIONS MACHINE

var machineOpts$1 = {
  services: {
    getSubscriptions: getSubscriptions
  },
  actions: {
    cacheError: assign$2({
      error: function error(ctx, evt) {
        var _evt$data, _evt$data$response;

        var error = (evt === null || evt === void 0 ? void 0 : (_evt$data = evt.data) === null || _evt$data === void 0 ? void 0 : (_evt$data$response = _evt$data.response) === null || _evt$data$response === void 0 ? void 0 : _evt$data$response.data) || (evt === null || evt === void 0 ? void 0 : evt.data);
        tracker$1('Client Error', {
          type: 'subscriptions-machine-error',
          location: 'subscriptions.machine',
          error: error
        });
        var message = (error === null || error === void 0 ? void 0 : error.message) || 'There was an error with the request';
        return {
          message: message
        };
      }
    }),
    cacheSubscriptions: assign$2({
      subscriptions: function subscriptions(ctx, evt) {
        var _evt$data2, _evt$data2$data;

        return evt === null || evt === void 0 ? void 0 : (_evt$data2 = evt.data) === null || _evt$data2 === void 0 ? void 0 : (_evt$data2$data = _evt$data2.data) === null || _evt$data2$data === void 0 ? void 0 : _evt$data2$data.subscriptions;
      }
    }),
    setSubscriptionAsCancelled: assign$2({
      subscriptions: function subscriptions(ctx, evt) {
        var _ref2 = (evt === null || evt === void 0 ? void 0 : evt.payload) || {},
            subscriptionId = _ref2.subscriptionId;

        return ctx === null || ctx === void 0 ? void 0 : ctx.subscriptions.map(function (s) {
          if (s.subscriptionId === subscriptionId) {
            return _objectSpread$B(_objectSpread$B({}, s), {}, {
              status: 'Cancelling'
            });
          }

          return s;
        });
      }
    }),
    setSubscriptionAsProvisioning: assign$2({
      subscriptions: function subscriptions(ctx, evt) {
        var _ref3 = (evt === null || evt === void 0 ? void 0 : evt.payload) || {},
            subscriptionId = _ref3.subscriptionId;

        return ctx === null || ctx === void 0 ? void 0 : ctx.subscriptions.map(function (s) {
          if (s.subscriptionId === subscriptionId) {
            return _objectSpread$B(_objectSpread$B({}, s), {}, {
              status: 'Provisioning'
            });
          }

          return s;
        });
      }
    }),
    setSubscriptionNewSeatsAmount: assign$2({
      subscriptions: function subscriptions(ctx, evt) {
        var _ref4 = (evt === null || evt === void 0 ? void 0 : evt.payload) || {},
            subscriptionId = _ref4.subscriptionId,
            totalSeats = _ref4.totalSeats;

        return ctx === null || ctx === void 0 ? void 0 : ctx.subscriptions.map(function (s) {
          if (s.subscriptionId === subscriptionId) {
            return _objectSpread$B(_objectSpread$B({}, s), {}, {
              users: totalSeats
            });
          }

          return s;
        });
      }
    }),
    onSuccess: function onSuccess() {// Placeholder - overridden when used by component
    }
  },
  guards: {
    maxRetriesReached: function maxRetriesReached(ctx) {
      return ctx.retries >= 2;
    }
  }
};
var subscriptionsMachine = Machine({
  id: 'gw-subscription',
  initial: 'idle',
  context: {
    retries: 0,
    subscriptions: [],
    error: null
  },
  states: {
    idle: {
      on: _defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6({}, events.GET, 'loading'), events.SET_AS_CANCELLED, 'settingSubscriptionAsCancelled'), events.SET_AS_PROVISIONING, 'settingSubscriptionAsProvisioning'), events.SET_NEW_SEATS_AMOUNT, 'settingSubscriptionNewSeatsAmount')
    },
    loading: {
      invoke: {
        id: 'get-subscriptions',
        src: 'getSubscriptions',
        onDone: {
          target: 'success',
          actions: ['cacheSubscriptions', 'onSuccess']
        },
        onError: {
          target: 'failure',
          actions: 'cacheError'
        }
      }
    },
    success: {
      after: {
        500: {
          target: 'idle'
        }
      }
    },
    failure: {
      on: _defineProperty$6({}, events.RETRY, [{
        cond: 'maxRetriesReached',
        target: 'maxAddRetries'
      }, {
        target: 'loading',
        actions: assign$2({
          retries: function retries(context) {
            return context.retries + 1;
          }
        })
      }])
    },
    maxAddRetries: {
      after: {
        500: {
          target: 'idle'
        }
      }
    },
    settingSubscriptionAsCancelled: {
      entry: 'setSubscriptionAsCancelled',
      after: {
        500: {
          target: 'idle'
        }
      }
    },
    settingSubscriptionAsProvisioning: {
      entry: 'setSubscriptionAsProvisioning',
      after: {
        500: {
          target: 'idle'
        }
      }
    },
    settingSubscriptionNewSeatsAmount: {
      entry: 'setSubscriptionNewSeatsAmount',
      after: {
        500: {
          target: 'idle'
        }
      }
    }
  }
}, machineOpts$1);

function ownKeys$A(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$A(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$A(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$A(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _regenerator$A() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$A(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$A(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$A(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$A(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$A(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$A(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$A(u), _regeneratorDefine2$A(u, o, "Generator"), _regeneratorDefine2$A(u, n, function () {
    return this;
  }), _regeneratorDefine2$A(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$A = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$A(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$A = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$A(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$A(e, r, n, t);
}

var GoogleWorkspaceContext = /*#__PURE__*/React.createContext();

function GoogleWorkspaceProvider(props) {
  var _currentSubscriptionS, _currentSubscriptionS2, _currentOnboardingSta, _currentAddSeatsState;

  var _useUserService = useUserService(),
      user = _useUserService.user; // Subscriptions


  var _useMachine = useMachine(subscriptionsMachine),
      _useMachine2 = _slicedToArray$4(_useMachine, 2),
      currentSubscriptionState = _useMachine2[0],
      sendSubscriptionEvent = _useMachine2[1];

  var getSubscriptions = function getSubscriptions() {
    sendSubscriptionEvent(events.GET);
  };

  var hasSubscriptionsError = currentSubscriptionState.matches('failure');
  var isSubscriptionsLoading = currentSubscriptionState.matches('loading');
  var isSubscriptionsSuccessful = currentSubscriptionState.matches('success');
  var subscriptions = currentSubscriptionState.context.subscriptions;
  var subscriptionsError = (_currentSubscriptionS = currentSubscriptionState.context) === null || _currentSubscriptionS === void 0 ? void 0 : (_currentSubscriptionS2 = _currentSubscriptionS.error) === null || _currentSubscriptionS2 === void 0 ? void 0 : _currentSubscriptionS2.message; // Login Url

  var _useMachine3 = useMachine(loginUrlMachine),
      _useMachine4 = _slicedToArray$4(_useMachine3, 2),
      currentLoginUrlState = _useMachine4[0],
      sendLoginUrlEvent = _useMachine4[1];

  var loginUrl = currentLoginUrlState.context.loginUrl;
  var isGetLoginUrlSuccessful = currentLoginUrlState.matches('success');
  var isGetLoginUrlLoading = currentLoginUrlState.matches('loading');

  var getLoginUrl = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$A().m(function _callee(subscriptionId) {
      return _regenerator$A().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              sendLoginUrlEvent({
                type: events$2.GET_LOGIN_URL,
                payload: {
                  subscriptionId: subscriptionId
                }
              });

            case 1:
              return _context.a(2);
          }
        }
      }, _callee);
    }));

    return function getLoginUrl(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  React.useEffect(function () {
    if (isGetLoginUrlSuccessful) {
      navigate(loginUrl);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isGetLoginUrlSuccessful]); // Cancel Subscription

  var _useMachine5 = useMachine(cancelSubscriptionMachine),
      _useMachine6 = _slicedToArray$4(_useMachine5, 2),
      currentCancelSubscriptionState = _useMachine6[0],
      sendCancelSubscriptionEvent = _useMachine6[1];

  var cancelSubscription = function cancelSubscription(shouldRetry, subscriptionId) {
    sendCancelSubscriptionEvent({
      type: shouldRetry ? events$4.RETRY : events$4.CANCEL_SUBSCRIPTION,
      payload: {
        subscriptionId: subscriptionId
      }
    });
  };

  var setSubscriptionAsCancelled = function setSubscriptionAsCancelled(subscriptionId) {
    sendSubscriptionEvent({
      type: events.SET_AS_CANCELLED,
      payload: {
        subscriptionId: subscriptionId
      }
    });
  };

  var setSubscriptionAsProvisioning = function setSubscriptionAsProvisioning(subscriptionId) {
    sendSubscriptionEvent({
      type: events.SET_AS_PROVISIONING,
      payload: {
        subscriptionId: subscriptionId
      }
    });
  };

  var resetCancelSubscription = function resetCancelSubscription() {
    sendCancelSubscriptionEvent({
      type: events$4.RESET
    });
  };

  var hasCancelSubscriptionError = currentCancelSubscriptionState.matches('failure');
  var isCancelSubscriptionLoading = currentCancelSubscriptionState.matches('loading');
  var isCancelSubscriptionSuccessful = currentCancelSubscriptionState.matches('success');
  var cancelMaxRetriesReached = currentCancelSubscriptionState.matches('maxCancelRetries'); // Onboarding form

  var _useMachine7 = useMachine(onboardingFormMachine),
      _useMachine8 = _slicedToArray$4(_useMachine7, 2),
      currentOnboardingState = _useMachine8[0],
      sendOnboardingEvents = _useMachine8[1];

  var saveOnboardingForm = function saveOnboardingForm(payload) {
    sendOnboardingEvents({
      type: events$1.SAVE,
      payload: payload
    });
  };

  var hasOnboardingError = currentOnboardingState.matches('failure');
  var isOnboardingLoading = currentOnboardingState.matches('loading');
  var hasOnboardingSuccess = currentOnboardingState.matches('success');
  var onboardingErrorMessage = (_currentOnboardingSta = currentOnboardingState.context) === null || _currentOnboardingSta === void 0 ? void 0 : _currentOnboardingSta.error; // Seats

  var _useMachine9 = useMachine(addGWSeatsMachine),
      _useMachine0 = _slicedToArray$4(_useMachine9, 2),
      currentAddSeatsState = _useMachine0[0],
      sendAddSeatsEvents = _useMachine0[1];

  var hasAddSeatsError = currentAddSeatsState.matches('failure');
  var isAddSeatsLoading = currentAddSeatsState.matches('loading');
  var hasAddSeatsSuccess = currentAddSeatsState.matches('success');
  var addSeatsErrorMessage = (_currentAddSeatsState = currentAddSeatsState.context) === null || _currentAddSeatsState === void 0 ? void 0 : _currentAddSeatsState.error;
  var addSeatsMaxRetriesReached = currentAddSeatsState.matches('maxAddRetries');

  var addSeats = function addSeats(payload) {
    sendAddSeatsEvents({
      type: events$5.ADD,
      payload: payload
    });
  };

  var retryAddSeats = function retryAddSeats(payload) {
    sendAddSeatsEvents({
      type: events$5.RETRY,
      payload: payload
    });
  };

  var resetAddSeats = function resetAddSeats() {
    sendAddSeatsEvents({
      type: events$5.RESET
    });
  };

  var setSubscriptionNewSeatsAmount = function setSubscriptionNewSeatsAmount(subscriptionId, totalSeats) {
    sendSubscriptionEvent({
      type: events.SET_NEW_SEATS_AMOUNT,
      payload: {
        subscriptionId: subscriptionId,
        totalSeats: totalSeats
      }
    });
  }; // Domains


  var _useMachine1 = useMachine(domainsMachine),
      _useMachine10 = _slicedToArray$4(_useMachine1, 2),
      currentDomainsState = _useMachine10[0],
      sendDomainsEvents = _useMachine10[1];

  var getDomains = function getDomains() {
    sendDomainsEvents(events$3.GET);
  };

  var hasDomainsError = currentDomainsState.matches('failure');
  var isDomainsLoading = currentDomainsState.matches('loading');
  var domains = currentDomainsState.context.domains;
  React.useEffect(function () {
    if (user !== null && user !== void 0 && user.customerId) {
      getSubscriptions();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [user === null || user === void 0 ? void 0 : user.customerId]);
  var navigate = props.navigate;
  var value = React.useMemo(function () {
    return {
      getSubscriptions: getSubscriptions,
      subscriptions: subscriptions,
      subscriptionsError: subscriptionsError,
      isSubscriptionsLoading: isSubscriptionsLoading,
      isSubscriptionsSuccessful: isSubscriptionsSuccessful,
      hasSubscriptionsError: hasSubscriptionsError,
      domains: domains,
      getDomains: getDomains,
      getLoginUrl: getLoginUrl,
      isGetLoginUrlLoading: isGetLoginUrlLoading,
      hasDomainsError: hasDomainsError,
      isDomainsLoading: isDomainsLoading,
      saveOnboardingForm: saveOnboardingForm,
      hasOnboardingError: hasOnboardingError,
      hasOnboardingSuccess: hasOnboardingSuccess,
      onboardingErrorMessage: onboardingErrorMessage,
      isOnboardingLoading: isOnboardingLoading,
      cancelSubscription: cancelSubscription,
      hasCancelSubscriptionError: hasCancelSubscriptionError,
      isCancelSubscriptionLoading: isCancelSubscriptionLoading,
      isCancelSubscriptionSuccessful: isCancelSubscriptionSuccessful,
      cancelMaxRetriesReached: cancelMaxRetriesReached,
      resetCancelSubscription: resetCancelSubscription,
      setSubscriptionAsCancelled: setSubscriptionAsCancelled,
      setSubscriptionAsProvisioning: setSubscriptionAsProvisioning,
      setSubscriptionNewSeatsAmount: setSubscriptionNewSeatsAmount,
      navigate: navigate,
      hasAddSeatsError: hasAddSeatsError,
      isAddSeatsLoading: isAddSeatsLoading,
      hasAddSeatsSuccess: hasAddSeatsSuccess,
      addSeatsErrorMessage: addSeatsErrorMessage,
      addSeats: addSeats,
      retryAddSeats: retryAddSeats,
      addSeatsMaxRetriesReached: addSeatsMaxRetriesReached,
      resetAddSeats: resetAddSeats
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [getSubscriptions, subscriptions, subscriptionsError, isSubscriptionsLoading, isSubscriptionsSuccessful, hasSubscriptionsError, hasOnboardingError, isOnboardingLoading, hasOnboardingSuccess, onboardingErrorMessage, domains, hasDomainsError, isDomainsLoading, saveOnboardingForm, cancelSubscription, hasCancelSubscriptionError, isCancelSubscriptionLoading, isCancelSubscriptionSuccessful, cancelMaxRetriesReached, resetCancelSubscription, setSubscriptionAsCancelled, setSubscriptionAsProvisioning, setSubscriptionNewSeatsAmount, navigate, hasAddSeatsError, isAddSeatsLoading, hasAddSeatsSuccess, addSeatsErrorMessage, addSeats, retryAddSeats, addSeatsMaxRetriesReached, resetAddSeats]);
  return /*#__PURE__*/jsx$1(GoogleWorkspaceContext.Provider, _objectSpread$A({
    value: value
  }, props));
}

function useGoogleWorkspaceService() {
  var context = React.useContext(GoogleWorkspaceContext);

  if (!context) {
    throw new Error("useGoogleWorkspaceService must be used within an GoogleWorkspaceProvider");
  }

  return _objectSpread$A({}, context);
}

GoogleWorkspaceProvider.propTypes = {
  navigate: PropTypes.func
};
GoogleWorkspaceProvider.defaultProps = {
  navigate: function navigate() {
    console.log('navigate function was not passed');
  }
};

function _regenerator$z() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$z(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$z(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$z(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$z(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$z(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$z(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$z(u), _regeneratorDefine2$z(u, o, "Generator"), _regeneratorDefine2$z(u, n, function () {
    return this;
  }), _regeneratorDefine2$z(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$z = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$z(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$z = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$z(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$z(e, r, n, t);
}

function ownKeys$z(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$z(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$z(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$z(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var propTypes$z = {
  onSuccess: PropTypes.func.isRequired,
  strings: PropTypes.shape({
    cancelButton: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    domainSelector: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    organizationName: PropTypes.string.isRequired,
    organizationNameRequired: PropTypes.string.isRequired,
    pageTitle: PropTypes.string.isRequired,
    postalCode: PropTypes.string.isRequired,
    primaryEmail: PropTypes.string.isRequired,
    primaryEmailRequired: PropTypes.string.isRequired,
    secondaryEmail: PropTypes.string.isRequired,
    secondaryEmailRequired: PropTypes.string.isRequired,
    submitButton: PropTypes.string.isRequired,
    validEmail: PropTypes.string.isRequired
  }).isRequired,
  subscriptionId: PropTypes.string
};
var defaultProps$d = {
  subscriptionId: null
};

function OnboardingForm(_ref) {
  var _user$primaryAddress, _user$primaryAddress2;

  var strings = _ref.strings,
      subscriptionId = _ref.subscriptionId,
      onSuccess = _ref.onSuccess;

  var _useUserService = useUserService(),
      user = _useUserService.user,
      isUserLoading = _useUserService.isLoading;

  var _useState = useState([]),
      _useState2 = _slicedToArray$4(_useState, 2),
      countries = _useState2[0],
      setCountries = _useState2[1];

  var passwordStrengthRegex = /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*\(\),.:;\?<>~\_\[\]\{\}\-]).{8,40})/;

  var testPasswordStrength = function testPasswordStrength(val) {
    return passwordStrengthRegex.test(val);
  };

  var formSchema = create().shape({
    alternateEmail: create$2().email(strings.validEmail).required(strings.secondaryEmailRequired).test('alternateEmail-should-not-match-domain', "".concat(strings.unusableAlternateEmail), function () {
      var alternateDomain = values.alternateEmail.split('@')[1];
      return alternateDomain !== values.domain;
    }),
    country: create$2().required(),
    domain: create$2().required(),
    firstName: create$2().required(),
    lastName: create$2().required(),
    organizationName: create$2().required(strings.organizationNameRequired),
    postalCode: create$2().required(),
    username: create$2().required(strings.primaryEmailRequired),
    password: create$2().required(authStrings.passwordRequired).test('regex', authStrings.passwordStrength, testPasswordStrength).test('confirmPassword-should-match-password', 'password and confirm password must match', function (pass) {
      return pass === values.confirmPassword;
    }).min(8, authStrings.passwordLength8)
  });

  var _useGoogleWorkspaceSe = useGoogleWorkspaceService(),
      saveOnboardingForm = _useGoogleWorkspaceSe.saveOnboardingForm,
      hasOnboardingSuccess = _useGoogleWorkspaceSe.hasOnboardingSuccess,
      hasOnboardingError = _useGoogleWorkspaceSe.hasOnboardingError,
      onboardingErrorMessage = _useGoogleWorkspaceSe.onboardingErrorMessage,
      isOnboardingLoading = _useGoogleWorkspaceSe.isOnboardingLoading,
      getDomains = _useGoogleWorkspaceSe.getDomains,
      domains = _useGoogleWorkspaceSe.domains,
      isDomainsLoading = _useGoogleWorkspaceSe.isDomainsLoading,
      subscriptions = _useGoogleWorkspaceSe.subscriptions,
      isSubscriptionsSuccessful = _useGoogleWorkspaceSe.isSubscriptionsSuccessful,
      navigate = _useGoogleWorkspaceSe.navigate;

  var formik = useFormik({
    initialValues: {
      username: '',
      password: '',
      firstName: user.firstname,
      lastName: user.lastname,
      country: user === null || user === void 0 ? void 0 : (_user$primaryAddress = user.primaryAddress) === null || _user$primaryAddress === void 0 ? void 0 : _user$primaryAddress.country,
      organizationName: user === null || user === void 0 ? void 0 : user.company,
      postalCode: user === null || user === void 0 ? void 0 : (_user$primaryAddress2 = user.primaryAddress) === null || _user$primaryAddress2 === void 0 ? void 0 : _user$primaryAddress2.postalCode,
      domain: '',
      alternateEmail: ''
    },
    onSubmit: function onSubmit(values) {
      var foundCountry = countries.find(function (c) {
        var _values$country;

        return c._Country.toLowerCase() === ((_values$country = values.country) === null || _values$country === void 0 ? void 0 : _values$country.toLowerCase());
      });
      saveOnboardingForm(_objectSpread$z(_objectSpread$z({}, values), {}, {
        username: "".concat(values.username, "@").concat(values.domain),
        countryCode: foundCountry._TwoLetterCode,
        subscriptionId: subscriptionId
      }));
    },
    validationSchema: formSchema
  });
  var errors = formik.errors,
      handleChange = formik.handleChange,
      values = formik.values,
      touched = formik.touched,
      setFieldValue = formik.setFieldValue;

  var getCountries = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$z().m(function _callee() {
      var _yield$get, data;

      return _regenerator$z().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              _context.n = 1;
              return get$3(countriesEndpoint);

            case 1:
              _yield$get = _context.v;
              data = _yield$get.data;
              setCountries(data);

            case 2:
              return _context.a(2);
          }
        }
      }, _callee);
    }));

    return function getCountries() {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (hasOnboardingSuccess) {
      onSuccess(subscriptionId);
    }
  }, [hasOnboardingSuccess]);
  useEffect(function () {
    getDomains();
    getCountries();
  }, []);
  useEffect(function () {
    if (isSubscriptionsSuccessful) {
      var currentSub = subscriptions.find(function (sub) {
        return sub.subscriptionId === subscriptionId;
      });

      if (!currentSub || currentSub.status !== 'New') {
        navigate(siteLinks.googleWorkspaceManager);
      }
    }
  }, [isSubscriptionsSuccessful]);
  useEffect(function () {
    if ((domains === null || domains === void 0 ? void 0 : domains.length) > 0) {
      setFieldValue('domain', domains[0].DomainName);
    }
  }, [domains, setFieldValue]);

  var handleEnterSubmit = function handleEnterSubmit(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      formik.handleSubmit(values);
    }
  };

  var selectorOpts = useMemo(function () {
    return domains.map(function (domain) {
      return {
        value: domain.DomainName,
        display: domain.DomainName
      };
    });
  }, [domains]);
  var countryOpts = useMemo(function () {
    return countries.map(function (country) {
      return {
        value: country._Country,
        display: country._Country
      };
    });
  }, [countries]);
  var showLoadingForm = isDomainsLoading || isUserLoading;
  var showForm = !showLoadingForm && !hasOnboardingSuccess;
  var showSuccess = hasOnboardingSuccess;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [showLoadingForm && /*#__PURE__*/jsx$1(Stack$2, {
      width: "50rem",
      children: times(7, function (idx) {
        return /*#__PURE__*/jsx$1(Skeleton$1, {
          height: "3.4rem",
          mb: 3,
          width: "100%"
        }, idx);
      })
    }), showForm &&
    /*#__PURE__*/

    /* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */
    jsxs("form", {
      id: "google-workspace-form",
      onKeyPress: handleEnterSubmit,
      children: [/*#__PURE__*/jsx$1(Select$2, {
        id: "domain-select",
        isLoading: isDomainsLoading,
        label: strings.domainSelector,
        onChange: function onChange(value) {
          return setFieldValue('domain', value);
        },
        options: selectorOpts,
        value: values.domain
      }), /*#__PURE__*/jsxs(Box$1, {
        alignItems: "flex-end",
        mt: 3,
        children: [/*#__PURE__*/jsx$1(Input$5, {
          "aria-invalid": errors.username,
          errorMessage: errors.username,
          hasError: errors.username && touched.username,
          id: "username",
          label: strings.primaryEmail,
          name: "username",
          onChange: handleChange,
          value: values.username
        }), /*#__PURE__*/jsxs(Text$1, {
          mb: 1,
          ml: 2,
          children: ["@", values.domain]
        })]
      }), /*#__PURE__*/jsx$1(Box$1, {
        alignItems: "flex-end",
        mt: 3,
        children: /*#__PURE__*/jsx$1(Input$5, {
          "aria-invalid": errors.password,
          errorMessage: errors.password,
          hasError: errors.password && touched.password,
          id: "password",
          label: strings.password,
          name: "password",
          type: "password",
          onChange: handleChange,
          value: values.password
        })
      }), /*#__PURE__*/jsx$1(Box$1, {
        alignItems: "flex-end",
        mt: 3,
        children: /*#__PURE__*/jsx$1(Input$5, {
          "aria-invalid": errors.confirmPassword,
          errorMessage: errors.confirmPassword,
          hasError: errors.confirmPassword && touched.confirmPassword,
          id: "confirmPassword",
          label: strings.confirmPassword,
          name: "confirmPassword",
          type: "password",
          onChange: handleChange,
          value: values.confirmPassword
        })
      }), /*#__PURE__*/jsx$1(Input$5, {
        "aria-invalid": errors.firstName,
        errorMessage: errors.firstName,
        hasError: errors.firstName && touched.firstName,
        id: "firstName",
        label: strings.firstName,
        mt: 3,
        name: "firstName",
        onChange: handleChange,
        value: values.firstName
      }), /*#__PURE__*/jsx$1(Input$5, {
        "aria-invalid": errors.lastName,
        errorMessage: errors.lastName,
        hasError: errors.lastName && touched.lastName,
        id: "lastName",
        label: strings.lastName,
        mt: 3,
        name: "lastName",
        onChange: handleChange,
        value: values.lastName
      }), /*#__PURE__*/jsx$1(Input$5, {
        "aria-invalid": errors.organizationName,
        errorMessage: errors.organizationName,
        hasError: errors.organizationName && touched.organizationName,
        id: "organizationName",
        label: strings.organizationName,
        mt: 3,
        name: "organizationName",
        onChange: handleChange,
        value: values.organizationName
      }), /*#__PURE__*/jsx$1(Input$5, {
        "aria-invalid": errors.alternateEmail,
        errorMessage: errors.alternateEmail,
        hasError: errors.alternateEmail && touched.alternateEmail,
        id: "alternateEmail",
        label: strings.secondaryEmail,
        mt: 3,
        name: "alternateEmail",
        onChange: handleChange,
        value: values.alternateEmail
      }), /*#__PURE__*/jsx$1(Input$5, {
        "aria-invalid": errors.postalCode,
        errorMessage: errors.postalCode,
        hasError: errors.postalCode && touched.postalCode,
        id: "postalCode",
        label: strings.postalCode,
        mt: 3,
        name: "postalCode",
        onChange: handleChange,
        value: values.postalCode
      }), /*#__PURE__*/jsx$1(Select$2, {
        id: "country-select",
        label: strings.country,
        mt: 3,
        onChange: function onChange(value) {
          return setFieldValue('country', value);
        },
        options: countryOpts,
        value: values.country
      }), hasOnboardingError && /*#__PURE__*/jsx$1(Message, {
        mt: 3,
        variant: "error",
        children: onboardingErrorMessage === null || onboardingErrorMessage === void 0 ? void 0 : onboardingErrorMessage.message
      }), /*#__PURE__*/jsx$1(Box$1, {
        alignItems: "center",
        justifyContent: "flex-end",
        mt: 3,
        children: isOnboardingLoading ? /*#__PURE__*/jsx$1(Spinner$1, {
          size: "2rem",
          stroke: ".3rem"
        }) : /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx$1(Button$1, {
            mr: 3,
            onClick: function onClick() {
              return navigate(siteLinks.googleWorkspaceManager);
            },
            variant: "inverse",
            children: strings.cancelButton
          }), /*#__PURE__*/jsx$1(Button$1, {
            id: "submit-info",
            onClick: function onClick() {
              formik.handleSubmit(values);
            },
            children: strings.submitButton
          })]
        })
      })]
    }), showSuccess && /*#__PURE__*/jsxs(Stack$2, {
      children: [/*#__PURE__*/jsx$1(Message, {
        py: 3,
        variant: "success",
        children: "Your account has been provisioned, please check your recovery email for an email from Google about accessing your new account."
      }), /*#__PURE__*/jsx$1(Button$1, {
        border: "none",
        color: "black",
        "data-testid": "backtomanager",
        mt: 3,
        onClick: function onClick() {
          return navigate(siteLinks.googleWorkspaceManager);
        },
        variant: "inverse",
        children: "Back to Google Workspace Manager"
      })]
    })]
  });
}

OnboardingForm.propTypes = propTypes$z;
OnboardingForm.defaultProps = defaultProps$d;

function _regenerator$y() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$y(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$y(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$y(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$y(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$y(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$y(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$y(u), _regeneratorDefine2$y(u, o, "Generator"), _regeneratorDefine2$y(u, n, function () {
    return this;
  }), _regeneratorDefine2$y(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$y = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$y(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$y = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$y(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$y(e, r, n, t);
}

var propTypes$y = {
  strings: PropTypes.shape({
    pageTitle: PropTypes.string.isRequired
  }).isRequired,
  subscriptionId: PropTypes.string
};
var defaultProps$c = {
  subscriptionId: null
};

function GoogleWorkspaceOnboardingForm(_ref) {
  var strings = _ref.strings,
      subscriptionId = _ref.subscriptionId;

  var _useGoogleWorkspaceSe = useGoogleWorkspaceService(),
      setSubscriptionAsProvisioning = _useGoogleWorkspaceSe.setSubscriptionAsProvisioning;

  var onOnboardingSuccess = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$y().m(function _callee(subId) {
      return _regenerator$y().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              setSubscriptionAsProvisioning(subId);

            case 1:
              return _context.a(2);
          }
        }
      }, _callee);
    }));

    return function onOnboardingSuccess(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/jsx$1(ErrorBoundary, {
    location: "google-workspace",
    children: /*#__PURE__*/jsxs(Stack$2, {
      alignItems: "center",
      width: "100%",
      children: [/*#__PURE__*/jsx$1(Heading, {
        mb: 3,
        variant: "petaBold",
        children: strings.pageTitle
      }), /*#__PURE__*/jsx$1(OnboardingForm, {
        onSuccess: onOnboardingSuccess,
        strings: strings,
        subscriptionId: subscriptionId
      })]
    })
  });
}

GoogleWorkspaceOnboardingForm.propTypes = propTypes$y;
GoogleWorkspaceOnboardingForm.defaultProps = defaultProps$c;

function CancelGWSubscriptiondModal(_ref) {
  var subscriptionId = _ref.subscriptionId,
      closeModal = _ref.closeModal,
      containerRef = _ref.containerRef,
      onSuccess = _ref.onSuccess,
      isDefault = _ref.isDefault,
      strings = _ref.strings;

  var _useGoogleWorkspaceSe = useGoogleWorkspaceService(),
      cancelSubscription = _useGoogleWorkspaceSe.cancelSubscription,
      isCancelSubscriptionLoading = _useGoogleWorkspaceSe.isCancelSubscriptionLoading,
      isCancelSubscriptionSuccessful = _useGoogleWorkspaceSe.isCancelSubscriptionSuccessful,
      hasCancelSubscriptionError = _useGoogleWorkspaceSe.hasCancelSubscriptionError,
      cancelMaxRetriesReached = _useGoogleWorkspaceSe.cancelMaxRetriesReached;

  useEffect(function () {
    if (isCancelSubscriptionSuccessful) {
      onSuccess(subscriptionId);
    }
  }, [isCancelSubscriptionSuccessful]);
  var content = isDefault ? strings.cancelConfirmationDefault : strings.cancelConfirmation;
  var btnText = strings.confirm;

  if (hasCancelSubscriptionError) {
    content = strings.retryMessage;
    btnText = strings.retry;
  }

  if (cancelMaxRetriesReached) {
    content = strings.maxRetriesMessage;
    btnText = strings.close;
  }

  return /*#__PURE__*/jsx$1(Confirmation, {
    btnText: btnText,
    containerRef: containerRef,
    content: content,
    isLoading: isCancelSubscriptionLoading,
    onCancel: closeModal,
    onConfirm: function onConfirm() {
      cancelSubscription(hasCancelSubscriptionError, subscriptionId);
    },
    title: strings.cancelModalTitle
  });
}

var propTypes$x = {
  children: PropTypes$1.node.isRequired,
  onOutsideClick: PropTypes$1.func.isRequired
};

function OutsideClickDetector(_ref) {
  var onOutsideClick = _ref.onOutsideClick,
      children = _ref.children;
  var ref = useRef(null);
  useEffect(function () {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        onOutsideClick();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
  return /*#__PURE__*/jsx$1(Box$1, {
    ref: ref,
    position: "absolute",
    children: children
  });
}

OutsideClickDetector.propTypes = propTypes$x;
var _excluded$b = ["options", "alignment", "label"];

function ownKeys$y(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$y(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$y(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$y(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var propTypes$w = {
  alignment: PropTypes$1.oneOf(['left', 'right']),
  id: PropTypes$1.string.isRequired,
  label: PropTypes$1.any,
  options: PropTypes$1.arrayOf(PropTypes$1.shape({
    id: PropTypes$1.string.isRequired
  })).isRequired
};
var defaultProps$b = {
  alignment: 'right',
  label: 'Edit'
};
var MenuItem$1 = styled.button.withConfig({
  displayName: "menu-button__MenuItem",
  componentId: "sc-6xnnzx-0"
})(["border:none;cursor:pointer;display:flex;justify-content:flex-start;padding:", " ", ";background:", ";transition:all 0.2s;font-size:", ";white-space:nowrap;&:hover{background:", ";}&:disabled{cursor:default;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.space[2];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space[3];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.greys[8];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes[1];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.greys[7];
});

function MenuButton(_ref6) {
  var options = _ref6.options,
      alignment = _ref6.alignment,
      label = _ref6.label,
      props = _objectWithoutProperties$8(_ref6, _excluded$b);

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var menuPane = useRef(null);
  var menuButton = useRef(null);
  var optionsRef = useRef(options.map(function () {
    return /*#__PURE__*/createRef();
  }));

  var _useState3 = useState(null),
      _useState4 = _slicedToArray$4(_useState3, 2),
      currentOptionIdx = _useState4[0],
      setCurrentOptionIdx = _useState4[1];

  var closeMenu = function closeMenu() {
    setOpen(false);
    setCurrentOptionIdx(null);
  };

  var openMenu = function openMenu() {
    setOpen(true);
    setCurrentOptionIdx(0);
  };

  useEffect(function () {
    var handleKeyPress = function handleKeyPress(e) {
      switch (e.key) {
        case 'ArrowDown':
          openMenu();
          e.preventDefault();
          break;

        case 'Enter':
        case ' ':
          if (open) {
            closeMenu();
          } else {
            openMenu();
          }

          e.preventDefault();
          break;

        case 'ArrowUp':
          closeMenu();
          e.preventDefault();
          break;
      }
    };

    var currentMenuButton = menuButton.current;
    currentMenuButton.addEventListener('keydown', handleKeyPress);
    return function () {
      if (currentMenuButton) {
        currentMenuButton.removeEventListener('keydown', handleKeyPress);
      }
    };
  });
  useEffect(function () {
    var setFocus = function setFocus() {
      var _optionsRef$current$c;

      var nextOption = (_optionsRef$current$c = optionsRef.current[currentOptionIdx]) === null || _optionsRef$current$c === void 0 ? void 0 : _optionsRef$current$c.current;

      if (nextOption) {
        nextOption.focus();
      }
    };

    var arrowTrap = function arrowTrap(e) {
      var nextIdx;

      switch (e.key) {
        case 'ArrowDown':
          nextIdx = currentOptionIdx === options.length - 1 ? 0 : currentOptionIdx + 1;
          setCurrentOptionIdx(nextIdx);
          setFocus();
          e.preventDefault();
          break;

        case 'ArrowUp':
          nextIdx = currentOptionIdx === 0 ? options.length - 1 : currentOptionIdx - 1;
          setCurrentOptionIdx(nextIdx);
          setFocus();
          e.preventDefault();
          break;

        case 'Escape':
          closeMenu();
          menuButton.current.focus();
          e.preventDefault();
          break;
      }
    };

    var currentMenuPane = menuPane.current;

    if (open) {
      if (currentOptionIdx === null) {
        setCurrentOptionIdx(0);
      }

      currentMenuPane.addEventListener('keydown', arrowTrap);
    } else if (currentMenuPane) {
      currentMenuPane.removeEventListener('keydown', arrowTrap);
      setCurrentOptionIdx(null);
    }

    return function () {
      if (currentMenuPane) {
        currentMenuPane.removeEventListener('keydown', arrowTrap);
      }
    };
  }, [options.length, open, currentOptionIdx]);
  useEffect(function () {
    if (currentOptionIdx !== null) {
      var _optionsRef$current$c2;

      var nextOption = (_optionsRef$current$c2 = optionsRef.current[currentOptionIdx]) === null || _optionsRef$current$c2 === void 0 ? void 0 : _optionsRef$current$c2.current;

      if (nextOption) {
        nextOption.focus();
      }
    }
  }, [currentOptionIdx]);

  var handleOptionClick = function handleOptionClick(_ref7) {
    var action = _ref7.action;

    if (action) {
      action();
    }

    closeMenu();
  };

  var handleButtonClick = function handleButtonClick() {
    if (open) {
      closeMenu();
      return;
    }

    openMenu();
  };

  var getMenuAlignment = function getMenuAlignment() {
    if (alignment === 'left') {
      return {
        left: 0
      };
    }

    return {
      right: 0
    };
  };

  return /*#__PURE__*/jsxs(Box$1, {
    position: "relative",
    children: [/*#__PURE__*/jsxs(Button$1, _objectSpread$y(_objectSpread$y({
      ref: menuButton
    }, props), {}, {
      "aria-expanded": open,
      "aria-haspopup": "true",
      color: "blueDark",
      onClick: handleButtonClick,
      variant: "inverse",
      children: [label, /*#__PURE__*/jsx$1(Icon$2, {
        ml: 2,
        name: "chevron-down"
      })]
    })), open && /*#__PURE__*/jsx$1(OutsideClickDetector, {
      onOutsideClick: closeMenu,
      children: /*#__PURE__*/jsx$1(Stack$2, _objectSpread$y(_objectSpread$y({
        ref: menuPane,
        boxShadow: 0,
        minWidth: "15rem",
        position: "absolute",
        role: "menu",
        top: "4rem",
        zIndex: "9999"
      }, getMenuAlignment()), {}, {
        children: options.map(function (option, idx) {
          return /*#__PURE__*/jsx$1(MenuItem$1, {
            disabled: option.disabled,
            ref: optionsRef.current[idx],
            "data-testid": option.id,
            id: option.id,
            justifyContent: "flex-start",
            onClick: function onClick() {
              return handleOptionClick(option);
            },
            role: "menuitem",
            tabIndex: "-1",
            type: "button",
            children: option.display
          }, option.id);
        })
      }))
    })]
  });
}

MenuButton.propTypes = propTypes$w;
MenuButton.defaultProps = defaultProps$b;
var propTypes$v = {
  cell: PropTypes.shape({
    value: PropTypes.shape({
      status: PropTypes.string,
      subscriptionId: PropTypes.string
    }).isRequired
  }).isRequired,
  navigateToBuy: PropTypes.func.isRequired,
  navigateToOnboarding: PropTypes.func.isRequired,
  openCancelModal: PropTypes.func.isRequired,
  strings: PropTypes.shape({
    onboardingButton: PropTypes.string.isRequired,
    openConsoleButton: PropTypes.string.isRequired
  }).isRequired
};

function SubscriptionActionCell(_ref) {
  var cell = _ref.cell,
      isGetLoginUrlLoading = _ref.isGetLoginUrlLoading,
      strings = _ref.strings,
      openCancelModal = _ref.openCancelModal,
      openConsole = _ref.openConsole,
      navigateToBuy = _ref.navigateToBuy,
      navigateToOnboarding = _ref.navigateToOnboarding;
  var options = [{
    id: "edit-users-".concat(cell.value.subscriptionId),
    display: 'Edit Users',
    action: function action() {
      navigateToBuy();
    }
  }, {
    id: "cancel-".concat(cell.value.subscriptionId),
    display: 'Cancel',
    action: function action() {
      openCancelModal();
    }
  }];
  return /*#__PURE__*/jsxs(Box$1, {
    justifyContent: "flex-end",
    children: [cell.value.status === 'Active' ? /*#__PURE__*/jsx$1(Button$1, {
      color: "blueDark",
      variant: "inverse",
      onClick: function onClick() {
        openConsole();
      },
      disabled: isGetLoginUrlLoading,
      children: strings.openConsoleButton
    }) : null, cell.value.status === 'New' ? /*#__PURE__*/jsx$1(Button$1, {
      color: "blueDark",
      "data-testid": "provision-".concat(cell.value.subscriptionId),
      lineHeight: "title",
      onClick: function onClick() {
        navigateToOnboarding();
      },
      variant: "solid",
      children: strings.onboardingButton
    }) : null, /*#__PURE__*/jsx$1(MenuButton, {
      alignment: "right",
      color: "blueDark",
      id: "edit-".concat(cell.value.subscriptionId),
      lineHeight: "title",
      ml: 2,
      options: options,
      variant: "inverse"
    })]
  });
}

SubscriptionActionCell.propTypes = propTypes$v;

function ownKeys$x(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$x(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$x(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$x(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function Cell(_ref) {
  var cell = _ref.cell;
  return /*#__PURE__*/jsx$1(Box$1, {
    justifyContent: "flex-start",
    children: /*#__PURE__*/jsx$1(Text$1, {
      variant: "kilo",
      children: cell.value
    })
  });
}

Cell.propTypes = {
  cell: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }).isRequired
};

function Table(_ref2) {
  var columns = _ref2.columns,
      data = _ref2.data;

  var _useTable = useTable({
    columns: columns,
    data: data
  }),
      getTableProps = _useTable.getTableProps,
      getTableBodyProps = _useTable.getTableBodyProps,
      headerGroups = _useTable.headerGroups,
      prepareRow = _useTable.prepareRow,
      rows = _useTable.rows;

  return (
    /*#__PURE__*/
    // apply the table props
    jsxs(Box$1, _objectSpread$x(_objectSpread$x({
      as: "table",
      display: "table",
      width: "100%"
    }, getTableProps()), {}, {
      children: [/*#__PURE__*/jsx$1("thead", {
        children: // Loop over the header rows
        headerGroups.map(function (headerGroup, hgIdx) {
          return (
            /*#__PURE__*/
            // Apply the header row props
            jsx$1(Box$1, _objectSpread$x(_objectSpread$x({
              as: "tr",
              border: 2,
              display: "table-row"
            }, headerGroup.getHeaderGroupProps()), {}, {
              children: // Loop over the headers in each row
              headerGroup.headers.map(function (column, hIdx) {
                return (
                  /*#__PURE__*/
                  // Apply the header cell props
                  jsx$1(Text$1, _objectSpread$x(_objectSpread$x({
                    as: "th",
                    pl: 3,
                    pr: 2,
                    py: 2,
                    textAlign: "left",
                    variant: "megaBold"
                  }, column.getHeaderProps()), {}, {
                    children: // Render the header
                    column.render('Header')
                  }), "header-".concat(hgIdx, "=").concat(hIdx))
                );
              })
            }), "header-group-".concat(hgIdx))
          );
        })
      }), /*#__PURE__*/jsx$1(Box$1, _objectSpread$x(_objectSpread$x({
        as: "tbody",
        borderLeft: 2,
        borderRight: 2,
        display: "table-row-group"
      }, getTableBodyProps()), {}, {
        children: // Loop over the table rows
        rows.map(function (row, rIdx) {
          // Prepare the row for display
          prepareRow(row);
          return (
            /*#__PURE__*/
            // Apply the row props
            jsx$1(Box$1, _objectSpread$x(_objectSpread$x({
              as: "tr",
              borderBottom: 2,
              display: "table-row"
            }, row.getRowProps()), {}, {
              children: // Loop over the rows cells
              row.cells.map(function (cell, cIdx) {
                return (
                  /*#__PURE__*/
                  // Apply the cell props
                  jsx$1(Text$1, _objectSpread$x(_objectSpread$x({
                    as: "td",
                    display: "table-cell",
                    pl: 3,
                    pr: 2,
                    py: 2
                  }, cell.getCellProps()), {}, {
                    children: // Render the cell contents
                    cell.render('Cell')
                  }), "cell-".concat(rIdx, "=").concat(cIdx))
                );
              })
            }), "row-".concat(rIdx))
          );
        })
      }))]
    }))
  );
}

Table.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

function ownKeys$w(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$w(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$w(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$w(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _regenerator$x() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$x(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$x(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$x(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$x(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$x(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$x(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$x(u), _regeneratorDefine2$x(u, o, "Generator"), _regeneratorDefine2$x(u, n, function () {
    return this;
  }), _regeneratorDefine2$x(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$x = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$x(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$x = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$x(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$x(e, r, n, t);
}

function PackageCell(_ref) {
  var _row$original;

  var row = _ref.row,
      value = _ref.value;
  return /*#__PURE__*/jsx$1(Text$1, {
    "data-testid": row === null || row === void 0 ? void 0 : (_row$original = row.original) === null || _row$original === void 0 ? void 0 : _row$original.subscriptionId,
    children: value
  });
}

PackageCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      subscriptionId: PropTypes.string
    })
  }).isRequired,
  value: PropTypes.string.isRequired
};

function StatusCell(_ref2) {
  var _row$original2;

  var row = _ref2.row,
      value = _ref2.value;
  return /*#__PURE__*/jsx$1(Text$1, {
    "data-testid": "".concat(value, "-").concat(row === null || row === void 0 ? void 0 : (_row$original2 = row.original) === null || _row$original2 === void 0 ? void 0 : _row$original2.subscriptionId),
    children: value
  });
}

StatusCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      subscriptionId: PropTypes.string
    })
  }).isRequired,
  value: PropTypes.string.isRequired
};
var propTypes$u = {
  strings: PropTypes.shape({}).isRequired
};

function SubscriptionsTable(_ref3) {
  var strings = _ref3.strings;

  var _useGoogleWorkspaceSe = useGoogleWorkspaceService(),
      subscriptions = _useGoogleWorkspaceSe.subscriptions,
      subscriptionsError = _useGoogleWorkspaceSe.subscriptionsError,
      isSubscriptionsLoading = _useGoogleWorkspaceSe.isSubscriptionsLoading,
      getLoginUrl = _useGoogleWorkspaceSe.getLoginUrl,
      isGetLoginUrlLoading = _useGoogleWorkspaceSe.isGetLoginUrlLoading,
      hasSubscriptionsError = _useGoogleWorkspaceSe.hasSubscriptionsError,
      resetCancelSubscription = _useGoogleWorkspaceSe.resetCancelSubscription,
      navigate = _useGoogleWorkspaceSe.navigate;

  var _useState = useState(null),
      _useState2 = _slicedToArray$4(_useState, 2),
      subIdToEdit = _useState2[0],
      setSubIdToEdit = _useState2[1];

  var _useModal = useModal(),
      openModal = _useModal.openModal,
      closeModal = _useModal.closeModal,
      Modal = _useModal.Modal,
      containerRef = _useModal.containerRef,
      isOpen = _useModal.isOpen;

  function LoadedActionCell(_ref4) {
    var cell = _ref4.cell;

    var openCancelModal = function openCancelModal() {
      setSubIdToEdit(cell.value.subscriptionId);
      openModal();
    };

    var navigateToBuy = function navigateToBuy() {
      setSubIdToEdit(cell.value.subscriptionId);
      navigate("/my-account/google-workspace/".concat(cell.value.subscriptionId, "/add"), {
        state: cell.value
      });
    };

    var navigateToOnboarding = function navigateToOnboarding() {
      setSubIdToEdit(cell.value.subscriptionId);
      navigate("/my-account/google-workspace/".concat(cell.value.subscriptionId, "/onboarding"), {
        subscriptionId: cell.value.subscriptionId
      });
    };

    var openConsole = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regenerator$x().m(function _callee() {
        return _regenerator$x().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                getLoginUrl(cell.value.subscriptionId);

              case 1:
                return _context.a(2);
            }
          }
        }, _callee);
      }));

      return function openConsole() {
        return _ref5.apply(this, arguments);
      };
    }();

    return /*#__PURE__*/jsx$1(SubscriptionActionCell, {
      cell: cell,
      isGetLoginUrlLoading: isGetLoginUrlLoading,
      navigateToBuy: navigateToBuy,
      navigateToOnboarding: navigateToOnboarding,
      openCancelModal: openCancelModal,
      openConsole: openConsole,
      strings: strings
    });
  }

  LoadedActionCell.propTypes = {
    cell: PropTypes.shape({
      value: PropTypes.shape({
        subscriptionId: PropTypes.string
      }).isRequired
    }).isRequired
  };

  var closeCancelModal = function closeCancelModal() {
    resetCancelSubscription();
    closeModal();
  };

  var columns = useMemo(function () {
    return [{
      Header: 'Package',
      accessor: 'itemName',
      Cell: PackageCell
    }, {
      Header: 'Users',
      accessor: 'users',
      Cell: Cell
    }, {
      Header: 'Status',
      accessor: 'status',
      Cell: StatusCell
    }, {
      Header: 'Domain',
      accessor: 'domain',
      Cell: Cell
    }, {
      Header: '',
      accessor: 'actions',
      Cell: LoadedActionCell
    }];
  });

  var _useGoogleWorkspaceSe2 = useGoogleWorkspaceService(),
      setSubscriptionAsCancelled = _useGoogleWorkspaceSe2.setSubscriptionAsCancelled;

  var onCancelSuccess = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regenerator$x().m(function _callee2(subscriptionId) {
      return _regenerator$x().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              setSubscriptionAsCancelled(subscriptionId);
              closeCancelModal();

            case 1:
              return _context2.a(2);
          }
        }
      }, _callee2);
    }));

    return function onCancelSuccess(_x) {
      return _ref6.apply(this, arguments);
    };
  }();

  var data = useMemo(function () {
    return subscriptions.map(function (sub) {
      return _objectSpread$w(_objectSpread$w({}, sub), {}, {
        actions: _objectSpread$w({}, sub)
      });
    });
  }, [subscriptions]);
  return /*#__PURE__*/jsxs(Stack$2, {
    width: "100%",
    children: [isSubscriptionsLoading ? /*#__PURE__*/jsxs(Stack$2, {
      width: "100%",
      children: [/*#__PURE__*/jsx$1(Skeleton$1, {
        height: "4.8rem",
        mb: 2,
        width: "100%"
      }), /*#__PURE__*/jsx$1(Skeleton$1, {
        height: "4.8rem",
        mb: 2,
        width: "100%"
      }), /*#__PURE__*/jsx$1(Skeleton$1, {
        height: "4.8rem",
        mb: 2,
        width: "100%"
      }), /*#__PURE__*/jsx$1(Skeleton$1, {
        height: "4.8rem",
        width: "100%"
      })]
    }) : /*#__PURE__*/jsx$1(Table, {
      columns: columns,
      data: data
    }), hasSubscriptionsError && /*#__PURE__*/jsx$1(Message, {
      containerProps: {
        mt: 3
      },
      variant: "error",
      children: subscriptionsError
    }), /*#__PURE__*/jsx$1(Modal, {
      closeBtnCb: closeCancelModal,
      id: "cancel-subscription-modal",
      isOpen: isOpen,
      onBgClick: closeCancelModal,
      onCancel: closeCancelModal,
      onEscapeKey: closeCancelModal,
      children: /*#__PURE__*/jsx$1(CancelGWSubscriptiondModal, {
        closeModal: closeCancelModal,
        containerRef: containerRef,
        onSuccess: onCancelSuccess,
        strings: strings,
        subscriptionId: subIdToEdit
      })
    })]
  });
}

SubscriptionsTable.propTypes = propTypes$u;
var propTypes$t = {
  strings: PropTypes.shape({}).isRequired
};

function GoogleWorkspaceSubscriptions(_ref) {
  var strings = _ref.strings;
  return /*#__PURE__*/jsx$1(SubscriptionsTable, {
    strings: strings
  });
}

GoogleWorkspaceSubscriptions.propTypes = propTypes$t;

function _regenerator$w() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$w(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$w(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$w(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$w(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$w(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$w(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$w(u), _regeneratorDefine2$w(u, o, "Generator"), _regeneratorDefine2$w(u, n, function () {
    return this;
  }), _regeneratorDefine2$w(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$w = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$w(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$w = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$w(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$w(e, r, n, t);
}

var track = function track(data) {
  trackEvent({
    event: 'InfoCollector',
    data: data
  });
};

function InfoCollectorEmbed(_ref) {
  var errorMessage = _ref.errorMessage,
      successMessage = _ref.successMessage,
      title = _ref.title,
      source = _ref.source,
      fields = _ref.fields;

  var _useModal = useModal(),
      containerRef = _useModal.containerRef;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      success = _useState2[0],
      setSuccess = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray$4(_useState3, 2),
      error = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray$4(_useState5, 2),
      submitting = _useState6[0],
      setSubmitting = _useState6[1];

  var url = "".concat(marketingEndpoint, "/web-form/").concat(source);

  var submitHandler = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$w().m(function _callee(info) {
      var urlParams, handleErrorResponse, _yield$post, data;

      return _regenerator$w().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              setSubmitting(true);
              setErrorMessage('');
              info.reseller = RESELLER;
              urlParams = queryString.parse(window.location.search);

              if (urlParams.utm_campaign) {
                info.utm_campaign = urlParams.utm_campaign;
              }

              if (urlParams.utm_source) {
                info.utm_source = urlParams.utm_source;
              }

              if (urlParams.utm_medium) {
                info.utm_medium = urlParams.utm_medium;
              }

              if (urlParams.utm_content) {
                info.utm_content = urlParams.utm_content;
              }

              handleErrorResponse = function handleErrorResponse(responseErrorMessage) {
                setErrorMessage(responseErrorMessage);
              };

              _context.p = 1;
              _context.n = 2;
              return post$1(url, info, {
                dontSetAuthorizationHeader: true
              });

            case 2:
              _yield$post = _context.v;
              data = _yield$post.data;

              if (data.success) {
                track({
                  type: 'submit',
                  embed: 'yes'
                });
                setSubmitting(false);
                setErrorMessage('');
                setSuccess(true);
              } else {
                handleErrorResponse(data.message);
              }

              _context.n = 4;
              break;

            case 3:
              _context.p = 3;
              handleErrorResponse(errorMessage);
              setSubmitting(false);

            case 4:
              return _context.a(2);
          }
        }
      }, _callee, null, [[1, 3]]);
    }));

    return function submitHandler(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/jsxs(ErrorBoundary, {
    location: "info-collector",
    children: [success && /*#__PURE__*/jsx$1(Box$1, {
      alignItems: "center",
      justifyContent: "center",
      children: /*#__PURE__*/jsxs(Text$1, {
        fontSize: 4,
        children: [successMessage, " "]
      })
    }), !success && /*#__PURE__*/jsx$1(InfoCollector$1, {
      containerRef: containerRef,
      errorMessage: error,
      fields: fields,
      isSubmitting: submitting,
      submitHandler: submitHandler,
      title: title,
      source: source
    })]
  });
}

var InfoCollector = InfoCollectorModal;

function _regenerator$v() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$v(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$v(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$v(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$v(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$v(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$v(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$v(u), _regeneratorDefine2$v(u, o, "Generator"), _regeneratorDefine2$v(u, n, function () {
    return this;
  }), _regeneratorDefine2$v(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$v = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$v(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$v = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$v(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$v(e, r, n, t);
}

var MyAccountDashboard = storageKeys.MyAccountDashboard; // Stored States

var DISMISSED_SETUP_PROGRESS = 'dismissed-setup-progress';
var preferences = {
  DISMISSED_SETUP_PROGRESS: DISMISSED_SETUP_PROGRESS
}; // Dismissed setup progress

var getDimissedSetupProgress = function getDimissedSetupProgress(domain) {
  var currentMyAccountDashboard = LS.getItem(MyAccountDashboard);
  return get$5(currentMyAccountDashboard, "".concat(DISMISSED_SETUP_PROGRESS, ".").concat(domain), false);
};

var setDismissedSetupProgress = function setDismissedSetupProgress(domain) {
  var newMyAccountDashboard = LS.getItem(MyAccountDashboard);
  set$2(newMyAccountDashboard, "".concat(DISMISSED_SETUP_PROGRESS, ".").concat(domain.replace(/\./g, '')), true);
  LS.setItem(MyAccountDashboard, newMyAccountDashboard);
}; // Open/Closed Accordions


var getOpenDomains = function getOpenDomains(domain) {
  var currentMyAccountDashboard = LS.getItem(MyAccountDashboard); // If array is empty

  if (!currentMyAccountDashboard) {
    return false;
  } // If domain is in array


  if (currentMyAccountDashboard.find(function (d) {
    return d === domain.replace(/\./g, '');
  })) {
    return true;
  }

  return false;
}; // Updates local storage
// Regex removing periods for domains since it was doing weird object creation


var setOpenDomain = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$v().m(function _callee(domain) {
    var newMyAccountDashboard, openDomains;
    return _regenerator$v().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            newMyAccountDashboard = LS.getItem(MyAccountDashboard); // If empty -> create new array with domain

            if (!newMyAccountDashboard) {
              openDomains = [domain.replace(/\./g, '')];
            } // If domain array currently contains an instance of type, filter out the matching domain
            else if (newMyAccountDashboard.indexOf(domain.replace(/\./g, '')) !== -1) {
              openDomains = newMyAccountDashboard.filter(function (d) {
                return d !== domain.replace(/\./g, '');
              });
            } // If populated array + domain is not in the array -> Push the domain name to the array
            else {
              openDomains = newMyAccountDashboard;
              openDomains.push(domain.replace(/\./g, ''));
            }

            LS.setItem(MyAccountDashboard, openDomains);

          case 1:
            return _context.a(2);
        }
      }
    }, _callee);
  }));

  return function setOpenDomain(_x) {
    return _ref.apply(this, arguments);
  };
}(); // My Account Dashboard


var removeMyAccountDashboard = function removeMyAccountDashboard() {
  LS.removeItem(MyAccountDashboard);
};

var MyAccountDashboardService = {
  getDimissedSetupProgress: getDimissedSetupProgress,
  preferences: preferences,
  removeMyAccountDashboard: removeMyAccountDashboard,
  setDismissedSetupProgress: setDismissedSetupProgress,
  getOpenDomains: getOpenDomains,
  setOpenDomain: setOpenDomain
};
var colors$h = theme.colors;
var propTypes$s = {
  isOpen: PropTypes.bool.isRequired
};
var ContentPane = motion.custom(styled.div.withConfig({
  displayName: "accordion-item-content__ContentPane",
  componentId: "sc-g0yy7y-0"
})(["overflow:hidden;background-color:", ";width:100%;"], colors$h.whiteDark));
var paneVariants$3 = {
  visible: {
    opacity: 1,
    height: 'auto'
  },
  hidden: {
    opacity: 0,
    height: '0px'
  }
}; // eslint-disable-next-line react/prop-types

function AccordionItemContent(_ref) {
  var isOpen = _ref.isOpen,
      children = _ref.children;
  return /*#__PURE__*/jsx$1(ContentPane, {
    animate: isOpen ? 'visible' : 'hidden',
    bg: "white",
    overflow: "hidden",
    transition: {
      opacity: {
        duration: 0.1
      },
      height: {
        duration: 0.2
      }
    },
    variants: paneVariants$3,
    width: "100%",
    children: children
  });
}

AccordionItemContent.propTypes = propTypes$s;
var _RECOVERY_PERIOD = 40;

var getDomainStatusTypes$1 = function getDomainStatusTypes() {
  var domainStatusTypes = {
    active: 'Active',
    expired: 'Expired',
    redemption: 'Redemption Grace Period',
    deleted: 'User Deleted',
    gone: 'gone'
  };
  return domainStatusTypes;
}; // calculate days until domain expiry


function getDaysTillExpiry(expiryDate) {
  var _MS_PER_DAY = 1000 * 60 * 60 * 24;

  var utcExpiry = Date.parse(expiryDate);

  var daysTilExpiry = (utcExpiry - Date.now()) / _MS_PER_DAY; // special case for when we are on the last day of pre-expiry, the milliseconds were causing things to show wrong


  daysTilExpiry = daysTilExpiry > -1 && daysTilExpiry < 0 ? Math.ceil(daysTilExpiry) : Math.floor(daysTilExpiry);
  return daysTilExpiry;
} // if domain is in its active phase


function domainIsNotExpired(expiryDate) {
  return getDaysTillExpiry(expiryDate) >= 0;
} // if domain is in its expiry phase


function withinExpiryPeriod(expiryDate) {
  var daysTilExpiry = getDaysTillExpiry(expiryDate);
  return Math.abs(daysTilExpiry) < _RECOVERY_PERIOD;
} // if domain has exceeded both active AND expiry phase


function exceededExpiryPeriod(expiryDate) {
  if (domainIsNotExpired(expiryDate)) {
    return false;
  }

  if (withinExpiryPeriod(expiryDate)) {
    return false;
  }

  return true;
}

var isDomainIndeedActive = function isDomainIndeedActive(status, expiry) {
  return (
    /* this function checks if the domain state says 'Active'
      it also ensures the expiry date is not exceeded */
    status === getDomainStatusTypes$1().active && domainIsNotExpired(expiry)
  );
};

var isDomainIndeedExpired = function isDomainIndeedExpired(status, expiry) {
  return (
    /* this function checks if the domain state says 'Active'
        it also ensures the expiry date is not exceeded */
    status === getDomainStatusTypes$1().expired && withinExpiryPeriod(expiry)
  );
};

function _regenerator$u() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$u(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$u(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$u(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$u(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$u(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$u(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$u(u), _regeneratorDefine2$u(u, o, "Generator"), _regeneratorDefine2$u(u, n, function () {
    return this;
  }), _regeneratorDefine2$u(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$u = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$u(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$u = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$u(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$u(e, r, n, t);
}

var getAddOnKeys = function getAddOnKeys() {
  var addOnKeys = {
    domainRegistration: {
      key: 'domainRegistration',
      name: 'Domain Registration'
    },
    weeblySite: {
      key: 'weeblySite',
      name: 'Weebly Site Builder'
    },
    webHosting: {
      key: 'webHosting',
      name: 'Web Hosting'
    },
    emailHosting: {
      key: 'emailHosting',
      name: 'Email Hosting'
    },
    sslCertificate: {
      key: 'sslCertificate',
      name: 'SSL Certificate'
    },
    privacyProtection: {
      key: 'privacyProtection',
      name: 'Privacy Protection'
    },
    expiryProtection: {
      key: 'expiryProtection',
      name: 'Expiry Protection'
    },
    ownershipProtection: {
      key: 'ownershipProtection',
      name: 'Ownership Protection'
    },
    seoTools: {
      key: 'seoTools',
      name: 'SEO Tools'
    }
  };
  return addOnKeys;
};

var getAddOn = function getAddOn(addOnKey, domainItem) {
  var userAddOn = domainItem.addOns.find(function (domainAddOn) {
    return domainAddOn.key === addOnKey;
  });
  return userAddOn;
};

var getSimpleEmail = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$u().m(function _callee(subscriptionId) {
    var response, _t;

    return _regenerator$u().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return get$3(simpleEmailLoginLink(subscriptionId));

          case 1:
            response = _context.v;

            if (!(response.status === 200)) {
              _context.n = 2;
              break;
            }

            return _context.a(2, response.data);

          case 2:
            return _context.a(2, null);

          case 3:
            _context.p = 3;
            _t = _context.v;
            console.error(_t);
            return _context.a(2, null);
        }
      }
    }, _callee, null, [[0, 3]]);
  }));

  return function getSimpleEmail(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getEmailLoginLink = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$u().m(function _callee2(domainItem) {
    var _getAddOn, emailType, loginLink, _t2;

    return _regenerator$u().w(function (_context2) {
      while (1) {
        switch (_context2.n) {
          case 0:
            _getAddOn = getAddOn(getAddOnKeys().emailHosting.key, domainItem), emailType = _getAddOn.emailType;

            if (emailType) {
              _context2.n = 1;
              break;
            }

            return _context2.a(2, null);

          case 1:
            if (!emailType.isCloud) {
              _context2.n = 2;
              break;
            }

            return _context2.a(2, '/my-account/email-manager');

          case 2:
            if (!emailType.isSimple) {
              _context2.n = 4;
              break;
            }

            _context2.n = 3;
            return getSimpleEmail(emailType.subscriptionID);

          case 3:
            _t2 = _context2.v;
            _context2.n = 5;
            break;

          case 4:
            _t2 = '/my-account/google-workspace';

          case 5:
            loginLink = _t2;
            return _context2.a(2, loginLink);
        }
      }
    }, _callee2);
  }));

  return function getEmailLoginLink(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var getSEOLoginLink = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator$u().m(function _callee3(domainItem) {
    var _getAddOn2, hasSEO, response, _t3;

    return _regenerator$u().w(function (_context3) {
      while (1) {
        switch (_context3.n) {
          case 0:
            _context3.p = 0;
            hasSEO = (_getAddOn2 = getAddOn(getAddOnKeys().seoTools.key, domainItem)) === null || _getAddOn2 === void 0 ? void 0 : _getAddOn2.status;

            if (hasSEO) {
              _context3.n = 1;
              break;
            }

            return _context3.a(2, null);

          case 1:
            _context3.n = 2;
            return get$3(getMarketgooLoginEndpoint(domainItem.id));

          case 2:
            response = _context3.v;

            if (!(response.status === 200 && response.data.success)) {
              _context3.n = 3;
              break;
            }

            return _context3.a(2, response.data.result);

          case 3:
            return _context3.a(2, null);

          case 4:
            _context3.p = 4;
            _t3 = _context3.v;
            console.error(_t3);
            return _context3.a(2, null);
        }
      }
    }, _callee3, null, [[0, 4]]);
  }));

  return function getSEOLoginLink(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

var getDomainStatusTypes = function getDomainStatusTypes() {
  var domainStatusTypes = {
    active: 'Active',
    expired: 'Expired',
    redemption: 'Redemption Grace Period',
    deleted: 'User Deleted',
    gone: 'gone',
    backorder: 'Back Order Application Submitted'
  };
  return domainStatusTypes;
};

var getEmailValue = function getEmailValue(email) {
  if (email) {
    if (email.cloudEmail) {
      return 'Cloud Email';
    }

    if (email.googleWorkspace) {
      return email.googleWorkspace.defaultItemCode === 'GW_STARTER' ? 'Google Workspace Starter' : 'Google Workspace Business';
    }

    if (email.simpleEmail) {
      return 'Simple Email';
    }
  }

  return "Add an email package";
};

var getEmailType = function getEmailType(email) {
  if (email) {
    if (email.cloudEmail) {
      return {
        isSimple: false,
        isCloud: true
      };
    }

    if (email.googleWorkspace) {
      return {
        isSimple: false,
        isCloud: false,
        subscriptionID: null
      };
    }

    if (email.simpleEmail) {
      return {
        isSimple: true,
        isCloud: false,
        subscriptionID: email.simpleEmail.SubscriptionID,
        EmailUsage: email.simpleEmail.Usage,
        EmailUsageLimit: email.simpleEmail.UsageLimit
      };
    }
  }

  return null;
};

var getHostingValue = function getHostingValue(hosting) {
  if (hosting) {
    return hosting.PackageName;
  }

  return "Add a hosting package";
};

var getWeeblyPackage = function getWeeblyPackage(weebly) {
  if (weebly) {
    return weebly.packageName;
  }

  return null;
};

function getRecoveryInfo(expiryDate, strings) {
  // Finnicky -> requires current to be a Date object
  var _MS_PER_DAY = 1000 * 60 * 60 * 24;

  var _RECOVERY_PERIOD = 40;
  var _ADVANCED_RECOVERY_PERIOD = 30;
  var utcExpiry = Date.parse(expiryDate);

  var daysTilExpiry = (utcExpiry - Date.now()) / _MS_PER_DAY; // special case for when we are on the last day of pre-expiry, the milliseconds were causing things to show wrong


  daysTilExpiry = daysTilExpiry > -1 && daysTilExpiry < 0 ? Math.ceil(daysTilExpiry) : Math.floor(daysTilExpiry);
  var recoveryInfo = {
    phase: null,
    message: null
  };

  if (daysTilExpiry >= 0) {
    /* If domain has not expired yet */
    recoveryInfo.phase = getDomainStatusTypes().active;
    recoveryInfo.message = "This domain has not reached its expiry date yet.";
  } else if (Math.abs(daysTilExpiry) < _RECOVERY_PERIOD) {
    /* If domain is in expired phase (first 40 days after expiry) */
    var countdown = _RECOVERY_PERIOD - Math.abs(daysTilExpiry);

    recoveryInfo.phase = getDomainStatusTypes().expired;
    recoveryInfo.message = strings.domainRecovery(countdown);
  } else if (Math.abs(daysTilExpiry) < _RECOVERY_PERIOD + _ADVANCED_RECOVERY_PERIOD) {
    /* If domain is in redemption phase (30 days after expired phase) */
    var _countdown = _ADVANCED_RECOVERY_PERIOD + _RECOVERY_PERIOD - Math.abs(daysTilExpiry);

    recoveryInfo.phase = getDomainStatusTypes().redemption;
    recoveryInfo.message = strings.domainRedemption(_countdown);
  } else {
    /* Beyond redemption grace Period  */
    recoveryInfo.phase = getDomainStatusTypes().gone;
    recoveryInfo.message = "This domain has exceeded its redemption grace period.";
  }

  return recoveryInfo;
}

var sortObjects = function sortObjects(objects, sortKey) {
  var newObject = _toConsumableArray$1(objects);

  var direction = sortKey.isAscending ? 1 : -1; // sort for addons active

  if (newObject[0] && Array.isArray(newObject[0][sortKey.key])) {
    return newObject.sort(function (a, b) {
      return (// eslint-disable-next-line no-nested-ternary
        _.sumBy(a[sortKey.key], function (addon) {
          return addon.status ? 1 : 0;
        }) > _.sumBy(b[sortKey.key], function (addon) {
          return addon.status ? 1 : 0;
        }) ? direction : _.sumBy(b[sortKey.key], function (addon) {
          return addon.status ? 1 : 0;
        }) > _.sumBy(a[sortKey.key], function (addon) {
          return addon.status ? 1 : 0;
        }) ? -direction : 0
      );
    });
  }

  return newObject.sort(function (a, b) {
    return (// eslint-disable-next-line no-nested-ternary
      a[sortKey.key] > b[sortKey.key] ? direction : b[sortKey.key] > a[sortKey.key] ? -direction : 0
    );
  });
};

function _regenerator$t() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$t(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$t(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$t(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$t(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$t(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$t(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$t(u), _regeneratorDefine2$t(u, o, "Generator"), _regeneratorDefine2$t(u, n, function () {
    return this;
  }), _regeneratorDefine2$t(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$t = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$t(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$t = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$t(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$t(e, r, n, t);
} // TDL: remove these in the future and have each addon have dynamic icons


var ACTIVE_ICON = 'checkmark-fill';
var INACTIVE_ICON = 'broken-link';

var composeSubText = function composeSubText(addOnKey, description) {
  var domainItem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (!domainItem) {
    return description;
  }

  var addOn = getAddOn(addOnKey, domainItem);
  var subText = addOn.status ? "Activated Package: ".concat(addOn.specificValue) : description;
  return subText;
};

var composeUsageSubText = function composeUsageSubText(addOnKey) {
  var _addOn$emailType, _addOn$emailType2, _addOn$emailType3;

  var domainItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!domainItem) {
    return "";
  }

  var addOn = getAddOn(addOnKey, domainItem);

  if (!((_addOn$emailType = addOn.emailType) !== null && _addOn$emailType !== void 0 && _addOn$emailType.EmailUsageLimit) || addOn.emailType.EmailUsageLimit === 0) {
    return "";
  }

  return "Usage: ".concat((_addOn$emailType2 = addOn.emailType) === null || _addOn$emailType2 === void 0 ? void 0 : _addOn$emailType2.EmailUsage, " / ").concat((_addOn$emailType3 = addOn.emailType) === null || _addOn$emailType3 === void 0 ? void 0 : _addOn$emailType3.EmailUsageLimit, " GB");
};

var getBaseAddOns = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$t().m(function _callee(strings) {
    var domainItem,
        _args = arguments;
    return _regenerator$t().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            domainItem = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
            return _context.a(2, [{
              key: getAddOnKeys().webHosting.key,
              name: getAddOnKeys().webHosting.name,
              mainText: strings.webHosting,
              subText: composeSubText(getAddOnKeys().webHosting.key, strings.webHostingSubtext, domainItem),
              activeIcon: ACTIVE_ICON,
              inactiveIcon: INACTIVE_ICON,
              itemCode: 'PPMANAGEDWORDPRESSBASE1',
              activeLinks: domainItem ? [{
                isEndpoint: false,
                href: '/MyAccount/HostingPackages.aspx',
                text: 'Manage Hosting',
                variant: 'link'
              }] : [],
              inactiveLinks: [{
                isEndpoint: false,
                href: '/hosting-overview',
                text: strings.buyNow,
                variant: 'solid'
              }]
            }]);
        }
      }
    }, _callee);
  }));

  return function getBaseAddOns(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getNoDomainSteps = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$t().m(function _callee2(strings) {
    var baseAddOns, addOns;
    return _regenerator$t().w(function (_context2) {
      while (1) {
        switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return getBaseAddOns(strings);

          case 1:
            baseAddOns = _context2.v;
            addOns = {
              title: strings.noDomainSectionTitle,
              description: strings.noDomainSectionDescription,
              ariaText: strings.noDomainSectionAria,
              addOns: [{
                key: getAddOnKeys().domainRegistration.key,
                name: getAddOnKeys().domainRegistration.name,
                mainText: strings.domainRegistration,
                subText: strings.noDomainRegistrationSectionDescription,
                activeIcon: ACTIVE_ICON,
                inactiveIcon: INACTIVE_ICON,
                itemCode: '',
                activeLinks: [],
                inactiveLinks: [{
                  isEndpoint: false,
                  href: "/search",
                  text: 'Search Domains',
                  variant: 'solid'
                }]
              }].concat(_toConsumableArray$1(baseAddOns.reverse()), [{
                // Isn't an addon with a definitive price, it just navigates user to the hosting migration page to learn more
                key: strings.hostingMigration,
                name: strings.hostingMigration,
                mainText: strings.hostingMigration,
                subText: strings.hostingMigrationsSubtext,
                activeIcon: ACTIVE_ICON,
                inactiveIcon: INACTIVE_ICON,
                itemCode: '',
                activeLinks: [],
                inactiveLinks: [{
                  isEndpoint: false,
                  href: "/hosting-migration",
                  text: 'Learn More',
                  variant: 'solid'
                }]
              }])
            };
            return _context2.a(2, addOns);
        }
      }
    }, _callee2);
  }));

  return function getNoDomainSteps(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

var getSetupSteps = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator$t().m(function _callee3(domainItem, strings) {
    var seoLoginLink, emailLoginLink, baseAddOns, setupSteps;
    return _regenerator$t().w(function (_context3) {
      while (1) {
        switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return getSEOLoginLink(domainItem);

          case 1:
            seoLoginLink = _context3.v;
            _context3.n = 2;
            return getEmailLoginLink(domainItem);

          case 2:
            emailLoginLink = _context3.v;
            _context3.n = 3;
            return getBaseAddOns(strings, domainItem);

          case 3:
            baseAddOns = _context3.v;
            setupSteps = [{
              title: strings.setupSectionTitle,
              description: strings.setupSectionDescription,
              ariaText: strings.setupSectionAria,
              addOns: [{
                key: getAddOnKeys().domainRegistration.key,
                name: getAddOnKeys().domainRegistration.name,
                mainText: strings.domainRegistration,
                subText: domainItem.name,
                activeIcon: ACTIVE_ICON,
                inactiveIcon: INACTIVE_ICON,
                itemCode: '',
                activeLinks: [{
                  isEndpoint: false,
                  href: "/MyAccount/DomainDetails.aspx?tab=0&domain=".concat(domainItem.name),
                  text: 'Domain Settings',
                  variant: 'link'
                }, {
                  isEndpoint: false,
                  href: "/MyAccount/DomainDetails.aspx?tab=1&domain=".concat(domainItem.name),
                  text: 'Manage DNS',
                  variant: 'link'
                }],
                inactiveLinks: []
              }].concat(_toConsumableArray$1(baseAddOns), [{
                key: getAddOnKeys().emailHosting.key,
                name: getAddOnKeys().emailHosting.name,
                mainText: strings.emailHosting,
                subText: composeSubText(getAddOnKeys().emailHosting.key, strings.emailHostingSubtext, domainItem),
                usageSubText: composeUsageSubText(getAddOnKeys().emailHosting.key, domainItem),
                activeIcon: ACTIVE_ICON,
                inactiveIcon: INACTIVE_ICON,
                itemCode: 'CLOUD_BASIC',
                activeLinks: domainItem ? [{
                  isEndpoint: false,
                  href: emailLoginLink,
                  text: 'Manage',
                  variant: 'link'
                }] : [],
                inactiveLinks: [{
                  isEndpoint: false,
                  href: "/my-account/email/buy?domain=".concat(domainItem.name, "&itemCode=CLOUD_SEC"),
                  text: strings.buyNow,
                  variant: 'solid'
                }]
              }])
            }, {
              title: strings.protectionSectionTitle,
              description: strings.protectionSectionDescription,
              ariaText: strings.protectionSectionAria,
              addOns: [{
                key: getAddOnKeys().sslCertificate.key,
                name: getAddOnKeys().sslCertificate.name,
                mainText: strings.sslCertificate,
                subText: strings.sslCertificateSubtext,
                activeIcon: ACTIVE_ICON,
                inactiveIcon: INACTIVE_ICON,
                itemCode: 'SSLALPHADOMAIN2',
                activeLinks: [{
                  isEndpoint: false,
                  href: '/MyAccount/SSLManager.aspx',
                  text: 'Manage SSL',
                  variant: 'link'
                }],
                inactiveLinks: [{
                  isEndpoint: false,
                  href: '/ssl-certificates',
                  text: strings.buyNow,
                  variant: 'solid'
                }]
              }, {
                key: getAddOnKeys().privacyProtection.key,
                name: getAddOnKeys().privacyProtection.name,
                mainText: strings.privacyProtection,
                subText: strings.privacyProtectionSubtext,
                activeIcon: ACTIVE_ICON,
                inactiveIcon: INACTIVE_ICON,
                itemCode: 'PRIVACY',
                activeLinks: [{
                  isEndpoint: true,
                  href: getPrivacyProtectionEndpoint(),
                  text: 'Remove Privacy Protection',
                  variant: 'link'
                }],
                inactiveLinks: [{
                  isEndpoint: true,
                  href: getPrivacyProtectionEndpoint(),
                  text: strings.buyNow,
                  variant: 'solid'
                }]
              }, {
                key: getAddOnKeys().expiryProtection.key,
                name: getAddOnKeys().expiryProtection.name,
                mainText: strings.expiryProtection,
                subText: strings.expiryProtectionSubtext,
                activeIcon: ACTIVE_ICON,
                inactiveIcon: INACTIVE_ICON,
                itemCode: 'DMEXPINSURANCE',
                activeLinks: [{
                  isEndpoint: true,
                  href: getExpiryProtectionEndpoint(),
                  text: 'Remove Expiry Protection',
                  variant: 'link'
                }],
                inactiveLinks: [{
                  isEndpoint: true,
                  href: getExpiryProtectionEndpoint(),
                  text: strings.buyNow,
                  variant: 'solid'
                }]
              }, {
                key: getAddOnKeys().ownershipProtection.key,
                name: getAddOnKeys().ownershipProtection.name,
                mainText: strings.ownershipProtection,
                subText: strings.ownershipProtectionSubtext,
                activeIcon: ACTIVE_ICON,
                inactiveIcon: INACTIVE_ICON,
                itemCode: 'DMLOCK',
                activeLinks: [{
                  isEndpoint: false,
                  href: 'https://s3.amazonaws.com/rebel.com/protection/Request+to+Cancel+Ownership+Protection+Form.pdf',
                  text: 'Remove Ownership Protection',
                  variant: 'link'
                }],
                inactiveLinks: [{
                  isEndpoint: true,
                  href: getOwnershipProtectionEndpoint(),
                  text: strings.buyNow,
                  variant: 'solid'
                }]
              }]
            }, {
              title: strings.seoSectionTitle,
              description: strings.seoSectionDescription,
              ariaText: strings.seoSectionAria,
              addOns: [{
                key: getAddOnKeys().seoTools.key,
                name: getAddOnKeys().seoTools.name,
                mainText: strings.seoTools,
                subText: strings.seoToolsSubtext,
                activeIcon: ACTIVE_ICON,
                inactiveIcon: INACTIVE_ICON,
                itemCode: 'MARKETGOOPRO',
                activeLinks: [{
                  isEndpoint: false,
                  href: seoLoginLink,
                  text: 'Login',
                  variant: 'link'
                }],
                inactiveLinks: [{
                  isEndpoint: false,
                  href: '/seo-tools/buy',
                  text: strings.buyNow,
                  variant: 'solid'
                }, {
                  isEndpoint: false,
                  href: '/seo-tools',
                  text: strings.learnMore,
                  variant: 'inverse'
                }]
              }]
            }];
            return _context3.a(2, setupSteps);
        }
      }
    }, _callee3);
  }));

  return function getSetupSteps(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();

var propTypes$r = {
  displayRenewal: PropTypes.bool.isRequired,
  price: PropTypes.shape({
    regular: PropTypes.number,
    renew: PropTypes.number,
    sale: PropTypes.number
  }).isRequired
};

function PriceDisplay(_ref) {
  var price = _ref.price,
      displayRenewal = _ref.displayRenewal;

  if (price) {
    var regular = price.regular,
        renew = price.renew,
        sale = price.sale;

    if (regular) {
      return /*#__PURE__*/jsx$1(Text$1, {
        ml: 1,
        textAlign: ['center', 'left', 'left'],
        variant: "mega",
        children: regular === 0 ? "- Starting at Free" : "- Starting at $".concat(sale.toFixed(2) || regular.toFixed(2), " ").concat(displayRenewal ? "(renews at $".concat(renew.toFixed(2), ")") : "")
      });
    }
  }

  return null;
}

PriceDisplay.propTypes = propTypes$r;
var _excluded$a = ["domainId", "addOn", "initialIsActive", "onClose", "name", "addonPrices", "displayRenewal"];

function ownKeys$v(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$v(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$v(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$v(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var colors$g = redesignTheme.colors;
var propTypes$q = {
  addOn: PropTypes.shape({
    activeIcon: PropTypes.string.isRequired,
    activeLinks: PropTypes.arrayOf(PropTypes.shape({
      href: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      variant: PropTypes.string.isRequired
    })),
    inactiveIcon: PropTypes.string.isRequired,
    inactiveLinks: PropTypes.arrayOf(PropTypes.shape({
      href: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      variant: PropTypes.string.isRequired
    })),
    isActive: PropTypes.bool,
    itemCode: PropTypes.string,
    key: PropTypes.string.isRequired,
    mainText: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    subText: PropTypes.string.isRequired
  }).isRequired,
  addonPrices: PropTypes.array.isRequired,
  description: PropTypes.string,
  displayRenewal: PropTypes.bool,
  domainId: PropTypes.number.isRequired,
  initialIsActive: PropTypes.bool.isRequired,
  links: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    variant: PropTypes.string.isRequired
  })),
  name: PropTypes.string.isRequired,
  onClose: PropTypes.bool,
  title: PropTypes.string
};
var defaultProps$a = {
  description: '',
  displayRenewal: true,
  links: [],
  onClose: false,
  title: ''
};

var sendTracker = function sendTracker(type, data) {
  if (type === 'activation') {
    tracker$1('MyAccount', {
      type: 'dashboard-activation',
      success: data.success,
      addOn: data.addOn,
      action: data.action,
      domain: data.domain
    });
  }

  if (type === 'redirect') {
    tracker$1('MyAccount', {
      type: 'dashboard-redirect',
      addOn: data.addOn,
      action: 'Redirect',
      domain: data.domain
    });
  }
};

function Segment(_ref) {
  var domainId = _ref.domainId,
      addOn = _ref.addOn,
      initialIsActive = _ref.initialIsActive,
      onClose = _ref.onClose,
      name = _ref.name,
      addonPrices = _ref.addonPrices,
      displayRenewal = _ref.displayRenewal,
      rest = _objectWithoutProperties$8(_ref, _excluded$a);

  var _useState = useState(initialIsActive),
      _useState2 = _slicedToArray$4(_useState, 2),
      isActive = _useState2[0],
      setIsActive = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray$4(_useState3, 2),
      requestIsLoading = _useState4[0],
      setRequestIsLoading = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray$4(_useState5, 2),
      confirmationMode = _useState6[0],
      setConfirmationMode = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray$4(_useState7, 2),
      message = _useState8[0],
      setMessage = _useState8[1];

  var _useState9 = useState(false),
      _useState0 = _slicedToArray$4(_useState9, 2),
      requestSuccessful = _useState0[0],
      setRequestSuccessful = _useState0[1];

  var _useState1 = useState(),
      _useState10 = _slicedToArray$4(_useState1, 2),
      price = _useState10[0],
      setPrice = _useState10[1];

  var _useSessionService = useSessionService(),
      currentCurrency = _useSessionService.data.currentCurrency;

  var links = isActive ? addOn.activeLinks : addOn.inactiveLinks;
  var icon = isActive ? {
    name: addOn.activeIcon,
    color: "".concat(isInternic ? 'blueDark' : 'green')
  } : {
    name: addOn.inactiveIcon,
    color: colors$g.greyLightish
  };
  var messageTypes = {
    requestFailure: 'requestFailure',
    confirmActivation: 'confirmActivation',
    confirmDeactivation: 'confirmDeactivation'
  };

  var composeMessage = function composeMessage(msgType, addOnName) {
    var msg;
    var verb = isActive ? 'deactivate' : 'activate';

    switch (msgType) {
      case messageTypes.requestFailure:
        msg = "Something happened while trying to ".concat(verb, " ").concat(addOnName, " on your domain");
        break;

      case messageTypes.confirmActivation:
        msg = "Click \"".concat(verb, "\" to enable ").concat(addOnName, " and we'll send you an invoice");
        break;

      case messageTypes.confirmDeactivation:
        msg = "Are you sure you want to ".concat(verb, " ").concat(addOnName, " on your domain?");
        break;

      default:
        msg = null;
    }

    return msg;
  };

  var makeToggleRequest = function makeToggleRequest(endpoint) {
    var addOnName;

    try {
      setRequestIsLoading(true);
      setMessage("Please wait, we're processing your request..."); // eslint-disable-next-line promise/prefer-await-to-then

      post$1(endpoint, {
        domainId: domainId
      }).then(function (response) {
        addOnName = response.addOn;
        setRequestIsLoading(false);
        setMessage(response.data.message);
        sendTracker('activation', response.data);

        if (response.data.success) {
          setIsActive(!isActive);
          setRequestSuccessful(true);
        }

        setConfirmationMode(false);
      });
    } catch (error) {
      setRequestIsLoading(false);
      setRequestSuccessful(false);
      setMessage(composeMessage(messageTypes.requestFailure, addOnName));
      setConfirmationMode(false);
    }
  };

  var getConfirmationStyle = function getConfirmationStyle() {
    if (isActive) {
      return {
        color: 'red',
        text: 'Yes, Deactivate!',
        variant: 'solid'
      };
    }

    return {
      color: 'green',
      text: 'Activate',
      variant: 'solid'
    };
  };

  var handleOnClick = function handleOnClick(endpoint) {
    if (confirmationMode) {
      makeToggleRequest(endpoint);
    } else {
      var msgType = isActive ? messageTypes.confirmDeactivation : messageTypes.confirmActivation;
      setConfirmationMode(true);
      setMessage(composeMessage(msgType, addOn.name));
    }
  };

  useEffect(function () {
    var tempPrice = addonPrices.find(function (addonPrice) {
      return addonPrice.itemCode === addOn.itemCode;
    });

    if (tempPrice) {
      setPrice(getCurrentPrice(addonPrices.find(function (addonPrice) {
        return addonPrice.itemCode === addOn.itemCode;
      }).prices, currentCurrency.code.toUpperCase() || 'CAD'));
    }
  }, [addonPrices, addOn.itemCode, currentCurrency]);
  return /*#__PURE__*/jsxs(Stack$2, _objectSpread$v(_objectSpread$v({
    border: isActive ? "1.5px solid ".concat(isInternic ? 'blue' : colors$g.mintGreenLight) : "1.5px solid ".concat(colors$g.greyLight)
  }, rest), {}, {
    children: [onClose && /*#__PURE__*/jsx$1(Box$1, {
      justifyContent: "flex-end",
      width: "100%",
      children: /*#__PURE__*/jsx$1(Button$1, {
        color: "black",
        height: "3rem",
        mt: 2,
        mx: 2,
        variant: "minimal",
        width: "3rem",
        children: /*#__PURE__*/jsx$1(Icon$2, {
          height: "100%",
          name: "close",
          onClick: onClose,
          title: "back",
          width: "100%"
        })
      })
    }), /*#__PURE__*/jsxs(Grid$1, {
      alignSelf: "center",
      gridGap: [0, 2],
      gridTemplateColumns: icon ? ['1fr', '0fr 2fr 1fr '] : ['1fr', '3fr 1fr'],
      px: onClose ? 4 : null,
      width: 1,
      children: [/*#__PURE__*/jsx$1(Box$1, {
        alignSelf: "center",
        justifyContent: ['center', 'center', 'flex-end'],
        my: [3, 3, 0],
        children: icon && /*#__PURE__*/jsx$1(Icon$2, {
          color: icon.color,
          height: "4rem",
          mx: 3,
          name: icon.name,
          title: "back",
          width: "4rem"
        })
      }), /*#__PURE__*/jsxs(Stack$2, {
        alignSelf: "center",
        children: [/*#__PURE__*/jsxs(Box$1, {
          alignItems: "baseline",
          display: ['block', 'flex'],
          justifyContent: ['center', 'normal'],
          mt: 2,
          children: [/*#__PURE__*/jsx$1(Heading, {
            textAlign: ['center', 'left', 'left'],
            variant: "megaBold",
            children: addOn.mainText
          }), isActive ? null : /*#__PURE__*/jsx$1(PriceDisplay, {
            displayRenewal: displayRenewal,
            price: price
          })]
        }), /*#__PURE__*/jsx$1(Text$1, {
          mb: 2,
          textAlign: ['center', 'left', 'left'],
          variant: "kilo",
          children: /*#__PURE__*/jsx$1(HtmlBlock, {
            children: addOn.subText
          })
        }), /*#__PURE__*/jsx$1(Text$1, {
          mb: 2,
          textAlign: ['center', 'left', 'left'],
          variant: "kilo",
          children: /*#__PURE__*/jsx$1(HtmlBlock, {
            children: addOn.usageSubText
          })
        }), /*#__PURE__*/jsx$1(Text$1, {
          color: // eslint-disable-next-line no-nested-ternary
          confirmationMode ? null : requestSuccessful ? 'green' : 'red',
          fontWeight: "bold",
          mb: 2,
          textAlign: ['center', 'left', 'left'],
          variant: "kiloBold",
          children: message
        })]
      }), /*#__PURE__*/jsxs(Box$1, {
        alignSelf: "center",
        display: ['flex', 'block', 'flex'],
        justifyContent: ['center', 'center', 'flex-end'],
        children: [links && links.map(function (link, idx) {
          return /*#__PURE__*/jsx$1(Button$1, {
            color: confirmationMode ? getConfirmationStyle().color : 'blueDark',
            disabled: !!requestIsLoading,
            m: 2,
            onClick: function onClick() {
              if (link.isEndpoint) {
                handleOnClick(link.href);
              } else if (link.href) {
                sendTracker('redirect', {
                  addOn: addOn.name,
                  domain: name,
                  href: link.href
                });
                window.open(link.href);
              } else {
                setMessage('Unable to generate target link. Please contact support.');
              }
            },
            variant: confirmationMode ? getConfirmationStyle().variant : link.variant,
            children: /*#__PURE__*/jsx$1(Text$1, {
              variant: "kiloBold",
              children: confirmationMode ? getConfirmationStyle().text : link.text
            })
          }, idx);
        }), confirmationMode && /*#__PURE__*/jsx$1(Button$1, {
          color: "blueDark",
          disabled: !!requestIsLoading,
          m: 2,
          onClick: function onClick() {
            setConfirmationMode(false);
            setMessage(null);
          },
          p: 2,
          variant: "link",
          children: /*#__PURE__*/jsx$1(Text$1, {
            variant: "kiloBold",
            children: "Cancel"
          })
        })]
      })]
    })]
  }));
}

Segment.propTypes = propTypes$q;
Segment.defaultProps = defaultProps$a;

var useAccordion = function useAccordion() {
  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      parentState = _useState2[0],
      setParentState = _useState2[1];

  var toggleParentState = function toggleParentState(allStates, setAllStates) {
    if (Array.isArray(allStates) && allStates.length > 0) {
      setParentState(!parentState);

      var allStatesCopy = _toConsumableArray$1(allStates);

      allStatesCopy.forEach(function (state, index) {
        allStatesCopy[index] = !parentState;
      });
      setAllStates(allStatesCopy);
    }
  };

  var toggleChildState = function toggleChildState(allStates, setAllStates, index) {
    var allStatesCopy = _toConsumableArray$1(allStates);

    allStatesCopy[index] = !allStatesCopy[index];
    setAllStates(allStatesCopy);
  };

  var getChildState = function getChildState(allStates, index) {
    if (Array.isArray(allStates) && allStates.length > 0) {
      return allStates[index];
    }

    return parentState;
  };

  return {
    parentState: parentState,
    toggleParentState: toggleParentState,
    toggleChildState: toggleChildState,
    getChildState: getChildState
  };
};

var colors$f = redesignTheme.colors;
var propTypes$p = {
  addonPrices: PropTypes.array.isRequired,
  allStates: PropTypes.array.isRequired,
  ariaText: PropTypes.string.isRequired,
  domainItem: PropTypes.shape({
    addOns: PropTypes.arrayOf(PropTypes.shape({
      iconName: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      status: PropTypes.bool.isRequired,
      value: PropTypes.string.isRequired
    })),
    expiry: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired
  }).isRequired,
  gridFormat: PropTypes.shape({
    gridGap: PropTypes.array.isRequired,
    gridTemplateColumns: PropTypes.array.isRequired
  }).isRequired,
  index: PropTypes.number.isRequired,
  setAllStates: PropTypes.func.isRequired,
  setupStep: PropTypes.shape({
    addOns: PropTypes.arrayOf(PropTypes.shape({
      activeLinks: PropTypes.arrayOf(PropTypes.shape({
        href: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        variant: PropTypes.string.isRequired
      })),
      inactiveLinks: PropTypes.arrayOf(PropTypes.shape({
        href: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        variant: PropTypes.string.isRequired
      })),
      isActive: PropTypes.bool.isRequired,
      itemCode: PropTypes.string,
      key: PropTypes.string.isRequired,
      mainText: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      subText: PropTypes.string.isRequired
    })),
    ariaText: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  }).isRequired
};
var buttonStyles$1 = css$3(["padding:18px;display:flex;align-items:center;justify-content:flex-start;border:none;outline:none;width:100%;transition:background-color 0.2s ease;background-color:", ";color:", ";&:hover,&:active{background-color:", ";color:", ";}"], colors$f.whiteDark, colors$f.black, isInternic ? colors$f.blueLightest : colors$f.greenLight, colors$f.black);

function SetupAccordionItems(_ref) {
  var setupStep = _ref.setupStep,
      domainItem = _ref.domainItem,
      gridFormat = _ref.gridFormat,
      index = _ref.index,
      allStates = _ref.allStates,
      setAllStates = _ref.setAllStates,
      addonPrices = _ref.addonPrices;

  var _useAccordion = useAccordion(),
      toggleChildState = _useAccordion.toggleChildState,
      getChildState = _useAccordion.getChildState;

  return /*#__PURE__*/jsxs(Stack$2, {
    justifyContent: "center",
    width: "100%",
    children: [/*#__PURE__*/jsxs(_StyledButton$b, {
      mb: 2,
      onClick: function onClick() {
        return toggleChildState(allStates, setAllStates, index);
      },
      py: 3,
      width: "100%",
      children: [/*#__PURE__*/jsx$1(Grid$1, {
        alignSelf: "center",
        gridGap: gridFormat.gridGap,
        gridTemplateColumns: gridFormat.gridTemplateColumns,
        width: 1,
        children: /*#__PURE__*/jsxs(Stack$2, {
          children: [/*#__PURE__*/jsx$1(Heading, {
            fontSize: 1,
            lineHeight: "1.7",
            mb: 2,
            textAlign: "left",
            variant: "gigaBold",
            children: setupStep.title
          }), /*#__PURE__*/jsx$1(Text$1, {
            lineHeight: "1.7",
            textAlign: "left",
            children: setupStep.description
          })]
        })
      }), /*#__PURE__*/jsx$1(ToggleArrowIcon, {
        ariaID: "".concat(domainItem.name, " - ").concat(setupStep.ariaText),
        isOpen: getChildState(allStates, index)
      })]
    }), /*#__PURE__*/jsx$1(AccordionItemContent, {
      isOpen: getChildState(allStates, index),
      children: /*#__PURE__*/jsx$1(Stack$2, {
        width: "100%",
        children: setupStep.addOns.map(function (addOn, idx) {
          // eslint-disable-next-line react/prop-types
          var userAddon = getAddOn(addOn.key, domainItem);
          var isActive = userAddon === null || userAddon === void 0 ? void 0 : userAddon.status;
          return /*#__PURE__*/jsx$1(Segment, {
            addOn: addOn,
            addonPrices: addonPrices,
            backgroundColor: colors$f.white,
            domainId: domainItem.id,
            initialIsActive: isActive,
            mb: 2,
            name: domainItem.name,
            padding: [3, 3, 2]
          }, idx);
        })
      })
    })]
  });
}

SetupAccordionItems.propTypes = propTypes$p;

var _StyledButton$b = styled(Button$1).withConfig({
  displayName: "setup-accordion-items___StyledButton",
  componentId: "sc-1imjthh-0"
})(["", ""], buttonStyles$1);

var _excluded$9 = ["addonPrices", "domainItem", "strings"];

function ownKeys$u(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$u(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$u(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$u(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _regenerator$s() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$s(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$s(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$s(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$s(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$s(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$s(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$s(u), _regeneratorDefine2$s(u, o, "Generator"), _regeneratorDefine2$s(u, n, function () {
    return this;
  }), _regeneratorDefine2$s(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$s = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$s(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$s = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$s(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$s(e, r, n, t);
}

var propTypes$o = {
  addonPrices: PropTypes.array.isRequired,
  domainItem: PropTypes.shape({
    addOns: PropTypes.arrayOf(PropTypes.shape({
      icon: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      status: PropTypes.bool.isRequired,
      value: PropTypes.string.isRequired
    })),
    expiry: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired
  }).isRequired,
  strings: PropTypes.object.isRequired
};
var gridFormat$2 = {
  gridGap: [0, 1],
  gridTemplateColumns: '1fr'
};

function SetupAccordion(_ref) {
  var addonPrices = _ref.addonPrices,
      domainItem = _ref.domainItem,
      strings = _ref.strings,
      rest = _objectWithoutProperties$8(_ref, _excluded$9);

  var _useState = useState([]),
      _useState2 = _slicedToArray$4(_useState, 2),
      setupSteps = _useState2[0],
      setSetupSteps = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray$4(_useState3, 2),
      allStates = _useState4[0],
      setAllStates = _useState4[1];

  useEffect(function () {
    var asyncGetSteps = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$s().m(function _callee() {
        var steps;
        return _regenerator$s().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.n = 1;
                return getSetupSteps(domainItem, strings);

              case 1:
                steps = _context.v;
                setSetupSteps(steps);
                setAllStates(Array(steps.length).fill(true).fill(false, 1));

              case 2:
                return _context.a(2);
            }
          }
        }, _callee);
      }));

      return function asyncGetSteps() {
        return _ref2.apply(this, arguments);
      };
    }();

    asyncGetSteps();
  }, [domainItem, strings]);
  return /*#__PURE__*/jsx$1(Stack$2, _objectSpread$u(_objectSpread$u({}, rest), {}, {
    children: /*#__PURE__*/jsx$1(Stack$2, {
      id: "setup-steps-".concat(domainItem.name),
      children: setupSteps.map(function (step, idx) {
        return /*#__PURE__*/jsx$1(SetupAccordionItems, {
          addonPrices: addonPrices,
          allStates: allStates,
          domainItem: domainItem,
          gridFormat: gridFormat$2,
          index: idx,
          setAllStates: setAllStates,
          setupStep: step
        }, "step-".concat(idx + 1, "-").concat(domainItem.name));
      })
    })
  }));
}

SetupAccordion.propTypes = propTypes$o;
var colors$e = redesignTheme.colors;
var propTypes$n = {
  addonPrices: PropTypes.array.isRequired,
  allStates: PropTypes.array.isRequired,
  domainItem: PropTypes.arrayOf(PropTypes.shape({
    addOns: PropTypes.arrayOf(PropTypes.shape({
      icon: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      status: PropTypes.bool.isRequired,
      value: PropTypes.string.isRequired
    })),
    expiry: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    open: PropTypes.bool,
    status: PropTypes.string.isRequired
  })).isRequired,
  gridFormat: PropTypes.shape({
    gridGap: PropTypes.array.isRequired,
    gridMargin: PropTypes.number.isRequired,
    gridTemplateColumns: PropTypes.array.isRequired
  }).isRequired,
  index: PropTypes.number.isRequired,
  isOnlyDomainItem: PropTypes.bool.isRequired,
  setAllStates: PropTypes.func.isRequired
};
var buttonStyles = css$3(["display:flex;border-color:", ";border-top:none;border-left:1px solid ", ";border-right:1px solid ", ";border-bottom:1px solid ", ";outline:none;width:100%;transition:background-color 0.2s ease;background-color:", ";color:", ";&:hover,&:active{background-color:", ";color:", ";}"], colors$e.greyLight, colors$e.greyLight, colors$e.greyLight, colors$e.greyLight, colors$e.white, colors$e.black, isInternic ? colors$e.blueLightest : colors$e.greenLight, colors$e.black);

function DomainsAccordionItems(_ref) {
  var index = _ref.index,
      addonPrices = _ref.addonPrices,
      domainItem = _ref.domainItem,
      gridFormat = _ref.gridFormat,
      allStates = _ref.allStates,
      isOnlyDomainItem = _ref.isOnlyDomainItem,
      setAllStates = _ref.setAllStates,
      strings = _ref.strings;

  var _useState = useState(null),
      _useState2 = _slicedToArray$4(_useState, 2),
      requestIsLoading = _useState2[0],
      setRequestIsLoading = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$4(_useState3, 2),
      confirmationMode = _useState4[0],
      setConfirmationMode = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray$4(_useState5, 2),
      message = _useState6[0],
      setMessage = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray$4(_useState7, 2),
      requestSuccessful = _useState8[0],
      setRequestSuccessful = _useState8[1];

  var _useState9 = useState(domainItem.status),
      _useState0 = _slicedToArray$4(_useState9, 2),
      domainStatus = _useState0[0];

  _useState0[1];

  var _useState1 = useState(domainItem.expiry),
      _useState10 = _slicedToArray$4(_useState1, 2),
      domainExpiry = _useState10[0];

  _useState10[1];

  var _useState11 = useState(isDomainActive),
      _useState12 = _slicedToArray$4(_useState11, 2),
      enableRow = _useState12[0],
      setEnableRow = _useState12[1];

  var isDomainExpired = isDomainIndeedExpired(domainStatus, domainExpiry);

  var _useAccordion = useAccordion(),
      toggleChildState = _useAccordion.toggleChildState;

  var recoveryInfo = getRecoveryInfo(domainItem.expiry, strings);
  recoveryInfo.phase;
  var recoveryMessage = recoveryInfo.message;
  var isDomainActive = isDomainIndeedActive(domainStatus, domainExpiry);
  useEffect(function () {
    setEnableRow(isDomainActive);
    var domainRegAddOnIndex = domainItem.addOns.findIndex(function (addOn) {
      return addOn.key === getAddOnKeys().domainRegistration.key;
    });
    domainItem.addOns[domainRegAddOnIndex].status = isDomainActive;
  }, [isDomainActive]);

  var getColor = function getColor() {
    return isInternic ? 'blueDark' : 'greenDark';
  };

  var getMessageColor = function getMessageColor() {
    if (requestIsLoading) {
      return 'black';
    }

    if (requestSuccessful) {
      return 'green';
    }

    return 'red';
  };

  var requestRecovery = function requestRecovery() {
    setConfirmationMode(false);
    setRequestIsLoading(true);
    setMessage('Please wait while we process your recovery order..');
    var domainRecoveryEndpoint = getDomainRecoveryEndpoint(domainItem.id.toString());
    post$1(domainRecoveryEndpoint).then(function () {
      setRequestSuccessful(true);
      setMessage(null);
      window.location = '/checkout';
    })["catch"](function (error) {
      console.error(error);
      setRequestIsLoading(false);
      setRequestSuccessful(false);
      setMessage('Oops! Looks like we caught an error there..');
    });
  };

  var confirmRecovery = function confirmRecovery() {
    if (confirmationMode) {
      requestRecovery();
    } else {
      setConfirmationMode(true);
      setMessage(isDomainExpired ? 'Recovering this domain renews it for 1 year at the regular renewal price plus a $5 (CAD) administrative fee. Do you want to proceed?' : 'Recovering this domain restores its previous settings at a $5 (CAD) administrative fee. Do you want to proceed?');
    }
  };

  var promptRecovery = function promptRecovery() {
    return /*#__PURE__*/jsxs(Box$1, {
      alignSelf: "center",
      flexDirection: ['column', 'column', 'row', 'row'],
      justifyContent: ['center', 'center', 'flex-start', 'flex-start'],
      mb: [2, 2, 0],
      children: [/*#__PURE__*/jsx$1(Button$1, {
        color: confirmationMode ? 'red' : getColor(),
        disabled: !!requestIsLoading,
        onClick: confirmRecovery,
        variant: "solid",
        children: /*#__PURE__*/jsx$1(Text$1, {
          children: "Recover Now"
        })
      }), confirmationMode && /*#__PURE__*/jsx$1(Button$1, {
        disabled: !!requestIsLoading,
        ml: [0, 0, 2],
        my: [2, 2, 0],
        onClick: function onClick() {
          setConfirmationMode(false);
          setMessage(null);
        },
        p: 2,
        variant: "link",
        children: /*#__PURE__*/jsx$1(Text$1, {
          variant: "kiloBold",
          children: "Cancel"
        })
      })]
    });
  };

  var renderRecoveryAction = function renderRecoveryAction(phase) {
    var prompt = promptRecovery();

    switch (phase) {
      case getDomainStatusTypes$1().deleted:
        return exceededExpiryPeriod(domainExpiry) ? null : prompt;

      case getDomainStatusTypes$1().expired:
        return prompt;

      case getDomainStatusTypes$1().redemption:
        return /*#__PURE__*/jsx$1(Link$1, {
          alignSelf: "center",
          color: getColor(),
          href: "/MyAccount/RGPManager.aspx",
          mb: [2, 2, 0],
          variant: "solid",
          children: /*#__PURE__*/jsx$1(Text$1, {
            children: strings.rgpButton
          })
        });

      default:
        return null;
    }
  };

  return /*#__PURE__*/jsx$1(Stack$2, {
    width: "100%",
    children: enableRow ? /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsxs(_StyledButton$a, {
        onClick: function onClick() {
          if (!isOnlyDomainItem) {
            toggleChildState(allStates, setAllStates, index);
            MyAccountDashboardService.setOpenDomain(domainItem.name);
          }
        },
        p: 3,
        width: "100%",
        children: [/*#__PURE__*/jsxs(Grid$1, {
          alignSelf: "center",
          gridGap: gridFormat.gridGap,
          gridTemplateColumns: gridFormat.gridTemplateColumns,
          width: "100%",
          children: [/*#__PURE__*/jsx$1(Stack$2, {
            children: /*#__PURE__*/jsx$1(Heading, {
              lineHeight: 1.7,
              my: 1,
              textAlign: "left",
              textTransform: "lowercase",
              children: /*#__PURE__*/jsx$1(Link$1, {
                color: getColor(),
                fontWeight: "bold",
                href: "/MyAccount/DomainDetails.aspx?tab=0&domain=".concat(domainItem.name),
                my: "0.7rem",
                newTab: true,
                onClick: function onClick(e) {
                  e.stopPropagation();
                },
                textAlign: "left",
                textDecoration: "underline",
                variant: "megaBold",
                children: domainItem.name
              })
            })
          }), /*#__PURE__*/jsx$1(Box$1, {
            alignSelf: "center",
            mb: [1, 1, 0],
            children: /*#__PURE__*/jsx$1(Text$1, {
              alignSelf: "center",
              fontSize: "13px",
              textAlign: "left",
              children: domainStatus
            })
          }), /*#__PURE__*/jsx$1(Box$1, {
            alignSelf: "center",
            mb: [1, 1, 0],
            children: /*#__PURE__*/jsx$1(Text$1, {
              alignSelf: "center",
              fontSize: "13px",
              textAlign: "left",
              children: domainExpiry
            })
          }), /*#__PURE__*/jsx$1(Box$1, {
            alignSelf: "center",
            mb: [1, 1, 0],
            children: domainItem.addOns.map(function (addOn, idx) {
              return addOn.status ? /*#__PURE__*/jsx$1(Icon$2, {
                color: "greenDark",
                height: "1.5rem",
                mr: 1,
                name: addOn.iconName,
                title: addOn.name,
                width: "1.5rem"
              }, idx) : /*#__PURE__*/jsx$1(Icon$2, {
                color: "greyLight",
                height: "1.5rem",
                mr: 1,
                name: addOn.iconName,
                title: addOn.name,
                width: "1.5rem"
              }, idx);
            })
          })]
        }), /*#__PURE__*/jsx$1(Box$1, {
          justifyContent: "flex-end",
          mx: 2,
          width: ['auto', 'auto', '20rem'],
          children: isOnlyDomainItem ? null : /*#__PURE__*/jsx$1(ToggleArrowIcon, {
            ariaID: "".concat(domainItem.name, "-").concat(index),
            isOpen: domainItem.open
          })
        })]
      }), /*#__PURE__*/jsx$1(AccordionItemContent, {
        isOpen: isOnlyDomainItem || MyAccountDashboardService.getOpenDomains(domainItem.name),
        children: /*#__PURE__*/jsx$1(SetupAccordion, {
          addonPrices: addonPrices,
          domainItem: domainItem,
          padding: [3, 4, 4],
          strings: strings
        })
      })]
    }) : /*#__PURE__*/jsxs(Box$1, {
      background: colors$e.white,
      border: "1px ".concat(colors$e.greyLight),
      borderStyle: "none solid solid solid",
      display: ['block', 'block', 'block', 'flex'],
      p: 3,
      width: "100%",
      children: [/*#__PURE__*/jsxs(Grid$1, {
        alignSelf: "center",
        gridColumnGap: gridFormat.gridGap,
        gridTemplateColumns: gridFormat.gridTemplateColumns,
        width: "100%",
        children: [/*#__PURE__*/jsxs(Stack$2, {
          children: [/*#__PURE__*/jsx$1(Heading, {
            my: [2, 2, 1],
            textAlign: ['center', 'center', 'left'],
            textTransform: "lowercase",
            children: /*#__PURE__*/jsx$1(Text$1, {
              as: "a",
              color: colors$e.greyDark,
              fontSize: "13px",
              fontWeight: "bold",
              textAlign: "left",
              children: domainItem.name
            })
          }), /*#__PURE__*/jsx$1(Text$1, {
            color: colors$e.greyDark,
            lineHeight: 1.7,
            mb: [2, 2, 0],
            textAlign: ['center', 'center', 'left'],
            variant: "milliBold",
            children: domainItem.status === getDomainStatusTypes$1().backorder ? "Domain is backordered" : recoveryMessage
          }), message && /*#__PURE__*/jsx$1(Text$1, {
            color: getMessageColor(),
            lineHeight: 1.7,
            mb: [2, 2, 2, 0],
            textAlign: ['center', 'center', 'left'],
            variant: "milliBold",
            width: "75%",
            children: message
          })]
        }), /*#__PURE__*/jsx$1(Box$1, {
          alignSelf: "center",
          justifyContent: ['center', 'center', 'left'],
          children: /*#__PURE__*/jsx$1(Text$1, {
            color: enableRow ? null : colors$e.greyDark,
            fontSize: "13px",
            mb: [2, 2, 0],
            children: domainItem.status
          })
        }), /*#__PURE__*/jsx$1(Box$1, {
          alignSelf: "center",
          justifyContent: ['center', 'center', 'left'],
          children: /*#__PURE__*/jsx$1(Text$1, {
            color: enableRow ? null : colors$e.greyDark,
            fontSize: "13px",
            mb: [2, 2, 0],
            children: domainItem.expiry
          })
        }), /*#__PURE__*/jsx$1(Box$1, {}), /*#__PURE__*/jsx$1(Box$1, {})]
      }), /*#__PURE__*/jsx$1(Box$1, {
        justifyContent: ['center', 'center', 'flex-end'],
        mx: 2,
        width: ['auto', 'auto', '20rem'],
        children: renderRecoveryAction(domainStatus)
      })]
    })
  });
}

DomainsAccordionItems.propTypes = propTypes$n;

var _StyledButton$a = styled(Button$1).withConfig({
  displayName: "domains-accordion-items___StyledButton",
  componentId: "sc-4dv32u-0"
})(["", ""], buttonStyles);

var _excluded$8 = ["list", "renderListItem", "renderOffset"];

function ownKeys$t(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$t(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$t(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$t(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var defaultProps$9 = {
  renderOffset: 10
};
var propTypes$m = {
  list: PropTypes.array.isRequired,
  renderListItem: PropTypes.func.isRequired,
  renderOffset: PropTypes.number
};

function InfiniteScroll(_ref) {
  var list = _ref.list,
      renderListItem = _ref.renderListItem,
      renderOffset = _ref.renderOffset,
      rest = _objectWithoutProperties$8(_ref, _excluded$8);

  var _useState = useState(list.slice(0, renderOffset)),
      _useState2 = _slicedToArray$4(_useState, 2),
      displayedList = _useState2[0],
      setDisplayedList = _useState2[1];

  var listInnerRef = useRef(null);

  var onScroll = function onScroll() {
    var windowBottom = Math.round(window.pageYOffset + window.innerHeight);
    var infiniteScrollBottom = Math.round(window.pageYOffset) + Math.round(listInnerRef.current.getBoundingClientRect().y) + listInnerRef.current.scrollHeight;

    if (windowBottom >= infiniteScrollBottom) {
      setDisplayedList(list.slice(0, displayedList.length + renderOffset));
    }
  };

  useEffect(function () {
    setDisplayedList(list.slice(0, renderOffset));
  }, [list, renderOffset]);
  useEffect(function () {
    if (displayedList.length > 0 && list.length > renderOffset) {
      document.addEventListener('scroll', onScroll);
      return function () {
        document.removeEventListener('scroll', onScroll);
      };
    }

    return null;
  });
  return /*#__PURE__*/jsx$1(Stack$2, _objectSpread$t(_objectSpread$t({
    ref: listInnerRef
  }, rest), {}, {
    children: displayedList.length > 0 ? displayedList.map(function (item, indx) {
      return renderListItem(item, indx);
    }) : null
  }));
}

InfiniteScroll.propTypes = propTypes$m;
InfiniteScroll.defaultProps = defaultProps$9;
var _excluded$7 = ["icon", "onClose", "order", "strings"];

function ownKeys$s(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$s(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$s(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$s(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var propTypes$l = {
  icon: PropTypes.shape({
    color: PropTypes.string,
    name: PropTypes.string.isRequired
  }),
  onClose: PropTypes.func,
  order: PropTypes.shape({
    orderFound: PropTypes.bool.isRequired,
    orderId: PropTypes.string.isRequired
  }).isRequired,
  strings: PropTypes.object.isRequired
};
var defaultProps$8 = {
  icon: null,
  onClose: false
};

function PostOrderSegment(_ref) {
  var icon = _ref.icon,
      onClose = _ref.onClose,
      order = _ref.order,
      strings = _ref.strings,
      rest = _objectWithoutProperties$8(_ref, _excluded$7);

  return /*#__PURE__*/jsxs(Stack$2, _objectSpread$s(_objectSpread$s({}, rest), {}, {
    backgroundColor: "mintGreenLightest",
    children: [onClose && /*#__PURE__*/jsx$1(Box$1, {
      justifyContent: "flex-end",
      width: "100%",
      children: /*#__PURE__*/jsx$1(Button$1, {
        color: "black",
        height: "3rem",
        mt: 2,
        mx: 2,
        variant: "minimal",
        width: "3rem",
        children: /*#__PURE__*/jsx$1(Icon$2, {
          height: "100%",
          name: "close",
          onClick: onClose,
          title: "back",
          width: "100%"
        })
      })
    }), /*#__PURE__*/jsxs(Grid$1, {
      alignSelf: "center",
      gridGap: [0, 2],
      gridTemplateColumns: icon ? ['1fr', '0fr 2fr 1fr '] : ['1fr', '3fr 1fr'],
      px: onClose ? 4 : null,
      width: 1,
      children: [/*#__PURE__*/jsx$1(Box$1, {
        alignSelf: "center",
        justifyContent: ['center', 'center', 'flex-end'],
        my: [3, 3, 0],
        children: icon && /*#__PURE__*/jsx$1(Icon$2, {
          color: icon.color,
          height: "4rem",
          mx: 3,
          name: icon.name,
          title: "back",
          width: "4rem"
        })
      }), /*#__PURE__*/jsxs(Stack$2, {
        children: [/*#__PURE__*/jsx$1(Text$1, {
          mb: 2,
          textAlign: ['center', 'left', 'left'],
          variant: "megaBold",
          children: strings.postOrderTitle
        }), /*#__PURE__*/jsx$1(Text$1, {
          textAlign: ['center', 'left', 'left'],
          variant: "kilo",
          children: strings.postOrderDescription(order.orderId)
        })]
      }), /*#__PURE__*/jsx$1(Box$1, {
        alignSelf: "center",
        justifyContent: ['center', 'center', 'flex-end'],
        my: [3, 3, 0],
        children: /*#__PURE__*/jsx$1(Link$1, {
          color: "blueDark",
          href: "/MyAccount/PrintOrder.aspx?orderId=".concat(order.orderId),
          mx: 2,
          variant: "link",
          children: /*#__PURE__*/jsx$1(Text$1, {
            variant: "kiloBold",
            children: strings.postOrderDownloadPDF
          })
        })
      })]
    })]
  }));
}

PostOrderSegment.propTypes = propTypes$l;
PostOrderSegment.defaultProps = defaultProps$8;
var _excluded$6 = ["strings", "addonPrices", "listOfDomains", "order"];

function ownKeys$r(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$r(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$r(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$r(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _regenerator$r() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$r(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$r(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$r(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$r(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$r(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$r(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$r(u), _regeneratorDefine2$r(u, o, "Generator"), _regeneratorDefine2$r(u, n, function () {
    return this;
  }), _regeneratorDefine2$r(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$r = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$r(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$r = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$r(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$r(e, r, n, t);
}

var colors$d = theme.colors;
var propTypes$k = {
  addonPrices: PropTypes.array.isRequired,
  listOfDomains: PropTypes.array.isRequired,
  order: PropTypes.object.isRequired,
  strings: PropTypes.object.isRequired
};
var headers = [{
  display: 'Domains',
  sortKey: 'name',
  sortable: true
}, {
  display: 'Status',
  sortKey: 'status',
  sortable: false
}, {
  display: 'Expiry',
  sortKey: 'expiry',
  sortable: true
}, {
  display: 'Add-Ons',
  sortKey: 'addOns',
  sortable: false
}];
var gridFormat$1 = {
  gridGap: ['10px'],
  gridTemplateColumns: ['1fr', '1fr', '1fr', '2fr 0.5fr 0.5fr 1.5fr'],
  gridMargin: 3,
  extremeRightCellWidth: '20rem'
};

function DomainAccordion(_ref) {
  var strings = _ref.strings,
      addonPrices = _ref.addonPrices,
      listOfDomains = _ref.listOfDomains,
      order = _ref.order,
      rest = _objectWithoutProperties$8(_ref, _excluded$6);

  var _useState = useState(listOfDomains),
      _useState2 = _slicedToArray$4(_useState, 2),
      userDomains = _useState2[0],
      setUserDomains = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray$4(_useState3, 2),
      allStates = _useState4[0],
      setAllStates = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray$4(_useState5, 2),
      singleDomain = _useState6[0],
      setSingleDomain = _useState6[1];

  var _useState7 = useState({
    key: null,
    isAscending: null
  }),
      _useState8 = _slicedToArray$4(_useState7, 2),
      currentSort = _useState8[0],
      setCurrentSort = _useState8[1];

  var _useState9 = useState(''),
      _useState0 = _slicedToArray$4(_useState9, 2),
      searchBarText = _useState0[0],
      setSearchBarText = _useState0[1];

  var _useState1 = useState(order),
      _useState10 = _slicedToArray$4(_useState1, 2),
      sessionOrder = _useState10[0],
      setSessionOrder = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray$4(_useState11, 2),
      toggleAllOpen = _useState12[0],
      setToggleAllOpen = _useState12[1];

  useEffect(function () {
    window.scrollTo(0, 0);

    var getDomains = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$r().m(function _callee() {
        return _regenerator$r().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                if (userDomains.length === 1) {
                  setSingleDomain(true);
                  setAllStates(Array(userDomains.length).fill(true));
                } else {
                  setAllStates(Array(userDomains.length).fill(false));
                }

              case 1:
                return _context.a(2);
            }
          }
        }, _callee);
      }));

      return function getDomains() {
        return _ref2.apply(this, arguments);
      };
    }();

    getDomains();
  }, []);

  var toggleAll = function toggleAll() {
    var copyDomains = userDomains;
    copyDomains.map(function (domain) {
      domain.open = !toggleAllOpen;
      return domain;
    });
    setUserDomains(copyDomains);
    setToggleAllOpen(!toggleAllOpen);
  };

  var sortDomains = function sortDomains(param) {
    var newSort = {
      key: param,
      isAscending: true
    };

    if (currentSort.key === param) {
      newSort.isAscending = !currentSort.isAscending;
    }

    setCurrentSort(newSort);
    setUserDomains(sortObjects(userDomains, newSort));
  };

  var filterDomains = function filterDomains(domains) {
    if (searchBarText === '') {
      return domains;
    }

    if (currentSort.key === 'name') {
      return sortedFilterStartsWith(domains, searchBarText, function (domain) {
        return domain.name;
      }, currentSort.isAscending);
    }

    return domains.filter(function (domain) {
      return domain.name.startsWith(searchBarText);
    });
  };

  var onSearch = function onSearch(term) {
    setSearchBarText(term);
  };

  var renderDomainItem = function renderDomainItem(domainItem, index) {
    return /*#__PURE__*/jsx$1(DomainsAccordionItems, {
      addonPrices: addonPrices,
      allStates: allStates,
      domainItem: domainItem,
      gridFormat: gridFormat$1,
      index: index,
      isOnlyDomainItem: singleDomain,
      setAllStates: setAllStates,
      strings: strings
    }, "".concat(domainItem.name, "_").concat(index));
  };

  var closePostPurchaseResponse = function closePostPurchaseResponse() {
    setSessionOrder(null);
  };

  return /*#__PURE__*/jsxs(Stack$2, _objectSpread$r(_objectSpread$r({}, rest), {}, {
    children: [sessionOrder && /*#__PURE__*/jsx$1(PostOrderSegment, {
      backgroundColor: colors$d.white,
      border: "1px solid ".concat(colors$d.greys[6]),
      icon: {
        name: 'basket',
        color: isInternic ? 'blueDark' : 'greenDark'
      },
      mb: 3,
      onClose: function onClose() {
        closePostPurchaseResponse();
      },
      order: sessionOrder,
      pb: 4,
      strings: strings
    }), /*#__PURE__*/jsx$1(Box$1, {
      alignItems: "flex-end",
      bg: "white",
      borderTop: "light",
      borderX: "light",
      justifyContent: "flex-end",
      p: 3,
      width: "100%",
      children: /*#__PURE__*/jsx$1(Box$1, {
        width: ['100%', '100%', '30rem'],
        children: /*#__PURE__*/jsx$1(SearchBar, {
          btnColor: isInternic ? 'blueDark' : 'greenDark',
          onClear: function onClear() {
            onSearch('');
          },
          onSearch: onSearch,
          placeholder: "Search your domains..."
        })
      })
    }), /*#__PURE__*/jsxs(Box$1, {
      bg: "white",
      border: "light",
      p: 3,
      width: "100%",
      children: [/*#__PURE__*/jsx$1(Grid$1, {
        alignSelf: "center",
        gridGap: gridFormat$1.gridGap,
        gridTemplateColumns: gridFormat$1.gridTemplateColumns,
        width: "100%",
        children: headers.map(function (header, idx) {
          return /*#__PURE__*/jsxs(Heading, {
            alignItems: "center",
            display: idx === 0 ? 'flex' : ['none', 'none', 'none', 'flex'],
            fontSize: 1,
            variant: ['kiloBold', 'milliBold', 'poundBold'],
            children: [header.display, header.sortable ? /*#__PURE__*/jsx$1(ToggleArrowIcon, {
              ariaID: "sort-".concat(header.display),
              isOpen: !(currentSort.key === header.sortKey && currentSort.isAscending),
              onClick: function onClick() {
                return sortDomains(header.sortKey);
              }
            }) : null]
          }, idx);
        })
      }), /*#__PURE__*/jsx$1(Box$1, {
        justifyContent: "flex-end",
        mx: 2,
        width: ['auto', 'auto', '20rem'],
        children: singleDomain ? null : /*#__PURE__*/jsx$1(ToggleArrowIcon, {
          ariaID: "all-domains",
          isOpen: toggleAllOpen,
          onClick: function onClick() {
            return toggleAll();
          }
        })
      })]
    }), /*#__PURE__*/jsx$1(InfiniteScroll, {
      bg: "greyLight",
      list: filterDomains(userDomains),
      mb: 4,
      renderListItem: renderDomainItem,
      renderOffset: 10
    })]
  }));
}

DomainAccordion.propTypes = propTypes$k;

function _regenerator$q() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$q(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$q(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$q(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$q(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$q(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$q(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$q(u), _regeneratorDefine2$q(u, o, "Generator"), _regeneratorDefine2$q(u, n, function () {
    return this;
  }), _regeneratorDefine2$q(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$q = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$q(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$q = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$q(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$q(e, r, n, t);
}

var colors$c = redesignTheme.colors;
var propTypes$j = {
  addonPrices: PropTypes.array.isRequired,
  order: PropTypes.object.isRequired,
  strings: PropTypes.object.isRequired
};
var gridFormat = {
  gridGap: [0, 1],
  gridTemplateColumns: '1fr'
};

function EmptyDomain(_ref) {
  var strings = _ref.strings,
      addonPrices = _ref.addonPrices,
      order = _ref.order;

  var _React$useState = React__default.useState({}),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      noDomainStep = _React$useState2[0],
      setNoDomainStep = _React$useState2[1];

  var _React$useState3 = React__default.useState(order),
      _React$useState4 = _slicedToArray$4(_React$useState3, 2),
      sessionOrder = _React$useState4[0],
      setSessionOrder = _React$useState4[1];

  useEffect(function () {
    var getEmptyDomainStep = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$q().m(function _callee() {
        var noDomain;
        return _regenerator$q().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.n = 1;
                return getNoDomainSteps(strings);

              case 1:
                noDomain = _context.v;
                setNoDomainStep(noDomain);

              case 2:
                return _context.a(2);
            }
          }
        }, _callee);
      }));

      return function getEmptyDomainStep() {
        return _ref2.apply(this, arguments);
      };
    }();

    getEmptyDomainStep();
  }, []);

  var closePostPurchaseResponse = function closePostPurchaseResponse() {
    setSessionOrder(null);
  };

  return /*#__PURE__*/jsxs(Stack$2, {
    justifyContent: "center",
    width: "100%",
    children: [sessionOrder && /*#__PURE__*/jsx$1(PostOrderSegment, {
      backgroundColor: colors$c.white,
      border: "1px solid ".concat(colors$c.greys[6]),
      icon: {
        name: 'basket',
        color: isInternic ? 'blueDark' : 'greenDark'
      },
      mb: 3,
      onClose: function onClose() {
        closePostPurchaseResponse();
      },
      order: sessionOrder,
      pb: 4,
      strings: strings
    }), /*#__PURE__*/jsx$1(Grid$1, {
      alignSelf: "center",
      gridGap: gridFormat.gridGap,
      gridTemplateColumns: gridFormat.gridTemplateColumns,
      width: 1,
      children: /*#__PURE__*/jsxs(Stack$2, {
        mb: 3,
        mt: 3,
        padding: [4, 4, 3],
        pl: 3,
        children: [/*#__PURE__*/jsx$1(Heading, {
          fontSize: 1,
          lineHeight: "1.7",
          mb: 2,
          textAlign: "left",
          variant: "gigaBold",
          children: noDomainStep.title
        }), /*#__PURE__*/jsx$1(Text$1, {
          lineHeight: "1.7",
          textAlign: "left",
          children: noDomainStep.description
        })]
      })
    }), /*#__PURE__*/jsx$1(Stack$2, {
      width: "100%",
      children: noDomainStep && noDomainStep.addOns && noDomainStep.addOns.map(function (addon, idx) {
        return /*#__PURE__*/jsx$1(Segment, {
          addOn: addon,
          addonPrices: addonPrices,
          backgroundColor: colors$c.white,
          displayRenewal: false,
          domainId: null,
          initialIsActive: false,
          mb: 2,
          name: "",
          padding: [3, 3, 2]
        }, idx);
      })
    })]
  });
}

EmptyDomain.propTypes = propTypes$j;

var shapeDomain = function shapeDomain(domain) {
  var shapedDomain = {
    id: domain.domainInfo.ID,
    name: domain.domainName,
    open: false,
    status: domain.domainInfo.Status,
    expiry: domain.domainInfo.Expires,
    addOns: [{
      key: getAddOnKeys().domainRegistration.key,
      name: getAddOnKeys().domainRegistration.name,
      iconName: 'worldwide',
      specificValue: domain.domainName,
      status: domain.domainInfo.Status === getDomainStatusTypes().active
    }, {
      key: getAddOnKeys().weeblySite.key,
      name: getAddOnKeys().weeblySite.name,
      iconName: 'websites',
      specificValue: getWeeblyPackage(domain.weeblyInfo),
      status: !!domain.weeblyInfo
    }, {
      key: getAddOnKeys().emailHosting.key,
      name: getAddOnKeys().emailHosting.name,
      iconName: 'email',
      specificValue: getEmailValue(domain.emailInfo),
      status: !!domain.emailInfo,
      emailType: getEmailType(domain.emailInfo)
    }, {
      key: getAddOnKeys().webHosting.key,
      name: getAddOnKeys().webHosting.name,
      iconName: 'cloud-computing',
      specificValue: getHostingValue(domain.hostingInfo),
      status: !!domain.hostingInfo
    }, {
      key: getAddOnKeys().sslCertificate.key,
      name: getAddOnKeys().sslCertificate.name,
      iconName: 'shield',
      specificValue: null,
      status: !domain.domainInfo.ShowSSL
    }, {
      key: getAddOnKeys().privacyProtection.key,
      name: getAddOnKeys().privacyProtection.name,
      iconName: 'lock',
      specificValue: null,
      status: domain.domainInfo.IsPrivacyActive
    }, {
      key: getAddOnKeys().expiryProtection.key,
      name: getAddOnKeys().expiryProtection.name,
      iconName: 'notification',
      specificValue: null,
      status: domain.domainInfo.IsDomainInsuranceActive
    }, {
      key: getAddOnKeys().ownershipProtection.key,
      name: getAddOnKeys().ownershipProtection.name,
      iconName: 'key',
      specificValue: null,
      status: domain.domainInfo.IsOwnershipProtectionActive
    }, {
      key: getAddOnKeys().seoTools.key,
      name: getAddOnKeys().seoTools.name,
      iconName: 'graph',
      specificValue: null,
      status: !!domain.seoInfo
    }]
  };
  return shapedDomain;
};

var shapeDomains = function shapeDomains(fullDomainInfo) {
  var allDomains = [];
  var extractedUserDomains = [];
  Object.keys(fullDomainInfo.data.domains).forEach(function (key) {
    return allDomains.push({
      domainName: key,
      domainInfo: fullDomainInfo.data.domains[key].additionalAssets,
      emailInfo: fullDomainInfo.data.domains[key].email,
      hostingInfo: fullDomainInfo.data.domains[key].hosting,
      weeblyInfo: fullDomainInfo.data.domains[key].partnerSiteInfo,
      seoInfo: fullDomainInfo.data.domains[key].hasMarketgooProducts
    });
  });
  allDomains.forEach(function (domain) {
    var summarizedDomain = shapeDomain(domain);
    extractedUserDomains.push(summarizedDomain);
  });
  return extractedUserDomains;
};

function _regenerator$p() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$p(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$p(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$p(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$p(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$p(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$p(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$p(u), _regeneratorDefine2$p(u, o, "Generator"), _regeneratorDefine2$p(u, n, function () {
    return this;
  }), _regeneratorDefine2$p(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$p = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$p(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$p = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$p(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$p(e, r, n, t);
}

var propTypes$i = {
  strings: PropTypes.object.isRequired
};

function DomainDashboard(_ref) {
  var strings = _ref.strings;

  var _useUserService = useUserService();

  _useUserService.user;

  var _React$useState = React__default.useState(true),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      loading = _React$useState2[0],
      setLoading = _React$useState2[1];

  var _React$useState3 = React__default.useState([]),
      _React$useState4 = _slicedToArray$4(_React$useState3, 2),
      addonPrices = _React$useState4[0],
      setAddonPrices = _React$useState4[1];

  var _React$useState5 = React__default.useState([]),
      _React$useState6 = _slicedToArray$4(_React$useState5, 2),
      userDomains = _React$useState6[0],
      setUserDomains = _React$useState6[1];

  var _React$useState7 = React__default.useState(null),
      _React$useState8 = _slicedToArray$4(_React$useState7, 2),
      sessionOrder = _React$useState8[0],
      setSessionOrder = _React$useState8[1];

  var _React$useState9 = React__default.useState(false),
      _React$useState0 = _slicedToArray$4(_React$useState9, 2),
      txEventSent = _React$useState0[0],
      setTxEventSent = _React$useState0[1];

  React__default.useEffect(function () {
    var getDomainsAndAddOns = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$p().m(function _callee() {
        var domainResponse, shapedDomains, lastOrder, purchase, addonResponse, prices;
        return _regenerator$p().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.p = 0;
                _context.n = 1;
                return get$3(accountDomains);

              case 1:
                domainResponse = _context.v;
                shapedDomains = shapeDomains(domainResponse);
                lastOrder = domainResponse.data.lastOrder;
                purchase = lastOrder.purchase;

                if (lastOrder.orderFound && !txEventSent) {
                  datalayerPush({
                    event: 'transaction',
                    ecommerce: {
                      purchase: purchase
                    }
                  });
                  setTxEventSent(true);
                }

                setUserDomains(shapedDomains);
                setSessionOrder(!!lastOrder.orderFound && lastOrder);
                _context.n = 3;
                break;

              case 2:
                _context.p = 2;
                setUserDomains([]);
                setSessionOrder(null);

              case 3:
                _context.n = 4;
                return get$3(pricesAddonsEndpoint);

              case 4:
                addonResponse = _context.v;
                prices = addonResponse.data.prices;
                setAddonPrices(prices);
                setLoading(false);

              case 5:
                return _context.a(2);
            }
          }
        }, _callee, null, [[0, 2]]);
      }));

      return function getDomainsAndAddOns() {
        return _ref2.apply(this, arguments);
      };
    }();

    getDomainsAndAddOns();
  }, []);

  if (loading) {
    return /*#__PURE__*/jsx$1(Skeleton$1, {
      minHeight: "containers.sm",
      mt: 3
    });
  }

  if (userDomains.length === 0) {
    return /*#__PURE__*/jsx$1(EmptyDomain, {
      addonPrices: addonPrices,
      order: sessionOrder,
      strings: strings
    });
  }

  return /*#__PURE__*/jsx$1(DomainAccordion, {
    addonPrices: addonPrices,
    listOfDomains: userDomains,
    order: sessionOrder,
    strings: strings
  });
}

DomainDashboard.propTypes = propTypes$i;

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */


function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}
/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */


function startOfWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */


function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */


function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

var MILLISECONDS_IN_DAY = 86400000;
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */

function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */


function compareAsc(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */

/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */


var millisecondsInMinute = 60000;
/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInHour = 3600000;
/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 * 
 * @example
 * // Are 4 September and 4 October in the same day?
 * var result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 * 
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}
/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */


function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
} // for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.


function compareLocalAsc(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}
/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full days according to the local timezone
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
//=> 92
 */


function differenceInDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareLocalAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign * difference); // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value

  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
  var result = sign * (difference - isLastDayNotFull); // Prevent negative zero

  return result === 0 ? 0 : result;
}
/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */


function differenceInMilliseconds(dateLeft, dateRight) {
  requiredArgs(2, arguments);
  return toDate(dateLeft).getTime() - toDate(dateRight).getTime();
}

var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function trunc(value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
  } // Math.trunc is not supported by IE

};
var defaultRoundingMethod = 'trunc';

function getRoundingMethod(method) {
  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}
/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */


function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}
/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */


function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */


function isLastDayOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  return endOfDay(date).getTime() === endOfMonth(date).getTime();
}
/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */


function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight));
  var result; // Check for the difference of less than month

  if (difference < 1) {
    result = 0;
  } else {
    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
      // This will check if the date is end of Feb and assign a higher end of month date
      // to compare it with Jan
      dateLeft.setDate(30);
    }

    dateLeft.setMonth(dateLeft.getMonth() - sign * difference); // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
    // If so, result must be decreased by 1 in absolute value

    var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign; // Check for cases of one full calendar month

    if (isLastDayOfMonth(toDate(dirtyDateLeft)) && difference === 1 && compareAsc(dirtyDateLeft, dateRight) === 1) {
      isLastMonthNotFull = false;
    }

    result = sign * (difference - Number(isLastMonthNotFull));
  } // Prevent negative zero


  return result === 0 ? 0 : result;
}
/**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of seconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */


function differenceInSeconds(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / 1000;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance$1 = function formatDistance$1(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

var formatDistance$2 = formatDistance$1;

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}; // TODO: Remove String()

    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatLong$1 = formatLong;
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

var formatRelative$1 = formatRelative;

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1 = localize;

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$1 = match;
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */

var locale = {
  code: 'en-US',
  formatDistance: formatDistance$2,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var defaultLocale = locale;

function assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  dirtyObject = dirtyObject || {};

  for (var property in dirtyObject) {
    if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) {
      target[property] = dirtyObject[property];
    }
  }

  return target;
}

function cloneObject(dirtyObject) {
  return assign({}, dirtyObject);
}

var MINUTES_IN_DAY = 1440;
var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var MINUTES_IN_MONTH = 43200;
var MINUTES_IN_TWO_MONTHS = 86400;
/**
 * @name formatDistance
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `distanceInWords ` to `formatDistance`
 *   to make its name consistent with `format` and `formatRelative`.
 *
 * - The order of arguments is swapped to make the function
 *   consistent with `differenceIn...` functions.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   distanceInWords(
 *     new Date(1986, 3, 4, 10, 32, 0),
 *     new Date(1986, 3, 4, 11, 32, 0),
 *     { addSuffix: true }
 *   ) //=> 'in about 1 hour'
 *
 *   // v2.0.0 onward
 *
 *   formatDistance(
 *     new Date(1986, 3, 4, 11, 32, 0),
 *     new Date(1986, 3, 4, 10, 32, 0),
 *     { addSuffix: true }
 *   ) //=> 'in about 1 hour'
 *   ```
 *
 * @param {Date|Number} date - the date
 * @param {Date|Number} baseDate - the date to compare with
 * @param {Object} [options] - an object with options.
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `baseDate` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * const result = formatDistance(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   { includeSeconds: true }
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> 'pli ol 1 jaro'
 */

function formatDistance(dirtyDate, dirtyBaseDate) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  requiredArgs(2, arguments);
  var locale = options.locale || defaultLocale;

  if (!locale.formatDistance) {
    throw new RangeError('locale must contain formatDistance property');
  }

  var comparison = compareAsc(dirtyDate, dirtyBaseDate);

  if (isNaN(comparison)) {
    throw new RangeError('Invalid time value');
  }

  var localizeOptions = cloneObject(options);
  localizeOptions.addSuffix = Boolean(options.addSuffix);
  localizeOptions.comparison = comparison;
  var dateLeft;
  var dateRight;

  if (comparison > 0) {
    dateLeft = toDate(dirtyBaseDate);
    dateRight = toDate(dirtyDate);
  } else {
    dateLeft = toDate(dirtyDate);
    dateRight = toDate(dirtyBaseDate);
  }

  var seconds = differenceInSeconds(dateRight, dateLeft);
  var offsetInSeconds = (getTimezoneOffsetInMilliseconds(dateRight) - getTimezoneOffsetInMilliseconds(dateLeft)) / 1000;
  var minutes = Math.round((seconds - offsetInSeconds) / 60);
  var months; // 0 up to 2 mins

  if (minutes < 2) {
    if (options.includeSeconds) {
      if (seconds < 5) {
        return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
      } else if (seconds < 10) {
        return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
      } else if (seconds < 20) {
        return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
      } else if (seconds < 40) {
        return locale.formatDistance('halfAMinute', null, localizeOptions);
      } else if (seconds < 60) {
        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
      } else {
        return locale.formatDistance('xMinutes', 1, localizeOptions);
      }
    } else {
      if (minutes === 0) {
        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
      } else {
        return locale.formatDistance('xMinutes', minutes, localizeOptions);
      }
    } // 2 mins up to 0.75 hrs

  } else if (minutes < 45) {
    return locale.formatDistance('xMinutes', minutes, localizeOptions); // 0.75 hrs up to 1.5 hrs
  } else if (minutes < 90) {
    return locale.formatDistance('aboutXHours', 1, localizeOptions); // 1.5 hrs up to 24 hrs
  } else if (minutes < MINUTES_IN_DAY) {
    var hours = Math.round(minutes / 60);
    return locale.formatDistance('aboutXHours', hours, localizeOptions); // 1 day up to 1.75 days
  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return locale.formatDistance('xDays', 1, localizeOptions); // 1.75 days up to 30 days
  } else if (minutes < MINUTES_IN_MONTH) {
    var days = Math.round(minutes / MINUTES_IN_DAY);
    return locale.formatDistance('xDays', days, localizeOptions); // 1 month up to 2 months
  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
    months = Math.round(minutes / MINUTES_IN_MONTH);
    return locale.formatDistance('aboutXMonths', months, localizeOptions);
  }

  months = differenceInMonths(dateRight, dateLeft); // 2 months up to 12 months

  if (months < 12) {
    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
    return locale.formatDistance('xMonths', nearestMonth, localizeOptions); // 1 year up to max Date
  } else {
    var monthsSinceStartOfYear = months % 12;
    var years = Math.floor(months / 12); // N years up to 1 years 3 months

    if (monthsSinceStartOfYear < 3) {
      return locale.formatDistance('aboutXYears', years, localizeOptions); // N years 3 months up to N years 9 months
    } else if (monthsSinceStartOfYear < 9) {
      return locale.formatDistance('overXYears', years, localizeOptions); // N years 9 months up to N year 12 months
    } else {
      return locale.formatDistance('almostXYears', years + 1, localizeOptions);
    }
  }
}
/**
 * @name isSameWeek
 * @category Week Helpers
 * @summary Are the given dates in the same week (and month and year)?
 *
 * @description
 * Are the given dates in the same week (and month and year)?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the dates are in the same week (and month and year)
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
 *   weekStartsOn: 1
 * })
 * //=> false
 * 
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same week?
 * var result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */


function isSameWeek(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  requiredArgs(2, arguments);
  var dateLeftStartOfWeek = startOfWeek(dirtyDateLeft, dirtyOptions);
  var dateRightStartOfWeek = startOfWeek(dirtyDateRight, dirtyOptions);
  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}
/**
 * @name isThisWeek
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 * @pure false
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @param {Object} [options] - the object with options
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the date is in this week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
 * //=> false
 */


function isThisWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  return isSameWeek(dirtyDate, Date.now(), options);
}
/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is today
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * var result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */


function isToday(dirtyDate) {
  requiredArgs(1, arguments);
  return isSameDay(dirtyDate, Date.now());
}
/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The previous `parse` implementation was renamed to `parseISO`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward
 *   parseISO('2016-01-01')
 *   ```
 *
 * - `parseISO` now validates separate date and time values in ISO-8601 strings
 *   and returns `Invalid Date` if the date is invalid.
 *
 *   ```javascript
 *   parseISO('2018-13-32')
 *   //=> Invalid Date
 *   ```
 *
 * - `parseISO` now doesn't fall back to `new Date` constructor
 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */


function parseISO(argument, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits == null ? 2 : toInteger(options.additionalDigits);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time)) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.

    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }

  return new Date(timestamp + time + offset);
}

var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString; // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].

  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null; // either year or century is null, not both

  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

function ownKeys$q(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$q(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$q(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$q(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _regenerator$o() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$o(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$o(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$o(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$o(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$o(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$o(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$o(u), _regeneratorDefine2$o(u, o, "Generator"), _regeneratorDefine2$o(u, n, function () {
    return this;
  }), _regeneratorDefine2$o(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$o = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$o(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$o = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$o(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$o(e, r, n, t);
}

var NotificationContext = /*#__PURE__*/React.createContext();
var notificationsAlreadySent = [];

function NotificationProvider(props) {
  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray$4(_React$useState, 2),
      isNotificationPaneOpen = _React$useState2[0],
      setIsNotificationPaneOpen = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray$4(_React$useState3, 2),
      showNotificationDot = _React$useState4[0],
      setNotificationDot = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray$4(_React$useState5, 2),
      notificationsUnread = _React$useState6[0],
      setNotificationsUnread = _React$useState6[1];

  var _React$useState7 = React.useState([]),
      _React$useState8 = _slicedToArray$4(_React$useState7, 2),
      notifications = _React$useState8[0],
      setNotifications = _React$useState8[1];

  var _React$useState9 = React.useState([]),
      _React$useState0 = _slicedToArray$4(_React$useState9, 2),
      alerts = _React$useState0[0],
      setAlerts = _React$useState0[1];

  var _useUserService = useUserService(),
      user = _useUserService.user;

  var setNotificationsRead = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$o().m(function _callee(notificationsRead) {
      var notificationsToBeSent, _yield$get, data, _t;

      return _regenerator$o().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              notificationsToBeSent = [];
              notificationsRead.forEach(function (id) {
                if (notificationsAlreadySent.indexOf(id) < 0) {
                  notificationsToBeSent.push(id);
                  notificationsAlreadySent.push(id);
                }
              });

              if (!(notificationsToBeSent.length > 0)) {
                _context.n = 5;
                break;
              }

              _context.p = 1;
              _context.n = 2;
              return post$1("".concat(notificationEndpoint, "/read"), {
                notifications: notificationsToBeSent
              });

            case 2:
              _context.n = 3;
              return get$3("".concat(notificationEndpoint));

            case 3:
              _yield$get = _context.v;
              data = _yield$get.data;
              setNotifications(data.notifications);
              _context.n = 5;
              break;

            case 4:
              _context.p = 4;
              _t = _context.v;
              console.error('Failed to mark notifications as read', _t);

            case 5:
              return _context.a(2);
          }
        }
      }, _callee, null, [[1, 4]]);
    }));

    return function setNotificationsRead(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var openNotificationPane = function openNotificationPane() {
    setIsNotificationPaneOpen(true);
    var notificationIds = [];

    if ((notifications === null || notifications === void 0 ? void 0 : notifications.length) > 0) {
      notificationIds = notifications.map(function (item) {
        return item.id;
      });
    }

    setNotificationsRead(notificationIds);
  };

  var closeNotificationPane = function closeNotificationPane() {
    return setIsNotificationPaneOpen(false);
  };

  var checkNotificationDot = function checkNotificationDot(items) {
    if (!items) {
      return;
    }

    var unread = 0;
    items.forEach(function (item) {
      unread += item.read ? 0 : 1;
    });
    setNotificationDot(unread > 0);
  };

  var updateNotificationsUnread = function updateNotificationsUnread(items) {
    if (!items) {
      return;
    }

    var unread = 0;
    items.forEach(function (item) {
      unread += item.read ? 0 : 1;
    });
    setNotificationsUnread(unread);
  };

  var getNotifications = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$o().m(function _callee2() {
      var _yield$get2, data, _t2;

      return _regenerator$o().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return get$3("".concat(notificationEndpoint));

            case 1:
              _yield$get2 = _context2.v;
              data = _yield$get2.data;
              setNotifications(data.notifications);
              _context2.n = 3;
              break;

            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.error({
                error: _t2
              });

            case 3:
              return _context2.a(2);
          }
        }
      }, _callee2, null, [[0, 2]]);
    }));

    return function getNotifications() {
      return _ref2.apply(this, arguments);
    };
  }();

  var getAlerts = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator$o().m(function _callee3() {
      var _yield$get3, data, _t3;

      return _regenerator$o().w(function (_context3) {
        while (1) {
          switch (_context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return get$3("".concat(notificationEndpoint, "/alerts"));

            case 1:
              _yield$get3 = _context3.v;
              data = _yield$get3.data;
              setAlerts(data.alerts);
              _context3.n = 3;
              break;

            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.error({
                error: _t3
              });

            case 3:
              return _context3.a(2);
          }
        }
      }, _callee3, null, [[0, 2]]);
    }));

    return function getAlerts() {
      return _ref3.apply(this, arguments);
    };
  }();

  React.useEffect(function () {
    updateNotificationsUnread(notifications);
    checkNotificationDot(notifications);
  }, [notifications]);
  React.useEffect(function () {
    if ((alerts === null || alerts === void 0 ? void 0 : alerts.length) > 0 && user) {
      var prevAlerts = LS.getItem(storageKeys.Alerts) || [];
      var alertIds = alerts.map(function (a) {
        return a.id;
      });
      var newAlerts = getExcludedItems(prevAlerts, alertIds);

      if ((newAlerts === null || newAlerts === void 0 ? void 0 : newAlerts.length) > 0) {
        openNotificationPane();
        LS.setItem(storageKeys.Alerts, getMergedSet(prevAlerts, alertIds));
      }
    }
  }, [alerts]);
  React.useEffect(function () {
    var excludedPages = ['checkout'];
    var path = window.location.href.replace(window.location.origin, '').replace('/', '');

    if (_get(user, 'features.notifications') && !excludedPages.includes(path)) {
      getNotifications();
      getAlerts();
    }
  }, [user]);
  var hasNotifications = !isEmpty$1(notifications);
  var hasAlerts = !isEmpty$1(alerts);
  var value = React.useMemo(function () {
    return {
      isNotificationPaneOpen: isNotificationPaneOpen,
      openNotificationPane: openNotificationPane,
      setNotificationsRead: setNotificationsRead,
      closeNotificationPane: closeNotificationPane,
      showNotificationDot: showNotificationDot,
      notifications: notifications,
      hasNotifications: hasNotifications,
      hasAlerts: hasAlerts,
      notificationsUnread: notificationsUnread,
      alerts: alerts
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [isNotificationPaneOpen, notifications, hasNotifications, alerts]);
  return /*#__PURE__*/jsx$1(NotificationContext.Provider, _objectSpread$q({
    value: value
  }, props));
}

function useNotificationService() {
  var notificationCtx = React.useContext(NotificationContext);

  if (!notificationCtx) {
    throw new Error("useNotificationService must be used within an NotificationProvider");
  }

  return _objectSpread$q({}, notificationCtx);
}

var transform$3 = system({
  transform: true
});
var StyledPaneStack = motion.custom(styled.div.withConfig({
  displayName: "pane-stack__StyledPaneStack",
  componentId: "sc-1mwrngt-0"
})(["", " ", " ", " ", " ", " ", " ", " ", " ", " display:flex;flex-direction:column;z-index:99;"], border$1, color$3, flexbox, layout, position, space$5, shadow, background, transform$3));
var paneVariants$2 = {
  visible: {
    x: 'calc(100vw - 100%)',
    opacity: 1
  },
  hidden: {
    x: '100vw',
    opacity: 0
  }
};
var propTypes$h = {
  children: PropTypes.node.isRequired,
  // initiator: PropTypes.oneOfType([
  //   // Either a function
  //   PropTypes.func,
  //   // Or the instance of a DOM native element (see the note about SSR)
  //   PropTypes.shape({ current: PropTypes.instanceOf(PropTypes.element) }),
  // ]),
  isOpen: PropTypes.bool.isRequired,
  onClosePane: PropTypes.func.isRequired
}; // The initiator PropType causes and issue.
// eslint-disable-next-line react/prop-types

function PaneStack(_ref) {
  var children = _ref.children,
      isOpen = _ref.isOpen,
      onClosePane = _ref.onClosePane,
      initiator = _ref.initiator;
  var paneRef = React.useRef();
  React.useEffect(function () {
    var handleKeydown = function handleKeydown(e) {
      if (e.key === 'Escape') {
        onClosePane();
      }
    };

    if (isOpen) {
      paneRef.current.focus();
      document.addEventListener('keydown', handleKeydown);
    } else {
      document.removeEventListener('keydown', handleKeydown);
    }

    return function () {
      if (hasDOM) {
        document.removeEventListener('keydown', handleKeydown);
      }
    };
  }, [isOpen, onClosePane]); // eslint-disable-next-line react/prop-types

  useTabTrapper(paneRef, [isOpen], (initiator === null || initiator === void 0 ? void 0 : initiator.current) || null);
  return /*#__PURE__*/jsx$1(StyledPaneStack, {
    ref: paneRef,
    animate: isOpen ? 'visible' : 'hidden',
    bg: "whiteDark",
    boxShadow: "0rem 1rem 6rem rgba(0, 0, 0, 0.4)",
    initial: "hidden",
    maxHeight: ['60rem'],
    overflowY: "auto",
    position: "absolute",
    tabIndex: "-1",
    top: "8rem",
    transition: {
      duration: 0.2
    },
    variants: paneVariants$2,
    width: ['100vw', '45rem'],
    children: children
  });
}

PaneStack.propTypes = propTypes$h;

var _templateObject$l;

function ownKeys$p(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$p(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$p(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$p(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var notificationPropTypes = {
  content: PropTypes.arrayOf(PropTypes.string).isRequired,
  createdAt: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  link: PropTypes.string,
  read: PropTypes.bool
};
var defaultNotificationPropTypes = {
  link: null,
  read: false
};
var itemCss = css$3(["transition:all 0.2s;&:nth-child(odd){background-color:", ";}&:hover{text-decoration:none;background-color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.greys[7];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.greys[6];
});

function Notification(_ref3) {
  var id = _ref3.id,
      content = _ref3.content,
      createdAt = _ref3.createdAt,
      link = _ref3.link,
      read = _ref3.read;
  return /*#__PURE__*/jsx$1(_StyledLink$5, {
    ariaLabel: id,
    href: link,
    width: 1,
    children: /*#__PURE__*/jsxs(Box$1, {
      pr: 2,
      py: 2,
      children: [/*#__PURE__*/jsx$1(Box$1, {
        alignItems: "flex-start",
        justifyContent: "center",
        width: "5rem",
        children: !read && /*#__PURE__*/jsx$1(Box$1, {
          bg: "#33CC99",
          borderRadius: "100%",
          height: ".8rem",
          mt: 1,
          width: ".8rem"
        })
      }), /*#__PURE__*/jsxs(Stack$2, {
        flex: "1",
        children: [content.map(function (c) {
          return /*#__PURE__*/jsx$1(StyleReset, {
            children: /*#__PURE__*/jsx$1(Text$1, {
              color: "blackLight",
              variant: "milli",
              children: /*#__PURE__*/jsx$1(HtmlBlock, {
                children: c
              })
            })
          }, c);
        }), /*#__PURE__*/jsx$1(Text$1, {
          color: "greyDarker",
          variant: "micro",
          children: formatDistance(new Date(createdAt), new Date())
        })]
      })]
    })
  });
}

Notification.propTypes = notificationPropTypes;
Notification.defaultProps = defaultNotificationPropTypes;
var alertProps = {
  alert: PropTypes.shape({
    content: PropTypes.string,
    ctas: PropTypes.arrayOf(PropTypes.shape({
      link: PropTypes.string,
      text: PropTypes.string,
      variant: PropTypes.string
    })),
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  }).isRequired
};

function Alert(_ref4) {
  var _alert$ctas;

  var alert = _ref4.alert;
  return /*#__PURE__*/jsxs(_StyledBox$b, {
    id: alert.id,
    p: 3,
    children: [/*#__PURE__*/jsx$1(Box$1, {
      bg: "#E62E31",
      borderRadius: "100%",
      flex: "0 0 .8rem",
      height: ".8rem",
      mr: 2,
      mt: 2,
      width: ".8rem"
    }), /*#__PURE__*/jsxs(Stack$2, {
      alignItems: "flex-start",
      children: [/*#__PURE__*/jsx$1(Text$1, {
        variant: "kiloBold",
        children: alert.title
      }), /*#__PURE__*/jsx$1(StyleReset, {
        children: /*#__PURE__*/jsx$1(Text$1, {
          variant: "milli",
          children: /*#__PURE__*/jsx$1(HtmlBlock, {
            children: alert.content
          })
        })
      }), ((_alert$ctas = alert.ctas) === null || _alert$ctas === void 0 ? void 0 : _alert$ctas.length) > 0 && /*#__PURE__*/jsx$1(Box$1, {
        alignItems: "center",
        flexWrap: "wrap",
        children: alert.ctas.map(function (cta) {
          return /*#__PURE__*/jsx$1(Link$1, {
            color: "blueDark",
            href: cta.link,
            mr: 2,
            mt: 3,
            variant: cta.variant || 'solid',
            children: cta.text
          }, cta.text);
        })
      })]
    })]
  });
}

Alert.propTypes = alertProps;

function NotificationPane(_ref5) {
  var initiator = _ref5.initiator;

  var _useNotificationServi = useNotificationService(),
      hasNotifications = _useNotificationServi.hasNotifications,
      notifications = _useNotificationServi.notifications,
      hasAlerts = _useNotificationServi.hasAlerts,
      alerts = _useNotificationServi.alerts,
      isNotificationPaneOpen = _useNotificationServi.isNotificationPaneOpen,
      closeNotificationPane = _useNotificationServi.closeNotificationPane;

  var _useUserService = useUserService(),
      user = _useUserService.user;

  if (!_get(user, 'features.notifications')) {
    return null;
  }

  return /*#__PURE__*/jsx$1(PaneStack, {
    initiator: initiator,
    isOpen: isNotificationPaneOpen,
    onClosePane: closeNotificationPane,
    children: /*#__PURE__*/jsxs(ErrorBoundary, {
      location: "notification-pane",
      children: [/*#__PURE__*/jsx$1(Box$1, {
        justifyContent: "flex-end",
        pr: 3,
        py: 1,
        children: /*#__PURE__*/jsx$1(Icon$2, {
          height: "3rem",
          name: "close",
          onClick: closeNotificationPane,
          right: "0.2rem",
          title: "Close",
          titleId: "checkmarkIcon",
          width: "3rem"
        })
      }), hasAlerts && /*#__PURE__*/jsx$1(Stack$2, {
        children: alerts.map(function (alert) {
          return /*#__PURE__*/jsx$1(Alert, {
            alert: alert
          }, alert.id);
        })
      }), !hasAlerts && !hasNotifications && /*#__PURE__*/jsx$1(Box$1, {
        backgroundColor: "rgba(255,255,255,.05)",
        justifyContent: "center",
        pr: 2,
        py: 2,
        children: /*#__PURE__*/jsx$1(Text$1, {
          color: "greyDark",
          fontSize: 0,
          fontWeight: "400",
          children: "You have no alerts or notifications. Have a great day."
        })
      }), hasNotifications && /*#__PURE__*/jsx$1(Stack$2, {
        alignItems: "flex-start",
        px: 3,
        py: 2,
        children: notifications.map(function (notification) {
          return /*#__PURE__*/jsx$1(Notification, _objectSpread$p({}, notification), notification.id);
        })
      })]
    })
  });
}

NotificationPane.propTypes = {
  initiator: PropTypes.oneOfType([// Either a function
  PropTypes.func, // Or the instance of a DOM native element (see the note about SSR)
  PropTypes.shape({
    current: PropTypes.instanceOf(PropTypes.element)
  })])
};
NotificationPane.defaultProps = {
  initiator: null
};
NotificationPane.displayName = 'NotificationPane';

var _StyledLink$5 = styled(Link$1)(_templateObject$l || (_templateObject$l = _taggedTemplateLiteral$1(["", ""])), itemCss);

var _StyledBox$b = styled(Box$1).withConfig({
  displayName: "notification-pane___StyledBox",
  componentId: "sc-1iik1r7-0"
})(["", ""], itemCss);

function ownKeys$o(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$o(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$o(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$o(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var notificationOrder = [{
  title: 'Today',
  key: 'today'
}, {
  title: 'This week',
  key: 'thisWeek'
}, {
  title: 'Last week',
  key: 'lastWeek'
}, {
  title: 'Older',
  key: 'older'
}];

function Notifications() {
  var _useNotificationServi = useNotificationService(),
      notifications = _useNotificationServi.notifications,
      notificationsUnread = _useNotificationServi.notificationsUnread;

  var notificationChunks = notifications.reduce(function (acc, next) {
    var createdAt = next.createdAt;
    var date = parseISO(createdAt);

    if (isToday(date)) {
      acc.today.push(next);
    } else if (isThisWeek(date)) {
      acc.thisWeek.push(next);
    } else if (differenceInDays(date, new Date()) > -14) {
      acc.lastWeek.push(next);
    } else {
      acc.older.push(next);
    }

    return acc;
  }, {
    today: [],
    thisWeek: [],
    lastWeek: [],
    older: []
  });
  return /*#__PURE__*/jsx$1(ErrorBoundary, {
    location: "notifications",
    children: /*#__PURE__*/jsx$1(Box$1, {
      bg: "greys.1",
      justifyContent: "center",
      minHeight: "100vh",
      pt: 5,
      width: "100%",
      children: /*#__PURE__*/jsxs(Stack$2, {
        maxWidth: "containers.md",
        width: "100%",
        children: [/*#__PURE__*/jsxs(Text$1, {
          as: "h1",
          color: "greys.5",
          mb: 3,
          variant: "gigaBold",
          children: ["Notifications", notificationsUnread > 0 && /*#__PURE__*/jsxs(Text$1, {
            as: "span",
            ml: 3,
            variant: "kiloBold",
            children: ["(", "".concat(notificationsUnread, " Unread"), ")"]
          })]
        }), /*#__PURE__*/jsx$1(Stack$2, {
          color: "greys.6",
          children: notificationOrder.map(function (order) {
            var hasNotif = notificationChunks[order.key].length > 0;

            if (!hasNotif) {
              return null;
            }

            return /*#__PURE__*/jsxs(Stack$2, {
              children: [/*#__PURE__*/jsx$1(Divider, {
                alignSelf: "center",
                my: 3,
                width: "90%",
                children: /*#__PURE__*/jsx$1(Text$1, {
                  display: "inline",
                  px: 4,
                  textTransform: "capitalize",
                  children: order.title
                })
              }), notificationChunks[order.key].map(function (n) {
                return /*#__PURE__*/jsx$1(Notification, _objectSpread$o({}, n), n.id);
              })]
            }, order.key);
          })
        })]
      })
    })
  });
}

var propTypes$g = {
  strings: PropTypes.shape({
    accountCredit: PropTypes.string,
    oustandingBalance: PropTypes.string
  }).isRequired
};

function AccountBalanceMessage(_ref) {
  var strings = _ref.strings;

  var _useUserService = useUserService(),
      user = _useUserService.user;

  if (!(user !== null && user !== void 0 && user.balance) && (user === null || user === void 0 ? void 0 : user.status) != 'CreditCardOnHold') {
    return null;
  }

  return /*#__PURE__*/jsxs(Stack$2, {
    my: 3,
    width: "100%",
    maxWidth: "400px",
    children: [(user === null || user === void 0 ? void 0 : user.balance) && /*#__PURE__*/jsx$1(Message, {
      variant: user.balance > 0 ? 'success' : 'warning',
      children: user.balance > 0 ? strings.accountCredit + Math.abs(user.balance) : strings.oustandingBalance + Math.abs(user.balance)
    }), user.status == 'CreditCardOnHold' && /*#__PURE__*/jsx$1(Message, {
      variant: "error",
      children: "Your current payment method is invalid or expired. Please update it to continue your services. Any outstanding balance will be charged to the new card."
    })]
  });
}

AccountBalanceMessage.propTypes = propTypes$g;
var propTypes$f = {
  strings: PropTypes.shape({
    maintenanceMessageBody: PropTypes.string,
    maintenanceMessageHeader: PropTypes.string,
    paymentSettingsHeader: PropTypes.string.isRequired
  }).isRequired
};
/**
 * Payment settings main UI component.
 */

function PaymentSettings(_ref) {
  var strings = _ref.strings;
  return /*#__PURE__*/jsx$1(CreditCardServiceProvider, {
    children: /*#__PURE__*/jsx$1(PaymentSettingsContent, {
      strings: strings
    })
  });
}

function PaymentSettingsContent(_ref2) {
  var strings = _ref2.strings;

  var _useState = useState(null),
      _useState2 = _slicedToArray$4(_useState, 2),
      payPalToken = _useState2[0],
      setPayPalToken = _useState2[1];

  var _useCreditCardService = useCreditCardService(),
      addCard = _useCreditCardService.addCard;

  var _useUserService = useUserService(),
      user = _useUserService.user;

  useEffect(function () {
    if (hasDOM) {
      var decoded = decodeURIComponent(window.location.search);

      var token = _get(queryString.parse(decoded), 'token');

      if (token) {
        setPayPalToken("".concat(token));
      }
    }
  }, []);
  useEffect(function () {
    if (payPalToken) {
      addCard(false, {
        card: {
          payPalToken: payPalToken,
          type: paymentTypes.paypal
        },
        user: user
      });
    }
  }, [payPalToken]);
  return /*#__PURE__*/jsx$1(ErrorBoundary, {
    location: "payment-settings",
    children: /*#__PURE__*/jsxs(Stack$2, {
      alignItems: "center",
      px: [2, 4],
      children: [/*#__PURE__*/jsxs(Stack$2, {
        bg: "white",
        border: 2,
        maxWidth: "containers.md",
        my: 4,
        px: [2, 4],
        py: [2, 3],
        width: "100%",
        children: [/*#__PURE__*/jsx$1(Heading, {
          variant: "gigaBold",
          children: strings.paymentSettingsHeader
        }), /*#__PURE__*/jsx$1(AccountBalanceMessage, {
          strings: strings
        }), /*#__PURE__*/jsx$1(CcView, {})]
      }), /*#__PURE__*/jsx$1(Box$1, {
        justifyContent: "center",
        mb: 5,
        children: /*#__PURE__*/jsx$1(HelpSection, {
          variant: "light"
        })
      })]
    })
  });
}

PaymentSettings.propTypes = propTypes$f;

var getIconWidth = function getIconWidth(large) {
  if (large) {
    return '23rem';
  }

  return 'auto';
};

var getIconMobileWidth = function getIconMobileWidth(large) {
  if (large) {
    return '5rem';
  }

  return '2rem';
};

var getIconHeight = function getIconHeight(large) {
  if (large) {
    return '5rem';
  }

  return '3rem';
};

var getRebelLogo = function getRebelLogo(useWhiteLogo) {
  if (useWhiteLogo) {
    return 'rebelcom-logo-white';
  }

  return 'rebelcom-logo';
};

function NavLogo(_ref) {
  var large = _ref.large,
      _ref$useWhite = _ref.useWhite,
      useWhite = _ref$useWhite === void 0 ? false : _ref$useWhite;

  switch (RESELLER) {
    case 'rebel.ca':
    case 'rebel.com':
      return /*#__PURE__*/jsx$1(Icon$2, {
        height: getIconHeight(large),
        name: getRebelLogo(useWhite),
        title: "rebel-logo-2021",
        titleId: "navbar-rebel-com-logo",
        width: getIconWidth(large)
      }, 'rebelcom');

    case 'internic.ca':
      return [/*#__PURE__*/jsx$1(Icon$2, {
        containerProps: {
          display: ['flex', 'none', 'none', 'none']
        },
        height: getIconHeight(large),
        name: "simpleinterniclogo",
        title: "internic-simple-logo",
        titleId: "navbar-internic-simple-logo",
        width: getIconMobileWidth(large)
      }, 'simple-internic'), /*#__PURE__*/jsx$1(Icon$2, {
        containerProps: {
          display: ['none', 'flex', 'flex', 'flex']
        },
        height: getIconHeight(large),
        name: useWhite ? 'interniclogo' : 'interniclogo-black',
        title: "internic--logo",
        titleId: "navbar-internic-logo",
        width: getIconWidth(large)
      }, 'internic')];

    default:
      return null;
  }
}

var _templateObject$k;

var propTypes$e = {
  isBeta: PropTypes.bool,
  strings: PropTypes.shape({
    betaLinkText: PropTypes.string.isRequired,
    betaRollbackUrl: PropTypes.string.isRequired,
    betaText: PropTypes.string.isRequired,
    continueShopping: PropTypes.string.isRequired
  }).isRequired
};
var detaultProps = {
  isBeta: false
};

function FocusHeader(_ref) {
  var strings = _ref.strings,
      isBeta = _ref.isBeta;
  var continueShopping = strings.continueShopping,
      betaText = strings.betaText,
      betaLinkText = strings.betaLinkText,
      betaRollbackUrl = strings.betaRollbackUrl;
  return /*#__PURE__*/jsx$1(Box$1, {
    alignItems: "center",
    alignSelf: "stretch",
    as: "header",
    color: "whiteDark",
    justifyContent: "space-between",
    position: "relative",
    px: [0, 3],
    py: 3,
    children: /*#__PURE__*/jsxs(Stack$2, {
      flex: "1",
      children: [/*#__PURE__*/jsxs(Box$1, {
        alignItems: "center",
        children: [/*#__PURE__*/jsx$1(Box$1, {
          flex: "1",
          children: /*#__PURE__*/jsx$1(Link$1, {
            ariaLabel: continueShopping,
            color: "white",
            href: "/",
            children: /*#__PURE__*/jsxs(Box$1, {
              alignItems: "center",
              children: [/*#__PURE__*/jsx$1(_StyledIcon$1, {
                height: "1rem",
                name: "arrow-right",
                title: "continue-shoppin",
                titleId: "continue-shopping",
                width: "1rem"
              }, 'arrow-right'), /*#__PURE__*/jsx$1(Text$1, {
                fontSize: 1,
                fontWeight: "500",
                ml: 2,
                children: continueShopping
              })]
            })
          })
        }), /*#__PURE__*/jsxs(Link$1, {
          ariaLabel: "home",
          href: "/",
          title: "Home",
          children: [/*#__PURE__*/jsx$1(Text$1, {
            display: ['none', 'flex'],
            children: /*#__PURE__*/jsx$1(NavLogo, {
              large: true,
              useWhite: true
            })
          }), /*#__PURE__*/jsx$1(Text$1, {
            display: ['flex', 'none'],
            children: /*#__PURE__*/jsx$1(NavLogo, {
              useWhite: true
            })
          })]
        }), /*#__PURE__*/jsx$1(Box$1, {
          flex: "1",
          justifyContent: "flex-end",
          children: isRebelCOM && /*#__PURE__*/jsx$1(CurrencySelector, {
            fontSize: "1.2rem",
            id: "focus-layout-currency-selector"
          })
        })]
      }), isBeta && /*#__PURE__*/jsx$1(Message, {
        mt: 3,
        variant: "whiteOnDark",
        children: /*#__PURE__*/jsxs(Box$1, {
          flexWrap: "wrap",
          children: [/*#__PURE__*/jsx$1(Text$1, {
            color: "white",
            children: betaText
          }), /*#__PURE__*/jsx$1(Link$1, {
            ariaLabel: betaLinkText,
            color: "white",
            href: betaRollbackUrl,
            ml: 2,
            title: betaLinkText,
            children: /*#__PURE__*/jsx$1(_StyledText$h, {
              children: betaLinkText
            })
          })]
        })
      })]
    })
  });
}

FocusHeader.propTypes = propTypes$e;
FocusHeader.defaultProps = detaultProps;

var _StyledIcon$1 = styled(Icon$2)(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral$1(["transform: rotate(180deg)"])));

var _StyledText$h = styled(Text$1).withConfig({
  displayName: "focus-header___StyledText",
  componentId: "sc-1q1uah6-0"
})(["text-decoration:underline;"]);

var colors$b = theme.colors;
var strings = {
  header: {
    continueShopping: 'Continue Shopping',
    betaText: 'Having trouble with our beta order page?',
    betaLinkText: 'Head over to the old experience to complete your purchase',
    betaRollbackUrl: '/order?optOutCart=true'
  }
};
var defaultProps$7 = {
  children: null,
  isBeta: false
};
var propTypes$d = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  isBeta: PropTypes.bool
};

function FocusLayout(_ref) {
  var children = _ref.children,
      isBeta = _ref.isBeta;
  return /*#__PURE__*/jsxs(Stack$2, {
    alignItems: "center",
    background: "linear-gradient(".concat(colors$b.blackLight, " 25rem, ").concat(colors$b.whiteDark, " 25rem);"),
    justifyContent: "flex-start",
    minHeight: "100vh",
    pt: 3,
    width: "100%",
    children: [/*#__PURE__*/jsx$1(FocusHeader, {
      isBeta: isBeta,
      strings: strings.header
    }), children]
  });
}

FocusLayout.defaultProps = defaultProps$7;
FocusLayout.propTypes = propTypes$d;
var _excluded$5 = ["children"];

function _regenerator$n() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$n(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$n(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$n(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$n(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$n(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$n(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$n(u), _regeneratorDefine2$n(u, o, "Generator"), _regeneratorDefine2$n(u, n, function () {
    return this;
  }), _regeneratorDefine2$n(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$n = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$n(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$n = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$n(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$n(e, r, n, t);
}

function ownKeys$n(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$n(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$n(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$n(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var colors$a = redesignTheme.colors;
redesignTheme.fonts;
var applyBulkSecurity = bulkSecurityService.applyBulkSecurity;
var propTypes$c = {
  recommendations: PropTypes.array.isRequired,
  strings: PropTypes.shape({
    "continue": PropTypes.string,
    email: PropTypes.shape({
      businessStandard: PropTypes.string,
      businessStandardDescription: PropTypes.string,
      businessStarter: PropTypes.string,
      businessStarterDescription: PropTypes.string,
      info: PropTypes.string,
      none: PropTypes.string,
      title: PropTypes.string
    }).isRequired,
    heading: PropTypes.string,
    managedWordpress: PropTypes.shape({
      cta: PropTypes.string,
      description: PropTypes.string,
      nicHead: PropTypes.string,
      rebelHead: PropTypes.string
    }).isRequired,
    protection: PropTypes.shape({
      contentA: PropTypes.string,
      contentB: PropTypes.string,
      info: PropTypes.string,
      learnMore: PropTypes.string,
      none: PropTypes.string,
      ownershipProtection: PropTypes.string,
      ownershipProtectionNone: PropTypes.string,
      planHeading: PropTypes.string,
      plans: PropTypes.array,
      privacyProtection: PropTypes.string,
      privacyProtectionNone: PropTypes.string,
      privacyUrl: PropTypes.string,
      protectionUrl: PropTypes.string,
      reasons: PropTypes.array,
      title: PropTypes.string,
      url: PropTypes.string
    }).isRequired,
    skip: PropTypes.string,
    subHeading: PropTypes.string,
    websiteDesign: PropTypes.shape({
      cta: PropTypes.string,
      description: PropTypes.string,
      placeholder: PropTypes.string,
      prePrice: PropTypes.string,
      price: PropTypes.string,
      requestType: PropTypes.string,
      title: PropTypes.string
    }).isRequired,
    seoTools: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string
    }).isRequired
  }).isRequired
};

function CustomizeCard(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties$8(_ref, _excluded$5);

  return /*#__PURE__*/jsx$1(Stack$2, _objectSpread$n(_objectSpread$n({
    bg: "white",
    border: 2,
    borderRadius: 2,
    justifyContent: "center",
    p: 4
  }, rest), {}, {
    children: children
  }));
}

CustomizeCard.propTypes = {
  children: PropTypes.node.isRequired
};

function Customize(_ref2) {
  var _strings$seoTools, _strings$seoTools2;

  var recommendations = _ref2.recommendations,
      strings = _ref2.strings;

  var _useState = useState(_toConsumableArray$1(recommendations)),
      _useState2 = _slicedToArray$4(_useState, 2),
      loadedRecommendations = _useState2[0],
      setLoadedRecommendations = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$4(_useState3, 2),
      isSticky = _useState4[0],
      setIsSticky = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray$4(_useState5, 2),
      wantsWordpress = _useState6[0],
      setWantsWordpress = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray$4(_useState7, 2),
      wantsSeo = _useState8[0],
      setWantsSeo = _useState8[1];

  var _useState9 = useState('no-email'),
      _useState0 = _slicedToArray$4(_useState9, 2),
      emailProduct = _useState0[0];

  _useState0[1];

  var _useState1 = useState('yes-privacy'),
      _useState10 = _slicedToArray$4(_useState1, 2),
      domainPrivacy = _useState10[0],
      setDomainPrivacy = _useState10[1];

  var _useState11 = useState('yes-protection'),
      _useState12 = _slicedToArray$4(_useState11, 2),
      ownershipExpiry = _useState12[0],
      setOwnershipExpiry = _useState12[1];

  var _useSessionService = useSessionService(),
      currentCurrency = _useSessionService.data.currentCurrency;

  var _useUserService = useUserService(),
      user = _useUserService.user;

  var loadRecommendationPrices = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator$n().m(function _callee() {
      var _yield$get, prices, itemCodes, productPrices;

      return _regenerator$n().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              _context.n = 1;
              return get$3("".concat(pricesEndpoint$1, "?currency=").concat(currentCurrency.code.toUpperCase(), "&reseller=").concat(SERVER_RESELLER));

            case 1:
              _yield$get = _context.v;
              prices = _yield$get.data;

              if (prices) {
                itemCodes = recommendations.map(function (_ref4) {
                  var itemCode = _ref4.itemCode;
                  return itemCode;
                });
                productPrices = prices.filter(function (price) {
                  return itemCodes.includes(price.itemCode);
                });
                setLoadedRecommendations(loadedRecommendations.map(function (rec) {
                  var price = productPrices.find(function (_ref5) {
                    var itemCode = _ref5.itemCode;
                    return rec.itemCode === itemCode;
                  });
                  return _objectSpread$n(_objectSpread$n({}, rec), {}, {
                    price: price
                  });
                }));
              }

            case 2:
              return _context.a(2);
          }
        }
      }, _callee);
    }));

    return function loadRecommendationPrices() {
      return _ref3.apply(this, arguments);
    };
  }();

  useEffect(function () {
    loadRecommendationPrices();
  }, [currentCurrency]);
  var getBulkSecurityPrice = loadedRecommendations === null || loadedRecommendations === void 0 ? void 0 : loadedRecommendations.reduce(function (acc, next) {
    if (bulkSecurityCodes.includes(next.itemCode) && next.price) {
      var _next$price$regular = next.price.regular,
          regPrice = _next$price$regular.price,
          promoPrice = _next$price$regular.promo;

      if (next.itemCode !== 'PRIVACY') {
        acc = Number(acc) + Math.min(regPrice, promoPrice);
      }
    }

    return acc % 1 === 0 ? acc : Number(acc).toFixed(2);
  }, 0);

  var getWordPressPrice = function getWordPressPrice() {
    var mwpRec = loadedRecommendations === null || loadedRecommendations === void 0 ? void 0 : loadedRecommendations.find(function (r) {
      return r.itemCode === 'PPMANAGEDWORDPRESSBASE1';
    });

    if (!(mwpRec !== null && mwpRec !== void 0 && mwpRec.price)) {
      return null;
    }

    var _mwpRec$price$regular = mwpRec.price.regular,
        regPrice = _mwpRec$price$regular.price,
        promoPrice = _mwpRec$price$regular.promo;
    return {
      startingPrice: Math.min(regPrice, promoPrice),
      renewalPrice: Math.max(regPrice, promoPrice)
    };
  };

  var getPrivacyPrice = function getPrivacyPrice() {
    var rec = loadedRecommendations === null || loadedRecommendations === void 0 ? void 0 : loadedRecommendations.find(function (r) {
      return r.itemCode === 'PRIVACY';
    });

    if (!(rec !== null && rec !== void 0 && rec.price)) {
      return null;
    }

    var regPrice = rec.price.regular.price;
    return regPrice;
  };

  var getGWStarterPrice = function getGWStarterPrice() {
    var rec = loadedRecommendations === null || loadedRecommendations === void 0 ? void 0 : loadedRecommendations.find(function (r) {
      return r.itemCode === 'GW_STARTER_USER';
    });

    if (!(rec !== null && rec !== void 0 && rec.price)) {
      return null;
    }

    return rec === null || rec === void 0 ? void 0 : rec.price.regular.price;
  };

  var getGWStandardPrice = function getGWStandardPrice() {
    var rec = loadedRecommendations === null || loadedRecommendations === void 0 ? void 0 : loadedRecommendations.find(function (r) {
      return r.itemCode === 'GW_BUSINESS_USER';
    });

    if (!(rec !== null && rec !== void 0 && rec.price)) {
      return null;
    }

    return rec === null || rec === void 0 ? void 0 : rec.price.regular.price;
  };

  var getExpInsurancePrice = function getExpInsurancePrice() {
    var exp = loadedRecommendations === null || loadedRecommendations === void 0 ? void 0 : loadedRecommendations.find(function (r) {
      return r.itemCode === 'DMEXPINSURANCE';
    });
    var lock = loadedRecommendations === null || loadedRecommendations === void 0 ? void 0 : loadedRecommendations.find(function (r) {
      return r.itemCode === 'DMLOCK';
    });

    if (!(exp !== null && exp !== void 0 && exp.price) || !(lock !== null && lock !== void 0 && lock.price)) {
      return null;
    }

    return (exp === null || exp === void 0 ? void 0 : exp.price.regular.price) + (lock === null || lock === void 0 ? void 0 : lock.price.regular.price);
  };

  var getSEOPrice = function getSEOPrice() {
    var rec = loadedRecommendations === null || loadedRecommendations === void 0 ? void 0 : loadedRecommendations.find(function (r) {
      return r.itemCode === 'MARKETGOOPRO';
    });

    if (!(rec !== null && rec !== void 0 && rec.price)) {
      return null;
    }

    return rec === null || rec === void 0 ? void 0 : rec.price.regular.price;
  };

  var handlePrivacyClick = function handlePrivacyClick(e) {
    setDomainPrivacy(e.target.value);
  };

  var handleOwnershipExpiryClick = function handleOwnershipExpiryClick(e) {
    setOwnershipExpiry(e.target.value);
  };

  var handleContinueClick = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regenerator$n().m(function _callee2() {
      var types, _gwStarterPrice, gwStardardPrice, _wordpressPrice, _seoPrice, _user$features, _t;

      return _regenerator$n().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              _context2.p = 0;

              if (!(domainPrivacy === 'yes-privacy' || ownershipExpiry === 'yes-protection')) {
                _context2.n = 1;
                break;
              }

              if (domainPrivacy === 'yes-privacy') {
                trackEvent({
                  event: ANALYTICS_EVENTS.addToCart,
                  eventCategory: ANALYTICS_CATEGORIES.purchase,
                  data: {
                    products: [{
                      itemCode: 'Privacy',
                      itemDescription: 'Privacy Protection',
                      product: 'Privacy',
                      productCategory: 'Security',
                      amount: getPrivacyPrice()
                    }],
                    currency: currentCurrency.code.toUpperCase(),
                    source: 'Customize'
                  }
                });
              }

              if (ownershipExpiry === 'yes-protection') {
                trackEvent({
                  event: ANALYTICS_EVENTS.addToCart,
                  eventCategory: ANALYTICS_CATEGORIES.purchase,
                  data: {
                    products: [{
                      itemCode: 'DMEXPINSURANCE',
                      itemDescription: 'Expiry Insurance',
                      product: 'ExpiryInsurance',
                      productCategory: 'Security',
                      amount: getExpInsurancePrice()
                    }],
                    currency: currentCurrency.code.toUpperCase(),
                    source: 'Customize'
                  }
                });
              } // Modifiers to bulk security so it knows what to add


              types = [];

              if (domainPrivacy === 'yes-privacy') {
                types.push('PRIVACY');
              }

              if (ownershipExpiry === 'yes-protection') {
                types.push('DMEXPINSURANCE');
              }

              _context2.n = 1;
              return applyBulkSecurity(types);

            case 1:
              if (!(emailProduct === 'business-starter')) {
                _context2.n = 3;
                break;
              }

              _gwStarterPrice = getGWStarterPrice();
              trackEvent({
                event: ANALYTICS_EVENTS.addToCart,
                eventCategory: ANALYTICS_CATEGORIES.purchase,
                data: {
                  products: [{
                    itemCode: 'GW_STARTER',
                    itemDescription: 'Google Workspace Starter',
                    product: 'Google Workspace / Starter',
                    productCategory: 'Email',
                    amount: _gwStarterPrice
                  }],
                  currency: currentCurrency.code.toUpperCase(),
                  path: '/api/googleworkspace/add-to-cart',
                  source: 'Customize'
                }
              });
              _context2.n = 2;
              return post$1('/api/googleworkspace/add-to-cart', {
                packageId: 1,
                users: 1
              });

            case 2:
              _context2.n = 4;
              break;

            case 3:
              if (!(emailProduct === 'business-standard')) {
                _context2.n = 4;
                break;
              }

              gwStardardPrice = getGWStandardPrice();
              trackEvent({
                event: ANALYTICS_EVENTS.addToCart,
                eventCategory: ANALYTICS_CATEGORIES.purchase,
                data: {
                  products: [{
                    itemCode: 'GW_BUSINESS',
                    itemDescription: 'Google Workspace Business',
                    product: 'Google Workspace / Business',
                    productCategory: 'Email',
                    amount: gwStardardPrice
                  }],
                  currency: currentCurrency.code.toUpperCase(),
                  path: '/api/googleworkspace/add-to-cart',
                  source: 'Customize'
                }
              });
              _context2.n = 4;
              return post$1('/api/googleworkspace/add-to-cart', {
                packageId: 2,
                users: 1
              });

            case 4:
              if (!wantsWordpress) {
                _context2.n = 5;
                break;
              }

              _wordpressPrice = getWordPressPrice();
              trackEvent({
                event: ANALYTICS_EVENTS.addToCart,
                eventCategory: ANALYTICS_CATEGORIES.purchase,
                data: {
                  products: [{
                    itemCode: 'PPMANAGEDWORDPRESSBASE1',
                    itemDescription: 'Managed Wordpress',
                    product: 'Plesk / Managed Wordpress',
                    productCategory: 'Hosting',
                    amount: _wordpressPrice.startingPrice
                  }],
                  currency: currentCurrency.code.toUpperCase(),
                  path: '/api/hosting/addplesktocart/PPMANAGEDWORDPRESSBASE1',
                  source: 'Customize'
                }
              });
              _context2.n = 5;
              return get$3('/api/hosting/addplesktocart/PPMANAGEDWORDPRESSBASE1');

            case 5:
              if (!wantsSeo) {
                _context2.n = 6;
                break;
              }

              _seoPrice = getSEOPrice();
              trackEvent({
                event: ANALYTICS_EVENTS.addToCart,
                eventCategory: ANALYTICS_CATEGORIES.purchase,
                data: {
                  products: [{
                    itemCode: 'MARKETGOOPRO',
                    itemDescription: '',
                    product: '',
                    productCategory: '',
                    amount: _seoPrice
                  }],
                  currency: currentCurrency.code.toUpperCase(),
                  path: '',
                  source: 'Customize'
                }
              });
              _context2.n = 6;
              return put$1(addBulkMarketgooEndpoint);

            case 6:
              _context2.n = 8;
              break;

            case 7:
              _context2.p = 7;
              _t = _context2.v;
              console.error('error', _t);

            case 8:
              if (hasDOM) {
                if (user !== null && user !== void 0 && (_user$features = user.features) !== null && _user$features !== void 0 && _user$features.checkoutredesign) {
                  navigateToUrl('/checkout');
                } else {
                  navigateToUrl('/MyAccount/ShoppingCart.aspx');
                }
              }

            case 9:
              return _context2.a(2);
          }
        }
      }, _callee2, null, [[0, 7]]);
    }));

    return function handleContinueClick() {
      return _ref6.apply(this, arguments);
    };
  }();

  useEffect(function () {
    var resolveSticky = function resolveSticky() {
      if (!isSticky && window.scrollY > 130) {
        setIsSticky(true);
      }

      if (isSticky && window.scrollY <= 130) {
        setIsSticky(false);
      }
    };

    if (hasDOM) {
      window.removeEventListener('scroll', resolveSticky);
      window.addEventListener('scroll', resolveSticky);
    }

    return function () {
      window.removeEventListener('scroll', resolveSticky);
    };
  }, [hasDOM, isSticky]);
  getGWStarterPrice();
  getGWStandardPrice();
  var wordpressPrice = getWordPressPrice();
  var privacyPrice = getPrivacyPrice();
  var seoPrice = getSEOPrice();
  return /*#__PURE__*/jsxs(FocusLayout, {
    children: [/*#__PURE__*/jsxs(Box$1, {
      flexDirection: ['column', 'column', 'row'],
      justifyContent: "center",
      maxWidth: ['containers.sm', 'containers.sm', 'containers.md', 'containers.lg'],
      mt: 3,
      pb: 4,
      position: "relative",
      px: [2, 3, 4],
      children: [/*#__PURE__*/jsxs(Stack$2, {
        width: [1, 1, 3 / 4],
        children: [/*#__PURE__*/jsxs(CustomizeCard, {
          mt: 3,
          children: [/*#__PURE__*/jsx$1(Heading, {
            variant: "gigaBold",
            children: strings.protection.title
          }), /*#__PURE__*/jsx$1(StyleReset, {
            children: /*#__PURE__*/jsx$1(Text$1, {
              mt: 3,
              variant: "kilo",
              children: /*#__PURE__*/jsx$1(HtmlBlock, {
                children: strings.protection.contentA
              })
            })
          }), /*#__PURE__*/jsxs(Stack$2, {
            as: "fieldset",
            id: "domain-privacy",
            mb: 4,
            children: [/*#__PURE__*/jsxs(Stack$2, {
              children: [/*#__PURE__*/jsxs(Box$1, {
                justifyContent: "space-between",
                children: [/*#__PURE__*/jsx$1(Radio, {
                  id: "yes-privacy",
                  isChecked: domainPrivacy === 'yes-privacy',
                  name: "domain-privacy",
                  onChange: handlePrivacyClick,
                  text: /*#__PURE__*/jsx$1(Text$1, {
                    ml: 2,
                    variant: "gigaBold",
                    children: strings.protection.privacyProtection
                  }),
                  value: "yes-privacy"
                }), /*#__PURE__*/jsxs(Stack$2, {
                  alignItems: "flex-end",
                  children: [isInternic ? /*#__PURE__*/jsx$1(Box$1, {
                    alignItems: "center",
                    px: 2,
                    children: /*#__PURE__*/jsx$1(Text$1, {
                      color: "greenDark",
                      variant: "gigaBold",
                      children: "FREE"
                    })
                  }) : null, privacyPrice && !isInternic ? /*#__PURE__*/jsxs(Fragment, {
                    children: [/*#__PURE__*/jsx$1(Box$1, {
                      alignItems: "center",
                      px: 2,
                      children: /*#__PURE__*/jsx$1(Text$1, {
                        color: "greenDark",
                        variant: "gigaBold",
                        children: "FREE"
                      })
                    }), /*#__PURE__*/jsx$1(Box$1, {
                      justifyContent: "center",
                      px: 2,
                      width: "100%",
                      children: /*#__PURE__*/jsxs(Text$1, {
                        variant: "milli",
                        children: ["Renews at ", "$".concat(privacyPrice), " /year"]
                      })
                    })]
                  }) : /*#__PURE__*/jsx$1(Skeleton$1, {
                    minHeight: "2rem"
                  })]
                })]
              }), /*#__PURE__*/jsx$1(Link$1, {
                href: strings.protection.privacyUrl,
                newTab: true,
                children: /*#__PURE__*/jsx$1(Text$1, {
                  variant: "kilo",
                  children: strings.protection.learnMore
                })
              })]
            }), /*#__PURE__*/jsx$1(Radio, {
              id: "no-privacy",
              isChecked: domainPrivacy === 'no-privacy',
              mt: 3,
              name: "domain-privacy",
              onChange: handlePrivacyClick,
              text: /*#__PURE__*/jsx$1(Text$1, {
                ml: 2,
                variant: "gigaBold",
                children: strings.protection.privacyProtectionNone
              }),
              value: "no-privacy"
            })]
          }), /*#__PURE__*/jsx$1(StyleReset, {
            borderTop: "1px solid black",
            children: /*#__PURE__*/jsx$1(Text$1, {
              mt: 3,
              variant: "kilo",
              children: /*#__PURE__*/jsx$1(HtmlBlock, {
                children: strings.protection.contentB
              })
            })
          }), /*#__PURE__*/jsxs(Stack$2, {
            as: "fieldset",
            id: "ownership-protection",
            mt: 2,
            children: [/*#__PURE__*/jsxs(Stack$2, {
              children: [/*#__PURE__*/jsxs(Box$1, {
                justifyContent: "space-between",
                children: [/*#__PURE__*/jsx$1(Radio, {
                  id: "yes-protection",
                  isChecked: ownershipExpiry === 'yes-protection',
                  name: "ownership-protection",
                  onChange: handleOwnershipExpiryClick,
                  text: /*#__PURE__*/jsx$1(Text$1, {
                    ml: 2,
                    variant: "gigaBold",
                    children: strings.protection.ownershipProtection
                  }),
                  value: "yes-protection"
                }), /*#__PURE__*/jsx$1(Text$1, {
                  color: "greenDark",
                  variant: "gigaBold",
                  children: "$".concat(getBulkSecurityPrice)
                })]
              }), /*#__PURE__*/jsx$1(Link$1, {
                href: strings.protection.protectionUrl,
                newTab: true,
                children: /*#__PURE__*/jsx$1(Text$1, {
                  variant: "kilo",
                  children: strings.protection.learnMore
                })
              })]
            }), /*#__PURE__*/jsx$1(Radio, {
              id: "no-protection",
              isChecked: ownershipExpiry === 'no-protection',
              mt: 3,
              name: "ownership-protection",
              onChange: handleOwnershipExpiryClick,
              text: /*#__PURE__*/jsx$1(Text$1, {
                ml: 2,
                variant: "gigaBold",
                children: strings.protection.ownershipProtectionNone
              }),
              value: "no-protection"
            })]
          })]
        }), /*#__PURE__*/jsx$1(CustomizeCard, {
          mt: 3,
          children: /*#__PURE__*/jsx$1(Stack$2, {
            as: "fieldset",
            id: "seo-tools",
            children: /*#__PURE__*/jsxs(Box$1, {
              children: [/*#__PURE__*/jsx$1(Checkbox, {
                checkBG: "white",
                checked: wantsSeo,
                "data-testid": "wants-seo",
                id: "wants-seo",
                mt: 2,
                onChange: function onChange(_ref7) {
                  var value = _ref7.value;
                  return setWantsSeo(value);
                },
                text: /*#__PURE__*/jsxs(Stack$2, {
                  ml: 2,
                  children: [/*#__PURE__*/jsx$1(Text$1, {
                    variant: "gigaBold",
                    children: strings === null || strings === void 0 ? void 0 : (_strings$seoTools = strings.seoTools) === null || _strings$seoTools === void 0 ? void 0 : _strings$seoTools.title
                  }), /*#__PURE__*/jsx$1(Text$1, {
                    children: strings === null || strings === void 0 ? void 0 : (_strings$seoTools2 = strings.seoTools) === null || _strings$seoTools2 === void 0 ? void 0 : _strings$seoTools2.description
                  })]
                })
              }), /*#__PURE__*/jsx$1(Stack$2, {
                children: /*#__PURE__*/jsx$1(Text$1, {
                  children: seoPrice ? /*#__PURE__*/jsxs(Box$1, {
                    alignItems: "center",
                    children: [/*#__PURE__*/jsx$1(Text$1, {
                      variant: "gigaBold",
                      children: "$".concat(parseFloat(seoPrice).toFixed(2))
                    }), /*#__PURE__*/jsx$1(Text$1, {
                      ml: 2,
                      variant: "kilo",
                      children: "/mo"
                    })]
                  }) : null
                })
              })]
            })
          })
        }), /*#__PURE__*/jsx$1(CustomizeCard, {
          bg: colors$a.blueDark,
          color: "white",
          mt: 3,
          children: /*#__PURE__*/jsx$1(Stack$2, {
            bg: colors$a.blueDark,
            width: "100%",
            children: /*#__PURE__*/jsx$1(Box$1, {
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              children: /*#__PURE__*/jsxs(Stack$2, {
                alignItems: "center",
                width: "90%",
                children: [/*#__PURE__*/jsx$1(Checkbox, {
                  checkBG: "white",
                  checked: wantsWordpress,
                  "data-testid": "wants-wordpress",
                  id: "wants-wordpress",
                  mt: 2,
                  onChange: function onChange(_ref8) {
                    var value = _ref8.value;
                    return setWantsWordpress(value);
                  },
                  text: /*#__PURE__*/jsxs(Stack$2, {
                    ml: 2,
                    children: [/*#__PURE__*/jsxs(Text$1, {
                      variant: "gigaBold",
                      children: [strings.managedWordpress.cta, ' ', isInternic ? strings.managedWordpress.nicHead : strings.managedWordpress.rebelHead]
                    }), /*#__PURE__*/jsx$1(Text$1, {
                      children: wordpressPrice && "Starting at $".concat(parseFloat(wordpressPrice.startingPrice).toFixed(2), " / month")
                    })]
                  })
                }), /*#__PURE__*/jsx$1(Text$1, {
                  mt: 3,
                  children: "Fast and reliable WordPress hosting with pre-installed Elementor Builder"
                }), /*#__PURE__*/jsx$1(Text$1, {
                  children: "Say goodbye to daily maintenance and manual updates"
                }), /*#__PURE__*/jsxs(Box$1, {
                  justifyContent: "space-evenly",
                  mt: 3,
                  width: "100%",
                  children: [/*#__PURE__*/jsxs(Box$1, {
                    children: [/*#__PURE__*/jsx$1(Text$1, {
                      children: "Automatic SSL"
                    }), /*#__PURE__*/jsx$1(Text$1, {
                      bg: "white",
                      borderRadius: "12px",
                      color: colors$a.blueDark,
                      ml: 2,
                      px: 2,
                      variant: "megaBold",
                      children: "FREE"
                    })]
                  }), /*#__PURE__*/jsxs(Box$1, {
                    children: [/*#__PURE__*/jsx$1(Text$1, {
                      children: "Malware Security"
                    }), /*#__PURE__*/jsx$1(Text$1, {
                      bg: "white",
                      borderRadius: "12px",
                      color: colors$a.blueDark,
                      ml: 2,
                      px: 2,
                      variant: "megaBold",
                      children: "FREE"
                    })]
                  })]
                })]
              })
            })
          })
        })]
      }), /*#__PURE__*/jsx$1(Box$1, {
        alignItems: "flex-start",
        bottom: [3, 3, 'auto'],
        left: [3, 3, 'auto'],
        ml: [0, 0, 3],
        position: ['fixed', 'fixed', 'relative'],
        width: ['auto', 'auto', '23rem'],
        children: /*#__PURE__*/jsxs(Button$1, {
          alignSelf: "flex-start",
          color: "blue",
          onClick: handleContinueClick,
          position: ['relative', 'relative', isSticky ? 'fixed' : 'relative'],
          top: ['auto', 'auto', isSticky ? '20px' : 'auto'],
          children: [/*#__PURE__*/jsx$1(Icon$2, {
            display: ['block', 'block', 'none'],
            height: "2rem",
            name: "cart",
            title: "continue to checkout",
            width: "2rem"
          }), /*#__PURE__*/jsx$1(Icon$2, {
            display: ['none', 'none', 'block'],
            height: "1.5rem",
            name: "cart",
            title: "continue to checkout",
            width: "1.5rem"
          }), /*#__PURE__*/jsx$1(Text$1, {
            display: ['none', 'flex'],
            ml: 2,
            variant: ['kilo', 'kilo', 'pound'],
            children: strings["continue"]
          }), /*#__PURE__*/jsx$1(Text$1, {
            display: ['flex', 'none'],
            ml: 2,
            variant: ['kilo', 'kilo', 'pound'],
            children: strings["continue"]
          })]
        })
      })]
    }), /*#__PURE__*/jsx$1(Box$1, {
      my: 5,
      children: /*#__PURE__*/jsx$1(HelpSection, {})
    })]
  });
}

Customize.propTypes = propTypes$c;

var _templateObject$j, _templateObject2$d;

function _regenerator$m() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$m(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$m(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$m(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$m(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$m(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$m(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$m(u), _regeneratorDefine2$m(u, o, "Generator"), _regeneratorDefine2$m(u, n, function () {
    return this;
  }), _regeneratorDefine2$m(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$m = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$m(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$m = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$m(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$m(e, r, n, t);
}

function DomainStep(_ref) {
  var onComplete = _ref.onComplete;

  var _useState = useState(''),
      _useState2 = _slicedToArray$4(_useState, 2),
      domain = _useState2[0],
      setDomain = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray$4(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray$4(_useState5, 2),
      isLoading = _useState6[0],
      setIsLoading = _useState6[1];

  function onSubmit() {
    return _onSubmit.apply(this, arguments);
  }

  function _onSubmit() {
    _onSubmit = _asyncToGenerator( /*#__PURE__*/_regenerator$m().m(function _callee() {
      var _yield$axios$get, data, _error$err, _error$err$ex, _t;

      return _regenerator$m().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              if (isValidDomain(domain)) {
                _context.n = 1;
                break;
              }

              setError('Valid domain name is required.');
              return _context.a(2);

            case 1:
              setIsLoading(true);
              _context.p = 2;
              _context.n = 3;
              return axios.get(quickRenewEndpoints.summary(domain));

            case 3:
              _yield$axios$get = _context.v;
              data = _yield$axios$get.data;
              onComplete(data.result);
              _context.n = 5;
              break;

            case 4:
              _context.p = 4;
              _t = _context.v;
              setError((_t === null || _t === void 0 ? void 0 : (_error$err = _t.err) === null || _error$err === void 0 ? void 0 : (_error$err$ex = _error$err.ex) === null || _error$err$ex === void 0 ? void 0 : _error$err$ex.Message) || 'Unexpected Error');

            case 5:
              setIsLoading(false);

            case 6:
              return _context.a(2);
          }
        }
      }, _callee, null, [[2, 4]]);
    }));
    return _onSubmit.apply(this, arguments);
  }

  return /*#__PURE__*/jsxs(_StyledStack$c, {
    justifyContent: "center",
    alignItems: "center",
    p: 4,
    children: [/*#__PURE__*/jsxs(Stack$2, {
      children: [/*#__PURE__*/jsx$1(_StyledText$g, {
        as: "h1",
        variant: "gigaBold",
        children: "Quick Renew"
      }), /*#__PURE__*/jsx$1(Text$1, {
        children: "Having trouble accessing your account and need to urgently renew your domain?"
      })]
    }), /*#__PURE__*/jsxs(_StyledBox$a, {
      children: [/*#__PURE__*/jsx$1(Input$5, {
        required: true,
        value: domain,
        placeholder: "mydomain.ca",
        onChange: function onChange(e) {
          return setDomain(e.target.value);
        }
      }), /*#__PURE__*/jsx$1(Button$1, {
        color: isInternic ? 'blueDark' : 'deepKoamaru',
        onClick: onSubmit,
        disabled: isLoading,
        children: isLoading ? 'Loading..' : 'Submit'
      })]
    }), error && /*#__PURE__*/jsx$1(Message, {
      variant: "error",
      children: error
    })]
  });
}

var _StyledStack$c = styled(Stack$2)(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral$1(["\n        border: 1px solid rgba(0, 0, 0, 0.1);\n        border-radius: 15px;\n        gap: 4rem;\n        text-align: center;\n      "])));

var _StyledText$g = styled(Text$1)(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteral$1(["\n            font-size: 3.5rem !important;\n          "])));

var _StyledBox$a = styled(Box$1).withConfig({
  displayName: "domain-step___StyledBox",
  componentId: "sc-caqcso-0"
})(["gap:12px;"]);

var _templateObject$i, _templateObject2$c, _templateObject3$7, _templateObject4$4, _templateObject5$2;

function _regenerator$l() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$l(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$l(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$l(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$l(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$l(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$l(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$l(u), _regeneratorDefine2$l(u, o, "Generator"), _regeneratorDefine2$l(u, n, function () {
    return this;
  }), _regeneratorDefine2$l(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$l = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$l(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$l = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$l(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$l(e, r, n, t);
}

function PaymentStep(_ref) {
  var cartSummary = _ref.cartSummary,
      cancel = _ref.cancel,
      onSuccess = _ref.onSuccess;

  var _useState = useState(''),
      _useState2 = _slicedToArray$4(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  function onTokenCreated(_x, _x2) {
    return _onTokenCreated.apply(this, arguments);
  }

  function _onTokenCreated() {
    _onTokenCreated = _asyncToGenerator( /*#__PURE__*/_regenerator$l().m(function _callee(token, cardType) {
      var _yield$axios$post, data;

      return _regenerator$l().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              if (cartSummary) {
                _context.n = 1;
                break;
              }

              return _context.a(2);

            case 1:
              _context.p = 1;
              _context.n = 2;
              return axios.post(quickRenewEndpoints.process(cartSummary.Domain, token));

            case 2:
              _yield$axios$post = _context.v;
              data = _yield$axios$post.data;
              onSuccess(data.result.split('T')[0]);
              _context.n = 4;
              break;

            case 3:
              _context.p = 3;
              setError('Could not renew your domain.');

            case 4:
              return _context.a(2);
          }
        }
      }, _callee, null, [[1, 3]]);
    }));
    return _onTokenCreated.apply(this, arguments);
  }

  if (!cartSummary) {
    return /*#__PURE__*/jsx$1(Message, {
      children: "Unexpected Error"
    });
  }

  return /*#__PURE__*/jsxs(_StyledStack$b, {
    justifyContent: "center",
    alignItems: "center",
    p: 4,
    children: [/*#__PURE__*/jsx$1(_StyledBox$9, {
      onClick: cancel,
      children: /*#__PURE__*/jsx$1(CircleArrowLeft, {})
    }), /*#__PURE__*/jsxs(Stack$2, {
      children: [/*#__PURE__*/jsx$1(_StyledText$f, {
        as: "h1",
        variant: "gigaBold",
        children: "Purchase Summary"
      }), /*#__PURE__*/jsxs(Text$1, {
        children: ["Renewing the domain \"", cartSummary.Domain, "\" for 1 year."]
      })]
    }), /*#__PURE__*/jsxs(_StyledBox2$3, {
      children: [/*#__PURE__*/jsx$1(Box$1, {
        p: 2,
        bg: isInternic ? 'blueDark' : 'deepKoamaru',
        children: /*#__PURE__*/jsxs(_StyledText2$2, {
          color: "white",
          variant: "gigaBold",
          children: [".", cartSummary.Domain.split('.').reverse()[0]]
        })
      }), /*#__PURE__*/jsxs(Stack$2, {
        alignItems: "start",
        css: true,
        children: [/*#__PURE__*/jsx$1("span", {
          style: {
            fontWeight: 700
          },
          children: cartSummary.Domain
        }), cartSummary.Addons.map(function (addon) {
          return /*#__PURE__*/jsx$1(_StyledText3, {
            children: addon
          });
        })]
      })]
    }), /*#__PURE__*/jsx$1(ChargebeeForm, {
      customPrimaryAction: "Renew \u2022 $".concat(cartSummary.Total),
      onTokenCreated: onTokenCreated
    }), error && /*#__PURE__*/jsx$1(Message, {
      variant: "error",
      children: error
    })]
  });
}

var _StyledStack$b = styled(Stack$2)(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral$1(["\n        position: relative;\n        border: 1px solid rgba(0, 0, 0, 0.1);\n        border-radius: 15px;\n        gap: 4rem;\n        text-align: center;\n      "])));

var _StyledBox$9 = styled(Box$1)(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteral$1(["\n          position: absolute;\n          top: 4px;\n          left: 4px;\n          padding: 6px;\n          transition: 0.2s;\n          cursor: pointer;\n          border-radius: 999px;\n          color: rgba(0, 0, 0, 0.75);\n          &:hover {\n            background: rgba(0, 0, 0, 0.1);\n          }\n        "])));

var _StyledText$f = styled(Text$1)(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteral$1(["\n            font-size: 3.5rem !important;\n          "])));

var _StyledBox2$3 = styled(Box$1)(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral$1(["\n          gap: 2rem;\n        "])));

var _StyledText2$2 = styled(Text$1)(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral$1(["\n              font-size: 2.5rem !important;\n            "])));

var _StyledText3 = styled(Text$1).withConfig({
  displayName: "payment-step___StyledText3",
  componentId: "sc-1pv6l79-0"
})(["margin-left:6px;opacity:0.75;font-size:1.2rem;"]);

var _templateObject$h;

function ResultStep(_ref) {
  var domain = _ref.domain,
      expiryDate = _ref.expiryDate;

  var _useSunshine = useSunshine(),
      openChat = _useSunshine.openChat;

  return /*#__PURE__*/jsxs(_StyledStack$a, {
    justifyContent: "center",
    alignItems: "center",
    p: 4,
    children: [/*#__PURE__*/jsx$1(_StyledText$e, {
      as: "h1",
      variant: "gigaBold",
      children: "Congratulations."
    }), /*#__PURE__*/jsx$1(CircleCheck, {
      size: 80,
      color: "green"
    }), /*#__PURE__*/jsxs(Text$1, {
      children: ["You have successfully renewed ", domain, ". Your new expiry date is", ' ', expiryDate, "."]
    }), /*#__PURE__*/jsx$1(Text$1, {
      variant: "milli",
      children: "Still need help accessing your account?"
    }), /*#__PURE__*/jsx$1(Button$1, {
      onClick: openChat,
      children: "Talk To Support"
    })]
  });
}

var _StyledStack$a = styled(Stack$2)(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral$1(["\n        position: relative;\n        border: 1px solid rgba(0, 0, 0, 0.1);\n        border-radius: 15px;\n        gap: 4rem;\n        text-align: center;\n      "])));

var _StyledText$e = styled(Text$1).withConfig({
  displayName: "result-step___StyledText",
  componentId: "sc-19v0wgw-0"
})(["font-size:3.5rem !important;"]);

function QuickRenew() {
  var _useState = useState('domain'),
      _useState2 = _slicedToArray$4(_useState, 2),
      step = _useState2[0],
      setStep = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray$4(_useState3, 2),
      cartSummary = _useState4[0],
      setCartSummary = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray$4(_useState5, 2),
      newExpiry = _useState6[0],
      setNewExpiry = _useState6[1];

  function onCompleteDomainStep(cartSummary) {
    setCartSummary(cartSummary);
    setStep('payment');
  }

  function onSuccess(newPaidExpiryDate) {
    setNewExpiry(newPaidExpiryDate);
    setStep('result');
  }

  return /*#__PURE__*/jsxs(Stack$2, {
    children: [step === 'domain' && /*#__PURE__*/jsx$1(DomainStep, {
      onComplete: onCompleteDomainStep
    }), step === 'payment' && /*#__PURE__*/jsx$1(PaymentStep, {
      cartSummary: cartSummary,
      onSuccess: onSuccess,
      cancel: function cancel() {
        setCartSummary(undefined);
        setStep('domain');
      }
    }), step === 'result' && /*#__PURE__*/jsx$1(ResultStep, {
      domain: (cartSummary === null || cartSummary === void 0 ? void 0 : cartSummary.Domain) || '',
      expiryDate: newExpiry
    })]
  });
}

var EVENTS = {
  ItemsChanged: 'Item Changed in Cart'
};
var domain; // This constructor is used to store event handlers. Instantiating this is
// faster than explicitly calling `Object.create(null)` to get a "clean" empty
// object (tested with v8 v4.9).

function EventHandlers() {}

EventHandlers.prototype = Object.create(null);

function EventEmitter() {
  EventEmitter.init.call(this);
} // nodejs oddity
// require('events') === require('events').EventEmitter


EventEmitter.EventEmitter = EventEmitter;
EventEmitter.usingDomains = false;
EventEmitter.prototype.domain = undefined;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined; // By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.

EventEmitter.defaultMaxListeners = 10;

EventEmitter.init = function () {
  this.domain = null;

  if (EventEmitter.usingDomains) {
    // if there is an active domain, then attach to it.
    if (domain.active) ;
  }

  if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
    this._events = new EventHandlers();
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
}; // Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.


EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || isNaN(n)) throw new TypeError('"n" argument must be a positive number');
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
}; // These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.


function emitNone(handler, isFn, self) {
  if (isFn) handler.call(self);else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);

    for (var i = 0; i < len; ++i) {
      listeners[i].call(self);
    }
  }
}

function emitOne(handler, isFn, self, arg1) {
  if (isFn) handler.call(self, arg1);else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);

    for (var i = 0; i < len; ++i) {
      listeners[i].call(self, arg1);
    }
  }
}

function emitTwo(handler, isFn, self, arg1, arg2) {
  if (isFn) handler.call(self, arg1, arg2);else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);

    for (var i = 0; i < len; ++i) {
      listeners[i].call(self, arg1, arg2);
    }
  }
}

function emitThree(handler, isFn, self, arg1, arg2, arg3) {
  if (isFn) handler.call(self, arg1, arg2, arg3);else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);

    for (var i = 0; i < len; ++i) {
      listeners[i].call(self, arg1, arg2, arg3);
    }
  }
}

function emitMany(handler, isFn, self, args) {
  if (isFn) handler.apply(self, args);else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);

    for (var i = 0; i < len; ++i) {
      listeners[i].apply(self, args);
    }
  }
}

EventEmitter.prototype.emit = function emit(type) {
  var er, handler, len, args, i, events, domain;
  var doError = type === 'error';
  events = this._events;
  if (events) doError = doError && events.error == null;else if (!doError) return false;
  domain = this.domain; // If there is no 'error' event listener then throw.

  if (doError) {
    er = arguments[1];

    if (domain) {
      if (!er) er = new Error('Uncaught, unspecified "error" event');
      er.domainEmitter = this;
      er.domain = domain;
      er.domainThrown = false;
      domain.emit('error', er);
    } else if (er instanceof Error) {
      throw er; // Unhandled 'error' event
    } else {
      // At least give some kind of context to the user
      var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
      err.context = er;
      throw err;
    }

    return false;
  }

  handler = events[type];
  if (!handler) return false;
  var isFn = typeof handler === 'function';
  len = arguments.length;

  switch (len) {
    // fast cases
    case 1:
      emitNone(handler, isFn, this);
      break;

    case 2:
      emitOne(handler, isFn, this, arguments[1]);
      break;

    case 3:
      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
      break;

    case 4:
      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
      break;
    // slower

    default:
      args = new Array(len - 1);

      for (i = 1; i < len; i++) {
        args[i - 1] = arguments[i];
      }

      emitMany(handler, isFn, this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;
  if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
  events = target._events;

  if (!events) {
    events = target._events = new EventHandlers();
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener) {
      target.emit('newListener', type, listener.listener ? listener.listener : listener); // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object

      events = target._events;
    }

    existing = events[type];
  }

  if (!existing) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] = prepend ? [listener, existing] : [existing, listener];
    } else {
      // If we've already got an array, just append.
      if (prepend) {
        existing.unshift(listener);
      } else {
        existing.push(listener);
      }
    } // Check for listener leak


    if (!existing.warned) {
      m = $getMaxListeners(target);

      if (m && m > 0 && existing.length > m) {
        existing.warned = true;
        var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + type + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit');
        w.name = 'MaxListenersExceededWarning';
        w.emitter = target;
        w.type = type;
        w.count = existing.length;
        emitWarning(w);
      }
    }
  }

  return target;
}

function emitWarning(e) {
  typeof console.warn === 'function' ? console.warn(e) : console.log(e);
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener = function prependListener(type, listener) {
  return _addListener(this, type, listener, true);
};

function _onceWrap(target, type, listener) {
  var fired = false;

  function g() {
    target.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(target, arguments);
    }
  }

  g.listener = listener;
  return g;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
  if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
  this.prependListener(type, _onceWrap(this, type, listener));
  return this;
}; // emits a 'removeListener' event iff the listener was removed


EventEmitter.prototype.removeListener = function removeListener(type, listener) {
  var list, events, position, i, originalListener;
  if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
  events = this._events;
  if (!events) return this;
  list = events[type];
  if (!list) return this;

  if (list === listener || list.listener && list.listener === listener) {
    if (--this._eventsCount === 0) this._events = new EventHandlers();else {
      delete events[type];
      if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
    }
  } else if (typeof list !== 'function') {
    position = -1;

    for (i = list.length; i-- > 0;) {
      if (list[i] === listener || list[i].listener && list[i].listener === listener) {
        originalListener = list[i].listener;
        position = i;
        break;
      }
    }

    if (position < 0) return this;

    if (list.length === 1) {
      list[0] = undefined;

      if (--this._eventsCount === 0) {
        this._events = new EventHandlers();
        return this;
      } else {
        delete events[type];
      }
    } else {
      spliceOne(list, position);
    }

    if (events.removeListener) this.emit('removeListener', type, originalListener || listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
  var listeners, events;
  events = this._events;
  if (!events) return this; // not listening for removeListener, no need to emit

  if (!events.removeListener) {
    if (arguments.length === 0) {
      this._events = new EventHandlers();
      this._eventsCount = 0;
    } else if (events[type]) {
      if (--this._eventsCount === 0) this._events = new EventHandlers();else delete events[type];
    }

    return this;
  } // emit removeListener for all listeners on all events


  if (arguments.length === 0) {
    var keys = Object.keys(events);

    for (var i = 0, key; i < keys.length; ++i) {
      key = keys[i];
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }

    this.removeAllListeners('removeListener');
    this._events = new EventHandlers();
    this._eventsCount = 0;
    return this;
  }

  listeners = events[type];

  if (typeof listeners === 'function') {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    do {
      this.removeListener(type, listeners[listeners.length - 1]);
    } while (listeners[0]);
  }

  return this;
};

EventEmitter.prototype.listeners = function listeners(type) {
  var evlistener;
  var ret;
  var events = this._events;
  if (!events) ret = [];else {
    evlistener = events[type];
    if (!evlistener) ret = [];else if (typeof evlistener === 'function') ret = [evlistener.listener || evlistener];else ret = unwrapListeners(evlistener);
  }
  return ret;
};

EventEmitter.listenerCount = function (emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;

function listenerCount(type) {
  var events = this._events;

  if (events) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
}; // About 1.5x faster than the two-arg version of Array#splice().


function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

function arrayClone(arr, i) {
  var copy = new Array(i);

  while (i--) {
    copy[i] = arr[i];
  }

  return copy;
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);

  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }

  return ret;
}

var getBaseBackendEndpoint = function getBaseBackendEndpoint() {
  if (__LOCAL__) {
    return "https://local.".concat(RESELLER);
  }

  if (__DEV__) {
    return "https://dev.".concat(RESELLER);
  }

  return "https://www.".concat(RESELLER);
};

var getRebelSearchEndpoint = function getRebelSearchEndpoint() {
  if (__LOCAL__) {
    return "http://localhost:8085";
  }

  if (__DEV__) {
    return "https://dev.search.".concat(RESELLER);
  }

  return "https://search.".concat(RESELLER);
};

var getPricesEndpoint = function getPricesEndpoint() {
  if (__PROD__) {
    return "https://www.".concat(RESELLER, "/api/price");
  }

  return "https://dev.".concat(RESELLER, "/api/price");
};

var pricesEndpoint = getPricesEndpoint();
var rebelSearchEndpoint = getRebelSearchEndpoint();
var baseBackendEndpoint = getBaseBackendEndpoint();
/**
 * Determines if a domain is already in the cart to prevent re-adding.
 */

function cartContainsDomain(cart, domain) {
  return cart.find(function (_ref) {
    var Name = _ref.Name,
        Type = _ref.Type;
    return Name === domain && (Type === 'GA' || Type === 'PR');
  }) !== undefined;
}

function determinePricing(_ref2) {
  var annual = _ref2.annual,
      regular = _ref2.regular,
      itemCode = _ref2.itemCode; // Special case because they only use promo price if bundled.

  var SPECIAL_CASES = ['DMLOCK', 'DMEXPINSURANCE'];

  if (SPECIAL_CASES.includes(itemCode)) {
    return {
      reg: regular.price,
      rnw: regular.price
    };
  }

  return annual ? {
    reg: annual.promo,
    rnw: annual.price
  } : {
    reg: regular.promo,
    rnw: regular.price
  };
}
/** Hardcoded prices, we don't have a way to fetch OP/EP prices dynamically. */


function getOPEPBundlePrices(currency) {
  if (currency === 'CAD') {
    return {
      reg: 10,
      rnw: 50
    };
  }

  if (currency === 'USD') {
    return {
      reg: 7.6,
      rnw: 38
    };
  } // Unsupported currency?


  return {
    reg: -1,
    rnw: -1
  };
}

function getDomainParts(domain) {
  var _parts$slice, _parts$slice$join;

  var parts = domain.split('.');
  return {
    domainName: parts[0],
    tld: ((_parts$slice = parts.slice(1)) === null || _parts$slice === void 0 ? void 0 : (_parts$slice$join = _parts$slice.join('.')) === null || _parts$slice$join === void 0 ? void 0 : _parts$slice$join.trim()) || null
  };
}
/** Returns the first available domain. */


function findFirstAvailableDomain(fetchedDomains) {
  return Object.values(fetchedDomains).find(function (domain) {
    return domain.available;
  });
}
/**
 * Determines if the query was found in the domains results list.
 * @param fetchedDomains Fetched information for domains.
 * @param query Search query.
 * @returns Availability of domain query.
 */


function determineAvailability(fetchedDomains, query) {
  var domain = fetchedDomains[query];

  if (!domain) {
    return 'INVALID';
  }

  return domain.available ? 'AVAILABLE' : 'UNAVAILABLE';
}

function getDynamicFontSize(domain) {
  var fontSize = ['28px', '32px', '32px'];

  if (domain.length > 12) {
    fontSize = ['24px', '28px', '28px'];
  }

  if (domain.length > 18) {
    fontSize = ['20px', '24px', '24px'];
  }

  if (domain.length > 22) {
    fontSize = ['16px', '20px', '20px'];
  }

  return fontSize;
}

function _regenerator$k() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$k(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$k(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$k(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$k(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$k(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$k(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$k(u), _regeneratorDefine2$k(u, o, "Generator"), _regeneratorDefine2$k(u, n, function () {
    return this;
  }), _regeneratorDefine2$k(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$k = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$k(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$k = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$k(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$k(e, r, n, t);
}

function _callSuper(t, o, e) {
  return o = _getPrototypeOf$1(o), _possibleConstructorReturn$2(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf$1(t).constructor) : o.apply(t, e));
}

function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}

  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

var CartService = /*#__PURE__*/function (_EventEmitter) {
  function CartService() {
    var _this;

    _classCallCheck$a(this, CartService);

    _this = _callSuper(this, CartService);
    /**
     * Takes you to the SEDO brokerage page for this domain.
     * @param domain Full domainName, including TLD.
     */

    _defineProperty$6(_this, "goToSedo", function (domain) {
      trackEvent({
        event: ANALYTICS_EVENTS.hireBrokerClick
      });
      window.open(_this.getSedoUrl(domain), '_blank');
    });

    _this.campaignId = isInternic ? 330250 : 330248;
    _this.client = axios.create({
      baseURL: baseBackendEndpoint,
      withCredentials: true
    });
    return _this;
  }
  /** Adds a single domain to cart. */


  _inherits$2(CartService, _EventEmitter);

  return _createClass$a(CartService, [{
    key: "addDomain",
    value: function () {
      var _addDomain = _asyncToGenerator( /*#__PURE__*/_regenerator$k().m(function _callee(params) {
        return _regenerator$k().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.n = 1;
                return this.client.get("/SearchData.ashx".concat(CartService.getAddDomainToCartQueryParams(params)));

              case 1:
                trackEvent({
                  event: ANALYTICS_EVENTS.addToCart,
                  eventCategory: ANALYTICS_CATEGORIES.purchase,
                  data: {
                    products: [{
                      itemCode: params.tld.toUpperCase(),
                      itemDescription: params.domain,
                      product: 'Domain',
                      productCategory: 'Domains'
                    }]
                  }
                });
                this.emit(EVENTS.ItemsChanged);

              case 2:
                return _context.a(2);
            }
          }
        }, _callee, this);
      }));

      function addDomain(_x) {
        return _addDomain.apply(this, arguments);
      }

      return addDomain;
    }()
    /** Adds many domains to cart. */

  }, {
    key: "addBulkDomains",
    value: function () {
      var _addBulkDomains = _asyncToGenerator( /*#__PURE__*/_regenerator$k().m(function _callee2(params) {
        var _this2 = this;

        var promises;
        return _regenerator$k().w(function (_context2) {
          while (1) {
            switch (_context2.n) {
              case 0:
                promises = params.map(function (param) {
                  return _this2.client("/SearchData.ashx".concat(CartService.getAddDomainToCartQueryParams(param)));
                });
                _context2.n = 1;
                return Promise.all(promises);

              case 1:
                trackEvent({
                  event: ANALYTICS_EVENTS.addToCart,
                  eventCategory: ANALYTICS_CATEGORIES.purchase,
                  data: {
                    products: params.map(function (param) {
                      return {
                        itemCode: param.tld.toUpperCase(),
                        itemDescription: param.domain,
                        product: 'Domain',
                        productCategory: 'Domains'
                      };
                    })
                  }
                });
                this.emit(EVENTS.ItemsChanged);

              case 2:
                return _context2.a(2);
            }
          }
        }, _callee2, this);
      }));

      function addBulkDomains(_x2) {
        return _addBulkDomains.apply(this, arguments);
      }

      return addBulkDomains;
    }()
  }, {
    key: "removeDomain",
    value: function () {
      var _removeDomain = _asyncToGenerator( /*#__PURE__*/_regenerator$k().m(function _callee3(domain) {
        return _regenerator$k().w(function (_context3) {
          while (1) {
            switch (_context3.n) {
              case 0:
                _context3.n = 1;
                return this.client.get("/SearchData.ashx?a=r&name=".concat(domain));

              case 1:
                this.emit(EVENTS.ItemsChanged);

              case 2:
                return _context3.a(2);
            }
          }
        }, _callee3, this);
      }));

      function removeDomain(_x3) {
        return _removeDomain.apply(this, arguments);
      }

      return removeDomain;
    }()
  }, {
    key: "removeBulkDomains",
    value: function () {
      var _removeBulkDomains = _asyncToGenerator( /*#__PURE__*/_regenerator$k().m(function _callee4(domains) {
        var _this3 = this;

        var promises;
        return _regenerator$k().w(function (_context4) {
          while (1) {
            switch (_context4.n) {
              case 0:
                promises = domains.map(function (domain) {
                  return _this3.client("/SearchData.ashx?a=r&name=".concat(domain));
                });
                _context4.n = 1;
                return Promise.all(promises);

              case 1:
                this.emit(EVENTS.ItemsChanged);

              case 2:
                return _context4.a(2);
            }
          }
        }, _callee4, this);
      }));

      function removeBulkDomains(_x4) {
        return _removeBulkDomains.apply(this, arguments);
      }

      return removeBulkDomains;
    }()
    /** Adds add-ons to local cart in one call. */

  }, {
    key: "addAddons",
    value: function () {
      var _addAddons = _asyncToGenerator( /*#__PURE__*/_regenerator$k().m(function _callee5(params) {
        return _regenerator$k().w(function (_context5) {
          while (1) {
            switch (_context5.n) {
              case 0:
                trackEvent({
                  event: ANALYTICS_EVENTS.addToCart,
                  eventCategory: ANALYTICS_CATEGORIES.purchase,
                  data: {
                    products: [].concat(_toConsumableArray$1(params.DomainAddOns.map(function (domainAddon) {
                      return {
                        itemCode: domainAddon
                      };
                    })), _toConsumableArray$1(params.HostingAddOns.map(function (hostingAddon) {
                      return {
                        itemCode: hostingAddon
                      };
                    })))
                  }
                });
                return _context5.a(2, this.client.post('/api/order/add-ons', params));
            }
          }
        }, _callee5, this);
      }));

      function addAddons(_x5) {
        return _addAddons.apply(this, arguments);
      }

      return addAddons;
    }()
    /** Adds bundle to cart. Expects domains to already be present in cart. */

  }, {
    key: "addBundle",
    value: function () {
      var _addBundle = _asyncToGenerator( /*#__PURE__*/_regenerator$k().m(function _callee6(_ref) {
        var domainName, bundleId;
        return _regenerator$k().w(function (_context6) {
          while (1) {
            switch (_context6.n) {
              case 0:
                domainName = _ref.domainName, bundleId = _ref.bundleId;
                return _context6.a(2, this.client.post('/api/order/domains/bundle', {
                  bundleId: bundleId,
                  baseDomain: domainName
                }));
            }
          }
        }, _callee6, this);
      }));

      function addBundle(_x6) {
        return _addBundle.apply(this, arguments);
      }

      return addBundle;
    }()
    /**
     * Fetches a simplified session cart summary.
     */

  }, {
    key: "getSummary",
    value: function () {
      var _getSummary = _asyncToGenerator( /*#__PURE__*/_regenerator$k().m(function _callee7() {
        var _yield$this$client$ge, data;

        return _regenerator$k().w(function (_context7) {
          while (1) {
            switch (_context7.n) {
              case 0:
                _context7.n = 1;
                return this.client.get('/SearchData.ashx?a=cs&includeChildItems=true');

              case 1:
                _yield$this$client$ge = _context7.v;
                data = _yield$this$client$ge.data;
                return _context7.a(2, data);
            }
          }
        }, _callee7, this);
      }));

      function getSummary() {
        return _getSummary.apply(this, arguments);
      }

      return getSummary;
    }()
  }, {
    key: "getSedoUrl",
    value: function getSedoUrl(domain) {
      return "https://sedo.com/checkdomainoffer.php?language=us&domain=".concat(domain, "&campaignId=").concat(this.campaignId);
    }
  }], [{
    key: "getAddDomainToCartQueryParams",
    value: function getAddDomainToCartQueryParams(_ref2) {
      var domain = _ref2.domain,
          tld = _ref2.tld,
          registryPremium = _ref2.registryPremium,
          premiumStatus = _ref2.premiumStatus,
          broker = _ref2.broker;

      var _getDomainParts = getDomainParts(domain),
          domainName = _getDomainParts.domainName;

      var regPremium = registryPremium ? 'true' : 'false';
      var premStatus = premiumStatus || 'Available';
      var addToCartPath = "?a=b&name=".concat(domainName, "&tld=").concat(tld, "&phase=ga&status=").concat(premStatus, "&term=1&registryPremium=").concat(regPremium).concat(broker ? "&broker=".concat(broker) : '');
      return addToCartPath;
    }
  }]);
}(EventEmitter);

function _regenerator$j() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$j(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$j(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$j(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$j(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$j(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$j(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$j(u), _regeneratorDefine2$j(u, o, "Generator"), _regeneratorDefine2$j(u, n, function () {
    return this;
  }), _regeneratorDefine2$j(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$j = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$j(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$j = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$j(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$j(e, r, n, t);
}

var DomainSearchService = /*#__PURE__*/function () {
  function DomainSearchService() {
    _classCallCheck$a(this, DomainSearchService);

    this.client = axios.create({
      baseURL: rebelSearchEndpoint,
      withCredentials: false
    });
  }
  /**
   * Calls RebelSearch to check for bundles.
   * RebelSearch handles domain availability, and making sure they're not premium.
   */


  return _createClass$a(DomainSearchService, [{
    key: "fetchBundle",
    value: function () {
      var _fetchBundle = _asyncToGenerator( /*#__PURE__*/_regenerator$j().m(function _callee(domainName, tld, currency) {
        var _yield$this$client$po, data;

        return _regenerator$j().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.n = 1;
                return this.client.post('/bundle', {
                  tld: tld,
                  currency: currency,
                  reseller: RESELLER_ID,
                  baseDomain: domainName
                });

              case 1:
                _yield$this$client$po = _context.v;
                data = _yield$this$client$po.data;
                return _context.a(2, data);
            }
          }
        }, _callee, this);
      }));

      function fetchBundle(_x, _x2, _x3) {
        return _fetchBundle.apply(this, arguments);
      }

      return fetchBundle;
    }()
    /** Finds relevant domains based on search criteria. */

  }, {
    key: "findRelevantDomains",
    value: function () {
      var _findRelevantDomains = _asyncToGenerator( /*#__PURE__*/_regenerator$j().m(function _callee2(_ref, currency) {
        var query, exact, tld, _yield$this$client$po2, data;

        return _regenerator$j().w(function (_context2) {
          while (1) {
            switch (_context2.n) {
              case 0:
                query = _ref.query, exact = _ref.exact, tld = _ref.tld;
                _context2.n = 1;
                return this.client.post('/spin', {
                  reseller: RESELLER_ID,
                  term: query,
                  exactMatch: exact,
                  tldonly: tld ? [tld] : null,
                  domainsOnly: true
                });

              case 1:
                _yield$this$client$po2 = _context2.v;
                data = _yield$this$client$po2.data;
                trackEvent({
                  event: ANALYTICS_EVENTS.search,
                  data: {
                    currency: currency,
                    domain: query
                  }
                });
                return _context2.a(2, (data === null || data === void 0 ? void 0 : data.data) || []);
            }
          }
        }, _callee2, this);
      }));

      function findRelevantDomains(_x4, _x5) {
        return _findRelevantDomains.apply(this, arguments);
      }

      return findRelevantDomains;
    }()
    /** Fetches the domain information for the provided list. */

  }, {
    key: "getInfoForList",
    value: function () {
      var _getInfoForList = _asyncToGenerator( /*#__PURE__*/_regenerator$j().m(function _callee3(domains, currency) {
        var _yield$this$client$po3, data, response, domain;

        return _regenerator$j().w(function (_context3) {
          while (1) {
            switch (_context3.n) {
              case 0:
                _context3.n = 1;
                return this.client.post('/search', {
                  currency: currency,
                  reseller: RESELLER_ID,
                  domains: domains
                });

              case 1:
                _yield$this$client$po3 = _context3.v;
                data = _yield$this$client$po3.data;
                response = data === null || data === void 0 ? void 0 : data.data;

                for (domain in response) {
                  if (response[domain].type === 'ERROR') {
                    delete response[domain];
                  }
                }

                return _context3.a(2, response);
            }
          }
        }, _callee3, this);
      }));

      function getInfoForList(_x6, _x7) {
        return _getInfoForList.apply(this, arguments);
      }

      return getInfoForList;
    }()
    /** Gets all domain categories, sorts them by bringing the "All" category to the top. */

  }, {
    key: "getDomainCategories",
    value: function () {
      var _getDomainCategories = _asyncToGenerator( /*#__PURE__*/_regenerator$j().m(function _callee4() {
        var response, data;
        return _regenerator$j().w(function (_context4) {
          while (1) {
            switch (_context4.n) {
              case 0:
                _context4.n = 1;
                return this.client.get('/categories');

              case 1:
                response = _context4.v;
                data = response.data;
                return _context4.a(2, data.sort(function (a, b) {
                  if (a.tld === null) {
                    return 1;
                  }

                  if (b.tld === null) {
                    return -1;
                  }

                  return a.order - b.order;
                }));
            }
          }
        }, _callee4, this);
      }));

      function getDomainCategories() {
        return _getDomainCategories.apply(this, arguments);
      }

      return getDomainCategories;
    }()
  }]);
}();

function _regenerator$i() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$i(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$i(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$i(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$i(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$i(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$i(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$i(u), _regeneratorDefine2$i(u, o, "Generator"), _regeneratorDefine2$i(u, n, function () {
    return this;
  }), _regeneratorDefine2$i(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$i = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$i(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$i = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$i(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$i(e, r, n, t);
}

var PriceService = /*#__PURE__*/function () {
  function PriceService() {
    _classCallCheck$a(this, PriceService);

    this.client = axios.create({
      baseURL: pricesEndpoint
    });
  }
  /** Returns the prices for all of our products for the specified currency and reseller */


  return _createClass$a(PriceService, [{
    key: "getStaticPrices",
    value: function () {
      var _getStaticPrices = _asyncToGenerator( /*#__PURE__*/_regenerator$i().m(function _callee(currency) {
        var _yield$this$client$ge, data;

        return _regenerator$i().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.n = 1;
                return this.client.get("/static/all?currency=".concat(currency, "&reseller=").concat(SERVER_RESELLER));

              case 1:
                _yield$this$client$ge = _context.v;
                data = _yield$this$client$ge.data;
                return _context.a(2, data);
            }
          }
        }, _callee, this);
      }));

      function getStaticPrices(_x) {
        return _getStaticPrices.apply(this, arguments);
      }

      return getStaticPrices;
    }()
  }]);
}();

function _regenerator$h() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$h(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$h(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$h(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$h(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$h(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$h(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$h(u), _regeneratorDefine2$h(u, o, "Generator"), _regeneratorDefine2$h(u, n, function () {
    return this;
  }), _regeneratorDefine2$h(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$h = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$h(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$h = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$h(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$h(e, r, n, t);
}

var PromptService = /*#__PURE__*/function () {
  function PromptService() {
    _classCallCheck$a(this, PromptService);

    this.client = axios.create({
      baseURL: "".concat(baseBackendEndpoint, "/api/prompt")
    });
  }
  /** Takes a prompt and returns a list of domain names. */


  return _createClass$a(PromptService, [{
    key: "getPromptSuggestions",
    value: function () {
      var _getPromptSuggestions = _asyncToGenerator( /*#__PURE__*/_regenerator$h().m(function _callee(prompt) {
        var _yield$this$client$po, data;

        return _regenerator$h().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.n = 1;
                return this.client.post('/suggest', {
                  prompt: prompt
                });

              case 1:
                _yield$this$client$po = _context.v;
                data = _yield$this$client$po.data;
                return _context.a(2, data);
            }
          }
        }, _callee, this);
      }));

      function getPromptSuggestions(_x) {
        return _getPromptSuggestions.apply(this, arguments);
      }

      return getPromptSuggestions;
    }()
  }]);
}();

var ErrorContext = /*#__PURE__*/createContext(undefined);

function ErrorProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(null),
      _useState2 = _slicedToArray$4(_useState, 2),
      message = _useState2[0],
      setMessage = _useState2[1];

  var emitError = useCallback(function (error) {
    if (error instanceof Error) {
      setMessage(error.message.length > 70 ? 'An unexpected error occurred.' : error.message);
    } else {
      setMessage('An unexpected error occurred.');
    }

    setTimeout(function () {
      return setMessage(null);
    }, 5000);
  }, []);
  return /*#__PURE__*/jsx$1(ErrorContext.Provider, {
    value: {
      error: message,
      emitError: emitError
    },
    children: children
  });
}

var useError = function useError() {
  var context = useContext(ErrorContext);

  if (!context) {
    throw new Error('useError must be used within an ErrorProvider');
  }

  return context;
};

function _regenerator$g() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$g(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$g(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$g(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$g(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$g(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$g(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$g(u), _regeneratorDefine2$g(u, o, "Generator"), _regeneratorDefine2$g(u, n, function () {
    return this;
  }), _regeneratorDefine2$g(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$g = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$g(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$g = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$g(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$g(e, r, n, t);
}

var CartContext = /*#__PURE__*/createContext(undefined);

function CartProvider(_ref) {
  var children = _ref.children;

  var _useState = useState([]),
      _useState2 = _slicedToArray$4(_useState, 2),
      cart = _useState2[0],
      setCart = _useState2[1];

  var cartService = useMemo(function () {
    return new CartService();
  }, []);

  var _useError = useError(),
      emitError = _useError.emitError; // Fetches cart on mount and whenever an ItemsChanged event is fired.


  useEffect(function () {
    function refreshCart() {
      return _refreshCart.apply(this, arguments);
    }

    function _refreshCart() {
      _refreshCart = _asyncToGenerator( /*#__PURE__*/_regenerator$g().m(function _callee() {
        var _yield$tryCatch, _yield$tryCatch2, response, error;

        return _regenerator$g().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.n = 1;
                return tryCatch(cartService.getSummary());

              case 1:
                _yield$tryCatch = _context.v;
                _yield$tryCatch2 = _slicedToArray$4(_yield$tryCatch, 2);
                response = _yield$tryCatch2[0];
                error = _yield$tryCatch2[1];

                if (!error) {
                  _context.n = 2;
                  break;
                }

                return _context.a(2, emitError(error));

              case 2:
                setCart(response.cartSummary);
                LS.setItem(storageKeys.OrderItems, response.cartSummary.length);

              case 3:
                return _context.a(2);
            }
          }
        }, _callee);
      }));
      return _refreshCart.apply(this, arguments);
    }

    refreshCart();

    var handleItemsChanged = function handleItemsChanged() {
      return refreshCart();
    };

    cartService.on(EVENTS.ItemsChanged, handleItemsChanged);
    return function () {
      if (cartService && cartService.off) {
        cartService.off(EVENTS.ItemsChanged, handleItemsChanged);
      }
    };
  }, [cartService, emitError]);
  return /*#__PURE__*/jsx$1(CartContext.Provider, {
    value: {
      cart: cart,
      cartService: cartService
    },
    children: children
  });
}

var useCart = function useCart() {
  var context = useContext(CartContext);

  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }

  return context;
};
/**
 * Filters domains by the category.
 * @param domains List of domain names including the tld.
 * @param param1 Total and currently selected categories.
 * @returns List of domains that belong to currently selected category.
 */


function filterDomainsByCategory(domains, currentCategory) {
  // This would typically be the "All" category, which doesn't restrict TLDs.
  if (currentCategory.tld === null) {
    return domains;
  }

  return domains.filter(function (domain) {
    var _getDomainParts = getDomainParts(domain),
        tld = _getDomainParts.tld;

    if (!tld) {
      return false;
    }

    return Object.keys(currentCategory.tld).includes(tld);
  });
}

function _regenerator$f() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$f(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$f(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$f(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$f(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$f(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$f(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$f(u), _regeneratorDefine2$f(u, o, "Generator"), _regeneratorDefine2$f(u, n, function () {
    return this;
  }), _regeneratorDefine2$f(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$f = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$f(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$f = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$f(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$f(e, r, n, t);
}

function ownKeys$m(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$m(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$m(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$m(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var SearchContext = /*#__PURE__*/createContext(undefined);
var BATCH_COUNT = 10;
var DEBOUNCE_TIME = 600;

function DomainSearchProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(),
      _useState2 = _slicedToArray$4(_useState, 2),
      bundle = _useState2[0],
      setBundle = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray$4(_useState3, 2),
      bulkSearch = _useState4[0],
      setBulkSearch = _useState4[1];

  var _useState5 = useState('NONE'),
      _useState6 = _slicedToArray$4(_useState5, 2),
      fetching = _useState6[0],
      setFetching = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray$4(_useState7, 2),
      lastSearchedQuery = _useState8[0],
      setLastSearchedQuery = _useState8[1];

  var _useState9 = useState({
    possible: [],
    fetched: {}
  }),
      _useState0 = _slicedToArray$4(_useState9, 2),
      searchDomains = _useState0[0],
      setSearchDomains = _useState0[1];

  var _useState1 = useState({
    allCategories: [{
      name: 'All',
      tld: null
    }],
    current: {
      name: 'All',
      tld: null
    }
  }),
      _useState10 = _slicedToArray$4(_useState1, 2),
      categories = _useState10[0],
      setCategories = _useState10[1];

  var _useState11 = useState({
    query: '',
    exact: true,
    tld: null
  }),
      _useState12 = _slicedToArray$4(_useState11, 2),
      searchParams = _useState12[0],
      setSearchParams = _useState12[1];

  var _useError = useError(),
      emitError = _useError.emitError;

  var domainSearchService = useMemo(function () {
    return new DomainSearchService();
  }, []);
  var currency = useSessionService().data.currentCurrency.code.toUpperCase();
  /** Allows user to load another batch of domains. */

  function loadMoreResults() {
    return _loadMoreResults.apply(this, arguments);
  }
  /** Updates the selected category based on user input */


  function _loadMoreResults() {
    _loadMoreResults = _asyncToGenerator( /*#__PURE__*/_regenerator$f().m(function _callee5() {
      var fetchedKeys, additionalDomains, _yield$tryCatch5, _yield$tryCatch6, info, error;

      return _regenerator$f().w(function (_context5) {
        while (1) {
          switch (_context5.n) {
            case 0:
              fetchedKeys = Object.keys(searchDomains.fetched); // We've fetched all possible domains already.

              if (!(fetchedKeys.length >= searchDomains.possible.length)) {
                _context5.n = 1;
                break;
              }

              return _context5.a(2);

            case 1:
              setFetching('MORE');
              additionalDomains = searchDomains.possible.slice(fetchedKeys.length, fetchedKeys.length + BATCH_COUNT);
              _context5.n = 2;
              return tryCatch(domainSearchService.getInfoForList(additionalDomains, currency));

            case 2:
              _yield$tryCatch5 = _context5.v;
              _yield$tryCatch6 = _slicedToArray$4(_yield$tryCatch5, 2);
              info = _yield$tryCatch6[0];
              error = _yield$tryCatch6[1];

              if (error) {
                emitError(error);
              }

              setSearchDomains(function (_ref2) {
                var possible = _ref2.possible,
                    fetched = _ref2.fetched;
                return {
                  possible: possible,
                  fetched: _objectSpread$m(_objectSpread$m({}, fetched), info)
                };
              });
              setFetching('NONE');

            case 3:
              return _context5.a(2);
          }
        }
      }, _callee5);
    }));
    return _loadMoreResults.apply(this, arguments);
  }

  function updateCategory(name) {
    var matchedCategory = categories.allCategories.find(function (category) {
      return category.name === name;
    });

    if (matchedCategory) {
      setCategories(function (prev) {
        return _objectSpread$m(_objectSpread$m({}, prev), {}, {
          current: matchedCategory
        });
      });
    }
  } // When bulk search params are updated, fetch their information.


  useEffect(function () {
    function handleBulkSearch() {
      return _handleBulkSearch.apply(this, arguments);
    }

    function _handleBulkSearch() {
      _handleBulkSearch = _asyncToGenerator( /*#__PURE__*/_regenerator$f().m(function _callee() {
        var _yield$tryCatch, _yield$tryCatch2, info, error;

        return _regenerator$f().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                if (bulkSearch) {
                  _context.n = 1;
                  break;
                }

                return _context.a(2);

              case 1:
                setFetching('NEW');
                setSearchParams(function (prev) {
                  return _objectSpread$m(_objectSpread$m({}, prev), {}, {
                    query: ''
                  });
                });
                setBundle(undefined);
                if (bulkSearch.invalidDomains.length > 0) ;
                _context.n = 2;
                return tryCatch(domainSearchService.getInfoForList(bulkSearch.validDomains, currency));

              case 2:
                _yield$tryCatch = _context.v;
                _yield$tryCatch2 = _slicedToArray$4(_yield$tryCatch, 2);
                info = _yield$tryCatch2[0];
                error = _yield$tryCatch2[1];

                if (error) {
                  emitError(error);
                } else {
                  setSearchDomains({
                    possible: bulkSearch.validDomains,
                    fetched: info
                  });
                }

                setFetching('NONE');

              case 3:
                return _context.a(2);
            }
          }
        }, _callee);
      }));
      return _handleBulkSearch.apply(this, arguments);
    }

    handleBulkSearch();
  }, [bulkSearch, currency, domainSearchService, emitError]); // Fetches categories on page load to be utilized later.

  useEffect(function () {
    function fetchCategories() {
      return _fetchCategories.apply(this, arguments);
    }

    function _fetchCategories() {
      _fetchCategories = _asyncToGenerator( /*#__PURE__*/_regenerator$f().m(function _callee2() {
        var allCategories, allDomainsCategory;
        return _regenerator$f().w(function (_context2) {
          while (1) {
            switch (_context2.n) {
              case 0:
                _context2.n = 1;
                return domainSearchService.getDomainCategories();

              case 1:
                allCategories = _context2.v;
                allDomainsCategory = {
                  name: 'All',
                  tld: null
                };
                setCategories({
                  allCategories: allCategories,
                  current: allDomainsCategory
                });

              case 2:
                return _context2.a(2);
            }
          }
        }, _callee2);
      }));
      return _fetchCategories.apply(this, arguments);
    }

    fetchCategories();
  }, [domainSearchService]); // Handles updating the URL with the search query.

  useEffect(function () {
    var url = new URL(window.location.href);

    if (searchParams.query) {
      url.searchParams.set('q', searchParams.query);
    } else {
      url.searchParams["delete"]('q');
    }

    if (searchParams.tld) {
      url.searchParams.set('tldonly', searchParams.tld || '');
    } else {
      url.searchParams["delete"]('tldonly');
    }

    if (!searchParams.exact) {
      url.searchParams.set('exact', 'false');
    } else {
      url.searchParams["delete"]('exact');
    }

    window.history.pushState({}, '', url.toString());
  }, [searchParams]); // Cleans query on every change.

  useEffect(function () {
    var cleanedQuery = cleanDomain(searchParams.query);

    if (cleanedQuery === searchParams.query) {
      return;
    }

    setSearchParams(function (prev) {
      return _objectSpread$m(_objectSpread$m({}, prev), {}, {
        query: cleanedQuery
      });
    });
  }, [searchParams.query]); // Runs search for domains when search params are updated.

  useEffect(function () {
    if (!searchParams.query) {
      return;
    }
    /** Gets bundle for typed query and sets the state variable */


    function getSetBundle() {
      return _getSetBundle.apply(this, arguments);
    }
    /** Finds all possible domains, then fetches info by batch count. */


    function _getSetBundle() {
      _getSetBundle = _asyncToGenerator( /*#__PURE__*/_regenerator$f().m(function _callee3() {
        var _getDomainParts, domainName, tld, _yield$tryCatch3, _yield$tryCatch4, fetchedBundle, error;

        return _regenerator$f().w(function (_context3) {
          while (1) {
            switch (_context3.n) {
              case 0:
                _getDomainParts = getDomainParts(searchParams.query), domainName = _getDomainParts.domainName, tld = _getDomainParts.tld;
                _context3.n = 1;
                return tryCatch(domainSearchService.fetchBundle(domainName, tld, currency));

              case 1:
                _yield$tryCatch3 = _context3.v;
                _yield$tryCatch4 = _slicedToArray$4(_yield$tryCatch3, 2);
                fetchedBundle = _yield$tryCatch4[0];
                error = _yield$tryCatch4[1];

                if (!error) {
                  _context3.n = 2;
                  break;
                }

                return _context3.a(2, emitError(error));

              case 2:
                setBundle(fetchedBundle);

              case 3:
                return _context3.a(2);
            }
          }
        }, _callee3);
      }));
      return _getSetBundle.apply(this, arguments);
    }

    function searchForDomains() {
      return _searchForDomains.apply(this, arguments);
    }

    function _searchForDomains() {
      _searchForDomains = _asyncToGenerator( /*#__PURE__*/_regenerator$f().m(function _callee4() {
        var list, filteredList, info, _t;

        return _regenerator$f().w(function (_context4) {
          while (1) {
            switch (_context4.n) {
              case 0:
                setFetching('NEW');
                _context4.p = 1;
                _context4.n = 2;
                return domainSearchService.findRelevantDomains(searchParams);

              case 2:
                list = _context4.v;
                filteredList = filterDomainsByCategory(list, categories.current);
                _context4.n = 3;
                return domainSearchService.getInfoForList(filteredList.slice(0, BATCH_COUNT), currency);

              case 3:
                info = _context4.v;
                setSearchDomains({
                  possible: filteredList,
                  fetched: info
                });
                _context4.n = 5;
                break;

              case 4:
                _context4.p = 4;
                _t = _context4.v;
                emitError(_t);

              case 5:
                setFetching('NONE'); // Reset bulk search.

                setBulkSearch(undefined);
                setLastSearchedQuery(searchParams.query);

              case 6:
                return _context4.a(2);
            }
          }
        }, _callee4, null, [[1, 4]]);
      }));
      return _searchForDomains.apply(this, arguments);
    }

    var handler = setTimeout(function () {
      searchForDomains();
      getSetBundle();
    }, DEBOUNCE_TIME);
    return function () {
      return clearTimeout(handler);
    };
  }, [searchParams, currency, domainSearchService, emitError, categories]);
  return /*#__PURE__*/jsx$1(SearchContext.Provider, {
    value: {
      bundle: bundle,
      fetching: fetching,
      currency: currency,
      searchDomains: searchDomains,
      isUpdatingSearchQuery: lastSearchedQuery !== searchParams.query,
      domainSearchService: domainSearchService,
      searchParams: searchParams,
      setSearchParams: setSearchParams,
      categories: categories,
      updateCategory: updateCategory,
      loadMoreResults: loadMoreResults,
      bulkSearch: bulkSearch,
      setBulkSearch: setBulkSearch
    },
    children: children
  });
}

var useDomainSearch = function useDomainSearch() {
  var context = useContext(SearchContext);

  if (!context) {
    throw new Error('useDomainSearch must be used within a DomainSearchProvider');
  }

  return context;
};

var DomainAddons = /*#__PURE__*/function (DomainAddons) {
  DomainAddons["Privacy"] = "PRIVACY";
  DomainAddons["Expiry"] = "DMEXPINSURANCE";
  DomainAddons["Ownership"] = "DMLOCK";
  DomainAddons["Bundle"] = "OPEPBUNDLE";
  return DomainAddons;
}({});

var HostingAddons = /*#__PURE__*/function (HostingAddons) {
  HostingAddons["Personal"] = "PPPRSN";
  HostingAddons["Startup"] = "PPBASE5";
  HostingAddons["Business"] = "PPBUSBASE";
  HostingAddons["MwpBase"] = "PPMANAGEDWORDPRESSBASE1";
  HostingAddons["MwpEcom"] = "PPMANAGEDWORDPRESSECOMM";
  return HostingAddons;
}({});

var AddOnCategories = /*#__PURE__*/function (AddOnCategories) {
  AddOnCategories["Domain"] = "Domain Protection";
  AddOnCategories["Hosting"] = "Hosting";
  return AddOnCategories;
}({});

var _templateObject$g, _templateObject2$b;

var _excluded$4 = ["children", "onClick", "direction", "loading"];

function ownKeys$l(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$l(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$l(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$l(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function DirectionButton(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      direction = _ref.direction,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      props = _objectWithoutProperties$8(_ref, _excluded$4);

  return /*#__PURE__*/jsxs(_StyledButton$9, _objectSpread$l(_objectSpread$l({
    variant: "minimal",
    alignItems: "center",
    onClick: onClick,
    flexDirection: direction === '->' ? 'row' : 'row-reverse',
    zIndex: 10,
    gap: 3,
    color: "primary-900",
    fontWeight: "semi",
    loading: loading,
    p: 0
  }, props), {}, {
    children: [/*#__PURE__*/jsx$1(_StyledText$d, {
      color: "primary-700",
      children: children
    }), /*#__PURE__*/jsx$1(_StyledBox$8, {
      alignItems: "center",
      justifyContent: "center",
      children: direction === '->' ? /*#__PURE__*/jsx$1(RiArrowRightCircleFill, {
        size: 40
      }) : /*#__PURE__*/jsx$1(RiArrowLeftCircleFill, {
        size: 40
      })
    })]
  }));
}

var _StyledButton$9 = styled(Button)(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral$1(["\n        transition: 0.2s;\n\n        &:hover {\n          color: ", ";\n        }\n      "])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors['primary-800'];
});

var _StyledText$d = styled(Text)(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteral$1(["\n          text-decoration: underline;\n        "])));

var _StyledBox$8 = styled(Box).withConfig({
  displayName: "direction-button___StyledBox",
  componentId: "sc-xmwa4r-0"
})(["svg{color:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors['primary-600'];
});

function BusinessWebHostingSVG() {
  return /*#__PURE__*/jsxs("svg", {
    width: 71,
    height: 73,
    viewBox: "0 0 71 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/jsx$1("path", {
      d: "M49.4012 17.2072L29.7927 12.5648C22.6802 10.8808 17.4232 13.5801 15.5111 19.8853L9.03519 41.2402C7.09179 47.6487 10.1421 52.2262 17.2546 53.9101L36.8632 58.5526C44.0903 60.2636 49.2053 57.6193 51.1487 51.2108L57.6246 29.8559C59.5367 23.5507 56.6284 18.9183 49.4012 17.2072Z",
      fill: "url(#paint0_linear_7412_7329)"
    }), /*#__PURE__*/jsx$1("g", {
      opacity: 0.5,
      filter: "url(#filter0_f_7412_7329)",
      children: /*#__PURE__*/jsx$1("path", {
        d: "M26.9447 34.8856C23.3759 34.5501 20.6484 31.5542 20.6484 27.9697V27.9697C20.6484 24.3851 23.3759 21.3892 26.9448 21.0538L34.6796 20.3267C39.1832 19.9034 43.0746 23.4462 43.0746 27.9697V27.9697C43.0746 32.4931 39.1832 36.0359 34.6796 35.6126L26.9447 34.8856Z",
        fill: "#0062FF"
      })
    }), /*#__PURE__*/jsx$1("foreignObject", {
      x: -19,
      y: 0.149658,
      width: 108.727,
      height: 96.7009,
      children: /*#__PURE__*/jsx$1("div", {
        style: {
          backdropFilter: 'blur(12px)',
          clipPath: 'url(#bgblur_0_7412_7329_clip_path)',
          height: '100%',
          width: '100%'
        }
      })
    }), /*#__PURE__*/jsx$1("path", {
      "data-figma-bg-blur-radius": 24,
      d: "M65.2162 38.9987C65.2162 34.5194 63.6748 30.9092 60.7874 28.4267C57.9102 25.953 53.7559 24.6497 48.6172 24.6497H22.1015C16.9616 24.6497 12.8066 25.953 9.92912 28.4267C7.0414 30.9092 5.5 34.5194 5.5 38.9987V57.9813C5.5 62.4605 7.04133 66.0756 9.92872 68.5631C12.8061 71.0419 16.9612 72.3506 22.1015 72.3506H48.6277C53.7668 72.3506 57.9212 71.0419 60.7982 68.563C63.6853 66.0755 65.2266 62.4605 65.2266 57.9813C65.2266 53.6233 65.224 49.1183 65.2214 45.5824C65.2201 43.8096 65.2188 42.2806 65.2178 41.1359C65.2168 39.9972 65.2162 39.2387 65.2162 38.9987Z",
      fill: "#3EA0FE",
      fillOpacity: 0.35,
      stroke: "url(#paint1_linear_7412_7329)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx$1("foreignObject", {
      x: 18.3926,
      y: 16.6697,
      width: 76.6074,
      height: 63.3431,
      children: /*#__PURE__*/jsx$1("div", {
        style: {
          backdropFilter: 'blur(12px)',
          clipPath: 'url(#bgblur_1_7412_7329_clip_path)',
          height: '100%',
          width: '100%'
        }
      })
    }), /*#__PURE__*/jsx$1("path", {
      "data-figma-bg-blur-radius": 24,
      d: "M43.0461 49.7721L43.0459 49.7721L43.0492 49.7856C43.9058 53.2148 47.2952 55.5712 51.0998 55.5117H67.2801C69.0065 55.5117 70.4993 54.2419 70.4993 52.5645L70.4993 44.1198L70.4993 44.1186C70.4953 42.4463 69.0082 41.173 67.2811 41.1697H67.2801L50.8059 41.1697L50.8045 41.1697C46.4748 41.1819 42.8858 44.3567 42.8926 48.376C42.8926 48.8455 42.9451 49.314 43.0461 49.7721Z",
      fill: "#3EA0FE",
      fillOpacity: 0.35,
      stroke: "url(#paint2_linear_7412_7329)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx$1("foreignObject", {
      x: 32.707,
      y: 30.4821,
      width: 36.4727,
      height: 35.7185,
      children: /*#__PURE__*/jsx$1("div", {
        style: {
          backdropFilter: 'blur(7.5px)',
          clipPath: 'url(#bgblur_2_7412_7329_clip_path)',
          height: '100%',
          width: '100%'
        }
      })
    }), /*#__PURE__*/jsxs("g", {
      filter: "url(#filter3_d_7412_7329)",
      "data-figma-bg-blur-radius": 15,
      children: [/*#__PURE__*/jsx$1("ellipse", {
        cx: 50.943,
        cy: 48.3413,
        rx: 3.23595,
        ry: 2.85924,
        fill: "url(#paint3_linear_7412_7329)"
      }), /*#__PURE__*/jsx$1("path", {
        d: "M54.0789 48.3413C54.0789 49.8539 52.6869 51.1005 50.943 51.1005C49.1991 51.1005 47.807 49.8539 47.807 48.3413C47.807 46.8287 49.1991 45.5821 50.943 45.5821C52.6869 45.5821 54.0789 46.8287 54.0789 48.3413Z",
        stroke: "url(#paint4_linear_7412_7329)",
        strokeOpacity: 0.5,
        strokeWidth: 0.2
      })]
    }), /*#__PURE__*/jsx$1("foreignObject", {
      x: 2.70117,
      y: 20.2079,
      width: 51.0664,
      height: 33.8721,
      children: /*#__PURE__*/jsx$1("div", {
        style: {
          backdropFilter: 'blur(7.5px)',
          clipPath: 'url(#bgblur_3_7412_7329_clip_path)',
          height: '100%',
          width: '100%'
        }
      })
    }), /*#__PURE__*/jsxs("g", {
      filter: "url(#filter4_d_7412_7329)",
      "data-figma-bg-blur-radius": 15,
      children: [/*#__PURE__*/jsx$1("path", {
        d: "M36.4989 39.08H19.938C18.6982 39.0755 17.696 38.2053 17.7012 37.1372C17.7064 36.0736 18.7061 35.2124 19.938 35.2079H36.5094C37.7491 35.2034 38.7619 36.0669 38.7671 37.1349C38.7723 38.2053 37.77 39.0755 36.5302 39.08H36.5094H36.4989Z",
        fill: "url(#paint5_linear_7412_7329)"
      }), /*#__PURE__*/jsx$1("path", {
        d: "M17.8012 37.1377C17.8061 36.1423 18.747 35.3123 19.9382 35.3079L36.5094 35.3079L36.5097 35.3079C37.7089 35.3036 38.6622 36.1361 38.6671 37.1354C38.672 38.137 37.729 38.9755 36.5301 38.98H36.5094H36.4989H19.9382C18.7392 38.9755 17.7963 38.1369 17.8012 37.1377ZM17.8012 37.1377L17.7012 37.1372L17.8012 37.1377Z",
        stroke: "url(#paint6_linear_7412_7329)",
        strokeOpacity: 0.5,
        strokeWidth: 0.2
      })]
    }), /*#__PURE__*/jsxs("defs", {
      children: [/*#__PURE__*/jsxs("filter", {
        id: "filter0_f_7412_7329",
        x: 0.648438,
        y: 0.292358,
        width: 62.4258,
        height: 55.3546,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx$1("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx$1("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/jsx$1("feGaussianBlur", {
          stdDeviation: 10,
          result: "effect1_foregroundBlur_7412_7329"
        })]
      }), /*#__PURE__*/jsx$1("clipPath", {
        id: "bgblur_0_7412_7329_clip_path",
        transform: "translate(19 -0.149658)",
        children: /*#__PURE__*/jsx$1("path", {
          d: "M65.2162 38.9987C65.2162 34.5194 63.6748 30.9092 60.7874 28.4267C57.9102 25.953 53.7559 24.6497 48.6172 24.6497H22.1015C16.9616 24.6497 12.8066 25.953 9.92912 28.4267C7.0414 30.9092 5.5 34.5194 5.5 38.9987V57.9813C5.5 62.4605 7.04133 66.0756 9.92872 68.5631C12.8061 71.0419 16.9612 72.3506 22.1015 72.3506H48.6277C53.7668 72.3506 57.9212 71.0419 60.7982 68.563C63.6853 66.0755 65.2266 62.4605 65.2266 57.9813C65.2266 53.6233 65.224 49.1183 65.2214 45.5824C65.2201 43.8096 65.2188 42.2806 65.2178 41.1359C65.2168 39.9972 65.2162 39.2387 65.2162 38.9987Z"
        })
      }), /*#__PURE__*/jsx$1("clipPath", {
        id: "bgblur_1_7412_7329_clip_path",
        transform: "translate(-18.3926 -16.6697)",
        children: /*#__PURE__*/jsx$1("path", {
          d: "M43.0461 49.7721L43.0459 49.7721L43.0492 49.7856C43.9058 53.2148 47.2952 55.5712 51.0998 55.5117H67.2801C69.0065 55.5117 70.4993 54.2419 70.4993 52.5645L70.4993 44.1198L70.4993 44.1186C70.4953 42.4463 69.0082 41.173 67.2811 41.1697H67.2801L50.8059 41.1697L50.8045 41.1697C46.4748 41.1819 42.8858 44.3567 42.8926 48.376C42.8926 48.8455 42.9451 49.314 43.0461 49.7721Z"
        })
      }), /*#__PURE__*/jsxs("filter", {
        id: "filter3_d_7412_7329",
        x: 32.707,
        y: 30.4821,
        width: 36.4727,
        height: 35.7185,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx$1("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx$1("feColorMatrix", {
          "in": "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/jsx$1("feOffset", {
          dx: 5,
          dy: 5
        }), /*#__PURE__*/jsx$1("feGaussianBlur", {
          stdDeviation: 5
        }), /*#__PURE__*/jsx$1("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.15375 0 0 0 0 0.522433 0 0 0 0 0.9 0 0 0 0.5 0"
        }), /*#__PURE__*/jsx$1("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_7412_7329"
        }), /*#__PURE__*/jsx$1("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "effect1_dropShadow_7412_7329",
          result: "shape"
        })]
      }), /*#__PURE__*/jsx$1("clipPath", {
        id: "bgblur_2_7412_7329_clip_path",
        transform: "translate(-32.707 -30.4821)",
        children: /*#__PURE__*/jsx$1("ellipse", {
          cx: 50.943,
          cy: 48.3413,
          rx: 3.23595,
          ry: 2.85924
        })
      }), /*#__PURE__*/jsxs("filter", {
        id: "filter4_d_7412_7329",
        x: 2.70117,
        y: 20.2079,
        width: 51.0664,
        height: 33.8721,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx$1("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx$1("feColorMatrix", {
          "in": "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/jsx$1("feOffset", {
          dx: 5,
          dy: 5
        }), /*#__PURE__*/jsx$1("feGaussianBlur", {
          stdDeviation: 5
        }), /*#__PURE__*/jsx$1("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.15375 0 0 0 0 0.522433 0 0 0 0 0.9 0 0 0 0.5 0"
        }), /*#__PURE__*/jsx$1("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_7412_7329"
        }), /*#__PURE__*/jsx$1("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "effect1_dropShadow_7412_7329",
          result: "shape"
        })]
      }), /*#__PURE__*/jsx$1("clipPath", {
        id: "bgblur_3_7412_7329_clip_path",
        transform: "translate(-2.70117 -20.2079)",
        children: /*#__PURE__*/jsx$1("path", {
          d: "M36.4989 39.08H19.938C18.6982 39.0755 17.696 38.2053 17.7012 37.1372C17.7064 36.0736 18.7061 35.2124 19.938 35.2079H36.5094C37.7491 35.2034 38.7619 36.0669 38.7671 37.1349C38.7723 38.2053 37.77 39.0755 36.5302 39.08H36.5094H36.4989Z"
        })
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint0_linear_7412_7329",
        x1: 57.6404,
        y1: 19.1578,
        x2: 4.02265,
        y2: 37.5413,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "#39AFFD"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "#477FFF"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint1_linear_7412_7329",
        x1: 15.3483,
        y1: 30.5904,
        x2: 52.3904,
        y2: 78.0409,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "white",
          stopOpacity: 0.25
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "white",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint2_linear_7412_7329",
        x1: 47.6279,
        y1: 43.2242,
        x2: 56.2741,
        y2: 60.7869,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "white",
          stopOpacity: 0.25
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "white",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint3_linear_7412_7329",
        x1: 53.7201,
        y1: 46.5147,
        x2: 46.5131,
        y2: 46.7806,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "white"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "white",
          stopOpacity: 0.2
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint4_linear_7412_7329",
        x1: 48.4042,
        y1: 47.4003,
        x2: 53.8997,
        y2: 47.4347,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "white"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "white",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint5_linear_7412_7329",
        x1: 37.2735,
        y1: 35.9071,
        x2: 14.4997,
        y2: 39.9468,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "white"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "white",
          stopOpacity: 0.2
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint6_linear_7412_7329",
        x1: 19.9704,
        y1: 36.5068,
        x2: 37.8427,
        y2: 37.0435,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "white"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "white",
          stopOpacity: 0
        })]
      })]
    })]
  });
}

function ExpiryProtectionSVG() {
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 66,
    fill: "none",
    children: [/*#__PURE__*/jsx$1("path", {
      fill: "url(#a)",
      d: "M37.734 44.11a1.435 1.435 0 0 1-.654.198l-7.464.366c-2.119.102-3.941-.107-5.574-.639a15.117 15.117 0 0 1-8.438-6.821L9.45 26.558c-.71-1.23-.55-2.8.392-3.91l8.452-9.904a3.481 3.481 0 0 1 1.96-1.162L32.9 8.959c1.415-.295 2.844.335 3.552 1.564l6.16 10.664c1.867 3.232 2.484 7.065 1.74 10.79-.343 1.71-1.056 3.423-2.178 5.24l-3.954 6.412c-.122.2-.29.364-.487.482"
    }), /*#__PURE__*/jsx$1("g", {
      filter: "url(#b)",
      children: /*#__PURE__*/jsx$1("path", {
        fill: "#1EA51F",
        fillOpacity: 0.5,
        d: "M34.433 37.762a1.09 1.09 0 0 1-.436.145l-4.915.507c-1.395.143-2.584.083-3.637-.181-2.303-.578-4.182-1.95-5.29-3.868l-3.65-6.306c-.422-.728-.26-1.698.4-2.414l5.913-6.397c.35-.383.823-.663 1.33-.788l8.403-2.087c.94-.235 1.855.098 2.275.825l3.653 6.312c1.108 1.913 1.372 4.241.746 6.556-.287 1.062-.818 2.14-1.622 3.297l-2.832 4.085a1.078 1.078 0 0 1-.338.314"
      })
    }), /*#__PURE__*/jsx$1("foreignObject", {
      width: 93.842,
      height: 99.249,
      x: -0.719,
      y: -11.499,
      children: /*#__PURE__*/jsx$1("div", {
        style: {
          backdropFilter: 'blur(12px)',
          clipPath: 'url(#c)',
          height: '100%',
          width: '100%'
        }
      })
    }), /*#__PURE__*/jsxs("g", {
      "data-figma-bg-blur-radius": 24,
      children: [/*#__PURE__*/jsxs("mask", {
        id: "e",
        width: 51.183,
        height: 58.273,
        x: 19.796,
        y: 9.172,
        fill: "#000",
        maskUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("path", {
          fill: "#fff",
          d: "M19.796 9.172h51.183v58.273H19.796z"
        }), /*#__PURE__*/jsx$1("path", {
          d: "M41.846 62.728a1.918 1.918 0 0 1-.841-.35l-8.064-5.957c-2.288-1.692-4.011-3.457-5.273-5.397-2.762-4.242-3.892-9.306-3.178-14.263l2.343-16.314c.27-1.883 1.725-3.382 3.616-3.735l16.918-3.13a4.589 4.589 0 0 1 2.993.454l15.308 8.011c1.714.894 2.684 2.763 2.411 4.643l-2.345 16.326a20.445 20.445 0 0 1-7.046 12.707c-1.759 1.488-3.906 2.666-6.564 3.603L42.75 62.64c-.292.105-.601.132-.903.087"
        })]
      }), /*#__PURE__*/jsx$1("path", {
        fill: "#72DC60",
        fillOpacity: 0.35,
        d: "M41.846 62.728a1.918 1.918 0 0 1-.841-.35l-8.064-5.957c-2.288-1.692-4.011-3.457-5.273-5.397-2.762-4.242-3.892-9.306-3.178-14.263l2.343-16.314c.27-1.883 1.725-3.382 3.616-3.735l16.918-3.13a4.589 4.589 0 0 1 2.993.454l15.308 8.011c1.714.894 2.684 2.763 2.411 4.643l-2.345 16.326a20.445 20.445 0 0 1-7.046 12.707c-1.759 1.488-3.906 2.666-6.564 3.603L42.75 62.64c-.292.105-.601.132-.903.087"
      }), /*#__PURE__*/jsx$1("path", {
        fill: "url(#d)",
        d: "M41.698 63.717a.991.991 0 0 0 1.136-.833 1.009 1.009 0 0 0-.84-1.145l-.296 1.978Zm-.693-1.338.589-.805-.59.805ZM32.94 56.42l-.59.804.59-.804Zm-5.273-5.397.836-.542-.836.542ZM24.49 36.761l.988.15-.988-.15Zm2.343-16.314.989.15v-.001l-.989-.15Zm3.616-3.735-.188-.985h-.001l.19.985Zm16.918-3.13.189.984.007-.001-.196-.983Zm2.993.454-.46.885.002.002.458-.887Zm15.308 8.011-.457.887h.001l.456-.887Zm2.411 4.643-.988-.15.988.15Zm-2.345 16.326-.989-.149.989.15Zm-7.046 12.707.648.766-.648-.766Zm-6.564 3.603-.337-.945h-.001l.338.945ZM42.75 62.64l-.339-.944-.004.001.343.943Zm-.762-.903a.991.991 0 0 0-1.13.843 1.009 1.009 0 0 0 .849 1.137l.281-1.98Zm.008.001a.913.913 0 0 1-.401-.165l-1.178 1.61c.386.285.83.462 1.282.533l.297-1.978Zm-.401-.165-8.064-5.957-1.178 1.608 8.064 5.958 1.178-1.609Zm-8.064-5.957c-2.212-1.636-3.844-3.317-5.026-5.135l-1.672 1.085c1.34 2.06 3.156 3.91 5.52 5.658l1.178-1.608Zm-5.027-5.136c-2.63-4.038-3.704-8.857-3.025-13.57l-1.977-.3c-.75 5.2.438 10.511 3.331 14.956l1.671-1.086Zm-3.025-13.57 2.344-16.315-1.978-.299-2.343 16.315 1.977.299Zm2.344-16.315c.208-1.451 1.334-2.623 2.817-2.9l-.38-1.968c-2.299.429-4.083 2.255-4.415 4.57l1.978.298Zm2.815-2.9 16.919-3.13-.377-1.969-16.918 3.13.376 1.97Zm16.926-3.131a3.59 3.59 0 0 1 2.337.356l.92-1.77a5.589 5.589 0 0 0-3.648-.552l.39 1.966Zm2.34.358 15.308 8.011.915-1.773-15.309-8.012-.915 1.774Zm15.31 8.012c1.34.7 2.088 2.155 1.878 3.605l1.977.3c.335-2.31-.857-4.592-2.943-5.68l-.913 1.775Zm1.878 3.606-2.346 16.326 1.978.299 2.345-16.326-1.977-.3Zm-2.346 16.326c-.675 4.707-3.055 9-6.705 12.089l1.296 1.533a21.438 21.438 0 0 0 7.387-13.323l-1.978-.299ZM58.04 54.956c-1.648 1.395-3.684 2.52-6.253 3.425l.675 1.89c2.746-.97 5.005-2.2 6.873-3.782l-1.295-1.533Zm-6.254 3.425-9.376 3.316.677 1.889 9.375-3.316-.676-1.889Zm-9.38 3.317a.86.86 0 0 1-.419.04l-.281 1.98c.46.07.935.027 1.385-.134l-.685-1.886Z",
        mask: "url(#e)"
      })]
    }), /*#__PURE__*/jsx$1("foreignObject", {
      width: 48.566,
      height: 41.599,
      x: 22.246,
      y: 16.989,
      children: /*#__PURE__*/jsx$1("div", {
        style: {
          backdropFilter: 'blur(7.5px)',
          clipPath: 'url(#f)',
          height: '100%',
          width: '100%'
        }
      })
    }), /*#__PURE__*/jsxs("g", {
      "data-figma-bg-blur-radius": 15,
      filter: "url(#g)",
      children: [/*#__PURE__*/jsx$1("path", {
        fill: "url(#h)",
        d: "M42.814 43.566a1.88 1.88 0 0 1-1.222-.725l-3.976-5.257a1.804 1.804 0 0 1 .368-2.554 1.879 1.879 0 0 1 2.597.392l2.86 3.782 9.402-6.86a1.879 1.879 0 0 1 2.596.392c.616.816.451 1.96-.366 2.553l-10.885 7.944c-.41.3-.904.405-1.374.333Z"
      }), /*#__PURE__*/jsx$1("path", {
        stroke: "url(#i)",
        strokeOpacity: 0.5,
        strokeWidth: 0.2,
        d: "M38.044 35.111a1.704 1.704 0 0 0-.348 2.413l.348-2.413Zm0 0a1.779 1.779 0 0 1 2.457.371l2.861 3.782.06.078.079-.057 9.4-6.86-14.857 2.686Zm3.627 7.67-3.975-5.257 15.206-5.1a1.779 1.779 0 0 1 2.457.371 1.702 1.702 0 0 1-.345 2.413l-10.885 7.944a1.747 1.747 0 0 1-1.3.315 1.78 1.78 0 0 1-1.158-.686Z"
      })]
    }), /*#__PURE__*/jsxs("defs", {
      children: [/*#__PURE__*/jsxs("linearGradient", {
        id: "a",
        x1: 32.831,
        x2: 22.982,
        y1: 4,
        y2: 40.218,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "#9BF763"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "#26AB5B"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "d",
        x1: 34.071,
        x2: 61.037,
        y1: 17.076,
        y2: 55.522,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "#fff",
          stopOpacity: 0.25
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "#fff",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "h",
        x1: 54.448,
        x2: 34.503,
        y1: 34.458,
        y2: 32.365,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "#fff"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "#fff",
          stopOpacity: 0.2
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "i",
        x1: 39.533,
        x2: 54.639,
        y1: 34.176,
        y2: 36.56,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "#fff"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "#fff",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/jsx$1("clipPath", {
        id: "c",
        transform: "translate(.719 11.5)",
        children: /*#__PURE__*/jsx$1("path", {
          d: "M41.846 62.728a1.918 1.918 0 0 1-.841-.35l-8.064-5.957c-2.288-1.692-4.011-3.457-5.273-5.397-2.762-4.242-3.892-9.306-3.178-14.263l2.343-16.314c.27-1.883 1.725-3.382 3.616-3.735l16.918-3.13a4.589 4.589 0 0 1 2.993.454l15.308 8.011c1.714.894 2.684 2.763 2.411 4.643l-2.345 16.326a20.445 20.445 0 0 1-7.046 12.707c-1.759 1.488-3.906 2.666-6.564 3.603L42.75 62.64c-.292.105-.601.132-.903.087"
        })
      }), /*#__PURE__*/jsx$1("clipPath", {
        id: "f",
        transform: "translate(-22.246 -16.99)",
        children: /*#__PURE__*/jsx$1("path", {
          d: "M42.814 43.566a1.88 1.88 0 0 1-1.222-.725l-3.976-5.257a1.804 1.804 0 0 1 .368-2.554 1.879 1.879 0 0 1 2.597.392l2.86 3.782 9.402-6.86a1.879 1.879 0 0 1 2.596.392c.616.816.451 1.96-.366 2.553l-10.885 7.944c-.41.3-.904.405-1.374.333Z"
        })
      }), /*#__PURE__*/jsxs("filter", {
        id: "b",
        width: 55.285,
        height: 54.191,
        x: 0.271,
        y: 0.299,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx$1("feBlend", {
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/jsx$1("feGaussianBlur", {
          result: "effect1_foregroundBlur_7412_6051",
          stdDeviation: 8
        })]
      }), /*#__PURE__*/jsxs("filter", {
        id: "g",
        width: 48.566,
        height: 41.599,
        x: 22.246,
        y: 16.989,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx$1("feColorMatrix", {
          "in": "SourceAlpha",
          result: "hardAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), /*#__PURE__*/jsx$1("feOffset", {
          dx: 5,
          dy: 5
        }), /*#__PURE__*/jsx$1("feGaussianBlur", {
          stdDeviation: 5
        }), /*#__PURE__*/jsx$1("feColorMatrix", {
          values: "0 0 0 0 0.454902 0 0 0 0 0.870588 0 0 0 0 0.376471 0 0 0 0.5 0"
        }), /*#__PURE__*/jsx$1("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_7412_6051"
        }), /*#__PURE__*/jsx$1("feBlend", {
          "in": "SourceGraphic",
          in2: "effect1_dropShadow_7412_6051",
          result: "shape"
        })]
      })]
    })]
  });
}

function OwnershipProtectionSVG() {
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 71,
    fill: "none",
    children: [/*#__PURE__*/jsx$1("path", {
      fill: "url(#a)",
      d: "m35.42 10.867-18.19 7.455c-7.113 2.914-9.987 9.935-7.149 17.461l6.552 17.37c2.83 7.505 9.523 10.605 16.635 7.69l18.19-7.455c7.112-2.915 9.965-9.927 7.135-17.432l-6.552-17.37c-2.839-7.526-9.51-10.634-16.622-7.72"
    }), /*#__PURE__*/jsx$1("g", {
      filter: "url(#b)",
      opacity: 0.5,
      children: /*#__PURE__*/jsx$1("path", {
        fill: "#30AD31",
        d: "m37.002 18.513-13.596 5.53c-4.931 2.005-6.83 5.756-5.164 10.182l5.643 14.99c1.693 4.498 5.515 5.855 10.446 3.85l13.596-5.53c5.012-2.037 6.851-5.697 5.158-10.195l-5.643-14.99c-1.666-4.426-5.428-5.874-10.44-3.837Z"
      })
    }), /*#__PURE__*/jsx$1("foreignObject", {
      width: 94.732,
      height: 96.059,
      x: -0.398,
      y: -3.109,
      children: /*#__PURE__*/jsx$1("div", {
        style: {
          backdropFilter: 'blur(12px)',
          clipPath: 'url(#c)',
          height: '100%',
          width: '100%'
        }
      })
    }), /*#__PURE__*/jsxs("g", {
      "data-figma-bg-blur-radius": 24,
      children: [/*#__PURE__*/jsxs("mask", {
        id: "e",
        width: 47,
        height: 49,
        x: 23.602,
        y: 20.891,
        fill: "#000",
        maskUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("path", {
          fill: "#fff",
          d: "M23.602 20.891h47v49h-47z"
        }), /*#__PURE__*/jsx$1("path", {
          d: "M56.675 21.891H37.282c-7.582 0-12.681 5.481-12.681 13.634V54.34c0 8.13 5.099 13.61 12.681 13.61h19.392c7.582 0 12.659-5.48 12.659-13.61V35.525c0-8.153-5.077-13.634-12.66-13.634"
        })]
      }), /*#__PURE__*/jsx$1("path", {
        fill: "#72DC60",
        fillOpacity: 0.35,
        d: "M56.675 21.891H37.282c-7.582 0-12.681 5.481-12.681 13.634V54.34c0 8.13 5.099 13.61 12.681 13.61h19.392c7.582 0 12.659-5.48 12.659-13.61V35.525c0-8.153-5.077-13.634-12.66-13.634"
      }), /*#__PURE__*/jsx$1("path", {
        fill: "url(#d)",
        d: "M56.675 22.891a1 1 0 1 0 0-2v2Zm0-2a1 1 0 0 0 0 2v-2Zm0 0H37.282v2h19.392v-2Zm-19.392 0c-4.043 0-7.488 1.468-9.916 4.079-2.423 2.604-3.765 6.27-3.765 10.555h2c0-3.868 1.207-7.019 3.23-9.193 2.016-2.168 4.912-3.44 8.451-3.44v-2ZM23.602 35.525V54.34h2V35.525h-2Zm0 18.815c0 4.274 1.343 7.934 3.765 10.535 2.429 2.607 5.873 4.075 9.916 4.075v-2c-3.539 0-6.435-1.273-8.452-3.438-2.023-2.172-3.23-5.317-3.23-9.172h-2Zm13.681 14.61h19.392v-2H37.282v2Zm19.392 0c4.043 0 7.482-1.468 9.905-4.076 2.417-2.601 3.754-6.261 3.754-10.534h-2c0 3.856-1.202 7.002-3.22 9.173-2.01 2.165-4.9 3.437-8.44 3.437v2Zm13.659-14.61V35.525h-2V54.34h2Zm0-18.815c0-4.284-1.337-7.95-3.754-10.554-2.423-2.612-5.862-4.08-9.905-4.08v2c3.538 0 6.428 1.273 8.44 3.44 2.017 2.174 3.219 5.325 3.219 9.194h2Z",
        mask: "url(#e)"
      })]
    }), /*#__PURE__*/jsx$1("foreignObject", {
      width: 55.768,
      height: 41.982,
      x: 18.994,
      y: 23.837,
      children: /*#__PURE__*/jsx$1("div", {
        style: {
          backdropFilter: 'blur(7.5px)',
          clipPath: 'url(#f)',
          height: '100%',
          width: '100%'
        }
      })
    }), /*#__PURE__*/jsxs("g", {
      "data-figma-bg-blur-radius": 15,
      filter: "url(#g)",
      children: [/*#__PURE__*/jsx$1("mask", {
        id: "j",
        fill: "#fff",
        children: /*#__PURE__*/jsx$1("path", {
          fillRule: "evenodd",
          d: "M58.085 50.82c.926 0 1.677-.774 1.677-1.728v-4.265c0-.953-.751-1.727-1.677-1.727H45.354c-.725-2.457-2.921-4.263-5.542-4.263-3.208 0-5.818 2.688-5.818 5.99 0 3.305 2.61 5.992 5.818 5.992 2.62 0 4.817-1.805 5.542-4.265h4.724v2.538c0 .954.751 1.727 1.677 1.727s1.677-.773 1.677-1.727v-2.538h2.975v2.538c0 .954.752 1.727 1.678 1.727Zm-20.738-5.993c0-1.4 1.107-2.538 2.465-2.538 1.357 0 2.464 1.138 2.464 2.538 0 1.398-1.107 2.535-2.465 2.535-1.357 0-2.464-1.137-2.464-2.535Z",
          clipRule: "evenodd"
        })
      }), /*#__PURE__*/jsx$1("path", {
        fill: "url(#h)",
        fillRule: "evenodd",
        d: "M58.085 50.82c.926 0 1.677-.774 1.677-1.728v-4.265c0-.953-.751-1.727-1.677-1.727H45.354c-.725-2.457-2.921-4.263-5.542-4.263-3.208 0-5.818 2.688-5.818 5.99 0 3.305 2.61 5.992 5.818 5.992 2.62 0 4.817-1.805 5.542-4.265h4.724v2.538c0 .954.751 1.727 1.677 1.727s1.677-.773 1.677-1.727v-2.538h2.975v2.538c0 .954.752 1.727 1.678 1.727Zm-20.738-5.993c0-1.4 1.107-2.538 2.465-2.538 1.357 0 2.464 1.138 2.464 2.538 0 1.398-1.107 2.535-2.465 2.535-1.357 0-2.464-1.137-2.464-2.535Z",
        clipRule: "evenodd"
      }), /*#__PURE__*/jsx$1("path", {
        fill: "url(#i)",
        fillOpacity: 0.5,
        d: "m45.354 43.1-.192.056.042.144h.15v-.2Zm0 3.454v-.2h-.15l-.042.144.192.056Zm4.724 0h.2v-.2h-.2v.2Zm3.354 0v-.2h-.2v.2h.2Zm2.975 0h.2v-.2h-.2v.2Zm3.155 2.538c0 .849-.667 1.527-1.477 1.527v.4c1.041 0 1.877-.868 1.877-1.927h-.4Zm0-4.265v4.265h.4v-4.265h-.4ZM58.085 43.3c.81 0 1.477.679 1.477 1.527h.4c0-1.058-.836-1.927-1.877-1.927v.4Zm-12.731 0h12.73v-.4h-12.73v.4Zm-5.542-4.263c2.525 0 4.648 1.74 5.35 4.12l.384-.114c-.748-2.535-3.017-4.406-5.734-4.406v.4Zm-5.618 5.79c0-3.197 2.526-5.79 5.618-5.79v-.4c-3.324 0-6.018 2.783-6.018 6.19h.4Zm5.618 5.792c-3.092 0-5.618-2.592-5.618-5.792h-.4c0 3.41 2.694 6.192 6.018 6.192v-.4Zm5.35-4.121c-.702 2.382-2.825 4.121-5.35 4.121v.4c2.717 0 4.986-1.871 5.734-4.408l-.384-.113Zm4.916-.144h-4.724v.4h4.724v-.4Zm.2 2.738v-2.538h-.4v2.538h.4Zm1.477 1.527c-.81 0-1.477-.678-1.477-1.527h-.4c0 1.059.835 1.927 1.877 1.927v-.4Zm1.477-1.527c0 .849-.667 1.527-1.477 1.527v.4c1.042 0 1.877-.868 1.877-1.927h-.4Zm0-2.538v2.538h.4v-2.538h-.4Zm3.175-.2h-2.974v.4h2.974v-.4Zm.2 2.738v-2.538h-.4v2.538h.4Zm1.478 1.527c-.81 0-1.478-.678-1.478-1.527h-.4c0 1.059.836 1.927 1.878 1.927v-.4Zm-18.273-8.53c-1.474 0-2.665 1.233-2.665 2.738h.4c0-1.295 1.023-2.338 2.265-2.338v-.4Zm2.664 2.738c0-1.505-1.191-2.738-2.664-2.738v.4c1.241 0 2.264 1.043 2.264 2.338h.4Zm-2.664 2.735c1.473 0 2.664-1.232 2.664-2.735h-.4c0 1.293-1.023 2.335-2.264 2.335v.4Zm-2.665-2.735c0 1.503 1.191 2.735 2.665 2.735v-.4c-1.242 0-2.265-1.042-2.265-2.335h-.4Z",
        mask: "url(#j)"
      })]
    }), /*#__PURE__*/jsxs("defs", {
      children: [/*#__PURE__*/jsxs("linearGradient", {
        id: "a",
        x1: 47.286,
        x2: 31.032,
        y1: 6.018,
        y2: 53.214,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "#9BF763"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "#26AB5B"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "d",
        x1: 31.722,
        x2: 61.272,
        y1: 27.257,
        y2: 62.801,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "#fff",
          stopOpacity: 0.25
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "#fff",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "h",
        x1: 57.935,
        x2: 29.342,
        y1: 41.001,
        y2: 43.006,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "#fff"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "#fff",
          stopOpacity: 0.2
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "i",
        x1: 36.77,
        x2: 58.648,
        y1: 42.857,
        y2: 43.116,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "#fff"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "#fff",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/jsx$1("clipPath", {
        id: "c",
        transform: "translate(.398 3.109)",
        children: /*#__PURE__*/jsx$1("path", {
          d: "M56.675 21.891H37.282c-7.582 0-12.681 5.481-12.681 13.634V54.34c0 8.13 5.099 13.61 12.681 13.61h19.392c7.582 0 12.659-5.48 12.659-13.61V35.525c0-8.153-5.077-13.634-12.66-13.634"
        })
      }), /*#__PURE__*/jsx$1("clipPath", {
        id: "f",
        transform: "translate(-18.994 -23.837)",
        children: /*#__PURE__*/jsx$1("path", {
          fillRule: "evenodd",
          d: "M58.085 50.82c.926 0 1.677-.774 1.677-1.728v-4.265c0-.953-.751-1.727-1.677-1.727H45.354c-.725-2.457-2.921-4.263-5.542-4.263-3.208 0-5.818 2.688-5.818 5.99 0 3.305 2.61 5.992 5.818 5.992 2.62 0 4.817-1.805 5.542-4.265h4.724v2.538c0 .954.751 1.727 1.677 1.727s1.677-.773 1.677-1.727v-2.538h2.975v2.538c0 .954.752 1.727 1.678 1.727Zm-20.738-5.993c0-1.4 1.107-2.538 2.465-2.538 1.357 0 2.464 1.138 2.464 2.538 0 1.398-1.107 2.535-2.465 2.535-1.357 0-2.464-1.137-2.464-2.535Z",
          clipRule: "evenodd"
        })
      }), /*#__PURE__*/jsxs("filter", {
        id: "b",
        width: 70.049,
        height: 70.361,
        x: 0.65,
        y: 0.607,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx$1("feBlend", {
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/jsx$1("feGaussianBlur", {
          result: "effect1_foregroundBlur_7412_6632",
          stdDeviation: 8.5
        })]
      }), /*#__PURE__*/jsxs("filter", {
        id: "g",
        width: 55.768,
        height: 41.982,
        x: 18.994,
        y: 23.837,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx$1("feColorMatrix", {
          "in": "SourceAlpha",
          result: "hardAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        }), /*#__PURE__*/jsx$1("feOffset", {
          dx: 5,
          dy: 5
        }), /*#__PURE__*/jsx$1("feGaussianBlur", {
          stdDeviation: 5
        }), /*#__PURE__*/jsx$1("feColorMatrix", {
          values: "0 0 0 0 0.454902 0 0 0 0 0.870588 0 0 0 0 0.376471 0 0 0 0.5 0"
        }), /*#__PURE__*/jsx$1("feBlend", {
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_7412_6632"
        }), /*#__PURE__*/jsx$1("feBlend", {
          "in": "SourceGraphic",
          in2: "effect1_dropShadow_7412_6632",
          result: "shape"
        })]
      })]
    })]
  });
}

function PersonalWebHostingSVG() {
  return /*#__PURE__*/jsxs("svg", {
    width: 67,
    height: 69,
    viewBox: "0 0 67 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/jsx$1("foreignObject", {
      x: 13.1543,
      y: -3.36023,
      width: 64.8457,
      height: 73.2373,
      children: /*#__PURE__*/jsx$1("div", {
        style: {
          backdropFilter: 'blur(6.5px)',
          clipPath: 'url(#bgblur_0_7412_5884_clip_path)',
          height: '100%',
          width: '100%'
        }
      })
    }), /*#__PURE__*/jsx$1("path", {
      "data-figma-bg-blur-radius": 13,
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M58.4294 22.138C58.4294 29.0761 52.7119 34.6362 45.5775 34.6362C38.4456 34.6362 32.7256 29.0761 32.7256 22.138C32.7256 15.1998 38.4456 9.63977 45.5775 9.63977C52.7119 9.63977 58.4294 15.1998 58.4294 22.138ZM26.1543 48.7872C26.1543 42.3646 35.1015 40.7576 45.577 40.7576C56.1093 40.7576 64.9996 42.4199 64.9996 48.8475C64.9996 55.2701 56.0524 56.877 45.577 56.877C35.0446 56.877 26.1543 55.2148 26.1543 48.7872Z",
      fill: "url(#paint0_linear_7412_5884)"
    }), /*#__PURE__*/jsx$1("g", {
      filter: "url(#filter1_f_7412_5884)",
      children: /*#__PURE__*/jsx$1("path", {
        d: "M41.3586 44.877C34.9628 44.877 29.5 45.9442 29.5 50.2096C29.5 54.4784 34.928 55.5823 41.3586 55.5823C47.7545 55.5823 53.2173 54.5151 53.2173 50.2497C53.2173 45.9809 47.7892 44.877 41.3586 44.877",
        fill: "#EF5641",
        fillOpacity: 0.5
      })
    }), /*#__PURE__*/jsx$1("g", {
      filter: "url(#filter2_f_7412_5884)",
      children: /*#__PURE__*/jsx$1("path", {
        d: "M42.4371 28.462C46.0279 28.462 48.9054 25.6046 48.9054 22.0388C48.9054 18.4731 46.0279 15.6156 42.4371 15.6156C38.8476 15.6156 35.9688 18.4731 35.9688 22.0388C35.9688 25.6046 38.8476 28.462 42.4371 28.462",
        fill: "#EF5641",
        fillOpacity: 0.5
      })
    }), /*#__PURE__*/jsx$1("foreignObject", {
      x: -15,
      y: -11.0996,
      width: 82.9434,
      height: 93.9502,
      children: /*#__PURE__*/jsx$1("div", {
        style: {
          backdropFilter: 'blur(7.5px)',
          clipPath: 'url(#bgblur_1_7412_5884_clip_path)',
          height: '100%',
          width: '100%'
        }
      })
    }), /*#__PURE__*/jsxs("g", {
      "data-figma-bg-blur-radius": 15,
      children: [/*#__PURE__*/jsxs("mask", {
        id: "path-4-outside-1_7412_5884",
        maskUnits: "userSpaceOnUse",
        x: 0,
        y: 3.90039,
        width: 53,
        height: 64,
        fill: "black",
        children: [/*#__PURE__*/jsx$1("rect", {
          fill: "white",
          y: 3.90039,
          width: 53,
          height: 64
        }), /*#__PURE__*/jsx$1("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M43.326 21.2911C43.326 30.39 35.8279 37.6817 26.4715 37.6817C17.1184 37.6817 9.61693 30.39 9.61693 21.2911C9.61693 12.1921 17.1184 4.90039 26.4715 4.90039C35.8279 4.90039 43.326 12.1921 43.326 21.2911ZM1 56.2412C1 47.8183 12.7337 45.7109 26.4717 45.7109C40.2843 45.7109 51.9434 47.8908 51.9434 56.3203C51.9434 64.7432 40.2097 66.8506 26.4717 66.8506C12.6591 66.8506 1 64.6706 1 56.2412Z"
        })]
      }), /*#__PURE__*/jsx$1("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M43.326 21.2911C43.326 30.39 35.8279 37.6817 26.4715 37.6817C17.1184 37.6817 9.61693 30.39 9.61693 21.2911C9.61693 12.1921 17.1184 4.90039 26.4715 4.90039C35.8279 4.90039 43.326 12.1921 43.326 21.2911ZM1 56.2412C1 47.8183 12.7337 45.7109 26.4717 45.7109C40.2843 45.7109 51.9434 47.8908 51.9434 56.3203C51.9434 64.7432 40.2097 66.8506 26.4717 66.8506C12.6591 66.8506 1 64.6706 1 56.2412Z",
        fill: "#FFAC95",
        fillOpacity: 0.4
      }), /*#__PURE__*/jsx$1("path", {
        d: "M26.4715 38.6817C36.3537 38.6817 44.326 30.9684 44.326 21.2911H42.326C42.326 29.8116 35.3021 36.6817 26.4715 36.6817V38.6817ZM8.61693 21.2911C8.61693 30.9686 16.5927 38.6817 26.4715 38.6817V36.6817C17.644 36.6817 10.6169 29.8115 10.6169 21.2911H8.61693ZM26.4715 3.90039C16.5927 3.90039 8.61693 11.6136 8.61693 21.2911H10.6169C10.6169 12.7706 17.644 5.90039 26.4715 5.90039V3.90039ZM44.326 21.2911C44.326 11.6137 36.3537 3.90039 26.4715 3.90039V5.90039C35.3021 5.90039 42.326 12.7705 42.326 21.2911H44.326ZM26.4717 44.7109C19.581 44.7109 13.0759 45.2356 8.26249 46.8706C5.8503 47.6899 3.78962 48.812 2.32351 50.3532C0.834434 51.9185 0 53.8753 0 56.2412H2C2 54.3955 2.63228 52.9303 3.77259 51.7316C4.93587 50.5088 6.66725 49.5247 8.90574 48.7643C13.3937 47.2399 19.6244 46.7109 26.4717 46.7109V44.7109ZM52.9434 56.3203C52.9434 53.9552 52.1154 51.9939 50.6338 50.4208C49.1745 48.8713 47.1213 47.7386 44.7129 46.9091C39.9076 45.2539 33.4012 44.7109 26.4717 44.7109V46.7109C33.3548 46.7109 39.5843 47.2578 44.0616 48.8C46.2946 49.5691 48.0194 50.562 49.1779 51.792C50.314 52.9984 50.9434 54.4707 50.9434 56.3203H52.9434ZM26.4717 67.8506C33.3624 67.8506 39.8675 67.3259 44.6809 65.6909C47.0931 64.8715 49.1538 63.7495 50.6199 62.2083C52.109 60.6429 52.9434 58.6861 52.9434 56.3203H50.9434C50.9434 58.1659 50.3111 59.6311 49.1708 60.8298C48.0075 62.0527 46.2762 63.0368 44.0377 63.7972C39.5497 65.3216 33.319 65.8506 26.4717 65.8506V67.8506ZM0 56.2412C0 58.6063 0.828009 60.5675 2.30958 62.1407C3.76887 63.6902 5.82208 64.8229 8.23047 65.6524C13.0358 67.3076 19.5422 67.8506 26.4717 67.8506V65.8506C19.5887 65.8506 13.3592 65.3036 8.8818 63.7614C6.64884 62.9923 4.92398 61.9995 3.76554 60.7695C2.62938 59.5631 2 58.0908 2 56.2412H0Z",
        fill: "url(#paint1_linear_7412_5884)",
        mask: "url(#path-4-outside-1_7412_5884)"
      })]
    }), /*#__PURE__*/jsxs("defs", {
      children: [/*#__PURE__*/jsx$1("clipPath", {
        id: "bgblur_0_7412_5884_clip_path",
        transform: "translate(-13.1543 3.36023)",
        children: /*#__PURE__*/jsx$1("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M58.4294 22.138C58.4294 29.0761 52.7119 34.6362 45.5775 34.6362C38.4456 34.6362 32.7256 29.0761 32.7256 22.138C32.7256 15.1998 38.4456 9.63977 45.5775 9.63977C52.7119 9.63977 58.4294 15.1998 58.4294 22.138ZM26.1543 48.7872C26.1543 42.3646 35.1015 40.7576 45.577 40.7576C56.1093 40.7576 64.9996 42.4199 64.9996 48.8475C64.9996 55.2701 56.0524 56.877 45.577 56.877C35.0446 56.877 26.1543 55.2148 26.1543 48.7872Z"
        })
      }), /*#__PURE__*/jsxs("filter", {
        id: "filter1_f_7412_5884",
        x: 16.5,
        y: 31.877,
        width: 49.7168,
        height: 36.7053,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx$1("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx$1("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/jsx$1("feGaussianBlur", {
          stdDeviation: 6.5,
          result: "effect1_foregroundBlur_7412_5884"
        })]
      }), /*#__PURE__*/jsxs("filter", {
        id: "filter2_f_7412_5884",
        x: 20.9688,
        y: 0.615601,
        width: 42.9375,
        height: 42.8464,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx$1("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx$1("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/jsx$1("feGaussianBlur", {
          stdDeviation: 7.5,
          result: "effect1_foregroundBlur_7412_5884"
        })]
      }), /*#__PURE__*/jsx$1("clipPath", {
        id: "bgblur_1_7412_5884_clip_path",
        transform: "translate(15 11.0996)",
        children: /*#__PURE__*/jsx$1("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M43.326 21.2911C43.326 30.39 35.8279 37.6817 26.4715 37.6817C17.1184 37.6817 9.61693 30.39 9.61693 21.2911C9.61693 12.1921 17.1184 4.90039 26.4715 4.90039C35.8279 4.90039 43.326 12.1921 43.326 21.2911ZM1 56.2412C1 47.8183 12.7337 45.7109 26.4717 45.7109C40.2843 45.7109 51.9434 47.8908 51.9434 56.3203C51.9434 64.7432 40.2097 66.8506 26.4717 66.8506C12.6591 66.8506 1 64.6706 1 56.2412Z"
        })
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint0_linear_7412_5884",
        x1: 48.4367,
        y1: 36.4216,
        x2: 12.0514,
        y2: 50.97,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "#FFA78F"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "#F23E2C"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint1_linear_7412_5884",
        x1: 9.10936,
        y1: 12.1177,
        x2: 49.5279,
        y2: 53.2829,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "white",
          stopOpacity: 0.25
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "white",
          stopOpacity: 0
        })]
      })]
    })]
  });
}

function PrivacySVG() {
  return /*#__PURE__*/jsxs("svg", {
    width: "71",
    height: "64",
    viewBox: "0 0 71 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M32.9954 12.3312L33.7026 15.2413C37.3291 15.6309 40.5099 18.1304 41.3688 21.6648L43.6459 31.0344C44.7093 35.4098 41.8223 39.6573 37.2 40.5203L20.5986 43.6196C15.9744 44.4829 11.363 41.6353 10.2996 37.2598L8.02248 27.8902C7.16352 24.3559 8.90796 20.9369 12.0365 19.2862L11.3292 16.3761C9.97411 10.7144 13.7038 5.22723 19.6435 4.11832C25.663 2.99454 31.6203 6.67325 32.9954 12.3312ZM20.677 7.52855C24.7549 6.76665 28.8317 9.28608 29.7695 13.1476L30.382 15.67L15.5769 18.4362L14.9551 15.8757C14.0421 12.0294 16.5991 8.29046 20.677 7.52855ZM27.9411 31.1177C28.163 32.0361 27.5716 32.9112 26.6068 33.0924C25.6616 33.2699 24.7171 32.6832 24.4953 31.7648L23.49 27.6041C23.2727 26.7044 23.864 25.8293 24.8092 25.6518C25.774 25.4706 26.7185 26.0573 26.9359 26.9569L27.9411 31.1177Z",
      fill: "url(#paint0_linear_7412_6098)"
    }), /*#__PURE__*/jsx$1("g", {
      opacity: "0.5",
      filter: "url(#filter0_f_7412_6098)",
      children: /*#__PURE__*/jsx$1("rect", {
        width: "20.1473",
        height: "13.3524",
        rx: "5",
        transform: "matrix(0.981554 -0.1917 0.2351 0.972344 14.1855 24.2093)",
        fill: "#8237FF"
      })
    }), /*#__PURE__*/jsx$1("foreignObject", {
      x: "10.7695",
      y: "-3.77467",
      width: "60.1562",
      height: "54.2836",
      children: /*#__PURE__*/jsx$1("div", {
        style: {
          backdropFilter: 'blur(7.5px)',
          clipPath: 'url(#bgblur_0_7412_6098_clip_path)',
          height: '100%',
          width: '100%'
        }
      })
    }), /*#__PURE__*/jsxs("g", {
      filter: "url(#filter1_d_7412_6098)",
      "data-figma-bg-blur-radius": "15",
      children: [/*#__PURE__*/jsx$1("path", {
        d: "M55.361 27.8843L52.9996 35.5089C52.1958 35.0522 51.3055 34.7001 50.3538 34.4591L48.726 34.0468L50.9783 26.7743C52.4542 22.009 49.5215 17.0891 44.4376 15.8016C39.3536 14.5141 34.0291 17.3174 32.5354 22.053L30.2685 29.3725L28.6657 28.9665C27.689 28.7192 26.726 28.6019 25.7695 28.6381L28.1382 20.99C30.3443 13.9539 38.1967 9.79081 45.6598 11.6809C53.2231 13.5963 57.5421 20.8418 55.361 27.8843Z",
        fill: "url(#paint1_linear_7412_6098)"
      }), /*#__PURE__*/jsx$1("path", {
        d: "M55.1671 27.8351L52.8821 35.2131C52.1224 34.8073 51.2929 34.4908 50.413 34.268L48.9791 33.9048L51.1722 26.8234C52.6836 21.9436 49.6786 16.9228 44.4968 15.6105C39.3158 14.2984 33.8715 17.1531 32.3418 22.0029L32.3415 22.0039L30.1338 29.1322L28.7249 28.7754C27.8239 28.5473 26.9311 28.4271 26.0416 28.4347L28.332 21.0395C30.5028 14.1168 38.2361 10.0069 45.6006 11.872C53.0665 13.7627 57.3126 20.9076 55.1671 27.8351Z",
        stroke: "url(#paint2_linear_7412_6098)",
        strokeWidth: "0.4"
      })]
    }), /*#__PURE__*/jsx$1("foreignObject", {
      x: "-11.3203",
      y: "-1.77911",
      width: "96.2793",
      height: "87.4619",
      children: /*#__PURE__*/jsx$1("div", {
        style: {
          backdropFilter: 'blur(12px)',
          clipPath: 'url(#bgblur_1_7412_6098_clip_path)',
          height: '100%',
          width: '100%'
        }
      })
    }), /*#__PURE__*/jsxs("g", {
      "data-figma-bg-blur-radius": "24",
      children: [/*#__PURE__*/jsxs("mask", {
        id: "path-5-outside-1_7412_6098",
        maskUnits: "userSpaceOnUse",
        x: "9.54878",
        y: "19.6919",
        width: "54.4916",
        height: "45.2527",
        fill: "black",
        children: [/*#__PURE__*/jsx$1("rect", {
          fill: "white",
          x: "9.54878",
          y: "19.6919",
          width: "54.4916",
          height: "45.2527"
        }), /*#__PURE__*/jsx$1("path", {
          d: "M52.1902 28.659L31.4966 23.5372C25.7318 22.1104 19.6443 25.4144 17.9007 30.9164L14.1671 42.6982C12.4235 48.2002 15.6838 53.8179 21.4486 55.2447L42.1422 60.3665C47.907 61.7933 53.9946 58.4893 55.7381 52.9873L59.4718 41.2055C61.2153 35.7035 57.955 30.0858 52.1902 28.659Z"
        })]
      }), /*#__PURE__*/jsx$1("path", {
        d: "M52.1902 28.659L31.4966 23.5372C25.7318 22.1104 19.6443 25.4144 17.9007 30.9164L14.1671 42.6982C12.4235 48.2002 15.6838 53.8179 21.4486 55.2447L42.1422 60.3665C47.907 61.7933 53.9946 58.4893 55.7381 52.9873L59.4718 41.2055C61.2153 35.7035 57.955 30.0858 52.1902 28.659Z",
        fill: "#BA90FF",
        fillOpacity: "0.35"
      }), /*#__PURE__*/jsx$1("path", {
        d: "M31.4966 23.5372L31.7952 22.5823L31.4966 23.5372ZM17.9007 30.9164L18.8708 31.1605L17.9007 30.9164ZM14.1671 42.6982L13.197 42.4541L14.1671 42.6982ZM21.4486 55.2447L21.7471 54.2899L21.4486 55.2447ZM42.1422 60.3665L41.8437 61.3214L42.1422 60.3665ZM55.7381 52.9873L54.768 52.7432L55.7381 52.9873ZM59.4718 41.2055L60.4419 41.4496L59.4718 41.2055ZM52.4888 27.7041L31.7952 22.5823L31.1981 24.492L51.8917 29.6138L52.4888 27.7041ZM31.7952 22.5823C25.5217 21.0296 18.8487 24.6195 16.9306 30.6723L18.8708 31.1605C20.4398 26.2093 25.942 23.1911 31.1981 24.492L31.7952 22.5823ZM16.9306 30.6723L13.197 42.4541L15.1372 42.9423L18.8708 31.1605L16.9306 30.6723ZM13.197 42.4541C11.2778 48.5101 14.874 54.6462 21.1501 56.1996L21.7471 54.2899C16.4937 52.9896 13.5692 47.8903 15.1372 42.9423L13.197 42.4541ZM21.1501 56.1996L41.8437 61.3214L42.4407 59.4117L21.7471 54.2899L21.1501 56.1996ZM41.8437 61.3214C48.1171 62.8741 54.7901 59.2842 56.7082 53.2314L54.768 52.7432C53.199 57.6944 47.6968 60.7126 42.4407 59.4117L41.8437 61.3214ZM56.7082 53.2314L60.4419 41.4496L58.5017 40.9614L54.768 52.7432L56.7082 53.2314ZM60.4419 41.4496C62.361 35.3936 58.7649 29.2575 52.4888 27.7041L51.8917 29.6138C57.1452 30.9141 60.0697 36.0134 58.5017 40.9614L60.4419 41.4496Z",
        fill: "url(#paint3_linear_7412_6098)",
        mask: "url(#path-5-outside-1_7412_6098)"
      })]
    }), /*#__PURE__*/jsx$1("foreignObject", {
      x: "18.7754",
      y: "22.2465",
      width: "36.0938",
      height: "39.407",
      children: /*#__PURE__*/jsx$1("div", {
        style: {
          backdropFilter: 'blur(7.5px)',
          clipPath: 'url(#bgblur_2_7412_6098_clip_path)',
          height: '100%',
          width: '100%'
        }
      })
    }), /*#__PURE__*/jsxs("g", {
      filter: "url(#filter3_d_7412_6098)",
      "data-figma-bg-blur-radius": "15",
      children: [/*#__PURE__*/jsx$1("path", {
        d: "M38.1545 45.0676C37.7966 46.2113 36.5574 46.8824 35.3583 46.5818C34.1836 46.2874 33.5141 45.1379 33.872 43.9943L35.4935 38.8128C35.844 37.6925 37.0833 37.0214 38.258 37.3158C39.4571 37.6164 40.1266 38.7658 39.776 39.8862L38.1545 45.0676Z",
        fill: "url(#paint4_linear_7412_6098)"
      }), /*#__PURE__*/jsx$1("path", {
        d: "M37.9605 45.019C37.6373 46.0516 36.5157 46.666 35.418 46.3908C34.3463 46.1222 33.7424 45.0769 34.066 44.0429L35.6875 38.8614C36.0034 37.8521 37.125 37.2378 38.1982 37.5068C39.2974 37.7823 39.8974 38.8296 39.582 39.8375L37.9605 45.019Z",
        stroke: "url(#paint5_linear_7412_6098)",
        strokeWidth: "0.4"
      })]
    }), /*#__PURE__*/jsxs("defs", {
      children: [/*#__PURE__*/jsxs("filter", {
        id: "filter0_f_7412_6098",
        x: "0.220703",
        y: "6.211",
        width: "50.8438",
        height: "45.1174",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx$1("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx$1("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/jsx$1("feGaussianBlur", {
          stdDeviation: "7.5",
          result: "effect1_foregroundBlur_7412_6098"
        })]
      }), /*#__PURE__*/jsxs("filter", {
        id: "filter1_d_7412_6098",
        x: "10.7695",
        y: "-3.77467",
        width: "60.1562",
        height: "54.2836",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx$1("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx$1("feColorMatrix", {
          "in": "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/jsx$1("feOffset", {
          dx: "5",
          dy: "5"
        }), /*#__PURE__*/jsx$1("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/jsx$1("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.577356 0 0 0 0 0.359375 0 0 0 0 0.9375 0 0 0 0.5 0"
        }), /*#__PURE__*/jsx$1("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_7412_6098"
        }), /*#__PURE__*/jsx$1("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "effect1_dropShadow_7412_6098",
          result: "shape"
        })]
      }), /*#__PURE__*/jsx$1("clipPath", {
        id: "bgblur_0_7412_6098_clip_path",
        transform: "translate(-10.7695 3.77467)",
        children: /*#__PURE__*/jsx$1("path", {
          d: "M55.361 27.8843L52.9996 35.5089C52.1958 35.0522 51.3055 34.7001 50.3538 34.4591L48.726 34.0468L50.9783 26.7743C52.4542 22.009 49.5215 17.0891 44.4376 15.8016C39.3536 14.5141 34.0291 17.3174 32.5354 22.053L30.2685 29.3725L28.6657 28.9665C27.689 28.7192 26.726 28.6019 25.7695 28.6381L28.1382 20.99C30.3443 13.9539 38.1967 9.79081 45.6598 11.6809C53.2231 13.5963 57.5421 20.8418 55.361 27.8843Z"
        })
      }), /*#__PURE__*/jsx$1("clipPath", {
        id: "bgblur_1_7412_6098_clip_path",
        transform: "translate(11.3203 1.77911)",
        children: /*#__PURE__*/jsx$1("path", {
          d: "M52.1902 28.659L31.4966 23.5372C25.7318 22.1104 19.6443 25.4144 17.9007 30.9164L14.1671 42.6982C12.4235 48.2002 15.6838 53.8179 21.4486 55.2447L42.1422 60.3665C47.907 61.7933 53.9946 58.4893 55.7381 52.9873L59.4718 41.2055C61.2153 35.7035 57.955 30.0858 52.1902 28.659Z"
        })
      }), /*#__PURE__*/jsxs("filter", {
        id: "filter3_d_7412_6098",
        x: "18.7754",
        y: "22.2465",
        width: "36.0938",
        height: "39.407",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx$1("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx$1("feColorMatrix", {
          "in": "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/jsx$1("feOffset", {
          dx: "5",
          dy: "5"
        }), /*#__PURE__*/jsx$1("feGaussianBlur", {
          stdDeviation: "5"
        }), /*#__PURE__*/jsx$1("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.577356 0 0 0 0 0.359375 0 0 0 0 0.9375 0 0 0 0.5 0"
        }), /*#__PURE__*/jsx$1("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_7412_6098"
        }), /*#__PURE__*/jsx$1("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "effect1_dropShadow_7412_6098",
          result: "shape"
        })]
      }), /*#__PURE__*/jsx$1("clipPath", {
        id: "bgblur_2_7412_6098_clip_path",
        transform: "translate(-18.7754 -22.2465)",
        children: /*#__PURE__*/jsx$1("path", {
          d: "M38.1545 45.0676C37.7966 46.2113 36.5574 46.8824 35.3583 46.5818C34.1836 46.2874 33.5141 45.1379 33.872 43.9943L35.4935 38.8128C35.844 37.6925 37.0833 37.0214 38.258 37.3158C39.4571 37.6164 40.1266 38.7658 39.776 39.8862L38.1545 45.0676Z"
        })
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint0_linear_7412_6098",
        x1: "19.8107",
        y1: "4.08626",
        x2: "27.1424",
        y2: "42.4428",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "#BC94FF"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: "1",
          stopColor: "#9F66FF"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint1_linear_7412_6098",
        x1: "56.2381",
        y1: "18.3316",
        x2: "25.9572",
        y2: "10.3591",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "white"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0.2"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint2_linear_7412_6098",
        x1: "35.6835",
        y1: "11.7167",
        x2: "42.2661",
        y2: "33.9429",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "white",
          stopOpacity: "0.25"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint3_linear_7412_6098",
        x1: "26.4814",
        y1: "26.2387",
        x2: "37.006",
        y2: "60.4372",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "white",
          stopOpacity: "0.25"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint4_linear_7412_6098",
        x1: "39.5842",
        y1: "39.4527",
        x2: "34.8688",
        y2: "38.0534",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "white"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0.2"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint5_linear_7412_6098",
        x1: "36.4728",
        y1: "38.0326",
        x2: "40.6864",
        y2: "42.388",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "white",
          stopOpacity: "0.25"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      })]
    })]
  });
}

function StartupWebHostingSVG() {
  return /*#__PURE__*/jsxs("svg", {
    width: 70,
    height: 68,
    viewBox: "0 0 70 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/jsx$1("path", {
      d: "M38.0076 8.30456L17.6321 14.2774C10.2069 16.454 7.07017 22.0566 8.95898 29.7685L14.1372 50.9107C16.026 58.6226 21.3031 61.7588 28.7283 59.5822L49.1038 53.6093C56.5289 51.4327 59.6463 45.8358 57.7575 38.1239L52.5792 16.9817C50.6904 9.26981 45.4327 6.12795 38.0076 8.30456Z",
      fill: "url(#paint0_linear_7412_6942)"
    }), /*#__PURE__*/jsx$1("g", {
      opacity: 0.5,
      filter: "url(#filter0_f_7412_6942)",
      children: /*#__PURE__*/jsx$1("path", {
        d: "M36.6061 17.7277L23.1442 21.6738C18.2385 23.1119 16.1319 26.6741 17.3196 31.5233L20.5757 44.8174C21.7635 49.6666 25.2159 51.5993 30.1216 50.1613L43.5835 46.2151C48.4893 44.7771 50.583 41.2187 49.3953 36.3695L46.1392 23.0753C44.9515 18.2261 41.5119 16.2897 36.6061 17.7277Z",
        fill: "#E31352"
      })
    }), /*#__PURE__*/jsx$1("foreignObject", {
      x: -5.32422,
      y: -5.58008,
      width: 94.6719,
      height: 97.4307,
      children: /*#__PURE__*/jsx$1("div", {
        style: {
          backdropFilter: 'blur(12px)',
          clipPath: 'url(#bgblur_0_7412_6942_clip_path)',
          height: '100%',
          width: '100%'
        }
      })
    }), /*#__PURE__*/jsx$1("path", {
      "data-figma-bg-blur-radius": 24,
      d: "M51.706 18.9199H32.3404C28.4232 18.9199 25.1185 20.3836 22.7974 22.9565C20.4803 25.525 19.1758 29.1616 19.1758 33.4594V52.8348C19.1758 57.121 20.4805 60.7518 22.7976 63.3171C25.1186 65.8869 28.4232 67.3506 32.3404 67.3506H51.706C55.6233 67.3506 58.9225 65.8868 61.2381 63.3167C63.5495 60.7511 64.8483 57.1205 64.8483 52.8348V33.4594C64.8483 29.1622 63.5497 25.5256 61.2383 22.957C58.9227 20.3837 55.6233 18.9199 51.706 18.9199Z",
      fill: "#FF749F",
      fillOpacity: 0.35,
      stroke: "url(#paint1_linear_7412_6942)",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx$1("foreignObject", {
      x: 48.4355,
      y: 0.935425,
      width: 36.5645,
      height: 36.9694,
      children: /*#__PURE__*/jsx$1("div", {
        style: {
          backdropFilter: 'blur(7.5px)',
          clipPath: 'url(#bgblur_1_7412_6942_clip_path)',
          height: '100%',
          width: '100%'
        }
      })
    }), /*#__PURE__*/jsx$1("path", {
      "data-figma-bg-blur-radius": 15,
      d: "M66.7176 15.9354C64.905 15.9354 63.4355 17.4956 63.4355 19.4201C63.4355 21.3447 64.905 22.9048 66.7176 22.9048C68.5302 22.9048 69.9997 21.3447 69.9997 19.4201C69.9997 18.4959 69.6539 17.6096 69.0384 16.9561C68.4229 16.3026 67.5881 15.9354 66.7176 15.9354Z",
      fill: "url(#paint2_linear_7412_6942)"
    }), /*#__PURE__*/jsx$1("foreignObject", {
      x: 15.2637,
      y: 21.0547,
      width: 53.7676,
      height: 45.2349,
      children: /*#__PURE__*/jsx$1("div", {
        style: {
          backdropFilter: 'blur(7.5px)',
          clipPath: 'url(#bgblur_2_7412_6942_clip_path)',
          height: '100%',
          width: '100%'
        }
      })
    }), /*#__PURE__*/jsxs("g", {
      filter: "url(#filter3_d_7412_6942)",
      "data-figma-bg-blur-radius": 15,
      children: [/*#__PURE__*/jsx$1("path", {
        d: "M53.6976 38.9353L47.3143 47.681C47.0457 48.0611 46.6429 48.3091 46.1984 48.3681C45.7539 48.427 45.3059 48.2917 44.9573 47.9934L38.8293 42.8917L33.3102 50.4713C32.9105 51.1452 32.1321 51.4479 31.4162 51.208C30.7003 50.9681 30.2275 50.2459 30.2658 49.451V49.451C30.2625 49.0576 30.3874 48.6752 30.6194 48.3682L37.2188 39.3309C37.4841 38.9538 37.8815 38.7059 38.3213 38.6433C38.7611 38.5806 39.2062 38.7083 39.5561 38.9977L45.6841 44.1202L51.0657 36.7696C51.3245 36.3907 51.7171 36.1391 52.1538 36.0724C52.5906 36.0056 53.0342 36.1295 53.3834 36.4157C54.1047 37.0146 54.2441 38.114 53.6976 38.8936V38.9353Z",
        fill: "url(#paint3_linear_7412_6942)"
      }), /*#__PURE__*/jsx$1("path", {
        d: "M30.4656 49.4606L30.2658 49.451L30.4658 49.4493C30.4629 49.099 30.5742 48.7597 30.7789 48.4887L30.779 48.4888L30.7809 48.4861L37.3803 39.4488L37.3803 39.4489L37.3823 39.446C37.6173 39.1121 37.9667 38.8958 38.3496 38.8412C38.7321 38.7867 39.1208 38.8974 39.4282 39.1516C39.4284 39.1517 39.4285 39.1517 39.4286 39.1518L45.5558 44.2737L45.7194 44.4105L45.8454 44.2384L51.2271 36.8878L51.2272 36.8879L51.2309 36.8824C51.4597 36.5472 51.8044 36.328 52.184 36.2701C52.5632 36.2121 52.9499 36.3192 53.2562 36.57C53.8949 37.1009 54.0219 38.0825 53.5338 38.7788L53.4976 38.8305V38.87L47.1527 47.5631L47.1527 47.5631L47.1509 47.5656C46.9131 47.9022 46.5591 48.1185 46.1721 48.1698C45.7854 48.221 45.3939 48.1038 45.0874 47.8414L45.0853 47.8397L38.9573 42.738L38.7933 42.6014L38.6677 42.7739L33.1485 50.3536L33.143 50.3612L33.1382 50.3693C32.784 50.9665 32.1015 51.2267 31.4798 51.0184C30.855 50.809 30.4313 50.1729 30.4656 49.4606Z",
        stroke: "url(#paint4_linear_7412_6942)",
        strokeWidth: 0.4
      })]
    }), /*#__PURE__*/jsxs("defs", {
      children: [/*#__PURE__*/jsxs("filter", {
        id: "filter0_f_7412_6942",
        x: -0.00390625,
        y: 0.26355,
        width: 66.7246,
        height: 67.3623,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx$1("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx$1("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/jsx$1("feGaussianBlur", {
          stdDeviation: 8.5,
          result: "effect1_foregroundBlur_7412_6942"
        })]
      }), /*#__PURE__*/jsx$1("clipPath", {
        id: "bgblur_0_7412_6942_clip_path",
        transform: "translate(5.32422 5.58008)",
        children: /*#__PURE__*/jsx$1("path", {
          d: "M51.706 18.9199H32.3404C28.4232 18.9199 25.1185 20.3836 22.7974 22.9565C20.4803 25.525 19.1758 29.1616 19.1758 33.4594V52.8348C19.1758 57.121 20.4805 60.7518 22.7976 63.3171C25.1186 65.8869 28.4232 67.3506 32.3404 67.3506H51.706C55.6233 67.3506 58.9225 65.8868 61.2381 63.3167C63.5495 60.7511 64.8483 57.1205 64.8483 52.8348V33.4594C64.8483 29.1622 63.5497 25.5256 61.2383 22.957C58.9227 20.3837 55.6233 18.9199 51.706 18.9199Z"
        })
      }), /*#__PURE__*/jsx$1("clipPath", {
        id: "bgblur_1_7412_6942_clip_path",
        transform: "translate(-48.4355 -0.935425)",
        children: /*#__PURE__*/jsx$1("path", {
          d: "M66.7176 15.9354C64.905 15.9354 63.4355 17.4956 63.4355 19.4201C63.4355 21.3447 64.905 22.9048 66.7176 22.9048C68.5302 22.9048 69.9997 21.3447 69.9997 19.4201C69.9997 18.4959 69.6539 17.6096 69.0384 16.9561C68.4229 16.3026 67.5881 15.9354 66.7176 15.9354Z"
        })
      }), /*#__PURE__*/jsxs("filter", {
        id: "filter3_d_7412_6942",
        x: 15.2637,
        y: 21.0547,
        width: 53.7676,
        height: 45.2349,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx$1("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx$1("feColorMatrix", {
          "in": "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/jsx$1("feOffset", {
          dx: 5,
          dy: 5
        }), /*#__PURE__*/jsx$1("feGaussianBlur", {
          stdDeviation: 5
        }), /*#__PURE__*/jsx$1("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 1 0 0 0 0 0.321569 0 0 0 0 0.54902 0 0 0 0.5 0"
        }), /*#__PURE__*/jsx$1("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_7412_6942"
        }), /*#__PURE__*/jsx$1("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "effect1_dropShadow_7412_6942",
          result: "shape"
        })]
      }), /*#__PURE__*/jsx$1("clipPath", {
        id: "bgblur_2_7412_6942_clip_path",
        transform: "translate(-15.2637 -21.0547)",
        children: /*#__PURE__*/jsx$1("path", {
          d: "M53.6976 38.9353L47.3143 47.681C47.0457 48.0611 46.6429 48.3091 46.1984 48.3681C45.7539 48.427 45.3059 48.2917 44.9573 47.9934L38.8293 42.8917L33.3102 50.4713C32.9105 51.1452 32.1321 51.4479 31.4162 51.208C30.7003 50.9681 30.2275 50.2459 30.2658 49.451V49.451C30.2625 49.0576 30.3874 48.6752 30.6194 48.3682L37.2188 39.3309C37.4841 38.9538 37.8815 38.7059 38.3213 38.6433C38.7611 38.5806 39.2062 38.7083 39.5561 38.9977L45.6841 44.1202L51.0657 36.7696C51.3245 36.3907 51.7171 36.1391 52.1538 36.0724C52.5906 36.0056 53.0342 36.1295 53.3834 36.4157C54.1047 37.0146 54.2441 38.114 53.6976 38.8936V38.9353Z"
        })
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint0_linear_7412_6942",
        x1: 37.3126,
        y1: 36.0386,
        x2: 2.33416,
        y2: 64.9479,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "#FF759F"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "#FF196E"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint1_linear_7412_6942",
        x1: 26.7869,
        y1: 24.9457,
        x2: 57.3741,
        y2: 60.6256,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "white",
          stopOpacity: 0.25
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "white",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint2_linear_7412_6942",
        x1: 67.2009,
        y1: 19.8868,
        x2: 61.3057,
        y2: 22.5865,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "#FF759F"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "#FF196E"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint3_linear_7412_6942",
        x1: 52.346,
        y1: 38.8058,
        x2: 25.9116,
        y2: 40.1504,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "white"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "white",
          stopOpacity: 0.2
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint4_linear_7412_6942",
        x1: 34.0471,
        y1: 37.8296,
        x2: 42.1634,
        y2: 53.5118,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "white",
          stopOpacity: 0.25
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "white",
          stopOpacity: 0
        })]
      })]
    })]
  });
}

var DOMAIN_ADDONS = [{
  icon: /*#__PURE__*/jsx$1(PrivacySVG, {}),
  name: 'Privacy',
  itemCode: DomainAddons.Privacy,
  pricing: {
    reg: -1,
    rnw: -1
  },
  description: 'Hides your registration details, blocking spammers and unwanted contacts.',
  info: ['Keep your personal details private in domain registration records.', 'Block spammers, scammers, and unwanted contacts.', 'Keep your registration information secure and private.', 'Protect your identity from unauthorized access.', 'Comply with privacy regulations and safeguard your data.'],
  isCheckedByDefault: true
}, {
  icon: /*#__PURE__*/jsx$1(OwnershipProtectionSVG, {}),
  name: 'Ownership Protection',
  itemCode: DomainAddons.Ownership,
  pricing: {
    reg: -1,
    rnw: -1
  },
  description: 'Prevent unauthorized transfers and accidental changes, keeping your domain safe and secure.',
  info: ['Prevent unauthorized domain transfers and changes.', 'Secure your domain from accidental ownership loss.', 'Ensure your domain stays under your control at all times.', 'Add an extra layer of security to protect your online assets.'],
  isCheckedByDefault: false
}, {
  icon: /*#__PURE__*/jsx$1(ExpiryProtectionSVG, {}),
  name: 'Expiry Protection',
  itemCode: DomainAddons.Expiry,
  pricing: {
    reg: -1,
    rnw: -1
  },
  description: 'Prevent accidental domain loss by keeping it secure even if renewal payment is missed.',
  info: ['Prevent accidental domain expiration and loss.', 'Automatically renew your domain even if you miss a renewal payment.', 'Ensure continuous ownership without interruption or downtime.', 'Receive alerts to remind you of upcoming renewals.', 'Protect your domain from being claimed by others.'],
  isCheckedByDefault: false
}, {
  icon: /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(OwnershipProtectionSVG, {}), /*#__PURE__*/jsx$1(ExpiryProtectionSVG, {})]
  }),
  name: 'Ownership + Expiry Protection',
  itemCode: DomainAddons.Bundle,
  pricing: {
    reg: -1,
    rnw: -1
  },
  description: 'Prevent unauthorized transfers and accidental changes while ensuring it never expires unexpectedly.',
  info: ['Combine expiry and ownership protection for maximum domain security.', 'Prevent accidental expiration and unauthorized transfers.', 'Ensure your domain stays secure and under your control.', 'Keep your domain safe from unauthorized changes and claims.', 'Add an extra layer of security to protect your online assets.'],
  isCheckedByDefault: true
}];

function MwpBaseSVG() {
  return /*#__PURE__*/jsxs("svg", {
    width: 80,
    height: 76,
    viewBox: "0 0 80 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/jsx$1("path", {
      d: "M50.5327 13.6795C47.6877 12.2061 44.3701 11.9521 41.3473 12.9634L21.4071 18.2821C18.26 18.9165 15.5145 20.7877 13.7907 23.4797C12.3106 26.3118 12.0554 29.6143 13.077 32.6446L18.4199 52.494C19.0572 55.6268 20.937 58.3598 23.6413 60.0757C26.4863 61.5491 29.8039 61.8031 32.848 60.7861L52.7882 55.4675C55.914 54.8387 58.6809 52.9618 60.4047 50.2698C61.8634 47.4435 62.1399 44.1352 61.1183 41.105L55.7754 21.2556C55.1168 18.1285 53.237 15.3954 50.5327 13.6795",
      fill: "url(#paint0_linear_7412_6412)"
    }), /*#__PURE__*/jsx$1("g", {
      opacity: 0.5,
      filter: "url(#filter0_f_7412_6412)",
      children: /*#__PURE__*/jsx$1("path", {
        d: "M40.4665 19.2734L25.4291 23.4489C19.9746 24.9634 17.5822 28.6407 18.9244 33.4308L23.4703 49.6542C24.8346 54.5228 28.7761 56.3736 34.2306 54.8591L49.268 50.6837C54.8104 49.1447 57.1307 45.5551 55.7665 40.6865L51.2205 24.4631C49.8783 19.6731 46.0089 17.7345 40.4665 19.2734Z",
        fill: "#30AD31"
      })
    }), /*#__PURE__*/jsx$1("foreignObject", {
      x: 0.902344,
      y: -1.02869,
      width: 98.0977,
      height: 97.8793,
      children: /*#__PURE__*/jsx$1("div", {
        style: {
          backdropFilter: 'blur(12px)',
          clipPath: 'url(#bgblur_0_7412_6412_clip_path)',
          height: '100%',
          width: '100%'
        }
      })
    }), /*#__PURE__*/jsxs("g", {
      "data-figma-bg-blur-radius": 24,
      children: [/*#__PURE__*/jsxs("mask", {
        id: "path-3-outside-1_7412_6412",
        maskUnits: "userSpaceOnUse",
        x: 24.9023,
        y: 22.9713,
        width: 51,
        height: 50,
        fill: "black",
        children: [/*#__PURE__*/jsx$1("rect", {
          fill: "white",
          x: 24.9023,
          y: 22.9713,
          width: 51,
          height: 50
        }), /*#__PURE__*/jsx$1("path", {
          d: "M70.6123 27.3202C68.0417 24.9766 64.6303 23.7808 61.1708 23.9961H38.7321C35.2486 23.7808 31.8372 24.9766 29.2666 27.3202C26.9122 29.8791 25.711 33.275 25.9272 36.7427V59.0792C25.711 62.5469 26.9122 65.9428 29.2666 68.5017C31.8372 70.8454 35.2486 72.0411 38.7321 71.8259H61.1708C64.6303 72.0411 68.0658 70.8454 70.6364 68.5017C72.9667 65.9428 74.1919 62.5469 73.9757 59.0792V36.7427C74.1679 33.275 72.9667 29.8791 70.6123 27.3202"
        })]
      }), /*#__PURE__*/jsx$1("path", {
        d: "M70.6123 27.3202C68.0417 24.9766 64.6303 23.7808 61.1708 23.9961H38.7321C35.2486 23.7808 31.8372 24.9766 29.2666 27.3202C26.9122 29.8791 25.711 33.275 25.9272 36.7427V59.0792C25.711 62.5469 26.9122 65.9428 29.2666 68.5017C31.8372 70.8454 35.2486 72.0411 38.7321 71.8259H61.1708C64.6303 72.0411 68.0658 70.8454 70.6364 68.5017C72.9667 65.9428 74.1919 62.5469 73.9757 59.0792V36.7427C74.1679 33.275 72.9667 29.8791 70.6123 27.3202",
        fill: "#72DC60",
        fillOpacity: 0.35
      }), /*#__PURE__*/jsx$1("path", {
        d: "M69.9386 28.0592C70.3467 28.4313 70.9792 28.4021 71.3513 27.994C71.7234 27.5858 71.6942 26.9533 71.2861 26.5813L69.9386 28.0592ZM61.1708 23.9961V24.9961C61.1915 24.9961 61.2122 24.9954 61.2329 24.9941L61.1708 23.9961ZM38.7321 23.9961L38.6705 24.9942C38.691 24.9954 38.7116 24.9961 38.7321 24.9961V23.9961ZM29.2666 27.3202L28.5928 26.5813C28.5712 26.601 28.5505 26.6216 28.5307 26.6431L29.2666 27.3202ZM25.9272 36.7427H26.9272C26.9272 36.7219 26.9266 36.7012 26.9253 36.6805L25.9272 36.7427ZM25.9272 59.0792L26.9253 59.1415C26.9266 59.1207 26.9272 59.1 26.9272 59.0792H25.9272ZM29.2666 68.5017L28.5307 69.1788C28.5505 69.2003 28.5712 69.221 28.5928 69.2407L29.2666 68.5017ZM38.7321 71.8259V70.8259C38.7116 70.8259 38.691 70.8265 38.6705 70.8278L38.7321 71.8259ZM61.1708 71.8259L61.2329 70.8278C61.2122 70.8265 61.1915 70.8259 61.1708 70.8259V71.8259ZM70.6364 68.5017L71.3101 69.2407C71.333 69.2198 71.3549 69.1979 71.3757 69.175L70.6364 68.5017ZM73.9757 59.0792H72.9757C72.9757 59.1 72.9764 59.1207 72.9777 59.1415L73.9757 59.0792ZM73.9757 36.7427L72.9773 36.6874C72.9762 36.7058 72.9757 36.7242 72.9757 36.7427H73.9757ZM71.3482 26.6431C70.9743 26.2367 70.3417 26.2104 69.9352 26.5843C69.5288 26.9583 69.5025 27.5909 69.8764 27.9973L71.3482 26.6431ZM71.2861 26.5813C68.515 24.0548 64.8379 22.766 61.1087 22.998L61.2329 24.9941C64.4227 24.7957 67.5685 25.8984 69.9386 28.0592L71.2861 26.5813ZM61.1708 22.9961H38.7321V24.9961H61.1708V22.9961ZM38.7938 22.998C35.0419 22.7661 31.3647 24.0541 28.5928 26.5813L29.9403 28.0592C32.3096 25.899 35.4553 24.7955 38.6705 24.9942L38.7938 22.998ZM28.5307 26.6431C25.9915 29.4028 24.696 33.0659 24.9291 36.8049L26.9253 36.6805C26.726 33.4842 27.8328 30.3554 30.0025 27.9973L28.5307 26.6431ZM24.9272 36.7427V59.0792H26.9272V36.7427H24.9272ZM24.9291 59.017C24.696 62.756 25.9915 66.4191 28.5307 69.1788L30.0025 67.8246C27.8328 65.4665 26.726 62.3377 26.9253 59.1415L24.9291 59.017ZM28.5928 69.2407C31.3647 71.7678 35.0419 73.0558 38.7938 72.824L38.6705 70.8278C35.4553 71.0264 32.3096 69.9229 29.9403 67.7627L28.5928 69.2407ZM38.7321 72.8259H61.1708V70.8259H38.7321V72.8259ZM61.1087 72.8239C64.8362 73.0559 68.5377 71.7683 71.3101 69.2407L69.9626 67.7627C67.5938 69.9224 64.4244 71.0264 61.2329 70.8278L61.1087 72.8239ZM71.3757 69.175C73.8845 66.4202 75.2072 62.7603 74.9738 59.017L72.9777 59.1415C73.1767 62.3334 72.049 65.4654 69.897 67.8284L71.3757 69.175ZM74.9757 59.0792V36.7427H72.9757V59.0792H74.9757ZM74.9742 36.798C75.1812 33.0639 73.8875 29.403 71.3482 26.6431L69.8764 27.9973C72.0459 30.3553 73.1547 33.4862 72.9773 36.6874L74.9742 36.798Z",
        fill: "url(#paint1_linear_7412_6412)",
        mask: "url(#path-3-outside-1_7412_6412)"
      })]
    }), /*#__PURE__*/jsx$1("foreignObject", {
      x: 22.625,
      y: 18.8142,
      width: 57.1406,
      height: 56.9641,
      children: /*#__PURE__*/jsx$1("div", {
        style: {
          backdropFilter: 'blur(7.5px)',
          clipPath: 'url(#bgblur_1_7412_6412_clip_path)',
          height: '100%',
          width: '100%'
        }
      })
    }), /*#__PURE__*/jsxs("g", {
      filter: "url(#filter2_d_7412_6412)",
      "data-figma-bg-blur-radius": 15,
      children: [/*#__PURE__*/jsx$1("mask", {
        id: "path-5-inside-2_7412_6412",
        fill: "white",
        children: /*#__PURE__*/jsx$1("path", {
          d: "M63.6673 43.3682L47.499 59.5108C46.6581 60.3239 45.553 60.7783 44.3998 60.7783H38.7541C38.4418 60.7783 38.1535 60.6587 37.9373 60.4435C37.7211 60.2282 37.625 59.9412 37.625 59.6304L37.7691 53.9625C37.7932 52.8385 38.2496 51.7863 39.0424 50.9971L50.502 39.5897C50.6942 39.3983 51.0305 39.3983 51.2227 39.5897L55.2348 43.5595C55.499 43.8226 55.8834 43.99 56.2919 43.99C57.1807 43.99 57.8775 43.2726 57.8775 42.4116C57.8775 41.9812 57.7093 41.5985 57.445 41.3115C57.3729 41.2159 53.5531 37.4373 53.5531 37.4373C53.3128 37.1982 53.3128 36.7916 53.5531 36.5525L55.1627 34.9263C56.6522 33.4435 59.0546 33.4435 60.5441 34.9263L63.6673 38.0352C65.1328 39.494 65.1328 41.8855 63.6673 43.3682"
        })
      }), /*#__PURE__*/jsx$1("path", {
        d: "M63.6673 43.3682L47.499 59.5108C46.6581 60.3239 45.553 60.7783 44.3998 60.7783H38.7541C38.4418 60.7783 38.1535 60.6587 37.9373 60.4435C37.7211 60.2282 37.625 59.9412 37.625 59.6304L37.7691 53.9625C37.7932 52.8385 38.2496 51.7863 39.0424 50.9971L50.502 39.5897C50.6942 39.3983 51.0305 39.3983 51.2227 39.5897L55.2348 43.5595C55.499 43.8226 55.8834 43.99 56.2919 43.99C57.1807 43.99 57.8775 43.2726 57.8775 42.4116C57.8775 41.9812 57.7093 41.5985 57.445 41.3115C57.3729 41.2159 53.5531 37.4373 53.5531 37.4373C53.3128 37.1982 53.3128 36.7916 53.5531 36.5525L55.1627 34.9263C56.6522 33.4435 59.0546 33.4435 60.5441 34.9263L63.6673 38.0352C65.1328 39.494 65.1328 41.8855 63.6673 43.3682",
        fill: "url(#paint2_linear_7412_6412)"
      }), /*#__PURE__*/jsx$1("path", {
        d: "M47.499 59.5108L47.638 59.6546L47.6403 59.6523L47.499 59.5108ZM37.625 59.6304L37.425 59.6253V59.6304H37.625ZM37.7691 53.9625L37.9691 53.9676L37.9691 53.9668L37.7691 53.9625ZM39.0424 50.9971L39.1835 51.1388L39.1835 51.1388L39.0424 50.9971ZM50.502 39.5897L50.3609 39.4479L50.3609 39.4479L50.502 39.5897ZM51.2227 39.5897L51.0816 39.7314L51.0821 39.7318L51.2227 39.5897ZM55.2348 43.5595L55.3759 43.4178L55.3755 43.4174L55.2348 43.5595ZM57.445 41.3115L57.2853 41.4319L57.2912 41.4398L57.2979 41.447L57.445 41.3115ZM53.5531 37.4373L53.412 37.5791L53.4124 37.5795L53.5531 37.4373ZM53.5531 36.5525L53.6942 36.6942L53.6952 36.6932L53.5531 36.5525ZM55.1627 34.9263L55.0216 34.7845L55.0206 34.7856L55.1627 34.9263ZM60.5441 34.9263L60.403 35.068L60.5441 34.9263ZM63.6673 38.0352L63.8084 37.8934L63.8084 37.8934L63.6673 38.0352ZM63.526 43.2267L47.3577 59.3692L47.6403 59.6523L63.8086 43.5097L63.526 43.2267ZM47.3599 59.367C46.5555 60.1449 45.4999 60.5783 44.3998 60.5783V60.9783C45.6061 60.9783 46.7608 60.5028 47.638 59.6545L47.3599 59.367ZM44.3998 60.5783H38.7541V60.9783H44.3998V60.5783ZM38.7541 60.5783C38.4943 60.5783 38.2569 60.4793 38.0784 60.3017L37.7962 60.5852C38.0502 60.838 38.3894 60.9783 38.7541 60.9783V60.5783ZM38.0784 60.3017C37.9074 60.1315 37.825 59.8996 37.825 59.6304H37.425C37.425 59.9829 37.5348 60.325 37.7962 60.5852L38.0784 60.3017ZM37.8249 59.6354L37.9691 53.9676L37.5692 53.9574L37.4251 59.6253L37.8249 59.6354ZM37.9691 53.9668C37.992 52.8951 38.427 51.8919 39.1835 51.1388L38.9013 50.8553C38.0723 51.6806 37.5943 52.782 37.5692 53.9582L37.9691 53.9668ZM39.1835 51.1388L50.6431 39.7314L50.3609 39.4479L38.9013 50.8553L39.1835 51.1388ZM50.6431 39.7314C50.7573 39.6178 50.9675 39.6178 51.0816 39.7314L51.3638 39.4479C51.0936 39.1789 50.6311 39.1789 50.3609 39.4479L50.6431 39.7314ZM51.0821 39.7318L55.0941 43.7017L55.3755 43.4174L51.3634 39.4475L51.0821 39.7318ZM55.0937 43.7013C55.3951 44.0013 55.8301 44.19 56.2919 44.19V43.79C55.9368 43.79 55.603 43.6439 55.3759 43.4178L55.0937 43.7013ZM56.2919 44.19C57.2923 44.19 58.0775 43.3819 58.0775 42.4116H57.6775C57.6775 43.1632 57.0692 43.79 56.2919 43.79V44.19ZM58.0775 42.4116C58.0775 41.9274 57.8879 41.4972 57.5921 41.1761L57.2979 41.447C57.5307 41.6998 57.6775 42.0349 57.6775 42.4116H58.0775ZM57.6048 41.1912C57.5906 41.1724 57.5591 41.1399 57.533 41.113C57.5003 41.0793 57.455 41.0333 57.3992 40.9769C57.2875 40.864 57.132 40.7082 56.9478 40.5243C56.5793 40.1564 56.0949 39.6749 55.6129 39.1966C55.1308 38.7182 54.6511 38.2429 54.2918 37.8871C54.1122 37.7092 53.9626 37.5612 53.858 37.4577C53.8057 37.4059 53.7647 37.3653 53.7367 37.3376C53.7227 37.3238 53.7119 37.3131 53.7047 37.306C53.7011 37.3024 53.6983 37.2997 53.6965 37.2979C53.6956 37.297 53.6949 37.2963 53.6944 37.2958C53.6942 37.2956 53.694 37.2954 53.6939 37.2953C53.6939 37.2952 53.6938 37.2952 53.6938 37.2952C53.6937 37.2951 53.6937 37.2951 53.5531 37.4373C53.4124 37.5795 53.4124 37.5795 53.4125 37.5795C53.4125 37.5796 53.4125 37.5796 53.4126 37.5797C53.4127 37.5798 53.4129 37.58 53.4131 37.5802C53.4136 37.5806 53.4143 37.5813 53.4152 37.5822C53.417 37.5841 53.4198 37.5868 53.4234 37.5903C53.4306 37.5975 53.4413 37.6081 53.4553 37.6219C53.4833 37.6496 53.5244 37.6903 53.5767 37.742C53.6813 37.8455 53.8307 37.9935 54.0103 38.1713C54.3695 38.527 54.8492 39.0023 55.3311 39.4805C55.8131 39.9588 56.2972 40.4399 56.6652 40.8074C56.8492 40.9911 57.004 41.1462 57.115 41.2583C57.1705 41.3144 57.2146 41.3593 57.2459 41.3915C57.2836 41.4305 57.2904 41.4387 57.2853 41.4319L57.6048 41.1912ZM53.6942 37.2956C53.5325 37.1346 53.5325 36.8552 53.6942 36.6942L53.412 36.4107C53.0932 36.728 53.0932 37.2617 53.412 37.5791L53.6942 37.2956ZM53.6952 36.6932L55.3049 35.0669L55.0206 34.7856L53.4109 36.4118L53.6952 36.6932ZM55.3038 35.068C56.7153 33.6629 58.9916 33.6629 60.403 35.068L60.6852 34.7845C59.1177 33.2241 56.5891 33.2241 55.0216 34.7845L55.3038 35.068ZM60.403 35.068L63.5262 38.1769L63.8084 37.8934L60.6852 34.7845L60.403 35.068ZM63.5262 38.1769C64.9125 39.5569 64.9142 41.8222 63.5251 43.2276L63.8095 43.5088C65.3514 41.9488 65.353 39.4311 63.8084 37.8934L63.5262 38.1769Z",
        fill: "url(#paint3_linear_7412_6412)",
        fillOpacity: 0.5,
        mask: "url(#path-5-inside-2_7412_6412)"
      })]
    }), /*#__PURE__*/jsxs("defs", {
      children: [/*#__PURE__*/jsxs("filter", {
        id: "filter0_f_7412_6412",
        x: 0.558594,
        y: 0.755615,
        width: 73.5898,
        height: 72.6187,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx$1("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx$1("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/jsx$1("feGaussianBlur", {
          stdDeviation: 9,
          result: "effect1_foregroundBlur_7412_6412"
        })]
      }), /*#__PURE__*/jsx$1("clipPath", {
        id: "bgblur_0_7412_6412_clip_path",
        transform: "translate(-0.902344 1.02869)",
        children: /*#__PURE__*/jsx$1("path", {
          d: "M70.6123 27.3202C68.0417 24.9766 64.6303 23.7808 61.1708 23.9961H38.7321C35.2486 23.7808 31.8372 24.9766 29.2666 27.3202C26.9122 29.8791 25.711 33.275 25.9272 36.7427V59.0792C25.711 62.5469 26.9122 65.9428 29.2666 68.5017C31.8372 70.8454 35.2486 72.0411 38.7321 71.8259H61.1708C64.6303 72.0411 68.0658 70.8454 70.6364 68.5017C72.9667 65.9428 74.1919 62.5469 73.9757 59.0792V36.7427C74.1679 33.275 72.9667 29.8791 70.6123 27.3202"
        })
      }), /*#__PURE__*/jsxs("filter", {
        id: "filter2_d_7412_6412",
        x: 22.625,
        y: 18.8142,
        width: 57.1406,
        height: 56.9641,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx$1("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx$1("feColorMatrix", {
          "in": "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/jsx$1("feOffset", {
          dx: 5,
          dy: 5
        }), /*#__PURE__*/jsx$1("feGaussianBlur", {
          stdDeviation: 5
        }), /*#__PURE__*/jsx$1("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.454902 0 0 0 0 0.870588 0 0 0 0 0.376471 0 0 0 0.5 0"
        }), /*#__PURE__*/jsx$1("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_7412_6412"
        }), /*#__PURE__*/jsx$1("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "effect1_dropShadow_7412_6412",
          result: "shape"
        })]
      }), /*#__PURE__*/jsx$1("clipPath", {
        id: "bgblur_1_7412_6412_clip_path",
        transform: "translate(-22.625 -18.8142)",
        children: /*#__PURE__*/jsx$1("path", {
          d: "M63.6673 43.3682L47.499 59.5108C46.6581 60.3239 45.553 60.7783 44.3998 60.7783H38.7541C38.4418 60.7783 38.1535 60.6587 37.9373 60.4435C37.7211 60.2282 37.625 59.9412 37.625 59.6304L37.7691 53.9625C37.7932 52.8385 38.2496 51.7863 39.0424 50.9971L50.502 39.5897C50.6942 39.3983 51.0305 39.3983 51.2227 39.5897L55.2348 43.5595C55.499 43.8226 55.8834 43.99 56.2919 43.99C57.1807 43.99 57.8775 43.2726 57.8775 42.4116C57.8775 41.9812 57.7093 41.5985 57.445 41.3115C57.3729 41.2159 53.5531 37.4373 53.5531 37.4373C53.3128 37.1982 53.3128 36.7916 53.5531 36.5525L55.1627 34.9263C56.6522 33.4435 59.0546 33.4435 60.5441 34.9263L63.6673 38.0352C65.1328 39.494 65.1328 41.8855 63.6673 43.3682"
        })
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint0_linear_7412_6412",
        x1: 52.7422,
        y1: 9.90044,
        x2: 32.2025,
        y2: 53.0986,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "#9BF763"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "#26AB5B"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint1_linear_7412_6412",
        x1: 33.5587,
        y1: 29.5493,
        x2: 64.071,
        y2: 67.512,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "white",
          stopOpacity: 0.25
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "white",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint2_linear_7412_6412",
        x1: 62.8421,
        y1: 38.6834,
        x2: 32.6096,
        y2: 39.6756,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "white"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "white",
          stopOpacity: 0.2
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint3_linear_7412_6412",
        x1: 40.5487,
        y1: 42.8593,
        x2: 63.5955,
        y2: 42.9874,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "white"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "white",
          stopOpacity: 0
        })]
      })]
    })]
  });
}

function MwpEcommSVG() {
  return /*#__PURE__*/jsxs("svg", {
    width: 69,
    height: 64,
    viewBox: "0 0 69 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/jsx$1("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.9574 11.9284C20.8766 10.8006 21.7958 10.2858 23.1976 10.2858H54.2322C54.9675 10.2858 55.565 9.6974 55.6339 8.91043L56.0706 3.41881C56.1395 2.58526 56.714 1.90126 57.4953 1.75171L62.9761 0.871578C63.9182 0.72203 64.8145 1.38642 64.9753 2.38913C65.1362 3.36978 64.4927 4.32591 63.5735 4.49752V4.49752C61.5273 4.8734 59.9894 6.578 59.8253 8.652L57.9894 31.86C57.7366 35.0961 55.2088 37.5943 52.1525 37.5943H27.0812C24.1628 37.5943 21.6809 35.3168 21.2673 32.2253L19.0842 16.1427C18.8774 14.6742 19.0382 13.0561 19.9574 11.9284",
      fill: "url(#paint0_linear_7412_7380)"
    }), /*#__PURE__*/jsx$1("g", {
      filter: "url(#filter0_f_7412_7380)",
      children: /*#__PURE__*/jsx$1("rect", {
        width: 27.5597,
        height: 17.2732,
        rx: 5,
        transform: "matrix(-1 0 0 1 54.0703 16.8442)",
        fill: "#2AA42B",
        fillOpacity: 0.5
      })
    }), /*#__PURE__*/jsx$1("foreignObject", {
      x: -24,
      y: -14.4463,
      width: 100.016,
      height: 102.247,
      children: /*#__PURE__*/jsx$1("div", {
        style: {
          backdropFilter: 'blur(12px)',
          clipPath: 'url(#bgblur_0_7412_7380_clip_path)',
          height: '100%',
          width: '100%'
        }
      })
    }), /*#__PURE__*/jsxs("g", {
      "data-figma-bg-blur-radius": 24,
      children: [/*#__PURE__*/jsxs("mask", {
        id: "path-3-outside-1_7412_7380",
        maskUnits: "userSpaceOnUse",
        x: 0,
        y: 8.55432,
        width: 53,
        height: 56,
        fill: "black",
        children: [/*#__PURE__*/jsx$1("rect", {
          fill: "white",
          y: 8.55432,
          width: 53,
          height: 56
        }), /*#__PURE__*/jsx$1("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M46.4558 20.8141C47.9801 20.8141 48.9796 21.374 49.9792 22.6003C50.9787 23.8266 51.1536 25.5861 50.9287 27.1829L48.5548 44.6711C48.105 48.0328 45.4063 50.5094 42.2328 50.5094H14.9704C11.6469 50.5094 8.8982 47.7929 8.62332 44.2739L6.32439 15.2131L2.55114 14.52C1.5516 14.3334 0.851924 13.2937 1.02684 12.2273C1.20176 11.137 2.17631 10.4145 3.20084 10.5771L9.16058 11.5342C10.0102 11.6968 10.6349 12.4406 10.7099 13.347L11.1846 19.3186C11.2596 20.1743 11.9093 20.8141 12.7089 20.8141H46.4558ZM14.5697 54.7232C12.4707 54.7232 10.7715 56.536 10.7715 58.7753C10.7715 60.988 12.4707 62.8008 14.5697 62.8008C16.6438 62.8008 18.343 60.988 18.343 58.7753C18.343 56.536 16.6438 54.7232 14.5697 54.7232ZM42.6815 54.7232C40.5825 54.7232 38.8833 56.536 38.8833 58.7753C38.8833 60.988 40.5825 62.8008 42.6815 62.8008C44.7555 62.8008 46.4548 60.988 46.4548 58.7753C46.4548 56.536 44.7555 54.7232 42.6815 54.7232Z"
        })]
      }), /*#__PURE__*/jsx$1("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M46.4558 20.8141C47.9801 20.8141 48.9796 21.374 49.9792 22.6003C50.9787 23.8266 51.1536 25.5861 50.9287 27.1829L48.5548 44.6711C48.105 48.0328 45.4063 50.5094 42.2328 50.5094H14.9704C11.6469 50.5094 8.8982 47.7929 8.62332 44.2739L6.32439 15.2131L2.55114 14.52C1.5516 14.3334 0.851924 13.2937 1.02684 12.2273C1.20176 11.137 2.17631 10.4145 3.20084 10.5771L9.16058 11.5342C10.0102 11.6968 10.6349 12.4406 10.7099 13.347L11.1846 19.3186C11.2596 20.1743 11.9093 20.8141 12.7089 20.8141H46.4558ZM14.5697 54.7232C12.4707 54.7232 10.7715 56.536 10.7715 58.7753C10.7715 60.988 12.4707 62.8008 14.5697 62.8008C16.6438 62.8008 18.343 60.988 18.343 58.7753C18.343 56.536 16.6438 54.7232 14.5697 54.7232ZM42.6815 54.7232C40.5825 54.7232 38.8833 56.536 38.8833 58.7753C38.8833 60.988 40.5825 62.8008 42.6815 62.8008C44.7555 62.8008 46.4548 60.988 46.4548 58.7753C46.4548 56.536 44.7555 54.7232 42.6815 54.7232Z",
        fill: "#72DC60",
        fillOpacity: 0.35
      }), /*#__PURE__*/jsx$1("path", {
        d: "M49.9792 22.6003L49.204 23.2321L49.204 23.2321L49.9792 22.6003ZM50.9287 27.1829L49.9385 27.0435L49.9378 27.0484L50.9287 27.1829ZM48.5548 44.6711L47.5639 44.5366L47.5637 44.5385L48.5548 44.6711ZM8.62332 44.2739L9.62029 44.196L9.62021 44.195L8.62332 44.2739ZM6.32439 15.2131L7.32128 15.1343C7.28555 14.6826 6.95065 14.3114 6.50506 14.2296L6.32439 15.2131ZM2.55114 14.52L2.36761 15.503L2.37046 15.5035L2.55114 14.52ZM1.02684 12.2273L2.01366 12.3892L2.01422 12.3857L1.02684 12.2273ZM3.20084 10.5771L3.35939 9.5898L3.3576 9.58951L3.20084 10.5771ZM9.16058 11.5342L9.34857 10.552C9.33878 10.5502 9.32897 10.5484 9.31913 10.5468L9.16058 11.5342ZM10.7099 13.347L11.7067 13.2677L11.7065 13.2646L10.7099 13.347ZM11.1846 19.3186L10.1878 19.3978L10.1885 19.4058L11.1846 19.3186ZM50.7543 21.9685C50.2 21.2885 49.5992 20.7355 48.8747 20.3596C48.1421 19.9797 47.3475 19.8141 46.4558 19.8141V21.8141C47.0884 21.8141 47.5557 21.9285 47.9538 22.135C48.36 22.3457 48.7588 22.6858 49.204 23.2321L50.7543 21.9685ZM51.919 27.3224C52.161 25.6039 52.0086 23.5073 50.7543 21.9685L49.204 23.2321C49.9488 24.1458 50.1463 25.5683 49.9385 27.0435L51.919 27.3224ZM49.5457 44.8056L51.9196 27.3174L49.9378 27.0484L47.5639 44.5366L49.5457 44.8056ZM42.2328 51.5094C45.9524 51.5094 49.0359 48.616 49.546 44.8037L47.5637 44.5385C47.1742 47.4495 44.8602 49.5094 42.2328 49.5094V51.5094ZM14.9704 51.5094H42.2328V49.5094H14.9704V51.5094ZM7.62636 44.3518C7.93743 48.3341 11.0695 51.5094 14.9704 51.5094V49.5094C12.2244 49.5094 9.85896 47.2516 9.62029 44.196L7.62636 44.3518ZM5.3275 15.292L7.62644 44.3528L9.62021 44.195L7.32128 15.1343L5.3275 15.292ZM2.37046 15.5035L6.14372 16.1967L6.50506 14.2296L2.73181 13.5364L2.37046 15.5035ZM0.0400311 12.0655C-0.215777 13.6249 0.791351 15.2087 2.36761 15.503L2.73466 13.537C2.31185 13.458 1.91963 12.9624 2.01365 12.3892L0.0400311 12.0655ZM3.3576 9.58951C1.75393 9.33497 0.296157 10.4689 0.0394679 12.0689L2.01422 12.3857C2.10737 11.8051 2.59869 11.4941 3.04407 11.5648L3.3576 9.58951ZM9.31913 10.5468L3.35939 9.5898L3.04228 11.5645L9.00202 12.5216L9.31913 10.5468ZM11.7065 13.2646C11.5983 11.9573 10.6834 10.8075 9.34857 10.552L8.97258 12.5164C9.337 12.5861 9.67145 12.9239 9.71326 13.4294L11.7065 13.2646ZM12.1815 19.2393L11.7067 13.2677L9.713 13.4263L10.1878 19.3978L12.1815 19.2393ZM12.7089 19.8141C12.4894 19.8141 12.2161 19.6343 12.1808 19.2313L10.1885 19.4058C10.3031 20.7143 11.3292 21.8141 12.7089 21.8141V19.8141ZM46.4558 19.8141H12.7089V21.8141H46.4558V19.8141ZM11.7715 58.7753C11.7715 57.0263 13.083 55.7232 14.5697 55.7232V53.7232C11.8585 53.7232 9.7715 56.0456 9.7715 58.7753H11.7715ZM14.5697 61.8008C13.0788 61.8008 11.7715 60.4933 11.7715 58.7753H9.7715C9.7715 61.4828 11.8626 63.8008 14.5697 63.8008V61.8008ZM17.343 58.7753C17.343 60.4977 16.0315 61.8008 14.5697 61.8008V63.8008C17.256 63.8008 19.343 61.4784 19.343 58.7753H17.343ZM14.5697 55.7232C16.0274 55.7232 17.343 57.0219 17.343 58.7753H19.343C19.343 56.0501 17.2602 53.7232 14.5697 53.7232V55.7232ZM39.8833 58.7753C39.8833 57.0263 41.1947 55.7232 42.6815 55.7232V53.7232C39.9702 53.7232 37.8833 56.0456 37.8833 58.7753H39.8833ZM42.6815 61.8008C41.1906 61.8008 39.8833 60.4933 39.8833 58.7753H37.8833C37.8833 61.4828 39.9744 63.8008 42.6815 63.8008V61.8008ZM45.4548 58.7753C45.4548 60.4977 44.1433 61.8008 42.6815 61.8008V63.8008C45.3678 63.8008 47.4548 61.4784 47.4548 58.7753H45.4548ZM42.6815 55.7232C44.1391 55.7232 45.4548 57.0219 45.4548 58.7753H47.4548C47.4548 56.0501 45.3719 53.7232 42.6815 53.7232V55.7232Z",
        fill: "url(#paint1_linear_7412_7380)",
        mask: "url(#path-3-outside-1_7412_7380)"
      })]
    }), /*#__PURE__*/jsx$1("foreignObject", {
      x: 14.4395,
      y: 15.674,
      width: 40.6699,
      height: 33.9988,
      children: /*#__PURE__*/jsx$1("div", {
        style: {
          backdropFilter: 'blur(7.5px)',
          clipPath: 'url(#bgblur_1_7412_7380_clip_path)',
          height: '100%',
          width: '100%'
        }
      })
    }), /*#__PURE__*/jsxs("g", {
      filter: "url(#filter2_d_7412_7380)",
      "data-figma-bg-blur-radius": 15,
      children: [/*#__PURE__*/jsx$1("mask", {
        id: "path-5-inside-2_7412_7380",
        fill: "white",
        children: /*#__PURE__*/jsx$1("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M38.2354 34.6728H31.3136C30.2641 34.6728 29.4395 33.7664 29.4395 32.6734C29.4395 31.5537 30.2641 30.674 31.3136 30.674H38.2354C39.2849 30.674 40.1095 31.5537 40.1095 32.6734C40.1095 33.7664 39.2849 34.6728 38.2354 34.6728"
        })
      }), /*#__PURE__*/jsx$1("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M38.2354 34.6728H31.3136C30.2641 34.6728 29.4395 33.7664 29.4395 32.6734C29.4395 31.5537 30.2641 30.674 31.3136 30.674H38.2354C39.2849 30.674 40.1095 31.5537 40.1095 32.6734C40.1095 33.7664 39.2849 34.6728 38.2354 34.6728",
        fill: "url(#paint2_linear_7412_7380)"
      }), /*#__PURE__*/jsx$1("path", {
        d: "M38.2354 34.4728H31.3136V34.8728H38.2354V34.4728ZM31.3136 34.4728C30.3882 34.4728 29.6395 33.6701 29.6395 32.6734H29.2395C29.2395 33.8626 30.1399 34.8728 31.3136 34.8728V34.4728ZM29.6395 32.6734C29.6395 31.6518 30.3865 30.874 31.3136 30.874V30.474C30.1416 30.474 29.2395 31.4556 29.2395 32.6734H29.6395ZM31.3136 30.874H38.2354V30.474H31.3136V30.874ZM38.2354 30.874C39.1624 30.874 39.9095 31.6518 39.9095 32.6734H40.3095C40.3095 31.4556 39.4073 30.474 38.2354 30.474V30.874ZM39.9095 32.6734C39.9095 33.6701 39.1608 34.4728 38.2354 34.4728V34.8728C39.409 34.8728 40.3095 33.8626 40.3095 32.6734H39.9095Z",
        fill: "url(#paint3_linear_7412_7380)",
        fillOpacity: 0.5,
        mask: "url(#path-5-inside-2_7412_7380)"
      })]
    }), /*#__PURE__*/jsxs("defs", {
      children: [/*#__PURE__*/jsxs("filter", {
        id: "filter0_f_7412_7380",
        x: 12.5098,
        y: 2.84424,
        width: 55.5605,
        height: 45.2732,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx$1("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx$1("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/jsx$1("feGaussianBlur", {
          stdDeviation: 7,
          result: "effect1_foregroundBlur_7412_7380"
        })]
      }), /*#__PURE__*/jsx$1("clipPath", {
        id: "bgblur_0_7412_7380_clip_path",
        transform: "translate(24 14.4463)",
        children: /*#__PURE__*/jsx$1("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M46.4558 20.8141C47.9801 20.8141 48.9796 21.374 49.9792 22.6003C50.9787 23.8266 51.1536 25.5861 50.9287 27.1829L48.5548 44.6711C48.105 48.0328 45.4063 50.5094 42.2328 50.5094H14.9704C11.6469 50.5094 8.8982 47.7929 8.62332 44.2739L6.32439 15.2131L2.55114 14.52C1.5516 14.3334 0.851924 13.2937 1.02684 12.2273C1.20176 11.137 2.17631 10.4145 3.20084 10.5771L9.16058 11.5342C10.0102 11.6968 10.6349 12.4406 10.7099 13.347L11.1846 19.3186C11.2596 20.1743 11.9093 20.8141 12.7089 20.8141H46.4558ZM14.5697 54.7232C12.4707 54.7232 10.7715 56.536 10.7715 58.7753C10.7715 60.988 12.4707 62.8008 14.5697 62.8008C16.6438 62.8008 18.343 60.988 18.343 58.7753C18.343 56.536 16.6438 54.7232 14.5697 54.7232ZM42.6815 54.7232C40.5825 54.7232 38.8833 56.536 38.8833 58.7753C38.8833 60.988 40.5825 62.8008 42.6815 62.8008C44.7555 62.8008 46.4548 60.988 46.4548 58.7753C46.4548 56.536 44.7555 54.7232 42.6815 54.7232Z"
        })
      }), /*#__PURE__*/jsxs("filter", {
        id: "filter2_d_7412_7380",
        x: 14.4395,
        y: 15.674,
        width: 40.6699,
        height: 33.9988,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/jsx$1("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/jsx$1("feColorMatrix", {
          "in": "SourceAlpha",
          type: "matrix",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/jsx$1("feOffset", {
          dx: 5,
          dy: 5
        }), /*#__PURE__*/jsx$1("feGaussianBlur", {
          stdDeviation: 5
        }), /*#__PURE__*/jsx$1("feColorMatrix", {
          type: "matrix",
          values: "0 0 0 0 0.454902 0 0 0 0 0.870588 0 0 0 0 0.376471 0 0 0 0.5 0"
        }), /*#__PURE__*/jsx$1("feBlend", {
          mode: "normal",
          in2: "BackgroundImageFix",
          result: "effect1_dropShadow_7412_7380"
        }), /*#__PURE__*/jsx$1("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "effect1_dropShadow_7412_7380",
          result: "shape"
        })]
      }), /*#__PURE__*/jsx$1("clipPath", {
        id: "bgblur_1_7412_7380_clip_path",
        transform: "translate(-14.4395 -15.674)",
        children: /*#__PURE__*/jsx$1("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M38.2354 34.6728H31.3136C30.2641 34.6728 29.4395 33.7664 29.4395 32.6734C29.4395 31.5537 30.2641 30.674 31.3136 30.674H38.2354C39.2849 30.674 40.1095 31.5537 40.1095 32.6734C40.1095 33.7664 39.2849 34.6728 38.2354 34.6728"
        })
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint0_linear_7412_7380",
        x1: 19.0041,
        y1: 0.850586,
        x2: 43.4337,
        y2: 36.6165,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "#9BF763"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "#26AB5B"
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint1_linear_7412_7380",
        x1: 8.9617,
        y1: 16.6411,
        x2: 42.5665,
        y2: 56.4844,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "white",
          stopOpacity: 0.25
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "white",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint2_linear_7412_7380",
        x1: 39.353,
        y1: 31.3961,
        x2: 27.5443,
        y2: 32.4234,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "white"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "white",
          stopOpacity: 0.2
        })]
      }), /*#__PURE__*/jsxs("linearGradient", {
        id: "paint3_linear_7412_7380",
        x1: 30.5889,
        y1: 32.0154,
        x2: 39.6475,
        y2: 32.1488,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/jsx$1("stop", {
          stopColor: "white"
        }), /*#__PURE__*/jsx$1("stop", {
          offset: 1,
          stopColor: "white",
          stopOpacity: 0
        })]
      })]
    })]
  });
}

var HOSTING_ADDONS = [{
  icon: /*#__PURE__*/jsx$1(PersonalWebHostingSVG, {}),
  name: 'Personal Web Hosting',
  itemCode: HostingAddons.Personal,
  pricing: {
    reg: -1,
    rnw: -1
  },
  description: 'Easily host your website with reliable, secure, and customizable options for your domain.',
  info: ['Host 1 website', '1 subdomain', '10G lightning fast speeds', '20 GB disk space', '20 email addresses', 'Free hosting migration', 'Canadian servers available', '30 day money back guarantee', '99.9% uptime guaranteed'],
  isCheckedByDefault: false
}, {
  icon: /*#__PURE__*/jsx$1(StartupWebHostingSVG, {}),
  name: 'Startup Web Hosting',
  itemCode: HostingAddons.Startup,
  pricing: {
    reg: -1,
    rnw: -1
  },
  description: 'Affordable, scalable hosting designed to grow with your business and website needs.',
  info: ['Host up to 5 websites', 'Up to 5 subdomains', '10G lightning fast speeds', '100 GB disk space', '100 email addresses', 'Free hosting migration', 'Canadian servers available', '30 day money back guarantee'],
  isCheckedByDefault: false
}, {
  icon: /*#__PURE__*/jsx$1(BusinessWebHostingSVG, {}),
  name: 'Business Web Hosting',
  itemCode: HostingAddons.Business,
  pricing: {
    reg: -1,
    rnw: -1
  },
  description: 'Robust, high-performance hosting with advanced features to support your growing business website.',
  info: ['Unlimited websites', 'Unlimited subdomains', '10G lightning fast speeds', '200 GB disk space', 'Unlimited email addresses', 'Free hosting migration', 'Canadian servers available', '30 day money back guarantee'],
  isCheckedByDefault: false
}, {
  icon: /*#__PURE__*/jsx$1(MwpBaseSVG, {}),
  name: 'Managed WordPress',
  itemCode: HostingAddons.MwpBase,
  pricing: {
    reg: -1,
    rnw: -1
  },
  description: 'Hassle-free, optimized hosting with automatic updates and expert support for your WordPress site.',
  info: ['20 GB SSD storage', '100 email addresses', 'Automatic WordPress core, plugin, and theme updates', 'Automatic staging & deployment', 'Plesk WordPress Toolkit', 'Optimized servers for WordPress', 'Canadian server locations available', '30-day money back guarantee', 'Free WordPress migration'],
  isCheckedByDefault: false
}, {
  icon: /*#__PURE__*/jsx$1(MwpEcommSVG, {}),
  name: 'MWP E-commerce',
  itemCode: HostingAddons.MwpEcom,
  pricing: {
    reg: -1,
    rnw: -1
  },
  description: 'Managed WordPress hosting optimized for speed, security, and a seamless online store experience.',
  info: ['100 GB SSD storage', '100 email addresses', 'Automatic WordPress core, plugin, and theme updates', 'Automatic staging & deployment', 'Plesk WordPress Toolkit', 'Optimized servers for WordPress', 'Canadian server locations available', '30-day money back guarantee', 'Free WordPress migration', 'Unlimited product listings'],
  isCheckedByDefault: false
}];

var formattedPrice = function formattedPrice(price, currency) {
  if (price === 0) {
    return 'Free';
  }

  return "".concat(currency[0]).concat(currency[1], " $").concat(price.toFixed(2));
};

var CardContainer = styled.div.withConfig({
  displayName: "flippable-card__CardContainer",
  componentId: "sc-jvtkbo-0"
})(["height:400px;width:100%;perspective:1000px;"]);
var Card = styled.div.withConfig({
  displayName: "flippable-card__Card",
  componentId: "sc-jvtkbo-1"
})(["width:100%;height:100%;position:relative;transform-style:preserve-3d;transition:transform 0.6s;&.flipped{transform:rotateY(180deg);}"]);
var CardSide = styled.div.withConfig({
  displayName: "flippable-card__CardSide",
  componentId: "sc-jvtkbo-2"
})(["position:absolute;top:0;left:0;right:0;bottom:0;backface-visibility:hidden;display:flex;align-items:center;justify-content:center;box-sizing:border-box;border-radius:8px;"]);
var FrontSide = styled(CardSide).withConfig({
  displayName: "flippable-card__FrontSide",
  componentId: "sc-jvtkbo-3"
})([""]);
var BackSide = styled(CardSide).withConfig({
  displayName: "flippable-card__BackSide",
  componentId: "sc-jvtkbo-4"
})(["transform:rotateY(180deg);"]);

function FlippableCard(_ref) {
  var front = _ref.front,
      back = _ref.back;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      flipped = _useState2[0],
      setFlipped = _useState2[1];

  var handleFlip = function handleFlip(e) {
    e.stopPropagation();
    setFlipped(function (prev) {
      return !prev;
    });
  };

  return /*#__PURE__*/jsx$1(CardContainer, {
    children: /*#__PURE__*/jsxs(Card, {
      className: flipped ? 'flipped' : '',
      children: [/*#__PURE__*/jsx$1(FrontSide, {
        children: front(handleFlip)
      }), /*#__PURE__*/jsx$1(BackSide, {
        children: back(handleFlip)
      })]
    })
  });
}

var _templateObject$f, _templateObject2$a;

function ProductCard(_ref) {
  var toggle = _ref.toggle,
      checked = _ref.checked,
      product = _ref.product,
      category = _ref.category;
  var icon = product.icon,
      name = product.name,
      description = product.description,
      pricing = product.pricing,
      itemCode = product.itemCode,
      info = product.info;

  var _useDomainSearch = useDomainSearch(),
      currency = _useDomainSearch.currency;

  var isOpEPBundle = itemCode === DomainAddons.Bundle;

  function CtaSection(onClick) {
    var isBack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return /*#__PURE__*/jsxs(Box, {
      width: "100%",
      justifyContent: "space-between",
      mt: 2,
      children: [/*#__PURE__*/jsxs(_StyledBox$7, {
        onClick: toggle,
        alignItems: "center",
        gap: 2,
        children: [/*#__PURE__*/jsx$1(Box, {
          backgroundColor: "primary-700",
          borderRadius: "circle",
          p: 1,
          justifyContent: "center",
          alignItems: "center",
          style: {
            transition: '0.2s'
          },
          children: checked ? /*#__PURE__*/jsx$1(Check$1, {
            color: "white",
            size: 12
          }) : /*#__PURE__*/jsx$1(Plus, {
            color: "white",
            size: 12
          })
        }), /*#__PURE__*/jsx$1(Text, {
          color: "primary-700",
          fontWeight: "semi",
          children: checked ? 'In Cart' : 'Add to Cart'
        })]
      }), /*#__PURE__*/jsx$1(Button, {
        id: "learn-more-".concat(name),
        title: "learn-more-".concat(name),
        onClick: onClick,
        variant: "minimal",
        children: /*#__PURE__*/jsx$1(_StyledText$c, {
          color: "primary-700",
          children: isBack ? 'Show less' : 'Show more'
        })
      })]
    });
  }

  function FrontComponent(onClick) {
    var handleShowMoreClick = function handleShowMoreClick(e) {
      trackEvent({
        event: ANALYTICS_EVENTS.addonsShowMore
      });
      onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };

    return /*#__PURE__*/jsxs(Stack$1, {
      height: "100%",
      p: "24px",
      borderRadius: "large",
      border: "1px solid",
      borderColor: checked ? 'primary-300' : 'primary-100',
      backgroundColor: checked ? 'primary-100' : 'primary-50',
      width: "100%",
      justifyContent: "space-between",
      style: {
        transition: '0.2s'
      },
      children: [isOpEPBundle ? /*#__PURE__*/jsx$1(Text, {
        backgroundColor: "secondary-600",
        borderRadius: "base",
        variant: "paragraph-small",
        fontWeight: "semi",
        color: "primary-600",
        mb: 3,
        padding: "8px",
        width: "fit-content",
        children: "80% OFF YOUR FIRST TERM"
      }) : /*#__PURE__*/jsx$1(Box, {
        justifyContent: "center",
        alignItems: "center",
        width: "fit-content",
        mb: 2,
        ml: -1,
        children: icon
      }), /*#__PURE__*/jsx$1(Text, {
        fontWeight: "semi",
        color: "neutral-900",
        variant: "paragraph-large",
        children: name
      }), /*#__PURE__*/jsx$1(Stack$1, {
        children: pricing.rnw < 0 ? /*#__PURE__*/jsx$1(Skeleton, {
          width: "60px",
          height: "20px"
        }) : /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx$1(Text, {
            fontWeight: "semi",
            color: "neutral-600",
            children: formattedPrice(pricing.reg, currency)
          }), /*#__PURE__*/jsxs(Text, {
            variant: "paragraph-small",
            color: "neutral-500",
            children: ["Renewal ", formattedPrice(pricing.rnw, currency), category === AddOnCategories.Domain ? '/yr' : '/mo']
          })]
        })
      }), /*#__PURE__*/jsx$1(Text, {
        variant: "paragraph-small",
        color: "neutral-500",
        my: isOpEPBundle ? 2 : 4,
        children: description
      }), isOpEPBundle && /*#__PURE__*/jsx$1(_StyledBox2$2, {
        alignItems: "center",
        children: icon
      }), CtaSection(handleShowMoreClick)]
    });
  }

  function BackComponent(onClick) {
    return /*#__PURE__*/jsxs(Stack$1, {
      height: "100%",
      p: "24px",
      borderRadius: "large",
      border: "1px solid",
      borderColor: checked ? 'primary-300' : 'primary-100',
      backgroundColor: checked ? 'primary-100' : 'primary-50',
      width: "100%",
      justifyContent: "space-between",
      style: {
        transition: '0.2s'
      },
      children: [/*#__PURE__*/jsx$1(Text, {
        color: "primary-600",
        variant: "paragraph-large",
        fontWeight: "semi",
        mb: 3,
        children: "Extra information"
      }), info.map(function (bulletpoint, i) {
        return /*#__PURE__*/jsxs(Text, {
          color: "primary-600",
          variant: "paragraph-xsmall",
          children: ["\u2022 ", bulletpoint]
        }, i);
      }), CtaSection(onClick, true)]
    });
  }

  return /*#__PURE__*/jsx$1(FlippableCard, {
    front: FrontComponent,
    back: BackComponent
  });
}

var _StyledBox$7 = styled(Box)(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral$1(["\n            cursor: pointer;\n\n            transition: 0.2s;\n          "])));

var _StyledText$c = styled(Text)(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteral$1(["\n              text-decoration: underline;\n            "])));

var _StyledBox2$2 = styled(Box).withConfig({
  displayName: "product-card___StyledBox2",
  componentId: "sc-oo9c3-0"
})(["gap:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.space[2];
});

function ownKeys$k(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$k(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$k(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$k(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function DomainAddonsSection(_ref) {
  var addOnsCart = _ref.addOnsCart,
      domainAddOns = _ref.domainAddOns,
      setAddOnsCart = _ref.setAddOnsCart;
  var category = AddOnCategories.Domain;
  /** Handles toggling to cart. Logic is particular so that it can handle bundle logic.
   * For example if you try add OP and EP separately, it should toggle those off and toggle the bundle.
   */

  function toggleDomainAddon(itemCode) {
    setAddOnsCart(function (prevCart) {
      var clone = _objectSpread$k({}, prevCart);

      var itemCodes = clone[category];

      if (itemCodes.includes(itemCode)) {
        clone[category] = itemCodes.filter(function (code) {
          return code !== itemCode;
        });
        return clone;
      }

      var newAddOns = [];
      var hasPrivacy = itemCodes.includes(DomainAddons.Privacy);
      var hasExpiry = itemCodes.includes(DomainAddons.Expiry);
      var hasOwnership = itemCodes.includes(DomainAddons.Ownership);
      var hasBundle = itemCodes.includes(DomainAddons.Bundle);

      if (hasPrivacy) {
        newAddOns.push(DomainAddons.Privacy);
      }

      switch (itemCode) {
        case DomainAddons.Bundle:
          newAddOns.push(DomainAddons.Bundle);
          break;

        case DomainAddons.Expiry:
          newAddOns.push(hasOwnership ? DomainAddons.Bundle : DomainAddons.Expiry);
          break;

        case DomainAddons.Ownership:
          newAddOns.push(hasExpiry ? DomainAddons.Bundle : DomainAddons.Ownership);
          break;

        case DomainAddons.Privacy:
          newAddOns.push(DomainAddons.Privacy);

          if (hasBundle) {
            newAddOns.push(DomainAddons.Bundle);
          }

          break;
      }

      clone[category] = newAddOns;
      return clone;
    });
  }

  return /*#__PURE__*/jsxs(Stack$1, {
    gap: 4,
    children: [/*#__PURE__*/jsx$1(Text, {
      variant: "heading-h2",
      fontWeight: "extraBold",
      color: "primary-600",
      children: category
    }), /*#__PURE__*/jsx$1(Grid, {
      width: "100%",
      gridTemplateColumns: ['1fr', '1fr 1fr', '1fr 1fr 1fr'],
      gap: 3,
      children: domainAddOns.filter(function (addon) {
        return addon.itemCode !== DomainAddons.Bundle;
      }).map(function (addon) {
        return /*#__PURE__*/jsx$1(ProductCard, {
          category: category,
          product: addon,
          checked: addOnsCart[category].includes(addon.itemCode),
          toggle: function toggle() {
            return toggleDomainAddon(addon.itemCode);
          }
        }, addon.itemCode);
      })
    }), /*#__PURE__*/jsxs(_StyledGrid$1, {
      width: "100%",
      gridTemplateColumns: ['1fr', '1fr 1fr', '1fr 1fr'],
      children: [/*#__PURE__*/jsxs(Stack$1, {
        height: "100%",
        justifyContent: "center",
        color: "primary-600",
        gap: 4,
        children: [/*#__PURE__*/jsx$1(Text, {
          variant: "heading-h4",
          fontWeight: "semi",
          children: "Bundle and Save"
        }), /*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-large",
          children: "The Ownership and Expiry Protection bundle keeps your domain secure from unauthorized transfers and accidental expiration. With both protections, you maintain full control, ensuring your domain remains safe and active without interruptions."
        })]
      }), /*#__PURE__*/jsx$1(ProductCard, {
        category: category,
        product: domainAddOns.find(function (addon) {
          return addon.itemCode === DomainAddons.Bundle;
        }),
        checked: addOnsCart[category].includes(DomainAddons.Bundle),
        toggle: function toggle() {
          return toggleDomainAddon(DomainAddons.Bundle);
        }
      })]
    })]
  });
}

var _StyledGrid$1 = styled(Grid).withConfig({
  displayName: "domain-section___StyledGrid",
  componentId: "sc-16orswl-0"
})(["gap:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.space[4];
});

function ownKeys$j(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$j(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$j(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$j(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function HostingAddonsSection(_ref) {
  var addOnsCart = _ref.addOnsCart,
      hostingAddOns = _ref.hostingAddOns,
      setAddOnsCart = _ref.setAddOnsCart;
  var category = AddOnCategories.Hosting;

  function toggleHostingAddon(itemCode) {
    setAddOnsCart(function (prevCart) {
      var clone = _objectSpread$j({}, prevCart);

      var itemCodes = clone[category];

      if (itemCodes.includes(itemCode)) {
        clone[category] = itemCodes.filter(function (code) {
          return code !== itemCode;
        });
      } else {
        clone[category].push(itemCode);
      }

      return clone;
    });
  }

  if (hostingAddOns.length !== 0 && hostingAddOns.length !== 5) {
    console.error('Hosting addons currently expects 5 items, found', hostingAddOns.length);
    return null;
  }

  return /*#__PURE__*/jsxs(Stack$1, {
    gap: 4,
    children: [/*#__PURE__*/jsx$1(Text, {
      variant: "heading-h2",
      fontWeight: "extraBold",
      color: "primary-600",
      children: category
    }), /*#__PURE__*/jsx$1(Grid, {
      width: "100%",
      gridTemplateColumns: ['1fr', '1fr 1fr', 'repeat(3, 1fr)'],
      gap: 3,
      mb: 3,
      children: hostingAddOns.slice(0, 3).map(function (addon) {
        return /*#__PURE__*/jsx$1(ProductCard, {
          category: category,
          product: addon,
          checked: addOnsCart[category].includes(addon.itemCode),
          toggle: function toggle() {
            return toggleHostingAddon(addon.itemCode);
          }
        }, addon.itemCode);
      })
    }), /*#__PURE__*/jsx$1(Grid, {
      width: "100%",
      gridTemplateColumns: ['1fr', '1fr 1fr', '1fr 1fr'],
      gap: 3,
      children: hostingAddOns.slice(3, 5).map(function (addon) {
        return /*#__PURE__*/jsx$1(ProductCard, {
          category: category,
          product: addon,
          checked: addOnsCart[category].includes(addon.itemCode),
          toggle: function toggle() {
            return toggleHostingAddon(addon.itemCode);
          }
        }, addon.itemCode);
      })
    })]
  });
}

function _regenerator$e() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$e(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$e(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$e(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$e(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$e(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$e(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$e(u), _regeneratorDefine2$e(u, o, "Generator"), _regeneratorDefine2$e(u, n, function () {
    return this;
  }), _regeneratorDefine2$e(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$e = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$e(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$e = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$e(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$e(e, r, n, t);
}

function ownKeys$i(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$i(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$i(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$i(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function AddOnsPage(_ref) {
  var goBack = _ref.goBack;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = useState(_defineProperty$6(_defineProperty$6({}, AddOnCategories.Domain, DOMAIN_ADDONS), AddOnCategories.Hosting, HOSTING_ADDONS)),
      _useState4 = _slicedToArray$4(_useState3, 2),
      addOns = _useState4[0],
      setAddOns = _useState4[1];

  var _useState6 = useState({
    'Domain Protection': [],
    Hosting: []
  }),
      _useState7 = _slicedToArray$4(_useState6, 2),
      addOnsCart = _useState7[0],
      setAddOnsCart = _useState7[1];

  var priceService = new PriceService();

  var _useDomainSearch = useDomainSearch(),
      currency = _useDomainSearch.currency;

  var _useCart = useCart(),
      cartService = _useCart.cartService;

  var _useError = useError(),
      emitError = _useError.emitError;

  function handleGoToCart() {
    return _handleGoToCart.apply(this, arguments);
  }

  function _handleGoToCart() {
    _handleGoToCart = _asyncToGenerator( /*#__PURE__*/_regenerator$e().m(function _callee2() {
      var _t;

      return _regenerator$e().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              setIsLoading(true);
              _context2.p = 1;
              _context2.n = 2;
              return cartService.addAddons({
                DomainAddOns: addOnsCart['Domain Protection'],
                HostingAddOns: addOnsCart.Hosting
              });

            case 2:
              window.location.href = '/checkout';
              _context2.n = 4;
              break;

            case 3:
              _context2.p = 3;
              _t = _context2.v;
              emitError(_t);

            case 4:
              setIsLoading(false);

            case 5:
              return _context2.a(2);
          }
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return _handleGoToCart.apply(this, arguments);
  }

  useEffect(function () {
    setTimeout(function () {
      return window.scrollTo({
        top: 0,
        behavior: 'instant'
      });
    }, 100);
  }, []);
  useEffect(function () {
    var defaultDomainAddons = DOMAIN_ADDONS.filter(function (addon) {
      return addon.isCheckedByDefault;
    }).map(function (addon) {
      return addon.itemCode;
    });
    var defaultHostingAddons = HOSTING_ADDONS.filter(function (addon) {
      return addon.isCheckedByDefault;
    }).map(function (addon) {
      return addon.itemCode;
    });
    setAddOnsCart({
      'Domain Protection': defaultDomainAddons,
      Hosting: defaultHostingAddons
    });
  }, []);
  useEffect(function () {
    function getPricing() {
      return _getPricing.apply(this, arguments);
    }

    function _getPricing() {
      _getPricing = _asyncToGenerator( /*#__PURE__*/_regenerator$e().m(function _callee() {
        var _yield$tryCatch, _yield$tryCatch2, prices, error, addOnsWithPrices;

        return _regenerator$e().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.n = 1;
                return tryCatch(priceService.getStaticPrices(currency));

              case 1:
                _yield$tryCatch = _context.v;
                _yield$tryCatch2 = _slicedToArray$4(_yield$tryCatch, 2);
                prices = _yield$tryCatch2[0];
                error = _yield$tryCatch2[1];

                if (!error) {
                  _context.n = 2;
                  break;
                }

                return _context.a(2, emitError(error));

              case 2:
                addOnsWithPrices = {
                  'Domain Protection': [],
                  Hosting: []
                }; // Here we loop over the products, and add pricing if we can find it.

                Object.values(AddOnCategories).forEach(function (category) {
                  var productCategory = addOns[category]; // Here, we know what the type is, but TS struggles with iterating over unions.

                  productCategory.forEach(function (product) {
                    var pricing = prices.find(function (p) {
                      return p.itemCode === product.itemCode;
                    });

                    if (pricing) {
                      var _determinePricing = determinePricing(pricing),
                          reg = _determinePricing.reg,
                          rnw = _determinePricing.rnw;

                      addOnsWithPrices[category].push(_objectSpread$i(_objectSpread$i({}, product), {}, {
                        pricing: {
                          reg: reg,
                          rnw: rnw
                        }
                      }));
                    } else if (product.itemCode === DomainAddons.Bundle) {
                      var _getOPEPBundlePrices = getOPEPBundlePrices(currency),
                          _reg = _getOPEPBundlePrices.reg,
                          _rnw = _getOPEPBundlePrices.rnw;

                      addOnsWithPrices[category].push(_objectSpread$i(_objectSpread$i({}, product), {}, {
                        pricing: {
                          reg: _reg,
                          rnw: _rnw
                        }
                      }));
                    } else {
                      addOnsWithPrices[category].push(product);
                    }
                  });
                });
                setAddOns(addOnsWithPrices);

              case 3:
                return _context.a(2);
            }
          }
        }, _callee);
      }));
      return _getPricing.apply(this, arguments);
    }

    getPricing();
  }, [currency]);
  return /*#__PURE__*/jsxs(Stack$1, {
    gap: 4,
    children: [/*#__PURE__*/jsxs(Box, {
      justifyContent: "space-between",
      width: "100%",
      backgroundColor: "white",
      top: "80px",
      position: "sticky",
      py: "10px",
      zIndex: 1,
      overflow: "hidden",
      children: [/*#__PURE__*/jsx$1(DirectionButton, {
        onClick: goBack,
        direction: "<-",
        children: "Continue Shopping"
      }), /*#__PURE__*/jsx$1(DirectionButton, {
        onClick: handleGoToCart,
        direction: "->",
        loading: isLoading,
        children: "Checkout"
      })]
    }), /*#__PURE__*/jsx$1(DomainAddonsSection, {
      domainAddOns: addOns['Domain Protection'],
      addOnsCart: addOnsCart,
      setAddOnsCart: setAddOnsCart
    }), /*#__PURE__*/jsx$1(HostingAddonsSection, {
      hostingAddOns: addOns.Hosting,
      addOnsCart: addOnsCart,
      setAddOnsCart: setAddOnsCart
    })]
  });
}

var blink = keyframes$3(["0%{opacity:1;}50%{opacity:0.3;}100%{opacity:1;}"]);
var Overlay = styled(Stack$1).withConfig({
  displayName: "loader__Overlay",
  componentId: "sc-1p87kwm-0"
})(["position:fixed;top:0;left:0;width:100vw;max-width:100%;height:100vh;background-color:rgba(247,247,247,0.9);z-index:100;justify-content:center;align-items:center;gap:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.space[3];
});
var DotGrid = styled.div.withConfig({
  displayName: "loader__DotGrid",
  componentId: "sc-1p87kwm-1"
})(["display:grid;grid-template-columns:repeat(3,20px);grid-template-rows:repeat(3,20px);gap:8px;"]);
var Dot = styled.div.withConfig({
  displayName: "loader__Dot",
  componentId: "sc-1p87kwm-2"
})(["width:24px;height:24px;border-radius:50%;background-color:", ";animation:", " 1.2s infinite ease-in-out;animation-delay:", "s;"], function (_ref2) {
  var delay = _ref2.delay,
      color1 = _ref2.color1,
      color2 = _ref2.color2;
  return delay % 2 === 0 ? color1 : color2;
}, blink, function (_ref3) {
  var delay = _ref3.delay;
  return delay * 0.15;
});
/** Loader overlay. Fixed position and covers whole page. */

function Loader() {
  var theme = useTheme();
  var positions = [[0, 1, 2], [5, 8, 7], [6, 3], [0]].flat();
  return /*#__PURE__*/jsxs(Overlay, {
    children: [/*#__PURE__*/jsx$1(DotGrid, {
      children: _toConsumableArray$1(Array(9)).map(function (_, i) {
        return /*#__PURE__*/jsx$1(Dot, {
          delay: positions.indexOf(i),
          color1: theme.colors['primary-700'],
          color2: theme.colors['secondary-700']
        }, i);
      })
    }), /*#__PURE__*/jsx$1(Text, {
      color: "primary-600",
      fontWeight: "extraBold",
      variant: "heading-h2",
      children: "Generating your perfect domain names"
    })]
  });
}

var _templateObject$e;

function _regenerator$d() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$d(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$d(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$d(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$d(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$d(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$d(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$d(u), _regeneratorDefine2$d(u, o, "Generator"), _regeneratorDefine2$d(u, n, function () {
    return this;
  }), _regeneratorDefine2$d(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$d = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$d(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$d = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$d(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$d(e, r, n, t);
}

function AISearch(_ref) {
  var goBack = _ref.goBack;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      generating = _useState2[0],
      setGenerating = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray$4(_useState3, 2),
      prompt = _useState4[0],
      setPrompt = _useState4[1];

  var _useDomainSearch = useDomainSearch(),
      setBulkSearch = _useDomainSearch.setBulkSearch;

  var promptService = useMemo(function () {
    return new PromptService();
  }, []);

  var _useError = useError(),
      emitError = _useError.emitError;
  /** Calls prompt engine, and bulk searches proposed domain names. */


  function generateAndBulkSearch() {
    return _generateAndBulkSearch.apply(this, arguments);
  }

  function _generateAndBulkSearch() {
    _generateAndBulkSearch = _asyncToGenerator( /*#__PURE__*/_regenerator$d().m(function _callee() {
      var search, _yield$tryCatch, _yield$tryCatch2, suggestions, error;

      return _regenerator$d().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              trackEvent({
                event: ANALYTICS_EVENTS.generatePromptClick
              });
              setGenerating(true);
              search = {
                validDomains: [],
                invalidDomains: []
              };
              _context.n = 1;
              return tryCatch(promptService.getPromptSuggestions(prompt));

            case 1:
              _yield$tryCatch = _context.v;
              _yield$tryCatch2 = _slicedToArray$4(_yield$tryCatch, 2);
              suggestions = _yield$tryCatch2[0];
              error = _yield$tryCatch2[1];
              setGenerating(false);

              if (!error) {
                _context.n = 2;
                break;
              }

              return _context.a(2, emitError(error));

            case 2:
              suggestions.forEach(function (domain) {
                var clean = domain.trim();

                if (isValidDomain(clean)) {
                  search.validDomains.push(clean);
                } else {
                  search.invalidDomains.push(clean);
                }
              });
              setBulkSearch(search);
              goBack();

            case 3:
              return _context.a(2);
          }
        }
      }, _callee);
    }));
    return _generateAndBulkSearch.apply(this, arguments);
  }

  useEffect(function () {
    function handleKeyDown(event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        generateAndBulkSearch();
      }
    }

    document.addEventListener('keydown', handleKeyDown);
    return function () {
      return document.removeEventListener('keydown', handleKeyDown);
    };
  }, [prompt]);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [generating && /*#__PURE__*/jsx$1(Loader, {}), /*#__PURE__*/jsxs(Stack$1, {
      gap: 4,
      "data-testid": "ai-search-view",
      children: [/*#__PURE__*/jsx$1(Box, {
        mr: "auto",
        children: /*#__PURE__*/jsx$1(DirectionButton, {
          direction: "<-",
          onClick: goBack,
          "data-testid": "back-to-results",
          children: "Back to Results"
        })
      }), /*#__PURE__*/jsxs(Stack$1, {
        width: ['100%', '100%', '60%'],
        gap: 3,
        children: [/*#__PURE__*/jsx$1(Text, {
          color: "neutral-700",
          fontWeight: "bold",
          variant: "heading-h1",
          children: "AI Generator Tool for Domain Search"
        }), /*#__PURE__*/jsx$1(Text, {
          color: "primary-600",
          variant: "paragraph-large",
          children: "Share the core of your vision, the essence of your product, or the unique value of your service. Let's explore the possibilities together and witness how AI can identify the most authentic extensions for your concept."
        })]
      }), /*#__PURE__*/jsx$1(_StyledStack$9, {
        width: "100%",
        children: /*#__PURE__*/jsx$1(Textarea, {
          "data-testid": "ai-search-input",
          id: "input-box-bulk-search",
          flex: 1,
          value: prompt,
          onChange: function onChange(e) {
            return setPrompt(e.target.value);
          },
          placeholder: "Type the core of your vision, the essence of your product ...",
          my: 3,
          mx: 0,
          rows: 8
        })
      }), /*#__PURE__*/jsx$1(_StyledButton$8, {
        "data-testid": "generate-ai-search",
        onClick: generateAndBulkSearch,
        variant: "primary",
        children: "Generate Prompt"
      })]
    })]
  });
}

var _StyledStack$9 = styled(Stack$1)(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral$1(["\n            gap: ", ";\n\n            & > div {\n              margin: 0;\n            }\n\n            div {\n              height: 100%;\n            }\n\n            textarea {\n              flex: 1;\n              padding: 2rem;\n              height: 100%;\n              border-radius: 8px;\n              border: 1px dashed ", ";\n            }\n          "])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.space[3];
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors['neutral-400'];
});

var _StyledButton$8 = styled(Button).withConfig({
  displayName: "ai-search___StyledButton",
  componentId: "sc-1riprd5-0"
})(["color:", ";background-color:", ";margin-left:auto;"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors['primary-800'];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors['secondary-900'];
});

var _templateObject$d;

function BulkSearch(_ref) {
  var goBack = _ref.goBack;

  var _useState = useState(''),
      _useState2 = _slicedToArray$4(_useState, 2),
      userInput = _useState2[0],
      setUserInput = _useState2[1];

  var _useDomainSearch = useDomainSearch(),
      setBulkSearch = _useDomainSearch.setBulkSearch;

  var closeAndSearch = function closeAndSearch() {
    var search = {
      validDomains: [],
      invalidDomains: []
    }; // Just to make sure we catch all cases, probably a better way to do this.

    var list = userInput.split('\r\n').join(',').split('\n').join(',').split(',');
    list.forEach(function (domain) {
      var clean = domain.trim();

      if (isValidDomain(clean)) {
        search.validDomains.push(clean);
      } else {
        search.invalidDomains.push(clean);
      }
    });

    if (search.validDomains.length > 0) {
      setBulkSearch(search);
    }

    goBack();
  };

  var handleFile = function handleFile(file) {
    if (file.type === 'text/plain' || file.name.endsWith('.csv')) {
      var reader = new FileReader();

      reader.onload = function (e) {
        var _e$target;

        var text = (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.result;
        var newEntries = text.split(',').map(function (line) {
          return line.trim();
        }).join('\r\n');
        setUserInput(function (prev) {
          return prev ? "".concat(prev, "\r\n").concat(newEntries) : newEntries;
        });
      };

      reader.readAsText(file);
    }
  };

  return /*#__PURE__*/jsxs(Stack$1, {
    "data-testid": "bulk-search-view",
    gap: 4,
    children: [/*#__PURE__*/jsx$1(Box, {
      mr: "auto",
      children: /*#__PURE__*/jsx$1(DirectionButton, {
        direction: "<-",
        onClick: goBack,
        "data-testid": "back-to-results",
        children: "Continue Shopping"
      })
    }), /*#__PURE__*/jsx$1(Box, {
      width: ['100%', '100%', '60%'],
      children: /*#__PURE__*/jsx$1(Text, {
        color: "neutral-700",
        fontWeight: "bold",
        variant: "heading-h1",
        children: "Find and register multiple domains in seconds with our bulk domain registration."
      })
    }), /*#__PURE__*/jsx$1(Box, {
      width: "100%",
      borderBottom: "1px solid",
      borderColor: "neutral-300",
      my: 2
    }), /*#__PURE__*/jsxs(Grid, {
      gridTemplateColumns: ['1fr', '1fr', '1fr 1fr'],
      gap: 4,
      children: [/*#__PURE__*/jsxs(_StyledStack$8, {
        minHeight: "300px",
        gap: 3,
        children: [/*#__PURE__*/jsx$1(Text, {
          variant: "paragraph-large",
          color: "primary-600",
          mb: 2,
          children: "Enter one domain per line (up to 500 domains)"
        }), /*#__PURE__*/jsx$1(Textarea, {
          "data-testid": "bulk-search-input",
          id: "input-box-bulk-search",
          m: 0,
          flex: 1,
          value: userInput,
          onChange: function onChange(e) {
            return setUserInput(e.target.value);
          },
          onDragOver: function onDragOver(e) {
            return e.preventDefault();
          },
          placeholder: "example.com",
          rows: 8
        })]
      }), /*#__PURE__*/jsx$1(Uploader, {
        onFileUpload: handleFile
      })]
    }), /*#__PURE__*/jsx$1(_StyledButton$7, {
      "data-testid": "generate-bulk-search",
      onClick: closeAndSearch,
      variant: "primary",
      children: "Generate Bulk Search"
    })]
  });
}

var _StyledStack$8 = styled(Stack$1)(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral$1(["\n            & > div {\n              margin: 0;\n            }\n\n            div {\n              height: 100%;\n            }\n\n            textarea {\n              flex: 1;\n              padding: 2rem;\n              height: 100%;\n              border-radius: ", ";\n              border: 1px dashed ", ";\n            }\n          "])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.radii.base;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors['neutral-400'];
});

var _StyledButton$7 = styled(Button).withConfig({
  displayName: "bulk-search___StyledButton",
  componentId: "sc-8xl4pa-0"
})(["color:", ";background-color:", ";margin-left:auto;"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors['primary-800'];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors['secondary-900'];
});

function PremiumBadge() {
  return /*#__PURE__*/jsxs(Box, {
    "data-testid": "premium-badge",
    backgroundColor: "supporting-strongCyan",
    color: "primary-600",
    p: ['4px 12px', '8px 24px', '8px 24px'],
    borderRadius: "base",
    alignItems: "center",
    width: "fit-content",
    gap: 2,
    children: [/*#__PURE__*/jsx$1(Crown, {}), /*#__PURE__*/jsx$1(Text, {
      fontWeight: "semi",
      variant: "paragraph-medium",
      children: "Premium"
    })]
  });
}

function SearchPricing(_ref) {
  var pricing = _ref.pricing,
      currency = _ref.currency;
  if (!pricing) return null;
  var sale = pricing.sale,
      regular = pricing.regular,
      renew = pricing.renew;
  var reg = formattedPrice(sale || regular, currency);
  var rnw = formattedPrice(renew, currency);
  var showRnw = (sale || regular) < renew;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(Stack$1, {
      display: ['none', 'flex', 'flex'],
      alignItems: "flex-end",
      gap: 1,
      children: [/*#__PURE__*/jsx$1(Text, {
        color: "primary-600",
        fontWeight: "extraBold",
        variant: "paragraph-large",
        children: reg
      }), showRnw && /*#__PURE__*/jsxs(Text, {
        color: "neutral-500",
        variant: "paragraph-medium",
        fontWeight: "medium",
        children: ["Renewal ", rnw, "/yr"]
      })]
    }), /*#__PURE__*/jsxs(Box, {
      alignItems: "center",
      display: ['flex', 'none', 'none'],
      children: [/*#__PURE__*/jsx$1(Text, {
        mr: 2,
        color: "primary-600",
        fontWeight: "semi",
        variant: "paragraph-small",
        children: reg
      }), showRnw && /*#__PURE__*/jsx$1(_StyledText$b, {
        color: "neutral-500",
        variant: "paragraph-xsmall",
        fontWeight: "medium",
        children: rnw
      })]
    })]
  });
}

var _StyledText$b = styled(Text).withConfig({
  displayName: "pricing___StyledText",
  componentId: "sc-gqoymj-0"
})(["text-decoration:line-through;"]);

function _regenerator$c() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$c(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$c(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$c(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$c(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$c(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$c(u), _regeneratorDefine2$c(u, o, "Generator"), _regeneratorDefine2$c(u, n, function () {
    return this;
  }), _regeneratorDefine2$c(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$c = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$c(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$c = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$c(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$c(e, r, n, t);
}

function AlternateBlock() {
  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useError = useError(),
      emitError = _useError.emitError;

  var _useCart = useCart(),
      cart = _useCart.cart,
      cartService = _useCart.cartService;

  var _useDomainSearch = useDomainSearch(),
      currency = _useDomainSearch.currency,
      isUpdatingSearchQuery = _useDomainSearch.isUpdatingSearchQuery,
      query = _useDomainSearch.searchParams.query,
      fetched = _useDomainSearch.searchDomains.fetched;

  if (isUpdatingSearchQuery) {
    return null;
  }

  if (!getDomainParts(query).tld) {
    return null;
  } // This is the alternate block, so if the searched domain is available, we don't show this.


  var availability = determineAvailability(fetched, query);

  if (availability === 'AVAILABLE') {
    return null;
  }

  var domainInfo = findFirstAvailableDomain(fetched);

  if (!domainInfo) {
    return null;
  }

  var domain = domainInfo.domain,
      pricing = domainInfo.pricing,
      premium = domainInfo.premium,
      rules = domainInfo.rules,
      messaging = domainInfo.messaging;
  var isDomainInCart = cartContainsDomain(cart, domain);
  var fontSize = getDynamicFontSize(domain);

  var handleCartAction = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$c().m(function _callee() {
      var action, _yield$tryCatch, _yield$tryCatch2, error;

      return _regenerator$c().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              setLoading(true);
              action = isDomainInCart ? cartService.removeDomain(domainInfo.domain) : cartService.addDomain(domainInfo);
              _context.n = 1;
              return tryCatch(action);

            case 1:
              _yield$tryCatch = _context.v;
              _yield$tryCatch2 = _slicedToArray$4(_yield$tryCatch, 2);
              error = _yield$tryCatch2[1];

              if (error) {
                emitError(error);
              }

              setLoading(false);

            case 2:
              return _context.a(2);
          }
        }
      }, _callee);
    }));

    return function handleCartAction() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/jsxs(Stack$1, {
    "data-testid": "alternate-domain-block",
    borderRadius: "large",
    backgroundColor: "primary-50",
    p: "24px 32px",
    justifyContent: "space-between",
    width: "100%",
    overflow: "hidden",
    maxWidth: "100%",
    gap: 3,
    children: [premium ? /*#__PURE__*/jsx$1(PremiumBadge, {}) : /*#__PURE__*/jsx$1(Text, {
      color: "primary-600",
      backgroundColor: "secondary-300",
      fontWeight: "semi",
      borderRadius: "base",
      height: "fit-content",
      padding: "8px",
      width: "fit-content",
      variant: "paragraph-small",
      children: "GREAT ALTERNATIVE"
    }), /*#__PURE__*/jsxs(Box, {
      width: "100%",
      justifyContent: "space-between",
      flex: 1,
      flexDirection: ['column', 'row', 'row'],
      children: [/*#__PURE__*/jsx$1(_StyledText$a, {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- allow it for this dynamic font size
        // @ts-ignore
        fontSize: fontSize,
        variant: "heading-h4",
        fontWeight: "medium",
        color: "primary-600",
        maxWidth: "310px",
        children: domain
      }), /*#__PURE__*/jsxs(Stack$1, {
        alignItems: ['start', 'flex-end', 'flex-end'],
        children: [/*#__PURE__*/jsx$1(SearchPricing, {
          pricing: pricing,
          currency: currency
        }), /*#__PURE__*/jsx$1(Button, {
          mt: 2,
          variant: "secondary",
          disabled: loading,
          onClick: handleCartAction,
          children: isDomainInCart ? 'In Cart' : 'Add to Cart'
        })]
      })]
    }), /*#__PURE__*/jsx$1(Box, {
      pt: 4,
      borderTop: "1px solid",
      borderColor: "primary-200",
      children: rules.length > 0 ? /*#__PURE__*/jsxs(Text, {
        variant: "paragraph-small",
        children: ["Why it's great:", ' ', rules.map(function (rule) {
          return /*#__PURE__*/jsxs("span", {
            children: [rule, " "]
          }, rule);
        })]
      }) : /*#__PURE__*/jsxs(Text, {
        variant: "paragraph-small",
        children: [/*#__PURE__*/jsxs("span", {
          children: [messaging.Message1, " "]
        }), /*#__PURE__*/jsx$1("span", {
          children: messaging.Message2
        })]
      })
    })]
  });
}

var _StyledText$a = styled(Text).withConfig({
  displayName: "alternate-block___StyledText",
  componentId: "sc-yqwvu9-0"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);

function _regenerator$b() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$b(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$b(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$b(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$b(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$b(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$b(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$b(u), _regeneratorDefine2$b(u, o, "Generator"), _regeneratorDefine2$b(u, n, function () {
    return this;
  }), _regeneratorDefine2$b(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$b = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$b(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$b = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$b(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$b(e, r, n, t);
}

function AvailabilityBlock() {
  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isAdding = _useState2[0],
      setIsAdding = _useState2[1];

  var _useDomainSearch = useDomainSearch(),
      currency = _useDomainSearch.currency,
      isUpdatingSearchQuery = _useDomainSearch.isUpdatingSearchQuery,
      query = _useDomainSearch.searchParams.query,
      fetched = _useDomainSearch.searchDomains.fetched;

  var _useCart = useCart(),
      cart = _useCart.cart,
      cartService = _useCart.cartService;

  var _useError = useError(),
      emitError = _useError.emitError;

  if (!query || isUpdatingSearchQuery) {
    return null;
  }

  var domainInfo;
  var availability;
  var isAvailable; // For specific TLD searches, try find that domain.
  // For generic searches, use first available domain.

  if (getDomainParts(query).tld) {
    domainInfo = fetched[query];
    availability = determineAvailability(fetched, query);
    isAvailable = availability === 'AVAILABLE';
  } else {
    domainInfo = findFirstAvailableDomain(fetched);
    availability = 'AVAILABLE';
    isAvailable = true;
  }

  if (!domainInfo) {
    return null;
  }

  var _domainInfo = domainInfo,
      domain = _domainInfo.domain,
      premium = _domainInfo.premium,
      pricing = _domainInfo.pricing,
      rules = _domainInfo.rules,
      messaging = _domainInfo.messaging;
  var isDomainInCart = cartContainsDomain(cart, domain);
  var fontSize = getDynamicFontSize(domain);

  var handleCartAction = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$b().m(function _callee() {
      var action, _yield$tryCatch, _yield$tryCatch2, error;

      return _regenerator$b().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              setIsAdding(true);
              action = isDomainInCart ? cartService.removeDomain(domainInfo.domain) : cartService.addDomain(domainInfo);
              _context.n = 1;
              return tryCatch(action);

            case 1:
              _yield$tryCatch = _context.v;
              _yield$tryCatch2 = _slicedToArray$4(_yield$tryCatch, 2);
              error = _yield$tryCatch2[1];

              if (error) {
                emitError(error);
              }

              setIsAdding(false);

            case 2:
              return _context.a(2);
          }
        }
      }, _callee);
    }));

    return function handleCartAction() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/jsxs(Stack$1, {
    "data-testid": "availability-block",
    borderRadius: "large",
    backgroundColor: "primary-50",
    p: "24px 32px",
    width: "100%",
    maxWidth: "100%",
    justifyContent: "space-between",
    overflow: "hidden",
    gap: 3,
    children: [isAvailable && premium ? /*#__PURE__*/jsx$1(PremiumBadge, {}) : /*#__PURE__*/jsx$1(Text, {
      color: "primary-600",
      backgroundColor: isAvailable ? 'success-300' : 'neutral-200',
      fontWeight: "semi",
      variant: "paragraph-small",
      borderRadius: "base",
      height: "fit-content",
      padding: "8px",
      width: "fit-content",
      children: isAvailable ? 'EXACT MATCH IS AVAILABLE' : 'ALREADY REGISTERED'
    }), /*#__PURE__*/jsxs(Box, {
      width: "100%",
      justifyContent: "space-between",
      flex: 1,
      flexDirection: ['column', 'row', 'row'],
      children: [/*#__PURE__*/jsxs(Stack$1, {
        color: "primary-600",
        children: [/*#__PURE__*/jsx$1(_StyledText$9, {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- We make an exception for this dynamic font size.
          // @ts-ignore
          fontSize: fontSize,
          variant: "heading-h4",
          fontWeight: "medium",
          maxWidth: "310px",
          children: domain
        }), !isAvailable && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx$1(Text, {
            fontWeight: "medium",
            variant: "paragraph-large",
            my: 3,
            children: "This domain is already taken"
          }), /*#__PURE__*/jsx$1(Text, {
            mb: 2,
            children: "Our brokerage team can help you get it."
          }), /*#__PURE__*/jsx$1(Text, {
            children: "\u2022 You remain anonymous"
          }), /*#__PURE__*/jsx$1(Text, {
            children: "\u2022 Personal Broker"
          }), /*#__PURE__*/jsx$1(Text, {
            children: "\u2022 Free and secure domain transfer"
          })]
        })]
      }), /*#__PURE__*/jsx$1(Stack$1, {
        alignItems: ['start', 'flex-end', 'flex-end'],
        children: isAvailable ? /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/jsx$1(SearchPricing, {
            pricing: pricing,
            currency: currency
          }), /*#__PURE__*/jsx$1(Button, {
            width: "140px",
            variant: "secondary",
            disabled: isAdding,
            loading: isAdding,
            onClick: handleCartAction,
            mt: 3,
            children: isDomainInCart ? 'In Cart' : 'Add to Cart'
          })]
        }) : /*#__PURE__*/jsx$1(Button, {
          variant: "secondary",
          width: "140px",
          onClick: function onClick() {
            trackEvent({
              event: ANALYTICS_EVENTS.hireBrokerClick
            });
            cartService.goToSedo(domain);
          },
          style: {
            marginTop: 'auto'
          },
          children: "Hire a Broker"
        })
      })]
    }), isAvailable && /*#__PURE__*/jsx$1(Box, {
      pt: 4,
      borderTop: "1px solid",
      borderColor: "primary-200",
      children: rules.length > 0 ? /*#__PURE__*/jsxs(Text, {
        variant: "paragraph-small",
        children: ["Why it's great:", ' ', rules.map(function (rule) {
          return /*#__PURE__*/jsxs("span", {
            children: [rule, " "]
          }, rule);
        })]
      }) : /*#__PURE__*/jsxs(Text, {
        variant: "paragraph-small",
        children: [/*#__PURE__*/jsxs("span", {
          children: [messaging.Message1, " "]
        }), /*#__PURE__*/jsx$1("span", {
          children: messaging.Message2
        })]
      })
    })]
  });
}

var _StyledText$9 = styled(Text).withConfig({
  displayName: "availability-block___StyledText",
  componentId: "sc-1ycum9y-0"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);

function _regenerator$a() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$a(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$a(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$a(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$a(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$a(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$a(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$a(u), _regeneratorDefine2$a(u, o, "Generator"), _regeneratorDefine2$a(u, n, function () {
    return this;
  }), _regeneratorDefine2$a(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$a = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$a(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$a = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$a(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$a(e, r, n, t);
}

function BundleBlock() {
  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isAdding = _useState2[0],
      setIsAdding = _useState2[1];

  var _useDomainSearch = useDomainSearch(),
      searchParams = _useDomainSearch.searchParams,
      bundle = _useDomainSearch.bundle,
      currency = _useDomainSearch.currency,
      isUpdatingSearchQuery = _useDomainSearch.isUpdatingSearchQuery;

  var _useCart = useCart(),
      cart = _useCart.cart,
      cartService = _useCart.cartService;

  var _useError = useError(),
      emitError = _useError.emitError;

  if (isUpdatingSearchQuery) {
    return null;
  }

  if (!bundle || !bundle.available) {
    return null;
  }

  var bundleId = bundle.bundleId,
      discountPercentage = bundle.discountPercentage,
      domains = bundle.domains,
      totals = bundle.totals;
  var areDomainsAllInCart = bundle.domains.every(function (domain) {
    return cartContainsDomain(cart, domain);
  });

  var handleCartAction = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$a().m(function _callee() {
      var bulkAddToCartParams, _t;

      return _regenerator$a().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              setIsAdding(true);
              _context.p = 1;

              if (!areDomainsAllInCart) {
                _context.n = 3;
                break;
              }

              _context.n = 2;
              return cartService.removeBulkDomains(bundle.domains);

            case 2:
              _context.n = 5;
              break;

            case 3:
              bulkAddToCartParams = domains.map(function (bundleDomain) {
                var _getDomainParts = getDomainParts(bundleDomain),
                    domainName = _getDomainParts.domainName,
                    tld = _getDomainParts.tld;

                if (!tld) {
                  throw new Error('No TLD when TLD was expected.');
                }

                return {
                  domain: domainName,
                  tld: tld,
                  registryPremium: false
                };
              });
              _context.n = 4;
              return cartService.addBulkDomains(bulkAddToCartParams);

            case 4:
              _context.n = 5;
              return cartService.addBundle({
                bundleId: bundleId,
                domainName: getDomainParts(searchParams.query).domainName
              });

            case 5:
              _context.n = 7;
              break;

            case 6:
              _context.p = 6;
              _t = _context.v;
              emitError(_t);

            case 7:
              setIsAdding(false);

            case 8:
              return _context.a(2);
          }
        }
      }, _callee, null, [[1, 6]]);
    }));

    return function handleCartAction() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/jsxs(Stack$1, {
    "data-testid": "bundle-block",
    id: "bundle-block",
    overflow: "hidden",
    backgroundColor: "primary-50",
    p: "24px 32px",
    borderRadius: "large",
    justifyContent: "space-between",
    width: "100%",
    maxWidth: "100%",
    gap: 3,
    children: [/*#__PURE__*/jsxs(Text, {
      color: "primary-600",
      fontWeight: "semi",
      variant: "paragraph-xsmall",
      borderRadius: "base",
      p: "8px",
      width: "fit-content",
      backgroundColor: "success-200",
      mb: 2,
      children: ["BUNDLE AND SAVE ", discountPercentage, "%"]
    }), /*#__PURE__*/jsxs(Box, {
      width: "100%",
      justifyContent: "space-between",
      flex: 1,
      flexDirection: ['column', 'row', 'row'],
      children: [/*#__PURE__*/jsx$1(Stack$1, {
        maxWidth: "310px",
        children: domains.sort(function (a, b) {
          if (a === searchParams.query) {
            return -1;
          }

          if (b === searchParams.query) {
            return 1;
          }

          return 0;
        }).map(function (domain) {
          return /*#__PURE__*/jsx$1(Box, {
            fontWeight: "medium",
            mb: 1,
            color: "primary-600",
            children: /*#__PURE__*/jsx$1(_StyledText$8, {
              variant: "paragraph-large",
              children: domain
            })
          }, domain);
        })
      }), /*#__PURE__*/jsxs(Stack$1, {
        alignItems: ['start', 'flex-end', 'flex-end'],
        children: [/*#__PURE__*/jsx$1(SearchPricing, {
          pricing: {
            regular: totals.reg,
            renew: totals.rnw
          },
          currency: currency
        }), /*#__PURE__*/jsx$1(Button, {
          variant: "secondary",
          onClick: handleCartAction,
          disabled: isAdding,
          loading: isAdding,
          width: "140px",
          mt: 3,
          children: areDomainsAllInCart ? 'In Cart' : 'Add to Cart'
        })]
      })]
    }), /*#__PURE__*/jsx$1(Box, {
      pt: 4,
      borderTop: "1px solid",
      borderColor: "primary-200",
      children: /*#__PURE__*/jsxs(Text, {
        color: "neutral-900",
        variant: "paragraph-small",
        children: ["Why it's great: Protect your business from copycats by registering these popular endings:", ' ', domains.map(function (domain, index) {
          var _getDomainParts$tld;

          return /*#__PURE__*/jsxs("span", {
            children: [(_getDomainParts$tld = getDomainParts(domain).tld) === null || _getDomainParts$tld === void 0 ? void 0 : _getDomainParts$tld.toUpperCase(), index === domains.length - 1 ? '.' : ',', ' ']
          }, domain);
        })]
      })
    })]
  });
}

var _StyledText$8 = styled(Text).withConfig({
  displayName: "bundle-block___StyledText",
  componentId: "sc-1tr11gz-0"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);

function _regenerator$9() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$9(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$9(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$9(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$9(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$9(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$9(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$9(u), _regeneratorDefine2$9(u, o, "Generator"), _regeneratorDefine2$9(u, n, function () {
    return this;
  }), _regeneratorDefine2$9(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$9 = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$9(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$9 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$9(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$9(e, r, n, t);
}

function ResultCTA(_ref) {
  var domainInfo = _ref.domainInfo;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      isAdding = _useState2[0],
      setisAdding = _useState2[1];

  var _useError = useError(),
      emitError = _useError.emitError;

  var _useCart = useCart(),
      cart = _useCart.cart,
      cartService = _useCart.cartService;

  var domain = domainInfo.domain,
      available = domainInfo.available;
  var isInCart = cartContainsDomain(cart, domain);

  var handleCTAClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$9().m(function _callee(e) {
      var action, _yield$tryCatch, _yield$tryCatch2, error;

      return _regenerator$9().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              e.stopPropagation();
              setisAdding(true);

              if (!available) {
                _context.n = 2;
                break;
              }

              action = isInCart ? cartService.removeDomain(domain) : cartService.addDomain(domainInfo);
              _context.n = 1;
              return tryCatch(action);

            case 1:
              _yield$tryCatch = _context.v;
              _yield$tryCatch2 = _slicedToArray$4(_yield$tryCatch, 2);
              error = _yield$tryCatch2[1];

              if (error) {
                emitError(error);
              }

              _context.n = 3;
              break;

            case 2:
              cartService.goToSedo(domain);

            case 3:
              setisAdding(false);

            case 4:
              return _context.a(2);
          }
        }
      }, _callee);
    }));

    return function handleCTAClick(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return domainInfo.available ? /*#__PURE__*/jsxs(_StyledButton$6, {
    "aria-label": isInCart ? 'Remove from cart' : 'Add to cart',
    variant: "outlined",
    width: ['fit-content', '140px', '140px'],
    loading: isAdding,
    disabled: isAdding,
    onClick: handleCTAClick,
    $_css: isInCart ? css$3(["background-color:", ";&:hover{background-color:", ";}"], function (_ref3) {
      var theme = _ref3.theme;
      return theme.colors['primary-100'];
    }, function (_ref4) {
      var theme = _ref4.theme;
      return theme.colors['primary-200'];
    }) : undefined,
    children: [/*#__PURE__*/jsx$1(Box, {
      display: ['none', 'flex', 'flex'],
      children: isInCart ? 'In Cart' : 'Add to Cart'
    }), /*#__PURE__*/jsx$1(Box, {
      display: ['flex', 'none', 'none'],
      color: "neutral-700",
      children: /*#__PURE__*/jsx$1(ShoppingCart, {})
    })]
  }) : /*#__PURE__*/jsxs(Button, {
    "aria-label": "Make an offer",
    variant: "minimal",
    width: ['auto', '140px', '140px'],
    onClick: handleCTAClick,
    children: [/*#__PURE__*/jsx$1(Box, {
      color: "neutral-700",
      display: ['none', 'flex', 'flex'],
      children: /*#__PURE__*/jsx$1(RiAuctionLine, {})
    }), /*#__PURE__*/jsx$1(Text, {
      children: "Make Offer"
    })]
  });
}

var _StyledButton$6 = styled(Button).withConfig({
  displayName: "cta___StyledButton",
  componentId: "sc-uto0dd-0"
})(["", ""], function (p) {
  return p.$_css;
});

function ConditionalSection(_ref) {
  var _domainInfo$messaging, _domainInfo$messaging2;

  var domainInfo = _ref.domainInfo;

  if (!domainInfo.available) {
    return /*#__PURE__*/jsxs(Stack$1, {
      "data-testid": "broker-messaging",
      px: 3,
      borderRight: "1px solid",
      borderColor: "neutral-300",
      children: [/*#__PURE__*/jsx$1(Text, {
        fontWeight: "semi",
        mb: 2,
        children: "Why Hire a Broker"
      }), /*#__PURE__*/jsx$1(Text, {
        children: "This domain has already been registered, but our brokerage team can help you acquire it securely, and anonymously"
      })]
    });
  }

  if (domainInfo.premium) {
    return /*#__PURE__*/jsxs(Stack$1, {
      "data-testid": "premium-messaging",
      px: 3,
      borderRight: "1px solid",
      borderColor: "neutral-300",
      children: [/*#__PURE__*/jsx$1(Text, {
        fontWeight: "semi",
        mb: 2,
        children: "What's a Premium Domain"
      }), /*#__PURE__*/jsx$1(Text, {
        children: "Premium Domain Names are more valuable than other domains because they are based on common words or phrases people often use in their online searches."
      })]
    });
  }

  return /*#__PURE__*/jsxs(Stack$1, {
    "data-testid": "standard-domain-messaging",
    px: 3,
    borderRight: "1px solid",
    borderColor: "neutral-300",
    children: [/*#__PURE__*/jsxs(Text, {
      fontWeight: "semi",
      mb: 2,
      children: [".", domainInfo.tld.toUpperCase(), " Domains"]
    }), /*#__PURE__*/jsxs(Stack$1, {
      children: [/*#__PURE__*/jsxs(Text, {
        children: ["\u2022 ", (_domainInfo$messaging = domainInfo.messaging) === null || _domainInfo$messaging === void 0 ? void 0 : _domainInfo$messaging.Message1]
      }), /*#__PURE__*/jsxs(Text, {
        children: ["\u2022 ", (_domainInfo$messaging2 = domainInfo.messaging) === null || _domainInfo$messaging2 === void 0 ? void 0 : _domainInfo$messaging2.Message2]
      })]
    })]
  });
}

var _templateObject$c, _templateObject2$9;

function Messaging(_ref) {
  var show = _ref.show,
      domainInfo = _ref.domainInfo; // Sometimes, a domain name might not have passed any rules, in which case, we don't have anything to show for the "Why it's great" section.

  var hasPassingRules = domainInfo.rules.length > 0;
  var templateColumns = hasPassingRules ? ['1fr 1fr', '1fr 1fr 1fr', '1fr 1fr 1fr'] : '1fr 1fr';
  return /*#__PURE__*/jsxs(_StyledGrid, {
    backgroundColor: "primary-50",
    color: "primary-600",
    display: "grid",
    borderBottom: show ? '3px solid' : '0px solid',
    borderColor: show ? 'white' : 'none',
    gridTemplateColumns: templateColumns,
    $_css: show ? '1000px' : '0px',
    $_css2: show ? '20px' : '0px',
    $_css3: show ? '20px' : '0px',
    children: [/*#__PURE__*/jsx$1(ConditionalSection, {
      domainInfo: domainInfo
    }), hasPassingRules && /*#__PURE__*/jsxs(Stack$1, {
      px: 3,
      borderRight: "1px solid",
      borderColor: "neutral-300",
      children: [/*#__PURE__*/jsx$1(Text, {
        mb: 2,
        fontWeight: "semi",
        children: "Why it's great"
      }), /*#__PURE__*/jsx$1(Stack$1, {
        children: domainInfo.rules.map(function (rule) {
          return /*#__PURE__*/jsxs(Text, {
            children: ["\u2022 ", rule]
          }, rule);
        })
      })]
    }), /*#__PURE__*/jsxs(_StyledStack$7, {
      px: 3 // Ugly, but this adjusts the grid on mobile.
      ,
      $_css4: hasPassingRules ? css$3(["", ""], function (_ref2) {
        var theme = _ref2.theme;
        return theme.media.smallAndDown(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral$1(["\n                  grid-column: span 2;\n                "])));
      }) : undefined,
      children: [/*#__PURE__*/jsxs(Text, {
        mb: 2,
        fontWeight: "semi",
        children: ["Why ", resellerName]
      }), /*#__PURE__*/jsxs(Stack$1, {
        children: [/*#__PURE__*/jsx$1(Text, {
          children: "\u2022 Proudly operating in Canada with a strong local presence."
        }), /*#__PURE__*/jsx$1(Text, {
          children: "\u2022 Dedicated support team provided real, human assistance every step of the way."
        })]
      })]
    })]
  });
}

var _StyledGrid = styled(Grid)(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral$1(["\n        transition: 0.2s;\n        max-height: ", ";\n        overflow: hidden;\n\n        & > div {\n          transition: 0.2s;\n          margin-top: ", ";\n          margin-bottom: ", ";\n        }\n      "])), function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
}, function (p) {
  return p.$_css3;
});

var _StyledStack$7 = styled(Stack$1).withConfig({
  displayName: "messaging___StyledStack",
  componentId: "sc-ywb355-0"
})(["", ""], function (p) {
  return p.$_css4;
});

var _templateObject$b;

function ResultComponent(_ref) {
  var domainInfo = _ref.domainInfo;

  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      showTldInfo = _useState2[0],
      setShowTldInfo = _useState2[1];

  var _useDomainSearch = useDomainSearch(),
      currency = _useDomainSearch.currency;

  var domain = domainInfo.domain;
  return /*#__PURE__*/jsxs(Stack$1, {
    "data-testid": "domain-list-item",
    children: [/*#__PURE__*/jsxs(Box, {
      width: "100%",
      minHeight: "100px",
      justifyContent: ['space-around', 'space-between', 'space-between'],
      alignItems: "center",
      overflow: "hidden",
      borderBottom: "1px solid",
      borderColor: "neutral-300",
      backgroundColor: showTldInfo ? 'primary-50' : 'none',
      px: [2, 3, 3],
      style: {
        cursor: 'pointer'
      },
      onClick: function onClick() {
        trackEvent({
          event: ANALYTICS_EVENTS.educationDropdownPress
        });
        setShowTldInfo(!showTldInfo);
      },
      children: [/*#__PURE__*/jsxs(Box, {
        flex: 1,
        alignItems: ['start', 'center', 'center'],
        flexDirection: ['column', 'row', 'row'],
        gap: 3,
        children: [/*#__PURE__*/jsxs(_StyledText$7, {
          fontWeight: "medium",
          color: "neutral-700",
          variant: "paragraph-large",
          maxWidth: ['200px', 'none', 'none'],
          children: [getDomainParts(domain).domainName, /*#__PURE__*/jsx$1("wbr", {}), /*#__PURE__*/jsxs("span", {
            children: [".", getDomainParts(domain).tld]
          })]
        }), domainInfo.premium && /*#__PURE__*/jsx$1(Box, {
          display: ['none', 'flex', 'flex'],
          children: /*#__PURE__*/jsx$1(PremiumBadge, {})
        }), domainInfo.available && /*#__PURE__*/jsx$1(Box, {
          ml: ['0', '0', 'auto'],
          children: /*#__PURE__*/jsx$1(SearchPricing, {
            pricing: domainInfo.pricing,
            currency: currency
          })
        })]
      }), /*#__PURE__*/jsxs(_StyledBox$6, {
        alignItems: "center",
        height: "100%",
        $_css: showTldInfo ? '180deg' : '0deg',
        children: [/*#__PURE__*/jsx$1(Box, {
          mx: [0, '24px', '24px'],
          children: /*#__PURE__*/jsx$1(ResultCTA, {
            domainInfo: domainInfo
          })
        }), /*#__PURE__*/jsx$1(Box, {
          display: ['none', 'flex', 'flex'],
          children: /*#__PURE__*/jsx$1(ChevronDown, {
            id: "extra-info-toggle",
            strokeWidth: 3,
            color: "#374151"
          })
        })]
      })]
    }, domain), /*#__PURE__*/jsx$1(Messaging, {
      show: showTldInfo,
      domainInfo: domainInfo
    })]
  });
}

var areEqual = function areEqual(prevProps, nextProps) {
  return prevProps.domainInfo === nextProps.domainInfo;
};

var Result = /*#__PURE__*/React__default.memo(ResultComponent, areEqual);

var _StyledText$7 = styled(Text)(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral$1(["\n              word-break: keep-all;\n              display: flex;\n              flex-wrap: wrap;\n            "])));

var _StyledBox$6 = styled(Box).withConfig({
  displayName: "result___StyledBox",
  componentId: "sc-110mwnp-0"
})(["transition:0.2s;#extra-info-toggle{transition:0.2s;transform:rotate(", ");}"], function (p) {
  return p.$_css;
});
/* eslint-disable react/no-array-index-key */


function Results() {
  var _useDomainSearch = useDomainSearch(),
      fetching = _useDomainSearch.fetching,
      searchDomains = _useDomainSearch.searchDomains;

  return /*#__PURE__*/jsx$1(Stack$1, {
    width: "100%",
    borderTop: "1px solid",
    borderColor: "neutral-300",
    children: function () {
      switch (fetching) {
        case 'NEW':
          {
            return Array.from({
              length: BATCH_COUNT
            }).map(function (_, i) {
              return /*#__PURE__*/jsx$1(Skeleton, {
                height: "100px",
                borderY: "1px solid",
                borderColor: "neutral-100"
              }, i);
            });
          }

        case 'MORE':
          {
            return /*#__PURE__*/jsxs(Fragment, {
              children: [Object.values(searchDomains.fetched).map(function (domainInfo) {
                return /*#__PURE__*/jsx$1(Result, {
                  domainInfo: domainInfo
                }, domainInfo.domain);
              }), Array.from({
                length: BATCH_COUNT
              }).map(function (_, i) {
                return /*#__PURE__*/jsx$1(Skeleton, {
                  height: "100px",
                  borderY: "1px solid",
                  borderColor: "neutral-100"
                }, i);
              })]
            });
          }

        default:
          {
            return Object.values(searchDomains.fetched).map(function (domainInfo) {
              return /*#__PURE__*/jsx$1(Result, {
                domainInfo: domainInfo
              }, domainInfo.domain);
            });
          }
      }
    }()
  });
}

var _templateObject$a, _templateObject2$8, _templateObject3$6, _templateObject4$3, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9;

function ownKeys$h(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$h(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$h(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$h(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function DomainSearch(_ref) {
  var goNext = _ref.goNext,
      goToAIView = _ref.goToAIView,
      goToBulkView = _ref.goToBulkView;
  var inputRef = useRef(null);

  var _useCart = useCart(),
      cart = _useCart.cart;

  var _useDomainSearch = useDomainSearch(),
      fetching = _useDomainSearch.fetching,
      bulkSearch = _useDomainSearch.bulkSearch,
      categories = _useDomainSearch.categories,
      searchParams = _useDomainSearch.searchParams,
      searchDomains = _useDomainSearch.searchDomains,
      updateCategory = _useDomainSearch.updateCategory,
      loadMoreResults = _useDomainSearch.loadMoreResults,
      setSearchParams = _useDomainSearch.setSearchParams,
      isUpdatingSearchQuery = _useDomainSearch.isUpdatingSearchQuery;

  var fetchedCount = useMemo(function () {
    return Object.keys(searchDomains.fetched).length;
  }, [searchDomains.fetched]);
  var isFirstSearch = fetchedCount === 0 && searchDomains.possible.length === 0 && !bulkSearch && !searchParams.query && !isUpdatingSearchQuery && fetching === 'NONE'; // Sets initial states from query params if present.

  useEffect(function () {
    var getSetUrlParams = function getSetUrlParams() {
      var urlSearchParams = new URLSearchParams(window.location.search);
      var q = urlSearchParams.get('q');
      var tldonly = urlSearchParams.get('tldonly');
      var exact = urlSearchParams.get('exact');
      var initSearchParams = {
        query: q || '',
        exact: exact !== 'false',
        tld: tldonly
      };
      setSearchParams(initSearchParams); // Focus input field on page load if no passed in query.

      if (!q) {
        var _inputRef$current;

        inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
      }
    };

    if (isFirstSearch) {
      getSetUrlParams();
    }
  }, [isFirstSearch, setSearchParams]);
  return /*#__PURE__*/jsxs(_StyledStack$6, {
    "data-testid": "domain-search-view",
    id: "Search-Wrapper",
    width: "100%",
    alignItems: "end",
    gap: 4,
    children: [/*#__PURE__*/jsx$1(_StyledText$6, {
      "data-testid": "welcome-header-text",
      textAlign: "center",
      fontWeight: "bold",
      color: "neutral-700",
      variant: "heading-h1",
      width: "100%",
      style: {
        transition: '0.2s',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      $_css: isFirstSearch ? '100px' : '0',
      $_css2: isFirstSearch ? '200px' : '0',
      $_css3: isFirstSearch ? '200px' : '0',
      children: "Your Perfect Domain Awaits"
    }), /*#__PURE__*/jsxs(Box, {
      width: "100%",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 3,
      children: [/*#__PURE__*/jsxs(_StyledBox$5, {
        id: "Input-Field-Container",
        borderRadius: "rounded",
        border: "1px solid",
        borderColor: "primary-100",
        py: 2,
        px: 4,
        gap: 1,
        alignItems: "center",
        justifyContent: "space-between",
        fontWeight: "semi",
        flex: 1,
        height: ['60px', '80px', '80px'],
        flexWrap: "nowrap",
        overflow: "hidden",
        onClick: function onClick() {
          var _inputRef$current2;

          return inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.focus();
        },
        children: [/*#__PURE__*/jsxs(Box, {
          alignItems: "center",
          flex: 1,
          gap: 1,
          children: [/*#__PURE__*/jsx$1(Search, {
            color: "#9CA3AF"
          }), /*#__PURE__*/jsx$1(_StyledInput$1, {
            "data-testid": "search-input",
            id: "search-input-field",
            ref: inputRef,
            placeholder: "mydomain.com",
            value: searchParams.query,
            onChange: function onChange(e) {
              return setSearchParams(_objectSpread$h(_objectSpread$h({}, searchParams), {}, {
                query: e.target.value
              }));
            }
          })]
        }), /*#__PURE__*/jsx$1(_StyledButton$5, {
          "data-testid": "go-to-bulk-search",
          display: ['none', 'flex', 'flex'],
          variant: "minimal",
          onClick: goToBulkView,
          children: "Bulk Search"
        })]
      }), /*#__PURE__*/jsxs(_StyledButton2, {
        left: 2,
        bottom: 2,
        position: ['fixed', 'sticky', 'sticky'],
        "data-testid": "go-to-ai-search",
        onClick: function onClick() {
          return goToAIView();
        },
        border: "none",
        variant: "secondary",
        zIndex: 1,
        backgroundColor: "supporting-haciendaBlue",
        children: [/*#__PURE__*/jsx$1(RiMagicLine, {}), /*#__PURE__*/jsx$1(Text, {
          color: "white",
          children: "AI Generator"
        })]
      })]
    }), cart.length > 0 && /*#__PURE__*/jsxs(Box, {
      "data-testid": "continue-to-addons-button",
      justifyContent: ['space-between', 'end', 'end'],
      backgroundColor: "card",
      top: "80px",
      width: "100%",
      position: "sticky",
      py: "10px",
      zIndex: 1,
      children: [/*#__PURE__*/jsx$1(Button, {
        variant: "minimal",
        onClick: goToBulkView,
        display: ['flex', 'none', 'none'],
        children: "Bulk Search"
      }), /*#__PURE__*/jsx$1(DirectionButton, {
        direction: "->",
        onClick: goNext,
        children: "Continue"
      })]
    }), /*#__PURE__*/jsxs(Grid, {
      width: "100%",
      gridTemplateColumns: ['1fr', '1fr', '1fr 1fr'],
      mb: 3,
      gap: 3,
      children: [/*#__PURE__*/jsx$1(AvailabilityBlock, {}), /*#__PURE__*/jsx$1(BundleBlock, {}), /*#__PURE__*/jsx$1(AlternateBlock, {})]
    }), !bulkSearch && !isFirstSearch && /*#__PURE__*/jsxs(Box, {
      "data-testid": "search-filters",
      width: "100%",
      justifyContent: ['center', 'space-between', 'space-between'],
      alignItems: ['start', 'center', 'center'],
      flexDirection: ['column', 'row', 'row'],
      mt: 2,
      gap: 2,
      children: [/*#__PURE__*/jsxs(_StyledBox2$1, {
        flexDirection: ['column', 'row', 'row'],
        alignItems: ['start', 'center', 'center'],
        gap: 2,
        children: [/*#__PURE__*/jsx$1(Text, {
          color: "neutral-900",
          variant: "paragraph-large",
          fontWeight: "semi",
          children: "Refine by category"
        }), /*#__PURE__*/jsx$1("select", {
          "data-testid": "category-select",
          "aria-label": "Refine by category",
          style: {
            borderRadius: '8px',
            padding: '8px 24px'
          },
          value: categories.current.name || 'All',
          onChange: function onChange(e) {
            return updateCategory(e.target.value);
          },
          children: function () {
            var allCategories = categories.allCategories;

            if (!allCategories) {
              return /*#__PURE__*/jsx$1("option", {
                value: "All",
                children: "All Categories"
              });
            }

            return allCategories.map(function (_ref2) {
              var name = _ref2.name;
              return /*#__PURE__*/jsx$1("option", {
                value: name,
                children: name === 'All' ? 'All Categories' : name
              }, name);
            });
          }()
        })]
      }), /*#__PURE__*/jsxs(_StyledBox3, {
        alignItems: "center",
        gap: 1,
        children: [/*#__PURE__*/jsx$1(Input$3, {
          id: "exact-checkbox",
          type: "checkbox",
          checked: searchParams.exact,
          onChange: function onChange(e) {
            return setSearchParams(function (prev) {
              return _objectSpread$h(_objectSpread$h({}, prev), {}, {
                exact: e.target.checked
              });
            });
          }
        }), /*#__PURE__*/jsx$1(_StyledText2$1, {
          as: "label",
          htmlFor: "exact-checkbox",
          color: "neutral-900",
          fontWeight: "semi",
          variant: "paragraph-large",
          children: "Show exact matches only"
        })]
      })]
    }), /*#__PURE__*/jsx$1(Results, {}), searchDomains.possible.length > fetchedCount && /*#__PURE__*/jsx$1(Button, {
      width: "200px",
      variant: "secondary",
      onClick: loadMoreResults,
      marginX: "auto",
      disabled: fetching === 'MORE',
      loading: fetching === 'MORE',
      children: "Load more"
    })]
  });
}

var _StyledStack$6 = styled(Stack$1)(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral$1(["\n        transition: 0.2s;\n      "])));

var _StyledText$6 = styled(Text)(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral$1(["\n          overflow: hidden;\n          margin-top: ", ";\n          max-height: ", ";\n          height: ", ";\n        "])), function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
}, function (p) {
  return p.$_css3;
});

var _StyledBox$5 = styled(Box)(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral$1(["\n            cursor: text;\n            box-shadow: 0px 17.608px 23.477px -17.608px rgba(0, 0, 0, 0.15);\n            transition: 0.2s;\n\n            &:focus-within,\n            &:hover {\n              box-shadow: 0px 17.608px 23.477px -17.608px rgba(0, 0, 0, 0.2);\n            }\n          "])));

var _StyledInput$1 = styled(Input$3)(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral$1(["\n                font-weight: ", ";\n                font-size: 20px;\n                padding: 0 12px;\n                border: none;\n                outline: none;\n                box-shadow: none;\n\n                ", "\n\n                &::placeholder {\n                  color: ", ";\n                }\n              "])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeights.semi;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.media.smallAndDown(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral$1(["\n                  font-size: 16px;\n                "])));
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors['neutral-200'];
});

var _StyledButton$5 = styled(Button)(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral$1(["\n              padding: 1rem 0;\n              color: ", ";\n              font-weight: ", ";\n              font-size: 16px;\n\n              &:hover {\n                color: ", ";\n              }\n            "])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors['primary-700'];
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontWeights.semi;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors['primary-800'];
});

var _StyledButton2 = styled(Button)(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral$1(["\n            &:hover {\n              background-color: ", " !important;\n              filter: brightness(0.9);\n            }\n          "])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors['supporting-haciendaBlue'];
});

var _StyledBox2$1 = styled(Box)(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral$1(["\n              select {\n                cursor: pointer;\n                border: 1px solid ", ";\n              }\n            "])), function (_ref0) {
  var theme = _ref0.theme;
  return theme.colors['neutral-400'];
});

var _StyledBox3 = styled(Box)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral$1(["\n              & > span {\n                white-space: nowrap;\n              }\n\n              input[type='checkbox'] {\n                cursor: pointer;\n                accent-color: ", ";\n                height: 20px;\n                width: 20px;\n              }\n            "])), function (_ref1) {
  var theme = _ref1.theme;
  return theme.colors['primary-700'];
});

var _StyledText2$1 = styled(Text).withConfig({
  displayName: "search___StyledText2",
  componentId: "sc-14of3o4-0"
})(["white-space:nowrap;font-family:", ";"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.fonts.body;
});

function SearchPage(_ref) {
  var goNext = _ref.goNext;

  var _useState = useState('DEFAULT'),
      _useState2 = _slicedToArray$4(_useState, 2),
      view = _useState2[0],
      setView = _useState2[1];

  useEffect(function () {
    var updateViewFromHash = function updateViewFromHash() {
      var hash = window.location.hash.replace('#', '').toUpperCase();

      if (hash === 'AI' || hash === 'BULK') {
        setView(hash);
      } else {
        setView('DEFAULT');
      }
    };

    updateViewFromHash();
    window.addEventListener('hashchange', updateViewFromHash);
    return function () {
      return window.removeEventListener('hashchange', updateViewFromHash);
    };
  }, []);
  useEffect(function () {
    window.scrollTo({
      top: 0,
      behavior: 'instant'
    });
  }, [view]);

  var changeView = function changeView(newView) {
    setView(newView);
    var hashValue = newView === 'DEFAULT' ? ' ' : "#".concat(newView.toLowerCase());
    window.history.replaceState(null, '', hashValue);
  };

  return /*#__PURE__*/jsxs(AnimatePresence, {
    mode: "wait",
    initial: false,
    children: [view === 'DEFAULT' && /*#__PURE__*/jsx$1(motion.div, {
      initial: {
        x: 0,
        opacity: 1
      },
      animate: {
        x: 0,
        opacity: 1
      },
      exit: {
        x: '-100%',
        opacity: 0
      },
      transition: {
        duration: 0.2,
        ease: 'easeInOut'
      },
      style: {
        width: '100%'
      },
      children: /*#__PURE__*/jsx$1(DomainSearch, {
        goNext: goNext,
        goToAIView: function goToAIView() {
          trackEvent({
            event: ANALYTICS_EVENTS.aiGeneratorClick
          });
          changeView('AI');
        },
        goToBulkView: function goToBulkView() {
          return changeView('BULK');
        }
      })
    }, 'default'), view === 'BULK' && /*#__PURE__*/jsx$1(motion.div, {
      initial: {
        x: '100%',
        opacity: 0
      },
      animate: {
        x: 0,
        opacity: 1
      },
      exit: {
        x: '100%',
        opacity: 0
      },
      transition: {
        duration: 0.2,
        ease: 'easeInOut'
      },
      style: {
        width: '100%'
      },
      children: /*#__PURE__*/jsx$1(BulkSearch, {
        goBack: function goBack() {
          return changeView('DEFAULT');
        }
      })
    }, 'bulk'), view === 'AI' && /*#__PURE__*/jsx$1(motion.div, {
      initial: {
        x: '100%',
        opacity: 0
      },
      animate: {
        x: 0,
        opacity: 1
      },
      exit: {
        x: '100%',
        opacity: 0
      },
      transition: {
        duration: 0.2,
        ease: 'easeInOut'
      },
      style: {
        width: '100%'
      },
      children: /*#__PURE__*/jsx$1(AISearch, {
        goBack: function goBack() {
          return changeView('DEFAULT');
        }
      })
    }, 'ai')]
  });
}

function ErrorBanner() {
  var _useError = useError(),
      error = _useError.error;

  return /*#__PURE__*/jsx$1(_StyledBox$4, {
    "data-testid": "error-banner",
    backgroundColor: "destructive-500",
    color: "white",
    mb: 2,
    justifyContent: "center",
    alignItems: "center",
    $_css: error ? function (_ref) {
      var theme = _ref.theme;
      return theme.space[3];
    } : 0,
    $_css2: error ? '100px' : '0',
    children: /*#__PURE__*/jsx$1(Text, {
      children: error
    })
  });
}

var _StyledBox$4 = styled(Box).withConfig({
  displayName: "error-banner___StyledBox",
  componentId: "sc-11krmvt-0"
})(["width:90%;border-bottom-right-radius:8px;border-bottom-left-radius:8px;padding:", ";max-height:", ";overflow:hidden;transition:0.2s;"], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
});

function SearchAndAddOnsPage(_ref) {
  var children = _ref.children;

  var _useState = useState('Domains'),
      _useState2 = _slicedToArray$4(_useState, 2),
      step = _useState2[0],
      setStep = _useState2[1];

  return /*#__PURE__*/jsx$1(ErrorBoundary, {
    location: "search-and-addons",
    children: /*#__PURE__*/jsxs(ErrorProvider, {
      children: [/*#__PURE__*/jsx$1(ErrorBanner, {}), /*#__PURE__*/jsx$1(DomainSearchProvider, {
        children: /*#__PURE__*/jsxs(CartProvider, {
          children: [children, /*#__PURE__*/jsx$1(_StyledStack$5, {
            maxWidth: "1300px",
            width: "100%",
            id: "Search-Page-Container",
            height: "100%",
            flex: "1",
            px: ['1.6rem', '1.6rem', '6.4rem'],
            alignItems: "center",
            my: [2, 5, 5],
            gap: 4,
            children: /*#__PURE__*/jsxs(AnimatePresence, {
              mode: "wait",
              initial: false,
              children: [step === 'Domains' && /*#__PURE__*/jsx$1(motion.div, {
                initial: {
                  x: 0,
                  opacity: 1
                },
                animate: {
                  x: 0,
                  opacity: 1
                },
                exit: {
                  x: '-100%',
                  opacity: 0
                },
                transition: {
                  duration: 0.2,
                  ease: 'easeInOut'
                },
                style: {
                  width: '100%'
                },
                children: /*#__PURE__*/jsx$1(SearchPage, {
                  goNext: function goNext() {
                    return setStep('Add-Ons');
                  }
                })
              }, 'Domains'), step === 'Add-Ons' && /*#__PURE__*/jsx$1(motion.div, {
                initial: {
                  x: '100%',
                  opacity: 0
                },
                animate: {
                  x: 0,
                  opacity: 1
                },
                exit: {
                  x: '100%',
                  opacity: 0
                },
                transition: {
                  duration: 0.2,
                  ease: 'easeInOut'
                },
                style: {
                  width: '100%'
                },
                children: /*#__PURE__*/jsx$1(AddOnsPage, {
                  goBack: function goBack() {
                    return setStep('Domains');
                  }
                })
              }, 'Add-Ons')]
            })
          })]
        })
      })]
    })
  });
}

var _StyledStack$5 = styled(Stack$1).withConfig({
  displayName: "search-and-addons___StyledStack",
  componentId: "sc-1065vlp-0"
})(["& > div:first-child{padding:4px;}"]);

function useScrollTop() {
  var deps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  React__default.useEffect(function () {
    if (hasDOM) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    }
  }, [deps]);
}

({
  errorGettingmfaType: PropTypes.bool.isRequired,
  onBack: PropTypes.func.isRequired,
  onSubmitPhone: PropTypes.func.isRequired,
  onSubmitApp: PropTypes.func.isRequired,
  currentmfaType: PropTypes.number.isRequired,
  strings: PropTypes.shape({
    backToSettings: PropTypes.string,
    errorGettingmfaType: PropTypes.string,
    textAuthenticatorDL: PropTypes.string,
    toQRScan: PropTypes.string
  }).isRequired
});
styled(Box$1).withConfig({
  displayName: "authenticator___StyledBox",
  componentId: "sc-17l3k63-0"
})(["gap:2rem;"]);

var _templateObject$9, _templateObject2$7, _templateObject3$5;

var propTypes$b = {
  onSuccess: PropTypes.func.isRequired,
  isAppActivation: PropTypes.bool.isRequired,
  strings: PropTypes.shape({
    textBackToSecurity: PropTypes.string,
    textDone: PropTypes.string,
    textLastMessage: PropTypes.string
  }).isRequired
};

function TwoFactorEndSuccess(_ref) {
  var strings = _ref.strings,
      onSuccess = _ref.onSuccess,
      isAppActivation = _ref.isAppActivation;
  useScrollTop();
  return /*#__PURE__*/jsxs(_StyledBox$3, {
    flexDirection: "column",
    mt: 3,
    children: [/*#__PURE__*/jsx$1(_StyledStack$4, {
      children: /*#__PURE__*/jsx$1(Icon$2, {
        name: "checkmark-outline",
        height: "100%",
        width: "100%",
        color: "#16a34a"
      })
    }), /*#__PURE__*/jsx$1(_StyledText$5, {
      children: "Successfully ".concat(isAppActivation ? 'enabled' : 'disabled')
    }), /*#__PURE__*/jsx$1(Text$1, {
      textAlign: "center",
      children: isAppActivation ? strings.textAppEnable : strings.textAppDisable
    }), /*#__PURE__*/jsx$1(_StyledButton$4, {
      alignSelf: "flex-start",
      id: "doneTwoFactorNext",
      onClick: onSuccess,
      variant: "link",
      children: strings.textBackToSecurity
    })]
  });
}

TwoFactorEndSuccess.propTypes = propTypes$b;

var _StyledBox$3 = styled(Box$1)(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral$1(["\n        align-items: center;\n      "])));

var _StyledStack$4 = styled(Stack$2)(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral$1(["\n          height: 3rem;\n          width: 3rem;\n        "])));

var _StyledText$5 = styled(Text$1)(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral$1(["\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          font-weight: 600;\n          font-size: 2.25rem;\n          color: #16a34a;\n        "])));

var _StyledButton$4 = styled(Button$1).withConfig({
  displayName: "end-success___StyledButton",
  componentId: "sc-17znt8p-0"
})(["margin:3rem auto 0 auto;"]);

var _templateObject$8;

var defaultProps$6 = {
  qrCode: null
};
var propTypes$a = {
  errorFetchingQRCode: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onSuccess: PropTypes.func.isRequired,
  qrCode: PropTypes.string,
  strings: PropTypes.shape({
    back: PropTypes.string,
    backToAuthenticator: PropTypes.string,
    backToSettings: PropTypes.string,
    errorCheckingEnabled: PropTypes.string,
    errorFetchingQRCode: PropTypes.string,
    fetchingQRCode: PropTypes.string,
    refreshBrowser: PropTypes.string,
    textNext: PropTypes.string,
    textQRScan: PropTypes.string,
    toVerification: PropTypes.string
  }).isRequired
};

function TwoFactorQRCode(_ref) {
  var strings = _ref.strings,
      onSuccess = _ref.onSuccess,
      errorFetchingQRCode = _ref.errorFetchingQRCode,
      isLoading = _ref.isLoading,
      qrCode = _ref.qrCode;
  useScrollTop();
  return /*#__PURE__*/jsxs(Box$1, {
    flexDirection: "column",
    width: "80%",
    children: [/*#__PURE__*/jsxs(_StyledStack$3, {
      children: [/*#__PURE__*/jsx$1("h2", {
        children: "To configure the app"
      }), /*#__PURE__*/jsxs("ul", {
        children: [/*#__PURE__*/jsx$1("li", {
          children: "Add a new time-based code"
        }), /*#__PURE__*/jsx$1("li", {
          children: "Use your app to scan the QR code below"
        })]
      })]
    }), /*#__PURE__*/jsxs(Box$1, {
      alignItems: "center",
      justifyContent: "center",
      my: [4],
      children: [isLoading && /*#__PURE__*/jsx$1(Skeleton$1, {
        alignItems: "center",
        "data-testid": "loading-skeleton",
        display: "flex",
        height: "20rem",
        justifyContent: "center",
        m: 3,
        width: "20rem",
        children: /*#__PURE__*/jsx$1(Text$1, {
          fontSize: 1,
          mx: 4,
          textAlign: "center",
          children: strings.fetchingQRCode
        })
      }), errorFetchingQRCode && /*#__PURE__*/jsx$1(Box$1, {
        alignItems: "center",
        bg: "redLighter",
        borderColor: "red",
        borderRadius: 1,
        borderStyle: "solid",
        borderWidth: "1px",
        display: "flex",
        height: "20rem",
        justifyContent: "center",
        m: 3,
        width: "20rem",
        children: /*#__PURE__*/jsxs(Text$1, {
          fontSize: 1,
          mx: 4,
          textAlign: "center",
          children: [/*#__PURE__*/jsx$1(Box$1, {
            display: "block",
            children: strings.errorFetchingQRCode
          }), /*#__PURE__*/jsx$1(Box$1, {
            mt: 3,
            children: strings.refreshBrowser
          })]
        })
      }), qrCode && /*#__PURE__*/jsx$1("img", {
        alt: "QR Code for Authenticator App",
        src: qrCode
      })]
    }), /*#__PURE__*/jsx$1(_StyledBox$2, {
      alignItems: "center",
      children: qrCode && /*#__PURE__*/jsx$1("span", {
        onClick: onSuccess,
        children: strings.textNext
      })
    })]
  });
}

TwoFactorQRCode.propTypes = propTypes$a;
TwoFactorQRCode.defaultProps = defaultProps$6;

var _StyledStack$3 = styled(Stack$2)(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral$1(["\n          justify-content: center;\n          align-items: center;\n          h2 {\n            font-size: 3rem;\n            font-weight: 600;\n          }\n          ul {\n            list-style: inside;\n          }\n        "])));

var _StyledBox$2 = styled(Box$1).withConfig({
  displayName: "qr-code___StyledBox",
  componentId: "sc-116dv04-0"
})(["width:100%;border-top:1px solid rgba(0,0,0,0.15);padding-top:2rem;justify-content:center;span{text-decoration:underline;cursor:pointer;}"]);

function _regenerator$8() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$8(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$8(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$8(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$8(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$8(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$8(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$8(u), _regeneratorDefine2$8(u, o, "Generator"), _regeneratorDefine2$8(u, n, function () {
    return this;
  }), _regeneratorDefine2$8(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$8 = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$8(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$8 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$8(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$8(e, r, n, t);
}

var _verifyAndUpdateMfaType = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$8().m(function _callee(ctx, evt) {
    return _regenerator$8().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            return _context.a(2, post$1("".concat(mfaEndpoint, "/token/validate"), {
              token: evt.code,
              mfaType: 'app',
              activationType: getmfaTypeFromInt(ctx.mfaType) == 'app' ? 'app-off' : 'app-on'
            }));
        }
      }
    }, _callee);
  }));

  return function verifyAndUpdateMfaType(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var fetchQRCode = function fetchQRCode() {
  return get$3("".concat(mfaEndpoint, "/qrcode"));
}; // CONSTANTS


var viewNames = {
  authenticator: 'authenticator',
  verification: 'verification',
  end: 'end',
  qrCode: 'qrCode'
}; // 2-FACTOR MACHINE

var MACHINE_ID = 'two-factor';
var machineOpts = {
  services: {
    fetchQRCode: fetchQRCode,
    getUserForMFA: getUserForMFA,
    verifyAndUpdateMfaType: function verifyAndUpdateMfaType(ctx, evt) {
      return _verifyAndUpdateMfaType(ctx, evt);
    }
  },
  actions: {
    cachemfaType: assign$2({
      mfaType: function mfaType(ctx, evt) {
        return evt.data.mfaType;
      }
    }),
    flipError: assign$2({
      hasError: true
    }),
    clearError: assign$2({
      hasError: false
    }),
    cacheQRCode: assign$2({
      qrCode: function qrCode(ctx, evt) {
        return evt.data.data.qrcode;
      }
    }),
    clearQRCode: assign$2({
      qrCode: function qrCode() {
        return null;
      }
    }),
    backToSecuritySettingsPage: function backToSecuritySettingsPage() {
      return navigateToUrl('/my-account/settings/security');
    }
  },
  guards: {
    isAppUser: function isAppUser(ctx, evt) {
      return getmfaTypeFromInt(evt.data.mfaType) === 'app';
    }
  }
};
var twoStepMachine = Machine({
  id: MACHINE_ID,
  initial: viewNames.authenticator,
  context: {
    retries: 0,
    qrCode: null,
    hasError: false,
    mfaType: 0
  },
  states: _defineProperty$6(_defineProperty$6(_defineProperty$6(_defineProperty$6({}, viewNames.authenticator, {
    id: viewNames.authenticator,
    initial: 'gettingmfaType',
    states: {
      gettingmfaType: {
        invoke: {
          src: 'getUserForMFA',
          onDone: [{
            cond: 'isAppUser',
            actions: 'cachemfaType',
            target: '#viewNames.verification'
          }, {
            actions: 'cachemfaType',
            target: '#viewNames.qrCode'
          }],
          onError: {
            target: 'errorGettingmfaType'
          }
        }
      },
      errorGettingmfaType: {
        on: {
          back: {
            actions: 'backToSecuritySettingsPage'
          }
        }
      }
    }
  }), viewNames.qrCode, {
    id: 'viewNames.qrCode',
    initial: 'fetchingQRCode',
    states: {
      fetchingQRCode: {
        invoke: {
          id: 'fetching-qr-code',
          src: 'fetchQRCode',
          onDone: {
            target: 'idle',
            actions: 'cacheQRCode'
          },
          onError: {
            target: 'errorFetchingQRCode'
          }
        }
      },
      idle: {
        id: 'qrCodeScan',
        on: {
          NEXT: {
            target: '#viewNames.verification'
          }
        }
      },
      errorFetchingQRCode: {}
    }
  }), viewNames.verification, {
    id: 'viewNames.verification',
    initial: 'acceptingCode',
    states: {
      acceptingCode: {
        on: {
          submitCode: 'verifyingCode',
          BACK: {
            target: '#qrCodeScan',
            actions: 'clearError'
          }
        }
      },
      verifyingCode: {
        id: 'verifyingCode',
        invoke: {
          id: 'verifying-code',
          src: 'verifyAndUpdateMfaType',
          onDone: '#viewNames.end',
          onError: {
            target: 'acceptingCode',
            actions: 'flipError'
          }
        }
      }
    }
  }), viewNames.end, {
    id: 'viewNames.end',
    on: {
      NEXT: {
        actions: 'backToSecuritySettingsPage'
      }
    }
  })
}, machineOpts);

var _templateObject$7, _templateObject2$6, _templateObject3$4, _templateObject4$2, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function ownKeys$g(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$g(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$g(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$g(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var propTypes$9 = {
  onBack: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onSubmitCode: PropTypes.func.isRequired,
  isAppActivation: PropTypes.bool.isRequired,
  errorVerifyingCode: PropTypes.bool.isRequired,
  strings: PropTypes.shape({
    textCodeMismatch: PropTypes.string,
    codeFromApp: PropTypes.string,
    textContincodeNotFromAppueToRecovery: PropTypes.string,
    textNext: PropTypes.string,
    textVerifiedCode: PropTypes.string
  }).isRequired
};

function TwoFactorVerification(_ref) {
  var onBack = _ref.onBack,
      strings = _ref.strings,
      isLoading = _ref.isLoading,
      onSubmitCode = _ref.onSubmitCode,
      isAppActivation = _ref.isAppActivation,
      errorVerifyingCode = _ref.errorVerifyingCode;
  var inputRef = useRef();

  var _useState = useState(''),
      _useState2 = _slicedToArray$4(_useState, 2),
      code = _useState2[0],
      setCode = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray$4(_useState3, 2);

  _useState4[0];
  var setDisabled = _useState4[1];

  var _useState5 = useState(5),
      _useState6 = _slicedToArray$4(_useState5, 2),
      secondsLeft = _useState6[0],
      setSecondsLeft = _useState6[1];

  var _useState7 = useState({
    0: '',
    1: '',
    2: '',
    3: '',
    4: '',
    5: ''
  }),
      _useState8 = _slicedToArray$4(_useState7, 2),
      codeValues = _useState8[0],
      setCodeValues = _useState8[1];

  useEffect(function () {
    if (secondsLeft > 0) {
      var timer = setTimeout(function () {
        setSecondsLeft(secondsLeft - 1);
      }, 1000);
      return function () {
        return clearTimeout(timer);
      };
    }

    if (secondsLeft <= 0) {
      setDisabled(false);
    }
  }, [secondsLeft]);

  function moveInDirection(direction, currentIndex) {
    var form = document.getElementById('codeForm');
    var inputs = form === null || form === void 0 ? void 0 : form.querySelectorAll('input');

    if (!inputs) {
      return;
    }

    var nextInput = inputs[currentIndex + direction];
    nextInput.focus();
  }

  function handleChange(event, currentIndex) {
    var currentLength = event.target.value.length;

    if (currentLength == 0) {
      return;
    }

    if (currentLength == 1) {
      setCodeValues(_objectSpread$g(_objectSpread$g({}, codeValues), {}, _defineProperty$6({}, currentIndex, event.target.value)));

      if (currentIndex < 5) {
        moveInDirection(1, currentIndex);
      } else {
        var _code = Object.values(codeValues).join('') + event.target.value;

        if (_code.length == 6) {
          setCodeValues({
            0: '',
            1: '',
            2: '',
            3: '',
            4: '',
            5: ''
          });
          onSubmitCode(_code);
        }
      }
    }

    if (currentLength > 1) {
      setCodeValues(_objectSpread$g(_objectSpread$g({}, codeValues), {}, _defineProperty$6({}, currentIndex, codeValues[currentIndex] ? event.target.value.replace(codeValues[currentIndex], '')[0] : event.target.value[0])));
      moveInDirection(1, currentIndex);
    }
  }

  function handleKeyDown(event, currentIndex) {
    switch (event.key) {
      case 'Backspace':
        setCodeValues(_objectSpread$g(_objectSpread$g({}, codeValues), {}, _defineProperty$6({}, currentIndex, '')));

        if (currentIndex > 0) {
          moveInDirection(-1, currentIndex);
        }

        break;

      case 'ArrowRight':
        if (currentIndex < 5) {
          moveInDirection(1, currentIndex);
        }

        break;

      case 'ArrowLeft':
        if (currentIndex > 0) {
          moveInDirection(-1, currentIndex);
        }

        break;

      case 'Delete':
        setCodeValues(_objectSpread$g(_objectSpread$g({}, codeValues), {}, _defineProperty$6({}, currentIndex, '')));
        break;
    }
  }

  function handlePaste(event) {
    var pastedData = event.clipboardData.getData('text');
    var pastedLength = pastedData.length;

    if (pastedLength == 6) {
      setCodeValues({
        0: '',
        1: '',
        2: '',
        3: '',
        4: '',
        5: ''
      });
      onSubmitCode(pastedData);
    }
  }

  useEffect(function () {
    if (isLoading) {
      return;
    }

    var firstInput = document.getElementById('first-input');

    if (firstInput) {
      setTimeout(function () {
        firstInput.focus();
      }, 300);
    }
  }, [errorVerifyingCode, isLoading]);
  useScrollTop();
  useEffect(function () {
    if (code.length === 6) {
      onSubmitCode(code);
      setCode('');
    }
  }, [code]);
  useEffect(function () {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  var formStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '1rem',
    width: '65%'
  };
  var inputStyles = "\n    display: flex;\n    width: 3rem;\n    justify-content: center;\n    align-items: center;\n    border-bottom: ".concat(errorVerifyingCode ? '2px solid #5c0000 !important;' : '2px solid rgba(0,0,0,0.4) !important;', "\n    cursor: pointer;\n    transition: 0.2s;\n    input {\n      background: transparent;\n      cursor: pointer;\n      border: none !important;\n      outline: none;\n      width: 100%;\n      padding: 0;\n      padding-bottom: 4px;\n      caret-color: transparent;\n      font-size: 3rem;\n      text-align: center;\n      &:focus {\n        box-shadow: none !important;\n      }\n    }\n    &:focus-within {\n      transform: translateY(-2px);\n      border-bottom: 2px solid rgba(180, 0, 0, 0.795) !important;\n    }\n  ");
  return isLoading ? /*#__PURE__*/jsx$1(Skeleton$1, {
    width: "100%",
    height: "30rem"
  }) : /*#__PURE__*/jsxs(_StyledStack$2, {
    children: [/*#__PURE__*/jsx$1(Text$1, {
      children: isAppActivation ? strings.codeAppEnable : strings.codeAppDisable
    }), /*#__PURE__*/jsxs("form", {
      id: "codeForm",
      style: formStyles,
      children: [/*#__PURE__*/jsx$1(_StyledInput, {
        type: "text",
        onKeyDown: function onKeyDown(e) {
          return handleKeyDown(e, 0);
        },
        autoComplete: "off",
        value: codeValues[0],
        id: "first-input",
        onChange: function onChange(e) {
          return handleChange(e, 0);
        },
        onPaste: function onPaste(e) {
          return handlePaste(e);
        },
        $_css: inputStyles
      }), /*#__PURE__*/jsx$1(_StyledInput2, {
        type: "text",
        onKeyDown: function onKeyDown(e) {
          return handleKeyDown(e, 1);
        },
        autoComplete: "off",
        value: codeValues[1],
        id: "2",
        onChange: function onChange(e) {
          return handleChange(e, 1);
        },
        onPaste: function onPaste(e) {
          return handlePaste(e);
        },
        $_css2: inputStyles
      }), /*#__PURE__*/jsx$1(_StyledInput3, {
        type: "text",
        onKeyDown: function onKeyDown(e) {
          return handleKeyDown(e, 2);
        },
        autoComplete: "off",
        value: codeValues[2],
        id: "3",
        onChange: function onChange(e) {
          return handleChange(e, 2);
        },
        onPaste: function onPaste(e) {
          return handlePaste(e);
        },
        $_css3: inputStyles
      }), /*#__PURE__*/jsx$1(_StyledInput4, {
        type: "text",
        onKeyDown: function onKeyDown(e) {
          return handleKeyDown(e, 3);
        },
        autoComplete: "off",
        value: codeValues[3],
        id: "4",
        onChange: function onChange(e) {
          return handleChange(e, 3);
        },
        onPaste: function onPaste(e) {
          return handlePaste(e);
        },
        $_css4: inputStyles
      }), /*#__PURE__*/jsx$1(_StyledInput5, {
        type: "text",
        onKeyDown: function onKeyDown(e) {
          return handleKeyDown(e, 4);
        },
        autoComplete: "off",
        value: codeValues[4],
        id: "5",
        onChange: function onChange(e) {
          return handleChange(e, 4);
        },
        onPaste: function onPaste(e) {
          return handlePaste(e);
        },
        $_css5: inputStyles
      }), /*#__PURE__*/jsx$1(_StyledInput6, {
        type: "text",
        onKeyDown: function onKeyDown(e) {
          return handleKeyDown(e, 5);
        },
        autoComplete: "off",
        value: codeValues[5],
        id: "6",
        onChange: function onChange(e) {
          return handleChange(e, 5);
        },
        onPaste: function onPaste(e) {
          return handlePaste(e);
        },
        $_css6: inputStyles
      })]
    }), errorVerifyingCode && /*#__PURE__*/jsxs(_StyledText$4, {
      display: "flex",
      children: [/*#__PURE__*/jsx$1(Icon$2, {
        mr: 2,
        name: "error"
      }), strings.textCodeMismatch]
    }), isAppActivation && /*#__PURE__*/jsx$1(_StyledBox$1, {
      alignItems: "center",
      children: /*#__PURE__*/jsx$1("span", {
        onClick: onBack,
        children: strings.back
      })
    })]
  });
}

TwoFactorVerification.propTypes = propTypes$9;

var _StyledStack$2 = styled(Stack$2)(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral$1(["\n        align-items: center;\n        gap: 5rem;\n      "])));

var _StyledInput = styled(Input$5)(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral$1(["", ""])), function (p) {
  return p.$_css;
});

var _StyledInput2 = styled(Input$5)(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral$1(["", ""])), function (p) {
  return p.$_css2;
});

var _StyledInput3 = styled(Input$5)(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral$1(["", ""])), function (p) {
  return p.$_css3;
});

var _StyledInput4 = styled(Input$5)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral$1(["", ""])), function (p) {
  return p.$_css4;
});

var _StyledInput5 = styled(Input$5)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral$1(["", ""])), function (p) {
  return p.$_css5;
});

var _StyledInput6 = styled(Input$5)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral$1(["", ""])), function (p) {
  return p.$_css6;
});

var _StyledText$4 = styled(Text$1)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral$1(["\n            font-size: 1.25rem;\n            align-items: center;\n            color: #5c0000;\n          "])));

var _StyledBox$1 = styled(Box$1).withConfig({
  displayName: "verification___StyledBox",
  componentId: "sc-27ieqx-0"
})(["width:100%;border-top:1px solid rgba(0,0,0,0.15);padding-top:2rem;justify-content:center;span{text-decoration:underline;cursor:pointer;}"]);

var defaultProps$5 = {
  strings: {
    twoFactorHeading: 'Default Heading'
  }
};
var propTypes$8 = {
  strings: PropTypes.shape({
    textTurnOn: PropTypes.string,
    twoFactorHeading: PropTypes.string
  })
};

function TwoFactor(_ref) {
  var strings = _ref.strings;

  var _useMachine = useMachine(twoStepMachine),
      _useMachine2 = _slicedToArray$4(_useMachine, 2),
      current = _useMachine2[0],
      send = _useMachine2[1];

  var isCheckingEnabled = current.matches("".concat(viewNames.authenticator, ".checkingEnabled"));
  return /*#__PURE__*/jsxs(_StyledStack$1, {
    maxWidth: "containers.sm",
    children: [/*#__PURE__*/jsx$1(Heading, {
      as: "h1",
      children: strings.twoFactorHeading
    }), isCheckingEnabled ? /*#__PURE__*/jsx$1(Skeleton$1, {
      height: "30rem"
    }) : /*#__PURE__*/jsxs(Fragment, {
      children: [current.matches(viewNames.qrCode) && /*#__PURE__*/jsx$1(TwoFactorQRCode, {
        errorFetchingQRCode: current.matches("".concat(viewNames.qrCode, ".errorFetchingQRCode")),
        isLoading: current.matches("".concat(viewNames.qrCode, ".fetchingQRCode")),
        onSuccess: function onSuccess() {
          return send('NEXT');
        },
        qrCode: current.context.qrCode,
        strings: strings
      }), current.matches(viewNames.verification) && /*#__PURE__*/jsx$1(TwoFactorVerification, {
        isLoading: current.matches("".concat(viewNames.verification, ".verifyingCode")),
        errorVerifyingCode: current.context.hasError,
        onBack: function onBack() {
          return send('BACK');
        },
        onSubmitCode: function onSubmitCode(code) {
          return send({
            type: 'submitCode',
            code: code
          });
        },
        strings: strings,
        isAppActivation: current.context.mfaType != 2,
        currentmfaType: current.context.mfaType
      }), current.matches(viewNames.end) && /*#__PURE__*/jsx$1(TwoFactorEndSuccess, {
        onSuccess: function onSuccess() {
          return send('NEXT');
        },
        isAppActivation: current.context.mfaType != 2,
        strings: strings
      })]
    })]
  });
}

TwoFactor.defaultProps = defaultProps$5;
TwoFactor.propTypes = propTypes$8;

var _StyledStack$1 = styled(Stack$2).withConfig({
  displayName: "two-factor___StyledStack",
  componentId: "sc-9f4yqo-0"
})(["align-items:center;width:100%;border:1px solid rgba(0,0,0,0.15);border-radius:5px;background:rgb(250,250,250);padding:1rem 4rem 4rem 4rem;& > h1{text-align:center;width:100%;font-weight:600;padding-bottom:1rem;margin-bottom:2rem;border-bottom:2px solid rgba(0,0,0,0.15);}"]);

function _regenerator$7() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$7(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$7(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$7(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$7(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$7(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$7(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$7(u), _regeneratorDefine2$7(u, o, "Generator"), _regeneratorDefine2$7(u, n, function () {
    return this;
  }), _regeneratorDefine2$7(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$7 = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$7(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$7 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$7(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$7(e, r, n, t);
}

function ownKeys$f(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$f(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$f(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$f(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function MfaModal(_ref) {
  var showModal = _ref.showModal,
      handleClose = _ref.handleClose,
      setUserVerified = _ref.setUserVerified;

  var _useModal = useModal(),
      openModal = _useModal.openModal,
      closeModal = _useModal.closeModal,
      Modal = _useModal.Modal;

  var _useState = useState(true),
      _useState2 = _slicedToArray$4(_useState, 2),
      showSixDigitsPage = _useState2[0],
      setShowSixDigitsPage = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$4(_useState3, 2),
      showContactMethodPage = _useState4[0],
      setShowContactMethodPage = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray$4(_useState5, 2),
      contactMethod = _useState6[0],
      setContactMethod = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray$4(_useState7, 2),
      isLoading = _useState8[0],
      setIsLoading = _useState8[1];

  var _useState9 = useState({
    customerId: 0,
    mfaType: 4,
    username: '',
    email: '',
    phone: '',
    alternateEmail: ''
  }),
      _useState0 = _slicedToArray$4(_useState9, 2),
      userInfo = _useState0[0],
      setUserInfo = _useState0[1];

  var _useState1 = useState({
    token: '',
    error: false,
    attempts: 0
  }),
      _useState10 = _slicedToArray$4(_useState1, 2),
      tokenStates = _useState10[0],
      setTokenStates = _useState10[1];

  function onCloseModal() {
    handleClose();
    closeModal();
  }

  function userFailedAuth() {
    onCloseModal();
    setUserVerified(false);
  }

  function tokenWasInvalid() {
    return _tokenWasInvalid.apply(this, arguments);
  }

  function _tokenWasInvalid() {
    _tokenWasInvalid = _asyncToGenerator( /*#__PURE__*/_regenerator$7().m(function _callee2() {
      return _regenerator$7().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              setIsLoading(false);

              if (tokenStates.attempts === 2) {
                userFailedAuth();
              } else {
                setTokenStates(function (prevTokenStates) {
                  return {
                    token: '',
                    error: true,
                    attempts: prevTokenStates.attempts + 1
                  };
                });
              }

            case 1:
              return _context2.a(2);
          }
        }
      }, _callee2);
    }));
    return _tokenWasInvalid.apply(this, arguments);
  }

  function sendToken(_x, _x2, _x3) {
    return _sendToken.apply(this, arguments);
  }

  function _sendToken() {
    _sendToken = _asyncToGenerator( /*#__PURE__*/_regenerator$7().m(function _callee3(contactMethod, customerId, username) {
      return _regenerator$7().w(function (_context3) {
        while (1) {
          switch (_context3.n) {
            case 0:
              _context3.p = 0;
              setIsLoading(true);
              setTokenStates(function (prevTokenStates) {
                return _objectSpread$f(_objectSpread$f({}, prevTokenStates), {}, {
                  error: false
                });
              });
              _context3.n = 1;
              return post$1("".concat(mfaEndpoint, "/token/send"), {
                username: username,
                customerId: customerId,
                contactMethod: contactMethod
              });

            case 1:
              setIsLoading(false);
              _context3.n = 3;
              break;

            case 2:
              _context3.p = 2;
              handleError();

            case 3:
              return _context3.a(2);
          }
        }
      }, _callee3, null, [[0, 2]]);
    }));
    return _sendToken.apply(this, arguments);
  }

  function verifyToken(_x4) {
    return _verifyToken.apply(this, arguments);
  }

  function _verifyToken() {
    _verifyToken = _asyncToGenerator( /*#__PURE__*/_regenerator$7().m(function _callee4(token) {
      return _regenerator$7().w(function (_context4) {
        while (1) {
          switch (_context4.n) {
            case 0:
              setIsLoading(true);
              _context4.p = 1;
              _context4.n = 2;
              return post$1("".concat(mfaEndpoint, "/token/validate"), {
                token: token,
                mfaType: getmfaTypeFromInt(userInfo.mfaType)
              });

            case 2:
              setUserVerified(true);
              _context4.n = 4;
              break;

            case 3:
              _context4.p = 3;
              tokenWasInvalid();

            case 4:
              return _context4.a(2);
          }
        }
      }, _callee4, null, [[1, 3]]);
    }));
    return _verifyToken.apply(this, arguments);
  }

  function handleError() {
    setIsLoading(false);
    setTokenStates(function (prevTokenStates) {
      return _objectSpread$f(_objectSpread$f({}, prevTokenStates), {}, {
        error: true
      });
    });
  }

  function _onSubmitContactMethod2(_x5) {
    return _onSubmitContactMethod.apply(this, arguments);
  }

  function _onSubmitContactMethod() {
    _onSubmitContactMethod = _asyncToGenerator( /*#__PURE__*/_regenerator$7().m(function _callee5(contactMethod) {
      return _regenerator$7().w(function (_context5) {
        while (1) {
          switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return sendToken(contactMethod, userInfo.customerId, userInfo.username);

            case 1:
              setContactMethod(contactMethod);

            case 2:
              return _context5.a(2);
          }
        }
      }, _callee5);
    }));
    return _onSubmitContactMethod.apply(this, arguments);
  }

  useEffect(function () {
    function getUserInfo() {
      return _getUserInfo.apply(this, arguments);
    }

    function _getUserInfo() {
      _getUserInfo = _asyncToGenerator( /*#__PURE__*/_regenerator$7().m(function _callee() {
        var user, mfaType, formatted, _t;

        return _regenerator$7().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                setIsLoading(true);
                _context.p = 1;
                _context.n = 2;
                return getUserForMFA();

              case 2:
                user = _context.v;

                if (!user.recentLogin) {
                  _context.n = 3;
                  break;
                }

                return _context.a(2, setUserVerified(true));

              case 3:
                mfaType = getmfaTypeFromInt(user.mfaType);
                _t = mfaType;
                _context.n = _t === 'none' ? 4 : _t === 'app' ? 5 : _t === 'alternateEmail' ? 6 : _t === 'email' ? 6 : _t === 'phone' ? 8 : 12;
                break;

              case 4:
                setUserVerified(true);
                return _context.a(3, 12);

              case 5:
                setUserInfo(user);
                setIsLoading(false);
                return _context.a(3, 12);

              case 6:
                setUserInfo(user);
                _context.n = 7;
                return sendToken(mfaType, user.customerId, user.username);

              case 7:
                return _context.a(3, 12);

              case 8:
                if (user.phone) {
                  _context.n = 10;
                  break;
                }

                setUserInfo(_objectSpread$f(_objectSpread$f({}, user), {}, {
                  mfaType: 3
                }));
                _context.n = 9;
                return sendToken('email', user.customerId, user.username);

              case 9:
                return _context.a(3, 12);

              case 10:
                formatted = user.phone.split(/[xX]/)[0].replace(/[^0-9]/g, '');
                setUserInfo(_objectSpread$f(_objectSpread$f({}, user), {}, {
                  phone: formatted
                }));
                _context.n = 11;
                return sendToken('phone', user.customerId, user.username);

              case 11:
                return _context.a(3, 12);

              case 12:
                _context.n = 14;
                break;

              case 13:
                _context.p = 13;
                handleError();

              case 14:
                return _context.a(2);
            }
          }
        }, _callee, null, [[1, 13]]);
      }));
      return _getUserInfo.apply(this, arguments);
    }

    getUserInfo();
  }, []);
  useEffect(function () {
    if (showModal) {
      openModal();
    }
  }, [showModal]);
  return /*#__PURE__*/jsxs(Modal, {
    closeBtnCb: onCloseModal,
    id: "2fa-modal",
    onBgClick: onCloseModal,
    onEscapeKey: onCloseModal,
    width: "61rem",
    containerProps: {
      px: '5',
      pt: '3'
    },
    children: [/*#__PURE__*/jsx$1(_StyledHeading$1, {
      headingStyle: 2,
      textAlign: "center",
      children: authStrings.twoFactorCodeHeading
    }), /*#__PURE__*/jsx$1(TwoFactorView, {
      error: tokenStates.error,
      currentType: contactMethod || getmfaTypeFromInt(userInfo.mfaType),
      contactInfo: {
        email: userInfo.email,
        phone: userInfo.phone,
        alternateEmail: userInfo.alternateEmail
      },
      onSubmitCode: function onSubmitCode(token) {
        return verifyToken(token);
      },
      onSubmitContactMethod: function onSubmitContactMethod(contactMethod) {
        _onSubmitContactMethod2(contactMethod);

        setShowSixDigitsPage(true);
        setShowContactMethodPage(false);
      },
      onGoToContactOptions: function onGoToContactOptions() {
        setShowSixDigitsPage(false);
        setShowContactMethodPage(true);
      },
      onResendCode: function onResendCode() {
        return sendToken(contactMethod || getmfaTypeFromInt(userInfo.mfaType), userInfo.customerId, userInfo.username);
      },
      onGoBack: function onGoBack() {
        setShowSixDigitsPage(true);
        setShowContactMethodPage(false);
      },
      showMFAInfoPage: false,
      showSixDigit: showSixDigitsPage,
      showContactMethodPicker: showContactMethodPage,
      isSending: isLoading
    })]
  });
}

var _StyledHeading$1 = styled(Heading).withConfig({
  displayName: "mfa-modal___StyledHeading",
  componentId: "sc-w9helk-0"
})(["font-size:1.75rem;font-weight:600;padding-bottom:2rem;border-bottom:2px solid rgba(0,0,0,0.1);"]);

var _templateObject$6, _templateObject2$5;

function _regenerator$6() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$6(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$6(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$6(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$6(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$6(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$6(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$6(u), _regeneratorDefine2$6(u, o, "Generator"), _regeneratorDefine2$6(u, n, function () {
    return this;
  }), _regeneratorDefine2$6(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$6 = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$6(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$6 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$6(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$6(e, r, n, t);
}

function LockAccount(_ref) {
  var strings = _ref.strings;

  var _useState = useState({
    customerId: '',
    token: ''
  }),
      _useState2 = _slicedToArray$4(_useState, 2),
      lockingInfo = _useState2[0],
      setLockingInfo = _useState2[1];

  var _useState3 = useState({
    message: '',
    isError: false
  }),
      _useState4 = _slicedToArray$4(_useState3, 2),
      messageInfo = _useState4[0],
      setMessageInfo = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray$4(_useState5, 2),
      isLoading = _useState6[0],
      setIsLoading = _useState6[1];

  var handleButtonClick = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$6().m(function _callee() {
      return _regenerator$6().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              setIsLoading(true);
              _context.p = 1;
              _context.n = 2;
              return post$1("".concat(mfaEndpoint, "/account/lock"), {
                customerId: lockingInfo.customerId,
                token: lockingInfo.token
              });

            case 2:
              setMessageInfo({
                message: strings.lockSuccess,
                isError: false
              });
              _context.n = 4;
              break;

            case 3:
              _context.p = 3;
              setMessageInfo({
                message: strings.lockFail,
                isError: true
              });

            case 4:
              _context.p = 4;
              setIsLoading(false);
              return _context.f(4);

            case 5:
              return _context.a(2);
          }
        }
      }, _callee, null, [[1, 3, 4, 5]]);
    }));

    return function handleButtonClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    var getUrlParams = function getUrlParams() {
      var searchParams = new URLSearchParams(window.location.search);
      return {
        customerId: searchParams.get('customerId'),
        token: searchParams.get('token')
      };
    };

    var _getUrlParams = getUrlParams(),
        customerId = _getUrlParams.customerId,
        token = _getUrlParams.token;

    setLockingInfo({
      customerId: customerId,
      token: token
    });
  }, []);

  function actionRequired() {
    return /*#__PURE__*/jsxs(_StyledStack, {
      justifyContent: "space-around",
      alignItems: "center",
      bg: "#F7F6F9",
      p: 4,
      children: [/*#__PURE__*/jsx$1(Box$1, {
        children: /*#__PURE__*/jsx$1(Icon$2, {
          name: "bell",
          color: "#453E63"
        })
      }), /*#__PURE__*/jsx$1(Text$1, {
        fontSize: "2rem",
        fontWeight: "700",
        color: "#453E63",
        children: strings.actionRequired
      }), /*#__PURE__*/jsx$1(Text$1, {
        color: "#453E63",
        textAlign: "center",
        my: 3,
        fontWeight: "400",
        children: strings.pageReason
      }), /*#__PURE__*/jsx$1(Button$1, {
        color: "deepKoamaru",
        fontWeight: "300",
        onClick: handleButtonClick,
        children: strings.lockAccount
      })]
    });
  }

  function lockSuccess() {
    return /*#__PURE__*/jsxs(_StyledStack2, {
      justifyContent: "space-around",
      alignItems: "center",
      bg: "#f0fdf4",
      p: 5,
      children: [/*#__PURE__*/jsx$1(Box$1, {
        children: /*#__PURE__*/jsx$1(Icon$2, {
          name: "padlock",
          color: "#16A34A"
        })
      }), /*#__PURE__*/jsx$1(Text$1, {
        fontSize: "2rem",
        fontWeight: "700",
        color: "#16A34A",
        children: messageInfo.message
      })]
    });
  }

  function lockFail() {
    return /*#__PURE__*/jsxs(_StyledStack3, {
      justifyContent: "space-around",
      alignItems: "center",
      bg: "#ffe9e9",
      p: 5,
      children: [/*#__PURE__*/jsx$1(Box$1, {
        children: /*#__PURE__*/jsx$1(Icon$2, {
          name: "error",
          color: "#c92a2a"
        })
      }), /*#__PURE__*/jsx$1(Text$1, {
        fontSize: "2rem",
        fontWeight: "700",
        color: "#c92a2a",
        children: messageInfo.message
      })]
    });
  }

  return lockingInfo.token && lockingInfo.customerId && !isLoading ? /*#__PURE__*/jsxs(Stack$2, {
    alignItems: "center",
    justifyContent: "space-around",
    width: "80%",
    height: "50%",
    children: [/*#__PURE__*/jsx$1(Text$1, {
      as: "h1",
      fontSize: "4rem",
      fontWeight: "700",
      children: strings.questionHeader
    }), !messageInfo.message ? actionRequired() : messageInfo.isError ? lockFail() : lockSuccess()]
  }) : /*#__PURE__*/jsx$1(Skeleton$1, {
    width: "80%",
    height: "80%"
  });
}

var _StyledStack = styled(Stack$2)(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral$1(["\n          border: 1px solid #cdc9dd;\n          border-radius: 5px;\n        "])));

var _StyledStack2 = styled(Stack$2)(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral$1(["\n          border: 1px solid #bbf7d0;\n          border-radius: 5px;\n        "])));

var _StyledStack3 = styled(Stack$2).withConfig({
  displayName: "lock-account___StyledStack3",
  componentId: "sc-lkaw6r-0"
})(["border:1px solid #ffd3d3;border-radius:5px;"]);

var _templateObject$5, _templateObject2$4, _templateObject3$3, _templateObject4$1;

function _regenerator$5() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$5(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$5(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$5(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$5(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$5(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$5(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$5(u), _regeneratorDefine2$5(u, o, "Generator"), _regeneratorDefine2$5(u, n, function () {
    return this;
  }), _regeneratorDefine2$5(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$5 = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$5(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$5 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$5(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$5(e, r, n, t);
}

function SecuritySettings(_ref) {
  var strings = _ref.strings;

  var _useUserService = useUserService(),
      user = _useUserService.user;

  var _useState = useState(2),
      _useState2 = _slicedToArray$4(_useState, 2),
      mfaType = _useState2[0],
      setMfaType = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray$4(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray$4(_useState5, 2),
      hasErrorGettingStatus = _useState6[0],
      setHasErrorGettingStatus = _useState6[1];

  var isSocialUser = user === null || user === void 0 ? void 0 : user.isSocialUser;
  var hasNoMfa = !mfaType || mfaType == 1;

  function getDisplayText(mfaType) {
    switch (getmfaTypeFromInt(mfaType)) {
      case 'app':
        return strings.accountIsAppUser;

      case 'email':
        return strings.accountIsEmailUser;

      case 'phone':
        return strings.accountIsPhoneUser;

      default:
        return strings.accountHasNoAuth;
    }
  }

  useEffect(function () {
    function getmfaType() {
      return _getmfaType.apply(this, arguments);
    }

    function _getmfaType() {
      _getmfaType = _asyncToGenerator( /*#__PURE__*/_regenerator$5().m(function _callee() {
        var _user;

        return _regenerator$5().w(function (_context) {
          while (1) {
            switch (_context.n) {
              case 0:
                _context.p = 0;
                _context.n = 1;
                return getUserForMFA();

              case 1:
                _user = _context.v;
                setMfaType((_user === null || _user === void 0 ? void 0 : _user.mfaType) || 0);
                setIsLoading(false);
                _context.n = 3;
                break;

              case 2:
                _context.p = 2;
                setHasErrorGettingStatus(true);
                setIsLoading(false);

              case 3:
                return _context.a(2);
            }
          }
        }, _callee, null, [[0, 2]]);
      }));
      return _getmfaType.apply(this, arguments);
    }

    getmfaType();
  }, []);
  return isLoading ? /*#__PURE__*/jsx$1(Skeleton$1, {
    height: "20rem",
    width: "80rem"
  }) : /*#__PURE__*/jsxs(_StyledBox, {
    flex: "1",
    flexDirection: "column",
    alignItems: "center",
    maxWidth: "containers.md",
    width: "100%",
    children: [/*#__PURE__*/jsx$1(_StyledHeading, {
      as: "h1",
      children: strings.headingSecurity
    }), /*#__PURE__*/jsxs(Stack$2, {
      alignItems: "center",
      children: [/*#__PURE__*/jsx$1(_StyledBox2, {
        children: /*#__PURE__*/jsx$1(Icon$2, {
          name: "shield",
          height: "100%",
          width: "100%",
          color: hasNoMfa ? '#753737' : '#16a34a'
        })
      }), /*#__PURE__*/jsx$1(_StyledText$3, {
        $_css: hasNoMfa ? '#753737' : '#16a34a',
        children: strings.headingTwoFactor
      }), /*#__PURE__*/jsx$1(Fragment, {
        children: isSocialUser ? strings.socialUser : /*#__PURE__*/jsxs(_StyledText2, {
          $_css2: hasNoMfa ? '#ffe5ed63' : '#e5fff663',
          $_css3: hasNoMfa ? '#2e0d17' : '#37754e',
          $_css4: hasNoMfa ? '#eb8d8d63' : '#a7e9bc63',
          $_css5: hasNoMfa ? '#2e0d17' : '#37754e',
          $_css6: hasNoMfa ? '#2e0d17' : '#37754e',
          children: [getDisplayText(mfaType), /*#__PURE__*/jsx$1(Link$1, {
            href: "/my-account/settings/security/two-factor",
            children: "click here"
          })]
        })
      })]
    }), hasErrorGettingStatus && /*#__PURE__*/jsx$1(Box$1, {
      mt: 2,
      width: "100%",
      children: /*#__PURE__*/jsx$1(Message, {
        variant: "error",
        children: strings.textErrorGettingStatus
      })
    }), /*#__PURE__*/jsx$1(Link$1, {
      href: "/my-account/user-details",
      color: "black",
      textDecoration: "underline",
      children: "Back to account settings"
    })]
  });
}

var _StyledBox = styled(Box$1)(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral$1(["\n        gap: 4rem;\n      "])));

var _StyledHeading = styled(Heading)(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral$1(["\n          font-size: 3rem;\n          font-weight: 700;\n        "])));

var _StyledBox2 = styled(Box$1)(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral$1(["\n            height: 3rem;\n            width: 3rem;\n          "])));

var _StyledText$3 = styled(Text$1)(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral$1(["\n            font-weight: 600;\n            font-size: 2.25rem;\n            color: ", ";\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n          "])), function (p) {
  return p.$_css;
});

var _StyledText2 = styled(Text$1).withConfig({
  displayName: "security-settings___StyledText2",
  componentId: "sc-1rj2qqg-0"
})(["padding:10px;background:", ";color:", ";border:1px solid ", ";border-radius:5px;text-align:center;a{color:", ";text-decoration:underline;font-weight:600;&:hover{color:", ";}}"], function (p) {
  return p.$_css2;
}, function (p) {
  return p.$_css3;
}, function (p) {
  return p.$_css4;
}, function (p) {
  return p.$_css5;
}, function (p) {
  return p.$_css6;
});

function _regenerator$4() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$4(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$4(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$4(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$4(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$4(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$4(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$4(u), _regeneratorDefine2$4(u, o, "Generator"), _regeneratorDefine2$4(u, n, function () {
    return this;
  }), _regeneratorDefine2$4(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$4 = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$4(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$4 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$4(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$4(e, r, n, t);
}

function ownKeys$e(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$e(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$e(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$e(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var initialState$1 = {
  email: '',
  error: null,
  success: null,
  isLoading: false
};

var reducer$1 = function reducer(state, action) {
  switch (action.type) {
    case 'error':
      {
        return _objectSpread$e(_objectSpread$e({}, state), {}, {
          error: action.payload,
          isLoading: false,
          success: null
        });
      }

    case 'success':
      {
        return _objectSpread$e(_objectSpread$e({}, state), {}, {
          error: null,
          success: action.payload,
          email: '',
          isLoading: false
        });
      }

    case 'submit':
      {
        return _objectSpread$e(_objectSpread$e({}, state), {}, {
          isLoading: true
        });
      }

    case 'input':
      {
        return _objectSpread$e(_objectSpread$e({}, state), {}, {
          email: action.payload,
          success: null,
          error: null
        });
      }

    case 'reset':
      {
        return initialState$1;
      }

    default:
      return initialState$1;
  }
};

var propTypes$7 = {
  id: PropTypes.string.isRequired
};

function NewsletterSignup$1(_ref) {
  var id = _ref.id;

  var _useReducer = useReducer(reducer$1, initialState$1),
      _useReducer2 = _slicedToArray$4(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var successMessage = 'Ok. Thanks for signing up';
  var alreadySignedUp = 'Great. You were already signed up.';
  var errorMessage = 'Oops, there was a problem signing you up. Make sure your email is in the right format.';

  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$4().m(function _callee() {
      var _yield$post, status, _t;

      return _regenerator$4().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return post$1(emailSignup, {
                email: state.email,
                campaign: RESELLER
              });

            case 1:
              _yield$post = _context.v;
              status = _yield$post.status;

              if (status === 200) {
                dispatch({
                  type: 'success',
                  payload: successMessage
                });
              } else {
                dispatch({
                  type: 'error',
                  payload: errorMessage
                });
              }

              _context.n = 3;
              break;

            case 2:
              _context.p = 2;
              _t = _context.v;

              if (_t.response.status === 409 || _t.response.status === 500) {
                dispatch({
                  type: 'success',
                  payload: alreadySignedUp
                });
              } else {
                dispatch({
                  type: 'error',
                  payload: errorMessage
                });
              }

            case 3:
              return _context.a(2);
          }
        }
      }, _callee, null, [[0, 2]]);
    }));

    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();

  var submitBtnColor = isInternic ? 'blue' : 'pinkLighter';
  return /*#__PURE__*/jsxs(Box$1, {
    flexDirection: "column",
    mb: 3,
    children: [/*#__PURE__*/jsx$1(Heading, {
      as: "div",
      fontSize: "1rem",
      textStyle: "navHeading",
      children: "Subscribe to our news & promotions"
    }), /*#__PURE__*/jsx$1(SubmitField, {
      color: submitBtnColor,
      id: "".concat(id, "-newsletter-signUp"),
      label: "Enter your email",
      mt: 4,
      noDisable: true,
      onChange: function onChange(e) {
        return dispatch({
          type: 'input',
          payload: e.target.value
        });
      },
      onClearValue: function onClearValue() {
        return dispatch({
          type: 'reset'
        });
      },
      onSubmit: handleSubmit,
      submitAriaLabel: "Submit",
      value: state.email
    }), /*#__PURE__*/jsxs(Text$1, {
      mt: 2,
      children: [state.error && /*#__PURE__*/jsx$1(Text$1, {
        color: "red",
        fontSize: "1.2rem",
        fontWeight: "bold",
        children: state.error
      }), state.success && /*#__PURE__*/jsx$1(Text$1, {
        color: "mintGreenDark",
        fontSize: "1.2rem",
        fontWeight: "bold",
        children: state.success
      })]
    })]
  });
}

NewsletterSignup$1.propTypes = propTypes$7;
var _excluded$3 = ["icon", "href", "title"];

function ownKeys$d(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$d(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$d(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$d(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var currentYear = new Date().getFullYear();
var defaultProps$4 = {
  showNewsletterSignup: true
};
var propTypes$6 = {
  showNewsletterSignup: PropTypes.bool
};
var footerLinks = {
  company: [{
    display: 'About',
    url: '/about'
  }, {
    display: 'Services',
    url: '/Prestige-Services.aspx',
    hide: isRebel
  }, {
    display: 'Careers',
    url: '/careers',
    hide: isInternic
  }, {
    display: 'Partner Program',
    url: '/programs/partner-program'
  }, {
    display: 'Affiliate Program',
    url: '/programs/affiliate-program/',
    hide: isInternic
  }, {
    display: 'ChangeMaker Program',
    url: '/programs/changemaker/',
    hide: isInternic
  }, {
    display: 'News and Events',
    url: '/news-and-events',
    hide: isInternic
  }, {
    display: 'Promos',
    url: '/sales/promos',
    hide: isInternic
  }, {
    display: 'Blog',
    url: 'https://blog.rebel.com',
    hide: isInternic
  }],
  support: [{
    display: 'Contact Us',
    url: isInternic ? 'https://support.internic.ca/#contact' : 'https://support.rebel.com/#contact'
  }, {
    display: 'Help Centre',
    url: isInternic ? 'https://support.internic.ca/' : 'https://support.rebel.com/'
  }, {
    display: 'Free Hosting Migration',
    url: '/hosting/hosting-migration'
  }, {
    display: 'Quick Renew',
    url: '/quick-renew'
  }, {
    display: 'Email Setup Assistant',
    url: '/email/smart-setup/'
  }, {
    display: 'Status Page',
    url: isInternic ? 'https://status.internic.ca/' : 'https://status.rebel.com/'
  }, {
    display: '#CommunityMatters',
    url: '/about/community/',
    hide: isInternic
  }]
};
var linkMargins = {
  mb: 4,
  mr: 3,
  color: 'white',
  fontSize: 0,
  fontWeight: 'semi'
};
var linkStyles = {
  color: 'white',
  fontSize: 0,
  fontWeight: 'regular'
};

function FooterBar(_ref) {
  var showNewsletterSignup = _ref.showNewsletterSignup;
  return /*#__PURE__*/jsxs(Box$1, {
    alignItems: "center",
    bg: "blackLight",
    color: "white",
    flexDirection: "column",
    pt: 3,
    children: [/*#__PURE__*/jsx$1(Box$1, {
      px: [3, 4],
      py: 4,
      width: 1,
      children: /*#__PURE__*/jsxs(Box$1, {
        flexDirection: ['column', 'row'],
        flexWrap: "wrap",
        justifyContent: "flex-start",
        maxWidth: "83rem",
        mx: "auto",
        width: 1,
        children: [/*#__PURE__*/jsx$1(Box$1, {
          flex: "1 1 0%",
          children: Object.keys(footerLinks).map(function (key) {
            return /*#__PURE__*/jsxs(Box$1, {
              as: "ul",
              flex: "1 1 0%",
              flexDirection: "column",
              mr: 2,
              children: [/*#__PURE__*/jsx$1(Box$1, {
                as: "li",
                mb: 4,
                children: /*#__PURE__*/jsx$1(Heading, {
                  as: "div",
                  fontSize: "1rem",
                  textStyle: "navHeading",
                  children: key
                })
              }), map$2(footerLinks[key], function (_ref2) {
                var display = _ref2.display,
                    url = _ref2.url,
                    hide = _ref2.hide;
                return hide ? null : /*#__PURE__*/jsx$1(Box$1, {
                  as: "li",
                  mb: 3,
                  children: /*#__PURE__*/jsx$1(Link$1, _objectSpread$d(_objectSpread$d({}, linkStyles), {}, {
                    ariaLabel: display,
                    href: url,
                    children: display
                  }))
                }, "".concat(key, "-").concat(display));
              })]
            }, key);
          })
        }), /*#__PURE__*/jsxs(Box$1, {
          alignSelf: ['center', 'flex-start'],
          flexDirection: "column",
          maxWidth: "34rem",
          minWidth: "28rem",
          mt: [4, 0],
          children: [showNewsletterSignup && /*#__PURE__*/jsx$1(NewsletterSignup$1, {
            id: "footer-signup"
          }), /*#__PURE__*/jsx$1(Box$1, {
            mb: 3,
            children: socialLinks.map(function (_ref3) {
              var icon = _ref3.icon,
                  href = _ref3.href,
                  title = _ref3.title,
                  rest = _objectWithoutProperties$8(_ref3, _excluded$3);

              return /*#__PURE__*/jsx$1(Link$1, _objectSpread$d(_objectSpread$d({
                ariaLabel: title,
                href: href,
                mr: 3,
                newTab: true
              }, rest), {}, {
                children: /*#__PURE__*/jsx$1(Icon$2, {
                  color: "grey",
                  height: "2rem",
                  name: icon,
                  title: title,
                  width: "4rem"
                })
              }), href);
            })
          })]
        })]
      })
    }), /*#__PURE__*/jsx$1(Box$1, {
      borderTop: 1,
      color: "greyLight",
      flexDirection: "column",
      px: [3, 4],
      py: 4,
      width: 1,
      children: /*#__PURE__*/jsxs(Box$1, {
        flexDirection: "column",
        maxWidth: "83rem",
        mx: "auto",
        width: 1,
        children: [/*#__PURE__*/jsxs(Box$1, {
          alignItems: "center",
          flexWrap: "wrap",
          children: [isRebelCOM && /*#__PURE__*/jsx$1(CurrencySelector, {
            containerProps: _objectSpread$d({}, linkMargins),
            id: "footer-currency-select"
          }), /*#__PURE__*/jsx$1(Link$1, _objectSpread$d(_objectSpread$d({}, linkMargins), {}, {
            ariaLabel: "Accessibility",
            href: isInternic ? 'https://support.internic.ca/hc/en-us/articles/229506907-What-is-your-Accessibility-Policy-' : 'https://support.rebel.com/hc/en-us/articles/228280348-What-is-your-Accessibility-Policy-',
            children: "Accessibility"
          })), /*#__PURE__*/jsx$1(Link$1, _objectSpread$d(_objectSpread$d({}, linkMargins), {}, {
            ariaLabel: "Privacy Policy",
            href: "/privacy-policy",
            children: "Privacy Policy"
          })), /*#__PURE__*/jsx$1(Link$1, _objectSpread$d(_objectSpread$d({}, linkMargins), {}, {
            ariaLabel: "Terms and Conditions",
            href: "/terms-conditions",
            children: "Terms & Conditions"
          })), /*#__PURE__*/jsx$1(Link$1, _objectSpread$d(_objectSpread$d({}, linkMargins), {}, {
            ariaLabel: "Abuse Policy",
            href: "/abuse-policy",
            children: "Abuse Policy"
          })), /*#__PURE__*/jsx$1(Link$1, _objectSpread$d(_objectSpread$d({}, linkMargins), {}, {
            ariaLabel: "Report Abuse",
            children: /*#__PURE__*/jsx$1(InfoCollectorModal, {
              id: "contact_modal_footer",
              fields: [{
                id: 'name',
                display: 'Full name',
                required: true
              }, {
                id: 'email',
                display: 'Primary Email address',
                type: 'email',
                required: true
              }, {
                id: 'domainService',
                display: 'Domain or Service',
                required: false
              }, {
                id: 'message',
                display: 'Comments',
                required: true,
                type: 'textarea'
              }],
              btnProps: {
                style: {
                  background: 'none',
                  border: 'none',
                  fontWeight: 'bold'
                }
              },
              source: "abuse-link",
              successMessage: "Abuse reports are reviewed within 24 hours.",
              errorMessage: "Something went wrong.",
              title: "Have you seen abuse on one of your products? Report it to us and we will help solve it for you!",
              buttonText: "Report Abuse"
            })
          }))]
        }), /*#__PURE__*/jsx$1(Box$1, {
          flexDirection: "column",
          children: /*#__PURE__*/jsxs(Text$1, {
            fontSize: "1rem",
            children: ["@ Copyright ".concat(currentYear, " ").concat(resellerName, ". All rights reserved."), /*#__PURE__*/jsxs(Box$1, {
              flexDirection: "column",
              mt: 2,
              children: [isRebelCOM && /*#__PURE__*/jsxs(Fragment, {
                children: [/*#__PURE__*/jsxs(Text$1, {
                  children: [/*#__PURE__*/jsx$1(Text$1, {
                    as: "span",
                    mr: 1,
                    children: "Canada Office:"
                  }), "532 Montreal Rd, Suite 261, Ottawa, ON Canada K1K 4R4"]
                }), /*#__PURE__*/jsxs(Text$1, {
                  children: [/*#__PURE__*/jsx$1(Text$1, {
                    as: "span",
                    mr: 1,
                    children: "TCI Office:"
                  }), "Neptune Court, Suite 204, Allegro Rd, Grace Bay, Providenciales, Turks and Caicos Islands TKCA 1ZZ"]
                }), /*#__PURE__*/jsxs(Text$1, {
                  mt: 2,
                  children: [/*#__PURE__*/jsx$1(Text$1, {
                    as: "span",
                    mr: 1,
                    children: "UK office:"
                  }), "1st Floor \u2013 2 Woodberry Grove, Finchley, London, England N12 0DR"]
                })]
              }), isRebelCA && /*#__PURE__*/jsxs(Text$1, {
                children: [/*#__PURE__*/jsx$1(Text$1, {
                  as: "span",
                  mr: 1,
                  children: "Canada Office:"
                }), "532 Montreal Rd, Suite 261, Ottawa, ON Canada K1K 4R4"]
              })]
            })]
          })
        })]
      })
    })]
  });
}

FooterBar.defaultProps = defaultProps$4;
FooterBar.propTypes = propTypes$6;
var _excluded$2 = ["title", "content", "iconName", "children", "titleId"];

function ownKeys$c(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$c(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$c(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$c(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var IconInfoBox = function IconInfoBox(_ref) {
  var title = _ref.title,
      content = _ref.content,
      iconName = _ref.iconName,
      children = _ref.children,
      titleId = _ref.titleId,
      rest = _objectWithoutProperties$8(_ref, _excluded$2);

  return /*#__PURE__*/jsxs(Stack$2, _objectSpread$c(_objectSpread$c({
    alignItems: "center"
  }, rest), {}, {
    children: [/*#__PURE__*/jsx$1(Icon$2, {
      height: 35,
      name: iconName,
      title: title,
      titleId: titleId,
      width: 35
    }), /*#__PURE__*/jsx$1(Heading, {
      as: "h3",
      color: "white",
      mt: [3],
      textAlign: "center",
      variant: ['gigaBold', 'gigaBold', 'teraBold'],
      children: title
    }), /*#__PURE__*/jsx$1(Text$1, {
      lineHeight: 1.7,
      mb: [3],
      mt: 3,
      textAlign: "center",
      variant: ['pound'],
      children: content
    }), /*#__PURE__*/jsx$1(Stack$2, {
      flex: "1",
      justifyContent: "flex-end",
      children: children
    })]
  }));
};

function ownKeys$b(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$b(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$b(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$b(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var getSupportPhone = function getSupportPhone() {
  switch (RESELLER) {
    case 'rebel.ca':
      return '1-844-548-2157';

    case 'internic.ca':
      return '1-866-642-1232';

    default:
      return '1-844-548-2157';
  }
};

var SUPPORT_PHONE = getSupportPhone();

var SupportBar = function SupportBar(_ref) {
  var containerProps = _ref.containerProps;

  var _useSunshine = useSunshine(),
      openChat = _useSunshine.openChat;

  var onChatClick = function onChatClick() {
    if (hasDOM && openChat) {
      openChat();
    }
  };

  var track = function track(type) {
    trackEvent({
      event: ANALYTICS_EVENTS.helpSection,
      eventCategory: ANALYTICS_CATEGORIES.user,
      data: {
        type: type
      }
    });
  };

  var linkColor = isInternic ? 'white' : 'pinkLighter';
  var buttonColor = isInternic ? 'white' : 'orangeDark';
  return /*#__PURE__*/jsxs(Stack$2, _objectSpread$b(_objectSpread$b({
    alignItems: "center",
    bg: "blackLight",
    px: 3,
    py: 5
  }, containerProps), {}, {
    color: "white",
    children: [/*#__PURE__*/jsx$1(Heading, {
      color: "white",
      textAlign: "center",
      variant: ['gigaBold', 'teraBold', 'petaBold'],
      children: "Award-winning support"
    }), /*#__PURE__*/jsx$1(Text$1, {
      color: "white",
      mt: [3],
      variant: ['pound', 'pound', 'giga'],
      children: "Speak to real humans"
    }), /*#__PURE__*/jsx$1(Stack$2, {
      alignItems: "center",
      mt: 4,
      children: /*#__PURE__*/jsx$1(IconInfoBox, {
        content: "Our agents are available 8am-10pm EST daily",
        iconName: "supportchat",
        title: "Chat with us",
        titleId: "start-chatting",
        children: /*#__PURE__*/jsx$1(Button$1, {
          ariaLabel: "Start Chatting Now",
          color: buttonColor,
          id: "chat-button",
          onClick: function onClick() {
            onChatClick();
            track('support-chat');
          },
          size: "large",
          variant: "solid",
          children: /*#__PURE__*/jsx$1(Text$1, {
            variant: ['megaBold'],
            children: "Start chatting now"
          })
        })
      })
    }), /*#__PURE__*/jsxs(Box$1, {
      alignItems: ['center', 'normal'],
      flexDirection: ['column', 'row'],
      justifyContent: "center",
      maxWidth: "82rem",
      mt: 5,
      width: 1,
      children: [/*#__PURE__*/jsx$1(IconInfoBox, {
        iconName: "supportemail",
        maxWidth: "17rem",
        title: "Email us",
        titleId: "emailUsIcon",
        content: "24/7",
        children: /*#__PURE__*/jsx$1(InfoCollectorModal, {
          id: "contact_modal_footer_support_bar",
          fields: [{
            id: 'name',
            display: 'Full name',
            required: true
          }, {
            id: 'email',
            display: 'Primary Email address',
            type: 'email',
            required: true
          }, {
            id: 'domainService',
            display: 'Domain or Service',
            required: false
          }, {
            id: 'message',
            display: 'Comments',
            required: true,
            type: 'textarea'
          }],
          btnProps: null,
          source: "support-footer",
          successMessage: "Thanks! We'll contact you within 24 hours.",
          errorMessage: "Something went wrong.",
          title: "We're here to help! Ready to chat? Give us a few details so we know where to start",
          buttonText: "Email Us"
        })
      }), /*#__PURE__*/jsx$1(IconInfoBox, {
        iconName: "supportphone",
        maxWidth: "17rem",
        ml: [0, 4],
        mt: [5, 0],
        title: "Call us",
        titleId: "supportPhoneIcon",
        content: "9am-5pm EST (daily)",
        children: /*#__PURE__*/jsx$1(_StyledLink$4, {
          ariaLabel: "Talk to our world-class support team",
          color: linkColor,
          href: "tel:".concat(SUPPORT_PHONE),
          onClick: function onClick() {
            track('support-email');
          },
          variant: "link",
          children: /*#__PURE__*/jsx$1(Text$1, {
            variant: ['poundBold'],
            children: SUPPORT_PHONE
          })
        })
      })]
    })]
  }));
};

var _StyledLink$4 = styled(Link$1).withConfig({
  displayName: "support-bar___StyledLink",
  componentId: "sc-syyeax-0"
})(["display:flex;justify-content:center;align-items:center;background:white;padding:0.8rem 1.6rem;color:rgba(0,0,0,0.8);text-decoration:none;font-weight:400;&:hover{color:black;}"]);

var propTypes$5 = {
  showNewsletterSignup: PropTypes.bool
};
var defaultProps$3 = {
  showNewsletterSignup: true
};

function Footer(_ref) {
  var showNewsletterSignup = _ref.showNewsletterSignup;
  return /*#__PURE__*/jsxs("footer", {
    children: [/*#__PURE__*/jsx$1(SupportBar, {}), /*#__PURE__*/jsx$1(FooterBar, {
      showNewsletterSignup: showNewsletterSignup
    })]
  });
}

Footer.propTypes = propTypes$5;
Footer.defaultProps = defaultProps$3;

function _regenerator$3() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$3(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$3(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$3(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$3(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$3(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$3(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$3(u), _regeneratorDefine2$3(u, o, "Generator"), _regeneratorDefine2$3(u, n, function () {
    return this;
  }), _regeneratorDefine2$3(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$3 = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$3(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$3 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$3(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$3(e, r, n, t);
}

function ownKeys$a(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$a(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$a(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$a(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var initialState = {
  email: '',
  error: null,
  success: null,
  isLoading: false
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'error':
      {
        return _objectSpread$a(_objectSpread$a({}, state), {}, {
          error: action.payload,
          isLoading: false,
          success: null
        });
      }

    case 'success':
      {
        return _objectSpread$a(_objectSpread$a({}, state), {}, {
          error: null,
          success: action.payload,
          email: '',
          isLoading: false
        });
      }

    case 'submit':
      {
        return _objectSpread$a(_objectSpread$a({}, state), {}, {
          isLoading: true
        });
      }

    case 'input':
      {
        return _objectSpread$a(_objectSpread$a({}, state), {}, {
          email: action.payload,
          success: null,
          error: null
        });
      }

    case 'reset':
      {
        return initialState;
      }

    default:
      return initialState;
  }
};

var propTypes$4 = {
  id: PropTypes.string.isRequired
};

function NewsletterSignup(_ref) {
  var id = _ref.id;

  var _useReducer = useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray$4(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var successMessage = 'Ok. Thanks for signing up';
  var alreadySignedUp = 'Great. You were already signed up.';
  var errorMessage = 'Oops, there was a problem signing you up. Make sure your email is in the right format.';

  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$3().m(function _callee() {
      var _yield$post, status, _t;

      return _regenerator$3().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return post$1(emailSignup, {
                email: state.email,
                campaign: RESELLER
              });

            case 1:
              _yield$post = _context.v;
              status = _yield$post.status;

              if (status === 200) {
                dispatch({
                  type: 'success',
                  payload: successMessage
                });
              } else {
                dispatch({
                  type: 'error',
                  payload: errorMessage
                });
              }

              _context.n = 3;
              break;

            case 2:
              _context.p = 2;
              _t = _context.v;

              if (_t.response.status === 409 || _t.response.status === 500) {
                dispatch({
                  type: 'success',
                  payload: alreadySignedUp
                });
              } else {
                dispatch({
                  type: 'error',
                  payload: errorMessage
                });
              }

            case 3:
              return _context.a(2);
          }
        }
      }, _callee, null, [[0, 2]]);
    }));

    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();

  var submitBtnColor = isInternic ? 'blue' : 'pinkLighter';
  return /*#__PURE__*/jsxs(Box$1, {
    flexDirection: "column",
    mb: 3,
    width: "100%",
    children: [/*#__PURE__*/jsx$1(SubmitField, {
      color: submitBtnColor,
      id: "".concat(id, "-newsletter-signup-v2"),
      label: "Enter your email",
      mt: 4,
      noDisable: true,
      onChange: function onChange(e) {
        return dispatch({
          type: 'input',
          payload: e.target.value
        });
      },
      onClearValue: function onClearValue() {
        return dispatch({
          type: 'reset'
        });
      },
      onSubmit: handleSubmit,
      submitAriaLabel: "Submit",
      value: state.email
    }), /*#__PURE__*/jsxs(Text$1, {
      mt: 2,
      children: [state.error && /*#__PURE__*/jsx$1(Text$1, {
        color: "red",
        fontSize: "1.2rem",
        fontWeight: "bold",
        children: state.error
      }), state.success && /*#__PURE__*/jsx$1(Text$1, {
        color: "mintGreenDark",
        fontSize: "1.2rem",
        fontWeight: "bold",
        children: state.success
      })]
    })]
  });
}

NewsletterSignup.propTypes = propTypes$4;
var _excluded$1 = ["btnProps", "textColor", "text"];

function ownKeys$9(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$9(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$9(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$9(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function LiveChatButton(_ref) {
  var btnProps = _ref.btnProps,
      textColor = _ref.textColor,
      text = _ref.text,
      rest = _objectWithoutProperties$8(_ref, _excluded$1);

  var _useSunshine = useSunshine(),
      openChat = _useSunshine.openChat;

  var onChatClick = function onChatClick() {
    if (hasDOM && openChat) {
      openChat();
    }
  };

  var track = function track(type) {
    trackEvent({
      event: ANALYTICS_EVENTS.helpSection,
      eventCategory: ANALYTICS_CATEGORIES.user,
      data: {
        type: type
      }
    });
  };

  return /*#__PURE__*/jsx$1(Text$1, _objectSpread$9(_objectSpread$9({}, rest), {}, {
    children: /*#__PURE__*/jsxs(Button$1, _objectSpread$9(_objectSpread$9({
      padding: "0.8rem 0rem",
      ariaLabel: "Chat with support",
      onClick: function onClick() {
        onChatClick();
        track('support-chat');
      }
    }, btnProps), {}, {
      children: [/*#__PURE__*/jsx$1(Text$1, {
        display: ['none', 'flex', 'flex'],
        color: textColor,
        children: text
      }), /*#__PURE__*/jsx$1(Icon$2, {
        name: "chat",
        title: "Live Chat",
        mx: 2,
        color: textColor
      })]
    }))
  }));
}

function UserAuthModal() {
  var _useUserService = useUserService(),
      closeUserAuthModal = _useUserService.closeUserAuthModal,
      Modal = _useUserService.Modal,
      isUserAuthModalOpen = _useUserService.isUserAuthModalOpen;

  return /*#__PURE__*/jsx$1(Modal, {
    closeBtnCb: closeUserAuthModal,
    id: "user-auth-modal",
    isOpen: isUserAuthModalOpen,
    onBgClick: closeUserAuthModal,
    onCancel: closeUserAuthModal,
    onEscapeKey: closeUserAuthModal,
    width: "61rem",
    containerProps: {
      px: '5',
      pt: '3'
    },
    children: /*#__PURE__*/jsx$1(UserAuth, {
      showHeading: true
    })
  });
}

var buttonCss = css$3(["background:none;border:none;padding:0 ", ";&:hover{background:", ";}"], theme.space.half, theme.colors.greys[6]);
var indicatorVariants = {
  visible: {
    x: '0',
    opacity: 1,
    rotate: 45
  },
  hidden: {
    x: '100vw',
    opacity: 0
  }
};
var transform$2 = system({
  transform: true
});
var IndicatorBox = motion.custom(styled.div.withConfig({
  displayName: "notification-indicator__IndicatorBox",
  componentId: "sc-z7zblr-0"
})(["", " ", " ", " ", " ", " ", " ", " ", " ", " display:flex;flex-direction:column;transform:rotate(45deg);"], border$1, color$3, flexbox, layout, position, space$5, shadow, background, transform$2));
var NotificationIndicator = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _useNotificationServi = useNotificationService(),
      isNotificationPaneOpen = _useNotificationServi.isNotificationPaneOpen,
      openNotificationPane = _useNotificationServi.openNotificationPane,
      closeNotificationPane = _useNotificationServi.closeNotificationPane,
      showNotificationDot = _useNotificationServi.showNotificationDot,
      hasAlerts = _useNotificationServi.hasAlerts,
      alerts = _useNotificationServi.alerts;

  var _useUserService = useUserService(),
      user = _useUserService.user;

  if (!_get(user, 'features.notifications')) {
    return null;
  }

  var toggleNotificationPane = function toggleNotificationPane() {
    if (isNotificationPaneOpen) {
      closeNotificationPane();
      return;
    }

    openNotificationPane();
  };

  return /*#__PURE__*/jsx$1(ErrorBoundary, {
    location: "notification-indicator",
    children: /*#__PURE__*/jsxs(_StyledButton$3, {
      ref: ref,
      alignItems: "center",
      ariaLabel: "Notification Toggle",
      height: "100%",
      id: "notification-toggle",
      justifyContent: "center",
      onClick: function onClick() {
        return toggleNotificationPane();
      },
      position: "relative",
      type: "button",
      children: [(showNotificationDot || hasAlerts) && /*#__PURE__*/jsx$1(Box$1, {
        bg: (alerts === null || alerts === void 0 ? void 0 : alerts.length) > 0 ? '#E62E31' : '#33CC99',
        borderRadius: "100%",
        height: ".8rem",
        position: "absolute",
        top: "50%",
        transform: "translate(1rem, -1rem)",
        width: ".8rem"
      }), /*#__PURE__*/jsx$1(Icon$2, {
        color: "black",
        height: "1.3rem",
        name: "notification",
        title: "notifications",
        titleId: "notificationsNavbar",
        width: "2rem"
      }), /*#__PURE__*/jsx$1(IndicatorBox, {
        animate: isNotificationPaneOpen ? 'visible' : 'hidden',
        bg: "greys.7",
        bottom: "-1rem",
        height: "2rem",
        id: "notification-pane-top",
        left: ".8rem",
        position: "absolute",
        transform: "rotate(45deg)",
        transition: {
          duration: 0.2
        },
        variants: indicatorVariants,
        width: "2rem"
      })]
    })
  });
});
NotificationIndicator.displayName = 'NotificationIndicator';
NotificationIndicator.defaultProps = {
  ref: null
};

var _StyledButton$3 = styled(Button$1).withConfig({
  displayName: "notification-indicator___StyledButton",
  componentId: "sc-z7zblr-1"
})(["", ""], buttonCss);

function ownKeys$8(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$8(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$8(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$8(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var NavigationContext = /*#__PURE__*/React__default.createContext();

function NavigationProvider(_ref) {
  var props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  var lastFocused;

  if (hasDOM) {
    lastFocused = document.activeElement;
  }

  var _useState = useState(''),
      _useState2 = _slicedToArray$4(_useState, 2),
      currentMenu = _useState2[0],
      setCurrentMenu = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray$4(_useState3, 2),
      openMenuGroup = _useState4[0],
      setOpenGroup = _useState4[1];

  var toggleMenu = function toggleMenu(menu, element) {
    if (element) {
      lastFocused = element;
    }

    if (currentMenu && menu === MENUS.main || currentMenu === menu) {
      setCurrentMenu();
    } else if (!menu) {
      lastFocused.focus();
      setCurrentMenu();
    } else if (currentMenu !== menu) {
      // Order is important here
      // User just clicked nav item and we must save focus before new menu opens
      lastFocused = document.activeElement;
      setCurrentMenu(menu);
    }
  };

  var onKeydown = function onKeydown(event) {
    if (event.key === 'Escape') {
      toggleMenu();
      lastFocused.focus();
    }
  };

  var onResize = function onResize() {
    toggleMenu();
  };

  useEffect(function () {
    if (Boolean(currentMenu) && hasDOM) {
      document.addEventListener('keydown', onKeydown);
      window.addEventListener('resize', onResize);
    }

    return function () {
      if (hasDOM) {
        document.removeEventListener('keydown', onKeydown);
        window.removeEventListener('resize', onResize);
      }
    };
  });

  var onMenuGroupToggle = function onMenuGroupToggle(menu) {
    setOpenGroup(openMenuGroup === menu ? '' : menu);
  };

  var value = useMemo(function () {
    return {
      onMenuGroupToggle: onMenuGroupToggle,
      toggleMenu: toggleMenu,
      currentMenu: currentMenu,
      openMenuGroup: openMenuGroup
    };
  }, [currentMenu, openMenuGroup]);
  return /*#__PURE__*/jsx$1(NavigationContext.Provider, _objectSpread$8({
    value: value
  }, props));
}

function useNavigationService() {
  var navigationCtx = React__default.useContext(NavigationContext);

  if (!navigationCtx) {
    throw new Error("useNavigationService must be used within an NavigationProvider");
  }

  return navigationCtx;
}

var _templateObject$4, _templateObject2$3;

var colors$9 = theme.colors,
    media$1 = theme.media;
var UserName = styled.span.withConfig({
  displayName: "accountstyles__UserName",
  componentId: "sc-8o9fwx-0"
})(["", " color:", ";text-align:left;text-transform:none;letter-spacing:1px;margin-top:0.2rem;", ""], function (_ref) {
  var truncate = _ref.truncate;
  return truncate && "\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    width: 9rem;\n    ";
}, isInternic ? 'blue' : colors$9.purpleDark, media$1.smallAndDown(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral$1(["\n    display: ", ";\n  "])), function (_ref2) {
  var noHide = _ref2.noHide;
  return !noHide && 'none';
}));
var MyAccount = styled.div.withConfig({
  displayName: "accountstyles__MyAccount",
  componentId: "sc-8o9fwx-1"
})(["text-transform:uppercase;font-weight:600;color:", ";", ""], isInternic ? 'blue' : colors$9.purpleDark, media$1.smallAndDown(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral$1(["\n    display: none;\n  "]))));

function AccountMenuButton() {
  var _useState = useState(false),
      _useState2 = _slicedToArray$4(_useState, 2),
      hasMounted = _useState2[0],
      setHasMounted = _useState2[1];

  var _useUserService = useUserService(),
      userName = _useUserService.userName,
      openUserAuthModal = _useUserService.openUserAuthModal;

  var _useNavigationService = useNavigationService(),
      toggleMenu = _useNavigationService.toggleMenu;

  useEffect(function () {
    setHasMounted(true);
  }, []);

  if (!hasMounted) {
    return null;
  }

  var toggleHandler = function toggleHandler() {
    toggleMenu(MENUS.myaccount);
  };

  var handleClick = function handleClick() {
    if (userName) {
      toggleHandler();
    } else {
      toggleMenu();
      openUserAuthModal(AUTH_VIEW_STATES.LOGIN_VIEW);
    }
  };

  var getButtonContent = function getButtonContent() {
    if (userName) {
      return /*#__PURE__*/jsxs(Stack$2, {
        position: "relative",
        children: [/*#__PURE__*/jsx$1(MyAccount, {
          children: "My Account"
        }), /*#__PURE__*/jsx$1(UserName, {
          "data-ls-disabled": true,
          truncate: true,
          children: userName
        }), /*#__PURE__*/jsx$1(Icon$2, {
          display: ['block', 'none'],
          mx: 2,
          name: "account",
          title: "Account",
          titleId: "userAccountIcon"
        })]
      });
    }

    return /*#__PURE__*/jsx$1(Text$1, {
      fontWeight: "bold",
      minWidth: "43px",
      children: "Sign In"
    });
  };

  var display = 'flex';

  if (userName) {
    display = 'none';
  }

  return /*#__PURE__*/jsx$1("li", {
    children: /*#__PURE__*/jsx$1(Box$1, {
      alignItems: "center",
      "data-testid": "account-menu-btn",
      display: [display, display, display, 'flex'],
      flexDirection: "column",
      height: "100%",
      justifyContent: "center",
      ml: 1,
      children: /*#__PURE__*/jsx$1(Button$1, {
        bg: "white",
        color: isInternic ? 'blueDark' : 'purpleDark',
        id: userName ? 'account-menu' : 'sign-in',
        justifyContent: "center",
        onClick: handleClick,
        px: [2, 3],
        rel: "nofollow",
        type: "button",
        variant: "inverse",
        children: getButtonContent()
      })
    })
  });
}

var _templateObject$3, _templateObject2$2, _templateObject3$2, _templateObject4;

var borders = theme.borders,
    colors$8 = theme.colors,
    focus = theme.focus,
    zIndices = theme.zIndices,
    media = theme.media;
var NavList = styled.ul.withConfig({
  displayName: "headerstyles__NavList",
  componentId: "sc-1pl68ct-0"
})(["display:flex;align-items:center;position:relative;background:inherit;margin-left:1rem;margin-right:1rem;z-index:", ";height:100%;& > *{height:100%;}", ";"], zIndices.navbar, media.mediumAndDown(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral$1(["\n    margin-left: auto;\n    margin-right: 0.3rem;\n  "]))));
var NavItem = styled.li.withConfig({
  displayName: "headerstyles__NavItem",
  componentId: "sc-1pl68ct-1"
})(["padding-left:1.5rem;padding-right:1.5rem;display:flex;align-items:center;height:100%;color:", ";transition:all 0.2s;"], colors$8.black);
var RightNavItem = styled(NavItem).withConfig({
  displayName: "headerstyles__RightNavItem",
  componentId: "sc-1pl68ct-2"
})(["padding-left:1rem;padding-right:1rem;", ";", ";"], media.mediumAndUp(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral$1(["\n    justify-self: flex-end;\n  "]))), media.mediumAndDown(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral$1(["\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  "]))));
styled(NavItem).withConfig({
  displayName: "headerstyles__LeftNavItem",
  componentId: "sc-1pl68ct-3"
})(["", ";&:first-child{border-right:", ";}"], media.mediumAndUp(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral$1(["\n    justify-self: flex-start;\n  "]))), borders.whiteDark);
var HomeLink = styled.a.withConfig({
  displayName: "headerstyles__HomeLink",
  componentId: "sc-1pl68ct-4"
})(["display:flex;justify-content:center;align-items:center;&:focus{", "}"], focus.style);
var NavLink = styled.a.withConfig({
  displayName: "headerstyles__NavLink",
  componentId: "sc-1pl68ct-5"
})(["transition:all 0.2s;color:", ";text-transform:uppercase;height:100%;display:flex;align-items:center;font-size:", ";font-weight:", ";&:active,&:visited{text-decoration:none;}&:focus{", "}"], colors$8.black, theme.textVariants.mega.fontSize, theme.textVariants.mega.fontWeight, focus.style);
var NavIconLink = styled(NavLink).withConfig({
  displayName: "cart__NavIconLink",
  componentId: "sc-tp29w6-0"
})(["padding-bottom:0;position:relative;width:2.5rem;"]);
var colors$7 = theme.colors;

function Cart() {
  var title = "Go to shopping cart";

  var _useState = useState(0),
      _useState2 = _slicedToArray$4(_useState, 2),
      count = _useState2[0],
      setCount = _useState2[1];

  useEffect(function () {
    var cartPolling = setInterval(function () {
      setCount(LS.getItem(storageKeys.OrderItems));
    }, 1000);
    return function () {
      clearInterval(cartPolling);
    };
  }, []);
  var link = '/MyAccount/ShoppingCart.aspx';
  var features = LS.getItem(storageKeys.Features);

  if (features !== null && features !== void 0 && features.checkoutredesign) {
    link = '/checkout';
  }

  var hideIconPaths = ['/search', '/search/'];

  if (hasDOM && hideIconPaths.includes(window.location.pathname)) {
    return null;
  }

  return /*#__PURE__*/jsxs(NavIconLink, {
    "aria-label": title,
    href: link,
    title: title,
    children: [/*#__PURE__*/jsx$1(Icon$2, {
      color: "black",
      name: "cart",
      title: "Cart",
      titleId: "cartIcon",
      verticalAlign: "middle",
      width: "1.5rem"
    }), count > 0 && /*#__PURE__*/jsx$1(Box$1, {
      "align-items": "center",
      bg: "blackLight",
      border: "1px solid ".concat(colors$7.white),
      borderRadius: "50%",
      color: "white",
      height: "2rem",
      justifyContent: "center",
      position: "absolute",
      right: "0",
      top: "2rem",
      width: "2rem",
      children: /*#__PURE__*/jsx$1(Text$1, {
        alignSelf: "center",
        letterSpacing: "0px",
        textAlign: "center",
        variant: "poundBold",
        children: count > 9 ? '9+' : count
      })
    })]
  });
}

var propTypes$3 = {
  ariaLabel: PropTypes$1.string.isRequired,
  children: PropTypes$1.oneOfType([PropTypes$1.node, PropTypes$1.string]).isRequired,
  menu: PropTypes$1.string
};
var defaultProps$2 = {
  menu: null
};

function DesktopNavButton(_ref) {
  var children = _ref.children,
      menu = _ref.menu,
      ariaLabel = _ref.ariaLabel;
  var buttonRef = useRef();

  var _useNavigationService = useNavigationService(),
      currentMenu = _useNavigationService.currentMenu,
      toggleMenu = _useNavigationService.toggleMenu;

  var isActive = menu && menu === currentMenu;

  var onToggle = function onToggle() {
    toggleMenu(isActive ? null : menu, buttonRef.current);
  };

  return /*#__PURE__*/jsx$1(_StyledButton$2, {
    ref: buttonRef,
    ariaLabel: ariaLabel,
    color: "black",
    height: "100%",
    onClick: onToggle,
    variant: "minimal",
    $_css: isActive ? 'text-decoration: underline;' : '',
    children: /*#__PURE__*/jsx$1(Text$1, {
      variant: "mega",
      children: children
    })
  });
}

DesktopNavButton.propTypes = propTypes$3;
DesktopNavButton.defaultProps = defaultProps$2;

var _StyledButton$2 = styled(Button$1).withConfig({
  displayName: "desktop-nav-button___StyledButton",
  componentId: "sc-g8hx0r-0"
})(["&:hover{text-decoration:underline;}", ""], function (p) {
  return p.$_css;
});

function ownKeys$7(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$7(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$7(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$7(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var colors$6 = theme.colors;

var renderSSOList = function renderSSOList(ssoUserList, onSSOLogin) {
  if (!ssoUserList || ssoUserList.length === 0) {
    return null;
  }

  return /*#__PURE__*/jsx$1(Stack$2, {
    alignItems: "flex-start",
    as: "ul",
    mt: 4,
    children: ssoUserList.map(function (_ref) {
      var UserLogin = _ref.UserLogin,
          ResellerName = _ref.ResellerName,
          UserID = _ref.UserID;
      return /*#__PURE__*/jsx$1(Box$1, {
        as: "li",
        children: /*#__PURE__*/jsx$1(Button$1, {
          color: "white",
          onClick: function onClick() {
            onSSOLogin(UserID);
          },
          rel: "nofollow",
          variant: "minimal",
          children: /*#__PURE__*/jsx$1(_StyledText$2, {
            color: "greyLight",
            $_css: colors$6.whiteDark,
            children: "".concat(UserLogin, " - ").concat(ResellerName)
          })
        })
      }, "ssoUser-".concat(UserID));
    })
  });
};

function Account(props) {
  var _useUserService = useUserService(),
      onLogout = _useUserService.onLogout,
      onSSOLogin = _useUserService.onSSOLogin,
      userName = _useUserService.userName,
      ssoUserList = _useUserService.ssoUserList;

  var _useNavigationService = useNavigationService(),
      currentMenu = _useNavigationService.currentMenu,
      toggleMenu = _useNavigationService.toggleMenu;

  var handleLogout = function handleLogout() {
    toggleMenu();
    onLogout();
  };

  if (currentMenu !== MENUS.myaccount) {
    return null;
  }

  return /*#__PURE__*/jsxs(Stack$2, _objectSpread$7(_objectSpread$7({}, props), {}, {
    children: [/*#__PURE__*/jsxs(Stack$2, {
      alignItems: ['flex-start', 'flex-start', 'flex-start', 'flex-end'],
      children: [/*#__PURE__*/jsx$1(Text$1, {
        color: "black",
        "data-ls-disabled": true,
        children: userName
      }), /*#__PURE__*/jsx$1(Button$1, {
        ariaLabel: "log out",
        color: "black",
        id: "logout",
        onClick: handleLogout,
        title: "Log out",
        variant: "minimal",
        children: "Log out"
      })]
    }), renderSSOList(ssoUserList, onSSOLogin)]
  }));
}

var _StyledText$2 = styled(Text$1).withConfig({
  displayName: "account___StyledText",
  componentId: "sc-nmfett-0"
})(["transition:all 0.2s linear;&:hover{color:", ";text-decoration:underline;}"], function (p) {
  return p.$_css;
});

var _templateObject$2, _templateObject2$1, _templateObject3$1;

var colors$5 = theme.colors,
    space = theme.space;
var helpSection = OrderStrings.purchaseFlow.helpSection;
css$3(["& > *:not(:last-child){margin-bottom:", ";}"], space.regular);
var hover = css$3(["&:hover,&:focus{text-decoration:underline;}"]);
var link = css$3(["display:flex;align-items:center;font-size:1.4rem;letter-spacing:1px;transition:all 0.2s;&,&:link,&:visited{color:", ";}&:hover,&:focus{color:", ";text-decoration:underline;}", ""], function (_ref) {
  var variant = _ref.variant;
  return variant === 'dark' ? "".concat(colors$5.white) : "".concat(colors$5.blackLight);
}, function (_ref2) {
  var variant = _ref2.variant;
  return variant === 'dark' ? "".concat(colors$5.white) : "".concat(colors$5.black);
}, function (_ref3) {
  var highlight = _ref3.highlight,
      variant = _ref3.variant;

  if (highlight) {
    return variant === 'dark' ? "\n            color: ".concat(colors$5.white, " !important\n            font-weight: 600;\n          ") : "\n            color: ".concat(colors$5.green, " !important;\n            font-weight: 600;\n          ");
  }

  return '';
});

function Support() {
  var track = trackLink({
    eventName: 'Navigation',
    location: 'header'
  });

  var _useSunshine = useSunshine(),
      openChat = _useSunshine.openChat;

  var onChatClick = function onChatClick() {
    if (hasDOM && openChat) {
      openChat();
    }
  };

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1(Box$1, {
      alignItems: "center",
      py: 2,
      children: /*#__PURE__*/jsxs(_StyledLink$3, {
        ariaLabel: "Help Center",
        display: "flex",
        fontSize: "1.4rem",
        fontWeight: "regular",
        href: isInternic ? "https://support.internic.ca" : "https://support.rebel.com",
        py: 2,
        title: "Help Center",
        variant: "light",
        children: [/*#__PURE__*/jsx$1(Icon$2, {
          height: "2rem",
          mr: space.regular,
          name: "assisted",
          title: "HelpCenter",
          titleId: "HelpCenterIcon",
          width: "2rem"
        }), "Help Center"]
      })
    }), /*#__PURE__*/jsx$1(Box$1, {
      alignItems: "center",
      py: 2,
      children: /*#__PURE__*/jsxs(_StyledButton$1, {
        alignItems: "center",
        ariaLabel: "Chat with us",
        highlight: true,
        id: "support-chat",
        onClick: function onClick() {
          onChatClick();
          track('support-chat');
        },
        title: helpSection.chatTitle,
        variant: "minimal",
        children: [/*#__PURE__*/jsx$1(Icon$2, {
          color: "black",
          height: "2rem",
          mr: space.regular,
          name: "chat",
          title: "Chat",
          titleId: "supportChatIcon-menu",
          width: "2rem"
        }), /*#__PURE__*/jsxs(_StyledText$1, {
          alignItems: "center",
          color: isInternic ? 'blueDark' : 'orangeDark',
          display: "flex",
          fontSize: "1.4rem",
          fontWeight: "bold",
          children: [/*#__PURE__*/jsx$1(Text$1, {
            mr: space.quarter,
            textTransform: "uppercase",
            children: helpSection.liveChat
          }), /*#__PURE__*/jsx$1(Text$1, {
            fontSize: "1.2rem",
            children: helpSection.officeHours
          })]
        })]
      })
    }), /*#__PURE__*/jsx$1(Box$1, {
      alignItems: "center",
      py: 2,
      children: /*#__PURE__*/jsxs(_StyledLink2$1, {
        ariaLabel: "Call us",
        display: "flex",
        fontSize: "1.4rem",
        fontWeight: "regular",
        href: "tel:".concat(SUPPORT_STRINGS.phone),
        onClick: function onClick() {
          track('support-phone');
        },
        py: 2,
        title: helpSection.phoneTitle,
        variant: "light",
        children: [/*#__PURE__*/jsx$1(Icon$2, {
          height: "2rem",
          mr: space.regular,
          name: "phone",
          title: "phone",
          titleId: "phoneIcon",
          width: "2rem"
        }), /*#__PURE__*/jsx$1(Text$1, {
          mr: space.quarter,
          children: SUPPORT_STRINGS.phone
        }), /*#__PURE__*/jsx$1(Text$1, {
          fontSize: "1.2rem",
          children: "(9am-5pm EST daily)"
        })]
      })
    }), /*#__PURE__*/jsxs(Box$1, {
      alignItems: "center",
      py: 2,
      children: [/*#__PURE__*/jsx$1(Icon$2, {
        height: "2rem",
        mr: space.regular,
        name: "email",
        title: "email",
        titleId: "emailIcon",
        width: "2rem"
      }), /*#__PURE__*/jsx$1(InfoCollectorModal, {
        id: "contact_modal_navigation",
        fields: [{
          id: 'name',
          display: 'Full name',
          required: true
        }, {
          id: 'email',
          display: 'Primary Email address',
          type: 'email',
          required: true
        }, {
          id: 'domainService',
          display: 'Domain or Service',
          required: false
        }, {
          id: 'message',
          display: 'Comments',
          required: true,
          type: 'textarea'
        }],
        btnProps: {
          width: '50%',
          color: 'purpleDark'
        },
        source: "support-nav",
        successMessage: "Thanks! We'll contact you within 24 hours.",
        errorMessage: "Something went wrong.",
        title: "We're here to help! Ready to chat? Give us a few details so we know where to start",
        buttonText: "Email Us"
      })]
    })]
  });
}

var _StyledLink$3 = styled(Link$1)(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral$1(["", ""])), link);

var _StyledButton$1 = styled(Button$1)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral$1(["\n            justify-content: flex-start;\n            padding: 0;\n          "])));

var _StyledText$1 = styled(Text$1)(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral$1(["", ""])), hover);

var _StyledLink2$1 = styled(Link$1).withConfig({
  displayName: "support___StyledLink2",
  componentId: "sc-zr3yq-0"
})(["", ""], link);

var getDisplayName = function getDisplayName(user) {
  var firstName = _get(user, 'firstname');

  var lastName = _get(user, 'lastname');

  var userName = _get(user, 'userName');

  var displayName = '';

  if (firstName) {
    displayName = "".concat(firstName, " ").concat(lastName ? lastName.charAt(0) : '');
  } else {
    displayName = userName;
  }

  return displayName;
};

var getTabIndex = function getTabIndex(isOpen) {
  var isTabbable = isOpen && (!isMobile || isMobile && isOpen);
  return isTabbable ? '0' : '-1';
};

var getMenuData = function getMenuData(menuName) {
  if (!menuName) {
    return [];
  }

  switch (menuName) {
    case MENUS.myaccount:
      return ACCOUNT_MENU;

    case MENUS.mobile:
      return MOBILE_NAV_MENUS;

    default:
      return [];
  }
};

var formatMenuGroupTitle = function formatMenuGroupTitle(menuName) {
  if (!menuName) {
    return [];
  }

  switch (menuName) {
    case MENUS.hosting:
      return 'Hosting & Websites';

    case MENUS.myaccount:
      return 'My Account';

    case MENUS.mydomains:
      return 'My Domains';

    case MENUS.myhosting:
      return 'My Hosting';

    default:
      return menuName;
  }
};

var _templateObject$1;

var _excluded = ["currentMenu"];

function ownKeys$6(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$6(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$6(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$6(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var propTypes$2 = {
  currentMenu: PropTypes.string
};
var defaultProps$1 = {
  currentMenu: null
};
var colors$4 = theme.colors;

function DesktopMenu(_ref) {
  var currentMenu = _ref.currentMenu,
      rest = _objectWithoutProperties$8(_ref, _excluded);

  var menuColumns;
  var menuGroups;

  if (currentMenu === MENUS.myaccount) {
    menuGroups = ACCOUNT_MENU;
  } else {
    menuColumns = NAV_MENUS[currentMenu];

    if (menuColumns) {
      menuColumns = menuColumns.filter(function (i) {
        return typeof i.hide === 'undefined' || i.hide === false;
      });
    }
  }

  var isSupport = currentMenu === 'support';
  var mainGridTemplate = isSupport ? {
    gridTemplateColumns: '2fr 1fr'
  } : {};
  var track = trackLink({
    eventName: 'Navigation',
    location: 'header'
  });
  return /*#__PURE__*/jsxs(Box$1, _objectSpread$6(_objectSpread$6({
    justifyContent: "center",
    px: 4
  }, rest), {}, {
    children: [menuColumns && /*#__PURE__*/jsxs(Grid$1, _objectSpread$6(_objectSpread$6({
      my: 4
    }, mainGridTemplate), {}, {
      children: [isSupport && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx$1(Text$1, {
          color: "black",
          my: "3",
          variant: "gigaBold",
          children: "Resources"
        }), /*#__PURE__*/jsx$1(Text$1, {
          color: "black",
          my: "3",
          variant: "gigaBold",
          children: "Award Winning Support"
        })]
      }), /*#__PURE__*/jsx$1(Box$1, {
        children: menuColumns.map(function (col, idx) {
          return /*#__PURE__*/jsx$1(Stack$2, {
            children: col.map(function (_ref2) {
              var display = _ref2.display,
                  url = _ref2.url,
                  hide = _ref2.hide,
                  applySale = _ref2.applySale,
                  applyNew = _ref2.applyNew;
              return hide ? null : /*#__PURE__*/jsxs(Box$1, {
                flexDirection: "row",
                children: [currentMenu !== MENUS.support && /*#__PURE__*/jsxs(Box$1, {
                  alignSelf: "center",
                  justifyContent: "center",
                  mx: 1,
                  width: "4rem",
                  children: [subMenuHasSale(applySale) && makeTag('orange', 'SALE'), subMenuHasNew(applyNew) && makeTag('#01CBCF', 'NEW')]
                }), /*#__PURE__*/jsx$1(Box$1, {
                  alignItems: "center",
                  mr: 5,
                  py: 2,
                  children: /*#__PURE__*/jsx$1(_StyledLink$2, {
                    ariaLabel: display,
                    color: "black",
                    href: url,
                    onClick: function onClick(e) {
                      return track(e);
                    },
                    textAlign: "left",
                    $_css: colors$4.purpleDark,
                    children: /*#__PURE__*/jsx$1(Text$1, {
                      variant: "mega",
                      children: display
                    })
                  })
                }, display)]
              });
            })
          }, "col-".concat(idx));
        })
      }), isSupport && /*#__PURE__*/jsx$1(Grid$1, {
        children: /*#__PURE__*/jsx$1(Support, {})
      })]
    })), menuGroups && Object.keys(menuGroups).map(function (groupName) {
      return /*#__PURE__*/jsxs(Box$1, {
        as: "ul",
        display: "block",
        listStyle: "none",
        mx: "regular",
        my: 4,
        children: [/*#__PURE__*/jsx$1(Heading, {
          as: "h2",
          color: colors$4.black,
          fontSize: "1.6rem",
          fontWeight: "semi",
          lineHeight: "2rem",
          mb: 2,
          onClick: function onClick(e) {
            return track(e);
          },
          textTransform: "capitalize",
          children: formatMenuGroupTitle(groupName)
        }), menuGroups[groupName].map(function (col) {
          return col.map(function (_ref3) {
            var display = _ref3.display,
                url = _ref3.url,
                hide = _ref3.hide,
                applyNew = _ref3.applyNew;
            return hide ? '' : /*#__PURE__*/jsxs(Box$1, {
              as: "li",
              position: "relative",
              children: [subMenuHasNew(applyNew) && makeTag('#01CBCF', 'NEW'), /*#__PURE__*/jsx$1(_StyledLink2, {
                ariaLabel: display,
                color: "black",
                href: url,
                mr: 4,
                my: 2,
                onClick: function onClick(e) {
                  return track(e);
                },
                textAlign: "left",
                $_css2: colors$4.purpleDark,
                children: /*#__PURE__*/jsx$1(Text$1, {
                  variant: "mega",
                  children: display
                })
              })]
            }, "".concat(groupName, "-").concat(display));
          });
        })]
      }, groupName);
    })]
  }));
}

DesktopMenu.propTypes = propTypes$2;
DesktopMenu.defaultProps = defaultProps$1;

var _StyledLink$2 = styled(Link$1)(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral$1(["\n                            &:hover,\n                            &:active {\n                              color: ", ";\n                            }\n                          "])), function (p) {
  return p.$_css;
});

var _StyledLink2 = styled(Link$1).withConfig({
  displayName: "desktop-menu___StyledLink2",
  componentId: "sc-1yreb08-0"
})(["&:hover,&:active{color:", ";}"], function (p) {
  return p.$_css2;
});

function ownKeys$5(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$5(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$5(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$5(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var colors$3 = theme.colors,
    shadows$1 = theme.shadows;
var transform$1 = system({
  transform: true
});
var paneVariants$1 = {
  visible: {
    y: 0,
    opacity: 1
  },
  hidden: {
    y: 'calc(0vh - 100%)',
    opacity: 0
  }
};
var DesktopMenuPaneStack = motion.custom(styled.div.withConfig({
  displayName: "desktop-menu-pane__DesktopMenuPaneStack",
  componentId: "sc-1y3iu21-0"
})(["", " ", " ", " ", " ", " ", " ", " ", " ", " flex-direction:column;z-index:99;align-items:stretch;justify-content:flex-start;overflow:hidden;position:absolute;left:0;right:0;top:0;width:100vw;z-index:-1;padding-top:8rem;box-shadow:", ";"], border$1, color$3, flexbox, layout, position, space$5, shadow, background, transform$1, shadows$1[0]));
var DesktopMenuPane = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _useNavigationService = useNavigationService(),
      currentMenu = _useNavigationService.currentMenu;

  useTabTrapper(ref, [currentMenu], null);
  return (
    /*#__PURE__*/
    // <OutsideClickDetector onOutsideClick={toggleMenu}>
    jsx$1(DesktopMenuPaneStack, _objectSpread$5(_objectSpread$5({
      ref: ref
    }, props), {}, {
      animate: currentMenu ? 'visible' : 'hidden',
      bg: "white",
      display: ['none', 'none', 'flex'],
      transition: {
        opacity: {
          duration: 0.1
        },
        y: {
          duration: 0.2
        }
      },
      variants: paneVariants$1,
      children: /*#__PURE__*/jsxs(Stack$2, {
        borderTop: "1px solid ".concat(colors$3.greyLight),
        children: [/*#__PURE__*/jsx$1(Box$1, {
          justifyContent: ['flex-start', 'flex-end'],
          mr: 4,
          children: /*#__PURE__*/jsx$1(Account, {
            mt: 4,
            mx: 4
          })
        }), /*#__PURE__*/jsx$1(DesktopMenu, {
          currentMenu: currentMenu,
          display: "flex"
        })]
      })
    })) // </OutsideClickDetector>

  );
});
DesktopMenuPane.displayName = 'DesktopMenuPane';
var colors$2 = theme.colors,
    shadows = theme.shadows;
var transform = system({
  transform: true
});
var MobileMenuPanBox = motion.custom(styled.div.withConfig({
  displayName: "mobile-menustyles__MobileMenuPanBox",
  componentId: "sc-7l3emq-0"
})(["", " ", " ", " ", " ", " ", " ", " ", " ", " background-color:", ";display:flex;flex-direction:row;overflow:auto;z-index:-1;padding-top:8rem;height:100vh;max-height:calc(100vh);box-shadow:", ";"], border$1, color$3, flexbox, layout, position, space$5, shadow, background, transform, colors$2.white, shadows[0]));
var paneVariants = {
  visible: {
    y: 0,
    opacity: 1
  },
  hidden: {
    y: 'calc(0vh - 100%)',
    opacity: 0
  }
};
var mobilePaneVariants = {
  show: {
    x: '-110vw'
  },
  hide: {
    x: '0'
  }
};
var MobileMenuPaneStack = motion.custom(styled.div.withConfig({
  displayName: "mobile-menustyles__MobileMenuPaneStack",
  componentId: "sc-7l3emq-1"
})(["", " ", " ", " ", " ", " ", " ", " ", " ", " display:flex;border:none;background-color:", ";z-index:-1;position:absolute;left:0;top:0;box-shadow:", ";"], border$1, color$3, flexbox, layout, position, space$5, shadow, background, transform, colors$2.blackLight, shadows[0]));

var _templateObject, _templateObject2, _templateObject3;

function ownKeys$4(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$4(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$4(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var fonts = redesignTheme.fonts;
var colors$1 = theme.colors;
var menuItemPropTypes = {
  children: PropTypes.node.isRequired,
  hide: PropTypes.bool,
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  url: PropTypes.bool
};
var defaultMenuItemPropTypes = {
  hide: false,
  url: false
};

function MenuItem(_ref) {
  var id = _ref.id,
      children = _ref.children,
      onClick = _ref.onClick,
      url = _ref.url,
      hide = _ref.hide;

  if (hide) {
    return null;
  }

  return /*#__PURE__*/jsx$1(Box$1, {
    as: "li",
    children: /*#__PURE__*/jsxs(Link$1, {
      ariaLabel: id,
      color: "black",
      display: "inline-flex",
      href: url,
      mb: 3,
      onClick: onClick,
      variant: "minimal",
      children: [/*#__PURE__*/jsxs(Text$1, {
        display: "flex",
        flexDirection: "row",
        fontFamily: fonts.title,
        textTransform: "uppercase",
        variant: "megaBold",
        children: [children, mainMenuHasTag(id, 'applySale') && makeTag('orange', 'SALE'), mainMenuHasTag(id, 'applyNew') && makeTag('#01CBCF', 'NEW')]
      }), id !== MENUS.seo && /*#__PURE__*/jsx$1(_StyledIcon, {
        name: "arrow-right",
        title: "back"
      })]
    })
  });
}

MenuItem.propTypes = menuItemPropTypes;
MenuItem.defaultProps = defaultMenuItemPropTypes;
var userMenuProps = {
  onItemClick: PropTypes.func.isRequired
};

function UserMainMenu(_ref2) {
  var onItemClick = _ref2.onItemClick;

  var _useUserService = useUserService(),
      user = _useUserService.user,
      onLogout = _useUserService.onLogout,
      onSSOLogin = _useUserService.onSSOLogin,
      ssoUserList = _useUserService.ssoUserList;

  var displayName = getDisplayName(user);

  if (!user) {
    return null;
  }

  return /*#__PURE__*/jsxs(Stack$2, {
    as: "ul",
    pb: 3,
    pl: 4,
    pt: 4,
    width: "110vw",
    children: [/*#__PURE__*/jsx$1(Text$1, {
      pb: 3,
      textTransform: "uppercase",
      variant: "milli",
      children: "My Account"
    }), Object.keys(ACCOUNT_MENU).map(function (key) {
      var handler = function handler() {
        return onItemClick(key, MENUS.myaccount, formatMenuGroupTitle(key));
      };

      return /*#__PURE__*/jsx$1(MenuItem, {
        hide: false,
        id: key,
        onClick: handler,
        type: MENUS.myaccount,
        url: false,
        children: formatMenuGroupTitle(key)
      }, key);
    }), /*#__PURE__*/jsx$1(Text$1, {
      pt: 3,
      variant: "mega",
      children: displayName
    }), ssoUserList && ssoUserList.length > 0 && /*#__PURE__*/jsx$1(Box$1, {
      mb: 4,
      children: renderSSOList(ssoUserList, onSSOLogin)
    }), /*#__PURE__*/jsx$1(Box$1, {
      justifyContent: "left",
      pt: 1,
      children: /*#__PURE__*/jsx$1(Button$1, {
        ariaLabel: "log out",
        color: "black",
        id: "account-logout",
        onClick: function onClick() {
          return onLogout();
        },
        title: "Log Out",
        variant: "link",
        children: "Log out"
      })
    })]
  });
}

UserMainMenu.propTypes = userMenuProps;
var backButtonProps = {
  onClick: PropTypes.func.isRequired
};

function BackButton(_ref3) {
  var onClick = _ref3.onClick;
  return /*#__PURE__*/jsx$1(Box$1, {
    alignItems: "flex-start",
    justifyContent: "center",
    children: /*#__PURE__*/jsx$1(_StyledButton, {
      height: "100%",
      id: "mobile-menu-back",
      onClick: onClick,
      type: "button",
      variant: "minimal",
      width: "5rem",
      children: /*#__PURE__*/jsx$1(Stack$2, {
        height: "100%",
        justifyContent: "flex-start",
        pt: 4,
        children: /*#__PURE__*/jsx$1(_StyledIcon2, {
          name: "arrow-right",
          title: "back"
        })
      })
    })
  });
}

function SubMenuOptions(props) {
  var closeSubMenu = props.closeSubMenu,
      subMenu = props.subMenu,
      track = props.track;
  return /*#__PURE__*/jsxs(Box$1, {
    borderTop: "light",
    children: [/*#__PURE__*/jsx$1(BackButton, {
      onClick: closeSubMenu
    }), /*#__PURE__*/jsxs(Stack$2, {
      as: "ul",
      borderLeft: "light",
      pb: 3,
      pl: 3,
      pt: 4,
      width: "110vw",
      children: [/*#__PURE__*/jsx$1(Heading, {
        "aria-label": subMenu.key,
        color: "black",
        mb: 3,
        mr: 3,
        tabIndex: getTabIndex(subMenu),
        textTransform: "capitalize",
        variant: "megaBold",
        children: formatMenuGroupTitle(subMenu.key)
      }), subMenu.items && subMenu.items.map(function (col) {
        return col.map(function (_ref4) {
          var display = _ref4.display,
              url = _ref4.url,
              hide = _ref4.hide,
              applySale = _ref4.applySale,
              applyNew = _ref4.applyNew;
          return hide ? '' : /*#__PURE__*/jsxs(Box$1, {
            as: "li",
            mb: 2,
            children: [/*#__PURE__*/jsx$1(_StyledLink$1, {
              ariaLabel: display,
              href: url,
              onClick: function onClick(e) {
                return track(e);
              },
              $_css: colors$1.purpleDark,
              children: /*#__PURE__*/jsx$1(Text$1, {
                color: "black",
                variant: "kilo",
                children: display
              })
            }), subMenuHasSale(applySale) && makeTag('orange', 'SALE'), subMenuHasNew(applyNew) && makeTag('#01CBCF', 'NEW')]
          }, display);
        });
      })]
    })]
  });
}

BackButton.propTypes = backButtonProps;

function MobileMenu(props) {
  var _useNavigationService = useNavigationService(),
      currentMenu = _useNavigationService.currentMenu;

  var _useState = useState({}),
      _useState2 = _slicedToArray$4(_useState, 2),
      subMenu = _useState2[0],
      setSubMenu = _useState2[1];

  var track = trackLink({
    eventName: 'Navigation',
    location: 'header'
  });

  var openSubMenu = function openSubMenu(name, menuType, title) {
    setSubMenu({
      key: name,
      items: getMenuData(menuType)[name],
      title: title
    });
  };

  var closeSubMenu = function closeSubMenu() {
    return setSubMenu({});
  };

  if (currentMenu !== MENUS.mobile) {
    return null;
  }

  return /*#__PURE__*/jsxs(MobileMenuPanBox, _objectSpread$4(_objectSpread$4({
    animate: subMenu.key ? 'show' : 'hide',
    flex: "1",
    transition: {
      duration: 0.2
    },
    variants: mobilePaneVariants
  }, props), {}, {
    children: [/*#__PURE__*/jsxs(Box$1, {
      flexDirection: "column",
      children: [/*#__PURE__*/jsx$1(Stack$2, {
        as: "ul",
        borderTop: "light",
        pb: 3,
        pl: 4,
        pt: 4,
        width: "110vw",
        children: Object.keys(MOBILE_NAV_MENUS).map(function (key) {
          var title = formatMenuGroupTitle(key);
          var handler = key === MENUS.seo ? track : function () {
            return openSubMenu(key, MENUS.mobile, title);
          };

          var _ref5 = key === MENUS.seo ? MOBILE_NAV_MENUS[key] : {
            url: false,
            hide: false
          },
              url = _ref5.url,
              hide = _ref5.hide;

          return /*#__PURE__*/jsx$1(MenuItem, {
            hide: hide,
            id: key,
            onClick: handler,
            type: MENUS.mobile,
            url: url,
            children: formatMenuGroupTitle(title)
          }, key);
        })
      }), /*#__PURE__*/jsx$1(UserMainMenu, {
        onItemClick: function onItemClick(key, menuType, title) {
          return openSubMenu(key, menuType, title);
        }
      })]
    }), /*#__PURE__*/jsx$1(SubMenuOptions, {
      closeSubMenu: closeSubMenu,
      subMenu: subMenu,
      track: track
    })]
  }));
}

var _StyledIcon = styled(Icon$2)(_templateObject || (_templateObject = _taggedTemplateLiteral$1(["\n              left: 90vw;\n              position: absolute;\n            "])));

var _StyledButton = styled(Button$1)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral$1(["\n          padding: 0;\n          color: black;\n        "])));

var _StyledIcon2 = styled(Icon$2)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral$1(["\n              transform: rotate(180deg);\n            "])));

var _StyledLink$1 = styled(Link$1).withConfig({
  displayName: "mobile-menu___StyledLink",
  componentId: "sc-1azdlb3-0"
})(["&:hover{color:", ";}"], function (p) {
  return p.$_css;
});

var colors = theme.colors;

function MobileSupportMenu() {
  var track = trackLink({
    eventName: 'Navigation',
    location: 'header'
  });
  return /*#__PURE__*/jsxs(Stack$2, {
    alignItems: "flex-start",
    bg: "white",
    display: ['flex', 'flex', 'flex', 'none'],
    mt: "6rem",
    pb: 3,
    pl: 5,
    pt: 4,
    width: "100vw",
    children: [/*#__PURE__*/jsx$1(Stack$2, {
      borderBottom: "1px solid ".concat(colors.greyLight),
      pb: 3,
      children: /*#__PURE__*/jsx$1(Support, {})
    }), /*#__PURE__*/jsx$1(Stack$2, {
      mt: 3,
      children: SUPPORT.map(function (col) {
        return col.map(function (_ref) {
          var display = _ref.display,
              url = _ref.url,
              hide = _ref.hide;
          return hide ? '' : /*#__PURE__*/jsx$1(Box$1, {
            as: "li",
            mb: 2,
            children: /*#__PURE__*/jsx$1(_StyledLink, {
              ariaLabel: display,
              color: "black",
              href: url,
              onClick: function onClick(e) {
                return track(e);
              },
              $_css: colors.purpleDark,
              children: display
            })
          }, display);
        });
      })
    })]
  });
}

var _StyledLink = styled(Link$1).withConfig({
  displayName: "mobile-support-menu___StyledLink",
  componentId: "sc-14srpw0-0"
})(["&:hover{color:", ";}"], function (p) {
  return p.$_css;
});

function ownKeys$3(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$3(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$3(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var MobileMenuPane = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _useNavigationService = useNavigationService(),
      currentMenu = _useNavigationService.currentMenu;

  useTabTrapper(Reflect, [], null);
  return /*#__PURE__*/jsxs(MobileMenuPaneStack, _objectSpread$3(_objectSpread$3({}, props), {}, {
    ref: ref,
    animate: currentMenu ? 'visible' : 'hidden',
    transition: {
      opacity: {
        duration: 0.1
      },
      y: {
        duration: 0.3
      }
    },
    variants: paneVariants,
    children: [currentMenu && currentMenu !== MENUS.support && /*#__PURE__*/jsx$1(MobileMenu, {
      display: ['flex', 'flex', 'flex', 'none']
    }), currentMenu === MENUS.support && /*#__PURE__*/jsx$1(MobileSupportMenu, {})]
  }));
});
MobileMenuPane.displayName = 'MobileMenuPane';

function ownKeys$2(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$2(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var MenuIcon = styled.svg.withConfig({
  displayName: "mobile-menu-button__MenuIcon",
  componentId: "sc-mw2j6b-0"
})(["fill:currentColor;margin-top:-0.1rem;transition:all 0.2s;height:2rem;path{transition:transform 0.3s;}", ""], function (_ref) {
  var open = _ref.open;
  return open && "\n\n      path:nth-child(1) {\n        transform: rotate(45deg) translate(12rem, -12rem);\n      }\n\n      path:nth-child(2) {\n        opacity: 0;\n      }\n\n      path:nth-child(3) {\n        transform: rotate(-45deg) translate(-23rem, -1rem);\n      }\n    ";
});

function MobileNavButton(_ref2) {
  var rest = Object.assign({}, (_objectDestructuringEmpty(_ref2), _ref2));

  var _useNavigationService = useNavigationService(),
      currentMenu = _useNavigationService.currentMenu,
      toggleMenu = _useNavigationService.toggleMenu;

  var iconPaths = Icon$2.getIcon('menu');

  var onToggle = function onToggle() {
    toggleMenu(currentMenu ? null : MENUS.mobile);
  };

  return /*#__PURE__*/jsx$1(Box$1, _objectSpread$2(_objectSpread$2({}, rest), {}, {
    display: ['flex', 'flex', 'flex', 'none'],
    height: "100%",
    children: /*#__PURE__*/jsx$1(Button$1, {
      ariaLabel: "menu",
      color: "black",
      height: "100%",
      id: "mobile-menu",
      mr: "1rem",
      onClick: onToggle,
      type: "button",
      variant: "minimal",
      children: /*#__PURE__*/jsx$1(MenuIcon, {
        alt: "close",
        open: Boolean(currentMenu),
        viewBox: "0 0 512 512",
        children: iconPaths
      })
    })
  }));
}

var propTypes$1 = {
  order: PropTypes.shape({}).isRequired,
  removeNav: PropTypes.bool
};
var defaultProps = {
  removeNav: false
};

var hideOrderCount = function hideOrderCount() {
  if (hasDOM) {
    var pathname = window.location.pathname;
    var urlMatches = ['/MyAccount/ProcessOrder'].filter(function (u) {
      return pathname.includes(u);
    });
    return Boolean(urlMatches.length);
  }

  return false;
};

function Header(_ref) {
  var removeNav = _ref.removeNav,
      hasCheckOutNav = _ref.hasCheckOutNav;
  var notificationIndicatorRef = useRef();
  var desktopPaneRef = useRef();
  var mobilePaneRef = useRef();

  var menuItemIsLink = function menuItemIsLink(menuName) {
    return !Array.isArray(NAV_MENUS[menuName]);
  };

  var menuItemLinkIsVisible = function menuItemLinkIsVisible(menuName) {
    var menuItem = NAV_MENUS[menuName];

    if (!Array.isArray(menuItem)) {
      return !menuItem.hide;
    }

    return true;
  };

  var getMenuLinkUrl = function getMenuLinkUrl(menuName) {
    var menuItem = NAV_MENUS[menuName];

    if (!Array.isArray(menuItem)) {
      return menuItem.url;
    }

    return 'n/a';
  };

  var renderCurrencyOptions = function renderCurrencyOptions(isRebel) {
    var _user$hasSubscription;

    var display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['none', 'flex'];
    var user = LS.getItem(storageKeys.User);
    var hasSubscriptions = (_user$hasSubscription = user === null || user === void 0 ? void 0 : user.hasSubscriptions) !== null && _user$hasSubscription !== void 0 ? _user$hasSubscription : false;
    return isRebel && !hasSubscriptions ? /*#__PURE__*/jsx$1(CurrencySelector, {
      containerProps: {
        color: 'black',
        display: display,
        as: 'li',
        mx: 3,
        mt: '0.5rem'
      },
      fetchOnStart: true,
      id: "navcurrency-select"
    }) : null;
  };

  return /*#__PURE__*/jsxs(Stack$2, {
    as: "nav",
    borderBottom: "light",
    left: "0",
    position: !hasCheckOutNav ? 'fixed' : 'relative',
    right: "0",
    top: "0",
    zIndex: "navbar",
    children: [/*#__PURE__*/jsx$1(Box$1, {
      left: "0",
      position: "absolute",
      top: "0",
      zIndex: "aboveNavbar",
      children: /*#__PURE__*/jsx$1(_StyledText, {
        alignItems: "center",
        as: "a",
        bg: "whiteDark",
        color: "black",
        display: "flex",
        fontSize: 1,
        height: "8rem",
        href: "#main-container",
        justifyContent: "center",
        ml: "-200rem",
        px: 2,
        textDecoration: "underline",
        textStyle: "caps",
        title: "Skip to main content",
        children: "Skip to main content"
      })
    }), /*#__PURE__*/jsx$1(NotificationProvider, {
      children: /*#__PURE__*/jsxs(NavigationProvider, {
        children: [/*#__PURE__*/jsxs(Box$1, {
          alignItems: "center",
          bg: "white",
          height: "8rem",
          justifyContent: "space-between",
          position: "relative",
          px: [3, 3, 3, 5],
          width: 1,
          children: [/*#__PURE__*/jsxs(Box$1, {
            alignItems: "center",
            as: "ul",
            height: "100%",
            position: "relative",
            children: [!removeNav ? /*#__PURE__*/jsx$1(MobileNavButton, {
              as: "li",
              flexDirection: "column",
              justifyContent: "center"
            }) : null, /*#__PURE__*/jsx$1(Box$1, {
              as: "li",
              flex: "1",
              justifyContent: "center",
              children: /*#__PURE__*/jsx$1(HomeLink, {
                "aria-label": "Home",
                href: "/",
                children: /*#__PURE__*/jsx$1(Box$1, {
                  height: "100%",
                  children: /*#__PURE__*/jsx$1(NavLogo, {})
                })
              })
            }), hasCheckOutNav ? /*#__PURE__*/jsx$1(Text$1, {
              alignSelf: "center",
              mx: 2,
              children: /*#__PURE__*/jsx$1(Button$1, {
                display: ['none', 'flex', 'flex', 'flex'],
                ariaLabel: "Continue Shopping",
                btnProps: {
                  color: 'white'
                },
                variant: "minimal",
                children: /*#__PURE__*/jsxs(Link$1, {
                  display: ['none', 'flex', 'flex'],
                  color: "black",
                  href: "/",
                  children: [/*#__PURE__*/jsx$1(Icon$2, {
                    name: "arrow-right",
                    style: {
                      transform: 'rotate(180deg)'
                    },
                    title: "Continue Shopping",
                    mx: 2,
                    color: "black"
                  }), "Continue Shopping"]
                })
              })
            }) : null]
          }), !removeNav ? /*#__PURE__*/jsxs(Fragment, {
            children: [/*#__PURE__*/jsx$1(Box$1, {
              alignItems: "center",
              as: "ul",
              display: ['none', 'none', 'none', 'flex'],
              height: "100%",
              mx: 3,
              position: "relative",
              zIndex: "navbar",
              children: Object.keys(NAV_MENUS).map(function (menuName) {
                return menuName !== MENUS.support ? /*#__PURE__*/jsx$1(React__default.Fragment, {
                  children: /*#__PURE__*/jsx$1(NavItem, {
                    children: menuItemIsLink(menuName) ? /*#__PURE__*/jsx$1(Fragment, {
                      children: menuItemLinkIsVisible(menuName) && /*#__PURE__*/jsxs(Fragment, {
                        children: [mainMenuHasTag(menuName, 'applySale') && makeTag('orange', 'SALE'), mainMenuHasTag(menuName, 'applyNew') && makeTag('#01CBCF', 'NEW'), /*#__PURE__*/jsx$1(NavLink, {
                          ariaLabel: menuName,
                          href: getMenuLinkUrl(menuName),
                          children: formatMenuGroupTitle(menuName)
                        })]
                      })
                    }) : /*#__PURE__*/jsxs(Fragment, {
                      children: [mainMenuHasTag(menuName, 'applySale') && makeTag('orange', 'SALE'), mainMenuHasTag(menuName, 'applyNew') && makeTag('#01CBCF', 'NEW'), /*#__PURE__*/jsx$1(DesktopNavButton, {
                        ariaLabel: menuName,
                        menu: menuName,
                        children: formatMenuGroupTitle(menuName)
                      })]
                    })
                  })
                }, menuName) : null;
              })
            }), /*#__PURE__*/jsxs(NavList, {
              children: [/*#__PURE__*/jsx$1(RightNavItem, {
                children: /*#__PURE__*/jsx$1(ErrorBoundary, {
                  location: "nav-notification-indicator",
                  children: /*#__PURE__*/jsx$1(NotificationIndicator, {
                    ref: notificationIndicatorRef
                  })
                })
              }), /*#__PURE__*/jsx$1(RightNavItem, {
                children: /*#__PURE__*/jsx$1(DesktopNavButton, {
                  ariaLabel: MENUS.support,
                  menu: MENUS.support,
                  children: /*#__PURE__*/jsx$1(Text$1, {
                    ariaLabel: "Help",
                    children: " Help "
                  })
                })
              }), /*#__PURE__*/jsx$1(RightNavItem, {
                children: /*#__PURE__*/jsx$1(Cart, {
                  hideCount: hideOrderCount()
                })
              }), renderCurrencyOptions(isRebelCOM), /*#__PURE__*/jsx$1(AccountMenuButton, {})]
            }), /*#__PURE__*/jsx$1(DesktopMenuPane, {
              ref: desktopPaneRef
            }), /*#__PURE__*/jsx$1(MobileMenuPane, {
              ref: mobilePaneRef
            })]
          }) : null, hasCheckOutNav ? /*#__PURE__*/jsxs(Box$1, {
            children: [/*#__PURE__*/jsx$1(LiveChatButton, {
              text: "Live Chat",
              variant: "navbar",
              textColor: "black",
              btnProps: {
                color: 'white'
              }
            }), /*#__PURE__*/jsx$1(RightNavItem, {
              children: renderCurrencyOptions(isRebelCOM, 'flex')
            })]
          }) : null]
        }, 'main-nav'), /*#__PURE__*/jsx$1(UserAuthModal, {}), /*#__PURE__*/jsx$1(PasswordResetModal, {}), !hasCheckOutNav ? /*#__PURE__*/jsx$1(NotificationPane, {
          initiator: notificationIndicatorRef || null
        }, 'notifications') : null]
      })
    })]
  });
}

Header.propTypes = propTypes$1;
Header.defaultProps = defaultProps;

var _StyledText = styled(Text$1).withConfig({
  displayName: "header___StyledText",
  componentId: "sc-11qcq52-0"
})(["transition:all 0.2s;&:focus{margin-left:0px;}"]);

function onError(errorHandler) {
  return new ApolloLink(function (operation, forward) {
    return new Observable(function (observer) {
      var sub;
      var retriedSub;
      var retriedResult;

      try {
        sub = forward(operation).subscribe({
          next: function next(result) {
            if (result.errors) {
              retriedResult = errorHandler({
                graphQLErrors: result.errors,
                response: result,
                operation: operation,
                forward: forward
              });

              if (retriedResult) {
                retriedSub = retriedResult.subscribe({
                  next: observer.next.bind(observer),
                  error: observer.error.bind(observer),
                  complete: observer.complete.bind(observer)
                });
                return;
              }
            }

            observer.next(result);
          },
          error: function error(networkError) {
            retriedResult = errorHandler({
              operation: operation,
              networkError: networkError,
              graphQLErrors: networkError && networkError.result && networkError.result.errors,
              forward: forward
            });

            if (retriedResult) {
              retriedSub = retriedResult.subscribe({
                next: observer.next.bind(observer),
                error: observer.error.bind(observer),
                complete: observer.complete.bind(observer)
              });
              return;
            }

            observer.error(networkError);
          },
          complete: function complete() {
            if (!retriedResult) {
              observer.complete.bind(observer)();
            }
          }
        });
      } catch (e) {
        errorHandler({
          networkError: e,
          operation: operation,
          forward: forward
        });
        observer.error(e);
      }

      return function () {
        if (sub) sub.unsubscribe();
        if (retriedSub) sub.unsubscribe();
      };
    });
  });
}

(function (_super) {
  __extends$1(ErrorLink, _super);

  function ErrorLink(errorHandler) {
    var _this = _super.call(this) || this;

    _this.link = onError(errorHandler);
    return _this;
  }

  ErrorLink.prototype.request = function (operation, forward) {
    return this.link.request(operation, forward);
  };

  return ErrorLink;
})(ApolloLink);

function fetch$1(e, n) {
  return n = n || {}, new Promise(function (t, r) {
    var s = new XMLHttpRequest(),
        o = [],
        u = [],
        i = {},
        a = function a() {
      return {
        ok: 2 == (s.status / 100 | 0),
        statusText: s.statusText,
        status: s.status,
        url: s.responseURL,
        text: function text() {
          return Promise.resolve(s.responseText);
        },
        json: function json() {
          return Promise.resolve(s.responseText).then(JSON.parse);
        },
        blob: function blob() {
          return Promise.resolve(new Blob([s.response]));
        },
        clone: a,
        headers: {
          keys: function keys() {
            return o;
          },
          entries: function entries() {
            return u;
          },
          get: function get(e) {
            return i[e.toLowerCase()];
          },
          has: function has(e) {
            return e.toLowerCase() in i;
          }
        }
      };
    };

    for (var l in s.open(n.method || "get", e, !0), s.onload = function () {
      s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (e, n, t) {
        o.push(n = n.toLowerCase()), u.push([n, t]), i[n] = i[n] ? i[n] + "," + t : t;
      }), t(a());
    }, s.onerror = r, s.withCredentials = "include" == n.credentials, n.headers) {
      s.setRequestHeader(l, n.headers[l]);
    }

    s.send(n.body || null);
  });
}

function _regenerator$2() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$2(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$2(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$2(u), _regeneratorDefine2$2(u, o, "Generator"), _regeneratorDefine2$2(u, n, function () {
    return this;
  }), _regeneratorDefine2$2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$2 = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$2(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$2 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$2(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$2(e, r, n, t);
}

function ownKeys$1(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread$1(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

var RWT = storageKeys.LSToken;
var cache = new InMemoryCache({
  possibleTypes: {
    DetailsTypes: ['DomainDetails', 'DomainRegistrationDetails', 'DomainTransferDetails', 'PremiumRegistrationDetails', 'PackageDetails', 'SecurityDetails', 'DomainRenewalDetails']
  }
}); // eslint-disable-next-line consistent-return

var errorLink = onError( /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$2().m(function _callee(_ref) {
    var graphQLErrors, operation, forward, gqlError, code, _yield$fetchToken, data;

    return _regenerator$2().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            graphQLErrors = _ref.graphQLErrors, operation = _ref.operation, forward = _ref.forward;

            if (!graphQLErrors) {
              _context.n = 2;
              break;
            }

            gqlError = graphQLErrors[0];
            code = gqlError.extensions.code;

            if (!(code === 'UNAUTHENTICATED')) {
              _context.n = 2;
              break;
            }

            _context.n = 1;
            return fetchToken({
              force: true
            });

          case 1:
            _yield$fetchToken = _context.v;
            data = _yield$fetchToken.data;
            operation.setContext({
              headers: _objectSpread$1(_objectSpread$1({}, operation.getContext().headers), {}, {
                Authorization: data.token
              })
            });
            return _context.a(2, forward(operation));

          case 2:
            return _context.a(2);
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}());
var jwtLink = new ApolloLink(function (operation, forward) {
  var jwt = LS.getItem(RWT);
  operation.setContext({
    headers: {
      Authorization: jwt
    }
  });
  return forward(operation);
});

var getClient = function getClient() {
  return new ApolloClient({
    link: from([errorLink, jwtLink, trackerLink, new HttpLink({
      uri: graphQLEndpoint,
      fetch: fetch$1
    })]),
    cache: cache
  });
};

function GraphProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/jsx$1(ApolloProvider, {
    client: getClient(),
    children: children
  });
}

GraphProvider.propTypes = {
  children: PropTypes$1.oneOfType([PropTypes$1.node, PropTypes$1.arrayOf(PropTypes$1.node)]).isRequired
};

function _regenerator$1() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2$1(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2$1(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2$1(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2$1(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2$1(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2$1(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2$1(u), _regeneratorDefine2$1(u, o, "Generator"), _regeneratorDefine2$1(u, n, function () {
    return this;
  }), _regeneratorDefine2$1(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator$1 = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2$1(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2$1 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2$1(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2$1(e, r, n, t);
}

var onDeleteRecoverRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator$1().m(function _callee(action, contextId) {
    var userId,
        endpoint,
        _yield$put,
        status,
        data,
        _err$response,
        _err$response$data,
        _args = arguments,
        _t;

    return _regenerator$1().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            userId = _args.length > 2 && _args[2] !== undefined ? _args[2] : null;
            _context.p = 1;
            endpoint = buildSkywalkerEndpoint("".concat(SKYWALKER_ENDPOINTS.openExchange, "accounts/").concat(contextId).concat(userId ? "/users/".concat(userId) : '', "/").concat(action));
            _context.n = 2;
            return put$1(endpoint);

          case 2:
            _yield$put = _context.v;
            status = _yield$put.status;
            data = _yield$put.data;
            return _context.a(2, status === 200 && data.success);

          case 3:
            _context.p = 3;
            _t = _context.v;
            throw new Error((_t === null || _t === void 0 ? void 0 : (_err$response = _t.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.message) || '');

          case 4:
            return _context.a(2);
        }
      }
    }, _callee, null, [[1, 3]]);
  }));

  return function onDeleteRecoverRequest(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var onChangePasswordRequest = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator$1().m(function _callee2(password, contextId, oxUserId) {
    var _yield$put2, status, data;

    return _regenerator$1().w(function (_context2) {
      while (1) {
        switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return put$1(buildSkywalkerEndpoint("".concat(SKYWALKER_ENDPOINTS.openExchange, "accounts/").concat(contextId, "/users/").concat(oxUserId, "/password")), {
              password: password
            });

          case 1:
            _yield$put2 = _context2.v;
            status = _yield$put2.status;
            data = _yield$put2.data;
            return _context2.a(2, status === 200 && data.success);
        }
      }
    }, _callee2);
  }));

  return function onChangePasswordRequest(_x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

var onChangeEmailRequest = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator$1().m(function _callee3(email, contextId, oxUserId) {
    var _yield$put3, status, data;

    return _regenerator$1().w(function (_context3) {
      while (1) {
        switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return put$1(buildSkywalkerEndpoint("".concat(SKYWALKER_ENDPOINTS.openExchange, "accounts/").concat(contextId, "/users/").concat(oxUserId, "/email")), {
              email: email
            });

          case 1:
            _yield$put3 = _context3.v;
            status = _yield$put3.status;
            data = _yield$put3.data;
            return _context3.a(2, status === 200 && data.success);
        }
      }
    }, _callee3);
  }));

  return function onChangeEmailRequest(_x6, _x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}();

var onAddAliasRequest = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regenerator$1().m(function _callee4(alias, contextId, oxUserId) {
    return _regenerator$1().w(function (_context4) {
      while (1) {
        switch (_context4.n) {
          case 0:
            return _context4.a(2, post$1(buildSkywalkerEndpoint("".concat(SKYWALKER_ENDPOINTS.openExchange, "accounts/").concat(contextId, "/users/").concat(oxUserId, "/aliases")), {
              alias: alias
            }));
        }
      }
    }, _callee4);
  }));

  return function onAddAliasRequest(_x9, _x0, _x1) {
    return _ref4.apply(this, arguments);
  };
}();

var onDeleteAliasRequest = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regenerator$1().m(function _callee5(alias, contextId, oxUserId) {
    var _yield$del, data, status;

    return _regenerator$1().w(function (_context5) {
      while (1) {
        switch (_context5.n) {
          case 0:
            _context5.n = 1;
            return del$1(buildSkywalkerEndpoint("".concat(SKYWALKER_ENDPOINTS.openExchange, "accounts/").concat(contextId, "/users/").concat(oxUserId, "/aliases/").concat(alias)));

          case 1:
            _yield$del = _context5.v;
            data = _yield$del.data;
            status = _yield$del.status;
            return _context5.a(2, status === 200 && data.success);
        }
      }
    }, _callee5);
  }));

  return function onDeleteAliasRequest(_x10, _x11, _x12) {
    return _ref5.apply(this, arguments);
  };
}();

var onAddForwardingRequest = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regenerator$1().m(function _callee6(forwardingAddress, contextId, oxUserId) {
    return _regenerator$1().w(function (_context6) {
      while (1) {
        switch (_context6.n) {
          case 0:
            return _context6.a(2, post$1(buildSkywalkerEndpoint("".concat(SKYWALKER_ENDPOINTS.openExchange, "accounts/").concat(contextId, "/users/").concat(oxUserId, "/forwards")), {
              forwardingAddress: forwardingAddress
            }));
        }
      }
    }, _callee6);
  }));

  return function onAddForwardingRequest(_x13, _x14, _x15) {
    return _ref6.apply(this, arguments);
  };
}();

var onDeleteFowardingRequest = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regenerator$1().m(function _callee7(forwardingId, contextId, oxUserId) {
    var _yield$del2, data, status;

    return _regenerator$1().w(function (_context7) {
      while (1) {
        switch (_context7.n) {
          case 0:
            _context7.n = 1;
            return del$1(buildSkywalkerEndpoint("".concat(SKYWALKER_ENDPOINTS.openExchange, "accounts/").concat(contextId, "/users/").concat(oxUserId, "/forwards/").concat(forwardingId)));

          case 1:
            _yield$del2 = _context7.v;
            data = _yield$del2.data;
            status = _yield$del2.status;
            return _context7.a(2, status === 200 && data.success);
        }
      }
    }, _callee7);
  }));

  return function onDeleteFowardingRequest(_x16, _x17, _x18) {
    return _ref7.apply(this, arguments);
  };
}();

function ownKeys(e, r) {
  var t = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }

  return t;
}

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty$6(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }

  return e;
}

function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
      t,
      r = "function" == typeof Symbol ? Symbol : {},
      n = r.iterator || "@@iterator",
      o = r.toStringTag || "@@toStringTag";

  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
        u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
          c,
          u,
          f = 0,
          p = o || [],
          y = !1,
          G = {
        p: 0,
        n: 0,
        v: e,
        a: d,
        f: d.bind(e, 4),
        d: function d(t, r) {
          return i = t, c = 0, u = e, G.n = r, a;
        }
      };

      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
              i = p[t],
              d = G.p,
              l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }

        if (o || r > 1) return a;
        throw y = !0, n;
      }

      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");

        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);

          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);

              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }

        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }

  var a = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
    return this;
  }), t),
      u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);

  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}

function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;

  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }

  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };

      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2(e, r, n, t);
}

var OX_BASE_URL = '/my-account/email-manager';
var RETRY_ATTEMPTS = 4;
var OpenExchangeContext = /*#__PURE__*/React__default.createContext();
var propTypes = {
  navigate: PropTypes.func.isRequired
}; // Blocking timeout

var sleep = function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

function OpenExchangeProvider(props) {
  var GatsbyNavigate = props.navigate;
  var useLocation = props.useLocation;

  var _useUserService = useUserService(),
      user = _useUserService.user;

  var _useState = useState([]),
      _useState2 = _slicedToArray$4(_useState, 2),
      accounts = _useState2[0],
      setAccounts = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray$4(_useState3, 2),
      fetchError = _useState4[0],
      setFetchError = _useState4[1];

  var _useState5 = useState({}),
      _useState6 = _slicedToArray$4(_useState5, 2),
      currentContext = _useState6[0],
      setCurrentContext = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray$4(_useState7, 2),
      currentEmailUser = _useState8[0],
      setCurrentEmailUser = _useState8[1];

  var _useState9 = useState({}),
      _useState0 = _slicedToArray$4(_useState9, 2),
      currentOXAccount = _useState0[0],
      setCurrentOXAccount = _useState0[1];

  var _useState1 = useState(),
      _useState10 = _slicedToArray$4(_useState1, 2),
      currentUserId = _useState10[0],
      setCurrentUserId = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray$4(_useState11, 2),
      providerLoading = _useState12[0],
      setLoading = _useState12[1];

  var _useState13 = useState({}),
      _useState14 = _slicedToArray$4(_useState13, 2),
      recentlyAdded = _useState14[0],
      setRecentlyAdded = _useState14[1]; // can be a boolean or a string with the message to display


  var _useState15 = useState(false),
      _useState16 = _slicedToArray$4(_useState15, 2),
      accountMigrationWarning = _useState16[0],
      setAccountMigrationWarning = _useState16[1];

  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  var reset = function reset() {
    setCurrentContext({});
    setCurrentUserId(null);
    setCurrentEmailUser(null);
  };
  /**
   * Sometimes the open exchange call will fail because the lambda timesout
   * This method will retry that call <RETRY_ATTEMPT> amount of times
   * It'll also stagger between each retry attempt.
   * @param {*} retry
   * @returns the data from the ox call or false if we run out of attempts
   */


  var _retry = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee(attempt) {
      return _regenerator().w(function (_context) {
        while (1) {
          switch (_context.n) {
            case 0:
              if (attempt) {
                _context.n = 1;
                break;
              }

              return _context.a(2, false);

            case 1:
              _context.n = 2;
              return sleep(attempt * 5000);

            case 2:
              _context.p = 2;

              if (!(attempt < RETRY_ATTEMPTS)) {
                _context.n = 4;
                break;
              }

              _context.n = 3;
              return get$3(getOXaccounts());

            case 3:
              return _context.a(2, _context.v);

            case 4:
              return _context.a(2, false);

            case 5:
              _context.p = 5;
              _context.n = 6;
              return _retry(attempt + 1);

            case 6:
              return _context.a(2, _context.v);
          }
        }
      }, _callee, null, [[2, 5]]);
    }));

    return function retry(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * _initializeAccounts
   * Cleans up the user data fetched from the backend and sets the account state.
   * @param {*} data
   */


  var _initializeAccounts = function _initializeAccounts(data) {
    var parsedData = data.map(function (acc) {
      var parsedUsers = acc.users.map(function (u) {
        return _objectSpread(_objectSpread({}, u), {}, {
          userId: parseInt(u.userId, 10),
          oxUserId: parseInt(u.oxUserId, 10)
        });
      });
      return _objectSpread(_objectSpread({}, acc), {}, {
        oxAccountId: parseInt(acc.oxAccountId, 10),
        contextId: parseInt(acc.contextId, 10),
        subscriptionId: parseInt(acc.subscriptionId, 10),
        users: parsedUsers
      });
    });
    setAccounts(parsedData); // If there was a warning up waiting for the migration, reset it.

    if (accountMigrationWarning) {
      setAccountMigrationWarning(false);
    }
  };
  /**
   * getOpenExchangeAccounts
   * @param boolean setLoadingState - optional parameter -
   *  if we want to make this request on a page that uses the loading spinner,
   *  but we don't want to reload the entire page
   */


  var getOpenExchangeAccounts = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee2() {
      var setLoadingState,
          _yield$get,
          data,
          responseRetry,
          _args2 = arguments,
          _t2;

      return _regenerator().w(function (_context2) {
        while (1) {
          switch (_context2.n) {
            case 0:
              setLoadingState = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : true;

              if (setLoadingState) {
                setLoading(true);
              }

              _context2.p = 1;
              _context2.n = 2;
              return get$3(getOXaccounts());

            case 2:
              _yield$get = _context2.v;
              data = _yield$get.data;

              if (data.success) {
                _initializeAccounts(data.result);
              }

              if (setLoadingState) {
                setLoading(false);
              }

              _context2.n = 5;
              break;

            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              _context2.n = 4;
              return _retry(1);

            case 4:
              responseRetry = _context2.v;

              if (responseRetry && responseRetry !== null && responseRetry !== void 0 && responseRetry.data && responseRetry !== null && responseRetry !== void 0 && responseRetry.data.success) {
                _initializeAccounts(responseRetry.data.result);
              } else {
                setFetchError(_t2);
              }

              if (setLoadingState) {
                setLoading(false);
              }

            case 5:
              return _context2.a(2);
          }
        }
      }, _callee2, null, [[1, 3]]);
    }));

    return function getOpenExchangeAccounts() {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * Get the extended information about current email user from its contextId and userId
   * Includes aliases, forwarding, and other future user related elements
   * @param {*} contextId
   * @param {*} userId
   */


  var getOpenExchangeUserSettings = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee3(contextId, userId) {
      var _yield$get2, data, settings, _user, forwards, aliases, _t3;

      return _regenerator().w(function (_context3) {
        while (1) {
          switch (_context3.n) {
            case 0:
              setLoading(true);
              _context3.p = 1;
              _context3.n = 2;
              return get$3("".concat(buildSkywalkerEndpoint(SKYWALKER_ENDPOINTS.openExchange), "accounts/").concat(contextId, "/users/").concat(userId, "/settings"));

            case 2:
              _yield$get2 = _context3.v;
              data = _yield$get2.data;
              settings = data.settings;
              _user = _objectSpread(_objectSpread({}, settings.users[0]), {}, {
                userId: parseInt(settings.users[0].userId, 10),
                oxUserId: parseInt(settings.users[0].oxUserId, 10)
              });
              forwards = [];
              forwards = settings.forwards && settings.forwards.filters ? settings.forwards.filters.filter(function (fw) {
                return fw.rulename.includes('Forward mail to:');
              }).map(function (fw) {
                var _fw$actioncmds$find;

                return {
                  id: fw.id,
                  forwardingAddress: (_fw$actioncmds$find = fw.actioncmds.find(function (cmd) {
                    return cmd.id === 'redirect';
                  })) === null || _fw$actioncmds$find === void 0 ? void 0 : _fw$actioncmds$find.to
                };
              }) : [];
              aliases = settings.aliases.filter(function (alias) {
                return alias !== settings.users[0].userName;
              });
              setCurrentEmailUser(_objectSpread(_objectSpread({}, _user), {}, {
                aliases: aliases,
                forwards: forwards
              }));
              setCurrentUserId(userId);
              setLoading(false);
              _context3.n = 4;
              break;

            case 3:
              _context3.p = 3;
              _t3 = _context3.v;
              setFetchError(_t3);
              setLoading(false);

            case 4:
              return _context3.a(2);
          }
        }
      }, _callee3, null, [[1, 3]]);
    }));

    return function getOpenExchangeUserSettings(_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * onNewOX
   *  Creates a new open exchange user or package.
   *  By default, it will fetch open exchange accounts (reloadData = true).
   *  However, if set to false, it will modify the current state of the provider by appending
   *  the newly added user/package to the accounts state.
   *  It returns true if all operations were successful, false otherwise.
   * @param {{
   *    username: string
   *    password: string
   *    packageId: number
   *    domainName: string
   *    firstName: string - optional
   *    lastName: string  - optional
   *    users: number - optional
   * }} payload
   * @param {boolean} reloadData - if set to true, then the loading spinner will be set, and openExchange call will be made
   *          - eg. { username: 'landy', domainName: 'email.com', password: kek1234, packageId: 7}
   * @returns {boolean} - true if getAddToCart was successful, false otherwise
   */


  var onNewOX = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee4(payload) {
      var reloadData,
          _yield$post,
          data,
          result,
          exists,
          tmp,
          _tmp,
          _err$response,
          _err$response$data,
          _args4 = arguments,
          _t4;

      return _regenerator().w(function (_context4) {
        while (1) {
          switch (_context4.n) {
            case 0:
              reloadData = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : true;
              _context4.p = 1;
              _context4.n = 2;
              return post$1(getOXAddToCart(), _objectSpread({
                firstName: payload.username,
                lastName: payload.domainName,
                users: 1
              }, payload));

            case 2:
              _yield$post = _context4.v;
              data = _yield$post.data;

              if (!reloadData) {
                _context4.n = 3;
                break;
              }

              getOpenExchangeAccounts();
              return _context4.a(2);

            case 3:
              result = data.result; // Check if the oxAccount is new --> search the list of accounts

              exists = accounts.find(function (acc) {
                return acc.oxAccountId === result.oxAccountId;
              }); // if it doesnt exist, it's a new OX account

              if (!exists) {
                tmp = result;
                setAccounts(function (acc) {
                  acc.push(tmp);
                });
              } else {
                // if it does exist, then it's an existing oxAccount with a new user
                exists.users.push(result.user);
                _tmp = accounts.map(function (acc) {
                  return acc.oxAccountId === data.oxAccountId ? exists : acc;
                });
                setAccounts(_tmp);
              }

              setRecentlyAdded(result);
              return _context4.a(2);

            case 4:
              _context4.p = 4;
              _t4 = _context4.v;
              throw new Error((_t4 === null || _t4 === void 0 ? void 0 : (_err$response = _t4.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.Message) || '');

            case 5:
              return _context4.a(2);
          }
        }
      }, _callee4, null, [[1, 4]]);
    }));

    return function onNewOX(_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
  /**
   * onDeleteRecover
   *  Calls the OX skywalker endpoint to either delete or recover a package or user.
   *  Only refetch OX accounts if the user deletes a package or recovers a user/package.
   *  (We do this because the status of a package changes upon deletion/recovery. So it's better to refetch the whole payload)
   *  Otherwise, if a user is being deleted, we don't need to refetch the entire payload,
   *  just modify the existing accounts.
   *
   * @param {'delete' | 'restore'} action
   * @param {*} contextId
   * @param {*} userId - oxUserId
   * @returns {boolean} - true if deletion was successful, false otherwise
   */


  var onDeleteRecover = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee5(action) {
      var contextId,
          userId,
          resp,
          _resp,
          newAccounts,
          _args5 = arguments,
          _t5;

      return _regenerator().w(function (_context5) {
        while (1) {
          switch (_context5.n) {
            case 0:
              contextId = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : currentContext.contextId;
              userId = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : null;
              _context5.p = 1;

              if (!(action === 'restore' || action === 'delete' && !userId)) {
                _context5.n = 3;
                break;
              }

              _context5.n = 2;
              return onDeleteRecoverRequest(action, contextId, userId);

            case 2:
              resp = _context5.v;
              getOpenExchangeAccounts(false); // silent reload

              return _context5.a(2, resp);

            case 3:
              if (!(action === 'delete' && !!userId)) {
                _context5.n = 5;
                break;
              }

              _context5.n = 4;
              return onDeleteRecoverRequest(action, contextId, userId);

            case 4:
              _resp = _context5.v;

              if (_resp) {
                newAccounts = accounts.map(function (acc) {
                  if (acc.contextId == contextId) {
                    acc.users = acc.users.filter(function (u) {
                      return u.oxUserId !== userId;
                    });
                  }

                  return acc;
                });
                setAccounts(newAccounts);
              }

              return _context5.a(2, _resp);

            case 5:
              _context5.n = 7;
              break;

            case 6:
              _context5.p = 6;
              _t5 = _context5.v;
              throw new Error(_t5.message);

            case 7:
              return _context5.a(2);
          }
        }
      }, _callee5, null, [[1, 6]]);
    }));

    return function onDeleteRecover(_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
  /**
   * [PRIVATE] onChangeCurrentUser - intermediary changes to the current user object
   *  that need to be directly reflected on the settings pages
   * @param {*} field
   * @param {*} newValue
   */


  function _onChangeCurrentUser(field, newValue) {
    if (!currentEmailUser[field] || currentEmailUser[field] === newValue) {
      return null;
    }

    setCurrentEmailUser(_objectSpread(_objectSpread({}, currentEmailUser), {}, _defineProperty$6({}, field, newValue)));
  }
  /**
   * onUserEmailChange - Makes a request to change users email server-side.
   * And if user is currently on the /settings page, it will auto update the current state.
   * @param {string} email
   * @param {number} contextId
   * @param {number} oxUserId
   * @returns true if the request was a success, false otherwise
   */


  var onUserEmailChange = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee6(email) {
      var contextId,
          oxUserId,
          resp,
          _args6 = arguments,
          _t6;

      return _regenerator().w(function (_context6) {
        while (1) {
          switch (_context6.n) {
            case 0:
              contextId = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : currentContext.contextId;
              oxUserId = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : currentUserId;
              _context6.p = 1;
              _context6.n = 2;
              return onChangeEmailRequest(email, contextId, oxUserId);

            case 2:
              resp = _context6.v; // If the parameters passed are the same as the current state, then we're on the settings page and need to immediately update

              if (resp && currentEmailUser.oxUserId === oxUserId && currentContext.contextId === contextId) {
                _onChangeCurrentUser('userName', email);
              }

              return _context6.a(2, resp);

            case 3:
              _context6.p = 3;
              _t6 = _context6.v;
              console.error(_t6);
              return _context6.a(2, false);
          }
        }
      }, _callee6, null, [[1, 3]]);
    }));

    return function onUserEmailChange(_x6) {
      return _ref6.apply(this, arguments);
    };
  }();
  /**
   * onUserPasswordChange - Makes a request to change the users password server-side
   * @param {string} password
   * @param {number} contextId
   * @param {number} oxUserId
   * @returns returns true if the request was a success, false otherwise
   */


  var onUserPasswordChange = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee7(password) {
      var contextId,
          oxUserId,
          resp,
          _args7 = arguments,
          _t7;

      return _regenerator().w(function (_context7) {
        while (1) {
          switch (_context7.n) {
            case 0:
              contextId = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : currentContext.contextId;
              oxUserId = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : currentUserId;
              _context7.p = 1;
              _context7.n = 2;
              return onChangePasswordRequest(password, contextId, oxUserId);

            case 2:
              resp = _context7.v;
              return _context7.a(2, resp);

            case 3:
              _context7.p = 3;
              _t7 = _context7.v;
              console.error(_t7);
              return _context7.a(2, false);
          }
        }
      }, _callee7, null, [[1, 3]]);
    }));

    return function onUserPasswordChange(_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
  /**
   * onAddUserAlias - Makes a request to add an alias to the users email account, and updates the current provider state
   * @param {string} password
   * @param {number} contextId
   * @param {number} oxUserId
   * @returns returns true if the request was a success, false otherwise
   */


  var onAddUserAlias = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee8(alias) {
      var contextId,
          oxUserId,
          _yield$onAddAliasRequ,
          status,
          data,
          _args8 = arguments;

      return _regenerator().w(function (_context8) {
        while (1) {
          switch (_context8.n) {
            case 0:
              contextId = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : currentContext.contextId;
              oxUserId = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : currentUserId;
              _context8.n = 1;
              return onAddAliasRequest(alias, contextId, oxUserId);

            case 1:
              _yield$onAddAliasRequ = _context8.v;
              status = _yield$onAddAliasRequ.status;
              data = _yield$onAddAliasRequ.data;

              if (!(!status === 200 || !data.success)) {
                _context8.n = 2;
                break;
              }

              return _context8.a(2);

            case 2:
              if (currentEmailUser.oxUserId === oxUserId && currentContext.contextId === contextId) {
                _onChangeCurrentUser('aliases', [].concat(_toConsumableArray$1(currentEmailUser.aliases), [alias]));
              }

            case 3:
              return _context8.a(2);
          }
        }
      }, _callee8);
    }));

    return function onAddUserAlias(_x8) {
      return _ref8.apply(this, arguments);
    };
  }();
  /**
   * onDeleteUserAlias - Makes a request to delete/remove an alias from the users email account, and updates the current provider state
   * @param {string} password
   * @param {number} contextId
   * @param {number} oxUserId
   * @returns returns true if the request was a success, false otherwise
   */


  var onDeleteUserAlias = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee9(removeAlias) {
      var contextId,
          oxUserId,
          resp,
          _args9 = arguments,
          _t8;

      return _regenerator().w(function (_context9) {
        while (1) {
          switch (_context9.n) {
            case 0:
              contextId = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : currentContext.contextId;
              oxUserId = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : currentUserId;
              _context9.p = 1;
              _context9.n = 2;
              return onDeleteAliasRequest(removeAlias, contextId, oxUserId);

            case 2:
              resp = _context9.v;

              if (resp && currentEmailUser.oxUserId === oxUserId && currentContext.contextId === contextId) {
                _onChangeCurrentUser('aliases', _toConsumableArray$1(currentEmailUser.aliases.filter(function (alias) {
                  return alias !== removeAlias;
                })));
              }

              return _context9.a(2, resp);

            case 3:
              _context9.p = 3;
              _t8 = _context9.v;
              console.error(_t8);
              return _context9.a(2, false);
          }
        }
      }, _callee9, null, [[1, 3]]);
    }));

    return function onDeleteUserAlias(_x9) {
      return _ref9.apply(this, arguments);
    };
  }();
  /**
   * onAddUserForwarding - Makes a request to add a forwarding address from the users email account
   * and update the current provider state
   * @param {*} forwardingAddress
   * @param {*} contextId
   * @param {*} oxUserId
   * @returns returns true if the request was a success, false otherwise
   */


  var onAddUserForwarding = /*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee0(forwardingAddress) {
      var contextId,
          oxUserId,
          _yield$onAddForwardin,
          data,
          _yield$get3,
          _data,
          forwards,
          filterForwards,
          _args0 = arguments;

      return _regenerator().w(function (_context0) {
        while (1) {
          switch (_context0.n) {
            case 0:
              contextId = _args0.length > 1 && _args0[1] !== undefined ? _args0[1] : currentContext.contextId;
              oxUserId = _args0.length > 2 && _args0[2] !== undefined ? _args0[2] : currentUserId;

              if (!(currentEmailUser.forwards.length >= 4)) {
                _context0.n = 1;
                break;
              }

              throw new Error('No more than 4 forwards can be added for a single email.');

            case 1:
              _context0.n = 2;
              return onAddForwardingRequest(forwardingAddress, contextId, oxUserId);

            case 2:
              _yield$onAddForwardin = _context0.v;
              data = _yield$onAddForwardin.data;

              if (data.success) {
                _context0.n = 3;
                break;
              }

              throw new Error('Something went wrong with adding the forward. Please contact customer support.');

            case 3:
              if (!(currentEmailUser.oxUserId === oxUserId && currentContext.contextId === contextId)) {
                _context0.n = 5;
                break;
              }

              _context0.n = 4;
              return get$3("".concat(buildSkywalkerEndpoint(SKYWALKER_ENDPOINTS.openExchange), "accounts/").concat(contextId, "/users/").concat(oxUserId, "/forwards"));

            case 4:
              _yield$get3 = _context0.v;
              _data = _yield$get3.data;

              if (_data.success) {
                forwards = _data.forwards;
                filterForwards = forwards.filters ? forwards.filters.filter(function (fw) {
                  return fw.rulename.includes('Forward mail to:');
                }).map(function (fw) {
                  var _fw$actioncmds$find2;

                  return {
                    id: fw.id,
                    forwardingAddress: (_fw$actioncmds$find2 = fw.actioncmds.find(function (cmd) {
                      return cmd.id === 'redirect';
                    })) === null || _fw$actioncmds$find2 === void 0 ? void 0 : _fw$actioncmds$find2.to
                  };
                }) : [];

                _onChangeCurrentUser('forwards', _toConsumableArray$1(filterForwards));
              }

            case 5:
              return _context0.a(2);
          }
        }
      }, _callee0);
    }));

    return function onAddUserForwarding(_x0) {
      return _ref0.apply(this, arguments);
    };
  }();
  /**
   * onDeleteUserForwarding - Makes a request to delete/remove a forwarding address from the users email account using the forwardingId
   * and update the current provider state
   * @param {*} forwardingId
   * @param {*} contextId
   * @param {*} oxUserId
   * @returns returns true if the request was a success, false otherwise
   */


  var onDeleteUserForwarding = /*#__PURE__*/function () {
    var _ref1 = _asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee1(forwardingId) {
      var contextId,
          oxUserId,
          resp,
          _args1 = arguments,
          _t9;

      return _regenerator().w(function (_context1) {
        while (1) {
          switch (_context1.n) {
            case 0:
              contextId = _args1.length > 1 && _args1[1] !== undefined ? _args1[1] : currentContext.contextId;
              oxUserId = _args1.length > 2 && _args1[2] !== undefined ? _args1[2] : currentUserId;
              _context1.p = 1;
              _context1.n = 2;
              return onDeleteFowardingRequest(forwardingId, contextId, oxUserId);

            case 2:
              resp = _context1.v;

              if (resp && currentEmailUser.oxUserId === oxUserId && currentContext.contextId === contextId) {
                _onChangeCurrentUser('forwards', _toConsumableArray$1(currentEmailUser.forwards.filter(function (fw) {
                  return fw.id !== forwardingId;
                })));
              }

              return _context1.a(2, resp);

            case 3:
              _context1.p = 3;
              _t9 = _context1.v;
              console.error(_t9);
              return _context1.a(2, false);
          }
        }
      }, _callee1, null, [[1, 3]]);
    }));

    return function onDeleteUserForwarding(_x1) {
      return _ref1.apply(this, arguments);
    };
  }();
  /**
   * Navigate
   * Overrides the Gastby Navigate method by adding some additional operations of our own beforehand
   * It sets the state of currentContext, currentOXAccount, currentUserId, and currentEmailUser
   * Each of these states are used to navigate between the /email-manager/settings pages
   * Once these states are set, then we use the gastby navigate method to navigate to those pages
   * @param {*} to
   * @param {*} options
   * @returns
   */


  var navigate = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee10(to) {
      var options,
          state,
          context,
          oxAccount,
          _context10,
          _args10 = arguments;

      return _regenerator().w(function (_context11) {
        while (1) {
          switch (_context11.n) {
            case 0:
              options = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : {};
              state = options.state;

              if (!(to === OX_BASE_URL)) {
                _context11.n = 1;
                break;
              }

              GatsbyNavigate(to, options);
              return _context11.a(2);

            case 1:
              if (!(state !== null && state !== void 0 && state.contextId && (isEmpty$3(currentContext) || currentContext.contextId !== state.contextId))) {
                _context11.n = 2;
                break;
              }

              context = accounts.find(function (acc) {
                return acc.contextId === state.contextId;
              });
              setCurrentContext(context);

              if (context) {
                _context11.n = 2;
                break;
              }

              GatsbyNavigate(OX_BASE_URL);
              return _context11.a(2);

            case 2:
              if (!(state !== null && state !== void 0 && state.oxAccountId && (isEmpty$3(currentOXAccount) || currentOXAccount.oxAccountId !== state.oxAccountId))) {
                _context11.n = 3;
                break;
              }

              oxAccount = accounts.find(function (acc) {
                return acc.oxAccountId === state.oxAccountId;
              });
              setCurrentOXAccount(oxAccount);

              if (oxAccount) {
                _context11.n = 3;
                break;
              }

              GatsbyNavigate(OX_BASE_URL);
              return _context11.a(2);

            case 3:
              /**
               * [REQUIRED] oxUserId - the unique ID for the ox email within an oxAccount/Context
               * /email-manager/:oxUid/* pages REQUIRES this to be passed
               */
              if (state !== null && state !== void 0 && state.userId && (!currentUserId || currentUserId !== (state === null || state === void 0 ? void 0 : state.userId))) {
                getOpenExchangeUserSettings((_context10 = context) === null || _context10 === void 0 ? void 0 : _context10.contextId, state === null || state === void 0 ? void 0 : state.userId);
              }

              GatsbyNavigate(to, options);

            case 4:
              return _context11.a(2);
          }
        }
      }, _callee10);
    }));

    return function navigate(_x10) {
      return _ref10.apply(this, arguments);
    };
  }(); // If the user lands on an ox page, and they're a customer, fetch their oxAccounts
  // If they have no accounts, send them to the email manager


  useEffect(function () {
    if (user !== null && user !== void 0 && user.customerId) {
      if (pathname == OX_BASE_URL || pathname == "".concat(OX_BASE_URL, "/")) {
        reset();
        return getOpenExchangeAccounts();
      }

      if (pathname.includes('/dns-setup')) {
        return getOpenExchangeAccounts();
      }

      if (isEmpty$3(currentContext)) {
        return GatsbyNavigate(OX_BASE_URL);
      }
    }
  }, [pathname, user === null || user === void 0 ? void 0 : user.customerId]);
  useEffect(function () {
    if (hasDOM) {
      if (document.referrer) {
        // If we're coming from the migrate email page,
        // let's assume the user is migrating an account
        var regex = new RegExp(/\/email\/\d+\/migrate\//g);
        var isComingFromMigrationPage = regex.test(document.referrer);

        if (isComingFromMigrationPage) {
          setAccountMigrationWarning(true);
        }
      }
    }
  }, []);
  var value = useMemo(function () {
    return {
      navigate: navigate,
      accounts: accounts,
      fetchError: fetchError,
      currentOXAccount: currentOXAccount,
      currentContext: currentContext,
      currentEmailUser: currentEmailUser,
      currentUserId: currentUserId,
      providerLoading: providerLoading,
      recentlyAdded: recentlyAdded,
      onNewOX: onNewOX,
      setRecentlyAdded: setRecentlyAdded,
      getOpenExchangeAccounts: getOpenExchangeAccounts,
      onDeleteRecover: onDeleteRecover,
      onUserEmailChange: onUserEmailChange,
      onUserPasswordChange: onUserPasswordChange,
      onDeleteUserAlias: onDeleteUserAlias,
      onAddUserAlias: onAddUserAlias,
      onAddUserForwarding: onAddUserForwarding,
      onDeleteUserForwarding: onDeleteUserForwarding,
      setAccountMigrationWarning: setAccountMigrationWarning,
      accountMigrationWarning: accountMigrationWarning
    };
  }, [navigate]);
  return /*#__PURE__*/jsx$1(OpenExchangeContext.Provider, _objectSpread({
    value: value
  }, props));
}

function useOpenExchangeService() {
  var context = useContext(OpenExchangeContext);

  if (!context) {
    throw new Error('useOpenExchangeService must be used within a OpenExchangeProvider');
  }

  return _objectSpread({}, context);
}

OpenExchangeProvider.propTypes = propTypes;

function Preconnect() {
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx$1("link", {
      crossOrigin: "true",
      href: "https://vars.hotjar.com",
      rel: "preconnect"
    }, 'hotjar-preconnect'), /*#__PURE__*/jsx$1("link", {
      crossOrigin: "true",
      href: "https://www.google-analytics.com",
      rel: "preconnect"
    }, 'ga-preconnect'), /*#__PURE__*/jsx$1("link", {
      crossOrigin: "true",
      href: "https://www.google.com",
      rel: "preconnect"
    }, 'googlecom-preconnect'), /*#__PURE__*/jsx$1("link", {
      crossOrigin: "true",
      href: "https://www.google.ca",
      rel: "preconnect"
    }, 'googleca-preconnect'), /*#__PURE__*/jsx$1("link", {
      crossOrigin: "true",
      href: "https://www.googleadservices.com",
      rel: "preconnect"
    }, 'gAds-preconnect'), /*#__PURE__*/jsx$1("link", {
      crossOrigin: "true",
      href: "https://googleads.g.doubleclick.net",
      rel: "preconnect"
    }, 'gAds-dblClick-preconnect'), /*#__PURE__*/jsx$1("link", {
      crossOrigin: "true",
      href: "https://rum-static.pingdom.net",
      rel: "preconnect"
    }, 'pingdom-preconnect')]
  });
}

function SunshineConversations() {
  useSunshine();
  return null;
}

export { AddToCartWithDomainModal as AddToCartWithInput, Carousel, CheckOutFlow, Checkbox, Confirmation, ContactProvider, CoreProvider, CreditCardForm, CurrencySelector, Customize, Dashboard, DomainAccordion, DomainDashboard, DomainSearchBar, DomainsAccordionItems, Dropdown, ERROR_KEYS, EmailSetupContainer as EmailSetup, EmptyDomain, EmptyOrder, ErrorBoundary, ErrorProvider$1 as ErrorProvider, FocusLayout, Footer, GoogleWorkspaceOnboardingForm, GoogleWorkspaceProvider, GoogleWorkspaceSubscriptions, GraphProvider, Header, HelpSection, InfoCollector, InfoCollectorEmbed, LoaderProvider, LoadingSpinner, LS as LocalStorage, LockAccount, NavLogo as Logo, MenuButton, MfaModal, MyAccountDashboardService, NewsletterSignup, Notification, NotificationProvider, Notifications, OpenExchangeProvider, Order, OrderLoader, OrderProvider, OrderQueryProvider, PasswordResetModal as PasswordReset, PaymentSettings, Preconnect, Price, PriceBox, QuickRenew, RESELLER, RecommendationModal, RetentionSurveyModal, SCREEN_SIZES, SaleBox, SearchAndAddOnsPage, SearchBar, SecuritySettings, SessionProvider, SunshineConversations, SupportBar, TLDSearchBox, Table$1 as Table, TrustPilotWidget, TwoFactor, UserAuth, UserProvider, VulcanThemeProvider, addToCart, bulkSecurityService, cleanDomain, createOrder, currencyFormatter, del$1 as del, fetchToken, get$3 as get, getBrowserInfo, getScreenSize, hasDOM, isInternic, navigateToUrl, overwriteOrderFromSession, post$1 as post, put$1 as put, shapeDomains, socialLinks, supportRequestService, tracker$1 as tracker, useErrorDispatchService, useErrorStateService, useGoogleWorkspaceService, useLoaderService, useNotificationService, useOpenExchangeService, useOrderQuery, useOrderService, useScrollTop, useSessionService, useUserService };